/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 371);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(378);
} else {
  module.exports = require('./cjs/react.development.js');
}


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) {
  var ReactIs = require('react-is');

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(ReactIs.isElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(394)();
}


/***/ }),
/* 2 */
/***/ (function(module, exports) {

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

module.exports = _interopRequireDefault;

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(165);

var _interopRequireDefault = __webpack_require__(2);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.sheetsManager = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(6));

var _objectSpread2 = _interopRequireDefault(__webpack_require__(17));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(11));

var _createClass2 = _interopRequireDefault(__webpack_require__(12));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(13));

var _inherits2 = _interopRequireDefault(__webpack_require__(14));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(4));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _warning = _interopRequireDefault(__webpack_require__(16));

var _hoistNonReactStatics = _interopRequireDefault(__webpack_require__(67));

var _getDisplayName = _interopRequireDefault(__webpack_require__(167));

var _wrapDisplayName = _interopRequireDefault(__webpack_require__(89));

var _contextTypes = _interopRequireDefault(__webpack_require__(435));

var _jss = __webpack_require__(232);

var ns = _interopRequireWildcard(__webpack_require__(231));

var _jssPreset = _interopRequireDefault(__webpack_require__(238));

var _mergeClasses = _interopRequireDefault(__webpack_require__(239));

var _createMuiTheme = _interopRequireDefault(__webpack_require__(171));

var _themeListener = _interopRequireDefault(__webpack_require__(172));

var _createGenerateClassName = _interopRequireDefault(__webpack_require__(240));

var _getStylesCreator = _interopRequireDefault(__webpack_require__(483));

var _getThemeProps = _interopRequireDefault(__webpack_require__(241));

// Default JSS instance.
var jss = (0, _jss.create)((0, _jssPreset.default)()); // Use a singleton or the provided one by the context.

var generateClassName = (0, _createGenerateClassName.default)(); // Global index counter to preserve source order.
// We create the style sheet during at the creation of the component,
// children are handled after the parents, so the order of style elements would be parent->child.
// It is a problem though when a parent passes a className
// which needs to override any childs styles.
// StyleSheet of the child has a higher specificity, because of the source order.
// So our solution is to render sheets them in the reverse order child->sheet, so
// that parent has a higher specificity.

var indexCounter = -10e10; // Exported for test purposes

var sheetsManager = new Map(); // We use the same empty object to ref count the styles that don't need a theme object.

exports.sheetsManager = sheetsManager;
var noopTheme = {}; // In order to have self-supporting components, we rely on default theme when not provided.

var defaultTheme;

function getDefaultTheme() {
  if (defaultTheme) {
    return defaultTheme;
  }

  defaultTheme = (0, _createMuiTheme.default)();
  return defaultTheme;
} // Link a style sheet with a component.
// It does not modify the component passed to it;
// instead, it returns a new component, with a `classes` property.


var withStyles = function withStyles(stylesOrCreator) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return function (Component) {
    var _options$withTheme = options.withTheme,
        withTheme = _options$withTheme === void 0 ? false : _options$withTheme,
        _options$flip = options.flip,
        flip = _options$flip === void 0 ? null : _options$flip,
        name = options.name,
        styleSheetOptions = (0, _objectWithoutProperties2.default)(options, ["withTheme", "flip", "name"]);
    var stylesCreator = (0, _getStylesCreator.default)(stylesOrCreator);
    var listenToTheme = stylesCreator.themingEnabled || withTheme || typeof name === 'string';
    indexCounter += 1;
    stylesCreator.options.index = indexCounter;
     false ? (0, _warning.default)(indexCounter < 0, ['Material-UI: you might have a memory leak.', 'The indexCounter is not supposed to grow that much.'].join(' ')) : void 0;

    var WithStyles =
    /*#__PURE__*/
    function (_React$Component) {
      (0, _inherits2.default)(WithStyles, _React$Component);

      function WithStyles(props, context) {
        var _this;

        (0, _classCallCheck2.default)(this, WithStyles);
        _this = (0, _possibleConstructorReturn2.default)(this, (WithStyles.__proto__ || Object.getPrototypeOf(WithStyles)).call(this, props, context));
        _this.disableStylesGeneration = false;
        _this.jss = null;
        _this.sheetOptions = null;
        _this.sheetsManager = sheetsManager;
        _this.stylesCreatorSaved = null;
        _this.theme = null;
        _this.unsubscribeId = null;
        _this.state = {};
        _this.jss = _this.context[ns.jss] || jss;
        var muiThemeProviderOptions = _this.context.muiThemeProviderOptions;

        if (muiThemeProviderOptions) {
          if (muiThemeProviderOptions.sheetsManager) {
            _this.sheetsManager = muiThemeProviderOptions.sheetsManager;
          }

          _this.disableStylesGeneration = muiThemeProviderOptions.disableStylesGeneration;
        } // Attach the stylesCreator to the instance of the component as in the context
        // of react-hot-loader the hooks can be executed in a different closure context:
        // https://github.com/gaearon/react-hot-loader/blob/master/src/patch.dev.js#L107


        _this.stylesCreatorSaved = stylesCreator;
        _this.sheetOptions = (0, _objectSpread2.default)({
          generateClassName: generateClassName
        }, _this.context[ns.sheetOptions]); // We use || as the function call is lazy evaluated.

        _this.theme = listenToTheme ? _themeListener.default.initial(context) || getDefaultTheme() : noopTheme;

        _this.attach(_this.theme);

        _this.cacheClasses = {
          // Cache for the finalized classes value.
          value: null,
          // Cache for the last used classes prop pointer.
          lastProp: null,
          // Cache for the last used rendered classes pointer.
          lastJSS: {}
        };
        return _this;
      }

      (0, _createClass2.default)(WithStyles, [{
        key: "componentDidMount",
        value: function componentDidMount() {
          var _this2 = this;

          if (!listenToTheme) {
            return;
          }

          this.unsubscribeId = _themeListener.default.subscribe(this.context, function (theme) {
            var oldTheme = _this2.theme;
            _this2.theme = theme;

            _this2.attach(_this2.theme); // Rerender the component so the underlying component gets the theme update.
            // By theme update we mean receiving and applying the new class names.


            _this2.setState({}, function () {
              _this2.detach(oldTheme);
            });
          });
        }
      }, {
        key: "componentDidUpdate",
        value: function componentDidUpdate() {
          // react-hot-loader specific logic
          if (this.stylesCreatorSaved === stylesCreator || "production" === 'production') {
            return;
          }

          this.detach(this.theme);
          this.stylesCreatorSaved = stylesCreator;
          this.attach(this.theme);
          this.forceUpdate();
        }
      }, {
        key: "componentWillUnmount",
        value: function componentWillUnmount() {
          this.detach(this.theme);

          if (this.unsubscribeId !== null) {
            _themeListener.default.unsubscribe(this.context, this.unsubscribeId);
          }
        }
      }, {
        key: "getClasses",
        value: function getClasses() {
          // Tracks if either the rendered classes or classes prop has changed,
          // requiring the generation of a new finalized classes object.
          var generate = false;

          if (!this.disableStylesGeneration) {
            var sheetManager = this.sheetsManager.get(this.stylesCreatorSaved);
            var sheetsManagerTheme = sheetManager.get(this.theme);

            if (sheetsManagerTheme.sheet.classes !== this.cacheClasses.lastJSS) {
              this.cacheClasses.lastJSS = sheetsManagerTheme.sheet.classes;
              generate = true;
            }
          }

          if (this.props.classes !== this.cacheClasses.lastProp) {
            this.cacheClasses.lastProp = this.props.classes;
            generate = true;
          }

          if (generate) {
            this.cacheClasses.value = (0, _mergeClasses.default)({
              baseClasses: this.cacheClasses.lastJSS,
              newClasses: this.props.classes,
              Component: Component,
              noBase: this.disableStylesGeneration
            });
          }

          return this.cacheClasses.value;
        }
      }, {
        key: "attach",
        value: function attach(theme) {
          if (this.disableStylesGeneration) {
            return;
          }

          var stylesCreatorSaved = this.stylesCreatorSaved;
          var sheetManager = this.sheetsManager.get(stylesCreatorSaved);

          if (!sheetManager) {
            sheetManager = new Map();
            this.sheetsManager.set(stylesCreatorSaved, sheetManager);
          }

          var sheetManagerTheme = sheetManager.get(theme);

          if (!sheetManagerTheme) {
            sheetManagerTheme = {
              refs: 0,
              sheet: null
            };
            sheetManager.set(theme, sheetManagerTheme);
          }

          if (sheetManagerTheme.refs === 0) {
            var styles = stylesCreatorSaved.create(theme, name);
            var meta = name;

            if (false) {
              meta = (0, _getDisplayName.default)(Component);
              process.env.NODE_ENV !== "production" ? (0, _warning.default)(typeof meta === 'string', ['Material-UI: the component displayName is invalid. It needs to be a string.', "Please fix the following component: ".concat(Component, ".")].join('\n')) : void 0;
            }

            var sheet = this.jss.createStyleSheet(styles, (0, _objectSpread2.default)({
              meta: meta,
              classNamePrefix: meta,
              flip: typeof flip === 'boolean' ? flip : theme.direction === 'rtl',
              link: false
            }, this.sheetOptions, stylesCreatorSaved.options, {
              name: name
            }, styleSheetOptions));
            sheetManagerTheme.sheet = sheet;
            sheet.attach();
            var sheetsRegistry = this.context[ns.sheetsRegistry];

            if (sheetsRegistry) {
              sheetsRegistry.add(sheet);
            }
          }

          sheetManagerTheme.refs += 1;
        }
      }, {
        key: "detach",
        value: function detach(theme) {
          if (this.disableStylesGeneration) {
            return;
          }

          var stylesCreatorSaved = this.stylesCreatorSaved;
          var sheetManager = this.sheetsManager.get(stylesCreatorSaved);
          var sheetManagerTheme = sheetManager.get(theme);
          sheetManagerTheme.refs -= 1;

          if (sheetManagerTheme.refs === 0) {
            sheetManager.delete(theme);
            this.jss.removeStyleSheet(sheetManagerTheme.sheet);
            var sheetsRegistry = this.context[ns.sheetsRegistry];

            if (sheetsRegistry) {
              sheetsRegistry.remove(sheetManagerTheme.sheet);
            }
          }
        }
      }, {
        key: "render",
        value: function render() {
          var _props = this.props,
              classes = _props.classes,
              innerRef = _props.innerRef,
              other = (0, _objectWithoutProperties2.default)(_props, ["classes", "innerRef"]);
          var more = (0, _getThemeProps.default)({
            theme: this.theme,
            name: name
          }); // Provide the theme to the wrapped component.
          // So we don't have to use the `withTheme()` Higher-order Component.

          if (withTheme) {
            more.theme = this.theme;
          }

          return _react.default.createElement(Component, (0, _extends2.default)({}, more, {
            classes: this.getClasses(),
            ref: innerRef
          }, other));
        }
      }]);
      return WithStyles;
    }(_react.default.Component);

    WithStyles.propTypes =  false ? {
      /**
       * Override or extend the styles applied to the component.
       */
      classes: _propTypes.default.object,

      /**
       * Use that property to pass a ref callback to the decorated component.
       */
      innerRef: _propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.object])
    } : {};
    WithStyles.contextTypes = (0, _objectSpread2.default)({
      muiThemeProviderOptions: _propTypes.default.object
    }, _contextTypes.default, listenToTheme ? _themeListener.default.contextTypes : {});

    if (false) {
      WithStyles.displayName = (0, _wrapDisplayName.default)(Component, 'WithStyles');
    }

    (0, _hoistNonReactStatics.default)(WithStyles, Component);

    if (false) {
      // Exposed for test purposes.
      WithStyles.Naked = Component;
      WithStyles.options = options;
    }

    return WithStyles;
  };
};

var _default = withStyles;
exports.default = _default;

/***/ }),
/* 4 */
/***/ (function(module, exports) {

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

module.exports = _objectWithoutProperties;

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2017 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames () {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg) && arg.length) {
				var inner = classNames.apply(null, arg);
				if (inner) {
					classes.push(inner);
				}
			} else if (argType === 'object') {
				for (var key in arg) {
					if (hasOwn.call(arg, key) && arg[key]) {
						classes.push(key);
					}
				}
			}
		}

		return classes.join(' ');
	}

	if (typeof module !== 'undefined' && module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
			return classNames;
		}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {
		window.classNames = classNames;
	}
}());


/***/ }),
/* 6 */
/***/ (function(module, exports) {

function _extends() {
  module.exports = _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

module.exports = _extends;

/***/ }),
/* 7 */
/***/ (function(module, exports) {

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

module.exports = _defineProperty;

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, module) {var __WEBPACK_AMD_DEFINE_RESULT__;/**
 * @license
 * Lodash <https://lodash.com/>
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */
;(function() {

  /** Used as a safe reference for `undefined` in pre-ES5 environments. */
  var undefined;

  /** Used as the semantic version number. */
  var VERSION = '4.17.15';

  /** Used as the size to enable large array optimizations. */
  var LARGE_ARRAY_SIZE = 200;

  /** Error message constants. */
  var CORE_ERROR_TEXT = 'Unsupported core-js use. Try https://npms.io/search?q=ponyfill.',
      FUNC_ERROR_TEXT = 'Expected a function';

  /** Used to stand-in for `undefined` hash values. */
  var HASH_UNDEFINED = '__lodash_hash_undefined__';

  /** Used as the maximum memoize cache size. */
  var MAX_MEMOIZE_SIZE = 500;

  /** Used as the internal argument placeholder. */
  var PLACEHOLDER = '__lodash_placeholder__';

  /** Used to compose bitmasks for cloning. */
  var CLONE_DEEP_FLAG = 1,
      CLONE_FLAT_FLAG = 2,
      CLONE_SYMBOLS_FLAG = 4;

  /** Used to compose bitmasks for value comparisons. */
  var COMPARE_PARTIAL_FLAG = 1,
      COMPARE_UNORDERED_FLAG = 2;

  /** Used to compose bitmasks for function metadata. */
  var WRAP_BIND_FLAG = 1,
      WRAP_BIND_KEY_FLAG = 2,
      WRAP_CURRY_BOUND_FLAG = 4,
      WRAP_CURRY_FLAG = 8,
      WRAP_CURRY_RIGHT_FLAG = 16,
      WRAP_PARTIAL_FLAG = 32,
      WRAP_PARTIAL_RIGHT_FLAG = 64,
      WRAP_ARY_FLAG = 128,
      WRAP_REARG_FLAG = 256,
      WRAP_FLIP_FLAG = 512;

  /** Used as default options for `_.truncate`. */
  var DEFAULT_TRUNC_LENGTH = 30,
      DEFAULT_TRUNC_OMISSION = '...';

  /** Used to detect hot functions by number of calls within a span of milliseconds. */
  var HOT_COUNT = 800,
      HOT_SPAN = 16;

  /** Used to indicate the type of lazy iteratees. */
  var LAZY_FILTER_FLAG = 1,
      LAZY_MAP_FLAG = 2,
      LAZY_WHILE_FLAG = 3;

  /** Used as references for various `Number` constants. */
  var INFINITY = 1 / 0,
      MAX_SAFE_INTEGER = 9007199254740991,
      MAX_INTEGER = 1.7976931348623157e+308,
      NAN = 0 / 0;

  /** Used as references for the maximum length and index of an array. */
  var MAX_ARRAY_LENGTH = 4294967295,
      MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1,
      HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;

  /** Used to associate wrap methods with their bit flags. */
  var wrapFlags = [
    ['ary', WRAP_ARY_FLAG],
    ['bind', WRAP_BIND_FLAG],
    ['bindKey', WRAP_BIND_KEY_FLAG],
    ['curry', WRAP_CURRY_FLAG],
    ['curryRight', WRAP_CURRY_RIGHT_FLAG],
    ['flip', WRAP_FLIP_FLAG],
    ['partial', WRAP_PARTIAL_FLAG],
    ['partialRight', WRAP_PARTIAL_RIGHT_FLAG],
    ['rearg', WRAP_REARG_FLAG]
  ];

  /** `Object#toString` result references. */
  var argsTag = '[object Arguments]',
      arrayTag = '[object Array]',
      asyncTag = '[object AsyncFunction]',
      boolTag = '[object Boolean]',
      dateTag = '[object Date]',
      domExcTag = '[object DOMException]',
      errorTag = '[object Error]',
      funcTag = '[object Function]',
      genTag = '[object GeneratorFunction]',
      mapTag = '[object Map]',
      numberTag = '[object Number]',
      nullTag = '[object Null]',
      objectTag = '[object Object]',
      promiseTag = '[object Promise]',
      proxyTag = '[object Proxy]',
      regexpTag = '[object RegExp]',
      setTag = '[object Set]',
      stringTag = '[object String]',
      symbolTag = '[object Symbol]',
      undefinedTag = '[object Undefined]',
      weakMapTag = '[object WeakMap]',
      weakSetTag = '[object WeakSet]';

  var arrayBufferTag = '[object ArrayBuffer]',
      dataViewTag = '[object DataView]',
      float32Tag = '[object Float32Array]',
      float64Tag = '[object Float64Array]',
      int8Tag = '[object Int8Array]',
      int16Tag = '[object Int16Array]',
      int32Tag = '[object Int32Array]',
      uint8Tag = '[object Uint8Array]',
      uint8ClampedTag = '[object Uint8ClampedArray]',
      uint16Tag = '[object Uint16Array]',
      uint32Tag = '[object Uint32Array]';

  /** Used to match empty string literals in compiled template source. */
  var reEmptyStringLeading = /\b__p \+= '';/g,
      reEmptyStringMiddle = /\b(__p \+=) '' \+/g,
      reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;

  /** Used to match HTML entities and HTML characters. */
  var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g,
      reUnescapedHtml = /[&<>"']/g,
      reHasEscapedHtml = RegExp(reEscapedHtml.source),
      reHasUnescapedHtml = RegExp(reUnescapedHtml.source);

  /** Used to match template delimiters. */
  var reEscape = /<%-([\s\S]+?)%>/g,
      reEvaluate = /<%([\s\S]+?)%>/g,
      reInterpolate = /<%=([\s\S]+?)%>/g;

  /** Used to match property names within property paths. */
  var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
      reIsPlainProp = /^\w*$/,
      rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

  /**
   * Used to match `RegExp`
   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
   */
  var reRegExpChar = /[\\^$.*+?()[\]{}|]/g,
      reHasRegExpChar = RegExp(reRegExpChar.source);

  /** Used to match leading and trailing whitespace. */
  var reTrim = /^\s+|\s+$/g,
      reTrimStart = /^\s+/,
      reTrimEnd = /\s+$/;

  /** Used to match wrap detail comments. */
  var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/,
      reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/,
      reSplitDetails = /,? & /;

  /** Used to match words composed of alphanumeric characters. */
  var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;

  /** Used to match backslashes in property paths. */
  var reEscapeChar = /\\(\\)?/g;

  /**
   * Used to match
   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
   */
  var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;

  /** Used to match `RegExp` flags from their coerced string values. */
  var reFlags = /\w*$/;

  /** Used to detect bad signed hexadecimal string values. */
  var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

  /** Used to detect binary string values. */
  var reIsBinary = /^0b[01]+$/i;

  /** Used to detect host constructors (Safari). */
  var reIsHostCtor = /^\[object .+?Constructor\]$/;

  /** Used to detect octal string values. */
  var reIsOctal = /^0o[0-7]+$/i;

  /** Used to detect unsigned integer values. */
  var reIsUint = /^(?:0|[1-9]\d*)$/;

  /** Used to match Latin Unicode letters (excluding mathematical operators). */
  var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;

  /** Used to ensure capturing order of template delimiters. */
  var reNoMatch = /($^)/;

  /** Used to match unescaped characters in compiled string literals. */
  var reUnescapedString = /['\n\r\u2028\u2029\\]/g;

  /** Used to compose unicode character classes. */
  var rsAstralRange = '\\ud800-\\udfff',
      rsComboMarksRange = '\\u0300-\\u036f',
      reComboHalfMarksRange = '\\ufe20-\\ufe2f',
      rsComboSymbolsRange = '\\u20d0-\\u20ff',
      rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
      rsDingbatRange = '\\u2700-\\u27bf',
      rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff',
      rsMathOpRange = '\\xac\\xb1\\xd7\\xf7',
      rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf',
      rsPunctuationRange = '\\u2000-\\u206f',
      rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000',
      rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde',
      rsVarRange = '\\ufe0e\\ufe0f',
      rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;

  /** Used to compose unicode capture groups. */
  var rsApos = "['\u2019]",
      rsAstral = '[' + rsAstralRange + ']',
      rsBreak = '[' + rsBreakRange + ']',
      rsCombo = '[' + rsComboRange + ']',
      rsDigits = '\\d+',
      rsDingbat = '[' + rsDingbatRange + ']',
      rsLower = '[' + rsLowerRange + ']',
      rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']',
      rsFitz = '\\ud83c[\\udffb-\\udfff]',
      rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
      rsNonAstral = '[^' + rsAstralRange + ']',
      rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
      rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
      rsUpper = '[' + rsUpperRange + ']',
      rsZWJ = '\\u200d';

  /** Used to compose unicode regexes. */
  var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')',
      rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')',
      rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?',
      rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?',
      reOptMod = rsModifier + '?',
      rsOptVar = '[' + rsVarRange + ']?',
      rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
      rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])',
      rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])',
      rsSeq = rsOptVar + reOptMod + rsOptJoin,
      rsEmoji = '(?:' + [rsDingbat, rsRegional, rsSurrPair].join('|') + ')' + rsSeq,
      rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';

  /** Used to match apostrophes. */
  var reApos = RegExp(rsApos, 'g');

  /**
   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
   */
  var reComboMark = RegExp(rsCombo, 'g');

  /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
  var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');

  /** Used to match complex or compound words. */
  var reUnicodeWord = RegExp([
    rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [rsBreak, rsUpper, '$'].join('|') + ')',
    rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [rsBreak, rsUpper + rsMiscLower, '$'].join('|') + ')',
    rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
    rsUpper + '+' + rsOptContrUpper,
    rsOrdUpper,
    rsOrdLower,
    rsDigits,
    rsEmoji
  ].join('|'), 'g');

  /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
  var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange  + rsComboRange + rsVarRange + ']');

  /** Used to detect strings that need a more robust regexp to match words. */
  var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;

  /** Used to assign default `context` object properties. */
  var contextProps = [
    'Array', 'Buffer', 'DataView', 'Date', 'Error', 'Float32Array', 'Float64Array',
    'Function', 'Int8Array', 'Int16Array', 'Int32Array', 'Map', 'Math', 'Object',
    'Promise', 'RegExp', 'Set', 'String', 'Symbol', 'TypeError', 'Uint8Array',
    'Uint8ClampedArray', 'Uint16Array', 'Uint32Array', 'WeakMap',
    '_', 'clearTimeout', 'isFinite', 'parseInt', 'setTimeout'
  ];

  /** Used to make template sourceURLs easier to identify. */
  var templateCounter = -1;

  /** Used to identify `toStringTag` values of typed arrays. */
  var typedArrayTags = {};
  typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
  typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
  typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
  typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
  typedArrayTags[uint32Tag] = true;
  typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
  typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
  typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
  typedArrayTags[errorTag] = typedArrayTags[funcTag] =
  typedArrayTags[mapTag] = typedArrayTags[numberTag] =
  typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
  typedArrayTags[setTag] = typedArrayTags[stringTag] =
  typedArrayTags[weakMapTag] = false;

  /** Used to identify `toStringTag` values supported by `_.clone`. */
  var cloneableTags = {};
  cloneableTags[argsTag] = cloneableTags[arrayTag] =
  cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
  cloneableTags[boolTag] = cloneableTags[dateTag] =
  cloneableTags[float32Tag] = cloneableTags[float64Tag] =
  cloneableTags[int8Tag] = cloneableTags[int16Tag] =
  cloneableTags[int32Tag] = cloneableTags[mapTag] =
  cloneableTags[numberTag] = cloneableTags[objectTag] =
  cloneableTags[regexpTag] = cloneableTags[setTag] =
  cloneableTags[stringTag] = cloneableTags[symbolTag] =
  cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
  cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
  cloneableTags[errorTag] = cloneableTags[funcTag] =
  cloneableTags[weakMapTag] = false;

  /** Used to map Latin Unicode letters to basic Latin letters. */
  var deburredLetters = {
    // Latin-1 Supplement block.
    '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
    '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
    '\xc7': 'C',  '\xe7': 'c',
    '\xd0': 'D',  '\xf0': 'd',
    '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
    '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
    '\xcc': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
    '\xec': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
    '\xd1': 'N',  '\xf1': 'n',
    '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
    '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
    '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
    '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
    '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
    '\xc6': 'Ae', '\xe6': 'ae',
    '\xde': 'Th', '\xfe': 'th',
    '\xdf': 'ss',
    // Latin Extended-A block.
    '\u0100': 'A',  '\u0102': 'A', '\u0104': 'A',
    '\u0101': 'a',  '\u0103': 'a', '\u0105': 'a',
    '\u0106': 'C',  '\u0108': 'C', '\u010a': 'C', '\u010c': 'C',
    '\u0107': 'c',  '\u0109': 'c', '\u010b': 'c', '\u010d': 'c',
    '\u010e': 'D',  '\u0110': 'D', '\u010f': 'd', '\u0111': 'd',
    '\u0112': 'E',  '\u0114': 'E', '\u0116': 'E', '\u0118': 'E', '\u011a': 'E',
    '\u0113': 'e',  '\u0115': 'e', '\u0117': 'e', '\u0119': 'e', '\u011b': 'e',
    '\u011c': 'G',  '\u011e': 'G', '\u0120': 'G', '\u0122': 'G',
    '\u011d': 'g',  '\u011f': 'g', '\u0121': 'g', '\u0123': 'g',
    '\u0124': 'H',  '\u0126': 'H', '\u0125': 'h', '\u0127': 'h',
    '\u0128': 'I',  '\u012a': 'I', '\u012c': 'I', '\u012e': 'I', '\u0130': 'I',
    '\u0129': 'i',  '\u012b': 'i', '\u012d': 'i', '\u012f': 'i', '\u0131': 'i',
    '\u0134': 'J',  '\u0135': 'j',
    '\u0136': 'K',  '\u0137': 'k', '\u0138': 'k',
    '\u0139': 'L',  '\u013b': 'L', '\u013d': 'L', '\u013f': 'L', '\u0141': 'L',
    '\u013a': 'l',  '\u013c': 'l', '\u013e': 'l', '\u0140': 'l', '\u0142': 'l',
    '\u0143': 'N',  '\u0145': 'N', '\u0147': 'N', '\u014a': 'N',
    '\u0144': 'n',  '\u0146': 'n', '\u0148': 'n', '\u014b': 'n',
    '\u014c': 'O',  '\u014e': 'O', '\u0150': 'O',
    '\u014d': 'o',  '\u014f': 'o', '\u0151': 'o',
    '\u0154': 'R',  '\u0156': 'R', '\u0158': 'R',
    '\u0155': 'r',  '\u0157': 'r', '\u0159': 'r',
    '\u015a': 'S',  '\u015c': 'S', '\u015e': 'S', '\u0160': 'S',
    '\u015b': 's',  '\u015d': 's', '\u015f': 's', '\u0161': 's',
    '\u0162': 'T',  '\u0164': 'T', '\u0166': 'T',
    '\u0163': 't',  '\u0165': 't', '\u0167': 't',
    '\u0168': 'U',  '\u016a': 'U', '\u016c': 'U', '\u016e': 'U', '\u0170': 'U', '\u0172': 'U',
    '\u0169': 'u',  '\u016b': 'u', '\u016d': 'u', '\u016f': 'u', '\u0171': 'u', '\u0173': 'u',
    '\u0174': 'W',  '\u0175': 'w',
    '\u0176': 'Y',  '\u0177': 'y', '\u0178': 'Y',
    '\u0179': 'Z',  '\u017b': 'Z', '\u017d': 'Z',
    '\u017a': 'z',  '\u017c': 'z', '\u017e': 'z',
    '\u0132': 'IJ', '\u0133': 'ij',
    '\u0152': 'Oe', '\u0153': 'oe',
    '\u0149': "'n", '\u017f': 's'
  };

  /** Used to map characters to HTML entities. */
  var htmlEscapes = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;'
  };

  /** Used to map HTML entities to characters. */
  var htmlUnescapes = {
    '&amp;': '&',
    '&lt;': '<',
    '&gt;': '>',
    '&quot;': '"',
    '&#39;': "'"
  };

  /** Used to escape characters for inclusion in compiled string literals. */
  var stringEscapes = {
    '\\': '\\',
    "'": "'",
    '\n': 'n',
    '\r': 'r',
    '\u2028': 'u2028',
    '\u2029': 'u2029'
  };

  /** Built-in method references without a dependency on `root`. */
  var freeParseFloat = parseFloat,
      freeParseInt = parseInt;

  /** Detect free variable `global` from Node.js. */
  var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

  /** Detect free variable `self`. */
  var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

  /** Used as a reference to the global object. */
  var root = freeGlobal || freeSelf || Function('return this')();

  /** Detect free variable `exports`. */
  var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

  /** Detect free variable `module`. */
  var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

  /** Detect the popular CommonJS extension `module.exports`. */
  var moduleExports = freeModule && freeModule.exports === freeExports;

  /** Detect free variable `process` from Node.js. */
  var freeProcess = moduleExports && freeGlobal.process;

  /** Used to access faster Node.js helpers. */
  var nodeUtil = (function() {
    try {
      // Use `util.types` for Node.js 10+.
      var types = freeModule && freeModule.require && freeModule.require('util').types;

      if (types) {
        return types;
      }

      // Legacy `process.binding('util')` for Node.js < 10.
      return freeProcess && freeProcess.binding && freeProcess.binding('util');
    } catch (e) {}
  }());

  /* Node.js helper references. */
  var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer,
      nodeIsDate = nodeUtil && nodeUtil.isDate,
      nodeIsMap = nodeUtil && nodeUtil.isMap,
      nodeIsRegExp = nodeUtil && nodeUtil.isRegExp,
      nodeIsSet = nodeUtil && nodeUtil.isSet,
      nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

  /*--------------------------------------------------------------------------*/

  /**
   * A faster alternative to `Function#apply`, this function invokes `func`
   * with the `this` binding of `thisArg` and the arguments of `args`.
   *
   * @private
   * @param {Function} func The function to invoke.
   * @param {*} thisArg The `this` binding of `func`.
   * @param {Array} args The arguments to invoke `func` with.
   * @returns {*} Returns the result of `func`.
   */
  function apply(func, thisArg, args) {
    switch (args.length) {
      case 0: return func.call(thisArg);
      case 1: return func.call(thisArg, args[0]);
      case 2: return func.call(thisArg, args[0], args[1]);
      case 3: return func.call(thisArg, args[0], args[1], args[2]);
    }
    return func.apply(thisArg, args);
  }

  /**
   * A specialized version of `baseAggregator` for arrays.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} setter The function to set `accumulator` values.
   * @param {Function} iteratee The iteratee to transform keys.
   * @param {Object} accumulator The initial aggregated object.
   * @returns {Function} Returns `accumulator`.
   */
  function arrayAggregator(array, setter, iteratee, accumulator) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      var value = array[index];
      setter(accumulator, value, iteratee(value), array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.forEach` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */
  function arrayEach(array, iteratee) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (iteratee(array[index], index, array) === false) {
        break;
      }
    }
    return array;
  }

  /**
   * A specialized version of `_.forEachRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */
  function arrayEachRight(array, iteratee) {
    var length = array == null ? 0 : array.length;

    while (length--) {
      if (iteratee(array[length], length, array) === false) {
        break;
      }
    }
    return array;
  }

  /**
   * A specialized version of `_.every` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if all elements pass the predicate check,
   *  else `false`.
   */
  function arrayEvery(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (!predicate(array[index], index, array)) {
        return false;
      }
    }
    return true;
  }

  /**
   * A specialized version of `_.filter` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {Array} Returns the new filtered array.
   */
  function arrayFilter(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length,
        resIndex = 0,
        result = [];

    while (++index < length) {
      var value = array[index];
      if (predicate(value, index, array)) {
        result[resIndex++] = value;
      }
    }
    return result;
  }

  /**
   * A specialized version of `_.includes` for arrays without support for
   * specifying an index to search from.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */
  function arrayIncludes(array, value) {
    var length = array == null ? 0 : array.length;
    return !!length && baseIndexOf(array, value, 0) > -1;
  }

  /**
   * This function is like `arrayIncludes` except that it accepts a comparator.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */
  function arrayIncludesWith(array, value, comparator) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (comparator(value, array[index])) {
        return true;
      }
    }
    return false;
  }

  /**
   * A specialized version of `_.map` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the new mapped array.
   */
  function arrayMap(array, iteratee) {
    var index = -1,
        length = array == null ? 0 : array.length,
        result = Array(length);

    while (++index < length) {
      result[index] = iteratee(array[index], index, array);
    }
    return result;
  }

  /**
   * Appends the elements of `values` to `array`.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {Array} values The values to append.
   * @returns {Array} Returns `array`.
   */
  function arrayPush(array, values) {
    var index = -1,
        length = values.length,
        offset = array.length;

    while (++index < length) {
      array[offset + index] = values[index];
    }
    return array;
  }

  /**
   * A specialized version of `_.reduce` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the first element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */
  function arrayReduce(array, iteratee, accumulator, initAccum) {
    var index = -1,
        length = array == null ? 0 : array.length;

    if (initAccum && length) {
      accumulator = array[++index];
    }
    while (++index < length) {
      accumulator = iteratee(accumulator, array[index], index, array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.reduceRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the last element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */
  function arrayReduceRight(array, iteratee, accumulator, initAccum) {
    var length = array == null ? 0 : array.length;
    if (initAccum && length) {
      accumulator = array[--length];
    }
    while (length--) {
      accumulator = iteratee(accumulator, array[length], length, array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.some` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if any element passes the predicate check,
   *  else `false`.
   */
  function arraySome(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (predicate(array[index], index, array)) {
        return true;
      }
    }
    return false;
  }

  /**
   * Gets the size of an ASCII `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */
  var asciiSize = baseProperty('length');

  /**
   * Converts an ASCII `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function asciiToArray(string) {
    return string.split('');
  }

  /**
   * Splits an ASCII `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */
  function asciiWords(string) {
    return string.match(reAsciiWord) || [];
  }

  /**
   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
   * without support for iteratee shorthands, which iterates over `collection`
   * using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the found element or its key, else `undefined`.
   */
  function baseFindKey(collection, predicate, eachFunc) {
    var result;
    eachFunc(collection, function(value, key, collection) {
      if (predicate(value, key, collection)) {
        result = key;
        return false;
      }
    });
    return result;
  }

  /**
   * The base implementation of `_.findIndex` and `_.findLastIndex` without
   * support for iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {number} fromIndex The index to search from.
   * @param {boolean} [fromRight] Specify iterating from right to left.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseFindIndex(array, predicate, fromIndex, fromRight) {
    var length = array.length,
        index = fromIndex + (fromRight ? 1 : -1);

    while ((fromRight ? index-- : ++index < length)) {
      if (predicate(array[index], index, array)) {
        return index;
      }
    }
    return -1;
  }

  /**
   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseIndexOf(array, value, fromIndex) {
    return value === value
      ? strictIndexOf(array, value, fromIndex)
      : baseFindIndex(array, baseIsNaN, fromIndex);
  }

  /**
   * This function is like `baseIndexOf` except that it accepts a comparator.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseIndexOfWith(array, value, fromIndex, comparator) {
    var index = fromIndex - 1,
        length = array.length;

    while (++index < length) {
      if (comparator(array[index], value)) {
        return index;
      }
    }
    return -1;
  }

  /**
   * The base implementation of `_.isNaN` without support for number objects.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
   */
  function baseIsNaN(value) {
    return value !== value;
  }

  /**
   * The base implementation of `_.mean` and `_.meanBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the mean.
   */
  function baseMean(array, iteratee) {
    var length = array == null ? 0 : array.length;
    return length ? (baseSum(array, iteratee) / length) : NAN;
  }

  /**
   * The base implementation of `_.property` without support for deep paths.
   *
   * @private
   * @param {string} key The key of the property to get.
   * @returns {Function} Returns the new accessor function.
   */
  function baseProperty(key) {
    return function(object) {
      return object == null ? undefined : object[key];
    };
  }

  /**
   * The base implementation of `_.propertyOf` without support for deep paths.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Function} Returns the new accessor function.
   */
  function basePropertyOf(object) {
    return function(key) {
      return object == null ? undefined : object[key];
    };
  }

  /**
   * The base implementation of `_.reduce` and `_.reduceRight`, without support
   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} accumulator The initial value.
   * @param {boolean} initAccum Specify using the first or last element of
   *  `collection` as the initial value.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the accumulated value.
   */
  function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
    eachFunc(collection, function(value, index, collection) {
      accumulator = initAccum
        ? (initAccum = false, value)
        : iteratee(accumulator, value, index, collection);
    });
    return accumulator;
  }

  /**
   * The base implementation of `_.sortBy` which uses `comparer` to define the
   * sort order of `array` and replaces criteria objects with their corresponding
   * values.
   *
   * @private
   * @param {Array} array The array to sort.
   * @param {Function} comparer The function to define sort order.
   * @returns {Array} Returns `array`.
   */
  function baseSortBy(array, comparer) {
    var length = array.length;

    array.sort(comparer);
    while (length--) {
      array[length] = array[length].value;
    }
    return array;
  }

  /**
   * The base implementation of `_.sum` and `_.sumBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the sum.
   */
  function baseSum(array, iteratee) {
    var result,
        index = -1,
        length = array.length;

    while (++index < length) {
      var current = iteratee(array[index]);
      if (current !== undefined) {
        result = result === undefined ? current : (result + current);
      }
    }
    return result;
  }

  /**
   * The base implementation of `_.times` without support for iteratee shorthands
   * or max array length checks.
   *
   * @private
   * @param {number} n The number of times to invoke `iteratee`.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the array of results.
   */
  function baseTimes(n, iteratee) {
    var index = -1,
        result = Array(n);

    while (++index < n) {
      result[index] = iteratee(index);
    }
    return result;
  }

  /**
   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
   * of key-value pairs for `object` corresponding to the property names of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the key-value pairs.
   */
  function baseToPairs(object, props) {
    return arrayMap(props, function(key) {
      return [key, object[key]];
    });
  }

  /**
   * The base implementation of `_.unary` without support for storing metadata.
   *
   * @private
   * @param {Function} func The function to cap arguments for.
   * @returns {Function} Returns the new capped function.
   */
  function baseUnary(func) {
    return function(value) {
      return func(value);
    };
  }

  /**
   * The base implementation of `_.values` and `_.valuesIn` which creates an
   * array of `object` property values corresponding to the property names
   * of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the array of property values.
   */
  function baseValues(object, props) {
    return arrayMap(props, function(key) {
      return object[key];
    });
  }

  /**
   * Checks if a `cache` value for `key` exists.
   *
   * @private
   * @param {Object} cache The cache to query.
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */
  function cacheHas(cache, key) {
    return cache.has(key);
  }

  /**
   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the first unmatched string symbol.
   */
  function charsStartIndex(strSymbols, chrSymbols) {
    var index = -1,
        length = strSymbols.length;

    while (++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
    return index;
  }

  /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the last unmatched string symbol.
   */
  function charsEndIndex(strSymbols, chrSymbols) {
    var index = strSymbols.length;

    while (index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
    return index;
  }

  /**
   * Gets the number of `placeholder` occurrences in `array`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} placeholder The placeholder to search for.
   * @returns {number} Returns the placeholder count.
   */
  function countHolders(array, placeholder) {
    var length = array.length,
        result = 0;

    while (length--) {
      if (array[length] === placeholder) {
        ++result;
      }
    }
    return result;
  }

  /**
   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
   * letters to basic Latin letters.
   *
   * @private
   * @param {string} letter The matched letter to deburr.
   * @returns {string} Returns the deburred letter.
   */
  var deburrLetter = basePropertyOf(deburredLetters);

  /**
   * Used by `_.escape` to convert characters to HTML entities.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */
  var escapeHtmlChar = basePropertyOf(htmlEscapes);

  /**
   * Used by `_.template` to escape characters for inclusion in compiled string literals.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */
  function escapeStringChar(chr) {
    return '\\' + stringEscapes[chr];
  }

  /**
   * Gets the value at `key` of `object`.
   *
   * @private
   * @param {Object} [object] The object to query.
   * @param {string} key The key of the property to get.
   * @returns {*} Returns the property value.
   */
  function getValue(object, key) {
    return object == null ? undefined : object[key];
  }

  /**
   * Checks if `string` contains Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
   */
  function hasUnicode(string) {
    return reHasUnicode.test(string);
  }

  /**
   * Checks if `string` contains a word composed of Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a word is found, else `false`.
   */
  function hasUnicodeWord(string) {
    return reHasUnicodeWord.test(string);
  }

  /**
   * Converts `iterator` to an array.
   *
   * @private
   * @param {Object} iterator The iterator to convert.
   * @returns {Array} Returns the converted array.
   */
  function iteratorToArray(iterator) {
    var data,
        result = [];

    while (!(data = iterator.next()).done) {
      result.push(data.value);
    }
    return result;
  }

  /**
   * Converts `map` to its key-value pairs.
   *
   * @private
   * @param {Object} map The map to convert.
   * @returns {Array} Returns the key-value pairs.
   */
  function mapToArray(map) {
    var index = -1,
        result = Array(map.size);

    map.forEach(function(value, key) {
      result[++index] = [key, value];
    });
    return result;
  }

  /**
   * Creates a unary function that invokes `func` with its argument transformed.
   *
   * @private
   * @param {Function} func The function to wrap.
   * @param {Function} transform The argument transform.
   * @returns {Function} Returns the new function.
   */
  function overArg(func, transform) {
    return function(arg) {
      return func(transform(arg));
    };
  }

  /**
   * Replaces all `placeholder` elements in `array` with an internal placeholder
   * and returns an array of their indexes.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {*} placeholder The placeholder to replace.
   * @returns {Array} Returns the new array of placeholder indexes.
   */
  function replaceHolders(array, placeholder) {
    var index = -1,
        length = array.length,
        resIndex = 0,
        result = [];

    while (++index < length) {
      var value = array[index];
      if (value === placeholder || value === PLACEHOLDER) {
        array[index] = PLACEHOLDER;
        result[resIndex++] = index;
      }
    }
    return result;
  }

  /**
   * Converts `set` to an array of its values.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the values.
   */
  function setToArray(set) {
    var index = -1,
        result = Array(set.size);

    set.forEach(function(value) {
      result[++index] = value;
    });
    return result;
  }

  /**
   * Converts `set` to its value-value pairs.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the value-value pairs.
   */
  function setToPairs(set) {
    var index = -1,
        result = Array(set.size);

    set.forEach(function(value) {
      result[++index] = [value, value];
    });
    return result;
  }

  /**
   * A specialized version of `_.indexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function strictIndexOf(array, value, fromIndex) {
    var index = fromIndex - 1,
        length = array.length;

    while (++index < length) {
      if (array[index] === value) {
        return index;
      }
    }
    return -1;
  }

  /**
   * A specialized version of `_.lastIndexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function strictLastIndexOf(array, value, fromIndex) {
    var index = fromIndex + 1;
    while (index--) {
      if (array[index] === value) {
        return index;
      }
    }
    return index;
  }

  /**
   * Gets the number of symbols in `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the string size.
   */
  function stringSize(string) {
    return hasUnicode(string)
      ? unicodeSize(string)
      : asciiSize(string);
  }

  /**
   * Converts `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function stringToArray(string) {
    return hasUnicode(string)
      ? unicodeToArray(string)
      : asciiToArray(string);
  }

  /**
   * Used by `_.unescape` to convert HTML entities to characters.
   *
   * @private
   * @param {string} chr The matched character to unescape.
   * @returns {string} Returns the unescaped character.
   */
  var unescapeHtmlChar = basePropertyOf(htmlUnescapes);

  /**
   * Gets the size of a Unicode `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */
  function unicodeSize(string) {
    var result = reUnicode.lastIndex = 0;
    while (reUnicode.test(string)) {
      ++result;
    }
    return result;
  }

  /**
   * Converts a Unicode `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function unicodeToArray(string) {
    return string.match(reUnicode) || [];
  }

  /**
   * Splits a Unicode `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */
  function unicodeWords(string) {
    return string.match(reUnicodeWord) || [];
  }

  /*--------------------------------------------------------------------------*/

  /**
   * Create a new pristine `lodash` function using the `context` object.
   *
   * @static
   * @memberOf _
   * @since 1.1.0
   * @category Util
   * @param {Object} [context=root] The context object.
   * @returns {Function} Returns a new `lodash` function.
   * @example
   *
   * _.mixin({ 'foo': _.constant('foo') });
   *
   * var lodash = _.runInContext();
   * lodash.mixin({ 'bar': lodash.constant('bar') });
   *
   * _.isFunction(_.foo);
   * // => true
   * _.isFunction(_.bar);
   * // => false
   *
   * lodash.isFunction(lodash.foo);
   * // => false
   * lodash.isFunction(lodash.bar);
   * // => true
   *
   * // Create a suped-up `defer` in Node.js.
   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
   */
  var runInContext = (function runInContext(context) {
    context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));

    /** Built-in constructor references. */
    var Array = context.Array,
        Date = context.Date,
        Error = context.Error,
        Function = context.Function,
        Math = context.Math,
        Object = context.Object,
        RegExp = context.RegExp,
        String = context.String,
        TypeError = context.TypeError;

    /** Used for built-in method references. */
    var arrayProto = Array.prototype,
        funcProto = Function.prototype,
        objectProto = Object.prototype;

    /** Used to detect overreaching core-js shims. */
    var coreJsData = context['__core-js_shared__'];

    /** Used to resolve the decompiled source of functions. */
    var funcToString = funcProto.toString;

    /** Used to check objects for own properties. */
    var hasOwnProperty = objectProto.hasOwnProperty;

    /** Used to generate unique IDs. */
    var idCounter = 0;

    /** Used to detect methods masquerading as native. */
    var maskSrcKey = (function() {
      var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
      return uid ? ('Symbol(src)_1.' + uid) : '';
    }());

    /**
     * Used to resolve the
     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
     * of values.
     */
    var nativeObjectToString = objectProto.toString;

    /** Used to infer the `Object` constructor. */
    var objectCtorString = funcToString.call(Object);

    /** Used to restore the original `_` reference in `_.noConflict`. */
    var oldDash = root._;

    /** Used to detect if a method is native. */
    var reIsNative = RegExp('^' +
      funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
      .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
    );

    /** Built-in value references. */
    var Buffer = moduleExports ? context.Buffer : undefined,
        Symbol = context.Symbol,
        Uint8Array = context.Uint8Array,
        allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined,
        getPrototype = overArg(Object.getPrototypeOf, Object),
        objectCreate = Object.create,
        propertyIsEnumerable = objectProto.propertyIsEnumerable,
        splice = arrayProto.splice,
        spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined,
        symIterator = Symbol ? Symbol.iterator : undefined,
        symToStringTag = Symbol ? Symbol.toStringTag : undefined;

    var defineProperty = (function() {
      try {
        var func = getNative(Object, 'defineProperty');
        func({}, '', {});
        return func;
      } catch (e) {}
    }());

    /** Mocked built-ins. */
    var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout,
        ctxNow = Date && Date.now !== root.Date.now && Date.now,
        ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;

    /* Built-in method references for those with the same name as other `lodash` methods. */
    var nativeCeil = Math.ceil,
        nativeFloor = Math.floor,
        nativeGetSymbols = Object.getOwnPropertySymbols,
        nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
        nativeIsFinite = context.isFinite,
        nativeJoin = arrayProto.join,
        nativeKeys = overArg(Object.keys, Object),
        nativeMax = Math.max,
        nativeMin = Math.min,
        nativeNow = Date.now,
        nativeParseInt = context.parseInt,
        nativeRandom = Math.random,
        nativeReverse = arrayProto.reverse;

    /* Built-in method references that are verified to be native. */
    var DataView = getNative(context, 'DataView'),
        Map = getNative(context, 'Map'),
        Promise = getNative(context, 'Promise'),
        Set = getNative(context, 'Set'),
        WeakMap = getNative(context, 'WeakMap'),
        nativeCreate = getNative(Object, 'create');

    /** Used to store function metadata. */
    var metaMap = WeakMap && new WeakMap;

    /** Used to lookup unminified function names. */
    var realNames = {};

    /** Used to detect maps, sets, and weakmaps. */
    var dataViewCtorString = toSource(DataView),
        mapCtorString = toSource(Map),
        promiseCtorString = toSource(Promise),
        setCtorString = toSource(Set),
        weakMapCtorString = toSource(WeakMap);

    /** Used to convert symbols to primitives and strings. */
    var symbolProto = Symbol ? Symbol.prototype : undefined,
        symbolValueOf = symbolProto ? symbolProto.valueOf : undefined,
        symbolToString = symbolProto ? symbolProto.toString : undefined;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a `lodash` object which wraps `value` to enable implicit method
     * chain sequences. Methods that operate on and return arrays, collections,
     * and functions can be chained together. Methods that retrieve a single value
     * or may return a primitive value will automatically end the chain sequence
     * and return the unwrapped value. Otherwise, the value must be unwrapped
     * with `_#value`.
     *
     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
     * enabled using `_.chain`.
     *
     * The execution of chained methods is lazy, that is, it's deferred until
     * `_#value` is implicitly or explicitly called.
     *
     * Lazy evaluation allows several methods to support shortcut fusion.
     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
     * the creation of intermediate arrays and can greatly reduce the number of
     * iteratee executions. Sections of a chain sequence qualify for shortcut
     * fusion if the section is applied to an array and iteratees accept only
     * one argument. The heuristic for whether a section qualifies for shortcut
     * fusion is subject to change.
     *
     * Chaining is supported in custom builds as long as the `_#value` method is
     * directly or indirectly included in the build.
     *
     * In addition to lodash methods, wrappers have `Array` and `String` methods.
     *
     * The wrapper `Array` methods are:
     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
     *
     * The wrapper `String` methods are:
     * `replace` and `split`
     *
     * The wrapper methods that support shortcut fusion are:
     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
     *
     * The chainable wrapper methods are:
     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
     * `zipObject`, `zipObjectDeep`, and `zipWith`
     *
     * The wrapper methods that are **not** chainable by default are:
     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
     * `upperFirst`, `value`, and `words`
     *
     * @name _
     * @constructor
     * @category Seq
     * @param {*} value The value to wrap in a `lodash` instance.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2, 3]);
     *
     * // Returns an unwrapped value.
     * wrapped.reduce(_.add);
     * // => 6
     *
     * // Returns a wrapped value.
     * var squares = wrapped.map(square);
     *
     * _.isArray(squares);
     * // => false
     *
     * _.isArray(squares.value());
     * // => true
     */
    function lodash(value) {
      if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
        if (value instanceof LodashWrapper) {
          return value;
        }
        if (hasOwnProperty.call(value, '__wrapped__')) {
          return wrapperClone(value);
        }
      }
      return new LodashWrapper(value);
    }

    /**
     * The base implementation of `_.create` without support for assigning
     * properties to the created object.
     *
     * @private
     * @param {Object} proto The object to inherit from.
     * @returns {Object} Returns the new object.
     */
    var baseCreate = (function() {
      function object() {}
      return function(proto) {
        if (!isObject(proto)) {
          return {};
        }
        if (objectCreate) {
          return objectCreate(proto);
        }
        object.prototype = proto;
        var result = new object;
        object.prototype = undefined;
        return result;
      };
    }());

    /**
     * The function whose prototype chain sequence wrappers inherit from.
     *
     * @private
     */
    function baseLodash() {
      // No operation performed.
    }

    /**
     * The base constructor for creating `lodash` wrapper objects.
     *
     * @private
     * @param {*} value The value to wrap.
     * @param {boolean} [chainAll] Enable explicit method chain sequences.
     */
    function LodashWrapper(value, chainAll) {
      this.__wrapped__ = value;
      this.__actions__ = [];
      this.__chain__ = !!chainAll;
      this.__index__ = 0;
      this.__values__ = undefined;
    }

    /**
     * By default, the template delimiters used by lodash are like those in
     * embedded Ruby (ERB) as well as ES2015 template strings. Change the
     * following template settings to use alternative delimiters.
     *
     * @static
     * @memberOf _
     * @type {Object}
     */
    lodash.templateSettings = {

      /**
       * Used to detect `data` property values to be HTML-escaped.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'escape': reEscape,

      /**
       * Used to detect code to be evaluated.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'evaluate': reEvaluate,

      /**
       * Used to detect `data` property values to inject.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'interpolate': reInterpolate,

      /**
       * Used to reference the data object in the template text.
       *
       * @memberOf _.templateSettings
       * @type {string}
       */
      'variable': '',

      /**
       * Used to import variables into the compiled template.
       *
       * @memberOf _.templateSettings
       * @type {Object}
       */
      'imports': {

        /**
         * A reference to the `lodash` function.
         *
         * @memberOf _.templateSettings.imports
         * @type {Function}
         */
        '_': lodash
      }
    };

    // Ensure wrappers are instances of `baseLodash`.
    lodash.prototype = baseLodash.prototype;
    lodash.prototype.constructor = lodash;

    LodashWrapper.prototype = baseCreate(baseLodash.prototype);
    LodashWrapper.prototype.constructor = LodashWrapper;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
     *
     * @private
     * @constructor
     * @param {*} value The value to wrap.
     */
    function LazyWrapper(value) {
      this.__wrapped__ = value;
      this.__actions__ = [];
      this.__dir__ = 1;
      this.__filtered__ = false;
      this.__iteratees__ = [];
      this.__takeCount__ = MAX_ARRAY_LENGTH;
      this.__views__ = [];
    }

    /**
     * Creates a clone of the lazy wrapper object.
     *
     * @private
     * @name clone
     * @memberOf LazyWrapper
     * @returns {Object} Returns the cloned `LazyWrapper` object.
     */
    function lazyClone() {
      var result = new LazyWrapper(this.__wrapped__);
      result.__actions__ = copyArray(this.__actions__);
      result.__dir__ = this.__dir__;
      result.__filtered__ = this.__filtered__;
      result.__iteratees__ = copyArray(this.__iteratees__);
      result.__takeCount__ = this.__takeCount__;
      result.__views__ = copyArray(this.__views__);
      return result;
    }

    /**
     * Reverses the direction of lazy iteration.
     *
     * @private
     * @name reverse
     * @memberOf LazyWrapper
     * @returns {Object} Returns the new reversed `LazyWrapper` object.
     */
    function lazyReverse() {
      if (this.__filtered__) {
        var result = new LazyWrapper(this);
        result.__dir__ = -1;
        result.__filtered__ = true;
      } else {
        result = this.clone();
        result.__dir__ *= -1;
      }
      return result;
    }

    /**
     * Extracts the unwrapped value from its lazy wrapper.
     *
     * @private
     * @name value
     * @memberOf LazyWrapper
     * @returns {*} Returns the unwrapped value.
     */
    function lazyValue() {
      var array = this.__wrapped__.value(),
          dir = this.__dir__,
          isArr = isArray(array),
          isRight = dir < 0,
          arrLength = isArr ? array.length : 0,
          view = getView(0, arrLength, this.__views__),
          start = view.start,
          end = view.end,
          length = end - start,
          index = isRight ? end : (start - 1),
          iteratees = this.__iteratees__,
          iterLength = iteratees.length,
          resIndex = 0,
          takeCount = nativeMin(length, this.__takeCount__);

      if (!isArr || (!isRight && arrLength == length && takeCount == length)) {
        return baseWrapperValue(array, this.__actions__);
      }
      var result = [];

      outer:
      while (length-- && resIndex < takeCount) {
        index += dir;

        var iterIndex = -1,
            value = array[index];

        while (++iterIndex < iterLength) {
          var data = iteratees[iterIndex],
              iteratee = data.iteratee,
              type = data.type,
              computed = iteratee(value);

          if (type == LAZY_MAP_FLAG) {
            value = computed;
          } else if (!computed) {
            if (type == LAZY_FILTER_FLAG) {
              continue outer;
            } else {
              break outer;
            }
          }
        }
        result[resIndex++] = value;
      }
      return result;
    }

    // Ensure `LazyWrapper` is an instance of `baseLodash`.
    LazyWrapper.prototype = baseCreate(baseLodash.prototype);
    LazyWrapper.prototype.constructor = LazyWrapper;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a hash object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function Hash(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the hash.
     *
     * @private
     * @name clear
     * @memberOf Hash
     */
    function hashClear() {
      this.__data__ = nativeCreate ? nativeCreate(null) : {};
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the hash.
     *
     * @private
     * @name delete
     * @memberOf Hash
     * @param {Object} hash The hash to modify.
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function hashDelete(key) {
      var result = this.has(key) && delete this.__data__[key];
      this.size -= result ? 1 : 0;
      return result;
    }

    /**
     * Gets the hash value for `key`.
     *
     * @private
     * @name get
     * @memberOf Hash
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function hashGet(key) {
      var data = this.__data__;
      if (nativeCreate) {
        var result = data[key];
        return result === HASH_UNDEFINED ? undefined : result;
      }
      return hasOwnProperty.call(data, key) ? data[key] : undefined;
    }

    /**
     * Checks if a hash value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Hash
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function hashHas(key) {
      var data = this.__data__;
      return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
    }

    /**
     * Sets the hash `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Hash
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the hash instance.
     */
    function hashSet(key, value) {
      var data = this.__data__;
      this.size += this.has(key) ? 0 : 1;
      data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
      return this;
    }

    // Add methods to `Hash`.
    Hash.prototype.clear = hashClear;
    Hash.prototype['delete'] = hashDelete;
    Hash.prototype.get = hashGet;
    Hash.prototype.has = hashHas;
    Hash.prototype.set = hashSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates an list cache object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function ListCache(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the list cache.
     *
     * @private
     * @name clear
     * @memberOf ListCache
     */
    function listCacheClear() {
      this.__data__ = [];
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the list cache.
     *
     * @private
     * @name delete
     * @memberOf ListCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function listCacheDelete(key) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      if (index < 0) {
        return false;
      }
      var lastIndex = data.length - 1;
      if (index == lastIndex) {
        data.pop();
      } else {
        splice.call(data, index, 1);
      }
      --this.size;
      return true;
    }

    /**
     * Gets the list cache value for `key`.
     *
     * @private
     * @name get
     * @memberOf ListCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function listCacheGet(key) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      return index < 0 ? undefined : data[index][1];
    }

    /**
     * Checks if a list cache value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf ListCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function listCacheHas(key) {
      return assocIndexOf(this.__data__, key) > -1;
    }

    /**
     * Sets the list cache `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf ListCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the list cache instance.
     */
    function listCacheSet(key, value) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      if (index < 0) {
        ++this.size;
        data.push([key, value]);
      } else {
        data[index][1] = value;
      }
      return this;
    }

    // Add methods to `ListCache`.
    ListCache.prototype.clear = listCacheClear;
    ListCache.prototype['delete'] = listCacheDelete;
    ListCache.prototype.get = listCacheGet;
    ListCache.prototype.has = listCacheHas;
    ListCache.prototype.set = listCacheSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a map cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function MapCache(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the map.
     *
     * @private
     * @name clear
     * @memberOf MapCache
     */
    function mapCacheClear() {
      this.size = 0;
      this.__data__ = {
        'hash': new Hash,
        'map': new (Map || ListCache),
        'string': new Hash
      };
    }

    /**
     * Removes `key` and its value from the map.
     *
     * @private
     * @name delete
     * @memberOf MapCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function mapCacheDelete(key) {
      var result = getMapData(this, key)['delete'](key);
      this.size -= result ? 1 : 0;
      return result;
    }

    /**
     * Gets the map value for `key`.
     *
     * @private
     * @name get
     * @memberOf MapCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function mapCacheGet(key) {
      return getMapData(this, key).get(key);
    }

    /**
     * Checks if a map value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf MapCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function mapCacheHas(key) {
      return getMapData(this, key).has(key);
    }

    /**
     * Sets the map `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf MapCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the map cache instance.
     */
    function mapCacheSet(key, value) {
      var data = getMapData(this, key),
          size = data.size;

      data.set(key, value);
      this.size += data.size == size ? 0 : 1;
      return this;
    }

    // Add methods to `MapCache`.
    MapCache.prototype.clear = mapCacheClear;
    MapCache.prototype['delete'] = mapCacheDelete;
    MapCache.prototype.get = mapCacheGet;
    MapCache.prototype.has = mapCacheHas;
    MapCache.prototype.set = mapCacheSet;

    /*------------------------------------------------------------------------*/

    /**
     *
     * Creates an array cache object to store unique values.
     *
     * @private
     * @constructor
     * @param {Array} [values] The values to cache.
     */
    function SetCache(values) {
      var index = -1,
          length = values == null ? 0 : values.length;

      this.__data__ = new MapCache;
      while (++index < length) {
        this.add(values[index]);
      }
    }

    /**
     * Adds `value` to the array cache.
     *
     * @private
     * @name add
     * @memberOf SetCache
     * @alias push
     * @param {*} value The value to cache.
     * @returns {Object} Returns the cache instance.
     */
    function setCacheAdd(value) {
      this.__data__.set(value, HASH_UNDEFINED);
      return this;
    }

    /**
     * Checks if `value` is in the array cache.
     *
     * @private
     * @name has
     * @memberOf SetCache
     * @param {*} value The value to search for.
     * @returns {number} Returns `true` if `value` is found, else `false`.
     */
    function setCacheHas(value) {
      return this.__data__.has(value);
    }

    // Add methods to `SetCache`.
    SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
    SetCache.prototype.has = setCacheHas;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a stack cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function Stack(entries) {
      var data = this.__data__ = new ListCache(entries);
      this.size = data.size;
    }

    /**
     * Removes all key-value entries from the stack.
     *
     * @private
     * @name clear
     * @memberOf Stack
     */
    function stackClear() {
      this.__data__ = new ListCache;
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the stack.
     *
     * @private
     * @name delete
     * @memberOf Stack
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function stackDelete(key) {
      var data = this.__data__,
          result = data['delete'](key);

      this.size = data.size;
      return result;
    }

    /**
     * Gets the stack value for `key`.
     *
     * @private
     * @name get
     * @memberOf Stack
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function stackGet(key) {
      return this.__data__.get(key);
    }

    /**
     * Checks if a stack value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Stack
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function stackHas(key) {
      return this.__data__.has(key);
    }

    /**
     * Sets the stack `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Stack
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the stack cache instance.
     */
    function stackSet(key, value) {
      var data = this.__data__;
      if (data instanceof ListCache) {
        var pairs = data.__data__;
        if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
          pairs.push([key, value]);
          this.size = ++data.size;
          return this;
        }
        data = this.__data__ = new MapCache(pairs);
      }
      data.set(key, value);
      this.size = data.size;
      return this;
    }

    // Add methods to `Stack`.
    Stack.prototype.clear = stackClear;
    Stack.prototype['delete'] = stackDelete;
    Stack.prototype.get = stackGet;
    Stack.prototype.has = stackHas;
    Stack.prototype.set = stackSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates an array of the enumerable property names of the array-like `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @param {boolean} inherited Specify returning inherited property names.
     * @returns {Array} Returns the array of property names.
     */
    function arrayLikeKeys(value, inherited) {
      var isArr = isArray(value),
          isArg = !isArr && isArguments(value),
          isBuff = !isArr && !isArg && isBuffer(value),
          isType = !isArr && !isArg && !isBuff && isTypedArray(value),
          skipIndexes = isArr || isArg || isBuff || isType,
          result = skipIndexes ? baseTimes(value.length, String) : [],
          length = result.length;

      for (var key in value) {
        if ((inherited || hasOwnProperty.call(value, key)) &&
            !(skipIndexes && (
               // Safari 9 has enumerable `arguments.length` in strict mode.
               key == 'length' ||
               // Node.js 0.10 has enumerable non-index properties on buffers.
               (isBuff && (key == 'offset' || key == 'parent')) ||
               // PhantomJS 2 has enumerable non-index properties on typed arrays.
               (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
               // Skip index properties.
               isIndex(key, length)
            ))) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * A specialized version of `_.sample` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @returns {*} Returns the random element.
     */
    function arraySample(array) {
      var length = array.length;
      return length ? array[baseRandom(0, length - 1)] : undefined;
    }

    /**
     * A specialized version of `_.sampleSize` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */
    function arraySampleSize(array, n) {
      return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
    }

    /**
     * A specialized version of `_.shuffle` for arrays.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */
    function arrayShuffle(array) {
      return shuffleSelf(copyArray(array));
    }

    /**
     * This function is like `assignValue` except that it doesn't assign
     * `undefined` values.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function assignMergeValue(object, key, value) {
      if ((value !== undefined && !eq(object[key], value)) ||
          (value === undefined && !(key in object))) {
        baseAssignValue(object, key, value);
      }
    }

    /**
     * Assigns `value` to `key` of `object` if the existing value is not equivalent
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function assignValue(object, key, value) {
      var objValue = object[key];
      if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
          (value === undefined && !(key in object))) {
        baseAssignValue(object, key, value);
      }
    }

    /**
     * Gets the index at which the `key` is found in `array` of key-value pairs.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {*} key The key to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     */
    function assocIndexOf(array, key) {
      var length = array.length;
      while (length--) {
        if (eq(array[length][0], key)) {
          return length;
        }
      }
      return -1;
    }

    /**
     * Aggregates elements of `collection` on `accumulator` with keys transformed
     * by `iteratee` and values set by `setter`.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform keys.
     * @param {Object} accumulator The initial aggregated object.
     * @returns {Function} Returns `accumulator`.
     */
    function baseAggregator(collection, setter, iteratee, accumulator) {
      baseEach(collection, function(value, key, collection) {
        setter(accumulator, value, iteratee(value), collection);
      });
      return accumulator;
    }

    /**
     * The base implementation of `_.assign` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */
    function baseAssign(object, source) {
      return object && copyObject(source, keys(source), object);
    }

    /**
     * The base implementation of `_.assignIn` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */
    function baseAssignIn(object, source) {
      return object && copyObject(source, keysIn(source), object);
    }

    /**
     * The base implementation of `assignValue` and `assignMergeValue` without
     * value checks.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function baseAssignValue(object, key, value) {
      if (key == '__proto__' && defineProperty) {
        defineProperty(object, key, {
          'configurable': true,
          'enumerable': true,
          'value': value,
          'writable': true
        });
      } else {
        object[key] = value;
      }
    }

    /**
     * The base implementation of `_.at` without support for individual paths.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {string[]} paths The property paths to pick.
     * @returns {Array} Returns the picked elements.
     */
    function baseAt(object, paths) {
      var index = -1,
          length = paths.length,
          result = Array(length),
          skip = object == null;

      while (++index < length) {
        result[index] = skip ? undefined : get(object, paths[index]);
      }
      return result;
    }

    /**
     * The base implementation of `_.clamp` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     */
    function baseClamp(number, lower, upper) {
      if (number === number) {
        if (upper !== undefined) {
          number = number <= upper ? number : upper;
        }
        if (lower !== undefined) {
          number = number >= lower ? number : lower;
        }
      }
      return number;
    }

    /**
     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
     * traversed objects.
     *
     * @private
     * @param {*} value The value to clone.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Deep clone
     *  2 - Flatten inherited properties
     *  4 - Clone symbols
     * @param {Function} [customizer] The function to customize cloning.
     * @param {string} [key] The key of `value`.
     * @param {Object} [object] The parent object of `value`.
     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
     * @returns {*} Returns the cloned value.
     */
    function baseClone(value, bitmask, customizer, key, object, stack) {
      var result,
          isDeep = bitmask & CLONE_DEEP_FLAG,
          isFlat = bitmask & CLONE_FLAT_FLAG,
          isFull = bitmask & CLONE_SYMBOLS_FLAG;

      if (customizer) {
        result = object ? customizer(value, key, object, stack) : customizer(value);
      }
      if (result !== undefined) {
        return result;
      }
      if (!isObject(value)) {
        return value;
      }
      var isArr = isArray(value);
      if (isArr) {
        result = initCloneArray(value);
        if (!isDeep) {
          return copyArray(value, result);
        }
      } else {
        var tag = getTag(value),
            isFunc = tag == funcTag || tag == genTag;

        if (isBuffer(value)) {
          return cloneBuffer(value, isDeep);
        }
        if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
          result = (isFlat || isFunc) ? {} : initCloneObject(value);
          if (!isDeep) {
            return isFlat
              ? copySymbolsIn(value, baseAssignIn(result, value))
              : copySymbols(value, baseAssign(result, value));
          }
        } else {
          if (!cloneableTags[tag]) {
            return object ? value : {};
          }
          result = initCloneByTag(value, tag, isDeep);
        }
      }
      // Check for circular references and return its corresponding clone.
      stack || (stack = new Stack);
      var stacked = stack.get(value);
      if (stacked) {
        return stacked;
      }
      stack.set(value, result);

      if (isSet(value)) {
        value.forEach(function(subValue) {
          result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
        });
      } else if (isMap(value)) {
        value.forEach(function(subValue, key) {
          result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
        });
      }

      var keysFunc = isFull
        ? (isFlat ? getAllKeysIn : getAllKeys)
        : (isFlat ? keysIn : keys);

      var props = isArr ? undefined : keysFunc(value);
      arrayEach(props || value, function(subValue, key) {
        if (props) {
          key = subValue;
          subValue = value[key];
        }
        // Recursively populate clone (susceptible to call stack limits).
        assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
      });
      return result;
    }

    /**
     * The base implementation of `_.conforms` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     */
    function baseConforms(source) {
      var props = keys(source);
      return function(object) {
        return baseConformsTo(object, source, props);
      };
    }

    /**
     * The base implementation of `_.conformsTo` which accepts `props` to check.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     */
    function baseConformsTo(object, source, props) {
      var length = props.length;
      if (object == null) {
        return !length;
      }
      object = Object(object);
      while (length--) {
        var key = props[length],
            predicate = source[key],
            value = object[key];

        if ((value === undefined && !(key in object)) || !predicate(value)) {
          return false;
        }
      }
      return true;
    }

    /**
     * The base implementation of `_.delay` and `_.defer` which accepts `args`
     * to provide to `func`.
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {Array} args The arguments to provide to `func`.
     * @returns {number|Object} Returns the timer id or timeout object.
     */
    function baseDelay(func, wait, args) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      return setTimeout(function() { func.apply(undefined, args); }, wait);
    }

    /**
     * The base implementation of methods like `_.difference` without support
     * for excluding multiple arrays or iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Array} values The values to exclude.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     */
    function baseDifference(array, values, iteratee, comparator) {
      var index = -1,
          includes = arrayIncludes,
          isCommon = true,
          length = array.length,
          result = [],
          valuesLength = values.length;

      if (!length) {
        return result;
      }
      if (iteratee) {
        values = arrayMap(values, baseUnary(iteratee));
      }
      if (comparator) {
        includes = arrayIncludesWith;
        isCommon = false;
      }
      else if (values.length >= LARGE_ARRAY_SIZE) {
        includes = cacheHas;
        isCommon = false;
        values = new SetCache(values);
      }
      outer:
      while (++index < length) {
        var value = array[index],
            computed = iteratee == null ? value : iteratee(value);

        value = (comparator || value !== 0) ? value : 0;
        if (isCommon && computed === computed) {
          var valuesIndex = valuesLength;
          while (valuesIndex--) {
            if (values[valuesIndex] === computed) {
              continue outer;
            }
          }
          result.push(value);
        }
        else if (!includes(values, computed, comparator)) {
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.forEach` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */
    var baseEach = createBaseEach(baseForOwn);

    /**
     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */
    var baseEachRight = createBaseEach(baseForOwnRight, true);

    /**
     * The base implementation of `_.every` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`
     */
    function baseEvery(collection, predicate) {
      var result = true;
      baseEach(collection, function(value, index, collection) {
        result = !!predicate(value, index, collection);
        return result;
      });
      return result;
    }

    /**
     * The base implementation of methods like `_.max` and `_.min` which accepts a
     * `comparator` to determine the extremum value.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The iteratee invoked per iteration.
     * @param {Function} comparator The comparator used to compare values.
     * @returns {*} Returns the extremum value.
     */
    function baseExtremum(array, iteratee, comparator) {
      var index = -1,
          length = array.length;

      while (++index < length) {
        var value = array[index],
            current = iteratee(value);

        if (current != null && (computed === undefined
              ? (current === current && !isSymbol(current))
              : comparator(current, computed)
            )) {
          var computed = current,
              result = value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.fill` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     */
    function baseFill(array, value, start, end) {
      var length = array.length;

      start = toInteger(start);
      if (start < 0) {
        start = -start > length ? 0 : (length + start);
      }
      end = (end === undefined || end > length) ? length : toInteger(end);
      if (end < 0) {
        end += length;
      }
      end = start > end ? 0 : toLength(end);
      while (start < end) {
        array[start++] = value;
      }
      return array;
    }

    /**
     * The base implementation of `_.filter` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     */
    function baseFilter(collection, predicate) {
      var result = [];
      baseEach(collection, function(value, index, collection) {
        if (predicate(value, index, collection)) {
          result.push(value);
        }
      });
      return result;
    }

    /**
     * The base implementation of `_.flatten` with support for restricting flattening.
     *
     * @private
     * @param {Array} array The array to flatten.
     * @param {number} depth The maximum recursion depth.
     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
     * @param {Array} [result=[]] The initial result value.
     * @returns {Array} Returns the new flattened array.
     */
    function baseFlatten(array, depth, predicate, isStrict, result) {
      var index = -1,
          length = array.length;

      predicate || (predicate = isFlattenable);
      result || (result = []);

      while (++index < length) {
        var value = array[index];
        if (depth > 0 && predicate(value)) {
          if (depth > 1) {
            // Recursively flatten arrays (susceptible to call stack limits).
            baseFlatten(value, depth - 1, predicate, isStrict, result);
          } else {
            arrayPush(result, value);
          }
        } else if (!isStrict) {
          result[result.length] = value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `baseForOwn` which iterates over `object`
     * properties returned by `keysFunc` and invokes `iteratee` for each property.
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */
    var baseFor = createBaseFor();

    /**
     * This function is like `baseFor` except that it iterates over properties
     * in the opposite order.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */
    var baseForRight = createBaseFor(true);

    /**
     * The base implementation of `_.forOwn` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */
    function baseForOwn(object, iteratee) {
      return object && baseFor(object, iteratee, keys);
    }

    /**
     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */
    function baseForOwnRight(object, iteratee) {
      return object && baseForRight(object, iteratee, keys);
    }

    /**
     * The base implementation of `_.functions` which creates an array of
     * `object` function property names filtered from `props`.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Array} props The property names to filter.
     * @returns {Array} Returns the function names.
     */
    function baseFunctions(object, props) {
      return arrayFilter(props, function(key) {
        return isFunction(object[key]);
      });
    }

    /**
     * The base implementation of `_.get` without support for default values.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @returns {*} Returns the resolved value.
     */
    function baseGet(object, path) {
      path = castPath(path, object);

      var index = 0,
          length = path.length;

      while (object != null && index < length) {
        object = object[toKey(path[index++])];
      }
      return (index && index == length) ? object : undefined;
    }

    /**
     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @param {Function} symbolsFunc The function to get the symbols of `object`.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function baseGetAllKeys(object, keysFunc, symbolsFunc) {
      var result = keysFunc(object);
      return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
    }

    /**
     * The base implementation of `getTag` without fallbacks for buggy environments.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */
    function baseGetTag(value) {
      if (value == null) {
        return value === undefined ? undefinedTag : nullTag;
      }
      return (symToStringTag && symToStringTag in Object(value))
        ? getRawTag(value)
        : objectToString(value);
    }

    /**
     * The base implementation of `_.gt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     */
    function baseGt(value, other) {
      return value > other;
    }

    /**
     * The base implementation of `_.has` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */
    function baseHas(object, key) {
      return object != null && hasOwnProperty.call(object, key);
    }

    /**
     * The base implementation of `_.hasIn` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */
    function baseHasIn(object, key) {
      return object != null && key in Object(object);
    }

    /**
     * The base implementation of `_.inRange` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to check.
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     */
    function baseInRange(number, start, end) {
      return number >= nativeMin(start, end) && number < nativeMax(start, end);
    }

    /**
     * The base implementation of methods like `_.intersection`, without support
     * for iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of shared values.
     */
    function baseIntersection(arrays, iteratee, comparator) {
      var includes = comparator ? arrayIncludesWith : arrayIncludes,
          length = arrays[0].length,
          othLength = arrays.length,
          othIndex = othLength,
          caches = Array(othLength),
          maxLength = Infinity,
          result = [];

      while (othIndex--) {
        var array = arrays[othIndex];
        if (othIndex && iteratee) {
          array = arrayMap(array, baseUnary(iteratee));
        }
        maxLength = nativeMin(array.length, maxLength);
        caches[othIndex] = !comparator && (iteratee || (length >= 120 && array.length >= 120))
          ? new SetCache(othIndex && array)
          : undefined;
      }
      array = arrays[0];

      var index = -1,
          seen = caches[0];

      outer:
      while (++index < length && result.length < maxLength) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        value = (comparator || value !== 0) ? value : 0;
        if (!(seen
              ? cacheHas(seen, computed)
              : includes(result, computed, comparator)
            )) {
          othIndex = othLength;
          while (--othIndex) {
            var cache = caches[othIndex];
            if (!(cache
                  ? cacheHas(cache, computed)
                  : includes(arrays[othIndex], computed, comparator))
                ) {
              continue outer;
            }
          }
          if (seen) {
            seen.push(computed);
          }
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.invert` and `_.invertBy` which inverts
     * `object` with values transformed by `iteratee` and set by `setter`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform values.
     * @param {Object} accumulator The initial inverted object.
     * @returns {Function} Returns `accumulator`.
     */
    function baseInverter(object, setter, iteratee, accumulator) {
      baseForOwn(object, function(value, key, object) {
        setter(accumulator, iteratee(value), key, object);
      });
      return accumulator;
    }

    /**
     * The base implementation of `_.invoke` without support for individual
     * method arguments.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {Array} args The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     */
    function baseInvoke(object, path, args) {
      path = castPath(path, object);
      object = parent(object, path);
      var func = object == null ? object : object[toKey(last(path))];
      return func == null ? undefined : apply(func, object, args);
    }

    /**
     * The base implementation of `_.isArguments`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     */
    function baseIsArguments(value) {
      return isObjectLike(value) && baseGetTag(value) == argsTag;
    }

    /**
     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     */
    function baseIsArrayBuffer(value) {
      return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
    }

    /**
     * The base implementation of `_.isDate` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     */
    function baseIsDate(value) {
      return isObjectLike(value) && baseGetTag(value) == dateTag;
    }

    /**
     * The base implementation of `_.isEqual` which supports partial comparisons
     * and tracks traversed objects.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Unordered comparison
     *  2 - Partial comparison
     * @param {Function} [customizer] The function to customize comparisons.
     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     */
    function baseIsEqual(value, other, bitmask, customizer, stack) {
      if (value === other) {
        return true;
      }
      if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
        return value !== value && other !== other;
      }
      return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
    }

    /**
     * A specialized version of `baseIsEqual` for arrays and objects which performs
     * deep comparisons and tracks traversed objects enabling objects with circular
     * references to be compared.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
      var objIsArr = isArray(object),
          othIsArr = isArray(other),
          objTag = objIsArr ? arrayTag : getTag(object),
          othTag = othIsArr ? arrayTag : getTag(other);

      objTag = objTag == argsTag ? objectTag : objTag;
      othTag = othTag == argsTag ? objectTag : othTag;

      var objIsObj = objTag == objectTag,
          othIsObj = othTag == objectTag,
          isSameTag = objTag == othTag;

      if (isSameTag && isBuffer(object)) {
        if (!isBuffer(other)) {
          return false;
        }
        objIsArr = true;
        objIsObj = false;
      }
      if (isSameTag && !objIsObj) {
        stack || (stack = new Stack);
        return (objIsArr || isTypedArray(object))
          ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
          : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
      }
      if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
            othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

        if (objIsWrapped || othIsWrapped) {
          var objUnwrapped = objIsWrapped ? object.value() : object,
              othUnwrapped = othIsWrapped ? other.value() : other;

          stack || (stack = new Stack);
          return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
      }
      if (!isSameTag) {
        return false;
      }
      stack || (stack = new Stack);
      return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
    }

    /**
     * The base implementation of `_.isMap` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     */
    function baseIsMap(value) {
      return isObjectLike(value) && getTag(value) == mapTag;
    }

    /**
     * The base implementation of `_.isMatch` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Array} matchData The property names, values, and compare flags to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     */
    function baseIsMatch(object, source, matchData, customizer) {
      var index = matchData.length,
          length = index,
          noCustomizer = !customizer;

      if (object == null) {
        return !length;
      }
      object = Object(object);
      while (index--) {
        var data = matchData[index];
        if ((noCustomizer && data[2])
              ? data[1] !== object[data[0]]
              : !(data[0] in object)
            ) {
          return false;
        }
      }
      while (++index < length) {
        data = matchData[index];
        var key = data[0],
            objValue = object[key],
            srcValue = data[1];

        if (noCustomizer && data[2]) {
          if (objValue === undefined && !(key in object)) {
            return false;
          }
        } else {
          var stack = new Stack;
          if (customizer) {
            var result = customizer(objValue, srcValue, key, object, source, stack);
          }
          if (!(result === undefined
                ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
                : result
              )) {
            return false;
          }
        }
      }
      return true;
    }

    /**
     * The base implementation of `_.isNative` without bad shim checks.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     */
    function baseIsNative(value) {
      if (!isObject(value) || isMasked(value)) {
        return false;
      }
      var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
      return pattern.test(toSource(value));
    }

    /**
     * The base implementation of `_.isRegExp` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     */
    function baseIsRegExp(value) {
      return isObjectLike(value) && baseGetTag(value) == regexpTag;
    }

    /**
     * The base implementation of `_.isSet` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     */
    function baseIsSet(value) {
      return isObjectLike(value) && getTag(value) == setTag;
    }

    /**
     * The base implementation of `_.isTypedArray` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     */
    function baseIsTypedArray(value) {
      return isObjectLike(value) &&
        isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
    }

    /**
     * The base implementation of `_.iteratee`.
     *
     * @private
     * @param {*} [value=_.identity] The value to convert to an iteratee.
     * @returns {Function} Returns the iteratee.
     */
    function baseIteratee(value) {
      // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
      // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
      if (typeof value == 'function') {
        return value;
      }
      if (value == null) {
        return identity;
      }
      if (typeof value == 'object') {
        return isArray(value)
          ? baseMatchesProperty(value[0], value[1])
          : baseMatches(value);
      }
      return property(value);
    }

    /**
     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function baseKeys(object) {
      if (!isPrototype(object)) {
        return nativeKeys(object);
      }
      var result = [];
      for (var key in Object(object)) {
        if (hasOwnProperty.call(object, key) && key != 'constructor') {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function baseKeysIn(object) {
      if (!isObject(object)) {
        return nativeKeysIn(object);
      }
      var isProto = isPrototype(object),
          result = [];

      for (var key in object) {
        if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.lt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     */
    function baseLt(value, other) {
      return value < other;
    }

    /**
     * The base implementation of `_.map` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     */
    function baseMap(collection, iteratee) {
      var index = -1,
          result = isArrayLike(collection) ? Array(collection.length) : [];

      baseEach(collection, function(value, key, collection) {
        result[++index] = iteratee(value, key, collection);
      });
      return result;
    }

    /**
     * The base implementation of `_.matches` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     */
    function baseMatches(source) {
      var matchData = getMatchData(source);
      if (matchData.length == 1 && matchData[0][2]) {
        return matchesStrictComparable(matchData[0][0], matchData[0][1]);
      }
      return function(object) {
        return object === source || baseIsMatch(object, source, matchData);
      };
    }

    /**
     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
     *
     * @private
     * @param {string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */
    function baseMatchesProperty(path, srcValue) {
      if (isKey(path) && isStrictComparable(srcValue)) {
        return matchesStrictComparable(toKey(path), srcValue);
      }
      return function(object) {
        var objValue = get(object, path);
        return (objValue === undefined && objValue === srcValue)
          ? hasIn(object, path)
          : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
      };
    }

    /**
     * The base implementation of `_.merge` without support for multiple sources.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} [customizer] The function to customize merged values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */
    function baseMerge(object, source, srcIndex, customizer, stack) {
      if (object === source) {
        return;
      }
      baseFor(source, function(srcValue, key) {
        stack || (stack = new Stack);
        if (isObject(srcValue)) {
          baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
        }
        else {
          var newValue = customizer
            ? customizer(safeGet(object, key), srcValue, (key + ''), object, source, stack)
            : undefined;

          if (newValue === undefined) {
            newValue = srcValue;
          }
          assignMergeValue(object, key, newValue);
        }
      }, keysIn);
    }

    /**
     * A specialized version of `baseMerge` for arrays and objects which performs
     * deep merges and tracks traversed objects enabling objects with circular
     * references to be merged.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {string} key The key of the value to merge.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} mergeFunc The function to merge values.
     * @param {Function} [customizer] The function to customize assigned values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */
    function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
      var objValue = safeGet(object, key),
          srcValue = safeGet(source, key),
          stacked = stack.get(srcValue);

      if (stacked) {
        assignMergeValue(object, key, stacked);
        return;
      }
      var newValue = customizer
        ? customizer(objValue, srcValue, (key + ''), object, source, stack)
        : undefined;

      var isCommon = newValue === undefined;

      if (isCommon) {
        var isArr = isArray(srcValue),
            isBuff = !isArr && isBuffer(srcValue),
            isTyped = !isArr && !isBuff && isTypedArray(srcValue);

        newValue = srcValue;
        if (isArr || isBuff || isTyped) {
          if (isArray(objValue)) {
            newValue = objValue;
          }
          else if (isArrayLikeObject(objValue)) {
            newValue = copyArray(objValue);
          }
          else if (isBuff) {
            isCommon = false;
            newValue = cloneBuffer(srcValue, true);
          }
          else if (isTyped) {
            isCommon = false;
            newValue = cloneTypedArray(srcValue, true);
          }
          else {
            newValue = [];
          }
        }
        else if (isPlainObject(srcValue) || isArguments(srcValue)) {
          newValue = objValue;
          if (isArguments(objValue)) {
            newValue = toPlainObject(objValue);
          }
          else if (!isObject(objValue) || isFunction(objValue)) {
            newValue = initCloneObject(srcValue);
          }
        }
        else {
          isCommon = false;
        }
      }
      if (isCommon) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, newValue);
        mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
        stack['delete'](srcValue);
      }
      assignMergeValue(object, key, newValue);
    }

    /**
     * The base implementation of `_.nth` which doesn't coerce arguments.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {number} n The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     */
    function baseNth(array, n) {
      var length = array.length;
      if (!length) {
        return;
      }
      n += n < 0 ? length : 0;
      return isIndex(n, length) ? array[n] : undefined;
    }

    /**
     * The base implementation of `_.orderBy` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
     * @param {string[]} orders The sort orders of `iteratees`.
     * @returns {Array} Returns the new sorted array.
     */
    function baseOrderBy(collection, iteratees, orders) {
      var index = -1;
      iteratees = arrayMap(iteratees.length ? iteratees : [identity], baseUnary(getIteratee()));

      var result = baseMap(collection, function(value, key, collection) {
        var criteria = arrayMap(iteratees, function(iteratee) {
          return iteratee(value);
        });
        return { 'criteria': criteria, 'index': ++index, 'value': value };
      });

      return baseSortBy(result, function(object, other) {
        return compareMultiple(object, other, orders);
      });
    }

    /**
     * The base implementation of `_.pick` without support for individual
     * property identifiers.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @returns {Object} Returns the new object.
     */
    function basePick(object, paths) {
      return basePickBy(object, paths, function(value, path) {
        return hasIn(object, path);
      });
    }

    /**
     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @param {Function} predicate The function invoked per property.
     * @returns {Object} Returns the new object.
     */
    function basePickBy(object, paths, predicate) {
      var index = -1,
          length = paths.length,
          result = {};

      while (++index < length) {
        var path = paths[index],
            value = baseGet(object, path);

        if (predicate(value, path)) {
          baseSet(result, castPath(path, object), value);
        }
      }
      return result;
    }

    /**
     * A specialized version of `baseProperty` which supports deep paths.
     *
     * @private
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     */
    function basePropertyDeep(path) {
      return function(object) {
        return baseGet(object, path);
      };
    }

    /**
     * The base implementation of `_.pullAllBy` without support for iteratee
     * shorthands.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     */
    function basePullAll(array, values, iteratee, comparator) {
      var indexOf = comparator ? baseIndexOfWith : baseIndexOf,
          index = -1,
          length = values.length,
          seen = array;

      if (array === values) {
        values = copyArray(values);
      }
      if (iteratee) {
        seen = arrayMap(array, baseUnary(iteratee));
      }
      while (++index < length) {
        var fromIndex = 0,
            value = values[index],
            computed = iteratee ? iteratee(value) : value;

        while ((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1) {
          if (seen !== array) {
            splice.call(seen, fromIndex, 1);
          }
          splice.call(array, fromIndex, 1);
        }
      }
      return array;
    }

    /**
     * The base implementation of `_.pullAt` without support for individual
     * indexes or capturing the removed elements.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {number[]} indexes The indexes of elements to remove.
     * @returns {Array} Returns `array`.
     */
    function basePullAt(array, indexes) {
      var length = array ? indexes.length : 0,
          lastIndex = length - 1;

      while (length--) {
        var index = indexes[length];
        if (length == lastIndex || index !== previous) {
          var previous = index;
          if (isIndex(index)) {
            splice.call(array, index, 1);
          } else {
            baseUnset(array, index);
          }
        }
      }
      return array;
    }

    /**
     * The base implementation of `_.random` without support for returning
     * floating-point numbers.
     *
     * @private
     * @param {number} lower The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the random number.
     */
    function baseRandom(lower, upper) {
      return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
    }

    /**
     * The base implementation of `_.range` and `_.rangeRight` which doesn't
     * coerce arguments.
     *
     * @private
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @param {number} step The value to increment or decrement by.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the range of numbers.
     */
    function baseRange(start, end, step, fromRight) {
      var index = -1,
          length = nativeMax(nativeCeil((end - start) / (step || 1)), 0),
          result = Array(length);

      while (length--) {
        result[fromRight ? length : ++index] = start;
        start += step;
      }
      return result;
    }

    /**
     * The base implementation of `_.repeat` which doesn't coerce arguments.
     *
     * @private
     * @param {string} string The string to repeat.
     * @param {number} n The number of times to repeat the string.
     * @returns {string} Returns the repeated string.
     */
    function baseRepeat(string, n) {
      var result = '';
      if (!string || n < 1 || n > MAX_SAFE_INTEGER) {
        return result;
      }
      // Leverage the exponentiation by squaring algorithm for a faster repeat.
      // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
      do {
        if (n % 2) {
          result += string;
        }
        n = nativeFloor(n / 2);
        if (n) {
          string += string;
        }
      } while (n);

      return result;
    }

    /**
     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     */
    function baseRest(func, start) {
      return setToString(overRest(func, start, identity), func + '');
    }

    /**
     * The base implementation of `_.sample`.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     */
    function baseSample(collection) {
      return arraySample(values(collection));
    }

    /**
     * The base implementation of `_.sampleSize` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */
    function baseSampleSize(collection, n) {
      var array = values(collection);
      return shuffleSelf(array, baseClamp(n, 0, array.length));
    }

    /**
     * The base implementation of `_.set`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */
    function baseSet(object, path, value, customizer) {
      if (!isObject(object)) {
        return object;
      }
      path = castPath(path, object);

      var index = -1,
          length = path.length,
          lastIndex = length - 1,
          nested = object;

      while (nested != null && ++index < length) {
        var key = toKey(path[index]),
            newValue = value;

        if (index != lastIndex) {
          var objValue = nested[key];
          newValue = customizer ? customizer(objValue, key, nested) : undefined;
          if (newValue === undefined) {
            newValue = isObject(objValue)
              ? objValue
              : (isIndex(path[index + 1]) ? [] : {});
          }
        }
        assignValue(nested, key, newValue);
        nested = nested[key];
      }
      return object;
    }

    /**
     * The base implementation of `setData` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */
    var baseSetData = !metaMap ? identity : function(func, data) {
      metaMap.set(func, data);
      return func;
    };

    /**
     * The base implementation of `setToString` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */
    var baseSetToString = !defineProperty ? identity : function(func, string) {
      return defineProperty(func, 'toString', {
        'configurable': true,
        'enumerable': false,
        'value': constant(string),
        'writable': true
      });
    };

    /**
     * The base implementation of `_.shuffle`.
     *
     * @private
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */
    function baseShuffle(collection) {
      return shuffleSelf(values(collection));
    }

    /**
     * The base implementation of `_.slice` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */
    function baseSlice(array, start, end) {
      var index = -1,
          length = array.length;

      if (start < 0) {
        start = -start > length ? 0 : (length + start);
      }
      end = end > length ? length : end;
      if (end < 0) {
        end += length;
      }
      length = start > end ? 0 : ((end - start) >>> 0);
      start >>>= 0;

      var result = Array(length);
      while (++index < length) {
        result[index] = array[index + start];
      }
      return result;
    }

    /**
     * The base implementation of `_.some` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     */
    function baseSome(collection, predicate) {
      var result;

      baseEach(collection, function(value, index, collection) {
        result = predicate(value, index, collection);
        return !result;
      });
      return !!result;
    }

    /**
     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
     * performs a binary search of `array` to determine the index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */
    function baseSortedIndex(array, value, retHighest) {
      var low = 0,
          high = array == null ? low : array.length;

      if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
        while (low < high) {
          var mid = (low + high) >>> 1,
              computed = array[mid];

          if (computed !== null && !isSymbol(computed) &&
              (retHighest ? (computed <= value) : (computed < value))) {
            low = mid + 1;
          } else {
            high = mid;
          }
        }
        return high;
      }
      return baseSortedIndexBy(array, value, identity, retHighest);
    }

    /**
     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
     * which invokes `iteratee` for `value` and each element of `array` to compute
     * their sort ranking. The iteratee is invoked with one argument; (value).
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} iteratee The iteratee invoked per element.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */
    function baseSortedIndexBy(array, value, iteratee, retHighest) {
      value = iteratee(value);

      var low = 0,
          high = array == null ? 0 : array.length,
          valIsNaN = value !== value,
          valIsNull = value === null,
          valIsSymbol = isSymbol(value),
          valIsUndefined = value === undefined;

      while (low < high) {
        var mid = nativeFloor((low + high) / 2),
            computed = iteratee(array[mid]),
            othIsDefined = computed !== undefined,
            othIsNull = computed === null,
            othIsReflexive = computed === computed,
            othIsSymbol = isSymbol(computed);

        if (valIsNaN) {
          var setLow = retHighest || othIsReflexive;
        } else if (valIsUndefined) {
          setLow = othIsReflexive && (retHighest || othIsDefined);
        } else if (valIsNull) {
          setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
        } else if (valIsSymbol) {
          setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
        } else if (othIsNull || othIsSymbol) {
          setLow = false;
        } else {
          setLow = retHighest ? (computed <= value) : (computed < value);
        }
        if (setLow) {
          low = mid + 1;
        } else {
          high = mid;
        }
      }
      return nativeMin(high, MAX_ARRAY_INDEX);
    }

    /**
     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
     * support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */
    function baseSortedUniq(array, iteratee) {
      var index = -1,
          length = array.length,
          resIndex = 0,
          result = [];

      while (++index < length) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        if (!index || !eq(computed, seen)) {
          var seen = computed;
          result[resIndex++] = value === 0 ? 0 : value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.toNumber` which doesn't ensure correct
     * conversions of binary, hexadecimal, or octal string values.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     */
    function baseToNumber(value) {
      if (typeof value == 'number') {
        return value;
      }
      if (isSymbol(value)) {
        return NAN;
      }
      return +value;
    }

    /**
     * The base implementation of `_.toString` which doesn't convert nullish
     * values to empty strings.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {string} Returns the string.
     */
    function baseToString(value) {
      // Exit early for strings to avoid a performance hit in some environments.
      if (typeof value == 'string') {
        return value;
      }
      if (isArray(value)) {
        // Recursively convert values (susceptible to call stack limits).
        return arrayMap(value, baseToString) + '';
      }
      if (isSymbol(value)) {
        return symbolToString ? symbolToString.call(value) : '';
      }
      var result = (value + '');
      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
    }

    /**
     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */
    function baseUniq(array, iteratee, comparator) {
      var index = -1,
          includes = arrayIncludes,
          length = array.length,
          isCommon = true,
          result = [],
          seen = result;

      if (comparator) {
        isCommon = false;
        includes = arrayIncludesWith;
      }
      else if (length >= LARGE_ARRAY_SIZE) {
        var set = iteratee ? null : createSet(array);
        if (set) {
          return setToArray(set);
        }
        isCommon = false;
        includes = cacheHas;
        seen = new SetCache;
      }
      else {
        seen = iteratee ? [] : result;
      }
      outer:
      while (++index < length) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        value = (comparator || value !== 0) ? value : 0;
        if (isCommon && computed === computed) {
          var seenIndex = seen.length;
          while (seenIndex--) {
            if (seen[seenIndex] === computed) {
              continue outer;
            }
          }
          if (iteratee) {
            seen.push(computed);
          }
          result.push(value);
        }
        else if (!includes(seen, computed, comparator)) {
          if (seen !== result) {
            seen.push(computed);
          }
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.unset`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The property path to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     */
    function baseUnset(object, path) {
      path = castPath(path, object);
      object = parent(object, path);
      return object == null || delete object[toKey(last(path))];
    }

    /**
     * The base implementation of `_.update`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to update.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */
    function baseUpdate(object, path, updater, customizer) {
      return baseSet(object, path, updater(baseGet(object, path)), customizer);
    }

    /**
     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
     * without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {Function} predicate The function invoked per iteration.
     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the slice of `array`.
     */
    function baseWhile(array, predicate, isDrop, fromRight) {
      var length = array.length,
          index = fromRight ? length : -1;

      while ((fromRight ? index-- : ++index < length) &&
        predicate(array[index], index, array)) {}

      return isDrop
        ? baseSlice(array, (fromRight ? 0 : index), (fromRight ? index + 1 : length))
        : baseSlice(array, (fromRight ? index + 1 : 0), (fromRight ? length : index));
    }

    /**
     * The base implementation of `wrapperValue` which returns the result of
     * performing a sequence of actions on the unwrapped `value`, where each
     * successive action is supplied the return value of the previous.
     *
     * @private
     * @param {*} value The unwrapped value.
     * @param {Array} actions Actions to perform to resolve the unwrapped value.
     * @returns {*} Returns the resolved value.
     */
    function baseWrapperValue(value, actions) {
      var result = value;
      if (result instanceof LazyWrapper) {
        result = result.value();
      }
      return arrayReduce(actions, function(result, action) {
        return action.func.apply(action.thisArg, arrayPush([result], action.args));
      }, result);
    }

    /**
     * The base implementation of methods like `_.xor`, without support for
     * iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of values.
     */
    function baseXor(arrays, iteratee, comparator) {
      var length = arrays.length;
      if (length < 2) {
        return length ? baseUniq(arrays[0]) : [];
      }
      var index = -1,
          result = Array(length);

      while (++index < length) {
        var array = arrays[index],
            othIndex = -1;

        while (++othIndex < length) {
          if (othIndex != index) {
            result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
          }
        }
      }
      return baseUniq(baseFlatten(result, 1), iteratee, comparator);
    }

    /**
     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
     *
     * @private
     * @param {Array} props The property identifiers.
     * @param {Array} values The property values.
     * @param {Function} assignFunc The function to assign values.
     * @returns {Object} Returns the new object.
     */
    function baseZipObject(props, values, assignFunc) {
      var index = -1,
          length = props.length,
          valsLength = values.length,
          result = {};

      while (++index < length) {
        var value = index < valsLength ? values[index] : undefined;
        assignFunc(result, props[index], value);
      }
      return result;
    }

    /**
     * Casts `value` to an empty array if it's not an array like object.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Array|Object} Returns the cast array-like object.
     */
    function castArrayLikeObject(value) {
      return isArrayLikeObject(value) ? value : [];
    }

    /**
     * Casts `value` to `identity` if it's not a function.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Function} Returns cast function.
     */
    function castFunction(value) {
      return typeof value == 'function' ? value : identity;
    }

    /**
     * Casts `value` to a path array if it's not one.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {Object} [object] The object to query keys on.
     * @returns {Array} Returns the cast property path array.
     */
    function castPath(value, object) {
      if (isArray(value)) {
        return value;
      }
      return isKey(value, object) ? [value] : stringToPath(toString(value));
    }

    /**
     * A `baseRest` alias which can be replaced with `identity` by module
     * replacement plugins.
     *
     * @private
     * @type {Function}
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */
    var castRest = baseRest;

    /**
     * Casts `array` to a slice if it's needed.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {number} start The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the cast slice.
     */
    function castSlice(array, start, end) {
      var length = array.length;
      end = end === undefined ? length : end;
      return (!start && end >= length) ? array : baseSlice(array, start, end);
    }

    /**
     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
     *
     * @private
     * @param {number|Object} id The timer id or timeout object of the timer to clear.
     */
    var clearTimeout = ctxClearTimeout || function(id) {
      return root.clearTimeout(id);
    };

    /**
     * Creates a clone of  `buffer`.
     *
     * @private
     * @param {Buffer} buffer The buffer to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Buffer} Returns the cloned buffer.
     */
    function cloneBuffer(buffer, isDeep) {
      if (isDeep) {
        return buffer.slice();
      }
      var length = buffer.length,
          result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

      buffer.copy(result);
      return result;
    }

    /**
     * Creates a clone of `arrayBuffer`.
     *
     * @private
     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
     * @returns {ArrayBuffer} Returns the cloned array buffer.
     */
    function cloneArrayBuffer(arrayBuffer) {
      var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
      new Uint8Array(result).set(new Uint8Array(arrayBuffer));
      return result;
    }

    /**
     * Creates a clone of `dataView`.
     *
     * @private
     * @param {Object} dataView The data view to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned data view.
     */
    function cloneDataView(dataView, isDeep) {
      var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
      return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
    }

    /**
     * Creates a clone of `regexp`.
     *
     * @private
     * @param {Object} regexp The regexp to clone.
     * @returns {Object} Returns the cloned regexp.
     */
    function cloneRegExp(regexp) {
      var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
      result.lastIndex = regexp.lastIndex;
      return result;
    }

    /**
     * Creates a clone of the `symbol` object.
     *
     * @private
     * @param {Object} symbol The symbol object to clone.
     * @returns {Object} Returns the cloned symbol object.
     */
    function cloneSymbol(symbol) {
      return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
    }

    /**
     * Creates a clone of `typedArray`.
     *
     * @private
     * @param {Object} typedArray The typed array to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned typed array.
     */
    function cloneTypedArray(typedArray, isDeep) {
      var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
      return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
    }

    /**
     * Compares values to sort them in ascending order.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {number} Returns the sort order indicator for `value`.
     */
    function compareAscending(value, other) {
      if (value !== other) {
        var valIsDefined = value !== undefined,
            valIsNull = value === null,
            valIsReflexive = value === value,
            valIsSymbol = isSymbol(value);

        var othIsDefined = other !== undefined,
            othIsNull = other === null,
            othIsReflexive = other === other,
            othIsSymbol = isSymbol(other);

        if ((!othIsNull && !othIsSymbol && !valIsSymbol && value > other) ||
            (valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol) ||
            (valIsNull && othIsDefined && othIsReflexive) ||
            (!valIsDefined && othIsReflexive) ||
            !valIsReflexive) {
          return 1;
        }
        if ((!valIsNull && !valIsSymbol && !othIsSymbol && value < other) ||
            (othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol) ||
            (othIsNull && valIsDefined && valIsReflexive) ||
            (!othIsDefined && valIsReflexive) ||
            !othIsReflexive) {
          return -1;
        }
      }
      return 0;
    }

    /**
     * Used by `_.orderBy` to compare multiple properties of a value to another
     * and stable sort them.
     *
     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
     * specify an order of "desc" for descending or "asc" for ascending sort order
     * of corresponding values.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {boolean[]|string[]} orders The order to sort by for each property.
     * @returns {number} Returns the sort order indicator for `object`.
     */
    function compareMultiple(object, other, orders) {
      var index = -1,
          objCriteria = object.criteria,
          othCriteria = other.criteria,
          length = objCriteria.length,
          ordersLength = orders.length;

      while (++index < length) {
        var result = compareAscending(objCriteria[index], othCriteria[index]);
        if (result) {
          if (index >= ordersLength) {
            return result;
          }
          var order = orders[index];
          return result * (order == 'desc' ? -1 : 1);
        }
      }
      // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
      // that causes it, under certain circumstances, to provide the same value for
      // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
      // for more details.
      //
      // This also ensures a stable sort in V8 and other engines.
      // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
      return object.index - other.index;
    }

    /**
     * Creates an array that is the composition of partially applied arguments,
     * placeholders, and provided arguments into a single array of arguments.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to prepend to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */
    function composeArgs(args, partials, holders, isCurried) {
      var argsIndex = -1,
          argsLength = args.length,
          holdersLength = holders.length,
          leftIndex = -1,
          leftLength = partials.length,
          rangeLength = nativeMax(argsLength - holdersLength, 0),
          result = Array(leftLength + rangeLength),
          isUncurried = !isCurried;

      while (++leftIndex < leftLength) {
        result[leftIndex] = partials[leftIndex];
      }
      while (++argsIndex < holdersLength) {
        if (isUncurried || argsIndex < argsLength) {
          result[holders[argsIndex]] = args[argsIndex];
        }
      }
      while (rangeLength--) {
        result[leftIndex++] = args[argsIndex++];
      }
      return result;
    }

    /**
     * This function is like `composeArgs` except that the arguments composition
     * is tailored for `_.partialRight`.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to append to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */
    function composeArgsRight(args, partials, holders, isCurried) {
      var argsIndex = -1,
          argsLength = args.length,
          holdersIndex = -1,
          holdersLength = holders.length,
          rightIndex = -1,
          rightLength = partials.length,
          rangeLength = nativeMax(argsLength - holdersLength, 0),
          result = Array(rangeLength + rightLength),
          isUncurried = !isCurried;

      while (++argsIndex < rangeLength) {
        result[argsIndex] = args[argsIndex];
      }
      var offset = argsIndex;
      while (++rightIndex < rightLength) {
        result[offset + rightIndex] = partials[rightIndex];
      }
      while (++holdersIndex < holdersLength) {
        if (isUncurried || argsIndex < argsLength) {
          result[offset + holders[holdersIndex]] = args[argsIndex++];
        }
      }
      return result;
    }

    /**
     * Copies the values of `source` to `array`.
     *
     * @private
     * @param {Array} source The array to copy values from.
     * @param {Array} [array=[]] The array to copy values to.
     * @returns {Array} Returns `array`.
     */
    function copyArray(source, array) {
      var index = -1,
          length = source.length;

      array || (array = Array(length));
      while (++index < length) {
        array[index] = source[index];
      }
      return array;
    }

    /**
     * Copies properties of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy properties from.
     * @param {Array} props The property identifiers to copy.
     * @param {Object} [object={}] The object to copy properties to.
     * @param {Function} [customizer] The function to customize copied values.
     * @returns {Object} Returns `object`.
     */
    function copyObject(source, props, object, customizer) {
      var isNew = !object;
      object || (object = {});

      var index = -1,
          length = props.length;

      while (++index < length) {
        var key = props[index];

        var newValue = customizer
          ? customizer(object[key], source[key], key, object, source)
          : undefined;

        if (newValue === undefined) {
          newValue = source[key];
        }
        if (isNew) {
          baseAssignValue(object, key, newValue);
        } else {
          assignValue(object, key, newValue);
        }
      }
      return object;
    }

    /**
     * Copies own symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */
    function copySymbols(source, object) {
      return copyObject(source, getSymbols(source), object);
    }

    /**
     * Copies own and inherited symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */
    function copySymbolsIn(source, object) {
      return copyObject(source, getSymbolsIn(source), object);
    }

    /**
     * Creates a function like `_.groupBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} [initializer] The accumulator object initializer.
     * @returns {Function} Returns the new aggregator function.
     */
    function createAggregator(setter, initializer) {
      return function(collection, iteratee) {
        var func = isArray(collection) ? arrayAggregator : baseAggregator,
            accumulator = initializer ? initializer() : {};

        return func(collection, setter, getIteratee(iteratee, 2), accumulator);
      };
    }

    /**
     * Creates a function like `_.assign`.
     *
     * @private
     * @param {Function} assigner The function to assign values.
     * @returns {Function} Returns the new assigner function.
     */
    function createAssigner(assigner) {
      return baseRest(function(object, sources) {
        var index = -1,
            length = sources.length,
            customizer = length > 1 ? sources[length - 1] : undefined,
            guard = length > 2 ? sources[2] : undefined;

        customizer = (assigner.length > 3 && typeof customizer == 'function')
          ? (length--, customizer)
          : undefined;

        if (guard && isIterateeCall(sources[0], sources[1], guard)) {
          customizer = length < 3 ? undefined : customizer;
          length = 1;
        }
        object = Object(object);
        while (++index < length) {
          var source = sources[index];
          if (source) {
            assigner(object, source, index, customizer);
          }
        }
        return object;
      });
    }

    /**
     * Creates a `baseEach` or `baseEachRight` function.
     *
     * @private
     * @param {Function} eachFunc The function to iterate over a collection.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */
    function createBaseEach(eachFunc, fromRight) {
      return function(collection, iteratee) {
        if (collection == null) {
          return collection;
        }
        if (!isArrayLike(collection)) {
          return eachFunc(collection, iteratee);
        }
        var length = collection.length,
            index = fromRight ? length : -1,
            iterable = Object(collection);

        while ((fromRight ? index-- : ++index < length)) {
          if (iteratee(iterable[index], index, iterable) === false) {
            break;
          }
        }
        return collection;
      };
    }

    /**
     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */
    function createBaseFor(fromRight) {
      return function(object, iteratee, keysFunc) {
        var index = -1,
            iterable = Object(object),
            props = keysFunc(object),
            length = props.length;

        while (length--) {
          var key = props[fromRight ? length : ++index];
          if (iteratee(iterable[key], key, iterable) === false) {
            break;
          }
        }
        return object;
      };
    }

    /**
     * Creates a function that wraps `func` to invoke it with the optional `this`
     * binding of `thisArg`.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createBind(func, bitmask, thisArg) {
      var isBind = bitmask & WRAP_BIND_FLAG,
          Ctor = createCtor(func);

      function wrapper() {
        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
        return fn.apply(isBind ? thisArg : this, arguments);
      }
      return wrapper;
    }

    /**
     * Creates a function like `_.lowerFirst`.
     *
     * @private
     * @param {string} methodName The name of the `String` case method to use.
     * @returns {Function} Returns the new case function.
     */
    function createCaseFirst(methodName) {
      return function(string) {
        string = toString(string);

        var strSymbols = hasUnicode(string)
          ? stringToArray(string)
          : undefined;

        var chr = strSymbols
          ? strSymbols[0]
          : string.charAt(0);

        var trailing = strSymbols
          ? castSlice(strSymbols, 1).join('')
          : string.slice(1);

        return chr[methodName]() + trailing;
      };
    }

    /**
     * Creates a function like `_.camelCase`.
     *
     * @private
     * @param {Function} callback The function to combine each word.
     * @returns {Function} Returns the new compounder function.
     */
    function createCompounder(callback) {
      return function(string) {
        return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
      };
    }

    /**
     * Creates a function that produces an instance of `Ctor` regardless of
     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
     *
     * @private
     * @param {Function} Ctor The constructor to wrap.
     * @returns {Function} Returns the new wrapped function.
     */
    function createCtor(Ctor) {
      return function() {
        // Use a `switch` statement to work with class constructors. See
        // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
        // for more details.
        var args = arguments;
        switch (args.length) {
          case 0: return new Ctor;
          case 1: return new Ctor(args[0]);
          case 2: return new Ctor(args[0], args[1]);
          case 3: return new Ctor(args[0], args[1], args[2]);
          case 4: return new Ctor(args[0], args[1], args[2], args[3]);
          case 5: return new Ctor(args[0], args[1], args[2], args[3], args[4]);
          case 6: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
          case 7: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
        }
        var thisBinding = baseCreate(Ctor.prototype),
            result = Ctor.apply(thisBinding, args);

        // Mimic the constructor's `return` behavior.
        // See https://es5.github.io/#x13.2.2 for more details.
        return isObject(result) ? result : thisBinding;
      };
    }

    /**
     * Creates a function that wraps `func` to enable currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {number} arity The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createCurry(func, bitmask, arity) {
      var Ctor = createCtor(func);

      function wrapper() {
        var length = arguments.length,
            args = Array(length),
            index = length,
            placeholder = getHolder(wrapper);

        while (index--) {
          args[index] = arguments[index];
        }
        var holders = (length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder)
          ? []
          : replaceHolders(args, placeholder);

        length -= holders.length;
        if (length < arity) {
          return createRecurry(
            func, bitmask, createHybrid, wrapper.placeholder, undefined,
            args, holders, undefined, undefined, arity - length);
        }
        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
        return apply(fn, this, args);
      }
      return wrapper;
    }

    /**
     * Creates a `_.find` or `_.findLast` function.
     *
     * @private
     * @param {Function} findIndexFunc The function to find the collection index.
     * @returns {Function} Returns the new find function.
     */
    function createFind(findIndexFunc) {
      return function(collection, predicate, fromIndex) {
        var iterable = Object(collection);
        if (!isArrayLike(collection)) {
          var iteratee = getIteratee(predicate, 3);
          collection = keys(collection);
          predicate = function(key) { return iteratee(iterable[key], key, iterable); };
        }
        var index = findIndexFunc(collection, predicate, fromIndex);
        return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
      };
    }

    /**
     * Creates a `_.flow` or `_.flowRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new flow function.
     */
    function createFlow(fromRight) {
      return flatRest(function(funcs) {
        var length = funcs.length,
            index = length,
            prereq = LodashWrapper.prototype.thru;

        if (fromRight) {
          funcs.reverse();
        }
        while (index--) {
          var func = funcs[index];
          if (typeof func != 'function') {
            throw new TypeError(FUNC_ERROR_TEXT);
          }
          if (prereq && !wrapper && getFuncName(func) == 'wrapper') {
            var wrapper = new LodashWrapper([], true);
          }
        }
        index = wrapper ? index : length;
        while (++index < length) {
          func = funcs[index];

          var funcName = getFuncName(func),
              data = funcName == 'wrapper' ? getData(func) : undefined;

          if (data && isLaziable(data[0]) &&
                data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) &&
                !data[4].length && data[9] == 1
              ) {
            wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
          } else {
            wrapper = (func.length == 1 && isLaziable(func))
              ? wrapper[funcName]()
              : wrapper.thru(func);
          }
        }
        return function() {
          var args = arguments,
              value = args[0];

          if (wrapper && args.length == 1 && isArray(value)) {
            return wrapper.plant(value).value();
          }
          var index = 0,
              result = length ? funcs[index].apply(this, args) : value;

          while (++index < length) {
            result = funcs[index].call(this, result);
          }
          return result;
        };
      });
    }

    /**
     * Creates a function that wraps `func` to invoke it with optional `this`
     * binding of `thisArg`, partial application, and currying.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [partialsRight] The arguments to append to those provided
     *  to the new function.
     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
      var isAry = bitmask & WRAP_ARY_FLAG,
          isBind = bitmask & WRAP_BIND_FLAG,
          isBindKey = bitmask & WRAP_BIND_KEY_FLAG,
          isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG),
          isFlip = bitmask & WRAP_FLIP_FLAG,
          Ctor = isBindKey ? undefined : createCtor(func);

      function wrapper() {
        var length = arguments.length,
            args = Array(length),
            index = length;

        while (index--) {
          args[index] = arguments[index];
        }
        if (isCurried) {
          var placeholder = getHolder(wrapper),
              holdersCount = countHolders(args, placeholder);
        }
        if (partials) {
          args = composeArgs(args, partials, holders, isCurried);
        }
        if (partialsRight) {
          args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
        }
        length -= holdersCount;
        if (isCurried && length < arity) {
          var newHolders = replaceHolders(args, placeholder);
          return createRecurry(
            func, bitmask, createHybrid, wrapper.placeholder, thisArg,
            args, newHolders, argPos, ary, arity - length
          );
        }
        var thisBinding = isBind ? thisArg : this,
            fn = isBindKey ? thisBinding[func] : func;

        length = args.length;
        if (argPos) {
          args = reorder(args, argPos);
        } else if (isFlip && length > 1) {
          args.reverse();
        }
        if (isAry && ary < length) {
          args.length = ary;
        }
        if (this && this !== root && this instanceof wrapper) {
          fn = Ctor || createCtor(fn);
        }
        return fn.apply(thisBinding, args);
      }
      return wrapper;
    }

    /**
     * Creates a function like `_.invertBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} toIteratee The function to resolve iteratees.
     * @returns {Function} Returns the new inverter function.
     */
    function createInverter(setter, toIteratee) {
      return function(object, iteratee) {
        return baseInverter(object, setter, toIteratee(iteratee), {});
      };
    }

    /**
     * Creates a function that performs a mathematical operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @param {number} [defaultValue] The value used for `undefined` arguments.
     * @returns {Function} Returns the new mathematical operation function.
     */
    function createMathOperation(operator, defaultValue) {
      return function(value, other) {
        var result;
        if (value === undefined && other === undefined) {
          return defaultValue;
        }
        if (value !== undefined) {
          result = value;
        }
        if (other !== undefined) {
          if (result === undefined) {
            return other;
          }
          if (typeof value == 'string' || typeof other == 'string') {
            value = baseToString(value);
            other = baseToString(other);
          } else {
            value = baseToNumber(value);
            other = baseToNumber(other);
          }
          result = operator(value, other);
        }
        return result;
      };
    }

    /**
     * Creates a function like `_.over`.
     *
     * @private
     * @param {Function} arrayFunc The function to iterate over iteratees.
     * @returns {Function} Returns the new over function.
     */
    function createOver(arrayFunc) {
      return flatRest(function(iteratees) {
        iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
        return baseRest(function(args) {
          var thisArg = this;
          return arrayFunc(iteratees, function(iteratee) {
            return apply(iteratee, thisArg, args);
          });
        });
      });
    }

    /**
     * Creates the padding for `string` based on `length`. The `chars` string
     * is truncated if the number of characters exceeds `length`.
     *
     * @private
     * @param {number} length The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padding for `string`.
     */
    function createPadding(length, chars) {
      chars = chars === undefined ? ' ' : baseToString(chars);

      var charsLength = chars.length;
      if (charsLength < 2) {
        return charsLength ? baseRepeat(chars, length) : chars;
      }
      var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
      return hasUnicode(chars)
        ? castSlice(stringToArray(result), 0, length).join('')
        : result.slice(0, length);
    }

    /**
     * Creates a function that wraps `func` to invoke it with the `this` binding
     * of `thisArg` and `partials` prepended to the arguments it receives.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {Array} partials The arguments to prepend to those provided to
     *  the new function.
     * @returns {Function} Returns the new wrapped function.
     */
    function createPartial(func, bitmask, thisArg, partials) {
      var isBind = bitmask & WRAP_BIND_FLAG,
          Ctor = createCtor(func);

      function wrapper() {
        var argsIndex = -1,
            argsLength = arguments.length,
            leftIndex = -1,
            leftLength = partials.length,
            args = Array(leftLength + argsLength),
            fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;

        while (++leftIndex < leftLength) {
          args[leftIndex] = partials[leftIndex];
        }
        while (argsLength--) {
          args[leftIndex++] = arguments[++argsIndex];
        }
        return apply(fn, isBind ? thisArg : this, args);
      }
      return wrapper;
    }

    /**
     * Creates a `_.range` or `_.rangeRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new range function.
     */
    function createRange(fromRight) {
      return function(start, end, step) {
        if (step && typeof step != 'number' && isIterateeCall(start, end, step)) {
          end = step = undefined;
        }
        // Ensure the sign of `-0` is preserved.
        start = toFinite(start);
        if (end === undefined) {
          end = start;
          start = 0;
        } else {
          end = toFinite(end);
        }
        step = step === undefined ? (start < end ? 1 : -1) : toFinite(step);
        return baseRange(start, end, step, fromRight);
      };
    }

    /**
     * Creates a function that performs a relational operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @returns {Function} Returns the new relational operation function.
     */
    function createRelationalOperation(operator) {
      return function(value, other) {
        if (!(typeof value == 'string' && typeof other == 'string')) {
          value = toNumber(value);
          other = toNumber(other);
        }
        return operator(value, other);
      };
    }

    /**
     * Creates a function that wraps `func` to continue currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {Function} wrapFunc The function to create the `func` wrapper.
     * @param {*} placeholder The placeholder value.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
      var isCurry = bitmask & WRAP_CURRY_FLAG,
          newHolders = isCurry ? holders : undefined,
          newHoldersRight = isCurry ? undefined : holders,
          newPartials = isCurry ? partials : undefined,
          newPartialsRight = isCurry ? undefined : partials;

      bitmask |= (isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG);
      bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);

      if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) {
        bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
      }
      var newData = [
        func, bitmask, thisArg, newPartials, newHolders, newPartialsRight,
        newHoldersRight, argPos, ary, arity
      ];

      var result = wrapFunc.apply(undefined, newData);
      if (isLaziable(func)) {
        setData(result, newData);
      }
      result.placeholder = placeholder;
      return setWrapToString(result, func, bitmask);
    }

    /**
     * Creates a function like `_.round`.
     *
     * @private
     * @param {string} methodName The name of the `Math` method to use when rounding.
     * @returns {Function} Returns the new round function.
     */
    function createRound(methodName) {
      var func = Math[methodName];
      return function(number, precision) {
        number = toNumber(number);
        precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
        if (precision && nativeIsFinite(number)) {
          // Shift with exponential notation to avoid floating-point issues.
          // See [MDN](https://mdn.io/round#Examples) for more details.
          var pair = (toString(number) + 'e').split('e'),
              value = func(pair[0] + 'e' + (+pair[1] + precision));

          pair = (toString(value) + 'e').split('e');
          return +(pair[0] + 'e' + (+pair[1] - precision));
        }
        return func(number);
      };
    }

    /**
     * Creates a set object of `values`.
     *
     * @private
     * @param {Array} values The values to add to the set.
     * @returns {Object} Returns the new set.
     */
    var createSet = !(Set && (1 / setToArray(new Set([,-0]))[1]) == INFINITY) ? noop : function(values) {
      return new Set(values);
    };

    /**
     * Creates a `_.toPairs` or `_.toPairsIn` function.
     *
     * @private
     * @param {Function} keysFunc The function to get the keys of a given object.
     * @returns {Function} Returns the new pairs function.
     */
    function createToPairs(keysFunc) {
      return function(object) {
        var tag = getTag(object);
        if (tag == mapTag) {
          return mapToArray(object);
        }
        if (tag == setTag) {
          return setToPairs(object);
        }
        return baseToPairs(object, keysFunc(object));
      };
    }

    /**
     * Creates a function that either curries or invokes `func` with optional
     * `this` binding and partially applied arguments.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags.
     *    1 - `_.bind`
     *    2 - `_.bindKey`
     *    4 - `_.curry` or `_.curryRight` of a bound function
     *    8 - `_.curry`
     *   16 - `_.curryRight`
     *   32 - `_.partial`
     *   64 - `_.partialRight`
     *  128 - `_.rearg`
     *  256 - `_.ary`
     *  512 - `_.flip`
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to be partially applied.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
      var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
      if (!isBindKey && typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var length = partials ? partials.length : 0;
      if (!length) {
        bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
        partials = holders = undefined;
      }
      ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
      arity = arity === undefined ? arity : toInteger(arity);
      length -= holders ? holders.length : 0;

      if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
        var partialsRight = partials,
            holdersRight = holders;

        partials = holders = undefined;
      }
      var data = isBindKey ? undefined : getData(func);

      var newData = [
        func, bitmask, thisArg, partials, holders, partialsRight, holdersRight,
        argPos, ary, arity
      ];

      if (data) {
        mergeData(newData, data);
      }
      func = newData[0];
      bitmask = newData[1];
      thisArg = newData[2];
      partials = newData[3];
      holders = newData[4];
      arity = newData[9] = newData[9] === undefined
        ? (isBindKey ? 0 : func.length)
        : nativeMax(newData[9] - length, 0);

      if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) {
        bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
      }
      if (!bitmask || bitmask == WRAP_BIND_FLAG) {
        var result = createBind(func, bitmask, thisArg);
      } else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) {
        result = createCurry(func, bitmask, arity);
      } else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) {
        result = createPartial(func, bitmask, thisArg, partials);
      } else {
        result = createHybrid.apply(undefined, newData);
      }
      var setter = data ? baseSetData : setData;
      return setWrapToString(setter(result, newData), func, bitmask);
    }

    /**
     * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
     * of source objects to the destination object for all destination properties
     * that resolve to `undefined`.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to assign.
     * @param {Object} object The parent object of `objValue`.
     * @returns {*} Returns the value to assign.
     */
    function customDefaultsAssignIn(objValue, srcValue, key, object) {
      if (objValue === undefined ||
          (eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key))) {
        return srcValue;
      }
      return objValue;
    }

    /**
     * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
     * objects into destination objects that are passed thru.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to merge.
     * @param {Object} object The parent object of `objValue`.
     * @param {Object} source The parent object of `srcValue`.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     * @returns {*} Returns the value to assign.
     */
    function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
      if (isObject(objValue) && isObject(srcValue)) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, objValue);
        baseMerge(objValue, srcValue, undefined, customDefaultsMerge, stack);
        stack['delete'](srcValue);
      }
      return objValue;
    }

    /**
     * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
     * objects.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {string} key The key of the property to inspect.
     * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
     */
    function customOmitClone(value) {
      return isPlainObject(value) ? undefined : value;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for arrays with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Array} array The array to compare.
     * @param {Array} other The other array to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `array` and `other` objects.
     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
     */
    function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
          arrLength = array.length,
          othLength = other.length;

      if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
        return false;
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(array);
      if (stacked && stack.get(other)) {
        return stacked == other;
      }
      var index = -1,
          result = true,
          seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;

      stack.set(array, other);
      stack.set(other, array);

      // Ignore non-index properties.
      while (++index < arrLength) {
        var arrValue = array[index],
            othValue = other[index];

        if (customizer) {
          var compared = isPartial
            ? customizer(othValue, arrValue, index, other, array, stack)
            : customizer(arrValue, othValue, index, array, other, stack);
        }
        if (compared !== undefined) {
          if (compared) {
            continue;
          }
          result = false;
          break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
          if (!arraySome(other, function(othValue, othIndex) {
                if (!cacheHas(seen, othIndex) &&
                    (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
                  return seen.push(othIndex);
                }
              })) {
            result = false;
            break;
          }
        } else if (!(
              arrValue === othValue ||
                equalFunc(arrValue, othValue, bitmask, customizer, stack)
            )) {
          result = false;
          break;
        }
      }
      stack['delete'](array);
      stack['delete'](other);
      return result;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for comparing objects of
     * the same `toStringTag`.
     *
     * **Note:** This function only supports comparing values with tags of
     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {string} tag The `toStringTag` of the objects to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
      switch (tag) {
        case dataViewTag:
          if ((object.byteLength != other.byteLength) ||
              (object.byteOffset != other.byteOffset)) {
            return false;
          }
          object = object.buffer;
          other = other.buffer;

        case arrayBufferTag:
          if ((object.byteLength != other.byteLength) ||
              !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
            return false;
          }
          return true;

        case boolTag:
        case dateTag:
        case numberTag:
          // Coerce booleans to `1` or `0` and dates to milliseconds.
          // Invalid dates are coerced to `NaN`.
          return eq(+object, +other);

        case errorTag:
          return object.name == other.name && object.message == other.message;

        case regexpTag:
        case stringTag:
          // Coerce regexes to strings and treat strings, primitives and objects,
          // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
          // for more details.
          return object == (other + '');

        case mapTag:
          var convert = mapToArray;

        case setTag:
          var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
          convert || (convert = setToArray);

          if (object.size != other.size && !isPartial) {
            return false;
          }
          // Assume cyclic values are equal.
          var stacked = stack.get(object);
          if (stacked) {
            return stacked == other;
          }
          bitmask |= COMPARE_UNORDERED_FLAG;

          // Recursively compare objects (susceptible to call stack limits).
          stack.set(object, other);
          var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
          stack['delete'](object);
          return result;

        case symbolTag:
          if (symbolValueOf) {
            return symbolValueOf.call(object) == symbolValueOf.call(other);
          }
      }
      return false;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for objects with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
          objProps = getAllKeys(object),
          objLength = objProps.length,
          othProps = getAllKeys(other),
          othLength = othProps.length;

      if (objLength != othLength && !isPartial) {
        return false;
      }
      var index = objLength;
      while (index--) {
        var key = objProps[index];
        if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
          return false;
        }
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(object);
      if (stacked && stack.get(other)) {
        return stacked == other;
      }
      var result = true;
      stack.set(object, other);
      stack.set(other, object);

      var skipCtor = isPartial;
      while (++index < objLength) {
        key = objProps[index];
        var objValue = object[key],
            othValue = other[key];

        if (customizer) {
          var compared = isPartial
            ? customizer(othValue, objValue, key, other, object, stack)
            : customizer(objValue, othValue, key, object, other, stack);
        }
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined
              ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
              : compared
            )) {
          result = false;
          break;
        }
        skipCtor || (skipCtor = key == 'constructor');
      }
      if (result && !skipCtor) {
        var objCtor = object.constructor,
            othCtor = other.constructor;

        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor &&
            ('constructor' in object && 'constructor' in other) &&
            !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
              typeof othCtor == 'function' && othCtor instanceof othCtor)) {
          result = false;
        }
      }
      stack['delete'](object);
      stack['delete'](other);
      return result;
    }

    /**
     * A specialized version of `baseRest` which flattens the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */
    function flatRest(func) {
      return setToString(overRest(func, undefined, flatten), func + '');
    }

    /**
     * Creates an array of own enumerable property names and symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function getAllKeys(object) {
      return baseGetAllKeys(object, keys, getSymbols);
    }

    /**
     * Creates an array of own and inherited enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function getAllKeysIn(object) {
      return baseGetAllKeys(object, keysIn, getSymbolsIn);
    }

    /**
     * Gets metadata for `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {*} Returns the metadata for `func`.
     */
    var getData = !metaMap ? noop : function(func) {
      return metaMap.get(func);
    };

    /**
     * Gets the name of `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {string} Returns the function name.
     */
    function getFuncName(func) {
      var result = (func.name + ''),
          array = realNames[result],
          length = hasOwnProperty.call(realNames, result) ? array.length : 0;

      while (length--) {
        var data = array[length],
            otherFunc = data.func;
        if (otherFunc == null || otherFunc == func) {
          return data.name;
        }
      }
      return result;
    }

    /**
     * Gets the argument placeholder value for `func`.
     *
     * @private
     * @param {Function} func The function to inspect.
     * @returns {*} Returns the placeholder value.
     */
    function getHolder(func) {
      var object = hasOwnProperty.call(lodash, 'placeholder') ? lodash : func;
      return object.placeholder;
    }

    /**
     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
     * this function returns the custom method, otherwise it returns `baseIteratee`.
     * If arguments are provided, the chosen function is invoked with them and
     * its result is returned.
     *
     * @private
     * @param {*} [value] The value to convert to an iteratee.
     * @param {number} [arity] The arity of the created iteratee.
     * @returns {Function} Returns the chosen function or its result.
     */
    function getIteratee() {
      var result = lodash.iteratee || iteratee;
      result = result === iteratee ? baseIteratee : result;
      return arguments.length ? result(arguments[0], arguments[1]) : result;
    }

    /**
     * Gets the data for `map`.
     *
     * @private
     * @param {Object} map The map to query.
     * @param {string} key The reference key.
     * @returns {*} Returns the map data.
     */
    function getMapData(map, key) {
      var data = map.__data__;
      return isKeyable(key)
        ? data[typeof key == 'string' ? 'string' : 'hash']
        : data.map;
    }

    /**
     * Gets the property names, values, and compare flags of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the match data of `object`.
     */
    function getMatchData(object) {
      var result = keys(object),
          length = result.length;

      while (length--) {
        var key = result[length],
            value = object[key];

        result[length] = [key, value, isStrictComparable(value)];
      }
      return result;
    }

    /**
     * Gets the native function at `key` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the method to get.
     * @returns {*} Returns the function if it's native, else `undefined`.
     */
    function getNative(object, key) {
      var value = getValue(object, key);
      return baseIsNative(value) ? value : undefined;
    }

    /**
     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the raw `toStringTag`.
     */
    function getRawTag(value) {
      var isOwn = hasOwnProperty.call(value, symToStringTag),
          tag = value[symToStringTag];

      try {
        value[symToStringTag] = undefined;
        var unmasked = true;
      } catch (e) {}

      var result = nativeObjectToString.call(value);
      if (unmasked) {
        if (isOwn) {
          value[symToStringTag] = tag;
        } else {
          delete value[symToStringTag];
        }
      }
      return result;
    }

    /**
     * Creates an array of the own enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */
    var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
      if (object == null) {
        return [];
      }
      object = Object(object);
      return arrayFilter(nativeGetSymbols(object), function(symbol) {
        return propertyIsEnumerable.call(object, symbol);
      });
    };

    /**
     * Creates an array of the own and inherited enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */
    var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
      var result = [];
      while (object) {
        arrayPush(result, getSymbols(object));
        object = getPrototype(object);
      }
      return result;
    };

    /**
     * Gets the `toStringTag` of `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */
    var getTag = baseGetTag;

    // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
    if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
        (Map && getTag(new Map) != mapTag) ||
        (Promise && getTag(Promise.resolve()) != promiseTag) ||
        (Set && getTag(new Set) != setTag) ||
        (WeakMap && getTag(new WeakMap) != weakMapTag)) {
      getTag = function(value) {
        var result = baseGetTag(value),
            Ctor = result == objectTag ? value.constructor : undefined,
            ctorString = Ctor ? toSource(Ctor) : '';

        if (ctorString) {
          switch (ctorString) {
            case dataViewCtorString: return dataViewTag;
            case mapCtorString: return mapTag;
            case promiseCtorString: return promiseTag;
            case setCtorString: return setTag;
            case weakMapCtorString: return weakMapTag;
          }
        }
        return result;
      };
    }

    /**
     * Gets the view, applying any `transforms` to the `start` and `end` positions.
     *
     * @private
     * @param {number} start The start of the view.
     * @param {number} end The end of the view.
     * @param {Array} transforms The transformations to apply to the view.
     * @returns {Object} Returns an object containing the `start` and `end`
     *  positions of the view.
     */
    function getView(start, end, transforms) {
      var index = -1,
          length = transforms.length;

      while (++index < length) {
        var data = transforms[index],
            size = data.size;

        switch (data.type) {
          case 'drop':      start += size; break;
          case 'dropRight': end -= size; break;
          case 'take':      end = nativeMin(end, start + size); break;
          case 'takeRight': start = nativeMax(start, end - size); break;
        }
      }
      return { 'start': start, 'end': end };
    }

    /**
     * Extracts wrapper details from the `source` body comment.
     *
     * @private
     * @param {string} source The source to inspect.
     * @returns {Array} Returns the wrapper details.
     */
    function getWrapDetails(source) {
      var match = source.match(reWrapDetails);
      return match ? match[1].split(reSplitDetails) : [];
    }

    /**
     * Checks if `path` exists on `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @param {Function} hasFunc The function to check properties.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     */
    function hasPath(object, path, hasFunc) {
      path = castPath(path, object);

      var index = -1,
          length = path.length,
          result = false;

      while (++index < length) {
        var key = toKey(path[index]);
        if (!(result = object != null && hasFunc(object, key))) {
          break;
        }
        object = object[key];
      }
      if (result || ++index != length) {
        return result;
      }
      length = object == null ? 0 : object.length;
      return !!length && isLength(length) && isIndex(key, length) &&
        (isArray(object) || isArguments(object));
    }

    /**
     * Initializes an array clone.
     *
     * @private
     * @param {Array} array The array to clone.
     * @returns {Array} Returns the initialized clone.
     */
    function initCloneArray(array) {
      var length = array.length,
          result = new array.constructor(length);

      // Add properties assigned by `RegExp#exec`.
      if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
        result.index = array.index;
        result.input = array.input;
      }
      return result;
    }

    /**
     * Initializes an object clone.
     *
     * @private
     * @param {Object} object The object to clone.
     * @returns {Object} Returns the initialized clone.
     */
    function initCloneObject(object) {
      return (typeof object.constructor == 'function' && !isPrototype(object))
        ? baseCreate(getPrototype(object))
        : {};
    }

    /**
     * Initializes an object clone based on its `toStringTag`.
     *
     * **Note:** This function only supports cloning values with tags of
     * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
     *
     * @private
     * @param {Object} object The object to clone.
     * @param {string} tag The `toStringTag` of the object to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the initialized clone.
     */
    function initCloneByTag(object, tag, isDeep) {
      var Ctor = object.constructor;
      switch (tag) {
        case arrayBufferTag:
          return cloneArrayBuffer(object);

        case boolTag:
        case dateTag:
          return new Ctor(+object);

        case dataViewTag:
          return cloneDataView(object, isDeep);

        case float32Tag: case float64Tag:
        case int8Tag: case int16Tag: case int32Tag:
        case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
          return cloneTypedArray(object, isDeep);

        case mapTag:
          return new Ctor;

        case numberTag:
        case stringTag:
          return new Ctor(object);

        case regexpTag:
          return cloneRegExp(object);

        case setTag:
          return new Ctor;

        case symbolTag:
          return cloneSymbol(object);
      }
    }

    /**
     * Inserts wrapper `details` in a comment at the top of the `source` body.
     *
     * @private
     * @param {string} source The source to modify.
     * @returns {Array} details The details to insert.
     * @returns {string} Returns the modified source.
     */
    function insertWrapDetails(source, details) {
      var length = details.length;
      if (!length) {
        return source;
      }
      var lastIndex = length - 1;
      details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
      details = details.join(length > 2 ? ', ' : ' ');
      return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
    }

    /**
     * Checks if `value` is a flattenable `arguments` object or array.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
     */
    function isFlattenable(value) {
      return isArray(value) || isArguments(value) ||
        !!(spreadableSymbol && value && value[spreadableSymbol]);
    }

    /**
     * Checks if `value` is a valid array-like index.
     *
     * @private
     * @param {*} value The value to check.
     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
     */
    function isIndex(value, length) {
      var type = typeof value;
      length = length == null ? MAX_SAFE_INTEGER : length;

      return !!length &&
        (type == 'number' ||
          (type != 'symbol' && reIsUint.test(value))) &&
            (value > -1 && value % 1 == 0 && value < length);
    }

    /**
     * Checks if the given arguments are from an iteratee call.
     *
     * @private
     * @param {*} value The potential iteratee value argument.
     * @param {*} index The potential iteratee index or key argument.
     * @param {*} object The potential iteratee object argument.
     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
     *  else `false`.
     */
    function isIterateeCall(value, index, object) {
      if (!isObject(object)) {
        return false;
      }
      var type = typeof index;
      if (type == 'number'
            ? (isArrayLike(object) && isIndex(index, object.length))
            : (type == 'string' && index in object)
          ) {
        return eq(object[index], value);
      }
      return false;
    }

    /**
     * Checks if `value` is a property name and not a property path.
     *
     * @private
     * @param {*} value The value to check.
     * @param {Object} [object] The object to query keys on.
     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
     */
    function isKey(value, object) {
      if (isArray(value)) {
        return false;
      }
      var type = typeof value;
      if (type == 'number' || type == 'symbol' || type == 'boolean' ||
          value == null || isSymbol(value)) {
        return true;
      }
      return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
        (object != null && value in Object(object));
    }

    /**
     * Checks if `value` is suitable for use as unique object key.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
     */
    function isKeyable(value) {
      var type = typeof value;
      return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
        ? (value !== '__proto__')
        : (value === null);
    }

    /**
     * Checks if `func` has a lazy counterpart.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
     *  else `false`.
     */
    function isLaziable(func) {
      var funcName = getFuncName(func),
          other = lodash[funcName];

      if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) {
        return false;
      }
      if (func === other) {
        return true;
      }
      var data = getData(other);
      return !!data && func === data[0];
    }

    /**
     * Checks if `func` has its source masked.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
     */
    function isMasked(func) {
      return !!maskSrcKey && (maskSrcKey in func);
    }

    /**
     * Checks if `func` is capable of being masked.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
     */
    var isMaskable = coreJsData ? isFunction : stubFalse;

    /**
     * Checks if `value` is likely a prototype object.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
     */
    function isPrototype(value) {
      var Ctor = value && value.constructor,
          proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

      return value === proto;
    }

    /**
     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` if suitable for strict
     *  equality comparisons, else `false`.
     */
    function isStrictComparable(value) {
      return value === value && !isObject(value);
    }

    /**
     * A specialized version of `matchesProperty` for source values suitable
     * for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {string} key The key of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */
    function matchesStrictComparable(key, srcValue) {
      return function(object) {
        if (object == null) {
          return false;
        }
        return object[key] === srcValue &&
          (srcValue !== undefined || (key in Object(object)));
      };
    }

    /**
     * A specialized version of `_.memoize` which clears the memoized function's
     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
     *
     * @private
     * @param {Function} func The function to have its output memoized.
     * @returns {Function} Returns the new memoized function.
     */
    function memoizeCapped(func) {
      var result = memoize(func, function(key) {
        if (cache.size === MAX_MEMOIZE_SIZE) {
          cache.clear();
        }
        return key;
      });

      var cache = result.cache;
      return result;
    }

    /**
     * Merges the function metadata of `source` into `data`.
     *
     * Merging metadata reduces the number of wrappers used to invoke a function.
     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
     * may be applied regardless of execution order. Methods like `_.ary` and
     * `_.rearg` modify function arguments, making the order in which they are
     * executed important, preventing the merging of metadata. However, we make
     * an exception for a safe combined case where curried functions have `_.ary`
     * and or `_.rearg` applied.
     *
     * @private
     * @param {Array} data The destination metadata.
     * @param {Array} source The source metadata.
     * @returns {Array} Returns `data`.
     */
    function mergeData(data, source) {
      var bitmask = data[1],
          srcBitmask = source[1],
          newBitmask = bitmask | srcBitmask,
          isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);

      var isCombo =
        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_CURRY_FLAG)) ||
        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_REARG_FLAG) && (data[7].length <= source[8])) ||
        ((srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG)) && (source[7].length <= source[8]) && (bitmask == WRAP_CURRY_FLAG));

      // Exit early if metadata can't be merged.
      if (!(isCommon || isCombo)) {
        return data;
      }
      // Use source `thisArg` if available.
      if (srcBitmask & WRAP_BIND_FLAG) {
        data[2] = source[2];
        // Set when currying a bound function.
        newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
      }
      // Compose partial arguments.
      var value = source[3];
      if (value) {
        var partials = data[3];
        data[3] = partials ? composeArgs(partials, value, source[4]) : value;
        data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
      }
      // Compose partial right arguments.
      value = source[5];
      if (value) {
        partials = data[5];
        data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
        data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
      }
      // Use source `argPos` if available.
      value = source[7];
      if (value) {
        data[7] = value;
      }
      // Use source `ary` if it's smaller.
      if (srcBitmask & WRAP_ARY_FLAG) {
        data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
      }
      // Use source `arity` if one is not provided.
      if (data[9] == null) {
        data[9] = source[9];
      }
      // Use source `func` and merge bitmasks.
      data[0] = source[0];
      data[1] = newBitmask;

      return data;
    }

    /**
     * This function is like
     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * except that it includes inherited enumerable properties.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function nativeKeysIn(object) {
      var result = [];
      if (object != null) {
        for (var key in Object(object)) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * Converts `value` to a string using `Object.prototype.toString`.
     *
     * @private
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     */
    function objectToString(value) {
      return nativeObjectToString.call(value);
    }

    /**
     * A specialized version of `baseRest` which transforms the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @param {Function} transform The rest array transform.
     * @returns {Function} Returns the new function.
     */
    function overRest(func, start, transform) {
      start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
      return function() {
        var args = arguments,
            index = -1,
            length = nativeMax(args.length - start, 0),
            array = Array(length);

        while (++index < length) {
          array[index] = args[start + index];
        }
        index = -1;
        var otherArgs = Array(start + 1);
        while (++index < start) {
          otherArgs[index] = args[index];
        }
        otherArgs[start] = transform(array);
        return apply(func, this, otherArgs);
      };
    }

    /**
     * Gets the parent value at `path` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array} path The path to get the parent value of.
     * @returns {*} Returns the parent value.
     */
    function parent(object, path) {
      return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
    }

    /**
     * Reorder `array` according to the specified indexes where the element at
     * the first index is assigned as the first element, the element at
     * the second index is assigned as the second element, and so on.
     *
     * @private
     * @param {Array} array The array to reorder.
     * @param {Array} indexes The arranged array indexes.
     * @returns {Array} Returns `array`.
     */
    function reorder(array, indexes) {
      var arrLength = array.length,
          length = nativeMin(indexes.length, arrLength),
          oldArray = copyArray(array);

      while (length--) {
        var index = indexes[length];
        array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
      }
      return array;
    }

    /**
     * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the property to get.
     * @returns {*} Returns the property value.
     */
    function safeGet(object, key) {
      if (key === 'constructor' && typeof object[key] === 'function') {
        return;
      }

      if (key == '__proto__') {
        return;
      }

      return object[key];
    }

    /**
     * Sets metadata for `func`.
     *
     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
     * period of time, it will trip its breaker and transition to an identity
     * function to avoid garbage collection pauses in V8. See
     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
     * for more details.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */
    var setData = shortOut(baseSetData);

    /**
     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @returns {number|Object} Returns the timer id or timeout object.
     */
    var setTimeout = ctxSetTimeout || function(func, wait) {
      return root.setTimeout(func, wait);
    };

    /**
     * Sets the `toString` method of `func` to return `string`.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */
    var setToString = shortOut(baseSetToString);

    /**
     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
     * with wrapper details in a comment at the top of the source body.
     *
     * @private
     * @param {Function} wrapper The function to modify.
     * @param {Function} reference The reference function.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Function} Returns `wrapper`.
     */
    function setWrapToString(wrapper, reference, bitmask) {
      var source = (reference + '');
      return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
    }

    /**
     * Creates a function that'll short out and invoke `identity` instead
     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
     * milliseconds.
     *
     * @private
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new shortable function.
     */
    function shortOut(func) {
      var count = 0,
          lastCalled = 0;

      return function() {
        var stamp = nativeNow(),
            remaining = HOT_SPAN - (stamp - lastCalled);

        lastCalled = stamp;
        if (remaining > 0) {
          if (++count >= HOT_COUNT) {
            return arguments[0];
          }
        } else {
          count = 0;
        }
        return func.apply(undefined, arguments);
      };
    }

    /**
     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @param {number} [size=array.length] The size of `array`.
     * @returns {Array} Returns `array`.
     */
    function shuffleSelf(array, size) {
      var index = -1,
          length = array.length,
          lastIndex = length - 1;

      size = size === undefined ? length : size;
      while (++index < size) {
        var rand = baseRandom(index, lastIndex),
            value = array[rand];

        array[rand] = array[index];
        array[index] = value;
      }
      array.length = size;
      return array;
    }

    /**
     * Converts `string` to a property path array.
     *
     * @private
     * @param {string} string The string to convert.
     * @returns {Array} Returns the property path array.
     */
    var stringToPath = memoizeCapped(function(string) {
      var result = [];
      if (string.charCodeAt(0) === 46 /* . */) {
        result.push('');
      }
      string.replace(rePropName, function(match, number, quote, subString) {
        result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
      });
      return result;
    });

    /**
     * Converts `value` to a string key if it's not a string or symbol.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {string|symbol} Returns the key.
     */
    function toKey(value) {
      if (typeof value == 'string' || isSymbol(value)) {
        return value;
      }
      var result = (value + '');
      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
    }

    /**
     * Converts `func` to its source code.
     *
     * @private
     * @param {Function} func The function to convert.
     * @returns {string} Returns the source code.
     */
    function toSource(func) {
      if (func != null) {
        try {
          return funcToString.call(func);
        } catch (e) {}
        try {
          return (func + '');
        } catch (e) {}
      }
      return '';
    }

    /**
     * Updates wrapper `details` based on `bitmask` flags.
     *
     * @private
     * @returns {Array} details The details to modify.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Array} Returns `details`.
     */
    function updateWrapDetails(details, bitmask) {
      arrayEach(wrapFlags, function(pair) {
        var value = '_.' + pair[0];
        if ((bitmask & pair[1]) && !arrayIncludes(details, value)) {
          details.push(value);
        }
      });
      return details.sort();
    }

    /**
     * Creates a clone of `wrapper`.
     *
     * @private
     * @param {Object} wrapper The wrapper to clone.
     * @returns {Object} Returns the cloned wrapper.
     */
    function wrapperClone(wrapper) {
      if (wrapper instanceof LazyWrapper) {
        return wrapper.clone();
      }
      var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
      result.__actions__ = copyArray(wrapper.__actions__);
      result.__index__  = wrapper.__index__;
      result.__values__ = wrapper.__values__;
      return result;
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates an array of elements split into groups the length of `size`.
     * If `array` can't be split evenly, the final chunk will be the remaining
     * elements.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to process.
     * @param {number} [size=1] The length of each chunk
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the new array of chunks.
     * @example
     *
     * _.chunk(['a', 'b', 'c', 'd'], 2);
     * // => [['a', 'b'], ['c', 'd']]
     *
     * _.chunk(['a', 'b', 'c', 'd'], 3);
     * // => [['a', 'b', 'c'], ['d']]
     */
    function chunk(array, size, guard) {
      if ((guard ? isIterateeCall(array, size, guard) : size === undefined)) {
        size = 1;
      } else {
        size = nativeMax(toInteger(size), 0);
      }
      var length = array == null ? 0 : array.length;
      if (!length || size < 1) {
        return [];
      }
      var index = 0,
          resIndex = 0,
          result = Array(nativeCeil(length / size));

      while (index < length) {
        result[resIndex++] = baseSlice(array, index, (index += size));
      }
      return result;
    }

    /**
     * Creates an array with all falsey values removed. The values `false`, `null`,
     * `0`, `""`, `undefined`, and `NaN` are falsey.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to compact.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.compact([0, 1, false, 2, '', 3]);
     * // => [1, 2, 3]
     */
    function compact(array) {
      var index = -1,
          length = array == null ? 0 : array.length,
          resIndex = 0,
          result = [];

      while (++index < length) {
        var value = array[index];
        if (value) {
          result[resIndex++] = value;
        }
      }
      return result;
    }

    /**
     * Creates a new array concatenating `array` with any additional arrays
     * and/or values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to concatenate.
     * @param {...*} [values] The values to concatenate.
     * @returns {Array} Returns the new concatenated array.
     * @example
     *
     * var array = [1];
     * var other = _.concat(array, 2, [3], [[4]]);
     *
     * console.log(other);
     * // => [1, 2, 3, [4]]
     *
     * console.log(array);
     * // => [1]
     */
    function concat() {
      var length = arguments.length;
      if (!length) {
        return [];
      }
      var args = Array(length - 1),
          array = arguments[0],
          index = length;

      while (index--) {
        args[index - 1] = arguments[index];
      }
      return arrayPush(isArray(array) ? copyArray(array) : [array], baseFlatten(args, 1));
    }

    /**
     * Creates an array of `array` values not included in the other given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * **Note:** Unlike `_.pullAll`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.without, _.xor
     * @example
     *
     * _.difference([2, 1], [2, 3]);
     * // => [1]
     */
    var difference = baseRest(function(array, values) {
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true))
        : [];
    });

    /**
     * This method is like `_.difference` except that it accepts `iteratee` which
     * is invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */
    var differenceBy = baseRest(function(array, values) {
      var iteratee = last(values);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee, 2))
        : [];
    });

    /**
     * This method is like `_.difference` except that it accepts `comparator`
     * which is invoked to compare elements of `array` to `values`. The order and
     * references of result values are determined by the first array. The comparator
     * is invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     *
     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }]
     */
    var differenceWith = baseRest(function(array, values) {
      var comparator = last(values);
      if (isArrayLikeObject(comparator)) {
        comparator = undefined;
      }
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined, comparator)
        : [];
    });

    /**
     * Creates a slice of `array` with `n` elements dropped from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.drop([1, 2, 3]);
     * // => [2, 3]
     *
     * _.drop([1, 2, 3], 2);
     * // => [3]
     *
     * _.drop([1, 2, 3], 5);
     * // => []
     *
     * _.drop([1, 2, 3], 0);
     * // => [1, 2, 3]
     */
    function drop(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      return baseSlice(array, n < 0 ? 0 : n, length);
    }

    /**
     * Creates a slice of `array` with `n` elements dropped from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.dropRight([1, 2, 3]);
     * // => [1, 2]
     *
     * _.dropRight([1, 2, 3], 2);
     * // => [1]
     *
     * _.dropRight([1, 2, 3], 5);
     * // => []
     *
     * _.dropRight([1, 2, 3], 0);
     * // => [1, 2, 3]
     */
    function dropRight(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      n = length - n;
      return baseSlice(array, 0, n < 0 ? 0 : n);
    }

    /**
     * Creates a slice of `array` excluding elements dropped from the end.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.dropRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropRightWhile(users, ['active', false]);
     * // => objects for ['barney']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropRightWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */
    function dropRightWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), true, true)
        : [];
    }

    /**
     * Creates a slice of `array` excluding elements dropped from the beginning.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.dropWhile(users, function(o) { return !o.active; });
     * // => objects for ['pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropWhile(users, ['active', false]);
     * // => objects for ['pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */
    function dropWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), true)
        : [];
    }

    /**
     * Fills elements of `array` with `value` from `start` up to, but not
     * including, `end`.
     *
     * **Note:** This method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Array
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.fill(array, 'a');
     * console.log(array);
     * // => ['a', 'a', 'a']
     *
     * _.fill(Array(3), 2);
     * // => [2, 2, 2]
     *
     * _.fill([4, 6, 8, 10], '*', 1, 3);
     * // => [4, '*', '*', 10]
     */
    function fill(array, value, start, end) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
        start = 0;
        end = length;
      }
      return baseFill(array, value, start, end);
    }

    /**
     * This method is like `_.find` except that it returns the index of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.findIndex(users, function(o) { return o.user == 'barney'; });
     * // => 0
     *
     * // The `_.matches` iteratee shorthand.
     * _.findIndex(users, { 'user': 'fred', 'active': false });
     * // => 1
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findIndex(users, ['active', false]);
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.findIndex(users, 'active');
     * // => 2
     */
    function findIndex(array, predicate, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = fromIndex == null ? 0 : toInteger(fromIndex);
      if (index < 0) {
        index = nativeMax(length + index, 0);
      }
      return baseFindIndex(array, getIteratee(predicate, 3), index);
    }

    /**
     * This method is like `_.findIndex` except that it iterates over elements
     * of `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
     * // => 2
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
     * // => 0
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastIndex(users, ['active', false]);
     * // => 2
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastIndex(users, 'active');
     * // => 0
     */
    function findLastIndex(array, predicate, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = length - 1;
      if (fromIndex !== undefined) {
        index = toInteger(fromIndex);
        index = fromIndex < 0
          ? nativeMax(length + index, 0)
          : nativeMin(index, length - 1);
      }
      return baseFindIndex(array, getIteratee(predicate, 3), index, true);
    }

    /**
     * Flattens `array` a single level deep.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flatten([1, [2, [3, [4]], 5]]);
     * // => [1, 2, [3, [4]], 5]
     */
    function flatten(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseFlatten(array, 1) : [];
    }

    /**
     * Recursively flattens `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flattenDeep([1, [2, [3, [4]], 5]]);
     * // => [1, 2, 3, 4, 5]
     */
    function flattenDeep(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseFlatten(array, INFINITY) : [];
    }

    /**
     * Recursively flatten `array` up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * var array = [1, [2, [3, [4]], 5]];
     *
     * _.flattenDepth(array, 1);
     * // => [1, 2, [3, [4]], 5]
     *
     * _.flattenDepth(array, 2);
     * // => [1, 2, 3, [4], 5]
     */
    function flattenDepth(array, depth) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      depth = depth === undefined ? 1 : toInteger(depth);
      return baseFlatten(array, depth);
    }

    /**
     * The inverse of `_.toPairs`; this method returns an object composed
     * from key-value `pairs`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} pairs The key-value pairs.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.fromPairs([['a', 1], ['b', 2]]);
     * // => { 'a': 1, 'b': 2 }
     */
    function fromPairs(pairs) {
      var index = -1,
          length = pairs == null ? 0 : pairs.length,
          result = {};

      while (++index < length) {
        var pair = pairs[index];
        result[pair[0]] = pair[1];
      }
      return result;
    }

    /**
     * Gets the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias first
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the first element of `array`.
     * @example
     *
     * _.head([1, 2, 3]);
     * // => 1
     *
     * _.head([]);
     * // => undefined
     */
    function head(array) {
      return (array && array.length) ? array[0] : undefined;
    }

    /**
     * Gets the index at which the first occurrence of `value` is found in `array`
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. If `fromIndex` is negative, it's used as the
     * offset from the end of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.indexOf([1, 2, 1, 2], 2);
     * // => 1
     *
     * // Search from the `fromIndex`.
     * _.indexOf([1, 2, 1, 2], 2, 2);
     * // => 3
     */
    function indexOf(array, value, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = fromIndex == null ? 0 : toInteger(fromIndex);
      if (index < 0) {
        index = nativeMax(length + index, 0);
      }
      return baseIndexOf(array, value, index);
    }

    /**
     * Gets all but the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.initial([1, 2, 3]);
     * // => [1, 2]
     */
    function initial(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseSlice(array, 0, -1) : [];
    }

    /**
     * Creates an array of unique values that are included in all given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersection([2, 1], [2, 3]);
     * // => [2]
     */
    var intersection = baseRest(function(arrays) {
      var mapped = arrayMap(arrays, castArrayLikeObject);
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped)
        : [];
    });

    /**
     * This method is like `_.intersection` except that it accepts `iteratee`
     * which is invoked for each element of each `arrays` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [2.1]
     *
     * // The `_.property` iteratee shorthand.
     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }]
     */
    var intersectionBy = baseRest(function(arrays) {
      var iteratee = last(arrays),
          mapped = arrayMap(arrays, castArrayLikeObject);

      if (iteratee === last(mapped)) {
        iteratee = undefined;
      } else {
        mapped.pop();
      }
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped, getIteratee(iteratee, 2))
        : [];
    });

    /**
     * This method is like `_.intersection` except that it accepts `comparator`
     * which is invoked to compare elements of `arrays`. The order and references
     * of result values are determined by the first array. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.intersectionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }]
     */
    var intersectionWith = baseRest(function(arrays) {
      var comparator = last(arrays),
          mapped = arrayMap(arrays, castArrayLikeObject);

      comparator = typeof comparator == 'function' ? comparator : undefined;
      if (comparator) {
        mapped.pop();
      }
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped, undefined, comparator)
        : [];
    });

    /**
     * Converts all elements in `array` into a string separated by `separator`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to convert.
     * @param {string} [separator=','] The element separator.
     * @returns {string} Returns the joined string.
     * @example
     *
     * _.join(['a', 'b', 'c'], '~');
     * // => 'a~b~c'
     */
    function join(array, separator) {
      return array == null ? '' : nativeJoin.call(array, separator);
    }

    /**
     * Gets the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the last element of `array`.
     * @example
     *
     * _.last([1, 2, 3]);
     * // => 3
     */
    function last(array) {
      var length = array == null ? 0 : array.length;
      return length ? array[length - 1] : undefined;
    }

    /**
     * This method is like `_.indexOf` except that it iterates over elements of
     * `array` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.lastIndexOf([1, 2, 1, 2], 2);
     * // => 3
     *
     * // Search from the `fromIndex`.
     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
     * // => 1
     */
    function lastIndexOf(array, value, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = length;
      if (fromIndex !== undefined) {
        index = toInteger(fromIndex);
        index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
      }
      return value === value
        ? strictLastIndexOf(array, value, index)
        : baseFindIndex(array, baseIsNaN, index, true);
    }

    /**
     * Gets the element at index `n` of `array`. If `n` is negative, the nth
     * element from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.11.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=0] The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     *
     * _.nth(array, 1);
     * // => 'b'
     *
     * _.nth(array, -2);
     * // => 'c';
     */
    function nth(array, n) {
      return (array && array.length) ? baseNth(array, toInteger(n)) : undefined;
    }

    /**
     * Removes all given values from `array` using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
     * to remove elements from an array by predicate.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...*} [values] The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pull(array, 'a', 'c');
     * console.log(array);
     * // => ['b', 'b']
     */
    var pull = baseRest(pullAll);

    /**
     * This method is like `_.pull` except that it accepts an array of values to remove.
     *
     * **Note:** Unlike `_.difference`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pullAll(array, ['a', 'c']);
     * console.log(array);
     * // => ['b', 'b']
     */
    function pullAll(array, values) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values)
        : array;
    }

    /**
     * This method is like `_.pullAll` except that it accepts `iteratee` which is
     * invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The iteratee is invoked with one argument: (value).
     *
     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
     *
     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
     * console.log(array);
     * // => [{ 'x': 2 }]
     */
    function pullAllBy(array, values, iteratee) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values, getIteratee(iteratee, 2))
        : array;
    }

    /**
     * This method is like `_.pullAll` except that it accepts `comparator` which
     * is invoked to compare elements of `array` to `values`. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
     *
     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
     * console.log(array);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
     */
    function pullAllWith(array, values, comparator) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values, undefined, comparator)
        : array;
    }

    /**
     * Removes elements from `array` corresponding to `indexes` and returns an
     * array of removed elements.
     *
     * **Note:** Unlike `_.at`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     * var pulled = _.pullAt(array, [1, 3]);
     *
     * console.log(array);
     * // => ['a', 'c']
     *
     * console.log(pulled);
     * // => ['b', 'd']
     */
    var pullAt = flatRest(function(array, indexes) {
      var length = array == null ? 0 : array.length,
          result = baseAt(array, indexes);

      basePullAt(array, arrayMap(indexes, function(index) {
        return isIndex(index, length) ? +index : index;
      }).sort(compareAscending));

      return result;
    });

    /**
     * Removes all elements from `array` that `predicate` returns truthy for
     * and returns an array of the removed elements. The predicate is invoked
     * with three arguments: (value, index, array).
     *
     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
     * to pull elements from an array by value.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = [1, 2, 3, 4];
     * var evens = _.remove(array, function(n) {
     *   return n % 2 == 0;
     * });
     *
     * console.log(array);
     * // => [1, 3]
     *
     * console.log(evens);
     * // => [2, 4]
     */
    function remove(array, predicate) {
      var result = [];
      if (!(array && array.length)) {
        return result;
      }
      var index = -1,
          indexes = [],
          length = array.length;

      predicate = getIteratee(predicate, 3);
      while (++index < length) {
        var value = array[index];
        if (predicate(value, index, array)) {
          result.push(value);
          indexes.push(index);
        }
      }
      basePullAt(array, indexes);
      return result;
    }

    /**
     * Reverses `array` so that the first element becomes the last, the second
     * element becomes the second to last, and so on.
     *
     * **Note:** This method mutates `array` and is based on
     * [`Array#reverse`](https://mdn.io/Array/reverse).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.reverse(array);
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */
    function reverse(array) {
      return array == null ? array : nativeReverse.call(array);
    }

    /**
     * Creates a slice of `array` from `start` up to, but not including, `end`.
     *
     * **Note:** This method is used instead of
     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
     * returned.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */
    function slice(array, start, end) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
        start = 0;
        end = length;
      }
      else {
        start = start == null ? 0 : toInteger(start);
        end = end === undefined ? length : toInteger(end);
      }
      return baseSlice(array, start, end);
    }

    /**
     * Uses a binary search to determine the lowest index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedIndex([30, 50], 40);
     * // => 1
     */
    function sortedIndex(array, value) {
      return baseSortedIndex(array, value);
    }

    /**
     * This method is like `_.sortedIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
     * // => 0
     */
    function sortedIndexBy(array, value, iteratee) {
      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
    }

    /**
     * This method is like `_.indexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
     * // => 1
     */
    function sortedIndexOf(array, value) {
      var length = array == null ? 0 : array.length;
      if (length) {
        var index = baseSortedIndex(array, value);
        if (index < length && eq(array[index], value)) {
          return index;
        }
      }
      return -1;
    }

    /**
     * This method is like `_.sortedIndex` except that it returns the highest
     * index at which `value` should be inserted into `array` in order to
     * maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
     * // => 4
     */
    function sortedLastIndex(array, value) {
      return baseSortedIndex(array, value, true);
    }

    /**
     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 1
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
     * // => 1
     */
    function sortedLastIndexBy(array, value, iteratee) {
      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
    }

    /**
     * This method is like `_.lastIndexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
     * // => 3
     */
    function sortedLastIndexOf(array, value) {
      var length = array == null ? 0 : array.length;
      if (length) {
        var index = baseSortedIndex(array, value, true) - 1;
        if (eq(array[index], value)) {
          return index;
        }
      }
      return -1;
    }

    /**
     * This method is like `_.uniq` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniq([1, 1, 2]);
     * // => [1, 2]
     */
    function sortedUniq(array) {
      return (array && array.length)
        ? baseSortedUniq(array)
        : [];
    }

    /**
     * This method is like `_.uniqBy` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
     * // => [1.1, 2.3]
     */
    function sortedUniqBy(array, iteratee) {
      return (array && array.length)
        ? baseSortedUniq(array, getIteratee(iteratee, 2))
        : [];
    }

    /**
     * Gets all but the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.tail([1, 2, 3]);
     * // => [2, 3]
     */
    function tail(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseSlice(array, 1, length) : [];
    }

    /**
     * Creates a slice of `array` with `n` elements taken from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.take([1, 2, 3]);
     * // => [1]
     *
     * _.take([1, 2, 3], 2);
     * // => [1, 2]
     *
     * _.take([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.take([1, 2, 3], 0);
     * // => []
     */
    function take(array, n, guard) {
      if (!(array && array.length)) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      return baseSlice(array, 0, n < 0 ? 0 : n);
    }

    /**
     * Creates a slice of `array` with `n` elements taken from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.takeRight([1, 2, 3]);
     * // => [3]
     *
     * _.takeRight([1, 2, 3], 2);
     * // => [2, 3]
     *
     * _.takeRight([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.takeRight([1, 2, 3], 0);
     * // => []
     */
    function takeRight(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      n = length - n;
      return baseSlice(array, n < 0 ? 0 : n, length);
    }

    /**
     * Creates a slice of `array` with elements taken from the end. Elements are
     * taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.takeRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeRightWhile(users, ['active', false]);
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeRightWhile(users, 'active');
     * // => []
     */
    function takeRightWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), false, true)
        : [];
    }

    /**
     * Creates a slice of `array` with elements taken from the beginning. Elements
     * are taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.takeWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeWhile(users, ['active', false]);
     * // => objects for ['barney', 'fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeWhile(users, 'active');
     * // => []
     */
    function takeWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3))
        : [];
    }

    /**
     * Creates an array of unique values, in order, from all given arrays using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.union([2], [1, 2]);
     * // => [2, 1]
     */
    var union = baseRest(function(arrays) {
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
    });

    /**
     * This method is like `_.union` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which uniqueness is computed. Result values are chosen from the first
     * array in which the value occurs. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */
    var unionBy = baseRest(function(arrays) {
      var iteratee = last(arrays);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee, 2));
    });

    /**
     * This method is like `_.union` except that it accepts `comparator` which
     * is invoked to compare elements of `arrays`. Result values are chosen from
     * the first array in which the value occurs. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.unionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */
    var unionWith = baseRest(function(arrays) {
      var comparator = last(arrays);
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined, comparator);
    });

    /**
     * Creates a duplicate-free version of an array, using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons, in which only the first occurrence of each element
     * is kept. The order of result values is determined by the order they occur
     * in the array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniq([2, 1, 2]);
     * // => [2, 1]
     */
    function uniq(array) {
      return (array && array.length) ? baseUniq(array) : [];
    }

    /**
     * This method is like `_.uniq` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * uniqueness is computed. The order of result values is determined by the
     * order they occur in the array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */
    function uniqBy(array, iteratee) {
      return (array && array.length) ? baseUniq(array, getIteratee(iteratee, 2)) : [];
    }

    /**
     * This method is like `_.uniq` except that it accepts `comparator` which
     * is invoked to compare elements of `array`. The order of result values is
     * determined by the order they occur in the array.The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.uniqWith(objects, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
     */
    function uniqWith(array, comparator) {
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return (array && array.length) ? baseUniq(array, undefined, comparator) : [];
    }

    /**
     * This method is like `_.zip` except that it accepts an array of grouped
     * elements and creates an array regrouping the elements to their pre-zip
     * configuration.
     *
     * @static
     * @memberOf _
     * @since 1.2.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     *
     * _.unzip(zipped);
     * // => [['a', 'b'], [1, 2], [true, false]]
     */
    function unzip(array) {
      if (!(array && array.length)) {
        return [];
      }
      var length = 0;
      array = arrayFilter(array, function(group) {
        if (isArrayLikeObject(group)) {
          length = nativeMax(group.length, length);
          return true;
        }
      });
      return baseTimes(length, function(index) {
        return arrayMap(array, baseProperty(index));
      });
    }

    /**
     * This method is like `_.unzip` except that it accepts `iteratee` to specify
     * how regrouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  regrouped values.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
     * // => [[1, 10, 100], [2, 20, 200]]
     *
     * _.unzipWith(zipped, _.add);
     * // => [3, 30, 300]
     */
    function unzipWith(array, iteratee) {
      if (!(array && array.length)) {
        return [];
      }
      var result = unzip(array);
      if (iteratee == null) {
        return result;
      }
      return arrayMap(result, function(group) {
        return apply(iteratee, undefined, group);
      });
    }

    /**
     * Creates an array excluding all given values using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.pull`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...*} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.xor
     * @example
     *
     * _.without([2, 1, 2, 3], 1, 2);
     * // => [3]
     */
    var without = baseRest(function(array, values) {
      return isArrayLikeObject(array)
        ? baseDifference(array, values)
        : [];
    });

    /**
     * Creates an array of unique values that is the
     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
     * of the given arrays. The order of result values is determined by the order
     * they occur in the arrays.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.without
     * @example
     *
     * _.xor([2, 1], [2, 3]);
     * // => [1, 3]
     */
    var xor = baseRest(function(arrays) {
      return baseXor(arrayFilter(arrays, isArrayLikeObject));
    });

    /**
     * This method is like `_.xor` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which by which they're compared. The order of result values is determined
     * by the order they occur in the arrays. The iteratee is invoked with one
     * argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2, 3.4]
     *
     * // The `_.property` iteratee shorthand.
     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */
    var xorBy = baseRest(function(arrays) {
      var iteratee = last(arrays);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee, 2));
    });

    /**
     * This method is like `_.xor` except that it accepts `comparator` which is
     * invoked to compare elements of `arrays`. The order of result values is
     * determined by the order they occur in the arrays. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.xorWith(objects, others, _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */
    var xorWith = baseRest(function(arrays) {
      var comparator = last(arrays);
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined, comparator);
    });

    /**
     * Creates an array of grouped elements, the first of which contains the
     * first elements of the given arrays, the second of which contains the
     * second elements of the given arrays, and so on.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     */
    var zip = baseRest(unzip);

    /**
     * This method is like `_.fromPairs` except that it accepts two arrays,
     * one of property identifiers and one of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 0.4.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObject(['a', 'b'], [1, 2]);
     * // => { 'a': 1, 'b': 2 }
     */
    function zipObject(props, values) {
      return baseZipObject(props || [], values || [], assignValue);
    }

    /**
     * This method is like `_.zipObject` except that it supports property paths.
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
     */
    function zipObjectDeep(props, values) {
      return baseZipObject(props || [], values || [], baseSet);
    }

    /**
     * This method is like `_.zip` except that it accepts `iteratee` to specify
     * how grouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  grouped values.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
     *   return a + b + c;
     * });
     * // => [111, 222]
     */
    var zipWith = baseRest(function(arrays) {
      var length = arrays.length,
          iteratee = length > 1 ? arrays[length - 1] : undefined;

      iteratee = typeof iteratee == 'function' ? (arrays.pop(), iteratee) : undefined;
      return unzipWith(arrays, iteratee);
    });

    /*------------------------------------------------------------------------*/

    /**
     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
     * chain sequences enabled. The result of such sequences must be unwrapped
     * with `_#value`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Seq
     * @param {*} value The value to wrap.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36 },
     *   { 'user': 'fred',    'age': 40 },
     *   { 'user': 'pebbles', 'age': 1 }
     * ];
     *
     * var youngest = _
     *   .chain(users)
     *   .sortBy('age')
     *   .map(function(o) {
     *     return o.user + ' is ' + o.age;
     *   })
     *   .head()
     *   .value();
     * // => 'pebbles is 1'
     */
    function chain(value) {
      var result = lodash(value);
      result.__chain__ = true;
      return result;
    }

    /**
     * This method invokes `interceptor` and returns `value`. The interceptor
     * is invoked with one argument; (value). The purpose of this method is to
     * "tap into" a method chain sequence in order to modify intermediate results.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns `value`.
     * @example
     *
     * _([1, 2, 3])
     *  .tap(function(array) {
     *    // Mutate input array.
     *    array.pop();
     *  })
     *  .reverse()
     *  .value();
     * // => [2, 1]
     */
    function tap(value, interceptor) {
      interceptor(value);
      return value;
    }

    /**
     * This method is like `_.tap` except that it returns the result of `interceptor`.
     * The purpose of this method is to "pass thru" values replacing intermediate
     * results in a method chain sequence.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns the result of `interceptor`.
     * @example
     *
     * _('  abc  ')
     *  .chain()
     *  .trim()
     *  .thru(function(value) {
     *    return [value];
     *  })
     *  .value();
     * // => ['abc']
     */
    function thru(value, interceptor) {
      return interceptor(value);
    }

    /**
     * This method is the wrapper version of `_.at`.
     *
     * @name at
     * @memberOf _
     * @since 1.0.0
     * @category Seq
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _(object).at(['a[0].b.c', 'a[1]']).value();
     * // => [3, 4]
     */
    var wrapperAt = flatRest(function(paths) {
      var length = paths.length,
          start = length ? paths[0] : 0,
          value = this.__wrapped__,
          interceptor = function(object) { return baseAt(object, paths); };

      if (length > 1 || this.__actions__.length ||
          !(value instanceof LazyWrapper) || !isIndex(start)) {
        return this.thru(interceptor);
      }
      value = value.slice(start, +start + (length ? 1 : 0));
      value.__actions__.push({
        'func': thru,
        'args': [interceptor],
        'thisArg': undefined
      });
      return new LodashWrapper(value, this.__chain__).thru(function(array) {
        if (length && !array.length) {
          array.push(undefined);
        }
        return array;
      });
    });

    /**
     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
     *
     * @name chain
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * // A sequence without explicit chaining.
     * _(users).head();
     * // => { 'user': 'barney', 'age': 36 }
     *
     * // A sequence with explicit chaining.
     * _(users)
     *   .chain()
     *   .head()
     *   .pick('user')
     *   .value();
     * // => { 'user': 'barney' }
     */
    function wrapperChain() {
      return chain(this);
    }

    /**
     * Executes the chain sequence and returns the wrapped result.
     *
     * @name commit
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2];
     * var wrapped = _(array).push(3);
     *
     * console.log(array);
     * // => [1, 2]
     *
     * wrapped = wrapped.commit();
     * console.log(array);
     * // => [1, 2, 3]
     *
     * wrapped.last();
     * // => 3
     *
     * console.log(array);
     * // => [1, 2, 3]
     */
    function wrapperCommit() {
      return new LodashWrapper(this.value(), this.__chain__);
    }

    /**
     * Gets the next value on a wrapped object following the
     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
     *
     * @name next
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the next iterator value.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 1 }
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 2 }
     *
     * wrapped.next();
     * // => { 'done': true, 'value': undefined }
     */
    function wrapperNext() {
      if (this.__values__ === undefined) {
        this.__values__ = toArray(this.value());
      }
      var done = this.__index__ >= this.__values__.length,
          value = done ? undefined : this.__values__[this.__index__++];

      return { 'done': done, 'value': value };
    }

    /**
     * Enables the wrapper to be iterable.
     *
     * @name Symbol.iterator
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the wrapper object.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped[Symbol.iterator]() === wrapped;
     * // => true
     *
     * Array.from(wrapped);
     * // => [1, 2]
     */
    function wrapperToIterator() {
      return this;
    }

    /**
     * Creates a clone of the chain sequence planting `value` as the wrapped value.
     *
     * @name plant
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @param {*} value The value to plant.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2]).map(square);
     * var other = wrapped.plant([3, 4]);
     *
     * other.value();
     * // => [9, 16]
     *
     * wrapped.value();
     * // => [1, 4]
     */
    function wrapperPlant(value) {
      var result,
          parent = this;

      while (parent instanceof baseLodash) {
        var clone = wrapperClone(parent);
        clone.__index__ = 0;
        clone.__values__ = undefined;
        if (result) {
          previous.__wrapped__ = clone;
        } else {
          result = clone;
        }
        var previous = clone;
        parent = parent.__wrapped__;
      }
      previous.__wrapped__ = value;
      return result;
    }

    /**
     * This method is the wrapper version of `_.reverse`.
     *
     * **Note:** This method mutates the wrapped array.
     *
     * @name reverse
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _(array).reverse().value()
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */
    function wrapperReverse() {
      var value = this.__wrapped__;
      if (value instanceof LazyWrapper) {
        var wrapped = value;
        if (this.__actions__.length) {
          wrapped = new LazyWrapper(this);
        }
        wrapped = wrapped.reverse();
        wrapped.__actions__.push({
          'func': thru,
          'args': [reverse],
          'thisArg': undefined
        });
        return new LodashWrapper(wrapped, this.__chain__);
      }
      return this.thru(reverse);
    }

    /**
     * Executes the chain sequence to resolve the unwrapped value.
     *
     * @name value
     * @memberOf _
     * @since 0.1.0
     * @alias toJSON, valueOf
     * @category Seq
     * @returns {*} Returns the resolved unwrapped value.
     * @example
     *
     * _([1, 2, 3]).value();
     * // => [1, 2, 3]
     */
    function wrapperValue() {
      return baseWrapperValue(this.__wrapped__, this.__actions__);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the number of times the key was returned by `iteratee`. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.countBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': 1, '6': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.countBy(['one', 'two', 'three'], 'length');
     * // => { '3': 2, '5': 1 }
     */
    var countBy = createAggregator(function(result, value, key) {
      if (hasOwnProperty.call(result, key)) {
        ++result[key];
      } else {
        baseAssignValue(result, key, 1);
      }
    });

    /**
     * Checks if `predicate` returns truthy for **all** elements of `collection`.
     * Iteration is stopped once `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * **Note:** This method returns `true` for
     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
     * elements of empty collections.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`.
     * @example
     *
     * _.every([true, 1, null, 'yes'], Boolean);
     * // => false
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.every(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.every(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.every(users, 'active');
     * // => false
     */
    function every(collection, predicate, guard) {
      var func = isArray(collection) ? arrayEvery : baseEvery;
      if (guard && isIterateeCall(collection, predicate, guard)) {
        predicate = undefined;
      }
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Iterates over elements of `collection`, returning an array of all elements
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * **Note:** Unlike `_.remove`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.reject
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * _.filter(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, { 'age': 36, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.filter(users, 'active');
     * // => objects for ['barney']
     */
    function filter(collection, predicate) {
      var func = isArray(collection) ? arrayFilter : baseFilter;
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Iterates over elements of `collection`, returning the first element
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': true },
     *   { 'user': 'fred',    'age': 40, 'active': false },
     *   { 'user': 'pebbles', 'age': 1,  'active': true }
     * ];
     *
     * _.find(users, function(o) { return o.age < 40; });
     * // => object for 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.find(users, { 'age': 1, 'active': true });
     * // => object for 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.find(users, ['active', false]);
     * // => object for 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.find(users, 'active');
     * // => object for 'barney'
     */
    var find = createFind(findIndex);

    /**
     * This method is like `_.find` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=collection.length-1] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * _.findLast([1, 2, 3, 4], function(n) {
     *   return n % 2 == 1;
     * });
     * // => 3
     */
    var findLast = createFind(findLastIndex);

    /**
     * Creates a flattened array of values by running each element in `collection`
     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
     * with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [n, n];
     * }
     *
     * _.flatMap([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */
    function flatMap(collection, iteratee) {
      return baseFlatten(map(collection, iteratee), 1);
    }

    /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDeep([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */
    function flatMapDeep(collection, iteratee) {
      return baseFlatten(map(collection, iteratee), INFINITY);
    }

    /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDepth([1, 2], duplicate, 2);
     * // => [[1, 1], [2, 2]]
     */
    function flatMapDepth(collection, iteratee, depth) {
      depth = depth === undefined ? 1 : toInteger(depth);
      return baseFlatten(map(collection, iteratee), depth);
    }

    /**
     * Iterates over elements of `collection` and invokes `iteratee` for each element.
     * The iteratee is invoked with three arguments: (value, index|key, collection).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * **Note:** As with other "Collections" methods, objects with a "length"
     * property are iterated like arrays. To avoid this behavior use `_.forIn`
     * or `_.forOwn` for object iteration.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias each
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEachRight
     * @example
     *
     * _.forEach([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `1` then `2`.
     *
     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */
    function forEach(collection, iteratee) {
      var func = isArray(collection) ? arrayEach : baseEach;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.forEach` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @alias eachRight
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEach
     * @example
     *
     * _.forEachRight([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `2` then `1`.
     */
    function forEachRight(collection, iteratee) {
      var func = isArray(collection) ? arrayEachRight : baseEachRight;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The order of grouped values
     * is determined by the order they occur in `collection`. The corresponding
     * value of each key is an array of elements responsible for generating the
     * key. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': [4.2], '6': [6.1, 6.3] }
     *
     * // The `_.property` iteratee shorthand.
     * _.groupBy(['one', 'two', 'three'], 'length');
     * // => { '3': ['one', 'two'], '5': ['three'] }
     */
    var groupBy = createAggregator(function(result, value, key) {
      if (hasOwnProperty.call(result, key)) {
        result[key].push(value);
      } else {
        baseAssignValue(result, key, [value]);
      }
    });

    /**
     * Checks if `value` is in `collection`. If `collection` is a string, it's
     * checked for a substring of `value`, otherwise
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * is used for equality comparisons. If `fromIndex` is negative, it's used as
     * the offset from the end of `collection`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {boolean} Returns `true` if `value` is found, else `false`.
     * @example
     *
     * _.includes([1, 2, 3], 1);
     * // => true
     *
     * _.includes([1, 2, 3], 1, 2);
     * // => false
     *
     * _.includes({ 'a': 1, 'b': 2 }, 1);
     * // => true
     *
     * _.includes('abcd', 'bc');
     * // => true
     */
    function includes(collection, value, fromIndex, guard) {
      collection = isArrayLike(collection) ? collection : values(collection);
      fromIndex = (fromIndex && !guard) ? toInteger(fromIndex) : 0;

      var length = collection.length;
      if (fromIndex < 0) {
        fromIndex = nativeMax(length + fromIndex, 0);
      }
      return isString(collection)
        ? (fromIndex <= length && collection.indexOf(value, fromIndex) > -1)
        : (!!length && baseIndexOf(collection, value, fromIndex) > -1);
    }

    /**
     * Invokes the method at `path` of each element in `collection`, returning
     * an array of the results of each invoked method. Any additional arguments
     * are provided to each invoked method. If `path` is a function, it's invoked
     * for, and `this` bound to, each element in `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array|Function|string} path The path of the method to invoke or
     *  the function invoked per iteration.
     * @param {...*} [args] The arguments to invoke each method with.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
     * // => [[1, 5, 7], [1, 2, 3]]
     *
     * _.invokeMap([123, 456], String.prototype.split, '');
     * // => [['1', '2', '3'], ['4', '5', '6']]
     */
    var invokeMap = baseRest(function(collection, path, args) {
      var index = -1,
          isFunc = typeof path == 'function',
          result = isArrayLike(collection) ? Array(collection.length) : [];

      baseEach(collection, function(value) {
        result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
      });
      return result;
    });

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the last element responsible for generating the key. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * var array = [
     *   { 'dir': 'left', 'code': 97 },
     *   { 'dir': 'right', 'code': 100 }
     * ];
     *
     * _.keyBy(array, function(o) {
     *   return String.fromCharCode(o.code);
     * });
     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
     *
     * _.keyBy(array, 'dir');
     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
     */
    var keyBy = createAggregator(function(result, value, key) {
      baseAssignValue(result, key, value);
    });

    /**
     * Creates an array of values by running each element in `collection` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
     *
     * The guarded methods are:
     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * _.map([4, 8], square);
     * // => [16, 64]
     *
     * _.map({ 'a': 4, 'b': 8 }, square);
     * // => [16, 64] (iteration order is not guaranteed)
     *
     * var users = [
     *   { 'user': 'barney' },
     *   { 'user': 'fred' }
     * ];
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, 'user');
     * // => ['barney', 'fred']
     */
    function map(collection, iteratee) {
      var func = isArray(collection) ? arrayMap : baseMap;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.sortBy` except that it allows specifying the sort
     * orders of the iteratees to sort by. If `orders` is unspecified, all values
     * are sorted in ascending order. Otherwise, specify an order of "desc" for
     * descending or "asc" for ascending sort order of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @param {string[]} [orders] The sort orders of `iteratees`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 34 },
     *   { 'user': 'fred',   'age': 40 },
     *   { 'user': 'barney', 'age': 36 }
     * ];
     *
     * // Sort by `user` in ascending order and by `age` in descending order.
     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
     */
    function orderBy(collection, iteratees, orders, guard) {
      if (collection == null) {
        return [];
      }
      if (!isArray(iteratees)) {
        iteratees = iteratees == null ? [] : [iteratees];
      }
      orders = guard ? undefined : orders;
      if (!isArray(orders)) {
        orders = orders == null ? [] : [orders];
      }
      return baseOrderBy(collection, iteratees, orders);
    }

    /**
     * Creates an array of elements split into two groups, the first of which
     * contains elements `predicate` returns truthy for, the second of which
     * contains elements `predicate` returns falsey for. The predicate is
     * invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of grouped elements.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': false },
     *   { 'user': 'fred',    'age': 40, 'active': true },
     *   { 'user': 'pebbles', 'age': 1,  'active': false }
     * ];
     *
     * _.partition(users, function(o) { return o.active; });
     * // => objects for [['fred'], ['barney', 'pebbles']]
     *
     * // The `_.matches` iteratee shorthand.
     * _.partition(users, { 'age': 1, 'active': false });
     * // => objects for [['pebbles'], ['barney', 'fred']]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.partition(users, ['active', false]);
     * // => objects for [['barney', 'pebbles'], ['fred']]
     *
     * // The `_.property` iteratee shorthand.
     * _.partition(users, 'active');
     * // => objects for [['fred'], ['barney', 'pebbles']]
     */
    var partition = createAggregator(function(result, value, key) {
      result[key ? 0 : 1].push(value);
    }, function() { return [[], []]; });

    /**
     * Reduces `collection` to a value which is the accumulated result of running
     * each element in `collection` thru `iteratee`, where each successive
     * invocation is supplied the return value of the previous. If `accumulator`
     * is not given, the first element of `collection` is used as the initial
     * value. The iteratee is invoked with four arguments:
     * (accumulator, value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.reduce`, `_.reduceRight`, and `_.transform`.
     *
     * The guarded methods are:
     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
     * and `sortBy`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduceRight
     * @example
     *
     * _.reduce([1, 2], function(sum, n) {
     *   return sum + n;
     * }, 0);
     * // => 3
     *
     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     *   return result;
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
     */
    function reduce(collection, iteratee, accumulator) {
      var func = isArray(collection) ? arrayReduce : baseReduce,
          initAccum = arguments.length < 3;

      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
    }

    /**
     * This method is like `_.reduce` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduce
     * @example
     *
     * var array = [[0, 1], [2, 3], [4, 5]];
     *
     * _.reduceRight(array, function(flattened, other) {
     *   return flattened.concat(other);
     * }, []);
     * // => [4, 5, 2, 3, 0, 1]
     */
    function reduceRight(collection, iteratee, accumulator) {
      var func = isArray(collection) ? arrayReduceRight : baseReduce,
          initAccum = arguments.length < 3;

      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
    }

    /**
     * The opposite of `_.filter`; this method returns the elements of `collection`
     * that `predicate` does **not** return truthy for.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.filter
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': true }
     * ];
     *
     * _.reject(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.reject(users, { 'age': 40, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.reject(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.reject(users, 'active');
     * // => objects for ['barney']
     */
    function reject(collection, predicate) {
      var func = isArray(collection) ? arrayFilter : baseFilter;
      return func(collection, negate(getIteratee(predicate, 3)));
    }

    /**
     * Gets a random element from `collection`.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     * @example
     *
     * _.sample([1, 2, 3, 4]);
     * // => 2
     */
    function sample(collection) {
      var func = isArray(collection) ? arraySample : baseSample;
      return func(collection);
    }

    /**
     * Gets `n` random elements at unique keys from `collection` up to the
     * size of `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @param {number} [n=1] The number of elements to sample.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the random elements.
     * @example
     *
     * _.sampleSize([1, 2, 3], 2);
     * // => [3, 1]
     *
     * _.sampleSize([1, 2, 3], 4);
     * // => [2, 3, 1]
     */
    function sampleSize(collection, n, guard) {
      if ((guard ? isIterateeCall(collection, n, guard) : n === undefined)) {
        n = 1;
      } else {
        n = toInteger(n);
      }
      var func = isArray(collection) ? arraySampleSize : baseSampleSize;
      return func(collection, n);
    }

    /**
     * Creates an array of shuffled values, using a version of the
     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     * @example
     *
     * _.shuffle([1, 2, 3, 4]);
     * // => [4, 1, 3, 2]
     */
    function shuffle(collection) {
      var func = isArray(collection) ? arrayShuffle : baseShuffle;
      return func(collection);
    }

    /**
     * Gets the size of `collection` by returning its length for array-like
     * values or the number of own enumerable string keyed properties for objects.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @returns {number} Returns the collection size.
     * @example
     *
     * _.size([1, 2, 3]);
     * // => 3
     *
     * _.size({ 'a': 1, 'b': 2 });
     * // => 2
     *
     * _.size('pebbles');
     * // => 7
     */
    function size(collection) {
      if (collection == null) {
        return 0;
      }
      if (isArrayLike(collection)) {
        return isString(collection) ? stringSize(collection) : collection.length;
      }
      var tag = getTag(collection);
      if (tag == mapTag || tag == setTag) {
        return collection.size;
      }
      return baseKeys(collection).length;
    }

    /**
     * Checks if `predicate` returns truthy for **any** element of `collection`.
     * Iteration is stopped once `predicate` returns truthy. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     * @example
     *
     * _.some([null, 0, 'yes', false], Boolean);
     * // => true
     *
     * var users = [
     *   { 'user': 'barney', 'active': true },
     *   { 'user': 'fred',   'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.some(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.some(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.some(users, 'active');
     * // => true
     */
    function some(collection, predicate, guard) {
      var func = isArray(collection) ? arraySome : baseSome;
      if (guard && isIterateeCall(collection, predicate, guard)) {
        predicate = undefined;
      }
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Creates an array of elements, sorted in ascending order by the results of
     * running each element in a collection thru each iteratee. This method
     * performs a stable sort, that is, it preserves the original sort order of
     * equal elements. The iteratees are invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 },
     *   { 'user': 'barney', 'age': 34 }
     * ];
     *
     * _.sortBy(users, [function(o) { return o.user; }]);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
     *
     * _.sortBy(users, ['user', 'age']);
     * // => objects for [['barney', 34], ['barney', 36], ['fred', 40], ['fred', 48]]
     */
    var sortBy = baseRest(function(collection, iteratees) {
      if (collection == null) {
        return [];
      }
      var length = iteratees.length;
      if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
        iteratees = [];
      } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
        iteratees = [iteratees[0]];
      }
      return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
    });

    /*------------------------------------------------------------------------*/

    /**
     * Gets the timestamp of the number of milliseconds that have elapsed since
     * the Unix epoch (1 January 1970 00:00:00 UTC).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Date
     * @returns {number} Returns the timestamp.
     * @example
     *
     * _.defer(function(stamp) {
     *   console.log(_.now() - stamp);
     * }, _.now());
     * // => Logs the number of milliseconds it took for the deferred invocation.
     */
    var now = ctxNow || function() {
      return root.Date.now();
    };

    /*------------------------------------------------------------------------*/

    /**
     * The opposite of `_.before`; this method creates a function that invokes
     * `func` once it's called `n` or more times.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {number} n The number of calls before `func` is invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var saves = ['profile', 'settings'];
     *
     * var done = _.after(saves.length, function() {
     *   console.log('done saving!');
     * });
     *
     * _.forEach(saves, function(type) {
     *   asyncSave({ 'type': type, 'complete': done });
     * });
     * // => Logs 'done saving!' after the two async saves have completed.
     */
    function after(n, func) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      n = toInteger(n);
      return function() {
        if (--n < 1) {
          return func.apply(this, arguments);
        }
      };
    }

    /**
     * Creates a function that invokes `func`, with up to `n` arguments,
     * ignoring any additional arguments.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @param {number} [n=func.length] The arity cap.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
     * // => [6, 8, 10]
     */
    function ary(func, n, guard) {
      n = guard ? undefined : n;
      n = (func && n == null) ? func.length : n;
      return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
    }

    /**
     * Creates a function that invokes `func`, with the `this` binding and arguments
     * of the created function, while it's called less than `n` times. Subsequent
     * calls to the created function return the result of the last `func` invocation.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {number} n The number of calls at which `func` is no longer invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * jQuery(element).on('click', _.before(5, addContactToList));
     * // => Allows adding up to 4 contacts to the list.
     */
    function before(n, func) {
      var result;
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      n = toInteger(n);
      return function() {
        if (--n > 0) {
          result = func.apply(this, arguments);
        }
        if (n <= 1) {
          func = undefined;
        }
        return result;
      };
    }

    /**
     * Creates a function that invokes `func` with the `this` binding of `thisArg`
     * and `partials` prepended to the arguments it receives.
     *
     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for partially applied arguments.
     *
     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
     * property of bound functions.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to bind.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * function greet(greeting, punctuation) {
     *   return greeting + ' ' + this.user + punctuation;
     * }
     *
     * var object = { 'user': 'fred' };
     *
     * var bound = _.bind(greet, object, 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bind(greet, object, _, '!');
     * bound('hi');
     * // => 'hi fred!'
     */
    var bind = baseRest(function(func, thisArg, partials) {
      var bitmask = WRAP_BIND_FLAG;
      if (partials.length) {
        var holders = replaceHolders(partials, getHolder(bind));
        bitmask |= WRAP_PARTIAL_FLAG;
      }
      return createWrap(func, bitmask, thisArg, partials, holders);
    });

    /**
     * Creates a function that invokes the method at `object[key]` with `partials`
     * prepended to the arguments it receives.
     *
     * This method differs from `_.bind` by allowing bound functions to reference
     * methods that may be redefined or don't yet exist. See
     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
     * for more details.
     *
     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Function
     * @param {Object} object The object to invoke the method on.
     * @param {string} key The key of the method.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * var object = {
     *   'user': 'fred',
     *   'greet': function(greeting, punctuation) {
     *     return greeting + ' ' + this.user + punctuation;
     *   }
     * };
     *
     * var bound = _.bindKey(object, 'greet', 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * object.greet = function(greeting, punctuation) {
     *   return greeting + 'ya ' + this.user + punctuation;
     * };
     *
     * bound('!');
     * // => 'hiya fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bindKey(object, 'greet', _, '!');
     * bound('hi');
     * // => 'hiya fred!'
     */
    var bindKey = baseRest(function(object, key, partials) {
      var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
      if (partials.length) {
        var holders = replaceHolders(partials, getHolder(bindKey));
        bitmask |= WRAP_PARTIAL_FLAG;
      }
      return createWrap(key, bitmask, object, partials, holders);
    });

    /**
     * Creates a function that accepts arguments of `func` and either invokes
     * `func` returning its result, if at least `arity` number of arguments have
     * been provided, or returns a function that accepts the remaining `func`
     * arguments, and so on. The arity of `func` may be specified if `func.length`
     * is not sufficient.
     *
     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curry(abc);
     *
     * curried(1)(2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(1)(_, 3)(2);
     * // => [1, 2, 3]
     */
    function curry(func, arity, guard) {
      arity = guard ? undefined : arity;
      var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
      result.placeholder = curry.placeholder;
      return result;
    }

    /**
     * This method is like `_.curry` except that arguments are applied to `func`
     * in the manner of `_.partialRight` instead of `_.partial`.
     *
     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curryRight(abc);
     *
     * curried(3)(2)(1);
     * // => [1, 2, 3]
     *
     * curried(2, 3)(1);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(3)(1, _)(2);
     * // => [1, 2, 3]
     */
    function curryRight(func, arity, guard) {
      arity = guard ? undefined : arity;
      var result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
      result.placeholder = curryRight.placeholder;
      return result;
    }

    /**
     * Creates a debounced function that delays invoking `func` until after `wait`
     * milliseconds have elapsed since the last time the debounced function was
     * invoked. The debounced function comes with a `cancel` method to cancel
     * delayed `func` invocations and a `flush` method to immediately invoke them.
     * Provide `options` to indicate whether `func` should be invoked on the
     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
     * with the last arguments provided to the debounced function. Subsequent
     * calls to the debounced function return the result of the last `func`
     * invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the debounced function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.debounce` and `_.throttle`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to debounce.
     * @param {number} [wait=0] The number of milliseconds to delay.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=false]
     *  Specify invoking on the leading edge of the timeout.
     * @param {number} [options.maxWait]
     *  The maximum time `func` is allowed to be delayed before it's invoked.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new debounced function.
     * @example
     *
     * // Avoid costly calculations while the window size is in flux.
     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
     *
     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
     * jQuery(element).on('click', _.debounce(sendMail, 300, {
     *   'leading': true,
     *   'trailing': false
     * }));
     *
     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
     * var source = new EventSource('/stream');
     * jQuery(source).on('message', debounced);
     *
     * // Cancel the trailing debounced invocation.
     * jQuery(window).on('popstate', debounced.cancel);
     */
    function debounce(func, wait, options) {
      var lastArgs,
          lastThis,
          maxWait,
          result,
          timerId,
          lastCallTime,
          lastInvokeTime = 0,
          leading = false,
          maxing = false,
          trailing = true;

      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      wait = toNumber(wait) || 0;
      if (isObject(options)) {
        leading = !!options.leading;
        maxing = 'maxWait' in options;
        maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
      }

      function invokeFunc(time) {
        var args = lastArgs,
            thisArg = lastThis;

        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
      }

      function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
      }

      function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime,
            timeSinceLastInvoke = time - lastInvokeTime,
            timeWaiting = wait - timeSinceLastCall;

        return maxing
          ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
          : timeWaiting;
      }

      function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime,
            timeSinceLastInvoke = time - lastInvokeTime;

        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
          (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
      }

      function timerExpired() {
        var time = now();
        if (shouldInvoke(time)) {
          return trailingEdge(time);
        }
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
      }

      function trailingEdge(time) {
        timerId = undefined;

        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) {
          return invokeFunc(time);
        }
        lastArgs = lastThis = undefined;
        return result;
      }

      function cancel() {
        if (timerId !== undefined) {
          clearTimeout(timerId);
        }
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
      }

      function flush() {
        return timerId === undefined ? result : trailingEdge(now());
      }

      function debounced() {
        var time = now(),
            isInvoking = shouldInvoke(time);

        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;

        if (isInvoking) {
          if (timerId === undefined) {
            return leadingEdge(lastCallTime);
          }
          if (maxing) {
            // Handle invocations in a tight loop.
            clearTimeout(timerId);
            timerId = setTimeout(timerExpired, wait);
            return invokeFunc(lastCallTime);
          }
        }
        if (timerId === undefined) {
          timerId = setTimeout(timerExpired, wait);
        }
        return result;
      }
      debounced.cancel = cancel;
      debounced.flush = flush;
      return debounced;
    }

    /**
     * Defers invoking the `func` until the current call stack has cleared. Any
     * additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to defer.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.defer(function(text) {
     *   console.log(text);
     * }, 'deferred');
     * // => Logs 'deferred' after one millisecond.
     */
    var defer = baseRest(function(func, args) {
      return baseDelay(func, 1, args);
    });

    /**
     * Invokes `func` after `wait` milliseconds. Any additional arguments are
     * provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.delay(function(text) {
     *   console.log(text);
     * }, 1000, 'later');
     * // => Logs 'later' after one second.
     */
    var delay = baseRest(function(func, wait, args) {
      return baseDelay(func, toNumber(wait) || 0, args);
    });

    /**
     * Creates a function that invokes `func` with arguments reversed.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to flip arguments for.
     * @returns {Function} Returns the new flipped function.
     * @example
     *
     * var flipped = _.flip(function() {
     *   return _.toArray(arguments);
     * });
     *
     * flipped('a', 'b', 'c', 'd');
     * // => ['d', 'c', 'b', 'a']
     */
    function flip(func) {
      return createWrap(func, WRAP_FLIP_FLAG);
    }

    /**
     * Creates a function that memoizes the result of `func`. If `resolver` is
     * provided, it determines the cache key for storing the result based on the
     * arguments provided to the memoized function. By default, the first argument
     * provided to the memoized function is used as the map cache key. The `func`
     * is invoked with the `this` binding of the memoized function.
     *
     * **Note:** The cache is exposed as the `cache` property on the memoized
     * function. Its creation may be customized by replacing the `_.memoize.Cache`
     * constructor with one whose instances implement the
     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to have its output memoized.
     * @param {Function} [resolver] The function to resolve the cache key.
     * @returns {Function} Returns the new memoized function.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     * var other = { 'c': 3, 'd': 4 };
     *
     * var values = _.memoize(_.values);
     * values(object);
     * // => [1, 2]
     *
     * values(other);
     * // => [3, 4]
     *
     * object.a = 2;
     * values(object);
     * // => [1, 2]
     *
     * // Modify the result cache.
     * values.cache.set(object, ['a', 'b']);
     * values(object);
     * // => ['a', 'b']
     *
     * // Replace `_.memoize.Cache`.
     * _.memoize.Cache = WeakMap;
     */
    function memoize(func, resolver) {
      if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var memoized = function() {
        var args = arguments,
            key = resolver ? resolver.apply(this, args) : args[0],
            cache = memoized.cache;

        if (cache.has(key)) {
          return cache.get(key);
        }
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result) || cache;
        return result;
      };
      memoized.cache = new (memoize.Cache || MapCache);
      return memoized;
    }

    // Expose `MapCache`.
    memoize.Cache = MapCache;

    /**
     * Creates a function that negates the result of the predicate `func`. The
     * `func` predicate is invoked with the `this` binding and arguments of the
     * created function.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} predicate The predicate to negate.
     * @returns {Function} Returns the new negated function.
     * @example
     *
     * function isEven(n) {
     *   return n % 2 == 0;
     * }
     *
     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
     * // => [1, 3, 5]
     */
    function negate(predicate) {
      if (typeof predicate != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      return function() {
        var args = arguments;
        switch (args.length) {
          case 0: return !predicate.call(this);
          case 1: return !predicate.call(this, args[0]);
          case 2: return !predicate.call(this, args[0], args[1]);
          case 3: return !predicate.call(this, args[0], args[1], args[2]);
        }
        return !predicate.apply(this, args);
      };
    }

    /**
     * Creates a function that is restricted to invoking `func` once. Repeat calls
     * to the function return the value of the first invocation. The `func` is
     * invoked with the `this` binding and arguments of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var initialize = _.once(createApplication);
     * initialize();
     * initialize();
     * // => `createApplication` is invoked once
     */
    function once(func) {
      return before(2, func);
    }

    /**
     * Creates a function that invokes `func` with its arguments transformed.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Function
     * @param {Function} func The function to wrap.
     * @param {...(Function|Function[])} [transforms=[_.identity]]
     *  The argument transforms.
     * @returns {Function} Returns the new function.
     * @example
     *
     * function doubled(n) {
     *   return n * 2;
     * }
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var func = _.overArgs(function(x, y) {
     *   return [x, y];
     * }, [square, doubled]);
     *
     * func(9, 3);
     * // => [81, 6]
     *
     * func(10, 5);
     * // => [100, 10]
     */
    var overArgs = castRest(function(func, transforms) {
      transforms = (transforms.length == 1 && isArray(transforms[0]))
        ? arrayMap(transforms[0], baseUnary(getIteratee()))
        : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));

      var funcsLength = transforms.length;
      return baseRest(function(args) {
        var index = -1,
            length = nativeMin(args.length, funcsLength);

        while (++index < length) {
          args[index] = transforms[index].call(this, args[index]);
        }
        return apply(func, this, args);
      });
    });

    /**
     * Creates a function that invokes `func` with `partials` prepended to the
     * arguments it receives. This method is like `_.bind` except it does **not**
     * alter the `this` binding.
     *
     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 0.2.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var sayHelloTo = _.partial(greet, 'hello');
     * sayHelloTo('fred');
     * // => 'hello fred'
     *
     * // Partially applied with placeholders.
     * var greetFred = _.partial(greet, _, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     */
    var partial = baseRest(function(func, partials) {
      var holders = replaceHolders(partials, getHolder(partial));
      return createWrap(func, WRAP_PARTIAL_FLAG, undefined, partials, holders);
    });

    /**
     * This method is like `_.partial` except that partially applied arguments
     * are appended to the arguments it receives.
     *
     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var greetFred = _.partialRight(greet, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     *
     * // Partially applied with placeholders.
     * var sayHelloTo = _.partialRight(greet, 'hello', _);
     * sayHelloTo('fred');
     * // => 'hello fred'
     */
    var partialRight = baseRest(function(func, partials) {
      var holders = replaceHolders(partials, getHolder(partialRight));
      return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined, partials, holders);
    });

    /**
     * Creates a function that invokes `func` with arguments arranged according
     * to the specified `indexes` where the argument value at the first index is
     * provided as the first argument, the argument value at the second index is
     * provided as the second argument, and so on.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to rearrange arguments for.
     * @param {...(number|number[])} indexes The arranged argument indexes.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var rearged = _.rearg(function(a, b, c) {
     *   return [a, b, c];
     * }, [2, 0, 1]);
     *
     * rearged('b', 'c', 'a')
     * // => ['a', 'b', 'c']
     */
    var rearg = flatRest(function(func, indexes) {
      return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
    });

    /**
     * Creates a function that invokes `func` with the `this` binding of the
     * created function and arguments from `start` and beyond provided as
     * an array.
     *
     * **Note:** This method is based on the
     * [rest parameter](https://mdn.io/rest_parameters).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.rest(function(what, names) {
     *   return what + ' ' + _.initial(names).join(', ') +
     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
     * });
     *
     * say('hello', 'fred', 'barney', 'pebbles');
     * // => 'hello fred, barney, & pebbles'
     */
    function rest(func, start) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      start = start === undefined ? start : toInteger(start);
      return baseRest(func, start);
    }

    /**
     * Creates a function that invokes `func` with the `this` binding of the
     * create function and an array of arguments much like
     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
     *
     * **Note:** This method is based on the
     * [spread operator](https://mdn.io/spread_operator).
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Function
     * @param {Function} func The function to spread arguments over.
     * @param {number} [start=0] The start position of the spread.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.spread(function(who, what) {
     *   return who + ' says ' + what;
     * });
     *
     * say(['fred', 'hello']);
     * // => 'fred says hello'
     *
     * var numbers = Promise.all([
     *   Promise.resolve(40),
     *   Promise.resolve(36)
     * ]);
     *
     * numbers.then(_.spread(function(x, y) {
     *   return x + y;
     * }));
     * // => a Promise of 76
     */
    function spread(func, start) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      start = start == null ? 0 : nativeMax(toInteger(start), 0);
      return baseRest(function(args) {
        var array = args[start],
            otherArgs = castSlice(args, 0, start);

        if (array) {
          arrayPush(otherArgs, array);
        }
        return apply(func, this, otherArgs);
      });
    }

    /**
     * Creates a throttled function that only invokes `func` at most once per
     * every `wait` milliseconds. The throttled function comes with a `cancel`
     * method to cancel delayed `func` invocations and a `flush` method to
     * immediately invoke them. Provide `options` to indicate whether `func`
     * should be invoked on the leading and/or trailing edge of the `wait`
     * timeout. The `func` is invoked with the last arguments provided to the
     * throttled function. Subsequent calls to the throttled function return the
     * result of the last `func` invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the throttled function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.throttle` and `_.debounce`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to throttle.
     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=true]
     *  Specify invoking on the leading edge of the timeout.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new throttled function.
     * @example
     *
     * // Avoid excessively updating the position while scrolling.
     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
     *
     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
     * jQuery(element).on('click', throttled);
     *
     * // Cancel the trailing throttled invocation.
     * jQuery(window).on('popstate', throttled.cancel);
     */
    function throttle(func, wait, options) {
      var leading = true,
          trailing = true;

      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      if (isObject(options)) {
        leading = 'leading' in options ? !!options.leading : leading;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
      }
      return debounce(func, wait, {
        'leading': leading,
        'maxWait': wait,
        'trailing': trailing
      });
    }

    /**
     * Creates a function that accepts up to one argument, ignoring any
     * additional arguments.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.unary(parseInt));
     * // => [6, 8, 10]
     */
    function unary(func) {
      return ary(func, 1);
    }

    /**
     * Creates a function that provides `value` to `wrapper` as its first
     * argument. Any additional arguments provided to the function are appended
     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
     * binding of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {*} value The value to wrap.
     * @param {Function} [wrapper=identity] The wrapper function.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var p = _.wrap(_.escape, function(func, text) {
     *   return '<p>' + func(text) + '</p>';
     * });
     *
     * p('fred, barney, & pebbles');
     * // => '<p>fred, barney, &amp; pebbles</p>'
     */
    function wrap(value, wrapper) {
      return partial(castFunction(wrapper), value);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Casts `value` as an array if it's not one.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Lang
     * @param {*} value The value to inspect.
     * @returns {Array} Returns the cast array.
     * @example
     *
     * _.castArray(1);
     * // => [1]
     *
     * _.castArray({ 'a': 1 });
     * // => [{ 'a': 1 }]
     *
     * _.castArray('abc');
     * // => ['abc']
     *
     * _.castArray(null);
     * // => [null]
     *
     * _.castArray(undefined);
     * // => [undefined]
     *
     * _.castArray();
     * // => []
     *
     * var array = [1, 2, 3];
     * console.log(_.castArray(array) === array);
     * // => true
     */
    function castArray() {
      if (!arguments.length) {
        return [];
      }
      var value = arguments[0];
      return isArray(value) ? value : [value];
    }

    /**
     * Creates a shallow clone of `value`.
     *
     * **Note:** This method is loosely based on the
     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
     * and supports cloning arrays, array buffers, booleans, date objects, maps,
     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
     * arrays. The own enumerable properties of `arguments` objects are cloned
     * as plain objects. An empty object is returned for uncloneable values such
     * as error objects, functions, DOM nodes, and WeakMaps.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to clone.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeep
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var shallow = _.clone(objects);
     * console.log(shallow[0] === objects[0]);
     * // => true
     */
    function clone(value) {
      return baseClone(value, CLONE_SYMBOLS_FLAG);
    }

    /**
     * This method is like `_.clone` except that it accepts `customizer` which
     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
     * cloning is handled by the method instead. The `customizer` is invoked with
     * up to four arguments; (value [, index|key, object, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeepWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(false);
     *   }
     * }
     *
     * var el = _.cloneWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 0
     */
    function cloneWith(value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
    }

    /**
     * This method is like `_.clone` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @returns {*} Returns the deep cloned value.
     * @see _.clone
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var deep = _.cloneDeep(objects);
     * console.log(deep[0] === objects[0]);
     * // => false
     */
    function cloneDeep(value) {
      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
    }

    /**
     * This method is like `_.cloneWith` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the deep cloned value.
     * @see _.cloneWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(true);
     *   }
     * }
     *
     * var el = _.cloneDeepWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 20
     */
    function cloneDeepWith(value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
    }

    /**
     * Checks if `object` conforms to `source` by invoking the predicate
     * properties of `source` with the corresponding property values of `object`.
     *
     * **Note:** This method is equivalent to `_.conforms` when `source` is
     * partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
     * // => true
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
     * // => false
     */
    function conformsTo(object, source) {
      return source == null || baseConformsTo(object, source, keys(source));
    }

    /**
     * Performs a
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * comparison between two values to determine if they are equivalent.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.eq(object, object);
     * // => true
     *
     * _.eq(object, other);
     * // => false
     *
     * _.eq('a', 'a');
     * // => true
     *
     * _.eq('a', Object('a'));
     * // => false
     *
     * _.eq(NaN, NaN);
     * // => true
     */
    function eq(value, other) {
      return value === other || (value !== value && other !== other);
    }

    /**
     * Checks if `value` is greater than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     * @see _.lt
     * @example
     *
     * _.gt(3, 1);
     * // => true
     *
     * _.gt(3, 3);
     * // => false
     *
     * _.gt(1, 3);
     * // => false
     */
    var gt = createRelationalOperation(baseGt);

    /**
     * Checks if `value` is greater than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than or equal to
     *  `other`, else `false`.
     * @see _.lte
     * @example
     *
     * _.gte(3, 1);
     * // => true
     *
     * _.gte(3, 3);
     * // => true
     *
     * _.gte(1, 3);
     * // => false
     */
    var gte = createRelationalOperation(function(value, other) {
      return value >= other;
    });

    /**
     * Checks if `value` is likely an `arguments` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     *  else `false`.
     * @example
     *
     * _.isArguments(function() { return arguments; }());
     * // => true
     *
     * _.isArguments([1, 2, 3]);
     * // => false
     */
    var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
      return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
        !propertyIsEnumerable.call(value, 'callee');
    };

    /**
     * Checks if `value` is classified as an `Array` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
     * @example
     *
     * _.isArray([1, 2, 3]);
     * // => true
     *
     * _.isArray(document.body.children);
     * // => false
     *
     * _.isArray('abc');
     * // => false
     *
     * _.isArray(_.noop);
     * // => false
     */
    var isArray = Array.isArray;

    /**
     * Checks if `value` is classified as an `ArrayBuffer` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     * @example
     *
     * _.isArrayBuffer(new ArrayBuffer(2));
     * // => true
     *
     * _.isArrayBuffer(new Array(2));
     * // => false
     */
    var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;

    /**
     * Checks if `value` is array-like. A value is considered array-like if it's
     * not a function and has a `value.length` that's an integer greater than or
     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
     * @example
     *
     * _.isArrayLike([1, 2, 3]);
     * // => true
     *
     * _.isArrayLike(document.body.children);
     * // => true
     *
     * _.isArrayLike('abc');
     * // => true
     *
     * _.isArrayLike(_.noop);
     * // => false
     */
    function isArrayLike(value) {
      return value != null && isLength(value.length) && !isFunction(value);
    }

    /**
     * This method is like `_.isArrayLike` except that it also checks if `value`
     * is an object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array-like object,
     *  else `false`.
     * @example
     *
     * _.isArrayLikeObject([1, 2, 3]);
     * // => true
     *
     * _.isArrayLikeObject(document.body.children);
     * // => true
     *
     * _.isArrayLikeObject('abc');
     * // => false
     *
     * _.isArrayLikeObject(_.noop);
     * // => false
     */
    function isArrayLikeObject(value) {
      return isObjectLike(value) && isArrayLike(value);
    }

    /**
     * Checks if `value` is classified as a boolean primitive or object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
     * @example
     *
     * _.isBoolean(false);
     * // => true
     *
     * _.isBoolean(null);
     * // => false
     */
    function isBoolean(value) {
      return value === true || value === false ||
        (isObjectLike(value) && baseGetTag(value) == boolTag);
    }

    /**
     * Checks if `value` is a buffer.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
     * @example
     *
     * _.isBuffer(new Buffer(2));
     * // => true
     *
     * _.isBuffer(new Uint8Array(2));
     * // => false
     */
    var isBuffer = nativeIsBuffer || stubFalse;

    /**
     * Checks if `value` is classified as a `Date` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     * @example
     *
     * _.isDate(new Date);
     * // => true
     *
     * _.isDate('Mon April 23 2012');
     * // => false
     */
    var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;

    /**
     * Checks if `value` is likely a DOM element.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
     * @example
     *
     * _.isElement(document.body);
     * // => true
     *
     * _.isElement('<body>');
     * // => false
     */
    function isElement(value) {
      return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
    }

    /**
     * Checks if `value` is an empty object, collection, map, or set.
     *
     * Objects are considered empty if they have no own enumerable string keyed
     * properties.
     *
     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
     * jQuery-like collections are considered empty if they have a `length` of `0`.
     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
     * @example
     *
     * _.isEmpty(null);
     * // => true
     *
     * _.isEmpty(true);
     * // => true
     *
     * _.isEmpty(1);
     * // => true
     *
     * _.isEmpty([1, 2, 3]);
     * // => false
     *
     * _.isEmpty({ 'a': 1 });
     * // => false
     */
    function isEmpty(value) {
      if (value == null) {
        return true;
      }
      if (isArrayLike(value) &&
          (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' ||
            isBuffer(value) || isTypedArray(value) || isArguments(value))) {
        return !value.length;
      }
      var tag = getTag(value);
      if (tag == mapTag || tag == setTag) {
        return !value.size;
      }
      if (isPrototype(value)) {
        return !baseKeys(value).length;
      }
      for (var key in value) {
        if (hasOwnProperty.call(value, key)) {
          return false;
        }
      }
      return true;
    }

    /**
     * Performs a deep comparison between two values to determine if they are
     * equivalent.
     *
     * **Note:** This method supports comparing arrays, array buffers, booleans,
     * date objects, error objects, maps, numbers, `Object` objects, regexes,
     * sets, strings, symbols, and typed arrays. `Object` objects are compared
     * by their own, not inherited, enumerable properties. Functions and DOM
     * nodes are compared by strict equality, i.e. `===`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.isEqual(object, other);
     * // => true
     *
     * object === other;
     * // => false
     */
    function isEqual(value, other) {
      return baseIsEqual(value, other);
    }

    /**
     * This method is like `_.isEqual` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with up to
     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, othValue) {
     *   if (isGreeting(objValue) && isGreeting(othValue)) {
     *     return true;
     *   }
     * }
     *
     * var array = ['hello', 'goodbye'];
     * var other = ['hi', 'goodbye'];
     *
     * _.isEqualWith(array, other, customizer);
     * // => true
     */
    function isEqualWith(value, other, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      var result = customizer ? customizer(value, other) : undefined;
      return result === undefined ? baseIsEqual(value, other, undefined, customizer) : !!result;
    }

    /**
     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
     * `SyntaxError`, `TypeError`, or `URIError` object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
     * @example
     *
     * _.isError(new Error);
     * // => true
     *
     * _.isError(Error);
     * // => false
     */
    function isError(value) {
      if (!isObjectLike(value)) {
        return false;
      }
      var tag = baseGetTag(value);
      return tag == errorTag || tag == domExcTag ||
        (typeof value.message == 'string' && typeof value.name == 'string' && !isPlainObject(value));
    }

    /**
     * Checks if `value` is a finite primitive number.
     *
     * **Note:** This method is based on
     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
     * @example
     *
     * _.isFinite(3);
     * // => true
     *
     * _.isFinite(Number.MIN_VALUE);
     * // => true
     *
     * _.isFinite(Infinity);
     * // => false
     *
     * _.isFinite('3');
     * // => false
     */
    function isFinite(value) {
      return typeof value == 'number' && nativeIsFinite(value);
    }

    /**
     * Checks if `value` is classified as a `Function` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
     * @example
     *
     * _.isFunction(_);
     * // => true
     *
     * _.isFunction(/abc/);
     * // => false
     */
    function isFunction(value) {
      if (!isObject(value)) {
        return false;
      }
      // The use of `Object#toString` avoids issues with the `typeof` operator
      // in Safari 9 which returns 'object' for typed arrays and other constructors.
      var tag = baseGetTag(value);
      return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
    }

    /**
     * Checks if `value` is an integer.
     *
     * **Note:** This method is based on
     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
     * @example
     *
     * _.isInteger(3);
     * // => true
     *
     * _.isInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isInteger(Infinity);
     * // => false
     *
     * _.isInteger('3');
     * // => false
     */
    function isInteger(value) {
      return typeof value == 'number' && value == toInteger(value);
    }

    /**
     * Checks if `value` is a valid array-like length.
     *
     * **Note:** This method is loosely based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
     * @example
     *
     * _.isLength(3);
     * // => true
     *
     * _.isLength(Number.MIN_VALUE);
     * // => false
     *
     * _.isLength(Infinity);
     * // => false
     *
     * _.isLength('3');
     * // => false
     */
    function isLength(value) {
      return typeof value == 'number' &&
        value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
    }

    /**
     * Checks if `value` is the
     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
     * @example
     *
     * _.isObject({});
     * // => true
     *
     * _.isObject([1, 2, 3]);
     * // => true
     *
     * _.isObject(_.noop);
     * // => true
     *
     * _.isObject(null);
     * // => false
     */
    function isObject(value) {
      var type = typeof value;
      return value != null && (type == 'object' || type == 'function');
    }

    /**
     * Checks if `value` is object-like. A value is object-like if it's not `null`
     * and has a `typeof` result of "object".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
     * @example
     *
     * _.isObjectLike({});
     * // => true
     *
     * _.isObjectLike([1, 2, 3]);
     * // => true
     *
     * _.isObjectLike(_.noop);
     * // => false
     *
     * _.isObjectLike(null);
     * // => false
     */
    function isObjectLike(value) {
      return value != null && typeof value == 'object';
    }

    /**
     * Checks if `value` is classified as a `Map` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     * @example
     *
     * _.isMap(new Map);
     * // => true
     *
     * _.isMap(new WeakMap);
     * // => false
     */
    var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;

    /**
     * Performs a partial deep comparison between `object` and `source` to
     * determine if `object` contains equivalent property values.
     *
     * **Note:** This method is equivalent to `_.matches` when `source` is
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.isMatch(object, { 'b': 2 });
     * // => true
     *
     * _.isMatch(object, { 'b': 1 });
     * // => false
     */
    function isMatch(object, source) {
      return object === source || baseIsMatch(object, source, getMatchData(source));
    }

    /**
     * This method is like `_.isMatch` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with five
     * arguments: (objValue, srcValue, index|key, object, source).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, srcValue) {
     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
     *     return true;
     *   }
     * }
     *
     * var object = { 'greeting': 'hello' };
     * var source = { 'greeting': 'hi' };
     *
     * _.isMatchWith(object, source, customizer);
     * // => true
     */
    function isMatchWith(object, source, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseIsMatch(object, source, getMatchData(source), customizer);
    }

    /**
     * Checks if `value` is `NaN`.
     *
     * **Note:** This method is based on
     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
     * `undefined` and other non-number values.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
     * @example
     *
     * _.isNaN(NaN);
     * // => true
     *
     * _.isNaN(new Number(NaN));
     * // => true
     *
     * isNaN(undefined);
     * // => true
     *
     * _.isNaN(undefined);
     * // => false
     */
    function isNaN(value) {
      // An `NaN` primitive is the only value that is not equal to itself.
      // Perform the `toStringTag` check first to avoid errors with some
      // ActiveX objects in IE.
      return isNumber(value) && value != +value;
    }

    /**
     * Checks if `value` is a pristine native function.
     *
     * **Note:** This method can't reliably detect native functions in the presence
     * of the core-js package because core-js circumvents this kind of detection.
     * Despite multiple requests, the core-js maintainer has made it clear: any
     * attempt to fix the detection will be obstructed. As a result, we're left
     * with little choice but to throw an error. Unfortunately, this also affects
     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
     * which rely on core-js.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     * @example
     *
     * _.isNative(Array.prototype.push);
     * // => true
     *
     * _.isNative(_);
     * // => false
     */
    function isNative(value) {
      if (isMaskable(value)) {
        throw new Error(CORE_ERROR_TEXT);
      }
      return baseIsNative(value);
    }

    /**
     * Checks if `value` is `null`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
     * @example
     *
     * _.isNull(null);
     * // => true
     *
     * _.isNull(void 0);
     * // => false
     */
    function isNull(value) {
      return value === null;
    }

    /**
     * Checks if `value` is `null` or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
     * @example
     *
     * _.isNil(null);
     * // => true
     *
     * _.isNil(void 0);
     * // => true
     *
     * _.isNil(NaN);
     * // => false
     */
    function isNil(value) {
      return value == null;
    }

    /**
     * Checks if `value` is classified as a `Number` primitive or object.
     *
     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
     * classified as numbers, use the `_.isFinite` method.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
     * @example
     *
     * _.isNumber(3);
     * // => true
     *
     * _.isNumber(Number.MIN_VALUE);
     * // => true
     *
     * _.isNumber(Infinity);
     * // => true
     *
     * _.isNumber('3');
     * // => false
     */
    function isNumber(value) {
      return typeof value == 'number' ||
        (isObjectLike(value) && baseGetTag(value) == numberTag);
    }

    /**
     * Checks if `value` is a plain object, that is, an object created by the
     * `Object` constructor or one with a `[[Prototype]]` of `null`.
     *
     * @static
     * @memberOf _
     * @since 0.8.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * _.isPlainObject(new Foo);
     * // => false
     *
     * _.isPlainObject([1, 2, 3]);
     * // => false
     *
     * _.isPlainObject({ 'x': 0, 'y': 0 });
     * // => true
     *
     * _.isPlainObject(Object.create(null));
     * // => true
     */
    function isPlainObject(value) {
      if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
        return false;
      }
      var proto = getPrototype(value);
      if (proto === null) {
        return true;
      }
      var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
      return typeof Ctor == 'function' && Ctor instanceof Ctor &&
        funcToString.call(Ctor) == objectCtorString;
    }

    /**
     * Checks if `value` is classified as a `RegExp` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     * @example
     *
     * _.isRegExp(/abc/);
     * // => true
     *
     * _.isRegExp('/abc/');
     * // => false
     */
    var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;

    /**
     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
     * double precision number which isn't the result of a rounded unsafe integer.
     *
     * **Note:** This method is based on
     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
     * @example
     *
     * _.isSafeInteger(3);
     * // => true
     *
     * _.isSafeInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isSafeInteger(Infinity);
     * // => false
     *
     * _.isSafeInteger('3');
     * // => false
     */
    function isSafeInteger(value) {
      return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
    }

    /**
     * Checks if `value` is classified as a `Set` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     * @example
     *
     * _.isSet(new Set);
     * // => true
     *
     * _.isSet(new WeakSet);
     * // => false
     */
    var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;

    /**
     * Checks if `value` is classified as a `String` primitive or object.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
     * @example
     *
     * _.isString('abc');
     * // => true
     *
     * _.isString(1);
     * // => false
     */
    function isString(value) {
      return typeof value == 'string' ||
        (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
    }

    /**
     * Checks if `value` is classified as a `Symbol` primitive or object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
     * @example
     *
     * _.isSymbol(Symbol.iterator);
     * // => true
     *
     * _.isSymbol('abc');
     * // => false
     */
    function isSymbol(value) {
      return typeof value == 'symbol' ||
        (isObjectLike(value) && baseGetTag(value) == symbolTag);
    }

    /**
     * Checks if `value` is classified as a typed array.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     * @example
     *
     * _.isTypedArray(new Uint8Array);
     * // => true
     *
     * _.isTypedArray([]);
     * // => false
     */
    var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

    /**
     * Checks if `value` is `undefined`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
     * @example
     *
     * _.isUndefined(void 0);
     * // => true
     *
     * _.isUndefined(null);
     * // => false
     */
    function isUndefined(value) {
      return value === undefined;
    }

    /**
     * Checks if `value` is classified as a `WeakMap` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
     * @example
     *
     * _.isWeakMap(new WeakMap);
     * // => true
     *
     * _.isWeakMap(new Map);
     * // => false
     */
    function isWeakMap(value) {
      return isObjectLike(value) && getTag(value) == weakMapTag;
    }

    /**
     * Checks if `value` is classified as a `WeakSet` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
     * @example
     *
     * _.isWeakSet(new WeakSet);
     * // => true
     *
     * _.isWeakSet(new Set);
     * // => false
     */
    function isWeakSet(value) {
      return isObjectLike(value) && baseGetTag(value) == weakSetTag;
    }

    /**
     * Checks if `value` is less than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     * @see _.gt
     * @example
     *
     * _.lt(1, 3);
     * // => true
     *
     * _.lt(3, 3);
     * // => false
     *
     * _.lt(3, 1);
     * // => false
     */
    var lt = createRelationalOperation(baseLt);

    /**
     * Checks if `value` is less than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than or equal to
     *  `other`, else `false`.
     * @see _.gte
     * @example
     *
     * _.lte(1, 3);
     * // => true
     *
     * _.lte(3, 3);
     * // => true
     *
     * _.lte(3, 1);
     * // => false
     */
    var lte = createRelationalOperation(function(value, other) {
      return value <= other;
    });

    /**
     * Converts `value` to an array.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Array} Returns the converted array.
     * @example
     *
     * _.toArray({ 'a': 1, 'b': 2 });
     * // => [1, 2]
     *
     * _.toArray('abc');
     * // => ['a', 'b', 'c']
     *
     * _.toArray(1);
     * // => []
     *
     * _.toArray(null);
     * // => []
     */
    function toArray(value) {
      if (!value) {
        return [];
      }
      if (isArrayLike(value)) {
        return isString(value) ? stringToArray(value) : copyArray(value);
      }
      if (symIterator && value[symIterator]) {
        return iteratorToArray(value[symIterator]());
      }
      var tag = getTag(value),
          func = tag == mapTag ? mapToArray : (tag == setTag ? setToArray : values);

      return func(value);
    }

    /**
     * Converts `value` to a finite number.
     *
     * @static
     * @memberOf _
     * @since 4.12.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted number.
     * @example
     *
     * _.toFinite(3.2);
     * // => 3.2
     *
     * _.toFinite(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toFinite(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toFinite('3.2');
     * // => 3.2
     */
    function toFinite(value) {
      if (!value) {
        return value === 0 ? value : 0;
      }
      value = toNumber(value);
      if (value === INFINITY || value === -INFINITY) {
        var sign = (value < 0 ? -1 : 1);
        return sign * MAX_INTEGER;
      }
      return value === value ? value : 0;
    }

    /**
     * Converts `value` to an integer.
     *
     * **Note:** This method is loosely based on
     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toInteger(3.2);
     * // => 3
     *
     * _.toInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toInteger(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toInteger('3.2');
     * // => 3
     */
    function toInteger(value) {
      var result = toFinite(value),
          remainder = result % 1;

      return result === result ? (remainder ? result - remainder : result) : 0;
    }

    /**
     * Converts `value` to an integer suitable for use as the length of an
     * array-like object.
     *
     * **Note:** This method is based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toLength(3.2);
     * // => 3
     *
     * _.toLength(Number.MIN_VALUE);
     * // => 0
     *
     * _.toLength(Infinity);
     * // => 4294967295
     *
     * _.toLength('3.2');
     * // => 3
     */
    function toLength(value) {
      return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
    }

    /**
     * Converts `value` to a number.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     * @example
     *
     * _.toNumber(3.2);
     * // => 3.2
     *
     * _.toNumber(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toNumber(Infinity);
     * // => Infinity
     *
     * _.toNumber('3.2');
     * // => 3.2
     */
    function toNumber(value) {
      if (typeof value == 'number') {
        return value;
      }
      if (isSymbol(value)) {
        return NAN;
      }
      if (isObject(value)) {
        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
        value = isObject(other) ? (other + '') : other;
      }
      if (typeof value != 'string') {
        return value === 0 ? value : +value;
      }
      value = value.replace(reTrim, '');
      var isBinary = reIsBinary.test(value);
      return (isBinary || reIsOctal.test(value))
        ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
        : (reIsBadHex.test(value) ? NAN : +value);
    }

    /**
     * Converts `value` to a plain object flattening inherited enumerable string
     * keyed properties of `value` to own properties of the plain object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Object} Returns the converted plain object.
     * @example
     *
     * function Foo() {
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.assign({ 'a': 1 }, new Foo);
     * // => { 'a': 1, 'b': 2 }
     *
     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
     * // => { 'a': 1, 'b': 2, 'c': 3 }
     */
    function toPlainObject(value) {
      return copyObject(value, keysIn(value));
    }

    /**
     * Converts `value` to a safe integer. A safe integer can be compared and
     * represented correctly.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toSafeInteger(3.2);
     * // => 3
     *
     * _.toSafeInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toSafeInteger(Infinity);
     * // => 9007199254740991
     *
     * _.toSafeInteger('3.2');
     * // => 3
     */
    function toSafeInteger(value) {
      return value
        ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER)
        : (value === 0 ? value : 0);
    }

    /**
     * Converts `value` to a string. An empty string is returned for `null`
     * and `undefined` values. The sign of `-0` is preserved.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.toString(null);
     * // => ''
     *
     * _.toString(-0);
     * // => '-0'
     *
     * _.toString([1, 2, 3]);
     * // => '1,2,3'
     */
    function toString(value) {
      return value == null ? '' : baseToString(value);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Assigns own enumerable string keyed properties of source objects to the
     * destination object. Source objects are applied from left to right.
     * Subsequent sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object` and is loosely based on
     * [`Object.assign`](https://mdn.io/Object/assign).
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assignIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assign({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'c': 3 }
     */
    var assign = createAssigner(function(object, source) {
      if (isPrototype(source) || isArrayLike(source)) {
        copyObject(source, keys(source), object);
        return;
      }
      for (var key in source) {
        if (hasOwnProperty.call(source, key)) {
          assignValue(object, key, source[key]);
        }
      }
    });

    /**
     * This method is like `_.assign` except that it iterates over own and
     * inherited source properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extend
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assign
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
     */
    var assignIn = createAssigner(function(object, source) {
      copyObject(source, keysIn(source), object);
    });

    /**
     * This method is like `_.assignIn` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extendWith
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignInWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
      copyObject(source, keysIn(source), object, customizer);
    });

    /**
     * This method is like `_.assign` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignInWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
      copyObject(source, keys(source), object, customizer);
    });

    /**
     * Creates an array of values corresponding to `paths` of `object`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Array} Returns the picked values.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _.at(object, ['a[0].b.c', 'a[1]']);
     * // => [3, 4]
     */
    var at = flatRest(baseAt);

    /**
     * Creates an object that inherits from the `prototype` object. If a
     * `properties` object is given, its own enumerable string keyed properties
     * are assigned to the created object.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Object
     * @param {Object} prototype The object to inherit from.
     * @param {Object} [properties] The properties to assign to the object.
     * @returns {Object} Returns the new object.
     * @example
     *
     * function Shape() {
     *   this.x = 0;
     *   this.y = 0;
     * }
     *
     * function Circle() {
     *   Shape.call(this);
     * }
     *
     * Circle.prototype = _.create(Shape.prototype, {
     *   'constructor': Circle
     * });
     *
     * var circle = new Circle;
     * circle instanceof Circle;
     * // => true
     *
     * circle instanceof Shape;
     * // => true
     */
    function create(prototype, properties) {
      var result = baseCreate(prototype);
      return properties == null ? result : baseAssign(result, properties);
    }

    /**
     * Assigns own and inherited enumerable string keyed properties of source
     * objects to the destination object for all destination properties that
     * resolve to `undefined`. Source objects are applied from left to right.
     * Once a property is set, additional values of the same property are ignored.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaultsDeep
     * @example
     *
     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var defaults = baseRest(function(object, sources) {
      object = Object(object);

      var index = -1;
      var length = sources.length;
      var guard = length > 2 ? sources[2] : undefined;

      if (guard && isIterateeCall(sources[0], sources[1], guard)) {
        length = 1;
      }

      while (++index < length) {
        var source = sources[index];
        var props = keysIn(source);
        var propsIndex = -1;
        var propsLength = props.length;

        while (++propsIndex < propsLength) {
          var key = props[propsIndex];
          var value = object[key];

          if (value === undefined ||
              (eq(value, objectProto[key]) && !hasOwnProperty.call(object, key))) {
            object[key] = source[key];
          }
        }
      }

      return object;
    });

    /**
     * This method is like `_.defaults` except that it recursively assigns
     * default properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaults
     * @example
     *
     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
     * // => { 'a': { 'b': 2, 'c': 3 } }
     */
    var defaultsDeep = baseRest(function(args) {
      args.push(undefined, customDefaultsMerge);
      return apply(mergeWith, undefined, args);
    });

    /**
     * This method is like `_.find` except that it returns the key of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findKey(users, function(o) { return o.age < 40; });
     * // => 'barney' (iteration order is not guaranteed)
     *
     * // The `_.matches` iteratee shorthand.
     * _.findKey(users, { 'age': 1, 'active': true });
     * // => 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findKey(users, 'active');
     * // => 'barney'
     */
    function findKey(object, predicate) {
      return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
    }

    /**
     * This method is like `_.findKey` except that it iterates over elements of
     * a collection in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findLastKey(users, function(o) { return o.age < 40; });
     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastKey(users, { 'age': 36, 'active': true });
     * // => 'barney'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastKey(users, 'active');
     * // => 'pebbles'
     */
    function findLastKey(object, predicate) {
      return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
    }

    /**
     * Iterates over own and inherited enumerable string keyed properties of an
     * object and invokes `iteratee` for each property. The iteratee is invoked
     * with three arguments: (value, key, object). Iteratee functions may exit
     * iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forInRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forIn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
     */
    function forIn(object, iteratee) {
      return object == null
        ? object
        : baseFor(object, getIteratee(iteratee, 3), keysIn);
    }

    /**
     * This method is like `_.forIn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forInRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
     */
    function forInRight(object, iteratee) {
      return object == null
        ? object
        : baseForRight(object, getIteratee(iteratee, 3), keysIn);
    }

    /**
     * Iterates over own enumerable string keyed properties of an object and
     * invokes `iteratee` for each property. The iteratee is invoked with three
     * arguments: (value, key, object). Iteratee functions may exit iteration
     * early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwnRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */
    function forOwn(object, iteratee) {
      return object && baseForOwn(object, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.forOwn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwnRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
     */
    function forOwnRight(object, iteratee) {
      return object && baseForOwnRight(object, getIteratee(iteratee, 3));
    }

    /**
     * Creates an array of function property names from own enumerable properties
     * of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functionsIn
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functions(new Foo);
     * // => ['a', 'b']
     */
    function functions(object) {
      return object == null ? [] : baseFunctions(object, keys(object));
    }

    /**
     * Creates an array of function property names from own and inherited
     * enumerable properties of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functions
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functionsIn(new Foo);
     * // => ['a', 'b', 'c']
     */
    function functionsIn(object) {
      return object == null ? [] : baseFunctions(object, keysIn(object));
    }

    /**
     * Gets the value at `path` of `object`. If the resolved value is
     * `undefined`, the `defaultValue` is returned in its place.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.get(object, 'a[0].b.c');
     * // => 3
     *
     * _.get(object, ['a', '0', 'b', 'c']);
     * // => 3
     *
     * _.get(object, 'a.b.c', 'default');
     * // => 'default'
     */
    function get(object, path, defaultValue) {
      var result = object == null ? undefined : baseGet(object, path);
      return result === undefined ? defaultValue : result;
    }

    /**
     * Checks if `path` is a direct property of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = { 'a': { 'b': 2 } };
     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.has(object, 'a');
     * // => true
     *
     * _.has(object, 'a.b');
     * // => true
     *
     * _.has(object, ['a', 'b']);
     * // => true
     *
     * _.has(other, 'a');
     * // => false
     */
    function has(object, path) {
      return object != null && hasPath(object, path, baseHas);
    }

    /**
     * Checks if `path` is a direct or inherited property of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.hasIn(object, 'a');
     * // => true
     *
     * _.hasIn(object, 'a.b');
     * // => true
     *
     * _.hasIn(object, ['a', 'b']);
     * // => true
     *
     * _.hasIn(object, 'b');
     * // => false
     */
    function hasIn(object, path) {
      return object != null && hasPath(object, path, baseHasIn);
    }

    /**
     * Creates an object composed of the inverted keys and values of `object`.
     * If `object` contains duplicate values, subsequent values overwrite
     * property assignments of previous values.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Object
     * @param {Object} object The object to invert.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invert(object);
     * // => { '1': 'c', '2': 'b' }
     */
    var invert = createInverter(function(result, value, key) {
      if (value != null &&
          typeof value.toString != 'function') {
        value = nativeObjectToString.call(value);
      }

      result[value] = key;
    }, constant(identity));

    /**
     * This method is like `_.invert` except that the inverted object is generated
     * from the results of running each element of `object` thru `iteratee`. The
     * corresponding inverted value of each inverted key is an array of keys
     * responsible for generating the inverted value. The iteratee is invoked
     * with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Object
     * @param {Object} object The object to invert.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invertBy(object);
     * // => { '1': ['a', 'c'], '2': ['b'] }
     *
     * _.invertBy(object, function(value) {
     *   return 'group' + value;
     * });
     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
     */
    var invertBy = createInverter(function(result, value, key) {
      if (value != null &&
          typeof value.toString != 'function') {
        value = nativeObjectToString.call(value);
      }

      if (hasOwnProperty.call(result, value)) {
        result[value].push(key);
      } else {
        result[value] = [key];
      }
    }, getIteratee);

    /**
     * Invokes the method at `path` of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
     *
     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
     * // => [2, 3]
     */
    var invoke = baseRest(baseInvoke);

    /**
     * Creates an array of the own enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects. See the
     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * for more details.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keys(new Foo);
     * // => ['a', 'b'] (iteration order is not guaranteed)
     *
     * _.keys('hi');
     * // => ['0', '1']
     */
    function keys(object) {
      return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
    }

    /**
     * Creates an array of the own and inherited enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keysIn(new Foo);
     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
     */
    function keysIn(object) {
      return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
    }

    /**
     * The opposite of `_.mapValues`; this method creates an object with the
     * same values as `object` and keys generated by running each own enumerable
     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
     * with three arguments: (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapValues
     * @example
     *
     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
     *   return key + value;
     * });
     * // => { 'a1': 1, 'b2': 2 }
     */
    function mapKeys(object, iteratee) {
      var result = {};
      iteratee = getIteratee(iteratee, 3);

      baseForOwn(object, function(value, key, object) {
        baseAssignValue(result, iteratee(value, key, object), value);
      });
      return result;
    }

    /**
     * Creates an object with the same keys as `object` and values generated
     * by running each own enumerable string keyed property of `object` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapKeys
     * @example
     *
     * var users = {
     *   'fred':    { 'user': 'fred',    'age': 40 },
     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
     * };
     *
     * _.mapValues(users, function(o) { return o.age; });
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     *
     * // The `_.property` iteratee shorthand.
     * _.mapValues(users, 'age');
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     */
    function mapValues(object, iteratee) {
      var result = {};
      iteratee = getIteratee(iteratee, 3);

      baseForOwn(object, function(value, key, object) {
        baseAssignValue(result, key, iteratee(value, key, object));
      });
      return result;
    }

    /**
     * This method is like `_.assign` except that it recursively merges own and
     * inherited enumerable string keyed properties of source objects into the
     * destination object. Source properties that resolve to `undefined` are
     * skipped if a destination value exists. Array and plain object properties
     * are merged recursively. Other objects and value types are overridden by
     * assignment. Source objects are applied from left to right. Subsequent
     * sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {
     *   'a': [{ 'b': 2 }, { 'd': 4 }]
     * };
     *
     * var other = {
     *   'a': [{ 'c': 3 }, { 'e': 5 }]
     * };
     *
     * _.merge(object, other);
     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
     */
    var merge = createAssigner(function(object, source, srcIndex) {
      baseMerge(object, source, srcIndex);
    });

    /**
     * This method is like `_.merge` except that it accepts `customizer` which
     * is invoked to produce the merged values of the destination and source
     * properties. If `customizer` returns `undefined`, merging is handled by the
     * method instead. The `customizer` is invoked with six arguments:
     * (objValue, srcValue, key, object, source, stack).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} customizer The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   if (_.isArray(objValue)) {
     *     return objValue.concat(srcValue);
     *   }
     * }
     *
     * var object = { 'a': [1], 'b': [2] };
     * var other = { 'a': [3], 'b': [4] };
     *
     * _.mergeWith(object, other, customizer);
     * // => { 'a': [1, 3], 'b': [2, 4] }
     */
    var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
      baseMerge(object, source, srcIndex, customizer);
    });

    /**
     * The opposite of `_.pick`; this method creates an object composed of the
     * own and inherited enumerable property paths of `object` that are not omitted.
     *
     * **Note:** This method is considerably slower than `_.pick`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to omit.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omit(object, ['a', 'c']);
     * // => { 'b': '2' }
     */
    var omit = flatRest(function(object, paths) {
      var result = {};
      if (object == null) {
        return result;
      }
      var isDeep = false;
      paths = arrayMap(paths, function(path) {
        path = castPath(path, object);
        isDeep || (isDeep = path.length > 1);
        return path;
      });
      copyObject(object, getAllKeysIn(object), result);
      if (isDeep) {
        result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
      }
      var length = paths.length;
      while (length--) {
        baseUnset(result, paths[length]);
      }
      return result;
    });

    /**
     * The opposite of `_.pickBy`; this method creates an object composed of
     * the own and inherited enumerable string keyed properties of `object` that
     * `predicate` doesn't return truthy for. The predicate is invoked with two
     * arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omitBy(object, _.isNumber);
     * // => { 'b': '2' }
     */
    function omitBy(object, predicate) {
      return pickBy(object, negate(getIteratee(predicate)));
    }

    /**
     * Creates an object composed of the picked `object` properties.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pick(object, ['a', 'c']);
     * // => { 'a': 1, 'c': 3 }
     */
    var pick = flatRest(function(object, paths) {
      return object == null ? {} : basePick(object, paths);
    });

    /**
     * Creates an object composed of the `object` properties `predicate` returns
     * truthy for. The predicate is invoked with two arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pickBy(object, _.isNumber);
     * // => { 'a': 1, 'c': 3 }
     */
    function pickBy(object, predicate) {
      if (object == null) {
        return {};
      }
      var props = arrayMap(getAllKeysIn(object), function(prop) {
        return [prop];
      });
      predicate = getIteratee(predicate);
      return basePickBy(object, props, function(value, path) {
        return predicate(value, path[0]);
      });
    }

    /**
     * This method is like `_.get` except that if the resolved value is a
     * function it's invoked with the `this` binding of its parent object and
     * its result is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to resolve.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
     *
     * _.result(object, 'a[0].b.c1');
     * // => 3
     *
     * _.result(object, 'a[0].b.c2');
     * // => 4
     *
     * _.result(object, 'a[0].b.c3', 'default');
     * // => 'default'
     *
     * _.result(object, 'a[0].b.c3', _.constant('default'));
     * // => 'default'
     */
    function result(object, path, defaultValue) {
      path = castPath(path, object);

      var index = -1,
          length = path.length;

      // Ensure the loop is entered when path is empty.
      if (!length) {
        length = 1;
        object = undefined;
      }
      while (++index < length) {
        var value = object == null ? undefined : object[toKey(path[index])];
        if (value === undefined) {
          index = length;
          value = defaultValue;
        }
        object = isFunction(value) ? value.call(object) : value;
      }
      return object;
    }

    /**
     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
     * it's created. Arrays are created for missing index properties while objects
     * are created for all other missing properties. Use `_.setWith` to customize
     * `path` creation.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.set(object, 'a[0].b.c', 4);
     * console.log(object.a[0].b.c);
     * // => 4
     *
     * _.set(object, ['x', '0', 'y', 'z'], 5);
     * console.log(object.x[0].y.z);
     * // => 5
     */
    function set(object, path, value) {
      return object == null ? object : baseSet(object, path, value);
    }

    /**
     * This method is like `_.set` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.setWith(object, '[0][1]', 'a', Object);
     * // => { '0': { '1': 'a' } }
     */
    function setWith(object, path, value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return object == null ? object : baseSet(object, path, value, customizer);
    }

    /**
     * Creates an array of own enumerable string keyed-value pairs for `object`
     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
     * entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entries
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairs(new Foo);
     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
     */
    var toPairs = createToPairs(keys);

    /**
     * Creates an array of own and inherited enumerable string keyed-value pairs
     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
     * or set, its entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entriesIn
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairsIn(new Foo);
     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
     */
    var toPairsIn = createToPairs(keysIn);

    /**
     * An alternative to `_.reduce`; this method transforms `object` to a new
     * `accumulator` object which is the result of running each of its own
     * enumerable string keyed properties thru `iteratee`, with each invocation
     * potentially mutating the `accumulator` object. If `accumulator` is not
     * provided, a new object with the same `[[Prototype]]` will be used. The
     * iteratee is invoked with four arguments: (accumulator, value, key, object).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The custom accumulator value.
     * @returns {*} Returns the accumulated value.
     * @example
     *
     * _.transform([2, 3, 4], function(result, n) {
     *   result.push(n *= n);
     *   return n % 2 == 0;
     * }, []);
     * // => [4, 9]
     *
     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] }
     */
    function transform(object, iteratee, accumulator) {
      var isArr = isArray(object),
          isArrLike = isArr || isBuffer(object) || isTypedArray(object);

      iteratee = getIteratee(iteratee, 4);
      if (accumulator == null) {
        var Ctor = object && object.constructor;
        if (isArrLike) {
          accumulator = isArr ? new Ctor : [];
        }
        else if (isObject(object)) {
          accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
        }
        else {
          accumulator = {};
        }
      }
      (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
        return iteratee(accumulator, value, index, object);
      });
      return accumulator;
    }

    /**
     * Removes the property at `path` of `object`.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
     * _.unset(object, 'a[0].b.c');
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     *
     * _.unset(object, ['a', '0', 'b', 'c']);
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     */
    function unset(object, path) {
      return object == null ? true : baseUnset(object, path);
    }

    /**
     * This method is like `_.set` except that accepts `updater` to produce the
     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
     * is invoked with one argument: (value).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
     * console.log(object.a[0].b.c);
     * // => 9
     *
     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
     * console.log(object.x[0].y.z);
     * // => 0
     */
    function update(object, path, updater) {
      return object == null ? object : baseUpdate(object, path, castFunction(updater));
    }

    /**
     * This method is like `_.update` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
     * // => { '0': { '1': 'a' } }
     */
    function updateWith(object, path, updater, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
    }

    /**
     * Creates an array of the own enumerable string keyed property values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.values(new Foo);
     * // => [1, 2] (iteration order is not guaranteed)
     *
     * _.values('hi');
     * // => ['h', 'i']
     */
    function values(object) {
      return object == null ? [] : baseValues(object, keys(object));
    }

    /**
     * Creates an array of the own and inherited enumerable string keyed property
     * values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.valuesIn(new Foo);
     * // => [1, 2, 3] (iteration order is not guaranteed)
     */
    function valuesIn(object) {
      return object == null ? [] : baseValues(object, keysIn(object));
    }

    /*------------------------------------------------------------------------*/

    /**
     * Clamps `number` within the inclusive `lower` and `upper` bounds.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Number
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     * @example
     *
     * _.clamp(-10, -5, 5);
     * // => -5
     *
     * _.clamp(10, -5, 5);
     * // => 5
     */
    function clamp(number, lower, upper) {
      if (upper === undefined) {
        upper = lower;
        lower = undefined;
      }
      if (upper !== undefined) {
        upper = toNumber(upper);
        upper = upper === upper ? upper : 0;
      }
      if (lower !== undefined) {
        lower = toNumber(lower);
        lower = lower === lower ? lower : 0;
      }
      return baseClamp(toNumber(number), lower, upper);
    }

    /**
     * Checks if `n` is between `start` and up to, but not including, `end`. If
     * `end` is not specified, it's set to `start` with `start` then set to `0`.
     * If `start` is greater than `end` the params are swapped to support
     * negative ranges.
     *
     * @static
     * @memberOf _
     * @since 3.3.0
     * @category Number
     * @param {number} number The number to check.
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     * @see _.range, _.rangeRight
     * @example
     *
     * _.inRange(3, 2, 4);
     * // => true
     *
     * _.inRange(4, 8);
     * // => true
     *
     * _.inRange(4, 2);
     * // => false
     *
     * _.inRange(2, 2);
     * // => false
     *
     * _.inRange(1.2, 2);
     * // => true
     *
     * _.inRange(5.2, 4);
     * // => false
     *
     * _.inRange(-3, -2, -6);
     * // => true
     */
    function inRange(number, start, end) {
      start = toFinite(start);
      if (end === undefined) {
        end = start;
        start = 0;
      } else {
        end = toFinite(end);
      }
      number = toNumber(number);
      return baseInRange(number, start, end);
    }

    /**
     * Produces a random number between the inclusive `lower` and `upper` bounds.
     * If only one argument is provided a number between `0` and the given number
     * is returned. If `floating` is `true`, or either `lower` or `upper` are
     * floats, a floating-point number is returned instead of an integer.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Number
     * @param {number} [lower=0] The lower bound.
     * @param {number} [upper=1] The upper bound.
     * @param {boolean} [floating] Specify returning a floating-point number.
     * @returns {number} Returns the random number.
     * @example
     *
     * _.random(0, 5);
     * // => an integer between 0 and 5
     *
     * _.random(5);
     * // => also an integer between 0 and 5
     *
     * _.random(5, true);
     * // => a floating-point number between 0 and 5
     *
     * _.random(1.2, 5.2);
     * // => a floating-point number between 1.2 and 5.2
     */
    function random(lower, upper, floating) {
      if (floating && typeof floating != 'boolean' && isIterateeCall(lower, upper, floating)) {
        upper = floating = undefined;
      }
      if (floating === undefined) {
        if (typeof upper == 'boolean') {
          floating = upper;
          upper = undefined;
        }
        else if (typeof lower == 'boolean') {
          floating = lower;
          lower = undefined;
        }
      }
      if (lower === undefined && upper === undefined) {
        lower = 0;
        upper = 1;
      }
      else {
        lower = toFinite(lower);
        if (upper === undefined) {
          upper = lower;
          lower = 0;
        } else {
          upper = toFinite(upper);
        }
      }
      if (lower > upper) {
        var temp = lower;
        lower = upper;
        upper = temp;
      }
      if (floating || lower % 1 || upper % 1) {
        var rand = nativeRandom();
        return nativeMin(lower + (rand * (upper - lower + freeParseFloat('1e-' + ((rand + '').length - 1)))), upper);
      }
      return baseRandom(lower, upper);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the camel cased string.
     * @example
     *
     * _.camelCase('Foo Bar');
     * // => 'fooBar'
     *
     * _.camelCase('--foo-bar--');
     * // => 'fooBar'
     *
     * _.camelCase('__FOO_BAR__');
     * // => 'fooBar'
     */
    var camelCase = createCompounder(function(result, word, index) {
      word = word.toLowerCase();
      return result + (index ? capitalize(word) : word);
    });

    /**
     * Converts the first character of `string` to upper case and the remaining
     * to lower case.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to capitalize.
     * @returns {string} Returns the capitalized string.
     * @example
     *
     * _.capitalize('FRED');
     * // => 'Fred'
     */
    function capitalize(string) {
      return upperFirst(toString(string).toLowerCase());
    }

    /**
     * Deburrs `string` by converting
     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
     * letters to basic Latin letters and removing
     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to deburr.
     * @returns {string} Returns the deburred string.
     * @example
     *
     * _.deburr('déjà vu');
     * // => 'deja vu'
     */
    function deburr(string) {
      string = toString(string);
      return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
    }

    /**
     * Checks if `string` ends with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=string.length] The position to search up to.
     * @returns {boolean} Returns `true` if `string` ends with `target`,
     *  else `false`.
     * @example
     *
     * _.endsWith('abc', 'c');
     * // => true
     *
     * _.endsWith('abc', 'b');
     * // => false
     *
     * _.endsWith('abc', 'b', 2);
     * // => true
     */
    function endsWith(string, target, position) {
      string = toString(string);
      target = baseToString(target);

      var length = string.length;
      position = position === undefined
        ? length
        : baseClamp(toInteger(position), 0, length);

      var end = position;
      position -= target.length;
      return position >= 0 && string.slice(position, end) == target;
    }

    /**
     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
     * corresponding HTML entities.
     *
     * **Note:** No other characters are escaped. To escape additional
     * characters use a third-party library like [_he_](https://mths.be/he).
     *
     * Though the ">" character is escaped for symmetry, characters like
     * ">" and "/" don't need escaping in HTML and have no special meaning
     * unless they're part of a tag or unquoted attribute value. See
     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
     * (under "semi-related fun fact") for more details.
     *
     * When working with HTML you should always
     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
     * XSS vectors.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escape('fred, barney, & pebbles');
     * // => 'fred, barney, &amp; pebbles'
     */
    function escape(string) {
      string = toString(string);
      return (string && reHasUnescapedHtml.test(string))
        ? string.replace(reUnescapedHtml, escapeHtmlChar)
        : string;
    }

    /**
     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escapeRegExp('[lodash](https://lodash.com/)');
     * // => '\[lodash\]\(https://lodash\.com/\)'
     */
    function escapeRegExp(string) {
      string = toString(string);
      return (string && reHasRegExpChar.test(string))
        ? string.replace(reRegExpChar, '\\$&')
        : string;
    }

    /**
     * Converts `string` to
     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the kebab cased string.
     * @example
     *
     * _.kebabCase('Foo Bar');
     * // => 'foo-bar'
     *
     * _.kebabCase('fooBar');
     * // => 'foo-bar'
     *
     * _.kebabCase('__FOO_BAR__');
     * // => 'foo-bar'
     */
    var kebabCase = createCompounder(function(result, word, index) {
      return result + (index ? '-' : '') + word.toLowerCase();
    });

    /**
     * Converts `string`, as space separated words, to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.lowerCase('--Foo-Bar--');
     * // => 'foo bar'
     *
     * _.lowerCase('fooBar');
     * // => 'foo bar'
     *
     * _.lowerCase('__FOO_BAR__');
     * // => 'foo bar'
     */
    var lowerCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + word.toLowerCase();
    });

    /**
     * Converts the first character of `string` to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.lowerFirst('Fred');
     * // => 'fred'
     *
     * _.lowerFirst('FRED');
     * // => 'fRED'
     */
    var lowerFirst = createCaseFirst('toLowerCase');

    /**
     * Pads `string` on the left and right sides if it's shorter than `length`.
     * Padding characters are truncated if they can't be evenly divided by `length`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.pad('abc', 8);
     * // => '  abc   '
     *
     * _.pad('abc', 8, '_-');
     * // => '_-abc_-_'
     *
     * _.pad('abc', 3);
     * // => 'abc'
     */
    function pad(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      if (!length || strLength >= length) {
        return string;
      }
      var mid = (length - strLength) / 2;
      return (
        createPadding(nativeFloor(mid), chars) +
        string +
        createPadding(nativeCeil(mid), chars)
      );
    }

    /**
     * Pads `string` on the right side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padEnd('abc', 6);
     * // => 'abc   '
     *
     * _.padEnd('abc', 6, '_-');
     * // => 'abc_-_'
     *
     * _.padEnd('abc', 3);
     * // => 'abc'
     */
    function padEnd(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      return (length && strLength < length)
        ? (string + createPadding(length - strLength, chars))
        : string;
    }

    /**
     * Pads `string` on the left side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padStart('abc', 6);
     * // => '   abc'
     *
     * _.padStart('abc', 6, '_-');
     * // => '_-_abc'
     *
     * _.padStart('abc', 3);
     * // => 'abc'
     */
    function padStart(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      return (length && strLength < length)
        ? (createPadding(length - strLength, chars) + string)
        : string;
    }

    /**
     * Converts `string` to an integer of the specified radix. If `radix` is
     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
     * hexadecimal, in which case a `radix` of `16` is used.
     *
     * **Note:** This method aligns with the
     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category String
     * @param {string} string The string to convert.
     * @param {number} [radix=10] The radix to interpret `value` by.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.parseInt('08');
     * // => 8
     *
     * _.map(['6', '08', '10'], _.parseInt);
     * // => [6, 8, 10]
     */
    function parseInt(string, radix, guard) {
      if (guard || radix == null) {
        radix = 0;
      } else if (radix) {
        radix = +radix;
      }
      return nativeParseInt(toString(string).replace(reTrimStart, ''), radix || 0);
    }

    /**
     * Repeats the given string `n` times.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to repeat.
     * @param {number} [n=1] The number of times to repeat the string.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the repeated string.
     * @example
     *
     * _.repeat('*', 3);
     * // => '***'
     *
     * _.repeat('abc', 2);
     * // => 'abcabc'
     *
     * _.repeat('abc', 0);
     * // => ''
     */
    function repeat(string, n, guard) {
      if ((guard ? isIterateeCall(string, n, guard) : n === undefined)) {
        n = 1;
      } else {
        n = toInteger(n);
      }
      return baseRepeat(toString(string), n);
    }

    /**
     * Replaces matches for `pattern` in `string` with `replacement`.
     *
     * **Note:** This method is based on
     * [`String#replace`](https://mdn.io/String/replace).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to modify.
     * @param {RegExp|string} pattern The pattern to replace.
     * @param {Function|string} replacement The match replacement.
     * @returns {string} Returns the modified string.
     * @example
     *
     * _.replace('Hi Fred', 'Fred', 'Barney');
     * // => 'Hi Barney'
     */
    function replace() {
      var args = arguments,
          string = toString(args[0]);

      return args.length < 3 ? string : string.replace(args[1], args[2]);
    }

    /**
     * Converts `string` to
     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the snake cased string.
     * @example
     *
     * _.snakeCase('Foo Bar');
     * // => 'foo_bar'
     *
     * _.snakeCase('fooBar');
     * // => 'foo_bar'
     *
     * _.snakeCase('--FOO-BAR--');
     * // => 'foo_bar'
     */
    var snakeCase = createCompounder(function(result, word, index) {
      return result + (index ? '_' : '') + word.toLowerCase();
    });

    /**
     * Splits `string` by `separator`.
     *
     * **Note:** This method is based on
     * [`String#split`](https://mdn.io/String/split).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to split.
     * @param {RegExp|string} separator The separator pattern to split by.
     * @param {number} [limit] The length to truncate results to.
     * @returns {Array} Returns the string segments.
     * @example
     *
     * _.split('a-b-c', '-', 2);
     * // => ['a', 'b']
     */
    function split(string, separator, limit) {
      if (limit && typeof limit != 'number' && isIterateeCall(string, separator, limit)) {
        separator = limit = undefined;
      }
      limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;
      if (!limit) {
        return [];
      }
      string = toString(string);
      if (string && (
            typeof separator == 'string' ||
            (separator != null && !isRegExp(separator))
          )) {
        separator = baseToString(separator);
        if (!separator && hasUnicode(string)) {
          return castSlice(stringToArray(string), 0, limit);
        }
      }
      return string.split(separator, limit);
    }

    /**
     * Converts `string` to
     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
     *
     * @static
     * @memberOf _
     * @since 3.1.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the start cased string.
     * @example
     *
     * _.startCase('--foo-bar--');
     * // => 'Foo Bar'
     *
     * _.startCase('fooBar');
     * // => 'Foo Bar'
     *
     * _.startCase('__FOO_BAR__');
     * // => 'FOO BAR'
     */
    var startCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + upperFirst(word);
    });

    /**
     * Checks if `string` starts with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=0] The position to search from.
     * @returns {boolean} Returns `true` if `string` starts with `target`,
     *  else `false`.
     * @example
     *
     * _.startsWith('abc', 'a');
     * // => true
     *
     * _.startsWith('abc', 'b');
     * // => false
     *
     * _.startsWith('abc', 'b', 1);
     * // => true
     */
    function startsWith(string, target, position) {
      string = toString(string);
      position = position == null
        ? 0
        : baseClamp(toInteger(position), 0, string.length);

      target = baseToString(target);
      return string.slice(position, position + target.length) == target;
    }

    /**
     * Creates a compiled template function that can interpolate data properties
     * in "interpolate" delimiters, HTML-escape interpolated data properties in
     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
     * properties may be accessed as free variables in the template. If a setting
     * object is given, it takes precedence over `_.templateSettings` values.
     *
     * **Note:** In the development build `_.template` utilizes
     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
     * for easier debugging.
     *
     * For more information on precompiling templates see
     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
     *
     * For more information on Chrome extension sandboxes see
     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The template string.
     * @param {Object} [options={}] The options object.
     * @param {RegExp} [options.escape=_.templateSettings.escape]
     *  The HTML "escape" delimiter.
     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
     *  The "evaluate" delimiter.
     * @param {Object} [options.imports=_.templateSettings.imports]
     *  An object to import into the template as free variables.
     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
     *  The "interpolate" delimiter.
     * @param {string} [options.sourceURL='lodash.templateSources[n]']
     *  The sourceURL of the compiled template.
     * @param {string} [options.variable='obj']
     *  The data object variable name.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the compiled template function.
     * @example
     *
     * // Use the "interpolate" delimiter to create a compiled template.
     * var compiled = _.template('hello <%= user %>!');
     * compiled({ 'user': 'fred' });
     * // => 'hello fred!'
     *
     * // Use the HTML "escape" delimiter to escape data property values.
     * var compiled = _.template('<b><%- value %></b>');
     * compiled({ 'value': '<script>' });
     * // => '<b>&lt;script&gt;</b>'
     *
     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the internal `print` function in "evaluate" delimiters.
     * var compiled = _.template('<% print("hello " + user); %>!');
     * compiled({ 'user': 'barney' });
     * // => 'hello barney!'
     *
     * // Use the ES template literal delimiter as an "interpolate" delimiter.
     * // Disable support by replacing the "interpolate" delimiter.
     * var compiled = _.template('hello ${ user }!');
     * compiled({ 'user': 'pebbles' });
     * // => 'hello pebbles!'
     *
     * // Use backslashes to treat delimiters as plain text.
     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
     * compiled({ 'value': 'ignored' });
     * // => '<%- value %>'
     *
     * // Use the `imports` option to import `jQuery` as `jq`.
     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
     * compiled(data);
     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
     *
     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
     * compiled.source;
     * // => function(data) {
     * //   var __t, __p = '';
     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
     * //   return __p;
     * // }
     *
     * // Use custom template delimiters.
     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
     * var compiled = _.template('hello {{ user }}!');
     * compiled({ 'user': 'mustache' });
     * // => 'hello mustache!'
     *
     * // Use the `source` property to inline compiled templates for meaningful
     * // line numbers in error messages and stack traces.
     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
     *   var JST = {\
     *     "main": ' + _.template(mainText).source + '\
     *   };\
     * ');
     */
    function template(string, options, guard) {
      // Based on John Resig's `tmpl` implementation
      // (http://ejohn.org/blog/javascript-micro-templating/)
      // and Laura Doktorova's doT.js (https://github.com/olado/doT).
      var settings = lodash.templateSettings;

      if (guard && isIterateeCall(string, options, guard)) {
        options = undefined;
      }
      string = toString(string);
      options = assignInWith({}, options, settings, customDefaultsAssignIn);

      var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn),
          importsKeys = keys(imports),
          importsValues = baseValues(imports, importsKeys);

      var isEscaping,
          isEvaluating,
          index = 0,
          interpolate = options.interpolate || reNoMatch,
          source = "__p += '";

      // Compile the regexp to match each delimiter.
      var reDelimiters = RegExp(
        (options.escape || reNoMatch).source + '|' +
        interpolate.source + '|' +
        (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' +
        (options.evaluate || reNoMatch).source + '|$'
      , 'g');

      // Use a sourceURL for easier debugging.
      // The sourceURL gets injected into the source that's eval-ed, so be careful
      // with lookup (in case of e.g. prototype pollution), and strip newlines if any.
      // A newline wouldn't be a valid sourceURL anyway, and it'd enable code injection.
      var sourceURL = '//# sourceURL=' +
        (hasOwnProperty.call(options, 'sourceURL')
          ? (options.sourceURL + '').replace(/[\r\n]/g, ' ')
          : ('lodash.templateSources[' + (++templateCounter) + ']')
        ) + '\n';

      string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
        interpolateValue || (interpolateValue = esTemplateValue);

        // Escape characters that can't be included in string literals.
        source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);

        // Replace delimiters with snippets.
        if (escapeValue) {
          isEscaping = true;
          source += "' +\n__e(" + escapeValue + ") +\n'";
        }
        if (evaluateValue) {
          isEvaluating = true;
          source += "';\n" + evaluateValue + ";\n__p += '";
        }
        if (interpolateValue) {
          source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
        }
        index = offset + match.length;

        // The JS engine embedded in Adobe products needs `match` returned in
        // order to produce the correct `offset` value.
        return match;
      });

      source += "';\n";

      // If `variable` is not specified wrap a with-statement around the generated
      // code to add the data object to the top of the scope chain.
      // Like with sourceURL, we take care to not check the option's prototype,
      // as this configuration is a code injection vector.
      var variable = hasOwnProperty.call(options, 'variable') && options.variable;
      if (!variable) {
        source = 'with (obj) {\n' + source + '\n}\n';
      }
      // Cleanup code by stripping empty strings.
      source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source)
        .replace(reEmptyStringMiddle, '$1')
        .replace(reEmptyStringTrailing, '$1;');

      // Frame code as the function body.
      source = 'function(' + (variable || 'obj') + ') {\n' +
        (variable
          ? ''
          : 'obj || (obj = {});\n'
        ) +
        "var __t, __p = ''" +
        (isEscaping
           ? ', __e = _.escape'
           : ''
        ) +
        (isEvaluating
          ? ', __j = Array.prototype.join;\n' +
            "function print() { __p += __j.call(arguments, '') }\n"
          : ';\n'
        ) +
        source +
        'return __p\n}';

      var result = attempt(function() {
        return Function(importsKeys, sourceURL + 'return ' + source)
          .apply(undefined, importsValues);
      });

      // Provide the compiled function's source by its `toString` method or
      // the `source` property as a convenience for inlining compiled templates.
      result.source = source;
      if (isError(result)) {
        throw result;
      }
      return result;
    }

    /**
     * Converts `string`, as a whole, to lower case just like
     * [String#toLowerCase](https://mdn.io/toLowerCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.toLower('--Foo-Bar--');
     * // => '--foo-bar--'
     *
     * _.toLower('fooBar');
     * // => 'foobar'
     *
     * _.toLower('__FOO_BAR__');
     * // => '__foo_bar__'
     */
    function toLower(value) {
      return toString(value).toLowerCase();
    }

    /**
     * Converts `string`, as a whole, to upper case just like
     * [String#toUpperCase](https://mdn.io/toUpperCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.toUpper('--foo-bar--');
     * // => '--FOO-BAR--'
     *
     * _.toUpper('fooBar');
     * // => 'FOOBAR'
     *
     * _.toUpper('__foo_bar__');
     * // => '__FOO_BAR__'
     */
    function toUpper(value) {
      return toString(value).toUpperCase();
    }

    /**
     * Removes leading and trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trim('  abc  ');
     * // => 'abc'
     *
     * _.trim('-_-abc-_-', '_-');
     * // => 'abc'
     *
     * _.map(['  foo  ', '  bar  '], _.trim);
     * // => ['foo', 'bar']
     */
    function trim(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return string.replace(reTrim, '');
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          chrSymbols = stringToArray(chars),
          start = charsStartIndex(strSymbols, chrSymbols),
          end = charsEndIndex(strSymbols, chrSymbols) + 1;

      return castSlice(strSymbols, start, end).join('');
    }

    /**
     * Removes trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimEnd('  abc  ');
     * // => '  abc'
     *
     * _.trimEnd('-_-abc-_-', '_-');
     * // => '-_-abc'
     */
    function trimEnd(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return string.replace(reTrimEnd, '');
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;

      return castSlice(strSymbols, 0, end).join('');
    }

    /**
     * Removes leading whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimStart('  abc  ');
     * // => 'abc  '
     *
     * _.trimStart('-_-abc-_-', '_-');
     * // => 'abc-_-'
     */
    function trimStart(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return string.replace(reTrimStart, '');
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          start = charsStartIndex(strSymbols, stringToArray(chars));

      return castSlice(strSymbols, start).join('');
    }

    /**
     * Truncates `string` if it's longer than the given maximum string length.
     * The last characters of the truncated string are replaced with the omission
     * string which defaults to "...".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to truncate.
     * @param {Object} [options={}] The options object.
     * @param {number} [options.length=30] The maximum string length.
     * @param {string} [options.omission='...'] The string to indicate text is omitted.
     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
     * @returns {string} Returns the truncated string.
     * @example
     *
     * _.truncate('hi-diddly-ho there, neighborino');
     * // => 'hi-diddly-ho there, neighbo...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': ' '
     * });
     * // => 'hi-diddly-ho there,...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': /,? +/
     * });
     * // => 'hi-diddly-ho there...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'omission': ' [...]'
     * });
     * // => 'hi-diddly-ho there, neig [...]'
     */
    function truncate(string, options) {
      var length = DEFAULT_TRUNC_LENGTH,
          omission = DEFAULT_TRUNC_OMISSION;

      if (isObject(options)) {
        var separator = 'separator' in options ? options.separator : separator;
        length = 'length' in options ? toInteger(options.length) : length;
        omission = 'omission' in options ? baseToString(options.omission) : omission;
      }
      string = toString(string);

      var strLength = string.length;
      if (hasUnicode(string)) {
        var strSymbols = stringToArray(string);
        strLength = strSymbols.length;
      }
      if (length >= strLength) {
        return string;
      }
      var end = length - stringSize(omission);
      if (end < 1) {
        return omission;
      }
      var result = strSymbols
        ? castSlice(strSymbols, 0, end).join('')
        : string.slice(0, end);

      if (separator === undefined) {
        return result + omission;
      }
      if (strSymbols) {
        end += (result.length - end);
      }
      if (isRegExp(separator)) {
        if (string.slice(end).search(separator)) {
          var match,
              substring = result;

          if (!separator.global) {
            separator = RegExp(separator.source, toString(reFlags.exec(separator)) + 'g');
          }
          separator.lastIndex = 0;
          while ((match = separator.exec(substring))) {
            var newEnd = match.index;
          }
          result = result.slice(0, newEnd === undefined ? end : newEnd);
        }
      } else if (string.indexOf(baseToString(separator), end) != end) {
        var index = result.lastIndexOf(separator);
        if (index > -1) {
          result = result.slice(0, index);
        }
      }
      return result + omission;
    }

    /**
     * The inverse of `_.escape`; this method converts the HTML entities
     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
     * their corresponding characters.
     *
     * **Note:** No other HTML entities are unescaped. To unescape additional
     * HTML entities use a third-party library like [_he_](https://mths.be/he).
     *
     * @static
     * @memberOf _
     * @since 0.6.0
     * @category String
     * @param {string} [string=''] The string to unescape.
     * @returns {string} Returns the unescaped string.
     * @example
     *
     * _.unescape('fred, barney, &amp; pebbles');
     * // => 'fred, barney, & pebbles'
     */
    function unescape(string) {
      string = toString(string);
      return (string && reHasEscapedHtml.test(string))
        ? string.replace(reEscapedHtml, unescapeHtmlChar)
        : string;
    }

    /**
     * Converts `string`, as space separated words, to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.upperCase('--foo-bar');
     * // => 'FOO BAR'
     *
     * _.upperCase('fooBar');
     * // => 'FOO BAR'
     *
     * _.upperCase('__foo_bar__');
     * // => 'FOO BAR'
     */
    var upperCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + word.toUpperCase();
    });

    /**
     * Converts the first character of `string` to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.upperFirst('fred');
     * // => 'Fred'
     *
     * _.upperFirst('FRED');
     * // => 'FRED'
     */
    var upperFirst = createCaseFirst('toUpperCase');

    /**
     * Splits `string` into an array of its words.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {RegExp|string} [pattern] The pattern to match words.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the words of `string`.
     * @example
     *
     * _.words('fred, barney, & pebbles');
     * // => ['fred', 'barney', 'pebbles']
     *
     * _.words('fred, barney, & pebbles', /[^, ]+/g);
     * // => ['fred', 'barney', '&', 'pebbles']
     */
    function words(string, pattern, guard) {
      string = toString(string);
      pattern = guard ? undefined : pattern;

      if (pattern === undefined) {
        return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
      }
      return string.match(pattern) || [];
    }

    /*------------------------------------------------------------------------*/

    /**
     * Attempts to invoke `func`, returning either the result or the caught error
     * object. Any additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Function} func The function to attempt.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {*} Returns the `func` result or error object.
     * @example
     *
     * // Avoid throwing errors for invalid selectors.
     * var elements = _.attempt(function(selector) {
     *   return document.querySelectorAll(selector);
     * }, '>_>');
     *
     * if (_.isError(elements)) {
     *   elements = [];
     * }
     */
    var attempt = baseRest(function(func, args) {
      try {
        return apply(func, undefined, args);
      } catch (e) {
        return isError(e) ? e : new Error(e);
      }
    });

    /**
     * Binds methods of an object to the object itself, overwriting the existing
     * method.
     *
     * **Note:** This method doesn't set the "length" property of bound functions.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Object} object The object to bind and assign the bound methods to.
     * @param {...(string|string[])} methodNames The object method names to bind.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var view = {
     *   'label': 'docs',
     *   'click': function() {
     *     console.log('clicked ' + this.label);
     *   }
     * };
     *
     * _.bindAll(view, ['click']);
     * jQuery(element).on('click', view.click);
     * // => Logs 'clicked docs' when clicked.
     */
    var bindAll = flatRest(function(object, methodNames) {
      arrayEach(methodNames, function(key) {
        key = toKey(key);
        baseAssignValue(object, key, bind(object[key], object));
      });
      return object;
    });

    /**
     * Creates a function that iterates over `pairs` and invokes the corresponding
     * function of the first predicate to return truthy. The predicate-function
     * pairs are invoked with the `this` binding and arguments of the created
     * function.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Array} pairs The predicate-function pairs.
     * @returns {Function} Returns the new composite function.
     * @example
     *
     * var func = _.cond([
     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
     *   [_.stubTrue,                      _.constant('no match')]
     * ]);
     *
     * func({ 'a': 1, 'b': 2 });
     * // => 'matches A'
     *
     * func({ 'a': 0, 'b': 1 });
     * // => 'matches B'
     *
     * func({ 'a': '1', 'b': '2' });
     * // => 'no match'
     */
    function cond(pairs) {
      var length = pairs == null ? 0 : pairs.length,
          toIteratee = getIteratee();

      pairs = !length ? [] : arrayMap(pairs, function(pair) {
        if (typeof pair[1] != 'function') {
          throw new TypeError(FUNC_ERROR_TEXT);
        }
        return [toIteratee(pair[0]), pair[1]];
      });

      return baseRest(function(args) {
        var index = -1;
        while (++index < length) {
          var pair = pairs[index];
          if (apply(pair[0], this, args)) {
            return apply(pair[1], this, args);
          }
        }
      });
    }

    /**
     * Creates a function that invokes the predicate properties of `source` with
     * the corresponding property values of a given object, returning `true` if
     * all predicates return truthy, else `false`.
     *
     * **Note:** The created function is equivalent to `_.conformsTo` with
     * `source` partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 2, 'b': 1 },
     *   { 'a': 1, 'b': 2 }
     * ];
     *
     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
     * // => [{ 'a': 1, 'b': 2 }]
     */
    function conforms(source) {
      return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that returns `value`.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {*} value The value to return from the new function.
     * @returns {Function} Returns the new constant function.
     * @example
     *
     * var objects = _.times(2, _.constant({ 'a': 1 }));
     *
     * console.log(objects);
     * // => [{ 'a': 1 }, { 'a': 1 }]
     *
     * console.log(objects[0] === objects[1]);
     * // => true
     */
    function constant(value) {
      return function() {
        return value;
      };
    }

    /**
     * Checks `value` to determine whether a default value should be returned in
     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
     * or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Util
     * @param {*} value The value to check.
     * @param {*} defaultValue The default value.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * _.defaultTo(1, 10);
     * // => 1
     *
     * _.defaultTo(undefined, 10);
     * // => 10
     */
    function defaultTo(value, defaultValue) {
      return (value == null || value !== value) ? defaultValue : value;
    }

    /**
     * Creates a function that returns the result of invoking the given functions
     * with the `this` binding of the created function, where each successive
     * invocation is supplied the return value of the previous.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flowRight
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flow([_.add, square]);
     * addSquare(1, 2);
     * // => 9
     */
    var flow = createFlow();

    /**
     * This method is like `_.flow` except that it creates a function that
     * invokes the given functions from right to left.
     *
     * @static
     * @since 3.0.0
     * @memberOf _
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flow
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flowRight([square, _.add]);
     * addSquare(1, 2);
     * // => 9
     */
    var flowRight = createFlow(true);

    /**
     * This method returns the first argument it receives.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {*} value Any value.
     * @returns {*} Returns `value`.
     * @example
     *
     * var object = { 'a': 1 };
     *
     * console.log(_.identity(object) === object);
     * // => true
     */
    function identity(value) {
      return value;
    }

    /**
     * Creates a function that invokes `func` with the arguments of the created
     * function. If `func` is a property name, the created function returns the
     * property value for a given element. If `func` is an array or object, the
     * created function returns `true` for elements that contain the equivalent
     * source properties, otherwise it returns `false`.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Util
     * @param {*} [func=_.identity] The value to convert to a callback.
     * @returns {Function} Returns the callback.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, _.iteratee(['user', 'fred']));
     * // => [{ 'user': 'fred', 'age': 40 }]
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, _.iteratee('user'));
     * // => ['barney', 'fred']
     *
     * // Create custom iteratee shorthands.
     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
     *     return func.test(string);
     *   };
     * });
     *
     * _.filter(['abc', 'def'], /ef/);
     * // => ['def']
     */
    function iteratee(func) {
      return baseIteratee(typeof func == 'function' ? func : baseClone(func, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that performs a partial deep comparison between a given
     * object and `source`, returning `true` if the given object has equivalent
     * property values, else `false`.
     *
     * **Note:** The created function is equivalent to `_.isMatch` with `source`
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
     */
    function matches(source) {
      return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that performs a partial deep comparison between the
     * value at `path` of a given object to `srcValue`, returning `true` if the
     * object value is equivalent, else `false`.
     *
     * **Note:** Partial comparisons will match empty array and empty object
     * `srcValue` values against any array or object value, respectively. See
     * `_.isEqual` for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.find(objects, _.matchesProperty('a', 4));
     * // => { 'a': 4, 'b': 5, 'c': 6 }
     */
    function matchesProperty(path, srcValue) {
      return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that invokes the method at `path` of a given object.
     * Any additional arguments are provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': _.constant(2) } },
     *   { 'a': { 'b': _.constant(1) } }
     * ];
     *
     * _.map(objects, _.method('a.b'));
     * // => [2, 1]
     *
     * _.map(objects, _.method(['a', 'b']));
     * // => [2, 1]
     */
    var method = baseRest(function(path, args) {
      return function(object) {
        return baseInvoke(object, path, args);
      };
    });

    /**
     * The opposite of `_.method`; this method creates a function that invokes
     * the method at a given path of `object`. Any additional arguments are
     * provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Object} object The object to query.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var array = _.times(3, _.constant),
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
     * // => [2, 0]
     */
    var methodOf = baseRest(function(object, args) {
      return function(path) {
        return baseInvoke(object, path, args);
      };
    });

    /**
     * Adds all own enumerable string keyed function properties of a source
     * object to the destination object. If `object` is a function, then methods
     * are added to its prototype as well.
     *
     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
     * avoid conflicts caused by modifying the original.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Function|Object} [object=lodash] The destination object.
     * @param {Object} source The object of functions to add.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
     * @returns {Function|Object} Returns `object`.
     * @example
     *
     * function vowels(string) {
     *   return _.filter(string, function(v) {
     *     return /[aeiou]/i.test(v);
     *   });
     * }
     *
     * _.mixin({ 'vowels': vowels });
     * _.vowels('fred');
     * // => ['e']
     *
     * _('fred').vowels().value();
     * // => ['e']
     *
     * _.mixin({ 'vowels': vowels }, { 'chain': false });
     * _('fred').vowels();
     * // => ['e']
     */
    function mixin(object, source, options) {
      var props = keys(source),
          methodNames = baseFunctions(source, props);

      if (options == null &&
          !(isObject(source) && (methodNames.length || !props.length))) {
        options = source;
        source = object;
        object = this;
        methodNames = baseFunctions(source, keys(source));
      }
      var chain = !(isObject(options) && 'chain' in options) || !!options.chain,
          isFunc = isFunction(object);

      arrayEach(methodNames, function(methodName) {
        var func = source[methodName];
        object[methodName] = func;
        if (isFunc) {
          object.prototype[methodName] = function() {
            var chainAll = this.__chain__;
            if (chain || chainAll) {
              var result = object(this.__wrapped__),
                  actions = result.__actions__ = copyArray(this.__actions__);

              actions.push({ 'func': func, 'args': arguments, 'thisArg': object });
              result.__chain__ = chainAll;
              return result;
            }
            return func.apply(object, arrayPush([this.value()], arguments));
          };
        }
      });

      return object;
    }

    /**
     * Reverts the `_` variable to its previous value and returns a reference to
     * the `lodash` function.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @returns {Function} Returns the `lodash` function.
     * @example
     *
     * var lodash = _.noConflict();
     */
    function noConflict() {
      if (root._ === this) {
        root._ = oldDash;
      }
      return this;
    }

    /**
     * This method returns `undefined`.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Util
     * @example
     *
     * _.times(2, _.noop);
     * // => [undefined, undefined]
     */
    function noop() {
      // No operation performed.
    }

    /**
     * Creates a function that gets the argument at index `n`. If `n` is negative,
     * the nth argument from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [n=0] The index of the argument to return.
     * @returns {Function} Returns the new pass-thru function.
     * @example
     *
     * var func = _.nthArg(1);
     * func('a', 'b', 'c', 'd');
     * // => 'b'
     *
     * var func = _.nthArg(-2);
     * func('a', 'b', 'c', 'd');
     * // => 'c'
     */
    function nthArg(n) {
      n = toInteger(n);
      return baseRest(function(args) {
        return baseNth(args, n);
      });
    }

    /**
     * Creates a function that invokes `iteratees` with the arguments it receives
     * and returns their results.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to invoke.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.over([Math.max, Math.min]);
     *
     * func(1, 2, 3, 4);
     * // => [4, 1]
     */
    var over = createOver(arrayMap);

    /**
     * Creates a function that checks if **all** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overEvery([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => false
     *
     * func(NaN);
     * // => false
     */
    var overEvery = createOver(arrayEvery);

    /**
     * Creates a function that checks if **any** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overSome([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => true
     *
     * func(NaN);
     * // => false
     */
    var overSome = createOver(arraySome);

    /**
     * Creates a function that returns the value at `path` of a given object.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': 2 } },
     *   { 'a': { 'b': 1 } }
     * ];
     *
     * _.map(objects, _.property('a.b'));
     * // => [2, 1]
     *
     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
     * // => [1, 2]
     */
    function property(path) {
      return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
    }

    /**
     * The opposite of `_.property`; this method creates a function that returns
     * the value at a given path of `object`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} object The object to query.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var array = [0, 1, 2],
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
     * // => [2, 0]
     */
    function propertyOf(object) {
      return function(path) {
        return object == null ? undefined : baseGet(object, path);
      };
    }

    /**
     * Creates an array of numbers (positive and/or negative) progressing from
     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
     * `start` is specified without an `end` or `step`. If `end` is not specified,
     * it's set to `start` with `start` then set to `0`.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.rangeRight
     * @example
     *
     * _.range(4);
     * // => [0, 1, 2, 3]
     *
     * _.range(-4);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 5);
     * // => [1, 2, 3, 4]
     *
     * _.range(0, 20, 5);
     * // => [0, 5, 10, 15]
     *
     * _.range(0, -4, -1);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.range(0);
     * // => []
     */
    var range = createRange();

    /**
     * This method is like `_.range` except that it populates values in
     * descending order.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.range
     * @example
     *
     * _.rangeRight(4);
     * // => [3, 2, 1, 0]
     *
     * _.rangeRight(-4);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 5);
     * // => [4, 3, 2, 1]
     *
     * _.rangeRight(0, 20, 5);
     * // => [15, 10, 5, 0]
     *
     * _.rangeRight(0, -4, -1);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.rangeRight(0);
     * // => []
     */
    var rangeRight = createRange(true);

    /**
     * This method returns a new empty array.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Array} Returns the new empty array.
     * @example
     *
     * var arrays = _.times(2, _.stubArray);
     *
     * console.log(arrays);
     * // => [[], []]
     *
     * console.log(arrays[0] === arrays[1]);
     * // => false
     */
    function stubArray() {
      return [];
    }

    /**
     * This method returns `false`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `false`.
     * @example
     *
     * _.times(2, _.stubFalse);
     * // => [false, false]
     */
    function stubFalse() {
      return false;
    }

    /**
     * This method returns a new empty object.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Object} Returns the new empty object.
     * @example
     *
     * var objects = _.times(2, _.stubObject);
     *
     * console.log(objects);
     * // => [{}, {}]
     *
     * console.log(objects[0] === objects[1]);
     * // => false
     */
    function stubObject() {
      return {};
    }

    /**
     * This method returns an empty string.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {string} Returns the empty string.
     * @example
     *
     * _.times(2, _.stubString);
     * // => ['', '']
     */
    function stubString() {
      return '';
    }

    /**
     * This method returns `true`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `true`.
     * @example
     *
     * _.times(2, _.stubTrue);
     * // => [true, true]
     */
    function stubTrue() {
      return true;
    }

    /**
     * Invokes the iteratee `n` times, returning an array of the results of
     * each invocation. The iteratee is invoked with one argument; (index).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} n The number of times to invoke `iteratee`.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.times(3, String);
     * // => ['0', '1', '2']
     *
     *  _.times(4, _.constant(0));
     * // => [0, 0, 0, 0]
     */
    function times(n, iteratee) {
      n = toInteger(n);
      if (n < 1 || n > MAX_SAFE_INTEGER) {
        return [];
      }
      var index = MAX_ARRAY_LENGTH,
          length = nativeMin(n, MAX_ARRAY_LENGTH);

      iteratee = getIteratee(iteratee);
      n -= MAX_ARRAY_LENGTH;

      var result = baseTimes(length, iteratee);
      while (++index < n) {
        iteratee(index);
      }
      return result;
    }

    /**
     * Converts `value` to a property path array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {*} value The value to convert.
     * @returns {Array} Returns the new property path array.
     * @example
     *
     * _.toPath('a.b.c');
     * // => ['a', 'b', 'c']
     *
     * _.toPath('a[0].b.c');
     * // => ['a', '0', 'b', 'c']
     */
    function toPath(value) {
      if (isArray(value)) {
        return arrayMap(value, toKey);
      }
      return isSymbol(value) ? [value] : copyArray(stringToPath(toString(value)));
    }

    /**
     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {string} [prefix=''] The value to prefix the ID with.
     * @returns {string} Returns the unique ID.
     * @example
     *
     * _.uniqueId('contact_');
     * // => 'contact_104'
     *
     * _.uniqueId();
     * // => '105'
     */
    function uniqueId(prefix) {
      var id = ++idCounter;
      return toString(prefix) + id;
    }

    /*------------------------------------------------------------------------*/

    /**
     * Adds two numbers.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {number} augend The first number in an addition.
     * @param {number} addend The second number in an addition.
     * @returns {number} Returns the total.
     * @example
     *
     * _.add(6, 4);
     * // => 10
     */
    var add = createMathOperation(function(augend, addend) {
      return augend + addend;
    }, 0);

    /**
     * Computes `number` rounded up to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round up.
     * @param {number} [precision=0] The precision to round up to.
     * @returns {number} Returns the rounded up number.
     * @example
     *
     * _.ceil(4.006);
     * // => 5
     *
     * _.ceil(6.004, 2);
     * // => 6.01
     *
     * _.ceil(6040, -2);
     * // => 6100
     */
    var ceil = createRound('ceil');

    /**
     * Divide two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} dividend The first number in a division.
     * @param {number} divisor The second number in a division.
     * @returns {number} Returns the quotient.
     * @example
     *
     * _.divide(6, 4);
     * // => 1.5
     */
    var divide = createMathOperation(function(dividend, divisor) {
      return dividend / divisor;
    }, 1);

    /**
     * Computes `number` rounded down to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round down.
     * @param {number} [precision=0] The precision to round down to.
     * @returns {number} Returns the rounded down number.
     * @example
     *
     * _.floor(4.006);
     * // => 4
     *
     * _.floor(0.046, 2);
     * // => 0.04
     *
     * _.floor(4060, -2);
     * // => 4000
     */
    var floor = createRound('floor');

    /**
     * Computes the maximum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * _.max([4, 2, 8, 6]);
     * // => 8
     *
     * _.max([]);
     * // => undefined
     */
    function max(array) {
      return (array && array.length)
        ? baseExtremum(array, identity, baseGt)
        : undefined;
    }

    /**
     * This method is like `_.max` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.maxBy(objects, function(o) { return o.n; });
     * // => { 'n': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.maxBy(objects, 'n');
     * // => { 'n': 2 }
     */
    function maxBy(array, iteratee) {
      return (array && array.length)
        ? baseExtremum(array, getIteratee(iteratee, 2), baseGt)
        : undefined;
    }

    /**
     * Computes the mean of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the mean.
     * @example
     *
     * _.mean([4, 2, 8, 6]);
     * // => 5
     */
    function mean(array) {
      return baseMean(array, identity);
    }

    /**
     * This method is like `_.mean` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be averaged.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the mean.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.meanBy(objects, function(o) { return o.n; });
     * // => 5
     *
     * // The `_.property` iteratee shorthand.
     * _.meanBy(objects, 'n');
     * // => 5
     */
    function meanBy(array, iteratee) {
      return baseMean(array, getIteratee(iteratee, 2));
    }

    /**
     * Computes the minimum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * _.min([4, 2, 8, 6]);
     * // => 2
     *
     * _.min([]);
     * // => undefined
     */
    function min(array) {
      return (array && array.length)
        ? baseExtremum(array, identity, baseLt)
        : undefined;
    }

    /**
     * This method is like `_.min` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.minBy(objects, function(o) { return o.n; });
     * // => { 'n': 1 }
     *
     * // The `_.property` iteratee shorthand.
     * _.minBy(objects, 'n');
     * // => { 'n': 1 }
     */
    function minBy(array, iteratee) {
      return (array && array.length)
        ? baseExtremum(array, getIteratee(iteratee, 2), baseLt)
        : undefined;
    }

    /**
     * Multiply two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} multiplier The first number in a multiplication.
     * @param {number} multiplicand The second number in a multiplication.
     * @returns {number} Returns the product.
     * @example
     *
     * _.multiply(6, 4);
     * // => 24
     */
    var multiply = createMathOperation(function(multiplier, multiplicand) {
      return multiplier * multiplicand;
    }, 1);

    /**
     * Computes `number` rounded to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round.
     * @param {number} [precision=0] The precision to round to.
     * @returns {number} Returns the rounded number.
     * @example
     *
     * _.round(4.006);
     * // => 4
     *
     * _.round(4.006, 2);
     * // => 4.01
     *
     * _.round(4060, -2);
     * // => 4100
     */
    var round = createRound('round');

    /**
     * Subtract two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {number} minuend The first number in a subtraction.
     * @param {number} subtrahend The second number in a subtraction.
     * @returns {number} Returns the difference.
     * @example
     *
     * _.subtract(6, 4);
     * // => 2
     */
    var subtract = createMathOperation(function(minuend, subtrahend) {
      return minuend - subtrahend;
    }, 0);

    /**
     * Computes the sum of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the sum.
     * @example
     *
     * _.sum([4, 2, 8, 6]);
     * // => 20
     */
    function sum(array) {
      return (array && array.length)
        ? baseSum(array, identity)
        : 0;
    }

    /**
     * This method is like `_.sum` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be summed.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the sum.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.sumBy(objects, function(o) { return o.n; });
     * // => 20
     *
     * // The `_.property` iteratee shorthand.
     * _.sumBy(objects, 'n');
     * // => 20
     */
    function sumBy(array, iteratee) {
      return (array && array.length)
        ? baseSum(array, getIteratee(iteratee, 2))
        : 0;
    }

    /*------------------------------------------------------------------------*/

    // Add methods that return wrapped values in chain sequences.
    lodash.after = after;
    lodash.ary = ary;
    lodash.assign = assign;
    lodash.assignIn = assignIn;
    lodash.assignInWith = assignInWith;
    lodash.assignWith = assignWith;
    lodash.at = at;
    lodash.before = before;
    lodash.bind = bind;
    lodash.bindAll = bindAll;
    lodash.bindKey = bindKey;
    lodash.castArray = castArray;
    lodash.chain = chain;
    lodash.chunk = chunk;
    lodash.compact = compact;
    lodash.concat = concat;
    lodash.cond = cond;
    lodash.conforms = conforms;
    lodash.constant = constant;
    lodash.countBy = countBy;
    lodash.create = create;
    lodash.curry = curry;
    lodash.curryRight = curryRight;
    lodash.debounce = debounce;
    lodash.defaults = defaults;
    lodash.defaultsDeep = defaultsDeep;
    lodash.defer = defer;
    lodash.delay = delay;
    lodash.difference = difference;
    lodash.differenceBy = differenceBy;
    lodash.differenceWith = differenceWith;
    lodash.drop = drop;
    lodash.dropRight = dropRight;
    lodash.dropRightWhile = dropRightWhile;
    lodash.dropWhile = dropWhile;
    lodash.fill = fill;
    lodash.filter = filter;
    lodash.flatMap = flatMap;
    lodash.flatMapDeep = flatMapDeep;
    lodash.flatMapDepth = flatMapDepth;
    lodash.flatten = flatten;
    lodash.flattenDeep = flattenDeep;
    lodash.flattenDepth = flattenDepth;
    lodash.flip = flip;
    lodash.flow = flow;
    lodash.flowRight = flowRight;
    lodash.fromPairs = fromPairs;
    lodash.functions = functions;
    lodash.functionsIn = functionsIn;
    lodash.groupBy = groupBy;
    lodash.initial = initial;
    lodash.intersection = intersection;
    lodash.intersectionBy = intersectionBy;
    lodash.intersectionWith = intersectionWith;
    lodash.invert = invert;
    lodash.invertBy = invertBy;
    lodash.invokeMap = invokeMap;
    lodash.iteratee = iteratee;
    lodash.keyBy = keyBy;
    lodash.keys = keys;
    lodash.keysIn = keysIn;
    lodash.map = map;
    lodash.mapKeys = mapKeys;
    lodash.mapValues = mapValues;
    lodash.matches = matches;
    lodash.matchesProperty = matchesProperty;
    lodash.memoize = memoize;
    lodash.merge = merge;
    lodash.mergeWith = mergeWith;
    lodash.method = method;
    lodash.methodOf = methodOf;
    lodash.mixin = mixin;
    lodash.negate = negate;
    lodash.nthArg = nthArg;
    lodash.omit = omit;
    lodash.omitBy = omitBy;
    lodash.once = once;
    lodash.orderBy = orderBy;
    lodash.over = over;
    lodash.overArgs = overArgs;
    lodash.overEvery = overEvery;
    lodash.overSome = overSome;
    lodash.partial = partial;
    lodash.partialRight = partialRight;
    lodash.partition = partition;
    lodash.pick = pick;
    lodash.pickBy = pickBy;
    lodash.property = property;
    lodash.propertyOf = propertyOf;
    lodash.pull = pull;
    lodash.pullAll = pullAll;
    lodash.pullAllBy = pullAllBy;
    lodash.pullAllWith = pullAllWith;
    lodash.pullAt = pullAt;
    lodash.range = range;
    lodash.rangeRight = rangeRight;
    lodash.rearg = rearg;
    lodash.reject = reject;
    lodash.remove = remove;
    lodash.rest = rest;
    lodash.reverse = reverse;
    lodash.sampleSize = sampleSize;
    lodash.set = set;
    lodash.setWith = setWith;
    lodash.shuffle = shuffle;
    lodash.slice = slice;
    lodash.sortBy = sortBy;
    lodash.sortedUniq = sortedUniq;
    lodash.sortedUniqBy = sortedUniqBy;
    lodash.split = split;
    lodash.spread = spread;
    lodash.tail = tail;
    lodash.take = take;
    lodash.takeRight = takeRight;
    lodash.takeRightWhile = takeRightWhile;
    lodash.takeWhile = takeWhile;
    lodash.tap = tap;
    lodash.throttle = throttle;
    lodash.thru = thru;
    lodash.toArray = toArray;
    lodash.toPairs = toPairs;
    lodash.toPairsIn = toPairsIn;
    lodash.toPath = toPath;
    lodash.toPlainObject = toPlainObject;
    lodash.transform = transform;
    lodash.unary = unary;
    lodash.union = union;
    lodash.unionBy = unionBy;
    lodash.unionWith = unionWith;
    lodash.uniq = uniq;
    lodash.uniqBy = uniqBy;
    lodash.uniqWith = uniqWith;
    lodash.unset = unset;
    lodash.unzip = unzip;
    lodash.unzipWith = unzipWith;
    lodash.update = update;
    lodash.updateWith = updateWith;
    lodash.values = values;
    lodash.valuesIn = valuesIn;
    lodash.without = without;
    lodash.words = words;
    lodash.wrap = wrap;
    lodash.xor = xor;
    lodash.xorBy = xorBy;
    lodash.xorWith = xorWith;
    lodash.zip = zip;
    lodash.zipObject = zipObject;
    lodash.zipObjectDeep = zipObjectDeep;
    lodash.zipWith = zipWith;

    // Add aliases.
    lodash.entries = toPairs;
    lodash.entriesIn = toPairsIn;
    lodash.extend = assignIn;
    lodash.extendWith = assignInWith;

    // Add methods to `lodash.prototype`.
    mixin(lodash, lodash);

    /*------------------------------------------------------------------------*/

    // Add methods that return unwrapped values in chain sequences.
    lodash.add = add;
    lodash.attempt = attempt;
    lodash.camelCase = camelCase;
    lodash.capitalize = capitalize;
    lodash.ceil = ceil;
    lodash.clamp = clamp;
    lodash.clone = clone;
    lodash.cloneDeep = cloneDeep;
    lodash.cloneDeepWith = cloneDeepWith;
    lodash.cloneWith = cloneWith;
    lodash.conformsTo = conformsTo;
    lodash.deburr = deburr;
    lodash.defaultTo = defaultTo;
    lodash.divide = divide;
    lodash.endsWith = endsWith;
    lodash.eq = eq;
    lodash.escape = escape;
    lodash.escapeRegExp = escapeRegExp;
    lodash.every = every;
    lodash.find = find;
    lodash.findIndex = findIndex;
    lodash.findKey = findKey;
    lodash.findLast = findLast;
    lodash.findLastIndex = findLastIndex;
    lodash.findLastKey = findLastKey;
    lodash.floor = floor;
    lodash.forEach = forEach;
    lodash.forEachRight = forEachRight;
    lodash.forIn = forIn;
    lodash.forInRight = forInRight;
    lodash.forOwn = forOwn;
    lodash.forOwnRight = forOwnRight;
    lodash.get = get;
    lodash.gt = gt;
    lodash.gte = gte;
    lodash.has = has;
    lodash.hasIn = hasIn;
    lodash.head = head;
    lodash.identity = identity;
    lodash.includes = includes;
    lodash.indexOf = indexOf;
    lodash.inRange = inRange;
    lodash.invoke = invoke;
    lodash.isArguments = isArguments;
    lodash.isArray = isArray;
    lodash.isArrayBuffer = isArrayBuffer;
    lodash.isArrayLike = isArrayLike;
    lodash.isArrayLikeObject = isArrayLikeObject;
    lodash.isBoolean = isBoolean;
    lodash.isBuffer = isBuffer;
    lodash.isDate = isDate;
    lodash.isElement = isElement;
    lodash.isEmpty = isEmpty;
    lodash.isEqual = isEqual;
    lodash.isEqualWith = isEqualWith;
    lodash.isError = isError;
    lodash.isFinite = isFinite;
    lodash.isFunction = isFunction;
    lodash.isInteger = isInteger;
    lodash.isLength = isLength;
    lodash.isMap = isMap;
    lodash.isMatch = isMatch;
    lodash.isMatchWith = isMatchWith;
    lodash.isNaN = isNaN;
    lodash.isNative = isNative;
    lodash.isNil = isNil;
    lodash.isNull = isNull;
    lodash.isNumber = isNumber;
    lodash.isObject = isObject;
    lodash.isObjectLike = isObjectLike;
    lodash.isPlainObject = isPlainObject;
    lodash.isRegExp = isRegExp;
    lodash.isSafeInteger = isSafeInteger;
    lodash.isSet = isSet;
    lodash.isString = isString;
    lodash.isSymbol = isSymbol;
    lodash.isTypedArray = isTypedArray;
    lodash.isUndefined = isUndefined;
    lodash.isWeakMap = isWeakMap;
    lodash.isWeakSet = isWeakSet;
    lodash.join = join;
    lodash.kebabCase = kebabCase;
    lodash.last = last;
    lodash.lastIndexOf = lastIndexOf;
    lodash.lowerCase = lowerCase;
    lodash.lowerFirst = lowerFirst;
    lodash.lt = lt;
    lodash.lte = lte;
    lodash.max = max;
    lodash.maxBy = maxBy;
    lodash.mean = mean;
    lodash.meanBy = meanBy;
    lodash.min = min;
    lodash.minBy = minBy;
    lodash.stubArray = stubArray;
    lodash.stubFalse = stubFalse;
    lodash.stubObject = stubObject;
    lodash.stubString = stubString;
    lodash.stubTrue = stubTrue;
    lodash.multiply = multiply;
    lodash.nth = nth;
    lodash.noConflict = noConflict;
    lodash.noop = noop;
    lodash.now = now;
    lodash.pad = pad;
    lodash.padEnd = padEnd;
    lodash.padStart = padStart;
    lodash.parseInt = parseInt;
    lodash.random = random;
    lodash.reduce = reduce;
    lodash.reduceRight = reduceRight;
    lodash.repeat = repeat;
    lodash.replace = replace;
    lodash.result = result;
    lodash.round = round;
    lodash.runInContext = runInContext;
    lodash.sample = sample;
    lodash.size = size;
    lodash.snakeCase = snakeCase;
    lodash.some = some;
    lodash.sortedIndex = sortedIndex;
    lodash.sortedIndexBy = sortedIndexBy;
    lodash.sortedIndexOf = sortedIndexOf;
    lodash.sortedLastIndex = sortedLastIndex;
    lodash.sortedLastIndexBy = sortedLastIndexBy;
    lodash.sortedLastIndexOf = sortedLastIndexOf;
    lodash.startCase = startCase;
    lodash.startsWith = startsWith;
    lodash.subtract = subtract;
    lodash.sum = sum;
    lodash.sumBy = sumBy;
    lodash.template = template;
    lodash.times = times;
    lodash.toFinite = toFinite;
    lodash.toInteger = toInteger;
    lodash.toLength = toLength;
    lodash.toLower = toLower;
    lodash.toNumber = toNumber;
    lodash.toSafeInteger = toSafeInteger;
    lodash.toString = toString;
    lodash.toUpper = toUpper;
    lodash.trim = trim;
    lodash.trimEnd = trimEnd;
    lodash.trimStart = trimStart;
    lodash.truncate = truncate;
    lodash.unescape = unescape;
    lodash.uniqueId = uniqueId;
    lodash.upperCase = upperCase;
    lodash.upperFirst = upperFirst;

    // Add aliases.
    lodash.each = forEach;
    lodash.eachRight = forEachRight;
    lodash.first = head;

    mixin(lodash, (function() {
      var source = {};
      baseForOwn(lodash, function(func, methodName) {
        if (!hasOwnProperty.call(lodash.prototype, methodName)) {
          source[methodName] = func;
        }
      });
      return source;
    }()), { 'chain': false });

    /*------------------------------------------------------------------------*/

    /**
     * The semantic version number.
     *
     * @static
     * @memberOf _
     * @type {string}
     */
    lodash.VERSION = VERSION;

    // Assign default placeholders.
    arrayEach(['bind', 'bindKey', 'curry', 'curryRight', 'partial', 'partialRight'], function(methodName) {
      lodash[methodName].placeholder = lodash;
    });

    // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
    arrayEach(['drop', 'take'], function(methodName, index) {
      LazyWrapper.prototype[methodName] = function(n) {
        n = n === undefined ? 1 : nativeMax(toInteger(n), 0);

        var result = (this.__filtered__ && !index)
          ? new LazyWrapper(this)
          : this.clone();

        if (result.__filtered__) {
          result.__takeCount__ = nativeMin(n, result.__takeCount__);
        } else {
          result.__views__.push({
            'size': nativeMin(n, MAX_ARRAY_LENGTH),
            'type': methodName + (result.__dir__ < 0 ? 'Right' : '')
          });
        }
        return result;
      };

      LazyWrapper.prototype[methodName + 'Right'] = function(n) {
        return this.reverse()[methodName](n).reverse();
      };
    });

    // Add `LazyWrapper` methods that accept an `iteratee` value.
    arrayEach(['filter', 'map', 'takeWhile'], function(methodName, index) {
      var type = index + 1,
          isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;

      LazyWrapper.prototype[methodName] = function(iteratee) {
        var result = this.clone();
        result.__iteratees__.push({
          'iteratee': getIteratee(iteratee, 3),
          'type': type
        });
        result.__filtered__ = result.__filtered__ || isFilter;
        return result;
      };
    });

    // Add `LazyWrapper` methods for `_.head` and `_.last`.
    arrayEach(['head', 'last'], function(methodName, index) {
      var takeName = 'take' + (index ? 'Right' : '');

      LazyWrapper.prototype[methodName] = function() {
        return this[takeName](1).value()[0];
      };
    });

    // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
    arrayEach(['initial', 'tail'], function(methodName, index) {
      var dropName = 'drop' + (index ? '' : 'Right');

      LazyWrapper.prototype[methodName] = function() {
        return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
      };
    });

    LazyWrapper.prototype.compact = function() {
      return this.filter(identity);
    };

    LazyWrapper.prototype.find = function(predicate) {
      return this.filter(predicate).head();
    };

    LazyWrapper.prototype.findLast = function(predicate) {
      return this.reverse().find(predicate);
    };

    LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
      if (typeof path == 'function') {
        return new LazyWrapper(this);
      }
      return this.map(function(value) {
        return baseInvoke(value, path, args);
      });
    });

    LazyWrapper.prototype.reject = function(predicate) {
      return this.filter(negate(getIteratee(predicate)));
    };

    LazyWrapper.prototype.slice = function(start, end) {
      start = toInteger(start);

      var result = this;
      if (result.__filtered__ && (start > 0 || end < 0)) {
        return new LazyWrapper(result);
      }
      if (start < 0) {
        result = result.takeRight(-start);
      } else if (start) {
        result = result.drop(start);
      }
      if (end !== undefined) {
        end = toInteger(end);
        result = end < 0 ? result.dropRight(-end) : result.take(end - start);
      }
      return result;
    };

    LazyWrapper.prototype.takeRightWhile = function(predicate) {
      return this.reverse().takeWhile(predicate).reverse();
    };

    LazyWrapper.prototype.toArray = function() {
      return this.take(MAX_ARRAY_LENGTH);
    };

    // Add `LazyWrapper` methods to `lodash.prototype`.
    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
      var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName),
          isTaker = /^(?:head|last)$/.test(methodName),
          lodashFunc = lodash[isTaker ? ('take' + (methodName == 'last' ? 'Right' : '')) : methodName],
          retUnwrapped = isTaker || /^find/.test(methodName);

      if (!lodashFunc) {
        return;
      }
      lodash.prototype[methodName] = function() {
        var value = this.__wrapped__,
            args = isTaker ? [1] : arguments,
            isLazy = value instanceof LazyWrapper,
            iteratee = args[0],
            useLazy = isLazy || isArray(value);

        var interceptor = function(value) {
          var result = lodashFunc.apply(lodash, arrayPush([value], args));
          return (isTaker && chainAll) ? result[0] : result;
        };

        if (useLazy && checkIteratee && typeof iteratee == 'function' && iteratee.length != 1) {
          // Avoid lazy use if the iteratee has a "length" value other than `1`.
          isLazy = useLazy = false;
        }
        var chainAll = this.__chain__,
            isHybrid = !!this.__actions__.length,
            isUnwrapped = retUnwrapped && !chainAll,
            onlyLazy = isLazy && !isHybrid;

        if (!retUnwrapped && useLazy) {
          value = onlyLazy ? value : new LazyWrapper(this);
          var result = func.apply(value, args);
          result.__actions__.push({ 'func': thru, 'args': [interceptor], 'thisArg': undefined });
          return new LodashWrapper(result, chainAll);
        }
        if (isUnwrapped && onlyLazy) {
          return func.apply(this, args);
        }
        result = this.thru(interceptor);
        return isUnwrapped ? (isTaker ? result.value()[0] : result.value()) : result;
      };
    });

    // Add `Array` methods to `lodash.prototype`.
    arrayEach(['pop', 'push', 'shift', 'sort', 'splice', 'unshift'], function(methodName) {
      var func = arrayProto[methodName],
          chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru',
          retUnwrapped = /^(?:pop|shift)$/.test(methodName);

      lodash.prototype[methodName] = function() {
        var args = arguments;
        if (retUnwrapped && !this.__chain__) {
          var value = this.value();
          return func.apply(isArray(value) ? value : [], args);
        }
        return this[chainName](function(value) {
          return func.apply(isArray(value) ? value : [], args);
        });
      };
    });

    // Map minified method names to their real names.
    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
      var lodashFunc = lodash[methodName];
      if (lodashFunc) {
        var key = lodashFunc.name + '';
        if (!hasOwnProperty.call(realNames, key)) {
          realNames[key] = [];
        }
        realNames[key].push({ 'name': methodName, 'func': lodashFunc });
      }
    });

    realNames[createHybrid(undefined, WRAP_BIND_KEY_FLAG).name] = [{
      'name': 'wrapper',
      'func': undefined
    }];

    // Add methods to `LazyWrapper`.
    LazyWrapper.prototype.clone = lazyClone;
    LazyWrapper.prototype.reverse = lazyReverse;
    LazyWrapper.prototype.value = lazyValue;

    // Add chain sequence methods to the `lodash` wrapper.
    lodash.prototype.at = wrapperAt;
    lodash.prototype.chain = wrapperChain;
    lodash.prototype.commit = wrapperCommit;
    lodash.prototype.next = wrapperNext;
    lodash.prototype.plant = wrapperPlant;
    lodash.prototype.reverse = wrapperReverse;
    lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;

    // Add lazy aliases.
    lodash.prototype.first = lodash.prototype.head;

    if (symIterator) {
      lodash.prototype[symIterator] = wrapperToIterator;
    }
    return lodash;
  });

  /*--------------------------------------------------------------------------*/

  // Export lodash.
  var _ = runInContext();

  // Some AMD build optimizers, like r.js, check for condition patterns like:
  if (true) {
    // Expose Lodash on the global object to prevent errors when Lodash is
    // loaded by a script tag in the presence of an AMD loader.
    // See http://requirejs.org/docs/errors.html#mismatch for more details.
    // Use `_.noConflict` to remove Lodash from the global object.
    root._ = _;

    // Define as an anonymous module so, through path mapping, it can be
    // referenced as the "underscore" module.
    !(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
      return _;
    }.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  }
  // Check for `exports` after `define` in case a build optimizer adds it.
  else if (freeModule) {
    // Export for Node.js.
    (freeModule.exports = _)._ = _;
    // Export for CommonJS support.
    freeExports._ = _;
  }
  else {
    // Export to the global object.
    root._ = _;
  }
}.call(this));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(36), __webpack_require__(94)(module)))

/***/ }),
/* 9 */
/***/ (function(module, exports) {

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

module.exports = _interopRequireDefault;

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(9);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _pure = _interopRequireDefault(__webpack_require__(96));

var _SvgIcon = _interopRequireDefault(__webpack_require__(97));

function createSvgIcon(path, displayName) {
  var Icon = function Icon(props) {
    return _react.default.createElement(_SvgIcon.default, props, path);
  };

  Icon.displayName = displayName;
  Icon = (0, _pure.default)(Icon);
  Icon.muiName = 'SvgIcon';
  return Icon;
}

;
var _default = createSvgIcon;
exports.default = _default;

/***/ }),
/* 11 */
/***/ (function(module, exports) {

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

module.exports = _classCallCheck;

/***/ }),
/* 12 */
/***/ (function(module, exports) {

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

module.exports = _createClass;

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

var _typeof = __webpack_require__(166);

var assertThisInitialized = __webpack_require__(88);

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return assertThisInitialized(self);
}

module.exports = _possibleConstructorReturn;

/***/ }),
/* 14 */
/***/ (function(module, exports) {

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

module.exports = _inherits;

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = __webpack_require__(136);
module.exports.easing = __webpack_require__(660);
module.exports.canvas = __webpack_require__(661);
module.exports.options = __webpack_require__(662);


/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @providesModule warning
 */



/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var __DEV__ = "production" !== 'production';

var warning = function() {};

if (__DEV__) {
  var printWarning = function printWarning(format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    var argIndex = 0;
    var message = 'Warning: ' +
      format.replace(/%s/g, function() {
        return args[argIndex++];
      });
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  }

  warning = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
          '`warning(condition, format, ...args)` requires a warning ' +
          'message argument'
      );
    }
    if (!condition) {
      printWarning.apply(null, [format].concat(args));
    }
  };
}

module.exports = warning;


/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

var defineProperty = __webpack_require__(7);

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      defineProperty(target, key, source[key]);
    });
  }

  return target;
}

module.exports = _objectSpread;

/***/ }),
/* 18 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__material_ui_core_styles_withStyles__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__material_ui_core_styles_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_styles_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid__ = __webpack_require__(249);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid__);
function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}// @material-ui/core components
var style={grid:{margin:"0 -15px",width:"calc(100% + 30px)"// '&:before,&:after':{
//   display: 'table',
//   content: '" "',
// },
// '&:after':{
//   clear: 'both',
// }
}};function GridContainer(_ref){var props=_objectWithoutProperties(_ref,[]);var classes=props.classes,children=props.children,className=props.className,rest=_objectWithoutProperties(props,["classes","children","className"]);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,Object.assign({container:true},rest,{className:classes.grid+" "+className}),children);}/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_1__material_ui_core_styles_withStyles___default()(style)(GridContainer));

/***/ }),
/* 19 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__material_ui_core_styles_withStyles__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__material_ui_core_styles_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_styles_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid__ = __webpack_require__(249);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid__);
function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}// @material-ui/core components
var style={grid:{padding:"0 15px !important"}};function GridItem(_ref){var props=_objectWithoutProperties(_ref,[]);var classes=props.classes,children=props.children,className=props.className,rest=_objectWithoutProperties(props,["classes","children","className"]);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,Object.assign({item:true},rest,{className:classes.grid+" "+className}),children);}/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_1__material_ui_core_styles_withStyles___default()(style)(GridItem));

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var helpers = __webpack_require__(15);

module.exports = {
	/**
	 * @private
	 */
	_set: function(scope, values) {
		return helpers.merge(this[scope] || (this[scope] = {}), values);
	}
};


/***/ }),
/* 21 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return drawerWidth; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return drawerMiniWidth; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return transition; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return container; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return containerFluid; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return boxShadow; });
/* unused harmony export card */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return defaultFont; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return primaryColor; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return warningColor; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return dangerColor; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return successColor; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return infoColor; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return roseColor; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return grayColor; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return primaryBoxShadow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return infoBoxShadow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return successBoxShadow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return warningBoxShadow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return dangerBoxShadow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return roseBoxShadow; });
/* unused harmony export orangeCardHeader */
/* unused harmony export greenCardHeader */
/* unused harmony export redCardHeader */
/* unused harmony export blueCardHeader */
/* unused harmony export purpleCardHeader */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return roseCardHeader; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return warningCardHeader; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return successCardHeader; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return dangerCardHeader; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return infoCardHeader; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return primaryCardHeader; });
/* unused harmony export cardActions */
/* unused harmony export cardHeader */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return defaultBoxShadow; });
/* unused harmony export tooltip */
/* unused harmony export title */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return cardTitle; });
/* unused harmony export cardSubtitle */
/* unused harmony export cardLink */
/*!

 =========================================================
 * Material Dashboard PRO React - v1.3.0 based on Material Dashboard PRO - v1.2.1
 =========================================================

 * Product Page: https://www.creative-tim.com/product/material-dashboard-react
 * Copyright 2018 Creative Tim (https://www.creative-tim.com)
 * Licensed under MIT (https://github.com/creativetimofficial/material-dashboard-react/blob/master/LICENSE.md)

 =========================================================

 * The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

 */// ##############################
// // // Variables - Styles that are used on more than one component
// #############################
var drawerWidth=260;var drawerMiniWidth=80;var transition={transition:"all 0.33s cubic-bezier(0.685, 0.0473, 0.346, 1)"};var containerFluid={paddingRight:"15px",paddingLeft:"15px",marginRight:"auto",marginLeft:"auto","&:before,&:after":{display:"table",content:'" "'},"&:after":{clear:"both"}};var container={paddingRight:"15px",paddingLeft:"15px",marginRight:"auto",marginLeft:"auto","@media (min-width: 768px)":{width:"750px"},"@media (min-width: 992px)":{width:"970px"},"@media (min-width: 1200px)":{width:"1170px"},"&:before,&:after":{display:"table",content:'" "'},"&:after":{clear:"both"}};var boxShadow={boxShadow:"0 10px 30px -12px rgba(0, 0, 0, 0.42), 0 4px 25px 0px rgba(0, 0, 0, 0.12), 0 8px 10px -5px rgba(0, 0, 0, 0.2)"};var card={display:"inline-block",position:"relative",width:"100%",margin:"25px 0",boxShadow:"0 1px 4px 0 rgba(0, 0, 0, 0.14)",borderRadius:"6px",color:"rgba(0, 0, 0, 0.87)",background:"#fff"};var defaultFont={fontFamily:'"Roboto", "Helvetica", "Arial", sans-serif',fontWeight:"300",lineHeight:"1.5em"};var primaryColor="#9c27b0";var warningColor="#ff9800";var dangerColor="#f44336";var successColor="#4caf50";var infoColor="#00acc1";var roseColor="#e91e63";var grayColor="#999999";var primaryBoxShadow={boxShadow:"0 12px 20px -10px rgba(156, 39, 176, 0.28), 0 4px 20px 0px rgba(0, 0, 0, 0.12), 0 7px 8px -5px rgba(156, 39, 176, 0.2)"};var infoBoxShadow={boxShadow:"0 12px 20px -10px rgba(0, 188, 212, 0.28), 0 4px 20px 0px rgba(0, 0, 0, 0.12), 0 7px 8px -5px rgba(0, 188, 212, 0.2)"};var successBoxShadow={boxShadow:"0 12px 20px -10px rgba(76, 175, 80, 0.28), 0 4px 20px 0px rgba(0, 0, 0, 0.12), 0 7px 8px -5px rgba(76, 175, 80, 0.2)"};var warningBoxShadow={boxShadow:"0 12px 20px -10px rgba(255, 152, 0, 0.28), 0 4px 20px 0px rgba(0, 0, 0, 0.12), 0 7px 8px -5px rgba(255, 152, 0, 0.2)"};var dangerBoxShadow={boxShadow:"0 12px 20px -10px rgba(244, 67, 54, 0.28), 0 4px 20px 0px rgba(0, 0, 0, 0.12), 0 7px 8px -5px rgba(244, 67, 54, 0.2)"};var roseBoxShadow={boxShadow:"0 4px 20px 0px rgba(0, 0, 0, 0.14), 0 7px 10px -5px rgba(233, 30, 99, 0.4)"};// old card headers
var orangeCardHeader=Object.assign({background:"linear-gradient(60deg, #ffa726, #fb8c00)"},warningBoxShadow);var greenCardHeader=Object.assign({background:"linear-gradient(60deg, #66bb6a, #43a047)"},successBoxShadow);var redCardHeader=Object.assign({background:"linear-gradient(60deg, #ef5350, #e53935)"},dangerBoxShadow);var blueCardHeader=Object.assign({background:"linear-gradient(60deg, #26c6da, #00acc1)"},infoBoxShadow);var purpleCardHeader=Object.assign({background:"linear-gradient(60deg, #ab47bc, #8e24aa)"},primaryBoxShadow);// new card headers
var warningCardHeader=Object.assign({background:"linear-gradient(60deg, #ffa726, #fb8c00)"},warningBoxShadow);var successCardHeader=Object.assign({background:"linear-gradient(60deg, #66bb6a, #43a047)"},successBoxShadow);var dangerCardHeader=Object.assign({background:"linear-gradient(60deg, #ef5350, #e53935)"},dangerBoxShadow);var infoCardHeader=Object.assign({background:"linear-gradient(60deg, #26c6da, #00acc1)"},infoBoxShadow);var primaryCardHeader=Object.assign({background:"linear-gradient(60deg, #ab47bc, #8e24aa)"},primaryBoxShadow);var roseCardHeader=Object.assign({background:"linear-gradient(60deg, #ec407a, #d81b60)"},roseBoxShadow);var cardActions=Object.assign({margin:"0 20px 10px",paddingTop:"10px",borderTop:"1px solid #eeeeee",height:"auto"},defaultFont);var cardHeader={margin:"-20px 15px 0",borderRadius:"3px",padding:"15px"};var defaultBoxShadow={border:"0",borderRadius:"3px",boxShadow:"0 10px 20px -12px rgba(0, 0, 0, 0.42), 0 3px 20px 0px rgba(0, 0, 0, 0.12), 0 8px 10px -5px rgba(0, 0, 0, 0.2)",padding:"10px 0",transition:"all 150ms ease 0s"};var tooltip={padding:"10px 15px",minWidth:"130px",color:"#FFFFFF",lineHeight:"1.7em",background:"rgba(85,85,85,0.9)",border:"none",borderRadius:"3px",opacity:"1!important",boxShadow:"0 8px 10px 1px rgba(0, 0, 0, 0.14), 0 3px 14px 2px rgba(0, 0, 0, 0.12), 0 5px 5px -3px rgba(0, 0, 0, 0.2)",maxWidth:"200px",textAlign:"center",fontFamily:'"Helvetica Neue",Helvetica,Arial,sans-serif',fontSize:"12px",fontStyle:"normal",fontWeight:"400",textShadow:"none",textTransform:"none",letterSpacing:"normal",wordBreak:"normal",wordSpacing:"normal",wordWrap:"normal",whiteSpace:"normal",lineBreak:"auto"};var title={color:"#3C4858",textDecoration:"none",fontWeight:"300",marginTop:"30px",marginBottom:"25px",minHeight:"32px",fontFamily:"'Roboto', 'Helvetica', 'Arial', sans-serif","& small":{color:"#777",fontSize:"65%",fontWeight:"400",lineHeight:"1"}};var cardTitle=Object.assign({},title,{marginTop:"0",marginBottom:"3px",minHeight:"auto","& a":Object.assign({},title,{marginTop:".625rem",marginBottom:"0.75rem",minHeight:"auto"})});var cardSubtitle={marginTop:"-.375rem"};var cardLink={"& + $cardLink":{marginLeft:"1.25rem"}};

/***/ }),
/* 22 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_styles_withStyles__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_styles_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_styles_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_Card_Card_jsx__ = __webpack_require__(176);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_Card_CardBody_jsx__ = __webpack_require__(177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_Card_CardHeader_jsx__ = __webpack_require__(516);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_Card_CardIcon_jsx__ = __webpack_require__(518);
var styles={cardHeader:{zIndex:"0 !important"},cardTitleActions:{color:"black",display:"flex",justifyContent:"space-between"}};// O objetivo desse component é praticamente encapsular os
// imports e evitar repetição sempre que usar o card.
var ECCard=function ECCard(_ref){var actions=_ref.actions,cardHeaderColor=_ref.cardHeaderColor,classes=_ref.classes,content=_ref.content,hasIcon=_ref.hasIcon,icon=_ref.icon,iconColor=_ref.iconColor,title=_ref.title,titleActionsClass=_ref.titleActionsClass;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_Card_Card_jsx__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_Card_CardHeader_jsx__["a" /* default */],{className:classes.cardHeader,color:cardHeaderColor,icon:hasIcon},icon&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_Card_CardIcon_jsx__["a" /* default */],{color:iconColor},icon),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:titleActionsClass||classes.cardTitleActions},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h4",null,title),actions)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_Card_CardBody_jsx__["a" /* default */],null,content));};ECCard.defaultProps={cardHeaderColor:"rose",hasIcon:true,iconColor:"info"};ECCard.propTypes={actions:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,cardHeaderColor:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(["danger","info","primary","rose","success","warning"]),classes:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,content:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node.isRequired,hasIcon:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,icon:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,iconColor:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(["danger","info","primary","rose","success","warning"]),title:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,titleActionsClass:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string};/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_2__material_ui_core_styles_withStyles___default()(styles)(ECCard));

/***/ }),
/* 23 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return capitalizeString; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return CPFMask; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CNPJMask; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getFromAtob; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return localeString; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return numberToBRL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return removeNonDigits; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return scrollToElement; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return telefoneMask; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return zipCodeMask; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return COLORS; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
var capitalizeString=function capitalizeString(string){return Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["toString"])(string).split(' ').map(__WEBPACK_IMPORTED_MODULE_0_lodash__["capitalize"]).join(' ');};var CPFMask=function CPFMask(){var cpf=arguments.length>0&&arguments[0]!==undefined?arguments[0]:"";if(!cpf)return"";cpf=Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["toString"])(cpf);cpf=cpf.replace(/\D/g,"");cpf=cpf.replace(/(\d{3})(\d)/,"$1.$2");cpf=cpf.replace(/(\d{3})(\d)/,"$1.$2");cpf=cpf.replace(/(\d{3})(\d{1,2})$/,"$1-$2");return cpf;};var CNPJMask=function CNPJMask(CNPJ){if(!CNPJ)return"";CNPJ=Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["toString"])(CNPJ);CNPJ=CNPJ.replace(/\D/g,"");CNPJ=CNPJ.substr(0,14);CNPJ=CNPJ.replace(/(\d{2})(\d)/,"$1.$2");CNPJ=CNPJ.replace(/(\d{3})(\d)/,"$1.$2");CNPJ=CNPJ.replace(/(\d{3})(\d)/,"$1/$2");CNPJ=CNPJ.replace(/(\d{4})(\d)/,"$1-$2");CNPJ=CNPJ.replace(/(\d{2})$/,"$1");return CNPJ;};// TODO: Write test
var getFromAtob=function getFromAtob(params){var results=[];Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["forEach"])(params,function(param){try{var result=atob(param);results.push(result);}catch(e){results.push('');}});return results;};var localeString=function localeString(value){value=value||"";return value.toLocaleString("pt-BR");};var numberToBRL=function numberToBRL(amount){if(!Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["isNumber"])(amount))return'';return new Intl.NumberFormat("pt-BR",{style:"currency",currency:"BRL"}).format(amount);};var removeNonDigits=function removeNonDigits(value){value=Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["toString"])(value);if(value.length===0)return'';return value.replace(/\D/g,'');};var scrollToElement=function scrollToElement(elem){return elem&&elem.scrollIntoView({behavior:"smooth",block:"start",inline:"start"});};var telefoneMask=function telefoneMask(telefone){telefone=removeNonDigits(telefone);if(!telefone)return"";var primeiraParte='('+telefone.substr(0,2)+') '+telefone.substr(2,5);var segundaParte='-'+telefone.substr(7,4);switch(telefone.length){case 1:return'('+telefone;case 2:return'('+telefone.substr(0,2);default:return telefone.length>7?''+primeiraParte+segundaParte:primeiraParte;}};var zipCodeMask=function zipCodeMask(zipCode){zipCode=removeNonDigits(zipCode);return zipCode.substr(0,2)+'.'+zipCode.substr(2,3)+'-'+zipCode.substr(5,3);};var COLORS=['#FF6384','#FF9F40','#4DC9F6','#ACC236','#58595B','#537BC4','#00A950','#166A8F','#8549BA'];

/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function checkDCE() {
  /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */
  if (
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' ||
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function'
  ) {
    return;
  }
  if (false) {
    // This branch is unreachable because this function is only called
    // in production, but the condition is true only in development.
    // Therefore if the branch is still here, dead code elimination wasn't
    // properly applied.
    // Don't change the message. React DevTools relies on it. Also make sure
    // this message doesn't occur elsewhere in this function, or it will cause
    // a false positive.
    throw new Error('^_^');
  }
  try {
    // Verify that the code above has been dead code eliminated (DCE'd).
    __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(checkDCE);
  } catch (err) {
    // DevTools shouldn't crash React, no matter what.
    // We should still report in case we break this code.
    console.error(err);
  }
}

if (true) {
  // DCE check should happen before ReactDOM bundle executes so that
  // DevTools can report bad minification during injection.
  checkDCE();
  module.exports = __webpack_require__(379);
} else {
  module.exports = require('./cjs/react-dom.development.js');
}


/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(730), __esModule: true };

/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _defineProperty = __webpack_require__(303);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      (0, _defineProperty2.default)(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _typeof2 = __webpack_require__(304);

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && ((typeof call === "undefined" ? "undefined" : (0, _typeof3.default)(call)) === "object" || typeof call === "function") ? call : self;
};

/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _setPrototypeOf = __webpack_require__(758);

var _setPrototypeOf2 = _interopRequireDefault(_setPrototypeOf);

var _create = __webpack_require__(762);

var _create2 = _interopRequireDefault(_create);

var _typeof2 = __webpack_require__(304);

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, _typeof3.default)(superClass)));
  }

  subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass;
};

/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var invariant = function(condition, format, a, b, c, d, e, f) {
  if (false) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  }

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error(
        'Minified exception occurred; use the non-minified dev environment ' +
        'for the full error message and additional helpful warnings.'
      );
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(
        format.replace(/%s/g, function() { return args[argIndex++]; })
      );
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
};

module.exports = invariant;


/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _defineProperty = __webpack_require__(303);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (obj, key, value) {
  if (key in obj) {
    (0, _defineProperty2.default)(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true,
})
var MAP = (exports.MAP = "__SECRET_MAP_DO_NOT_USE_OR_YOU_WILL_BE_FIRED")

// export const SKELETON = `__SECRET_SKELETON_DO_NOT_USE_OR_YOU_WILL_BE_FIRED`;

var MARKER = (exports.MARKER =
  "__SECRET_MARKER_DO_NOT_USE_OR_YOU_WILL_BE_FIRED")

var MARKER_WITH_LABEL = (exports.MARKER_WITH_LABEL =
  "__SECRET_MARKER_WITH_LABEL_DO_NOT_USE_OR_YOU_WILL_BE_FIRED")

var RECTANGLE = (exports.RECTANGLE =
  "__SECRET_RECTANGLE_DO_NOT_USE_OR_YOU_WILL_BE_FIRED")

var POLYLINE = (exports.POLYLINE =
  "__SECRET_POLYLINE_DO_NOT_USE_OR_YOU_WILL_BE_FIRED")

var POLYGON = (exports.POLYGON =
  "__SECRET_POLYGON_DO_NOT_USE_OR_YOU_WILL_BE_FIRED")

var CIRCLE = (exports.CIRCLE =
  "__SECRET_CIRCLE_DO_NOT_USE_OR_YOU_WILL_BE_FIRED")

var KML_LAYER = (exports.KML_LAYER =
  "__SECRET_KML_LAYER_DO_NOT_USE_OR_YOU_WILL_BE_FIRED")

var DIRECTIONS_RENDERER = (exports.DIRECTIONS_RENDERER =
  "__SECRET_DIRECTIONS_RENDERER_DO_NOT_USE_OR_YOU_WILL_BE_FIRED")

var HEATMAP_LAYER = (exports.HEATMAP_LAYER =
  "__SECRET_HEATMAP_LAYER_DO_NOT_USE_OR_YOU_WILL_BE_FIRED")

var FUSION_TABLES_LAYER = (exports.FUSION_TABLES_LAYER =
  "__SECRET_FUSION_TABLES_LAYER_DO_NOT_USE_OR_YOU_WILL_BE_FIRED")

var ANCHOR = (exports.ANCHOR =
  "__SECRET_ANCHOR_DO_NOT_USE_OR_YOU_WILL_BE_FIRED")

var INFO_WINDOW = (exports.INFO_WINDOW =
  "__SECRET_INFO_WINDOW_DO_NOT_USE_OR_YOU_WILL_BE_FIRED")

var OVERLAY_VIEW = (exports.OVERLAY_VIEW =
  "__SECRET_OVERLAY_VIEW_DO_NOT_USE_OR_YOU_WILL_BE_FIRED")

var GROUND_LAYER = (exports.GROUND_LAYER =
  "__SECRET_GROUND_LAYER_DO_NOT_USE_OR_YOU_WILL_BE_FIRED")

var DRAWING_MANAGER = (exports.DRAWING_MANAGER =
  "__SECRET_DRAWING_MANAGER_DO_NOT_USE_OR_YOU_WILL_BE_FIRED")

var SEARCH_BOX = (exports.SEARCH_BOX =
  "__SECRET_SEARCH_BOX_DO_NOT_USE_OR_YOU_WILL_BE_FIRED")

var MARKER_CLUSTERER = (exports.MARKER_CLUSTERER =
  "__SECRET_MARKER_CLUSTERER_DO_NOT_USE_OR_YOU_WILL_BE_FIRED")

var INFO_BOX = (exports.INFO_BOX =
  "__SECRET_INFO_BOX_DO_NOT_USE_OR_YOU_WILL_BE_FIRED")

var TRAFFIC_LAYER = (exports.TRAFFIC_LAYER =
  "__SECRET_TRAFFIC_LAYER_DO_NOT_USE_OR_YOU_WILL_BE_FIRED")

var STREET_VIEW_PANORAMA = (exports.STREET_VIEW_PANORAMA =
  "__SECRET_STREET_VIEW_PANORAMA_DO_NOT_USE_OR_YOU_WILL_BE_FIRED")

var BICYCLING_LAYER = (exports.BICYCLING_LAYER =
  "__SECRET_BICYCLING_LAYER_DO_NOT_USE_OR_YOU_WILL_BE_FIRED")


/***/ }),
/* 33 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles_withStyles__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_Button__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_Button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_assets_jss_material_dashboard_pro_react_components_buttonStyle_jsx__ = __webpack_require__(513);
function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}// nodejs library that concatenates classes
// nodejs library to set properties for components
// material-ui components
function RegularButton(_ref){var _classNames;var props=_objectWithoutProperties(_ref,[]);var classes=props.classes,color=props.color,round=props.round,children=props.children,fullWidth=props.fullWidth,disabled=props.disabled,simple=props.simple,size=props.size,block=props.block,link=props.link,justIcon=props.justIcon,className=props.className,muiClasses=props.muiClasses,rest=_objectWithoutProperties(props,["classes","color","round","children","fullWidth","disabled","simple","size","block","link","justIcon","className","muiClasses"]);var btnClasses=__WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classNames={},_defineProperty(_classNames,classes.button,true),_defineProperty(_classNames,classes[size],size),_defineProperty(_classNames,classes[color],color),_defineProperty(_classNames,classes.round,round),_defineProperty(_classNames,classes.fullWidth,fullWidth),_defineProperty(_classNames,classes.disabled,disabled),_defineProperty(_classNames,classes.simple,simple),_defineProperty(_classNames,classes.block,block),_defineProperty(_classNames,classes.link,link),_defineProperty(_classNames,classes.justIcon,justIcon),_defineProperty(_classNames,className,className),_classNames));return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Button___default.a,Object.assign({},rest,{classes:muiClasses,className:btnClasses}),children);}RegularButton.propTypes={classes:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired,color:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOf(["primary","info","success","warning","danger","rose","white","twitter","facebook","google","linkedin","pinterest","youtube","tumblr","github","behance","dribbble","reddit","transparent"]),size:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOf(["sm","lg"]),simple:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,round:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,fullWidth:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,disabled:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,block:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,link:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,justIcon:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,className:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,muiClasses:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object};/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles_withStyles___default()(__WEBPACK_IMPORTED_MODULE_5_assets_jss_material_dashboard_pro_react_components_buttonStyle_jsx__["a" /* default */])(RegularButton));

/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var require;//! moment.js

;(function (global, factory) {
     true ? module.exports = factory() :
    typeof define === 'function' && define.amd ? define(factory) :
    global.moment = factory()
}(this, (function () { 'use strict';

    var hookCallback;

    function hooks () {
        return hookCallback.apply(null, arguments);
    }

    // This is done to register the method called with moment()
    // without creating circular dependencies.
    function setHookCallback (callback) {
        hookCallback = callback;
    }

    function isArray(input) {
        return input instanceof Array || Object.prototype.toString.call(input) === '[object Array]';
    }

    function isObject(input) {
        // IE8 will treat undefined and null as object if it wasn't for
        // input != null
        return input != null && Object.prototype.toString.call(input) === '[object Object]';
    }

    function isObjectEmpty(obj) {
        if (Object.getOwnPropertyNames) {
            return (Object.getOwnPropertyNames(obj).length === 0);
        } else {
            var k;
            for (k in obj) {
                if (obj.hasOwnProperty(k)) {
                    return false;
                }
            }
            return true;
        }
    }

    function isUndefined(input) {
        return input === void 0;
    }

    function isNumber(input) {
        return typeof input === 'number' || Object.prototype.toString.call(input) === '[object Number]';
    }

    function isDate(input) {
        return input instanceof Date || Object.prototype.toString.call(input) === '[object Date]';
    }

    function map(arr, fn) {
        var res = [], i;
        for (i = 0; i < arr.length; ++i) {
            res.push(fn(arr[i], i));
        }
        return res;
    }

    function hasOwnProp(a, b) {
        return Object.prototype.hasOwnProperty.call(a, b);
    }

    function extend(a, b) {
        for (var i in b) {
            if (hasOwnProp(b, i)) {
                a[i] = b[i];
            }
        }

        if (hasOwnProp(b, 'toString')) {
            a.toString = b.toString;
        }

        if (hasOwnProp(b, 'valueOf')) {
            a.valueOf = b.valueOf;
        }

        return a;
    }

    function createUTC (input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, true).utc();
    }

    function defaultParsingFlags() {
        // We need to deep clone this object.
        return {
            empty           : false,
            unusedTokens    : [],
            unusedInput     : [],
            overflow        : -2,
            charsLeftOver   : 0,
            nullInput       : false,
            invalidMonth    : null,
            invalidFormat   : false,
            userInvalidated : false,
            iso             : false,
            parsedDateParts : [],
            meridiem        : null,
            rfc2822         : false,
            weekdayMismatch : false
        };
    }

    function getParsingFlags(m) {
        if (m._pf == null) {
            m._pf = defaultParsingFlags();
        }
        return m._pf;
    }

    var some;
    if (Array.prototype.some) {
        some = Array.prototype.some;
    } else {
        some = function (fun) {
            var t = Object(this);
            var len = t.length >>> 0;

            for (var i = 0; i < len; i++) {
                if (i in t && fun.call(this, t[i], i, t)) {
                    return true;
                }
            }

            return false;
        };
    }

    function isValid(m) {
        if (m._isValid == null) {
            var flags = getParsingFlags(m);
            var parsedParts = some.call(flags.parsedDateParts, function (i) {
                return i != null;
            });
            var isNowValid = !isNaN(m._d.getTime()) &&
                flags.overflow < 0 &&
                !flags.empty &&
                !flags.invalidMonth &&
                !flags.invalidWeekday &&
                !flags.weekdayMismatch &&
                !flags.nullInput &&
                !flags.invalidFormat &&
                !flags.userInvalidated &&
                (!flags.meridiem || (flags.meridiem && parsedParts));

            if (m._strict) {
                isNowValid = isNowValid &&
                    flags.charsLeftOver === 0 &&
                    flags.unusedTokens.length === 0 &&
                    flags.bigHour === undefined;
            }

            if (Object.isFrozen == null || !Object.isFrozen(m)) {
                m._isValid = isNowValid;
            }
            else {
                return isNowValid;
            }
        }
        return m._isValid;
    }

    function createInvalid (flags) {
        var m = createUTC(NaN);
        if (flags != null) {
            extend(getParsingFlags(m), flags);
        }
        else {
            getParsingFlags(m).userInvalidated = true;
        }

        return m;
    }

    // Plugins that add properties should also add the key here (null value),
    // so we can properly clone ourselves.
    var momentProperties = hooks.momentProperties = [];

    function copyConfig(to, from) {
        var i, prop, val;

        if (!isUndefined(from._isAMomentObject)) {
            to._isAMomentObject = from._isAMomentObject;
        }
        if (!isUndefined(from._i)) {
            to._i = from._i;
        }
        if (!isUndefined(from._f)) {
            to._f = from._f;
        }
        if (!isUndefined(from._l)) {
            to._l = from._l;
        }
        if (!isUndefined(from._strict)) {
            to._strict = from._strict;
        }
        if (!isUndefined(from._tzm)) {
            to._tzm = from._tzm;
        }
        if (!isUndefined(from._isUTC)) {
            to._isUTC = from._isUTC;
        }
        if (!isUndefined(from._offset)) {
            to._offset = from._offset;
        }
        if (!isUndefined(from._pf)) {
            to._pf = getParsingFlags(from);
        }
        if (!isUndefined(from._locale)) {
            to._locale = from._locale;
        }

        if (momentProperties.length > 0) {
            for (i = 0; i < momentProperties.length; i++) {
                prop = momentProperties[i];
                val = from[prop];
                if (!isUndefined(val)) {
                    to[prop] = val;
                }
            }
        }

        return to;
    }

    var updateInProgress = false;

    // Moment prototype object
    function Moment(config) {
        copyConfig(this, config);
        this._d = new Date(config._d != null ? config._d.getTime() : NaN);
        if (!this.isValid()) {
            this._d = new Date(NaN);
        }
        // Prevent infinite loop in case updateOffset creates new moment
        // objects.
        if (updateInProgress === false) {
            updateInProgress = true;
            hooks.updateOffset(this);
            updateInProgress = false;
        }
    }

    function isMoment (obj) {
        return obj instanceof Moment || (obj != null && obj._isAMomentObject != null);
    }

    function absFloor (number) {
        if (number < 0) {
            // -0 -> 0
            return Math.ceil(number) || 0;
        } else {
            return Math.floor(number);
        }
    }

    function toInt(argumentForCoercion) {
        var coercedNumber = +argumentForCoercion,
            value = 0;

        if (coercedNumber !== 0 && isFinite(coercedNumber)) {
            value = absFloor(coercedNumber);
        }

        return value;
    }

    // compare two arrays, return the number of differences
    function compareArrays(array1, array2, dontConvert) {
        var len = Math.min(array1.length, array2.length),
            lengthDiff = Math.abs(array1.length - array2.length),
            diffs = 0,
            i;
        for (i = 0; i < len; i++) {
            if ((dontConvert && array1[i] !== array2[i]) ||
                (!dontConvert && toInt(array1[i]) !== toInt(array2[i]))) {
                diffs++;
            }
        }
        return diffs + lengthDiff;
    }

    function warn(msg) {
        if (hooks.suppressDeprecationWarnings === false &&
                (typeof console !==  'undefined') && console.warn) {
            console.warn('Deprecation warning: ' + msg);
        }
    }

    function deprecate(msg, fn) {
        var firstTime = true;

        return extend(function () {
            if (hooks.deprecationHandler != null) {
                hooks.deprecationHandler(null, msg);
            }
            if (firstTime) {
                var args = [];
                var arg;
                for (var i = 0; i < arguments.length; i++) {
                    arg = '';
                    if (typeof arguments[i] === 'object') {
                        arg += '\n[' + i + '] ';
                        for (var key in arguments[0]) {
                            arg += key + ': ' + arguments[0][key] + ', ';
                        }
                        arg = arg.slice(0, -2); // Remove trailing comma and space
                    } else {
                        arg = arguments[i];
                    }
                    args.push(arg);
                }
                warn(msg + '\nArguments: ' + Array.prototype.slice.call(args).join('') + '\n' + (new Error()).stack);
                firstTime = false;
            }
            return fn.apply(this, arguments);
        }, fn);
    }

    var deprecations = {};

    function deprecateSimple(name, msg) {
        if (hooks.deprecationHandler != null) {
            hooks.deprecationHandler(name, msg);
        }
        if (!deprecations[name]) {
            warn(msg);
            deprecations[name] = true;
        }
    }

    hooks.suppressDeprecationWarnings = false;
    hooks.deprecationHandler = null;

    function isFunction(input) {
        return input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
    }

    function set (config) {
        var prop, i;
        for (i in config) {
            prop = config[i];
            if (isFunction(prop)) {
                this[i] = prop;
            } else {
                this['_' + i] = prop;
            }
        }
        this._config = config;
        // Lenient ordinal parsing accepts just a number in addition to
        // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
        // TODO: Remove "ordinalParse" fallback in next major release.
        this._dayOfMonthOrdinalParseLenient = new RegExp(
            (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) +
                '|' + (/\d{1,2}/).source);
    }

    function mergeConfigs(parentConfig, childConfig) {
        var res = extend({}, parentConfig), prop;
        for (prop in childConfig) {
            if (hasOwnProp(childConfig, prop)) {
                if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
                    res[prop] = {};
                    extend(res[prop], parentConfig[prop]);
                    extend(res[prop], childConfig[prop]);
                } else if (childConfig[prop] != null) {
                    res[prop] = childConfig[prop];
                } else {
                    delete res[prop];
                }
            }
        }
        for (prop in parentConfig) {
            if (hasOwnProp(parentConfig, prop) &&
                    !hasOwnProp(childConfig, prop) &&
                    isObject(parentConfig[prop])) {
                // make sure changes to properties don't modify parent config
                res[prop] = extend({}, res[prop]);
            }
        }
        return res;
    }

    function Locale(config) {
        if (config != null) {
            this.set(config);
        }
    }

    var keys;

    if (Object.keys) {
        keys = Object.keys;
    } else {
        keys = function (obj) {
            var i, res = [];
            for (i in obj) {
                if (hasOwnProp(obj, i)) {
                    res.push(i);
                }
            }
            return res;
        };
    }

    var defaultCalendar = {
        sameDay : '[Today at] LT',
        nextDay : '[Tomorrow at] LT',
        nextWeek : 'dddd [at] LT',
        lastDay : '[Yesterday at] LT',
        lastWeek : '[Last] dddd [at] LT',
        sameElse : 'L'
    };

    function calendar (key, mom, now) {
        var output = this._calendar[key] || this._calendar['sameElse'];
        return isFunction(output) ? output.call(mom, now) : output;
    }

    var defaultLongDateFormat = {
        LTS  : 'h:mm:ss A',
        LT   : 'h:mm A',
        L    : 'MM/DD/YYYY',
        LL   : 'MMMM D, YYYY',
        LLL  : 'MMMM D, YYYY h:mm A',
        LLLL : 'dddd, MMMM D, YYYY h:mm A'
    };

    function longDateFormat (key) {
        var format = this._longDateFormat[key],
            formatUpper = this._longDateFormat[key.toUpperCase()];

        if (format || !formatUpper) {
            return format;
        }

        this._longDateFormat[key] = formatUpper.replace(/MMMM|MM|DD|dddd/g, function (val) {
            return val.slice(1);
        });

        return this._longDateFormat[key];
    }

    var defaultInvalidDate = 'Invalid date';

    function invalidDate () {
        return this._invalidDate;
    }

    var defaultOrdinal = '%d';
    var defaultDayOfMonthOrdinalParse = /\d{1,2}/;

    function ordinal (number) {
        return this._ordinal.replace('%d', number);
    }

    var defaultRelativeTime = {
        future : 'in %s',
        past   : '%s ago',
        s  : 'a few seconds',
        ss : '%d seconds',
        m  : 'a minute',
        mm : '%d minutes',
        h  : 'an hour',
        hh : '%d hours',
        d  : 'a day',
        dd : '%d days',
        M  : 'a month',
        MM : '%d months',
        y  : 'a year',
        yy : '%d years'
    };

    function relativeTime (number, withoutSuffix, string, isFuture) {
        var output = this._relativeTime[string];
        return (isFunction(output)) ?
            output(number, withoutSuffix, string, isFuture) :
            output.replace(/%d/i, number);
    }

    function pastFuture (diff, output) {
        var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
        return isFunction(format) ? format(output) : format.replace(/%s/i, output);
    }

    var aliases = {};

    function addUnitAlias (unit, shorthand) {
        var lowerCase = unit.toLowerCase();
        aliases[lowerCase] = aliases[lowerCase + 's'] = aliases[shorthand] = unit;
    }

    function normalizeUnits(units) {
        return typeof units === 'string' ? aliases[units] || aliases[units.toLowerCase()] : undefined;
    }

    function normalizeObjectUnits(inputObject) {
        var normalizedInput = {},
            normalizedProp,
            prop;

        for (prop in inputObject) {
            if (hasOwnProp(inputObject, prop)) {
                normalizedProp = normalizeUnits(prop);
                if (normalizedProp) {
                    normalizedInput[normalizedProp] = inputObject[prop];
                }
            }
        }

        return normalizedInput;
    }

    var priorities = {};

    function addUnitPriority(unit, priority) {
        priorities[unit] = priority;
    }

    function getPrioritizedUnits(unitsObj) {
        var units = [];
        for (var u in unitsObj) {
            units.push({unit: u, priority: priorities[u]});
        }
        units.sort(function (a, b) {
            return a.priority - b.priority;
        });
        return units;
    }

    function zeroFill(number, targetLength, forceSign) {
        var absNumber = '' + Math.abs(number),
            zerosToFill = targetLength - absNumber.length,
            sign = number >= 0;
        return (sign ? (forceSign ? '+' : '') : '-') +
            Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) + absNumber;
    }

    var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|YYYYYY|YYYYY|YYYY|YY|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g;

    var localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g;

    var formatFunctions = {};

    var formatTokenFunctions = {};

    // token:    'M'
    // padded:   ['MM', 2]
    // ordinal:  'Mo'
    // callback: function () { this.month() + 1 }
    function addFormatToken (token, padded, ordinal, callback) {
        var func = callback;
        if (typeof callback === 'string') {
            func = function () {
                return this[callback]();
            };
        }
        if (token) {
            formatTokenFunctions[token] = func;
        }
        if (padded) {
            formatTokenFunctions[padded[0]] = function () {
                return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
            };
        }
        if (ordinal) {
            formatTokenFunctions[ordinal] = function () {
                return this.localeData().ordinal(func.apply(this, arguments), token);
            };
        }
    }

    function removeFormattingTokens(input) {
        if (input.match(/\[[\s\S]/)) {
            return input.replace(/^\[|\]$/g, '');
        }
        return input.replace(/\\/g, '');
    }

    function makeFormatFunction(format) {
        var array = format.match(formattingTokens), i, length;

        for (i = 0, length = array.length; i < length; i++) {
            if (formatTokenFunctions[array[i]]) {
                array[i] = formatTokenFunctions[array[i]];
            } else {
                array[i] = removeFormattingTokens(array[i]);
            }
        }

        return function (mom) {
            var output = '', i;
            for (i = 0; i < length; i++) {
                output += isFunction(array[i]) ? array[i].call(mom, format) : array[i];
            }
            return output;
        };
    }

    // format date using native date object
    function formatMoment(m, format) {
        if (!m.isValid()) {
            return m.localeData().invalidDate();
        }

        format = expandFormat(format, m.localeData());
        formatFunctions[format] = formatFunctions[format] || makeFormatFunction(format);

        return formatFunctions[format](m);
    }

    function expandFormat(format, locale) {
        var i = 5;

        function replaceLongDateFormatTokens(input) {
            return locale.longDateFormat(input) || input;
        }

        localFormattingTokens.lastIndex = 0;
        while (i >= 0 && localFormattingTokens.test(format)) {
            format = format.replace(localFormattingTokens, replaceLongDateFormatTokens);
            localFormattingTokens.lastIndex = 0;
            i -= 1;
        }

        return format;
    }

    var match1         = /\d/;            //       0 - 9
    var match2         = /\d\d/;          //      00 - 99
    var match3         = /\d{3}/;         //     000 - 999
    var match4         = /\d{4}/;         //    0000 - 9999
    var match6         = /[+-]?\d{6}/;    // -999999 - 999999
    var match1to2      = /\d\d?/;         //       0 - 99
    var match3to4      = /\d\d\d\d?/;     //     999 - 9999
    var match5to6      = /\d\d\d\d\d\d?/; //   99999 - 999999
    var match1to3      = /\d{1,3}/;       //       0 - 999
    var match1to4      = /\d{1,4}/;       //       0 - 9999
    var match1to6      = /[+-]?\d{1,6}/;  // -999999 - 999999

    var matchUnsigned  = /\d+/;           //       0 - inf
    var matchSigned    = /[+-]?\d+/;      //    -inf - inf

    var matchOffset    = /Z|[+-]\d\d:?\d\d/gi; // +00:00 -00:00 +0000 -0000 or Z
    var matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi; // +00 -00 +00:00 -00:00 +0000 -0000 or Z

    var matchTimestamp = /[+-]?\d+(\.\d{1,3})?/; // 123456789 123456789.123

    // any word (or two) characters or numbers including two/three word month in arabic.
    // includes scottish gaelic two word and hyphenated months
    var matchWord = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i;

    var regexes = {};

    function addRegexToken (token, regex, strictRegex) {
        regexes[token] = isFunction(regex) ? regex : function (isStrict, localeData) {
            return (isStrict && strictRegex) ? strictRegex : regex;
        };
    }

    function getParseRegexForToken (token, config) {
        if (!hasOwnProp(regexes, token)) {
            return new RegExp(unescapeFormat(token));
        }

        return regexes[token](config._strict, config._locale);
    }

    // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
    function unescapeFormat(s) {
        return regexEscape(s.replace('\\', '').replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function (matched, p1, p2, p3, p4) {
            return p1 || p2 || p3 || p4;
        }));
    }

    function regexEscape(s) {
        return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
    }

    var tokens = {};

    function addParseToken (token, callback) {
        var i, func = callback;
        if (typeof token === 'string') {
            token = [token];
        }
        if (isNumber(callback)) {
            func = function (input, array) {
                array[callback] = toInt(input);
            };
        }
        for (i = 0; i < token.length; i++) {
            tokens[token[i]] = func;
        }
    }

    function addWeekParseToken (token, callback) {
        addParseToken(token, function (input, array, config, token) {
            config._w = config._w || {};
            callback(input, config._w, config, token);
        });
    }

    function addTimeToArrayFromToken(token, input, config) {
        if (input != null && hasOwnProp(tokens, token)) {
            tokens[token](input, config._a, config, token);
        }
    }

    var YEAR = 0;
    var MONTH = 1;
    var DATE = 2;
    var HOUR = 3;
    var MINUTE = 4;
    var SECOND = 5;
    var MILLISECOND = 6;
    var WEEK = 7;
    var WEEKDAY = 8;

    // FORMATTING

    addFormatToken('Y', 0, 0, function () {
        var y = this.year();
        return y <= 9999 ? '' + y : '+' + y;
    });

    addFormatToken(0, ['YY', 2], 0, function () {
        return this.year() % 100;
    });

    addFormatToken(0, ['YYYY',   4],       0, 'year');
    addFormatToken(0, ['YYYYY',  5],       0, 'year');
    addFormatToken(0, ['YYYYYY', 6, true], 0, 'year');

    // ALIASES

    addUnitAlias('year', 'y');

    // PRIORITIES

    addUnitPriority('year', 1);

    // PARSING

    addRegexToken('Y',      matchSigned);
    addRegexToken('YY',     match1to2, match2);
    addRegexToken('YYYY',   match1to4, match4);
    addRegexToken('YYYYY',  match1to6, match6);
    addRegexToken('YYYYYY', match1to6, match6);

    addParseToken(['YYYYY', 'YYYYYY'], YEAR);
    addParseToken('YYYY', function (input, array) {
        array[YEAR] = input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
    });
    addParseToken('YY', function (input, array) {
        array[YEAR] = hooks.parseTwoDigitYear(input);
    });
    addParseToken('Y', function (input, array) {
        array[YEAR] = parseInt(input, 10);
    });

    // HELPERS

    function daysInYear(year) {
        return isLeapYear(year) ? 366 : 365;
    }

    function isLeapYear(year) {
        return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
    }

    // HOOKS

    hooks.parseTwoDigitYear = function (input) {
        return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
    };

    // MOMENTS

    var getSetYear = makeGetSet('FullYear', true);

    function getIsLeapYear () {
        return isLeapYear(this.year());
    }

    function makeGetSet (unit, keepTime) {
        return function (value) {
            if (value != null) {
                set$1(this, unit, value);
                hooks.updateOffset(this, keepTime);
                return this;
            } else {
                return get(this, unit);
            }
        };
    }

    function get (mom, unit) {
        return mom.isValid() ?
            mom._d['get' + (mom._isUTC ? 'UTC' : '') + unit]() : NaN;
    }

    function set$1 (mom, unit, value) {
        if (mom.isValid() && !isNaN(value)) {
            if (unit === 'FullYear' && isLeapYear(mom.year()) && mom.month() === 1 && mom.date() === 29) {
                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value, mom.month(), daysInMonth(value, mom.month()));
            }
            else {
                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value);
            }
        }
    }

    // MOMENTS

    function stringGet (units) {
        units = normalizeUnits(units);
        if (isFunction(this[units])) {
            return this[units]();
        }
        return this;
    }


    function stringSet (units, value) {
        if (typeof units === 'object') {
            units = normalizeObjectUnits(units);
            var prioritized = getPrioritizedUnits(units);
            for (var i = 0; i < prioritized.length; i++) {
                this[prioritized[i].unit](units[prioritized[i].unit]);
            }
        } else {
            units = normalizeUnits(units);
            if (isFunction(this[units])) {
                return this[units](value);
            }
        }
        return this;
    }

    function mod(n, x) {
        return ((n % x) + x) % x;
    }

    var indexOf;

    if (Array.prototype.indexOf) {
        indexOf = Array.prototype.indexOf;
    } else {
        indexOf = function (o) {
            // I know
            var i;
            for (i = 0; i < this.length; ++i) {
                if (this[i] === o) {
                    return i;
                }
            }
            return -1;
        };
    }

    function daysInMonth(year, month) {
        if (isNaN(year) || isNaN(month)) {
            return NaN;
        }
        var modMonth = mod(month, 12);
        year += (month - modMonth) / 12;
        return modMonth === 1 ? (isLeapYear(year) ? 29 : 28) : (31 - modMonth % 7 % 2);
    }

    // FORMATTING

    addFormatToken('M', ['MM', 2], 'Mo', function () {
        return this.month() + 1;
    });

    addFormatToken('MMM', 0, 0, function (format) {
        return this.localeData().monthsShort(this, format);
    });

    addFormatToken('MMMM', 0, 0, function (format) {
        return this.localeData().months(this, format);
    });

    // ALIASES

    addUnitAlias('month', 'M');

    // PRIORITY

    addUnitPriority('month', 8);

    // PARSING

    addRegexToken('M',    match1to2);
    addRegexToken('MM',   match1to2, match2);
    addRegexToken('MMM',  function (isStrict, locale) {
        return locale.monthsShortRegex(isStrict);
    });
    addRegexToken('MMMM', function (isStrict, locale) {
        return locale.monthsRegex(isStrict);
    });

    addParseToken(['M', 'MM'], function (input, array) {
        array[MONTH] = toInt(input) - 1;
    });

    addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
        var month = config._locale.monthsParse(input, token, config._strict);
        // if we didn't find a month name, mark the date as invalid.
        if (month != null) {
            array[MONTH] = month;
        } else {
            getParsingFlags(config).invalidMonth = input;
        }
    });

    // LOCALES

    var MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/;
    var defaultLocaleMonths = 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_');
    function localeMonths (m, format) {
        if (!m) {
            return isArray(this._months) ? this._months :
                this._months['standalone'];
        }
        return isArray(this._months) ? this._months[m.month()] :
            this._months[(this._months.isFormat || MONTHS_IN_FORMAT).test(format) ? 'format' : 'standalone'][m.month()];
    }

    var defaultLocaleMonthsShort = 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_');
    function localeMonthsShort (m, format) {
        if (!m) {
            return isArray(this._monthsShort) ? this._monthsShort :
                this._monthsShort['standalone'];
        }
        return isArray(this._monthsShort) ? this._monthsShort[m.month()] :
            this._monthsShort[MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'][m.month()];
    }

    function handleStrictParse(monthName, format, strict) {
        var i, ii, mom, llc = monthName.toLocaleLowerCase();
        if (!this._monthsParse) {
            // this is not used
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
            for (i = 0; i < 12; ++i) {
                mom = createUTC([2000, i]);
                this._shortMonthsParse[i] = this.monthsShort(mom, '').toLocaleLowerCase();
                this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
            }
        }

        if (strict) {
            if (format === 'MMM') {
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'MMM') {
                ii = indexOf.call(this._shortMonthsParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }

    function localeMonthsParse (monthName, format, strict) {
        var i, mom, regex;

        if (this._monthsParseExact) {
            return handleStrictParse.call(this, monthName, format, strict);
        }

        if (!this._monthsParse) {
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
        }

        // TODO: add sorting
        // Sorting makes sure if one month (or abbr) is a prefix of another
        // see sorting in computeMonthsParse
        for (i = 0; i < 12; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, i]);
            if (strict && !this._longMonthsParse[i]) {
                this._longMonthsParse[i] = new RegExp('^' + this.months(mom, '').replace('.', '') + '$', 'i');
                this._shortMonthsParse[i] = new RegExp('^' + this.monthsShort(mom, '').replace('.', '') + '$', 'i');
            }
            if (!strict && !this._monthsParse[i]) {
                regex = '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
                this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (strict && format === 'MMMM' && this._longMonthsParse[i].test(monthName)) {
                return i;
            } else if (strict && format === 'MMM' && this._shortMonthsParse[i].test(monthName)) {
                return i;
            } else if (!strict && this._monthsParse[i].test(monthName)) {
                return i;
            }
        }
    }

    // MOMENTS

    function setMonth (mom, value) {
        var dayOfMonth;

        if (!mom.isValid()) {
            // No op
            return mom;
        }

        if (typeof value === 'string') {
            if (/^\d+$/.test(value)) {
                value = toInt(value);
            } else {
                value = mom.localeData().monthsParse(value);
                // TODO: Another silent failure?
                if (!isNumber(value)) {
                    return mom;
                }
            }
        }

        dayOfMonth = Math.min(mom.date(), daysInMonth(mom.year(), value));
        mom._d['set' + (mom._isUTC ? 'UTC' : '') + 'Month'](value, dayOfMonth);
        return mom;
    }

    function getSetMonth (value) {
        if (value != null) {
            setMonth(this, value);
            hooks.updateOffset(this, true);
            return this;
        } else {
            return get(this, 'Month');
        }
    }

    function getDaysInMonth () {
        return daysInMonth(this.year(), this.month());
    }

    var defaultMonthsShortRegex = matchWord;
    function monthsShortRegex (isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) {
                computeMonthsParse.call(this);
            }
            if (isStrict) {
                return this._monthsShortStrictRegex;
            } else {
                return this._monthsShortRegex;
            }
        } else {
            if (!hasOwnProp(this, '_monthsShortRegex')) {
                this._monthsShortRegex = defaultMonthsShortRegex;
            }
            return this._monthsShortStrictRegex && isStrict ?
                this._monthsShortStrictRegex : this._monthsShortRegex;
        }
    }

    var defaultMonthsRegex = matchWord;
    function monthsRegex (isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) {
                computeMonthsParse.call(this);
            }
            if (isStrict) {
                return this._monthsStrictRegex;
            } else {
                return this._monthsRegex;
            }
        } else {
            if (!hasOwnProp(this, '_monthsRegex')) {
                this._monthsRegex = defaultMonthsRegex;
            }
            return this._monthsStrictRegex && isStrict ?
                this._monthsStrictRegex : this._monthsRegex;
        }
    }

    function computeMonthsParse () {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }

        var shortPieces = [], longPieces = [], mixedPieces = [],
            i, mom;
        for (i = 0; i < 12; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, i]);
            shortPieces.push(this.monthsShort(mom, ''));
            longPieces.push(this.months(mom, ''));
            mixedPieces.push(this.months(mom, ''));
            mixedPieces.push(this.monthsShort(mom, ''));
        }
        // Sorting makes sure if one month (or abbr) is a prefix of another it
        // will match the longer piece.
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        for (i = 0; i < 12; i++) {
            shortPieces[i] = regexEscape(shortPieces[i]);
            longPieces[i] = regexEscape(longPieces[i]);
        }
        for (i = 0; i < 24; i++) {
            mixedPieces[i] = regexEscape(mixedPieces[i]);
        }

        this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._monthsShortRegex = this._monthsRegex;
        this._monthsStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
        this._monthsShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
    }

    function createDate (y, m, d, h, M, s, ms) {
        // can't just apply() to create a date:
        // https://stackoverflow.com/q/181348
        var date = new Date(y, m, d, h, M, s, ms);

        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0 && isFinite(date.getFullYear())) {
            date.setFullYear(y);
        }
        return date;
    }

    function createUTCDate (y) {
        var date = new Date(Date.UTC.apply(null, arguments));

        // the Date.UTC function remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0 && isFinite(date.getUTCFullYear())) {
            date.setUTCFullYear(y);
        }
        return date;
    }

    // start-of-first-week - start-of-year
    function firstWeekOffset(year, dow, doy) {
        var // first-week day -- which january is always in the first week (4 for iso, 1 for other)
            fwd = 7 + dow - doy,
            // first-week day local weekday -- which local weekday is fwd
            fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;

        return -fwdlw + fwd - 1;
    }

    // https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
        var localWeekday = (7 + weekday - dow) % 7,
            weekOffset = firstWeekOffset(year, dow, doy),
            dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset,
            resYear, resDayOfYear;

        if (dayOfYear <= 0) {
            resYear = year - 1;
            resDayOfYear = daysInYear(resYear) + dayOfYear;
        } else if (dayOfYear > daysInYear(year)) {
            resYear = year + 1;
            resDayOfYear = dayOfYear - daysInYear(year);
        } else {
            resYear = year;
            resDayOfYear = dayOfYear;
        }

        return {
            year: resYear,
            dayOfYear: resDayOfYear
        };
    }

    function weekOfYear(mom, dow, doy) {
        var weekOffset = firstWeekOffset(mom.year(), dow, doy),
            week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1,
            resWeek, resYear;

        if (week < 1) {
            resYear = mom.year() - 1;
            resWeek = week + weeksInYear(resYear, dow, doy);
        } else if (week > weeksInYear(mom.year(), dow, doy)) {
            resWeek = week - weeksInYear(mom.year(), dow, doy);
            resYear = mom.year() + 1;
        } else {
            resYear = mom.year();
            resWeek = week;
        }

        return {
            week: resWeek,
            year: resYear
        };
    }

    function weeksInYear(year, dow, doy) {
        var weekOffset = firstWeekOffset(year, dow, doy),
            weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
        return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
    }

    // FORMATTING

    addFormatToken('w', ['ww', 2], 'wo', 'week');
    addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek');

    // ALIASES

    addUnitAlias('week', 'w');
    addUnitAlias('isoWeek', 'W');

    // PRIORITIES

    addUnitPriority('week', 5);
    addUnitPriority('isoWeek', 5);

    // PARSING

    addRegexToken('w',  match1to2);
    addRegexToken('ww', match1to2, match2);
    addRegexToken('W',  match1to2);
    addRegexToken('WW', match1to2, match2);

    addWeekParseToken(['w', 'ww', 'W', 'WW'], function (input, week, config, token) {
        week[token.substr(0, 1)] = toInt(input);
    });

    // HELPERS

    // LOCALES

    function localeWeek (mom) {
        return weekOfYear(mom, this._week.dow, this._week.doy).week;
    }

    var defaultLocaleWeek = {
        dow : 0, // Sunday is the first day of the week.
        doy : 6  // The week that contains Jan 1st is the first week of the year.
    };

    function localeFirstDayOfWeek () {
        return this._week.dow;
    }

    function localeFirstDayOfYear () {
        return this._week.doy;
    }

    // MOMENTS

    function getSetWeek (input) {
        var week = this.localeData().week(this);
        return input == null ? week : this.add((input - week) * 7, 'd');
    }

    function getSetISOWeek (input) {
        var week = weekOfYear(this, 1, 4).week;
        return input == null ? week : this.add((input - week) * 7, 'd');
    }

    // FORMATTING

    addFormatToken('d', 0, 'do', 'day');

    addFormatToken('dd', 0, 0, function (format) {
        return this.localeData().weekdaysMin(this, format);
    });

    addFormatToken('ddd', 0, 0, function (format) {
        return this.localeData().weekdaysShort(this, format);
    });

    addFormatToken('dddd', 0, 0, function (format) {
        return this.localeData().weekdays(this, format);
    });

    addFormatToken('e', 0, 0, 'weekday');
    addFormatToken('E', 0, 0, 'isoWeekday');

    // ALIASES

    addUnitAlias('day', 'd');
    addUnitAlias('weekday', 'e');
    addUnitAlias('isoWeekday', 'E');

    // PRIORITY
    addUnitPriority('day', 11);
    addUnitPriority('weekday', 11);
    addUnitPriority('isoWeekday', 11);

    // PARSING

    addRegexToken('d',    match1to2);
    addRegexToken('e',    match1to2);
    addRegexToken('E',    match1to2);
    addRegexToken('dd',   function (isStrict, locale) {
        return locale.weekdaysMinRegex(isStrict);
    });
    addRegexToken('ddd',   function (isStrict, locale) {
        return locale.weekdaysShortRegex(isStrict);
    });
    addRegexToken('dddd',   function (isStrict, locale) {
        return locale.weekdaysRegex(isStrict);
    });

    addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config, token) {
        var weekday = config._locale.weekdaysParse(input, token, config._strict);
        // if we didn't get a weekday name, mark the date as invalid
        if (weekday != null) {
            week.d = weekday;
        } else {
            getParsingFlags(config).invalidWeekday = input;
        }
    });

    addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
        week[token] = toInt(input);
    });

    // HELPERS

    function parseWeekday(input, locale) {
        if (typeof input !== 'string') {
            return input;
        }

        if (!isNaN(input)) {
            return parseInt(input, 10);
        }

        input = locale.weekdaysParse(input);
        if (typeof input === 'number') {
            return input;
        }

        return null;
    }

    function parseIsoWeekday(input, locale) {
        if (typeof input === 'string') {
            return locale.weekdaysParse(input) % 7 || 7;
        }
        return isNaN(input) ? null : input;
    }

    // LOCALES

    var defaultLocaleWeekdays = 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_');
    function localeWeekdays (m, format) {
        if (!m) {
            return isArray(this._weekdays) ? this._weekdays :
                this._weekdays['standalone'];
        }
        return isArray(this._weekdays) ? this._weekdays[m.day()] :
            this._weekdays[this._weekdays.isFormat.test(format) ? 'format' : 'standalone'][m.day()];
    }

    var defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_');
    function localeWeekdaysShort (m) {
        return (m) ? this._weekdaysShort[m.day()] : this._weekdaysShort;
    }

    var defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_');
    function localeWeekdaysMin (m) {
        return (m) ? this._weekdaysMin[m.day()] : this._weekdaysMin;
    }

    function handleStrictParse$1(weekdayName, format, strict) {
        var i, ii, mom, llc = weekdayName.toLocaleLowerCase();
        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._minWeekdaysParse = [];

            for (i = 0; i < 7; ++i) {
                mom = createUTC([2000, 1]).day(i);
                this._minWeekdaysParse[i] = this.weekdaysMin(mom, '').toLocaleLowerCase();
                this._shortWeekdaysParse[i] = this.weekdaysShort(mom, '').toLocaleLowerCase();
                this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
            }
        }

        if (strict) {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }

    function localeWeekdaysParse (weekdayName, format, strict) {
        var i, mom, regex;

        if (this._weekdaysParseExact) {
            return handleStrictParse$1.call(this, weekdayName, format, strict);
        }

        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._minWeekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._fullWeekdaysParse = [];
        }

        for (i = 0; i < 7; i++) {
            // make the regex if we don't have it already

            mom = createUTC([2000, 1]).day(i);
            if (strict && !this._fullWeekdaysParse[i]) {
                this._fullWeekdaysParse[i] = new RegExp('^' + this.weekdays(mom, '').replace('.', '\\.?') + '$', 'i');
                this._shortWeekdaysParse[i] = new RegExp('^' + this.weekdaysShort(mom, '').replace('.', '\\.?') + '$', 'i');
                this._minWeekdaysParse[i] = new RegExp('^' + this.weekdaysMin(mom, '').replace('.', '\\.?') + '$', 'i');
            }
            if (!this._weekdaysParse[i]) {
                regex = '^' + this.weekdays(mom, '') + '|^' + this.weekdaysShort(mom, '') + '|^' + this.weekdaysMin(mom, '');
                this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (strict && format === 'dddd' && this._fullWeekdaysParse[i].test(weekdayName)) {
                return i;
            } else if (strict && format === 'ddd' && this._shortWeekdaysParse[i].test(weekdayName)) {
                return i;
            } else if (strict && format === 'dd' && this._minWeekdaysParse[i].test(weekdayName)) {
                return i;
            } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
                return i;
            }
        }
    }

    // MOMENTS

    function getSetDayOfWeek (input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
        if (input != null) {
            input = parseWeekday(input, this.localeData());
            return this.add(input - day, 'd');
        } else {
            return day;
        }
    }

    function getSetLocaleDayOfWeek (input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
        return input == null ? weekday : this.add(input - weekday, 'd');
    }

    function getSetISODayOfWeek (input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }

        // behaves the same as moment#day except
        // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
        // as a setter, sunday should belong to the previous week.

        if (input != null) {
            var weekday = parseIsoWeekday(input, this.localeData());
            return this.day(this.day() % 7 ? weekday : weekday - 7);
        } else {
            return this.day() || 7;
        }
    }

    var defaultWeekdaysRegex = matchWord;
    function weekdaysRegex (isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysStrictRegex;
            } else {
                return this._weekdaysRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                this._weekdaysRegex = defaultWeekdaysRegex;
            }
            return this._weekdaysStrictRegex && isStrict ?
                this._weekdaysStrictRegex : this._weekdaysRegex;
        }
    }

    var defaultWeekdaysShortRegex = matchWord;
    function weekdaysShortRegex (isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysShortStrictRegex;
            } else {
                return this._weekdaysShortRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysShortRegex')) {
                this._weekdaysShortRegex = defaultWeekdaysShortRegex;
            }
            return this._weekdaysShortStrictRegex && isStrict ?
                this._weekdaysShortStrictRegex : this._weekdaysShortRegex;
        }
    }

    var defaultWeekdaysMinRegex = matchWord;
    function weekdaysMinRegex (isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysMinStrictRegex;
            } else {
                return this._weekdaysMinRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysMinRegex')) {
                this._weekdaysMinRegex = defaultWeekdaysMinRegex;
            }
            return this._weekdaysMinStrictRegex && isStrict ?
                this._weekdaysMinStrictRegex : this._weekdaysMinRegex;
        }
    }


    function computeWeekdaysParse () {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }

        var minPieces = [], shortPieces = [], longPieces = [], mixedPieces = [],
            i, mom, minp, shortp, longp;
        for (i = 0; i < 7; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, 1]).day(i);
            minp = this.weekdaysMin(mom, '');
            shortp = this.weekdaysShort(mom, '');
            longp = this.weekdays(mom, '');
            minPieces.push(minp);
            shortPieces.push(shortp);
            longPieces.push(longp);
            mixedPieces.push(minp);
            mixedPieces.push(shortp);
            mixedPieces.push(longp);
        }
        // Sorting makes sure if one weekday (or abbr) is a prefix of another it
        // will match the longer piece.
        minPieces.sort(cmpLenRev);
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        for (i = 0; i < 7; i++) {
            shortPieces[i] = regexEscape(shortPieces[i]);
            longPieces[i] = regexEscape(longPieces[i]);
            mixedPieces[i] = regexEscape(mixedPieces[i]);
        }

        this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._weekdaysShortRegex = this._weekdaysRegex;
        this._weekdaysMinRegex = this._weekdaysRegex;

        this._weekdaysStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
        this._weekdaysShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
        this._weekdaysMinStrictRegex = new RegExp('^(' + minPieces.join('|') + ')', 'i');
    }

    // FORMATTING

    function hFormat() {
        return this.hours() % 12 || 12;
    }

    function kFormat() {
        return this.hours() || 24;
    }

    addFormatToken('H', ['HH', 2], 0, 'hour');
    addFormatToken('h', ['hh', 2], 0, hFormat);
    addFormatToken('k', ['kk', 2], 0, kFormat);

    addFormatToken('hmm', 0, 0, function () {
        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
    });

    addFormatToken('hmmss', 0, 0, function () {
        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2) +
            zeroFill(this.seconds(), 2);
    });

    addFormatToken('Hmm', 0, 0, function () {
        return '' + this.hours() + zeroFill(this.minutes(), 2);
    });

    addFormatToken('Hmmss', 0, 0, function () {
        return '' + this.hours() + zeroFill(this.minutes(), 2) +
            zeroFill(this.seconds(), 2);
    });

    function meridiem (token, lowercase) {
        addFormatToken(token, 0, 0, function () {
            return this.localeData().meridiem(this.hours(), this.minutes(), lowercase);
        });
    }

    meridiem('a', true);
    meridiem('A', false);

    // ALIASES

    addUnitAlias('hour', 'h');

    // PRIORITY
    addUnitPriority('hour', 13);

    // PARSING

    function matchMeridiem (isStrict, locale) {
        return locale._meridiemParse;
    }

    addRegexToken('a',  matchMeridiem);
    addRegexToken('A',  matchMeridiem);
    addRegexToken('H',  match1to2);
    addRegexToken('h',  match1to2);
    addRegexToken('k',  match1to2);
    addRegexToken('HH', match1to2, match2);
    addRegexToken('hh', match1to2, match2);
    addRegexToken('kk', match1to2, match2);

    addRegexToken('hmm', match3to4);
    addRegexToken('hmmss', match5to6);
    addRegexToken('Hmm', match3to4);
    addRegexToken('Hmmss', match5to6);

    addParseToken(['H', 'HH'], HOUR);
    addParseToken(['k', 'kk'], function (input, array, config) {
        var kInput = toInt(input);
        array[HOUR] = kInput === 24 ? 0 : kInput;
    });
    addParseToken(['a', 'A'], function (input, array, config) {
        config._isPm = config._locale.isPM(input);
        config._meridiem = input;
    });
    addParseToken(['h', 'hh'], function (input, array, config) {
        array[HOUR] = toInt(input);
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmm', function (input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmmss', function (input, array, config) {
        var pos1 = input.length - 4;
        var pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('Hmm', function (input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
    });
    addParseToken('Hmmss', function (input, array, config) {
        var pos1 = input.length - 4;
        var pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
    });

    // LOCALES

    function localeIsPM (input) {
        // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
        // Using charAt should be more compatible.
        return ((input + '').toLowerCase().charAt(0) === 'p');
    }

    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i;
    function localeMeridiem (hours, minutes, isLower) {
        if (hours > 11) {
            return isLower ? 'pm' : 'PM';
        } else {
            return isLower ? 'am' : 'AM';
        }
    }


    // MOMENTS

    // Setting the hour should keep the time, because the user explicitly
    // specified which hour they want. So trying to maintain the same hour (in
    // a new timezone) makes sense. Adding/subtracting hours does not follow
    // this rule.
    var getSetHour = makeGetSet('Hours', true);

    var baseConfig = {
        calendar: defaultCalendar,
        longDateFormat: defaultLongDateFormat,
        invalidDate: defaultInvalidDate,
        ordinal: defaultOrdinal,
        dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
        relativeTime: defaultRelativeTime,

        months: defaultLocaleMonths,
        monthsShort: defaultLocaleMonthsShort,

        week: defaultLocaleWeek,

        weekdays: defaultLocaleWeekdays,
        weekdaysMin: defaultLocaleWeekdaysMin,
        weekdaysShort: defaultLocaleWeekdaysShort,

        meridiemParse: defaultLocaleMeridiemParse
    };

    // internal storage for locale config files
    var locales = {};
    var localeFamilies = {};
    var globalLocale;

    function normalizeLocale(key) {
        return key ? key.toLowerCase().replace('_', '-') : key;
    }

    // pick the locale from the array
    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
    function chooseLocale(names) {
        var i = 0, j, next, locale, split;

        while (i < names.length) {
            split = normalizeLocale(names[i]).split('-');
            j = split.length;
            next = normalizeLocale(names[i + 1]);
            next = next ? next.split('-') : null;
            while (j > 0) {
                locale = loadLocale(split.slice(0, j).join('-'));
                if (locale) {
                    return locale;
                }
                if (next && next.length >= j && compareArrays(split, next, true) >= j - 1) {
                    //the next array item is better than a shallower substring of this one
                    break;
                }
                j--;
            }
            i++;
        }
        return globalLocale;
    }

    function loadLocale(name) {
        var oldLocale = null;
        // TODO: Find a better way to register and load all the locales in Node
        if (!locales[name] && (typeof module !== 'undefined') &&
                module && module.exports) {
            try {
                oldLocale = globalLocale._abbr;
                var aliasedRequire = require;
                !(function webpackMissingModule() { var e = new Error("Cannot find module \"./locale\""); e.code = 'MODULE_NOT_FOUND'; throw e; }());
                getSetGlobalLocale(oldLocale);
            } catch (e) {}
        }
        return locales[name];
    }

    // This function will load locale and then set the global locale.  If
    // no arguments are passed in, it will simply return the current global
    // locale key.
    function getSetGlobalLocale (key, values) {
        var data;
        if (key) {
            if (isUndefined(values)) {
                data = getLocale(key);
            }
            else {
                data = defineLocale(key, values);
            }

            if (data) {
                // moment.duration._locale = moment._locale = data;
                globalLocale = data;
            }
            else {
                if ((typeof console !==  'undefined') && console.warn) {
                    //warn user if arguments are passed but the locale could not be set
                    console.warn('Locale ' + key +  ' not found. Did you forget to load it?');
                }
            }
        }

        return globalLocale._abbr;
    }

    function defineLocale (name, config) {
        if (config !== null) {
            var locale, parentConfig = baseConfig;
            config.abbr = name;
            if (locales[name] != null) {
                deprecateSimple('defineLocaleOverride',
                        'use moment.updateLocale(localeName, config) to change ' +
                        'an existing locale. moment.defineLocale(localeName, ' +
                        'config) should only be used for creating a new locale ' +
                        'See http://momentjs.com/guides/#/warnings/define-locale/ for more info.');
                parentConfig = locales[name]._config;
            } else if (config.parentLocale != null) {
                if (locales[config.parentLocale] != null) {
                    parentConfig = locales[config.parentLocale]._config;
                } else {
                    locale = loadLocale(config.parentLocale);
                    if (locale != null) {
                        parentConfig = locale._config;
                    } else {
                        if (!localeFamilies[config.parentLocale]) {
                            localeFamilies[config.parentLocale] = [];
                        }
                        localeFamilies[config.parentLocale].push({
                            name: name,
                            config: config
                        });
                        return null;
                    }
                }
            }
            locales[name] = new Locale(mergeConfigs(parentConfig, config));

            if (localeFamilies[name]) {
                localeFamilies[name].forEach(function (x) {
                    defineLocale(x.name, x.config);
                });
            }

            // backwards compat for now: also set the locale
            // make sure we set the locale AFTER all child locales have been
            // created, so we won't end up with the child locale set.
            getSetGlobalLocale(name);


            return locales[name];
        } else {
            // useful for testing
            delete locales[name];
            return null;
        }
    }

    function updateLocale(name, config) {
        if (config != null) {
            var locale, tmpLocale, parentConfig = baseConfig;
            // MERGE
            tmpLocale = loadLocale(name);
            if (tmpLocale != null) {
                parentConfig = tmpLocale._config;
            }
            config = mergeConfigs(parentConfig, config);
            locale = new Locale(config);
            locale.parentLocale = locales[name];
            locales[name] = locale;

            // backwards compat for now: also set the locale
            getSetGlobalLocale(name);
        } else {
            // pass null for config to unupdate, useful for tests
            if (locales[name] != null) {
                if (locales[name].parentLocale != null) {
                    locales[name] = locales[name].parentLocale;
                } else if (locales[name] != null) {
                    delete locales[name];
                }
            }
        }
        return locales[name];
    }

    // returns locale data
    function getLocale (key) {
        var locale;

        if (key && key._locale && key._locale._abbr) {
            key = key._locale._abbr;
        }

        if (!key) {
            return globalLocale;
        }

        if (!isArray(key)) {
            //short-circuit everything else
            locale = loadLocale(key);
            if (locale) {
                return locale;
            }
            key = [key];
        }

        return chooseLocale(key);
    }

    function listLocales() {
        return keys(locales);
    }

    function checkOverflow (m) {
        var overflow;
        var a = m._a;

        if (a && getParsingFlags(m).overflow === -2) {
            overflow =
                a[MONTH]       < 0 || a[MONTH]       > 11  ? MONTH :
                a[DATE]        < 1 || a[DATE]        > daysInMonth(a[YEAR], a[MONTH]) ? DATE :
                a[HOUR]        < 0 || a[HOUR]        > 24 || (a[HOUR] === 24 && (a[MINUTE] !== 0 || a[SECOND] !== 0 || a[MILLISECOND] !== 0)) ? HOUR :
                a[MINUTE]      < 0 || a[MINUTE]      > 59  ? MINUTE :
                a[SECOND]      < 0 || a[SECOND]      > 59  ? SECOND :
                a[MILLISECOND] < 0 || a[MILLISECOND] > 999 ? MILLISECOND :
                -1;

            if (getParsingFlags(m)._overflowDayOfYear && (overflow < YEAR || overflow > DATE)) {
                overflow = DATE;
            }
            if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
                overflow = WEEK;
            }
            if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
                overflow = WEEKDAY;
            }

            getParsingFlags(m).overflow = overflow;
        }

        return m;
    }

    // Pick the first defined of two or three arguments.
    function defaults(a, b, c) {
        if (a != null) {
            return a;
        }
        if (b != null) {
            return b;
        }
        return c;
    }

    function currentDateArray(config) {
        // hooks is actually the exported moment object
        var nowValue = new Date(hooks.now());
        if (config._useUTC) {
            return [nowValue.getUTCFullYear(), nowValue.getUTCMonth(), nowValue.getUTCDate()];
        }
        return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
    }

    // convert an array to a date.
    // the array should mirror the parameters below
    // note: all values past the year are optional and will default to the lowest possible value.
    // [year, month, day , hour, minute, second, millisecond]
    function configFromArray (config) {
        var i, date, input = [], currentDate, expectedWeekday, yearToUse;

        if (config._d) {
            return;
        }

        currentDate = currentDateArray(config);

        //compute day of the year from weeks and weekdays
        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
            dayOfYearFromWeekInfo(config);
        }

        //if the day of the year is set, figure out what it is
        if (config._dayOfYear != null) {
            yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);

            if (config._dayOfYear > daysInYear(yearToUse) || config._dayOfYear === 0) {
                getParsingFlags(config)._overflowDayOfYear = true;
            }

            date = createUTCDate(yearToUse, 0, config._dayOfYear);
            config._a[MONTH] = date.getUTCMonth();
            config._a[DATE] = date.getUTCDate();
        }

        // Default to current date.
        // * if no year, month, day of month are given, default to today
        // * if day of month is given, default month and year
        // * if month is given, default only year
        // * if year is given, don't default anything
        for (i = 0; i < 3 && config._a[i] == null; ++i) {
            config._a[i] = input[i] = currentDate[i];
        }

        // Zero out whatever was not defaulted, including time
        for (; i < 7; i++) {
            config._a[i] = input[i] = (config._a[i] == null) ? (i === 2 ? 1 : 0) : config._a[i];
        }

        // Check for 24:00:00.000
        if (config._a[HOUR] === 24 &&
                config._a[MINUTE] === 0 &&
                config._a[SECOND] === 0 &&
                config._a[MILLISECOND] === 0) {
            config._nextDay = true;
            config._a[HOUR] = 0;
        }

        config._d = (config._useUTC ? createUTCDate : createDate).apply(null, input);
        expectedWeekday = config._useUTC ? config._d.getUTCDay() : config._d.getDay();

        // Apply timezone offset from input. The actual utcOffset can be changed
        // with parseZone.
        if (config._tzm != null) {
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
        }

        if (config._nextDay) {
            config._a[HOUR] = 24;
        }

        // check for mismatching day of week
        if (config._w && typeof config._w.d !== 'undefined' && config._w.d !== expectedWeekday) {
            getParsingFlags(config).weekdayMismatch = true;
        }
    }

    function dayOfYearFromWeekInfo(config) {
        var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow;

        w = config._w;
        if (w.GG != null || w.W != null || w.E != null) {
            dow = 1;
            doy = 4;

            // TODO: We need to take the current isoWeekYear, but that depends on
            // how we interpret now (local, utc, fixed offset). So create
            // a now version of current config (take local/utc/offset flags, and
            // create now).
            weekYear = defaults(w.GG, config._a[YEAR], weekOfYear(createLocal(), 1, 4).year);
            week = defaults(w.W, 1);
            weekday = defaults(w.E, 1);
            if (weekday < 1 || weekday > 7) {
                weekdayOverflow = true;
            }
        } else {
            dow = config._locale._week.dow;
            doy = config._locale._week.doy;

            var curWeek = weekOfYear(createLocal(), dow, doy);

            weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);

            // Default to current week.
            week = defaults(w.w, curWeek.week);

            if (w.d != null) {
                // weekday -- low day numbers are considered next week
                weekday = w.d;
                if (weekday < 0 || weekday > 6) {
                    weekdayOverflow = true;
                }
            } else if (w.e != null) {
                // local weekday -- counting starts from begining of week
                weekday = w.e + dow;
                if (w.e < 0 || w.e > 6) {
                    weekdayOverflow = true;
                }
            } else {
                // default to begining of week
                weekday = dow;
            }
        }
        if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
            getParsingFlags(config)._overflowWeeks = true;
        } else if (weekdayOverflow != null) {
            getParsingFlags(config)._overflowWeekday = true;
        } else {
            temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
            config._a[YEAR] = temp.year;
            config._dayOfYear = temp.dayOfYear;
        }
    }

    // iso 8601 regex
    // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
    var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;
    var basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;

    var tzRegex = /Z|[+-]\d\d(?::?\d\d)?/;

    var isoDates = [
        ['YYYYYY-MM-DD', /[+-]\d{6}-\d\d-\d\d/],
        ['YYYY-MM-DD', /\d{4}-\d\d-\d\d/],
        ['GGGG-[W]WW-E', /\d{4}-W\d\d-\d/],
        ['GGGG-[W]WW', /\d{4}-W\d\d/, false],
        ['YYYY-DDD', /\d{4}-\d{3}/],
        ['YYYY-MM', /\d{4}-\d\d/, false],
        ['YYYYYYMMDD', /[+-]\d{10}/],
        ['YYYYMMDD', /\d{8}/],
        // YYYYMM is NOT allowed by the standard
        ['GGGG[W]WWE', /\d{4}W\d{3}/],
        ['GGGG[W]WW', /\d{4}W\d{2}/, false],
        ['YYYYDDD', /\d{7}/]
    ];

    // iso time formats and regexes
    var isoTimes = [
        ['HH:mm:ss.SSSS', /\d\d:\d\d:\d\d\.\d+/],
        ['HH:mm:ss,SSSS', /\d\d:\d\d:\d\d,\d+/],
        ['HH:mm:ss', /\d\d:\d\d:\d\d/],
        ['HH:mm', /\d\d:\d\d/],
        ['HHmmss.SSSS', /\d\d\d\d\d\d\.\d+/],
        ['HHmmss,SSSS', /\d\d\d\d\d\d,\d+/],
        ['HHmmss', /\d\d\d\d\d\d/],
        ['HHmm', /\d\d\d\d/],
        ['HH', /\d\d/]
    ];

    var aspNetJsonRegex = /^\/?Date\((\-?\d+)/i;

    // date from iso format
    function configFromISO(config) {
        var i, l,
            string = config._i,
            match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string),
            allowTime, dateFormat, timeFormat, tzFormat;

        if (match) {
            getParsingFlags(config).iso = true;

            for (i = 0, l = isoDates.length; i < l; i++) {
                if (isoDates[i][1].exec(match[1])) {
                    dateFormat = isoDates[i][0];
                    allowTime = isoDates[i][2] !== false;
                    break;
                }
            }
            if (dateFormat == null) {
                config._isValid = false;
                return;
            }
            if (match[3]) {
                for (i = 0, l = isoTimes.length; i < l; i++) {
                    if (isoTimes[i][1].exec(match[3])) {
                        // match[2] should be 'T' or space
                        timeFormat = (match[2] || ' ') + isoTimes[i][0];
                        break;
                    }
                }
                if (timeFormat == null) {
                    config._isValid = false;
                    return;
                }
            }
            if (!allowTime && timeFormat != null) {
                config._isValid = false;
                return;
            }
            if (match[4]) {
                if (tzRegex.exec(match[4])) {
                    tzFormat = 'Z';
                } else {
                    config._isValid = false;
                    return;
                }
            }
            config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
            configFromStringAndFormat(config);
        } else {
            config._isValid = false;
        }
    }

    // RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
    var rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/;

    function extractFromRFC2822Strings(yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr) {
        var result = [
            untruncateYear(yearStr),
            defaultLocaleMonthsShort.indexOf(monthStr),
            parseInt(dayStr, 10),
            parseInt(hourStr, 10),
            parseInt(minuteStr, 10)
        ];

        if (secondStr) {
            result.push(parseInt(secondStr, 10));
        }

        return result;
    }

    function untruncateYear(yearStr) {
        var year = parseInt(yearStr, 10);
        if (year <= 49) {
            return 2000 + year;
        } else if (year <= 999) {
            return 1900 + year;
        }
        return year;
    }

    function preprocessRFC2822(s) {
        // Remove comments and folding whitespace and replace multiple-spaces with a single space
        return s.replace(/\([^)]*\)|[\n\t]/g, ' ').replace(/(\s\s+)/g, ' ').replace(/^\s\s*/, '').replace(/\s\s*$/, '');
    }

    function checkWeekday(weekdayStr, parsedInput, config) {
        if (weekdayStr) {
            // TODO: Replace the vanilla JS Date object with an indepentent day-of-week check.
            var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr),
                weekdayActual = new Date(parsedInput[0], parsedInput[1], parsedInput[2]).getDay();
            if (weekdayProvided !== weekdayActual) {
                getParsingFlags(config).weekdayMismatch = true;
                config._isValid = false;
                return false;
            }
        }
        return true;
    }

    var obsOffsets = {
        UT: 0,
        GMT: 0,
        EDT: -4 * 60,
        EST: -5 * 60,
        CDT: -5 * 60,
        CST: -6 * 60,
        MDT: -6 * 60,
        MST: -7 * 60,
        PDT: -7 * 60,
        PST: -8 * 60
    };

    function calculateOffset(obsOffset, militaryOffset, numOffset) {
        if (obsOffset) {
            return obsOffsets[obsOffset];
        } else if (militaryOffset) {
            // the only allowed military tz is Z
            return 0;
        } else {
            var hm = parseInt(numOffset, 10);
            var m = hm % 100, h = (hm - m) / 100;
            return h * 60 + m;
        }
    }

    // date and time from ref 2822 format
    function configFromRFC2822(config) {
        var match = rfc2822.exec(preprocessRFC2822(config._i));
        if (match) {
            var parsedArray = extractFromRFC2822Strings(match[4], match[3], match[2], match[5], match[6], match[7]);
            if (!checkWeekday(match[1], parsedArray, config)) {
                return;
            }

            config._a = parsedArray;
            config._tzm = calculateOffset(match[8], match[9], match[10]);

            config._d = createUTCDate.apply(null, config._a);
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);

            getParsingFlags(config).rfc2822 = true;
        } else {
            config._isValid = false;
        }
    }

    // date from iso format or fallback
    function configFromString(config) {
        var matched = aspNetJsonRegex.exec(config._i);

        if (matched !== null) {
            config._d = new Date(+matched[1]);
            return;
        }

        configFromISO(config);
        if (config._isValid === false) {
            delete config._isValid;
        } else {
            return;
        }

        configFromRFC2822(config);
        if (config._isValid === false) {
            delete config._isValid;
        } else {
            return;
        }

        // Final attempt, use Input Fallback
        hooks.createFromInputFallback(config);
    }

    hooks.createFromInputFallback = deprecate(
        'value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), ' +
        'which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are ' +
        'discouraged and will be removed in an upcoming major release. Please refer to ' +
        'http://momentjs.com/guides/#/warnings/js-date/ for more info.',
        function (config) {
            config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
        }
    );

    // constant that refers to the ISO standard
    hooks.ISO_8601 = function () {};

    // constant that refers to the RFC 2822 form
    hooks.RFC_2822 = function () {};

    // date from string and format string
    function configFromStringAndFormat(config) {
        // TODO: Move this to another part of the creation flow to prevent circular deps
        if (config._f === hooks.ISO_8601) {
            configFromISO(config);
            return;
        }
        if (config._f === hooks.RFC_2822) {
            configFromRFC2822(config);
            return;
        }
        config._a = [];
        getParsingFlags(config).empty = true;

        // This array is used to make a Date, either with `new Date` or `Date.UTC`
        var string = '' + config._i,
            i, parsedInput, tokens, token, skipped,
            stringLength = string.length,
            totalParsedInputLength = 0;

        tokens = expandFormat(config._f, config._locale).match(formattingTokens) || [];

        for (i = 0; i < tokens.length; i++) {
            token = tokens[i];
            parsedInput = (string.match(getParseRegexForToken(token, config)) || [])[0];
            // console.log('token', token, 'parsedInput', parsedInput,
            //         'regex', getParseRegexForToken(token, config));
            if (parsedInput) {
                skipped = string.substr(0, string.indexOf(parsedInput));
                if (skipped.length > 0) {
                    getParsingFlags(config).unusedInput.push(skipped);
                }
                string = string.slice(string.indexOf(parsedInput) + parsedInput.length);
                totalParsedInputLength += parsedInput.length;
            }
            // don't parse if it's not a known token
            if (formatTokenFunctions[token]) {
                if (parsedInput) {
                    getParsingFlags(config).empty = false;
                }
                else {
                    getParsingFlags(config).unusedTokens.push(token);
                }
                addTimeToArrayFromToken(token, parsedInput, config);
            }
            else if (config._strict && !parsedInput) {
                getParsingFlags(config).unusedTokens.push(token);
            }
        }

        // add remaining unparsed input length to the string
        getParsingFlags(config).charsLeftOver = stringLength - totalParsedInputLength;
        if (string.length > 0) {
            getParsingFlags(config).unusedInput.push(string);
        }

        // clear _12h flag if hour is <= 12
        if (config._a[HOUR] <= 12 &&
            getParsingFlags(config).bigHour === true &&
            config._a[HOUR] > 0) {
            getParsingFlags(config).bigHour = undefined;
        }

        getParsingFlags(config).parsedDateParts = config._a.slice(0);
        getParsingFlags(config).meridiem = config._meridiem;
        // handle meridiem
        config._a[HOUR] = meridiemFixWrap(config._locale, config._a[HOUR], config._meridiem);

        configFromArray(config);
        checkOverflow(config);
    }


    function meridiemFixWrap (locale, hour, meridiem) {
        var isPm;

        if (meridiem == null) {
            // nothing to do
            return hour;
        }
        if (locale.meridiemHour != null) {
            return locale.meridiemHour(hour, meridiem);
        } else if (locale.isPM != null) {
            // Fallback
            isPm = locale.isPM(meridiem);
            if (isPm && hour < 12) {
                hour += 12;
            }
            if (!isPm && hour === 12) {
                hour = 0;
            }
            return hour;
        } else {
            // this is not supposed to happen
            return hour;
        }
    }

    // date from string and array of format strings
    function configFromStringAndArray(config) {
        var tempConfig,
            bestMoment,

            scoreToBeat,
            i,
            currentScore;

        if (config._f.length === 0) {
            getParsingFlags(config).invalidFormat = true;
            config._d = new Date(NaN);
            return;
        }

        for (i = 0; i < config._f.length; i++) {
            currentScore = 0;
            tempConfig = copyConfig({}, config);
            if (config._useUTC != null) {
                tempConfig._useUTC = config._useUTC;
            }
            tempConfig._f = config._f[i];
            configFromStringAndFormat(tempConfig);

            if (!isValid(tempConfig)) {
                continue;
            }

            // if there is any input that was not parsed add a penalty for that format
            currentScore += getParsingFlags(tempConfig).charsLeftOver;

            //or tokens
            currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;

            getParsingFlags(tempConfig).score = currentScore;

            if (scoreToBeat == null || currentScore < scoreToBeat) {
                scoreToBeat = currentScore;
                bestMoment = tempConfig;
            }
        }

        extend(config, bestMoment || tempConfig);
    }

    function configFromObject(config) {
        if (config._d) {
            return;
        }

        var i = normalizeObjectUnits(config._i);
        config._a = map([i.year, i.month, i.day || i.date, i.hour, i.minute, i.second, i.millisecond], function (obj) {
            return obj && parseInt(obj, 10);
        });

        configFromArray(config);
    }

    function createFromConfig (config) {
        var res = new Moment(checkOverflow(prepareConfig(config)));
        if (res._nextDay) {
            // Adding is smart enough around DST
            res.add(1, 'd');
            res._nextDay = undefined;
        }

        return res;
    }

    function prepareConfig (config) {
        var input = config._i,
            format = config._f;

        config._locale = config._locale || getLocale(config._l);

        if (input === null || (format === undefined && input === '')) {
            return createInvalid({nullInput: true});
        }

        if (typeof input === 'string') {
            config._i = input = config._locale.preparse(input);
        }

        if (isMoment(input)) {
            return new Moment(checkOverflow(input));
        } else if (isDate(input)) {
            config._d = input;
        } else if (isArray(format)) {
            configFromStringAndArray(config);
        } else if (format) {
            configFromStringAndFormat(config);
        }  else {
            configFromInput(config);
        }

        if (!isValid(config)) {
            config._d = null;
        }

        return config;
    }

    function configFromInput(config) {
        var input = config._i;
        if (isUndefined(input)) {
            config._d = new Date(hooks.now());
        } else if (isDate(input)) {
            config._d = new Date(input.valueOf());
        } else if (typeof input === 'string') {
            configFromString(config);
        } else if (isArray(input)) {
            config._a = map(input.slice(0), function (obj) {
                return parseInt(obj, 10);
            });
            configFromArray(config);
        } else if (isObject(input)) {
            configFromObject(config);
        } else if (isNumber(input)) {
            // from milliseconds
            config._d = new Date(input);
        } else {
            hooks.createFromInputFallback(config);
        }
    }

    function createLocalOrUTC (input, format, locale, strict, isUTC) {
        var c = {};

        if (locale === true || locale === false) {
            strict = locale;
            locale = undefined;
        }

        if ((isObject(input) && isObjectEmpty(input)) ||
                (isArray(input) && input.length === 0)) {
            input = undefined;
        }
        // object construction must be done this way.
        // https://github.com/moment/moment/issues/1423
        c._isAMomentObject = true;
        c._useUTC = c._isUTC = isUTC;
        c._l = locale;
        c._i = input;
        c._f = format;
        c._strict = strict;

        return createFromConfig(c);
    }

    function createLocal (input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, false);
    }

    var prototypeMin = deprecate(
        'moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/',
        function () {
            var other = createLocal.apply(null, arguments);
            if (this.isValid() && other.isValid()) {
                return other < this ? this : other;
            } else {
                return createInvalid();
            }
        }
    );

    var prototypeMax = deprecate(
        'moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/',
        function () {
            var other = createLocal.apply(null, arguments);
            if (this.isValid() && other.isValid()) {
                return other > this ? this : other;
            } else {
                return createInvalid();
            }
        }
    );

    // Pick a moment m from moments so that m[fn](other) is true for all
    // other. This relies on the function fn to be transitive.
    //
    // moments should either be an array of moment objects or an array, whose
    // first element is an array of moment objects.
    function pickBy(fn, moments) {
        var res, i;
        if (moments.length === 1 && isArray(moments[0])) {
            moments = moments[0];
        }
        if (!moments.length) {
            return createLocal();
        }
        res = moments[0];
        for (i = 1; i < moments.length; ++i) {
            if (!moments[i].isValid() || moments[i][fn](res)) {
                res = moments[i];
            }
        }
        return res;
    }

    // TODO: Use [].sort instead?
    function min () {
        var args = [].slice.call(arguments, 0);

        return pickBy('isBefore', args);
    }

    function max () {
        var args = [].slice.call(arguments, 0);

        return pickBy('isAfter', args);
    }

    var now = function () {
        return Date.now ? Date.now() : +(new Date());
    };

    var ordering = ['year', 'quarter', 'month', 'week', 'day', 'hour', 'minute', 'second', 'millisecond'];

    function isDurationValid(m) {
        for (var key in m) {
            if (!(indexOf.call(ordering, key) !== -1 && (m[key] == null || !isNaN(m[key])))) {
                return false;
            }
        }

        var unitHasDecimal = false;
        for (var i = 0; i < ordering.length; ++i) {
            if (m[ordering[i]]) {
                if (unitHasDecimal) {
                    return false; // only allow non-integers for smallest unit
                }
                if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) {
                    unitHasDecimal = true;
                }
            }
        }

        return true;
    }

    function isValid$1() {
        return this._isValid;
    }

    function createInvalid$1() {
        return createDuration(NaN);
    }

    function Duration (duration) {
        var normalizedInput = normalizeObjectUnits(duration),
            years = normalizedInput.year || 0,
            quarters = normalizedInput.quarter || 0,
            months = normalizedInput.month || 0,
            weeks = normalizedInput.week || 0,
            days = normalizedInput.day || 0,
            hours = normalizedInput.hour || 0,
            minutes = normalizedInput.minute || 0,
            seconds = normalizedInput.second || 0,
            milliseconds = normalizedInput.millisecond || 0;

        this._isValid = isDurationValid(normalizedInput);

        // representation for dateAddRemove
        this._milliseconds = +milliseconds +
            seconds * 1e3 + // 1000
            minutes * 6e4 + // 1000 * 60
            hours * 1000 * 60 * 60; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
        // Because of dateAddRemove treats 24 hours as different from a
        // day when working around DST, we need to store them separately
        this._days = +days +
            weeks * 7;
        // It is impossible to translate months into days without knowing
        // which months you are are talking about, so we have to store
        // it separately.
        this._months = +months +
            quarters * 3 +
            years * 12;

        this._data = {};

        this._locale = getLocale();

        this._bubble();
    }

    function isDuration (obj) {
        return obj instanceof Duration;
    }

    function absRound (number) {
        if (number < 0) {
            return Math.round(-1 * number) * -1;
        } else {
            return Math.round(number);
        }
    }

    // FORMATTING

    function offset (token, separator) {
        addFormatToken(token, 0, 0, function () {
            var offset = this.utcOffset();
            var sign = '+';
            if (offset < 0) {
                offset = -offset;
                sign = '-';
            }
            return sign + zeroFill(~~(offset / 60), 2) + separator + zeroFill(~~(offset) % 60, 2);
        });
    }

    offset('Z', ':');
    offset('ZZ', '');

    // PARSING

    addRegexToken('Z',  matchShortOffset);
    addRegexToken('ZZ', matchShortOffset);
    addParseToken(['Z', 'ZZ'], function (input, array, config) {
        config._useUTC = true;
        config._tzm = offsetFromString(matchShortOffset, input);
    });

    // HELPERS

    // timezone chunker
    // '+10:00' > ['10',  '00']
    // '-1530'  > ['-15', '30']
    var chunkOffset = /([\+\-]|\d\d)/gi;

    function offsetFromString(matcher, string) {
        var matches = (string || '').match(matcher);

        if (matches === null) {
            return null;
        }

        var chunk   = matches[matches.length - 1] || [];
        var parts   = (chunk + '').match(chunkOffset) || ['-', 0, 0];
        var minutes = +(parts[1] * 60) + toInt(parts[2]);

        return minutes === 0 ?
          0 :
          parts[0] === '+' ? minutes : -minutes;
    }

    // Return a moment from input, that is local/utc/zone equivalent to model.
    function cloneWithOffset(input, model) {
        var res, diff;
        if (model._isUTC) {
            res = model.clone();
            diff = (isMoment(input) || isDate(input) ? input.valueOf() : createLocal(input).valueOf()) - res.valueOf();
            // Use low-level api, because this fn is low-level api.
            res._d.setTime(res._d.valueOf() + diff);
            hooks.updateOffset(res, false);
            return res;
        } else {
            return createLocal(input).local();
        }
    }

    function getDateOffset (m) {
        // On Firefox.24 Date#getTimezoneOffset returns a floating point.
        // https://github.com/moment/moment/pull/1871
        return -Math.round(m._d.getTimezoneOffset() / 15) * 15;
    }

    // HOOKS

    // This function will be called whenever a moment is mutated.
    // It is intended to keep the offset in sync with the timezone.
    hooks.updateOffset = function () {};

    // MOMENTS

    // keepLocalTime = true means only change the timezone, without
    // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
    // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
    // +0200, so we adjust the time as needed, to be valid.
    //
    // Keeping the time actually adds/subtracts (one hour)
    // from the actual represented time. That is why we call updateOffset
    // a second time. In case it wants us to change the offset again
    // _changeInProgress == true case, then we have to adjust, because
    // there is no such time in the given timezone.
    function getSetOffset (input, keepLocalTime, keepMinutes) {
        var offset = this._offset || 0,
            localAdjust;
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        if (input != null) {
            if (typeof input === 'string') {
                input = offsetFromString(matchShortOffset, input);
                if (input === null) {
                    return this;
                }
            } else if (Math.abs(input) < 16 && !keepMinutes) {
                input = input * 60;
            }
            if (!this._isUTC && keepLocalTime) {
                localAdjust = getDateOffset(this);
            }
            this._offset = input;
            this._isUTC = true;
            if (localAdjust != null) {
                this.add(localAdjust, 'm');
            }
            if (offset !== input) {
                if (!keepLocalTime || this._changeInProgress) {
                    addSubtract(this, createDuration(input - offset, 'm'), 1, false);
                } else if (!this._changeInProgress) {
                    this._changeInProgress = true;
                    hooks.updateOffset(this, true);
                    this._changeInProgress = null;
                }
            }
            return this;
        } else {
            return this._isUTC ? offset : getDateOffset(this);
        }
    }

    function getSetZone (input, keepLocalTime) {
        if (input != null) {
            if (typeof input !== 'string') {
                input = -input;
            }

            this.utcOffset(input, keepLocalTime);

            return this;
        } else {
            return -this.utcOffset();
        }
    }

    function setOffsetToUTC (keepLocalTime) {
        return this.utcOffset(0, keepLocalTime);
    }

    function setOffsetToLocal (keepLocalTime) {
        if (this._isUTC) {
            this.utcOffset(0, keepLocalTime);
            this._isUTC = false;

            if (keepLocalTime) {
                this.subtract(getDateOffset(this), 'm');
            }
        }
        return this;
    }

    function setOffsetToParsedOffset () {
        if (this._tzm != null) {
            this.utcOffset(this._tzm, false, true);
        } else if (typeof this._i === 'string') {
            var tZone = offsetFromString(matchOffset, this._i);
            if (tZone != null) {
                this.utcOffset(tZone);
            }
            else {
                this.utcOffset(0, true);
            }
        }
        return this;
    }

    function hasAlignedHourOffset (input) {
        if (!this.isValid()) {
            return false;
        }
        input = input ? createLocal(input).utcOffset() : 0;

        return (this.utcOffset() - input) % 60 === 0;
    }

    function isDaylightSavingTime () {
        return (
            this.utcOffset() > this.clone().month(0).utcOffset() ||
            this.utcOffset() > this.clone().month(5).utcOffset()
        );
    }

    function isDaylightSavingTimeShifted () {
        if (!isUndefined(this._isDSTShifted)) {
            return this._isDSTShifted;
        }

        var c = {};

        copyConfig(c, this);
        c = prepareConfig(c);

        if (c._a) {
            var other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
            this._isDSTShifted = this.isValid() &&
                compareArrays(c._a, other.toArray()) > 0;
        } else {
            this._isDSTShifted = false;
        }

        return this._isDSTShifted;
    }

    function isLocal () {
        return this.isValid() ? !this._isUTC : false;
    }

    function isUtcOffset () {
        return this.isValid() ? this._isUTC : false;
    }

    function isUtc () {
        return this.isValid() ? this._isUTC && this._offset === 0 : false;
    }

    // ASP.NET json date format regex
    var aspNetRegex = /^(\-|\+)?(?:(\d*)[. ])?(\d+)\:(\d+)(?:\:(\d+)(\.\d*)?)?$/;

    // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
    // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
    // and further modified to allow for strings containing both week and day
    var isoRegex = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;

    function createDuration (input, key) {
        var duration = input,
            // matching against regexp is expensive, do it on demand
            match = null,
            sign,
            ret,
            diffRes;

        if (isDuration(input)) {
            duration = {
                ms : input._milliseconds,
                d  : input._days,
                M  : input._months
            };
        } else if (isNumber(input)) {
            duration = {};
            if (key) {
                duration[key] = input;
            } else {
                duration.milliseconds = input;
            }
        } else if (!!(match = aspNetRegex.exec(input))) {
            sign = (match[1] === '-') ? -1 : 1;
            duration = {
                y  : 0,
                d  : toInt(match[DATE])                         * sign,
                h  : toInt(match[HOUR])                         * sign,
                m  : toInt(match[MINUTE])                       * sign,
                s  : toInt(match[SECOND])                       * sign,
                ms : toInt(absRound(match[MILLISECOND] * 1000)) * sign // the millisecond decimal point is included in the match
            };
        } else if (!!(match = isoRegex.exec(input))) {
            sign = (match[1] === '-') ? -1 : (match[1] === '+') ? 1 : 1;
            duration = {
                y : parseIso(match[2], sign),
                M : parseIso(match[3], sign),
                w : parseIso(match[4], sign),
                d : parseIso(match[5], sign),
                h : parseIso(match[6], sign),
                m : parseIso(match[7], sign),
                s : parseIso(match[8], sign)
            };
        } else if (duration == null) {// checks for null or undefined
            duration = {};
        } else if (typeof duration === 'object' && ('from' in duration || 'to' in duration)) {
            diffRes = momentsDifference(createLocal(duration.from), createLocal(duration.to));

            duration = {};
            duration.ms = diffRes.milliseconds;
            duration.M = diffRes.months;
        }

        ret = new Duration(duration);

        if (isDuration(input) && hasOwnProp(input, '_locale')) {
            ret._locale = input._locale;
        }

        return ret;
    }

    createDuration.fn = Duration.prototype;
    createDuration.invalid = createInvalid$1;

    function parseIso (inp, sign) {
        // We'd normally use ~~inp for this, but unfortunately it also
        // converts floats to ints.
        // inp may be undefined, so careful calling replace on it.
        var res = inp && parseFloat(inp.replace(',', '.'));
        // apply sign while we're at it
        return (isNaN(res) ? 0 : res) * sign;
    }

    function positiveMomentsDifference(base, other) {
        var res = {milliseconds: 0, months: 0};

        res.months = other.month() - base.month() +
            (other.year() - base.year()) * 12;
        if (base.clone().add(res.months, 'M').isAfter(other)) {
            --res.months;
        }

        res.milliseconds = +other - +(base.clone().add(res.months, 'M'));

        return res;
    }

    function momentsDifference(base, other) {
        var res;
        if (!(base.isValid() && other.isValid())) {
            return {milliseconds: 0, months: 0};
        }

        other = cloneWithOffset(other, base);
        if (base.isBefore(other)) {
            res = positiveMomentsDifference(base, other);
        } else {
            res = positiveMomentsDifference(other, base);
            res.milliseconds = -res.milliseconds;
            res.months = -res.months;
        }

        return res;
    }

    // TODO: remove 'name' arg after deprecation is removed
    function createAdder(direction, name) {
        return function (val, period) {
            var dur, tmp;
            //invert the arguments, but complain about it
            if (period !== null && !isNaN(+period)) {
                deprecateSimple(name, 'moment().' + name  + '(period, number) is deprecated. Please use moment().' + name + '(number, period). ' +
                'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.');
                tmp = val; val = period; period = tmp;
            }

            val = typeof val === 'string' ? +val : val;
            dur = createDuration(val, period);
            addSubtract(this, dur, direction);
            return this;
        };
    }

    function addSubtract (mom, duration, isAdding, updateOffset) {
        var milliseconds = duration._milliseconds,
            days = absRound(duration._days),
            months = absRound(duration._months);

        if (!mom.isValid()) {
            // No op
            return;
        }

        updateOffset = updateOffset == null ? true : updateOffset;

        if (months) {
            setMonth(mom, get(mom, 'Month') + months * isAdding);
        }
        if (days) {
            set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
        }
        if (milliseconds) {
            mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
        }
        if (updateOffset) {
            hooks.updateOffset(mom, days || months);
        }
    }

    var add      = createAdder(1, 'add');
    var subtract = createAdder(-1, 'subtract');

    function getCalendarFormat(myMoment, now) {
        var diff = myMoment.diff(now, 'days', true);
        return diff < -6 ? 'sameElse' :
                diff < -1 ? 'lastWeek' :
                diff < 0 ? 'lastDay' :
                diff < 1 ? 'sameDay' :
                diff < 2 ? 'nextDay' :
                diff < 7 ? 'nextWeek' : 'sameElse';
    }

    function calendar$1 (time, formats) {
        // We want to compare the start of today, vs this.
        // Getting start-of-today depends on whether we're local/utc/offset or not.
        var now = time || createLocal(),
            sod = cloneWithOffset(now, this).startOf('day'),
            format = hooks.calendarFormat(this, sod) || 'sameElse';

        var output = formats && (isFunction(formats[format]) ? formats[format].call(this, now) : formats[format]);

        return this.format(output || this.localeData().calendar(format, this, createLocal(now)));
    }

    function clone () {
        return new Moment(this);
    }

    function isAfter (input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(!isUndefined(units) ? units : 'millisecond');
        if (units === 'millisecond') {
            return this.valueOf() > localInput.valueOf();
        } else {
            return localInput.valueOf() < this.clone().startOf(units).valueOf();
        }
    }

    function isBefore (input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(!isUndefined(units) ? units : 'millisecond');
        if (units === 'millisecond') {
            return this.valueOf() < localInput.valueOf();
        } else {
            return this.clone().endOf(units).valueOf() < localInput.valueOf();
        }
    }

    function isBetween (from, to, units, inclusivity) {
        inclusivity = inclusivity || '()';
        return (inclusivity[0] === '(' ? this.isAfter(from, units) : !this.isBefore(from, units)) &&
            (inclusivity[1] === ')' ? this.isBefore(to, units) : !this.isAfter(to, units));
    }

    function isSame (input, units) {
        var localInput = isMoment(input) ? input : createLocal(input),
            inputMs;
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units || 'millisecond');
        if (units === 'millisecond') {
            return this.valueOf() === localInput.valueOf();
        } else {
            inputMs = localInput.valueOf();
            return this.clone().startOf(units).valueOf() <= inputMs && inputMs <= this.clone().endOf(units).valueOf();
        }
    }

    function isSameOrAfter (input, units) {
        return this.isSame(input, units) || this.isAfter(input,units);
    }

    function isSameOrBefore (input, units) {
        return this.isSame(input, units) || this.isBefore(input,units);
    }

    function diff (input, units, asFloat) {
        var that,
            zoneDelta,
            output;

        if (!this.isValid()) {
            return NaN;
        }

        that = cloneWithOffset(input, this);

        if (!that.isValid()) {
            return NaN;
        }

        zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;

        units = normalizeUnits(units);

        switch (units) {
            case 'year': output = monthDiff(this, that) / 12; break;
            case 'month': output = monthDiff(this, that); break;
            case 'quarter': output = monthDiff(this, that) / 3; break;
            case 'second': output = (this - that) / 1e3; break; // 1000
            case 'minute': output = (this - that) / 6e4; break; // 1000 * 60
            case 'hour': output = (this - that) / 36e5; break; // 1000 * 60 * 60
            case 'day': output = (this - that - zoneDelta) / 864e5; break; // 1000 * 60 * 60 * 24, negate dst
            case 'week': output = (this - that - zoneDelta) / 6048e5; break; // 1000 * 60 * 60 * 24 * 7, negate dst
            default: output = this - that;
        }

        return asFloat ? output : absFloor(output);
    }

    function monthDiff (a, b) {
        // difference in months
        var wholeMonthDiff = ((b.year() - a.year()) * 12) + (b.month() - a.month()),
            // b is in (anchor - 1 month, anchor + 1 month)
            anchor = a.clone().add(wholeMonthDiff, 'months'),
            anchor2, adjust;

        if (b - anchor < 0) {
            anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor - anchor2);
        } else {
            anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor2 - anchor);
        }

        //check for negative zero, return zero if negative zero
        return -(wholeMonthDiff + adjust) || 0;
    }

    hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
    hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';

    function toString () {
        return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
    }

    function toISOString(keepOffset) {
        if (!this.isValid()) {
            return null;
        }
        var utc = keepOffset !== true;
        var m = utc ? this.clone().utc() : this;
        if (m.year() < 0 || m.year() > 9999) {
            return formatMoment(m, utc ? 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYYYY-MM-DD[T]HH:mm:ss.SSSZ');
        }
        if (isFunction(Date.prototype.toISOString)) {
            // native implementation is ~50x faster, use it when we can
            if (utc) {
                return this.toDate().toISOString();
            } else {
                return new Date(this.valueOf() + this.utcOffset() * 60 * 1000).toISOString().replace('Z', formatMoment(m, 'Z'));
            }
        }
        return formatMoment(m, utc ? 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYY-MM-DD[T]HH:mm:ss.SSSZ');
    }

    /**
     * Return a human readable representation of a moment that can
     * also be evaluated to get a new moment which is the same
     *
     * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
     */
    function inspect () {
        if (!this.isValid()) {
            return 'moment.invalid(/* ' + this._i + ' */)';
        }
        var func = 'moment';
        var zone = '';
        if (!this.isLocal()) {
            func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
            zone = 'Z';
        }
        var prefix = '[' + func + '("]';
        var year = (0 <= this.year() && this.year() <= 9999) ? 'YYYY' : 'YYYYYY';
        var datetime = '-MM-DD[T]HH:mm:ss.SSS';
        var suffix = zone + '[")]';

        return this.format(prefix + year + datetime + suffix);
    }

    function format (inputString) {
        if (!inputString) {
            inputString = this.isUtc() ? hooks.defaultFormatUtc : hooks.defaultFormat;
        }
        var output = formatMoment(this, inputString);
        return this.localeData().postformat(output);
    }

    function from (time, withoutSuffix) {
        if (this.isValid() &&
                ((isMoment(time) && time.isValid()) ||
                 createLocal(time).isValid())) {
            return createDuration({to: this, from: time}).locale(this.locale()).humanize(!withoutSuffix);
        } else {
            return this.localeData().invalidDate();
        }
    }

    function fromNow (withoutSuffix) {
        return this.from(createLocal(), withoutSuffix);
    }

    function to (time, withoutSuffix) {
        if (this.isValid() &&
                ((isMoment(time) && time.isValid()) ||
                 createLocal(time).isValid())) {
            return createDuration({from: this, to: time}).locale(this.locale()).humanize(!withoutSuffix);
        } else {
            return this.localeData().invalidDate();
        }
    }

    function toNow (withoutSuffix) {
        return this.to(createLocal(), withoutSuffix);
    }

    // If passed a locale key, it will set the locale for this
    // instance.  Otherwise, it will return the locale configuration
    // variables for this instance.
    function locale (key) {
        var newLocaleData;

        if (key === undefined) {
            return this._locale._abbr;
        } else {
            newLocaleData = getLocale(key);
            if (newLocaleData != null) {
                this._locale = newLocaleData;
            }
            return this;
        }
    }

    var lang = deprecate(
        'moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.',
        function (key) {
            if (key === undefined) {
                return this.localeData();
            } else {
                return this.locale(key);
            }
        }
    );

    function localeData () {
        return this._locale;
    }

    function startOf (units) {
        units = normalizeUnits(units);
        // the following switch intentionally omits break keywords
        // to utilize falling through the cases.
        switch (units) {
            case 'year':
                this.month(0);
                /* falls through */
            case 'quarter':
            case 'month':
                this.date(1);
                /* falls through */
            case 'week':
            case 'isoWeek':
            case 'day':
            case 'date':
                this.hours(0);
                /* falls through */
            case 'hour':
                this.minutes(0);
                /* falls through */
            case 'minute':
                this.seconds(0);
                /* falls through */
            case 'second':
                this.milliseconds(0);
        }

        // weeks are a special case
        if (units === 'week') {
            this.weekday(0);
        }
        if (units === 'isoWeek') {
            this.isoWeekday(1);
        }

        // quarters are also special
        if (units === 'quarter') {
            this.month(Math.floor(this.month() / 3) * 3);
        }

        return this;
    }

    function endOf (units) {
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond') {
            return this;
        }

        // 'date' is an alias for 'day', so it should be considered as such.
        if (units === 'date') {
            units = 'day';
        }

        return this.startOf(units).add(1, (units === 'isoWeek' ? 'week' : units)).subtract(1, 'ms');
    }

    function valueOf () {
        return this._d.valueOf() - ((this._offset || 0) * 60000);
    }

    function unix () {
        return Math.floor(this.valueOf() / 1000);
    }

    function toDate () {
        return new Date(this.valueOf());
    }

    function toArray () {
        var m = this;
        return [m.year(), m.month(), m.date(), m.hour(), m.minute(), m.second(), m.millisecond()];
    }

    function toObject () {
        var m = this;
        return {
            years: m.year(),
            months: m.month(),
            date: m.date(),
            hours: m.hours(),
            minutes: m.minutes(),
            seconds: m.seconds(),
            milliseconds: m.milliseconds()
        };
    }

    function toJSON () {
        // new Date(NaN).toJSON() === null
        return this.isValid() ? this.toISOString() : null;
    }

    function isValid$2 () {
        return isValid(this);
    }

    function parsingFlags () {
        return extend({}, getParsingFlags(this));
    }

    function invalidAt () {
        return getParsingFlags(this).overflow;
    }

    function creationData() {
        return {
            input: this._i,
            format: this._f,
            locale: this._locale,
            isUTC: this._isUTC,
            strict: this._strict
        };
    }

    // FORMATTING

    addFormatToken(0, ['gg', 2], 0, function () {
        return this.weekYear() % 100;
    });

    addFormatToken(0, ['GG', 2], 0, function () {
        return this.isoWeekYear() % 100;
    });

    function addWeekYearFormatToken (token, getter) {
        addFormatToken(0, [token, token.length], 0, getter);
    }

    addWeekYearFormatToken('gggg',     'weekYear');
    addWeekYearFormatToken('ggggg',    'weekYear');
    addWeekYearFormatToken('GGGG',  'isoWeekYear');
    addWeekYearFormatToken('GGGGG', 'isoWeekYear');

    // ALIASES

    addUnitAlias('weekYear', 'gg');
    addUnitAlias('isoWeekYear', 'GG');

    // PRIORITY

    addUnitPriority('weekYear', 1);
    addUnitPriority('isoWeekYear', 1);


    // PARSING

    addRegexToken('G',      matchSigned);
    addRegexToken('g',      matchSigned);
    addRegexToken('GG',     match1to2, match2);
    addRegexToken('gg',     match1to2, match2);
    addRegexToken('GGGG',   match1to4, match4);
    addRegexToken('gggg',   match1to4, match4);
    addRegexToken('GGGGG',  match1to6, match6);
    addRegexToken('ggggg',  match1to6, match6);

    addWeekParseToken(['gggg', 'ggggg', 'GGGG', 'GGGGG'], function (input, week, config, token) {
        week[token.substr(0, 2)] = toInt(input);
    });

    addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
        week[token] = hooks.parseTwoDigitYear(input);
    });

    // MOMENTS

    function getSetWeekYear (input) {
        return getSetWeekYearHelper.call(this,
                input,
                this.week(),
                this.weekday(),
                this.localeData()._week.dow,
                this.localeData()._week.doy);
    }

    function getSetISOWeekYear (input) {
        return getSetWeekYearHelper.call(this,
                input, this.isoWeek(), this.isoWeekday(), 1, 4);
    }

    function getISOWeeksInYear () {
        return weeksInYear(this.year(), 1, 4);
    }

    function getWeeksInYear () {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
    }

    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
        var weeksTarget;
        if (input == null) {
            return weekOfYear(this, dow, doy).year;
        } else {
            weeksTarget = weeksInYear(input, dow, doy);
            if (week > weeksTarget) {
                week = weeksTarget;
            }
            return setWeekAll.call(this, input, week, weekday, dow, doy);
        }
    }

    function setWeekAll(weekYear, week, weekday, dow, doy) {
        var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy),
            date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);

        this.year(date.getUTCFullYear());
        this.month(date.getUTCMonth());
        this.date(date.getUTCDate());
        return this;
    }

    // FORMATTING

    addFormatToken('Q', 0, 'Qo', 'quarter');

    // ALIASES

    addUnitAlias('quarter', 'Q');

    // PRIORITY

    addUnitPriority('quarter', 7);

    // PARSING

    addRegexToken('Q', match1);
    addParseToken('Q', function (input, array) {
        array[MONTH] = (toInt(input) - 1) * 3;
    });

    // MOMENTS

    function getSetQuarter (input) {
        return input == null ? Math.ceil((this.month() + 1) / 3) : this.month((input - 1) * 3 + this.month() % 3);
    }

    // FORMATTING

    addFormatToken('D', ['DD', 2], 'Do', 'date');

    // ALIASES

    addUnitAlias('date', 'D');

    // PRIORITY
    addUnitPriority('date', 9);

    // PARSING

    addRegexToken('D',  match1to2);
    addRegexToken('DD', match1to2, match2);
    addRegexToken('Do', function (isStrict, locale) {
        // TODO: Remove "ordinalParse" fallback in next major release.
        return isStrict ?
          (locale._dayOfMonthOrdinalParse || locale._ordinalParse) :
          locale._dayOfMonthOrdinalParseLenient;
    });

    addParseToken(['D', 'DD'], DATE);
    addParseToken('Do', function (input, array) {
        array[DATE] = toInt(input.match(match1to2)[0]);
    });

    // MOMENTS

    var getSetDayOfMonth = makeGetSet('Date', true);

    // FORMATTING

    addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear');

    // ALIASES

    addUnitAlias('dayOfYear', 'DDD');

    // PRIORITY
    addUnitPriority('dayOfYear', 4);

    // PARSING

    addRegexToken('DDD',  match1to3);
    addRegexToken('DDDD', match3);
    addParseToken(['DDD', 'DDDD'], function (input, array, config) {
        config._dayOfYear = toInt(input);
    });

    // HELPERS

    // MOMENTS

    function getSetDayOfYear (input) {
        var dayOfYear = Math.round((this.clone().startOf('day') - this.clone().startOf('year')) / 864e5) + 1;
        return input == null ? dayOfYear : this.add((input - dayOfYear), 'd');
    }

    // FORMATTING

    addFormatToken('m', ['mm', 2], 0, 'minute');

    // ALIASES

    addUnitAlias('minute', 'm');

    // PRIORITY

    addUnitPriority('minute', 14);

    // PARSING

    addRegexToken('m',  match1to2);
    addRegexToken('mm', match1to2, match2);
    addParseToken(['m', 'mm'], MINUTE);

    // MOMENTS

    var getSetMinute = makeGetSet('Minutes', false);

    // FORMATTING

    addFormatToken('s', ['ss', 2], 0, 'second');

    // ALIASES

    addUnitAlias('second', 's');

    // PRIORITY

    addUnitPriority('second', 15);

    // PARSING

    addRegexToken('s',  match1to2);
    addRegexToken('ss', match1to2, match2);
    addParseToken(['s', 'ss'], SECOND);

    // MOMENTS

    var getSetSecond = makeGetSet('Seconds', false);

    // FORMATTING

    addFormatToken('S', 0, 0, function () {
        return ~~(this.millisecond() / 100);
    });

    addFormatToken(0, ['SS', 2], 0, function () {
        return ~~(this.millisecond() / 10);
    });

    addFormatToken(0, ['SSS', 3], 0, 'millisecond');
    addFormatToken(0, ['SSSS', 4], 0, function () {
        return this.millisecond() * 10;
    });
    addFormatToken(0, ['SSSSS', 5], 0, function () {
        return this.millisecond() * 100;
    });
    addFormatToken(0, ['SSSSSS', 6], 0, function () {
        return this.millisecond() * 1000;
    });
    addFormatToken(0, ['SSSSSSS', 7], 0, function () {
        return this.millisecond() * 10000;
    });
    addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
        return this.millisecond() * 100000;
    });
    addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
        return this.millisecond() * 1000000;
    });


    // ALIASES

    addUnitAlias('millisecond', 'ms');

    // PRIORITY

    addUnitPriority('millisecond', 16);

    // PARSING

    addRegexToken('S',    match1to3, match1);
    addRegexToken('SS',   match1to3, match2);
    addRegexToken('SSS',  match1to3, match3);

    var token;
    for (token = 'SSSS'; token.length <= 9; token += 'S') {
        addRegexToken(token, matchUnsigned);
    }

    function parseMs(input, array) {
        array[MILLISECOND] = toInt(('0.' + input) * 1000);
    }

    for (token = 'S'; token.length <= 9; token += 'S') {
        addParseToken(token, parseMs);
    }
    // MOMENTS

    var getSetMillisecond = makeGetSet('Milliseconds', false);

    // FORMATTING

    addFormatToken('z',  0, 0, 'zoneAbbr');
    addFormatToken('zz', 0, 0, 'zoneName');

    // MOMENTS

    function getZoneAbbr () {
        return this._isUTC ? 'UTC' : '';
    }

    function getZoneName () {
        return this._isUTC ? 'Coordinated Universal Time' : '';
    }

    var proto = Moment.prototype;

    proto.add               = add;
    proto.calendar          = calendar$1;
    proto.clone             = clone;
    proto.diff              = diff;
    proto.endOf             = endOf;
    proto.format            = format;
    proto.from              = from;
    proto.fromNow           = fromNow;
    proto.to                = to;
    proto.toNow             = toNow;
    proto.get               = stringGet;
    proto.invalidAt         = invalidAt;
    proto.isAfter           = isAfter;
    proto.isBefore          = isBefore;
    proto.isBetween         = isBetween;
    proto.isSame            = isSame;
    proto.isSameOrAfter     = isSameOrAfter;
    proto.isSameOrBefore    = isSameOrBefore;
    proto.isValid           = isValid$2;
    proto.lang              = lang;
    proto.locale            = locale;
    proto.localeData        = localeData;
    proto.max               = prototypeMax;
    proto.min               = prototypeMin;
    proto.parsingFlags      = parsingFlags;
    proto.set               = stringSet;
    proto.startOf           = startOf;
    proto.subtract          = subtract;
    proto.toArray           = toArray;
    proto.toObject          = toObject;
    proto.toDate            = toDate;
    proto.toISOString       = toISOString;
    proto.inspect           = inspect;
    proto.toJSON            = toJSON;
    proto.toString          = toString;
    proto.unix              = unix;
    proto.valueOf           = valueOf;
    proto.creationData      = creationData;
    proto.year       = getSetYear;
    proto.isLeapYear = getIsLeapYear;
    proto.weekYear    = getSetWeekYear;
    proto.isoWeekYear = getSetISOWeekYear;
    proto.quarter = proto.quarters = getSetQuarter;
    proto.month       = getSetMonth;
    proto.daysInMonth = getDaysInMonth;
    proto.week           = proto.weeks        = getSetWeek;
    proto.isoWeek        = proto.isoWeeks     = getSetISOWeek;
    proto.weeksInYear    = getWeeksInYear;
    proto.isoWeeksInYear = getISOWeeksInYear;
    proto.date       = getSetDayOfMonth;
    proto.day        = proto.days             = getSetDayOfWeek;
    proto.weekday    = getSetLocaleDayOfWeek;
    proto.isoWeekday = getSetISODayOfWeek;
    proto.dayOfYear  = getSetDayOfYear;
    proto.hour = proto.hours = getSetHour;
    proto.minute = proto.minutes = getSetMinute;
    proto.second = proto.seconds = getSetSecond;
    proto.millisecond = proto.milliseconds = getSetMillisecond;
    proto.utcOffset            = getSetOffset;
    proto.utc                  = setOffsetToUTC;
    proto.local                = setOffsetToLocal;
    proto.parseZone            = setOffsetToParsedOffset;
    proto.hasAlignedHourOffset = hasAlignedHourOffset;
    proto.isDST                = isDaylightSavingTime;
    proto.isLocal              = isLocal;
    proto.isUtcOffset          = isUtcOffset;
    proto.isUtc                = isUtc;
    proto.isUTC                = isUtc;
    proto.zoneAbbr = getZoneAbbr;
    proto.zoneName = getZoneName;
    proto.dates  = deprecate('dates accessor is deprecated. Use date instead.', getSetDayOfMonth);
    proto.months = deprecate('months accessor is deprecated. Use month instead', getSetMonth);
    proto.years  = deprecate('years accessor is deprecated. Use year instead', getSetYear);
    proto.zone   = deprecate('moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/', getSetZone);
    proto.isDSTShifted = deprecate('isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information', isDaylightSavingTimeShifted);

    function createUnix (input) {
        return createLocal(input * 1000);
    }

    function createInZone () {
        return createLocal.apply(null, arguments).parseZone();
    }

    function preParsePostFormat (string) {
        return string;
    }

    var proto$1 = Locale.prototype;

    proto$1.calendar        = calendar;
    proto$1.longDateFormat  = longDateFormat;
    proto$1.invalidDate     = invalidDate;
    proto$1.ordinal         = ordinal;
    proto$1.preparse        = preParsePostFormat;
    proto$1.postformat      = preParsePostFormat;
    proto$1.relativeTime    = relativeTime;
    proto$1.pastFuture      = pastFuture;
    proto$1.set             = set;

    proto$1.months            =        localeMonths;
    proto$1.monthsShort       =        localeMonthsShort;
    proto$1.monthsParse       =        localeMonthsParse;
    proto$1.monthsRegex       = monthsRegex;
    proto$1.monthsShortRegex  = monthsShortRegex;
    proto$1.week = localeWeek;
    proto$1.firstDayOfYear = localeFirstDayOfYear;
    proto$1.firstDayOfWeek = localeFirstDayOfWeek;

    proto$1.weekdays       =        localeWeekdays;
    proto$1.weekdaysMin    =        localeWeekdaysMin;
    proto$1.weekdaysShort  =        localeWeekdaysShort;
    proto$1.weekdaysParse  =        localeWeekdaysParse;

    proto$1.weekdaysRegex       =        weekdaysRegex;
    proto$1.weekdaysShortRegex  =        weekdaysShortRegex;
    proto$1.weekdaysMinRegex    =        weekdaysMinRegex;

    proto$1.isPM = localeIsPM;
    proto$1.meridiem = localeMeridiem;

    function get$1 (format, index, field, setter) {
        var locale = getLocale();
        var utc = createUTC().set(setter, index);
        return locale[field](utc, format);
    }

    function listMonthsImpl (format, index, field) {
        if (isNumber(format)) {
            index = format;
            format = undefined;
        }

        format = format || '';

        if (index != null) {
            return get$1(format, index, field, 'month');
        }

        var i;
        var out = [];
        for (i = 0; i < 12; i++) {
            out[i] = get$1(format, i, field, 'month');
        }
        return out;
    }

    // ()
    // (5)
    // (fmt, 5)
    // (fmt)
    // (true)
    // (true, 5)
    // (true, fmt, 5)
    // (true, fmt)
    function listWeekdaysImpl (localeSorted, format, index, field) {
        if (typeof localeSorted === 'boolean') {
            if (isNumber(format)) {
                index = format;
                format = undefined;
            }

            format = format || '';
        } else {
            format = localeSorted;
            index = format;
            localeSorted = false;

            if (isNumber(format)) {
                index = format;
                format = undefined;
            }

            format = format || '';
        }

        var locale = getLocale(),
            shift = localeSorted ? locale._week.dow : 0;

        if (index != null) {
            return get$1(format, (index + shift) % 7, field, 'day');
        }

        var i;
        var out = [];
        for (i = 0; i < 7; i++) {
            out[i] = get$1(format, (i + shift) % 7, field, 'day');
        }
        return out;
    }

    function listMonths (format, index) {
        return listMonthsImpl(format, index, 'months');
    }

    function listMonthsShort (format, index) {
        return listMonthsImpl(format, index, 'monthsShort');
    }

    function listWeekdays (localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
    }

    function listWeekdaysShort (localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
    }

    function listWeekdaysMin (localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
    }

    getSetGlobalLocale('en', {
        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
        ordinal : function (number) {
            var b = number % 10,
                output = (toInt(number % 100 / 10) === 1) ? 'th' :
                (b === 1) ? 'st' :
                (b === 2) ? 'nd' :
                (b === 3) ? 'rd' : 'th';
            return number + output;
        }
    });

    // Side effect imports

    hooks.lang = deprecate('moment.lang is deprecated. Use moment.locale instead.', getSetGlobalLocale);
    hooks.langData = deprecate('moment.langData is deprecated. Use moment.localeData instead.', getLocale);

    var mathAbs = Math.abs;

    function abs () {
        var data           = this._data;

        this._milliseconds = mathAbs(this._milliseconds);
        this._days         = mathAbs(this._days);
        this._months       = mathAbs(this._months);

        data.milliseconds  = mathAbs(data.milliseconds);
        data.seconds       = mathAbs(data.seconds);
        data.minutes       = mathAbs(data.minutes);
        data.hours         = mathAbs(data.hours);
        data.months        = mathAbs(data.months);
        data.years         = mathAbs(data.years);

        return this;
    }

    function addSubtract$1 (duration, input, value, direction) {
        var other = createDuration(input, value);

        duration._milliseconds += direction * other._milliseconds;
        duration._days         += direction * other._days;
        duration._months       += direction * other._months;

        return duration._bubble();
    }

    // supports only 2.0-style add(1, 's') or add(duration)
    function add$1 (input, value) {
        return addSubtract$1(this, input, value, 1);
    }

    // supports only 2.0-style subtract(1, 's') or subtract(duration)
    function subtract$1 (input, value) {
        return addSubtract$1(this, input, value, -1);
    }

    function absCeil (number) {
        if (number < 0) {
            return Math.floor(number);
        } else {
            return Math.ceil(number);
        }
    }

    function bubble () {
        var milliseconds = this._milliseconds;
        var days         = this._days;
        var months       = this._months;
        var data         = this._data;
        var seconds, minutes, hours, years, monthsFromDays;

        // if we have a mix of positive and negative values, bubble down first
        // check: https://github.com/moment/moment/issues/2166
        if (!((milliseconds >= 0 && days >= 0 && months >= 0) ||
                (milliseconds <= 0 && days <= 0 && months <= 0))) {
            milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
            days = 0;
            months = 0;
        }

        // The following code bubbles up values, see the tests for
        // examples of what that means.
        data.milliseconds = milliseconds % 1000;

        seconds           = absFloor(milliseconds / 1000);
        data.seconds      = seconds % 60;

        minutes           = absFloor(seconds / 60);
        data.minutes      = minutes % 60;

        hours             = absFloor(minutes / 60);
        data.hours        = hours % 24;

        days += absFloor(hours / 24);

        // convert days to months
        monthsFromDays = absFloor(daysToMonths(days));
        months += monthsFromDays;
        days -= absCeil(monthsToDays(monthsFromDays));

        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;

        data.days   = days;
        data.months = months;
        data.years  = years;

        return this;
    }

    function daysToMonths (days) {
        // 400 years have 146097 days (taking into account leap year rules)
        // 400 years have 12 months === 4800
        return days * 4800 / 146097;
    }

    function monthsToDays (months) {
        // the reverse of daysToMonths
        return months * 146097 / 4800;
    }

    function as (units) {
        if (!this.isValid()) {
            return NaN;
        }
        var days;
        var months;
        var milliseconds = this._milliseconds;

        units = normalizeUnits(units);

        if (units === 'month' || units === 'year') {
            days   = this._days   + milliseconds / 864e5;
            months = this._months + daysToMonths(days);
            return units === 'month' ? months : months / 12;
        } else {
            // handle milliseconds separately because of floating point math errors (issue #1867)
            days = this._days + Math.round(monthsToDays(this._months));
            switch (units) {
                case 'week'   : return days / 7     + milliseconds / 6048e5;
                case 'day'    : return days         + milliseconds / 864e5;
                case 'hour'   : return days * 24    + milliseconds / 36e5;
                case 'minute' : return days * 1440  + milliseconds / 6e4;
                case 'second' : return days * 86400 + milliseconds / 1000;
                // Math.floor prevents floating point math errors here
                case 'millisecond': return Math.floor(days * 864e5) + milliseconds;
                default: throw new Error('Unknown unit ' + units);
            }
        }
    }

    // TODO: Use this.as('ms')?
    function valueOf$1 () {
        if (!this.isValid()) {
            return NaN;
        }
        return (
            this._milliseconds +
            this._days * 864e5 +
            (this._months % 12) * 2592e6 +
            toInt(this._months / 12) * 31536e6
        );
    }

    function makeAs (alias) {
        return function () {
            return this.as(alias);
        };
    }

    var asMilliseconds = makeAs('ms');
    var asSeconds      = makeAs('s');
    var asMinutes      = makeAs('m');
    var asHours        = makeAs('h');
    var asDays         = makeAs('d');
    var asWeeks        = makeAs('w');
    var asMonths       = makeAs('M');
    var asYears        = makeAs('y');

    function clone$1 () {
        return createDuration(this);
    }

    function get$2 (units) {
        units = normalizeUnits(units);
        return this.isValid() ? this[units + 's']() : NaN;
    }

    function makeGetter(name) {
        return function () {
            return this.isValid() ? this._data[name] : NaN;
        };
    }

    var milliseconds = makeGetter('milliseconds');
    var seconds      = makeGetter('seconds');
    var minutes      = makeGetter('minutes');
    var hours        = makeGetter('hours');
    var days         = makeGetter('days');
    var months       = makeGetter('months');
    var years        = makeGetter('years');

    function weeks () {
        return absFloor(this.days() / 7);
    }

    var round = Math.round;
    var thresholds = {
        ss: 44,         // a few seconds to seconds
        s : 45,         // seconds to minute
        m : 45,         // minutes to hour
        h : 22,         // hours to day
        d : 26,         // days to month
        M : 11          // months to year
    };

    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
        return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
    }

    function relativeTime$1 (posNegDuration, withoutSuffix, locale) {
        var duration = createDuration(posNegDuration).abs();
        var seconds  = round(duration.as('s'));
        var minutes  = round(duration.as('m'));
        var hours    = round(duration.as('h'));
        var days     = round(duration.as('d'));
        var months   = round(duration.as('M'));
        var years    = round(duration.as('y'));

        var a = seconds <= thresholds.ss && ['s', seconds]  ||
                seconds < thresholds.s   && ['ss', seconds] ||
                minutes <= 1             && ['m']           ||
                minutes < thresholds.m   && ['mm', minutes] ||
                hours   <= 1             && ['h']           ||
                hours   < thresholds.h   && ['hh', hours]   ||
                days    <= 1             && ['d']           ||
                days    < thresholds.d   && ['dd', days]    ||
                months  <= 1             && ['M']           ||
                months  < thresholds.M   && ['MM', months]  ||
                years   <= 1             && ['y']           || ['yy', years];

        a[2] = withoutSuffix;
        a[3] = +posNegDuration > 0;
        a[4] = locale;
        return substituteTimeAgo.apply(null, a);
    }

    // This function allows you to set the rounding function for relative time strings
    function getSetRelativeTimeRounding (roundingFunction) {
        if (roundingFunction === undefined) {
            return round;
        }
        if (typeof(roundingFunction) === 'function') {
            round = roundingFunction;
            return true;
        }
        return false;
    }

    // This function allows you to set a threshold for relative time strings
    function getSetRelativeTimeThreshold (threshold, limit) {
        if (thresholds[threshold] === undefined) {
            return false;
        }
        if (limit === undefined) {
            return thresholds[threshold];
        }
        thresholds[threshold] = limit;
        if (threshold === 's') {
            thresholds.ss = limit - 1;
        }
        return true;
    }

    function humanize (withSuffix) {
        if (!this.isValid()) {
            return this.localeData().invalidDate();
        }

        var locale = this.localeData();
        var output = relativeTime$1(this, !withSuffix, locale);

        if (withSuffix) {
            output = locale.pastFuture(+this, output);
        }

        return locale.postformat(output);
    }

    var abs$1 = Math.abs;

    function sign(x) {
        return ((x > 0) - (x < 0)) || +x;
    }

    function toISOString$1() {
        // for ISO strings we do not use the normal bubbling rules:
        //  * milliseconds bubble up until they become hours
        //  * days do not bubble at all
        //  * months bubble up until they become years
        // This is because there is no context-free conversion between hours and days
        // (think of clock changes)
        // and also not between days and months (28-31 days per month)
        if (!this.isValid()) {
            return this.localeData().invalidDate();
        }

        var seconds = abs$1(this._milliseconds) / 1000;
        var days         = abs$1(this._days);
        var months       = abs$1(this._months);
        var minutes, hours, years;

        // 3600 seconds -> 60 minutes -> 1 hour
        minutes           = absFloor(seconds / 60);
        hours             = absFloor(minutes / 60);
        seconds %= 60;
        minutes %= 60;

        // 12 months -> 1 year
        years  = absFloor(months / 12);
        months %= 12;


        // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
        var Y = years;
        var M = months;
        var D = days;
        var h = hours;
        var m = minutes;
        var s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, '') : '';
        var total = this.asSeconds();

        if (!total) {
            // this is the same as C#'s (Noda) and python (isodate)...
            // but not other JS (goog.date)
            return 'P0D';
        }

        var totalSign = total < 0 ? '-' : '';
        var ymSign = sign(this._months) !== sign(total) ? '-' : '';
        var daysSign = sign(this._days) !== sign(total) ? '-' : '';
        var hmsSign = sign(this._milliseconds) !== sign(total) ? '-' : '';

        return totalSign + 'P' +
            (Y ? ymSign + Y + 'Y' : '') +
            (M ? ymSign + M + 'M' : '') +
            (D ? daysSign + D + 'D' : '') +
            ((h || m || s) ? 'T' : '') +
            (h ? hmsSign + h + 'H' : '') +
            (m ? hmsSign + m + 'M' : '') +
            (s ? hmsSign + s + 'S' : '');
    }

    var proto$2 = Duration.prototype;

    proto$2.isValid        = isValid$1;
    proto$2.abs            = abs;
    proto$2.add            = add$1;
    proto$2.subtract       = subtract$1;
    proto$2.as             = as;
    proto$2.asMilliseconds = asMilliseconds;
    proto$2.asSeconds      = asSeconds;
    proto$2.asMinutes      = asMinutes;
    proto$2.asHours        = asHours;
    proto$2.asDays         = asDays;
    proto$2.asWeeks        = asWeeks;
    proto$2.asMonths       = asMonths;
    proto$2.asYears        = asYears;
    proto$2.valueOf        = valueOf$1;
    proto$2._bubble        = bubble;
    proto$2.clone          = clone$1;
    proto$2.get            = get$2;
    proto$2.milliseconds   = milliseconds;
    proto$2.seconds        = seconds;
    proto$2.minutes        = minutes;
    proto$2.hours          = hours;
    proto$2.days           = days;
    proto$2.weeks          = weeks;
    proto$2.months         = months;
    proto$2.years          = years;
    proto$2.humanize       = humanize;
    proto$2.toISOString    = toISOString$1;
    proto$2.toString       = toISOString$1;
    proto$2.toJSON         = toISOString$1;
    proto$2.locale         = locale;
    proto$2.localeData     = localeData;

    proto$2.toIsoString = deprecate('toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)', toISOString$1);
    proto$2.lang = lang;

    // Side effect imports

    // FORMATTING

    addFormatToken('X', 0, 0, 'unix');
    addFormatToken('x', 0, 0, 'valueOf');

    // PARSING

    addRegexToken('x', matchSigned);
    addRegexToken('X', matchTimestamp);
    addParseToken('X', function (input, array, config) {
        config._d = new Date(parseFloat(input, 10) * 1000);
    });
    addParseToken('x', function (input, array, config) {
        config._d = new Date(toInt(input));
    });

    // Side effect imports


    hooks.version = '2.22.2';

    setHookCallback(createLocal);

    hooks.fn                    = proto;
    hooks.min                   = min;
    hooks.max                   = max;
    hooks.now                   = now;
    hooks.utc                   = createUTC;
    hooks.unix                  = createUnix;
    hooks.months                = listMonths;
    hooks.isDate                = isDate;
    hooks.locale                = getSetGlobalLocale;
    hooks.invalid               = createInvalid;
    hooks.duration              = createDuration;
    hooks.isMoment              = isMoment;
    hooks.weekdays              = listWeekdays;
    hooks.parseZone             = createInZone;
    hooks.localeData            = getLocale;
    hooks.isDuration            = isDuration;
    hooks.monthsShort           = listMonthsShort;
    hooks.weekdaysMin           = listWeekdaysMin;
    hooks.defineLocale          = defineLocale;
    hooks.updateLocale          = updateLocale;
    hooks.locales               = listLocales;
    hooks.weekdaysShort         = listWeekdaysShort;
    hooks.normalizeUnits        = normalizeUnits;
    hooks.relativeTimeRounding  = getSetRelativeTimeRounding;
    hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
    hooks.calendarFormat        = getCalendarFormat;
    hooks.prototype             = proto;

    // currently HTML5 input type only supports 24-hour formats
    hooks.HTML5_FMT = {
        DATETIME_LOCAL: 'YYYY-MM-DDTHH:mm',             // <input type="datetime-local" />
        DATETIME_LOCAL_SECONDS: 'YYYY-MM-DDTHH:mm:ss',  // <input type="datetime-local" step="1" />
        DATETIME_LOCAL_MS: 'YYYY-MM-DDTHH:mm:ss.SSS',   // <input type="datetime-local" step="0.001" />
        DATE: 'YYYY-MM-DD',                             // <input type="date" />
        TIME: 'HH:mm',                                  // <input type="time" />
        TIME_SECONDS: 'HH:mm:ss',                       // <input type="time" step="1" />
        TIME_MS: 'HH:mm:ss.SSS',                        // <input type="time" step="0.001" />
        WEEK: 'YYYY-[W]WW',                             // <input type="week" />
        MONTH: 'YYYY-MM'                                // <input type="month" />
    };

    return hooks;

})));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(94)(module)))

/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true,
})

var _bind2 = __webpack_require__(142)

var _bind3 = _interopRequireDefault(_bind2)

var _isFunction2 = __webpack_require__(143)

var _isFunction3 = _interopRequireDefault(_isFunction2)

var _reduce3 = __webpack_require__(814)

var _reduce4 = _interopRequireDefault(_reduce3)

var _forEach2 = __webpack_require__(890)

var _forEach3 = _interopRequireDefault(_forEach2)

var _lowerFirst2 = __webpack_require__(892)

var _lowerFirst3 = _interopRequireDefault(_lowerFirst2)

var _has2 = __webpack_require__(899)

var _has3 = _interopRequireDefault(_has2)

exports.construct = construct
exports.componentDidMount = componentDidMount
exports.componentDidUpdate = componentDidUpdate
exports.componentWillUnmount = componentWillUnmount

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj }
}

/* global google */
/* eslint-disable no-param-reassign */
function rdcUncontrolledAndControlledProps(acc, value, key) {
  if ((0, _has3.default)(acc.prevProps, key)) {
    var match = key.match(/^default(\S+)/)
    if (match) {
      var unprefixedKey = (0, _lowerFirst3.default)(match[1])
      if (!(0, _has3.default)(acc.nextProps, unprefixedKey)) {
        acc.nextProps[unprefixedKey] = acc.prevProps[key]
      }
    } else {
      acc.nextProps[key] = acc.prevProps[key]
    }
  }
  return acc
}

function applyUpdaterToNextProps(updaterMap, prevProps, nextProps, instance) {
  ;(0, _forEach3.default)(updaterMap, function(fn, key) {
    var nextValue = nextProps[key]
    if (nextValue !== prevProps[key]) {
      fn(instance, nextValue)
    }
  })
}

function construct(propTypes, updaterMap, prevProps, instance) {
  var _reduce2 = (0, _reduce4.default)(
      propTypes,
      rdcUncontrolledAndControlledProps,
      {
        nextProps: {},
        prevProps: prevProps,
      }
    ),
    nextProps = _reduce2.nextProps

  applyUpdaterToNextProps(
    updaterMap,
    {
      /* empty prevProps for construct */
    },
    nextProps,
    instance
  )
}

function componentDidMount(component, instance, eventMap) {
  registerEvents(component, instance, eventMap)
}

function componentDidUpdate(
  component,
  instance,
  eventMap,
  updaterMap,
  prevProps
) {
  component.unregisterAllEvents()
  applyUpdaterToNextProps(updaterMap, prevProps, component.props, instance)
  registerEvents(component, instance, eventMap)
}

function componentWillUnmount(component) {
  component.unregisterAllEvents()
}

function registerEvents(component, instance, eventMap) {
  var registeredList = (0, _reduce4.default)(
    eventMap,
    function(acc, googleEventName, onEventName) {
      if ((0, _isFunction3.default)(component.props[onEventName])) {
        acc.push(
          google.maps.event.addListener(
            instance,
            googleEventName,
            component.props[onEventName]
          )
        )
      }
      return acc
    },
    []
  )

  component.unregisterAllEvents = (0, _bind3.default)(
    _forEach3.default,
    null,
    registeredList,
    unregisterEvent
  )
}

function unregisterEvent(registered) {
  google.maps.event.removeListener(registered)
}


/***/ }),
/* 36 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(2);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.capitalize = capitalize;
exports.contains = contains;
exports.findIndex = findIndex;
exports.find = find;
exports.createChainedFunction = createChainedFunction;

var _typeof2 = _interopRequireDefault(__webpack_require__(166));

var _warning = _interopRequireDefault(__webpack_require__(16));

//  weak
function capitalize(string) {
  if (false) {
    throw new Error('Material-UI: capitalize(string) expects a string argument.');
  }

  return string.charAt(0).toUpperCase() + string.slice(1);
}

function contains(obj, pred) {
  return Object.keys(pred).every(function (key) {
    return obj.hasOwnProperty(key) && obj[key] === pred[key];
  });
}

function findIndex(arr, pred) {
  var predType = (0, _typeof2.default)(pred);

  for (var i = 0; i < arr.length; i += 1) {
    if (predType === 'function' && !!pred(arr[i], i, arr) === true) {
      return i;
    }

    if (predType === 'object' && contains(arr[i], pred)) {
      return i;
    }

    if (['string', 'number', 'boolean'].indexOf(predType) !== -1) {
      return arr.indexOf(pred);
    }
  }

  return -1;
}

function find(arr, pred) {
  var index = findIndex(arr, pred);
  return index > -1 ? arr[index] : undefined;
}
/**
 * Safe chained function
 *
 * Will only create a new function if needed,
 * otherwise will pass back existing functions or null.
 *
 * @param {function} functions to chain
 * @returns {function|null}
 */


function createChainedFunction() {
  for (var _len = arguments.length, funcs = new Array(_len), _key = 0; _key < _len; _key++) {
    funcs[_key] = arguments[_key];
  }

  return funcs.reduce(function (acc, func) {
    if (func == null) {
      return acc;
    }

     false ? (0, _warning.default)(typeof func === 'function', 'Material-UI: invalid Argument Type, must only provide functions, undefined, or null.') : void 0;
    return function chainedFunction() {
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      acc.apply(this, args);
      func.apply(this, args);
    };
  }, function () {});
}

/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

var freeGlobal = __webpack_require__(315);

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

module.exports = root;


/***/ }),
/* 39 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Provider__ = __webpack_require__(393);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_connectAdvanced__ = __webpack_require__(222);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__connect_connect__ = __webpack_require__(397);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__components_Provider__["a"]; });
/* unused harmony reexport createProvider */
/* unused harmony reexport connectAdvanced */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_2__connect_connect__["a"]; });






/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__(250);
var isBuffer = __webpack_require__(523);

/*global toString:true*/

// utils is a library of generic helper functions non-specific to axios

var toString = Object.prototype.toString;

/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */
function isArray(val) {
  return toString.call(val) === '[object Array]';
}

/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */
function isArrayBuffer(val) {
  return toString.call(val) === '[object ArrayBuffer]';
}

/**
 * Determine if a value is a FormData
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */
function isFormData(val) {
  return (typeof FormData !== 'undefined') && (val instanceof FormData);
}

/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */
function isArrayBufferView(val) {
  var result;
  if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
    result = ArrayBuffer.isView(val);
  } else {
    result = (val) && (val.buffer) && (val.buffer instanceof ArrayBuffer);
  }
  return result;
}

/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */
function isString(val) {
  return typeof val === 'string';
}

/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */
function isNumber(val) {
  return typeof val === 'number';
}

/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */
function isUndefined(val) {
  return typeof val === 'undefined';
}

/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */
function isObject(val) {
  return val !== null && typeof val === 'object';
}

/**
 * Determine if a value is a Date
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */
function isDate(val) {
  return toString.call(val) === '[object Date]';
}

/**
 * Determine if a value is a File
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */
function isFile(val) {
  return toString.call(val) === '[object File]';
}

/**
 * Determine if a value is a Blob
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */
function isBlob(val) {
  return toString.call(val) === '[object Blob]';
}

/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */
function isFunction(val) {
  return toString.call(val) === '[object Function]';
}

/**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */
function isStream(val) {
  return isObject(val) && isFunction(val.pipe);
}

/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */
function isURLSearchParams(val) {
  return typeof URLSearchParams !== 'undefined' && val instanceof URLSearchParams;
}

/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */
function trim(str) {
  return str.replace(/^\s*/, '').replace(/\s*$/, '');
}

/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 */
function isStandardBrowserEnv() {
  if (typeof navigator !== 'undefined' && navigator.product === 'ReactNative') {
    return false;
  }
  return (
    typeof window !== 'undefined' &&
    typeof document !== 'undefined'
  );
}

/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */
function forEach(obj, fn) {
  // Don't bother if no value provided
  if (obj === null || typeof obj === 'undefined') {
    return;
  }

  // Force an array if not already something iterable
  if (typeof obj !== 'object') {
    /*eslint no-param-reassign:0*/
    obj = [obj];
  }

  if (isArray(obj)) {
    // Iterate over array values
    for (var i = 0, l = obj.length; i < l; i++) {
      fn.call(null, obj[i], i, obj);
    }
  } else {
    // Iterate over object keys
    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        fn.call(null, obj[key], key, obj);
      }
    }
  }
}

/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */
function merge(/* obj1, obj2, obj3, ... */) {
  var result = {};
  function assignValue(val, key) {
    if (typeof result[key] === 'object' && typeof val === 'object') {
      result[key] = merge(result[key], val);
    } else {
      result[key] = val;
    }
  }

  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */
function extend(a, b, thisArg) {
  forEach(b, function assignValue(val, key) {
    if (thisArg && typeof val === 'function') {
      a[key] = bind(val, thisArg);
    } else {
      a[key] = val;
    }
  });
  return a;
}

module.exports = {
  isArray: isArray,
  isArrayBuffer: isArrayBuffer,
  isBuffer: isBuffer,
  isFormData: isFormData,
  isArrayBufferView: isArrayBufferView,
  isString: isString,
  isNumber: isNumber,
  isObject: isObject,
  isUndefined: isUndefined,
  isDate: isDate,
  isFile: isFile,
  isBlob: isBlob,
  isFunction: isFunction,
  isStream: isStream,
  isURLSearchParams: isURLSearchParams,
  isStandardBrowserEnv: isStandardBrowserEnv,
  forEach: forEach,
  merge: merge,
  extend: extend,
  trim: trim
};


/***/ }),
/* 41 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(global) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "flush", function() { return flush; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "hydrate", function() { return hydrate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "cx", function() { return cx; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "merge", function() { return merge; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getRegisteredStyles", function() { return getRegisteredStyles; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "injectGlobal", function() { return injectGlobal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "keyframes", function() { return keyframes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "css", function() { return css; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "sheet", function() { return sheet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "caches", function() { return caches; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_create_emotion__ = __webpack_require__(591);


var context = typeof global !== 'undefined' ? global : {};

var _createEmotion = Object(__WEBPACK_IMPORTED_MODULE_0_create_emotion__["a" /* default */])(context),
    flush = _createEmotion.flush,
    hydrate = _createEmotion.hydrate,
    cx = _createEmotion.cx,
    merge = _createEmotion.merge,
    getRegisteredStyles = _createEmotion.getRegisteredStyles,
    injectGlobal = _createEmotion.injectGlobal,
    keyframes = _createEmotion.keyframes,
    css = _createEmotion.css,
    sheet = _createEmotion.sheet,
    caches = _createEmotion.caches;


//# sourceMappingURL=index.esm.js.map

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(36)))

/***/ }),
/* 42 */
/***/ (function(module, exports) {

var core = module.exports = { version: '2.6.11' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),
/* 43 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__bouncing_loader_css__ = __webpack_require__(484);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__bouncing_loader_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__bouncing_loader_css__);
var BouncingLoader=function BouncingLoader(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"bouncing-loader"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null));};/* harmony default export */ __webpack_exports__["a"] = (BouncingLoader);

/***/ }),
/* 44 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

module.exports = isArray;


/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var borderRadius = exports.borderRadius = 4;

var colors = exports.colors = {
  text: '#222',
  textLight: '#444',
  primary: '#2684FF',
  primary75: '#4C9AFF',
  primary50: '#B2D4FF',
  primary25: '#DEEBFF',
  danger: '#DE350B',
  dangerLight: '#FFBDAD',

  neutral0: 'hsl(0, 0%, 100%)',
  neutral1: 'hsl(0, 0%, 99%)',
  neutral2: 'hsl(0, 0%, 98%)',
  neutral3: 'hsl(0, 0%, 97%)',
  neutral4: 'hsl(0, 0%, 96%)',
  neutral5: 'hsl(0, 0%, 95%)',
  neutral10: 'hsl(0, 0%, 90%)',
  neutral20: 'hsl(0, 0%, 80%)',
  neutral30: 'hsl(0, 0%, 70%)',
  neutral40: 'hsl(0, 0%, 60%)',
  neutral50: 'hsl(0, 0%, 50%)',
  neutral60: 'hsl(0, 0%, 40%)',
  neutral70: 'hsl(0, 0%, 30%)',
  neutral80: 'hsl(0, 0%, 20%)',
  neutral90: 'hsl(0, 0%, 10%)',
  neutral100: 'hsl(0, 0%, 0%)',

  neutral1a: 'hsla(0, 0%, 0%, 0.01)',
  neutral2a: 'hsla(0, 0%, 0%, 0.02)',
  neutral3a: 'hsla(0, 0%, 0%, 0.03)',
  neutral4a: 'hsla(0, 0%, 0%, 0.04)',
  neutral5a: 'hsla(0, 0%, 0%, 0.05)',
  neutral10a: 'hsla(0, 0%, 0%, 0.1)',
  neutral20a: 'hsla(0, 0%, 0%, 0.2)',
  neutral30a: 'hsla(0, 0%, 0%, 0.3)',
  neutral40a: 'hsla(0, 0%, 0%, 0.4)',
  neutral50a: 'hsla(0, 0%, 0%, 0.5)',
  neutral60a: 'hsla(0, 0%, 0%, 0.6)',
  neutral70a: 'hsla(0, 0%, 0%, 0.7)',
  neutral80a: 'hsla(0, 0%, 0%, 0.8)',
  neutral90a: 'hsla(0, 0%, 0%, 0.9)'
};

var baseUnit = 4;

var spacing = exports.spacing = {
  /* Used to calculate consistent margin/padding on elements */
  baseUnit: baseUnit,
  /* The minimum height of the control */
  controlHeight: 38,
  /* The amount of space between the control and menu */
  menuGutter: baseUnit * 2
};

/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var color = __webpack_require__(290);
var helpers = __webpack_require__(15);

function interpolate(start, view, model, ease) {
	var keys = Object.keys(model);
	var i, ilen, key, actual, origin, target, type, c0, c1;

	for (i = 0, ilen = keys.length; i < ilen; ++i) {
		key = keys[i];

		target = model[key];

		// if a value is added to the model after pivot() has been called, the view
		// doesn't contain it, so let's initialize the view to the target value.
		if (!view.hasOwnProperty(key)) {
			view[key] = target;
		}

		actual = view[key];

		if (actual === target || key[0] === '_') {
			continue;
		}

		if (!start.hasOwnProperty(key)) {
			start[key] = actual;
		}

		origin = start[key];

		type = typeof target;

		if (type === typeof origin) {
			if (type === 'string') {
				c0 = color(origin);
				if (c0.valid) {
					c1 = color(target);
					if (c1.valid) {
						view[key] = c1.mix(c0, ease).rgbString();
						continue;
					}
				}
			} else if (type === 'number' && isFinite(origin) && isFinite(target)) {
				view[key] = origin + (target - origin) * ease;
				continue;
			}
		}

		view[key] = target;
	}
}

var Element = function(configuration) {
	helpers.extend(this, configuration);
	this.initialize.apply(this, arguments);
};

helpers.extend(Element.prototype, {

	initialize: function() {
		this.hidden = false;
	},

	pivot: function() {
		var me = this;
		if (!me._view) {
			me._view = helpers.clone(me._model);
		}
		me._start = {};
		return me;
	},

	transition: function(ease) {
		var me = this;
		var model = me._model;
		var start = me._start;
		var view = me._view;

		// No animation -> No Transition
		if (!model || ease === 1) {
			me._view = model;
			me._start = null;
			return me;
		}

		if (!view) {
			view = me._view = {};
		}

		if (!start) {
			start = me._start = {};
		}

		interpolate(start, view, model, ease);

		return me;
	},

	tooltipPosition: function() {
		return {
			x: this._model.x,
			y: this._model.y
		};
	},

	hasValue: function() {
		return helpers.isNumber(this._model.x) && helpers.isNumber(this._model.y);
	}
});

Element.extend = helpers.inherits;

module.exports = Element;


/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

var store = __webpack_require__(194)('wks');
var uid = __webpack_require__(139);
var Symbol = __webpack_require__(56).Symbol;
var USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function (name) {
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};

$exports.store = store;


/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

function ownerDocument(node) {
  return node && node.ownerDocument || document;
}

var _default = ownerDocument;
exports.default = _default;

/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(522);

/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(9);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(10));

var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
  fill: "none",
  d: "M0 0h24v24H0z"
}), _react.default.createElement("path", {
  d: "M19 3h-4.18C14.4 1.84 13.3 1 12 1c-1.3 0-2.4.84-2.82 2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7 0c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm2 14H7v-2h7v2zm3-4H7v-2h10v2zm0-4H7V7h10v2z"
})), 'Assignment');

exports.default = _default;

/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(2);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Paper.default;
  }
});

var _Paper = _interopRequireDefault(__webpack_require__(509));

/***/ }),
/* 52 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return updateUserInfo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return authenticateUser; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return cadastrarUsuario; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return login; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return logout; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return resetPassword; });
/* unused harmony export logoutAction */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_services_auth__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__(179);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_config_axios__ = __webpack_require__(180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_reducers_action_helpers__ = __webpack_require__(248);
// ACTION CREATORS
var userUpdated=Object(__WEBPACK_IMPORTED_MODULE_3_reducers_action_helpers__["b" /* makeStandardActionCreator */])(__WEBPACK_IMPORTED_MODULE_1__constants__["d" /* USER_UPDATED */]);// ASYNC ACTION CREATORS
var updateUserInfo=Object(__WEBPACK_IMPORTED_MODULE_3_reducers_action_helpers__["a" /* makeApiActionCreator */])(__WEBPACK_IMPORTED_MODULE_0_services_auth__["i" /* updateUserInfo */],userUpdated);var authenticateUser=function authenticateUser(userData){return function(dispatch){Object(__WEBPACK_IMPORTED_MODULE_2_config_axios__["b" /* axiosTokenSetup */])(userData);dispatch(userAuthenticated(userData));};};var cadastrarUsuario=function cadastrarUsuario(info){return function(dispatch){return __WEBPACK_IMPORTED_MODULE_0_services_auth__["a" /* cadastrarUsuario */](info).then(function(_ref){var data=_ref.data;if(data.confirmacaoPendente){return data;}else{dispatch(authenticateUser(data));return{confirmacaoPendente:false};}});};};var login=function login(username,password){return function(dispatch){return __WEBPACK_IMPORTED_MODULE_0_services_auth__["f" /* login */](username,password).then(function(_ref2){var data=_ref2.data;return dispatch(authenticateUser(data));});};};var logout=function logout(){return function(dispatch){localStorage.removeItem(__WEBPACK_IMPORTED_MODULE_1__constants__["c" /* USER_INFO */]);return __WEBPACK_IMPORTED_MODULE_0_services_auth__["g" /* logout */]().then(function(){return dispatch(logoutAction());}).catch(function(){return dispatch(logoutAction());});};};var resetPassword=function resetPassword(params){return function(dispatch){return __WEBPACK_IMPORTED_MODULE_0_services_auth__["h" /* resetPassword */](params).then(function(_ref3){var data=_ref3.data;return dispatch(authenticateUser(data));});};};var logoutAction=function logoutAction(){return{type:__WEBPACK_IMPORTED_MODULE_1__constants__["b" /* REVOKE_USER */]};};// OLD-STYLE ACTION CREATORS
var userAuthenticated=function userAuthenticated(user){return{type:__WEBPACK_IMPORTED_MODULE_1__constants__["a" /* AUTHENTICATE_USER */],payload:{user:user}};};

/***/ }),
/* 53 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var routes={assinatura:{addUser:function addUser(){return"/assinatura/adicionarUsuario";},fetch:function fetch(){return"/assinatura";},removeUser:function removeUser(userId){return"/assinatura/removerUsuario/"+userId;},updateAdmin:function updateAdmin(){return"/assinatura/alterarAdmin";}},auth:{confirmacaoConvite:function confirmacaoConvite(){return"/account/confirmacaoConvite";},forgetPassword:function forgetPassword(){return"/account/esqueceuSenha";},login:function login(){return"/account/login";},logout:function logout(){return"/account/logout";},reset:function reset(){return"/account/resetarSenha";},update:function update(){return"/account/atualizarSenha";}},buscaCativo:{fetch:function fetch(){return"/relatorioCativo";},fetchNextPage:function fetchNextPage(idRelatorio,pagina){return"/relatorioCativo/getPaginaRelatorio?idRelatorio="+idRelatorio+"&pagina="+pagina+"&tamanhoPagina=20\"";},getRelatorioCSV:function getRelatorioCSV(idRelatorio,pagina){return"/relatorioCativo/getRelatorioCSV?idRelatorio="+idRelatorio+"&pagina="+pagina+"&tamanhoPagina=20\"";},parametros:function parametros(){return"/relatorioCativo/parametros";}},companies:{buscarEmpresaFechado:function buscarEmpresaFechado(q){return"/companies/sugerir/"+q;},fetchCargasEGeracao:function fetchCargasEGeracao(companyId){return"/medicao/cargasegeracoesempresa/"+companyId;},fetch:function fetch(){return"/companies";},getBreakEven:function getBreakEven(dsitrId,companyId){return"/dashboard/breakeven/"+dsitrId+"?idEmpresa="+companyId;},getCativoInfo:function getCativoInfo(cnpj){return"/companies/search/"+cnpj;},getCurvaPerfisAgentes:function getCurvaPerfisAgentes(){return'dashboard/curvaPerfisAgentes';},getInfo:function getInfo(id){return"/dashboard/"+id;}},contato:{sendMessage:function sendMessage(){return"/contato";}},dadosGerais:{fetchCidades:function fetchCidades(estado){return"/dadosgerais/cidades/"+estado;}},relatorios:{fetch:function fetch(){return"/relatorios";},fetchNextPage:function fetchNextPage(idRelatorio,pagina){return"/relatorios/getPaginaRelatorio?idRelatorio="+idRelatorio+"&pagina="+pagina+"&tamanhoPagina=20\"";},getRelatorioCSV:function getRelatorioCSV(idRelatorio,pagina){return"/relatorios/getRelatorioCSV?idRelatorio="+idRelatorio+"&pagina="+pagina+"&tamanhoPagina=20\"";},parametros:function parametros(){return"/relatorios/parametros";}},simuladores:{buscarCNPJ:function buscarCNPJ(q){return"/simuladorEconomia/buscarCNPJ/"+q;},buscarEmpresa:function buscarEmpresa(q){return"/simuladorEconomia/buscarEmpresa/"+q;},calcularEconomia:function calcularEconomia(){return'/simuladorEconomia/CalcularEconomia';},fetchDefaultParametros:function fetchDefaultParametros(){return'/simuladorEconomia/parametros';},getCativoInfo:function getCativoInfo(cnpj){return"/simuladorEconomia/buscarCNPJ/"+cnpj;},getInfo:function getInfo(id){return"/simuladorEconomia/dadosEmpresa/"+id;}},user:{cadastro:function cadastro(){return"/account/cadastro";},confirmacaoEmail:function confirmacaoEmail(){return"/account/confirmacaoEmail";},enviarEmailCadastro:function enviarEmailCadastro(){return"/account/enviarEmailCadastro";},update:function update(){return"/account/atualizarUsuario";}}};/* harmony default export */ __webpack_exports__["a"] = (routes);

/***/ }),
/* 54 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles_withStyles__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_Table__ = __webpack_require__(571);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_Table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_TableBody__ = __webpack_require__(573);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_TableBody___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_TableBody__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_TableCell__ = __webpack_require__(575);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_TableCell___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_TableCell__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_TableHead__ = __webpack_require__(577);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_TableHead___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_TableHead__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_TableRow__ = __webpack_require__(579);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_TableRow___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_TableRow__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_assets_jss_material_dashboard_pro_react_components_tableStyle__ = __webpack_require__(581);
var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}// @material-ui/core components
var styles=function styles(theme){var originalTableStyle=Object.assign({},Object(__WEBPACK_IMPORTED_MODULE_9_assets_jss_material_dashboard_pro_react_components_tableStyle__["a" /* default */])(theme));return Object.assign({},originalTableStyle,{tableCellTotal:Object.assign({},originalTableStyle.tableCellTotal,{textAlign:"left"}),tableCellAmount:Object.assign({},originalTableStyle.tableCellAmount,{fontSize:"1.25em",fontWeight:"500",textAlign:"left"}),tableHeadClickable:{cursor:"pointer"}});};function CustomTable(_ref){var props=_objectWithoutProperties(_ref,[]);var classes=props.classes,tableHead=props.tableHead,tableData=props.tableData,tableHeaderColor=props.tableHeaderColor,hover=props.hover,colorsColls=props.colorsColls,coloredColls=props.coloredColls,customCellClasses=props.customCellClasses,customClassesForCells=props.customClassesForCells,striped=props.striped,tableShopping=props.tableShopping,customHeadCellClasses=props.customHeadCellClasses,customHeadClassesForCells=props.customHeadClassesForCells;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:classes.tableResponsive},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Table___default.a,{className:classes.table},tableHead!==undefined?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_TableHead___default.a,{className:classes[tableHeaderColor]},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_TableRow___default.a,{className:classes.tableRow},tableHead.map(function(prop,key){var _cx;var tableCellClasses=classes.tableHeadCell+" "+classes.tableCell+" "+__WEBPACK_IMPORTED_MODULE_1_classnames___default()((_cx={},_defineProperty(_cx,customHeadCellClasses[customHeadClassesForCells.indexOf(key)],customHeadClassesForCells.indexOf(key)!==-1),_defineProperty(_cx,classes.tableShoppingHead,tableShopping),_defineProperty(_cx,classes.tableHeadFontSize,!tableShopping),_defineProperty(_cx,classes.tableHeadClickable,(typeof prop==="undefined"?"undefined":_typeof(prop))==="object"),_cx));return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_TableCell___default.a,{className:tableCellClasses,key:key},prop);}))):null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_TableBody___default.a,null,tableData.map(function(prop,key){var _cx2;var rowColor="";var rowColored=false;if(prop.color!==undefined){rowColor=prop.color;rowColored=true;prop=prop.data;}var tableRowClasses=__WEBPACK_IMPORTED_MODULE_1_classnames___default()((_cx2={},_defineProperty(_cx2,classes.tableRowHover,hover),_defineProperty(_cx2,classes[rowColor+"Row"],rowColored),_defineProperty(_cx2,classes.tableStripedRow,striped&&key%2===0),_cx2));if(prop.total){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_TableRow___default.a,{key:key,hover:hover,className:tableRowClasses},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_TableCell___default.a,{className:classes.tableCell,colSpan:prop.colspan}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_TableCell___default.a,{className:classes.tableCell+" "+classes.tableCellTotal},"Total"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_TableCell___default.a,{className:classes.tableCell+" "+classes.tableCellAmount},prop.amount),tableHead.length-(prop.colspan-0+2)>0?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_TableCell___default.a,{className:classes.tableCell,colSpan:tableHead.length-(prop.colspan-0+2)}):null);}if(prop.purchase){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_TableRow___default.a,{key:key,hover:hover,className:tableRowClasses},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_TableCell___default.a,{className:classes.tableCell,colSpan:prop.colspan}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_TableCell___default.a,{className:classes.tableCell+" "+classes.right,colSpan:prop.col.colspan},prop.col.text));}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_TableRow___default.a,{key:key,hover:hover,className:classes.tableRow+" "+tableRowClasses},prop.map(function(prop,key){var _cx3;var tableCellClasses=classes.tableCell+" "+__WEBPACK_IMPORTED_MODULE_1_classnames___default()((_cx3={},_defineProperty(_cx3,classes[colorsColls[coloredColls.indexOf(key)]],coloredColls.indexOf(key)!==-1),_defineProperty(_cx3,customCellClasses[customClassesForCells.indexOf(key)],customClassesForCells.indexOf(key)!==-1),_cx3));return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_TableCell___default.a,{className:tableCellClasses,key:key},prop);}));}))));}CustomTable.defaultProps={tableHeaderColor:"gray",hover:false,colorsColls:[],coloredColls:[],striped:false,customCellClasses:[],customClassesForCells:[],customHeadCellClasses:[],customHeadClassesForCells:[]};CustomTable.propTypes={classes:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired,tableHeaderColor:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOf(["warning","primary","danger","success","info","rose","gray"]),tableHead:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node])),// Of(PropTypes.arrayOf(PropTypes.node)) || Of(PropTypes.object),
tableData:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array,hover:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,coloredColls:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number),// Of(["warning","primary","danger","success","info","rose","gray"]) - colorsColls
colorsColls:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array,customCellClasses:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string),customClassesForCells:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number),customHeadCellClasses:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string),customHeadClassesForCells:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number),striped:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,// this will cause some changes in font
tableShopping:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool};/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles_withStyles___default()(styles)(CustomTable));

/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {};
module.exports.Arc = __webpack_require__(668);
module.exports.Line = __webpack_require__(669);
module.exports.Point = __webpack_require__(670);
module.exports.Rectangle = __webpack_require__(671);


/***/ }),
/* 56 */
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(56);
var core = __webpack_require__(42);
var ctx = __webpack_require__(195);
var hide = __webpack_require__(80);
var has = __webpack_require__(64);
var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var IS_WRAP = type & $export.W;
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE];
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE];
  var key, own, out;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    if (own && has(exports, key)) continue;
    // export native or passed
    out = own ? target[key] : source[key];
    // prevent global pollution for namespaces
    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
    // bind timers to global for call from export context
    : IS_BIND && own ? ctx(out, global)
    // wrap global constructors for prevent change them in library
    : IS_WRAP && target[key] == out ? (function (C) {
      var F = function (a, b, c) {
        if (this instanceof C) {
          switch (arguments.length) {
            case 0: return new C();
            case 1: return new C(a);
            case 2: return new C(a, b);
          } return new C(a, b, c);
        } return C.apply(this, arguments);
      };
      F[PROTOTYPE] = C[PROTOTYPE];
      return F;
    // make static versions for prototype methods
    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
    if (IS_PROTO) {
      (exports.virtual || (exports.virtual = {}))[key] = out;
      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
      if (type & $export.R && expProto && !expProto[key]) hide(expProto, key, out);
    }
  }
};
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;


/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(81);
var IE8_DOM_DEFINE = __webpack_require__(301);
var toPrimitive = __webpack_require__(196);
var dP = Object.defineProperty;

exports.f = __webpack_require__(59) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__(83)(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(2);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Hidden.default;
  }
});

var _Hidden = _interopRequireDefault(__webpack_require__(937));

/***/ }),
/* 61 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createBrowserHistory__ = __webpack_require__(388);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__createBrowserHistory__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__createHashHistory__ = __webpack_require__(391);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__createHashHistory__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__createMemoryHistory__ = __webpack_require__(392);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_2__createMemoryHistory__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__LocationUtils__ = __webpack_require__(115);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_3__LocationUtils__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_3__LocationUtils__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__PathUtils__ = __webpack_require__(87);
/* unused harmony reexport parsePath */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_4__PathUtils__["b"]; });










/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.EXITING = exports.ENTERED = exports.ENTERING = exports.EXITED = exports.UNMOUNTED = undefined;

var _propTypes = __webpack_require__(1);

var PropTypes = _interopRequireWildcard(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(24);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reactLifecyclesCompat = __webpack_require__(244);

var _PropTypes = __webpack_require__(245);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var UNMOUNTED = exports.UNMOUNTED = 'unmounted';
var EXITED = exports.EXITED = 'exited';
var ENTERING = exports.ENTERING = 'entering';
var ENTERED = exports.ENTERED = 'entered';
var EXITING = exports.EXITING = 'exiting';

/**
 * The Transition component lets you describe a transition from one component
 * state to another _over time_ with a simple declarative API. Most commonly
 * it's used to animate the mounting and unmounting of a component, but can also
 * be used to describe in-place transition states as well.
 *
 * By default the `Transition` component does not alter the behavior of the
 * component it renders, it only tracks "enter" and "exit" states for the components.
 * It's up to you to give meaning and effect to those states. For example we can
 * add styles to a component when it enters or exits:
 *
 * ```jsx
 * import Transition from 'react-transition-group/Transition';
 *
 * const duration = 300;
 *
 * const defaultStyle = {
 *   transition: `opacity ${duration}ms ease-in-out`,
 *   opacity: 0,
 * }
 *
 * const transitionStyles = {
 *   entering: { opacity: 0 },
 *   entered:  { opacity: 1 },
 * };
 *
 * const Fade = ({ in: inProp }) => (
 *   <Transition in={inProp} timeout={duration}>
 *     {(state) => (
 *       <div style={{
 *         ...defaultStyle,
 *         ...transitionStyles[state]
 *       }}>
 *         I'm a fade Transition!
 *       </div>
 *     )}
 *   </Transition>
 * );
 * ```
 *
 * As noted the `Transition` component doesn't _do_ anything by itself to its child component.
 * What it does do is track transition states over time so you can update the
 * component (such as by adding styles or classes) when it changes states.
 *
 * There are 4 main states a Transition can be in:
 *  - `'entering'`
 *  - `'entered'`
 *  - `'exiting'`
 *  - `'exited'`
 *
 * Transition state is toggled via the `in` prop. When `true` the component begins the
 * "Enter" stage. During this stage, the component will shift from its current transition state,
 * to `'entering'` for the duration of the transition and then to the `'entered'` stage once
 * it's complete. Let's take the following example:
 *
 * ```jsx
 * state = { in: false };
 *
 * toggleEnterState = () => {
 *   this.setState({ in: true });
 * }
 *
 * render() {
 *   return (
 *     <div>
 *       <Transition in={this.state.in} timeout={500} />
 *       <button onClick={this.toggleEnterState}>Click to Enter</button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the button is clicked the component will shift to the `'entering'` state and
 * stay there for 500ms (the value of `timeout`) before it finally switches to `'entered'`.
 *
 * When `in` is `false` the same thing happens except the state moves from `'exiting'` to `'exited'`.
 *
 * ## Timing
 *
 * Timing is often the trickiest part of animation, mistakes can result in slight delays
 * that are hard to pin down. A common example is when you want to add an exit transition,
 * you should set the desired final styles when the state is `'exiting'`. That's when the
 * transition to those styles will start and, if you matched the `timeout` prop with the
 * CSS Transition duration, it will end exactly when the state changes to `'exited'`.
 *
 * > **Note**: For simpler transitions the `Transition` component might be enough, but
 * > take into account that it's platform-agnostic, while the `CSSTransition` component
 * > [forces reflows](https://github.com/reactjs/react-transition-group/blob/5007303e729a74be66a21c3e2205e4916821524b/src/CSSTransition.js#L208-L215)
 * > in order to make more complex transitions more predictable. For example, even though
 * > classes `example-enter` and `example-enter-active` are applied immediately one after
 * > another, you can still transition from one to the other because of the forced reflow
 * > (read [this issue](https://github.com/reactjs/react-transition-group/issues/159#issuecomment-322761171)
 * > for more info). Take this into account when choosing between `Transition` and
 * > `CSSTransition`.
 *
 * ## Example
 *
 * <iframe src="https://codesandbox.io/embed/741op4mmj0?fontsize=14" style="width:100%; height:500px; border:0; border-radius: 4px; overflow:hidden;" sandbox="allow-modals allow-forms allow-popups allow-scripts allow-same-origin"></iframe>
 *
 */

var Transition = function (_React$Component) {
  _inherits(Transition, _React$Component);

  function Transition(props, context) {
    _classCallCheck(this, Transition);

    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props, context));

    var parentGroup = context.transitionGroup;
    // In the context of a TransitionGroup all enters are really appears
    var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;

    var initialStatus = void 0;

    _this.appearStatus = null;

    if (props.in) {
      if (appear) {
        initialStatus = EXITED;
        _this.appearStatus = ENTERING;
      } else {
        initialStatus = ENTERED;
      }
    } else {
      if (props.unmountOnExit || props.mountOnEnter) {
        initialStatus = UNMOUNTED;
      } else {
        initialStatus = EXITED;
      }
    }

    _this.state = { status: initialStatus };

    _this.nextCallback = null;
    return _this;
  }

  Transition.prototype.getChildContext = function getChildContext() {
    return { transitionGroup: null // allows for nested Transitions
    };
  };

  Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
    var nextIn = _ref.in;

    if (nextIn && prevState.status === UNMOUNTED) {
      return { status: EXITED };
    }
    return null;
  };

  // getSnapshotBeforeUpdate(prevProps) {
  //   let nextStatus = null

  //   if (prevProps !== this.props) {
  //     const { status } = this.state

  //     if (this.props.in) {
  //       if (status !== ENTERING && status !== ENTERED) {
  //         nextStatus = ENTERING
  //       }
  //     } else {
  //       if (status === ENTERING || status === ENTERED) {
  //         nextStatus = EXITING
  //       }
  //     }
  //   }

  //   return { nextStatus }
  // }

  Transition.prototype.componentDidMount = function componentDidMount() {
    this.updateStatus(true, this.appearStatus);
  };

  Transition.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
    var nextStatus = null;
    if (prevProps !== this.props) {
      var status = this.state.status;


      if (this.props.in) {
        if (status !== ENTERING && status !== ENTERED) {
          nextStatus = ENTERING;
        }
      } else {
        if (status === ENTERING || status === ENTERED) {
          nextStatus = EXITING;
        }
      }
    }
    this.updateStatus(false, nextStatus);
  };

  Transition.prototype.componentWillUnmount = function componentWillUnmount() {
    this.cancelNextCallback();
  };

  Transition.prototype.getTimeouts = function getTimeouts() {
    var timeout = this.props.timeout;

    var exit = void 0,
        enter = void 0,
        appear = void 0;

    exit = enter = appear = timeout;

    if (timeout != null && typeof timeout !== 'number') {
      exit = timeout.exit;
      enter = timeout.enter;
      appear = timeout.appear;
    }
    return { exit: exit, enter: enter, appear: appear };
  };

  Transition.prototype.updateStatus = function updateStatus() {
    var mounting = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    var nextStatus = arguments[1];

    if (nextStatus !== null) {
      // nextStatus will always be ENTERING or EXITING.
      this.cancelNextCallback();
      var node = _reactDom2.default.findDOMNode(this);

      if (nextStatus === ENTERING) {
        this.performEnter(node, mounting);
      } else {
        this.performExit(node);
      }
    } else if (this.props.unmountOnExit && this.state.status === EXITED) {
      this.setState({ status: UNMOUNTED });
    }
  };

  Transition.prototype.performEnter = function performEnter(node, mounting) {
    var _this2 = this;

    var enter = this.props.enter;

    var appearing = this.context.transitionGroup ? this.context.transitionGroup.isMounting : mounting;

    var timeouts = this.getTimeouts();

    // no enter animation skip right to ENTERED
    // if we are mounting and running this it means appear _must_ be set
    if (!mounting && !enter) {
      this.safeSetState({ status: ENTERED }, function () {
        _this2.props.onEntered(node);
      });
      return;
    }

    this.props.onEnter(node, appearing);

    this.safeSetState({ status: ENTERING }, function () {
      _this2.props.onEntering(node, appearing);

      // FIXME: appear timeout?
      _this2.onTransitionEnd(node, timeouts.enter, function () {
        _this2.safeSetState({ status: ENTERED }, function () {
          _this2.props.onEntered(node, appearing);
        });
      });
    });
  };

  Transition.prototype.performExit = function performExit(node) {
    var _this3 = this;

    var exit = this.props.exit;

    var timeouts = this.getTimeouts();

    // no exit animation skip right to EXITED
    if (!exit) {
      this.safeSetState({ status: EXITED }, function () {
        _this3.props.onExited(node);
      });
      return;
    }
    this.props.onExit(node);

    this.safeSetState({ status: EXITING }, function () {
      _this3.props.onExiting(node);

      _this3.onTransitionEnd(node, timeouts.exit, function () {
        _this3.safeSetState({ status: EXITED }, function () {
          _this3.props.onExited(node);
        });
      });
    });
  };

  Transition.prototype.cancelNextCallback = function cancelNextCallback() {
    if (this.nextCallback !== null) {
      this.nextCallback.cancel();
      this.nextCallback = null;
    }
  };

  Transition.prototype.safeSetState = function safeSetState(nextState, callback) {
    // This shouldn't be necessary, but there are weird race conditions with
    // setState callbacks and unmounting in testing, so always make sure that
    // we can cancel any pending setState callbacks after we unmount.
    callback = this.setNextCallback(callback);
    this.setState(nextState, callback);
  };

  Transition.prototype.setNextCallback = function setNextCallback(callback) {
    var _this4 = this;

    var active = true;

    this.nextCallback = function (event) {
      if (active) {
        active = false;
        _this4.nextCallback = null;

        callback(event);
      }
    };

    this.nextCallback.cancel = function () {
      active = false;
    };

    return this.nextCallback;
  };

  Transition.prototype.onTransitionEnd = function onTransitionEnd(node, timeout, handler) {
    this.setNextCallback(handler);

    if (node) {
      if (this.props.addEndListener) {
        this.props.addEndListener(node, this.nextCallback);
      }
      if (timeout != null) {
        setTimeout(this.nextCallback, timeout);
      }
    } else {
      setTimeout(this.nextCallback, 0);
    }
  };

  Transition.prototype.render = function render() {
    var status = this.state.status;
    if (status === UNMOUNTED) {
      return null;
    }

    var _props = this.props,
        children = _props.children,
        childProps = _objectWithoutProperties(_props, ['children']);
    // filter props for Transtition


    delete childProps.in;
    delete childProps.mountOnEnter;
    delete childProps.unmountOnExit;
    delete childProps.appear;
    delete childProps.enter;
    delete childProps.exit;
    delete childProps.timeout;
    delete childProps.addEndListener;
    delete childProps.onEnter;
    delete childProps.onEntering;
    delete childProps.onEntered;
    delete childProps.onExit;
    delete childProps.onExiting;
    delete childProps.onExited;

    if (typeof children === 'function') {
      return children(status, childProps);
    }

    var child = _react2.default.Children.only(children);
    return _react2.default.cloneElement(child, childProps);
  };

  return Transition;
}(_react2.default.Component);

Transition.contextTypes = {
  transitionGroup: PropTypes.object
};
Transition.childContextTypes = {
  transitionGroup: function transitionGroup() {}
};


Transition.propTypes =  false ? {
  /**
   * A `function` child can be used instead of a React element.
   * This function is called with the current transition status
   * ('entering', 'entered', 'exiting', 'exited', 'unmounted'), which can be used
   * to apply context specific props to a component.
   *
   * ```jsx
   * <Transition timeout={150}>
   *   {(status) => (
   *     <MyComponent className={`fade fade-${status}`} />
   *   )}
   * </Transition>
   * ```
   */
  children: PropTypes.oneOfType([PropTypes.func.isRequired, PropTypes.element.isRequired]).isRequired,

  /**
   * Show the component; triggers the enter or exit states
   */
  in: PropTypes.bool,

  /**
   * By default the child component is mounted immediately along with
   * the parent `Transition` component. If you want to "lazy mount" the component on the
   * first `in={true}` you can set `mountOnEnter`. After the first enter transition the component will stay
   * mounted, even on "exited", unless you also specify `unmountOnExit`.
   */
  mountOnEnter: PropTypes.bool,

  /**
   * By default the child component stays mounted after it reaches the `'exited'` state.
   * Set `unmountOnExit` if you'd prefer to unmount the component after it finishes exiting.
   */
  unmountOnExit: PropTypes.bool,

  /**
   * Normally a component is not transitioned if it is shown when the `<Transition>` component mounts.
   * If you want to transition on the first mount set `appear` to `true`, and the
   * component will transition in as soon as the `<Transition>` mounts.
   *
   * > Note: there are no specific "appear" states. `appear` only adds an additional `enter` transition.
   */
  appear: PropTypes.bool,

  /**
   * Enable or disable enter transitions.
   */
  enter: PropTypes.bool,

  /**
   * Enable or disable exit transitions.
   */
  exit: PropTypes.bool,

  /**
   * The duration of the transition, in milliseconds.
   * Required unless `addEndListener` is provided
   *
   * You may specify a single timeout for all transitions like: `timeout={500}`,
   * or individually like:
   *
   * ```jsx
   * timeout={{
   *  enter: 300,
   *  exit: 500,
   * }}
   * ```
   *
   * @type {number | { enter?: number, exit?: number }}
   */
  timeout: function timeout(props) {
    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    var pt = _PropTypes.timeoutsShape;
    if (!props.addEndListener) pt = pt.isRequired;
    return pt.apply(undefined, [props].concat(args));
  },

  /**
   * Add a custom transition end trigger. Called with the transitioning
   * DOM node and a `done` callback. Allows for more fine grained transition end
   * logic. **Note:** Timeouts are still used as a fallback if provided.
   *
   * ```jsx
   * addEndListener={(node, done) => {
   *   // use the css transitionend event to mark the finish of a transition
   *   node.addEventListener('transitionend', done, false);
   * }}
   * ```
   */
  addEndListener: PropTypes.func,

  /**
   * Callback fired before the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEnter: PropTypes.func,

  /**
   * Callback fired after the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntering: PropTypes.func,

  /**
   * Callback fired after the "entered" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEntered: PropTypes.func,

  /**
   * Callback fired before the "exiting" status is applied.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExit: PropTypes.func,

  /**
   * Callback fired after the "exiting" status is applied.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExiting: PropTypes.func,

  /**
   * Callback fired after the "exited" status is applied.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExited: PropTypes.func

  // Name the function so it is clearer in the documentation
} : {};function noop() {}

Transition.defaultProps = {
  in: false,
  mountOnEnter: false,
  unmountOnExit: false,
  appear: false,
  enter: true,
  exit: true,

  onEnter: noop,
  onEntering: noop,
  onEntered: noop,

  onExit: noop,
  onExiting: noop,
  onExited: noop
};

Transition.UNMOUNTED = 0;
Transition.EXITED = 1;
Transition.ENTERING = 2;
Transition.ENTERED = 3;
Transition.EXITING = 4;

exports.default = (0, _reactLifecyclesCompat.polyfill)(Transition);

/***/ }),
/* 63 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_styles_withStyles__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_styles_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_styles_withStyles__);
var style={actionsWrapper:{cursor:"pointer",display:"inline-flex"},infoGridItem:{alignItems:"center",display:"flex",minHeight:"36px"},infoGridItemLabel:{fontWeight:"700",marginRight:"7px",textTransform:"uppercase",whiteSpace:"nowrap"},forceNewRowModifier:{gridColumnStart:"1"},forceNewFullRowModifier:{gridColumn:"1 / span 2","@media (max-width: 768px)":{gridColumn:"unset"}}};function InfoGridItem(_ref){var actions=_ref.actions,classes=_ref.classes,label=_ref.label,modifiers=_ref.modifiers,value=_ref.value;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:classes.infoGridItem+' '+modifiers.map(function(modifier){return classes[modifier];}).join(' ')},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span",{className:classes.infoGridItemLabel},label,":"),value&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span",null,value),actions&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span",{className:classes.actionsWrapper},actions));}InfoGridItem.defaultProps={modifiers:[]};InfoGridItem.propTypes={actions:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.node,classes:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object.isRequired,label:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired,modifiers:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.array,value:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.node};/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_2__material_ui_core_styles_withStyles___default()(style)(InfoGridItem));

/***/ }),
/* 64 */
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};


/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsNative = __webpack_require__(768),
    getValue = __webpack_require__(773);

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

module.exports = getNative;


/***/ }),
/* 66 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

module.exports = isObject;


/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
var REACT_STATICS = {
    childContextTypes: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};

var KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};

var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = getPrototypeOf && getPrototypeOf(Object);

function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components

        if (objectPrototype) {
            var inheritedComponent = getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== objectPrototype) {
                hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
            }
        }

        var keys = getOwnPropertyNames(sourceComponent);

        if (getOwnPropertySymbols) {
            keys = keys.concat(getOwnPropertySymbols(sourceComponent));
        }

        for (var i = 0; i < keys.length; ++i) {
            var key = keys[i];
            if (!REACT_STATICS[key] && !KNOWN_STATICS[key] && (!blacklist || !blacklist[key])) {
                var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
                try { // Avoid failures from read-only properties
                    defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }

        return targetComponent;
    }

    return targetComponent;
}

module.exports = hoistNonReactStatics;


/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var warning = function() {};

if (false) {
  warning = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
        '`warning(condition, format, ...args)` requires a warning ' +
        'message argument'
      );
    }

    if (format.length < 10 || (/^[s\W]*$/).test(format)) {
      throw new Error(
        'The warning format should be able to uniquely identify this ' +
        'warning. Please, use a more descriptive format than: ' + format
      );
    }

    if (!condition) {
      var argIndex = 0;
      var message = 'Warning: ' +
        format.replace(/%s/g, function() {
          return args[argIndex++];
        });
      if (typeof console !== 'undefined') {
        console.error(message);
      }
      try {
        // This error was thrown as a convenience so that you can use this stack
        // to find the callsite that caused this warning to fire.
        throw new Error(message);
      } catch(x) {}
    }
  };
}

module.exports = warning;


/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _warning = __webpack_require__(68);

var _warning2 = _interopRequireDefault(_warning);

var _toCss = __webpack_require__(168);

var _toCss2 = _interopRequireDefault(_toCss);

var _toCssValue = __webpack_require__(118);

var _toCssValue2 = _interopRequireDefault(_toCssValue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var StyleRule = function () {
  function StyleRule(key, style, options) {
    _classCallCheck(this, StyleRule);

    this.type = 'style';
    this.isProcessed = false;
    var sheet = options.sheet,
        Renderer = options.Renderer,
        selector = options.selector;

    this.key = key;
    this.options = options;
    this.style = style;
    if (selector) this.selectorText = selector;
    this.renderer = sheet ? sheet.renderer : new Renderer();
  }

  /**
   * Set selector string.
   * Attention: use this with caution. Most browsers didn't implement
   * selectorText setter, so this may result in rerendering of entire Style Sheet.
   */


  _createClass(StyleRule, [{
    key: 'prop',


    /**
     * Get or set a style property.
     */
    value: function prop(name, value) {
      // It's a getter.
      if (value === undefined) return this.style[name];

      // Don't do anything if the value has not changed.
      if (this.style[name] === value) return this;

      value = this.options.jss.plugins.onChangeValue(value, name, this);

      var isEmpty = value == null || value === false;
      var isDefined = name in this.style;

      // Value is empty and wasn't defined before.
      if (isEmpty && !isDefined) return this;

      // We are going to remove this value.
      var remove = isEmpty && isDefined;

      if (remove) delete this.style[name];else this.style[name] = value;

      // Renderable is defined if StyleSheet option `link` is true.
      if (this.renderable) {
        if (remove) this.renderer.removeProperty(this.renderable, name);else this.renderer.setProperty(this.renderable, name, value);
        return this;
      }

      var sheet = this.options.sheet;

      if (sheet && sheet.attached) {
        (0, _warning2['default'])(false, 'Rule is not linked. Missing sheet option "link: true".');
      }
      return this;
    }

    /**
     * Apply rule to an element inline.
     */

  }, {
    key: 'applyTo',
    value: function applyTo(renderable) {
      var json = this.toJSON();
      for (var prop in json) {
        this.renderer.setProperty(renderable, prop, json[prop]);
      }return this;
    }

    /**
     * Returns JSON representation of the rule.
     * Fallbacks are not supported.
     * Useful for inline styles.
     */

  }, {
    key: 'toJSON',
    value: function toJSON() {
      var json = {};
      for (var prop in this.style) {
        var value = this.style[prop];
        if ((typeof value === 'undefined' ? 'undefined' : _typeof(value)) !== 'object') json[prop] = value;else if (Array.isArray(value)) json[prop] = (0, _toCssValue2['default'])(value);
      }
      return json;
    }

    /**
     * Generates a CSS string.
     */

  }, {
    key: 'toString',
    value: function toString(options) {
      var sheet = this.options.sheet;

      var link = sheet ? sheet.options.link : false;
      var opts = link ? _extends({}, options, { allowEmpty: true }) : options;
      return (0, _toCss2['default'])(this.selector, this.style, opts);
    }
  }, {
    key: 'selector',
    set: function set(selector) {
      if (selector === this.selectorText) return;

      this.selectorText = selector;

      if (!this.renderable) return;

      var hasChanged = this.renderer.setSelector(this.renderable, selector);

      // If selector setter is not implemented, rerender the rule.
      if (!hasChanged && this.renderable) {
        var renderable = this.renderer.replaceRule(this.renderable, this);
        if (renderable) this.renderable = renderable;
      }
    }

    /**
     * Get selector string.
     */
    ,
    get: function get() {
      return this.selectorText;
    }
  }]);

  return StyleRule;
}();

exports['default'] = StyleRule;

/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(2);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.convertHexToRGB = convertHexToRGB;
exports.rgbToHex = rgbToHex;
exports.decomposeColor = decomposeColor;
exports.recomposeColor = recomposeColor;
exports.getContrastRatio = getContrastRatio;
exports.getLuminance = getLuminance;
exports.emphasize = emphasize;
exports.fade = fade;
exports.darken = darken;
exports.lighten = lighten;

var _warning = _interopRequireDefault(__webpack_require__(16));

//  weak

/* eslint-disable no-use-before-define */

/**
 * Returns a number whose value is limited to the given range.
 *
 * @param {number} value The value to be clamped
 * @param {number} min The lower boundary of the output range
 * @param {number} max The upper boundary of the output range
 * @returns {number} A number in the range [min, max]
 */
function clamp(value) {
  var min = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var max = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
   false ? (0, _warning.default)(value >= min && value <= max, "Material-UI: the value provided ".concat(value, " is out of range [").concat(min, ", ").concat(max, "].")) : void 0;

  if (value < min) {
    return min;
  }

  if (value > max) {
    return max;
  }

  return value;
}
/**
 * Converts a color from CSS hex format to CSS rgb format.
 *
 * @param {string} color - Hex color, i.e. #nnn or #nnnnnn
 * @returns {string} A CSS rgb color string
 */


function convertHexToRGB(color) {
  color = color.substr(1);
  var re = new RegExp(".{1,".concat(color.length / 3, "}"), 'g');
  var colors = color.match(re);

  if (colors && colors[0].length === 1) {
    colors = colors.map(function (n) {
      return n + n;
    });
  }

  return colors ? "rgb(".concat(colors.map(function (n) {
    return parseInt(n, 16);
  }).join(', '), ")") : '';
}
/**
 * Converts a color from CSS rgb format to CSS hex format.
 *
 * @param {string} color - RGB color, i.e. rgb(n, n, n)
 * @returns {string} A CSS rgb color string, i.e. #nnnnnn
 */


function rgbToHex(color) {
  // Pass hex straight through
  if (color.indexOf('#') === 0) {
    return color;
  }

  function intToHex(c) {
    var hex = c.toString(16);
    return hex.length === 1 ? "0".concat(hex) : hex;
  }

  var _decomposeColor = decomposeColor(color),
      values = _decomposeColor.values;

  values = values.map(function (n) {
    return intToHex(n);
  });
  return "#".concat(values.join(''));
}
/**
 * Returns an object with the type and values of a color.
 *
 * Note: Does not support rgb % values.
 *
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @returns {object} - A MUI color object: {type: string, values: number[]}
 */


function decomposeColor(color) {
  if (color.charAt(0) === '#') {
    return decomposeColor(convertHexToRGB(color));
  }

  var marker = color.indexOf('(');
  var type = color.substring(0, marker);
  var values = color.substring(marker + 1, color.length - 1).split(',');
  values = values.map(function (value) {
    return parseFloat(value);
  });

  if (false) {
    if (['rgb', 'rgba', 'hsl', 'hsla'].indexOf(type) === -1) {
      throw new Error(["Material-UI: unsupported `".concat(color, "` color."), 'We support the following formats: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla().'].join('\n'));
    }
  }

  return {
    type: type,
    values: values
  };
}
/**
 * Converts a color object with type and values to a string.
 *
 * @param {object} color - Decomposed color
 * @param {string} color.type - One of: 'rgb', 'rgba', 'hsl', 'hsla'
 * @param {array} color.values - [n,n,n] or [n,n,n,n]
 * @returns {string} A CSS color string
 */


function recomposeColor(color) {
  var type = color.type;
  var values = color.values;

  if (type.indexOf('rgb') !== -1) {
    // Only convert the first 3 values to int (i.e. not alpha)
    values = values.map(function (n, i) {
      return i < 3 ? parseInt(n, 10) : n;
    });
  }

  if (type.indexOf('hsl') !== -1) {
    values[1] = "".concat(values[1], "%");
    values[2] = "".concat(values[2], "%");
  }

  return "".concat(color.type, "(").concat(values.join(', '), ")");
}
/**
 * Calculates the contrast ratio between two colors.
 *
 * Formula: https://www.w3.org/TR/WCAG20-TECHS/G17.html#G17-tests
 *
 * @param {string} foreground - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @param {string} background - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @returns {number} A contrast ratio value in the range 0 - 21.
 */


function getContrastRatio(foreground, background) {
  var lumA = getLuminance(foreground);
  var lumB = getLuminance(background);
  return (Math.max(lumA, lumB) + 0.05) / (Math.min(lumA, lumB) + 0.05);
}
/**
 * The relative brightness of any point in a color space,
 * normalized to 0 for darkest black and 1 for lightest white.
 *
 * Formula: https://www.w3.org/TR/WCAG20-TECHS/G17.html#G17-tests
 *
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @returns {number} The relative brightness of the color in the range 0 - 1
 */


function getLuminance(color) {
  var decomposedColor = decomposeColor(color);

  if (decomposedColor.type.indexOf('rgb') !== -1) {
    var rgb = decomposedColor.values.map(function (val) {
      val /= 255; // normalized

      return val <= 0.03928 ? val / 12.92 : Math.pow((val + 0.055) / 1.055, 2.4);
    }); // Truncate at 3 digits

    return Number((0.2126 * rgb[0] + 0.7152 * rgb[1] + 0.0722 * rgb[2]).toFixed(3));
  } // else if (decomposedColor.type.indexOf('hsl') !== -1)


  return decomposedColor.values[2] / 100;
}
/**
 * Darken or lighten a colour, depending on its luminance.
 * Light colors are darkened, dark colors are lightened.
 *
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @param {number} coefficient=0.15 - multiplier in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */


function emphasize(color) {
  var coefficient = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0.15;
  return getLuminance(color) > 0.5 ? darken(color, coefficient) : lighten(color, coefficient);
}
/**
 * Set the absolute transparency of a color.
 * Any existing alpha values are overwritten.
 *
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @param {number} value - value to set the alpha channel to in the range 0 -1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */


function fade(color, value) {
   false ? (0, _warning.default)(color, "Material-UI: missing color argument in fade(".concat(color, ", ").concat(value, ").")) : void 0;
  if (!color) return color;
  color = decomposeColor(color);
  value = clamp(value);

  if (color.type === 'rgb' || color.type === 'hsl') {
    color.type += 'a';
  }

  color.values[3] = value;
  return recomposeColor(color);
}
/**
 * Darkens a color.
 *
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @param {number} coefficient - multiplier in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */


function darken(color, coefficient) {
   false ? (0, _warning.default)(color, "Material-UI: missing color argument in darken(".concat(color, ", ").concat(coefficient, ").")) : void 0;
  if (!color) return color;
  color = decomposeColor(color);
  coefficient = clamp(coefficient);

  if (color.type.indexOf('hsl') !== -1) {
    color.values[2] *= 1 - coefficient;
  } else if (color.type.indexOf('rgb') !== -1) {
    for (var i = 0; i < 3; i += 1) {
      color.values[i] *= 1 - coefficient;
    }
  }

  return recomposeColor(color);
}
/**
 * Lightens a color.
 *
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @param {number} coefficient - multiplier in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */


function lighten(color, coefficient) {
   false ? (0, _warning.default)(color, "Material-UI: missing color argument in lighten(".concat(color, ", ").concat(coefficient, ").")) : void 0;
  if (!color) return color;
  color = decomposeColor(color);
  coefficient = clamp(coefficient);

  if (color.type.indexOf('hsl') !== -1) {
    color.values[2] += (100 - color.values[2]) * coefficient;
  } else if (color.type.indexOf('rgb') !== -1) {
    for (var i = 0; i < 3; i += 1) {
      color.values[i] += (255 - color.values[i]) * coefficient;
    }
  }

  return recomposeColor(color);
}

/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(2);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(6));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(4));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(11));

var _createClass2 = _interopRequireDefault(__webpack_require__(12));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(13));

var _inherits2 = _interopRequireDefault(__webpack_require__(14));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _hoistNonReactStatics = _interopRequireDefault(__webpack_require__(67));

var _wrapDisplayName = _interopRequireDefault(__webpack_require__(89));

var _createMuiTheme = _interopRequireDefault(__webpack_require__(171));

var _themeListener = _interopRequireDefault(__webpack_require__(172));

var defaultTheme;

function getDefaultTheme() {
  if (defaultTheme) {
    return defaultTheme;
  }

  defaultTheme = (0, _createMuiTheme.default)();
  return defaultTheme;
} // Provide the theme object as a property to the input component.


var withTheme = function withTheme() {
  return function (Component) {
    var WithTheme =
    /*#__PURE__*/
    function (_React$Component) {
      (0, _inherits2.default)(WithTheme, _React$Component);

      function WithTheme(props, context) {
        var _this;

        (0, _classCallCheck2.default)(this, WithTheme);
        _this = (0, _possibleConstructorReturn2.default)(this, (WithTheme.__proto__ || Object.getPrototypeOf(WithTheme)).call(this, props, context));
        _this.unsubscribeId = null;
        _this.state = {};
        _this.state = {
          // We use || as the function call is lazy evaluated.
          theme: _themeListener.default.initial(context) || getDefaultTheme()
        };
        return _this;
      }

      (0, _createClass2.default)(WithTheme, [{
        key: "componentDidMount",
        value: function componentDidMount() {
          var _this2 = this;

          this.unsubscribeId = _themeListener.default.subscribe(this.context, function (theme) {
            _this2.setState({
              theme: theme
            });
          });
        }
      }, {
        key: "componentWillUnmount",
        value: function componentWillUnmount() {
          if (this.unsubscribeId !== null) {
            _themeListener.default.unsubscribe(this.context, this.unsubscribeId);
          }
        }
      }, {
        key: "render",
        value: function render() {
          var _props = this.props,
              innerRef = _props.innerRef,
              other = (0, _objectWithoutProperties2.default)(_props, ["innerRef"]);
          return _react.default.createElement(Component, (0, _extends2.default)({
            theme: this.state.theme,
            ref: innerRef
          }, other));
        }
      }]);
      return WithTheme;
    }(_react.default.Component);

    WithTheme.propTypes =  false ? {
      /**
       * Use that property to pass a ref callback to the decorated component.
       */
      innerRef: _propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.object])
    } : {};
    WithTheme.contextTypes = _themeListener.default.contextTypes;

    if (false) {
      WithTheme.displayName = (0, _wrapDisplayName.default)(Component, 'WithTheme');
    }

    (0, _hoistNonReactStatics.default)(WithTheme, Component);

    if (false) {
      // Exposed for test purposes.
      WithTheme.Naked = Component;
    }

    return WithTheme;
  };
};

var _default = withTheme;
exports.default = _default;

/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(9);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(10));

var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
  fill: "none",
  d: "M0 0h24v24H0z"
}), _react.default.createElement("path", {
  d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-6h2v6zm0-8h-2V7h2v2z"
})), 'Info');

exports.default = _default;

/***/ }),
/* 73 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return cadastrarUsuario; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return confirmacaoEmail; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return confirmacaoConvite; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return enviarEmailCadastro; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return forgetPassword; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return login; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return logout; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return resetPassword; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return updateUserPassword; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return updateUserInfo; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_services_routes__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
var cadastrarUsuario=function cadastrarUsuario(info){return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_1_services_routes__["a" /* default */].user.cadastro(),info);};var confirmacaoEmail=function confirmacaoEmail(info){return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_1_services_routes__["a" /* default */].user.confirmacaoEmail(),info);};var confirmacaoConvite=function confirmacaoConvite(params){return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_1_services_routes__["a" /* default */].auth.confirmacaoConvite(),params);};var enviarEmailCadastro=function enviarEmailCadastro(info){return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_1_services_routes__["a" /* default */].user.enviarEmailCadastro(),info);};var forgetPassword=function forgetPassword(email){return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_1_services_routes__["a" /* default */].auth.forgetPassword(),{email:email});};var login=function login(username,password){return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_1_services_routes__["a" /* default */].auth.login(),'username='+username+'&password='+password+'&grant_type=password');};// A lib no servidor requer um header que está sendo forçadamente adicionado via o fake authToken.
var logout=function logout(){return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_1_services_routes__["a" /* default */].auth.logout(),'authToken='+Object(__WEBPACK_IMPORTED_MODULE_2_lodash__["random"])(0,100000)+'.'+Object(__WEBPACK_IMPORTED_MODULE_2_lodash__["random"])(0,100000));};var resetPassword=function resetPassword(params){return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_1_services_routes__["a" /* default */].auth.reset(),params);};var updateUserPassword=function updateUserPassword(params){return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_1_services_routes__["a" /* default */].auth.update(),params);};var updateUserInfo=function updateUserInfo(params){return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_1_services_routes__["a" /* default */].user.update(),params);};

/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(2);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Checkbox.default;
  }
});

var _Checkbox = _interopRequireDefault(__webpack_require__(547));

/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(2);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Tooltip.default;
  }
});

var _Tooltip = _interopRequireDefault(__webpack_require__(582));

/***/ }),
/* 76 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var lightTooltipStyle=function lightTooltipStyle(theme){return{lightTooltip:{background:theme.palette.common.white,boxShadow:theme.shadows[1],color:theme.palette.text.primary,fontSize:13,lineHeight:"25px",maxWidth:"unset","& div":{display:"flex",justifyContent:"space-between"},"& b":{marginLeft:"10px"}},lightTooltipPopper:{opacity:1},tooltipContentWrapper:{display:"flex","& > svg":{marginLeft:"5px"}}};};/* harmony default export */ __webpack_exports__["a"] = (lightTooltipStyle);

/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(9);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(10));

var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("defs", null, _react.default.createElement("path", {
  id: "a",
  d: "M0 0h24v24H0V0z"
})), _react.default.createElement("clipPath", {
  id: "b"
}, _react.default.createElement("use", {
  overflow: "visible",
  xlinkHref: "#a"
})), _react.default.createElement("path", {
  d: "M23 8c0 1.1-.9 2-2 2-.18 0-.35-.02-.51-.07l-3.56 3.55c.05.16.07.34.07.52 0 1.1-.9 2-2 2s-2-.9-2-2c0-.18.02-.36.07-.52l-2.55-2.55c-.16.05-.34.07-.52.07s-.36-.02-.52-.07l-4.55 4.56c.05.16.07.33.07.51 0 1.1-.9 2-2 2s-2-.9-2-2 .9-2 2-2c.18 0 .35.02.51.07l4.56-4.55C8.02 9.36 8 9.18 8 9c0-1.1.9-2 2-2s2 .9 2 2c0 .18-.02.36-.07.52l2.55 2.55c.16-.05.34-.07.52-.07s.36.02.52.07l3.55-3.56C19.02 8.35 19 8.18 19 8c0-1.1.9-2 2-2s2 .9 2 2z",
  clipPath: "url(#b)"
})), 'Timeline');

exports.default = _default;

/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * @namespace Chart
 */
var Chart = __webpack_require__(659)();

Chart.helpers = __webpack_require__(15);

// @todo dispatch these helpers into appropriated helpers/helpers.* file and write unit tests!
__webpack_require__(663)(Chart);

Chart.defaults = __webpack_require__(20);
Chart.Element = __webpack_require__(46);
Chart.elements = __webpack_require__(55);
Chart.Interaction = __webpack_require__(291);
Chart.layouts = __webpack_require__(106);
Chart.platform = __webpack_require__(292);
Chart.plugins = __webpack_require__(293);
Chart.Ticks = __webpack_require__(107);

__webpack_require__(674)(Chart);
__webpack_require__(675)(Chart);
__webpack_require__(676)(Chart);
__webpack_require__(677)(Chart);
__webpack_require__(678)(Chart);
__webpack_require__(679)(Chart);

__webpack_require__(680)(Chart);
__webpack_require__(681)(Chart);
__webpack_require__(682)(Chart);
__webpack_require__(683)(Chart);
__webpack_require__(684)(Chart);
__webpack_require__(685)(Chart);

// Controllers must be loaded after elements
// See Chart.core.datasetController.dataElementType
__webpack_require__(686)(Chart);
__webpack_require__(687)(Chart);
__webpack_require__(688)(Chart);
__webpack_require__(689)(Chart);
__webpack_require__(690)(Chart);
__webpack_require__(691)(Chart);
__webpack_require__(692)(Chart);

__webpack_require__(693)(Chart);
__webpack_require__(694)(Chart);
__webpack_require__(695)(Chart);
__webpack_require__(696)(Chart);
__webpack_require__(697)(Chart);
__webpack_require__(698)(Chart);
__webpack_require__(699)(Chart);

// Loading built-it plugins
var plugins = __webpack_require__(700);
for (var k in plugins) {
	if (plugins.hasOwnProperty(k)) {
		Chart.plugins.register(plugins[k]);
	}
}

Chart.platform.initialize();

module.exports = Chart;
if (typeof window !== 'undefined') {
	window.Chart = Chart;
}

// DEPRECATIONS

/**
 * Provided for backward compatibility, not available anymore
 * @namespace Chart.Legend
 * @deprecated since version 2.1.5
 * @todo remove at version 3
 * @private
 */
Chart.Legend = plugins.legend._element;

/**
 * Provided for backward compatibility, not available anymore
 * @namespace Chart.Title
 * @deprecated since version 2.1.5
 * @todo remove at version 3
 * @private
 */
Chart.Title = plugins.title._element;

/**
 * Provided for backward compatibility, use Chart.plugins instead
 * @namespace Chart.pluginService
 * @deprecated since version 2.1.5
 * @todo remove at version 3
 * @private
 */
Chart.pluginService = Chart.plugins;

/**
 * Provided for backward compatibility, inheriting from Chart.PlugingBase has no
 * effect, instead simply create/register plugins via plain JavaScript objects.
 * @interface Chart.PluginBase
 * @deprecated since version 2.5.0
 * @todo remove at version 3
 * @private
 */
Chart.PluginBase = Chart.Element.extend({});

/**
 * Provided for backward compatibility, use Chart.helpers.canvas instead.
 * @namespace Chart.canvasHelpers
 * @deprecated since version 2.6.0
 * @todo remove at version 3
 * @private
 */
Chart.canvasHelpers = Chart.helpers.canvas;

/**
 * Provided for backward compatibility, use Chart.layouts instead.
 * @namespace Chart.layoutService
 * @deprecated since version 2.8.0
 * @todo remove at version 3
 * @private
 */
Chart.layoutService = Chart.layouts;


/***/ }),
/* 79 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_styles_withStyles__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_styles_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_styles_withStyles__);
var style={infoGrid:{background:"#fff",color:"rgba(0, 0, 0, 0.87)",display:"grid",gridColumnGap:"20px",gridRowGap:"5px",gridTemplateColumns:"repeat(auto-fit, minmax(200px, 1fr))",width:"100%","@media (max-width: 768px)":{gridTemplateColumns:"1fr"}}};function InfoGrid(_ref){var children=_ref.children,classes=_ref.classes;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:classes.infoGrid},children);}InfoGrid.propTypes={children:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.node.isRequired,classes:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object.isRequired};/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_2__material_ui_core_styles_withStyles___default()(style)(InfoGrid));

/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(58);
var createDesc = __webpack_require__(109);
module.exports = __webpack_require__(59) ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(82);
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};


/***/ }),
/* 82 */
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),
/* 83 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};


/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__(309);
var defined = __webpack_require__(192);
module.exports = function (it) {
  return IObject(defined(it));
};


/***/ }),
/* 85 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

module.exports = isObjectLike;


/***/ }),
/* 86 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var centerStyle=function centerStyle(theme){return _defineProperty({margin:"0 auto",width:"1150px"},theme.breakpoints.down("sm"),{padding:"20px",width:"auto"});};/* harmony default export */ __webpack_exports__["a"] = (centerStyle);

/***/ }),
/* 87 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return addLeadingSlash; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return stripLeadingSlash; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return hasBasename; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return stripBasename; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return stripTrailingSlash; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return parsePath; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return createPath; });
var addLeadingSlash = function addLeadingSlash(path) {
  return path.charAt(0) === '/' ? path : '/' + path;
};

var stripLeadingSlash = function stripLeadingSlash(path) {
  return path.charAt(0) === '/' ? path.substr(1) : path;
};

var hasBasename = function hasBasename(path, prefix) {
  return new RegExp('^' + prefix + '(\\/|\\?|#|$)', 'i').test(path);
};

var stripBasename = function stripBasename(path, prefix) {
  return hasBasename(path, prefix) ? path.substr(prefix.length) : path;
};

var stripTrailingSlash = function stripTrailingSlash(path) {
  return path.charAt(path.length - 1) === '/' ? path.slice(0, -1) : path;
};

var parsePath = function parsePath(path) {
  var pathname = path || '/';
  var search = '';
  var hash = '';

  var hashIndex = pathname.indexOf('#');
  if (hashIndex !== -1) {
    hash = pathname.substr(hashIndex);
    pathname = pathname.substr(0, hashIndex);
  }

  var searchIndex = pathname.indexOf('?');
  if (searchIndex !== -1) {
    search = pathname.substr(searchIndex);
    pathname = pathname.substr(0, searchIndex);
  }

  return {
    pathname: pathname,
    search: search === '?' ? '' : search,
    hash: hash === '#' ? '' : hash
  };
};

var createPath = function createPath(location) {
  var pathname = location.pathname,
      search = location.search,
      hash = location.hash;


  var path = pathname || '/';

  if (search && search !== '?') path += search.charAt(0) === '?' ? search : '?' + search;

  if (hash && hash !== '#') path += hash.charAt(0) === '#' ? hash : '#' + hash;

  return path;
};

/***/ }),
/* 88 */
/***/ (function(module, exports) {

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

module.exports = _assertThisInitialized;

/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(90);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _getDisplayName = _interopRequireDefault(__webpack_require__(167));

var wrapDisplayName = function wrapDisplayName(BaseComponent, hocName) {
  return hocName + "(" + (0, _getDisplayName.default)(BaseComponent) + ")";
};

var _default = wrapDisplayName;
exports.default = _default;

/***/ }),
/* 90 */
/***/ (function(module, exports) {

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

module.exports = _interopRequireDefault;

/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _createRule = __webpack_require__(119);

var _createRule2 = _interopRequireDefault(_createRule);

var _linkRule = __webpack_require__(235);

var _linkRule2 = _interopRequireDefault(_linkRule);

var _StyleRule = __webpack_require__(69);

var _StyleRule2 = _interopRequireDefault(_StyleRule);

var _escape = __webpack_require__(442);

var _escape2 = _interopRequireDefault(_escape);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Contains rules objects and allows adding/removing etc.
 * Is used for e.g. by `StyleSheet` or `ConditionalRule`.
 */
var RuleList = function () {

  // Original styles object.
  function RuleList(options) {
    var _this = this;

    _classCallCheck(this, RuleList);

    this.map = {};
    this.raw = {};
    this.index = [];

    this.update = function (name, data) {
      var _options = _this.options,
          plugins = _options.jss.plugins,
          sheet = _options.sheet;

      if (typeof name === 'string') {
        plugins.onUpdate(data, _this.get(name), sheet);
      } else {
        for (var index = 0; index < _this.index.length; index++) {
          plugins.onUpdate(name, _this.index[index], sheet);
        }
      }
    };

    this.options = options;
    this.classes = options.classes;
  }

  /**
   * Create and register rule.
   *
   * Will not render after Style Sheet was rendered the first time.
   */


  // Used to ensure correct rules order.

  // Rules registry for access by .get() method.
  // It contains the same rule registered by name and by selector.


  _createClass(RuleList, [{
    key: 'add',
    value: function add(name, decl, options) {
      var _options2 = this.options,
          parent = _options2.parent,
          sheet = _options2.sheet,
          jss = _options2.jss,
          Renderer = _options2.Renderer,
          generateClassName = _options2.generateClassName;


      options = _extends({
        classes: this.classes,
        parent: parent,
        sheet: sheet,
        jss: jss,
        Renderer: Renderer,
        generateClassName: generateClassName
      }, options);

      if (!options.selector && this.classes[name]) {
        options.selector = '.' + (0, _escape2['default'])(this.classes[name]);
      }

      this.raw[name] = decl;

      var rule = (0, _createRule2['default'])(name, decl, options);

      var className = void 0;

      if (!options.selector && rule instanceof _StyleRule2['default']) {
        className = generateClassName(rule, sheet);
        rule.selector = '.' + (0, _escape2['default'])(className);
      }

      this.register(rule, className);

      var index = options.index === undefined ? this.index.length : options.index;
      this.index.splice(index, 0, rule);

      return rule;
    }

    /**
     * Get a rule.
     */

  }, {
    key: 'get',
    value: function get(name) {
      return this.map[name];
    }

    /**
     * Delete a rule.
     */

  }, {
    key: 'remove',
    value: function remove(rule) {
      this.unregister(rule);
      this.index.splice(this.indexOf(rule), 1);
    }

    /**
     * Get index of a rule.
     */

  }, {
    key: 'indexOf',
    value: function indexOf(rule) {
      return this.index.indexOf(rule);
    }

    /**
     * Run `onProcessRule()` plugins on every rule.
     */

  }, {
    key: 'process',
    value: function process() {
      var plugins = this.options.jss.plugins;
      // We need to clone array because if we modify the index somewhere else during a loop
      // we end up with very hard-to-track-down side effects.

      this.index.slice(0).forEach(plugins.onProcessRule, plugins);
    }

    /**
     * Register a rule in `.map` and `.classes` maps.
     */

  }, {
    key: 'register',
    value: function register(rule, className) {
      this.map[rule.key] = rule;
      if (rule instanceof _StyleRule2['default']) {
        this.map[rule.selector] = rule;
        if (className) this.classes[rule.key] = className;
      }
    }

    /**
     * Unregister a rule.
     */

  }, {
    key: 'unregister',
    value: function unregister(rule) {
      delete this.map[rule.key];
      if (rule instanceof _StyleRule2['default']) {
        delete this.map[rule.selector];
        delete this.classes[rule.key];
      }
    }

    /**
     * Update the function values with a new data.
     */

  }, {
    key: 'link',


    /**
     * Link renderable rules with CSSRuleList.
     */
    value: function link(cssRules) {
      var map = this.options.sheet.renderer.getUnescapedKeysMap(this.index);

      for (var i = 0; i < cssRules.length; i++) {
        var cssRule = cssRules[i];
        var _key = this.options.sheet.renderer.getKey(cssRule);
        if (map[_key]) _key = map[_key];
        var rule = this.map[_key];
        if (rule) (0, _linkRule2['default'])(rule, cssRule);
      }
    }

    /**
     * Convert rules to a CSS string.
     */

  }, {
    key: 'toString',
    value: function toString(options) {
      var str = '';
      var sheet = this.options.sheet;

      var link = sheet ? sheet.options.link : false;

      for (var index = 0; index < this.index.length; index++) {
        var rule = this.index[index];
        var css = rule.toString(options);

        // No need to render an empty rule.
        if (!css && !link) continue;

        if (str) str += '\n';
        str += css;
      }

      return str;
    }
  }]);

  return RuleList;
}();

exports['default'] = RuleList;

/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(2);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = createBreakpoints;
exports.keys = void 0;

var _objectSpread2 = _interopRequireDefault(__webpack_require__(17));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(4));

// Sorted ASC by size. That's important.
// It can't be configured as it's used statically for propTypes.
var keys = ['xs', 'sm', 'md', 'lg', 'xl']; // Keep in mind that @media is inclusive by the CSS specification.

exports.keys = keys;

function createBreakpoints(breakpoints) {
  var _breakpoints$values = breakpoints.values,
      values = _breakpoints$values === void 0 ? {
    xs: 0,
    sm: 600,
    md: 960,
    lg: 1280,
    xl: 1920
  } : _breakpoints$values,
      _breakpoints$unit = breakpoints.unit,
      unit = _breakpoints$unit === void 0 ? 'px' : _breakpoints$unit,
      _breakpoints$step = breakpoints.step,
      step = _breakpoints$step === void 0 ? 5 : _breakpoints$step,
      other = (0, _objectWithoutProperties2.default)(breakpoints, ["values", "unit", "step"]);

  function up(key) {
    var value = typeof values[key] === 'number' ? values[key] : key;
    return "@media (min-width:".concat(value).concat(unit, ")");
  }

  function down(key) {
    var endIndex = keys.indexOf(key) + 1;
    var upperbound = values[keys[endIndex]];

    if (endIndex === keys.length) {
      // xl down applies to all sizes
      return up('xs');
    }

    var value = typeof upperbound === 'number' && endIndex > 0 ? upperbound : key;
    return "@media (max-width:".concat(value - step / 100).concat(unit, ")");
  }

  function between(start, end) {
    var endIndex = keys.indexOf(end) + 1;

    if (endIndex === keys.length) {
      return up(start);
    }

    return "@media (min-width:".concat(values[start]).concat(unit, ") and ") + "(max-width:".concat(values[keys[endIndex]] - step / 100).concat(unit, ")");
  }

  function only(key) {
    return between(key, key);
  }

  function width(key) {
    return values[key];
  }

  return (0, _objectSpread2.default)({
    keys: keys,
    values: values,
    up: up,
    down: down,
    between: between,
    only: only,
    width: width
  }, other);
}

/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(2);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.isNumber = exports.isString = exports.formatMs = exports.duration = exports.easing = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(4));

var _warning = _interopRequireDefault(__webpack_require__(16));

/* eslint-disable no-param-reassign */

/* eslint-disable no-restricted-globals */
// Follow https://material.google.com/motion/duration-easing.html#duration-easing-natural-easing-curves
// to learn the context in which each easing should be used.
var easing = {
  // This is the most common easing curve.
  easeInOut: 'cubic-bezier(0.4, 0, 0.2, 1)',
  // Objects enter the screen at full velocity from off-screen and
  // slowly decelerate to a resting point.
  easeOut: 'cubic-bezier(0.0, 0, 0.2, 1)',
  // Objects leave the screen at full velocity. They do not decelerate when off-screen.
  easeIn: 'cubic-bezier(0.4, 0, 1, 1)',
  // The sharp curve is used by objects that may return to the screen at any time.
  sharp: 'cubic-bezier(0.4, 0, 0.6, 1)'
}; // Follow https://material.io/guidelines/motion/duration-easing.html#duration-easing-common-durations
// to learn when use what timing

exports.easing = easing;
var duration = {
  shortest: 150,
  shorter: 200,
  short: 250,
  // most basic recommended timing
  standard: 300,
  // this is to be used in complex animations
  complex: 375,
  // recommended when something is entering screen
  enteringScreen: 225,
  // recommended when something is leaving screen
  leavingScreen: 195
};
exports.duration = duration;

var formatMs = function formatMs(milliseconds) {
  return "".concat(Math.round(milliseconds), "ms");
};

exports.formatMs = formatMs;

var isString = function isString(value) {
  return typeof value === 'string';
};

exports.isString = isString;

var isNumber = function isNumber(value) {
  return !isNaN(parseFloat(value));
};
/**
 * @param {string|Array} props
 * @param {object} param
 * @param {string} param.prop
 * @param {number} param.duration
 * @param {string} param.easing
 * @param {number} param.delay
 */


exports.isNumber = isNumber;
var _default = {
  easing: easing,
  duration: duration,
  create: function create() {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ['all'];
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return function () {
      var _options$duration = options.duration,
          durationOption = _options$duration === void 0 ? duration.standard : _options$duration,
          _options$easing = options.easing,
          easingOption = _options$easing === void 0 ? easing.easeInOut : _options$easing,
          _options$delay = options.delay,
          delay = _options$delay === void 0 ? 0 : _options$delay,
          other = (0, _objectWithoutProperties2.default)(options, ["duration", "easing", "delay"]);
       false ? (0, _warning.default)(isString(props) || Array.isArray(props), 'Material-UI: argument "props" must be a string or Array.') : void 0;
       false ? (0, _warning.default)(isNumber(durationOption) || isString(durationOption), "Material-UI: argument \"duration\" must be a number or a string but found ".concat(durationOption, ".")) : void 0;
       false ? (0, _warning.default)(isString(easingOption), 'Material-UI: argument "easing" must be a string.') : void 0;
       false ? (0, _warning.default)(isNumber(delay) || isString(delay), 'Material-UI: argument "delay" must be a number or a string.') : void 0;
       false ? (0, _warning.default)(Object.keys(other).length === 0, "Material-UI: unrecognized argument(s) [".concat(Object.keys(other).join(','), "]")) : void 0;
      return (Array.isArray(props) ? props : [props]).map(function (animatedProp) {
        return "".concat(animatedProp, " ").concat(typeof durationOption === 'string' ? durationOption : formatMs(durationOption), " ").concat(easingOption, " ").concat(typeof delay === 'string' ? delay : formatMs(delay));
      }).join(',');
    }();
  },
  getAutoHeightDuration: function getAutoHeightDuration(height) {
    if (!height) {
      return 0;
    }

    var constant = height / 36; // https://www.wolframalpha.com/input/?i=(4+%2B+15+*+(x+%2F+36+)+**+0.25+%2B+(x+%2F+36)+%2F+5)+*+10

    return Math.round((4 + 15 * Math.pow(constant, 0.25) + constant / 5) * 10);
  }
};
exports.default = _default;

/***/ }),
/* 94 */
/***/ (function(module, exports) {

module.exports = function(module) {
	if(!module.webpackPolyfill) {
		module.deprecate = function() {};
		module.paths = [];
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(2);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.specialProperty = void 0;

var _defineProperty2 = _interopRequireDefault(__webpack_require__(7));

var _objectSpread3 = _interopRequireDefault(__webpack_require__(17));

// This module is based on https://github.com/airbnb/prop-types-exact repository.
// However, in order to reduce the number of dependencies and to remove some extra safe checks
// the module was forked.
// Only exported for test purposes.
var specialProperty = "exact-prop: \u200B";
exports.specialProperty = specialProperty;

function exactProp(propTypes) {
  /* istanbul ignore if */
  if (true) {
    return propTypes;
  }

  return (0, _objectSpread3.default)({}, propTypes, (0, _defineProperty2.default)({}, specialProperty, function (props) {
    var unsupportedProps = Object.keys(props).filter(function (prop) {
      return !propTypes.hasOwnProperty(prop);
    });

    if (unsupportedProps.length > 0) {
      return new Error("The following properties are not supported: ".concat(unsupportedProps.map(function (prop) {
        return "`".concat(prop, "`");
      }).join(', '), ". Please remove them."));
    }

    return null;
  }));
}

var _default = exactProp;
exports.default = _default;

/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(90);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _shouldUpdate = _interopRequireDefault(__webpack_require__(491));

var _shallowEqual = _interopRequireDefault(__webpack_require__(494));

var _setDisplayName = _interopRequireDefault(__webpack_require__(242));

var _wrapDisplayName = _interopRequireDefault(__webpack_require__(89));

var pure = function pure(BaseComponent) {
  var hoc = (0, _shouldUpdate.default)(function (props, nextProps) {
    return !(0, _shallowEqual.default)(props, nextProps);
  });

  if (false) {
    return (0, _setDisplayName.default)((0, _wrapDisplayName.default)(BaseComponent, 'pure'))(hoc(BaseComponent));
  }

  return hoc(BaseComponent);
};

var _default = pure;
exports.default = _default;

/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(2);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _SvgIcon.default;
  }
});

var _SvgIcon = _interopRequireDefault(__webpack_require__(495));

/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(2);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _IconButton.default;
  }
});

var _IconButton = _interopRequireDefault(__webpack_require__(497));

/***/ }),
/* 99 */
/***/ (function(module, exports) {

// Source: http://jsfiddle.net/vWx8V/
// http://stackoverflow.com/questions/5603195/full-list-of-javascript-keycodes

/**
 * Conenience method returns corresponding value for given keyName or keyCode.
 *
 * @param {Mixed} keyCode {Number} or keyName {String}
 * @return {Mixed}
 * @api public
 */

function keyCode(searchInput) {
  // Keyboard Events
  if (searchInput && 'object' === typeof searchInput) {
    var hasKeyCode = searchInput.which || searchInput.keyCode || searchInput.charCode
    if (hasKeyCode) searchInput = hasKeyCode
  }

  // Numbers
  if ('number' === typeof searchInput) return names[searchInput]

  // Everything else (cast to string)
  var search = String(searchInput)

  // check codes
  var foundNamedKey = codes[search.toLowerCase()]
  if (foundNamedKey) return foundNamedKey

  // check aliases
  var foundNamedKey = aliases[search.toLowerCase()]
  if (foundNamedKey) return foundNamedKey

  // weird character?
  if (search.length === 1) return search.charCodeAt(0)

  return undefined
}

/**
 * Compares a keyboard event with a given keyCode or keyName.
 *
 * @param {Event} event Keyboard event that should be tested
 * @param {Mixed} keyCode {Number} or keyName {String}
 * @return {Boolean}
 * @api public
 */
keyCode.isEventKey = function isEventKey(event, nameOrCode) {
  if (event && 'object' === typeof event) {
    var keyCode = event.which || event.keyCode || event.charCode
    if (keyCode === null || keyCode === undefined) { return false; }
    if (typeof nameOrCode === 'string') {
      // check codes
      var foundNamedKey = codes[nameOrCode.toLowerCase()]
      if (foundNamedKey) { return foundNamedKey === keyCode; }
    
      // check aliases
      var foundNamedKey = aliases[nameOrCode.toLowerCase()]
      if (foundNamedKey) { return foundNamedKey === keyCode; }
    } else if (typeof nameOrCode === 'number') {
      return nameOrCode === keyCode;
    }
    return false;
  }
}

exports = module.exports = keyCode;

/**
 * Get by name
 *
 *   exports.code['enter'] // => 13
 */

var codes = exports.code = exports.codes = {
  'backspace': 8,
  'tab': 9,
  'enter': 13,
  'shift': 16,
  'ctrl': 17,
  'alt': 18,
  'pause/break': 19,
  'caps lock': 20,
  'esc': 27,
  'space': 32,
  'page up': 33,
  'page down': 34,
  'end': 35,
  'home': 36,
  'left': 37,
  'up': 38,
  'right': 39,
  'down': 40,
  'insert': 45,
  'delete': 46,
  'command': 91,
  'left command': 91,
  'right command': 93,
  'numpad *': 106,
  'numpad +': 107,
  'numpad -': 109,
  'numpad .': 110,
  'numpad /': 111,
  'num lock': 144,
  'scroll lock': 145,
  'my computer': 182,
  'my calculator': 183,
  ';': 186,
  '=': 187,
  ',': 188,
  '-': 189,
  '.': 190,
  '/': 191,
  '`': 192,
  '[': 219,
  '\\': 220,
  ']': 221,
  "'": 222
}

// Helper aliases

var aliases = exports.aliases = {
  'windows': 91,
  '⇧': 16,
  '⌥': 18,
  '⌃': 17,
  '⌘': 91,
  'ctl': 17,
  'control': 17,
  'option': 18,
  'pause': 19,
  'break': 19,
  'caps': 20,
  'return': 13,
  'escape': 27,
  'spc': 32,
  'spacebar': 32,
  'pgup': 33,
  'pgdn': 34,
  'ins': 45,
  'del': 46,
  'cmd': 91
}

/*!
 * Programatically add the following
 */

// lower case chars
for (i = 97; i < 123; i++) codes[String.fromCharCode(i)] = i - 32

// numbers
for (var i = 48; i < 58; i++) codes[i - 48] = i

// function keys
for (i = 1; i < 13; i++) codes['f'+i] = i + 111

// numpad keys
for (i = 0; i < 10; i++) codes['numpad '+i] = i + 96

/**
 * Get by code
 *
 *   exports.name[13] // => 'Enter'
 */

var names = exports.names = exports.title = {} // title for backward compat

// Create reverse mapping
for (i in codes) names[codes[i]] = i

// Add aliases
for (var alias in aliases) {
  codes[alias] = aliases[alias]
}


/***/ }),
/* 100 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return showAlert; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return dismissAlert; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__(247);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_reducers_action_helpers__ = __webpack_require__(248);
// ACTION CREATORS
var alertCreated=Object(__WEBPACK_IMPORTED_MODULE_2_reducers_action_helpers__["b" /* makeStandardActionCreator */])(__WEBPACK_IMPORTED_MODULE_1__constants__["b" /* SHOW_ALERT */]);var alertDismissed=Object(__WEBPACK_IMPORTED_MODULE_2_reducers_action_helpers__["b" /* makeStandardActionCreator */])(__WEBPACK_IMPORTED_MODULE_1__constants__["a" /* DISMISS_ALERT */]);/**
  * @param {Object} payload - contains 'message' and 'type' properties.
  * @param {String} payload.message
  * @param {String} payload.type - 'error'(vermelho), 'info'(azul), 'success'(verde), 'warning'(amarelo)
  */var showAlert=function showAlert(payload){return function(dispatch){var id=Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["uniqueId"])('alert_');payload.id=id;dispatch(alertCreated(payload));setTimeout(function(){dispatch(alertDismissed({id:id}));},5000);};};var dismissAlert=function dismissAlert(id){return function(dispatch){dispatch(alertDismissed({id:id}));};};

/***/ }),
/* 101 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles_withStyles__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_FormControl__ = __webpack_require__(182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_FormControl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_FormControl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_InputLabel__ = __webpack_require__(185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_InputLabel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_InputLabel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_FormHelperText__ = __webpack_require__(262);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_FormHelperText___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_FormHelperText__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_Input__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_Input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_Input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_assets_jss_material_dashboard_pro_react_components_customInputStyle_jsx__ = __webpack_require__(569);
function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}// nodejs library to set properties for components
// nodejs library that concatenates classes
// @material-ui/core components
function CustomInput(_ref){var _classNames,_classNames2,_classNames4,_classNames5;var props=_objectWithoutProperties(_ref,[]);var classes=props.classes,formControlProps=props.formControlProps,labelText=props.labelText,id=props.id,labelProps=props.labelProps,inputProps=props.inputProps,error=props.error,white=props.white,inputRootCustomClasses=props.inputRootCustomClasses,success=props.success,helpText=props.helpText;var labelClasses=__WEBPACK_IMPORTED_MODULE_2_classnames___default()((_classNames={},_defineProperty(_classNames," "+classes.labelRootError,error),_defineProperty(_classNames," "+classes.labelRootSuccess,success&&!error),_classNames));var underlineClasses=__WEBPACK_IMPORTED_MODULE_2_classnames___default()((_classNames2={},_defineProperty(_classNames2,classes.underlineError,error),_defineProperty(_classNames2,classes.underlineSuccess,success&&!error),_defineProperty(_classNames2,classes.underline,true),_defineProperty(_classNames2,classes.whiteUnderline,white),_classNames2));var marginTop=__WEBPACK_IMPORTED_MODULE_2_classnames___default()(_defineProperty({},inputRootCustomClasses,inputRootCustomClasses!==undefined));var inputClasses=__WEBPACK_IMPORTED_MODULE_2_classnames___default()((_classNames4={},_defineProperty(_classNames4,classes.input,true),_defineProperty(_classNames4,classes.whiteInput,white),_classNames4));var formControlClasses;if(formControlProps!==undefined){formControlClasses=__WEBPACK_IMPORTED_MODULE_2_classnames___default()(formControlProps.className,classes.formControl);}else{formControlClasses=classes.formControl;}var helpTextClasses=__WEBPACK_IMPORTED_MODULE_2_classnames___default()((_classNames5={},_defineProperty(_classNames5,classes.labelRootError,error),_defineProperty(_classNames5,classes.labelRootSuccess,success&&!error),_classNames5));return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_FormControl___default.a,Object.assign({},formControlProps,{className:formControlClasses}),labelText!==undefined?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_InputLabel___default.a,Object.assign({className:classes.labelRoot+" "+labelClasses,htmlFor:id},labelProps),labelText):null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_Input___default.a,Object.assign({classes:{input:inputClasses,root:marginTop,disabled:classes.disabled,underline:underlineClasses},id:id},inputProps)),helpText!==undefined?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_FormHelperText___default.a,{id:id+"-text",className:helpTextClasses},helpText):null);}CustomInput.propTypes={classes:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,labelText:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,labelProps:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,id:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,inputProps:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,formControlProps:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,inputRootCustomClasses:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,error:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,success:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,white:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,helpText:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node};/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles_withStyles___default()(__WEBPACK_IMPORTED_MODULE_8_assets_jss_material_dashboard_pro_react_components_customInputStyle_jsx__["a" /* default */])(CustomInput));

/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var _classCallCheck = _interopDefault(__webpack_require__(557));
var _createClass = _interopDefault(__webpack_require__(558));
var _possibleConstructorReturn = _interopDefault(__webpack_require__(559));
var _inherits = _interopDefault(__webpack_require__(561));
var _typeof = _interopDefault(__webpack_require__(261));
var _objectWithoutProperties = _interopDefault(__webpack_require__(562));
var _objectSpread = _interopDefault(__webpack_require__(563));
var React = _interopDefault(__webpack_require__(0));
var PropTypes = _interopDefault(__webpack_require__(1));
var warning = _interopDefault(__webpack_require__(16));

function defineProperty(object, property, attr) {
  return Object.defineProperty(object, property, attr);
} // Passive options
// Inspired by https://github.com/Modernizr/Modernizr/blob/master/feature-detects/dom/passiveeventlisteners.js


var passiveOption = function () {
  var cache = null;
  return function () {
    if (cache !== null) {
      return cache;
    }

    var supportsPassiveOption = false;

    try {
      window.addEventListener('test', null, defineProperty({}, 'passive', {
        get: function get() {
          supportsPassiveOption = true;
        }
      }));
    } catch (err) {//
    }

    cache = supportsPassiveOption;
    return supportsPassiveOption;
  }();
}();

var defaultEventOptions = {
  capture: false,
  passive: false
};

function mergeDefaultEventOptions(options) {
  return _objectSpread({}, defaultEventOptions, options);
}

function getEventListenerArgs(eventName, callback, options) {
  var args = [eventName, callback];
  args.push(passiveOption ? options : options.capture);
  return args;
}

function on(target, eventName, callback, options) {
  // eslint-disable-next-line prefer-spread
  target.addEventListener.apply(target, getEventListenerArgs(eventName, callback, options));
}

function off(target, eventName, callback, options) {
  // eslint-disable-next-line prefer-spread
  target.removeEventListener.apply(target, getEventListenerArgs(eventName, callback, options));
}

function forEachListener(props, iteratee) {
  var children = props.children,
      target = props.target,
      eventProps = _objectWithoutProperties(props, ["children", "target"]);

  Object.keys(eventProps).forEach(function (name) {
    if (name.substring(0, 2) !== 'on') {
      return;
    }

    var prop = eventProps[name];

    var type = _typeof(prop);

    var isObject = type === 'object';
    var isFunction = type === 'function';

    if (!isObject && !isFunction) {
      return;
    }

    var capture = name.substr(-7).toLowerCase() === 'capture';
    var eventName = name.substring(2).toLowerCase();
    eventName = capture ? eventName.substring(0, eventName.length - 7) : eventName;

    if (isObject) {
      iteratee(eventName, prop.handler, prop.options);
    } else {
      iteratee(eventName, prop, mergeDefaultEventOptions({
        capture: capture
      }));
    }
  });
}

function withOptions(handler, options) {
   false ? warning(options, 'react-event-listener: should be specified options in withOptions.') : void 0;
  return {
    handler: handler,
    options: mergeDefaultEventOptions(options)
  };
}

var EventListener =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(EventListener, _React$PureComponent);

  function EventListener() {
    _classCallCheck(this, EventListener);

    return _possibleConstructorReturn(this, (EventListener.__proto__ || Object.getPrototypeOf(EventListener)).apply(this, arguments));
  }

  _createClass(EventListener, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.applyListeners(on);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      this.applyListeners(off, prevProps);
      this.applyListeners(on);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.applyListeners(off);
    }
  }, {
    key: "applyListeners",
    value: function applyListeners(onOrOff) {
      var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.props;
      var target = props.target;

      if (target) {
        var element = target;

        if (typeof target === 'string') {
          element = window[target];
        }

        forEachListener(props, onOrOff.bind(null, element));
      }
    }
  }, {
    key: "render",
    value: function render() {
      return this.props.children || null;
    }
  }]);

  return EventListener;
}(React.PureComponent);

EventListener.propTypes =  false ? {
  /**
   * You can provide a single child too.
   */
  children: PropTypes.node,

  /**
   * The DOM target to listen to.
   */
  target: PropTypes.oneOfType([PropTypes.object, PropTypes.string]).isRequired
} : {};

exports.withOptions = withOptions;
exports.default = EventListener;


/***/ }),
/* 103 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export SelectBase */
/* unused harmony export Async */
/* unused harmony export AsyncCreatable */
/* unused harmony export Creatable */
/* unused harmony export createFilter */
/* unused harmony export makeAnimated */
/* unused harmony export components */
/* unused harmony export mergeStyles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_emotion__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_dom__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_raf__ = __webpack_require__(268);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_raf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_raf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_input_autosize__ = __webpack_require__(269);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_input_autosize___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_input_autosize__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_transition_group__ = __webpack_require__(187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_transition_group___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_transition_group__);








var diacritics = [{ base: 'A', letters: /[\u0041\u24B6\uFF21\u00C0\u00C1\u00C2\u1EA6\u1EA4\u1EAA\u1EA8\u00C3\u0100\u0102\u1EB0\u1EAE\u1EB4\u1EB2\u0226\u01E0\u00C4\u01DE\u1EA2\u00C5\u01FA\u01CD\u0200\u0202\u1EA0\u1EAC\u1EB6\u1E00\u0104\u023A\u2C6F]/g }, { base: 'AA', letters: /[\uA732]/g }, { base: 'AE', letters: /[\u00C6\u01FC\u01E2]/g }, { base: 'AO', letters: /[\uA734]/g }, { base: 'AU', letters: /[\uA736]/g }, { base: 'AV', letters: /[\uA738\uA73A]/g }, { base: 'AY', letters: /[\uA73C]/g }, { base: 'B', letters: /[\u0042\u24B7\uFF22\u1E02\u1E04\u1E06\u0243\u0182\u0181]/g }, { base: 'C', letters: /[\u0043\u24B8\uFF23\u0106\u0108\u010A\u010C\u00C7\u1E08\u0187\u023B\uA73E]/g }, { base: 'D', letters: /[\u0044\u24B9\uFF24\u1E0A\u010E\u1E0C\u1E10\u1E12\u1E0E\u0110\u018B\u018A\u0189\uA779]/g }, { base: 'DZ', letters: /[\u01F1\u01C4]/g }, { base: 'Dz', letters: /[\u01F2\u01C5]/g }, { base: 'E', letters: /[\u0045\u24BA\uFF25\u00C8\u00C9\u00CA\u1EC0\u1EBE\u1EC4\u1EC2\u1EBC\u0112\u1E14\u1E16\u0114\u0116\u00CB\u1EBA\u011A\u0204\u0206\u1EB8\u1EC6\u0228\u1E1C\u0118\u1E18\u1E1A\u0190\u018E]/g }, { base: 'F', letters: /[\u0046\u24BB\uFF26\u1E1E\u0191\uA77B]/g }, { base: 'G', letters: /[\u0047\u24BC\uFF27\u01F4\u011C\u1E20\u011E\u0120\u01E6\u0122\u01E4\u0193\uA7A0\uA77D\uA77E]/g }, { base: 'H', letters: /[\u0048\u24BD\uFF28\u0124\u1E22\u1E26\u021E\u1E24\u1E28\u1E2A\u0126\u2C67\u2C75\uA78D]/g }, { base: 'I', letters: /[\u0049\u24BE\uFF29\u00CC\u00CD\u00CE\u0128\u012A\u012C\u0130\u00CF\u1E2E\u1EC8\u01CF\u0208\u020A\u1ECA\u012E\u1E2C\u0197]/g }, { base: 'J', letters: /[\u004A\u24BF\uFF2A\u0134\u0248]/g }, { base: 'K', letters: /[\u004B\u24C0\uFF2B\u1E30\u01E8\u1E32\u0136\u1E34\u0198\u2C69\uA740\uA742\uA744\uA7A2]/g }, { base: 'L', letters: /[\u004C\u24C1\uFF2C\u013F\u0139\u013D\u1E36\u1E38\u013B\u1E3C\u1E3A\u0141\u023D\u2C62\u2C60\uA748\uA746\uA780]/g }, { base: 'LJ', letters: /[\u01C7]/g }, { base: 'Lj', letters: /[\u01C8]/g }, { base: 'M', letters: /[\u004D\u24C2\uFF2D\u1E3E\u1E40\u1E42\u2C6E\u019C]/g }, { base: 'N', letters: /[\u004E\u24C3\uFF2E\u01F8\u0143\u00D1\u1E44\u0147\u1E46\u0145\u1E4A\u1E48\u0220\u019D\uA790\uA7A4]/g }, { base: 'NJ', letters: /[\u01CA]/g }, { base: 'Nj', letters: /[\u01CB]/g }, { base: 'O', letters: /[\u004F\u24C4\uFF2F\u00D2\u00D3\u00D4\u1ED2\u1ED0\u1ED6\u1ED4\u00D5\u1E4C\u022C\u1E4E\u014C\u1E50\u1E52\u014E\u022E\u0230\u00D6\u022A\u1ECE\u0150\u01D1\u020C\u020E\u01A0\u1EDC\u1EDA\u1EE0\u1EDE\u1EE2\u1ECC\u1ED8\u01EA\u01EC\u00D8\u01FE\u0186\u019F\uA74A\uA74C]/g }, { base: 'OI', letters: /[\u01A2]/g }, { base: 'OO', letters: /[\uA74E]/g }, { base: 'OU', letters: /[\u0222]/g }, { base: 'P', letters: /[\u0050\u24C5\uFF30\u1E54\u1E56\u01A4\u2C63\uA750\uA752\uA754]/g }, { base: 'Q', letters: /[\u0051\u24C6\uFF31\uA756\uA758\u024A]/g }, { base: 'R', letters: /[\u0052\u24C7\uFF32\u0154\u1E58\u0158\u0210\u0212\u1E5A\u1E5C\u0156\u1E5E\u024C\u2C64\uA75A\uA7A6\uA782]/g }, { base: 'S', letters: /[\u0053\u24C8\uFF33\u1E9E\u015A\u1E64\u015C\u1E60\u0160\u1E66\u1E62\u1E68\u0218\u015E\u2C7E\uA7A8\uA784]/g }, { base: 'T', letters: /[\u0054\u24C9\uFF34\u1E6A\u0164\u1E6C\u021A\u0162\u1E70\u1E6E\u0166\u01AC\u01AE\u023E\uA786]/g }, { base: 'TZ', letters: /[\uA728]/g }, { base: 'U', letters: /[\u0055\u24CA\uFF35\u00D9\u00DA\u00DB\u0168\u1E78\u016A\u1E7A\u016C\u00DC\u01DB\u01D7\u01D5\u01D9\u1EE6\u016E\u0170\u01D3\u0214\u0216\u01AF\u1EEA\u1EE8\u1EEE\u1EEC\u1EF0\u1EE4\u1E72\u0172\u1E76\u1E74\u0244]/g }, { base: 'V', letters: /[\u0056\u24CB\uFF36\u1E7C\u1E7E\u01B2\uA75E\u0245]/g }, { base: 'VY', letters: /[\uA760]/g }, { base: 'W', letters: /[\u0057\u24CC\uFF37\u1E80\u1E82\u0174\u1E86\u1E84\u1E88\u2C72]/g }, { base: 'X', letters: /[\u0058\u24CD\uFF38\u1E8A\u1E8C]/g }, { base: 'Y', letters: /[\u0059\u24CE\uFF39\u1EF2\u00DD\u0176\u1EF8\u0232\u1E8E\u0178\u1EF6\u1EF4\u01B3\u024E\u1EFE]/g }, { base: 'Z', letters: /[\u005A\u24CF\uFF3A\u0179\u1E90\u017B\u017D\u1E92\u1E94\u01B5\u0224\u2C7F\u2C6B\uA762]/g }, { base: 'a', letters: /[\u0061\u24D0\uFF41\u1E9A\u00E0\u00E1\u00E2\u1EA7\u1EA5\u1EAB\u1EA9\u00E3\u0101\u0103\u1EB1\u1EAF\u1EB5\u1EB3\u0227\u01E1\u00E4\u01DF\u1EA3\u00E5\u01FB\u01CE\u0201\u0203\u1EA1\u1EAD\u1EB7\u1E01\u0105\u2C65\u0250]/g }, { base: 'aa', letters: /[\uA733]/g }, { base: 'ae', letters: /[\u00E6\u01FD\u01E3]/g }, { base: 'ao', letters: /[\uA735]/g }, { base: 'au', letters: /[\uA737]/g }, { base: 'av', letters: /[\uA739\uA73B]/g }, { base: 'ay', letters: /[\uA73D]/g }, { base: 'b', letters: /[\u0062\u24D1\uFF42\u1E03\u1E05\u1E07\u0180\u0183\u0253]/g }, { base: 'c', letters: /[\u0063\u24D2\uFF43\u0107\u0109\u010B\u010D\u00E7\u1E09\u0188\u023C\uA73F\u2184]/g }, { base: 'd', letters: /[\u0064\u24D3\uFF44\u1E0B\u010F\u1E0D\u1E11\u1E13\u1E0F\u0111\u018C\u0256\u0257\uA77A]/g }, { base: 'dz', letters: /[\u01F3\u01C6]/g }, { base: 'e', letters: /[\u0065\u24D4\uFF45\u00E8\u00E9\u00EA\u1EC1\u1EBF\u1EC5\u1EC3\u1EBD\u0113\u1E15\u1E17\u0115\u0117\u00EB\u1EBB\u011B\u0205\u0207\u1EB9\u1EC7\u0229\u1E1D\u0119\u1E19\u1E1B\u0247\u025B\u01DD]/g }, { base: 'f', letters: /[\u0066\u24D5\uFF46\u1E1F\u0192\uA77C]/g }, { base: 'g', letters: /[\u0067\u24D6\uFF47\u01F5\u011D\u1E21\u011F\u0121\u01E7\u0123\u01E5\u0260\uA7A1\u1D79\uA77F]/g }, { base: 'h', letters: /[\u0068\u24D7\uFF48\u0125\u1E23\u1E27\u021F\u1E25\u1E29\u1E2B\u1E96\u0127\u2C68\u2C76\u0265]/g }, { base: 'hv', letters: /[\u0195]/g }, { base: 'i', letters: /[\u0069\u24D8\uFF49\u00EC\u00ED\u00EE\u0129\u012B\u012D\u00EF\u1E2F\u1EC9\u01D0\u0209\u020B\u1ECB\u012F\u1E2D\u0268\u0131]/g }, { base: 'j', letters: /[\u006A\u24D9\uFF4A\u0135\u01F0\u0249]/g }, { base: 'k', letters: /[\u006B\u24DA\uFF4B\u1E31\u01E9\u1E33\u0137\u1E35\u0199\u2C6A\uA741\uA743\uA745\uA7A3]/g }, { base: 'l', letters: /[\u006C\u24DB\uFF4C\u0140\u013A\u013E\u1E37\u1E39\u013C\u1E3D\u1E3B\u017F\u0142\u019A\u026B\u2C61\uA749\uA781\uA747]/g }, { base: 'lj', letters: /[\u01C9]/g }, { base: 'm', letters: /[\u006D\u24DC\uFF4D\u1E3F\u1E41\u1E43\u0271\u026F]/g }, { base: 'n', letters: /[\u006E\u24DD\uFF4E\u01F9\u0144\u00F1\u1E45\u0148\u1E47\u0146\u1E4B\u1E49\u019E\u0272\u0149\uA791\uA7A5]/g }, { base: 'nj', letters: /[\u01CC]/g }, { base: 'o', letters: /[\u006F\u24DE\uFF4F\u00F2\u00F3\u00F4\u1ED3\u1ED1\u1ED7\u1ED5\u00F5\u1E4D\u022D\u1E4F\u014D\u1E51\u1E53\u014F\u022F\u0231\u00F6\u022B\u1ECF\u0151\u01D2\u020D\u020F\u01A1\u1EDD\u1EDB\u1EE1\u1EDF\u1EE3\u1ECD\u1ED9\u01EB\u01ED\u00F8\u01FF\u0254\uA74B\uA74D\u0275]/g }, { base: 'oi', letters: /[\u01A3]/g }, { base: 'ou', letters: /[\u0223]/g }, { base: 'oo', letters: /[\uA74F]/g }, { base: 'p', letters: /[\u0070\u24DF\uFF50\u1E55\u1E57\u01A5\u1D7D\uA751\uA753\uA755]/g }, { base: 'q', letters: /[\u0071\u24E0\uFF51\u024B\uA757\uA759]/g }, { base: 'r', letters: /[\u0072\u24E1\uFF52\u0155\u1E59\u0159\u0211\u0213\u1E5B\u1E5D\u0157\u1E5F\u024D\u027D\uA75B\uA7A7\uA783]/g }, { base: 's', letters: /[\u0073\u24E2\uFF53\u00DF\u015B\u1E65\u015D\u1E61\u0161\u1E67\u1E63\u1E69\u0219\u015F\u023F\uA7A9\uA785\u1E9B]/g }, { base: 't', letters: /[\u0074\u24E3\uFF54\u1E6B\u1E97\u0165\u1E6D\u021B\u0163\u1E71\u1E6F\u0167\u01AD\u0288\u2C66\uA787]/g }, { base: 'tz', letters: /[\uA729]/g }, { base: 'u', letters: /[\u0075\u24E4\uFF55\u00F9\u00FA\u00FB\u0169\u1E79\u016B\u1E7B\u016D\u00FC\u01DC\u01D8\u01D6\u01DA\u1EE7\u016F\u0171\u01D4\u0215\u0217\u01B0\u1EEB\u1EE9\u1EEF\u1EED\u1EF1\u1EE5\u1E73\u0173\u1E77\u1E75\u0289]/g }, { base: 'v', letters: /[\u0076\u24E5\uFF56\u1E7D\u1E7F\u028B\uA75F\u028C]/g }, { base: 'vy', letters: /[\uA761]/g }, { base: 'w', letters: /[\u0077\u24E6\uFF57\u1E81\u1E83\u0175\u1E87\u1E85\u1E98\u1E89\u2C73]/g }, { base: 'x', letters: /[\u0078\u24E7\uFF58\u1E8B\u1E8D]/g }, { base: 'y', letters: /[\u0079\u24E8\uFF59\u1EF3\u00FD\u0177\u1EF9\u0233\u1E8F\u00FF\u1EF7\u1E99\u1EF5\u01B4\u024F\u1EFF]/g }, { base: 'z', letters: /[\u007A\u24E9\uFF5A\u017A\u1E91\u017C\u017E\u1E93\u1E95\u01B6\u0225\u0240\u2C6C\uA763]/g }];

var stripDiacritics = function stripDiacritics(str) {
	for (var i = 0; i < diacritics.length; i++) {
		str = str.replace(diacritics[i].letters, diacritics[i].base);
	}
	return str;
};

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};

var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var defineProperty = function (obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var inherits = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};

var objectWithoutProperties = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

var possibleConstructorReturn = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};

var slicedToArray = function () {
  function sliceIterator(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;

    try {
      for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);

        if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;
      _e = err;
    } finally {
      try {
        if (!_n && _i["return"]) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }

    return _arr;
  }

  return function (arr, i) {
    if (Array.isArray(arr)) {
      return arr;
    } else if (Symbol.iterator in Object(arr)) {
      return sliceIterator(arr, i);
    } else {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }
  };
}();

var toConsumableArray = function (arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) arr2[i] = arr[i];

    return arr2;
  } else {
    return Array.from(arr);
  }
};

var trimString = function trimString(str) {
  return str.replace(/^\s+|\s+$/g, '');
};
var defaulStringify = function defaulStringify(option) {
  return option.label + ' ' + option.value;
};

var createFilter = function createFilter(config) {
  return function (option, rawInput) {
    var _ignoreCase$ignoreAcc = _extends({
      ignoreCase: true,
      ignoreAccents: true,
      stringify: defaulStringify,
      trim: true,
      matchFrom: 'any'
    }, config),
        ignoreCase = _ignoreCase$ignoreAcc.ignoreCase,
        ignoreAccents = _ignoreCase$ignoreAcc.ignoreAccents,
        stringify = _ignoreCase$ignoreAcc.stringify,
        trim = _ignoreCase$ignoreAcc.trim,
        matchFrom = _ignoreCase$ignoreAcc.matchFrom;

    var input = trim ? trimString(rawInput) : rawInput;
    var candidate = trim ? trimString(stringify(option)) : stringify(option);
    if (ignoreCase) {
      input = input.toLowerCase();
      candidate = candidate.toLowerCase();
    }
    if (ignoreAccents) {
      input = stripDiacritics(input);
      candidate = stripDiacritics(candidate);
    }
    return matchFrom === 'start' ? candidate.substr(0, input.length) === input : candidate.indexOf(input) > -1;
  };
};

var DummyInput = function (_Component) {
  inherits(DummyInput, _Component);

  function DummyInput() {
    classCallCheck(this, DummyInput);
    return possibleConstructorReturn(this, (DummyInput.__proto__ || Object.getPrototypeOf(DummyInput)).apply(this, arguments));
  }

  createClass(DummyInput, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          inProp = _props.in,
          out = _props.out,
          onExited = _props.onExited,
          appear = _props.appear,
          enter = _props.enter,
          exit = _props.exit,
          innerRef = _props.innerRef,
          props = objectWithoutProperties(_props, ['in', 'out', 'onExited', 'appear', 'enter', 'exit', 'innerRef']);

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input', _extends({
        ref: innerRef
      }, props, {
        className: Object(__WEBPACK_IMPORTED_MODULE_0_emotion__["css"])({
          // get rid of any default styles
          background: 0,
          border: 0,
          fontSize: 'inherit',
          outline: 0,
          padding: 0,

          // important! without `width` browsers won't allow focus
          width: 1,

          // remove cursor on desktop
          color: 'transparent',

          // remove cursor on mobile whilst maintaining "scroll into view" behaviour
          left: -100,
          opacity: 0,
          position: 'relative',
          transform: 'scale(0)'
        })
      }));
    }
  }]);
  return DummyInput;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);

var NodeResolver = function (_Component) {
  inherits(NodeResolver, _Component);

  function NodeResolver() {
    classCallCheck(this, NodeResolver);
    return possibleConstructorReturn(this, (NodeResolver.__proto__ || Object.getPrototypeOf(NodeResolver)).apply(this, arguments));
  }

  createClass(NodeResolver, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.props.innerRef(Object(__WEBPACK_IMPORTED_MODULE_2_react_dom__["findDOMNode"])(this));
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.props.innerRef(null);
    }
  }, {
    key: 'render',
    value: function render() {
      return this.props.children;
    }
  }]);
  return NodeResolver;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);

var STYLE_KEYS = ['boxSizing', 'height', 'overflow', 'paddingRight', 'position'];

var LOCK_STYLES = {
  boxSizing: 'border-box', // account for possible declaration `width: 100%;` on body
  overflow: 'hidden',
  position: 'relative',
  height: '100%'
};

function preventTouchMove(e) {
  e.preventDefault();
}

function allowTouchMove(e) {
  e.stopPropagation();
}

function preventInertiaScroll() {
  var top = this.scrollTop;
  var totalScroll = this.scrollHeight;
  var currentScroll = top + this.offsetHeight;

  if (top === 0) {
    this.scrollTop = 1;
  } else if (currentScroll === totalScroll) {
    this.scrollTop = top - 1;
  }
}

// `ontouchstart` check works on most browsers
// `maxTouchPoints` works on IE10/11 and Surface
function isTouchDevice() {
  return 'ontouchstart' in window || navigator.maxTouchPoints;
}

var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

var activeScrollLocks = 0;

var ScrollLock = function (_Component) {
  inherits(ScrollLock, _Component);

  function ScrollLock() {
    var _ref;

    var _temp, _this, _ret;

    classCallCheck(this, ScrollLock);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn(this, (_ref = ScrollLock.__proto__ || Object.getPrototypeOf(ScrollLock)).call.apply(_ref, [this].concat(args))), _this), _this.originalStyles = {}, _this.listenerOptions = {
      capture: false,
      passive: false
    }, _temp), possibleConstructorReturn(_this, _ret);
  }

  createClass(ScrollLock, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      if (!canUseDOM) return;

      var _props = this.props,
          accountForScrollbars = _props.accountForScrollbars,
          touchScrollTarget = _props.touchScrollTarget;

      var target = document.body;
      var targetStyle = target && target.style;

      if (accountForScrollbars) {
        // store any styles already applied to the body
        STYLE_KEYS.forEach(function (key) {
          var val = targetStyle && targetStyle[key];
          _this2.originalStyles[key] = val;
        });
      }

      // apply the lock styles and padding if this is the first scroll lock
      if (accountForScrollbars && activeScrollLocks < 1) {
        var currentPadding = parseInt(this.originalStyles.paddingRight, 10) || 0;
        var clientWidth = document.body ? document.body.clientWidth : 0;
        var adjustedPadding = window.innerWidth - clientWidth + currentPadding || 0;

        Object.keys(LOCK_STYLES).forEach(function (key) {
          var val = LOCK_STYLES[key];
          if (targetStyle) {
            targetStyle[key] = val;
          }
        });

        if (targetStyle) {
          targetStyle.paddingRight = adjustedPadding + 'px';
        }
      }

      // account for touch devices
      if (target && isTouchDevice()) {
        // Mobile Safari ignores { overflow: hidden } declaration on the body.
        target.addEventListener('touchmove', preventTouchMove, this.listenerOptions);

        // Allow scroll on provided target
        if (touchScrollTarget) {
          touchScrollTarget.addEventListener('touchstart', preventInertiaScroll, this.listenerOptions);
          touchScrollTarget.addEventListener('touchmove', allowTouchMove, this.listenerOptions);
        }
      }

      // increment active scroll locks
      activeScrollLocks += 1;
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      var _this3 = this;

      if (!canUseDOM) return;

      var _props2 = this.props,
          accountForScrollbars = _props2.accountForScrollbars,
          touchScrollTarget = _props2.touchScrollTarget;

      var target = document.body;
      var targetStyle = target && target.style;

      // safely decrement active scroll locks
      activeScrollLocks = Math.max(activeScrollLocks - 1, 0);

      // reapply original body styles, if any
      if (accountForScrollbars && activeScrollLocks < 1) {
        STYLE_KEYS.forEach(function (key) {
          var val = _this3.originalStyles[key];
          if (targetStyle) {
            targetStyle[key] = val;
          }
        });
      }

      // remove touch listeners
      if (target && isTouchDevice()) {
        target.removeEventListener('touchmove', preventTouchMove, this.listenerOptions);

        if (touchScrollTarget) {
          touchScrollTarget.removeEventListener('touchstart', preventInertiaScroll, this.listenerOptions);
          touchScrollTarget.removeEventListener('touchmove', allowTouchMove, this.listenerOptions);
        }
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return null;
    }
  }]);
  return ScrollLock;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);

ScrollLock.defaultProps = {
  accountForScrollbars: true
};

var createPrimitive = function createPrimitive(Tag) {
  return function (_ref) {
    var css$$1 = _ref.css,
        innerRef = _ref.innerRef,
        props = objectWithoutProperties(_ref, ['css', 'innerRef']);
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Tag, _extends({ ref: innerRef, className: Object(__WEBPACK_IMPORTED_MODULE_0_emotion__["css"])(css$$1)
    }, props));
  };
};
var Div = createPrimitive('div');

// Assistive text to describe visual elements. Hidden for sighted users.
var A11yText = function A11yText(props) {
  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span', _extends({
    className: Object(__WEBPACK_IMPORTED_MODULE_0_emotion__["css"])({
      zIndex: 9999,
      border: 0,
      clip: 'rect(1px, 1px, 1px, 1px)',
      height: 1,
      width: 1,
      position: 'absolute',
      overflow: 'hidden',
      padding: 0,
      whiteSpace: 'nowrap',
      backgroundColor: 'red',
      color: 'blue'
    })
  }, props));
};

// NOTE:
// We shouldn't need this after updating to React v16.3.0, which introduces:
// - createRef() https://reactjs.org/docs/react-api.html#reactcreateref
// - forwardRef() https://reactjs.org/docs/react-api.html#reactforwardref

var ScrollBlock = function (_PureComponent) {
  inherits(ScrollBlock, _PureComponent);

  function ScrollBlock() {
    var _ref;

    var _temp, _this, _ret;

    classCallCheck(this, ScrollBlock);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn(this, (_ref = ScrollBlock.__proto__ || Object.getPrototypeOf(ScrollBlock)).call.apply(_ref, [this].concat(args))), _this), _this.state = { touchScrollTarget: null }, _this.getScrollTarget = function (ref) {
      if (ref === _this.state.touchScrollTarget) return;
      _this.setState({ touchScrollTarget: ref });
    }, _this.blurSelectInput = function () {
      if (document.activeElement) {
        document.activeElement.blur();
      }
    }, _temp), possibleConstructorReturn(_this, _ret);
  }

  // must be in state to trigger a re-render, only runs once per instance


  // this will close the menu when a user clicks outside


  createClass(ScrollBlock, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          children = _props.children,
          isEnabled = _props.isEnabled;
      var touchScrollTarget = this.state.touchScrollTarget;

      // bail early if not enabled

      if (!isEnabled) return children;

      /*
       * Div
       * ------------------------------
       * blocks scrolling on non-body elements behind the menu
        * NodeResolver
       * ------------------------------
       * we need a reference to the scrollable element to "unlock" scroll on
       * mobile devices
        * ScrollLock
       * ------------------------------
       * actually does the scroll locking
       */
      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Div, {
          onClick: this.blurSelectInput,
          className: Object(__WEBPACK_IMPORTED_MODULE_0_emotion__["css"])({ position: 'fixed', left: 0, bottom: 0, right: 0, top: 0 })
        }),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          NodeResolver,
          { innerRef: this.getScrollTarget },
          children
        ),
        touchScrollTarget ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(ScrollLock, { touchScrollTarget: touchScrollTarget }) : null
      );
    }
  }]);
  return ScrollBlock;
}(__WEBPACK_IMPORTED_MODULE_1_react__["PureComponent"]);

var ScrollCaptor = function (_Component) {
  inherits(ScrollCaptor, _Component);

  function ScrollCaptor() {
    var _ref;

    var _temp, _this, _ret;

    classCallCheck(this, ScrollCaptor);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn(this, (_ref = ScrollCaptor.__proto__ || Object.getPrototypeOf(ScrollCaptor)).call.apply(_ref, [this].concat(args))), _this), _this.isBottom = false, _this.isTop = false, _this.cancelScroll = function (event) {
      event.preventDefault();
      event.stopPropagation();
    }, _this.handleEventDelta = function (event, delta) {
      var _this$props = _this.props,
          onBottomArrive = _this$props.onBottomArrive,
          onBottomLeave = _this$props.onBottomLeave,
          onTopArrive = _this$props.onTopArrive,
          onTopLeave = _this$props.onTopLeave;
      var _this$scrollTarget = _this.scrollTarget,
          scrollTop = _this$scrollTarget.scrollTop,
          scrollHeight = _this$scrollTarget.scrollHeight,
          clientHeight = _this$scrollTarget.clientHeight;

      var target = _this.scrollTarget;
      var isDeltaPositive = delta > 0;
      var availableScroll = scrollHeight - clientHeight - scrollTop;
      var shouldCancelScroll = false;

      // reset bottom/top flags
      if (availableScroll > delta && _this.isBottom) {
        if (onBottomLeave) onBottomLeave(event);
        _this.isBottom = false;
      }
      if (isDeltaPositive && _this.isTop) {
        if (onTopLeave) onTopLeave(event);
        _this.isTop = false;
      }

      // bottom limit
      if (isDeltaPositive && delta > availableScroll) {
        if (onBottomArrive && !_this.isBottom) {
          onBottomArrive(event);
        }
        target.scrollTop = scrollHeight;
        shouldCancelScroll = true;
        _this.isBottom = true;

        // top limit
      } else if (!isDeltaPositive && -delta > scrollTop) {
        if (onTopArrive && !_this.isTop) {
          onTopArrive(event);
        }
        target.scrollTop = 0;
        shouldCancelScroll = true;
        _this.isTop = true;
      }

      // cancel scroll
      if (shouldCancelScroll) {
        _this.cancelScroll(event);
      }
    }, _this.onWheel = function (event) {
      _this.handleEventDelta(event, event.deltaY);
    }, _this.onTouchStart = function (event) {
      // set touch start so we can calculate touchmove delta
      _this.touchStart = event.changedTouches[0].clientY;
    }, _this.onTouchMove = function (event) {
      var deltaY = _this.touchStart - event.changedTouches[0].clientY;
      _this.handleEventDelta(event, deltaY);
    }, _this.getScrollTarget = function (ref) {
      _this.scrollTarget = ref;
    }, _temp), possibleConstructorReturn(_this, _ret);
  }

  createClass(ScrollCaptor, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.startListening(this.scrollTarget);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.stopListening(this.scrollTarget);
    }
  }, {
    key: 'startListening',
    value: function startListening(el) {
      // bail early if no scroll available
      if (el.scrollHeight <= el.clientHeight) return;

      // all the if statements are to appease Flow 😢
      if (typeof el.addEventListener === 'function') {
        el.addEventListener('wheel', this.onWheel, false);
      }
      if (typeof el.addEventListener === 'function') {
        el.addEventListener('touchstart', this.onTouchStart, false);
      }
      if (typeof el.addEventListener === 'function') {
        el.addEventListener('touchmove', this.onTouchMove, false);
      }
    }
  }, {
    key: 'stopListening',
    value: function stopListening(el) {
      // bail early if no scroll available
      if (el.scrollHeight <= el.clientHeight) return;

      // all the if statements are to appease Flow 😢
      if (typeof el.removeEventListener === 'function') {
        el.removeEventListener('wheel', this.onWheel, false);
      }
      if (typeof el.removeEventListener === 'function') {
        el.removeEventListener('touchstart', this.onTouchStart, false);
      }
      if (typeof el.removeEventListener === 'function') {
        el.removeEventListener('touchmove', this.onTouchMove, false);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        NodeResolver,
        { innerRef: this.getScrollTarget },
        this.props.children
      );
    }
  }]);
  return ScrollCaptor;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);

var ScrollCaptorSwitch = function (_Component2) {
  inherits(ScrollCaptorSwitch, _Component2);

  function ScrollCaptorSwitch() {
    classCallCheck(this, ScrollCaptorSwitch);
    return possibleConstructorReturn(this, (ScrollCaptorSwitch.__proto__ || Object.getPrototypeOf(ScrollCaptorSwitch)).apply(this, arguments));
  }

  createClass(ScrollCaptorSwitch, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          isEnabled = _props.isEnabled,
          props = objectWithoutProperties(_props, ['isEnabled']);

      return isEnabled ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(ScrollCaptor, props) : this.props.children;
    }
  }]);
  return ScrollCaptorSwitch;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);

ScrollCaptorSwitch.defaultProps = { isEnabled: true };

var instructionsAriaMessage = function instructionsAriaMessage(event) {
  var context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var isSearchable = context.isSearchable,
      isMulti = context.isMulti,
      label = context.label;

  switch (event) {
    case 'menu':
      return 'Use Up and Down to choose options, press Backspace to select the currently focused option, press Escape to exit the menu, press Tab to select the option and exit the menu.';
    case 'input':
      return (label ? label : 'Select') + ' is focused ' + (isSearchable ? ',type to refine list' : '') + ', press Down to open the menu, ' + (isMulti ? ' press left to focus selected values' : '');
    case 'value':
      return 'Use left and right to toggle between focused values, press Enter to remove the currently focused value';
  }
};

var valueEventAriaMessage = function valueEventAriaMessage(event, context) {
  var value = context.value;

  if (!value) return;
  switch (event) {
    case 'deselect-option':
    case 'pop-value':
    case 'remove-value':
      return 'option ' + value + ', deselected.';
    case 'select-option':
      return 'option ' + value + ', selected.';
  }
};

var valueFocusAriaMessage = function valueFocusAriaMessage(_ref) {
  var focusedValue = _ref.focusedValue,
      getOptionLabel = _ref.getOptionLabel,
      selectValue = _ref.selectValue;
  return 'value ' + getOptionLabel(focusedValue) + ' focused, ' + (selectValue.indexOf(focusedValue) + 1) + ' of ' + selectValue.length + '.';
};
var optionFocusAriaMessage = function optionFocusAriaMessage(_ref2) {
  var focusedOption = _ref2.focusedOption,
      getOptionLabel = _ref2.getOptionLabel,
      options = _ref2.options;
  return 'option ' + getOptionLabel(focusedOption) + ' focused, ' + (options.indexOf(focusedOption) + 1) + ' of ' + options.length + '.';
};
var resultsAriaMessage = function resultsAriaMessage(_ref3) {
  var inputValue = _ref3.inputValue,
      screenReaderMessage = _ref3.screenReaderMessage;
  return '' + screenReaderMessage + (inputValue ? ' for search term ' + inputValue : '') + '.';
};

// ==============================
// NO OP
// ==============================

var noop = function noop() {};

// ==============================
// Class Name Prefixer
// ==============================

/**
 String representation of component state for styling with class names.

 Expects an array of strings OR a string/object pair:
 - className(['comp', 'comp-arg', 'comp-arg-2'])
   @returns 'react-select__comp react-select__comp-arg react-select__comp-arg-2'
 - className('comp', { some: true, state: false })
   @returns 'react-select__comp react-select__comp--some'
*/
function applyPrefixToName(prefix, name) {
  if (!name) {
    return prefix;
  } else if (name[0] === '-') {
    return prefix + name;
  } else {
    return prefix + '__' + name;
  }
}

function classNames(prefix, cssKey, state, className) {
  var arr = [cssKey, className];
  if (state && prefix) {
    for (var key in state) {
      if (state.hasOwnProperty(key) && state[key]) {
        arr.push('' + applyPrefixToName(prefix, key));
      }
    }
  }

  return arr.filter(function (i) {
    return i;
  }).map(function (i) {
    return String(i).trim();
  }).join(' ');
}
// ==============================
// Clean Value
// ==============================

var cleanValue = function cleanValue(value) {
  if (Array.isArray(value)) return value.filter(Boolean);
  if ((typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object' && value !== null) return [value];
  return [];
};

// ==============================
// Handle Input Change
// ==============================

function handleInputChange(inputValue, actionMeta, onInputChange) {
  if (onInputChange) {
    var newValue = onInputChange(inputValue, actionMeta);
    if (typeof newValue === 'string') return newValue;
  }
  return inputValue;
}

// ==============================
// Scroll Helpers
// ==============================

function isDocumentElement(el) {
  return [document.documentElement, document.body, window].indexOf(el) > -1;
}

// Normalized scrollTo & scrollTop
// ------------------------------

function getScrollTop(el) {
  if (isDocumentElement(el)) {
    return window.pageYOffset;
  }
  return el.scrollTop;
}

function scrollTo(el, top) {
  // with a scroll distance, we perform scroll on the element
  if (isDocumentElement(el)) {
    window.scrollTo(0, top);
    return;
  }

  el.scrollTop = top;
}

// Get Scroll Parent
// ------------------------------

function getScrollParent(element) {
  var style = getComputedStyle(element);
  var excludeStaticParent = style.position === 'absolute';
  var overflowRx = /(auto|scroll)/;
  var docEl = document.documentElement; // suck it, flow...

  if (style.position === 'fixed') return docEl;

  for (var parent = element; parent = parent.parentElement;) {
    style = getComputedStyle(parent);
    if (excludeStaticParent && style.position === 'static') {
      continue;
    }
    if (overflowRx.test(style.overflow + style.overflowY + style.overflowX)) {
      return parent;
    }
  }

  return docEl;
}

// Animated Scroll To
// ------------------------------

/**
  @param t: time (elapsed)
  @param b: initial value
  @param c: amount of change
  @param d: duration
*/
function easeOutCubic(t, b, c, d) {
  return c * ((t = t / d - 1) * t * t + 1) + b;
}

function animatedScrollTo(element, to) {
  var duration = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 200;
  var callback = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : noop;

  var start = getScrollTop(element);
  var change = to - start;
  var increment = 10;
  var currentTime = 0;

  function animateScroll() {
    currentTime += increment;
    var val = easeOutCubic(currentTime, start, change, duration);
    scrollTo(element, val);
    if (currentTime < duration) {
      __WEBPACK_IMPORTED_MODULE_3_raf___default()(animateScroll);
    } else {
      callback(element);
    }
  }
  animateScroll();
}

// Scroll Into View
// ------------------------------

function scrollIntoView(menuEl, focusedEl) {
  var menuRect = menuEl.getBoundingClientRect();
  var focusedRect = focusedEl.getBoundingClientRect();
  var overScroll = focusedEl.offsetHeight / 3;

  if (focusedRect.bottom + overScroll > menuRect.bottom) {
    scrollTo(menuEl, Math.min(focusedEl.offsetTop + focusedEl.clientHeight - menuEl.offsetHeight + overScroll, menuEl.scrollHeight));
  } else if (focusedRect.top - overScroll < menuRect.top) {
    scrollTo(menuEl, Math.max(focusedEl.offsetTop - overScroll, 0));
  }
}

// ==============================
// Get bounding client object
// ==============================

// cannot get keys using array notation with DOMRect
function getBoundingClientObj(element) {
  var rect = element.getBoundingClientRect();
  return {
    bottom: rect.bottom,
    height: rect.height,
    left: rect.left,
    right: rect.right,
    top: rect.top,
    width: rect.width
  };
}

// ==============================
// Touch Capability Detector
// ==============================

function isTouchCapable() {
  try {
    document.createEvent('TouchEvent');
    return true;
  } catch (e) {
    return false;
  }
}

// ==============================
// Mobile Device Detector
// ==============================

function isMobileDevice() {
  try {
    return (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)
    );
  } catch (e) {
    return false;
  }
}

var formatGroupLabel = function formatGroupLabel(group) {
  return group.label;
};

var getOptionLabel = function getOptionLabel(option) {
  return option.label;
};

var getOptionValue = function getOptionValue(option) {
  return option.value;
};

var isOptionDisabled = function isOptionDisabled(option) {
  return !!option.isDisabled;
};

var borderRadius = 4;

var colors = {
  text: '#222',
  textLight: '#444',
  primary: '#2684FF',
  primary75: '#4C9AFF',
  primary50: '#B2D4FF',
  primary25: '#DEEBFF',
  danger: '#DE350B',
  dangerLight: '#FFBDAD',

  neutral0: 'hsl(0, 0%, 100%)',
  neutral1: 'hsl(0, 0%, 99%)',
  neutral2: 'hsl(0, 0%, 98%)',
  neutral3: 'hsl(0, 0%, 97%)',
  neutral4: 'hsl(0, 0%, 96%)',
  neutral5: 'hsl(0, 0%, 95%)',
  neutral10: 'hsl(0, 0%, 90%)',
  neutral20: 'hsl(0, 0%, 80%)',
  neutral30: 'hsl(0, 0%, 70%)',
  neutral40: 'hsl(0, 0%, 60%)',
  neutral50: 'hsl(0, 0%, 50%)',
  neutral60: 'hsl(0, 0%, 40%)',
  neutral70: 'hsl(0, 0%, 30%)',
  neutral80: 'hsl(0, 0%, 20%)',
  neutral90: 'hsl(0, 0%, 10%)',
  neutral100: 'hsl(0, 0%, 0%)',

  neutral1a: 'hsla(0, 0%, 0%, 0.01)',
  neutral2a: 'hsla(0, 0%, 0%, 0.02)',
  neutral3a: 'hsla(0, 0%, 0%, 0.03)',
  neutral4a: 'hsla(0, 0%, 0%, 0.04)',
  neutral5a: 'hsla(0, 0%, 0%, 0.05)',
  neutral10a: 'hsla(0, 0%, 0%, 0.1)',
  neutral20a: 'hsla(0, 0%, 0%, 0.2)',
  neutral30a: 'hsla(0, 0%, 0%, 0.3)',
  neutral40a: 'hsla(0, 0%, 0%, 0.4)',
  neutral50a: 'hsla(0, 0%, 0%, 0.5)',
  neutral60a: 'hsla(0, 0%, 0%, 0.6)',
  neutral70a: 'hsla(0, 0%, 0%, 0.7)',
  neutral80a: 'hsla(0, 0%, 0%, 0.8)',
  neutral90a: 'hsla(0, 0%, 0%, 0.9)'
};

var baseUnit = 4;

var spacing = {
  /* Used to calculate consistent margin/padding on elements */
  baseUnit: baseUnit,
  /* The minimum height of the control */
  controlHeight: 38,
  /* The amount of space between the control and menu */
  menuGutter: baseUnit * 2
};

// ==============================
// Root Container
// ==============================

var containerCSS = function containerCSS(_ref) {
  var isDisabled = _ref.isDisabled,
      isRtl = _ref.isRtl;
  return {
    direction: isRtl ? 'rtl' : null,
    pointerEvents: isDisabled ? 'none' : null, // cancel mouse events when disabled
    position: 'relative'
  };
};
var SelectContainer = function SelectContainer(props) {
  var children = props.children,
      className = props.className,
      cx = props.cx,
      getStyles = props.getStyles,
      innerProps = props.innerProps,
      isDisabled = props.isDisabled,
      isRtl = props.isRtl;

  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
    'div',
    _extends({
      className: cx( /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0_emotion__["css"])(getStyles('container', props)), {
        '--is-disabled': isDisabled,
        '--is-rtl': isRtl
      }, className)
    }, innerProps),
    children
  );
};

// ==============================
// Value Container
// ==============================

var valueContainerCSS = function valueContainerCSS() {
  return {
    alignItems: 'center',
    display: 'flex',
    flex: 1,
    flexWrap: 'wrap',
    padding: spacing.baseUnit / 2 + 'px ' + spacing.baseUnit * 2 + 'px',
    WebkitOverflowScrolling: 'touch',
    position: 'relative'
  };
};
var ValueContainer = function (_Component) {
  inherits(ValueContainer, _Component);

  function ValueContainer() {
    classCallCheck(this, ValueContainer);
    return possibleConstructorReturn(this, (ValueContainer.__proto__ || Object.getPrototypeOf(ValueContainer)).apply(this, arguments));
  }

  createClass(ValueContainer, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          children = _props.children,
          className = _props.className,
          cx = _props.cx,
          isMulti = _props.isMulti,
          getStyles = _props.getStyles,
          hasValue = _props.hasValue;


      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        {
          className: cx( /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0_emotion__["css"])(getStyles('valueContainer', this.props)), {
            'value-container': true,
            'value-container--is-multi': isMulti,
            'value-container--has-value': hasValue
          }, className)
        },
        children
      );
    }
  }]);
  return ValueContainer;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);

// ==============================
// Indicator Container
// ==============================

var indicatorsContainerCSS = function indicatorsContainerCSS() {
  return {
    alignItems: 'center',
    alignSelf: 'stretch',
    display: 'flex',
    flexShrink: 0
  };
};
var IndicatorsContainer = function IndicatorsContainer(props) {
  var children = props.children,
      className = props.className,
      cx = props.cx,
      getStyles = props.getStyles;


  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
    'div',
    {
      className: cx( /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0_emotion__["css"])(getStyles('indicatorsContainer', props)), {
        'indicators': true
      }, className)
    },
    children
  );
};

// ==============================
// Dropdown & Clear Icons
// ==============================

var Svg = function Svg(_ref) {
  var size = _ref.size,
      props = objectWithoutProperties(_ref, ['size']);
  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('svg', _extends({
    height: size,
    width: size,
    viewBox: '0 0 20 20',
    'aria-hidden': 'true',
    focusable: 'false',
    className: /*#__PURE__*/ /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0_emotion__["css"])({
      display: 'inline-block',
      fill: 'currentColor',
      lineHeight: 1,
      stroke: 'currentColor',
      strokeWidth: 0
    })
  }, props));
};

var CrossIcon = function CrossIcon(props) {
  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
    Svg,
    _extends({ size: 20 }, props),
    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path', { d: 'M14.348 14.849c-0.469 0.469-1.229 0.469-1.697 0l-2.651-3.030-2.651 3.029c-0.469 0.469-1.229 0.469-1.697 0-0.469-0.469-0.469-1.229 0-1.697l2.758-3.15-2.759-3.152c-0.469-0.469-0.469-1.228 0-1.697s1.228-0.469 1.697 0l2.652 3.031 2.651-3.031c0.469-0.469 1.228-0.469 1.697 0s0.469 1.229 0 1.697l-2.758 3.152 2.758 3.15c0.469 0.469 0.469 1.229 0 1.698z' })
  );
};
var DownChevron = function DownChevron(props) {
  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
    Svg,
    _extends({ size: 20 }, props),
    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path', { d: 'M4.516 7.548c0.436-0.446 1.043-0.481 1.576 0l3.908 3.747 3.908-3.747c0.533-0.481 1.141-0.446 1.574 0 0.436 0.445 0.408 1.197 0 1.615-0.406 0.418-4.695 4.502-4.695 4.502-0.217 0.223-0.502 0.335-0.787 0.335s-0.57-0.112-0.789-0.335c0 0-4.287-4.084-4.695-4.502s-0.436-1.17 0-1.615z' })
  );
};

// ==============================
// Dropdown & Clear Buttons
// ==============================

var baseCSS = function baseCSS(_ref2) {
  var isFocused = _ref2.isFocused;
  return {
    color: isFocused ? colors.neutral60 : colors.neutral20,
    display: 'flex',
    padding: spacing.baseUnit * 2,
    transition: 'color 150ms',

    ':hover': {
      color: isFocused ? colors.neutral100 : colors.neutral40
    }
  };
};

var dropdownIndicatorCSS = baseCSS;
var DropdownIndicator = function DropdownIndicator(props) {
  var _props$children = props.children,
      children = _props$children === undefined ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(DownChevron, null) : _props$children,
      className = props.className,
      cx = props.cx,
      getStyles = props.getStyles,
      innerProps = props.innerProps;

  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
    'div',
    _extends({}, innerProps, {
      className: cx( /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0_emotion__["css"])(getStyles('dropdownIndicator', props)), {
        'indicator': true,
        'dropdown-indicator': true
      }, className)
    }),
    children
  );
};

var clearIndicatorCSS = baseCSS;
var ClearIndicator = function ClearIndicator(props) {
  var _props$children2 = props.children,
      children = _props$children2 === undefined ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(CrossIcon, null) : _props$children2,
      className = props.className,
      cx = props.cx,
      getStyles = props.getStyles,
      innerProps = props.innerProps;

  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
    'div',
    _extends({}, innerProps, {
      className: cx( /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0_emotion__["css"])(getStyles('clearIndicator', props)), {
        'indicator': true,
        'clear-indicator': true
      }, className)
    }),
    children
  );
};

// ==============================
// Separator
// ==============================

var indicatorSeparatorCSS = function indicatorSeparatorCSS(_ref3) {
  var isDisabled = _ref3.isDisabled;
  return {
    alignSelf: 'stretch',
    backgroundColor: isDisabled ? colors.neutral10 : colors.neutral20,
    marginBottom: spacing.baseUnit * 2,
    marginTop: spacing.baseUnit * 2,
    width: 1
  };
};

var IndicatorSeparator = function IndicatorSeparator(props) {
  var className = props.className,
      cx = props.cx,
      getStyles = props.getStyles,
      innerProps = props.innerProps;

  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span', _extends({}, innerProps, {
    className: cx( /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0_emotion__["css"])(getStyles('indicatorSeparator', props)), { 'indicator-separator': true }, className)
  }));
};

// ==============================
// Loading
// ==============================

var keyframesName = 'react-select-loading-indicator';

var loadingIndicatorCSS = function loadingIndicatorCSS(_ref4) {
  var isFocused = _ref4.isFocused,
      size = _ref4.size;
  return {
    color: isFocused ? colors.neutral60 : colors.neutral20,
    display: 'flex',
    padding: spacing.baseUnit * 2,
    transition: 'color 150ms',
    alignSelf: 'center',
    fontSize: size,
    lineHeight: 1,
    marginRight: size,
    textAlign: 'center',
    verticalAlign: 'middle'
  };
};

var LoadingDot = function LoadingDot(_ref5) {
  var color = _ref5.color,
      delay = _ref5.delay,
      offset = _ref5.offset;
  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span', {
    className: Object(__WEBPACK_IMPORTED_MODULE_0_emotion__["css"])({
      animationDuration: '1s',
      animationDelay: delay + 'ms',
      animationIterationCount: 'infinite',
      animationName: keyframesName,
      animationTimingFunction: 'ease-in-out',
      backgroundColor: color,
      borderRadius: '1em',
      display: 'inline-block',
      marginLeft: offset ? '1em' : null,
      height: '1em',
      verticalAlign: 'top',
      width: '1em'
    })
  });
};

// eslint-disable-next-line no-unused-expressions
Object(__WEBPACK_IMPORTED_MODULE_0_emotion__["injectGlobal"])('@keyframes ', keyframesName, '{0%,80%,100%{opacity:0;}40%{opacity:1;}};');

var LoadingIndicator = function LoadingIndicator(props) {
  var className = props.className,
      cx = props.cx,
      getStyles = props.getStyles,
      innerProps = props.innerProps,
      isFocused = props.isFocused,
      isRtl = props.isRtl;

  var color = isFocused ? colors.text : colors.neutral20;

  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
    'div',
    _extends({}, innerProps, {
      className: cx( /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0_emotion__["css"])(getStyles('loadingIndicator', props)), {
        'indicator': true,
        'loading-indicator': true
      }, className)
    }),
    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(LoadingDot, { color: color, delay: 0, offset: isRtl }),
    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(LoadingDot, { color: color, delay: 160, offset: true }),
    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(LoadingDot, { color: color, delay: 320, offset: !isRtl })
  );
};
LoadingIndicator.defaultProps = { size: 4 };

var css$1 = function css$$1(_ref) {
  var isDisabled = _ref.isDisabled,
      isFocused = _ref.isFocused;
  return {
    alignItems: 'center',
    backgroundColor: isDisabled ? colors.neutral5 : isFocused ? colors.neutral0 : colors.neutral2,
    borderColor: isDisabled ? colors.neutral10 : isFocused ? colors.primary : colors.neutral20,
    borderRadius: borderRadius,
    borderStyle: 'solid',
    borderWidth: 1,
    boxShadow: isFocused ? '0 0 0 1px ' + colors.primary : null,
    cursor: 'default',
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-between',
    minHeight: spacing.controlHeight,
    outline: '0 !important',
    position: 'relative',
    transition: 'all 100ms',

    '&:hover': {
      borderColor: isFocused ? colors.primary : colors.neutral30
    }
  };
};

var Control = function Control(props) {
  var children = props.children,
      cx = props.cx,
      getStyles = props.getStyles,
      className = props.className,
      isDisabled = props.isDisabled,
      isFocused = props.isFocused,
      innerProps = props.innerProps;
  var innerRef = innerProps.innerRef,
      rest = objectWithoutProperties(innerProps, ['innerRef']);

  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
    'div',
    _extends({
      ref: innerRef,
      className: cx( /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0_emotion__["css"])(getStyles('control', props)), {
        'control': true,
        'control--is-disabled': isDisabled,
        'control--is-focused': isFocused
      }, className)
    }, rest),
    children
  );
};

var groupCSS = function groupCSS() {
  return {
    paddingBottom: spacing.baseUnit * 2,
    paddingTop: spacing.baseUnit * 2
  };
};

var Group = function Group(props) {
  var children = props.children,
      className = props.className,
      cx = props.cx,
      getStyles = props.getStyles,
      Heading = props.Heading,
      label = props.label;

  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
    'div',
    {
      className: cx( /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0_emotion__["css"])(getStyles('group', props)), { 'group': true }, className)
    },
    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
      Heading,
      { getStyles: getStyles, cx: cx },
      label
    ),
    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
      'div',
      null,
      children
    )
  );
};

var groupHeadingCSS = function groupHeadingCSS() {
  return {
    color: '#999',
    cursor: 'default',
    display: 'block',
    fontSize: '75%',
    fontWeight: '500',
    marginBottom: '0.25em',
    paddingLeft: spacing.baseUnit * 3,
    paddingRight: spacing.baseUnit * 3,
    textTransform: 'uppercase'
  };
};

var GroupHeading = function GroupHeading(props) {
  var className = props.className,
      cx = props.cx,
      getStyles = props.getStyles,
      cleanProps = objectWithoutProperties(props, ['className', 'cx', 'getStyles']);

  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', _extends({
    className: cx( /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0_emotion__["css"])(getStyles('groupHeading', props)), { 'group-heading': true }, className)
  }, cleanProps));
};

var inputCSS = function inputCSS(_ref) {
  var isDisabled = _ref.isDisabled;
  return {
    margin: spacing.baseUnit / 2,
    paddingBottom: spacing.baseUnit / 2,
    paddingTop: spacing.baseUnit / 2,
    visibility: isDisabled ? 'hidden' : 'visible',
    color: colors.text
  };
};
var inputStyle = function inputStyle(isHidden) {
  return {
    background: 0,
    border: 0,
    fontSize: 'inherit',
    opacity: isHidden ? 0 : 1,
    outline: 0,
    padding: 0,
    color: 'inherit'
  };
};

var Input$1 = function Input(_ref2) {
  var className = _ref2.className,
      cx = _ref2.cx,
      getStyles = _ref2.getStyles,
      innerRef = _ref2.innerRef,
      isHidden = _ref2.isHidden,
      isDisabled = _ref2.isDisabled,
      props = objectWithoutProperties(_ref2, ['className', 'cx', 'getStyles', 'innerRef', 'isHidden', 'isDisabled']);
  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
    'div',
    {
      className: Object(__WEBPACK_IMPORTED_MODULE_0_emotion__["css"])(getStyles('input', props))
    },
    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_input_autosize___default.a, _extends({
      className: cx(null, { 'input': true }, className),
      inputRef: innerRef,
      inputStyle: inputStyle(isHidden),
      disabled: isDisabled
    }, props))
  );
};

// ==============================
// Menu
// ==============================

// Get Menu Placement
// ------------------------------

function getMenuPlacement(_ref) {
  var maxHeight = _ref.maxHeight,
      menuEl = _ref.menuEl,
      minHeight = _ref.minHeight,
      placement = _ref.placement,
      shouldScroll = _ref.shouldScroll,
      isFixedPosition = _ref.isFixedPosition;

  var scrollParent = getScrollParent(menuEl);
  var defaultState = { placement: 'bottom', maxHeight: maxHeight };

  // something went wrong, return default state
  if (!menuEl || !menuEl.offsetParent) return defaultState;

  // we can't trust `scrollParent.scrollHeight` --> it may increase when
  // the menu is rendered

  var _scrollParent$getBoun = scrollParent.getBoundingClientRect(),
      scrollHeight = _scrollParent$getBoun.height;

  var _menuEl$getBoundingCl = menuEl.getBoundingClientRect(),
      menuBottom = _menuEl$getBoundingCl.bottom,
      menuHeight = _menuEl$getBoundingCl.height,
      menuTop = _menuEl$getBoundingCl.top;

  // $FlowFixMe function returns above if there's no offsetParent


  var _menuEl$offsetParent$ = menuEl.offsetParent.getBoundingClientRect(),
      containerTop = _menuEl$offsetParent$.top;

  var viewHeight = window.innerHeight;
  var scrollTop = getScrollTop(scrollParent);
  var gutter = spacing.menuGutter;

  var viewSpaceAbove = containerTop - gutter;
  var viewSpaceBelow = viewHeight - menuTop;
  var scrollSpaceAbove = viewSpaceAbove + scrollTop;
  var scrollSpaceBelow = scrollHeight - scrollTop - menuTop;

  var scrollDown = menuBottom - viewHeight + scrollTop + gutter;
  var scrollUp = scrollTop + menuTop - gutter;
  var scrollDuration = 160;

  switch (placement) {
    case 'auto':
    case 'bottom':
      // 1: the menu will fit, do nothing
      if (viewSpaceBelow >= menuHeight) {
        return { placement: 'bottom', maxHeight: maxHeight };
      }

      // 2: the menu will fit, if scrolled
      if (scrollSpaceBelow >= menuHeight && !isFixedPosition) {
        if (shouldScroll) {
          animatedScrollTo(scrollParent, scrollDown, scrollDuration);
        }

        return { placement: 'bottom', maxHeight: maxHeight };
      }

      // 3: the menu will fit, if constrained
      if (!isFixedPosition && scrollSpaceBelow >= minHeight || isFixedPosition && viewSpaceBelow >= minHeight) {
        if (shouldScroll) {
          animatedScrollTo(scrollParent, scrollDown, scrollDuration);
        }

        // we want to provide as much of the menu as possible to the user,
        // so give them whatever is available below rather than the minHeight.
        var constrainedHeight = isFixedPosition ? viewSpaceBelow - gutter : scrollSpaceBelow - gutter;

        return {
          placement: 'bottom',
          maxHeight: constrainedHeight
        };
      }

      // 4. Forked beviour when there isn't enough space below

      // AUTO: flip the menu, render above
      if (placement === 'auto' || isFixedPosition) {
        // may need to be constrained after flipping
        var _constrainedHeight = maxHeight;

        if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) {
          _constrainedHeight = isFixedPosition ? viewSpaceAbove - gutter - spacing.controlHeight : scrollSpaceAbove - gutter - spacing.controlHeight;
        }

        return { placement: 'top', maxHeight: _constrainedHeight };
      }

      // BOTTOM: allow browser to increase scrollable area and immediately set scroll
      if (placement === 'bottom') {
        scrollTo(scrollParent, scrollDown);
        return { placement: 'bottom', maxHeight: maxHeight };
      }
      break;
    case 'top':
      // 1: the menu will fit, do nothing
      if (viewSpaceAbove >= menuHeight) {
        return { placement: 'top', maxHeight: maxHeight };
      }

      // 2: the menu will fit, if scrolled
      if (scrollSpaceAbove >= menuHeight && !isFixedPosition) {
        if (shouldScroll) {
          animatedScrollTo(scrollParent, scrollUp, scrollDuration);
        }

        return { placement: 'top', maxHeight: maxHeight };
      }

      // 3: the menu will fit, if constrained
      if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) {
        var _constrainedHeight2 = maxHeight;

        // we want to provide as much of the menu as possible to the user,
        // so give them whatever is available below rather than the minHeight.
        if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) {
          _constrainedHeight2 = isFixedPosition ? viewSpaceAbove - gutter : scrollSpaceAbove - gutter;
        }

        if (shouldScroll) {
          animatedScrollTo(scrollParent, scrollUp, scrollDuration);
        }

        return {
          placement: 'top',
          maxHeight: _constrainedHeight2
        };
      }

      // 4. not enough space, the browser WILL NOT increase scrollable area when
      // absolutely positioned element rendered above the viewport (only below).
      // Flip the menu, render below
      return { placement: 'bottom', maxHeight: maxHeight };
    default:
      throw new Error('Invalid placement provided "' + placement + '".');
  }

  // fulfil contract with flow: implicit return value of undefined
  return defaultState;
}

// Menu Component
// ------------------------------

function alignToControl(placement) {
  var placementToCSSProp = { bottom: 'top', top: 'bottom' };
  return placement ? placementToCSSProp[placement] : 'bottom';
}
var coercePlacement = function coercePlacement(p) {
  return p === 'auto' ? 'bottom' : p;
};

var menuCSS = function menuCSS(_ref2) {
  var _ref3;

  var placement = _ref2.placement;
  return _ref3 = {}, defineProperty(_ref3, alignToControl(placement), '100%'), defineProperty(_ref3, 'backgroundColor', colors.neutral0), defineProperty(_ref3, 'borderRadius', borderRadius), defineProperty(_ref3, 'boxShadow', '0 0 0 1px ' + colors.neutral10a + ', 0 4px 11px ' + colors.neutral10a), defineProperty(_ref3, 'marginBottom', spacing.menuGutter), defineProperty(_ref3, 'marginTop', spacing.menuGutter), defineProperty(_ref3, 'position', 'absolute'), defineProperty(_ref3, 'width', '100%'), defineProperty(_ref3, 'zIndex', 1), _ref3;
};

var Menu = function (_Component) {
  inherits(Menu, _Component);

  function Menu() {
    var _ref4;

    var _temp, _this, _ret;

    classCallCheck(this, Menu);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn(this, (_ref4 = Menu.__proto__ || Object.getPrototypeOf(Menu)).call.apply(_ref4, [this].concat(args))), _this), _this.state = {
      maxHeight: _this.props.maxMenuHeight,
      placement: null
    }, _this.getPlacement = function (ref) {
      var _this$props = _this.props,
          minMenuHeight = _this$props.minMenuHeight,
          maxMenuHeight = _this$props.maxMenuHeight,
          menuPlacement = _this$props.menuPlacement,
          menuPosition = _this$props.menuPosition,
          menuShouldScrollIntoView = _this$props.menuShouldScrollIntoView;
      var getPortalPlacement = _this.context.getPortalPlacement;


      if (!ref) return;

      // DO NOT scroll if position is fixed
      var isFixedPosition = menuPosition === 'fixed';
      var shouldScroll = menuShouldScrollIntoView && !isFixedPosition;

      var state = getMenuPlacement({
        maxHeight: maxMenuHeight,
        menuEl: ref,
        minHeight: minMenuHeight,
        placement: menuPlacement,
        shouldScroll: shouldScroll,
        isFixedPosition: isFixedPosition
      });

      if (getPortalPlacement) getPortalPlacement(state);

      _this.setState(state);
    }, _this.getState = function () {
      var menuPlacement = _this.props.menuPlacement;

      var placement = _this.state.placement || coercePlacement(menuPlacement);

      return _extends({}, _this.props, { placement: placement, maxHeight: _this.state.maxHeight });
    }, _temp), possibleConstructorReturn(_this, _ret);
  }

  createClass(Menu, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          children = _props.children,
          className = _props.className,
          cx = _props.cx,
          getStyles = _props.getStyles,
          innerProps = _props.innerProps;


      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        _extends({
          className: cx( /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0_emotion__["css"])(getStyles('menu', this.getState())), {
            'menu': true
          }, className),
          ref: this.getPlacement
        }, innerProps),
        children
      );
    }
  }]);
  return Menu;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);

Menu.contextTypes = {
  getPortalPlacement: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func
};

// ==============================
// Menu List
// ==============================

var menuListCSS = function menuListCSS(_ref5) {
  var maxHeight = _ref5.maxHeight;
  return {
    maxHeight: maxHeight,
    overflowY: 'auto',
    paddingBottom: spacing.baseUnit,
    paddingTop: spacing.baseUnit,
    position: 'relative', // required for offset[Height, Top] > keyboard scroll
    WebkitOverflowScrolling: 'touch'
  };
};
var MenuList = function MenuList(props) {
  var children = props.children,
      className = props.className,
      cx = props.cx,
      getStyles = props.getStyles,
      isMulti = props.isMulti,
      innerProps = props.innerProps;
  var innerRef = innerProps.innerRef;

  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
    'div',
    {
      className: cx( /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0_emotion__["css"])(getStyles('menuList', props)), {
        'menu-list': true,
        'menu-list--is-multi': isMulti
      }, className),
      ref: innerRef
    },
    children
  );
};

// ==============================
// Menu Notices
// ==============================

var noticeCSS = function noticeCSS() {
  return {
    color: colors.neutral40,
    padding: spacing.baseUnit * 2 + 'px ' + spacing.baseUnit * 3 + 'px',
    textAlign: 'center'
  };
};
var noOptionsMessageCSS = noticeCSS;
var loadingMessageCSS = noticeCSS;

var NoOptionsMessage = function NoOptionsMessage(props) {
  var children = props.children,
      className = props.className,
      cx = props.cx,
      getStyles = props.getStyles,
      innerProps = props.innerProps;

  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
    'div',
    _extends({
      className: cx( /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0_emotion__["css"])(getStyles('noOptionsMessage', props)), {
        'menu-notice': true,
        'menu-notice--no-options': true
      }, className)
    }, innerProps),
    children
  );
};
NoOptionsMessage.defaultProps = {
  children: 'No options'
};

var LoadingMessage = function LoadingMessage(props) {
  var children = props.children,
      className = props.className,
      cx = props.cx,
      getStyles = props.getStyles,
      innerProps = props.innerProps;

  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
    'div',
    _extends({
      className: cx( /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0_emotion__["css"])(getStyles('loadingMessage', props)), {
        'menu-notice': true,
        'menu-notice--loading': true
      }, className)
    }, innerProps),
    children
  );
};
LoadingMessage.defaultProps = {
  children: 'Loading...'
};

// ==============================
// Menu Portal
// ==============================

var menuPortalCSS = function menuPortalCSS(_ref6) {
  var rect = _ref6.rect,
      offset = _ref6.offset,
      position = _ref6.position;
  return {
    left: rect.left,
    position: position,
    top: offset,
    width: rect.width,
    zIndex: 1
  };
};

var MenuPortal = function (_Component2) {
  inherits(MenuPortal, _Component2);

  function MenuPortal() {
    var _ref7;

    var _temp2, _this2, _ret2;

    classCallCheck(this, MenuPortal);

    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    return _ret2 = (_temp2 = (_this2 = possibleConstructorReturn(this, (_ref7 = MenuPortal.__proto__ || Object.getPrototypeOf(MenuPortal)).call.apply(_ref7, [this].concat(args))), _this2), _this2.state = { placement: null }, _this2.getPortalPlacement = function (_ref8) {
      var placement = _ref8.placement;

      var initialPlacement = coercePlacement(_this2.props.menuPlacement);

      // avoid re-renders if the placement has not changed
      if (placement !== initialPlacement) {
        _this2.setState({ placement: placement });
      }
    }, _temp2), possibleConstructorReturn(_this2, _ret2);
  }

  createClass(MenuPortal, [{
    key: 'getChildContext',
    value: function getChildContext() {
      return {
        getPortalPlacement: this.getPortalPlacement
      };
    }

    // callback for occassions where the menu must "flip"

  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          appendTo = _props2.appendTo,
          children = _props2.children,
          controlElement = _props2.controlElement,
          menuPlacement = _props2.menuPlacement,
          position = _props2.menuPosition,
          getStyles = _props2.getStyles;

      var isFixed = position === 'fixed';

      // bail early if required elements aren't present
      if (!appendTo && !isFixed || !controlElement) {
        return null;
      }

      var placement = this.state.placement || coercePlacement(menuPlacement);
      var rect = getBoundingClientObj(controlElement);
      var scrollDistance = isFixed ? 0 : window.pageYOffset;
      var offset = rect[placement] + scrollDistance;
      var state = { offset: offset, position: position, rect: rect };

      // same wrapper element whether fixed or portalled
      var menuWrapper = __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        {
          className: /*#__PURE__*/ /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0_emotion__["css"])(getStyles('menuPortal', state))
        },
        children
      );

      return appendTo ? Object(__WEBPACK_IMPORTED_MODULE_2_react_dom__["createPortal"])(menuWrapper, appendTo) : menuWrapper;
    }
  }]);
  return MenuPortal;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);
MenuPortal.childContextTypes = {
  getPortalPlacement: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func
};

var multiValueCSS = function multiValueCSS() {
  return {
    backgroundColor: colors.neutral10,
    borderRadius: borderRadius / 2,
    display: 'flex',
    margin: spacing.baseUnit / 2,
    minWidth: 0 // resolves flex/text-overflow bug
  };
};
var multiValueLabelCSS = function multiValueLabelCSS(_ref) {
  var cropWithEllipsis = _ref.cropWithEllipsis;
  return {
    color: colors.text,
    fontSize: '85%',
    overflow: 'hidden',
    padding: 3,
    paddingLeft: 6,
    textOverflow: cropWithEllipsis ? 'ellipsis' : null,
    whiteSpace: 'nowrap'
  };
};
var multiValueRemoveCSS = function multiValueRemoveCSS(_ref2) {
  var isFocused = _ref2.isFocused;
  return {
    alignItems: 'center',
    borderRadius: borderRadius / 2,
    backgroundColor: isFocused && colors.dangerLight,
    display: 'flex',
    paddingLeft: spacing.baseUnit,
    paddingRight: spacing.baseUnit,
    ':hover': {
      backgroundColor: colors.dangerLight,
      color: colors.danger
    }
  };
};

var MultiValueContainer = Div;
var MultiValueLabel = Div;

var MultiValueRemove = function (_Component) {
  inherits(MultiValueRemove, _Component);

  function MultiValueRemove() {
    classCallCheck(this, MultiValueRemove);
    return possibleConstructorReturn(this, (MultiValueRemove.__proto__ || Object.getPrototypeOf(MultiValueRemove)).apply(this, arguments));
  }

  createClass(MultiValueRemove, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          children = _props.children,
          props = objectWithoutProperties(_props, ['children']);

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        Div,
        props,
        children
      );
    }
  }]);
  return MultiValueRemove;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);

MultiValueRemove.defaultProps = {
  children: __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(CrossIcon, { size: 14 })
};

var MultiValue = function (_Component2) {
  inherits(MultiValue, _Component2);

  function MultiValue() {
    classCallCheck(this, MultiValue);
    return possibleConstructorReturn(this, (MultiValue.__proto__ || Object.getPrototypeOf(MultiValue)).apply(this, arguments));
  }

  createClass(MultiValue, [{
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          children = _props2.children,
          className = _props2.className,
          components = _props2.components,
          cx = _props2.cx,
          getStyles = _props2.getStyles,
          innerProps = _props2.innerProps,
          isDisabled = _props2.isDisabled,
          removeProps = _props2.removeProps;

      var cn = {
        container: cx( /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0_emotion__["css"])(getStyles('multiValue', this.props)), {
          'multi-value': true,
          'multi-value--is-disabled': isDisabled
        }, className),
        label: cx( /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0_emotion__["css"])(getStyles('multiValueLabel', this.props)), {
          'multi-value__label': true
        }, className),
        remove: cx( /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0_emotion__["css"])(getStyles('multiValueRemove', this.props)), {
          'multi-value__remove': true
        }, className)
      };
      var Container = components.Container,
          Label = components.Label,
          Remove = components.Remove;


      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        Container,
        _extends({
          className: cn.container
        }, innerProps),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          Label,
          { className: cn.label },
          children
        ),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Remove, _extends({ className: cn.remove }, removeProps))
      );
    }
  }]);
  return MultiValue;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);

MultiValue.defaultProps = {
  cropWithEllipsis: true
};

var optionCSS = function optionCSS(_ref) {
  var isDisabled = _ref.isDisabled,
      isFocused = _ref.isFocused,
      isSelected = _ref.isSelected;
  return {
    backgroundColor: isSelected ? colors.primary : isFocused ? colors.primary25 : 'transparent',
    color: isDisabled ? colors.neutral20 : isSelected ? colors.neutral0 : 'inherit',
    cursor: 'default',
    display: 'block',
    fontSize: 'inherit',
    padding: spacing.baseUnit * 2 + 'px ' + spacing.baseUnit * 3 + 'px',
    width: '100%',
    userSelect: 'none',
    WebkitTapHighlightColor: 'rgba(0, 0, 0, 0)',

    // provide some affordance on touch devices
    ':active': {
      backgroundColor: isSelected ? colors.primary : colors.primary50
    }
  };
};

var Option = function Option(props) {
  var children = props.children,
      className = props.className,
      cx = props.cx,
      getStyles = props.getStyles,
      isDisabled = props.isDisabled,
      isFocused = props.isFocused,
      isSelected = props.isSelected,
      innerProps = props.innerProps;
  var innerRef = innerProps.innerRef,
      rest = objectWithoutProperties(innerProps, ['innerRef']);

  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
    'div',
    _extends({
      ref: innerRef,
      className: cx( /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0_emotion__["css"])(getStyles('option', props)), {
        'option': true,
        'option--is-disabled': isDisabled,
        'option--is-focused': isFocused,
        'option--is-selected': isSelected
      }, className)
    }, rest),
    children
  );
};

var placeholderCSS = function placeholderCSS() {
  return {
    color: colors.neutral50,
    marginLeft: spacing.baseUnit / 2,
    marginRight: spacing.baseUnit / 2,
    position: 'absolute',
    top: '50%',
    transform: 'translateY(-50%)'
  };
};

var Placeholder = function Placeholder(props) {
  var children = props.children,
      className = props.className,
      cx = props.cx,
      getStyles = props.getStyles,
      innerProps = props.innerProps;

  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
    'div',
    _extends({
      className: cx( /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0_emotion__["css"])(getStyles('placeholder', props)), {
        'placeholder': true
      }, className)
    }, innerProps),
    children
  );
};

var css$2 = function css$$1(_ref) {
  var isDisabled = _ref.isDisabled;
  return {
    color: isDisabled ? colors.neutral40 : colors.text,
    marginLeft: spacing.baseUnit / 2,
    marginRight: spacing.baseUnit / 2,
    maxWidth: 'calc(100% - ' + spacing.baseUnit * 2 + 'px)',
    overflow: 'hidden',
    position: 'absolute',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    top: '50%',
    transform: 'translateY(-50%)'
  };
};

var SingleValue = function SingleValue(props) {
  var children = props.children,
      className = props.className,
      cx = props.cx,
      getStyles = props.getStyles,
      isDisabled = props.isDisabled,
      innerProps = props.innerProps;

  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
    'div',
    _extends({
      className: cx( /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0_emotion__["css"])(getStyles('singleValue', props)), {
        'single-value': true,
        'single-value--is-disabled': isDisabled
      }, className)
    }, innerProps),
    children
  );
};

var components = {
  ClearIndicator: ClearIndicator,
  Control: Control,
  DropdownIndicator: DropdownIndicator,
  DownChevron: DownChevron,
  CrossIcon: CrossIcon,
  Group: Group,
  GroupHeading: GroupHeading,
  IndicatorsContainer: IndicatorsContainer,
  IndicatorSeparator: IndicatorSeparator,
  Input: Input$1,
  LoadingIndicator: LoadingIndicator,
  Menu: Menu,
  MenuList: MenuList,
  MenuPortal: MenuPortal,
  LoadingMessage: LoadingMessage,
  NoOptionsMessage: NoOptionsMessage,
  MultiValue: MultiValue,
  MultiValueContainer: MultiValueContainer,
  MultiValueLabel: MultiValueLabel,
  MultiValueRemove: MultiValueRemove,
  Option: Option,
  Placeholder: Placeholder,
  SelectContainer: SelectContainer,
  SingleValue: SingleValue,
  ValueContainer: ValueContainer
};

var defaultComponents = function defaultComponents(props) {
  return _extends({}, components, props.components);
};

var defaultStyles = {
  clearIndicator: clearIndicatorCSS,
  container: containerCSS,
  control: css$1,
  dropdownIndicator: dropdownIndicatorCSS,
  group: groupCSS,
  groupHeading: groupHeadingCSS,
  indicatorsContainer: indicatorsContainerCSS,
  indicatorSeparator: indicatorSeparatorCSS,
  input: inputCSS,
  loadingIndicator: loadingIndicatorCSS,
  loadingMessage: loadingMessageCSS,
  menu: menuCSS,
  menuList: menuListCSS,
  menuPortal: menuPortalCSS,
  multiValue: multiValueCSS,
  multiValueLabel: multiValueLabelCSS,
  multiValueRemove: multiValueRemoveCSS,
  noOptionsMessage: noOptionsMessageCSS,
  option: optionCSS,
  placeholder: placeholderCSS,
  singleValue: css$2,
  valueContainer: valueContainerCSS
};

// Merge Utility
// Allows consumers to extend a base Select with additional styles

function mergeStyles(source) {
  var target = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  // initialize with source styles
  var styles = _extends({}, source);

  // massage in target styles
  Object.keys(target).forEach(function (key) {
    if (source[key]) {
      styles[key] = function (rsCss, props) {
        return target[key](source[key](rsCss, props), props);
      };
    } else {
      styles[key] = target[key];
    }
  });

  return styles;
}

var defaultProps = {
  backspaceRemovesValue: true,
  blurInputOnSelect: isTouchCapable(),
  captureMenuScroll: !isTouchCapable(),
  closeMenuOnSelect: true,
  components: {},
  controlShouldRenderValue: true,
  escapeClearsValue: false,
  filterOption: createFilter(),
  formatGroupLabel: formatGroupLabel,
  getOptionLabel: getOptionLabel,
  getOptionValue: getOptionValue,
  isDisabled: false,
  isLoading: false,
  isMulti: false,
  isRtl: false,
  isSearchable: true,
  isOptionDisabled: isOptionDisabled,
  loadingMessage: function loadingMessage() {
    return 'Loading...';
  },
  maxMenuHeight: 300,
  minMenuHeight: 140,
  menuIsOpen: false,
  menuPlacement: 'bottom',
  menuPosition: 'absolute',
  menuShouldBlockScroll: false,
  menuShouldScrollIntoView: !isMobileDevice(),
  noOptionsMessage: function noOptionsMessage() {
    return 'No options';
  },
  openMenuOnFocus: false,
  openMenuOnClick: true,
  options: [],
  pageSize: 5,
  placeholder: 'Select...',
  screenReaderStatus: function screenReaderStatus(_ref) {
    var count = _ref.count;
    return count + ' result' + (count !== 1 ? 's' : '') + ' available';
  },
  styles: {},
  tabIndex: '0',
  tabSelectsValue: true
};

var instanceId = 1;

var Select = function (_Component) {
  inherits(Select, _Component);

  // Lifecycle
  // ------------------------------

  // Refs
  // ------------------------------

  // Misc. Instance Properties
  // ------------------------------

  function Select(props) {
    classCallCheck(this, Select);

    var _this = possibleConstructorReturn(this, (Select.__proto__ || Object.getPrototypeOf(Select)).call(this, props));

    _initialiseProps.call(_this);

    var value = props.value;

    _this.components = defaultComponents(props);
    _this.instancePrefix = 'react-select-' + (_this.props.instanceId || ++instanceId);

    var selectValue = cleanValue(value);
    var menuOptions = _this.buildMenuOptions(props, selectValue);

    _this.state.menuOptions = menuOptions;
    _this.state.selectValue = selectValue;
    return _this;
  } // TODO


  createClass(Select, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.startListeningToTouch();

      if (this.props.autoFocus) {
        this.focusInput();
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var _props = this.props,
          components$$1 = _props.components,
          options = _props.options,
          value = _props.value,
          inputValue = _props.inputValue;
      // re-cache custom components

      if (nextProps.components !== components$$1) {
        this.components = defaultComponents(nextProps);
      }
      // rebuild the menu options
      if (nextProps.value !== value || nextProps.options !== options || nextProps.inputValue !== inputValue) {
        var _selectValue = cleanValue(nextProps.value);
        var _menuOptions = this.buildMenuOptions(nextProps, _selectValue);
        var _focusedValue = this.getNextFocusedValue(_selectValue);
        var _focusedOption = this.getNextFocusedOption(_menuOptions.focusable);
        this.setState({ menuOptions: _menuOptions, selectValue: _selectValue, focusedOption: _focusedOption, focusedValue: _focusedValue });
      }
      // some updates should toggle the state of the input visibility
      if (this.inputIsHiddenAfterUpdate != null) {
        this.setState({
          inputIsHidden: this.inputIsHiddenAfterUpdate
        });
        delete this.inputIsHiddenAfterUpdate;
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      var _props2 = this.props,
          isDisabled = _props2.isDisabled,
          menuIsOpen = _props2.menuIsOpen;
      var isFocused = this.state.isFocused;


      if (
      // ensure focus is restored correctly when the control becomes enabled
      isFocused && !isDisabled && prevProps.isDisabled ||
      // ensure focus is on the Input when the menu opens
      isFocused && menuIsOpen && !prevProps.menuIsOpen) {
        this.focusInput();
      }

      // scroll the focused option into view if necessary
      if (this.menuListRef && this.focusedOptionRef && this.scrollToFocusedOptionOnUpdate) {
        scrollIntoView(this.menuListRef, this.focusedOptionRef);
      }
      this.scrollToFocusedOptionOnUpdate = false;
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.stopListeningToTouch();
    }

    // ==============================
    // Consumer Handlers
    // ==============================

  }, {
    key: 'onMenuOpen',
    value: function onMenuOpen() {
      this.props.onMenuOpen();
    }
  }, {
    key: 'onMenuClose',
    value: function onMenuClose() {
      var _props3 = this.props,
          isSearchable = _props3.isSearchable,
          isMulti = _props3.isMulti;

      this.announceAriaLiveContext({ event: 'input', context: { isSearchable: isSearchable, isMulti: isMulti } });
      this.onInputChange('', { action: 'menu-close' });
      this.props.onMenuClose();
    }
  }, {
    key: 'onInputChange',
    value: function onInputChange(newValue, actionMeta) {
      this.props.onInputChange(newValue, actionMeta);
    }

    // ==============================
    // Methods
    // ==============================

  }, {
    key: 'focusInput',
    value: function focusInput() {
      if (!this.inputRef) return;
      this.inputRef.focus();
    }
  }, {
    key: 'blurInput',
    value: function blurInput() {
      if (!this.inputRef) return;
      this.inputRef.blur();
    }

    // aliased for consumers

  }, {
    key: 'openMenu',
    value: function openMenu(focusOption) {
      var _state = this.state,
          menuOptions = _state.menuOptions,
          selectValue = _state.selectValue;
      var isMulti = this.props.isMulti;

      var openAtIndex = focusOption === 'first' ? 0 : menuOptions.focusable.length - 1;

      if (!isMulti) {
        var selectedIndex = menuOptions.focusable.indexOf(selectValue[0]);
        if (selectedIndex > -1) {
          openAtIndex = selectedIndex;
        }
      }

      this.scrollToFocusedOptionOnUpdate = true;
      this.inputIsHiddenAfterUpdate = false;

      this.onMenuOpen();
      this.setState({
        focusedValue: null,
        focusedOption: menuOptions.focusable[openAtIndex]
      });

      this.announceAriaLiveContext({ event: 'menu' });
    }
  }, {
    key: 'focusValue',
    value: function focusValue(direction) {
      var _props4 = this.props,
          isMulti = _props4.isMulti,
          isSearchable = _props4.isSearchable;
      var _state2 = this.state,
          selectValue = _state2.selectValue,
          focusedValue = _state2.focusedValue;

      // Only multiselects support value focusing

      if (!isMulti) return;

      this.setState({
        focusedOption: null
      });

      var focusedIndex = selectValue.indexOf(focusedValue);
      if (!focusedValue) {
        focusedIndex = -1;
        this.announceAriaLiveContext({ event: 'value' });
      }

      var lastIndex = selectValue.length - 1;
      var nextFocus = -1;
      if (!selectValue.length) return;

      switch (direction) {
        case 'previous':
          if (focusedIndex === 0) {
            // don't cycle from the start to the end
            nextFocus = 0;
          } else if (focusedIndex === -1) {
            // if nothing is focused, focus the last value first
            nextFocus = lastIndex;
          } else {
            nextFocus = focusedIndex - 1;
          }
          break;
        case 'next':
          if (focusedIndex > -1 && focusedIndex < lastIndex) {
            nextFocus = focusedIndex + 1;
          }
          break;
      }

      if (nextFocus === -1) {
        this.announceAriaLiveContext({ event: 'input', context: { isSearchable: isSearchable, isMulti: isMulti } });
      }

      this.setState({
        inputIsHidden: nextFocus === -1 ? false : true,
        focusedValue: selectValue[nextFocus]
      });
    }
  }, {
    key: 'focusOption',
    value: function focusOption() {
      var direction = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'first';
      var pageSize = this.props.pageSize;
      var _state3 = this.state,
          focusedOption = _state3.focusedOption,
          menuOptions = _state3.menuOptions;

      var options = menuOptions.focusable;

      if (!options.length) return;
      var nextFocus = 0; // handles 'first'
      var focusedIndex = options.indexOf(focusedOption);
      if (!focusedOption) {
        focusedIndex = -1;
        this.announceAriaLiveContext({ event: 'menu' });
      }

      if (direction === 'up') {
        nextFocus = focusedIndex > 0 ? focusedIndex - 1 : options.length - 1;
      } else if (direction === 'down') {
        nextFocus = (focusedIndex + 1) % options.length;
      } else if (direction === 'pageup') {
        nextFocus = focusedIndex - pageSize;
        if (nextFocus < 0) nextFocus = 0;
      } else if (direction === 'pagedown') {
        nextFocus = focusedIndex + pageSize;
        if (nextFocus > options.length - 1) nextFocus = options.length - 1;
      } else if (direction === 'last') {
        nextFocus = options.length - 1;
      }
      this.scrollToFocusedOptionOnUpdate = true;
      this.setState({
        focusedOption: options[nextFocus],
        focusedValue: null
      });
    }
  }, {
    key: 'getCommonProps',


    // ==============================
    // Getters
    // ==============================

    value: function getCommonProps() {
      var clearValue = this.clearValue,
          getStyles = this.getStyles,
          setValue = this.setValue,
          selectOption = this.selectOption,
          props = this.props;
      var className = props.className,
          classNamePrefix = props.classNamePrefix,
          isMulti = props.isMulti,
          isRtl = props.isRtl,
          options = props.options;
      var selectValue = this.state.selectValue;

      var hasValue = this.hasValue();
      var getValue = function getValue() {
        return selectValue;
      };
      var cxPrefix = classNamePrefix;
      if (className && classNamePrefix === undefined) {
        console.warn('\n        Warning: the behaviour of \'className\' has changed between 2.0.0-beta.2 and 2.0.0-beta.3.\n        You can now use className to specify the class name of the outer container, and classNamePrefix to enable our provided BEM class names for internal elements.\n        The className prop will have no effect on internal elements when 2.0.0 is released.\n      ');
        cxPrefix = className;
      }

      var cx = classNames.bind(null, cxPrefix);
      return {
        cx: cx,
        clearValue: clearValue,
        getStyles: getStyles,
        getValue: getValue,
        hasValue: hasValue,
        isMulti: isMulti,
        isRtl: isRtl,
        options: options,
        selectOption: selectOption,
        setValue: setValue,
        selectProps: props
      };
    }
  }, {
    key: 'getNextFocusedValue',
    value: function getNextFocusedValue(nextSelectValue) {
      if (this.clearFocusValueOnUpdate) {
        this.clearFocusValueOnUpdate = false;
        return null;
      }
      var _state4 = this.state,
          focusedValue = _state4.focusedValue,
          lastSelectValue = _state4.selectValue;

      var lastFocusedIndex = lastSelectValue.indexOf(focusedValue);
      if (lastFocusedIndex > -1) {
        var nextFocusedIndex = nextSelectValue.indexOf(focusedValue);
        if (nextFocusedIndex > -1) {
          // the focused value is still in the selectValue, return it
          return focusedValue;
        } else if (lastFocusedIndex < nextSelectValue.length) {
          // the focusedValue is not present in the next selectValue array by
          // reference, so return the new value at the same index
          return nextSelectValue[lastFocusedIndex];
        }
      }
      return null;
    }
  }, {
    key: 'getNextFocusedOption',
    value: function getNextFocusedOption(options) {
      var lastFocusedOption = this.state.focusedOption;

      return lastFocusedOption && options.indexOf(lastFocusedOption) > -1 ? lastFocusedOption : options[0];
    }

    // ==============================
    // Helpers
    // ==============================

  }, {
    key: 'hasValue',
    value: function hasValue() {
      var selectValue = this.state.selectValue;

      return selectValue.length > 0;
    }
  }, {
    key: 'hasOptions',
    value: function hasOptions() {
      return !!this.state.menuOptions.render.length;
    }
  }, {
    key: 'countOptions',
    value: function countOptions() {
      return this.state.menuOptions.focusable.length;
    }
  }, {
    key: 'isClearable',
    value: function isClearable() {
      var _props5 = this.props,
          isClearable = _props5.isClearable,
          isMulti = _props5.isMulti;

      // single select, by default, IS NOT clearable
      // multi select, by default, IS clearable

      if (isClearable === undefined) return isMulti;

      return isClearable;
    }
  }, {
    key: 'isOptionDisabled',
    value: function isOptionDisabled$$1(option) {
      return typeof this.props.isOptionDisabled === 'function' ? this.props.isOptionDisabled(option) : false;
    }
  }, {
    key: 'isOptionSelected',
    value: function isOptionSelected(option, selectValue) {
      var _this2 = this;

      if (selectValue.indexOf(option) > -1) return true;
      if (typeof this.props.isOptionSelected === 'function') {
        return this.props.isOptionSelected(option, selectValue);
      }
      var candidate = this.getOptionValue(option);
      return selectValue.some(function (i) {
        return _this2.getOptionValue(i) === candidate;
      });
    }
  }, {
    key: 'filterOption',
    value: function filterOption(option, inputValue) {
      return this.props.filterOption ? this.props.filterOption(option, inputValue) : true;
    }
  }, {
    key: 'formatOptionLabel',
    value: function formatOptionLabel(data, context) {
      if (typeof this.props.formatOptionLabel === 'function') {
        var _inputValue = this.props.inputValue;
        var _selectValue2 = this.state.selectValue;

        return this.props.formatOptionLabel(data, {
          context: context,
          inputValue: _inputValue,
          selectValue: _selectValue2
        });
      } else {
        return this.getOptionLabel(data);
      }
    }
  }, {
    key: 'formatGroupLabel',
    value: function formatGroupLabel$$1(data) {
      return this.props.formatGroupLabel(data);
    }

    // ==============================
    // Mouse Handlers
    // ==============================

  }, {
    key: 'startListeningToTouch',


    // ==============================
    // Touch Handlers
    // ==============================

    value: function startListeningToTouch() {
      if (document && document.addEventListener) {
        document.addEventListener('touchstart', this.onTouchStart, false);
        document.addEventListener('touchmove', this.onTouchMove, false);
        document.addEventListener('touchend', this.onTouchEnd, false);
      }
    }
  }, {
    key: 'stopListeningToTouch',
    value: function stopListeningToTouch() {
      if (document && document.removeEventListener) {
        document.removeEventListener('touchstart', this.onTouchStart);
        document.removeEventListener('touchmove', this.onTouchMove);
        document.removeEventListener('touchend', this.onTouchEnd);
      }
    }

    // ==============================
    // Focus Handlers
    // ==============================

    // ==============================
    // Keyboard Handlers
    // ==============================

  }, {
    key: 'buildMenuOptions',


    // ==============================
    // Menu Options
    // ==============================

    value: function buildMenuOptions(props, selectValue) {
      var _this3 = this;

      var _props$inputValue = props.inputValue,
          inputValue = _props$inputValue === undefined ? '' : _props$inputValue,
          options = props.options;


      var toOption = function toOption(option, id) {
        var isDisabled = _this3.isOptionDisabled(option);
        var isSelected = _this3.isOptionSelected(option, selectValue);
        var label = _this3.getOptionLabel(option);
        var value = _this3.getOptionValue(option);

        if (_this3.shouldHideSelectedOptions() && isSelected || !_this3.filterOption({ label: label, value: value, data: option }, inputValue)) {
          return;
        }

        var onHover = isDisabled ? undefined : function () {
          return _this3.onOptionHover(option);
        };
        var onSelect = isDisabled ? undefined : function () {
          return _this3.selectOption(option);
        };
        var optionId = _this3.getElementId('option') + '-' + id;

        return {
          innerProps: {
            id: optionId,
            onClick: onSelect,
            onMouseMove: onHover,
            onMouseOver: onHover,
            role: 'option',
            tabIndex: -1
          },
          data: option,
          isDisabled: isDisabled,
          isSelected: isSelected,
          key: optionId,
          label: label,
          type: 'option',
          value: value
        };
      };

      return options.reduce(function (acc, item, itemIndex) {
        if (item.options) {
          // TODO needs a tidier implementation
          if (!_this3.hasGroups) _this3.hasGroups = true;

          var items = item.options;

          var children = items.map(function (child, i) {
            var option = toOption(child, itemIndex + '-' + i);
            if (option && !option.isDisabled) acc.focusable.push(child);
            return option;
          }).filter(Boolean);
          if (children.length) {
            var groupId = _this3.getElementId('group') + '-' + itemIndex;
            acc.render.push({
              type: 'group',
              key: groupId,
              data: item,
              options: children
            });
          }
        } else {
          var option = toOption(item, '' + itemIndex);
          if (option) {
            acc.render.push(option);
            if (!option.isDisabled) acc.focusable.push(item);
          }
        }
        return acc;
      }, { render: [], focusable: [] });
    }

    // ==============================
    // Renderers
    // ==============================

  }, {
    key: 'constructAriaLiveMessage',
    value: function constructAriaLiveMessage() {
      var _state5 = this.state,
          ariaLiveContext = _state5.ariaLiveContext,
          selectValue = _state5.selectValue,
          focusedValue = _state5.focusedValue,
          focusedOption = _state5.focusedOption;
      var _props6 = this.props,
          options = _props6.options,
          menuIsOpen = _props6.menuIsOpen,
          inputValue = _props6.inputValue,
          screenReaderStatus = _props6.screenReaderStatus;

      // An aria live message representing the currently focused value in the select.

      var focusedValueMsg = focusedValue ? valueFocusAriaMessage({ focusedValue: focusedValue, getOptionLabel: this.getOptionLabel, selectValue: selectValue }) : '';
      // An aria live message representing the currently focused option in the select.
      var focusedOptionMsg = focusedOption && menuIsOpen ? optionFocusAriaMessage({ focusedOption: focusedOption, getOptionLabel: this.getOptionLabel, options: options }) : '';
      // An aria live message representing the set of focusable results and current searchterm/inputvalue.
      var resultsMsg = resultsAriaMessage({ inputValue: inputValue, screenReaderMessage: screenReaderStatus({ count: this.countOptions() }) });

      return focusedValueMsg + ' ' + focusedOptionMsg + ' ' + resultsMsg + ' ' + ariaLiveContext;
    }
  }, {
    key: 'renderInput',
    value: function renderInput() {
      var _props7 = this.props,
          isDisabled = _props7.isDisabled,
          isSearchable = _props7.isSearchable,
          inputId = _props7.inputId,
          inputValue = _props7.inputValue,
          tabIndex = _props7.tabIndex;
      var Input$$1 = this.components.Input;
      var inputIsHidden = this.state.inputIsHidden;


      var id = inputId || this.getElementId('input');

      if (!isSearchable) {
        // use a dummy input to maintain focus/blur functionality
        return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(DummyInput, {
          id: id,
          innerRef: this.getInputRef,
          onBlur: this.onInputBlur,
          onChange: noop,
          onFocus: this.onInputFocus,
          readOnly: true,
          tabIndex: tabIndex,
          value: ''
        });
      }

      // aria attributes makes the JSX "noisy", separated for clarity
      var ariaAttributes = {
        'aria-autocomplete': 'list',
        'aria-label': this.props['aria-label'],
        'aria-labelledby': this.props['aria-labelledby']
      };

      var cx = this.commonProps.cx;


      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Input$$1, _extends({
        autoCapitalize: 'none',
        autoComplete: 'off',
        autoCorrect: 'off',
        cx: cx,
        getStyles: this.getStyles,
        id: id,
        innerRef: this.getInputRef,
        isDisabled: isDisabled,
        isHidden: inputIsHidden,
        onBlur: this.onInputBlur,
        onChange: this.handleInputChange,
        onFocus: this.onInputFocus,
        spellCheck: 'false',
        tabIndex: tabIndex,
        type: 'text',
        value: inputValue
      }, ariaAttributes));
    }
  }, {
    key: 'renderPlaceholderOrValue',
    value: function renderPlaceholderOrValue() {
      var _this4 = this;

      var _components = this.components,
          MultiValue = _components.MultiValue,
          MultiValueContainer = _components.MultiValueContainer,
          MultiValueLabel = _components.MultiValueLabel,
          MultiValueRemove = _components.MultiValueRemove,
          SingleValue = _components.SingleValue,
          Placeholder = _components.Placeholder;
      var commonProps = this.commonProps;
      var _props8 = this.props,
          controlShouldRenderValue = _props8.controlShouldRenderValue,
          isDisabled = _props8.isDisabled,
          isMulti = _props8.isMulti,
          inputValue = _props8.inputValue,
          placeholder = _props8.placeholder;
      var _state6 = this.state,
          selectValue = _state6.selectValue,
          focusedValue = _state6.focusedValue;


      if (!this.hasValue() || !controlShouldRenderValue) {
        return inputValue ? null : __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          Placeholder,
          _extends({}, commonProps, { key: 'placeholder', isDisabled: isDisabled }),
          placeholder
        );
      }

      if (isMulti) {
        var selectValues = selectValue.map(function (opt) {
          var isFocused = opt === focusedValue;
          return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            MultiValue,
            _extends({}, commonProps, {
              components: {
                Container: MultiValueContainer,
                Label: MultiValueLabel,
                Remove: MultiValueRemove
              },
              isFocused: isFocused,
              isDisabled: isDisabled,
              key: _this4.getOptionValue(opt),
              removeProps: {
                onClick: function onClick() {
                  return _this4.removeValue(opt);
                },
                onTouchEnd: function onTouchEnd() {
                  return _this4.removeValue(opt);
                },
                onMouseDown: function onMouseDown(e) {
                  e.preventDefault();
                  e.stopPropagation();
                }
              },
              data: opt
            }),
            _this4.formatOptionLabel(opt, 'value')
          );
        });
        return selectValues;
      }

      if (inputValue) {
        return null;
      }

      var singleValue = selectValue[0];
      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        SingleValue,
        _extends({}, commonProps, { data: singleValue, isDisabled: isDisabled }),
        this.formatOptionLabel(singleValue, 'value')
      );
    }
  }, {
    key: 'renderClearIndicator',
    value: function renderClearIndicator() {
      var ClearIndicator = this.components.ClearIndicator;
      var commonProps = this.commonProps;
      var _props9 = this.props,
          isDisabled = _props9.isDisabled,
          isLoading = _props9.isLoading;
      var isFocused = this.state.isFocused;


      if (!this.isClearable() || !ClearIndicator || isDisabled || !this.hasValue() || isLoading) {
        return null;
      }

      var innerProps = {
        onMouseDown: this.onClearIndicatorMouseDown,
        onTouchEnd: this.onClearIndicatorTouchEnd,
        'aria-hidden': 'true'
      };

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(ClearIndicator, _extends({}, commonProps, {
        innerProps: innerProps,
        isFocused: isFocused
      }));
    }
  }, {
    key: 'renderLoadingIndicator',
    value: function renderLoadingIndicator() {
      var LoadingIndicator = this.components.LoadingIndicator;
      var commonProps = this.commonProps;
      var _props10 = this.props,
          isDisabled = _props10.isDisabled,
          isLoading = _props10.isLoading;
      var isFocused = this.state.isFocused;


      if (!LoadingIndicator || !isLoading) return null;

      var innerProps = { 'aria-hidden': 'true' };
      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(LoadingIndicator, _extends({}, commonProps, {
        innerProps: innerProps,
        isDisabled: isDisabled,
        isFocused: isFocused
      }));
    }
  }, {
    key: 'renderIndicatorSeparator',
    value: function renderIndicatorSeparator() {
      var _components2 = this.components,
          DropdownIndicator = _components2.DropdownIndicator,
          IndicatorSeparator = _components2.IndicatorSeparator;

      // separator doesn't make sense without the dropdown indicator

      if (!DropdownIndicator || !IndicatorSeparator) return null;

      var commonProps = this.commonProps;
      var isDisabled = this.props.isDisabled;
      var isFocused = this.state.isFocused;


      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(IndicatorSeparator, _extends({}, commonProps, {
        isDisabled: isDisabled,
        isFocused: isFocused
      }));
    }
  }, {
    key: 'renderDropdownIndicator',
    value: function renderDropdownIndicator() {
      var DropdownIndicator = this.components.DropdownIndicator;

      if (!DropdownIndicator) return null;
      var commonProps = this.commonProps;
      var isDisabled = this.props.isDisabled;
      var isFocused = this.state.isFocused;


      var innerProps = {
        onMouseDown: this.onDropdownIndicatorMouseDown,
        onTouchEnd: this.onDropdownIndicatorTouchEnd,
        'aria-hidden': 'true'
      };

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(DropdownIndicator, _extends({}, commonProps, {
        innerProps: innerProps,
        isDisabled: isDisabled,
        isFocused: isFocused
      }));
    }
  }, {
    key: 'renderMenu',
    value: function renderMenu() {
      var _this5 = this;

      var _components3 = this.components,
          Group = _components3.Group,
          GroupHeading = _components3.GroupHeading,
          Menu = _components3.Menu,
          MenuList = _components3.MenuList,
          MenuPortal = _components3.MenuPortal,
          LoadingMessage = _components3.LoadingMessage,
          NoOptionsMessage = _components3.NoOptionsMessage,
          Option = _components3.Option;
      var commonProps = this.commonProps;
      var _state7 = this.state,
          focusedOption = _state7.focusedOption,
          menuOptions = _state7.menuOptions;
      var _props11 = this.props,
          captureMenuScroll = _props11.captureMenuScroll,
          inputValue = _props11.inputValue,
          isLoading = _props11.isLoading,
          loadingMessage = _props11.loadingMessage,
          minMenuHeight = _props11.minMenuHeight,
          maxMenuHeight = _props11.maxMenuHeight,
          menuIsOpen = _props11.menuIsOpen,
          menuPlacement = _props11.menuPlacement,
          menuPosition = _props11.menuPosition,
          menuPortalTarget = _props11.menuPortalTarget,
          menuShouldBlockScroll = _props11.menuShouldBlockScroll,
          menuShouldScrollIntoView = _props11.menuShouldScrollIntoView,
          noOptionsMessage = _props11.noOptionsMessage,
          onMenuScrollToTop = _props11.onMenuScrollToTop,
          onMenuScrollToBottom = _props11.onMenuScrollToBottom;


      if (!menuIsOpen) return null;

      // TODO: Internal Option Type here
      var render = function render(props) {
        // for performance, the menu options in state aren't changed when the
        // focused option changes so we calculate additional props based on that
        var isFocused = focusedOption === props.data;
        props.innerProps.innerRef = isFocused ? _this5.getFocusedOptionRef : undefined;

        return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          Option,
          _extends({}, commonProps, props, { isFocused: isFocused }),
          _this5.formatOptionLabel(props.data, 'menu')
        );
      };

      var menuUI = void 0;

      if (this.hasOptions()) {
        menuUI = menuOptions.render.map(function (item) {
          if (item.type === 'group') {
            var type = item.type,
                group = objectWithoutProperties(item, ['type']);

            var headingId = item.key + '-heading';

            return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              Group,
              _extends({}, commonProps, group, {
                Heading: GroupHeading,
                headingProps: {
                  id: headingId
                },
                label: _this5.formatGroupLabel(item.data)
              }),
              item.options.map(function (option) {
                return render(option);
              })
            );
          } else if (item.type === 'option') {
            return render(item);
          }
        });
      } else if (isLoading) {
        var message = loadingMessage({ inputValue: inputValue });
        if (message === null) return null;
        menuUI = __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          LoadingMessage,
          commonProps,
          message
        );
      } else {
        var _message = noOptionsMessage({ inputValue: inputValue });
        if (_message === null) return null;
        menuUI = __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          NoOptionsMessage,
          commonProps,
          _message
        );
      }

      var menuElement = __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          Menu,
          _extends({}, commonProps, {
            innerProps: {
              onMouseDown: this.onMenuMouseDown,
              onMouseMove: this.onMenuMouseMove
            },
            isLoading: isLoading,
            minMenuHeight: minMenuHeight,
            maxMenuHeight: maxMenuHeight,
            menuPlacement: menuPlacement,
            menuPosition: menuPosition,
            menuShouldScrollIntoView: menuShouldScrollIntoView
          }),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            ScrollCaptorSwitch,
            {
              isEnabled: captureMenuScroll,
              onTopArrive: onMenuScrollToTop,
              onBottomArrive: onMenuScrollToBottom
            },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              ScrollBlock,
              { isEnabled: menuShouldBlockScroll },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                MenuList,
                _extends({}, commonProps, {
                  innerProps: {
                    innerRef: this.getMenuListRef
                  },
                  isLoading: isLoading,
                  maxHeight: maxMenuHeight
                }),
                menuUI
              )
            )
          )
        )
      );

      // positioning behaviour is almost identical for portalled and fixed,
      // so we use the same component. the actual portalling logic is forked
      // within the component based on `menuPosition`
      return menuPortalTarget || menuPosition === 'fixed' ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        MenuPortal,
        _extends({}, commonProps, {
          appendTo: menuPortalTarget,
          controlElement: this.controlRef,
          menuPlacement: menuPlacement,
          menuPosition: menuPosition
        }),
        menuElement
      ) : menuElement;
    }
  }, {
    key: 'renderFormField',
    value: function renderFormField() {
      var _this6 = this;

      var _props12 = this.props,
          delimiter = _props12.delimiter,
          isDisabled = _props12.isDisabled,
          isMulti = _props12.isMulti,
          name = _props12.name;
      var selectValue = this.state.selectValue;


      if (!name || isDisabled) return;

      if (isMulti) {
        if (delimiter) {
          var _value = selectValue.map(function (opt) {
            return _this6.getOptionValue(opt);
          }).join(delimiter);
          return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input', { name: name, type: 'hidden', value: _value });
        } else {
          return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            null,
            selectValue.map(function (opt, i) {
              return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input', {
                key: 'i-' + i,
                name: name,
                type: 'hidden',
                value: _this6.getOptionValue(opt)
              });
            })
          );
        }
      } else {
        var _value2 = selectValue[0] ? this.getOptionValue(selectValue[0]) : '';
        return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input', { name: name, type: 'hidden', value: _value2 });
      }
    }
  }, {
    key: 'renderLiveRegion',
    value: function renderLiveRegion() {
      if (!this.state.isFocused) return null;
      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        A11yText,
        { 'aria-live': 'assertive' },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'p',
          { id: 'aria-selection-event' },
          '\xA0',
          this.state.ariaLiveSelection
        ),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'p',
          { id: 'aria-context' },
          '\xA0',
          this.constructAriaLiveMessage()
        )
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _components4 = this.components,
          Control = _components4.Control,
          IndicatorsContainer = _components4.IndicatorsContainer,
          SelectContainer = _components4.SelectContainer,
          ValueContainer = _components4.ValueContainer;
      var _props13 = this.props,
          className = _props13.className,
          id = _props13.id,
          isDisabled = _props13.isDisabled;
      var isFocused = this.state.isFocused;


      var commonProps = this.commonProps = this.getCommonProps();

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        SelectContainer,
        _extends({}, commonProps, {
          className: className,
          innerProps: {
            id: id,
            onKeyDown: this.onKeyDown
          },
          isDisabled: isDisabled,
          isFocused: isFocused
        }),
        this.renderLiveRegion(),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          Control,
          _extends({}, commonProps, {
            innerProps: {
              innerRef: this.getControlRef,
              onMouseDown: this.onControlMouseDown,
              onTouchEnd: this.onControlTouchEnd
            },
            isDisabled: isDisabled,
            isFocused: isFocused
          }),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            ValueContainer,
            _extends({}, commonProps, { isDisabled: isDisabled }),
            this.renderPlaceholderOrValue(),
            this.renderInput()
          ),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            IndicatorsContainer,
            _extends({}, commonProps, { isDisabled: isDisabled }),
            this.renderClearIndicator(),
            this.renderLoadingIndicator(),
            this.renderIndicatorSeparator(),
            this.renderDropdownIndicator()
          )
        ),
        this.renderMenu(),
        this.renderFormField()
      );
    }
  }]);
  return Select;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);

Select.defaultProps = defaultProps;

var _initialiseProps = function _initialiseProps() {
  var _this7 = this;

  this.state = {
    ariaLiveSelection: '',
    ariaLiveContext: '',
    focusedOption: null,
    focusedValue: null,
    inputIsHidden: false,
    isFocused: false,
    menuOptions: { render: [], focusable: [] },
    selectValue: []
  };
  this.blockOptionHover = false;
  this.clearFocusValueOnUpdate = false;
  this.hasGroups = false;
  this.initialTouchX = 0;
  this.initialTouchY = 0;
  this.instancePrefix = '';
  this.openAfterFocus = false;
  this.scrollToFocusedOptionOnUpdate = false;
  this.controlRef = null;

  this.getControlRef = function (ref) {
    _this7.controlRef = ref;
  };

  this.focusedOptionRef = null;

  this.getFocusedOptionRef = function (ref) {
    _this7.focusedOptionRef = ref;
  };

  this.menuListRef = null;

  this.getMenuListRef = function (ref) {
    _this7.menuListRef = ref;
  };

  this.inputRef = null;

  this.getInputRef = function (ref) {
    _this7.inputRef = ref;
  };

  this.focus = this.focusInput;
  this.blur = this.blurInput;

  this.setValue = function (newValue) {
    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'set-value';
    var option = arguments[2];
    var _props14 = _this7.props,
        closeMenuOnSelect = _props14.closeMenuOnSelect,
        isMulti = _props14.isMulti,
        onChange = _props14.onChange;

    _this7.onInputChange('', { action: 'set-value' });
    if (closeMenuOnSelect) {
      _this7.inputIsHiddenAfterUpdate = !isMulti;
      _this7.onMenuClose();
    }
    // when the select value should change, we should reset focusedValue
    _this7.clearFocusValueOnUpdate = true;
    onChange(newValue, { action: action, option: option });
  };

  this.selectOption = function (newValue) {
    var _props15 = _this7.props,
        blurInputOnSelect = _props15.blurInputOnSelect,
        isMulti = _props15.isMulti;


    if (isMulti) {
      var _selectValue3 = _this7.state.selectValue;

      if (_this7.isOptionSelected(newValue, _selectValue3)) {
        var candidate = _this7.getOptionValue(newValue);
        _this7.setValue(_selectValue3.filter(function (i) {
          return _this7.getOptionValue(i) !== candidate;
        }), 'deselect-option', newValue);
        _this7.announceAriaLiveSelection({ event: 'deselect-option', context: { value: _this7.getOptionLabel(newValue) } });
      } else {

        _this7.setValue([].concat(toConsumableArray(_selectValue3), [newValue]), 'select-option', newValue);
        _this7.announceAriaLiveSelection({ event: 'select-option', context: { value: _this7.getOptionLabel(newValue) } });
      }
    } else {
      _this7.setValue(newValue, 'select-option');
      _this7.announceAriaLiveSelection({ event: 'select-option', context: { value: _this7.getOptionLabel(newValue) } });
    }

    if (blurInputOnSelect) {
      _this7.blurInput();
    }
  };

  this.removeValue = function (removedValue) {
    var onChange = _this7.props.onChange;
    var selectValue = _this7.state.selectValue;

    var candidate = _this7.getOptionValue(removedValue);
    onChange(selectValue.filter(function (i) {
      return _this7.getOptionValue(i) !== candidate;
    }), {
      action: 'remove-value',
      removedValue: removedValue
    });
    _this7.announceAriaLiveSelection({ event: 'remove-value', context: { value: removedValue ? _this7.getOptionLabel(removedValue) : undefined } });
    _this7.focusInput();
  };

  this.clearValue = function () {
    var _props16 = _this7.props,
        isMulti = _props16.isMulti,
        onChange = _props16.onChange;

    onChange(isMulti ? [] : null, { action: 'clear' });
  };

  this.popValue = function () {
    var onChange = _this7.props.onChange;
    var selectValue = _this7.state.selectValue;

    var lastSelectedValue = selectValue[selectValue.length - 1];
    _this7.announceAriaLiveSelection({ event: 'pop-value', context: { value: lastSelectedValue ? _this7.getOptionLabel(lastSelectedValue) : undefined } });
    onChange(selectValue.slice(0, selectValue.length - 1), {
      action: 'pop-value',
      removedValue: lastSelectedValue
    });
  };

  this.getOptionLabel = function (data) {
    return _this7.props.getOptionLabel(data);
  };

  this.getOptionValue = function (data) {
    return _this7.props.getOptionValue(data);
  };

  this.getStyles = function (key, props) {
    var base = defaultStyles[key](props);
    base.boxSizing = 'border-box';
    var custom = _this7.props.styles[key];
    return custom ? custom(base, props) : base;
  };

  this.getElementId = function (element) {
    return _this7.instancePrefix + '-' + element;
  };

  this.getActiveDescendentId = function () {
    var menuIsOpen = _this7.props.menuIsOpen;
    var _state8 = _this7.state,
        menuOptions = _state8.menuOptions,
        focusedOption = _state8.focusedOption;


    if (!focusedOption || !menuIsOpen) return undefined;

    var index = menuOptions.focusable.indexOf(focusedOption);
    var option = menuOptions.render[index];

    return option && option.key;
  };

  this.announceAriaLiveSelection = function (_ref2) {
    var event = _ref2.event,
        context = _ref2.context;

    _this7.setState({
      ariaLiveSelection: valueEventAriaMessage(event, context)
    });
  };

  this.announceAriaLiveContext = function (_ref3) {
    var event = _ref3.event,
        context = _ref3.context;

    _this7.setState({
      ariaLiveContext: instructionsAriaMessage(event, _extends({}, context, { label: _this7.props['aria-label'] }))
    });
  };

  this.onMenuMouseDown = function (event) {
    if (event.button !== 0) {
      return;
    }
    event.stopPropagation();
    event.preventDefault();
    _this7.focusInput();
  };

  this.onMenuMouseMove = function (event) {
    _this7.blockOptionHover = false;
  };

  this.onControlMouseDown = function (event) {
    var openMenuOnClick = _this7.props.openMenuOnClick;

    if (!_this7.state.isFocused) {
      if (openMenuOnClick) {
        _this7.openAfterFocus = true;
      }
      _this7.focusInput();
    } else if (!_this7.props.menuIsOpen) {
      _this7.openMenu('first');
    } else {
      _this7.onMenuClose();
    }
    // $FlowFixMe HTMLElement type does not have tagName property
    if (event.target.tagName !== 'INPUT') {
      event.preventDefault();
    }
  };

  this.onDropdownIndicatorMouseDown = function (event) {
    // ignore mouse events that weren't triggered by the primary button
    if (event && event.type === 'mousedown' && event.button !== 0) {
      return;
    }
    if (_this7.props.isDisabled) return;
    var _props17 = _this7.props,
        isMulti = _props17.isMulti,
        menuIsOpen = _props17.menuIsOpen;

    _this7.focusInput();
    if (menuIsOpen) {
      _this7.inputIsHiddenAfterUpdate = !isMulti;
      _this7.onMenuClose();
    } else {
      _this7.openMenu('first');
    }
    event.preventDefault();
    event.stopPropagation();
  };

  this.onClearIndicatorMouseDown = function (event) {
    // ignore mouse events that weren't triggered by the primary button
    if (event && event.type === 'mousedown' && event.button !== 0) {
      return;
    }
    _this7.clearValue();
    event.stopPropagation();
    _this7.openAfterFocus = false;
    setTimeout(function () {
      return _this7.focusInput();
    });
  };

  this.onTouchStart = function (_ref4) {
    var _ref4$touches = slicedToArray(_ref4.touches, 1),
        touch = _ref4$touches[0];

    _this7.initialTouchX = touch.clientX;
    _this7.initialTouchY = touch.clientY;
    _this7.userIsDragging = false;
  };

  this.onTouchMove = function (_ref5) {
    var _ref5$touches = slicedToArray(_ref5.touches, 1),
        touch = _ref5$touches[0];

    var deltaX = Math.abs(touch.clientX - _this7.initialTouchX);
    var deltaY = Math.abs(touch.clientY - _this7.initialTouchY);
    var moveThreshold = 5;

    _this7.userIsDragging = deltaX > moveThreshold || deltaY > moveThreshold;
  };

  this.onTouchEnd = function (event) {
    if (_this7.userIsDragging) return;

    // type cast the EventTarget
    var target = event.target;

    // close the menu if the user taps outside
    if (_this7.controlRef && !_this7.controlRef.contains(target) && _this7.menuListRef && !_this7.menuListRef.contains(target)) {
      _this7.blurInput();
    }

    // reset move vars
    _this7.initialTouchX = 0;
    _this7.initialTouchY = 0;
  };

  this.onControlTouchEnd = function (event) {
    if (_this7.userIsDragging) return;

    _this7.onControlMouseDown(event);
  };

  this.onClearIndicatorTouchEnd = function (event) {
    if (_this7.userIsDragging) return;

    _this7.onClearIndicatorMouseDown(event);
  };

  this.onDropdownIndicatorTouchEnd = function (event) {
    if (_this7.userIsDragging) return;

    _this7.onDropdownIndicatorMouseDown(event);
  };

  this.handleInputChange = function (event) {
    var inputValue = event.currentTarget.value;
    _this7.inputIsHiddenAfterUpdate = false;
    _this7.onInputChange(inputValue, { action: 'input-change' });
    _this7.onMenuOpen();
  };

  this.onInputFocus = function (event) {
    var _props18 = _this7.props,
        isSearchable = _props18.isSearchable,
        isMulti = _props18.isMulti;

    if (_this7.props.onFocus) {
      _this7.props.onFocus(event);
    }
    _this7.inputIsHiddenAfterUpdate = false;
    _this7.announceAriaLiveContext({ event: 'input', context: { isSearchable: isSearchable, isMulti: isMulti } });
    _this7.setState({
      isFocused: true
    });
    if (_this7.openAfterFocus || _this7.props.openMenuOnFocus) {
      _this7.openMenu('first');
    }
    _this7.openAfterFocus = false;
  };

  this.onInputBlur = function (event) {
    if (_this7.props.onBlur) {
      _this7.props.onBlur(event);
    }
    _this7.onInputChange('', { action: 'input-blur' });
    _this7.onMenuClose();
    _this7.setState({
      focusedValue: null,
      isFocused: false
    });
  };

  this.onOptionHover = function (focusedOption) {
    if (_this7.blockOptionHover || _this7.state.focusedOption === focusedOption) {
      return;
    }
    _this7.setState({ focusedOption: focusedOption });
  };

  this.shouldHideSelectedOptions = function () {
    var _props19 = _this7.props,
        hideSelectedOptions = _props19.hideSelectedOptions,
        isMulti = _props19.isMulti;

    if (hideSelectedOptions === undefined) return isMulti;
    return hideSelectedOptions;
  };

  this.onKeyDown = function (event) {
    var _props20 = _this7.props,
        isMulti = _props20.isMulti,
        backspaceRemovesValue = _props20.backspaceRemovesValue,
        escapeClearsValue = _props20.escapeClearsValue,
        inputValue = _props20.inputValue,
        isClearable = _props20.isClearable,
        isDisabled = _props20.isDisabled,
        menuIsOpen = _props20.menuIsOpen,
        onKeyDown = _props20.onKeyDown,
        tabSelectsValue = _props20.tabSelectsValue,
        openMenuOnFocus = _props20.openMenuOnFocus;
    var _state9 = _this7.state,
        focusedOption = _state9.focusedOption,
        focusedValue = _state9.focusedValue,
        selectValue = _state9.selectValue;


    if (isDisabled) return;

    if (typeof onKeyDown === 'function') {
      onKeyDown(event);
      if (event.defaultPrevented) {
        return;
      }
    }

    // Block option hover events when the user has just pressed a key
    _this7.blockOptionHover = true;
    switch (event.key) {
      case 'ArrowLeft':
        if (!isMulti || inputValue) return;
        _this7.focusValue('previous');
        break;
      case 'ArrowRight':
        if (!isMulti || inputValue) return;
        _this7.focusValue('next');
        break;
      case 'Backspace':
        if (inputValue) return;
        if (focusedValue) {
          _this7.removeValue(focusedValue);
        } else {
          if (!backspaceRemovesValue) return;
          _this7.popValue();
        }
        break;
      case 'Tab':
        if (event.shiftKey || !menuIsOpen || !tabSelectsValue || !focusedOption ||
        // don't capture the event if the menu opens on focus and the focused
        // option is already selected; it breaks the flow of navigation
        openMenuOnFocus && _this7.isOptionSelected(focusedOption, selectValue)) {
          return;
        }
        _this7.selectOption(focusedOption);
        break;
      case 'Enter':
        if (menuIsOpen) {
          if (!focusedOption) return;
          _this7.selectOption(focusedOption);
        } else {
          _this7.focusOption('first');
        }
        break;
      case 'Escape':
        if (menuIsOpen) {
          _this7.inputIsHiddenAfterUpdate = false;
          _this7.onInputChange('', { action: 'menu-close' });
          _this7.onMenuClose();
        } else if (isClearable && escapeClearsValue) {
          _this7.clearValue();
        }
        break;
      case ' ':
        // space
        if (inputValue) {
          return;
        }
        if (!menuIsOpen) {
          _this7.openMenu('first');
          break;
        }
        if (!focusedOption) return;
        _this7.selectOption(focusedOption);
        break;
      case 'ArrowUp':
        if (menuIsOpen) {
          _this7.focusOption('up');
        } else {
          _this7.openMenu('last');
        }
        break;
      case 'ArrowDown':
        if (menuIsOpen) {
          _this7.focusOption('down');
        } else {
          _this7.openMenu('first');
        }
        break;
      case 'PageUp':
        if (!menuIsOpen) return;
        _this7.focusOption('pageup');
        break;
      case 'PageDown':
        if (!menuIsOpen) return;
        _this7.focusOption('pagedown');
        break;
      case 'Home':
        if (!menuIsOpen) return;
        _this7.focusOption('first');
        break;
      case 'End':
        if (!menuIsOpen) return;
        _this7.focusOption('last');
        break;
      default:
        return;
    }
    event.preventDefault();
  };
};

var manageState = function manageState(SelectComponent) {
  var _class, _temp2;

  return _temp2 = _class = function (_Component) {
    inherits(StateManager, _Component);

    function StateManager() {
      var _ref;

      var _temp, _this, _ret;

      classCallCheck(this, StateManager);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = possibleConstructorReturn(this, (_ref = StateManager.__proto__ || Object.getPrototypeOf(StateManager)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
        inputValue: _this.props.inputValue !== undefined ? _this.props.inputValue : _this.props.defaultInputValue,
        menuIsOpen: _this.props.menuIsOpen !== undefined ? _this.props.menuIsOpen : _this.props.defaultMenuIsOpen,
        value: _this.props.value !== undefined ? _this.props.value : _this.props.defaultValue
      }, _this.onChange = function (value, actionMeta) {
        _this.callProp('onChange', value, actionMeta);
        _this.setState({ value: value });
      }, _this.onInputChange = function (value, actionMeta) {
        // TODO: for backwards compatibility, we allow the prop to return a new
        // value, but now inputValue is a controllable prop we probably shouldn't
        var newValue = _this.callProp('onInputChange', value, actionMeta);
        _this.setState({
          inputValue: newValue !== undefined ? newValue : value
        });
      }, _this.onMenuOpen = function () {
        _this.callProp('onMenuOpen');
        _this.setState({ menuIsOpen: true });
      }, _this.onMenuClose = function () {
        _this.callProp('onMenuClose');
        _this.setState({ menuIsOpen: false });
      }, _temp), possibleConstructorReturn(_this, _ret);
    }

    createClass(StateManager, [{
      key: 'focus',
      value: function focus() {
        this.select.focus();
      }
    }, {
      key: 'blur',
      value: function blur() {
        this.select.blur();
      }
    }, {
      key: 'getProp',
      value: function getProp(key) {
        return this.props[key] !== undefined ? this.props[key] : this.state[key];
      }
    }, {
      key: 'callProp',
      value: function callProp(name) {
        if (typeof this.props[name] === 'function') {
          var _props;

          for (var _len2 = arguments.length, args = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
            args[_key2 - 1] = arguments[_key2];
          }

          return (_props = this.props)[name].apply(_props, toConsumableArray(args));
        }
      }
    }, {
      key: 'render',
      value: function render() {
        var _this2 = this;

        return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(SelectComponent, _extends({}, this.props, {
          ref: function ref(_ref2) {
            _this2.select = _ref2;
          },
          inputValue: this.getProp('inputValue'),
          menuIsOpen: this.getProp('menuIsOpen'),
          onChange: this.onChange,
          onInputChange: this.onInputChange,
          onMenuClose: this.onMenuClose,
          onMenuOpen: this.onMenuOpen,
          value: this.getProp('value')
        }));
      }
    }]);
    return StateManager;
  }(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]), _class.defaultProps = {
    defaultInputValue: '',
    defaultMenuIsOpen: false,
    defaultValue: null
  }, _temp2;
};

var defaultProps$1 = {
  cacheOptions: false,
  defaultOptions: false
};

var makeAsyncSelect = function makeAsyncSelect(SelectComponent) {
  var _class, _temp;

  return _temp = _class = function (_Component) {
    inherits(Async, _Component);

    function Async(props) {
      classCallCheck(this, Async);

      var _this = possibleConstructorReturn(this, (Async.__proto__ || Object.getPrototypeOf(Async)).call(this));

      _this.mounted = false;
      _this.optionsCache = {};

      _this.handleInputChange = function (newValue, actionMeta) {
        var _this$props = _this.props,
            cacheOptions = _this$props.cacheOptions,
            onInputChange = _this$props.onInputChange;
        // TODO

        var inputValue = handleInputChange(newValue, actionMeta, onInputChange);
        if (!inputValue) {
          delete _this.lastRequest;
          _this.setState({
            inputValue: '',
            loadedInputValue: '',
            loadedOptions: [],
            isLoading: false,
            passEmptyOptions: false
          });
          return;
        }
        if (cacheOptions && _this.optionsCache[inputValue]) {
          _this.setState({
            inputValue: inputValue,
            loadedInputValue: inputValue,
            loadedOptions: _this.optionsCache[inputValue],
            isLoading: false,
            passEmptyOptions: false
          });
        } else {
          var request = _this.lastRequest = {};
          _this.setState({
            inputValue: inputValue,
            isLoading: true,
            passEmptyOptions: !_this.state.loadedInputValue
          }, function () {
            _this.loadOptions(inputValue, function (options) {
              if (!_this.mounted) return;
              if (options) {
                _this.optionsCache[inputValue] = options;
              }
              if (request !== _this.lastRequest) return;
              delete _this.lastRequest;
              _this.setState({
                isLoading: false,
                loadedInputValue: inputValue,
                loadedOptions: options || [],
                passEmptyOptions: false
              });
            });
          });
        }
        return inputValue;
      };

      _this.state = {
        defaultOptions: Array.isArray(props.defaultOptions) ? props.defaultOptions : undefined,
        inputValue: '',
        isLoading: props.defaultOptions === true ? true : false,
        loadedOptions: [],
        passEmptyOptions: false
      };
      return _this;
    }

    createClass(Async, [{
      key: 'componentDidMount',
      value: function componentDidMount() {
        var _this2 = this;

        this.mounted = true;
        var defaultOptions = this.props.defaultOptions;

        if (defaultOptions === true) {
          this.loadOptions('', function (options) {
            if (!_this2.mounted) return;
            var isLoading = !!_this2.lastRequest;
            _this2.setState({ defaultOptions: options || [], isLoading: isLoading });
          });
        }
      }
    }, {
      key: 'componentWillReceiveProps',
      value: function componentWillReceiveProps(nextProps) {
        // if the cacheOptions prop changes, clear the cache
        if (nextProps.cacheOptions !== this.props.cacheOptions) {
          this.optionsCache = {};
        }
      }
    }, {
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        this.mounted = false;
      }
    }, {
      key: 'focus',
      value: function focus() {
        this.select.focus();
      }
    }, {
      key: 'blur',
      value: function blur() {
        this.select.blur();
      }
    }, {
      key: 'loadOptions',
      value: function loadOptions(inputValue, callback) {
        var loadOptions = this.props.loadOptions;

        if (!loadOptions) return callback();
        var loader = loadOptions(inputValue, callback);
        if (loader && typeof loader.then === 'function') {
          loader.then(callback, function () {
            return callback();
          });
        }
      }
    }, {
      key: 'render',
      value: function render() {
        var _this3 = this;

        var _props = this.props,
            loadOptions = _props.loadOptions,
            props = objectWithoutProperties(_props, ['loadOptions']);
        var _state = this.state,
            defaultOptions = _state.defaultOptions,
            inputValue = _state.inputValue,
            isLoading = _state.isLoading,
            loadedInputValue = _state.loadedInputValue,
            loadedOptions = _state.loadedOptions,
            passEmptyOptions = _state.passEmptyOptions;

        var options = passEmptyOptions ? [] : inputValue && loadedInputValue ? loadedOptions : defaultOptions || [];
        return (
          // $FlowFixMe
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(SelectComponent, _extends({}, props, {
            ref: function ref(_ref) {
              _this3.select = _ref;
            },
            options: options,
            filterOption: null,
            isLoading: isLoading,
            onInputChange: this.handleInputChange
          }))
        );
      }
    }]);
    return Async;
  }(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]), _class.defaultProps = defaultProps$1, _temp;
};
var Async = makeAsyncSelect(manageState(Select));

var compareOption = function compareOption(inputValue, option) {
  var candidate = inputValue.toLowerCase();
  return option.value.toLowerCase() === candidate || option.label.toLowerCase() === candidate;
};

var builtins = {
  formatCreateLabel: function formatCreateLabel(inputValue) {
    return 'Create "' + inputValue + '"';
  },
  isValidNewOption: function isValidNewOption(inputValue, selectValue, selectOptions) {
    return !(!inputValue || selectValue.some(function (option) {
      return compareOption(inputValue, option);
    }) || selectOptions.some(function (option) {
      return compareOption(inputValue, option);
    }));
  },
  getNewOptionData: function getNewOptionData(inputValue, optionLabel) {
    return {
      label: optionLabel,
      value: inputValue,
      __isNew__: true
    };
  }
};

var defaultProps$2 = _extends({
  allowCreateWhileLoading: false,
  createOptionPosition: 'last'
}, builtins);

var makeCreatableSelect = function makeCreatableSelect(SelectComponent) {
  var _class, _temp;

  return _temp = _class = function (_Component) {
    inherits(Creatable, _Component);

    function Creatable(props) {
      classCallCheck(this, Creatable);

      var _this = possibleConstructorReturn(this, (Creatable.__proto__ || Object.getPrototypeOf(Creatable)).call(this, props));

      _this.onChange = function (newValue, actionMeta) {
        var _this$props = _this.props,
            getNewOptionData = _this$props.getNewOptionData,
            inputValue = _this$props.inputValue,
            isMulti = _this$props.isMulti,
            onChange = _this$props.onChange,
            onCreateOption = _this$props.onCreateOption,
            value = _this$props.value;

        if (actionMeta.action !== 'select-option') {
          return onChange(newValue, actionMeta);
        }
        var newOption = _this.state.newOption;

        var valueArray = Array.isArray(newValue) ? newValue : [newValue];

        if (valueArray[valueArray.length - 1] === newOption) {
          if (onCreateOption) onCreateOption(inputValue);else {
            var newOptionData = getNewOptionData(inputValue, inputValue);
            var newActionMeta = { action: 'create-option' };
            if (isMulti) {
              onChange([].concat(toConsumableArray(cleanValue(value)), [newOptionData]), newActionMeta);
            } else {
              onChange(newOptionData, newActionMeta);
            }
          }
          return;
        }
        onChange(newValue, actionMeta);
      };

      var options = props.options || [];
      _this.state = {
        newOption: undefined,
        options: options
      };
      return _this;
    }

    createClass(Creatable, [{
      key: 'componentWillReceiveProps',
      value: function componentWillReceiveProps(nextProps) {
        var allowCreateWhileLoading = nextProps.allowCreateWhileLoading,
            createOptionPosition = nextProps.createOptionPosition,
            formatCreateLabel = nextProps.formatCreateLabel,
            getNewOptionData = nextProps.getNewOptionData,
            inputValue = nextProps.inputValue,
            isLoading = nextProps.isLoading,
            isValidNewOption = nextProps.isValidNewOption,
            value = nextProps.value;

        var options = nextProps.options || [];
        var newOption = this.state.newOption;

        if (isValidNewOption(inputValue, cleanValue(value), options)) {
          newOption = getNewOptionData(inputValue, formatCreateLabel(inputValue));
        } else {
          newOption = undefined;
        }
        this.setState({
          newOption: newOption,
          options: (allowCreateWhileLoading || !isLoading) && newOption ? createOptionPosition === 'first' ? [newOption].concat(toConsumableArray(options)) : [].concat(toConsumableArray(options), [newOption]) : options
        });
      }
    }, {
      key: 'focus',
      value: function focus() {
        this.select.focus();
      }
    }, {
      key: 'blur',
      value: function blur() {
        this.select.blur();
      }
    }, {
      key: 'render',
      value: function render() {
        var _this2 = this;

        var props = objectWithoutProperties(this.props, []);
        var options = this.state.options;

        return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(SelectComponent, _extends({}, props, {
          ref: function ref(_ref) {
            _this2.select = _ref;
          },
          options: options,
          onChange: this.onChange
        }));
      }
    }]);
    return Creatable;
  }(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]), _class.defaultProps = defaultProps$2, _temp;
};
var Creatable = manageState(makeCreatableSelect(Select));

var AsyncCreatable = makeAsyncSelect(manageState(makeCreatableSelect(Select)));

// ==============================
// Fade Transition
// ==============================

var Fade = function Fade(_ref) {
  var Tag = _ref.component,
      _ref$duration = _ref.duration,
      duration = _ref$duration === undefined ? 1 : _ref$duration,
      inProp = _ref.in,
      onExited = _ref.onExited,
      props = objectWithoutProperties(_ref, ['component', 'duration', 'in', 'onExited']);

  var transition = {
    entering: { opacity: 0 },
    entered: { opacity: 1, transition: 'opacity ' + duration + 'ms' },
    exiting: { opacity: 0 },
    exited: { opacity: 0 }
  };

  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_6_react_transition_group__["Transition"],
    { mountOnEnter: true, unmountOnExit: true, 'in': inProp, timeout: duration },
    function (state) {
      var innerProps = {
        style: _extends({}, transition[state])
      };
      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Tag, _extends({ innerProps: innerProps }, props));
    }
  );
};
var collapseDuration = 260;

// wrap each MultiValue with a collapse transition; decreases width until
// finally removing from DOM
var Collapse = function (_Component) {
  inherits(Collapse, _Component);

  function Collapse() {
    var _ref2;

    var _temp, _this, _ret;

    classCallCheck(this, Collapse);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn(this, (_ref2 = Collapse.__proto__ || Object.getPrototypeOf(Collapse)).call.apply(_ref2, [this].concat(args))), _this), _this.duration = collapseDuration, _this.state = { width: 'auto' }, _this.transition = {
      exiting: { width: 0, transition: 'width ' + _this.duration + 'ms ease-out' },
      exited: { width: 0 }
    }, _this.getWidth = function (ref) {
      if (ref && isNaN(_this.state.width)) {
        // cannot use `offsetWidth` because it is rounded
        var _ref$getBoundingClien = ref.getBoundingClientRect(),
            _width = _ref$getBoundingClien.width;

        _this.setState({ width: _width });
      }
    }, _this.getStyle = function (width) {
      return {
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        width: width
      };
    }, _this.getTransition = function (state) {
      return _this.transition[state];
    }, _temp), possibleConstructorReturn(_this, _ret);
  }

  // width must be calculated; cannot transition from `undefined` to `number`


  // get base styles


  // get transition styles


  createClass(Collapse, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          children = _props.children,
          inProp = _props.in;
      var width = this.state.width;


      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_6_react_transition_group__["Transition"],
        {
          enter: false,
          mountOnEnter: true,
          unmountOnExit: true,
          'in': inProp,
          timeout: this.duration
        },
        function (state) {
          var style = _extends({}, _this2.getStyle(width), _this2.getTransition(state));
          return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            { ref: _this2.getWidth, style: style },
            children
          );
        }
      );
    }
  }]);
  return Collapse;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);

// strip transition props off before spreading onto select component
// note we need to be explicit about innerRef for flow
var AnimatedInput = function AnimatedInput(WrappedComponent) {
  return function (_ref) {
    var inProp = _ref.in,
        onExited = _ref.onExited,
        appear = _ref.appear,
        enter = _ref.enter,
        exit = _ref.exit,
        innerRef = _ref.innerRef,
        props = objectWithoutProperties(_ref, ['in', 'onExited', 'appear', 'enter', 'exit', 'innerRef']);
    return (
      // $FlowFixMe
      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(WrappedComponent, _extends({ innerRef: innerRef }, props))
    );
  };
};

// strip transition props off before spreading onto actual component


var AnimatedMultiValue = function AnimatedMultiValue(WrappedComponent) {
  return function (_ref) {
    var inProp = _ref.in,
        onExited = _ref.onExited,
        props = objectWithoutProperties(_ref, ['in', 'onExited']);
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
      Collapse,
      { 'in': inProp, onExited: onExited },
      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(WrappedComponent, _extends({ cropWithEllipsis: inProp }, props))
    );
  };
};

// fade in when last multi-value removed, otherwise instant
var AnimatedPlaceholder = function AnimatedPlaceholder(WrappedComponent) {
  return function (props) {
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Fade, _extends({
      component: WrappedComponent,
      duration: props.isMulti ? collapseDuration : 1
    }, props));
  };
};

// instant fade; all transition-group children must be transitions

var AnimatedSingleValue = function AnimatedSingleValue(WrappedComponent) {
  return function (props) {
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Fade, _extends({ component: WrappedComponent }, props));
  };
};

// make ValueContainer a transition group
var AnimatedValueContainer = function AnimatedValueContainer(WrappedComponent) {
  return function (props) {
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_transition_group__["TransitionGroup"], _extends({ component: WrappedComponent }, props));
  };
};

var makeAnimated = function makeAnimated(externalComponents) {
  var components$$1 = defaultComponents({ components: externalComponents });
  var Input = components$$1.Input,
      MultiValue = components$$1.MultiValue,
      Placeholder = components$$1.Placeholder,
      SingleValue = components$$1.SingleValue,
      ValueContainer = components$$1.ValueContainer,
      rest = objectWithoutProperties(components$$1, ['Input', 'MultiValue', 'Placeholder', 'SingleValue', 'ValueContainer']);

  return _extends({
    Input: AnimatedInput(Input),
    MultiValue: AnimatedMultiValue(MultiValue),
    Placeholder: AnimatedPlaceholder(Placeholder),
    SingleValue: AnimatedSingleValue(SingleValue),
    ValueContainer: AnimatedValueContainer(ValueContainer)
  }, rest);
};

var AnimatedComponents = makeAnimated();

var Input$2 = AnimatedComponents.Input;
var MultiValue$1 = AnimatedComponents.MultiValue;
var Placeholder$1 = AnimatedComponents.Placeholder;
var SingleValue$1 = AnimatedComponents.SingleValue;
var ValueContainer$1 = AnimatedComponents.ValueContainer;

var index = manageState(Select);

/* harmony default export */ __webpack_exports__["a"] = (index);



/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ValueContainer = exports.SingleValue = exports.Placeholder = exports.MultiValue = exports.Input = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _index = __webpack_require__(603);

var _Input = __webpack_require__(610);

var _Input2 = _interopRequireDefault(_Input);

var _MultiValue = __webpack_require__(611);

var _MultiValue2 = _interopRequireDefault(_MultiValue);

var _Placeholder = __webpack_require__(612);

var _Placeholder2 = _interopRequireDefault(_Placeholder);

var _SingleValue = __webpack_require__(613);

var _SingleValue2 = _interopRequireDefault(_SingleValue);

var _ValueContainer = __webpack_require__(614);

var _ValueContainer2 = _interopRequireDefault(_ValueContainer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var makeAnimated = function makeAnimated(externalComponents) {
  var components = (0, _index.defaultComponents)({ components: externalComponents });

  var Input = components.Input,
      MultiValue = components.MultiValue,
      Placeholder = components.Placeholder,
      SingleValue = components.SingleValue,
      ValueContainer = components.ValueContainer,
      rest = _objectWithoutProperties(components, ['Input', 'MultiValue', 'Placeholder', 'SingleValue', 'ValueContainer']);

  return _extends({
    Input: (0, _Input2.default)(Input),
    MultiValue: (0, _MultiValue2.default)(MultiValue),
    Placeholder: (0, _Placeholder2.default)(Placeholder),
    SingleValue: (0, _SingleValue2.default)(SingleValue),
    ValueContainer: (0, _ValueContainer2.default)(ValueContainer)
  }, rest);
};

var AnimatedComponents = makeAnimated();

var Input = exports.Input = AnimatedComponents.Input;
var MultiValue = exports.MultiValue = AnimatedComponents.MultiValue;
var Placeholder = exports.Placeholder = AnimatedComponents.Placeholder;
var SingleValue = exports.SingleValue = AnimatedComponents.SingleValue;
var ValueContainer = exports.ValueContainer = AnimatedComponents.ValueContainer;

exports.default = makeAnimated;

/***/ }),
/* 105 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export buscarEmpresaFechado */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return fetchCargasEGeracao; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return fetchCompanies; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getBreakEven; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getCativoInfo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getCompanyInfo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return getCurvaPerfisAgentes; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__routes__ = __webpack_require__(53);
var buscarEmpresaFechado=function buscarEmpresaFechado(q){return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_1__routes__["a" /* default */].companies.buscarEmpresaFechado(q));};var fetchCargasEGeracao=function fetchCargasEGeracao(companyId){return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_1__routes__["a" /* default */].companies.fetchCargasEGeracao(companyId));};var fetchCompanies=function fetchCompanies(){return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_1__routes__["a" /* default */].companies.fetch());};var getBreakEven=function getBreakEven(distrId,companyId){return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_1__routes__["a" /* default */].companies.getBreakEven(distrId,companyId));};var getCativoInfo=function getCativoInfo(cnpj){return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_1__routes__["a" /* default */].companies.getCativoInfo(cnpj));};var getCompanyInfo=function getCompanyInfo(id){return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_1__routes__["a" /* default */].companies.getInfo(id));};var getCurvaPerfisAgentes=function getCurvaPerfisAgentes(params){return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_1__routes__["a" /* default */].companies.getCurvaPerfisAgentes(),params);};

/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var helpers = __webpack_require__(15);

function filterByPosition(array, position) {
	return helpers.where(array, function(v) {
		return v.position === position;
	});
}

function sortByWeight(array, reverse) {
	array.forEach(function(v, i) {
		v._tmpIndex_ = i;
		return v;
	});
	array.sort(function(a, b) {
		var v0 = reverse ? b : a;
		var v1 = reverse ? a : b;
		return v0.weight === v1.weight ?
			v0._tmpIndex_ - v1._tmpIndex_ :
			v0.weight - v1.weight;
	});
	array.forEach(function(v) {
		delete v._tmpIndex_;
	});
}

/**
 * @interface ILayoutItem
 * @prop {String} position - The position of the item in the chart layout. Possible values are
 * 'left', 'top', 'right', 'bottom', and 'chartArea'
 * @prop {Number} weight - The weight used to sort the item. Higher weights are further away from the chart area
 * @prop {Boolean} fullWidth - if true, and the item is horizontal, then push vertical boxes down
 * @prop {Function} isHorizontal - returns true if the layout item is horizontal (ie. top or bottom)
 * @prop {Function} update - Takes two parameters: width and height. Returns size of item
 * @prop {Function} getPadding -  Returns an object with padding on the edges
 * @prop {Number} width - Width of item. Must be valid after update()
 * @prop {Number} height - Height of item. Must be valid after update()
 * @prop {Number} left - Left edge of the item. Set by layout system and cannot be used in update
 * @prop {Number} top - Top edge of the item. Set by layout system and cannot be used in update
 * @prop {Number} right - Right edge of the item. Set by layout system and cannot be used in update
 * @prop {Number} bottom - Bottom edge of the item. Set by layout system and cannot be used in update
 */

// The layout service is very self explanatory.  It's responsible for the layout within a chart.
// Scales, Legends and Plugins all rely on the layout service and can easily register to be placed anywhere they need
// It is this service's responsibility of carrying out that layout.
module.exports = {
	defaults: {},

	/**
	 * Register a box to a chart.
	 * A box is simply a reference to an object that requires layout. eg. Scales, Legend, Title.
	 * @param {Chart} chart - the chart to use
	 * @param {ILayoutItem} item - the item to add to be layed out
	 */
	addBox: function(chart, item) {
		if (!chart.boxes) {
			chart.boxes = [];
		}

		// initialize item with default values
		item.fullWidth = item.fullWidth || false;
		item.position = item.position || 'top';
		item.weight = item.weight || 0;

		chart.boxes.push(item);
	},

	/**
	 * Remove a layoutItem from a chart
	 * @param {Chart} chart - the chart to remove the box from
	 * @param {Object} layoutItem - the item to remove from the layout
	 */
	removeBox: function(chart, layoutItem) {
		var index = chart.boxes ? chart.boxes.indexOf(layoutItem) : -1;
		if (index !== -1) {
			chart.boxes.splice(index, 1);
		}
	},

	/**
	 * Sets (or updates) options on the given `item`.
	 * @param {Chart} chart - the chart in which the item lives (or will be added to)
	 * @param {Object} item - the item to configure with the given options
	 * @param {Object} options - the new item options.
	 */
	configure: function(chart, item, options) {
		var props = ['fullWidth', 'position', 'weight'];
		var ilen = props.length;
		var i = 0;
		var prop;

		for (; i < ilen; ++i) {
			prop = props[i];
			if (options.hasOwnProperty(prop)) {
				item[prop] = options[prop];
			}
		}
	},

	/**
	 * Fits boxes of the given chart into the given size by having each box measure itself
	 * then running a fitting algorithm
	 * @param {Chart} chart - the chart
	 * @param {Number} width - the width to fit into
	 * @param {Number} height - the height to fit into
	 */
	update: function(chart, width, height) {
		if (!chart) {
			return;
		}

		var layoutOptions = chart.options.layout || {};
		var padding = helpers.options.toPadding(layoutOptions.padding);
		var leftPadding = padding.left;
		var rightPadding = padding.right;
		var topPadding = padding.top;
		var bottomPadding = padding.bottom;

		var leftBoxes = filterByPosition(chart.boxes, 'left');
		var rightBoxes = filterByPosition(chart.boxes, 'right');
		var topBoxes = filterByPosition(chart.boxes, 'top');
		var bottomBoxes = filterByPosition(chart.boxes, 'bottom');
		var chartAreaBoxes = filterByPosition(chart.boxes, 'chartArea');

		// Sort boxes by weight. A higher weight is further away from the chart area
		sortByWeight(leftBoxes, true);
		sortByWeight(rightBoxes, false);
		sortByWeight(topBoxes, true);
		sortByWeight(bottomBoxes, false);

		// Essentially we now have any number of boxes on each of the 4 sides.
		// Our canvas looks like the following.
		// The areas L1 and L2 are the left axes. R1 is the right axis, T1 is the top axis and
		// B1 is the bottom axis
		// There are also 4 quadrant-like locations (left to right instead of clockwise) reserved for chart overlays
		// These locations are single-box locations only, when trying to register a chartArea location that is already taken,
		// an error will be thrown.
		//
		// |----------------------------------------------------|
		// |                  T1 (Full Width)                   |
		// |----------------------------------------------------|
		// |    |    |                 T2                  |    |
		// |    |----|-------------------------------------|----|
		// |    |    | C1 |                           | C2 |    |
		// |    |    |----|                           |----|    |
		// |    |    |                                     |    |
		// | L1 | L2 |           ChartArea (C0)            | R1 |
		// |    |    |                                     |    |
		// |    |    |----|                           |----|    |
		// |    |    | C3 |                           | C4 |    |
		// |    |----|-------------------------------------|----|
		// |    |    |                 B1                  |    |
		// |----------------------------------------------------|
		// |                  B2 (Full Width)                   |
		// |----------------------------------------------------|
		//
		// What we do to find the best sizing, we do the following
		// 1. Determine the minimum size of the chart area.
		// 2. Split the remaining width equally between each vertical axis
		// 3. Split the remaining height equally between each horizontal axis
		// 4. Give each layout the maximum size it can be. The layout will return it's minimum size
		// 5. Adjust the sizes of each axis based on it's minimum reported size.
		// 6. Refit each axis
		// 7. Position each axis in the final location
		// 8. Tell the chart the final location of the chart area
		// 9. Tell any axes that overlay the chart area the positions of the chart area

		// Step 1
		var chartWidth = width - leftPadding - rightPadding;
		var chartHeight = height - topPadding - bottomPadding;
		var chartAreaWidth = chartWidth / 2; // min 50%
		var chartAreaHeight = chartHeight / 2; // min 50%

		// Step 2
		var verticalBoxWidth = (width - chartAreaWidth) / (leftBoxes.length + rightBoxes.length);

		// Step 3
		var horizontalBoxHeight = (height - chartAreaHeight) / (topBoxes.length + bottomBoxes.length);

		// Step 4
		var maxChartAreaWidth = chartWidth;
		var maxChartAreaHeight = chartHeight;
		var minBoxSizes = [];

		function getMinimumBoxSize(box) {
			var minSize;
			var isHorizontal = box.isHorizontal();

			if (isHorizontal) {
				minSize = box.update(box.fullWidth ? chartWidth : maxChartAreaWidth, horizontalBoxHeight);
				maxChartAreaHeight -= minSize.height;
			} else {
				minSize = box.update(verticalBoxWidth, maxChartAreaHeight);
				maxChartAreaWidth -= minSize.width;
			}

			minBoxSizes.push({
				horizontal: isHorizontal,
				minSize: minSize,
				box: box,
			});
		}

		helpers.each(leftBoxes.concat(rightBoxes, topBoxes, bottomBoxes), getMinimumBoxSize);

		// If a horizontal box has padding, we move the left boxes over to avoid ugly charts (see issue #2478)
		var maxHorizontalLeftPadding = 0;
		var maxHorizontalRightPadding = 0;
		var maxVerticalTopPadding = 0;
		var maxVerticalBottomPadding = 0;

		helpers.each(topBoxes.concat(bottomBoxes), function(horizontalBox) {
			if (horizontalBox.getPadding) {
				var boxPadding = horizontalBox.getPadding();
				maxHorizontalLeftPadding = Math.max(maxHorizontalLeftPadding, boxPadding.left);
				maxHorizontalRightPadding = Math.max(maxHorizontalRightPadding, boxPadding.right);
			}
		});

		helpers.each(leftBoxes.concat(rightBoxes), function(verticalBox) {
			if (verticalBox.getPadding) {
				var boxPadding = verticalBox.getPadding();
				maxVerticalTopPadding = Math.max(maxVerticalTopPadding, boxPadding.top);
				maxVerticalBottomPadding = Math.max(maxVerticalBottomPadding, boxPadding.bottom);
			}
		});

		// At this point, maxChartAreaHeight and maxChartAreaWidth are the size the chart area could
		// be if the axes are drawn at their minimum sizes.
		// Steps 5 & 6
		var totalLeftBoxesWidth = leftPadding;
		var totalRightBoxesWidth = rightPadding;
		var totalTopBoxesHeight = topPadding;
		var totalBottomBoxesHeight = bottomPadding;

		// Function to fit a box
		function fitBox(box) {
			var minBoxSize = helpers.findNextWhere(minBoxSizes, function(minBox) {
				return minBox.box === box;
			});

			if (minBoxSize) {
				if (box.isHorizontal()) {
					var scaleMargin = {
						left: Math.max(totalLeftBoxesWidth, maxHorizontalLeftPadding),
						right: Math.max(totalRightBoxesWidth, maxHorizontalRightPadding),
						top: 0,
						bottom: 0
					};

					// Don't use min size here because of label rotation. When the labels are rotated, their rotation highly depends
					// on the margin. Sometimes they need to increase in size slightly
					box.update(box.fullWidth ? chartWidth : maxChartAreaWidth, chartHeight / 2, scaleMargin);
				} else {
					box.update(minBoxSize.minSize.width, maxChartAreaHeight);
				}
			}
		}

		// Update, and calculate the left and right margins for the horizontal boxes
		helpers.each(leftBoxes.concat(rightBoxes), fitBox);

		helpers.each(leftBoxes, function(box) {
			totalLeftBoxesWidth += box.width;
		});

		helpers.each(rightBoxes, function(box) {
			totalRightBoxesWidth += box.width;
		});

		// Set the Left and Right margins for the horizontal boxes
		helpers.each(topBoxes.concat(bottomBoxes), fitBox);

		// Figure out how much margin is on the top and bottom of the vertical boxes
		helpers.each(topBoxes, function(box) {
			totalTopBoxesHeight += box.height;
		});

		helpers.each(bottomBoxes, function(box) {
			totalBottomBoxesHeight += box.height;
		});

		function finalFitVerticalBox(box) {
			var minBoxSize = helpers.findNextWhere(minBoxSizes, function(minSize) {
				return minSize.box === box;
			});

			var scaleMargin = {
				left: 0,
				right: 0,
				top: totalTopBoxesHeight,
				bottom: totalBottomBoxesHeight
			};

			if (minBoxSize) {
				box.update(minBoxSize.minSize.width, maxChartAreaHeight, scaleMargin);
			}
		}

		// Let the left layout know the final margin
		helpers.each(leftBoxes.concat(rightBoxes), finalFitVerticalBox);

		// Recalculate because the size of each layout might have changed slightly due to the margins (label rotation for instance)
		totalLeftBoxesWidth = leftPadding;
		totalRightBoxesWidth = rightPadding;
		totalTopBoxesHeight = topPadding;
		totalBottomBoxesHeight = bottomPadding;

		helpers.each(leftBoxes, function(box) {
			totalLeftBoxesWidth += box.width;
		});

		helpers.each(rightBoxes, function(box) {
			totalRightBoxesWidth += box.width;
		});

		helpers.each(topBoxes, function(box) {
			totalTopBoxesHeight += box.height;
		});
		helpers.each(bottomBoxes, function(box) {
			totalBottomBoxesHeight += box.height;
		});

		// We may be adding some padding to account for rotated x axis labels
		var leftPaddingAddition = Math.max(maxHorizontalLeftPadding - totalLeftBoxesWidth, 0);
		totalLeftBoxesWidth += leftPaddingAddition;
		totalRightBoxesWidth += Math.max(maxHorizontalRightPadding - totalRightBoxesWidth, 0);

		var topPaddingAddition = Math.max(maxVerticalTopPadding - totalTopBoxesHeight, 0);
		totalTopBoxesHeight += topPaddingAddition;
		totalBottomBoxesHeight += Math.max(maxVerticalBottomPadding - totalBottomBoxesHeight, 0);

		// Figure out if our chart area changed. This would occur if the dataset layout label rotation
		// changed due to the application of the margins in step 6. Since we can only get bigger, this is safe to do
		// without calling `fit` again
		var newMaxChartAreaHeight = height - totalTopBoxesHeight - totalBottomBoxesHeight;
		var newMaxChartAreaWidth = width - totalLeftBoxesWidth - totalRightBoxesWidth;

		if (newMaxChartAreaWidth !== maxChartAreaWidth || newMaxChartAreaHeight !== maxChartAreaHeight) {
			helpers.each(leftBoxes, function(box) {
				box.height = newMaxChartAreaHeight;
			});

			helpers.each(rightBoxes, function(box) {
				box.height = newMaxChartAreaHeight;
			});

			helpers.each(topBoxes, function(box) {
				if (!box.fullWidth) {
					box.width = newMaxChartAreaWidth;
				}
			});

			helpers.each(bottomBoxes, function(box) {
				if (!box.fullWidth) {
					box.width = newMaxChartAreaWidth;
				}
			});

			maxChartAreaHeight = newMaxChartAreaHeight;
			maxChartAreaWidth = newMaxChartAreaWidth;
		}

		// Step 7 - Position the boxes
		var left = leftPadding + leftPaddingAddition;
		var top = topPadding + topPaddingAddition;

		function placeBox(box) {
			if (box.isHorizontal()) {
				box.left = box.fullWidth ? leftPadding : totalLeftBoxesWidth;
				box.right = box.fullWidth ? width - rightPadding : totalLeftBoxesWidth + maxChartAreaWidth;
				box.top = top;
				box.bottom = top + box.height;

				// Move to next point
				top = box.bottom;

			} else {

				box.left = left;
				box.right = left + box.width;
				box.top = totalTopBoxesHeight;
				box.bottom = totalTopBoxesHeight + maxChartAreaHeight;

				// Move to next point
				left = box.right;
			}
		}

		helpers.each(leftBoxes.concat(topBoxes), placeBox);

		// Account for chart width and height
		left += maxChartAreaWidth;
		top += maxChartAreaHeight;

		helpers.each(rightBoxes, placeBox);
		helpers.each(bottomBoxes, placeBox);

		// Step 8
		chart.chartArea = {
			left: totalLeftBoxesWidth,
			top: totalTopBoxesHeight,
			right: totalLeftBoxesWidth + maxChartAreaWidth,
			bottom: totalTopBoxesHeight + maxChartAreaHeight
		};

		// Step 9
		helpers.each(chartAreaBoxes, function(box) {
			box.left = chart.chartArea.left;
			box.top = chart.chartArea.top;
			box.right = chart.chartArea.right;
			box.bottom = chart.chartArea.bottom;

			box.update(maxChartAreaWidth, maxChartAreaHeight);
		});
	}
};


/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var helpers = __webpack_require__(15);

/**
 * Namespace to hold static tick generation functions
 * @namespace Chart.Ticks
 */
module.exports = {
	/**
	 * Namespace to hold formatters for different types of ticks
	 * @namespace Chart.Ticks.formatters
	 */
	formatters: {
		/**
		 * Formatter for value labels
		 * @method Chart.Ticks.formatters.values
		 * @param value the value to display
		 * @return {String|Array} the label to display
		 */
		values: function(value) {
			return helpers.isArray(value) ? value : '' + value;
		},

		/**
		 * Formatter for linear numeric ticks
		 * @method Chart.Ticks.formatters.linear
		 * @param tickValue {Number} the value to be formatted
		 * @param index {Number} the position of the tickValue parameter in the ticks array
		 * @param ticks {Array<Number>} the list of ticks being converted
		 * @return {String} string representation of the tickValue parameter
		 */
		linear: function(tickValue, index, ticks) {
			// If we have lots of ticks, don't use the ones
			var delta = ticks.length > 3 ? ticks[2] - ticks[1] : ticks[1] - ticks[0];

			// If we have a number like 2.5 as the delta, figure out how many decimal places we need
			if (Math.abs(delta) > 1) {
				if (tickValue !== Math.floor(tickValue)) {
					// not an integer
					delta = tickValue - Math.floor(tickValue);
				}
			}

			var logDelta = helpers.log10(Math.abs(delta));
			var tickString = '';

			if (tickValue !== 0) {
				var numDecimal = -1 * Math.floor(logDelta);
				numDecimal = Math.max(Math.min(numDecimal, 20), 0); // toFixed has a max of 20 decimal places
				tickString = tickValue.toFixed(numDecimal);
			} else {
				tickString = '0'; // never show decimal places for 0
			}

			return tickString;
		},

		logarithmic: function(tickValue, index, ticks) {
			var remain = tickValue / (Math.pow(10, Math.floor(helpers.log10(tickValue))));

			if (tickValue === 0) {
				return '0';
			} else if (remain === 1 || remain === 2 || remain === 5 || index === 0 || index === ticks.length - 1) {
				return tickValue.toExponential();
			}
			return '';
		}
	}
};


/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.13 ToObject(argument)
var defined = __webpack_require__(192);
module.exports = function (it) {
  return Object(defined(it));
};


/***/ }),
/* 109 */
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),
/* 110 */
/***/ (function(module, exports) {

module.exports = {};


/***/ }),
/* 111 */
/***/ (function(module, exports) {

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

module.exports = identity;


/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(144),
    getRawTag = __webpack_require__(769),
    objectToString = __webpack_require__(770);

/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? getRawTag(value)
    : objectToString(value);
}

module.exports = baseGetTag;


/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/


/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

module.exports = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};


/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var warning = function() {};

if (false) {
  warning = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
        '`warning(condition, format, ...args)` requires a warning ' +
        'message argument'
      );
    }

    if (format.length < 10 || (/^[s\W]*$/).test(format)) {
      throw new Error(
        'The warning format should be able to uniquely identify this ' +
        'warning. Please, use a more descriptive format than: ' + format
      );
    }

    if (!condition) {
      var argIndex = 0;
      var message = 'Warning: ' +
        format.replace(/%s/g, function() {
          return args[argIndex++];
        });
      if (typeof console !== 'undefined') {
        console.error(message);
      }
      try {
        // This error was thrown as a convenience so that you can use this stack
        // to find the callsite that caused this warning to fire.
        throw new Error(message);
      } catch(x) {}
    }
  };
}

module.exports = warning;


/***/ }),
/* 115 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return createLocation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return locationsAreEqual; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_resolve_pathname__ = __webpack_require__(389);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_value_equal__ = __webpack_require__(390);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__PathUtils__ = __webpack_require__(87);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var createLocation = function createLocation(path, state, key, currentLocation) {
  var location = void 0;
  if (typeof path === 'string') {
    // Two-arg form: push(path, state)
    location = Object(__WEBPACK_IMPORTED_MODULE_2__PathUtils__["d" /* parsePath */])(path);
    location.state = state;
  } else {
    // One-arg form: push(location)
    location = _extends({}, path);

    if (location.pathname === undefined) location.pathname = '';

    if (location.search) {
      if (location.search.charAt(0) !== '?') location.search = '?' + location.search;
    } else {
      location.search = '';
    }

    if (location.hash) {
      if (location.hash.charAt(0) !== '#') location.hash = '#' + location.hash;
    } else {
      location.hash = '';
    }

    if (state !== undefined && location.state === undefined) location.state = state;
  }

  try {
    location.pathname = decodeURI(location.pathname);
  } catch (e) {
    if (e instanceof URIError) {
      throw new URIError('Pathname "' + location.pathname + '" could not be decoded. ' + 'This is likely caused by an invalid percent-encoding.');
    } else {
      throw e;
    }
  }

  if (key) location.key = key;

  if (currentLocation) {
    // Resolve incomplete/relative pathname relative to current location.
    if (!location.pathname) {
      location.pathname = currentLocation.pathname;
    } else if (location.pathname.charAt(0) !== '/') {
      location.pathname = Object(__WEBPACK_IMPORTED_MODULE_0_resolve_pathname__["a" /* default */])(location.pathname, currentLocation.pathname);
    }
  } else {
    // When there is no prior location and pathname is empty, set it to /
    if (!location.pathname) {
      location.pathname = '/';
    }
  }

  return location;
};

var locationsAreEqual = function locationsAreEqual(a, b) {
  return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash && a.key === b.key && Object(__WEBPACK_IMPORTED_MODULE_1_value_equal__["a" /* default */])(a.state, b.state);
};

/***/ }),
/* 116 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__BrowserRouter__ = __webpack_require__(413);
/* unused harmony reexport BrowserRouter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__HashRouter__ = __webpack_require__(414);
/* unused harmony reexport HashRouter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Link__ = __webpack_require__(226);
/* unused harmony reexport Link */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__MemoryRouter__ = __webpack_require__(415);
/* unused harmony reexport MemoryRouter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__NavLink__ = __webpack_require__(417);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_4__NavLink__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Prompt__ = __webpack_require__(419);
/* unused harmony reexport Prompt */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Redirect__ = __webpack_require__(421);
/* unused harmony reexport Redirect */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Route__ = __webpack_require__(227);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_7__Route__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Router__ = __webpack_require__(162);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_8__Router__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__StaticRouter__ = __webpack_require__(423);
/* unused harmony reexport StaticRouter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Switch__ = __webpack_require__(425);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_10__Switch__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__generatePath__ = __webpack_require__(427);
/* unused harmony reexport generatePath */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__matchPath__ = __webpack_require__(428);
/* unused harmony reexport matchPath */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__withRouter__ = __webpack_require__(429);
/* unused harmony reexport withRouter */





























/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var strictUriEncode = __webpack_require__(433);
var objectAssign = __webpack_require__(113);
var decodeComponent = __webpack_require__(434);

function encoderForArrayFormat(opts) {
	switch (opts.arrayFormat) {
		case 'index':
			return function (key, value, index) {
				return value === null ? [
					encode(key, opts),
					'[',
					index,
					']'
				].join('') : [
					encode(key, opts),
					'[',
					encode(index, opts),
					']=',
					encode(value, opts)
				].join('');
			};

		case 'bracket':
			return function (key, value) {
				return value === null ? encode(key, opts) : [
					encode(key, opts),
					'[]=',
					encode(value, opts)
				].join('');
			};

		default:
			return function (key, value) {
				return value === null ? encode(key, opts) : [
					encode(key, opts),
					'=',
					encode(value, opts)
				].join('');
			};
	}
}

function parserForArrayFormat(opts) {
	var result;

	switch (opts.arrayFormat) {
		case 'index':
			return function (key, value, accumulator) {
				result = /\[(\d*)\]$/.exec(key);

				key = key.replace(/\[\d*\]$/, '');

				if (!result) {
					accumulator[key] = value;
					return;
				}

				if (accumulator[key] === undefined) {
					accumulator[key] = {};
				}

				accumulator[key][result[1]] = value;
			};

		case 'bracket':
			return function (key, value, accumulator) {
				result = /(\[\])$/.exec(key);
				key = key.replace(/\[\]$/, '');

				if (!result) {
					accumulator[key] = value;
					return;
				} else if (accumulator[key] === undefined) {
					accumulator[key] = [value];
					return;
				}

				accumulator[key] = [].concat(accumulator[key], value);
			};

		default:
			return function (key, value, accumulator) {
				if (accumulator[key] === undefined) {
					accumulator[key] = value;
					return;
				}

				accumulator[key] = [].concat(accumulator[key], value);
			};
	}
}

function encode(value, opts) {
	if (opts.encode) {
		return opts.strict ? strictUriEncode(value) : encodeURIComponent(value);
	}

	return value;
}

function keysSorter(input) {
	if (Array.isArray(input)) {
		return input.sort();
	} else if (typeof input === 'object') {
		return keysSorter(Object.keys(input)).sort(function (a, b) {
			return Number(a) - Number(b);
		}).map(function (key) {
			return input[key];
		});
	}

	return input;
}

function extract(str) {
	var queryStart = str.indexOf('?');
	if (queryStart === -1) {
		return '';
	}
	return str.slice(queryStart + 1);
}

function parse(str, opts) {
	opts = objectAssign({arrayFormat: 'none'}, opts);

	var formatter = parserForArrayFormat(opts);

	// Create an object with no prototype
	// https://github.com/sindresorhus/query-string/issues/47
	var ret = Object.create(null);

	if (typeof str !== 'string') {
		return ret;
	}

	str = str.trim().replace(/^[?#&]/, '');

	if (!str) {
		return ret;
	}

	str.split('&').forEach(function (param) {
		var parts = param.replace(/\+/g, ' ').split('=');
		// Firefox (pre 40) decodes `%3D` to `=`
		// https://github.com/sindresorhus/query-string/pull/37
		var key = parts.shift();
		var val = parts.length > 0 ? parts.join('=') : undefined;

		// missing `=` should be `null`:
		// http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
		val = val === undefined ? null : decodeComponent(val);

		formatter(decodeComponent(key), val, ret);
	});

	return Object.keys(ret).sort().reduce(function (result, key) {
		var val = ret[key];
		if (Boolean(val) && typeof val === 'object' && !Array.isArray(val)) {
			// Sort object keys, not values
			result[key] = keysSorter(val);
		} else {
			result[key] = val;
		}

		return result;
	}, Object.create(null));
}

exports.extract = extract;
exports.parse = parse;

exports.stringify = function (obj, opts) {
	var defaults = {
		encode: true,
		strict: true,
		arrayFormat: 'none'
	};

	opts = objectAssign(defaults, opts);

	if (opts.sort === false) {
		opts.sort = function () {};
	}

	var formatter = encoderForArrayFormat(opts);

	return obj ? Object.keys(obj).sort(opts.sort).map(function (key) {
		var val = obj[key];

		if (val === undefined) {
			return '';
		}

		if (val === null) {
			return encode(key, opts);
		}

		if (Array.isArray(val)) {
			var result = [];

			val.slice().forEach(function (val2) {
				if (val2 === undefined) {
					return;
				}

				result.push(formatter(key, val2, result.length));
			});

			return result.join('&');
		}

		return encode(key, opts) + '=' + encode(val, opts);
	}).filter(function (x) {
		return x.length > 0;
	}).join('&') : '';
};

exports.parseUrl = function (str, opts) {
	return {
		url: str.split('?')[0] || '',
		query: parse(extract(str), opts)
	};
};


/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = toCssValue;
var join = function join(value, by) {
  var result = '';
  for (var i = 0; i < value.length; i++) {
    // Remove !important from the value, it will be readded later.
    if (value[i] === '!important') break;
    if (result) result += by;
    result += value[i];
  }
  return result;
};

/**
 * Converts array values to string.
 *
 * `margin: [['5px', '10px']]` > `margin: 5px 10px;`
 * `border: ['1px', '2px']` > `border: 1px, 2px;`
 * `margin: [['5px', '10px'], '!important']` > `margin: 5px 10px !important;`
 * `color: ['red', !important]` > `color: red !important;`
 */
function toCssValue(value) {
  var ignoreImportant = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  if (!Array.isArray(value)) return value;

  var cssValue = '';

  // Support space separated values via `[['5px', '10px']]`.
  if (Array.isArray(value[0])) {
    for (var i = 0; i < value.length; i++) {
      if (value[i] === '!important') break;
      if (cssValue) cssValue += ', ';
      cssValue += join(value[i], ' ');
    }
  } else cssValue = join(value, ', ');

  // Add !important, because it was ignored.
  if (!ignoreImportant && value[value.length - 1] === '!important') {
    cssValue += ' !important';
  }

  return cssValue;
}

/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = createRule;

var _warning = __webpack_require__(68);

var _warning2 = _interopRequireDefault(_warning);

var _StyleRule = __webpack_require__(69);

var _StyleRule2 = _interopRequireDefault(_StyleRule);

var _cloneStyle = __webpack_require__(439);

var _cloneStyle2 = _interopRequireDefault(_cloneStyle);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

/**
 * Create a rule instance.
 */
function createRule() {
  var name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'unnamed';
  var decl = arguments[1];
  var options = arguments[2];
  var jss = options.jss;

  var declCopy = (0, _cloneStyle2['default'])(decl);

  var rule = jss.plugins.onCreateRule(name, declCopy, options);
  if (rule) return rule;

  // It is an at-rule and it has no instance.
  if (name[0] === '@') {
    (0, _warning2['default'])(false, '[JSS] Unknown at-rule %s', name);
  }

  return new _StyleRule2['default'](name, declCopy, options);
}

/***/ }),
/* 120 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isBrowser", function() { return isBrowser; });
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var isBrowser = (typeof window === "undefined" ? "undefined" : _typeof(window)) === "object" && (typeof document === "undefined" ? "undefined" : _typeof(document)) === 'object' && document.nodeType === 9;

/* harmony default export */ __webpack_exports__["default"] = (isBrowser);


/***/ }),
/* 121 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
var isMergeableObject = function isMergeableObject(value) {
	return isNonNullObject(value)
		&& !isSpecial(value)
};

function isNonNullObject(value) {
	return !!value && typeof value === 'object'
}

function isSpecial(value) {
	var stringValue = Object.prototype.toString.call(value);

	return stringValue === '[object RegExp]'
		|| stringValue === '[object Date]'
		|| isReactElement(value)
}

// see https://github.com/facebook/react/blob/b5ac963fb791d1298e7f396236383bc955f916c1/src/isomorphic/classic/element/ReactElement.js#L21-L25
var canUseSymbol = typeof Symbol === 'function' && Symbol.for;
var REACT_ELEMENT_TYPE = canUseSymbol ? Symbol.for('react.element') : 0xeac7;

function isReactElement(value) {
	return value.$$typeof === REACT_ELEMENT_TYPE
}

function emptyTarget(val) {
	return Array.isArray(val) ? [] : {}
}

function cloneUnlessOtherwiseSpecified(value, options) {
	return (options.clone !== false && options.isMergeableObject(value))
		? deepmerge(emptyTarget(value), value, options)
		: value
}

function defaultArrayMerge(target, source, options) {
	return target.concat(source).map(function(element) {
		return cloneUnlessOtherwiseSpecified(element, options)
	})
}

function mergeObject(target, source, options) {
	var destination = {};
	if (options.isMergeableObject(target)) {
		Object.keys(target).forEach(function(key) {
			destination[key] = cloneUnlessOtherwiseSpecified(target[key], options);
		});
	}
	Object.keys(source).forEach(function(key) {
		if (!options.isMergeableObject(source[key]) || !target[key]) {
			destination[key] = cloneUnlessOtherwiseSpecified(source[key], options);
		} else {
			destination[key] = deepmerge(target[key], source[key], options);
		}
	});
	return destination
}

function deepmerge(target, source, options) {
	options = options || {};
	options.arrayMerge = options.arrayMerge || defaultArrayMerge;
	options.isMergeableObject = options.isMergeableObject || isMergeableObject;

	var sourceIsArray = Array.isArray(source);
	var targetIsArray = Array.isArray(target);
	var sourceAndTargetTypesMatch = sourceIsArray === targetIsArray;

	if (!sourceAndTargetTypesMatch) {
		return cloneUnlessOtherwiseSpecified(source, options)
	} else if (sourceIsArray) {
		return options.arrayMerge(target, source, options)
	} else {
		return mergeObject(target, source, options)
	}
}

deepmerge.all = function deepmergeAll(array, options) {
	if (!Array.isArray(array)) {
		throw new Error('first argument should be an array')
	}

	return array.reduce(function(prev, next) {
		return deepmerge(prev, next, options)
	}, {})
};

var deepmerge_1 = deepmerge;

/* harmony default export */ __webpack_exports__["default"] = (deepmerge_1);


/***/ }),
/* 122 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__AlertContent__ = __webpack_require__(488);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_reducers_alerts_actions__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash__);
var styles={alertsWrapper:{bottom:'15px',position:'fixed',right:'15px'}};var Alerts=function Alerts(_ref){var alerts=_ref.alerts,classes=_ref.classes,dismissAlert=_ref.dismissAlert;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:classes.alertsWrapper},Object(__WEBPACK_IMPORTED_MODULE_6_lodash__["map"])(alerts,function(alert,index){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__AlertContent__["a" /* default */],{key:alert.id,message:alert.message,onClose:function onClose(){return dismissAlert(alert.id);},variant:alert.type});}));};Alerts.propTypes={alerts:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({id:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired,message:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.node.isRequired,type:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.oneOf(['error',// vermelho
'info',// azul
'success',// verde
'warning']// amarelo
).isRequired})),classes:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object.isRequired,dismissAlert:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired};var mapStateToProps=function mapStateToProps(state){return{alerts:state.alerts};};var mapDispatchToProps={dismissAlert:__WEBPACK_IMPORTED_MODULE_5_reducers_alerts_actions__["a" /* dismissAlert */]};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(Object(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles__["withStyles"])(styles)(Alerts)));

/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(2);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "createGenerateClassName", {
  enumerable: true,
  get: function get() {
    return _createGenerateClassName.default;
  }
});
Object.defineProperty(exports, "createMuiTheme", {
  enumerable: true,
  get: function get() {
    return _createMuiTheme.default;
  }
});
Object.defineProperty(exports, "jssPreset", {
  enumerable: true,
  get: function get() {
    return _jssPreset.default;
  }
});
Object.defineProperty(exports, "MuiThemeProvider", {
  enumerable: true,
  get: function get() {
    return _MuiThemeProvider.default;
  }
});
Object.defineProperty(exports, "createStyles", {
  enumerable: true,
  get: function get() {
    return _createStyles.default;
  }
});
Object.defineProperty(exports, "withStyles", {
  enumerable: true,
  get: function get() {
    return _withStyles.default;
  }
});
Object.defineProperty(exports, "withTheme", {
  enumerable: true,
  get: function get() {
    return _withTheme.default;
  }
});

var _createGenerateClassName = _interopRequireDefault(__webpack_require__(240));

var _createMuiTheme = _interopRequireDefault(__webpack_require__(171));

var _jssPreset = _interopRequireDefault(__webpack_require__(238));

var _MuiThemeProvider = _interopRequireDefault(__webpack_require__(485));

var _createStyles = _interopRequireDefault(__webpack_require__(487));

var _withStyles = _interopRequireDefault(__webpack_require__(3));

var _withTheme = _interopRequireDefault(__webpack_require__(71));

/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(2);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _ButtonBase.default;
  }
});

var _ButtonBase = _interopRequireDefault(__webpack_require__(498));

/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(2);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _ownerDocument = _interopRequireDefault(__webpack_require__(48));

function ownerWindow(node) {
  var fallback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : window;
  var doc = (0, _ownerDocument.default)(node);
  return doc.defaultView || doc.parentView || fallback;
}

var _default = ownerWindow;
exports.default = _default;

/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(2);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Typography.default;
  }
});

var _Typography = _interopRequireDefault(__webpack_require__(510));

/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(2);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _FormControlLabel.default;
  }
});

var _FormControlLabel = _interopRequireDefault(__webpack_require__(553));

/***/ }),
/* 128 */
/***/ (function(module, exports) {

/**
 * Returns a function, that, as long as it continues to be invoked, will not
 * be triggered. The function will be called after it stops being called for
 * N milliseconds. If `immediate` is passed, trigger the function on the
 * leading edge, instead of the trailing. The function also has a property 'clear' 
 * that is a function which will clear the timer to prevent previously scheduled executions. 
 *
 * @source underscore.js
 * @see http://unscriptable.com/2009/03/20/debouncing-javascript-methods/
 * @param {Function} function to wrap
 * @param {Number} timeout in ms (`100`)
 * @param {Boolean} whether to execute at the beginning (`false`)
 * @api public
 */
function debounce(func, wait, immediate){
  var timeout, args, context, timestamp, result;
  if (null == wait) wait = 100;

  function later() {
    var last = Date.now() - timestamp;

    if (last < wait && last >= 0) {
      timeout = setTimeout(later, wait - last);
    } else {
      timeout = null;
      if (!immediate) {
        result = func.apply(context, args);
        context = args = null;
      }
    }
  };

  var debounced = function(){
    context = this;
    args = arguments;
    timestamp = Date.now();
    var callNow = immediate && !timeout;
    if (!timeout) timeout = setTimeout(later, wait);
    if (callNow) {
      result = func.apply(context, args);
      context = args = null;
    }

    return result;
  };

  debounced.clear = function() {
    if (timeout) {
      clearTimeout(timeout);
      timeout = null;
    }
  };
  
  debounced.flush = function() {
    if (timeout) {
      result = func.apply(context, args);
      context = args = null;
      
      clearTimeout(timeout);
      timeout = null;
    }
  };

  return debounced;
};

// Adds compatibility for ES modules
debounce.debounce = debounce;

module.exports = debounce;


/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(2);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Input.default;
  }
});

var _Input = _interopRequireDefault(__webpack_require__(183));

/***/ }),
/* 130 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__ = __webpack_require__(21);
var customCheckboxRadioSwitch={checkboxAndRadio:{position:"relative",display:"block",marginTop:"10px",marginBottom:"10px"},checkboxAndRadioHorizontal:{position:"relative",display:"block","&:first-child":{marginTop:"10px"},"&:not(:first-child)":{marginTop:"-14px"},marginTop:"0",marginBottom:"0"},checked:{color:__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["r" /* primaryColor */]+"!important"},checkedIcon:{width:"20px",height:"20px",border:"1px solid rgba(0, 0, 0, .54)",borderRadius:"3px"},uncheckedIcon:{width:"0px",height:"0px",padding:"9px",border:"1px solid rgba(0, 0, 0, .54)",borderRadius:"3px"},disabledCheckboxAndRadio:{"& $checkedIcon,& $uncheckedIcon,& $radioChecked,& $radioUnchecked":{borderColor:"#000000",opacity:"0.26",color:"#000000"}},label:{cursor:"pointer",paddingLeft:"0",color:"#AAAAAA",fontSize:"14px",lineHeight:"1.428571429",fontWeight:"400",display:"inline-flex",transition:"0.3s ease all"},labelHorizontal:{color:"rgba(0, 0, 0, 0.26)",cursor:"pointer",display:"inline-flex",fontSize:"14px",lineHeight:"1.428571429",fontWeight:"400",paddingTop:"39px",marginRight:"0","@media (min-width: 992px)":{float:"right"}},labelHorizontalRadioCheckbox:{paddingTop:"22px"},labelLeftHorizontal:{color:"rgba(0, 0, 0, 0.26)",cursor:"pointer",display:"inline-flex",fontSize:"14px",lineHeight:"1.428571429",fontWeight:"400",paddingTop:"22px",marginRight:"0"},labelError:{color:__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["g" /* dangerColor */]},radio:{color:__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["r" /* primaryColor */]+"!important"},radioChecked:{width:"16px",height:"16px",border:"1px solid "+__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["r" /* primaryColor */],borderRadius:"50%"},radioUnchecked:{width:"0px",height:"0px",padding:"7px",border:"1px solid rgba(0, 0, 0, .54)",borderRadius:"50%"},inlineChecks:{marginTop:"8px"},iconCheckbox:{height:"116px",width:"116px",color:__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["l" /* grayColor */],"& > span:first-child":{borderWidth:"4px",borderStyle:"solid",borderColor:"#CCCCCC",textAlign:"center",verticalAlign:"middle",borderRadius:"50%",color:"inherit",margin:"0 auto 20px",transition:"all 0.2s"},"&:hover":{color:__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["u" /* roseColor */],"& > span:first-child":{borderColor:__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["u" /* roseColor */]}}},iconCheckboxChecked:{color:__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["u" /* roseColor */],"& > span:first-child":{borderColor:__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["u" /* roseColor */]}},iconCheckboxIcon:{fontSize:"40px",lineHeight:"111px"},switchBase:{color:__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["r" /* primaryColor */]+"!important"},switchIcon:{boxShadow:"0 1px 3px 1px rgba(0, 0, 0, 0.4)",color:"#FFFFFF !important",border:"1px solid rgba(0, 0, 0, .54)",transform:"translateX(-4px)!important"},switchIconChecked:{borderColor:"#9c27b0",transform:"translateX(0px)!important"},switchBar:{width:"30px",height:"15px",backgroundColor:"rgb(80, 80, 80)",borderRadius:"15px",opacity:"0.7!important"},switchChecked:{"& + $switchBar":{backgroundColor:"rgba(156, 39, 176, 1) !important"}}};/* harmony default export */ __webpack_exports__["a"] = (customCheckboxRadioSwitch);

/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getTransitionProps = getTransitionProps;
exports.reflow = void 0;

var reflow = function reflow(node) {
  return node.scrollTop;
};

exports.reflow = reflow;

function getTransitionProps(props, options) {
  var timeout = props.timeout,
      _props$style = props.style,
      style = _props$style === void 0 ? {} : _props$style;
  return {
    duration: style.transitionDuration || typeof timeout === 'number' ? timeout : timeout[options.mode],
    delay: style.transitionDelay
  };
}

/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Collapse = exports.collapseDuration = exports.Fade = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactTransitionGroup = __webpack_require__(187);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

// ==============================
// Fade Transition
// ==============================

var Fade = function Fade(_ref) {
  var Tag = _ref.component,
      _ref$duration = _ref.duration,
      duration = _ref$duration === undefined ? 1 : _ref$duration,
      inProp = _ref.in,
      onExited = _ref.onExited,
      props = _objectWithoutProperties(_ref, ['component', 'duration', 'in', 'onExited']);

  var transition = {
    entering: { opacity: 0 },
    entered: { opacity: 1, transition: 'opacity ' + duration + 'ms' },
    exiting: { opacity: 0 },
    exited: { opacity: 0 }
  };

  return _react2.default.createElement(
    _reactTransitionGroup.Transition,
    { mountOnEnter: true, unmountOnExit: true, 'in': inProp, timeout: duration },
    function (state) {
      var innerProps = {
        style: _extends({}, transition[state])
      };
      return _react2.default.createElement(Tag, _extends({ innerProps: innerProps }, props));
    }
  );
};

// ==============================
// Collapse Transition
// ==============================

exports.Fade = Fade;
var collapseDuration = exports.collapseDuration = 260;

// wrap each MultiValue with a collapse transition; decreases width until
// finally removing from DOM
var Collapse = exports.Collapse = function (_Component) {
  _inherits(Collapse, _Component);

  function Collapse() {
    var _ref2;

    var _temp, _this, _ret;

    _classCallCheck(this, Collapse);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref2 = Collapse.__proto__ || Object.getPrototypeOf(Collapse)).call.apply(_ref2, [this].concat(args))), _this), _this.duration = collapseDuration, _this.state = { width: 'auto' }, _this.transition = {
      exiting: { width: 0, transition: 'width ' + _this.duration + 'ms ease-out' },
      exited: { width: 0 }
    }, _this.getWidth = function (ref) {
      if (ref && isNaN(_this.state.width)) {
        // cannot use `offsetWidth` because it is rounded
        var _ref$getBoundingClien = ref.getBoundingClientRect(),
            _width = _ref$getBoundingClien.width;

        _this.setState({ width: _width });
      }
    }, _this.getStyle = function (width) {
      return {
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        width: width
      };
    }, _this.getTransition = function (state) {
      return _this.transition[state];
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  // width must be calculated; cannot transition from `undefined` to `number`


  // get base styles


  // get transition styles


  _createClass(Collapse, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          children = _props.children,
          inProp = _props.in;
      var width = this.state.width;


      return _react2.default.createElement(
        _reactTransitionGroup.Transition,
        {
          enter: false,
          mountOnEnter: true,
          unmountOnExit: true,
          'in': inProp,
          timeout: this.duration
        },
        function (state) {
          var style = _extends({}, _this2.getStyle(width), _this2.getTransition(state));
          return _react2.default.createElement(
            'div',
            { ref: _this2.getWidth, style: style },
            children
          );
        }
      );
    }
  }]);

  return Collapse;
}(_react.Component);

/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(2);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _CircularProgress.default;
  }
});

var _CircularProgress = _interopRequireDefault(__webpack_require__(615));

/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(2);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Modal.default;
  }
});
Object.defineProperty(exports, "ModalManager", {
  enumerable: true,
  get: function get() {
    return _ModalManager.default;
  }
});

var _Modal = _interopRequireDefault(__webpack_require__(622));

var _ModalManager = _interopRequireDefault(__webpack_require__(280));

/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(2);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _MenuItem.default;
  }
});

var _MenuItem = _interopRequireDefault(__webpack_require__(655));

/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * @namespace Chart.helpers
 */
var helpers = {
	/**
	 * An empty function that can be used, for example, for optional callback.
	 */
	noop: function() {},

	/**
	 * Returns a unique id, sequentially generated from a global variable.
	 * @returns {Number}
	 * @function
	 */
	uid: (function() {
		var id = 0;
		return function() {
			return id++;
		};
	}()),

	/**
	 * Returns true if `value` is neither null nor undefined, else returns false.
	 * @param {*} value - The value to test.
	 * @returns {Boolean}
	 * @since 2.7.0
	 */
	isNullOrUndef: function(value) {
		return value === null || typeof value === 'undefined';
	},

	/**
	 * Returns true if `value` is an array, else returns false.
	 * @param {*} value - The value to test.
	 * @returns {Boolean}
	 * @function
	 */
	isArray: Array.isArray ? Array.isArray : function(value) {
		return Object.prototype.toString.call(value) === '[object Array]';
	},

	/**
	 * Returns true if `value` is an object (excluding null), else returns false.
	 * @param {*} value - The value to test.
	 * @returns {Boolean}
	 * @since 2.7.0
	 */
	isObject: function(value) {
		return value !== null && Object.prototype.toString.call(value) === '[object Object]';
	},

	/**
	 * Returns `value` if defined, else returns `defaultValue`.
	 * @param {*} value - The value to return if defined.
	 * @param {*} defaultValue - The value to return if `value` is undefined.
	 * @returns {*}
	 */
	valueOrDefault: function(value, defaultValue) {
		return typeof value === 'undefined' ? defaultValue : value;
	},

	/**
	 * Returns value at the given `index` in array if defined, else returns `defaultValue`.
	 * @param {Array} value - The array to lookup for value at `index`.
	 * @param {Number} index - The index in `value` to lookup for value.
	 * @param {*} defaultValue - The value to return if `value[index]` is undefined.
	 * @returns {*}
	 */
	valueAtIndexOrDefault: function(value, index, defaultValue) {
		return helpers.valueOrDefault(helpers.isArray(value) ? value[index] : value, defaultValue);
	},

	/**
	 * Calls `fn` with the given `args` in the scope defined by `thisArg` and returns the
	 * value returned by `fn`. If `fn` is not a function, this method returns undefined.
	 * @param {Function} fn - The function to call.
	 * @param {Array|undefined|null} args - The arguments with which `fn` should be called.
	 * @param {Object} [thisArg] - The value of `this` provided for the call to `fn`.
	 * @returns {*}
	 */
	callback: function(fn, args, thisArg) {
		if (fn && typeof fn.call === 'function') {
			return fn.apply(thisArg, args);
		}
	},

	/**
	 * Note(SB) for performance sake, this method should only be used when loopable type
	 * is unknown or in none intensive code (not called often and small loopable). Else
	 * it's preferable to use a regular for() loop and save extra function calls.
	 * @param {Object|Array} loopable - The object or array to be iterated.
	 * @param {Function} fn - The function to call for each item.
	 * @param {Object} [thisArg] - The value of `this` provided for the call to `fn`.
	 * @param {Boolean} [reverse] - If true, iterates backward on the loopable.
	 */
	each: function(loopable, fn, thisArg, reverse) {
		var i, len, keys;
		if (helpers.isArray(loopable)) {
			len = loopable.length;
			if (reverse) {
				for (i = len - 1; i >= 0; i--) {
					fn.call(thisArg, loopable[i], i);
				}
			} else {
				for (i = 0; i < len; i++) {
					fn.call(thisArg, loopable[i], i);
				}
			}
		} else if (helpers.isObject(loopable)) {
			keys = Object.keys(loopable);
			len = keys.length;
			for (i = 0; i < len; i++) {
				fn.call(thisArg, loopable[keys[i]], keys[i]);
			}
		}
	},

	/**
	 * Returns true if the `a0` and `a1` arrays have the same content, else returns false.
	 * @see http://stackoverflow.com/a/14853974
	 * @param {Array} a0 - The array to compare
	 * @param {Array} a1 - The array to compare
	 * @returns {Boolean}
	 */
	arrayEquals: function(a0, a1) {
		var i, ilen, v0, v1;

		if (!a0 || !a1 || a0.length !== a1.length) {
			return false;
		}

		for (i = 0, ilen = a0.length; i < ilen; ++i) {
			v0 = a0[i];
			v1 = a1[i];

			if (v0 instanceof Array && v1 instanceof Array) {
				if (!helpers.arrayEquals(v0, v1)) {
					return false;
				}
			} else if (v0 !== v1) {
				// NOTE: two different object instances will never be equal: {x:20} != {x:20}
				return false;
			}
		}

		return true;
	},

	/**
	 * Returns a deep copy of `source` without keeping references on objects and arrays.
	 * @param {*} source - The value to clone.
	 * @returns {*}
	 */
	clone: function(source) {
		if (helpers.isArray(source)) {
			return source.map(helpers.clone);
		}

		if (helpers.isObject(source)) {
			var target = {};
			var keys = Object.keys(source);
			var klen = keys.length;
			var k = 0;

			for (; k < klen; ++k) {
				target[keys[k]] = helpers.clone(source[keys[k]]);
			}

			return target;
		}

		return source;
	},

	/**
	 * The default merger when Chart.helpers.merge is called without merger option.
	 * Note(SB): this method is also used by configMerge and scaleMerge as fallback.
	 * @private
	 */
	_merger: function(key, target, source, options) {
		var tval = target[key];
		var sval = source[key];

		if (helpers.isObject(tval) && helpers.isObject(sval)) {
			helpers.merge(tval, sval, options);
		} else {
			target[key] = helpers.clone(sval);
		}
	},

	/**
	 * Merges source[key] in target[key] only if target[key] is undefined.
	 * @private
	 */
	_mergerIf: function(key, target, source) {
		var tval = target[key];
		var sval = source[key];

		if (helpers.isObject(tval) && helpers.isObject(sval)) {
			helpers.mergeIf(tval, sval);
		} else if (!target.hasOwnProperty(key)) {
			target[key] = helpers.clone(sval);
		}
	},

	/**
	 * Recursively deep copies `source` properties into `target` with the given `options`.
	 * IMPORTANT: `target` is not cloned and will be updated with `source` properties.
	 * @param {Object} target - The target object in which all sources are merged into.
	 * @param {Object|Array(Object)} source - Object(s) to merge into `target`.
	 * @param {Object} [options] - Merging options:
	 * @param {Function} [options.merger] - The merge method (key, target, source, options)
	 * @returns {Object} The `target` object.
	 */
	merge: function(target, source, options) {
		var sources = helpers.isArray(source) ? source : [source];
		var ilen = sources.length;
		var merge, i, keys, klen, k;

		if (!helpers.isObject(target)) {
			return target;
		}

		options = options || {};
		merge = options.merger || helpers._merger;

		for (i = 0; i < ilen; ++i) {
			source = sources[i];
			if (!helpers.isObject(source)) {
				continue;
			}

			keys = Object.keys(source);
			for (k = 0, klen = keys.length; k < klen; ++k) {
				merge(keys[k], target, source, options);
			}
		}

		return target;
	},

	/**
	 * Recursively deep copies `source` properties into `target` *only* if not defined in target.
	 * IMPORTANT: `target` is not cloned and will be updated with `source` properties.
	 * @param {Object} target - The target object in which all sources are merged into.
	 * @param {Object|Array(Object)} source - Object(s) to merge into `target`.
	 * @returns {Object} The `target` object.
	 */
	mergeIf: function(target, source) {
		return helpers.merge(target, source, {merger: helpers._mergerIf});
	},

	/**
	 * Applies the contents of two or more objects together into the first object.
	 * @param {Object} target - The target object in which all objects are merged into.
	 * @param {Object} arg1 - Object containing additional properties to merge in target.
	 * @param {Object} argN - Additional objects containing properties to merge in target.
	 * @returns {Object} The `target` object.
	 */
	extend: function(target) {
		var setFn = function(value, key) {
			target[key] = value;
		};
		for (var i = 1, ilen = arguments.length; i < ilen; ++i) {
			helpers.each(arguments[i], setFn);
		}
		return target;
	},

	/**
	 * Basic javascript inheritance based on the model created in Backbone.js
	 */
	inherits: function(extensions) {
		var me = this;
		var ChartElement = (extensions && extensions.hasOwnProperty('constructor')) ? extensions.constructor : function() {
			return me.apply(this, arguments);
		};

		var Surrogate = function() {
			this.constructor = ChartElement;
		};

		Surrogate.prototype = me.prototype;
		ChartElement.prototype = new Surrogate();
		ChartElement.extend = helpers.inherits;

		if (extensions) {
			helpers.extend(ChartElement.prototype, extensions);
		}

		ChartElement.__super__ = me.prototype;
		return ChartElement;
	}
};

module.exports = helpers;

// DEPRECATIONS

/**
 * Provided for backward compatibility, use Chart.helpers.callback instead.
 * @function Chart.helpers.callCallback
 * @deprecated since version 2.6.0
 * @todo remove at version 3
 * @private
 */
helpers.callCallback = helpers.callback;

/**
 * Provided for backward compatibility, use Array.prototype.indexOf instead.
 * Array.prototype.indexOf compatibility: Chrome, Opera, Safari, FF1.5+, IE9+
 * @function Chart.helpers.indexOf
 * @deprecated since version 2.7.0
 * @todo remove at version 3
 * @private
 */
helpers.indexOf = function(array, item, fromIndex) {
	return Array.prototype.indexOf.call(array, item, fromIndex);
};

/**
 * Provided for backward compatibility, use Chart.helpers.valueOrDefault instead.
 * @function Chart.helpers.getValueOrDefault
 * @deprecated since version 2.7.0
 * @todo remove at version 3
 * @private
 */
helpers.getValueOrDefault = helpers.valueOrDefault;

/**
 * Provided for backward compatibility, use Chart.helpers.valueAtIndexOrDefault instead.
 * @function Chart.helpers.getValueAtIndexOrDefault
 * @deprecated since version 2.7.0
 * @todo remove at version 3
 * @private
 */
helpers.getValueAtIndexOrDefault = helpers.valueAtIndexOrDefault;


/***/ }),
/* 137 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return fulfillWith; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}// Preenche o início da collection com value.
// Útil para as empresas que entaram no ACL e não
// tem ainda 12 meses completos de histórico.
var fulfillWith=function fulfillWith(collection,value){var diff=12-collection.length;if(diff===0){return collection;}else{return[].concat(_toConsumableArray(Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["times"])(diff,function(){return value;})),_toConsumableArray(collection));}};

/***/ }),
/* 138 */
/***/ (function(module, exports) {

module.exports = true;


/***/ }),
/* 139 */
/***/ (function(module, exports) {

var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};


/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys = __webpack_require__(308);
var enumBugKeys = __webpack_require__(200);

module.exports = Object.keys || function keys(O) {
  return $keys(O, enumBugKeys);
};


/***/ }),
/* 141 */
/***/ (function(module, exports) {

exports.f = {}.propertyIsEnumerable;


/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

var baseRest = __webpack_require__(205),
    createWrap = __webpack_require__(774),
    getHolder = __webpack_require__(210),
    replaceHolders = __webpack_require__(147);

/** Used to compose bitmasks for function metadata. */
var WRAP_BIND_FLAG = 1,
    WRAP_PARTIAL_FLAG = 32;

/**
 * Creates a function that invokes `func` with the `this` binding of `thisArg`
 * and `partials` prepended to the arguments it receives.
 *
 * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
 * may be used as a placeholder for partially applied arguments.
 *
 * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
 * property of bound functions.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to bind.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {...*} [partials] The arguments to be partially applied.
 * @returns {Function} Returns the new bound function.
 * @example
 *
 * function greet(greeting, punctuation) {
 *   return greeting + ' ' + this.user + punctuation;
 * }
 *
 * var object = { 'user': 'fred' };
 *
 * var bound = _.bind(greet, object, 'hi');
 * bound('!');
 * // => 'hi fred!'
 *
 * // Bound with placeholders.
 * var bound = _.bind(greet, object, _, '!');
 * bound('hi');
 * // => 'hi fred!'
 */
var bind = baseRest(function(func, thisArg, partials) {
  var bitmask = WRAP_BIND_FLAG;
  if (partials.length) {
    var holders = replaceHolders(partials, getHolder(bind));
    bitmask |= WRAP_PARTIAL_FLAG;
  }
  return createWrap(func, bitmask, thisArg, partials, holders);
});

// Assign default placeholders.
bind.placeholder = {};

module.exports = bind;


/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(112),
    isObject = __webpack_require__(66);

/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    proxyTag = '[object Proxy]';

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!isObject(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = baseGetTag(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

module.exports = isFunction;


/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(38);

/** Built-in value references. */
var Symbol = root.Symbol;

module.exports = Symbol;


/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

var baseCreate = __webpack_require__(207),
    isObject = __webpack_require__(66);

/**
 * Creates a function that produces an instance of `Ctor` regardless of
 * whether it was invoked as part of a `new` expression or by `call` or `apply`.
 *
 * @private
 * @param {Function} Ctor The constructor to wrap.
 * @returns {Function} Returns the new wrapped function.
 */
function createCtor(Ctor) {
  return function() {
    // Use a `switch` statement to work with class constructors. See
    // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
    // for more details.
    var args = arguments;
    switch (args.length) {
      case 0: return new Ctor;
      case 1: return new Ctor(args[0]);
      case 2: return new Ctor(args[0], args[1]);
      case 3: return new Ctor(args[0], args[1], args[2]);
      case 4: return new Ctor(args[0], args[1], args[2], args[3]);
      case 5: return new Ctor(args[0], args[1], args[2], args[3], args[4]);
      case 6: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
      case 7: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
    }
    var thisBinding = baseCreate(Ctor.prototype),
        result = Ctor.apply(thisBinding, args);

    // Mimic the constructor's `return` behavior.
    // See https://es5.github.io/#x13.2.2 for more details.
    return isObject(result) ? result : thisBinding;
  };
}

module.exports = createCtor;


/***/ }),
/* 146 */
/***/ (function(module, exports) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  var type = typeof value;
  length = length == null ? MAX_SAFE_INTEGER : length;

  return !!length &&
    (type == 'number' ||
      (type != 'symbol' && reIsUint.test(value))) &&
        (value > -1 && value % 1 == 0 && value < length);
}

module.exports = isIndex;


/***/ }),
/* 147 */
/***/ (function(module, exports) {

/** Used as the internal argument placeholder. */
var PLACEHOLDER = '__lodash_placeholder__';

/**
 * Replaces all `placeholder` elements in `array` with an internal placeholder
 * and returns an array of their indexes.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {*} placeholder The placeholder to replace.
 * @returns {Array} Returns the new array of placeholder indexes.
 */
function replaceHolders(array, placeholder) {
  var index = -1,
      length = array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (value === placeholder || value === PLACEHOLDER) {
      array[index] = PLACEHOLDER;
      result[resIndex++] = index;
    }
  }
  return result;
}

module.exports = replaceHolders;


/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(112),
    isObjectLike = __webpack_require__(85);

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && baseGetTag(value) == symbolTag);
}

module.exports = isSymbol;


/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

var arrayLikeKeys = __webpack_require__(819),
    baseKeys = __webpack_require__(826),
    isArrayLike = __webpack_require__(150);

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

module.exports = keys;


/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

var isFunction = __webpack_require__(143),
    isLength = __webpack_require__(211);

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

module.exports = isArrayLike;


/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

var listCacheClear = __webpack_require__(833),
    listCacheDelete = __webpack_require__(834),
    listCacheGet = __webpack_require__(835),
    listCacheHas = __webpack_require__(836),
    listCacheSet = __webpack_require__(837);

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

module.exports = ListCache;


/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

var eq = __webpack_require__(153);

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

module.exports = assocIndexOf;


/***/ }),
/* 153 */
/***/ (function(module, exports) {

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

module.exports = eq;


/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(65);

/* Built-in method references that are verified to be native. */
var nativeCreate = getNative(Object, 'create');

module.exports = nativeCreate;


/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

var isKeyable = __webpack_require__(851);

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

module.exports = getMapData;


/***/ }),
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

var isSymbol = __webpack_require__(148);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey(value) {
  if (typeof value == 'string' || isSymbol(value)) {
    return value;
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = toKey;


/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(2);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _InputAdornment.default;
  }
});

var _InputAdornment = _interopRequireDefault(__webpack_require__(942));

/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 * 
 */

/*eslint-disable no-self-compare */



var hasOwnProperty = Object.prototype.hasOwnProperty;

/**
 * inlined Object.is polyfill to avoid requiring consumers ship their own
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
 */
function is(x, y) {
  // SameValue algorithm
  if (x === y) {
    // Steps 1-5, 7-10
    // Steps 6.b-6.e: +0 != -0
    // Added the nonzero y check to make Flow happy, but it is redundant
    return x !== 0 || y !== 0 || 1 / x === 1 / y;
  } else {
    // Step 6.a: NaN == NaN
    return x !== x && y !== y;
  }
}

/**
 * Performs equality by iterating through keys on an object and returning false
 * when any key has values which are not strictly equal between the arguments.
 * Returns true when the values of all keys are strictly equal.
 */
function shallowEqual(objA, objB) {
  if (is(objA, objB)) {
    return true;
  }

  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) {
    return false;
  }

  // Test for A's keys different from B.
  for (var i = 0; i < keysA.length; i++) {
    if (!hasOwnProperty.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
      return false;
    }
  }

  return true;
}

module.exports = shallowEqual;

/***/ }),
/* 159 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return createStore; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return combineReducers; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return bindActionCreators; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return applyMiddleware; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return compose; });
/* unused harmony export __DO_NOT_USE__ActionTypes */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_symbol_observable__ = __webpack_require__(386);


/**
 * These are private action types reserved by Redux.
 * For any unknown actions, you must return the current state.
 * If the current state is undefined, you must return the initial state.
 * Do not reference these action types directly in your code.
 */
var ActionTypes = {
  INIT: '@@redux/INIT' + Math.random().toString(36).substring(7).split('').join('.'),
  REPLACE: '@@redux/REPLACE' + Math.random().toString(36).substring(7).split('').join('.')
};

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

/**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */
function isPlainObject(obj) {
  if ((typeof obj === 'undefined' ? 'undefined' : _typeof(obj)) !== 'object' || obj === null) return false;

  var proto = obj;
  while (Object.getPrototypeOf(proto) !== null) {
    proto = Object.getPrototypeOf(proto);
  }

  return Object.getPrototypeOf(obj) === proto;
}

/**
 * Creates a Redux store that holds the state tree.
 * The only way to change the data in the store is to call `dispatch()` on it.
 *
 * There should only be a single store in your app. To specify how different
 * parts of the state tree respond to actions, you may combine several reducers
 * into a single reducer function by using `combineReducers`.
 *
 * @param {Function} reducer A function that returns the next state tree, given
 * the current state tree and the action to handle.
 *
 * @param {any} [preloadedState] The initial state. You may optionally specify it
 * to hydrate the state from the server in universal apps, or to restore a
 * previously serialized user session.
 * If you use `combineReducers` to produce the root reducer function, this must be
 * an object with the same shape as `combineReducers` keys.
 *
 * @param {Function} [enhancer] The store enhancer. You may optionally specify it
 * to enhance the store with third-party capabilities such as middleware,
 * time travel, persistence, etc. The only store enhancer that ships with Redux
 * is `applyMiddleware()`.
 *
 * @returns {Store} A Redux store that lets you read the state, dispatch actions
 * and subscribe to changes.
 */
function createStore(reducer, preloadedState, enhancer) {
  var _ref2;

  if (typeof preloadedState === 'function' && typeof enhancer === 'undefined') {
    enhancer = preloadedState;
    preloadedState = undefined;
  }

  if (typeof enhancer !== 'undefined') {
    if (typeof enhancer !== 'function') {
      throw new Error('Expected the enhancer to be a function.');
    }

    return enhancer(createStore)(reducer, preloadedState);
  }

  if (typeof reducer !== 'function') {
    throw new Error('Expected the reducer to be a function.');
  }

  var currentReducer = reducer;
  var currentState = preloadedState;
  var currentListeners = [];
  var nextListeners = currentListeners;
  var isDispatching = false;

  function ensureCanMutateNextListeners() {
    if (nextListeners === currentListeners) {
      nextListeners = currentListeners.slice();
    }
  }

  /**
   * Reads the state tree managed by the store.
   *
   * @returns {any} The current state tree of your application.
   */
  function getState() {
    if (isDispatching) {
      throw new Error('You may not call store.getState() while the reducer is executing. ' + 'The reducer has already received the state as an argument. ' + 'Pass it down from the top reducer instead of reading it from the store.');
    }

    return currentState;
  }

  /**
   * Adds a change listener. It will be called any time an action is dispatched,
   * and some part of the state tree may potentially have changed. You may then
   * call `getState()` to read the current state tree inside the callback.
   *
   * You may call `dispatch()` from a change listener, with the following
   * caveats:
   *
   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
   * If you subscribe or unsubscribe while the listeners are being invoked, this
   * will not have any effect on the `dispatch()` that is currently in progress.
   * However, the next `dispatch()` call, whether nested or not, will use a more
   * recent snapshot of the subscription list.
   *
   * 2. The listener should not expect to see all state changes, as the state
   * might have been updated multiple times during a nested `dispatch()` before
   * the listener is called. It is, however, guaranteed that all subscribers
   * registered before the `dispatch()` started will be called with the latest
   * state by the time it exits.
   *
   * @param {Function} listener A callback to be invoked on every dispatch.
   * @returns {Function} A function to remove this change listener.
   */
  function subscribe(listener) {
    if (typeof listener !== 'function') {
      throw new Error('Expected the listener to be a function.');
    }

    if (isDispatching) {
      throw new Error('You may not call store.subscribe() while the reducer is executing. ' + 'If you would like to be notified after the store has been updated, subscribe from a ' + 'component and invoke store.getState() in the callback to access the latest state. ' + 'See https://redux.js.org/api-reference/store#subscribe(listener) for more details.');
    }

    var isSubscribed = true;

    ensureCanMutateNextListeners();
    nextListeners.push(listener);

    return function unsubscribe() {
      if (!isSubscribed) {
        return;
      }

      if (isDispatching) {
        throw new Error('You may not unsubscribe from a store listener while the reducer is executing. ' + 'See https://redux.js.org/api-reference/store#subscribe(listener) for more details.');
      }

      isSubscribed = false;

      ensureCanMutateNextListeners();
      var index = nextListeners.indexOf(listener);
      nextListeners.splice(index, 1);
    };
  }

  /**
   * Dispatches an action. It is the only way to trigger a state change.
   *
   * The `reducer` function, used to create the store, will be called with the
   * current state tree and the given `action`. Its return value will
   * be considered the **next** state of the tree, and the change listeners
   * will be notified.
   *
   * The base implementation only supports plain object actions. If you want to
   * dispatch a Promise, an Observable, a thunk, or something else, you need to
   * wrap your store creating function into the corresponding middleware. For
   * example, see the documentation for the `redux-thunk` package. Even the
   * middleware will eventually dispatch plain object actions using this method.
   *
   * @param {Object} action A plain object representing “what changed”. It is
   * a good idea to keep actions serializable so you can record and replay user
   * sessions, or use the time travelling `redux-devtools`. An action must have
   * a `type` property which may not be `undefined`. It is a good idea to use
   * string constants for action types.
   *
   * @returns {Object} For convenience, the same action object you dispatched.
   *
   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
   * return something else (for example, a Promise you can await).
   */
  function dispatch(action) {
    if (!isPlainObject(action)) {
      throw new Error('Actions must be plain objects. ' + 'Use custom middleware for async actions.');
    }

    if (typeof action.type === 'undefined') {
      throw new Error('Actions may not have an undefined "type" property. ' + 'Have you misspelled a constant?');
    }

    if (isDispatching) {
      throw new Error('Reducers may not dispatch actions.');
    }

    try {
      isDispatching = true;
      currentState = currentReducer(currentState, action);
    } finally {
      isDispatching = false;
    }

    var listeners = currentListeners = nextListeners;
    for (var i = 0; i < listeners.length; i++) {
      var listener = listeners[i];
      listener();
    }

    return action;
  }

  /**
   * Replaces the reducer currently used by the store to calculate the state.
   *
   * You might need this if your app implements code splitting and you want to
   * load some of the reducers dynamically. You might also need this if you
   * implement a hot reloading mechanism for Redux.
   *
   * @param {Function} nextReducer The reducer for the store to use instead.
   * @returns {void}
   */
  function replaceReducer(nextReducer) {
    if (typeof nextReducer !== 'function') {
      throw new Error('Expected the nextReducer to be a function.');
    }

    currentReducer = nextReducer;
    dispatch({ type: ActionTypes.REPLACE });
  }

  /**
   * Interoperability point for observable/reactive libraries.
   * @returns {observable} A minimal observable of state changes.
   * For more information, see the observable proposal:
   * https://github.com/tc39/proposal-observable
   */
  function observable() {
    var _ref;

    var outerSubscribe = subscribe;
    return _ref = {
      /**
       * The minimal observable subscription method.
       * @param {Object} observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns {subscription} An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */
      subscribe: function subscribe(observer) {
        if ((typeof observer === 'undefined' ? 'undefined' : _typeof(observer)) !== 'object' || observer === null) {
          throw new TypeError('Expected the observer to be an object.');
        }

        function observeState() {
          if (observer.next) {
            observer.next(getState());
          }
        }

        observeState();
        var unsubscribe = outerSubscribe(observeState);
        return { unsubscribe: unsubscribe };
      }
    }, _ref[__WEBPACK_IMPORTED_MODULE_0_symbol_observable__["a" /* default */]] = function () {
      return this;
    }, _ref;
  }

  // When a store is created, an "INIT" action is dispatched so that every
  // reducer returns their initial state. This effectively populates
  // the initial state tree.
  dispatch({ type: ActionTypes.INIT });

  return _ref2 = {
    dispatch: dispatch,
    subscribe: subscribe,
    getState: getState,
    replaceReducer: replaceReducer
  }, _ref2[__WEBPACK_IMPORTED_MODULE_0_symbol_observable__["a" /* default */]] = observable, _ref2;
}

/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */
function warning(message) {
  /* eslint-disable no-console */
  if (typeof console !== 'undefined' && typeof console.error === 'function') {
    console.error(message);
  }
  /* eslint-enable no-console */
  try {
    // This error was thrown as a convenience so that if you enable
    // "break on all exceptions" in your console,
    // it would pause the execution at this line.
    throw new Error(message);
  } catch (e) {} // eslint-disable-line no-empty
}

function getUndefinedStateErrorMessage(key, action) {
  var actionType = action && action.type;
  var actionDescription = actionType && 'action "' + String(actionType) + '"' || 'an action';

  return 'Given ' + actionDescription + ', reducer "' + key + '" returned undefined. ' + 'To ignore an action, you must explicitly return the previous state. ' + 'If you want this reducer to hold no value, you can return null instead of undefined.';
}

function getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
  var reducerKeys = Object.keys(reducers);
  var argumentName = action && action.type === ActionTypes.INIT ? 'preloadedState argument passed to createStore' : 'previous state received by the reducer';

  if (reducerKeys.length === 0) {
    return 'Store does not have a valid reducer. Make sure the argument passed ' + 'to combineReducers is an object whose values are reducers.';
  }

  if (!isPlainObject(inputState)) {
    return 'The ' + argumentName + ' has unexpected type of "' + {}.toString.call(inputState).match(/\s([a-z|A-Z]+)/)[1] + '". Expected argument to be an object with the following ' + ('keys: "' + reducerKeys.join('", "') + '"');
  }

  var unexpectedKeys = Object.keys(inputState).filter(function (key) {
    return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
  });

  unexpectedKeys.forEach(function (key) {
    unexpectedKeyCache[key] = true;
  });

  if (action && action.type === ActionTypes.REPLACE) return;

  if (unexpectedKeys.length > 0) {
    return 'Unexpected ' + (unexpectedKeys.length > 1 ? 'keys' : 'key') + ' ' + ('"' + unexpectedKeys.join('", "') + '" found in ' + argumentName + '. ') + 'Expected to find one of the known reducer keys instead: ' + ('"' + reducerKeys.join('", "') + '". Unexpected keys will be ignored.');
  }
}

function assertReducerShape(reducers) {
  Object.keys(reducers).forEach(function (key) {
    var reducer = reducers[key];
    var initialState = reducer(undefined, { type: ActionTypes.INIT });

    if (typeof initialState === 'undefined') {
      throw new Error('Reducer "' + key + '" returned undefined during initialization. ' + 'If the state passed to the reducer is undefined, you must ' + 'explicitly return the initial state. The initial state may ' + 'not be undefined. If you don\'t want to set a value for this reducer, ' + 'you can use null instead of undefined.');
    }

    var type = '@@redux/PROBE_UNKNOWN_ACTION_' + Math.random().toString(36).substring(7).split('').join('.');
    if (typeof reducer(undefined, { type: type }) === 'undefined') {
      throw new Error('Reducer "' + key + '" returned undefined when probed with a random type. ' + ('Don\'t try to handle ' + ActionTypes.INIT + ' or other actions in "redux/*" ') + 'namespace. They are considered private. Instead, you must return the ' + 'current state for any unknown actions, unless it is undefined, ' + 'in which case you must return the initial state, regardless of the ' + 'action type. The initial state may not be undefined, but can be null.');
    }
  });
}

/**
 * Turns an object whose values are different reducer functions, into a single
 * reducer function. It will call every child reducer, and gather their results
 * into a single state object, whose keys correspond to the keys of the passed
 * reducer functions.
 *
 * @param {Object} reducers An object whose values correspond to different
 * reducer functions that need to be combined into one. One handy way to obtain
 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
 * undefined for any action. Instead, they should return their initial state
 * if the state passed to them was undefined, and the current state for any
 * unrecognized action.
 *
 * @returns {Function} A reducer function that invokes every reducer inside the
 * passed object, and builds a state object with the same shape.
 */
function combineReducers(reducers) {
  var reducerKeys = Object.keys(reducers);
  var finalReducers = {};
  for (var i = 0; i < reducerKeys.length; i++) {
    var key = reducerKeys[i];

    if (false) {
      if (typeof reducers[key] === 'undefined') {
        warning('No reducer provided for key "' + key + '"');
      }
    }

    if (typeof reducers[key] === 'function') {
      finalReducers[key] = reducers[key];
    }
  }
  var finalReducerKeys = Object.keys(finalReducers);

  var unexpectedKeyCache = void 0;
  if (false) {
    unexpectedKeyCache = {};
  }

  var shapeAssertionError = void 0;
  try {
    assertReducerShape(finalReducers);
  } catch (e) {
    shapeAssertionError = e;
  }

  return function combination() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var action = arguments[1];

    if (shapeAssertionError) {
      throw shapeAssertionError;
    }

    if (false) {
      var warningMessage = getUnexpectedStateShapeWarningMessage(state, finalReducers, action, unexpectedKeyCache);
      if (warningMessage) {
        warning(warningMessage);
      }
    }

    var hasChanged = false;
    var nextState = {};
    for (var _i = 0; _i < finalReducerKeys.length; _i++) {
      var _key = finalReducerKeys[_i];
      var reducer = finalReducers[_key];
      var previousStateForKey = state[_key];
      var nextStateForKey = reducer(previousStateForKey, action);
      if (typeof nextStateForKey === 'undefined') {
        var errorMessage = getUndefinedStateErrorMessage(_key, action);
        throw new Error(errorMessage);
      }
      nextState[_key] = nextStateForKey;
      hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
    }
    return hasChanged ? nextState : state;
  };
}

function bindActionCreator(actionCreator, dispatch) {
  return function () {
    return dispatch(actionCreator.apply(this, arguments));
  };
}

/**
 * Turns an object whose values are action creators, into an object with the
 * same keys, but with every function wrapped into a `dispatch` call so they
 * may be invoked directly. This is just a convenience method, as you can call
 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
 *
 * For convenience, you can also pass a single function as the first argument,
 * and get a function in return.
 *
 * @param {Function|Object} actionCreators An object whose values are action
 * creator functions. One handy way to obtain it is to use ES6 `import * as`
 * syntax. You may also pass a single function.
 *
 * @param {Function} dispatch The `dispatch` function available on your Redux
 * store.
 *
 * @returns {Function|Object} The object mimicking the original object, but with
 * every action creator wrapped into the `dispatch` call. If you passed a
 * function as `actionCreators`, the return value will also be a single
 * function.
 */
function bindActionCreators(actionCreators, dispatch) {
  if (typeof actionCreators === 'function') {
    return bindActionCreator(actionCreators, dispatch);
  }

  if ((typeof actionCreators === 'undefined' ? 'undefined' : _typeof(actionCreators)) !== 'object' || actionCreators === null) {
    throw new Error('bindActionCreators expected an object or a function, instead received ' + (actionCreators === null ? 'null' : typeof actionCreators === 'undefined' ? 'undefined' : _typeof(actionCreators)) + '. ' + 'Did you write "import ActionCreators from" instead of "import * as ActionCreators from"?');
  }

  var keys = Object.keys(actionCreators);
  var boundActionCreators = {};
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    var actionCreator = actionCreators[key];
    if (typeof actionCreator === 'function') {
      boundActionCreators[key] = bindActionCreator(actionCreator, dispatch);
    }
  }
  return boundActionCreators;
}

/**
 * Composes single-argument functions from right to left. The rightmost
 * function can take multiple arguments as it provides the signature for
 * the resulting composite function.
 *
 * @param {...Function} funcs The functions to compose.
 * @returns {Function} A function obtained by composing the argument functions
 * from right to left. For example, compose(f, g, h) is identical to doing
 * (...args) => f(g(h(...args))).
 */

function compose() {
  for (var _len = arguments.length, funcs = Array(_len), _key = 0; _key < _len; _key++) {
    funcs[_key] = arguments[_key];
  }

  if (funcs.length === 0) {
    return function (arg) {
      return arg;
    };
  }

  if (funcs.length === 1) {
    return funcs[0];
  }

  return funcs.reduce(function (a, b) {
    return function () {
      return a(b.apply(undefined, arguments));
    };
  });
}

/**
 * Creates a store enhancer that applies middleware to the dispatch method
 * of the Redux store. This is handy for a variety of tasks, such as expressing
 * asynchronous actions in a concise manner, or logging every action payload.
 *
 * See `redux-thunk` package as an example of the Redux middleware.
 *
 * Because middleware is potentially asynchronous, this should be the first
 * store enhancer in the composition chain.
 *
 * Note that each middleware will be given the `dispatch` and `getState` functions
 * as named arguments.
 *
 * @param {...Function} middlewares The middleware chain to be applied.
 * @returns {Function} A store enhancer applying the middleware.
 */
function applyMiddleware() {
  for (var _len = arguments.length, middlewares = Array(_len), _key = 0; _key < _len; _key++) {
    middlewares[_key] = arguments[_key];
  }

  return function (createStore) {
    return function () {
      for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      var store = createStore.apply(undefined, args);
      var _dispatch = function dispatch() {
        throw new Error('Dispatching while constructing your middleware is not allowed. ' + 'Other middleware would not be applied to this dispatch.');
      };

      var middlewareAPI = {
        getState: store.getState,
        dispatch: function dispatch() {
          return _dispatch.apply(undefined, arguments);
        }
      };
      var chain = middlewares.map(function (middleware) {
        return middleware(middlewareAPI);
      });
      _dispatch = compose.apply(undefined, chain)(store.dispatch);

      return _extends({}, store, {
        dispatch: _dispatch
      });
    };
  };
}

/*
 * This is a dummy function to check if the function name has been altered by minification.
 * If the function has been minified and NODE_ENV !== 'production', warn the user.
 */
function isCrushed() {}

if (false) {
  warning("You are currently using minified code outside of NODE_ENV === 'production'. " + 'This means that you are running a slower development build of Redux. ' + 'You can use loose-envify (https://github.com/zertosh/loose-envify) for browserify ' + 'or DefinePlugin for webpack (http://stackoverflow.com/questions/30030031) ' + 'to ensure you have the correct code for your production build.');
}




/***/ }),
/* 160 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);


var createTransitionManager = function createTransitionManager() {
  var prompt = null;

  var setPrompt = function setPrompt(nextPrompt) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(prompt == null, 'A history supports only one prompt at a time');

    prompt = nextPrompt;

    return function () {
      if (prompt === nextPrompt) prompt = null;
    };
  };

  var confirmTransitionTo = function confirmTransitionTo(location, action, getUserConfirmation, callback) {
    // TODO: If another transition starts while we're still confirming
    // the previous one, we may end up in a weird state. Figure out the
    // best way to handle this.
    if (prompt != null) {
      var result = typeof prompt === 'function' ? prompt(location, action) : prompt;

      if (typeof result === 'string') {
        if (typeof getUserConfirmation === 'function') {
          getUserConfirmation(result, callback);
        } else {
          __WEBPACK_IMPORTED_MODULE_0_warning___default()(false, 'A history needs a getUserConfirmation function in order to use a prompt message');

          callback(true);
        }
      } else {
        // Return false from a transition hook to cancel the transition.
        callback(result !== false);
      }
    } else {
      callback(true);
    }
  };

  var listeners = [];

  var appendListener = function appendListener(fn) {
    var isActive = true;

    var listener = function listener() {
      if (isActive) fn.apply(undefined, arguments);
    };

    listeners.push(listener);

    return function () {
      isActive = false;
      listeners = listeners.filter(function (item) {
        return item !== listener;
      });
    };
  };

  var notifyListeners = function notifyListeners() {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    listeners.forEach(function (listener) {
      return listener.apply(undefined, args);
    });
  };

  return {
    setPrompt: setPrompt,
    confirmTransitionTo: confirmTransitionTo,
    appendListener: appendListener,
    notifyListeners: notifyListeners
  };
};

/* harmony default export */ __webpack_exports__["a"] = (createTransitionManager);

/***/ }),
/* 161 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = warning;
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */
function warning(message) {
  /* eslint-disable no-console */
  if (typeof console !== 'undefined' && typeof console.error === 'function') {
    console.error(message);
  }
  /* eslint-enable no-console */
  try {
    // This error was thrown as a convenience so that if you enable
    // "break on all exceptions" in your console,
    // it would pause the execution at this line.
    throw new Error(message);
    /* eslint-disable no-empty */
  } catch (e) {}
  /* eslint-enable no-empty */
}

/***/ }),
/* 162 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Router__ = __webpack_require__(163);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Router__["a" /* default */]);

/***/ }),
/* 163 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






/**
 * The public API for putting history on context.
 */

var Router = function (_React$Component) {
  _inherits(Router, _React$Component);

  function Router() {
    var _temp, _this, _ret;

    _classCallCheck(this, Router);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
      match: _this.computeMatch(_this.props.history.location.pathname)
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Router.prototype.getChildContext = function getChildContext() {
    return {
      router: _extends({}, this.context.router, {
        history: this.props.history,
        route: {
          location: this.props.history.location,
          match: this.state.match
        }
      })
    };
  };

  Router.prototype.computeMatch = function computeMatch(pathname) {
    return {
      path: "/",
      url: "/",
      params: {},
      isExact: pathname === "/"
    };
  };

  Router.prototype.componentWillMount = function componentWillMount() {
    var _this2 = this;

    var _props = this.props,
        children = _props.children,
        history = _props.history;


    __WEBPACK_IMPORTED_MODULE_1_invariant___default()(children == null || __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.count(children) === 1, "A <Router> may have only one child element");

    // Do this here so we can setState when a <Redirect> changes the
    // location in componentWillMount. This happens e.g. when doing
    // server rendering using a <StaticRouter>.
    this.unlisten = history.listen(function () {
      _this2.setState({
        match: _this2.computeMatch(history.location.pathname)
      });
    });
  };

  Router.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(this.props.history === nextProps.history, "You cannot change <Router history>");
  };

  Router.prototype.componentWillUnmount = function componentWillUnmount() {
    this.unlisten();
  };

  Router.prototype.render = function render() {
    var children = this.props.children;

    return children ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.only(children) : null;
  };

  return Router;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

Router.propTypes = {
  history: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
  children: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node
};
Router.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
};
Router.childContextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Router);

/***/ }),
/* 164 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_path_to_regexp__ = __webpack_require__(229);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_path_to_regexp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_path_to_regexp__);


var patternCache = {};
var cacheLimit = 10000;
var cacheCount = 0;

var compilePath = function compilePath(pattern, options) {
  var cacheKey = "" + options.end + options.strict + options.sensitive;
  var cache = patternCache[cacheKey] || (patternCache[cacheKey] = {});

  if (cache[pattern]) return cache[pattern];

  var keys = [];
  var re = __WEBPACK_IMPORTED_MODULE_0_path_to_regexp___default()(pattern, keys, options);
  var compiledPattern = { re: re, keys: keys };

  if (cacheCount < cacheLimit) {
    cache[pattern] = compiledPattern;
    cacheCount++;
  }

  return compiledPattern;
};

/**
 * Public API for matching a URL pathname to a path pattern.
 */
var matchPath = function matchPath(pathname) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var parent = arguments[2];

  if (typeof options === "string") options = { path: options };

  var _options = options,
      path = _options.path,
      _options$exact = _options.exact,
      exact = _options$exact === undefined ? false : _options$exact,
      _options$strict = _options.strict,
      strict = _options$strict === undefined ? false : _options$strict,
      _options$sensitive = _options.sensitive,
      sensitive = _options$sensitive === undefined ? false : _options$sensitive;


  if (path == null) return parent;

  var _compilePath = compilePath(path, { end: exact, strict: strict, sensitive: sensitive }),
      re = _compilePath.re,
      keys = _compilePath.keys;

  var match = re.exec(pathname);

  if (!match) return null;

  var url = match[0],
      values = match.slice(1);

  var isExact = pathname === url;

  if (exact && !isExact) return null;

  return {
    path: path, // the path pattern used to match
    url: path === "/" && url === "" ? "/" : url, // the matched portion of the URL
    isExact: isExact, // whether or not we matched exactly
    params: keys.reduce(function (memo, key, index) {
      memo[key.name] = values[index];
      return memo;
    }, {})
  };
};

/* harmony default export */ __webpack_exports__["a"] = (matchPath);

/***/ }),
/* 165 */
/***/ (function(module, exports) {

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

module.exports = _interopRequireWildcard;

/***/ }),
/* 166 */
/***/ (function(module, exports) {

function _typeof2(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof2 = function _typeof2(obj) { return typeof obj; }; } else { _typeof2 = function _typeof2(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof2(obj); }

function _typeof(obj) {
  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
    module.exports = _typeof = function _typeof(obj) {
      return _typeof2(obj);
    };
  } else {
    module.exports = _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : _typeof2(obj);
    };
  }

  return _typeof(obj);
}

module.exports = _typeof;

/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var getDisplayName = function getDisplayName(Component) {
  if (typeof Component === 'string') {
    return Component;
  }

  if (!Component) {
    return undefined;
  }

  return Component.displayName || Component.name || 'Component';
};

var _default = getDisplayName;
exports.default = _default;

/***/ }),
/* 168 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = toCss;

var _toCssValue = __webpack_require__(118);

var _toCssValue2 = _interopRequireDefault(_toCssValue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

/**
 * Indent a string.
 * http://jsperf.com/array-join-vs-for
 */
function indentStr(str, indent) {
  var result = '';
  for (var index = 0; index < indent; index++) {
    result += '  ';
  }return result + str;
}

/**
 * Converts a Rule to CSS string.
 */

function toCss(selector, style) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  var result = '';

  if (!style) return result;

  var _options$indent = options.indent,
      indent = _options$indent === undefined ? 0 : _options$indent;
  var fallbacks = style.fallbacks;


  indent++;

  // Apply fallbacks first.
  if (fallbacks) {
    // Array syntax {fallbacks: [{prop: value}]}
    if (Array.isArray(fallbacks)) {
      for (var index = 0; index < fallbacks.length; index++) {
        var fallback = fallbacks[index];
        for (var prop in fallback) {
          var value = fallback[prop];
          if (value != null) {
            result += '\n' + indentStr(prop + ': ' + (0, _toCssValue2['default'])(value) + ';', indent);
          }
        }
      }
    } else {
      // Object syntax {fallbacks: {prop: value}}
      for (var _prop in fallbacks) {
        var _value = fallbacks[_prop];
        if (_value != null) {
          result += '\n' + indentStr(_prop + ': ' + (0, _toCssValue2['default'])(_value) + ';', indent);
        }
      }
    }
  }

  for (var _prop2 in style) {
    var _value2 = style[_prop2];
    if (_value2 != null && _prop2 !== 'fallbacks') {
      result += '\n' + indentStr(_prop2 + ': ' + (0, _toCssValue2['default'])(_value2) + ';', indent);
    }
  }

  // Allow empty style in this case, because properties will be added dynamically.
  if (!result && !options.allowEmpty) return result;

  indent--;
  result = indentStr(selector + ' {' + result + '\n', indent) + indentStr('}', indent);

  return result;
}

/***/ }),
/* 169 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _SheetsRegistry = __webpack_require__(233);

var _SheetsRegistry2 = _interopRequireDefault(_SheetsRegistry);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

/**
 * This is a global sheets registry. Only DomRenderer will add sheets to it.
 * On the server one should use an own SheetsRegistry instance and add the
 * sheets to it, because you need to make sure to create a new registry for
 * each request in order to not leak sheets across requests.
 */
exports['default'] = new _SheetsRegistry2['default']();

/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _isInBrowser = __webpack_require__(120);

var _isInBrowser2 = _interopRequireDefault(_isInBrowser);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var js = ''; /**
              * Export javascript style and css style vendor prefixes.
              * Based on "transform" support test.
              */

var css = '';

// We should not do anything if required serverside.
if (_isInBrowser2['default']) {
  // Order matters. We need to check Webkit the last one because
  // other vendors use to add Webkit prefixes to some properties
  var jsCssMap = {
    Moz: '-moz-',
    // IE did it wrong again ...
    ms: '-ms-',
    O: '-o-',
    Webkit: '-webkit-'
  };
  var style = document.createElement('p').style;
  var testProp = 'Transform';

  for (var key in jsCssMap) {
    if (key + testProp in style) {
      js = key;
      css = jsCssMap[key];
      break;
    }
  }
}

/**
 * Vendor prefix string for the current browser.
 *
 * @type {{js: String, css: String}}
 * @api public
 */
exports['default'] = { js: js, css: css };

/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(2);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectSpread2 = _interopRequireDefault(__webpack_require__(17));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(4));

var _deepmerge = _interopRequireDefault(__webpack_require__(121));

var _isPlainObject = _interopRequireDefault(__webpack_require__(469));

var _warning = _interopRequireDefault(__webpack_require__(16));

var _createBreakpoints = _interopRequireDefault(__webpack_require__(92));

var _createMixins = _interopRequireDefault(__webpack_require__(471));

var _createPalette = _interopRequireDefault(__webpack_require__(472));

var _createTypography = _interopRequireDefault(__webpack_require__(478));

var _shadows = _interopRequireDefault(__webpack_require__(479));

var _shape = _interopRequireDefault(__webpack_require__(480));

var _spacing = _interopRequireDefault(__webpack_require__(481));

var _transitions = _interopRequireDefault(__webpack_require__(93));

var _zIndex = _interopRequireDefault(__webpack_require__(482));

// < 1kb payload overhead when lodash/merge is > 3kb.
function createMuiTheme() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _options$breakpoints = options.breakpoints,
      breakpointsInput = _options$breakpoints === void 0 ? {} : _options$breakpoints,
      _options$mixins = options.mixins,
      mixinsInput = _options$mixins === void 0 ? {} : _options$mixins,
      _options$palette = options.palette,
      paletteInput = _options$palette === void 0 ? {} : _options$palette,
      shadowsInput = options.shadows,
      _options$typography = options.typography,
      typographyInput = _options$typography === void 0 ? {} : _options$typography,
      other = (0, _objectWithoutProperties2.default)(options, ["breakpoints", "mixins", "palette", "shadows", "typography"]);
  var palette = (0, _createPalette.default)(paletteInput);
  var breakpoints = (0, _createBreakpoints.default)(breakpointsInput);
  var muiTheme = (0, _objectSpread2.default)({
    breakpoints: breakpoints,
    direction: 'ltr',
    mixins: (0, _createMixins.default)(breakpoints, _spacing.default, mixinsInput),
    overrides: {},
    // Inject custom styles
    palette: palette,
    props: {},
    // Inject custom properties
    shadows: shadowsInput || _shadows.default,
    typography: (0, _createTypography.default)(palette, typographyInput)
  }, (0, _deepmerge.default)({
    shape: _shape.default,
    spacing: _spacing.default,
    transitions: _transitions.default,
    zIndex: _zIndex.default
  }, other, {
    isMergeableObject: _isPlainObject.default
  }));
   false ? (0, _warning.default)(muiTheme.shadows.length === 25, 'Material-UI: the shadows array provided to createMuiTheme should support 25 elevations.') : void 0;
  return muiTheme;
}

var _default = createMuiTheme;
exports.default = _default;

/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(2);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.CHANNEL = void 0;

var _defineProperty2 = _interopRequireDefault(__webpack_require__(7));

var _propTypes = _interopRequireDefault(__webpack_require__(1));

// Same value used by react-jss
var CHANNEL = '__THEMING__';
exports.CHANNEL = CHANNEL;
var themeListener = {
  contextTypes: (0, _defineProperty2.default)({}, CHANNEL, _propTypes.default.object),
  initial: function initial(context) {
    if (!context[CHANNEL]) {
      return null;
    }

    return context[CHANNEL].getState();
  },
  subscribe: function subscribe(context, cb) {
    if (!context[CHANNEL]) {
      return null;
    }

    return context[CHANNEL].subscribe(cb);
  },
  unsubscribe: function unsubscribe(context, subscriptionId) {
    if (context[CHANNEL]) {
      context[CHANNEL].unsubscribe(subscriptionId);
    }
  }
};
var _default = themeListener;
exports.default = _default;

/***/ }),
/* 173 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(9);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(10));

var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
  d: "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
}), _react.default.createElement("path", {
  fill: "none",
  d: "M0 0h24v24H0z"
})), 'Close');

exports.default = _default;

/***/ }),
/* 174 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactLifecyclesCompat = __webpack_require__(244);

var _ChildMapping = __webpack_require__(504);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var values = Object.values || function (obj) {
  return Object.keys(obj).map(function (k) {
    return obj[k];
  });
};

var propTypes = {
  /**
   * `<TransitionGroup>` renders a `<div>` by default. You can change this
   * behavior by providing a `component` prop.
   * If you use React v16+ and would like to avoid a wrapping `<div>` element
   * you can pass in `component={null}`. This is useful if the wrapping div
   * borks your css styles.
   */
  component: _propTypes2.default.any,
  /**
   * A set of `<Transition>` components, that are toggled `in` and out as they
   * leave. the `<TransitionGroup>` will inject specific transition props, so
   * remember to spread them through if you are wrapping the `<Transition>` as
   * with our `<Fade>` example.
   */
  children: _propTypes2.default.node,

  /**
   * A convenience prop that enables or disables appear animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  appear: _propTypes2.default.bool,
  /**
   * A convenience prop that enables or disables enter animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  enter: _propTypes2.default.bool,
  /**
   * A convenience prop that enables or disables exit animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  exit: _propTypes2.default.bool,

  /**
   * You may need to apply reactive updates to a child as it is exiting.
   * This is generally done by using `cloneElement` however in the case of an exiting
   * child the element has already been removed and not accessible to the consumer.
   *
   * If you do need to update a child as it leaves you can provide a `childFactory`
   * to wrap every child, even the ones that are leaving.
   *
   * @type Function(child: ReactElement) -> ReactElement
   */
  childFactory: _propTypes2.default.func
};

var defaultProps = {
  component: 'div',
  childFactory: function childFactory(child) {
    return child;
  }

  /**
   * The `<TransitionGroup>` component manages a set of `<Transition>` components
   * in a list. Like with the `<Transition>` component, `<TransitionGroup>`, is a
   * state machine for managing the mounting and unmounting of components over
   * time.
   *
   * Consider the example below using the `Fade` CSS transition from before.
   * As items are removed or added to the TodoList the `in` prop is toggled
   * automatically by the `<TransitionGroup>`. You can use _any_ `<Transition>`
   * component in a `<TransitionGroup>`, not just css.
   *
   * ## Example
   *
   * <iframe src="https://codesandbox.io/embed/00rqyo26kn?fontsize=14" style="width:100%; height:500px; border:0; border-radius: 4px; overflow:hidden;" sandbox="allow-modals allow-forms allow-popups allow-scripts allow-same-origin"></iframe>
   *
   * Note that `<TransitionGroup>`  does not define any animation behavior!
   * Exactly _how_ a list item animates is up to the individual `<Transition>`
   * components. This means you can mix and match animations across different
   * list items.
   */
};
var TransitionGroup = function (_React$Component) {
  _inherits(TransitionGroup, _React$Component);

  function TransitionGroup(props, context) {
    _classCallCheck(this, TransitionGroup);

    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props, context));

    var handleExited = _this.handleExited.bind(_this);

    // Initial children should all be entering, dependent on appear
    _this.state = {
      handleExited: handleExited,
      firstRender: true
    };
    return _this;
  }

  TransitionGroup.prototype.getChildContext = function getChildContext() {
    return {
      transitionGroup: { isMounting: !this.appeared }
    };
  };

  TransitionGroup.prototype.componentDidMount = function componentDidMount() {
    this.appeared = true;
  };

  TransitionGroup.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, _ref) {
    var prevChildMapping = _ref.children,
        handleExited = _ref.handleExited,
        firstRender = _ref.firstRender;

    return {
      children: firstRender ? (0, _ChildMapping.getInitialChildMapping)(nextProps, handleExited) : (0, _ChildMapping.getNextChildMapping)(nextProps, prevChildMapping, handleExited),
      firstRender: false
    };
  };

  TransitionGroup.prototype.handleExited = function handleExited(child, node) {
    var currentChildMapping = (0, _ChildMapping.getChildMapping)(this.props.children);

    if (child.key in currentChildMapping) return;

    if (child.props.onExited) {
      child.props.onExited(node);
    }

    this.setState(function (state) {
      var children = _extends({}, state.children);

      delete children[child.key];
      return { children: children };
    });
  };

  TransitionGroup.prototype.render = function render() {
    var _props = this.props,
        Component = _props.component,
        childFactory = _props.childFactory,
        props = _objectWithoutProperties(_props, ['component', 'childFactory']);

    var children = values(this.state.children).map(childFactory);

    delete props.appear;
    delete props.enter;
    delete props.exit;

    if (Component === null) {
      return children;
    }
    return _react2.default.createElement(
      Component,
      props,
      children
    );
  };

  return TransitionGroup;
}(_react2.default.Component);

TransitionGroup.childContextTypes = {
  transitionGroup: _propTypes2.default.object.isRequired
};


TransitionGroup.propTypes =  false ? propTypes : {};
TransitionGroup.defaultProps = defaultProps;

exports.default = (0, _reactLifecyclesCompat.polyfill)(TransitionGroup);
module.exports = exports['default'];

/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(2);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Button.default;
  }
});

var _Button = _interopRequireDefault(__webpack_require__(512));

/***/ }),
/* 176 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles_withStyles__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_assets_jss_material_dashboard_pro_react_components_cardStyle_jsx__ = __webpack_require__(514);
function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}// nodejs library that concatenates classes
// nodejs library to set properties for components
// @material-ui/core components
// @material-ui/icons
// core components
function Card(_ref){var _classNames;var props=_objectWithoutProperties(_ref,[]);var classes=props.classes,className=props.className,children=props.children,plain=props.plain,profile=props.profile,blog=props.blog,raised=props.raised,background=props.background,pricing=props.pricing,color=props.color,product=props.product,testimonial=props.testimonial,chart=props.chart,login=props.login,rest=_objectWithoutProperties(props,["classes","className","children","plain","profile","blog","raised","background","pricing","color","product","testimonial","chart","login"]);var cardClasses=__WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classNames={},_defineProperty(_classNames,classes.card,true),_defineProperty(_classNames,classes.cardPlain,plain),_defineProperty(_classNames,classes.cardProfile,profile||testimonial),_defineProperty(_classNames,classes.cardBlog,blog),_defineProperty(_classNames,classes.cardRaised,raised),_defineProperty(_classNames,classes.cardBackground,background),_defineProperty(_classNames,classes.cardPricingColor,pricing&&color!==undefined||pricing&&background!==undefined),_defineProperty(_classNames,classes[color],color),_defineProperty(_classNames,classes.cardPricing,pricing),_defineProperty(_classNames,classes.cardProduct,product),_defineProperty(_classNames,classes.cardChart,chart),_defineProperty(_classNames,classes.cardLogin,login),_defineProperty(_classNames,className,className!==undefined),_classNames));return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",Object.assign({className:cardClasses},rest),children);}Card.propTypes={classes:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired,className:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,plain:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,profile:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,blog:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,raised:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,background:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,pricing:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,testimonial:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,color:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOf(["primary","info","success","warning","danger","rose"]),product:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,chart:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,login:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool};/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles_withStyles___default()(__WEBPACK_IMPORTED_MODULE_4_assets_jss_material_dashboard_pro_react_components_cardStyle_jsx__["a" /* default */])(Card));

/***/ }),
/* 177 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles_withStyles__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_assets_jss_material_dashboard_pro_react_components_cardBodyStyle_jsx__ = __webpack_require__(515);
function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}// nodejs library that concatenates classes
// nodejs library to set properties for components
// @material-ui/core components
// @material-ui/icons
// core components
function CardBody(_ref){var _classNames;var props=_objectWithoutProperties(_ref,[]);var classes=props.classes,className=props.className,children=props.children,background=props.background,plain=props.plain,formHorizontal=props.formHorizontal,pricing=props.pricing,signup=props.signup,color=props.color,profile=props.profile,calendar=props.calendar,rest=_objectWithoutProperties(props,["classes","className","children","background","plain","formHorizontal","pricing","signup","color","profile","calendar"]);var cardBodyClasses=__WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classNames={},_defineProperty(_classNames,classes.cardBody,true),_defineProperty(_classNames,classes.cardBodyBackground,background),_defineProperty(_classNames,classes.cardBodyPlain,plain),_defineProperty(_classNames,classes.cardBodyFormHorizontal,formHorizontal),_defineProperty(_classNames,classes.cardPricing,pricing),_defineProperty(_classNames,classes.cardSignup,signup),_defineProperty(_classNames,classes.cardBodyColor,color),_defineProperty(_classNames,classes.cardBodyProfile,profile),_defineProperty(_classNames,classes.cardBodyCalendar,calendar),_defineProperty(_classNames,className,className!==undefined),_classNames));return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",Object.assign({className:cardBodyClasses},rest),children);}CardBody.propTypes={classes:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired,className:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,background:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,plain:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,formHorizontal:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,pricing:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,signup:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,color:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,profile:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,calendar:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool};/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles_withStyles___default()(__WEBPACK_IMPORTED_MODULE_4_assets_jss_material_dashboard_pro_react_components_cardBodyStyle_jsx__["a" /* default */])(CardBody));

/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {

var utils = __webpack_require__(40);
var normalizeHeaderName = __webpack_require__(525);

var DEFAULT_CONTENT_TYPE = {
  'Content-Type': 'application/x-www-form-urlencoded'
};

function setContentTypeIfUnset(headers, value) {
  if (!utils.isUndefined(headers) && utils.isUndefined(headers['Content-Type'])) {
    headers['Content-Type'] = value;
  }
}

function getDefaultAdapter() {
  var adapter;
  if (typeof XMLHttpRequest !== 'undefined') {
    // For browsers use XHR adapter
    adapter = __webpack_require__(252);
  } else if (typeof process !== 'undefined') {
    // For node use HTTP adapter
    adapter = __webpack_require__(252);
  }
  return adapter;
}

var defaults = {
  adapter: getDefaultAdapter(),

  transformRequest: [function transformRequest(data, headers) {
    normalizeHeaderName(headers, 'Content-Type');
    if (utils.isFormData(data) ||
      utils.isArrayBuffer(data) ||
      utils.isBuffer(data) ||
      utils.isStream(data) ||
      utils.isFile(data) ||
      utils.isBlob(data)
    ) {
      return data;
    }
    if (utils.isArrayBufferView(data)) {
      return data.buffer;
    }
    if (utils.isURLSearchParams(data)) {
      setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
      return data.toString();
    }
    if (utils.isObject(data)) {
      setContentTypeIfUnset(headers, 'application/json;charset=utf-8');
      return JSON.stringify(data);
    }
    return data;
  }],

  transformResponse: [function transformResponse(data) {
    /*eslint no-param-reassign:0*/
    if (typeof data === 'string') {
      try {
        data = JSON.parse(data);
      } catch (e) { /* Ignore */ }
    }
    return data;
  }],

  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,

  xsrfCookieName: 'XSRF-TOKEN',
  xsrfHeaderName: 'X-XSRF-TOKEN',

  maxContentLength: -1,

  validateStatus: function validateStatus(status) {
    return status >= 200 && status < 300;
  }
};

defaults.headers = {
  common: {
    'Accept': 'application/json, text/plain, */*'
  }
};

utils.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
  defaults.headers[method] = {};
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  defaults.headers[method] = utils.merge(DEFAULT_CONTENT_TYPE);
});

module.exports = defaults;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(251)))

/***/ }),
/* 179 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AUTHENTICATE_USER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return REVOKE_USER; });
/* unused harmony export USER_DETAILS */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return USER_INFO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return USER_UPDATED; });
var AUTHENTICATE_USER='USER::AUTHENTICATE_USER';var REVOKE_USER='USER::REVOKE_USER';var USER_DETAILS='USER::DETAIL';var USER_INFO='USER::INFO';var USER_UPDATED='USER::UPDATED';

/***/ }),
/* 180 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return axiosProductionURLSetup; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return axiosTokenSetup; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return redirectWhenUnauthorized; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reducers_user_actions__ = __webpack_require__(52);
var axiosProductionURLSetup=function axiosProductionURLSetup(){if(true){if(Object({"NODE_ENV":"production","PUBLIC_URL":""}).REACT_APP_ENV==='STAGING'){__WEBPACK_IMPORTED_MODULE_0_axios___default.a.defaults.baseURL='https://ecstaging.herokuapp.com/api';}else{__WEBPACK_IMPORTED_MODULE_0_axios___default.a.defaults.baseURL='https://api.energycompany.com.br/api';}}};var axiosTokenSetup=function axiosTokenSetup(user){if(user.access_token){// only add Authorization header for logged in users, otherwise we get a 401 error trying to decode signature 'null'
__WEBPACK_IMPORTED_MODULE_0_axios___default.a.defaults.headers.common.Authorization='Bearer '+user.access_token;}};var redirectWhenUnauthorized=function redirectWhenUnauthorized(store){__WEBPACK_IMPORTED_MODULE_0_axios___default.a.interceptors.response.use(function(response){return response;},function(error){// Check error.response because axios does not send response
// when canceling pending requests via axios.CancelToken.source().
var landingPageAddress='/';var NOT_AUTHORIZED_ERROR=401;var PAYMENT_NEEDED_ERROR=402;var destination=void 0;if(error.response){if(error.response.status===NOT_AUTHORIZED_ERROR){store.dispatch(Object(__WEBPACK_IMPORTED_MODULE_1_reducers_user_actions__["d" /* logout */])());destination=landingPageAddress;}else if(error.response.status===PAYMENT_NEEDED_ERROR){store.dispatch(Object(__WEBPACK_IMPORTED_MODULE_1_reducers_user_actions__["d" /* logout */])());destination='/planos';}if(destination&&window.location.pathname!==landingPageAddress){window.location.href=destination;}}return Promise.reject(error);});};

/***/ }),
/* 181 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/*!
 * perfect-scrollbar v1.4.0
 * (c) 2018 Hyunje Jun
 * @license MIT
 */
function get(element) {
  return getComputedStyle(element);
}

function set(element, obj) {
  for (var key in obj) {
    var val = obj[key];
    if (typeof val === 'number') {
      val = val + "px";
    }
    element.style[key] = val;
  }
  return element;
}

function div(className) {
  var div = document.createElement('div');
  div.className = className;
  return div;
}

var elMatches =
  typeof Element !== 'undefined' &&
  (Element.prototype.matches ||
    Element.prototype.webkitMatchesSelector ||
    Element.prototype.mozMatchesSelector ||
    Element.prototype.msMatchesSelector);

function matches(element, query) {
  if (!elMatches) {
    throw new Error('No element matching method supported');
  }

  return elMatches.call(element, query);
}

function remove(element) {
  if (element.remove) {
    element.remove();
  } else {
    if (element.parentNode) {
      element.parentNode.removeChild(element);
    }
  }
}

function queryChildren(element, selector) {
  return Array.prototype.filter.call(element.children, function (child) { return matches(child, selector); }
  );
}

var cls = {
  main: 'ps',
  element: {
    thumb: function (x) { return ("ps__thumb-" + x); },
    rail: function (x) { return ("ps__rail-" + x); },
    consuming: 'ps__child--consume',
  },
  state: {
    focus: 'ps--focus',
    clicking: 'ps--clicking',
    active: function (x) { return ("ps--active-" + x); },
    scrolling: function (x) { return ("ps--scrolling-" + x); },
  },
};

/*
 * Helper methods
 */
var scrollingClassTimeout = { x: null, y: null };

function addScrollingClass(i, x) {
  var classList = i.element.classList;
  var className = cls.state.scrolling(x);

  if (classList.contains(className)) {
    clearTimeout(scrollingClassTimeout[x]);
  } else {
    classList.add(className);
  }
}

function removeScrollingClass(i, x) {
  scrollingClassTimeout[x] = setTimeout(
    function () { return i.isAlive && i.element.classList.remove(cls.state.scrolling(x)); },
    i.settings.scrollingThreshold
  );
}

function setScrollingClassInstantly(i, x) {
  addScrollingClass(i, x);
  removeScrollingClass(i, x);
}

var EventElement = function EventElement(element) {
  this.element = element;
  this.handlers = {};
};

var prototypeAccessors = { isEmpty: { configurable: true } };

EventElement.prototype.bind = function bind (eventName, handler) {
  if (typeof this.handlers[eventName] === 'undefined') {
    this.handlers[eventName] = [];
  }
  this.handlers[eventName].push(handler);
  this.element.addEventListener(eventName, handler, false);
};

EventElement.prototype.unbind = function unbind (eventName, target) {
    var this$1 = this;

  this.handlers[eventName] = this.handlers[eventName].filter(function (handler) {
    if (target && handler !== target) {
      return true;
    }
    this$1.element.removeEventListener(eventName, handler, false);
    return false;
  });
};

EventElement.prototype.unbindAll = function unbindAll () {
    var this$1 = this;

  for (var name in this$1.handlers) {
    this$1.unbind(name);
  }
};

prototypeAccessors.isEmpty.get = function () {
    var this$1 = this;

  return Object.keys(this.handlers).every(
    function (key) { return this$1.handlers[key].length === 0; }
  );
};

Object.defineProperties( EventElement.prototype, prototypeAccessors );

var EventManager = function EventManager() {
  this.eventElements = [];
};

EventManager.prototype.eventElement = function eventElement (element) {
  var ee = this.eventElements.filter(function (ee) { return ee.element === element; })[0];
  if (!ee) {
    ee = new EventElement(element);
    this.eventElements.push(ee);
  }
  return ee;
};

EventManager.prototype.bind = function bind (element, eventName, handler) {
  this.eventElement(element).bind(eventName, handler);
};

EventManager.prototype.unbind = function unbind (element, eventName, handler) {
  var ee = this.eventElement(element);
  ee.unbind(eventName, handler);

  if (ee.isEmpty) {
    // remove
    this.eventElements.splice(this.eventElements.indexOf(ee), 1);
  }
};

EventManager.prototype.unbindAll = function unbindAll () {
  this.eventElements.forEach(function (e) { return e.unbindAll(); });
  this.eventElements = [];
};

EventManager.prototype.once = function once (element, eventName, handler) {
  var ee = this.eventElement(element);
  var onceHandler = function (evt) {
    ee.unbind(eventName, onceHandler);
    handler(evt);
  };
  ee.bind(eventName, onceHandler);
};

function createEvent(name) {
  if (typeof window.CustomEvent === 'function') {
    return new CustomEvent(name);
  } else {
    var evt = document.createEvent('CustomEvent');
    evt.initCustomEvent(name, false, false, undefined);
    return evt;
  }
}

var processScrollDiff = function(
  i,
  axis,
  diff,
  useScrollingClass,
  forceFireReachEvent
) {
  if ( useScrollingClass === void 0 ) useScrollingClass = true;
  if ( forceFireReachEvent === void 0 ) forceFireReachEvent = false;

  var fields;
  if (axis === 'top') {
    fields = [
      'contentHeight',
      'containerHeight',
      'scrollTop',
      'y',
      'up',
      'down' ];
  } else if (axis === 'left') {
    fields = [
      'contentWidth',
      'containerWidth',
      'scrollLeft',
      'x',
      'left',
      'right' ];
  } else {
    throw new Error('A proper axis should be provided');
  }

  processScrollDiff$1(i, diff, fields, useScrollingClass, forceFireReachEvent);
};

function processScrollDiff$1(
  i,
  diff,
  ref,
  useScrollingClass,
  forceFireReachEvent
) {
  var contentHeight = ref[0];
  var containerHeight = ref[1];
  var scrollTop = ref[2];
  var y = ref[3];
  var up = ref[4];
  var down = ref[5];
  if ( useScrollingClass === void 0 ) useScrollingClass = true;
  if ( forceFireReachEvent === void 0 ) forceFireReachEvent = false;

  var element = i.element;

  // reset reach
  i.reach[y] = null;

  // 1 for subpixel rounding
  if (element[scrollTop] < 1) {
    i.reach[y] = 'start';
  }

  // 1 for subpixel rounding
  if (element[scrollTop] > i[contentHeight] - i[containerHeight] - 1) {
    i.reach[y] = 'end';
  }

  if (diff) {
    element.dispatchEvent(createEvent(("ps-scroll-" + y)));

    if (diff < 0) {
      element.dispatchEvent(createEvent(("ps-scroll-" + up)));
    } else if (diff > 0) {
      element.dispatchEvent(createEvent(("ps-scroll-" + down)));
    }

    if (useScrollingClass) {
      setScrollingClassInstantly(i, y);
    }
  }

  if (i.reach[y] && (diff || forceFireReachEvent)) {
    element.dispatchEvent(createEvent(("ps-" + y + "-reach-" + (i.reach[y]))));
  }
}

function toInt(x) {
  return parseInt(x, 10) || 0;
}

function isEditable(el) {
  return (
    matches(el, 'input,[contenteditable]') ||
    matches(el, 'select,[contenteditable]') ||
    matches(el, 'textarea,[contenteditable]') ||
    matches(el, 'button,[contenteditable]')
  );
}

function outerWidth(element) {
  var styles = get(element);
  return (
    toInt(styles.width) +
    toInt(styles.paddingLeft) +
    toInt(styles.paddingRight) +
    toInt(styles.borderLeftWidth) +
    toInt(styles.borderRightWidth)
  );
}

var env = {
  isWebKit:
    typeof document !== 'undefined' &&
    'WebkitAppearance' in document.documentElement.style,
  supportsTouch:
    typeof window !== 'undefined' &&
    ('ontouchstart' in window ||
      (window.DocumentTouch && document instanceof window.DocumentTouch)),
  supportsIePointer:
    typeof navigator !== 'undefined' && navigator.msMaxTouchPoints,
  isChrome:
    typeof navigator !== 'undefined' &&
    /Chrome/i.test(navigator && navigator.userAgent),
};

var updateGeometry = function(i) {
  var element = i.element;
  var roundedScrollTop = Math.floor(element.scrollTop);

  i.containerWidth = element.clientWidth;
  i.containerHeight = element.clientHeight;
  i.contentWidth = element.scrollWidth;
  i.contentHeight = element.scrollHeight;

  if (!element.contains(i.scrollbarXRail)) {
    // clean up and append
    queryChildren(element, cls.element.rail('x')).forEach(function (el) { return remove(el); }
    );
    element.appendChild(i.scrollbarXRail);
  }
  if (!element.contains(i.scrollbarYRail)) {
    // clean up and append
    queryChildren(element, cls.element.rail('y')).forEach(function (el) { return remove(el); }
    );
    element.appendChild(i.scrollbarYRail);
  }

  if (
    !i.settings.suppressScrollX &&
    i.containerWidth + i.settings.scrollXMarginOffset < i.contentWidth
  ) {
    i.scrollbarXActive = true;
    i.railXWidth = i.containerWidth - i.railXMarginWidth;
    i.railXRatio = i.containerWidth / i.railXWidth;
    i.scrollbarXWidth = getThumbSize(
      i,
      toInt(i.railXWidth * i.containerWidth / i.contentWidth)
    );
    i.scrollbarXLeft = toInt(
      (i.negativeScrollAdjustment + element.scrollLeft) *
        (i.railXWidth - i.scrollbarXWidth) /
        (i.contentWidth - i.containerWidth)
    );
  } else {
    i.scrollbarXActive = false;
  }

  if (
    !i.settings.suppressScrollY &&
    i.containerHeight + i.settings.scrollYMarginOffset < i.contentHeight
  ) {
    i.scrollbarYActive = true;
    i.railYHeight = i.containerHeight - i.railYMarginHeight;
    i.railYRatio = i.containerHeight / i.railYHeight;
    i.scrollbarYHeight = getThumbSize(
      i,
      toInt(i.railYHeight * i.containerHeight / i.contentHeight)
    );
    i.scrollbarYTop = toInt(
      roundedScrollTop *
        (i.railYHeight - i.scrollbarYHeight) /
        (i.contentHeight - i.containerHeight)
    );
  } else {
    i.scrollbarYActive = false;
  }

  if (i.scrollbarXLeft >= i.railXWidth - i.scrollbarXWidth) {
    i.scrollbarXLeft = i.railXWidth - i.scrollbarXWidth;
  }
  if (i.scrollbarYTop >= i.railYHeight - i.scrollbarYHeight) {
    i.scrollbarYTop = i.railYHeight - i.scrollbarYHeight;
  }

  updateCss(element, i);

  if (i.scrollbarXActive) {
    element.classList.add(cls.state.active('x'));
  } else {
    element.classList.remove(cls.state.active('x'));
    i.scrollbarXWidth = 0;
    i.scrollbarXLeft = 0;
    element.scrollLeft = 0;
  }
  if (i.scrollbarYActive) {
    element.classList.add(cls.state.active('y'));
  } else {
    element.classList.remove(cls.state.active('y'));
    i.scrollbarYHeight = 0;
    i.scrollbarYTop = 0;
    element.scrollTop = 0;
  }
};

function getThumbSize(i, thumbSize) {
  if (i.settings.minScrollbarLength) {
    thumbSize = Math.max(thumbSize, i.settings.minScrollbarLength);
  }
  if (i.settings.maxScrollbarLength) {
    thumbSize = Math.min(thumbSize, i.settings.maxScrollbarLength);
  }
  return thumbSize;
}

function updateCss(element, i) {
  var xRailOffset = { width: i.railXWidth };
  var roundedScrollTop = Math.floor(element.scrollTop);

  if (i.isRtl) {
    xRailOffset.left =
      i.negativeScrollAdjustment +
      element.scrollLeft +
      i.containerWidth -
      i.contentWidth;
  } else {
    xRailOffset.left = element.scrollLeft;
  }
  if (i.isScrollbarXUsingBottom) {
    xRailOffset.bottom = i.scrollbarXBottom - roundedScrollTop;
  } else {
    xRailOffset.top = i.scrollbarXTop + roundedScrollTop;
  }
  set(i.scrollbarXRail, xRailOffset);

  var yRailOffset = { top: roundedScrollTop, height: i.railYHeight };
  if (i.isScrollbarYUsingRight) {
    if (i.isRtl) {
      yRailOffset.right =
        i.contentWidth -
        (i.negativeScrollAdjustment + element.scrollLeft) -
        i.scrollbarYRight -
        i.scrollbarYOuterWidth;
    } else {
      yRailOffset.right = i.scrollbarYRight - element.scrollLeft;
    }
  } else {
    if (i.isRtl) {
      yRailOffset.left =
        i.negativeScrollAdjustment +
        element.scrollLeft +
        i.containerWidth * 2 -
        i.contentWidth -
        i.scrollbarYLeft -
        i.scrollbarYOuterWidth;
    } else {
      yRailOffset.left = i.scrollbarYLeft + element.scrollLeft;
    }
  }
  set(i.scrollbarYRail, yRailOffset);

  set(i.scrollbarX, {
    left: i.scrollbarXLeft,
    width: i.scrollbarXWidth - i.railBorderXWidth,
  });
  set(i.scrollbarY, {
    top: i.scrollbarYTop,
    height: i.scrollbarYHeight - i.railBorderYWidth,
  });
}

var clickRail = function(i) {
  i.event.bind(i.scrollbarY, 'mousedown', function (e) { return e.stopPropagation(); });
  i.event.bind(i.scrollbarYRail, 'mousedown', function (e) {
    var positionTop =
      e.pageY -
      window.pageYOffset -
      i.scrollbarYRail.getBoundingClientRect().top;
    var direction = positionTop > i.scrollbarYTop ? 1 : -1;

    i.element.scrollTop += direction * i.containerHeight;
    updateGeometry(i);

    e.stopPropagation();
  });

  i.event.bind(i.scrollbarX, 'mousedown', function (e) { return e.stopPropagation(); });
  i.event.bind(i.scrollbarXRail, 'mousedown', function (e) {
    var positionLeft =
      e.pageX -
      window.pageXOffset -
      i.scrollbarXRail.getBoundingClientRect().left;
    var direction = positionLeft > i.scrollbarXLeft ? 1 : -1;

    i.element.scrollLeft += direction * i.containerWidth;
    updateGeometry(i);

    e.stopPropagation();
  });
};

var dragThumb = function(i) {
  bindMouseScrollHandler(i, [
    'containerWidth',
    'contentWidth',
    'pageX',
    'railXWidth',
    'scrollbarX',
    'scrollbarXWidth',
    'scrollLeft',
    'x',
    'scrollbarXRail' ]);
  bindMouseScrollHandler(i, [
    'containerHeight',
    'contentHeight',
    'pageY',
    'railYHeight',
    'scrollbarY',
    'scrollbarYHeight',
    'scrollTop',
    'y',
    'scrollbarYRail' ]);
};

function bindMouseScrollHandler(
  i,
  ref
) {
  var containerHeight = ref[0];
  var contentHeight = ref[1];
  var pageY = ref[2];
  var railYHeight = ref[3];
  var scrollbarY = ref[4];
  var scrollbarYHeight = ref[5];
  var scrollTop = ref[6];
  var y = ref[7];
  var scrollbarYRail = ref[8];

  var element = i.element;

  var startingScrollTop = null;
  var startingMousePageY = null;
  var scrollBy = null;

  function mouseMoveHandler(e) {
    element[scrollTop] =
      startingScrollTop + scrollBy * (e[pageY] - startingMousePageY);
    addScrollingClass(i, y);
    updateGeometry(i);

    e.stopPropagation();
    e.preventDefault();
  }

  function mouseUpHandler() {
    removeScrollingClass(i, y);
    i[scrollbarYRail].classList.remove(cls.state.clicking);
    i.event.unbind(i.ownerDocument, 'mousemove', mouseMoveHandler);
  }

  i.event.bind(i[scrollbarY], 'mousedown', function (e) {
    startingScrollTop = element[scrollTop];
    startingMousePageY = e[pageY];
    scrollBy =
      (i[contentHeight] - i[containerHeight]) /
      (i[railYHeight] - i[scrollbarYHeight]);

    i.event.bind(i.ownerDocument, 'mousemove', mouseMoveHandler);
    i.event.once(i.ownerDocument, 'mouseup', mouseUpHandler);

    i[scrollbarYRail].classList.add(cls.state.clicking);

    e.stopPropagation();
    e.preventDefault();
  });
}

var keyboard = function(i) {
  var element = i.element;

  var elementHovered = function () { return matches(element, ':hover'); };
  var scrollbarFocused = function () { return matches(i.scrollbarX, ':focus') || matches(i.scrollbarY, ':focus'); };

  function shouldPreventDefault(deltaX, deltaY) {
    var scrollTop = Math.floor(element.scrollTop);
    if (deltaX === 0) {
      if (!i.scrollbarYActive) {
        return false;
      }
      if (
        (scrollTop === 0 && deltaY > 0) ||
        (scrollTop >= i.contentHeight - i.containerHeight && deltaY < 0)
      ) {
        return !i.settings.wheelPropagation;
      }
    }

    var scrollLeft = element.scrollLeft;
    if (deltaY === 0) {
      if (!i.scrollbarXActive) {
        return false;
      }
      if (
        (scrollLeft === 0 && deltaX < 0) ||
        (scrollLeft >= i.contentWidth - i.containerWidth && deltaX > 0)
      ) {
        return !i.settings.wheelPropagation;
      }
    }
    return true;
  }

  i.event.bind(i.ownerDocument, 'keydown', function (e) {
    if (
      (e.isDefaultPrevented && e.isDefaultPrevented()) ||
      e.defaultPrevented
    ) {
      return;
    }

    if (!elementHovered() && !scrollbarFocused()) {
      return;
    }

    var activeElement = document.activeElement
      ? document.activeElement
      : i.ownerDocument.activeElement;
    if (activeElement) {
      if (activeElement.tagName === 'IFRAME') {
        activeElement = activeElement.contentDocument.activeElement;
      } else {
        // go deeper if element is a webcomponent
        while (activeElement.shadowRoot) {
          activeElement = activeElement.shadowRoot.activeElement;
        }
      }
      if (isEditable(activeElement)) {
        return;
      }
    }

    var deltaX = 0;
    var deltaY = 0;

    switch (e.which) {
      case 37: // left
        if (e.metaKey) {
          deltaX = -i.contentWidth;
        } else if (e.altKey) {
          deltaX = -i.containerWidth;
        } else {
          deltaX = -30;
        }
        break;
      case 38: // up
        if (e.metaKey) {
          deltaY = i.contentHeight;
        } else if (e.altKey) {
          deltaY = i.containerHeight;
        } else {
          deltaY = 30;
        }
        break;
      case 39: // right
        if (e.metaKey) {
          deltaX = i.contentWidth;
        } else if (e.altKey) {
          deltaX = i.containerWidth;
        } else {
          deltaX = 30;
        }
        break;
      case 40: // down
        if (e.metaKey) {
          deltaY = -i.contentHeight;
        } else if (e.altKey) {
          deltaY = -i.containerHeight;
        } else {
          deltaY = -30;
        }
        break;
      case 32: // space bar
        if (e.shiftKey) {
          deltaY = i.containerHeight;
        } else {
          deltaY = -i.containerHeight;
        }
        break;
      case 33: // page up
        deltaY = i.containerHeight;
        break;
      case 34: // page down
        deltaY = -i.containerHeight;
        break;
      case 36: // home
        deltaY = i.contentHeight;
        break;
      case 35: // end
        deltaY = -i.contentHeight;
        break;
      default:
        return;
    }

    if (i.settings.suppressScrollX && deltaX !== 0) {
      return;
    }
    if (i.settings.suppressScrollY && deltaY !== 0) {
      return;
    }

    element.scrollTop -= deltaY;
    element.scrollLeft += deltaX;
    updateGeometry(i);

    if (shouldPreventDefault(deltaX, deltaY)) {
      e.preventDefault();
    }
  });
};

var wheel = function(i) {
  var element = i.element;

  function shouldPreventDefault(deltaX, deltaY) {
    var roundedScrollTop = Math.floor(element.scrollTop);
    var isTop = element.scrollTop === 0;
    var isBottom =
      roundedScrollTop + element.offsetHeight === element.scrollHeight;
    var isLeft = element.scrollLeft === 0;
    var isRight =
      element.scrollLeft + element.offsetWidth === element.scrollWidth;

    var hitsBound;

    // pick axis with primary direction
    if (Math.abs(deltaY) > Math.abs(deltaX)) {
      hitsBound = isTop || isBottom;
    } else {
      hitsBound = isLeft || isRight;
    }

    return hitsBound ? !i.settings.wheelPropagation : true;
  }

  function getDeltaFromEvent(e) {
    var deltaX = e.deltaX;
    var deltaY = -1 * e.deltaY;

    if (typeof deltaX === 'undefined' || typeof deltaY === 'undefined') {
      // OS X Safari
      deltaX = -1 * e.wheelDeltaX / 6;
      deltaY = e.wheelDeltaY / 6;
    }

    if (e.deltaMode && e.deltaMode === 1) {
      // Firefox in deltaMode 1: Line scrolling
      deltaX *= 10;
      deltaY *= 10;
    }

    if (deltaX !== deltaX && deltaY !== deltaY /* NaN checks */) {
      // IE in some mouse drivers
      deltaX = 0;
      deltaY = e.wheelDelta;
    }

    if (e.shiftKey) {
      // reverse axis with shift key
      return [-deltaY, -deltaX];
    }
    return [deltaX, deltaY];
  }

  function shouldBeConsumedByChild(target, deltaX, deltaY) {
    // FIXME: this is a workaround for <select> issue in FF and IE #571
    if (!env.isWebKit && element.querySelector('select:focus')) {
      return true;
    }

    if (!element.contains(target)) {
      return false;
    }

    var cursor = target;

    while (cursor && cursor !== element) {
      if (cursor.classList.contains(cls.element.consuming)) {
        return true;
      }

      var style = get(cursor);
      var overflow = [style.overflow, style.overflowX, style.overflowY].join(
        ''
      );

      // if scrollable
      if (overflow.match(/(scroll|auto)/)) {
        var maxScrollTop = cursor.scrollHeight - cursor.clientHeight;
        if (maxScrollTop > 0) {
          if (
            !(cursor.scrollTop === 0 && deltaY > 0) &&
            !(cursor.scrollTop === maxScrollTop && deltaY < 0)
          ) {
            return true;
          }
        }
        var maxScrollLeft = cursor.scrollWidth - cursor.clientWidth;
        if (maxScrollLeft > 0) {
          if (
            !(cursor.scrollLeft === 0 && deltaX < 0) &&
            !(cursor.scrollLeft === maxScrollLeft && deltaX > 0)
          ) {
            return true;
          }
        }
      }

      cursor = cursor.parentNode;
    }

    return false;
  }

  function mousewheelHandler(e) {
    var ref = getDeltaFromEvent(e);
    var deltaX = ref[0];
    var deltaY = ref[1];

    if (shouldBeConsumedByChild(e.target, deltaX, deltaY)) {
      return;
    }

    var shouldPrevent = false;
    if (!i.settings.useBothWheelAxes) {
      // deltaX will only be used for horizontal scrolling and deltaY will
      // only be used for vertical scrolling - this is the default
      element.scrollTop -= deltaY * i.settings.wheelSpeed;
      element.scrollLeft += deltaX * i.settings.wheelSpeed;
    } else if (i.scrollbarYActive && !i.scrollbarXActive) {
      // only vertical scrollbar is active and useBothWheelAxes option is
      // active, so let's scroll vertical bar using both mouse wheel axes
      if (deltaY) {
        element.scrollTop -= deltaY * i.settings.wheelSpeed;
      } else {
        element.scrollTop += deltaX * i.settings.wheelSpeed;
      }
      shouldPrevent = true;
    } else if (i.scrollbarXActive && !i.scrollbarYActive) {
      // useBothWheelAxes and only horizontal bar is active, so use both
      // wheel axes for horizontal bar
      if (deltaX) {
        element.scrollLeft += deltaX * i.settings.wheelSpeed;
      } else {
        element.scrollLeft -= deltaY * i.settings.wheelSpeed;
      }
      shouldPrevent = true;
    }

    updateGeometry(i);

    shouldPrevent = shouldPrevent || shouldPreventDefault(deltaX, deltaY);
    if (shouldPrevent && !e.ctrlKey) {
      e.stopPropagation();
      e.preventDefault();
    }
  }

  if (typeof window.onwheel !== 'undefined') {
    i.event.bind(element, 'wheel', mousewheelHandler);
  } else if (typeof window.onmousewheel !== 'undefined') {
    i.event.bind(element, 'mousewheel', mousewheelHandler);
  }
};

var touch = function(i) {
  if (!env.supportsTouch && !env.supportsIePointer) {
    return;
  }

  var element = i.element;

  function shouldPrevent(deltaX, deltaY) {
    var scrollTop = Math.floor(element.scrollTop);
    var scrollLeft = element.scrollLeft;
    var magnitudeX = Math.abs(deltaX);
    var magnitudeY = Math.abs(deltaY);

    if (magnitudeY > magnitudeX) {
      // user is perhaps trying to swipe up/down the page

      if (
        (deltaY < 0 && scrollTop === i.contentHeight - i.containerHeight) ||
        (deltaY > 0 && scrollTop === 0)
      ) {
        // set prevent for mobile Chrome refresh
        return window.scrollY === 0 && deltaY > 0 && env.isChrome;
      }
    } else if (magnitudeX > magnitudeY) {
      // user is perhaps trying to swipe left/right across the page

      if (
        (deltaX < 0 && scrollLeft === i.contentWidth - i.containerWidth) ||
        (deltaX > 0 && scrollLeft === 0)
      ) {
        return true;
      }
    }

    return true;
  }

  function applyTouchMove(differenceX, differenceY) {
    element.scrollTop -= differenceY;
    element.scrollLeft -= differenceX;

    updateGeometry(i);
  }

  var startOffset = {};
  var startTime = 0;
  var speed = {};
  var easingLoop = null;

  function getTouch(e) {
    if (e.targetTouches) {
      return e.targetTouches[0];
    } else {
      // Maybe IE pointer
      return e;
    }
  }

  function shouldHandle(e) {
    if (e.pointerType && e.pointerType === 'pen' && e.buttons === 0) {
      return false;
    }
    if (e.targetTouches && e.targetTouches.length === 1) {
      return true;
    }
    if (
      e.pointerType &&
      e.pointerType !== 'mouse' &&
      e.pointerType !== e.MSPOINTER_TYPE_MOUSE
    ) {
      return true;
    }
    return false;
  }

  function touchStart(e) {
    if (!shouldHandle(e)) {
      return;
    }

    var touch = getTouch(e);

    startOffset.pageX = touch.pageX;
    startOffset.pageY = touch.pageY;

    startTime = new Date().getTime();

    if (easingLoop !== null) {
      clearInterval(easingLoop);
    }
  }

  function shouldBeConsumedByChild(target, deltaX, deltaY) {
    if (!element.contains(target)) {
      return false;
    }

    var cursor = target;

    while (cursor && cursor !== element) {
      if (cursor.classList.contains(cls.element.consuming)) {
        return true;
      }

      var style = get(cursor);
      var overflow = [style.overflow, style.overflowX, style.overflowY].join(
        ''
      );

      // if scrollable
      if (overflow.match(/(scroll|auto)/)) {
        var maxScrollTop = cursor.scrollHeight - cursor.clientHeight;
        if (maxScrollTop > 0) {
          if (
            !(cursor.scrollTop === 0 && deltaY > 0) &&
            !(cursor.scrollTop === maxScrollTop && deltaY < 0)
          ) {
            return true;
          }
        }
        var maxScrollLeft = cursor.scrollLeft - cursor.clientWidth;
        if (maxScrollLeft > 0) {
          if (
            !(cursor.scrollLeft === 0 && deltaX < 0) &&
            !(cursor.scrollLeft === maxScrollLeft && deltaX > 0)
          ) {
            return true;
          }
        }
      }

      cursor = cursor.parentNode;
    }

    return false;
  }

  function touchMove(e) {
    if (shouldHandle(e)) {
      var touch = getTouch(e);

      var currentOffset = { pageX: touch.pageX, pageY: touch.pageY };

      var differenceX = currentOffset.pageX - startOffset.pageX;
      var differenceY = currentOffset.pageY - startOffset.pageY;

      if (shouldBeConsumedByChild(e.target, differenceX, differenceY)) {
        return;
      }

      applyTouchMove(differenceX, differenceY);
      startOffset = currentOffset;

      var currentTime = new Date().getTime();

      var timeGap = currentTime - startTime;
      if (timeGap > 0) {
        speed.x = differenceX / timeGap;
        speed.y = differenceY / timeGap;
        startTime = currentTime;
      }

      if (shouldPrevent(differenceX, differenceY)) {
        e.preventDefault();
      }
    }
  }
  function touchEnd() {
    if (i.settings.swipeEasing) {
      clearInterval(easingLoop);
      easingLoop = setInterval(function() {
        if (i.isInitialized) {
          clearInterval(easingLoop);
          return;
        }

        if (!speed.x && !speed.y) {
          clearInterval(easingLoop);
          return;
        }

        if (Math.abs(speed.x) < 0.01 && Math.abs(speed.y) < 0.01) {
          clearInterval(easingLoop);
          return;
        }

        applyTouchMove(speed.x * 30, speed.y * 30);

        speed.x *= 0.8;
        speed.y *= 0.8;
      }, 10);
    }
  }

  if (env.supportsTouch) {
    i.event.bind(element, 'touchstart', touchStart);
    i.event.bind(element, 'touchmove', touchMove);
    i.event.bind(element, 'touchend', touchEnd);
  } else if (env.supportsIePointer) {
    if (window.PointerEvent) {
      i.event.bind(element, 'pointerdown', touchStart);
      i.event.bind(element, 'pointermove', touchMove);
      i.event.bind(element, 'pointerup', touchEnd);
    } else if (window.MSPointerEvent) {
      i.event.bind(element, 'MSPointerDown', touchStart);
      i.event.bind(element, 'MSPointerMove', touchMove);
      i.event.bind(element, 'MSPointerUp', touchEnd);
    }
  }
};

var defaultSettings = function () { return ({
  handlers: ['click-rail', 'drag-thumb', 'keyboard', 'wheel', 'touch'],
  maxScrollbarLength: null,
  minScrollbarLength: null,
  scrollingThreshold: 1000,
  scrollXMarginOffset: 0,
  scrollYMarginOffset: 0,
  suppressScrollX: false,
  suppressScrollY: false,
  swipeEasing: true,
  useBothWheelAxes: false,
  wheelPropagation: true,
  wheelSpeed: 1,
}); };

var handlers = {
  'click-rail': clickRail,
  'drag-thumb': dragThumb,
  keyboard: keyboard,
  wheel: wheel,
  touch: touch,
};

var PerfectScrollbar = function PerfectScrollbar(element, userSettings) {
  var this$1 = this;
  if ( userSettings === void 0 ) userSettings = {};

  if (typeof element === 'string') {
    element = document.querySelector(element);
  }

  if (!element || !element.nodeName) {
    throw new Error('no element is specified to initialize PerfectScrollbar');
  }

  this.element = element;

  element.classList.add(cls.main);

  this.settings = defaultSettings();
  for (var key in userSettings) {
    this$1.settings[key] = userSettings[key];
  }

  this.containerWidth = null;
  this.containerHeight = null;
  this.contentWidth = null;
  this.contentHeight = null;

  var focus = function () { return element.classList.add(cls.state.focus); };
  var blur = function () { return element.classList.remove(cls.state.focus); };

  this.isRtl = get(element).direction === 'rtl';
  this.isNegativeScroll = (function () {
    var originalScrollLeft = element.scrollLeft;
    var result = null;
    element.scrollLeft = -1;
    result = element.scrollLeft < 0;
    element.scrollLeft = originalScrollLeft;
    return result;
  })();
  this.negativeScrollAdjustment = this.isNegativeScroll
    ? element.scrollWidth - element.clientWidth
    : 0;
  this.event = new EventManager();
  this.ownerDocument = element.ownerDocument || document;

  this.scrollbarXRail = div(cls.element.rail('x'));
  element.appendChild(this.scrollbarXRail);
  this.scrollbarX = div(cls.element.thumb('x'));
  this.scrollbarXRail.appendChild(this.scrollbarX);
  this.scrollbarX.setAttribute('tabindex', 0);
  this.event.bind(this.scrollbarX, 'focus', focus);
  this.event.bind(this.scrollbarX, 'blur', blur);
  this.scrollbarXActive = null;
  this.scrollbarXWidth = null;
  this.scrollbarXLeft = null;
  var railXStyle = get(this.scrollbarXRail);
  this.scrollbarXBottom = parseInt(railXStyle.bottom, 10);
  if (isNaN(this.scrollbarXBottom)) {
    this.isScrollbarXUsingBottom = false;
    this.scrollbarXTop = toInt(railXStyle.top);
  } else {
    this.isScrollbarXUsingBottom = true;
  }
  this.railBorderXWidth =
    toInt(railXStyle.borderLeftWidth) + toInt(railXStyle.borderRightWidth);
  // Set rail to display:block to calculate margins
  set(this.scrollbarXRail, { display: 'block' });
  this.railXMarginWidth =
    toInt(railXStyle.marginLeft) + toInt(railXStyle.marginRight);
  set(this.scrollbarXRail, { display: '' });
  this.railXWidth = null;
  this.railXRatio = null;

  this.scrollbarYRail = div(cls.element.rail('y'));
  element.appendChild(this.scrollbarYRail);
  this.scrollbarY = div(cls.element.thumb('y'));
  this.scrollbarYRail.appendChild(this.scrollbarY);
  this.scrollbarY.setAttribute('tabindex', 0);
  this.event.bind(this.scrollbarY, 'focus', focus);
  this.event.bind(this.scrollbarY, 'blur', blur);
  this.scrollbarYActive = null;
  this.scrollbarYHeight = null;
  this.scrollbarYTop = null;
  var railYStyle = get(this.scrollbarYRail);
  this.scrollbarYRight = parseInt(railYStyle.right, 10);
  if (isNaN(this.scrollbarYRight)) {
    this.isScrollbarYUsingRight = false;
    this.scrollbarYLeft = toInt(railYStyle.left);
  } else {
    this.isScrollbarYUsingRight = true;
  }
  this.scrollbarYOuterWidth = this.isRtl ? outerWidth(this.scrollbarY) : null;
  this.railBorderYWidth =
    toInt(railYStyle.borderTopWidth) + toInt(railYStyle.borderBottomWidth);
  set(this.scrollbarYRail, { display: 'block' });
  this.railYMarginHeight =
    toInt(railYStyle.marginTop) + toInt(railYStyle.marginBottom);
  set(this.scrollbarYRail, { display: '' });
  this.railYHeight = null;
  this.railYRatio = null;

  this.reach = {
    x:
      element.scrollLeft <= 0
        ? 'start'
        : element.scrollLeft >= this.contentWidth - this.containerWidth
          ? 'end'
          : null,
    y:
      element.scrollTop <= 0
        ? 'start'
        : element.scrollTop >= this.contentHeight - this.containerHeight
          ? 'end'
          : null,
  };

  this.isAlive = true;

  this.settings.handlers.forEach(function (handlerName) { return handlers[handlerName](this$1); });

  this.lastScrollTop = Math.floor(element.scrollTop); // for onScroll only
  this.lastScrollLeft = element.scrollLeft; // for onScroll only
  this.event.bind(this.element, 'scroll', function (e) { return this$1.onScroll(e); });
  updateGeometry(this);
};

PerfectScrollbar.prototype.update = function update () {
  if (!this.isAlive) {
    return;
  }

  // Recalcuate negative scrollLeft adjustment
  this.negativeScrollAdjustment = this.isNegativeScroll
    ? this.element.scrollWidth - this.element.clientWidth
    : 0;

  // Recalculate rail margins
  set(this.scrollbarXRail, { display: 'block' });
  set(this.scrollbarYRail, { display: 'block' });
  this.railXMarginWidth =
    toInt(get(this.scrollbarXRail).marginLeft) +
    toInt(get(this.scrollbarXRail).marginRight);
  this.railYMarginHeight =
    toInt(get(this.scrollbarYRail).marginTop) +
    toInt(get(this.scrollbarYRail).marginBottom);

  // Hide scrollbars not to affect scrollWidth and scrollHeight
  set(this.scrollbarXRail, { display: 'none' });
  set(this.scrollbarYRail, { display: 'none' });

  updateGeometry(this);

  processScrollDiff(this, 'top', 0, false, true);
  processScrollDiff(this, 'left', 0, false, true);

  set(this.scrollbarXRail, { display: '' });
  set(this.scrollbarYRail, { display: '' });
};

PerfectScrollbar.prototype.onScroll = function onScroll (e) {
  if (!this.isAlive) {
    return;
  }

  updateGeometry(this);
  processScrollDiff(this, 'top', this.element.scrollTop - this.lastScrollTop);
  processScrollDiff(
    this,
    'left',
    this.element.scrollLeft - this.lastScrollLeft
  );

  this.lastScrollTop = Math.floor(this.element.scrollTop);
  this.lastScrollLeft = this.element.scrollLeft;
};

PerfectScrollbar.prototype.destroy = function destroy () {
  if (!this.isAlive) {
    return;
  }

  this.event.unbindAll();
  remove(this.scrollbarX);
  remove(this.scrollbarY);
  remove(this.scrollbarXRail);
  remove(this.scrollbarYRail);
  this.removePsClasses();

  // unset elements
  this.element = null;
  this.scrollbarX = null;
  this.scrollbarY = null;
  this.scrollbarXRail = null;
  this.scrollbarYRail = null;

  this.isAlive = false;
};

PerfectScrollbar.prototype.removePsClasses = function removePsClasses () {
  this.element.className = this.element.className
    .split(' ')
    .filter(function (name) { return !name.match(/^ps([-_].+|)$/); })
    .join(' ');
};

/* harmony default export */ __webpack_exports__["a"] = (PerfectScrollbar);


/***/ }),
/* 182 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(2);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _FormControl.default;
  }
});

var _FormControl = _interopRequireDefault(__webpack_require__(555));

/***/ }),
/* 183 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(2);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.hasValue = hasValue;
exports.isFilled = isFilled;
exports.isAdornedStart = isAdornedStart;
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(6));

var _objectSpread2 = _interopRequireDefault(__webpack_require__(17));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(7));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(4));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(11));

var _createClass2 = _interopRequireDefault(__webpack_require__(12));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(13));

var _inherits2 = _interopRequireDefault(__webpack_require__(14));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _classnames = _interopRequireDefault(__webpack_require__(5));

var _withStyles = _interopRequireDefault(__webpack_require__(3));

var _Textarea = _interopRequireDefault(__webpack_require__(556));

// Supports determination of isControlled().
// Controlled input accepts its current value as a prop.
//
// @see https://facebook.github.io/react/docs/forms.html#controlled-components
// @param value
// @returns {boolean} true if string (including '') or number (including zero)
function hasValue(value) {
  return value != null && !(Array.isArray(value) && value.length === 0);
} // Determine if field is empty or filled.
// Response determines if label is presented above field or as placeholder.
//
// @param obj
// @param SSR
// @returns {boolean} False when not present or empty string.
//                    True when any number or string with length.


function isFilled(obj) {
  var SSR = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  return obj && (hasValue(obj.value) && obj.value !== '' || SSR && hasValue(obj.defaultValue) && obj.defaultValue !== '');
} // Determine if an Input is adorned on start.
// It's corresponding to the left with LTR.
//
// @param obj
// @returns {boolean} False when no adornments.
//                    True when adorned at the start.


function isAdornedStart(obj) {
  return obj.startAdornment;
}

var styles = function styles(theme) {
  var light = theme.palette.type === 'light';
  var placeholder = {
    color: 'currentColor',
    opacity: light ? 0.42 : 0.5,
    transition: theme.transitions.create('opacity', {
      duration: theme.transitions.duration.shorter
    })
  };
  var placeholderHidden = {
    opacity: 0
  };
  var placeholderVisible = {
    opacity: light ? 0.42 : 0.5
  };
  var bottomLineColor = light ? 'rgba(0, 0, 0, 0.42)' : 'rgba(255, 255, 255, 0.7)';
  return {
    /* Styles applied to the root element. */
    root: {
      // Mimics the default input display property used by browsers for an input.
      display: 'inline-flex',
      position: 'relative',
      fontFamily: theme.typography.fontFamily,
      color: light ? 'rgba(0, 0, 0, 0.87)' : theme.palette.common.white,
      fontSize: theme.typography.pxToRem(16),
      lineHeight: '1.1875em',
      // Reset (19px), match the native input line-height
      '&$disabled': {
        color: theme.palette.text.disabled
      }
    },

    /* Styles applied to the root element if the component is a descendant of `FormControl`. */
    formControl: {
      'label + &': {
        marginTop: 16
      }
    },

    /* Styles applied to the root element if the component is focused. */
    focused: {},

    /* Styles applied to the root element if `disabled={true}`. */
    disabled: {},

    /* Styles applied to the root element if `disabledUnderline={false}`. */
    underline: {
      '&:after': {
        borderBottom: "2px solid ".concat(theme.palette.primary[light ? 'dark' : 'light']),
        left: 0,
        bottom: 0,
        // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
        content: '""',
        position: 'absolute',
        right: 0,
        transform: 'scaleX(0)',
        transition: theme.transitions.create('transform', {
          duration: theme.transitions.duration.shorter,
          easing: theme.transitions.easing.easeOut
        }),
        pointerEvents: 'none' // Transparent to the hover style.

      },
      '&$focused:after': {
        transform: 'scaleX(1)'
      },
      '&$error:after': {
        borderBottomColor: theme.palette.error.main,
        transform: 'scaleX(1)' // error is always underlined in red

      },
      '&:before': {
        borderBottom: "1px solid ".concat(bottomLineColor),
        left: 0,
        bottom: 0,
        // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
        content: '"\\00a0"',
        position: 'absolute',
        right: 0,
        transition: theme.transitions.create('border-bottom-color', {
          duration: theme.transitions.duration.shorter
        }),
        pointerEvents: 'none' // Transparent to the hover style.

      },
      '&:hover:not($disabled):not($focused):not($error):before': {
        borderBottom: "2px solid ".concat(theme.palette.text.primary)
      },
      '&$disabled:before': {
        borderBottom: "1px dotted ".concat(bottomLineColor)
      }
    },

    /* Styles applied to the root element if `error={true}`. */
    error: {},

    /* Styles applied to the root element if `multiline={true}`. */
    multiline: {
      padding: "".concat(8 - 2, "px 0 ").concat(8 - 1, "px")
    },

    /* Styles applied to the root element if `fullWidth={true}`. */
    fullWidth: {
      width: '100%'
    },

    /* Styles applied to the `input` element. */
    input: {
      font: 'inherit',
      color: 'currentColor',
      padding: "".concat(8 - 2, "px 0 ").concat(8 - 1, "px"),
      border: 0,
      boxSizing: 'content-box',
      verticalAlign: 'middle',
      background: 'none',
      margin: 0,
      // Reset for Safari
      // Remove grey highlight
      WebkitTapHighlightColor: 'transparent',
      display: 'block',
      // Make the flex item shrink with Firefox
      minWidth: 0,
      flexGrow: 1,
      '&::-webkit-input-placeholder': placeholder,
      '&::-moz-placeholder': placeholder,
      // Firefox 19+
      '&:-ms-input-placeholder': placeholder,
      // IE 11
      '&::-ms-input-placeholder': placeholder,
      // Edge
      '&:focus': {
        outline: 0
      },
      // Reset Firefox invalid required input style
      '&:invalid': {
        boxShadow: 'none'
      },
      '&::-webkit-search-decoration': {
        // Remove the padding when type=search.
        '-webkit-appearance': 'none'
      },
      // Show and hide the placeholder logic
      'label[data-shrink=false] + $formControl &': {
        '&::-webkit-input-placeholder': placeholderHidden,
        '&::-moz-placeholder': placeholderHidden,
        // Firefox 19+
        '&:-ms-input-placeholder': placeholderHidden,
        // IE 11
        '&::-ms-input-placeholder': placeholderHidden,
        // Edge
        '&:focus::-webkit-input-placeholder': placeholderVisible,
        '&:focus::-moz-placeholder': placeholderVisible,
        // Firefox 19+
        '&:focus:-ms-input-placeholder': placeholderVisible,
        // IE 11
        '&:focus::-ms-input-placeholder': placeholderVisible // Edge

      },
      '&$disabled': {
        opacity: 1 // Reset iOS opacity

      }
    },

    /* Styles applied to the `input` element if `margin="dense"`. */
    inputMarginDense: {
      paddingTop: 4 - 1
    },

    /* Styles applied to the `input` element if `multiline={true}`. */
    inputMultiline: {
      resize: 'none',
      padding: 0
    },

    /* Styles applied to the `input` element if `type` is not "text"`. */
    inputType: {
      // type="date" or type="time", etc. have specific styles we need to reset.
      height: '1.1875em' // Reset (19px), match the native input line-height

    },

    /* Styles applied to the `input` element if `type="search"`. */
    inputTypeSearch: {
      // Improve type search style.
      '-moz-appearance': 'textfield',
      '-webkit-appearance': 'textfield'
    }
  };
};

exports.styles = styles;

function formControlState(props, context) {
  var disabled = props.disabled;
  var error = props.error;
  var margin = props.margin;
  var required = props.required;

  if (context && context.muiFormControl) {
    if (typeof disabled === 'undefined') {
      disabled = context.muiFormControl.disabled;
    }

    if (typeof error === 'undefined') {
      error = context.muiFormControl.error;
    }

    if (typeof margin === 'undefined') {
      margin = context.muiFormControl.margin;
    }

    if (typeof required === 'undefined') {
      required = context.muiFormControl.required;
    }
  }

  return {
    disabled: disabled,
    error: error,
    margin: margin,
    required: required
  };
}

var Input =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(Input, _React$Component);

  // Holds the input reference
  function Input(props, context) {
    var _this;

    (0, _classCallCheck2.default)(this, Input);
    _this = (0, _possibleConstructorReturn2.default)(this, (Input.__proto__ || Object.getPrototypeOf(Input)).call(this, props, context));
    _this.isControlled = _this.props.value != null;
    _this.input = null;
    _this.state = {
      focused: false
    };

    _this.handleFocus = function (event) {
      // Fix a bug with IE11 where the focus/blur events are triggered
      // while the input is disabled.
      if (formControlState(_this.props, _this.context).disabled) {
        event.stopPropagation();
        return;
      }

      _this.setState({
        focused: true
      });

      if (_this.props.onFocus) {
        _this.props.onFocus(event);
      }

      var muiFormControl = _this.context.muiFormControl;

      if (muiFormControl && muiFormControl.onFocus) {
        muiFormControl.onFocus(event);
      }
    };

    _this.handleBlur = function (event) {
      _this.setState({
        focused: false
      });

      if (_this.props.onBlur) {
        _this.props.onBlur(event);
      }

      var muiFormControl = _this.context.muiFormControl;

      if (muiFormControl && muiFormControl.onBlur) {
        muiFormControl.onBlur(event);
      }
    };

    _this.handleChange = function (event) {
      if (!_this.isControlled) {
        _this.checkDirty(_this.inputRef);
      } // Perform in the willUpdate


      if (_this.props.onChange) {
        _this.props.onChange(event);
      }
    };

    _this.handleRefInput = function (ref) {
      _this.inputRef = ref;
      var refProp;

      if (_this.props.inputRef) {
        refProp = _this.props.inputRef;
      } else if (_this.props.inputProps && _this.props.inputProps.ref) {
        refProp = _this.props.inputProps.ref;
      }

      if (refProp) {
        if (typeof refProp === 'function') {
          refProp(ref);
        } else {
          refProp.current = ref;
        }
      }
    };

    if (_this.isControlled) {
      _this.checkDirty(props);
    }

    var componentWillReceiveProps = function componentWillReceiveProps(nextProps, nextContext) {
      // The blur won't fire when the disabled state is set on a focused input.
      // We need to book keep the focused state manually.
      if (!formControlState(_this.props, _this.context).disabled && formControlState(nextProps, nextContext).disabled) {
        _this.setState({
          focused: false
        });
      }
    };

    var componentWillUpdate = function componentWillUpdate(nextProps, nextState, nextContext) {
      // Book keep the focused state.
      if (!formControlState(_this.props, _this.context).disabled && formControlState(nextProps, nextContext).disabled) {
        var muiFormControl = _this.context.muiFormControl;

        if (muiFormControl && muiFormControl.onBlur) {
          muiFormControl.onBlur();
        }
      }
    }; // Support for react >= 16.3.0 && < 17.0.0

    /* istanbul ignore else */


    if (_react.default.createContext) {
      _this.UNSAFE_componentWillReceiveProps = componentWillReceiveProps;
      _this.UNSAFE_componentWillUpdate = componentWillUpdate;
    } else {
      _this.componentWillReceiveProps = componentWillReceiveProps;
      _this.componentWillUpdate = componentWillUpdate;
    }

    return _this;
  }

  (0, _createClass2.default)(Input, [{
    key: "getChildContext",
    value: function getChildContext() {
      // We are consuming the parent muiFormControl context.
      // We don't want a child to consume it a second time.
      return {
        muiFormControl: null
      };
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      if (!this.isControlled) {
        this.checkDirty(this.inputRef);
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      if (this.isControlled) {
        this.checkDirty(this.props);
      } // else performed in the onChange

    }
  }, {
    key: "checkDirty",
    value: function checkDirty(obj) {
      var muiFormControl = this.context.muiFormControl;

      if (isFilled(obj)) {
        if (muiFormControl && muiFormControl.onFilled) {
          muiFormControl.onFilled();
        }

        if (this.props.onFilled) {
          this.props.onFilled();
        }

        return;
      }

      if (muiFormControl && muiFormControl.onEmpty) {
        muiFormControl.onEmpty();
      }

      if (this.props.onEmpty) {
        this.props.onEmpty();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _classNames, _classNames2;

      var _props = this.props,
          autoComplete = _props.autoComplete,
          autoFocus = _props.autoFocus,
          classes = _props.classes,
          classNameProp = _props.className,
          defaultValue = _props.defaultValue,
          disabledProp = _props.disabled,
          disableUnderline = _props.disableUnderline,
          endAdornment = _props.endAdornment,
          errorProp = _props.error,
          fullWidth = _props.fullWidth,
          id = _props.id,
          inputComponent = _props.inputComponent,
          _props$inputProps = _props.inputProps;
      _props$inputProps = _props$inputProps === void 0 ? {} : _props$inputProps;
      var inputPropsClassName = _props$inputProps.className,
          inputPropsProp = (0, _objectWithoutProperties2.default)(_props$inputProps, ["className"]),
          inputRef = _props.inputRef,
          marginProp = _props.margin,
          multiline = _props.multiline,
          name = _props.name,
          onBlur = _props.onBlur,
          onChange = _props.onChange,
          onEmpty = _props.onEmpty,
          onFilled = _props.onFilled,
          onFocus = _props.onFocus,
          onKeyDown = _props.onKeyDown,
          onKeyUp = _props.onKeyUp,
          placeholder = _props.placeholder,
          readOnly = _props.readOnly,
          rows = _props.rows,
          rowsMax = _props.rowsMax,
          startAdornment = _props.startAdornment,
          type = _props.type,
          value = _props.value,
          other = (0, _objectWithoutProperties2.default)(_props, ["autoComplete", "autoFocus", "classes", "className", "defaultValue", "disabled", "disableUnderline", "endAdornment", "error", "fullWidth", "id", "inputComponent", "inputProps", "inputRef", "margin", "multiline", "name", "onBlur", "onChange", "onEmpty", "onFilled", "onFocus", "onKeyDown", "onKeyUp", "placeholder", "readOnly", "rows", "rowsMax", "startAdornment", "type", "value"]);
      var muiFormControl = this.context.muiFormControl;

      var _formControlState = formControlState(this.props, this.context),
          disabled = _formControlState.disabled,
          error = _formControlState.error,
          margin = _formControlState.margin,
          required = _formControlState.required;

      var className = (0, _classnames.default)(classes.root, (_classNames = {}, (0, _defineProperty2.default)(_classNames, classes.disabled, disabled), (0, _defineProperty2.default)(_classNames, classes.error, error), (0, _defineProperty2.default)(_classNames, classes.fullWidth, fullWidth), (0, _defineProperty2.default)(_classNames, classes.focused, this.state.focused), (0, _defineProperty2.default)(_classNames, classes.formControl, muiFormControl), (0, _defineProperty2.default)(_classNames, classes.multiline, multiline), (0, _defineProperty2.default)(_classNames, classes.underline, !disableUnderline), _classNames), classNameProp);
      var inputClassName = (0, _classnames.default)(classes.input, (_classNames2 = {}, (0, _defineProperty2.default)(_classNames2, classes.disabled, disabled), (0, _defineProperty2.default)(_classNames2, classes.inputType, type !== 'text'), (0, _defineProperty2.default)(_classNames2, classes.inputTypeSearch, type === 'search'), (0, _defineProperty2.default)(_classNames2, classes.inputMultiline, multiline), (0, _defineProperty2.default)(_classNames2, classes.inputMarginDense, margin === 'dense'), _classNames2), inputPropsClassName);
      var InputComponent = 'input';
      var inputProps = (0, _objectSpread2.default)({}, inputPropsProp, {
        ref: this.handleRefInput
      });

      if (inputComponent) {
        InputComponent = inputComponent;
        inputProps = (0, _objectSpread2.default)({
          // Rename ref to inputRef as we don't know the
          // provided `inputComponent` structure.
          inputRef: this.handleRefInput
        }, inputProps, {
          ref: null
        });
      } else if (multiline) {
        if (rows && !rowsMax) {
          InputComponent = 'textarea';
        } else {
          inputProps = (0, _objectSpread2.default)({
            rowsMax: rowsMax,
            textareaRef: this.handleRefInput
          }, inputProps, {
            ref: null
          });
          InputComponent = _Textarea.default;
        }
      }

      return _react.default.createElement("div", (0, _extends2.default)({
        className: className
      }, other), startAdornment, _react.default.createElement(InputComponent, (0, _extends2.default)({
        "aria-invalid": error,
        autoComplete: autoComplete,
        autoFocus: autoFocus,
        className: inputClassName,
        defaultValue: defaultValue,
        disabled: disabled,
        id: id,
        name: name,
        onBlur: this.handleBlur,
        onChange: this.handleChange,
        onFocus: this.handleFocus,
        onKeyDown: onKeyDown,
        onKeyUp: onKeyUp,
        placeholder: placeholder,
        readOnly: readOnly,
        required: required,
        rows: rows,
        type: type,
        value: value
      }, inputProps)), endAdornment);
    }
  }]);
  return Input;
}(_react.default.Component);

Input.propTypes =  false ? {
  /**
   * This property helps users to fill forms faster, especially on mobile devices.
   * The name can be confusing, as it's more like an autofill.
   * You can learn more about it here:
   * https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#autofill
   */
  autoComplete: _propTypes.default.string,

  /**
   * If `true`, the input will be focused during the first mount.
   */
  autoFocus: _propTypes.default.bool,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * The CSS class name of the wrapper element.
   */
  className: _propTypes.default.string,

  /**
   * The default input value, useful when not controlling the component.
   */
  defaultValue: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),

  /**
   * If `true`, the input will be disabled.
   */
  disabled: _propTypes.default.bool,

  /**
   * If `true`, the input will not have an underline.
   */
  disableUnderline: _propTypes.default.bool,

  /**
   * End `InputAdornment` for this component.
   */
  endAdornment: _propTypes.default.node,

  /**
   * If `true`, the input will indicate an error. This is normally obtained via context from
   * FormControl.
   */
  error: _propTypes.default.bool,

  /**
   * If `true`, the input will take up the full width of its container.
   */
  fullWidth: _propTypes.default.bool,

  /**
   * The id of the `input` element.
   */
  id: _propTypes.default.string,

  /**
   * The component used for the native input.
   * Either a string to use a DOM element or a component.
   */
  inputComponent: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func, _propTypes.default.object]),

  /**
   * Attributes applied to the `input` element.
   */
  inputProps: _propTypes.default.object,

  /**
   * Use that property to pass a ref callback to the native input component.
   */
  inputRef: _propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.object]),

  /**
   * If `dense`, will adjust vertical spacing. This is normally obtained via context from
   * FormControl.
   */
  margin: _propTypes.default.oneOf(['dense', 'none']),

  /**
   * If `true`, a textarea element will be rendered.
   */
  multiline: _propTypes.default.bool,

  /**
   * Name attribute of the `input` element.
   */
  name: _propTypes.default.string,

  /**
   * @ignore
   */
  onBlur: _propTypes.default.func,

  /**
   * Callback fired when the value is changed.
   *
   * @param {object} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value`.
   */
  onChange: _propTypes.default.func,

  /**
   * @ignore
   */
  onEmpty: _propTypes.default.func,

  /**
   * @ignore
   */
  onFilled: _propTypes.default.func,

  /**
   * @ignore
   */
  onFocus: _propTypes.default.func,

  /**
   * @ignore
   */
  onKeyDown: _propTypes.default.func,

  /**
   * @ignore
   */
  onKeyUp: _propTypes.default.func,

  /**
   * The short hint displayed in the input before the user enters a value.
   */
  placeholder: _propTypes.default.string,

  /**
   * It prevents the user from changing the value of the field
   * (not from interacting with the field).
   */
  readOnly: _propTypes.default.bool,

  /**
   * If `true`, the input will be required.
   */
  required: _propTypes.default.bool,

  /**
   * Number of rows to display when multiline option is set to true.
   */
  rows: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),

  /**
   * Maximum number of rows to display when multiline option is set to true.
   */
  rowsMax: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),

  /**
   * Start `InputAdornment` for this component.
   */
  startAdornment: _propTypes.default.node,

  /**
   * Type of the input element. It should be a valid HTML5 input type.
   */
  type: _propTypes.default.string,

  /**
   * The input value, required for a controlled component.
   */
  value: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number, _propTypes.default.arrayOf(_propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]))])
} : {};
Input.muiName = 'Input';
Input.defaultProps = {
  disableUnderline: false,
  fullWidth: false,
  multiline: false,
  type: 'text'
};
Input.contextTypes = {
  muiFormControl: _propTypes.default.object
};
Input.childContextTypes = {
  muiFormControl: _propTypes.default.object
};

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiInput'
})(Input);

exports.default = _default;

/***/ }),
/* 184 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(2);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.cloneElementWithClassName = cloneElementWithClassName;
exports.cloneChildrenWithClassName = cloneChildrenWithClassName;
exports.isMuiElement = isMuiElement;
exports.isMuiComponent = isMuiComponent;

var _react = _interopRequireDefault(__webpack_require__(0));

var _classnames = _interopRequireDefault(__webpack_require__(5));

/* eslint-disable import/prefer-default-export */
function cloneElementWithClassName(child, className) {
  return _react.default.cloneElement(child, {
    className: (0, _classnames.default)(child.props.className, className)
  });
}

function cloneChildrenWithClassName(children, className) {
  return _react.default.Children.map(children, function (child) {
    return _react.default.isValidElement(child) && cloneElementWithClassName(child, className);
  });
}

function isMuiElement(element, muiNames) {
  return _react.default.isValidElement(element) && muiNames.indexOf(element.type.muiName) !== -1;
}

function isMuiComponent(element, muiNames) {
  return muiNames.indexOf(element.muiName) !== -1;
}

/***/ }),
/* 185 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(2);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _InputLabel.default;
  }
});

var _InputLabel = _interopRequireDefault(__webpack_require__(565));

/***/ }),
/* 186 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(2);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Grow.default;
  }
});

var _Grow = _interopRequireDefault(__webpack_require__(584));

/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _CSSTransition = __webpack_require__(598);

var _CSSTransition2 = _interopRequireDefault(_CSSTransition);

var _ReplaceTransition = __webpack_require__(602);

var _ReplaceTransition2 = _interopRequireDefault(_ReplaceTransition);

var _TransitionGroup = __webpack_require__(174);

var _TransitionGroup2 = _interopRequireDefault(_TransitionGroup);

var _Transition = __webpack_require__(62);

var _Transition2 = _interopRequireDefault(_Transition);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

module.exports = {
  Transition: _Transition2.default,
  TransitionGroup: _TransitionGroup2.default,
  ReplaceTransition: _ReplaceTransition2.default,
  CSSTransition: _CSSTransition2.default
};

/***/ }),
/* 188 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_TextField__ = __webpack_require__(189);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_TextField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_TextField__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles_withStyles__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles_withStyles__);
var style=function style(theme){return{customInput:{backgroundColor:"#FAFAFA",borderRadius:4,border:'1px solid #CCCCCC',fontSize:16,height:'16px',padding:'10px 12px',transition:theme.transitions.create(['border-color','box-shadow']),width:'calc(100% - 24px)','&:focus':{backgroundColor:theme.palette.common.white,borderColor:'#2684FF',boxShadow:'0 0 0 1px #2684FF'}}};};var CustomInput=function CustomInput(_ref){var classes=_ref.classes,disabled=_ref.disabled,onChange=_ref.onChange,placeholder=_ref.placeholder,startAdornment=_ref.startAdornment,type=_ref.type,value=_ref.value;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_TextField___default.a,{disabled:disabled,fullWidth:true,InputProps:{classes:{input:classes.customInput},disableUnderline:true,startAdornment:startAdornment},onChange:onChange,placeholder:placeholder,type:type,value:value});};CustomInput.defaultProps={disabled:false,placeholder:"",type:"text",startAdornment:undefined};CustomInput.propTypes={classes:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object.isRequired,disabled:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,onChange:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,placeholder:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,startAdornment:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.node,type:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,value:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number,__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string]).isRequired};/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles_withStyles___default()(style)(CustomInput));

/***/ }),
/* 189 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(2);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _TextField.default;
  }
});

var _TextField = _interopRequireDefault(__webpack_require__(616));

/***/ }),
/* 190 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export DashboardComponent */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles_withStyles__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_EnergyCompany_Autosuggest_AutosuggestCNPJ__ = __webpack_require__(641);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__partials_BreakEven__ = __webpack_require__(657);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__partials_CargaEGeracao_jsx__ = __webpack_require__(706);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__partials_CCEEData__ = __webpack_require__(716);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__partials_CNAE__ = __webpack_require__(717);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__partials_ConsolidatedAccounting__ = __webpack_require__(718);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__partials_ConsumptionChart__ = __webpack_require__(719);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__partials_CorporateStructure__ = __webpack_require__(720);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__partials_DRE__ = __webpack_require__(722);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__partials_Informations__ = __webpack_require__(723);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__material_ui_core_LinearProgress__ = __webpack_require__(298);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__material_ui_core_LinearProgress___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__material_ui_core_LinearProgress__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__partials_MediaMovel__ = __webpack_require__(725);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__partials_Mapa__ = __webpack_require__(726);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__partials_RiscoChart__ = __webpack_require__(927);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__partials_SazoFlex__ = __webpack_require__(296);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__partials_TabelaBalanco__ = __webpack_require__(928);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_services_companies__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_services_utils__ = __webpack_require__(23);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var styles={autosuggestWrapper:{marginBottom:"25px"}};var Dashboard=function(_Component){_inherits(Dashboard,_Component);function Dashboard(){var _ref;var _temp,_this,_ret;_classCallCheck(this,Dashboard);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=Dashboard.__proto__||Object.getPrototypeOf(Dashboard)).call.apply(_ref,[this].concat(args))),_this),_this.state={allProfilesChecked:true,cnpjDados:undefined,error:undefined,loading:false,profilesChecked:{}},_this.handleAllProfilesCheck=function(e){_this.setState({allProfilesChecked:e.target.checked,profilesChecked:e.target.checked?_this.getAllProfilesIds(_this.state.cnpjDados):{}});},_this.handleProfileCheck=function(e){var _e$target=e.target,checked=_e$target.checked,value=_e$target.value;var checkedLength=Object(__WEBPACK_IMPORTED_MODULE_4_lodash__["compact"])(Object(__WEBPACK_IMPORTED_MODULE_4_lodash__["values"])(_this.state.profilesChecked)).length;_this.setState(function(prevState){return{allProfilesChecked:checked&&checkedLength===_this.state.cnpjDados.empresa.agents[0].agentProfiles.length-1,profilesChecked:Object.assign({},prevState.profilesChecked,_defineProperty({},value,checked))};});},_this.handleSearch=function(selected){if(!selected)return;var request=void 0;_this.setState({cnpjDados:undefined,error:undefined,loading:true});if(selected.id==="CATIVO"){request=Object(__WEBPACK_IMPORTED_MODULE_21_services_companies__["d" /* getCativoInfo */])(Object(__WEBPACK_IMPORTED_MODULE_22_services_utils__["h" /* removeNonDigits */])(selected.cnpj));}else{request=Object(__WEBPACK_IMPORTED_MODULE_21_services_companies__["e" /* getCompanyInfo */])(selected.id);}request.then(function(res){_this.setState({allProfilesChecked:true,cnpjDados:res.data,error:undefined,loading:false,profilesChecked:_this.getAllProfilesIds(res.data)});}).catch(function(){return _this.setState({cnpjDados:undefined,error:'Nenhuma empresa encontrada',loading:false});});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(Dashboard,[{key:"componentDidMount",value:function componentDidMount(){var _this2=this;this.handleSearch(this.props.selected);// NOTE: seTimeout é necessário senão o elem.scrollIntoView
// não funciona dentro do componentDidUpdate.
if(this.props.simplified){setTimeout(function(){return Object(__WEBPACK_IMPORTED_MODULE_22_services_utils__["i" /* scrollToElement */])(_this2.dashboard);},200);}}},{key:"componentDidUpdate",value:function componentDidUpdate(prevProps,prevState){var _this3=this;if(!Object(__WEBPACK_IMPORTED_MODULE_4_lodash__["isEqual"])(prevProps.selected,this.props.selected)&&this.props.selected){this.handleSearch(this.props.selected);// NOTE: Ditto
setTimeout(function(){return Object(__WEBPACK_IMPORTED_MODULE_22_services_utils__["i" /* scrollToElement */])(_this3.dashboard);},200);}if(!Object(__WEBPACK_IMPORTED_MODULE_4_lodash__["isEqual"])(prevState.cnpjDados,this.state.cnpjDados)&&this.state.cnpjDados){// NOTE: Ditto
setTimeout(function(){return Object(__WEBPACK_IMPORTED_MODULE_22_services_utils__["i" /* scrollToElement */])(_this3.dashboardLoaded);},200);}}},{key:"getAllProfilesIds",value:function getAllProfilesIds(data){var profilesChecked={};if(!data.empresa.agents.length)return profilesChecked;Object(__WEBPACK_IMPORTED_MODULE_4_lodash__["forEach"])(data.empresa.agents[0].agentProfiles,function(profile){return profilesChecked[profile.id]=true;});return profilesChecked;}},{key:"getCheckedProfiles",value:function getCheckedProfiles(){var _state=this.state,cnpjDados=_state.cnpjDados,profilesChecked=_state.profilesChecked;var checkedProfilesIds=Object(__WEBPACK_IMPORTED_MODULE_4_lodash__["keys"])(Object(__WEBPACK_IMPORTED_MODULE_4_lodash__["pickBy"])(profilesChecked));return Object(__WEBPACK_IMPORTED_MODULE_4_lodash__["filter"])(cnpjDados.empresa.agents[0].agentProfiles,function(profile){return Object(__WEBPACK_IMPORTED_MODULE_4_lodash__["includes"])(checkedProfilesIds,profile.id);});}},{key:"getConsolidatedFromProfiles",value:function getConsolidatedFromProfiles(){var _this4=this;var cnpjDados=this.state.cnpjDados;var monthsKeys=Object(__WEBPACK_IMPORTED_MODULE_4_lodash__["keys"])(cnpjDados.empresa.agents[0].consolidatedEnergy);var months=Object(__WEBPACK_IMPORTED_MODULE_4_lodash__["sortBy"])(monthsKeys,function(month){return __WEBPACK_IMPORTED_MODULE_0_moment___default()(month).unix();});var energy={};var accounting={};var balanco={};Object(__WEBPACK_IMPORTED_MODULE_4_lodash__["forEach"])(months,function(month){accounting[month]={ajusteAlivioRetroativo:0,ajusteExposicaoFinanceira:0,ajusteMCSDExPost:0,ajusteRecontabilizacoes:0,ajustes:0,compensacaoMRE:0,ecd:0,ecqa:0,eccen:0,eccgf:0,ecita:0,errh:0,edesc:0,efeitos:0,encargos:0,exposicaoMCP:0,excedenteER:0,resultadoFinal:0};energy[month]={garantiaFisica:0,lastro:0,recurso:0,recursoConsiderandoGF:0,requisito:0,saldo:0};balanco[month]={consumoLiquido:0,perdasConsumo:0,consumo:0,comprasSemProinfa:0,proinfa:0,vendas:0,saldoContratos:0,saldo:0};Object(__WEBPACK_IMPORTED_MODULE_4_lodash__["forEach"])(_this4.getCheckedProfiles(),function(_ref2){var accountingValues=_ref2.accountingValues,energiesValues=_ref2.energiesValues;// Coluna de ajustes e valores do tooltip
accounting[month].ajustes+=Object(__WEBPACK_IMPORTED_MODULE_4_lodash__["get"])(accountingValues,month+".ajustes",0);accounting[month].ajusteAlivioRetroativo+=Object(__WEBPACK_IMPORTED_MODULE_4_lodash__["get"])(accountingValues,month+".ajusteAlivioRetroativo",0);accounting[month].ajusteExposicaoFinanceira+=Object(__WEBPACK_IMPORTED_MODULE_4_lodash__["get"])(accountingValues,month+".ajusteExposicaoFinanceira",0);accounting[month].ajusteMCSDExPost+=Object(__WEBPACK_IMPORTED_MODULE_4_lodash__["get"])(accountingValues,month+".ajusteMCSDExPost",0);accounting[month].ajusteRecontabilizacoes+=Object(__WEBPACK_IMPORTED_MODULE_4_lodash__["get"])(accountingValues,month+".ajusteRecontabilizacoes",0);// Coluna de efeitos e valores do tooltip
accounting[month].efeitos+=Object(__WEBPACK_IMPORTED_MODULE_4_lodash__["get"])(accountingValues,month+".efeitos",0);accounting[month].ecd+=Object(__WEBPACK_IMPORTED_MODULE_4_lodash__["get"])(accountingValues,month+".ecd",0);accounting[month].ecqa+=Object(__WEBPACK_IMPORTED_MODULE_4_lodash__["get"])(accountingValues,month+".ecqa",0);accounting[month].eccen+=Object(__WEBPACK_IMPORTED_MODULE_4_lodash__["get"])(accountingValues,month+".eccen",0);accounting[month].eccgf+=Object(__WEBPACK_IMPORTED_MODULE_4_lodash__["get"])(accountingValues,month+".eccgf",0);accounting[month].ecita+=Object(__WEBPACK_IMPORTED_MODULE_4_lodash__["get"])(accountingValues,month+".ecita",0);accounting[month].errh+=Object(__WEBPACK_IMPORTED_MODULE_4_lodash__["get"])(accountingValues,month+".errh",0);accounting[month].edesc+=Object(__WEBPACK_IMPORTED_MODULE_4_lodash__["get"])(accountingValues,month+".edesc",0);accounting[month].compensacaoMRE+=Object(__WEBPACK_IMPORTED_MODULE_4_lodash__["get"])(accountingValues,month+".compensacaoMRE",0);accounting[month].encargos+=Object(__WEBPACK_IMPORTED_MODULE_4_lodash__["get"])(accountingValues,month+".encargos",0);accounting[month].exposicaoMCP+=Object(__WEBPACK_IMPORTED_MODULE_4_lodash__["get"])(accountingValues,month+".exposicaoMCP",0);accounting[month].excedenteER+=Object(__WEBPACK_IMPORTED_MODULE_4_lodash__["get"])(accountingValues,month+".resultadoExcedenteFinanceiroEnergiaReserva",0);accounting[month].resultadoFinal+=Object(__WEBPACK_IMPORTED_MODULE_4_lodash__["get"])(accountingValues,month+".resultadoFinal",0);energy[month].garantiaFisica+=Object(__WEBPACK_IMPORTED_MODULE_4_lodash__["get"])(energiesValues,month+".garantiaFisica",0);energy[month].lastro+=Object(__WEBPACK_IMPORTED_MODULE_4_lodash__["get"])(energiesValues,month+".lastro",0);energy[month].recurso+=Object(__WEBPACK_IMPORTED_MODULE_4_lodash__["get"])(energiesValues,month+".recurso",0);energy[month].recursoConsiderandoGF+=Object(__WEBPACK_IMPORTED_MODULE_4_lodash__["get"])(energiesValues,month+".recursoConsiderandoGF",0);energy[month].requisito+=Object(__WEBPACK_IMPORTED_MODULE_4_lodash__["get"])(energiesValues,month+".requisito",0);energy[month].saldo+=Object(__WEBPACK_IMPORTED_MODULE_4_lodash__["get"])(energiesValues,month+".saldo",0);// Tabela de Balanço
balanco[month].consumoLiquido+=Object(__WEBPACK_IMPORTED_MODULE_4_lodash__["get"])(energiesValues,month+".consumoLiquido",0);balanco[month].perdasConsumo+=Object(__WEBPACK_IMPORTED_MODULE_4_lodash__["get"])(energiesValues,month+".perdasConsumo",0);balanco[month].consumo+=Object(__WEBPACK_IMPORTED_MODULE_4_lodash__["get"])(energiesValues,month+".consumo",0);balanco[month].comprasSemProinfa+=Object(__WEBPACK_IMPORTED_MODULE_4_lodash__["get"])(energiesValues,month+".comprasSemProinfa",0);balanco[month].proinfa+=Object(__WEBPACK_IMPORTED_MODULE_4_lodash__["get"])(energiesValues,month+".proinfa",0);balanco[month].vendas+=Object(__WEBPACK_IMPORTED_MODULE_4_lodash__["get"])(energiesValues,month+".vendas",0);balanco[month].saldoContratos+=Object(__WEBPACK_IMPORTED_MODULE_4_lodash__["get"])(energiesValues,month+".saldoContratos",0);balanco[month].saldo+=Object(__WEBPACK_IMPORTED_MODULE_4_lodash__["get"])(energiesValues,month+".saldo",0);});});return{accounting:accounting,energy:energy,balanco:balanco};}},{key:"ehCativo",value:function ehCativo(){var agents=this.state.cnpjDados.empresa.agents;// agents.length === 0 significa empresa no cativo.
return agents.length===0;}},{key:"ehConsumidor",value:function ehConsumidor(){var agents=this.state.cnpjDados.empresa.agents;return Object(__WEBPACK_IMPORTED_MODULE_4_lodash__["some"])(agents[0].agentProfiles,function(profile){return Object(__WEBPACK_IMPORTED_MODULE_4_lodash__["includes"])(Object(__WEBPACK_IMPORTED_MODULE_4_lodash__["toLower"])(profile.class),"consumidor");});}},{key:"ehCativoOuConsumidor",value:function ehCativoOuConsumidor(){if(this.ehCativo()||this.ehConsumidor()){return true;}return false;}},{key:"render",value:function render(){var _this5=this;var _props=this.props,classes=_props.classes,simplified=_props.simplified;var _state2=this.state,allProfilesChecked=_state2.allProfilesChecked,cnpjDados=_state2.cnpjDados,error=_state2.error,loading=_state2.loading,profilesChecked=_state2.profilesChecked;var calculatedValuesFromProfiles=void 0;if(cnpjDados&&cnpjDados.empresa.agents.length){calculatedValuesFromProfiles=this.getConsolidatedFromProfiles();}var agentProfile=Object(__WEBPACK_IMPORTED_MODULE_4_lodash__["get"])(cnpjDados,'empresa.agents[0].agentProfiles[0]',{});return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("div",{ref:function ref(node){return _this5.dashboard=node;}},!simplified&&__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("div",{className:classes.autosuggestWrapper},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_EnergyCompany_Autosuggest_AutosuggestCNPJ__["a" /* default */],{defaultValue:Object(__WEBPACK_IMPORTED_MODULE_4_lodash__["get"])(cnpjDados,"empresa.name",""),onHandleSelected:this.handleSearch})),!simplified&&error&&__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("h3",null,error),loading&&__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__material_ui_core_LinearProgress___default.a,null),cnpjDados&&__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("div",{ref:function ref(node){return _this5.dashboardLoaded=node;}},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__partials_Informations__["a" /* default */],{empresa:cnpjDados.empresa}),cnpjDados.empresa.address&&__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__partials_Mapa__["a" /* default */],{address:cnpjDados.empresa.address}),cnpjDados.empresa.companyResponsibles.length>0&&__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__partials_CorporateStructure__["a" /* default */],{companyResponsibles:cnpjDados.empresa.companyResponsibles,selectEmpresa:this.handleSearch}),this.ehCativoOuConsumidor()&&__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__partials_BreakEven__["a" /* default */],{agentesDistribuidores:cnpjDados.agentesDistribuidores,companyId:cnpjDados.empresa.id,distribuidoraSugeridaId:cnpjDados.empresa.idDistribuidoraSugerida}),cnpjDados.empresa.agents.length>0&&__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__partials_CCEEData__["a" /* default */],{agent:cnpjDados.empresa.agents[0],allProfilesChecked:allProfilesChecked,handleAllProfilesCheck:this.handleAllProfilesCheck,handleProfileCheck:this.handleProfileCheck,profilesChecked:profilesChecked}),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__partials_CargaEGeracao_jsx__["a" /* default */],{companyId:cnpjDados.empresa.id}),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__partials_ConsumptionChart__["a" /* default */],{consolidatedEnergy:calculatedValuesFromProfiles.energy}),this.ehConsumidor()&&__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__partials_TabelaBalanco__["a" /* default */],{balancoDados:calculatedValuesFromProfiles.balanco}),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__partials_MediaMovel__["a" /* default */],{agentProfile:agentProfile,checkedProfiles:this.getCheckedProfiles(),consolidatedEnergy:calculatedValuesFromProfiles.energy,pld:cnpjDados.pldMedioPorSubmercado}),cnpjDados.empresa.dadosRisco&&__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__partials_RiscoChart__["a" /* default */],{data:cnpjDados.empresa.dadosRisco}),this.ehCativoOuConsumidor()&&__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__partials_SazoFlex__["a" /* default */],{checkedAgentProfiles:this.getCheckedProfiles(),selected:this.props.selected}),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__partials_ConsolidatedAccounting__["a" /* default */],{consolidatedAccountingValues:calculatedValuesFromProfiles.accounting})),cnpjDados.empresa.dre&&__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__partials_DRE__["a" /* default */],{dre:cnpjDados.empresa.dre}),this.ehCativoOuConsumidor()&&cnpjDados.empresa.cnae&&__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__partials_CNAE__["a" /* default */],{cnae:cnpjDados.empresa.cnae})));}}]);return Dashboard;}(__WEBPACK_IMPORTED_MODULE_2_react__["Component"]);Dashboard.propTypes={classes:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,selected:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,simplified:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool};/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles_withStyles___default()(styles)(Dashboard));

/***/ }),
/* 191 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.default = compareObjects;
function compareObjects(objA, objB) {
  var keys = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];

  if (objA === objB) {
    return false;
  }

  var aKeys = Object.keys(objA);
  var bKeys = Object.keys(objB);

  if (aKeys.length !== bKeys.length) {
    return true;
  }

  var keysMap = {};
  var i = void 0,
      len = void 0;

  for (i = 0, len = keys.length; i < len; i++) {
    keysMap[keys[i]] = true;
  }

  for (i = 0, len = aKeys.length; i < len; i++) {
    var key = aKeys[i];
    var aValue = objA[key];
    var bValue = objB[key];

    if (aValue === bValue) {
      continue;
    }

    if (!keysMap[key] || aValue === null || bValue === null || (typeof aValue === 'undefined' ? 'undefined' : _typeof(aValue)) !== 'object' || (typeof bValue === 'undefined' ? 'undefined' : _typeof(bValue)) !== 'object') {
      return true;
    }

    var aValueKeys = Object.keys(aValue);
    var bValueKeys = Object.keys(bValue);

    if (aValueKeys.length !== bValueKeys.length) {
      return true;
    }

    for (var n = 0, length = aValueKeys.length; n < length; n++) {
      var aValueKey = aValueKeys[n];

      if (aValue[aValueKey] !== bValue[aValueKey]) {
        return true;
      }
    }
  }

  return false;
}

/***/ }),
/* 192 */
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};


/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__(194)('keys');
var uid = __webpack_require__(139);
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};


/***/ }),
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

var core = __webpack_require__(42);
var global = __webpack_require__(56);
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: core.version,
  mode: __webpack_require__(138) ? 'pure' : 'global',
  copyright: '© 2019 Denis Pushkarev (zloirock.ru)'
});


/***/ }),
/* 195 */
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__(733);
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__(82);
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),
/* 197 */
/***/ (function(module, exports) {

// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};


/***/ }),
/* 198 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject = __webpack_require__(81);
var dPs = __webpack_require__(740);
var enumBugKeys = __webpack_require__(200);
var IE_PROTO = __webpack_require__(193)('IE_PROTO');
var Empty = function () { /* empty */ };
var PROTOTYPE = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = __webpack_require__(302)('iframe');
  var i = enumBugKeys.length;
  var lt = '<';
  var gt = '>';
  var iframeDocument;
  iframe.style.display = 'none';
  __webpack_require__(743).appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
  return createDict();
};

module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty();
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};


/***/ }),
/* 199 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};


/***/ }),
/* 200 */
/***/ (function(module, exports) {

// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');


/***/ }),
/* 201 */
/***/ (function(module, exports, __webpack_require__) {

var def = __webpack_require__(58).f;
var has = __webpack_require__(64);
var TAG = __webpack_require__(47)('toStringTag');

module.exports = function (it, tag, stat) {
  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
};


/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {

exports.f = __webpack_require__(47);


/***/ }),
/* 203 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(56);
var core = __webpack_require__(42);
var LIBRARY = __webpack_require__(138);
var wksExt = __webpack_require__(202);
var defineProperty = __webpack_require__(58).f;
module.exports = function (name) {
  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
};


/***/ }),
/* 204 */
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;


/***/ }),
/* 205 */
/***/ (function(module, exports, __webpack_require__) {

var identity = __webpack_require__(111),
    overRest = __webpack_require__(765),
    setToString = __webpack_require__(313);

/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */
function baseRest(func, start) {
  return setToString(overRest(func, start, identity), func + '');
}

module.exports = baseRest;


/***/ }),
/* 206 */
/***/ (function(module, exports) {

/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */
function apply(func, thisArg, args) {
  switch (args.length) {
    case 0: return func.call(thisArg);
    case 1: return func.call(thisArg, args[0]);
    case 2: return func.call(thisArg, args[0], args[1]);
    case 3: return func.call(thisArg, args[0], args[1], args[2]);
  }
  return func.apply(thisArg, args);
}

module.exports = apply;


/***/ }),
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(66);

/** Built-in value references. */
var objectCreate = Object.create;

/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */
var baseCreate = (function() {
  function object() {}
  return function(proto) {
    if (!isObject(proto)) {
      return {};
    }
    if (objectCreate) {
      return objectCreate(proto);
    }
    object.prototype = proto;
    var result = new object;
    object.prototype = undefined;
    return result;
  };
}());

module.exports = baseCreate;


/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {

var baseCreate = __webpack_require__(207),
    baseLodash = __webpack_require__(209);

/** Used as references for the maximum length and index of an array. */
var MAX_ARRAY_LENGTH = 4294967295;

/**
 * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
 *
 * @private
 * @constructor
 * @param {*} value The value to wrap.
 */
function LazyWrapper(value) {
  this.__wrapped__ = value;
  this.__actions__ = [];
  this.__dir__ = 1;
  this.__filtered__ = false;
  this.__iteratees__ = [];
  this.__takeCount__ = MAX_ARRAY_LENGTH;
  this.__views__ = [];
}

// Ensure `LazyWrapper` is an instance of `baseLodash`.
LazyWrapper.prototype = baseCreate(baseLodash.prototype);
LazyWrapper.prototype.constructor = LazyWrapper;

module.exports = LazyWrapper;


/***/ }),
/* 209 */
/***/ (function(module, exports) {

/**
 * The function whose prototype chain sequence wrappers inherit from.
 *
 * @private
 */
function baseLodash() {
  // No operation performed.
}

module.exports = baseLodash;


/***/ }),
/* 210 */
/***/ (function(module, exports) {

/**
 * Gets the argument placeholder value for `func`.
 *
 * @private
 * @param {Function} func The function to inspect.
 * @returns {*} Returns the placeholder value.
 */
function getHolder(func) {
  var object = func;
  return object.placeholder;
}

module.exports = getHolder;


/***/ }),
/* 211 */
/***/ (function(module, exports) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

module.exports = isLength;


/***/ }),
/* 212 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(65),
    root = __webpack_require__(38);

/* Built-in method references that are verified to be native. */
var Map = getNative(root, 'Map');

module.exports = Map;


/***/ }),
/* 213 */
/***/ (function(module, exports, __webpack_require__) {

var mapCacheClear = __webpack_require__(843),
    mapCacheDelete = __webpack_require__(850),
    mapCacheGet = __webpack_require__(852),
    mapCacheHas = __webpack_require__(853),
    mapCacheSet = __webpack_require__(854);

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

module.exports = MapCache;


/***/ }),
/* 214 */
/***/ (function(module, exports, __webpack_require__) {

var isArray = __webpack_require__(44),
    isSymbol = __webpack_require__(148);

/** Used to match property names within property paths. */
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/;

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey(value, object) {
  if (isArray(value)) {
    return false;
  }
  var type = typeof value;
  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
      value == null || isSymbol(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
    (object != null && value in Object(object));
}

module.exports = isKey;


/***/ }),
/* 215 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var asap = __webpack_require__(374);

function noop() {}

// States:
//
// 0 - pending
// 1 - fulfilled with _value
// 2 - rejected with _value
// 3 - adopted the state of another promise, _value
//
// once the state is no longer pending (0) it is immutable

// All `_` prefixed properties will be reduced to `_{random number}`
// at build time to obfuscate them and discourage their use.
// We don't use symbols or Object.defineProperty to fully hide them
// because the performance isn't good enough.


// to avoid using try/catch inside critical functions, we
// extract them to here.
var LAST_ERROR = null;
var IS_ERROR = {};
function getThen(obj) {
  try {
    return obj.then;
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}

function tryCallOne(fn, a) {
  try {
    return fn(a);
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}
function tryCallTwo(fn, a, b) {
  try {
    fn(a, b);
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}

module.exports = Promise;

function Promise(fn) {
  if (typeof this !== 'object') {
    throw new TypeError('Promises must be constructed via new');
  }
  if (typeof fn !== 'function') {
    throw new TypeError('Promise constructor\'s argument is not a function');
  }
  this._75 = 0;
  this._83 = 0;
  this._18 = null;
  this._38 = null;
  if (fn === noop) return;
  doResolve(fn, this);
}
Promise._47 = null;
Promise._71 = null;
Promise._44 = noop;

Promise.prototype.then = function(onFulfilled, onRejected) {
  if (this.constructor !== Promise) {
    return safeThen(this, onFulfilled, onRejected);
  }
  var res = new Promise(noop);
  handle(this, new Handler(onFulfilled, onRejected, res));
  return res;
};

function safeThen(self, onFulfilled, onRejected) {
  return new self.constructor(function (resolve, reject) {
    var res = new Promise(noop);
    res.then(resolve, reject);
    handle(self, new Handler(onFulfilled, onRejected, res));
  });
}
function handle(self, deferred) {
  while (self._83 === 3) {
    self = self._18;
  }
  if (Promise._47) {
    Promise._47(self);
  }
  if (self._83 === 0) {
    if (self._75 === 0) {
      self._75 = 1;
      self._38 = deferred;
      return;
    }
    if (self._75 === 1) {
      self._75 = 2;
      self._38 = [self._38, deferred];
      return;
    }
    self._38.push(deferred);
    return;
  }
  handleResolved(self, deferred);
}

function handleResolved(self, deferred) {
  asap(function() {
    var cb = self._83 === 1 ? deferred.onFulfilled : deferred.onRejected;
    if (cb === null) {
      if (self._83 === 1) {
        resolve(deferred.promise, self._18);
      } else {
        reject(deferred.promise, self._18);
      }
      return;
    }
    var ret = tryCallOne(cb, self._18);
    if (ret === IS_ERROR) {
      reject(deferred.promise, LAST_ERROR);
    } else {
      resolve(deferred.promise, ret);
    }
  });
}
function resolve(self, newValue) {
  // Promise Resolution Procedure: https://github.com/promises-aplus/promises-spec#the-promise-resolution-procedure
  if (newValue === self) {
    return reject(
      self,
      new TypeError('A promise cannot be resolved with itself.')
    );
  }
  if (
    newValue &&
    (typeof newValue === 'object' || typeof newValue === 'function')
  ) {
    var then = getThen(newValue);
    if (then === IS_ERROR) {
      return reject(self, LAST_ERROR);
    }
    if (
      then === self.then &&
      newValue instanceof Promise
    ) {
      self._83 = 3;
      self._18 = newValue;
      finale(self);
      return;
    } else if (typeof then === 'function') {
      doResolve(then.bind(newValue), self);
      return;
    }
  }
  self._83 = 1;
  self._18 = newValue;
  finale(self);
}

function reject(self, newValue) {
  self._83 = 2;
  self._18 = newValue;
  if (Promise._71) {
    Promise._71(self, newValue);
  }
  finale(self);
}
function finale(self) {
  if (self._75 === 1) {
    handle(self, self._38);
    self._38 = null;
  }
  if (self._75 === 2) {
    for (var i = 0; i < self._38.length; i++) {
      handle(self, self._38[i]);
    }
    self._38 = null;
  }
}

function Handler(onFulfilled, onRejected, promise){
  this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
  this.onRejected = typeof onRejected === 'function' ? onRejected : null;
  this.promise = promise;
}

/**
 * Take a potentially misbehaving resolver function and make sure
 * onFulfilled and onRejected are only called once.
 *
 * Makes no guarantees about asynchrony.
 */
function doResolve(fn, promise) {
  var done = false;
  var res = tryCallTwo(fn, function (value) {
    if (done) return;
    done = true;
    resolve(promise, value);
  }, function (reason) {
    if (done) return;
    done = true;
    reject(promise, reason);
  });
  if (!done && res === IS_ERROR) {
    done = true;
    reject(promise, LAST_ERROR);
  }
}


/***/ }),
/* 216 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var validateFormat = function validateFormat(format) {};

if (false) {
  validateFormat = function validateFormat(format) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  };
}

function invariant(condition, format, a, b, c, d, e, f) {
  validateFormat(format);

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(format.replace(/%s/g, function () {
        return args[argIndex++];
      }));
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
}

module.exports = invariant;

/***/ }),
/* 217 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var emptyObject = {};

if (false) {
  Object.freeze(emptyObject);
}

module.exports = emptyObject;

/***/ }),
/* 218 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

function makeEmptyFunction(arg) {
  return function () {
    return arg;
  };
}

/**
 * This function accepts and discards inputs; it has no side effects. This is
 * primarily useful idiomatically for overridable function endpoints which
 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
 */
var emptyFunction = function emptyFunction() {};

emptyFunction.thatReturns = makeEmptyFunction;
emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
emptyFunction.thatReturnsNull = makeEmptyFunction(null);
emptyFunction.thatReturnsThis = function () {
  return this;
};
emptyFunction.thatReturnsArgument = function (arg) {
  return arg;
};

module.exports = emptyFunction;

/***/ }),
/* 219 */
/***/ (function(module, exports) {

module.exports = function(originalModule) {
	if(!originalModule.webpackPolyfill) {
		var module = Object.create(originalModule);
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		Object.defineProperty(module, "exports", {
			enumerable: true,
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),
/* 220 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return canUseDOM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return addEventListener; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return removeEventListener; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getConfirmation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return supportsHistory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return supportsPopStateOnHashChange; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return supportsGoWithoutReloadUsingHash; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return isExtraneousPopstateEvent; });
var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

var addEventListener = function addEventListener(node, event, listener) {
  return node.addEventListener ? node.addEventListener(event, listener, false) : node.attachEvent('on' + event, listener);
};

var removeEventListener = function removeEventListener(node, event, listener) {
  return node.removeEventListener ? node.removeEventListener(event, listener, false) : node.detachEvent('on' + event, listener);
};

var getConfirmation = function getConfirmation(message, callback) {
  return callback(window.confirm(message));
}; // eslint-disable-line no-alert

/**
 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
 *
 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
 * changed to avoid false negatives for Windows Phones: https://github.com/reactjs/react-router/issues/586
 */
var supportsHistory = function supportsHistory() {
  var ua = window.navigator.userAgent;

  if ((ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) && ua.indexOf('Mobile Safari') !== -1 && ua.indexOf('Chrome') === -1 && ua.indexOf('Windows Phone') === -1) return false;

  return window.history && 'pushState' in window.history;
};

/**
 * Returns true if browser fires popstate on hash change.
 * IE10 and IE11 do not.
 */
var supportsPopStateOnHashChange = function supportsPopStateOnHashChange() {
  return window.navigator.userAgent.indexOf('Trident') === -1;
};

/**
 * Returns false if using go(n) with hash history causes a full page reload.
 */
var supportsGoWithoutReloadUsingHash = function supportsGoWithoutReloadUsingHash() {
  return window.navigator.userAgent.indexOf('Firefox') === -1;
};

/**
 * Returns true if a given popstate event is an extraneous WebKit event.
 * Accounts for the fact that Chrome on iOS fires real popstate events
 * containing undefined state when pressing the back button.
 */
var isExtraneousPopstateEvent = function isExtraneousPopstateEvent(event) {
  return event.state === undefined && navigator.userAgent.indexOf('CriOS') === -1;
};

/***/ }),
/* 221 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return subscriptionShape; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return storeShape; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);


var subscriptionShape = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({
  trySubscribe: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  tryUnsubscribe: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  notifyNestedSubs: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  isSubscribed: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired
});

var storeShape = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({
  subscribe: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  dispatch: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  getState: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired
});

/***/ }),
/* 222 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = connectAdvanced;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_hoist_non_react_statics__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_hoist_non_react_statics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_Subscription__ = __webpack_require__(396);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_PropTypes__ = __webpack_require__(221);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }








var hotReloadingVersion = 0;
var dummyState = {};
function noop() {}
function makeSelectorStateful(sourceSelector, store) {
  // wrap the selector in an object that tracks its results between runs.
  var selector = {
    run: function runComponentSelector(props) {
      try {
        var nextProps = sourceSelector(store.getState(), props);
        if (nextProps !== selector.props || selector.error) {
          selector.shouldComponentUpdate = true;
          selector.props = nextProps;
          selector.error = null;
        }
      } catch (error) {
        selector.shouldComponentUpdate = true;
        selector.error = error;
      }
    }
  };

  return selector;
}

function connectAdvanced(
/*
  selectorFactory is a func that is responsible for returning the selector function used to
  compute new props from state, props, and dispatch. For example:
     export default connectAdvanced((dispatch, options) => (state, props) => ({
      thing: state.things[props.thingId],
      saveThing: fields => dispatch(actionCreators.saveThing(props.thingId, fields)),
    }))(YourComponent)
   Access to dispatch is provided to the factory so selectorFactories can bind actionCreators
  outside of their selector as an optimization. Options passed to connectAdvanced are passed to
  the selectorFactory, along with displayName and WrappedComponent, as the second argument.
   Note that selectorFactory is responsible for all caching/memoization of inbound and outbound
  props. Do not use connectAdvanced directly without memoizing results between calls to your
  selector, otherwise the Connect component will re-render on every state or props change.
*/
selectorFactory) {
  var _contextTypes, _childContextTypes;

  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref$getDisplayName = _ref.getDisplayName,
      getDisplayName = _ref$getDisplayName === undefined ? function (name) {
    return 'ConnectAdvanced(' + name + ')';
  } : _ref$getDisplayName,
      _ref$methodName = _ref.methodName,
      methodName = _ref$methodName === undefined ? 'connectAdvanced' : _ref$methodName,
      _ref$renderCountProp = _ref.renderCountProp,
      renderCountProp = _ref$renderCountProp === undefined ? undefined : _ref$renderCountProp,
      _ref$shouldHandleStat = _ref.shouldHandleStateChanges,
      shouldHandleStateChanges = _ref$shouldHandleStat === undefined ? true : _ref$shouldHandleStat,
      _ref$storeKey = _ref.storeKey,
      storeKey = _ref$storeKey === undefined ? 'store' : _ref$storeKey,
      _ref$withRef = _ref.withRef,
      withRef = _ref$withRef === undefined ? false : _ref$withRef,
      connectOptions = _objectWithoutProperties(_ref, ['getDisplayName', 'methodName', 'renderCountProp', 'shouldHandleStateChanges', 'storeKey', 'withRef']);

  var subscriptionKey = storeKey + 'Subscription';
  var version = hotReloadingVersion++;

  var contextTypes = (_contextTypes = {}, _contextTypes[storeKey] = __WEBPACK_IMPORTED_MODULE_4__utils_PropTypes__["a" /* storeShape */], _contextTypes[subscriptionKey] = __WEBPACK_IMPORTED_MODULE_4__utils_PropTypes__["b" /* subscriptionShape */], _contextTypes);
  var childContextTypes = (_childContextTypes = {}, _childContextTypes[subscriptionKey] = __WEBPACK_IMPORTED_MODULE_4__utils_PropTypes__["b" /* subscriptionShape */], _childContextTypes);

  return function wrapWithConnect(WrappedComponent) {
    __WEBPACK_IMPORTED_MODULE_1_invariant___default()(typeof WrappedComponent == 'function', 'You must pass a component to the function returned by ' + (methodName + '. Instead received ' + JSON.stringify(WrappedComponent)));

    var wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || 'Component';

    var displayName = getDisplayName(wrappedComponentName);

    var selectorFactoryOptions = _extends({}, connectOptions, {
      getDisplayName: getDisplayName,
      methodName: methodName,
      renderCountProp: renderCountProp,
      shouldHandleStateChanges: shouldHandleStateChanges,
      storeKey: storeKey,
      withRef: withRef,
      displayName: displayName,
      wrappedComponentName: wrappedComponentName,
      WrappedComponent: WrappedComponent
    });

    var Connect = function (_Component) {
      _inherits(Connect, _Component);

      function Connect(props, context) {
        _classCallCheck(this, Connect);

        var _this = _possibleConstructorReturn(this, _Component.call(this, props, context));

        _this.version = version;
        _this.state = {};
        _this.renderCount = 0;
        _this.store = props[storeKey] || context[storeKey];
        _this.propsMode = Boolean(props[storeKey]);
        _this.setWrappedInstance = _this.setWrappedInstance.bind(_this);

        __WEBPACK_IMPORTED_MODULE_1_invariant___default()(_this.store, 'Could not find "' + storeKey + '" in either the context or props of ' + ('"' + displayName + '". Either wrap the root component in a <Provider>, ') + ('or explicitly pass "' + storeKey + '" as a prop to "' + displayName + '".'));

        _this.initSelector();
        _this.initSubscription();
        return _this;
      }

      Connect.prototype.getChildContext = function getChildContext() {
        var _ref2;

        // If this component received store from props, its subscription should be transparent
        // to any descendants receiving store+subscription from context; it passes along
        // subscription passed to it. Otherwise, it shadows the parent subscription, which allows
        // Connect to control ordering of notifications to flow top-down.
        var subscription = this.propsMode ? null : this.subscription;
        return _ref2 = {}, _ref2[subscriptionKey] = subscription || this.context[subscriptionKey], _ref2;
      };

      Connect.prototype.componentDidMount = function componentDidMount() {
        if (!shouldHandleStateChanges) return;

        // componentWillMount fires during server side rendering, but componentDidMount and
        // componentWillUnmount do not. Because of this, trySubscribe happens during ...didMount.
        // Otherwise, unsubscription would never take place during SSR, causing a memory leak.
        // To handle the case where a child component may have triggered a state change by
        // dispatching an action in its componentWillMount, we have to re-run the select and maybe
        // re-render.
        this.subscription.trySubscribe();
        this.selector.run(this.props);
        if (this.selector.shouldComponentUpdate) this.forceUpdate();
      };

      Connect.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
        this.selector.run(nextProps);
      };

      Connect.prototype.shouldComponentUpdate = function shouldComponentUpdate() {
        return this.selector.shouldComponentUpdate;
      };

      Connect.prototype.componentWillUnmount = function componentWillUnmount() {
        if (this.subscription) this.subscription.tryUnsubscribe();
        this.subscription = null;
        this.notifyNestedSubs = noop;
        this.store = null;
        this.selector.run = noop;
        this.selector.shouldComponentUpdate = false;
      };

      Connect.prototype.getWrappedInstance = function getWrappedInstance() {
        __WEBPACK_IMPORTED_MODULE_1_invariant___default()(withRef, 'To access the wrapped instance, you need to specify ' + ('{ withRef: true } in the options argument of the ' + methodName + '() call.'));
        return this.wrappedInstance;
      };

      Connect.prototype.setWrappedInstance = function setWrappedInstance(ref) {
        this.wrappedInstance = ref;
      };

      Connect.prototype.initSelector = function initSelector() {
        var sourceSelector = selectorFactory(this.store.dispatch, selectorFactoryOptions);
        this.selector = makeSelectorStateful(sourceSelector, this.store);
        this.selector.run(this.props);
      };

      Connect.prototype.initSubscription = function initSubscription() {
        if (!shouldHandleStateChanges) return;

        // parentSub's source should match where store came from: props vs. context. A component
        // connected to the store via props shouldn't use subscription from context, or vice versa.
        var parentSub = (this.propsMode ? this.props : this.context)[subscriptionKey];
        this.subscription = new __WEBPACK_IMPORTED_MODULE_3__utils_Subscription__["a" /* default */](this.store, parentSub, this.onStateChange.bind(this));

        // `notifyNestedSubs` is duplicated to handle the case where the component is  unmounted in
        // the middle of the notification loop, where `this.subscription` will then be null. An
        // extra null check every change can be avoided by copying the method onto `this` and then
        // replacing it with a no-op on unmount. This can probably be avoided if Subscription's
        // listeners logic is changed to not call listeners that have been unsubscribed in the
        // middle of the notification loop.
        this.notifyNestedSubs = this.subscription.notifyNestedSubs.bind(this.subscription);
      };

      Connect.prototype.onStateChange = function onStateChange() {
        this.selector.run(this.props);

        if (!this.selector.shouldComponentUpdate) {
          this.notifyNestedSubs();
        } else {
          this.componentDidUpdate = this.notifyNestedSubsOnComponentDidUpdate;
          this.setState(dummyState);
        }
      };

      Connect.prototype.notifyNestedSubsOnComponentDidUpdate = function notifyNestedSubsOnComponentDidUpdate() {
        // `componentDidUpdate` is conditionally implemented when `onStateChange` determines it
        // needs to notify nested subs. Once called, it unimplements itself until further state
        // changes occur. Doing it this way vs having a permanent `componentDidUpdate` that does
        // a boolean check every time avoids an extra method call most of the time, resulting
        // in some perf boost.
        this.componentDidUpdate = undefined;
        this.notifyNestedSubs();
      };

      Connect.prototype.isSubscribed = function isSubscribed() {
        return Boolean(this.subscription) && this.subscription.isSubscribed();
      };

      Connect.prototype.addExtraProps = function addExtraProps(props) {
        if (!withRef && !renderCountProp && !(this.propsMode && this.subscription)) return props;
        // make a shallow copy so that fields added don't leak to the original selector.
        // this is especially important for 'ref' since that's a reference back to the component
        // instance. a singleton memoized selector would then be holding a reference to the
        // instance, preventing the instance from being garbage collected, and that would be bad
        var withExtras = _extends({}, props);
        if (withRef) withExtras.ref = this.setWrappedInstance;
        if (renderCountProp) withExtras[renderCountProp] = this.renderCount++;
        if (this.propsMode && this.subscription) withExtras[subscriptionKey] = this.subscription;
        return withExtras;
      };

      Connect.prototype.render = function render() {
        var selector = this.selector;
        selector.shouldComponentUpdate = false;

        if (selector.error) {
          throw selector.error;
        } else {
          return Object(__WEBPACK_IMPORTED_MODULE_2_react__["createElement"])(WrappedComponent, this.addExtraProps(selector.props));
        }
      };

      return Connect;
    }(__WEBPACK_IMPORTED_MODULE_2_react__["Component"]);

    Connect.WrappedComponent = WrappedComponent;
    Connect.displayName = displayName;
    Connect.childContextTypes = childContextTypes;
    Connect.contextTypes = contextTypes;
    Connect.propTypes = contextTypes;

    if (false) {
      Connect.prototype.componentWillUpdate = function componentWillUpdate() {
        var _this2 = this;

        // We are hot reloading!
        if (this.version !== version) {
          this.version = version;
          this.initSelector();

          // If any connected descendants don't hot reload (and resubscribe in the process), their
          // listeners will be lost when we unsubscribe. Unfortunately, by copying over all
          // listeners, this does mean that the old versions of connected descendants will still be
          // notified of state changes; however, their onStateChange function is a no-op so this
          // isn't a huge deal.
          var oldListeners = [];

          if (this.subscription) {
            oldListeners = this.subscription.listeners.get();
            this.subscription.tryUnsubscribe();
          }
          this.initSubscription();
          if (shouldHandleStateChanges) {
            this.subscription.trySubscribe();
            oldListeners.forEach(function (listener) {
              return _this2.subscription.listeners.subscribe(listener);
            });
          }
        }
      };
    }

    return __WEBPACK_IMPORTED_MODULE_0_hoist_non_react_statics___default()(Connect, WrappedComponent);
  };
}

/***/ }),
/* 223 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = wrapMapToPropsConstant;
/* unused harmony export getDependsOnOwnProps */
/* harmony export (immutable) */ __webpack_exports__["b"] = wrapMapToPropsFunc;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_verifyPlainObject__ = __webpack_require__(224);


function wrapMapToPropsConstant(getConstant) {
  return function initConstantSelector(dispatch, options) {
    var constant = getConstant(dispatch, options);

    function constantSelector() {
      return constant;
    }
    constantSelector.dependsOnOwnProps = false;
    return constantSelector;
  };
}

// dependsOnOwnProps is used by createMapToPropsProxy to determine whether to pass props as args
// to the mapToProps function being wrapped. It is also used by makePurePropsSelector to determine
// whether mapToProps needs to be invoked when props have changed.
// 
// A length of one signals that mapToProps does not depend on props from the parent component.
// A length of zero is assumed to mean mapToProps is getting args via arguments or ...args and
// therefore not reporting its length accurately..
function getDependsOnOwnProps(mapToProps) {
  return mapToProps.dependsOnOwnProps !== null && mapToProps.dependsOnOwnProps !== undefined ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
}

// Used by whenMapStateToPropsIsFunction and whenMapDispatchToPropsIsFunction,
// this function wraps mapToProps in a proxy function which does several things:
// 
//  * Detects whether the mapToProps function being called depends on props, which
//    is used by selectorFactory to decide if it should reinvoke on props changes.
//    
//  * On first call, handles mapToProps if returns another function, and treats that
//    new function as the true mapToProps for subsequent calls.
//    
//  * On first call, verifies the first result is a plain object, in order to warn
//    the developer that their mapToProps function is not returning a valid result.
//    
function wrapMapToPropsFunc(mapToProps, methodName) {
  return function initProxySelector(dispatch, _ref) {
    var displayName = _ref.displayName;

    var proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
      return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch);
    };

    // allow detectFactoryAndVerify to get ownProps
    proxy.dependsOnOwnProps = true;

    proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
      proxy.mapToProps = mapToProps;
      proxy.dependsOnOwnProps = getDependsOnOwnProps(mapToProps);
      var props = proxy(stateOrDispatch, ownProps);

      if (typeof props === 'function') {
        proxy.mapToProps = props;
        proxy.dependsOnOwnProps = getDependsOnOwnProps(props);
        props = proxy(stateOrDispatch, ownProps);
      }

      if (false) verifyPlainObject(props, displayName, methodName);

      return props;
    };

    return proxy;
  };
}

/***/ }),
/* 224 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_es_isPlainObject__ = __webpack_require__(400);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__warning__ = __webpack_require__(161);



function verifyPlainObject(value, displayName, methodName) {
  if (!Object(__WEBPACK_IMPORTED_MODULE_0_lodash_es_isPlainObject__["a" /* default */])(value)) {
    Object(__WEBPACK_IMPORTED_MODULE_1__warning__["a" /* default */])(methodName + '() in ' + displayName + ' must return a plain object. Instead received ' + value + '.');
  }
}

/***/ }),
/* 225 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__root_js__ = __webpack_require__(402);


/** Built-in value references. */
var Symbol = __WEBPACK_IMPORTED_MODULE_0__root_js__["a" /* default */].Symbol;

/* harmony default export */ __webpack_exports__["a"] = (Symbol);


/***/ }),
/* 226 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history__ = __webpack_require__(61);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var isModifiedEvent = function isModifiedEvent(event) {
  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
};

/**
 * The public API for rendering a history-aware <a>.
 */

var Link = function (_React$Component) {
  _inherits(Link, _React$Component);

  function Link() {
    var _temp, _this, _ret;

    _classCallCheck(this, Link);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.handleClick = function (event) {
      if (_this.props.onClick) _this.props.onClick(event);

      if (!event.defaultPrevented && // onClick prevented default
      event.button === 0 && // ignore everything but left clicks
      !_this.props.target && // let browser handle "target=_blank" etc.
      !isModifiedEvent(event) // ignore clicks with modifier keys
      ) {
          event.preventDefault();

          var history = _this.context.router.history;
          var _this$props = _this.props,
              replace = _this$props.replace,
              to = _this$props.to;


          if (replace) {
            history.replace(to);
          } else {
            history.push(to);
          }
        }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Link.prototype.render = function render() {
    var _props = this.props,
        replace = _props.replace,
        to = _props.to,
        innerRef = _props.innerRef,
        props = _objectWithoutProperties(_props, ["replace", "to", "innerRef"]); // eslint-disable-line no-unused-vars

    __WEBPACK_IMPORTED_MODULE_2_invariant___default()(this.context.router, "You should not use <Link> outside a <Router>");

    __WEBPACK_IMPORTED_MODULE_2_invariant___default()(to !== undefined, 'You must specify the "to" property');

    var history = this.context.router.history;

    var location = typeof to === "string" ? Object(__WEBPACK_IMPORTED_MODULE_3_history__["c" /* createLocation */])(to, null, null, history.location) : to;

    var href = history.createHref(location);
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a", _extends({}, props, { onClick: this.handleClick, href: href, ref: innerRef }));
  };

  return Link;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Link.propTypes = {
  onClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  target: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  replace: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  to: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object]).isRequired,
  innerRef: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func])
};
Link.defaultProps = {
  replace: false
};
Link.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      push: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
      replace: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
      createHref: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
    }).isRequired
  }).isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Link);

/***/ }),
/* 227 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Route__ = __webpack_require__(228);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Route__["a" /* default */]);

/***/ }),
/* 228 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__matchPath__ = __webpack_require__(164);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var isEmptyChildren = function isEmptyChildren(children) {
  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.count(children) === 0;
};

/**
 * The public API for matching a single path and rendering.
 */

var Route = function (_React$Component) {
  _inherits(Route, _React$Component);

  function Route() {
    var _temp, _this, _ret;

    _classCallCheck(this, Route);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
      match: _this.computeMatch(_this.props, _this.context.router)
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Route.prototype.getChildContext = function getChildContext() {
    return {
      router: _extends({}, this.context.router, {
        route: {
          location: this.props.location || this.context.router.route.location,
          match: this.state.match
        }
      })
    };
  };

  Route.prototype.computeMatch = function computeMatch(_ref, router) {
    var computedMatch = _ref.computedMatch,
        location = _ref.location,
        path = _ref.path,
        strict = _ref.strict,
        exact = _ref.exact,
        sensitive = _ref.sensitive;

    if (computedMatch) return computedMatch; // <Switch> already computed the match for us

    __WEBPACK_IMPORTED_MODULE_1_invariant___default()(router, "You should not use <Route> or withRouter() outside a <Router>");

    var route = router.route;

    var pathname = (location || route.location).pathname;

    return Object(__WEBPACK_IMPORTED_MODULE_4__matchPath__["a" /* default */])(pathname, { path: path, strict: strict, exact: exact, sensitive: sensitive }, route.match);
  };

  Route.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(this.props.component && this.props.render), "You should not use <Route component> and <Route render> in the same route; <Route render> will be ignored");

    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(this.props.component && this.props.children && !isEmptyChildren(this.props.children)), "You should not use <Route component> and <Route children> in the same route; <Route children> will be ignored");

    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(this.props.render && this.props.children && !isEmptyChildren(this.props.children)), "You should not use <Route render> and <Route children> in the same route; <Route children> will be ignored");
  };

  Route.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps, nextContext) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(nextProps.location && !this.props.location), '<Route> elements should not change from uncontrolled to controlled (or vice versa). You initially used no "location" prop and then provided one on a subsequent render.');

    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(!nextProps.location && this.props.location), '<Route> elements should not change from controlled to uncontrolled (or vice versa). You provided a "location" prop initially but omitted it on a subsequent render.');

    this.setState({
      match: this.computeMatch(nextProps, nextContext.router)
    });
  };

  Route.prototype.render = function render() {
    var match = this.state.match;
    var _props = this.props,
        children = _props.children,
        component = _props.component,
        render = _props.render;
    var _context$router = this.context.router,
        history = _context$router.history,
        route = _context$router.route,
        staticContext = _context$router.staticContext;

    var location = this.props.location || route.location;
    var props = { match: match, location: location, history: history, staticContext: staticContext };

    if (component) return match ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(component, props) : null;

    if (render) return match ? render(props) : null;

    if (typeof children === "function") return children(props);

    if (children && !isEmptyChildren(children)) return __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.only(children);

    return null;
  };

  return Route;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

Route.propTypes = {
  computedMatch: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object, // private, from <Switch>
  path: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  exact: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  strict: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  sensitive: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  component: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,
  render: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,
  children: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node]),
  location: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
};
Route.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
    route: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
    staticContext: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
  })
};
Route.childContextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Route);

/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

var isarray = __webpack_require__(418)

/**
 * Expose `pathToRegexp`.
 */
module.exports = pathToRegexp
module.exports.parse = parse
module.exports.compile = compile
module.exports.tokensToFunction = tokensToFunction
module.exports.tokensToRegExp = tokensToRegExp

/**
 * The main path matching regexp utility.
 *
 * @type {RegExp}
 */
var PATH_REGEXP = new RegExp([
  // Match escaped characters that would otherwise appear in future matches.
  // This allows the user to escape special characters that won't transform.
  '(\\\\.)',
  // Match Express-style parameters and un-named parameters with a prefix
  // and optional suffixes. Matches appear as:
  //
  // "/:test(\\d+)?" => ["/", "test", "\d+", undefined, "?", undefined]
  // "/route(\\d+)"  => [undefined, undefined, undefined, "\d+", undefined, undefined]
  // "/*"            => ["/", undefined, undefined, undefined, undefined, "*"]
  '([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?|(\\*))'
].join('|'), 'g')

/**
 * Parse a string for the raw tokens.
 *
 * @param  {string}  str
 * @param  {Object=} options
 * @return {!Array}
 */
function parse (str, options) {
  var tokens = []
  var key = 0
  var index = 0
  var path = ''
  var defaultDelimiter = options && options.delimiter || '/'
  var res

  while ((res = PATH_REGEXP.exec(str)) != null) {
    var m = res[0]
    var escaped = res[1]
    var offset = res.index
    path += str.slice(index, offset)
    index = offset + m.length

    // Ignore already escaped sequences.
    if (escaped) {
      path += escaped[1]
      continue
    }

    var next = str[index]
    var prefix = res[2]
    var name = res[3]
    var capture = res[4]
    var group = res[5]
    var modifier = res[6]
    var asterisk = res[7]

    // Push the current path onto the tokens.
    if (path) {
      tokens.push(path)
      path = ''
    }

    var partial = prefix != null && next != null && next !== prefix
    var repeat = modifier === '+' || modifier === '*'
    var optional = modifier === '?' || modifier === '*'
    var delimiter = res[2] || defaultDelimiter
    var pattern = capture || group

    tokens.push({
      name: name || key++,
      prefix: prefix || '',
      delimiter: delimiter,
      optional: optional,
      repeat: repeat,
      partial: partial,
      asterisk: !!asterisk,
      pattern: pattern ? escapeGroup(pattern) : (asterisk ? '.*' : '[^' + escapeString(delimiter) + ']+?')
    })
  }

  // Match any characters still remaining.
  if (index < str.length) {
    path += str.substr(index)
  }

  // If the path exists, push it onto the end.
  if (path) {
    tokens.push(path)
  }

  return tokens
}

/**
 * Compile a string to a template function for the path.
 *
 * @param  {string}             str
 * @param  {Object=}            options
 * @return {!function(Object=, Object=)}
 */
function compile (str, options) {
  return tokensToFunction(parse(str, options))
}

/**
 * Prettier encoding of URI path segments.
 *
 * @param  {string}
 * @return {string}
 */
function encodeURIComponentPretty (str) {
  return encodeURI(str).replace(/[\/?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Encode the asterisk parameter. Similar to `pretty`, but allows slashes.
 *
 * @param  {string}
 * @return {string}
 */
function encodeAsterisk (str) {
  return encodeURI(str).replace(/[?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Expose a method for transforming tokens into the path function.
 */
function tokensToFunction (tokens) {
  // Compile all the tokens into regexps.
  var matches = new Array(tokens.length)

  // Compile all the patterns before compilation.
  for (var i = 0; i < tokens.length; i++) {
    if (typeof tokens[i] === 'object') {
      matches[i] = new RegExp('^(?:' + tokens[i].pattern + ')$')
    }
  }

  return function (obj, opts) {
    var path = ''
    var data = obj || {}
    var options = opts || {}
    var encode = options.pretty ? encodeURIComponentPretty : encodeURIComponent

    for (var i = 0; i < tokens.length; i++) {
      var token = tokens[i]

      if (typeof token === 'string') {
        path += token

        continue
      }

      var value = data[token.name]
      var segment

      if (value == null) {
        if (token.optional) {
          // Prepend partial segment prefixes.
          if (token.partial) {
            path += token.prefix
          }

          continue
        } else {
          throw new TypeError('Expected "' + token.name + '" to be defined')
        }
      }

      if (isarray(value)) {
        if (!token.repeat) {
          throw new TypeError('Expected "' + token.name + '" to not repeat, but received `' + JSON.stringify(value) + '`')
        }

        if (value.length === 0) {
          if (token.optional) {
            continue
          } else {
            throw new TypeError('Expected "' + token.name + '" to not be empty')
          }
        }

        for (var j = 0; j < value.length; j++) {
          segment = encode(value[j])

          if (!matches[i].test(segment)) {
            throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '", but received `' + JSON.stringify(segment) + '`')
          }

          path += (j === 0 ? token.prefix : token.delimiter) + segment
        }

        continue
      }

      segment = token.asterisk ? encodeAsterisk(value) : encode(value)

      if (!matches[i].test(segment)) {
        throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but received "' + segment + '"')
      }

      path += token.prefix + segment
    }

    return path
  }
}

/**
 * Escape a regular expression string.
 *
 * @param  {string} str
 * @return {string}
 */
function escapeString (str) {
  return str.replace(/([.+*?=^!:${}()[\]|\/\\])/g, '\\$1')
}

/**
 * Escape the capturing group by escaping special characters and meaning.
 *
 * @param  {string} group
 * @return {string}
 */
function escapeGroup (group) {
  return group.replace(/([=!:$\/()])/g, '\\$1')
}

/**
 * Attach the keys as a property of the regexp.
 *
 * @param  {!RegExp} re
 * @param  {Array}   keys
 * @return {!RegExp}
 */
function attachKeys (re, keys) {
  re.keys = keys
  return re
}

/**
 * Get the flags for a regexp from the options.
 *
 * @param  {Object} options
 * @return {string}
 */
function flags (options) {
  return options.sensitive ? '' : 'i'
}

/**
 * Pull out keys from a regexp.
 *
 * @param  {!RegExp} path
 * @param  {!Array}  keys
 * @return {!RegExp}
 */
function regexpToRegexp (path, keys) {
  // Use a negative lookahead to match only capturing groups.
  var groups = path.source.match(/\((?!\?)/g)

  if (groups) {
    for (var i = 0; i < groups.length; i++) {
      keys.push({
        name: i,
        prefix: null,
        delimiter: null,
        optional: false,
        repeat: false,
        partial: false,
        asterisk: false,
        pattern: null
      })
    }
  }

  return attachKeys(path, keys)
}

/**
 * Transform an array into a regexp.
 *
 * @param  {!Array}  path
 * @param  {Array}   keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function arrayToRegexp (path, keys, options) {
  var parts = []

  for (var i = 0; i < path.length; i++) {
    parts.push(pathToRegexp(path[i], keys, options).source)
  }

  var regexp = new RegExp('(?:' + parts.join('|') + ')', flags(options))

  return attachKeys(regexp, keys)
}

/**
 * Create a path regexp from string input.
 *
 * @param  {string}  path
 * @param  {!Array}  keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function stringToRegexp (path, keys, options) {
  return tokensToRegExp(parse(path, options), keys, options)
}

/**
 * Expose a function for taking tokens and returning a RegExp.
 *
 * @param  {!Array}          tokens
 * @param  {(Array|Object)=} keys
 * @param  {Object=}         options
 * @return {!RegExp}
 */
function tokensToRegExp (tokens, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options)
    keys = []
  }

  options = options || {}

  var strict = options.strict
  var end = options.end !== false
  var route = ''

  // Iterate over the tokens and create our regexp string.
  for (var i = 0; i < tokens.length; i++) {
    var token = tokens[i]

    if (typeof token === 'string') {
      route += escapeString(token)
    } else {
      var prefix = escapeString(token.prefix)
      var capture = '(?:' + token.pattern + ')'

      keys.push(token)

      if (token.repeat) {
        capture += '(?:' + prefix + capture + ')*'
      }

      if (token.optional) {
        if (!token.partial) {
          capture = '(?:' + prefix + '(' + capture + '))?'
        } else {
          capture = prefix + '(' + capture + ')?'
        }
      } else {
        capture = prefix + '(' + capture + ')'
      }

      route += capture
    }
  }

  var delimiter = escapeString(options.delimiter || '/')
  var endsWithDelimiter = route.slice(-delimiter.length) === delimiter

  // In non-strict mode we allow a slash at the end of match. If the path to
  // match already ends with a slash, we remove it for consistency. The slash
  // is valid at the end of a path match, not in the middle. This is important
  // in non-ending mode, where "/test/" shouldn't match "/test//route".
  if (!strict) {
    route = (endsWithDelimiter ? route.slice(0, -delimiter.length) : route) + '(?:' + delimiter + '(?=$))?'
  }

  if (end) {
    route += '$'
  } else {
    // In non-ending mode, we need the capturing groups to match as much as
    // possible by using a positive lookahead to the end or next path segment.
    route += strict && endsWithDelimiter ? '' : '(?=' + delimiter + '|$)'
  }

  return attachKeys(new RegExp('^' + route, flags(options)), keys)
}

/**
 * Normalize the given path string, returning a regular expression.
 *
 * An empty array can be passed in for the keys, which will hold the
 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
 *
 * @param  {(string|RegExp|Array)} path
 * @param  {(Array|Object)=}       keys
 * @param  {Object=}               options
 * @return {!RegExp}
 */
function pathToRegexp (path, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options)
    keys = []
  }

  options = options || {}

  if (path instanceof RegExp) {
    return regexpToRegexp(path, /** @type {!Array} */ (keys))
  }

  if (isarray(path)) {
    return arrayToRegexp(/** @type {!Array} */ (path), /** @type {!Array} */ (keys), options)
  }

  return stringToRegexp(/** @type {string} */ (path), /** @type {!Array} */ (keys), options)
}


/***/ }),
/* 230 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_path_to_regexp__ = __webpack_require__(229);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_path_to_regexp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_path_to_regexp__);


var patternCache = {};
var cacheLimit = 10000;
var cacheCount = 0;

var compileGenerator = function compileGenerator(pattern) {
  var cacheKey = pattern;
  var cache = patternCache[cacheKey] || (patternCache[cacheKey] = {});

  if (cache[pattern]) return cache[pattern];

  var compiledGenerator = __WEBPACK_IMPORTED_MODULE_0_path_to_regexp___default.a.compile(pattern);

  if (cacheCount < cacheLimit) {
    cache[pattern] = compiledGenerator;
    cacheCount++;
  }

  return compiledGenerator;
};

/**
 * Public API for generating a URL pathname from a pattern and parameters.
 */
var generatePath = function generatePath() {
  var pattern = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "/";
  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  if (pattern === "/") {
    return pattern;
  }
  var generator = compileGenerator(pattern);
  return generator(params, { pretty: true });
};

/* harmony default export */ __webpack_exports__["a"] = (generatePath);

/***/ }),
/* 231 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * Namespaces to avoid conflicts on the context.
 */
var jss = exports.jss = '64a55d578f856d258dc345b094a2a2b3';
var sheetsRegistry = exports.sheetsRegistry = 'd4bd0baacbc52bbd48bbb9eb24344ecd';
var managers = exports.managers = 'b768b78919504fba9de2c03545c5cd3a';
var sheetOptions = exports.sheetOptions = '6fc570d6bd61383819d0f9e7407c452d';

/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.create = exports.createGenerateClassName = exports.sheets = exports.RuleList = exports.SheetsManager = exports.SheetsRegistry = exports.toCssValue = exports.getDynamicStyles = undefined;

var _getDynamicStyles = __webpack_require__(437);

Object.defineProperty(exports, 'getDynamicStyles', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_getDynamicStyles)['default'];
  }
});

var _toCssValue = __webpack_require__(118);

Object.defineProperty(exports, 'toCssValue', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_toCssValue)['default'];
  }
});

var _SheetsRegistry = __webpack_require__(233);

Object.defineProperty(exports, 'SheetsRegistry', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_SheetsRegistry)['default'];
  }
});

var _SheetsManager = __webpack_require__(438);

Object.defineProperty(exports, 'SheetsManager', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_SheetsManager)['default'];
  }
});

var _RuleList = __webpack_require__(91);

Object.defineProperty(exports, 'RuleList', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_RuleList)['default'];
  }
});

var _sheets = __webpack_require__(169);

Object.defineProperty(exports, 'sheets', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_sheets)['default'];
  }
});

var _createGenerateClassName = __webpack_require__(236);

Object.defineProperty(exports, 'createGenerateClassName', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_createGenerateClassName)['default'];
  }
});

var _Jss = __webpack_require__(444);

var _Jss2 = _interopRequireDefault(_Jss);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

/**
 * Creates a new instance of Jss.
 */
var create = exports.create = function create(options) {
  return new _Jss2['default'](options);
};

/**
 * A global Jss instance.
 */
exports['default'] = create();

/***/ }),
/* 233 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Sheets registry to access them all at one place.
 */
var SheetsRegistry = function () {
  function SheetsRegistry() {
    _classCallCheck(this, SheetsRegistry);

    this.registry = [];
  }

  _createClass(SheetsRegistry, [{
    key: 'add',


    /**
     * Register a Style Sheet.
     */
    value: function add(sheet) {
      var registry = this.registry;
      var index = sheet.options.index;


      if (registry.indexOf(sheet) !== -1) return;

      if (registry.length === 0 || index >= this.index) {
        registry.push(sheet);
        return;
      }

      // Find a position.
      for (var i = 0; i < registry.length; i++) {
        if (registry[i].options.index > index) {
          registry.splice(i, 0, sheet);
          return;
        }
      }
    }

    /**
     * Reset the registry.
     */

  }, {
    key: 'reset',
    value: function reset() {
      this.registry = [];
    }

    /**
     * Remove a Style Sheet.
     */

  }, {
    key: 'remove',
    value: function remove(sheet) {
      var index = this.registry.indexOf(sheet);
      this.registry.splice(index, 1);
    }

    /**
     * Convert all attached sheets to a CSS string.
     */

  }, {
    key: 'toString',
    value: function toString(options) {
      return this.registry.filter(function (sheet) {
        return sheet.attached;
      }).map(function (sheet) {
        return sheet.toString(options);
      }).join('\n');
    }
  }, {
    key: 'index',


    /**
     * Current highest index number.
     */
    get: function get() {
      return this.registry.length === 0 ? 0 : this.registry[this.registry.length - 1].options.index;
    }
  }]);

  return SheetsRegistry;
}();

exports['default'] = SheetsRegistry;

/***/ }),
/* 234 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _symbolObservable = __webpack_require__(440);

var _symbolObservable2 = _interopRequireDefault(_symbolObservable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = function (value) {
  return value && value[_symbolObservable2['default']] && value === value[_symbolObservable2['default']]();
};

/***/ }),
/* 235 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = linkRule;
/**
 * Link rule with CSSStyleRule and nested rules with corresponding nested cssRules if both exists.
 */
function linkRule(rule, cssRule) {
  rule.renderable = cssRule;
  if (rule.rules && cssRule.cssRules) rule.rules.link(cssRule.cssRules);
}

/***/ }),
/* 236 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _warning = __webpack_require__(68);

var _warning2 = _interopRequireDefault(_warning);

var _StyleSheet = __webpack_require__(237);

var _StyleSheet2 = _interopRequireDefault(_StyleSheet);

var _moduleId = __webpack_require__(443);

var _moduleId2 = _interopRequireDefault(_moduleId);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var maxRules = 1e10;


var env = "production";

/**
 * Returns a function which generates unique class names based on counters.
 * When new generator function is created, rule counter is reseted.
 * We need to reset the rule counter for SSR for each request.
 */

exports['default'] = function () {
  var ruleCounter = 0;
  var defaultPrefix = env === 'production' ? 'c' : '';

  return function (rule, sheet) {
    ruleCounter += 1;

    if (ruleCounter > maxRules) {
      (0, _warning2['default'])(false, '[JSS] You might have a memory leak. Rule counter is at %s.', ruleCounter);
    }

    var prefix = defaultPrefix;
    var jssId = '';

    if (sheet) {
      prefix = sheet.options.classNamePrefix || defaultPrefix;
      if (sheet.options.jss.id != null) jssId += sheet.options.jss.id;
    }

    if (env === 'production') {
      return '' + prefix + _moduleId2['default'] + jssId + ruleCounter;
    }

    return prefix + rule.key + '-' + _moduleId2['default'] + (jssId && '-' + jssId) + '-' + ruleCounter;
  };
};

/***/ }),
/* 237 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _linkRule = __webpack_require__(235);

var _linkRule2 = _interopRequireDefault(_linkRule);

var _RuleList = __webpack_require__(91);

var _RuleList2 = _interopRequireDefault(_RuleList);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/* eslint-disable-next-line no-use-before-define */
var StyleSheet = function () {
  function StyleSheet(styles, options) {
    var _this = this;

    _classCallCheck(this, StyleSheet);

    this.update = function (name, data) {
      if (typeof name === 'string') {
        _this.rules.update(name, data);
      } else {
        _this.rules.update(name);
      }
      return _this;
    };

    this.attached = false;
    this.deployed = false;
    this.linked = false;
    this.classes = {};
    this.options = _extends({}, options, {
      sheet: this,
      parent: this,
      classes: this.classes
    });
    this.renderer = new options.Renderer(this);
    this.rules = new _RuleList2['default'](this.options);

    for (var _name in styles) {
      this.rules.add(_name, styles[_name]);
    }

    this.rules.process();
  }

  /**
   * Attach renderable to the render tree.
   */


  _createClass(StyleSheet, [{
    key: 'attach',
    value: function attach() {
      if (this.attached) return this;
      if (!this.deployed) this.deploy();
      this.renderer.attach();
      if (!this.linked && this.options.link) this.link();
      this.attached = true;
      return this;
    }

    /**
     * Remove renderable from render tree.
     */

  }, {
    key: 'detach',
    value: function detach() {
      if (!this.attached) return this;
      this.renderer.detach();
      this.attached = false;
      return this;
    }

    /**
     * Add a rule to the current stylesheet.
     * Will insert a rule also after the stylesheet has been rendered first time.
     */

  }, {
    key: 'addRule',
    value: function addRule(name, decl, options) {
      var queue = this.queue;

      // Plugins can create rules.
      // In order to preserve the right order, we need to queue all `.addRule` calls,
      // which happen after the first `rules.add()` call.

      if (this.attached && !queue) this.queue = [];

      var rule = this.rules.add(name, decl, options);
      this.options.jss.plugins.onProcessRule(rule);

      if (this.attached) {
        if (!this.deployed) return rule;
        // Don't insert rule directly if there is no stringified version yet.
        // It will be inserted all together when .attach is called.
        if (queue) queue.push(rule);else {
          this.insertRule(rule);
          if (this.queue) {
            this.queue.forEach(this.insertRule, this);
            this.queue = undefined;
          }
        }
        return rule;
      }

      // We can't add rules to a detached style node.
      // We will redeploy the sheet once user will attach it.
      this.deployed = false;

      return rule;
    }

    /**
     * Insert rule into the StyleSheet
     */

  }, {
    key: 'insertRule',
    value: function insertRule(rule) {
      var renderable = this.renderer.insertRule(rule);
      if (renderable && this.options.link) (0, _linkRule2['default'])(rule, renderable);
    }

    /**
     * Create and add rules.
     * Will render also after Style Sheet was rendered the first time.
     */

  }, {
    key: 'addRules',
    value: function addRules(styles, options) {
      var added = [];
      for (var _name2 in styles) {
        added.push(this.addRule(_name2, styles[_name2], options));
      }
      return added;
    }

    /**
     * Get a rule by name.
     */

  }, {
    key: 'getRule',
    value: function getRule(name) {
      return this.rules.get(name);
    }

    /**
     * Delete a rule by name.
     * Returns `true`: if rule has been deleted from the DOM.
     */

  }, {
    key: 'deleteRule',
    value: function deleteRule(name) {
      var rule = this.rules.get(name);

      if (!rule) return false;

      this.rules.remove(rule);

      if (this.attached && rule.renderable) {
        return this.renderer.deleteRule(rule.renderable);
      }

      return true;
    }

    /**
     * Get index of a rule.
     */

  }, {
    key: 'indexOf',
    value: function indexOf(rule) {
      return this.rules.indexOf(rule);
    }

    /**
     * Deploy pure CSS string to a renderable.
     */

  }, {
    key: 'deploy',
    value: function deploy() {
      this.renderer.deploy();
      this.deployed = true;
      return this;
    }

    /**
     * Link renderable CSS rules from sheet with their corresponding models.
     */

  }, {
    key: 'link',
    value: function link() {
      var cssRules = this.renderer.getRules();

      // Is undefined when VirtualRenderer is used.
      if (cssRules) this.rules.link(cssRules);
      this.linked = true;
      return this;
    }

    /**
     * Update the function values with a new data.
     */

  }, {
    key: 'toString',


    /**
     * Convert rules to a CSS string.
     */
    value: function toString(options) {
      return this.rules.toString(options);
    }
  }]);

  return StyleSheet;
}();

exports['default'] = StyleSheet;

/***/ }),
/* 238 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(2);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _jssGlobal = _interopRequireDefault(__webpack_require__(456));

var _jssNested = _interopRequireDefault(__webpack_require__(457));

var _jssCamelCase = _interopRequireDefault(__webpack_require__(459));

var _jssDefaultUnit = _interopRequireDefault(__webpack_require__(461));

var _jssVendorPrefixer = _interopRequireDefault(__webpack_require__(463));

var _jssPropsSort = _interopRequireDefault(__webpack_require__(468));

// Subset of jss-preset-default with only the plugins the Material-UI
// components are using.
function jssPreset() {
  return {
    plugins: [(0, _jssGlobal.default)(), (0, _jssNested.default)(), (0, _jssCamelCase.default)(), (0, _jssDefaultUnit.default)(), (0, _jssVendorPrefixer.default)(), (0, _jssPropsSort.default)()]
  };
}

var _default = jssPreset;
exports.default = _default;

/***/ }),
/* 239 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(2);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectSpread2 = _interopRequireDefault(__webpack_require__(17));

var _warning = _interopRequireDefault(__webpack_require__(16));

var _getDisplayName = _interopRequireDefault(__webpack_require__(167));

function mergeClasses() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var baseClasses = options.baseClasses,
      newClasses = options.newClasses,
      Component = options.Component,
      _options$noBase = options.noBase,
      noBase = _options$noBase === void 0 ? false : _options$noBase;

  if (!newClasses) {
    return baseClasses;
  }

  return (0, _objectSpread2.default)({}, baseClasses, Object.keys(newClasses).reduce(function (accumulator, key) {
     false ? (0, _warning.default)(baseClasses[key] || noBase, ["Material-UI: the key `".concat(key, "` ") + "provided to the classes property is not implemented in ".concat((0, _getDisplayName.default)(Component), "."), "You can only override one of the following: ".concat(Object.keys(baseClasses).join(','))].join('\n')) : void 0;
     false ? (0, _warning.default)(!newClasses[key] || typeof newClasses[key] === 'string', ["Material-UI: the key `".concat(key, "` ") + "provided to the classes property is not valid for ".concat((0, _getDisplayName.default)(Component), "."), "You need to provide a non empty string instead of: ".concat(newClasses[key], ".")].join('\n')) : void 0;

    if (newClasses[key]) {
      accumulator[key] = "".concat(baseClasses[key], " ").concat(newClasses[key]);
    }

    return accumulator;
  }, {}));
}

var _default = mergeClasses;
exports.default = _default;

/***/ }),
/* 240 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

var _interopRequireDefault = __webpack_require__(2);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = createGenerateClassName;

var _warning = _interopRequireDefault(__webpack_require__(16));

/* eslint-disable no-underscore-dangle */
// People might bundle this classname generator twice.
// We need to use a global.
global.__MUI_GENERATOR_COUNTER__ = 0;
var escapeRegex = /([[\].#*$><+~=|^:(),"'`\s])/g;

function safePrefix(classNamePrefix) {
  var prefix = String(classNamePrefix);
   false ? (0, _warning.default)(prefix.length < 256, "Material-UI: the class name prefix is too long: ".concat(prefix, ".")) : void 0; // Sanitize the string as will be used to prefix the generated class name.

  return prefix.replace(escapeRegex, '-');
} // Returns a function which generates unique class names based on counters.
// When new generator function is created, rule counter is reset.
// We need to reset the rule counter for SSR for each request.
//
// It's inspired by
// https://github.com/cssinjs/jss/blob/4e6a05dd3f7b6572fdd3ab216861d9e446c20331/src/utils/createGenerateClassName.js


function createGenerateClassName() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _options$dangerouslyU = options.dangerouslyUseGlobalCSS,
      dangerouslyUseGlobalCSS = _options$dangerouslyU === void 0 ? false : _options$dangerouslyU,
      _options$productionPr = options.productionPrefix,
      productionPrefix = _options$productionPr === void 0 ? 'jss' : _options$productionPr;
  var ruleCounter = 0; // - HMR can lead to many class name generators being instantiated,
  // so the warning is only triggered in production.
  // - We expect a class name generator to be instantiated per new request on the server,
  // so the warning is only triggered client side.

  if ("production" === 'production' && typeof window !== 'undefined') {
    global.__MUI_GENERATOR_COUNTER__ += 1;

    if (global.__MUI_GENERATOR_COUNTER__ > 2) {
      // eslint-disable-next-line no-console
      console.error(['Material-UI: we have detected more than needed creation of the class name generator.', 'You should only use one class name generator on the client side.', 'If you do otherwise, you take the risk to have conflicting class names in production.'].join('\n'));
    }
  }

  return function (rule, styleSheet) {
    ruleCounter += 1;
     false ? (0, _warning.default)(ruleCounter < 1e10, ['Material-UI: you might have a memory leak.', 'The ruleCounter is not supposed to grow that much.'].join('')) : void 0; // Code branch the whole block at the expense of more code.

    if (dangerouslyUseGlobalCSS) {
      if (styleSheet) {
        if (styleSheet.options.name) {
          return "".concat(styleSheet.options.name, "-").concat(rule.key);
        }

        if (styleSheet.options.classNamePrefix && "production" !== 'production') {
          var prefix = safePrefix(styleSheet.options.classNamePrefix);
          return "".concat(prefix, "-").concat(rule.key, "-").concat(ruleCounter);
        }
      }

      if (true) {
        return "".concat(productionPrefix).concat(ruleCounter);
      }

      return "".concat(rule.key, "-").concat(ruleCounter);
    }

    if (true) {
      return "".concat(productionPrefix).concat(ruleCounter);
    }

    if (styleSheet && styleSheet.options.classNamePrefix) {
      var _prefix = safePrefix(styleSheet.options.classNamePrefix);

      return "".concat(_prefix, "-").concat(rule.key, "-").concat(ruleCounter);
    }

    return "".concat(rule.key, "-").concat(ruleCounter);
  };
}
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(36)))

/***/ }),
/* 241 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

function getThemeProps(params) {
  var theme = params.theme,
      name = params.name;

  if (!name || !theme.props || !theme.props[name]) {
    return {};
  }

  return theme.props[name];
}

var _default = getThemeProps;
exports.default = _default;

/***/ }),
/* 242 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(90);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _setStatic = _interopRequireDefault(__webpack_require__(493));

var setDisplayName = function setDisplayName(displayName) {
  return (0, _setStatic.default)('displayName', displayName);
};

var _default = setDisplayName;
exports.default = _default;

/***/ }),
/* 243 */
/***/ (function(module, exports, __webpack_require__) {

var arrayWithoutHoles = __webpack_require__(501);

var iterableToArray = __webpack_require__(502);

var nonIterableSpread = __webpack_require__(503);

function _toConsumableArray(arr) {
  return arrayWithoutHoles(arr) || iterableToArray(arr) || nonIterableSpread();
}

module.exports = _toConsumableArray;

/***/ }),
/* 244 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "polyfill", function() { return polyfill; });
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

function componentWillMount() {
  // Call this.constructor.gDSFP to support sub-classes.
  var state = this.constructor.getDerivedStateFromProps(this.props, this.state);
  if (state !== null && state !== undefined) {
    this.setState(state);
  }
}

function componentWillReceiveProps(nextProps) {
  // Call this.constructor.gDSFP to support sub-classes.
  // Use the setState() updater to ensure state isn't stale in certain edge cases.
  function updater(prevState) {
    var state = this.constructor.getDerivedStateFromProps(nextProps, prevState);
    return state !== null && state !== undefined ? state : null;
  }
  // Binding "this" is important for shallow renderer support.
  this.setState(updater.bind(this));
}

function componentWillUpdate(nextProps, nextState) {
  try {
    var prevProps = this.props;
    var prevState = this.state;
    this.props = nextProps;
    this.state = nextState;
    this.__reactInternalSnapshotFlag = true;
    this.__reactInternalSnapshot = this.getSnapshotBeforeUpdate(
      prevProps,
      prevState
    );
  } finally {
    this.props = prevProps;
    this.state = prevState;
  }
}

// React may warn about cWM/cWRP/cWU methods being deprecated.
// Add a flag to suppress these warnings for this special case.
componentWillMount.__suppressDeprecationWarning = true;
componentWillReceiveProps.__suppressDeprecationWarning = true;
componentWillUpdate.__suppressDeprecationWarning = true;

function polyfill(Component) {
  var prototype = Component.prototype;

  if (!prototype || !prototype.isReactComponent) {
    throw new Error('Can only polyfill class components');
  }

  if (
    typeof Component.getDerivedStateFromProps !== 'function' &&
    typeof prototype.getSnapshotBeforeUpdate !== 'function'
  ) {
    return Component;
  }

  // If new component APIs are defined, "unsafe" lifecycles won't be called.
  // Error if any of these lifecycles are present,
  // Because they would work differently between older and newer (16.3+) versions of React.
  var foundWillMountName = null;
  var foundWillReceivePropsName = null;
  var foundWillUpdateName = null;
  if (typeof prototype.componentWillMount === 'function') {
    foundWillMountName = 'componentWillMount';
  } else if (typeof prototype.UNSAFE_componentWillMount === 'function') {
    foundWillMountName = 'UNSAFE_componentWillMount';
  }
  if (typeof prototype.componentWillReceiveProps === 'function') {
    foundWillReceivePropsName = 'componentWillReceiveProps';
  } else if (typeof prototype.UNSAFE_componentWillReceiveProps === 'function') {
    foundWillReceivePropsName = 'UNSAFE_componentWillReceiveProps';
  }
  if (typeof prototype.componentWillUpdate === 'function') {
    foundWillUpdateName = 'componentWillUpdate';
  } else if (typeof prototype.UNSAFE_componentWillUpdate === 'function') {
    foundWillUpdateName = 'UNSAFE_componentWillUpdate';
  }
  if (
    foundWillMountName !== null ||
    foundWillReceivePropsName !== null ||
    foundWillUpdateName !== null
  ) {
    var componentName = Component.displayName || Component.name;
    var newApiName =
      typeof Component.getDerivedStateFromProps === 'function'
        ? 'getDerivedStateFromProps()'
        : 'getSnapshotBeforeUpdate()';

    throw Error(
      'Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n' +
        componentName +
        ' uses ' +
        newApiName +
        ' but also contains the following legacy lifecycles:' +
        (foundWillMountName !== null ? '\n  ' + foundWillMountName : '') +
        (foundWillReceivePropsName !== null
          ? '\n  ' + foundWillReceivePropsName
          : '') +
        (foundWillUpdateName !== null ? '\n  ' + foundWillUpdateName : '') +
        '\n\nThe above lifecycles should be removed. Learn more about this warning here:\n' +
        'https://fb.me/react-async-component-lifecycle-hooks'
    );
  }

  // React <= 16.2 does not support static getDerivedStateFromProps.
  // As a workaround, use cWM and cWRP to invoke the new static lifecycle.
  // Newer versions of React will ignore these lifecycles if gDSFP exists.
  if (typeof Component.getDerivedStateFromProps === 'function') {
    prototype.componentWillMount = componentWillMount;
    prototype.componentWillReceiveProps = componentWillReceiveProps;
  }

  // React <= 16.2 does not support getSnapshotBeforeUpdate.
  // As a workaround, use cWU to invoke the new lifecycle.
  // Newer versions of React will ignore that lifecycle if gSBU exists.
  if (typeof prototype.getSnapshotBeforeUpdate === 'function') {
    if (typeof prototype.componentDidUpdate !== 'function') {
      throw new Error(
        'Cannot polyfill getSnapshotBeforeUpdate() for components that do not define componentDidUpdate() on the prototype'
      );
    }

    prototype.componentWillUpdate = componentWillUpdate;

    var componentDidUpdate = prototype.componentDidUpdate;

    prototype.componentDidUpdate = function componentDidUpdatePolyfill(
      prevProps,
      prevState,
      maybeSnapshot
    ) {
      // 16.3+ will not execute our will-update method;
      // It will pass a snapshot value to did-update though.
      // Older versions will require our polyfilled will-update value.
      // We need to handle both cases, but can't just check for the presence of "maybeSnapshot",
      // Because for <= 15.x versions this might be a "prevContext" object.
      // We also can't just check "__reactInternalSnapshot",
      // Because get-snapshot might return a falsy value.
      // So check for the explicit __reactInternalSnapshotFlag flag to determine behavior.
      var snapshot = this.__reactInternalSnapshotFlag
        ? this.__reactInternalSnapshot
        : maybeSnapshot;

      componentDidUpdate.call(this, prevProps, prevState, snapshot);
    };
  }

  return Component;
}




/***/ }),
/* 245 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.classNamesShape = exports.timeoutsShape = undefined;
exports.transitionTimeout = transitionTimeout;

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function transitionTimeout(transitionType) {
  var timeoutPropName = 'transition' + transitionType + 'Timeout';
  var enabledPropName = 'transition' + transitionType;

  return function (props) {
    // If the transition is enabled
    if (props[enabledPropName]) {
      // If no timeout duration is provided
      if (props[timeoutPropName] == null) {
        return new Error(timeoutPropName + ' wasn\'t supplied to CSSTransitionGroup: ' + 'this can cause unreliable animations and won\'t be supported in ' + 'a future version of React. See ' + 'https://fb.me/react-animation-transition-group-timeout for more ' + 'information.');

        // If the duration isn't a number
      } else if (typeof props[timeoutPropName] !== 'number') {
        return new Error(timeoutPropName + ' must be a number (in milliseconds)');
      }
    }

    return null;
  };
}

var timeoutsShape = exports.timeoutsShape = _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.shape({
  enter: _propTypes2.default.number,
  exit: _propTypes2.default.number
}).isRequired]);

var classNamesShape = exports.classNamesShape = _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.shape({
  enter: _propTypes2.default.string,
  exit: _propTypes2.default.string,
  active: _propTypes2.default.string
}), _propTypes2.default.shape({
  enter: _propTypes2.default.string,
  enterDone: _propTypes2.default.string,
  enterActive: _propTypes2.default.string,
  exit: _propTypes2.default.string,
  exitDone: _propTypes2.default.string,
  exitActive: _propTypes2.default.string
})]);

/***/ }),
/* 246 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(2);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _SnackbarContent.default;
  }
});

var _SnackbarContent = _interopRequireDefault(__webpack_require__(508));

/***/ }),
/* 247 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DISMISS_ALERT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SHOW_ALERT; });
var DISMISS_ALERT='ALERT::DISMISS_ALERT';var SHOW_ALERT='ALERT::SHOW_ALERT';

/***/ }),
/* 248 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return makeStandardActionCreator; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return makeApiActionCreator; });
// import axios from 'axios';
// import { DANGER } from 'reducers/alert/constants';
// import { errorMessageStringFromResponse } from 'components/alert/error-message-string-from-response';
// import { showAlert } from 'reducers/alert/actions';
// Inspired by https://github.com/acdlite/flux-standard-action and
// https://redux-actions.js.org/docs/api/createAction.html
// Returns an action creator that stores the first argument (probably an object, so you can store multiple key-values
// and destructure) as the action.payload. And the second argument as action.meta; meta can be useful to provide the
// reducer with request parameters that aren't included in a payload returned by the server, for example.
var makeStandardActionCreator=function makeStandardActionCreator(ACTION_TYPE){return function(payload/*, meta*/){return{// meta,
payload:payload,type:ACTION_TYPE};};};// To make action creators that make an API call and dispatch an action creator on success with the response.
// Doesn't handle dispatching for errors.
var makeApiActionCreator=function makeApiActionCreator(apiCall,successActionCreator){return function(args){return function(dispatch){return apiCall(args).then(function(_ref){var data=_ref.data;dispatch(successActionCreator(data,args));});};};};// To make action creators that make an API call and dispatch an action creator on success with the response.
// And show an error alert on failure. Re-throwing the error so others in the promise chain can respond to.
// IDEA: Avaliar necessidade.
// export const makeApiActionCreatorWithAlertOnError = (apiCall, successActionCreator) => {
//   return args => dispatch => {
//     return apiCall(args)
//       .then(({ data }) => {
//         dispatch(successActionCreator(data, args));
//       })
//       .catch((error) => {
//         dispatch(showAlert({ type: DANGER, message: errorMessageStringFromResponse(error.response) }));
//         throw error;
//       });
//   };
// };
// Our API has paging built-in by default, returning a `next` URL in the results
// as long as there are more results to get. So this helper makes it easy to write
// action creators that make repeated API requests until all resources at the
// endpoint have been fetched, dispatching an action for each page of data as it
// comes in (so that the UI can update incrementally).
//
// Example usage:
//   // successActionCreator
//   export const SUBJECTS_FETCHED = 'SUBJECTS::SUBJECTS_FETCHED';
//
//   export const subjectsFetched = (payload, meta) => {
//     return {
//       meta,
//       payload,
//       type: SUBJECTS_FETCHED,
//     };
//   };
//
//   // apiCall
//   const fetchSubjects = queryParams => (
//     axios.get(<URL with queryParams>)
//   );
//
//   // async action creator
//   export const fetchSubjects = makePaginatedApiActionCreator(
//     api.fetchSubjects,
//     subjectsFetched,
//   );
// IDEA: Avaliar necessidade.
// export const makePaginatedApiActionCreator = (apiCall, successActionCreator, requestActionCreator) => {
//   return args => (dispatch) => {
//     const dispatchResultsAndFetchNextIfPresent = ({ data }) => {
//       dispatch(successActionCreator(data.results, args));
//       if (data.next !== null) {
//         return axios.get(data.next).then(dispatchResultsAndFetchNextIfPresent);
//       } else {
//         Promise.resolve({ data });
//       }
//     };
//
//     if (requestActionCreator) {
//       dispatch(requestActionCreator(undefined, args));
//     }
//     return apiCall(args).then(dispatchResultsAndFetchNextIfPresent);
//   };
// };

/***/ }),
/* 249 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(2);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Grid.default;
  }
});

var _Grid = _interopRequireDefault(__webpack_require__(520));

/***/ }),
/* 250 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function bind(fn, thisArg) {
  return function wrap() {
    var args = new Array(arguments.length);
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }
    return fn.apply(thisArg, args);
  };
};


/***/ }),
/* 251 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 252 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(40);
var settle = __webpack_require__(526);
var buildURL = __webpack_require__(528);
var parseHeaders = __webpack_require__(529);
var isURLSameOrigin = __webpack_require__(530);
var createError = __webpack_require__(253);
var btoa = (typeof window !== 'undefined' && window.btoa && window.btoa.bind(window)) || __webpack_require__(531);

module.exports = function xhrAdapter(config) {
  return new Promise(function dispatchXhrRequest(resolve, reject) {
    var requestData = config.data;
    var requestHeaders = config.headers;

    if (utils.isFormData(requestData)) {
      delete requestHeaders['Content-Type']; // Let the browser set it
    }

    var request = new XMLHttpRequest();
    var loadEvent = 'onreadystatechange';
    var xDomain = false;

    // For IE 8/9 CORS support
    // Only supports POST and GET calls and doesn't returns the response headers.
    // DON'T do this for testing b/c XMLHttpRequest is mocked, not XDomainRequest.
    if ("production" !== 'test' &&
        typeof window !== 'undefined' &&
        window.XDomainRequest && !('withCredentials' in request) &&
        !isURLSameOrigin(config.url)) {
      request = new window.XDomainRequest();
      loadEvent = 'onload';
      xDomain = true;
      request.onprogress = function handleProgress() {};
      request.ontimeout = function handleTimeout() {};
    }

    // HTTP basic authentication
    if (config.auth) {
      var username = config.auth.username || '';
      var password = config.auth.password || '';
      requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
    }

    request.open(config.method.toUpperCase(), buildURL(config.url, config.params, config.paramsSerializer), true);

    // Set the request timeout in MS
    request.timeout = config.timeout;

    // Listen for ready state
    request[loadEvent] = function handleLoad() {
      if (!request || (request.readyState !== 4 && !xDomain)) {
        return;
      }

      // The request errored out and we didn't get a response, this will be
      // handled by onerror instead
      // With one exception: request that using file: protocol, most browsers
      // will return status as 0 even though it's a successful request
      if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
        return;
      }

      // Prepare the response
      var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
      var responseData = !config.responseType || config.responseType === 'text' ? request.responseText : request.response;
      var response = {
        data: responseData,
        // IE sends 1223 instead of 204 (https://github.com/axios/axios/issues/201)
        status: request.status === 1223 ? 204 : request.status,
        statusText: request.status === 1223 ? 'No Content' : request.statusText,
        headers: responseHeaders,
        config: config,
        request: request
      };

      settle(resolve, reject, response);

      // Clean up request
      request = null;
    };

    // Handle low level network errors
    request.onerror = function handleError() {
      // Real errors are hidden from us by the browser
      // onerror should only fire if it's a network error
      reject(createError('Network Error', config, null, request));

      // Clean up request
      request = null;
    };

    // Handle timeout
    request.ontimeout = function handleTimeout() {
      reject(createError('timeout of ' + config.timeout + 'ms exceeded', config, 'ECONNABORTED',
        request));

      // Clean up request
      request = null;
    };

    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if (utils.isStandardBrowserEnv()) {
      var cookies = __webpack_require__(532);

      // Add xsrf header
      var xsrfValue = (config.withCredentials || isURLSameOrigin(config.url)) && config.xsrfCookieName ?
          cookies.read(config.xsrfCookieName) :
          undefined;

      if (xsrfValue) {
        requestHeaders[config.xsrfHeaderName] = xsrfValue;
      }
    }

    // Add headers to the request
    if ('setRequestHeader' in request) {
      utils.forEach(requestHeaders, function setRequestHeader(val, key) {
        if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
          // Remove Content-Type if data is undefined
          delete requestHeaders[key];
        } else {
          // Otherwise add header to the request
          request.setRequestHeader(key, val);
        }
      });
    }

    // Add withCredentials to request if needed
    if (config.withCredentials) {
      request.withCredentials = true;
    }

    // Add responseType to request if needed
    if (config.responseType) {
      try {
        request.responseType = config.responseType;
      } catch (e) {
        // Expected DOMException thrown by browsers not compatible XMLHttpRequest Level 2.
        // But, this can be suppressed for 'json' type as it can be parsed by default 'transformResponse' function.
        if (config.responseType !== 'json') {
          throw e;
        }
      }
    }

    // Handle progress if needed
    if (typeof config.onDownloadProgress === 'function') {
      request.addEventListener('progress', config.onDownloadProgress);
    }

    // Not all browsers support upload events
    if (typeof config.onUploadProgress === 'function' && request.upload) {
      request.upload.addEventListener('progress', config.onUploadProgress);
    }

    if (config.cancelToken) {
      // Handle cancellation
      config.cancelToken.promise.then(function onCanceled(cancel) {
        if (!request) {
          return;
        }

        request.abort();
        reject(cancel);
        // Clean up request
        request = null;
      });
    }

    if (requestData === undefined) {
      requestData = null;
    }

    // Send the request
    request.send(requestData);
  });
};


/***/ }),
/* 253 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var enhanceError = __webpack_require__(527);

/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The created error.
 */
module.exports = function createError(message, config, code, request, response) {
  var error = new Error(message);
  return enhanceError(error, config, code, request, response);
};


/***/ }),
/* 254 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function isCancel(value) {
  return !!(value && value.__CANCEL__);
};


/***/ }),
/* 255 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * A `Cancel` is an object that is thrown when an operation is canceled.
 *
 * @class
 * @param {string=} message The message.
 */
function Cancel(message) {
  this.message = message;
}

Cancel.prototype.toString = function toString() {
  return 'Cancel' + (this.message ? ': ' + this.message : '');
};

Cancel.prototype.__CANCEL__ = true;

module.exports = Cancel;


/***/ }),
/* 256 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 257 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__ = __webpack_require__(21);
function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}// ##############################
// // // App styles
// #############################
var appStyle=function appStyle(theme){var _Object$assign;return{wrapper:{position:"relative",top:"0",height:"100vh","&:after":{display:"table",clear:"both",content:'" "'}},mainPanel:Object.assign((_Object$assign={transitionProperty:"top, bottom, width",transitionDuration:".2s, .2s, .35s",transitionTimingFunction:"linear, linear, ease"},_defineProperty(_Object$assign,theme.breakpoints.up("md"),{width:"calc(100% - "+__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["k" /* drawerWidth */]+"px)"}),_defineProperty(_Object$assign,"overflow","auto"),_defineProperty(_Object$assign,"position","relative"),_defineProperty(_Object$assign,"float","right"),_Object$assign),__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["y" /* transition */],{maxHeight:"100%",width:"100%",overflowScrolling:"touch"}),content:{marginTop:"70px",padding:"30px 15px",minHeight:"calc(100vh - 123px)"},container:Object.assign({},__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["d" /* containerFluid */]),map:{marginTop:"70px"},mainPanelSidebarMini:_defineProperty({},theme.breakpoints.up("md"),{width:"calc(100% - "+__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["j" /* drawerMiniWidth */]+"px)"}),mainPanelWithPerfectScrollbar:{overflow:"hidden !important"}};};/* harmony default export */ __webpack_exports__["a"] = (appStyle);

/***/ }),
/* 258 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return internalRoutes; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__material_ui_icons_Dashboard__ = __webpack_require__(259);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__material_ui_icons_Dashboard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__material_ui_icons_Dashboard__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__material_ui_icons_FilterList__ = __webpack_require__(542);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__material_ui_icons_FilterList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__material_ui_icons_FilterList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_views_Assinatura_Assinatura_jsx__ = __webpack_require__(543);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_views_Dashboard_BuscaCativo_jsx__ = __webpack_require__(590);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_views_Dashboard_Dashboard_jsx__ = __webpack_require__(190);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_views_Dashboard_Relatorio_jsx__ = __webpack_require__(934);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_views_Pages_SimuladoresPage_jsx__ = __webpack_require__(355);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_views_User_UserProfile_jsx__ = __webpack_require__(945);
var dashRoutes=[{path:"/dashboard",name:"Dashboard",icon:__WEBPACK_IMPORTED_MODULE_0__material_ui_icons_Dashboard___default.a,component:__WEBPACK_IMPORTED_MODULE_4_views_Dashboard_Dashboard_jsx__["a" /* default */]},{path:"/dashboard/relatorios",name:"Relatórios",icon:__WEBPACK_IMPORTED_MODULE_1__material_ui_icons_FilterList___default.a,component:__WEBPACK_IMPORTED_MODULE_5_views_Dashboard_Relatorio_jsx__["a" /* default */]},{path:"/dashboard/busca-cativo",name:"Busca Cativo",icon:__WEBPACK_IMPORTED_MODULE_1__material_ui_icons_FilterList___default.a,component:__WEBPACK_IMPORTED_MODULE_3_views_Dashboard_BuscaCativo_jsx__["a" /* default */]},{path:"/dashboard/simulador-cativo-livre",name:"Simulador Cativo",icon:__WEBPACK_IMPORTED_MODULE_0__material_ui_icons_Dashboard___default.a,component:__WEBPACK_IMPORTED_MODULE_6_views_Pages_SimuladoresPage_jsx__["a" /* default */]}];var internalRoutes=[{path:"/dashboard/perfil",name:"Meu Perfil",mini:"MP",component:__WEBPACK_IMPORTED_MODULE_7_views_User_UserProfile_jsx__["a" /* default */]},{path:"/dashboard/assinatura",name:"Assinatura",mini:"AS",component:__WEBPACK_IMPORTED_MODULE_2_views_Assinatura_Assinatura_jsx__["a" /* default */]}];/* harmony default export */ __webpack_exports__["a"] = (dashRoutes);

/***/ }),
/* 259 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(9);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(10));

var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
  fill: "none",
  d: "M0 0h24v24H0z"
}), _react.default.createElement("path", {
  d: "M3 13h8V3H3v10zm0 8h8v-6H3v6zm10 0h8V11h-8v10zm0-18v6h8V3h-8z"
})), 'Dashboard');

exports.default = _default;

/***/ }),
/* 260 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(9);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(10));

var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
  fill: "none",
  d: "M0 0h24v24H0z"
}), _react.default.createElement("path", {
  d: "M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"
})), 'Check');

exports.default = _default;

/***/ }),
/* 261 */
/***/ (function(module, exports) {

function _typeof2(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof2 = function _typeof2(obj) { return typeof obj; }; } else { _typeof2 = function _typeof2(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof2(obj); }

function _typeof(obj) {
  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
    module.exports = _typeof = function _typeof(obj) {
      return _typeof2(obj);
    };
  } else {
    module.exports = _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : _typeof2(obj);
    };
  }

  return _typeof(obj);
}

module.exports = _typeof;

/***/ }),
/* 262 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(2);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _FormHelperText.default;
  }
});

var _FormHelperText = _interopRequireDefault(__webpack_require__(568));

/***/ }),
/* 263 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(2);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _RootRef.default;
  }
});

var _RootRef = _interopRequireDefault(__webpack_require__(583));

/***/ }),
/* 264 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(2);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Popper.default;
  }
});

var _Popper = _interopRequireDefault(__webpack_require__(585));

/***/ }),
/* 265 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(2);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Portal.default;
  }
});

var _Portal = _interopRequireDefault(__webpack_require__(587));

/***/ }),
/* 266 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return addUserAssinatura; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return fetchAssinatura; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return updateUserAssinatura; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return removeUserAssinatura; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_services_routes__ = __webpack_require__(53);
var addUserAssinatura=function addUserAssinatura(params){return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_1_services_routes__["a" /* default */].assinatura.addUser(),params);};var fetchAssinatura=function fetchAssinatura(){return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_1_services_routes__["a" /* default */].assinatura.fetch());};var updateUserAssinatura=function updateUserAssinatura(params){return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.patch(__WEBPACK_IMPORTED_MODULE_1_services_routes__["a" /* default */].assinatura.updateAdmin(),params);};var removeUserAssinatura=function removeUserAssinatura(userId){return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.delete(__WEBPACK_IMPORTED_MODULE_1_services_routes__["a" /* default */].assinatura.removeUser(userId));};

/***/ }),
/* 267 */
/***/ (function(module, exports) {

module.exports = function(data, filename, mime, bom) {
    var blobData = (typeof bom !== 'undefined') ? [bom, data] : [data]
    var blob = new Blob(blobData, {type: mime || 'application/octet-stream'});
    if (typeof window.navigator.msSaveBlob !== 'undefined') {
        // IE workaround for "HTML7007: One or more blob URLs were
        // revoked by closing the blob for which they were created.
        // These URLs will no longer resolve as the data backing
        // the URL has been freed."
        window.navigator.msSaveBlob(blob, filename);
    }
    else {
        var blobURL = (window.URL && window.URL.createObjectURL) ? window.URL.createObjectURL(blob) : window.webkitURL.createObjectURL(blob);
        var tempLink = document.createElement('a');
        tempLink.style.display = 'none';
        tempLink.href = blobURL;
        tempLink.setAttribute('download', filename);

        // Safari thinks _blank anchor are pop ups. We only want to set _blank
        // target if the browser does not support the HTML5 download attribute.
        // This allows you to download files in desktop safari if pop up blocking
        // is enabled.
        if (typeof tempLink.download === 'undefined') {
            tempLink.setAttribute('target', '_blank');
        }

        document.body.appendChild(tempLink);
        tempLink.click();

        // Fixes "webkit blob resource error 1"
        setTimeout(function() {
            document.body.removeChild(tempLink);
            window.URL.revokeObjectURL(blobURL);
        }, 200)
    }
}


/***/ }),
/* 268 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var now = __webpack_require__(597)
  , root = typeof window === 'undefined' ? global : window
  , vendors = ['moz', 'webkit']
  , suffix = 'AnimationFrame'
  , raf = root['request' + suffix]
  , caf = root['cancel' + suffix] || root['cancelRequest' + suffix]

for(var i = 0; !raf && i < vendors.length; i++) {
  raf = root[vendors[i] + 'Request' + suffix]
  caf = root[vendors[i] + 'Cancel' + suffix]
      || root[vendors[i] + 'CancelRequest' + suffix]
}

// Some versions of FF have rAF but not cAF
if(!raf || !caf) {
  var last = 0
    , id = 0
    , queue = []
    , frameDuration = 1000 / 60

  raf = function(callback) {
    if(queue.length === 0) {
      var _now = now()
        , next = Math.max(0, frameDuration - (_now - last))
      last = next + _now
      setTimeout(function() {
        var cp = queue.slice(0)
        // Clear queue here to prevent
        // callbacks from appending listeners
        // to the current frame's queue
        queue.length = 0
        for(var i = 0; i < cp.length; i++) {
          if(!cp[i].cancelled) {
            try{
              cp[i].callback(last)
            } catch(e) {
              setTimeout(function() { throw e }, 0)
            }
          }
        }
      }, Math.round(next))
    }
    queue.push({
      handle: ++id,
      callback: callback,
      cancelled: false
    })
    return id
  }

  caf = function(handle) {
    for(var i = 0; i < queue.length; i++) {
      if(queue[i].handle === handle) {
        queue[i].cancelled = true
      }
    }
  }
}

module.exports = function(fn) {
  // Wrap in a new function to prevent
  // `cancel` potentially being assigned
  // to the native rAF function
  return raf.call(root, fn)
}
module.exports.cancel = function() {
  caf.apply(root, arguments)
}
module.exports.polyfill = function(object) {
  if (!object) {
    object = root;
  }
  object.requestAnimationFrame = raf
  object.cancelAnimationFrame = caf
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(36)))

/***/ }),
/* 269 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var sizerStyle = {
	position: 'absolute',
	top: 0,
	left: 0,
	visibility: 'hidden',
	height: 0,
	overflow: 'scroll',
	whiteSpace: 'pre'
};

var INPUT_PROPS_BLACKLIST = ['extraWidth', 'injectStyles', 'inputClassName', 'inputRef', 'inputStyle', 'minWidth', 'onAutosize', 'placeholderIsMinWidth'];

var cleanInputProps = function cleanInputProps(inputProps) {
	INPUT_PROPS_BLACKLIST.forEach(function (field) {
		return delete inputProps[field];
	});
	return inputProps;
};

var copyStyles = function copyStyles(styles, node) {
	node.style.fontSize = styles.fontSize;
	node.style.fontFamily = styles.fontFamily;
	node.style.fontWeight = styles.fontWeight;
	node.style.fontStyle = styles.fontStyle;
	node.style.letterSpacing = styles.letterSpacing;
	node.style.textTransform = styles.textTransform;
};

var isIE = typeof window !== 'undefined' && window.navigator ? /MSIE |Trident\/|Edge\//.test(window.navigator.userAgent) : false;

var generateId = function generateId() {
	// we only need an auto-generated ID for stylesheet injection, which is only
	// used for IE. so if the browser is not IE, this should return undefined.
	return isIE ? '_' + Math.random().toString(36).substr(2, 12) : undefined;
};

var AutosizeInput = function (_Component) {
	_inherits(AutosizeInput, _Component);

	function AutosizeInput(props) {
		_classCallCheck(this, AutosizeInput);

		var _this = _possibleConstructorReturn(this, (AutosizeInput.__proto__ || Object.getPrototypeOf(AutosizeInput)).call(this, props));

		_this.inputRef = function (el) {
			_this.input = el;
			if (typeof _this.props.inputRef === 'function') {
				_this.props.inputRef(el);
			}
		};

		_this.placeHolderSizerRef = function (el) {
			_this.placeHolderSizer = el;
		};

		_this.sizerRef = function (el) {
			_this.sizer = el;
		};

		_this.state = {
			inputWidth: props.minWidth,
			inputId: props.id || generateId()
		};
		return _this;
	}

	_createClass(AutosizeInput, [{
		key: 'componentDidMount',
		value: function componentDidMount() {
			this.mounted = true;
			this.copyInputStyles();
			this.updateInputWidth();
		}
	}, {
		key: 'componentWillReceiveProps',
		value: function componentWillReceiveProps(nextProps) {
			var id = nextProps.id;

			if (id !== this.props.id) {
				this.setState({ inputId: id || generateId() });
			}
		}
	}, {
		key: 'componentDidUpdate',
		value: function componentDidUpdate(prevProps, prevState) {
			if (prevState.inputWidth !== this.state.inputWidth) {
				if (typeof this.props.onAutosize === 'function') {
					this.props.onAutosize(this.state.inputWidth);
				}
			}
			this.updateInputWidth();
		}
	}, {
		key: 'componentWillUnmount',
		value: function componentWillUnmount() {
			this.mounted = false;
		}
	}, {
		key: 'copyInputStyles',
		value: function copyInputStyles() {
			if (!this.mounted || !window.getComputedStyle) {
				return;
			}
			var inputStyles = this.input && window.getComputedStyle(this.input);
			if (!inputStyles) {
				return;
			}
			copyStyles(inputStyles, this.sizer);
			if (this.placeHolderSizer) {
				copyStyles(inputStyles, this.placeHolderSizer);
			}
		}
	}, {
		key: 'updateInputWidth',
		value: function updateInputWidth() {
			if (!this.mounted || !this.sizer || typeof this.sizer.scrollWidth === 'undefined') {
				return;
			}
			var newInputWidth = void 0;
			if (this.props.placeholder && (!this.props.value || this.props.value && this.props.placeholderIsMinWidth)) {
				newInputWidth = Math.max(this.sizer.scrollWidth, this.placeHolderSizer.scrollWidth) + 2;
			} else {
				newInputWidth = this.sizer.scrollWidth + 2;
			}
			// add extraWidth to the detected width. for number types, this defaults to 16 to allow for the stepper UI
			var extraWidth = this.props.type === 'number' && this.props.extraWidth === undefined ? 16 : parseInt(this.props.extraWidth) || 0;
			newInputWidth += extraWidth;
			if (newInputWidth < this.props.minWidth) {
				newInputWidth = this.props.minWidth;
			}
			if (newInputWidth !== this.state.inputWidth) {
				this.setState({
					inputWidth: newInputWidth
				});
			}
		}
	}, {
		key: 'getInput',
		value: function getInput() {
			return this.input;
		}
	}, {
		key: 'focus',
		value: function focus() {
			this.input.focus();
		}
	}, {
		key: 'blur',
		value: function blur() {
			this.input.blur();
		}
	}, {
		key: 'select',
		value: function select() {
			this.input.select();
		}
	}, {
		key: 'renderStyles',
		value: function renderStyles() {
			// this method injects styles to hide IE's clear indicator, which messes
			// with input size detection. the stylesheet is only injected when the
			// browser is IE, and can also be disabled by the `injectStyles` prop.
			var injectStyles = this.props.injectStyles;

			return isIE && injectStyles ? _react2.default.createElement('style', { dangerouslySetInnerHTML: {
					__html: 'input#' + this.state.inputId + '::-ms-clear {display: none;}'
				} }) : null;
		}
	}, {
		key: 'render',
		value: function render() {
			var sizerValue = [this.props.defaultValue, this.props.value, ''].reduce(function (previousValue, currentValue) {
				if (previousValue !== null && previousValue !== undefined) {
					return previousValue;
				}
				return currentValue;
			});

			var wrapperStyle = _extends({}, this.props.style);
			if (!wrapperStyle.display) wrapperStyle.display = 'inline-block';

			var inputStyle = _extends({
				boxSizing: 'content-box',
				width: this.state.inputWidth + 'px'
			}, this.props.inputStyle);

			var inputProps = _objectWithoutProperties(this.props, []);

			cleanInputProps(inputProps);
			inputProps.className = this.props.inputClassName;
			inputProps.id = this.state.inputId;
			inputProps.style = inputStyle;

			return _react2.default.createElement(
				'div',
				{ className: this.props.className, style: wrapperStyle },
				this.renderStyles(),
				_react2.default.createElement('input', _extends({}, inputProps, { ref: this.inputRef })),
				_react2.default.createElement(
					'div',
					{ ref: this.sizerRef, style: sizerStyle },
					sizerValue
				),
				this.props.placeholder ? _react2.default.createElement(
					'div',
					{ ref: this.placeHolderSizerRef, style: sizerStyle },
					this.props.placeholder
				) : null
			);
		}
	}]);

	return AutosizeInput;
}(_react.Component);

AutosizeInput.propTypes = {
	className: _propTypes2.default.string, // className for the outer element
	defaultValue: _propTypes2.default.any, // default field value
	extraWidth: _propTypes2.default.oneOfType([// additional width for input element
	_propTypes2.default.number, _propTypes2.default.string]),
	id: _propTypes2.default.string, // id to use for the input, can be set for consistent snapshots
	injectStyles: _propTypes2.default.bool, // inject the custom stylesheet to hide clear UI, defaults to true
	inputClassName: _propTypes2.default.string, // className for the input element
	inputRef: _propTypes2.default.func, // ref callback for the input element
	inputStyle: _propTypes2.default.object, // css styles for the input element
	minWidth: _propTypes2.default.oneOfType([// minimum width for input element
	_propTypes2.default.number, _propTypes2.default.string]),
	onAutosize: _propTypes2.default.func, // onAutosize handler: function(newWidth) {}
	onChange: _propTypes2.default.func, // onChange handler: function(event) {}
	placeholder: _propTypes2.default.string, // placeholder text
	placeholderIsMinWidth: _propTypes2.default.bool, // don't collapse size to less than the placeholder
	style: _propTypes2.default.object, // css styles for the outer element
	value: _propTypes2.default.any // field value
};
AutosizeInput.defaultProps = {
	minWidth: 1,
	injectStyles: true
};

exports.default = AutosizeInput;

/***/ }),
/* 270 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IndicatorsContainer = exports.indicatorsContainerCSS = exports.ValueContainer = exports.valueContainerCSS = exports.SelectContainer = exports.containerCSS = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _emotion = __webpack_require__(41);

var _theme = __webpack_require__(45);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// ==============================
// Root Container
// ==============================

var containerCSS = exports.containerCSS = function containerCSS(_ref) {
  var isDisabled = _ref.isDisabled,
      isRtl = _ref.isRtl;
  return {
    direction: isRtl ? 'rtl' : null,
    pointerEvents: isDisabled ? 'none' : null, // cancel mouse events when disabled
    position: 'relative'
  };
};
var SelectContainer = exports.SelectContainer = function SelectContainer(props) {
  var children = props.children,
      className = props.className,
      cx = props.cx,
      getStyles = props.getStyles,
      innerProps = props.innerProps,
      isDisabled = props.isDisabled,
      isRtl = props.isRtl;

  return _react2.default.createElement(
    'div',
    _extends({
      className: cx( /*#__PURE__*/(0, _emotion.css)(getStyles('container', props)), {
        '--is-disabled': isDisabled,
        '--is-rtl': isRtl
      }, className)
    }, innerProps),
    children
  );
};

// ==============================
// Value Container
// ==============================

var valueContainerCSS = exports.valueContainerCSS = function valueContainerCSS() {
  return {
    alignItems: 'center',
    display: 'flex',
    flex: 1,
    flexWrap: 'wrap',
    padding: _theme.spacing.baseUnit / 2 + 'px ' + _theme.spacing.baseUnit * 2 + 'px',
    WebkitOverflowScrolling: 'touch',
    position: 'relative'
  };
};

var ValueContainer = exports.ValueContainer = function (_Component) {
  _inherits(ValueContainer, _Component);

  function ValueContainer() {
    _classCallCheck(this, ValueContainer);

    return _possibleConstructorReturn(this, (ValueContainer.__proto__ || Object.getPrototypeOf(ValueContainer)).apply(this, arguments));
  }

  _createClass(ValueContainer, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          children = _props.children,
          className = _props.className,
          cx = _props.cx,
          isMulti = _props.isMulti,
          getStyles = _props.getStyles,
          hasValue = _props.hasValue;


      return _react2.default.createElement(
        'div',
        {
          className: cx( /*#__PURE__*/(0, _emotion.css)(getStyles('valueContainer', this.props)), {
            'value-container': true,
            'value-container--is-multi': isMulti,
            'value-container--has-value': hasValue
          }, className)
        },
        children
      );
    }
  }]);

  return ValueContainer;
}(_react.Component);

// ==============================
// Indicator Container
// ==============================

var indicatorsContainerCSS = exports.indicatorsContainerCSS = function indicatorsContainerCSS() {
  return {
    alignItems: 'center',
    alignSelf: 'stretch',
    display: 'flex',
    flexShrink: 0
  };
};
var IndicatorsContainer = exports.IndicatorsContainer = function IndicatorsContainer(props) {
  var children = props.children,
      className = props.className,
      cx = props.cx,
      getStyles = props.getStyles;


  return _react2.default.createElement(
    'div',
    {
      className: cx( /*#__PURE__*/(0, _emotion.css)(getStyles('indicatorsContainer', props)), {
        'indicators': true
      }, className)
    },
    children
  );
};

/***/ }),
/* 271 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LoadingIndicator = exports.loadingIndicatorCSS = exports.IndicatorSeparator = exports.indicatorSeparatorCSS = exports.ClearIndicator = exports.clearIndicatorCSS = exports.DropdownIndicator = exports.dropdownIndicatorCSS = exports.DownChevron = exports.CrossIcon = undefined;

var _emotion = __webpack_require__(41);

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _theme = __webpack_require__(45);

__webpack_require__(272);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

// ==============================
// Dropdown & Clear Icons
// ==============================

var Svg = function Svg(_ref) {
  var size = _ref.size,
      props = _objectWithoutProperties(_ref, ['size']);

  return _react2.default.createElement('svg', _extends({
    height: size,
    width: size,
    viewBox: '0 0 20 20',
    'aria-hidden': 'true',
    focusable: 'false',
    className: /*#__PURE__*/ /*#__PURE__*/(0, _emotion.css)({
      display: 'inline-block',
      fill: 'currentColor',
      lineHeight: 1,
      stroke: 'currentColor',
      strokeWidth: 0
    })
  }, props));
};

var CrossIcon = exports.CrossIcon = function CrossIcon(props) {
  return _react2.default.createElement(
    Svg,
    _extends({ size: 20 }, props),
    _react2.default.createElement('path', { d: 'M14.348 14.849c-0.469 0.469-1.229 0.469-1.697 0l-2.651-3.030-2.651 3.029c-0.469 0.469-1.229 0.469-1.697 0-0.469-0.469-0.469-1.229 0-1.697l2.758-3.15-2.759-3.152c-0.469-0.469-0.469-1.228 0-1.697s1.228-0.469 1.697 0l2.652 3.031 2.651-3.031c0.469-0.469 1.228-0.469 1.697 0s0.469 1.229 0 1.697l-2.758 3.152 2.758 3.15c0.469 0.469 0.469 1.229 0 1.698z' })
  );
};
var DownChevron = exports.DownChevron = function DownChevron(props) {
  return _react2.default.createElement(
    Svg,
    _extends({ size: 20 }, props),
    _react2.default.createElement('path', { d: 'M4.516 7.548c0.436-0.446 1.043-0.481 1.576 0l3.908 3.747 3.908-3.747c0.533-0.481 1.141-0.446 1.574 0 0.436 0.445 0.408 1.197 0 1.615-0.406 0.418-4.695 4.502-4.695 4.502-0.217 0.223-0.502 0.335-0.787 0.335s-0.57-0.112-0.789-0.335c0 0-4.287-4.084-4.695-4.502s-0.436-1.17 0-1.615z' })
  );
};

// ==============================
// Dropdown & Clear Buttons
// ==============================

var baseCSS = function baseCSS(_ref2) {
  var isFocused = _ref2.isFocused;
  return {
    color: isFocused ? _theme.colors.neutral60 : _theme.colors.neutral20,
    display: 'flex',
    padding: _theme.spacing.baseUnit * 2,
    transition: 'color 150ms',

    ':hover': {
      color: isFocused ? _theme.colors.neutral100 : _theme.colors.neutral40
    }
  };
};

var dropdownIndicatorCSS = exports.dropdownIndicatorCSS = baseCSS;
var DropdownIndicator = exports.DropdownIndicator = function DropdownIndicator(props) {
  var _props$children = props.children,
      children = _props$children === undefined ? _react2.default.createElement(DownChevron, null) : _props$children,
      className = props.className,
      cx = props.cx,
      getStyles = props.getStyles,
      innerProps = props.innerProps;

  return _react2.default.createElement(
    'div',
    _extends({}, innerProps, {
      className: cx( /*#__PURE__*/(0, _emotion.css)(getStyles('dropdownIndicator', props)), {
        'indicator': true,
        'dropdown-indicator': true
      }, className)
    }),
    children
  );
};

var clearIndicatorCSS = exports.clearIndicatorCSS = baseCSS;
var ClearIndicator = exports.ClearIndicator = function ClearIndicator(props) {
  var _props$children2 = props.children,
      children = _props$children2 === undefined ? _react2.default.createElement(CrossIcon, null) : _props$children2,
      className = props.className,
      cx = props.cx,
      getStyles = props.getStyles,
      innerProps = props.innerProps;

  return _react2.default.createElement(
    'div',
    _extends({}, innerProps, {
      className: cx( /*#__PURE__*/(0, _emotion.css)(getStyles('clearIndicator', props)), {
        'indicator': true,
        'clear-indicator': true
      }, className)
    }),
    children
  );
};

// ==============================
// Separator
// ==============================

var indicatorSeparatorCSS = exports.indicatorSeparatorCSS = function indicatorSeparatorCSS(_ref3) {
  var isDisabled = _ref3.isDisabled;
  return {
    alignSelf: 'stretch',
    backgroundColor: isDisabled ? _theme.colors.neutral10 : _theme.colors.neutral20,
    marginBottom: _theme.spacing.baseUnit * 2,
    marginTop: _theme.spacing.baseUnit * 2,
    width: 1
  };
};

var IndicatorSeparator = exports.IndicatorSeparator = function IndicatorSeparator(props) {
  var className = props.className,
      cx = props.cx,
      getStyles = props.getStyles,
      innerProps = props.innerProps;

  return _react2.default.createElement('span', _extends({}, innerProps, {
    className: cx( /*#__PURE__*/(0, _emotion.css)(getStyles('indicatorSeparator', props)), { 'indicator-separator': true }, className)
  }));
};

// ==============================
// Loading
// ==============================

var keyframesName = 'react-select-loading-indicator';

var loadingIndicatorCSS = exports.loadingIndicatorCSS = function loadingIndicatorCSS(_ref4) {
  var isFocused = _ref4.isFocused,
      size = _ref4.size;
  return {
    color: isFocused ? _theme.colors.neutral60 : _theme.colors.neutral20,
    display: 'flex',
    padding: _theme.spacing.baseUnit * 2,
    transition: 'color 150ms',
    alignSelf: 'center',
    fontSize: size,
    lineHeight: 1,
    marginRight: size,
    textAlign: 'center',
    verticalAlign: 'middle'
  };
};

var LoadingDot = function LoadingDot(_ref5) {
  var color = _ref5.color,
      delay = _ref5.delay,
      offset = _ref5.offset;
  return _react2.default.createElement('span', {
    className: (0, _emotion.css)({
      animationDuration: '1s',
      animationDelay: delay + 'ms',
      animationIterationCount: 'infinite',
      animationName: keyframesName,
      animationTimingFunction: 'ease-in-out',
      backgroundColor: color,
      borderRadius: '1em',
      display: 'inline-block',
      marginLeft: offset ? '1em' : null,
      height: '1em',
      verticalAlign: 'top',
      width: '1em'
    })
  });
};

// eslint-disable-next-line no-unused-expressions
(0, _emotion.injectGlobal)('@keyframes ', keyframesName, '{0%,80%,100%{opacity:0;}40%{opacity:1;}};');

var LoadingIndicator = exports.LoadingIndicator = function LoadingIndicator(props) {
  var className = props.className,
      cx = props.cx,
      getStyles = props.getStyles,
      innerProps = props.innerProps,
      isFocused = props.isFocused,
      isRtl = props.isRtl;

  var color = isFocused ? _theme.colors.text : _theme.colors.neutral20;

  return _react2.default.createElement(
    'div',
    _extends({}, innerProps, {
      className: cx( /*#__PURE__*/(0, _emotion.css)(getStyles('loadingIndicator', props)), {
        'indicator': true,
        'loading-indicator': true
      }, className)
    }),
    _react2.default.createElement(LoadingDot, { color: color, delay: 0, offset: isRtl }),
    _react2.default.createElement(LoadingDot, { color: color, delay: 160, offset: true }),
    _react2.default.createElement(LoadingDot, { color: color, delay: 320, offset: !isRtl })
  );
};
LoadingIndicator.defaultProps = { size: 4 };

/***/ }),
/* 272 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/***/ }),
/* 273 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.inputCSS = undefined;

var _emotion = __webpack_require__(41);

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactInputAutosize = __webpack_require__(269);

var _reactInputAutosize2 = _interopRequireDefault(_reactInputAutosize);

var _theme = __webpack_require__(45);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var inputCSS = exports.inputCSS = function inputCSS(_ref) {
  var isDisabled = _ref.isDisabled;
  return {
    margin: _theme.spacing.baseUnit / 2,
    paddingBottom: _theme.spacing.baseUnit / 2,
    paddingTop: _theme.spacing.baseUnit / 2,
    visibility: isDisabled ? 'hidden' : 'visible',
    color: _theme.colors.text
  };
};
var inputStyle = function inputStyle(isHidden) {
  return {
    background: 0,
    border: 0,
    fontSize: 'inherit',
    opacity: isHidden ? 0 : 1,
    outline: 0,
    padding: 0,
    color: 'inherit'
  };
};

var Input = function Input(_ref2) {
  var className = _ref2.className,
      cx = _ref2.cx,
      getStyles = _ref2.getStyles,
      innerRef = _ref2.innerRef,
      isHidden = _ref2.isHidden,
      isDisabled = _ref2.isDisabled,
      props = _objectWithoutProperties(_ref2, ['className', 'cx', 'getStyles', 'innerRef', 'isHidden', 'isDisabled']);

  return _react2.default.createElement(
    'div',
    {
      className: (0, _emotion.css)(getStyles('input', props))
    },
    _react2.default.createElement(_reactInputAutosize2.default, _extends({
      className: cx(null, { 'input': true }, className),
      inputRef: innerRef,
      inputStyle: inputStyle(isHidden),
      disabled: isDisabled
    }, props))
  );
};

exports.default = Input;

/***/ }),
/* 274 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MultiValueRemove = exports.MultiValueLabel = exports.MultiValueContainer = exports.multiValueRemoveCSS = exports.multiValueLabelCSS = exports.multiValueCSS = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _emotion = __webpack_require__(41);

var _theme = __webpack_require__(45);

var _indicators = __webpack_require__(271);

var _primitives = __webpack_require__(608);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var multiValueCSS = exports.multiValueCSS = function multiValueCSS() {
  return {
    backgroundColor: _theme.colors.neutral10,
    borderRadius: _theme.borderRadius / 2,
    display: 'flex',
    margin: _theme.spacing.baseUnit / 2,
    minWidth: 0 // resolves flex/text-overflow bug
  };
};
var multiValueLabelCSS = exports.multiValueLabelCSS = function multiValueLabelCSS(_ref) {
  var cropWithEllipsis = _ref.cropWithEllipsis;
  return {
    color: _theme.colors.text,
    fontSize: '85%',
    overflow: 'hidden',
    padding: 3,
    paddingLeft: 6,
    textOverflow: cropWithEllipsis ? 'ellipsis' : null,
    whiteSpace: 'nowrap'
  };
};
var multiValueRemoveCSS = exports.multiValueRemoveCSS = function multiValueRemoveCSS(_ref2) {
  var isFocused = _ref2.isFocused;
  return {
    alignItems: 'center',
    borderRadius: _theme.borderRadius / 2,
    backgroundColor: isFocused && _theme.colors.dangerLight,
    display: 'flex',
    paddingLeft: _theme.spacing.baseUnit,
    paddingRight: _theme.spacing.baseUnit,
    ':hover': {
      backgroundColor: _theme.colors.dangerLight,
      color: _theme.colors.danger
    }
  };
};

var MultiValueContainer = exports.MultiValueContainer = _primitives.Div;
var MultiValueLabel = exports.MultiValueLabel = _primitives.Div;

var MultiValueRemove = exports.MultiValueRemove = function (_Component) {
  _inherits(MultiValueRemove, _Component);

  function MultiValueRemove() {
    _classCallCheck(this, MultiValueRemove);

    return _possibleConstructorReturn(this, (MultiValueRemove.__proto__ || Object.getPrototypeOf(MultiValueRemove)).apply(this, arguments));
  }

  _createClass(MultiValueRemove, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          children = _props.children,
          props = _objectWithoutProperties(_props, ['children']);

      return _react2.default.createElement(
        _primitives.Div,
        props,
        children
      );
    }
  }]);

  return MultiValueRemove;
}(_react.Component);

MultiValueRemove.defaultProps = {
  children: _react2.default.createElement(_indicators.CrossIcon, { size: 14 })
};

var MultiValue = function (_Component2) {
  _inherits(MultiValue, _Component2);

  function MultiValue() {
    _classCallCheck(this, MultiValue);

    return _possibleConstructorReturn(this, (MultiValue.__proto__ || Object.getPrototypeOf(MultiValue)).apply(this, arguments));
  }

  _createClass(MultiValue, [{
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          children = _props2.children,
          className = _props2.className,
          components = _props2.components,
          cx = _props2.cx,
          getStyles = _props2.getStyles,
          innerProps = _props2.innerProps,
          isDisabled = _props2.isDisabled,
          removeProps = _props2.removeProps;

      var cn = {
        container: cx( /*#__PURE__*/(0, _emotion.css)(getStyles('multiValue', this.props)), {
          'multi-value': true,
          'multi-value--is-disabled': isDisabled
        }, className),
        label: cx( /*#__PURE__*/(0, _emotion.css)(getStyles('multiValueLabel', this.props)), {
          'multi-value__label': true
        }, className),
        remove: cx( /*#__PURE__*/(0, _emotion.css)(getStyles('multiValueRemove', this.props)), {
          'multi-value__remove': true
        }, className)
      };
      var Container = components.Container,
          Label = components.Label,
          Remove = components.Remove;


      return _react2.default.createElement(
        Container,
        _extends({
          className: cn.container
        }, innerProps),
        _react2.default.createElement(
          Label,
          { className: cn.label },
          children
        ),
        _react2.default.createElement(Remove, _extends({ className: cn.remove }, removeProps))
      );
    }
  }]);

  return MultiValue;
}(_react.Component);

MultiValue.defaultProps = {
  cropWithEllipsis: true
};
exports.default = MultiValue;

/***/ }),
/* 275 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.placeholderCSS = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _emotion = __webpack_require__(41);

var _theme = __webpack_require__(45);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var placeholderCSS = exports.placeholderCSS = function placeholderCSS() {
  return {
    color: _theme.colors.neutral50,
    marginLeft: _theme.spacing.baseUnit / 2,
    marginRight: _theme.spacing.baseUnit / 2,
    position: 'absolute',
    top: '50%',
    transform: 'translateY(-50%)'
  };
};

var Placeholder = function Placeholder(props) {
  var children = props.children,
      className = props.className,
      cx = props.cx,
      getStyles = props.getStyles,
      innerProps = props.innerProps;

  return _react2.default.createElement(
    'div',
    _extends({
      className: cx( /*#__PURE__*/(0, _emotion.css)(getStyles('placeholder', props)), {
        'placeholder': true
      }, className)
    }, innerProps),
    children
  );
};

exports.default = Placeholder;

/***/ }),
/* 276 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.css = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _emotion = __webpack_require__(41);

var _theme = __webpack_require__(45);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var css = exports.css = function css(_ref) {
  var isDisabled = _ref.isDisabled;
  return {
    color: isDisabled ? _theme.colors.neutral40 : _theme.colors.text,
    marginLeft: _theme.spacing.baseUnit / 2,
    marginRight: _theme.spacing.baseUnit / 2,
    maxWidth: 'calc(100% - ' + _theme.spacing.baseUnit * 2 + 'px)',
    overflow: 'hidden',
    position: 'absolute',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    top: '50%',
    transform: 'translateY(-50%)'
  };
};

var SingleValue = function SingleValue(props) {
  var children = props.children,
      className = props.className,
      cx = props.cx,
      getStyles = props.getStyles,
      isDisabled = props.isDisabled,
      innerProps = props.innerProps;

  return _react2.default.createElement(
    'div',
    _extends({
      className: cx( /*#__PURE__*/(0, _emotion.css)(getStyles('singleValue', props)), {
        'single-value': true,
        'single-value--is-disabled': isDisabled
      }, className)
    }, innerProps),
    children
  );
};

exports.default = SingleValue;

/***/ }),
/* 277 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(2);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Select.default;
  }
});

var _Select = _interopRequireDefault(__webpack_require__(617));

/***/ }),
/* 278 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (recalc) {
  if (!size && size !== 0 || recalc) {
    if (_inDOM2.default) {
      var scrollDiv = document.createElement('div');

      scrollDiv.style.position = 'absolute';
      scrollDiv.style.top = '-9999px';
      scrollDiv.style.width = '50px';
      scrollDiv.style.height = '50px';
      scrollDiv.style.overflow = 'scroll';

      document.body.appendChild(scrollDiv);
      size = scrollDiv.offsetWidth - scrollDiv.clientWidth;
      document.body.removeChild(scrollDiv);
    }
  }

  return size;
};

var _inDOM = __webpack_require__(279);

var _inDOM2 = _interopRequireDefault(_inDOM);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var size = void 0;

module.exports = exports['default'];

/***/ }),
/* 279 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
module.exports = exports['default'];

/***/ }),
/* 280 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(2);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(11));

var _createClass2 = _interopRequireDefault(__webpack_require__(12));

var _style = _interopRequireDefault(__webpack_require__(623));

var _scrollbarSize = _interopRequireDefault(__webpack_require__(278));

var _ownerDocument = _interopRequireDefault(__webpack_require__(48));

var _isOverflowing = _interopRequireDefault(__webpack_require__(631));

var _manageAriaHidden = __webpack_require__(633);

function findIndexOf(data, callback) {
  var idx = -1;
  data.some(function (item, index) {
    if (callback(item)) {
      idx = index;
      return true;
    }

    return false;
  });
  return idx;
}

function getPaddingRight(node) {
  return parseInt((0, _style.default)(node, 'paddingRight') || 0, 10);
}

function setContainerStyle(data, container) {
  var style = {
    overflow: 'hidden'
  }; // We are only interested in the actual `style` here because we will override it.

  data.style = {
    overflow: container.style.overflow,
    paddingRight: container.style.paddingRight
  };

  if (data.overflowing) {
    var scrollbarSize = (0, _scrollbarSize.default)(); // Use computed style, here to get the real padding to add our scrollbar width.

    style.paddingRight = "".concat(getPaddingRight(container) + scrollbarSize, "px"); // .mui-fixed is a global helper.

    var fixedNodes = (0, _ownerDocument.default)(container).querySelectorAll('.mui-fixed');

    for (var i = 0; i < fixedNodes.length; i += 1) {
      var paddingRight = getPaddingRight(fixedNodes[i]);
      data.prevPaddings.push(paddingRight);
      fixedNodes[i].style.paddingRight = "".concat(paddingRight + scrollbarSize, "px");
    }
  }

  Object.keys(style).forEach(function (key) {
    container.style[key] = style[key];
  });
}

function removeContainerStyle(data, container) {
  Object.keys(data.style).forEach(function (key) {
    container.style[key] = data.style[key];
  });
  var fixedNodes = (0, _ownerDocument.default)(container).querySelectorAll('.mui-fixed');

  for (var i = 0; i < fixedNodes.length; i += 1) {
    fixedNodes[i].style.paddingRight = "".concat(data.prevPaddings[i], "px");
  }
}
/**
 * @ignore - do not document.
 *
 * Proper state managment for containers and the modals in those containers.
 * Simplified, but inspired by react-overlay's ModalManager class.
 * Used by the Modal to ensure proper styling of containers.
 */


var ModalManager =
/*#__PURE__*/
function () {
  function ModalManager() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    (0, _classCallCheck2.default)(this, ModalManager);
    var _options$hideSiblingN = options.hideSiblingNodes,
        hideSiblingNodes = _options$hideSiblingN === void 0 ? true : _options$hideSiblingN,
        _options$handleContai = options.handleContainerOverflow,
        handleContainerOverflow = _options$handleContai === void 0 ? true : _options$handleContai;
    this.hideSiblingNodes = hideSiblingNodes;
    this.handleContainerOverflow = handleContainerOverflow; // this.modals[modalIdx] = modal

    this.modals = []; // this.containers[containerIdx] = container

    this.containers = []; // this.data[containerIdx] = {
    //   modals: [],
    // }

    this.data = [];
  }

  (0, _createClass2.default)(ModalManager, [{
    key: "add",
    value: function add(modal, container) {
      var modalIdx = this.modals.indexOf(modal);

      if (modalIdx !== -1) {
        return modalIdx;
      }

      modalIdx = this.modals.length;
      this.modals.push(modal);

      if (this.hideSiblingNodes) {
        (0, _manageAriaHidden.hideSiblings)(container, modal.mountNode);
      }

      var containerIdx = this.containers.indexOf(container);

      if (containerIdx !== -1) {
        this.data[containerIdx].modals.push(modal);
        return modalIdx;
      }

      var data = {
        modals: [modal],
        overflowing: (0, _isOverflowing.default)(container),
        prevPaddings: []
      };

      if (this.handleContainerOverflow) {
        setContainerStyle(data, container);
      }

      this.containers.push(container);
      this.data.push(data);
      return modalIdx;
    }
  }, {
    key: "remove",
    value: function remove(modal) {
      var modalIdx = this.modals.indexOf(modal);

      if (modalIdx === -1) {
        return modalIdx;
      }

      var containerIdx = findIndexOf(this.data, function (item) {
        return item.modals.indexOf(modal) !== -1;
      });
      var data = this.data[containerIdx];
      var container = this.containers[containerIdx];
      data.modals.splice(data.modals.indexOf(modal), 1);
      this.modals.splice(modalIdx, 1); // If that was the last modal in a container, clean up the container.

      if (data.modals.length === 0) {
        if (this.handleContainerOverflow) {
          removeContainerStyle(data, container);
        }

        if (this.hideSiblingNodes) {
          (0, _manageAriaHidden.showSiblings)(container, modal.mountNode);
        }

        this.containers.splice(containerIdx, 1);
        this.data.splice(containerIdx, 1);
      } else if (this.hideSiblingNodes) {
        // Otherwise make sure the next top modal is visible to a screan reader.
        (0, _manageAriaHidden.ariaHidden)(false, data.modals[data.modals.length - 1].mountNode);
      }

      return modalIdx;
    }
  }, {
    key: "isTopModal",
    value: function isTopModal(modal) {
      return !!this.modals.length && this.modals[this.modals.length - 1] === modal;
    }
  }]);
  return ModalManager;
}();

var _default = ModalManager;
exports.default = _default;

/***/ }),
/* 281 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = camelizeStyleName;

var _camelize = __webpack_require__(624);

var _camelize2 = _interopRequireDefault(_camelize);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var msPattern = /^-ms-/; /**
                          * Copyright 2014-2015, Facebook, Inc.
                          * All rights reserved.
                          * https://github.com/facebook/react/blob/2aeb8a2a6beb00617a4217f7f8284924fa2ad819/src/vendor/core/camelizeStyleName.js
                          */
function camelizeStyleName(string) {
  return (0, _camelize2.default)(string.replace(msPattern, 'ms-'));
}
module.exports = exports['default'];

/***/ }),
/* 282 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(2);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _MenuList.default;
  }
});

var _MenuList = _interopRequireDefault(__webpack_require__(638));

/***/ }),
/* 283 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(2);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _List.default;
  }
});

var _List = _interopRequireDefault(__webpack_require__(639));

/***/ }),
/* 284 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(2);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _pure = _interopRequireDefault(__webpack_require__(96));

var _SvgIcon = _interopRequireDefault(__webpack_require__(97));

var _ref = _react.default.createElement("path", {
  d: "M7 10l5 5 5-5z"
});

/**
 * @ignore - internal component.
 */
var ArrowDropDown = function ArrowDropDown(props) {
  return _react.default.createElement(_SvgIcon.default, props, _ref);
};

ArrowDropDown = (0, _pure.default)(ArrowDropDown);
ArrowDropDown.muiName = 'SvgIcon';
var _default = ArrowDropDown;
exports.default = _default;

/***/ }),
/* 285 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(2);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(6));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(7));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(4));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _classnames = _interopRequireDefault(__webpack_require__(5));

/**
 * @ignore - internal component.
 */
function NativeSelectInput(props) {
  var children = props.children,
      classes = props.classes,
      className = props.className,
      disabled = props.disabled,
      IconComponent = props.IconComponent,
      inputRef = props.inputRef,
      name = props.name,
      onChange = props.onChange,
      value = props.value,
      other = (0, _objectWithoutProperties2.default)(props, ["children", "classes", "className", "disabled", "IconComponent", "inputRef", "name", "onChange", "value"]);
  return _react.default.createElement("div", {
    className: classes.root
  }, _react.default.createElement("select", (0, _extends2.default)({
    className: (0, _classnames.default)(classes.select, (0, _defineProperty2.default)({}, classes.disabled, disabled), className),
    name: name,
    disabled: disabled,
    onChange: onChange,
    value: value,
    ref: inputRef
  }, other), children), _react.default.createElement(IconComponent, {
    className: classes.icon
  }));
}

NativeSelectInput.propTypes =  false ? {
  /**
   * The option elements to populate the select with.
   * Can be some `<option>` elements.
   */
  children: _propTypes.default.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * The CSS class name of the select element.
   */
  className: _propTypes.default.string,

  /**
   * If `true`, the select will be disabled.
   */
  disabled: _propTypes.default.bool,

  /**
   * The icon that displays the arrow.
   */
  IconComponent: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func, _propTypes.default.object]),

  /**
   * Use that property to pass a ref callback to the native select element.
   */
  inputRef: _propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.object]),

  /**
   * Name attribute of the `select` or hidden `input` element.
   */
  name: _propTypes.default.string,

  /**
   * Callback function fired when a menu item is selected.
   *
   * @param {object} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value`.
   */
  onChange: _propTypes.default.func,

  /**
   * The input value.
   */
  value: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number])
} : {};
var _default = NativeSelectInput;
exports.default = _default;

/***/ }),
/* 286 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = __webpack_require__(642).default;

/***/ }),
/* 287 */
/***/ (function(module, exports, __webpack_require__) {

var removeDiacritics = __webpack_require__(654).clean;

// https://developer.mozilla.org/en/docs/Web/JavaScript/Guide/Regular_Expressions#Using_special_characters
var specialCharsRegex = /[.*+?^${}()|[\]\\]/g;

// http://www.ecma-international.org/ecma-262/5.1/#sec-15.10.2.6
var wordCharacterRegex = /[a-z0-9_]/i;

var whitespacesRegex = /\s+/;

function escapeRegexCharacters(str) {
  return str.replace(specialCharsRegex, '\\$&');
}

module.exports = function match(text, query) {
  text = removeDiacritics(text);
  query = removeDiacritics(query);

  return (
    query
      .trim()
      .split(whitespacesRegex)
      // If query is blank, we'll get empty string here, so let's filter it out.
      .filter(function(word) {
        return word.length > 0;
      })
      .reduce(function(result, word) {
        var wordLen = word.length;
        var prefix = wordCharacterRegex.test(word[0]) ? '\\b' : '';
        var regex = new RegExp(prefix + escapeRegexCharacters(word), 'i');
        var index = text.search(regex);

        if (index > -1) {
          result.push([index, index + wordLen]);

          // Replace what we just found with spaces so we don't find it again.
          text =
            text.slice(0, index) +
            new Array(wordLen + 1).join(' ') +
            text.slice(index + wordLen);
        }

        return result;
      }, [])
      .sort(function(match1, match2) {
        return match1[0] - match2[0];
      })
  );
};


/***/ }),
/* 288 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(2);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _ListItem.default;
  }
});

var _ListItem = _interopRequireDefault(__webpack_require__(656));

/***/ }),
/* 289 */
/***/ (function(module, exports) {

module.exports = function parse(text, matches) {
  var result = [];

  if (matches.length === 0) {
    result.push({
      text: text,
      highlight: false
    });
  } else {
    if (matches[0][0] > 0) {
      result.push({
        text: text.slice(0, matches[0][0]),
        highlight: false
      });
    }
  }

  matches.forEach(function(match, i) {
    var startIndex = match[0];
    var endIndex = match[1];

    result.push({
      text: text.slice(startIndex, endIndex),
      highlight: true
    });

    if (i === matches.length - 1) {
      if (endIndex < text.length) {
        result.push({
          text: text.slice(endIndex, text.length),
          highlight: false
        });
      }
    } else if (endIndex < matches[i + 1][0]) {
      result.push({
        text: text.slice(endIndex, matches[i + 1][0]),
        highlight: false
      });
    }
  });

  return result;
};


/***/ }),
/* 290 */
/***/ (function(module, exports, __webpack_require__) {

/* MIT license */
var convert = __webpack_require__(664);
var string = __webpack_require__(666);

var Color = function (obj) {
	if (obj instanceof Color) {
		return obj;
	}
	if (!(this instanceof Color)) {
		return new Color(obj);
	}

	this.valid = false;
	this.values = {
		rgb: [0, 0, 0],
		hsl: [0, 0, 0],
		hsv: [0, 0, 0],
		hwb: [0, 0, 0],
		cmyk: [0, 0, 0, 0],
		alpha: 1
	};

	// parse Color() argument
	var vals;
	if (typeof obj === 'string') {
		vals = string.getRgba(obj);
		if (vals) {
			this.setValues('rgb', vals);
		} else if (vals = string.getHsla(obj)) {
			this.setValues('hsl', vals);
		} else if (vals = string.getHwb(obj)) {
			this.setValues('hwb', vals);
		}
	} else if (typeof obj === 'object') {
		vals = obj;
		if (vals.r !== undefined || vals.red !== undefined) {
			this.setValues('rgb', vals);
		} else if (vals.l !== undefined || vals.lightness !== undefined) {
			this.setValues('hsl', vals);
		} else if (vals.v !== undefined || vals.value !== undefined) {
			this.setValues('hsv', vals);
		} else if (vals.w !== undefined || vals.whiteness !== undefined) {
			this.setValues('hwb', vals);
		} else if (vals.c !== undefined || vals.cyan !== undefined) {
			this.setValues('cmyk', vals);
		}
	}
};

Color.prototype = {
	isValid: function () {
		return this.valid;
	},
	rgb: function () {
		return this.setSpace('rgb', arguments);
	},
	hsl: function () {
		return this.setSpace('hsl', arguments);
	},
	hsv: function () {
		return this.setSpace('hsv', arguments);
	},
	hwb: function () {
		return this.setSpace('hwb', arguments);
	},
	cmyk: function () {
		return this.setSpace('cmyk', arguments);
	},

	rgbArray: function () {
		return this.values.rgb;
	},
	hslArray: function () {
		return this.values.hsl;
	},
	hsvArray: function () {
		return this.values.hsv;
	},
	hwbArray: function () {
		var values = this.values;
		if (values.alpha !== 1) {
			return values.hwb.concat([values.alpha]);
		}
		return values.hwb;
	},
	cmykArray: function () {
		return this.values.cmyk;
	},
	rgbaArray: function () {
		var values = this.values;
		return values.rgb.concat([values.alpha]);
	},
	hslaArray: function () {
		var values = this.values;
		return values.hsl.concat([values.alpha]);
	},
	alpha: function (val) {
		if (val === undefined) {
			return this.values.alpha;
		}
		this.setValues('alpha', val);
		return this;
	},

	red: function (val) {
		return this.setChannel('rgb', 0, val);
	},
	green: function (val) {
		return this.setChannel('rgb', 1, val);
	},
	blue: function (val) {
		return this.setChannel('rgb', 2, val);
	},
	hue: function (val) {
		if (val) {
			val %= 360;
			val = val < 0 ? 360 + val : val;
		}
		return this.setChannel('hsl', 0, val);
	},
	saturation: function (val) {
		return this.setChannel('hsl', 1, val);
	},
	lightness: function (val) {
		return this.setChannel('hsl', 2, val);
	},
	saturationv: function (val) {
		return this.setChannel('hsv', 1, val);
	},
	whiteness: function (val) {
		return this.setChannel('hwb', 1, val);
	},
	blackness: function (val) {
		return this.setChannel('hwb', 2, val);
	},
	value: function (val) {
		return this.setChannel('hsv', 2, val);
	},
	cyan: function (val) {
		return this.setChannel('cmyk', 0, val);
	},
	magenta: function (val) {
		return this.setChannel('cmyk', 1, val);
	},
	yellow: function (val) {
		return this.setChannel('cmyk', 2, val);
	},
	black: function (val) {
		return this.setChannel('cmyk', 3, val);
	},

	hexString: function () {
		return string.hexString(this.values.rgb);
	},
	rgbString: function () {
		return string.rgbString(this.values.rgb, this.values.alpha);
	},
	rgbaString: function () {
		return string.rgbaString(this.values.rgb, this.values.alpha);
	},
	percentString: function () {
		return string.percentString(this.values.rgb, this.values.alpha);
	},
	hslString: function () {
		return string.hslString(this.values.hsl, this.values.alpha);
	},
	hslaString: function () {
		return string.hslaString(this.values.hsl, this.values.alpha);
	},
	hwbString: function () {
		return string.hwbString(this.values.hwb, this.values.alpha);
	},
	keyword: function () {
		return string.keyword(this.values.rgb, this.values.alpha);
	},

	rgbNumber: function () {
		var rgb = this.values.rgb;
		return (rgb[0] << 16) | (rgb[1] << 8) | rgb[2];
	},

	luminosity: function () {
		// http://www.w3.org/TR/WCAG20/#relativeluminancedef
		var rgb = this.values.rgb;
		var lum = [];
		for (var i = 0; i < rgb.length; i++) {
			var chan = rgb[i] / 255;
			lum[i] = (chan <= 0.03928) ? chan / 12.92 : Math.pow(((chan + 0.055) / 1.055), 2.4);
		}
		return 0.2126 * lum[0] + 0.7152 * lum[1] + 0.0722 * lum[2];
	},

	contrast: function (color2) {
		// http://www.w3.org/TR/WCAG20/#contrast-ratiodef
		var lum1 = this.luminosity();
		var lum2 = color2.luminosity();
		if (lum1 > lum2) {
			return (lum1 + 0.05) / (lum2 + 0.05);
		}
		return (lum2 + 0.05) / (lum1 + 0.05);
	},

	level: function (color2) {
		var contrastRatio = this.contrast(color2);
		if (contrastRatio >= 7.1) {
			return 'AAA';
		}

		return (contrastRatio >= 4.5) ? 'AA' : '';
	},

	dark: function () {
		// YIQ equation from http://24ways.org/2010/calculating-color-contrast
		var rgb = this.values.rgb;
		var yiq = (rgb[0] * 299 + rgb[1] * 587 + rgb[2] * 114) / 1000;
		return yiq < 128;
	},

	light: function () {
		return !this.dark();
	},

	negate: function () {
		var rgb = [];
		for (var i = 0; i < 3; i++) {
			rgb[i] = 255 - this.values.rgb[i];
		}
		this.setValues('rgb', rgb);
		return this;
	},

	lighten: function (ratio) {
		var hsl = this.values.hsl;
		hsl[2] += hsl[2] * ratio;
		this.setValues('hsl', hsl);
		return this;
	},

	darken: function (ratio) {
		var hsl = this.values.hsl;
		hsl[2] -= hsl[2] * ratio;
		this.setValues('hsl', hsl);
		return this;
	},

	saturate: function (ratio) {
		var hsl = this.values.hsl;
		hsl[1] += hsl[1] * ratio;
		this.setValues('hsl', hsl);
		return this;
	},

	desaturate: function (ratio) {
		var hsl = this.values.hsl;
		hsl[1] -= hsl[1] * ratio;
		this.setValues('hsl', hsl);
		return this;
	},

	whiten: function (ratio) {
		var hwb = this.values.hwb;
		hwb[1] += hwb[1] * ratio;
		this.setValues('hwb', hwb);
		return this;
	},

	blacken: function (ratio) {
		var hwb = this.values.hwb;
		hwb[2] += hwb[2] * ratio;
		this.setValues('hwb', hwb);
		return this;
	},

	greyscale: function () {
		var rgb = this.values.rgb;
		// http://en.wikipedia.org/wiki/Grayscale#Converting_color_to_grayscale
		var val = rgb[0] * 0.3 + rgb[1] * 0.59 + rgb[2] * 0.11;
		this.setValues('rgb', [val, val, val]);
		return this;
	},

	clearer: function (ratio) {
		var alpha = this.values.alpha;
		this.setValues('alpha', alpha - (alpha * ratio));
		return this;
	},

	opaquer: function (ratio) {
		var alpha = this.values.alpha;
		this.setValues('alpha', alpha + (alpha * ratio));
		return this;
	},

	rotate: function (degrees) {
		var hsl = this.values.hsl;
		var hue = (hsl[0] + degrees) % 360;
		hsl[0] = hue < 0 ? 360 + hue : hue;
		this.setValues('hsl', hsl);
		return this;
	},

	/**
	 * Ported from sass implementation in C
	 * https://github.com/sass/libsass/blob/0e6b4a2850092356aa3ece07c6b249f0221caced/functions.cpp#L209
	 */
	mix: function (mixinColor, weight) {
		var color1 = this;
		var color2 = mixinColor;
		var p = weight === undefined ? 0.5 : weight;

		var w = 2 * p - 1;
		var a = color1.alpha() - color2.alpha();

		var w1 = (((w * a === -1) ? w : (w + a) / (1 + w * a)) + 1) / 2.0;
		var w2 = 1 - w1;

		return this
			.rgb(
				w1 * color1.red() + w2 * color2.red(),
				w1 * color1.green() + w2 * color2.green(),
				w1 * color1.blue() + w2 * color2.blue()
			)
			.alpha(color1.alpha() * p + color2.alpha() * (1 - p));
	},

	toJSON: function () {
		return this.rgb();
	},

	clone: function () {
		// NOTE(SB): using node-clone creates a dependency to Buffer when using browserify,
		// making the final build way to big to embed in Chart.js. So let's do it manually,
		// assuming that values to clone are 1 dimension arrays containing only numbers,
		// except 'alpha' which is a number.
		var result = new Color();
		var source = this.values;
		var target = result.values;
		var value, type;

		for (var prop in source) {
			if (source.hasOwnProperty(prop)) {
				value = source[prop];
				type = ({}).toString.call(value);
				if (type === '[object Array]') {
					target[prop] = value.slice(0);
				} else if (type === '[object Number]') {
					target[prop] = value;
				} else {
					console.error('unexpected color value:', value);
				}
			}
		}

		return result;
	}
};

Color.prototype.spaces = {
	rgb: ['red', 'green', 'blue'],
	hsl: ['hue', 'saturation', 'lightness'],
	hsv: ['hue', 'saturation', 'value'],
	hwb: ['hue', 'whiteness', 'blackness'],
	cmyk: ['cyan', 'magenta', 'yellow', 'black']
};

Color.prototype.maxes = {
	rgb: [255, 255, 255],
	hsl: [360, 100, 100],
	hsv: [360, 100, 100],
	hwb: [360, 100, 100],
	cmyk: [100, 100, 100, 100]
};

Color.prototype.getValues = function (space) {
	var values = this.values;
	var vals = {};

	for (var i = 0; i < space.length; i++) {
		vals[space.charAt(i)] = values[space][i];
	}

	if (values.alpha !== 1) {
		vals.a = values.alpha;
	}

	// {r: 255, g: 255, b: 255, a: 0.4}
	return vals;
};

Color.prototype.setValues = function (space, vals) {
	var values = this.values;
	var spaces = this.spaces;
	var maxes = this.maxes;
	var alpha = 1;
	var i;

	this.valid = true;

	if (space === 'alpha') {
		alpha = vals;
	} else if (vals.length) {
		// [10, 10, 10]
		values[space] = vals.slice(0, space.length);
		alpha = vals[space.length];
	} else if (vals[space.charAt(0)] !== undefined) {
		// {r: 10, g: 10, b: 10}
		for (i = 0; i < space.length; i++) {
			values[space][i] = vals[space.charAt(i)];
		}

		alpha = vals.a;
	} else if (vals[spaces[space][0]] !== undefined) {
		// {red: 10, green: 10, blue: 10}
		var chans = spaces[space];

		for (i = 0; i < space.length; i++) {
			values[space][i] = vals[chans[i]];
		}

		alpha = vals.alpha;
	}

	values.alpha = Math.max(0, Math.min(1, (alpha === undefined ? values.alpha : alpha)));

	if (space === 'alpha') {
		return false;
	}

	var capped;

	// cap values of the space prior converting all values
	for (i = 0; i < space.length; i++) {
		capped = Math.max(0, Math.min(maxes[space][i], values[space][i]));
		values[space][i] = Math.round(capped);
	}

	// convert to all the other color spaces
	for (var sname in spaces) {
		if (sname !== space) {
			values[sname] = convert[space][sname](values[space]);
		}
	}

	return true;
};

Color.prototype.setSpace = function (space, args) {
	var vals = args[0];

	if (vals === undefined) {
		// color.rgb()
		return this.getValues(space);
	}

	// color.rgb(10, 10, 10)
	if (typeof vals === 'number') {
		vals = Array.prototype.slice.call(args);
	}

	this.setValues(space, vals);
	return this;
};

Color.prototype.setChannel = function (space, index, val) {
	var svalues = this.values[space];
	if (val === undefined) {
		// color.red()
		return svalues[index];
	} else if (val === svalues[index]) {
		// color.red(color.red())
		return this;
	}

	// color.red(100)
	svalues[index] = val;
	this.setValues(space, svalues);

	return this;
};

if (typeof window !== 'undefined') {
	window.Color = Color;
}

module.exports = Color;


/***/ }),
/* 291 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var helpers = __webpack_require__(15);

/**
 * Helper function to get relative position for an event
 * @param {Event|IEvent} event - The event to get the position for
 * @param {Chart} chart - The chart
 * @returns {Point} the event position
 */
function getRelativePosition(e, chart) {
	if (e.native) {
		return {
			x: e.x,
			y: e.y
		};
	}

	return helpers.getRelativePosition(e, chart);
}

/**
 * Helper function to traverse all of the visible elements in the chart
 * @param chart {chart} the chart
 * @param handler {Function} the callback to execute for each visible item
 */
function parseVisibleItems(chart, handler) {
	var datasets = chart.data.datasets;
	var meta, i, j, ilen, jlen;

	for (i = 0, ilen = datasets.length; i < ilen; ++i) {
		if (!chart.isDatasetVisible(i)) {
			continue;
		}

		meta = chart.getDatasetMeta(i);
		for (j = 0, jlen = meta.data.length; j < jlen; ++j) {
			var element = meta.data[j];
			if (!element._view.skip) {
				handler(element);
			}
		}
	}
}

/**
 * Helper function to get the items that intersect the event position
 * @param items {ChartElement[]} elements to filter
 * @param position {Point} the point to be nearest to
 * @return {ChartElement[]} the nearest items
 */
function getIntersectItems(chart, position) {
	var elements = [];

	parseVisibleItems(chart, function(element) {
		if (element.inRange(position.x, position.y)) {
			elements.push(element);
		}
	});

	return elements;
}

/**
 * Helper function to get the items nearest to the event position considering all visible items in teh chart
 * @param chart {Chart} the chart to look at elements from
 * @param position {Point} the point to be nearest to
 * @param intersect {Boolean} if true, only consider items that intersect the position
 * @param distanceMetric {Function} function to provide the distance between points
 * @return {ChartElement[]} the nearest items
 */
function getNearestItems(chart, position, intersect, distanceMetric) {
	var minDistance = Number.POSITIVE_INFINITY;
	var nearestItems = [];

	parseVisibleItems(chart, function(element) {
		if (intersect && !element.inRange(position.x, position.y)) {
			return;
		}

		var center = element.getCenterPoint();
		var distance = distanceMetric(position, center);

		if (distance < minDistance) {
			nearestItems = [element];
			minDistance = distance;
		} else if (distance === minDistance) {
			// Can have multiple items at the same distance in which case we sort by size
			nearestItems.push(element);
		}
	});

	return nearestItems;
}

/**
 * Get a distance metric function for two points based on the
 * axis mode setting
 * @param {String} axis the axis mode. x|y|xy
 */
function getDistanceMetricForAxis(axis) {
	var useX = axis.indexOf('x') !== -1;
	var useY = axis.indexOf('y') !== -1;

	return function(pt1, pt2) {
		var deltaX = useX ? Math.abs(pt1.x - pt2.x) : 0;
		var deltaY = useY ? Math.abs(pt1.y - pt2.y) : 0;
		return Math.sqrt(Math.pow(deltaX, 2) + Math.pow(deltaY, 2));
	};
}

function indexMode(chart, e, options) {
	var position = getRelativePosition(e, chart);
	// Default axis for index mode is 'x' to match old behaviour
	options.axis = options.axis || 'x';
	var distanceMetric = getDistanceMetricForAxis(options.axis);
	var items = options.intersect ? getIntersectItems(chart, position) : getNearestItems(chart, position, false, distanceMetric);
	var elements = [];

	if (!items.length) {
		return [];
	}

	chart.data.datasets.forEach(function(dataset, datasetIndex) {
		if (chart.isDatasetVisible(datasetIndex)) {
			var meta = chart.getDatasetMeta(datasetIndex);
			var element = meta.data[items[0]._index];

			// don't count items that are skipped (null data)
			if (element && !element._view.skip) {
				elements.push(element);
			}
		}
	});

	return elements;
}

/**
 * @interface IInteractionOptions
 */
/**
 * If true, only consider items that intersect the point
 * @name IInterfaceOptions#boolean
 * @type Boolean
 */

/**
 * Contains interaction related functions
 * @namespace Chart.Interaction
 */
module.exports = {
	// Helper function for different modes
	modes: {
		single: function(chart, e) {
			var position = getRelativePosition(e, chart);
			var elements = [];

			parseVisibleItems(chart, function(element) {
				if (element.inRange(position.x, position.y)) {
					elements.push(element);
					return elements;
				}
			});

			return elements.slice(0, 1);
		},

		/**
		 * @function Chart.Interaction.modes.label
		 * @deprecated since version 2.4.0
		 * @todo remove at version 3
		 * @private
		 */
		label: indexMode,

		/**
		 * Returns items at the same index. If the options.intersect parameter is true, we only return items if we intersect something
		 * If the options.intersect mode is false, we find the nearest item and return the items at the same index as that item
		 * @function Chart.Interaction.modes.index
		 * @since v2.4.0
		 * @param chart {chart} the chart we are returning items from
		 * @param e {Event} the event we are find things at
		 * @param options {IInteractionOptions} options to use during interaction
		 * @return {Chart.Element[]} Array of elements that are under the point. If none are found, an empty array is returned
		 */
		index: indexMode,

		/**
		 * Returns items in the same dataset. If the options.intersect parameter is true, we only return items if we intersect something
		 * If the options.intersect is false, we find the nearest item and return the items in that dataset
		 * @function Chart.Interaction.modes.dataset
		 * @param chart {chart} the chart we are returning items from
		 * @param e {Event} the event we are find things at
		 * @param options {IInteractionOptions} options to use during interaction
		 * @return {Chart.Element[]} Array of elements that are under the point. If none are found, an empty array is returned
		 */
		dataset: function(chart, e, options) {
			var position = getRelativePosition(e, chart);
			options.axis = options.axis || 'xy';
			var distanceMetric = getDistanceMetricForAxis(options.axis);
			var items = options.intersect ? getIntersectItems(chart, position) : getNearestItems(chart, position, false, distanceMetric);

			if (items.length > 0) {
				items = chart.getDatasetMeta(items[0]._datasetIndex).data;
			}

			return items;
		},

		/**
		 * @function Chart.Interaction.modes.x-axis
		 * @deprecated since version 2.4.0. Use index mode and intersect == true
		 * @todo remove at version 3
		 * @private
		 */
		'x-axis': function(chart, e) {
			return indexMode(chart, e, {intersect: false});
		},

		/**
		 * Point mode returns all elements that hit test based on the event position
		 * of the event
		 * @function Chart.Interaction.modes.intersect
		 * @param chart {chart} the chart we are returning items from
		 * @param e {Event} the event we are find things at
		 * @return {Chart.Element[]} Array of elements that are under the point. If none are found, an empty array is returned
		 */
		point: function(chart, e) {
			var position = getRelativePosition(e, chart);
			return getIntersectItems(chart, position);
		},

		/**
		 * nearest mode returns the element closest to the point
		 * @function Chart.Interaction.modes.intersect
		 * @param chart {chart} the chart we are returning items from
		 * @param e {Event} the event we are find things at
		 * @param options {IInteractionOptions} options to use
		 * @return {Chart.Element[]} Array of elements that are under the point. If none are found, an empty array is returned
		 */
		nearest: function(chart, e, options) {
			var position = getRelativePosition(e, chart);
			options.axis = options.axis || 'xy';
			var distanceMetric = getDistanceMetricForAxis(options.axis);
			var nearestItems = getNearestItems(chart, position, options.intersect, distanceMetric);

			// We have multiple items at the same distance from the event. Now sort by smallest
			if (nearestItems.length > 1) {
				nearestItems.sort(function(a, b) {
					var sizeA = a.getArea();
					var sizeB = b.getArea();
					var ret = sizeA - sizeB;

					if (ret === 0) {
						// if equal sort by dataset index
						ret = a._datasetIndex - b._datasetIndex;
					}

					return ret;
				});
			}

			// Return only 1 item
			return nearestItems.slice(0, 1);
		},

		/**
		 * x mode returns the elements that hit-test at the current x coordinate
		 * @function Chart.Interaction.modes.x
		 * @param chart {chart} the chart we are returning items from
		 * @param e {Event} the event we are find things at
		 * @param options {IInteractionOptions} options to use
		 * @return {Chart.Element[]} Array of elements that are under the point. If none are found, an empty array is returned
		 */
		x: function(chart, e, options) {
			var position = getRelativePosition(e, chart);
			var items = [];
			var intersectsItem = false;

			parseVisibleItems(chart, function(element) {
				if (element.inXRange(position.x)) {
					items.push(element);
				}

				if (element.inRange(position.x, position.y)) {
					intersectsItem = true;
				}
			});

			// If we want to trigger on an intersect and we don't have any items
			// that intersect the position, return nothing
			if (options.intersect && !intersectsItem) {
				items = [];
			}
			return items;
		},

		/**
		 * y mode returns the elements that hit-test at the current y coordinate
		 * @function Chart.Interaction.modes.y
		 * @param chart {chart} the chart we are returning items from
		 * @param e {Event} the event we are find things at
		 * @param options {IInteractionOptions} options to use
		 * @return {Chart.Element[]} Array of elements that are under the point. If none are found, an empty array is returned
		 */
		y: function(chart, e, options) {
			var position = getRelativePosition(e, chart);
			var items = [];
			var intersectsItem = false;

			parseVisibleItems(chart, function(element) {
				if (element.inYRange(position.y)) {
					items.push(element);
				}

				if (element.inRange(position.x, position.y)) {
					intersectsItem = true;
				}
			});

			// If we want to trigger on an intersect and we don't have any items
			// that intersect the position, return nothing
			if (options.intersect && !intersectsItem) {
				items = [];
			}
			return items;
		}
	}
};


/***/ }),
/* 292 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var helpers = __webpack_require__(15);
var basic = __webpack_require__(672);
var dom = __webpack_require__(673);

// @TODO Make possible to select another platform at build time.
var implementation = dom._enabled ? dom : basic;

/**
 * @namespace Chart.platform
 * @see https://chartjs.gitbooks.io/proposals/content/Platform.html
 * @since 2.4.0
 */
module.exports = helpers.extend({
	/**
	 * @since 2.7.0
	 */
	initialize: function() {},

	/**
	 * Called at chart construction time, returns a context2d instance implementing
	 * the [W3C Canvas 2D Context API standard]{@link https://www.w3.org/TR/2dcontext/}.
	 * @param {*} item - The native item from which to acquire context (platform specific)
	 * @param {Object} options - The chart options
	 * @returns {CanvasRenderingContext2D} context2d instance
	 */
	acquireContext: function() {},

	/**
	 * Called at chart destruction time, releases any resources associated to the context
	 * previously returned by the acquireContext() method.
	 * @param {CanvasRenderingContext2D} context - The context2d instance
	 * @returns {Boolean} true if the method succeeded, else false
	 */
	releaseContext: function() {},

	/**
	 * Registers the specified listener on the given chart.
	 * @param {Chart} chart - Chart from which to listen for event
	 * @param {String} type - The ({@link IEvent}) type to listen for
	 * @param {Function} listener - Receives a notification (an object that implements
	 * the {@link IEvent} interface) when an event of the specified type occurs.
	 */
	addEventListener: function() {},

	/**
	 * Removes the specified listener previously registered with addEventListener.
	 * @param {Chart} chart -Chart from which to remove the listener
	 * @param {String} type - The ({@link IEvent}) type to remove
	 * @param {Function} listener - The listener function to remove from the event target.
	 */
	removeEventListener: function() {}

}, implementation);

/**
 * @interface IPlatform
 * Allows abstracting platform dependencies away from the chart
 * @borrows Chart.platform.acquireContext as acquireContext
 * @borrows Chart.platform.releaseContext as releaseContext
 * @borrows Chart.platform.addEventListener as addEventListener
 * @borrows Chart.platform.removeEventListener as removeEventListener
 */

/**
 * @interface IEvent
 * @prop {String} type - The event type name, possible values are:
 * 'contextmenu', 'mouseenter', 'mousedown', 'mousemove', 'mouseup', 'mouseout',
 * 'click', 'dblclick', 'keydown', 'keypress', 'keyup' and 'resize'
 * @prop {*} native - The original native event (null for emulated events, e.g. 'resize')
 * @prop {Number} x - The mouse x position, relative to the canvas (null for incompatible events)
 * @prop {Number} y - The mouse y position, relative to the canvas (null for incompatible events)
 */


/***/ }),
/* 293 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var defaults = __webpack_require__(20);
var helpers = __webpack_require__(15);

defaults._set('global', {
	plugins: {}
});

/**
 * The plugin service singleton
 * @namespace Chart.plugins
 * @since 2.1.0
 */
module.exports = {
	/**
	 * Globally registered plugins.
	 * @private
	 */
	_plugins: [],

	/**
	 * This identifier is used to invalidate the descriptors cache attached to each chart
	 * when a global plugin is registered or unregistered. In this case, the cache ID is
	 * incremented and descriptors are regenerated during following API calls.
	 * @private
	 */
	_cacheId: 0,

	/**
	 * Registers the given plugin(s) if not already registered.
	 * @param {Array|Object} plugins plugin instance(s).
	 */
	register: function(plugins) {
		var p = this._plugins;
		([]).concat(plugins).forEach(function(plugin) {
			if (p.indexOf(plugin) === -1) {
				p.push(plugin);
			}
		});

		this._cacheId++;
	},

	/**
	 * Unregisters the given plugin(s) only if registered.
	 * @param {Array|Object} plugins plugin instance(s).
	 */
	unregister: function(plugins) {
		var p = this._plugins;
		([]).concat(plugins).forEach(function(plugin) {
			var idx = p.indexOf(plugin);
			if (idx !== -1) {
				p.splice(idx, 1);
			}
		});

		this._cacheId++;
	},

	/**
	 * Remove all registered plugins.
	 * @since 2.1.5
	 */
	clear: function() {
		this._plugins = [];
		this._cacheId++;
	},

	/**
	 * Returns the number of registered plugins?
	 * @returns {Number}
	 * @since 2.1.5
	 */
	count: function() {
		return this._plugins.length;
	},

	/**
	 * Returns all registered plugin instances.
	 * @returns {Array} array of plugin objects.
	 * @since 2.1.5
	 */
	getAll: function() {
		return this._plugins;
	},

	/**
	 * Calls enabled plugins for `chart` on the specified hook and with the given args.
	 * This method immediately returns as soon as a plugin explicitly returns false. The
	 * returned value can be used, for instance, to interrupt the current action.
	 * @param {Object} chart - The chart instance for which plugins should be called.
	 * @param {String} hook - The name of the plugin method to call (e.g. 'beforeUpdate').
	 * @param {Array} [args] - Extra arguments to apply to the hook call.
	 * @returns {Boolean} false if any of the plugins return false, else returns true.
	 */
	notify: function(chart, hook, args) {
		var descriptors = this.descriptors(chart);
		var ilen = descriptors.length;
		var i, descriptor, plugin, params, method;

		for (i = 0; i < ilen; ++i) {
			descriptor = descriptors[i];
			plugin = descriptor.plugin;
			method = plugin[hook];
			if (typeof method === 'function') {
				params = [chart].concat(args || []);
				params.push(descriptor.options);
				if (method.apply(plugin, params) === false) {
					return false;
				}
			}
		}

		return true;
	},

	/**
	 * Returns descriptors of enabled plugins for the given chart.
	 * @returns {Array} [{ plugin, options }]
	 * @private
	 */
	descriptors: function(chart) {
		var cache = chart.$plugins || (chart.$plugins = {});
		if (cache.id === this._cacheId) {
			return cache.descriptors;
		}

		var plugins = [];
		var descriptors = [];
		var config = (chart && chart.config) || {};
		var options = (config.options && config.options.plugins) || {};

		this._plugins.concat(config.plugins || []).forEach(function(plugin) {
			var idx = plugins.indexOf(plugin);
			if (idx !== -1) {
				return;
			}

			var id = plugin.id;
			var opts = options[id];
			if (opts === false) {
				return;
			}

			if (opts === true) {
				opts = helpers.clone(defaults.global.plugins[id]);
			}

			plugins.push(plugin);
			descriptors.push({
				plugin: plugin,
				options: opts || {}
			});
		});

		cache.descriptors = descriptors;
		cache.id = this._cacheId;
		return descriptors;
	},

	/**
	 * Invalidates cache for the given chart: descriptors hold a reference on plugin option,
	 * but in some cases, this reference can be changed by the user when updating options.
	 * https://github.com/chartjs/Chart.js/issues/5111#issuecomment-355934167
	 * @private
	 */
	_invalidate: function(chart) {
		delete chart.$plugins;
	}
};

/**
 * Plugin extension hooks.
 * @interface IPlugin
 * @since 2.1.0
 */
/**
 * @method IPlugin#beforeInit
 * @desc Called before initializing `chart`.
 * @param {Chart.Controller} chart - The chart instance.
 * @param {Object} options - The plugin options.
 */
/**
 * @method IPlugin#afterInit
 * @desc Called after `chart` has been initialized and before the first update.
 * @param {Chart.Controller} chart - The chart instance.
 * @param {Object} options - The plugin options.
 */
/**
 * @method IPlugin#beforeUpdate
 * @desc Called before updating `chart`. If any plugin returns `false`, the update
 * is cancelled (and thus subsequent render(s)) until another `update` is triggered.
 * @param {Chart.Controller} chart - The chart instance.
 * @param {Object} options - The plugin options.
 * @returns {Boolean} `false` to cancel the chart update.
 */
/**
 * @method IPlugin#afterUpdate
 * @desc Called after `chart` has been updated and before rendering. Note that this
 * hook will not be called if the chart update has been previously cancelled.
 * @param {Chart.Controller} chart - The chart instance.
 * @param {Object} options - The plugin options.
 */
/**
 * @method IPlugin#beforeDatasetsUpdate
 * @desc Called before updating the `chart` datasets. If any plugin returns `false`,
 * the datasets update is cancelled until another `update` is triggered.
 * @param {Chart.Controller} chart - The chart instance.
 * @param {Object} options - The plugin options.
 * @returns {Boolean} false to cancel the datasets update.
 * @since version 2.1.5
*/
/**
 * @method IPlugin#afterDatasetsUpdate
 * @desc Called after the `chart` datasets have been updated. Note that this hook
 * will not be called if the datasets update has been previously cancelled.
 * @param {Chart.Controller} chart - The chart instance.
 * @param {Object} options - The plugin options.
 * @since version 2.1.5
 */
/**
 * @method IPlugin#beforeDatasetUpdate
 * @desc Called before updating the `chart` dataset at the given `args.index`. If any plugin
 * returns `false`, the datasets update is cancelled until another `update` is triggered.
 * @param {Chart} chart - The chart instance.
 * @param {Object} args - The call arguments.
 * @param {Number} args.index - The dataset index.
 * @param {Object} args.meta - The dataset metadata.
 * @param {Object} options - The plugin options.
 * @returns {Boolean} `false` to cancel the chart datasets drawing.
 */
/**
 * @method IPlugin#afterDatasetUpdate
 * @desc Called after the `chart` datasets at the given `args.index` has been updated. Note
 * that this hook will not be called if the datasets update has been previously cancelled.
 * @param {Chart} chart - The chart instance.
 * @param {Object} args - The call arguments.
 * @param {Number} args.index - The dataset index.
 * @param {Object} args.meta - The dataset metadata.
 * @param {Object} options - The plugin options.
 */
/**
 * @method IPlugin#beforeLayout
 * @desc Called before laying out `chart`. If any plugin returns `false`,
 * the layout update is cancelled until another `update` is triggered.
 * @param {Chart.Controller} chart - The chart instance.
 * @param {Object} options - The plugin options.
 * @returns {Boolean} `false` to cancel the chart layout.
 */
/**
 * @method IPlugin#afterLayout
 * @desc Called after the `chart` has been layed out. Note that this hook will not
 * be called if the layout update has been previously cancelled.
 * @param {Chart.Controller} chart - The chart instance.
 * @param {Object} options - The plugin options.
 */
/**
 * @method IPlugin#beforeRender
 * @desc Called before rendering `chart`. If any plugin returns `false`,
 * the rendering is cancelled until another `render` is triggered.
 * @param {Chart.Controller} chart - The chart instance.
 * @param {Object} options - The plugin options.
 * @returns {Boolean} `false` to cancel the chart rendering.
 */
/**
 * @method IPlugin#afterRender
 * @desc Called after the `chart` has been fully rendered (and animation completed). Note
 * that this hook will not be called if the rendering has been previously cancelled.
 * @param {Chart.Controller} chart - The chart instance.
 * @param {Object} options - The plugin options.
 */
/**
 * @method IPlugin#beforeDraw
 * @desc Called before drawing `chart` at every animation frame specified by the given
 * easing value. If any plugin returns `false`, the frame drawing is cancelled until
 * another `render` is triggered.
 * @param {Chart.Controller} chart - The chart instance.
 * @param {Number} easingValue - The current animation value, between 0.0 and 1.0.
 * @param {Object} options - The plugin options.
 * @returns {Boolean} `false` to cancel the chart drawing.
 */
/**
 * @method IPlugin#afterDraw
 * @desc Called after the `chart` has been drawn for the specific easing value. Note
 * that this hook will not be called if the drawing has been previously cancelled.
 * @param {Chart.Controller} chart - The chart instance.
 * @param {Number} easingValue - The current animation value, between 0.0 and 1.0.
 * @param {Object} options - The plugin options.
 */
/**
 * @method IPlugin#beforeDatasetsDraw
 * @desc Called before drawing the `chart` datasets. If any plugin returns `false`,
 * the datasets drawing is cancelled until another `render` is triggered.
 * @param {Chart.Controller} chart - The chart instance.
 * @param {Number} easingValue - The current animation value, between 0.0 and 1.0.
 * @param {Object} options - The plugin options.
 * @returns {Boolean} `false` to cancel the chart datasets drawing.
 */
/**
 * @method IPlugin#afterDatasetsDraw
 * @desc Called after the `chart` datasets have been drawn. Note that this hook
 * will not be called if the datasets drawing has been previously cancelled.
 * @param {Chart.Controller} chart - The chart instance.
 * @param {Number} easingValue - The current animation value, between 0.0 and 1.0.
 * @param {Object} options - The plugin options.
 */
/**
 * @method IPlugin#beforeDatasetDraw
 * @desc Called before drawing the `chart` dataset at the given `args.index` (datasets
 * are drawn in the reverse order). If any plugin returns `false`, the datasets drawing
 * is cancelled until another `render` is triggered.
 * @param {Chart} chart - The chart instance.
 * @param {Object} args - The call arguments.
 * @param {Number} args.index - The dataset index.
 * @param {Object} args.meta - The dataset metadata.
 * @param {Number} args.easingValue - The current animation value, between 0.0 and 1.0.
 * @param {Object} options - The plugin options.
 * @returns {Boolean} `false` to cancel the chart datasets drawing.
 */
/**
 * @method IPlugin#afterDatasetDraw
 * @desc Called after the `chart` datasets at the given `args.index` have been drawn
 * (datasets are drawn in the reverse order). Note that this hook will not be called
 * if the datasets drawing has been previously cancelled.
 * @param {Chart} chart - The chart instance.
 * @param {Object} args - The call arguments.
 * @param {Number} args.index - The dataset index.
 * @param {Object} args.meta - The dataset metadata.
 * @param {Number} args.easingValue - The current animation value, between 0.0 and 1.0.
 * @param {Object} options - The plugin options.
 */
/**
 * @method IPlugin#beforeTooltipDraw
 * @desc Called before drawing the `tooltip`. If any plugin returns `false`,
 * the tooltip drawing is cancelled until another `render` is triggered.
 * @param {Chart} chart - The chart instance.
 * @param {Object} args - The call arguments.
 * @param {Object} args.tooltip - The tooltip.
 * @param {Number} args.easingValue - The current animation value, between 0.0 and 1.0.
 * @param {Object} options - The plugin options.
 * @returns {Boolean} `false` to cancel the chart tooltip drawing.
 */
/**
 * @method IPlugin#afterTooltipDraw
 * @desc Called after drawing the `tooltip`. Note that this hook will not
 * be called if the tooltip drawing has been previously cancelled.
 * @param {Chart} chart - The chart instance.
 * @param {Object} args - The call arguments.
 * @param {Object} args.tooltip - The tooltip.
 * @param {Number} args.easingValue - The current animation value, between 0.0 and 1.0.
 * @param {Object} options - The plugin options.
 */
/**
 * @method IPlugin#beforeEvent
 * @desc Called before processing the specified `event`. If any plugin returns `false`,
 * the event will be discarded.
 * @param {Chart.Controller} chart - The chart instance.
 * @param {IEvent} event - The event object.
 * @param {Object} options - The plugin options.
 */
/**
 * @method IPlugin#afterEvent
 * @desc Called after the `event` has been consumed. Note that this hook
 * will not be called if the `event` has been previously discarded.
 * @param {Chart.Controller} chart - The chart instance.
 * @param {IEvent} event - The event object.
 * @param {Object} options - The plugin options.
 */
/**
 * @method IPlugin#resize
 * @desc Called after the chart as been resized.
 * @param {Chart.Controller} chart - The chart instance.
 * @param {Number} size - The new canvas display size (eq. canvas.style width & height).
 * @param {Object} options - The plugin options.
 */
/**
 * @method IPlugin#destroy
 * @desc Called after the chart as been destroyed.
 * @param {Chart.Controller} chart - The chart instance.
 * @param {Object} options - The plugin options.
 */


/***/ }),
/* 294 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(2);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Collapse.default;
  }
});

var _Collapse = _interopRequireDefault(__webpack_require__(710));

/***/ }),
/* 295 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(9);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(10));

var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
  d: "M16.59 8.59L12 13.17 7.41 8.59 6 10l6 6 6-6z"
}), _react.default.createElement("path", {
  fill: "none",
  d: "M0 0h24v24H0z"
})), 'ExpandMore');

exports.default = _default;

/***/ }),
/* 296 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export SazoFlexComponent */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles_withStyles__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_icons_Assignment__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_icons_Assignment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__material_ui_icons_Assignment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_EnergyCompany_Cards_ECCard_jsx__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_Grid_GridContainer_jsx__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_Grid_GridItem_jsx__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_EnergyCompany_Grid_InfoGrid_jsx__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_EnergyCompany_Grid_InfoGridItem_jsx__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_components_Table_Table_jsx__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_services_utils__ = __webpack_require__(23);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var styles={tableWrapper:{marginTop:"30px"}};var SazoFlex=function SazoFlex(_ref){var checkedAgentProfiles=_ref.checkedAgentProfiles,classes=_ref.classes,title=_ref.title;var getSazonalidadeMinima=function getSazonalidadeMinima(sazonalidadeMinima){var value=Object(__WEBPACK_IMPORTED_MODULE_4_lodash__["round"])(sazonalidadeMinima*100);return value<70?"Sazonalizar mensalmente":value+"%";};var getSazonalidadeMaxima=function getSazonalidadeMaxima(sazonalidadeMaxima){var value=Object(__WEBPACK_IMPORTED_MODULE_4_lodash__["round"])(sazonalidadeMaxima*100);return value>130?"Sazonalizar mensalmente":value+"%";};var calculateMWMedioPerMonth=function calculateMWMedioPerMonth(){var mWMedioPerMonth={};Object(__WEBPACK_IMPORTED_MODULE_4_lodash__["forEach"])(checkedAgentProfiles,function(agentProfile){Object(__WEBPACK_IMPORTED_MODULE_4_lodash__["forEach"])(agentProfile.energiesValues,function(data,month){mWMedioPerMonth[month]=mWMedioPerMonth[month]||{leve:0,medio:0,pesado:0,total:0};mWMedioPerMonth[month].leve+=Object(__WEBPACK_IMPORTED_MODULE_4_lodash__["get"])(data.consumoMWMedPorPatamar,"leve",0);mWMedioPerMonth[month].medio+=Object(__WEBPACK_IMPORTED_MODULE_4_lodash__["get"])(data.consumoMWMedPorPatamar,"medio",0);mWMedioPerMonth[month].pesado+=Object(__WEBPACK_IMPORTED_MODULE_4_lodash__["get"])(data.consumoMWMedPorPatamar,"pesado",0);mWMedioPerMonth[month].total+=Object(__WEBPACK_IMPORTED_MODULE_4_lodash__["get"])(data.consumoMWMedPorPatamar,"total",0);});});return mWMedioPerMonth;};var calculateModulacoes=function calculateModulacoes(mWMedioPerMonth){var modulacoes={};Object(__WEBPACK_IMPORTED_MODULE_4_lodash__["forEach"])(mWMedioPerMonth,function(data,month){modulacoes[month]=modulacoes[month]||{leve:0,medio:0,pesado:0};modulacoes[month].leve=data.leve/data.total||0;modulacoes[month].medio=data.medio/data.total||0;modulacoes[month].pesado=data.pesado/data.total||0;});return modulacoes;};var calculateModulacaoMinMax=function calculateModulacaoMinMax(modulacoes){var data=Object(__WEBPACK_IMPORTED_MODULE_4_lodash__["chain"])(modulacoes).values().map(function(monthData){return Object(__WEBPACK_IMPORTED_MODULE_4_lodash__["values"])(monthData);}).flatten().orderBy().value();return[Object(__WEBPACK_IMPORTED_MODULE_4_lodash__["first"])(data)*100,Object(__WEBPACK_IMPORTED_MODULE_4_lodash__["last"])(data)*100];};var calculateConsumoMinMax=function calculateConsumoMinMax(mWMedioPerMonth){var data=Object(__WEBPACK_IMPORTED_MODULE_4_lodash__["chain"])(mWMedioPerMonth).values().map(function(monthData){return monthData.total;}).orderBy().value();return[Object(__WEBPACK_IMPORTED_MODULE_4_lodash__["first"])(data),Object(__WEBPACK_IMPORTED_MODULE_4_lodash__["last"])(data)];};var calculateRecursoTotal=function calculateRecursoTotal(){var recursoTotal=0;Object(__WEBPACK_IMPORTED_MODULE_4_lodash__["forEach"])(checkedAgentProfiles,function(agentProfile){return Object(__WEBPACK_IMPORTED_MODULE_4_lodash__["forEach"])(agentProfile.energiesValues,function(data){return recursoTotal+=data.recurso;});});return recursoTotal;};var getTableData=function getTableData(mWMedioPerMonth){return Object(__WEBPACK_IMPORTED_MODULE_4_lodash__["map"])(mWMedioPerMonth,function(value,key){return[__WEBPACK_IMPORTED_MODULE_0_moment___default()(key).format("MMM Y"),Object(__WEBPACK_IMPORTED_MODULE_12_services_utils__["f" /* localeString */])(value.leve),Object(__WEBPACK_IMPORTED_MODULE_12_services_utils__["f" /* localeString */])(value.medio),Object(__WEBPACK_IMPORTED_MODULE_12_services_utils__["f" /* localeString */])(value.pesado),Object(__WEBPACK_IMPORTED_MODULE_12_services_utils__["f" /* localeString */])(value.total)];});};var selectedSubmarkets=Object(__WEBPACK_IMPORTED_MODULE_4_lodash__["orderBy"])(Object(__WEBPACK_IMPORTED_MODULE_4_lodash__["uniq"])(Object(__WEBPACK_IMPORTED_MODULE_4_lodash__["map"])(checkedAgentProfiles,'submarket')));var mWMedioPerMonth=calculateMWMedioPerMonth();var montante=Object(__WEBPACK_IMPORTED_MODULE_4_lodash__["reduce"])(Object(__WEBPACK_IMPORTED_MODULE_4_lodash__["values"])(mWMedioPerMonth),function(sum,data){return sum+data.total;},0)/Object(__WEBPACK_IMPORTED_MODULE_4_lodash__["values"])(mWMedioPerMonth).length;var modulacoes=calculateModulacoes(mWMedioPerMonth);var _calculateModulacaoMi=calculateModulacaoMinMax(modulacoes),_calculateModulacaoMi2=_slicedToArray(_calculateModulacaoMi,2),modulacaoMinima=_calculateModulacaoMi2[0],modulacaoMaxima=_calculateModulacaoMi2[1];var _calculateConsumoMinM=calculateConsumoMinMax(mWMedioPerMonth),_calculateConsumoMinM2=_slicedToArray(_calculateConsumoMinM,2),consumoMinimo=_calculateConsumoMinM2[0],consumoMaximo=_calculateConsumoMinM2[1];var recursoTotal=calculateRecursoTotal();var sazonalidadeMaxima=consumoMaximo/consumoMinimo;var sazonalidadeMinima=2-sazonalidadeMaxima;var shouldShow=!!Object(__WEBPACK_IMPORTED_MODULE_4_lodash__["values"])(mWMedioPerMonth).length;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_Grid_GridContainer_jsx__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_Grid_GridItem_jsx__["a" /* default */],{md:12,sm:12,xs:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_EnergyCompany_Cards_ECCard_jsx__["a" /* default */],{content:consumoMaximo===0?recursoTotal===0?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("h4",null,"Agente sem ponto de carga associada."):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("h4",null,"Agente sem ponto de carga associada. O recurso deste agente pode estar sendo utilizado por outro agente."):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_EnergyCompany_Grid_InfoGrid_jsx__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_EnergyCompany_Grid_InfoGridItem_jsx__["a" /* default */],{label:"Montante",value:shouldShow&&Object(__WEBPACK_IMPORTED_MODULE_12_services_utils__["f" /* localeString */])(montante)+" MW M\xE9dio"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_EnergyCompany_Grid_InfoGridItem_jsx__["a" /* default */],{label:"Flexibilidade M\xE1xima",value:shouldShow&&Object(__WEBPACK_IMPORTED_MODULE_4_lodash__["round"])(consumoMaximo/montante*100)+"%"})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_EnergyCompany_Grid_InfoGrid_jsx__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_EnergyCompany_Grid_InfoGridItem_jsx__["a" /* default */],{label:"Submercado",value:selectedSubmarkets.join(", ")}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_EnergyCompany_Grid_InfoGridItem_jsx__["a" /* default */],{label:"Flexibilidade M\xEDnima",value:shouldShow&&Object(__WEBPACK_IMPORTED_MODULE_4_lodash__["round"])(consumoMinimo/montante*100)+"%"})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_EnergyCompany_Grid_InfoGrid_jsx__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_EnergyCompany_Grid_InfoGridItem_jsx__["a" /* default */],{label:"Modula\xE7\xE3o M\xE1xima",value:shouldShow&&Object(__WEBPACK_IMPORTED_MODULE_4_lodash__["round"])(modulacaoMaxima)+"%"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_EnergyCompany_Grid_InfoGridItem_jsx__["a" /* default */],{label:"Sazonalidade M\xE1xima",value:shouldShow&&getSazonalidadeMaxima(sazonalidadeMaxima)})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_EnergyCompany_Grid_InfoGrid_jsx__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_EnergyCompany_Grid_InfoGridItem_jsx__["a" /* default */],{label:"Modula\xE7\xE3o M\xEDnima",value:shouldShow&&Object(__WEBPACK_IMPORTED_MODULE_4_lodash__["round"])(modulacaoMinima)+"%"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_EnergyCompany_Grid_InfoGridItem_jsx__["a" /* default */],{label:"Sazonalidade M\xEDnima",value:shouldShow&&getSazonalidadeMinima(sazonalidadeMinima)})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:classes.tableWrapper},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components_Table_Table_jsx__["a" /* default */],{tableData:getTableData(mWMedioPerMonth),tableHead:["Mês","Leve","Médio","Pesado","Total"],tableHeaderColor:"primary"}))),icon:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_icons_Assignment___default.a,null),title:title})));};SazoFlex.defaultProps={title:"Perfil de Contratação Sugerida"};SazoFlex.propTypes={checkedAgentProfiles:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({submarket:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired})).isRequired,classes:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired,title:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string};/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles_withStyles___default()(styles)(SazoFlex));

/***/ }),
/* 297 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__material_ui_icons_Info__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__material_ui_icons_Info___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__material_ui_icons_Info__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_Tooltip__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_Tooltip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Tooltip__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_styles_withStyles__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_styles_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_styles_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_assets_EnergyCompany_jss_lightTooltip__ = __webpack_require__(76);
var styles=function styles(theme){return Object.assign({},Object(__WEBPACK_IMPORTED_MODULE_5_assets_EnergyCompany_jss_lightTooltip__["a" /* default */])(theme),{tooltipWrapper:Object.assign({},Object(__WEBPACK_IMPORTED_MODULE_5_assets_EnergyCompany_jss_lightTooltip__["a" /* default */])(theme).tooltipContentWrapper,{alignItems:"flex-end"}),tooltipContent:{alignItems:"flex-start",display:"flex",flexDirection:"column","& span":{marginLeft:"15px"}}});};var UsinaTooltip=function UsinaTooltip(_ref){var classes=_ref.classes,shouldShow=_ref.shouldShow,title=_ref.title;return shouldShow?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Tooltip___default.a,{classes:{popper:classes.lightTooltipPopper,tooltip:classes.lightTooltip},placement:"top",title:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:classes.tooltipContent},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("h4",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("b",null,"N\xE3o estamos considerando:")),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span",null,"MRGF/fator de disponibilidade (exceto usinas sem GF definida)"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span",null,"Perdas internas (usinas fora do MRE)"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span",null,"A sazonaliza\xE7\xE3o das usinas (usinas fora do MRE)"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span",null,"O fator de capacidade m\xE1xima e nem o \xEDndice de disponibilidade verificado (usinas n\xE3o hidr\xE1ulicas sem GF definida com despacho IA ou IIA)"))},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span",{className:classes.tooltipWrapper},title," ",__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_icons_Info___default.a,null))):title;};UsinaTooltip.propTypes={classes:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired,shouldShow:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool.isRequired,title:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired};/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_4__material_ui_core_styles_withStyles___default()(styles)(UsinaTooltip));

/***/ }),
/* 298 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(2);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _LinearProgress.default;
  }
});

var _LinearProgress = _interopRequireDefault(__webpack_require__(724));

/***/ }),
/* 299 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

/***/ }),
/* 300 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has = __webpack_require__(64);
var toObject = __webpack_require__(108);
var IE_PROTO = __webpack_require__(193)('IE_PROTO');
var ObjectProto = Object.prototype;

module.exports = Object.getPrototypeOf || function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto : null;
};


/***/ }),
/* 301 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__(59) && !__webpack_require__(83)(function () {
  return Object.defineProperty(__webpack_require__(302)('div'), 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 302 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(82);
var document = __webpack_require__(56).document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};


/***/ }),
/* 303 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(734), __esModule: true };

/***/ }),
/* 304 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _iterator = __webpack_require__(736);

var _iterator2 = _interopRequireDefault(_iterator);

var _symbol = __webpack_require__(748);

var _symbol2 = _interopRequireDefault(_symbol);

var _typeof = typeof _symbol2.default === "function" && typeof _iterator2.default === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = typeof _symbol2.default === "function" && _typeof(_iterator2.default) === "symbol" ? function (obj) {
  return typeof obj === "undefined" ? "undefined" : _typeof(obj);
} : function (obj) {
  return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof(obj);
};

/***/ }),
/* 305 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $at = __webpack_require__(738)(true);

// 21.1.3.27 String.prototype[@@iterator]()
__webpack_require__(306)(String, 'String', function (iterated) {
  this._t = String(iterated); // target
  this._i = 0;                // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var index = this._i;
  var point;
  if (index >= O.length) return { value: undefined, done: true };
  point = $at(O, index);
  this._i += point.length;
  return { value: point, done: false };
});


/***/ }),
/* 306 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(138);
var $export = __webpack_require__(57);
var redefine = __webpack_require__(307);
var hide = __webpack_require__(80);
var Iterators = __webpack_require__(110);
var $iterCreate = __webpack_require__(739);
var setToStringTag = __webpack_require__(201);
var getPrototypeOf = __webpack_require__(300);
var ITERATOR = __webpack_require__(47)('iterator');
var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var FF_ITERATOR = '@@iterator';
var KEYS = 'keys';
var VALUES = 'values';

var returnThis = function () { return this; };

module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
  $iterCreate(Constructor, NAME, next);
  var getMethod = function (kind) {
    if (!BUGGY && kind in proto) return proto[kind];
    switch (kind) {
      case KEYS: return function keys() { return new Constructor(this, kind); };
      case VALUES: return function values() { return new Constructor(this, kind); };
    } return function entries() { return new Constructor(this, kind); };
  };
  var TAG = NAME + ' Iterator';
  var DEF_VALUES = DEFAULT == VALUES;
  var VALUES_BUG = false;
  var proto = Base.prototype;
  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
  var $default = $native || getMethod(DEFAULT);
  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
  var methods, key, IteratorPrototype;
  // Fix native
  if ($anyNative) {
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
      // Set @@toStringTag to native iterators
      setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEF_VALUES && $native && $native.name !== VALUES) {
    VALUES_BUG = true;
    $default = function values() { return $native.call(this); };
  }
  // Define iterator
  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG] = returnThis;
  if (DEFAULT) {
    methods = {
      values: DEF_VALUES ? $default : getMethod(VALUES),
      keys: IS_SET ? $default : getMethod(KEYS),
      entries: $entries
    };
    if (FORCED) for (key in methods) {
      if (!(key in proto)) redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};


/***/ }),
/* 307 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(80);


/***/ }),
/* 308 */
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__(64);
var toIObject = __webpack_require__(84);
var arrayIndexOf = __webpack_require__(741)(false);
var IE_PROTO = __webpack_require__(193)('IE_PROTO');

module.exports = function (object, names) {
  var O = toIObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};


/***/ }),
/* 309 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__(199);
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};


/***/ }),
/* 310 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.15 ToLength
var toInteger = __webpack_require__(197);
var min = Math.min;
module.exports = function (it) {
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};


/***/ }),
/* 311 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
var $keys = __webpack_require__(308);
var hiddenKeys = __webpack_require__(200).concat('length', 'prototype');

exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return $keys(O, hiddenKeys);
};


/***/ }),
/* 312 */
/***/ (function(module, exports, __webpack_require__) {

var pIE = __webpack_require__(141);
var createDesc = __webpack_require__(109);
var toIObject = __webpack_require__(84);
var toPrimitive = __webpack_require__(196);
var has = __webpack_require__(64);
var IE8_DOM_DEFINE = __webpack_require__(301);
var gOPD = Object.getOwnPropertyDescriptor;

exports.f = __webpack_require__(59) ? gOPD : function getOwnPropertyDescriptor(O, P) {
  O = toIObject(O);
  P = toPrimitive(P, true);
  if (IE8_DOM_DEFINE) try {
    return gOPD(O, P);
  } catch (e) { /* empty */ }
  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
};


/***/ }),
/* 313 */
/***/ (function(module, exports, __webpack_require__) {

var baseSetToString = __webpack_require__(766),
    shortOut = __webpack_require__(317);

/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var setToString = shortOut(baseSetToString);

module.exports = setToString;


/***/ }),
/* 314 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(65);

var defineProperty = (function() {
  try {
    var func = getNative(Object, 'defineProperty');
    func({}, '', {});
    return func;
  } catch (e) {}
}());

module.exports = defineProperty;


/***/ }),
/* 315 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

module.exports = freeGlobal;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(36)))

/***/ }),
/* 316 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var funcProto = Function.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

module.exports = toSource;


/***/ }),
/* 317 */
/***/ (function(module, exports) {

/** Used to detect hot functions by number of calls within a span of milliseconds. */
var HOT_COUNT = 800,
    HOT_SPAN = 16;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeNow = Date.now;

/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */
function shortOut(func) {
  var count = 0,
      lastCalled = 0;

  return function() {
    var stamp = nativeNow(),
        remaining = HOT_SPAN - (stamp - lastCalled);

    lastCalled = stamp;
    if (remaining > 0) {
      if (++count >= HOT_COUNT) {
        return arguments[0];
      }
    } else {
      count = 0;
    }
    return func.apply(undefined, arguments);
  };
}

module.exports = shortOut;


/***/ }),
/* 318 */
/***/ (function(module, exports, __webpack_require__) {

var identity = __webpack_require__(111),
    metaMap = __webpack_require__(319);

/**
 * The base implementation of `setData` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to associate metadata with.
 * @param {*} data The metadata.
 * @returns {Function} Returns `func`.
 */
var baseSetData = !metaMap ? identity : function(func, data) {
  metaMap.set(func, data);
  return func;
};

module.exports = baseSetData;


/***/ }),
/* 319 */
/***/ (function(module, exports, __webpack_require__) {

var WeakMap = __webpack_require__(320);

/** Used to store function metadata. */
var metaMap = WeakMap && new WeakMap;

module.exports = metaMap;


/***/ }),
/* 320 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(65),
    root = __webpack_require__(38);

/* Built-in method references that are verified to be native. */
var WeakMap = getNative(root, 'WeakMap');

module.exports = WeakMap;


/***/ }),
/* 321 */
/***/ (function(module, exports, __webpack_require__) {

var composeArgs = __webpack_require__(322),
    composeArgsRight = __webpack_require__(323),
    countHolders = __webpack_require__(777),
    createCtor = __webpack_require__(145),
    createRecurry = __webpack_require__(324),
    getHolder = __webpack_require__(210),
    reorder = __webpack_require__(792),
    replaceHolders = __webpack_require__(147),
    root = __webpack_require__(38);

/** Used to compose bitmasks for function metadata. */
var WRAP_BIND_FLAG = 1,
    WRAP_BIND_KEY_FLAG = 2,
    WRAP_CURRY_FLAG = 8,
    WRAP_CURRY_RIGHT_FLAG = 16,
    WRAP_ARY_FLAG = 128,
    WRAP_FLIP_FLAG = 512;

/**
 * Creates a function that wraps `func` to invoke it with optional `this`
 * binding of `thisArg`, partial application, and currying.
 *
 * @private
 * @param {Function|string} func The function or method name to wrap.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @param {*} [thisArg] The `this` binding of `func`.
 * @param {Array} [partials] The arguments to prepend to those provided to
 *  the new function.
 * @param {Array} [holders] The `partials` placeholder indexes.
 * @param {Array} [partialsRight] The arguments to append to those provided
 *  to the new function.
 * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
 * @param {Array} [argPos] The argument positions of the new function.
 * @param {number} [ary] The arity cap of `func`.
 * @param {number} [arity] The arity of `func`.
 * @returns {Function} Returns the new wrapped function.
 */
function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
  var isAry = bitmask & WRAP_ARY_FLAG,
      isBind = bitmask & WRAP_BIND_FLAG,
      isBindKey = bitmask & WRAP_BIND_KEY_FLAG,
      isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG),
      isFlip = bitmask & WRAP_FLIP_FLAG,
      Ctor = isBindKey ? undefined : createCtor(func);

  function wrapper() {
    var length = arguments.length,
        args = Array(length),
        index = length;

    while (index--) {
      args[index] = arguments[index];
    }
    if (isCurried) {
      var placeholder = getHolder(wrapper),
          holdersCount = countHolders(args, placeholder);
    }
    if (partials) {
      args = composeArgs(args, partials, holders, isCurried);
    }
    if (partialsRight) {
      args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
    }
    length -= holdersCount;
    if (isCurried && length < arity) {
      var newHolders = replaceHolders(args, placeholder);
      return createRecurry(
        func, bitmask, createHybrid, wrapper.placeholder, thisArg,
        args, newHolders, argPos, ary, arity - length
      );
    }
    var thisBinding = isBind ? thisArg : this,
        fn = isBindKey ? thisBinding[func] : func;

    length = args.length;
    if (argPos) {
      args = reorder(args, argPos);
    } else if (isFlip && length > 1) {
      args.reverse();
    }
    if (isAry && ary < length) {
      args.length = ary;
    }
    if (this && this !== root && this instanceof wrapper) {
      fn = Ctor || createCtor(fn);
    }
    return fn.apply(thisBinding, args);
  }
  return wrapper;
}

module.exports = createHybrid;


/***/ }),
/* 322 */
/***/ (function(module, exports) {

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * Creates an array that is the composition of partially applied arguments,
 * placeholders, and provided arguments into a single array of arguments.
 *
 * @private
 * @param {Array} args The provided arguments.
 * @param {Array} partials The arguments to prepend to those provided.
 * @param {Array} holders The `partials` placeholder indexes.
 * @params {boolean} [isCurried] Specify composing for a curried function.
 * @returns {Array} Returns the new array of composed arguments.
 */
function composeArgs(args, partials, holders, isCurried) {
  var argsIndex = -1,
      argsLength = args.length,
      holdersLength = holders.length,
      leftIndex = -1,
      leftLength = partials.length,
      rangeLength = nativeMax(argsLength - holdersLength, 0),
      result = Array(leftLength + rangeLength),
      isUncurried = !isCurried;

  while (++leftIndex < leftLength) {
    result[leftIndex] = partials[leftIndex];
  }
  while (++argsIndex < holdersLength) {
    if (isUncurried || argsIndex < argsLength) {
      result[holders[argsIndex]] = args[argsIndex];
    }
  }
  while (rangeLength--) {
    result[leftIndex++] = args[argsIndex++];
  }
  return result;
}

module.exports = composeArgs;


/***/ }),
/* 323 */
/***/ (function(module, exports) {

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * This function is like `composeArgs` except that the arguments composition
 * is tailored for `_.partialRight`.
 *
 * @private
 * @param {Array} args The provided arguments.
 * @param {Array} partials The arguments to append to those provided.
 * @param {Array} holders The `partials` placeholder indexes.
 * @params {boolean} [isCurried] Specify composing for a curried function.
 * @returns {Array} Returns the new array of composed arguments.
 */
function composeArgsRight(args, partials, holders, isCurried) {
  var argsIndex = -1,
      argsLength = args.length,
      holdersIndex = -1,
      holdersLength = holders.length,
      rightIndex = -1,
      rightLength = partials.length,
      rangeLength = nativeMax(argsLength - holdersLength, 0),
      result = Array(rangeLength + rightLength),
      isUncurried = !isCurried;

  while (++argsIndex < rangeLength) {
    result[argsIndex] = args[argsIndex];
  }
  var offset = argsIndex;
  while (++rightIndex < rightLength) {
    result[offset + rightIndex] = partials[rightIndex];
  }
  while (++holdersIndex < holdersLength) {
    if (isUncurried || argsIndex < argsLength) {
      result[offset + holders[holdersIndex]] = args[argsIndex++];
    }
  }
  return result;
}

module.exports = composeArgsRight;


/***/ }),
/* 324 */
/***/ (function(module, exports, __webpack_require__) {

var isLaziable = __webpack_require__(778),
    setData = __webpack_require__(328),
    setWrapToString = __webpack_require__(329);

/** Used to compose bitmasks for function metadata. */
var WRAP_BIND_FLAG = 1,
    WRAP_BIND_KEY_FLAG = 2,
    WRAP_CURRY_BOUND_FLAG = 4,
    WRAP_CURRY_FLAG = 8,
    WRAP_PARTIAL_FLAG = 32,
    WRAP_PARTIAL_RIGHT_FLAG = 64;

/**
 * Creates a function that wraps `func` to continue currying.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @param {Function} wrapFunc The function to create the `func` wrapper.
 * @param {*} placeholder The placeholder value.
 * @param {*} [thisArg] The `this` binding of `func`.
 * @param {Array} [partials] The arguments to prepend to those provided to
 *  the new function.
 * @param {Array} [holders] The `partials` placeholder indexes.
 * @param {Array} [argPos] The argument positions of the new function.
 * @param {number} [ary] The arity cap of `func`.
 * @param {number} [arity] The arity of `func`.
 * @returns {Function} Returns the new wrapped function.
 */
function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
  var isCurry = bitmask & WRAP_CURRY_FLAG,
      newHolders = isCurry ? holders : undefined,
      newHoldersRight = isCurry ? undefined : holders,
      newPartials = isCurry ? partials : undefined,
      newPartialsRight = isCurry ? undefined : partials;

  bitmask |= (isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG);
  bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);

  if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) {
    bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
  }
  var newData = [
    func, bitmask, thisArg, newPartials, newHolders, newPartialsRight,
    newHoldersRight, argPos, ary, arity
  ];

  var result = wrapFunc.apply(undefined, newData);
  if (isLaziable(func)) {
    setData(result, newData);
  }
  result.placeholder = placeholder;
  return setWrapToString(result, func, bitmask);
}

module.exports = createRecurry;


/***/ }),
/* 325 */
/***/ (function(module, exports, __webpack_require__) {

var metaMap = __webpack_require__(319),
    noop = __webpack_require__(779);

/**
 * Gets metadata for `func`.
 *
 * @private
 * @param {Function} func The function to query.
 * @returns {*} Returns the metadata for `func`.
 */
var getData = !metaMap ? noop : function(func) {
  return metaMap.get(func);
};

module.exports = getData;


/***/ }),
/* 326 */
/***/ (function(module, exports, __webpack_require__) {

var baseCreate = __webpack_require__(207),
    baseLodash = __webpack_require__(209);

/**
 * The base constructor for creating `lodash` wrapper objects.
 *
 * @private
 * @param {*} value The value to wrap.
 * @param {boolean} [chainAll] Enable explicit method chain sequences.
 */
function LodashWrapper(value, chainAll) {
  this.__wrapped__ = value;
  this.__actions__ = [];
  this.__chain__ = !!chainAll;
  this.__index__ = 0;
  this.__values__ = undefined;
}

LodashWrapper.prototype = baseCreate(baseLodash.prototype);
LodashWrapper.prototype.constructor = LodashWrapper;

module.exports = LodashWrapper;


/***/ }),
/* 327 */
/***/ (function(module, exports) {

/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */
function copyArray(source, array) {
  var index = -1,
      length = source.length;

  array || (array = Array(length));
  while (++index < length) {
    array[index] = source[index];
  }
  return array;
}

module.exports = copyArray;


/***/ }),
/* 328 */
/***/ (function(module, exports, __webpack_require__) {

var baseSetData = __webpack_require__(318),
    shortOut = __webpack_require__(317);

/**
 * Sets metadata for `func`.
 *
 * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
 * period of time, it will trip its breaker and transition to an identity
 * function to avoid garbage collection pauses in V8. See
 * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
 * for more details.
 *
 * @private
 * @param {Function} func The function to associate metadata with.
 * @param {*} data The metadata.
 * @returns {Function} Returns `func`.
 */
var setData = shortOut(baseSetData);

module.exports = setData;


/***/ }),
/* 329 */
/***/ (function(module, exports, __webpack_require__) {

var getWrapDetails = __webpack_require__(784),
    insertWrapDetails = __webpack_require__(785),
    setToString = __webpack_require__(313),
    updateWrapDetails = __webpack_require__(786);

/**
 * Sets the `toString` method of `wrapper` to mimic the source of `reference`
 * with wrapper details in a comment at the top of the source body.
 *
 * @private
 * @param {Function} wrapper The function to modify.
 * @param {Function} reference The reference function.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @returns {Function} Returns `wrapper`.
 */
function setWrapToString(wrapper, reference, bitmask) {
  var source = (reference + '');
  return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
}

module.exports = setWrapToString;


/***/ }),
/* 330 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */
function arrayEach(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (iteratee(array[index], index, array) === false) {
      break;
    }
  }
  return array;
}

module.exports = arrayEach;


/***/ }),
/* 331 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(66),
    isSymbol = __webpack_require__(148);

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** Used to match leading and trailing whitespace. */
var reTrim = /^\s+|\s+$/g;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim, '');
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

module.exports = toNumber;


/***/ }),
/* 332 */
/***/ (function(module, exports) {

var canUseDOM = !!(
  typeof window !== 'undefined' &&
  window.document &&
  window.document.createElement
);

module.exports = canUseDOM;

/***/ }),
/* 333 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "mapProps", function() { return mapProps; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "withProps", function() { return withProps; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "withPropsOnChange", function() { return withPropsOnChange; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "withHandlers", function() { return withHandlers; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "defaultProps", function() { return defaultProps; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "renameProp", function() { return renameProp; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "renameProps", function() { return renameProps; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "flattenProp", function() { return flattenProp; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "withState", function() { return withState; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "withStateHandlers", function() { return withStateHandlers; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "withReducer", function() { return withReducer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "branch", function() { return branch; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "renderComponent", function() { return renderComponent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "renderNothing", function() { return renderNothing; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "shouldUpdate", function() { return shouldUpdate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "pure", function() { return pure; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "onlyUpdateForKeys", function() { return onlyUpdateForKeys; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "onlyUpdateForPropTypes", function() { return onlyUpdateForPropTypes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "withContext", function() { return withContext; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getContext", function() { return getContext; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "lifecycle", function() { return lifecycle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "toClass", function() { return toClass; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setStatic", function() { return setStatic; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setPropTypes", function() { return setPropTypes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setDisplayName", function() { return setDisplayName; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "compose", function() { return compose; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getDisplayName", function() { return getDisplayName; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "wrapDisplayName", function() { return wrapDisplayName; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isClassComponent", function() { return isClassComponent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createSink", function() { return createSink; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "componentFromProp", function() { return componentFromProp; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "nest", function() { return nest; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "hoistStatics", function() { return hoistStatics; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "componentFromStream", function() { return componentFromStream; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "componentFromStreamWithConfig", function() { return componentFromStreamWithConfig; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "mapPropsStream", function() { return mapPropsStream; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "mapPropsStreamWithConfig", function() { return mapPropsStreamWithConfig; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createEventHandler", function() { return createEventHandler; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createEventHandlerWithConfig", function() { return createEventHandlerWithConfig; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setObservableConfig", function() { return configureObservable; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_fbjs_lib_shallowEqual__ = __webpack_require__(158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_fbjs_lib_shallowEqual___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_fbjs_lib_shallowEqual__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_change_emitter__ = __webpack_require__(797);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_change_emitter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_change_emitter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_symbol_observable__ = __webpack_require__(798);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_symbol_observable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_symbol_observable__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "shallowEqual", function() { return __WEBPACK_IMPORTED_MODULE_1_fbjs_lib_shallowEqual___default.a; });






var setStatic = function setStatic(key, value) {
  return function (BaseComponent) {
    /* eslint-disable no-param-reassign */
    BaseComponent[key] = value;
    /* eslint-enable no-param-reassign */
    return BaseComponent;
  };
};

var setDisplayName = function setDisplayName(displayName) {
  return setStatic('displayName', displayName);
};

var getDisplayName = function getDisplayName(Component$$1) {
  if (typeof Component$$1 === 'string') {
    return Component$$1;
  }

  if (!Component$$1) {
    return undefined;
  }

  return Component$$1.displayName || Component$$1.name || 'Component';
};

var wrapDisplayName = function wrapDisplayName(BaseComponent, hocName) {
  return hocName + '(' + getDisplayName(BaseComponent) + ')';
};

var mapProps = function mapProps(propsMapper) {
  return function (BaseComponent) {
    var factory = Object(__WEBPACK_IMPORTED_MODULE_0_react__["createFactory"])(BaseComponent);
    var MapProps = function MapProps(props) {
      return factory(propsMapper(props));
    };
    if (false) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'mapProps'))(MapProps);
    }
    return MapProps;
  };
};

var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};









var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};



var inherits = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};









var objectWithoutProperties = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

var possibleConstructorReturn = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};

var withProps = function withProps(input) {
  var hoc = mapProps(function (props) {
    return _extends({}, props, typeof input === 'function' ? input(props) : input);
  });
  if (false) {
    return function (BaseComponent) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'withProps'))(hoc(BaseComponent));
    };
  }
  return hoc;
};

var pick = function pick(obj, keys) {
  var result = {};
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    if (obj.hasOwnProperty(key)) {
      result[key] = obj[key];
    }
  }
  return result;
};

var withPropsOnChange = function withPropsOnChange(shouldMapOrKeys, propsMapper) {
  return function (BaseComponent) {
    var factory = Object(__WEBPACK_IMPORTED_MODULE_0_react__["createFactory"])(BaseComponent);
    var shouldMap = typeof shouldMapOrKeys === 'function' ? shouldMapOrKeys : function (props, nextProps) {
      return !__WEBPACK_IMPORTED_MODULE_1_fbjs_lib_shallowEqual___default()(pick(props, shouldMapOrKeys), pick(nextProps, shouldMapOrKeys));
    };

    var WithPropsOnChange = function (_Component) {
      inherits(WithPropsOnChange, _Component);

      function WithPropsOnChange() {
        var _temp, _this, _ret;

        classCallCheck(this, WithPropsOnChange);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.computedProps = propsMapper(_this.props), _temp), possibleConstructorReturn(_this, _ret);
      }

      WithPropsOnChange.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
        if (shouldMap(this.props, nextProps)) {
          this.computedProps = propsMapper(nextProps);
        }
      };

      WithPropsOnChange.prototype.render = function render() {
        return factory(_extends({}, this.props, this.computedProps));
      };

      return WithPropsOnChange;
    }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

    if (false) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'withPropsOnChange'))(WithPropsOnChange);
    }
    return WithPropsOnChange;
  };
};

var mapValues = function mapValues(obj, func) {
  var result = {};
  /* eslint-disable no-restricted-syntax */
  for (var key in obj) {
    if (obj.hasOwnProperty(key)) {
      result[key] = func(obj[key], key);
    }
  }
  /* eslint-enable no-restricted-syntax */
  return result;
};

/* eslint-disable no-console */
var withHandlers = function withHandlers(handlers) {
  return function (BaseComponent) {
    var factory = Object(__WEBPACK_IMPORTED_MODULE_0_react__["createFactory"])(BaseComponent);

    var WithHandlers = function (_Component) {
      inherits(WithHandlers, _Component);

      function WithHandlers() {
        var _temp, _this, _ret;

        classCallCheck(this, WithHandlers);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _initialiseProps.call(_this), _temp), possibleConstructorReturn(_this, _ret);
      }

      WithHandlers.prototype.componentWillReceiveProps = function componentWillReceiveProps() {
        this.cachedHandlers = {};
      };

      WithHandlers.prototype.render = function render() {
        return factory(_extends({}, this.props, this.handlers));
      };

      return WithHandlers;
    }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

    var _initialiseProps = function _initialiseProps() {
      var _this2 = this;

      this.cachedHandlers = {};
      this.handlers = mapValues(typeof handlers === 'function' ? handlers(this.props) : handlers, function (createHandler, handlerName) {
        return function () {
          var cachedHandler = _this2.cachedHandlers[handlerName];
          if (cachedHandler) {
            return cachedHandler.apply(undefined, arguments);
          }

          var handler = createHandler(_this2.props);
          _this2.cachedHandlers[handlerName] = handler;

          if (false) {
            console.error(
            // eslint-disable-line no-console
            'withHandlers(): Expected a map of higher-order functions. ' + 'Refer to the docs for more info.');
          }

          return handler.apply(undefined, arguments);
        };
      });
    };

    if (false) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'withHandlers'))(WithHandlers);
    }
    return WithHandlers;
  };
};

var defaultProps = function defaultProps(props) {
  return function (BaseComponent) {
    var factory = Object(__WEBPACK_IMPORTED_MODULE_0_react__["createFactory"])(BaseComponent);
    var DefaultProps = function DefaultProps(ownerProps) {
      return factory(ownerProps);
    };
    DefaultProps.defaultProps = props;
    if (false) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'defaultProps'))(DefaultProps);
    }
    return DefaultProps;
  };
};

var omit = function omit(obj, keys) {
  var rest = objectWithoutProperties(obj, []);

  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    if (rest.hasOwnProperty(key)) {
      delete rest[key];
    }
  }
  return rest;
};

var renameProp = function renameProp(oldName, newName) {
  var hoc = mapProps(function (props) {
    var _babelHelpers$extends;

    return _extends({}, omit(props, [oldName]), (_babelHelpers$extends = {}, _babelHelpers$extends[newName] = props[oldName], _babelHelpers$extends));
  });
  if (false) {
    return function (BaseComponent) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'renameProp'))(hoc(BaseComponent));
    };
  }
  return hoc;
};

var keys = Object.keys;


var mapKeys = function mapKeys(obj, func) {
  return keys(obj).reduce(function (result, key) {
    var val = obj[key];
    /* eslint-disable no-param-reassign */
    result[func(val, key)] = val;
    /* eslint-enable no-param-reassign */
    return result;
  }, {});
};

var renameProps = function renameProps(nameMap) {
  var hoc = mapProps(function (props) {
    return _extends({}, omit(props, keys(nameMap)), mapKeys(pick(props, keys(nameMap)), function (_, oldName) {
      return nameMap[oldName];
    }));
  });
  if (false) {
    return function (BaseComponent) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'renameProps'))(hoc(BaseComponent));
    };
  }
  return hoc;
};

var flattenProp = function flattenProp(propName) {
  return function (BaseComponent) {
    var factory = Object(__WEBPACK_IMPORTED_MODULE_0_react__["createFactory"])(BaseComponent);
    var FlattenProp = function FlattenProp(props) {
      return factory(_extends({}, props, props[propName]));
    };

    if (false) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'flattenProp'))(FlattenProp);
    }
    return FlattenProp;
  };
};

var withState = function withState(stateName, stateUpdaterName, initialState) {
  return function (BaseComponent) {
    var factory = Object(__WEBPACK_IMPORTED_MODULE_0_react__["createFactory"])(BaseComponent);

    var WithState = function (_Component) {
      inherits(WithState, _Component);

      function WithState() {
        var _temp, _this, _ret;

        classCallCheck(this, WithState);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
          stateValue: typeof initialState === 'function' ? initialState(_this.props) : initialState
        }, _this.updateStateValue = function (updateFn, callback) {
          return _this.setState(function (_ref) {
            var stateValue = _ref.stateValue;
            return {
              stateValue: typeof updateFn === 'function' ? updateFn(stateValue) : updateFn
            };
          }, callback);
        }, _temp), possibleConstructorReturn(_this, _ret);
      }

      WithState.prototype.render = function render() {
        var _babelHelpers$extends;

        return factory(_extends({}, this.props, (_babelHelpers$extends = {}, _babelHelpers$extends[stateName] = this.state.stateValue, _babelHelpers$extends[stateUpdaterName] = this.updateStateValue, _babelHelpers$extends)));
      };

      return WithState;
    }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

    if (false) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'withState'))(WithState);
    }
    return WithState;
  };
};

var withStateHandlers = function withStateHandlers(initialState, stateUpdaters) {
  return function (BaseComponent) {
    var factory = Object(__WEBPACK_IMPORTED_MODULE_0_react__["createFactory"])(BaseComponent);

    var WithStateHandlers = function (_Component) {
      inherits(WithStateHandlers, _Component);

      function WithStateHandlers() {
        var _temp, _this, _ret;

        classCallCheck(this, WithStateHandlers);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _initialiseProps.call(_this), _temp), possibleConstructorReturn(_this, _ret);
      }

      WithStateHandlers.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps, nextState) {
        var propsChanged = nextProps !== this.props;
        // the idea is to skip render if stateUpdater handler return undefined
        // this allows to create no state update handlers with access to state and props
        var stateChanged = !__WEBPACK_IMPORTED_MODULE_1_fbjs_lib_shallowEqual___default()(nextState, this.state);
        return propsChanged || stateChanged;
      };

      WithStateHandlers.prototype.render = function render() {
        return factory(_extends({}, this.props, this.state, this.stateUpdaters));
      };

      return WithStateHandlers;
    }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

    var _initialiseProps = function _initialiseProps() {
      var _this2 = this;

      this.state = typeof initialState === 'function' ? initialState(this.props) : initialState;
      this.stateUpdaters = mapValues(stateUpdaters, function (handler) {
        return function (mayBeEvent) {
          for (var _len2 = arguments.length, args = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
            args[_key2 - 1] = arguments[_key2];
          }

          // Having that functional form of setState can be called async
          // we need to persist SyntheticEvent
          if (mayBeEvent && typeof mayBeEvent.persist === 'function') {
            mayBeEvent.persist();
          }

          _this2.setState(function (state, props) {
            return handler(state, props).apply(undefined, [mayBeEvent].concat(args));
          });
        };
      });
    };

    if (false) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'withStateHandlers'))(WithStateHandlers);
    }
    return WithStateHandlers;
  };
};

var withReducer = function withReducer(stateName, dispatchName, reducer, initialState) {
  return function (BaseComponent) {
    var factory = Object(__WEBPACK_IMPORTED_MODULE_0_react__["createFactory"])(BaseComponent);

    var WithReducer = function (_Component) {
      inherits(WithReducer, _Component);

      function WithReducer() {
        var _temp, _this, _ret;

        classCallCheck(this, WithReducer);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
          stateValue: _this.initializeStateValue()
        }, _this.dispatch = function (action) {
          return _this.setState(function (_ref) {
            var stateValue = _ref.stateValue;
            return {
              stateValue: reducer(stateValue, action)
            };
          });
        }, _temp), possibleConstructorReturn(_this, _ret);
      }

      WithReducer.prototype.initializeStateValue = function initializeStateValue() {
        if (initialState !== undefined) {
          return typeof initialState === 'function' ? initialState(this.props) : initialState;
        }
        return reducer(undefined, { type: '@@recompose/INIT' });
      };

      WithReducer.prototype.render = function render() {
        var _babelHelpers$extends;

        return factory(_extends({}, this.props, (_babelHelpers$extends = {}, _babelHelpers$extends[stateName] = this.state.stateValue, _babelHelpers$extends[dispatchName] = this.dispatch, _babelHelpers$extends)));
      };

      return WithReducer;
    }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

    if (false) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'withReducer'))(WithReducer);
    }
    return WithReducer;
  };
};

var identity = function identity(Component$$1) {
  return Component$$1;
};

var branch = function branch(test, left) {
  var right = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : identity;
  return function (BaseComponent) {
    var leftFactory = void 0;
    var rightFactory = void 0;
    var Branch = function Branch(props) {
      if (test(props)) {
        leftFactory = leftFactory || Object(__WEBPACK_IMPORTED_MODULE_0_react__["createFactory"])(left(BaseComponent));
        return leftFactory(props);
      }
      rightFactory = rightFactory || Object(__WEBPACK_IMPORTED_MODULE_0_react__["createFactory"])(right(BaseComponent));
      return rightFactory(props);
    };

    if (false) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'branch'))(Branch);
    }
    return Branch;
  };
};

var renderComponent = function renderComponent(Component$$1) {
  return function (_) {
    var factory = Object(__WEBPACK_IMPORTED_MODULE_0_react__["createFactory"])(Component$$1);
    var RenderComponent = function RenderComponent(props) {
      return factory(props);
    };
    if (false) {
      RenderComponent.displayName = wrapDisplayName(Component$$1, 'renderComponent');
    }
    return RenderComponent;
  };
};

var Nothing = function (_Component) {
  inherits(Nothing, _Component);

  function Nothing() {
    classCallCheck(this, Nothing);
    return possibleConstructorReturn(this, _Component.apply(this, arguments));
  }

  Nothing.prototype.render = function render() {
    return null;
  };

  return Nothing;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

var renderNothing = function renderNothing(_) {
  return Nothing;
};

var shouldUpdate = function shouldUpdate(test) {
  return function (BaseComponent) {
    var factory = Object(__WEBPACK_IMPORTED_MODULE_0_react__["createFactory"])(BaseComponent);

    var ShouldUpdate = function (_Component) {
      inherits(ShouldUpdate, _Component);

      function ShouldUpdate() {
        classCallCheck(this, ShouldUpdate);
        return possibleConstructorReturn(this, _Component.apply(this, arguments));
      }

      ShouldUpdate.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
        return test(this.props, nextProps);
      };

      ShouldUpdate.prototype.render = function render() {
        return factory(this.props);
      };

      return ShouldUpdate;
    }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

    if (false) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'shouldUpdate'))(ShouldUpdate);
    }
    return ShouldUpdate;
  };
};

var pure = function pure(BaseComponent) {
  var hoc = shouldUpdate(function (props, nextProps) {
    return !__WEBPACK_IMPORTED_MODULE_1_fbjs_lib_shallowEqual___default()(props, nextProps);
  });

  if (false) {
    return setDisplayName(wrapDisplayName(BaseComponent, 'pure'))(hoc(BaseComponent));
  }

  return hoc(BaseComponent);
};

var onlyUpdateForKeys = function onlyUpdateForKeys(propKeys) {
  var hoc = shouldUpdate(function (props, nextProps) {
    return !__WEBPACK_IMPORTED_MODULE_1_fbjs_lib_shallowEqual___default()(pick(nextProps, propKeys), pick(props, propKeys));
  });

  if (false) {
    return function (BaseComponent) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'onlyUpdateForKeys'))(hoc(BaseComponent));
    };
  }
  return hoc;
};

var onlyUpdateForPropTypes = function onlyUpdateForPropTypes(BaseComponent) {
  var propTypes = BaseComponent.propTypes;

  if (false) {
    if (!propTypes) {
      /* eslint-disable */
      console.error('A component without any `propTypes` was passed to ' + '`onlyUpdateForPropTypes()`. Check the implementation of the ' + ('component with display name "' + getDisplayName(BaseComponent) + '".'));
      /* eslint-enable */
    }
  }

  var propKeys = Object.keys(propTypes || {});
  var OnlyUpdateForPropTypes = onlyUpdateForKeys(propKeys)(BaseComponent);

  if (false) {
    return setDisplayName(wrapDisplayName(BaseComponent, 'onlyUpdateForPropTypes'))(OnlyUpdateForPropTypes);
  }
  return OnlyUpdateForPropTypes;
};

var withContext = function withContext(childContextTypes, getChildContext) {
  return function (BaseComponent) {
    var factory = Object(__WEBPACK_IMPORTED_MODULE_0_react__["createFactory"])(BaseComponent);

    var WithContext = function (_Component) {
      inherits(WithContext, _Component);

      function WithContext() {
        var _temp, _this, _ret;

        classCallCheck(this, WithContext);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.getChildContext = function () {
          return getChildContext(_this.props);
        }, _temp), possibleConstructorReturn(_this, _ret);
      }

      WithContext.prototype.render = function render() {
        return factory(this.props);
      };

      return WithContext;
    }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

    WithContext.childContextTypes = childContextTypes;

    if (false) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'withContext'))(WithContext);
    }
    return WithContext;
  };
};

var getContext = function getContext(contextTypes) {
  return function (BaseComponent) {
    var factory = Object(__WEBPACK_IMPORTED_MODULE_0_react__["createFactory"])(BaseComponent);
    var GetContext = function GetContext(ownerProps, context) {
      return factory(_extends({}, ownerProps, context));
    };

    GetContext.contextTypes = contextTypes;

    if (false) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'getContext'))(GetContext);
    }
    return GetContext;
  };
};

/* eslint-disable no-console */
var lifecycle = function lifecycle(spec) {
  return function (BaseComponent) {
    var factory = Object(__WEBPACK_IMPORTED_MODULE_0_react__["createFactory"])(BaseComponent);

    if (false) {
      console.error('lifecycle() does not support the render method; its behavior is to ' + 'pass all props and state to the base component.');
    }

    var Lifecycle = function (_Component) {
      inherits(Lifecycle, _Component);

      function Lifecycle() {
        classCallCheck(this, Lifecycle);
        return possibleConstructorReturn(this, _Component.apply(this, arguments));
      }

      Lifecycle.prototype.render = function render() {
        return factory(_extends({}, this.props, this.state));
      };

      return Lifecycle;
    }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

    Object.keys(spec).forEach(function (hook) {
      return Lifecycle.prototype[hook] = spec[hook];
    });

    if (false) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'lifecycle'))(Lifecycle);
    }
    return Lifecycle;
  };
};

var isClassComponent = function isClassComponent(Component$$1) {
  return Boolean(Component$$1 && Component$$1.prototype && typeof Component$$1.prototype.render === 'function');
};

var toClass = function toClass(baseComponent) {
  if (isClassComponent(baseComponent)) {
    return baseComponent;
  }

  var ToClass = function (_Component) {
    inherits(ToClass, _Component);

    function ToClass() {
      classCallCheck(this, ToClass);
      return possibleConstructorReturn(this, _Component.apply(this, arguments));
    }

    ToClass.prototype.render = function render() {
      if (typeof baseComponent === 'string') {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(baseComponent, this.props);
      }
      return baseComponent(this.props, this.context);
    };

    return ToClass;
  }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

  ToClass.displayName = getDisplayName(baseComponent);
  ToClass.propTypes = baseComponent.propTypes;
  ToClass.contextTypes = baseComponent.contextTypes;
  ToClass.defaultProps = baseComponent.defaultProps;

  return ToClass;
};

var setPropTypes = function setPropTypes(propTypes) {
  return setStatic('propTypes', propTypes);
};

function compose() {
  for (var _len = arguments.length, funcs = Array(_len), _key = 0; _key < _len; _key++) {
    funcs[_key] = arguments[_key];
  }

  if (funcs.length === 0) {
    return function (arg) {
      return arg;
    };
  }

  if (funcs.length === 1) {
    return funcs[0];
  }

  return funcs.reduce(function (a, b) {
    return function () {
      return a(b.apply(undefined, arguments));
    };
  });
}

var createSink = function createSink(callback) {
  return function (_Component) {
    inherits(Sink, _Component);

    function Sink() {
      classCallCheck(this, Sink);
      return possibleConstructorReturn(this, _Component.apply(this, arguments));
    }

    Sink.prototype.componentWillMount = function componentWillMount() {
      callback(this.props);
    };

    Sink.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
      callback(nextProps);
    };

    Sink.prototype.render = function render() {
      return null;
    };

    return Sink;
  }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);
};

var componentFromProp = function componentFromProp(propName) {
  var Component$$1 = function Component$$1(props) {
    return Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(props[propName], omit(props, [propName]));
  };
  Component$$1.displayName = 'componentFromProp(' + propName + ')';
  return Component$$1;
};

var nest = function nest() {
  for (var _len = arguments.length, Components = Array(_len), _key = 0; _key < _len; _key++) {
    Components[_key] = arguments[_key];
  }

  var factories = Components.map(__WEBPACK_IMPORTED_MODULE_0_react__["createFactory"]);
  var Nest = function Nest(_ref) {
    var props = objectWithoutProperties(_ref, []),
        children = _ref.children;
    return factories.reduceRight(function (child, factory) {
      return factory(props, child);
    }, children);
  };

  if (false) {
    var displayNames = Components.map(getDisplayName);
    Nest.displayName = 'nest(' + displayNames.join(', ') + ')';
  }

  return Nest;
};

var hoistStatics = function hoistStatics(higherOrderComponent) {
  return function (BaseComponent) {
    var NewComponent = higherOrderComponent(BaseComponent);
    __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics___default()(NewComponent, BaseComponent);
    return NewComponent;
  };
};

var _config = {
  fromESObservable: null,
  toESObservable: null
};

var configureObservable = function configureObservable(c) {
  _config = c;
};

var config = {
  fromESObservable: function fromESObservable(observable) {
    return typeof _config.fromESObservable === 'function' ? _config.fromESObservable(observable) : observable;
  },
  toESObservable: function toESObservable(stream) {
    return typeof _config.toESObservable === 'function' ? _config.toESObservable(stream) : stream;
  }
};

var componentFromStreamWithConfig = function componentFromStreamWithConfig(config$$1) {
  return function (propsToVdom) {
    return function (_Component) {
      inherits(ComponentFromStream, _Component);

      function ComponentFromStream() {
        var _config$fromESObserva;

        var _temp, _this, _ret;

        classCallCheck(this, ComponentFromStream);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = { vdom: null }, _this.propsEmitter = Object(__WEBPACK_IMPORTED_MODULE_3_change_emitter__["createChangeEmitter"])(), _this.props$ = config$$1.fromESObservable((_config$fromESObserva = {
          subscribe: function subscribe(observer) {
            var unsubscribe = _this.propsEmitter.listen(function (props) {
              if (props) {
                observer.next(props);
              } else {
                observer.complete();
              }
            });
            return { unsubscribe: unsubscribe };
          }
        }, _config$fromESObserva[__WEBPACK_IMPORTED_MODULE_4_symbol_observable___default.a] = function () {
          return this;
        }, _config$fromESObserva)), _this.vdom$ = config$$1.toESObservable(propsToVdom(_this.props$)), _temp), possibleConstructorReturn(_this, _ret);
      }

      // Stream of props


      // Stream of vdom


      ComponentFromStream.prototype.componentWillMount = function componentWillMount() {
        var _this2 = this;

        // Subscribe to child prop changes so we know when to re-render
        this.subscription = this.vdom$.subscribe({
          next: function next(vdom) {
            _this2.setState({ vdom: vdom });
          }
        });
        this.propsEmitter.emit(this.props);
      };

      ComponentFromStream.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
        // Receive new props from the owner
        this.propsEmitter.emit(nextProps);
      };

      ComponentFromStream.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps, nextState) {
        return nextState.vdom !== this.state.vdom;
      };

      ComponentFromStream.prototype.componentWillUnmount = function componentWillUnmount() {
        // Call without arguments to complete stream
        this.propsEmitter.emit();

        // Clean-up subscription before un-mounting
        this.subscription.unsubscribe();
      };

      ComponentFromStream.prototype.render = function render() {
        return this.state.vdom;
      };

      return ComponentFromStream;
    }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);
  };
};

var componentFromStream = function componentFromStream(propsToVdom) {
  return componentFromStreamWithConfig(config)(propsToVdom);
};

var identity$1 = function identity(t) {
  return t;
};

var mapPropsStreamWithConfig = function mapPropsStreamWithConfig(config$$1) {
  var componentFromStream = componentFromStreamWithConfig({
    fromESObservable: identity$1,
    toESObservable: identity$1
  });
  return function (transform) {
    return function (BaseComponent) {
      var factory = Object(__WEBPACK_IMPORTED_MODULE_0_react__["createFactory"])(BaseComponent);
      var fromESObservable = config$$1.fromESObservable,
          toESObservable = config$$1.toESObservable;

      return componentFromStream(function (props$) {
        var _ref;

        return _ref = {
          subscribe: function subscribe(observer) {
            var subscription = toESObservable(transform(fromESObservable(props$))).subscribe({
              next: function next(childProps) {
                return observer.next(factory(childProps));
              }
            });
            return {
              unsubscribe: function unsubscribe() {
                return subscription.unsubscribe();
              }
            };
          }
        }, _ref[__WEBPACK_IMPORTED_MODULE_4_symbol_observable___default.a] = function () {
          return this;
        }, _ref;
      });
    };
  };
};

var mapPropsStream = function mapPropsStream(transform) {
  var hoc = mapPropsStreamWithConfig(config)(transform);

  if (false) {
    return function (BaseComponent) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'mapPropsStream'))(hoc(BaseComponent));
    };
  }
  return hoc;
};

var createEventHandlerWithConfig = function createEventHandlerWithConfig(config$$1) {
  return function () {
    var _config$fromESObserva;

    var emitter = Object(__WEBPACK_IMPORTED_MODULE_3_change_emitter__["createChangeEmitter"])();
    var stream = config$$1.fromESObservable((_config$fromESObserva = {
      subscribe: function subscribe(observer) {
        var unsubscribe = emitter.listen(function (value) {
          return observer.next(value);
        });
        return { unsubscribe: unsubscribe };
      }
    }, _config$fromESObserva[__WEBPACK_IMPORTED_MODULE_4_symbol_observable___default.a] = function () {
      return this;
    }, _config$fromESObserva));
    return {
      handler: emitter.emit,
      stream: stream
    };
  };
};

var createEventHandler = createEventHandlerWithConfig(config);

// Higher-order component helpers




/***/ }),
/* 334 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var warning = function() {};

if (false) {
  warning = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
        '`warning(condition, format, ...args)` requires a warning ' +
        'message argument'
      );
    }

    if (format.length < 10 || (/^[s\W]*$/).test(format)) {
      throw new Error(
        'The warning format should be able to uniquely identify this ' +
        'warning. Please, use a more descriptive format than: ' + format
      );
    }

    if (!condition) {
      var argIndex = 0;
      var message = 'Warning: ' +
        format.replace(/%s/g, function() {
          return args[argIndex++];
        });
      if (typeof console !== 'undefined') {
        console.error(message);
      }
      try {
        // This error was thrown as a convenience so that you can use this stack
        // to find the callsite that caused this warning to fire.
        throw new Error(message);
      } catch(x) {}
    }
  };
}

module.exports = warning;


/***/ }),
/* 335 */
/***/ (function(module, exports, __webpack_require__) {

var baseForOwn = __webpack_require__(816),
    createBaseEach = __webpack_require__(829);

/**
 * The base implementation of `_.forEach` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 */
var baseEach = createBaseEach(baseForOwn);

module.exports = baseEach;


/***/ }),
/* 336 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsArguments = __webpack_require__(821),
    isObjectLike = __webpack_require__(85);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
    !propertyIsEnumerable.call(value, 'callee');
};

module.exports = isArguments;


/***/ }),
/* 337 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(38),
    stubFalse = __webpack_require__(822);

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse;

module.exports = isBuffer;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(94)(module)))

/***/ }),
/* 338 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsTypedArray = __webpack_require__(823),
    baseUnary = __webpack_require__(824),
    nodeUtil = __webpack_require__(825);

/* Node.js helper references. */
var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

module.exports = isTypedArray;


/***/ }),
/* 339 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

module.exports = isPrototype;


/***/ }),
/* 340 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(151),
    stackClear = __webpack_require__(838),
    stackDelete = __webpack_require__(839),
    stackGet = __webpack_require__(840),
    stackHas = __webpack_require__(841),
    stackSet = __webpack_require__(842);

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  var data = this.__data__ = new ListCache(entries);
  this.size = data.size;
}

// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;

module.exports = Stack;


/***/ }),
/* 341 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsEqualDeep = __webpack_require__(855),
    isObjectLike = __webpack_require__(85);

/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */
function baseIsEqual(value, other, bitmask, customizer, stack) {
  if (value === other) {
    return true;
  }
  if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
    return value !== value && other !== other;
  }
  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
}

module.exports = baseIsEqual;


/***/ }),
/* 342 */
/***/ (function(module, exports, __webpack_require__) {

var SetCache = __webpack_require__(856),
    arraySome = __webpack_require__(859),
    cacheHas = __webpack_require__(860);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */
function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      arrLength = array.length,
      othLength = other.length;

  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
    return false;
  }
  // Assume cyclic values are equal.
  var stacked = stack.get(array);
  if (stacked && stack.get(other)) {
    return stacked == other;
  }
  var index = -1,
      result = true,
      seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;

  stack.set(array, other);
  stack.set(other, array);

  // Ignore non-index properties.
  while (++index < arrLength) {
    var arrValue = array[index],
        othValue = other[index];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, arrValue, index, other, array, stack)
        : customizer(arrValue, othValue, index, array, other, stack);
    }
    if (compared !== undefined) {
      if (compared) {
        continue;
      }
      result = false;
      break;
    }
    // Recursively compare arrays (susceptible to call stack limits).
    if (seen) {
      if (!arraySome(other, function(othValue, othIndex) {
            if (!cacheHas(seen, othIndex) &&
                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
              return seen.push(othIndex);
            }
          })) {
        result = false;
        break;
      }
    } else if (!(
          arrValue === othValue ||
            equalFunc(arrValue, othValue, bitmask, customizer, stack)
        )) {
      result = false;
      break;
    }
  }
  stack['delete'](array);
  stack['delete'](other);
  return result;
}

module.exports = equalArrays;


/***/ }),
/* 343 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(66);

/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */
function isStrictComparable(value) {
  return value === value && !isObject(value);
}

module.exports = isStrictComparable;


/***/ }),
/* 344 */
/***/ (function(module, exports) {

/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function matchesStrictComparable(key, srcValue) {
  return function(object) {
    if (object == null) {
      return false;
    }
    return object[key] === srcValue &&
      (srcValue !== undefined || (key in Object(object)));
  };
}

module.exports = matchesStrictComparable;


/***/ }),
/* 345 */
/***/ (function(module, exports, __webpack_require__) {

var castPath = __webpack_require__(346),
    toKey = __webpack_require__(156);

/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */
function baseGet(object, path) {
  path = castPath(path, object);

  var index = 0,
      length = path.length;

  while (object != null && index < length) {
    object = object[toKey(path[index++])];
  }
  return (index && index == length) ? object : undefined;
}

module.exports = baseGet;


/***/ }),
/* 346 */
/***/ (function(module, exports, __webpack_require__) {

var isArray = __webpack_require__(44),
    isKey = __webpack_require__(214),
    stringToPath = __webpack_require__(879),
    toString = __webpack_require__(347);

/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */
function castPath(value, object) {
  if (isArray(value)) {
    return value;
  }
  return isKey(value, object) ? [value] : stringToPath(toString(value));
}

module.exports = castPath;


/***/ }),
/* 347 */
/***/ (function(module, exports, __webpack_require__) {

var baseToString = __webpack_require__(882);

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : baseToString(value);
}

module.exports = toString;


/***/ }),
/* 348 */
/***/ (function(module, exports, __webpack_require__) {

var castPath = __webpack_require__(346),
    isArguments = __webpack_require__(336),
    isArray = __webpack_require__(44),
    isIndex = __webpack_require__(146),
    isLength = __webpack_require__(211),
    toKey = __webpack_require__(156);

/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */
function hasPath(object, path, hasFunc) {
  path = castPath(path, object);

  var index = -1,
      length = path.length,
      result = false;

  while (++index < length) {
    var key = toKey(path[index]);
    if (!(result = object != null && hasFunc(object, key))) {
      break;
    }
    object = object[key];
  }
  if (result || ++index != length) {
    return result;
  }
  length = object == null ? 0 : object.length;
  return !!length && isLength(length) && isIndex(key, length) &&
    (isArray(object) || isArguments(object));
}

module.exports = hasPath;


/***/ }),
/* 349 */
/***/ (function(module, exports) {

/** Used to compose unicode character classes. */
var rsAstralRange = '\\ud800-\\udfff',
    rsComboMarksRange = '\\u0300-\\u036f',
    reComboHalfMarksRange = '\\ufe20-\\ufe2f',
    rsComboSymbolsRange = '\\u20d0-\\u20ff',
    rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
    rsVarRange = '\\ufe0e\\ufe0f';

/** Used to compose unicode capture groups. */
var rsZWJ = '\\u200d';

/** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange  + rsComboRange + rsVarRange + ']');

/**
 * Checks if `string` contains Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a symbol is found, else `false`.
 */
function hasUnicode(string) {
  return reHasUnicode.test(string);
}

module.exports = hasUnicode;


/***/ }),
/* 350 */
/***/ (function(module, exports, __webpack_require__) {

var baseAssignValue = __webpack_require__(351),
    eq = __webpack_require__(153);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignValue(object, key, value) {
  var objValue = object[key];
  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
      (value === undefined && !(key in object))) {
    baseAssignValue(object, key, value);
  }
}

module.exports = assignValue;


/***/ }),
/* 351 */
/***/ (function(module, exports, __webpack_require__) {

var defineProperty = __webpack_require__(314);

/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function baseAssignValue(object, key, value) {
  if (key == '__proto__' && defineProperty) {
    defineProperty(object, key, {
      'configurable': true,
      'enumerable': true,
      'value': value,
      'writable': true
    });
  } else {
    object[key] = value;
  }
}

module.exports = baseAssignValue;


/***/ }),
/* 352 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(9);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(10));

var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
  d: "M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM19 4h-3.5l-1-1h-5l-1 1H5v2h14V4z"
}), _react.default.createElement("path", {
  fill: "none",
  d: "M0 0h24v24H0z"
})), 'Delete');

exports.default = _default;

/***/ }),
/* 353 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_select__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_icons_CloudDownload__ = __webpack_require__(929);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_icons_CloudDownload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__material_ui_icons_CloudDownload__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_styles_withStyles__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_styles_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_styles_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_select_lib_animated__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_select_lib_animated___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_select_lib_animated__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_icons_Assignment__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_icons_Assignment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__material_ui_icons_Assignment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_CustomButtons_Button_jsx__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_EnergyCompany_Pagination_custom_pagination__ = __webpack_require__(930);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_EnergyCompany_Cards_ECCard_jsx__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_components_Grid_GridContainer_jsx__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_components_Grid_GridItem_jsx__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_components_Table_Table_jsx__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_services_utils__ = __webpack_require__(23);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var empresasFiltradasStyle=function empresasFiltradasStyle(theme){return{button:{margin:"10px 0 0"},icon:{margin:"0 5px 0 0 !important"}};};var EmpresasFiltradas=function(_Component){_inherits(EmpresasFiltradas,_Component);function EmpresasFiltradas(props){_classCallCheck(this,EmpresasFiltradas);var _this=_possibleConstructorReturn(this,(EmpresasFiltradas.__proto__||Object.getPrototypeOf(EmpresasFiltradas)).call(this,props));_this.handleFiltroChange=function(value){var orderedValues=Object(__WEBPACK_IMPORTED_MODULE_4_lodash__["orderBy"])(value,['order']);_this.setState({filtros:orderedValues});};var columns=Object(__WEBPACK_IMPORTED_MODULE_4_lodash__["chain"])(props.relatorio.colunas).map(function(coluna,index){return Object.assign({},coluna,{order:index+1});}).filter(function(_ref){var id=_ref.id;return id!==props.colunaFixa.key;}).value();_this.state={columns:columns,filtros:Object(__WEBPACK_IMPORTED_MODULE_4_lodash__["filter"])(columns,function(column){return Object(__WEBPACK_IMPORTED_MODULE_4_lodash__["includes"])(props.relatorio.colunasIniciais,column.id);})};return _this;}_createClass(EmpresasFiltradas,[{key:"componentDidMount",value:function componentDidMount(){Object(__WEBPACK_IMPORTED_MODULE_14_services_utils__["i" /* scrollToElement */])(this.table);}},{key:"getData",value:function getData(){var _this2=this;var _props=this.props,colunaFixa=_props.colunaFixa,itens=_props.itens,relatorio=_props.relatorio;var getLink=function getLink(item,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{key:index,onClick:function onClick(){return _this2.props.searchEmpresa(item);},style:{cursor:"pointer"}},item[colunaFixa.key]);};return Object(__WEBPACK_IMPORTED_MODULE_4_lodash__["map"])(itens,function(item,index){return Object(__WEBPACK_IMPORTED_MODULE_4_lodash__["filter"])([relatorio.indiceInicio+index,getLink(item,index)].concat(_toConsumableArray(Object(__WEBPACK_IMPORTED_MODULE_4_lodash__["map"])(_this2.state.columns,function(column){return _this2.shouldShowColumn(column.id)&&Object(__WEBPACK_IMPORTED_MODULE_14_services_utils__["f" /* localeString */])(item[column.id]);}))),function(value){return value!==false;});});}},{key:"getHeaders",value:function getHeaders(){var _this3=this;var colunaFixa=this.props.colunaFixa;var headers=['#',colunaFixa.label];Object(__WEBPACK_IMPORTED_MODULE_4_lodash__["forEach"])(this.state.columns,function(column){if(_this3.shouldShowColumn(column.id)){headers.push(column.nome);}});return headers;}},{key:"shouldShowColumn",value:function shouldShowColumn(columnId){return Object(__WEBPACK_IMPORTED_MODULE_4_lodash__["some"])(this.state.filtros,function(filtro){return filtro.id===columnId;});}},{key:"render",value:function render(){var _this4=this;var _props2=this.props,classes=_props2.classes,downloadCSV=_props2.downloadCSV,itens=_props2.itens,relatorio=_props2.relatorio,requestNextPage=_props2.requestNextPage;var _state=this.state,columns=_state.columns,filtros=_state.filtros;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{ref:function ref(node){return _this4.table=node;}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components_Grid_GridContainer_jsx__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_components_Grid_GridItem_jsx__["a" /* default */],{xs:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_EnergyCompany_Cards_ECCard_jsx__["a" /* default */],{actions:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_CustomButtons_Button_jsx__["a" /* default */],{className:classes.button,color:"info",onClick:downloadCSV,size:"sm"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_icons_CloudDownload___default.a,{className:classes.icon}),"Download CSV"),content:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_select__["a" /* default */],{components:__WEBPACK_IMPORTED_MODULE_6_react_select_lib_animated__,getOptionLabel:function getOptionLabel(option){return option.nome;},getOptionValue:function getOptionValue(option){return option.id;},isMulti:true,noOptionsMessage:function noOptionsMessage(){return'Todos os filtros estão selecionados';},onChange:this.handleFiltroChange,options:columns,placeholder:"Colunas",value:filtros}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_components_Table_Table_jsx__["a" /* default */],{tableData:this.getData(),tableHead:this.getHeaders(),tableHeaderColor:"primary"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_EnergyCompany_Pagination_custom_pagination__["a" /* default */],{items:itens,onChangePage:requestNextPage,totalItens:relatorio.totalItens})),icon:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_icons_Assignment___default.a,null),title:"Empresas Filtradas ("+relatorio.totalItens+")"}))));}}]);return EmpresasFiltradas;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);;EmpresasFiltradas.propTypes={classes:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,colunaFixa:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({key:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,label:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired}).isRequired,downloadCSV:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,itens:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array.isRequired,relatorio:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({colunas:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object).isRequired,colunasIniciais:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string).isRequired,indiceInicio:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,totalItens:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number}),requestNextPage:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,searchEmpresa:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired};/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_5__material_ui_core_styles_withStyles___default()(empresasFiltradasStyle)(EmpresasFiltradas));

/***/ }),
/* 354 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return fetchCidades; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__routes__ = __webpack_require__(53);
var fetchCidades=function fetchCidades(estado){return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_1__routes__["a" /* default */].dadosGerais.fetchCidades(estado));};

/***/ }),
/* 355 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export SimuladorComponent */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__material_ui_icons_AttachMoney__ = __webpack_require__(936);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__material_ui_icons_AttachMoney___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__material_ui_icons_AttachMoney__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_CustomButtons_Button_jsx__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_CircularProgress__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_CircularProgress___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_CircularProgress__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_EnergyCompany_Cards_ECCard_jsx__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_Grid_GridContainer_jsx__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_Grid_GridItem_jsx__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_Hidden__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_Hidden___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Hidden__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_InputAdornment__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_InputAdornment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_InputAdornment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_LinearProgress__ = __webpack_require__(298);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_LinearProgress___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_LinearProgress__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_select__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__material_ui_core_styles_withStyles__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__material_ui_core_styles_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__material_ui_core_styles_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react_select_lib_animated__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react_select_lib_animated___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_react_select_lib_animated__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_lodash__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_components_EnergyCompany_Autosuggest_AutosuggestCNPJAsync__ = __webpack_require__(943);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_components_EnergyCompany_BouncingLoader_BouncingLoader_jsx__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_assets_EnergyCompany_jss_button_transparent_blue_border_jsx__ = __webpack_require__(357);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_components_EnergyCompany_Input_Input__ = __webpack_require__(188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__partials_ResultadoSimuladorCativoLivre__ = __webpack_require__(944);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_services_simulador__ = __webpack_require__(356);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_services_utils__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_services_contato__ = __webpack_require__(359);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var defaultStyleForSection={display:"grid",gridColumnGap:"15px",gridRowGap:"15px",gridTemplateColumns:"1fr 1fr",padding:"10px",width:"100%"};var inputTextStyle={border:"none",background:"#F6F6F6",borderRadius:"3px",height:"40px",padding:"0 10px"};var simuladorStyle=function simuladorStyle(theme){return{autosuggest:{marginBottom:"50px"},loading:{marginTop:"25px"},infoWrapper:Object.assign({},defaultStyleForSection),outrosWrapper:Object.assign({},defaultStyleForSection),forceNewRowModifier:{gridColumnStart:"1"},calcularButtonWrapper:{display:"flex",justifyContent:"flex-end",padding:"10px"},requiredFieldsError:{color:"red",display:"flex",justifyContent:"flex-end"},button:Object.assign({},__WEBPACK_IMPORTED_MODULE_17_assets_EnergyCompany_jss_button_transparent_blue_border_jsx__["a" /* default */],{gridColumnStart:2}),disclaimer:_defineProperty({flex:1,"& h4":{fontWeight:"bold"},"& p":{fontWeight:"400"}},theme.breakpoints.down("sm"),{fontSize:"16px",textAlign:"center"}),emailSentMessage:{gridColumnEnd:"span 2"},form:{flex:1,display:"grid",gridGap:"15px",gridTemplateColumns:"1fr 1fr"},formCard:_defineProperty({backgroundColor:"white",borderRadius:"6px",display:"flex",padding:"50px"},theme.breakpoints.down("sm"),{padding:"10px",display:"block"}),inputText:Object.assign({},inputTextStyle),textarea:Object.assign({},inputTextStyle,{gridColumn:"1 / span 2",height:"unset",padding:"10px"})};};var tiposDeEnergia=[{id:"total",nome:"Total"},{id:"patamar",nome:"Patamar"}];var Simulador=function(_Component){_inherits(Simulador,_Component);function Simulador(){var _ref;var _temp,_this,_ret;_classCallCheck(this,Simulador);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=Simulador.__proto__||Object.getPrototypeOf(Simulador)).call.apply(_ref,[this].concat(args))),_this),_this.state={categoriaCNAE:{},cnpjDados:undefined,crescimentoAnualTarifaCativo:0,custoEncargos:0,demandaPontaKW:0,demandaForaPontaKW:0,desconto:{},distribuidora:{},energiaPonta:0,energiaForaPonta:0,energiaTotal:0,error:undefined,percentualEnergiaProinfa:0,custoRepresentacaoMensal:0,loading:false,modalidade:{},parametros:{},precoLivreAno:0,precoLivreAnoMais1:0,precoLivreAnoMais2:0,precoLivreAnoMais3:0,previsaoIPCA:0,resultadoEconomia:undefined,simulando:false,subgrupo:{},tarifaCCEEPorMWh:0,tipoDeEnergia:tiposDeEnergia[1],unidadeEnergia:{},emailSentMessage:"",email:"",nome:"",msg:"",sending:false},_this.companyNotFound=function(){_this.setState({cnpjDados:undefined,error:'Nenhuma empresa encontrada',loading:false});},_this.handleSearch=function(selected){if(!selected)return;var request=void 0;_this.setState({cnpjDados:undefined,loading:true});if(selected.id==="CATIVO"){request=Object(__WEBPACK_IMPORTED_MODULE_20_services_simulador__["d" /* getCativoInfo */])(Object(__WEBPACK_IMPORTED_MODULE_21_services_utils__["h" /* removeNonDigits */])(selected.cnpj));}else{request=Object(__WEBPACK_IMPORTED_MODULE_20_services_simulador__["e" /* getCompanyInfo */])(selected.id);}request.then(function(_ref2){var data=_ref2.data;if(data&&data.length===0){return _this.companyNotFound();}var categoriaCNAE=data.categoriaCNAE,consumoMedioForaPontaMWMed=data.consumoMedioForaPontaMWMed,consumoMedioPontaMWMed=data.consumoMedioPontaMWMed,consumoMedioTotalMWMed=data.consumoMedioTotalMWMed,custoContabilizacao=data.custoContabilizacao,custoRepresentacaoMensal=data.custoRepresentacaoMensal,demandaForaPonta=data.demandaForaPonta,demandaPonta=data.demandaPonta,distribuidoraSugerida=data.distribuidoraSugerida,modalidadeTarifaria=data.modalidadeTarifaria,percentualEnergiaProinfa=data.percentualEnergiaProinfa,subgrupo=data.subgrupo;_this.setState({categoriaCNAE:categoriaCNAE,cnpjDados:data,custoEncargos:custoContabilizacao,custoRepresentacaoMensal:custoRepresentacaoMensal,demandaForaPontaKW:demandaForaPonta,demandaPontaKW:demandaPonta,distribuidora:distribuidoraSugerida,energiaForaPonta:consumoMedioForaPontaMWMed,energiaPonta:consumoMedioPontaMWMed,energiaTotal:consumoMedioTotalMWMed,error:undefined,loading:false,modalidade:modalidadeTarifaria,percentualEnergiaProinfa:Object(__WEBPACK_IMPORTED_MODULE_14_lodash__["round"])(percentualEnergiaProinfa,2),subgrupo:subgrupo});}).catch(_this.companyNotFound);},_this.simularEconomia=function(){var _this$state=_this.state,categoriaCNAE=_this$state.categoriaCNAE,cnpjDados=_this$state.cnpjDados,crescimentoAnualTarifaCativo=_this$state.crescimentoAnualTarifaCativo,custoEncargos=_this$state.custoEncargos,demandaPontaKW=_this$state.demandaPontaKW,demandaForaPontaKW=_this$state.demandaForaPontaKW,desconto=_this$state.desconto,distribuidora=_this$state.distribuidora,energiaPonta=_this$state.energiaPonta,energiaForaPonta=_this$state.energiaForaPonta,energiaTotal=_this$state.energiaTotal,percentualEnergiaProinfa=_this$state.percentualEnergiaProinfa,custoRepresentacaoMensal=_this$state.custoRepresentacaoMensal,modalidade=_this$state.modalidade,precoLivreAno=_this$state.precoLivreAno,precoLivreAnoMais1=_this$state.precoLivreAnoMais1,precoLivreAnoMais2=_this$state.precoLivreAnoMais2,precoLivreAnoMais3=_this$state.precoLivreAnoMais3,previsaoIPCA=_this$state.previsaoIPCA,subgrupo=_this$state.subgrupo,tarifaCCEEPorMWh=_this$state.tarifaCCEEPorMWh,tipoDeEnergia=_this$state.tipoDeEnergia,unidadeEnergia=_this$state.unidadeEnergia;_this.setState({resultadoEconomia:undefined});var params={idEmpresa:cnpjDados.id,idDistribuidora:distribuidora.id,subgrupo:subgrupo.id,modalidadeTarifaria:modalidade.id,categoriaCNAE:categoriaCNAE.id,desconto:desconto.id,energiaMensal:Object(__WEBPACK_IMPORTED_MODULE_14_lodash__["times"])(12,function(i){var mensal={mes:i+1,unidadeEnergia:unidadeEnergia.id};if(tipoDeEnergia.id==='total'){mensal.energiaTotal=energiaTotal;}else{mensal.energiaPonta=energiaPonta;mensal.energiaForaPonta=energiaForaPonta;}return mensal;}),demandaPontaKW:demandaPontaKW,demandaForaPontaKW:demandaForaPontaKW,percentualEnergiaProinfa:percentualEnergiaProinfa,tarifaCCEEPorMWh:tarifaCCEEPorMWh,custoEncargos:custoEncargos,custoRepresentacaoMensal:custoRepresentacaoMensal,previsaoIPCA:previsaoIPCA,crescimentoAnualTarifaCativo:crescimentoAnualTarifaCativo,precosEnergiaLivre:{precoLivreAno:precoLivreAno,precoLivreAnoMais1:precoLivreAnoMais1,precoLivreAnoMais2:precoLivreAnoMais2,precoLivreAnoMais3:precoLivreAnoMais3}};return Object(__WEBPACK_IMPORTED_MODULE_20_services_simulador__["b" /* calcularEconomia */])(params).then(function(res){_this.setState({resultadoEconomia:res.data,simulando:false});}).catch(function(){_this.setState({simulando:false});});},_this.btnSimularEconomia=function(){var classes=_this.props.classes;var simulando=_this.state.simulando;if(Object(__WEBPACK_IMPORTED_MODULE_14_lodash__["isEmpty"])(_this.state.desconto)){return;}var shouldDisableBtn=!_this.state.cnpjDados||Object(__WEBPACK_IMPORTED_MODULE_14_lodash__["isEmpty"])(_this.state.distribuidora)||Object(__WEBPACK_IMPORTED_MODULE_14_lodash__["isEmpty"])(_this.state.subgrupo)||Object(__WEBPACK_IMPORTED_MODULE_14_lodash__["isEmpty"])(_this.state.modalidade)||Object(__WEBPACK_IMPORTED_MODULE_14_lodash__["isEmpty"])(_this.state.categoriaCNAE)||_this.state.demandaForaPontaKW<0||Object(__WEBPACK_IMPORTED_MODULE_14_lodash__["isEmpty"])(_this.state.tipoDeEnergia)||Object(__WEBPACK_IMPORTED_MODULE_14_lodash__["isEmpty"])(_this.state.unidadeEnergia)||!_this.state.precoLivreAno||!_this.state.precoLivreAnoMais1||!_this.state.precoLivreAnoMais2;if(_this.state.tipoDeEnergia.id==='total'){if(!_this.state.energiaTotal){shouldDisableBtn=true;}}else{if(!_this.state.energiaPonta||!_this.state.energiaForaPonta){shouldDisableBtn=true;}}var precos=_this.state.parametros.precosEnergiaLivrePorDescontoEAno[_this.state.desconto.id];var precosKeys=Object(__WEBPACK_IMPORTED_MODULE_14_lodash__["keys"])(precos);// As vezes vem 4 anos as vezes 3, então não podemos checar sempre o quarto ano como obrigatório.
if(precosKeys.length===4&&!_this.state.precoLivreAnoMais3){shouldDisableBtn=true;}if(simulando){return __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("div",{className:classes.calcularButtonWrapper},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16_components_EnergyCompany_BouncingLoader_BouncingLoader_jsx__["a" /* default */],null));}else{return[__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("div",{className:classes.calcularButtonWrapper,key:"0"},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_CustomButtons_Button_jsx__["a" /* default */],{color:"info",disabled:shouldDisableBtn,onClick:function onClick(){_this.setState({simulando:true});_this.simularEconomia();}},"Calcular")),shouldDisableBtn&&__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("p",{className:classes.requiredFieldsError,key:"1"},"Cont\xE9m campos obrigat\xF3rios ainda n\xE3o preenchidos")];}},_this.handleEntreEmContatoClick=function(){_this.setState({sending:true});var _this$state2=_this.state,email=_this$state2.email,nome=_this$state2.nome,msg=_this$state2.msg;Object(__WEBPACK_IMPORTED_MODULE_22_services_contato__["a" /* sendMessage */])({email:email,nome:nome,msg:"Quero ser livre. "+msg}).then(function(){return _this.setState({emailSentMessage:"Mensagem enviada com sucesso, entraremos em contato em breve.",email:"",nome:"",msg:"",sending:false});}).catch(function(){return _this.setState({emailSentMessage:"Erro no envio da mensage, por favor tente novamente mais tarde.",sending:false});});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(Simulador,[{key:"componentDidMount",value:function componentDidMount(){var _this2=this;Object(__WEBPACK_IMPORTED_MODULE_20_services_simulador__["c" /* fetchDefaultParametros */])().then(function(_ref3){var data=_ref3.data;var unidadeEnergia=Object(__WEBPACK_IMPORTED_MODULE_14_lodash__["find"])(data.unidades,['id',1]);var desconto=Object(__WEBPACK_IMPORTED_MODULE_14_lodash__["find"])(data.descontosPerfisAgentes,['id','convencional']);_this2.savePrecos(data.precosEnergiaLivrePorDescontoEAno,desconto);_this2.setState({crescimentoAnualTarifaCativo:data.crescimentoAnualTarifaCativo,custoRepresentacaoMensal:data.custoRepresentacaoMensal,desconto:desconto,parametros:data,percentualEnergiaProinfa:data.percentualEnergiaProinfa,previsaoIPCA:data.previsaoIPCA,tarifaCCEEPorMWh:data.tarifaCCEEPorMWh,unidadeEnergia:unidadeEnergia});});}},{key:"componentDidUpdate",value:function componentDidUpdate(prevPros,prevState){var _state=this.state,desconto=_state.desconto,parametros=_state.parametros,subgrupo=_state.subgrupo;var descontoMudou=!Object(__WEBPACK_IMPORTED_MODULE_14_lodash__["isEqual"])(prevState.desconto,desconto);var subgrupoMudou=!Object(__WEBPACK_IMPORTED_MODULE_14_lodash__["isEqual"])(prevState.subgrupo,subgrupo);if(descontoMudou){this.savePrecos(parametros.precosEnergiaLivrePorDescontoEAno,desconto);}if(subgrupoMudou){var descontosPerfisAgentes=parametros.descontosPerfisAgentes,modalidadesTarifarias=parametros.modalidadesTarifarias;if(subgrupo.id==='a3'){this.setState({desconto:Object(__WEBPACK_IMPORTED_MODULE_14_lodash__["find"])(descontosPerfisAgentes,['id','convencional']),modalidade:Object(__WEBPACK_IMPORTED_MODULE_14_lodash__["find"])(modalidadesTarifarias,['id','azul'])});}if(subgrupo.id==='a4'){this.setState({desconto:Object(__WEBPACK_IMPORTED_MODULE_14_lodash__["find"])(descontosPerfisAgentes,['id','i50']),modalidade:Object(__WEBPACK_IMPORTED_MODULE_14_lodash__["find"])(modalidadesTarifarias,['id','verde'])});}}}},{key:"savePrecos",value:function savePrecos(precosEnergiaLivrePorDescontoEAno,desconto){var precos=precosEnergiaLivrePorDescontoEAno[desconto.id];var precosKeys=Object(__WEBPACK_IMPORTED_MODULE_14_lodash__["keys"])(precos);this.setState({precoLivreAno:precos[precosKeys[0]],precoLivreAnoMais1:precos[precosKeys[1]],precoLivreAnoMais2:precos[precosKeys[2]],precoLivreAnoMais3:precos[precosKeys[3]]});}},{key:"getInfoContent",value:function getInfoContent(){var _this3=this;var classes=this.props.classes;var _state2=this.state,categoriaCNAE=_state2.categoriaCNAE,cnpjDados=_state2.cnpjDados,desconto=_state2.desconto,distribuidora=_state2.distribuidora,loading=_state2.loading,modalidade=_state2.modalidade,parametros=_state2.parametros,subgrupo=_state2.subgrupo;var shouldDisable=!cnpjDados||loading;return __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("h3",null,__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("b",null,"Informa\xE7\xF5es Gerais")),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("div",{className:classes.infoWrapper},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("h6",null,"Distribuidora Sugerida*"),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_react_select__["a" /* default */],{components:__WEBPACK_IMPORTED_MODULE_13_react_select_lib_animated__,getOptionLabel:function getOptionLabel(option){return option.nome;},getOptionValue:function getOptionValue(option){return option.id;},isDisabled:shouldDisable,noOptionsMessage:function noOptionsMessage(){return"Carregando...";},onChange:function onChange(option){return _this3.setState({distribuidora:option});},options:parametros.agentesDistribuidores||[],placeholder:"Distribuidoras",value:distribuidora})),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("h6",null,"Subgrupo*"),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_react_select__["a" /* default */],{components:__WEBPACK_IMPORTED_MODULE_13_react_select_lib_animated__,getOptionLabel:function getOptionLabel(option){return option.nome;},getOptionValue:function getOptionValue(option){return option.id;},isDisabled:shouldDisable,noOptionsMessage:function noOptionsMessage(){return"Carregando...";},onChange:function onChange(option){return _this3.setState({subgrupo:option});},options:parametros.subgrupos||[],placeholder:"Subgrupos",value:subgrupo})),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("h6",null,"Modalidade Tarifaria*"),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_react_select__["a" /* default */],{components:__WEBPACK_IMPORTED_MODULE_13_react_select_lib_animated__,getOptionLabel:function getOptionLabel(option){return option.nome;},getOptionValue:function getOptionValue(option){return option.id;},isDisabled:shouldDisable,noOptionsMessage:function noOptionsMessage(){return"Carregando...";},onChange:function onChange(option){return _this3.setState({modalidade:option});},options:parametros.modalidadesTarifarias||[],placeholder:"Modalidades",value:modalidade})),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("h6",null,"Categoria CNAE*"),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_react_select__["a" /* default */],{components:__WEBPACK_IMPORTED_MODULE_13_react_select_lib_animated__,getOptionLabel:function getOptionLabel(option){return option.nome;},getOptionValue:function getOptionValue(option){return option.id;},isDisabled:shouldDisable,noOptionsMessage:function noOptionsMessage(){return"Carregando...";},onChange:function onChange(option){return _this3.setState({categoriaCNAE:option});},options:parametros.categoriasCNAE||[],placeholder:"Categorias",value:categoriaCNAE})),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("h6",null,"Desconto*"),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_react_select__["a" /* default */],{components:__WEBPACK_IMPORTED_MODULE_13_react_select_lib_animated__,getOptionLabel:function getOptionLabel(option){return option.nome;},getOptionValue:function getOptionValue(option){return option.id;},isDisabled:shouldDisable,noOptionsMessage:function noOptionsMessage(){return"Carregando...";},onChange:function onChange(option){return _this3.setState({desconto:option});},options:parametros.descontosPerfisAgentes||[],placeholder:"Categorias",value:desconto}))));}},{key:"getEnergia",value:function getEnergia(){var _this4=this;var classes=this.props.classes;var _state3=this.state,demandaPontaKW=_state3.demandaPontaKW,demandaForaPontaKW=_state3.demandaForaPontaKW,energiaPonta=_state3.energiaPonta,energiaForaPonta=_state3.energiaForaPonta,energiaTotal=_state3.energiaTotal,modalidade=_state3.modalidade,parametros=_state3.parametros,tipoDeEnergia=_state3.tipoDeEnergia,unidadeEnergia=_state3.unidadeEnergia;var _state4=this.state,cnpjDados=_state4.cnpjDados,loading=_state4.loading;var shouldDisable=!cnpjDados||loading;return __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("h3",null,__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("b",null,"Energia")),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("div",{className:classes.outrosWrapper},modalidade.id!=='verde'&&__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("h6",null,"Demanda ponta"),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18_components_EnergyCompany_Input_Input__["a" /* default */],{disabled:shouldDisable,onChange:function onChange(_ref4){var target=_ref4.target;return _this4.setState({demandaPontaKW:Number(target.value)});},startAdornment:__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_InputAdornment___default.a,{position:"start"},"KW"),type:"number",value:demandaPontaKW})),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("h6",null,"Demanda fora ponta*"),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18_components_EnergyCompany_Input_Input__["a" /* default */],{disabled:shouldDisable,onChange:function onChange(_ref5){var target=_ref5.target;return _this4.setState({demandaForaPontaKW:Number(target.value)});},startAdornment:__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_InputAdornment___default.a,{position:"start"},"KW"),type:"number",value:demandaForaPontaKW})),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("div",{className:classes.forceNewRowModifier},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("h6",null,"Escolher energia total ou patamarizada"),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_react_select__["a" /* default */],{components:__WEBPACK_IMPORTED_MODULE_13_react_select_lib_animated__,getOptionLabel:function getOptionLabel(option){return option.nome;},getOptionValue:function getOptionValue(option){return option.id;},isDisabled:shouldDisable,noOptionsMessage:function noOptionsMessage(){return"Carregando...";},onChange:function onChange(option){return _this4.setState({tipoDeEnergia:option});},options:tiposDeEnergia,placeholder:"",value:tipoDeEnergia})),tipoDeEnergia.id==='total'?__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("div",{className:classes.forceNewRowModifier},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("h6",null,"Energia total*"),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18_components_EnergyCompany_Input_Input__["a" /* default */],{disabled:shouldDisable,onChange:function onChange(_ref6){var target=_ref6.target;return _this4.setState({energiaTotal:Number(target.value)});},type:"number",value:energiaTotal})):[__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("div",{className:classes.forceNewRowModifier,key:"0"},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("h6",null,"Energia ponta*"),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18_components_EnergyCompany_Input_Input__["a" /* default */],{disabled:shouldDisable,onChange:function onChange(_ref7){var target=_ref7.target;return _this4.setState({energiaPonta:Number(target.value)});},type:"number",value:energiaPonta})),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("div",{key:"1"},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("h6",null,"Energia fora ponta*"),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18_components_EnergyCompany_Input_Input__["a" /* default */],{disabled:shouldDisable,onChange:function onChange(_ref8){var target=_ref8.target;return _this4.setState({energiaForaPonta:Number(target.value)});},type:"number",value:energiaForaPonta}))],__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("div",{className:classes.forceNewRowModifier},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("h6",null,"Unidade*"),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_react_select__["a" /* default */],{components:__WEBPACK_IMPORTED_MODULE_13_react_select_lib_animated__,getOptionLabel:function getOptionLabel(option){return option.nome;},getOptionValue:function getOptionValue(option){return option.id;},isDisabled:shouldDisable,noOptionsMessage:function noOptionsMessage(){return"Carregando...";},onChange:function onChange(option){return _this4.setState({unidadeEnergia:option});},options:Object(__WEBPACK_IMPORTED_MODULE_14_lodash__["filter"])(parametros.unidades,'energia'),placeholder:"",value:unidadeEnergia}))));}},{key:"getPrecos",value:function getPrecos(){var _this5=this;var classes=this.props.classes;var _state5=this.state,desconto=_state5.desconto,parametros=_state5.parametros,precoLivreAno=_state5.precoLivreAno,precoLivreAnoMais1=_state5.precoLivreAnoMais1,precoLivreAnoMais2=_state5.precoLivreAnoMais2,precoLivreAnoMais3=_state5.precoLivreAnoMais3;var _state6=this.state,cnpjDados=_state6.cnpjDados,loading=_state6.loading;if(Object(__WEBPACK_IMPORTED_MODULE_14_lodash__["isEmpty"])(desconto)){return;}var shouldDisable=!cnpjDados||loading;var precos=parametros.precosEnergiaLivrePorDescontoEAno[desconto.id];var precosKeys=Object(__WEBPACK_IMPORTED_MODULE_14_lodash__["keys"])(precos);return __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("h3",null,__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("b",null,"Pre\xE7os")),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("div",{className:classes.outrosWrapper},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18_components_EnergyCompany_Input_Input__["a" /* default */],{disabled:shouldDisable,onChange:function onChange(_ref9){var target=_ref9.target;return _this5.setState({precoLivreAno:Number(target.value)});},startAdornment:__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_InputAdornment___default.a,{position:"start"},precosKeys[0],"*"),type:"number",value:precoLivreAno})),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18_components_EnergyCompany_Input_Input__["a" /* default */],{disabled:shouldDisable,onChange:function onChange(_ref10){var target=_ref10.target;return _this5.setState({precoLivreAnoMais1:Number(target.value)});},startAdornment:__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_InputAdornment___default.a,{position:"start"},precosKeys[1],"*"),type:"number",value:precoLivreAnoMais1})),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18_components_EnergyCompany_Input_Input__["a" /* default */],{disabled:shouldDisable,onChange:function onChange(_ref11){var target=_ref11.target;return _this5.setState({precoLivreAnoMais2:Number(target.value)});},startAdornment:__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_InputAdornment___default.a,{position:"start"},precosKeys[2],"*"),type:"number",value:precoLivreAnoMais2})),precosKeys.length>3&&__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18_components_EnergyCompany_Input_Input__["a" /* default */],{disabled:shouldDisable,onChange:function onChange(_ref12){var target=_ref12.target;return _this5.setState({precoLivreAnoMais3:Number(target.value)});},startAdornment:__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_InputAdornment___default.a,{position:"start"},precosKeys[3],"*"),type:"number",value:precoLivreAnoMais3}))));}},{key:"getOutros",value:function getOutros(){var _this6=this;var classes=this.props.classes;var _state7=this.state,crescimentoAnualTarifaCativo=_state7.crescimentoAnualTarifaCativo,custoEncargos=_state7.custoEncargos,percentualEnergiaProinfa=_state7.percentualEnergiaProinfa,custoRepresentacaoMensal=_state7.custoRepresentacaoMensal,previsaoIPCA=_state7.previsaoIPCA,tarifaCCEEPorMWh=_state7.tarifaCCEEPorMWh;var _state8=this.state,cnpjDados=_state8.cnpjDados,loading=_state8.loading;var shouldDisable=!cnpjDados||loading;return __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("h3",null,__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("b",null,"Outros")),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("div",{className:classes.outrosWrapper},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("h6",null,"Energia Proinfa"),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18_components_EnergyCompany_Input_Input__["a" /* default */],{disabled:shouldDisable,onChange:function onChange(_ref13){var target=_ref13.target;return _this6.setState({percentualEnergiaProinfa:Number(target.value)});},startAdornment:__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_InputAdornment___default.a,{position:"start"},"%"),type:"number",value:percentualEnergiaProinfa})),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("h6",null,"Tarifa CCEE"),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18_components_EnergyCompany_Input_Input__["a" /* default */],{disabled:shouldDisable,onChange:function onChange(_ref14){var target=_ref14.target;return _this6.setState({tarifaCCEEPorMWh:Number(target.value)});},startAdornment:__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_InputAdornment___default.a,{position:"start"},"R$/MWh"),type:"number",value:tarifaCCEEPorMWh})),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("h6",null,"Encargos setoriais"),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18_components_EnergyCompany_Input_Input__["a" /* default */],{disabled:shouldDisable,onChange:function onChange(_ref15){var target=_ref15.target;return _this6.setState({custoEncargos:Number(target.value)});},startAdornment:__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_InputAdornment___default.a,{position:"start"},"R$/MWh"),type:"number",value:custoEncargos})),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("h6",null,"Representa\xE7\xE3o CCEE (mensal)"),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18_components_EnergyCompany_Input_Input__["a" /* default */],{disabled:shouldDisable,onChange:function onChange(_ref16){var target=_ref16.target;return _this6.setState({custoRepresentacaoMensal:Number(target.value)});},startAdornment:__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_InputAdornment___default.a,{position:"start"},"R$"),type:"number",value:custoRepresentacaoMensal})),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("h6",null,"Previs\xE3o IPCA"),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18_components_EnergyCompany_Input_Input__["a" /* default */],{disabled:shouldDisable,onChange:function onChange(_ref17){var target=_ref17.target;return _this6.setState({previsaoIPCA:Number(target.value)});},startAdornment:__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_InputAdornment___default.a,{position:"start"},"%"),type:"number",value:previsaoIPCA})),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("h6",null,"Crescimento Anual Tarifa Cativo"),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18_components_EnergyCompany_Input_Input__["a" /* default */],{disabled:shouldDisable,onChange:function onChange(_ref18){var target=_ref18.target;return _this6.setState({crescimentoAnualTarifaCativo:Number(target.value)});},startAdornment:__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_InputAdornment___default.a,{position:"start"},"%"),type:"number",value:crescimentoAnualTarifaCativo}))));}},{key:"render",value:function render(){var _this7=this;var classes=this.props.classes;var _state9=this.state,emailSentMessage=_state9.emailSentMessage,email=_state9.email,error=_state9.error,loading=_state9.loading,msg=_state9.msg,nome=_state9.nome,sending=_state9.sending,resultadoEconomia=_state9.resultadoEconomia;return __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_Grid_GridContainer_jsx__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_Grid_GridItem_jsx__["a" /* default */],{md:12,sm:12,xs:12},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("div",{className:classes.autosuggest},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_components_EnergyCompany_Autosuggest_AutosuggestCNPJAsync__["a" /* default */],{onHandleSelected:this.handleSearch,placeholder:"Buscar por CNPJ para calcular a economia"}),error&&__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("h3",null,error),loading&&__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("div",{className:classes.loading},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_LinearProgress___default.a,null))),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_EnergyCompany_Cards_ECCard_jsx__["a" /* default */],{content:__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("div",null,this.getInfoContent(),this.getEnergia(),this.getPrecos(),this.getOutros(),this.btnSimularEconomia(),resultadoEconomia&&__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__partials_ResultadoSimuladorCativoLivre__["a" /* default */],{resultadoEconomia:resultadoEconomia}),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("div",{className:classes.disclaimer},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("h3",null,__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("b",null,"Deseja ser livre? Entre em contato")),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Hidden___default.a,{mdUp:true},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("p",null,"Envie uma mensagem para se cadastrar na Energy Company, retornaremos o contato o mais r\xE1pido poss\xEDvel. Tenha acesso livre durante ",__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("b",null,"30 dias")," para testar todas as nossas funcionalidades. S\xF3 comece a pagar se satisfeito."))),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("div",{className:classes.form},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("input",{className:classes.inputText,onChange:function onChange(e){return _this7.setState({nome:e.target.value});},placeholder:"Nome",type:"text",value:nome}),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("input",{className:classes.inputText,onChange:function onChange(e){return _this7.setState({email:e.target.value});},placeholder:"E-mail",type:"text",value:email}),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("textarea",{className:classes.textarea,onChange:function onChange(e){return _this7.setState({msg:e.target.value});},placeholder:"Mensagem",rows:"5",type:"area",value:msg}),emailSentMessage?__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("p",{className:classes.emailSentMessage},emailSentMessage):__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("div",{className:classes.sendButtonWrapper},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("button",{className:classes.button,disabled:sending,onClick:this.handleEntreEmContatoClick},"Enviar"),sending&&__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_CircularProgress___default.a,{className:classes.circularProgress,size:24})))))),icon:__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_icons_AttachMoney___default.a,null),title:"Simulador de Economia"})));}}]);return Simulador;}(__WEBPACK_IMPORTED_MODULE_10_react__["Component"]);Simulador.propTypes={classes:__WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.object.isRequired};/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_12__material_ui_core_styles_withStyles___default()(simuladorStyle)(Simulador));

/***/ }),
/* 356 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return buscarCNPJ; });
/* unused harmony export buscarEmpresa */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return fetchDefaultParametros; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getCativoInfo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getCompanyInfo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return calcularEconomia; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__routes__ = __webpack_require__(53);
var buscarCNPJ=function buscarCNPJ(q){return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_1__routes__["a" /* default */].simuladores.buscarCNPJ(q));};var buscarEmpresa=function buscarEmpresa(q){return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_1__routes__["a" /* default */].simuladores.buscarEmpresa(q));};var fetchDefaultParametros=function fetchDefaultParametros(){return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_1__routes__["a" /* default */].simuladores.fetchDefaultParametros());};var getCativoInfo=function getCativoInfo(cnpj){return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_1__routes__["a" /* default */].simuladores.getCativoInfo(cnpj));};var getCompanyInfo=function getCompanyInfo(id){return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_1__routes__["a" /* default */].simuladores.getInfo(id));};var calcularEconomia=function calcularEconomia(params){return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_1__routes__["a" /* default */].simuladores.calcularEconomia(),params);};

/***/ }),
/* 357 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__button__ = __webpack_require__(358);
var buttonTransparentBlueBorder=Object.assign({},__WEBPACK_IMPORTED_MODULE_0__button__["a" /* default */],{backgroundColor:"white",border:"1px solid",color:"#3E64AE","&:disabled":{opacity:"0.65",pointerEvents:"none"}});/* harmony default export */ __webpack_exports__["a"] = (buttonTransparentBlueBorder);

/***/ }),
/* 358 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var buttonStyle={border:"none",borderRadius:"2px",cursor:"pointer",height:"31px",padding:"0px 30px",transition:"all 0.3s ease-in-out 0s"};/* harmony default export */ __webpack_exports__["a"] = (buttonStyle);

/***/ }),
/* 359 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return sendMessage; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__routes__ = __webpack_require__(53);
var sendMessage=function sendMessage(params){return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_1__routes__["a" /* default */].contato.sendMessage(),params);};

/***/ }),
/* 360 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(9);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(10));

var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
  d: "M12 5.9c1.16 0 2.1.94 2.1 2.1s-.94 2.1-2.1 2.1S9.9 9.16 9.9 8s.94-2.1 2.1-2.1m0 9c2.97 0 6.1 1.46 6.1 2.1v1.1H5.9V17c0-.64 3.13-2.1 6.1-2.1M12 4C9.79 4 8 5.79 8 8s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm0 9c-2.67 0-8 1.34-8 4v3h16v-3c0-2.66-5.33-4-8-4z"
}), _react.default.createElement("path", {
  fill: "none",
  d: "M0 0h24v24H0z"
})), 'PermIdentity');

exports.default = _default;

/***/ }),
/* 361 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles_withStyles__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_assets_jss_material_dashboard_pro_react_components_footerStyle__ = __webpack_require__(947);
function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}//////////////////////////////////////////////////////////////////////
///     Este componente foi modificado do original do tema.        ///
///     É basicamente igual só removendo/alterando algumas partes. ///
///     Checar novas versões manualmente.                          ///
//////////////////////////////////////////////////////////////////////
var styles=Object.assign({},__WEBPACK_IMPORTED_MODULE_4_assets_jss_material_dashboard_pro_react_components_footerStyle__["a" /* default */],{noMargin:{margin:0},noZIndex:{zIndex:"unset"},right:Object.assign({},__WEBPACK_IMPORTED_MODULE_4_assets_jss_material_dashboard_pro_react_components_footerStyle__["a" /* default */].right,{textAlign:"right"})});var Footer=function Footer(_ref){var _cx;var props=_objectWithoutProperties(_ref,[]);var classes=props.classes,fluid=props.fluid,white=props.white;var container=__WEBPACK_IMPORTED_MODULE_2_classnames___default()((_cx={},_defineProperty(_cx,classes.container,!fluid),_defineProperty(_cx,classes.containerFluid,fluid),_defineProperty(_cx,classes.whiteColor,white),_defineProperty(_cx,classes.noZIndex,true),_cx));var anchor=classes.a+__WEBPACK_IMPORTED_MODULE_2_classnames___default()(_defineProperty({}," "+classes.whiteColor,white));return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("footer",{className:classes.footer},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:container},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:classes.right},"\xA9 ",1900+new Date().getYear()," ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{className:anchor,href:"http://www.energycompany.com.br"},"Energy Company"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{className:classes.noMargin},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,"Este site utiliza dados fornecidos pela ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{href:"https://www.ccee.org.br/",rel:"noopener noreferrer",target:"_blank"},"CCEE")," e ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{href:"http://www.cvm.gov.br/",rel:"noopener noreferrer",target:"_blank"},"CVM."))))));};Footer.propTypes={classes:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,fluid:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,white:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool};/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles_withStyles___default()(styles)(Footer));

/***/ }),
/* 362 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles_withStyles__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_AppBar__ = __webpack_require__(948);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_AppBar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_AppBar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_Toolbar__ = __webpack_require__(950);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_Toolbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Toolbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_IconButton__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_IconButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_IconButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_Button__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_Button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_Button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_Hidden__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_Hidden___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Hidden__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_icons_Menu__ = __webpack_require__(952);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_icons_Menu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__material_ui_icons_Menu__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__material_ui_icons_MoreVert__ = __webpack_require__(953);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__material_ui_icons_MoreVert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__material_ui_icons_MoreVert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__material_ui_icons_ViewList__ = __webpack_require__(954);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__material_ui_icons_ViewList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__material_ui_icons_ViewList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__HeaderLinks__ = __webpack_require__(363);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_components_CustomButtons_Button_jsx__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_assets_jss_material_dashboard_pro_react_components_headerStyle_jsx__ = __webpack_require__(960);
function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}//////////////////////////////////////////////////////////////////////
///     Este componente foi modificado do original do tema.        ///
///     É basicamente igual só removendo/alterando algumas partes. ///
///     Checar novas versões manualmente.                          ///
//////////////////////////////////////////////////////////////////////
// material-ui components
// material-ui icons
// core components
var Header=function Header(_ref){var props=_objectWithoutProperties(_ref,[]);var makeBrand=function makeBrand(){var name=void 0;props.routes.map(function(prop,key){if(prop.collapse){prop.views.map(function(prop,key){if(prop.path===props.location.pathname){name=prop.name;}return null;});}if(prop.path===props.location.pathname){name=prop.name;}return null;});return name;};var classes=props.classes,color=props.color;var appBarClasses=__WEBPACK_IMPORTED_MODULE_2_classnames___default()(_defineProperty({}," "+classes[color],color));var sidebarMinimize=classes.sidebarMinimize;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_AppBar___default.a,{className:classes.appBar+appBarClasses},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Toolbar___default.a,{className:classes.container},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Hidden___default.a,{smDown:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:sidebarMinimize},props.miniActive?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_components_CustomButtons_Button_jsx__["a" /* default */],{color:"white",justIcon:true,onClick:props.sidebarMinimize,round:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_icons_ViewList___default.a,{className:classes.sidebarMiniIcon})):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_components_CustomButtons_Button_jsx__["a" /* default */],{color:"white",justIcon:true,onClick:props.sidebarMinimize,round:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_icons_MoreVert___default.a,{className:classes.sidebarMiniIcon})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:classes.flex},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_Button___default.a,{className:classes.title,href:"#"},makeBrand())),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Hidden___default.a,{implementation:"css",smDown:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__HeaderLinks__["a" /* default */],null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Hidden___default.a,{mdUp:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_IconButton___default.a,{"aria-label":"open drawer",className:classes.appResponsive,color:"inherit",onClick:props.handleDrawerToggle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_icons_Menu___default.a,null)))));};Header.propTypes={classes:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,color:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(["primary","info","success","warning","danger"]),handleDrawerToggle:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,location:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({pathname:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired}).isRequired,miniActive:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,routes:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,sidebarMinimize:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired};/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles_withStyles___default()(__WEBPACK_IMPORTED_MODULE_14_assets_jss_material_dashboard_pro_react_components_headerStyle_jsx__["a" /* default */])(Header));

/***/ }),
/* 363 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_components_CustomButtons_Button_jsx__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_ClickAwayListener__ = __webpack_require__(955);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_ClickAwayListener___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_ClickAwayListener__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grow__ = __webpack_require__(186);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grow___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grow__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_MenuItem__ = __webpack_require__(135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_MenuItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_MenuItem__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_MenuList__ = __webpack_require__(282);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_MenuList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_MenuList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_Paper__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_Paper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Paper__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_icons_SettingsRounded__ = __webpack_require__(957);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_icons_SettingsRounded___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__material_ui_icons_SettingsRounded__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_Popper__ = __webpack_require__(264);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_Popper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Popper__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__material_ui_core_styles_withStyles__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__material_ui_core_styles_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__material_ui_core_styles_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react_redux__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_assets_jss_material_dashboard_pro_react_components_headerLinksStyle__ = __webpack_require__(958);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_reducers_user_actions__ = __webpack_require__(52);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}//////////////////////////////////////////////////////////////////////
///     Este componente foi modificado do original do tema.        ///
///     É basicamente igual só removendo/alterando algumas partes. ///
///     Checar novas versões manualmente.                          ///
//////////////////////////////////////////////////////////////////////
var HeaderLinks=function(_Component){_inherits(HeaderLinks,_Component);function HeaderLinks(){var _ref;var _temp,_this,_ret;_classCallCheck(this,HeaderLinks);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=HeaderLinks.__proto__||Object.getPrototypeOf(HeaderLinks)).call.apply(_ref,[this].concat(args))),_this),_this.state={open:false},_this.handleClick=function(){_this.setState({open:!_this.state.open});},_this.handleClose=function(){_this.setState({open:false});},_this.logout=function(){_this.props.logout().then(function(){return window.location.href="/";}).catch(function(){return window.location.href="/";});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(HeaderLinks,[{key:"render",value:function render(){var _this2=this,_classNames;var classes=this.props.classes;var open=this.state.open;var dropdownItem=classes.dropdownItem;return __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_components_CustomButtons_Button_jsx__["a" /* default */],{"aria-haspopup":"true","aria-label":"Notifications","aria-owns":open?"menu-list":null,buttonRef:function buttonRef(node){_this2.anchorEl=node;},className:classes.buttonLink,color:"transparent",justIcon:true,onClick:this.handleClick},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_icons_SettingsRounded___default.a,{className:classes.links})),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Popper___default.a,{anchorEl:this.anchorEl,className:__WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classNames={},_defineProperty(_classNames,classes.popperClose,!open),_defineProperty(_classNames,classes.pooperResponsive,true),_defineProperty(_classNames,classes.pooperNav,true),_classNames)),disablePortal:true,open:open,placement:"bottom",transition:true},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_ClickAwayListener___default.a,{onClickAway:this.handleClose},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grow___default.a,{id:"menu-list","in":open,style:{transformOrigin:"0 0 0"}},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Paper___default.a,{className:classes.dropdown},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_MenuList___default.a,{role:"menu"},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_MenuItem___default.a,{className:dropdownItem,onClick:this.logout},"Sair")))))));}}]);return HeaderLinks;}(__WEBPACK_IMPORTED_MODULE_10_react__["Component"]);HeaderLinks.propTypes={classes:__WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.object.isRequired,logout:__WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.func.isRequired};var mapDispatchToProps={logout:__WEBPACK_IMPORTED_MODULE_14_reducers_user_actions__["d" /* logout */]};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_12_react_redux__["b" /* connect */])(null,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_11__material_ui_core_styles_withStyles___default()(__WEBPACK_IMPORTED_MODULE_13_assets_jss_material_dashboard_pro_react_components_headerLinksStyle__["a" /* default */])(HeaderLinks)));

/***/ }),
/* 364 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/logoEC.cedb6008.png";

/***/ }),
/* 365 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_icons_Person__ = __webpack_require__(961);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_icons_Person___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__material_ui_icons_Person__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_styles_withStyles__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_styles_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_styles_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_Drawer__ = __webpack_require__(962);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_Drawer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Drawer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_List__ = __webpack_require__(283);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_List___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_List__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_ListItem__ = __webpack_require__(288);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_ListItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_ListItem__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_core_ListItemIcon__ = __webpack_require__(966);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_core_ListItemIcon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_ListItemIcon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__material_ui_core_ListItemText__ = __webpack_require__(968);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__material_ui_core_ListItemText___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_ListItemText__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__material_ui_core_Hidden__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__material_ui_core_Hidden___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__material_ui_core_Hidden__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__material_ui_core_Collapse__ = __webpack_require__(294);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__material_ui_core_Collapse___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__material_ui_core_Collapse__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_components_EnergyCompany_Header_HeaderLinks_jsx__ = __webpack_require__(363);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__SidebarWrapper_jsx__ = __webpack_require__(970);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_assets_jss_material_dashboard_pro_react_components_sidebarStyle_jsx__ = __webpack_require__(971);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_lodash__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_routes_dashboard_jsx__ = __webpack_require__(258);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}//////////////////////////////////////////////////////////////////////
///     Este componente foi modificado do original do tema.        ///
///     É basicamente igual só removendo/alterando algumas partes. ///
///     Checar novas versões manualmente.                          ///
//////////////////////////////////////////////////////////////////////
// javascript plugin used to create scrollbars on windows
// material-ui components
// core components
// import avatar from "assets/EnergyCompany/img/default-avatar.png";
var styles=function styles(theme){var originalSidebarStyle=Object.assign({},Object(__WEBPACK_IMPORTED_MODULE_15_assets_jss_material_dashboard_pro_react_components_sidebarStyle_jsx__["a" /* default */])(theme));return Object.assign({},originalSidebarStyle,{logoMini:Object.assign({},originalSidebarStyle.logoMini,{marginTop:0}),photo:Object.assign({},originalSidebarStyle.photo,{alignItems:"center",boxShadow:"none",display:"flex",marginRight:"0"}),userCollapseLinks:Object.assign({},originalSidebarStyle.userCollapseLinks,{"&:hover,&:focus":{color:"inherit"}})});};var Sidebar=function(_React$Component){_inherits(Sidebar,_React$Component);function Sidebar(props){_classCallCheck(this,Sidebar);var _this=_possibleConstructorReturn(this,(Sidebar.__proto__||Object.getPrototypeOf(Sidebar)).call(this,props));_this.state={openAvatar:false,miniActive:true};_this.activeRoute.bind(_this);return _this;}// verifies if routeName is the one active (in browser input)
_createClass(Sidebar,[{key:"activeRoute",value:function activeRoute(routeName){return this.props.location.pathname===routeName?true:false;}},{key:"openCollapse",value:function openCollapse(collapse){var st={};st[collapse]=!this.state[collapse];this.setState(st);}},{key:"render",value:function render(){var _this2=this,_cx13;var _props=this.props,bgColor=_props.bgColor,classes=_props.classes,color=_props.color,image=_props.image,logo=_props.logo,logoText=_props.logoText,routes=_props.routes,userInfo=_props.userInfo;var itemText=classes.itemText+" "+__WEBPACK_IMPORTED_MODULE_3_classnames___default()(_defineProperty({},classes.itemTextMini,this.props.miniActive&&this.state.miniActive));var collapseItemText=classes.collapseItemText+" "+__WEBPACK_IMPORTED_MODULE_3_classnames___default()(_defineProperty({},classes.collapseItemTextMini,this.props.miniActive&&this.state.miniActive));var userWrapperClass=classes.user+" "+__WEBPACK_IMPORTED_MODULE_3_classnames___default()(_defineProperty({},classes.whiteAfter,bgColor==="white"));var caret=classes.caret;var collapseItemMini=classes.collapseItemMini;var photo=classes.photo;var user=!Object(__WEBPACK_IMPORTED_MODULE_16_lodash__["isEmpty"])(userInfo)?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:userWrapperClass},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:photo},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_icons_Person___default.a,null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_List___default.a,{className:classes.list},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_ListItem___default.a,{className:classes.item+" "+classes.userItem},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["a" /* NavLink */],{className:classes.itemLink+" "+classes.userCollapseButton,onClick:function onClick(){return _this2.openCollapse("openAvatar");},to:"#"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_ListItemText___default.a,{className:itemText+" "+classes.userItemText,disableTypography:true,primary:this.props.userInfo.nome,secondary:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b",{className:caret+" "+classes.userCaret+" "+(this.state.openAvatar?classes.caretActive:"")})})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__material_ui_core_Collapse___default.a,{"in":this.state.openAvatar,unmountOnExit:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_List___default.a,{className:classes.list+" "+classes.collapseList},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_ListItem___default.a,{className:classes.collapseItem},Object(__WEBPACK_IMPORTED_MODULE_16_lodash__["map"])(__WEBPACK_IMPORTED_MODULE_17_routes_dashboard_jsx__["b" /* internalRoutes */],function(route,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["a" /* NavLink */],{className:classes.itemLink+" "+classes.userCollapseLinks,key:index,to:route.path},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:collapseItemMini},route.mini),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_ListItemText___default.a,{className:collapseItemText,disableTypography:true,primary:route.name}));}))))))):undefined;var links=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_List___default.a,{className:classes.list},routes.map(function(prop,key){if(prop.redirect){return null;}if(prop.collapse){var _navLinkClasses=classes.itemLink+" "+__WEBPACK_IMPORTED_MODULE_3_classnames___default()(_defineProperty({}," "+classes.collapseActive,_this2.activeRoute(prop.path)));var _itemText=classes.itemText+" "+__WEBPACK_IMPORTED_MODULE_3_classnames___default()(_defineProperty({},classes.itemTextMini,_this2.props.miniActive&&_this2.state.miniActive));var _collapseItemText=classes.collapseItemText+" "+__WEBPACK_IMPORTED_MODULE_3_classnames___default()(_defineProperty({},classes.collapseItemTextMini,_this2.props.miniActive&&_this2.state.miniActive));var _itemIcon=classes.itemIcon;var _caret=classes.caret;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_ListItem___default.a,{className:classes.item,key:key},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["a" /* NavLink */],{className:_navLinkClasses,onClick:function onClick(){return _this2.openCollapse(prop.state);},to:"#"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_ListItemIcon___default.a,{className:_itemIcon},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(prop.icon,null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_ListItemText___default.a,{className:_itemText,disableTypography:true,primary:prop.name,secondary:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b",{className:_caret+" "+(_this2.state[prop.state]?classes.caretActive:"")})})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__material_ui_core_Collapse___default.a,{"in":_this2.state[prop.state],unmountOnExit:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_List___default.a,{className:classes.list+" "+classes.collapseList},prop.views.map(function(prop,key){if(prop.redirect){return null;}var navLinkClasses=classes.collapseItemLink+" "+__WEBPACK_IMPORTED_MODULE_3_classnames___default()(_defineProperty({}," "+classes[color],_this2.activeRoute(prop.path)));var collapseItemMini=classes.collapseItemMini;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_ListItem___default.a,{className:classes.collapseItem,key:key},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["a" /* NavLink */],{className:navLinkClasses,to:prop.path},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:collapseItemMini},prop.mini),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_ListItemText___default.a,{className:_collapseItemText,disableTypography:true,primary:prop.name})));}))));}var navLinkClasses=classes.itemLink+" "+__WEBPACK_IMPORTED_MODULE_3_classnames___default()(_defineProperty({}," "+classes[color],_this2.activeRoute(prop.path)));var itemText=classes.itemText+" "+__WEBPACK_IMPORTED_MODULE_3_classnames___default()(_defineProperty({},classes.itemTextMini,_this2.props.miniActive&&_this2.state.miniActive));var itemIcon=classes.itemIcon;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_ListItem___default.a,{className:classes.item,key:key},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["a" /* NavLink */],{className:navLinkClasses,to:prop.path},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_ListItemIcon___default.a,{className:itemIcon},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(prop.icon,null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_ListItemText___default.a,{className:itemText,disableTypography:true,primary:prop.name})));}));var logoNormal=classes.logoNormal+" "+__WEBPACK_IMPORTED_MODULE_3_classnames___default()(_defineProperty({},classes.logoNormalSidebarMini,this.props.miniActive&&this.state.miniActive));var logoMini=classes.logoMini;var logoClasses=classes.logo+" "+__WEBPACK_IMPORTED_MODULE_3_classnames___default()(_defineProperty({},classes.whiteAfter,bgColor==="white"));var brand=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:logoClasses},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{className:logoMini,href:"/"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{alt:"logo",className:classes.img,src:logo})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{className:logoNormal,href:"/"},logoText));var drawerPaper=classes.drawerPaper+" "+__WEBPACK_IMPORTED_MODULE_3_classnames___default()(_defineProperty({},classes.drawerPaperMini,this.props.miniActive&&this.state.miniActive));var sidebarWrapper=classes.sidebarWrapper+" "+__WEBPACK_IMPORTED_MODULE_3_classnames___default()((_cx13={},_defineProperty(_cx13,classes.drawerPaperMini,this.props.miniActive&&this.state.miniActive),_defineProperty(_cx13,classes.sidebarWrapperWithPerfectScrollbar,navigator.platform.indexOf("Win")>-1),_cx13));return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core_Hidden___default.a,{mdUp:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Drawer___default.a,{anchor:"right",classes:{paper:drawerPaper+" "+classes[bgColor+"Background"]},ModalProps:{keepMounted:true}// Better open performance on mobile.
,onClose:this.props.handleDrawerToggle,open:this.props.open,variant:"temporary"},brand,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__SidebarWrapper_jsx__["a" /* default */],{className:sidebarWrapper,headerLinks:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_components_EnergyCompany_Header_HeaderLinks_jsx__["a" /* default */],null),links:links,user:user}),image!==undefined?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:classes.background,style:{backgroundImage:"url("+image+")"}}):null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core_Hidden___default.a,{smDown:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Drawer___default.a,{anchor:"left",classes:{paper:drawerPaper+" "+classes[bgColor+"Background"]},onMouseOut:function onMouseOut(){return _this2.setState({miniActive:true});},onMouseOver:function onMouseOver(){return _this2.setState({miniActive:false});},open:true,variant:"permanent"},brand,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__SidebarWrapper_jsx__["a" /* default */],{className:sidebarWrapper,links:links,user:user}),image!==undefined?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:classes.background,style:{backgroundImage:"url("+image+")"}}):null)));}}]);return Sidebar;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);Sidebar.defaultProps={bgColor:"white",userInfo:{}};Sidebar.propTypes={bgColor:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(["white","black","blue"]),classes:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,color:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(["white","red","orange","green","blue","purple","rose"]),handleDrawerToggle:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,image:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,location:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({pathname:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired}).isRequired,logo:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,logoText:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,miniActive:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,open:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,routes:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object),userInfo:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({email:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,name:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string})};/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_5__material_ui_core_styles_withStyles___default()(styles)(Sidebar));

/***/ }),
/* 366 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__button__ = __webpack_require__(358);
var buttonBlue=Object.assign({},__WEBPACK_IMPORTED_MODULE_0__button__["a" /* default */],{backgroundColor:"#3E64AE",color:"white"});/* harmony default export */ __webpack_exports__["a"] = (buttonBlue);

/***/ }),
/* 367 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(9);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(10));

var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
  d: "M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z"
}), _react.default.createElement("path", {
  fill: "none",
  d: "M0 0h24v24H0z"
})), 'Email');

exports.default = _default;

/***/ }),
/* 368 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(9);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(10));

var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("g", {
  fill: "none"
}, _react.default.createElement("path", {
  d: "M0 0h24v24H0V0z"
}), _react.default.createElement("path", {
  d: "M0 0h24v24H0V0z",
  opacity: ".87"
})), _react.default.createElement("path", {
  d: "M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zM9 6c0-1.66 1.34-3 3-3s3 1.34 3 3v2H9V6zm9 14H6V10h12v10zm-6-3c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2z"
})), 'LockOutlined');

exports.default = _default;

/***/ }),
/* 369 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles_withStyles__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_SnackbarContent__ = __webpack_require__(246);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_SnackbarContent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_SnackbarContent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_IconButton__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_IconButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_IconButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_icons_Close__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_icons_Close___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__material_ui_icons_Close__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_assets_jss_material_dashboard_pro_react_components_snackbarContentStyle_jsx__ = __webpack_require__(995);
function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}// @material-ui/core components
// @material-ui/icons
function SnackbarContent(_ref){var _cx2;var props=_objectWithoutProperties(_ref,[]);var classes=props.classes,message=props.message,color=props.color,close=props.close,icon=props.icon;var action=[];var messageClasses=__WEBPACK_IMPORTED_MODULE_2_classnames___default()(_defineProperty({},classes.iconMessage,icon!==undefined));if(close!==undefined){action=[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_IconButton___default.a,{className:classes.iconButton,key:"close","aria-label":"Close",color:"inherit"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_icons_Close___default.a,{className:classes.close}))];}var iconClasses=__WEBPACK_IMPORTED_MODULE_2_classnames___default()((_cx2={},_defineProperty(_cx2,classes.icon,classes.icon),_defineProperty(_cx2,classes.infoIcon,color==="info"),_defineProperty(_cx2,classes.successIcon,color==="success"),_defineProperty(_cx2,classes.warningIcon,color==="warning"),_defineProperty(_cx2,classes.dangerIcon,color==="danger"),_defineProperty(_cx2,classes.primaryIcon,color==="primary"),_defineProperty(_cx2,classes.roseIcon,color==="rose"),_cx2));return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_SnackbarContent___default.a,{message:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,icon!==undefined?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(props.icon,{className:iconClasses}):null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:messageClasses},message)),classes:{root:classes.root+" "+classes[color],message:classes.message},action:action});}SnackbarContent.defaultProps={color:"info"};SnackbarContent.propTypes={classes:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,message:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node.isRequired,color:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(["info","success","warning","danger","primary","rose"]),close:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,icon:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func};/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles_withStyles___default()(__WEBPACK_IMPORTED_MODULE_7_assets_jss_material_dashboard_pro_react_components_snackbarContentStyle_jsx__["a" /* default */])(SnackbarContent));

/***/ }),
/* 370 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__ = __webpack_require__(21);
function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}// ##############################
// // // LoginPage view styles
// #############################
var loginPageStyle=function loginPageStyle(theme){return{container:Object.assign({},__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["c" /* container */],_defineProperty({zIndex:"4"},theme.breakpoints.down("sm"),{paddingBottom:"100px"})),cardTitle:Object.assign({},__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["b" /* cardTitle */],{color:"#FFFFFF"}),textCenter:{textAlign:"center"},justifyContentCenter:{justifyContent:"center !important"},customButtonClass:{"&,&:focus,&:hover":{color:"#FFFFFF"},marginLeft:"5px",marginRight:"5px"},inputAdornment:{marginRight:"18px"},inputAdornmentIcon:{color:"#555"},cardHidden:{opacity:"0",transform:"translate3d(0, -60px, 0)"},cardHeader:{marginBottom:"20px"},socialLine:{padding:"0.9375rem 0"}};};/* harmony default export */ __webpack_exports__["a"] = (loginPageStyle);

/***/ }),
/* 371 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(372);
module.exports = __webpack_require__(377);


/***/ }),
/* 372 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// @remove-on-eject-begin
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
// @remove-on-eject-end


if (typeof Promise === 'undefined') {
  // Rejection tracking prevents a common issue where React gets into an
  // inconsistent state due to an error, but it gets swallowed by a Promise,
  // and the user has no idea what causes React's erratic future behavior.
  __webpack_require__(373).enable();
  window.Promise = __webpack_require__(375);
}

// fetch() polyfill for making API calls.
__webpack_require__(376);

// Object.assign() is commonly used with React.
// It will use the native implementation if it's present and isn't buggy.
Object.assign = __webpack_require__(113);

// In tests, polyfill requestAnimationFrame since jsdom doesn't provide it yet.
// We don't polyfill it in the browser--this is user's responsibility.
if (false) {
  require('raf').polyfill(global);
}


/***/ }),
/* 373 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Promise = __webpack_require__(215);

var DEFAULT_WHITELIST = [
  ReferenceError,
  TypeError,
  RangeError
];

var enabled = false;
exports.disable = disable;
function disable() {
  enabled = false;
  Promise._47 = null;
  Promise._71 = null;
}

exports.enable = enable;
function enable(options) {
  options = options || {};
  if (enabled) disable();
  enabled = true;
  var id = 0;
  var displayId = 0;
  var rejections = {};
  Promise._47 = function (promise) {
    if (
      promise._83 === 2 && // IS REJECTED
      rejections[promise._56]
    ) {
      if (rejections[promise._56].logged) {
        onHandled(promise._56);
      } else {
        clearTimeout(rejections[promise._56].timeout);
      }
      delete rejections[promise._56];
    }
  };
  Promise._71 = function (promise, err) {
    if (promise._75 === 0) { // not yet handled
      promise._56 = id++;
      rejections[promise._56] = {
        displayId: null,
        error: err,
        timeout: setTimeout(
          onUnhandled.bind(null, promise._56),
          // For reference errors and type errors, this almost always
          // means the programmer made a mistake, so log them after just
          // 100ms
          // otherwise, wait 2 seconds to see if they get handled
          matchWhitelist(err, DEFAULT_WHITELIST)
            ? 100
            : 2000
        ),
        logged: false
      };
    }
  };
  function onUnhandled(id) {
    if (
      options.allRejections ||
      matchWhitelist(
        rejections[id].error,
        options.whitelist || DEFAULT_WHITELIST
      )
    ) {
      rejections[id].displayId = displayId++;
      if (options.onUnhandled) {
        rejections[id].logged = true;
        options.onUnhandled(
          rejections[id].displayId,
          rejections[id].error
        );
      } else {
        rejections[id].logged = true;
        logError(
          rejections[id].displayId,
          rejections[id].error
        );
      }
    }
  }
  function onHandled(id) {
    if (rejections[id].logged) {
      if (options.onHandled) {
        options.onHandled(rejections[id].displayId, rejections[id].error);
      } else if (!rejections[id].onUnhandled) {
        console.warn(
          'Promise Rejection Handled (id: ' + rejections[id].displayId + '):'
        );
        console.warn(
          '  This means you can ignore any previous messages of the form "Possible Unhandled Promise Rejection" with id ' +
          rejections[id].displayId + '.'
        );
      }
    }
  }
}

function logError(id, error) {
  console.warn('Possible Unhandled Promise Rejection (id: ' + id + '):');
  var errStr = (error && (error.stack || error)) + '';
  errStr.split('\n').forEach(function (line) {
    console.warn('  ' + line);
  });
}

function matchWhitelist(error, list) {
  return list.some(function (cls) {
    return error instanceof cls;
  });
}

/***/ }),
/* 374 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

// Use the fastest means possible to execute a task in its own turn, with
// priority over other events including IO, animation, reflow, and redraw
// events in browsers.
//
// An exception thrown by a task will permanently interrupt the processing of
// subsequent tasks. The higher level `asap` function ensures that if an
// exception is thrown by a task, that the task queue will continue flushing as
// soon as possible, but if you use `rawAsap` directly, you are responsible to
// either ensure that no exceptions are thrown from your task, or to manually
// call `rawAsap.requestFlush` if an exception is thrown.
module.exports = rawAsap;
function rawAsap(task) {
    if (!queue.length) {
        requestFlush();
        flushing = true;
    }
    // Equivalent to push, but avoids a function call.
    queue[queue.length] = task;
}

var queue = [];
// Once a flush has been requested, no further calls to `requestFlush` are
// necessary until the next `flush` completes.
var flushing = false;
// `requestFlush` is an implementation-specific method that attempts to kick
// off a `flush` event as quickly as possible. `flush` will attempt to exhaust
// the event queue before yielding to the browser's own event loop.
var requestFlush;
// The position of the next task to execute in the task queue. This is
// preserved between calls to `flush` so that it can be resumed if
// a task throws an exception.
var index = 0;
// If a task schedules additional tasks recursively, the task queue can grow
// unbounded. To prevent memory exhaustion, the task queue will periodically
// truncate already-completed tasks.
var capacity = 1024;

// The flush function processes all tasks that have been scheduled with
// `rawAsap` unless and until one of those tasks throws an exception.
// If a task throws an exception, `flush` ensures that its state will remain
// consistent and will resume where it left off when called again.
// However, `flush` does not make any arrangements to be called again if an
// exception is thrown.
function flush() {
    while (index < queue.length) {
        var currentIndex = index;
        // Advance the index before calling the task. This ensures that we will
        // begin flushing on the next task the task throws an error.
        index = index + 1;
        queue[currentIndex].call();
        // Prevent leaking memory for long chains of recursive calls to `asap`.
        // If we call `asap` within tasks scheduled by `asap`, the queue will
        // grow, but to avoid an O(n) walk for every task we execute, we don't
        // shift tasks off the queue after they have been executed.
        // Instead, we periodically shift 1024 tasks off the queue.
        if (index > capacity) {
            // Manually shift all values starting at the index back to the
            // beginning of the queue.
            for (var scan = 0, newLength = queue.length - index; scan < newLength; scan++) {
                queue[scan] = queue[scan + index];
            }
            queue.length -= index;
            index = 0;
        }
    }
    queue.length = 0;
    index = 0;
    flushing = false;
}

// `requestFlush` is implemented using a strategy based on data collected from
// every available SauceLabs Selenium web driver worker at time of writing.
// https://docs.google.com/spreadsheets/d/1mG-5UYGup5qxGdEMWkhP6BWCz053NUb2E1QoUTU16uA/edit#gid=783724593

// Safari 6 and 6.1 for desktop, iPad, and iPhone are the only browsers that
// have WebKitMutationObserver but not un-prefixed MutationObserver.
// Must use `global` or `self` instead of `window` to work in both frames and web
// workers. `global` is a provision of Browserify, Mr, Mrs, or Mop.

/* globals self */
var scope = typeof global !== "undefined" ? global : self;
var BrowserMutationObserver = scope.MutationObserver || scope.WebKitMutationObserver;

// MutationObservers are desirable because they have high priority and work
// reliably everywhere they are implemented.
// They are implemented in all modern browsers.
//
// - Android 4-4.3
// - Chrome 26-34
// - Firefox 14-29
// - Internet Explorer 11
// - iPad Safari 6-7.1
// - iPhone Safari 7-7.1
// - Safari 6-7
if (typeof BrowserMutationObserver === "function") {
    requestFlush = makeRequestCallFromMutationObserver(flush);

// MessageChannels are desirable because they give direct access to the HTML
// task queue, are implemented in Internet Explorer 10, Safari 5.0-1, and Opera
// 11-12, and in web workers in many engines.
// Although message channels yield to any queued rendering and IO tasks, they
// would be better than imposing the 4ms delay of timers.
// However, they do not work reliably in Internet Explorer or Safari.

// Internet Explorer 10 is the only browser that has setImmediate but does
// not have MutationObservers.
// Although setImmediate yields to the browser's renderer, it would be
// preferrable to falling back to setTimeout since it does not have
// the minimum 4ms penalty.
// Unfortunately there appears to be a bug in Internet Explorer 10 Mobile (and
// Desktop to a lesser extent) that renders both setImmediate and
// MessageChannel useless for the purposes of ASAP.
// https://github.com/kriskowal/q/issues/396

// Timers are implemented universally.
// We fall back to timers in workers in most engines, and in foreground
// contexts in the following browsers.
// However, note that even this simple case requires nuances to operate in a
// broad spectrum of browsers.
//
// - Firefox 3-13
// - Internet Explorer 6-9
// - iPad Safari 4.3
// - Lynx 2.8.7
} else {
    requestFlush = makeRequestCallFromTimer(flush);
}

// `requestFlush` requests that the high priority event queue be flushed as
// soon as possible.
// This is useful to prevent an error thrown in a task from stalling the event
// queue if the exception handled by Node.js’s
// `process.on("uncaughtException")` or by a domain.
rawAsap.requestFlush = requestFlush;

// To request a high priority event, we induce a mutation observer by toggling
// the text of a text node between "1" and "-1".
function makeRequestCallFromMutationObserver(callback) {
    var toggle = 1;
    var observer = new BrowserMutationObserver(callback);
    var node = document.createTextNode("");
    observer.observe(node, {characterData: true});
    return function requestCall() {
        toggle = -toggle;
        node.data = toggle;
    };
}

// The message channel technique was discovered by Malte Ubl and was the
// original foundation for this library.
// http://www.nonblocking.io/2011/06/windownexttick.html

// Safari 6.0.5 (at least) intermittently fails to create message ports on a
// page's first load. Thankfully, this version of Safari supports
// MutationObservers, so we don't need to fall back in that case.

// function makeRequestCallFromMessageChannel(callback) {
//     var channel = new MessageChannel();
//     channel.port1.onmessage = callback;
//     return function requestCall() {
//         channel.port2.postMessage(0);
//     };
// }

// For reasons explained above, we are also unable to use `setImmediate`
// under any circumstances.
// Even if we were, there is another bug in Internet Explorer 10.
// It is not sufficient to assign `setImmediate` to `requestFlush` because
// `setImmediate` must be called *by name* and therefore must be wrapped in a
// closure.
// Never forget.

// function makeRequestCallFromSetImmediate(callback) {
//     return function requestCall() {
//         setImmediate(callback);
//     };
// }

// Safari 6.0 has a problem where timers will get lost while the user is
// scrolling. This problem does not impact ASAP because Safari 6.0 supports
// mutation observers, so that implementation is used instead.
// However, if we ever elect to use timers in Safari, the prevalent work-around
// is to add a scroll event listener that calls for a flush.

// `setTimeout` does not call the passed callback if the delay is less than
// approximately 7 in web workers in Firefox 8 through 18, and sometimes not
// even then.

function makeRequestCallFromTimer(callback) {
    return function requestCall() {
        // We dispatch a timeout with a specified delay of 0 for engines that
        // can reliably accommodate that request. This will usually be snapped
        // to a 4 milisecond delay, but once we're flushing, there's no delay
        // between events.
        var timeoutHandle = setTimeout(handleTimer, 0);
        // However, since this timer gets frequently dropped in Firefox
        // workers, we enlist an interval handle that will try to fire
        // an event 20 times per second until it succeeds.
        var intervalHandle = setInterval(handleTimer, 50);

        function handleTimer() {
            // Whichever timer succeeds will cancel both timers and
            // execute the callback.
            clearTimeout(timeoutHandle);
            clearInterval(intervalHandle);
            callback();
        }
    };
}

// This is for `asap.js` only.
// Its name will be periodically randomized to break any code that depends on
// its existence.
rawAsap.makeRequestCallFromTimer = makeRequestCallFromTimer;

// ASAP was originally a nextTick shim included in Q. This was factored out
// into this ASAP package. It was later adapted to RSVP which made further
// amendments. These decisions, particularly to marginalize MessageChannel and
// to capture the MutationObserver implementation in a closure, were integrated
// back into ASAP proper.
// https://github.com/tildeio/rsvp.js/blob/cddf7232546a9cf858524b75cde6f9edf72620a7/lib/rsvp/asap.js

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(36)))

/***/ }),
/* 375 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//This file contains the ES6 extensions to the core Promises/A+ API

var Promise = __webpack_require__(215);

module.exports = Promise;

/* Static Functions */

var TRUE = valuePromise(true);
var FALSE = valuePromise(false);
var NULL = valuePromise(null);
var UNDEFINED = valuePromise(undefined);
var ZERO = valuePromise(0);
var EMPTYSTRING = valuePromise('');

function valuePromise(value) {
  var p = new Promise(Promise._44);
  p._83 = 1;
  p._18 = value;
  return p;
}
Promise.resolve = function (value) {
  if (value instanceof Promise) return value;

  if (value === null) return NULL;
  if (value === undefined) return UNDEFINED;
  if (value === true) return TRUE;
  if (value === false) return FALSE;
  if (value === 0) return ZERO;
  if (value === '') return EMPTYSTRING;

  if (typeof value === 'object' || typeof value === 'function') {
    try {
      var then = value.then;
      if (typeof then === 'function') {
        return new Promise(then.bind(value));
      }
    } catch (ex) {
      return new Promise(function (resolve, reject) {
        reject(ex);
      });
    }
  }
  return valuePromise(value);
};

Promise.all = function (arr) {
  var args = Array.prototype.slice.call(arr);

  return new Promise(function (resolve, reject) {
    if (args.length === 0) return resolve([]);
    var remaining = args.length;
    function res(i, val) {
      if (val && (typeof val === 'object' || typeof val === 'function')) {
        if (val instanceof Promise && val.then === Promise.prototype.then) {
          while (val._83 === 3) {
            val = val._18;
          }
          if (val._83 === 1) return res(i, val._18);
          if (val._83 === 2) reject(val._18);
          val.then(function (val) {
            res(i, val);
          }, reject);
          return;
        } else {
          var then = val.then;
          if (typeof then === 'function') {
            var p = new Promise(then.bind(val));
            p.then(function (val) {
              res(i, val);
            }, reject);
            return;
          }
        }
      }
      args[i] = val;
      if (--remaining === 0) {
        resolve(args);
      }
    }
    for (var i = 0; i < args.length; i++) {
      res(i, args[i]);
    }
  });
};

Promise.reject = function (value) {
  return new Promise(function (resolve, reject) {
    reject(value);
  });
};

Promise.race = function (values) {
  return new Promise(function (resolve, reject) {
    values.forEach(function(value){
      Promise.resolve(value).then(resolve, reject);
    });
  });
};

/* Prototype Methods */

Promise.prototype['catch'] = function (onRejected) {
  return this.then(null, onRejected);
};


/***/ }),
/* 376 */
/***/ (function(module, exports) {

(function(self) {
  'use strict';

  if (self.fetch) {
    return
  }

  var support = {
    searchParams: 'URLSearchParams' in self,
    iterable: 'Symbol' in self && 'iterator' in Symbol,
    blob: 'FileReader' in self && 'Blob' in self && (function() {
      try {
        new Blob()
        return true
      } catch(e) {
        return false
      }
    })(),
    formData: 'FormData' in self,
    arrayBuffer: 'ArrayBuffer' in self
  }

  if (support.arrayBuffer) {
    var viewClasses = [
      '[object Int8Array]',
      '[object Uint8Array]',
      '[object Uint8ClampedArray]',
      '[object Int16Array]',
      '[object Uint16Array]',
      '[object Int32Array]',
      '[object Uint32Array]',
      '[object Float32Array]',
      '[object Float64Array]'
    ]

    var isDataView = function(obj) {
      return obj && DataView.prototype.isPrototypeOf(obj)
    }

    var isArrayBufferView = ArrayBuffer.isView || function(obj) {
      return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
    }
  }

  function normalizeName(name) {
    if (typeof name !== 'string') {
      name = String(name)
    }
    if (/[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(name)) {
      throw new TypeError('Invalid character in header field name')
    }
    return name.toLowerCase()
  }

  function normalizeValue(value) {
    if (typeof value !== 'string') {
      value = String(value)
    }
    return value
  }

  // Build a destructive iterator for the value list
  function iteratorFor(items) {
    var iterator = {
      next: function() {
        var value = items.shift()
        return {done: value === undefined, value: value}
      }
    }

    if (support.iterable) {
      iterator[Symbol.iterator] = function() {
        return iterator
      }
    }

    return iterator
  }

  function Headers(headers) {
    this.map = {}

    if (headers instanceof Headers) {
      headers.forEach(function(value, name) {
        this.append(name, value)
      }, this)
    } else if (Array.isArray(headers)) {
      headers.forEach(function(header) {
        this.append(header[0], header[1])
      }, this)
    } else if (headers) {
      Object.getOwnPropertyNames(headers).forEach(function(name) {
        this.append(name, headers[name])
      }, this)
    }
  }

  Headers.prototype.append = function(name, value) {
    name = normalizeName(name)
    value = normalizeValue(value)
    var oldValue = this.map[name]
    this.map[name] = oldValue ? oldValue+','+value : value
  }

  Headers.prototype['delete'] = function(name) {
    delete this.map[normalizeName(name)]
  }

  Headers.prototype.get = function(name) {
    name = normalizeName(name)
    return this.has(name) ? this.map[name] : null
  }

  Headers.prototype.has = function(name) {
    return this.map.hasOwnProperty(normalizeName(name))
  }

  Headers.prototype.set = function(name, value) {
    this.map[normalizeName(name)] = normalizeValue(value)
  }

  Headers.prototype.forEach = function(callback, thisArg) {
    for (var name in this.map) {
      if (this.map.hasOwnProperty(name)) {
        callback.call(thisArg, this.map[name], name, this)
      }
    }
  }

  Headers.prototype.keys = function() {
    var items = []
    this.forEach(function(value, name) { items.push(name) })
    return iteratorFor(items)
  }

  Headers.prototype.values = function() {
    var items = []
    this.forEach(function(value) { items.push(value) })
    return iteratorFor(items)
  }

  Headers.prototype.entries = function() {
    var items = []
    this.forEach(function(value, name) { items.push([name, value]) })
    return iteratorFor(items)
  }

  if (support.iterable) {
    Headers.prototype[Symbol.iterator] = Headers.prototype.entries
  }

  function consumed(body) {
    if (body.bodyUsed) {
      return Promise.reject(new TypeError('Already read'))
    }
    body.bodyUsed = true
  }

  function fileReaderReady(reader) {
    return new Promise(function(resolve, reject) {
      reader.onload = function() {
        resolve(reader.result)
      }
      reader.onerror = function() {
        reject(reader.error)
      }
    })
  }

  function readBlobAsArrayBuffer(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsArrayBuffer(blob)
    return promise
  }

  function readBlobAsText(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsText(blob)
    return promise
  }

  function readArrayBufferAsText(buf) {
    var view = new Uint8Array(buf)
    var chars = new Array(view.length)

    for (var i = 0; i < view.length; i++) {
      chars[i] = String.fromCharCode(view[i])
    }
    return chars.join('')
  }

  function bufferClone(buf) {
    if (buf.slice) {
      return buf.slice(0)
    } else {
      var view = new Uint8Array(buf.byteLength)
      view.set(new Uint8Array(buf))
      return view.buffer
    }
  }

  function Body() {
    this.bodyUsed = false

    this._initBody = function(body) {
      this._bodyInit = body
      if (!body) {
        this._bodyText = ''
      } else if (typeof body === 'string') {
        this._bodyText = body
      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
        this._bodyBlob = body
      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
        this._bodyFormData = body
      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
        this._bodyText = body.toString()
      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
        this._bodyArrayBuffer = bufferClone(body.buffer)
        // IE 10-11 can't handle a DataView body.
        this._bodyInit = new Blob([this._bodyArrayBuffer])
      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
        this._bodyArrayBuffer = bufferClone(body)
      } else {
        throw new Error('unsupported BodyInit type')
      }

      if (!this.headers.get('content-type')) {
        if (typeof body === 'string') {
          this.headers.set('content-type', 'text/plain;charset=UTF-8')
        } else if (this._bodyBlob && this._bodyBlob.type) {
          this.headers.set('content-type', this._bodyBlob.type)
        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8')
        }
      }
    }

    if (support.blob) {
      this.blob = function() {
        var rejected = consumed(this)
        if (rejected) {
          return rejected
        }

        if (this._bodyBlob) {
          return Promise.resolve(this._bodyBlob)
        } else if (this._bodyArrayBuffer) {
          return Promise.resolve(new Blob([this._bodyArrayBuffer]))
        } else if (this._bodyFormData) {
          throw new Error('could not read FormData body as blob')
        } else {
          return Promise.resolve(new Blob([this._bodyText]))
        }
      }

      this.arrayBuffer = function() {
        if (this._bodyArrayBuffer) {
          return consumed(this) || Promise.resolve(this._bodyArrayBuffer)
        } else {
          return this.blob().then(readBlobAsArrayBuffer)
        }
      }
    }

    this.text = function() {
      var rejected = consumed(this)
      if (rejected) {
        return rejected
      }

      if (this._bodyBlob) {
        return readBlobAsText(this._bodyBlob)
      } else if (this._bodyArrayBuffer) {
        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
      } else if (this._bodyFormData) {
        throw new Error('could not read FormData body as text')
      } else {
        return Promise.resolve(this._bodyText)
      }
    }

    if (support.formData) {
      this.formData = function() {
        return this.text().then(decode)
      }
    }

    this.json = function() {
      return this.text().then(JSON.parse)
    }

    return this
  }

  // HTTP methods whose capitalization should be normalized
  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT']

  function normalizeMethod(method) {
    var upcased = method.toUpperCase()
    return (methods.indexOf(upcased) > -1) ? upcased : method
  }

  function Request(input, options) {
    options = options || {}
    var body = options.body

    if (input instanceof Request) {
      if (input.bodyUsed) {
        throw new TypeError('Already read')
      }
      this.url = input.url
      this.credentials = input.credentials
      if (!options.headers) {
        this.headers = new Headers(input.headers)
      }
      this.method = input.method
      this.mode = input.mode
      if (!body && input._bodyInit != null) {
        body = input._bodyInit
        input.bodyUsed = true
      }
    } else {
      this.url = String(input)
    }

    this.credentials = options.credentials || this.credentials || 'omit'
    if (options.headers || !this.headers) {
      this.headers = new Headers(options.headers)
    }
    this.method = normalizeMethod(options.method || this.method || 'GET')
    this.mode = options.mode || this.mode || null
    this.referrer = null

    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
      throw new TypeError('Body not allowed for GET or HEAD requests')
    }
    this._initBody(body)
  }

  Request.prototype.clone = function() {
    return new Request(this, { body: this._bodyInit })
  }

  function decode(body) {
    var form = new FormData()
    body.trim().split('&').forEach(function(bytes) {
      if (bytes) {
        var split = bytes.split('=')
        var name = split.shift().replace(/\+/g, ' ')
        var value = split.join('=').replace(/\+/g, ' ')
        form.append(decodeURIComponent(name), decodeURIComponent(value))
      }
    })
    return form
  }

  function parseHeaders(rawHeaders) {
    var headers = new Headers()
    rawHeaders.split(/\r?\n/).forEach(function(line) {
      var parts = line.split(':')
      var key = parts.shift().trim()
      if (key) {
        var value = parts.join(':').trim()
        headers.append(key, value)
      }
    })
    return headers
  }

  Body.call(Request.prototype)

  function Response(bodyInit, options) {
    if (!options) {
      options = {}
    }

    this.type = 'default'
    this.status = 'status' in options ? options.status : 200
    this.ok = this.status >= 200 && this.status < 300
    this.statusText = 'statusText' in options ? options.statusText : 'OK'
    this.headers = new Headers(options.headers)
    this.url = options.url || ''
    this._initBody(bodyInit)
  }

  Body.call(Response.prototype)

  Response.prototype.clone = function() {
    return new Response(this._bodyInit, {
      status: this.status,
      statusText: this.statusText,
      headers: new Headers(this.headers),
      url: this.url
    })
  }

  Response.error = function() {
    var response = new Response(null, {status: 0, statusText: ''})
    response.type = 'error'
    return response
  }

  var redirectStatuses = [301, 302, 303, 307, 308]

  Response.redirect = function(url, status) {
    if (redirectStatuses.indexOf(status) === -1) {
      throw new RangeError('Invalid status code')
    }

    return new Response(null, {status: status, headers: {location: url}})
  }

  self.Headers = Headers
  self.Request = Request
  self.Response = Response

  self.fetch = function(input, init) {
    return new Promise(function(resolve, reject) {
      var request = new Request(input, init)
      var xhr = new XMLHttpRequest()

      xhr.onload = function() {
        var options = {
          status: xhr.status,
          statusText: xhr.statusText,
          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
        }
        options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL')
        var body = 'response' in xhr ? xhr.response : xhr.responseText
        resolve(new Response(body, options))
      }

      xhr.onerror = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.ontimeout = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.open(request.method, request.url, true)

      if (request.credentials === 'include') {
        xhr.withCredentials = true
      }

      if ('responseType' in xhr && support.blob) {
        xhr.responseType = 'blob'
      }

      request.headers.forEach(function(value, name) {
        xhr.setRequestHeader(name, value)
      })

      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit)
    })
  }
  self.fetch.polyfill = true
})(typeof self !== 'undefined' ? self : this);


/***/ }),
/* 377 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_thunk__ = __webpack_require__(385);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux__ = __webpack_require__(159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_history__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_redux__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_router_dom__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_routes_index_jsx__ = __webpack_require__(431);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__reducers_reducers__ = __webpack_require__(1010);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__config_axios__ = __webpack_require__(180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__config_moment__ = __webpack_require__(1013);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__config_chart__ = __webpack_require__(1014);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_assets_scss_material_dashboard_pro_react_css__ = __webpack_require__(1015);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_assets_scss_material_dashboard_pro_react_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_assets_scss_material_dashboard_pro_react_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_moment_locale_pt_br__ = __webpack_require__(1016);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_moment_locale_pt_br___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_moment_locale_pt_br__);
var composeEnhancers=__WEBPACK_IMPORTED_MODULE_3_redux__["d" /* compose */];var middleware=[__WEBPACK_IMPORTED_MODULE_2_redux_thunk__["a" /* default */]];if(false){composeEnhancers=window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__||composeEnhancers;middleware.push(require('redux-freeze'));}var hist=Object(__WEBPACK_IMPORTED_MODULE_4_history__["a" /* createBrowserHistory */])();var store=Object(__WEBPACK_IMPORTED_MODULE_3_redux__["e" /* createStore */])(__WEBPACK_IMPORTED_MODULE_8__reducers_reducers__["a" /* default */],composeEnhancers(__WEBPACK_IMPORTED_MODULE_3_redux__["a" /* applyMiddleware */].apply(undefined,middleware)));Object(__WEBPACK_IMPORTED_MODULE_9__config_axios__["a" /* axiosProductionURLSetup */])();Object(__WEBPACK_IMPORTED_MODULE_10__config_moment__["a" /* momentConfigLocale */])();Object(__WEBPACK_IMPORTED_MODULE_9__config_axios__["c" /* redirectWhenUnauthorized */])(store);__WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.render(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_redux__["a" /* Provider */],{store:store},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_router_dom__["c" /* Router */],{history:hist},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_router_dom__["d" /* Switch */],null,__WEBPACK_IMPORTED_MODULE_7_routes_index_jsx__["a" /* default */].map(function(prop,key){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_router_dom__["b" /* Route */],{component:prop.component,key:key,path:prop.path});})))),document.getElementById("root"));

/***/ }),
/* 378 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.4.1
 * react.production.min.js
 *
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var k=__webpack_require__(113),n=__webpack_require__(216),p=__webpack_require__(217),q=__webpack_require__(218),r="function"===typeof Symbol&&Symbol.for,t=r?Symbol.for("react.element"):60103,u=r?Symbol.for("react.portal"):60106,v=r?Symbol.for("react.fragment"):60107,w=r?Symbol.for("react.strict_mode"):60108,x=r?Symbol.for("react.profiler"):60114,y=r?Symbol.for("react.provider"):60109,z=r?Symbol.for("react.context"):60110,A=r?Symbol.for("react.async_mode"):60111,B=
r?Symbol.for("react.forward_ref"):60112;r&&Symbol.for("react.timeout");var C="function"===typeof Symbol&&Symbol.iterator;function D(a){for(var b=arguments.length-1,e="https://reactjs.org/docs/error-decoder.html?invariant="+a,c=0;c<b;c++)e+="&args[]="+encodeURIComponent(arguments[c+1]);n(!1,"Minified React error #"+a+"; visit %s for the full message or use the non-minified dev environment for full errors and additional helpful warnings. ",e)}
var E={isMounted:function(){return!1},enqueueForceUpdate:function(){},enqueueReplaceState:function(){},enqueueSetState:function(){}};function F(a,b,e){this.props=a;this.context=b;this.refs=p;this.updater=e||E}F.prototype.isReactComponent={};F.prototype.setState=function(a,b){"object"!==typeof a&&"function"!==typeof a&&null!=a?D("85"):void 0;this.updater.enqueueSetState(this,a,b,"setState")};F.prototype.forceUpdate=function(a){this.updater.enqueueForceUpdate(this,a,"forceUpdate")};function G(){}
G.prototype=F.prototype;function H(a,b,e){this.props=a;this.context=b;this.refs=p;this.updater=e||E}var I=H.prototype=new G;I.constructor=H;k(I,F.prototype);I.isPureReactComponent=!0;var J={current:null},K=Object.prototype.hasOwnProperty,L={key:!0,ref:!0,__self:!0,__source:!0};
function M(a,b,e){var c=void 0,d={},g=null,h=null;if(null!=b)for(c in void 0!==b.ref&&(h=b.ref),void 0!==b.key&&(g=""+b.key),b)K.call(b,c)&&!L.hasOwnProperty(c)&&(d[c]=b[c]);var f=arguments.length-2;if(1===f)d.children=e;else if(1<f){for(var l=Array(f),m=0;m<f;m++)l[m]=arguments[m+2];d.children=l}if(a&&a.defaultProps)for(c in f=a.defaultProps,f)void 0===d[c]&&(d[c]=f[c]);return{$$typeof:t,type:a,key:g,ref:h,props:d,_owner:J.current}}
function N(a){return"object"===typeof a&&null!==a&&a.$$typeof===t}function escape(a){var b={"=":"=0",":":"=2"};return"$"+(""+a).replace(/[=:]/g,function(a){return b[a]})}var O=/\/+/g,P=[];function Q(a,b,e,c){if(P.length){var d=P.pop();d.result=a;d.keyPrefix=b;d.func=e;d.context=c;d.count=0;return d}return{result:a,keyPrefix:b,func:e,context:c,count:0}}function R(a){a.result=null;a.keyPrefix=null;a.func=null;a.context=null;a.count=0;10>P.length&&P.push(a)}
function S(a,b,e,c){var d=typeof a;if("undefined"===d||"boolean"===d)a=null;var g=!1;if(null===a)g=!0;else switch(d){case "string":case "number":g=!0;break;case "object":switch(a.$$typeof){case t:case u:g=!0}}if(g)return e(c,a,""===b?"."+T(a,0):b),1;g=0;b=""===b?".":b+":";if(Array.isArray(a))for(var h=0;h<a.length;h++){d=a[h];var f=b+T(d,h);g+=S(d,f,e,c)}else if(null===a||"undefined"===typeof a?f=null:(f=C&&a[C]||a["@@iterator"],f="function"===typeof f?f:null),"function"===typeof f)for(a=f.call(a),
h=0;!(d=a.next()).done;)d=d.value,f=b+T(d,h++),g+=S(d,f,e,c);else"object"===d&&(e=""+a,D("31","[object Object]"===e?"object with keys {"+Object.keys(a).join(", ")+"}":e,""));return g}function T(a,b){return"object"===typeof a&&null!==a&&null!=a.key?escape(a.key):b.toString(36)}function U(a,b){a.func.call(a.context,b,a.count++)}
function V(a,b,e){var c=a.result,d=a.keyPrefix;a=a.func.call(a.context,b,a.count++);Array.isArray(a)?W(a,c,e,q.thatReturnsArgument):null!=a&&(N(a)&&(b=d+(!a.key||b&&b.key===a.key?"":(""+a.key).replace(O,"$&/")+"/")+e,a={$$typeof:t,type:a.type,key:b,ref:a.ref,props:a.props,_owner:a._owner}),c.push(a))}function W(a,b,e,c,d){var g="";null!=e&&(g=(""+e).replace(O,"$&/")+"/");b=Q(b,g,c,d);null==a||S(a,"",V,b);R(b)}
var X={Children:{map:function(a,b,e){if(null==a)return a;var c=[];W(a,c,null,b,e);return c},forEach:function(a,b,e){if(null==a)return a;b=Q(null,null,b,e);null==a||S(a,"",U,b);R(b)},count:function(a){return null==a?0:S(a,"",q.thatReturnsNull,null)},toArray:function(a){var b=[];W(a,b,null,q.thatReturnsArgument);return b},only:function(a){N(a)?void 0:D("143");return a}},createRef:function(){return{current:null}},Component:F,PureComponent:H,createContext:function(a,b){void 0===b&&(b=null);a={$$typeof:z,
_calculateChangedBits:b,_defaultValue:a,_currentValue:a,_currentValue2:a,_changedBits:0,_changedBits2:0,Provider:null,Consumer:null};a.Provider={$$typeof:y,_context:a};return a.Consumer=a},forwardRef:function(a){return{$$typeof:B,render:a}},Fragment:v,StrictMode:w,unstable_AsyncMode:A,unstable_Profiler:x,createElement:M,cloneElement:function(a,b,e){null===a||void 0===a?D("267",a):void 0;var c=void 0,d=k({},a.props),g=a.key,h=a.ref,f=a._owner;if(null!=b){void 0!==b.ref&&(h=b.ref,f=J.current);void 0!==
b.key&&(g=""+b.key);var l=void 0;a.type&&a.type.defaultProps&&(l=a.type.defaultProps);for(c in b)K.call(b,c)&&!L.hasOwnProperty(c)&&(d[c]=void 0===b[c]&&void 0!==l?l[c]:b[c])}c=arguments.length-2;if(1===c)d.children=e;else if(1<c){l=Array(c);for(var m=0;m<c;m++)l[m]=arguments[m+2];d.children=l}return{$$typeof:t,type:a.type,key:g,ref:h,props:d,_owner:f}},createFactory:function(a){var b=M.bind(null,a);b.type=a;return b},isValidElement:N,version:"16.4.1",__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED:{ReactCurrentOwner:J,
assign:k}},Y={default:X},Z=Y&&X||Y;module.exports=Z.default?Z.default:Z;


/***/ }),
/* 379 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.4.1
 * react-dom.production.min.js
 *
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

/*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/
var aa=__webpack_require__(216),ba=__webpack_require__(0),m=__webpack_require__(380),p=__webpack_require__(113),v=__webpack_require__(218),da=__webpack_require__(381),ea=__webpack_require__(158),fa=__webpack_require__(382),ha=__webpack_require__(217);
function A(a){for(var b=arguments.length-1,c="https://reactjs.org/docs/error-decoder.html?invariant="+a,d=0;d<b;d++)c+="&args[]="+encodeURIComponent(arguments[d+1]);aa(!1,"Minified React error #"+a+"; visit %s for the full message or use the non-minified dev environment for full errors and additional helpful warnings. ",c)}ba?void 0:A("227");
function ia(a,b,c,d,e,f,g,h,k){this._hasCaughtError=!1;this._caughtError=null;var n=Array.prototype.slice.call(arguments,3);try{b.apply(c,n)}catch(r){this._caughtError=r,this._hasCaughtError=!0}}
var B={_caughtError:null,_hasCaughtError:!1,_rethrowError:null,_hasRethrowError:!1,invokeGuardedCallback:function(a,b,c,d,e,f,g,h,k){ia.apply(B,arguments)},invokeGuardedCallbackAndCatchFirstError:function(a,b,c,d,e,f,g,h,k){B.invokeGuardedCallback.apply(this,arguments);if(B.hasCaughtError()){var n=B.clearCaughtError();B._hasRethrowError||(B._hasRethrowError=!0,B._rethrowError=n)}},rethrowCaughtError:function(){return ka.apply(B,arguments)},hasCaughtError:function(){return B._hasCaughtError},clearCaughtError:function(){if(B._hasCaughtError){var a=
B._caughtError;B._caughtError=null;B._hasCaughtError=!1;return a}A("198")}};function ka(){if(B._hasRethrowError){var a=B._rethrowError;B._rethrowError=null;B._hasRethrowError=!1;throw a;}}var la=null,ma={};
function na(){if(la)for(var a in ma){var b=ma[a],c=la.indexOf(a);-1<c?void 0:A("96",a);if(!oa[c]){b.extractEvents?void 0:A("97",a);oa[c]=b;c=b.eventTypes;for(var d in c){var e=void 0;var f=c[d],g=b,h=d;pa.hasOwnProperty(h)?A("99",h):void 0;pa[h]=f;var k=f.phasedRegistrationNames;if(k){for(e in k)k.hasOwnProperty(e)&&qa(k[e],g,h);e=!0}else f.registrationName?(qa(f.registrationName,g,h),e=!0):e=!1;e?void 0:A("98",d,a)}}}}
function qa(a,b,c){ra[a]?A("100",a):void 0;ra[a]=b;sa[a]=b.eventTypes[c].dependencies}var oa=[],pa={},ra={},sa={};function ta(a){la?A("101"):void 0;la=Array.prototype.slice.call(a);na()}function ua(a){var b=!1,c;for(c in a)if(a.hasOwnProperty(c)){var d=a[c];ma.hasOwnProperty(c)&&ma[c]===d||(ma[c]?A("102",c):void 0,ma[c]=d,b=!0)}b&&na()}
var va={plugins:oa,eventNameDispatchConfigs:pa,registrationNameModules:ra,registrationNameDependencies:sa,possibleRegistrationNames:null,injectEventPluginOrder:ta,injectEventPluginsByName:ua},wa=null,xa=null,ya=null;function za(a,b,c,d){b=a.type||"unknown-event";a.currentTarget=ya(d);B.invokeGuardedCallbackAndCatchFirstError(b,c,void 0,a);a.currentTarget=null}
function Aa(a,b){null==b?A("30"):void 0;if(null==a)return b;if(Array.isArray(a)){if(Array.isArray(b))return a.push.apply(a,b),a;a.push(b);return a}return Array.isArray(b)?[a].concat(b):[a,b]}function Ba(a,b,c){Array.isArray(a)?a.forEach(b,c):a&&b.call(c,a)}var Ca=null;
function Da(a,b){if(a){var c=a._dispatchListeners,d=a._dispatchInstances;if(Array.isArray(c))for(var e=0;e<c.length&&!a.isPropagationStopped();e++)za(a,b,c[e],d[e]);else c&&za(a,b,c,d);a._dispatchListeners=null;a._dispatchInstances=null;a.isPersistent()||a.constructor.release(a)}}function Ea(a){return Da(a,!0)}function Fa(a){return Da(a,!1)}var Ga={injectEventPluginOrder:ta,injectEventPluginsByName:ua};
function Ha(a,b){var c=a.stateNode;if(!c)return null;var d=wa(c);if(!d)return null;c=d[b];a:switch(b){case "onClick":case "onClickCapture":case "onDoubleClick":case "onDoubleClickCapture":case "onMouseDown":case "onMouseDownCapture":case "onMouseMove":case "onMouseMoveCapture":case "onMouseUp":case "onMouseUpCapture":(d=!d.disabled)||(a=a.type,d=!("button"===a||"input"===a||"select"===a||"textarea"===a));a=!d;break a;default:a=!1}if(a)return null;c&&"function"!==typeof c?A("231",b,typeof c):void 0;
return c}function Ia(a,b){null!==a&&(Ca=Aa(Ca,a));a=Ca;Ca=null;a&&(b?Ba(a,Ea):Ba(a,Fa),Ca?A("95"):void 0,B.rethrowCaughtError())}function Ja(a,b,c,d){for(var e=null,f=0;f<oa.length;f++){var g=oa[f];g&&(g=g.extractEvents(a,b,c,d))&&(e=Aa(e,g))}Ia(e,!1)}var Ka={injection:Ga,getListener:Ha,runEventsInBatch:Ia,runExtractedEventsInBatch:Ja},La=Math.random().toString(36).slice(2),C="__reactInternalInstance$"+La,Ma="__reactEventHandlers$"+La;
function Na(a){if(a[C])return a[C];for(;!a[C];)if(a.parentNode)a=a.parentNode;else return null;a=a[C];return 5===a.tag||6===a.tag?a:null}function Oa(a){if(5===a.tag||6===a.tag)return a.stateNode;A("33")}function Pa(a){return a[Ma]||null}var Qa={precacheFiberNode:function(a,b){b[C]=a},getClosestInstanceFromNode:Na,getInstanceFromNode:function(a){a=a[C];return!a||5!==a.tag&&6!==a.tag?null:a},getNodeFromInstance:Oa,getFiberCurrentPropsFromNode:Pa,updateFiberProps:function(a,b){a[Ma]=b}};
function F(a){do a=a.return;while(a&&5!==a.tag);return a?a:null}function Ra(a,b,c){for(var d=[];a;)d.push(a),a=F(a);for(a=d.length;0<a--;)b(d[a],"captured",c);for(a=0;a<d.length;a++)b(d[a],"bubbled",c)}function Sa(a,b,c){if(b=Ha(a,c.dispatchConfig.phasedRegistrationNames[b]))c._dispatchListeners=Aa(c._dispatchListeners,b),c._dispatchInstances=Aa(c._dispatchInstances,a)}function Ta(a){a&&a.dispatchConfig.phasedRegistrationNames&&Ra(a._targetInst,Sa,a)}
function Ua(a){if(a&&a.dispatchConfig.phasedRegistrationNames){var b=a._targetInst;b=b?F(b):null;Ra(b,Sa,a)}}function Va(a,b,c){a&&c&&c.dispatchConfig.registrationName&&(b=Ha(a,c.dispatchConfig.registrationName))&&(c._dispatchListeners=Aa(c._dispatchListeners,b),c._dispatchInstances=Aa(c._dispatchInstances,a))}function Xa(a){a&&a.dispatchConfig.registrationName&&Va(a._targetInst,null,a)}function Ya(a){Ba(a,Ta)}
function Za(a,b,c,d){if(c&&d)a:{var e=c;for(var f=d,g=0,h=e;h;h=F(h))g++;h=0;for(var k=f;k;k=F(k))h++;for(;0<g-h;)e=F(e),g--;for(;0<h-g;)f=F(f),h--;for(;g--;){if(e===f||e===f.alternate)break a;e=F(e);f=F(f)}e=null}else e=null;f=e;for(e=[];c&&c!==f;){g=c.alternate;if(null!==g&&g===f)break;e.push(c);c=F(c)}for(c=[];d&&d!==f;){g=d.alternate;if(null!==g&&g===f)break;c.push(d);d=F(d)}for(d=0;d<e.length;d++)Va(e[d],"bubbled",a);for(a=c.length;0<a--;)Va(c[a],"captured",b)}
var $a={accumulateTwoPhaseDispatches:Ya,accumulateTwoPhaseDispatchesSkipTarget:function(a){Ba(a,Ua)},accumulateEnterLeaveDispatches:Za,accumulateDirectDispatches:function(a){Ba(a,Xa)}};function ab(a,b){var c={};c[a.toLowerCase()]=b.toLowerCase();c["Webkit"+a]="webkit"+b;c["Moz"+a]="moz"+b;c["ms"+a]="MS"+b;c["O"+a]="o"+b.toLowerCase();return c}
var bb={animationend:ab("Animation","AnimationEnd"),animationiteration:ab("Animation","AnimationIteration"),animationstart:ab("Animation","AnimationStart"),transitionend:ab("Transition","TransitionEnd")},cb={},db={};m.canUseDOM&&(db=document.createElement("div").style,"AnimationEvent"in window||(delete bb.animationend.animation,delete bb.animationiteration.animation,delete bb.animationstart.animation),"TransitionEvent"in window||delete bb.transitionend.transition);
function eb(a){if(cb[a])return cb[a];if(!bb[a])return a;var b=bb[a],c;for(c in b)if(b.hasOwnProperty(c)&&c in db)return cb[a]=b[c];return a}var fb=eb("animationend"),gb=eb("animationiteration"),hb=eb("animationstart"),ib=eb("transitionend"),jb="abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange seeked seeking stalled suspend timeupdate volumechange waiting".split(" "),kb=null;
function lb(){!kb&&m.canUseDOM&&(kb="textContent"in document.documentElement?"textContent":"innerText");return kb}var G={_root:null,_startText:null,_fallbackText:null};function mb(){if(G._fallbackText)return G._fallbackText;var a,b=G._startText,c=b.length,d,e=nb(),f=e.length;for(a=0;a<c&&b[a]===e[a];a++);var g=c-a;for(d=1;d<=g&&b[c-d]===e[f-d];d++);G._fallbackText=e.slice(a,1<d?1-d:void 0);return G._fallbackText}function nb(){return"value"in G._root?G._root.value:G._root[lb()]}
var ob="dispatchConfig _targetInst nativeEvent isDefaultPrevented isPropagationStopped _dispatchListeners _dispatchInstances".split(" "),pb={type:null,target:null,currentTarget:v.thatReturnsNull,eventPhase:null,bubbles:null,cancelable:null,timeStamp:function(a){return a.timeStamp||Date.now()},defaultPrevented:null,isTrusted:null};
function H(a,b,c,d){this.dispatchConfig=a;this._targetInst=b;this.nativeEvent=c;a=this.constructor.Interface;for(var e in a)a.hasOwnProperty(e)&&((b=a[e])?this[e]=b(c):"target"===e?this.target=d:this[e]=c[e]);this.isDefaultPrevented=(null!=c.defaultPrevented?c.defaultPrevented:!1===c.returnValue)?v.thatReturnsTrue:v.thatReturnsFalse;this.isPropagationStopped=v.thatReturnsFalse;return this}
p(H.prototype,{preventDefault:function(){this.defaultPrevented=!0;var a=this.nativeEvent;a&&(a.preventDefault?a.preventDefault():"unknown"!==typeof a.returnValue&&(a.returnValue=!1),this.isDefaultPrevented=v.thatReturnsTrue)},stopPropagation:function(){var a=this.nativeEvent;a&&(a.stopPropagation?a.stopPropagation():"unknown"!==typeof a.cancelBubble&&(a.cancelBubble=!0),this.isPropagationStopped=v.thatReturnsTrue)},persist:function(){this.isPersistent=v.thatReturnsTrue},isPersistent:v.thatReturnsFalse,
destructor:function(){var a=this.constructor.Interface,b;for(b in a)this[b]=null;for(a=0;a<ob.length;a++)this[ob[a]]=null}});H.Interface=pb;H.extend=function(a){function b(){}function c(){return d.apply(this,arguments)}var d=this;b.prototype=d.prototype;var e=new b;p(e,c.prototype);c.prototype=e;c.prototype.constructor=c;c.Interface=p({},d.Interface,a);c.extend=d.extend;qb(c);return c};qb(H);
function rb(a,b,c,d){if(this.eventPool.length){var e=this.eventPool.pop();this.call(e,a,b,c,d);return e}return new this(a,b,c,d)}function sb(a){a instanceof this?void 0:A("223");a.destructor();10>this.eventPool.length&&this.eventPool.push(a)}function qb(a){a.eventPool=[];a.getPooled=rb;a.release=sb}var tb=H.extend({data:null}),ub=H.extend({data:null}),vb=[9,13,27,32],wb=m.canUseDOM&&"CompositionEvent"in window,xb=null;m.canUseDOM&&"documentMode"in document&&(xb=document.documentMode);
var yb=m.canUseDOM&&"TextEvent"in window&&!xb,zb=m.canUseDOM&&(!wb||xb&&8<xb&&11>=xb),Ab=String.fromCharCode(32),Bb={beforeInput:{phasedRegistrationNames:{bubbled:"onBeforeInput",captured:"onBeforeInputCapture"},dependencies:["compositionend","keypress","textInput","paste"]},compositionEnd:{phasedRegistrationNames:{bubbled:"onCompositionEnd",captured:"onCompositionEndCapture"},dependencies:"blur compositionend keydown keypress keyup mousedown".split(" ")},compositionStart:{phasedRegistrationNames:{bubbled:"onCompositionStart",
captured:"onCompositionStartCapture"},dependencies:"blur compositionstart keydown keypress keyup mousedown".split(" ")},compositionUpdate:{phasedRegistrationNames:{bubbled:"onCompositionUpdate",captured:"onCompositionUpdateCapture"},dependencies:"blur compositionupdate keydown keypress keyup mousedown".split(" ")}},Cb=!1;
function Db(a,b){switch(a){case "keyup":return-1!==vb.indexOf(b.keyCode);case "keydown":return 229!==b.keyCode;case "keypress":case "mousedown":case "blur":return!0;default:return!1}}function Eb(a){a=a.detail;return"object"===typeof a&&"data"in a?a.data:null}var Fb=!1;function Gb(a,b){switch(a){case "compositionend":return Eb(b);case "keypress":if(32!==b.which)return null;Cb=!0;return Ab;case "textInput":return a=b.data,a===Ab&&Cb?null:a;default:return null}}
function Hb(a,b){if(Fb)return"compositionend"===a||!wb&&Db(a,b)?(a=mb(),G._root=null,G._startText=null,G._fallbackText=null,Fb=!1,a):null;switch(a){case "paste":return null;case "keypress":if(!(b.ctrlKey||b.altKey||b.metaKey)||b.ctrlKey&&b.altKey){if(b.char&&1<b.char.length)return b.char;if(b.which)return String.fromCharCode(b.which)}return null;case "compositionend":return zb?null:b.data;default:return null}}
var Ib={eventTypes:Bb,extractEvents:function(a,b,c,d){var e=void 0;var f=void 0;if(wb)b:{switch(a){case "compositionstart":e=Bb.compositionStart;break b;case "compositionend":e=Bb.compositionEnd;break b;case "compositionupdate":e=Bb.compositionUpdate;break b}e=void 0}else Fb?Db(a,c)&&(e=Bb.compositionEnd):"keydown"===a&&229===c.keyCode&&(e=Bb.compositionStart);e?(zb&&(Fb||e!==Bb.compositionStart?e===Bb.compositionEnd&&Fb&&(f=mb()):(G._root=d,G._startText=nb(),Fb=!0)),e=tb.getPooled(e,b,c,d),f?e.data=
f:(f=Eb(c),null!==f&&(e.data=f)),Ya(e),f=e):f=null;(a=yb?Gb(a,c):Hb(a,c))?(b=ub.getPooled(Bb.beforeInput,b,c,d),b.data=a,Ya(b)):b=null;return null===f?b:null===b?f:[f,b]}},Jb=null,Kb={injectFiberControlledHostComponent:function(a){Jb=a}},Lb=null,Mb=null;function Nb(a){if(a=xa(a)){Jb&&"function"===typeof Jb.restoreControlledState?void 0:A("194");var b=wa(a.stateNode);Jb.restoreControlledState(a.stateNode,a.type,b)}}function Ob(a){Lb?Mb?Mb.push(a):Mb=[a]:Lb=a}
function Pb(){return null!==Lb||null!==Mb}function Qb(){if(Lb){var a=Lb,b=Mb;Mb=Lb=null;Nb(a);if(b)for(a=0;a<b.length;a++)Nb(b[a])}}var Rb={injection:Kb,enqueueStateRestore:Ob,needsStateRestore:Pb,restoreStateIfNeeded:Qb};function Sb(a,b){return a(b)}function Tb(a,b,c){return a(b,c)}function Ub(){}var Vb=!1;function Wb(a,b){if(Vb)return a(b);Vb=!0;try{return Sb(a,b)}finally{Vb=!1,Pb()&&(Ub(),Qb())}}
var Xb={color:!0,date:!0,datetime:!0,"datetime-local":!0,email:!0,month:!0,number:!0,password:!0,range:!0,search:!0,tel:!0,text:!0,time:!0,url:!0,week:!0};function Yb(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return"input"===b?!!Xb[a.type]:"textarea"===b?!0:!1}function Zb(a){a=a.target||a.srcElement||window;a.correspondingUseElement&&(a=a.correspondingUseElement);return 3===a.nodeType?a.parentNode:a}
function $b(a,b){if(!m.canUseDOM||b&&!("addEventListener"in document))return!1;a="on"+a;b=a in document;b||(b=document.createElement("div"),b.setAttribute(a,"return;"),b="function"===typeof b[a]);return b}function ac(a){var b=a.type;return(a=a.nodeName)&&"input"===a.toLowerCase()&&("checkbox"===b||"radio"===b)}
function bc(a){var b=ac(a)?"checked":"value",c=Object.getOwnPropertyDescriptor(a.constructor.prototype,b),d=""+a[b];if(!a.hasOwnProperty(b)&&"undefined"!==typeof c&&"function"===typeof c.get&&"function"===typeof c.set){var e=c.get,f=c.set;Object.defineProperty(a,b,{configurable:!0,get:function(){return e.call(this)},set:function(a){d=""+a;f.call(this,a)}});Object.defineProperty(a,b,{enumerable:c.enumerable});return{getValue:function(){return d},setValue:function(a){d=""+a},stopTracking:function(){a._valueTracker=
null;delete a[b]}}}}function cc(a){a._valueTracker||(a._valueTracker=bc(a))}function dc(a){if(!a)return!1;var b=a._valueTracker;if(!b)return!0;var c=b.getValue();var d="";a&&(d=ac(a)?a.checked?"true":"false":a.value);a=d;return a!==c?(b.setValue(a),!0):!1}
var ec=ba.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner,fc="function"===typeof Symbol&&Symbol.for,gc=fc?Symbol.for("react.element"):60103,hc=fc?Symbol.for("react.portal"):60106,ic=fc?Symbol.for("react.fragment"):60107,jc=fc?Symbol.for("react.strict_mode"):60108,kc=fc?Symbol.for("react.profiler"):60114,lc=fc?Symbol.for("react.provider"):60109,mc=fc?Symbol.for("react.context"):60110,pc=fc?Symbol.for("react.async_mode"):60111,qc=fc?Symbol.for("react.forward_ref"):60112,rc=fc?Symbol.for("react.timeout"):
60113,sc="function"===typeof Symbol&&Symbol.iterator;function tc(a){if(null===a||"undefined"===typeof a)return null;a=sc&&a[sc]||a["@@iterator"];return"function"===typeof a?a:null}
function uc(a){var b=a.type;if("function"===typeof b)return b.displayName||b.name;if("string"===typeof b)return b;switch(b){case pc:return"AsyncMode";case mc:return"Context.Consumer";case ic:return"ReactFragment";case hc:return"ReactPortal";case kc:return"Profiler("+a.pendingProps.id+")";case lc:return"Context.Provider";case jc:return"StrictMode";case rc:return"Timeout"}if("object"===typeof b&&null!==b)switch(b.$$typeof){case qc:return a=b.render.displayName||b.render.name||"",""!==a?"ForwardRef("+
a+")":"ForwardRef"}return null}function vc(a){var b="";do{a:switch(a.tag){case 0:case 1:case 2:case 5:var c=a._debugOwner,d=a._debugSource;var e=uc(a);var f=null;c&&(f=uc(c));c=d;e="\n    in "+(e||"Unknown")+(c?" (at "+c.fileName.replace(/^.*[\\\/]/,"")+":"+c.lineNumber+")":f?" (created by "+f+")":"");break a;default:e=""}b+=e;a=a.return}while(a);return b}
var wc=/^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/,xc={},zc={};function Ac(a){if(zc.hasOwnProperty(a))return!0;if(xc.hasOwnProperty(a))return!1;if(wc.test(a))return zc[a]=!0;xc[a]=!0;return!1}
function Bc(a,b,c,d){if(null!==c&&0===c.type)return!1;switch(typeof b){case "function":case "symbol":return!0;case "boolean":if(d)return!1;if(null!==c)return!c.acceptsBooleans;a=a.toLowerCase().slice(0,5);return"data-"!==a&&"aria-"!==a;default:return!1}}function Cc(a,b,c,d){if(null===b||"undefined"===typeof b||Bc(a,b,c,d))return!0;if(d)return!1;if(null!==c)switch(c.type){case 3:return!b;case 4:return!1===b;case 5:return isNaN(b);case 6:return isNaN(b)||1>b}return!1}
function I(a,b,c,d,e){this.acceptsBooleans=2===b||3===b||4===b;this.attributeName=d;this.attributeNamespace=e;this.mustUseProperty=c;this.propertyName=a;this.type=b}var J={};"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a){J[a]=new I(a,0,!1,a,null)});
[["acceptCharset","accept-charset"],["className","class"],["htmlFor","for"],["httpEquiv","http-equiv"]].forEach(function(a){var b=a[0];J[b]=new I(b,1,!1,a[1],null)});["contentEditable","draggable","spellCheck","value"].forEach(function(a){J[a]=new I(a,2,!1,a.toLowerCase(),null)});["autoReverse","externalResourcesRequired","preserveAlpha"].forEach(function(a){J[a]=new I(a,2,!1,a,null)});
"allowFullScreen async autoFocus autoPlay controls default defer disabled formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a){J[a]=new I(a,3,!1,a.toLowerCase(),null)});["checked","multiple","muted","selected"].forEach(function(a){J[a]=new I(a,3,!0,a.toLowerCase(),null)});["capture","download"].forEach(function(a){J[a]=new I(a,4,!1,a.toLowerCase(),null)});
["cols","rows","size","span"].forEach(function(a){J[a]=new I(a,6,!1,a.toLowerCase(),null)});["rowSpan","start"].forEach(function(a){J[a]=new I(a,5,!1,a.toLowerCase(),null)});var Dc=/[\-:]([a-z])/g;function Ec(a){return a[1].toUpperCase()}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a){var b=a.replace(Dc,
Ec);J[b]=new I(b,1,!1,a,null)});"xlink:actuate xlink:arcrole xlink:href xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a){var b=a.replace(Dc,Ec);J[b]=new I(b,1,!1,a,"http://www.w3.org/1999/xlink")});["xml:base","xml:lang","xml:space"].forEach(function(a){var b=a.replace(Dc,Ec);J[b]=new I(b,1,!1,a,"http://www.w3.org/XML/1998/namespace")});J.tabIndex=new I("tabIndex",1,!1,"tabindex",null);
function Fc(a,b,c,d){var e=J.hasOwnProperty(b)?J[b]:null;var f=null!==e?0===e.type:d?!1:!(2<b.length)||"o"!==b[0]&&"O"!==b[0]||"n"!==b[1]&&"N"!==b[1]?!1:!0;f||(Cc(b,c,e,d)&&(c=null),d||null===e?Ac(b)&&(null===c?a.removeAttribute(b):a.setAttribute(b,""+c)):e.mustUseProperty?a[e.propertyName]=null===c?3===e.type?!1:"":c:(b=e.attributeName,d=e.attributeNamespace,null===c?a.removeAttribute(b):(e=e.type,c=3===e||4===e&&!0===c?"":""+c,d?a.setAttributeNS(d,b,c):a.setAttribute(b,c))))}
function Gc(a,b){var c=b.checked;return p({},b,{defaultChecked:void 0,defaultValue:void 0,value:void 0,checked:null!=c?c:a._wrapperState.initialChecked})}function Hc(a,b){var c=null==b.defaultValue?"":b.defaultValue,d=null!=b.checked?b.checked:b.defaultChecked;c=Ic(null!=b.value?b.value:c);a._wrapperState={initialChecked:d,initialValue:c,controlled:"checkbox"===b.type||"radio"===b.type?null!=b.checked:null!=b.value}}function Jc(a,b){b=b.checked;null!=b&&Fc(a,"checked",b,!1)}
function Kc(a,b){Jc(a,b);var c=Ic(b.value);if(null!=c)if("number"===b.type){if(0===c&&""===a.value||a.value!=c)a.value=""+c}else a.value!==""+c&&(a.value=""+c);b.hasOwnProperty("value")?Lc(a,b.type,c):b.hasOwnProperty("defaultValue")&&Lc(a,b.type,Ic(b.defaultValue));null==b.checked&&null!=b.defaultChecked&&(a.defaultChecked=!!b.defaultChecked)}
function Mc(a,b,c){if(b.hasOwnProperty("value")||b.hasOwnProperty("defaultValue")){b=""+a._wrapperState.initialValue;var d=a.value;c||b===d||(a.value=b);a.defaultValue=b}c=a.name;""!==c&&(a.name="");a.defaultChecked=!a.defaultChecked;a.defaultChecked=!a.defaultChecked;""!==c&&(a.name=c)}function Lc(a,b,c){if("number"!==b||a.ownerDocument.activeElement!==a)null==c?a.defaultValue=""+a._wrapperState.initialValue:a.defaultValue!==""+c&&(a.defaultValue=""+c)}
function Ic(a){switch(typeof a){case "boolean":case "number":case "object":case "string":case "undefined":return a;default:return""}}var Nc={change:{phasedRegistrationNames:{bubbled:"onChange",captured:"onChangeCapture"},dependencies:"blur change click focus input keydown keyup selectionchange".split(" ")}};function Oc(a,b,c){a=H.getPooled(Nc.change,a,b,c);a.type="change";Ob(c);Ya(a);return a}var Pc=null,Qc=null;function Rc(a){Ia(a,!1)}function Sc(a){var b=Oa(a);if(dc(b))return a}
function Tc(a,b){if("change"===a)return b}var Uc=!1;m.canUseDOM&&(Uc=$b("input")&&(!document.documentMode||9<document.documentMode));function Vc(){Pc&&(Pc.detachEvent("onpropertychange",Wc),Qc=Pc=null)}function Wc(a){"value"===a.propertyName&&Sc(Qc)&&(a=Oc(Qc,a,Zb(a)),Wb(Rc,a))}function Xc(a,b,c){"focus"===a?(Vc(),Pc=b,Qc=c,Pc.attachEvent("onpropertychange",Wc)):"blur"===a&&Vc()}function Yc(a){if("selectionchange"===a||"keyup"===a||"keydown"===a)return Sc(Qc)}
function Zc(a,b){if("click"===a)return Sc(b)}function $c(a,b){if("input"===a||"change"===a)return Sc(b)}
var ad={eventTypes:Nc,_isInputEventSupported:Uc,extractEvents:function(a,b,c,d){var e=b?Oa(b):window,f=void 0,g=void 0,h=e.nodeName&&e.nodeName.toLowerCase();"select"===h||"input"===h&&"file"===e.type?f=Tc:Yb(e)?Uc?f=$c:(f=Yc,g=Xc):(h=e.nodeName)&&"input"===h.toLowerCase()&&("checkbox"===e.type||"radio"===e.type)&&(f=Zc);if(f&&(f=f(a,b)))return Oc(f,c,d);g&&g(a,e,b);"blur"===a&&(a=e._wrapperState)&&a.controlled&&"number"===e.type&&Lc(e,"number",e.value)}},bd=H.extend({view:null,detail:null}),cd={Alt:"altKey",
Control:"ctrlKey",Meta:"metaKey",Shift:"shiftKey"};function dd(a){var b=this.nativeEvent;return b.getModifierState?b.getModifierState(a):(a=cd[a])?!!b[a]:!1}function ed(){return dd}
var fd=bd.extend({screenX:null,screenY:null,clientX:null,clientY:null,pageX:null,pageY:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,getModifierState:ed,button:null,buttons:null,relatedTarget:function(a){return a.relatedTarget||(a.fromElement===a.srcElement?a.toElement:a.fromElement)}}),gd=fd.extend({pointerId:null,width:null,height:null,pressure:null,tiltX:null,tiltY:null,pointerType:null,isPrimary:null}),hd={mouseEnter:{registrationName:"onMouseEnter",dependencies:["mouseout","mouseover"]},
mouseLeave:{registrationName:"onMouseLeave",dependencies:["mouseout","mouseover"]},pointerEnter:{registrationName:"onPointerEnter",dependencies:["pointerout","pointerover"]},pointerLeave:{registrationName:"onPointerLeave",dependencies:["pointerout","pointerover"]}},id={eventTypes:hd,extractEvents:function(a,b,c,d){var e="mouseover"===a||"pointerover"===a,f="mouseout"===a||"pointerout"===a;if(e&&(c.relatedTarget||c.fromElement)||!f&&!e)return null;e=d.window===d?d:(e=d.ownerDocument)?e.defaultView||
e.parentWindow:window;f?(f=b,b=(b=c.relatedTarget||c.toElement)?Na(b):null):f=null;if(f===b)return null;var g=void 0,h=void 0,k=void 0,n=void 0;if("mouseout"===a||"mouseover"===a)g=fd,h=hd.mouseLeave,k=hd.mouseEnter,n="mouse";else if("pointerout"===a||"pointerover"===a)g=gd,h=hd.pointerLeave,k=hd.pointerEnter,n="pointer";a=null==f?e:Oa(f);e=null==b?e:Oa(b);h=g.getPooled(h,f,c,d);h.type=n+"leave";h.target=a;h.relatedTarget=e;c=g.getPooled(k,b,c,d);c.type=n+"enter";c.target=e;c.relatedTarget=a;Za(h,
c,f,b);return[h,c]}};function jd(a){var b=a;if(a.alternate)for(;b.return;)b=b.return;else{if(0!==(b.effectTag&2))return 1;for(;b.return;)if(b=b.return,0!==(b.effectTag&2))return 1}return 3===b.tag?2:3}function kd(a){2!==jd(a)?A("188"):void 0}
function ld(a){var b=a.alternate;if(!b)return b=jd(a),3===b?A("188"):void 0,1===b?null:a;for(var c=a,d=b;;){var e=c.return,f=e?e.alternate:null;if(!e||!f)break;if(e.child===f.child){for(var g=e.child;g;){if(g===c)return kd(e),a;if(g===d)return kd(e),b;g=g.sibling}A("188")}if(c.return!==d.return)c=e,d=f;else{g=!1;for(var h=e.child;h;){if(h===c){g=!0;c=e;d=f;break}if(h===d){g=!0;d=e;c=f;break}h=h.sibling}if(!g){for(h=f.child;h;){if(h===c){g=!0;c=f;d=e;break}if(h===d){g=!0;d=f;c=e;break}h=h.sibling}g?
void 0:A("189")}}c.alternate!==d?A("190"):void 0}3!==c.tag?A("188"):void 0;return c.stateNode.current===c?a:b}function md(a){a=ld(a);if(!a)return null;for(var b=a;;){if(5===b.tag||6===b.tag)return b;if(b.child)b.child.return=b,b=b.child;else{if(b===a)break;for(;!b.sibling;){if(!b.return||b.return===a)return null;b=b.return}b.sibling.return=b.return;b=b.sibling}}return null}
function nd(a){a=ld(a);if(!a)return null;for(var b=a;;){if(5===b.tag||6===b.tag)return b;if(b.child&&4!==b.tag)b.child.return=b,b=b.child;else{if(b===a)break;for(;!b.sibling;){if(!b.return||b.return===a)return null;b=b.return}b.sibling.return=b.return;b=b.sibling}}return null}var od=H.extend({animationName:null,elapsedTime:null,pseudoElement:null}),pd=H.extend({clipboardData:function(a){return"clipboardData"in a?a.clipboardData:window.clipboardData}}),qd=bd.extend({relatedTarget:null});
function rd(a){var b=a.keyCode;"charCode"in a?(a=a.charCode,0===a&&13===b&&(a=13)):a=b;10===a&&(a=13);return 32<=a||13===a?a:0}
var sd={Esc:"Escape",Spacebar:" ",Left:"ArrowLeft",Up:"ArrowUp",Right:"ArrowRight",Down:"ArrowDown",Del:"Delete",Win:"OS",Menu:"ContextMenu",Apps:"ContextMenu",Scroll:"ScrollLock",MozPrintableKey:"Unidentified"},td={8:"Backspace",9:"Tab",12:"Clear",13:"Enter",16:"Shift",17:"Control",18:"Alt",19:"Pause",20:"CapsLock",27:"Escape",32:" ",33:"PageUp",34:"PageDown",35:"End",36:"Home",37:"ArrowLeft",38:"ArrowUp",39:"ArrowRight",40:"ArrowDown",45:"Insert",46:"Delete",112:"F1",113:"F2",114:"F3",115:"F4",
116:"F5",117:"F6",118:"F7",119:"F8",120:"F9",121:"F10",122:"F11",123:"F12",144:"NumLock",145:"ScrollLock",224:"Meta"},ud=bd.extend({key:function(a){if(a.key){var b=sd[a.key]||a.key;if("Unidentified"!==b)return b}return"keypress"===a.type?(a=rd(a),13===a?"Enter":String.fromCharCode(a)):"keydown"===a.type||"keyup"===a.type?td[a.keyCode]||"Unidentified":""},location:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,repeat:null,locale:null,getModifierState:ed,charCode:function(a){return"keypress"===
a.type?rd(a):0},keyCode:function(a){return"keydown"===a.type||"keyup"===a.type?a.keyCode:0},which:function(a){return"keypress"===a.type?rd(a):"keydown"===a.type||"keyup"===a.type?a.keyCode:0}}),vd=fd.extend({dataTransfer:null}),wd=bd.extend({touches:null,targetTouches:null,changedTouches:null,altKey:null,metaKey:null,ctrlKey:null,shiftKey:null,getModifierState:ed}),xd=H.extend({propertyName:null,elapsedTime:null,pseudoElement:null}),yd=fd.extend({deltaX:function(a){return"deltaX"in a?a.deltaX:"wheelDeltaX"in
a?-a.wheelDeltaX:0},deltaY:function(a){return"deltaY"in a?a.deltaY:"wheelDeltaY"in a?-a.wheelDeltaY:"wheelDelta"in a?-a.wheelDelta:0},deltaZ:null,deltaMode:null}),zd=[["abort","abort"],[fb,"animationEnd"],[gb,"animationIteration"],[hb,"animationStart"],["canplay","canPlay"],["canplaythrough","canPlayThrough"],["drag","drag"],["dragenter","dragEnter"],["dragexit","dragExit"],["dragleave","dragLeave"],["dragover","dragOver"],["durationchange","durationChange"],["emptied","emptied"],["encrypted","encrypted"],
["ended","ended"],["error","error"],["gotpointercapture","gotPointerCapture"],["load","load"],["loadeddata","loadedData"],["loadedmetadata","loadedMetadata"],["loadstart","loadStart"],["lostpointercapture","lostPointerCapture"],["mousemove","mouseMove"],["mouseout","mouseOut"],["mouseover","mouseOver"],["playing","playing"],["pointermove","pointerMove"],["pointerout","pointerOut"],["pointerover","pointerOver"],["progress","progress"],["scroll","scroll"],["seeking","seeking"],["stalled","stalled"],
["suspend","suspend"],["timeupdate","timeUpdate"],["toggle","toggle"],["touchmove","touchMove"],[ib,"transitionEnd"],["waiting","waiting"],["wheel","wheel"]],Ad={},Bd={};function Cd(a,b){var c=a[0];a=a[1];var d="on"+(a[0].toUpperCase()+a.slice(1));b={phasedRegistrationNames:{bubbled:d,captured:d+"Capture"},dependencies:[c],isInteractive:b};Ad[a]=b;Bd[c]=b}
[["blur","blur"],["cancel","cancel"],["click","click"],["close","close"],["contextmenu","contextMenu"],["copy","copy"],["cut","cut"],["dblclick","doubleClick"],["dragend","dragEnd"],["dragstart","dragStart"],["drop","drop"],["focus","focus"],["input","input"],["invalid","invalid"],["keydown","keyDown"],["keypress","keyPress"],["keyup","keyUp"],["mousedown","mouseDown"],["mouseup","mouseUp"],["paste","paste"],["pause","pause"],["play","play"],["pointercancel","pointerCancel"],["pointerdown","pointerDown"],
["pointerup","pointerUp"],["ratechange","rateChange"],["reset","reset"],["seeked","seeked"],["submit","submit"],["touchcancel","touchCancel"],["touchend","touchEnd"],["touchstart","touchStart"],["volumechange","volumeChange"]].forEach(function(a){Cd(a,!0)});zd.forEach(function(a){Cd(a,!1)});
var Dd={eventTypes:Ad,isInteractiveTopLevelEventType:function(a){a=Bd[a];return void 0!==a&&!0===a.isInteractive},extractEvents:function(a,b,c,d){var e=Bd[a];if(!e)return null;switch(a){case "keypress":if(0===rd(c))return null;case "keydown":case "keyup":a=ud;break;case "blur":case "focus":a=qd;break;case "click":if(2===c.button)return null;case "dblclick":case "mousedown":case "mousemove":case "mouseup":case "mouseout":case "mouseover":case "contextmenu":a=fd;break;case "drag":case "dragend":case "dragenter":case "dragexit":case "dragleave":case "dragover":case "dragstart":case "drop":a=
vd;break;case "touchcancel":case "touchend":case "touchmove":case "touchstart":a=wd;break;case fb:case gb:case hb:a=od;break;case ib:a=xd;break;case "scroll":a=bd;break;case "wheel":a=yd;break;case "copy":case "cut":case "paste":a=pd;break;case "gotpointercapture":case "lostpointercapture":case "pointercancel":case "pointerdown":case "pointermove":case "pointerout":case "pointerover":case "pointerup":a=gd;break;default:a=H}b=a.getPooled(e,b,c,d);Ya(b);return b}},Ed=Dd.isInteractiveTopLevelEventType,
Fd=[];function Gd(a){var b=a.targetInst;do{if(!b){a.ancestors.push(b);break}var c;for(c=b;c.return;)c=c.return;c=3!==c.tag?null:c.stateNode.containerInfo;if(!c)break;a.ancestors.push(b);b=Na(c)}while(b);for(c=0;c<a.ancestors.length;c++)b=a.ancestors[c],Ja(a.topLevelType,b,a.nativeEvent,Zb(a.nativeEvent))}var Hd=!0;function Id(a){Hd=!!a}function K(a,b){if(!b)return null;var c=(Ed(a)?Kd:Ld).bind(null,a);b.addEventListener(a,c,!1)}
function Md(a,b){if(!b)return null;var c=(Ed(a)?Kd:Ld).bind(null,a);b.addEventListener(a,c,!0)}function Kd(a,b){Tb(Ld,a,b)}function Ld(a,b){if(Hd){var c=Zb(b);c=Na(c);null===c||"number"!==typeof c.tag||2===jd(c)||(c=null);if(Fd.length){var d=Fd.pop();d.topLevelType=a;d.nativeEvent=b;d.targetInst=c;a=d}else a={topLevelType:a,nativeEvent:b,targetInst:c,ancestors:[]};try{Wb(Gd,a)}finally{a.topLevelType=null,a.nativeEvent=null,a.targetInst=null,a.ancestors.length=0,10>Fd.length&&Fd.push(a)}}}
var Nd={get _enabled(){return Hd},setEnabled:Id,isEnabled:function(){return Hd},trapBubbledEvent:K,trapCapturedEvent:Md,dispatchEvent:Ld},Od={},Pd=0,Qd="_reactListenersID"+(""+Math.random()).slice(2);function Rd(a){Object.prototype.hasOwnProperty.call(a,Qd)||(a[Qd]=Pd++,Od[a[Qd]]={});return Od[a[Qd]]}function Sd(a){for(;a&&a.firstChild;)a=a.firstChild;return a}
function Td(a,b){var c=Sd(a);a=0;for(var d;c;){if(3===c.nodeType){d=a+c.textContent.length;if(a<=b&&d>=b)return{node:c,offset:b-a};a=d}a:{for(;c;){if(c.nextSibling){c=c.nextSibling;break a}c=c.parentNode}c=void 0}c=Sd(c)}}function Ud(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return b&&("input"===b&&("text"===a.type||"search"===a.type||"tel"===a.type||"url"===a.type||"password"===a.type)||"textarea"===b||"true"===a.contentEditable)}
var Vd=m.canUseDOM&&"documentMode"in document&&11>=document.documentMode,Wd={select:{phasedRegistrationNames:{bubbled:"onSelect",captured:"onSelectCapture"},dependencies:"blur contextmenu focus keydown keyup mousedown mouseup selectionchange".split(" ")}},Xd=null,Yd=null,Zd=null,$d=!1;
function ae(a,b){if($d||null==Xd||Xd!==da())return null;var c=Xd;"selectionStart"in c&&Ud(c)?c={start:c.selectionStart,end:c.selectionEnd}:window.getSelection?(c=window.getSelection(),c={anchorNode:c.anchorNode,anchorOffset:c.anchorOffset,focusNode:c.focusNode,focusOffset:c.focusOffset}):c=void 0;return Zd&&ea(Zd,c)?null:(Zd=c,a=H.getPooled(Wd.select,Yd,a,b),a.type="select",a.target=Xd,Ya(a),a)}
var be={eventTypes:Wd,extractEvents:function(a,b,c,d){var e=d.window===d?d.document:9===d.nodeType?d:d.ownerDocument,f;if(!(f=!e)){a:{e=Rd(e);f=sa.onSelect;for(var g=0;g<f.length;g++){var h=f[g];if(!e.hasOwnProperty(h)||!e[h]){e=!1;break a}}e=!0}f=!e}if(f)return null;e=b?Oa(b):window;switch(a){case "focus":if(Yb(e)||"true"===e.contentEditable)Xd=e,Yd=b,Zd=null;break;case "blur":Zd=Yd=Xd=null;break;case "mousedown":$d=!0;break;case "contextmenu":case "mouseup":return $d=!1,ae(c,d);case "selectionchange":if(Vd)break;
case "keydown":case "keyup":return ae(c,d)}return null}};Ga.injectEventPluginOrder("ResponderEventPlugin SimpleEventPlugin TapEventPlugin EnterLeaveEventPlugin ChangeEventPlugin SelectEventPlugin BeforeInputEventPlugin".split(" "));wa=Qa.getFiberCurrentPropsFromNode;xa=Qa.getInstanceFromNode;ya=Qa.getNodeFromInstance;Ga.injectEventPluginsByName({SimpleEventPlugin:Dd,EnterLeaveEventPlugin:id,ChangeEventPlugin:ad,SelectEventPlugin:be,BeforeInputEventPlugin:Ib});
var ce="function"===typeof requestAnimationFrame?requestAnimationFrame:void 0,de=Date,ee=setTimeout,fe=clearTimeout,ge=void 0;if("object"===typeof performance&&"function"===typeof performance.now){var he=performance;ge=function(){return he.now()}}else ge=function(){return de.now()};var ie=void 0,je=void 0;
if(m.canUseDOM){var ke="function"===typeof ce?ce:function(){A("276")},L=null,le=null,me=-1,ne=!1,oe=!1,pe=0,qe=33,re=33,se={didTimeout:!1,timeRemaining:function(){var a=pe-ge();return 0<a?a:0}},ue=function(a,b){var c=a.scheduledCallback,d=!1;try{c(b),d=!0}finally{je(a),d||(ne=!0,window.postMessage(te,"*"))}},te="__reactIdleCallback$"+Math.random().toString(36).slice(2);window.addEventListener("message",function(a){if(a.source===window&&a.data===te&&(ne=!1,null!==L)){if(null!==L){var b=ge();if(!(-1===
me||me>b)){a=-1;for(var c=[],d=L;null!==d;){var e=d.timeoutTime;-1!==e&&e<=b?c.push(d):-1!==e&&(-1===a||e<a)&&(a=e);d=d.next}if(0<c.length)for(se.didTimeout=!0,b=0,d=c.length;b<d;b++)ue(c[b],se);me=a}}for(a=ge();0<pe-a&&null!==L;)a=L,se.didTimeout=!1,ue(a,se),a=ge();null===L||oe||(oe=!0,ke(ve))}},!1);var ve=function(a){oe=!1;var b=a-pe+re;b<re&&qe<re?(8>b&&(b=8),re=b<qe?qe:b):qe=b;pe=a+re;ne||(ne=!0,window.postMessage(te,"*"))};ie=function(a,b){var c=-1;null!=b&&"number"===typeof b.timeout&&(c=ge()+
b.timeout);if(-1===me||-1!==c&&c<me)me=c;a={scheduledCallback:a,timeoutTime:c,prev:null,next:null};null===L?L=a:(b=a.prev=le,null!==b&&(b.next=a));le=a;oe||(oe=!0,ke(ve));return a};je=function(a){if(null!==a.prev||L===a){var b=a.next,c=a.prev;a.next=null;a.prev=null;null!==b?null!==c?(c.next=b,b.prev=c):(b.prev=null,L=b):null!==c?(c.next=null,le=c):le=L=null}}}else{var we=new Map;ie=function(a){var b={scheduledCallback:a,timeoutTime:0,next:null,prev:null},c=ee(function(){a({timeRemaining:function(){return Infinity},
didTimeout:!1})});we.set(a,c);return b};je=function(a){var b=we.get(a.scheduledCallback);we.delete(a);fe(b)}}function xe(a){var b="";ba.Children.forEach(a,function(a){null==a||"string"!==typeof a&&"number"!==typeof a||(b+=a)});return b}function ye(a,b){a=p({children:void 0},b);if(b=xe(b.children))a.children=b;return a}
function ze(a,b,c,d){a=a.options;if(b){b={};for(var e=0;e<c.length;e++)b["$"+c[e]]=!0;for(c=0;c<a.length;c++)e=b.hasOwnProperty("$"+a[c].value),a[c].selected!==e&&(a[c].selected=e),e&&d&&(a[c].defaultSelected=!0)}else{c=""+c;b=null;for(e=0;e<a.length;e++){if(a[e].value===c){a[e].selected=!0;d&&(a[e].defaultSelected=!0);return}null!==b||a[e].disabled||(b=a[e])}null!==b&&(b.selected=!0)}}
function Ae(a,b){var c=b.value;a._wrapperState={initialValue:null!=c?c:b.defaultValue,wasMultiple:!!b.multiple}}function Be(a,b){null!=b.dangerouslySetInnerHTML?A("91"):void 0;return p({},b,{value:void 0,defaultValue:void 0,children:""+a._wrapperState.initialValue})}function Ce(a,b){var c=b.value;null==c&&(c=b.defaultValue,b=b.children,null!=b&&(null!=c?A("92"):void 0,Array.isArray(b)&&(1>=b.length?void 0:A("93"),b=b[0]),c=""+b),null==c&&(c=""));a._wrapperState={initialValue:""+c}}
function De(a,b){var c=b.value;null!=c&&(c=""+c,c!==a.value&&(a.value=c),null==b.defaultValue&&(a.defaultValue=c));null!=b.defaultValue&&(a.defaultValue=b.defaultValue)}function Ee(a){var b=a.textContent;b===a._wrapperState.initialValue&&(a.value=b)}var Fe={html:"http://www.w3.org/1999/xhtml",mathml:"http://www.w3.org/1998/Math/MathML",svg:"http://www.w3.org/2000/svg"};
function Ge(a){switch(a){case "svg":return"http://www.w3.org/2000/svg";case "math":return"http://www.w3.org/1998/Math/MathML";default:return"http://www.w3.org/1999/xhtml"}}function He(a,b){return null==a||"http://www.w3.org/1999/xhtml"===a?Ge(b):"http://www.w3.org/2000/svg"===a&&"foreignObject"===b?"http://www.w3.org/1999/xhtml":a}
var Ie=void 0,Je=function(a){return"undefined"!==typeof MSApp&&MSApp.execUnsafeLocalFunction?function(b,c,d,e){MSApp.execUnsafeLocalFunction(function(){return a(b,c,d,e)})}:a}(function(a,b){if(a.namespaceURI!==Fe.svg||"innerHTML"in a)a.innerHTML=b;else{Ie=Ie||document.createElement("div");Ie.innerHTML="<svg>"+b+"</svg>";for(b=Ie.firstChild;a.firstChild;)a.removeChild(a.firstChild);for(;b.firstChild;)a.appendChild(b.firstChild)}});
function Ke(a,b){if(b){var c=a.firstChild;if(c&&c===a.lastChild&&3===c.nodeType){c.nodeValue=b;return}}a.textContent=b}
var Le={animationIterationCount:!0,borderImageOutset:!0,borderImageSlice:!0,borderImageWidth:!0,boxFlex:!0,boxFlexGroup:!0,boxOrdinalGroup:!0,columnCount:!0,columns:!0,flex:!0,flexGrow:!0,flexPositive:!0,flexShrink:!0,flexNegative:!0,flexOrder:!0,gridRow:!0,gridRowEnd:!0,gridRowSpan:!0,gridRowStart:!0,gridColumn:!0,gridColumnEnd:!0,gridColumnSpan:!0,gridColumnStart:!0,fontWeight:!0,lineClamp:!0,lineHeight:!0,opacity:!0,order:!0,orphans:!0,tabSize:!0,widows:!0,zIndex:!0,zoom:!0,fillOpacity:!0,floodOpacity:!0,
stopOpacity:!0,strokeDasharray:!0,strokeDashoffset:!0,strokeMiterlimit:!0,strokeOpacity:!0,strokeWidth:!0},Me=["Webkit","ms","Moz","O"];Object.keys(Le).forEach(function(a){Me.forEach(function(b){b=b+a.charAt(0).toUpperCase()+a.substring(1);Le[b]=Le[a]})});
function Ne(a,b){a=a.style;for(var c in b)if(b.hasOwnProperty(c)){var d=0===c.indexOf("--");var e=c;var f=b[c];e=null==f||"boolean"===typeof f||""===f?"":d||"number"!==typeof f||0===f||Le.hasOwnProperty(e)&&Le[e]?(""+f).trim():f+"px";"float"===c&&(c="cssFloat");d?a.setProperty(c,e):a[c]=e}}var Oe=p({menuitem:!0},{area:!0,base:!0,br:!0,col:!0,embed:!0,hr:!0,img:!0,input:!0,keygen:!0,link:!0,meta:!0,param:!0,source:!0,track:!0,wbr:!0});
function Pe(a,b,c){b&&(Oe[a]&&(null!=b.children||null!=b.dangerouslySetInnerHTML?A("137",a,c()):void 0),null!=b.dangerouslySetInnerHTML&&(null!=b.children?A("60"):void 0,"object"===typeof b.dangerouslySetInnerHTML&&"__html"in b.dangerouslySetInnerHTML?void 0:A("61")),null!=b.style&&"object"!==typeof b.style?A("62",c()):void 0)}
function Qe(a,b){if(-1===a.indexOf("-"))return"string"===typeof b.is;switch(a){case "annotation-xml":case "color-profile":case "font-face":case "font-face-src":case "font-face-uri":case "font-face-format":case "font-face-name":case "missing-glyph":return!1;default:return!0}}var Re=v.thatReturns("");
function Se(a,b){a=9===a.nodeType||11===a.nodeType?a:a.ownerDocument;var c=Rd(a);b=sa[b];for(var d=0;d<b.length;d++){var e=b[d];if(!c.hasOwnProperty(e)||!c[e]){switch(e){case "scroll":Md("scroll",a);break;case "focus":case "blur":Md("focus",a);Md("blur",a);c.blur=!0;c.focus=!0;break;case "cancel":case "close":$b(e,!0)&&Md(e,a);break;case "invalid":case "submit":case "reset":break;default:-1===jb.indexOf(e)&&K(e,a)}c[e]=!0}}}
function Te(a,b,c,d){c=9===c.nodeType?c:c.ownerDocument;d===Fe.html&&(d=Ge(a));d===Fe.html?"script"===a?(a=c.createElement("div"),a.innerHTML="<script>\x3c/script>",a=a.removeChild(a.firstChild)):a="string"===typeof b.is?c.createElement(a,{is:b.is}):c.createElement(a):a=c.createElementNS(d,a);return a}function Ue(a,b){return(9===b.nodeType?b:b.ownerDocument).createTextNode(a)}
function Ve(a,b,c,d){var e=Qe(b,c);switch(b){case "iframe":case "object":K("load",a);var f=c;break;case "video":case "audio":for(f=0;f<jb.length;f++)K(jb[f],a);f=c;break;case "source":K("error",a);f=c;break;case "img":case "image":case "link":K("error",a);K("load",a);f=c;break;case "form":K("reset",a);K("submit",a);f=c;break;case "details":K("toggle",a);f=c;break;case "input":Hc(a,c);f=Gc(a,c);K("invalid",a);Se(d,"onChange");break;case "option":f=ye(a,c);break;case "select":Ae(a,c);f=p({},c,{value:void 0});
K("invalid",a);Se(d,"onChange");break;case "textarea":Ce(a,c);f=Be(a,c);K("invalid",a);Se(d,"onChange");break;default:f=c}Pe(b,f,Re);var g=f,h;for(h in g)if(g.hasOwnProperty(h)){var k=g[h];"style"===h?Ne(a,k,Re):"dangerouslySetInnerHTML"===h?(k=k?k.__html:void 0,null!=k&&Je(a,k)):"children"===h?"string"===typeof k?("textarea"!==b||""!==k)&&Ke(a,k):"number"===typeof k&&Ke(a,""+k):"suppressContentEditableWarning"!==h&&"suppressHydrationWarning"!==h&&"autoFocus"!==h&&(ra.hasOwnProperty(h)?null!=k&&Se(d,
h):null!=k&&Fc(a,h,k,e))}switch(b){case "input":cc(a);Mc(a,c,!1);break;case "textarea":cc(a);Ee(a,c);break;case "option":null!=c.value&&a.setAttribute("value",c.value);break;case "select":a.multiple=!!c.multiple;b=c.value;null!=b?ze(a,!!c.multiple,b,!1):null!=c.defaultValue&&ze(a,!!c.multiple,c.defaultValue,!0);break;default:"function"===typeof f.onClick&&(a.onclick=v)}}
function We(a,b,c,d,e){var f=null;switch(b){case "input":c=Gc(a,c);d=Gc(a,d);f=[];break;case "option":c=ye(a,c);d=ye(a,d);f=[];break;case "select":c=p({},c,{value:void 0});d=p({},d,{value:void 0});f=[];break;case "textarea":c=Be(a,c);d=Be(a,d);f=[];break;default:"function"!==typeof c.onClick&&"function"===typeof d.onClick&&(a.onclick=v)}Pe(b,d,Re);b=a=void 0;var g=null;for(a in c)if(!d.hasOwnProperty(a)&&c.hasOwnProperty(a)&&null!=c[a])if("style"===a){var h=c[a];for(b in h)h.hasOwnProperty(b)&&(g||
(g={}),g[b]="")}else"dangerouslySetInnerHTML"!==a&&"children"!==a&&"suppressContentEditableWarning"!==a&&"suppressHydrationWarning"!==a&&"autoFocus"!==a&&(ra.hasOwnProperty(a)?f||(f=[]):(f=f||[]).push(a,null));for(a in d){var k=d[a];h=null!=c?c[a]:void 0;if(d.hasOwnProperty(a)&&k!==h&&(null!=k||null!=h))if("style"===a)if(h){for(b in h)!h.hasOwnProperty(b)||k&&k.hasOwnProperty(b)||(g||(g={}),g[b]="");for(b in k)k.hasOwnProperty(b)&&h[b]!==k[b]&&(g||(g={}),g[b]=k[b])}else g||(f||(f=[]),f.push(a,g)),
g=k;else"dangerouslySetInnerHTML"===a?(k=k?k.__html:void 0,h=h?h.__html:void 0,null!=k&&h!==k&&(f=f||[]).push(a,""+k)):"children"===a?h===k||"string"!==typeof k&&"number"!==typeof k||(f=f||[]).push(a,""+k):"suppressContentEditableWarning"!==a&&"suppressHydrationWarning"!==a&&(ra.hasOwnProperty(a)?(null!=k&&Se(e,a),f||h===k||(f=[])):(f=f||[]).push(a,k))}g&&(f=f||[]).push("style",g);return f}
function Xe(a,b,c,d,e){"input"===c&&"radio"===e.type&&null!=e.name&&Jc(a,e);Qe(c,d);d=Qe(c,e);for(var f=0;f<b.length;f+=2){var g=b[f],h=b[f+1];"style"===g?Ne(a,h,Re):"dangerouslySetInnerHTML"===g?Je(a,h):"children"===g?Ke(a,h):Fc(a,g,h,d)}switch(c){case "input":Kc(a,e);break;case "textarea":De(a,e);break;case "select":a._wrapperState.initialValue=void 0,b=a._wrapperState.wasMultiple,a._wrapperState.wasMultiple=!!e.multiple,c=e.value,null!=c?ze(a,!!e.multiple,c,!1):b!==!!e.multiple&&(null!=e.defaultValue?
ze(a,!!e.multiple,e.defaultValue,!0):ze(a,!!e.multiple,e.multiple?[]:"",!1))}}
function Ye(a,b,c,d,e){switch(b){case "iframe":case "object":K("load",a);break;case "video":case "audio":for(d=0;d<jb.length;d++)K(jb[d],a);break;case "source":K("error",a);break;case "img":case "image":case "link":K("error",a);K("load",a);break;case "form":K("reset",a);K("submit",a);break;case "details":K("toggle",a);break;case "input":Hc(a,c);K("invalid",a);Se(e,"onChange");break;case "select":Ae(a,c);K("invalid",a);Se(e,"onChange");break;case "textarea":Ce(a,c),K("invalid",a),Se(e,"onChange")}Pe(b,
c,Re);d=null;for(var f in c)if(c.hasOwnProperty(f)){var g=c[f];"children"===f?"string"===typeof g?a.textContent!==g&&(d=["children",g]):"number"===typeof g&&a.textContent!==""+g&&(d=["children",""+g]):ra.hasOwnProperty(f)&&null!=g&&Se(e,f)}switch(b){case "input":cc(a);Mc(a,c,!0);break;case "textarea":cc(a);Ee(a,c);break;case "select":case "option":break;default:"function"===typeof c.onClick&&(a.onclick=v)}return d}function Ze(a,b){return a.nodeValue!==b}
var $e={createElement:Te,createTextNode:Ue,setInitialProperties:Ve,diffProperties:We,updateProperties:Xe,diffHydratedProperties:Ye,diffHydratedText:Ze,warnForUnmatchedText:function(){},warnForDeletedHydratableElement:function(){},warnForDeletedHydratableText:function(){},warnForInsertedHydratedElement:function(){},warnForInsertedHydratedText:function(){},restoreControlledState:function(a,b,c){switch(b){case "input":Kc(a,c);b=c.name;if("radio"===c.type&&null!=b){for(c=a;c.parentNode;)c=c.parentNode;
c=c.querySelectorAll("input[name="+JSON.stringify(""+b)+'][type="radio"]');for(b=0;b<c.length;b++){var d=c[b];if(d!==a&&d.form===a.form){var e=Pa(d);e?void 0:A("90");dc(d);Kc(d,e)}}}break;case "textarea":De(a,c);break;case "select":b=c.value,null!=b&&ze(a,!!c.multiple,b,!1)}}},af=null,bf=null;function cf(a,b){switch(a){case "button":case "input":case "select":case "textarea":return!!b.autoFocus}return!1}
function df(a,b){return"textarea"===a||"string"===typeof b.children||"number"===typeof b.children||"object"===typeof b.dangerouslySetInnerHTML&&null!==b.dangerouslySetInnerHTML&&"string"===typeof b.dangerouslySetInnerHTML.__html}var ef=ge,ff=ie,gf=je;function hf(a){for(a=a.nextSibling;a&&1!==a.nodeType&&3!==a.nodeType;)a=a.nextSibling;return a}function jf(a){for(a=a.firstChild;a&&1!==a.nodeType&&3!==a.nodeType;)a=a.nextSibling;return a}new Set;var kf=[],lf=-1;function mf(a){return{current:a}}
function M(a){0>lf||(a.current=kf[lf],kf[lf]=null,lf--)}function N(a,b){lf++;kf[lf]=a.current;a.current=b}var nf=mf(ha),O=mf(!1),of=ha;function pf(a){return qf(a)?of:nf.current}
function rf(a,b){var c=a.type.contextTypes;if(!c)return ha;var d=a.stateNode;if(d&&d.__reactInternalMemoizedUnmaskedChildContext===b)return d.__reactInternalMemoizedMaskedChildContext;var e={},f;for(f in c)e[f]=b[f];d&&(a=a.stateNode,a.__reactInternalMemoizedUnmaskedChildContext=b,a.__reactInternalMemoizedMaskedChildContext=e);return e}function qf(a){return 2===a.tag&&null!=a.type.childContextTypes}function sf(a){qf(a)&&(M(O,a),M(nf,a))}function tf(a){M(O,a);M(nf,a)}
function uf(a,b,c){nf.current!==ha?A("168"):void 0;N(nf,b,a);N(O,c,a)}function vf(a,b){var c=a.stateNode,d=a.type.childContextTypes;if("function"!==typeof c.getChildContext)return b;c=c.getChildContext();for(var e in c)e in d?void 0:A("108",uc(a)||"Unknown",e);return p({},b,c)}function wf(a){if(!qf(a))return!1;var b=a.stateNode;b=b&&b.__reactInternalMemoizedMergedChildContext||ha;of=nf.current;N(nf,b,a);N(O,O.current,a);return!0}
function xf(a,b){var c=a.stateNode;c?void 0:A("169");if(b){var d=vf(a,of);c.__reactInternalMemoizedMergedChildContext=d;M(O,a);M(nf,a);N(nf,d,a)}else M(O,a);N(O,b,a)}
function yf(a,b,c,d){this.tag=a;this.key=c;this.sibling=this.child=this.return=this.stateNode=this.type=null;this.index=0;this.ref=null;this.pendingProps=b;this.memoizedState=this.updateQueue=this.memoizedProps=null;this.mode=d;this.effectTag=0;this.lastEffect=this.firstEffect=this.nextEffect=null;this.expirationTime=0;this.alternate=null}
function zf(a,b,c){var d=a.alternate;null===d?(d=new yf(a.tag,b,a.key,a.mode),d.type=a.type,d.stateNode=a.stateNode,d.alternate=a,a.alternate=d):(d.pendingProps=b,d.effectTag=0,d.nextEffect=null,d.firstEffect=null,d.lastEffect=null);d.expirationTime=c;d.child=a.child;d.memoizedProps=a.memoizedProps;d.memoizedState=a.memoizedState;d.updateQueue=a.updateQueue;d.sibling=a.sibling;d.index=a.index;d.ref=a.ref;return d}
function Af(a,b,c){var d=a.type,e=a.key;a=a.props;if("function"===typeof d)var f=d.prototype&&d.prototype.isReactComponent?2:0;else if("string"===typeof d)f=5;else switch(d){case ic:return Bf(a.children,b,c,e);case pc:f=11;b|=3;break;case jc:f=11;b|=2;break;case kc:return d=new yf(15,a,e,b|4),d.type=kc,d.expirationTime=c,d;case rc:f=16;b|=2;break;default:a:{switch("object"===typeof d&&null!==d?d.$$typeof:null){case lc:f=13;break a;case mc:f=12;break a;case qc:f=14;break a;default:A("130",null==d?
d:typeof d,"")}f=void 0}}b=new yf(f,a,e,b);b.type=d;b.expirationTime=c;return b}function Bf(a,b,c,d){a=new yf(10,a,d,b);a.expirationTime=c;return a}function Cf(a,b,c){a=new yf(6,a,null,b);a.expirationTime=c;return a}function Df(a,b,c){b=new yf(4,null!==a.children?a.children:[],a.key,b);b.expirationTime=c;b.stateNode={containerInfo:a.containerInfo,pendingChildren:null,implementation:a.implementation};return b}
function Ef(a,b,c){b=new yf(3,null,null,b?3:0);a={current:b,containerInfo:a,pendingChildren:null,earliestPendingTime:0,latestPendingTime:0,earliestSuspendedTime:0,latestSuspendedTime:0,latestPingedTime:0,pendingCommitExpirationTime:0,finishedWork:null,context:null,pendingContext:null,hydrate:c,remainingExpirationTime:0,firstBatch:null,nextScheduledRoot:null};return b.stateNode=a}var Ff=null,Gf=null;function Hf(a){return function(b){try{return a(b)}catch(c){}}}
function If(a){if("undefined"===typeof __REACT_DEVTOOLS_GLOBAL_HOOK__)return!1;var b=__REACT_DEVTOOLS_GLOBAL_HOOK__;if(b.isDisabled||!b.supportsFiber)return!0;try{var c=b.inject(a);Ff=Hf(function(a){return b.onCommitFiberRoot(c,a)});Gf=Hf(function(a){return b.onCommitFiberUnmount(c,a)})}catch(d){}return!0}function Jf(a){"function"===typeof Ff&&Ff(a)}function Kf(a){"function"===typeof Gf&&Gf(a)}var Lf=!1;
function Mf(a){return{expirationTime:0,baseState:a,firstUpdate:null,lastUpdate:null,firstCapturedUpdate:null,lastCapturedUpdate:null,firstEffect:null,lastEffect:null,firstCapturedEffect:null,lastCapturedEffect:null}}function Nf(a){return{expirationTime:a.expirationTime,baseState:a.baseState,firstUpdate:a.firstUpdate,lastUpdate:a.lastUpdate,firstCapturedUpdate:null,lastCapturedUpdate:null,firstEffect:null,lastEffect:null,firstCapturedEffect:null,lastCapturedEffect:null}}
function Of(a){return{expirationTime:a,tag:0,payload:null,callback:null,next:null,nextEffect:null}}function Pf(a,b,c){null===a.lastUpdate?a.firstUpdate=a.lastUpdate=b:(a.lastUpdate.next=b,a.lastUpdate=b);if(0===a.expirationTime||a.expirationTime>c)a.expirationTime=c}
function Qf(a,b,c){var d=a.alternate;if(null===d){var e=a.updateQueue;var f=null;null===e&&(e=a.updateQueue=Mf(a.memoizedState))}else e=a.updateQueue,f=d.updateQueue,null===e?null===f?(e=a.updateQueue=Mf(a.memoizedState),f=d.updateQueue=Mf(d.memoizedState)):e=a.updateQueue=Nf(f):null===f&&(f=d.updateQueue=Nf(e));null===f||e===f?Pf(e,b,c):null===e.lastUpdate||null===f.lastUpdate?(Pf(e,b,c),Pf(f,b,c)):(Pf(e,b,c),f.lastUpdate=b)}
function Rf(a,b,c){var d=a.updateQueue;d=null===d?a.updateQueue=Mf(a.memoizedState):Sf(a,d);null===d.lastCapturedUpdate?d.firstCapturedUpdate=d.lastCapturedUpdate=b:(d.lastCapturedUpdate.next=b,d.lastCapturedUpdate=b);if(0===d.expirationTime||d.expirationTime>c)d.expirationTime=c}function Sf(a,b){var c=a.alternate;null!==c&&b===c.updateQueue&&(b=a.updateQueue=Nf(b));return b}
function Tf(a,b,c,d,e,f){switch(c.tag){case 1:return a=c.payload,"function"===typeof a?a.call(f,d,e):a;case 3:a.effectTag=a.effectTag&-1025|64;case 0:a=c.payload;e="function"===typeof a?a.call(f,d,e):a;if(null===e||void 0===e)break;return p({},d,e);case 2:Lf=!0}return d}
function Uf(a,b,c,d,e){Lf=!1;if(!(0===b.expirationTime||b.expirationTime>e)){b=Sf(a,b);for(var f=b.baseState,g=null,h=0,k=b.firstUpdate,n=f;null!==k;){var r=k.expirationTime;if(r>e){if(null===g&&(g=k,f=n),0===h||h>r)h=r}else n=Tf(a,b,k,n,c,d),null!==k.callback&&(a.effectTag|=32,k.nextEffect=null,null===b.lastEffect?b.firstEffect=b.lastEffect=k:(b.lastEffect.nextEffect=k,b.lastEffect=k));k=k.next}r=null;for(k=b.firstCapturedUpdate;null!==k;){var w=k.expirationTime;if(w>e){if(null===r&&(r=k,null===
g&&(f=n)),0===h||h>w)h=w}else n=Tf(a,b,k,n,c,d),null!==k.callback&&(a.effectTag|=32,k.nextEffect=null,null===b.lastCapturedEffect?b.firstCapturedEffect=b.lastCapturedEffect=k:(b.lastCapturedEffect.nextEffect=k,b.lastCapturedEffect=k));k=k.next}null===g&&(b.lastUpdate=null);null===r?b.lastCapturedUpdate=null:a.effectTag|=32;null===g&&null===r&&(f=n);b.baseState=f;b.firstUpdate=g;b.firstCapturedUpdate=r;b.expirationTime=h;a.memoizedState=n}}
function Vf(a,b){"function"!==typeof a?A("191",a):void 0;a.call(b)}
function Wf(a,b,c){null!==b.firstCapturedUpdate&&(null!==b.lastUpdate&&(b.lastUpdate.next=b.firstCapturedUpdate,b.lastUpdate=b.lastCapturedUpdate),b.firstCapturedUpdate=b.lastCapturedUpdate=null);a=b.firstEffect;for(b.firstEffect=b.lastEffect=null;null!==a;){var d=a.callback;null!==d&&(a.callback=null,Vf(d,c));a=a.nextEffect}a=b.firstCapturedEffect;for(b.firstCapturedEffect=b.lastCapturedEffect=null;null!==a;)b=a.callback,null!==b&&(a.callback=null,Vf(b,c)),a=a.nextEffect}
function Xf(a,b){return{value:a,source:b,stack:vc(b)}}var Yf=mf(null),Zf=mf(null),$f=mf(0);function ag(a){var b=a.type._context;N($f,b._changedBits,a);N(Zf,b._currentValue,a);N(Yf,a,a);b._currentValue=a.pendingProps.value;b._changedBits=a.stateNode}function bg(a){var b=$f.current,c=Zf.current;M(Yf,a);M(Zf,a);M($f,a);a=a.type._context;a._currentValue=c;a._changedBits=b}var cg={},dg=mf(cg),eg=mf(cg),fg=mf(cg);function gg(a){a===cg?A("174"):void 0;return a}
function ig(a,b){N(fg,b,a);N(eg,a,a);N(dg,cg,a);var c=b.nodeType;switch(c){case 9:case 11:b=(b=b.documentElement)?b.namespaceURI:He(null,"");break;default:c=8===c?b.parentNode:b,b=c.namespaceURI||null,c=c.tagName,b=He(b,c)}M(dg,a);N(dg,b,a)}function jg(a){M(dg,a);M(eg,a);M(fg,a)}function kg(a){eg.current===a&&(M(dg,a),M(eg,a))}function lg(a,b,c){var d=a.memoizedState;b=b(c,d);d=null===b||void 0===b?d:p({},d,b);a.memoizedState=d;a=a.updateQueue;null!==a&&0===a.expirationTime&&(a.baseState=d)}
var pg={isMounted:function(a){return(a=a._reactInternalFiber)?2===jd(a):!1},enqueueSetState:function(a,b,c){a=a._reactInternalFiber;var d=mg();d=ng(d,a);var e=Of(d);e.payload=b;void 0!==c&&null!==c&&(e.callback=c);Qf(a,e,d);og(a,d)},enqueueReplaceState:function(a,b,c){a=a._reactInternalFiber;var d=mg();d=ng(d,a);var e=Of(d);e.tag=1;e.payload=b;void 0!==c&&null!==c&&(e.callback=c);Qf(a,e,d);og(a,d)},enqueueForceUpdate:function(a,b){a=a._reactInternalFiber;var c=mg();c=ng(c,a);var d=Of(c);d.tag=2;void 0!==
b&&null!==b&&(d.callback=b);Qf(a,d,c);og(a,c)}};function qg(a,b,c,d,e,f){var g=a.stateNode;a=a.type;return"function"===typeof g.shouldComponentUpdate?g.shouldComponentUpdate(c,e,f):a.prototype&&a.prototype.isPureReactComponent?!ea(b,c)||!ea(d,e):!0}
function rg(a,b,c,d){a=b.state;"function"===typeof b.componentWillReceiveProps&&b.componentWillReceiveProps(c,d);"function"===typeof b.UNSAFE_componentWillReceiveProps&&b.UNSAFE_componentWillReceiveProps(c,d);b.state!==a&&pg.enqueueReplaceState(b,b.state,null)}
function sg(a,b){var c=a.type,d=a.stateNode,e=a.pendingProps,f=pf(a);d.props=e;d.state=a.memoizedState;d.refs=ha;d.context=rf(a,f);f=a.updateQueue;null!==f&&(Uf(a,f,e,d,b),d.state=a.memoizedState);f=a.type.getDerivedStateFromProps;"function"===typeof f&&(lg(a,f,e),d.state=a.memoizedState);"function"===typeof c.getDerivedStateFromProps||"function"===typeof d.getSnapshotBeforeUpdate||"function"!==typeof d.UNSAFE_componentWillMount&&"function"!==typeof d.componentWillMount||(c=d.state,"function"===typeof d.componentWillMount&&
d.componentWillMount(),"function"===typeof d.UNSAFE_componentWillMount&&d.UNSAFE_componentWillMount(),c!==d.state&&pg.enqueueReplaceState(d,d.state,null),f=a.updateQueue,null!==f&&(Uf(a,f,e,d,b),d.state=a.memoizedState));"function"===typeof d.componentDidMount&&(a.effectTag|=4)}var tg=Array.isArray;
function ug(a,b,c){a=c.ref;if(null!==a&&"function"!==typeof a&&"object"!==typeof a){if(c._owner){c=c._owner;var d=void 0;c&&(2!==c.tag?A("110"):void 0,d=c.stateNode);d?void 0:A("147",a);var e=""+a;if(null!==b&&null!==b.ref&&"function"===typeof b.ref&&b.ref._stringRef===e)return b.ref;b=function(a){var b=d.refs===ha?d.refs={}:d.refs;null===a?delete b[e]:b[e]=a};b._stringRef=e;return b}"string"!==typeof a?A("148"):void 0;c._owner?void 0:A("254",a)}return a}
function vg(a,b){"textarea"!==a.type&&A("31","[object Object]"===Object.prototype.toString.call(b)?"object with keys {"+Object.keys(b).join(", ")+"}":b,"")}
function wg(a){function b(b,c){if(a){var d=b.lastEffect;null!==d?(d.nextEffect=c,b.lastEffect=c):b.firstEffect=b.lastEffect=c;c.nextEffect=null;c.effectTag=8}}function c(c,d){if(!a)return null;for(;null!==d;)b(c,d),d=d.sibling;return null}function d(a,b){for(a=new Map;null!==b;)null!==b.key?a.set(b.key,b):a.set(b.index,b),b=b.sibling;return a}function e(a,b,c){a=zf(a,b,c);a.index=0;a.sibling=null;return a}function f(b,c,d){b.index=d;if(!a)return c;d=b.alternate;if(null!==d)return d=d.index,d<c?(b.effectTag=
2,c):d;b.effectTag=2;return c}function g(b){a&&null===b.alternate&&(b.effectTag=2);return b}function h(a,b,c,d){if(null===b||6!==b.tag)return b=Cf(c,a.mode,d),b.return=a,b;b=e(b,c,d);b.return=a;return b}function k(a,b,c,d){if(null!==b&&b.type===c.type)return d=e(b,c.props,d),d.ref=ug(a,b,c),d.return=a,d;d=Af(c,a.mode,d);d.ref=ug(a,b,c);d.return=a;return d}function n(a,b,c,d){if(null===b||4!==b.tag||b.stateNode.containerInfo!==c.containerInfo||b.stateNode.implementation!==c.implementation)return b=
Df(c,a.mode,d),b.return=a,b;b=e(b,c.children||[],d);b.return=a;return b}function r(a,b,c,d,f){if(null===b||10!==b.tag)return b=Bf(c,a.mode,d,f),b.return=a,b;b=e(b,c,d);b.return=a;return b}function w(a,b,c){if("string"===typeof b||"number"===typeof b)return b=Cf(""+b,a.mode,c),b.return=a,b;if("object"===typeof b&&null!==b){switch(b.$$typeof){case gc:return c=Af(b,a.mode,c),c.ref=ug(a,null,b),c.return=a,c;case hc:return b=Df(b,a.mode,c),b.return=a,b}if(tg(b)||tc(b))return b=Bf(b,a.mode,c,null),b.return=
a,b;vg(a,b)}return null}function P(a,b,c,d){var e=null!==b?b.key:null;if("string"===typeof c||"number"===typeof c)return null!==e?null:h(a,b,""+c,d);if("object"===typeof c&&null!==c){switch(c.$$typeof){case gc:return c.key===e?c.type===ic?r(a,b,c.props.children,d,e):k(a,b,c,d):null;case hc:return c.key===e?n(a,b,c,d):null}if(tg(c)||tc(c))return null!==e?null:r(a,b,c,d,null);vg(a,c)}return null}function nc(a,b,c,d,e){if("string"===typeof d||"number"===typeof d)return a=a.get(c)||null,h(b,a,""+d,e);
if("object"===typeof d&&null!==d){switch(d.$$typeof){case gc:return a=a.get(null===d.key?c:d.key)||null,d.type===ic?r(b,a,d.props.children,e,d.key):k(b,a,d,e);case hc:return a=a.get(null===d.key?c:d.key)||null,n(b,a,d,e)}if(tg(d)||tc(d))return a=a.get(c)||null,r(b,a,d,e,null);vg(b,d)}return null}function Jd(e,g,h,k){for(var u=null,x=null,t=g,q=g=0,n=null;null!==t&&q<h.length;q++){t.index>q?(n=t,t=null):n=t.sibling;var l=P(e,t,h[q],k);if(null===l){null===t&&(t=n);break}a&&t&&null===l.alternate&&b(e,
t);g=f(l,g,q);null===x?u=l:x.sibling=l;x=l;t=n}if(q===h.length)return c(e,t),u;if(null===t){for(;q<h.length;q++)if(t=w(e,h[q],k))g=f(t,g,q),null===x?u=t:x.sibling=t,x=t;return u}for(t=d(e,t);q<h.length;q++)if(n=nc(t,e,q,h[q],k))a&&null!==n.alternate&&t.delete(null===n.key?q:n.key),g=f(n,g,q),null===x?u=n:x.sibling=n,x=n;a&&t.forEach(function(a){return b(e,a)});return u}function E(e,g,h,k){var u=tc(h);"function"!==typeof u?A("150"):void 0;h=u.call(h);null==h?A("151"):void 0;for(var t=u=null,n=g,x=
g=0,y=null,l=h.next();null!==n&&!l.done;x++,l=h.next()){n.index>x?(y=n,n=null):y=n.sibling;var r=P(e,n,l.value,k);if(null===r){n||(n=y);break}a&&n&&null===r.alternate&&b(e,n);g=f(r,g,x);null===t?u=r:t.sibling=r;t=r;n=y}if(l.done)return c(e,n),u;if(null===n){for(;!l.done;x++,l=h.next())l=w(e,l.value,k),null!==l&&(g=f(l,g,x),null===t?u=l:t.sibling=l,t=l);return u}for(n=d(e,n);!l.done;x++,l=h.next())l=nc(n,e,x,l.value,k),null!==l&&(a&&null!==l.alternate&&n.delete(null===l.key?x:l.key),g=f(l,g,x),null===
t?u=l:t.sibling=l,t=l);a&&n.forEach(function(a){return b(e,a)});return u}return function(a,d,f,h){var k="object"===typeof f&&null!==f&&f.type===ic&&null===f.key;k&&(f=f.props.children);var n="object"===typeof f&&null!==f;if(n)switch(f.$$typeof){case gc:a:{n=f.key;for(k=d;null!==k;){if(k.key===n)if(10===k.tag?f.type===ic:k.type===f.type){c(a,k.sibling);d=e(k,f.type===ic?f.props.children:f.props,h);d.ref=ug(a,k,f);d.return=a;a=d;break a}else{c(a,k);break}else b(a,k);k=k.sibling}f.type===ic?(d=Bf(f.props.children,
a.mode,h,f.key),d.return=a,a=d):(h=Af(f,a.mode,h),h.ref=ug(a,d,f),h.return=a,a=h)}return g(a);case hc:a:{for(k=f.key;null!==d;){if(d.key===k)if(4===d.tag&&d.stateNode.containerInfo===f.containerInfo&&d.stateNode.implementation===f.implementation){c(a,d.sibling);d=e(d,f.children||[],h);d.return=a;a=d;break a}else{c(a,d);break}else b(a,d);d=d.sibling}d=Df(f,a.mode,h);d.return=a;a=d}return g(a)}if("string"===typeof f||"number"===typeof f)return f=""+f,null!==d&&6===d.tag?(c(a,d.sibling),d=e(d,f,h),d.return=
a,a=d):(c(a,d),d=Cf(f,a.mode,h),d.return=a,a=d),g(a);if(tg(f))return Jd(a,d,f,h);if(tc(f))return E(a,d,f,h);n&&vg(a,f);if("undefined"===typeof f&&!k)switch(a.tag){case 2:case 1:h=a.type,A("152",h.displayName||h.name||"Component")}return c(a,d)}}var xg=wg(!0),yg=wg(!1),zg=null,Ag=null,Bg=!1;function Cg(a,b){var c=new yf(5,null,null,0);c.type="DELETED";c.stateNode=b;c.return=a;c.effectTag=8;null!==a.lastEffect?(a.lastEffect.nextEffect=c,a.lastEffect=c):a.firstEffect=a.lastEffect=c}
function Dg(a,b){switch(a.tag){case 5:var c=a.type;b=1!==b.nodeType||c.toLowerCase()!==b.nodeName.toLowerCase()?null:b;return null!==b?(a.stateNode=b,!0):!1;case 6:return b=""===a.pendingProps||3!==b.nodeType?null:b,null!==b?(a.stateNode=b,!0):!1;default:return!1}}function Eg(a){if(Bg){var b=Ag;if(b){var c=b;if(!Dg(a,b)){b=hf(c);if(!b||!Dg(a,b)){a.effectTag|=2;Bg=!1;zg=a;return}Cg(zg,c)}zg=a;Ag=jf(b)}else a.effectTag|=2,Bg=!1,zg=a}}
function Fg(a){for(a=a.return;null!==a&&5!==a.tag&&3!==a.tag;)a=a.return;zg=a}function Gg(a){if(a!==zg)return!1;if(!Bg)return Fg(a),Bg=!0,!1;var b=a.type;if(5!==a.tag||"head"!==b&&"body"!==b&&!df(b,a.memoizedProps))for(b=Ag;b;)Cg(a,b),b=hf(b);Fg(a);Ag=zg?hf(a.stateNode):null;return!0}function Hg(){Ag=zg=null;Bg=!1}function Q(a,b,c){Ig(a,b,c,b.expirationTime)}function Ig(a,b,c,d){b.child=null===a?yg(b,null,c,d):xg(b,a.child,c,d)}
function Jg(a,b){var c=b.ref;if(null===a&&null!==c||null!==a&&a.ref!==c)b.effectTag|=128}function Kg(a,b,c,d,e){Jg(a,b);var f=0!==(b.effectTag&64);if(!c&&!f)return d&&xf(b,!1),R(a,b);c=b.stateNode;ec.current=b;var g=f?null:c.render();b.effectTag|=1;f&&(Ig(a,b,null,e),b.child=null);Ig(a,b,g,e);b.memoizedState=c.state;b.memoizedProps=c.props;d&&xf(b,!0);return b.child}
function Lg(a){var b=a.stateNode;b.pendingContext?uf(a,b.pendingContext,b.pendingContext!==b.context):b.context&&uf(a,b.context,!1);ig(a,b.containerInfo)}
function Mg(a,b,c,d){var e=a.child;null!==e&&(e.return=a);for(;null!==e;){switch(e.tag){case 12:var f=e.stateNode|0;if(e.type===b&&0!==(f&c)){for(f=e;null!==f;){var g=f.alternate;if(0===f.expirationTime||f.expirationTime>d)f.expirationTime=d,null!==g&&(0===g.expirationTime||g.expirationTime>d)&&(g.expirationTime=d);else if(null!==g&&(0===g.expirationTime||g.expirationTime>d))g.expirationTime=d;else break;f=f.return}f=null}else f=e.child;break;case 13:f=e.type===a.type?null:e.child;break;default:f=
e.child}if(null!==f)f.return=e;else for(f=e;null!==f;){if(f===a){f=null;break}e=f.sibling;if(null!==e){e.return=f.return;f=e;break}f=f.return}e=f}}
function Qg(a,b,c){var d=b.type._context,e=b.pendingProps,f=b.memoizedProps,g=!0;if(O.current)g=!1;else if(f===e)return b.stateNode=0,ag(b),R(a,b);var h=e.value;b.memoizedProps=e;if(null===f)h=1073741823;else if(f.value===e.value){if(f.children===e.children&&g)return b.stateNode=0,ag(b),R(a,b);h=0}else{var k=f.value;if(k===h&&(0!==k||1/k===1/h)||k!==k&&h!==h){if(f.children===e.children&&g)return b.stateNode=0,ag(b),R(a,b);h=0}else if(h="function"===typeof d._calculateChangedBits?d._calculateChangedBits(k,
h):1073741823,h|=0,0===h){if(f.children===e.children&&g)return b.stateNode=0,ag(b),R(a,b)}else Mg(b,d,h,c)}b.stateNode=h;ag(b);Q(a,b,e.children);return b.child}function R(a,b){null!==a&&b.child!==a.child?A("153"):void 0;if(null!==b.child){a=b.child;var c=zf(a,a.pendingProps,a.expirationTime);b.child=c;for(c.return=b;null!==a.sibling;)a=a.sibling,c=c.sibling=zf(a,a.pendingProps,a.expirationTime),c.return=b;c.sibling=null}return b.child}
function Rg(a,b,c){if(0===b.expirationTime||b.expirationTime>c){switch(b.tag){case 3:Lg(b);break;case 2:wf(b);break;case 4:ig(b,b.stateNode.containerInfo);break;case 13:ag(b)}return null}switch(b.tag){case 0:null!==a?A("155"):void 0;var d=b.type,e=b.pendingProps,f=pf(b);f=rf(b,f);d=d(e,f);b.effectTag|=1;"object"===typeof d&&null!==d&&"function"===typeof d.render&&void 0===d.$$typeof?(f=b.type,b.tag=2,b.memoizedState=null!==d.state&&void 0!==d.state?d.state:null,f=f.getDerivedStateFromProps,"function"===
typeof f&&lg(b,f,e),e=wf(b),d.updater=pg,b.stateNode=d,d._reactInternalFiber=b,sg(b,c),a=Kg(a,b,!0,e,c)):(b.tag=1,Q(a,b,d),b.memoizedProps=e,a=b.child);return a;case 1:return e=b.type,c=b.pendingProps,O.current||b.memoizedProps!==c?(d=pf(b),d=rf(b,d),e=e(c,d),b.effectTag|=1,Q(a,b,e),b.memoizedProps=c,a=b.child):a=R(a,b),a;case 2:e=wf(b);if(null===a)if(null===b.stateNode){var g=b.pendingProps,h=b.type;d=pf(b);var k=2===b.tag&&null!=b.type.contextTypes;f=k?rf(b,d):ha;g=new h(g,f);b.memoizedState=null!==
g.state&&void 0!==g.state?g.state:null;g.updater=pg;b.stateNode=g;g._reactInternalFiber=b;k&&(k=b.stateNode,k.__reactInternalMemoizedUnmaskedChildContext=d,k.__reactInternalMemoizedMaskedChildContext=f);sg(b,c);d=!0}else{h=b.type;d=b.stateNode;k=b.memoizedProps;f=b.pendingProps;d.props=k;var n=d.context;g=pf(b);g=rf(b,g);var r=h.getDerivedStateFromProps;(h="function"===typeof r||"function"===typeof d.getSnapshotBeforeUpdate)||"function"!==typeof d.UNSAFE_componentWillReceiveProps&&"function"!==typeof d.componentWillReceiveProps||
(k!==f||n!==g)&&rg(b,d,f,g);Lf=!1;var w=b.memoizedState;n=d.state=w;var P=b.updateQueue;null!==P&&(Uf(b,P,f,d,c),n=b.memoizedState);k!==f||w!==n||O.current||Lf?("function"===typeof r&&(lg(b,r,f),n=b.memoizedState),(k=Lf||qg(b,k,f,w,n,g))?(h||"function"!==typeof d.UNSAFE_componentWillMount&&"function"!==typeof d.componentWillMount||("function"===typeof d.componentWillMount&&d.componentWillMount(),"function"===typeof d.UNSAFE_componentWillMount&&d.UNSAFE_componentWillMount()),"function"===typeof d.componentDidMount&&
(b.effectTag|=4)):("function"===typeof d.componentDidMount&&(b.effectTag|=4),b.memoizedProps=f,b.memoizedState=n),d.props=f,d.state=n,d.context=g,d=k):("function"===typeof d.componentDidMount&&(b.effectTag|=4),d=!1)}else h=b.type,d=b.stateNode,f=b.memoizedProps,k=b.pendingProps,d.props=f,n=d.context,g=pf(b),g=rf(b,g),r=h.getDerivedStateFromProps,(h="function"===typeof r||"function"===typeof d.getSnapshotBeforeUpdate)||"function"!==typeof d.UNSAFE_componentWillReceiveProps&&"function"!==typeof d.componentWillReceiveProps||
(f!==k||n!==g)&&rg(b,d,k,g),Lf=!1,n=b.memoizedState,w=d.state=n,P=b.updateQueue,null!==P&&(Uf(b,P,k,d,c),w=b.memoizedState),f!==k||n!==w||O.current||Lf?("function"===typeof r&&(lg(b,r,k),w=b.memoizedState),(r=Lf||qg(b,f,k,n,w,g))?(h||"function"!==typeof d.UNSAFE_componentWillUpdate&&"function"!==typeof d.componentWillUpdate||("function"===typeof d.componentWillUpdate&&d.componentWillUpdate(k,w,g),"function"===typeof d.UNSAFE_componentWillUpdate&&d.UNSAFE_componentWillUpdate(k,w,g)),"function"===typeof d.componentDidUpdate&&
(b.effectTag|=4),"function"===typeof d.getSnapshotBeforeUpdate&&(b.effectTag|=256)):("function"!==typeof d.componentDidUpdate||f===a.memoizedProps&&n===a.memoizedState||(b.effectTag|=4),"function"!==typeof d.getSnapshotBeforeUpdate||f===a.memoizedProps&&n===a.memoizedState||(b.effectTag|=256),b.memoizedProps=k,b.memoizedState=w),d.props=k,d.state=w,d.context=g,d=r):("function"!==typeof d.componentDidUpdate||f===a.memoizedProps&&n===a.memoizedState||(b.effectTag|=4),"function"!==typeof d.getSnapshotBeforeUpdate||
f===a.memoizedProps&&n===a.memoizedState||(b.effectTag|=256),d=!1);return Kg(a,b,d,e,c);case 3:Lg(b);e=b.updateQueue;if(null!==e)if(d=b.memoizedState,d=null!==d?d.element:null,Uf(b,e,b.pendingProps,null,c),e=b.memoizedState.element,e===d)Hg(),a=R(a,b);else{d=b.stateNode;if(d=(null===a||null===a.child)&&d.hydrate)Ag=jf(b.stateNode.containerInfo),zg=b,d=Bg=!0;d?(b.effectTag|=2,b.child=yg(b,null,e,c)):(Hg(),Q(a,b,e));a=b.child}else Hg(),a=R(a,b);return a;case 5:a:{gg(fg.current);e=gg(dg.current);d=He(e,
b.type);e!==d&&(N(eg,b,b),N(dg,d,b));null===a&&Eg(b);e=b.type;k=b.memoizedProps;d=b.pendingProps;f=null!==a?a.memoizedProps:null;if(!O.current&&k===d){if(k=b.mode&1&&!!d.hidden)b.expirationTime=1073741823;if(!k||1073741823!==c){a=R(a,b);break a}}k=d.children;df(e,d)?k=null:f&&df(e,f)&&(b.effectTag|=16);Jg(a,b);1073741823!==c&&b.mode&1&&d.hidden?(b.expirationTime=1073741823,b.memoizedProps=d,a=null):(Q(a,b,k),b.memoizedProps=d,a=b.child)}return a;case 6:return null===a&&Eg(b),b.memoizedProps=b.pendingProps,
null;case 16:return null;case 4:return ig(b,b.stateNode.containerInfo),e=b.pendingProps,O.current||b.memoizedProps!==e?(null===a?b.child=xg(b,null,e,c):Q(a,b,e),b.memoizedProps=e,a=b.child):a=R(a,b),a;case 14:return e=b.type.render,c=b.pendingProps,d=b.ref,O.current||b.memoizedProps!==c||d!==(null!==a?a.ref:null)?(e=e(c,d),Q(a,b,e),b.memoizedProps=c,a=b.child):a=R(a,b),a;case 10:return c=b.pendingProps,O.current||b.memoizedProps!==c?(Q(a,b,c),b.memoizedProps=c,a=b.child):a=R(a,b),a;case 11:return c=
b.pendingProps.children,O.current||null!==c&&b.memoizedProps!==c?(Q(a,b,c),b.memoizedProps=c,a=b.child):a=R(a,b),a;case 15:return c=b.pendingProps,b.memoizedProps===c?a=R(a,b):(Q(a,b,c.children),b.memoizedProps=c,a=b.child),a;case 13:return Qg(a,b,c);case 12:a:if(d=b.type,f=b.pendingProps,k=b.memoizedProps,e=d._currentValue,g=d._changedBits,O.current||0!==g||k!==f){b.memoizedProps=f;h=f.unstable_observedBits;if(void 0===h||null===h)h=1073741823;b.stateNode=h;if(0!==(g&h))Mg(b,d,g,c);else if(k===f){a=
R(a,b);break a}c=f.children;c=c(e);b.effectTag|=1;Q(a,b,c);a=b.child}else a=R(a,b);return a;default:A("156")}}function Sg(a){a.effectTag|=4}var Tg=void 0,Ug=void 0,Vg=void 0;Tg=function(){};Ug=function(a,b,c){(b.updateQueue=c)&&Sg(b)};Vg=function(a,b,c,d){c!==d&&Sg(b)};
function Wg(a,b){var c=b.pendingProps;switch(b.tag){case 1:return null;case 2:return sf(b),null;case 3:jg(b);tf(b);var d=b.stateNode;d.pendingContext&&(d.context=d.pendingContext,d.pendingContext=null);if(null===a||null===a.child)Gg(b),b.effectTag&=-3;Tg(b);return null;case 5:kg(b);d=gg(fg.current);var e=b.type;if(null!==a&&null!=b.stateNode){var f=a.memoizedProps,g=b.stateNode,h=gg(dg.current);g=We(g,e,f,c,d);Ug(a,b,g,e,f,c,d,h);a.ref!==b.ref&&(b.effectTag|=128)}else{if(!c)return null===b.stateNode?
A("166"):void 0,null;a=gg(dg.current);if(Gg(b))c=b.stateNode,e=b.type,f=b.memoizedProps,c[C]=b,c[Ma]=f,d=Ye(c,e,f,a,d),b.updateQueue=d,null!==d&&Sg(b);else{a=Te(e,c,d,a);a[C]=b;a[Ma]=c;a:for(f=b.child;null!==f;){if(5===f.tag||6===f.tag)a.appendChild(f.stateNode);else if(4!==f.tag&&null!==f.child){f.child.return=f;f=f.child;continue}if(f===b)break;for(;null===f.sibling;){if(null===f.return||f.return===b)break a;f=f.return}f.sibling.return=f.return;f=f.sibling}Ve(a,e,c,d);cf(e,c)&&Sg(b);b.stateNode=
a}null!==b.ref&&(b.effectTag|=128)}return null;case 6:if(a&&null!=b.stateNode)Vg(a,b,a.memoizedProps,c);else{if("string"!==typeof c)return null===b.stateNode?A("166"):void 0,null;d=gg(fg.current);gg(dg.current);Gg(b)?(d=b.stateNode,c=b.memoizedProps,d[C]=b,Ze(d,c)&&Sg(b)):(d=Ue(c,d),d[C]=b,b.stateNode=d)}return null;case 14:return null;case 16:return null;case 10:return null;case 11:return null;case 15:return null;case 4:return jg(b),Tg(b),null;case 13:return bg(b),null;case 12:return null;case 0:A("167");
default:A("156")}}function Xg(a,b){var c=b.source;null===b.stack&&null!==c&&vc(c);null!==c&&uc(c);b=b.value;null!==a&&2===a.tag&&uc(a);try{b&&b.suppressReactErrorLogging||console.error(b)}catch(d){d&&d.suppressReactErrorLogging||console.error(d)}}function Yg(a){var b=a.ref;if(null!==b)if("function"===typeof b)try{b(null)}catch(c){Zg(a,c)}else b.current=null}
function $g(a){"function"===typeof Kf&&Kf(a);switch(a.tag){case 2:Yg(a);var b=a.stateNode;if("function"===typeof b.componentWillUnmount)try{b.props=a.memoizedProps,b.state=a.memoizedState,b.componentWillUnmount()}catch(c){Zg(a,c)}break;case 5:Yg(a);break;case 4:ah(a)}}function bh(a){return 5===a.tag||3===a.tag||4===a.tag}
function ch(a){a:{for(var b=a.return;null!==b;){if(bh(b)){var c=b;break a}b=b.return}A("160");c=void 0}var d=b=void 0;switch(c.tag){case 5:b=c.stateNode;d=!1;break;case 3:b=c.stateNode.containerInfo;d=!0;break;case 4:b=c.stateNode.containerInfo;d=!0;break;default:A("161")}c.effectTag&16&&(Ke(b,""),c.effectTag&=-17);a:b:for(c=a;;){for(;null===c.sibling;){if(null===c.return||bh(c.return)){c=null;break a}c=c.return}c.sibling.return=c.return;for(c=c.sibling;5!==c.tag&&6!==c.tag;){if(c.effectTag&2)continue b;
if(null===c.child||4===c.tag)continue b;else c.child.return=c,c=c.child}if(!(c.effectTag&2)){c=c.stateNode;break a}}for(var e=a;;){if(5===e.tag||6===e.tag)if(c)if(d){var f=b,g=e.stateNode,h=c;8===f.nodeType?f.parentNode.insertBefore(g,h):f.insertBefore(g,h)}else b.insertBefore(e.stateNode,c);else d?(f=b,g=e.stateNode,8===f.nodeType?f.parentNode.insertBefore(g,f):f.appendChild(g)):b.appendChild(e.stateNode);else if(4!==e.tag&&null!==e.child){e.child.return=e;e=e.child;continue}if(e===a)break;for(;null===
e.sibling;){if(null===e.return||e.return===a)return;e=e.return}e.sibling.return=e.return;e=e.sibling}}
function ah(a){for(var b=a,c=!1,d=void 0,e=void 0;;){if(!c){c=b.return;a:for(;;){null===c?A("160"):void 0;switch(c.tag){case 5:d=c.stateNode;e=!1;break a;case 3:d=c.stateNode.containerInfo;e=!0;break a;case 4:d=c.stateNode.containerInfo;e=!0;break a}c=c.return}c=!0}if(5===b.tag||6===b.tag){a:for(var f=b,g=f;;)if($g(g),null!==g.child&&4!==g.tag)g.child.return=g,g=g.child;else{if(g===f)break;for(;null===g.sibling;){if(null===g.return||g.return===f)break a;g=g.return}g.sibling.return=g.return;g=g.sibling}e?
(f=d,g=b.stateNode,8===f.nodeType?f.parentNode.removeChild(g):f.removeChild(g)):d.removeChild(b.stateNode)}else if(4===b.tag?d=b.stateNode.containerInfo:$g(b),null!==b.child){b.child.return=b;b=b.child;continue}if(b===a)break;for(;null===b.sibling;){if(null===b.return||b.return===a)return;b=b.return;4===b.tag&&(c=!1)}b.sibling.return=b.return;b=b.sibling}}
function dh(a,b){switch(b.tag){case 2:break;case 5:var c=b.stateNode;if(null!=c){var d=b.memoizedProps;a=null!==a?a.memoizedProps:d;var e=b.type,f=b.updateQueue;b.updateQueue=null;null!==f&&(c[Ma]=d,Xe(c,f,e,a,d))}break;case 6:null===b.stateNode?A("162"):void 0;b.stateNode.nodeValue=b.memoizedProps;break;case 3:break;case 15:break;case 16:break;default:A("163")}}function eh(a,b,c){c=Of(c);c.tag=3;c.payload={element:null};var d=b.value;c.callback=function(){fh(d);Xg(a,b)};return c}
function gh(a,b,c){c=Of(c);c.tag=3;var d=a.stateNode;null!==d&&"function"===typeof d.componentDidCatch&&(c.callback=function(){null===hh?hh=new Set([this]):hh.add(this);var c=b.value,d=b.stack;Xg(a,b);this.componentDidCatch(c,{componentStack:null!==d?d:""})});return c}
function ih(a,b,c,d,e,f){c.effectTag|=512;c.firstEffect=c.lastEffect=null;d=Xf(d,c);a=b;do{switch(a.tag){case 3:a.effectTag|=1024;d=eh(a,d,f);Rf(a,d,f);return;case 2:if(b=d,c=a.stateNode,0===(a.effectTag&64)&&null!==c&&"function"===typeof c.componentDidCatch&&(null===hh||!hh.has(c))){a.effectTag|=1024;d=gh(a,b,f);Rf(a,d,f);return}}a=a.return}while(null!==a)}
function jh(a){switch(a.tag){case 2:sf(a);var b=a.effectTag;return b&1024?(a.effectTag=b&-1025|64,a):null;case 3:return jg(a),tf(a),b=a.effectTag,b&1024?(a.effectTag=b&-1025|64,a):null;case 5:return kg(a),null;case 16:return b=a.effectTag,b&1024?(a.effectTag=b&-1025|64,a):null;case 4:return jg(a),null;case 13:return bg(a),null;default:return null}}var kh=ef(),lh=2,mh=kh,nh=0,oh=0,ph=!1,S=null,qh=null,T=0,rh=-1,sh=!1,U=null,th=!1,uh=!1,hh=null;
function vh(){if(null!==S)for(var a=S.return;null!==a;){var b=a;switch(b.tag){case 2:sf(b);break;case 3:jg(b);tf(b);break;case 5:kg(b);break;case 4:jg(b);break;case 13:bg(b)}a=a.return}qh=null;T=0;rh=-1;sh=!1;S=null;uh=!1}
function wh(a){for(;;){var b=a.alternate,c=a.return,d=a.sibling;if(0===(a.effectTag&512)){b=Wg(b,a,T);var e=a;if(1073741823===T||1073741823!==e.expirationTime){var f=0;switch(e.tag){case 3:case 2:var g=e.updateQueue;null!==g&&(f=g.expirationTime)}for(g=e.child;null!==g;)0!==g.expirationTime&&(0===f||f>g.expirationTime)&&(f=g.expirationTime),g=g.sibling;e.expirationTime=f}if(null!==b)return b;null!==c&&0===(c.effectTag&512)&&(null===c.firstEffect&&(c.firstEffect=a.firstEffect),null!==a.lastEffect&&
(null!==c.lastEffect&&(c.lastEffect.nextEffect=a.firstEffect),c.lastEffect=a.lastEffect),1<a.effectTag&&(null!==c.lastEffect?c.lastEffect.nextEffect=a:c.firstEffect=a,c.lastEffect=a));if(null!==d)return d;if(null!==c)a=c;else{uh=!0;break}}else{a=jh(a,sh,T);if(null!==a)return a.effectTag&=511,a;null!==c&&(c.firstEffect=c.lastEffect=null,c.effectTag|=512);if(null!==d)return d;if(null!==c)a=c;else break}}return null}
function xh(a){var b=Rg(a.alternate,a,T);null===b&&(b=wh(a));ec.current=null;return b}
function yh(a,b,c){ph?A("243"):void 0;ph=!0;if(b!==T||a!==qh||null===S)vh(),qh=a,T=b,rh=-1,S=zf(qh.current,null,T),a.pendingCommitExpirationTime=0;var d=!1;sh=!c||T<=lh;do{try{if(c)for(;null!==S&&!zh();)S=xh(S);else for(;null!==S;)S=xh(S)}catch(f){if(null===S)d=!0,fh(f);else{null===S?A("271"):void 0;c=S;var e=c.return;if(null===e){d=!0;fh(f);break}ih(a,e,c,f,sh,T,mh);S=wh(c)}}break}while(1);ph=!1;if(d)return null;if(null===S){if(uh)return a.pendingCommitExpirationTime=b,a.current.alternate;sh?A("262"):
void 0;0<=rh&&setTimeout(function(){var b=a.current.expirationTime;0!==b&&(0===a.remainingExpirationTime||a.remainingExpirationTime<b)&&Ah(a,b)},rh);Bh(a.current.expirationTime)}return null}
function Zg(a,b){var c;a:{ph&&!th?A("263"):void 0;for(c=a.return;null!==c;){switch(c.tag){case 2:var d=c.stateNode;if("function"===typeof c.type.getDerivedStateFromCatch||"function"===typeof d.componentDidCatch&&(null===hh||!hh.has(d))){a=Xf(b,a);a=gh(c,a,1);Qf(c,a,1);og(c,1);c=void 0;break a}break;case 3:a=Xf(b,a);a=eh(c,a,1);Qf(c,a,1);og(c,1);c=void 0;break a}c=c.return}3===a.tag&&(c=Xf(b,a),c=eh(a,c,1),Qf(a,c,1),og(a,1));c=void 0}return c}
function Ch(){var a=2+25*(((mg()-2+500)/25|0)+1);a<=nh&&(a=nh+1);return nh=a}function ng(a,b){a=0!==oh?oh:ph?th?1:T:b.mode&1?Dh?2+10*(((a-2+15)/10|0)+1):2+25*(((a-2+500)/25|0)+1):1;Dh&&(0===Eh||a>Eh)&&(Eh=a);return a}
function og(a,b){for(;null!==a;){if(0===a.expirationTime||a.expirationTime>b)a.expirationTime=b;null!==a.alternate&&(0===a.alternate.expirationTime||a.alternate.expirationTime>b)&&(a.alternate.expirationTime=b);if(null===a.return)if(3===a.tag){var c=a.stateNode;!ph&&0!==T&&b<T&&vh();var d=c.current.expirationTime;ph&&!th&&qh===c||Ah(c,d);Fh>Gh&&A("185")}else break;a=a.return}}function mg(){mh=ef()-kh;return lh=(mh/10|0)+2}
function Hh(a){var b=oh;oh=2+25*(((mg()-2+500)/25|0)+1);try{return a()}finally{oh=b}}function Ih(a,b,c,d,e){var f=oh;oh=1;try{return a(b,c,d,e)}finally{oh=f}}var Jh=null,V=null,Kh=0,Lh=void 0,W=!1,X=null,Y=0,Eh=0,Mh=!1,Nh=!1,Oh=null,Ph=null,Z=!1,Qh=!1,Dh=!1,Rh=null,Gh=1E3,Fh=0,Sh=1;function Th(a){if(0!==Kh){if(a>Kh)return;null!==Lh&&gf(Lh)}var b=ef()-kh;Kh=a;Lh=ff(Uh,{timeout:10*(a-2)-b})}
function Ah(a,b){if(null===a.nextScheduledRoot)a.remainingExpirationTime=b,null===V?(Jh=V=a,a.nextScheduledRoot=a):(V=V.nextScheduledRoot=a,V.nextScheduledRoot=Jh);else{var c=a.remainingExpirationTime;if(0===c||b<c)a.remainingExpirationTime=b}W||(Z?Qh&&(X=a,Y=1,Vh(a,1,!1)):1===b?Wh():Th(b))}
function Xh(){var a=0,b=null;if(null!==V)for(var c=V,d=Jh;null!==d;){var e=d.remainingExpirationTime;if(0===e){null===c||null===V?A("244"):void 0;if(d===d.nextScheduledRoot){Jh=V=d.nextScheduledRoot=null;break}else if(d===Jh)Jh=e=d.nextScheduledRoot,V.nextScheduledRoot=e,d.nextScheduledRoot=null;else if(d===V){V=c;V.nextScheduledRoot=Jh;d.nextScheduledRoot=null;break}else c.nextScheduledRoot=d.nextScheduledRoot,d.nextScheduledRoot=null;d=c.nextScheduledRoot}else{if(0===a||e<a)a=e,b=d;if(d===V)break;
c=d;d=d.nextScheduledRoot}}c=X;null!==c&&c===b&&1===a?Fh++:Fh=0;X=b;Y=a}function Uh(a){Yh(0,!0,a)}function Wh(){Yh(1,!1,null)}function Yh(a,b,c){Ph=c;Xh();if(b)for(;null!==X&&0!==Y&&(0===a||a>=Y)&&(!Mh||mg()>=Y);)mg(),Vh(X,Y,!Mh),Xh();else for(;null!==X&&0!==Y&&(0===a||a>=Y);)Vh(X,Y,!1),Xh();null!==Ph&&(Kh=0,Lh=null);0!==Y&&Th(Y);Ph=null;Mh=!1;Zh()}function $h(a,b){W?A("253"):void 0;X=a;Y=b;Vh(a,b,!1);Wh();Zh()}
function Zh(){Fh=0;if(null!==Rh){var a=Rh;Rh=null;for(var b=0;b<a.length;b++){var c=a[b];try{c._onComplete()}catch(d){Nh||(Nh=!0,Oh=d)}}}if(Nh)throw a=Oh,Oh=null,Nh=!1,a;}function Vh(a,b,c){W?A("245"):void 0;W=!0;c?(c=a.finishedWork,null!==c?ai(a,c,b):(c=yh(a,b,!0),null!==c&&(zh()?a.finishedWork=c:ai(a,c,b)))):(c=a.finishedWork,null!==c?ai(a,c,b):(c=yh(a,b,!1),null!==c&&ai(a,c,b)));W=!1}
function ai(a,b,c){var d=a.firstBatch;if(null!==d&&d._expirationTime<=c&&(null===Rh?Rh=[d]:Rh.push(d),d._defer)){a.finishedWork=b;a.remainingExpirationTime=0;return}a.finishedWork=null;th=ph=!0;c=b.stateNode;c.current===b?A("177"):void 0;d=c.pendingCommitExpirationTime;0===d?A("261"):void 0;c.pendingCommitExpirationTime=0;mg();ec.current=null;if(1<b.effectTag)if(null!==b.lastEffect){b.lastEffect.nextEffect=b;var e=b.firstEffect}else e=b;else e=b.firstEffect;af=Hd;var f=da();if(Ud(f)){if("selectionStart"in
f)var g={start:f.selectionStart,end:f.selectionEnd};else a:{var h=window.getSelection&&window.getSelection();if(h&&0!==h.rangeCount){g=h.anchorNode;var k=h.anchorOffset,n=h.focusNode;h=h.focusOffset;try{g.nodeType,n.nodeType}catch(Wa){g=null;break a}var r=0,w=-1,P=-1,nc=0,Jd=0,E=f,t=null;b:for(;;){for(var x;;){E!==g||0!==k&&3!==E.nodeType||(w=r+k);E!==n||0!==h&&3!==E.nodeType||(P=r+h);3===E.nodeType&&(r+=E.nodeValue.length);if(null===(x=E.firstChild))break;t=E;E=x}for(;;){if(E===f)break b;t===g&&
++nc===k&&(w=r);t===n&&++Jd===h&&(P=r);if(null!==(x=E.nextSibling))break;E=t;t=E.parentNode}E=x}g=-1===w||-1===P?null:{start:w,end:P}}else g=null}g=g||{start:0,end:0}}else g=null;bf={focusedElem:f,selectionRange:g};Id(!1);for(U=e;null!==U;){f=!1;g=void 0;try{for(;null!==U;){if(U.effectTag&256){var u=U.alternate;k=U;switch(k.tag){case 2:if(k.effectTag&256&&null!==u){var y=u.memoizedProps,D=u.memoizedState,ja=k.stateNode;ja.props=k.memoizedProps;ja.state=k.memoizedState;var mi=ja.getSnapshotBeforeUpdate(y,
D);ja.__reactInternalSnapshotBeforeUpdate=mi}break;case 3:case 5:case 6:case 4:break;default:A("163")}}U=U.nextEffect}}catch(Wa){f=!0,g=Wa}f&&(null===U?A("178"):void 0,Zg(U,g),null!==U&&(U=U.nextEffect))}for(U=e;null!==U;){u=!1;y=void 0;try{for(;null!==U;){var q=U.effectTag;q&16&&Ke(U.stateNode,"");if(q&128){var z=U.alternate;if(null!==z){var l=z.ref;null!==l&&("function"===typeof l?l(null):l.current=null)}}switch(q&14){case 2:ch(U);U.effectTag&=-3;break;case 6:ch(U);U.effectTag&=-3;dh(U.alternate,
U);break;case 4:dh(U.alternate,U);break;case 8:D=U,ah(D),D.return=null,D.child=null,D.alternate&&(D.alternate.child=null,D.alternate.return=null)}U=U.nextEffect}}catch(Wa){u=!0,y=Wa}u&&(null===U?A("178"):void 0,Zg(U,y),null!==U&&(U=U.nextEffect))}l=bf;z=da();q=l.focusedElem;u=l.selectionRange;if(z!==q&&fa(document.documentElement,q)){null!==u&&Ud(q)&&(z=u.start,l=u.end,void 0===l&&(l=z),"selectionStart"in q?(q.selectionStart=z,q.selectionEnd=Math.min(l,q.value.length)):window.getSelection&&(z=window.getSelection(),
y=q[lb()].length,l=Math.min(u.start,y),u=void 0===u.end?l:Math.min(u.end,y),!z.extend&&l>u&&(y=u,u=l,l=y),y=Td(q,l),D=Td(q,u),y&&D&&(1!==z.rangeCount||z.anchorNode!==y.node||z.anchorOffset!==y.offset||z.focusNode!==D.node||z.focusOffset!==D.offset)&&(ja=document.createRange(),ja.setStart(y.node,y.offset),z.removeAllRanges(),l>u?(z.addRange(ja),z.extend(D.node,D.offset)):(ja.setEnd(D.node,D.offset),z.addRange(ja)))));z=[];for(l=q;l=l.parentNode;)1===l.nodeType&&z.push({element:l,left:l.scrollLeft,
top:l.scrollTop});"function"===typeof q.focus&&q.focus();for(q=0;q<z.length;q++)l=z[q],l.element.scrollLeft=l.left,l.element.scrollTop=l.top}bf=null;Id(af);af=null;c.current=b;for(U=e;null!==U;){e=!1;q=void 0;try{for(z=d;null!==U;){var hg=U.effectTag;if(hg&36){var oc=U.alternate;l=U;u=z;switch(l.tag){case 2:var ca=l.stateNode;if(l.effectTag&4)if(null===oc)ca.props=l.memoizedProps,ca.state=l.memoizedState,ca.componentDidMount();else{var wi=oc.memoizedProps,xi=oc.memoizedState;ca.props=l.memoizedProps;
ca.state=l.memoizedState;ca.componentDidUpdate(wi,xi,ca.__reactInternalSnapshotBeforeUpdate)}var Ng=l.updateQueue;null!==Ng&&(ca.props=l.memoizedProps,ca.state=l.memoizedState,Wf(l,Ng,ca,u));break;case 3:var Og=l.updateQueue;if(null!==Og){y=null;if(null!==l.child)switch(l.child.tag){case 5:y=l.child.stateNode;break;case 2:y=l.child.stateNode}Wf(l,Og,y,u)}break;case 5:var yi=l.stateNode;null===oc&&l.effectTag&4&&cf(l.type,l.memoizedProps)&&yi.focus();break;case 6:break;case 4:break;case 15:break;case 16:break;
default:A("163")}}if(hg&128){l=void 0;var yc=U.ref;if(null!==yc){var Pg=U.stateNode;switch(U.tag){case 5:l=Pg;break;default:l=Pg}"function"===typeof yc?yc(l):yc.current=l}}var zi=U.nextEffect;U.nextEffect=null;U=zi}}catch(Wa){e=!0,q=Wa}e&&(null===U?A("178"):void 0,Zg(U,q),null!==U&&(U=U.nextEffect))}ph=th=!1;"function"===typeof Jf&&Jf(b.stateNode);b=c.current.expirationTime;0===b&&(hh=null);a.remainingExpirationTime=b}function zh(){return null===Ph||Ph.timeRemaining()>Sh?!1:Mh=!0}
function fh(a){null===X?A("246"):void 0;X.remainingExpirationTime=0;Nh||(Nh=!0,Oh=a)}function Bh(a){null===X?A("246"):void 0;X.remainingExpirationTime=a}function bi(a,b){var c=Z;Z=!0;try{return a(b)}finally{(Z=c)||W||Wh()}}function ci(a,b){if(Z&&!Qh){Qh=!0;try{return a(b)}finally{Qh=!1}}return a(b)}function di(a,b){W?A("187"):void 0;var c=Z;Z=!0;try{return Ih(a,b)}finally{Z=c,Wh()}}
function ei(a,b,c){if(Dh)return a(b,c);Z||W||0===Eh||(Yh(Eh,!1,null),Eh=0);var d=Dh,e=Z;Z=Dh=!0;try{return a(b,c)}finally{Dh=d,(Z=e)||W||Wh()}}function fi(a){var b=Z;Z=!0;try{Ih(a)}finally{(Z=b)||W||Yh(1,!1,null)}}
function gi(a,b,c,d,e){var f=b.current;if(c){c=c._reactInternalFiber;var g;b:{2===jd(c)&&2===c.tag?void 0:A("170");for(g=c;3!==g.tag;){if(qf(g)){g=g.stateNode.__reactInternalMemoizedMergedChildContext;break b}(g=g.return)?void 0:A("171")}g=g.stateNode.context}c=qf(c)?vf(c,g):g}else c=ha;null===b.context?b.context=c:b.pendingContext=c;b=e;e=Of(d);e.payload={element:a};b=void 0===b?null:b;null!==b&&(e.callback=b);Qf(f,e,d);og(f,d);return d}
function hi(a){var b=a._reactInternalFiber;void 0===b&&("function"===typeof a.render?A("188"):A("268",Object.keys(a)));a=md(b);return null===a?null:a.stateNode}function ii(a,b,c,d){var e=b.current,f=mg();e=ng(f,e);return gi(a,b,c,e,d)}function ji(a){a=a.current;if(!a.child)return null;switch(a.child.tag){case 5:return a.child.stateNode;default:return a.child.stateNode}}
function ki(a){var b=a.findFiberByHostInstance;return If(p({},a,{findHostInstanceByFiber:function(a){a=md(a);return null===a?null:a.stateNode},findFiberByHostInstance:function(a){return b?b(a):null}}))}
var li={updateContainerAtExpirationTime:gi,createContainer:function(a,b,c){return Ef(a,b,c)},updateContainer:ii,flushRoot:$h,requestWork:Ah,computeUniqueAsyncExpiration:Ch,batchedUpdates:bi,unbatchedUpdates:ci,deferredUpdates:Hh,syncUpdates:Ih,interactiveUpdates:ei,flushInteractiveUpdates:function(){W||0===Eh||(Yh(Eh,!1,null),Eh=0)},flushControlled:fi,flushSync:di,getPublicRootInstance:ji,findHostInstance:hi,findHostInstanceWithNoPortals:function(a){a=nd(a);return null===a?null:a.stateNode},injectIntoDevTools:ki};
function ni(a,b,c){var d=3<arguments.length&&void 0!==arguments[3]?arguments[3]:null;return{$$typeof:hc,key:null==d?null:""+d,children:a,containerInfo:b,implementation:c}}Kb.injectFiberControlledHostComponent($e);function oi(a){this._expirationTime=Ch();this._root=a;this._callbacks=this._next=null;this._hasChildren=this._didComplete=!1;this._children=null;this._defer=!0}
oi.prototype.render=function(a){this._defer?void 0:A("250");this._hasChildren=!0;this._children=a;var b=this._root._internalRoot,c=this._expirationTime,d=new pi;gi(a,b,null,c,d._onCommit);return d};oi.prototype.then=function(a){if(this._didComplete)a();else{var b=this._callbacks;null===b&&(b=this._callbacks=[]);b.push(a)}};
oi.prototype.commit=function(){var a=this._root._internalRoot,b=a.firstBatch;this._defer&&null!==b?void 0:A("251");if(this._hasChildren){var c=this._expirationTime;if(b!==this){this._hasChildren&&(c=this._expirationTime=b._expirationTime,this.render(this._children));for(var d=null,e=b;e!==this;)d=e,e=e._next;null===d?A("251"):void 0;d._next=e._next;this._next=b;a.firstBatch=this}this._defer=!1;$h(a,c);b=this._next;this._next=null;b=a.firstBatch=b;null!==b&&b._hasChildren&&b.render(b._children)}else this._next=
null,this._defer=!1};oi.prototype._onComplete=function(){if(!this._didComplete){this._didComplete=!0;var a=this._callbacks;if(null!==a)for(var b=0;b<a.length;b++)(0,a[b])()}};function pi(){this._callbacks=null;this._didCommit=!1;this._onCommit=this._onCommit.bind(this)}pi.prototype.then=function(a){if(this._didCommit)a();else{var b=this._callbacks;null===b&&(b=this._callbacks=[]);b.push(a)}};
pi.prototype._onCommit=function(){if(!this._didCommit){this._didCommit=!0;var a=this._callbacks;if(null!==a)for(var b=0;b<a.length;b++){var c=a[b];"function"!==typeof c?A("191",c):void 0;c()}}};function qi(a,b,c){this._internalRoot=Ef(a,b,c)}qi.prototype.render=function(a,b){var c=this._internalRoot,d=new pi;b=void 0===b?null:b;null!==b&&d.then(b);ii(a,c,null,d._onCommit);return d};
qi.prototype.unmount=function(a){var b=this._internalRoot,c=new pi;a=void 0===a?null:a;null!==a&&c.then(a);ii(null,b,null,c._onCommit);return c};qi.prototype.legacy_renderSubtreeIntoContainer=function(a,b,c){var d=this._internalRoot,e=new pi;c=void 0===c?null:c;null!==c&&e.then(c);ii(b,d,a,e._onCommit);return e};
qi.prototype.createBatch=function(){var a=new oi(this),b=a._expirationTime,c=this._internalRoot,d=c.firstBatch;if(null===d)c.firstBatch=a,a._next=null;else{for(c=null;null!==d&&d._expirationTime<=b;)c=d,d=d._next;a._next=d;null!==c&&(c._next=a)}return a};function ri(a){return!(!a||1!==a.nodeType&&9!==a.nodeType&&11!==a.nodeType&&(8!==a.nodeType||" react-mount-point-unstable "!==a.nodeValue))}Sb=li.batchedUpdates;Tb=li.interactiveUpdates;Ub=li.flushInteractiveUpdates;
function si(a,b){b||(b=a?9===a.nodeType?a.documentElement:a.firstChild:null,b=!(!b||1!==b.nodeType||!b.hasAttribute("data-reactroot")));if(!b)for(var c;c=a.lastChild;)a.removeChild(c);return new qi(a,!1,b)}
function ti(a,b,c,d,e){ri(c)?void 0:A("200");var f=c._reactRootContainer;if(f){if("function"===typeof e){var g=e;e=function(){var a=ji(f._internalRoot);g.call(a)}}null!=a?f.legacy_renderSubtreeIntoContainer(a,b,e):f.render(b,e)}else{f=c._reactRootContainer=si(c,d);if("function"===typeof e){var h=e;e=function(){var a=ji(f._internalRoot);h.call(a)}}ci(function(){null!=a?f.legacy_renderSubtreeIntoContainer(a,b,e):f.render(b,e)})}return ji(f._internalRoot)}
function ui(a,b){var c=2<arguments.length&&void 0!==arguments[2]?arguments[2]:null;ri(b)?void 0:A("200");return ni(a,b,null,c)}
var vi={createPortal:ui,findDOMNode:function(a){return null==a?null:1===a.nodeType?a:hi(a)},hydrate:function(a,b,c){return ti(null,a,b,!0,c)},render:function(a,b,c){return ti(null,a,b,!1,c)},unstable_renderSubtreeIntoContainer:function(a,b,c,d){null==a||void 0===a._reactInternalFiber?A("38"):void 0;return ti(a,b,c,!1,d)},unmountComponentAtNode:function(a){ri(a)?void 0:A("40");return a._reactRootContainer?(ci(function(){ti(null,null,a,!1,function(){a._reactRootContainer=null})}),!0):!1},unstable_createPortal:function(){return ui.apply(void 0,
arguments)},unstable_batchedUpdates:bi,unstable_deferredUpdates:Hh,unstable_interactiveUpdates:ei,flushSync:di,unstable_flushControlled:fi,__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED:{EventPluginHub:Ka,EventPluginRegistry:va,EventPropagators:$a,ReactControlledComponent:Rb,ReactDOMComponentTree:Qa,ReactDOMEventListener:Nd},unstable_createRoot:function(a,b){return new qi(a,!0,null!=b&&!0===b.hydrate)}};ki({findFiberByHostInstance:Na,bundleType:0,version:"16.4.1",rendererPackageName:"react-dom"});
var Ai={default:vi},Bi=Ai&&vi||Ai;module.exports=Bi.default?Bi.default:Bi;


/***/ }),
/* 380 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

/**
 * Simple, lightweight module assisting with the detection and context of
 * Worker. Helps avoid circular dependencies and allows code to reason about
 * whether or not they are in a Worker, even if they never include the main
 * `ReactWorker` dependency.
 */
var ExecutionEnvironment = {

  canUseDOM: canUseDOM,

  canUseWorkers: typeof Worker !== 'undefined',

  canUseEventListeners: canUseDOM && !!(window.addEventListener || window.attachEvent),

  canUseViewport: canUseDOM && !!window.screen,

  isInWorker: !canUseDOM // For now, this is true - might change in the future.

};

module.exports = ExecutionEnvironment;

/***/ }),
/* 381 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

/* eslint-disable fb-www/typeof-undefined */

/**
 * Same as document.activeElement but wraps in a try-catch block. In IE it is
 * not safe to call document.activeElement if there is nothing focused.
 *
 * The activeElement will be null only if the document or document body is not
 * yet defined.
 *
 * @param {?DOMDocument} doc Defaults to current document.
 * @return {?DOMElement}
 */
function getActiveElement(doc) /*?DOMElement*/{
  doc = doc || (typeof document !== 'undefined' ? document : undefined);
  if (typeof doc === 'undefined') {
    return null;
  }
  try {
    return doc.activeElement || doc.body;
  } catch (e) {
    return doc.body;
  }
}

module.exports = getActiveElement;

/***/ }),
/* 382 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

var isTextNode = __webpack_require__(383);

/*eslint-disable no-bitwise */

/**
 * Checks if a given DOM node contains or is another DOM node.
 */
function containsNode(outerNode, innerNode) {
  if (!outerNode || !innerNode) {
    return false;
  } else if (outerNode === innerNode) {
    return true;
  } else if (isTextNode(outerNode)) {
    return false;
  } else if (isTextNode(innerNode)) {
    return containsNode(outerNode, innerNode.parentNode);
  } else if ('contains' in outerNode) {
    return outerNode.contains(innerNode);
  } else if (outerNode.compareDocumentPosition) {
    return !!(outerNode.compareDocumentPosition(innerNode) & 16);
  } else {
    return false;
  }
}

module.exports = containsNode;

/***/ }),
/* 383 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

var isNode = __webpack_require__(384);

/**
 * @param {*} object The object to check.
 * @return {boolean} Whether or not the object is a DOM text node.
 */
function isTextNode(object) {
  return isNode(object) && object.nodeType == 3;
}

module.exports = isTextNode;

/***/ }),
/* 384 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

/**
 * @param {*} object The object to check.
 * @return {boolean} Whether or not the object is a DOM node.
 */
function isNode(object) {
  var doc = object ? object.ownerDocument || object : document;
  var defaultView = doc.defaultView || window;
  return !!(object && (typeof defaultView.Node === 'function' ? object instanceof defaultView.Node : typeof object === 'object' && typeof object.nodeType === 'number' && typeof object.nodeName === 'string'));
}

module.exports = isNode;

/***/ }),
/* 385 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function createThunkMiddleware(extraArgument) {
  return function (_ref) {
    var dispatch = _ref.dispatch,
        getState = _ref.getState;
    return function (next) {
      return function (action) {
        if (typeof action === 'function') {
          return action(dispatch, getState, extraArgument);
        }

        return next(action);
      };
    };
  };
}

var thunk = createThunkMiddleware();
thunk.withExtraArgument = createThunkMiddleware;

/* harmony default export */ __webpack_exports__["a"] = (thunk);

/***/ }),
/* 386 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global, module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ponyfill_js__ = __webpack_require__(387);
/* global window */


var root;

if (typeof self !== 'undefined') {
  root = self;
} else if (typeof window !== 'undefined') {
  root = window;
} else if (typeof global !== 'undefined') {
  root = global;
} else if (true) {
  root = module;
} else {
  root = Function('return this')();
}

var result = Object(__WEBPACK_IMPORTED_MODULE_0__ponyfill_js__["a" /* default */])(root);
/* harmony default export */ __webpack_exports__["a"] = (result);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(36), __webpack_require__(219)(module)))

/***/ }),
/* 387 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = symbolObservablePonyfill;
function symbolObservablePonyfill(root) {
	var result;
	var Symbol = root.Symbol;

	if (typeof Symbol === 'function') {
		if (Symbol.observable) {
			result = Symbol.observable;
		} else {
			result = Symbol('observable');
			Symbol.observable = result;
		}
	} else {
		result = '@@observable';
	}

	return result;
};


/***/ }),
/* 388 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__LocationUtils__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__PathUtils__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__createTransitionManager__ = __webpack_require__(160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__DOMUtils__ = __webpack_require__(220);
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };








var PopStateEvent = 'popstate';
var HashChangeEvent = 'hashchange';

var getHistoryState = function getHistoryState() {
  try {
    return window.history.state || {};
  } catch (e) {
    // IE 11 sometimes throws when accessing window.history.state
    // See https://github.com/ReactTraining/history/pull/289
    return {};
  }
};

/**
 * Creates a history object that uses the HTML5 history API including
 * pushState, replaceState, and the popstate event.
 */
var createBrowserHistory = function createBrowserHistory() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  __WEBPACK_IMPORTED_MODULE_1_invariant___default()(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["b" /* canUseDOM */], 'Browser history needs a DOM');

  var globalHistory = window.history;
  var canUseHistory = Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["g" /* supportsHistory */])();
  var needsHashChangeListener = !Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["h" /* supportsPopStateOnHashChange */])();

  var _props$forceRefresh = props.forceRefresh,
      forceRefresh = _props$forceRefresh === undefined ? false : _props$forceRefresh,
      _props$getUserConfirm = props.getUserConfirmation,
      getUserConfirmation = _props$getUserConfirm === undefined ? __WEBPACK_IMPORTED_MODULE_5__DOMUtils__["c" /* getConfirmation */] : _props$getUserConfirm,
      _props$keyLength = props.keyLength,
      keyLength = _props$keyLength === undefined ? 6 : _props$keyLength;

  var basename = props.basename ? Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["g" /* stripTrailingSlash */])(Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["a" /* addLeadingSlash */])(props.basename)) : '';

  var getDOMLocation = function getDOMLocation(historyState) {
    var _ref = historyState || {},
        key = _ref.key,
        state = _ref.state;

    var _window$location = window.location,
        pathname = _window$location.pathname,
        search = _window$location.search,
        hash = _window$location.hash;


    var path = pathname + search + hash;

    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!basename || Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["c" /* hasBasename */])(path, basename), 'You are attempting to use a basename on a page whose URL path does not begin ' + 'with the basename. Expected path "' + path + '" to begin with "' + basename + '".');

    if (basename) path = Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["e" /* stripBasename */])(path, basename);

    return Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(path, state, key);
  };

  var createKey = function createKey() {
    return Math.random().toString(36).substr(2, keyLength);
  };

  var transitionManager = Object(__WEBPACK_IMPORTED_MODULE_4__createTransitionManager__["a" /* default */])();

  var setState = function setState(nextState) {
    _extends(history, nextState);

    history.length = globalHistory.length;

    transitionManager.notifyListeners(history.location, history.action);
  };

  var handlePopState = function handlePopState(event) {
    // Ignore extraneous popstate events in WebKit.
    if (Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["d" /* isExtraneousPopstateEvent */])(event)) return;

    handlePop(getDOMLocation(event.state));
  };

  var handleHashChange = function handleHashChange() {
    handlePop(getDOMLocation(getHistoryState()));
  };

  var forceNextPop = false;

  var handlePop = function handlePop(location) {
    if (forceNextPop) {
      forceNextPop = false;
      setState();
    } else {
      var action = 'POP';

      transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
        if (ok) {
          setState({ action: action, location: location });
        } else {
          revertPop(location);
        }
      });
    }
  };

  var revertPop = function revertPop(fromLocation) {
    var toLocation = history.location;

    // TODO: We could probably make this more reliable by
    // keeping a list of keys we've seen in sessionStorage.
    // Instead, we just default to 0 for keys we don't know.

    var toIndex = allKeys.indexOf(toLocation.key);

    if (toIndex === -1) toIndex = 0;

    var fromIndex = allKeys.indexOf(fromLocation.key);

    if (fromIndex === -1) fromIndex = 0;

    var delta = toIndex - fromIndex;

    if (delta) {
      forceNextPop = true;
      go(delta);
    }
  };

  var initialLocation = getDOMLocation(getHistoryState());
  var allKeys = [initialLocation.key];

  // Public interface

  var createHref = function createHref(location) {
    return basename + Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(location);
  };

  var push = function push(path, state) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to push when the 1st ' + 'argument is a location-like object that already has state; it is ignored');

    var action = 'PUSH';
    var location = Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(path, state, createKey(), history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var href = createHref(location);
      var key = location.key,
          state = location.state;


      if (canUseHistory) {
        globalHistory.pushState({ key: key, state: state }, null, href);

        if (forceRefresh) {
          window.location.href = href;
        } else {
          var prevIndex = allKeys.indexOf(history.location.key);
          var nextKeys = allKeys.slice(0, prevIndex === -1 ? 0 : prevIndex + 1);

          nextKeys.push(location.key);
          allKeys = nextKeys;

          setState({ action: action, location: location });
        }
      } else {
        __WEBPACK_IMPORTED_MODULE_0_warning___default()(state === undefined, 'Browser history cannot push state in browsers that do not support HTML5 history');

        window.location.href = href;
      }
    });
  };

  var replace = function replace(path, state) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to replace when the 1st ' + 'argument is a location-like object that already has state; it is ignored');

    var action = 'REPLACE';
    var location = Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(path, state, createKey(), history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var href = createHref(location);
      var key = location.key,
          state = location.state;


      if (canUseHistory) {
        globalHistory.replaceState({ key: key, state: state }, null, href);

        if (forceRefresh) {
          window.location.replace(href);
        } else {
          var prevIndex = allKeys.indexOf(history.location.key);

          if (prevIndex !== -1) allKeys[prevIndex] = location.key;

          setState({ action: action, location: location });
        }
      } else {
        __WEBPACK_IMPORTED_MODULE_0_warning___default()(state === undefined, 'Browser history cannot replace state in browsers that do not support HTML5 history');

        window.location.replace(href);
      }
    });
  };

  var go = function go(n) {
    globalHistory.go(n);
  };

  var goBack = function goBack() {
    return go(-1);
  };

  var goForward = function goForward() {
    return go(1);
  };

  var listenerCount = 0;

  var checkDOMListeners = function checkDOMListeners(delta) {
    listenerCount += delta;

    if (listenerCount === 1) {
      Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["a" /* addEventListener */])(window, PopStateEvent, handlePopState);

      if (needsHashChangeListener) Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["a" /* addEventListener */])(window, HashChangeEvent, handleHashChange);
    } else if (listenerCount === 0) {
      Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["e" /* removeEventListener */])(window, PopStateEvent, handlePopState);

      if (needsHashChangeListener) Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["e" /* removeEventListener */])(window, HashChangeEvent, handleHashChange);
    }
  };

  var isBlocked = false;

  var block = function block() {
    var prompt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    var unblock = transitionManager.setPrompt(prompt);

    if (!isBlocked) {
      checkDOMListeners(1);
      isBlocked = true;
    }

    return function () {
      if (isBlocked) {
        isBlocked = false;
        checkDOMListeners(-1);
      }

      return unblock();
    };
  };

  var listen = function listen(listener) {
    var unlisten = transitionManager.appendListener(listener);
    checkDOMListeners(1);

    return function () {
      checkDOMListeners(-1);
      unlisten();
    };
  };

  var history = {
    length: globalHistory.length,
    action: 'POP',
    location: initialLocation,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    block: block,
    listen: listen
  };

  return history;
};

/* harmony default export */ __webpack_exports__["a"] = (createBrowserHistory);

/***/ }),
/* 389 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function isAbsolute(pathname) {
  return pathname.charAt(0) === '/';
}

// About 1.5x faster than the two-arg version of Array#splice()
function spliceOne(list, index) {
  for (var i = index, k = i + 1, n = list.length; k < n; i += 1, k += 1) {
    list[i] = list[k];
  }

  list.pop();
}

// This implementation is based heavily on node's url.parse
function resolvePathname(to) {
  var from = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

  var toParts = to && to.split('/') || [];
  var fromParts = from && from.split('/') || [];

  var isToAbs = to && isAbsolute(to);
  var isFromAbs = from && isAbsolute(from);
  var mustEndAbs = isToAbs || isFromAbs;

  if (to && isAbsolute(to)) {
    // to is absolute
    fromParts = toParts;
  } else if (toParts.length) {
    // to is relative, drop the filename
    fromParts.pop();
    fromParts = fromParts.concat(toParts);
  }

  if (!fromParts.length) return '/';

  var hasTrailingSlash = void 0;
  if (fromParts.length) {
    var last = fromParts[fromParts.length - 1];
    hasTrailingSlash = last === '.' || last === '..' || last === '';
  } else {
    hasTrailingSlash = false;
  }

  var up = 0;
  for (var i = fromParts.length; i >= 0; i--) {
    var part = fromParts[i];

    if (part === '.') {
      spliceOne(fromParts, i);
    } else if (part === '..') {
      spliceOne(fromParts, i);
      up++;
    } else if (up) {
      spliceOne(fromParts, i);
      up--;
    }
  }

  if (!mustEndAbs) for (; up--; up) {
    fromParts.unshift('..');
  }if (mustEndAbs && fromParts[0] !== '' && (!fromParts[0] || !isAbsolute(fromParts[0]))) fromParts.unshift('');

  var result = fromParts.join('/');

  if (hasTrailingSlash && result.substr(-1) !== '/') result += '/';

  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (resolvePathname);

/***/ }),
/* 390 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function valueEqual(a, b) {
  if (a === b) return true;

  if (a == null || b == null) return false;

  if (Array.isArray(a)) {
    return Array.isArray(b) && a.length === b.length && a.every(function (item, index) {
      return valueEqual(item, b[index]);
    });
  }

  var aType = typeof a === 'undefined' ? 'undefined' : _typeof(a);
  var bType = typeof b === 'undefined' ? 'undefined' : _typeof(b);

  if (aType !== bType) return false;

  if (aType === 'object') {
    var aValue = a.valueOf();
    var bValue = b.valueOf();

    if (aValue !== a || bValue !== b) return valueEqual(aValue, bValue);

    var aKeys = Object.keys(a);
    var bKeys = Object.keys(b);

    if (aKeys.length !== bKeys.length) return false;

    return aKeys.every(function (key) {
      return valueEqual(a[key], b[key]);
    });
  }

  return false;
}

/* harmony default export */ __webpack_exports__["a"] = (valueEqual);

/***/ }),
/* 391 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__LocationUtils__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__PathUtils__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__createTransitionManager__ = __webpack_require__(160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__DOMUtils__ = __webpack_require__(220);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };








var HashChangeEvent = 'hashchange';

var HashPathCoders = {
  hashbang: {
    encodePath: function encodePath(path) {
      return path.charAt(0) === '!' ? path : '!/' + Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["f" /* stripLeadingSlash */])(path);
    },
    decodePath: function decodePath(path) {
      return path.charAt(0) === '!' ? path.substr(1) : path;
    }
  },
  noslash: {
    encodePath: __WEBPACK_IMPORTED_MODULE_3__PathUtils__["f" /* stripLeadingSlash */],
    decodePath: __WEBPACK_IMPORTED_MODULE_3__PathUtils__["a" /* addLeadingSlash */]
  },
  slash: {
    encodePath: __WEBPACK_IMPORTED_MODULE_3__PathUtils__["a" /* addLeadingSlash */],
    decodePath: __WEBPACK_IMPORTED_MODULE_3__PathUtils__["a" /* addLeadingSlash */]
  }
};

var getHashPath = function getHashPath() {
  // We can't use window.location.hash here because it's not
  // consistent across browsers - Firefox will pre-decode it!
  var href = window.location.href;
  var hashIndex = href.indexOf('#');
  return hashIndex === -1 ? '' : href.substring(hashIndex + 1);
};

var pushHashPath = function pushHashPath(path) {
  return window.location.hash = path;
};

var replaceHashPath = function replaceHashPath(path) {
  var hashIndex = window.location.href.indexOf('#');

  window.location.replace(window.location.href.slice(0, hashIndex >= 0 ? hashIndex : 0) + '#' + path);
};

var createHashHistory = function createHashHistory() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  __WEBPACK_IMPORTED_MODULE_1_invariant___default()(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["b" /* canUseDOM */], 'Hash history needs a DOM');

  var globalHistory = window.history;
  var canGoWithoutReload = Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["f" /* supportsGoWithoutReloadUsingHash */])();

  var _props$getUserConfirm = props.getUserConfirmation,
      getUserConfirmation = _props$getUserConfirm === undefined ? __WEBPACK_IMPORTED_MODULE_5__DOMUtils__["c" /* getConfirmation */] : _props$getUserConfirm,
      _props$hashType = props.hashType,
      hashType = _props$hashType === undefined ? 'slash' : _props$hashType;

  var basename = props.basename ? Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["g" /* stripTrailingSlash */])(Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["a" /* addLeadingSlash */])(props.basename)) : '';

  var _HashPathCoders$hashT = HashPathCoders[hashType],
      encodePath = _HashPathCoders$hashT.encodePath,
      decodePath = _HashPathCoders$hashT.decodePath;


  var getDOMLocation = function getDOMLocation() {
    var path = decodePath(getHashPath());

    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!basename || Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["c" /* hasBasename */])(path, basename), 'You are attempting to use a basename on a page whose URL path does not begin ' + 'with the basename. Expected path "' + path + '" to begin with "' + basename + '".');

    if (basename) path = Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["e" /* stripBasename */])(path, basename);

    return Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(path);
  };

  var transitionManager = Object(__WEBPACK_IMPORTED_MODULE_4__createTransitionManager__["a" /* default */])();

  var setState = function setState(nextState) {
    _extends(history, nextState);

    history.length = globalHistory.length;

    transitionManager.notifyListeners(history.location, history.action);
  };

  var forceNextPop = false;
  var ignorePath = null;

  var handleHashChange = function handleHashChange() {
    var path = getHashPath();
    var encodedPath = encodePath(path);

    if (path !== encodedPath) {
      // Ensure we always have a properly-encoded hash.
      replaceHashPath(encodedPath);
    } else {
      var location = getDOMLocation();
      var prevLocation = history.location;

      if (!forceNextPop && Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["b" /* locationsAreEqual */])(prevLocation, location)) return; // A hashchange doesn't always == location change.

      if (ignorePath === Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(location)) return; // Ignore this change; we already setState in push/replace.

      ignorePath = null;

      handlePop(location);
    }
  };

  var handlePop = function handlePop(location) {
    if (forceNextPop) {
      forceNextPop = false;
      setState();
    } else {
      var action = 'POP';

      transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
        if (ok) {
          setState({ action: action, location: location });
        } else {
          revertPop(location);
        }
      });
    }
  };

  var revertPop = function revertPop(fromLocation) {
    var toLocation = history.location;

    // TODO: We could probably make this more reliable by
    // keeping a list of paths we've seen in sessionStorage.
    // Instead, we just default to 0 for paths we don't know.

    var toIndex = allPaths.lastIndexOf(Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(toLocation));

    if (toIndex === -1) toIndex = 0;

    var fromIndex = allPaths.lastIndexOf(Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(fromLocation));

    if (fromIndex === -1) fromIndex = 0;

    var delta = toIndex - fromIndex;

    if (delta) {
      forceNextPop = true;
      go(delta);
    }
  };

  // Ensure the hash is encoded properly before doing anything else.
  var path = getHashPath();
  var encodedPath = encodePath(path);

  if (path !== encodedPath) replaceHashPath(encodedPath);

  var initialLocation = getDOMLocation();
  var allPaths = [Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(initialLocation)];

  // Public interface

  var createHref = function createHref(location) {
    return '#' + encodePath(basename + Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(location));
  };

  var push = function push(path, state) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(state === undefined, 'Hash history cannot push state; it is ignored');

    var action = 'PUSH';
    var location = Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(path, undefined, undefined, history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var path = Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(location);
      var encodedPath = encodePath(basename + path);
      var hashChanged = getHashPath() !== encodedPath;

      if (hashChanged) {
        // We cannot tell if a hashchange was caused by a PUSH, so we'd
        // rather setState here and ignore the hashchange. The caveat here
        // is that other hash histories in the page will consider it a POP.
        ignorePath = path;
        pushHashPath(encodedPath);

        var prevIndex = allPaths.lastIndexOf(Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(history.location));
        var nextPaths = allPaths.slice(0, prevIndex === -1 ? 0 : prevIndex + 1);

        nextPaths.push(path);
        allPaths = nextPaths;

        setState({ action: action, location: location });
      } else {
        __WEBPACK_IMPORTED_MODULE_0_warning___default()(false, 'Hash history cannot PUSH the same path; a new entry will not be added to the history stack');

        setState();
      }
    });
  };

  var replace = function replace(path, state) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(state === undefined, 'Hash history cannot replace state; it is ignored');

    var action = 'REPLACE';
    var location = Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(path, undefined, undefined, history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var path = Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(location);
      var encodedPath = encodePath(basename + path);
      var hashChanged = getHashPath() !== encodedPath;

      if (hashChanged) {
        // We cannot tell if a hashchange was caused by a REPLACE, so we'd
        // rather setState here and ignore the hashchange. The caveat here
        // is that other hash histories in the page will consider it a POP.
        ignorePath = path;
        replaceHashPath(encodedPath);
      }

      var prevIndex = allPaths.indexOf(Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(history.location));

      if (prevIndex !== -1) allPaths[prevIndex] = path;

      setState({ action: action, location: location });
    });
  };

  var go = function go(n) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(canGoWithoutReload, 'Hash history go(n) causes a full page reload in this browser');

    globalHistory.go(n);
  };

  var goBack = function goBack() {
    return go(-1);
  };

  var goForward = function goForward() {
    return go(1);
  };

  var listenerCount = 0;

  var checkDOMListeners = function checkDOMListeners(delta) {
    listenerCount += delta;

    if (listenerCount === 1) {
      Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["a" /* addEventListener */])(window, HashChangeEvent, handleHashChange);
    } else if (listenerCount === 0) {
      Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["e" /* removeEventListener */])(window, HashChangeEvent, handleHashChange);
    }
  };

  var isBlocked = false;

  var block = function block() {
    var prompt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    var unblock = transitionManager.setPrompt(prompt);

    if (!isBlocked) {
      checkDOMListeners(1);
      isBlocked = true;
    }

    return function () {
      if (isBlocked) {
        isBlocked = false;
        checkDOMListeners(-1);
      }

      return unblock();
    };
  };

  var listen = function listen(listener) {
    var unlisten = transitionManager.appendListener(listener);
    checkDOMListeners(1);

    return function () {
      checkDOMListeners(-1);
      unlisten();
    };
  };

  var history = {
    length: globalHistory.length,
    action: 'POP',
    location: initialLocation,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    block: block,
    listen: listen
  };

  return history;
};

/* harmony default export */ __webpack_exports__["a"] = (createHashHistory);

/***/ }),
/* 392 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PathUtils__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__LocationUtils__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__createTransitionManager__ = __webpack_require__(160);
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };






var clamp = function clamp(n, lowerBound, upperBound) {
  return Math.min(Math.max(n, lowerBound), upperBound);
};

/**
 * Creates a history object that stores locations in memory.
 */
var createMemoryHistory = function createMemoryHistory() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var getUserConfirmation = props.getUserConfirmation,
      _props$initialEntries = props.initialEntries,
      initialEntries = _props$initialEntries === undefined ? ['/'] : _props$initialEntries,
      _props$initialIndex = props.initialIndex,
      initialIndex = _props$initialIndex === undefined ? 0 : _props$initialIndex,
      _props$keyLength = props.keyLength,
      keyLength = _props$keyLength === undefined ? 6 : _props$keyLength;


  var transitionManager = Object(__WEBPACK_IMPORTED_MODULE_3__createTransitionManager__["a" /* default */])();

  var setState = function setState(nextState) {
    _extends(history, nextState);

    history.length = history.entries.length;

    transitionManager.notifyListeners(history.location, history.action);
  };

  var createKey = function createKey() {
    return Math.random().toString(36).substr(2, keyLength);
  };

  var index = clamp(initialIndex, 0, initialEntries.length - 1);
  var entries = initialEntries.map(function (entry) {
    return typeof entry === 'string' ? Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(entry, undefined, createKey()) : Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(entry, undefined, entry.key || createKey());
  });

  // Public interface

  var createHref = __WEBPACK_IMPORTED_MODULE_1__PathUtils__["b" /* createPath */];

  var push = function push(path, state) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to push when the 1st ' + 'argument is a location-like object that already has state; it is ignored');

    var action = 'PUSH';
    var location = Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(path, state, createKey(), history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var prevIndex = history.index;
      var nextIndex = prevIndex + 1;

      var nextEntries = history.entries.slice(0);
      if (nextEntries.length > nextIndex) {
        nextEntries.splice(nextIndex, nextEntries.length - nextIndex, location);
      } else {
        nextEntries.push(location);
      }

      setState({
        action: action,
        location: location,
        index: nextIndex,
        entries: nextEntries
      });
    });
  };

  var replace = function replace(path, state) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to replace when the 1st ' + 'argument is a location-like object that already has state; it is ignored');

    var action = 'REPLACE';
    var location = Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(path, state, createKey(), history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      history.entries[history.index] = location;

      setState({ action: action, location: location });
    });
  };

  var go = function go(n) {
    var nextIndex = clamp(history.index + n, 0, history.entries.length - 1);

    var action = 'POP';
    var location = history.entries[nextIndex];

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (ok) {
        setState({
          action: action,
          location: location,
          index: nextIndex
        });
      } else {
        // Mimic the behavior of DOM histories by
        // causing a render after a cancelled POP.
        setState();
      }
    });
  };

  var goBack = function goBack() {
    return go(-1);
  };

  var goForward = function goForward() {
    return go(1);
  };

  var canGo = function canGo(n) {
    var nextIndex = history.index + n;
    return nextIndex >= 0 && nextIndex < history.entries.length;
  };

  var block = function block() {
    var prompt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    return transitionManager.setPrompt(prompt);
  };

  var listen = function listen(listener) {
    return transitionManager.appendListener(listener);
  };

  var history = {
    length: entries.length,
    action: 'POP',
    location: entries[index],
    index: index,
    entries: entries,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    canGo: canGo,
    block: block,
    listen: listen
  };

  return history;
};

/* harmony default export */ __webpack_exports__["a"] = (createMemoryHistory);

/***/ }),
/* 393 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export createProvider */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_PropTypes__ = __webpack_require__(221);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_warning__ = __webpack_require__(161);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var didWarnAboutReceivingStore = false;
function warnAboutReceivingStore() {
  if (didWarnAboutReceivingStore) {
    return;
  }
  didWarnAboutReceivingStore = true;

  Object(__WEBPACK_IMPORTED_MODULE_3__utils_warning__["a" /* default */])('<Provider> does not support changing `store` on the fly. ' + 'It is most likely that you see this error because you updated to ' + 'Redux 2.x and React Redux 2.x which no longer hot reload reducers ' + 'automatically. See https://github.com/reactjs/react-redux/releases/' + 'tag/v2.0.0 for the migration instructions.');
}

function createProvider() {
  var _Provider$childContex;

  var storeKey = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'store';
  var subKey = arguments[1];

  var subscriptionKey = subKey || storeKey + 'Subscription';

  var Provider = function (_Component) {
    _inherits(Provider, _Component);

    Provider.prototype.getChildContext = function getChildContext() {
      var _ref;

      return _ref = {}, _ref[storeKey] = this[storeKey], _ref[subscriptionKey] = null, _ref;
    };

    function Provider(props, context) {
      _classCallCheck(this, Provider);

      var _this = _possibleConstructorReturn(this, _Component.call(this, props, context));

      _this[storeKey] = props.store;
      return _this;
    }

    Provider.prototype.render = function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react__["Children"].only(this.props.children);
    };

    return Provider;
  }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

  if (false) {
    Provider.prototype.componentWillReceiveProps = function (nextProps) {
      if (this[storeKey] !== nextProps.store) {
        warnAboutReceivingStore();
      }
    };
  }

  Provider.propTypes = {
    store: __WEBPACK_IMPORTED_MODULE_2__utils_PropTypes__["a" /* storeShape */].isRequired,
    children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.element.isRequired
  };
  Provider.childContextTypes = (_Provider$childContex = {}, _Provider$childContex[storeKey] = __WEBPACK_IMPORTED_MODULE_2__utils_PropTypes__["a" /* storeShape */].isRequired, _Provider$childContex[subscriptionKey] = __WEBPACK_IMPORTED_MODULE_2__utils_PropTypes__["b" /* subscriptionShape */], _Provider$childContex);

  return Provider;
}

/* harmony default export */ __webpack_exports__["a"] = (createProvider());

/***/ }),
/* 394 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = __webpack_require__(395);

function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,

    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };

  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 395 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 396 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Subscription; });
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

// encapsulates the subscription logic for connecting a component to the redux store, as
// well as nesting subscriptions of descendant components, so that we can ensure the
// ancestor components re-render before descendants

var CLEARED = null;
var nullListeners = {
  notify: function notify() {}
};

function createListenerCollection() {
  // the current/next pattern is copied from redux's createStore code.
  // TODO: refactor+expose that code to be reusable here?
  var current = [];
  var next = [];

  return {
    clear: function clear() {
      next = CLEARED;
      current = CLEARED;
    },
    notify: function notify() {
      var listeners = current = next;
      for (var i = 0; i < listeners.length; i++) {
        listeners[i]();
      }
    },
    get: function get() {
      return next;
    },
    subscribe: function subscribe(listener) {
      var isSubscribed = true;
      if (next === current) next = current.slice();
      next.push(listener);

      return function unsubscribe() {
        if (!isSubscribed || current === CLEARED) return;
        isSubscribed = false;

        if (next === current) next = current.slice();
        next.splice(next.indexOf(listener), 1);
      };
    }
  };
}

var Subscription = function () {
  function Subscription(store, parentSub, onStateChange) {
    _classCallCheck(this, Subscription);

    this.store = store;
    this.parentSub = parentSub;
    this.onStateChange = onStateChange;
    this.unsubscribe = null;
    this.listeners = nullListeners;
  }

  Subscription.prototype.addNestedSub = function addNestedSub(listener) {
    this.trySubscribe();
    return this.listeners.subscribe(listener);
  };

  Subscription.prototype.notifyNestedSubs = function notifyNestedSubs() {
    this.listeners.notify();
  };

  Subscription.prototype.isSubscribed = function isSubscribed() {
    return Boolean(this.unsubscribe);
  };

  Subscription.prototype.trySubscribe = function trySubscribe() {
    if (!this.unsubscribe) {
      this.unsubscribe = this.parentSub ? this.parentSub.addNestedSub(this.onStateChange) : this.store.subscribe(this.onStateChange);

      this.listeners = createListenerCollection();
    }
  };

  Subscription.prototype.tryUnsubscribe = function tryUnsubscribe() {
    if (this.unsubscribe) {
      this.unsubscribe();
      this.unsubscribe = null;
      this.listeners.clear();
      this.listeners = nullListeners;
    }
  };

  return Subscription;
}();



/***/ }),
/* 397 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export createConnect */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_connectAdvanced__ = __webpack_require__(222);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_shallowEqual__ = __webpack_require__(398);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mapDispatchToProps__ = __webpack_require__(399);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mapStateToProps__ = __webpack_require__(409);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mergeProps__ = __webpack_require__(410);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__selectorFactory__ = __webpack_require__(411);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }








/*
  connect is a facade over connectAdvanced. It turns its args into a compatible
  selectorFactory, which has the signature:

    (dispatch, options) => (nextState, nextOwnProps) => nextFinalProps
  
  connect passes its args to connectAdvanced as options, which will in turn pass them to
  selectorFactory each time a Connect component instance is instantiated or hot reloaded.

  selectorFactory returns a final props selector from its mapStateToProps,
  mapStateToPropsFactories, mapDispatchToProps, mapDispatchToPropsFactories, mergeProps,
  mergePropsFactories, and pure args.

  The resulting final props selector is called by the Connect component instance whenever
  it receives new props or store state.
 */

function match(arg, factories, name) {
  for (var i = factories.length - 1; i >= 0; i--) {
    var result = factories[i](arg);
    if (result) return result;
  }

  return function (dispatch, options) {
    throw new Error('Invalid value of type ' + typeof arg + ' for ' + name + ' argument when connecting component ' + options.wrappedComponentName + '.');
  };
}

function strictEqual(a, b) {
  return a === b;
}

// createConnect with default args builds the 'official' connect behavior. Calling it with
// different options opens up some testing and extensibility scenarios
function createConnect() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$connectHOC = _ref.connectHOC,
      connectHOC = _ref$connectHOC === undefined ? __WEBPACK_IMPORTED_MODULE_0__components_connectAdvanced__["a" /* default */] : _ref$connectHOC,
      _ref$mapStateToPropsF = _ref.mapStateToPropsFactories,
      mapStateToPropsFactories = _ref$mapStateToPropsF === undefined ? __WEBPACK_IMPORTED_MODULE_3__mapStateToProps__["a" /* default */] : _ref$mapStateToPropsF,
      _ref$mapDispatchToPro = _ref.mapDispatchToPropsFactories,
      mapDispatchToPropsFactories = _ref$mapDispatchToPro === undefined ? __WEBPACK_IMPORTED_MODULE_2__mapDispatchToProps__["a" /* default */] : _ref$mapDispatchToPro,
      _ref$mergePropsFactor = _ref.mergePropsFactories,
      mergePropsFactories = _ref$mergePropsFactor === undefined ? __WEBPACK_IMPORTED_MODULE_4__mergeProps__["a" /* default */] : _ref$mergePropsFactor,
      _ref$selectorFactory = _ref.selectorFactory,
      selectorFactory = _ref$selectorFactory === undefined ? __WEBPACK_IMPORTED_MODULE_5__selectorFactory__["a" /* default */] : _ref$selectorFactory;

  return function connect(mapStateToProps, mapDispatchToProps, mergeProps) {
    var _ref2 = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {},
        _ref2$pure = _ref2.pure,
        pure = _ref2$pure === undefined ? true : _ref2$pure,
        _ref2$areStatesEqual = _ref2.areStatesEqual,
        areStatesEqual = _ref2$areStatesEqual === undefined ? strictEqual : _ref2$areStatesEqual,
        _ref2$areOwnPropsEqua = _ref2.areOwnPropsEqual,
        areOwnPropsEqual = _ref2$areOwnPropsEqua === undefined ? __WEBPACK_IMPORTED_MODULE_1__utils_shallowEqual__["a" /* default */] : _ref2$areOwnPropsEqua,
        _ref2$areStatePropsEq = _ref2.areStatePropsEqual,
        areStatePropsEqual = _ref2$areStatePropsEq === undefined ? __WEBPACK_IMPORTED_MODULE_1__utils_shallowEqual__["a" /* default */] : _ref2$areStatePropsEq,
        _ref2$areMergedPropsE = _ref2.areMergedPropsEqual,
        areMergedPropsEqual = _ref2$areMergedPropsE === undefined ? __WEBPACK_IMPORTED_MODULE_1__utils_shallowEqual__["a" /* default */] : _ref2$areMergedPropsE,
        extraOptions = _objectWithoutProperties(_ref2, ['pure', 'areStatesEqual', 'areOwnPropsEqual', 'areStatePropsEqual', 'areMergedPropsEqual']);

    var initMapStateToProps = match(mapStateToProps, mapStateToPropsFactories, 'mapStateToProps');
    var initMapDispatchToProps = match(mapDispatchToProps, mapDispatchToPropsFactories, 'mapDispatchToProps');
    var initMergeProps = match(mergeProps, mergePropsFactories, 'mergeProps');

    return connectHOC(selectorFactory, _extends({
      // used in error messages
      methodName: 'connect',

      // used to compute Connect's displayName from the wrapped component's displayName.
      getDisplayName: function getDisplayName(name) {
        return 'Connect(' + name + ')';
      },

      // if mapStateToProps is falsy, the Connect component doesn't subscribe to store state changes
      shouldHandleStateChanges: Boolean(mapStateToProps),

      // passed through to selectorFactory
      initMapStateToProps: initMapStateToProps,
      initMapDispatchToProps: initMapDispatchToProps,
      initMergeProps: initMergeProps,
      pure: pure,
      areStatesEqual: areStatesEqual,
      areOwnPropsEqual: areOwnPropsEqual,
      areStatePropsEqual: areStatePropsEqual,
      areMergedPropsEqual: areMergedPropsEqual

    }, extraOptions));
  };
}

/* harmony default export */ __webpack_exports__["a"] = (createConnect());

/***/ }),
/* 398 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = shallowEqual;
var hasOwn = Object.prototype.hasOwnProperty;

function is(x, y) {
  if (x === y) {
    return x !== 0 || y !== 0 || 1 / x === 1 / y;
  } else {
    return x !== x && y !== y;
  }
}

function shallowEqual(objA, objB) {
  if (is(objA, objB)) return true;

  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) return false;

  for (var i = 0; i < keysA.length; i++) {
    if (!hasOwn.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
      return false;
    }
  }

  return true;
}

/***/ }),
/* 399 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export whenMapDispatchToPropsIsFunction */
/* unused harmony export whenMapDispatchToPropsIsMissing */
/* unused harmony export whenMapDispatchToPropsIsObject */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__ = __webpack_require__(223);



function whenMapDispatchToPropsIsFunction(mapDispatchToProps) {
  return typeof mapDispatchToProps === 'function' ? Object(__WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__["b" /* wrapMapToPropsFunc */])(mapDispatchToProps, 'mapDispatchToProps') : undefined;
}

function whenMapDispatchToPropsIsMissing(mapDispatchToProps) {
  return !mapDispatchToProps ? Object(__WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__["a" /* wrapMapToPropsConstant */])(function (dispatch) {
    return { dispatch: dispatch };
  }) : undefined;
}

function whenMapDispatchToPropsIsObject(mapDispatchToProps) {
  return mapDispatchToProps && typeof mapDispatchToProps === 'object' ? Object(__WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__["a" /* wrapMapToPropsConstant */])(function (dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_0_redux__["b" /* bindActionCreators */])(mapDispatchToProps, dispatch);
  }) : undefined;
}

/* harmony default export */ __webpack_exports__["a"] = ([whenMapDispatchToPropsIsFunction, whenMapDispatchToPropsIsMissing, whenMapDispatchToPropsIsObject]);

/***/ }),
/* 400 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__ = __webpack_require__(401);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getPrototype_js__ = __webpack_require__(406);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isObjectLike_js__ = __webpack_require__(408);




/** `Object#toString` result references. */
var objectTag = '[object Object]';

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to infer the `Object` constructor. */
var objectCtorString = funcToString.call(Object);

/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */
function isPlainObject(value) {
  if (!Object(__WEBPACK_IMPORTED_MODULE_2__isObjectLike_js__["a" /* default */])(value) || Object(__WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__["a" /* default */])(value) != objectTag) {
    return false;
  }
  var proto = Object(__WEBPACK_IMPORTED_MODULE_1__getPrototype_js__["a" /* default */])(value);
  if (proto === null) {
    return true;
  }
  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
    funcToString.call(Ctor) == objectCtorString;
}

/* harmony default export */ __webpack_exports__["a"] = (isPlainObject);


/***/ }),
/* 401 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Symbol_js__ = __webpack_require__(225);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getRawTag_js__ = __webpack_require__(404);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__objectToString_js__ = __webpack_require__(405);




/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */] ? __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */].toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? Object(__WEBPACK_IMPORTED_MODULE_1__getRawTag_js__["a" /* default */])(value)
    : Object(__WEBPACK_IMPORTED_MODULE_2__objectToString_js__["a" /* default */])(value);
}

/* harmony default export */ __webpack_exports__["a"] = (baseGetTag);


/***/ }),
/* 402 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__freeGlobal_js__ = __webpack_require__(403);


/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = __WEBPACK_IMPORTED_MODULE_0__freeGlobal_js__["a" /* default */] || freeSelf || Function('return this')();

/* harmony default export */ __webpack_exports__["a"] = (root);


/***/ }),
/* 403 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/* harmony default export */ __webpack_exports__["a"] = (freeGlobal);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(36)))

/***/ }),
/* 404 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Symbol_js__ = __webpack_require__(225);


/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */] ? __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */].toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (getRawTag);


/***/ }),
/* 405 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

/* harmony default export */ __webpack_exports__["a"] = (objectToString);


/***/ }),
/* 406 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__overArg_js__ = __webpack_require__(407);


/** Built-in value references. */
var getPrototype = Object(__WEBPACK_IMPORTED_MODULE_0__overArg_js__["a" /* default */])(Object.getPrototypeOf, Object);

/* harmony default export */ __webpack_exports__["a"] = (getPrototype);


/***/ }),
/* 407 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

/* harmony default export */ __webpack_exports__["a"] = (overArg);


/***/ }),
/* 408 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

/* harmony default export */ __webpack_exports__["a"] = (isObjectLike);


/***/ }),
/* 409 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export whenMapStateToPropsIsFunction */
/* unused harmony export whenMapStateToPropsIsMissing */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__wrapMapToProps__ = __webpack_require__(223);


function whenMapStateToPropsIsFunction(mapStateToProps) {
  return typeof mapStateToProps === 'function' ? Object(__WEBPACK_IMPORTED_MODULE_0__wrapMapToProps__["b" /* wrapMapToPropsFunc */])(mapStateToProps, 'mapStateToProps') : undefined;
}

function whenMapStateToPropsIsMissing(mapStateToProps) {
  return !mapStateToProps ? Object(__WEBPACK_IMPORTED_MODULE_0__wrapMapToProps__["a" /* wrapMapToPropsConstant */])(function () {
    return {};
  }) : undefined;
}

/* harmony default export */ __webpack_exports__["a"] = ([whenMapStateToPropsIsFunction, whenMapStateToPropsIsMissing]);

/***/ }),
/* 410 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export defaultMergeProps */
/* unused harmony export wrapMergePropsFunc */
/* unused harmony export whenMergePropsIsFunction */
/* unused harmony export whenMergePropsIsOmitted */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_verifyPlainObject__ = __webpack_require__(224);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



function defaultMergeProps(stateProps, dispatchProps, ownProps) {
  return _extends({}, ownProps, stateProps, dispatchProps);
}

function wrapMergePropsFunc(mergeProps) {
  return function initMergePropsProxy(dispatch, _ref) {
    var displayName = _ref.displayName,
        pure = _ref.pure,
        areMergedPropsEqual = _ref.areMergedPropsEqual;

    var hasRunOnce = false;
    var mergedProps = void 0;

    return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
      var nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);

      if (hasRunOnce) {
        if (!pure || !areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
      } else {
        hasRunOnce = true;
        mergedProps = nextMergedProps;

        if (false) verifyPlainObject(mergedProps, displayName, 'mergeProps');
      }

      return mergedProps;
    };
  };
}

function whenMergePropsIsFunction(mergeProps) {
  return typeof mergeProps === 'function' ? wrapMergePropsFunc(mergeProps) : undefined;
}

function whenMergePropsIsOmitted(mergeProps) {
  return !mergeProps ? function () {
    return defaultMergeProps;
  } : undefined;
}

/* harmony default export */ __webpack_exports__["a"] = ([whenMergePropsIsFunction, whenMergePropsIsOmitted]);

/***/ }),
/* 411 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export impureFinalPropsSelectorFactory */
/* unused harmony export pureFinalPropsSelectorFactory */
/* harmony export (immutable) */ __webpack_exports__["a"] = finalPropsSelectorFactory;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__verifySubselectors__ = __webpack_require__(412);
function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }



function impureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch) {
  return function impureFinalPropsSelector(state, ownProps) {
    return mergeProps(mapStateToProps(state, ownProps), mapDispatchToProps(dispatch, ownProps), ownProps);
  };
}

function pureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, _ref) {
  var areStatesEqual = _ref.areStatesEqual,
      areOwnPropsEqual = _ref.areOwnPropsEqual,
      areStatePropsEqual = _ref.areStatePropsEqual;

  var hasRunAtLeastOnce = false;
  var state = void 0;
  var ownProps = void 0;
  var stateProps = void 0;
  var dispatchProps = void 0;
  var mergedProps = void 0;

  function handleFirstCall(firstState, firstOwnProps) {
    state = firstState;
    ownProps = firstOwnProps;
    stateProps = mapStateToProps(state, ownProps);
    dispatchProps = mapDispatchToProps(dispatch, ownProps);
    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    hasRunAtLeastOnce = true;
    return mergedProps;
  }

  function handleNewPropsAndNewState() {
    stateProps = mapStateToProps(state, ownProps);

    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);

    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }

  function handleNewProps() {
    if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);

    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);

    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }

  function handleNewState() {
    var nextStateProps = mapStateToProps(state, ownProps);
    var statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
    stateProps = nextStateProps;

    if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);

    return mergedProps;
  }

  function handleSubsequentCalls(nextState, nextOwnProps) {
    var propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
    var stateChanged = !areStatesEqual(nextState, state);
    state = nextState;
    ownProps = nextOwnProps;

    if (propsChanged && stateChanged) return handleNewPropsAndNewState();
    if (propsChanged) return handleNewProps();
    if (stateChanged) return handleNewState();
    return mergedProps;
  }

  return function pureFinalPropsSelector(nextState, nextOwnProps) {
    return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
  };
}

// TODO: Add more comments

// If pure is true, the selector returned by selectorFactory will memoize its results,
// allowing connectAdvanced's shouldComponentUpdate to return false if final
// props have not changed. If false, the selector will always return a new
// object and shouldComponentUpdate will always return true.

function finalPropsSelectorFactory(dispatch, _ref2) {
  var initMapStateToProps = _ref2.initMapStateToProps,
      initMapDispatchToProps = _ref2.initMapDispatchToProps,
      initMergeProps = _ref2.initMergeProps,
      options = _objectWithoutProperties(_ref2, ['initMapStateToProps', 'initMapDispatchToProps', 'initMergeProps']);

  var mapStateToProps = initMapStateToProps(dispatch, options);
  var mapDispatchToProps = initMapDispatchToProps(dispatch, options);
  var mergeProps = initMergeProps(dispatch, options);

  if (false) {
    verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps, options.displayName);
  }

  var selectorFactory = options.pure ? pureFinalPropsSelectorFactory : impureFinalPropsSelectorFactory;

  return selectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
}

/***/ }),
/* 412 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_warning__ = __webpack_require__(161);


function verify(selector, methodName, displayName) {
  if (!selector) {
    throw new Error('Unexpected value for ' + methodName + ' in ' + displayName + '.');
  } else if (methodName === 'mapStateToProps' || methodName === 'mapDispatchToProps') {
    if (!selector.hasOwnProperty('dependsOnOwnProps')) {
      Object(__WEBPACK_IMPORTED_MODULE_0__utils_warning__["a" /* default */])('The selector for ' + methodName + ' of ' + displayName + ' did not specify a value for dependsOnOwnProps.');
    }
  }
}

function verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps, displayName) {
  verify(mapStateToProps, 'mapStateToProps', displayName);
  verify(mapDispatchToProps, 'mapDispatchToProps', displayName);
  verify(mergeProps, 'mergeProps', displayName);
}

/***/ }),
/* 413 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Router__ = __webpack_require__(162);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for a <Router> that uses HTML5 history.
 */

var BrowserRouter = function (_React$Component) {
  _inherits(BrowserRouter, _React$Component);

  function BrowserRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, BrowserRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = Object(__WEBPACK_IMPORTED_MODULE_3_history__["a" /* createBrowserHistory */])(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
  }

  BrowserRouter.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!this.props.history, "<BrowserRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { BrowserRouter as Router }`.");
  };

  BrowserRouter.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Router__["a" /* default */], { history: this.history, children: this.props.children });
  };

  return BrowserRouter;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

BrowserRouter.propTypes = {
  basename: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
  forceRefresh: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
  getUserConfirmation: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  keyLength: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node
};


/* unused harmony default export */ var _unused_webpack_default_export = (BrowserRouter);

/***/ }),
/* 414 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Router__ = __webpack_require__(162);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for a <Router> that uses window.location.hash.
 */

var HashRouter = function (_React$Component) {
  _inherits(HashRouter, _React$Component);

  function HashRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, HashRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = Object(__WEBPACK_IMPORTED_MODULE_3_history__["b" /* createHashHistory */])(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
  }

  HashRouter.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!this.props.history, "<HashRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { HashRouter as Router }`.");
  };

  HashRouter.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Router__["a" /* default */], { history: this.history, children: this.props.children });
  };

  return HashRouter;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

HashRouter.propTypes = {
  basename: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
  getUserConfirmation: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  hashType: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOf(["hashbang", "noslash", "slash"]),
  children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node
};


/* unused harmony default export */ var _unused_webpack_default_export = (HashRouter);

/***/ }),
/* 415 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_MemoryRouter__ = __webpack_require__(416);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_MemoryRouter__["a" /* default */]);

/***/ }),
/* 416 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Router__ = __webpack_require__(163);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for a <Router> that stores location in memory.
 */

var MemoryRouter = function (_React$Component) {
  _inherits(MemoryRouter, _React$Component);

  function MemoryRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, MemoryRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = Object(__WEBPACK_IMPORTED_MODULE_3_history__["d" /* createMemoryHistory */])(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
  }

  MemoryRouter.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!this.props.history, "<MemoryRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { MemoryRouter as Router }`.");
  };

  MemoryRouter.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Router__["a" /* default */], { history: this.history, children: this.props.children });
  };

  return MemoryRouter;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

MemoryRouter.propTypes = {
  initialEntries: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array,
  initialIndex: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  getUserConfirmation: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  keyLength: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node
};


/* harmony default export */ __webpack_exports__["a"] = (MemoryRouter);

/***/ }),
/* 417 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Route__ = __webpack_require__(227);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Link__ = __webpack_require__(226);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }






/**
 * A <Link> wrapper that knows if it's "active" or not.
 */
var NavLink = function NavLink(_ref) {
  var to = _ref.to,
      exact = _ref.exact,
      strict = _ref.strict,
      location = _ref.location,
      activeClassName = _ref.activeClassName,
      className = _ref.className,
      activeStyle = _ref.activeStyle,
      style = _ref.style,
      getIsActive = _ref.isActive,
      ariaCurrent = _ref["aria-current"],
      rest = _objectWithoutProperties(_ref, ["to", "exact", "strict", "location", "activeClassName", "className", "activeStyle", "style", "isActive", "aria-current"]);

  var path = (typeof to === "undefined" ? "undefined" : _typeof(to)) === "object" ? to.pathname : to;

  // Regex taken from: https://github.com/pillarjs/path-to-regexp/blob/master/index.js#L202
  var escapedPath = path && path.replace(/([.+*?=^!:${}()[\]|/\\])/g, "\\$1");

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Route__["a" /* default */], {
    path: escapedPath,
    exact: exact,
    strict: strict,
    location: location,
    children: function children(_ref2) {
      var location = _ref2.location,
          match = _ref2.match;

      var isActive = !!(getIsActive ? getIsActive(match, location) : match);

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Link__["a" /* default */], _extends({
        to: to,
        className: isActive ? [className, activeClassName].filter(function (i) {
          return i;
        }).join(" ") : className,
        style: isActive ? _extends({}, style, activeStyle) : style,
        "aria-current": isActive && ariaCurrent || null
      }, rest));
    }
  });
};

NavLink.propTypes = {
  to: __WEBPACK_IMPORTED_MODULE_3__Link__["a" /* default */].propTypes.to,
  exact: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  strict: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  location: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  activeClassName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  activeStyle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  style: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  isActive: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  "aria-current": __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(["page", "step", "location", "date", "time", "true"])
};

NavLink.defaultProps = {
  activeClassName: "active",
  "aria-current": "page"
};

/* harmony default export */ __webpack_exports__["a"] = (NavLink);

/***/ }),
/* 418 */
/***/ (function(module, exports) {

module.exports = Array.isArray || function (arr) {
  return Object.prototype.toString.call(arr) == '[object Array]';
};


/***/ }),
/* 419 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Prompt__ = __webpack_require__(420);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Prompt__["a" /* default */]);

/***/ }),
/* 420 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_invariant__);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





/**
 * The public API for prompting the user before navigating away
 * from a screen with a component.
 */

var Prompt = function (_React$Component) {
  _inherits(Prompt, _React$Component);

  function Prompt() {
    _classCallCheck(this, Prompt);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  Prompt.prototype.enable = function enable(message) {
    if (this.unblock) this.unblock();

    this.unblock = this.context.router.history.block(message);
  };

  Prompt.prototype.disable = function disable() {
    if (this.unblock) {
      this.unblock();
      this.unblock = null;
    }
  };

  Prompt.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_2_invariant___default()(this.context.router, "You should not use <Prompt> outside a <Router>");

    if (this.props.when) this.enable(this.props.message);
  };

  Prompt.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if (nextProps.when) {
      if (!this.props.when || this.props.message !== nextProps.message) this.enable(nextProps.message);
    } else {
      this.disable();
    }
  };

  Prompt.prototype.componentWillUnmount = function componentWillUnmount() {
    this.disable();
  };

  Prompt.prototype.render = function render() {
    return null;
  };

  return Prompt;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Prompt.propTypes = {
  when: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  message: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]).isRequired
};
Prompt.defaultProps = {
  when: true
};
Prompt.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      block: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
    }).isRequired
  }).isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Prompt);

/***/ }),
/* 421 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Redirect__ = __webpack_require__(422);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Redirect__["a" /* default */]);

/***/ }),
/* 422 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_warning__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_history__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__generatePath__ = __webpack_require__(230);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








/**
 * The public API for updating the location programmatically
 * with a component.
 */

var Redirect = function (_React$Component) {
  _inherits(Redirect, _React$Component);

  function Redirect() {
    _classCallCheck(this, Redirect);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  Redirect.prototype.isStatic = function isStatic() {
    return this.context.router && this.context.router.staticContext;
  };

  Redirect.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_3_invariant___default()(this.context.router, "You should not use <Redirect> outside a <Router>");

    if (this.isStatic()) this.perform();
  };

  Redirect.prototype.componentDidMount = function componentDidMount() {
    if (!this.isStatic()) this.perform();
  };

  Redirect.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
    var prevTo = Object(__WEBPACK_IMPORTED_MODULE_4_history__["c" /* createLocation */])(prevProps.to);
    var nextTo = Object(__WEBPACK_IMPORTED_MODULE_4_history__["c" /* createLocation */])(this.props.to);

    if (Object(__WEBPACK_IMPORTED_MODULE_4_history__["f" /* locationsAreEqual */])(prevTo, nextTo)) {
      __WEBPACK_IMPORTED_MODULE_2_warning___default()(false, "You tried to redirect to the same route you're currently on: " + ("\"" + nextTo.pathname + nextTo.search + "\""));
      return;
    }

    this.perform();
  };

  Redirect.prototype.computeTo = function computeTo(_ref) {
    var computedMatch = _ref.computedMatch,
        to = _ref.to;

    if (computedMatch) {
      if (typeof to === "string") {
        return Object(__WEBPACK_IMPORTED_MODULE_5__generatePath__["a" /* default */])(to, computedMatch.params);
      } else {
        return _extends({}, to, {
          pathname: Object(__WEBPACK_IMPORTED_MODULE_5__generatePath__["a" /* default */])(to.pathname, computedMatch.params)
        });
      }
    }

    return to;
  };

  Redirect.prototype.perform = function perform() {
    var history = this.context.router.history;
    var push = this.props.push;

    var to = this.computeTo(this.props);

    if (push) {
      history.push(to);
    } else {
      history.replace(to);
    }
  };

  Redirect.prototype.render = function render() {
    return null;
  };

  return Redirect;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Redirect.propTypes = {
  computedMatch: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object, // private, from <Switch>
  push: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  from: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  to: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object]).isRequired
};
Redirect.defaultProps = {
  push: false
};
Redirect.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      push: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
      replace: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
    }).isRequired,
    staticContext: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
  }).isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Redirect);

/***/ }),
/* 423 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_StaticRouter__ = __webpack_require__(424);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_StaticRouter__["a" /* default */]);

/***/ }),
/* 424 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_history__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Router__ = __webpack_require__(163);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var addLeadingSlash = function addLeadingSlash(path) {
  return path.charAt(0) === "/" ? path : "/" + path;
};

var addBasename = function addBasename(basename, location) {
  if (!basename) return location;

  return _extends({}, location, {
    pathname: addLeadingSlash(basename) + location.pathname
  });
};

var stripBasename = function stripBasename(basename, location) {
  if (!basename) return location;

  var base = addLeadingSlash(basename);

  if (location.pathname.indexOf(base) !== 0) return location;

  return _extends({}, location, {
    pathname: location.pathname.substr(base.length)
  });
};

var createURL = function createURL(location) {
  return typeof location === "string" ? location : Object(__WEBPACK_IMPORTED_MODULE_4_history__["e" /* createPath */])(location);
};

var staticHandler = function staticHandler(methodName) {
  return function () {
    __WEBPACK_IMPORTED_MODULE_1_invariant___default()(false, "You cannot %s with <StaticRouter>", methodName);
  };
};

var noop = function noop() {};

/**
 * The public top-level API for a "static" <Router>, so-called because it
 * can't actually change the current location. Instead, it just records
 * location changes in a context object. Useful mainly in testing and
 * server-rendering scenarios.
 */

var StaticRouter = function (_React$Component) {
  _inherits(StaticRouter, _React$Component);

  function StaticRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, StaticRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.createHref = function (path) {
      return addLeadingSlash(_this.props.basename + createURL(path));
    }, _this.handlePush = function (location) {
      var _this$props = _this.props,
          basename = _this$props.basename,
          context = _this$props.context;

      context.action = "PUSH";
      context.location = addBasename(basename, Object(__WEBPACK_IMPORTED_MODULE_4_history__["c" /* createLocation */])(location));
      context.url = createURL(context.location);
    }, _this.handleReplace = function (location) {
      var _this$props2 = _this.props,
          basename = _this$props2.basename,
          context = _this$props2.context;

      context.action = "REPLACE";
      context.location = addBasename(basename, Object(__WEBPACK_IMPORTED_MODULE_4_history__["c" /* createLocation */])(location));
      context.url = createURL(context.location);
    }, _this.handleListen = function () {
      return noop;
    }, _this.handleBlock = function () {
      return noop;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  StaticRouter.prototype.getChildContext = function getChildContext() {
    return {
      router: {
        staticContext: this.props.context
      }
    };
  };

  StaticRouter.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!this.props.history, "<StaticRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { StaticRouter as Router }`.");
  };

  StaticRouter.prototype.render = function render() {
    var _props = this.props,
        basename = _props.basename,
        context = _props.context,
        location = _props.location,
        props = _objectWithoutProperties(_props, ["basename", "context", "location"]);

    var history = {
      createHref: this.createHref,
      action: "POP",
      location: stripBasename(basename, Object(__WEBPACK_IMPORTED_MODULE_4_history__["c" /* createLocation */])(location)),
      push: this.handlePush,
      replace: this.handleReplace,
      go: staticHandler("go"),
      goBack: staticHandler("goBack"),
      goForward: staticHandler("goForward"),
      listen: this.handleListen,
      block: this.handleBlock
    };

    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Router__["a" /* default */], _extends({}, props, { history: history }));
  };

  return StaticRouter;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

StaticRouter.propTypes = {
  basename: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  context: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
  location: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object])
};
StaticRouter.defaultProps = {
  basename: "",
  location: "/"
};
StaticRouter.childContextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (StaticRouter);

/***/ }),
/* 425 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Switch__ = __webpack_require__(426);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Switch__["a" /* default */]);

/***/ }),
/* 426 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_warning__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__matchPath__ = __webpack_require__(164);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for rendering the first <Route> that matches.
 */

var Switch = function (_React$Component) {
  _inherits(Switch, _React$Component);

  function Switch() {
    _classCallCheck(this, Switch);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  Switch.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_3_invariant___default()(this.context.router, "You should not use <Switch> outside a <Router>");
  };

  Switch.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    __WEBPACK_IMPORTED_MODULE_2_warning___default()(!(nextProps.location && !this.props.location), '<Switch> elements should not change from uncontrolled to controlled (or vice versa). You initially used no "location" prop and then provided one on a subsequent render.');

    __WEBPACK_IMPORTED_MODULE_2_warning___default()(!(!nextProps.location && this.props.location), '<Switch> elements should not change from controlled to uncontrolled (or vice versa). You provided a "location" prop initially but omitted it on a subsequent render.');
  };

  Switch.prototype.render = function render() {
    var route = this.context.router.route;
    var children = this.props.children;

    var location = this.props.location || route.location;

    var match = void 0,
        child = void 0;
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.forEach(children, function (element) {
      if (match == null && __WEBPACK_IMPORTED_MODULE_0_react___default.a.isValidElement(element)) {
        var _element$props = element.props,
            pathProp = _element$props.path,
            exact = _element$props.exact,
            strict = _element$props.strict,
            sensitive = _element$props.sensitive,
            from = _element$props.from;

        var path = pathProp || from;

        child = element;
        match = Object(__WEBPACK_IMPORTED_MODULE_4__matchPath__["a" /* default */])(location.pathname, { path: path, exact: exact, strict: strict, sensitive: sensitive }, route.match);
      }
    });

    return match ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.cloneElement(child, { location: location, computedMatch: match }) : null;
  };

  return Switch;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Switch.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    route: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired
  }).isRequired
};
Switch.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  location: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};


/* harmony default export */ __webpack_exports__["a"] = (Switch);

/***/ }),
/* 427 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_generatePath__ = __webpack_require__(230);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_generatePath__["a" /* default */]);

/***/ }),
/* 428 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_matchPath__ = __webpack_require__(164);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_matchPath__["a" /* default */]);

/***/ }),
/* 429 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_withRouter__ = __webpack_require__(430);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_withRouter__["a" /* default */]);

/***/ }),
/* 430 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Route__ = __webpack_require__(228);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }






/**
 * A public higher-order component to access the imperative API
 */
var withRouter = function withRouter(Component) {
  var C = function C(props) {
    var wrappedComponentRef = props.wrappedComponentRef,
        remainingProps = _objectWithoutProperties(props, ["wrappedComponentRef"]);

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Route__["a" /* default */], {
      children: function children(routeComponentProps) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Component, _extends({}, remainingProps, routeComponentProps, {
          ref: wrappedComponentRef
        }));
      }
    });
  };

  C.displayName = "withRouter(" + (Component.displayName || Component.name) + ")";
  C.WrappedComponent = Component;
  C.propTypes = {
    wrappedComponentRef: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
  };

  return __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics___default()(C, Component);
};

/* harmony default export */ __webpack_exports__["a"] = (withRouter);

/***/ }),
/* 431 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_views_Pages_ConfirmacaoConvitePage_jsx__ = __webpack_require__(432);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_views_Pages_ConfirmacaoEmailPage_jsx__ = __webpack_require__(540);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_layouts_Dashboard_jsx__ = __webpack_require__(541);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_layouts_DashboardAreaAberta_jsx__ = __webpack_require__(972);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_views_LandingPage_LandingPage_jsx__ = __webpack_require__(974);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_views_Pages_LoginPage_jsx__ = __webpack_require__(994);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_views_Pages_PlanosPage_jsx__ = __webpack_require__(996);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_views_Pages_RegisterPage_jsx__ = __webpack_require__(999);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_views_Pages_ResetPasswordPage_jsx__ = __webpack_require__(1009);
var indexRoutes=[{path:"/dashboard",name:"Home",component:__WEBPACK_IMPORTED_MODULE_2_layouts_Dashboard_jsx__["a" /* default */]},{path:"/login",name:"Login",component:__WEBPACK_IMPORTED_MODULE_5_views_Pages_LoginPage_jsx__["a" /* default */]},{path:"/cadastro",name:"Cadastro",component:__WEBPACK_IMPORTED_MODULE_7_views_Pages_RegisterPage_jsx__["a" /* default */]},{path:"/resetar-senha",name:"Resetar Senha",component:__WEBPACK_IMPORTED_MODULE_8_views_Pages_ResetPasswordPage_jsx__["a" /* default */]},{path:"/confirmacao-email",name:"Resetar Senha",component:__WEBPACK_IMPORTED_MODULE_1_views_Pages_ConfirmacaoEmailPage_jsx__["a" /* default */]},{path:"/confirmacao-convite",name:"Confirmar Convite",component:__WEBPACK_IMPORTED_MODULE_0_views_Pages_ConfirmacaoConvitePage_jsx__["a" /* default */]},{path:"/planos",name:"Planos",component:__WEBPACK_IMPORTED_MODULE_6_views_Pages_PlanosPage_jsx__["a" /* default */]},{path:"/area-aberta",name:"Simuladores",component:__WEBPACK_IMPORTED_MODULE_3_layouts_DashboardAreaAberta_jsx__["a" /* default */]},{path:"/",name:"Landing Page",component:__WEBPACK_IMPORTED_MODULE_4_views_LandingPage_LandingPage_jsx__["a" /* default */]}];/* harmony default export */ __webpack_exports__["a"] = (indexRoutes);

/***/ }),
/* 432 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_query_string__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_query_string___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_query_string__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles_withStyles__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_redux__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_EnergyCompany_BouncingLoader_BouncingLoader_jsx__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_EnergyCompany_Alert_Alerts__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_CustomButtons_Button_jsx__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_EnergyCompany_Cards_ECCard_jsx__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_Grid_GridContainer_jsx__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_components_Grid_GridItem_jsx__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_reducers_user_actions__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_services_auth__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_services_utils__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_reducers_alerts_actions__ = __webpack_require__(100);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var styles={buttons:{display:"flex",margin:"20px 0"},confirmarBtn:{marginRight:"10px"},contentWrapper:{display:"flex",flexDirection:"column",alignItems:"center"},titleActions:{color:"#3C4858",display:"flex",fontSize:"2.6em",justifyContent:"center"}};var ConfirmacaoConvitePage=function(_Component){_inherits(ConfirmacaoConvitePage,_Component);function ConfirmacaoConvitePage(){var _ref;var _temp,_this,_ret;_classCallCheck(this,ConfirmacaoConvitePage);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=ConfirmacaoConvitePage.__proto__||Object.getPrototypeOf(ConfirmacaoConvitePage)).call.apply(_ref,[this].concat(args))),_this),_this.state={loading:false,msg:""},_this.confirmacaoConvite=function(resposta){var _this$props=_this.props,authenticateUser=_this$props.authenticateUser,history=_this$props.history,location=_this$props.location;var _queryString$parse=__WEBPACK_IMPORTED_MODULE_0_query_string___default.a.parse(location.search),codigo=_queryString$parse.codigo,id=_queryString$parse.id,idAssinatura=_queryString$parse.idAssinatura;_this.setState({loading:true});Object(__WEBPACK_IMPORTED_MODULE_13_services_auth__["b" /* confirmacaoConvite */])({codigo:codigo,id:id,idAssinatura:idAssinatura,resposta:resposta}).then(function(_ref2){var data=_ref2.data;_this.setState({msg:"Redirecionando para o dashboard."});authenticateUser(data);setTimeout(function(){history.push("/dashboard");},2000);}).catch(function(_ref3){var response=_ref3.response;_this.setState({cadastrando:false,loading:false});_this.props.showAlert({message:Object(__WEBPACK_IMPORTED_MODULE_5_lodash__["values"])(response.data).join(" "),type:'error'});});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(ConfirmacaoConvitePage,[{key:"render",value:function render(){var _this2=this;var _props=this.props,classes=_props.classes,location=_props.location;var _state=this.state,loading=_state.loading,msg=_state.msg;var _getFromAtob=Object(__WEBPACK_IMPORTED_MODULE_14_services_utils__["e" /* getFromAtob */])([__WEBPACK_IMPORTED_MODULE_0_query_string___default.a.parse(location.search)]),_getFromAtob2=_slicedToArray(_getFromAtob,1),nomeAssinatura=_getFromAtob2[0];return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:classes.container},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_Grid_GridContainer_jsx__["a" /* default */],{alignContent:"center",justify:"center"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components_Grid_GridItem_jsx__["a" /* default */],{md:10,sm:12,xs:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_EnergyCompany_Cards_ECCard_jsx__["a" /* default */],{content:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:classes.contentWrapper},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("h4",null,"Voc\xEA foi convidado para fazer da assinatura de ",__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("b",null,atob(nomeAssinatura)),"."),loading?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_EnergyCompany_BouncingLoader_BouncingLoader_jsx__["a" /* default */],null):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:classes.buttons},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_CustomButtons_Button_jsx__["a" /* default */],{className:classes.confirmarBtn,color:"rose",onClick:function onClick(){return _this2.confirmacaoConvite(false);},round:true},"Recusar"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_CustomButtons_Button_jsx__["a" /* default */],{color:"info",onClick:function onClick(){return _this2.confirmacaoConvite(true);},round:true},"Confirmar")),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("h4",null,msg)),title:"Aceitar ou recusar convite",titleActionsClass:classes.titleActions}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_EnergyCompany_Alert_Alerts__["a" /* default */],null));}}]);return ConfirmacaoConvitePage;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);ConfirmacaoConvitePage.propTypes={authenticateUser:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,classes:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired,history:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired,location:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired,showAlert:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired};var mapDispatchToProps={authenticateUser:__WEBPACK_IMPORTED_MODULE_12_reducers_user_actions__["a" /* authenticateUser */],showAlert:__WEBPACK_IMPORTED_MODULE_15_reducers_alerts_actions__["b" /* showAlert */]};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_4_react_redux__["b" /* connect */])(null,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles_withStyles___default()(styles)(ConfirmacaoConvitePage)));

/***/ }),
/* 433 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

module.exports = function (str) {
	return encodeURIComponent(str).replace(/[!'()*]/g, function (c) {
		return '%' + c.charCodeAt(0).toString(16).toUpperCase();
	});
};


/***/ }),
/* 434 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var token = '%[a-f0-9]{2}';
var singleMatcher = new RegExp(token, 'gi');
var multiMatcher = new RegExp('(' + token + ')+', 'gi');

function decodeComponents(components, split) {
	try {
		// Try to decode the entire string first
		return decodeURIComponent(components.join(''));
	} catch (err) {
		// Do nothing
	}

	if (components.length === 1) {
		return components;
	}

	split = split || 1;

	// Split the array in 2 parts
	var left = components.slice(0, split);
	var right = components.slice(split);

	return Array.prototype.concat.call([], decodeComponents(left), decodeComponents(right));
}

function decode(input) {
	try {
		return decodeURIComponent(input);
	} catch (err) {
		var tokens = input.match(singleMatcher);

		for (var i = 1; i < tokens.length; i++) {
			input = decodeComponents(tokens, i).join('');

			tokens = input.match(singleMatcher);
		}

		return input;
	}
}

function customDecodeURIComponent(input) {
	// Keep track of all the replacements and prefill the map with the `BOM`
	var replaceMap = {
		'%FE%FF': '\uFFFD\uFFFD',
		'%FF%FE': '\uFFFD\uFFFD'
	};

	var match = multiMatcher.exec(input);
	while (match) {
		try {
			// Decode as big chunks as possible
			replaceMap[match[0]] = decodeURIComponent(match[0]);
		} catch (err) {
			var result = decode(match[0]);

			if (result !== match[0]) {
				replaceMap[match[0]] = result;
			}
		}

		match = multiMatcher.exec(input);
	}

	// Add `%C2` at the end of the map to make sure it does not replace the combinator before everything else
	replaceMap['%C2'] = '\uFFFD';

	var entries = Object.keys(replaceMap);

	for (var i = 0; i < entries.length; i++) {
		// Replace all decoded components
		var key = entries[i];
		input = input.replace(new RegExp(key, 'g'), replaceMap[key]);
	}

	return input;
}

module.exports = function (encodedURI) {
	if (typeof encodedURI !== 'string') {
		throw new TypeError('Expected `encodedURI` to be of type `string`, got `' + typeof encodedURI + '`');
	}

	try {
		encodedURI = encodedURI.replace(/\+/g, ' ');

		// Try the built in decoder first
		return decodeURIComponent(encodedURI);
	} catch (err) {
		// Fallback to a more advanced decoder
		return customDecodeURIComponent(encodedURI);
	}
};


/***/ }),
/* 435 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ns$jss$ns$sheetOptio;

var _propTypes = __webpack_require__(1);

var _ns = __webpack_require__(231);

var ns = _interopRequireWildcard(_ns);

var _propTypes2 = __webpack_require__(436);

var _propTypes3 = _interopRequireDefault(_propTypes2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

exports['default'] = (_ns$jss$ns$sheetOptio = {}, _defineProperty(_ns$jss$ns$sheetOptio, ns.jss, _propTypes3['default'].jss), _defineProperty(_ns$jss$ns$sheetOptio, ns.sheetOptions, _propTypes.object), _defineProperty(_ns$jss$ns$sheetOptio, ns.sheetsRegistry, _propTypes3['default'].registry), _defineProperty(_ns$jss$ns$sheetOptio, ns.managers, _propTypes.object), _ns$jss$ns$sheetOptio);

/***/ }),
/* 436 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__(1);

exports['default'] = {
  jss: (0, _propTypes.shape)({
    options: (0, _propTypes.shape)({
      createGenerateClassName: _propTypes.func.isRequired
    }).isRequired,
    createStyleSheet: _propTypes.func.isRequired,
    removeStyleSheet: _propTypes.func.isRequired
  }),
  registry: (0, _propTypes.shape)({
    add: _propTypes.func.isRequired,
    toString: _propTypes.func.isRequired
  })
};

/***/ }),
/* 437 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports['default'] = getDynamicStyles;
/**
 * Extracts a styles object with only props that contain function values.
 */
function getDynamicStyles(styles) {
  var to = null;

  for (var key in styles) {
    var value = styles[key];
    var type = typeof value === 'undefined' ? 'undefined' : _typeof(value);

    if (type === 'function') {
      if (!to) to = {};
      to[key] = value;
    } else if (type === 'object' && value !== null && !Array.isArray(value)) {
      var extracted = getDynamicStyles(value);
      if (extracted) {
        if (!to) to = {};
        to[key] = extracted;
      }
    }
  }

  return to;
}

/***/ }),
/* 438 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _warning = __webpack_require__(68);

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * SheetsManager is like a WeakMap which is designed to count StyleSheet
 * instances and attach/detach automatically.
 */
var SheetsManager = function () {
  function SheetsManager() {
    _classCallCheck(this, SheetsManager);

    this.sheets = [];
    this.refs = [];
    this.keys = [];
  }

  _createClass(SheetsManager, [{
    key: 'get',
    value: function get(key) {
      var index = this.keys.indexOf(key);
      return this.sheets[index];
    }
  }, {
    key: 'add',
    value: function add(key, sheet) {
      var sheets = this.sheets,
          refs = this.refs,
          keys = this.keys;

      var index = sheets.indexOf(sheet);

      if (index !== -1) return index;

      sheets.push(sheet);
      refs.push(0);
      keys.push(key);

      return sheets.length - 1;
    }
  }, {
    key: 'manage',
    value: function manage(key) {
      var index = this.keys.indexOf(key);
      var sheet = this.sheets[index];
      if (this.refs[index] === 0) sheet.attach();
      this.refs[index]++;
      if (!this.keys[index]) this.keys.splice(index, 0, key);
      return sheet;
    }
  }, {
    key: 'unmanage',
    value: function unmanage(key) {
      var index = this.keys.indexOf(key);
      if (index === -1) {
        // eslint-ignore-next-line no-console
        (0, _warning2['default'])(false, "SheetsManager: can't find sheet to unmanage");
        return;
      }
      if (this.refs[index] > 0) {
        this.refs[index]--;
        if (this.refs[index] === 0) this.sheets[index].detach();
      }
    }
  }, {
    key: 'size',
    get: function get() {
      return this.keys.length;
    }
  }]);

  return SheetsManager;
}();

exports['default'] = SheetsManager;

/***/ }),
/* 439 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports['default'] = cloneStyle;

var _isObservable = __webpack_require__(234);

var _isObservable2 = _interopRequireDefault(_isObservable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var isArray = Array.isArray;
function cloneStyle(style) {
  // Support empty values in case user ends up with them by accident.
  if (style == null) return style;

  // Support string value for SimpleRule.
  var typeOfStyle = typeof style === 'undefined' ? 'undefined' : _typeof(style);

  if (typeOfStyle === 'string' || typeOfStyle === 'number' || typeOfStyle === 'function') {
    return style;
  }

  // Support array for FontFaceRule.
  if (isArray(style)) return style.map(cloneStyle);

  // Support Observable styles.  Observables are immutable, so we don't need to
  // copy them.
  if ((0, _isObservable2['default'])(style)) return style;

  var newStyle = {};
  for (var name in style) {
    var value = style[name];
    if ((typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object') {
      newStyle[name] = cloneStyle(value);
      continue;
    }
    newStyle[name] = value;
  }

  return newStyle;
}

/***/ }),
/* 440 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(global, module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ponyfill_js__ = __webpack_require__(441);
/* global window */


var root;

if (typeof self !== 'undefined') {
  root = self;
} else if (typeof window !== 'undefined') {
  root = window;
} else if (typeof global !== 'undefined') {
  root = global;
} else if (true) {
  root = module;
} else {
  root = Function('return this')();
}

var result = Object(__WEBPACK_IMPORTED_MODULE_0__ponyfill_js__["a" /* default */])(root);
/* harmony default export */ __webpack_exports__["default"] = (result);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(36), __webpack_require__(219)(module)))

/***/ }),
/* 441 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = symbolObservablePonyfill;
function symbolObservablePonyfill(root) {
	var result;
	var Symbol = root.Symbol;

	if (typeof Symbol === 'function') {
		if (Symbol.observable) {
			result = Symbol.observable;
		} else {
			result = Symbol('observable');
			Symbol.observable = result;
		}
	} else {
		result = '@@observable';
	}

	return result;
};


/***/ }),
/* 442 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
var CSS = global.CSS;

var env = "production";

var escapeRegex = /([[\].#*$><+~=|^:(),"'`])/g;

exports['default'] = function (str) {
  // We don't need to escape it in production, because we are not using user's
  // input for selectors, we are generating a valid selector.
  if (env === 'production') return str;

  if (!CSS || !CSS.escape) {
    return str.replace(escapeRegex, '\\$1');
  }

  return CSS.escape(str);
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(36)))

/***/ }),
/* 443 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
var ns = '2f1acc6c3a606b082e5eef5e54414ffb';
if (global[ns] == null) global[ns] = 0;

// Bundle may contain multiple JSS versions at the same time. In order to identify
// the current version with just one short number and use it for classes generation
// we use a counter. Also it is more accurate, because user can manually reevaluate
// the module.
exports['default'] = global[ns]++;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(36)))

/***/ }),
/* 444 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _isInBrowser = __webpack_require__(120);

var _isInBrowser2 = _interopRequireDefault(_isInBrowser);

var _StyleSheet = __webpack_require__(237);

var _StyleSheet2 = _interopRequireDefault(_StyleSheet);

var _PluginsRegistry = __webpack_require__(445);

var _PluginsRegistry2 = _interopRequireDefault(_PluginsRegistry);

var _rules = __webpack_require__(446);

var _rules2 = _interopRequireDefault(_rules);

var _observables = __webpack_require__(452);

var _observables2 = _interopRequireDefault(_observables);

var _functions = __webpack_require__(453);

var _functions2 = _interopRequireDefault(_functions);

var _sheets = __webpack_require__(169);

var _sheets2 = _interopRequireDefault(_sheets);

var _StyleRule = __webpack_require__(69);

var _StyleRule2 = _interopRequireDefault(_StyleRule);

var _createGenerateClassName = __webpack_require__(236);

var _createGenerateClassName2 = _interopRequireDefault(_createGenerateClassName);

var _createRule2 = __webpack_require__(119);

var _createRule3 = _interopRequireDefault(_createRule2);

var _DomRenderer = __webpack_require__(454);

var _DomRenderer2 = _interopRequireDefault(_DomRenderer);

var _VirtualRenderer = __webpack_require__(455);

var _VirtualRenderer2 = _interopRequireDefault(_VirtualRenderer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var defaultPlugins = _rules2['default'].concat([_observables2['default'], _functions2['default']]);

var instanceCounter = 0;

var Jss = function () {
  function Jss(options) {
    _classCallCheck(this, Jss);

    this.id = instanceCounter++;
    this.version = "9.8.7";
    this.plugins = new _PluginsRegistry2['default']();
    this.options = {
      createGenerateClassName: _createGenerateClassName2['default'],
      Renderer: _isInBrowser2['default'] ? _DomRenderer2['default'] : _VirtualRenderer2['default'],
      plugins: []
    };
    this.generateClassName = (0, _createGenerateClassName2['default'])();

    // eslint-disable-next-line prefer-spread
    this.use.apply(this, defaultPlugins);
    this.setup(options);
  }

  _createClass(Jss, [{
    key: 'setup',
    value: function setup() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      if (options.createGenerateClassName) {
        this.options.createGenerateClassName = options.createGenerateClassName;
        // $FlowFixMe
        this.generateClassName = options.createGenerateClassName();
      }

      if (options.insertionPoint != null) this.options.insertionPoint = options.insertionPoint;
      if (options.virtual || options.Renderer) {
        this.options.Renderer = options.Renderer || (options.virtual ? _VirtualRenderer2['default'] : _DomRenderer2['default']);
      }

      // eslint-disable-next-line prefer-spread
      if (options.plugins) this.use.apply(this, options.plugins);

      return this;
    }

    /**
     * Create a Style Sheet.
     */

  }, {
    key: 'createStyleSheet',
    value: function createStyleSheet(styles) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      var index = options.index;
      if (typeof index !== 'number') {
        index = _sheets2['default'].index === 0 ? 0 : _sheets2['default'].index + 1;
      }
      var sheet = new _StyleSheet2['default'](styles, _extends({}, options, {
        jss: this,
        generateClassName: options.generateClassName || this.generateClassName,
        insertionPoint: this.options.insertionPoint,
        Renderer: this.options.Renderer,
        index: index
      }));
      this.plugins.onProcessSheet(sheet);

      return sheet;
    }

    /**
     * Detach the Style Sheet and remove it from the registry.
     */

  }, {
    key: 'removeStyleSheet',
    value: function removeStyleSheet(sheet) {
      sheet.detach();
      _sheets2['default'].remove(sheet);
      return this;
    }

    /**
     * Create a rule without a Style Sheet.
     */

  }, {
    key: 'createRule',
    value: function createRule(name) {
      var style = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

      // Enable rule without name for inline styles.
      if ((typeof name === 'undefined' ? 'undefined' : _typeof(name)) === 'object') {
        options = style;
        style = name;
        name = undefined;
      }

      // Cast from RuleFactoryOptions to RuleOptions
      // https://stackoverflow.com/questions/41328728/force-casting-in-flow
      var ruleOptions = options;

      ruleOptions.jss = this;
      ruleOptions.Renderer = this.options.Renderer;
      if (!ruleOptions.generateClassName) ruleOptions.generateClassName = this.generateClassName;
      if (!ruleOptions.classes) ruleOptions.classes = {};
      var rule = (0, _createRule3['default'])(name, style, ruleOptions);

      if (!ruleOptions.selector && rule instanceof _StyleRule2['default']) {
        rule.selector = '.' + ruleOptions.generateClassName(rule);
      }

      this.plugins.onProcessRule(rule);

      return rule;
    }

    /**
     * Register plugin. Passed function will be invoked with a rule instance.
     */

  }, {
    key: 'use',
    value: function use() {
      var _this = this;

      for (var _len = arguments.length, plugins = Array(_len), _key = 0; _key < _len; _key++) {
        plugins[_key] = arguments[_key];
      }

      plugins.forEach(function (plugin) {
        // Avoids applying same plugin twice, at least based on ref.
        if (_this.options.plugins.indexOf(plugin) === -1) {
          _this.options.plugins.push(plugin);
          _this.plugins.use(plugin);
        }
      });

      return this;
    }
  }]);

  return Jss;
}();

exports['default'] = Jss;

/***/ }),
/* 445 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _warning = __webpack_require__(68);

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var PluginsRegistry = function () {
  function PluginsRegistry() {
    _classCallCheck(this, PluginsRegistry);

    this.hooks = {
      onCreateRule: [],
      onProcessRule: [],
      onProcessStyle: [],
      onProcessSheet: [],
      onChangeValue: [],
      onUpdate: []

      /**
       * Call `onCreateRule` hooks and return an object if returned by a hook.
       */
    };
  }

  _createClass(PluginsRegistry, [{
    key: 'onCreateRule',
    value: function onCreateRule(name, decl, options) {
      for (var i = 0; i < this.hooks.onCreateRule.length; i++) {
        var rule = this.hooks.onCreateRule[i](name, decl, options);
        if (rule) return rule;
      }
      return null;
    }

    /**
     * Call `onProcessRule` hooks.
     */

  }, {
    key: 'onProcessRule',
    value: function onProcessRule(rule) {
      if (rule.isProcessed) return;
      var sheet = rule.options.sheet;

      for (var i = 0; i < this.hooks.onProcessRule.length; i++) {
        this.hooks.onProcessRule[i](rule, sheet);
      }

      // $FlowFixMe
      if (rule.style) this.onProcessStyle(rule.style, rule, sheet);

      rule.isProcessed = true;
    }

    /**
     * Call `onProcessStyle` hooks.
     */

  }, {
    key: 'onProcessStyle',
    value: function onProcessStyle(style, rule, sheet) {
      var nextStyle = style;

      for (var i = 0; i < this.hooks.onProcessStyle.length; i++) {
        nextStyle = this.hooks.onProcessStyle[i](nextStyle, rule, sheet);
        // $FlowFixMe
        rule.style = nextStyle;
      }
    }

    /**
     * Call `onProcessSheet` hooks.
     */

  }, {
    key: 'onProcessSheet',
    value: function onProcessSheet(sheet) {
      for (var i = 0; i < this.hooks.onProcessSheet.length; i++) {
        this.hooks.onProcessSheet[i](sheet);
      }
    }

    /**
     * Call `onUpdate` hooks.
     */

  }, {
    key: 'onUpdate',
    value: function onUpdate(data, rule, sheet) {
      for (var i = 0; i < this.hooks.onUpdate.length; i++) {
        this.hooks.onUpdate[i](data, rule, sheet);
      }
    }

    /**
     * Call `onChangeValue` hooks.
     */

  }, {
    key: 'onChangeValue',
    value: function onChangeValue(value, prop, rule) {
      var processedValue = value;
      for (var i = 0; i < this.hooks.onChangeValue.length; i++) {
        processedValue = this.hooks.onChangeValue[i](processedValue, prop, rule);
      }
      return processedValue;
    }

    /**
     * Register a plugin.
     * If function is passed, it is a shortcut for `{onProcessRule}`.
     */

  }, {
    key: 'use',
    value: function use(plugin) {
      for (var name in plugin) {
        if (this.hooks[name]) this.hooks[name].push(plugin[name]);else (0, _warning2['default'])(false, '[JSS] Unknown hook "%s".', name);
      }
    }
  }]);

  return PluginsRegistry;
}();

exports['default'] = PluginsRegistry;

/***/ }),
/* 446 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _SimpleRule = __webpack_require__(447);

var _SimpleRule2 = _interopRequireDefault(_SimpleRule);

var _KeyframesRule = __webpack_require__(448);

var _KeyframesRule2 = _interopRequireDefault(_KeyframesRule);

var _ConditionalRule = __webpack_require__(449);

var _ConditionalRule2 = _interopRequireDefault(_ConditionalRule);

var _FontFaceRule = __webpack_require__(450);

var _FontFaceRule2 = _interopRequireDefault(_FontFaceRule);

var _ViewportRule = __webpack_require__(451);

var _ViewportRule2 = _interopRequireDefault(_ViewportRule);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var classes = {
  '@charset': _SimpleRule2['default'],
  '@import': _SimpleRule2['default'],
  '@namespace': _SimpleRule2['default'],
  '@keyframes': _KeyframesRule2['default'],
  '@media': _ConditionalRule2['default'],
  '@supports': _ConditionalRule2['default'],
  '@font-face': _FontFaceRule2['default'],
  '@viewport': _ViewportRule2['default'],
  '@-ms-viewport': _ViewportRule2['default']

  /**
   * Generate plugins which will register all rules.
   */
};
var plugins = Object.keys(classes).map(function (key) {
  // https://jsperf.com/indexof-vs-substr-vs-regex-at-the-beginning-3
  var re = new RegExp('^' + key);
  var RuleClass = classes[key];
  var onCreateRule = function onCreateRule(name, decl, options) {
    return re.test(name) ? new RuleClass(name, decl, options) : null;
  };
  return { onCreateRule: onCreateRule };
});

exports['default'] = plugins;

/***/ }),
/* 447 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var SimpleRule = function () {
  function SimpleRule(key, value, options) {
    _classCallCheck(this, SimpleRule);

    this.type = 'simple';
    this.isProcessed = false;

    this.key = key;
    this.value = value;
    this.options = options;
  }

  /**
   * Generates a CSS string.
   */
  // eslint-disable-next-line no-unused-vars


  _createClass(SimpleRule, [{
    key: 'toString',
    value: function toString(options) {
      if (Array.isArray(this.value)) {
        var str = '';
        for (var index = 0; index < this.value.length; index++) {
          str += this.key + ' ' + this.value[index] + ';';
          if (this.value[index + 1]) str += '\n';
        }
        return str;
      }

      return this.key + ' ' + this.value + ';';
    }
  }]);

  return SimpleRule;
}();

exports['default'] = SimpleRule;

/***/ }),
/* 448 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _RuleList = __webpack_require__(91);

var _RuleList2 = _interopRequireDefault(_RuleList);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Rule for @keyframes
 */
var KeyframesRule = function () {
  function KeyframesRule(key, frames, options) {
    _classCallCheck(this, KeyframesRule);

    this.type = 'keyframes';
    this.isProcessed = false;

    this.key = key;
    this.options = options;
    this.rules = new _RuleList2['default'](_extends({}, options, { parent: this }));

    for (var name in frames) {
      this.rules.add(name, frames[name], _extends({}, this.options, {
        parent: this,
        selector: name
      }));
    }

    this.rules.process();
  }

  /**
   * Generates a CSS string.
   */


  _createClass(KeyframesRule, [{
    key: 'toString',
    value: function toString() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { indent: 1 };

      var inner = this.rules.toString(options);
      if (inner) inner += '\n';
      return this.key + ' {\n' + inner + '}';
    }
  }]);

  return KeyframesRule;
}();

exports['default'] = KeyframesRule;

/***/ }),
/* 449 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _RuleList = __webpack_require__(91);

var _RuleList2 = _interopRequireDefault(_RuleList);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Conditional rule for @media, @supports
 */
var ConditionalRule = function () {
  function ConditionalRule(key, styles, options) {
    _classCallCheck(this, ConditionalRule);

    this.type = 'conditional';
    this.isProcessed = false;

    this.key = key;
    this.options = options;
    this.rules = new _RuleList2['default'](_extends({}, options, { parent: this }));

    for (var name in styles) {
      this.rules.add(name, styles[name]);
    }

    this.rules.process();
  }

  /**
   * Get a rule.
   */


  _createClass(ConditionalRule, [{
    key: 'getRule',
    value: function getRule(name) {
      return this.rules.get(name);
    }

    /**
     * Get index of a rule.
     */

  }, {
    key: 'indexOf',
    value: function indexOf(rule) {
      return this.rules.indexOf(rule);
    }

    /**
     * Create and register rule, run plugins.
     */

  }, {
    key: 'addRule',
    value: function addRule(name, style, options) {
      var rule = this.rules.add(name, style, options);
      this.options.jss.plugins.onProcessRule(rule);
      return rule;
    }

    /**
     * Generates a CSS string.
     */

  }, {
    key: 'toString',
    value: function toString() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { indent: 1 };

      var inner = this.rules.toString(options);
      return inner ? this.key + ' {\n' + inner + '\n}' : '';
    }
  }]);

  return ConditionalRule;
}();

exports['default'] = ConditionalRule;

/***/ }),
/* 450 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _toCss = __webpack_require__(168);

var _toCss2 = _interopRequireDefault(_toCss);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var FontFaceRule = function () {
  function FontFaceRule(key, style, options) {
    _classCallCheck(this, FontFaceRule);

    this.type = 'font-face';
    this.isProcessed = false;

    this.key = key;
    this.style = style;
    this.options = options;
  }

  /**
   * Generates a CSS string.
   */


  _createClass(FontFaceRule, [{
    key: 'toString',
    value: function toString(options) {
      if (Array.isArray(this.style)) {
        var str = '';
        for (var index = 0; index < this.style.length; index++) {
          str += (0, _toCss2['default'])(this.key, this.style[index]);
          if (this.style[index + 1]) str += '\n';
        }
        return str;
      }

      return (0, _toCss2['default'])(this.key, this.style, options);
    }
  }]);

  return FontFaceRule;
}();

exports['default'] = FontFaceRule;

/***/ }),
/* 451 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _toCss = __webpack_require__(168);

var _toCss2 = _interopRequireDefault(_toCss);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ViewportRule = function () {
  function ViewportRule(key, style, options) {
    _classCallCheck(this, ViewportRule);

    this.type = 'viewport';
    this.isProcessed = false;

    this.key = key;
    this.style = style;
    this.options = options;
  }

  /**
   * Generates a CSS string.
   */


  _createClass(ViewportRule, [{
    key: 'toString',
    value: function toString(options) {
      return (0, _toCss2['default'])(this.key, this.style, options);
    }
  }]);

  return ViewportRule;
}();

exports['default'] = ViewportRule;

/***/ }),
/* 452 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _StyleRule = __webpack_require__(69);

var _StyleRule2 = _interopRequireDefault(_StyleRule);

var _createRule = __webpack_require__(119);

var _createRule2 = _interopRequireDefault(_createRule);

var _isObservable = __webpack_require__(234);

var _isObservable2 = _interopRequireDefault(_isObservable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = {
  onCreateRule: function onCreateRule(name, decl, options) {
    if (!(0, _isObservable2['default'])(decl)) return null;

    // Cast `decl` to `Observable`, since it passed the type guard.
    var style$ = decl;

    var rule = (0, _createRule2['default'])(name, {}, options);

    // TODO
    // Call `stream.subscribe()` returns a subscription, which should be explicitly
    // unsubscribed from when we know this sheet is no longer needed.
    style$.subscribe(function (style) {
      for (var prop in style) {
        rule.prop(prop, style[prop]);
      }
    });

    return rule;
  },
  onProcessRule: function onProcessRule(rule) {
    if (!(rule instanceof _StyleRule2['default'])) return;
    var styleRule = rule;
    var style = styleRule.style;

    var _loop = function _loop(prop) {
      var value = style[prop];
      if (!(0, _isObservable2['default'])(value)) return 'continue';
      delete style[prop];
      value.subscribe({
        next: function next(nextValue) {
          styleRule.prop(prop, nextValue);
        }
      });
    };

    for (var prop in style) {
      var _ret = _loop(prop);

      if (_ret === 'continue') continue;
    }
  }
};

/***/ }),
/* 453 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _RuleList = __webpack_require__(91);

var _RuleList2 = _interopRequireDefault(_RuleList);

var _StyleRule = __webpack_require__(69);

var _StyleRule2 = _interopRequireDefault(_StyleRule);

var _createRule = __webpack_require__(119);

var _createRule2 = _interopRequireDefault(_createRule);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

// A symbol replacement.
var now = Date.now();

var fnValuesNs = 'fnValues' + now;
var fnStyleNs = 'fnStyle' + ++now;

exports['default'] = {
  onCreateRule: function onCreateRule(name, decl, options) {
    if (typeof decl !== 'function') return null;
    var rule = (0, _createRule2['default'])(name, {}, options);
    rule[fnStyleNs] = decl;
    return rule;
  },
  onProcessStyle: function onProcessStyle(style, rule) {
    var fn = {};
    for (var prop in style) {
      var value = style[prop];
      if (typeof value !== 'function') continue;
      delete style[prop];
      fn[prop] = value;
    }
    rule = rule;
    rule[fnValuesNs] = fn;
    return style;
  },
  onUpdate: function onUpdate(data, rule) {
    // It is a rules container like for e.g. ConditionalRule.
    if (rule.rules instanceof _RuleList2['default']) {
      rule.rules.update(data);
      return;
    }
    if (!(rule instanceof _StyleRule2['default'])) return;

    rule = rule;

    // If we have a fn values map, it is a rule with function values.
    if (rule[fnValuesNs]) {
      for (var prop in rule[fnValuesNs]) {
        rule.prop(prop, rule[fnValuesNs][prop](data));
      }
    }

    rule = rule;

    var fnStyle = rule[fnStyleNs];

    // If we have a style function, the entire rule is dynamic and style object
    // will be returned from that function.
    if (fnStyle) {
      var style = fnStyle(data);
      for (var _prop in style) {
        rule.prop(_prop, style[_prop]);
      }
    }
  }
};

/***/ }),
/* 454 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _warning = __webpack_require__(68);

var _warning2 = _interopRequireDefault(_warning);

var _sheets = __webpack_require__(169);

var _sheets2 = _interopRequireDefault(_sheets);

var _StyleRule = __webpack_require__(69);

var _StyleRule2 = _interopRequireDefault(_StyleRule);

var _toCssValue = __webpack_require__(118);

var _toCssValue2 = _interopRequireDefault(_toCssValue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Cache the value from the first time a function is called.
 */
var memoize = function memoize(fn) {
  var value = void 0;
  return function () {
    if (!value) value = fn();
    return value;
  };
};

/**
 * Get a style property value.
 */
function getPropertyValue(cssRule, prop) {
  try {
    return cssRule.style.getPropertyValue(prop);
  } catch (err) {
    // IE may throw if property is unknown.
    return '';
  }
}

/**
 * Set a style property.
 */
function setProperty(cssRule, prop, value) {
  try {
    var cssValue = value;

    if (Array.isArray(value)) {
      cssValue = (0, _toCssValue2['default'])(value, true);

      if (value[value.length - 1] === '!important') {
        cssRule.style.setProperty(prop, cssValue, 'important');
        return true;
      }
    }

    cssRule.style.setProperty(prop, cssValue);
  } catch (err) {
    // IE may throw if property is unknown.
    return false;
  }
  return true;
}

/**
 * Remove a style property.
 */
function removeProperty(cssRule, prop) {
  try {
    cssRule.style.removeProperty(prop);
  } catch (err) {
    (0, _warning2['default'])(false, '[JSS] DOMException "%s" was thrown. Tried to remove property "%s".', err.message, prop);
  }
}

var CSSRuleTypes = {
  STYLE_RULE: 1,
  KEYFRAMES_RULE: 7

  /**
   * Get the CSS Rule key.
   */

};var getKey = function () {
  var extractKey = function extractKey(cssText) {
    var from = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    return cssText.substr(from, cssText.indexOf('{') - 1);
  };

  return function (cssRule) {
    if (cssRule.type === CSSRuleTypes.STYLE_RULE) return cssRule.selectorText;
    if (cssRule.type === CSSRuleTypes.KEYFRAMES_RULE) {
      var name = cssRule.name;

      if (name) return '@keyframes ' + name;

      // There is no rule.name in the following browsers:
      // - IE 9
      // - Safari 7.1.8
      // - Mobile Safari 9.0.0
      var cssText = cssRule.cssText;

      return '@' + extractKey(cssText, cssText.indexOf('keyframes'));
    }

    // Conditionals.
    return extractKey(cssRule.cssText);
  };
}();

/**
 * Set the selector.
 */
function setSelector(cssRule, selectorText) {
  cssRule.selectorText = selectorText;

  // Return false if setter was not successful.
  // Currently works in chrome only.
  return cssRule.selectorText === selectorText;
}

/**
 * Gets the `head` element upon the first call and caches it.
 */
var getHead = memoize(function () {
  return document.head || document.getElementsByTagName('head')[0];
});

/**
 * Gets a map of rule keys, where the property is an unescaped key and value
 * is a potentially escaped one.
 * It is used to identify CSS rules and the corresponding JSS rules. As an identifier
 * for CSSStyleRule we normally use `selectorText`. Though if original selector text
 * contains escaped code points e.g. `:not(#\\20)`, CSSOM will compile it to `:not(# )`
 * and so CSS rule's `selectorText` won't match JSS rule selector.
 *
 * https://www.w3.org/International/questions/qa-escapes#cssescapes
 */
var getUnescapedKeysMap = function () {
  var style = void 0;
  var isAttached = false;

  return function (rules) {
    var map = {};
    // https://github.com/facebook/flow/issues/2696
    if (!style) style = document.createElement('style');
    for (var i = 0; i < rules.length; i++) {
      var rule = rules[i];
      if (!(rule instanceof _StyleRule2['default'])) continue;
      var selector = rule.selector;
      // Only unescape selector over CSSOM if it contains a back slash.

      if (selector && selector.indexOf('\\') !== -1) {
        // Lazilly attach when needed.
        if (!isAttached) {
          getHead().appendChild(style);
          isAttached = true;
        }
        style.textContent = selector + ' {}';
        var _style = style,
            sheet = _style.sheet;

        if (sheet) {
          var cssRules = sheet.cssRules;

          if (cssRules) map[cssRules[0].selectorText] = rule.key;
        }
      }
    }
    if (isAttached) {
      getHead().removeChild(style);
      isAttached = false;
    }
    return map;
  };
}();

/**
 * Find attached sheet with an index higher than the passed one.
 */
function findHigherSheet(registry, options) {
  for (var i = 0; i < registry.length; i++) {
    var sheet = registry[i];
    if (sheet.attached && sheet.options.index > options.index && sheet.options.insertionPoint === options.insertionPoint) {
      return sheet;
    }
  }
  return null;
}

/**
 * Find attached sheet with the highest index.
 */
function findHighestSheet(registry, options) {
  for (var i = registry.length - 1; i >= 0; i--) {
    var sheet = registry[i];
    if (sheet.attached && sheet.options.insertionPoint === options.insertionPoint) {
      return sheet;
    }
  }
  return null;
}

/**
 * Find a comment with "jss" inside.
 */
function findCommentNode(text) {
  var head = getHead();
  for (var i = 0; i < head.childNodes.length; i++) {
    var node = head.childNodes[i];
    if (node.nodeType === 8 && node.nodeValue.trim() === text) {
      return node;
    }
  }
  return null;
}

/**
 * Find a node before which we can insert the sheet.
 */
function findPrevNode(options) {
  var registry = _sheets2['default'].registry;


  if (registry.length > 0) {
    // Try to insert before the next higher sheet.
    var sheet = findHigherSheet(registry, options);
    if (sheet) return sheet.renderer.element;

    // Otherwise insert after the last attached.
    sheet = findHighestSheet(registry, options);
    if (sheet) return sheet.renderer.element.nextElementSibling;
  }

  // Try to find a comment placeholder if registry is empty.
  var insertionPoint = options.insertionPoint;

  if (insertionPoint && typeof insertionPoint === 'string') {
    var comment = findCommentNode(insertionPoint);
    if (comment) return comment.nextSibling;
    // If user specifies an insertion point and it can't be found in the document -
    // bad specificity issues may appear.
    (0, _warning2['default'])(insertionPoint === 'jss', '[JSS] Insertion point "%s" not found.', insertionPoint);
  }

  return null;
}

/**
 * Insert style element into the DOM.
 */
function insertStyle(style, options) {
  var insertionPoint = options.insertionPoint;

  var prevNode = findPrevNode(options);

  if (prevNode) {
    var parentNode = prevNode.parentNode;

    if (parentNode) parentNode.insertBefore(style, prevNode);
    return;
  }

  // Works with iframes and any node types.
  if (insertionPoint && typeof insertionPoint.nodeType === 'number') {
    // https://stackoverflow.com/questions/41328728/force-casting-in-flow
    var insertionPointElement = insertionPoint;
    var _parentNode = insertionPointElement.parentNode;

    if (_parentNode) _parentNode.insertBefore(style, insertionPointElement.nextSibling);else (0, _warning2['default'])(false, '[JSS] Insertion point is not in the DOM.');
    return;
  }

  getHead().insertBefore(style, prevNode);
}

/**
 * Read jss nonce setting from the page if the user has set it.
 */
var getNonce = memoize(function () {
  var node = document.querySelector('meta[property="csp-nonce"]');
  return node ? node.getAttribute('content') : null;
});

var DomRenderer = function () {
  function DomRenderer(sheet) {
    _classCallCheck(this, DomRenderer);

    this.getPropertyValue = getPropertyValue;
    this.setProperty = setProperty;
    this.removeProperty = removeProperty;
    this.setSelector = setSelector;
    this.getKey = getKey;
    this.getUnescapedKeysMap = getUnescapedKeysMap;
    this.hasInsertedRules = false;

    // There is no sheet when the renderer is used from a standalone StyleRule.
    if (sheet) _sheets2['default'].add(sheet);

    this.sheet = sheet;

    var _ref = this.sheet ? this.sheet.options : {},
        media = _ref.media,
        meta = _ref.meta,
        element = _ref.element;

    this.element = element || document.createElement('style');
    this.element.setAttribute('data-jss', '');
    if (media) this.element.setAttribute('media', media);
    if (meta) this.element.setAttribute('data-meta', meta);
    var nonce = getNonce();
    if (nonce) this.element.setAttribute('nonce', nonce);
  }

  /**
   * Insert style element into render tree.
   */


  // HTMLStyleElement needs fixing https://github.com/facebook/flow/issues/2696


  _createClass(DomRenderer, [{
    key: 'attach',
    value: function attach() {
      // In the case the element node is external and it is already in the DOM.
      if (this.element.parentNode || !this.sheet) return;

      // When rules are inserted using `insertRule` API, after `sheet.detach().attach()`
      // browsers remove those rules.
      // TODO figure out if its a bug and if it is known.
      // Workaround is to redeploy the sheet before attaching as a string.
      if (this.hasInsertedRules) {
        this.deploy();
        this.hasInsertedRules = false;
      }

      insertStyle(this.element, this.sheet.options);
    }

    /**
     * Remove style element from render tree.
     */

  }, {
    key: 'detach',
    value: function detach() {
      this.element.parentNode.removeChild(this.element);
    }

    /**
     * Inject CSS string into element.
     */

  }, {
    key: 'deploy',
    value: function deploy() {
      if (!this.sheet) return;
      this.element.textContent = '\n' + this.sheet.toString() + '\n';
    }

    /**
     * Insert a rule into element.
     */

  }, {
    key: 'insertRule',
    value: function insertRule(rule, index) {
      var sheet = this.element.sheet;
      var cssRules = sheet.cssRules;

      var str = rule.toString();
      if (!index) index = cssRules.length;

      if (!str) return false;

      try {
        sheet.insertRule(str, index);
      } catch (err) {
        (0, _warning2['default'])(false, '[JSS] Can not insert an unsupported rule \n\r%s', rule);
        return false;
      }
      this.hasInsertedRules = true;

      return cssRules[index];
    }

    /**
     * Delete a rule.
     */

  }, {
    key: 'deleteRule',
    value: function deleteRule(cssRule) {
      var sheet = this.element.sheet;

      var index = this.indexOf(cssRule);
      if (index === -1) return false;
      sheet.deleteRule(index);
      return true;
    }

    /**
     * Get index of a CSS Rule.
     */

  }, {
    key: 'indexOf',
    value: function indexOf(cssRule) {
      var cssRules = this.element.sheet.cssRules;

      for (var _index = 0; _index < cssRules.length; _index++) {
        if (cssRule === cssRules[_index]) return _index;
      }
      return -1;
    }

    /**
     * Generate a new CSS rule and replace the existing one.
     */

  }, {
    key: 'replaceRule',
    value: function replaceRule(cssRule, rule) {
      var index = this.indexOf(cssRule);
      var newCssRule = this.insertRule(rule, index);
      this.element.sheet.deleteRule(index);
      return newCssRule;
    }

    /**
     * Get all rules elements.
     */

  }, {
    key: 'getRules',
    value: function getRules() {
      return this.element.sheet.cssRules;
    }
  }]);

  return DomRenderer;
}();

exports['default'] = DomRenderer;

/***/ }),
/* 455 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/* eslint-disable class-methods-use-this */

/**
 * Rendering backend to do nothing in nodejs.
 */
var VirtualRenderer = function () {
  function VirtualRenderer() {
    _classCallCheck(this, VirtualRenderer);
  }

  _createClass(VirtualRenderer, [{
    key: 'setProperty',
    value: function setProperty() {
      return true;
    }
  }, {
    key: 'getPropertyValue',
    value: function getPropertyValue() {
      return '';
    }
  }, {
    key: 'removeProperty',
    value: function removeProperty() {}
  }, {
    key: 'setSelector',
    value: function setSelector() {
      return true;
    }
  }, {
    key: 'getKey',
    value: function getKey() {
      return '';
    }
  }, {
    key: 'attach',
    value: function attach() {}
  }, {
    key: 'detach',
    value: function detach() {}
  }, {
    key: 'deploy',
    value: function deploy() {}
  }, {
    key: 'insertRule',
    value: function insertRule() {
      return false;
    }
  }, {
    key: 'deleteRule',
    value: function deleteRule() {
      return true;
    }
  }, {
    key: 'replaceRule',
    value: function replaceRule() {
      return false;
    }
  }, {
    key: 'getRules',
    value: function getRules() {}
  }, {
    key: 'indexOf',
    value: function indexOf() {
      return -1;
    }
  }]);

  return VirtualRenderer;
}();

exports['default'] = VirtualRenderer;

/***/ }),
/* 456 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports['default'] = jssGlobal;

var _jss = __webpack_require__(232);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var propKey = '@global';
var prefixKey = '@global ';

var GlobalContainerRule = function () {
  function GlobalContainerRule(key, styles, options) {
    _classCallCheck(this, GlobalContainerRule);

    this.type = 'global';

    this.key = key;
    this.options = options;
    this.rules = new _jss.RuleList(_extends({}, options, {
      parent: this
    }));

    for (var selector in styles) {
      this.rules.add(selector, styles[selector], { selector: selector });
    }

    this.rules.process();
  }

  /**
   * Get a rule.
   */


  _createClass(GlobalContainerRule, [{
    key: 'getRule',
    value: function getRule(name) {
      return this.rules.get(name);
    }

    /**
     * Create and register rule, run plugins.
     */

  }, {
    key: 'addRule',
    value: function addRule(name, style, options) {
      var rule = this.rules.add(name, style, options);
      this.options.jss.plugins.onProcessRule(rule);
      return rule;
    }

    /**
     * Get index of a rule.
     */

  }, {
    key: 'indexOf',
    value: function indexOf(rule) {
      return this.rules.indexOf(rule);
    }

    /**
     * Generates a CSS string.
     */

  }, {
    key: 'toString',
    value: function toString() {
      return this.rules.toString();
    }
  }]);

  return GlobalContainerRule;
}();

var GlobalPrefixedRule = function () {
  function GlobalPrefixedRule(name, style, options) {
    _classCallCheck(this, GlobalPrefixedRule);

    this.name = name;
    this.options = options;
    var selector = name.substr(prefixKey.length);
    this.rule = options.jss.createRule(selector, style, _extends({}, options, {
      parent: this,
      selector: selector
    }));
  }

  _createClass(GlobalPrefixedRule, [{
    key: 'toString',
    value: function toString(options) {
      return this.rule.toString(options);
    }
  }]);

  return GlobalPrefixedRule;
}();

var separatorRegExp = /\s*,\s*/g;

function addScope(selector, scope) {
  var parts = selector.split(separatorRegExp);
  var scoped = '';
  for (var i = 0; i < parts.length; i++) {
    scoped += scope + ' ' + parts[i].trim();
    if (parts[i + 1]) scoped += ', ';
  }
  return scoped;
}

function handleNestedGlobalContainerRule(rule) {
  var options = rule.options,
      style = rule.style;

  var rules = style[propKey];

  if (!rules) return;

  for (var name in rules) {
    options.sheet.addRule(name, rules[name], _extends({}, options, {
      selector: addScope(name, rule.selector)
    }));
  }

  delete style[propKey];
}

function handlePrefixedGlobalRule(rule) {
  var options = rule.options,
      style = rule.style;

  for (var prop in style) {
    if (prop.substr(0, propKey.length) !== propKey) continue;

    var selector = addScope(prop.substr(propKey.length), rule.selector);
    options.sheet.addRule(selector, style[prop], _extends({}, options, {
      selector: selector
    }));
    delete style[prop];
  }
}

/**
 * Convert nested rules to separate, remove them from original styles.
 *
 * @param {Rule} rule
 * @api public
 */
function jssGlobal() {
  function onCreateRule(name, styles, options) {
    if (name === propKey) {
      return new GlobalContainerRule(name, styles, options);
    }

    if (name[0] === '@' && name.substr(0, prefixKey.length) === prefixKey) {
      return new GlobalPrefixedRule(name, styles, options);
    }

    var parent = options.parent;


    if (parent) {
      if (parent.type === 'global' || parent.options.parent.type === 'global') {
        options.global = true;
      }
    }

    if (options.global) options.selector = name;

    return null;
  }

  function onProcessRule(rule) {
    if (rule.type !== 'style') return;

    handleNestedGlobalContainerRule(rule);
    handlePrefixedGlobalRule(rule);
  }

  return { onCreateRule: onCreateRule, onProcessRule: onProcessRule };
}

/***/ }),
/* 457 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = jssNested;

var _warning = __webpack_require__(458);

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var separatorRegExp = /\s*,\s*/g;
var parentRegExp = /&/g;
var refRegExp = /\$([\w-]+)/g;

/**
 * Convert nested rules to separate, remove them from original styles.
 *
 * @param {Rule} rule
 * @api public
 */
function jssNested() {
  // Get a function to be used for $ref replacement.
  function getReplaceRef(container) {
    return function (match, key) {
      var rule = container.getRule(key);
      if (rule) return rule.selector;
      (0, _warning2.default)(false, '[JSS] Could not find the referenced rule %s in %s.', key, container.options.meta || container);
      return key;
    };
  }

  var hasAnd = function hasAnd(str) {
    return str.indexOf('&') !== -1;
  };

  function replaceParentRefs(nestedProp, parentProp) {
    var parentSelectors = parentProp.split(separatorRegExp);
    var nestedSelectors = nestedProp.split(separatorRegExp);

    var result = '';

    for (var i = 0; i < parentSelectors.length; i++) {
      var parent = parentSelectors[i];

      for (var j = 0; j < nestedSelectors.length; j++) {
        var nested = nestedSelectors[j];
        if (result) result += ', ';
        // Replace all & by the parent or prefix & with the parent.
        result += hasAnd(nested) ? nested.replace(parentRegExp, parent) : parent + ' ' + nested;
      }
    }

    return result;
  }

  function getOptions(rule, container, options) {
    // Options has been already created, now we only increase index.
    if (options) return _extends({}, options, { index: options.index + 1 });

    var nestingLevel = rule.options.nestingLevel;

    nestingLevel = nestingLevel === undefined ? 1 : nestingLevel + 1;

    return _extends({}, rule.options, {
      nestingLevel: nestingLevel,
      index: container.indexOf(rule) + 1
    });
  }

  function onProcessStyle(style, rule) {
    if (rule.type !== 'style') return style;
    var container = rule.options.parent;
    var options = void 0;
    var replaceRef = void 0;
    for (var prop in style) {
      var isNested = hasAnd(prop);
      var isNestedConditional = prop[0] === '@';

      if (!isNested && !isNestedConditional) continue;

      options = getOptions(rule, container, options);

      if (isNested) {
        var selector = replaceParentRefs(prop, rule.selector
        // Lazily create the ref replacer function just once for
        // all nested rules within the sheet.
        );if (!replaceRef) replaceRef = getReplaceRef(container
        // Replace all $refs.
        );selector = selector.replace(refRegExp, replaceRef);

        container.addRule(selector, style[prop], _extends({}, options, { selector: selector }));
      } else if (isNestedConditional) {
        container
        // Place conditional right after the parent rule to ensure right ordering.
        .addRule(prop, null, options).addRule(rule.key, style[prop], { selector: rule.selector });
      }

      delete style[prop];
    }

    return style;
  }

  return { onProcessStyle: onProcessStyle };
}

/***/ }),
/* 458 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var warning = function() {};

if (false) {
  warning = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
        '`warning(condition, format, ...args)` requires a warning ' +
        'message argument'
      );
    }

    if (format.length < 10 || (/^[s\W]*$/).test(format)) {
      throw new Error(
        'The warning format should be able to uniquely identify this ' +
        'warning. Please, use a more descriptive format than: ' + format
      );
    }

    if (!condition) {
      var argIndex = 0;
      var message = 'Warning: ' +
        format.replace(/%s/g, function() {
          return args[argIndex++];
        });
      if (typeof console !== 'undefined') {
        console.error(message);
      }
      try {
        // This error was thrown as a convenience so that you can use this stack
        // to find the callsite that caused this warning to fire.
        throw new Error(message);
      } catch(x) {}
    }
  };
}

module.exports = warning;


/***/ }),
/* 459 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = camelCase;

var _hyphenateStyleName = __webpack_require__(460);

var _hyphenateStyleName2 = _interopRequireDefault(_hyphenateStyleName);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

/**
 * Convert camel cased property names to dash separated.
 *
 * @param {Object} style
 * @return {Object}
 */
function convertCase(style) {
  var converted = {};

  for (var prop in style) {
    converted[(0, _hyphenateStyleName2['default'])(prop)] = style[prop];
  }

  if (style.fallbacks) {
    if (Array.isArray(style.fallbacks)) converted.fallbacks = style.fallbacks.map(convertCase);else converted.fallbacks = convertCase(style.fallbacks);
  }

  return converted;
}

/**
 * Allow camel cased property names by converting them back to dasherized.
 *
 * @param {Rule} rule
 */
function camelCase() {
  function onProcessStyle(style) {
    if (Array.isArray(style)) {
      // Handle rules like @font-face, which can have multiple styles in an array
      for (var index = 0; index < style.length; index++) {
        style[index] = convertCase(style[index]);
      }
      return style;
    }

    return convertCase(style);
  }

  function onChangeValue(value, prop, rule) {
    var hyphenatedProp = (0, _hyphenateStyleName2['default'])(prop);

    // There was no camel case in place
    if (prop === hyphenatedProp) return value;

    rule.prop(hyphenatedProp, value);

    // Core will ignore that property value we set the proper one above.
    return null;
  }

  return { onProcessStyle: onProcessStyle, onChangeValue: onChangeValue };
}

/***/ }),
/* 460 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var uppercasePattern = /[A-Z]/g;
var msPattern = /^ms-/;
var cache = {};

function hyphenateStyleName(string) {
    return string in cache
    ? cache[string]
    : cache[string] = string
      .replace(uppercasePattern, '-$&')
      .toLowerCase()
      .replace(msPattern, '-ms-');
}

module.exports = hyphenateStyleName;


/***/ }),
/* 461 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports['default'] = defaultUnit;

var _defaultUnits = __webpack_require__(462);

var _defaultUnits2 = _interopRequireDefault(_defaultUnits);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

/**
 * Clones the object and adds a camel cased property version.
 */
function addCamelCasedVersion(obj) {
  var regExp = /(-[a-z])/g;
  var replace = function replace(str) {
    return str[1].toUpperCase();
  };
  var newObj = {};
  for (var key in obj) {
    newObj[key] = obj[key];
    newObj[key.replace(regExp, replace)] = obj[key];
  }
  return newObj;
}

var units = addCamelCasedVersion(_defaultUnits2['default']);

/**
 * Recursive deep style passing function
 *
 * @param {String} current property
 * @param {(Object|Array|Number|String)} property value
 * @param {Object} options
 * @return {(Object|Array|Number|String)} resulting value
 */
function iterate(prop, value, options) {
  if (!value) return value;

  var convertedValue = value;

  var type = typeof value === 'undefined' ? 'undefined' : _typeof(value);
  if (type === 'object' && Array.isArray(value)) type = 'array';

  switch (type) {
    case 'object':
      if (prop === 'fallbacks') {
        for (var innerProp in value) {
          value[innerProp] = iterate(innerProp, value[innerProp], options);
        }
        break;
      }
      for (var _innerProp in value) {
        value[_innerProp] = iterate(prop + '-' + _innerProp, value[_innerProp], options);
      }
      break;
    case 'array':
      for (var i = 0; i < value.length; i++) {
        value[i] = iterate(prop, value[i], options);
      }
      break;
    case 'number':
      if (value !== 0) {
        convertedValue = value + (options[prop] || units[prop] || '');
      }
      break;
    default:
      break;
  }

  return convertedValue;
}

/**
 * Add unit to numeric values.
 */
function defaultUnit() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var camelCasedOptions = addCamelCasedVersion(options);

  function onProcessStyle(style, rule) {
    if (rule.type !== 'style') return style;

    for (var prop in style) {
      style[prop] = iterate(prop, style[prop], camelCasedOptions);
    }

    return style;
  }

  function onChangeValue(value, prop) {
    return iterate(prop, value, camelCasedOptions);
  }

  return { onProcessStyle: onProcessStyle, onChangeValue: onChangeValue };
}

/***/ }),
/* 462 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * Generated jss-default-unit CSS property units
 *
 * @type object
 */
exports['default'] = {
  'animation-delay': 'ms',
  'animation-duration': 'ms',
  'background-position': 'px',
  'background-position-x': 'px',
  'background-position-y': 'px',
  'background-size': 'px',
  border: 'px',
  'border-bottom': 'px',
  'border-bottom-left-radius': 'px',
  'border-bottom-right-radius': 'px',
  'border-bottom-width': 'px',
  'border-left': 'px',
  'border-left-width': 'px',
  'border-radius': 'px',
  'border-right': 'px',
  'border-right-width': 'px',
  'border-spacing': 'px',
  'border-top': 'px',
  'border-top-left-radius': 'px',
  'border-top-right-radius': 'px',
  'border-top-width': 'px',
  'border-width': 'px',
  'border-after-width': 'px',
  'border-before-width': 'px',
  'border-end-width': 'px',
  'border-horizontal-spacing': 'px',
  'border-start-width': 'px',
  'border-vertical-spacing': 'px',
  bottom: 'px',
  'box-shadow': 'px',
  'column-gap': 'px',
  'column-rule': 'px',
  'column-rule-width': 'px',
  'column-width': 'px',
  'flex-basis': 'px',
  'font-size': 'px',
  'font-size-delta': 'px',
  height: 'px',
  left: 'px',
  'letter-spacing': 'px',
  'logical-height': 'px',
  'logical-width': 'px',
  margin: 'px',
  'margin-after': 'px',
  'margin-before': 'px',
  'margin-bottom': 'px',
  'margin-left': 'px',
  'margin-right': 'px',
  'margin-top': 'px',
  'max-height': 'px',
  'max-width': 'px',
  'margin-end': 'px',
  'margin-start': 'px',
  'mask-position-x': 'px',
  'mask-position-y': 'px',
  'mask-size': 'px',
  'max-logical-height': 'px',
  'max-logical-width': 'px',
  'min-height': 'px',
  'min-width': 'px',
  'min-logical-height': 'px',
  'min-logical-width': 'px',
  motion: 'px',
  'motion-offset': 'px',
  outline: 'px',
  'outline-offset': 'px',
  'outline-width': 'px',
  padding: 'px',
  'padding-bottom': 'px',
  'padding-left': 'px',
  'padding-right': 'px',
  'padding-top': 'px',
  'padding-after': 'px',
  'padding-before': 'px',
  'padding-end': 'px',
  'padding-start': 'px',
  'perspective-origin-x': '%',
  'perspective-origin-y': '%',
  perspective: 'px',
  right: 'px',
  'shape-margin': 'px',
  size: 'px',
  'text-indent': 'px',
  'text-stroke': 'px',
  'text-stroke-width': 'px',
  top: 'px',
  'transform-origin': '%',
  'transform-origin-x': '%',
  'transform-origin-y': '%',
  'transform-origin-z': '%',
  'transition-delay': 'ms',
  'transition-duration': 'ms',
  'vertical-align': 'px',
  width: 'px',
  'word-spacing': 'px',
  // Not existing properties.
  // Used to avoid issues with jss-expand intergration.
  'box-shadow-x': 'px',
  'box-shadow-y': 'px',
  'box-shadow-blur': 'px',
  'box-shadow-spread': 'px',
  'font-line-height': 'px',
  'text-shadow-x': 'px',
  'text-shadow-y': 'px',
  'text-shadow-blur': 'px'
};

/***/ }),
/* 463 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = jssVendorPrefixer;

var _cssVendor = __webpack_require__(464);

var vendor = _interopRequireWildcard(_cssVendor);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }

/**
 * Add vendor prefix to a property name when needed.
 *
 * @param {Rule} rule
 * @api public
 */
function jssVendorPrefixer() {
  function onProcessRule(rule) {
    if (rule.type === 'keyframes') {
      rule.key = '@' + vendor.prefix.css + rule.key.substr(1);
    }
  }

  function onProcessStyle(style, rule) {
    if (rule.type !== 'style') return style;

    for (var prop in style) {
      var value = style[prop];

      var changeProp = false;
      var supportedProp = vendor.supportedProperty(prop);
      if (supportedProp && supportedProp !== prop) changeProp = true;

      var changeValue = false;
      var supportedValue = vendor.supportedValue(supportedProp, value);
      if (supportedValue && supportedValue !== value) changeValue = true;

      if (changeProp || changeValue) {
        if (changeProp) delete style[prop];
        style[supportedProp || prop] = supportedValue || value;
      }
    }

    return style;
  }

  function onChangeValue(value, prop) {
    return vendor.supportedValue(prop, value);
  }

  return { onProcessRule: onProcessRule, onProcessStyle: onProcessStyle, onChangeValue: onChangeValue };
}

/***/ }),
/* 464 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.supportedValue = exports.supportedProperty = exports.prefix = undefined;

var _prefix = __webpack_require__(170);

var _prefix2 = _interopRequireDefault(_prefix);

var _supportedProperty = __webpack_require__(465);

var _supportedProperty2 = _interopRequireDefault(_supportedProperty);

var _supportedValue = __webpack_require__(467);

var _supportedValue2 = _interopRequireDefault(_supportedValue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = {
  prefix: _prefix2['default'],
  supportedProperty: _supportedProperty2['default'],
  supportedValue: _supportedValue2['default']
}; /**
    * CSS Vendor prefix detection and property feature testing.
    *
    * @copyright Oleg Slobodskoi 2015
    * @website https://github.com/jsstyles/css-vendor
    * @license MIT
    */

exports.prefix = _prefix2['default'];
exports.supportedProperty = _supportedProperty2['default'];
exports.supportedValue = _supportedValue2['default'];

/***/ }),
/* 465 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = supportedProperty;

var _isInBrowser = __webpack_require__(120);

var _isInBrowser2 = _interopRequireDefault(_isInBrowser);

var _prefix = __webpack_require__(170);

var _prefix2 = _interopRequireDefault(_prefix);

var _camelize = __webpack_require__(466);

var _camelize2 = _interopRequireDefault(_camelize);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var el = void 0;
var cache = {};

if (_isInBrowser2['default']) {
  el = document.createElement('p');

  /**
   * We test every property on vendor prefix requirement.
   * Once tested, result is cached. It gives us up to 70% perf boost.
   * http://jsperf.com/element-style-object-access-vs-plain-object
   *
   * Prefill cache with known css properties to reduce amount of
   * properties we need to feature test at runtime.
   * http://davidwalsh.name/vendor-prefix
   */
  var computed = window.getComputedStyle(document.documentElement, '');
  for (var key in computed) {
    if (!isNaN(key)) cache[computed[key]] = computed[key];
  }
}

/**
 * Test if a property is supported, returns supported property with vendor
 * prefix if required. Returns `false` if not supported.
 *
 * @param {String} prop dash separated
 * @return {String|Boolean}
 * @api public
 */
function supportedProperty(prop) {
  // For server-side rendering.
  if (!el) return prop;

  // We have not tested this prop yet, lets do the test.
  if (cache[prop] != null) return cache[prop];

  // Camelization is required because we can't test using
  // css syntax for e.g. in FF.
  // Test if property is supported as it is.
  if ((0, _camelize2['default'])(prop) in el.style) {
    cache[prop] = prop;
  }
  // Test if property is supported with vendor prefix.
  else if (_prefix2['default'].js + (0, _camelize2['default'])('-' + prop) in el.style) {
      cache[prop] = _prefix2['default'].css + prop;
    } else {
      cache[prop] = false;
    }

  return cache[prop];
}

/***/ }),
/* 466 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = camelize;
var regExp = /[-\s]+(.)?/g;

/**
 * Convert dash separated strings to camel cased.
 *
 * @param {String} str
 * @return {String}
 */
function camelize(str) {
  return str.replace(regExp, toUpper);
}

function toUpper(match, c) {
  return c ? c.toUpperCase() : '';
}

/***/ }),
/* 467 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = supportedValue;

var _isInBrowser = __webpack_require__(120);

var _isInBrowser2 = _interopRequireDefault(_isInBrowser);

var _prefix = __webpack_require__(170);

var _prefix2 = _interopRequireDefault(_prefix);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var cache = {};
var el = void 0;

if (_isInBrowser2['default']) el = document.createElement('p');

/**
 * Returns prefixed value if needed. Returns `false` if value is not supported.
 *
 * @param {String} property
 * @param {String} value
 * @return {String|Boolean}
 * @api public
 */
function supportedValue(property, value) {
  // For server-side rendering.
  if (!el) return value;

  // It is a string or a number as a string like '1'.
  // We want only prefixable values here.
  if (typeof value !== 'string' || !isNaN(parseInt(value, 10))) return value;

  var cacheKey = property + value;

  if (cache[cacheKey] != null) return cache[cacheKey];

  // IE can even throw an error in some cases, for e.g. style.content = 'bar'
  try {
    // Test value as it is.
    el.style[property] = value;
  } catch (err) {
    cache[cacheKey] = false;
    return false;
  }

  // Value is supported as it is.
  if (el.style[property] !== '') {
    cache[cacheKey] = value;
  } else {
    // Test value with vendor prefix.
    value = _prefix2['default'].css + value;

    // Hardcode test to convert "flex" to "-ms-flexbox" for IE10.
    if (value === '-ms-flex') value = '-ms-flexbox';

    el.style[property] = value;

    // Value is supported with vendor prefix.
    if (el.style[property] !== '') cache[cacheKey] = value;
  }

  if (!cache[cacheKey]) cache[cacheKey] = false;

  // Reset style value.
  el.style[property] = '';

  return cache[cacheKey];
}

/***/ }),
/* 468 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = jssPropsSort;
/**
 * Sort props by length.
 */
function jssPropsSort() {
  function sort(prop0, prop1) {
    return prop0.length - prop1.length;
  }

  function onProcessStyle(style, rule) {
    if (rule.type !== 'style') return style;

    var newStyle = {};
    var props = Object.keys(style).sort(sort);
    for (var prop in props) {
      newStyle[props[prop]] = style[props[prop]];
    }
    return newStyle;
  }

  return { onProcessStyle: onProcessStyle };
}

/***/ }),
/* 469 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*!
 * is-plain-object <https://github.com/jonschlinkert/is-plain-object>
 *
 * Copyright (c) 2014-2017, Jon Schlinkert.
 * Released under the MIT License.
 */



var isObject = __webpack_require__(470);

function isObjectObject(o) {
  return isObject(o) === true
    && Object.prototype.toString.call(o) === '[object Object]';
}

module.exports = function isPlainObject(o) {
  var ctor,prot;

  if (isObjectObject(o) === false) return false;

  // If has modified constructor
  ctor = o.constructor;
  if (typeof ctor !== 'function') return false;

  // If has modified prototype
  prot = ctor.prototype;
  if (isObjectObject(prot) === false) return false;

  // If constructor does not have an Object-specific method
  if (prot.hasOwnProperty('isPrototypeOf') === false) {
    return false;
  }

  // Most likely a plain Object
  return true;
};


/***/ }),
/* 470 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*!
 * isobject <https://github.com/jonschlinkert/isobject>
 *
 * Copyright (c) 2014-2017, Jon Schlinkert.
 * Released under the MIT License.
 */



module.exports = function isObject(val) {
  return val != null && typeof val === 'object' && Array.isArray(val) === false;
};


/***/ }),
/* 471 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(2);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = createMixins;

var _defineProperty2 = _interopRequireDefault(__webpack_require__(7));

var _objectSpread3 = _interopRequireDefault(__webpack_require__(17));

function createMixins(breakpoints, spacing, mixins) {
  var _toolbar;

  return (0, _objectSpread3.default)({
    gutters: function gutters() {
      var styles = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return (0, _objectSpread3.default)({
        paddingLeft: spacing.unit * 2,
        paddingRight: spacing.unit * 2
      }, styles, (0, _defineProperty2.default)({}, breakpoints.up('sm'), (0, _objectSpread3.default)({
        paddingLeft: spacing.unit * 3,
        paddingRight: spacing.unit * 3
      }, styles[breakpoints.up('sm')])));
    },
    toolbar: (_toolbar = {
      minHeight: 56
    }, (0, _defineProperty2.default)(_toolbar, "".concat(breakpoints.up('xs'), " and (orientation: landscape)"), {
      minHeight: 48
    }), (0, _defineProperty2.default)(_toolbar, breakpoints.up('sm'), {
      minHeight: 64
    }), _toolbar)
  }, mixins);
}

/***/ }),
/* 472 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(2);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = createPalette;
exports.dark = exports.light = void 0;

var _objectSpread2 = _interopRequireDefault(__webpack_require__(17));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(4));

var _warning = _interopRequireDefault(__webpack_require__(16));

var _deepmerge = _interopRequireDefault(__webpack_require__(121));

var _indigo = _interopRequireDefault(__webpack_require__(473));

var _pink = _interopRequireDefault(__webpack_require__(474));

var _grey = _interopRequireDefault(__webpack_require__(475));

var _red = _interopRequireDefault(__webpack_require__(476));

var _common = _interopRequireDefault(__webpack_require__(477));

var _colorManipulator = __webpack_require__(70);

// < 1kb payload overhead when lodash/merge is > 3kb.
var light = {
  // The colors used to style the text.
  text: {
    // The most important text.
    primary: 'rgba(0, 0, 0, 0.87)',
    // Secondary text.
    secondary: 'rgba(0, 0, 0, 0.54)',
    // Disabled text have even lower visual prominence.
    disabled: 'rgba(0, 0, 0, 0.38)',
    // Text hints.
    hint: 'rgba(0, 0, 0, 0.38)'
  },
  // The color used to divide different elements.
  divider: 'rgba(0, 0, 0, 0.12)',
  // The background colors used to style the surfaces.
  // Consistency between these values is important.
  background: {
    paper: _common.default.white,
    default: _grey.default[50]
  },
  // The colors used to style the action elements.
  action: {
    // The color of an active action like an icon button.
    active: 'rgba(0, 0, 0, 0.54)',
    // The color of an hovered action.
    hover: 'rgba(0, 0, 0, 0.08)',
    hoverOpacity: 0.08,
    // The color of a selected action.
    selected: 'rgba(0, 0, 0, 0.14)',
    // The color of a disabled action.
    disabled: 'rgba(0, 0, 0, 0.26)',
    // The background color of a disabled action.
    disabledBackground: 'rgba(0, 0, 0, 0.12)'
  }
};
exports.light = light;
var dark = {
  text: {
    primary: _common.default.white,
    secondary: 'rgba(255, 255, 255, 0.7)',
    disabled: 'rgba(255, 255, 255, 0.5)',
    hint: 'rgba(255, 255, 255, 0.5)',
    icon: 'rgba(255, 255, 255, 0.5)'
  },
  divider: 'rgba(255, 255, 255, 0.12)',
  background: {
    paper: _grey.default[800],
    default: '#303030'
  },
  action: {
    active: _common.default.white,
    hover: 'rgba(255, 255, 255, 0.1)',
    hoverOpacity: 0.1,
    selected: 'rgba(255, 255, 255, 0.2)',
    disabled: 'rgba(255, 255, 255, 0.3)',
    disabledBackground: 'rgba(255, 255, 255, 0.12)'
  }
};
exports.dark = dark;

function addLightOrDark(intent, direction, shade, tonalOffset) {
  if (!intent[direction]) {
    if (intent.hasOwnProperty(shade)) {
      intent[direction] = intent[shade];
    } else if (direction === 'light') {
      intent.light = (0, _colorManipulator.lighten)(intent.main, tonalOffset);
    } else if (direction === 'dark') {
      intent.dark = (0, _colorManipulator.darken)(intent.main, tonalOffset * 1.5);
    }
  }
}

function createPalette(palette) {
  var _palette$primary = palette.primary,
      primary = _palette$primary === void 0 ? {
    light: _indigo.default[300],
    main: _indigo.default[500],
    dark: _indigo.default[700]
  } : _palette$primary,
      _palette$secondary = palette.secondary,
      secondary = _palette$secondary === void 0 ? {
    light: _pink.default.A200,
    main: _pink.default.A400,
    dark: _pink.default.A700
  } : _palette$secondary,
      _palette$error = palette.error,
      error = _palette$error === void 0 ? {
    light: _red.default[300],
    main: _red.default[500],
    dark: _red.default[700]
  } : _palette$error,
      _palette$type = palette.type,
      type = _palette$type === void 0 ? 'light' : _palette$type,
      _palette$contrastThre = palette.contrastThreshold,
      contrastThreshold = _palette$contrastThre === void 0 ? 3 : _palette$contrastThre,
      _palette$tonalOffset = palette.tonalOffset,
      tonalOffset = _palette$tonalOffset === void 0 ? 0.2 : _palette$tonalOffset,
      other = (0, _objectWithoutProperties2.default)(palette, ["primary", "secondary", "error", "type", "contrastThreshold", "tonalOffset"]);

  function getContrastText(background) {
    // Use the same logic as
    // Bootstrap: https://github.com/twbs/bootstrap/blob/1d6e3710dd447de1a200f29e8fa521f8a0908f70/scss/_functions.scss#L59
    // and material-components-web https://github.com/material-components/material-components-web/blob/ac46b8863c4dab9fc22c4c662dc6bd1b65dd652f/packages/mdc-theme/_functions.scss#L54
    var contrastText = (0, _colorManipulator.getContrastRatio)(background, dark.text.primary) >= contrastThreshold ? dark.text.primary : light.text.primary;

    if (false) {
      var contrast = (0, _colorManipulator.getContrastRatio)(background, contrastText);
      process.env.NODE_ENV !== "production" ? (0, _warning.default)(contrast >= 3, ["Material-UI: the contrast ratio of ".concat(contrast, ":1 for ").concat(contrastText, " on ").concat(background), 'falls below the WACG recommended absolute minimum contrast ratio of 3:1.', 'https://www.w3.org/TR/2008/REC-WCAG20-20081211/#visual-audio-contrast-contrast'].join('\n')) : void 0;
    }

    return contrastText;
  }

  function augmentColor(color) {
    var mainShade = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 500;
    var lightShade = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 300;
    var darkShade = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 700;

    if (!color.main && color[mainShade]) {
      color.main = color[mainShade];
    }

    if (false) {
      throw new Error(['Material-UI: the color provided to augmentColor(color) is invalid.', "The color object needs to have a `main` property or a `".concat(mainShade, "` property.")].join('\n'));
    }

    addLightOrDark(color, 'light', lightShade, tonalOffset);
    addLightOrDark(color, 'dark', darkShade, tonalOffset);

    if (!color.contrastText) {
      color.contrastText = getContrastText(color.main);
    }
  }

  augmentColor(primary);
  augmentColor(secondary, 'A400', 'A200', 'A700');
  augmentColor(error);
  var types = {
    dark: dark,
    light: light
  };
   false ? (0, _warning.default)(types[type], "Material-UI: the palette type `".concat(type, "` is not supported.")) : void 0;
  var paletteOutput = (0, _deepmerge.default)((0, _objectSpread2.default)({
    // A collection of common colors.
    common: _common.default,
    // The palette type, can be light or dark.
    type: type,
    // The colors used to represent primary interface elements for a user.
    primary: primary,
    // The colors used to represent secondary interface elements for a user.
    secondary: secondary,
    // The colors used to represent interface elements that the user should be made aware of.
    error: error,
    // The grey colors.
    grey: _grey.default,
    // Used by `getContrastText()` to maximize the contrast between the background and
    // the text.
    contrastThreshold: contrastThreshold,
    // Take a background color and return the color of the text to maximize the contrast.
    getContrastText: getContrastText,
    // Generate a rich color object.
    augmentColor: augmentColor,
    // Used by the functions below to shift a color's luminance by approximately
    // two indexes within its tonal palette.
    // E.g., shift from Red 500 to Red 300 or Red 700.
    tonalOffset: tonalOffset
  }, types[type]), other, {
    clone: false // No need to clone deep

  });
  return paletteOutput;
}

/***/ }),
/* 473 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var indigo = {
  50: '#e8eaf6',
  100: '#c5cae9',
  200: '#9fa8da',
  300: '#7986cb',
  400: '#5c6bc0',
  500: '#3f51b5',
  600: '#3949ab',
  700: '#303f9f',
  800: '#283593',
  900: '#1a237e',
  A100: '#8c9eff',
  A200: '#536dfe',
  A400: '#3d5afe',
  A700: '#304ffe'
};
var _default = indigo;
exports.default = _default;

/***/ }),
/* 474 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var pink = {
  50: '#fce4ec',
  100: '#f8bbd0',
  200: '#f48fb1',
  300: '#f06292',
  400: '#ec407a',
  500: '#e91e63',
  600: '#d81b60',
  700: '#c2185b',
  800: '#ad1457',
  900: '#880e4f',
  A100: '#ff80ab',
  A200: '#ff4081',
  A400: '#f50057',
  A700: '#c51162'
};
var _default = pink;
exports.default = _default;

/***/ }),
/* 475 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var grey = {
  50: '#fafafa',
  100: '#f5f5f5',
  200: '#eeeeee',
  300: '#e0e0e0',
  400: '#bdbdbd',
  500: '#9e9e9e',
  600: '#757575',
  700: '#616161',
  800: '#424242',
  900: '#212121',
  A100: '#d5d5d5',
  A200: '#aaaaaa',
  A400: '#303030',
  A700: '#616161'
};
var _default = grey;
exports.default = _default;

/***/ }),
/* 476 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var red = {
  50: '#ffebee',
  100: '#ffcdd2',
  200: '#ef9a9a',
  300: '#e57373',
  400: '#ef5350',
  500: '#f44336',
  600: '#e53935',
  700: '#d32f2f',
  800: '#c62828',
  900: '#b71c1c',
  A100: '#ff8a80',
  A200: '#ff5252',
  A400: '#ff1744',
  A700: '#d50000'
};
var _default = red;
exports.default = _default;

/***/ }),
/* 477 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var common = {
  black: '#000',
  white: '#fff'
};
var _default = common;
exports.default = _default;

/***/ }),
/* 478 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(2);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = createTypography;

var _objectSpread2 = _interopRequireDefault(__webpack_require__(17));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(4));

var _deepmerge = _interopRequireDefault(__webpack_require__(121));

// < 1kb payload overhead when lodash/merge is > 3kb.
function round(value) {
  return Math.round(value * 1e5) / 1e5;
}

function createTypography(palette, typography) {
  var _ref = typeof typography === 'function' ? typography(palette) : typography,
      _ref$fontFamily = _ref.fontFamily,
      fontFamily = _ref$fontFamily === void 0 ? '"Roboto", "Helvetica", "Arial", sans-serif' : _ref$fontFamily,
      _ref$fontSize = _ref.fontSize,
      fontSize = _ref$fontSize === void 0 ? 14 : _ref$fontSize,
      _ref$fontWeightLight = _ref.fontWeightLight,
      fontWeightLight = _ref$fontWeightLight === void 0 ? 300 : _ref$fontWeightLight,
      _ref$fontWeightRegula = _ref.fontWeightRegular,
      fontWeightRegular = _ref$fontWeightRegula === void 0 ? 400 : _ref$fontWeightRegula,
      _ref$fontWeightMedium = _ref.fontWeightMedium,
      fontWeightMedium = _ref$fontWeightMedium === void 0 ? 500 : _ref$fontWeightMedium,
      _ref$htmlFontSize = _ref.htmlFontSize,
      htmlFontSize = _ref$htmlFontSize === void 0 ? 16 : _ref$htmlFontSize,
      allVariants = _ref.allVariants,
      other = (0, _objectWithoutProperties2.default)(_ref, ["fontFamily", "fontSize", "fontWeightLight", "fontWeightRegular", "fontWeightMedium", "htmlFontSize", "allVariants"]);

  var coef = fontSize / 14;

  function pxToRem(value) {
    return "".concat(value / htmlFontSize * coef, "rem");
  }

  return (0, _deepmerge.default)({
    pxToRem: pxToRem,
    round: round,
    fontFamily: fontFamily,
    fontSize: fontSize,
    fontWeightLight: fontWeightLight,
    fontWeightRegular: fontWeightRegular,
    fontWeightMedium: fontWeightMedium,
    display4: (0, _objectSpread2.default)({
      fontSize: pxToRem(112),
      fontWeight: fontWeightLight,
      fontFamily: fontFamily,
      letterSpacing: '-.04em',
      lineHeight: "".concat(round(128 / 112), "em"),
      marginLeft: '-.04em',
      color: palette.text.secondary
    }, allVariants),
    display3: (0, _objectSpread2.default)({
      fontSize: pxToRem(56),
      fontWeight: fontWeightRegular,
      fontFamily: fontFamily,
      letterSpacing: '-.02em',
      lineHeight: "".concat(round(73 / 56), "em"),
      marginLeft: '-.02em',
      color: palette.text.secondary
    }, allVariants),
    display2: (0, _objectSpread2.default)({
      fontSize: pxToRem(45),
      fontWeight: fontWeightRegular,
      fontFamily: fontFamily,
      lineHeight: "".concat(round(51 / 45), "em"),
      marginLeft: '-.02em',
      color: palette.text.secondary
    }, allVariants),
    display1: (0, _objectSpread2.default)({
      fontSize: pxToRem(34),
      fontWeight: fontWeightRegular,
      fontFamily: fontFamily,
      lineHeight: "".concat(round(41 / 34), "em"),
      color: palette.text.secondary
    }, allVariants),
    headline: (0, _objectSpread2.default)({
      fontSize: pxToRem(24),
      fontWeight: fontWeightRegular,
      fontFamily: fontFamily,
      lineHeight: "".concat(round(32.5 / 24), "em"),
      color: palette.text.primary
    }, allVariants),
    title: (0, _objectSpread2.default)({
      fontSize: pxToRem(21),
      fontWeight: fontWeightMedium,
      fontFamily: fontFamily,
      lineHeight: "".concat(round(24.5 / 21), "em"),
      color: palette.text.primary
    }, allVariants),
    subheading: (0, _objectSpread2.default)({
      fontSize: pxToRem(16),
      fontWeight: fontWeightRegular,
      fontFamily: fontFamily,
      lineHeight: "".concat(round(24 / 16), "em"),
      color: palette.text.primary
    }, allVariants),
    body2: (0, _objectSpread2.default)({
      fontSize: pxToRem(14),
      fontWeight: fontWeightMedium,
      fontFamily: fontFamily,
      lineHeight: "".concat(round(24 / 14), "em"),
      color: palette.text.primary
    }, allVariants),
    body1: (0, _objectSpread2.default)({
      fontSize: pxToRem(14),
      fontWeight: fontWeightRegular,
      fontFamily: fontFamily,
      lineHeight: "".concat(round(20.5 / 14), "em"),
      color: palette.text.primary
    }, allVariants),
    caption: (0, _objectSpread2.default)({
      fontSize: pxToRem(12),
      fontWeight: fontWeightRegular,
      fontFamily: fontFamily,
      lineHeight: "".concat(round(16.5 / 12), "em"),
      color: palette.text.secondary
    }, allVariants),
    button: (0, _objectSpread2.default)({
      fontSize: pxToRem(14),
      textTransform: 'uppercase',
      fontWeight: fontWeightMedium,
      fontFamily: fontFamily,
      color: palette.text.primary
    }, allVariants)
  }, other, {
    clone: false // No need to clone deep

  });
}

/***/ }),
/* 479 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var shadowKeyUmbraOpacity = 0.2;
var shadowKeyPenumbraOpacity = 0.14;
var shadowAmbientShadowOpacity = 0.12;

function createShadow() {
  return ["".concat(arguments.length <= 0 ? undefined : arguments[0], "px ").concat(arguments.length <= 1 ? undefined : arguments[1], "px ").concat(arguments.length <= 2 ? undefined : arguments[2], "px ").concat(arguments.length <= 3 ? undefined : arguments[3], "px rgba(0, 0, 0, ").concat(shadowKeyUmbraOpacity, ")"), "".concat(arguments.length <= 4 ? undefined : arguments[4], "px ").concat(arguments.length <= 5 ? undefined : arguments[5], "px ").concat(arguments.length <= 6 ? undefined : arguments[6], "px ").concat(arguments.length <= 7 ? undefined : arguments[7], "px rgba(0, 0, 0, ").concat(shadowKeyPenumbraOpacity, ")"), "".concat(arguments.length <= 8 ? undefined : arguments[8], "px ").concat(arguments.length <= 9 ? undefined : arguments[9], "px ").concat(arguments.length <= 10 ? undefined : arguments[10], "px ").concat(arguments.length <= 11 ? undefined : arguments[11], "px rgba(0, 0, 0, ").concat(shadowAmbientShadowOpacity, ")")].join(',');
}

var shadows = ['none', createShadow(0, 1, 3, 0, 0, 1, 1, 0, 0, 2, 1, -1), createShadow(0, 1, 5, 0, 0, 2, 2, 0, 0, 3, 1, -2), createShadow(0, 1, 8, 0, 0, 3, 4, 0, 0, 3, 3, -2), createShadow(0, 2, 4, -1, 0, 4, 5, 0, 0, 1, 10, 0), createShadow(0, 3, 5, -1, 0, 5, 8, 0, 0, 1, 14, 0), createShadow(0, 3, 5, -1, 0, 6, 10, 0, 0, 1, 18, 0), createShadow(0, 4, 5, -2, 0, 7, 10, 1, 0, 2, 16, 1), createShadow(0, 5, 5, -3, 0, 8, 10, 1, 0, 3, 14, 2), createShadow(0, 5, 6, -3, 0, 9, 12, 1, 0, 3, 16, 2), createShadow(0, 6, 6, -3, 0, 10, 14, 1, 0, 4, 18, 3), createShadow(0, 6, 7, -4, 0, 11, 15, 1, 0, 4, 20, 3), createShadow(0, 7, 8, -4, 0, 12, 17, 2, 0, 5, 22, 4), createShadow(0, 7, 8, -4, 0, 13, 19, 2, 0, 5, 24, 4), createShadow(0, 7, 9, -4, 0, 14, 21, 2, 0, 5, 26, 4), createShadow(0, 8, 9, -5, 0, 15, 22, 2, 0, 6, 28, 5), createShadow(0, 8, 10, -5, 0, 16, 24, 2, 0, 6, 30, 5), createShadow(0, 8, 11, -5, 0, 17, 26, 2, 0, 6, 32, 5), createShadow(0, 9, 11, -5, 0, 18, 28, 2, 0, 7, 34, 6), createShadow(0, 9, 12, -6, 0, 19, 29, 2, 0, 7, 36, 6), createShadow(0, 10, 13, -6, 0, 20, 31, 3, 0, 8, 38, 7), createShadow(0, 10, 13, -6, 0, 21, 33, 3, 0, 8, 40, 7), createShadow(0, 10, 14, -6, 0, 22, 35, 3, 0, 8, 42, 7), createShadow(0, 11, 14, -7, 0, 23, 36, 3, 0, 9, 44, 8), createShadow(0, 11, 15, -7, 0, 24, 38, 3, 0, 9, 46, 8)];
var _default = shadows;
exports.default = _default;

/***/ }),
/* 480 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var shape = {
  borderRadius: 4
};
var _default = shape;
exports.default = _default;

/***/ }),
/* 481 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var spacing = {
  // All components align to an 8dp square baseline grid for mobile, tablet, and desktop.
  // https://material.io/design/layout/understanding-layout.html#pixel-density
  unit: 8
};
var _default = spacing;
exports.default = _default;

/***/ }),
/* 482 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
// We need to centralize the zIndex definitions as they work
// like global values in the browser.
var zIndex = {
  mobileStepper: 1000,
  appBar: 1100,
  drawer: 1200,
  modal: 1300,
  snackbar: 1400,
  tooltip: 1500
};
var _default = zIndex;
exports.default = _default;

/***/ }),
/* 483 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(2);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectSpread2 = _interopRequireDefault(__webpack_require__(17));

var _typeof2 = _interopRequireDefault(__webpack_require__(166));

var _warning = _interopRequireDefault(__webpack_require__(16));

var _deepmerge = _interopRequireDefault(__webpack_require__(121));

// < 1kb payload overhead when lodash/merge is > 3kb.
// Support for the jss-expand plugin.
function arrayMerge(destination, source) {
  return source;
}

function getStylesCreator(stylesOrCreator) {
  var themingEnabled = typeof stylesOrCreator === 'function';
   false ? (0, _warning.default)((0, _typeof2.default)(stylesOrCreator) === 'object' || themingEnabled, ['Material-UI: the first argument provided to withStyles() is invalid.', 'You need to provide a function generating the styles or a styles object.'].join('\n')) : void 0;

  function create(theme, name) {
    var styles = themingEnabled ? stylesOrCreator(theme) : stylesOrCreator;

    if (!name || !theme.overrides || !theme.overrides[name]) {
      return styles;
    }

    var overrides = theme.overrides[name];
    var stylesWithOverrides = (0, _objectSpread2.default)({}, styles);
    Object.keys(overrides).forEach(function (key) {
       false ? (0, _warning.default)(stylesWithOverrides[key], ['Material-UI: you are trying to override a style that does not exist.', "Fix the `".concat(key, "` key of `theme.overrides.").concat(name, "`.")].join('\n')) : void 0;
      stylesWithOverrides[key] = (0, _deepmerge.default)(stylesWithOverrides[key], overrides[key], {
        arrayMerge: arrayMerge
      });
    });
    return stylesWithOverrides;
  }

  return {
    create: create,
    options: {},
    themingEnabled: themingEnabled
  };
}

var _default = getStylesCreator;
exports.default = _default;

/***/ }),
/* 484 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 485 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(165);

var _interopRequireDefault = __webpack_require__(2);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectSpread2 = _interopRequireDefault(__webpack_require__(17));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(7));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(11));

var _createClass2 = _interopRequireDefault(__webpack_require__(12));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(13));

var _inherits2 = _interopRequireDefault(__webpack_require__(14));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _warning = _interopRequireDefault(__webpack_require__(16));

var _brcast = _interopRequireDefault(__webpack_require__(486));

var _themeListener = _interopRequireWildcard(__webpack_require__(172));

var _exactProp = _interopRequireDefault(__webpack_require__(95));

/**
 * This component takes a `theme` property.
 * It makes the `theme` available down the React tree thanks to React context.
 * This component should preferably be used at **the root of your component tree**.
 */
var MuiThemeProvider =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(MuiThemeProvider, _React$Component);

  // We are not using the React state in order to avoid unnecessary rerender.
  function MuiThemeProvider(props, context) {
    var _this;

    (0, _classCallCheck2.default)(this, MuiThemeProvider);
    _this = (0, _possibleConstructorReturn2.default)(this, (MuiThemeProvider.__proto__ || Object.getPrototypeOf(MuiThemeProvider)).call(this, props, context)); // Get the outer theme from the context, can be null

    _this.broadcast = (0, _brcast.default)();
    _this.unsubscribeId = null;
    _this.outerTheme = null;
    _this.outerTheme = _themeListener.default.initial(context); // Propagate the theme so it can be accessed by the children

    _this.broadcast.setState(_this.mergeOuterLocalTheme(_this.props.theme));

    return _this;
  }

  (0, _createClass2.default)(MuiThemeProvider, [{
    key: "getChildContext",
    value: function getChildContext() {
      var _ref;

      var _props = this.props,
          sheetsManager = _props.sheetsManager,
          disableStylesGeneration = _props.disableStylesGeneration;
      var muiThemeProviderOptions = this.context.muiThemeProviderOptions || {};

      if (sheetsManager !== undefined) {
        muiThemeProviderOptions.sheetsManager = sheetsManager;
      }

      if (disableStylesGeneration !== undefined) {
        muiThemeProviderOptions.disableStylesGeneration = disableStylesGeneration;
      }

      return _ref = {}, (0, _defineProperty2.default)(_ref, _themeListener.CHANNEL, this.broadcast), (0, _defineProperty2.default)(_ref, "muiThemeProviderOptions", muiThemeProviderOptions), _ref;
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      // Subscribe on the outer theme, if present
      this.unsubscribeId = _themeListener.default.subscribe(this.context, function (outerTheme) {
        _this2.outerTheme = outerTheme; // Forward the parent theme update to the children

        _this2.broadcast.setState(_this2.mergeOuterLocalTheme(_this2.props.theme));
      });
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      // Propagate a local theme update
      if (this.props.theme !== prevProps.theme) {
        this.broadcast.setState(this.mergeOuterLocalTheme(this.props.theme));
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.unsubscribeId !== null) {
        _themeListener.default.unsubscribe(this.context, this.unsubscribeId);
      }
    } // Simple merge between the outer theme and the local theme

  }, {
    key: "mergeOuterLocalTheme",
    value: function mergeOuterLocalTheme(localTheme) {
      // To support composition of theme.
      if (typeof localTheme === 'function') {
         false ? (0, _warning.default)(this.outerTheme, ['Material-UI: you are providing a theme function property ' + 'to the MuiThemeProvider component:', '<MuiThemeProvider theme={outerTheme => outerTheme} />', 'However, no outer theme is present.', 'Make sure a theme is already injected higher in the React tree ' + 'or provide a theme object.'].join('\n')) : void 0;
        return localTheme(this.outerTheme);
      }

      if (!this.outerTheme) {
        return localTheme;
      }

      return (0, _objectSpread2.default)({}, this.outerTheme, localTheme);
    }
  }, {
    key: "render",
    value: function render() {
      // TODO move the sheetsManager property to a different component.
      // warning(
      //   typeof window !== 'undefined' || this.props.sheetsManager,
      //   [
      //     'Material-UI: you need to provide a sheetsManager to the MuiThemeProvider ' +
      //       'when rendering on the server.',
      //     'If you do not, you might experience a memory leak',
      //   ].join('\n'),
      // );
      return this.props.children;
    }
  }]);
  return MuiThemeProvider;
}(_react.default.Component);

MuiThemeProvider.propTypes =  false ? {
  /**
   * You can wrap a node.
   */
  children: _propTypes.default.node.isRequired,

  /**
   * You can disable the generation of the styles with this option.
   * It can be useful when traversing the React tree outside of the HTML
   * rendering step on the server.
   * Let's say you are using react-apollo to extract all
   * the queries made by the interface server side.
   * You can significantly speed up the traversal with this property.
   */
  disableStylesGeneration: _propTypes.default.bool,

  /**
   * The sheetsManager is used to deduplicate style sheet injection in the page.
   * It's deduplicating using the (theme, styles) couple.
   * On the server, you should provide a new instance for each request.
   */
  sheetsManager: _propTypes.default.object,

  /**
   * A theme object.
   */
  theme: _propTypes.default.oneOfType([_propTypes.default.object, _propTypes.default.func]).isRequired
} : {};
MuiThemeProvider.propTypes =  false ? (0, _exactProp.default)(MuiThemeProvider.propTypes) : {};
MuiThemeProvider.childContextTypes = (0, _objectSpread2.default)({}, _themeListener.default.contextTypes, {
  muiThemeProviderOptions: _propTypes.default.object
});
MuiThemeProvider.contextTypes = (0, _objectSpread2.default)({}, _themeListener.default.contextTypes, {
  muiThemeProviderOptions: _propTypes.default.object
});
var _default = MuiThemeProvider;
exports.default = _default;

/***/ }),
/* 486 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
function createBroadcast (initialState) {
  var listeners = {};
  var id = 1;
  var _state = initialState;

  function getState () {
    return _state
  }

  function setState (state) {
    _state = state;
    var keys = Object.keys(listeners);
    var i = 0;
    var len = keys.length;
    for (; i < len; i++) {
      // if a listener gets unsubscribed during setState we just skip it
      if (listeners[keys[i]]) { listeners[keys[i]](state); }
    }
  }

  // subscribe to changes and return the subscriptionId
  function subscribe (listener) {
    if (typeof listener !== 'function') {
      throw new Error('listener must be a function.')
    }
    var currentId = id;
    listeners[currentId] = listener;
    id += 1;
    return currentId
  }

  // remove subscription by removing the listener function
  function unsubscribe (id) {
    listeners[id] = undefined;
  }

  return { getState: getState, setState: setState, subscribe: subscribe, unsubscribe: unsubscribe }
}

/* harmony default export */ __webpack_exports__["default"] = (createBroadcast);


/***/ }),
/* 487 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = createStyles;

function createStyles(s) {
  return s;
}

/***/ }),
/* 488 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__material_ui_core_colors_amber__ = __webpack_require__(489);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__material_ui_core_colors_amber___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__material_ui_core_colors_amber__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__material_ui_icons_CheckCircle__ = __webpack_require__(490);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__material_ui_icons_CheckCircle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__material_ui_icons_CheckCircle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_icons_Close__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_icons_Close___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__material_ui_icons_Close__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_icons_Error__ = __webpack_require__(496);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_icons_Error___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__material_ui_icons_Error__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_IconButton__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_IconButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_IconButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_icons_Info__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_icons_Info___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__material_ui_icons_Info__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_colors_green__ = __webpack_require__(507);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_colors_green___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_colors_green__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__material_ui_core_SnackbarContent__ = __webpack_require__(246);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__material_ui_core_SnackbarContent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_SnackbarContent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__material_ui_icons_Warning__ = __webpack_require__(511);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__material_ui_icons_Warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__material_ui_icons_Warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__material_ui_core_styles__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__material_ui_core_styles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__material_ui_core_styles__);
function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}var variantIcon={error:__WEBPACK_IMPORTED_MODULE_4__material_ui_icons_Error___default.a,info:__WEBPACK_IMPORTED_MODULE_6__material_ui_icons_Info___default.a,success:__WEBPACK_IMPORTED_MODULE_1__material_ui_icons_CheckCircle___default.a,warning:__WEBPACK_IMPORTED_MODULE_11__material_ui_icons_Warning___default.a};var styles=function styles(theme){return{success:{backgroundColor:__WEBPACK_IMPORTED_MODULE_7__material_ui_core_colors_green___default.a[600]},error:{backgroundColor:theme.palette.error.dark},info:{backgroundColor:theme.palette.primary.dark},warning:{backgroundColor:__WEBPACK_IMPORTED_MODULE_0__material_ui_core_colors_amber___default.a[700]},icon:{fontSize:20},iconVariant:{opacity:0.9,marginRight:theme.spacing.unit},message:{display:'flex',alignItems:'center'},root:{marginTop:"10px"}};};var AlertContent=function AlertContent(props){var classes=props.classes,className=props.className,message=props.message,onClose=props.onClose,variant=props.variant,other=_objectWithoutProperties(props,['classes','className','message','onClose','variant']);var Icon=variantIcon[variant];return __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_SnackbarContent___default.a,Object.assign({action:[__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_IconButton___default.a,{'aria-label':'Close',className:classes.close,color:'inherit',key:'close',onClick:onClose},__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_icons_Close___default.a,{className:classes.icon}))],'aria-describedby':'client-snackbar',classes:{root:classes.root},className:__WEBPACK_IMPORTED_MODULE_3_classnames___default()(classes[variant],className),message:__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement('span',{className:classes.message,id:'client-snackbar'},__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(Icon,{className:__WEBPACK_IMPORTED_MODULE_3_classnames___default()(classes.icon,classes.iconVariant)}),message)},other));};AlertContent.propTypes={classes:__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.object.isRequired,className:__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.string,message:__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.node,onClose:__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func,variant:__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.oneOf(['error',// vermelho
'info',// azul
'success',// verde
'warning']// amarelo
).isRequired};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_12__material_ui_core_styles__["withStyles"])(styles)(AlertContent));

/***/ }),
/* 489 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var amber = {
  50: '#fff8e1',
  100: '#ffecb3',
  200: '#ffe082',
  300: '#ffd54f',
  400: '#ffca28',
  500: '#ffc107',
  600: '#ffb300',
  700: '#ffa000',
  800: '#ff8f00',
  900: '#ff6f00',
  A100: '#ffe57f',
  A200: '#ffd740',
  A400: '#ffc400',
  A700: '#ffab00'
};
var _default = amber;
exports.default = _default;

/***/ }),
/* 490 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(9);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(10));

var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
  fill: "none",
  d: "M0 0h24v24H0z"
}), _react.default.createElement("path", {
  d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"
})), 'CheckCircle');

exports.default = _default;

/***/ }),
/* 491 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(90);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(492));

var _react = __webpack_require__(0);

var _setDisplayName = _interopRequireDefault(__webpack_require__(242));

var _wrapDisplayName = _interopRequireDefault(__webpack_require__(89));

var shouldUpdate = function shouldUpdate(test) {
  return function (BaseComponent) {
    var factory = (0, _react.createFactory)(BaseComponent);

    var ShouldUpdate =
    /*#__PURE__*/
    function (_Component) {
      (0, _inheritsLoose2.default)(ShouldUpdate, _Component);

      function ShouldUpdate() {
        return _Component.apply(this, arguments) || this;
      }

      var _proto = ShouldUpdate.prototype;

      _proto.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
        return test(this.props, nextProps);
      };

      _proto.render = function render() {
        return factory(this.props);
      };

      return ShouldUpdate;
    }(_react.Component);

    if (false) {
      return (0, _setDisplayName.default)((0, _wrapDisplayName.default)(BaseComponent, 'shouldUpdate'))(ShouldUpdate);
    }

    return ShouldUpdate;
  };
};

var _default = shouldUpdate;
exports.default = _default;

/***/ }),
/* 492 */
/***/ (function(module, exports) {

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

module.exports = _inheritsLoose;

/***/ }),
/* 493 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var setStatic = function setStatic(key, value) {
  return function (BaseComponent) {
    /* eslint-disable no-param-reassign */
    BaseComponent[key] = value;
    /* eslint-enable no-param-reassign */

    return BaseComponent;
  };
};

var _default = setStatic;
exports.default = _default;

/***/ }),
/* 494 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(90);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _shallowEqual = _interopRequireDefault(__webpack_require__(158));

var _default = _shallowEqual.default;
exports.default = _default;

/***/ }),
/* 495 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(2);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(6));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(7));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(4));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _classnames = _interopRequireDefault(__webpack_require__(5));

var _withStyles = _interopRequireDefault(__webpack_require__(3));

var _helpers = __webpack_require__(37);

var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      userSelect: 'none',
      width: '1em',
      height: '1em',
      display: 'inline-block',
      fill: 'currentColor',
      flexShrink: 0,
      fontSize: 24,
      transition: theme.transitions.create('fill', {
        duration: theme.transitions.duration.shorter
      })
    },

    /* Styles applied to the root element if `color="primary"`. */
    colorPrimary: {
      color: theme.palette.primary.main
    },

    /* Styles applied to the root element if `color="secondary"`. */
    colorSecondary: {
      color: theme.palette.secondary.main
    },

    /* Styles applied to the root element if `color="saction"`. */
    colorAction: {
      color: theme.palette.action.active
    },

    /* Styles applied to the root element if `color="error"`. */
    colorError: {
      color: theme.palette.error.main
    },

    /* Styles applied to the root element if `color="disabled"`. */
    colorDisabled: {
      color: theme.palette.action.disabled
    },

    /* Styles applied to the root element if `fontSize="inherit"`. */
    fontSizeInherit: {
      fontSize: 'inherit'
    }
  };
};

exports.styles = styles;

function SvgIcon(props) {
  var _classNames;

  var children = props.children,
      classes = props.classes,
      classNameProp = props.className,
      color = props.color,
      Component = props.component,
      fontSize = props.fontSize,
      nativeColor = props.nativeColor,
      titleAccess = props.titleAccess,
      viewBox = props.viewBox,
      other = (0, _objectWithoutProperties2.default)(props, ["children", "classes", "className", "color", "component", "fontSize", "nativeColor", "titleAccess", "viewBox"]);
  var className = (0, _classnames.default)(classes.root, (_classNames = {}, (0, _defineProperty2.default)(_classNames, classes.fontSizeInherit, fontSize === 'inherit'), (0, _defineProperty2.default)(_classNames, classes["color".concat((0, _helpers.capitalize)(color))], color !== 'inherit'), _classNames), classNameProp);
  return _react.default.createElement(Component, (0, _extends2.default)({
    className: className,
    focusable: "false",
    viewBox: viewBox,
    color: nativeColor,
    "aria-hidden": titleAccess ? 'false' : 'true'
  }, other), children, titleAccess ? _react.default.createElement("title", null, titleAccess) : null);
}

SvgIcon.propTypes =  false ? {
  /**
   * Node passed into the SVG element.
   */
  children: _propTypes.default.node.isRequired,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * The color of the component. It supports those theme colors that make sense for this component.
   * You can use the `nativeColor` property to apply a color attribute to the SVG element.
   */
  color: _propTypes.default.oneOf(['inherit', 'primary', 'secondary', 'action', 'error', 'disabled']),

  /**
   * The component used for the root node.
   * Either a string to use a DOM element or a component.
   */
  component: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func, _propTypes.default.object]),

  /**
   * The fontSize applied to the icon. Defaults to 24px, but can be configure to inherit font size.
   */
  fontSize: _propTypes.default.oneOf(['inherit', 'default']),

  /**
   * Applies a color attribute to the SVG element.
   */
  nativeColor: _propTypes.default.string,

  /**
   * Provides a human-readable title for the element that contains it.
   * https://www.w3.org/TR/SVG-access/#Equivalent
   */
  titleAccess: _propTypes.default.string,

  /**
   * Allows you to redefine what the coordinates without units mean inside an SVG element.
   * For example, if the SVG element is 500 (width) by 200 (height),
   * and you pass viewBox="0 0 50 20",
   * this means that the coordinates inside the SVG will go from the top left corner (0,0)
   * to bottom right (50,20) and each unit will be worth 10px.
   */
  viewBox: _propTypes.default.string
} : {};
SvgIcon.defaultProps = {
  color: 'inherit',
  component: 'svg',
  fontSize: 'default',
  viewBox: '0 0 24 24'
};
SvgIcon.muiName = 'SvgIcon';

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiSvgIcon'
})(SvgIcon);

exports.default = _default;

/***/ }),
/* 496 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(9);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(10));

var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
  fill: "none",
  d: "M0 0h24v24H0z"
}), _react.default.createElement("path", {
  d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z"
})), 'Error');

exports.default = _default;

/***/ }),
/* 497 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(2);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(6));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(7));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(4));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _classnames = _interopRequireDefault(__webpack_require__(5));

var _withStyles = _interopRequireDefault(__webpack_require__(3));

var _colorManipulator = __webpack_require__(70);

var _ButtonBase = _interopRequireDefault(__webpack_require__(124));

var _helpers = __webpack_require__(37);

// @inheritedComponent ButtonBase
var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      textAlign: 'center',
      flex: '0 0 auto',
      fontSize: theme.typography.pxToRem(24),
      width: 48,
      height: 48,
      padding: 0,
      borderRadius: '50%',
      color: theme.palette.action.active,
      transition: theme.transitions.create('background-color', {
        duration: theme.transitions.duration.shortest
      }),
      '&:hover': {
        backgroundColor: (0, _colorManipulator.fade)(theme.palette.action.active, theme.palette.action.hoverOpacity),
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
          backgroundColor: 'transparent'
        },
        '&$disabled': {
          backgroundColor: 'transparent'
        }
      },
      '&$disabled': {
        color: theme.palette.action.disabled
      }
    },

    /* Styles applied to the root element if `color="inherit"`. */
    colorInherit: {
      color: 'inherit'
    },

    /* Styles applied to the root element if `color="primary"`. */
    colorPrimary: {
      color: theme.palette.primary.main,
      '&:hover': {
        backgroundColor: (0, _colorManipulator.fade)(theme.palette.primary.main, theme.palette.action.hoverOpacity),
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
          backgroundColor: 'transparent'
        }
      }
    },

    /* Styles applied to the root element if `color="secondary"`. */
    colorSecondary: {
      color: theme.palette.secondary.main,
      '&:hover': {
        backgroundColor: (0, _colorManipulator.fade)(theme.palette.secondary.main, theme.palette.action.hoverOpacity),
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
          backgroundColor: 'transparent'
        }
      }
    },

    /* Styles applied to the root element if `disabled={true}`. */
    disabled: {},

    /* Styles applied to the children container element. */
    label: {
      width: '100%',
      display: 'flex',
      alignItems: 'inherit',
      justifyContent: 'inherit'
    }
  };
};
/**
 * Refer to the [Icons](/style/icons) section of the documentation
 * regarding the available icon options.
 */


exports.styles = styles;

function IconButton(props) {
  var _classNames;

  var children = props.children,
      classes = props.classes,
      className = props.className,
      color = props.color,
      disabled = props.disabled,
      other = (0, _objectWithoutProperties2.default)(props, ["children", "classes", "className", "color", "disabled"]);
  return _react.default.createElement(_ButtonBase.default, (0, _extends2.default)({
    className: (0, _classnames.default)(classes.root, (_classNames = {}, (0, _defineProperty2.default)(_classNames, classes["color".concat((0, _helpers.capitalize)(color))], color !== 'default'), (0, _defineProperty2.default)(_classNames, classes.disabled, disabled), _classNames), className),
    centerRipple: true,
    focusRipple: true,
    disabled: disabled
  }, other), _react.default.createElement("span", {
    className: classes.label
  }, children));
}

IconButton.propTypes =  false ? {
  /**
   * The icon element.
   */
  children: _propTypes.default.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * The color of the component. It supports those theme colors that make sense for this component.
   */
  color: _propTypes.default.oneOf(['default', 'inherit', 'primary', 'secondary']),

  /**
   * If `true`, the button will be disabled.
   */
  disabled: _propTypes.default.bool,

  /**
   * If `true`, the ripple will be disabled.
   */
  disableRipple: _propTypes.default.bool
} : {};
IconButton.defaultProps = {
  color: 'default',
  disabled: false
};

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiIconButton'
})(IconButton);

exports.default = _default;

/***/ }),
/* 498 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(2);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(6));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(7));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(4));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(11));

var _createClass2 = _interopRequireDefault(__webpack_require__(12));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(13));

var _inherits2 = _interopRequireDefault(__webpack_require__(14));

var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(88));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _reactDom = _interopRequireDefault(__webpack_require__(24));

var _classnames = _interopRequireDefault(__webpack_require__(5));

var _keycode = _interopRequireDefault(__webpack_require__(99));

var _ownerWindow = _interopRequireDefault(__webpack_require__(125));

var _withStyles = _interopRequireDefault(__webpack_require__(3));

var _focusVisible = __webpack_require__(499);

var _TouchRipple = _interopRequireDefault(__webpack_require__(500));

var _createRippleHandler = _interopRequireDefault(__webpack_require__(506));

var styles = {
  /* Styles applied to the root element. */
  root: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'relative',
    // Remove grey highlight
    WebkitTapHighlightColor: 'transparent',
    backgroundColor: 'transparent',
    // Reset default value
    // We disable the focus ring for mouse, touch and keyboard users.
    outline: 'none',
    border: 0,
    margin: 0,
    // Remove the margin in Safari
    borderRadius: 0,
    padding: 0,
    // Remove the padding in Firefox
    cursor: 'pointer',
    userSelect: 'none',
    verticalAlign: 'middle',
    '-moz-appearance': 'none',
    // Reset
    '-webkit-appearance': 'none',
    // Reset
    textDecoration: 'none',
    // So we take precedent over the style of a native <a /> element.
    color: 'inherit',
    '&::-moz-focus-inner': {
      borderStyle: 'none' // Remove Firefox dotted outline.

    },
    '&$disabled': {
      pointerEvents: 'none',
      // Disable link interactions
      cursor: 'default'
    }
  },

  /* Styles applied to the root element if `disabled={true}`. */
  disabled: {},

  /* Styles applied to the root element if keyboard focused. */
  focusVisible: {}
};
/* istanbul ignore if */

exports.styles = styles;

if (false) {
  throw new Error('Material-UI: react@16.3.0 or greater is required.');
}
/**
 * `ButtonBase` contains as few styles as possible.
 * It aims to be a simple building block for creating a button.
 * It contains a load of style reset and some focus/ripple logic.
 */


var ButtonBase =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(ButtonBase, _React$Component);

  function ButtonBase() {
    var _ref;

    var _temp, _this;

    (0, _classCallCheck2.default)(this, ButtonBase);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return (0, _possibleConstructorReturn2.default)(_this, (_temp = _this = (0, _possibleConstructorReturn2.default)(this, (_ref = ButtonBase.__proto__ || Object.getPrototypeOf(ButtonBase)).call.apply(_ref, [this].concat(args))), _this.ripple = null, _this.keyDown = false, _this.button = null, _this.focusVisibleTimeout = null, _this.focusVisibleCheckTime = 50, _this.focusVisibleMaxCheckTimes = 5, _this.handleMouseDown = (0, _createRippleHandler.default)((0, _assertThisInitialized2.default)(_this), 'MouseDown', 'start', function () {
      clearTimeout(_this.focusVisibleTimeout);

      if (_this.state.focusVisible) {
        _this.setState({
          focusVisible: false
        });
      }
    }), _this.handleMouseUp = (0, _createRippleHandler.default)((0, _assertThisInitialized2.default)(_this), 'MouseUp', 'stop'), _this.handleMouseLeave = (0, _createRippleHandler.default)((0, _assertThisInitialized2.default)(_this), 'MouseLeave', 'stop', function (event) {
      if (_this.state.focusVisible) {
        event.preventDefault();
      }
    }), _this.handleTouchStart = (0, _createRippleHandler.default)((0, _assertThisInitialized2.default)(_this), 'TouchStart', 'start'), _this.handleTouchEnd = (0, _createRippleHandler.default)((0, _assertThisInitialized2.default)(_this), 'TouchEnd', 'stop'), _this.handleTouchMove = (0, _createRippleHandler.default)((0, _assertThisInitialized2.default)(_this), 'TouchMove', 'stop'), _this.handleBlur = (0, _createRippleHandler.default)((0, _assertThisInitialized2.default)(_this), 'Blur', 'stop', function () {
      clearTimeout(_this.focusVisibleTimeout);

      if (_this.state.focusVisible) {
        _this.setState({
          focusVisible: false
        });
      }
    }), _this.state = {}, _this.onRippleRef = function (node) {
      _this.ripple = node;
    }, _this.onFocusVisibleHandler = function (event) {
      _this.keyDown = false;

      _this.setState({
        focusVisible: true
      });

      if (_this.props.onFocusVisible) {
        _this.props.onFocusVisible(event);
      }
    }, _this.handleKeyDown = function (event) {
      var _this$props = _this.props,
          component = _this$props.component,
          focusRipple = _this$props.focusRipple,
          onKeyDown = _this$props.onKeyDown,
          onClick = _this$props.onClick;
      var key = (0, _keycode.default)(event); // Check if key is already down to avoid repeats being counted as multiple activations

      if (focusRipple && !_this.keyDown && _this.state.focusVisible && _this.ripple && key === 'space') {
        _this.keyDown = true;
        event.persist();

        _this.ripple.stop(event, function () {
          _this.ripple.start(event);
        });
      }

      if (onKeyDown) {
        onKeyDown(event);
      } // Keyboard accessibility for non interactive elements


      if (event.target === event.currentTarget && component && component !== 'button' && (key === 'space' || key === 'enter') && !(_this.button.tagName === 'A' && _this.button.href)) {
        event.preventDefault();

        if (onClick) {
          onClick(event);
        }
      }
    }, _this.handleKeyUp = function (event) {
      if (_this.props.focusRipple && (0, _keycode.default)(event) === 'space' && _this.ripple && _this.state.focusVisible) {
        _this.keyDown = false;
        event.persist();

        _this.ripple.stop(event, function () {
          _this.ripple.pulsate(event);
        });
      }

      if (_this.props.onKeyUp) {
        _this.props.onKeyUp(event);
      }
    }, _this.handleFocus = function (event) {
      if (_this.props.disabled) {
        return;
      } // Fix for https://github.com/facebook/react/issues/7769


      if (!_this.button) {
        _this.button = event.currentTarget;
      }

      event.persist();
      (0, _focusVisible.detectFocusVisible)((0, _assertThisInitialized2.default)(_this), _this.button, function () {
        _this.onFocusVisibleHandler(event);
      });

      if (_this.props.onFocus) {
        _this.props.onFocus(event);
      }
    }, _temp));
  }

  (0, _createClass2.default)(ButtonBase, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      this.button = _reactDom.default.findDOMNode(this);
      (0, _focusVisible.listenForFocusKeys)((0, _ownerWindow.default)(this.button));

      if (this.props.action) {
        this.props.action({
          focusVisible: function focusVisible() {
            _this2.setState({
              focusVisible: true
            });

            _this2.button.focus();
          }
        });
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      if (this.props.focusRipple && !this.props.disableRipple && !prevState.focusVisible && this.state.focusVisible) {
        this.ripple.pulsate();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.button = null;
      clearTimeout(this.focusVisibleTimeout);
    }
  }, {
    key: "render",
    value: function render() {
      var _classNames;

      var _props = this.props,
          action = _props.action,
          buttonRef = _props.buttonRef,
          centerRipple = _props.centerRipple,
          children = _props.children,
          classes = _props.classes,
          classNameProp = _props.className,
          component = _props.component,
          disabled = _props.disabled,
          disableRipple = _props.disableRipple,
          disableTouchRipple = _props.disableTouchRipple,
          focusRipple = _props.focusRipple,
          focusVisibleClassName = _props.focusVisibleClassName,
          onBlur = _props.onBlur,
          onFocus = _props.onFocus,
          onFocusVisible = _props.onFocusVisible,
          onKeyDown = _props.onKeyDown,
          onKeyUp = _props.onKeyUp,
          onMouseDown = _props.onMouseDown,
          onMouseLeave = _props.onMouseLeave,
          onMouseUp = _props.onMouseUp,
          onTouchEnd = _props.onTouchEnd,
          onTouchMove = _props.onTouchMove,
          onTouchStart = _props.onTouchStart,
          tabIndex = _props.tabIndex,
          TouchRippleProps = _props.TouchRippleProps,
          type = _props.type,
          other = (0, _objectWithoutProperties2.default)(_props, ["action", "buttonRef", "centerRipple", "children", "classes", "className", "component", "disabled", "disableRipple", "disableTouchRipple", "focusRipple", "focusVisibleClassName", "onBlur", "onFocus", "onFocusVisible", "onKeyDown", "onKeyUp", "onMouseDown", "onMouseLeave", "onMouseUp", "onTouchEnd", "onTouchMove", "onTouchStart", "tabIndex", "TouchRippleProps", "type"]);
      var className = (0, _classnames.default)(classes.root, (_classNames = {}, (0, _defineProperty2.default)(_classNames, classes.disabled, disabled), (0, _defineProperty2.default)(_classNames, classes.focusVisible, this.state.focusVisible), (0, _defineProperty2.default)(_classNames, focusVisibleClassName, this.state.focusVisible), _classNames), classNameProp);
      var buttonProps = {};
      var ComponentProp = component;

      if (ComponentProp === 'button' && other.href) {
        ComponentProp = 'a';
      }

      if (ComponentProp === 'button') {
        buttonProps.type = type || 'button';
        buttonProps.disabled = disabled;
      } else {
        buttonProps.role = 'button';
      }

      return _react.default.createElement(ComponentProp, (0, _extends2.default)({
        onBlur: this.handleBlur,
        onFocus: this.handleFocus,
        onKeyDown: this.handleKeyDown,
        onKeyUp: this.handleKeyUp,
        onMouseDown: this.handleMouseDown,
        onMouseLeave: this.handleMouseLeave,
        onMouseUp: this.handleMouseUp,
        onTouchEnd: this.handleTouchEnd,
        onTouchMove: this.handleTouchMove,
        onTouchStart: this.handleTouchStart,
        tabIndex: disabled ? '-1' : tabIndex,
        className: className,
        ref: buttonRef
      }, buttonProps, other), children, !disableRipple && !disabled ? _react.default.createElement(_TouchRipple.default, (0, _extends2.default)({
        innerRef: this.onRippleRef,
        center: centerRipple
      }, TouchRippleProps)) : null);
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps, prevState) {
      if (typeof prevState.focusVisible === 'undefined') {
        return {
          focusVisible: false,
          lastDisabled: nextProps.disabled
        };
      } // The blur won't fire when the disabled state is set on a focused input.
      // We need to book keep the focused state manually.


      if (!prevState.prevState && nextProps.disabled && prevState.focusVisible) {
        return {
          focusVisible: false,
          lastDisabled: nextProps.disabled
        };
      }

      return {
        lastDisabled: nextProps.disabled
      };
    }
  }]);
  return ButtonBase;
}(_react.default.Component);

ButtonBase.propTypes =  false ? {
  /**
   * Callback fired when the component mounts.
   * This is useful when you want to trigger an action programmatically.
   * It currently only supports `focusVisible()` action.
   *
   * @param {object} actions This object contains all possible actions
   * that can be triggered programmatically.
   */
  action: _propTypes.default.func,

  /**
   * Use that property to pass a ref callback to the native button component.
   */
  buttonRef: _propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.object]),

  /**
   * If `true`, the ripples will be centered.
   * They won't start at the cursor interaction position.
   */
  centerRipple: _propTypes.default.bool,

  /**
   * The content of the component.
   */
  children: _propTypes.default.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * The component used for the root node.
   * Either a string to use a DOM element or a component.
   */
  component: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func, _propTypes.default.object]),

  /**
   * If `true`, the base button will be disabled.
   */
  disabled: _propTypes.default.bool,

  /**
   * If `true`, the ripple effect will be disabled.
   */
  disableRipple: _propTypes.default.bool,

  /**
   * If `true`, the touch ripple effect will be disabled.
   */
  disableTouchRipple: _propTypes.default.bool,

  /**
   * If `true`, the base button will have a keyboard focus ripple.
   * `disableRipple` must also be `false`.
   */
  focusRipple: _propTypes.default.bool,

  /**
   * This property can help a person know which element has the keyboard focus.
   * The class name will be applied when the element gain the focus through a keyboard interaction.
   * It's a polyfill for the [CSS :focus-visible feature](https://drafts.csswg.org/selectors-4/#the-focus-visible-pseudo).
   * The rational for using this feature [is explain here](https://github.com/WICG/focus-visible/blob/master/explainer.md).
   */
  focusVisibleClassName: _propTypes.default.string,

  /**
   * @ignore
   */
  onBlur: _propTypes.default.func,

  /**
   * @ignore
   */
  onClick: _propTypes.default.func,

  /**
   * @ignore
   */
  onFocus: _propTypes.default.func,

  /**
   * Callback fired when the component is focused with a keyboard.
   * We trigger a `onFocus` callback too.
   */
  onFocusVisible: _propTypes.default.func,

  /**
   * @ignore
   */
  onKeyDown: _propTypes.default.func,

  /**
   * @ignore
   */
  onKeyUp: _propTypes.default.func,

  /**
   * @ignore
   */
  onMouseDown: _propTypes.default.func,

  /**
   * @ignore
   */
  onMouseLeave: _propTypes.default.func,

  /**
   * @ignore
   */
  onMouseUp: _propTypes.default.func,

  /**
   * @ignore
   */
  onTouchEnd: _propTypes.default.func,

  /**
   * @ignore
   */
  onTouchMove: _propTypes.default.func,

  /**
   * @ignore
   */
  onTouchStart: _propTypes.default.func,

  /**
   * @ignore
   */
  role: _propTypes.default.string,

  /**
   * @ignore
   */
  tabIndex: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),

  /**
   * Properties applied to the `TouchRipple` element.
   */
  TouchRippleProps: _propTypes.default.object,

  /**
   * Used to control the button's purpose.
   * This property passes the value to the `type` attribute of the native button component.
   * Valid property values include `button`, `submit`, and `reset`.
   */
  type: _propTypes.default.string
} : {};
ButtonBase.defaultProps = {
  centerRipple: false,
  component: 'button',
  disableRipple: false,
  disableTouchRipple: false,
  focusRipple: false,
  tabIndex: '0',
  type: 'button'
};

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiButtonBase'
})(ButtonBase);

exports.default = _default;

/***/ }),
/* 499 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(2);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.detectFocusVisible = detectFocusVisible;
exports.listenForFocusKeys = listenForFocusKeys;

var _keycode = _interopRequireDefault(__webpack_require__(99));

var _warning = _interopRequireDefault(__webpack_require__(16));

var _ownerDocument = _interopRequireDefault(__webpack_require__(48));

//  weak
var internal = {
  focusKeyPressed: false,
  keyUpEventTimeout: -1
};

function detectFocusVisible(instance, element, callback) {
  var attempt = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1;
   false ? (0, _warning.default)(instance.focusVisibleCheckTime, 'Material-UI: missing instance.focusVisibleCheckTime.') : void 0;
   false ? (0, _warning.default)(instance.focusVisibleMaxCheckTimes, 'Material-UI: missing instance.focusVisibleMaxCheckTimes.') : void 0;
  instance.focusVisibleTimeout = setTimeout(function () {
    var doc = (0, _ownerDocument.default)(element);

    if (internal.focusKeyPressed && (doc.activeElement === element || element.contains(doc.activeElement))) {
      callback();
    } else if (attempt < instance.focusVisibleMaxCheckTimes) {
      detectFocusVisible(instance, element, callback, attempt + 1);
    }
  }, instance.focusVisibleCheckTime);
}

var FOCUS_KEYS = ['tab', 'enter', 'space', 'esc', 'up', 'down', 'left', 'right'];

function isFocusKey(event) {
  return FOCUS_KEYS.indexOf((0, _keycode.default)(event)) > -1;
}

var handleKeyUpEvent = function handleKeyUpEvent(event) {
  if (isFocusKey(event)) {
    internal.focusKeyPressed = true; // Let's consider that the user is using a keyboard during a window frame of 1s.

    clearTimeout(internal.keyUpEventTimeout);
    internal.keyUpEventTimeout = setTimeout(function () {
      internal.focusKeyPressed = false;
    }, 1e3);
  }
};

function listenForFocusKeys(win) {
  // The event listener will only be added once per window.
  // Duplicate event listeners will be ignored by addEventListener.
  // Also, this logic is client side only, we don't need a teardown.
  win.addEventListener('keyup', handleKeyUpEvent);
}

/***/ }),
/* 500 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(2);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = exports.DELAY_RIPPLE = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(6));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(4));

var _toConsumableArray2 = _interopRequireDefault(__webpack_require__(243));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(11));

var _createClass2 = _interopRequireDefault(__webpack_require__(12));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(13));

var _inherits2 = _interopRequireDefault(__webpack_require__(14));

var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(88));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _reactDom = _interopRequireDefault(__webpack_require__(24));

var _TransitionGroup = _interopRequireDefault(__webpack_require__(174));

var _classnames = _interopRequireDefault(__webpack_require__(5));

var _withStyles = _interopRequireDefault(__webpack_require__(3));

var _Ripple = _interopRequireDefault(__webpack_require__(505));

var DURATION = 550;
var DELAY_RIPPLE = 80;
exports.DELAY_RIPPLE = DELAY_RIPPLE;

var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      display: 'block',
      position: 'absolute',
      overflow: 'hidden',
      borderRadius: 'inherit',
      width: '100%',
      height: '100%',
      left: 0,
      top: 0,
      pointerEvents: 'none',
      zIndex: 0
    },

    /* Styles applied to the internal `Ripple` components `ripple` class. */
    ripple: {
      width: 50,
      height: 50,
      left: 0,
      top: 0,
      opacity: 0,
      position: 'absolute'
    },

    /* Styles applied to the internal `Ripple` components `rippleVisible` class. */
    rippleVisible: {
      opacity: 0.3,
      transform: 'scale(1)',
      animation: "mui-ripple-enter ".concat(DURATION, "ms ").concat(theme.transitions.easing.easeInOut)
    },

    /* Styles applied to the internal `Ripple` components `ripplePulsate` class. */
    ripplePulsate: {
      animationDuration: "".concat(theme.transitions.duration.shorter, "ms")
    },

    /* Styles applied to the internal `Ripple` components `child` class. */
    child: {
      opacity: 1,
      display: 'block',
      width: '100%',
      height: '100%',
      borderRadius: '50%',
      backgroundColor: 'currentColor'
    },

    /* Styles applied to the internal `Ripple` components `childLeaving` class. */
    childLeaving: {
      opacity: 0,
      animation: "mui-ripple-exit ".concat(DURATION, "ms ").concat(theme.transitions.easing.easeInOut)
    },

    /* Styles applied to the internal `Ripple` components `childPulsate` class. */
    childPulsate: {
      position: 'absolute',
      left: 0,
      top: 0,
      animation: "mui-ripple-pulsate 2500ms ".concat(theme.transitions.easing.easeInOut, " 200ms infinite")
    },
    '@keyframes mui-ripple-enter': {
      '0%': {
        transform: 'scale(0)',
        opacity: 0.1
      },
      '100%': {
        transform: 'scale(1)',
        opacity: 0.3
      }
    },
    '@keyframes mui-ripple-exit': {
      '0%': {
        opacity: 1
      },
      '100%': {
        opacity: 0
      }
    },
    '@keyframes mui-ripple-pulsate': {
      '0%': {
        transform: 'scale(1)'
      },
      '50%': {
        transform: 'scale(0.92)'
      },
      '100%': {
        transform: 'scale(1)'
      }
    }
  };
};

exports.styles = styles;

var TouchRipple =
/*#__PURE__*/
function (_React$PureComponent) {
  (0, _inherits2.default)(TouchRipple, _React$PureComponent);

  function TouchRipple() {
    var _ref;

    var _temp, _this;

    (0, _classCallCheck2.default)(this, TouchRipple);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return (0, _possibleConstructorReturn2.default)(_this, (_temp = _this = (0, _possibleConstructorReturn2.default)(this, (_ref = TouchRipple.__proto__ || Object.getPrototypeOf(TouchRipple)).call.apply(_ref, [this].concat(args))), _this.ignoringMouseDown = false, _this.startTimer = null, _this.startTimerCommit = null, _this.state = {
      // eslint-disable-next-line react/no-unused-state
      nextKey: 0,
      ripples: []
    }, _this.pulsate = function () {
      _this.start({}, {
        pulsate: true
      });
    }, _this.start = function () {
      var event = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var cb = arguments.length > 2 ? arguments[2] : undefined;
      var _options$pulsate = options.pulsate,
          pulsate = _options$pulsate === void 0 ? false : _options$pulsate,
          _options$center = options.center,
          center = _options$center === void 0 ? _this.props.center || options.pulsate : _options$center,
          _options$fakeElement = options.fakeElement,
          fakeElement = _options$fakeElement === void 0 ? false : _options$fakeElement;

      if (event.type === 'mousedown' && _this.ignoringMouseDown) {
        _this.ignoringMouseDown = false;
        return;
      }

      if (event.type === 'touchstart') {
        _this.ignoringMouseDown = true;
      }

      var element = fakeElement ? null : _reactDom.default.findDOMNode((0, _assertThisInitialized2.default)(_this));
      var rect = element ? element.getBoundingClientRect() : {
        width: 0,
        height: 0,
        left: 0,
        top: 0
      }; // Get the size of the ripple

      var rippleX;
      var rippleY;
      var rippleSize;

      if (center || event.clientX === 0 && event.clientY === 0 || !event.clientX && !event.touches) {
        rippleX = Math.round(rect.width / 2);
        rippleY = Math.round(rect.height / 2);
      } else {
        var clientX = event.clientX ? event.clientX : event.touches[0].clientX;
        var clientY = event.clientY ? event.clientY : event.touches[0].clientY;
        rippleX = Math.round(clientX - rect.left);
        rippleY = Math.round(clientY - rect.top);
      }

      if (center) {
        rippleSize = Math.sqrt((2 * Math.pow(rect.width, 2) + Math.pow(rect.height, 2)) / 3); // For some reason the animation is broken on Mobile Chrome if the size if even.

        if (rippleSize % 2 === 0) {
          rippleSize += 1;
        }
      } else {
        var sizeX = Math.max(Math.abs((element ? element.clientWidth : 0) - rippleX), rippleX) * 2 + 2;
        var sizeY = Math.max(Math.abs((element ? element.clientHeight : 0) - rippleY), rippleY) * 2 + 2;
        rippleSize = Math.sqrt(Math.pow(sizeX, 2) + Math.pow(sizeY, 2));
      } // Touche devices


      if (event.touches) {
        // Prepare the ripple effect.
        _this.startTimerCommit = function () {
          _this.startCommit({
            pulsate: pulsate,
            rippleX: rippleX,
            rippleY: rippleY,
            rippleSize: rippleSize,
            cb: cb
          });
        }; // Deplay the execution of the ripple effect.


        _this.startTimer = setTimeout(function () {
          if (_this.startTimerCommit) {
            _this.startTimerCommit();

            _this.startTimerCommit = null;
          }
        }, DELAY_RIPPLE); // We have to make a tradeoff with this value.
      } else {
        _this.startCommit({
          pulsate: pulsate,
          rippleX: rippleX,
          rippleY: rippleY,
          rippleSize: rippleSize,
          cb: cb
        });
      }
    }, _this.startCommit = function (params) {
      var pulsate = params.pulsate,
          rippleX = params.rippleX,
          rippleY = params.rippleY,
          rippleSize = params.rippleSize,
          cb = params.cb;

      _this.setState(function (state) {
        return {
          nextKey: state.nextKey + 1,
          ripples: (0, _toConsumableArray2.default)(state.ripples).concat([_react.default.createElement(_Ripple.default, {
            key: state.nextKey,
            classes: _this.props.classes,
            timeout: {
              exit: DURATION,
              enter: DURATION
            },
            pulsate: pulsate,
            rippleX: rippleX,
            rippleY: rippleY,
            rippleSize: rippleSize
          })])
        };
      }, cb);
    }, _this.stop = function (event, cb) {
      clearTimeout(_this.startTimer);
      var ripples = _this.state.ripples; // The touch interaction occurs too quickly.
      // We still want to show ripple effect.

      if (event.type === 'touchend' && _this.startTimerCommit) {
        event.persist();

        _this.startTimerCommit();

        _this.startTimerCommit = null;
        _this.startTimer = setTimeout(function () {
          _this.stop(event, cb);
        }, 0);
        return;
      }

      _this.startTimerCommit = null;

      if (ripples && ripples.length) {
        _this.setState({
          ripples: ripples.slice(1)
        }, cb);
      }
    }, _temp));
  }

  (0, _createClass2.default)(TouchRipple, [{
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      clearTimeout(this.startTimer);
    }
  }, {
    key: "render",
    value: function render() {
      var _props = this.props,
          center = _props.center,
          classes = _props.classes,
          className = _props.className,
          other = (0, _objectWithoutProperties2.default)(_props, ["center", "classes", "className"]);
      return _react.default.createElement(_TransitionGroup.default, (0, _extends2.default)({
        component: "span",
        enter: true,
        exit: true,
        className: (0, _classnames.default)(classes.root, className)
      }, other), this.state.ripples);
    }
  }]);
  return TouchRipple;
}(_react.default.PureComponent);

TouchRipple.propTypes =  false ? {
  /**
   * If `true`, the ripple starts at the center of the component
   * rather than at the point of interaction.
   */
  center: _propTypes.default.bool,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string
} : {};
TouchRipple.defaultProps = {
  center: false
};

var _default = (0, _withStyles.default)(styles, {
  flip: false,
  name: 'MuiTouchRipple'
})(TouchRipple);

exports.default = _default;

/***/ }),
/* 501 */
/***/ (function(module, exports) {

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  }
}

module.exports = _arrayWithoutHoles;

/***/ }),
/* 502 */
/***/ (function(module, exports) {

function _iterableToArray(iter) {
  if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}

module.exports = _iterableToArray;

/***/ }),
/* 503 */
/***/ (function(module, exports) {

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}

module.exports = _nonIterableSpread;

/***/ }),
/* 504 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.getChildMapping = getChildMapping;
exports.mergeChildMappings = mergeChildMappings;
exports.getInitialChildMapping = getInitialChildMapping;
exports.getNextChildMapping = getNextChildMapping;

var _react = __webpack_require__(0);

/**
 * Given `this.props.children`, return an object mapping key to child.
 *
 * @param {*} children `this.props.children`
 * @return {object} Mapping of key to child
 */
function getChildMapping(children, mapFn) {
  var mapper = function mapper(child) {
    return mapFn && (0, _react.isValidElement)(child) ? mapFn(child) : child;
  };

  var result = Object.create(null);
  if (children) _react.Children.map(children, function (c) {
    return c;
  }).forEach(function (child) {
    // run the map function here instead so that the key is the computed one
    result[child.key] = mapper(child);
  });
  return result;
}

/**
 * When you're adding or removing children some may be added or removed in the
 * same render pass. We want to show *both* since we want to simultaneously
 * animate elements in and out. This function takes a previous set of keys
 * and a new set of keys and merges them with its best guess of the correct
 * ordering. In the future we may expose some of the utilities in
 * ReactMultiChild to make this easy, but for now React itself does not
 * directly have this concept of the union of prevChildren and nextChildren
 * so we implement it here.
 *
 * @param {object} prev prev children as returned from
 * `ReactTransitionChildMapping.getChildMapping()`.
 * @param {object} next next children as returned from
 * `ReactTransitionChildMapping.getChildMapping()`.
 * @return {object} a key set that contains all keys in `prev` and all keys
 * in `next` in a reasonable order.
 */
function mergeChildMappings(prev, next) {
  prev = prev || {};
  next = next || {};

  function getValueForKey(key) {
    return key in next ? next[key] : prev[key];
  }

  // For each key of `next`, the list of keys to insert before that key in
  // the combined list
  var nextKeysPending = Object.create(null);

  var pendingKeys = [];
  for (var prevKey in prev) {
    if (prevKey in next) {
      if (pendingKeys.length) {
        nextKeysPending[prevKey] = pendingKeys;
        pendingKeys = [];
      }
    } else {
      pendingKeys.push(prevKey);
    }
  }

  var i = void 0;
  var childMapping = {};
  for (var nextKey in next) {
    if (nextKeysPending[nextKey]) {
      for (i = 0; i < nextKeysPending[nextKey].length; i++) {
        var pendingNextKey = nextKeysPending[nextKey][i];
        childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
      }
    }
    childMapping[nextKey] = getValueForKey(nextKey);
  }

  // Finally, add the keys which didn't appear before any key in `next`
  for (i = 0; i < pendingKeys.length; i++) {
    childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
  }

  return childMapping;
}

function getProp(child, prop, props) {
  return props[prop] != null ? props[prop] : child.props[prop];
}

function getInitialChildMapping(props, onExited) {
  return getChildMapping(props.children, function (child) {
    return (0, _react.cloneElement)(child, {
      onExited: onExited.bind(null, child),
      in: true,
      appear: getProp(child, 'appear', props),
      enter: getProp(child, 'enter', props),
      exit: getProp(child, 'exit', props)
    });
  });
}

function getNextChildMapping(nextProps, prevChildMapping, onExited) {
  var nextChildMapping = getChildMapping(nextProps.children);
  var children = mergeChildMappings(prevChildMapping, nextChildMapping);

  Object.keys(children).forEach(function (key) {
    var child = children[key];

    if (!(0, _react.isValidElement)(child)) return;

    var hasPrev = key in prevChildMapping;
    var hasNext = key in nextChildMapping;

    var prevChild = prevChildMapping[key];
    var isLeaving = (0, _react.isValidElement)(prevChild) && !prevChild.props.in;

    // item is new (entering)
    if (hasNext && (!hasPrev || isLeaving)) {
      // console.log('entering', key)
      children[key] = (0, _react.cloneElement)(child, {
        onExited: onExited.bind(null, child),
        in: true,
        exit: getProp(child, 'exit', nextProps),
        enter: getProp(child, 'enter', nextProps)
      });
    } else if (!hasNext && hasPrev && !isLeaving) {
      // item is old (exiting)
      // console.log('leaving', key)
      children[key] = (0, _react.cloneElement)(child, { in: false });
    } else if (hasNext && hasPrev && (0, _react.isValidElement)(prevChild)) {
      // item hasn't changed transition states
      // copy over the last transition props;
      // console.log('unchanged', key)
      children[key] = (0, _react.cloneElement)(child, {
        onExited: onExited.bind(null, child),
        in: prevChild.props.in,
        exit: getProp(child, 'exit', nextProps),
        enter: getProp(child, 'enter', nextProps)
      });
    }
  });

  return children;
}

/***/ }),
/* 505 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(2);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(6));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(7));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(4));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(11));

var _createClass2 = _interopRequireDefault(__webpack_require__(12));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(13));

var _inherits2 = _interopRequireDefault(__webpack_require__(14));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _classnames = _interopRequireDefault(__webpack_require__(5));

var _Transition = _interopRequireDefault(__webpack_require__(62));

/**
 * @ignore - internal component.
 */
var Ripple =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(Ripple, _React$Component);

  function Ripple() {
    var _ref;

    var _temp, _this;

    (0, _classCallCheck2.default)(this, Ripple);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return (0, _possibleConstructorReturn2.default)(_this, (_temp = _this = (0, _possibleConstructorReturn2.default)(this, (_ref = Ripple.__proto__ || Object.getPrototypeOf(Ripple)).call.apply(_ref, [this].concat(args))), _this.state = {
      visible: false,
      leaving: false
    }, _this.handleEnter = function () {
      _this.setState({
        visible: true
      });
    }, _this.handleExit = function () {
      _this.setState({
        leaving: true
      });
    }, _temp));
  }

  (0, _createClass2.default)(Ripple, [{
    key: "render",
    value: function render() {
      var _classNames, _classNames2;

      var _props = this.props,
          classes = _props.classes,
          classNameProp = _props.className,
          pulsate = _props.pulsate,
          rippleX = _props.rippleX,
          rippleY = _props.rippleY,
          rippleSize = _props.rippleSize,
          other = (0, _objectWithoutProperties2.default)(_props, ["classes", "className", "pulsate", "rippleX", "rippleY", "rippleSize"]);
      var _state = this.state,
          visible = _state.visible,
          leaving = _state.leaving;
      var rippleClassName = (0, _classnames.default)(classes.ripple, (_classNames = {}, (0, _defineProperty2.default)(_classNames, classes.rippleVisible, visible), (0, _defineProperty2.default)(_classNames, classes.ripplePulsate, pulsate), _classNames), classNameProp);
      var rippleStyles = {
        width: rippleSize,
        height: rippleSize,
        top: -(rippleSize / 2) + rippleY,
        left: -(rippleSize / 2) + rippleX
      };
      var childClassName = (0, _classnames.default)(classes.child, (_classNames2 = {}, (0, _defineProperty2.default)(_classNames2, classes.childLeaving, leaving), (0, _defineProperty2.default)(_classNames2, classes.childPulsate, pulsate), _classNames2));
      return _react.default.createElement(_Transition.default, (0, _extends2.default)({
        onEnter: this.handleEnter,
        onExit: this.handleExit
      }, other), _react.default.createElement("span", {
        className: rippleClassName,
        style: rippleStyles
      }, _react.default.createElement("span", {
        className: childClassName
      })));
    }
  }]);
  return Ripple;
}(_react.default.Component);

Ripple.propTypes =  false ? {
  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * If `true`, the ripple pulsates, typically indicating the keyboard focus state of an element.
   */
  pulsate: _propTypes.default.bool,

  /**
   * Diameter of the ripple.
   */
  rippleSize: _propTypes.default.number,

  /**
   * Horizontal position of the ripple center.
   */
  rippleX: _propTypes.default.number,

  /**
   * Vertical position of the ripple center.
   */
  rippleY: _propTypes.default.number
} : {};
Ripple.defaultProps = {
  pulsate: false
};
var _default = Ripple;
exports.default = _default;

/***/ }),
/* 506 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

function createRippleHandler(instance, eventName, action, cb) {
  return function handleEvent(event) {
    if (cb) {
      cb.call(instance, event);
    }

    var ignore = false; // Ignore events that have been `event.preventDefault()` marked.

    if (event.defaultPrevented) {
      ignore = true;
    }

    if (instance.props.disableTouchRipple && eventName !== 'Blur') {
      ignore = true;
    }

    if (!ignore && instance.ripple) {
      instance.ripple[action](event);
    }

    if (typeof instance.props["on".concat(eventName)] === 'function') {
      instance.props["on".concat(eventName)](event);
    }

    return true;
  };
}

var _default = createRippleHandler;
exports.default = _default;

/***/ }),
/* 507 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var green = {
  50: '#e8f5e9',
  100: '#c8e6c9',
  200: '#a5d6a7',
  300: '#81c784',
  400: '#66bb6a',
  500: '#4caf50',
  600: '#43a047',
  700: '#388e3c',
  800: '#2e7d32',
  900: '#1b5e20',
  A100: '#b9f6ca',
  A200: '#69f0ae',
  A400: '#00e676',
  A700: '#00c853'
};
var _default = green;
exports.default = _default;

/***/ }),
/* 508 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(2);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(6));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(4));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(7));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _classnames = _interopRequireDefault(__webpack_require__(5));

var _withStyles = _interopRequireDefault(__webpack_require__(3));

var _Paper = _interopRequireDefault(__webpack_require__(51));

var _Typography = _interopRequireDefault(__webpack_require__(126));

var _colorManipulator = __webpack_require__(70);

// @inheritedComponent Paper
var styles = function styles(theme) {
  var _root;

  var emphasis = theme.palette.type === 'light' ? 0.8 : 0.98;
  var backgroundColor = (0, _colorManipulator.emphasize)(theme.palette.background.default, emphasis);
  return {
    /* Styles applied to the root element. */
    root: (_root = {
      color: theme.palette.getContrastText(backgroundColor),
      backgroundColor: backgroundColor,
      display: 'flex',
      alignItems: 'center',
      flexWrap: 'wrap',
      padding: '6px 24px'
    }, (0, _defineProperty2.default)(_root, theme.breakpoints.up('md'), {
      minWidth: 288,
      maxWidth: 568,
      borderRadius: theme.shape.borderRadius
    }), (0, _defineProperty2.default)(_root, theme.breakpoints.down('sm'), {
      flexGrow: 1
    }), _root),

    /* Styles applied to the message wrapper element. */
    message: {
      padding: '8px 0'
    },

    /* Styles applied to the action wrapper element if `action` is provided. */
    action: {
      display: 'flex',
      alignItems: 'center',
      marginLeft: 'auto',
      paddingLeft: 24,
      marginRight: -8
    }
  };
};

exports.styles = styles;

function SnackbarContent(props) {
  var action = props.action,
      classes = props.classes,
      className = props.className,
      message = props.message,
      other = (0, _objectWithoutProperties2.default)(props, ["action", "classes", "className", "message"]);
  return _react.default.createElement(_Paper.default, (0, _extends2.default)({
    component: _Typography.default,
    headlineMapping: {
      body1: 'div'
    },
    role: "alertdialog",
    square: true,
    elevation: 6,
    className: (0, _classnames.default)(classes.root, className)
  }, other), _react.default.createElement("div", {
    className: classes.message
  }, message), action ? _react.default.createElement("div", {
    className: classes.action
  }, action) : null);
}

SnackbarContent.propTypes =  false ? {
  /**
   * The action to display.
   */
  action: _propTypes.default.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * The message to display.
   */
  message: _propTypes.default.node
} : {};

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiSnackbarContent'
})(SnackbarContent);

exports.default = _default;

/***/ }),
/* 509 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(2);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(6));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(7));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(4));

var _objectSpread2 = _interopRequireDefault(__webpack_require__(17));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _classnames = _interopRequireDefault(__webpack_require__(5));

var _warning = _interopRequireDefault(__webpack_require__(16));

var _withStyles = _interopRequireDefault(__webpack_require__(3));

var styles = function styles(theme) {
  var elevations = {};
  theme.shadows.forEach(function (shadow, index) {
    elevations["elevation".concat(index)] = {
      boxShadow: shadow
    };
  });
  return (0, _objectSpread2.default)({
    /* Styles applied to the root element. */
    root: {
      backgroundColor: theme.palette.background.paper
    },

    /* Styles applied to the root element if `square={false}`. */
    rounded: {
      borderRadius: theme.shape.borderRadius
    }
  }, elevations);
};

exports.styles = styles;

function Paper(props) {
  var classes = props.classes,
      classNameProp = props.className,
      Component = props.component,
      square = props.square,
      elevation = props.elevation,
      other = (0, _objectWithoutProperties2.default)(props, ["classes", "className", "component", "square", "elevation"]);
   false ? (0, _warning.default)(elevation >= 0 && elevation < 25, "Material-UI: this elevation `".concat(elevation, "` is not implemented.")) : void 0;
  var className = (0, _classnames.default)(classes.root, classes["elevation".concat(elevation)], (0, _defineProperty2.default)({}, classes.rounded, !square), classNameProp);
  return _react.default.createElement(Component, (0, _extends2.default)({
    className: className
  }, other));
}

Paper.propTypes =  false ? {
  /**
   * The content of the component.
   */
  children: _propTypes.default.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * The component used for the root node.
   * Either a string to use a DOM element or a component.
   */
  component: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func, _propTypes.default.object]),

  /**
   * Shadow depth, corresponds to `dp` in the spec.
   * It's accepting values between 0 and 24 inclusive.
   */
  elevation: _propTypes.default.number,

  /**
   * If `true`, rounded corners are disabled.
   */
  square: _propTypes.default.bool
} : {};
Paper.defaultProps = {
  component: 'div',
  elevation: 2,
  square: false
};

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiPaper'
})(Paper);

exports.default = _default;

/***/ }),
/* 510 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(2);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(6));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(7));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(4));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _classnames = _interopRequireDefault(__webpack_require__(5));

var _withStyles = _interopRequireDefault(__webpack_require__(3));

var _helpers = __webpack_require__(37);

var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      display: 'block',
      margin: 0
    },

    /* Styles applied to the root element if `variant="display4"`. */
    display4: theme.typography.display4,

    /* Styles applied to the root element if `variant="display3"`. */
    display3: theme.typography.display3,

    /* Styles applied to the root element if `variant="display2"`. */
    display2: theme.typography.display2,

    /* Styles applied to the root element if `variant="display1"`. */
    display1: theme.typography.display1,

    /* Styles applied to the root element if `variant="headline"`. */
    headline: theme.typography.headline,

    /* Styles applied to the root element if `variant="title"`. */
    title: theme.typography.title,

    /* Styles applied to the root element if `variant="subheading"`. */
    subheading: theme.typography.subheading,

    /* Styles applied to the root element if `variant="body2"`. */
    body2: theme.typography.body2,

    /* Styles applied to the root element if `variant="body1"`. */
    body1: theme.typography.body1,

    /* Styles applied to the root element if `variant="caption"`. */
    caption: theme.typography.caption,

    /* Styles applied to the root element if `variant="button"`. */
    button: theme.typography.button,

    /* Styles applied to the root element if `align="left"`. */
    alignLeft: {
      textAlign: 'left'
    },

    /* Styles applied to the root element if `align="center"`. */
    alignCenter: {
      textAlign: 'center'
    },

    /* Styles applied to the root element if `align="right"`. */
    alignRight: {
      textAlign: 'right'
    },

    /* Styles applied to the root element if `align="justify"`. */
    alignJustify: {
      textAlign: 'justify'
    },

    /* Styles applied to the root element if `align="nowrap"`. */
    noWrap: {
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap'
    },

    /* Styles applied to the root element if `gutterBottom={true}`. */
    gutterBottom: {
      marginBottom: '0.35em'
    },

    /* Styles applied to the root element if `paragraph={true}`. */
    paragraph: {
      marginBottom: 16
    },

    /* Styles applied to the root element if `color="inherit"`. */
    colorInherit: {
      color: 'inherit'
    },

    /* Styles applied to the root element if `color="primary"`. */
    colorPrimary: {
      color: theme.palette.primary.main
    },

    /* Styles applied to the root element if `color="secondary"`. */
    colorSecondary: {
      color: theme.palette.secondary.main
    },

    /* Styles applied to the root element if `color="textPrimary"`. */
    colorTextPrimary: {
      color: theme.palette.text.primary
    },

    /* Styles applied to the root element if `color="textSecondary"`. */
    colorTextSecondary: {
      color: theme.palette.text.secondary
    },

    /* Styles applied to the root element if `color="error"`. */
    colorError: {
      color: theme.palette.error.main
    }
  };
};

exports.styles = styles;

function Typography(props) {
  var _classNames;

  var align = props.align,
      classes = props.classes,
      classNameProp = props.className,
      color = props.color,
      componentProp = props.component,
      gutterBottom = props.gutterBottom,
      headlineMapping = props.headlineMapping,
      noWrap = props.noWrap,
      paragraph = props.paragraph,
      variant = props.variant,
      other = (0, _objectWithoutProperties2.default)(props, ["align", "classes", "className", "color", "component", "gutterBottom", "headlineMapping", "noWrap", "paragraph", "variant"]);
  var className = (0, _classnames.default)(classes.root, classes[variant], (_classNames = {}, (0, _defineProperty2.default)(_classNames, classes["color".concat((0, _helpers.capitalize)(color))], color !== 'default'), (0, _defineProperty2.default)(_classNames, classes.noWrap, noWrap), (0, _defineProperty2.default)(_classNames, classes.gutterBottom, gutterBottom), (0, _defineProperty2.default)(_classNames, classes.paragraph, paragraph), (0, _defineProperty2.default)(_classNames, classes["align".concat((0, _helpers.capitalize)(align))], align !== 'inherit'), _classNames), classNameProp);
  var Component = componentProp || (paragraph ? 'p' : headlineMapping[variant]) || 'span';
  return _react.default.createElement(Component, (0, _extends2.default)({
    className: className
  }, other));
}

Typography.propTypes =  false ? {
  /**
   * Set the text-align on the component.
   */
  align: _propTypes.default.oneOf(['inherit', 'left', 'center', 'right', 'justify']),

  /**
   * The content of the component.
   */
  children: _propTypes.default.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * The color of the component. It supports those theme colors that make sense for this component.
   */
  color: _propTypes.default.oneOf(['default', 'error', 'inherit', 'primary', 'secondary', 'textPrimary', 'textSecondary']),

  /**
   * The component used for the root node.
   * Either a string to use a DOM element or a component.
   * By default, it maps the variant to a good default headline component.
   */
  component: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func, _propTypes.default.object]),

  /**
   * If `true`, the text will have a bottom margin.
   */
  gutterBottom: _propTypes.default.bool,

  /**
   * We are empirically mapping the variant property to a range of different DOM element types.
   * For instance, h1 to h6. If you wish to change that mapping, you can provide your own.
   * Alternatively, you can use the `component` property.
   */
  headlineMapping: _propTypes.default.object,

  /**
   * If `true`, the text will not wrap, but instead will truncate with an ellipsis.
   */
  noWrap: _propTypes.default.bool,

  /**
   * If `true`, the text will have a bottom margin.
   */
  paragraph: _propTypes.default.bool,

  /**
   * Applies the theme typography styles.
   */
  variant: _propTypes.default.oneOf(['display4', 'display3', 'display2', 'display1', 'headline', 'title', 'subheading', 'body2', 'body1', 'caption', 'button'])
} : {};
Typography.defaultProps = {
  align: 'inherit',
  color: 'default',
  gutterBottom: false,
  headlineMapping: {
    display4: 'h1',
    display3: 'h1',
    display2: 'h1',
    display1: 'h1',
    headline: 'h1',
    title: 'h2',
    subheading: 'h3',
    body2: 'aside',
    body1: 'p'
  },
  noWrap: false,
  paragraph: false,
  variant: 'body1'
};

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiTypography'
})(Typography);

exports.default = _default;

/***/ }),
/* 511 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(9);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(10));

var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
  fill: "none",
  d: "M0 0h24v24H0z"
}), _react.default.createElement("path", {
  d: "M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z"
})), 'Warning');

exports.default = _default;

/***/ }),
/* 512 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(2);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(6));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(7));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(4));

var _objectSpread2 = _interopRequireDefault(__webpack_require__(17));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _classnames = _interopRequireDefault(__webpack_require__(5));

var _withStyles = _interopRequireDefault(__webpack_require__(3));

var _colorManipulator = __webpack_require__(70);

var _ButtonBase = _interopRequireDefault(__webpack_require__(124));

var _helpers = __webpack_require__(37);

// @inheritedComponent ButtonBase
var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: (0, _objectSpread2.default)({}, theme.typography.button, {
      lineHeight: '1.4em',
      // Improve readability for multiline button.
      boxSizing: 'border-box',
      minWidth: 64,
      minHeight: 36,
      padding: '8px 16px',
      borderRadius: theme.shape.borderRadius,
      color: theme.palette.text.primary,
      transition: theme.transitions.create(['background-color', 'box-shadow'], {
        duration: theme.transitions.duration.short
      }),
      '&:hover': {
        textDecoration: 'none',
        backgroundColor: (0, _colorManipulator.fade)(theme.palette.text.primary, theme.palette.action.hoverOpacity),
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
          backgroundColor: 'transparent'
        },
        '&$disabled': {
          backgroundColor: 'transparent'
        }
      },
      '&$disabled': {
        color: theme.palette.action.disabled
      }
    }),

    /* Styles applied to the span element that wraps the children. */
    label: {
      width: '100%',
      // assure the correct width for iOS Safari
      display: 'inherit',
      alignItems: 'inherit',
      justifyContent: 'inherit'
    },

    /* Styles applied to the root element if `variant="text"`. */
    text: {},

    /* Styles applied to the root element if `variant="text"` and `color="primary"`. */
    textPrimary: {
      color: theme.palette.primary.main,
      '&:hover': {
        backgroundColor: (0, _colorManipulator.fade)(theme.palette.primary.main, theme.palette.action.hoverOpacity),
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
          backgroundColor: 'transparent'
        }
      }
    },

    /* Styles applied to the root element if `variant="text"` and `color="secondary"`. */
    textSecondary: {
      color: theme.palette.secondary.main,
      '&:hover': {
        backgroundColor: (0, _colorManipulator.fade)(theme.palette.secondary.main, theme.palette.action.hoverOpacity),
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
          backgroundColor: 'transparent'
        }
      }
    },

    /* Styles applied to the root element for backwards compatibility with legacy variant naming. */
    flat: {},

    /* Styles applied to the root element for backwards compatibility with legacy variant naming. */
    flatPrimary: {},

    /* Styles applied to the root element for backwards compatibility with legacy variant naming. */
    flatSecondary: {},

    /* Styles applied to the root element if `variant="outlined"`. */
    outlined: {
      border: "1px solid ".concat(theme.palette.type === 'light' ? 'rgba(0, 0, 0, 0.23)' : 'rgba(255, 255, 255, 0.23)')
    },

    /* Styles applied to the root element if `variant="[contained | fab]"`. */
    contained: {
      color: theme.palette.getContrastText(theme.palette.grey[300]),
      backgroundColor: theme.palette.grey[300],
      boxShadow: theme.shadows[2],
      '&$focusVisible': {
        boxShadow: theme.shadows[6]
      },
      '&:active': {
        boxShadow: theme.shadows[8]
      },
      '&$disabled': {
        color: theme.palette.action.disabled,
        boxShadow: theme.shadows[0],
        backgroundColor: theme.palette.action.disabledBackground
      },
      '&:hover': {
        backgroundColor: theme.palette.grey.A100,
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
          backgroundColor: theme.palette.grey[300]
        },
        '&$disabled': {
          backgroundColor: theme.palette.action.disabledBackground
        }
      }
    },

    /* Styles applied to the root element if `variant="[contained | fab]"` and `color="primary"`. */
    containedPrimary: {
      color: theme.palette.primary.contrastText,
      backgroundColor: theme.palette.primary.main,
      '&:hover': {
        backgroundColor: theme.palette.primary.dark,
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
          backgroundColor: theme.palette.primary.main
        }
      }
    },

    /* Styles applied to the root element if `variant="[contained | fab]"` and `color="secondary"`. */
    containedSecondary: {
      color: theme.palette.secondary.contrastText,
      backgroundColor: theme.palette.secondary.main,
      '&:hover': {
        backgroundColor: theme.palette.secondary.dark,
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
          backgroundColor: theme.palette.secondary.main
        }
      }
    },

    /* Styles applied to the root element for backwards compatibility with legacy variant naming. */
    raised: {},
    // legacy

    /* Styles applied to the root element for backwards compatibility with legacy variant naming. */
    raisedPrimary: {},
    // legacy

    /* Styles applied to the root element for backwards compatibility with legacy variant naming. */
    raisedSecondary: {},
    // legacy

    /* Styles applied to the root element if `variant="[fab | extendedFab]"`. */
    fab: {
      borderRadius: '50%',
      padding: 0,
      minWidth: 0,
      width: 56,
      height: 56,
      boxShadow: theme.shadows[6],
      '&:active': {
        boxShadow: theme.shadows[12]
      }
    },

    /* Styles applied to the root element if `variant="extendedFab"`. */
    extendedFab: {
      borderRadius: 48 / 2,
      padding: '0 16px',
      width: 'auto',
      minWidth: 48,
      height: 48
    },

    /* Styles applied to the ButtonBase root element if the button is keyboard focused. */
    focusVisible: {},

    /* Styles applied to the root element if `disabled={true}`. */
    disabled: {},

    /* Styles applied to the root element if `color="inherit"`. */
    colorInherit: {
      color: 'inherit'
    },

    /* Styles applied to the root element if `size="mini"` & `variant="[fab | extendedFab]"`. */
    mini: {
      width: 40,
      height: 40
    },

    /* Styles applied to the root element if `size="small"`. */
    sizeSmall: {
      padding: '7px 8px',
      minWidth: 64,
      minHeight: 32,
      fontSize: theme.typography.pxToRem(13)
    },

    /* Styles applied to the root element if `size="large"`. */
    sizeLarge: {
      padding: '8px 24px',
      minWidth: 112,
      minHeight: 40,
      fontSize: theme.typography.pxToRem(15)
    },

    /* Styles applied to the root element if `fullWidth={true}`. */
    fullWidth: {
      width: '100%'
    }
  };
};

exports.styles = styles;

function Button(props) {
  var _classNames;

  var children = props.children,
      classes = props.classes,
      classNameProp = props.className,
      color = props.color,
      disabled = props.disabled,
      disableFocusRipple = props.disableFocusRipple,
      fullWidth = props.fullWidth,
      focusVisibleClassName = props.focusVisibleClassName,
      mini = props.mini,
      size = props.size,
      variant = props.variant,
      other = (0, _objectWithoutProperties2.default)(props, ["children", "classes", "className", "color", "disabled", "disableFocusRipple", "fullWidth", "focusVisibleClassName", "mini", "size", "variant"]);
  var fab = variant === 'fab' || variant === 'extendedFab';
  var contained = variant === 'contained' || variant === 'raised';
  var text = variant === 'text' || variant === 'flat' || variant === 'outlined';
  var className = (0, _classnames.default)(classes.root, (_classNames = {}, (0, _defineProperty2.default)(_classNames, classes.fab, fab), (0, _defineProperty2.default)(_classNames, classes.mini, fab && mini), (0, _defineProperty2.default)(_classNames, classes.extendedFab, variant === 'extendedFab'), (0, _defineProperty2.default)(_classNames, classes.text, text), (0, _defineProperty2.default)(_classNames, classes.textPrimary, text && color === 'primary'), (0, _defineProperty2.default)(_classNames, classes.textSecondary, text && color === 'secondary'), (0, _defineProperty2.default)(_classNames, classes.flat, variant === 'text' || variant === 'flat'), (0, _defineProperty2.default)(_classNames, classes.flatPrimary, (variant === 'text' || variant === 'flat') && color === 'primary'), (0, _defineProperty2.default)(_classNames, classes.flatSecondary, (variant === 'text' || variant === 'flat') && color === 'secondary'), (0, _defineProperty2.default)(_classNames, classes.contained, contained || fab), (0, _defineProperty2.default)(_classNames, classes.containedPrimary, (contained || fab) && color === 'primary'), (0, _defineProperty2.default)(_classNames, classes.containedSecondary, (contained || fab) && color === 'secondary'), (0, _defineProperty2.default)(_classNames, classes.raised, contained || fab), (0, _defineProperty2.default)(_classNames, classes.raisedPrimary, (contained || fab) && color === 'primary'), (0, _defineProperty2.default)(_classNames, classes.raisedSecondary, (contained || fab) && color === 'secondary'), (0, _defineProperty2.default)(_classNames, classes.outlined, variant === 'outlined'), (0, _defineProperty2.default)(_classNames, classes["size".concat((0, _helpers.capitalize)(size))], size !== 'medium'), (0, _defineProperty2.default)(_classNames, classes.disabled, disabled), (0, _defineProperty2.default)(_classNames, classes.fullWidth, fullWidth), (0, _defineProperty2.default)(_classNames, classes.colorInherit, color === 'inherit'), _classNames), classNameProp);
  return _react.default.createElement(_ButtonBase.default, (0, _extends2.default)({
    className: className,
    disabled: disabled,
    focusRipple: !disableFocusRipple,
    focusVisibleClassName: (0, _classnames.default)(classes.focusVisible, focusVisibleClassName)
  }, other), _react.default.createElement("span", {
    className: classes.label
  }, children));
}

Button.propTypes =  false ? {
  /**
   * The content of the button.
   */
  children: _propTypes.default.node.isRequired,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * The color of the component. It supports those theme colors that make sense for this component.
   */
  color: _propTypes.default.oneOf(['default', 'inherit', 'primary', 'secondary']),

  /**
   * The component used for the root node.
   * Either a string to use a DOM element or a component.
   */
  component: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func, _propTypes.default.object]),

  /**
   * If `true`, the button will be disabled.
   */
  disabled: _propTypes.default.bool,

  /**
   * If `true`, the  keyboard focus ripple will be disabled.
   * `disableRipple` must also be true.
   */
  disableFocusRipple: _propTypes.default.bool,

  /**
   * If `true`, the ripple effect will be disabled.
   */
  disableRipple: _propTypes.default.bool,

  /**
   * @ignore
   */
  focusVisibleClassName: _propTypes.default.string,

  /**
   * If `true`, the button will take up the full width of its container.
   */
  fullWidth: _propTypes.default.bool,

  /**
   * The URL to link to when the button is clicked.
   * If defined, an `a` element will be used as the root node.
   */
  href: _propTypes.default.string,

  /**
   * If `true`, and `variant` is `'fab'`, will use mini floating action button styling.
   */
  mini: _propTypes.default.bool,

  /**
   * The size of the button.
   * `small` is equivalent to the dense button styling.
   */
  size: _propTypes.default.oneOf(['small', 'medium', 'large']),

  /**
   * @ignore
   */
  type: _propTypes.default.string,

  /**
   * The variant to use.
   */
  variant: _propTypes.default.oneOf(['text', 'flat', 'outlined', 'contained', 'raised', 'fab', 'extendedFab'])
} : {};
Button.defaultProps = {
  color: 'default',
  component: 'button',
  disabled: false,
  disableFocusRipple: false,
  fullWidth: false,
  mini: false,
  size: 'medium',
  type: 'button',
  variant: 'text'
};

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiButton'
})(Button);

exports.default = _default;

/***/ }),
/* 513 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__ = __webpack_require__(21);
// ##############################
// // // Button styles
// #############################
var buttonStyle={button:{minHeight:"auto",minWidth:"auto",backgroundColor:__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["l" /* grayColor */],color:"#FFFFFF",boxShadow:"0 2px 2px 0 rgba(153, 153, 153, 0.14), 0 3px 1px -2px rgba(153, 153, 153, 0.2), 0 1px 5px 0 rgba(153, 153, 153, 0.12)",border:"none",borderRadius:"3px",position:"relative",padding:"12px 30px",margin:".3125rem 1px",fontSize:"12px",fontWeight:"400",textTransform:"uppercase",letterSpacing:"0",willChange:"box-shadow, transform",transition:"box-shadow 0.2s cubic-bezier(0.4, 0, 1, 1), background-color 0.2s cubic-bezier(0.4, 0, 0.2, 1)",lineHeight:"1.42857143",textAlign:"center",whiteSpace:"nowrap",verticalAlign:"middle",touchAction:"manipulation",cursor:"pointer","&:hover,&:focus":{color:"#FFFFFF",backgroundColor:__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["l" /* grayColor */],boxShadow:"0 14px 26px -12px rgba(153, 153, 153, 0.42), 0 4px 23px 0px rgba(0, 0, 0, 0.12), 0 8px 10px -5px rgba(153, 153, 153, 0.2)"},"& .fab,& .fas,& .far,& .fal,& .material-icons":{position:"relative",display:"inline-block",top:"0",marginTop:"-1em",marginBottom:"-1em",fontSize:"1.1rem",marginRight:"4px",verticalAlign:"middle"},"& svg":{position:"relative",display:"inline-block",top:"0",width:"18px",height:"18px",marginRight:"4px",verticalAlign:"middle"},"&$justIcon":{"& .fab,& .fas,& .far,& .fal,& .material-icons":{marginTop:"0px",position:"absolute",width:"100%",transform:"none",left:"0px",top:"0px",height:"100%",lineHeight:"41px",fontSize:"20px"}}},fullWidth:{width:"100%"},primary:{backgroundColor:__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["r" /* primaryColor */],boxShadow:"0 2px 2px 0 rgba(156, 39, 176, 0.14), 0 3px 1px -2px rgba(156, 39, 176, 0.2), 0 1px 5px 0 rgba(156, 39, 176, 0.12)","&:hover,&:focus":{backgroundColor:__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["r" /* primaryColor */],boxShadow:"0 14px 26px -12px rgba(156, 39, 176, 0.42), 0 4px 23px 0px rgba(0, 0, 0, 0.12), 0 8px 10px -5px rgba(156, 39, 176, 0.2)"}},info:{backgroundColor:__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["o" /* infoColor */],boxShadow:"0 2px 2px 0 rgba(0, 188, 212, 0.14), 0 3px 1px -2px rgba(0, 188, 212, 0.2), 0 1px 5px 0 rgba(0, 188, 212, 0.12)","&:hover,&:focus":{backgroundColor:__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["o" /* infoColor */],boxShadow:"0 14px 26px -12px rgba(0, 188, 212, 0.42), 0 4px 23px 0px rgba(0, 0, 0, 0.12), 0 8px 10px -5px rgba(0, 188, 212, 0.2)"}},success:{backgroundColor:__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["x" /* successColor */],boxShadow:"0 2px 2px 0 rgba(76, 175, 80, 0.14), 0 3px 1px -2px rgba(76, 175, 80, 0.2), 0 1px 5px 0 rgba(76, 175, 80, 0.12)","&:hover,&:focus":{backgroundColor:__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["x" /* successColor */],boxShadow:"0 14px 26px -12px rgba(76, 175, 80, 0.42), 0 4px 23px 0px rgba(0, 0, 0, 0.12), 0 8px 10px -5px rgba(76, 175, 80, 0.2)"}},warning:{backgroundColor:__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["B" /* warningColor */],boxShadow:"0 2px 2px 0 rgba(255, 152, 0, 0.14), 0 3px 1px -2px rgba(255, 152, 0, 0.2), 0 1px 5px 0 rgba(255, 152, 0, 0.12)","&:hover,&:focus":{backgroundColor:__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["B" /* warningColor */],boxShadow:"0 14px 26px -12px rgba(255, 152, 0, 0.42), 0 4px 23px 0px rgba(0, 0, 0, 0.12), 0 8px 10px -5px rgba(255, 152, 0, 0.2)"}},danger:{backgroundColor:__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["g" /* dangerColor */],boxShadow:"0 2px 2px 0 rgba(244, 67, 54, 0.14), 0 3px 1px -2px rgba(244, 67, 54, 0.2), 0 1px 5px 0 rgba(244, 67, 54, 0.12)","&:hover,&:focus":{backgroundColor:__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["g" /* dangerColor */],boxShadow:"0 14px 26px -12px rgba(244, 67, 54, 0.42), 0 4px 23px 0px rgba(0, 0, 0, 0.12), 0 8px 10px -5px rgba(244, 67, 54, 0.2)"}},rose:{backgroundColor:__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["u" /* roseColor */],boxShadow:"0 2px 2px 0 rgba(233, 30, 99, 0.14), 0 3px 1px -2px rgba(233, 30, 99, 0.2), 0 1px 5px 0 rgba(233, 30, 99, 0.12)","&:hover,&:focus":{backgroundColor:__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["u" /* roseColor */],boxShadow:"0 14px 26px -12px rgba(233, 30, 99, 0.42), 0 4px 23px 0px rgba(0, 0, 0, 0.12), 0 8px 10px -5px rgba(233, 30, 99, 0.2)"}},white:{"&,&:focus,&:hover":{backgroundColor:"#FFFFFF",color:__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["l" /* grayColor */]}},twitter:{backgroundColor:"#55acee",color:"#fff",boxShadow:"0 2px 2px 0 rgba(85, 172, 238, 0.14), 0 3px 1px -2px rgba(85, 172, 238, 0.2), 0 1px 5px 0 rgba(85, 172, 238, 0.12)","&:hover,&:focus,&:visited":{backgroundColor:"#55acee",color:"#fff",boxShadow:"0 14px 26px -12px rgba(85, 172, 238, 0.42), 0 4px 23px 0px rgba(0, 0, 0, 0.12), 0 8px 10px -5px rgba(85, 172, 238, 0.2)"}},facebook:{backgroundColor:"#3b5998",color:"#fff",boxShadow:"0 2px 2px 0 rgba(59, 89, 152, 0.14), 0 3px 1px -2px rgba(59, 89, 152, 0.2), 0 1px 5px 0 rgba(59, 89, 152, 0.12)","&:hover,&:focus":{backgroundColor:"#3b5998",color:"#fff",boxShadow:"0 14px 26px -12px rgba(59, 89, 152, 0.42), 0 4px 23px 0px rgba(0, 0, 0, 0.12), 0 8px 10px -5px rgba(59, 89, 152, 0.2)"}},google:{backgroundColor:"#dd4b39",color:"#fff",boxShadow:"0 2px 2px 0 rgba(221, 75, 57, 0.14), 0 3px 1px -2px rgba(221, 75, 57, 0.2), 0 1px 5px 0 rgba(221, 75, 57, 0.12)","&:hover,&:focus":{backgroundColor:"#dd4b39",color:"#fff",boxShadow:"0 14px 26px -12px rgba(221, 75, 57, 0.42), 0 4px 23px 0px rgba(0, 0, 0, 0.12), 0 8px 10px -5px rgba(221, 75, 57, 0.2)"}},linkedin:{backgroundColor:"#0976b4",color:"#fff",boxShadow:"0 2px 2px 0 rgba(9, 118, 180, 0.14), 0 3px 1px -2px rgba(9, 118, 180, 0.2), 0 1px 5px 0 rgba(9, 118, 180, 0.12)","&:hover,&:focus":{backgroundColor:"#0976b4",color:"#fff",boxShadow:"0 14px 26px -12px rgba(9, 118, 180, 0.42), 0 4px 23px 0px rgba(0, 0, 0, 0.12), 0 8px 10px -5px rgba(9, 118, 180, 0.2)"}},pinterest:{backgroundColor:"#cc2127",color:"#fff",boxShadow:"0 2px 2px 0 rgba(204, 33, 39, 0.14), 0 3px 1px -2px rgba(204, 33, 39, 0.2), 0 1px 5px 0 rgba(204, 33, 39, 0.12)","&:hover,&:focus":{backgroundColor:"#cc2127",color:"#fff",boxShadow:"0 14px 26px -12px rgba(204, 33, 39, 0.42), 0 4px 23px 0px rgba(0, 0, 0, 0.12), 0 8px 10px -5px rgba(204, 33, 39, 0.2)"}},youtube:{backgroundColor:"#e52d27",color:"#fff",boxShadow:"0 2px 2px 0 rgba(229, 45, 39, 0.14), 0 3px 1px -2px rgba(229, 45, 39, 0.2), 0 1px 5px 0 rgba(229, 45, 39, 0.12)","&:hover,&:focus":{backgroundColor:"#e52d27",color:"#fff",boxShadow:"0 14px 26px -12px rgba(229, 45, 39, 0.42), 0 4px 23px 0px rgba(0, 0, 0, 0.12), 0 8px 10px -5px rgba(229, 45, 39, 0.2)"}},tumblr:{backgroundColor:"#35465c",color:"#fff",boxShadow:"0 2px 2px 0 rgba(53, 70, 92, 0.14), 0 3px 1px -2px rgba(53, 70, 92, 0.2), 0 1px 5px 0 rgba(53, 70, 92, 0.12)","&:hover,&:focus":{backgroundColor:"#35465c",color:"#fff",boxShadow:"0 14px 26px -12px rgba(53, 70, 92, 0.42), 0 4px 23px 0px rgba(0, 0, 0, 0.12), 0 8px 10px -5px rgba(53, 70, 92, 0.2)"}},github:{backgroundColor:"#333333",color:"#fff",boxShadow:"0 2px 2px 0 rgba(51, 51, 51, 0.14), 0 3px 1px -2px rgba(51, 51, 51, 0.2), 0 1px 5px 0 rgba(51, 51, 51, 0.12)","&:hover,&:focus":{backgroundColor:"#333333",color:"#fff",boxShadow:"0 14px 26px -12px rgba(51, 51, 51, 0.42), 0 4px 23px 0px rgba(0, 0, 0, 0.12), 0 8px 10px -5px rgba(51, 51, 51, 0.2)"}},behance:{backgroundColor:"#1769ff",color:"#fff",boxShadow:"0 2px 2px 0 rgba(23, 105, 255, 0.14), 0 3px 1px -2px rgba(23, 105, 255, 0.2), 0 1px 5px 0 rgba(23, 105, 255, 0.12)","&:hover,&:focus":{backgroundColor:"#1769ff",color:"#fff",boxShadow:"0 14px 26px -12px rgba(23, 105, 255, 0.42), 0 4px 23px 0px rgba(0, 0, 0, 0.12), 0 8px 10px -5px rgba(23, 105, 255, 0.2)"}},dribbble:{backgroundColor:"#ea4c89",color:"#fff",boxShadow:"0 2px 2px 0 rgba(234, 76, 137, 0.14), 0 3px 1px -2px rgba(234, 76, 137, 0.2), 0 1px 5px 0 rgba(234, 76, 137, 0.12)","&:hover,&:focus":{backgroundColor:"#ea4c89",color:"#fff",boxShadow:"0 14px 26px -12px rgba(234, 76, 137, 0.42), 0 4px 23px 0px rgba(0, 0, 0, 0.12), 0 8px 10px -5px rgba(234, 76, 137, 0.2)"}},reddit:{backgroundColor:"#ff4500",color:" #fff",boxShadow:"0 2px 2px 0 rgba(255, 69, 0, 0.14), 0 3px 1px -2px rgba(255, 69, 0, 0.2), 0 1px 5px 0 rgba(255, 69, 0, 0.12)","&:hover,&:focus":{backgroundColor:"#ff4500",color:" #fff",boxShadow:"0 14px 26px -12px rgba(255, 69, 0, 0.42), 0 4px 23px 0px rgba(0, 0, 0, 0.12), 0 8px 10px -5px rgba(255, 69, 0, 0.2)"}},simple:{"&,&:focus,&:hover":{color:"#FFFFFF",background:"transparent",boxShadow:"none"},"&$primary":{"&,&:focus,&:hover,&:visited":{color:__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["r" /* primaryColor */]}},"&$info":{"&,&:focus,&:hover,&:visited":{color:__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["o" /* infoColor */]}},"&$success":{"&,&:focus,&:hover,&:visited":{color:__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["x" /* successColor */]}},"&$warning":{"&,&:focus,&:hover,&:visited":{color:__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["B" /* warningColor */]}},"&$rose":{"&,&:focus,&:hover,&:visited":{color:__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["u" /* roseColor */]}},"&$danger":{"&,&:focus,&:hover,&:visited":{color:__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["g" /* dangerColor */]}},"&$twitter":{"&,&:focus,&:hover,&:visited":{color:"#55acee"}},"&$facebook":{"&,&:focus,&:hover,&:visited":{color:"#3b5998"}},"&$google":{"&,&:focus,&:hover,&:visited":{color:"#dd4b39"}},"&$linkedin":{"&,&:focus,&:hover,&:visited":{color:"#0976b4"}},"&$pinterest":{"&,&:focus,&:hover,&:visited":{color:"#cc2127"}},"&$youtube":{"&,&:focus,&:hover,&:visited":{color:"#e52d27"}},"&$tumblr":{"&,&:focus,&:hover,&:visited":{color:"#35465c"}},"&$github":{"&,&:focus,&:hover,&:visited":{color:"#333333"}},"&$behance":{"&,&:focus,&:hover,&:visited":{color:"#1769ff"}},"&$dribbble":{"&,&:focus,&:hover,&:visited":{color:"#ea4c89"}},"&$reddit":{"&,&:focus,&:hover,&:visited":{color:"#ff4500"}}},transparent:{"&,&:focus,&:hover":{color:"inherit",background:"transparent",boxShadow:"none"}},disabled:{opacity:"0.65",pointerEvents:"none"},lg:{padding:"1.125rem 2.25rem",fontSize:"0.875rem",lineHeight:"1.333333",borderRadius:"0.2rem"},sm:{padding:"0.40625rem 1.25rem",fontSize:"0.6875rem",lineHeight:"1.5",borderRadius:"0.2rem"},round:{borderRadius:"30px"},block:{width:"100% !important"},link:{"&,&:hover,&:focus":{backgroundColor:"transparent",color:"#999999",boxShadow:"none"}},justIcon:{paddingLeft:"12px",paddingRight:"12px",fontSize:"20px",height:"41px",minWidth:"41px",width:"41px","& .fab,& .fas,& .far,& .fal,& svg,& .material-icons":{marginRight:"0px"},"&$lg":{height:"57px",minWidth:"57px",width:"57px",lineHeight:"56px","& .fab,& .fas,& .far,& .fal,& .material-icons":{fontSize:"32px",lineHeight:"56px"},"& svg":{width:"32px",height:"32px"}},"&$sm":{height:"30px",minWidth:"30px",width:"30px","& .fab,& .fas,& .far,& .fal,& .material-icons":{fontSize:"17px",lineHeight:"29px"},"& svg":{width:"17px",height:"17px"}}}};/* harmony default export */ __webpack_exports__["a"] = (buttonStyle);

/***/ }),
/* 514 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// import {
//
// } from "assets/jss/material-dashboard-pro-react.jsx";
var cardStyle={card:{border:"0",marginBottom:"30px",marginTop:"30px",borderRadius:"6px",color:"rgba(0, 0, 0, 0.87)",background:"#fff",width:"100%",boxShadow:"0 1px 4px 0 rgba(0, 0, 0, 0.14)",position:"relative",display:"flex",flexDirection:"column",minWidth:"0",wordWrap:"break-word",fontSize:".875rem"},cardPlain:{background:"transparent",boxShadow:"none"},cardProfile:{marginTop:"30px",textAlign:"center"},cardBlog:{marginTop:"60px"},cardRaised:{boxShadow:"0 16px 38px -12px rgba(0, 0, 0, 0.56), 0 4px 25px 0px rgba(0, 0, 0, 0.12), 0 8px 10px -5px rgba(0, 0, 0, 0.2)"},cardBackground:{backgroundPosition:"center center",backgroundSize:"cover",textAlign:"center","&:after":{position:"absolute",zIndex:"1",width:"100%",height:"100%",display:"block",left:"0",top:"0",content:'""',backgroundColor:"rgba(0, 0, 0, 0.56)",borderRadius:"6px"},"& small":{color:"rgba(255, 255, 255, 0.7) !important"}},cardPricing:{textAlign:"center","&:after":{backgroundColor:"rgba(0, 0, 0, 0.7) !important"},"& ul":{listStyle:"none",padding:0,maxWidth:"240px",margin:"10px auto"},"& ul li":{color:"#999999",textAlign:"center",padding:"12px 0px",borderBottom:"1px solid rgba(153,153,153,0.3)"},"& ul li:last-child":{border:0},"& ul li b":{color:"#3c4858"},"& h1":{marginTop:"30px"},"& h1 small":{display:"inline-flex",height:0,fontSize:"18px"},"& h1 small:first-child":{position:"relative",top:"-17px",fontSize:"26px"},"& ul li svg, & ul li .fab,& ul li .fas,& ul li .far,& ul li .fal,& ul li .material-icons":{position:"relative",top:"7px"}},cardPricingColor:{"& ul li":{color:"#fff",borderColor:"rgba(255,255,255,0.3)","& b, & svg,& .fab,& .fas,& .far,& .fal,& .material-icons":{color:"#fff",fontWeight:"700"}}},cardProduct:{marginTop:"30px"},primary:{background:"linear-gradient(60deg,#ab47bc,#7b1fa2)","& h1 small":{color:"rgba(255, 255, 255, 0.8)"},color:"#FFFFFF"},info:{background:"linear-gradient(60deg,#26c6da,#0097a7)","& h1 small":{color:"rgba(255, 255, 255, 0.8)"},color:"#FFFFFF"},success:{background:"linear-gradient(60deg,#66bb6a,#388e3c)","& h1 small":{color:"rgba(255, 255, 255, 0.8)"},color:"#FFFFFF"},warning:{background:"linear-gradient(60deg,#ffa726,#f57c00)","& h1 small":{color:"rgba(255, 255, 255, 0.8)"},color:"#FFFFFF"},danger:{background:"linear-gradient(60deg,#ef5350,#d32f2f)","& h1 small":{color:"rgba(255, 255, 255, 0.8)"},color:"#FFFFFF"},rose:{background:"linear-gradient(60deg,#ec407a,#c2185b)","& h1 small":{color:"rgba(255, 255, 255, 0.8)"},color:"#FFFFFF"},cardChart:{"& p":{marginTop:"0px",paddingTop:"0px"}},cardLogin:{transform:"translate3d(0, 0, 0)",transition:"all 300ms linear"}};/* harmony default export */ __webpack_exports__["a"] = (cardStyle);

/***/ }),
/* 515 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var cardBodyStyle={cardBody:{padding:"0.9375rem 20px",flex:"1 1 auto",WebkitBoxFlex:"1",position:"relative"},cardBodyBackground:{position:"relative",zIndex:"2",minHeight:"280px",paddingTop:"40px",paddingBottom:"40px",maxWidth:"440px",margin:"0 auto"},cardBodyPlain:{paddingLeft:"5px",paddingRight:"5px"},cardBodyFormHorizontal:{paddingLeft:"15px",paddingRight:"15px","& form":{margin:"0"}},cardPricing:{padding:"15px!important",margin:"0px!important"},cardSignup:{padding:"0px 30px 0px 30px"},cardBodyColor:{borderRadius:"6px","&":{"h1, h2, h3":{"& small":{color:"rgba(255, 255, 255, 0.8)"}}}},cardBodyProfile:{marginTop:"15px"},cardBodyCalendar:{padding:"0px !important"}};/* harmony default export */ __webpack_exports__["a"] = (cardBodyStyle);

/***/ }),
/* 516 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles_withStyles__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_assets_jss_material_dashboard_pro_react_components_cardHeaderStyle_jsx__ = __webpack_require__(517);
function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}// nodejs library that concatenates classes
// nodejs library to set properties for components
// @material-ui/core components
// @material-ui/icons
// core components
function CardHeader(_ref){var _classNames;var props=_objectWithoutProperties(_ref,[]);var classes=props.classes,className=props.className,children=props.children,color=props.color,plain=props.plain,image=props.image,contact=props.contact,signup=props.signup,stats=props.stats,icon=props.icon,text=props.text,rest=_objectWithoutProperties(props,["classes","className","children","color","plain","image","contact","signup","stats","icon","text"]);var cardHeaderClasses=__WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classNames={},_defineProperty(_classNames,classes.cardHeader,true),_defineProperty(_classNames,classes[color+"CardHeader"],color),_defineProperty(_classNames,classes.cardHeaderPlain,plain),_defineProperty(_classNames,classes.cardHeaderImage,image),_defineProperty(_classNames,classes.cardHeaderContact,contact),_defineProperty(_classNames,classes.cardHeaderSignup,signup),_defineProperty(_classNames,classes.cardHeaderStats,stats),_defineProperty(_classNames,classes.cardHeaderIcon,icon),_defineProperty(_classNames,classes.cardHeaderText,text),_defineProperty(_classNames,className,className!==undefined),_classNames));return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",Object.assign({className:cardHeaderClasses},rest),children);}CardHeader.propTypes={classes:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired,className:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,color:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOf(["warning","success","danger","info","primary","rose"]),plain:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,image:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,contact:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,signup:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,stats:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,icon:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,text:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool};/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles_withStyles___default()(__WEBPACK_IMPORTED_MODULE_4_assets_jss_material_dashboard_pro_react_components_cardHeaderStyle_jsx__["a" /* default */])(CardHeader));

/***/ }),
/* 517 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__ = __webpack_require__(21);
var cardHeaderStyle={cardHeader:{padding:"0.75rem 1.25rem",marginBottom:"0",borderBottom:"none",background:"transparent",zIndex:"3 !important","&$cardHeaderPlain,&$cardHeaderImage,&$cardHeaderContact,&$cardHeaderSignup,&$cardHeaderIcon,&$cardHeaderStats,&$warningCardHeader,&$successCardHeader,&$dangerCardHeader,&$infoCardHeader,&$primaryCardHeader,&$roseCardHeader":{margin:"0 15px",padding:"0",position:"relative",color:"#FFFFFF"},"&:first-child":{borderRadius:"calc(.25rem - 1px) calc(.25rem - 1px) 0 0"},"&$warningCardHeader,&$successCardHeader,&$dangerCardHeader,&$infoCardHeader,&$primaryCardHeader,&$roseCardHeader":{"&:not($cardHeaderIcon):not($cardHeaderImage):not($cardHeaderText)":{borderRadius:"3px",marginTop:"-20px",padding:"15px"}},"&$cardHeaderStats svg":{fontSize:"36px",lineHeight:"56px",textAlign:"center",width:"36px",height:"36px",margin:"10px 10px 4px"},"&$cardHeaderStats .fab,&$cardHeaderStats .fas,&$cardHeaderStats .far,&$cardHeaderStats .fal,&$cardHeaderStats .material-icons":{fontSize:"36px",lineHeight:"56px",width:"56px",height:"56px",textAlign:"center",overflow:"unset",marginBottom:"1px"},"&$cardHeaderStats$cardHeaderIcon":{textAlign:"right"},"&$cardHeaderImage":{marginLeft:"15px",marginRight:"15px",marginTop:"-30px",borderRadius:"6px"},"&$cardHeaderText":{display:"inline-block"}},cardHeaderPlain:{marginLeft:"0px",marginRight:"0px","&$cardHeaderImage":{margin:"0 !important"}},cardHeaderImage:{position:"relative",padding:"0",zIndex:"1","& img":{width:"100%",borderRadius:"6px",pointerEvents:"none",boxShadow:"0 5px 15px -8px rgba(0, 0, 0, 0.24), 0 8px 10px -5px rgba(0, 0, 0, 0.2)"},"& a":{display:"block"}},cardHeaderContact:{margin:"0 15px",marginTop:"-20px"},cardHeaderSignup:{marginLeft:"20px",marginRight:"20px",marginTop:"-40px",padding:"20px 0",width:"100%",marginBottom:"15px"},cardHeaderStats:{"& $cardHeaderIcon":{textAlign:"right"},"& h1,& h2,& h3,& h4,& h5,& h6":{margin:"0 !important"}},cardHeaderIcon:{"&$warningCardHeader,&$successCardHeader,&$dangerCardHeader,&$infoCardHeader,&$primaryCardHeader,&$roseCardHeader":{background:"transparent",boxShadow:"none"},"& .fab,& .fas,& .far,& .fal,& .material-icons":{width:"33px",height:"33px",textAlign:"center",lineHeight:"33px"},"& svg":{width:"24px",height:"24px",textAlign:"center",lineHeight:"33px",margin:"5px 4px 0px"}},cardHeaderText:{},warningCardHeader:{color:"#FFFFFF","&:not($cardHeaderText):not($cardHeaderIcon)":Object.assign({},__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["A" /* warningCardHeader */])},successCardHeader:{color:"#FFFFFF","&:not($cardHeaderText):not($cardHeaderIcon)":Object.assign({},__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["w" /* successCardHeader */])},dangerCardHeader:{color:"#FFFFFF","&:not($cardHeaderText):not($cardHeaderIcon)":Object.assign({},__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["f" /* dangerCardHeader */])},infoCardHeader:{color:"#FFFFFF","&:not($cardHeaderText):not($cardHeaderIcon)":Object.assign({},__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["n" /* infoCardHeader */])},primaryCardHeader:{color:"#FFFFFF","&:not($cardHeaderText):not($cardHeaderIcon)":Object.assign({},__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["q" /* primaryCardHeader */])},roseCardHeader:{color:"#FFFFFF","&:not($cardHeaderText):not($cardHeaderIcon)":Object.assign({},__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["t" /* roseCardHeader */])}};/* harmony default export */ __webpack_exports__["a"] = (cardHeaderStyle);

/***/ }),
/* 518 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles_withStyles__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_assets_jss_material_dashboard_pro_react_components_cardIconStyle_jsx__ = __webpack_require__(519);
function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}// nodejs library that concatenates classes
// nodejs library to set properties for components
// @material-ui/core components
// @material-ui/icons
// core components
function CardIcon(_ref){var _classNames;var props=_objectWithoutProperties(_ref,[]);var classes=props.classes,className=props.className,children=props.children,color=props.color,rest=_objectWithoutProperties(props,["classes","className","children","color"]);var cardIconClasses=__WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classNames={},_defineProperty(_classNames,classes.cardIcon,true),_defineProperty(_classNames,classes[color+"CardHeader"],color),_defineProperty(_classNames,className,className!==undefined),_classNames));return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",Object.assign({className:cardIconClasses},rest),children);}CardIcon.propTypes={classes:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired,className:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,color:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOf(["warning","success","danger","info","primary","rose"])};/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles_withStyles___default()(__WEBPACK_IMPORTED_MODULE_4_assets_jss_material_dashboard_pro_react_components_cardIconStyle_jsx__["a" /* default */])(CardIcon));

/***/ }),
/* 519 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__ = __webpack_require__(21);
var cardIconStyle={cardIcon:{"&$warningCardHeader,&$successCardHeader,&$dangerCardHeader,&$infoCardHeader,&$primaryCardHeader,&$roseCardHeader":{borderRadius:"3px",backgroundColor:"#999",padding:"15px",marginTop:"-20px",marginRight:"15px",float:"left"}},warningCardHeader:__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["A" /* warningCardHeader */],successCardHeader:__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["w" /* successCardHeader */],dangerCardHeader:__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["f" /* dangerCardHeader */],infoCardHeader:__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["n" /* infoCardHeader */],primaryCardHeader:__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["q" /* primaryCardHeader */],roseCardHeader:__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["t" /* roseCardHeader */]};/* harmony default export */ __webpack_exports__["a"] = (cardIconStyle);

/***/ }),
/* 520 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(2);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _defineProperty2 = _interopRequireDefault(__webpack_require__(7));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(4));

var _objectSpread2 = _interopRequireDefault(__webpack_require__(17));

var _extends2 = _interopRequireDefault(__webpack_require__(6));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _classnames = _interopRequireDefault(__webpack_require__(5));

var _withStyles = _interopRequireDefault(__webpack_require__(3));

var _createBreakpoints = __webpack_require__(92);

var _requirePropFactory = _interopRequireDefault(__webpack_require__(521));

// A grid component using the following libs as inspiration.
//
// For the implementation:
// - http://v4-alpha.getbootstrap.com/layout/flexbox-grid/
// - https://github.com/kristoferjoseph/flexboxgrid/blob/master/src/css/flexboxgrid.css
// - https://github.com/roylee0704/react-flexbox-grid
// - https://material.angularjs.org/latest/layout/introduction
//
// Follow this flexbox Guide to better understand the underlying model:
// - https://css-tricks.com/snippets/css/a-guide-to-flexbox/
var GUTTERS = [0, 8, 16, 24, 32, 40];
var GRID_SIZES = ['auto', true, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];

function generateGrid(globalStyles, theme, breakpoint) {
  var styles = {};
  GRID_SIZES.forEach(function (size) {
    var key = "grid-".concat(breakpoint, "-").concat(size);

    if (size === true) {
      // For the auto layouting
      styles[key] = {
        flexBasis: 0,
        flexGrow: 1,
        maxWidth: '100%'
      };
      return;
    }

    if (size === 'auto') {
      styles[key] = {
        flexBasis: 'auto',
        flexGrow: 0,
        maxWidth: 'none'
      };
      return;
    } // Only keep 6 significant numbers.


    var width = "".concat(Math.round(size / 12 * 10e6) / 10e4, "%"); // Close to the bootstrap implementation:
    // https://github.com/twbs/bootstrap/blob/8fccaa2439e97ec72a4b7dc42ccc1f649790adb0/scss/mixins/_grid.scss#L41

    styles[key] = {
      flexBasis: width,
      flexGrow: 0,
      maxWidth: width
    };
  }); // No need for a media query for the first size.

  if (breakpoint === 'xs') {
    (0, _extends2.default)(globalStyles, styles);
  } else {
    globalStyles[theme.breakpoints.up(breakpoint)] = styles;
  }
}

function generateGutter(theme, breakpoint) {
  var styles = {};
  GUTTERS.forEach(function (spacing, index) {
    if (index === 0) {
      // Skip the default style.
      return;
    }

    styles["spacing-".concat(breakpoint, "-").concat(spacing)] = {
      margin: -spacing / 2,
      width: "calc(100% + ".concat(spacing, "px)"),
      '& > $item': {
        padding: spacing / 2
      }
    };
  });
  return styles;
} // Default CSS values
// flex: '0 1 auto',
// flexDirection: 'row',
// alignItems: 'flex-start',
// flexWrap: 'nowrap',
// justifyContent: 'flex-start',


var styles = function styles(theme) {
  return (0, _objectSpread2.default)({
    /* Styles applied to the root element if `container={true}`. */
    container: {
      boxSizing: 'border-box',
      display: 'flex',
      flexWrap: 'wrap',
      width: '100%'
    },

    /* Styles applied to the root element if `item={true}`. */
    item: {
      boxSizing: 'border-box',
      margin: '0' // For instance, it's useful when used with a `figure` element.

    },

    /* Styles applied to the root element if `zeroMinWidth={true}`. */
    zeroMinWidth: {
      minWidth: 0
    },

    /* Styles applied to the root element if `direction="column"`. */
    'direction-xs-column': {
      flexDirection: 'column'
    },

    /* Styles applied to the root element if `direction="column-reverse"`. */
    'direction-xs-column-reverse': {
      flexDirection: 'column-reverse'
    },

    /* Styles applied to the root element if `direction="rwo-reverse"`. */
    'direction-xs-row-reverse': {
      flexDirection: 'row-reverse'
    },

    /* Styles applied to the root element if `wrap="nowrap"`. */
    'wrap-xs-nowrap': {
      flexWrap: 'nowrap'
    },

    /* Styles applied to the root element if `wrap="reverse"`. */
    'wrap-xs-wrap-reverse': {
      flexWrap: 'wrap-reverse'
    },

    /* Styles applied to the root element if `alignItems="center"`. */
    'align-items-xs-center': {
      alignItems: 'center'
    },

    /* Styles applied to the root element if `alignItems="flex-start"`. */
    'align-items-xs-flex-start': {
      alignItems: 'flex-start'
    },

    /* Styles applied to the root element if `alignItems="flex-end"`. */
    'align-items-xs-flex-end': {
      alignItems: 'flex-end'
    },

    /* Styles applied to the root element if `alignItems="baseline"`. */
    'align-items-xs-baseline': {
      alignItems: 'baseline'
    },

    /* Styles applied to the root element if `alignContent="center"`. */
    'align-content-xs-center': {
      alignContent: 'center'
    },

    /* Styles applied to the root element if `alignContent="flex-start"`. */
    'align-content-xs-flex-start': {
      alignContent: 'flex-start'
    },

    /* Styles applied to the root element if `alignContent="flex-end"`. */
    'align-content-xs-flex-end': {
      alignContent: 'flex-end'
    },

    /* Styles applied to the root element if `alignContent="space-between"`. */
    'align-content-xs-space-between': {
      alignContent: 'space-between'
    },

    /* Styles applied to the root element if `alignContent="space-around"`. */
    'align-content-xs-space-around': {
      alignContent: 'space-around'
    },

    /* Styles applied to the root element if `justify="center"`. */
    'justify-xs-center': {
      justifyContent: 'center'
    },

    /* Styles applied to the root element if `justify="flex-end"`. */
    'justify-xs-flex-end': {
      justifyContent: 'flex-end'
    },

    /* Styles applied to the root element if `justify="space-between"`. */
    'justify-xs-space-between': {
      justifyContent: 'space-between'
    },

    /* Styles applied to the root element if `justify="space-around"`. */
    'justify-xs-space-around': {
      justifyContent: 'space-around'
    },

    /* Styles applied to the root element if `justify="space-evenly"`. */
    'justify-xs-space-evenly': {
      justifyContent: 'space-evenly'
    }
  }, generateGutter(theme, 'xs'), _createBreakpoints.keys.reduce(function (accumulator, key) {
    // Use side effect over immutability for better performance.
    generateGrid(accumulator, theme, key);
    return accumulator;
  }, {}));
};

exports.styles = styles;

function Grid(props) {
  var _classNames;

  var alignContent = props.alignContent,
      alignItems = props.alignItems,
      classes = props.classes,
      classNameProp = props.className,
      Component = props.component,
      container = props.container,
      direction = props.direction,
      item = props.item,
      justify = props.justify,
      lg = props.lg,
      md = props.md,
      sm = props.sm,
      spacing = props.spacing,
      wrap = props.wrap,
      xl = props.xl,
      xs = props.xs,
      zeroMinWidth = props.zeroMinWidth,
      other = (0, _objectWithoutProperties2.default)(props, ["alignContent", "alignItems", "classes", "className", "component", "container", "direction", "item", "justify", "lg", "md", "sm", "spacing", "wrap", "xl", "xs", "zeroMinWidth"]);
  var className = (0, _classnames.default)((_classNames = {}, (0, _defineProperty2.default)(_classNames, classes.container, container), (0, _defineProperty2.default)(_classNames, classes.item, item), (0, _defineProperty2.default)(_classNames, classes.zeroMinWidth, zeroMinWidth), (0, _defineProperty2.default)(_classNames, classes["spacing-xs-".concat(String(spacing))], container && spacing !== 0), (0, _defineProperty2.default)(_classNames, classes["direction-xs-".concat(String(direction))], direction !== Grid.defaultProps.direction), (0, _defineProperty2.default)(_classNames, classes["wrap-xs-".concat(String(wrap))], wrap !== Grid.defaultProps.wrap), (0, _defineProperty2.default)(_classNames, classes["align-items-xs-".concat(String(alignItems))], alignItems !== Grid.defaultProps.alignItems), (0, _defineProperty2.default)(_classNames, classes["align-content-xs-".concat(String(alignContent))], alignContent !== Grid.defaultProps.alignContent), (0, _defineProperty2.default)(_classNames, classes["justify-xs-".concat(String(justify))], justify !== Grid.defaultProps.justify), (0, _defineProperty2.default)(_classNames, classes["grid-xs-".concat(String(xs))], xs !== false), (0, _defineProperty2.default)(_classNames, classes["grid-sm-".concat(String(sm))], sm !== false), (0, _defineProperty2.default)(_classNames, classes["grid-md-".concat(String(md))], md !== false), (0, _defineProperty2.default)(_classNames, classes["grid-lg-".concat(String(lg))], lg !== false), (0, _defineProperty2.default)(_classNames, classes["grid-xl-".concat(String(xl))], xl !== false), _classNames), classNameProp);
  return _react.default.createElement(Component, (0, _extends2.default)({
    className: className
  }, other));
}

Grid.propTypes =  false ? {
  /**
   * Defines the `align-content` style property.
   * It's applied for all screen sizes.
   */
  alignContent: _propTypes.default.oneOf(['stretch', 'center', 'flex-start', 'flex-end', 'space-between', 'space-around']),

  /**
   * Defines the `align-items` style property.
   * It's applied for all screen sizes.
   */
  alignItems: _propTypes.default.oneOf(['flex-start', 'center', 'flex-end', 'stretch', 'baseline']),

  /**
   * The content of the component.
   */
  children: _propTypes.default.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * The component used for the root node.
   * Either a string to use a DOM element or a component.
   */
  component: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func, _propTypes.default.object]),

  /**
   * If `true`, the component will have the flex *container* behavior.
   * You should be wrapping *items* with a *container*.
   */
  container: _propTypes.default.bool,

  /**
   * Defines the `flex-direction` style property.
   * It is applied for all screen sizes.
   */
  direction: _propTypes.default.oneOf(['row', 'row-reverse', 'column', 'column-reverse']),

  /**
   * If `true`, the component will have the flex *item* behavior.
   * You should be wrapping *items* with a *container*.
   */
  item: _propTypes.default.bool,

  /**
   * Defines the `justify-content` style property.
   * It is applied for all screen sizes.
   */
  justify: _propTypes.default.oneOf(['flex-start', 'center', 'flex-end', 'space-between', 'space-around', 'space-evenly']),

  /**
   * Defines the number of grids the component is going to use.
   * It's applied for the `lg` breakpoint and wider screens if not overridden.
   */
  lg: _propTypes.default.oneOf([false, 'auto', true, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]),

  /**
   * Defines the number of grids the component is going to use.
   * It's applied for the `md` breakpoint and wider screens if not overridden.
   */
  md: _propTypes.default.oneOf([false, 'auto', true, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]),

  /**
   * Defines the number of grids the component is going to use.
   * It's applied for the `sm` breakpoint and wider screens if not overridden.
   */
  sm: _propTypes.default.oneOf([false, 'auto', true, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]),

  /**
   * Defines the space between the type `item` component.
   * It can only be used on a type `container` component.
   */
  spacing: _propTypes.default.oneOf(GUTTERS),

  /**
   * Defines the `flex-wrap` style property.
   * It's applied for all screen sizes.
   */
  wrap: _propTypes.default.oneOf(['nowrap', 'wrap', 'wrap-reverse']),

  /**
   * Defines the number of grids the component is going to use.
   * It's applied for the `xl` breakpoint and wider screens.
   */
  xl: _propTypes.default.oneOf([false, 'auto', true, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]),

  /**
   * Defines the number of grids the component is going to use.
   * It's applied for all the screen sizes with the lowest priority.
   */
  xs: _propTypes.default.oneOf([false, 'auto', true, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]),

  /**
   * If `true`, it sets `min-width: 0` on the item.
   * Refer to the limitations section of the documentation to better understand the use case.
   */
  zeroMinWidth: _propTypes.default.bool
} : {};
Grid.defaultProps = {
  alignContent: 'stretch',
  alignItems: 'stretch',
  component: 'div',
  container: false,
  direction: 'row',
  item: false,
  justify: 'flex-start',
  lg: false,
  md: false,
  sm: false,
  spacing: 0,
  wrap: 'wrap',
  xl: false,
  xs: false,
  zeroMinWidth: false
};
var StyledGrid = (0, _withStyles.default)(styles, {
  name: 'MuiGrid'
})(Grid);

if (false) {
  var requireProp = (0, _requirePropFactory.default)('Grid');
  StyledGrid.propTypes = (0, _objectSpread2.default)({}, StyledGrid.propTypes, {
    alignContent: requireProp('container'),
    alignItems: requireProp('container'),
    direction: requireProp('container'),
    justify: requireProp('container'),
    lg: requireProp('item'),
    md: requireProp('item'),
    sm: requireProp('item'),
    spacing: requireProp('container'),
    wrap: requireProp('container'),
    xs: requireProp('item'),
    zeroMinWidth: requireProp('zeroMinWidth')
  });
}

var _default = StyledGrid;
exports.default = _default;

/***/ }),
/* 521 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

//  weak
function requirePropFactory(componentNameInError) {
  /* istanbul ignore if */
  if (true) {
    return function () {
      return null;
    };
  }

  var requireProp = function requireProp(requiredProp) {
    return function (props, propName, componentName, location, propFullName) {
      var propFullNameSafe = propFullName || propName;

      if (typeof props[propName] !== 'undefined' && !props[requiredProp]) {
        return new Error("The property `".concat(propFullNameSafe, "` of ") + "`".concat(componentNameInError, "` must be used on `").concat(requiredProp, "`."));
      }

      return null;
    };
  };

  return requireProp;
}

var _default = requirePropFactory;
exports.default = _default;

/***/ }),
/* 522 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(40);
var bind = __webpack_require__(250);
var Axios = __webpack_require__(524);
var defaults = __webpack_require__(178);

/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */
function createInstance(defaultConfig) {
  var context = new Axios(defaultConfig);
  var instance = bind(Axios.prototype.request, context);

  // Copy axios.prototype to instance
  utils.extend(instance, Axios.prototype, context);

  // Copy context to instance
  utils.extend(instance, context);

  return instance;
}

// Create the default instance to be exported
var axios = createInstance(defaults);

// Expose Axios class to allow class inheritance
axios.Axios = Axios;

// Factory for creating new instances
axios.create = function create(instanceConfig) {
  return createInstance(utils.merge(defaults, instanceConfig));
};

// Expose Cancel & CancelToken
axios.Cancel = __webpack_require__(255);
axios.CancelToken = __webpack_require__(538);
axios.isCancel = __webpack_require__(254);

// Expose all/spread
axios.all = function all(promises) {
  return Promise.all(promises);
};
axios.spread = __webpack_require__(539);

module.exports = axios;

// Allow use of default import syntax in TypeScript
module.exports.default = axios;


/***/ }),
/* 523 */
/***/ (function(module, exports) {

/*!
 * Determine if an object is a Buffer
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */

// The _isBuffer check is for Safari 5-7 support, because it's missing
// Object.prototype.constructor. Remove this eventually
module.exports = function (obj) {
  return obj != null && (isBuffer(obj) || isSlowBuffer(obj) || !!obj._isBuffer)
}

function isBuffer (obj) {
  return !!obj.constructor && typeof obj.constructor.isBuffer === 'function' && obj.constructor.isBuffer(obj)
}

// For Node v0.10 support. Remove this eventually.
function isSlowBuffer (obj) {
  return typeof obj.readFloatLE === 'function' && typeof obj.slice === 'function' && isBuffer(obj.slice(0, 0))
}


/***/ }),
/* 524 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var defaults = __webpack_require__(178);
var utils = __webpack_require__(40);
var InterceptorManager = __webpack_require__(533);
var dispatchRequest = __webpack_require__(534);

/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */
function Axios(instanceConfig) {
  this.defaults = instanceConfig;
  this.interceptors = {
    request: new InterceptorManager(),
    response: new InterceptorManager()
  };
}

/**
 * Dispatch a request
 *
 * @param {Object} config The config specific for this request (merged with this.defaults)
 */
Axios.prototype.request = function request(config) {
  /*eslint no-param-reassign:0*/
  // Allow for axios('example/url'[, config]) a la fetch API
  if (typeof config === 'string') {
    config = utils.merge({
      url: arguments[0]
    }, arguments[1]);
  }

  config = utils.merge(defaults, {method: 'get'}, this.defaults, config);
  config.method = config.method.toLowerCase();

  // Hook up interceptors middleware
  var chain = [dispatchRequest, undefined];
  var promise = Promise.resolve(config);

  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
    chain.unshift(interceptor.fulfilled, interceptor.rejected);
  });

  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
    chain.push(interceptor.fulfilled, interceptor.rejected);
  });

  while (chain.length) {
    promise = promise.then(chain.shift(), chain.shift());
  }

  return promise;
};

// Provide aliases for supported request methods
utils.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url
    }));
  };
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, data, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url,
      data: data
    }));
  };
});

module.exports = Axios;


/***/ }),
/* 525 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(40);

module.exports = function normalizeHeaderName(headers, normalizedName) {
  utils.forEach(headers, function processHeader(value, name) {
    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
      headers[normalizedName] = value;
      delete headers[name];
    }
  });
};


/***/ }),
/* 526 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var createError = __webpack_require__(253);

/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 */
module.exports = function settle(resolve, reject, response) {
  var validateStatus = response.config.validateStatus;
  // Note: status is not exposed by XDomainRequest
  if (!response.status || !validateStatus || validateStatus(response.status)) {
    resolve(response);
  } else {
    reject(createError(
      'Request failed with status code ' + response.status,
      response.config,
      null,
      response.request,
      response
    ));
  }
};


/***/ }),
/* 527 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Update an Error with the specified config, error code, and response.
 *
 * @param {Error} error The error to update.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The error.
 */
module.exports = function enhanceError(error, config, code, request, response) {
  error.config = config;
  if (code) {
    error.code = code;
  }
  error.request = request;
  error.response = response;
  return error;
};


/***/ }),
/* 528 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(40);

function encode(val) {
  return encodeURIComponent(val).
    replace(/%40/gi, '@').
    replace(/%3A/gi, ':').
    replace(/%24/g, '$').
    replace(/%2C/gi, ',').
    replace(/%20/g, '+').
    replace(/%5B/gi, '[').
    replace(/%5D/gi, ']');
}

/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @returns {string} The formatted url
 */
module.exports = function buildURL(url, params, paramsSerializer) {
  /*eslint no-param-reassign:0*/
  if (!params) {
    return url;
  }

  var serializedParams;
  if (paramsSerializer) {
    serializedParams = paramsSerializer(params);
  } else if (utils.isURLSearchParams(params)) {
    serializedParams = params.toString();
  } else {
    var parts = [];

    utils.forEach(params, function serialize(val, key) {
      if (val === null || typeof val === 'undefined') {
        return;
      }

      if (utils.isArray(val)) {
        key = key + '[]';
      } else {
        val = [val];
      }

      utils.forEach(val, function parseValue(v) {
        if (utils.isDate(v)) {
          v = v.toISOString();
        } else if (utils.isObject(v)) {
          v = JSON.stringify(v);
        }
        parts.push(encode(key) + '=' + encode(v));
      });
    });

    serializedParams = parts.join('&');
  }

  if (serializedParams) {
    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
  }

  return url;
};


/***/ }),
/* 529 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(40);

// Headers whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
var ignoreDuplicateOf = [
  'age', 'authorization', 'content-length', 'content-type', 'etag',
  'expires', 'from', 'host', 'if-modified-since', 'if-unmodified-since',
  'last-modified', 'location', 'max-forwards', 'proxy-authorization',
  'referer', 'retry-after', 'user-agent'
];

/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} headers Headers needing to be parsed
 * @returns {Object} Headers parsed into an object
 */
module.exports = function parseHeaders(headers) {
  var parsed = {};
  var key;
  var val;
  var i;

  if (!headers) { return parsed; }

  utils.forEach(headers.split('\n'), function parser(line) {
    i = line.indexOf(':');
    key = utils.trim(line.substr(0, i)).toLowerCase();
    val = utils.trim(line.substr(i + 1));

    if (key) {
      if (parsed[key] && ignoreDuplicateOf.indexOf(key) >= 0) {
        return;
      }
      if (key === 'set-cookie') {
        parsed[key] = (parsed[key] ? parsed[key] : []).concat([val]);
      } else {
        parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
      }
    }
  });

  return parsed;
};


/***/ }),
/* 530 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(40);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs have full support of the APIs needed to test
  // whether the request URL is of the same origin as current location.
  (function standardBrowserEnv() {
    var msie = /(msie|trident)/i.test(navigator.userAgent);
    var urlParsingNode = document.createElement('a');
    var originURL;

    /**
    * Parse a URL to discover it's components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */
    function resolveURL(url) {
      var href = url;

      if (msie) {
        // IE needs attribute set twice to normalize properties
        urlParsingNode.setAttribute('href', href);
        href = urlParsingNode.href;
      }

      urlParsingNode.setAttribute('href', href);

      // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
      return {
        href: urlParsingNode.href,
        protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
        host: urlParsingNode.host,
        search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
        hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
        hostname: urlParsingNode.hostname,
        port: urlParsingNode.port,
        pathname: (urlParsingNode.pathname.charAt(0) === '/') ?
                  urlParsingNode.pathname :
                  '/' + urlParsingNode.pathname
      };
    }

    originURL = resolveURL(window.location.href);

    /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */
    return function isURLSameOrigin(requestURL) {
      var parsed = (utils.isString(requestURL)) ? resolveURL(requestURL) : requestURL;
      return (parsed.protocol === originURL.protocol &&
            parsed.host === originURL.host);
    };
  })() :

  // Non standard browser envs (web workers, react-native) lack needed support.
  (function nonStandardBrowserEnv() {
    return function isURLSameOrigin() {
      return true;
    };
  })()
);


/***/ }),
/* 531 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// btoa polyfill for IE<10 courtesy https://github.com/davidchambers/Base64.js

var chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';

function E() {
  this.message = 'String contains an invalid character';
}
E.prototype = new Error;
E.prototype.code = 5;
E.prototype.name = 'InvalidCharacterError';

function btoa(input) {
  var str = String(input);
  var output = '';
  for (
    // initialize result and counter
    var block, charCode, idx = 0, map = chars;
    // if the next str index does not exist:
    //   change the mapping table to "="
    //   check if d has no fractional digits
    str.charAt(idx | 0) || (map = '=', idx % 1);
    // "8 - idx % 1 * 8" generates the sequence 2, 4, 6, 8
    output += map.charAt(63 & block >> 8 - idx % 1 * 8)
  ) {
    charCode = str.charCodeAt(idx += 3 / 4);
    if (charCode > 0xFF) {
      throw new E();
    }
    block = block << 8 | charCode;
  }
  return output;
}

module.exports = btoa;


/***/ }),
/* 532 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(40);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs support document.cookie
  (function standardBrowserEnv() {
    return {
      write: function write(name, value, expires, path, domain, secure) {
        var cookie = [];
        cookie.push(name + '=' + encodeURIComponent(value));

        if (utils.isNumber(expires)) {
          cookie.push('expires=' + new Date(expires).toGMTString());
        }

        if (utils.isString(path)) {
          cookie.push('path=' + path);
        }

        if (utils.isString(domain)) {
          cookie.push('domain=' + domain);
        }

        if (secure === true) {
          cookie.push('secure');
        }

        document.cookie = cookie.join('; ');
      },

      read: function read(name) {
        var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
        return (match ? decodeURIComponent(match[3]) : null);
      },

      remove: function remove(name) {
        this.write(name, '', Date.now() - 86400000);
      }
    };
  })() :

  // Non standard browser env (web workers, react-native) lack needed support.
  (function nonStandardBrowserEnv() {
    return {
      write: function write() {},
      read: function read() { return null; },
      remove: function remove() {}
    };
  })()
);


/***/ }),
/* 533 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(40);

function InterceptorManager() {
  this.handlers = [];
}

/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */
InterceptorManager.prototype.use = function use(fulfilled, rejected) {
  this.handlers.push({
    fulfilled: fulfilled,
    rejected: rejected
  });
  return this.handlers.length - 1;
};

/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */
InterceptorManager.prototype.eject = function eject(id) {
  if (this.handlers[id]) {
    this.handlers[id] = null;
  }
};

/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */
InterceptorManager.prototype.forEach = function forEach(fn) {
  utils.forEach(this.handlers, function forEachHandler(h) {
    if (h !== null) {
      fn(h);
    }
  });
};

module.exports = InterceptorManager;


/***/ }),
/* 534 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(40);
var transformData = __webpack_require__(535);
var isCancel = __webpack_require__(254);
var defaults = __webpack_require__(178);
var isAbsoluteURL = __webpack_require__(536);
var combineURLs = __webpack_require__(537);

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
function throwIfCancellationRequested(config) {
  if (config.cancelToken) {
    config.cancelToken.throwIfRequested();
  }
}

/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */
module.exports = function dispatchRequest(config) {
  throwIfCancellationRequested(config);

  // Support baseURL config
  if (config.baseURL && !isAbsoluteURL(config.url)) {
    config.url = combineURLs(config.baseURL, config.url);
  }

  // Ensure headers exist
  config.headers = config.headers || {};

  // Transform request data
  config.data = transformData(
    config.data,
    config.headers,
    config.transformRequest
  );

  // Flatten headers
  config.headers = utils.merge(
    config.headers.common || {},
    config.headers[config.method] || {},
    config.headers || {}
  );

  utils.forEach(
    ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
    function cleanHeaderConfig(method) {
      delete config.headers[method];
    }
  );

  var adapter = config.adapter || defaults.adapter;

  return adapter(config).then(function onAdapterResolution(response) {
    throwIfCancellationRequested(config);

    // Transform response data
    response.data = transformData(
      response.data,
      response.headers,
      config.transformResponse
    );

    return response;
  }, function onAdapterRejection(reason) {
    if (!isCancel(reason)) {
      throwIfCancellationRequested(config);

      // Transform response data
      if (reason && reason.response) {
        reason.response.data = transformData(
          reason.response.data,
          reason.response.headers,
          config.transformResponse
        );
      }
    }

    return Promise.reject(reason);
  });
};


/***/ }),
/* 535 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(40);

/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */
module.exports = function transformData(data, headers, fns) {
  /*eslint no-param-reassign:0*/
  utils.forEach(fns, function transform(fn) {
    data = fn(data, headers);
  });

  return data;
};


/***/ }),
/* 536 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */
module.exports = function isAbsoluteURL(url) {
  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
  // by any combination of letters, digits, plus, period, or hyphen.
  return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
};


/***/ }),
/* 537 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 * @returns {string} The combined URL
 */
module.exports = function combineURLs(baseURL, relativeURL) {
  return relativeURL
    ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '')
    : baseURL;
};


/***/ }),
/* 538 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Cancel = __webpack_require__(255);

/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @class
 * @param {Function} executor The executor function.
 */
function CancelToken(executor) {
  if (typeof executor !== 'function') {
    throw new TypeError('executor must be a function.');
  }

  var resolvePromise;
  this.promise = new Promise(function promiseExecutor(resolve) {
    resolvePromise = resolve;
  });

  var token = this;
  executor(function cancel(message) {
    if (token.reason) {
      // Cancellation has already been requested
      return;
    }

    token.reason = new Cancel(message);
    resolvePromise(token.reason);
  });
}

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
CancelToken.prototype.throwIfRequested = function throwIfRequested() {
  if (this.reason) {
    throw this.reason;
  }
};

/**
 * Returns an object that contains a new `CancelToken` and a function that, when called,
 * cancels the `CancelToken`.
 */
CancelToken.source = function source() {
  var cancel;
  var token = new CancelToken(function executor(c) {
    cancel = c;
  });
  return {
    token: token,
    cancel: cancel
  };
};

module.exports = CancelToken;


/***/ }),
/* 539 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 * @returns {Function}
 */
module.exports = function spread(callback) {
  return function wrap(arr) {
    return callback.apply(null, arr);
  };
};


/***/ }),
/* 540 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_query_string__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_query_string___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_query_string__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles_withStyles__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_redux__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_EnergyCompany_BouncingLoader_BouncingLoader_jsx__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_EnergyCompany_Cards_ECCard_jsx__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_Grid_GridContainer_jsx__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_Grid_GridItem_jsx__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_reducers_user_actions__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_services_auth__ = __webpack_require__(73);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var styles={loader:{alignItems:"center",display:"flex",flexDirection:"column",justifyContent:"center"},titleActions:{color:"#3C4858",display:"flex",fontSize:"2.6em",justifyContent:"center"}};var ConfirmacaoEmailPage=function(_Component){_inherits(ConfirmacaoEmailPage,_Component);function ConfirmacaoEmailPage(){var _ref;var _temp,_this,_ret;_classCallCheck(this,ConfirmacaoEmailPage);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=ConfirmacaoEmailPage.__proto__||Object.getPrototypeOf(ConfirmacaoEmailPage)).call.apply(_ref,[this].concat(args))),_this),_this.state={confirmando:true,errors:null,msg:"Estamos confirmando seu email"},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(ConfirmacaoEmailPage,[{key:"componentDidMount",value:function componentDidMount(){var _this2=this;var _props=this.props,authenticateUser=_props.authenticateUser,history=_props.history,location=_props.location;var _queryString$parse=__WEBPACK_IMPORTED_MODULE_0_query_string___default.a.parse(location.search),codigo=_queryString$parse.codigo,id=_queryString$parse.id;Object(__WEBPACK_IMPORTED_MODULE_11_services_auth__["c" /* confirmacaoEmail */])({codigo:codigo,id:id}).then(function(_ref2){var data=_ref2.data;_this2.setState({confirmando:false,msg:"Confirmado, redirecionando para o dashboard"});authenticateUser(data);setTimeout(function(){history.push("/dashboard");},2000);}).catch(function(_ref3){var response=_ref3.response;_this2.setState({confirmando:false,errors:response.data,msg:"Erro na confirmação"});});}},{key:"render",value:function render(){var classes=this.props.classes;var _state=this.state,confirmando=_state.confirmando,errors=_state.errors,msg=_state.msg;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:classes.container},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_Grid_GridContainer_jsx__["a" /* default */],{alignContent:"center",justify:"center"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_Grid_GridItem_jsx__["a" /* default */],{md:10,sm:12,xs:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_EnergyCompany_Cards_ECCard_jsx__["a" /* default */],{content:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:classes.loader},confirmando&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_EnergyCompany_BouncingLoader_BouncingLoader_jsx__["a" /* default */],null),Object(__WEBPACK_IMPORTED_MODULE_5_lodash__["map"])(errors,function(error,index){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("h4",{key:index},error);}),errors&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("h4",null,"Por favor enviar um email para ",__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("a",{href:"mailto:contato@energycompany.com.br"},"contato@energycompany.com.br"))),title:msg,titleActionsClass:classes.titleActions}))));}}]);return ConfirmacaoEmailPage;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);ConfirmacaoEmailPage.propTypes={authenticateUser:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,classes:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired,history:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired,location:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired};var mapDispatchToProps={authenticateUser:__WEBPACK_IMPORTED_MODULE_10_reducers_user_actions__["a" /* authenticateUser */]};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_4_react_redux__["b" /* connect */])(null,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles_withStyles___default()(styles)(ConfirmacaoEmailPage)));

/***/ }),
/* 541 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_classnames__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_perfect_scrollbar__ = __webpack_require__(181);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_styles_withStyles__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_styles_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_styles_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_redux__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_router_dom__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_perfect_scrollbar_css_perfect_scrollbar_css__ = __webpack_require__(256);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_perfect_scrollbar_css_perfect_scrollbar_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_perfect_scrollbar_css_perfect_scrollbar_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_assets_jss_material_dashboard_pro_react_layouts_dashboardStyle_jsx__ = __webpack_require__(257);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_EnergyCompany_Alert_Alerts__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_routes_dashboard_jsx__ = __webpack_require__(258);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_components_EnergyCompany_Footer_Footer_jsx__ = __webpack_require__(361);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_components_EnergyCompany_Header_Header_jsx__ = __webpack_require__(362);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_assets_EnergyCompany_img_logoEC_png__ = __webpack_require__(364);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_assets_EnergyCompany_img_logoEC_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_assets_EnergyCompany_img_logoEC_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_components_EnergyCompany_Sidebar_Sidebar_jsx__ = __webpack_require__(365);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ps=void 0;var Dashboard=function(_React$Component){_inherits(Dashboard,_React$Component);function Dashboard(){var _ref;var _temp,_this,_ret;_classCallCheck(this,Dashboard);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=Dashboard.__proto__||Object.getPrototypeOf(Dashboard)).call.apply(_ref,[this].concat(args))),_this),_this.state={mobileOpen:false,miniActive:false},_this.handleDrawerToggle=function(){_this.setState({mobileOpen:!_this.state.mobileOpen});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(Dashboard,[{key:"componentWillMount",value:function componentWillMount(){if(!this.props.user.access_token){window.location.href="/";}}},{key:"componentDidMount",value:function componentDidMount(){if(navigator.platform.indexOf("Win")>-1){// eslint-disable-next-line
ps=new __WEBPACK_IMPORTED_MODULE_1_perfect_scrollbar__["a" /* default */](this.mainPanel,{suppressScrollX:true,suppressScrollY:false});}}},{key:"componentDidUpdate",value:function componentDidUpdate(e){if(e.history.location.pathname!==e.location.pathname){this.mainPanel.scrollTop=0;}}},{key:"componentWillUnmount",value:function componentWillUnmount(){if(navigator.platform.indexOf("Win")>-1){ps.destroy();}}},{key:"getRoute",value:function getRoute(){return this.props.location.pathname!=="/dashboard/maps/full-screen-maps";}},{key:"getSwitchRoutes",value:function getSwitchRoutes(){return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_router_dom__["d" /* Switch */],null,__WEBPACK_IMPORTED_MODULE_10_routes_dashboard_jsx__["a" /* default */].concat(__WEBPACK_IMPORTED_MODULE_10_routes_dashboard_jsx__["b" /* internalRoutes */]).map(function(prop,key){// if (prop.redirect) {
//   return <Redirect from={prop.path} key={key} to={prop.pathTo} />;
// }
// if (prop.collapse) {
//   return prop.views.map((prop, key) => (
//     <Route component={prop.component} exact key={key} path={prop.path} />
//   ));
// }
// if (prop.path === "/dashboard") {
//   return <Route exact key={key} path={prop.path} render={props => <prop.component {...props} cnpj={this.state.cnpj} />} />;
// } else {
return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_router_dom__["b" /* Route */],{component:prop.component,exact:true,key:key,path:prop.path});// }
}));}},{key:"sidebarMinimize",value:function sidebarMinimize(){this.setState({miniActive:!this.state.miniActive});}},{key:"render",value:function render(){var _cx,_this2=this;var _props=this.props,classes=_props.classes,rest=_objectWithoutProperties(_props,["classes"]);var mainPanel=classes.mainPanel+" "+__WEBPACK_IMPORTED_MODULE_0_classnames___default()((_cx={},_defineProperty(_cx,classes.mainPanelSidebarMini,this.state.miniActive),_defineProperty(_cx,classes.mainPanelWithPerfectScrollbar,navigator.platform.indexOf("Win")>-1),_cx));if(!this.props.user.access_token){return false;}return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("div",{className:classes.wrapper},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_components_EnergyCompany_Sidebar_Sidebar_jsx__["a" /* default */],Object.assign({bgColor:"white",color:"blue",handleDrawerToggle:this.handleDrawerToggle,logo:__WEBPACK_IMPORTED_MODULE_13_assets_EnergyCompany_img_logoEC_png___default.a,logoText:"Energy Company",miniActive:this.state.miniActive,open:this.state.mobileOpen,routes:__WEBPACK_IMPORTED_MODULE_10_routes_dashboard_jsx__["a" /* default */],userInfo:this.props.user.info},rest)),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("div",{className:mainPanel,ref:function ref(node){return _this2.mainPanel=node;}},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_components_EnergyCompany_Header_Header_jsx__["a" /* default */],Object.assign({handleDrawerToggle:this.handleDrawerToggle,miniActive:this.state.miniActive,routes:__WEBPACK_IMPORTED_MODULE_10_routes_dashboard_jsx__["a" /* default */].concat(__WEBPACK_IMPORTED_MODULE_10_routes_dashboard_jsx__["b" /* internalRoutes */]),sidebarMinimize:this.sidebarMinimize.bind(this)},rest)),this.getRoute()?__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("div",{className:classes.content},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("div",{className:classes.container},this.getSwitchRoutes())):__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("div",{className:classes.map},this.getSwitchRoutes()),this.getRoute()?__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components_EnergyCompany_Footer_Footer_jsx__["a" /* default */],{fluid:true}):null),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_EnergyCompany_Alert_Alerts__["a" /* default */],null));}}]);return Dashboard;}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);Dashboard.propTypes={classes:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired,location:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({pathname:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired}).isRequired,user:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired};var mapDispatchToProps={};var mapStateToProps=function mapStateToProps(state){return{user:state.user};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_5_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_styles_withStyles___default()(__WEBPACK_IMPORTED_MODULE_8_assets_jss_material_dashboard_pro_react_layouts_dashboardStyle_jsx__["a" /* default */])(Dashboard)));

/***/ }),
/* 542 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(9);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(10));

var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
  d: "M10 18h4v-2h-4v2zM3 6v2h18V6H3zm3 7h12v-2H6v2z"
}), _react.default.createElement("path", {
  fill: "none",
  d: "M0 0h24v24H0z"
})), 'FilterList');

exports.default = _default;

/***/ }),
/* 543 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export AssinaturaComponent */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_icons_People__ = __webpack_require__(544);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_icons_People___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__material_ui_icons_People__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_styles_withStyles__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_styles_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_styles_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_redux__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_Badge_Badge_jsx__ = __webpack_require__(545);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_EnergyCompany_BouncingLoader_BouncingLoader_jsx__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_CustomButtons_Button_jsx__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__material_ui_core_Checkbox__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__material_ui_core_Checkbox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_Checkbox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__material_ui_icons_Close__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__material_ui_icons_Close___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__material_ui_icons_Close__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__partials_ConvidarUsuario__ = __webpack_require__(552);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_components_EnergyCompany_Cards_ECCard_jsx__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_components_Grid_GridContainer_jsx__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_components_Grid_GridItem_jsx__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__material_ui_icons_Info__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__material_ui_icons_Info___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__material_ui_icons_Info__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_components_Table_Table_jsx__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__material_ui_core_Tooltip__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__material_ui_core_Tooltip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__material_ui_core_Tooltip__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_services_assinatura__ = __webpack_require__(266);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_reducers_alerts_actions__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_assets_jss_material_dashboard_pro_react_views_extendedTablesStyle_jsx__ = __webpack_require__(588);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_assets_EnergyCompany_jss_lightTooltip__ = __webpack_require__(76);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var styles=function styles(theme){return Object.assign({},__WEBPACK_IMPORTED_MODULE_21_assets_jss_material_dashboard_pro_react_views_extendedTablesStyle_jsx__["a" /* default */],Object(__WEBPACK_IMPORTED_MODULE_22_assets_EnergyCompany_jss_lightTooltip__["a" /* default */])(theme));};var Assinatura=function(_Component){_inherits(Assinatura,_Component);function Assinatura(){var _ref;var _temp,_this,_ret;_classCallCheck(this,Assinatura);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=Assinatura.__proto__||Object.getPrototypeOf(Assinatura)).call.apply(_ref,[this].concat(args))),_this),_this.state={adminUserChanging:null,assinatura:null,removingUser:null},_this.getButton=function(usuario){var classes=_this.props.classes;var removingUser=_this.state.removingUser;var currentUser=_this.getCurrentUser();var actionsBtns=[{color:"danger",icon:__WEBPACK_IMPORTED_MODULE_11__material_ui_icons_Close___default.a}];return Object(__WEBPACK_IMPORTED_MODULE_6_lodash__["map"])(actionsBtns,function(prop,key){return removingUser===usuario.id?__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_EnergyCompany_BouncingLoader_BouncingLoader_jsx__["a" /* default */],{key:key}):__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_CustomButtons_Button_jsx__["a" /* default */],{color:prop.color,customclass:classes.actionButton,disabled:usuario.email===currentUser.email,key:key,onClick:function onClick(){return _this.handleRemoveUserClick(usuario);}},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(prop.icon,{className:classes.icon}));});},_this.handleConvidarClick=function(params){var assinatura=_this.state.assinatura;return Object(__WEBPACK_IMPORTED_MODULE_19_services_assinatura__["a" /* addUserAssinatura */])(params).then(function(_ref2){var data=_ref2.data;_this.props.showAlert({message:params.email+" convidado com sucesso.",type:'success'});_this.setState({assinatura:Object.assign({},assinatura,{usuarios:[].concat(_toConsumableArray(assinatura.usuarios),[data])})});}).catch(function(_ref3){var response=_ref3.response;_this.props.showAlert({message:Object(__WEBPACK_IMPORTED_MODULE_6_lodash__["values"])(response.data).join(' '),type:'error'});});},_this.handleRemoveUserClick=function(usuario){var assinatura=_this.state.assinatura;_this.setState({removingUser:usuario.id});Object(__WEBPACK_IMPORTED_MODULE_19_services_assinatura__["c" /* removeUserAssinatura */])(usuario.id).then(function(){_this.props.showAlert({message:usuario.email+" removido com sucesso.",type:'success'});_this.setState({assinatura:Object.assign({},assinatura,{usuarios:Object(__WEBPACK_IMPORTED_MODULE_6_lodash__["filter"])(assinatura.usuarios,function(u){return u.email!==usuario.email;})}),removingUser:null});}).catch(function(_ref4){var response=_ref4.response;_this.props.showAlert({message:Object(__WEBPACK_IMPORTED_MODULE_6_lodash__["values"])(response.data).join(' '),type:'error'});_this.setState({removingUser:null});});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(Assinatura,[{key:"componentDidMount",value:function componentDidMount(){var _this2=this;Object(__WEBPACK_IMPORTED_MODULE_19_services_assinatura__["b" /* fetchAssinatura */])().then(function(_ref5){var data=_ref5.data;return _this2.setState({assinatura:data});});}},{key:"getAdminSelect",value:function getAdminSelect(usuario){var _this3=this;return this.state.adminUserChanging===usuario.id?__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_EnergyCompany_BouncingLoader_BouncingLoader_jsx__["a" /* default */],null):__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_Checkbox___default.a,{checked:usuario.admin,onChange:function onChange(e){return _this3.handleIsAdminChange(usuario,e.target.checked);}});}},{key:"getCurrentUser",value:function getCurrentUser(){var assinatura=this.state.assinatura;var user=this.props.user;if(assinatura&&user.info){return Object(__WEBPACK_IMPORTED_MODULE_6_lodash__["find"])(assinatura.usuarios,['email',user.info.email]);}else{return{};}}},{key:"getHeaderTooltip",value:function getHeaderTooltip(header){var classes=this.props.classes;return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__material_ui_core_Tooltip___default.a,{classes:{popper:classes.lightTooltipPopper,tooltip:classes.lightTooltip},placement:"top",title:"Admin pode convidar, remover ou dar privil\xE9gio de admin para outros usu\xE1rios da assinatura."},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("span",{className:classes.tooltipContentWrapper},header," ",__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__material_ui_icons_Info___default.a,null)));}},{key:"getTableData",value:function getTableData(){var _this4=this;var assinatura=this.state.assinatura;var currentUser=this.getCurrentUser();var shouldShow=this.shouldShow(currentUser);if(!assinatura)return[];var getBadge=function getBadge(pendente){return pendente?__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_Badge_Badge_jsx__["a" /* default */],{color:"warning"},"Pendente"):__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_Badge_Badge_jsx__["a" /* default */],{color:"success"},"Ativo");};// Não podemos usar _.compact aqui porque sobrenome as vezes é "".
return Object(__WEBPACK_IMPORTED_MODULE_6_lodash__["map"])(assinatura.usuarios,function(usuario){return Object(__WEBPACK_IMPORTED_MODULE_6_lodash__["filter"])([usuario.nome,usuario.sobrenome,usuario.email,shouldShow&&getBadge(usuario.pendente),shouldShow&&_this4.getAdminSelect(usuario),shouldShow&&_this4.getButton(usuario)],function(value){return value!==false;});});}},{key:"handleIsAdminChange",value:function handleIsAdminChange(usuarioAlterado,isAdmin){var _this5=this;var assinatura=this.state.assinatura;var params={admin:isAdmin,email:usuarioAlterado.email};this.setState({adminUserChanging:usuarioAlterado.id});Object(__WEBPACK_IMPORTED_MODULE_19_services_assinatura__["d" /* updateUserAssinatura */])(params).then(function(_ref6){var data=_ref6.data;var message=isAdmin?usuarioAlterado.email+" se tornou admin da assinatura.":usuarioAlterado.email+" n\xE3o \xE9 mais admin da assinatura.";_this5.props.showAlert({message:message,type:'success'});_this5.setState({adminUserChanging:null,assinatura:Object.assign({},assinatura,{usuarios:Object(__WEBPACK_IMPORTED_MODULE_6_lodash__["map"])(assinatura.usuarios,function(usuario){return usuario.email!==usuarioAlterado.email?usuario:data;})})});}).catch(function(){_this5.props.showAlert({message:'Ocorreu um erro, por favor tente após alguns minutos.',type:'error'});_this5.setState({adminUserChanging:null});});}},{key:"shouldShow",value:function shouldShow(currentUser){return currentUser.admin&&this.state.assinatura.numeroMaximoUsuarios>1;}},{key:"render",value:function render(){var classes=this.props.classes;var assinatura=this.state.assinatura;var currentUser=this.getCurrentUser();var shouldShow=this.shouldShow(currentUser);if(!assinatura)return false;return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_components_Grid_GridContainer_jsx__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_components_Grid_GridItem_jsx__["a" /* default */],{md:12,sm:12,xs:12},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_components_EnergyCompany_Cards_ECCard_jsx__["a" /* default */],{content:__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_components_Table_Table_jsx__["a" /* default */],{customCellClasses:[classes.center],customClassesForCells:[5],customHeadCellClasses:[classes.center],customHeadClassesForCells:[5],tableData:this.getTableData(),tableHead:Object(__WEBPACK_IMPORTED_MODULE_6_lodash__["compact"])(["Nome","Sobrenome","Email",shouldShow&&"Status",shouldShow&&this.getHeaderTooltip("Admin"),shouldShow&&"Ações"])})),icon:__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_icons_People___default.a,null),iconColor:"info",title:__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("span",{title:assinatura.nome},"Assinatura ",Object(__WEBPACK_IMPORTED_MODULE_6_lodash__["truncate"])(assinatura.nome)," - Expira em ",__WEBPACK_IMPORTED_MODULE_0_moment___default()(assinatura.dataExpiracao).format("DD/MM/YY"))}))),this.shouldShow(currentUser)&&__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__partials_ConvidarUsuario__["a" /* default */],{assinatura:assinatura,handleClick:this.handleConvidarClick}));}}]);return Assinatura;}(__WEBPACK_IMPORTED_MODULE_2_react__["Component"]);Assinatura.propTypes={classes:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,showAlert:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,user:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired};var mapStateToProps=function mapStateToProps(state){return{user:state.user};};var mapDispatchToProps={showAlert:__WEBPACK_IMPORTED_MODULE_20_reducers_alerts_actions__["b" /* showAlert */]};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_5_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_styles_withStyles___default()(styles)(Assinatura)));

/***/ }),
/* 544 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(9);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(10));

var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
  fill: "none",
  d: "M0 0h24v24H0z"
}), _react.default.createElement("path", {
  d: "M16 11c1.66 0 2.99-1.34 2.99-3S17.66 5 16 5c-1.66 0-3 1.34-3 3s1.34 3 3 3zm-8 0c1.66 0 2.99-1.34 2.99-3S9.66 5 8 5C6.34 5 5 6.34 5 8s1.34 3 3 3zm0 2c-2.33 0-7 1.17-7 3.5V19h14v-2.5c0-2.33-4.67-3.5-7-3.5zm8 0c-.29 0-.62.02-.97.05 1.16.84 1.97 1.97 1.97 3.45V19h6v-2.5c0-2.33-4.67-3.5-7-3.5z"
})), 'People');

exports.default = _default;

/***/ }),
/* 545 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_styles_withStyles__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_styles_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_styles_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_assets_jss_material_dashboard_pro_react_components_badgeStyle_jsx__ = __webpack_require__(546);
function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}// @material-ui/core components
function Badge(_ref){var props=_objectWithoutProperties(_ref,[]);var classes=props.classes,color=props.color,children=props.children;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:classes.badge+" "+classes[color]},children);}Badge.propTypes={classes:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,color:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(["primary","warning","danger","success","info","rose","gray"])};/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_2__material_ui_core_styles_withStyles___default()(__WEBPACK_IMPORTED_MODULE_3_assets_jss_material_dashboard_pro_react_components_badgeStyle_jsx__["a" /* default */])(Badge));

/***/ }),
/* 546 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__ = __webpack_require__(21);
// ##############################
// // // Badge component styles
// #############################
var badgeStyle={badge:{borderRadius:"12px",padding:"5px 12px",textTransform:"uppercase",fontSize:"10px",fontWeight:"700",lineHeight:"1",color:"#fff",textAlign:"center",verticalAlign:"baseline",display:"inline-block"},primary:{backgroundColor:__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["r" /* primaryColor */]},warning:{backgroundColor:__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["B" /* warningColor */]},danger:{backgroundColor:__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["g" /* dangerColor */]},success:{backgroundColor:__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["x" /* successColor */]},info:{backgroundColor:__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["o" /* infoColor */]},rose:{backgroundColor:__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["u" /* roseColor */]},gray:{backgroundColor:__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["l" /* grayColor */]}};/* harmony default export */ __webpack_exports__["a"] = (badgeStyle);

/***/ }),
/* 547 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(2);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(6));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(4));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _classnames = _interopRequireDefault(__webpack_require__(5));

var _SwitchBase = _interopRequireDefault(__webpack_require__(548));

var _CheckBoxOutlineBlank = _interopRequireDefault(__webpack_require__(549));

var _CheckBox = _interopRequireDefault(__webpack_require__(550));

var _IndeterminateCheckBox = _interopRequireDefault(__webpack_require__(551));

var _helpers = __webpack_require__(37);

var _withStyles = _interopRequireDefault(__webpack_require__(3));

var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      color: theme.palette.text.secondary
    },

    /* Styles applied to the root element if `checked={true}`. */
    checked: {},

    /* Styles applied to the root element if `disabled={true}`. */
    disabled: {},

    /* Styles applied to the root element if `color="primary"`. */
    colorPrimary: {
      '&$checked': {
        color: theme.palette.primary.main
      },
      '&$disabled': {
        color: theme.palette.action.disabled
      }
    },

    /* Styles applied to the root element if `color="secondary"`. */
    colorSecondary: {
      '&$checked': {
        color: theme.palette.secondary.main
      },
      '&$disabled': {
        color: theme.palette.action.disabled
      }
    }
  };
};

exports.styles = styles;

function Checkbox(props) {
  var checkedIcon = props.checkedIcon,
      classes = props.classes,
      color = props.color,
      icon = props.icon,
      indeterminate = props.indeterminate,
      indeterminateIcon = props.indeterminateIcon,
      other = (0, _objectWithoutProperties2.default)(props, ["checkedIcon", "classes", "color", "icon", "indeterminate", "indeterminateIcon"]);
  return _react.default.createElement(_SwitchBase.default, (0, _extends2.default)({
    checkedIcon: indeterminate ? indeterminateIcon : checkedIcon,
    classes: {
      root: (0, _classnames.default)(classes.root, classes["color".concat((0, _helpers.capitalize)(color))]),
      checked: classes.checked,
      disabled: classes.disabled
    },
    icon: indeterminate ? indeterminateIcon : icon
  }, other));
}

Checkbox.propTypes =  false ? {
  /**
   * If `true`, the component is checked.
   */
  checked: _propTypes.default.oneOfType([_propTypes.default.bool, _propTypes.default.string]),

  /**
   * The icon to display when the component is checked.
   */
  checkedIcon: _propTypes.default.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * The color of the component. It supports those theme colors that make sense for this component.
   */
  color: _propTypes.default.oneOf(['primary', 'secondary', 'default']),

  /**
   * If `true`, the switch will be disabled.
   */
  disabled: _propTypes.default.bool,

  /**
   * If `true`, the ripple effect will be disabled.
   */
  disableRipple: _propTypes.default.bool,

  /**
   * The icon to display when the component is unchecked.
   */
  icon: _propTypes.default.node,

  /**
   * The id of the `input` element.
   */
  id: _propTypes.default.string,

  /**
   * If `true`, the component appears indeterminate.
   */
  indeterminate: _propTypes.default.bool,

  /**
   * The icon to display when the component is indeterminate.
   */
  indeterminateIcon: _propTypes.default.node,

  /**
   * Properties applied to the `input` element.
   */
  inputProps: _propTypes.default.object,

  /**
   * Use that property to pass a ref callback to the native input component.
   */
  inputRef: _propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.object]),

  /**
   * Callback fired when the state is changed.
   *
   * @param {object} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.checked`.
   * @param {boolean} checked The `checked` value of the switch
   */
  onChange: _propTypes.default.func,

  /**
   * The input component property `type`.
   */
  type: _propTypes.default.string,

  /**
   * The value of the component.
   */
  value: _propTypes.default.string
} : {};
Checkbox.defaultProps = {
  checkedIcon: _react.default.createElement(_CheckBox.default, null),
  color: 'secondary',
  icon: _react.default.createElement(_CheckBoxOutlineBlank.default, null),
  indeterminate: false,
  indeterminateIcon: _react.default.createElement(_IndeterminateCheckBox.default, null)
};

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiCheckbox'
})(Checkbox);

exports.default = _default;

/***/ }),
/* 548 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(2);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(6));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(7));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(4));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(11));

var _createClass2 = _interopRequireDefault(__webpack_require__(12));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(13));

var _inherits2 = _interopRequireDefault(__webpack_require__(14));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _classnames = _interopRequireDefault(__webpack_require__(5));

var _withStyles = _interopRequireDefault(__webpack_require__(3));

var _IconButton = _interopRequireDefault(__webpack_require__(98));

// @inheritedComponent IconButton
var styles = {
  root: {
    display: 'inline-flex',
    alignItems: 'center',
    transition: 'none',
    '&:hover': {
      // Disable the hover effect for the IconButton.
      backgroundColor: 'transparent'
    }
  },
  checked: {},
  disabled: {},
  input: {
    cursor: 'inherit',
    position: 'absolute',
    opacity: 0,
    width: '100%',
    height: '100%',
    top: 0,
    left: 0,
    margin: 0,
    padding: 0
  }
};
/**
 * @ignore - internal component.
 */

exports.styles = styles;

var SwitchBase =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(SwitchBase, _React$Component);

  function SwitchBase(props) {
    var _this;

    (0, _classCallCheck2.default)(this, SwitchBase);
    _this = (0, _possibleConstructorReturn2.default)(this, (SwitchBase.__proto__ || Object.getPrototypeOf(SwitchBase)).call(this, props));
    _this.input = null;
    _this.isControlled = null;
    _this.state = {};

    _this.handleFocus = function (event) {
      if (_this.props.onFocus) {
        _this.props.onFocus(event);
      }

      var muiFormControl = _this.context.muiFormControl;

      if (muiFormControl && muiFormControl.onFocus) {
        muiFormControl.onFocus(event);
      }
    };

    _this.handleBlur = function (event) {
      if (_this.props.onBlur) {
        _this.props.onBlur(event);
      }

      var muiFormControl = _this.context.muiFormControl;

      if (muiFormControl && muiFormControl.onBlur) {
        muiFormControl.onBlur(event);
      }
    };

    _this.handleInputChange = function (event) {
      var checked = event.target.checked;

      if (!_this.isControlled) {
        _this.setState({
          checked: checked
        });
      }

      if (_this.props.onChange) {
        _this.props.onChange(event, checked);
      }
    };

    _this.isControlled = props.checked != null;

    if (!_this.isControlled) {
      // not controlled, use internal state
      _this.state.checked = props.defaultChecked !== undefined ? props.defaultChecked : false;
    }

    return _this;
  }

  (0, _createClass2.default)(SwitchBase, [{
    key: "render",
    value: function render() {
      var _classNames;

      var _props = this.props,
          autoFocus = _props.autoFocus,
          checkedProp = _props.checked,
          checkedIcon = _props.checkedIcon,
          classes = _props.classes,
          classNameProp = _props.className,
          disabledProp = _props.disabled,
          icon = _props.icon,
          id = _props.id,
          inputProps = _props.inputProps,
          inputRef = _props.inputRef,
          name = _props.name,
          onBlur = _props.onBlur,
          onChange = _props.onChange,
          onFocus = _props.onFocus,
          readOnly = _props.readOnly,
          required = _props.required,
          tabIndex = _props.tabIndex,
          type = _props.type,
          value = _props.value,
          other = (0, _objectWithoutProperties2.default)(_props, ["autoFocus", "checked", "checkedIcon", "classes", "className", "disabled", "icon", "id", "inputProps", "inputRef", "name", "onBlur", "onChange", "onFocus", "readOnly", "required", "tabIndex", "type", "value"]);
      var muiFormControl = this.context.muiFormControl;
      var disabled = disabledProp;

      if (muiFormControl) {
        if (typeof disabled === 'undefined') {
          disabled = muiFormControl.disabled;
        }
      }

      var checked = this.isControlled ? checkedProp : this.state.checked;
      var hasLabelFor = type === 'checkbox' || type === 'radio';
      return _react.default.createElement(_IconButton.default, (0, _extends2.default)({
        component: "span",
        className: (0, _classnames.default)(classes.root, (_classNames = {}, (0, _defineProperty2.default)(_classNames, classes.checked, checked), (0, _defineProperty2.default)(_classNames, classes.disabled, disabled), _classNames), classNameProp),
        disabled: disabled,
        tabIndex: null,
        role: undefined,
        onFocus: this.handleFocus,
        onBlur: this.handleBlur
      }, other), checked ? checkedIcon : icon, _react.default.createElement("input", (0, _extends2.default)({
        autoFocus: autoFocus,
        checked: checked,
        className: classes.input,
        disabled: disabled,
        id: hasLabelFor && id,
        name: name,
        onChange: this.handleInputChange,
        readOnly: readOnly,
        ref: inputRef,
        required: required,
        tabIndex: tabIndex,
        type: type,
        value: value
      }, inputProps)));
    }
  }]);
  return SwitchBase;
}(_react.default.Component); // NB: If changed, please update Checkbox, Switch and Radio
// so that the API documentation is updated.


SwitchBase.propTypes =  false ? {
  /**
   * If `true`, the input will be focused during the first mount.
   */
  autoFocus: _propTypes.default.bool,

  /**
   * If `true`, the component is checked.
   */
  checked: _propTypes.default.oneOfType([_propTypes.default.bool, _propTypes.default.string]),

  /**
   * The icon to display when the component is checked.
   */
  checkedIcon: _propTypes.default.node.isRequired,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * @ignore
   */
  defaultChecked: _propTypes.default.bool,

  /**
   * If `true`, the switch will be disabled.
   */
  disabled: _propTypes.default.bool,

  /**
   * If `true`, the ripple effect will be disabled.
   */
  disableRipple: _propTypes.default.bool,

  /**
   * The icon to display when the component is unchecked.
   */
  icon: _propTypes.default.node.isRequired,

  /**
   * The id of the `input` element.
   */
  id: _propTypes.default.string,

  /**
   * If `true`, the component appears indeterminate.
   */
  indeterminate: _propTypes.default.bool,

  /**
   * The icon to display when the component is indeterminate.
   */
  indeterminateIcon: _propTypes.default.node,

  /**
   * Attributes applied to the `input` element.
   */
  inputProps: _propTypes.default.object,

  /**
   * Use that property to pass a ref callback to the native input component.
   */
  inputRef: _propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.object]),

  /*
   * @ignore
   */
  name: _propTypes.default.string,

  /**
   * @ignore
   */
  onBlur: _propTypes.default.func,

  /**
   * Callback fired when the state is changed.
   *
   * @param {object} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.checked`.
   * @param {boolean} checked The `checked` value of the switch
   */
  onChange: _propTypes.default.func,

  /**
   * @ignore
   */
  onFocus: _propTypes.default.func,

  /**
   * It prevents the user from changing the value of the field
   * (not from interacting with the field).
   */
  readOnly: _propTypes.default.bool,

  /**
   * If `true`, the input will be required.
   */
  required: _propTypes.default.bool,

  /**
   * @ignore
   */
  tabIndex: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),

  /**
   * The input component property `type`.
   */
  type: _propTypes.default.string,

  /**
   * The value of the component.
   */
  value: _propTypes.default.string
} : {};
SwitchBase.defaultProps = {
  type: 'checkbox'
};
SwitchBase.contextTypes = {
  muiFormControl: _propTypes.default.object
};

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiSwitchBase'
})(SwitchBase);

exports.default = _default;

/***/ }),
/* 549 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(2);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _pure = _interopRequireDefault(__webpack_require__(96));

var _SvgIcon = _interopRequireDefault(__webpack_require__(97));

var _ref = _react.default.createElement("path", {
  d: "M19 5v14H5V5h14m0-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z"
});

/**
 * @ignore - internal component.
 */
var CheckBoxOutlineBlank = function CheckBoxOutlineBlank(props) {
  return _react.default.createElement(_SvgIcon.default, props, _ref);
};

CheckBoxOutlineBlank = (0, _pure.default)(CheckBoxOutlineBlank);
CheckBoxOutlineBlank.muiName = 'SvgIcon';
var _default = CheckBoxOutlineBlank;
exports.default = _default;

/***/ }),
/* 550 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(2);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _pure = _interopRequireDefault(__webpack_require__(96));

var _SvgIcon = _interopRequireDefault(__webpack_require__(97));

var _ref = _react.default.createElement("path", {
  d: "M19 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.11 0 2-.9 2-2V5c0-1.1-.89-2-2-2zm-9 14l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"
});

/**
 * @ignore - internal component.
 */
var CheckBox = function CheckBox(props) {
  return _react.default.createElement(_SvgIcon.default, props, _ref);
};

CheckBox = (0, _pure.default)(CheckBox);
CheckBox.muiName = 'SvgIcon';
var _default = CheckBox;
exports.default = _default;

/***/ }),
/* 551 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(2);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _pure = _interopRequireDefault(__webpack_require__(96));

var _SvgIcon = _interopRequireDefault(__webpack_require__(97));

var _ref = _react.default.createElement("path", {
  d: "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-2 10H7v-2h10v2z"
});

/**
 * @ignore - internal component.
 */
var IndeterminateCheckBox = function IndeterminateCheckBox(props) {
  return _react.default.createElement(_SvgIcon.default, props, _ref);
};

IndeterminateCheckBox = (0, _pure.default)(IndeterminateCheckBox);
IndeterminateCheckBox.muiName = 'SvgIcon';
var _default = IndeterminateCheckBox;
exports.default = _default;

/***/ }),
/* 552 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__material_ui_icons_Check__ = __webpack_require__(260);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__material_ui_icons_Check___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__material_ui_icons_Check__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__material_ui_core_Checkbox__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__material_ui_core_Checkbox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Checkbox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_FormControlLabel__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_FormControlLabel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_FormControlLabel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_icons_MailOutline__ = __webpack_require__(554);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_icons_MailOutline___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__material_ui_icons_MailOutline__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_styles_withStyles__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_styles_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_styles_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_EnergyCompany_BouncingLoader_BouncingLoader_jsx__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_CustomButtons_Button_jsx__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_CustomInput_CustomInput_jsx__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_EnergyCompany_Cards_ECCard_jsx__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_components_Grid_GridContainer_jsx__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_components_Grid_GridItem_jsx__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_assets_jss_material_dashboard_pro_react_views_regularFormsStyle__ = __webpack_require__(570);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Assinatura=function(_Component){_inherits(Assinatura,_Component);function Assinatura(){var _ref;var _temp,_this,_ret;_classCallCheck(this,Assinatura);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=Assinatura.__proto__||Object.getPrototypeOf(Assinatura)).call.apply(_ref,[this].concat(args))),_this),_this.state={admin:false,email:'',loading:false,nome:'',sobrenome:''},_this.handleClick=function(){var _this$state=_this.state,admin=_this$state.admin,email=_this$state.email,nome=_this$state.nome,sobrenome=_this$state.sobrenome;_this.setState({loading:true});_this.props.handleClick({admin:admin,email:email,nome:nome,sobrenome:sobrenome}).then(function(){_this.setState({admin:false,email:'',loading:false,nome:'',sobrenome:''});}).catch(function(){_this.setState({loading:false});});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(Assinatura,[{key:"render",value:function render(){var _this2=this;var _state=this.state,email=_state.email,loading=_state.loading,nome=_state.nome,sobrenome=_state.sobrenome;var _props=this.props,assinatura=_props.assinatura,classes=_props.classes;return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components_Grid_GridContainer_jsx__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_components_Grid_GridItem_jsx__["a" /* default */],{md:12,sm:12,xs:12},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_EnergyCompany_Cards_ECCard_jsx__["a" /* default */],{content:assinatura.usuarios.length===assinatura.numeroMaximoUsuarios?__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div",null,"Assinatura j\xE1 atingiu o limite m\xE1ximo de ",assinatura.numeroMaximoUsuarios," usu\xE1rio(s)."),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("strong",null,"Deseja aumentar a capacidade do seu plano?")," Visite nossa p\xE1gina de ",__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("a",{href:"/planos"},"planos")," ou entre em contato por email ",__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("a",{href:"mailto:contato@energycompany.com.br?subject=Ol\xE1,%20desejo%20contratar%20um%20plano%20maior"},"contato@energycompany.com.br"))):__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("form",null,__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_CustomInput_CustomInput_jsx__["a" /* default */],{formControlProps:{fullWidth:true},inputProps:{onChange:function onChange(evt){return _this2.setState({email:evt.target.value});},type:"email",value:email},labelText:"Email*"}),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_CustomInput_CustomInput_jsx__["a" /* default */],{formControlProps:{fullWidth:true},inputProps:{onChange:function onChange(evt){return _this2.setState({nome:evt.target.value});},type:"text",value:nome},labelText:"Nome*"}),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_CustomInput_CustomInput_jsx__["a" /* default */],{formControlProps:{fullWidth:true},inputProps:{onChange:function onChange(evt){return _this2.setState({sobrenome:evt.target.value});},type:"text",value:sobrenome},labelText:"Sobrenome"}),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div",{className:classes.checkboxAndRadio},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_FormControlLabel___default.a,{classes:{label:classes.label},control:__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Checkbox___default.a,{checkedIcon:__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_icons_Check___default.a,{className:classes.checkedIcon}),classes:{checked:classes.checked},icon:__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_icons_Check___default.a,{className:classes.uncheckedIcon}),onClick:function onClick(evt){return _this2.setState({admin:evt.target.checked});}}),label:"Admin"})),loading?__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_EnergyCompany_BouncingLoader_BouncingLoader_jsx__["a" /* default */],null):__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_CustomButtons_Button_jsx__["a" /* default */],{color:"rose",disabled:!email||!nome,onClick:this.handleClick},"Convidar")),icon:__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_icons_MailOutline___default.a,null),iconColor:"info",title:"Convidar usu\xE1rio"})));}}]);return Assinatura;}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);Assinatura.propTypes={assinatura:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,classes:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,handleClick:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func.isRequired};/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_6__material_ui_core_styles_withStyles___default()(__WEBPACK_IMPORTED_MODULE_13_assets_jss_material_dashboard_pro_react_views_regularFormsStyle__["a" /* default */])(Assinatura));

/***/ }),
/* 553 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(2);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(6));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(7));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(4));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _classnames = _interopRequireDefault(__webpack_require__(5));

var _withStyles = _interopRequireDefault(__webpack_require__(3));

var _Typography = _interopRequireDefault(__webpack_require__(126));

/* eslint-disable jsx-a11y/label-has-for */
var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      display: 'inline-flex',
      alignItems: 'center',
      cursor: 'pointer',
      // For correct alignment with the text.
      verticalAlign: 'middle',
      // Remove grey highlight
      WebkitTapHighlightColor: 'transparent',
      marginLeft: -14,
      marginRight: 16,
      // used for row presentation of radio/checkbox
      '&$disabled': {
        cursor: 'default'
      }
    },

    /* Styles applied to the root element if `labelPlacement="start"`. */
    labelPlacementStart: {
      flexDirection: 'row-reverse'
    },

    /* Styles applied to the root element if `disabled={true}`. */
    disabled: {},

    /* Styles applied to the label's Typography component. */
    label: {
      '&$disabled': {
        color: theme.palette.text.disabled
      }
    }
  };
};
/**
 * Drop in replacement of the `Radio`, `Switch` and `Checkbox` component.
 * Use this component if you want to display an extra label.
 */


exports.styles = styles;

function FormControlLabel(props, context) {
  var _classNames;

  var checked = props.checked,
      classes = props.classes,
      classNameProp = props.className,
      control = props.control,
      disabledProp = props.disabled,
      inputRef = props.inputRef,
      label = props.label,
      labelPlacement = props.labelPlacement,
      name = props.name,
      onChange = props.onChange,
      value = props.value,
      other = (0, _objectWithoutProperties2.default)(props, ["checked", "classes", "className", "control", "disabled", "inputRef", "label", "labelPlacement", "name", "onChange", "value"]);
  var muiFormControl = context.muiFormControl;
  var disabled = disabledProp;

  if (typeof disabled === 'undefined' && typeof control.props.disabled !== 'undefined') {
    disabled = control.props.disabled;
  }

  if (typeof disabled === 'undefined' && muiFormControl) {
    disabled = muiFormControl.disabled;
  }

  var controlProps = {
    disabled: disabled
  };
  ['checked', 'name', 'onChange', 'value', 'inputRef'].forEach(function (key) {
    if (typeof control.props[key] === 'undefined' && typeof props[key] !== 'undefined') {
      controlProps[key] = props[key];
    }
  });
  return _react.default.createElement("label", (0, _extends2.default)({
    className: (0, _classnames.default)(classes.root, (_classNames = {}, (0, _defineProperty2.default)(_classNames, classes.labelPlacementStart, labelPlacement === 'start'), (0, _defineProperty2.default)(_classNames, classes.disabled, disabled), _classNames), classNameProp)
  }, other), _react.default.cloneElement(control, controlProps), _react.default.createElement(_Typography.default, {
    component: "span",
    className: (0, _classnames.default)(classes.label, (0, _defineProperty2.default)({}, classes.disabled, disabled))
  }, label));
}

FormControlLabel.propTypes =  false ? {
  /**
   * If `true`, the component appears selected.
   */
  checked: _propTypes.default.oneOfType([_propTypes.default.bool, _propTypes.default.string]),

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * A control element. For instance, it can be be a `Radio`, a `Switch` or a `Checkbox`.
   */
  control: _propTypes.default.element,

  /**
   * If `true`, the control will be disabled.
   */
  disabled: _propTypes.default.bool,

  /**
   * Use that property to pass a ref callback to the native input component.
   */
  inputRef: _propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.object]),

  /**
   * The text to be used in an enclosing label element.
   */
  label: _propTypes.default.node,

  /**
   * The position of the label.
   */
  labelPlacement: _propTypes.default.oneOf(['end', 'start']),

  /*
   * @ignore
   */
  name: _propTypes.default.string,

  /**
   * Callback fired when the state is changed.
   *
   * @param {object} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.checked`.
   * @param {boolean} checked The `checked` value of the switch
   */
  onChange: _propTypes.default.func,

  /**
   * The value of the component.
   */
  value: _propTypes.default.string
} : {};
FormControlLabel.defaultProps = {
  labelPlacement: 'end'
};
FormControlLabel.contextTypes = {
  muiFormControl: _propTypes.default.object
};

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiFormControlLabel'
})(FormControlLabel);

exports.default = _default;

/***/ }),
/* 554 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(9);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(10));

var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
  fill: "none",
  d: "M0 0h24v24H0z"
}), _react.default.createElement("path", {
  d: "M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 14H4V8l8 5 8-5v10zm-8-7L4 6h16l-8 5z"
})), 'MailOutline');

exports.default = _default;

/***/ }),
/* 555 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(2);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(6));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(7));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(4));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(11));

var _createClass2 = _interopRequireDefault(__webpack_require__(12));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(13));

var _inherits2 = _interopRequireDefault(__webpack_require__(14));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _classnames = _interopRequireDefault(__webpack_require__(5));

var _withStyles = _interopRequireDefault(__webpack_require__(3));

var _Input = __webpack_require__(183);

var _helpers = __webpack_require__(37);

var _reactHelpers = __webpack_require__(184);

var styles = {
  /* Styles applied to the root element. */
  root: {
    display: 'inline-flex',
    flexDirection: 'column',
    position: 'relative',
    // Reset fieldset default style
    minWidth: 0,
    padding: 0,
    margin: 0,
    border: 0
  },

  /* Styles applied to the root element if `margin="normal"`. */
  marginNormal: {
    marginTop: 16,
    marginBottom: 8
  },

  /* Styles applied to the root element if `margin="dense"`. */
  marginDense: {
    marginTop: 8,
    marginBottom: 4
  },

  /* Styles applied to the root element if `fullWidth={true}`. */
  fullWidth: {
    width: '100%'
  }
};
/**
 * Provides context such as filled/focused/error/required for form inputs.
 * Relying on the context provides high flexibilty and ensures that the state always stays
 * consistent across the children of the `FormControl`.
 * This context is used by the following components:
 *  - FormLabel
 *  - FormHelperText
 *  - Input
 *  - InputLabel
 */

exports.styles = styles;

var FormControl =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(FormControl, _React$Component);

  function FormControl(props) {
    var _this;

    (0, _classCallCheck2.default)(this, FormControl);
    _this = (0, _possibleConstructorReturn2.default)(this, (FormControl.__proto__ || Object.getPrototypeOf(FormControl)).call(this, props)); // We need to iterate through the children and find the Input in order
    // to fully support server side rendering.

    _this.state = {
      adornedStart: false,
      filled: false,
      focused: false
    };

    _this.handleFocus = function () {
      _this.setState(function (state) {
        return !state.focused ? {
          focused: true
        } : null;
      });
    };

    _this.handleBlur = function () {
      _this.setState(function (state) {
        return state.focused ? {
          focused: false
        } : null;
      });
    };

    _this.handleDirty = function () {
      if (!_this.state.filled) {
        _this.setState({
          filled: true
        });
      }
    };

    _this.handleClean = function () {
      if (_this.state.filled) {
        _this.setState({
          filled: false
        });
      }
    };

    var children = _this.props.children;

    if (children) {
      _react.default.Children.forEach(children, function (child) {
        if (!(0, _reactHelpers.isMuiElement)(child, ['Input', 'Select', 'NativeSelect'])) {
          return;
        }

        if ((0, _Input.isFilled)(child.props, true)) {
          _this.state.filled = true;
        }

        var input = (0, _reactHelpers.isMuiElement)(child, ['Select', 'NativeSelect']) ? child.props.input : child;

        if (input && (0, _Input.isAdornedStart)(input.props)) {
          _this.state.adornedStart = true;
        }
      });
    }

    return _this;
  }

  (0, _createClass2.default)(FormControl, [{
    key: "getChildContext",
    value: function getChildContext() {
      var _props = this.props,
          disabled = _props.disabled,
          error = _props.error,
          required = _props.required,
          margin = _props.margin;
      var _state = this.state,
          adornedStart = _state.adornedStart,
          filled = _state.filled,
          focused = _state.focused;
      return {
        muiFormControl: {
          adornedStart: adornedStart,
          disabled: disabled,
          error: error,
          filled: filled,
          focused: focused,
          margin: margin,
          onBlur: this.handleBlur,
          onEmpty: this.handleClean,
          onFilled: this.handleDirty,
          onFocus: this.handleFocus,
          required: required
        }
      };
    }
  }, {
    key: "render",
    value: function render() {
      var _classNames;

      var _props2 = this.props,
          classes = _props2.classes,
          className = _props2.className,
          Component = _props2.component,
          disabled = _props2.disabled,
          error = _props2.error,
          fullWidth = _props2.fullWidth,
          margin = _props2.margin,
          required = _props2.required,
          other = (0, _objectWithoutProperties2.default)(_props2, ["classes", "className", "component", "disabled", "error", "fullWidth", "margin", "required"]);
      return _react.default.createElement(Component, (0, _extends2.default)({
        className: (0, _classnames.default)(classes.root, (_classNames = {}, (0, _defineProperty2.default)(_classNames, classes["margin".concat((0, _helpers.capitalize)(margin))], margin !== 'none'), (0, _defineProperty2.default)(_classNames, classes.fullWidth, fullWidth), _classNames), className)
      }, other));
    }
  }]);
  return FormControl;
}(_react.default.Component);

FormControl.propTypes =  false ? {
  /**
   * The contents of the form control.
   */
  children: _propTypes.default.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * The component used for the root node.
   * Either a string to use a DOM element or a component.
   */
  component: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func, _propTypes.default.object]),

  /**
   * If `true`, the label, input and helper text should be displayed in a disabled state.
   */
  disabled: _propTypes.default.bool,

  /**
   * If `true`, the label should be displayed in an error state.
   */
  error: _propTypes.default.bool,

  /**
   * If `true`, the component will take up the full width of its container.
   */
  fullWidth: _propTypes.default.bool,

  /**
   * If `dense` or `normal`, will adjust vertical spacing of this and contained components.
   */
  margin: _propTypes.default.oneOf(['none', 'dense', 'normal']),

  /**
   * If `true`, the label will indicate that the input is required.
   */
  required: _propTypes.default.bool
} : {};
FormControl.defaultProps = {
  component: 'div',
  disabled: false,
  error: false,
  fullWidth: false,
  margin: 'none',
  required: false
};
FormControl.childContextTypes = {
  muiFormControl: _propTypes.default.object
};

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiFormControl'
})(FormControl);

exports.default = _default;

/***/ }),
/* 556 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(2);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(6));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(4));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(11));

var _createClass2 = _interopRequireDefault(__webpack_require__(12));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(13));

var _inherits2 = _interopRequireDefault(__webpack_require__(14));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _classnames = _interopRequireDefault(__webpack_require__(5));

var _debounce = _interopRequireDefault(__webpack_require__(128));

var _reactEventListener = _interopRequireDefault(__webpack_require__(102));

var _withStyles = _interopRequireDefault(__webpack_require__(3));

// < 1kb payload overhead when lodash/debounce is > 3kb.
var ROWS_HEIGHT = 19;
var styles = {
  /* Styles applied to the root element. */
  root: {
    position: 'relative',
    // because the shadow has position: 'absolute',
    width: '100%'
  },
  textarea: {
    width: '100%',
    height: '100%',
    resize: 'none',
    font: 'inherit',
    padding: 0,
    cursor: 'inherit',
    boxSizing: 'border-box',
    lineHeight: 'inherit',
    border: 'none',
    outline: 'none',
    background: 'transparent'
  },
  shadow: {
    // Overflow also needed to here to remove the extra row
    // added to textareas in Firefox.
    overflow: 'hidden',
    // Visibility needed to hide the extra text area on ipads
    visibility: 'hidden',
    position: 'absolute',
    height: 'auto',
    whiteSpace: 'pre-wrap'
  }
};
/**
 * @ignore - internal component.
 */

exports.styles = styles;

var Textarea =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(Textarea, _React$Component);

  // Corresponds to 10 frames at 60 Hz.
  function Textarea(props) {
    var _this;

    (0, _classCallCheck2.default)(this, Textarea);
    _this = (0, _possibleConstructorReturn2.default)(this, (Textarea.__proto__ || Object.getPrototypeOf(Textarea)).call(this, props)); // <Input> expects the components it renders to respond to 'value'
    // so that it can check whether they are filled.

    _this.isControlled = _this.props.value != null;
    _this.shadowRef = null;
    _this.singlelineShadowRef = null;
    _this.inputRef = null;
    _this.value = null;
    _this.handleResize = (0, _debounce.default)(function () {
      _this.syncHeightWithShadow();
    }, 166);
    _this.state = {
      height: null
    };

    _this.handleRefInput = function (ref) {
      _this.inputRef = ref;
      var textareaRef = _this.props.textareaRef;

      if (textareaRef) {
        if (typeof textareaRef === 'function') {
          textareaRef(ref);
        } else {
          textareaRef.current = ref;
        }
      }
    };

    _this.handleRefSinglelineShadow = function (ref) {
      _this.singlelineShadowRef = ref;
    };

    _this.handleRefShadow = function (ref) {
      _this.shadowRef = ref;
    };

    _this.handleChange = function (event) {
      _this.value = event.target.value;

      if (!_this.isControlled) {
        // The component is not controlled, we need to update the shallow value.
        _this.shadowRef.value = _this.value;

        _this.syncHeightWithShadow();
      }

      if (_this.props.onChange) {
        _this.props.onChange(event);
      }
    };

    _this.value = props.value || props.defaultValue || '';
    _this.state = {
      height: Number(props.rows) * ROWS_HEIGHT
    };
    return _this;
  }

  (0, _createClass2.default)(Textarea, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.syncHeightWithShadow();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.syncHeightWithShadow();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.handleResize.clear();
    }
  }, {
    key: "syncHeightWithShadow",
    value: function syncHeightWithShadow() {
      var props = this.props; // Guarding for **broken** shallow rendering method that call componentDidMount
      // but doesn't handle refs correctly.
      // To remove once the shallow rendering has been fixed.

      if (!this.shadowRef) {
        return;
      }

      if (this.isControlled) {
        // The component is controlled, we need to update the shallow value.
        this.shadowRef.value = props.value == null ? '' : String(props.value);
      }

      var lineHeight = this.singlelineShadowRef.scrollHeight;
      var newHeight = this.shadowRef.scrollHeight; // Guarding for jsdom, where scrollHeight isn't present.
      // See https://github.com/tmpvar/jsdom/issues/1013

      if (newHeight === undefined) {
        return;
      }

      if (Number(props.rowsMax) >= Number(props.rows)) {
        newHeight = Math.min(Number(props.rowsMax) * lineHeight, newHeight);
      }

      newHeight = Math.max(newHeight, lineHeight); // Need a large enough different to update the height.
      // This prevents infinite rendering loop.

      if (Math.abs(this.state.height - newHeight) > 1) {
        this.setState({
          height: newHeight
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _props = this.props,
          classes = _props.classes,
          className = _props.className,
          defaultValue = _props.defaultValue,
          onChange = _props.onChange,
          rows = _props.rows,
          rowsMax = _props.rowsMax,
          textareaRef = _props.textareaRef,
          value = _props.value,
          other = (0, _objectWithoutProperties2.default)(_props, ["classes", "className", "defaultValue", "onChange", "rows", "rowsMax", "textareaRef", "value"]);
      return _react.default.createElement("div", {
        className: classes.root,
        style: {
          height: this.state.height
        }
      }, _react.default.createElement(_reactEventListener.default, {
        target: "window",
        onResize: this.handleResize
      }), _react.default.createElement("textarea", {
        "aria-hidden": "true",
        className: (0, _classnames.default)(classes.textarea, classes.shadow),
        readOnly: true,
        ref: this.handleRefSinglelineShadow,
        rows: "1",
        tabIndex: -1,
        value: ""
      }), _react.default.createElement("textarea", {
        "aria-hidden": "true",
        className: (0, _classnames.default)(classes.textarea, classes.shadow),
        defaultValue: defaultValue,
        readOnly: true,
        ref: this.handleRefShadow,
        rows: rows,
        tabIndex: -1,
        value: value
      }), _react.default.createElement("textarea", (0, _extends2.default)({
        rows: rows,
        className: (0, _classnames.default)(classes.textarea, className),
        defaultValue: defaultValue,
        value: value,
        onChange: this.handleChange,
        ref: this.handleRefInput
      }, other)));
    }
  }]);
  return Textarea;
}(_react.default.Component);

Textarea.propTypes =  false ? {
  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * @ignore
   */
  defaultValue: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),

  /**
   * @ignore
   */
  disabled: _propTypes.default.bool,

  /**
   * @ignore
   */
  onChange: _propTypes.default.func,

  /**
   * Number of rows to display when multiline option is set to true.
   */
  rows: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),

  /**
   * Maximum number of rows to display when multiline option is set to true.
   */
  rowsMax: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),

  /**
   * Use that property to pass a ref callback to the native textarea element.
   */
  textareaRef: _propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.object]),

  /**
   * @ignore
   */
  value: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number])
} : {};
Textarea.defaultProps = {
  rows: 1
};

var _default = (0, _withStyles.default)(styles)(Textarea);

exports.default = _default;

/***/ }),
/* 557 */
/***/ (function(module, exports) {

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

module.exports = _classCallCheck;

/***/ }),
/* 558 */
/***/ (function(module, exports) {

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

module.exports = _createClass;

/***/ }),
/* 559 */
/***/ (function(module, exports, __webpack_require__) {

var _typeof = __webpack_require__(261);

var assertThisInitialized = __webpack_require__(560);

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return assertThisInitialized(self);
}

module.exports = _possibleConstructorReturn;

/***/ }),
/* 560 */
/***/ (function(module, exports) {

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

module.exports = _assertThisInitialized;

/***/ }),
/* 561 */
/***/ (function(module, exports) {

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

module.exports = _inherits;

/***/ }),
/* 562 */
/***/ (function(module, exports) {

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

module.exports = _objectWithoutProperties;

/***/ }),
/* 563 */
/***/ (function(module, exports, __webpack_require__) {

var defineProperty = __webpack_require__(564);

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      defineProperty(target, key, source[key]);
    });
  }

  return target;
}

module.exports = _objectSpread;

/***/ }),
/* 564 */
/***/ (function(module, exports) {

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

module.exports = _defineProperty;

/***/ }),
/* 565 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(2);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(6));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(7));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(4));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _classnames = _interopRequireDefault(__webpack_require__(5));

var _withStyles = _interopRequireDefault(__webpack_require__(3));

var _FormLabel = _interopRequireDefault(__webpack_require__(566));

// @inheritedComponent FormLabel
var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      transformOrigin: 'top left'
    },

    /* Styles applied to the root element if the component is a descendant of `FormControl`. */
    formControl: {
      position: 'absolute',
      left: 0,
      top: 0,
      // slight alteration to spec spacing to match visual spec result
      transform: 'translate(0, 24px) scale(1)'
    },

    /* Styles applied to the root element if `margin="dense"`. */
    marginDense: {
      // Compensation for the `Input.inputDense` style.
      transform: 'translate(0, 21px) scale(1)'
    },

    /* Styles applied to the `input` element if `shrink={true}`. */
    shrink: {
      transform: 'translate(0, 1.5px) scale(0.75)',
      transformOrigin: 'top left'
    },

    /* Styles applied to the `input` element if `disableAnimation={false}`. */
    animated: {
      transition: theme.transitions.create('transform', {
        duration: theme.transitions.duration.shorter,
        easing: theme.transitions.easing.easeOut
      })
    }
  };
};

exports.styles = styles;

function InputLabel(props, context) {
  var _classNames;

  var children = props.children,
      classes = props.classes,
      classNameProp = props.className,
      disableAnimation = props.disableAnimation,
      FormLabelClasses = props.FormLabelClasses,
      marginProp = props.margin,
      shrinkProp = props.shrink,
      other = (0, _objectWithoutProperties2.default)(props, ["children", "classes", "className", "disableAnimation", "FormLabelClasses", "margin", "shrink"]);
  var muiFormControl = context.muiFormControl;
  var shrink = shrinkProp;

  if (typeof shrink === 'undefined' && muiFormControl) {
    shrink = muiFormControl.filled || muiFormControl.focused || muiFormControl.adornedStart;
  }

  var margin = marginProp;

  if (typeof margin === 'undefined' && muiFormControl) {
    margin = muiFormControl.margin;
  }

  var className = (0, _classnames.default)(classes.root, (_classNames = {}, (0, _defineProperty2.default)(_classNames, classes.formControl, muiFormControl), (0, _defineProperty2.default)(_classNames, classes.animated, !disableAnimation), (0, _defineProperty2.default)(_classNames, classes.shrink, shrink), (0, _defineProperty2.default)(_classNames, classes.marginDense, margin === 'dense'), _classNames), classNameProp);
  return _react.default.createElement(_FormLabel.default, (0, _extends2.default)({
    "data-shrink": shrink,
    className: className,
    classes: FormLabelClasses
  }, other), children);
}

InputLabel.propTypes =  false ? {
  /**
   * The contents of the `InputLabel`.
   */
  children: _propTypes.default.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * If `true`, the transition animation is disabled.
   */
  disableAnimation: _propTypes.default.bool,

  /**
   * If `true`, apply disabled class.
   */
  disabled: _propTypes.default.bool,

  /**
   * If `true`, the label will be displayed in an error state.
   */
  error: _propTypes.default.bool,

  /**
   * If `true`, the input of this label is focused.
   */
  focused: _propTypes.default.bool,

  /**
   * `classes` property applied to the `FormLabel` element.
   */
  FormLabelClasses: _propTypes.default.object,

  /**
   * If `dense`, will adjust vertical spacing. This is normally obtained via context from
   * FormControl.
   */
  margin: _propTypes.default.oneOf(['dense']),

  /**
   * if `true`, the label will indicate that the input is required.
   */
  required: _propTypes.default.bool,

  /**
   * If `true`, the label is shrunk.
   */
  shrink: _propTypes.default.bool
} : {};
InputLabel.defaultProps = {
  disableAnimation: false
};
InputLabel.contextTypes = {
  muiFormControl: _propTypes.default.object
};

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiInputLabel'
})(InputLabel);

exports.default = _default;

/***/ }),
/* 566 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(2);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _FormLabel.default;
  }
});

var _FormLabel = _interopRequireDefault(__webpack_require__(567));

/***/ }),
/* 567 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(2);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(6));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(7));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(4));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _classnames = _interopRequireDefault(__webpack_require__(5));

var _withStyles = _interopRequireDefault(__webpack_require__(3));

var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      fontFamily: theme.typography.fontFamily,
      color: theme.palette.text.secondary,
      fontSize: theme.typography.pxToRem(16),
      lineHeight: 1,
      padding: 0,
      '&$focused': {
        color: theme.palette.primary[theme.palette.type === 'light' ? 'dark' : 'light']
      },
      '&$disabled': {
        color: theme.palette.text.disabled
      },
      '&$error': {
        color: theme.palette.error.main
      }
    },

    /* Styles applied to the root element if `focused={true}`. */
    focused: {},

    /* Styles applied to the root element if `disabled={true}`. */
    disabled: {},

    /* Styles applied to the root element if `error={true}`. */
    error: {},

    /* Styles applied to the root element if `filled={true}`. */
    filled: {},

    /* Styles applied to the root element if `required={true}`. */
    required: {},
    asterisk: {
      '&$error': {
        color: theme.palette.error.main
      }
    }
  };
};

exports.styles = styles;

function FormLabel(props, context) {
  var _classNames;

  var children = props.children,
      classes = props.classes,
      classNameProp = props.className,
      Component = props.component,
      disabledProp = props.disabled,
      errorProp = props.error,
      filledProp = props.filled,
      focusedProp = props.focused,
      requiredProp = props.required,
      other = (0, _objectWithoutProperties2.default)(props, ["children", "classes", "className", "component", "disabled", "error", "filled", "focused", "required"]);
  var muiFormControl = context.muiFormControl;
  var disabled = disabledProp;
  var error = errorProp;
  var filled = filledProp;
  var focused = focusedProp;
  var required = requiredProp;

  if (muiFormControl) {
    if (typeof required === 'undefined') {
      required = muiFormControl.required;
    }

    if (typeof focused === 'undefined') {
      focused = muiFormControl.focused;
    }

    if (typeof disabled === 'undefined') {
      disabled = muiFormControl.disabled;
    }

    if (typeof error === 'undefined') {
      error = muiFormControl.error;
    }

    if (typeof filled === 'undefined') {
      filled = muiFormControl.filled;
    }
  }

  var className = (0, _classnames.default)(classes.root, (_classNames = {}, (0, _defineProperty2.default)(_classNames, classes.disabled, disabled), (0, _defineProperty2.default)(_classNames, classes.error, error), (0, _defineProperty2.default)(_classNames, classes.filled, filled), (0, _defineProperty2.default)(_classNames, classes.focused, focused), (0, _defineProperty2.default)(_classNames, classes.required, required), _classNames), classNameProp);
  return _react.default.createElement(Component, (0, _extends2.default)({
    className: className
  }, other), children, required && _react.default.createElement("span", {
    className: (0, _classnames.default)(classes.asterisk, (0, _defineProperty2.default)({}, classes.error, error))
  }, "\u2009*"));
}

FormLabel.propTypes =  false ? {
  /**
   * The content of the component.
   */
  children: _propTypes.default.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * The component used for the root node.
   * Either a string to use a DOM element or a component.
   */
  component: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func, _propTypes.default.object]),

  /**
   * If `true`, the label should be displayed in a disabled state.
   */
  disabled: _propTypes.default.bool,

  /**
   * If `true`, the label should be displayed in an error state.
   */
  error: _propTypes.default.bool,

  /**
   * If `true`, the label should use filled classes key.
   */
  filled: _propTypes.default.bool,

  /**
   * If `true`, the input of this label is focused (used by `FormGroup` components).
   */
  focused: _propTypes.default.bool,

  /**
   * If `true`, the label will indicate that the input is required.
   */
  required: _propTypes.default.bool
} : {};
FormLabel.defaultProps = {
  component: 'label'
};
FormLabel.contextTypes = {
  muiFormControl: _propTypes.default.object
};

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiFormLabel'
})(FormLabel);

exports.default = _default;

/***/ }),
/* 568 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(2);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(6));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(7));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(4));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _classnames = _interopRequireDefault(__webpack_require__(5));

var _withStyles = _interopRequireDefault(__webpack_require__(3));

var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      color: theme.palette.text.secondary,
      fontFamily: theme.typography.fontFamily,
      fontSize: theme.typography.pxToRem(12),
      textAlign: 'left',
      marginTop: 8,
      lineHeight: '1em',
      minHeight: '1em',
      margin: 0,
      '&$error': {
        color: theme.palette.error.main
      },
      '&$disabled': {
        color: theme.palette.text.disabled
      }
    },

    /* Styles applied to the root element if `error={true}`. */
    error: {},

    /* Styles applied to the root element if `disabled={true}`. */
    disabled: {},

    /* Styles applied to the root element if `margin="dense"`. */
    marginDense: {
      marginTop: 4
    },

    /* Styles applied to the root element if `focused={true}`. */
    focused: {},

    /* Styles applied to the root element if `filled={true}`. */
    filled: {},

    /* Styles applied to the root element if `required={true}`. */
    required: {}
  };
};

exports.styles = styles;

function FormHelperText(props, context) {
  var _classNames;

  var classes = props.classes,
      classNameProp = props.className,
      Component = props.component,
      disabledProp = props.disabled,
      errorProp = props.error,
      filledProp = props.filled,
      focusedProp = props.focused,
      marginProp = props.margin,
      requiredProp = props.required,
      other = (0, _objectWithoutProperties2.default)(props, ["classes", "className", "component", "disabled", "error", "filled", "focused", "margin", "required"]);
  var muiFormControl = context.muiFormControl;
  var disabled = disabledProp;
  var error = errorProp;
  var filled = filledProp;
  var focused = focusedProp;
  var margin = marginProp;
  var required = requiredProp;

  if (muiFormControl) {
    if (typeof disabled === 'undefined') {
      disabled = muiFormControl.disabled;
    }

    if (typeof error === 'undefined') {
      error = muiFormControl.error;
    }

    if (typeof margin === 'undefined') {
      margin = muiFormControl.margin;
    }

    if (typeof required === 'undefined') {
      required = muiFormControl.required;
    }

    if (typeof focused === 'undefined') {
      focused = muiFormControl.focused;
    }

    if (typeof filled === 'undefined') {
      filled = muiFormControl.filled;
    }
  }

  var className = (0, _classnames.default)(classes.root, (_classNames = {}, (0, _defineProperty2.default)(_classNames, classes.disabled, disabled), (0, _defineProperty2.default)(_classNames, classes.error, error), (0, _defineProperty2.default)(_classNames, classes.filled, filled), (0, _defineProperty2.default)(_classNames, classes.focused, focused), (0, _defineProperty2.default)(_classNames, classes.marginDense, margin === 'dense'), (0, _defineProperty2.default)(_classNames, classes.required, required), _classNames), classNameProp);
  return _react.default.createElement(Component, (0, _extends2.default)({
    className: className
  }, other));
}

FormHelperText.propTypes =  false ? {
  /**
   * The content of the component.
   */
  children: _propTypes.default.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * The component used for the root node.
   * Either a string to use a DOM element or a component.
   */
  component: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func, _propTypes.default.object]),

  /**
   * If `true`, the helper text should be displayed in a disabled state.
   */
  disabled: _propTypes.default.bool,

  /**
   * If `true`, helper text should be displayed in an error state.
   */
  error: _propTypes.default.bool,

  /**
   * If `true`, the helper text should use filled classes key.
   */
  filled: _propTypes.default.bool,

  /**
   * If `true`, the helper text should use focused classes key.
   */
  focused: _propTypes.default.bool,

  /**
   * If `dense`, will adjust vertical spacing. This is normally obtained via context from
   * FormControl.
   */
  margin: _propTypes.default.oneOf(['dense']),

  /**
   * If `true`, the helper text should use required classes key.
   */
  required: _propTypes.default.bool
} : {};
FormHelperText.defaultProps = {
  component: 'p'
};
FormHelperText.contextTypes = {
  muiFormControl: _propTypes.default.object
};

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiFormHelperText'
})(FormHelperText);

exports.default = _default;

/***/ }),
/* 569 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__ = __webpack_require__(21);
var customInputStyle={disabled:{"&:before":{borderColor:"transparent !important"}},underline:{"&:hover:not($disabled):before,&:before":{borderColor:"#D2D2D2 !important",borderWidth:"1px !important"},"&:after":{borderColor:__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["r" /* primaryColor */]}},underlineError:{"&:after":{borderColor:__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["g" /* dangerColor */]}},underlineSuccess:{"&:after":{borderColor:__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["x" /* successColor */]}},labelRoot:Object.assign({},__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["i" /* defaultFont */],{color:"#AAAAAA !important",fontWeight:"400",fontSize:"14px",lineHeight:"1.42857",top:"10px","& + $underline":{marginTop:"0px"}}),labelRootError:{color:__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["g" /* dangerColor */]+" !important"},labelRootSuccess:{color:__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["x" /* successColor */]+" !important"},formControl:{margin:"0 0 17px 0",paddingTop:"27px",position:"relative","& svg,& .fab,& .far,& .fal,& .fas,& .material-icons":{color:"#495057"}},whiteUnderline:{"&:hover:not($disabled):before,&:before":{backgroundColor:"#FFFFFF"},"&:after":{backgroundColor:"#FFFFFF"}},input:{color:"#495057","&,&::placeholder":{fontSize:"14px",fontFamily:'"Roboto", "Helvetica", "Arial", sans-serif',fontWeight:"400",lineHeight:"1.42857",opacity:"1"},"&::placeholder":{color:"#AAAAAA"}},whiteInput:{"&,&::placeholder":{color:"#FFFFFF",opacity:"1"}}};/* harmony default export */ __webpack_exports__["a"] = (customInputStyle);

/***/ }),
/* 570 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_assets_jss_material_dashboard_pro_react_customCheckboxRadioSwitch_jsx__ = __webpack_require__(130);
// ##############################
// // // RegularForms view styles
// #############################
var regularFormsStyle=Object.assign({},__WEBPACK_IMPORTED_MODULE_1_assets_jss_material_dashboard_pro_react_customCheckboxRadioSwitch_jsx__["a" /* default */],{cardIconTitle:Object.assign({},__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["b" /* cardTitle */],{marginTop:"15px",marginBottom:"0px"}),staticFormGroup:{marginLeft:"0",marginRight:"0",paddingBottom:"10px",margin:"8px 0 0 0",position:"relative","&:before,&:after":{display:"table",content:'" "'},"&:after":{clear:"both"}},staticFormControl:{marginBottom:"0",paddingTop:"8px",paddingBottom:"8px",minHeight:"34px"},inputAdornment:{marginRight:"8px",position:"relative"},inputAdornmentIconSuccess:{color:__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["x" /* successColor */]+"!important"},inputAdornmentIconError:{color:__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["g" /* dangerColor */]+"!important"}});/* harmony default export */ __webpack_exports__["a"] = (regularFormsStyle);

/***/ }),
/* 571 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(2);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Table.default;
  }
});

var _Table = _interopRequireDefault(__webpack_require__(572));

/***/ }),
/* 572 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(2);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(6));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(4));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(11));

var _createClass2 = _interopRequireDefault(__webpack_require__(12));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(13));

var _inherits2 = _interopRequireDefault(__webpack_require__(14));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _classnames = _interopRequireDefault(__webpack_require__(5));

var _withStyles = _interopRequireDefault(__webpack_require__(3));

var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      display: 'table',
      fontFamily: theme.typography.fontFamily,
      width: '100%',
      borderCollapse: 'collapse',
      borderSpacing: 0
    }
  };
};

exports.styles = styles;

var Table =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(Table, _React$Component);

  function Table() {
    (0, _classCallCheck2.default)(this, Table);
    return (0, _possibleConstructorReturn2.default)(this, (Table.__proto__ || Object.getPrototypeOf(Table)).apply(this, arguments));
  }

  (0, _createClass2.default)(Table, [{
    key: "getChildContext",
    value: function getChildContext() {
      // eslint-disable-line class-methods-use-this
      return {
        table: {}
      };
    }
  }, {
    key: "render",
    value: function render() {
      var _props = this.props,
          classes = _props.classes,
          className = _props.className,
          Component = _props.component,
          other = (0, _objectWithoutProperties2.default)(_props, ["classes", "className", "component"]);
      return _react.default.createElement(Component, (0, _extends2.default)({
        className: (0, _classnames.default)(classes.root, className)
      }, other));
    }
  }]);
  return Table;
}(_react.default.Component);

Table.propTypes =  false ? {
  /**
   * The content of the table, normally `TableHeader` and `TableBody`.
   */
  children: _propTypes.default.node.isRequired,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * The component used for the root node.
   * Either a string to use a DOM element or a component.
   */
  component: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func, _propTypes.default.object])
} : {};
Table.defaultProps = {
  component: 'table'
};
Table.childContextTypes = {
  table: _propTypes.default.object
};

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiTable'
})(Table);

exports.default = _default;

/***/ }),
/* 573 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(2);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _TableBody.default;
  }
});

var _TableBody = _interopRequireDefault(__webpack_require__(574));

/***/ }),
/* 574 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(2);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(6));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(4));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(11));

var _createClass2 = _interopRequireDefault(__webpack_require__(12));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(13));

var _inherits2 = _interopRequireDefault(__webpack_require__(14));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _classnames = _interopRequireDefault(__webpack_require__(5));

var _withStyles = _interopRequireDefault(__webpack_require__(3));

var styles = {
  /* Styles applied to the root element. */
  root: {
    display: 'table-row-group'
  }
};
exports.styles = styles;

var TableBody =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(TableBody, _React$Component);

  function TableBody() {
    (0, _classCallCheck2.default)(this, TableBody);
    return (0, _possibleConstructorReturn2.default)(this, (TableBody.__proto__ || Object.getPrototypeOf(TableBody)).apply(this, arguments));
  }

  (0, _createClass2.default)(TableBody, [{
    key: "getChildContext",
    value: function getChildContext() {
      // eslint-disable-line class-methods-use-this
      return {
        table: {
          body: true
        }
      };
    }
  }, {
    key: "render",
    value: function render() {
      var _props = this.props,
          classes = _props.classes,
          className = _props.className,
          Component = _props.component,
          other = (0, _objectWithoutProperties2.default)(_props, ["classes", "className", "component"]);
      return _react.default.createElement(Component, (0, _extends2.default)({
        className: (0, _classnames.default)(classes.root, className)
      }, other));
    }
  }]);
  return TableBody;
}(_react.default.Component);

TableBody.propTypes =  false ? {
  /**
   * The content of the component, normally `TableRow`.
   */
  children: _propTypes.default.node.isRequired,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * The component used for the root node.
   * Either a string to use a DOM element or a component.
   */
  component: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func, _propTypes.default.object])
} : {};
TableBody.defaultProps = {
  component: 'tbody'
};
TableBody.childContextTypes = {
  table: _propTypes.default.object
};

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiTableBody'
})(TableBody);

exports.default = _default;

/***/ }),
/* 575 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(2);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _TableCell.default;
  }
});

var _TableCell = _interopRequireDefault(__webpack_require__(576));

/***/ }),
/* 576 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(2);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(6));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(7));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(4));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _classnames = _interopRequireDefault(__webpack_require__(5));

var _withStyles = _interopRequireDefault(__webpack_require__(3));

var _helpers = __webpack_require__(37);

var _colorManipulator = __webpack_require__(70);

var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      display: 'table-cell',
      verticalAlign: 'inherit',
      // Workaround for a rendering bug with spanned columns in Chrome 62.0.
      // Removes the alpha (sets it to 1), and lightens or darkens the theme color.
      borderBottom: "1px solid\n    ".concat(theme.palette.type === 'light' ? (0, _colorManipulator.lighten)((0, _colorManipulator.fade)(theme.palette.divider, 1), 0.88) : (0, _colorManipulator.darken)((0, _colorManipulator.fade)(theme.palette.divider, 1), 0.8)),
      textAlign: 'left',
      padding: '4px 56px 4px 24px',
      '&:last-child': {
        paddingRight: 24
      }
    },

    /* Styles applied to the root element if `variant="head"` or `context.table.head`. */
    head: {
      color: theme.palette.text.secondary,
      fontSize: theme.typography.pxToRem(12),
      fontWeight: theme.typography.fontWeightMedium
    },

    /* Styles applied to the root element if `variant="body"` or `context.table.body`. */
    body: {
      color: theme.palette.text.primary,
      fontSize: theme.typography.pxToRem(13),
      fontWeight: theme.typography.fontWeightRegular
    },

    /* Styles applied to the root element if `variant="footer"` or `context.table.footer`. */
    footer: {
      borderBottom: 0,
      color: theme.palette.text.secondary,
      fontSize: theme.typography.pxToRem(12)
    },

    /* Styles applied to the root element if `numeric={true}`. */
    numeric: {
      textAlign: 'right',
      flexDirection: 'row-reverse' // can be dynamically inherited at runtime by contents

    },

    /* Styles applied to the root element if `padding="dense"`. */
    paddingDense: {
      paddingRight: 24
    },

    /* Styles applied to the root element if `padding="checkbox"`. */
    paddingCheckbox: {
      padding: '0 12px',
      '&:last-child': {
        paddingRight: 12
      }
    },

    /* Styles applied to the root element if `padding="none"`. */
    paddingNone: {
      padding: 0,
      '&:last-child': {
        padding: 0
      }
    }
  };
};

exports.styles = styles;

function TableCell(props, context) {
  var _classNames;

  var children = props.children,
      classes = props.classes,
      classNameProp = props.className,
      component = props.component,
      sortDirection = props.sortDirection,
      numeric = props.numeric,
      padding = props.padding,
      scopeProp = props.scope,
      variant = props.variant,
      other = (0, _objectWithoutProperties2.default)(props, ["children", "classes", "className", "component", "sortDirection", "numeric", "padding", "scope", "variant"]);
  var table = context.table;
  var Component;

  if (component) {
    Component = component;
  } else {
    Component = table && table.head ? 'th' : 'td';
  }

  var scope = scopeProp;

  if (!scope && table && table.head) {
    scope = 'col';
  }

  var className = (0, _classnames.default)(classes.root, (_classNames = {}, (0, _defineProperty2.default)(_classNames, classes.head, variant ? variant === 'head' : table && table.head), (0, _defineProperty2.default)(_classNames, classes.body, variant ? variant === 'body' : table && table.body), (0, _defineProperty2.default)(_classNames, classes.footer, variant ? variant === 'footer' : table && table.footer), (0, _defineProperty2.default)(_classNames, classes.numeric, numeric), (0, _defineProperty2.default)(_classNames, classes["padding".concat((0, _helpers.capitalize)(padding))], padding !== 'default'), _classNames), classNameProp);
  var ariaSort = null;

  if (sortDirection) {
    ariaSort = sortDirection === 'asc' ? 'ascending' : 'descending';
  }

  return _react.default.createElement(Component, (0, _extends2.default)({
    className: className,
    "aria-sort": ariaSort,
    scope: scope
  }, other), children);
}

TableCell.propTypes =  false ? {
  /**
   * The table cell contents.
   */
  children: _propTypes.default.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * The component used for the root node.
   * Either a string to use a DOM element or a component.
   */
  component: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func, _propTypes.default.object]),

  /**
   * If `true`, content will align to the right.
   */
  numeric: _propTypes.default.bool,

  /**
   * Sets the padding applied to the cell.
   */
  padding: _propTypes.default.oneOf(['default', 'checkbox', 'dense', 'none']),

  /**
   * Set scope attribute.
   */
  scope: _propTypes.default.string,

  /**
   * Set aria-sort direction.
   */
  sortDirection: _propTypes.default.oneOf(['asc', 'desc', false]),

  /**
   * Specify the cell type.
   * By default, the TableHead, TableBody or TableFooter parent component set the value.
   */
  variant: _propTypes.default.oneOf(['head', 'body', 'footer'])
} : {};
TableCell.defaultProps = {
  numeric: false,
  padding: 'default'
};
TableCell.contextTypes = {
  table: _propTypes.default.object.isRequired
};

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiTableCell'
})(TableCell);

exports.default = _default;

/***/ }),
/* 577 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(2);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _TableHead.default;
  }
});

var _TableHead = _interopRequireDefault(__webpack_require__(578));

/***/ }),
/* 578 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(2);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(6));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(4));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(11));

var _createClass2 = _interopRequireDefault(__webpack_require__(12));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(13));

var _inherits2 = _interopRequireDefault(__webpack_require__(14));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _classnames = _interopRequireDefault(__webpack_require__(5));

var _withStyles = _interopRequireDefault(__webpack_require__(3));

var styles = {
  /* Styles applied to the root element. */
  root: {
    display: 'table-header-group'
  }
};
exports.styles = styles;

var TableHead =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(TableHead, _React$Component);

  function TableHead() {
    (0, _classCallCheck2.default)(this, TableHead);
    return (0, _possibleConstructorReturn2.default)(this, (TableHead.__proto__ || Object.getPrototypeOf(TableHead)).apply(this, arguments));
  }

  (0, _createClass2.default)(TableHead, [{
    key: "getChildContext",
    value: function getChildContext() {
      // eslint-disable-line class-methods-use-this
      return {
        table: {
          head: true
        }
      };
    }
  }, {
    key: "render",
    value: function render() {
      var _props = this.props,
          classes = _props.classes,
          className = _props.className,
          Component = _props.component,
          other = (0, _objectWithoutProperties2.default)(_props, ["classes", "className", "component"]);
      return _react.default.createElement(Component, (0, _extends2.default)({
        className: (0, _classnames.default)(classes.root, className)
      }, other));
    }
  }]);
  return TableHead;
}(_react.default.Component);

TableHead.propTypes =  false ? {
  /**
   * The content of the component, normally `TableRow`.
   */
  children: _propTypes.default.node.isRequired,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * The component used for the root node.
   * Either a string to use a DOM element or a component.
   */
  component: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func, _propTypes.default.object])
} : {};
TableHead.defaultProps = {
  component: 'thead'
};
TableHead.childContextTypes = {
  table: _propTypes.default.object
};

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiTableHead'
})(TableHead);

exports.default = _default;

/***/ }),
/* 579 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(2);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _TableRow.default;
  }
});

var _TableRow = _interopRequireDefault(__webpack_require__(580));

/***/ }),
/* 580 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(2);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(6));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(7));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(4));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _classnames = _interopRequireDefault(__webpack_require__(5));

var _withStyles = _interopRequireDefault(__webpack_require__(3));

var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      color: 'inherit',
      display: 'table-row',
      height: 48,
      verticalAlign: 'middle',
      // We disable the focus ring for mouse, touch and keyboard users.
      outline: 'none',
      '&$selected': {
        backgroundColor: theme.palette.type === 'light' ? 'rgba(0, 0, 0, 0.04)' // grey[100]
        : 'rgba(255, 255, 255, 0.08)'
      },
      '&$hover:hover': {
        backgroundColor: theme.palette.type === 'light' ? 'rgba(0, 0, 0, 0.07)' // grey[200]
        : 'rgba(255, 255, 255, 0.14)'
      }
    },

    /* Styles applied to the root element if `context.table` & `selected={true}`. */
    selected: {},

    /* Styles applied to the root element if `context.table` & `hover={true}`. */
    hover: {},

    /* Styles applied to the root element if `context.table.head`. */
    head: {
      height: 56
    },

    /* Styles applied to the root element if `context.table.footer`. */
    footer: {
      height: 56
    }
  };
};
/**
 * Will automatically set dynamic row height
 * based on the material table element parent (head, body, etc).
 */


exports.styles = styles;

function TableRow(props, context) {
  var _classNames;

  var classes = props.classes,
      classNameProp = props.className,
      Component = props.component,
      hover = props.hover,
      selected = props.selected,
      other = (0, _objectWithoutProperties2.default)(props, ["classes", "className", "component", "hover", "selected"]);
  var table = context.table;
  var className = (0, _classnames.default)(classes.root, (_classNames = {}, (0, _defineProperty2.default)(_classNames, classes.head, table && table.head), (0, _defineProperty2.default)(_classNames, classes.footer, table && table.footer), (0, _defineProperty2.default)(_classNames, classes.hover, table && hover), (0, _defineProperty2.default)(_classNames, classes.selected, table && selected), _classNames), classNameProp);
  return _react.default.createElement(Component, (0, _extends2.default)({
    className: className
  }, other));
}

TableRow.propTypes =  false ? {
  /**
   * Should be valid <tr> children such as `TableCell`.
   */
  children: _propTypes.default.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * The component used for the root node.
   * Either a string to use a DOM element or a component.
   */
  component: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func, _propTypes.default.object]),

  /**
   * If `true`, the table row will shade on hover.
   */
  hover: _propTypes.default.bool,

  /**
   * If `true`, the table row will have the selected shading.
   */
  selected: _propTypes.default.bool
} : {};
TableRow.defaultProps = {
  component: 'tr',
  hover: false,
  selected: false
};
TableRow.contextTypes = {
  table: _propTypes.default.object
};

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiTableRow'
})(TableRow);

exports.default = _default;

/***/ }),
/* 581 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__ = __webpack_require__(21);
function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}// ##############################
// // // Table styles
// #############################
var tableStyle=function tableStyle(theme){return{warning:{color:__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["B" /* warningColor */]},primary:{color:__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["r" /* primaryColor */]},danger:{color:__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["g" /* dangerColor */]},success:{color:__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["x" /* successColor */]},info:{color:__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["o" /* infoColor */]},rose:{color:__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["u" /* roseColor */]},gray:{color:__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["l" /* grayColor */]},right:{textAlign:"right"},table:{marginBottom:"0",width:"100%",maxWidth:"100%",backgroundColor:"transparent",borderSpacing:"0",borderCollapse:"collapse",overflow:"auto"},tableShoppingHead:{fontSize:"0.9em !important",textTransform:"uppercase !important"},tableHeadFontSize:{fontSize:"1.25em !important"},tableHeadCell:{color:"rgba(0, 0, 0, 0.87)",border:"none !important"},tableCell:Object.assign({},__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["i" /* defaultFont */],_defineProperty({lineHeight:"1.42857143",padding:"12px 8px!important",verticalAlign:"middle",fontSize:"1em",borderBottom:"none",borderTop:"1px solid #ddd",position:"relative"},theme.breakpoints.down("sm"),{minHeight:"24px",minWidth:"32px"})),tableCellTotal:{fontWeight:"500",fontSize:"1.25em",paddingTop:"14px",textAlign:"right"},tableCellAmount:{fontSize:"26px",fontWeight:"300",marginTop:"5px",textAlign:"right"},tableResponsive:{// width: "100%",
minHeight:"0.1%",overflowX:"auto"},tableStripedRow:{backgroundColor:"#f9f9f9"},tableRowHover:{"&:hover":{backgroundColor:"#f5f5f5"}},warningRow:{backgroundColor:"#fcf8e3","&:hover":{backgroundColor:"#faf2cc"}},dangerRow:{backgroundColor:"#f2dede","&:hover":{backgroundColor:"#ebcccc"}},successRow:{backgroundColor:"#dff0d8","&:hover":{backgroundColor:"#d0e9c6"}},infoRow:{backgroundColor:"#d9edf7","&:hover":{backgroundColor:"#c4e3f3"}}};};/* harmony default export */ __webpack_exports__["a"] = (tableStyle);

/***/ }),
/* 582 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(2);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(6));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(11));

var _createClass2 = _interopRequireDefault(__webpack_require__(12));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(13));

var _inherits2 = _interopRequireDefault(__webpack_require__(14));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(7));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _warning = _interopRequireDefault(__webpack_require__(16));

var _classnames = _interopRequireDefault(__webpack_require__(5));

var _RootRef = _interopRequireDefault(__webpack_require__(263));

var _withStyles = _interopRequireDefault(__webpack_require__(3));

var _helpers = __webpack_require__(37);

var _exactProp = _interopRequireDefault(__webpack_require__(95));

var _Grow = _interopRequireDefault(__webpack_require__(186));

var _Popper = _interopRequireDefault(__webpack_require__(264));

var styles = function styles(theme) {
  return {
    /* Styles applied to the Popper component. */
    popper: {
      zIndex: theme.zIndex.tooltip,
      opacity: 0.9
    },

    /* Styles applied to the tooltip (label wrapper) element. */
    tooltip: {
      backgroundColor: theme.palette.grey[700],
      borderRadius: theme.shape.borderRadius,
      color: theme.palette.common.white,
      fontFamily: theme.typography.fontFamily,
      padding: '4px 8px',
      fontSize: theme.typography.pxToRem(10),
      lineHeight: "".concat(theme.typography.round(14 / 10), "em"),
      maxWidth: 300
    },

    /* Styles applied to the tooltip (label wrapper) element if the tooltip is opened by touch. */
    touch: {
      padding: '8px 16px',
      fontSize: theme.typography.pxToRem(14),
      lineHeight: "".concat(theme.typography.round(16 / 14), "em")
    },

    /* Styles applied to the tooltip (label wrapper) element if `placement` contains "left". */
    tooltipPlacementLeft: (0, _defineProperty2.default)({
      transformOrigin: 'right center',
      margin: '0 24px '
    }, theme.breakpoints.up('sm'), {
      margin: '0 14px'
    }),

    /* Styles applied to the tooltip (label wrapper) element if `placement` contains "right". */
    tooltipPlacementRight: (0, _defineProperty2.default)({
      transformOrigin: 'left center',
      margin: '0 24px'
    }, theme.breakpoints.up('sm'), {
      margin: '0 14px'
    }),

    /* Styles applied to the tooltip (label wrapper) element if `placement` contains "top". */
    tooltipPlacementTop: (0, _defineProperty2.default)({
      transformOrigin: 'center bottom',
      margin: '24px 0'
    }, theme.breakpoints.up('sm'), {
      margin: '14px 0'
    }),

    /* Styles applied to the tooltip (label wrapper) element if `placement` contains "bottom". */
    tooltipPlacementBottom: (0, _defineProperty2.default)({
      transformOrigin: 'center top',
      margin: '24px 0'
    }, theme.breakpoints.up('sm'), {
      margin: '14px 0'
    })
  };
};

exports.styles = styles;

var Tooltip =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(Tooltip, _React$Component);

  function Tooltip(props) {
    var _this;

    (0, _classCallCheck2.default)(this, Tooltip);
    _this = (0, _possibleConstructorReturn2.default)(this, (Tooltip.__proto__ || Object.getPrototypeOf(Tooltip)).call(this, props));
    _this.childrenRef = null;
    _this.closeTimer = null;
    _this.defaultId = null;
    _this.enterTimer = null;
    _this.focusTimer = null;
    _this.ignoreNonTouchEvents = false;
    _this.isControlled = null;
    _this.leaveTimer = null;
    _this.touchTimer = null;
    _this.internalState = {
      hover: false,
      focus: false
    };

    _this.onRootRef = function (ref) {
      _this.childrenRef = ref;
    };

    _this.handleFocus = function (event) {
      event.persist(); // The autoFocus of React might trigger the event before the componentDidMount.
      // We need to account for this eventuality.

      _this.focusTimer = setTimeout(function () {
        _this.handleEnter(event);
      });
    };

    _this.handleEnter = function (event) {
      var _this$props = _this.props,
          children = _this$props.children,
          enterDelay = _this$props.enterDelay;
      var childrenProps = children.props;

      if (event.type === 'focus') {
        _this.internalState.focus = true;

        if (childrenProps.onFocus) {
          childrenProps.onFocus(event);
        }
      }

      if (event.type === 'mouseover') {
        _this.internalState.hover = true;

        if (childrenProps.onMouseOver) {
          childrenProps.onMouseOver(event);
        }
      }

      if (_this.ignoreNonTouchEvents && event.type !== 'touchstart') {
        return;
      } // Remove the title ahead of time.
      // We don't want to wait for the next render commit.
      // We would risk displaying two tooltips at the same time (native + this one).


      _this.childrenRef.setAttribute('title', '');

      clearTimeout(_this.enterTimer);
      clearTimeout(_this.leaveTimer);

      if (enterDelay) {
        event.persist();
        _this.enterTimer = setTimeout(function () {
          _this.handleOpen(event);
        }, enterDelay);
      } else {
        _this.handleOpen(event);
      }
    };

    _this.handleOpen = function (event) {
      // The mouseover event will trigger for every nested element in the tooltip.
      // We can skip rerendering when the tooltip is already open.
      // We are using the mouseover event instead of the mouseenter event to fix a hide/show issue.
      if (!_this.isControlled && !_this.state.open) {
        _this.setState({
          open: true
        });
      }

      if (_this.props.onOpen) {
        _this.props.onOpen(event);
      }
    };

    _this.handleLeave = function (event) {
      var _this$props2 = _this.props,
          children = _this$props2.children,
          leaveDelay = _this$props2.leaveDelay;
      var childrenProps = children.props;

      if (event.type === 'blur') {
        _this.internalState.focus = false;

        if (childrenProps.onBlur) {
          childrenProps.onBlur(event);
        }
      }

      if (event.type === 'mouseleave') {
        _this.internalState.hover = false;

        if (childrenProps.onMouseLeave) {
          childrenProps.onMouseLeave(event);
        }
      }

      clearTimeout(_this.enterTimer);
      clearTimeout(_this.leaveTimer);

      if (leaveDelay) {
        event.persist();
        _this.leaveTimer = setTimeout(function () {
          _this.handleClose(event);
        }, leaveDelay);
      } else {
        _this.handleClose(event);
      }
    };

    _this.handleClose = function (event) {
      if (_this.internalState.focus || _this.internalState.hover) {
        return;
      }

      if (!_this.isControlled) {
        _this.setState({
          open: false
        });
      }

      if (_this.props.onClose) {
        _this.props.onClose(event);
      }

      clearTimeout(_this.closeTimer);
      _this.closeTimer = setTimeout(function () {
        _this.ignoreNonTouchEvents = false;
      }, _this.props.theme.transitions.duration.shortest);
    };

    _this.handleTouchStart = function (event) {
      _this.ignoreNonTouchEvents = true;
      var _this$props3 = _this.props,
          children = _this$props3.children,
          enterTouchDelay = _this$props3.enterTouchDelay;

      if (children.props.onTouchStart) {
        children.props.onTouchStart(event);
      }

      clearTimeout(_this.leaveTimer);
      clearTimeout(_this.closeTimer);
      clearTimeout(_this.touchTimer);
      event.persist();
      _this.touchTimer = setTimeout(function () {
        _this.handleEnter(event);
      }, enterTouchDelay);
    };

    _this.handleTouchEnd = function (event) {
      var _this$props4 = _this.props,
          children = _this$props4.children,
          leaveTouchDelay = _this$props4.leaveTouchDelay;

      if (children.props.onTouchEnd) {
        children.props.onTouchEnd(event);
      }

      clearTimeout(_this.touchTimer);
      clearTimeout(_this.leaveTimer);
      event.persist();
      _this.leaveTimer = setTimeout(function () {
        _this.handleClose(event);
      }, leaveTouchDelay);
    };

    _this.isControlled = props.open != null;
    _this.state = {
      open: null
    };

    if (!_this.isControlled) {
      // not controlled, use internal state
      _this.state.open = false;
    }

    return _this;
  }

  (0, _createClass2.default)(Tooltip, [{
    key: "componentDidMount",
    value: function componentDidMount() {
       false ? (0, _warning.default)(!this.childrenRef.disabled || !this.childrenRef.tagName.toLowerCase() === 'button', ['Material-UI: you are providing a disabled `button` child to the Tooltip component.', 'A disabled element does not fire events.', "Tooltip needs to listen to the child element's events to display the title.", '', 'Place a `div` container on top of the element.'].join('\n')) : void 0; // Fallback to this default id when possible.
      // Use the random value for client side rendering only.
      // We can't use it server side.

      this.defaultId = "mui-tooltip-".concat(Math.round(Math.random() * 1e5)); // Rerender with this.defaultId and this.childrenRef.

      if (this.props.open) {
        this.forceUpdate();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      clearTimeout(this.closeTimer);
      clearTimeout(this.enterTimer);
      clearTimeout(this.focusTimer);
      clearTimeout(this.leaveTimer);
      clearTimeout(this.touchTimer);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          children = _props.children,
          classes = _props.classes,
          disableFocusListener = _props.disableFocusListener,
          disableHoverListener = _props.disableHoverListener,
          disableTouchListener = _props.disableTouchListener,
          id = _props.id,
          openProp = _props.open,
          placement = _props.placement,
          PopperProps = _props.PopperProps,
          theme = _props.theme,
          title = _props.title,
          TransitionComponent = _props.TransitionComponent,
          TransitionProps = _props.TransitionProps;
      var open = this.isControlled ? openProp : this.state.open; // There is no point at displaying an empty tooltip.

      if (title === '') {
        open = false;
      }

      var childrenProps = {
        'aria-describedby': open ? id || this.defaultId : null,
        title: !open && typeof title === 'string' ? title : null
      };

      if (!disableTouchListener) {
        childrenProps.onTouchStart = this.handleTouchStart;
        childrenProps.onTouchEnd = this.handleTouchEnd;
      }

      if (!disableHoverListener) {
        childrenProps.onMouseOver = this.handleEnter;
        childrenProps.onMouseLeave = this.handleLeave;
      }

      if (!disableFocusListener) {
        childrenProps.onFocus = this.handleFocus;
        childrenProps.onBlur = this.handleLeave;
      }

       false ? (0, _warning.default)(!children.props.title, ['Material-UI: you have provided a `title` property to the child of <Tooltip />.', "Remove this title property `".concat(children.props.title, "` or the Tooltip component.")].join('\n')) : void 0;
      return _react.default.createElement(_react.default.Fragment, null, _react.default.createElement(_RootRef.default, {
        rootRef: this.onRootRef
      }, _react.default.cloneElement(children, childrenProps)), _react.default.createElement(_Popper.default, (0, _extends2.default)({
        className: classes.popper,
        placement: placement,
        anchorEl: this.childrenRef,
        open: open,
        id: childrenProps['aria-describedby'],
        transition: true
      }, PopperProps), function (_ref) {
        var placementInner = _ref.placement,
            TransitionPropsInner = _ref.TransitionProps;
        return _react.default.createElement(TransitionComponent, (0, _extends2.default)({
          timeout: theme.transitions.duration.shorter
        }, TransitionPropsInner, TransitionProps), _react.default.createElement("div", {
          className: (0, _classnames.default)(classes.tooltip, (0, _defineProperty2.default)({}, classes.touch, _this2.ignoreNonTouchEvents), classes["tooltipPlacement".concat((0, _helpers.capitalize)(placementInner.split('-')[0]))])
        }, title));
      }));
    }
  }]);
  return Tooltip;
}(_react.default.Component);

Tooltip.propTypes =  false ? {
  /**
   * Tooltip reference element.
   */
  children: _propTypes.default.element.isRequired,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * Do not respond to focus events.
   */
  disableFocusListener: _propTypes.default.bool,

  /**
   * Do not respond to hover events.
   */
  disableHoverListener: _propTypes.default.bool,

  /**
   * Do not respond to long press touch events.
   */
  disableTouchListener: _propTypes.default.bool,

  /**
   * The number of milliseconds to wait before showing the tooltip.
   * This property won't impact the enter touch delay (`enterTouchDelay`).
   */
  enterDelay: _propTypes.default.number,

  /**
   * The number of milliseconds a user must touch the element before showing the tooltip.
   */
  enterTouchDelay: _propTypes.default.number,

  /**
   * The relationship between the tooltip and the wrapper component is not clear from the DOM.
   * This property is used with aria-describedby to solve the accessibility issue.
   * If you don't provide this property. It fallback to a random generated id.
   */
  id: _propTypes.default.string,

  /**
   * The number of milliseconds to wait before hiding the tooltip.
   * This property won't impact the leave touch delay (`leaveTouchDelay`).
   */
  leaveDelay: _propTypes.default.number,

  /**
   * The number of milliseconds after the user stops touching an element before hiding the tooltip.
   */
  leaveTouchDelay: _propTypes.default.number,

  /**
   * Callback fired when the tooltip requests to be closed.
   *
   * @param {object} event The event source of the callback
   */
  onClose: _propTypes.default.func,

  /**
   * Callback fired when the tooltip requests to be open.
   *
   * @param {object} event The event source of the callback
   */
  onOpen: _propTypes.default.func,

  /**
   * If `true`, the tooltip is shown.
   */
  open: _propTypes.default.bool,

  /**
   * Tooltip placement.
   */
  placement: _propTypes.default.oneOf(['bottom-end', 'bottom-start', 'bottom', 'left-end', 'left-start', 'left', 'right-end', 'right-start', 'right', 'top-end', 'top-start', 'top']),

  /**
   * Properties applied to the [`Popper`](/api/popper) element.
   */
  PopperProps: _propTypes.default.object,

  /**
   * @ignore
   */
  theme: _propTypes.default.object.isRequired,

  /**
   * Tooltip title. Zero-length titles string are never displayed.
   */
  title: _propTypes.default.node.isRequired,

  /**
   * Transition component.
   */
  TransitionComponent: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func, _propTypes.default.object]),

  /**
   * Properties applied to the `Transition` element.
   */
  TransitionProps: _propTypes.default.object
} : {};
Tooltip.propTypes =  false ? (0, _exactProp.default)(Tooltip.propTypes) : {};
Tooltip.defaultProps = {
  disableFocusListener: false,
  disableHoverListener: false,
  disableTouchListener: false,
  enterDelay: 0,
  enterTouchDelay: 1000,
  leaveDelay: 0,
  leaveTouchDelay: 1500,
  placement: 'bottom',
  TransitionComponent: _Grow.default
};

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiTooltip',
  withTheme: true
})(Tooltip);

exports.default = _default;

/***/ }),
/* 583 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(2);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(11));

var _createClass2 = _interopRequireDefault(__webpack_require__(12));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(13));

var _inherits2 = _interopRequireDefault(__webpack_require__(14));

var _react = _interopRequireDefault(__webpack_require__(0));

var _reactDom = _interopRequireDefault(__webpack_require__(24));

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _exactProp = _interopRequireDefault(__webpack_require__(95));

function setRef(ref, value) {
  if (typeof ref === 'function') {
    ref(value);
  } else if (ref) {
    ref.current = value;
  }
}
/**
 * Helper component to allow attaching a ref to a
 * wrapped element to access the underlying DOM element.
 *
 * It's highly inspired by https://github.com/facebook/react/issues/11401#issuecomment-340543801.
 * For example:
 * ```jsx
 * import React from 'react';
 * import RootRef from '@material-ui/core/RootRef';
 *
 * class MyComponent extends React.Component {
 *   constructor(props) {
 *     super(props);
 *     this.domRef = React.createRef();
 *   }
 *
 *   componentDidMount() {
 *     console.log(this.domRef.current); // DOM node
 *   }
 *
 *   render() {
 *     return (
 *       <RootRef rootRef={this.domRef}>
 *         <SomeChildComponent />
 *       </RootRef>
 *     );
 *   }
 * }
 * ```
 */


var RootRef =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(RootRef, _React$Component);

  function RootRef() {
    (0, _classCallCheck2.default)(this, RootRef);
    return (0, _possibleConstructorReturn2.default)(this, (RootRef.__proto__ || Object.getPrototypeOf(RootRef)).apply(this, arguments));
  }

  (0, _createClass2.default)(RootRef, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      setRef(this.props.rootRef, _reactDom.default.findDOMNode(this));
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (prevProps.rootRef !== this.props.rootRef) {
        setRef(prevProps.rootRef, null);
        setRef(this.props.rootRef, _reactDom.default.findDOMNode(this));
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      setRef(this.props.rootRef, null);
    }
  }, {
    key: "render",
    value: function render() {
      return this.props.children;
    }
  }]);
  return RootRef;
}(_react.default.Component);

RootRef.propTypes =  false ? {
  /**
   * The wrapped element.
   */
  children: _propTypes.default.element.isRequired,

  /**
   * Provide a way to access the DOM node of the wrapped element.
   * You can provide a callback ref or a `React.createRef()` ref.
   */
  rootRef: _propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.object]).isRequired
} : {};
RootRef.propTypes =  false ? (0, _exactProp.default)(RootRef.propTypes) : {};
var _default = RootRef;
exports.default = _default;

/***/ }),
/* 584 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(2);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(6));

var _objectSpread2 = _interopRequireDefault(__webpack_require__(17));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(4));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(11));

var _createClass2 = _interopRequireDefault(__webpack_require__(12));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(13));

var _inherits2 = _interopRequireDefault(__webpack_require__(14));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _Transition = _interopRequireDefault(__webpack_require__(62));

var _withTheme = _interopRequireDefault(__webpack_require__(71));

var _utils = __webpack_require__(131);

// @inheritedComponent Transition
function getScale(value) {
  return "scale(".concat(value, ", ").concat(Math.pow(value, 2), ")");
}

var styles = {
  entering: {
    opacity: 1,
    transform: getScale(1)
  },
  entered: {
    opacity: 1,
    // Use translateZ to scrolling issue on Chrome.
    transform: "".concat(getScale(1), " translateZ(0)")
  }
};
/**
 * The Grow transition is used by the [Tooltip](/demos/tooltips) and
 * [Popover](/utils/popover) components.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */

var Grow =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(Grow, _React$Component);

  function Grow() {
    var _ref;

    var _temp, _this;

    (0, _classCallCheck2.default)(this, Grow);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return (0, _possibleConstructorReturn2.default)(_this, (_temp = _this = (0, _possibleConstructorReturn2.default)(this, (_ref = Grow.__proto__ || Object.getPrototypeOf(Grow)).call.apply(_ref, [this].concat(args))), _this.autoTimeout = null, _this.timer = null, _this.handleEnter = function (node) {
      var _this$props = _this.props,
          theme = _this$props.theme,
          timeout = _this$props.timeout;
      (0, _utils.reflow)(node); // So the animation always start from the start.

      var _getTransitionProps = (0, _utils.getTransitionProps)(_this.props, {
        mode: 'enter'
      }),
          transitionDuration = _getTransitionProps.duration,
          delay = _getTransitionProps.delay;

      var duration = 0;

      if (timeout === 'auto') {
        duration = theme.transitions.getAutoHeightDuration(node.clientHeight);
        _this.autoTimeout = duration;
      } else {
        duration = transitionDuration;
      }

      node.style.transition = [theme.transitions.create('opacity', {
        duration: duration,
        delay: delay
      }), theme.transitions.create('transform', {
        duration: duration * 0.666,
        delay: delay
      })].join(',');

      if (_this.props.onEnter) {
        _this.props.onEnter(node);
      }
    }, _this.handleExit = function (node) {
      var _this$props2 = _this.props,
          theme = _this$props2.theme,
          timeout = _this$props2.timeout;
      var duration = 0;

      var _getTransitionProps2 = (0, _utils.getTransitionProps)(_this.props, {
        mode: 'exit'
      }),
          transitionDuration = _getTransitionProps2.duration,
          delay = _getTransitionProps2.delay;

      if (timeout === 'auto') {
        duration = theme.transitions.getAutoHeightDuration(node.clientHeight);
        _this.autoTimeout = duration;
      } else {
        duration = transitionDuration;
      }

      node.style.transition = [theme.transitions.create('opacity', {
        duration: duration,
        delay: delay
      }), theme.transitions.create('transform', {
        duration: duration * 0.666,
        delay: delay || duration * 0.333
      })].join(',');
      node.style.opacity = '0';
      node.style.transform = getScale(0.75);

      if (_this.props.onExit) {
        _this.props.onExit(node);
      }
    }, _this.addEndListener = function (_, next) {
      if (_this.props.timeout === 'auto') {
        _this.timer = setTimeout(next, _this.autoTimeout || 0);
      }
    }, _temp));
  }

  (0, _createClass2.default)(Grow, [{
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      clearTimeout(this.timer);
    }
  }, {
    key: "render",
    value: function render() {
      var _props = this.props,
          children = _props.children,
          onEnter = _props.onEnter,
          onExit = _props.onExit,
          styleProp = _props.style,
          theme = _props.theme,
          timeout = _props.timeout,
          other = (0, _objectWithoutProperties2.default)(_props, ["children", "onEnter", "onExit", "style", "theme", "timeout"]);
      var style = (0, _objectSpread2.default)({}, styleProp, _react.default.isValidElement(children) ? children.props.style : {});
      return _react.default.createElement(_Transition.default, (0, _extends2.default)({
        appear: true,
        onEnter: this.handleEnter,
        onExit: this.handleExit,
        addEndListener: this.addEndListener,
        timeout: timeout === 'auto' ? null : timeout
      }, other), function (state, childProps) {
        return _react.default.cloneElement(children, (0, _objectSpread2.default)({
          style: (0, _objectSpread2.default)({
            opacity: 0,
            transform: getScale(0.75)
          }, styles[state], style)
        }, childProps));
      });
    }
  }]);
  return Grow;
}(_react.default.Component);

Grow.propTypes =  false ? {
  /**
   * A single child content element.
   */
  children: _propTypes.default.oneOfType([_propTypes.default.element, _propTypes.default.func]),

  /**
   * If `true`, show the component; triggers the enter or exit animation.
   */
  in: _propTypes.default.bool,

  /**
   * @ignore
   */
  onEnter: _propTypes.default.func,

  /**
   * @ignore
   */
  onExit: _propTypes.default.func,

  /**
   * @ignore
   */
  style: _propTypes.default.object,

  /**
   * @ignore
   */
  theme: _propTypes.default.object.isRequired,

  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   *
   * Set to 'auto' to automatically calculate transition time based on height.
   */
  timeout: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.shape({
    enter: _propTypes.default.number,
    exit: _propTypes.default.number
  }), _propTypes.default.oneOf(['auto'])])
} : {};
Grow.defaultProps = {
  timeout: 'auto'
};
Grow.muiSupportAuto = true;

var _default = (0, _withTheme.default)()(Grow);

exports.default = _default;

/***/ }),
/* 585 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(2);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(6));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(4));

var _objectSpread2 = _interopRequireDefault(__webpack_require__(17));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(11));

var _createClass2 = _interopRequireDefault(__webpack_require__(12));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(13));

var _inherits2 = _interopRequireDefault(__webpack_require__(14));

var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(88));

var _react = _interopRequireDefault(__webpack_require__(0));

var _reactDom = _interopRequireDefault(__webpack_require__(24));

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _popper = _interopRequireDefault(__webpack_require__(586));

var _withTheme = _interopRequireDefault(__webpack_require__(71));

var _Portal = _interopRequireDefault(__webpack_require__(265));

function flipPlacement(theme, placement) {
  if (theme.direction !== 'rtl') {
    return placement;
  }

  switch (placement) {
    case 'bottom-end':
      return 'bottom-start';

    case 'bottom-start':
      return 'bottom-end';

    case 'top-end':
      return 'top-start';

    case 'top-start':
      return 'top-end';

    default:
      return placement;
  }
}

function getAnchorEl(anchorEl) {
  return typeof anchorEl === 'function' ? anchorEl() : anchorEl;
}
/**
 * Poppers rely on the 3rd party library [Popper.js](https://github.com/FezVrasta/popper.js) for positioning.
 */


var Popper =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(Popper, _React$Component);

  function Popper(props) {
    var _this;

    (0, _classCallCheck2.default)(this, Popper);
    _this = (0, _possibleConstructorReturn2.default)(this, (Popper.__proto__ || Object.getPrototypeOf(Popper)).call(this, props));
    _this.popper = null;

    _this.handleOpen = function () {
      var _this$props = _this.props,
          anchorEl = _this$props.anchorEl,
          modifiers = _this$props.modifiers,
          open = _this$props.open,
          placement = _this$props.placement,
          _this$props$popperOpt = _this$props.popperOptions,
          popperOptions = _this$props$popperOpt === void 0 ? {} : _this$props$popperOpt,
          theme = _this$props.theme,
          disablePortal = _this$props.disablePortal;

      var popperNode = _reactDom.default.findDOMNode((0, _assertThisInitialized2.default)(_this));

      if (!popperNode || !anchorEl || !open) {
        return;
      }

      if (_this.popper) {
        _this.popper.destroy();

        _this.popper = null;
      }

      _this.popper = new _popper.default(getAnchorEl(anchorEl), popperNode, (0, _objectSpread2.default)({
        placement: flipPlacement(theme, placement)
      }, popperOptions, {
        modifiers: (0, _objectSpread2.default)({}, disablePortal ? {} : {
          // It's using scrollParent by default, we can use the viewport when using a portal.
          preventOverflow: {
            boundariesElement: 'window'
          }
        }, modifiers, popperOptions.modifiers),
        // We could have been using a custom modifier like react-popper is doing.
        // But it seems this is the best public API for this use case.
        onCreate: _this.handlePopperUpdate,
        onUpdate: _this.handlePopperUpdate
      }));
    };

    _this.handlePopperUpdate = function (data) {
      if (data.placement !== _this.state.placement) {
        _this.setState({
          placement: data.placement
        });
      }
    };

    _this.handleExited = function () {
      _this.setState({
        exited: true
      });

      _this.handleClose();
    };

    _this.handleClose = function () {
      if (!_this.popper) {
        return;
      }

      _this.popper.destroy();

      _this.popper = null;
    };

    _this.state = {
      exited: !_this.props.open
    };
    return _this;
  }

  (0, _createClass2.default)(Popper, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (prevProps.open !== this.props.open && !this.props.open && !this.props.transition) {
        // Otherwise handleExited will call this.
        this.handleClose();
      } // Let's update the popper position.


      if (prevProps.open !== this.props.open || prevProps.anchorEl !== this.props.anchorEl || prevProps.popperOptions !== this.props.popperOptions || prevProps.modifiers !== this.props.modifiers || prevProps.disablePortal !== this.props.disablePortal || prevProps.placement !== this.props.placement) {
        this.handleOpen();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.handleClose();
    }
  }, {
    key: "render",
    value: function render() {
      var _props = this.props,
          anchorEl = _props.anchorEl,
          children = _props.children,
          container = _props.container,
          disablePortal = _props.disablePortal,
          keepMounted = _props.keepMounted,
          modifiers = _props.modifiers,
          open = _props.open,
          placementProps = _props.placement,
          popperOptions = _props.popperOptions,
          theme = _props.theme,
          transition = _props.transition,
          other = (0, _objectWithoutProperties2.default)(_props, ["anchorEl", "children", "container", "disablePortal", "keepMounted", "modifiers", "open", "placement", "popperOptions", "theme", "transition"]);
      var _state = this.state,
          exited = _state.exited,
          placement = _state.placement;

      if (!keepMounted && !open && (!transition || exited)) {
        return null;
      }

      var childProps = {
        placement: placement || flipPlacement(theme, placementProps)
      };

      if (transition) {
        childProps.TransitionProps = {
          in: open,
          onExited: this.handleExited
        };
      }

      return _react.default.createElement(_Portal.default, {
        onRendered: this.handleOpen,
        disablePortal: disablePortal,
        container: container
      }, _react.default.createElement("div", (0, _extends2.default)({
        role: "tooltip",
        style: {
          // Prevents scroll issue, waiting for Popper.js to add this style once initiated.
          position: 'absolute'
        }
      }, other), typeof children === 'function' ? children(childProps) : children));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps) {
      if (nextProps.open) {
        return {
          exited: false
        };
      }

      if (!nextProps.transition) {
        // Otherwise let handleExited take care of marking exited.
        return {
          exited: true
        };
      }

      return null;
    }
  }]);
  return Popper;
}(_react.default.Component);

Popper.propTypes =  false ? {
  /**
   * This is the DOM element, or a function that returns the DOM element,
   * that may be used to set the position of the popover.
   * The return value will passed as the reference object of the Popper
   * instance.
   */
  anchorEl: _propTypes.default.oneOfType([_propTypes.default.object, _propTypes.default.func]),

  /**
   * Popper render function or node.
   */
  children: _propTypes.default.oneOfType([_propTypes.default.node, _propTypes.default.func]).isRequired,

  /**
   * A node, component instance, or function that returns either.
   * The `container` will passed to the Modal component.
   * By default, it uses the body of the anchorEl's top-level document object,
   * so it's simply `document.body` most of the time.
   */
  container: _propTypes.default.oneOfType([_propTypes.default.object, _propTypes.default.func]),

  /**
   * Disable the portal behavior.
   * The children stay within it's parent DOM hierarchy.
   */
  disablePortal: _propTypes.default.bool,

  /**
   * Always keep the children in the DOM.
   * This property can be useful in SEO situation or
   * when you want to maximize the responsiveness of the Popper.
   */
  keepMounted: _propTypes.default.bool,

  /**
   * Popper.js is based on a "plugin-like" architecture,
   * most of its features are fully encapsulated "modifiers".
   *
   * A modifier is a function that is called each time Popper.js needs to
   * compute the position of the popper.
   * For this reason, modifiers should be very performant to avoid bottlenecks.
   * To learn how to create a modifier, [read the modifiers documentation](https://github.com/FezVrasta/popper.js/blob/master/docs/_includes/popper-documentation.md#modifiers--object).
   */
  modifiers: _propTypes.default.object,

  /**
   * If `true`, the popper is visible.
   */
  open: _propTypes.default.bool.isRequired,

  /**
   * Popper placement.
   */
  placement: _propTypes.default.oneOf(['bottom-end', 'bottom-start', 'bottom', 'left-end', 'left-start', 'left', 'right-end', 'right-start', 'right', 'top-end', 'top-start', 'top']),

  /**
   * Options provided to the [`popper.js`](https://github.com/FezVrasta/popper.js) instance.
   */
  popperOptions: _propTypes.default.object,

  /**
   * @ignore
   */
  theme: _propTypes.default.object.isRequired,

  /**
   * Help supporting a react-transition-group/Transition component.
   */
  transition: _propTypes.default.bool
} : {};
Popper.defaultProps = {
  disablePortal: false,
  placement: 'bottom',
  transition: false
};

var _default = (0, _withTheme.default)()(Popper);

exports.default = _default;

/***/ }),
/* 586 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(global) {/**!
 * @fileOverview Kickass library to create and place poppers near their reference elements.
 * @version 1.14.4
 * @license
 * Copyright (c) 2016 Federico Zivolo and contributors
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */
var isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined';

var longerTimeoutBrowsers = ['Edge', 'Trident', 'Firefox'];
var timeoutDuration = 0;
for (var i = 0; i < longerTimeoutBrowsers.length; i += 1) {
  if (isBrowser && navigator.userAgent.indexOf(longerTimeoutBrowsers[i]) >= 0) {
    timeoutDuration = 1;
    break;
  }
}

function microtaskDebounce(fn) {
  var called = false;
  return function () {
    if (called) {
      return;
    }
    called = true;
    window.Promise.resolve().then(function () {
      called = false;
      fn();
    });
  };
}

function taskDebounce(fn) {
  var scheduled = false;
  return function () {
    if (!scheduled) {
      scheduled = true;
      setTimeout(function () {
        scheduled = false;
        fn();
      }, timeoutDuration);
    }
  };
}

var supportsMicroTasks = isBrowser && window.Promise;

/**
* Create a debounced version of a method, that's asynchronously deferred
* but called in the minimum time possible.
*
* @method
* @memberof Popper.Utils
* @argument {Function} fn
* @returns {Function}
*/
var debounce = supportsMicroTasks ? microtaskDebounce : taskDebounce;

/**
 * Check if the given variable is a function
 * @method
 * @memberof Popper.Utils
 * @argument {Any} functionToCheck - variable to check
 * @returns {Boolean} answer to: is a function?
 */
function isFunction(functionToCheck) {
  var getType = {};
  return functionToCheck && getType.toString.call(functionToCheck) === '[object Function]';
}

/**
 * Get CSS computed property of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Eement} element
 * @argument {String} property
 */
function getStyleComputedProperty(element, property) {
  if (element.nodeType !== 1) {
    return [];
  }
  // NOTE: 1 DOM access here
  var css = getComputedStyle(element, null);
  return property ? css[property] : css;
}

/**
 * Returns the parentNode or the host of the element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} parent
 */
function getParentNode(element) {
  if (element.nodeName === 'HTML') {
    return element;
  }
  return element.parentNode || element.host;
}

/**
 * Returns the scrolling parent of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} scroll parent
 */
function getScrollParent(element) {
  // Return body, `getScroll` will take care to get the correct `scrollTop` from it
  if (!element) {
    return document.body;
  }

  switch (element.nodeName) {
    case 'HTML':
    case 'BODY':
      return element.ownerDocument.body;
    case '#document':
      return element.body;
  }

  // Firefox want us to check `-x` and `-y` variations as well

  var _getStyleComputedProp = getStyleComputedProperty(element),
      overflow = _getStyleComputedProp.overflow,
      overflowX = _getStyleComputedProp.overflowX,
      overflowY = _getStyleComputedProp.overflowY;

  if (/(auto|scroll|overlay)/.test(overflow + overflowY + overflowX)) {
    return element;
  }

  return getScrollParent(getParentNode(element));
}

var isIE11 = isBrowser && !!(window.MSInputMethodContext && document.documentMode);
var isIE10 = isBrowser && /MSIE 10/.test(navigator.userAgent);

/**
 * Determines if the browser is Internet Explorer
 * @method
 * @memberof Popper.Utils
 * @param {Number} version to check
 * @returns {Boolean} isIE
 */
function isIE(version) {
  if (version === 11) {
    return isIE11;
  }
  if (version === 10) {
    return isIE10;
  }
  return isIE11 || isIE10;
}

/**
 * Returns the offset parent of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} offset parent
 */
function getOffsetParent(element) {
  if (!element) {
    return document.documentElement;
  }

  var noOffsetParent = isIE(10) ? document.body : null;

  // NOTE: 1 DOM access here
  var offsetParent = element.offsetParent;
  // Skip hidden elements which don't have an offsetParent
  while (offsetParent === noOffsetParent && element.nextElementSibling) {
    offsetParent = (element = element.nextElementSibling).offsetParent;
  }

  var nodeName = offsetParent && offsetParent.nodeName;

  if (!nodeName || nodeName === 'BODY' || nodeName === 'HTML') {
    return element ? element.ownerDocument.documentElement : document.documentElement;
  }

  // .offsetParent will return the closest TD or TABLE in case
  // no offsetParent is present, I hate this job...
  if (['TD', 'TABLE'].indexOf(offsetParent.nodeName) !== -1 && getStyleComputedProperty(offsetParent, 'position') === 'static') {
    return getOffsetParent(offsetParent);
  }

  return offsetParent;
}

function isOffsetContainer(element) {
  var nodeName = element.nodeName;

  if (nodeName === 'BODY') {
    return false;
  }
  return nodeName === 'HTML' || getOffsetParent(element.firstElementChild) === element;
}

/**
 * Finds the root node (document, shadowDOM root) of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} node
 * @returns {Element} root node
 */
function getRoot(node) {
  if (node.parentNode !== null) {
    return getRoot(node.parentNode);
  }

  return node;
}

/**
 * Finds the offset parent common to the two provided nodes
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element1
 * @argument {Element} element2
 * @returns {Element} common offset parent
 */
function findCommonOffsetParent(element1, element2) {
  // This check is needed to avoid errors in case one of the elements isn't defined for any reason
  if (!element1 || !element1.nodeType || !element2 || !element2.nodeType) {
    return document.documentElement;
  }

  // Here we make sure to give as "start" the element that comes first in the DOM
  var order = element1.compareDocumentPosition(element2) & Node.DOCUMENT_POSITION_FOLLOWING;
  var start = order ? element1 : element2;
  var end = order ? element2 : element1;

  // Get common ancestor container
  var range = document.createRange();
  range.setStart(start, 0);
  range.setEnd(end, 0);
  var commonAncestorContainer = range.commonAncestorContainer;

  // Both nodes are inside #document

  if (element1 !== commonAncestorContainer && element2 !== commonAncestorContainer || start.contains(end)) {
    if (isOffsetContainer(commonAncestorContainer)) {
      return commonAncestorContainer;
    }

    return getOffsetParent(commonAncestorContainer);
  }

  // one of the nodes is inside shadowDOM, find which one
  var element1root = getRoot(element1);
  if (element1root.host) {
    return findCommonOffsetParent(element1root.host, element2);
  } else {
    return findCommonOffsetParent(element1, getRoot(element2).host);
  }
}

/**
 * Gets the scroll value of the given element in the given side (top and left)
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @argument {String} side `top` or `left`
 * @returns {number} amount of scrolled pixels
 */
function getScroll(element) {
  var side = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'top';

  var upperSide = side === 'top' ? 'scrollTop' : 'scrollLeft';
  var nodeName = element.nodeName;

  if (nodeName === 'BODY' || nodeName === 'HTML') {
    var html = element.ownerDocument.documentElement;
    var scrollingElement = element.ownerDocument.scrollingElement || html;
    return scrollingElement[upperSide];
  }

  return element[upperSide];
}

/*
 * Sum or subtract the element scroll values (left and top) from a given rect object
 * @method
 * @memberof Popper.Utils
 * @param {Object} rect - Rect object you want to change
 * @param {HTMLElement} element - The element from the function reads the scroll values
 * @param {Boolean} subtract - set to true if you want to subtract the scroll values
 * @return {Object} rect - The modifier rect object
 */
function includeScroll(rect, element) {
  var subtract = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  var scrollTop = getScroll(element, 'top');
  var scrollLeft = getScroll(element, 'left');
  var modifier = subtract ? -1 : 1;
  rect.top += scrollTop * modifier;
  rect.bottom += scrollTop * modifier;
  rect.left += scrollLeft * modifier;
  rect.right += scrollLeft * modifier;
  return rect;
}

/*
 * Helper to detect borders of a given element
 * @method
 * @memberof Popper.Utils
 * @param {CSSStyleDeclaration} styles
 * Result of `getStyleComputedProperty` on the given element
 * @param {String} axis - `x` or `y`
 * @return {number} borders - The borders size of the given axis
 */

function getBordersSize(styles, axis) {
  var sideA = axis === 'x' ? 'Left' : 'Top';
  var sideB = sideA === 'Left' ? 'Right' : 'Bottom';

  return parseFloat(styles['border' + sideA + 'Width'], 10) + parseFloat(styles['border' + sideB + 'Width'], 10);
}

function getSize(axis, body, html, computedStyle) {
  return Math.max(body['offset' + axis], body['scroll' + axis], html['client' + axis], html['offset' + axis], html['scroll' + axis], isIE(10) ? parseInt(html['offset' + axis]) + parseInt(computedStyle['margin' + (axis === 'Height' ? 'Top' : 'Left')]) + parseInt(computedStyle['margin' + (axis === 'Height' ? 'Bottom' : 'Right')]) : 0);
}

function getWindowSizes(document) {
  var body = document.body;
  var html = document.documentElement;
  var computedStyle = isIE(10) && getComputedStyle(html);

  return {
    height: getSize('Height', body, html, computedStyle),
    width: getSize('Width', body, html, computedStyle)
  };
}

var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();





var defineProperty = function (obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

/**
 * Given element offsets, generate an output similar to getBoundingClientRect
 * @method
 * @memberof Popper.Utils
 * @argument {Object} offsets
 * @returns {Object} ClientRect like output
 */
function getClientRect(offsets) {
  return _extends({}, offsets, {
    right: offsets.left + offsets.width,
    bottom: offsets.top + offsets.height
  });
}

/**
 * Get bounding client rect of given element
 * @method
 * @memberof Popper.Utils
 * @param {HTMLElement} element
 * @return {Object} client rect
 */
function getBoundingClientRect(element) {
  var rect = {};

  // IE10 10 FIX: Please, don't ask, the element isn't
  // considered in DOM in some circumstances...
  // This isn't reproducible in IE10 compatibility mode of IE11
  try {
    if (isIE(10)) {
      rect = element.getBoundingClientRect();
      var scrollTop = getScroll(element, 'top');
      var scrollLeft = getScroll(element, 'left');
      rect.top += scrollTop;
      rect.left += scrollLeft;
      rect.bottom += scrollTop;
      rect.right += scrollLeft;
    } else {
      rect = element.getBoundingClientRect();
    }
  } catch (e) {}

  var result = {
    left: rect.left,
    top: rect.top,
    width: rect.right - rect.left,
    height: rect.bottom - rect.top
  };

  // subtract scrollbar size from sizes
  var sizes = element.nodeName === 'HTML' ? getWindowSizes(element.ownerDocument) : {};
  var width = sizes.width || element.clientWidth || result.right - result.left;
  var height = sizes.height || element.clientHeight || result.bottom - result.top;

  var horizScrollbar = element.offsetWidth - width;
  var vertScrollbar = element.offsetHeight - height;

  // if an hypothetical scrollbar is detected, we must be sure it's not a `border`
  // we make this check conditional for performance reasons
  if (horizScrollbar || vertScrollbar) {
    var styles = getStyleComputedProperty(element);
    horizScrollbar -= getBordersSize(styles, 'x');
    vertScrollbar -= getBordersSize(styles, 'y');

    result.width -= horizScrollbar;
    result.height -= vertScrollbar;
  }

  return getClientRect(result);
}

function getOffsetRectRelativeToArbitraryNode(children, parent) {
  var fixedPosition = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  var isIE10 = isIE(10);
  var isHTML = parent.nodeName === 'HTML';
  var childrenRect = getBoundingClientRect(children);
  var parentRect = getBoundingClientRect(parent);
  var scrollParent = getScrollParent(children);

  var styles = getStyleComputedProperty(parent);
  var borderTopWidth = parseFloat(styles.borderTopWidth, 10);
  var borderLeftWidth = parseFloat(styles.borderLeftWidth, 10);

  // In cases where the parent is fixed, we must ignore negative scroll in offset calc
  if (fixedPosition && isHTML) {
    parentRect.top = Math.max(parentRect.top, 0);
    parentRect.left = Math.max(parentRect.left, 0);
  }
  var offsets = getClientRect({
    top: childrenRect.top - parentRect.top - borderTopWidth,
    left: childrenRect.left - parentRect.left - borderLeftWidth,
    width: childrenRect.width,
    height: childrenRect.height
  });
  offsets.marginTop = 0;
  offsets.marginLeft = 0;

  // Subtract margins of documentElement in case it's being used as parent
  // we do this only on HTML because it's the only element that behaves
  // differently when margins are applied to it. The margins are included in
  // the box of the documentElement, in the other cases not.
  if (!isIE10 && isHTML) {
    var marginTop = parseFloat(styles.marginTop, 10);
    var marginLeft = parseFloat(styles.marginLeft, 10);

    offsets.top -= borderTopWidth - marginTop;
    offsets.bottom -= borderTopWidth - marginTop;
    offsets.left -= borderLeftWidth - marginLeft;
    offsets.right -= borderLeftWidth - marginLeft;

    // Attach marginTop and marginLeft because in some circumstances we may need them
    offsets.marginTop = marginTop;
    offsets.marginLeft = marginLeft;
  }

  if (isIE10 && !fixedPosition ? parent.contains(scrollParent) : parent === scrollParent && scrollParent.nodeName !== 'BODY') {
    offsets = includeScroll(offsets, parent);
  }

  return offsets;
}

function getViewportOffsetRectRelativeToArtbitraryNode(element) {
  var excludeScroll = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  var html = element.ownerDocument.documentElement;
  var relativeOffset = getOffsetRectRelativeToArbitraryNode(element, html);
  var width = Math.max(html.clientWidth, window.innerWidth || 0);
  var height = Math.max(html.clientHeight, window.innerHeight || 0);

  var scrollTop = !excludeScroll ? getScroll(html) : 0;
  var scrollLeft = !excludeScroll ? getScroll(html, 'left') : 0;

  var offset = {
    top: scrollTop - relativeOffset.top + relativeOffset.marginTop,
    left: scrollLeft - relativeOffset.left + relativeOffset.marginLeft,
    width: width,
    height: height
  };

  return getClientRect(offset);
}

/**
 * Check if the given element is fixed or is inside a fixed parent
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @argument {Element} customContainer
 * @returns {Boolean} answer to "isFixed?"
 */
function isFixed(element) {
  var nodeName = element.nodeName;
  if (nodeName === 'BODY' || nodeName === 'HTML') {
    return false;
  }
  if (getStyleComputedProperty(element, 'position') === 'fixed') {
    return true;
  }
  return isFixed(getParentNode(element));
}

/**
 * Finds the first parent of an element that has a transformed property defined
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} first transformed parent or documentElement
 */

function getFixedPositionOffsetParent(element) {
  // This check is needed to avoid errors in case one of the elements isn't defined for any reason
  if (!element || !element.parentElement || isIE()) {
    return document.documentElement;
  }
  var el = element.parentElement;
  while (el && getStyleComputedProperty(el, 'transform') === 'none') {
    el = el.parentElement;
  }
  return el || document.documentElement;
}

/**
 * Computed the boundaries limits and return them
 * @method
 * @memberof Popper.Utils
 * @param {HTMLElement} popper
 * @param {HTMLElement} reference
 * @param {number} padding
 * @param {HTMLElement} boundariesElement - Element used to define the boundaries
 * @param {Boolean} fixedPosition - Is in fixed position mode
 * @returns {Object} Coordinates of the boundaries
 */
function getBoundaries(popper, reference, padding, boundariesElement) {
  var fixedPosition = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;

  // NOTE: 1 DOM access here

  var boundaries = { top: 0, left: 0 };
  var offsetParent = fixedPosition ? getFixedPositionOffsetParent(popper) : findCommonOffsetParent(popper, reference);

  // Handle viewport case
  if (boundariesElement === 'viewport') {
    boundaries = getViewportOffsetRectRelativeToArtbitraryNode(offsetParent, fixedPosition);
  } else {
    // Handle other cases based on DOM element used as boundaries
    var boundariesNode = void 0;
    if (boundariesElement === 'scrollParent') {
      boundariesNode = getScrollParent(getParentNode(reference));
      if (boundariesNode.nodeName === 'BODY') {
        boundariesNode = popper.ownerDocument.documentElement;
      }
    } else if (boundariesElement === 'window') {
      boundariesNode = popper.ownerDocument.documentElement;
    } else {
      boundariesNode = boundariesElement;
    }

    var offsets = getOffsetRectRelativeToArbitraryNode(boundariesNode, offsetParent, fixedPosition);

    // In case of HTML, we need a different computation
    if (boundariesNode.nodeName === 'HTML' && !isFixed(offsetParent)) {
      var _getWindowSizes = getWindowSizes(popper.ownerDocument),
          height = _getWindowSizes.height,
          width = _getWindowSizes.width;

      boundaries.top += offsets.top - offsets.marginTop;
      boundaries.bottom = height + offsets.top;
      boundaries.left += offsets.left - offsets.marginLeft;
      boundaries.right = width + offsets.left;
    } else {
      // for all the other DOM elements, this one is good
      boundaries = offsets;
    }
  }

  // Add paddings
  padding = padding || 0;
  var isPaddingNumber = typeof padding === 'number';
  boundaries.left += isPaddingNumber ? padding : padding.left || 0;
  boundaries.top += isPaddingNumber ? padding : padding.top || 0;
  boundaries.right -= isPaddingNumber ? padding : padding.right || 0;
  boundaries.bottom -= isPaddingNumber ? padding : padding.bottom || 0;

  return boundaries;
}

function getArea(_ref) {
  var width = _ref.width,
      height = _ref.height;

  return width * height;
}

/**
 * Utility used to transform the `auto` placement to the placement with more
 * available space.
 * @method
 * @memberof Popper.Utils
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function computeAutoPlacement(placement, refRect, popper, reference, boundariesElement) {
  var padding = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 0;

  if (placement.indexOf('auto') === -1) {
    return placement;
  }

  var boundaries = getBoundaries(popper, reference, padding, boundariesElement);

  var rects = {
    top: {
      width: boundaries.width,
      height: refRect.top - boundaries.top
    },
    right: {
      width: boundaries.right - refRect.right,
      height: boundaries.height
    },
    bottom: {
      width: boundaries.width,
      height: boundaries.bottom - refRect.bottom
    },
    left: {
      width: refRect.left - boundaries.left,
      height: boundaries.height
    }
  };

  var sortedAreas = Object.keys(rects).map(function (key) {
    return _extends({
      key: key
    }, rects[key], {
      area: getArea(rects[key])
    });
  }).sort(function (a, b) {
    return b.area - a.area;
  });

  var filteredAreas = sortedAreas.filter(function (_ref2) {
    var width = _ref2.width,
        height = _ref2.height;
    return width >= popper.clientWidth && height >= popper.clientHeight;
  });

  var computedPlacement = filteredAreas.length > 0 ? filteredAreas[0].key : sortedAreas[0].key;

  var variation = placement.split('-')[1];

  return computedPlacement + (variation ? '-' + variation : '');
}

/**
 * Get offsets to the reference element
 * @method
 * @memberof Popper.Utils
 * @param {Object} state
 * @param {Element} popper - the popper element
 * @param {Element} reference - the reference element (the popper will be relative to this)
 * @param {Element} fixedPosition - is in fixed position mode
 * @returns {Object} An object containing the offsets which will be applied to the popper
 */
function getReferenceOffsets(state, popper, reference) {
  var fixedPosition = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

  var commonOffsetParent = fixedPosition ? getFixedPositionOffsetParent(popper) : findCommonOffsetParent(popper, reference);
  return getOffsetRectRelativeToArbitraryNode(reference, commonOffsetParent, fixedPosition);
}

/**
 * Get the outer sizes of the given element (offset size + margins)
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Object} object containing width and height properties
 */
function getOuterSizes(element) {
  var styles = getComputedStyle(element);
  var x = parseFloat(styles.marginTop) + parseFloat(styles.marginBottom);
  var y = parseFloat(styles.marginLeft) + parseFloat(styles.marginRight);
  var result = {
    width: element.offsetWidth + y,
    height: element.offsetHeight + x
  };
  return result;
}

/**
 * Get the opposite placement of the given one
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement
 * @returns {String} flipped placement
 */
function getOppositePlacement(placement) {
  var hash = { left: 'right', right: 'left', bottom: 'top', top: 'bottom' };
  return placement.replace(/left|right|bottom|top/g, function (matched) {
    return hash[matched];
  });
}

/**
 * Get offsets to the popper
 * @method
 * @memberof Popper.Utils
 * @param {Object} position - CSS position the Popper will get applied
 * @param {HTMLElement} popper - the popper element
 * @param {Object} referenceOffsets - the reference offsets (the popper will be relative to this)
 * @param {String} placement - one of the valid placement options
 * @returns {Object} popperOffsets - An object containing the offsets which will be applied to the popper
 */
function getPopperOffsets(popper, referenceOffsets, placement) {
  placement = placement.split('-')[0];

  // Get popper node sizes
  var popperRect = getOuterSizes(popper);

  // Add position, width and height to our offsets object
  var popperOffsets = {
    width: popperRect.width,
    height: popperRect.height
  };

  // depending by the popper placement we have to compute its offsets slightly differently
  var isHoriz = ['right', 'left'].indexOf(placement) !== -1;
  var mainSide = isHoriz ? 'top' : 'left';
  var secondarySide = isHoriz ? 'left' : 'top';
  var measurement = isHoriz ? 'height' : 'width';
  var secondaryMeasurement = !isHoriz ? 'height' : 'width';

  popperOffsets[mainSide] = referenceOffsets[mainSide] + referenceOffsets[measurement] / 2 - popperRect[measurement] / 2;
  if (placement === secondarySide) {
    popperOffsets[secondarySide] = referenceOffsets[secondarySide] - popperRect[secondaryMeasurement];
  } else {
    popperOffsets[secondarySide] = referenceOffsets[getOppositePlacement(secondarySide)];
  }

  return popperOffsets;
}

/**
 * Mimics the `find` method of Array
 * @method
 * @memberof Popper.Utils
 * @argument {Array} arr
 * @argument prop
 * @argument value
 * @returns index or -1
 */
function find(arr, check) {
  // use native find if supported
  if (Array.prototype.find) {
    return arr.find(check);
  }

  // use `filter` to obtain the same behavior of `find`
  return arr.filter(check)[0];
}

/**
 * Return the index of the matching object
 * @method
 * @memberof Popper.Utils
 * @argument {Array} arr
 * @argument prop
 * @argument value
 * @returns index or -1
 */
function findIndex(arr, prop, value) {
  // use native findIndex if supported
  if (Array.prototype.findIndex) {
    return arr.findIndex(function (cur) {
      return cur[prop] === value;
    });
  }

  // use `find` + `indexOf` if `findIndex` isn't supported
  var match = find(arr, function (obj) {
    return obj[prop] === value;
  });
  return arr.indexOf(match);
}

/**
 * Loop trough the list of modifiers and run them in order,
 * each of them will then edit the data object.
 * @method
 * @memberof Popper.Utils
 * @param {dataObject} data
 * @param {Array} modifiers
 * @param {String} ends - Optional modifier name used as stopper
 * @returns {dataObject}
 */
function runModifiers(modifiers, data, ends) {
  var modifiersToRun = ends === undefined ? modifiers : modifiers.slice(0, findIndex(modifiers, 'name', ends));

  modifiersToRun.forEach(function (modifier) {
    if (modifier['function']) {
      // eslint-disable-line dot-notation
      console.warn('`modifier.function` is deprecated, use `modifier.fn`!');
    }
    var fn = modifier['function'] || modifier.fn; // eslint-disable-line dot-notation
    if (modifier.enabled && isFunction(fn)) {
      // Add properties to offsets to make them a complete clientRect object
      // we do this before each modifier to make sure the previous one doesn't
      // mess with these values
      data.offsets.popper = getClientRect(data.offsets.popper);
      data.offsets.reference = getClientRect(data.offsets.reference);

      data = fn(data, modifier);
    }
  });

  return data;
}

/**
 * Updates the position of the popper, computing the new offsets and applying
 * the new style.<br />
 * Prefer `scheduleUpdate` over `update` because of performance reasons.
 * @method
 * @memberof Popper
 */
function update() {
  // if popper is destroyed, don't perform any further update
  if (this.state.isDestroyed) {
    return;
  }

  var data = {
    instance: this,
    styles: {},
    arrowStyles: {},
    attributes: {},
    flipped: false,
    offsets: {}
  };

  // compute reference element offsets
  data.offsets.reference = getReferenceOffsets(this.state, this.popper, this.reference, this.options.positionFixed);

  // compute auto placement, store placement inside the data object,
  // modifiers will be able to edit `placement` if needed
  // and refer to originalPlacement to know the original value
  data.placement = computeAutoPlacement(this.options.placement, data.offsets.reference, this.popper, this.reference, this.options.modifiers.flip.boundariesElement, this.options.modifiers.flip.padding);

  // store the computed placement inside `originalPlacement`
  data.originalPlacement = data.placement;

  data.positionFixed = this.options.positionFixed;

  // compute the popper offsets
  data.offsets.popper = getPopperOffsets(this.popper, data.offsets.reference, data.placement);

  data.offsets.popper.position = this.options.positionFixed ? 'fixed' : 'absolute';

  // run the modifiers
  data = runModifiers(this.modifiers, data);

  // the first `update` will call `onCreate` callback
  // the other ones will call `onUpdate` callback
  if (!this.state.isCreated) {
    this.state.isCreated = true;
    this.options.onCreate(data);
  } else {
    this.options.onUpdate(data);
  }
}

/**
 * Helper used to know if the given modifier is enabled.
 * @method
 * @memberof Popper.Utils
 * @returns {Boolean}
 */
function isModifierEnabled(modifiers, modifierName) {
  return modifiers.some(function (_ref) {
    var name = _ref.name,
        enabled = _ref.enabled;
    return enabled && name === modifierName;
  });
}

/**
 * Get the prefixed supported property name
 * @method
 * @memberof Popper.Utils
 * @argument {String} property (camelCase)
 * @returns {String} prefixed property (camelCase or PascalCase, depending on the vendor prefix)
 */
function getSupportedPropertyName(property) {
  var prefixes = [false, 'ms', 'Webkit', 'Moz', 'O'];
  var upperProp = property.charAt(0).toUpperCase() + property.slice(1);

  for (var i = 0; i < prefixes.length; i++) {
    var prefix = prefixes[i];
    var toCheck = prefix ? '' + prefix + upperProp : property;
    if (typeof document.body.style[toCheck] !== 'undefined') {
      return toCheck;
    }
  }
  return null;
}

/**
 * Destroys the popper.
 * @method
 * @memberof Popper
 */
function destroy() {
  this.state.isDestroyed = true;

  // touch DOM only if `applyStyle` modifier is enabled
  if (isModifierEnabled(this.modifiers, 'applyStyle')) {
    this.popper.removeAttribute('x-placement');
    this.popper.style.position = '';
    this.popper.style.top = '';
    this.popper.style.left = '';
    this.popper.style.right = '';
    this.popper.style.bottom = '';
    this.popper.style.willChange = '';
    this.popper.style[getSupportedPropertyName('transform')] = '';
  }

  this.disableEventListeners();

  // remove the popper if user explicity asked for the deletion on destroy
  // do not use `remove` because IE11 doesn't support it
  if (this.options.removeOnDestroy) {
    this.popper.parentNode.removeChild(this.popper);
  }
  return this;
}

/**
 * Get the window associated with the element
 * @argument {Element} element
 * @returns {Window}
 */
function getWindow(element) {
  var ownerDocument = element.ownerDocument;
  return ownerDocument ? ownerDocument.defaultView : window;
}

function attachToScrollParents(scrollParent, event, callback, scrollParents) {
  var isBody = scrollParent.nodeName === 'BODY';
  var target = isBody ? scrollParent.ownerDocument.defaultView : scrollParent;
  target.addEventListener(event, callback, { passive: true });

  if (!isBody) {
    attachToScrollParents(getScrollParent(target.parentNode), event, callback, scrollParents);
  }
  scrollParents.push(target);
}

/**
 * Setup needed event listeners used to update the popper position
 * @method
 * @memberof Popper.Utils
 * @private
 */
function setupEventListeners(reference, options, state, updateBound) {
  // Resize event listener on window
  state.updateBound = updateBound;
  getWindow(reference).addEventListener('resize', state.updateBound, { passive: true });

  // Scroll event listener on scroll parents
  var scrollElement = getScrollParent(reference);
  attachToScrollParents(scrollElement, 'scroll', state.updateBound, state.scrollParents);
  state.scrollElement = scrollElement;
  state.eventsEnabled = true;

  return state;
}

/**
 * It will add resize/scroll events and start recalculating
 * position of the popper element when they are triggered.
 * @method
 * @memberof Popper
 */
function enableEventListeners() {
  if (!this.state.eventsEnabled) {
    this.state = setupEventListeners(this.reference, this.options, this.state, this.scheduleUpdate);
  }
}

/**
 * Remove event listeners used to update the popper position
 * @method
 * @memberof Popper.Utils
 * @private
 */
function removeEventListeners(reference, state) {
  // Remove resize event listener on window
  getWindow(reference).removeEventListener('resize', state.updateBound);

  // Remove scroll event listener on scroll parents
  state.scrollParents.forEach(function (target) {
    target.removeEventListener('scroll', state.updateBound);
  });

  // Reset state
  state.updateBound = null;
  state.scrollParents = [];
  state.scrollElement = null;
  state.eventsEnabled = false;
  return state;
}

/**
 * It will remove resize/scroll events and won't recalculate popper position
 * when they are triggered. It also won't trigger `onUpdate` callback anymore,
 * unless you call `update` method manually.
 * @method
 * @memberof Popper
 */
function disableEventListeners() {
  if (this.state.eventsEnabled) {
    cancelAnimationFrame(this.scheduleUpdate);
    this.state = removeEventListeners(this.reference, this.state);
  }
}

/**
 * Tells if a given input is a number
 * @method
 * @memberof Popper.Utils
 * @param {*} input to check
 * @return {Boolean}
 */
function isNumeric(n) {
  return n !== '' && !isNaN(parseFloat(n)) && isFinite(n);
}

/**
 * Set the style to the given popper
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element - Element to apply the style to
 * @argument {Object} styles
 * Object with a list of properties and values which will be applied to the element
 */
function setStyles(element, styles) {
  Object.keys(styles).forEach(function (prop) {
    var unit = '';
    // add unit if the value is numeric and is one of the following
    if (['width', 'height', 'top', 'right', 'bottom', 'left'].indexOf(prop) !== -1 && isNumeric(styles[prop])) {
      unit = 'px';
    }
    element.style[prop] = styles[prop] + unit;
  });
}

/**
 * Set the attributes to the given popper
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element - Element to apply the attributes to
 * @argument {Object} styles
 * Object with a list of properties and values which will be applied to the element
 */
function setAttributes(element, attributes) {
  Object.keys(attributes).forEach(function (prop) {
    var value = attributes[prop];
    if (value !== false) {
      element.setAttribute(prop, attributes[prop]);
    } else {
      element.removeAttribute(prop);
    }
  });
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} data.styles - List of style properties - values to apply to popper element
 * @argument {Object} data.attributes - List of attribute properties - values to apply to popper element
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The same data object
 */
function applyStyle(data) {
  // any property present in `data.styles` will be applied to the popper,
  // in this way we can make the 3rd party modifiers add custom styles to it
  // Be aware, modifiers could override the properties defined in the previous
  // lines of this modifier!
  setStyles(data.instance.popper, data.styles);

  // any property present in `data.attributes` will be applied to the popper,
  // they will be set as HTML attributes of the element
  setAttributes(data.instance.popper, data.attributes);

  // if arrowElement is defined and arrowStyles has some properties
  if (data.arrowElement && Object.keys(data.arrowStyles).length) {
    setStyles(data.arrowElement, data.arrowStyles);
  }

  return data;
}

/**
 * Set the x-placement attribute before everything else because it could be used
 * to add margins to the popper margins needs to be calculated to get the
 * correct popper offsets.
 * @method
 * @memberof Popper.modifiers
 * @param {HTMLElement} reference - The reference element used to position the popper
 * @param {HTMLElement} popper - The HTML element used as popper
 * @param {Object} options - Popper.js options
 */
function applyStyleOnLoad(reference, popper, options, modifierOptions, state) {
  // compute reference element offsets
  var referenceOffsets = getReferenceOffsets(state, popper, reference, options.positionFixed);

  // compute auto placement, store placement inside the data object,
  // modifiers will be able to edit `placement` if needed
  // and refer to originalPlacement to know the original value
  var placement = computeAutoPlacement(options.placement, referenceOffsets, popper, reference, options.modifiers.flip.boundariesElement, options.modifiers.flip.padding);

  popper.setAttribute('x-placement', placement);

  // Apply `position` to popper before anything else because
  // without the position applied we can't guarantee correct computations
  setStyles(popper, { position: options.positionFixed ? 'fixed' : 'absolute' });

  return options;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function computeStyle(data, options) {
  var x = options.x,
      y = options.y;
  var popper = data.offsets.popper;

  // Remove this legacy support in Popper.js v2

  var legacyGpuAccelerationOption = find(data.instance.modifiers, function (modifier) {
    return modifier.name === 'applyStyle';
  }).gpuAcceleration;
  if (legacyGpuAccelerationOption !== undefined) {
    console.warn('WARNING: `gpuAcceleration` option moved to `computeStyle` modifier and will not be supported in future versions of Popper.js!');
  }
  var gpuAcceleration = legacyGpuAccelerationOption !== undefined ? legacyGpuAccelerationOption : options.gpuAcceleration;

  var offsetParent = getOffsetParent(data.instance.popper);
  var offsetParentRect = getBoundingClientRect(offsetParent);

  // Styles
  var styles = {
    position: popper.position
  };

  // Avoid blurry text by using full pixel integers.
  // For pixel-perfect positioning, top/bottom prefers rounded
  // values, while left/right prefers floored values.
  var offsets = {
    left: Math.floor(popper.left),
    top: Math.round(popper.top),
    bottom: Math.round(popper.bottom),
    right: Math.floor(popper.right)
  };

  var sideA = x === 'bottom' ? 'top' : 'bottom';
  var sideB = y === 'right' ? 'left' : 'right';

  // if gpuAcceleration is set to `true` and transform is supported,
  //  we use `translate3d` to apply the position to the popper we
  // automatically use the supported prefixed version if needed
  var prefixedProperty = getSupportedPropertyName('transform');

  // now, let's make a step back and look at this code closely (wtf?)
  // If the content of the popper grows once it's been positioned, it
  // may happen that the popper gets misplaced because of the new content
  // overflowing its reference element
  // To avoid this problem, we provide two options (x and y), which allow
  // the consumer to define the offset origin.
  // If we position a popper on top of a reference element, we can set
  // `x` to `top` to make the popper grow towards its top instead of
  // its bottom.
  var left = void 0,
      top = void 0;
  if (sideA === 'bottom') {
    // when offsetParent is <html> the positioning is relative to the bottom of the screen (excluding the scrollbar)
    // and not the bottom of the html element
    if (offsetParent.nodeName === 'HTML') {
      top = -offsetParent.clientHeight + offsets.bottom;
    } else {
      top = -offsetParentRect.height + offsets.bottom;
    }
  } else {
    top = offsets.top;
  }
  if (sideB === 'right') {
    if (offsetParent.nodeName === 'HTML') {
      left = -offsetParent.clientWidth + offsets.right;
    } else {
      left = -offsetParentRect.width + offsets.right;
    }
  } else {
    left = offsets.left;
  }
  if (gpuAcceleration && prefixedProperty) {
    styles[prefixedProperty] = 'translate3d(' + left + 'px, ' + top + 'px, 0)';
    styles[sideA] = 0;
    styles[sideB] = 0;
    styles.willChange = 'transform';
  } else {
    // othwerise, we use the standard `top`, `left`, `bottom` and `right` properties
    var invertTop = sideA === 'bottom' ? -1 : 1;
    var invertLeft = sideB === 'right' ? -1 : 1;
    styles[sideA] = top * invertTop;
    styles[sideB] = left * invertLeft;
    styles.willChange = sideA + ', ' + sideB;
  }

  // Attributes
  var attributes = {
    'x-placement': data.placement
  };

  // Update `data` attributes, styles and arrowStyles
  data.attributes = _extends({}, attributes, data.attributes);
  data.styles = _extends({}, styles, data.styles);
  data.arrowStyles = _extends({}, data.offsets.arrow, data.arrowStyles);

  return data;
}

/**
 * Helper used to know if the given modifier depends from another one.<br />
 * It checks if the needed modifier is listed and enabled.
 * @method
 * @memberof Popper.Utils
 * @param {Array} modifiers - list of modifiers
 * @param {String} requestingName - name of requesting modifier
 * @param {String} requestedName - name of requested modifier
 * @returns {Boolean}
 */
function isModifierRequired(modifiers, requestingName, requestedName) {
  var requesting = find(modifiers, function (_ref) {
    var name = _ref.name;
    return name === requestingName;
  });

  var isRequired = !!requesting && modifiers.some(function (modifier) {
    return modifier.name === requestedName && modifier.enabled && modifier.order < requesting.order;
  });

  if (!isRequired) {
    var _requesting = '`' + requestingName + '`';
    var requested = '`' + requestedName + '`';
    console.warn(requested + ' modifier is required by ' + _requesting + ' modifier in order to work, be sure to include it before ' + _requesting + '!');
  }
  return isRequired;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function arrow(data, options) {
  var _data$offsets$arrow;

  // arrow depends on keepTogether in order to work
  if (!isModifierRequired(data.instance.modifiers, 'arrow', 'keepTogether')) {
    return data;
  }

  var arrowElement = options.element;

  // if arrowElement is a string, suppose it's a CSS selector
  if (typeof arrowElement === 'string') {
    arrowElement = data.instance.popper.querySelector(arrowElement);

    // if arrowElement is not found, don't run the modifier
    if (!arrowElement) {
      return data;
    }
  } else {
    // if the arrowElement isn't a query selector we must check that the
    // provided DOM node is child of its popper node
    if (!data.instance.popper.contains(arrowElement)) {
      console.warn('WARNING: `arrow.element` must be child of its popper element!');
      return data;
    }
  }

  var placement = data.placement.split('-')[0];
  var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var isVertical = ['left', 'right'].indexOf(placement) !== -1;

  var len = isVertical ? 'height' : 'width';
  var sideCapitalized = isVertical ? 'Top' : 'Left';
  var side = sideCapitalized.toLowerCase();
  var altSide = isVertical ? 'left' : 'top';
  var opSide = isVertical ? 'bottom' : 'right';
  var arrowElementSize = getOuterSizes(arrowElement)[len];

  //
  // extends keepTogether behavior making sure the popper and its
  // reference have enough pixels in conjunction
  //

  // top/left side
  if (reference[opSide] - arrowElementSize < popper[side]) {
    data.offsets.popper[side] -= popper[side] - (reference[opSide] - arrowElementSize);
  }
  // bottom/right side
  if (reference[side] + arrowElementSize > popper[opSide]) {
    data.offsets.popper[side] += reference[side] + arrowElementSize - popper[opSide];
  }
  data.offsets.popper = getClientRect(data.offsets.popper);

  // compute center of the popper
  var center = reference[side] + reference[len] / 2 - arrowElementSize / 2;

  // Compute the sideValue using the updated popper offsets
  // take popper margin in account because we don't have this info available
  var css = getStyleComputedProperty(data.instance.popper);
  var popperMarginSide = parseFloat(css['margin' + sideCapitalized], 10);
  var popperBorderSide = parseFloat(css['border' + sideCapitalized + 'Width'], 10);
  var sideValue = center - data.offsets.popper[side] - popperMarginSide - popperBorderSide;

  // prevent arrowElement from being placed not contiguously to its popper
  sideValue = Math.max(Math.min(popper[len] - arrowElementSize, sideValue), 0);

  data.arrowElement = arrowElement;
  data.offsets.arrow = (_data$offsets$arrow = {}, defineProperty(_data$offsets$arrow, side, Math.round(sideValue)), defineProperty(_data$offsets$arrow, altSide, ''), _data$offsets$arrow);

  return data;
}

/**
 * Get the opposite placement variation of the given one
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement variation
 * @returns {String} flipped placement variation
 */
function getOppositeVariation(variation) {
  if (variation === 'end') {
    return 'start';
  } else if (variation === 'start') {
    return 'end';
  }
  return variation;
}

/**
 * List of accepted placements to use as values of the `placement` option.<br />
 * Valid placements are:
 * - `auto`
 * - `top`
 * - `right`
 * - `bottom`
 * - `left`
 *
 * Each placement can have a variation from this list:
 * - `-start`
 * - `-end`
 *
 * Variations are interpreted easily if you think of them as the left to right
 * written languages. Horizontally (`top` and `bottom`), `start` is left and `end`
 * is right.<br />
 * Vertically (`left` and `right`), `start` is top and `end` is bottom.
 *
 * Some valid examples are:
 * - `top-end` (on top of reference, right aligned)
 * - `right-start` (on right of reference, top aligned)
 * - `bottom` (on bottom, centered)
 * - `auto-end` (on the side with more space available, alignment depends by placement)
 *
 * @static
 * @type {Array}
 * @enum {String}
 * @readonly
 * @method placements
 * @memberof Popper
 */
var placements = ['auto-start', 'auto', 'auto-end', 'top-start', 'top', 'top-end', 'right-start', 'right', 'right-end', 'bottom-end', 'bottom', 'bottom-start', 'left-end', 'left', 'left-start'];

// Get rid of `auto` `auto-start` and `auto-end`
var validPlacements = placements.slice(3);

/**
 * Given an initial placement, returns all the subsequent placements
 * clockwise (or counter-clockwise).
 *
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement - A valid placement (it accepts variations)
 * @argument {Boolean} counter - Set to true to walk the placements counterclockwise
 * @returns {Array} placements including their variations
 */
function clockwise(placement) {
  var counter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  var index = validPlacements.indexOf(placement);
  var arr = validPlacements.slice(index + 1).concat(validPlacements.slice(0, index));
  return counter ? arr.reverse() : arr;
}

var BEHAVIORS = {
  FLIP: 'flip',
  CLOCKWISE: 'clockwise',
  COUNTERCLOCKWISE: 'counterclockwise'
};

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function flip(data, options) {
  // if `inner` modifier is enabled, we can't use the `flip` modifier
  if (isModifierEnabled(data.instance.modifiers, 'inner')) {
    return data;
  }

  if (data.flipped && data.placement === data.originalPlacement) {
    // seems like flip is trying to loop, probably there's not enough space on any of the flippable sides
    return data;
  }

  var boundaries = getBoundaries(data.instance.popper, data.instance.reference, options.padding, options.boundariesElement, data.positionFixed);

  var placement = data.placement.split('-')[0];
  var placementOpposite = getOppositePlacement(placement);
  var variation = data.placement.split('-')[1] || '';

  var flipOrder = [];

  switch (options.behavior) {
    case BEHAVIORS.FLIP:
      flipOrder = [placement, placementOpposite];
      break;
    case BEHAVIORS.CLOCKWISE:
      flipOrder = clockwise(placement);
      break;
    case BEHAVIORS.COUNTERCLOCKWISE:
      flipOrder = clockwise(placement, true);
      break;
    default:
      flipOrder = options.behavior;
  }

  flipOrder.forEach(function (step, index) {
    if (placement !== step || flipOrder.length === index + 1) {
      return data;
    }

    placement = data.placement.split('-')[0];
    placementOpposite = getOppositePlacement(placement);

    var popperOffsets = data.offsets.popper;
    var refOffsets = data.offsets.reference;

    // using floor because the reference offsets may contain decimals we are not going to consider here
    var floor = Math.floor;
    var overlapsRef = placement === 'left' && floor(popperOffsets.right) > floor(refOffsets.left) || placement === 'right' && floor(popperOffsets.left) < floor(refOffsets.right) || placement === 'top' && floor(popperOffsets.bottom) > floor(refOffsets.top) || placement === 'bottom' && floor(popperOffsets.top) < floor(refOffsets.bottom);

    var overflowsLeft = floor(popperOffsets.left) < floor(boundaries.left);
    var overflowsRight = floor(popperOffsets.right) > floor(boundaries.right);
    var overflowsTop = floor(popperOffsets.top) < floor(boundaries.top);
    var overflowsBottom = floor(popperOffsets.bottom) > floor(boundaries.bottom);

    var overflowsBoundaries = placement === 'left' && overflowsLeft || placement === 'right' && overflowsRight || placement === 'top' && overflowsTop || placement === 'bottom' && overflowsBottom;

    // flip the variation if required
    var isVertical = ['top', 'bottom'].indexOf(placement) !== -1;
    var flippedVariation = !!options.flipVariations && (isVertical && variation === 'start' && overflowsLeft || isVertical && variation === 'end' && overflowsRight || !isVertical && variation === 'start' && overflowsTop || !isVertical && variation === 'end' && overflowsBottom);

    if (overlapsRef || overflowsBoundaries || flippedVariation) {
      // this boolean to detect any flip loop
      data.flipped = true;

      if (overlapsRef || overflowsBoundaries) {
        placement = flipOrder[index + 1];
      }

      if (flippedVariation) {
        variation = getOppositeVariation(variation);
      }

      data.placement = placement + (variation ? '-' + variation : '');

      // this object contains `position`, we want to preserve it along with
      // any additional property we may add in the future
      data.offsets.popper = _extends({}, data.offsets.popper, getPopperOffsets(data.instance.popper, data.offsets.reference, data.placement));

      data = runModifiers(data.instance.modifiers, data, 'flip');
    }
  });
  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function keepTogether(data) {
  var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var placement = data.placement.split('-')[0];
  var floor = Math.floor;
  var isVertical = ['top', 'bottom'].indexOf(placement) !== -1;
  var side = isVertical ? 'right' : 'bottom';
  var opSide = isVertical ? 'left' : 'top';
  var measurement = isVertical ? 'width' : 'height';

  if (popper[side] < floor(reference[opSide])) {
    data.offsets.popper[opSide] = floor(reference[opSide]) - popper[measurement];
  }
  if (popper[opSide] > floor(reference[side])) {
    data.offsets.popper[opSide] = floor(reference[side]);
  }

  return data;
}

/**
 * Converts a string containing value + unit into a px value number
 * @function
 * @memberof {modifiers~offset}
 * @private
 * @argument {String} str - Value + unit string
 * @argument {String} measurement - `height` or `width`
 * @argument {Object} popperOffsets
 * @argument {Object} referenceOffsets
 * @returns {Number|String}
 * Value in pixels, or original string if no values were extracted
 */
function toValue(str, measurement, popperOffsets, referenceOffsets) {
  // separate value from unit
  var split = str.match(/((?:\-|\+)?\d*\.?\d*)(.*)/);
  var value = +split[1];
  var unit = split[2];

  // If it's not a number it's an operator, I guess
  if (!value) {
    return str;
  }

  if (unit.indexOf('%') === 0) {
    var element = void 0;
    switch (unit) {
      case '%p':
        element = popperOffsets;
        break;
      case '%':
      case '%r':
      default:
        element = referenceOffsets;
    }

    var rect = getClientRect(element);
    return rect[measurement] / 100 * value;
  } else if (unit === 'vh' || unit === 'vw') {
    // if is a vh or vw, we calculate the size based on the viewport
    var size = void 0;
    if (unit === 'vh') {
      size = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
    } else {
      size = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
    }
    return size / 100 * value;
  } else {
    // if is an explicit pixel unit, we get rid of the unit and keep the value
    // if is an implicit unit, it's px, and we return just the value
    return value;
  }
}

/**
 * Parse an `offset` string to extrapolate `x` and `y` numeric offsets.
 * @function
 * @memberof {modifiers~offset}
 * @private
 * @argument {String} offset
 * @argument {Object} popperOffsets
 * @argument {Object} referenceOffsets
 * @argument {String} basePlacement
 * @returns {Array} a two cells array with x and y offsets in numbers
 */
function parseOffset(offset, popperOffsets, referenceOffsets, basePlacement) {
  var offsets = [0, 0];

  // Use height if placement is left or right and index is 0 otherwise use width
  // in this way the first offset will use an axis and the second one
  // will use the other one
  var useHeight = ['right', 'left'].indexOf(basePlacement) !== -1;

  // Split the offset string to obtain a list of values and operands
  // The regex addresses values with the plus or minus sign in front (+10, -20, etc)
  var fragments = offset.split(/(\+|\-)/).map(function (frag) {
    return frag.trim();
  });

  // Detect if the offset string contains a pair of values or a single one
  // they could be separated by comma or space
  var divider = fragments.indexOf(find(fragments, function (frag) {
    return frag.search(/,|\s/) !== -1;
  }));

  if (fragments[divider] && fragments[divider].indexOf(',') === -1) {
    console.warn('Offsets separated by white space(s) are deprecated, use a comma (,) instead.');
  }

  // If divider is found, we divide the list of values and operands to divide
  // them by ofset X and Y.
  var splitRegex = /\s*,\s*|\s+/;
  var ops = divider !== -1 ? [fragments.slice(0, divider).concat([fragments[divider].split(splitRegex)[0]]), [fragments[divider].split(splitRegex)[1]].concat(fragments.slice(divider + 1))] : [fragments];

  // Convert the values with units to absolute pixels to allow our computations
  ops = ops.map(function (op, index) {
    // Most of the units rely on the orientation of the popper
    var measurement = (index === 1 ? !useHeight : useHeight) ? 'height' : 'width';
    var mergeWithPrevious = false;
    return op
    // This aggregates any `+` or `-` sign that aren't considered operators
    // e.g.: 10 + +5 => [10, +, +5]
    .reduce(function (a, b) {
      if (a[a.length - 1] === '' && ['+', '-'].indexOf(b) !== -1) {
        a[a.length - 1] = b;
        mergeWithPrevious = true;
        return a;
      } else if (mergeWithPrevious) {
        a[a.length - 1] += b;
        mergeWithPrevious = false;
        return a;
      } else {
        return a.concat(b);
      }
    }, [])
    // Here we convert the string values into number values (in px)
    .map(function (str) {
      return toValue(str, measurement, popperOffsets, referenceOffsets);
    });
  });

  // Loop trough the offsets arrays and execute the operations
  ops.forEach(function (op, index) {
    op.forEach(function (frag, index2) {
      if (isNumeric(frag)) {
        offsets[index] += frag * (op[index2 - 1] === '-' ? -1 : 1);
      }
    });
  });
  return offsets;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @argument {Number|String} options.offset=0
 * The offset value as described in the modifier description
 * @returns {Object} The data object, properly modified
 */
function offset(data, _ref) {
  var offset = _ref.offset;
  var placement = data.placement,
      _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var basePlacement = placement.split('-')[0];

  var offsets = void 0;
  if (isNumeric(+offset)) {
    offsets = [+offset, 0];
  } else {
    offsets = parseOffset(offset, popper, reference, basePlacement);
  }

  if (basePlacement === 'left') {
    popper.top += offsets[0];
    popper.left -= offsets[1];
  } else if (basePlacement === 'right') {
    popper.top += offsets[0];
    popper.left += offsets[1];
  } else if (basePlacement === 'top') {
    popper.left += offsets[0];
    popper.top -= offsets[1];
  } else if (basePlacement === 'bottom') {
    popper.left += offsets[0];
    popper.top += offsets[1];
  }

  data.popper = popper;
  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function preventOverflow(data, options) {
  var boundariesElement = options.boundariesElement || getOffsetParent(data.instance.popper);

  // If offsetParent is the reference element, we really want to
  // go one step up and use the next offsetParent as reference to
  // avoid to make this modifier completely useless and look like broken
  if (data.instance.reference === boundariesElement) {
    boundariesElement = getOffsetParent(boundariesElement);
  }

  // NOTE: DOM access here
  // resets the popper's position so that the document size can be calculated excluding
  // the size of the popper element itself
  var transformProp = getSupportedPropertyName('transform');
  var popperStyles = data.instance.popper.style; // assignment to help minification
  var top = popperStyles.top,
      left = popperStyles.left,
      transform = popperStyles[transformProp];

  popperStyles.top = '';
  popperStyles.left = '';
  popperStyles[transformProp] = '';

  var boundaries = getBoundaries(data.instance.popper, data.instance.reference, options.padding, boundariesElement, data.positionFixed);

  // NOTE: DOM access here
  // restores the original style properties after the offsets have been computed
  popperStyles.top = top;
  popperStyles.left = left;
  popperStyles[transformProp] = transform;

  options.boundaries = boundaries;

  var order = options.priority;
  var popper = data.offsets.popper;

  var check = {
    primary: function primary(placement) {
      var value = popper[placement];
      if (popper[placement] < boundaries[placement] && !options.escapeWithReference) {
        value = Math.max(popper[placement], boundaries[placement]);
      }
      return defineProperty({}, placement, value);
    },
    secondary: function secondary(placement) {
      var mainSide = placement === 'right' ? 'left' : 'top';
      var value = popper[mainSide];
      if (popper[placement] > boundaries[placement] && !options.escapeWithReference) {
        value = Math.min(popper[mainSide], boundaries[placement] - (placement === 'right' ? popper.width : popper.height));
      }
      return defineProperty({}, mainSide, value);
    }
  };

  order.forEach(function (placement) {
    var side = ['left', 'top'].indexOf(placement) !== -1 ? 'primary' : 'secondary';
    popper = _extends({}, popper, check[side](placement));
  });

  data.offsets.popper = popper;

  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function shift(data) {
  var placement = data.placement;
  var basePlacement = placement.split('-')[0];
  var shiftvariation = placement.split('-')[1];

  // if shift shiftvariation is specified, run the modifier
  if (shiftvariation) {
    var _data$offsets = data.offsets,
        reference = _data$offsets.reference,
        popper = _data$offsets.popper;

    var isVertical = ['bottom', 'top'].indexOf(basePlacement) !== -1;
    var side = isVertical ? 'left' : 'top';
    var measurement = isVertical ? 'width' : 'height';

    var shiftOffsets = {
      start: defineProperty({}, side, reference[side]),
      end: defineProperty({}, side, reference[side] + reference[measurement] - popper[measurement])
    };

    data.offsets.popper = _extends({}, popper, shiftOffsets[shiftvariation]);
  }

  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function hide(data) {
  if (!isModifierRequired(data.instance.modifiers, 'hide', 'preventOverflow')) {
    return data;
  }

  var refRect = data.offsets.reference;
  var bound = find(data.instance.modifiers, function (modifier) {
    return modifier.name === 'preventOverflow';
  }).boundaries;

  if (refRect.bottom < bound.top || refRect.left > bound.right || refRect.top > bound.bottom || refRect.right < bound.left) {
    // Avoid unnecessary DOM access if visibility hasn't changed
    if (data.hide === true) {
      return data;
    }

    data.hide = true;
    data.attributes['x-out-of-boundaries'] = '';
  } else {
    // Avoid unnecessary DOM access if visibility hasn't changed
    if (data.hide === false) {
      return data;
    }

    data.hide = false;
    data.attributes['x-out-of-boundaries'] = false;
  }

  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function inner(data) {
  var placement = data.placement;
  var basePlacement = placement.split('-')[0];
  var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var isHoriz = ['left', 'right'].indexOf(basePlacement) !== -1;

  var subtractLength = ['top', 'left'].indexOf(basePlacement) === -1;

  popper[isHoriz ? 'left' : 'top'] = reference[basePlacement] - (subtractLength ? popper[isHoriz ? 'width' : 'height'] : 0);

  data.placement = getOppositePlacement(placement);
  data.offsets.popper = getClientRect(popper);

  return data;
}

/**
 * Modifier function, each modifier can have a function of this type assigned
 * to its `fn` property.<br />
 * These functions will be called on each update, this means that you must
 * make sure they are performant enough to avoid performance bottlenecks.
 *
 * @function ModifierFn
 * @argument {dataObject} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {dataObject} The data object, properly modified
 */

/**
 * Modifiers are plugins used to alter the behavior of your poppers.<br />
 * Popper.js uses a set of 9 modifiers to provide all the basic functionalities
 * needed by the library.
 *
 * Usually you don't want to override the `order`, `fn` and `onLoad` props.
 * All the other properties are configurations that could be tweaked.
 * @namespace modifiers
 */
var modifiers = {
  /**
   * Modifier used to shift the popper on the start or end of its reference
   * element.<br />
   * It will read the variation of the `placement` property.<br />
   * It can be one either `-end` or `-start`.
   * @memberof modifiers
   * @inner
   */
  shift: {
    /** @prop {number} order=100 - Index used to define the order of execution */
    order: 100,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: shift
  },

  /**
   * The `offset` modifier can shift your popper on both its axis.
   *
   * It accepts the following units:
   * - `px` or unit-less, interpreted as pixels
   * - `%` or `%r`, percentage relative to the length of the reference element
   * - `%p`, percentage relative to the length of the popper element
   * - `vw`, CSS viewport width unit
   * - `vh`, CSS viewport height unit
   *
   * For length is intended the main axis relative to the placement of the popper.<br />
   * This means that if the placement is `top` or `bottom`, the length will be the
   * `width`. In case of `left` or `right`, it will be the `height`.
   *
   * You can provide a single value (as `Number` or `String`), or a pair of values
   * as `String` divided by a comma or one (or more) white spaces.<br />
   * The latter is a deprecated method because it leads to confusion and will be
   * removed in v2.<br />
   * Additionally, it accepts additions and subtractions between different units.
   * Note that multiplications and divisions aren't supported.
   *
   * Valid examples are:
   * ```
   * 10
   * '10%'
   * '10, 10'
   * '10%, 10'
   * '10 + 10%'
   * '10 - 5vh + 3%'
   * '-10px + 5vh, 5px - 6%'
   * ```
   * > **NB**: If you desire to apply offsets to your poppers in a way that may make them overlap
   * > with their reference element, unfortunately, you will have to disable the `flip` modifier.
   * > You can read more on this at this [issue](https://github.com/FezVrasta/popper.js/issues/373).
   *
   * @memberof modifiers
   * @inner
   */
  offset: {
    /** @prop {number} order=200 - Index used to define the order of execution */
    order: 200,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: offset,
    /** @prop {Number|String} offset=0
     * The offset value as described in the modifier description
     */
    offset: 0
  },

  /**
   * Modifier used to prevent the popper from being positioned outside the boundary.
   *
   * A scenario exists where the reference itself is not within the boundaries.<br />
   * We can say it has "escaped the boundaries" — or just "escaped".<br />
   * In this case we need to decide whether the popper should either:
   *
   * - detach from the reference and remain "trapped" in the boundaries, or
   * - if it should ignore the boundary and "escape with its reference"
   *
   * When `escapeWithReference` is set to`true` and reference is completely
   * outside its boundaries, the popper will overflow (or completely leave)
   * the boundaries in order to remain attached to the edge of the reference.
   *
   * @memberof modifiers
   * @inner
   */
  preventOverflow: {
    /** @prop {number} order=300 - Index used to define the order of execution */
    order: 300,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: preventOverflow,
    /**
     * @prop {Array} [priority=['left','right','top','bottom']]
     * Popper will try to prevent overflow following these priorities by default,
     * then, it could overflow on the left and on top of the `boundariesElement`
     */
    priority: ['left', 'right', 'top', 'bottom'],
    /**
     * @prop {number} padding=5
     * Amount of pixel used to define a minimum distance between the boundaries
     * and the popper. This makes sure the popper always has a little padding
     * between the edges of its container
     */
    padding: 5,
    /**
     * @prop {String|HTMLElement} boundariesElement='scrollParent'
     * Boundaries used by the modifier. Can be `scrollParent`, `window`,
     * `viewport` or any DOM element.
     */
    boundariesElement: 'scrollParent'
  },

  /**
   * Modifier used to make sure the reference and its popper stay near each other
   * without leaving any gap between the two. Especially useful when the arrow is
   * enabled and you want to ensure that it points to its reference element.
   * It cares only about the first axis. You can still have poppers with margin
   * between the popper and its reference element.
   * @memberof modifiers
   * @inner
   */
  keepTogether: {
    /** @prop {number} order=400 - Index used to define the order of execution */
    order: 400,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: keepTogether
  },

  /**
   * This modifier is used to move the `arrowElement` of the popper to make
   * sure it is positioned between the reference element and its popper element.
   * It will read the outer size of the `arrowElement` node to detect how many
   * pixels of conjunction are needed.
   *
   * It has no effect if no `arrowElement` is provided.
   * @memberof modifiers
   * @inner
   */
  arrow: {
    /** @prop {number} order=500 - Index used to define the order of execution */
    order: 500,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: arrow,
    /** @prop {String|HTMLElement} element='[x-arrow]' - Selector or node used as arrow */
    element: '[x-arrow]'
  },

  /**
   * Modifier used to flip the popper's placement when it starts to overlap its
   * reference element.
   *
   * Requires the `preventOverflow` modifier before it in order to work.
   *
   * **NOTE:** this modifier will interrupt the current update cycle and will
   * restart it if it detects the need to flip the placement.
   * @memberof modifiers
   * @inner
   */
  flip: {
    /** @prop {number} order=600 - Index used to define the order of execution */
    order: 600,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: flip,
    /**
     * @prop {String|Array} behavior='flip'
     * The behavior used to change the popper's placement. It can be one of
     * `flip`, `clockwise`, `counterclockwise` or an array with a list of valid
     * placements (with optional variations)
     */
    behavior: 'flip',
    /**
     * @prop {number} padding=5
     * The popper will flip if it hits the edges of the `boundariesElement`
     */
    padding: 5,
    /**
     * @prop {String|HTMLElement} boundariesElement='viewport'
     * The element which will define the boundaries of the popper position.
     * The popper will never be placed outside of the defined boundaries
     * (except if `keepTogether` is enabled)
     */
    boundariesElement: 'viewport'
  },

  /**
   * Modifier used to make the popper flow toward the inner of the reference element.
   * By default, when this modifier is disabled, the popper will be placed outside
   * the reference element.
   * @memberof modifiers
   * @inner
   */
  inner: {
    /** @prop {number} order=700 - Index used to define the order of execution */
    order: 700,
    /** @prop {Boolean} enabled=false - Whether the modifier is enabled or not */
    enabled: false,
    /** @prop {ModifierFn} */
    fn: inner
  },

  /**
   * Modifier used to hide the popper when its reference element is outside of the
   * popper boundaries. It will set a `x-out-of-boundaries` attribute which can
   * be used to hide with a CSS selector the popper when its reference is
   * out of boundaries.
   *
   * Requires the `preventOverflow` modifier before it in order to work.
   * @memberof modifiers
   * @inner
   */
  hide: {
    /** @prop {number} order=800 - Index used to define the order of execution */
    order: 800,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: hide
  },

  /**
   * Computes the style that will be applied to the popper element to gets
   * properly positioned.
   *
   * Note that this modifier will not touch the DOM, it just prepares the styles
   * so that `applyStyle` modifier can apply it. This separation is useful
   * in case you need to replace `applyStyle` with a custom implementation.
   *
   * This modifier has `850` as `order` value to maintain backward compatibility
   * with previous versions of Popper.js. Expect the modifiers ordering method
   * to change in future major versions of the library.
   *
   * @memberof modifiers
   * @inner
   */
  computeStyle: {
    /** @prop {number} order=850 - Index used to define the order of execution */
    order: 850,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: computeStyle,
    /**
     * @prop {Boolean} gpuAcceleration=true
     * If true, it uses the CSS 3D transformation to position the popper.
     * Otherwise, it will use the `top` and `left` properties
     */
    gpuAcceleration: true,
    /**
     * @prop {string} [x='bottom']
     * Where to anchor the X axis (`bottom` or `top`). AKA X offset origin.
     * Change this if your popper should grow in a direction different from `bottom`
     */
    x: 'bottom',
    /**
     * @prop {string} [x='left']
     * Where to anchor the Y axis (`left` or `right`). AKA Y offset origin.
     * Change this if your popper should grow in a direction different from `right`
     */
    y: 'right'
  },

  /**
   * Applies the computed styles to the popper element.
   *
   * All the DOM manipulations are limited to this modifier. This is useful in case
   * you want to integrate Popper.js inside a framework or view library and you
   * want to delegate all the DOM manipulations to it.
   *
   * Note that if you disable this modifier, you must make sure the popper element
   * has its position set to `absolute` before Popper.js can do its work!
   *
   * Just disable this modifier and define your own to achieve the desired effect.
   *
   * @memberof modifiers
   * @inner
   */
  applyStyle: {
    /** @prop {number} order=900 - Index used to define the order of execution */
    order: 900,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: applyStyle,
    /** @prop {Function} */
    onLoad: applyStyleOnLoad,
    /**
     * @deprecated since version 1.10.0, the property moved to `computeStyle` modifier
     * @prop {Boolean} gpuAcceleration=true
     * If true, it uses the CSS 3D transformation to position the popper.
     * Otherwise, it will use the `top` and `left` properties
     */
    gpuAcceleration: undefined
  }
};

/**
 * The `dataObject` is an object containing all the information used by Popper.js.
 * This object is passed to modifiers and to the `onCreate` and `onUpdate` callbacks.
 * @name dataObject
 * @property {Object} data.instance The Popper.js instance
 * @property {String} data.placement Placement applied to popper
 * @property {String} data.originalPlacement Placement originally defined on init
 * @property {Boolean} data.flipped True if popper has been flipped by flip modifier
 * @property {Boolean} data.hide True if the reference element is out of boundaries, useful to know when to hide the popper
 * @property {HTMLElement} data.arrowElement Node used as arrow by arrow modifier
 * @property {Object} data.styles Any CSS property defined here will be applied to the popper. It expects the JavaScript nomenclature (eg. `marginBottom`)
 * @property {Object} data.arrowStyles Any CSS property defined here will be applied to the popper arrow. It expects the JavaScript nomenclature (eg. `marginBottom`)
 * @property {Object} data.boundaries Offsets of the popper boundaries
 * @property {Object} data.offsets The measurements of popper, reference and arrow elements
 * @property {Object} data.offsets.popper `top`, `left`, `width`, `height` values
 * @property {Object} data.offsets.reference `top`, `left`, `width`, `height` values
 * @property {Object} data.offsets.arrow] `top` and `left` offsets, only one of them will be different from 0
 */

/**
 * Default options provided to Popper.js constructor.<br />
 * These can be overridden using the `options` argument of Popper.js.<br />
 * To override an option, simply pass an object with the same
 * structure of the `options` object, as the 3rd argument. For example:
 * ```
 * new Popper(ref, pop, {
 *   modifiers: {
 *     preventOverflow: { enabled: false }
 *   }
 * })
 * ```
 * @type {Object}
 * @static
 * @memberof Popper
 */
var Defaults = {
  /**
   * Popper's placement.
   * @prop {Popper.placements} placement='bottom'
   */
  placement: 'bottom',

  /**
   * Set this to true if you want popper to position it self in 'fixed' mode
   * @prop {Boolean} positionFixed=false
   */
  positionFixed: false,

  /**
   * Whether events (resize, scroll) are initially enabled.
   * @prop {Boolean} eventsEnabled=true
   */
  eventsEnabled: true,

  /**
   * Set to true if you want to automatically remove the popper when
   * you call the `destroy` method.
   * @prop {Boolean} removeOnDestroy=false
   */
  removeOnDestroy: false,

  /**
   * Callback called when the popper is created.<br />
   * By default, it is set to no-op.<br />
   * Access Popper.js instance with `data.instance`.
   * @prop {onCreate}
   */
  onCreate: function onCreate() {},

  /**
   * Callback called when the popper is updated. This callback is not called
   * on the initialization/creation of the popper, but only on subsequent
   * updates.<br />
   * By default, it is set to no-op.<br />
   * Access Popper.js instance with `data.instance`.
   * @prop {onUpdate}
   */
  onUpdate: function onUpdate() {},

  /**
   * List of modifiers used to modify the offsets before they are applied to the popper.
   * They provide most of the functionalities of Popper.js.
   * @prop {modifiers}
   */
  modifiers: modifiers
};

/**
 * @callback onCreate
 * @param {dataObject} data
 */

/**
 * @callback onUpdate
 * @param {dataObject} data
 */

// Utils
// Methods
var Popper = function () {
  /**
   * Creates a new Popper.js instance.
   * @class Popper
   * @param {HTMLElement|referenceObject} reference - The reference element used to position the popper
   * @param {HTMLElement} popper - The HTML element used as the popper
   * @param {Object} options - Your custom options to override the ones defined in [Defaults](#defaults)
   * @return {Object} instance - The generated Popper.js instance
   */
  function Popper(reference, popper) {
    var _this = this;

    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    classCallCheck(this, Popper);

    this.scheduleUpdate = function () {
      return requestAnimationFrame(_this.update);
    };

    // make update() debounced, so that it only runs at most once-per-tick
    this.update = debounce(this.update.bind(this));

    // with {} we create a new object with the options inside it
    this.options = _extends({}, Popper.Defaults, options);

    // init state
    this.state = {
      isDestroyed: false,
      isCreated: false,
      scrollParents: []
    };

    // get reference and popper elements (allow jQuery wrappers)
    this.reference = reference && reference.jquery ? reference[0] : reference;
    this.popper = popper && popper.jquery ? popper[0] : popper;

    // Deep merge modifiers options
    this.options.modifiers = {};
    Object.keys(_extends({}, Popper.Defaults.modifiers, options.modifiers)).forEach(function (name) {
      _this.options.modifiers[name] = _extends({}, Popper.Defaults.modifiers[name] || {}, options.modifiers ? options.modifiers[name] : {});
    });

    // Refactoring modifiers' list (Object => Array)
    this.modifiers = Object.keys(this.options.modifiers).map(function (name) {
      return _extends({
        name: name
      }, _this.options.modifiers[name]);
    })
    // sort the modifiers by order
    .sort(function (a, b) {
      return a.order - b.order;
    });

    // modifiers have the ability to execute arbitrary code when Popper.js get inited
    // such code is executed in the same order of its modifier
    // they could add new properties to their options configuration
    // BE AWARE: don't add options to `options.modifiers.name` but to `modifierOptions`!
    this.modifiers.forEach(function (modifierOptions) {
      if (modifierOptions.enabled && isFunction(modifierOptions.onLoad)) {
        modifierOptions.onLoad(_this.reference, _this.popper, _this.options, modifierOptions, _this.state);
      }
    });

    // fire the first update to position the popper in the right place
    this.update();

    var eventsEnabled = this.options.eventsEnabled;
    if (eventsEnabled) {
      // setup event listeners, they will take care of update the position in specific situations
      this.enableEventListeners();
    }

    this.state.eventsEnabled = eventsEnabled;
  }

  // We can't use class properties because they don't get listed in the
  // class prototype and break stuff like Sinon stubs


  createClass(Popper, [{
    key: 'update',
    value: function update$$1() {
      return update.call(this);
    }
  }, {
    key: 'destroy',
    value: function destroy$$1() {
      return destroy.call(this);
    }
  }, {
    key: 'enableEventListeners',
    value: function enableEventListeners$$1() {
      return enableEventListeners.call(this);
    }
  }, {
    key: 'disableEventListeners',
    value: function disableEventListeners$$1() {
      return disableEventListeners.call(this);
    }

    /**
     * Schedules an update. It will run on the next UI update available.
     * @method scheduleUpdate
     * @memberof Popper
     */


    /**
     * Collection of utilities useful when writing custom modifiers.
     * Starting from version 1.7, this method is available only if you
     * include `popper-utils.js` before `popper.js`.
     *
     * **DEPRECATION**: This way to access PopperUtils is deprecated
     * and will be removed in v2! Use the PopperUtils module directly instead.
     * Due to the high instability of the methods contained in Utils, we can't
     * guarantee them to follow semver. Use them at your own risk!
     * @static
     * @private
     * @type {Object}
     * @deprecated since version 1.8
     * @member Utils
     * @memberof Popper
     */

  }]);
  return Popper;
}();

/**
 * The `referenceObject` is an object that provides an interface compatible with Popper.js
 * and lets you use it as replacement of a real DOM node.<br />
 * You can use this method to position a popper relatively to a set of coordinates
 * in case you don't have a DOM node to use as reference.
 *
 * ```
 * new Popper(referenceObject, popperNode);
 * ```
 *
 * NB: This feature isn't supported in Internet Explorer 10.
 * @name referenceObject
 * @property {Function} data.getBoundingClientRect
 * A function that returns a set of coordinates compatible with the native `getBoundingClientRect` method.
 * @property {number} data.clientWidth
 * An ES6 getter that will return the width of the virtual reference element.
 * @property {number} data.clientHeight
 * An ES6 getter that will return the height of the virtual reference element.
 */


Popper.Utils = (typeof window !== 'undefined' ? window : global).PopperUtils;
Popper.placements = placements;
Popper.Defaults = Defaults;

/* harmony default export */ __webpack_exports__["default"] = (Popper);
//# sourceMappingURL=popper.js.map

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(36)))

/***/ }),
/* 587 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(2);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(11));

var _createClass2 = _interopRequireDefault(__webpack_require__(12));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(13));

var _inherits2 = _interopRequireDefault(__webpack_require__(14));

var _react = _interopRequireDefault(__webpack_require__(0));

var _reactDom = _interopRequireDefault(__webpack_require__(24));

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _ownerDocument = _interopRequireDefault(__webpack_require__(48));

var _exactProp = _interopRequireDefault(__webpack_require__(95));

function getContainer(container, defaultContainer) {
  container = typeof container === 'function' ? container() : container;
  return _reactDom.default.findDOMNode(container) || defaultContainer;
}

function getOwnerDocument(element) {
  return (0, _ownerDocument.default)(_reactDom.default.findDOMNode(element));
}
/**
 * Portals provide a first-class way to render children into a DOM node
 * that exists outside the DOM hierarchy of the parent component.
 */


var Portal =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(Portal, _React$Component);

  function Portal() {
    var _ref;

    var _temp, _this;

    (0, _classCallCheck2.default)(this, Portal);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return (0, _possibleConstructorReturn2.default)(_this, (_temp = _this = (0, _possibleConstructorReturn2.default)(this, (_ref = Portal.__proto__ || Object.getPrototypeOf(Portal)).call.apply(_ref, [this].concat(args))), _this.getMountNode = function () {
      return _this.mountNode;
    }, _temp));
  }

  (0, _createClass2.default)(Portal, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.setMountNode(this.props.container); // Only rerender if needed

      if (!this.props.disablePortal) {
        this.forceUpdate(this.props.onRendered);
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (prevProps.container !== this.props.container || prevProps.disablePortal !== this.props.disablePortal) {
        this.setMountNode(this.props.container); // Only rerender if needed

        if (!this.props.disablePortal) {
          this.forceUpdate(this.props.onRendered);
        }
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.mountNode = null;
    }
  }, {
    key: "setMountNode",
    value: function setMountNode(container) {
      if (this.props.disablePortal) {
        this.mountNode = _reactDom.default.findDOMNode(this).parentElement;
        return;
      }

      this.mountNode = getContainer(container, getOwnerDocument(this).body);
    }
    /**
     * @public
     */

  }, {
    key: "render",
    value: function render() {
      var _props = this.props,
          children = _props.children,
          disablePortal = _props.disablePortal;

      if (disablePortal) {
        return children;
      }

      return this.mountNode ? _reactDom.default.createPortal(children, this.mountNode) : null;
    }
  }]);
  return Portal;
}(_react.default.Component);

Portal.propTypes =  false ? {
  /**
   * The children to render into the `container`.
   */
  children: _propTypes.default.node.isRequired,

  /**
   * A node, component instance, or function that returns either.
   * The `container` will have the portal children appended to it.
   * By default, it uses the body of the top-level document object,
   * so it's simply `document.body` most of the time.
   */
  container: _propTypes.default.oneOfType([_propTypes.default.object, _propTypes.default.func]),

  /**
   * Disable the portal behavior.
   * The children stay within it's parent DOM hierarchy.
   */
  disablePortal: _propTypes.default.bool,

  /**
   * Callback fired once the children has been mounted into the `container`.
   */
  onRendered: _propTypes.default.func
} : {};
Portal.defaultProps = {
  disablePortal: false
};
Portal.propTypes =  false ? (0, _exactProp.default)(Portal.propTypes) : {};
var _default = Portal;
exports.default = _default;

/***/ }),
/* 588 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_buttonGroupStyle_jsx__ = __webpack_require__(589);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_assets_jss_material_dashboard_pro_react_customCheckboxRadioSwitch_jsx__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_assets_jss_material_dashboard_pro_react_jsx__ = __webpack_require__(21);
var extendedTablesStyle=Object.assign({},__WEBPACK_IMPORTED_MODULE_1_assets_jss_material_dashboard_pro_react_customCheckboxRadioSwitch_jsx__["a" /* default */],__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_buttonGroupStyle_jsx__["a" /* default */],{right:{textAlign:"right"},center:{textAlign:"center"},description:{maxWidth:"150px"},actionButton:{margin:"0 0 0 5px",padding:"5px","& svg,& .fab,& .fas,& .far,& .fal,& .material-icons":{marginRight:"0px"}},icon:{verticalAlign:"middle",width:"17px",height:"17px",top:"-1px",position:"relative"},imgContainer:{width:"120px",maxHeight:"160px",overflow:"hidden",display:"block"},img:{width:"100%",height:"auto",verticalAlign:"middle",border:"0"},tdName:{minWidth:"200px",fontWeight:"400",fontSize:"1.5em"},tdNameAnchor:{color:"#3C4858"},tdNameSmall:{color:"#999999",fontSize:"0.75em",fontWeight:"300"},tdNumber:{textAlign:"right",minWidth:"145px",fontWeight:"300",fontSize:"1.3em !important"},tdNumberSmall:{marginRight:"3px"},tdNumberAndButtonGroup:{lineHeight:"1 !important"},positionAbsolute:{position:"absolute",right:"0",top:"0"},customFont:{fontSize:"16px !important"},actionButtonRound:{width:"auto",height:"auto",minWidth:"auto"},cardIconTitle:Object.assign({},__WEBPACK_IMPORTED_MODULE_2_assets_jss_material_dashboard_pro_react_jsx__["b" /* cardTitle */],{marginTop:"15px",marginBottom:"0px"})});/* harmony default export */ __webpack_exports__["a"] = (extendedTablesStyle);

/***/ }),
/* 589 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ##############################
// // // Button Group styles
// #############################
var buttonGroupStyle={buttonGroup:{position:"relative",margin:"10px 1px",display:"inline-block",verticalAlign:"middle"},firstButton:{borderTopRightRadius:"0",borderBottomRightRadius:"0",margin:"0",position:"relative",float:"left","&:hover":{zIndex:"2"}},middleButton:{borderRadius:"0",margin:"0",position:"relative",float:"left","&:hover":{zIndex:"2"}},lastButton:{borderTopLeftRadius:"0",borderBottomLeftRadius:"0",margin:"0","&:hover":{zIndex:"2"}}};/* harmony default export */ __webpack_exports__["a"] = (buttonGroupStyle);

/***/ }),
/* 590 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export DashboardComponent */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_file_download__ = __webpack_require__(267);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_file_download___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_js_file_download__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_select__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_styles_withStyles__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_styles_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_styles_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_select_lib_animated__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_select_lib_animated___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_select_lib_animated__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_CustomButtons_Button_jsx__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_CircularProgress__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_CircularProgress___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_CircularProgress__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_EnergyCompany_Input_Input__ = __webpack_require__(188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Dashboard__ = __webpack_require__(190);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__material_ui_icons_Delete__ = __webpack_require__(352);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__material_ui_icons_Delete___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__material_ui_icons_Delete__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__relatorio_partials_EmpresasFiltradas__ = __webpack_require__(353);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_services_utils__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_services_dados_gerais__ = __webpack_require__(354);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_services_busca_cativo__ = __webpack_require__(933);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var buscaCativoStyle=function buscaCativoStyle(theme){return{atributosWrapper:{display:"flex"},atributos:{display:"grid",gridColumnGap:"15px",gridRowGap:"15px",gridTemplateColumns:"repeat(auto-fit, minmax(150px, 1fr))",width:"100%"},atributosAction:{alignItems:"center",cursor:"pointer",display:"flex",marginLeft:"15px"},atributosActionWrapper:{display:"flex",alignItems:"flex-end",paddingBottom:"10px"},buscarButtonWrapper:{display:"flex",justifyContent:"flex-end",margin:"20px 0","& > div":{position:"relative"}},buttonProgress:{position:'absolute',top:'50%',left:'50%',marginTop:-12,marginLeft:-12},estados:{display:"grid",gridColumnGap:"15px",gridRowGap:"15px",gridTemplateColumns:"repeat(auto-fit, minmax(300px, 1fr))"},filtroWrapper:{marginBottom:"15px"},novoAtributo:{cursor:"pointer"},ordenaçãoWrapper:{display:"grid",gridColumnGap:"15px",gridRowGap:"15px",gridTemplateColumns:"repeat(auto-fit, minmax(250px, 1fr))"}};};var BuscaCativo=function(_Component){_inherits(BuscaCativo,_Component);function BuscaCativo(){var _ref;var _temp,_this,_ret;_classCallCheck(this,BuscaCativo);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=BuscaCativo.__proto__||Object.getPrototypeOf(BuscaCativo)).call.apply(_ref,[this].concat(args))),_this),_this.state=Object.assign({},_this.getPristineState()),_this.addAtributo=function(){_this.setState({atributos:_this.state.atributos.concat({uniqueId:Object(__WEBPACK_IMPORTED_MODULE_5_lodash__["uniqueId"])("atributo")})});},_this.removeAtributo=function(indexToRemove){_this.setState(function(prevState){var atributos=[].concat(_toConsumableArray(prevState.atributos));Object(__WEBPACK_IMPORTED_MODULE_5_lodash__["remove"])(atributos,function(val,index){return index===indexToRemove;});return{atributos:atributos};});},_this.clearSelections=function(){_this.setState(Object.assign({},_this.getPristineState(),{parametros:_this.state.parametros}));},_this.requestBuscaFiltrada=function(){var _this$state=_this.state,atributos=_this$state.atributos,cidades=_this$state.cidades,classesCNAE=_this$state.classesCNAE,cnaes=_this$state.cnaes,divisoesCNAE=_this$state.divisoesCNAE,estados=_this$state.estados,gruposCNAE=_this$state.gruposCNAE,ordenacao=_this$state.ordenacao,regioes=_this$state.regioes,sentidoOrdenacao=_this$state.sentidoOrdenacao,subgroups=_this$state.subgroups,submercados=_this$state.submercados;_this.setState({empresa:undefined,itens:undefined,loading:true,relatorio:undefined});Object(__WEBPACK_IMPORTED_MODULE_15_services_busca_cativo__["b" /* fetchReport */])({atributos:atributos,cidades:cidades,cnaes:cnaes,divisoesCNAE:divisoesCNAE,estados:estados,gruposCNAE:gruposCNAE,classesCNAE:classesCNAE,ordenacao:ordenacao,regioes:regioes,sentidoOrdenacao:sentidoOrdenacao,subgroups:subgroups,submercados:submercados}).then(function(_ref2){var data=_ref2.data;_this.setState({itens:data.relatorio.itens,loading:false,relatorio:data.relatorio});}).catch(function(){return _this.setState({loading:false});});},_this.requestNextPage=function(page){Object(__WEBPACK_IMPORTED_MODULE_15_services_busca_cativo__["c" /* fetchReportPage */])(_this.state.relatorio.id,page-1).then(function(_ref3){var data=_ref3.data;_this.setState({itens:data.relatorio.itens,relatorio:data.relatorio});});},_this.searchEmpresa=function(empresa){_this.setState({empresa:empresa});},_this.setEstadoAndFetchCidades=function(estados){_this.setState({estados:estados,loadingCidades:true});if(estados&&estados.length===1){Object(__WEBPACK_IMPORTED_MODULE_14_services_dados_gerais__["a" /* fetchCidades */])(estados[0].id).then(function(res){_this.setState({availableCidades:res.data,loadingCidades:false});});}else{_this.setState({availableCidades:[],cidades:[],loadingCidades:false});}},_this.updateAtributo=function(key,value,index){_this.setState(function(prevState){var atributos=[].concat(_toConsumableArray(prevState.atributos));atributos[index][key]=value;if(key==='tipo'){atributos[index]['condicao']=atributos[index]['condicao']||_this.state.parametros.condicoes[0];atributos[index]['valor']=atributos[index]['valor']||0;atributos[index]['unidade']=atributos[index]['unidade']||_this.state.parametros.unidades[0];}return{atributos:atributos};});},_this.updateSubmercado=function(value){if(value.length){_this.setState({cidades:[],estados:[],submercados:value});}else{_this.setState({submercados:value});}},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(BuscaCativo,[{key:"componentDidMount",value:function componentDidMount(){var _this2=this;Object(__WEBPACK_IMPORTED_MODULE_15_services_busca_cativo__["a" /* fetchParametros */])().then(function(_ref4){var data=_ref4.data;_this2.setState({parametros:data});});}},{key:"getPristineState",value:function getPristineState(){return{atributos:[{uniqueId:Object(__WEBPACK_IMPORTED_MODULE_5_lodash__["uniqueId"])("atributo")}],availableCidades:[],cidades:[],cnaes:[],divisoesCNAE:[],empresa:undefined,estados:[],gruposCNAE:[],classesCNAE:[],itens:undefined,loading:false,loadingCidades:false,ordenacao:"",parametros:{},regioes:[],relatorio:undefined,sentidoOrdenacao:"",subgroups:[],submercados:[]};}},{key:"noOptionsMessage",value:function noOptionsMessage(options){return options?"Sem resultado":"Carregando...";}},{key:"render",value:function render(){var _this3=this;var classes=this.props.classes;var _state=this.state,atributos=_state.atributos,availableCidades=_state.availableCidades,cidades=_state.cidades,subgroups=_state.subgroups,cnaes=_state.cnaes,divisoesCNAE=_state.divisoesCNAE,empresa=_state.empresa,estados=_state.estados,gruposCNAE=_state.gruposCNAE,classesCNAE=_state.classesCNAE,itens=_state.itens,loading=_state.loading,loadingCidades=_state.loadingCidades,ordenacao=_state.ordenacao,parametros=_state.parametros,regioes=_state.regioes,relatorio=_state.relatorio,sentidoOrdenacao=_state.sentidoOrdenacao,submercados=_state.submercados;return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("div",{className:classes.filtroWrapper},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("h4",null,"Submercado"),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_select__["a" /* default */],{components:__WEBPACK_IMPORTED_MODULE_6_react_select_lib_animated__,getOptionLabel:function getOptionLabel(option){return option.nome;},getOptionValue:function getOptionValue(option){return option.id;},isDisabled:!!regioes.length||!!estados.length,isMulti:true,noOptionsMessage:function noOptionsMessage(){return _this3.noOptionsMessage(parametros.submercados);},onChange:this.updateSubmercado,options:parametros.submercados,placeholder:"Submercado",value:submercados})),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("div",{className:classes.filtroWrapper},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("h4",null,"Regi\xF5es"),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_select__["a" /* default */],{components:__WEBPACK_IMPORTED_MODULE_6_react_select_lib_animated__,getOptionLabel:function getOptionLabel(option){return option.nome;},getOptionValue:function getOptionValue(option){return option.id;},isDisabled:!!submercados.length||!!estados.length,isMulti:true,noOptionsMessage:function noOptionsMessage(){return _this3.noOptionsMessage(parametros.regioes);},onChange:function onChange(e){return _this3.setState({regioes:e});},options:parametros.regioes,placeholder:"Regi\xF5es",value:regioes})),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("div",{className:classes.filtroWrapper},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("div",{className:classes.estados},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("h4",null,"Estados"),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_select__["a" /* default */],{components:__WEBPACK_IMPORTED_MODULE_6_react_select_lib_animated__,getOptionLabel:function getOptionLabel(option){return option.nome;},getOptionValue:function getOptionValue(option){return option.id;},isClearable:true,isDisabled:!!submercados.length||!!regioes.length,isMulti:true,noOptionsMessage:function noOptionsMessage(){return _this3.noOptionsMessage(parametros.estados);},onChange:this.setEstadoAndFetchCidades,options:parametros.estados,placeholder:"Estados",value:estados})),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("h4",null,"Cidades"),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_select__["a" /* default */],{components:__WEBPACK_IMPORTED_MODULE_6_react_select_lib_animated__,getOptionLabel:function getOptionLabel(option){return Object(__WEBPACK_IMPORTED_MODULE_13_services_utils__["d" /* capitalizeString */])(option.nome);},getOptionValue:function getOptionValue(option){return option.id;},isDisabled:!!submercados.length||!!regioes.length||estados.length>1,isLoading:loadingCidades,isMulti:true,loadingMessage:function loadingMessage(){return"Carregando cidades...";},noOptionsMessage:function noOptionsMessage(){return"Sem resultado";},onChange:function onChange(e){return _this3.setState({cidades:e});},options:availableCidades,placeholder:"Cidades",value:cidades})))),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("div",{className:classes.filtroWrapper},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("h4",null,"Subgrupos"),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_select__["a" /* default */],{components:__WEBPACK_IMPORTED_MODULE_6_react_select_lib_animated__,getOptionLabel:function getOptionLabel(option){return option.nome;},getOptionValue:function getOptionValue(option){return option.id;},isMulti:true,noOptionsMessage:function noOptionsMessage(){return _this3.noOptionsMessage(parametros.subgroups);},onChange:function onChange(e){return _this3.setState({subgroups:e});},options:parametros.subgroups,placeholder:"Subgrupos",value:subgroups})),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("div",{className:classes.filtroWrapper},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("h4",null,"Divis\xF5es CNAE"),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_select__["a" /* default */],{components:__WEBPACK_IMPORTED_MODULE_6_react_select_lib_animated__,getOptionLabel:function getOptionLabel(option){return option.nome;},getOptionValue:function getOptionValue(option){return option.id;},isMulti:true,noOptionsMessage:function noOptionsMessage(){return _this3.noOptionsMessage(parametros.divisoesCNAE);},onChange:function onChange(e){return _this3.setState({divisoesCNAE:e});},options:parametros.divisoesCNAE,placeholder:"Divis\xF5es CNAE",value:divisoesCNAE})),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("div",{className:classes.filtroWrapper},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("h4",null,"Grupos CNAE"),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_select__["a" /* default */],{components:__WEBPACK_IMPORTED_MODULE_6_react_select_lib_animated__,getOptionLabel:function getOptionLabel(option){return option.nome;},getOptionValue:function getOptionValue(option){return option.id;},isMulti:true,noOptionsMessage:function noOptionsMessage(){return _this3.noOptionsMessage(parametros.gruposCNAE);},onChange:function onChange(e){return _this3.setState({gruposCNAE:e});},options:parametros.gruposCNAE,placeholder:"Grupos CNAE",value:gruposCNAE})),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("div",{className:classes.filtroWrapper},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("h4",null,"Classes CNAE"),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_select__["a" /* default */],{components:__WEBPACK_IMPORTED_MODULE_6_react_select_lib_animated__,getOptionLabel:function getOptionLabel(option){return option.nome;},getOptionValue:function getOptionValue(option){return option.id;},isMulti:true,noOptionsMessage:function noOptionsMessage(){return _this3.noOptionsMessage(parametros.classesCNAE);},onChange:function onChange(e){return _this3.setState({classesCNAE:e});},options:parametros.classesCNAE,placeholder:"Classes CNAE",value:classesCNAE})),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("div",{className:classes.filtroWrapper},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("h4",null,"CNAEs"),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_select__["a" /* default */],{components:__WEBPACK_IMPORTED_MODULE_6_react_select_lib_animated__,getOptionLabel:function getOptionLabel(option){return option.nome;},getOptionValue:function getOptionValue(option){return option.id;},isMulti:true,noOptionsMessage:function noOptionsMessage(){return _this3.noOptionsMessage(parametros.cnaes);},onChange:function onChange(e){return _this3.setState({cnaes:e});},options:Object(__WEBPACK_IMPORTED_MODULE_5_lodash__["orderBy"])(parametros.cnaes,["nome"]),placeholder:"CNAEs",value:cnaes})),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("div",{className:classes.filtroWrapper},Object(__WEBPACK_IMPORTED_MODULE_5_lodash__["map"])(atributos,function(atributo,index){return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("div",{className:classes.filtroWrapper,key:atributo.uniqueId},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("div",{className:classes.atributosWrapper},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("div",{className:classes.atributos},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("h4",null,"Filtro"),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_select__["a" /* default */],{components:__WEBPACK_IMPORTED_MODULE_6_react_select_lib_animated__,getOptionLabel:function getOptionLabel(option){return option.nome;},getOptionValue:function getOptionValue(option){return option.id;},noOptionsMessage:function noOptionsMessage(){return _this3.noOptionsMessage(parametros.atributos);},onChange:function onChange(e){return _this3.updateAtributo('tipo',e,index);},options:parametros.atributos,placeholder:"Tipo",value:atributo.tipo})),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("h4",null,"Condi\xE7\xE3o"),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_select__["a" /* default */],{components:__WEBPACK_IMPORTED_MODULE_6_react_select_lib_animated__,getOptionLabel:function getOptionLabel(option){return option.nome;},getOptionValue:function getOptionValue(option){return option.id;},noOptionsMessage:function noOptionsMessage(){return _this3.noOptionsMessage(parametros.condicoes);},onChange:function onChange(e){return _this3.updateAtributo('condicao',e,index);},options:parametros.condicoes,placeholder:"Condi\xE7\xE3o",value:atributo.condicao})),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("h4",null,"Valor"),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_EnergyCompany_Input_Input__["a" /* default */],{onChange:function onChange(_ref5){var target=_ref5.target;return _this3.updateAtributo('valor',target.value===""?"":Number(target.value),index);},placeholder:"Valor",type:"number",value:Object(__WEBPACK_IMPORTED_MODULE_5_lodash__["isNumber"])(atributo.valor)?atributo.valor:""})),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("h4",null,"Unidade"),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_select__["a" /* default */],{components:__WEBPACK_IMPORTED_MODULE_6_react_select_lib_animated__,getOptionLabel:function getOptionLabel(option){return option.nome;},getOptionValue:function getOptionValue(option){return option.id;},label:"Unidade",noOptionsMessage:function noOptionsMessage(){return _this3.noOptionsMessage(parametros.unidades);},onChange:function onChange(e){return _this3.updateAtributo('unidade',e,index);},options:parametros.unidades,placeholder:"Unidade",value:atributo.unidade}))),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("div",{className:classes.atributosActionWrapper},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("div",{className:classes.atributosAction},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_icons_Delete___default.a,{onClick:function onClick(){return _this3.removeAtributo(index);}})))));}),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("a",{className:classes.novoAtributo,onClick:this.addAtributo},"+ Adicionar novo filtro")),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("div",{className:classes.ordenaçãoWrapper},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("h4",null,"Ordena\xE7\xE3o"),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_select__["a" /* default */],{components:__WEBPACK_IMPORTED_MODULE_6_react_select_lib_animated__,getOptionLabel:function getOptionLabel(option){return option.nome;},getOptionValue:function getOptionValue(option){return option.id;},noOptionsMessage:function noOptionsMessage(){return _this3.noOptionsMessage(parametros.atributosOrdenacao);},onChange:function onChange(e){return _this3.setState({ordenacao:e});},options:parametros.atributosOrdenacao,placeholder:"Ordena\xE7\xE3o",value:ordenacao})),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("h4",null,"Sentido da Ordena\xE7\xE3o"),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_select__["a" /* default */],{components:__WEBPACK_IMPORTED_MODULE_6_react_select_lib_animated__,getOptionLabel:function getOptionLabel(option){return option.nome;},getOptionValue:function getOptionValue(option){return option.id;},onChange:function onChange(e){return _this3.setState({sentidoOrdenacao:e});},options:[{id:false,nome:"A -> Z"},{id:true,nome:"Z -> A"}],placeholder:"Sentido da ordena\xE7\xE3o",value:sentidoOrdenacao}))),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("div",{className:classes.buscarButtonWrapper},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_CustomButtons_Button_jsx__["a" /* default */],{color:"rose",disabled:loading,onClick:this.clearSelections},"Limpar Filtros"),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_CustomButtons_Button_jsx__["a" /* default */],{color:"info",disabled:loading,onClick:this.requestBuscaFiltrada},"Buscar"),loading&&__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_CircularProgress___default.a,{className:classes.buttonProgress,size:24}))),itens&&itens.length>0&&__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__relatorio_partials_EmpresasFiltradas__["a" /* default */],{colunaFixa:{key:'nomeEmpresa',label:'Razão Social'},downloadCSV:function downloadCSV(){Object(__WEBPACK_IMPORTED_MODULE_15_services_busca_cativo__["d" /* getRelatorioCSV */])(relatorio.id,0).then(function(response){__WEBPACK_IMPORTED_MODULE_0_js_file_download___default()(response.data,'empresas-busca-cativo.csv');});},itens:itens,relatorio:relatorio,requestNextPage:this.requestNextPage,searchEmpresa:this.searchEmpresa}),itens&&itens.length===0&&__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("h3",null,"Nenhuma empresa encontrada"),empresa&&__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__Dashboard__["a" /* default */],{selected:{id:empresa.idEmpresa},simplified:true}));}}]);return BuscaCativo;}(__WEBPACK_IMPORTED_MODULE_2_react__["Component"]);BuscaCativo.propTypes={classes:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired};/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_4__material_ui_core_styles_withStyles___default()(buscaCativoStyle)(BuscaCativo));

/***/ }),
/* 591 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__emotion_memoize__ = __webpack_require__(592);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__emotion_unitless__ = __webpack_require__(593);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__emotion_hash__ = __webpack_require__(594);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__emotion_stylis__ = __webpack_require__(595);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_stylis_rule_sheet__ = __webpack_require__(596);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_stylis_rule_sheet___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_stylis_rule_sheet__);






var hyphenateRegex = /[A-Z]|^ms/g;
var processStyleName = Object(__WEBPACK_IMPORTED_MODULE_0__emotion_memoize__["a" /* default */])(function (styleName) {
  return styleName.replace(hyphenateRegex, '-$&').toLowerCase();
});
var processStyleValue = function processStyleValue(key, value) {
  if (value == null || typeof value === 'boolean') {
    return '';
  }

  if (__WEBPACK_IMPORTED_MODULE_1__emotion_unitless__["a" /* default */][key] !== 1 && key.charCodeAt(1) !== 45 && // custom properties
  !isNaN(value) && value !== 0) {
    return value + 'px';
  }

  return value;
};

if (false) {
  var contentValuePattern = /(attr|calc|counters?|url)\(/;
  var contentValues = ['normal', 'none', 'counter', 'open-quote', 'close-quote', 'no-open-quote', 'no-close-quote', 'initial', 'inherit', 'unset'];
  var oldProcessStyleValue = processStyleValue;

  processStyleValue = function processStyleValue(key, value) {
    if (key === 'content') {
      if (typeof value !== 'string' || contentValues.indexOf(value) === -1 && !contentValuePattern.test(value) && (value.charAt(0) !== value.charAt(value.length - 1) || value.charAt(0) !== '"' && value.charAt(0) !== "'")) {
        console.error("You seem to be using a value for 'content' without quotes, try replacing it with `content: '\"" + value + "\"'`");
      }
    }

    return oldProcessStyleValue(key, value);
  };
}

var classnames = function classnames(args) {
  var len = args.length;
  var i = 0;
  var cls = '';

  for (; i < len; i++) {
    var arg = args[i];
    if (arg == null) continue;
    var toAdd = void 0;

    switch (typeof arg) {
      case 'boolean':
        break;

      case 'function':
        if (false) {
          console.error('Passing functions to cx is deprecated and will be removed in the next major version of Emotion.\n' + 'Please call the function before passing it to cx.');
        }

        toAdd = classnames([arg()]);
        break;

      case 'object':
        {
          if (Array.isArray(arg)) {
            toAdd = classnames(arg);
          } else {
            toAdd = '';

            for (var k in arg) {
              if (arg[k] && k) {
                toAdd && (toAdd += ' ');
                toAdd += k;
              }
            }
          }

          break;
        }

      default:
        {
          toAdd = arg;
        }
    }

    if (toAdd) {
      cls && (cls += ' ');
      cls += toAdd;
    }
  }

  return cls;
};
var isBrowser = typeof document !== 'undefined';

/*

high performance StyleSheet for css-in-js systems

- uses multiple style tags behind the scenes for millions of rules
- uses `insertRule` for appending in production for *much* faster performance
- 'polyfills' on server side

// usage

import StyleSheet from 'glamor/lib/sheet'
let styleSheet = new StyleSheet()

styleSheet.inject()
- 'injects' the stylesheet into the page (or into memory if on server)

styleSheet.insert('#box { border: 1px solid red; }')
- appends a css rule into the stylesheet

styleSheet.flush()
- empties the stylesheet of all its contents

*/
// $FlowFixMe
function sheetForTag(tag) {
  if (tag.sheet) {
    // $FlowFixMe
    return tag.sheet;
  } // this weirdness brought to you by firefox


  for (var i = 0; i < document.styleSheets.length; i++) {
    if (document.styleSheets[i].ownerNode === tag) {
      // $FlowFixMe
      return document.styleSheets[i];
    }
  }
}

function makeStyleTag(opts) {
  var tag = document.createElement('style');
  tag.setAttribute('data-emotion', opts.key || '');

  if (opts.nonce !== undefined) {
    tag.setAttribute('nonce', opts.nonce);
  }

  tag.appendChild(document.createTextNode('')) // $FlowFixMe
  ;
  (opts.container !== undefined ? opts.container : document.head).appendChild(tag);
  return tag;
}

var StyleSheet =
/*#__PURE__*/
function () {
  function StyleSheet(options) {
    this.isSpeedy = "production" === 'production'; // the big drawback here is that the css won't be editable in devtools

    this.tags = [];
    this.ctr = 0;
    this.opts = options;
  }

  var _proto = StyleSheet.prototype;

  _proto.inject = function inject() {
    if (this.injected) {
      throw new Error('already injected!');
    }

    this.tags[0] = makeStyleTag(this.opts);
    this.injected = true;
  };

  _proto.speedy = function speedy(bool) {
    if (this.ctr !== 0) {
      // cannot change speedy mode after inserting any rule to sheet. Either call speedy(${bool}) earlier in your app, or call flush() before speedy(${bool})
      throw new Error("cannot change speedy now");
    }

    this.isSpeedy = !!bool;
  };

  _proto.insert = function insert(rule, sourceMap) {
    // this is the ultrafast version, works across browsers
    if (this.isSpeedy) {
      var tag = this.tags[this.tags.length - 1];
      var sheet = sheetForTag(tag);

      try {
        sheet.insertRule(rule, sheet.cssRules.length);
      } catch (e) {
        if (false) {
          console.warn('illegal rule', rule); // eslint-disable-line no-console
        }
      }
    } else {
      var _tag = makeStyleTag(this.opts);

      this.tags.push(_tag);

      _tag.appendChild(document.createTextNode(rule + (sourceMap || '')));
    }

    this.ctr++;

    if (this.ctr % 65000 === 0) {
      this.tags.push(makeStyleTag(this.opts));
    }
  };

  _proto.flush = function flush() {
    // $FlowFixMe
    this.tags.forEach(function (tag) {
      return tag.parentNode.removeChild(tag);
    });
    this.tags = [];
    this.ctr = 0; // todo - look for remnants in document.styleSheets

    this.injected = false;
  };

  return StyleSheet;
}();

function createEmotion(context, options) {
  if (context.__SECRET_EMOTION__ !== undefined) {
    return context.__SECRET_EMOTION__;
  }

  if (options === undefined) options = {};
  var key = options.key || 'css';

  if (false) {
    if (/[^a-z-]/.test(key)) {
      throw new Error("Emotion key must only contain lower case alphabetical characters and - but \"" + key + "\" was passed");
    }
  }

  var current;

  function insertRule(rule) {
    current += rule;

    if (isBrowser) {
      sheet.insert(rule, currentSourceMap);
    }
  }

  var insertionPlugin = __WEBPACK_IMPORTED_MODULE_4_stylis_rule_sheet___default()(insertRule);
  var stylisOptions;

  if (options.prefix !== undefined) {
    stylisOptions = {
      prefix: options.prefix
    };
  }

  var caches = {
    registered: {},
    inserted: {},
    nonce: options.nonce,
    key: key
  };
  var sheet = new StyleSheet(options);

  if (isBrowser) {
    // 🚀
    sheet.inject();
  }

  var stylis = new __WEBPACK_IMPORTED_MODULE_3__emotion_stylis__["a" /* default */](stylisOptions);
  stylis.use(options.stylisPlugins)(insertionPlugin);
  var currentSourceMap = '';

  function handleInterpolation(interpolation, couldBeSelectorInterpolation) {
    if (interpolation == null) {
      return '';
    }

    switch (typeof interpolation) {
      case 'boolean':
        return '';

      case 'function':
        if (interpolation.__emotion_styles !== undefined) {
          var selector = interpolation.toString();

          if (selector === 'NO_COMPONENT_SELECTOR' && "production" !== 'production') {
            throw new Error('Component selectors can only be used in conjunction with babel-plugin-emotion.');
          }

          return selector;
        }

        if (this === undefined && "production" !== 'production') {
          console.error('Interpolating functions in css calls is deprecated and will be removed in the next major version of Emotion.\n' + 'If you want to have a css call based on props, create a function that returns a css call like this\n' + 'let dynamicStyle = (props) => css`color: ${props.color}`\n' + 'It can be called directly with props or interpolated in a styled call like this\n' + "let SomeComponent = styled('div')`${dynamicStyle}`");
        }

        return handleInterpolation.call(this, this === undefined ? interpolation() : // $FlowFixMe
        interpolation(this.mergedProps, this.context), couldBeSelectorInterpolation);

      case 'object':
        return createStringFromObject.call(this, interpolation);

      default:
        var cached = caches.registered[interpolation];
        return couldBeSelectorInterpolation === false && cached !== undefined ? cached : interpolation;
    }
  }

  var objectToStringCache = new WeakMap();

  function createStringFromObject(obj) {
    if (objectToStringCache.has(obj)) {
      // $FlowFixMe
      return objectToStringCache.get(obj);
    }

    var string = '';

    if (Array.isArray(obj)) {
      obj.forEach(function (interpolation) {
        string += handleInterpolation.call(this, interpolation, false);
      }, this);
    } else {
      Object.keys(obj).forEach(function (key) {
        if (typeof obj[key] !== 'object') {
          if (caches.registered[obj[key]] !== undefined) {
            string += key + "{" + caches.registered[obj[key]] + "}";
          } else {
            string += processStyleName(key) + ":" + processStyleValue(key, obj[key]) + ";";
          }
        } else {
          if (key === 'NO_COMPONENT_SELECTOR' && "production" !== 'production') {
            throw new Error('Component selectors can only be used in conjunction with babel-plugin-emotion.');
          }

          if (Array.isArray(obj[key]) && typeof obj[key][0] === 'string' && caches.registered[obj[key][0]] === undefined) {
            obj[key].forEach(function (value) {
              string += processStyleName(key) + ":" + processStyleValue(key, value) + ";";
            });
          } else {
            string += key + "{" + handleInterpolation.call(this, obj[key], false) + "}";
          }
        }
      }, this);
    }

    objectToStringCache.set(obj, string);
    return string;
  }

  var name;
  var stylesWithLabel;
  var labelPattern = /label:\s*([^\s;\n{]+)\s*;/g;

  var createClassName = function createClassName(styles, identifierName) {
    return Object(__WEBPACK_IMPORTED_MODULE_2__emotion_hash__["a" /* default */])(styles + identifierName) + identifierName;
  };

  if (false) {
    var oldCreateClassName = createClassName;
    var sourceMappingUrlPattern = /\/\*#\ssourceMappingURL=data:application\/json;\S+\s+\*\//g;

    createClassName = function createClassName(styles, identifierName) {
      return oldCreateClassName(styles.replace(sourceMappingUrlPattern, function (sourceMap) {
        currentSourceMap = sourceMap;
        return '';
      }), identifierName);
    };
  }

  var createStyles = function createStyles(strings) {
    var stringMode = true;
    var styles = '';
    var identifierName = '';

    if (strings == null || strings.raw === undefined) {
      stringMode = false;
      styles += handleInterpolation.call(this, strings, false);
    } else {
      styles += strings[0];
    }

    for (var _len = arguments.length, interpolations = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      interpolations[_key - 1] = arguments[_key];
    }

    interpolations.forEach(function (interpolation, i) {
      styles += handleInterpolation.call(this, interpolation, styles.charCodeAt(styles.length - 1) === 46 // .
      );

      if (stringMode === true && strings[i + 1] !== undefined) {
        styles += strings[i + 1];
      }
    }, this);
    stylesWithLabel = styles;
    styles = styles.replace(labelPattern, function (match, p1) {
      identifierName += "-" + p1;
      return '';
    });
    name = createClassName(styles, identifierName);
    return styles;
  };

  if (false) {
    var oldStylis = stylis;

    stylis = function stylis(selector, styles) {
      oldStylis(selector, styles);
      currentSourceMap = '';
    };
  }

  function insert(scope, styles) {
    if (caches.inserted[name] === undefined) {
      current = '';
      stylis(scope, styles);
      caches.inserted[name] = current;
    }
  }

  var css = function css() {
    var styles = createStyles.apply(this, arguments);
    var selector = key + "-" + name;

    if (caches.registered[selector] === undefined) {
      caches.registered[selector] = stylesWithLabel;
    }

    insert("." + selector, styles);
    return selector;
  };

  var keyframes = function keyframes() {
    var styles = createStyles.apply(this, arguments);
    var animation = "animation-" + name;
    insert('', "@keyframes " + animation + "{" + styles + "}");
    return animation;
  };

  var injectGlobal = function injectGlobal() {
    var styles = createStyles.apply(this, arguments);
    insert('', styles);
  };

  function getRegisteredStyles(registeredStyles, classNames) {
    var rawClassName = '';
    classNames.split(' ').forEach(function (className) {
      if (caches.registered[className] !== undefined) {
        registeredStyles.push(className);
      } else {
        rawClassName += className + " ";
      }
    });
    return rawClassName;
  }

  function merge(className, sourceMap) {
    var registeredStyles = [];
    var rawClassName = getRegisteredStyles(registeredStyles, className);

    if (registeredStyles.length < 2) {
      return className;
    }

    return rawClassName + css(registeredStyles, sourceMap);
  }

  function cx() {
    for (var _len2 = arguments.length, classNames = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      classNames[_key2] = arguments[_key2];
    }

    return merge(classnames(classNames));
  }

  function hydrateSingleId(id) {
    caches.inserted[id] = true;
  }

  function hydrate(ids) {
    ids.forEach(hydrateSingleId);
  }

  function flush() {
    if (isBrowser) {
      sheet.flush();
      sheet.inject();
    }

    caches.inserted = {};
    caches.registered = {};
  }

  if (isBrowser) {
    var chunks = document.querySelectorAll("[data-emotion-" + key + "]");
    Array.prototype.forEach.call(chunks, function (node) {
      // $FlowFixMe
      sheet.tags[0].parentNode.insertBefore(node, sheet.tags[0]); // $FlowFixMe

      node.getAttribute("data-emotion-" + key).split(' ').forEach(hydrateSingleId);
    });
  }

  var emotion = {
    flush: flush,
    hydrate: hydrate,
    cx: cx,
    merge: merge,
    getRegisteredStyles: getRegisteredStyles,
    injectGlobal: injectGlobal,
    keyframes: keyframes,
    css: css,
    sheet: sheet,
    caches: caches
  };
  context.__SECRET_EMOTION__ = emotion;
  return emotion;
}

/* harmony default export */ __webpack_exports__["a"] = (createEmotion);
//# sourceMappingURL=index.esm.js.map


/***/ }),
/* 592 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function memoize(fn) {
  var cache = {};
  return function (arg) {
    if (cache[arg] === undefined) cache[arg] = fn(arg);
    return cache[arg];
  };
}

/* harmony default export */ __webpack_exports__["a"] = (memoize);
//# sourceMappingURL=memoize.esm.js.map


/***/ }),
/* 593 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var unitlessKeys = {
  animationIterationCount: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  // SVG-related properties
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
};

/* harmony default export */ __webpack_exports__["a"] = (unitlessKeys);


/***/ }),
/* 594 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* eslint-disable */
// murmurhash2 via https://github.com/garycourt/murmurhash-js/blob/master/murmurhash2_gc.js
function murmurhash2_32_gc(str) {
  var l = str.length,
      h = l ^ l,
      i = 0,
      k;

  while (l >= 4) {
    k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
    k = (k & 0xffff) * 0x5bd1e995 + (((k >>> 16) * 0x5bd1e995 & 0xffff) << 16);
    k ^= k >>> 24;
    k = (k & 0xffff) * 0x5bd1e995 + (((k >>> 16) * 0x5bd1e995 & 0xffff) << 16);
    h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16) ^ k;
    l -= 4;
    ++i;
  }

  switch (l) {
    case 3:
      h ^= (str.charCodeAt(i + 2) & 0xff) << 16;

    case 2:
      h ^= (str.charCodeAt(i + 1) & 0xff) << 8;

    case 1:
      h ^= str.charCodeAt(i) & 0xff;
      h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16);
  }

  h ^= h >>> 13;
  h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16);
  h ^= h >>> 15;
  return (h >>> 0).toString(36);
}

/* harmony default export */ __webpack_exports__["a"] = (murmurhash2_32_gc);
//# sourceMappingURL=hash.esm.js.map


/***/ }),
/* 595 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var W = function da(X) {
  function M(d, c, e, h, a) {
    for (var m = 0, b = 0, v = 0, n = 0, q, g, x = 0, J = 0, k, u = k = q = 0, l = 0, r = 0, z = 0, t = 0, K = e.length, I = K - 1, y, f = '', p = '', F = '', G = '', C; l < K;) {
      g = e.charCodeAt(l);
      l === I && 0 !== b + n + v + m && (0 !== b && (g = 47 === b ? 10 : 47), n = v = m = 0, K++, I++);

      if (0 === b + n + v + m) {
        if (l === I && (0 < r && (f = f.replace(N, '')), 0 < f.trim().length)) {
          switch (g) {
            case 32:
            case 9:
            case 59:
            case 13:
            case 10:
              break;

            default:
              f += e.charAt(l);
          }

          g = 59;
        }

        switch (g) {
          case 123:
            f = f.trim();
            q = f.charCodeAt(0);
            k = 1;

            for (t = ++l; l < K;) {
              switch (g = e.charCodeAt(l)) {
                case 123:
                  k++;
                  break;

                case 125:
                  k--;
                  break;

                case 47:
                  switch (g = e.charCodeAt(l + 1)) {
                    case 42:
                    case 47:
                      a: {
                        for (u = l + 1; u < I; ++u) {
                          switch (e.charCodeAt(u)) {
                            case 47:
                              if (42 === g && 42 === e.charCodeAt(u - 1) && l + 2 !== u) {
                                l = u + 1;
                                break a;
                              }

                              break;

                            case 10:
                              if (47 === g) {
                                l = u + 1;
                                break a;
                              }

                          }
                        }

                        l = u;
                      }

                  }

                  break;

                case 91:
                  g++;

                case 40:
                  g++;

                case 34:
                case 39:
                  for (; l++ < I && e.charCodeAt(l) !== g;) {
                  }

              }

              if (0 === k) break;
              l++;
            }

            k = e.substring(t, l);
            0 === q && (q = (f = f.replace(ea, '').trim()).charCodeAt(0));

            switch (q) {
              case 64:
                0 < r && (f = f.replace(N, ''));
                g = f.charCodeAt(1);

                switch (g) {
                  case 100:
                  case 109:
                  case 115:
                  case 45:
                    r = c;
                    break;

                  default:
                    r = O;
                }

                k = M(c, r, k, g, a + 1);
                t = k.length;
                0 < B && (r = Y(O, f, z), C = H(3, k, r, c, D, A, t, g, a, h), f = r.join(''), void 0 !== C && 0 === (t = (k = C.trim()).length) && (g = 0, k = ''));
                if (0 < t) switch (g) {
                  case 115:
                    f = f.replace(fa, ha);

                  case 100:
                  case 109:
                  case 45:
                    k = f + '{' + k + '}';
                    break;

                  case 107:
                    f = f.replace(ia, '$1 $2');
                    k = f + '{' + k + '}';
                    k = 1 === w || 2 === w && L('@' + k, 3) ? '@-webkit-' + k + '@' + k : '@' + k;
                    break;

                  default:
                    k = f + k, 112 === h && (k = (p += k, ''));
                } else k = '';
                break;

              default:
                k = M(c, Y(c, f, z), k, h, a + 1);
            }

            F += k;
            k = z = r = u = q = 0;
            f = '';
            g = e.charCodeAt(++l);
            break;

          case 125:
          case 59:
            f = (0 < r ? f.replace(N, '') : f).trim();
            if (1 < (t = f.length)) switch (0 === u && (q = f.charCodeAt(0), 45 === q || 96 < q && 123 > q) && (t = (f = f.replace(' ', ':')).length), 0 < B && void 0 !== (C = H(1, f, c, d, D, A, p.length, h, a, h)) && 0 === (t = (f = C.trim()).length) && (f = '\x00\x00'), q = f.charCodeAt(0), g = f.charCodeAt(1), q) {
              case 0:
                break;

              case 64:
                if (105 === g || 99 === g) {
                  G += f + e.charAt(l);
                  break;
                }

              default:
                58 !== f.charCodeAt(t - 1) && (p += P(f, q, g, f.charCodeAt(2)));
            }
            z = r = u = q = 0;
            f = '';
            g = e.charCodeAt(++l);
        }
      }

      switch (g) {
        case 13:
        case 10:
          47 === b ? b = 0 : 0 === 1 + q && 107 !== h && 0 < f.length && (r = 1, f += '\x00');
          0 < B * Z && H(0, f, c, d, D, A, p.length, h, a, h);
          A = 1;
          D++;
          break;

        case 59:
        case 125:
          if (0 === b + n + v + m) {
            A++;
            break;
          }

        default:
          A++;
          y = e.charAt(l);

          switch (g) {
            case 9:
            case 32:
              if (0 === n + m + b) switch (x) {
                case 44:
                case 58:
                case 9:
                case 32:
                  y = '';
                  break;

                default:
                  32 !== g && (y = ' ');
              }
              break;

            case 0:
              y = '\\0';
              break;

            case 12:
              y = '\\f';
              break;

            case 11:
              y = '\\v';
              break;

            case 38:
              0 === n + b + m && (r = z = 1, y = '\f' + y);
              break;

            case 108:
              if (0 === n + b + m + E && 0 < u) switch (l - u) {
                case 2:
                  112 === x && 58 === e.charCodeAt(l - 3) && (E = x);

                case 8:
                  111 === J && (E = J);
              }
              break;

            case 58:
              0 === n + b + m && (u = l);
              break;

            case 44:
              0 === b + v + n + m && (r = 1, y += '\r');
              break;

            case 34:
            case 39:
              0 === b && (n = n === g ? 0 : 0 === n ? g : n);
              break;

            case 91:
              0 === n + b + v && m++;
              break;

            case 93:
              0 === n + b + v && m--;
              break;

            case 41:
              0 === n + b + m && v--;
              break;

            case 40:
              if (0 === n + b + m) {
                if (0 === q) switch (2 * x + 3 * J) {
                  case 533:
                    break;

                  default:
                    q = 1;
                }
                v++;
              }

              break;

            case 64:
              0 === b + v + n + m + u + k && (k = 1);
              break;

            case 42:
            case 47:
              if (!(0 < n + m + v)) switch (b) {
                case 0:
                  switch (2 * g + 3 * e.charCodeAt(l + 1)) {
                    case 235:
                      b = 47;
                      break;

                    case 220:
                      t = l, b = 42;
                  }

                  break;

                case 42:
                  47 === g && 42 === x && t + 2 !== l && (33 === e.charCodeAt(t + 2) && (p += e.substring(t, l + 1)), y = '', b = 0);
              }
          }

          0 === b && (f += y);
      }

      J = x;
      x = g;
      l++;
    }

    t = p.length;

    if (0 < t) {
      r = c;
      if (0 < B && (C = H(2, p, r, d, D, A, t, h, a, h), void 0 !== C && 0 === (p = C).length)) return G + p + F;
      p = r.join(',') + '{' + p + '}';

      if (0 !== w * E) {
        2 !== w || L(p, 2) || (E = 0);

        switch (E) {
          case 111:
            p = p.replace(ja, ':-moz-$1') + p;
            break;

          case 112:
            p = p.replace(Q, '::-webkit-input-$1') + p.replace(Q, '::-moz-$1') + p.replace(Q, ':-ms-input-$1') + p;
        }

        E = 0;
      }
    }

    return G + p + F;
  }

  function Y(d, c, e) {
    var h = c.trim().split(ka);
    c = h;
    var a = h.length,
        m = d.length;

    switch (m) {
      case 0:
      case 1:
        var b = 0;

        for (d = 0 === m ? '' : d[0] + ' '; b < a; ++b) {
          c[b] = aa(d, c[b], e, m).trim();
        }

        break;

      default:
        var v = b = 0;

        for (c = []; b < a; ++b) {
          for (var n = 0; n < m; ++n) {
            c[v++] = aa(d[n] + ' ', h[b], e, m).trim();
          }
        }

    }

    return c;
  }

  function aa(d, c, e) {
    var h = c.charCodeAt(0);
    33 > h && (h = (c = c.trim()).charCodeAt(0));

    switch (h) {
      case 38:
        return c.replace(F, '$1' + d.trim());

      case 58:
        return d.trim() + c.replace(F, '$1' + d.trim());

      default:
        if (0 < 1 * e && 0 < c.indexOf('\f')) return c.replace(F, (58 === d.charCodeAt(0) ? '' : '$1') + d.trim());
    }

    return d + c;
  }

  function P(d, c, e, h) {
    var a = d + ';',
        m = 2 * c + 3 * e + 4 * h;

    if (944 === m) {
      d = a.indexOf(':', 9) + 1;
      var b = a.substring(d, a.length - 1).trim();
      b = a.substring(0, d).trim() + b + ';';
      return 1 === w || 2 === w && L(b, 1) ? '-webkit-' + b + b : b;
    }

    if (0 === w || 2 === w && !L(a, 1)) return a;

    switch (m) {
      case 1015:
        return 97 === a.charCodeAt(10) ? '-webkit-' + a + a : a;

      case 951:
        return 116 === a.charCodeAt(3) ? '-webkit-' + a + a : a;

      case 963:
        return 110 === a.charCodeAt(5) ? '-webkit-' + a + a : a;

      case 1009:
        if (100 !== a.charCodeAt(4)) break;

      case 969:
      case 942:
        return '-webkit-' + a + a;

      case 978:
        return '-webkit-' + a + '-moz-' + a + a;

      case 1019:
      case 983:
        return '-webkit-' + a + '-moz-' + a + '-ms-' + a + a;

      case 883:
        if (45 === a.charCodeAt(8)) return '-webkit-' + a + a;
        if (0 < a.indexOf('image-set(', 11)) return a.replace(la, '$1-webkit-$2') + a;
        break;

      case 932:
        if (45 === a.charCodeAt(4)) switch (a.charCodeAt(5)) {
          case 103:
            return '-webkit-box-' + a.replace('-grow', '') + '-webkit-' + a + '-ms-' + a.replace('grow', 'positive') + a;

          case 115:
            return '-webkit-' + a + '-ms-' + a.replace('shrink', 'negative') + a;

          case 98:
            return '-webkit-' + a + '-ms-' + a.replace('basis', 'preferred-size') + a;
        }
        return '-webkit-' + a + '-ms-' + a + a;

      case 964:
        return '-webkit-' + a + '-ms-flex-' + a + a;

      case 1023:
        if (99 !== a.charCodeAt(8)) break;
        b = a.substring(a.indexOf(':', 15)).replace('flex-', '').replace('space-between', 'justify');
        return '-webkit-box-pack' + b + '-webkit-' + a + '-ms-flex-pack' + b + a;

      case 1005:
        return ma.test(a) ? a.replace(ba, ':-webkit-') + a.replace(ba, ':-moz-') + a : a;

      case 1e3:
        b = a.substring(13).trim();
        c = b.indexOf('-') + 1;

        switch (b.charCodeAt(0) + b.charCodeAt(c)) {
          case 226:
            b = a.replace(G, 'tb');
            break;

          case 232:
            b = a.replace(G, 'tb-rl');
            break;

          case 220:
            b = a.replace(G, 'lr');
            break;

          default:
            return a;
        }

        return '-webkit-' + a + '-ms-' + b + a;

      case 1017:
        if (-1 === a.indexOf('sticky', 9)) break;

      case 975:
        c = (a = d).length - 10;
        b = (33 === a.charCodeAt(c) ? a.substring(0, c) : a).substring(d.indexOf(':', 7) + 1).trim();

        switch (m = b.charCodeAt(0) + (b.charCodeAt(7) | 0)) {
          case 203:
            if (111 > b.charCodeAt(8)) break;

          case 115:
            a = a.replace(b, '-webkit-' + b) + ';' + a;
            break;

          case 207:
          case 102:
            a = a.replace(b, '-webkit-' + (102 < m ? 'inline-' : '') + 'box') + ';' + a.replace(b, '-webkit-' + b) + ';' + a.replace(b, '-ms-' + b + 'box') + ';' + a;
        }

        return a + ';';

      case 938:
        if (45 === a.charCodeAt(5)) switch (a.charCodeAt(6)) {
          case 105:
            return b = a.replace('-items', ''), '-webkit-' + a + '-webkit-box-' + b + '-ms-flex-' + b + a;

          case 115:
            return '-webkit-' + a + '-ms-flex-item-' + a.replace(ca, '') + a;

          default:
            return '-webkit-' + a + '-ms-flex-line-pack' + a.replace('align-content', '').replace(ca, '') + a;
        }
        break;

      case 973:
      case 989:
        if (45 !== a.charCodeAt(3) || 122 === a.charCodeAt(4)) break;

      case 931:
      case 953:
        if (!0 === na.test(d)) return 115 === (b = d.substring(d.indexOf(':') + 1)).charCodeAt(0) ? P(d.replace('stretch', 'fill-available'), c, e, h).replace(':fill-available', ':stretch') : a.replace(b, '-webkit-' + b) + a.replace(b, '-moz-' + b.replace('fill-', '')) + a;
        break;

      case 962:
        if (a = '-webkit-' + a + (102 === a.charCodeAt(5) ? '-ms-' + a : '') + a, 211 === e + h && 105 === a.charCodeAt(13) && 0 < a.indexOf('transform', 10)) return a.substring(0, a.indexOf(';', 27) + 1).replace(oa, '$1-webkit-$2') + a;
    }

    return a;
  }

  function L(d, c) {
    var e = d.indexOf(1 === c ? ':' : '{'),
        h = d.substring(0, 3 !== c ? e : 10);
    e = d.substring(e + 1, d.length - 1);
    return R(2 !== c ? h : h.replace(pa, '$1'), e, c);
  }

  function ha(d, c) {
    var e = P(c, c.charCodeAt(0), c.charCodeAt(1), c.charCodeAt(2));
    return e !== c + ';' ? e.replace(qa, ' or ($1)').substring(4) : '(' + c + ')';
  }

  function H(d, c, e, h, a, m, b, v, n, q) {
    for (var g = 0, x = c, w; g < B; ++g) {
      switch (w = S[g].call(z, d, x, e, h, a, m, b, v, n, q)) {
        case void 0:
        case !1:
        case !0:
        case null:
          break;

        default:
          x = w;
      }
    }

    if (x !== c) return x;
  }

  function T(d) {
    switch (d) {
      case void 0:
      case null:
        B = S.length = 0;
        break;

      default:
        switch (d.constructor) {
          case Array:
            for (var c = 0, e = d.length; c < e; ++c) {
              T(d[c]);
            }

            break;

          case Function:
            S[B++] = d;
            break;

          case Boolean:
            Z = !!d | 0;
        }

    }

    return T;
  }

  function U(d) {
    d = d.prefix;
    void 0 !== d && (R = null, d ? 'function' !== typeof d ? w = 1 : (w = 2, R = d) : w = 0);
    return U;
  }

  function z(d, c) {
    if (void 0 !== this && this.constructor === z) return da(d);
    var e = d;
    33 > e.charCodeAt(0) && (e = e.trim());
    V = e;
    e = [V];

    if (0 < B) {
      var h = H(-1, c, e, e, D, A, 0, 0, 0, 0);
      void 0 !== h && 'string' === typeof h && (c = h);
    }

    var a = M(O, e, c, 0, 0);
    0 < B && (h = H(-2, a, e, e, D, A, a.length, 0, 0, 0), void 0 !== h && (a = h));
    V = '';
    E = 0;
    A = D = 1;
    return a;
  }

  var ea = /^\0+/g,
      N = /[\0\r\f]/g,
      ba = /: */g,
      ma = /zoo|gra/,
      oa = /([,: ])(transform)/g,
      ka = /,\r+?/g,
      F = /([\t\r\n ])*\f?&/g,
      ia = /@(k\w+)\s*(\S*)\s*/,
      Q = /::(place)/g,
      ja = /:(read-only)/g,
      G = /[svh]\w+-[tblr]{2}/,
      fa = /\(\s*(.*)\s*\)/g,
      qa = /([\s\S]*?);/g,
      ca = /-self|flex-/g,
      pa = /[^]*?(:[rp][el]a[\w-]+)[^]*/,
      na = /stretch|:\s*\w+\-(?:conte|avail)/,
      la = /([^-])(image-set\()/,
      A = 1,
      D = 1,
      E = 0,
      w = 1,
      O = [],
      S = [],
      B = 0,
      R = null,
      Z = 0,
      V = '';
  z.use = T;
  z.set = U;
  void 0 !== X && U(X);
  return z;
};

/* harmony default export */ __webpack_exports__["a"] = (W);
//# sourceMappingURL=stylis.esm.js.map


/***/ }),
/* 596 */
/***/ (function(module, exports, __webpack_require__) {

(function (factory) {
	 true ? (module['exports'] = factory()) :
		typeof define === 'function' && define['amd'] ? define(factory()) :
			(window['stylisRuleSheet'] = factory())
}(function () {

	'use strict'

	return function (insertRule) {
		var delimiter = '/*|*/'
		var needle = delimiter+'}'

		function toSheet (block) {
			if (block)
				try {
					insertRule(block + '}')
				} catch (e) {}
		}

		return function ruleSheet (context, content, selectors, parents, line, column, length, ns, depth, at) {
			switch (context) {
				// property
				case 1:
					// @import
					if (depth === 0 && content.charCodeAt(0) === 64)
						return insertRule(content+';'), ''
					break
				// selector
				case 2:
					if (ns === 0)
						return content + delimiter
					break
				// at-rule
				case 3:
					switch (ns) {
						// @font-face, @page
						case 102:
						case 112:
							return insertRule(selectors[0]+content), ''
						default:
							return content + (at === 0 ? delimiter : '')
					}
				case -2:
					content.split(needle).forEach(toSheet)
			}
		}
	}
}))


/***/ }),
/* 597 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {// Generated by CoffeeScript 1.12.2
(function() {
  var getNanoSeconds, hrtime, loadTime, moduleLoadTime, nodeLoadTime, upTime;

  if ((typeof performance !== "undefined" && performance !== null) && performance.now) {
    module.exports = function() {
      return performance.now();
    };
  } else if ((typeof process !== "undefined" && process !== null) && process.hrtime) {
    module.exports = function() {
      return (getNanoSeconds() - nodeLoadTime) / 1e6;
    };
    hrtime = process.hrtime;
    getNanoSeconds = function() {
      var hr;
      hr = hrtime();
      return hr[0] * 1e9 + hr[1];
    };
    moduleLoadTime = getNanoSeconds();
    upTime = process.uptime() * 1e9;
    nodeLoadTime = moduleLoadTime - upTime;
  } else if (Date.now) {
    module.exports = function() {
      return Date.now() - loadTime;
    };
    loadTime = Date.now();
  } else {
    module.exports = function() {
      return new Date().getTime() - loadTime;
    };
    loadTime = new Date().getTime();
  }

}).call(this);

//# sourceMappingURL=performance-now.js.map

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(251)))

/***/ }),
/* 598 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _propTypes = __webpack_require__(1);

var PropTypes = _interopRequireWildcard(_propTypes);

var _addClass = __webpack_require__(599);

var _addClass2 = _interopRequireDefault(_addClass);

var _removeClass = __webpack_require__(601);

var _removeClass2 = _interopRequireDefault(_removeClass);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Transition = __webpack_require__(62);

var _Transition2 = _interopRequireDefault(_Transition);

var _PropTypes = __webpack_require__(245);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var addClass = function addClass(node, classes) {
  return node && classes && classes.split(' ').forEach(function (c) {
    return (0, _addClass2.default)(node, c);
  });
};
var removeClass = function removeClass(node, classes) {
  return node && classes && classes.split(' ').forEach(function (c) {
    return (0, _removeClass2.default)(node, c);
  });
};

var propTypes = _extends({}, _Transition2.default.propTypes, {

  /**
   * The animation classNames applied to the component as it enters, exits or has finished the transition.
   * A single name can be provided and it will be suffixed for each stage: e.g.
   *
   * `classNames="fade"` applies `fade-enter`, `fade-enter-active`, `fade-enter-done`,
   * `fade-exit`, `fade-exit-active`, `fade-exit-done`, `fade-appear`, and `fade-appear-active`.
   * Each individual classNames can also be specified independently like:
   *
   * ```js
   * classNames={{
   *  appear: 'my-appear',
   *  appearActive: 'my-active-appear',
   *  enter: 'my-enter',
   *  enterActive: 'my-active-enter',
   *  enterDone: 'my-done-enter',
   *  exit: 'my-exit',
   *  exitActive: 'my-active-exit',
   *  exitDone: 'my-done-exit',
   * }}
   * ```
   *
   * If you want to set these classes using CSS Modules:
   *
   * ```js
   * import styles from './styles.css';
   * ```
   *
   * you might want to use camelCase in your CSS file, that way could simply spread
   * them instead of listing them one by one:
   *
   * ```js
   * classNames={{ ...styles }}
   * ```
   *
   * @type {string | {
   *  appear?: string,
   *  appearActive?: string,
   *  enter?: string,
   *  enterActive?: string,
   *  enterDone?: string,
   *  exit?: string,
   *  exitActive?: string,
   *  exitDone?: string,
   * }}
   */
  classNames: _PropTypes.classNamesShape,

  /**
   * A `<Transition>` callback fired immediately after the 'enter' or 'appear' class is
   * applied.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEnter: PropTypes.func,

  /**
   * A `<Transition>` callback fired immediately after the 'enter-active' or
   * 'appear-active' class is applied.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntering: PropTypes.func,

  /**
   * A `<Transition>` callback fired immediately after the 'enter' or
   * 'appear' classes are **removed** and the `done` class is added to the DOM node.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntered: PropTypes.func,

  /**
   * A `<Transition>` callback fired immediately after the 'exit' class is
   * applied.
   *
   * @type Function(node: HtmlElement)
   */
  onExit: PropTypes.func,

  /**
   * A `<Transition>` callback fired immediately after the 'exit-active' is applied.
   *
   * @type Function(node: HtmlElement
   */
  onExiting: PropTypes.func,

  /**
   * A `<Transition>` callback fired immediately after the 'exit' classes
   * are **removed** and the `exit-done` class is added to the DOM node.
   *
   * @type Function(node: HtmlElement)
   */
  onExited: PropTypes.func
});

/**
 * A `Transition` component using CSS transitions and animations.
 * It's inspired by the excellent [ng-animate](http://www.nganimate.org/) library.
 *
 * `CSSTransition` applies a pair of class names during the `appear`, `enter`,
 * and `exit` stages of the transition. The first class is applied and then a
 * second "active" class in order to activate the css animation. After the animation,
 * matching `done` class names are applied to persist the animation state.
 *
 * When the `in` prop is toggled to `true` the Component will get
 * the `example-enter` CSS class and the `example-enter-active` CSS class
 * added in the next tick. This is a convention based on the `classNames` prop.
 *
 * ## Example
 *
 * <iframe src="https://codesandbox.io/embed/m77l2vp00x?fontsize=14" style="width:100%; height:500px; border:0; border-radius: 4px; overflow:hidden;" sandbox="allow-modals allow-forms allow-popups allow-scripts allow-same-origin"></iframe>
 */

var CSSTransition = function (_React$Component) {
  _inherits(CSSTransition, _React$Component);

  function CSSTransition() {
    var _temp, _this, _ret;

    _classCallCheck(this, CSSTransition);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.onEnter = function (node, appearing) {
      var _this$getClassNames = _this.getClassNames(appearing ? 'appear' : 'enter'),
          className = _this$getClassNames.className;

      _this.removeClasses(node, 'exit');
      addClass(node, className);

      if (_this.props.onEnter) {
        _this.props.onEnter(node);
      }
    }, _this.onEntering = function (node, appearing) {
      var _this$getClassNames2 = _this.getClassNames(appearing ? 'appear' : 'enter'),
          activeClassName = _this$getClassNames2.activeClassName;

      _this.reflowAndAddClass(node, activeClassName);

      if (_this.props.onEntering) {
        _this.props.onEntering(node);
      }
    }, _this.onEntered = function (node, appearing) {
      var _this$getClassNames3 = _this.getClassNames('enter'),
          doneClassName = _this$getClassNames3.doneClassName;

      _this.removeClasses(node, appearing ? 'appear' : 'enter');
      addClass(node, doneClassName);

      if (_this.props.onEntered) {
        _this.props.onEntered(node);
      }
    }, _this.onExit = function (node) {
      var _this$getClassNames4 = _this.getClassNames('exit'),
          className = _this$getClassNames4.className;

      _this.removeClasses(node, 'appear');
      _this.removeClasses(node, 'enter');
      addClass(node, className);

      if (_this.props.onExit) {
        _this.props.onExit(node);
      }
    }, _this.onExiting = function (node) {
      var _this$getClassNames5 = _this.getClassNames('exit'),
          activeClassName = _this$getClassNames5.activeClassName;

      _this.reflowAndAddClass(node, activeClassName);

      if (_this.props.onExiting) {
        _this.props.onExiting(node);
      }
    }, _this.onExited = function (node) {
      var _this$getClassNames6 = _this.getClassNames('exit'),
          doneClassName = _this$getClassNames6.doneClassName;

      _this.removeClasses(node, 'exit');
      addClass(node, doneClassName);

      if (_this.props.onExited) {
        _this.props.onExited(node);
      }
    }, _this.getClassNames = function (type) {
      var classNames = _this.props.classNames;


      var className = typeof classNames !== 'string' ? classNames[type] : classNames + '-' + type;

      var activeClassName = typeof classNames !== 'string' ? classNames[type + 'Active'] : className + '-active';

      var doneClassName = typeof classNames !== 'string' ? classNames[type + 'Done'] : className + '-done';

      return {
        className: className,
        activeClassName: activeClassName,
        doneClassName: doneClassName
      };
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  CSSTransition.prototype.removeClasses = function removeClasses(node, type) {
    var _getClassNames = this.getClassNames(type),
        className = _getClassNames.className,
        activeClassName = _getClassNames.activeClassName,
        doneClassName = _getClassNames.doneClassName;

    className && removeClass(node, className);
    activeClassName && removeClass(node, activeClassName);
    doneClassName && removeClass(node, doneClassName);
  };

  CSSTransition.prototype.reflowAndAddClass = function reflowAndAddClass(node, className) {
    // This is for to force a repaint,
    // which is necessary in order to transition styles when adding a class name.
    if (className) {
      /* eslint-disable no-unused-expressions */
      node && node.scrollTop;
      /* eslint-enable no-unused-expressions */
      addClass(node, className);
    }
  };

  CSSTransition.prototype.render = function render() {
    var props = _extends({}, this.props);

    delete props.classNames;

    return _react2.default.createElement(_Transition2.default, _extends({}, props, {
      onEnter: this.onEnter,
      onEntered: this.onEntered,
      onEntering: this.onEntering,
      onExit: this.onExit,
      onExiting: this.onExiting,
      onExited: this.onExited
    }));
  };

  return CSSTransition;
}(_react2.default.Component);

CSSTransition.propTypes =  false ? propTypes : {};

exports.default = CSSTransition;
module.exports = exports['default'];

/***/ }),
/* 599 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = addClass;

var _hasClass = __webpack_require__(600);

var _hasClass2 = _interopRequireDefault(_hasClass);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function addClass(element, className) {
  if (element.classList) element.classList.add(className);else if (!(0, _hasClass2.default)(element, className)) if (typeof element.className === 'string') element.className = element.className + ' ' + className;else element.setAttribute('class', (element.className && element.className.baseVal || '') + ' ' + className);
}
module.exports = exports['default'];

/***/ }),
/* 600 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = hasClass;
function hasClass(element, className) {
  if (element.classList) return !!className && element.classList.contains(className);else return (" " + (element.className.baseVal || element.className) + " ").indexOf(" " + className + " ") !== -1;
}
module.exports = exports["default"];

/***/ }),
/* 601 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function replaceClassName(origClass, classToRemove) {
  return origClass.replace(new RegExp('(^|\\s)' + classToRemove + '(?:\\s|$)', 'g'), '$1').replace(/\s+/g, ' ').replace(/^\s*|\s*$/g, '');
}

module.exports = function removeClass(element, className) {
  if (element.classList) element.classList.remove(className);else if (typeof element.className === 'string') element.className = replaceClassName(element.className, className);else element.setAttribute('class', replaceClassName(element.className && element.className.baseVal || '', className));
};

/***/ }),
/* 602 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(24);

var _TransitionGroup = __webpack_require__(174);

var _TransitionGroup2 = _interopRequireDefault(_TransitionGroup);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var propTypes = {
  in: _propTypes2.default.bool.isRequired,
  children: function children(props, propName) {
    if (_react2.default.Children.count(props[propName]) !== 2) return new Error('"' + propName + '" must be exactly two transition components.');

    return null;
  }
};

/**
 * The `<ReplaceTransition>` component is a specialized `Transition` component
 * that animates between two children.
 *
 * ```jsx
 * <ReplaceTransition in>
 *   <Fade><div>I appear first</div></Fade>
 *   <Fade><div>I replace the above</div></Fade>
 * </ReplaceTransition>
 * ```
 */

var ReplaceTransition = function (_React$Component) {
  _inherits(ReplaceTransition, _React$Component);

  function ReplaceTransition() {
    var _temp, _this, _ret;

    _classCallCheck(this, ReplaceTransition);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _initialiseProps.call(_this), _temp), _possibleConstructorReturn(_this, _ret);
  }

  ReplaceTransition.prototype.handleLifecycle = function handleLifecycle(handler, idx, originalArgs) {
    var _child$props;

    var children = this.props.children;

    var child = _react2.default.Children.toArray(children)[idx];

    if (child.props[handler]) (_child$props = child.props)[handler].apply(_child$props, originalArgs);
    if (this.props[handler]) this.props[handler]((0, _reactDom.findDOMNode)(this));
  };

  ReplaceTransition.prototype.render = function render() {
    var _props = this.props,
        children = _props.children,
        inProp = _props.in,
        props = _objectWithoutProperties(_props, ['children', 'in']);

    var _React$Children$toArr = _react2.default.Children.toArray(children),
        first = _React$Children$toArr[0],
        second = _React$Children$toArr[1];

    delete props.onEnter;
    delete props.onEntering;
    delete props.onEntered;
    delete props.onExit;
    delete props.onExiting;
    delete props.onExited;

    return _react2.default.createElement(
      _TransitionGroup2.default,
      props,
      inProp ? _react2.default.cloneElement(first, {
        key: 'first',
        onEnter: this.handleEnter,
        onEntering: this.handleEntering,
        onEntered: this.handleEntered

      }) : _react2.default.cloneElement(second, {
        key: 'second',
        onEnter: this.handleExit,
        onEntering: this.handleExiting,
        onEntered: this.handleExited
      })
    );
  };

  return ReplaceTransition;
}(_react2.default.Component);

var _initialiseProps = function _initialiseProps() {
  var _this2 = this;

  this.handleEnter = function () {
    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    return _this2.handleLifecycle('onEnter', 0, args);
  };

  this.handleEntering = function () {
    for (var _len3 = arguments.length, args = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      args[_key3] = arguments[_key3];
    }

    return _this2.handleLifecycle('onEntering', 0, args);
  };

  this.handleEntered = function () {
    for (var _len4 = arguments.length, args = Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
      args[_key4] = arguments[_key4];
    }

    return _this2.handleLifecycle('onEntered', 0, args);
  };

  this.handleExit = function () {
    for (var _len5 = arguments.length, args = Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
      args[_key5] = arguments[_key5];
    }

    return _this2.handleLifecycle('onExit', 1, args);
  };

  this.handleExiting = function () {
    for (var _len6 = arguments.length, args = Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
      args[_key6] = arguments[_key6];
    }

    return _this2.handleLifecycle('onExiting', 1, args);
  };

  this.handleExited = function () {
    for (var _len7 = arguments.length, args = Array(_len7), _key7 = 0; _key7 < _len7; _key7++) {
      args[_key7] = arguments[_key7];
    }

    return _this2.handleLifecycle('onExited', 1, args);
  };
};

ReplaceTransition.propTypes =  false ? propTypes : {};

exports.default = ReplaceTransition;
module.exports = exports['default'];

/***/ }),
/* 603 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defaultComponents = exports.components = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

__webpack_require__(0);

var _containers = __webpack_require__(270);

var _indicators = __webpack_require__(271);

var _Control = __webpack_require__(604);

var _Control2 = _interopRequireDefault(_Control);

var _Group = __webpack_require__(605);

var _Group2 = _interopRequireDefault(_Group);

var _Input = __webpack_require__(273);

var _Input2 = _interopRequireDefault(_Input);

var _Menu = __webpack_require__(606);

var _Menu2 = _interopRequireDefault(_Menu);

var _MultiValue = __webpack_require__(274);

var _MultiValue2 = _interopRequireDefault(_MultiValue);

var _Option = __webpack_require__(609);

var _Option2 = _interopRequireDefault(_Option);

var _Placeholder = __webpack_require__(275);

var _Placeholder2 = _interopRequireDefault(_Placeholder);

var _SingleValue = __webpack_require__(276);

var _SingleValue2 = _interopRequireDefault(_SingleValue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var components = exports.components = {
  ClearIndicator: _indicators.ClearIndicator,
  Control: _Control2.default,
  DropdownIndicator: _indicators.DropdownIndicator,
  DownChevron: _indicators.DownChevron,
  CrossIcon: _indicators.CrossIcon,
  Group: _Group2.default,
  GroupHeading: _Group.GroupHeading,
  IndicatorsContainer: _containers.IndicatorsContainer,
  IndicatorSeparator: _indicators.IndicatorSeparator,
  Input: _Input2.default,
  LoadingIndicator: _indicators.LoadingIndicator,
  Menu: _Menu2.default,
  MenuList: _Menu.MenuList,
  MenuPortal: _Menu.MenuPortal,
  LoadingMessage: _Menu.LoadingMessage,
  NoOptionsMessage: _Menu.NoOptionsMessage,
  MultiValue: _MultiValue2.default,
  MultiValueContainer: _MultiValue.MultiValueContainer,
  MultiValueLabel: _MultiValue.MultiValueLabel,
  MultiValueRemove: _MultiValue.MultiValueRemove,
  Option: _Option2.default,
  Placeholder: _Placeholder2.default,
  SelectContainer: _containers.SelectContainer,
  SingleValue: _SingleValue2.default,
  ValueContainer: _containers.ValueContainer
};

var defaultComponents = exports.defaultComponents = function defaultComponents(props) {
  return _extends({}, components, props.components);
};

/***/ }),
/* 604 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.css = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _emotion = __webpack_require__(41);

var _theme = __webpack_require__(45);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var css = exports.css = function css(_ref) {
  var isDisabled = _ref.isDisabled,
      isFocused = _ref.isFocused;
  return {
    alignItems: 'center',
    backgroundColor: isDisabled ? _theme.colors.neutral5 : isFocused ? _theme.colors.neutral0 : _theme.colors.neutral2,
    borderColor: isDisabled ? _theme.colors.neutral10 : isFocused ? _theme.colors.primary : _theme.colors.neutral20,
    borderRadius: _theme.borderRadius,
    borderStyle: 'solid',
    borderWidth: 1,
    boxShadow: isFocused ? '0 0 0 1px ' + _theme.colors.primary : null,
    cursor: 'default',
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-between',
    minHeight: _theme.spacing.controlHeight,
    outline: '0 !important',
    position: 'relative',
    transition: 'all 100ms',

    '&:hover': {
      borderColor: isFocused ? _theme.colors.primary : _theme.colors.neutral30
    }
  };
};

var Control = function Control(props) {
  var children = props.children,
      cx = props.cx,
      getStyles = props.getStyles,
      className = props.className,
      isDisabled = props.isDisabled,
      isFocused = props.isFocused,
      innerProps = props.innerProps;

  var innerRef = innerProps.innerRef,
      rest = _objectWithoutProperties(innerProps, ['innerRef']);

  return _react2.default.createElement(
    'div',
    _extends({
      ref: innerRef,
      className: cx( /*#__PURE__*/(0, _emotion.css)(getStyles('control', props)), {
        'control': true,
        'control--is-disabled': isDisabled,
        'control--is-focused': isFocused
      }, className)
    }, rest),
    children
  );
};

exports.default = Control;

/***/ }),
/* 605 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GroupHeading = exports.groupHeadingCSS = exports.groupCSS = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _emotion = __webpack_require__(41);

var _theme = __webpack_require__(45);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var groupCSS = exports.groupCSS = function groupCSS() {
  return {
    paddingBottom: _theme.spacing.baseUnit * 2,
    paddingTop: _theme.spacing.baseUnit * 2
  };
};

var Group = function Group(props) {
  var children = props.children,
      className = props.className,
      cx = props.cx,
      getStyles = props.getStyles,
      Heading = props.Heading,
      label = props.label;

  return _react2.default.createElement(
    'div',
    {
      className: cx( /*#__PURE__*/(0, _emotion.css)(getStyles('group', props)), { 'group': true }, className)
    },
    _react2.default.createElement(
      Heading,
      { getStyles: getStyles, cx: cx },
      label
    ),
    _react2.default.createElement(
      'div',
      null,
      children
    )
  );
};

var groupHeadingCSS = exports.groupHeadingCSS = function groupHeadingCSS() {
  return {
    color: '#999',
    cursor: 'default',
    display: 'block',
    fontSize: '75%',
    fontWeight: '500',
    marginBottom: '0.25em',
    paddingLeft: _theme.spacing.baseUnit * 3,
    paddingRight: _theme.spacing.baseUnit * 3,
    textTransform: 'uppercase'
  };
};

var GroupHeading = function GroupHeading(props) {
  var className = props.className,
      cx = props.cx,
      getStyles = props.getStyles,
      cleanProps = _objectWithoutProperties(props, ['className', 'cx', 'getStyles']);

  return _react2.default.createElement('div', _extends({
    className: cx( /*#__PURE__*/(0, _emotion.css)(getStyles('groupHeading', props)), { 'group-heading': true }, className)
  }, cleanProps));
};

exports.GroupHeading = GroupHeading;
exports.default = Group;

/***/ }),
/* 606 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MenuPortal = exports.menuPortalCSS = exports.LoadingMessage = exports.NoOptionsMessage = exports.loadingMessageCSS = exports.noOptionsMessageCSS = exports.MenuList = exports.menuListCSS = exports.Menu = exports.menuCSS = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.getMenuPlacement = getMenuPlacement;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _emotion = __webpack_require__(41);

var _reactDom = __webpack_require__(24);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _utils = __webpack_require__(607);

var _theme = __webpack_require__(45);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

// ==============================
// Menu
// ==============================

// Get Menu Placement
// ------------------------------

function getMenuPlacement(_ref) {
  var maxHeight = _ref.maxHeight,
      menuEl = _ref.menuEl,
      minHeight = _ref.minHeight,
      placement = _ref.placement,
      shouldScroll = _ref.shouldScroll,
      isFixedPosition = _ref.isFixedPosition;

  var scrollParent = (0, _utils.getScrollParent)(menuEl);
  var defaultState = { placement: 'bottom', maxHeight: maxHeight };

  // something went wrong, return default state
  if (!menuEl || !menuEl.offsetParent) return defaultState;

  // we can't trust `scrollParent.scrollHeight` --> it may increase when
  // the menu is rendered

  var _scrollParent$getBoun = scrollParent.getBoundingClientRect(),
      scrollHeight = _scrollParent$getBoun.height;

  var _menuEl$getBoundingCl = menuEl.getBoundingClientRect(),
      menuBottom = _menuEl$getBoundingCl.bottom,
      menuHeight = _menuEl$getBoundingCl.height,
      menuTop = _menuEl$getBoundingCl.top;

  // $FlowFixMe function returns above if there's no offsetParent


  var _menuEl$offsetParent$ = menuEl.offsetParent.getBoundingClientRect(),
      containerTop = _menuEl$offsetParent$.top;

  var viewHeight = window.innerHeight;
  var scrollTop = (0, _utils.getScrollTop)(scrollParent);
  var gutter = _theme.spacing.menuGutter;

  var viewSpaceAbove = containerTop - gutter;
  var viewSpaceBelow = viewHeight - menuTop;
  var scrollSpaceAbove = viewSpaceAbove + scrollTop;
  var scrollSpaceBelow = scrollHeight - scrollTop - menuTop;

  var scrollDown = menuBottom - viewHeight + scrollTop + gutter;
  var scrollUp = scrollTop + menuTop - gutter;
  var scrollDuration = 160;

  switch (placement) {
    case 'auto':
    case 'bottom':
      // 1: the menu will fit, do nothing
      if (viewSpaceBelow >= menuHeight) {
        return { placement: 'bottom', maxHeight: maxHeight };
      }

      // 2: the menu will fit, if scrolled
      if (scrollSpaceBelow >= menuHeight && !isFixedPosition) {
        if (shouldScroll) {
          (0, _utils.animatedScrollTo)(scrollParent, scrollDown, scrollDuration);
        }

        return { placement: 'bottom', maxHeight: maxHeight };
      }

      // 3: the menu will fit, if constrained
      if (!isFixedPosition && scrollSpaceBelow >= minHeight || isFixedPosition && viewSpaceBelow >= minHeight) {
        if (shouldScroll) {
          (0, _utils.animatedScrollTo)(scrollParent, scrollDown, scrollDuration);
        }

        // we want to provide as much of the menu as possible to the user,
        // so give them whatever is available below rather than the minHeight.
        var constrainedHeight = isFixedPosition ? viewSpaceBelow - gutter : scrollSpaceBelow - gutter;

        return {
          placement: 'bottom',
          maxHeight: constrainedHeight
        };
      }

      // 4. Forked beviour when there isn't enough space below

      // AUTO: flip the menu, render above
      if (placement === 'auto' || isFixedPosition) {
        // may need to be constrained after flipping
        var _constrainedHeight = maxHeight;

        if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) {
          _constrainedHeight = isFixedPosition ? viewSpaceAbove - gutter - _theme.spacing.controlHeight : scrollSpaceAbove - gutter - _theme.spacing.controlHeight;
        }

        return { placement: 'top', maxHeight: _constrainedHeight };
      }

      // BOTTOM: allow browser to increase scrollable area and immediately set scroll
      if (placement === 'bottom') {
        (0, _utils.scrollTo)(scrollParent, scrollDown);
        return { placement: 'bottom', maxHeight: maxHeight };
      }
      break;
    case 'top':
      // 1: the menu will fit, do nothing
      if (viewSpaceAbove >= menuHeight) {
        return { placement: 'top', maxHeight: maxHeight };
      }

      // 2: the menu will fit, if scrolled
      if (scrollSpaceAbove >= menuHeight && !isFixedPosition) {
        if (shouldScroll) {
          (0, _utils.animatedScrollTo)(scrollParent, scrollUp, scrollDuration);
        }

        return { placement: 'top', maxHeight: maxHeight };
      }

      // 3: the menu will fit, if constrained
      if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) {
        var _constrainedHeight2 = maxHeight;

        // we want to provide as much of the menu as possible to the user,
        // so give them whatever is available below rather than the minHeight.
        if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) {
          _constrainedHeight2 = isFixedPosition ? viewSpaceAbove - gutter : scrollSpaceAbove - gutter;
        }

        if (shouldScroll) {
          (0, _utils.animatedScrollTo)(scrollParent, scrollUp, scrollDuration);
        }

        return {
          placement: 'top',
          maxHeight: _constrainedHeight2
        };
      }

      // 4. not enough space, the browser WILL NOT increase scrollable area when
      // absolutely positioned element rendered above the viewport (only below).
      // Flip the menu, render below
      return { placement: 'bottom', maxHeight: maxHeight };
    default:
      throw new Error('Invalid placement provided "' + placement + '".');
  }

  // fulfil contract with flow: implicit return value of undefined
  return defaultState;
}

// Menu Component
// ------------------------------

function alignToControl(placement) {
  var placementToCSSProp = { bottom: 'top', top: 'bottom' };
  return placement ? placementToCSSProp[placement] : 'bottom';
}
var coercePlacement = function coercePlacement(p) {
  return p === 'auto' ? 'bottom' : p;
};

var menuCSS = exports.menuCSS = function menuCSS(_ref2) {
  var _ref3;

  var placement = _ref2.placement;
  return _ref3 = {}, _defineProperty(_ref3, alignToControl(placement), '100%'), _defineProperty(_ref3, 'backgroundColor', _theme.colors.neutral0), _defineProperty(_ref3, 'borderRadius', _theme.borderRadius), _defineProperty(_ref3, 'boxShadow', '0 0 0 1px ' + _theme.colors.neutral10a + ', 0 4px 11px ' + _theme.colors.neutral10a), _defineProperty(_ref3, 'marginBottom', _theme.spacing.menuGutter), _defineProperty(_ref3, 'marginTop', _theme.spacing.menuGutter), _defineProperty(_ref3, 'position', 'absolute'), _defineProperty(_ref3, 'width', '100%'), _defineProperty(_ref3, 'zIndex', 1), _ref3;
};

var Menu = exports.Menu = function (_Component) {
  _inherits(Menu, _Component);

  function Menu() {
    var _ref4;

    var _temp, _this, _ret;

    _classCallCheck(this, Menu);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref4 = Menu.__proto__ || Object.getPrototypeOf(Menu)).call.apply(_ref4, [this].concat(args))), _this), _this.state = {
      maxHeight: _this.props.maxMenuHeight,
      placement: null
    }, _this.getPlacement = function (ref) {
      var _this$props = _this.props,
          minMenuHeight = _this$props.minMenuHeight,
          maxMenuHeight = _this$props.maxMenuHeight,
          menuPlacement = _this$props.menuPlacement,
          menuPosition = _this$props.menuPosition,
          menuShouldScrollIntoView = _this$props.menuShouldScrollIntoView;
      var getPortalPlacement = _this.context.getPortalPlacement;


      if (!ref) return;

      // DO NOT scroll if position is fixed
      var isFixedPosition = menuPosition === 'fixed';
      var shouldScroll = menuShouldScrollIntoView && !isFixedPosition;

      var state = getMenuPlacement({
        maxHeight: maxMenuHeight,
        menuEl: ref,
        minHeight: minMenuHeight,
        placement: menuPlacement,
        shouldScroll: shouldScroll,
        isFixedPosition: isFixedPosition
      });

      if (getPortalPlacement) getPortalPlacement(state);

      _this.setState(state);
    }, _this.getState = function () {
      var menuPlacement = _this.props.menuPlacement;

      var placement = _this.state.placement || coercePlacement(menuPlacement);

      return _extends({}, _this.props, { placement: placement, maxHeight: _this.state.maxHeight });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Menu, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          children = _props.children,
          className = _props.className,
          cx = _props.cx,
          getStyles = _props.getStyles,
          innerProps = _props.innerProps;


      return _react2.default.createElement(
        'div',
        _extends({
          className: cx( /*#__PURE__*/(0, _emotion.css)(getStyles('menu', this.getState())), {
            'menu': true
          }, className),
          ref: this.getPlacement
        }, innerProps),
        children
      );
    }
  }]);

  return Menu;
}(_react.Component);

Menu.contextTypes = {
  getPortalPlacement: _propTypes2.default.func
};
exports.default = Menu;

// ==============================
// Menu List
// ==============================

var menuListCSS = exports.menuListCSS = function menuListCSS(_ref5) {
  var maxHeight = _ref5.maxHeight;
  return {
    maxHeight: maxHeight,
    overflowY: 'auto',
    paddingBottom: _theme.spacing.baseUnit,
    paddingTop: _theme.spacing.baseUnit,
    position: 'relative', // required for offset[Height, Top] > keyboard scroll
    WebkitOverflowScrolling: 'touch'
  };
};
var MenuList = exports.MenuList = function MenuList(props) {
  var children = props.children,
      className = props.className,
      cx = props.cx,
      getStyles = props.getStyles,
      isMulti = props.isMulti,
      innerProps = props.innerProps;
  var innerRef = innerProps.innerRef;

  return _react2.default.createElement(
    'div',
    {
      className: cx( /*#__PURE__*/(0, _emotion.css)(getStyles('menuList', props)), {
        'menu-list': true,
        'menu-list--is-multi': isMulti
      }, className),
      ref: innerRef
    },
    children
  );
};

// ==============================
// Menu Notices
// ==============================

var noticeCSS = function noticeCSS() {
  return {
    color: _theme.colors.neutral40,
    padding: _theme.spacing.baseUnit * 2 + 'px ' + _theme.spacing.baseUnit * 3 + 'px',
    textAlign: 'center'
  };
};
var noOptionsMessageCSS = exports.noOptionsMessageCSS = noticeCSS;
var loadingMessageCSS = exports.loadingMessageCSS = noticeCSS;

var NoOptionsMessage = exports.NoOptionsMessage = function NoOptionsMessage(props) {
  var children = props.children,
      className = props.className,
      cx = props.cx,
      getStyles = props.getStyles,
      innerProps = props.innerProps;

  return _react2.default.createElement(
    'div',
    _extends({
      className: cx( /*#__PURE__*/(0, _emotion.css)(getStyles('noOptionsMessage', props)), {
        'menu-notice': true,
        'menu-notice--no-options': true
      }, className)
    }, innerProps),
    children
  );
};
NoOptionsMessage.defaultProps = {
  children: 'No options'
};

var LoadingMessage = exports.LoadingMessage = function LoadingMessage(props) {
  var children = props.children,
      className = props.className,
      cx = props.cx,
      getStyles = props.getStyles,
      innerProps = props.innerProps;

  return _react2.default.createElement(
    'div',
    _extends({
      className: cx( /*#__PURE__*/(0, _emotion.css)(getStyles('loadingMessage', props)), {
        'menu-notice': true,
        'menu-notice--loading': true
      }, className)
    }, innerProps),
    children
  );
};
LoadingMessage.defaultProps = {
  children: 'Loading...'
};

// ==============================
// Menu Portal
// ==============================

var menuPortalCSS = exports.menuPortalCSS = function menuPortalCSS(_ref6) {
  var rect = _ref6.rect,
      offset = _ref6.offset,
      position = _ref6.position;
  return {
    left: rect.left,
    position: position,
    top: offset,
    width: rect.width,
    zIndex: 1
  };
};

var MenuPortal = exports.MenuPortal = function (_Component2) {
  _inherits(MenuPortal, _Component2);

  function MenuPortal() {
    var _ref7;

    var _temp2, _this2, _ret2;

    _classCallCheck(this, MenuPortal);

    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    return _ret2 = (_temp2 = (_this2 = _possibleConstructorReturn(this, (_ref7 = MenuPortal.__proto__ || Object.getPrototypeOf(MenuPortal)).call.apply(_ref7, [this].concat(args))), _this2), _this2.state = { placement: null }, _this2.getPortalPlacement = function (_ref8) {
      var placement = _ref8.placement;

      var initialPlacement = coercePlacement(_this2.props.menuPlacement);

      // avoid re-renders if the placement has not changed
      if (placement !== initialPlacement) {
        _this2.setState({ placement: placement });
      }
    }, _temp2), _possibleConstructorReturn(_this2, _ret2);
  }

  _createClass(MenuPortal, [{
    key: 'getChildContext',
    value: function getChildContext() {
      return {
        getPortalPlacement: this.getPortalPlacement
      };
    }

    // callback for occassions where the menu must "flip"

  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          appendTo = _props2.appendTo,
          children = _props2.children,
          controlElement = _props2.controlElement,
          menuPlacement = _props2.menuPlacement,
          position = _props2.menuPosition,
          getStyles = _props2.getStyles;

      var isFixed = position === 'fixed';

      // bail early if required elements aren't present
      if (!appendTo && !isFixed || !controlElement) {
        return null;
      }

      var placement = this.state.placement || coercePlacement(menuPlacement);
      var rect = (0, _utils.getBoundingClientObj)(controlElement);
      var scrollDistance = isFixed ? 0 : window.pageYOffset;
      var offset = rect[placement] + scrollDistance;
      var state = { offset: offset, position: position, rect: rect };

      // same wrapper element whether fixed or portalled
      var menuWrapper = _react2.default.createElement(
        'div',
        {
          className: /*#__PURE__*/ /*#__PURE__*/(0, _emotion.css)(getStyles('menuPortal', state))
        },
        children
      );

      return appendTo ? (0, _reactDom.createPortal)(menuWrapper, appendTo) : menuWrapper;
    }
  }]);

  return MenuPortal;
}(_react.Component);

MenuPortal.childContextTypes = {
  getPortalPlacement: _propTypes2.default.func
};

/***/ }),
/* 607 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.cleanValue = exports.emptyString = exports.noop = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.classNames = classNames;
exports.handleInputChange = handleInputChange;
exports.normalizedHeight = normalizedHeight;
exports.getScrollTop = getScrollTop;
exports.scrollTo = scrollTo;
exports.getScrollParent = getScrollParent;
exports.animatedScrollTo = animatedScrollTo;
exports.scrollIntoView = scrollIntoView;
exports.getBoundingClientObj = getBoundingClientObj;
exports.toKey = toKey;
exports.isTouchCapable = isTouchCapable;
exports.isMobileDevice = isMobileDevice;

var _raf = __webpack_require__(268);

var _raf2 = _interopRequireDefault(_raf);

__webpack_require__(0);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// ==============================
// NO OP
// ==============================

var noop = exports.noop = function noop() {};
var emptyString = exports.emptyString = function emptyString() {
  return '';
};

// ==============================
// Class Name Prefixer
// ==============================

/**
 String representation of component state for styling with class names.

 Expects an array of strings OR a string/object pair:
 - className(['comp', 'comp-arg', 'comp-arg-2'])
   @returns 'react-select__comp react-select__comp-arg react-select__comp-arg-2'
 - className('comp', { some: true, state: false })
   @returns 'react-select__comp react-select__comp--some'
*/
function applyPrefixToName(prefix, name) {
  if (!name) {
    return prefix;
  } else if (name[0] === '-') {
    return prefix + name;
  } else {
    return prefix + '__' + name;
  }
}

function classNames(prefix, cssKey, state, className) {
  var arr = [cssKey, className];
  if (state && prefix) {
    for (var key in state) {
      if (state.hasOwnProperty(key) && state[key]) {
        arr.push('' + applyPrefixToName(prefix, key));
      }
    }
  }

  return arr.filter(function (i) {
    return i;
  }).map(function (i) {
    return String(i).trim();
  }).join(' ');
}
// ==============================
// Clean Value
// ==============================

var cleanValue = exports.cleanValue = function cleanValue(value) {
  if (Array.isArray(value)) return value.filter(Boolean);
  if ((typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object' && value !== null) return [value];
  return [];
};

// ==============================
// Handle Input Change
// ==============================

function handleInputChange(inputValue, actionMeta, onInputChange) {
  if (onInputChange) {
    var newValue = onInputChange(inputValue, actionMeta);
    if (typeof newValue === 'string') return newValue;
  }
  return inputValue;
}

// ==============================
// Scroll Helpers
// ==============================

function isDocumentElement(el) {
  return [document.documentElement, document.body, window].indexOf(el) > -1;
}

// Normalized Scroll Top
// ------------------------------

function normalizedHeight(el) {
  if (isDocumentElement(el)) {
    return window.innerHeight;
  }

  return el.clientHeight;
}

// Normalized scrollTo & scrollTop
// ------------------------------

function getScrollTop(el) {
  if (isDocumentElement(el)) {
    return window.pageYOffset;
  }
  return el.scrollTop;
}

function scrollTo(el, top) {
  // with a scroll distance, we perform scroll on the element
  if (isDocumentElement(el)) {
    window.scrollTo(0, top);
    return;
  }

  el.scrollTop = top;
}

// Get Scroll Parent
// ------------------------------

function getScrollParent(element) {
  var style = getComputedStyle(element);
  var excludeStaticParent = style.position === 'absolute';
  var overflowRx = /(auto|scroll)/;
  var docEl = document.documentElement; // suck it, flow...

  if (style.position === 'fixed') return docEl;

  for (var parent = element; parent = parent.parentElement;) {
    style = getComputedStyle(parent);
    if (excludeStaticParent && style.position === 'static') {
      continue;
    }
    if (overflowRx.test(style.overflow + style.overflowY + style.overflowX)) {
      return parent;
    }
  }

  return docEl;
}

// Animated Scroll To
// ------------------------------

/**
  @param t: time (elapsed)
  @param b: initial value
  @param c: amount of change
  @param d: duration
*/
function easeOutCubic(t, b, c, d) {
  return c * ((t = t / d - 1) * t * t + 1) + b;
}

function animatedScrollTo(element, to) {
  var duration = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 200;
  var callback = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : noop;

  var start = getScrollTop(element);
  var change = to - start;
  var increment = 10;
  var currentTime = 0;

  function animateScroll() {
    currentTime += increment;
    var val = easeOutCubic(currentTime, start, change, duration);
    scrollTo(element, val);
    if (currentTime < duration) {
      (0, _raf2.default)(animateScroll);
    } else {
      callback(element);
    }
  }
  animateScroll();
}

// Scroll Into View
// ------------------------------

function scrollIntoView(menuEl, focusedEl) {
  var menuRect = menuEl.getBoundingClientRect();
  var focusedRect = focusedEl.getBoundingClientRect();
  var overScroll = focusedEl.offsetHeight / 3;

  if (focusedRect.bottom + overScroll > menuRect.bottom) {
    scrollTo(menuEl, Math.min(focusedEl.offsetTop + focusedEl.clientHeight - menuEl.offsetHeight + overScroll, menuEl.scrollHeight));
  } else if (focusedRect.top - overScroll < menuRect.top) {
    scrollTo(menuEl, Math.max(focusedEl.offsetTop - overScroll, 0));
  }
}

// ==============================
// Get bounding client object
// ==============================

// cannot get keys using array notation with DOMRect
function getBoundingClientObj(element) {
  var rect = element.getBoundingClientRect();
  return {
    bottom: rect.bottom,
    height: rect.height,
    left: rect.left,
    right: rect.right,
    top: rect.top,
    width: rect.width
  };
}


// ==============================
// String to Key (kebabify)
// ==============================

function toKey(str) {
  return str.replace(/\W/g, '-');
}

// ==============================
// Touch Capability Detector
// ==============================

function isTouchCapable() {
  try {
    document.createEvent('TouchEvent');
    return true;
  } catch (e) {
    return false;
  }
}

// ==============================
// Mobile Device Detector
// ==============================

function isMobileDevice() {
  try {
    return (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)
    );
  } catch (e) {
    return false;
  }
}

/***/ }),
/* 608 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.A11yText = exports.Input = exports.Span = exports.Div = exports.Button = undefined;

var _emotion = __webpack_require__(41);

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var createPrimitive = function createPrimitive(Tag) {
  return function (_ref) {
    var css = _ref.css,
        innerRef = _ref.innerRef,
        props = _objectWithoutProperties(_ref, ['css', 'innerRef']);

    return _react2.default.createElement(Tag, _extends({ ref: innerRef, className: (0, _emotion.css)(css)
    }, props));
  };
};

var Button = exports.Button = createPrimitive('button');
var Div = exports.Div = createPrimitive('div');
var Span = exports.Span = createPrimitive('span');
var Input = exports.Input = createPrimitive('input');

// Assistive text to describe visual elements. Hidden for sighted users.
var A11yText = exports.A11yText = function A11yText(props) {
  return _react2.default.createElement('span', _extends({
    className: (0, _emotion.css)({
      zIndex: 9999,
      border: 0,
      clip: 'rect(1px, 1px, 1px, 1px)',
      height: 1,
      width: 1,
      position: 'absolute',
      overflow: 'hidden',
      padding: 0,
      whiteSpace: 'nowrap',
      backgroundColor: 'red',
      color: 'blue'
    })
  }, props));
};

/***/ }),
/* 609 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.optionCSS = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _emotion = __webpack_require__(41);

var _theme = __webpack_require__(45);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var optionCSS = exports.optionCSS = function optionCSS(_ref) {
  var isDisabled = _ref.isDisabled,
      isFocused = _ref.isFocused,
      isSelected = _ref.isSelected;
  return {
    backgroundColor: isSelected ? _theme.colors.primary : isFocused ? _theme.colors.primary25 : 'transparent',
    color: isDisabled ? _theme.colors.neutral20 : isSelected ? _theme.colors.neutral0 : 'inherit',
    cursor: 'default',
    display: 'block',
    fontSize: 'inherit',
    padding: _theme.spacing.baseUnit * 2 + 'px ' + _theme.spacing.baseUnit * 3 + 'px',
    width: '100%',
    userSelect: 'none',
    WebkitTapHighlightColor: 'rgba(0, 0, 0, 0)',

    // provide some affordance on touch devices
    ':active': {
      backgroundColor: isSelected ? _theme.colors.primary : _theme.colors.primary50
    }
  };
};

var Option = function Option(props) {
  var children = props.children,
      className = props.className,
      cx = props.cx,
      getStyles = props.getStyles,
      isDisabled = props.isDisabled,
      isFocused = props.isFocused,
      isSelected = props.isSelected,
      innerProps = props.innerProps;

  var innerRef = innerProps.innerRef,
      rest = _objectWithoutProperties(innerProps, ['innerRef']);

  return _react2.default.createElement(
    'div',
    _extends({
      ref: innerRef,
      className: cx( /*#__PURE__*/(0, _emotion.css)(getStyles('option', props)), {
        'option': true,
        'option--is-disabled': isDisabled,
        'option--is-focused': isFocused,
        'option--is-selected': isSelected
      }, className)
    }, rest),
    children
  );
};

exports.default = Option;

/***/ }),
/* 610 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

__webpack_require__(273);

__webpack_require__(132);

__webpack_require__(272);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

// strip transition props off before spreading onto select component
// note we need to be explicit about innerRef for flow
var AnimatedInput = function AnimatedInput(WrappedComponent) {
  return function (_ref) {
    var inProp = _ref.in,
        onExited = _ref.onExited,
        appear = _ref.appear,
        enter = _ref.enter,
        exit = _ref.exit,
        innerRef = _ref.innerRef,
        props = _objectWithoutProperties(_ref, ['in', 'onExited', 'appear', 'enter', 'exit', 'innerRef']);

    return (
      // $FlowFixMe
      _react2.default.createElement(WrappedComponent, _extends({ innerRef: innerRef }, props))
    );
  };
};

exports.default = AnimatedInput;

/***/ }),
/* 611 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

__webpack_require__(274);

var _transitions = __webpack_require__(132);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

// strip transition props off before spreading onto actual component
var AnimatedMultiValue = function AnimatedMultiValue(WrappedComponent) {
  return function (_ref) {
    var inProp = _ref.in,
        onExited = _ref.onExited,
        props = _objectWithoutProperties(_ref, ['in', 'onExited']);

    return _react2.default.createElement(
      _transitions.Collapse,
      { 'in': inProp, onExited: onExited },
      _react2.default.createElement(WrappedComponent, _extends({ cropWithEllipsis: inProp }, props))
    );
  };
};

exports.default = AnimatedMultiValue;

/***/ }),
/* 612 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

__webpack_require__(275);

var _transitions = __webpack_require__(132);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// fade in when last multi-value removed, otherwise instant
var AnimatedPlaceholder = function AnimatedPlaceholder(WrappedComponent) {
  return function (props) {
    return _react2.default.createElement(_transitions.Fade, _extends({
      component: WrappedComponent,
      duration: props.isMulti ? _transitions.collapseDuration : 1
    }, props));
  };
};

exports.default = AnimatedPlaceholder;

/***/ }),
/* 613 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

__webpack_require__(276);

var _transitions = __webpack_require__(132);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// instant fade; all transition-group children must be transitions

var AnimatedSingleValue = function AnimatedSingleValue(WrappedComponent) {
  return function (props) {
    return _react2.default.createElement(_transitions.Fade, _extends({ component: WrappedComponent }, props));
  };
};

exports.default = AnimatedSingleValue;

/***/ }),
/* 614 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactTransitionGroup = __webpack_require__(187);

__webpack_require__(270);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// make ValueContainer a transition group
var AnimatedValueContainer = function AnimatedValueContainer(WrappedComponent) {
  return function (props) {
    return _react2.default.createElement(_reactTransitionGroup.TransitionGroup, _extends({ component: WrappedComponent }, props));
  };
};

exports.default = AnimatedValueContainer;

/***/ }),
/* 615 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(2);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(6));

var _objectSpread2 = _interopRequireDefault(__webpack_require__(17));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(7));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(4));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _classnames = _interopRequireDefault(__webpack_require__(5));

var _withStyles = _interopRequireDefault(__webpack_require__(3));

var _helpers = __webpack_require__(37);

var SIZE = 44;

function getRelativeValue(value, min, max) {
  var clampedValue = Math.min(Math.max(min, value), max);
  return (clampedValue - min) / (max - min);
}

function easeOut(t) {
  t = getRelativeValue(t, 0, 1); // https://gist.github.com/gre/1650294

  t = (t -= 1) * t * t + 1;
  return t;
}

function easeIn(t) {
  return t * t;
}

var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      display: 'inline-block',
      lineHeight: 1 // Keep the progress centered

    },

    /* Styles applied to the root element if `variant="static"`. */
    static: {
      transition: theme.transitions.create('transform')
    },

    /* Styles applied to the root element if `variant="indeterminate"`. */
    indeterminate: {
      animation: 'mui-progress-circular-rotate 1.4s linear infinite'
    },

    /* Styles applied to the root element if `color="primary"`. */
    colorPrimary: {
      color: theme.palette.primary.main
    },

    /* Styles applied to the root element if `color="secondary"`. */
    colorSecondary: {
      color: theme.palette.secondary.main
    },

    /* Styles applied to the `svg` element. */
    svg: {},

    /* Styles applied to the `circle` svg path. */
    circle: {
      stroke: 'currentColor' // Use butt to follow the specification, by chance, it's already the default CSS value.
      // strokeLinecap: 'butt',

    },

    /* Styles applied to the `circle` svg path if `variant="static"`. */
    circleStatic: {
      transition: theme.transitions.create('stroke-dashoffset')
    },

    /* Styles applied to the `circle` svg path if `variant="indeterminate"`. */
    circleIndeterminate: {
      animation: 'mui-progress-circular-dash 1.4s ease-in-out infinite',
      // Some default value that looks fine waiting for the animation to kicks in.
      strokeDasharray: '80px, 200px',
      strokeDashoffset: '0px' // Add the unit to fix a Edge 16 and below bug.

    },
    '@keyframes mui-progress-circular-rotate': {
      '100%': {
        transform: 'rotate(360deg)'
      }
    },
    '@keyframes mui-progress-circular-dash': {
      '0%': {
        strokeDasharray: '1px, 200px',
        strokeDashoffset: '0px'
      },
      '50%': {
        strokeDasharray: '100px, 200px',
        strokeDashoffset: '-15px'
      },
      '100%': {
        strokeDasharray: '100px, 200px',
        strokeDashoffset: '-120px'
      }
    }
  };
};
/**
 * ## ARIA
 *
 * If the progress bar is describing the loading progress of a particular region of a page,
 * you should use `aria-describedby` to point to the progress bar, and set the `aria-busy`
 * attribute to `true` on that region until it has finished loading.
 */


exports.styles = styles;

function CircularProgress(props) {
  var _classNames, _classNames2;

  var classes = props.classes,
      className = props.className,
      color = props.color,
      size = props.size,
      style = props.style,
      thickness = props.thickness,
      value = props.value,
      variant = props.variant,
      other = (0, _objectWithoutProperties2.default)(props, ["classes", "className", "color", "size", "style", "thickness", "value", "variant"]);
  var circleStyle = {};
  var rootStyle = {};
  var rootProps = {};

  if (variant === 'determinate' || variant === 'static') {
    var circumference = 2 * Math.PI * ((SIZE - thickness) / 2);
    circleStyle.strokeDasharray = circumference.toFixed(3);
    rootProps['aria-valuenow'] = Math.round(value);

    if (variant === 'static') {
      circleStyle.strokeDashoffset = "".concat(((100 - value) / 100 * circumference).toFixed(3), "px");
      rootStyle.transform = 'rotate(-90deg)';
    } else {
      circleStyle.strokeDashoffset = "".concat((easeIn((100 - value) / 100) * circumference).toFixed(3), "px");
      rootStyle.transform = "rotate(".concat((easeOut(value / 70) * 270).toFixed(3), "deg)");
    }
  }

  return _react.default.createElement("div", (0, _extends2.default)({
    className: (0, _classnames.default)(classes.root, (_classNames = {}, (0, _defineProperty2.default)(_classNames, classes["color".concat((0, _helpers.capitalize)(color))], color !== 'inherit'), (0, _defineProperty2.default)(_classNames, classes.indeterminate, variant === 'indeterminate'), (0, _defineProperty2.default)(_classNames, classes.static, variant === 'static'), _classNames), className),
    style: (0, _objectSpread2.default)({
      width: size,
      height: size
    }, rootStyle, style),
    role: "progressbar"
  }, rootProps, other), _react.default.createElement("svg", {
    className: classes.svg,
    viewBox: "".concat(SIZE / 2, " ").concat(SIZE / 2, " ").concat(SIZE, " ").concat(SIZE)
  }, _react.default.createElement("circle", {
    className: (0, _classnames.default)(classes.circle, (_classNames2 = {}, (0, _defineProperty2.default)(_classNames2, classes.circleIndeterminate, variant === 'indeterminate'), (0, _defineProperty2.default)(_classNames2, classes.circleStatic, variant === 'static'), _classNames2)),
    style: circleStyle,
    cx: SIZE,
    cy: SIZE,
    r: (SIZE - thickness) / 2,
    fill: "none",
    strokeWidth: thickness
  })));
}

CircularProgress.propTypes =  false ? {
  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * The color of the component. It supports those theme colors that make sense for this component.
   */
  color: _propTypes.default.oneOf(['primary', 'secondary', 'inherit']),

  /**
   * The size of the circle.
   */
  size: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),

  /**
   * @ignore
   */
  style: _propTypes.default.object,

  /**
   * The thickness of the circle.
   */
  thickness: _propTypes.default.number,

  /**
   * The value of the progress indicator for the determinate and static variants.
   * Value between 0 and 100.
   */
  value: _propTypes.default.number,

  /**
   * The variant to use.
   * Use indeterminate when there is no progress value.
   */
  variant: _propTypes.default.oneOf(['determinate', 'indeterminate', 'static'])
} : {};
CircularProgress.defaultProps = {
  color: 'primary',
  size: 40,
  thickness: 3.6,
  value: 0,
  variant: 'indeterminate'
};

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiCircularProgress',
  flip: false
})(CircularProgress);

exports.default = _default;

/***/ }),
/* 616 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(2);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(6));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(4));

var _react = _interopRequireDefault(__webpack_require__(0));

var _warning = _interopRequireDefault(__webpack_require__(16));

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _Input = _interopRequireDefault(__webpack_require__(129));

var _InputLabel = _interopRequireDefault(__webpack_require__(185));

var _FormControl = _interopRequireDefault(__webpack_require__(182));

var _FormHelperText = _interopRequireDefault(__webpack_require__(262));

var _Select = _interopRequireDefault(__webpack_require__(277));

// @inheritedComponent FormControl

/**
 * The `TextField` is a convenience wrapper for the most common cases (80%).
 * It cannot be all things to all people, otherwise the API would grow out of control.
 *
 * ## Advanced Configuration
 *
 * It's important to understand that the text field is a simple abstraction
 * on top of the following components:
 * - [FormControl](/api/form-control)
 * - [InputLabel](/api/input-label)
 * - [Input](/api/input)
 * - [FormHelperText](/api/form-helper-text)
 *
 * If you wish to alter the properties applied to the native input, you can do so as follows:
 *
 * ```jsx
 * const inputProps = {
 *   step: 300,
 * };
 *
 * return <TextField id="time" type="time" inputProps={inputProps} />;
 * ```
 *
 * For advanced cases, please look at the source of TextField by clicking on the
 * "Edit this page" button above. Consider either:
 * - using the upper case props for passing values directly to the components
 * - using the underlying components directly as shown in the demos
 */
function TextField(props) {
  var autoComplete = props.autoComplete,
      autoFocus = props.autoFocus,
      children = props.children,
      className = props.className,
      defaultValue = props.defaultValue,
      disabled = props.disabled,
      error = props.error,
      FormHelperTextProps = props.FormHelperTextProps,
      fullWidth = props.fullWidth,
      helperText = props.helperText,
      id = props.id,
      InputLabelProps = props.InputLabelProps,
      inputProps = props.inputProps,
      InputProps = props.InputProps,
      inputRef = props.inputRef,
      label = props.label,
      multiline = props.multiline,
      name = props.name,
      onBlur = props.onBlur,
      onChange = props.onChange,
      onFocus = props.onFocus,
      placeholder = props.placeholder,
      required = props.required,
      rows = props.rows,
      rowsMax = props.rowsMax,
      select = props.select,
      SelectProps = props.SelectProps,
      type = props.type,
      value = props.value,
      other = (0, _objectWithoutProperties2.default)(props, ["autoComplete", "autoFocus", "children", "className", "defaultValue", "disabled", "error", "FormHelperTextProps", "fullWidth", "helperText", "id", "InputLabelProps", "inputProps", "InputProps", "inputRef", "label", "multiline", "name", "onBlur", "onChange", "onFocus", "placeholder", "required", "rows", "rowsMax", "select", "SelectProps", "type", "value"]);
   false ? (0, _warning.default)(!select || Boolean(children), 'Material-UI: `children` must be passed when using the `TextField` component with `select`.') : void 0;
  var helperTextId = helperText && id ? "".concat(id, "-helper-text") : undefined;

  var InputElement = _react.default.createElement(_Input.default, (0, _extends2.default)({
    autoComplete: autoComplete,
    autoFocus: autoFocus,
    defaultValue: defaultValue,
    disabled: disabled,
    fullWidth: fullWidth,
    multiline: multiline,
    name: name,
    rows: rows,
    rowsMax: rowsMax,
    type: type,
    value: value,
    id: id,
    inputRef: inputRef,
    onBlur: onBlur,
    onChange: onChange,
    onFocus: onFocus,
    placeholder: placeholder,
    inputProps: inputProps
  }, InputProps));

  return _react.default.createElement(_FormControl.default, (0, _extends2.default)({
    "aria-describedby": helperTextId,
    className: className,
    error: error,
    fullWidth: fullWidth,
    required: required
  }, other), label && _react.default.createElement(_InputLabel.default, (0, _extends2.default)({
    htmlFor: id
  }, InputLabelProps), label), select ? _react.default.createElement(_Select.default, (0, _extends2.default)({
    value: value,
    input: InputElement
  }, SelectProps), children) : InputElement, helperText && _react.default.createElement(_FormHelperText.default, (0, _extends2.default)({
    id: helperTextId
  }, FormHelperTextProps), helperText));
}

TextField.propTypes =  false ? {
  /**
   * This property helps users to fill forms faster, especially on mobile devices.
   * The name can be confusing, as it's more like an autofill.
   * You can learn more about it here:
   * https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#autofill
   */
  autoComplete: _propTypes.default.string,

  /**
   * If `true`, the input will be focused during the first mount.
   */
  autoFocus: _propTypes.default.bool,

  /**
   * @ignore
   */
  children: _propTypes.default.node,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * The default value of the `Input` element.
   */
  defaultValue: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),

  /**
   * If `true`, the input will be disabled.
   */
  disabled: _propTypes.default.bool,

  /**
   * If `true`, the label will be displayed in an error state.
   */
  error: _propTypes.default.bool,

  /**
   * Properties applied to the [`FormHelperText`](/api/form-helper-text) element.
   */
  FormHelperTextProps: _propTypes.default.object,

  /**
   * If `true`, the input will take up the full width of its container.
   */
  fullWidth: _propTypes.default.bool,

  /**
   * The helper text content.
   */
  helperText: _propTypes.default.node,

  /**
   * The id of the `input` element.
   * Use that property to make `label` and `helperText` accessible for screen readers.
   */
  id: _propTypes.default.string,

  /**
   * Properties applied to the [`InputLabel`](/api/input-label) element.
   */
  InputLabelProps: _propTypes.default.object,

  /**
   * Properties applied to the `Input` element.
   */
  InputProps: _propTypes.default.object,

  /**
   * Attributes applied to the native `input` element.
   */
  inputProps: _propTypes.default.object,

  /**
   * Use that property to pass a ref callback to the native input component.
   */
  inputRef: _propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.object]),

  /**
   * The label content.
   */
  label: _propTypes.default.node,

  /**
   * If `dense` or `normal`, will adjust vertical spacing of this and contained components.
   */
  margin: _propTypes.default.oneOf(['none', 'dense', 'normal']),

  /**
   * If `true`, a textarea element will be rendered instead of an input.
   */
  multiline: _propTypes.default.bool,

  /**
   * Name attribute of the `input` element.
   */
  name: _propTypes.default.string,

  /**
   * @ignore
   */
  onBlur: _propTypes.default.func,

  /**
   * Callback fired when the value is changed.
   *
   * @param {object} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value`.
   */
  onChange: _propTypes.default.func,

  /**
   * @ignore
   */
  onFocus: _propTypes.default.func,

  /**
   * The short hint displayed in the input before the user enters a value.
   */
  placeholder: _propTypes.default.string,

  /**
   * If `true`, the label is displayed as required and the input will be required.
   */
  required: _propTypes.default.bool,

  /**
   * Number of rows to display when multiline option is set to true.
   */
  rows: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),

  /**
   * Maximum number of rows to display when multiline option is set to true.
   */
  rowsMax: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),

  /**
   * Render a `Select` element while passing the `Input` element to `Select` as `input` parameter.
   * If this option is set you must pass the options of the select as children.
   */
  select: _propTypes.default.bool,

  /**
   * Properties applied to the [`Select`](/api/select) element.
   */
  SelectProps: _propTypes.default.object,

  /**
   * Type attribute of the `Input` element. It should be a valid HTML5 input type.
   */
  type: _propTypes.default.string,

  /**
   * The value of the `Input` element, required for a controlled component.
   */
  value: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number, _propTypes.default.arrayOf(_propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]))])
} : {};
TextField.defaultProps = {
  required: false,
  select: false
};
var _default = TextField;
exports.default = _default;

/***/ }),
/* 617 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(2);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _objectSpread2 = _interopRequireDefault(__webpack_require__(17));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(4));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _SelectInput = _interopRequireDefault(__webpack_require__(618));

var _withStyles = _interopRequireDefault(__webpack_require__(3));

var _mergeClasses = _interopRequireDefault(__webpack_require__(239));

var _ArrowDropDown = _interopRequireDefault(__webpack_require__(284));

var _Input = _interopRequireDefault(__webpack_require__(129));

var _NativeSelect = __webpack_require__(640);

var _NativeSelectInput = _interopRequireDefault(__webpack_require__(285));

// @inheritedComponent Input
var styles = _NativeSelect.styles;
exports.styles = styles;

function Select(props) {
  var autoWidth = props.autoWidth,
      children = props.children,
      classes = props.classes,
      displayEmpty = props.displayEmpty,
      IconComponent = props.IconComponent,
      input = props.input,
      inputProps = props.inputProps,
      MenuProps = props.MenuProps,
      multiple = props.multiple,
      native = props.native,
      onClose = props.onClose,
      onOpen = props.onOpen,
      open = props.open,
      renderValue = props.renderValue,
      SelectDisplayProps = props.SelectDisplayProps,
      other = (0, _objectWithoutProperties2.default)(props, ["autoWidth", "children", "classes", "displayEmpty", "IconComponent", "input", "inputProps", "MenuProps", "multiple", "native", "onClose", "onOpen", "open", "renderValue", "SelectDisplayProps"]);
  var inputComponent = native ? _NativeSelectInput.default : _SelectInput.default;
  return _react.default.cloneElement(input, (0, _objectSpread2.default)({
    // Most of the logic is implemented in `SelectInput`.
    // The `Select` component is a simple API wrapper to expose something better to play with.
    inputComponent: inputComponent,
    inputProps: (0, _objectSpread2.default)({
      children: children,
      IconComponent: IconComponent,
      type: undefined
    }, native ? {} : {
      autoWidth: autoWidth,
      displayEmpty: displayEmpty,
      MenuProps: MenuProps,
      multiple: multiple,
      onClose: onClose,
      onOpen: onOpen,
      open: open,
      renderValue: renderValue,
      SelectDisplayProps: SelectDisplayProps
    }, inputProps, {
      classes: inputProps ? (0, _mergeClasses.default)({
        baseClasses: classes,
        newClasses: inputProps.classes,
        Component: Select
      }) : classes
    }, input ? input.props.inputProps : {})
  }, other));
}

Select.propTypes =  false ? {
  /**
   * If true, the width of the popover will automatically be set according to the items inside the
   * menu, otherwise it will be at least the width of the select input.
   */
  autoWidth: _propTypes.default.bool,

  /**
   * The option elements to populate the select with.
   * Can be some `MenuItem` when `native` is false and `option` when `native` is true.
   */
  children: _propTypes.default.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * If `true`, the selected item is displayed even if its value is empty.
   * You can only use it when the `native` property is `false` (default).
   */
  displayEmpty: _propTypes.default.bool,

  /**
   * The icon that displays the arrow.
   */
  IconComponent: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func, _propTypes.default.object]),

  /**
   * An `Input` element; does not have to be a material-ui specific `Input`.
   */
  input: _propTypes.default.element,

  /**
   * Attributes applied to the `input` element.
   * When `native` is `true`, the attributes are applied on the `select` element.
   */
  inputProps: _propTypes.default.object,

  /**
   * Properties applied to the [`Menu`](/api/menu) element.
   */
  MenuProps: _propTypes.default.object,

  /**
   * If true, `value` must be an array and the menu will support multiple selections.
   * You can only use it when the `native` property is `false` (default).
   */
  multiple: _propTypes.default.bool,

  /**
   * If `true`, the component will be using a native `select` element.
   */
  native: _propTypes.default.bool,

  /**
   * Callback function fired when a menu item is selected.
   *
   * @param {object} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value`.
   * @param {object} [child] The react element that was selected when `native` is `false` (default).
   */
  onChange: _propTypes.default.func,

  /**
   * Callback fired when the component requests to be closed.
   * Use in controlled mode (see open).
   *
   * @param {object} event The event source of the callback
   */
  onClose: _propTypes.default.func,

  /**
   * Callback fired when the component requests to be opened.
   * Use in controlled mode (see open).
   *
   * @param {object} event The event source of the callback
   */
  onOpen: _propTypes.default.func,

  /**
   * Control `select` open state.
   * You can only use it when the `native` property is `false` (default).
   */
  open: _propTypes.default.bool,

  /**
   * Render the selected value.
   * You can only use it when the `native` property is `false` (default).
   *
   * @param {*} value The `value` provided to the component.
   * @returns {ReactElement}
   */
  renderValue: _propTypes.default.func,

  /**
   * Properties applied to the clickable div element.
   */
  SelectDisplayProps: _propTypes.default.object,

  /**
   * The input value.
   * This property is required when the `native` property is `false` (default).
   */
  value: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number, _propTypes.default.arrayOf(_propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]))])
} : {};
Select.defaultProps = {
  autoWidth: false,
  displayEmpty: false,
  IconComponent: _ArrowDropDown.default,
  input: _react.default.createElement(_Input.default, null),
  multiple: false,
  native: false
};
Select.muiName = 'Select';

var _default = (0, _withStyles.default)(_NativeSelect.styles, {
  name: 'MuiSelect'
})(Select);

exports.default = _default;

/***/ }),
/* 618 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(2);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectSpread2 = _interopRequireDefault(__webpack_require__(17));

var _extends2 = _interopRequireDefault(__webpack_require__(6));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(7));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(4));

var _toConsumableArray2 = _interopRequireDefault(__webpack_require__(243));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(11));

var _createClass2 = _interopRequireDefault(__webpack_require__(12));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(13));

var _inherits2 = _interopRequireDefault(__webpack_require__(14));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _classnames = _interopRequireDefault(__webpack_require__(5));

var _keycode = _interopRequireDefault(__webpack_require__(99));

var _warning = _interopRequireDefault(__webpack_require__(16));

var _Menu = _interopRequireDefault(__webpack_require__(619));

var _Input = __webpack_require__(183);

/**
 * @ignore - internal component.
 */
var SelectInput =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(SelectInput, _React$Component);

  function SelectInput() {
    var _ref;

    var _temp, _this;

    (0, _classCallCheck2.default)(this, SelectInput);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return (0, _possibleConstructorReturn2.default)(_this, (_temp = _this = (0, _possibleConstructorReturn2.default)(this, (_ref = SelectInput.__proto__ || Object.getPrototypeOf(SelectInput)).call.apply(_ref, [this].concat(args))), _this.ignoreNextBlur = false, _this.displayRef = null, _this.isOpenControlled = _this.props.open !== undefined, _this.state = {
      menuMinWidth: null,
      open: false
    }, _this.update = function (_ref2) {
      var event = _ref2.event,
          open = _ref2.open;

      if (_this.isOpenControlled) {
        if (open) {
          _this.props.onOpen(event);
        } else {
          _this.props.onClose(event);
        }

        return;
      }

      _this.setState({
        // Perfom the layout computation outside of the render method.
        menuMinWidth: _this.props.autoWidth ? null : _this.displayRef.clientWidth,
        open: open
      });
    }, _this.handleClick = function (event) {
      // Opening the menu is going to blur the. It will be focused back when closed.
      _this.ignoreNextBlur = true;

      _this.update({
        open: true,
        event: event
      });
    }, _this.handleClose = function (event) {
      _this.update({
        open: false,
        event: event
      });
    }, _this.handleItemClick = function (child) {
      return function (event) {
        if (!_this.props.multiple) {
          _this.update({
            open: false,
            event: event
          });
        }

        var _this$props = _this.props,
            onChange = _this$props.onChange,
            name = _this$props.name;

        if (onChange) {
          var value;

          if (_this.props.multiple) {
            value = Array.isArray(_this.props.value) ? (0, _toConsumableArray2.default)(_this.props.value) : [];
            var itemIndex = value.indexOf(child.props.value);

            if (itemIndex === -1) {
              value.push(child.props.value);
            } else {
              value.splice(itemIndex, 1);
            }
          } else {
            value = child.props.value;
          }

          event.persist();
          event.target = {
            value: value,
            name: name
          };
          onChange(event, child);
        }
      };
    }, _this.handleBlur = function (event) {
      if (_this.ignoreNextBlur === true) {
        // The parent components are relying on the bubbling of the event.
        event.stopPropagation();
        _this.ignoreNextBlur = false;
        return;
      }

      if (_this.props.onBlur) {
        _this.props.onBlur(event);
      }
    }, _this.handleKeyDown = function (event) {
      if (_this.props.readOnly) {
        return;
      }

      if (['space', 'up', 'down'].indexOf((0, _keycode.default)(event)) !== -1) {
        event.preventDefault(); // Opening the menu is going to blur the. It will be focused back when closed.

        _this.ignoreNextBlur = true;

        _this.update({
          open: true,
          event: event
        });
      }
    }, _this.handleDisplayRef = function (ref) {
      _this.displayRef = ref;
    }, _this.handleInputRef = function (ref) {
      var inputRef = _this.props.inputRef;

      if (!inputRef) {
        return;
      }

      var nodeProxy = {
        node: ref,
        // By pass the native input as we expose a rich object (array).
        value: _this.props.value
      };

      if (typeof inputRef === 'function') {
        inputRef(nodeProxy);
      } else {
        inputRef.current = nodeProxy;
      }
    }, _temp));
  }

  (0, _createClass2.default)(SelectInput, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.isOpenControlled && this.props.open) {
        // Focus the display node so the focus is restored on this element once
        // the menu is closed.
        this.displayRef.focus(); // Rerender with the resolve `displayRef` reference.

        this.forceUpdate();
      }

      if (this.props.autoFocus) {
        this.displayRef.focus();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          autoWidth = _props.autoWidth,
          children = _props.children,
          classes = _props.classes,
          className = _props.className,
          disabled = _props.disabled,
          displayEmpty = _props.displayEmpty,
          IconComponent = _props.IconComponent,
          inputRef = _props.inputRef,
          _props$MenuProps = _props.MenuProps,
          MenuProps = _props$MenuProps === void 0 ? {} : _props$MenuProps,
          multiple = _props.multiple,
          name = _props.name,
          onBlur = _props.onBlur,
          onChange = _props.onChange,
          onClose = _props.onClose,
          onFocus = _props.onFocus,
          onOpen = _props.onOpen,
          openProp = _props.open,
          readOnly = _props.readOnly,
          renderValue = _props.renderValue,
          required = _props.required,
          SelectDisplayProps = _props.SelectDisplayProps,
          tabIndexProp = _props.tabIndex,
          _props$type = _props.type,
          type = _props$type === void 0 ? 'hidden' : _props$type,
          value = _props.value,
          other = (0, _objectWithoutProperties2.default)(_props, ["autoWidth", "children", "classes", "className", "disabled", "displayEmpty", "IconComponent", "inputRef", "MenuProps", "multiple", "name", "onBlur", "onChange", "onClose", "onFocus", "onOpen", "open", "readOnly", "renderValue", "required", "SelectDisplayProps", "tabIndex", "type", "value"]);
      var open = this.isOpenControlled && this.displayRef ? openProp : this.state.open;
      delete other['aria-invalid'];
      var display;
      var displaySingle = '';
      var displayMultiple = [];
      var computeDisplay = false; // No need to display any value if the field is empty.

      if ((0, _Input.isFilled)(this.props) || displayEmpty) {
        if (renderValue) {
          display = renderValue(value);
        } else {
          computeDisplay = true;
        }
      }

      var items = _react.default.Children.map(children, function (child) {
        if (!_react.default.isValidElement(child)) {
          return null;
        }

         false ? (0, _warning.default)(child.type !== _react.default.Fragment, ["Material-UI: the Select component doesn't accept a Fragment as a child.", 'Consider providing an array instead.'].join('\n')) : void 0;
        var selected;

        if (multiple) {
          if (!Array.isArray(value)) {
            throw new Error('Material-UI: the `value` property must be an array ' + 'when using the `Select` component with `multiple`.');
          }

          selected = value.indexOf(child.props.value) !== -1;

          if (selected && computeDisplay) {
            displayMultiple.push(child.props.children);
          }
        } else {
          selected = value === child.props.value;

          if (selected && computeDisplay) {
            displaySingle = child.props.children;
          }
        }

        return _react.default.cloneElement(child, {
          onClick: _this2.handleItemClick(child),
          role: 'option',
          selected: selected,
          value: undefined,
          // The value is most likely not a valid HTML attribute.
          'data-value': child.props.value // Instead, we provide it as a data attribute.

        });
      });

      if (computeDisplay) {
        display = multiple ? displayMultiple.join(', ') : displaySingle;
      } // Avoid performing a layout computation in the render method.


      var menuMinWidth = this.state.menuMinWidth;

      if (!autoWidth && this.isOpenControlled && this.displayRef) {
        menuMinWidth = this.displayRef.clientWidth;
      }

      var tabIndex;

      if (typeof tabIndexProp !== 'undefined') {
        tabIndex = tabIndexProp;
      } else {
        tabIndex = disabled ? null : 0;
      }

      return _react.default.createElement("div", {
        className: classes.root
      }, _react.default.createElement("div", (0, _extends2.default)({
        className: (0, _classnames.default)(classes.select, classes.selectMenu, (0, _defineProperty2.default)({}, classes.disabled, disabled), className),
        ref: this.handleDisplayRef,
        "aria-pressed": open ? 'true' : 'false',
        tabIndex: tabIndex,
        role: "button",
        "aria-owns": open ? "menu-".concat(name || '') : null,
        "aria-haspopup": "true",
        onKeyDown: this.handleKeyDown,
        onBlur: this.handleBlur,
        onClick: disabled || readOnly ? null : this.handleClick,
        onFocus: onFocus
      }, SelectDisplayProps), display || _react.default.createElement("span", {
        dangerouslySetInnerHTML: {
          __html: '&#8203;'
        }
      })), _react.default.createElement("input", (0, _extends2.default)({
        value: Array.isArray(value) ? value.join(',') : value,
        name: name,
        ref: this.handleInputRef,
        type: type
      }, other)), _react.default.createElement(IconComponent, {
        className: classes.icon
      }), _react.default.createElement(_Menu.default, (0, _extends2.default)({
        id: "menu-".concat(name || ''),
        anchorEl: this.displayRef,
        open: open,
        onClose: this.handleClose
      }, MenuProps, {
        MenuListProps: (0, _objectSpread2.default)({
          role: 'listbox'
        }, MenuProps.MenuListProps),
        PaperProps: (0, _objectSpread2.default)({}, MenuProps.PaperProps, {
          style: (0, _objectSpread2.default)({
            minWidth: menuMinWidth
          }, MenuProps.PaperProps != null ? MenuProps.PaperProps.style : null)
        })
      }), items));
    }
  }]);
  return SelectInput;
}(_react.default.Component);

SelectInput.propTypes =  false ? {
  /**
   * @ignore
   */
  autoFocus: _propTypes.default.bool,

  /**
   * If true, the width of the popover will automatically be set according to the items inside the
   * menu, otherwise it will be at least the width of the select input.
   */
  autoWidth: _propTypes.default.bool,

  /**
   * The option elements to populate the select with.
   * Can be some `<MenuItem>` elements.
   */
  children: _propTypes.default.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * The CSS class name of the select element.
   */
  className: _propTypes.default.string,

  /**
   * If `true`, the select will be disabled.
   */
  disabled: _propTypes.default.bool,

  /**
   * If `true`, the selected item is displayed even if its value is empty.
   */
  displayEmpty: _propTypes.default.bool,

  /**
   * The icon that displays the arrow.
   */
  IconComponent: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func, _propTypes.default.object]),

  /**
   * Use that property to pass a ref callback to the native select element.
   */
  inputRef: _propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.object]),

  /**
   * Properties applied to the [`Menu`](/api/menu) element.
   */
  MenuProps: _propTypes.default.object,

  /**
   * If true, `value` must be an array and the menu will support multiple selections.
   */
  multiple: _propTypes.default.bool,

  /**
   * Name attribute of the `select` or hidden `input` element.
   */
  name: _propTypes.default.string,

  /**
   * @ignore
   */
  onBlur: _propTypes.default.func,

  /**
   * Callback function fired when a menu item is selected.
   *
   * @param {object} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value`.
   * @param {object} [child] The react element that was selected.
   */
  onChange: _propTypes.default.func,

  /**
   * Callback fired when the component requests to be closed.
   * Use in controlled mode (see open).
   *
   * @param {object} event The event source of the callback
   */
  onClose: _propTypes.default.func,

  /**
   * @ignore
   */
  onFocus: _propTypes.default.func,

  /**
   * Callback fired when the component requests to be opened.
   * Use in controlled mode (see open).
   *
   * @param {object} event The event source of the callback
   */
  onOpen: _propTypes.default.func,

  /**
   * Control `select` open state.
   */
  open: _propTypes.default.bool,

  /**
   * @ignore
   */
  readOnly: _propTypes.default.bool,

  /**
   * Render the selected value.
   *
   * @param {*} value The `value` provided to the component.
   * @returns {ReactElement}
   */
  renderValue: _propTypes.default.func,

  /**
   * @ignore
   */
  required: _propTypes.default.bool,

  /**
   * Properties applied to the clickable div element.
   */
  SelectDisplayProps: _propTypes.default.object,

  /**
   * @ignore
   */
  tabIndex: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),

  /**
   * @ignore
   */
  type: _propTypes.default.string,

  /**
   * The input value.
   */
  value: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number, _propTypes.default.arrayOf(_propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]))]).isRequired
} : {};
var _default = SelectInput;
exports.default = _default;

/***/ }),
/* 619 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(2);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(6));

var _objectSpread2 = _interopRequireDefault(__webpack_require__(17));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(4));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(11));

var _createClass2 = _interopRequireDefault(__webpack_require__(12));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(13));

var _inherits2 = _interopRequireDefault(__webpack_require__(14));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _reactDom = _interopRequireDefault(__webpack_require__(24));

var _scrollbarSize = _interopRequireDefault(__webpack_require__(278));

var _withStyles = _interopRequireDefault(__webpack_require__(3));

var _Popover = _interopRequireDefault(__webpack_require__(620));

var _MenuList = _interopRequireDefault(__webpack_require__(282));

// @inheritedComponent Popover
var RTL_ORIGIN = {
  vertical: 'top',
  horizontal: 'right'
};
var LTR_ORIGIN = {
  vertical: 'top',
  horizontal: 'left'
};
var styles = {
  /* Styles applied to the `Paper` component. */
  paper: {
    // specZ: The maximum height of a simple menu should be one or more rows less than the view
    // height. This ensures a tapable area outside of the simple menu with which to dismiss
    // the menu.
    maxHeight: 'calc(100% - 96px)',
    // Add iOS momentum scrolling.
    WebkitOverflowScrolling: 'touch'
  }
};
exports.styles = styles;

var Menu =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(Menu, _React$Component);

  function Menu() {
    var _ref;

    var _temp, _this;

    (0, _classCallCheck2.default)(this, Menu);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return (0, _possibleConstructorReturn2.default)(_this, (_temp = _this = (0, _possibleConstructorReturn2.default)(this, (_ref = Menu.__proto__ || Object.getPrototypeOf(Menu)).call.apply(_ref, [this].concat(args))), _this.menuListRef = null, _this.getContentAnchorEl = function () {
      if (!_this.menuListRef || !_this.menuListRef.selectedItemRef) {
        return _reactDom.default.findDOMNode(_this.menuListRef).firstChild;
      }

      return _reactDom.default.findDOMNode(_this.menuListRef.selectedItemRef);
    }, _this.focus = function () {
      if (_this.menuListRef && _this.menuListRef.selectedItemRef) {
        _reactDom.default.findDOMNode(_this.menuListRef.selectedItemRef).focus();

        return;
      }

      var menuList = _reactDom.default.findDOMNode(_this.menuListRef);

      if (menuList && menuList.firstChild) {
        menuList.firstChild.focus();
      }
    }, _this.handleEnter = function (element) {
      var _this$props = _this.props,
          disableAutoFocusItem = _this$props.disableAutoFocusItem,
          theme = _this$props.theme;

      var menuList = _reactDom.default.findDOMNode(_this.menuListRef); // Focus so the scroll computation of the Popover works as expected.


      if (disableAutoFocusItem !== true) {
        _this.focus();
      } // Let's ignore that piece of logic if users are already overriding the width
      // of the menu.


      if (menuList && element.clientHeight < menuList.clientHeight && !menuList.style.width) {
        var size = "".concat((0, _scrollbarSize.default)(), "px");
        menuList.style[theme.direction === 'rtl' ? 'paddingLeft' : 'paddingRight'] = size;
        menuList.style.width = "calc(100% + ".concat(size, ")");
      }

      if (_this.props.onEnter) {
        _this.props.onEnter(element);
      }
    }, _this.handleListKeyDown = function (event, key) {
      if (key === 'tab') {
        event.preventDefault();

        if (_this.props.onClose) {
          _this.props.onClose(event);
        }
      }
    }, _temp));
  }

  (0, _createClass2.default)(Menu, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.open && this.props.disableAutoFocusItem !== true) {
        this.focus();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          children = _props.children,
          classes = _props.classes,
          disableAutoFocusItem = _props.disableAutoFocusItem,
          MenuListProps = _props.MenuListProps,
          onEnter = _props.onEnter,
          _props$PaperProps = _props.PaperProps,
          PaperProps = _props$PaperProps === void 0 ? {} : _props$PaperProps,
          PopoverClasses = _props.PopoverClasses,
          theme = _props.theme,
          other = (0, _objectWithoutProperties2.default)(_props, ["children", "classes", "disableAutoFocusItem", "MenuListProps", "onEnter", "PaperProps", "PopoverClasses", "theme"]);
      return _react.default.createElement(_Popover.default, (0, _extends2.default)({
        getContentAnchorEl: this.getContentAnchorEl,
        classes: PopoverClasses,
        onEnter: this.handleEnter,
        anchorOrigin: theme.direction === 'rtl' ? RTL_ORIGIN : LTR_ORIGIN,
        transformOrigin: theme.direction === 'rtl' ? RTL_ORIGIN : LTR_ORIGIN,
        PaperProps: (0, _objectSpread2.default)({}, PaperProps, {
          classes: (0, _objectSpread2.default)({}, PaperProps.classes, {
            root: classes.paper
          })
        })
      }, other), _react.default.createElement(_MenuList.default, (0, _extends2.default)({
        onKeyDown: this.handleListKeyDown
      }, MenuListProps, {
        ref: function ref(_ref2) {
          _this2.menuListRef = _ref2;
        }
      }), children));
    }
  }]);
  return Menu;
}(_react.default.Component);

Menu.propTypes =  false ? {
  /**
   * The DOM element used to set the position of the menu.
   */
  anchorEl: _propTypes.default.oneOfType([_propTypes.default.object, _propTypes.default.func]),

  /**
   * Menu contents, normally `MenuItem`s.
   */
  children: _propTypes.default.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * If `true`, the selected / first menu item will not be auto focused.
   */
  disableAutoFocusItem: _propTypes.default.bool,

  /**
   * Properties applied to the [`MenuList`](/api/menu-list) element.
   */
  MenuListProps: _propTypes.default.object,

  /**
   * Callback fired when the component requests to be closed.
   *
   * @param {object} event The event source of the callback
   */
  onClose: _propTypes.default.func,

  /**
   * Callback fired before the Menu enters.
   */
  onEnter: _propTypes.default.func,

  /**
   * Callback fired when the Menu has entered.
   */
  onEntered: _propTypes.default.func,

  /**
   * Callback fired when the Menu is entering.
   */
  onEntering: _propTypes.default.func,

  /**
   * Callback fired before the Menu exits.
   */
  onExit: _propTypes.default.func,

  /**
   * Callback fired when the Menu has exited.
   */
  onExited: _propTypes.default.func,

  /**
   * Callback fired when the Menu is exiting.
   */
  onExiting: _propTypes.default.func,

  /**
   * If `true`, the menu is visible.
   */
  open: _propTypes.default.bool.isRequired,

  /**
   * @ignore
   */
  PaperProps: _propTypes.default.object,

  /**
   * `classes` property applied to the `Popover` element.
   */
  PopoverClasses: _propTypes.default.object,

  /**
   * @ignore
   */
  theme: _propTypes.default.object.isRequired,

  /**
   * The length of the transition in `ms`, or 'auto'
   */
  transitionDuration: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.shape({
    enter: _propTypes.default.number,
    exit: _propTypes.default.number
  }), _propTypes.default.oneOf(['auto'])])
} : {};
Menu.defaultProps = {
  disableAutoFocusItem: false,
  transitionDuration: 'auto'
};

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiMenu',
  withTheme: true
})(Menu);

exports.default = _default;

/***/ }),
/* 620 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(2);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Popover.default;
  }
});

var _Popover = _interopRequireDefault(__webpack_require__(621));

/***/ }),
/* 621 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(2);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(6));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(4));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(11));

var _createClass2 = _interopRequireDefault(__webpack_require__(12));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(13));

var _inherits2 = _interopRequireDefault(__webpack_require__(14));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _reactDom = _interopRequireDefault(__webpack_require__(24));

var _warning = _interopRequireDefault(__webpack_require__(16));

var _debounce = _interopRequireDefault(__webpack_require__(128));

var _reactEventListener = _interopRequireDefault(__webpack_require__(102));

var _ownerDocument = _interopRequireDefault(__webpack_require__(48));

var _ownerWindow = _interopRequireDefault(__webpack_require__(125));

var _withStyles = _interopRequireDefault(__webpack_require__(3));

var _Modal = _interopRequireDefault(__webpack_require__(134));

var _Grow = _interopRequireDefault(__webpack_require__(186));

var _Paper = _interopRequireDefault(__webpack_require__(51));

// @inheritedComponent Modal
// < 1kb payload overhead when lodash/debounce is > 3kb.
function getOffsetTop(rect, vertical) {
  var offset = 0;

  if (typeof vertical === 'number') {
    offset = vertical;
  } else if (vertical === 'center') {
    offset = rect.height / 2;
  } else if (vertical === 'bottom') {
    offset = rect.height;
  }

  return offset;
}

function getOffsetLeft(rect, horizontal) {
  var offset = 0;

  if (typeof horizontal === 'number') {
    offset = horizontal;
  } else if (horizontal === 'center') {
    offset = rect.width / 2;
  } else if (horizontal === 'right') {
    offset = rect.width;
  }

  return offset;
}

function getTransformOriginValue(transformOrigin) {
  return [transformOrigin.horizontal, transformOrigin.vertical].map(function (n) {
    return typeof n === 'number' ? "".concat(n, "px") : n;
  }).join(' ');
} // Sum the scrollTop between two elements.


function getScrollParent(parent, child) {
  var element = child;
  var scrollTop = 0;

  while (element && element !== parent) {
    element = element.parentNode;
    scrollTop += element.scrollTop;
  }

  return scrollTop;
}

function getAnchorEl(anchorEl) {
  return typeof anchorEl === 'function' ? anchorEl() : anchorEl;
}

var styles = {
  /* Styles applied to the `Paper` component. */
  paper: {
    position: 'absolute',
    overflowY: 'auto',
    overflowX: 'hidden',
    // So we see the popover when it's empty.
    // It's most likely on issue on userland.
    minWidth: 16,
    minHeight: 16,
    maxWidth: 'calc(100% - 32px)',
    maxHeight: 'calc(100% - 32px)',
    // We disable the focus ring for mouse, touch and keyboard users.
    outline: 'none'
  }
};
exports.styles = styles;

var Popover =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(Popover, _React$Component);

  function Popover() {
    var _ref;

    var _temp, _this;

    (0, _classCallCheck2.default)(this, Popover);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return (0, _possibleConstructorReturn2.default)(_this, (_temp = _this = (0, _possibleConstructorReturn2.default)(this, (_ref = Popover.__proto__ || Object.getPrototypeOf(Popover)).call.apply(_ref, [this].concat(args))), _this.paperRef = null, _this.handleGetOffsetTop = getOffsetTop, _this.handleGetOffsetLeft = getOffsetLeft, _this.handleResize = (0, _debounce.default)(function () {
      _this.setPositioningStyles(_this.paperRef);
    }, 166), _this.componentWillUnmount = function () {
      _this.handleResize.clear();
    }, _this.setPositioningStyles = function (element) {
      if (element && element.style) {
        var positioning = _this.getPositioningStyle(element);

        if (positioning.top !== null) {
          element.style.top = positioning.top;
        }

        if (positioning.left !== null) {
          element.style.left = positioning.left;
        }

        element.style.transformOrigin = positioning.transformOrigin;
      }
    }, _this.getPositioningStyle = function (element) {
      var _this$props = _this.props,
          anchorEl = _this$props.anchorEl,
          anchorReference = _this$props.anchorReference,
          marginThreshold = _this$props.marginThreshold; // Check if the parent has requested anchoring on an inner content node

      var contentAnchorOffset = _this.getContentAnchorOffset(element);

      var elemRect = {
        width: element.clientWidth,
        height: element.clientHeight
      }; // Get the transform origin point on the element itself

      var transformOrigin = _this.getTransformOrigin(elemRect, contentAnchorOffset);

      if (anchorReference === 'none') {
        return {
          top: null,
          left: null,
          transformOrigin: getTransformOriginValue(transformOrigin)
        };
      } // Get the offset of of the anchoring element


      var anchorOffset = _this.getAnchorOffset(contentAnchorOffset); // Calculate element positioning


      var top = anchorOffset.top - transformOrigin.vertical;
      var left = anchorOffset.left - transformOrigin.horizontal;
      var bottom = top + elemRect.height;
      var right = left + elemRect.width; // Use the parent window of the anchorEl if provided

      var containerWindow = (0, _ownerWindow.default)(getAnchorEl(anchorEl)); // Window thresholds taking required margin into account

      var heightThreshold = containerWindow.innerHeight - marginThreshold;
      var widthThreshold = containerWindow.innerWidth - marginThreshold; // Check if the vertical axis needs shifting

      if (top < marginThreshold) {
        var diff = top - marginThreshold;
        top -= diff;
        transformOrigin.vertical += diff;
      } else if (bottom > heightThreshold) {
        var _diff = bottom - heightThreshold;

        top -= _diff;
        transformOrigin.vertical += _diff;
      }

       false ? (0, _warning.default)(elemRect.height < heightThreshold || !elemRect.height || !heightThreshold, ['Material-UI: the popover component is too tall.', "Some part of it can not be seen on the screen (".concat(elemRect.height - heightThreshold, "px)."), 'Please consider adding a `max-height` to improve the user-experience.'].join('\n')) : void 0; // Check if the horizontal axis needs shifting

      if (left < marginThreshold) {
        var _diff2 = left - marginThreshold;

        left -= _diff2;
        transformOrigin.horizontal += _diff2;
      } else if (right > widthThreshold) {
        var _diff3 = right - widthThreshold;

        left -= _diff3;
        transformOrigin.horizontal += _diff3;
      }

      return {
        top: "".concat(top, "px"),
        left: "".concat(left, "px"),
        transformOrigin: getTransformOriginValue(transformOrigin)
      };
    }, _this.handleEnter = function (element) {
      if (_this.props.onEnter) {
        _this.props.onEnter(element);
      }

      _this.setPositioningStyles(element);
    }, _temp));
  }

  (0, _createClass2.default)(Popover, [{
    key: "componentDidMount",
    // Corresponds to 10 frames at 60 Hz.
    value: function componentDidMount() {
      if (this.props.action) {
        this.props.action({
          updatePosition: this.handleResize
        });
      }
    }
  }, {
    key: "getAnchorOffset",
    // Returns the top/left offset of the position
    // to attach to on the anchor element (or body if none is provided)
    value: function getAnchorOffset(contentAnchorOffset) {
      var _props = this.props,
          anchorEl = _props.anchorEl,
          anchorOrigin = _props.anchorOrigin,
          anchorReference = _props.anchorReference,
          anchorPosition = _props.anchorPosition;

      if (anchorReference === 'anchorPosition') {
         false ? (0, _warning.default)(anchorPosition, 'Material-UI: you need to provide a `anchorPosition` property when using ' + '<Popover anchorReference="anchorPosition" />.') : void 0;
        return anchorPosition;
      } // If an anchor element wasn't provided, just use the parent body element of this Popover


      var anchorElement = getAnchorEl(anchorEl) || (0, _ownerDocument.default)(this.paperRef).body;
      var anchorRect = anchorElement.getBoundingClientRect();
      var anchorVertical = contentAnchorOffset === 0 ? anchorOrigin.vertical : 'center';
      return {
        top: anchorRect.top + this.handleGetOffsetTop(anchorRect, anchorVertical),
        left: anchorRect.left + this.handleGetOffsetLeft(anchorRect, anchorOrigin.horizontal)
      };
    } // Returns the vertical offset of inner content to anchor the transform on if provided

  }, {
    key: "getContentAnchorOffset",
    value: function getContentAnchorOffset(element) {
      var _props2 = this.props,
          getContentAnchorEl = _props2.getContentAnchorEl,
          anchorReference = _props2.anchorReference;
      var contentAnchorOffset = 0;

      if (getContentAnchorEl && anchorReference === 'anchorEl') {
        var contentAnchorEl = getContentAnchorEl(element);

        if (contentAnchorEl && element.contains(contentAnchorEl)) {
          var scrollTop = getScrollParent(element, contentAnchorEl);
          contentAnchorOffset = contentAnchorEl.offsetTop + contentAnchorEl.clientHeight / 2 - scrollTop || 0;
        } // != the default value


         false ? (0, _warning.default)(this.props.anchorOrigin.vertical === 'top', ['Material-UI: you can not change the default `anchorOrigin.vertical` value ', 'when also providing the `getContentAnchorEl` property to the popover component.', 'Only use one of the two properties.', 'Set `getContentAnchorEl` to null or leave `anchorOrigin.vertical` unchanged.'].join('\n')) : void 0;
      }

      return contentAnchorOffset;
    } // Return the base transform origin using the element
    // and taking the content anchor offset into account if in use

  }, {
    key: "getTransformOrigin",
    value: function getTransformOrigin(elemRect) {
      var contentAnchorOffset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      var transformOrigin = this.props.transformOrigin;
      return {
        vertical: this.handleGetOffsetTop(elemRect, transformOrigin.vertical) + contentAnchorOffset,
        horizontal: this.handleGetOffsetLeft(elemRect, transformOrigin.horizontal)
      };
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _props3 = this.props,
          action = _props3.action,
          anchorEl = _props3.anchorEl,
          anchorOrigin = _props3.anchorOrigin,
          anchorPosition = _props3.anchorPosition,
          anchorReference = _props3.anchorReference,
          children = _props3.children,
          classes = _props3.classes,
          containerProp = _props3.container,
          elevation = _props3.elevation,
          getContentAnchorEl = _props3.getContentAnchorEl,
          marginThreshold = _props3.marginThreshold,
          onEnter = _props3.onEnter,
          onEntered = _props3.onEntered,
          onEntering = _props3.onEntering,
          onExit = _props3.onExit,
          onExited = _props3.onExited,
          onExiting = _props3.onExiting,
          open = _props3.open,
          PaperProps = _props3.PaperProps,
          role = _props3.role,
          transformOrigin = _props3.transformOrigin,
          TransitionComponent = _props3.TransitionComponent,
          transitionDurationProp = _props3.transitionDuration,
          TransitionProps = _props3.TransitionProps,
          other = (0, _objectWithoutProperties2.default)(_props3, ["action", "anchorEl", "anchorOrigin", "anchorPosition", "anchorReference", "children", "classes", "container", "elevation", "getContentAnchorEl", "marginThreshold", "onEnter", "onEntered", "onEntering", "onExit", "onExited", "onExiting", "open", "PaperProps", "role", "transformOrigin", "TransitionComponent", "transitionDuration", "TransitionProps"]);
      var transitionDuration = transitionDurationProp;

      if (transitionDurationProp === 'auto' && !TransitionComponent.muiSupportAuto) {
        transitionDuration = undefined;
      } // If the container prop is provided, use that
      // If the anchorEl prop is provided, use its parent body element as the container
      // If neither are provided let the Modal take care of choosing the container


      var container = containerProp || (anchorEl ? (0, _ownerDocument.default)(getAnchorEl(anchorEl)).body : undefined);
      return _react.default.createElement(_Modal.default, (0, _extends2.default)({
        container: container,
        open: open,
        BackdropProps: {
          invisible: true
        }
      }, other), _react.default.createElement(TransitionComponent, (0, _extends2.default)({
        appear: true,
        "in": open,
        onEnter: this.handleEnter,
        onEntered: onEntered,
        onEntering: onEntering,
        onExit: onExit,
        onExited: onExited,
        onExiting: onExiting,
        role: role,
        timeout: transitionDuration
      }, TransitionProps), _react.default.createElement(_Paper.default, (0, _extends2.default)({
        className: classes.paper,
        elevation: elevation,
        ref: function ref(_ref2) {
          _this2.paperRef = _reactDom.default.findDOMNode(_ref2);
        }
      }, PaperProps), _react.default.createElement(_reactEventListener.default, {
        target: "window",
        onResize: this.handleResize
      }), children)));
    }
  }]);
  return Popover;
}(_react.default.Component);

Popover.propTypes =  false ? {
  /**
   * This is callback property. It's called by the component on mount.
   * This is useful when you want to trigger an action programmatically.
   * It currently only supports updatePosition() action.
   *
   * @param {object} actions This object contains all posible actions
   * that can be triggered programmatically.
   */
  action: _propTypes.default.func,

  /**
   * This is the DOM element, or a function that returns the DOM element,
   * that may be used to set the position of the popover.
   */
  anchorEl: _propTypes.default.oneOfType([_propTypes.default.object, _propTypes.default.func]),

  /**
   * This is the point on the anchor where the popover's
   * `anchorEl` will attach to. This is not used when the
   * anchorReference is 'anchorPosition'.
   *
   * Options:
   * vertical: [top, center, bottom];
   * horizontal: [left, center, right].
   */
  anchorOrigin: _propTypes.default.shape({
    horizontal: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.oneOf(['left', 'center', 'right'])]).isRequired,
    vertical: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.oneOf(['top', 'center', 'bottom'])]).isRequired
  }),

  /**
   * This is the position that may be used
   * to set the position of the popover.
   * The coordinates are relative to
   * the application's client area.
   */
  anchorPosition: _propTypes.default.shape({
    left: _propTypes.default.number.isRequired,
    top: _propTypes.default.number.isRequired
  }),

  /*
   * This determines which anchor prop to refer to to set
   * the position of the popover.
   */
  anchorReference: _propTypes.default.oneOf(['anchorEl', 'anchorPosition', 'none']),

  /**
   * The content of the component.
   */
  children: _propTypes.default.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * A node, component instance, or function that returns either.
   * The `container` will passed to the Modal component.
   * By default, it uses the body of the anchorEl's top-level document object,
   * so it's simply `document.body` most of the time.
   */
  container: _propTypes.default.oneOfType([_propTypes.default.object, _propTypes.default.func]),

  /**
   * The elevation of the popover.
   */
  elevation: _propTypes.default.number,

  /**
   * This function is called in order to retrieve the content anchor element.
   * It's the opposite of the `anchorEl` property.
   * The content anchor element should be an element inside the popover.
   * It's used to correctly scroll and set the position of the popover.
   * The positioning strategy tries to make the content anchor element just above the
   * anchor element.
   */
  getContentAnchorEl: _propTypes.default.func,

  /**
   * Specifies how close to the edge of the window the popover can appear.
   */
  marginThreshold: _propTypes.default.number,

  /**
   * Callback fired when the component requests to be closed.
   *
   * @param {object} event The event source of the callback.
   */
  onClose: _propTypes.default.func,

  /**
   * Callback fired before the component is entering.
   */
  onEnter: _propTypes.default.func,

  /**
   * Callback fired when the component has entered.
   */
  onEntered: _propTypes.default.func,

  /**
   * Callback fired when the component is entering.
   */
  onEntering: _propTypes.default.func,

  /**
   * Callback fired before the component is exiting.
   */
  onExit: _propTypes.default.func,

  /**
   * Callback fired when the component has exited.
   */
  onExited: _propTypes.default.func,

  /**
   * Callback fired when the component is exiting.
   */
  onExiting: _propTypes.default.func,

  /**
   * If `true`, the popover is visible.
   */
  open: _propTypes.default.bool.isRequired,

  /**
   * Properties applied to the [`Paper`](/api/paper) element.
   */
  PaperProps: _propTypes.default.object,

  /**
   * @ignore
   */
  role: _propTypes.default.string,

  /**
   * This is the point on the popover which
   * will attach to the anchor's origin.
   *
   * Options:
   * vertical: [top, center, bottom, x(px)];
   * horizontal: [left, center, right, x(px)].
   */
  transformOrigin: _propTypes.default.shape({
    horizontal: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.oneOf(['left', 'center', 'right'])]).isRequired,
    vertical: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.oneOf(['top', 'center', 'bottom'])]).isRequired
  }),

  /**
   * Transition component.
   */
  TransitionComponent: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func, _propTypes.default.object]),

  /**
   * Set to 'auto' to automatically calculate transition time based on height.
   */
  transitionDuration: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.shape({
    enter: _propTypes.default.number,
    exit: _propTypes.default.number
  }), _propTypes.default.oneOf(['auto'])]),

  /**
   * Properties applied to the `Transition` element.
   */
  TransitionProps: _propTypes.default.object
} : {};
Popover.defaultProps = {
  anchorReference: 'anchorEl',
  anchorOrigin: {
    vertical: 'top',
    horizontal: 'left'
  },
  elevation: 8,
  marginThreshold: 16,
  transformOrigin: {
    vertical: 'top',
    horizontal: 'left'
  },
  TransitionComponent: _Grow.default,
  transitionDuration: 'auto'
};

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiPopover'
})(Popover);

exports.default = _default;

/***/ }),
/* 622 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(2);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(6));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(7));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(4));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(11));

var _createClass2 = _interopRequireDefault(__webpack_require__(12));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(13));

var _inherits2 = _interopRequireDefault(__webpack_require__(14));

var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(88));

var _react = _interopRequireDefault(__webpack_require__(0));

var _reactDom = _interopRequireDefault(__webpack_require__(24));

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _classnames = _interopRequireDefault(__webpack_require__(5));

var _warning = _interopRequireDefault(__webpack_require__(16));

var _keycode = _interopRequireDefault(__webpack_require__(99));

var _ownerDocument = _interopRequireDefault(__webpack_require__(48));

var _RootRef = _interopRequireDefault(__webpack_require__(263));

var _Portal = _interopRequireDefault(__webpack_require__(265));

var _helpers = __webpack_require__(37);

var _withStyles = _interopRequireDefault(__webpack_require__(3));

var _ModalManager = _interopRequireDefault(__webpack_require__(280));

var _Backdrop = _interopRequireDefault(__webpack_require__(634));

function getContainer(container, defaultContainer) {
  container = typeof container === 'function' ? container() : container;
  return _reactDom.default.findDOMNode(container) || defaultContainer;
}

function getHasTransition(props) {
  return props.children ? props.children.props.hasOwnProperty('in') : false;
}

var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      position: 'fixed',
      zIndex: theme.zIndex.modal,
      right: 0,
      bottom: 0,
      top: 0,
      left: 0
    },

    /* Styles applied to the root element if the `Modal` has exited. */
    hidden: {
      visibility: 'hidden'
    }
  };
};
/* istanbul ignore if */


exports.styles = styles;

if (false) {
  throw new Error('Material-UI: react@16.3.0 or greater is required.');
}
/**
 * This component shares many concepts with [react-overlays](https://react-bootstrap.github.io/react-overlays/#modals).
 */


var Modal =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(Modal, _React$Component);

  function Modal(props) {
    var _this;

    (0, _classCallCheck2.default)(this, Modal);
    _this = (0, _possibleConstructorReturn2.default)(this, (Modal.__proto__ || Object.getPrototypeOf(Modal)).call(this, props));
    _this.mountNode = null;
    _this.modalRef = null;
    _this.dialogRef = null;
    _this.mounted = false;

    _this.handleRendered = function () {
      _this.autoFocus(); // Fix a bug on Chrome where the scroll isn't initially 0.


      _this.modalRef.scrollTop = 0;

      if (_this.props.onRendered) {
        _this.props.onRendered();
      }
    };

    _this.handleOpen = function () {
      var doc = (0, _ownerDocument.default)(_this.mountNode);
      var container = getContainer(_this.props.container, doc.body);

      _this.props.manager.add((0, _assertThisInitialized2.default)(_this), container);

      doc.addEventListener('keydown', _this.handleDocumentKeyDown);
      doc.addEventListener('focus', _this.enforceFocus, true);
    };

    _this.handleClose = function () {
      _this.props.manager.remove((0, _assertThisInitialized2.default)(_this));

      var doc = (0, _ownerDocument.default)(_this.mountNode);
      doc.removeEventListener('keydown', _this.handleDocumentKeyDown);
      doc.removeEventListener('focus', _this.enforceFocus, true);

      _this.restoreLastFocus();
    };

    _this.handleExited = function () {
      _this.setState({
        exited: true
      });

      _this.handleClose();
    };

    _this.handleBackdropClick = function (event) {
      if (event.target !== event.currentTarget) {
        return;
      }

      if (_this.props.onBackdropClick) {
        _this.props.onBackdropClick(event);
      }

      if (!_this.props.disableBackdropClick && _this.props.onClose) {
        _this.props.onClose(event, 'backdropClick');
      }
    };

    _this.handleDocumentKeyDown = function (event) {
      if (!_this.isTopModal() || (0, _keycode.default)(event) !== 'esc') {
        return;
      } // Ignore events that have been `event.preventDefault()` marked.


      if (event.defaultPrevented) {
        return;
      }

      if (_this.props.onEscapeKeyDown) {
        _this.props.onEscapeKeyDown(event);
      }

      if (!_this.props.disableEscapeKeyDown && _this.props.onClose) {
        _this.props.onClose(event, 'escapeKeyDown');
      }
    };

    _this.checkForFocus = function () {
      _this.lastFocus = (0, _ownerDocument.default)(_this.mountNode).activeElement;
    };

    _this.enforceFocus = function () {
      if (_this.props.disableEnforceFocus || !_this.mounted || !_this.isTopModal()) {
        return;
      }

      var currentActiveElement = (0, _ownerDocument.default)(_this.mountNode).activeElement;

      if (_this.dialogRef && !_this.dialogRef.contains(currentActiveElement)) {
        _this.dialogRef.focus();
      }
    };

    _this.state = {
      exited: !_this.props.open
    };
    return _this;
  }

  (0, _createClass2.default)(Modal, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.mounted = true;

      if (this.props.open) {
        this.handleOpen();
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (!prevProps.open && this.props.open) {
        this.checkForFocus();
      }

      if (prevProps.open && !this.props.open && !getHasTransition(this.props)) {
        // Otherwise handleExited will call this.
        this.handleClose();
      } else if (!prevProps.open && this.props.open) {
        this.handleOpen();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.mounted = false;

      if (this.props.open || getHasTransition(this.props) && !this.state.exited) {
        this.handleClose();
      }
    }
  }, {
    key: "autoFocus",
    value: function autoFocus() {
      if (this.props.disableAutoFocus) {
        return;
      }

      var currentActiveElement = (0, _ownerDocument.default)(this.mountNode).activeElement;

      if (this.dialogRef && !this.dialogRef.contains(currentActiveElement)) {
        this.lastFocus = currentActiveElement;

        if (!this.dialogRef.hasAttribute('tabIndex')) {
           false ? (0, _warning.default)(false, ['Material-UI: the modal content node does not accept focus.', 'For the benefit of assistive technologies, ' + 'the tabIndex of the node is being set to "-1".'].join('\n')) : void 0;
          this.dialogRef.setAttribute('tabIndex', -1);
        }

        this.dialogRef.focus();
      }
    }
  }, {
    key: "restoreLastFocus",
    value: function restoreLastFocus() {
      if (this.props.disableRestoreFocus) {
        return;
      }

      if (this.lastFocus) {
        // Not all elements in IE11 have a focus method.
        // Because IE11 market share is low, we accept the restore focus being broken
        // and we silent the issue.
        if (this.lastFocus.focus) {
          this.lastFocus.focus();
        }

        this.lastFocus = null;
      }
    }
  }, {
    key: "isTopModal",
    value: function isTopModal() {
      return this.props.manager.isTopModal(this);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          BackdropComponent = _props.BackdropComponent,
          BackdropProps = _props.BackdropProps,
          children = _props.children,
          classes = _props.classes,
          className = _props.className,
          container = _props.container,
          disableAutoFocus = _props.disableAutoFocus,
          disableBackdropClick = _props.disableBackdropClick,
          disableEnforceFocus = _props.disableEnforceFocus,
          disableEscapeKeyDown = _props.disableEscapeKeyDown,
          disablePortal = _props.disablePortal,
          disableRestoreFocus = _props.disableRestoreFocus,
          hideBackdrop = _props.hideBackdrop,
          keepMounted = _props.keepMounted,
          manager = _props.manager,
          onBackdropClick = _props.onBackdropClick,
          onClose = _props.onClose,
          onEscapeKeyDown = _props.onEscapeKeyDown,
          onRendered = _props.onRendered,
          open = _props.open,
          other = (0, _objectWithoutProperties2.default)(_props, ["BackdropComponent", "BackdropProps", "children", "classes", "className", "container", "disableAutoFocus", "disableBackdropClick", "disableEnforceFocus", "disableEscapeKeyDown", "disablePortal", "disableRestoreFocus", "hideBackdrop", "keepMounted", "manager", "onBackdropClick", "onClose", "onEscapeKeyDown", "onRendered", "open"]);
      var exited = this.state.exited;
      var hasTransition = getHasTransition(this.props);
      var childProps = {};

      if (!keepMounted && !open && (!hasTransition || exited)) {
        return null;
      } // It's a Transition like component


      if (hasTransition) {
        childProps.onExited = (0, _helpers.createChainedFunction)(this.handleExited, children.props.onExited);
      }

      if (children.props.role === undefined) {
        childProps.role = children.props.role || 'document';
      }

      if (children.props.tabIndex === undefined) {
        childProps.tabIndex = children.props.tabIndex || '-1';
      }

      return _react.default.createElement(_Portal.default, {
        ref: function ref(_ref2) {
          _this2.mountNode = _ref2 ? _ref2.getMountNode() : _ref2;
        },
        container: container,
        disablePortal: disablePortal,
        onRendered: this.handleRendered
      }, _react.default.createElement("div", (0, _extends2.default)({
        ref: function ref(_ref) {
          _this2.modalRef = _ref;
        },
        className: (0, _classnames.default)(classes.root, className, (0, _defineProperty2.default)({}, classes.hidden, exited))
      }, other), hideBackdrop ? null : _react.default.createElement(BackdropComponent, (0, _extends2.default)({
        open: open,
        onClick: this.handleBackdropClick
      }, BackdropProps)), _react.default.createElement(_RootRef.default, {
        rootRef: function rootRef(ref) {
          _this2.dialogRef = ref;
        }
      }, _react.default.cloneElement(children, childProps))));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps) {
      if (nextProps.open) {
        return {
          exited: false
        };
      }

      if (!getHasTransition(nextProps)) {
        // Otherwise let handleExited take care of marking exited.
        return {
          exited: true
        };
      }

      return null;
    }
  }]);
  return Modal;
}(_react.default.Component);

Modal.propTypes =  false ? {
  /**
   * A backdrop component. This property enables custom backdrop rendering.
   */
  BackdropComponent: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func, _propTypes.default.object]),

  /**
   * Properties applied to the [`Backdrop`](/api/backdrop) element.
   */
  BackdropProps: _propTypes.default.object,

  /**
   * A single child content element.
   */
  children: _propTypes.default.element,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * A node, component instance, or function that returns either.
   * The `container` will have the portal children appended to it.
   */
  container: _propTypes.default.oneOfType([_propTypes.default.object, _propTypes.default.func]),

  /**
   * If `true`, the modal will not automatically shift focus to itself when it opens, and
   * replace it to the last focused element when it closes.
   * This also works correctly with any modal children that have the `disableAutoFocus` prop.
   *
   * Generally this should never be set to `true` as it makes the modal less
   * accessible to assistive technologies, like screen readers.
   */
  disableAutoFocus: _propTypes.default.bool,

  /**
   * If `true`, clicking the backdrop will not fire any callback.
   */
  disableBackdropClick: _propTypes.default.bool,

  /**
   * If `true`, the modal will not prevent focus from leaving the modal while open.
   *
   * Generally this should never be set to `true` as it makes the modal less
   * accessible to assistive technologies, like screen readers.
   */
  disableEnforceFocus: _propTypes.default.bool,

  /**
   * If `true`, hitting escape will not fire any callback.
   */
  disableEscapeKeyDown: _propTypes.default.bool,

  /**
   * Disable the portal behavior.
   * The children stay within it's parent DOM hierarchy.
   */
  disablePortal: _propTypes.default.bool,

  /**
   * If `true`, the modal will not restore focus to previously focused element once
   * modal is hidden.
   */
  disableRestoreFocus: _propTypes.default.bool,

  /**
   * If `true`, the backdrop is not rendered.
   */
  hideBackdrop: _propTypes.default.bool,

  /**
   * Always keep the children in the DOM.
   * This property can be useful in SEO situation or
   * when you want to maximize the responsiveness of the Modal.
   */
  keepMounted: _propTypes.default.bool,

  /**
   * A modal manager used to track and manage the state of open
   * Modals. This enables customizing how modals interact within a container.
   */
  manager: _propTypes.default.object,

  /**
   * Callback fired when the backdrop is clicked.
   */
  onBackdropClick: _propTypes.default.func,

  /**
   * Callback fired when the component requests to be closed.
   * The `reason` parameter can optionally be used to control the response to `onClose`.
   *
   * @param {object} event The event source of the callback
   * @param {string} reason Can be:`"escapeKeyDown"`, `"backdropClick"`
   */
  onClose: _propTypes.default.func,

  /**
   * Callback fired when the escape key is pressed,
   * `disableEscapeKeyDown` is false and the modal is in focus.
   */
  onEscapeKeyDown: _propTypes.default.func,

  /**
   * Callback fired once the children has been mounted into the `container`.
   * It signals that the `open={true}` property took effect.
   */
  onRendered: _propTypes.default.func,

  /**
   * If `true`, the modal is open.
   */
  open: _propTypes.default.bool.isRequired
} : {};
Modal.defaultProps = {
  disableAutoFocus: false,
  disableBackdropClick: false,
  disableEnforceFocus: false,
  disableEscapeKeyDown: false,
  disablePortal: false,
  disableRestoreFocus: false,
  hideBackdrop: false,
  keepMounted: false,
  // Modals don't open on the server so this won't conflict with concurrent requests.
  manager: new _ModalManager.default(),
  BackdropComponent: _Backdrop.default
};

var _default = (0, _withStyles.default)(styles, {
  flip: false,
  name: 'MuiModal'
})(Modal);

exports.default = _default;

/***/ }),
/* 623 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = style;

var _camelizeStyle = __webpack_require__(281);

var _camelizeStyle2 = _interopRequireDefault(_camelizeStyle);

var _hyphenateStyle = __webpack_require__(625);

var _hyphenateStyle2 = _interopRequireDefault(_hyphenateStyle);

var _getComputedStyle2 = __webpack_require__(627);

var _getComputedStyle3 = _interopRequireDefault(_getComputedStyle2);

var _removeStyle = __webpack_require__(628);

var _removeStyle2 = _interopRequireDefault(_removeStyle);

var _properties = __webpack_require__(629);

var _isTransform = __webpack_require__(630);

var _isTransform2 = _interopRequireDefault(_isTransform);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function style(node, property, value) {
  var css = '';
  var transforms = '';
  var props = property;

  if (typeof property === 'string') {
    if (value === undefined) {
      return node.style[(0, _camelizeStyle2.default)(property)] || (0, _getComputedStyle3.default)(node).getPropertyValue((0, _hyphenateStyle2.default)(property));
    } else {
      (props = {})[property] = value;
    }
  }

  Object.keys(props).forEach(function (key) {
    var value = props[key];
    if (!value && value !== 0) {
      (0, _removeStyle2.default)(node, (0, _hyphenateStyle2.default)(key));
    } else if ((0, _isTransform2.default)(key)) {
      transforms += key + '(' + value + ') ';
    } else {
      css += (0, _hyphenateStyle2.default)(key) + ': ' + value + ';';
    }
  });

  if (transforms) {
    css += _properties.transform + ': ' + transforms + ';';
  }

  node.style.cssText += ';' + css;
}
module.exports = exports['default'];

/***/ }),
/* 624 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = camelize;
var rHyphen = /-(.)/g;

function camelize(string) {
  return string.replace(rHyphen, function (_, chr) {
    return chr.toUpperCase();
  });
}
module.exports = exports["default"];

/***/ }),
/* 625 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = hyphenateStyleName;

var _hyphenate = __webpack_require__(626);

var _hyphenate2 = _interopRequireDefault(_hyphenate);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var msPattern = /^ms-/; /**
                         * Copyright 2013-2014, Facebook, Inc.
                         * All rights reserved.
                         * https://github.com/facebook/react/blob/2aeb8a2a6beb00617a4217f7f8284924fa2ad819/src/vendor/core/hyphenateStyleName.js
                         */

function hyphenateStyleName(string) {
  return (0, _hyphenate2.default)(string).replace(msPattern, '-ms-');
}
module.exports = exports['default'];

/***/ }),
/* 626 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = hyphenate;

var rUpper = /([A-Z])/g;

function hyphenate(string) {
  return string.replace(rUpper, '-$1').toLowerCase();
}
module.exports = exports['default'];

/***/ }),
/* 627 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _getComputedStyle;

var _camelizeStyle = __webpack_require__(281);

var _camelizeStyle2 = _interopRequireDefault(_camelizeStyle);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var rposition = /^(top|right|bottom|left)$/;
var rnumnonpx = /^([+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|))(?!px)[a-z%]+$/i;

function _getComputedStyle(node) {
  if (!node) throw new TypeError('No Element passed to `getComputedStyle()`');
  var doc = node.ownerDocument;

  return 'defaultView' in doc ? doc.defaultView.opener ? node.ownerDocument.defaultView.getComputedStyle(node, null) : window.getComputedStyle(node, null) : {
    //ie 8 "magic" from: https://github.com/jquery/jquery/blob/1.11-stable/src/css/curCSS.js#L72
    getPropertyValue: function getPropertyValue(prop) {
      var style = node.style;

      prop = (0, _camelizeStyle2.default)(prop);

      if (prop == 'float') prop = 'styleFloat';

      var current = node.currentStyle[prop] || null;

      if (current == null && style && style[prop]) current = style[prop];

      if (rnumnonpx.test(current) && !rposition.test(prop)) {
        // Remember the original values
        var left = style.left;
        var runStyle = node.runtimeStyle;
        var rsLeft = runStyle && runStyle.left;

        // Put in the new values to get a computed value out
        if (rsLeft) runStyle.left = node.currentStyle.left;

        style.left = prop === 'fontSize' ? '1em' : current;
        current = style.pixelLeft + 'px';

        // Revert the changed values
        style.left = left;
        if (rsLeft) runStyle.left = rsLeft;
      }

      return current;
    }
  };
}
module.exports = exports['default'];

/***/ }),
/* 628 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = removeStyle;
function removeStyle(node, key) {
  return 'removeProperty' in node.style ? node.style.removeProperty(key) : node.style.removeAttribute(key);
}
module.exports = exports['default'];

/***/ }),
/* 629 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.animationEnd = exports.animationDelay = exports.animationTiming = exports.animationDuration = exports.animationName = exports.transitionEnd = exports.transitionDuration = exports.transitionDelay = exports.transitionTiming = exports.transitionProperty = exports.transform = undefined;

var _inDOM = __webpack_require__(279);

var _inDOM2 = _interopRequireDefault(_inDOM);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var transform = 'transform';
var prefix = void 0,
    transitionEnd = void 0,
    animationEnd = void 0;
var transitionProperty = void 0,
    transitionDuration = void 0,
    transitionTiming = void 0,
    transitionDelay = void 0;
var animationName = void 0,
    animationDuration = void 0,
    animationTiming = void 0,
    animationDelay = void 0;

if (_inDOM2.default) {
  var _getTransitionPropert = getTransitionProperties();

  prefix = _getTransitionPropert.prefix;
  exports.transitionEnd = transitionEnd = _getTransitionPropert.transitionEnd;
  exports.animationEnd = animationEnd = _getTransitionPropert.animationEnd;


  exports.transform = transform = prefix + '-' + transform;
  exports.transitionProperty = transitionProperty = prefix + '-transition-property';
  exports.transitionDuration = transitionDuration = prefix + '-transition-duration';
  exports.transitionDelay = transitionDelay = prefix + '-transition-delay';
  exports.transitionTiming = transitionTiming = prefix + '-transition-timing-function';

  exports.animationName = animationName = prefix + '-animation-name';
  exports.animationDuration = animationDuration = prefix + '-animation-duration';
  exports.animationTiming = animationTiming = prefix + '-animation-delay';
  exports.animationDelay = animationDelay = prefix + '-animation-timing-function';
}

exports.transform = transform;
exports.transitionProperty = transitionProperty;
exports.transitionTiming = transitionTiming;
exports.transitionDelay = transitionDelay;
exports.transitionDuration = transitionDuration;
exports.transitionEnd = transitionEnd;
exports.animationName = animationName;
exports.animationDuration = animationDuration;
exports.animationTiming = animationTiming;
exports.animationDelay = animationDelay;
exports.animationEnd = animationEnd;
exports.default = {
  transform: transform,
  end: transitionEnd,
  property: transitionProperty,
  timing: transitionTiming,
  delay: transitionDelay,
  duration: transitionDuration
};


function getTransitionProperties() {
  var style = document.createElement('div').style;

  var vendorMap = {
    O: function O(e) {
      return 'o' + e.toLowerCase();
    },
    Moz: function Moz(e) {
      return e.toLowerCase();
    },
    Webkit: function Webkit(e) {
      return 'webkit' + e;
    },
    ms: function ms(e) {
      return 'MS' + e;
    }
  };

  var vendors = Object.keys(vendorMap);

  var transitionEnd = void 0,
      animationEnd = void 0;
  var prefix = '';

  for (var i = 0; i < vendors.length; i++) {
    var vendor = vendors[i];

    if (vendor + 'TransitionProperty' in style) {
      prefix = '-' + vendor.toLowerCase();
      transitionEnd = vendorMap[vendor]('TransitionEnd');
      animationEnd = vendorMap[vendor]('AnimationEnd');
      break;
    }
  }

  if (!transitionEnd && 'transitionProperty' in style) transitionEnd = 'transitionend';

  if (!animationEnd && 'animationName' in style) animationEnd = 'animationend';

  style = null;

  return { animationEnd: animationEnd, transitionEnd: transitionEnd, prefix: prefix };
}

/***/ }),
/* 630 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isTransform;
var supportedTransforms = /^((translate|rotate|scale)(X|Y|Z|3d)?|matrix(3d)?|perspective|skew(X|Y)?)$/i;

function isTransform(property) {
  return !!(property && supportedTransforms.test(property));
}
module.exports = exports["default"];

/***/ }),
/* 631 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(2);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isBody = isBody;
exports.default = isOverflowing;

var _isWindow = _interopRequireDefault(__webpack_require__(632));

var _ownerDocument = _interopRequireDefault(__webpack_require__(48));

var _ownerWindow = _interopRequireDefault(__webpack_require__(125));

function isBody(node) {
  return node && node.tagName.toLowerCase() === 'body';
} // Do we have a scroll bar?


function isOverflowing(container) {
  var doc = (0, _ownerDocument.default)(container);
  var win = (0, _ownerWindow.default)(doc);
  /* istanbul ignore next */

  if (!(0, _isWindow.default)(doc) && !isBody(container)) {
    return container.scrollHeight > container.clientHeight;
  } // Takes in account potential non zero margin on the body.


  var style = win.getComputedStyle(doc.body);
  var marginLeft = parseInt(style.getPropertyValue('margin-left'), 10);
  var marginRight = parseInt(style.getPropertyValue('margin-right'), 10);
  return marginLeft + doc.body.clientWidth + marginRight < win.innerWidth;
}

/***/ }),
/* 632 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getWindow;
function getWindow(node) {
  return node === node.window ? node : node.nodeType === 9 ? node.defaultView || node.parentWindow : false;
}
module.exports = exports["default"];

/***/ }),
/* 633 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ariaHidden = ariaHidden;
exports.hideSiblings = hideSiblings;
exports.showSiblings = showSiblings;
var BLACKLIST = ['template', 'script', 'style'];

function isHidable(node) {
  return node.nodeType === 1 && BLACKLIST.indexOf(node.tagName.toLowerCase()) === -1;
}

function siblings(container, mount, callback) {
  mount = [].concat(mount); // eslint-disable-line no-param-reassign

  [].forEach.call(container.children, function (node) {
    if (mount.indexOf(node) === -1 && isHidable(node)) {
      callback(node);
    }
  });
}

function ariaHidden(show, node) {
  if (!node) {
    return;
  }

  if (show) {
    node.setAttribute('aria-hidden', 'true');
  } else {
    node.removeAttribute('aria-hidden');
  }
}

function hideSiblings(container, mountNode) {
  siblings(container, mountNode, function (node) {
    return ariaHidden(true, node);
  });
}

function showSiblings(container, mountNode) {
  siblings(container, mountNode, function (node) {
    return ariaHidden(false, node);
  });
}

/***/ }),
/* 634 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(2);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Backdrop.default;
  }
});

var _Backdrop = _interopRequireDefault(__webpack_require__(635));

/***/ }),
/* 635 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(2);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(6));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(7));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(4));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _classnames = _interopRequireDefault(__webpack_require__(5));

var _withStyles = _interopRequireDefault(__webpack_require__(3));

var _Fade = _interopRequireDefault(__webpack_require__(636));

var styles = {
  /* Styles applied to the root element. */
  root: {
    zIndex: -1,
    position: 'fixed',
    right: 0,
    bottom: 0,
    top: 0,
    left: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    // Remove grey highlight
    WebkitTapHighlightColor: 'transparent',
    // Disable scroll capabilities.
    touchAction: 'none'
  },

  /* Styles applied to the root element if `invisible={true}`. */
  invisible: {
    backgroundColor: 'transparent'
  }
};
exports.styles = styles;

function Backdrop(props) {
  var classes = props.classes,
      className = props.className,
      invisible = props.invisible,
      open = props.open,
      transitionDuration = props.transitionDuration,
      other = (0, _objectWithoutProperties2.default)(props, ["classes", "className", "invisible", "open", "transitionDuration"]);
  return _react.default.createElement(_Fade.default, (0, _extends2.default)({
    appear: true,
    "in": open,
    timeout: transitionDuration
  }, other), _react.default.createElement("div", {
    className: (0, _classnames.default)(classes.root, (0, _defineProperty2.default)({}, classes.invisible, invisible), className),
    "aria-hidden": "true"
  }));
}

Backdrop.propTypes =  false ? {
  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * If `true`, the backdrop is invisible.
   * It can be used when rendering a popover or a custom select component.
   */
  invisible: _propTypes.default.bool,

  /**
   * If `true`, the backdrop is open.
   */
  open: _propTypes.default.bool.isRequired,

  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   */
  transitionDuration: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.shape({
    enter: _propTypes.default.number,
    exit: _propTypes.default.number
  })])
} : {};
Backdrop.defaultProps = {
  invisible: false
};

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiBackdrop'
})(Backdrop);

exports.default = _default;

/***/ }),
/* 636 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(2);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Fade.default;
  }
});

var _Fade = _interopRequireDefault(__webpack_require__(637));

/***/ }),
/* 637 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(2);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(6));

var _objectSpread2 = _interopRequireDefault(__webpack_require__(17));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(4));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(11));

var _createClass2 = _interopRequireDefault(__webpack_require__(12));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(13));

var _inherits2 = _interopRequireDefault(__webpack_require__(14));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _Transition = _interopRequireDefault(__webpack_require__(62));

var _transitions = __webpack_require__(93);

var _withTheme = _interopRequireDefault(__webpack_require__(71));

var _utils = __webpack_require__(131);

// @inheritedComponent Transition
var styles = {
  entering: {
    opacity: 1
  },
  entered: {
    opacity: 1
  }
};
/**
 * The Fade transition is used by the [Modal](/utils/modal) component.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */

var Fade =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(Fade, _React$Component);

  function Fade() {
    var _ref;

    var _temp, _this;

    (0, _classCallCheck2.default)(this, Fade);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return (0, _possibleConstructorReturn2.default)(_this, (_temp = _this = (0, _possibleConstructorReturn2.default)(this, (_ref = Fade.__proto__ || Object.getPrototypeOf(Fade)).call.apply(_ref, [this].concat(args))), _this.handleEnter = function (node) {
      var theme = _this.props.theme;
      (0, _utils.reflow)(node); // So the animation always start from the start.

      var transitionProps = (0, _utils.getTransitionProps)(_this.props, {
        mode: 'enter'
      });
      node.style.webkitTransition = theme.transitions.create('opacity', transitionProps);
      node.style.transition = theme.transitions.create('opacity', transitionProps);

      if (_this.props.onEnter) {
        _this.props.onEnter(node);
      }
    }, _this.handleExit = function (node) {
      var theme = _this.props.theme;
      var transitionProps = (0, _utils.getTransitionProps)(_this.props, {
        mode: 'exit'
      });
      node.style.webkitTransition = theme.transitions.create('opacity', transitionProps);
      node.style.transition = theme.transitions.create('opacity', transitionProps);

      if (_this.props.onExit) {
        _this.props.onExit(node);
      }
    }, _temp));
  }

  (0, _createClass2.default)(Fade, [{
    key: "render",
    value: function render() {
      var _props = this.props,
          children = _props.children,
          onEnter = _props.onEnter,
          onExit = _props.onExit,
          styleProp = _props.style,
          theme = _props.theme,
          other = (0, _objectWithoutProperties2.default)(_props, ["children", "onEnter", "onExit", "style", "theme"]);
      var style = (0, _objectSpread2.default)({}, styleProp, _react.default.isValidElement(children) ? children.props.style : {});
      return _react.default.createElement(_Transition.default, (0, _extends2.default)({
        appear: true,
        onEnter: this.handleEnter,
        onExit: this.handleExit
      }, other), function (state, childProps) {
        return _react.default.cloneElement(children, (0, _objectSpread2.default)({
          style: (0, _objectSpread2.default)({
            opacity: 0,
            willChange: 'opacity'
          }, styles[state], style)
        }, childProps));
      });
    }
  }]);
  return Fade;
}(_react.default.Component);

Fade.propTypes =  false ? {
  /**
   * A single child content element.
   */
  children: _propTypes.default.oneOfType([_propTypes.default.element, _propTypes.default.func]),

  /**
   * If `true`, the component will transition in.
   */
  in: _propTypes.default.bool,

  /**
   * @ignore
   */
  onEnter: _propTypes.default.func,

  /**
   * @ignore
   */
  onExit: _propTypes.default.func,

  /**
   * @ignore
   */
  style: _propTypes.default.object,

  /**
   * @ignore
   */
  theme: _propTypes.default.object.isRequired,

  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   */
  timeout: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.shape({
    enter: _propTypes.default.number,
    exit: _propTypes.default.number
  })])
} : {};
Fade.defaultProps = {
  timeout: {
    enter: _transitions.duration.enteringScreen,
    exit: _transitions.duration.leavingScreen
  }
};

var _default = (0, _withTheme.default)()(Fade);

exports.default = _default;

/***/ }),
/* 638 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(2);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(6));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(4));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(11));

var _createClass2 = _interopRequireDefault(__webpack_require__(12));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(13));

var _inherits2 = _interopRequireDefault(__webpack_require__(14));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _reactDom = _interopRequireDefault(__webpack_require__(24));

var _keycode = _interopRequireDefault(__webpack_require__(99));

var _warning = _interopRequireDefault(__webpack_require__(16));

var _ownerDocument = _interopRequireDefault(__webpack_require__(48));

var _List = _interopRequireDefault(__webpack_require__(283));

// @inheritedComponent List
var MenuList =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(MenuList, _React$Component);

  function MenuList() {
    var _ref;

    var _temp, _this;

    (0, _classCallCheck2.default)(this, MenuList);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return (0, _possibleConstructorReturn2.default)(_this, (_temp = _this = (0, _possibleConstructorReturn2.default)(this, (_ref = MenuList.__proto__ || Object.getPrototypeOf(MenuList)).call.apply(_ref, [this].concat(args))), _this.listRef = null, _this.selectedItemRef = null, _this.blurTimer = null, _this.state = {
      currentTabIndex: null
    }, _this.handleBlur = function (event) {
      _this.blurTimer = setTimeout(function () {
        if (_this.listRef) {
          var list = _this.listRef;
          var currentFocus = (0, _ownerDocument.default)(list).activeElement;

          if (!list.contains(currentFocus)) {
            _this.resetTabIndex();
          }
        }
      }, 30);

      if (_this.props.onBlur) {
        _this.props.onBlur(event);
      }
    }, _this.handleKeyDown = function (event) {
      var list = _this.listRef;
      var key = (0, _keycode.default)(event);
      var currentFocus = (0, _ownerDocument.default)(list).activeElement;

      if ((key === 'up' || key === 'down') && (!currentFocus || currentFocus && !list.contains(currentFocus))) {
        if (_this.selectedItemRef) {
          _this.selectedItemRef.focus();
        } else {
          list.firstChild.focus();
        }
      } else if (key === 'down') {
        event.preventDefault();

        if (currentFocus.nextElementSibling) {
          currentFocus.nextElementSibling.focus();
        }
      } else if (key === 'up') {
        event.preventDefault();

        if (currentFocus.previousElementSibling) {
          currentFocus.previousElementSibling.focus();
        }
      }

      if (_this.props.onKeyDown) {
        _this.props.onKeyDown(event, key);
      }
    }, _this.handleItemFocus = function (event) {
      var list = _this.listRef;

      if (list) {
        for (var i = 0; i < list.children.length; i += 1) {
          if (list.children[i] === event.currentTarget) {
            _this.setTabIndex(i);

            break;
          }
        }
      }
    }, _temp));
  }

  (0, _createClass2.default)(MenuList, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.resetTabIndex();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      clearTimeout(this.blurTimer);
    }
  }, {
    key: "setTabIndex",
    value: function setTabIndex(index) {
      this.setState({
        currentTabIndex: index
      });
    }
  }, {
    key: "focus",
    value: function focus() {
      var currentTabIndex = this.state.currentTabIndex;
      var list = this.listRef;

      if (!list || !list.children || !list.firstChild) {
        return;
      }

      if (currentTabIndex && currentTabIndex >= 0) {
        list.children[currentTabIndex].focus();
      } else {
        list.firstChild.focus();
      }
    }
  }, {
    key: "resetTabIndex",
    value: function resetTabIndex() {
      var list = this.listRef;
      var currentFocus = (0, _ownerDocument.default)(list).activeElement;
      var items = [];

      for (var i = 0; i < list.children.length; i += 1) {
        items.push(list.children[i]);
      }

      var currentFocusIndex = items.indexOf(currentFocus);

      if (currentFocusIndex !== -1) {
        return this.setTabIndex(currentFocusIndex);
      }

      if (this.selectedItemRef) {
        return this.setTabIndex(items.indexOf(this.selectedItemRef));
      }

      return this.setTabIndex(0);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          children = _props.children,
          className = _props.className,
          onBlur = _props.onBlur,
          onKeyDown = _props.onKeyDown,
          other = (0, _objectWithoutProperties2.default)(_props, ["children", "className", "onBlur", "onKeyDown"]);
      return _react.default.createElement(_List.default, (0, _extends2.default)({
        role: "menu",
        ref: function ref(_ref2) {
          _this2.listRef = _reactDom.default.findDOMNode(_ref2);
        },
        className: className,
        onKeyDown: this.handleKeyDown,
        onBlur: this.handleBlur
      }, other), _react.default.Children.map(children, function (child, index) {
        if (!_react.default.isValidElement(child)) {
          return null;
        }

         false ? (0, _warning.default)(child.type !== _react.default.Fragment, ["Material-UI: the MenuList component doesn't accept a Fragment as a child.", 'Consider providing an array instead.'].join('\n')) : void 0;
        return _react.default.cloneElement(child, {
          tabIndex: index === _this2.state.currentTabIndex ? 0 : -1,
          ref: child.props.selected ? function (ref) {
            _this2.selectedItemRef = _reactDom.default.findDOMNode(ref);
          } : undefined,
          onFocus: _this2.handleItemFocus
        });
      }));
    }
  }]);
  return MenuList;
}(_react.default.Component);

MenuList.propTypes =  false ? {
  /**
   * MenuList contents, normally `MenuItem`s.
   */
  children: _propTypes.default.node,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * @ignore
   */
  onBlur: _propTypes.default.func,

  /**
   * @ignore
   */
  onKeyDown: _propTypes.default.func
} : {};
var _default = MenuList;
exports.default = _default;

/***/ }),
/* 639 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(2);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(6));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(7));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(4));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(11));

var _createClass2 = _interopRequireDefault(__webpack_require__(12));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(13));

var _inherits2 = _interopRequireDefault(__webpack_require__(14));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _classnames = _interopRequireDefault(__webpack_require__(5));

var _withStyles = _interopRequireDefault(__webpack_require__(3));

var styles = {
  /* Styles applied to the root element. */
  root: {
    listStyle: 'none',
    margin: 0,
    padding: 0,
    position: 'relative'
  },

  /* Styles applied to the root element if `disablePadding={false}`. */
  padding: {
    paddingTop: 8,
    paddingBottom: 8
  },

  /* Styles applied to the root element if `dense={true}` & `disablePadding={false}`. */
  dense: {
    paddingTop: 4,
    paddingBottom: 4
  },

  /* Styles applied to the root element if a `subheader` is provided. */
  subheader: {
    paddingTop: 0
  }
};
exports.styles = styles;

var List =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(List, _React$Component);

  function List() {
    (0, _classCallCheck2.default)(this, List);
    return (0, _possibleConstructorReturn2.default)(this, (List.__proto__ || Object.getPrototypeOf(List)).apply(this, arguments));
  }

  (0, _createClass2.default)(List, [{
    key: "getChildContext",
    value: function getChildContext() {
      return {
        dense: this.props.dense
      };
    }
  }, {
    key: "render",
    value: function render() {
      var _classNames;

      var _props = this.props,
          children = _props.children,
          classes = _props.classes,
          classNameProp = _props.className,
          Component = _props.component,
          dense = _props.dense,
          disablePadding = _props.disablePadding,
          subheader = _props.subheader,
          other = (0, _objectWithoutProperties2.default)(_props, ["children", "classes", "className", "component", "dense", "disablePadding", "subheader"]);
      var className = (0, _classnames.default)(classes.root, (_classNames = {}, (0, _defineProperty2.default)(_classNames, classes.dense, dense && !disablePadding), (0, _defineProperty2.default)(_classNames, classes.padding, !disablePadding), (0, _defineProperty2.default)(_classNames, classes.subheader, subheader), _classNames), classNameProp);
      return _react.default.createElement(Component, (0, _extends2.default)({
        className: className
      }, other), subheader, children);
    }
  }]);
  return List;
}(_react.default.Component);

List.propTypes =  false ? {
  /**
   * The content of the component.
   */
  children: _propTypes.default.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * The component used for the root node.
   * Either a string to use a DOM element or a component.
   */
  component: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func, _propTypes.default.object]),

  /**
   * If `true`, compact vertical padding designed for keyboard and mouse input will be used for
   * the list and list items. The property is available to descendant components as the
   * `dense` context.
   */
  dense: _propTypes.default.bool,

  /**
   * If `true`, vertical padding will be removed from the list.
   */
  disablePadding: _propTypes.default.bool,

  /**
   * The content of the subheader, normally `ListSubheader`.
   */
  subheader: _propTypes.default.node
} : {};
List.defaultProps = {
  component: 'ul',
  dense: false,
  disablePadding: false
};
List.childContextTypes = {
  dense: _propTypes.default.bool
};

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiList'
})(List);

exports.default = _default;

/***/ }),
/* 640 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(2);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _objectSpread2 = _interopRequireDefault(__webpack_require__(17));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(4));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _NativeSelectInput = _interopRequireDefault(__webpack_require__(285));

var _withStyles = _interopRequireDefault(__webpack_require__(3));

var _ArrowDropDown = _interopRequireDefault(__webpack_require__(284));

var _Input = _interopRequireDefault(__webpack_require__(129));

// @inheritedComponent Input
var styles = function styles(theme) {
  return {
    /* Styles applied to the `Input` component `root` class. */
    root: {
      position: 'relative',
      width: '100%'
    },

    /* Styles applied to the `Input` component `select` class. */
    select: {
      '-moz-appearance': 'none',
      // Reset
      '-webkit-appearance': 'none',
      // Reset
      // When interacting quickly, the text can end up selected.
      // Native select can't be selected either.
      userSelect: 'none',
      paddingRight: 32,
      width: 'calc(100% - 32px)',
      minWidth: 16,
      // So it doesn't collapse.
      cursor: 'pointer',
      '&:focus': {
        // Show that it's not an text input
        background: theme.palette.type === 'light' ? 'rgba(0, 0, 0, 0.05)' : 'rgba(255, 255, 255, 0.05)',
        borderRadius: 0 // Reset Chrome style

      },
      // Remove Firefox focus border
      '&:-moz-focusring': {
        color: 'transparent',
        textShadow: '0 0 0 #000'
      },
      // Remove IE11 arrow
      '&::-ms-expand': {
        display: 'none'
      },
      '&$disabled': {
        cursor: 'default'
      }
    },

    /* Styles applied to the `Input` component `selectMenu` class. */
    selectMenu: {
      width: 'auto',
      // Fix Safari textOverflow
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      minHeight: '1.1875em' // Reset (19px), match the native input line-height

    },

    /* Styles applied to the `Input` component `disabled` class. */
    disabled: {},

    /* Styles applied to the `Input` component `icon` class. */
    icon: {
      // We use a position absolute over a flexbox in order to forward the pointer events
      // to the input.
      position: 'absolute',
      right: 0,
      top: 'calc(50% - 12px)',
      // Center vertically
      color: theme.palette.action.active,
      'pointer-events': 'none' // Don't block pointer events on the select under the icon.

    }
  };
};
/**
 * An alternative to `<Select native />` with a much smaller dependency graph.
 */


exports.styles = styles;

function NativeSelect(props) {
  var children = props.children,
      classes = props.classes,
      IconComponent = props.IconComponent,
      input = props.input,
      inputProps = props.inputProps,
      other = (0, _objectWithoutProperties2.default)(props, ["children", "classes", "IconComponent", "input", "inputProps"]);
  return _react.default.cloneElement(input, (0, _objectSpread2.default)({
    // Most of the logic is implemented in `NativeSelectInput`.
    // The `Select` component is a simple API wrapper to expose something better to play with.
    inputComponent: _NativeSelectInput.default,
    inputProps: (0, _objectSpread2.default)({
      children: children,
      classes: classes,
      IconComponent: IconComponent,
      type: undefined
    }, inputProps, input ? input.props.inputProps : {})
  }, other));
}

NativeSelect.propTypes =  false ? {
  /**
   * The option elements to populate the select with.
   * Can be some `<option>` elements.
   */
  children: _propTypes.default.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * The icon that displays the arrow.
   */
  IconComponent: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func, _propTypes.default.object]),

  /**
   * An `Input` element; does not have to be a material-ui specific `Input`.
   */
  input: _propTypes.default.element,

  /**
   * Attributes applied to the `select` element.
   */
  inputProps: _propTypes.default.object,

  /**
   * Callback function fired when a menu item is selected.
   *
   * @param {object} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value`.
   */
  onChange: _propTypes.default.func,

  /**
   * The input value.
   */
  value: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number])
} : {};
NativeSelect.defaultProps = {
  IconComponent: _ArrowDropDown.default,
  input: _react.default.createElement(_Input.default, null)
};
NativeSelect.muiName = 'NativeSelect';

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiNativeSelect'
})(NativeSelect);

exports.default = _default;

/***/ }),
/* 641 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_autosuggest__ = __webpack_require__(286);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_autosuggest___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_autosuggest__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__companies__ = __webpack_require__(653);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_autosuggest_highlight_match__ = __webpack_require__(287);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_autosuggest_highlight_match___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_autosuggest_highlight_match__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_MenuItem__ = __webpack_require__(135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_MenuItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_MenuItem__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_Paper__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_Paper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Paper__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_autosuggest_highlight_parse__ = __webpack_require__(289);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_autosuggest_highlight_parse___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_autosuggest_highlight_parse__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_TextField__ = __webpack_require__(189);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_TextField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_TextField__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_services_utils__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_services_companies__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lodash__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__material_ui_core_styles__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__material_ui_core_styles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__material_ui_core_styles__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var styles=function styles(theme){return{container:{flexGrow:1,position:'relative'},suggestionsContainerOpen:{position:'absolute',left:0,marginTop:theme.spacing.unit,right:0,zIndex:1},suggestion:{display:'block',position:"relative","&:after":{content:'""',position:"absolute",bottom:"0",height:"1px",right:"15px",width:"calc(100% - 30px)",backgroundColor:"hsla(0, 3%, 20%, 0.3)"},"&:last-child":{"&:after":{content:"none"}}},suggestionsList:{listStyleType:'none',margin:0,padding:0}};};var AutosuggestCNPJ=function(_Component){_inherits(AutosuggestCNPJ,_Component);function AutosuggestCNPJ(){var _ref;var _temp,_this,_ret;_classCallCheck(this,AutosuggestCNPJ);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=AutosuggestCNPJ.__proto__||Object.getPrototypeOf(AutosuggestCNPJ)).call.apply(_ref,[this].concat(args))),_this),_this.state={// Decidi colocar as empresas num arquivo
// .js estático pra servir instantaneamente.
// O componentDidMount faz uma request e atualiza.
options:__WEBPACK_IMPORTED_MODULE_1__companies__["a" /* default */],suggestions:[],value:_this.props.defaultValue},_this.handleSuggestionsFetchRequested=function(_ref2){var value=_ref2.value;_this.setState({suggestions:_this.getSuggestions(value)});},_this.handleSuggestionsClearRequested=function(){_this.setState({suggestions:[]});},_this.handleChange=function(event,_ref3){var newValue=_ref3.newValue;_this.setState({value:newValue});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(AutosuggestCNPJ,[{key:'componentDidMount',value:function componentDidMount(){var _this2=this;Object(__WEBPACK_IMPORTED_MODULE_10_services_companies__["b" /* fetchCompanies */])().then(function(res){_this2.setState({options:res.data});_this2.checkIfUpdateCompaniesJS(res.data);});}},{key:'componentDidUpdate',value:function componentDidUpdate(prevProps){if(prevProps.defaultValue!==this.props.defaultValue&&this.props.defaultValue!==''){this.setState({value:this.props.defaultValue});}}},{key:'checkIfUpdateCompaniesJS',value:function checkIfUpdateCompaniesJS(newData){// NOTE: Atualizar companies.js quando lengths forem diferentes.
if(Object(__WEBPACK_IMPORTED_MODULE_11_lodash__["get"])(this.state.options,"length")!==Object(__WEBPACK_IMPORTED_MODULE_11_lodash__["get"])(newData,"length")){console.error("Please update companies.js");}else{console.log("Arquivo companies não precisa de atualização");}}// Buscar os 15 primeiros matches principais em options.
// Priorizar a busca principal (name + cnpj) e se não preencher os 15 juntar com a adicional (buscaAdicional).
// Caso não ache nada, criar uma opção de cativo.
},{key:'getSuggestionMatchingValues',value:function getSuggestionMatchingValues(inputValue){inputValue=inputValue.toLowerCase();var mainMatched=[];var additionalMatched=[];this.state.options.forEach(function(option){var mainSearch=option.name+' '+option.commercialName+' '+option.cnpj;var additionalSearch=''+option.buscaAdicional;if(mainMatched.length===10)return false;if(mainSearch.toLowerCase().includes(inputValue)){mainMatched.push(option);}else if(additionalSearch.toLowerCase().includes(inputValue)){additionalMatched.push(option);}});var finalMatched=Object(__WEBPACK_IMPORTED_MODULE_11_lodash__["take"])(mainMatched.concat(additionalMatched),15);if(finalMatched.length===0){finalMatched.push({name:"Buscar no Mercado Cativo",cnpj:inputValue,id:"CATIVO"});}return finalMatched;}// Normaliza o input (trim + lowerCase) e depois busca as options baseado no input
},{key:'getSuggestions',value:function getSuggestions(value){var inputValue=value.trim().toLowerCase();return inputValue.length===0?[]:this.getSuggestionMatchingValues(inputValue);}},{key:'getSuggestionValue',value:function getSuggestionValue(suggestion){return suggestion.name;}// Método chamado quando tem um onChange no input.
},{key:'renderInput',value:function renderInput(inputProps){var classes=inputProps.classes,ref=inputProps.ref,other=_objectWithoutProperties(inputProps,['classes','ref']);return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_TextField___default.a,{fullWidth:true,InputProps:Object.assign({inputRef:ref,classes:{input:classes.input}},other)});}},{key:'renderSuggestion',value:function renderSuggestion(suggestion,_ref4){var query=_ref4.query,isHighlighted=_ref4.isHighlighted;var matches=__WEBPACK_IMPORTED_MODULE_2_autosuggest_highlight_match___default()(suggestion.name,query);var parts=__WEBPACK_IMPORTED_MODULE_6_autosuggest_highlight_parse___default()(suggestion.name,matches);var formattedCNPJ=Object(__WEBPACK_IMPORTED_MODULE_9_services_utils__["a" /* CNPJMask */])(suggestion.cnpj);var subtext=formattedCNPJ+' '+(suggestion.city?Object(__WEBPACK_IMPORTED_MODULE_9_services_utils__["d" /* capitalizeString */])(suggestion.city):"")+' '+(suggestion.stateCode?"- "+suggestion.stateCode:"");return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_MenuItem___default.a,{component:'div',selected:isHighlighted},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',null,parts.map(function(part,index){return part.highlight?__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('span',{key:String(index),style:{fontWeight:300}},part.text):__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('strong',{key:String(index),style:{fontWeight:500}},part.text);}))),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_MenuItem___default.a,{component:'div',selected:isHighlighted},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',null,subtext)));}},{key:'renderSuggestionsContainer',value:function renderSuggestionsContainer(options){var containerProps=options.containerProps,children=options.children;return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Paper___default.a,Object.assign({},containerProps,{square:true}),children);}},{key:'render',value:function render(){var _props=this.props,classes=_props.classes,onHandleSelected=_props.onHandleSelected,placeholder=_props.placeholder;var _state=this.state,suggestions=_state.suggestions,value=_state.value;return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react_autosuggest___default.a,{getSuggestionValue:this.getSuggestionValue,inputProps:{autoFocus:true,classes:classes,onChange:this.handleChange,placeholder:placeholder,value:value},onSuggestionsClearRequested:this.handleSuggestionsClearRequested,onSuggestionSelected:function onSuggestionSelected(event,_ref5){var suggestion=_ref5.suggestion;return onHandleSelected(suggestion);},onSuggestionsFetchRequested:this.handleSuggestionsFetchRequested,renderInputComponent:this.renderInput,renderSuggestion:this.renderSuggestion,renderSuggestionsContainer:this.renderSuggestionsContainer,suggestions:suggestions,theme:{container:classes.container,suggestionsContainerOpen:classes.suggestionsContainerOpen,suggestionsList:classes.suggestionsList,suggestion:classes.suggestion}});}}]);return AutosuggestCNPJ;}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);AutosuggestCNPJ.defaultProps={defaultValue:'',placeholder:'Buscar empresa por Nome ou CNPJ'};AutosuggestCNPJ.propTypes={classes:__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.object.isRequired,defaultValue:__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string,onHandleSelected:__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func.isRequired,placeholder:__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_12__material_ui_core_styles__["withStyles"])(styles)(AutosuggestCNPJ));

/***/ }),
/* 642 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _arrays = __webpack_require__(643);

var _arrays2 = _interopRequireDefault(_arrays);

var _reactAutowhatever = __webpack_require__(644);

var _reactAutowhatever2 = _interopRequireDefault(_reactAutowhatever);

var _theme = __webpack_require__(652);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var alwaysTrue = function alwaysTrue() {
  return true;
};
var defaultShouldRenderSuggestions = function defaultShouldRenderSuggestions(value) {
  return value.trim().length > 0;
};
var defaultRenderSuggestionsContainer = function defaultRenderSuggestionsContainer(_ref) {
  var containerProps = _ref.containerProps,
      children = _ref.children;
  return _react2.default.createElement(
    'div',
    containerProps,
    children
  );
};

var Autosuggest = function (_Component) {
  _inherits(Autosuggest, _Component);

  function Autosuggest(_ref2) {
    var alwaysRenderSuggestions = _ref2.alwaysRenderSuggestions;

    _classCallCheck(this, Autosuggest);

    var _this = _possibleConstructorReturn(this, (Autosuggest.__proto__ || Object.getPrototypeOf(Autosuggest)).call(this));

    _initialiseProps.call(_this);

    _this.state = {
      isFocused: false,
      isCollapsed: !alwaysRenderSuggestions,
      highlightedSectionIndex: null,
      highlightedSuggestionIndex: null,
      highlightedSuggestion: null,
      valueBeforeUpDown: null
    };

    _this.justPressedUpDown = false;
    _this.justMouseEntered = false;
    return _this;
  }

  _createClass(Autosuggest, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      document.addEventListener('mousedown', this.onDocumentMouseDown);

      this.input = this.autowhatever.input;
      this.suggestionsContainer = this.autowhatever.itemsContainer;
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if ((0, _arrays2.default)(nextProps.suggestions, this.props.suggestions)) {
        if (nextProps.highlightFirstSuggestion && nextProps.suggestions.length > 0 && this.justPressedUpDown === false && this.justMouseEntered === false) {
          this.highlightFirstSuggestion();
        }
      } else {
        if (this.willRenderSuggestions(nextProps)) {
          if (this.state.isCollapsed && !this.justSelectedSuggestion) {
            this.revealSuggestions();
          }
        } else {
          this.resetHighlightedSuggestion();
        }
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps, prevState) {
      var _props = this.props,
          suggestions = _props.suggestions,
          onSuggestionHighlighted = _props.onSuggestionHighlighted,
          highlightFirstSuggestion = _props.highlightFirstSuggestion;


      if (!(0, _arrays2.default)(suggestions, prevProps.suggestions) && suggestions.length > 0 && highlightFirstSuggestion) {
        this.highlightFirstSuggestion();
        return;
      }

      if (onSuggestionHighlighted) {
        var highlightedSuggestion = this.getHighlightedSuggestion();
        var prevHighlightedSuggestion = prevState.highlightedSuggestion;

        if (highlightedSuggestion != prevHighlightedSuggestion) {
          onSuggestionHighlighted({
            suggestion: highlightedSuggestion
          });
        }
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      document.removeEventListener('mousedown', this.onDocumentMouseDown);
    }
  }, {
    key: 'updateHighlightedSuggestion',
    value: function updateHighlightedSuggestion(sectionIndex, suggestionIndex, prevValue) {
      var _this2 = this;

      this.setState(function (state) {
        var valueBeforeUpDown = state.valueBeforeUpDown;


        if (suggestionIndex === null) {
          valueBeforeUpDown = null;
        } else if (valueBeforeUpDown === null && typeof prevValue !== 'undefined') {
          valueBeforeUpDown = prevValue;
        }

        return {
          highlightedSectionIndex: sectionIndex,
          highlightedSuggestionIndex: suggestionIndex,
          highlightedSuggestion: suggestionIndex === null ? null : _this2.getSuggestion(sectionIndex, suggestionIndex),
          valueBeforeUpDown: valueBeforeUpDown
        };
      });
    }
  }, {
    key: 'resetHighlightedSuggestion',
    value: function resetHighlightedSuggestion() {
      var shouldResetValueBeforeUpDown = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

      this.setState(function (state) {
        var valueBeforeUpDown = state.valueBeforeUpDown;


        return {
          highlightedSectionIndex: null,
          highlightedSuggestionIndex: null,
          highlightedSuggestion: null,
          valueBeforeUpDown: shouldResetValueBeforeUpDown ? null : valueBeforeUpDown
        };
      });
    }
  }, {
    key: 'revealSuggestions',
    value: function revealSuggestions() {
      this.setState({
        isCollapsed: false
      });
    }
  }, {
    key: 'closeSuggestions',
    value: function closeSuggestions() {
      this.setState({
        highlightedSectionIndex: null,
        highlightedSuggestionIndex: null,
        highlightedSuggestion: null,
        valueBeforeUpDown: null,
        isCollapsed: true
      });
    }
  }, {
    key: 'getSuggestion',
    value: function getSuggestion(sectionIndex, suggestionIndex) {
      var _props2 = this.props,
          suggestions = _props2.suggestions,
          multiSection = _props2.multiSection,
          getSectionSuggestions = _props2.getSectionSuggestions;


      if (multiSection) {
        return getSectionSuggestions(suggestions[sectionIndex])[suggestionIndex];
      }

      return suggestions[suggestionIndex];
    }
  }, {
    key: 'getHighlightedSuggestion',
    value: function getHighlightedSuggestion() {
      var _state = this.state,
          highlightedSectionIndex = _state.highlightedSectionIndex,
          highlightedSuggestionIndex = _state.highlightedSuggestionIndex;


      if (highlightedSuggestionIndex === null) {
        return null;
      }

      return this.getSuggestion(highlightedSectionIndex, highlightedSuggestionIndex);
    }
  }, {
    key: 'getSuggestionValueByIndex',
    value: function getSuggestionValueByIndex(sectionIndex, suggestionIndex) {
      var getSuggestionValue = this.props.getSuggestionValue;


      return getSuggestionValue(this.getSuggestion(sectionIndex, suggestionIndex));
    }
  }, {
    key: 'getSuggestionIndices',
    value: function getSuggestionIndices(suggestionElement) {
      var sectionIndex = suggestionElement.getAttribute('data-section-index');
      var suggestionIndex = suggestionElement.getAttribute('data-suggestion-index');

      return {
        sectionIndex: typeof sectionIndex === 'string' ? parseInt(sectionIndex, 10) : null,
        suggestionIndex: parseInt(suggestionIndex, 10)
      };
    }
  }, {
    key: 'findSuggestionElement',
    value: function findSuggestionElement(startNode) {
      var node = startNode;

      do {
        if (node.getAttribute('data-suggestion-index') !== null) {
          return node;
        }

        node = node.parentNode;
      } while (node !== null);

      console.error('Clicked element:', startNode); // eslint-disable-line no-console
      throw new Error("Couldn't find suggestion element");
    }
  }, {
    key: 'maybeCallOnChange',
    value: function maybeCallOnChange(event, newValue, method) {
      var _props$inputProps = this.props.inputProps,
          value = _props$inputProps.value,
          onChange = _props$inputProps.onChange;


      if (newValue !== value) {
        onChange(event, { newValue: newValue, method: method });
      }
    }
  }, {
    key: 'willRenderSuggestions',
    value: function willRenderSuggestions(props) {
      var suggestions = props.suggestions,
          inputProps = props.inputProps,
          shouldRenderSuggestions = props.shouldRenderSuggestions;
      var value = inputProps.value;


      return suggestions.length > 0 && shouldRenderSuggestions(value);
    }
  }, {
    key: 'getQuery',
    value: function getQuery() {
      var inputProps = this.props.inputProps;
      var value = inputProps.value;
      var valueBeforeUpDown = this.state.valueBeforeUpDown;


      return (valueBeforeUpDown === null ? value : valueBeforeUpDown).trim();
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _props3 = this.props,
          suggestions = _props3.suggestions,
          renderInputComponent = _props3.renderInputComponent,
          onSuggestionsFetchRequested = _props3.onSuggestionsFetchRequested,
          renderSuggestion = _props3.renderSuggestion,
          inputProps = _props3.inputProps,
          multiSection = _props3.multiSection,
          renderSectionTitle = _props3.renderSectionTitle,
          id = _props3.id,
          getSectionSuggestions = _props3.getSectionSuggestions,
          theme = _props3.theme,
          getSuggestionValue = _props3.getSuggestionValue,
          alwaysRenderSuggestions = _props3.alwaysRenderSuggestions,
          highlightFirstSuggestion = _props3.highlightFirstSuggestion;
      var _state2 = this.state,
          isFocused = _state2.isFocused,
          isCollapsed = _state2.isCollapsed,
          highlightedSectionIndex = _state2.highlightedSectionIndex,
          highlightedSuggestionIndex = _state2.highlightedSuggestionIndex,
          valueBeforeUpDown = _state2.valueBeforeUpDown;

      var shouldRenderSuggestions = alwaysRenderSuggestions ? alwaysTrue : this.props.shouldRenderSuggestions;
      var value = inputProps.value,
          _onFocus = inputProps.onFocus,
          _onKeyDown = inputProps.onKeyDown;

      var willRenderSuggestions = this.willRenderSuggestions(this.props);
      var isOpen = alwaysRenderSuggestions || isFocused && !isCollapsed && willRenderSuggestions;
      var items = isOpen ? suggestions : [];
      var autowhateverInputProps = _extends({}, inputProps, {
        onFocus: function onFocus(event) {
          if (!_this3.justSelectedSuggestion && !_this3.justClickedOnSuggestionsContainer) {
            var shouldRender = shouldRenderSuggestions(value);

            _this3.setState({
              isFocused: true,
              isCollapsed: !shouldRender
            });

            _onFocus && _onFocus(event);

            if (shouldRender) {
              onSuggestionsFetchRequested({ value: value, reason: 'input-focused' });
            }
          }
        },
        onBlur: function onBlur(event) {
          if (_this3.justClickedOnSuggestionsContainer) {
            _this3.input.focus();
            return;
          }

          _this3.blurEvent = event;

          if (!_this3.justSelectedSuggestion) {
            _this3.onBlur();
            _this3.onSuggestionsClearRequested();
          }
        },
        onChange: function onChange(event) {
          var value = event.target.value;

          var shouldRender = shouldRenderSuggestions(value);

          _this3.maybeCallOnChange(event, value, 'type');

          _this3.setState(_extends({}, highlightFirstSuggestion ? {} : {
            highlightedSectionIndex: null,
            highlightedSuggestionIndex: null,
            highlightedSuggestion: null
          }, {
            valueBeforeUpDown: null,
            isCollapsed: !shouldRender
          }));

          if (shouldRender) {
            onSuggestionsFetchRequested({ value: value, reason: 'input-changed' });
          } else {
            _this3.onSuggestionsClearRequested();
          }
        },
        onKeyDown: function onKeyDown(event, data) {
          var keyCode = event.keyCode;


          switch (keyCode) {
            case 40: // ArrowDown
            case 38:
              // ArrowUp
              if (isCollapsed) {
                if (shouldRenderSuggestions(value)) {
                  onSuggestionsFetchRequested({
                    value: value,
                    reason: 'suggestions-revealed'
                  });
                  _this3.revealSuggestions();
                }
              } else if (suggestions.length > 0) {
                var newHighlightedSectionIndex = data.newHighlightedSectionIndex,
                    newHighlightedItemIndex = data.newHighlightedItemIndex;


                var newValue = void 0;

                if (newHighlightedItemIndex === null) {
                  // valueBeforeUpDown can be null if, for example, user
                  // hovers on the first suggestion and then pressed Up.
                  // If that happens, use the original input value.
                  newValue = valueBeforeUpDown === null ? value : valueBeforeUpDown;
                } else {
                  newValue = _this3.getSuggestionValueByIndex(newHighlightedSectionIndex, newHighlightedItemIndex);
                }

                _this3.updateHighlightedSuggestion(newHighlightedSectionIndex, newHighlightedItemIndex, value);
                _this3.maybeCallOnChange(event, newValue, keyCode === 40 ? 'down' : 'up');
              }

              event.preventDefault(); // Prevents the cursor from moving

              _this3.justPressedUpDown = true;

              setTimeout(function () {
                _this3.justPressedUpDown = false;
              });

              break;

            // Enter
            case 13:
              {
                // See #388
                if (event.keyCode === 229) {
                  break;
                }

                var highlightedSuggestion = _this3.getHighlightedSuggestion();

                if (isOpen && !alwaysRenderSuggestions) {
                  _this3.closeSuggestions();
                }

                if (highlightedSuggestion != null) {
                  var _newValue = getSuggestionValue(highlightedSuggestion);

                  _this3.maybeCallOnChange(event, _newValue, 'enter');

                  _this3.onSuggestionSelected(event, {
                    suggestion: highlightedSuggestion,
                    suggestionValue: _newValue,
                    suggestionIndex: highlightedSuggestionIndex,
                    sectionIndex: highlightedSectionIndex,
                    method: 'enter'
                  });

                  _this3.justSelectedSuggestion = true;

                  setTimeout(function () {
                    _this3.justSelectedSuggestion = false;
                  });
                }

                break;
              }

            // Escape
            case 27:
              {
                if (isOpen) {
                  // If input.type === 'search', the browser clears the input
                  // when Escape is pressed. We want to disable this default
                  // behaviour so that, when suggestions are shown, we just hide
                  // them, without clearing the input.
                  event.preventDefault();
                }

                var willCloseSuggestions = isOpen && !alwaysRenderSuggestions;

                if (valueBeforeUpDown === null) {
                  // Didn't interact with Up/Down
                  if (!willCloseSuggestions) {
                    var _newValue2 = '';

                    _this3.maybeCallOnChange(event, _newValue2, 'escape');

                    if (shouldRenderSuggestions(_newValue2)) {
                      onSuggestionsFetchRequested({
                        value: _newValue2,
                        reason: 'escape-pressed'
                      });
                    } else {
                      _this3.onSuggestionsClearRequested();
                    }
                  }
                } else {
                  // Interacted with Up/Down
                  _this3.maybeCallOnChange(event, valueBeforeUpDown, 'escape');
                }

                if (willCloseSuggestions) {
                  _this3.onSuggestionsClearRequested();
                  _this3.closeSuggestions();
                } else {
                  _this3.resetHighlightedSuggestion();
                }

                break;
              }
          }

          _onKeyDown && _onKeyDown(event);
        }
      });
      var renderSuggestionData = {
        query: this.getQuery()
      };

      return _react2.default.createElement(_reactAutowhatever2.default, {
        multiSection: multiSection,
        items: items,
        renderInputComponent: renderInputComponent,
        renderItemsContainer: this.renderSuggestionsContainer,
        renderItem: renderSuggestion,
        renderItemData: renderSuggestionData,
        renderSectionTitle: renderSectionTitle,
        getSectionItems: getSectionSuggestions,
        highlightedSectionIndex: highlightedSectionIndex,
        highlightedItemIndex: highlightedSuggestionIndex,
        inputProps: autowhateverInputProps,
        itemProps: this.itemProps,
        theme: (0, _theme.mapToAutowhateverTheme)(theme),
        id: id,
        ref: this.storeAutowhateverRef
      });
    }
  }]);

  return Autosuggest;
}(_react.Component);

Autosuggest.propTypes = {
  suggestions: _propTypes2.default.array.isRequired,
  onSuggestionsFetchRequested: function onSuggestionsFetchRequested(props, propName) {
    var onSuggestionsFetchRequested = props[propName];

    if (typeof onSuggestionsFetchRequested !== 'function') {
      throw new Error("'onSuggestionsFetchRequested' must be implemented. See: https://github.com/moroshko/react-autosuggest#onSuggestionsFetchRequestedProp");
    }
  },
  onSuggestionsClearRequested: function onSuggestionsClearRequested(props, propName) {
    var onSuggestionsClearRequested = props[propName];

    if (props.alwaysRenderSuggestions === false && typeof onSuggestionsClearRequested !== 'function') {
      throw new Error("'onSuggestionsClearRequested' must be implemented. See: https://github.com/moroshko/react-autosuggest#onSuggestionsClearRequestedProp");
    }
  },
  onSuggestionSelected: _propTypes2.default.func,
  onSuggestionHighlighted: _propTypes2.default.func,
  renderInputComponent: _propTypes2.default.func,
  renderSuggestionsContainer: _propTypes2.default.func,
  getSuggestionValue: _propTypes2.default.func.isRequired,
  renderSuggestion: _propTypes2.default.func.isRequired,
  inputProps: function inputProps(props, propName) {
    var inputProps = props[propName];

    if (!inputProps.hasOwnProperty('value')) {
      throw new Error("'inputProps' must have 'value'.");
    }

    if (!inputProps.hasOwnProperty('onChange')) {
      throw new Error("'inputProps' must have 'onChange'.");
    }
  },
  shouldRenderSuggestions: _propTypes2.default.func,
  alwaysRenderSuggestions: _propTypes2.default.bool,
  multiSection: _propTypes2.default.bool,
  renderSectionTitle: function renderSectionTitle(props, propName) {
    var renderSectionTitle = props[propName];

    if (props.multiSection === true && typeof renderSectionTitle !== 'function') {
      throw new Error("'renderSectionTitle' must be implemented. See: https://github.com/moroshko/react-autosuggest#renderSectionTitleProp");
    }
  },
  getSectionSuggestions: function getSectionSuggestions(props, propName) {
    var getSectionSuggestions = props[propName];

    if (props.multiSection === true && typeof getSectionSuggestions !== 'function') {
      throw new Error("'getSectionSuggestions' must be implemented. See: https://github.com/moroshko/react-autosuggest#getSectionSuggestionsProp");
    }
  },
  focusInputOnSuggestionClick: _propTypes2.default.bool,
  highlightFirstSuggestion: _propTypes2.default.bool,
  theme: _propTypes2.default.object,
  id: _propTypes2.default.string
};
Autosuggest.defaultProps = {
  renderSuggestionsContainer: defaultRenderSuggestionsContainer,
  shouldRenderSuggestions: defaultShouldRenderSuggestions,
  alwaysRenderSuggestions: false,
  multiSection: false,
  focusInputOnSuggestionClick: true,
  highlightFirstSuggestion: false,
  theme: _theme.defaultTheme,
  id: '1'
};

var _initialiseProps = function _initialiseProps() {
  var _this4 = this;

  this.onDocumentMouseDown = function (event) {
    _this4.justClickedOnSuggestionsContainer = false;

    var node = event.detail && event.detail.target || // This is for testing only. Please show me a better way to emulate this.
    event.target;

    while (node !== null && node !== document) {
      if (node.getAttribute('data-suggestion-index') !== null) {
        // Suggestion was clicked
        return;
      }

      if (node === _this4.suggestionsContainer) {
        // Something else inside suggestions container was clicked
        _this4.justClickedOnSuggestionsContainer = true;
        return;
      }

      node = node.parentNode;
    }
  };

  this.storeAutowhateverRef = function (autowhatever) {
    if (autowhatever !== null) {
      _this4.autowhatever = autowhatever;
    }
  };

  this.onSuggestionMouseEnter = function (event, _ref3) {
    var sectionIndex = _ref3.sectionIndex,
        itemIndex = _ref3.itemIndex;

    _this4.updateHighlightedSuggestion(sectionIndex, itemIndex);

    _this4.justMouseEntered = true;

    setTimeout(function () {
      _this4.justMouseEntered = false;
    });
  };

  this.highlightFirstSuggestion = function () {
    _this4.updateHighlightedSuggestion(_this4.props.multiSection ? 0 : null, 0);
  };

  this.onSuggestionMouseDown = function () {
    _this4.justSelectedSuggestion = true;
  };

  this.onSuggestionsClearRequested = function () {
    var onSuggestionsClearRequested = _this4.props.onSuggestionsClearRequested;


    onSuggestionsClearRequested && onSuggestionsClearRequested();
  };

  this.onSuggestionSelected = function (event, data) {
    var _props4 = _this4.props,
        alwaysRenderSuggestions = _props4.alwaysRenderSuggestions,
        onSuggestionSelected = _props4.onSuggestionSelected,
        onSuggestionsFetchRequested = _props4.onSuggestionsFetchRequested;


    onSuggestionSelected && onSuggestionSelected(event, data);

    if (alwaysRenderSuggestions) {
      onSuggestionsFetchRequested({
        value: data.suggestionValue,
        reason: 'suggestion-selected'
      });
    } else {
      _this4.onSuggestionsClearRequested();
    }

    _this4.resetHighlightedSuggestion();
  };

  this.onSuggestionClick = function (event) {
    var _props5 = _this4.props,
        alwaysRenderSuggestions = _props5.alwaysRenderSuggestions,
        focusInputOnSuggestionClick = _props5.focusInputOnSuggestionClick;

    var _getSuggestionIndices = _this4.getSuggestionIndices(_this4.findSuggestionElement(event.target)),
        sectionIndex = _getSuggestionIndices.sectionIndex,
        suggestionIndex = _getSuggestionIndices.suggestionIndex;

    var clickedSuggestion = _this4.getSuggestion(sectionIndex, suggestionIndex);
    var clickedSuggestionValue = _this4.props.getSuggestionValue(clickedSuggestion);

    _this4.maybeCallOnChange(event, clickedSuggestionValue, 'click');
    _this4.onSuggestionSelected(event, {
      suggestion: clickedSuggestion,
      suggestionValue: clickedSuggestionValue,
      suggestionIndex: suggestionIndex,
      sectionIndex: sectionIndex,
      method: 'click'
    });

    if (!alwaysRenderSuggestions) {
      _this4.closeSuggestions();
    }

    if (focusInputOnSuggestionClick === true) {
      _this4.input.focus();
    } else {
      _this4.onBlur();
    }

    setTimeout(function () {
      _this4.justSelectedSuggestion = false;
    });
  };

  this.onBlur = function () {
    var _props6 = _this4.props,
        inputProps = _props6.inputProps,
        shouldRenderSuggestions = _props6.shouldRenderSuggestions;
    var value = inputProps.value,
        onBlur = inputProps.onBlur;

    var highlightedSuggestion = _this4.getHighlightedSuggestion();
    var shouldRender = shouldRenderSuggestions(value);

    _this4.setState({
      isFocused: false,
      highlightedSectionIndex: null,
      highlightedSuggestionIndex: null,
      highlightedSuggestion: null,
      valueBeforeUpDown: null,
      isCollapsed: !shouldRender
    });

    onBlur && onBlur(_this4.blurEvent, { highlightedSuggestion: highlightedSuggestion });
  };

  this.resetHighlightedSuggestionOnMouseLeave = function () {
    _this4.resetHighlightedSuggestion(false); // shouldResetValueBeforeUpDown
  };

  this.itemProps = function (_ref4) {
    var sectionIndex = _ref4.sectionIndex,
        itemIndex = _ref4.itemIndex;

    return {
      'data-section-index': sectionIndex,
      'data-suggestion-index': itemIndex,
      onMouseEnter: _this4.onSuggestionMouseEnter,
      onMouseLeave: _this4.resetHighlightedSuggestionOnMouseLeave,
      onMouseDown: _this4.onSuggestionMouseDown,
      onTouchStart: _this4.onSuggestionMouseDown, // Because on iOS `onMouseDown` is not triggered
      onClick: _this4.onSuggestionClick
    };
  };

  this.renderSuggestionsContainer = function (_ref5) {
    var containerProps = _ref5.containerProps,
        children = _ref5.children;
    var renderSuggestionsContainer = _this4.props.renderSuggestionsContainer;


    return renderSuggestionsContainer({
      containerProps: containerProps,
      children: children,
      query: _this4.getQuery()
    });
  };
};

exports.default = Autosuggest;

/***/ }),
/* 643 */
/***/ (function(module, exports) {

module.exports = function shallowEqualArrays(arrA, arrB) {
  if (arrA === arrB) {
    return true;
  }

  var len = arrA.length;

  if (arrB.length !== len) {
    return false;
  }

  for (var i = 0; i < len; i++) {
    if (arrA[i] !== arrB[i]) {
      return false;
    }
  }

  return true;
};


/***/ }),
/* 644 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = __webpack_require__(645).default;

/***/ }),
/* 645 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _sectionIterator = __webpack_require__(646);

var _sectionIterator2 = _interopRequireDefault(_sectionIterator);

var _reactThemeable = __webpack_require__(647);

var _reactThemeable2 = _interopRequireDefault(_reactThemeable);

var _SectionTitle = __webpack_require__(649);

var _SectionTitle2 = _interopRequireDefault(_SectionTitle);

var _ItemsList = __webpack_require__(650);

var _ItemsList2 = _interopRequireDefault(_ItemsList);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var emptyObject = {};
var defaultRenderInputComponent = function defaultRenderInputComponent(props) {
  return _react2.default.createElement('input', props);
};
var defaultRenderItemsContainer = function defaultRenderItemsContainer(_ref) {
  var containerProps = _ref.containerProps,
      children = _ref.children;
  return _react2.default.createElement(
    'div',
    containerProps,
    children
  );
};
var defaultTheme = {
  container: 'react-autowhatever__container',
  containerOpen: 'react-autowhatever__container--open',
  input: 'react-autowhatever__input',
  inputOpen: 'react-autowhatever__input--open',
  inputFocused: 'react-autowhatever__input--focused',
  itemsContainer: 'react-autowhatever__items-container',
  itemsContainerOpen: 'react-autowhatever__items-container--open',
  itemsList: 'react-autowhatever__items-list',
  item: 'react-autowhatever__item',
  itemFirst: 'react-autowhatever__item--first',
  itemHighlighted: 'react-autowhatever__item--highlighted',
  sectionContainer: 'react-autowhatever__section-container',
  sectionContainerFirst: 'react-autowhatever__section-container--first',
  sectionTitle: 'react-autowhatever__section-title'
};

var Autowhatever = function (_Component) {
  _inherits(Autowhatever, _Component);

  function Autowhatever(props) {
    _classCallCheck(this, Autowhatever);

    var _this = _possibleConstructorReturn(this, (Autowhatever.__proto__ || Object.getPrototypeOf(Autowhatever)).call(this, props));

    _this.storeInputReference = function (input) {
      if (input !== null) {
        _this.input = input;
      }
    };

    _this.storeItemsContainerReference = function (itemsContainer) {
      if (itemsContainer !== null) {
        _this.itemsContainer = itemsContainer;
      }
    };

    _this.onHighlightedItemChange = function (highlightedItem) {
      _this.highlightedItem = highlightedItem;
    };

    _this.getItemId = function (sectionIndex, itemIndex) {
      if (itemIndex === null) {
        return null;
      }

      var id = _this.props.id;

      var section = sectionIndex === null ? '' : 'section-' + sectionIndex;

      return 'react-autowhatever-' + id + '-' + section + '-item-' + itemIndex;
    };

    _this.onFocus = function (event) {
      var inputProps = _this.props.inputProps;


      _this.setState({
        isInputFocused: true
      });

      inputProps.onFocus && inputProps.onFocus(event);
    };

    _this.onBlur = function (event) {
      var inputProps = _this.props.inputProps;


      _this.setState({
        isInputFocused: false
      });

      inputProps.onBlur && inputProps.onBlur(event);
    };

    _this.onKeyDown = function (event) {
      var _this$props = _this.props,
          inputProps = _this$props.inputProps,
          highlightedSectionIndex = _this$props.highlightedSectionIndex,
          highlightedItemIndex = _this$props.highlightedItemIndex;


      switch (event.key) {
        case 'ArrowDown':
        case 'ArrowUp':
          {
            var nextPrev = event.key === 'ArrowDown' ? 'next' : 'prev';

            var _this$sectionIterator = _this.sectionIterator[nextPrev]([highlightedSectionIndex, highlightedItemIndex]),
                _this$sectionIterator2 = _slicedToArray(_this$sectionIterator, 2),
                newHighlightedSectionIndex = _this$sectionIterator2[0],
                newHighlightedItemIndex = _this$sectionIterator2[1];

            inputProps.onKeyDown(event, { newHighlightedSectionIndex: newHighlightedSectionIndex, newHighlightedItemIndex: newHighlightedItemIndex });
            break;
          }

        default:
          inputProps.onKeyDown(event, { highlightedSectionIndex: highlightedSectionIndex, highlightedItemIndex: highlightedItemIndex });
      }
    };

    _this.highlightedItem = null;

    _this.state = {
      isInputFocused: false
    };

    _this.setSectionsItems(props);
    _this.setSectionIterator(props);
    _this.setTheme(props);
    return _this;
  }

  _createClass(Autowhatever, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.ensureHighlightedItemIsVisible();
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.items !== this.props.items) {
        this.setSectionsItems(nextProps);
      }

      if (nextProps.items !== this.props.items || nextProps.multiSection !== this.props.multiSection) {
        this.setSectionIterator(nextProps);
      }

      if (nextProps.theme !== this.props.theme) {
        this.setTheme(nextProps);
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      this.ensureHighlightedItemIsVisible();
    }
  }, {
    key: 'setSectionsItems',
    value: function setSectionsItems(props) {
      if (props.multiSection) {
        this.sectionsItems = props.items.map(function (section) {
          return props.getSectionItems(section);
        });
        this.sectionsLengths = this.sectionsItems.map(function (items) {
          return items.length;
        });
        this.allSectionsAreEmpty = this.sectionsLengths.every(function (itemsCount) {
          return itemsCount === 0;
        });
      }
    }
  }, {
    key: 'setSectionIterator',
    value: function setSectionIterator(props) {
      this.sectionIterator = (0, _sectionIterator2.default)({
        multiSection: props.multiSection,
        data: props.multiSection ? this.sectionsLengths : props.items.length
      });
    }
  }, {
    key: 'setTheme',
    value: function setTheme(props) {
      this.theme = (0, _reactThemeable2.default)(props.theme);
    }
  }, {
    key: 'renderSections',
    value: function renderSections() {
      var _this2 = this;

      if (this.allSectionsAreEmpty) {
        return null;
      }

      var theme = this.theme;
      var _props = this.props,
          id = _props.id,
          items = _props.items,
          renderItem = _props.renderItem,
          renderItemData = _props.renderItemData,
          renderSectionTitle = _props.renderSectionTitle,
          highlightedSectionIndex = _props.highlightedSectionIndex,
          highlightedItemIndex = _props.highlightedItemIndex,
          itemProps = _props.itemProps;


      return items.map(function (section, sectionIndex) {
        var keyPrefix = 'react-autowhatever-' + id + '-';
        var sectionKeyPrefix = keyPrefix + 'section-' + sectionIndex + '-';
        var isFirstSection = sectionIndex === 0;

        // `key` is provided by theme()
        /* eslint-disable react/jsx-key */
        return _react2.default.createElement(
          'div',
          theme(sectionKeyPrefix + 'container', 'sectionContainer', isFirstSection && 'sectionContainerFirst'),
          _react2.default.createElement(_SectionTitle2.default, {
            section: section,
            renderSectionTitle: renderSectionTitle,
            theme: theme,
            sectionKeyPrefix: sectionKeyPrefix
          }),
          _react2.default.createElement(_ItemsList2.default, {
            items: _this2.sectionsItems[sectionIndex],
            itemProps: itemProps,
            renderItem: renderItem,
            renderItemData: renderItemData,
            sectionIndex: sectionIndex,
            highlightedItemIndex: highlightedSectionIndex === sectionIndex ? highlightedItemIndex : null,
            onHighlightedItemChange: _this2.onHighlightedItemChange,
            getItemId: _this2.getItemId,
            theme: theme,
            keyPrefix: keyPrefix,
            ref: _this2.storeItemsListReference
          })
        );
        /* eslint-enable react/jsx-key */
      });
    }
  }, {
    key: 'renderItems',
    value: function renderItems() {
      var items = this.props.items;


      if (items.length === 0) {
        return null;
      }

      var theme = this.theme;
      var _props2 = this.props,
          id = _props2.id,
          renderItem = _props2.renderItem,
          renderItemData = _props2.renderItemData,
          highlightedSectionIndex = _props2.highlightedSectionIndex,
          highlightedItemIndex = _props2.highlightedItemIndex,
          itemProps = _props2.itemProps;


      return _react2.default.createElement(_ItemsList2.default, {
        items: items,
        itemProps: itemProps,
        renderItem: renderItem,
        renderItemData: renderItemData,
        highlightedItemIndex: highlightedSectionIndex === null ? highlightedItemIndex : null,
        onHighlightedItemChange: this.onHighlightedItemChange,
        getItemId: this.getItemId,
        theme: theme,
        keyPrefix: 'react-autowhatever-' + id + '-'
      });
    }
  }, {
    key: 'ensureHighlightedItemIsVisible',
    value: function ensureHighlightedItemIsVisible() {
      var highlightedItem = this.highlightedItem;


      if (!highlightedItem) {
        return;
      }

      var itemsContainer = this.itemsContainer;

      var itemOffsetRelativeToContainer = highlightedItem.offsetParent === itemsContainer ? highlightedItem.offsetTop : highlightedItem.offsetTop - itemsContainer.offsetTop;

      var scrollTop = itemsContainer.scrollTop; // Top of the visible area

      if (itemOffsetRelativeToContainer < scrollTop) {
        // Item is off the top of the visible area
        scrollTop = itemOffsetRelativeToContainer;
      } else if (itemOffsetRelativeToContainer + highlightedItem.offsetHeight > scrollTop + itemsContainer.offsetHeight) {
        // Item is off the bottom of the visible area
        scrollTop = itemOffsetRelativeToContainer + highlightedItem.offsetHeight - itemsContainer.offsetHeight;
      }

      if (scrollTop !== itemsContainer.scrollTop) {
        itemsContainer.scrollTop = scrollTop;
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var theme = this.theme;
      var _props3 = this.props,
          id = _props3.id,
          multiSection = _props3.multiSection,
          renderInputComponent = _props3.renderInputComponent,
          renderItemsContainer = _props3.renderItemsContainer,
          highlightedSectionIndex = _props3.highlightedSectionIndex,
          highlightedItemIndex = _props3.highlightedItemIndex;
      var isInputFocused = this.state.isInputFocused;

      var renderedItems = multiSection ? this.renderSections() : this.renderItems();
      var isOpen = renderedItems !== null;
      var ariaActivedescendant = this.getItemId(highlightedSectionIndex, highlightedItemIndex);
      var itemsContainerId = 'react-autowhatever-' + id;
      var containerProps = _extends({
        role: 'combobox',
        'aria-haspopup': 'listbox',
        'aria-owns': itemsContainerId,
        'aria-expanded': isOpen
      }, theme('react-autowhatever-' + id + '-container', 'container', isOpen && 'containerOpen'));
      var inputComponent = renderInputComponent(_extends({
        type: 'text',
        value: '',
        autoComplete: 'off',
        'aria-autocomplete': 'list',
        'aria-controls': itemsContainerId,
        'aria-activedescendant': ariaActivedescendant
      }, theme('react-autowhatever-' + id + '-input', 'input', isOpen && 'inputOpen', isInputFocused && 'inputFocused'), this.props.inputProps, {
        onFocus: this.onFocus,
        onBlur: this.onBlur,
        onKeyDown: this.props.inputProps.onKeyDown && this.onKeyDown,
        ref: this.storeInputReference
      }));
      var itemsContainer = renderItemsContainer({
        containerProps: _extends({
          id: itemsContainerId,
          role: 'listbox'
        }, theme('react-autowhatever-' + id + '-items-container', 'itemsContainer', isOpen && 'itemsContainerOpen'), {
          ref: this.storeItemsContainerReference
        }),
        children: renderedItems
      });

      return _react2.default.createElement(
        'div',
        containerProps,
        inputComponent,
        itemsContainer
      );
    }
  }]);

  return Autowhatever;
}(_react.Component);

Autowhatever.propTypes = {
  id: _propTypes2.default.string, // Used in aria-* attributes. If multiple Autowhatever's are rendered on a page, they must have unique ids.
  multiSection: _propTypes2.default.bool, // Indicates whether a multi section layout should be rendered.
  renderInputComponent: _propTypes2.default.func, // When specified, it is used to render the input element.
  renderItemsContainer: _propTypes2.default.func, // Renders the items container.
  items: _propTypes2.default.array.isRequired, // Array of items or sections to render.
  renderItem: _propTypes2.default.func, // This function renders a single item.
  renderItemData: _propTypes2.default.object, // Arbitrary data that will be passed to renderItem()
  renderSectionTitle: _propTypes2.default.func, // This function gets a section and renders its title.
  getSectionItems: _propTypes2.default.func, // This function gets a section and returns its items, which will be passed into `renderItem` for rendering.
  inputProps: _propTypes2.default.object, // Arbitrary input props
  itemProps: _propTypes2.default.oneOfType([// Arbitrary item props
  _propTypes2.default.object, _propTypes2.default.func]),
  highlightedSectionIndex: _propTypes2.default.number, // Section index of the highlighted item
  highlightedItemIndex: _propTypes2.default.number, // Highlighted item index (within a section)
  theme: _propTypes2.default.oneOfType([// Styles. See: https://github.com/markdalgleish/react-themeable
  _propTypes2.default.object, _propTypes2.default.array])
};
Autowhatever.defaultProps = {
  id: '1',
  multiSection: false,
  renderInputComponent: defaultRenderInputComponent,
  renderItemsContainer: defaultRenderItemsContainer,
  renderItem: function renderItem() {
    throw new Error('`renderItem` must be provided');
  },
  renderItemData: emptyObject,
  renderSectionTitle: function renderSectionTitle() {
    throw new Error('`renderSectionTitle` must be provided');
  },
  getSectionItems: function getSectionItems() {
    throw new Error('`getSectionItems` must be provided');
  },
  inputProps: emptyObject,
  itemProps: emptyObject,
  highlightedSectionIndex: null,
  highlightedItemIndex: null,
  theme: defaultTheme
};
exports.default = Autowhatever;

/***/ }),
/* 646 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

module.exports = function (_ref) {
  var data = _ref.data;
  var multiSection = _ref.multiSection;

  function nextNonEmptySectionIndex(sectionIndex) {
    if (sectionIndex === null) {
      sectionIndex = 0;
    } else {
      sectionIndex++;
    }

    while (sectionIndex < data.length && data[sectionIndex] === 0) {
      sectionIndex++;
    }

    return sectionIndex === data.length ? null : sectionIndex;
  }

  function prevNonEmptySectionIndex(sectionIndex) {
    if (sectionIndex === null) {
      sectionIndex = data.length - 1;
    } else {
      sectionIndex--;
    }

    while (sectionIndex >= 0 && data[sectionIndex] === 0) {
      sectionIndex--;
    }

    return sectionIndex === -1 ? null : sectionIndex;
  }

  function next(position) {
    var _position = _slicedToArray(position, 2);

    var sectionIndex = _position[0];
    var itemIndex = _position[1];


    if (multiSection) {
      if (itemIndex === null || itemIndex === data[sectionIndex] - 1) {
        sectionIndex = nextNonEmptySectionIndex(sectionIndex);

        if (sectionIndex === null) {
          return [null, null];
        }

        return [sectionIndex, 0];
      }

      return [sectionIndex, itemIndex + 1];
    }

    if (data === 0 || itemIndex === data - 1) {
      return [null, null];
    }

    if (itemIndex === null) {
      return [null, 0];
    }

    return [null, itemIndex + 1];
  }

  function prev(position) {
    var _position2 = _slicedToArray(position, 2);

    var sectionIndex = _position2[0];
    var itemIndex = _position2[1];


    if (multiSection) {
      if (itemIndex === null || itemIndex === 0) {
        sectionIndex = prevNonEmptySectionIndex(sectionIndex);

        if (sectionIndex === null) {
          return [null, null];
        }

        return [sectionIndex, data[sectionIndex] - 1];
      }

      return [sectionIndex, itemIndex - 1];
    }

    if (data === 0 || itemIndex === 0) {
      return [null, null];
    }

    if (itemIndex === null) {
      return [null, data - 1];
    }

    return [null, itemIndex - 1];
  }

  function isLast(position) {
    return next(position)[1] === null;
  }

  return {
    next: next,
    prev: prev,
    isLast: isLast
  };
};


/***/ }),
/* 647 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, '__esModule', {
  value: true
});

var _slicedToArray = (function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i['return']) _i['return'](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError('Invalid attempt to destructure non-iterable instance'); } }; })();

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) arr2[i] = arr[i]; return arr2; } else { return Array.from(arr); } }

var _objectAssign = __webpack_require__(648);

var _objectAssign2 = _interopRequireDefault(_objectAssign);

var truthy = function truthy(x) {
  return x;
};

exports['default'] = function (input) {
  var _ref = Array.isArray(input) && input.length === 2 ? input : [input, null];

  var _ref2 = _slicedToArray(_ref, 2);

  var theme = _ref2[0];
  var classNameDecorator = _ref2[1];

  return function (key) {
    for (var _len = arguments.length, names = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      names[_key - 1] = arguments[_key];
    }

    var styles = names.map(function (name) {
      return theme[name];
    }).filter(truthy);

    return typeof styles[0] === 'string' || typeof classNameDecorator === 'function' ? { key: key, className: classNameDecorator ? classNameDecorator.apply(undefined, _toConsumableArray(styles)) : styles.join(' ') } : { key: key, style: _objectAssign2['default'].apply(undefined, [{}].concat(_toConsumableArray(styles))) };
  };
};

module.exports = exports['default'];

/***/ }),
/* 648 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function ToObject(val) {
	if (val == null) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function ownEnumerableKeys(obj) {
	var keys = Object.getOwnPropertyNames(obj);

	if (Object.getOwnPropertySymbols) {
		keys = keys.concat(Object.getOwnPropertySymbols(obj));
	}

	return keys.filter(function (key) {
		return propIsEnumerable.call(obj, key);
	});
}

module.exports = Object.assign || function (target, source) {
	var from;
	var keys;
	var to = ToObject(target);

	for (var s = 1; s < arguments.length; s++) {
		from = arguments[s];
		keys = ownEnumerableKeys(Object(from));

		for (var i = 0; i < keys.length; i++) {
			to[keys[i]] = from[keys[i]];
		}
	}

	return to;
};


/***/ }),
/* 649 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _compareObjects = __webpack_require__(191);

var _compareObjects2 = _interopRequireDefault(_compareObjects);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SectionTitle = function (_Component) {
  _inherits(SectionTitle, _Component);

  function SectionTitle() {
    _classCallCheck(this, SectionTitle);

    return _possibleConstructorReturn(this, (SectionTitle.__proto__ || Object.getPrototypeOf(SectionTitle)).apply(this, arguments));
  }

  _createClass(SectionTitle, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps) {
      return (0, _compareObjects2.default)(nextProps, this.props);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          section = _props.section,
          renderSectionTitle = _props.renderSectionTitle,
          theme = _props.theme,
          sectionKeyPrefix = _props.sectionKeyPrefix;

      var sectionTitle = renderSectionTitle(section);

      if (!sectionTitle) {
        return null;
      }

      return _react2.default.createElement(
        'div',
        theme(sectionKeyPrefix + 'title', 'sectionTitle'),
        sectionTitle
      );
    }
  }]);

  return SectionTitle;
}(_react.Component);

SectionTitle.propTypes = {
  section: _propTypes2.default.any.isRequired,
  renderSectionTitle: _propTypes2.default.func.isRequired,
  theme: _propTypes2.default.func.isRequired,
  sectionKeyPrefix: _propTypes2.default.string.isRequired
};
exports.default = SectionTitle;

/***/ }),
/* 650 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Item = __webpack_require__(651);

var _Item2 = _interopRequireDefault(_Item);

var _compareObjects = __webpack_require__(191);

var _compareObjects2 = _interopRequireDefault(_compareObjects);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ItemsList = function (_Component) {
  _inherits(ItemsList, _Component);

  function ItemsList() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, ItemsList);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ItemsList.__proto__ || Object.getPrototypeOf(ItemsList)).call.apply(_ref, [this].concat(args))), _this), _this.storeHighlightedItemReference = function (highlightedItem) {
      _this.props.onHighlightedItemChange(highlightedItem === null ? null : highlightedItem.item);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(ItemsList, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps) {
      return (0, _compareObjects2.default)(nextProps, this.props, ['itemProps']);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          items = _props.items,
          itemProps = _props.itemProps,
          renderItem = _props.renderItem,
          renderItemData = _props.renderItemData,
          sectionIndex = _props.sectionIndex,
          highlightedItemIndex = _props.highlightedItemIndex,
          getItemId = _props.getItemId,
          theme = _props.theme,
          keyPrefix = _props.keyPrefix;

      var sectionPrefix = sectionIndex === null ? keyPrefix : keyPrefix + 'section-' + sectionIndex + '-';
      var isItemPropsFunction = typeof itemProps === 'function';

      return _react2.default.createElement(
        'ul',
        _extends({ role: 'listbox' }, theme(sectionPrefix + 'items-list', 'itemsList')),
        items.map(function (item, itemIndex) {
          var isFirst = itemIndex === 0;
          var isHighlighted = itemIndex === highlightedItemIndex;
          var itemKey = sectionPrefix + 'item-' + itemIndex;
          var itemPropsObj = isItemPropsFunction ? itemProps({ sectionIndex: sectionIndex, itemIndex: itemIndex }) : itemProps;
          var allItemProps = _extends({
            id: getItemId(sectionIndex, itemIndex),
            'aria-selected': isHighlighted
          }, theme(itemKey, 'item', isFirst && 'itemFirst', isHighlighted && 'itemHighlighted'), itemPropsObj);

          if (isHighlighted) {
            allItemProps.ref = _this2.storeHighlightedItemReference;
          }

          // `key` is provided by theme()
          /* eslint-disable react/jsx-key */
          return _react2.default.createElement(_Item2.default, _extends({}, allItemProps, {
            sectionIndex: sectionIndex,
            isHighlighted: isHighlighted,
            itemIndex: itemIndex,
            item: item,
            renderItem: renderItem,
            renderItemData: renderItemData
          }));
          /* eslint-enable react/jsx-key */
        })
      );
    }
  }]);

  return ItemsList;
}(_react.Component);

ItemsList.propTypes = {
  items: _propTypes2.default.array.isRequired,
  itemProps: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.func]),
  renderItem: _propTypes2.default.func.isRequired,
  renderItemData: _propTypes2.default.object.isRequired,
  sectionIndex: _propTypes2.default.number,
  highlightedItemIndex: _propTypes2.default.number,
  onHighlightedItemChange: _propTypes2.default.func.isRequired,
  getItemId: _propTypes2.default.func.isRequired,
  theme: _propTypes2.default.func.isRequired,
  keyPrefix: _propTypes2.default.string.isRequired
};
ItemsList.defaultProps = {
  sectionIndex: null
};
exports.default = ItemsList;

/***/ }),
/* 651 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _compareObjects = __webpack_require__(191);

var _compareObjects2 = _interopRequireDefault(_compareObjects);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Item = function (_Component) {
  _inherits(Item, _Component);

  function Item() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Item);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Item.__proto__ || Object.getPrototypeOf(Item)).call.apply(_ref, [this].concat(args))), _this), _this.storeItemReference = function (item) {
      if (item !== null) {
        _this.item = item;
      }
    }, _this.onMouseEnter = function (event) {
      var _this$props = _this.props,
          sectionIndex = _this$props.sectionIndex,
          itemIndex = _this$props.itemIndex;


      _this.props.onMouseEnter(event, { sectionIndex: sectionIndex, itemIndex: itemIndex });
    }, _this.onMouseLeave = function (event) {
      var _this$props2 = _this.props,
          sectionIndex = _this$props2.sectionIndex,
          itemIndex = _this$props2.itemIndex;


      _this.props.onMouseLeave(event, { sectionIndex: sectionIndex, itemIndex: itemIndex });
    }, _this.onMouseDown = function (event) {
      var _this$props3 = _this.props,
          sectionIndex = _this$props3.sectionIndex,
          itemIndex = _this$props3.itemIndex;


      _this.props.onMouseDown(event, { sectionIndex: sectionIndex, itemIndex: itemIndex });
    }, _this.onClick = function (event) {
      var _this$props4 = _this.props,
          sectionIndex = _this$props4.sectionIndex,
          itemIndex = _this$props4.itemIndex;


      _this.props.onClick(event, { sectionIndex: sectionIndex, itemIndex: itemIndex });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Item, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps) {
      return (0, _compareObjects2.default)(nextProps, this.props, ['renderItemData']);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          isHighlighted = _props.isHighlighted,
          item = _props.item,
          renderItem = _props.renderItem,
          renderItemData = _props.renderItemData,
          restProps = _objectWithoutProperties(_props, ['isHighlighted', 'item', 'renderItem', 'renderItemData']);

      delete restProps.sectionIndex;
      delete restProps.itemIndex;

      if (typeof restProps.onMouseEnter === 'function') {
        restProps.onMouseEnter = this.onMouseEnter;
      }

      if (typeof restProps.onMouseLeave === 'function') {
        restProps.onMouseLeave = this.onMouseLeave;
      }

      if (typeof restProps.onMouseDown === 'function') {
        restProps.onMouseDown = this.onMouseDown;
      }

      if (typeof restProps.onClick === 'function') {
        restProps.onClick = this.onClick;
      }

      return _react2.default.createElement(
        'li',
        _extends({ role: 'option' }, restProps, { ref: this.storeItemReference }),
        renderItem(item, _extends({ isHighlighted: isHighlighted }, renderItemData))
      );
    }
  }]);

  return Item;
}(_react.Component);

Item.propTypes = {
  sectionIndex: _propTypes2.default.number,
  isHighlighted: _propTypes2.default.bool.isRequired,
  itemIndex: _propTypes2.default.number.isRequired,
  item: _propTypes2.default.any.isRequired,
  renderItem: _propTypes2.default.func.isRequired,
  renderItemData: _propTypes2.default.object.isRequired,
  onMouseEnter: _propTypes2.default.func,
  onMouseLeave: _propTypes2.default.func,
  onMouseDown: _propTypes2.default.func,
  onClick: _propTypes2.default.func
};
exports.default = Item;

/***/ }),
/* 652 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var defaultTheme = exports.defaultTheme = {
  container: 'react-autosuggest__container',
  containerOpen: 'react-autosuggest__container--open',
  input: 'react-autosuggest__input',
  inputOpen: 'react-autosuggest__input--open',
  inputFocused: 'react-autosuggest__input--focused',
  suggestionsContainer: 'react-autosuggest__suggestions-container',
  suggestionsContainerOpen: 'react-autosuggest__suggestions-container--open',
  suggestionsList: 'react-autosuggest__suggestions-list',
  suggestion: 'react-autosuggest__suggestion',
  suggestionFirst: 'react-autosuggest__suggestion--first',
  suggestionHighlighted: 'react-autosuggest__suggestion--highlighted',
  sectionContainer: 'react-autosuggest__section-container',
  sectionContainerFirst: 'react-autosuggest__section-container--first',
  sectionTitle: 'react-autosuggest__section-title'
};

var mapToAutowhateverTheme = exports.mapToAutowhateverTheme = function mapToAutowhateverTheme(theme) {
  var result = {};

  for (var key in theme) {
    switch (key) {
      case 'suggestionsContainer':
        result['itemsContainer'] = theme[key];
        break;

      case 'suggestionsContainerOpen':
        result['itemsContainerOpen'] = theme[key];
        break;

      case 'suggestion':
        result['item'] = theme[key];
        break;

      case 'suggestionFirst':
        result['itemFirst'] = theme[key];
        break;

      case 'suggestionHighlighted':
        result['itemHighlighted'] = theme[key];
        break;

      case 'suggestionsList':
        result['itemsList'] = theme[key];
        break;

      default:
        result[key] = theme[key];
    }
  }

  return result;
};

/***/ }),
/* 653 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var companies=[{"id":"408dd690-640a-4117-4fbf-08d5ad2bf6ba","name":"OXICAP INDUSTRIA DE GASES LTDA.","commercialName":"","cnpj":"43117399000106","city":"","stateCode":null,"buscaAdicional":"OXICAP 1259 OXICAP-AIR LIQ. MAUA 7064"},{"id":"68d6bbee-b8eb-4d0e-4fd7-08d5ad2bf6ba","name":"INTERNATIONAL COMPONENT SUPPLY LTDA","commercialName":"","cnpj":"04206328000110","city":"","stateCode":null,"buscaAdicional":"ICS 1303 ICS-INT. C. SUPPLY 7813"},{"id":"f0ea5102-1def-45ce-4ff2-08d5ad2bf6ba","name":"PLASTICOS CREMER SA","commercialName":"","cnpj":"82726316000120","city":"","stateCode":null,"buscaAdicional":"PLAST CREME EI 1368 PLASTICOS CREMER 70548"},{"id":"0eb6351c-1a05-4c63-500b-08d5ad2bf6ba","name":"FEDRIGONI BRASIL PAPEIS LTDA.","commercialName":"","cnpj":"45943370000109","city":"","stateCode":null,"buscaAdicional":"ARJO WIGGINS 1411 ARJO WIGGINS SALTO 7396"},{"id":"15a97cbf-cb43-4d15-5091-08d5ad2bf6ba","name":"COMPANHIA DE BEBIDAS DAS AMERICAS - AMBEV","commercialName":"","cnpj":"02808708000107","city":"","stateCode":null,"buscaAdicional":"AMBEV MATRIZ 1725 AMBEV GRU 7057 AMBEV CAMACARI 72328 AMBEV-CUIABA 71860"},{"id":"7f148404-e40d-471e-5176-08d5ad2bf6ba","name":"ARCELORMITTAL BEKAERT SUMARE LTDA","commercialName":"ARCELORMITTAL","cnpj":"65969156000201","city":"","stateCode":null,"buscaAdicional":"BEKAERT SUMARE 2195 CORD BR SUMARE 7071"},{"id":"908da62b-18af-45cb-5193-08d5ad2bf6ba","name":"INDUSTRIA DE ALIMENTOS BOMGOSTO LTDA","commercialName":"","cnpj":"35603679000198","city":"","stateCode":null,"buscaAdicional":"VITARELLA 2379 VITARELLA LIVRE 70606"},{"id":"eba3fc15-0bf6-4280-51ec-08d5ad2bf6ba","name":"FIBRIA-MS CELULOSE SUL MATO-GROSSENSE LTDA","commercialName":"FIBRIA-MS","cnpj":"36785418000107","city":"","stateCode":null,"buscaAdicional":"FIBRIATLAGOAS 2725 VCP TRES LAGOAS 70681 FIBRIA CARGA II 910097 FIBRIA MS INTERL. 910092 FIBRIA MS-II INTERL. 910101 FIBRIA MS INTERL 910093 FIBRIA-MS (H1) 8493 UTE.FL.MS.029694-5.01 FIBRIA (H2) 910094 UTE.FL.MS.037624-8.01 FIBRIA MS-II INTERL 910096"},{"id":"664a9956-cf91-4fad-52ca-08d5ad2bf6ba","name":"NACIONAL MINERIOS S/A","commercialName":"","cnpj":"08446702000105","city":"","stateCode":null,"buscaAdicional":"NAMISA 3313 NAMISA PIRES 71064 NAMISA FERNANDINHO 71212"},{"id":"698b10db-eefd-481d-544c-08d5ad2bf6ba","name":"COPEBRAS INDUSTRIA LTDA.","commercialName":"COPEBRAS","cnpj":"46567202000382","city":"","stateCode":null,"buscaAdicional":"ANGLO FOSFATOS 4143 COPEBRAS OUVIDOR 7498"},{"id":"9c94c951-7329-421f-54f7-08d5ad2bf6ba","name":"ONDULINE DO BRASIL LTDA.","commercialName":"TELHAS ONDULINE DO BRASIL","cnpj":"01163538000503","city":"","stateCode":null,"buscaAdicional":"ONDULINE 4620 ONDULINE-J FORA 71850"},{"id":"ecf746ea-b357-48a9-5541-08d5ad2bf6ba","name":"FIACAO E TECELAGEM NORTISTA LTDA.","commercialName":"","cnpj":"13142823000101","city":"","stateCode":null,"buscaAdicional":"NORTISTA 5209 NORTISTA-ARACAJU 71854"},{"id":"c8b172ed-f359-4dce-5572-08d5ad2bf6ba","name":"ASJA AMBIENTE ITALIA SPA","commercialName":"","cnpj":"07650490000110","city":"","stateCode":"EX","buscaAdicional":"ASJA ITALIA 5613 HORIZONTE ASJA-ASJA 20007 UTE.RU.MG.030191-4.01"},{"id":"289c6b6a-a8fd-4b04-55fb-08d5ad2bf6ba","name":"POLIMIX CONCRETO LTDA","commercialName":"POLIMIX","cnpj":"29067113021002","city":"","stateCode":null,"buscaAdicional":"POLIMIX 6471 POLIMIX MATOZINHOS 904553 MIZU - RJ 72179 POLIMIX MANAUS 904421 MARE CIMENTO BARAUNA 889325 MARE CIM -PACATUBA 71938 POLIMIX-MOGI CRUZES 72284 POLIMIX - GUARULHOS 907594"},{"id":"134c7fbd-018d-474f-5658-08d5ad2bf6ba","name":"ELIZABETH REVESTIMENTOS LTDA.","commercialName":"","cnpj":"12924130000108","city":"","stateCode":null,"buscaAdicional":"ELIZABETHREV 6921 ELIZABETH RVT JP PB 888130"},{"id":"513c812f-7f61-4e79-5784-08d5ad2bf6ba","name":"AGCO DO BRASIL MAQUINAS E EQUIPAMENTOS AGRICOLAS LTDA.","commercialName":"AGCO","cnpj":"61076055000170","city":"","stateCode":null,"buscaAdicional":"AGCO MOGI 8974 AGCO MOGI 889077"},{"id":"c28ddec7-1b4d-497b-584f-08d5ad2bf6ba","name":"ORSA INTERNATIONAL PAPER EMBALAGENS LTDA","commercialName":"","cnpj":"17101880000195","city":"","stateCode":null,"buscaAdicional":"ORSA SA 11329 ORSA PAULINIA 7195 ORSA CELSU 70515"},{"id":"e66b5b8e-a96a-4d3c-59dd-08d5ad2bf6ba","name":"MATO GROSSO BOVINOS S.A.","commercialName":"","cnpj":"15514479000151","city":"","stateCode":null,"buscaAdicional":"MATO GROSSO 15736 BRF FRIG. MIRASSOL 71427"},{"id":"7507cf9e-243e-460a-5a0f-08d5ad2bf6ba","name":"OER TEODORO SAMPAIO ENERGIA S.A.","commercialName":"","cnpj":"15864723000106","city":"","stateCode":null,"buscaAdicional":"OER TEODORO 16445 ALCIDIA 8791 UTE.AI.SP.027913-7.01"},{"id":"d4bf0309-8639-4e8b-5ab5-08d5ad2bf6ba","name":"POLIFORT INDUSTRIA, COMERCIO, IMPORTACAO E EXPORTACAO DE PERFIS E PECAS PLASTICAS S/A","commercialName":"POLIFORT","cnpj":"08263902000122","city":"","stateCode":null,"buscaAdicional":"POLIFORT MAT 50196 POLIFORT PALMEIRA PR 897369"},{"id":"cb44e6eb-b0a5-48a7-5b6e-08d5ad2bf6ba","name":"VENTOS DE SANTA GENOVEVA ENERGIAS RENOVAVEIS S.A","commercialName":"","cnpj":"17875140000106","city":"","stateCode":null,"buscaAdicional":"SANTA GENOVEVA 50703"},{"id":"f929be37-fdcb-4b9d-5b74-08d5ad2bf6ba","name":"RTL ARMAZENS E LOGISTICA LTDA.","commercialName":"REITER LOGISTICA","cnpj":"13477184000127","city":"","stateCode":null,"buscaAdicional":"RTL 50709 REITERLOG 899821"},{"id":"c7e9fa0e-6666-49db-5b87-08d5ad2bf6ba","name":"UNIAO DE ENSINO SUPERIOR DO PARA","commercialName":"UNESPA","cnpj":"15752686000144","city":"","stateCode":null,"buscaAdicional":"UNAMA BELEM 50753 UNAMA BELEM 898046"},{"id":"366ce5f8-d05a-4d6c-5b98-08d5ad2bf6ba","name":"DESTILARIAS MELHORAMENTOS S.A.","commercialName":"","cnpj":"49333800000113","city":"","stateCode":null,"buscaAdicional":"DESTIMEL NL 50775 DESTILARIA MELHOR. 897166 UTE.AI.PR.028074-7.01"},{"id":"8983c2cd-12f3-4542-5cc2-08d5ad2bf6ba","name":"COMPANHIA MULLER DE BEBIDAS NORDESTE","commercialName":"","cnpj":"02151119000190","city":"","stateCode":null,"buscaAdicional":"CIA MULLER NORDESTE 51559 CIA MULLER NORDESTE 902213"},{"id":"898b2ef3-bdd7-4bc1-5cd0-08d5ad2bf6ba","name":"KATEXTIL LTDA","commercialName":"","cnpj":"03519962000140","city":"","stateCode":null,"buscaAdicional":"KATEXTIL 51577 KATEXTIL 898647 KYLY 907105"},{"id":"1666184b-7a6e-4e5f-5f86-08d5ad2bf6ba","name":"MINERVA INDUSTRIA E COMERCIO DE ALIMENTOS S/A","commercialName":"","cnpj":"07955536000100","city":"","stateCode":null,"buscaAdicional":"MINERVA RMO 53011 MINERVA IND E COM 906263"},{"id":"35031ea7-d422-44e5-602e-08d5ad2bf6ba","name":"LOG & PRINT DADOS VARIAVEIS S.A.","commercialName":"","cnpj":"03113360000198","city":"","stateCode":null,"buscaAdicional":"LOG & PRINT SA 53416 LOG & PRINT 903870"},{"id":"6148ca83-0303-4591-62ad-08d5ad2bf6ba","name":"OCEANA ESTALEIRO S.A.","commercialName":"","cnpj":"14185954000201","city":"","stateCode":null,"buscaAdicional":"OCEANA 54916 OCEANA 905035"},{"id":"ea7e6ce6-e0d4-49d5-646b-08d5ad2bf6ba","name":"ELEBAT ALIMENTOS S.A.","commercialName":"","cnpj":"21229645000170","city":"","stateCode":null,"buscaAdicional":"ELEBAT 55989 ELEBAT TERENOS MS 906797"},{"id":"a3dfe0f4-bc65-4532-6540-08d5ad2bf6ba","name":"CONVENCAO SAO PAULO INDUSTRIA DE BEBIDAS E CONEXOS LTDA","commercialName":"","cnpj":"56199714000125","city":"","stateCode":null,"buscaAdicional":"CONVENCAO SP 56618 CONVENCAO SP BEBIDAS 906724"},{"id":"90e8251c-a23c-46ed-654a-08d5ad2bf6ba","name":"INSTITUTO MINEIRO DE EDUCACAO E CULTURA UNI-BH S/A","commercialName":"","cnpj":"08446503000288","city":"","stateCode":null,"buscaAdicional":"ANIMA UNIBH 56641 UNIBH CULTURA 907205"},{"id":"1a608789-aafe-4be7-65a6-08d5ad2bf6ba","name":"INVIVO NUTRICAO E SAUDE ANIMAL LTDA","commercialName":"","cnpj":"06066837001272","city":"","stateCode":null,"buscaAdicional":"INVIVO CANOAS 56902 INVIVO CANOAS 909680"},{"id":"e51bddaf-6be3-46fa-65b7-08d5ad2bf6ba","name":"BRPR XXVII EMPREENDIMENTOS E PARTICIPACOES LTDA.","commercialName":"","cnpj":"11426701000103","city":"","stateCode":null,"buscaAdicional":"EDIFICIO MANCHETE 56993 EDIFICIO MANCHETE 906657"},{"id":"387b17a4-ee98-4ecf-669c-08d5ad2bf6ba","name":"FRONERI BRASIL INDUSTRIAL DE SORVETES E CONGELADOS LTDA.","commercialName":"","cnpj":"25062706000109","city":"","stateCode":null,"buscaAdicional":"FRONERI 57690 NESTLE JACAREPAGUA 889546"},{"id":"fc7135d6-2d58-4fab-6768-08d5ad2bf6ba","name":"SJT FORJARIA LTDA.","commercialName":"","cnpj":"25052187000106","city":"","stateCode":null,"buscaAdicional":"SJT FORJARIA 58079 ETC SIFCO JUNDIAI 88 7826 SIFCO-CAMPINAS 70969"},{"id":"a1e1e692-8bc3-4f82-6788-08d5ad2bf6ba","name":"ISOFARMA INDUSTRIAL FARMACEUTICA LTDA","commercialName":"","cnpj":"02281006000100","city":"","stateCode":null,"buscaAdicional":"ISOFARMA 58248 ISOFARMA EUSEBIO 908390"},{"id":"46a361ba-0d9c-469e-67ed-08d5ad2bf6ba","name":"AGCO DO BRASIL MAQUINAS E EQUIPAMENTOS AGRICOLAS LTDA.","commercialName":"AGCO","cnpj":"61076055001494","city":"","stateCode":null,"buscaAdicional":"AGCO STA ROSA RS 58891 VALTRA SANTA ROSA 889382"},{"id":"70f08289-a1e5-45fe-67ee-08d5ad2bf6ba","name":"AGCO DO BRASIL MAQUINAS E EQUIPAMENTOS AGRICOLAS LTDA.","commercialName":"AGCO","cnpj":"61076055001141","city":"","stateCode":null,"buscaAdicional":"AGCO CANOAS RS 58892 VALTRA-CANOAS-RS 7167"},{"id":"0b044bf8-3b10-4d6f-6880-08d5ad2bf6ba","name":"NEVADA INDUSTRIA DE PRODUTOS MEDICOS LTDA.","commercialName":"","cnpj":"12006339000184","city":"","stateCode":null,"buscaAdicional":"BSN MEDICAL 60104 BSN MEDICAL 909756"},{"id":"ba4d7f7f-acba-47d8-68e2-08d5ad2bf6ba","name":"INVIVO NUTRICAO E SAUDE ANIMAL LTDA","commercialName":"","cnpj":"06066837001949","city":"","stateCode":null,"buscaAdicional":"INVIVO RONDONIA 60528 INVIVO ROLIM DE MOUR 905935"},{"id":"69a96877-89e5-45bb-68ff-08d5ad2bf6ba","name":"AGENTE CENTRALIZADOR DOS EFEITOS DAS LIMINARES - GSF","commercialName":null,"cnpj":"93376083000107","city":"","stateCode":"","buscaAdicional":"ACEL - GSF 60711"},{"id":"c3e95e1d-cfa8-40fb-8826-08d5ae44ed50","name":"COMPANHIA LUZ E FORCA SANTA CRUZ","commercialName":"","cnpj":"61116265000144","city":"","stateCode":null,"buscaAdicional":"CPFL STA CRUZ 28"},{"id":"9f486c47-3f4b-4172-8827-08d5ae44ed50","name":"COMPANHIA NACIONAL DE ENERGIA ELETRICA","commercialName":"","cnpj":"61416244000144","city":"","stateCode":null,"buscaAdicional":"CNEE 29"},{"id":"f6f7475a-21e7-422d-8828-08d5ae44ed50","name":"COMPANHIA SUL PAULISTA DE ENERGIA","commercialName":"SUL PAULISTA","cnpj":"60855608000120","city":"","stateCode":null,"buscaAdicional":"CPFL SUL PTA 38"},{"id":"79123cae-461a-4860-8829-08d5ae44ed50","name":"EMPRESA ELETRICA BRAGANTINA S A","commercialName":"","cnpj":"60942281000123","city":"","stateCode":null,"buscaAdicional":"EEB 43"},{"id":"233c35d8-e0df-49a8-882a-08d5ae44ed50","name":"COMPANHIA LESTE PAULISTA DE ENERGIA","commercialName":"","cnpj":"61015582000174","city":"","stateCode":null,"buscaAdicional":"CPFL LESTE PTA 129"},{"id":"7845da8a-9ee6-41cd-8830-08d5ae44ed50","name":"VOTORANTIM METAIS S.A.","commercialName":"","cnpj":"18499616000114","city":"","stateCode":null,"buscaAdicional":"VMETAIS 1205"},{"id":"12973546-5e30-447d-8839-08d5ae44ed50","name":"TIGRE S.A. PARTICIPACOES","commercialName":"","cnpj":"84684455007176","city":"","stateCode":null,"buscaAdicional":"TIGRE RC 1438"},{"id":"42c83d09-847f-449f-883a-08d5ae44ed50","name":"BTG PACTUAL COMERCIALIZADORA DE ENERGIA LTDA.","commercialName":"","cnpj":"07133522000100","city":"","stateCode":null,"buscaAdicional":"BTG PACTUAL 1591"},{"id":"9b787876-fb6f-48ef-883b-08d5ae44ed50","name":"AGCO DO BRASIL COMERCIO E INDUSTRIA LTDA","commercialName":"","cnpj":"59876003000136","city":"","stateCode":null,"buscaAdicional":"AGCO CANOAS 1647"},{"id":"a2f8b8f4-9565-41d2-883c-08d5ae44ed50","name":"COMPANHIA LUZ E FORCA DE MOCOCA","commercialName":"","cnpj":"52503802000118","city":"","stateCode":null,"buscaAdicional":"CPFL MOCOCA 1722"},{"id":"f275cf2a-492b-439a-8841-08d5ae44ed50","name":"CNH INDUSTRIAL LATIN AMERICA LTDA.","commercialName":"","cnpj":"60850617000128","city":"","stateCode":null,"buscaAdicional":"CNH 1793"},{"id":"7fbbd85b-d8ea-4869-8845-08d5ae44ed50","name":"EMPRESA DE DISTRIBUICAO DE ENERGIA VALE PARANAPANEMA S.A.","commercialName":"","cnpj":"07297359000111","city":"","stateCode":null,"buscaAdicional":"PARANAPANEMA 2103"},{"id":"6e8d61cd-5ded-47fc-884c-08d5ae44ed50","name":"CANDEIAS ENERGIA S.A.","commercialName":"CANDEIAS ENERGIA","cnpj":"09497818000136","city":"","stateCode":null,"buscaAdicional":"CANDEIAS 2970"},{"id":"222601cb-bf48-450f-884e-08d5ae44ed50","name":"FABRICA DE PAPEL E PAPELAO NOSSA SENHORA DA PENHA SA","commercialName":"","cnpj":"49912199000385","city":"","stateCode":null,"buscaAdicional":"PENHA 3129"},{"id":"b544380c-57fa-40d8-8850-08d5ae44ed50","name":"SE SUPERMERCADOS LTDA.","commercialName":"","cnpj":"01545828000198","city":"","stateCode":null,"buscaAdicional":"SE 3235"},{"id":"a7452736-781e-44ca-8852-08d5ae44ed50","name":"FRINAL S/A - FRIGORIFICO E INTEGRACAO AVICOLA","commercialName":"FRINAL","cnpj":"89750541000140","city":"","stateCode":null,"buscaAdicional":"FRINAL 3524"},{"id":"f82c080e-ebd3-419f-8855-08d5ae44ed50","name":"UNIDADE DE TRATAMENTO DE RESIDUOS S.A","commercialName":"","cnpj":"06189712000187","city":"","stateCode":null,"buscaAdicional":"UTR 3745 UTR 71223"},{"id":"43d1bd02-f324-4402-8856-08d5ae44ed50","name":"LAFARGE BRASIL S.A.","commercialName":"LACIM","cnpj":"10917819000414","city":"","stateCode":null,"buscaAdicional":"LACIM-PB 3769"},{"id":"6c97bfcb-997b-4ca2-885b-08d5ae44ed50","name":"INDUSTRIA E COMERCIO DE MOVEIS ALBA LTDA","commercialName":"","cnpj":"04600723000182","city":"","stateCode":null,"buscaAdicional":"ALBA 4207 ALBA-RODEIRO MG 71476"},{"id":"256b3ecc-6b46-4b31-885d-08d5ae44ed50","name":"LAFARGE BRASIL S.A.","commercialName":"","cnpj":"10917819000171","city":"","stateCode":null,"buscaAdicional":"LAFARGE BRASIL 4374"},{"id":"8803de54-902a-4c27-885f-08d5ae44ed50","name":"SOCIEDADE EDUCACIONAL BRAZ CUBAS LTDA.","commercialName":"FEDERACAO DAS FACULDADES BRAZ CUBAS","cnpj":"52556412000378","city":"","stateCode":null,"buscaAdicional":"UNIVEBRASCUBAS 4396"},{"id":"da582ef1-e700-46af-8865-08d5ae44ed50","name":"ARCELORMITTAL COMERCIALIZADORA DE ENERGIA LTDA.","commercialName":"","cnpj":"14549239000120","city":"","stateCode":null,"buscaAdicional":"AM ENERGIA 5196"},{"id":"ade6f47e-cdb6-4307-8867-08d5ae44ed50","name":"CNH INDUSTRIAL LATIN AMERICA LTDA.","commercialName":"","cnpj":"60850617000985","city":"","stateCode":null,"buscaAdicional":"CNH CURITIBA 5399"},{"id":"457409c4-52f5-4a77-886a-08d5ae44ed50","name":"MINERACAO TURMALINA LTDA","commercialName":"","cnpj":"01731616000103","city":"","stateCode":null,"buscaAdicional":"MTL-TURMALINA 5710"},{"id":"85bd41b9-1336-4b79-8878-08d5ae44ed50","name":"PINCÉIS TIGRE LTDA","commercialName":"","cnpj":"61182606000180","city":"","stateCode":null,"buscaAdicional":"PINCEIS TIGRE 7620"},{"id":"3452fc5b-c9b4-4035-887a-08d5ae44ed50","name":"CNH INDUSTRIAL LATIN AMERICA LTDA.","commercialName":"","cnpj":"60850617002090","city":"","stateCode":null,"buscaAdicional":"CNH SOROCABA 8232"},{"id":"dc8486e6-28c5-45e0-887e-08d5ae44ed50","name":"AGCO DO BRASIL COMERCIO E INDUSTRIA LTDA","commercialName":"","cnpj":"59876003000217","city":"","stateCode":null,"buscaAdicional":"AGCO STA ROSA 8975"},{"id":"ec5f2e81-79b7-48f1-8884-08d5ae44ed50","name":"CRISTAL MINERACAO DO BRASIL LTDA","commercialName":"","cnpj":"08571089000158","city":"","stateCode":null,"buscaAdicional":"CRISTAL MINERACAO 10450"},{"id":"4e0cc313-05a5-4fcf-8886-08d5ae44ed50","name":"COMPANHIA MARANHENSE DE REFRIGERANTES","commercialName":"","cnpj":"06272199001327","city":"","stateCode":null,"buscaAdicional":"RENOSA 10769"},{"id":"2f125b50-1c9e-4431-888c-08d5ae44ed50","name":"BRASALPLA PERNAMBUCO - INDUSTRIA DE EMBALAGENS LTDA","commercialName":"","cnpj":"09292229000111","city":"","stateCode":null,"buscaAdicional":"BRASALPLA PERNAMBUCO 12972"},{"id":"89c0dcd8-bc3b-4323-888f-08d5ae44ed50","name":"FIDELITY PROCESSADORA S.A.","commercialName":"","cnpj":"04792521000503","city":"","stateCode":null,"buscaAdicional":"FIDELITY 13196"},{"id":"256895a1-45ee-4fd0-88a9-08d5ae44ed50","name":"OER RIO BRILHANTE ENERGIA S.A.","commercialName":"","cnpj":"15806930000104","city":"","stateCode":null,"buscaAdicional":"OER BRILHANTE 16446"},{"id":"74c91d8c-5192-42d7-88aa-08d5ae44ed50","name":"OER CACU ENERGIA S.A.","commercialName":"","cnpj":"19006822000108","city":"","stateCode":null,"buscaAdicional":"OER CACU 16447"},{"id":"869eeaf1-ca56-47ee-88ab-08d5ae44ed50","name":"OER NOVA ALVORADA ENERGIA S.A.","commercialName":"","cnpj":"19005112000163","city":"","stateCode":null,"buscaAdicional":"OER ALVORADA 16448"},{"id":"9e6dc03e-506e-4059-88ac-08d5ae44ed50","name":"OER MIRANTE ENERGIA S.A.","commercialName":"","cnpj":"19006829000120","city":"","stateCode":null,"buscaAdicional":"OER MIRANTE 16464 CONQUISTA DO PONTAL 8650 UTE.AI.SP.030024-1.01"},{"id":"12bb74ec-1b15-4b57-88b7-08d5ae44ed50","name":"PERNAMBUCO COMERCIALIZADORA DE ENERGIA RENOVAVEL LTDA","commercialName":"PERNAMBUCO ENERGIA","cnpj":"21072532000104","city":"","stateCode":null,"buscaAdicional":"PERNAMBUCO ENERGIA 50095"},{"id":"b632d2cf-3c99-4327-88a6-08d5ae44ed50","name":"LAFARGE BRASIL S.A.","commercialName":"","cnpj":"10917819003600","city":"","stateCode":null,"buscaAdicional":"LAFARGE MONTES CLAROS 15715"},{"id":"53e05232-53c6-423f-88bd-08d5ae44ed50","name":"SYNGENTA SEEDS LTDA.","commercialName":"","cnpj":"49156326000100","city":"","stateCode":null,"buscaAdicional":"SYNGENTA SEEDS 50617"},{"id":"8768333a-f191-4be5-88c2-08d5ae44ed50","name":"EMBALPLAN INDUSTRIA E COMERCIO DE EMBALAGENS S/A","commercialName":"","cnpj":"72250988000158","city":"","stateCode":null,"buscaAdicional":"EMBALPLAN 50891"},{"id":"519cf263-1fba-4e19-88c3-08d5ae44ed50","name":"METALURGICA SKYCUT LTDA.","commercialName":"","cnpj":"07323558000157","city":"","stateCode":null,"buscaAdicional":"METALURGICA SKYCUT 51075"},{"id":"6f53dfd3-99a7-46f0-88c4-08d5ae44ed50","name":"CNH INDUSTRIAL LATIN AMERICA LTDA.","commercialName":"CNH","cnpj":"60850617001019","city":"","stateCode":null,"buscaAdicional":"CNH PIRACICABA 51260"},{"id":"4ce1c186-24c2-4059-88cd-08d5ae44ed50","name":"ESTANCIA HIDROMINERAL DE ITABIRITO LTDA","commercialName":"","cnpj":"01313895000187","city":"","stateCode":null,"buscaAdicional":"ESTANCIA HIDROMINERAL 52091"},{"id":"ac80dd12-9d5c-4c66-88c0-08d5ae44ed50","name":"CRH CANTAGALO INDUSTRIA DE CIMENTOS S.A.","commercialName":"","cnpj":"20927816000172","city":"","stateCode":null,"buscaAdicional":"CRH CANTAGALO 50764"},{"id":"8272b354-1236-4f98-88d2-08d5ae44ed50","name":"HACO FIOS LTDA","commercialName":"HACO FIOS","cnpj":"04740731000124","city":"","stateCode":null,"buscaAdicional":"HACO FIOS 52592"},{"id":"7f915d01-c62d-4477-88d7-08d5ae44ed50","name":"BIO SOJA FERTILIZANTES LTDA","commercialName":"","cnpj":"02423920000148","city":"","stateCode":null,"buscaAdicional":"BIO SOJA 52919"},{"id":"2042aa28-d680-4571-88d8-08d5ae44ed50","name":"DANEVA MAQUINAS E CONDUTORES ELETRICOS LTDA","commercialName":"","cnpj":"47090782000160","city":"","stateCode":null,"buscaAdicional":"DANEVA 52920"},{"id":"17523218-da55-45cc-88dc-08d5ae44ed50","name":"NUTRIZON ALIMENTOS LTDA","commercialName":"NUTRIZON","cnpj":"07242726000180","city":"","stateCode":null,"buscaAdicional":"NUTRIZON 53496"},{"id":"5647c6df-7269-4a50-88f4-08d5ae44ed50","name":"BRASLO PRODUTOS DE CARNE LTDA","commercialName":"","cnpj":"47488531000139","city":"","stateCode":null,"buscaAdicional":"BRASLO 56811"},{"id":"f79ce547-3585-4447-88f8-08d5ae44ed50","name":"GNATUS EQUIPAMENTOS MEDICO ODONTOLOGICOS S/A","commercialName":"GNATUS EQUIPAMENTOS MEDICO ODONTOLOGICOS S/A","cnpj":"48015119000164","city":"","stateCode":null,"buscaAdicional":"GNATUS 57382"},{"id":"c54c1c52-acff-4711-88f9-08d5ae44ed50","name":"ADMINISTRACAO IMOBILIARIA SANTA MARGARIDA LTDA","commercialName":"SUPERMERCADO BRAIZINHO","cnpj":"22007280000607","city":"","stateCode":null,"buscaAdicional":"SUPER BRAIZINHO 57577"},{"id":"4e7175a0-3226-4879-720d-08d5cf600bef","name":"NET SERVICOS DE COMUNICACAO S/A","commercialName":"","cnpj":"00108786000165","city":"","stateCode":null,"buscaAdicional":""},{"id":"d5fcb42d-4bea-4b0c-721a-08d5cf600bef","name":"GTD PARTICIPACOES S/A","commercialName":"","cnpj":"00649881000176","city":"","stateCode":null,"buscaAdicional":""},{"id":"7d26fc39-820d-4b22-722b-08d5cf600bef","name":"ENERGIPAR PARTICIPACOES S/A","commercialName":"ENERGIPAR S.A.","cnpj":"01414107000149","city":"","stateCode":null,"buscaAdicional":""},{"id":"10eacb38-8ff2-4322-7232-08d5cf600bef","name":"VALETRON S/A","commercialName":"","cnpj":"01772313000120","city":"","stateCode":null,"buscaAdicional":""},{"id":"b75cd5e7-e128-4a2f-723d-08d5cf600bef","name":"TELEMAR PARTICIPACOES S/A","commercialName":"","cnpj":"02107946000187","city":"","stateCode":null,"buscaAdicional":""},{"id":"deedf11d-2db6-4647-7248-08d5cf600bef","name":"SUBESTACAO ELETROMETRO S.A","commercialName":"","cnpj":"02286509000178","city":"","stateCode":null,"buscaAdicional":""},{"id":"49edba01-1e2f-4cfa-724a-08d5cf600bef","name":"DALETH PARTICIPACOES S.A.","commercialName":"","cnpj":"02312604000107","city":"","stateCode":null,"buscaAdicional":""},{"id":"ea5ca123-28b2-4387-7253-08d5cf600bef","name":"LF TEL S/A","commercialName":"","cnpj":"02390206000109","city":"","stateCode":null,"buscaAdicional":""},{"id":"ce5e4281-8a25-4ece-7260-08d5cf600bef","name":"EMBRATEL PARTICIPACOES S.A.","commercialName":"","cnpj":"02558124000112","city":"","stateCode":null,"buscaAdicional":""},{"id":"fc40fba3-67df-4ad3-7272-08d5cf600bef","name":"AETATIS CONSULTORIA EMPRESARIAL S.A.","commercialName":"","cnpj":"02808481000191","city":"","stateCode":null,"buscaAdicional":""},{"id":"cc7fc5c6-4622-439b-7275-08d5cf600bef","name":"VICUNHA SIDERURGIA S/A.","commercialName":"","cnpj":"02871007000104","city":"","stateCode":null,"buscaAdicional":""},{"id":"8301d48f-e59b-424c-7279-08d5cf600bef","name":"CEMIG TELECOMUNICACOES S.A.-CEMIGTELECOM","commercialName":"","cnpj":"02983428000127","city":"","stateCode":null,"buscaAdicional":""},{"id":"bfaa8b3b-74fd-47e4-727b-08d5cf600bef","name":"AES TIETE S/A","commercialName":"","cnpj":"02998609000127","city":"","stateCode":null,"buscaAdicional":""},{"id":"57cbdb19-eefe-4c79-7286-08d5cf600bef","name":"ARAUCARIA PARTICIPACOES S.A.","commercialName":"","cnpj":"03616277000131","city":"","stateCode":null,"buscaAdicional":""},{"id":"13079192-7d8a-49bc-7295-08d5cf600bef","name":"BRPR 53 SECURITIZADORA DE CREDITOS IMOBILIARIOS S.A.","commercialName":"","cnpj":"04370082000117","city":"","stateCode":null,"buscaAdicional":""},{"id":"bd2453dd-677a-442b-72a2-08d5cf600bef","name":"SOLVAY INDUPA S A I C","commercialName":"","cnpj":"05711813000103","city":"","stateCode":"EX","buscaAdicional":""},{"id":"3637072a-4591-4780-72b0-08d5cf600bef","name":"TEMPO PARTICIPACOES S.A.","commercialName":"","cnpj":"06977739000134","city":"","stateCode":null,"buscaAdicional":""},{"id":"b16edc15-10b5-4251-72c8-08d5cf600bef","name":"CENTENNIAL ASSET PARTICIPACOES MINAS-RIO S.A.","commercialName":"","cnpj":"07949970000187","city":"","stateCode":null,"buscaAdicional":""},{"id":"47eafb8a-d171-48c4-72e2-08d5cf600bef","name":"LAEP INVESTMENTS LTD","commercialName":"","cnpj":"08904552000136","city":"","stateCode":"EX","buscaAdicional":""},{"id":"c18a63c4-dcd0-4e47-72e4-08d5cf600bef","name":"INTERNATIONAL MEAL COMPANY HOLDINGS S.A.","commercialName":"","cnpj":"08936792000112","city":"","stateCode":null,"buscaAdicional":""},{"id":"02939d4c-2c4a-492b-72e6-08d5cf600bef","name":"AGRENCO LTD","commercialName":"","cnpj":"08943312000140","city":"","stateCode":"EX","buscaAdicional":""},{"id":"a85962a9-5f4c-4eb5-72f8-08d5cf600bef","name":"BERNA PARTICIPACOES S.A.","commercialName":"","cnpj":"09400937000129","city":"","stateCode":null,"buscaAdicional":""},{"id":"fe6dd849-26d8-4ef5-72fc-08d5cf600bef","name":"BRT HOLDING 1 S.A.","commercialName":"","cnpj":"09462890000128","city":"","stateCode":null,"buscaAdicional":""},{"id":"cabc9554-4e00-4cd1-72fe-08d5cf600bef","name":"AGV HOLDING S.A","commercialName":"","cnpj":"09594796000122","city":"","stateCode":null,"buscaAdicional":""},{"id":"92a469c6-5235-4a41-72ff-08d5cf600bef","name":"CTX PARTICIPACOES S.A","commercialName":"","cnpj":"09601322000160","city":"","stateCode":null,"buscaAdicional":""},{"id":"2edadba7-3ce7-4093-7305-08d5cf600bef","name":"DUXXI IMOBILIARIA S.A.","commercialName":"","cnpj":"10382341000122","city":"","stateCode":null,"buscaAdicional":""},{"id":"699e9b84-b1ec-4c67-731e-08d5cf600bef","name":"PASCRO PARTICIPACOES S.A.","commercialName":"","cnpj":"11995753000109","city":"","stateCode":null,"buscaAdicional":""},{"id":"f93f98ea-2bdc-4299-7321-08d5cf600bef","name":"REDENTOR ENERGIA S.A.","commercialName":"","cnpj":"12126500000153","city":"","stateCode":null,"buscaAdicional":""},{"id":"63333a55-110e-49d0-733d-08d5cf600bef","name":"NISA PARTICIPACOES S.A.","commercialName":"","cnpj":"14200537000100","city":"","stateCode":null,"buscaAdicional":""},{"id":"04b36db3-8c31-4e47-734d-08d5cf600bef","name":"BPMB I PARTICIPACOES S.A.","commercialName":"","cnpj":"15483430000189","city":"","stateCode":null,"buscaAdicional":""},{"id":"3b54fe66-8936-4960-734f-08d5cf600bef","name":"SMILES S.A.","commercialName":"","cnpj":"15912764000120","city":"","stateCode":null,"buscaAdicional":""},{"id":"7180690b-6f91-43a5-7367-08d5cf600bef","name":"MERCANTIL DO BRASIL LEASING S/A-ARRENDAMENTO MERCANTIL","commercialName":"","cnpj":"26386169000115","city":"","stateCode":null,"buscaAdicional":""},{"id":"387aa03e-7935-4a34-736c-08d5cf600bef","name":"TAIPE TRANCOSO EMPREENDIMENTOS S/A","commercialName":"","cnpj":"28573830000127","city":"","stateCode":null,"buscaAdicional":""},{"id":"1d4bce33-a4e0-4c14-7383-08d5cf600bef","name":"AMIL PARTICIPACOES SA","commercialName":"","cnpj":"36461242000120","city":"","stateCode":null,"buscaAdicional":""},{"id":"e97f2316-c0e4-49f5-739a-08d5cf600bef","name":"M&G POLIESTER S.A.","commercialName":"EXCEL","cnpj":"56806656000150","city":"","stateCode":null,"buscaAdicional":""},{"id":"72561d3e-783d-4174-73bc-08d5cf600bef","name":"COMPANHIA DE CREDITO, FINANCIAMENTO E INVESTIMENTO RCI BRASIL","commercialName":"","cnpj":"61784278000191","city":"","stateCode":null,"buscaAdicional":""},{"id":"0a48510d-9dd0-42d6-73ff-08d5cf600bef","name":"JP PARTICIPACOES S.A","commercialName":"","cnpj":"15463423000115","city":"","stateCode":null,"buscaAdicional":""},{"id":"83451588-c786-4838-7403-08d5cf600bef","name":"ISEC BRASIL SECURITIZADORA S.A.","commercialName":"","cnpj":"17568683000180","city":"","stateCode":null,"buscaAdicional":""},{"id":"f4589e7f-90bd-40ab-7406-08d5cf600bef","name":"RUMO LOGISTICA OPERADORA MULTIMODAL S.A.","commercialName":"","cnpj":"71550388000142","city":"","stateCode":null,"buscaAdicional":""},{"id":"de666165-50cb-4fc9-8d91-08d5d060706e","name":"FRIGORIFICO ASTRA DO PARANA LTDA","commercialName":"","cnpj":"07615913000242","city":"","stateCode":null,"buscaAdicional":"FRIGO ASTRA 61043 FRIGORIFICO ASTRA 913488"},{"id":"f66fca2b-e56a-41f0-4f0d-08d5d159243d","name":"TGLT S/A","commercialName":"","cnpj":"14212464000176","city":"","stateCode":"EX","buscaAdicional":""},{"id":"639c994d-070a-4d14-4f0f-08d5d159243d","name":"SCCA SECURITIZADORA DE CREDITOS DO AGRONEGOCIO S.A.","commercialName":"","cnpj":"19288959000100","city":"","stateCode":null,"buscaAdicional":""},{"id":"d7835533-77d5-4e34-4f13-08d5d159243d","name":"FOXFIELD PARTICIPACOES S.A.","commercialName":"FOXFIELD","cnpj":"21987041000193","city":"","stateCode":null,"buscaAdicional":""},{"id":"e097bc12-556d-4df6-4f14-08d5d159243d","name":"FOURSTONES PARTICIPACOES S.A.","commercialName":"FOURSTONES","cnpj":"21987053000118","city":"","stateCode":null,"buscaAdicional":""},{"id":"f36a054b-712d-46dc-4f15-08d5d159243d","name":"FRIESTON PARTICIPACOES S.A.","commercialName":"FRIESTON","cnpj":"21987068000186","city":"","stateCode":null,"buscaAdicional":""},{"id":"a075b9df-8634-4e9a-4f18-08d5d159243d","name":"RR CASA DE INVESTIMENTOS E PARTICIPACOES S.A.","commercialName":"CMN SOLUTIONS A005 PARTICIPACOES S.A","cnpj":"22131736000131","city":"","stateCode":null,"buscaAdicional":""},{"id":"80470c44-2b8b-43f9-9f7f-08d5d7870f30","name":"VITAMILHO ALIMENTOS DO NORDESTE LTDA","commercialName":"","cnpj":"04747020000181","city":"","stateCode":null,"buscaAdicional":""},{"id":"a8b71fc5-d735-4c95-1cb8-08d5b8870181","name":"HIDROLUZ CENTRAIS ELETRICAS LTDA","commercialName":"HIDROLUZ","cnpj":"04907355000110","city":"ALTA FLORESTA D'OESTE","stateCode":"RO","buscaAdicional":"HIDROLUZ 60985 PCH FIGUEIRA - HIDRO 913271 PCH.PH.RO.029758-5.01"},{"id":"442ff3ff-5703-4594-657a-08d5ad2bf6ba","name":"HIDROELETRICA CACHIMBO ALTO LTDA","commercialName":"CACHIMBO ALTO LTDA","cnpj":"08264991000121","city":"ALTA FLORESTA D'OESTE","stateCode":"RO","buscaAdicional":"PCH CACHIMBO ALTO 56739 CACHIMBO ALTO 910095 PCH.PH.RO.030573-1.01"},{"id":"ec4fa1f3-45ec-4bfa-5b6b-08d5ad2bf6ba","name":"CENTRAIS ELETRICAS FIGUEIRAO LTDA","commercialName":"","cnpj":"07530227000198","city":"ALTA FLORESTA D'OESTE","stateCode":"RO","buscaAdicional":"PCH FIGUEIRA 50700 PCH FIGUEIRA 908877 PCH.PH.RO.029758-5.01"},{"id":"b837fdf6-a65a-4baf-5996-08d5ad2bf6ba","name":"ELETROSSOL CENTRAIS ELETRICAS CASSOL LTDA","commercialName":"","cnpj":"02301444000192","city":"ALTA FLORESTA D'OESTE","stateCode":"RO","buscaAdicional":"PCH MONTE BELO 14996 MONTE BELO 894542 PCH.PH.RO.027072-5.01"},{"id":"74fa2648-f3af-42fa-5850-08d5ad2bf6ba","name":"HIDROSSOL HIDROELETRICAS CASSOL LTDA.","commercialName":"HIDROSSOL","cnpj":"04267560000168","city":"ALTA FLORESTA D'OESTE","stateCode":"RO","buscaAdicional":"PCH RIO BRANCO 11349 RIO BRANCO 892782 PCH.PH.RO.028026-7.01"},{"id":"8eb681a4-a44e-4f04-5382-08d5ad2bf6ba","name":"HIDROELETRICA ANGELO CASSOL LTDA.","commercialName":"P.C.H. ANGELO CASSOL","cnpj":"04856326000176","city":"ALTA FLORESTA D'OESTE","stateCode":"RO","buscaAdicional":"PCH ANGELO 3673 ANGELO CASSOL 8834 PCH.PH.RO.028849-7.01"},{"id":"a74768f1-1d89-4af6-53cd-08d5ad2bf6ba","name":"CANAA GERACAO DE ENERGIA S/A","commercialName":"CANAA GERACAO DE ENERGIA","cnpj":"06900697000133","city":"ARIQUEMES","stateCode":"RO","buscaAdicional":"CANAA 3867 STA CRUZ MONTE NEGRO 892762 PCH.PH.RO.029434-9.01 PCH CANAA 894625 PCH.PH.RO.029436-5.01 JAMARI 894626 PCH.PH.RO.029435-7.01"},{"id":"2d74da03-04b2-4ecf-6801-08d5ad2bf6ba","name":"R P C ADMINISTRADORA DE IMOVEIS EIRELI","commercialName":"","cnpj":"25206342000193","city":"CACOAL","stateCode":"RO","buscaAdicional":"RPC 59179 RPC ADMINISTRADORA D 912447"},{"id":"2016e5fc-2de8-426c-6904-08d5ad2bf6ba","name":"CACHOEIRA PARECIS SA","commercialName":"","cnpj":"01938852000197","city":"CEREJEIRAS","stateCode":"RO","buscaAdicional":"CGH SAO JOAO PA 60720 SAO JOAO PA 910991 CGH.PH.RO.027161-6.02"},{"id":"ad8badf1-4a24-4a24-59f8-08d5ad2bf6ba","name":"PCH CASTAMAN LTDA","commercialName":"PCH - 2","cnpj":"01293871000103","city":"COLORADO DO OESTE","stateCode":"RO","buscaAdicional":"CGH CASTAMAN II 16176 CASTAMAN II 895381 CGH.PH.RO.028083-6.02"},{"id":"84530cfd-36ba-4087-59f9-08d5ad2bf6ba","name":"HIDRELETRICA MARGARIDA LTDA","commercialName":"PCH CASTAMAN III","cnpj":"01903504000184","city":"COLORADO DO OESTE","stateCode":"RO","buscaAdicional":"PCH CASTAMAN III 16177 CASTAMAN III 895261 CGH.PH.RO.028099-2.02"},{"id":"1a5edff7-c18a-4036-5737-08d5ad2bf6ba","name":"SEBO JI-PARANA INDUSTRIA E COMERCIO DE PRODUTOS ANIMAIS LTDA","commercialName":"SEBO JI-PARANA","cnpj":"11181903000132","city":"JI-PARANÁ","stateCode":"RO","buscaAdicional":"SEBOJI PARANA 8352 SEBO JI PARANA 888314"},{"id":"dc24b48e-95ff-470c-55e1-08d5ad2bf6ba","name":"BRASIL DE RONDONIA INDUSTRIA E COMERCIO DE VIDROS LTDA","commercialName":"MIRANDEX REFERENCIA EM VIDROS","cnpj":"03727410000127","city":"JI-PARANÁ","stateCode":"RO","buscaAdicional":"BRASIL RON 6272 MIRANDEX - JI-PARANA 888198"},{"id":"1270955f-ef13-4242-6581-08d5ad2bf6ba","name":"BERNARDO ALIMENTOS INDUSTRIA E COMERCIO LTDA.","commercialName":"BERNARDO ALIMENTOS","cnpj":"05194398000168","city":"JI-PARANÁ","stateCode":"RO","buscaAdicional":"BERNARDO ALIMENTOS 56752 BERNARDO ALIM JI PAR 908187"},{"id":"27083a0c-06e3-4918-560d-08d5ad2bf6ba","name":"ELETRO CESAR GERACAO DE ENERGIA LTDA","commercialName":"ELETRO CESAR LTDA","cnpj":"04647811000130","city":"PIMENTA BUENO","stateCode":"RO","buscaAdicional":"PCH PRIMAVERA 6562 PRIMAVERA 8985 PCH.PH.RO.028840-3.01"},{"id":"31823bb2-73e7-47c8-54a5-08d5ad2bf6ba","name":"UNIRON - UNIAO DAS ESCOLAS SUPERIORES DE RONDONIA LTDA.","commercialName":"UNIRON","cnpj":"03327149000178","city":"PORTO VELHO","stateCode":"RO","buscaAdicional":"UNI UNIRON 4407 UNIRON RIO MADEIRA 888288 UNIRON MAMORE 888289 UNIRON MAMORE 2 898153"},{"id":"412e9c17-57e9-48a9-527e-08d5ad2bf6ba","name":"TERMO NORTE ENERGIA S/A","commercialName":"","cnpj":"02750988000131","city":"PORTO VELHO","stateCode":"RO","buscaAdicional":"TERMONORTE 3092 TERMONORTE II 8607 UTE.GN.RO.028033-0.01"},{"id":"b4274a48-ceb4-49ff-51bd-08d5ad2bf6ba","name":"CENTRAIS ELETRICAS DE RONDONIA SA CERON","commercialName":"ELETROBRAS DISTRIBUICAO RONDONIA","cnpj":"05914650000166","city":"PORTO VELHO","stateCode":"RO","buscaAdicional":"CERON 2556 CERON 70792 JIRAU-CANTEIRO OBRAS 70804"},{"id":"eb4442ad-ffc9-420a-5da1-08d5ad2bf6ba","name":"CONDOMINIO EDILICIO DO COMPLEXO DO PORTO VELHO SHOPPING","commercialName":"","cnpj":"19539419000144","city":"PORTO VELHO","stateCode":"RO","buscaAdicional":"PORTO VELHO SHOPPING 51940 COMPLEXO DO PORTO 901088"},{"id":"083273e1-5262-43ee-5e9a-08d5ad2bf6ba","name":"INDUSTRIA E COMERCIO DE BEBIDAS MDM LTDA","commercialName":"REFRIGERANTES DYDYO","cnpj":"03559491000101","city":"PORTO VELHO","stateCode":"RO","buscaAdicional":"MDM 52461 MDM 904022"},{"id":"cae2b220-62e5-4942-64c9-08d5ad2bf6ba","name":"COIMBRA IMPORTACAO E EXPORTACAO LTDA","commercialName":"DISTRIBUIDORA COIMBRA","cnpj":"06151921000131","city":"PORTO VELHO","stateCode":"RO","buscaAdicional":"COIMBRA 56221 COIMBRA MATRIZ 912420 COIMBRA 912446"},{"id":"43a4990e-5a1f-46c9-66d4-08d5ad2bf6ba","name":"GUAPORE INDUSTRIA E COMERCIO DE VIDROS LTDA","commercialName":"GUAPORE VIDROS","cnpj":"07328256000171","city":"PORTO VELHO","stateCode":"RO","buscaAdicional":"GUAPORE VIDROS 57846 GUAPORE VIDROS 908859"},{"id":"73c4d4e8-2552-4f49-8da7-08d5d060706e","name":"CENTRO DE ENSINO SAO LUCAS LTDA","commercialName":"CENTRO UNIVERSITARIO SAO LUCAS","cnpj":"84596170000170","city":"PORTO VELHO","stateCode":"RO","buscaAdicional":"SAO LUCAS 62150 CENTRO SAO LUCAS 913612"},{"id":"e2ed5165-c875-448c-676e-08d5ad2bf6ba","name":"BLUAMERICA INDUSTRIA E COMERCIO DE COUROS LTDA","commercialName":"BLUAMERICA COUROS","cnpj":"15174730000186","city":"PRESIDENTE MÉDICI","stateCode":"RO","buscaAdicional":"BLUAMERICA COUROS 58094 BLUAMERICA COURO 909095"},{"id":"6ab1deb1-2b98-41e4-6979-08d5ad2bf6ba","name":"NEOVIA NUTRICAO E SAUDE ANIMAL LTDA.","commercialName":"NEOVIA NUTRICAO E SAUDE ANIMAL LTDA","cnpj":"18631739002291","city":"ROLIM DE MOURA","stateCode":"RO","buscaAdicional":"NEOVIA 62132"},{"id":"1d4e4a71-1dde-4552-5834-08d5ad2bf6ba","name":"CASSOL CENTRAIS ELETRICAS LTDA","commercialName":"","cnpj":"22845499000170","city":"ROLIM DE MOURA","stateCode":"RO","buscaAdicional":"PCH CABIXI 11010 CABIXI II 889951 PCH.PH.MT.028482-3.01 CABIXI I 889950 PCH.PH.RO.027042-3.01"},{"id":"a7f6b956-8e70-47e6-5a03-08d5ad2bf6ba","name":"PEQUENA CENTRAL HIDRELETRICA CACHOEIRA DO CAMBARA LTDA","commercialName":"PCH CACHOEIRA DO CAMBARA","cnpj":"15682054000151","city":"VILHENA","stateCode":"RO","buscaAdicional":"PCH CACHOEIRA CAMBARA 16339 CACHOEIRA CAMBARA 895341 CGH.PH.RO.032220-2.01"},{"id":"4afd0e2f-e2c8-4a19-5361-08d5ad2bf6ba","name":"MMRC GERACAO DE ENERGIA LTDA","commercialName":"MMRC ENERGIA","cnpj":"04101275000172","city":"VILHENA","stateCode":"RO","buscaAdicional":"MMRC 3603 MARCOL 8921 CGH.PH.RO.001412-5.02"},{"id":"2afdf09e-cfb7-4ebf-5609-08d5ad2bf6ba","name":"PATO BRANCO ALIMENTOS LTDA","commercialName":"SUPERMERCADO PATO BRANCO","cnpj":"02570953000110","city":"VILHENA","stateCode":"RO","buscaAdicional":"PATO BRANCO 6502 PATO BRANCO GETULIO 889622 PATO BRANCO MATRIZ 889623"},{"id":"4d0cea80-77f5-433a-59ce-08d5ad2bf6ba","name":"HIDROELETRICA BERGAMIN LTDA.","commercialName":"PCH BERGAMIN","cnpj":"09342398000119","city":"ALTO ALEGRE DOS PARECIS","stateCode":"RO","buscaAdicional":"PCH BERGAMIN 15615 BERGAMIN 894844 PCH.PH.RO.026716-3.01"},{"id":"a450ad49-5d98-45c7-5878-08d5ad2bf6ba","name":"USINA HIDRELETRICA CACHOEIRA LTDA","commercialName":"USINA CACHOEIRA","cnpj":"07210615000191","city":"CHUPINGUAIA","stateCode":"RO","buscaAdicional":"PCH CHUPINGUAIA 11952 CHUPINGUAIA PCH 891021 PCH.PH.RO.000775-7.01"},{"id":"3306422c-a78a-4f24-590e-08d5ad2bf6ba","name":"CENTRAIS ELETRICAS CESAR FILHO LTDA.","commercialName":"PCH CESAR FILHO","cnpj":"08879127000134","city":"CHUPINGUAIA","stateCode":"RO","buscaAdicional":"PCH CESAR FILHO AP 13652 CESAR FILHO 892462 PCH.PH.RO.031050-6.01"},{"id":"aeb3d840-4bbd-4c7a-5354-08d5ad2bf6ba","name":"HIDROELETRICA CHUPINGUAIA LTDA","commercialName":"P.C.H. CASCATA","cnpj":"05551710000123","city":"CHUPINGUAIA","stateCode":"RO","buscaAdicional":"PCH CASCATA 3583 CASCATA CHUPINGUAIA 8830 PCH.PH.RO.029373-3.01"},{"id":"2ee8958d-fda3-4cdf-663d-08d5ad2bf6ba","name":"DISTRIBOI - INDUSTRIA, COMERCIO E TRANSPORTE DE CARNE BOVINA LTDA.","commercialName":"DISTRIBOI","cnpj":"22882054000160","city":"SERINGUEIRAS","stateCode":"RO","buscaAdicional":"DISTRIBOI 57416 DISTRIBOI ROLIM MOUR 910405 DISTRIBOI JI PARANA 910406"},{"id":"aa01d92d-5184-4178-5363-08d5ad2bf6ba","name":"UNIAO EDUCACIONAL DO NORTE LTDA","commercialName":"UNINORTE","cnpj":"04515940000174","city":"RIO BRANCO","stateCode":"AC","buscaAdicional":"UNINORTEAC 3606 UNINORTE-RIO BRANCO 71628"},{"id":"995d090e-1b63-4536-51c1-08d5ad2bf6ba","name":"COMPANHIA DE ELETRICIDADE DO ACRE","commercialName":"ELETROACRE","cnpj":"04065033000170","city":"RIO BRANCO","stateCode":"AC","buscaAdicional":"ELETROACRE 2576 ELETROACRE 70790"},{"id":"7e9c1251-ee60-41b1-5641-08d5ad2bf6ba","name":"A. C. D. A. IMPORTACAO E EXPORTACAO LTDA","commercialName":"ARAUJO","cnpj":"84308980000184","city":"RIO BRANCO","stateCode":"AC","buscaAdicional":"SUPER ARAUJO 6823 ARAUJO AMAPA 904191 ARAUJO SOBRAL 904235 ARAUJO PLACAS 904236 ARAUJO CD 904237 SUPER ARAUJO 3475891 904866 S ARAUJO C MENDES 889042 S ARAUJO TANGARA 889043 SUP ARAUJO BOSQUE 889262 SUP ARAUJO AVIARIO 889263 S ARAUJO RIO JANEIRO 889538 S ARAUJO PORTO VELHO 889421"},{"id":"d9ec5ca6-6b64-4fb7-60b4-08d5ad2bf6ba","name":"CONDOMINIO VOLUNTARIO VIA VERDE SHOPPING CENTER","commercialName":"CONDOMINIO VIA VERDE SHOPPING","cnpj":"11238374000166","city":"RIO BRANCO","stateCode":"AC","buscaAdicional":"VIAVERDE 53643 VIA VERDE SHOPPING 904867"},{"id":"7d7823ec-9169-4f41-5f30-08d5ad2bf6ba","name":"FRISACRE FRIGORIFICO SANTO AFONSO DO ACRE LTDA","commercialName":"FRISACRE","cnpj":"14290696000142","city":"RIO BRANCO","stateCode":"AC","buscaAdicional":"FRISACRE 52839 FRISACRE 901019"},{"id":"3a878f06-31ce-4f03-5f66-08d5ad2bf6ba","name":"MICROSERVICE TECNOLOGIA DIGITAL DA AMAZONIA LTDA","commercialName":"MICROSERVICE TECNOLOGIA DIGITAL","cnpj":"34525444000162","city":"MANAUS","stateCode":"AM","buscaAdicional":"MICROSERVICE 52928 MICROSERVICE TEC DIG 906650"},{"id":"e4dfc6f6-ed61-4787-5faa-08d5ad2bf6ba","name":"CARBOXI - INDUSTRIA E COMERCIO DE GASES LTDA.","commercialName":"","cnpj":"05914165000192","city":"MANAUS","stateCode":"AM","buscaAdicional":"CARBOXI MANAUS 53074 CARBOXI MANAUS 905933"},{"id":"f2213049-ecc0-4ee0-60cc-08d5ad2bf6ba","name":"TECHNOS DA AMAZONIA INDUSTRIA E COMERCIO S.A.","commercialName":"","cnpj":"04628426000145","city":"MANAUS","stateCode":"AM","buscaAdicional":"GRUPO TECHNOS 53728 TECHNOS 600A 906276 TECHNOS 13 906295"},{"id":"f455fb92-6005-4032-60cd-08d5ad2bf6ba","name":"MASA DA AMAZONIA LTDA","commercialName":"MASA","cnpj":"04454120000110","city":"MANAUS","stateCode":"AM","buscaAdicional":"MASA 53742 MASA 904897"},{"id":"8562ddc9-eac9-443a-60ed-08d5ad2bf6ba","name":"NEOTEC INDUSTRIA E COMERCIO DE PNEUS LTDA","commercialName":"","cnpj":"08775944000142","city":"MANAUS","stateCode":"AM","buscaAdicional":"NEOTEC 53903 NEOTEC IND COM PNEUS 906663"},{"id":"2e090373-5aec-4be9-5fec-08d5ad2bf6ba","name":"MERCANTIL NOVA ERA LTDA","commercialName":"","cnpj":"04240370000157","city":"MANAUS","stateCode":"AM","buscaAdicional":"MER NOVA ERA 53286 NOVA ERA COMPENSA 904181 NOVA ERA FLORES 904182 NOVA ERA GR CIRCULAR 904217 MER NOVA ERA 873977 904701"},{"id":"ceb754b0-9bc6-471d-6002-08d5ad2bf6ba","name":"INDUSTRIA DE TRANSFORMADORES AMAZONAS LTDA","commercialName":"","cnpj":"15815491000104","city":"MANAUS","stateCode":"AM","buscaAdicional":"ITAM 53339 ITAM TRANSFORMADORES 905907"},{"id":"36089c78-3590-4df7-600e-08d5ad2bf6ba","name":"TECHNICOLOR BRASIL MIDIA E ENTRETENIMENTO LTDA.","commercialName":"R C A","cnpj":"02773531000142","city":"MANAUS","stateCode":"AM","buscaAdicional":"TECHNICOLOR 53360 TECHNICOLOR 904355"},{"id":"bfadcb12-9ac5-4231-5eac-08d5ad2bf6ba","name":"MANAUS AMBIENTAL S.A.","commercialName":"","cnpj":"03264927000127","city":"MANAUS","stateCode":"AM","buscaAdicional":"MANAUS AMBIENTAL 52498 MANAUS AMBIENTAL 901505 MANAUS AMBIENTAL ALV 907474 MANAUS AMB CIDADE NV 907635 MANAUS AMB MAUAZINHO 907636 MANAUS AMB MOCO 907665 MANAUS AMB 086110-3 907771 MANAUS AMB 086131-6 907772 MANAUS AMBIENTAL MN 913573"},{"id":"20d83fa5-984b-49e2-5e47-08d5ad2bf6ba","name":"RIMO ENTERTAINMENT INDUSTRIA E COMERCIO S.A","commercialName":"RIMO ENTERTAINMENT","cnpj":"67562884000491","city":"MANAUS","stateCode":"AM","buscaAdicional":"SONOPRESS 52310 SONOPRESS RIMO IND 901283"},{"id":"17c05884-53dd-486c-5da7-08d5ad2bf6ba","name":"VIDEOLAR-INNOVA S/A","commercialName":"INNOVA","cnpj":"04229761000766","city":"MANAUS","stateCode":"AM","buscaAdicional":"VIDEOLAR IV 51946 VIDEOLAR IV 901315"},{"id":"bd2cf2c5-90c7-456f-5dab-08d5ad2bf6ba","name":"VIDEOLAR-INNOVA S/A","commercialName":"INNOVA","cnpj":"04229761000170","city":"MANAUS","stateCode":"AM","buscaAdicional":"VIDEOLAR INNOVA I 51950 VIDEOLAR I 901316 VIDEOLAR-INNOVA ACAI 913611"},{"id":"2b22e055-5175-4c83-5dad-08d5ad2bf6ba","name":"CONDOMINIO AMAZONAS SHOPPING CENTER","commercialName":"AMAZONAS SHOPPING","cnpj":"63691570000195","city":"MANAUS","stateCode":"AM","buscaAdicional":"AMAZONAS SHOPPING 51953 AMAZONAS SHOPPING 2 904829 AMAZONAS SHOPPING 3 904830 AMAZONAS SHOPPING 4 904832 AMAZONAS SHOPPING 5 904854 CONDOMINIO AMAZONAS 905355"},{"id":"95f4f053-4548-4da9-5d98-08d5ad2bf6ba","name":"TVLANDIA EMPREENDIMENTOS IMOBILIARIOS LTDA","commercialName":"MANAUS PLAZA SHOPPING","cnpj":"05043280000139","city":"MANAUS","stateCode":"AM","buscaAdicional":"TVLANDIA 51929 TVLANDIA 904303"},{"id":"123728f8-024c-4f4c-5caf-08d5ad2bf6ba","name":"PAM INDUSTRIA DE PLASTICOS INJETADOS LTDA","commercialName":"PAM PLASTICOS","cnpj":"04413977000191","city":"MANAUS","stateCode":"AM","buscaAdicional":"PAM PLASTICOS 51506 PAM PLASTICOS 904120"},{"id":"a84ac17d-1c24-4607-5873-08d5ad2bf6ba","name":"AMAZONAS GERACAO E TRANSMISSAO DE ENERGIA S.A","commercialName":"AMAZONAS GT","cnpj":"17957780000165","city":"MANAUS","stateCode":"AM","buscaAdicional":"AMAZONAS GT 11829 SAO JOSE 895603 UTE.PE.AM.028922-1.01 APARECIDA (OLEO) 890538 MAUA BLOCO 4 890540 MAUA BLOCO I 895584 UTE.PE.AM.002952-1.01 FLORES 3 900717 UTE.PE.AM.029192-7.01 IRANDUBA 895582 UTE.PE.AM.030274-0.01 FLORES 1 895586 UTE.PE.AM.029192-7.01 FLORES 2 900706 UTE.PE.AM.029192-7.01 SAO JOSE 895603 UTE.PE.AM.028922-1.01 UTE MAUA 3 909378 UTE.GN.AM.031888-4.01 BALBINA 890395 UHE.PH.AM.000190-2.01 APARECIDA (OLEO) 890538 MAUA BLOCO 3 890539 MAUA BLOCO 4 890540 APARECIDA 895561 UTE.PE.AM.027250-7.01 MAUA BLOCO I 895584 UTE.PE.AM.002952-1.01"},{"id":"80a177d5-5066-4f27-5821-08d5ad2bf6ba","name":"BREITENER JARAQUI S.A.","commercialName":"","cnpj":"07387573000169","city":"MANAUS","stateCode":"AM","buscaAdicional":"UTE JARAQUI 10810 JARAQUI 890461 UTE.GN.AM.029272-9.01"},{"id":"d35aaf1f-524e-4679-5822-08d5ad2bf6ba","name":"BREITENER TAMBAQUI S.A.","commercialName":"","cnpj":"07390807000127","city":"MANAUS","stateCode":"AM","buscaAdicional":"UTE TAMBAQUI 10811 TAMBAQUI 890462 UTE.PE.AM.029276-1.01"},{"id":"5ffa4453-b6cc-4829-5bad-08d5ad2bf6ba","name":"PANASONIC DO BRASIL LIMITADA","commercialName":"","cnpj":"04403408000165","city":"MANAUS","stateCode":"AM","buscaAdicional":"PANASONIC 50823 PANASONIC MANAUS 906377"},{"id":"0b4d0afc-bd5d-42a6-5b17-08d5ad2bf6ba","name":"CONSORCIO CONDOMINIO SHOPPING PONTA NEGRA","commercialName":"","cnpj":"18893082000106","city":"MANAUS","stateCode":"AM","buscaAdicional":"SHOPPING PONTA NEGRA 50459 SHOPPING PONTA NEGRA 899674"},{"id":"36843610-2025-41d3-573a-08d5ad2bf6ba","name":"RIO AMAZONAS ENERGIA S/A","commercialName":"RIO AMAZONAS ENERGIA S/A","cnpj":"07386098000106","city":"MANAUS","stateCode":"AM","buscaAdicional":"RAESA 8371 CRISTIANO ROCHA 890460 UTE.PE.AM.029499-3.01"},{"id":"d0c8355f-abbb-47ab-5780-08d5ad2bf6ba","name":"GERA AMAZONAS GERADORA DE ENERGIA DO AMAZONAS S/A.","commercialName":"GERADORA DE ENERGIA AMAZONAS S/A","cnpj":"07469933000171","city":"MANAUS","stateCode":"AM","buscaAdicional":"GERA AM 8969 PONTA NEGRA 890438 UTE.GN.AM.029361-0.02"},{"id":"08383a7d-43e0-4e10-57b9-08d5ad2bf6ba","name":"COMPANHIA ENERGETICA MANAUARA","commercialName":"","cnpj":"07303379000239","city":"MANAUS","stateCode":"AM","buscaAdicional":"CEM MANAUARA 9490 MANAUARA 890459 UTE.GN.AM.029432-2.01"},{"id":"22fc9d9b-de35-4886-51bf-08d5ad2bf6ba","name":"AMAZONAS DISTRIBUIDORA DE ENERGIA S/A","commercialName":"","cnpj":"02341467000120","city":"MANAUS","stateCode":"AM","buscaAdicional":"AMAZONAS ENERG 2562 AMAZONAS ENERGIA 890396"},{"id":"15f723f0-86ae-4021-508b-08d5ad2bf6ba","name":"PROCTER & GAMBLE DO BRASIL S.A.","commercialName":"","cnpj":"59476770000158","city":"MANAUS","stateCode":"AM","buscaAdicional":"PROCTER DO BRASIL 1709 PG SOLIMOES 905690 PEG RIO NEGRO 907083 CRUX - SAROPEDICA 898548 RIO TAQUARA RJ 898549 PROCTER QUEIMADOS 898592"},{"id":"1d2a5962-71cb-42e8-5057-08d5ad2bf6ba","name":"MINERACAO TABOCA S A","commercialName":"","cnpj":"34019992000110","city":"MANAUS","stateCode":"AM","buscaAdicional":"TABOCA 1581 MAMORE 65S-P BJESUS 7570"},{"id":"cdc9c69e-6966-4f4d-50ea-08d5ad2bf6ba","name":"BALL EMBALAGENS AMAZONIA LTDA","commercialName":"BALL","cnpj":"04838649000137","city":"MANAUS","stateCode":"AM","buscaAdicional":"BALL AMAZONIA 1905 REXAM AMAZONIA LTDA 907118"},{"id":"5b8088b8-0ff7-41fd-6652-08d5ad2bf6ba","name":"DIGITRON DA AMAZONIA INDUSTRIA E COMERCIO S. A.","commercialName":"","cnpj":"84489988000194","city":"MANAUS","stateCode":"AM","buscaAdicional":"DIGITRON 57493 DIGITRON DA AMAZONIA 908496"},{"id":"8cfd1fe9-5761-4ad6-6628-08d5ad2bf6ba","name":"3M MANAUS INDUSTRIA DE PRODUTOS QUIMICOS LTDA","commercialName":"3M MANAUS","cnpj":"08014346000150","city":"MANAUS","stateCode":"AM","buscaAdicional":"3M MANAUS 57376 3M MANAUS 908817"},{"id":"e212d9f8-ccb2-430d-66a4-08d5ad2bf6ba","name":"A. W. FABER-CASTELL AMAZONIA S. A.","commercialName":"","cnpj":"07656227000139","city":"MANAUS","stateCode":"AM","buscaAdicional":"FABER CASTEL AMAZONIA 57719 FABER CASTELL AMAZON 908497"},{"id":"190832bb-d511-4b11-6686-08d5ad2bf6ba","name":"PIONEER DO BRASIL LTDA","commercialName":"","cnpj":"05553531000125","city":"MANAUS","stateCode":"AM","buscaAdicional":"PIONEER 57629 PIONEER DO BRASIL 909357"},{"id":"36ad9c25-e10d-4f0e-666c-08d5ad2bf6ba","name":"VALFILM AMAZONIA INDUSTRIA E COMERCIO LTDA","commercialName":"","cnpj":"03071894000107","city":"MANAUS","stateCode":"AM","buscaAdicional":"VALFILM AM 57554 VALFILM AM MATRIZ 907505 VALFILM AM TENTO 907898"},{"id":"f87fe67b-e969-4c68-667e-08d5ad2bf6ba","name":"MANAUS SHOPPING SAO JOSE LTDA","commercialName":"UAI SHOPPING SAO JOSE","cnpj":"03497860000170","city":"MANAUS","stateCode":"AM","buscaAdicional":"SHOPPING SAO JOSE 57621 SHOPPING SAO JOSE 908847"},{"id":"cda5bdfa-2498-45c8-6777-08d5ad2bf6ba","name":"ESSILOR DA AMAZONIA INDUSTRIA E COMERCIO LTDA","commercialName":"","cnpj":"54612650000117","city":"MANAUS","stateCode":"AM","buscaAdicional":"EDAM1 58158 ESSILOR DA AMAZON 2 907506 ESSILOR EDAM1 908952"},{"id":"cb02f780-ff64-4cc9-675b-08d5ad2bf6ba","name":"J. CRUZ INDUSTRIA DE BEBIDAS LTDA.","commercialName":"FABRICA MAGISTRAL","cnpj":"04398251000127","city":"MANAUS","stateCode":"AM","buscaAdicional":"JCRUZ 58060 J CRUZ 909358"},{"id":"7b444c77-98eb-472e-6761-08d5ad2bf6ba","name":"CAL-COMP INDUSTRIA DE SEMICONDUTORES S.A","commercialName":"","cnpj":"21315035000190","city":"MANAUS","stateCode":"AM","buscaAdicional":"CAL-COMP CCBS 58071 CAL COMP CCBS 909732"},{"id":"141f33d5-318e-415d-6738-08d5ad2bf6ba","name":"CDL CENTRO DE DISTRIBUICAO E LOGISTICA LTDA","commercialName":"","cnpj":"03488542000143","city":"MANAUS","stateCode":"AM","buscaAdicional":"ATACK 58006 CDL LOGISTICA 910111 ATACK - FILIAL CIDAD 913414"},{"id":"3334d605-16b8-48a9-6758-08d5ad2bf6ba","name":"AMAZON INDUSTRIA DE GELO E BEBIDAS LTDA","commercialName":"","cnpj":"02402867000107","city":"MANAUS","stateCode":"AM","buscaAdicional":"AMAZON INDUSTRIA 58057 AMAZON REFRIGERANTES 909359 AMAZON GELO 910633"},{"id":"2613a2ab-f5d8-4a68-67a7-08d5ad2bf6ba","name":"FEDERAL MOGUL INDUSTRIA DE AUTOPECAS LTDA.","commercialName":"","cnpj":"09241710000188","city":"MANAUS","stateCode":"AM","buscaAdicional":"FM MANAUS 58398 FM MANAUS 908466"},{"id":"24f2eed5-d904-481f-67b6-08d5ad2bf6ba","name":"RECOFARMA INDUSTRIA DO AMAZONAS LTDA","commercialName":"RECOFARMA S A","cnpj":"61454393000106","city":"MANAUS","stateCode":"AM","buscaAdicional":"RECOFARMA MANAUS 58533 RECOFARMA AMAZONAS 910917"},{"id":"d57fb3db-5144-4027-66c6-08d5ad2bf6ba","name":"STECK DA AMAZONIA INDUSTRIA ELETRICA LTDA","commercialName":"","cnpj":"06048486000114","city":"MANAUS","stateCode":"AM","buscaAdicional":"STECK 57812 STECK 912020"},{"id":"e450985d-7d81-44da-6918-08d5ad2bf6ba","name":"YAMAHA MOTOR DA AMAZONIA LTDA","commercialName":"","cnpj":"04817052000106","city":"MANAUS","stateCode":"AM","buscaAdicional":"YAMAHA 60768 YAMAHA 912019"},{"id":"54f3f93d-a0bb-4dde-67f6-08d5ad2bf6ba","name":"KEIHIN TECNOLOGIA DO BRASIL LTDA","commercialName":"","cnpj":"04161047000198","city":"MANAUS","stateCode":"AM","buscaAdicional":"KEIHIN 59090 KEIHIN 910504"},{"id":"8bddc289-47bd-4889-67cf-08d5ad2bf6ba","name":"HOSPITAL SANTA JULIA LTDA","commercialName":"","cnpj":"04666863000153","city":"MANAUS","stateCode":"AM","buscaAdicional":"HOSPITAL SANTA JULIA 58646 HOSPITAL SANTA JULIA 912449"},{"id":"0b58142d-464f-45d3-67e6-08d5ad2bf6ba","name":"SONY BRASIL LTDA.","commercialName":"EST UNIF","cnpj":"43447044000177","city":"MANAUS","stateCode":"AM","buscaAdicional":"SONYBRASIL 58812 SONY BRASIL MA 909710 SONY BRASIL MF 909731"},{"id":"4787b21a-4918-4c05-67e8-08d5ad2bf6ba","name":"SOCIEDADE DE ENSINO SUPERIOR ESTACIO AMAZONAS LTDA","commercialName":"ESTACIO AMAZONAS","cnpj":"03754112000126","city":"MANAUS","stateCode":"AM","buscaAdicional":"ESTACIO AMAZONAS 58877 ESTACIO AMAZONAS 909093"},{"id":"301ce435-dff2-4aa2-6833-08d5ad2bf6ba","name":"SAMSUNG ELETRONICA DA AMAZONIA LTDA","commercialName":"SAMSUNG DA AMAZONIA","cnpj":"00280273000137","city":"MANAUS","stateCode":"AM","buscaAdicional":"SAMSUNG AM 59464 SAMSUNG ELETR AMAZON 910112"},{"id":"c3f5e440-d081-4601-6852-08d5ad2bf6ba","name":"CONDOMINIO DO NOVO SHOPPING GRANDE CIRCULAR","commercialName":"","cnpj":"27263927000170","city":"MANAUS","stateCode":"AM","buscaAdicional":"SHOPPING CIRCULAR 59790 SHOPPING CIRCULAR 910604"},{"id":"b4b8763e-e369-4cf3-686a-08d5ad2bf6ba","name":"LABEL PACKING INDUSTRIA DE EMBALAGENS DA AMAZONIA LTDA","commercialName":"LABEL PACKING INDUSTRIA DE EMBALAGENS DA AMAZONIA LTDA","cnpj":"17179228000193","city":"MANAUS","stateCode":"AM","buscaAdicional":"LABEL PACKING 59971 LABEL PACKING 910632"},{"id":"adfc28dc-c134-4c01-686b-08d5ad2bf6ba","name":"LABELPRESS INDUSTRIA E COMERCIO DA AMAZONIA LTDA.","commercialName":"LABELPRESS","cnpj":"03497916000197","city":"MANAUS","stateCode":"AM","buscaAdicional":"LABELPRESS 59975 LABEL PRESS AM 909751"},{"id":"d34ab378-9df6-47c0-68ca-08d5ad2bf6ba","name":"MITSUBA DO BRASIL LTDA","commercialName":"","cnpj":"05299463000110","city":"MANAUS","stateCode":"AM","buscaAdicional":"MITSUBA 60415 MITSUBA - MANAUS 911896"},{"id":"52c284b1-5570-4640-68d2-08d5ad2bf6ba","name":"HONDA LOCK DO BRASIL LTDA","commercialName":"HONDA LOCK DO BRASIL","cnpj":"07379546000144","city":"MANAUS","stateCode":"AM","buscaAdicional":"HONDA LOCK 60444 HONDA LOCK M 911531"},{"id":"7fd7d05d-00b3-4404-64d4-08d5ad2bf6ba","name":"NISSIN BRAKE DO BRASIL LTDA","commercialName":"","cnpj":"01771241000105","city":"MANAUS","stateCode":"AM","buscaAdicional":"NISSIN BRAKE 56260 NISSIN BRAKE DO BR 907117"},{"id":"a606e961-56e1-47a0-64ea-08d5ad2bf6ba","name":"TUTIPLAST INDUSTRIA E COMERCIO LTDA","commercialName":"","cnpj":"84501873000178","city":"MANAUS","stateCode":"AM","buscaAdicional":"TUTIPLAST 56304 TUTIPLAST MATRIZ 908495"},{"id":"d8cd9a27-0569-4237-6474-08d5ad2bf6ba","name":"REAL BEBIDAS DA AMAZONIA LTDA","commercialName":"","cnpj":"06990011000142","city":"MANAUS","stateCode":"AM","buscaAdicional":"REAL BEBIDAS AM 56010 REAL BEBIDAS AM 907662"},{"id":"444f8993-12da-485a-648a-08d5ad2bf6ba","name":"FITAS FLAX DA AMAZONIA LTDA","commercialName":"","cnpj":"07169868000169","city":"MANAUS","stateCode":"AM","buscaAdicional":"FITAS FLAX 56080 FITAS FLAX DA AMAZON 907365"},{"id":"1648c5ce-d117-47d7-6490-08d5ad2bf6ba","name":"NOVAMED FABRICACAO DE PRODUTOS FARMACEUTICOS LTDA.","commercialName":"NOVAMED","cnpj":"12424020000179","city":"MANAUS","stateCode":"AM","buscaAdicional":"NOVAMED 56090 NOVAMED 907638"},{"id":"854cb0b9-7d46-45b0-64a2-08d5ad2bf6ba","name":"CAL-COMP INDUSTRIA E COMERCIO DE ELETRONICOS E INFORMATICA LTDA.","commercialName":"","cnpj":"07200194000118","city":"MANAUS","stateCode":"AM","buscaAdicional":"CAL-COMP 56139 CAL-COMP IND COM ELT 907119 CAL-COMP CR 907135"},{"id":"0efd0177-1445-4007-6582-08d5ad2bf6ba","name":"PST ELETRONICA LTDA","commercialName":"","cnpj":"84496066000104","city":"MANAUS","stateCode":"AM","buscaAdicional":"POSITRON 56753 PST ELETRONICA S.A. 908258"},{"id":"4e37aa85-b51d-4075-6571-08d5ad2bf6ba","name":"GREIF EMBALAGENS INDUSTRIAIS DO AMAZONAS LTDA","commercialName":"","cnpj":"03432490000193","city":"MANAUS","stateCode":"AM","buscaAdicional":"GREIF MANAUS 56729 GREIF MANAUS 907134"},{"id":"4fa82734-ec8d-48be-6576-08d5ad2bf6ba","name":"SHOWA DO BRASIL LTDA","commercialName":"","cnpj":"04012043000148","city":"MANAUS","stateCode":"AM","buscaAdicional":"SHOWA 56735 SHOWA MANAUS AM 907663"},{"id":"ef7ae27c-a0df-4595-651e-08d5ad2bf6ba","name":"CERAS JOHNSON LTDA","commercialName":"CERAS JOHNSON","cnpj":"33122466000704","city":"MANAUS","stateCode":"AM","buscaAdicional":"CERAS JOHNSON 56489 CERAS JOHNSON 907526"},{"id":"aa9d7e40-1007-460f-6374-08d5ad2bf6ba","name":"WHIRLPOOL ELETRODOMESTICOS AM S.A.","commercialName":"BRASTEMP","cnpj":"63699839000180","city":"MANAUS","stateCode":"AM","buscaAdicional":"WHIRLPOOL MANAUS 55375 WHIRLPOOL - MANAUS 904579"},{"id":"a5de10a8-51d0-4740-637e-08d5ad2bf6ba","name":"CONDOMINIO GERAL DO MILLENNIUM CENTER","commercialName":"MILLENNIUM CENTER","cnpj":"07119723000153","city":"MANAUS","stateCode":"AM","buscaAdicional":"CONDOMINIO MILLENNIUM 55411 MILLENNIUM GERAL 908845 MILLENIUM LOJAS 908846"},{"id":"813d129c-2cac-45ef-63d5-08d5ad2bf6ba","name":"SODECIA DA AMAZONIA LTDA","commercialName":"I A C M DA AMAZONIA","cnpj":"02422460000133","city":"MANAUS","stateCode":"AM","buscaAdicional":"SODECIA AMAZONIA 55646 SODECIA BALATA 907659 SODECIA ALEIXO 907660"},{"id":"695a0dec-208d-4079-6428-08d5ad2bf6ba","name":"SB COMERCIO LTDA","commercialName":"SB LOG","cnpj":"04429478000192","city":"MANAUS","stateCode":"AM","buscaAdicional":"SB COMERCIO 55860 SB COMERCIO FILIAL 907133 SB COMERCIO MATRIZ 908434"},{"id":"903b9e55-6c47-4c75-6442-08d5ad2bf6ba","name":"BIC AMAZONIA S/A","commercialName":"","cnpj":"04402277000100","city":"MANAUS","stateCode":"AM","buscaAdicional":"BIC AMAZONIA 55899 BIC AMAZONIA 907639"},{"id":"f10955e4-27c4-4d81-6444-08d5ad2bf6ba","name":"SALCOMP INDUSTRIAL ELETRONICA DA AMAZONIA LTDA","commercialName":"SALCOMP","cnpj":"07637620000185","city":"MANAUS","stateCode":"AM","buscaAdicional":"SALCOMP 55901 SALCOMP 906888"},{"id":"8e2cbf06-2121-40d2-644a-08d5ad2bf6ba","name":"SOCIEDADE FOGAS LIMITADA","commercialName":"","cnpj":"04563672000166","city":"MANAUS","stateCode":"AM","buscaAdicional":"FOGAS 55913 FOGAS_AM 907002 FOGAS_RO 907120 FOGAS_AC 907122"},{"id":"19e94066-1d13-45d2-6455-08d5ad2bf6ba","name":"SONY DADC BRASIL INDUSTRIA, COMERCIO E DISTRIBUICAO VIDEO-FONOGRAFICA LTDA","commercialName":"","cnpj":"07305913000165","city":"MANAUS","stateCode":"AM","buscaAdicional":"SONY DADC 55935 SONY DADC BRASIL 906670"},{"id":"967d827e-6753-41b7-629c-08d5ad2bf6ba","name":"COPAG DA AMAZONIA S A","commercialName":"COPAG","cnpj":"04664637000133","city":"MANAUS","stateCode":"AM","buscaAdicional":"COPAG 54824 COPAG DA AMAZONIA 905906"},{"id":"3d55aed4-0908-42fb-629a-08d5ad2bf6ba","name":"NOVODISC MIDIA DIGITAL DA AMAZONIA LTDA","commercialName":"NOVODISC MDA","cnpj":"02104848000196","city":"MANAUS","stateCode":"AM","buscaAdicional":"NOVODISC AM 54815 NOVODISC MIDIA 909423"},{"id":"24009ad7-fbb9-40e6-6245-08d5ad2bf6ba","name":"RIO NEGRO AMBIENTAL, CAPTACAO, TRATAMENTO E DISTRIBUICAO DE AGUAS SPE S.A","commercialName":"","cnpj":"24483032000153","city":"MANAUS","stateCode":"AM","buscaAdicional":"RNA 54666 RNA CAPTACAO 904941 RNA CASTANHERAL UN 1 904983 TANC NEVES UC0788920 906666 NV FLTA UC0787792-7 906667"},{"id":"0948a18d-20d1-439d-6274-08d5ad2bf6ba","name":"AMCOR EMBALAGENS DA AMAZONIA S.A.","commercialName":"","cnpj":"84127208000166","city":"MANAUS","stateCode":"AM","buscaAdicional":"AMCOR EMBALAGENS 54765 AMCOR EMBALAGENS 904847"},{"id":"cc1bd136-2135-4e53-62cb-08d5ad2bf6ba","name":"MUSASHI DA AMAZONIA LTDA","commercialName":"","cnpj":"04944068000180","city":"MANAUS","stateCode":"AM","buscaAdicional":"MUSASHI AM 54973 MUSASHI DA AMAZONIA 906665"},{"id":"974c90be-e364-4d56-6301-08d5ad2bf6ba","name":"NIPPON SEIKI DO BRASIL LTDA","commercialName":"","cnpj":"05213262000158","city":"MANAUS","stateCode":"AM","buscaAdicional":"NIPPON 55075 NIPPON SEIKI 905914"},{"id":"40a67932-1d8a-4629-6325-08d5ad2bf6ba","name":"FORMAPACK EMBALAGENS PLASTICAS LTDA","commercialName":"FORMAPACK EMBALAGENS PLASTICAS","cnpj":"09397075000122","city":"MANAUS","stateCode":"AM","buscaAdicional":"FORMAPACK 55183 FORMAPACK- MANAUS AM 907421"},{"id":"16559685-e685-4256-6134-08d5ad2bf6ba","name":"JABIL INDUSTRIAL DO BRASIL LTDA","commercialName":"","cnpj":"04898857000202","city":"MANAUS","stateCode":"AM","buscaAdicional":"JABIL AM 54054 JABIL MANAUS 904855"},{"id":"4bdf05a1-dc5a-442c-6141-08d5ad2bf6ba","name":"BENCHIMOL IRMAO & CIA LTDA","commercialName":"BEMOL MATRIZ","cnpj":"04565289000147","city":"MANAUS","stateCode":"AM","buscaAdicional":"BEMOL 54076 BEMOL MIRANDA LEAO 905909 BEMOL LOJA AVENIDA 905910 BEMOL MATRIZ 905911 BEMOL TORQUATO 905912 BEMOL - LOJA CAMAPUA 906136 BEMOL - LOJA RIO BRA 907121 BEMOL BARROSO 907637 BEMOL LJ PORTO VELHO 908188 BEMOL MILLENIUM 909360 BEMOL PORTO VELHO SH 909718"},{"id":"3d3bcb59-ab2f-4ac6-6158-08d5ad2bf6ba","name":"MOTO HONDA DA AMAZONIA LTDA","commercialName":"MOTO HONDA","cnpj":"04337168000148","city":"MANAUS","stateCode":"AM","buscaAdicional":"HONDA AMAZONIA 54143 HONDA MANAUS 903627 HONDA STO AMARO 905529"},{"id":"fbff9d6c-1bcf-4849-6169-08d5ad2bf6ba","name":"SUPERMERCADOS DB LTDA","commercialName":"","cnpj":"22991939000106","city":"MANAUS","stateCode":"AM","buscaAdicional":"DB 54177 DB PARAIBA LJ 01 905908 DB MAX TEIXEIRA L18 906664 DB NOVA CIDADE LJ 22 906914 DB BURITI CD 906917 DB DISTRITO LOJA 9 906923 DB PARQUE 10 LJ 19 906924 DB COSTA E SILVA 14 906938 DB DJALMA LJ 16 906939 DB PONTA NEGRA 906943 DB NOVA CID LJ 22 907049 DB CAMPOS ELISEOS 907061 DB COMPENSA 907062 DB CACHOEIRINHA LJ18 907132 DB MUTIRAO - LOJA 23 907451 DB EDUARDO RIBEIRO 907661 DB PEDRO TEIXEIRA 15 910634 SHOP SUMAUMA 907115"},{"id":"49d2ad6d-2f74-45f8-616e-08d5ad2bf6ba","name":"PRESTIGE DA AMAZONIA LTDA","commercialName":"","cnpj":"02648270000139","city":"MANAUS","stateCode":"AM","buscaAdicional":"PRESTIGE 54183 PRESTIGE DA AMAZONIA 908186"},{"id":"c0d86dab-afca-4a8a-6178-08d5ad2bf6ba","name":"PHILCO ELETRONICOS SA","commercialName":"","cnpj":"11283356000287","city":"MANAUS","stateCode":"AM","buscaAdicional":"PHILCO 54200 PHILCO ELETRONICOS 904305"},{"id":"ea455173-f2d0-4ca3-61ab-08d5ad2bf6ba","name":"METALMA DA AMAZONIA S/A","commercialName":"","cnpj":"06207412000183","city":"MANAUS","stateCode":"AM","buscaAdicional":"METALMA AM 54335 METALMA DA AMAZONIA 904499"},{"id":"7715774b-5299-4a69-61ad-08d5ad2bf6ba","name":"CONDOMINIO MANAUARA SHOPPING","commercialName":"MANAUARA SHOPPING","cnpj":"10575844000114","city":"MANAUS","stateCode":"AM","buscaAdicional":"MANAUARA SHOPPING 54337 SHOP MANAUARA 903819"},{"id":"4f17e9c8-809d-4676-61e4-08d5ad2bf6ba","name":"SIEMENS ELETROELETRONICA LTDA","commercialName":"EQUITEL","cnpj":"34558841000300","city":"MANAUS","stateCode":"AM","buscaAdicional":"SIEMENS MANAUS 54458 SIEMENS MANAUS 904898"},{"id":"da35d8bd-828f-49b4-61e6-08d5ad2bf6ba","name":"SHOPPING MANAUS VIA NORTE SPE S.A","commercialName":"","cnpj":"16455394000102","city":"MANAUS","stateCode":"AM","buscaAdicional":"VIANORTE SHOP 54460 SHOP MANAUS VIANORTE 907376"},{"id":"83fa0b9c-28b3-45e7-61fc-08d5ad2bf6ba","name":"WEG AMAZONIA S/A","commercialName":"","cnpj":"06303603000149","city":"MANAUS","stateCode":"AM","buscaAdicional":"WEG AMAZONIA 54497 WEG AMAZONIA - AM 904845"},{"id":"034944cc-4a22-4b36-8d8e-08d5d060706e","name":"EDIFICIO THE OFFICE","commercialName":"EDIFICIO THE OFFICE","cnpj":"18758609000190","city":"MANAUS","stateCode":"AM","buscaAdicional":"THE OFFICE 61039 THE OFFICE 913572"},{"id":"a1d2650c-d448-4222-1cc4-08d5b8870181","name":"BRASIL NORTE BEBIDAS S/A","commercialName":"","cnpj":"34590315000158","city":"MANAUS","stateCode":"AM","buscaAdicional":"BNB 61312 BRASIL NORTE BEBIDAS 913111"},{"id":"c3ec2f05-f8d8-4cf8-1ccb-08d5b8870181","name":"BIOPLUS COMERCIO E REPRESENTACOES DE MEDICAMENTOS E SERVICOS DE EQUIPAMENTOS MEDICO-HOSPITALARES LTDA","commercialName":"BIOPLUS LTDA","cnpj":"08992424000191","city":"MANAUS","stateCode":"AM","buscaAdicional":"BIOPLUS 61654 BIOPLUS 912866 BIOPLUS 1 913011"},{"id":"bc1cc81d-d80f-4976-88cc-08d5ae44ed50","name":"VIDEOLAR-INNOVA S/A","commercialName":"INNOVA","cnpj":"04229761000928","city":"MANAUS","stateCode":"AM","buscaAdicional":"VIDEOLAR I 51951"},{"id":"1ae7cc0b-796d-49b9-7387-08d5cf600bef","name":"IGB ELETRONICA S.A","commercialName":"","cnpj":"43185362000107","city":"MANAUS","stateCode":"AM","buscaAdicional":""},{"id":"668f5975-39e4-44ef-7364-08d5cf600bef","name":"TEC TOY S.A.","commercialName":"TECTOY","cnpj":"22770366000182","city":"MANAUS","stateCode":"AM","buscaAdicional":""},{"id":"43f1d6f6-20a2-4a57-5894-08d5ad2bf6ba","name":"BOA VISTA ENERGIA S/A","commercialName":"ELETROBRAS DISTRIBUICAO RORAIMA","cnpj":"02341470000144","city":"BOA VISTA","stateCode":"RR","buscaAdicional":"BOA VISTA ENERG 12512"},{"id":"7445133c-f5f8-4312-51f5-08d5ad2bf6ba","name":"CURUA ENERGIA S/A","commercialName":"CURUA ENERGIA","cnpj":"05215888000101","city":"ALTAMIRA","stateCode":"PA","buscaAdicional":"CURUA ENERGIA 2742 SALTO BURITI 8472 PCH.PH.PA.028671-0.01 SALTO CURUA 8473 PCH.PH.PA.028672-9.01"},{"id":"517273dc-57ec-4563-51f6-08d5ad2bf6ba","name":"ELETRICIDADE PARAENSE S/A","commercialName":"ELETRICIDADE PARAENSE","cnpj":"07108413000133","city":"ALTAMIRA","stateCode":"PA","buscaAdicional":"ELETRICIDADE PARAENSE 2745 SALTO TRES DE MAIO 8478 PCH.PH.PA.028653-2.01"},{"id":"67f800f8-a393-4a0d-5b88-08d5ad2bf6ba","name":"UNIAO DE ENSINO SUPERIOR DO PARA","commercialName":"UNESPA","cnpj":"15752686000225","city":"ANANINDEUA","stateCode":"PA","buscaAdicional":"UNAMA BR 50754 UNAMA BR 898026"},{"id":"c1b11994-bfe0-45ba-5d78-08d5ad2bf6ba","name":"LIDER COMERCIO E INDUSTRIA LTDA.","commercialName":"LIDER - CIDADE NOVA","cnpj":"05054671001988","city":"ANANINDEUA","stateCode":"PA","buscaAdicional":"LIDER CIDADE NOVA 51831 LIDER CIDADE NOVA 898771"},{"id":"fc9d1175-6bf1-43de-5d64-08d5ad2bf6ba","name":"LIDER COMERCIO E INDUSTRIA LTDA.","commercialName":"SUPERMERCADOS LIDER","cnpj":"05054671001473","city":"ANANINDEUA","stateCode":"PA","buscaAdicional":"LIDER BR 51805 LIDER BR 898837"},{"id":"9816f7f4-b0a8-4eb8-b9be-08d5caef97db","name":"LAMINADOS DE MADEIRAS DO PARA LTDA","commercialName":"LAMAPA","cnpj":"04732657000102","city":"ANANINDEUA","stateCode":"PA","buscaAdicional":""},{"id":"5056df52-d558-45b7-622c-08d5ad2bf6ba","name":"CONDOMINIO DO CASTANHEIRA SHOPPING CENTER","commercialName":"CONDOMINIO DO CASTANHEIRA SHOPPING CENTER","cnpj":"02287538000154","city":"ANANINDEUA","stateCode":"PA","buscaAdicional":"SHOPPING CASTANHEIRA 54603 SHOPPING CASTANHEIRA 907128"},{"id":"8a11c358-90ea-4f6b-613c-08d5ad2bf6ba","name":"MERCURIO ALIMENTOS S/A","commercialName":"","cnpj":"11831785000160","city":"ANANINDEUA","stateCode":"PA","buscaAdicional":"MERCURIO ANANINDEUA 54062 MERCURIO ANANINDEUA 905059"},{"id":"56df10ec-4682-446c-62c6-08d5ad2bf6ba","name":"ASSOCIACAO ADVENTISTA NORTE BRASILEIRA DE PREVENCAO E ASSISTENCIA A SAUDE","commercialName":"","cnpj":"83367342000171","city":"ANANINDEUA","stateCode":"PA","buscaAdicional":"ASSOCIACAO ADVENTISTA UNB 54966 HOSP ADVENTISTA BEL 906610"},{"id":"01d39d3e-fc10-4db7-689a-08d5ad2bf6ba","name":"SC2 SHOPPING PARA LTDA","commercialName":"","cnpj":"14097230000125","city":"ANANINDEUA","stateCode":"PA","buscaAdicional":"SHOPPING METROPOLE ANANIDEUA 60202 SC2 SHOPPING PARA 910952"},{"id":"f2dbf5bd-f914-4411-682c-08d5ad2bf6ba","name":"INDUSTRIA E COMERCIO DE ALIMENTOS NORTE PARA EIRELI","commercialName":"DISTRIBUIDORA NORTE PARA","cnpj":"22493964000151","city":"ANANINDEUA","stateCode":"PA","buscaAdicional":"FABRICA VITORIA PARA 59453 FABRICA VITORIA 907424"},{"id":"15bf9017-c405-4adf-67ef-08d5ad2bf6ba","name":"ALUBAR METAIS E CABOS S/A","commercialName":"ALUBAR METAIS E CABOS","cnpj":"08262121000113","city":"BARCARENA","stateCode":"PA","buscaAdicional":"ALUBAR 58893 ALUBAR 908762"},{"id":"137e5e67-382a-4333-1c9d-08d5b8870181","name":"PARA PIGMENTOS S A","commercialName":"PPSA","cnpj":"33931510000131","city":"BARCARENA","stateCode":"PA","buscaAdicional":"IMERYS PPSA 1537 IMERYS PPSA 912597"},{"id":"5faec0e4-380d-4d5b-5d62-08d5ad2bf6ba","name":"LIDER COMERCIO E INDUSTRIA LTDA.","commercialName":"LIDER - BARCARENA","cnpj":"05054671003174","city":"BARCARENA","stateCode":"PA","buscaAdicional":"LIDER BARCARENA 51803 LIDER BARCARENA 898769"},{"id":"62dab96c-18c4-48f0-503a-08d5ad2bf6ba","name":"IMERYS RIO CAPIM CAULIM S.A.","commercialName":"","cnpj":"16532798000152","city":"BARCARENA","stateCode":"PA","buscaAdicional":"IMERYS R CAPIM 1526 IMERYS R CAPIM-PORTO 7931 IMERYS MINA IPIXUNA 70594"},{"id":"82dd60eb-05a8-41cd-4fe1-08d5ad2bf6ba","name":"ALBRAS ALUMINIO BRASILEIRO S/A","commercialName":"ALBRAS","cnpj":"05053020000306","city":"BARCARENA","stateCode":"PA","buscaAdicional":"ALBRAS 1330 ALBRAS PARA 159"},{"id":"f461b108-6fae-4cb2-4fe7-08d5ad2bf6ba","name":"ALUNORTE ALUMINA DO NORTE DO BRASIL S/A","commercialName":"","cnpj":"05848387000154","city":"BARCARENA","stateCode":"PA","buscaAdicional":"ALUNORTE 1349 ALUNORTE PR BARCAREN 7020"},{"id":"3af07918-0b39-4bba-4ee7-08d5ad2bf6ba","name":"CENTRAIS ELETRICAS DO PARA S.A. - CELPA","commercialName":"","cnpj":"04895728000180","city":"BELÉM","stateCode":"PA","buscaAdicional":"CELPA 16 CELPA 39"},{"id":"f9bdd9ec-8782-47b0-575e-08d5ad2bf6ba","name":"HILEIA INDUSTRIAS DE PRODUTOS ALIMENTICIOS S A","commercialName":"","cnpj":"05388392000202","city":"BELÉM","stateCode":"PA","buscaAdicional":"HILEIA BEL 8731 HILEIA BEL 891924"},{"id":"8331f209-f34b-4f1f-5765-08d5ad2bf6ba","name":"FACEPA FABRICA DE PAPEL DA AMAZONIA S.A","commercialName":"FACEPA","cnpj":"04909479000134","city":"BELÉM","stateCode":"PA","buscaAdicional":"FACEPA 8789 FACEPA BELEM PA 897678 FACEPA FILIAL 901453"},{"id":"b9cc8e52-3c7c-4731-5d63-08d5ad2bf6ba","name":"LIDER COMERCIO E INDUSTRIA LTDA.","commercialName":"SUPERMERCADOS LIDER","cnpj":"05054671001040","city":"BELÉM","stateCode":"PA","buscaAdicional":"LIDER BATISTA CAMPOS 51804 LIDER BATISTA PA 898849"},{"id":"e02dca0b-349f-4280-5d61-08d5ad2bf6ba","name":"LIDER COMERCIO E INDUSTRIA LTDA.","commercialName":"LIDER AUGUSTO MONTENEGRO","cnpj":"05054671003417","city":"BELÉM","stateCode":"PA","buscaAdicional":"LIDER A. MONTENEGRO 51802 LIDER MONTENEGRO 898768"},{"id":"b8080cb0-3443-4529-5d79-08d5ad2bf6ba","name":"LIDER COMERCIO E INDUSTRIA LTDA.","commercialName":"MAGAZINE LIDER","cnpj":"05054671000582","city":"BELÉM","stateCode":"PA","buscaAdicional":"LIDER DOCA 51832 LIDER DOCA 898788"},{"id":"78f0d2d1-dff9-4caa-5d7a-08d5ad2bf6ba","name":"LIDER COMERCIO E INDUSTRIA LTDA.","commercialName":"SUPERMERCADOS LIDER","cnpj":"05054671001120","city":"BELÉM","stateCode":"PA","buscaAdicional":"LIDER HUMAITA 51833 LIDER HUMAITA 898772"},{"id":"cfe00e9a-f072-4217-5d7b-08d5ad2bf6ba","name":"LIDER COMERCIO E INDUSTRIA LTDA.","commercialName":"LIDER INDEPENDENCIA","cnpj":"05054671002879","city":"BELÉM","stateCode":"PA","buscaAdicional":"LIDER INDEPENDENCIA 51834 LIDER INDEPENDENCIA 898773"},{"id":"11410970-1f43-4fbd-5d7c-08d5ad2bf6ba","name":"LIDER COMERCIO E INDUSTRIA LTDA.","commercialName":"","cnpj":"05054671002798","city":"BELÉM","stateCode":"PA","buscaAdicional":"LIDER PEDREIRA 51835 LIDER PEDREIRA 898695"},{"id":"43a2679f-2379-40fa-5d7d-08d5ad2bf6ba","name":"LIDER COMERCIO E INDUSTRIA LTDA.","commercialName":"SUPERMERCADO LIDER","cnpj":"05054671000906","city":"BELÉM","stateCode":"PA","buscaAdicional":"LIDER PRACA BRASIL 51836 LIDER PRACA BRASIL 899792"},{"id":"b6b16ae8-6531-48aa-5d9f-08d5ad2bf6ba","name":"CERPA CERVEJARIA PARAENSE SA","commercialName":"CERPA","cnpj":"04894085000150","city":"BELÉM","stateCode":"PA","buscaAdicional":"CERPA CERVEJARIA 51937 CERPA CERVEJARIA 901050"},{"id":"031f0b06-4243-4faf-5d65-08d5ad2bf6ba","name":"LIDER COMERCIO E INDUSTRIA LTDA.","commercialName":"LIDER CANUDOS","cnpj":"05054671001805","city":"BELÉM","stateCode":"PA","buscaAdicional":"LIDER CANUDOS 51806 LIDER CANUDOS 898770"},{"id":"03e78eea-146d-4463-5d66-08d5ad2bf6ba","name":"LIDER COMERCIO E INDUSTRIA LTDA.","commercialName":"HIPER LIDER CASTANHEIRA","cnpj":"05054671000744","city":"BELÉM","stateCode":"PA","buscaAdicional":"LIDER CASTANHEIRA 51808 LIDER CASTANHEIRA 898787"},{"id":"12e11c79-c88b-4f49-5d67-08d5ad2bf6ba","name":"LIDER COMERCIO E INDUSTRIA LTDA.","commercialName":"CENTRO DE DISTRIBUICAO AUGUSTO MONTENEGRO - CDAM","cnpj":"05054671001554","city":"BELÉM","stateCode":"PA","buscaAdicional":"LIDER CDAM 51809 LIDER CDAM 898866"},{"id":"857dc8cf-4a57-4e29-5d3a-08d5ad2bf6ba","name":"LIDER COMERCIO E INDUSTRIA LTDA.","commercialName":"ESCRITORIO CENTRAL","cnpj":"05054671000159","city":"BELÉM","stateCode":"PA","buscaAdicional":"LIDER ESCRITORIO CENTRAL 51742 LIDER CENTRAL 905358"},{"id":"47a6acbd-72ea-4e36-5e3f-08d5ad2bf6ba","name":"OCRIM S A PRODUTOS ALIMENTICIOS","commercialName":"","cnpj":"61065199000473","city":"BELÉM","stateCode":"PA","buscaAdicional":"OCRIM 52295 OCRIM MOINHO 899818 OCRIM RACOES 900075"},{"id":"e3174813-304c-4dba-5feb-08d5ad2bf6ba","name":"NAZARE COMERCIAL DE ALIMENTOS E MAGAZINES LTDA","commercialName":"","cnpj":"05205463000103","city":"BELÉM","stateCode":"PA","buscaAdicional":"NAZARE 53285 NAZARE S FRANCISCO 905341 NAZARE SUPERCENTER 905686 NAZARE BELEM 905698 NAZARE DUQUE DE CAXI 905701 NAZARE SENADOR LEMOS 905705 NAZARE FREITAS 909623"},{"id":"305e9178-7740-48cb-60f2-08d5ad2bf6ba","name":"LIDER COMERCIO E INDUSTRIA LTDA.","commercialName":"SUPERMERCADOS LIDER","cnpj":"05054671001392","city":"BELÉM","stateCode":"PA","buscaAdicional":"LIDER ICOARACI 53916 LIDER ICOARACI 905365"},{"id":"f729ea6e-af1a-45a8-5c16-08d5ad2bf6ba","name":"BELEM HOTEIS E TURISMO S/A","commercialName":"","cnpj":"04833448000228","city":"BELÉM","stateCode":"PA","buscaAdicional":"BELEM HOTEIS 51079 BELEM HOTEIS 898688"},{"id":"5d43eb0a-d97f-41e2-5b50-08d5ad2bf6ba","name":"Y YAMADA S/A COMERCIO E INDUSTRIA EM RECUPERACAO JUDICIAL","commercialName":"","cnpj":"04895751000174","city":"BELÉM","stateCode":"PA","buscaAdicional":"YAMADA MATRIZ 50597 YAMADA UC 17639 897646 YAMADA 35955 PA 897776 YAMADA 19255760 897777 YAMADA 129 897778 YAMADA 17450 PA 897782 YAMADA 18643 PA 897783 YAMADA 6212824 PA 897784 YAMADA 19151 897827 YAMADA 16659 897830 YAMADA 17560310 897831 YAMADA 16667 PA 897835 YAMADA 13196 897846 YAMADA 13374 897829 YAMADA 6355811 897832 YAMADA 22888 PA 897833 YAMADA 10098076 PA 897834 Y YAMADA 898108"},{"id":"3727a5f4-b1a0-41aa-5a73-08d5ad2bf6ba","name":"NORSK HYDRO ENERGIA LTDA","commercialName":"","cnpj":"22109465000118","city":"BELÉM","stateCode":"PA","buscaAdicional":"HYDRO ENERGIA 49665"},{"id":"f6702bfb-3060-4aa4-88f2-08d5ae44ed50","name":"INDUSTRIA E COMERCIO DE ALIMENTOS BRASIL EIRELI","commercialName":"PRODUTOS VITORIA","cnpj":"10999466000104","city":"BELÉM","stateCode":"PA","buscaAdicional":"FABRICA VITORIA 56351"},{"id":"422ef8e1-b0d1-487f-88e4-08d5ae44ed50","name":"PORTO DIAS DIAGNOSTICO POR IMAGEM LTDA","commercialName":"PORTO DIAS DIAGNOSTICO POR IMAGEM","cnpj":"06189829000322","city":"BELÉM","stateCode":"PA","buscaAdicional":"PORTO DIAS REDUTO 54444"},{"id":"65fdffb0-2d2c-431b-729c-08d5cf600bef","name":"BANCO DA AMAZONIA SA","commercialName":"BASA DIRECAO GERAL","cnpj":"04902979000144","city":"BELÉM","stateCode":"PA","buscaAdicional":""},{"id":"916b5625-e5a8-43b6-729d-08d5cf600bef","name":"PORTUENSE FERRAGENS SA","commercialName":"","cnpj":"04912242000102","city":"BELÉM","stateCode":"PA","buscaAdicional":""},{"id":"284b943d-be97-47be-729e-08d5cf600bef","name":"BANCO DO ESTADO DO PARA S A","commercialName":"BANPARA","cnpj":"04913711000108","city":"BELÉM","stateCode":"PA","buscaAdicional":""},{"id":"14feac7c-22a2-454b-67ec-08d5ad2bf6ba","name":"ORGANIZACAO PARAENSE EDUCACIONAL E DE EMPREENDIMENTOS LTDA","commercialName":"ORPES","cnpj":"03137964000174","city":"BELÉM","stateCode":"PA","buscaAdicional":"ESTACIO IESAM 58890 ESTACIO IESAM 2 910581 ESTACIO IESAM 1 910582"},{"id":"cad137cd-d784-425a-684e-08d5ad2bf6ba","name":"CONDOMINIO DO SHOPPING BOSQUE GRAO PARA","commercialName":"SHOPPING CENTER BOSQUE GRAO PARA","cnpj":"26769130000187","city":"BELÉM","stateCode":"PA","buscaAdicional":"SHOP GRAO PARA 59715 CALILA - BELEM - PA 899915"},{"id":"06f0b3b6-ff76-469e-6800-08d5ad2bf6ba","name":"ESTALEIRO RIO MAGUARI S/A","commercialName":"ESTALEIRO RIO MAGUARI","cnpj":"03024422000195","city":"BELÉM","stateCode":"PA","buscaAdicional":"RIO MAGUARI 59172 RIO MAGUARI 909752"},{"id":"e375b78b-6c08-45ef-68bc-08d5ad2bf6ba","name":"COMTUR - ADMINISTRADORA DE HOTEIS E TURISMO LTDA","commercialName":"","cnpj":"04833604000170","city":"BELÉM","stateCode":"PA","buscaAdicional":"HOTEL SAGRES 60359 HOTEL SAGRES 910364"},{"id":"9598fa1f-4459-412c-68eb-08d5ad2bf6ba","name":"COMPAR COMPANHIA PARAENSE DE REFRIGERANTES","commercialName":"COMPAR","cnpj":"04928297000100","city":"BELÉM","stateCode":"PA","buscaAdicional":"COMPAR 60571 COMPAR REFRIGERANTES 910363"},{"id":"ac71dc6b-0990-4160-693d-08d5ad2bf6ba","name":"PORTO DIAS DIAGNOSTICO POR IMAGEM LTDA","commercialName":"PORTO DIAS DIAGNOSTICO POR IMAGEM","cnpj":"06189829000160","city":"BELÉM","stateCode":"PA","buscaAdicional":"PORTO DIAS MATRIZ 60856 PORTO DIAS REDUTO 903386 PORTO DIAS GUAMA 910846"},{"id":"5118bd0d-1aa2-4229-6943-08d5ad2bf6ba","name":"ECONOMICO COMERCIO DE ALIMENTOS EIRELI","commercialName":"","cnpj":"06957694000136","city":"BELÉM","stateCode":"PA","buscaAdicional":"ECONOMICO 60950 YAMADA 15580 897847"},{"id":"c3f479ad-c632-42f2-6714-08d5ad2bf6ba","name":"LIDER COMERCIO E INDUSTRIA LTDA.","commercialName":"SUPERMERCADOS LIDER","cnpj":"05054671000663","city":"BELÉM","stateCode":"PA","buscaAdicional":"LIDER CIDADE VELHA 57950 LIDER OBIDOS BELEM 908112"},{"id":"24159a11-c59c-42a4-6629-08d5ad2bf6ba","name":"TRAMONTINA BELEM SA","commercialName":"","cnpj":"14068605000129","city":"BELÉM","stateCode":"PA","buscaAdicional":"TRAMONTINA BELEM 57377 TRAMONTINA BELEM SA 907129"},{"id":"32461771-3eca-464c-6630-08d5ad2bf6ba","name":"NORTE HOTELARIA SA","commercialName":"HOTEL REGENTE","cnpj":"05441787000140","city":"BELÉM","stateCode":"PA","buscaAdicional":"HOTEL REGENTE BELEM 57385 HOTEL REGENTE BELEM 908090"},{"id":"601809b8-3fd9-4d52-6643-08d5ad2bf6ba","name":"CONDOMINIO EDILICIO PATIO BELEM","commercialName":"SHOPPING PATIO BELEM","cnpj":"84154160000185","city":"BELÉM","stateCode":"PA","buscaAdicional":"COND PATIO BELEM 57452 COND PATIO BELEM 908764"},{"id":"c2791b21-307c-4d42-6303-08d5ad2bf6ba","name":"PARA-INDUSTRIAS REUNIDAS RAYMUNDO DA FONTE S/A","commercialName":"","cnpj":"22949911000100","city":"BELÉM","stateCode":"PA","buscaAdicional":"RAYMUNDOFONTE PA 55078 RAYMUNDO DA FONTE PA 908002"},{"id":"144a321e-61b1-43ea-62a8-08d5ad2bf6ba","name":"MOINHOS CRUZEIRO DO SUL S A","commercialName":"","cnpj":"88301155002152","city":"BELÉM","stateCode":"PA","buscaAdicional":"MOINHOS BELEM 54899 MOINHOS BELEM 904325"},{"id":"a92883d7-f399-4e68-611b-08d5ad2bf6ba","name":"LIDER COMERCIO E INDUSTRIA LTDA.","commercialName":"SUPERMERCADOS LIDER","cnpj":"05054671000230","city":"BELÉM","stateCode":"PA","buscaAdicional":"LIDER ALCINDO CACELA 54022 LIDER A CALCELA 905364"},{"id":"7a781280-329e-4cd4-611f-08d5ad2bf6ba","name":"LIDER COMERCIO E INDUSTRIA LTDA.","commercialName":"SUPERMERCADOS LIDER","cnpj":"05054671001635","city":"BELÉM","stateCode":"PA","buscaAdicional":"LIDER CONDOR 54028 LIDER CONDOR 905363"},{"id":"d62b0485-29e8-4272-612e-08d5ad2bf6ba","name":"LIDER COMERCIO E INDUSTRIA LTDA.","commercialName":"LIDER MARAMBAIA","cnpj":"05054671004065","city":"BELÉM","stateCode":"PA","buscaAdicional":"LIDER MARAMBAIA 54047 LIDER MARAMBAIA 905366"},{"id":"6ff5ee62-05c9-46bf-61d7-08d5ad2bf6ba","name":"HOSPITAL PORTO DIAS LTDA","commercialName":"HOSPITAL PORTO DIAS","cnpj":"84154608000160","city":"BELÉM","stateCode":"PA","buscaAdicional":"PORTO DIAS MARCO 54445 PORTO DIAS MARCO 903102"},{"id":"ccf8bb0b-4d8f-4661-61cb-08d5ad2bf6ba","name":"HOSPITAL PORTO DIAS LTDA","commercialName":"PORTO DIAS PRIME","cnpj":"84154608000322","city":"BELÉM","stateCode":"PA","buscaAdicional":"PORTO DIAS PRIME 54429 PORTO DIAS PRIME 903118"},{"id":"0acffa74-0961-4932-63d8-08d5ad2bf6ba","name":"BOULEVARD SHOPPING BELEM S.A","commercialName":"SHOPPING BOULEVARD BELEM","cnpj":"09137429000108","city":"BELÉM","stateCode":"PA","buscaAdicional":"SHOPPING BOULEVARD BELEM 55680 BOULEVARD SHOPPING 907138"},{"id":"89ce90e7-84c2-4ed8-63d6-08d5ad2bf6ba","name":"NORTE SHOPPING BELEM S/A","commercialName":"PARQUE SHOPPING BELEM","cnpj":"09268761000101","city":"BELÉM","stateCode":"PA","buscaAdicional":"NORTE SHOPPING BELEM 55647 NORTE SHOPPING BELEM 908545"},{"id":"0da3a601-c5c2-4afb-63c4-08d5ad2bf6ba","name":"DM HOTELARIA E SERVICOS LTDA","commercialName":"DM HOTEIS E RESORTS","cnpj":"14028134000125","city":"BELÉM","stateCode":"PA","buscaAdicional":"DM HOTELARIA 55621 DM HOTELARIA 905966"},{"id":"d57619ed-480e-439f-6399-08d5ad2bf6ba","name":"AMAZONAS INDUSTRIAS ALIMENTICIAS S A AMASA","commercialName":"","cnpj":"05574041000105","city":"BELÉM","stateCode":"PA","buscaAdicional":"AMASA 55479 AMASA 905967"},{"id":"0e7f7b90-a924-4ec1-655f-08d5ad2bf6ba","name":"COSTA NORTE COMERCIO DE PESCADOS LTDA","commercialName":"COSTA NORTE PESCADOS","cnpj":"07671061000120","city":"BELÉM","stateCode":"PA","buscaAdicional":"COSTA NORTE PESCADOS 56702 COSTA NORTE PESCADOS 907714"},{"id":"f89df8db-9709-451f-64ba-08d5ad2bf6ba","name":"TELEVISAO LIBERAL SA","commercialName":"TELEVISAO LIBERAL","cnpj":"04832721000119","city":"BELÉM","stateCode":"PA","buscaAdicional":"TV LIBERAL 56179 TV LIBERAL 907525"},{"id":"43572ec3-75b0-41c4-64bb-08d5ad2bf6ba","name":"LIBNET COMUNICACAO INTERATIVA LTDA","commercialName":"LIBNET","cnpj":"01785921000170","city":"BELÉM","stateCode":"PA","buscaAdicional":"LIBNET COMUNICACAO 56180 LIBNET COMUNICACAO 909264"},{"id":"220551c0-d052-44bf-64c3-08d5ad2bf6ba","name":"DELTA PUBLICIDADE S A","commercialName":"O LIBERAL","cnpj":"04929683000117","city":"BELÉM","stateCode":"PA","buscaAdicional":"DELTA PUBLICIDADE 56197 DELTA PUBLICIDADE 908765"},{"id":"1b2e24bd-7e2f-446b-5aca-08d5ad2bf6ba","name":"TAPAJOS ALIMENTOS LTDA","commercialName":"TAPAJOS ALIMENTOS LTDA","cnpj":"06153245000305","city":"BELTERRA","stateCode":"PA","buscaAdicional":"TAPAJOS ABATEDOURO I 50240 TAPAJOS ALIMENTOS 897869"},{"id":"6d652eba-7c12-43f9-5dbd-08d5ad2bf6ba","name":"INDUSTRIA E COMERCIO DE COSMETICOS NATURA LTDA","commercialName":"NATURA","cnpj":"00190373000768","city":"BENEVIDES","stateCode":"PA","buscaAdicional":"NATURA PA N 51972 NATURA BENEVIDES 899713"},{"id":"b51b11b5-0233-43fb-675a-08d5ad2bf6ba","name":"HADEX COMERCIO E INDUSTRIA DE MADEIRA LTDA","commercialName":"HADEX","cnpj":"05661374000171","city":"BENEVIDES","stateCode":"PA","buscaAdicional":"HADEX 58059 HADEX 908766"},{"id":"432460b8-dbf2-4a62-6830-08d5ad2bf6ba","name":"SAMPAIO & MORAES LTDA","commercialName":"SPLASH","cnpj":"10385998000143","city":"BENEVIDES","stateCode":"PA","buscaAdicional":"SPLASH 59458 SPLASH 910073"},{"id":"0fa0dcb9-9134-479d-67c9-08d5ad2bf6ba","name":"SNACKS PRODUTOS ALIMENTICIOS LTDA","commercialName":"SNACKS","cnpj":"05863041000125","city":"BENEVIDES","stateCode":"PA","buscaAdicional":"SNACKS 58636 SNACKS ALIMENTOS 908427"},{"id":"11d86f6f-2f59-4fb3-51ea-08d5ad2bf6ba","name":"PALMYRA DO BRASIL INDUSTRIA E COMERCIO DE SILICIO METALICO E RECURSOS NATURAIS LTDA.","commercialName":"PALMYRA DO BRASIL IND COM DE SILICIO MET E REC NAT LTDA","cnpj":"04872297000136","city":"BREU BRANCO","stateCode":"PA","buscaAdicional":"PALMYRA DO BRASIL 2717 DOW CORNING 70710 GMICSA-SANTOS DUMONT 7467 DCTA S DUMONT 138 KV 70109"},{"id":"eabcd169-f2a6-481f-5150-08d5ad2bf6ba","name":"CIMENTOS DO BRASIL S/A CIBRASA","commercialName":"CIBRASA","cnpj":"04898425000200","city":"CAPANEMA","stateCode":"PA","buscaAdicional":"CIBRASA 2111 CIBRASA 70455"},{"id":"9cbb750c-5233-40ac-6941-08d5ad2bf6ba","name":"ACL SANTOS COMERCIO DE GENEROS ALIMENTICIOS LTDA","commercialName":"ATACADAO DO CARLITO","cnpj":"08856321000102","city":"CAPANEMA","stateCode":"PA","buscaAdicional":"ATACADAO DO CARLITO 60940 YAMADA 6669514 897781"},{"id":"a1272e73-d2bb-4a55-6937-08d5ad2bf6ba","name":"ATIVO ALIMENTOS EXPORTADORA E IMPORTADORA EIRELI","commercialName":"ATIVO ALIMENTOS","cnpj":"06128996000100","city":"CASTANHAL","stateCode":"PA","buscaAdicional":"MAFRINORTE AL 60843 ATIVO ALIMENTOS 912018"},{"id":"2374378f-2616-4855-692c-08d5ad2bf6ba","name":"PERFAL INDUSTRIA DE ESQUADRIAS COMERCIO E SERVICOS LTDA","commercialName":"PERFAL LTDA","cnpj":"04379001000140","city":"CASTANHAL","stateCode":"PA","buscaAdicional":"PERFAL 60831 PERFAL 912017"},{"id":"b855d65b-cbd0-4240-6631-08d5ad2bf6ba","name":"PLASNORT EMBALAGENS LTDA","commercialName":"PLASNORT","cnpj":"04823224000154","city":"CASTANHAL","stateCode":"PA","buscaAdicional":"PLASNORT 57386 PLASNORT 907802"},{"id":"7fbd0924-9a4f-40cc-6126-08d5ad2bf6ba","name":"LIDER COMERCIO E INDUSTRIA LTDA.","commercialName":"SUPERMERCADOS LIDER","cnpj":"05054671001201","city":"CASTANHAL","stateCode":"PA","buscaAdicional":"LIDER CASTANHAL 54037 LIDER CASTANHAL 905360"},{"id":"e1e40585-7b8a-4333-613b-08d5ad2bf6ba","name":"MERCURIO ALIMENTOS S/A","commercialName":"","cnpj":"11831785000241","city":"CASTANHAL","stateCode":"PA","buscaAdicional":"MERCURIO CASTANHAL 54061 MERCURIO CASTANHAL 905058"},{"id":"dd8fd76d-2922-4d5d-619a-08d5ad2bf6ba","name":"PETRUZ FRUITY INDUSTRIA, COMERCIO E DISTRIBUIDORA LTDA","commercialName":"PETRUZ FRUITY","cnpj":"10404940000108","city":"CASTANHAL","stateCode":"PA","buscaAdicional":"PETRUZ FRUITY 54286 PETRUZ FRUITY LTDA 907137"},{"id":"7b0f5187-7ac5-4d7c-619e-08d5ad2bf6ba","name":"BELA IACA POLPAS DE FRUTAS INDUSTRIA E COMERCIO LTDA","commercialName":"BELA IACA","cnpj":"07481452000181","city":"CASTANHAL","stateCode":"PA","buscaAdicional":"BELA IACA 54292 BELA IACA CASTANHAL 908114"},{"id":"0f521542-7654-44d4-62d3-08d5ad2bf6ba","name":"AMAZON POLPAS IND. E COM. DE POLPAS DA AMAZONIA LTDA","commercialName":"ACAI DELICIA DO PARA","cnpj":"07620120000130","city":"CASTANHAL","stateCode":"PA","buscaAdicional":"AMAZON POLPAS 54981 AMAZON POLPAS 906618"},{"id":"8374e1fe-a515-4e72-62f9-08d5ad2bf6ba","name":"I C MELO & CIA LTDA","commercialName":"FLAMBOYANT","cnpj":"01141049000127","city":"CASTANHAL","stateCode":"PA","buscaAdicional":"FLAMBOYANT 55064 FLAMBOYANT 906620"},{"id":"f386661d-3848-433b-575f-08d5ad2bf6ba","name":"HILEIA INDUSTRIAS DE PRODUTOS ALIMENTICIOS S A","commercialName":"","cnpj":"05388392000121","city":"CASTANHAL","stateCode":"PA","buscaAdicional":"HILEIA CAS 8732 HILEIA CASTANHAL 891923"},{"id":"04f26148-1fe0-4683-5abf-08d5ad2bf6ba","name":"MARIZA INDUSTRIA E COMERCIO DE ALIMENTOS LTDA","commercialName":"MARIZA ALIMENTOS","cnpj":"01773117000170","city":"CASTANHAL","stateCode":"PA","buscaAdicional":"MARIZA 50218 MARIZA 898062"},{"id":"708c073c-aa7c-4527-5a78-08d5ad2bf6ba","name":"PLASTICOS KOURY LTDA","commercialName":"PLASTIKO","cnpj":"14069066000142","city":"CASTANHAL","stateCode":"PA","buscaAdicional":"P KOURY 49724 PLASTICOS KOURY 899586"},{"id":"f5b605e5-8af1-4e6b-5886-08d5ad2bf6ba","name":"COMPANHIA TEXTIL DE CASTANHAL","commercialName":"","cnpj":"05389812000194","city":"CASTANHAL","stateCode":"PA","buscaAdicional":"CTC CASTANHAL 12212 TEXTIL DE CASTANHAL 891702"},{"id":"118ef80e-32e1-4441-5b9e-08d5ad2bf6ba","name":"ITAITUBA INDUSTRIA DE CIMENTOS DO PARA S/A","commercialName":"CAIMA","cnpj":"04953915000849","city":"ITAITUBA","stateCode":"PA","buscaAdicional":"ITAITUBA 50789 ITAITUBA PA 898550"},{"id":"f58451b9-c350-4158-5c07-08d5ad2bf6ba","name":"SIDERURGICA NORTE BRASIL S.A EM RECUPERACAO JUDICIAL","commercialName":"SINOBRAS","cnpj":"07933914000154","city":"MARABÁ","stateCode":"PA","buscaAdicional":"SINOBRAS 51040 SINOBRAS 898132"},{"id":"ae34719a-c55a-45c9-672c-08d5ad2bf6ba","name":"LIDER COMERCIO E INDUSTRIA LTDA.","commercialName":"LIDER MARABA","cnpj":"05054671003255","city":"MARABÁ","stateCode":"PA","buscaAdicional":"LIDER MARABA 57991 LIDER MARABA 909271"},{"id":"c0388409-e712-4b5e-8866-08d5ae44ed50","name":"SIDEPAR - SIDERURGICA DO PARA S/A","commercialName":"SIDEPAR","cnpj":"06149423000154","city":"MARABÁ","stateCode":"PA","buscaAdicional":"SIDEPAR 5273 SID PARA-MARABA 72287"},{"id":"ac43ce81-7c96-437c-b9bd-08d5caef97db","name":"DISTRIBUIDORA BELEM DE ALIMENTOS LTDA.","commercialName":"","cnpj":"04141778000333","city":"MARITUBA","stateCode":"PA","buscaAdicional":""},{"id":"931c9735-40bc-4f68-5595-08d5ad2bf6ba","name":"FLORAPLAC MDF LTDA","commercialName":"FLORAPLAC MDF","cnpj":"09256139000175","city":"PARAGOMINAS","stateCode":"PA","buscaAdicional":"FLORAPLACMDF PIE 5857 FLORAPLAC MDF-PARAGO 72012 FLORAPLAC 896125 UTE.FL.PA.032116-8.01"},{"id":"2ea2d1f0-0196-4a9f-53ab-08d5ad2bf6ba","name":"MINERACAO PARAGOMINAS S.A.","commercialName":"","cnpj":"12094570000177","city":"PARAGOMINAS","stateCode":"PA","buscaAdicional":"PARAGOMINAS 3761 MINA BAUX PARAGOMINA 70295"},{"id":"534ca558-65c7-456c-6834-08d5ad2bf6ba","name":"AVB MINERACAO LTDA.","commercialName":"AVB MINERACAO LTDA.","cnpj":"07605563000233","city":"PARAUAPEBAS","stateCode":"PA","buscaAdicional":"AVB AVANCO PA 59470 AVB MINERACAO LTDA 912488"},{"id":"7e85802d-bd0d-433e-6446-08d5ad2bf6ba","name":"I S CAMPOS ATACADISTA E DISTRIBUIDORA LTDA","commercialName":"ATACADAO MACRE","cnpj":"09634089000112","city":"PARAUAPEBAS","stateCode":"PA","buscaAdicional":"ATACADAO MACRE 55903 ATACADAO OURILANDIA 907706 ATACADAO PARAUAPEBAS 907708 LOJA NOVA 908426 MACRE 103504694 910362"},{"id":"b34d7f95-0b41-4faf-6430-08d5ad2bf6ba","name":"HIPERMERCADO SENNA DIST. EXP. E IMPORT. LTDA","commercialName":"HIPERSENNA","cnpj":"08533503000134","city":"PARAUAPEBAS","stateCode":"PA","buscaAdicional":"HIPERSENNA 55875 HIPERSENNA 105163185 906611 HIPERSENNA 109084425 906612 HIPERSENNA 18610280 907098"},{"id":"63e8bcc6-bae2-4bb4-67d7-08d5ad2bf6ba","name":"FRIGORIFICO RIO MARIA LTDA","commercialName":"FRIGORIFICO RIO MARIA","cnpj":"04749233000142","city":"RIO MARIA","stateCode":"PA","buscaAdicional":"FRIGORIFICO RIO MARIA 58673 FRIGORIF RIO MARIA 908763"},{"id":"15ffd823-9fad-4826-67ff-08d5ad2bf6ba","name":"AMAZONFRUTAS POLPAS DE FRUTAS DA AMAZONIA LTDA","commercialName":"RAJA FRUTAS","cnpj":"02736703000108","city":"SANTA BÁRBARA DO PARÁ","stateCode":"PA","buscaAdicional":"AMAZONFRUTAS 59171 AMAZONFRUTAS 909265"},{"id":"9b109200-23dd-4703-694e-08d5ad2bf6ba","name":"BENEVIDES AGUAS S/A","commercialName":"CEBRASA","cnpj":"15887193000111","city":"SANTA ISABEL DO PARÁ","stateCode":"PA","buscaAdicional":"BELAGUA 61037 BENEVIDES AGUAS 911954"},{"id":"8dcba151-0a72-4555-5c50-08d5ad2bf6ba","name":"PLASMETAL INDUSTRIA E COMERCIO LTDA","commercialName":"","cnpj":"04320375000190","city":"SANTA ISABEL DO PARÁ","stateCode":"PA","buscaAdicional":"PLASMETAL 51259 PLASMETAL 898793"},{"id":"e470c7ac-80a9-44f6-58ca-08d5ad2bf6ba","name":"SANTA IZABEL ALIMENTOS LTDA","commercialName":"","cnpj":"03779994000346","city":"SANTA ISABEL DO PARÁ","stateCode":"PA","buscaAdicional":"F AMERICANO RACAO 13313 F AMERICANO RACAO 892005"},{"id":"d6912860-88c2-4f5f-58cb-08d5ad2bf6ba","name":"SANTA IZABEL ALIMENTOS LTDA","commercialName":"","cnpj":"03779994000508","city":"SANTA ISABEL DO PARÁ","stateCode":"PA","buscaAdicional":"F AMERICANO AVINEL 13314 F AMERICANO AVINEL 892004"},{"id":"de08c6fb-473f-4113-58cc-08d5ad2bf6ba","name":"SANTA IZABEL ALIMENTOS LTDA","commercialName":"FRANGO AMERICANO","cnpj":"03779994000184","city":"SANTA ISABEL DO PARÁ","stateCode":"PA","buscaAdicional":"F AMERICANO ABAT 13315 F AMERICANO ABAT 892006"},{"id":"b3b3f8d6-c869-4b13-60ec-08d5ad2bf6ba","name":"SANTA IZABEL ALIMENTOS LTDA","commercialName":"FRANGO AMERICANO","cnpj":"03779994001237","city":"SANTA ISABEL DO PARÁ","stateCode":"PA","buscaAdicional":"F AMERICANO INCUB 53900 F AMERICANO INCUB 906619"},{"id":"29ff5eef-c303-4bb7-5ac9-08d5ad2bf6ba","name":"TAPAJOS ALIMENTOS LTDA","commercialName":"TAPAJOS ALIMENTOS LTDA","cnpj":"06153245000216","city":"SANTARÉM","stateCode":"PA","buscaAdicional":"TAPAJOS TABOCAL 50239 TAPAJOS TABOCAL 897989"},{"id":"00feafc1-50d3-4546-686f-08d5ad2bf6ba","name":"RIO TAPAJOS SHOPPING CENTER","commercialName":"RIO TAPAJOS SHOPPING CENTER","cnpj":"20813068000105","city":"SANTARÉM","stateCode":"PA","buscaAdicional":"RIO TAPAJOS 60035 RIO TAPAJOS 909734"},{"id":"9412c391-454b-4df1-6667-08d5ad2bf6ba","name":"CARGILL AGRICOLA S A","commercialName":"CARGILL AGRICOLA","cnpj":"60498706033594","city":"SANTARÉM","stateCode":"PA","buscaAdicional":"CARGILL STM 57530 CARGILL STM 908441"},{"id":"bacd1e64-abc1-4c01-8da3-08d5d060706e","name":"NILZA PLACHI","commercialName":"FABRICA DE GELO POLAR","cnpj":"34834937000184","city":"SANTARÉM","stateCode":"PA","buscaAdicional":"NILZAPLACHI 61796 23116 913554"},{"id":"86a5887a-f817-4e23-685e-08d5ad2bf6ba","name":"MASTERBOI LTDA.","commercialName":"MASTERBOI","cnpj":"03721769000944","city":"SÃO GERALDO DO ARAGUAIA","stateCode":"PA","buscaAdicional":"MASTERBOI PA 59864 MASTERBOI LTDA PARA 910614"},{"id":"c73dacb8-2613-4503-613a-08d5ad2bf6ba","name":"MERCURIO ALIMENTOS S/A","commercialName":"","cnpj":"11831785000322","city":"XINGUARA","stateCode":"PA","buscaAdicional":"MERCURIO XINGUARA 54060 MERCURIO XINGUARA 905965"},{"id":"6c7fa0ff-ca0f-4144-5847-08d5ad2bf6ba","name":"EMPRESA DE ENERGIA CACHOEIRA CALDEIRAO S.A.","commercialName":"","cnpj":"17200920000156","city":"FERREIRA GOMES","stateCode":"AP","buscaAdicional":"EECC 11169 CACHOEIRA CALDEIRAO 890999 UHE.PH.AP.031186-3.01"},{"id":"9b544dbd-60ff-4d39-5437-08d5ad2bf6ba","name":"COMPANHIA DE ELETRICIDADE DO AMAPA - CEA","commercialName":"","cnpj":"05965546000109","city":"MACAPÁ","stateCode":"AP","buscaAdicional":"CEA 4092 CEA 894862"},{"id":"f928ed14-bfa2-442b-5156-08d5ad2bf6ba","name":"BONASA ALIMENTOS S/A","commercialName":"BONASA","cnpj":"03573324000298","city":"AGUIARNÓPOLIS","stateCode":"TO","buscaAdicional":"BONASA ALIMENTOS 2122 BONASA ALIMENTOS TO 905745"},{"id":"f22b33eb-6038-49bb-52db-08d5ad2bf6ba","name":"MINERVA S.A.","commercialName":"","cnpj":"67620377001862","city":"ARAGUAÍNA","stateCode":"TO","buscaAdicional":"MINERVA AR 3335 MINERVA AR 71057"},{"id":"c44cbd81-3ada-41f0-556a-08d5ad2bf6ba","name":"ITPAC INSTITUTO TOCANTINENSE PRESIDENTE ANTONIO CARLOS S.A","commercialName":"ITPAC","cnpj":"02941990000198","city":"ARAGUAÍNA","stateCode":"TO","buscaAdicional":"ITPAC 5550 ITPAC 888435"},{"id":"69805eb2-8b88-45e7-61c6-08d5ad2bf6ba","name":"CALTINS CALCARIO TOCANTINS LTDA","commercialName":"CALTINS","cnpj":"02649005000175","city":"BANDEIRANTES DO TOCANTINS","stateCode":"TO","buscaAdicional":"CALTINS 54424 CALTINS CALCARIO 906624"},{"id":"ccaf5c24-8502-4041-6065-08d5ad2bf6ba","name":"FAZENDAO INDUSTRIA E COMERCIO DE PRODUTOS AGROPECUARIOS LTDA","commercialName":"FAZENDAO AGRONEGOCIO","cnpj":"06697576000306","city":"CARIRI DO TOCANTINS","stateCode":"TO","buscaAdicional":"FAZENDAO AGRONEGOCIO 53489 FAZENDAO AGRONEGOCIO 908093"},{"id":"5bd4e7b0-66e4-4bca-8d93-08d5d060706e","name":"CURTIDORA TOCANTINS LTDA","commercialName":"CURTIDORA TOCANTINS","cnpj":"09233233000109","city":"COLINAS DO TOCANTINS","stateCode":"TO","buscaAdicional":"CURTIDORA TOCANTINS 61089 CURTIDORA TOCANTINS 913574"},{"id":"5c92d860-57d7-494a-6839-08d5ad2bf6ba","name":"COOPERATIVA DOS PRODUTORES DE CARNE E DERIVADOS DE GURUPI","commercialName":"COOPERFRIGU","cnpj":"02964051000169","city":"GURUPI","stateCode":"TO","buscaAdicional":"COOPERFRIGU 59496 COOPERFRIGU 910402"},{"id":"9e1770b9-2893-4d91-88c8-08d5ae44ed50","name":"SOL MAIOR GERADORA DE ENERGIA S.A.","commercialName":"UFV SOL MAIOR 2","cnpj":"23817528000153","city":"MIRACEMA DO TOCANTINS","stateCode":"TO","buscaAdicional":"UFV SOL MAIOR 2 51673"},{"id":"c07f4152-ba62-4c02-4f17-08d5ad2bf6ba","name":"INVESTCO SA","commercialName":"","cnpj":"00644907000193","city":"MIRACEMA DO TOCANTINS","stateCode":"TO","buscaAdicional":"INVESTCO 87 LAJEADO INVESTCO 8288 UHE.PH.TO.001304-8.01"},{"id":"0e513e88-5394-4a80-57f8-08d5ad2bf6ba","name":"NATICAL NATIVIDADE CALCARIO LTDA","commercialName":"NATICAL","cnpj":"05683638000198","city":"NATIVIDADE","stateCode":"TO","buscaAdicional":"NATICAL 10310 NATICAL NATIVIDADE 906326"},{"id":"4b8b1b59-c86d-4951-6902-08d5ad2bf6ba","name":"NATIVA MINERACAO LIMITADA","commercialName":"","cnpj":"02932663000170","city":"NATIVIDADE","stateCode":"TO","buscaAdicional":"NATIVA MINERACAO 60718 NATIVA MINERACAO LIM 912316"},{"id":"921a0dce-4f52-422c-5b28-08d5ad2bf6ba","name":"MASTERBOI LTDA.","commercialName":"MASTERBOI","cnpj":"03721769000600","city":"NOVA OLINDA","stateCode":"TO","buscaAdicional":"TRA-MASTERBOI-TO 50499 MASTERBOI TO 898531"},{"id":"a15fdb54-02ea-411c-5a53-08d5ad2bf6ba","name":"SAO SEBASTIAO ENERGIA LTDA","commercialName":"SAO SEBASTIAO ENERGIA","cnpj":"07450504000152","city":"NOVO JARDIM","stateCode":"TO","buscaAdicional":"PCH DOIDO 17349 PCH DOIDO 896624 PCH.PH.TO.031244-4.01"},{"id":"f6a5fbeb-c7bc-48d8-6890-08d5ad2bf6ba","name":"FRIGORIFICO PARAISO LTDA","commercialName":"FRIGORIFICO PARAISO","cnpj":"14836553000193","city":"PARAÍSO DO TOCANTINS","stateCode":"TO","buscaAdicional":"FRIGORIFICO PARAISO 60155 FRIGORIFICO PARAISO 910416"},{"id":"a967b894-1b47-42a1-547e-08d5ad2bf6ba","name":"PEDRO AFONSO ACUCAR & BIOENERGIA LTDA","commercialName":"","cnpj":"09067572000162","city":"PEDRO AFONSO","stateCode":"TO","buscaAdicional":"PEDRO AFONSO 4301 PEDRO AFONSO 889721 UTE.AI.TO.030518-9.01"},{"id":"f9a7d7db-b919-4e4a-5368-08d5ad2bf6ba","name":"CENTRAL HIDRELETRICA BURITIRANA S.A.","commercialName":"PCH BURITIRANA","cnpj":"09528781000166","city":"PONTE ALTA DO BOM JESUS","stateCode":"TO","buscaAdicional":"CGH BURITIRANA 3618 BURITIRANA 8819 CGH.PH.TO.029804-2.01"},{"id":"742ff186-7b59-4c7a-5bc2-08d5ad2bf6ba","name":"CENTRAL HIDRELETRICA SIRIVERA LTDA","commercialName":"CENTRAL HIDRELETRICA SIRIVERA","cnpj":"17692801000168","city":"PONTE ALTA DO BOM JESUS","stateCode":"TO","buscaAdicional":"SIRIVERA 50884 SIRIVERA 899696 CGH.PH.TO.035446-5.01"},{"id":"f508561b-9037-4ebe-5bc3-08d5ad2bf6ba","name":"CENTRAL HIDRELETRICA TAPUIAS LTDA","commercialName":"CENTRAL HIDRELETRICA TAPUIAS","cnpj":"17692540000186","city":"PONTE ALTA DO BOM JESUS","stateCode":"TO","buscaAdicional":"TAPUIAS 50885 TAPUIAS 899149 CGH.PH.TO.035426-0.01"},{"id":"0db61b7c-ff89-4d84-59f5-08d5ad2bf6ba","name":"CENTRAL HIDRELETRICA PIABANHA LTDA","commercialName":"PCH PIABANHA","cnpj":"10687199000121","city":"PONTE ALTA DO BOM JESUS","stateCode":"TO","buscaAdicional":"PIABANHA 16115 PIABANHA TOCANTINS 895063 CGH.PH.TO.031902-3.01"},{"id":"00164637-676e-473f-6683-08d5ad2bf6ba","name":"CENTRAL HIDRELETRICA SUCURI S/A","commercialName":"CENTRAL HIDRELETRICA SUCURI","cnpj":"23509244000108","city":"PONTE ALTA DO BOM JESUS","stateCode":"TO","buscaAdicional":"CGH SUCURI 57626 CGH SUCURI 911351 CGH.PH.TO.035733-2.01"},{"id":"2b3d5e3f-09e1-46ea-59b0-08d5ad2bf6ba","name":"ITPAC PORTO NACIONAL - INSTITUTO TOCANTINENSE PRESIDENTE ANTONIO CARLOS PORTO S.A.","commercialName":"ITPAC PORTO NACIONAL","cnpj":"10261569000164","city":"PORTO NACIONAL","stateCode":"TO","buscaAdicional":"ITPAC PORTO NACIONAL 15335 ITPAC P NACIONAL 894462"},{"id":"9bdf0160-d08d-466e-4ee9-08d5ad2bf6ba","name":"ENERGISA TOCANTINS DISTRIBUIDORA DE ENERGIA S.A.","commercialName":"ENERGISA TOCANTINS","cnpj":"25086034000171","city":"PALMAS","stateCode":"TO","buscaAdicional":"ENERGISA TO 18 ENERGISA TO 38"},{"id":"ad771926-68d3-4ec3-5293-08d5ad2bf6ba","name":"CAPIM DOURADO EMPREENDIMENTOS IMOBILIARIOS E PARTICIPACOES LTDA","commercialName":"CAPIM DOURADO SHOPPING","cnpj":"09086013000108","city":"PALMAS","stateCode":"TO","buscaAdicional":"CAP DOURADO SC 3156 SHOP CAPIM DOURADO 71358"},{"id":"87f70a35-563c-4ab7-6760-08d5ad2bf6ba","name":"NMB SHOPPING CENTER LTDA","commercialName":"PALM BLUE SHOPPING CENTER","cnpj":"38149506000130","city":"PALMAS","stateCode":"TO","buscaAdicional":"PALMAS SHOPPING 58070 PALMAS SHOPPING 911265"},{"id":"80266645-9ce3-48a2-6909-08d5ad2bf6ba","name":"TEMPERTINS INDUSTRIA E COMERCIO DE VIDROS LTDA","commercialName":"VITRAX","cnpj":"07360547000147","city":"PALMAS","stateCode":"TO","buscaAdicional":"TEMPERTINS 60738 TEMPERTINS 911983"},{"id":"a71de18b-4961-41f1-4efc-08d5d159243d","name":"COMPANHIA DE SANEAMENTO DO TOCANTINS - SANEATINS","commercialName":"BRK AMBIENTAL / SANEATINS","cnpj":"25089509000183","city":"PALMAS","stateCode":"TO","buscaAdicional":""},{"id":"97623828-d84b-421c-61c5-08d5ad2bf6ba","name":"MINERAX - MINERACAO XAMBIOA LTDA","commercialName":"MINERAX","cnpj":"08886407000170","city":"XAMBIOÁ","stateCode":"TO","buscaAdicional":"MINERAX 54423 MINERAX - MINERACAO 906327"},{"id":"eb2ae9f2-ec06-4500-51a5-08d5ad2bf6ba","name":"GUSA NORDESTE S/A","commercialName":"","cnpj":"07636657000199","city":"AÇAILÂNDIA","stateCode":"MA","buscaAdicional":"GUSA NORDESTE 2469 ACIARIA GUSA 894924 GUSA NORDESTE 8387 UTE.FL.MA.029722-4.01"},{"id":"a95082cc-2152-47b3-539f-08d5ad2bf6ba","name":"VIENA SIDERURGICA S/A","commercialName":"","cnpj":"07609993000142","city":"AÇAILÂNDIA","stateCode":"MA","buscaAdicional":"VIENA 3733 VIENA 8914 UTE.FL.MA.028917-5.01"},{"id":"39bb6788-6c9d-4cfd-588f-08d5ad2bf6ba","name":"GUARANY SIDERURGIA E MINERACAO S.A.","commercialName":"","cnpj":"10426518000145","city":"AÇAILÂNDIA","stateCode":"MA","buscaAdicional":"GUARANY SID 12432 SIMASA (GUARANY) 891123 UTE.FL.MA.028500-5.01"},{"id":"3c390a42-13ac-4d84-5890-08d5ad2bf6ba","name":"COMPANHIA SIDERURGICA VALE DO PINDARE","commercialName":"","cnpj":"22016026000160","city":"AÇAILÂNDIA","stateCode":"MA","buscaAdicional":"VALE DO PINDARE 12433 SIMASA (PINDARE) 891122 UTE.FL.MA.028500-5.01"},{"id":"1229585c-3638-4e30-5bb2-08d5ad2bf6ba","name":"CIMENTO VERDE DO BRASIL S A","commercialName":"CIMENTO VERDE DO BRASIL LTDA","cnpj":"15733416000277","city":"AÇAILÂNDIA","stateCode":"MA","buscaAdicional":"CIMENTO VERDE 50832 CIMENTO VERDE 898167"},{"id":"ef7c6089-cbe4-476f-5d19-08d5ad2bf6ba","name":"NOTARO ALIMENTOS LTDA","commercialName":"","cnpj":"01682695001092","city":"BALSAS","stateCode":"MA","buscaAdicional":"NOTARO-MA RACAO 51701 NOTARO RACAO 898805"},{"id":"5eef3776-38c1-4afd-5d01-08d5ad2bf6ba","name":"NOTARO ALIMENTOS LTDA","commercialName":"","cnpj":"01682695001769","city":"BALSAS","stateCode":"MA","buscaAdicional":"NOTARO-MA MATRIZEIRO 51675 NOTARO 898807"},{"id":"2ee4a258-7c9d-4929-615d-08d5ad2bf6ba","name":"F. C. OLIVEIRA & CIA. LTDA","commercialName":"DISTRIBUIDORA CODOENSE","cnpj":"07069487000370","city":"CODÓ","stateCode":"MA","buscaAdicional":"FC OLIVEIRA 54154 FC OLIVEIRA 902277"},{"id":"60205ae5-21f5-49cf-8876-08d5ae44ed50","name":"ITAPICURU AGRO INDUSTRIAL SA","commercialName":"","cnpj":"10319846000142","city":"CODÓ","stateCode":"MA","buscaAdicional":"COG ITAPICURU 7018 COG ITAPICURU 890206"},{"id":"c8ad9bd2-f3f2-4231-6422-08d5ad2bf6ba","name":"MARANHAO INDUSTRIA DE COUROS LTDA","commercialName":"MARANHAO INDUSTRIA DE COUROS","cnpj":"10481071000107","city":"GOVERNADOR EDISON LOBÃO","stateCode":"MA","buscaAdicional":"MARANHAO COUROS 55854 MARANHAO COUROS 906607"},{"id":"34e3844b-eeb0-47ec-61f7-08d5ad2bf6ba","name":"RIO GRANDE COMERCIO DE CARNES LTDA","commercialName":"FRIBAL FRIGORIFICO","cnpj":"07555950001012","city":"IMPERATRIZ","stateCode":"MA","buscaAdicional":"FRIBAL 54488 FRIBAL 906218"},{"id":"b435ecc3-48d9-47d4-68ed-08d5ad2bf6ba","name":"IMPERIAL SHOPPING","commercialName":"IMPERIAL SHOPPING","cnpj":"16602614000183","city":"IMPERATRIZ","stateCode":"MA","buscaAdicional":"IMPERIAL SHOPPING 60573 IMPERIAL SHOPPING 910380"},{"id":"31445427-f67a-41a6-517d-08d5ad2bf6ba","name":"GERA MARANHAO - GERADORA DE ENERGIA DO MARANHAO S.A","commercialName":"","cnpj":"09110880000123","city":"MIRANDA DO NORTE","stateCode":"MA","buscaAdicional":"GERANORTE 2208 GERAMAR I 8564 UTE.PE.MA.029705-4.01 GERAMAR II 8567 UTE.PE.MA.029668-6.01"},{"id":"695ed214-2607-4388-5564-08d5ad2bf6ba","name":"COSIMA - SIDERURGICA DO MARANHAO LTDA.","commercialName":"COSIMA","cnpj":"10431245000127","city":"PINDARÉ-MIRIM","stateCode":"MA","buscaAdicional":"UTE COSIMA 5489 COSIMA 8963 UTE.CM.MA.030550-2.01"},{"id":"d5a5ee57-9d05-4f00-1cb3-08d5b8870181","name":"NUTRILAR INDUSTRIA DE SABAO E OLEO LTDA","commercialName":"NUTRILAR","cnpj":"04742371000108","city":"PRESIDENTE DUTRA","stateCode":"MA","buscaAdicional":"NUTRILAR 60872 NUTRILAR ROD BR 226 912595 NUTRILAR AV P T 912631"},{"id":"97a4d776-6921-4498-66e2-08d5ad2bf6ba","name":"EM VIDROS INDUSTRIA E COMERCIO LTDA","commercialName":"EM VIDROS","cnpj":"17587823000168","city":"RAPOSA","stateCode":"MA","buscaAdicional":"EM VIDROS 57866 EM VIDROS IND E COM 909305"},{"id":"5dc1f6bc-56df-4ce2-6959-08d5ad2bf6ba","name":"PARNAIBA GAS NATURAL S.A.","commercialName":"","cnpj":"11230122000603","city":"SANTO ANTÔNIO DOS LOPES","stateCode":"MA","buscaAdicional":"UTG PARNAIBA 61072 UTG PARNAIBA 912482"},{"id":"5436cc2c-ab5d-45eb-553a-08d5ad2bf6ba","name":"PARNAIBA II GERACAO DE ENERGIA S.A","commercialName":"","cnpj":"14578002000177","city":"SANTO ANTÔNIO DOS LOPES","stateCode":"MA","buscaAdicional":"UTE PARNAIB II 5171 MARANHAO III 888069 UTE.GN.MA.030800-5.01"},{"id":"c1b2490d-67f6-4291-5519-08d5ad2bf6ba","name":"PARNAIBA I GERACAO DE ENERGIA S.A","commercialName":"PARNAIBA I","cnpj":"11744699000110","city":"SANTO ANTÔNIO DOS LOPES","stateCode":"MA","buscaAdicional":"UTE PARNAIBA 5049 MARANHAO IV 888071 UTE.GN.MA.030202-3.01 MARANHAO V 888148 UTE.GN.MA.030203-1.01"},{"id":"a644dae0-e2b1-4783-51eb-08d5ad2bf6ba","name":"PARNAIBA III GERACAO DE ENERGIA S.A","commercialName":"UTE MC2 NOVA VENECIA 2 S.A.","cnpj":"10536701000101","city":"SANTO ANTÔNIO DOS LOPES","stateCode":"MA","buscaAdicional":"MPXNOVAVENECIA 2723 MC2 NOVA VENECIA 2 888150 UTE.GN.MA.030196-5.01"},{"id":"2d2b0b1e-98f4-482a-5f15-08d5ad2bf6ba","name":"CONDOMINIO DO PATIO NORTE SHOPPING","commercialName":"CONDOMINIO PATIO NORTE","cnpj":"21675002000150","city":"SÃO JOSÉ DE RIBAMAR","stateCode":"MA","buscaAdicional":"PATIO NORTE SHOP 52728 PATIO NORTE SHOPPING 902534 PATIO NORTE SHOP CON 902617"},{"id":"0510e3e3-8139-4f4b-7017-08d5c7c81a03","name":"CINEMATOGRAFICA NORDESTE LTDA","commercialName":"CENTERPLEX CINEMAS","cnpj":"21599452000101","city":"SÃO JOSÉ DE RIBAMAR","stateCode":"MA","buscaAdicional":""},{"id":"46a0fd26-6285-4f00-7280-08d5cf600bef","name":"EQUATORIAL ENERGIA S/A","commercialName":"","cnpj":"03220438000173","city":"SÃO LUÍS","stateCode":"MA","buscaAdicional":""},{"id":"62e31924-9947-4a9f-72ee-08d5cf600bef","name":"FERROVIA NORTE SUL S/A","commercialName":"FERROVIA NORTE SUL","cnpj":"09257877000137","city":"SÃO LUÍS","stateCode":"MA","buscaAdicional":""},{"id":"14cddca9-5c9f-468e-4f05-08d5d159243d","name":"EQUATORIAL TRANSMISSORA 8 SPE S.A.","commercialName":"","cnpj":"27967244000102","city":"SÃO LUÍS","stateCode":"MA","buscaAdicional":""},{"id":"fbc288ac-4a95-46eb-8db4-08d5d060706e","name":"CONSTROEM-CONSTRUCOES E EMPREEND DO MARANHAO LTDA","commercialName":"CONSTROEM","cnpj":"07357551000156","city":"SÃO LUÍS","stateCode":"MA","buscaAdicional":"BOULEVARD TROPICAL 63152 BOULEVARD TROPICAL 913575"},{"id":"7a339384-15ba-43d9-6940-08d5ad2bf6ba","name":"UDI HOSPITAL - EMPREENDIMENTOS MEDICO HOSPITALARES DO MARANHAO LTDA.","commercialName":"","cnpj":"35181726000152","city":"SÃO LUÍS","stateCode":"MA","buscaAdicional":"HOSPITAL UDI 60939 UDI HOSPITAL 911797"},{"id":"21411f0a-dd0d-4b9d-6910-08d5ad2bf6ba","name":"WINDOWS HOTEIS E TURISMO LTDA","commercialName":"HOTEL IBIS","cnpj":"09456657000213","city":"SÃO LUÍS","stateCode":"MA","buscaAdicional":"HOTEL IBIS MA 60757 HOTEL IBIS MA 911179"},{"id":"06b86f28-1312-4341-6888-08d5ad2bf6ba","name":"POTIGUAR MATERIAIS DE CONSTRUCAO LTDA","commercialName":"POTIGUAR","cnpj":"06778591000109","city":"SÃO LUÍS","stateCode":"MA","buscaAdicional":"POTIGUAR MATERIAIS 60118 POTIGUAR COHAFUMA 910381 POTIGUAR COHAMA 910383 POTIGUAR FORQUILHA 910384"},{"id":"424717c8-1325-4dce-68b9-08d5ad2bf6ba","name":"CENTRO DE ENSINO ATENAS MARANHENSE LTDA","commercialName":"FAMA-FACULDADE ATENAS MARANHENSE","cnpj":"03062543000121","city":"SÃO LUÍS","stateCode":"MA","buscaAdicional":"PITAGORAS SAO LUIS 60355 PITAGORAS SAO LUIZ 910068"},{"id":"568e340c-8478-4c16-6840-08d5ad2bf6ba","name":"RIO ANIL SHOPPING","commercialName":"RIO ANIL SHOPPING","cnpj":"11665929000156","city":"SÃO LUÍS","stateCode":"MA","buscaAdicional":"RIO ANIL SHOPPING 59610 RIO ANIL SHOPPING 910257"},{"id":"625afbdd-b4be-4110-6759-08d5ad2bf6ba","name":"ARMAZEM MATEUS S.A.","commercialName":"ARMAZEM MATEUS","cnpj":"23439441001323","city":"SÃO LUÍS","stateCode":"MA","buscaAdicional":"ARMAZEM MATEUS 58058 ARMAZEN MATEUS 908773 ARMAZEM MATEUS BENEV 910072"},{"id":"4ba8799d-7c59-45d9-6672-08d5ad2bf6ba","name":"SAO LUIS ADMINISTRADORA DE SHOPPING CENTER LTDA","commercialName":"SAO LUIS ADMINISTRADORA","cnpj":"01637668000107","city":"SÃO LUÍS","stateCode":"MA","buscaAdicional":"SHOPPING SAO LUIS 57573 SAO LUIS SHOPPING 908425"},{"id":"a874e310-09cb-4664-6614-08d5ad2bf6ba","name":"LUZEIROS HOTEIS S/A.","commercialName":"HOTEL LUZEIROS SAO LUIS","cnpj":"07721300000109","city":"SÃO LUÍS","stateCode":"MA","buscaAdicional":"LUZEIROS HOTEIS 57293 LUZEIROS HOTEIS 907431"},{"id":"cae37d67-c518-4567-62a6-08d5ad2bf6ba","name":"MOINHOS CRUZEIRO DO SUL S A","commercialName":"MOINHOS CRUZEIRO DO SUL","cnpj":"88301155002314","city":"SÃO LUÍS","stateCode":"MA","buscaAdicional":"MOINHOS SAO LUIS 54897 MOINHOS SAO LUIS 905096"},{"id":"fa10629e-c63e-483a-62ba-08d5ad2bf6ba","name":"CIMAR - CIMENTOS DO MARANHAO S.A.","commercialName":"CIMAR","cnpj":"15129010000107","city":"SÃO LUÍS","stateCode":"MA","buscaAdicional":"CIMENTO BRAVO 54940 CIMAR MARANHAO 905633"},{"id":"021f0e30-1932-452e-6235-08d5ad2bf6ba","name":"GRUPO DOM BOSCO LTDA","commercialName":"COLEGIO DOM BOSCO LTDA","cnpj":"41478561000188","city":"SÃO LUÍS","stateCode":"MA","buscaAdicional":"COLEGIO DOM BOSCO 54622 COLEGIO DOM BOSCO 902521"},{"id":"3a3238fb-adb9-42d3-647c-08d5ad2bf6ba","name":"MATEUS SUPERMERCADOS S.A.","commercialName":"MATEUS SUPERMERCADOS","cnpj":"03995515001309","city":"SÃO LUÍS","stateCode":"MA","buscaAdicional":"HIPER MATEUS 56023 HIPER MATEUS GUAJAJA 905582 HIPER MATEUS COHAMA 905634 HIPER MATEUS CID OPE 905636 HIPER MATEUS SH AUTO 905637 HIPER MATEUS R ANIL 905638 HIPER MATEUS LOJA 03 905815 HIPER MATEUS LOJA 92 905816 HIPER MATEUS L15 ACA 905934 HIPER MATEUS 95 908129 HIPER MATEUS 01 908131 HIPER MATEUS 27 908749 HIPER MATEUS 02 908750 HIPER MATEUS 23 908759 HIPER MATEUS 29 908760 HIPER MATEUS 18 908761 HIPER MATEUS 121 908771 HIPER MATEUS 05 908772 HIPER MATEUS LJ 96 908875 HIPER MATEUS 31 909097 HIPER MATEUS 91 909098 HIPER MATEUS 19 909099 HIPER MATEUS 20 909113 HIPER MATEUS 30 909285 HIPER MATEUS 93 909303 HIPER MATEUS UC 1057 911784 HIPER MATEUS RENASCE 911798 YAMADA 19429 PA 897779 YAMADA 12445512 PA 897828 YAMADA 7338325 897848 HIPER MATEUS UC 1925 908369 HIPER MATEUS ALTAMIR 908658 HIPER MATEUS 19151 909210 HIPER PARAUPEBA 910597 HIPER MATEUS MARABA 910615 HIPER MIX MARABA 910616 HIPER MATEUS 912231 HIPER MATEUS JACARAT 905635 HIPER MATEUS 22 909096"},{"id":"0df2c83f-69a3-406c-6485-08d5ad2bf6ba","name":"INDUSTRIA DE PAES E MASSAS MATEUS LTDA","commercialName":"INDUSTRIA DE PAES E MASSAS MATEUS","cnpj":"08898073000154","city":"SÃO LUÍS","stateCode":"MA","buscaAdicional":"IND SAO LUIS 56056 IND SAO LUIZ 905970 IND SAO LUIS FILIAL 908132"},{"id":"cd17dc28-ae76-40f0-5deb-08d5ad2bf6ba","name":"UNISAOLUIS EDUCACIONAL LTDA","commercialName":"","cnpj":"03186792000129","city":"SÃO LUÍS","stateCode":"MA","buscaAdicional":"ESTACIO UNISAOLUIS 52069 ESTACIO UNISAOLUIS 910069"},{"id":"64e03d7e-ee4b-4efb-58fa-08d5ad2bf6ba","name":"PARNAIBA GERACAO E COMERCIALIZACAO DE ENERGIA S.A","commercialName":"","cnpj":"15743303000171","city":"SÃO LUÍS","stateCode":"MA","buscaAdicional":"PARNAIBA COM 13512 PARNAIBA IV-PARNAIBA 891422 UTE.GN.MA.031193-6.01"},{"id":"c4d71824-bab0-480c-5191-08d5ad2bf6ba","name":"ITAQUI GERACAO DE ENERGIA S/A","commercialName":"","cnpj":"08219477000174","city":"SÃO LUÍS","stateCode":"MA","buscaAdicional":"DIF EMPREEND 2376 PORTO DO ITAQUI 8903 UTE.CM.MA.029700-3.01"},{"id":"371d3a2b-cd9c-48cd-4eea-08d5ad2bf6ba","name":"COMPANHIA ENERGÉTICA DO MARANHÃO-CEMAR","commercialName":"CEMAR","cnpj":"06272793000184","city":"SÃO LUÍS","stateCode":"MA","buscaAdicional":"CEMAR 19 CEMAR 27"},{"id":"90a3fb99-f861-4329-4fd0-08d5ad2bf6ba","name":"ALCAN ALUMINA LTDA","commercialName":"ALCAN ALUMINA LTDA","cnpj":"06959319000125","city":"SÃO LUÍS","stateCode":"MA","buscaAdicional":"ALCAN ALUMINA 1291 ALUMAR REFINAR ALCAN 70613"},{"id":"01d787da-3815-433e-5511-08d5ad2bf6ba","name":"SC2 MARANHAO LOCACAO DE CENTROS COMERCIAIS LTDA","commercialName":"SPE SA CAVALCANTE INCORPORACOES IMOBILIARIAS","cnpj":"09653566000197","city":"SÃO LUÍS","stateCode":"MA","buscaAdicional":"SHOP DA ILHA 5001 SHOPPING DA ILHA 888333 SHOPPING DA ILHA CAG 889260"},{"id":"f575ef31-9e03-4899-589d-08d5ad2bf6ba","name":"CENTRAL GERADORA EOLICA NOTUS S.A","commercialName":"","cnpj":"12960127000131","city":"CALDEIRÃO GRANDE DO PIAUÍ","stateCode":"PI","buscaAdicional":"NOTUS 12772"},{"id":"37975c5b-5149-4456-589e-08d5ad2bf6ba","name":"CENTRAL GERADORA EOLICA LIRA S.A","commercialName":"","cnpj":"12964095000142","city":"CALDEIRÃO GRANDE DO PIAUÍ","stateCode":"PI","buscaAdicional":"LIRA 12773"},{"id":"88ea27d7-1206-4a30-589f-08d5ad2bf6ba","name":"CENTRAL GERADORA EOLICA JAPURA S.A","commercialName":"","cnpj":"12960117000104","city":"CALDEIRÃO GRANDE DO PIAUÍ","stateCode":"PI","buscaAdicional":"JAPURA 12774"},{"id":"aaa4de7a-5f74-461d-58a0-08d5ad2bf6ba","name":"CENTRAL EOLICA FLORENZ LTDA","commercialName":"","cnpj":"12960110000184","city":"CALDEIRÃO GRANDE DO PIAUÍ","stateCode":"PI","buscaAdicional":"FLORENZ 12775"},{"id":"ca2630f9-530f-4db2-58a1-08d5ad2bf6ba","name":"CENTRAL GERADORA EOLICA DANUBIO S.A","commercialName":"","cnpj":"12960103000182","city":"CALDEIRÃO GRANDE DO PIAUÍ","stateCode":"PI","buscaAdicional":"EOL DANUBIO 12776"},{"id":"f86a1350-a2aa-464d-58a2-08d5ad2bf6ba","name":"CENTRAL GERADORA EOLICA CRUZEIRO S.A","commercialName":"","cnpj":"12960094000120","city":"CALDEIRÃO GRANDE DO PIAUÍ","stateCode":"PI","buscaAdicional":"CRUZEIRO 12777"},{"id":"beaa0982-eda1-41d1-58a3-08d5ad2bf6ba","name":"CENTRAL GERADORA EOLICA COQUEIRAL S.A","commercialName":"","cnpj":"10656568000119","city":"CALDEIRÃO GRANDE DO PIAUÍ","stateCode":"PI","buscaAdicional":"COQUEIRAL 12778"},{"id":"5a841997-099c-4daf-58a4-08d5ad2bf6ba","name":"CENTRAL GERADORA EOLICA COLIBRI S.A","commercialName":"","cnpj":"10823648000111","city":"CALDEIRÃO GRANDE DO PIAUÍ","stateCode":"PI","buscaAdicional":"COLIBRI 12779 VENTOS SANTO ADRIANO 909831 EOL.CV.PI.031271-1.01"},{"id":"6778aa28-d1a5-497a-58a5-08d5ad2bf6ba","name":"CENTRAL GERADORA EOLICA BRITE S.A","commercialName":"","cnpj":"12960082000103","city":"CALDEIRÃO GRANDE DO PIAUÍ","stateCode":"PI","buscaAdicional":"BRITE 12780 SANTA EDWIGES 908909 EOL.CV.PI.031270-3.01"},{"id":"83e4c089-089e-4fd5-58a6-08d5ad2bf6ba","name":"CENTRAL GERADORA EOLICA BOREAS S.A","commercialName":"","cnpj":"12960071000115","city":"CALDEIRÃO GRANDE DO PIAUÍ","stateCode":"PI","buscaAdicional":"BOREAS 12781 VENTOS SANTA REGINA 909392 EOL.CV.PI.031276-2.01"},{"id":"265feba7-09f1-4e79-58a7-08d5ad2bf6ba","name":"CENTRAL GERADORA EOLICA BARTOLOMEU S.A","commercialName":"","cnpj":"12960065000168","city":"CALDEIRÃO GRANDE DO PIAUÍ","stateCode":"PI","buscaAdicional":"BARTOLOMEU 12782 SANTA FATIMA 908910 EOL.CV.PI.031273-8.01"},{"id":"6fb579bf-2243-4231-58a8-08d5ad2bf6ba","name":"CENTRAL GERADORA EOLICA ARISTARCO S.A","commercialName":"","cnpj":"12960046000131","city":"CALDEIRÃO GRANDE DO PIAUÍ","stateCode":"PI","buscaAdicional":"ARISTARCO 12783 VENTOS SANTA BARBARA 900524 EOL.CV.PI.031274-6.01"},{"id":"24a08f6b-9bc8-4d35-58a9-08d5ad2bf6ba","name":"CENTRAL GERADORA EOLICA AMONTADA S.A","commercialName":"","cnpj":"10682436000161","city":"CALDEIRÃO GRANDE DO PIAUÍ","stateCode":"PI","buscaAdicional":"AMONTADA 12784 SANTA ANGELINA 900522 EOL.CV.PI.031275-4.01"},{"id":"c09d4e43-3cbc-4bda-58ac-08d5ad2bf6ba","name":"CENTRAL GERADORA EOLICA CAICARA S.A.","commercialName":"","cnpj":"10656606000133","city":"CALDEIRÃO GRANDE DO PIAUÍ","stateCode":"PI","buscaAdicional":"CAICARA CENTRAL EOLICA 12794 VENTOS SANTO ALBANO 909804 EOL.CV.PI.031272-0.01"},{"id":"d440bbe5-bf79-4edf-5c2a-08d5ad2bf6ba","name":"VENTOS DE SAO ADEODATO ENERGIAS RENOVAVEIS S.A","commercialName":"","cnpj":"21877676000138","city":"CURRAL NOVO DO PIAUÍ","stateCode":"PI","buscaAdicional":"VENTOS DE SAO ADEODATO 51124 VENTOS S VICENTE 13 908987 EOL.CV.PI.033139-2.01"},{"id":"25d9cdff-cfa0-420e-5c2f-08d5ad2bf6ba","name":"VENTOS DE SANTO AFONSO ENERGIAS RENOVAVEIS S.A","commercialName":"","cnpj":"21869347000145","city":"CURRAL NOVO DO PIAUÍ","stateCode":"PI","buscaAdicional":"VENTOS DE SANTO AFONSO 51136 VENTOS VICENTE 14 909014 EOL.CV.PI.033138-4.01"},{"id":"9b7d1d29-1129-4445-5c30-08d5ad2bf6ba","name":"VENTOS DE SANTO AGOSTINHO ENERGIAS RENOVAVEIS S.A","commercialName":"","cnpj":"21840567000146","city":"CURRAL NOVO DO PIAUÍ","stateCode":"PI","buscaAdicional":"VENTOS DE SANTO AGOSTINHO 51137 VENTOS S VICENTE 10 908984 EOL.CV.PI.033136-8.01"},{"id":"6742fd06-6fb4-4bb6-5c32-08d5ad2bf6ba","name":"VENTOS DE SANTA ALBERTINA ENERGIAS RENOVAVEIS S/A","commercialName":"","cnpj":"23037357000140","city":"CURRAL NOVO DO PIAUÍ","stateCode":"PI","buscaAdicional":"VENTOS DE SANTA ALBERTINA 51171 VENTOS S VICENTE 11 908985 EOL.CV.PI.033141-4.01"},{"id":"1a855eea-d2db-42d0-5c33-08d5ad2bf6ba","name":"VENTOS DE SANTO ALBERTO ENERGIAS RENOVAVEIS S.A","commercialName":"","cnpj":"21716502000193","city":"CURRAL NOVO DO PIAUÍ","stateCode":"PI","buscaAdicional":"VENTOS DE SANTO ALBERTO 51172 VENTOS S VICENTE 09 908983 EOL.CV.PI.033143-0.01"},{"id":"bf4d3d83-c5db-4c56-5c34-08d5ad2bf6ba","name":"VENTOS DE SAO CASIMIRO ENERGIAS RENOVAVEIS S.A","commercialName":"","cnpj":"21877685000129","city":"CURRAL NOVO DO PIAUÍ","stateCode":"PI","buscaAdicional":"VENTOS DE SAO CASIMIRO 51173 VENTOS S VICENTE 12 908986 EOL.CV.PI.033140-6.01"},{"id":"cb007695-f612-4ec1-5c35-08d5ad2bf6ba","name":"VENTOS DE SAO VINICIUS ENERGIAS RENOVAVEIS S.A","commercialName":"","cnpj":"21840617000195","city":"CURRAL NOVO DO PIAUÍ","stateCode":"PI","buscaAdicional":"VENTOS DE SAO VINICIUS 51174 VENTOS S VICENTE 08 908982 EOL.CV.PI.033144-9.01"},{"id":"2837bb62-fbb2-409b-886d-08d5ae44ed50","name":"ITAPISSUMA S/A","commercialName":"","cnpj":"11482080000185","city":"FRONTEIRAS","stateCode":"PI","buscaAdicional":"COG-ITAPISSUMA 6160 ITAPISSUMA - FRONTRA 72099"},{"id":"a1fc9f94-ed81-4b23-62aa-08d5ad2bf6ba","name":"CONDOMINIO PARNAIBA SHOPPING CENTER","commercialName":"CONDOMINIO PARNAIBA SHOPPING CENTER","cnpj":"18661514000153","city":"PARNAÍBA","stateCode":"PI","buscaAdicional":"PARNAIBASHOPPING 54912 PARNAIBA SHOPPING 906695"},{"id":"ffab2e61-764d-4f8b-627d-08d5ad2bf6ba","name":"SC2 SHOPPING RIO POTY LTDA","commercialName":"","cnpj":"12404376000140","city":"TERESINA","stateCode":"PI","buscaAdicional":"SHOP RIO POTY 54783 SHOP RIO POTY 905833"},{"id":"fc201540-e78c-4adb-6228-08d5ad2bf6ba","name":"TROUW NUTRITION BRASIL NUTRICAO ANIMAL LTDA","commercialName":"","cnpj":"03022008000813","city":"TERESINA","stateCode":"PI","buscaAdicional":"NUTRECO TERESINA 54599 NUTRECO TERESINA 908134"},{"id":"eee3593c-ab1e-4ca9-67a0-08d5ad2bf6ba","name":"CIALNE INDUSTRIA DE ALIMENTOS S A","commercialName":"","cnpj":"11072849000197","city":"TERESINA","stateCode":"PI","buscaAdicional":"DUDICO 58371 CIALNE INDUSTRIA 908506"},{"id":"a39afe3d-07d5-4f0d-4eed-08d5ad2bf6ba","name":"COMPANHIA ENERGETICA DO PIAUI","commercialName":"CEPISA","cnpj":"06840748000189","city":"TERESINA","stateCode":"PI","buscaAdicional":"CEPISA 22 CEPISA 26"},{"id":"d90c4c62-8e37-46f1-51d7-08d5ad2bf6ba","name":"COMVAP ACUCAR E ALCOOL LTDA","commercialName":"COMVAP","cnpj":"05343207000182","city":"UNIÃO","stateCode":"PI","buscaAdicional":"COMVAP 2618 COMVAP 8441 UTE.AI.PI.029773-9.01"},{"id":"e6d6e9fb-e7e5-4dba-5313-08d5ad2bf6ba","name":"NOVA EOLICA COQUEIRO S.A.","commercialName":"","cnpj":"11646832000104","city":"ACARAÚ","stateCode":"CE","buscaAdicional":"NOVA COQUEIRO 3468 COQUEIROS 20062 EOL.CV.CE.030282-1.01"},{"id":"1ef75e8e-2732-4eb3-5314-08d5ad2bf6ba","name":"NOVA EOLICA BURITI S.A.","commercialName":"","cnpj":"11646785000190","city":"ACARAÚ","stateCode":"CE","buscaAdicional":"NOVA BURITI 3470 NOVA BURITI 891362 EOL.CV.CE.030279-1.01"},{"id":"1d2bb547-5555-4f2f-5b4a-08d5ad2bf6ba","name":"CATAVENTOS ACARAU - GERACAO DE ENERGIAS RENOVAVEIS S.A.","commercialName":"CATAVENTOS ACARAU","cnpj":"10902268000172","city":"ACARAÚ","stateCode":"CE","buscaAdicional":"CATACARAU 50570 CATAVENTOS ACARAU I 913131 EOL.CV.CE.033756-0.01"},{"id":"dfca5856-5e37-44bb-600d-08d5ad2bf6ba","name":"TELHAS BARCELONA LTDA","commercialName":"TELHAS BARCELONA","cnpj":"10751056000131","city":"AIUABA","stateCode":"CE","buscaAdicional":"TELHAS BARCELONA 53359 TELHAS BARCELONA 905070"},{"id":"848c32b7-0330-480c-52d3-08d5ad2bf6ba","name":"CENTRAL GERADORA EOLICA ICARAI I S.A.","commercialName":"","cnpj":"11476987000131","city":"AMONTADA","stateCode":"CE","buscaAdicional":"ICARAI I 3324 ICARAI I 889184 EOL.CV.CE.030372-0.01"},{"id":"5dd471b6-d611-41f7-52d5-08d5ad2bf6ba","name":"CENTRAL GERADORA EOLICA ICARAI II S.A.","commercialName":"","cnpj":"11477001000148","city":"AMONTADA","stateCode":"CE","buscaAdicional":"ICARAI II 3326 ICARAI II 888953 EOL.CV.CE.030356-9.01"},{"id":"a59c2d77-04a1-4e1d-557f-08d5ad2bf6ba","name":"CENTRAL GERADORA EOLICA RIBEIRAO S.A.","commercialName":"","cnpj":"10656583000167","city":"AMONTADA","stateCode":"CE","buscaAdicional":"EOLOS-RIB 5714 RIBEIRAO EOLOS 893723 EOL.CV.CE.030695-9.01"},{"id":"09a096d8-89ee-47c1-5580-08d5ad2bf6ba","name":"CENTRAL GERADORA EOLICA PALMAS S.A.","commercialName":"","cnpj":"10656525000133","city":"AMONTADA","stateCode":"CE","buscaAdicional":"EOLOS-PAL 5716 BOCA DO CORREGO 893522 EOL.CV.CE.030697-5.01"},{"id":"35f314ec-1921-402c-5581-08d5ad2bf6ba","name":"CENTRAL GERADORA EOLICA ILHA GRANDE S.A.","commercialName":"","cnpj":"08624273000119","city":"AMONTADA","stateCode":"CE","buscaAdicional":"EOLOS-IG 5717 ILHA GRANDE 893503 EOL.CV.CE.030691-6.01"},{"id":"909909e9-04c3-4df8-541a-08d5ad2bf6ba","name":"EOLICA ICARAI GERACAO E COMERCIALIZACAO DE ENERGIA S/A","commercialName":"EOLICA ICARAI","cnpj":"12108854000175","city":"AMONTADA","stateCode":"CE","buscaAdicional":"EOLICA ICARAI 4011 ICARAI 20067 EOL.CV.CE.030289-9.01"},{"id":"4c6b4ed1-2f94-4271-607a-08d5ad2bf6ba","name":"L F S COMERCIO E IMPORTACAO DE ALIMENTOS LTDA","commercialName":"LAREDO FOOD SERVICE","cnpj":"15099833000129","city":"AQUIRAZ","stateCode":"CE","buscaAdicional":"LAREDO FOOD SERVICE 53528 L F S COMERCIO 905095"},{"id":"82fc6e85-0e5b-487a-5d4e-08d5ad2bf6ba","name":"FRESENIUS KABI BRASIL LTDA.","commercialName":"","cnpj":"49324221000880","city":"AQUIRAZ","stateCode":"CE","buscaAdicional":"FRESENIUS KABI 51777 FRESENIUS KABI 903982"},{"id":"413c07d2-5616-43d8-6642-08d5ad2bf6ba","name":"AMAZON TEMPER INDUSTRIA E COMERCIO DE VIDROS TEMPERADOS LTDA","commercialName":"AMAZON TEMPER","cnpj":"09177724000180","city":"AQUIRAZ","stateCode":"CE","buscaAdicional":"AMAZON AQUIRAZ 57451 AMAZON TEMPER CE 908748"},{"id":"de82e3d7-0e70-4b22-63c1-08d5ad2bf6ba","name":"BEACH PARK HOTEIS E TURISMO S/A","commercialName":"","cnpj":"11805397000105","city":"AQUIRAZ","stateCode":"CE","buscaAdicional":"BEACH PARK 55598 BEACH PARK - CORRENT 905976 BEACH PARK - OCEANI 906119 BEACH PARK ACQUA 906394 BEACH PARK HOTEIS 911974 BEACH PARK - ATLANTI 912372"},{"id":"0c1dc8c0-609e-46e5-5311-08d5ad2bf6ba","name":"CENTRAL EOLICA QUIXABA S.A.","commercialName":"","cnpj":"11646934000111","city":"ARACATI","stateCode":"CE","buscaAdicional":"QUIXABA 3466 QUIXABA 20056 EOL.CV.CE.030369-0.01"},{"id":"f537168d-38d0-4b06-5413-08d5ad2bf6ba","name":"LIBRA LIGAS DO BRASIL S/A","commercialName":"","cnpj":"10500221000182","city":"BANABUIÚ","stateCode":"CE","buscaAdicional":"LIBRA 3992 LIBRA-CE 71498"},{"id":"a5bd654f-60a1-4c82-8861-08d5ae44ed50","name":"ITAPUI BARBALHENSE INDUSTRIA DE CIMENTOS S/A","commercialName":"","cnpj":"07052194000118","city":"BARBALHA","stateCode":"CE","buscaAdicional":"COG-ITAPUICE 4497 ITAPUI-BARBALHA 71818"},{"id":"0b469142-b89b-4c6d-5d83-08d5ad2bf6ba","name":"RUBBERLOSS INDUSTRIA DE CALCADOS E COMPONENTES LTDA","commercialName":"","cnpj":"07861712000225","city":"CANINDÉ","stateCode":"CE","buscaAdicional":"RUBBERLOSS CANINDE 51844 RUBBERLOS CANINDE 907320"},{"id":"320b2f37-4efa-41d9-5d2c-08d5ad2bf6ba","name":"COMPANHIA SULAMERICANA DE CERAMICA","commercialName":"","cnpj":"15244677000142","city":"CAUCAIA","stateCode":"CE","buscaAdicional":"CSC 51726 CSC CAUCAIA CE 900915"},{"id":"b639b8cf-3bff-4b23-5cc1-08d5ad2bf6ba","name":"ACO CEARENSE INDUSTRIAL LTDA EM RECUPERACAO JUDICIAL","commercialName":"","cnpj":"00990842000138","city":"CAUCAIA","stateCode":"CE","buscaAdicional":"ACO CEARENSE INDUSTRIAL MATRIZ 51557 ACO CEARENSE FILIAL 898711 ACO CEARENSE MATRIZ 899575"},{"id":"cd53c0b3-3ff6-488a-5343-08d5ad2bf6ba","name":"COMPANHIA INDUSTRIAL DE CIMENTO APODI","commercialName":"","cnpj":"10260249000270","city":"CAUCAIA","stateCode":"CE","buscaAdicional":"CIMENTO APODI 3542 CIMENTO APODI 69 KV 71429"},{"id":"89733716-4c87-4cd0-4f38-08d5ad2bf6ba","name":"CGTF CENTRAL GERADORA TERMELETRICA FORTALEZA S.A.","commercialName":"ENEL","cnpj":"04659917000153","city":"CAUCAIA","stateCode":"CE","buscaAdicional":"CGTF 140 FORTALEZA 8012 UTE.GN.CE.028357-6.01"},{"id":"e7790284-5c44-4a02-62af-08d5ad2bf6ba","name":"AERIS INDUSTRIA E COMERCIO DE EQUIPAMENTOS PARA GERACAO DE ENERGIA S.A","commercialName":"","cnpj":"12528708000107","city":"CAUCAIA","stateCode":"CE","buscaAdicional":"AERIS 54920 AERIS - CAUCAIA - CE 906621"},{"id":"9f637438-0fe7-4c40-633a-08d5ad2bf6ba","name":"TECLAV - TECNOLOGIA E LAVAGEM INDUSTRIAL LTDA","commercialName":"TECLAV","cnpj":"05945932000120","city":"EUSÉBIO","stateCode":"CE","buscaAdicional":"TECLAV 55252 TECLAV 905071"},{"id":"19dffa0a-be40-4544-5049-08d5ad2bf6ba","name":"M DIAS BRANCO S.A. INDUSTRIA E COMERCIO DE ALIMENTOS","commercialName":"FABRICA FORTALEZA","cnpj":"07206816000115","city":"EUSÉBIO","stateCode":"CE","buscaAdicional":"MDB-FABRICA FORTALEZA 1556 M DIAS BRANCO IND 899806"},{"id":"2a5c8974-7323-4e3b-5774-08d5ad2bf6ba","name":"TRES CORACOES ALIMENTOS S.A.","commercialName":"","cnpj":"63310411000101","city":"EUSÉBIO","stateCode":"CE","buscaAdicional":"TRES CORACOES ALIMENTOS 8853 3 CORACOES REFRESCO 901199 3 CORACOES EUZEBIO 901218 TRES CORACOES - NOVO 911651 3 CORACOES MOINHO 901198"},{"id":"8c4b9b14-0e4e-40d9-5ede-08d5ad2bf6ba","name":"HACO ETIQUETAS DO NORDESTE LTDA","commercialName":"","cnpj":"02179938000146","city":"EUSÉBIO","stateCode":"CE","buscaAdicional":"HACO ETIQUETAS NOR 52591 HACO ETIQUETAS CE 900975"},{"id":"f86704ed-964f-479e-5f83-08d5ad2bf6ba","name":"IPADE - INSTITUTO PARA O DESENVOLVIMENTO DA EDUCACAO LTDA.","commercialName":"","cnpj":"04102843000150","city":"FORTALEZA","stateCode":"CE","buscaAdicional":"UNICHRISTUS 53007 UNICHRISTUS PQ ECOL 903114 UNICHRISTUS DOM LUIS 903220"},{"id":"6ac5049d-ef91-4c81-6052-08d5ad2bf6ba","name":"CONDOMINIO DO SHOPPING CENTER IGUATEMI","commercialName":"","cnpj":"73870891000100","city":"FORTALEZA","stateCode":"CE","buscaAdicional":"SHOP IGUATEMI FORTALEZA 53465 SHOP IGUATEMI FORTAL 904323"},{"id":"b9f48622-47a1-41f0-5e27-08d5ad2bf6ba","name":"SUBCONDOMINIO SHOPPING CENTER RIOMAR FORTALEZA","commercialName":"","cnpj":"21399573000100","city":"FORTALEZA","stateCode":"CE","buscaAdicional":"RIOMAR FORTALEZA 52237 RIOMAR FORTALEZA 900840"},{"id":"7e49edf3-6173-47e5-5e2a-08d5ad2bf6ba","name":"UNIMED FORTALEZA SOCIEDADE COOPERATIVA MEDICA LTDA","commercialName":"HOSPITAL REGIONAL UNIMED","cnpj":"05868278000280","city":"FORTALEZA","stateCode":"CE","buscaAdicional":"UNIMED FORTALEZA 52240 UNIMED FORTALEZA 901064"},{"id":"bbedc43b-410d-484c-5a6a-08d5ad2bf6ba","name":"FOTOWATIO DO BRASIL PROJETOS DE ENERGIAS RENOVAVEIS LTDA","commercialName":"","cnpj":"17026946000120","city":"FORTALEZA","stateCode":"CE","buscaAdicional":"FRV MASSAPE 17448"},{"id":"4275fd6a-8bb6-44a5-5c61-08d5ad2bf6ba","name":"MWN COMERCIAL DE ALIMENTOS LTDA","commercialName":"","cnpj":"04601165000170","city":"FORTALEZA","stateCode":"CE","buscaAdicional":"SUPER LAGOA MATRIZ 51290 SUPER LAGOA 2000 902594 SUPER LAGOA SOBRAL 902656 SUP LAGOA PARAGANBA 902690 SUPER LAGOA JUAZEIRO 902703 SUPER LAGOA - NORTH 911898 SUPER LAGOA - MESSEJ 911975 SUPER LAGOA L.C 912031 SUPER LAGOA MATRIZ 912357 SUPER LAGOA - IGUATU 912375 SUPER LAGOA - R.T 912516"},{"id":"0581a1ac-1076-4066-5be1-08d5ad2bf6ba","name":"M DIAS BRANCO S.A. INDUSTRIA E COMERCIO DE ALIMENTOS","commercialName":"DIVISAO GME - GORDURAS E MARGARINAS ESPECIAIS","cnpj":"07206816002835","city":"FORTALEZA","stateCode":"CE","buscaAdicional":"MDB-GME 50971 M DIAS BRANCO GME 899734"},{"id":"c196f16b-3a02-49b3-5be3-08d5ad2bf6ba","name":"M DIAS BRANCO S.A. INDUSTRIA E COMERCIO DE ALIMENTOS","commercialName":"FILIAL MOINHO DIAS BRANCO","cnpj":"07206816002401","city":"FORTALEZA","stateCode":"CE","buscaAdicional":"MDB MOINHO MUCURIPE 50973 DIAS BRANCO MUCURI 905729"},{"id":"6f16dac6-ebb2-44b6-5910-08d5ad2bf6ba","name":"ASSOCIACAO DO CONDOMINIO DO NORTH SHOPPING JOQUEI","commercialName":"","cnpj":"17801130000126","city":"FORTALEZA","stateCode":"CE","buscaAdicional":"ACNP 13654 NORTH JOCKEY ACNP 893082"},{"id":"f73cbe35-53af-4e4b-583e-08d5ad2bf6ba","name":"VIA SUL CONDOMINIO","commercialName":"","cnpj":"10322099000100","city":"FORTALEZA","stateCode":"CE","buscaAdicional":"VSC 11089 VSC FORTALEZA 889954"},{"id":"93efd162-0292-4fe3-585a-08d5ad2bf6ba","name":"HOTEIS SEARA LTDA","commercialName":"PONTA MAR HOTEL","cnpj":"10353107000177","city":"FORTALEZA","stateCode":"CE","buscaAdicional":"HOTEIS SEARA 11450 HOTEIS SEARA 890215 HOTEIS SEARA PRAIANO 890216 HOTEIS SEARA SEARA 890217"},{"id":"5fd2297f-9204-4e6f-59d3-08d5ad2bf6ba","name":"VENTOS DE SAO CLEMENTE I ENERGIAS RENOVAVEIS S.A","commercialName":"","cnpj":"21014004000107","city":"FORTALEZA","stateCode":"CE","buscaAdicional":"SAO CLEMENTE I 15655 SAO CLEMENTE I 899082 EOL.CV.PE.031818-3.01"},{"id":"30912ed5-f906-4c5d-59d4-08d5ad2bf6ba","name":"VENTOS DE SAO CLEMENTE II ENERGIAS RENOVAVEIS S.A","commercialName":"","cnpj":"21014134000131","city":"FORTALEZA","stateCode":"CE","buscaAdicional":"SAO CLEMENTE II 15656 SAO CLEMENTE II 899092 EOL.CV.PE.031819-1.01"},{"id":"722144fa-504d-47aa-59d5-08d5ad2bf6ba","name":"VENTOS DE SAO CLEMENTE III ENERGIAS RENOVAVEIS S.A","commercialName":"","cnpj":"21014090000140","city":"FORTALEZA","stateCode":"CE","buscaAdicional":"SAO CLEMENTE III 15657 SAO CLEMENTE III 899093 EOL.CV.PE.031820-5.01"},{"id":"0ff56dac-b10f-4769-59d6-08d5ad2bf6ba","name":"VENTOS DE SAO CLEMENTE IV ENERGIAS RENOVAVEIS S.A","commercialName":"","cnpj":"21013854000182","city":"FORTALEZA","stateCode":"CE","buscaAdicional":"SAO CLEMENTE IV 15658 SAO CLEMENTE IV 899095 EOL.CV.PE.031821-3.01"},{"id":"23222b90-8fef-405b-59d7-08d5ad2bf6ba","name":"VENTOS DE SAO CLEMENTE VI ENERGIAS RENOVAVEIS S.A","commercialName":"","cnpj":"21013968000122","city":"FORTALEZA","stateCode":"CE","buscaAdicional":"SAO CLEMENTE VI 15659 SAO CLEMENTE VI 899127 EOL.CV.PE.031823-0.01"},{"id":"de5dc2d7-01b7-43d4-59d8-08d5ad2bf6ba","name":"VENTOS DE SAO CLEMENTE V ENERGIAS RENOVAVEIS S.A","commercialName":"","cnpj":"21013993000106","city":"FORTALEZA","stateCode":"CE","buscaAdicional":"SAO CLEMENTE V 15660 SAO CLEMENTE V 899677 EOL.CV.PE.031822-1.01"},{"id":"ba5587a8-4a9a-444a-59d9-08d5ad2bf6ba","name":"VENTOS DE SAO CLEMENTE VIII ENERGIAS RENOVAVEIS S.A","commercialName":"","cnpj":"21013880000100","city":"FORTALEZA","stateCode":"CE","buscaAdicional":"SAO CLEMENTE VIII 15661 SAO CLEMENTE VIII 899370 EOL.CV.PE.031825-6.01"},{"id":"3a3f858a-1573-41e7-59da-08d5ad2bf6ba","name":"VENTOS DE SAO CLEMENTE VII ENERGIAS RENOVAVEIS S.A","commercialName":"","cnpj":"21013833000167","city":"FORTALEZA","stateCode":"CE","buscaAdicional":"SAO CLEMENTE VII 15662 SAO CLEMENTE VII 899700 EOL.CV.PE.031824-8.01"},{"id":"af2cadc8-183d-42b3-5999-08d5ad2bf6ba","name":"COMPANHIA INDUSTRIAL DE CIMENTO APODI","commercialName":"","cnpj":"10260249000190","city":"FORTALEZA","stateCode":"CE","buscaAdicional":"CIMENTO APODI MATRIZ 15075 CIMENTO APODI 894602"},{"id":"89bdd351-4667-4322-5772-08d5ad2bf6ba","name":"MAIS SABOR INDUSTRIA E COMERCIO DE REFRIGERANTES EIRELI","commercialName":"","cnpj":"07196579000159","city":"FORTALEZA","stateCode":"CE","buscaAdicional":"MAIS SABOR 8851 MAIS SABOR 892245"},{"id":"a7e7fc4e-3dd9-454c-577a-08d5ad2bf6ba","name":"NORSA REFRIGERANTES S.A","commercialName":"","cnpj":"07196033000106","city":"FORTALEZA","stateCode":"CE","buscaAdicional":"NORSA REFR 8949 NORSA MACAIBA 71345 NORSA VITORIA DA CON 889863 NORSA SUAPE 889131 NORSA MARACANAU 890633 REFRI GUARARAPES 72439 NORSA TERESINA PI 906947 NORSA SIMOES FILHO 901460 NORSA - PETROLINA 72435 NORSA VARZEA GRANDE 889706 NORSA - MACEIO - AL 912511"},{"id":"c361df03-3bd5-46eb-5794-08d5ad2bf6ba","name":"BOM VIZINHO DISTRIBUIDORA DE ALIMENTOS LTDA.","commercialName":"PINHEIRO SUPERMERCADO - O BOM VIZINHO","cnpj":"04163766000148","city":"FORTALEZA","stateCode":"CE","buscaAdicional":"BOM VIZINHO 9071 BOM VIZINHO SOBRAL 889011 BOM VIZINHO MESEJANA 889012 BOM VIZINHO LIM NOR 889044 BOM VIZINHO ITAPIPOC 889064 BOM VIZINHO MONDUBIM 889065 BOM VIZINHO 889066 PINHEIRO WS CE 898631 PINHEIRO SOBRAL 898674 PINHEIRO CD 898691 PINHEIRO QUIXADA 898951 PAN AMERICANO CE 899053"},{"id":"c4bac46f-b0f9-496c-579d-08d5ad2bf6ba","name":"ASSOCIACAO DOS LOJISTAS DO NORTH SHOPPING","commercialName":"","cnpj":"41456690000175","city":"FORTALEZA","stateCode":"CE","buscaAdicional":"NORTH SHOPPING 9190 NORTH SHOPPING 889996"},{"id":"87f2affc-b284-4d8d-5720-08d5ad2bf6ba","name":"MARQUISE EMPREENDIMENTOS S/A","commercialName":"","cnpj":"07406242000129","city":"FORTALEZA","stateCode":"CE","buscaAdicional":"GRAN MARQUISE 8230 MARQUISE CE 901000"},{"id":"014dc281-739f-4675-55ba-08d5ad2bf6ba","name":"NP BRASIL SERVICOS E PROJETOS EIRELI","commercialName":"","cnpj":"67959015000152","city":"FORTALEZA","stateCode":"CE","buscaAdicional":"NEOPLASTIC 6039 NEOPLASTIC 2 889678"},{"id":"bd92d956-1cfe-486a-547a-08d5ad2bf6ba","name":"METALGRAFICA CEARENSE S/A MECESA EM RECUPERACAO JUDICIAL","commercialName":"MECESA","cnpj":"07203615000164","city":"FORTALEZA","stateCode":"CE","buscaAdicional":"ELN-MECESA 4294 MECESA-FORTALEZA CE 71636"},{"id":"9de7af46-d601-4ad9-5472-08d5ad2bf6ba","name":"UNITEXTIL UNIAO INDUSTRIAL TEXTIL S A","commercialName":"FABRICA SANTA INES","cnpj":"07203904000163","city":"FORTALEZA","stateCode":"CE","buscaAdicional":"UNITEXTIL 4258 UNITEXTIL-FORTALEZA 71525"},{"id":"f751c617-233a-468a-557a-08d5ad2bf6ba","name":"EOLOS ENERGIAS RENOVAVEIS SA","commercialName":"EOLOS ENERGIAS RENOVAVEIS SA","cnpj":"12959267000190","city":"FORTALEZA","stateCode":"CE","buscaAdicional":"EOLOS 5693"},{"id":"ad7d658c-a8f1-4f37-5525-08d5ad2bf6ba","name":"GERADORA EOLICA BONS VENTOS DA SERRA I S.A.","commercialName":"","cnpj":"14080223000110","city":"FORTALEZA","stateCode":"CE","buscaAdicional":"EOL BONSVENTOS 5148 MALHADINHA 1 893283 EOL.CV.CE.030841-2.01"},{"id":"ea3ada77-b4d4-4142-507e-08d5ad2bf6ba","name":"TBM - TEXTIL BEZERRA DE MENEZES S/A","commercialName":"","cnpj":"07671092000180","city":"FORTALEZA","stateCode":"CE","buscaAdicional":"TBM UNIDADE 1 1653 TBM UN 1 FORTALEZA 7161 TBM UN 3 MARACANAU 7159"},{"id":"9ee02d4d-6bc2-4c37-4ef3-08d5ad2bf6ba","name":"COMPANHIA ENERGETICA DO CEARA","commercialName":"ENEL","cnpj":"07047251000170","city":"FORTALEZA","stateCode":"CE","buscaAdicional":"COELCE 31 COELCE 21"},{"id":"2f07cf8d-885f-4b21-52fc-08d5ad2bf6ba","name":"VENTOS BRASIL GERACAO E COMERCIALIZACAO DE ENERGIA ELETRICA S.A.","commercialName":"VENTOS BRASIL","cnpj":"09283886000100","city":"FORTALEZA","stateCode":"CE","buscaAdicional":"VENTOS 3422 D. DE PARACURU (VEN) 20034 EOL.CV.CE.030299-6.01"},{"id":"cd0ad6ad-5db5-4991-516d-08d5ad2bf6ba","name":"J MACEDO S/A","commercialName":"","cnpj":"14998371000119","city":"FORTALEZA","stateCode":"CE","buscaAdicional":"J MACEDO NE 2166 J MACEDO-SJC 71106 J MACEDO SALV MASSAS 71384 J. MACEDO SA 907097 J MACEDO FORTALEZA 71386 J MACEDO LONDRINA 902654"},{"id":"44740b59-ea54-478f-633d-08d5ad2bf6ba","name":"COMPANHIA DE ALIMENTOS DO NORDESTE CIALNE","commercialName":"GRANJAS CIALNE","cnpj":"07220874000101","city":"FORTALEZA","stateCode":"CE","buscaAdicional":"CIALNE 55255 CIA DE ALIMENTOS NE 907359 CIALNE 27 908029 CIALNE 30 908030 CIALNE 3A 908042 CIALNE 9005125 908343 CIALNE 9000238 908357 CIALNE 46 908389 CIALNE 6 CON 908401 CIALNE AQUIRAZ 908412"},{"id":"c9b2459e-f981-4ecb-6345-08d5ad2bf6ba","name":"HOLANDA ARTE INTERIOR E EMPREENDIMENTOS LTDA","commercialName":"HOLANDA ARTE INTERIOR","cnpj":"07884489000150","city":"FORTALEZA","stateCode":"CE","buscaAdicional":"HOLANDA 55285 HOLANDA 908083 HOLANDA MARAPONGA 908092"},{"id":"317a3272-c7a1-4175-624f-08d5ad2bf6ba","name":"INTEGRAL AGROINDUSTRIAL LTDA","commercialName":"","cnpj":"01588099000157","city":"FORTALEZA","stateCode":"CE","buscaAdicional":"INTEGRAL AGRO 54679 INTEGRAL AGRO 905093 INTEGRAL AGRO 2 905094"},{"id":"a7343149-1ad3-4c1c-6250-08d5ad2bf6ba","name":"MINALBA ALIMENTOS E BEBIDAS LTDA","commercialName":"","cnpj":"54505052000149","city":"FORTALEZA","stateCode":"CE","buscaAdicional":"MINALBA 54680 MINALBA ALIMENTOS 905173"},{"id":"298144b3-8529-48d3-6166-08d5ad2bf6ba","name":"FAE SISTEMAS DE MEDICAO S/A","commercialName":"","cnpj":"07281413000130","city":"FORTALEZA","stateCode":"CE","buscaAdicional":"FAE 54174 FAE SISTEMA DE MED 905728"},{"id":"f6c445c0-a586-4d2d-639b-08d5ad2bf6ba","name":"CONSORCIO SHOPPING PARANGABA","commercialName":"CONSORCIO SHOPPING PARANGABA","cnpj":"18788033000103","city":"FORTALEZA","stateCode":"CE","buscaAdicional":"SHOPPING PARANGABA 55481 CONS SHOP PARANGABA 906980"},{"id":"0a40f7be-e113-4b16-63a7-08d5ad2bf6ba","name":"GRANDE MOINHO CEARENSE SA","commercialName":"","cnpj":"07199805000155","city":"FORTALEZA","stateCode":"CE","buscaAdicional":"MOINHO CEARENSE 55502 GRANDE MOINHO CEARA 907347"},{"id":"e8e9405d-86a8-4582-638c-08d5ad2bf6ba","name":"SUPER MERCADO DO POVO LTDA","commercialName":"","cnpj":"10389021000102","city":"FORTALEZA","stateCode":"CE","buscaAdicional":"SUPER DO POVO 55462 SUPER DO POVO - LOJA 905974 SUPER DO POVO - LOJA 905975 SUPER DO POVO LJ 02 907328 SUPER DO POVO LJ 05 907330 SUPER DO POVO LJ 01 907354 SUPER DO POVO LJ 03 907355 SUPER DO POVO LJ 07 907357"},{"id":"86137f5a-d878-4ebd-8864-08d5ae44ed50","name":"TECNEIRA ACARAU GERACAO E COMERCIALIZACAO DE ENERGIA ELETRICA S. A.","commercialName":"TECNEIRA ACARAU","cnpj":"14518485000114","city":"FORTALEZA","stateCode":"CE","buscaAdicional":"TECNEIRA ACARA 5155"},{"id":"88dfff9d-6b53-4fdd-8858-08d5ae44ed50","name":"PRECABURA SERVICOS DE LIMPEZA LTDA","commercialName":"","cnpj":"12749260000143","city":"FORTALEZA","stateCode":"CE","buscaAdicional":"GRYPS 4044 SERRA (GRYPS) 8255 CGH.PH.RJ.029324-5.01 CASCATA (GRYPS) 8258 CGH.PH.RJ.030103-5.01"},{"id":"fdb387c0-8585-4fe2-6929-08d5ad2bf6ba","name":"PASSAMANARIA DO NORDESTE SA","commercialName":"PASSAMANARIA","cnpj":"07295413000190","city":"FORTALEZA","stateCode":"CE","buscaAdicional":"PASSAMANARIA 60813 PASSAMANARIA 910916"},{"id":"34d9d165-4501-4a3a-681c-08d5ad2bf6ba","name":"AMENDOAS DO BRASIL LTDA","commercialName":"","cnpj":"03196885000134","city":"FORTALEZA","stateCode":"CE","buscaAdicional":"AMENDOAS DO BRASIL 59354 AMENDOAS DO BRASIL 910258"},{"id":"59877eb5-84d3-438f-67c8-08d5ad2bf6ba","name":"CONDOMINIO SHOPPING BENFICA","commercialName":"CONDOMINIO SHOPPING BENFICA","cnpj":"05206443000157","city":"FORTALEZA","stateCode":"CE","buscaAdicional":"SHOPPING BENFICA 58633 SHOPPING BENFICA 908854"},{"id":"2c496e5e-8276-45d2-6861-08d5ad2bf6ba","name":"HOSPITAL SAO CARLOS LTDA","commercialName":"","cnpj":"11794674000121","city":"FORTALEZA","stateCode":"CE","buscaAdicional":"HOSPITAL SAO CARLOS 59891 HOSP SAO CARLOS 909634"},{"id":"ba69146a-9221-4e4e-6624-08d5ad2bf6ba","name":"FUNDACAO EDSON QUEIROZ","commercialName":"","cnpj":"07373434000186","city":"FORTALEZA","stateCode":"CE","buscaAdicional":"UNIFOR 57371 FUND EDSON QUEIROZ 907349 FUND EDSON QUEIROZ C 907350"},{"id":"8938d072-6604-4f5d-65f5-08d5ad2bf6ba","name":"NACIONAL GAS BUTANO DISTRIBUIDORA LTDA","commercialName":"","cnpj":"06980064000182","city":"FORTALEZA","stateCode":"CE","buscaAdicional":"NACIONAL GAS 57236 NACIONAL GAS BUTANO 907322 NGB FORTALEZA 908413 NGB SUAPE 911335 NGB PARANA 911696 NGB_DUQUE DE CAXIAS 911712 NGB MAUA 911757 NGB BARUERI 911778 NGB CANOAS 911891 NACIONAL GAS BUTANO 913581"},{"id":"75e2dbaa-715f-4130-65ff-08d5ad2bf6ba","name":"INDAIA BRASIL AGUAS MINERAIS LTDA","commercialName":"INDAIA","cnpj":"00048785000172","city":"FORTALEZA","stateCode":"CE","buscaAdicional":"INDAIA 57260 INDAIA AGUA MINERAL 907509 INDAIA HORIZONTE 913498"},{"id":"8a2a195c-1f79-4d7c-6600-08d5ad2bf6ba","name":"NACIONAL ARCO-IRIS INDUSTRIA E COMERCIO DE TINTAS LTDA","commercialName":"","cnpj":"09320639000129","city":"FORTALEZA","stateCode":"CE","buscaAdicional":"HIPERCOR 57261 NACIONAL ARCOIRIS 907374"},{"id":"e9f5bfbb-7158-4deb-6601-08d5ad2bf6ba","name":"TELEVISAO VERDES MARES LTDA","commercialName":"","cnpj":"07199664000170","city":"FORTALEZA","stateCode":"CE","buscaAdicional":"TV VERDES MARES 57262 TV VERDES MARES 907326"},{"id":"4ac9080e-d411-4645-6594-08d5ad2bf6ba","name":"BETANIA LACTEOS S.A.","commercialName":"BETANIA LACTEOS","cnpj":"10483444000189","city":"FORTALEZA","stateCode":"CE","buscaAdicional":"CBL FORTALEZA 56835 CBL ALIMENTOS 72422 CBL FORTALEZA 907353"},{"id":"f40b4f5e-6f86-49df-67b7-08d5ad2bf6ba","name":"CENTRO EMPRESARIAL DEL PASEO","commercialName":"CENTRO EMPRESARIAL DEL PASEO","cnpj":"04014647000123","city":"FORTALEZA","stateCode":"CE","buscaAdicional":"DEL PASEO 58534 DEL PASEO -FORTALEZA 911897"},{"id":"c0326507-5238-4d1e-67bd-08d5ad2bf6ba","name":"HOSPITAL SAO MATEUS LTDA.","commercialName":"","cnpj":"41580077000165","city":"FORTALEZA","stateCode":"CE","buscaAdicional":"HOSPITAL SAO MATEUS LTDA 58596 HOSPITAL SAO MATEUS 910900"},{"id":"558c9f33-b04c-4196-677e-08d5ad2bf6ba","name":"CEARA SERVICOS DE ATENDIMENTO AO CIDADAO S/A","commercialName":"","cnpj":"18778783000102","city":"FORTALEZA","stateCode":"CE","buscaAdicional":"CEARA CIDADAO 58224 CEARA CID ANTONIO BE 908501 CEARA CID MESSEJANA 908502 CEARA CID JUAZEIRO 908503 CEARA CID SOBRAL 908504"},{"id":"dda37fbf-003b-40b4-6732-08d5ad2bf6ba","name":"ADTALEM EDUCACIONAL DO BRASIL S/A","commercialName":"ADTALEM BRASIL","cnpj":"03681572000171","city":"FORTALEZA","stateCode":"CE","buscaAdicional":"FANOR DUNAS 57999 DEVRY EDUCACIONAL 911222"},{"id":"c17e4b45-85ff-476d-6811-08d5d153df4d","name":"HAPVIDA PARTICIPACOES E INVESTIMENTOS S/A","commercialName":"","cnpj":"05197443000138","city":"FORTALEZA","stateCode":"CE","buscaAdicional":""},{"id":"ee8dc93b-f9af-4695-8da8-08d5d060706e","name":"SUPERMERCADO GUARA LTDA","commercialName":"SUPERMERCADO GUARA","cnpj":"04675604000199","city":"FORTALEZA","stateCode":"CE","buscaAdicional":"SUPERMERCADO GUARA 62210 SUPER GUARA EUSEBIO 913306 SUPER GUARA PARANGAB 913325 SUPER GUARA - JACARE 913326"},{"id":"8bc3285c-78bb-46e1-7401-08d5cf600bef","name":"FTL - FERROVIA TRANSNORDESTINA LOGISTICA S.A","commercialName":"FTL","cnpj":"17234244000131","city":"FORTALEZA","stateCode":"CE","buscaAdicional":""},{"id":"3ce85754-0437-453c-a406-08d5d085fadd","name":"GUARARAPES CONFECCOES S/A","commercialName":"","cnpj":"08402943001477","city":"FORTALEZA","stateCode":"CE","buscaAdicional":""},{"id":"fbf712ff-498a-42e7-72b5-08d5cf600bef","name":"COMPANHIA DE AGUA E ESGOTO DO CEARA CAGECE","commercialName":"CAGECE","cnpj":"07040108000157","city":"FORTALEZA","stateCode":"CE","buscaAdicional":""},{"id":"4740c5d2-20e3-4857-72ae-08d5cf600bef","name":"EMPREENDIMENTOS PAGUE MENOS S/A","commercialName":"FARMACIA PAGUE MENOS","cnpj":"06626253000151","city":"FORTALEZA","stateCode":"CE","buscaAdicional":""},{"id":"78f38f51-f9b7-4556-72ba-08d5cf600bef","name":"BANCO DO NORDESTE DO BRASIL SA","commercialName":"BNB","cnpj":"07237373000120","city":"FORTALEZA","stateCode":"CE","buscaAdicional":""},{"id":"b7a92922-56de-48ab-72bb-08d5cf600bef","name":"CARBOMIL SA MINERACAO E INDUSTRIA","commercialName":"HIDROQUIM","cnpj":"07253321000147","city":"FORTALEZA","stateCode":"CE","buscaAdicional":""},{"id":"4e679d74-15b6-4e1f-72bc-08d5cf600bef","name":"PETROLEO E LUBRIFICANTES DO NORDESTE S A PETROLUSA","commercialName":"PETROLUSA","cnpj":"07275159000168","city":"FORTALEZA","stateCode":"CE","buscaAdicional":""},{"id":"8bb247bb-962f-466d-72bd-08d5cf600bef","name":"MARINA DE IRACEMA PARK S A","commercialName":"","cnpj":"07334600000135","city":"FORTALEZA","stateCode":"CE","buscaAdicional":""},{"id":"8408f980-0aed-47b6-7247-08d5cf600bef","name":"TRANSNORDESTINA LOGISTICA S.A","commercialName":"","cnpj":"02281836000137","city":"FORTALEZA","stateCode":"CE","buscaAdicional":""},{"id":"b970b5e9-d3d6-4aef-88b3-08d5ae44ed50","name":"FOTOWATIO DO BRASIL PROJETOS DE ENERGIAS RENOVAVEIS III LTDA","commercialName":"","cnpj":"17344867000167","city":"FORTALEZA","stateCode":"CE","buscaAdicional":"FRV BANABUIU 17447"},{"id":"8b75ce0b-240d-416f-88d6-08d5ae44ed50","name":"CALILA ADMINISTRACAO E COMERCIO S A","commercialName":"","cnpj":"07204217000162","city":"FORTALEZA","stateCode":"CE","buscaAdicional":"CALILA 52914"},{"id":"ed0a7b4e-09ca-4016-6717-08d5ad2bf6ba","name":"ESTRELA SUPERMERCADO LTDA","commercialName":"ESTRELA SUPERMERCADO LTDA","cnpj":"07671198000184","city":"HORIZONTE","stateCode":"CE","buscaAdicional":"ESTRELA SUPERMERCADO 57955 ESTRELA HORIZONTE 909799 ESTRELA FORTALEZA 909800 ESTRELA PACAJUS 909801 ESTRELA CAUCAIA 909899"},{"id":"225bc989-7d00-4004-503c-08d5ad2bf6ba","name":"SANTANA TEXTIL S A","commercialName":"","cnpj":"72418478000147","city":"HORIZONTE","stateCode":"CE","buscaAdicional":"SANTANA 1531 SANTANA TEXTIL HORIZ 7929"},{"id":"e58ca678-620a-449d-5418-08d5ad2bf6ba","name":"VULCABRAS AZALEIA - CE, CALCADOS E ARTIGOS ESPORTIVOS S/A","commercialName":"VULCABRAS AZALEIA","cnpj":"00954394000117","city":"HORIZONTE","stateCode":"CE","buscaAdicional":"VULCABRAS 4005 VULCABRAS 71375"},{"id":"40726fa4-e022-4c52-598f-08d5ad2bf6ba","name":"GERADORA EOLICA BONS VENTOS DA SERRA 2 S.A.","commercialName":"GERADORA EOLICA BONS VENTOS DA SERRA 2 S.A.","cnpj":"19953139000188","city":"IBIAPINA","stateCode":"CE","buscaAdicional":"BONS VENTOS DA SERRA 2 14875 EOL B VEN CACIMBAS 4 908891 EOL.CV.CE.031621-0.01 EOL B VEN CACIMBAS 5 908892 EOL.CV.CE.031579-6.01 EOL B VEN CACIMBAS 3 908870 EOL.CV.CE.031627-0.01 EOL B VEN CACIMBAS 2 908869 EOL.CV.CE.031644-0.01 EOL B VEN CACIMBAS 7 908893 EOL.CV.CE.031611-3.01"},{"id":"6fdd9903-204d-4267-6793-08d5ad2bf6ba","name":"CENTRAL EOLICA SAO RAIMUNDO S.A.","commercialName":"","cnpj":"10408112000130","city":"ICAPUÍ","stateCode":"CE","buscaAdicional":"SAO RAIMUNDO I5 58313 EOL SAO RAIMUNDO 910901 EOL.CV.CE.035219-5.01"},{"id":"e81d4612-b453-43db-6883-08d5ad2bf6ba","name":"CENTRAL EOLICA GARROTE S.A.","commercialName":"","cnpj":"10272489000104","city":"ICAPUÍ","stateCode":"CE","buscaAdicional":"GARROTE 60107 EOL GARROTE 910915 EOL.CV.CE.035197-0.01"},{"id":"ec15250f-5408-495d-6898-08d5ad2bf6ba","name":"CENTRAL EOLICA SANTO INACIO IV S.A.","commercialName":"","cnpj":"11738349000141","city":"ICAPUÍ","stateCode":"CE","buscaAdicional":"SANTO INACIO IV 60192 SANTO INACIO IV 910931 EOL.CV.CE.031866-3.01"},{"id":"4a7b8cec-29f8-4443-6899-08d5ad2bf6ba","name":"CENTRAL EOLICA SANTO INACIO III S.A.","commercialName":"","cnpj":"12009141000154","city":"ICAPUÍ","stateCode":"CE","buscaAdicional":"SANTO INACIO III 60193 SANTO INACIO III 910932 EOL.CV.CE.035217-9.01"},{"id":"461a9931-ecaa-455f-652c-08d5ad2bf6ba","name":"SUPERMERCADO MAE RAINHA LTDA","commercialName":"SUPERMERCADO MAE RAINHA","cnpj":"05377917000123","city":"ITAITINGA","stateCode":"CE","buscaAdicional":"MAE RAINHA 56575 SUP MAE RAINHA ITATI 908070 SUP MAE RAINHA SGONC 908091 SUP MAE RAINHA MARAC 908094"},{"id":"0e921bb3-2ecc-457e-5cc9-08d5ad2bf6ba","name":"PAQUETA CALCADOS LTDA","commercialName":"","cnpj":"01098983000103","city":"ITAPAGÉ","stateCode":"CE","buscaAdicional":"PAQUETA CALCADOS 51568 PAQUETA CALCADOS 901575 PAQUETA URUBURETAMA 908757 PAQUETA ITAPAJE 908758"},{"id":"bc3b2ed0-af38-4529-606e-08d5ad2bf6ba","name":"DASS NORDESTE CALCADOS E ARTIGOS ESPORTIVOS S.A.","commercialName":"","cnpj":"01287588000179","city":"ITAPIPOCA","stateCode":"CE","buscaAdicional":"DASS CALCADOS 53505 DASS NORDESTE CALCAD 902193 DASS NE CALC E ART 904320 DASS NE CALCADOS 904467 DASS NE CALC E ART E 904681 DASS ITABERABA 909327 DASS VDC CONFECCAO 910554"},{"id":"c25c9b81-a11b-4ea3-6136-08d5ad2bf6ba","name":"DUCOCO PRODUTOS ALIMENTICIOS S/A","commercialName":"DUCOCO","cnpj":"09426032000128","city":"ITAPIPOCA","stateCode":"CE","buscaAdicional":"DUCOCO CE 54056 DUCOCO PRODUTOS 905738"},{"id":"a2d7dbfa-127d-405f-5312-08d5ad2bf6ba","name":"NOVA EOLICA CAJUCOCO S.A.","commercialName":"","cnpj":"11646760000197","city":"ITAREMA","stateCode":"CE","buscaAdicional":"NOVA CAJUCOCO 3467 NOVA CAJUCOCO 20061 EOL.CV.CE.030294-5.01"},{"id":"bcb5aaae-6421-4d30-5a9b-08d5ad2bf6ba","name":"NOVA FIACAO INDUSTRIA TEXTIL LTDA","commercialName":"NOVA FIACAO","cnpj":"18067083000100","city":"JAGUARUANA","stateCode":"CE","buscaAdicional":"NOVAFIACAO 50104 NOVA FIACAO 897167"},{"id":"02c47adc-37ce-4a8c-88d4-08d5ae44ed50","name":"OKYTA MINERACAO LTDA","commercialName":"","cnpj":"09140853000101","city":"JAGUARUANA","stateCode":"CE","buscaAdicional":"OKYTA MINERACAO 52727"},{"id":"0bf96f84-2bae-4ced-1cd5-08d5b8870181","name":"CAJUINA SAO GERALDO LTDA","commercialName":"","cnpj":"06942221000165","city":"JUAZEIRO DO NORTE","stateCode":"CE","buscaAdicional":"CAJUINA SAO GERALDO 62187 CAJUINA SAO GERALDO 912864"},{"id":"cbb16dac-8c90-4480-6378-08d5ad2bf6ba","name":"CONDOMINIO DO EDIFICIO CARIRI SHOPPING CENTER","commercialName":"CARIRI SHOPPING CENTER","cnpj":"03575205000193","city":"JUAZEIRO DO NORTE","stateCode":"CE","buscaAdicional":"SHOP CARIRI 55379 SHOP CARIRI 905072"},{"id":"8cecca3b-dd50-4212-637f-08d5ad2bf6ba","name":"DELFA INDUSTRIA E COM.DE ACESSORIOS DO VESTUARIO LTDA","commercialName":"","cnpj":"06037585000109","city":"MARACANAÚ","stateCode":"CE","buscaAdicional":"DELFA 55412 DELFA IND E COM ACES 905973"},{"id":"df3f795f-296c-47ea-687d-08d5ad2bf6ba","name":"TINTAS HIDRACOR S/A","commercialName":"","cnpj":"04706416000180","city":"MARACANAÚ","stateCode":"CE","buscaAdicional":"HIDRACOR 60101 HIDRACOR UCHA 910127 HIDRACOR MATRIZ 910146"},{"id":"dcfb157e-2ff0-4612-6946-08d5ad2bf6ba","name":"ISOPLAST INDUSTRIA E COMERCIO DE PLASTICOS LTDA","commercialName":"","cnpj":"72273436000165","city":"MARACANAÚ","stateCode":"CE","buscaAdicional":"ISOPLAST 60955 ISOPLAST 912015"},{"id":"89819bcc-af4e-4056-6972-08d5ad2bf6ba","name":"BEATRIZ TEXTIL S/A","commercialName":"","cnpj":"23464852000135","city":"MARACANAÚ","stateCode":"CE","buscaAdicional":"BEATRIZ TEXTIL 61670 BEATRIZ TEXTIL 912515"},{"id":"dd74e705-3378-46ae-6595-08d5ad2bf6ba","name":"NEW PLASTIC INDUSTRIA E COMERCIO DE PLASTICOS LTDA","commercialName":"","cnpj":"20593185000100","city":"MARACANAÚ","stateCode":"CE","buscaAdicional":"NEW PLASTIC 56836 NEW PLASTIC COMERCIO 907325"},{"id":"3a6e7efc-de91-4374-65e9-08d5ad2bf6ba","name":"POLE ALIMENTOS LTDA","commercialName":"","cnpj":"03282301000143","city":"MARACANAÚ","stateCode":"CE","buscaAdicional":"POLE ALIMENTOS 57193 POLE ALIMENTOS LTDA 907786 POLE ALIMENTOS AQUIR 907750"},{"id":"8766efc0-f9dc-4cfa-5a93-08d5ad2bf6ba","name":"CANDENGO ENERGIAS RENOVAVEIS LTDA","commercialName":"","cnpj":"22454143000106","city":"MARACANAÚ","stateCode":"CE","buscaAdicional":"CANDENGO 50088 PCH CANDENGO 907840 PCH.PH.BA.033901-6.01"},{"id":"8c00c877-f917-4b92-5a5c-08d5ad2bf6ba","name":"VENTOS DE SAO VIRGILIO 02 ENERGIAS RENOVAVEIS S.A","commercialName":"","cnpj":"21480086000177","city":"MARACANAÚ","stateCode":"CE","buscaAdicional":"VENTOS DE SAO VIRGILIO 02 17404 VENTOS S VIRGILIO 02 907432 EOL.CV.PI.033667-0.01"},{"id":"71f0a73e-0941-467a-5bae-08d5ad2bf6ba","name":"MARACANAU SHOPPING CENTER","commercialName":"SHOPPING MARACANAU","cnpj":"05825973000183","city":"MARACANAÚ","stateCode":"CE","buscaAdicional":"MSC 50827 MARACANAU SHOPPING 899599"},{"id":"bb87fc33-c96c-4882-5c25-08d5ad2bf6ba","name":"CERAMICA BRASILEIRA CERBRAS LTDA","commercialName":"","cnpj":"35029057000106","city":"MARACANAÚ","stateCode":"CE","buscaAdicional":"CERBRAS 51118 CERAMICA BRASILEIRA 899078"},{"id":"60348fcb-084b-4470-592c-08d5ad2bf6ba","name":"TROUW NUTRITION BRASIL NUTRICAO ANIMAL LTDA","commercialName":"","cnpj":"03022008000732","city":"MARACANAÚ","stateCode":"CE","buscaAdicional":"NUTRECO 13995 NUTRECO CE 894702"},{"id":"b262b94a-92c6-4fcd-5949-08d5ad2bf6ba","name":"VENTOS DE SANTA JOANA I ENERGIAS RENOVAVEIS S.A","commercialName":"","cnpj":"19724929000191","city":"MARACANAÚ","stateCode":"CE","buscaAdicional":"SANTAJOANA I 14228 EOL SANTA JOANA I 896944 EOL.CV.PI.031581-8.01"},{"id":"6a7ccac7-6cc1-4f9d-594a-08d5ad2bf6ba","name":"VENTOS DE SANTA JOANA III ENERGIAS RENOVAVEIS S.A","commercialName":"","cnpj":"19725354000121","city":"MARACANAÚ","stateCode":"CE","buscaAdicional":"SANTAJOANA III 14229 EOL SANTA JOANA III 896947 EOL.CV.PI.031580-0.01"},{"id":"4e166740-fe83-4f54-594b-08d5ad2bf6ba","name":"VENTOS DE SANTA JOANA IV ENERGIAS RENOVAVEIS S.A","commercialName":"","cnpj":"19725614000169","city":"MARACANAÚ","stateCode":"CE","buscaAdicional":"SANTAJOANA IV 14230 EOL SANTA JOANA IV 896964 EOL.CV.PI.031520-6.01"},{"id":"79a2fe4c-1877-4f10-594c-08d5ad2bf6ba","name":"VENTOS DE SANTA JOANA V ENERGIAS RENOVAVEIS S.A","commercialName":"","cnpj":"19725631000104","city":"MARACANAÚ","stateCode":"CE","buscaAdicional":"SANTAJOANA V 14231 EOL SANTA JOANA V 896948 EOL.CV.PI.031538-9.01"},{"id":"239d48db-a079-43ff-594d-08d5ad2bf6ba","name":"VENTOS DE SANTA JOANA VII ENERGIAS RENOVAVEIS S.A","commercialName":"","cnpj":"19725315000124","city":"MARACANAÚ","stateCode":"CE","buscaAdicional":"SANTAJOANA VII 14232 EOL SANTA JOANA VII 896949 EOL.CV.PI.031597-4.01"},{"id":"a28fca85-363d-4ae4-5947-08d5ad2bf6ba","name":"VENTOS DE SANTO AUGUSTO IV ENERGIAS RENOVAVEIS S.A","commercialName":"","cnpj":"19781992000160","city":"MARACANAÚ","stateCode":"CE","buscaAdicional":"SANTOAUGUSTO IV 14225 SANTO AUGUSTO IV 896950 EOL.CV.PI.031603-2.01"},{"id":"7b0cbbfb-e97d-431a-59ba-08d5ad2bf6ba","name":"VENTOS DE SANTO AUGUSTO I ENERGIAS RENOVAVEIS S.A","commercialName":"VENTOS DE SAO FLORIANO","cnpj":"15674987000105","city":"MARACANAÚ","stateCode":"CE","buscaAdicional":"VENTOS STO AUGUSTO I 15455 VENTOS STO AUGUSTO I 907803 EOL.CV.PI.031746-2.02"},{"id":"945f0326-950c-4920-59bb-08d5ad2bf6ba","name":"VENTOS DE SANTO AUGUSTO II ENERGIAS RENOVAVEIS S.A","commercialName":"VENTOS DE SAO JOAQUIM","cnpj":"15673911000157","city":"MARACANAÚ","stateCode":"CE","buscaAdicional":"VENTOS STO AUGUSTO II 15456 SANTO AUGUSTO II 906764 EOL.CV.PI.031747-0.02"},{"id":"9c266aaf-8c89-4bb2-59bc-08d5ad2bf6ba","name":"VENTOS DE SANTO AUGUSTO VI ENERGIAS RENOVAVEIS S.A","commercialName":"VENTOS DE SAO JUSTINO","cnpj":"15673793000187","city":"MARACANAÚ","stateCode":"CE","buscaAdicional":"VENTOS STO AUGUSTO VI 15457 V SANTO AUGUSTO VI 907839 EOL.CV.PI.031766-7.01"},{"id":"f56932f5-276b-4872-59bd-08d5ad2bf6ba","name":"VENTOS DE SANTO AUGUSTO VII ENERGIAS RENOVAVEIS S.A","commercialName":"VENTOS DE SAO LEONARDO","cnpj":"15673881000189","city":"MARACANAÚ","stateCode":"CE","buscaAdicional":"VENTOS STO AUGUSTO VII 15458 VENTOS STO AUGUSTO 7 907804 EOL.CV.PI.031749-7.01"},{"id":"664ce8df-2da7-44d4-59be-08d5ad2bf6ba","name":"VENTOS DE SANTO AUGUSTO VIII ENERGIAS RENOVAVEIS S.A","commercialName":"","cnpj":"14676003000154","city":"MARACANAÚ","stateCode":"CE","buscaAdicional":"VENTOS STO AUGUSTO VIII 15459 SANTO AUGUSTO VIII 906762 EOL.CV.PI.031767-5.0"},{"id":"af3ee227-e867-46c2-59bf-08d5ad2bf6ba","name":"VENTOS DE SANTO ESTEVAO I ENERGIAS RENOVAVEIS S.A","commercialName":"","cnpj":"16712566000186","city":"MARACANAÚ","stateCode":"CE","buscaAdicional":"VENTOS STO ESTEVAO I 15460 SANTO ESTEVAO I 908907 EOL.CV.PE.031761-6.01"},{"id":"3b5a200d-05a1-43ce-59c0-08d5ad2bf6ba","name":"VENTOS DE SANTO ESTEVAO II ENERGIAS RENOVAVEIS S.A","commercialName":"VENTOS DE SAO QUIRINO","cnpj":"16603387000100","city":"MARACANAÚ","stateCode":"CE","buscaAdicional":"VENTOS STO ESTEVAO II 15461 SANTO ESTEVAO II 908534 EOL.CV.PE.031762-4.01"},{"id":"8bfd2098-954d-4a69-59c1-08d5ad2bf6ba","name":"VENTOS DE SANTO ESTEVAO III ENERGIAS RENOVAVEIS S.A","commercialName":"VENTOS DE SAO RAIMUNDO","cnpj":"15674836000149","city":"MARACANAÚ","stateCode":"CE","buscaAdicional":"VENTOS STO ESTEVAO III 15462 SANTO ESTEVAO III 906153 EOL.CV.PE.031763-2.01"},{"id":"7002a0d4-5929-40a1-59c2-08d5ad2bf6ba","name":"VENTOS DE SANTO ESTEVAO V ENERGIAS RENOVAVEIS S.A","commercialName":"VENTOS DE SAO SILVERIO","cnpj":"15674805000198","city":"MARACANAÚ","stateCode":"CE","buscaAdicional":"VENTOS STO ESTEVAO V 15463 SANTO ESTEVAO V 906154 EOL.CV.PE.031764-0.01"},{"id":"fed1058b-ed70-4d25-5a35-08d5ad2bf6ba","name":"VENTOS DE SANTO ESTEVAO IV ENERGIAS RENOVAVEIS S.A","commercialName":"","cnpj":"21480026000154","city":"MARACANAÚ","stateCode":"CE","buscaAdicional":"VENTOS DE SANTO ESTEVAO IV 17217 VENTOS STO ESTEVAO 4 909805 EOL.CV.PE.032365-9.01"},{"id":"db011b6b-a05a-447c-5a3c-08d5ad2bf6ba","name":"VENTOS DE SAO VIRGILIO 01 ENERGIAS RENOVAVEIS S.A","commercialName":"","cnpj":"21479982000116","city":"MARACANAÚ","stateCode":"CE","buscaAdicional":"VENTOS DE SAO VIRGILIO 01 17233 SAO VIRGILIO 01 908210 EOL.CV.PI.032367-5.01"},{"id":"d22c4e9a-93de-4f40-5a3d-08d5ad2bf6ba","name":"VENTOS DE SAO VIRGILIO 03 ENERGIAS RENOVAVEIS S.A","commercialName":"","cnpj":"21480051000138","city":"MARACANAÚ","stateCode":"CE","buscaAdicional":"VENTOS DE SAO VIRGILIO 03 17234 VENTOS S VIRGILIO 03 909382 EOL.CV.PI.032368-3.01"},{"id":"63906893-a4ea-472a-5a3e-08d5ad2bf6ba","name":"VENTOS DE SANTO ONOFRE IV ENERGIAS RENOVAVEIS S.A","commercialName":"","cnpj":"21480328000122","city":"MARACANAÚ","stateCode":"CE","buscaAdicional":"VENTOS DE SANTO ONOFRE IV 17235 V SANTO ONOFRE 4 908209 EOL.CV.PI.032366-7.01"},{"id":"01e5c5ce-7179-4426-5869-08d5ad2bf6ba","name":"CASA DOS VENTOS ENERGIAS RENOVAVEIS S/A","commercialName":"","cnpj":"10772867000119","city":"MARACANAÚ","stateCode":"CE","buscaAdicional":"CASA DOS VENTOS 11689"},{"id":"b829fd6c-bc76-4b7a-58e9-08d5ad2bf6ba","name":"VENTOS DE SANTA JOANA VIII ENERGIAS RENOVAVEIS S.A.","commercialName":"VENTOS DE SANTA JOANA VIII ENERGIAS RENOVAVEIS S.A.","cnpj":"19022356000154","city":"MARACANAÚ","stateCode":"CE","buscaAdicional":"VENTOS DE SANTA JOANA VIII 13466 SANTA JOANA VIII 896526 EOL.CV.PI.031366-1.01"},{"id":"351c0cd2-0dd0-4a4a-58ea-08d5ad2bf6ba","name":"VENTOS DE SANTA JOANA XIV ENERGIAS RENOVAVEIS S.A.","commercialName":"VENTOS DE SANTA JOANA XIV ENERGIAS RENOVAVEIS S.A.","cnpj":"19023513000146","city":"MARACANAÚ","stateCode":"CE","buscaAdicional":"VENTOS DE SANTA JOANA XIV 13472 SANTA JOANA XIV 896546 EOL.CV.PI.031368-8.01"},{"id":"77229270-18fb-4a81-58eb-08d5ad2bf6ba","name":"VENTOS DE SANTA JOANA VI ENERGIAS RENOVAVEIS S.A.","commercialName":"VENTOS DE SANTA JOANA VI ENERGIAS RENOVAVEIS S.A.","cnpj":"19022818000133","city":"MARACANAÚ","stateCode":"CE","buscaAdicional":"VENTOS DE SANTA JOANA VI 13473 SANTA JOANA VI 896527 EOL.CV.PI.031367-0.01"},{"id":"4ffe53d3-f306-47f8-58ec-08d5ad2bf6ba","name":"VENTOS DE SANTA JOANA II ENERGIAS RENOVAVEIS S.A.","commercialName":"VENTOS DE SANTA JOANA II ENERGIAS RENOVAVEIS S.A.","cnpj":"19023213000167","city":"MARACANAÚ","stateCode":"CE","buscaAdicional":"VENTOS DE SANTA JOANA II 13474 SANTA JOANA II 896528 EOL.CV.PI.031361-0.01"},{"id":"dabab06d-a3b6-4a78-58ed-08d5ad2bf6ba","name":"VENTOS DE SANTO ONOFRE III ENERGIAS RENOVAVEIS S.A.","commercialName":"VENTOS DE SANTO ONOFRE III ENERGIAS RENOVAVEIS S.A.","cnpj":"19023342000155","city":"MARACANAÚ","stateCode":"CE","buscaAdicional":"VENTOS DE SANTO ONOFRE III 13475 SANTO ONOFRE III 896524 EOL.CV.PI.031886-8.02"},{"id":"cc2acf3b-6a43-4cb7-58ee-08d5ad2bf6ba","name":"VENTOS DE SANTO ONOFRE II ENERGIAS RENOVAVEIS S.A.","commercialName":"VENTOS DE SANTO ONOFRE II ENERGIAS RENOVAVEIS S.A.","cnpj":"19022974000102","city":"MARACANAÚ","stateCode":"CE","buscaAdicional":"VENTOS DE SANTO ONOFRE II 13476 SANTO ONOFRE II 896525 EOL.CV.PI.031362-9.01"},{"id":"97085d7a-20a3-4082-58ef-08d5ad2bf6ba","name":"VENTOS DE SANTO ONOFRE I ENERGIAS RENOVAVEIS S.A.","commercialName":"VENTOS DE SANTO ONOFRE ENERGIAS RENOVAVEIS S.A.","cnpj":"19022138000110","city":"MARACANAÚ","stateCode":"CE","buscaAdicional":"VENTOS DE SANTO ONOFRE I 13477 SANTO ONOFRE 1 896545 EOL.CV.PI.031364-5.01"},{"id":"5a856e70-ac2c-4b64-5cda-08d5ad2bf6ba","name":"D R LING INDUSTRIA E COMERCIO S/A","commercialName":"D R LING","cnpj":"00119633000113","city":"MARACANAÚ","stateCode":"CE","buscaAdicional":"DR LING 51591 DR LING 901052"},{"id":"3084ba07-58f2-4c87-5351-08d5ad2bf6ba","name":"COBAP COMERCIO E BENEFICIAMENTO DE ARTEFATOS DE PAPEL EIRELI","commercialName":"COBAP","cnpj":"07329386000129","city":"MARACANAÚ","stateCode":"CE","buscaAdicional":"COBAP 3576 COBAP 71269"},{"id":"8c7935af-08d7-44e6-5330-08d5ad2bf6ba","name":"TBM TEXTIL - INDUSTRIA E COMERCIO S.A.","commercialName":"","cnpj":"05435483000170","city":"MARACANAÚ","stateCode":"CE","buscaAdicional":"TBM UNIDADE 5 3503 TBM 5 RONDONOPOLIS 71228"},{"id":"8c67ec47-522a-4ba9-5178-08d5ad2bf6ba","name":"MARACANAU GERADORA DE ENERGIA S/A","commercialName":"MARACANAU GERADORA DE ENERGIA","cnpj":"09047261000131","city":"MARACANAÚ","stateCode":"CE","buscaAdicional":"UTE MARACANAU 2197 MARACANAU I 8569 UTE.PE.CE.029654-6.01"},{"id":"2b96c55f-9be1-4f66-5020-08d5ad2bf6ba","name":"VICUNHA TEXTIL S/A.","commercialName":"VICUNHA","cnpj":"07332190000193","city":"MARACANAÚ","stateCode":"CE","buscaAdicional":"VICUNHA IV 1459 VICUNHA TEXT MARACA 7845 VICUNHA I FIA MARACA 7854 VICUNHA I TEC MARACA 7856 VICUNHA III PACAJUS 7858 VICUNHA TEXTIL 2 70839"},{"id":"7d472e81-6074-43f8-5021-08d5ad2bf6ba","name":"DURAMETAL LTDA","commercialName":"","cnpj":"07041007000109","city":"MARACANAÚ","stateCode":"CE","buscaAdicional":"DURAMETAL 1460 DURAMETAL CE 7847"},{"id":"9d6c8eb2-0238-4bb8-5078-08d5ad2bf6ba","name":"COTECE S.A.","commercialName":"COTECE","cnpj":"06054647000182","city":"MARACANAÚ","stateCode":"CE","buscaAdicional":"COTECE 1641 COTECE-MARACANAU-CE 70048"},{"id":"5ee2e0ef-d5eb-448a-50b4-08d5ad2bf6ba","name":"TEXTIL UNIAO S A","commercialName":"","cnpj":"07971955000135","city":"MARACANAÚ","stateCode":"CE","buscaAdicional":"TEXTIL UNIAO 1788 TEXT UNIAO MTZ MARAC 70286"},{"id":"1ef51dd3-fbd9-4faa-539e-08d5ad2bf6ba","name":"FRIOCEARA ARMAZENS FRIGORIFICOS LTDA","commercialName":"","cnpj":"63303887000107","city":"MARACANAÚ","stateCode":"CE","buscaAdicional":"FRIOCEARA 3731 FRIOCEARA 71377"},{"id":"3c3e5b28-e1cc-42ad-53cb-08d5ad2bf6ba","name":"ESMALTEC S/A","commercialName":"","cnpj":"02948030000230","city":"MARACANAÚ","stateCode":"CE","buscaAdicional":"ESMALTEC SA 3856 ESMALTECSA-MARACANAU 71574"},{"id":"4fb97cc8-923e-4713-5523-08d5ad2bf6ba","name":"SANTA HELENA ENERGIAS RENOVAVEIS S.A","commercialName":"","cnpj":"12053929000168","city":"MARACANAÚ","stateCode":"CE","buscaAdicional":"SANTAHELENA 5128 SANTA HELENA 893424 EOL.CV.RN.030834-0.01"},{"id":"c338ff03-a251-42a2-5524-08d5ad2bf6ba","name":"SANTA MARIA ENERGIAS RENOVAVEIS S.A","commercialName":"","cnpj":"12053787000139","city":"MARACANAÚ","stateCode":"CE","buscaAdicional":"SANTAMARIA 5129 SM (SANTA MARIA) 893422 EOL.CV.RN.030864-1.01"},{"id":"c4a82b9b-a9b8-4830-55b9-08d5ad2bf6ba","name":"OSASUNA PARTICIPACOES LTDA.","commercialName":"OSASUNA","cnpj":"03941904000100","city":"MARACANAÚ","stateCode":"CE","buscaAdicional":"JANGADEIRO 6038 COG JANGADEIRO 72068"},{"id":"0c974946-7e58-4a30-560c-08d5ad2bf6ba","name":"CIA METALIC NORDESTE","commercialName":"","cnpj":"01183070000195","city":"MARACANAÚ","stateCode":"CE","buscaAdicional":"METALIC 6557 METALIC 888348"},{"id":"c2ac41f3-efcf-499c-56b9-08d5ad2bf6ba","name":"ANCORA DISTRIBUIDORA LTDA","commercialName":"SUPER ANCORA","cnpj":"03879760000109","city":"MARACANAÚ","stateCode":"CE","buscaAdicional":"SUPER FRANGOLA 7541 SUPER FRANGOLA 888985 SF FREI MANSUETO 888987 SF PADRE GUERRA 888988 SF CAPITAO VALDEMAR 889063 SF ANCORA ITAPERI 899668 ANCORA ALVARO WAYNE 899676 ANCORA ARACATI 899699 ANCORA TIANGUA 899980 ANCORA MONTE CASTELO 900133 ANCORA EUSEBIO 905479 ANCORA CD 912356"},{"id":"b557b098-514e-482b-6453-08d5ad2bf6ba","name":"CESDE INDUSTRIA E COMERCIO DE ELETRODOMESTICOS LTDA","commercialName":"CESDE LTDA","cnpj":"00153282000167","city":"MARANGUAPE","stateCode":"CE","buscaAdicional":"MALLORY 55933 CESDE ELETRODOMESTIC 907324"},{"id":"8e635391-a9af-4852-5d07-08d5ad2bf6ba","name":"COOPERSHOES - COOPERATIVA DE TRABALHO E INDUSTRIA DE CALCADOS JOANETENSE LTDA","commercialName":"","cnpj":"02675611000750","city":"MORADA NOVA","stateCode":"CE","buscaAdicional":"COOPERSHOES CEARA 51681 COOPERSHOES CEARA 904096"},{"id":"3c71629c-38d3-47f8-5e6c-08d5ad2bf6ba","name":"RIGESA DO NORDESTE INDUSTRIA DE EMBALAGENS LTDA","commercialName":"","cnpj":"00310707000102","city":"PACAJUS","stateCode":"CE","buscaAdicional":"RIGESA NORDESTE 52381 RIGESA NORDESTE 901510"},{"id":"c2690384-2cfa-41c7-603c-08d5ad2bf6ba","name":"ZANOTTI PACATUBA INDUSTRIA E COMERCIO DE ARTIGOS TEXTEIS LTDA","commercialName":"","cnpj":"10892699000103","city":"PACATUBA","stateCode":"CE","buscaAdicional":"ZANOTTI PACATUBA 53433 ZANOTTI PACATUBA 905731"},{"id":"e6c961ac-35a7-4f9f-5b3f-08d5ad2bf6ba","name":"ALLIANCE QUIMICA INDUSTRIA E COMERCIO LTDA","commercialName":"ALLIANCE INDUSTRIA E COMERCIO","cnpj":"14980121000151","city":"PACATUBA","stateCode":"CE","buscaAdicional":"ALLIANCE 50536 ALLIANCE QUIMICA 899554"},{"id":"fb8f854e-9fcb-4737-5500-08d5ad2bf6ba","name":"MECESA EMBALAGENS S/A EM RECUPERACAO JUDICIAL","commercialName":"","cnpj":"04794651000151","city":"PACATUBA","stateCode":"CE","buscaAdicional":"ELN-EMBALAGENS 4749 MECESA EMB PACATUBA 71899"},{"id":"383234e4-3074-4b9d-5cae-08d5ad2bf6ba","name":"PAQUETA CALCADOS LTDA","commercialName":"","cnpj":"01098983000707","city":"PENTECOSTE","stateCode":"CE","buscaAdicional":"PAQUETA PENTECOSTE 51504 PAQUETA CALCADOS CE 902735"},{"id":"2fcb1eea-a321-4329-5473-08d5ad2bf6ba","name":"COMPANHIA BRASILEIRA DE BEBIDAS PREMIUM","commercialName":"","cnpj":"09325874000193","city":"PINDORETAMA","stateCode":"CE","buscaAdicional":"COG-CBBPCE 4259 C BRASILEIRA BEBIDAS 71553"},{"id":"91791df3-a6b3-417c-67a3-08d5ad2bf6ba","name":"CARBOMIL QUIMICA S A","commercialName":"","cnpj":"07645062000523","city":"QUIXERÉ","stateCode":"CE","buscaAdicional":"CARBOMIL 58376 OKYTA MINERACAO 903777"},{"id":"2b5361e2-f228-4a68-67de-08d5ad2bf6ba","name":"DSM PRODUTOS NUTRICIONAIS BRASIL S.A.","commercialName":"","cnpj":"56992951000572","city":"SÃO GONÇALO DO AMARANTE","stateCode":"CE","buscaAdicional":"DSM SAO GONCALO 58738 DSM PECEM - SAO GONC 910145"},{"id":"5ee73d2d-9b6c-476a-5190-08d5ad2bf6ba","name":"PORTO DO PECEM GERACAO DE ENERGIA S/A","commercialName":"PORTO DO PECEM GERACAO DE ENERGIA S/A","cnpj":"08976495000109","city":"SÃO GONÇALO DO AMARANTE","stateCode":"CE","buscaAdicional":"ENERGIA PECEM 2375 ESTEIRA PECEM 912337 PORTO PECEM I 8904 UTE.CM.CE.029720-8.01"},{"id":"fe6ee848-2084-4286-51e9-08d5ad2bf6ba","name":"PECEM II GERACAO DE ENERGIA S. A.","commercialName":"","cnpj":"10471487000144","city":"SÃO GONÇALO DO AMARANTE","stateCode":"CE","buscaAdicional":"MPX PECEM II 2716 PORTO DO PECEM II 888070 UTE.CM.CE.030098-5.01"},{"id":"9aea9810-71c4-4472-52ce-08d5ad2bf6ba","name":"CENTRAL GERADORA EOLICA TAIBA ANDORINHA S.A.","commercialName":"","cnpj":"11477020000174","city":"SÃO GONÇALO DO AMARANTE","stateCode":"CE","buscaAdicional":"ANDORINHA 3319 TAIBA ANDORINHA 889182 EOL.CV.CE.030373-9.01"},{"id":"b5ca76dc-0b6b-4e0d-52cf-08d5ad2bf6ba","name":"CENTRAL GERADORA EOLICA COLONIA S.A.","commercialName":"","cnpj":"11476958000170","city":"SÃO GONÇALO DO AMARANTE","stateCode":"CE","buscaAdicional":"COLONIA 3320 COLONIA 889183 EOL.CV.CE.030295-3.01"},{"id":"0000de06-c574-4a2c-52d2-08d5ad2bf6ba","name":"CENTRAL GERADORA EOLICA TAIBA AGUIA S.A.","commercialName":"","cnpj":"11477009000104","city":"SÃO GONÇALO DO AMARANTE","stateCode":"CE","buscaAdicional":"TAIBA AGUIA 3323 TAIBA AGUIA 888684 EOL.CV.CE.028857-8.01"},{"id":"2c0d080b-9d5b-4f07-59fd-08d5ad2bf6ba","name":"CSP - COMPANHIA SIDERURGICA DO PECEM","commercialName":"","cnpj":"09509535000167","city":"SÃO GONÇALO DO AMARANTE","stateCode":"CE","buscaAdicional":"CSP 16276 CSP (CONSUMO) 896164 UTE CSP 904686 UTE.FL.CE.031241-0.01"},{"id":"473c9029-32ba-4c89-5a80-08d5ad2bf6ba","name":"CONDOMINIO NORTH SHOPPING SOBRAL","commercialName":"","cnpj":"15179694000143","city":"SOBRAL","stateCode":"CE","buscaAdicional":"NORTH SHOPPING SOBRAL 49844 NORTH SHOPING SOBRAL 897368"},{"id":"badd23a9-cf85-45f9-536d-08d5ad2bf6ba","name":"GRENDENE S A","commercialName":"","cnpj":"89850341000160","city":"SOBRAL","stateCode":"CE","buscaAdicional":"GRENDENE 3633 GRENDENE I 71191 GRENDENE II 71192 GRENDENE FORTALEZA 71409 GRENDENE CRATO 71410 GRENDENE SOBRAL 71408"},{"id":"11a6e1b9-ba14-45df-6454-08d5ad2bf6ba","name":"BEPLAST NORDESTE INDUSTRIA E COMERCIO DE PLASTICOS LTDA","commercialName":"","cnpj":"02313082000150","city":"SOBRAL","stateCode":"CE","buscaAdicional":"BEPLAST NE 55934 BEPLAST SOBRAL 907964"},{"id":"2f2bc221-8c35-4263-5457-08d5ad2bf6ba","name":"TAUA GERACAO DE ENERGIA LTDA.","commercialName":"MPX TAUA ENERGIA SOLAR LTDA","cnpj":"09193216000195","city":"TAUÁ","stateCode":"CE","buscaAdicional":"MPX TAUA 4175 TAUA 8858 UFV.RS.CE.030060-8.01"},{"id":"71027b26-4c0d-4b2c-5425-08d5ad2bf6ba","name":"NOVA VENTOS DE TIANGUA ENERGIAS RENOVAVEIS S.A","commercialName":"","cnpj":"12773911000130","city":"TIANGUÁ","stateCode":"CE","buscaAdicional":"TIANGUA 4031 EOL TIANGUA 904175 EOL.CV.CE.030585-5.01"},{"id":"87491d54-82bc-4b91-5426-08d5ad2bf6ba","name":"NOVA VENTOS DE TIANGUA NORTE ENERGIAS RENOVAVEIS S.A","commercialName":"","cnpj":"12773953000171","city":"TIANGUÁ","stateCode":"CE","buscaAdicional":"TIANGUA NORTE 4032 EOL TIANGUA NORTE 904176 EOL.CV.CE.030584-7.01"},{"id":"df6762c1-da34-46ce-5422-08d5ad2bf6ba","name":"NOVA VENTOS DO MORRO DO CHAPEU ENERGIAS RENOVAVEIS S.A","commercialName":"","cnpj":"12774017000185","city":"TIANGUÁ","stateCode":"CE","buscaAdicional":"MORRO CHAPEU 4028 EOL MORRO DO CHAPEU 904193 EOL.CV.CE.030582-0.01"},{"id":"1c00dd66-de56-4088-886e-08d5ae44ed50","name":"NOVA VENTOS DE SAO SEBASTIAO ENERGIAS RENOVAVEIS S.A","commercialName":"","cnpj":"13346139000133","city":"TIANGUÁ","stateCode":"CE","buscaAdicional":"SAO SEBASTIAO 6558"},{"id":"b2637ae5-0bee-414c-886f-08d5ae44ed50","name":"NOVA VENTOS DE SANTA ROSA ENERGIAS RENOVAVEIS S.A","commercialName":"","cnpj":"12056188000179","city":"TIANGUÁ","stateCode":"CE","buscaAdicional":"SANTA ROSA EN 6559"},{"id":"8cd7ff8f-2b58-4836-8870-08d5ae44ed50","name":"NOVA VENTOS DE SANTO INACIO ENERGIAS RENOVAVEIS S.A","commercialName":"","cnpj":"13346117000173","city":"TIANGUÁ","stateCode":"CE","buscaAdicional":"SANTO INACIO 6560"},{"id":"e295fd7d-27f8-47b5-8871-08d5ae44ed50","name":"NOVA VENTOS DE SAO GERALDO ENERGIAS RENOVAVEIS S.A","commercialName":"","cnpj":"13312601000181","city":"TIANGUÁ","stateCode":"CE","buscaAdicional":"SAO GERALDO 6561"},{"id":"9dc90856-b2d3-4e0a-1ca9-08d5b8870181","name":"ADEL COCO BRASIL INDUSTRIA E COMERCIO LTDA","commercialName":"","cnpj":"10567693000152","city":"TRAIRI","stateCode":"CE","buscaAdicional":"ADEL COCO 60652 ADEL COCO 912596"},{"id":"dcf2eded-479d-43b8-55f2-08d5ad2bf6ba","name":"CENTRAL EOLICA SAO CRISTOVAO S.A.","commercialName":"","cnpj":"10272500000136","city":"TRAIRI","stateCode":"CE","buscaAdicional":"CGE SC 6370 SAO CRISTOVAO 892121 EOL.CV.CE.030912-5.01"},{"id":"5941ea8a-101a-459e-55f3-08d5ad2bf6ba","name":"CENTRAL EOLICA SAO JORGE S.A.","commercialName":"","cnpj":"09571485000148","city":"TRAIRI","stateCode":"CE","buscaAdicional":"CGE SJ 6371 SAO JORGE CE 892253 EOL.CV.CE.030911-7.01"},{"id":"81fbd887-9349-4e50-55f4-08d5ad2bf6ba","name":"CENTRAL EOLICA SANTO ANTONIO DE PADUA S.A.","commercialName":"","cnpj":"09601233000114","city":"TRAIRI","stateCode":"CE","buscaAdicional":"CGE SA 6372 STO ANTONIO DE PADUA 892326 EOL.CV.CE.030916-8.01"},{"id":"faec54f1-e8e8-4b28-52ea-08d5ad2bf6ba","name":"EOLICA FAISA I - GERACAO E COMERCIALIZACAO DE ENERGIA S.A.","commercialName":"EOLICA FAISA I","cnpj":"11619268000122","city":"TRAIRI","stateCode":"CE","buscaAdicional":"EOL FAISA I 3354 FAISA I 20014 EOL.CV.CE.030352-6.01"},{"id":"3ea6ced6-ca1d-4c7e-52eb-08d5ad2bf6ba","name":"EOLICA FAISA II - GERACAO E COMERCIALIZACAO DE ENERGIA S.A.","commercialName":"EOLICA FAISA II","cnpj":"11619388000120","city":"TRAIRI","stateCode":"CE","buscaAdicional":"EOL FAISA II 3355 FAISA II 20015 EOL.CV.CE.030331-3.01"},{"id":"962d9f06-5783-4f99-52ec-08d5ad2bf6ba","name":"EOLICA FAISA III - GERACAO E COMERCIALIZACAO DE ENERGIA S.A.","commercialName":"EOLICA FAISA III","cnpj":"11619413000175","city":"TRAIRI","stateCode":"CE","buscaAdicional":"EOL FAISA III 3356 FAISA III 20016 EOL.CV.CE.030332-1.01"},{"id":"a5e5e012-b108-4fa0-52ed-08d5ad2bf6ba","name":"EOLICA FAISA IV - GERACAO E COMERCIALIZACAO DE ENERGIA S.A.","commercialName":"EOLICA FAISA IV","cnpj":"11619342000100","city":"TRAIRI","stateCode":"CE","buscaAdicional":"EOL FAISA IV 3357 FAISA IV 20017 EOL.CV.CE.030329-1.01"},{"id":"89e4f404-6b6c-42c4-52ee-08d5ad2bf6ba","name":"EOLICA FAISA V - GERACAO E COMERCIALIZACAO DE ENERGIA S.A.","commercialName":"EOLICA FAISA V","cnpj":"11652254000100","city":"TRAIRI","stateCode":"CE","buscaAdicional":"EOL FAISA V 3358 FAISA V 20018 EOL.CV.CE.030309-7.01"},{"id":"bf1f67bc-fcbb-43e1-52f1-08d5ad2bf6ba","name":"EMBUACA GERACAO E COMERCIALIZACAO DE ENERGIA S/A","commercialName":"","cnpj":"10288461000165","city":"TRAIRI","stateCode":"CE","buscaAdicional":"EOL EMBUACA 3362 EMBUACA 20066 EOL.CV.CE.030336-4.01"},{"id":"d8dedac5-754f-4a4b-5423-08d5ad2bf6ba","name":"NOVA VENTOS DO PARAZINHO ENERGIAS RENOVAVEIS S.A","commercialName":"","cnpj":"12773991000124","city":"UBAJARA","stateCode":"CE","buscaAdicional":"PARAZINHO 4029 EOL PARAZINHO 904195 EOL.CV.CE.030596-0.01"},{"id":"4abe65a8-7b7b-4c84-5427-08d5ad2bf6ba","name":"NOVA VENTO FORMOSO ENERGIAS RENOVAVEIS S.A","commercialName":"","cnpj":"12774042000169","city":"UBAJARA","stateCode":"CE","buscaAdicional":"VENTO FORMOSO 4033 VENTO FORMOSO 904194 EOL.CV.CE.030595-2.01"},{"id":"705529fb-85cc-43cb-556f-08d5ad2bf6ba","name":"FAZENDA AMWAY NUTRILITE DO BRASIL LTDA","commercialName":"NUTRIBOTANICA","cnpj":"02038405000144","city":"UBAJARA","stateCode":"CE","buscaAdicional":"COG-AMWAYCE 5610 AMWAY-UBAJARA 71898"},{"id":"7cd9cf01-0c3f-4ca3-55b5-08d5ad2bf6ba","name":"USINA DE ENERGIA EOLICA CARCARA I SPE S.A.","commercialName":"USINA DE ENERGIA EOLICA CARCARA I SPE S.A.","cnpj":"14535594000140","city":"AREIA BRANCA","stateCode":"RN","buscaAdicional":"CARCARA I 6023 CARCARA I 893266 EOL.CV.RN.030832-3.01"},{"id":"a0979df6-ca41-46e7-56ea-08d5ad2bf6ba","name":"USINA DE ENERGIA EOLICA CARCARA II SPE S.A.","commercialName":"USINA DE ENERGIA EOLICA CARCARA II SPE S.A.","cnpj":"15394399000100","city":"AREIA BRANCA","stateCode":"RN","buscaAdicional":"CARCARA II 7988 CARCARA 2 889868 EOL.CV.RN.030897-8.01"},{"id":"22e39908-b29b-4bf3-56f8-08d5ad2bf6ba","name":"USINA DE ENERGIA EOLICA TERRAL SPE S.A","commercialName":"USINA DE ENERGIA EOLICA TERRAL SPE S.A.","cnpj":"15394357000179","city":"AREIA BRANCA","stateCode":"RN","buscaAdicional":"TERRAL 8042 TERRAL 889895 EOL.CV.RN.030898-6.01"},{"id":"32bce6e8-5055-475e-52ef-08d5ad2bf6ba","name":"EOLICA BELA VISTA GERACAO E COMERCIALIZACAO DE ENERGIA SA","commercialName":"EOLICA BELA VISTA","cnpj":"10288502000113","city":"AREIA BRANCA","stateCode":"RN","buscaAdicional":"EOL BELA VISTA 3359 AREIA BRANCA (EBV) 20064 EOL.CV.RN.030340-2.01"},{"id":"ce27b30b-4b01-4189-52f0-08d5ad2bf6ba","name":"EOLICA MAR E TERRA GERACAO E COMERCIALIZACAO DE ENERGIA S.A.","commercialName":"EOLICA MAR E TERRA","cnpj":"10288438000170","city":"AREIA BRANCA","stateCode":"RN","buscaAdicional":"EOL MAR TERRA 3361 MAR E TERRA 20065 EOL.CV.RN.030389-5.01"},{"id":"07423968-8d11-4538-5e1a-08d5ad2bf6ba","name":"SOLAIRE FLORESTA I ENERGIA SOLAR SPE S.A","commercialName":"","cnpj":"23741570000138","city":"AREIA BRANCA","stateCode":"RN","buscaAdicional":"SOLAIRE FLORESTA I 52212 UFV FLORESTA I 910578 UFV.RS.RN.034310-2.01"},{"id":"dd446439-80df-432b-5e1b-08d5ad2bf6ba","name":"SOLAIRE FLORESTA II ENERGIA SOLAR SPE S.A","commercialName":"","cnpj":"23741520000150","city":"AREIA BRANCA","stateCode":"RN","buscaAdicional":"SOLAIRE FLORESTA II 52214 UFV FLORESTA II 910577 UFV.RS.RN.034309-9.01"},{"id":"bb6b8c96-5baf-44ee-5e1c-08d5ad2bf6ba","name":"SOLAIRE FLORESTA III ENERGIA SOLAR SPE S.A","commercialName":"","cnpj":"23723730000116","city":"AREIA BRANCA","stateCode":"RN","buscaAdicional":"SOLAIRE FLORESTA III 52221 UFV FLORESTA III 910576 UFV.RS.RN.033569-0.01"},{"id":"ab71b737-c1ec-4820-5788-08d5ad2bf6ba","name":"CENTRAL GERADORA EOLICA APELIOTES S.A","commercialName":"","cnpj":"12959413000187","city":"CEARÁ-MIRIM","stateCode":"RN","buscaAdicional":"QGER APELIOT 9029 RIACHAO VI 895126 EOL.CV.RN.030872-2.01"},{"id":"23467bb3-d183-4420-5789-08d5ad2bf6ba","name":"CENTRAL GERADORA EOLICA ANEMOI S.A","commercialName":"CENTRAL EOLICA ANEMOI LTDA","cnpj":"12959327000174","city":"CEARÁ-MIRIM","stateCode":"RN","buscaAdicional":"QGER ANEMOI 9030 RIACHAO IV 895144 EOL.CV.RN.030874-9.01"},{"id":"40263632-f1f8-4df4-578a-08d5ad2bf6ba","name":"CENTRAL GERADORA EOLICA ARENA S.A","commercialName":"","cnpj":"11781913000109","city":"CEARÁ-MIRIM","stateCode":"RN","buscaAdicional":"QGER ARENA 9031 RIACHAO VII 895127 EOL.CV.RN.030873-0.01"},{"id":"8fcb861e-498a-46c7-578b-08d5ad2bf6ba","name":"CENTRAL GERADORA EOLICA ALBUQUERQUE S.A","commercialName":"","cnpj":"12960216000188","city":"CEARÁ-MIRIM","stateCode":"RN","buscaAdicional":"QGER ALBUQUE 9032 RIACHAO II 895143 EOL.CV.RN.030871-4.01"},{"id":"52234935-91b0-4a66-578c-08d5ad2bf6ba","name":"CENTRAL GERADORA EOLICA ACARI S.A","commercialName":"CENTRAL EOLICA ACARI LTDA","cnpj":"12959291000129","city":"CEARÁ-MIRIM","stateCode":"RN","buscaAdicional":"QGER ACARAI 9033 RIACHAO I 895125 EOL.CV.RN.030870-6.01"},{"id":"669e8400-087a-4803-5a6b-08d5ad2bf6ba","name":"EOLICA PEDRA RAJADA S.A.","commercialName":"","cnpj":"21909246000150","city":"CERRO CORÁ","stateCode":"RN","buscaAdicional":"PEDRA RAJADA 17449 PEDRA RAJADA 910131 EOL.CV.RN.032352-7.01"},{"id":"06c3b5f4-9d9c-4cc7-5a6c-08d5ad2bf6ba","name":"EOLICA PEDRA RAJADA II S.A.","commercialName":"","cnpj":"21909399000106","city":"CERRO CORÁ","stateCode":"RN","buscaAdicional":"PEDRA RAJADA II 17450 PEDRA RAJADA II 910113 EOL.CV.RN.032353-5.01"},{"id":"e5230b17-f94f-42df-5ed1-08d5ad2bf6ba","name":"SUPERMERCADO NORDESTAO LTDA","commercialName":"NORDESTAO","cnpj":"08030363000181","city":"PARNAMIRIM","stateCode":"RN","buscaAdicional":"SUPER NORDESTAO 52561 NORDESTAO PARNAMIRIM 901616 NORDESTAO POTENGI 901617 SUPER NORDESTAO LJ 3 902433 SUPER NORDESTAO LJ 7 902434 SUPER NORDESTAO LJ 4 902711 SUPER NORDESTAO LJ 2 903623 SUPER NORDESTAO LJ 6 903624 SUPER NORDESTAO LJ 8 903836 PARNAMIRIM-S.FACIL 903965"},{"id":"e968ea8f-c4bc-4f1e-72d1-08d5cf600bef","name":"TECBLU TECELAGEM BLUMENAU S A","commercialName":"TECBLU","cnpj":"08424178000171","city":"PARNAMIRIM","stateCode":"RN","buscaAdicional":""},{"id":"a406491c-cb4c-493e-6579-08d5ad2bf6ba","name":"BEMIS DO BRASIL INDUSTRIA E COMERCIO DE EMBALAGENS LTDA.","commercialName":"","cnpj":"60394723001892","city":"PARNAMIRIM","stateCode":"RN","buscaAdicional":"BEMIS PARNAMIRIM 56738 BEMIS PARNAMIRIM 906454"},{"id":"253ba375-a079-4755-6114-08d5ad2bf6ba","name":"LAMINOR S.A.","commercialName":"LAMINOR","cnpj":"05553211000175","city":"PARNAMIRIM","stateCode":"RN","buscaAdicional":"LAMINOR 53996 LAMINOR PARNAMIRIM 901355"},{"id":"4d931898-76f6-46b8-52d1-08d5ad2bf6ba","name":"REI DOS VENTOS 3 GERADORA DE ENERGIA S.A.","commercialName":"","cnpj":"11637104000128","city":"GALINHOS","stateCode":"RN","buscaAdicional":"RDV 3 3322 REI VENTOS 3 20037 EOL.CV.RN.030417-4.01"},{"id":"82c7337a-9f44-4f9e-52d4-08d5ad2bf6ba","name":"BRASVENTOS EOLO GERADORA DE ENERGIA S.A.","commercialName":"","cnpj":"11637090000142","city":"GALINHOS","stateCode":"RN","buscaAdicional":"RDV 1 3325 REI VENTOS 1 2LER 20036 EOL.CV.RN.030416-6.01"},{"id":"61c36d0e-23d7-471e-60ad-08d5ad2bf6ba","name":"CERAMICA ELIZABETH RN LTDA","commercialName":"","cnpj":"19454979000104","city":"GOIANINHA","stateCode":"RN","buscaAdicional":"ELIZABETH RN 53632 CERAMICA ELIZABETH 905971"},{"id":"6a107cf2-5135-4b98-52d0-08d5ad2bf6ba","name":"BRASVENTOS ARATUA 1 GERADORA DE ENERGIA S.A.","commercialName":"","cnpj":"11637037000141","city":"GUAMARÉ","stateCode":"RN","buscaAdicional":"ART 1 3321 ARATUA 1 8958 EOL.CV.RN.030121-3.01"},{"id":"809ef642-e557-480d-5460-08d5ad2bf6ba","name":"MIASSABA GERADORA EOLICA S.A","commercialName":"","cnpj":"08664111000104","city":"GUAMARÉ","stateCode":"RN","buscaAdicional":"MIA 4200 MIASSABA 2 8940 EOL.CV.RN.030370-4.01"},{"id":"883c1247-97ed-42ca-53e6-08d5ad2bf6ba","name":"EURUS II ENERGIAS RENOVAVEIS S.A.","commercialName":"","cnpj":"10797897000180","city":"JOÃO CÂMARA","stateCode":"RN","buscaAdicional":"EURUS II 3901 EURUS 2 3LER 890761 EOL.CV.RN.030499-9.01"},{"id":"26f5c6b1-d37a-4e61-5672-08d5ad2bf6ba","name":"VENTOS DE SANTO URIEL S.A","commercialName":"","cnpj":"14583703000102","city":"JOÃO CÂMARA","stateCode":"RN","buscaAdicional":"DESA URIEL 7101 VENTOS DE STO URIEL 893428 EOL.CV.RN.030828-5.01"},{"id":"ee090381-8309-478c-5685-08d5ad2bf6ba","name":"EOLICA LANCHINHA S.A.","commercialName":"","cnpj":"14603978000152","city":"LAGOA NOVA","stateCode":"RN","buscaAdicional":"LANCHINHA 7224 USRNLANCHI 893325 EOL.CV.RN.030860-9.01"},{"id":"d2f4267c-0f4f-4b8d-5686-08d5ad2bf6ba","name":"EOLICA PARAISO S.A.","commercialName":"","cnpj":"14604100000131","city":"LAGOA NOVA","stateCode":"RN","buscaAdicional":"PARAISO 7225 PARQUE EOLICO PELADO 893446 EOL.CV.RN.030856-0.01"},{"id":"a620d81f-cc38-406a-5719-08d5ad2bf6ba","name":"GESTAMP EOLICA ALVORADA S/A","commercialName":"","cnpj":"15231479000144","city":"LAGOA NOVA","stateCode":"RN","buscaAdicional":"ALVORADA I 8223 CABECO PRETO 6 889888 EOL.CV.RN.030900-1.01"},{"id":"ee65139c-3edf-4f32-571a-08d5ad2bf6ba","name":"GESTAMP EOLICA JARDINS SA","commercialName":"","cnpj":"15231547000175","city":"LAGOA NOVA","stateCode":"RN","buscaAdicional":"JARDINS 8224 CABECO PRETO 5 889887 EOL.CV.RN.030876-5.01"},{"id":"94546c28-01ae-492d-571b-08d5ad2bf6ba","name":"GESTAMP EOLICA AGRESTE SA","commercialName":"","cnpj":"15231615000104","city":"LAGOA NOVA","stateCode":"RN","buscaAdicional":"AGRESTE 8225 CABECO PRETO 3 889900 EOL.CV.RN.031015-8.01"},{"id":"a6e2be24-c61e-42f9-571c-08d5ad2bf6ba","name":"GESTAMP EOLICA MACAMBIRA II SA","commercialName":"","cnpj":"15231448000193","city":"LAGOA NOVA","stateCode":"RN","buscaAdicional":"MACAMBIRA II 8226 MACAMBIRA 2 889899 EOL.CV.RN.031026-3.01"},{"id":"ea045fbe-9ca7-4a2c-571d-08d5ad2bf6ba","name":"GESTAMP EOLICA MACAMBIRA I SA","commercialName":"","cnpj":"15231588000161","city":"LAGOA NOVA","stateCode":"RN","buscaAdicional":"MACAMBIRA I 8227 MACAMBIRA 1 889898 EOL.CV.RN.031025-5.01"},{"id":"b724929c-4a47-4a5e-543c-08d5ad2bf6ba","name":"EOLICA SERRA DE SANTANA S.A.","commercialName":"GESTAMP EOLICA SERRA DE SANTANA SA","cnpj":"12848401000185","city":"LAGOA NOVA","stateCode":"RN","buscaAdicional":"GESTAMP SANTAN 4118 S DE SANTANA 1 3LER 890774 EOL.CV.RN.030625-8.01"},{"id":"d847b38d-4b49-40f2-543d-08d5ad2bf6ba","name":"EOLICA LAGOA NOVA S.A.","commercialName":"GESTAMP EOLICA LAGOA NOVA SA","cnpj":"12851098000170","city":"LAGOA NOVA","stateCode":"RN","buscaAdicional":"GESTAMP LAGOA 4119 S DE SANTANA 2 3LER 890775 EOL.CV.RN.030609-6.01"},{"id":"d916cf3a-b0fc-425d-543e-08d5ad2bf6ba","name":"EOLICA MOXOTO S.A.","commercialName":"GESTAMP EOLICA MOXOTO SA","cnpj":"12848329000196","city":"LAGOA NOVA","stateCode":"RN","buscaAdicional":"GESTAMP MOXOTO 4120 CABECO PRETO IV 8984 EOL.CV.RN.030501-4.01"},{"id":"41471bda-7aa9-4fb5-5445-08d5ad2bf6ba","name":"EOLICATEC SOBRADINHO S.A.","commercialName":"","cnpj":"12684715000190","city":"LAGOA NOVA","stateCode":"RN","buscaAdicional":"GESTAMP 4131 PEDRA REINO III 3LER 20077 EOL.CV.BA.030608-8.01"},{"id":"bf547562-6250-434d-5446-08d5ad2bf6ba","name":"EOLICA SERIDO S.A.","commercialName":"GESTAMP EOLICA SERIDO SA","cnpj":"12848783000147","city":"LAGOA NOVA","stateCode":"RN","buscaAdicional":"GESTAMP SERIDO 4132 S DE SANTANA 3 3LER 890776 EOL.CV.RN.030615-0.01"},{"id":"31ffc06b-a865-4668-5334-08d5ad2bf6ba","name":"EOLICA BAIXA VERDE S.A.","commercialName":"GESTAMP EOLICA BAIXA VERDE","cnpj":"11613311000142","city":"LAGOA NOVA","stateCode":"RN","buscaAdicional":"GEOBV 3510 CABECO PRETO 8983 EOL.CV.RN.030333-0.01"},{"id":"ea30376b-2aee-4e16-531d-08d5ad2bf6ba","name":"EOLICA PEDRA DO REINO S.A.","commercialName":"","cnpj":"11608271000140","city":"LAGOA NOVA","stateCode":"RN","buscaAdicional":"EOPR 3482 PEDRA DO REINO 20039 EOL.CV.BA.030288-0.01"},{"id":"efc7140b-ffb5-4aa6-5982-08d5ad2bf6ba","name":"EOLICA CABECO VERMELHO S.A.","commercialName":"","cnpj":"20024563000127","city":"LAGOA NOVA","stateCode":"RN","buscaAdicional":"GEOCV 14696 EOL CABECO VERMELHO 908894 EOL.CV.RN.031651-2.01"},{"id":"f8949b5e-0d58-4a63-5983-08d5ad2bf6ba","name":"EOLICA CABECO VERMELHO II S.A.","commercialName":"","cnpj":"20024516000183","city":"LAGOA NOVA","stateCode":"RN","buscaAdicional":"GEOCV II 14702 CABECO VERMELHO 2 908886 EOL.CV.RN.031665-2.01"},{"id":"92b182c7-9a51-4013-51db-08d5ad2bf6ba","name":"COMPANHIA ENERGETICA POTIGUAR","commercialName":"COMPANHIA ENERGETICA POTIGUAR","cnpj":"09439128000120","city":"MACAÍBA","stateCode":"RN","buscaAdicional":"CEP 2628 POTIGUAR 8433 UTE.PE.RN.028655-9.01 POTIGUAR III 8434 UTE.PE.RN.029556-6.01"},{"id":"ca7d26d5-94c6-40d4-6210-08d5ad2bf6ba","name":"ASPERBRAS TUBOS E CONEXOES LTDA","commercialName":"ASPERBRAS","cnpj":"02271201000159","city":"MACAÍBA","stateCode":"RN","buscaAdicional":"ASPERBRAS 54534 ASPERBRAS - TUBOS BA 907153 ASPERBRAS MACAIBA 907758 ASPERBRAS PENAPOLIS 908235 ASPERBRAS ROTO PENAP 908252"},{"id":"2a6b2bde-e218-43f0-4f1a-08d5d159243d","name":"TRIUNFO SECURITIZADORA DE ATIVOS S/A","commercialName":"TRIUNFO SECURITIZADORA","cnpj":"24955657000170","city":"MACAÍBA","stateCode":"RN","buscaAdicional":""},{"id":"b2fe5398-9639-46c5-533a-08d5ad2bf6ba","name":"BRASVENTOS MIASSABA 3 GERADORA DE ENERGIA S.A.","commercialName":"","cnpj":"11839616000177","city":"MACAU","stateCode":"RN","buscaAdicional":"MIA 3 3525 MIASSABA 3 20038 EOL.CV.RN.030339-9.01"},{"id":"1eefcdd3-fe1a-46ee-53ad-08d5ad2bf6ba","name":"ITAPETINGA AGRO INDUSTRIAL SA","commercialName":"","cnpj":"08331340000298","city":"MOSSORÓ","stateCode":"RN","buscaAdicional":"ITAPETINGA 3764 ITAPETINGA C NASSAU 71264"},{"id":"9003bc2d-87cd-4fe3-5efa-08d5ad2bf6ba","name":"CONDOMINIO PARTAGE SHOPPING MOSSORO","commercialName":"CONDOMINIO PARTAGE SHOPPING MOSSORO","cnpj":"08806718000181","city":"MOSSORÓ","stateCode":"RN","buscaAdicional":"PSM 52678 PARTAGE SHOP MOSSORO 903637"},{"id":"b16334ae-ed3c-4a2a-5efe-08d5ad2bf6ba","name":"CONDOMINIO PARTAGE NORTE SHOPPING NATAL","commercialName":"CONDOMINIO PARTAGE NORTE SHOPPING NATAL","cnpj":"09472250000107","city":"NATAL","stateCode":"RN","buscaAdicional":"PNSN 52699 COND PARTAGE NORTE 903862"},{"id":"2a689cc5-18ae-48fc-5d42-08d5ad2bf6ba","name":"APEC - SOCIEDADE POTIGUAR DE EDUCACAO E CULTURA LTDA","commercialName":"","cnpj":"08480071000140","city":"NATAL","stateCode":"RN","buscaAdicional":"APEC 51750 APECMATRIZ 900775 APECSALG371 900776 APECROB2184 900777 APECROB1200 900779 APECMOSSORO 900780 APECSALG327 900794 APEC NASC 1597 906441 APEC NASC 1897 906827 APEC AGOST 906830"},{"id":"4524b975-ee4b-4c4d-59f4-08d5ad2bf6ba","name":"ICONE ENERGIA LTDA","commercialName":"ICONE ENERGIA","cnpj":"16650807000100","city":"NATAL","stateCode":"RN","buscaAdicional":"ICONE 16076"},{"id":"66ac6d18-96a4-4862-5379-08d5ad2bf6ba","name":"CONDOMINIO CIVIL PRO-INDIVISO DO NATAL SHOPPING CENTER","commercialName":"","cnpj":"03553283000197","city":"NATAL","stateCode":"RN","buscaAdicional":"NATAL SHOPPING 3646 NATAL SHOPPING 71193 NATAL SHOPPING CND 2 71194"},{"id":"5507fc5e-829d-4774-568f-08d5ad2bf6ba","name":"TRES CORACOES ALIMENTOS S.A.","commercialName":"UNIDADE INDUSTRIAL NATAL","cnpj":"63310411001418","city":"NATAL","stateCode":"RN","buscaAdicional":"3 CORACOES AL 7234 3 CORACOES NATAL 72189"},{"id":"9eda399a-4603-4116-52d9-08d5ad2bf6ba","name":"EOLICA MANGUE SECO 1 - GERADORA E COMERCIALIZADORA DE ENERGIA ELETRICA S.A.","commercialName":"EOLICA MANGUE SECO 01","cnpj":"11643458000185","city":"NATAL","stateCode":"RN","buscaAdicional":"MANGUE SECO 1 3332 MANGUE SECO 1 8912 EOL.CV.RN.030285-6.01"},{"id":"e918a8a8-05ac-4252-52da-08d5ad2bf6ba","name":"EOLICA MANGUE SECO 2 - GERADORA E COMERCIALIZADORA DE ENERGIA ELETRICA S.A.","commercialName":"EOLICA MANGUE SECO 02","cnpj":"11643504000146","city":"NATAL","stateCode":"RN","buscaAdicional":"MANGUE SECO 2 3334 MANGUE SECO 2 8910 EOL.CV.RN.030284-8.01"},{"id":"201b67fb-bbe5-4151-52dc-08d5ad2bf6ba","name":"EOLICA MANGUE SECO 3 - GERADORA E COMERCIALIZADORA DE ENERGIA ELETRICA S.A.","commercialName":"EOLICA MANGUE SECO 03","cnpj":"11643567000100","city":"NATAL","stateCode":"RN","buscaAdicional":"MANGUE SECO 3 3336 MANGUE SECO 3 8892 EOL.CV.RN.030281-3.01"},{"id":"d85eeb49-81d2-4575-52dd-08d5ad2bf6ba","name":"EOLICA MANGUE SECO 4 - GERADORA E COMERCIALIZADORA DE ENERGIA ELETRICA S.A.","commercialName":"EOLICA MANGUE SECO 04","cnpj":"11643647000158","city":"NATAL","stateCode":"RN","buscaAdicional":"MANGUE SECO 4 3337 MANGUE SECO 5 8922 EOL.CV.RN.030290-2.01"},{"id":"82dc56a7-04b2-49f5-4ef4-08d5ad2bf6ba","name":"COMPANHIA ENERGETICA DO RIO GRANDE DO NORTE COSERN","commercialName":"","cnpj":"08324196000181","city":"NATAL","stateCode":"RN","buscaAdicional":"COSERN 33 COSERN 19 COSERN DITC SC 72309"},{"id":"0b3fba1c-d576-48e7-4f19-08d5d159243d","name":"TRIPLICE SECURITIZADORA DE ATIVOS MERCANTIS S/A","commercialName":"TRIPLICE SECURITIZADORA DE ATIVOS MERCANTIS S/A","cnpj":"24717074000101","city":"NATAL","stateCode":"RN","buscaAdicional":""},{"id":"836eb2ee-8a2b-439e-423a-08d5e5532bcf","name":"INTERSISTEMAS SERVICOS EM TECNOLOGIA LTDA","commercialName":"INTERSISTEMAS","cnpj":"08822613000116","city":"NATAL","stateCode":"RN","buscaAdicional":""},{"id":"b2113e81-ab1f-46d8-631d-08d5ad2bf6ba","name":"ARENA DAS DUNAS CONCESSAO E EVENTOS S/A","commercialName":"ARENA DAS DUNAS CONCESSAO E EVENTOS S/A","cnpj":"13475478000110","city":"NATAL","stateCode":"RN","buscaAdicional":"ARENADUNAS 55174 ARENA DAS DUNAS 905972"},{"id":"27cd3254-0b78-4e0b-65be-08d5ad2bf6ba","name":"CONDOMINIO SHOPPING CENTER MIDWAY MALL","commercialName":"MIDWAY MALL","cnpj":"08713566000172","city":"NATAL","stateCode":"RN","buscaAdicional":"MIDWAY MALL 57031 COND SH MIDWAY MALL 907123"},{"id":"c3524794-1f1a-4452-685a-08d5ad2bf6ba","name":"GUARARAPES CONFECCOES S/A","commercialName":"GUARARAPES","cnpj":"08402943000152","city":"NATAL","stateCode":"RN","buscaAdicional":"GUARARAPES CONFECCOES 59853 GUARARAPES CONFECCOE 910259 GUARARAPES CONFEC 911266"},{"id":"c80d3796-a3a9-49c7-53e3-08d5ad2bf6ba","name":"RENASCENCA V ENERGIAS RENOVAVEIS S.A.","commercialName":"","cnpj":"10797904000143","city":"PARAZINHO","stateCode":"RN","buscaAdicional":"RENASCENCA V 3890 RENASCENCA 5 3LER 890756 EOL.CV.RN.030497-2.01"},{"id":"026a0e41-eaa7-4d09-5420-08d5ad2bf6ba","name":"NOVA ASA BRANCA II ENERGIAS RENOVAVEIS S.A","commercialName":"NOVA ASA BRANCA II","cnpj":"12802844000135","city":"PARAZINHO","stateCode":"RN","buscaAdicional":"NOVA ASA B II 4026 ASA BRANCA 2 2LFA 891943 EOL.CV.RN.030547-2.01"},{"id":"4a11914a-e5cc-4d22-5421-08d5ad2bf6ba","name":"NOVA ASA BRANCA III ENERGIAS RENOVAVEIS S.A","commercialName":"NOVA ASA BRANCA III","cnpj":"12802835000144","city":"PARAZINHO","stateCode":"RN","buscaAdicional":"NOVA ASA B III 4027 ASA BRANCA 3 2LFA 891944 EOL.CV.RN.030548-0.01"},{"id":"97ea72ef-e9c6-4ee3-5966-08d5ad2bf6ba","name":"FORTE CANTO DE BAIXO GERADORA EOLICA S/A","commercialName":"","cnpj":"18265320000139","city":"PEDRA GRANDE","stateCode":"RN","buscaAdicional":"FORTE_12 14399 UNIAO DOS VENTOS 12 911352 EOL.CV.RN.031645-8.01"},{"id":"6911a8dc-2883-45d5-5967-08d5ad2bf6ba","name":"VENTOS DE SANTO ANTONIO GERADORA EOLICA S/A","commercialName":"","cnpj":"17143971000193","city":"PEDRA GRANDE","stateCode":"RN","buscaAdicional":"SANTONIO_13 14400 UNIAO DOS VENTOS 13 910992 EOL.CV.RN.031697-0.01"},{"id":"9c0a399d-718c-4bc7-5968-08d5ad2bf6ba","name":"VENTOS DO CANTO DE BAIXO GERADORA EOLICA S/A","commercialName":"","cnpj":"17143838000137","city":"PEDRA GRANDE","stateCode":"RN","buscaAdicional":"CBAIXO_14 14402 UNIAO DOS VENTOS 14 910973 EOL.CV.RN.031643-1.01"},{"id":"3f0efd8d-5fa4-446e-5c48-08d5ad2bf6ba","name":"SERVENG ENERGIAS RENOVAVEIS S/A.","commercialName":"","cnpj":"11696857000104","city":"PEDRA GRANDE","stateCode":"RN","buscaAdicional":"SERVENG COMERCIALIZADORA 51250"},{"id":"5fc2feac-f0e8-4b66-5a51-08d5ad2bf6ba","name":"USINA DE ENERGIA EOLICA GUAJIRU S/A","commercialName":"USINA DE ENERGIA EOLICA GUAJIRU S/A","cnpj":"21957870000123","city":"SÃO BENTO DO NORTE","stateCode":"RN","buscaAdicional":"EOL GUAJIRU 17344"},{"id":"f667c5e0-e5e4-440b-5a52-08d5ad2bf6ba","name":"USINA DE ENERGIA EOLICA POTIGUAR S/A","commercialName":"USINA DE ENERGIA EOLICA POTIGUAR S/A","cnpj":"21957968000180","city":"SÃO BENTO DO NORTE","stateCode":"RN","buscaAdicional":"EOL POTIGUAR 17345"},{"id":"1b5ff6c8-883b-4f88-5a4a-08d5ad2bf6ba","name":"USINA DE ENERGIA EOLICA CUTIA S/A","commercialName":"USINA DE ENERGIA EOLICA CUTIA S/A","cnpj":"21917808000108","city":"SÃO BENTO DO NORTE","stateCode":"RN","buscaAdicional":"EOL CUTIA 17326"},{"id":"726a9f8a-e94f-4eaa-5a4b-08d5ad2bf6ba","name":"USINA DE ENERGIA EOLICA ESPERANCA DO NORDESTE S/A","commercialName":"USINA DE ENERGIA EOLICA ESPERANCA DO NORDESTE S/A","cnpj":"21916951000185","city":"SÃO BENTO DO NORTE","stateCode":"RN","buscaAdicional":"EOL ESPERANCA 17327"},{"id":"6d551892-7536-41bf-5a4c-08d5ad2bf6ba","name":"USINA DE ENERGIA EOLICA JANGADA S/A","commercialName":"USINA DE ENERGIA EOLICA JANGADA S/A","cnpj":"21957722000109","city":"SÃO BENTO DO NORTE","stateCode":"RN","buscaAdicional":"EOL JANGADA 17328"},{"id":"a118e246-ec10-4905-5a4d-08d5ad2bf6ba","name":"USINA DE ENERGIA EOLICA MARIA HELENA S/A","commercialName":"USINA DE ENERGIA EOLICA MARIA HELENA S/A","cnpj":"21909793000136","city":"SÃO BENTO DO NORTE","stateCode":"RN","buscaAdicional":"EOL MARIA HELENA 17329"},{"id":"bf9c9cbb-248c-4a8b-5a4e-08d5ad2bf6ba","name":"USINA DE ENERGIA EOLICA PARAISO DOS VENTOS DO NORDESTE S/A","commercialName":"USINA DE ENERGIA EOLICA PARAISO DOS VENTOS DO NORDESTE","cnpj":"21909032000184","city":"SÃO BENTO DO NORTE","stateCode":"RN","buscaAdicional":"EOL PARAISO 17330"},{"id":"3707217a-ce8e-46ca-53f5-08d5ad2bf6ba","name":"GE BOA VISTA S/A","commercialName":"GE BOA VISTA S/A","cnpj":"12723413000183","city":"SÃO BENTO DO NORTE","stateCode":"RN","buscaAdicional":"BOAVISTA 3934 BOA VISTA 2LFA 890623 EOL.CV.RN.030512-0.01"},{"id":"f9c97577-1a6d-4953-53f6-08d5ad2bf6ba","name":"GE OLHO D'AGUA S/A","commercialName":"GE OLHO D'AGUA S/A","cnpj":"12723444000134","city":"SÃO BENTO DO NORTE","stateCode":"RN","buscaAdicional":"OLHODAGUA 3935 OLHO DAGUA 2LFA 890622 EOL.CV.RN.030549-9.01"},{"id":"c6e270a7-e3b9-4c75-53f7-08d5ad2bf6ba","name":"GE FAROL S/A","commercialName":"GE FAROL S/A","cnpj":"12723335000117","city":"SÃO BENTO DO NORTE","stateCode":"RN","buscaAdicional":"FAROL 3936 FAROL 890277 EOL.CV.RN.030502-2.01"},{"id":"ac8992f5-1a37-4787-53f8-08d5ad2bf6ba","name":"GE SAO BENTO DO NORTE S/A","commercialName":"GE SAO BENTO DO NORTE S/A","cnpj":"12723384000150","city":"SÃO BENTO DO NORTE","stateCode":"RN","buscaAdicional":"SAOBENTO 3937 S BENTO NORTE 2 LFA 890621 EOL.CV.RN.030536-7.01"},{"id":"a96d255e-58d6-471f-5542-08d5ad2bf6ba","name":"NORTEX INDUSTRIA E COMERCIO S/A","commercialName":"","cnpj":"24523508000132","city":"SÃO GONÇALO DO AMARANTE","stateCode":"RN","buscaAdicional":"NORTEX SA 5212 NORTEXSA-NATAL 71901"},{"id":"c2502f3a-79d8-46ff-50c9-08d5ad2bf6ba","name":"TEXTILE INDUSTRIAL S/A","commercialName":"","cnpj":"12987103000176","city":"SÃO GONÇALO DO AMARANTE","stateCode":"RN","buscaAdicional":"TEXTILE 1846 TEXTILE S G AMARANTE 71986"},{"id":"43dec17b-a5a4-410b-68de-08d5ad2bf6ba","name":"INFRAMERICA CONCESSIONARIA DO AEROPORTO DE SAO GONCALO DO AMARANTE S.A.","commercialName":"INFRAMERICA","cnpj":"14639720000106","city":"SÃO GONÇALO DO AMARANTE","stateCode":"RN","buscaAdicional":"INFRAMERICA NATAL 60516 INFRAMERICA - S GONC 911303"},{"id":"cdffa163-fc79-4044-61cd-08d5ad2bf6ba","name":"COATS CORRENTE TEXTIL LTDA","commercialName":"","cnpj":"07246969000196","city":"SÃO GONÇALO DO AMARANTE","stateCode":"RN","buscaAdicional":"COATS CORRENTE RN 54431 COATS CORRENTE RN 904444"},{"id":"2508453e-66b6-4b31-541f-08d5ad2bf6ba","name":"NOVA ASA BRANCA I ENERGIAS RENOVAVEIS S.A","commercialName":"NOVA ASA BRANCA I","cnpj":"12802855000115","city":"SÃO MIGUEL DO GOSTOSO","stateCode":"RN","buscaAdicional":"NOVA ASA B I 4024 ASA BRANCA 1 2LFA 891926 EOL.CV.RN.030505-7.01"},{"id":"a9a5d20c-bd39-4918-55b6-08d5ad2bf6ba","name":"USINA DE ENERGIA EOLICA REDUTO SPE S.A","commercialName":"USINA DE ENERGIA EOLICA REDUTO SPE S.A.","cnpj":"14527003000192","city":"SÃO MIGUEL DO GOSTOSO","stateCode":"RN","buscaAdicional":"REDUTO 6024 REDUTO 893342 EOL.CV.RN.030843-9.01"},{"id":"ef62cc3f-a449-4966-55b3-08d5ad2bf6ba","name":"USINA DE ENERGIA EOLICA SAO JOAO SPE S.A","commercialName":"USINA DE ENERGIA EOLICA SAO JOAO SPE S.A.","cnpj":"14535646000188","city":"SÃO MIGUEL DO GOSTOSO","stateCode":"RN","buscaAdicional":"SAO JOAO 6021 EOL SAO JOAO 893382 EOL.CV.RN.030804-8.01"},{"id":"0717c7fe-e1ac-4cb4-55b4-08d5ad2bf6ba","name":"USINA DE ENERGIA EOLICA CARNAUBA SPE S.A","commercialName":"USINA DE ENERGIA EOLICA CARNAUBA SPE S.A.","cnpj":"14535588000192","city":"SÃO MIGUEL DO GOSTOSO","stateCode":"RN","buscaAdicional":"CARNAUBA 6022 CARNAUBAS 893222 EOL.CV.RN.030831-5.01"},{"id":"dad2d69c-da1a-479b-5723-08d5ad2bf6ba","name":"USINA DE ENERGIA EOLICA CAICARA II SPE S.A.","commercialName":"USINA DE ENERGIA EOLICA CAICARA II SPE S.A.","cnpj":"15313113000114","city":"SERRA DO MEL","stateCode":"RN","buscaAdicional":"EOL CAICARA II 8263 CAICARA II 896984 EOL.CV.RN.030915-0.02"},{"id":"fea78dad-5501-4c12-5724-08d5ad2bf6ba","name":"USINA DE ENERGIA EOLICA JUNCO I SPE S.A.","commercialName":"USINA DE ENERGIA EOLICA JUNCO I SPE S.A.","cnpj":"15313226000110","city":"SERRA DO MEL","stateCode":"RN","buscaAdicional":"EOL JUNCO I 8264 JUNCO 1 889873 EOL.CV.RN.030902-8.02"},{"id":"7a466fa0-ed3a-4146-5725-08d5ad2bf6ba","name":"USINA DE ENERGIA EOLICA JUNCO II SPE S.A.","commercialName":"USINA DE ENERGIA EOLICA JUNCO II SPE S.A.","cnpj":"15313187000150","city":"SERRA DO MEL","stateCode":"RN","buscaAdicional":"EOL JUNCO II 8265 JUNCO 2 889874 EOL.CV.RN.030914-1.02"},{"id":"9c41d1d6-d0d6-4e8c-5728-08d5ad2bf6ba","name":"USINA DE ENERGIA EOLICA CAICARA I SPE S.A.","commercialName":"USINA DE ENERGIA EOLICA CAICARA I SPE S.A.","cnpj":"15313271000174","city":"SERRA DO MEL","stateCode":"RN","buscaAdicional":"EOL CAICARA I 8268 CAICARA I 889866 EOL.CV.RN.030895-1.02"},{"id":"820a4329-5bcc-4b70-599d-08d5ad2bf6ba","name":"USINA DE ENERGIA EOLICA VILA PARA I SPE S.A.","commercialName":"USINA DE ENERGIA EOLICA VILA PARA I SPE S.A.","cnpj":"20318451000189","city":"SERRA DO MEL","stateCode":"RN","buscaAdicional":"EOL VILA PARA I 15175 EOL VILA PARA I 901918 EOL.CV.RN.031759-4.01"},{"id":"df938aae-2319-422a-599e-08d5ad2bf6ba","name":"USINA DE ENERGIA EOLICA VILA PARA II SPE S.A.","commercialName":"USINA DE ENERGIA EOLICA VILA PARA II SPE S.A.","cnpj":"20318810000106","city":"SERRA DO MEL","stateCode":"RN","buscaAdicional":"EOL VILA PARA II 15195 EOL VILA PARA II 901919 EOL.CV.RN.031757-8.01"},{"id":"2e82cc95-8e80-41aa-599f-08d5ad2bf6ba","name":"USINA DE ENERGIA EOLICA VILA PARA III SPE S.A.","commercialName":"USINA DE ENERGIA EOLICA VILA PARA III SPE S.A.","cnpj":"20318427000140","city":"SERRA DO MEL","stateCode":"RN","buscaAdicional":"EOL VILA PARA III 15196 EOL VILA PARA III 903385 EOL.CV.RN.031765-9.01"},{"id":"cc4d41de-0005-4e1f-59a0-08d5ad2bf6ba","name":"USINA DE ENERGIA EOLICA VILA AMAZONAS V SPE S.A.","commercialName":"USINA DE ENERGIA EOLICA VILA AMAZONAS V SPE S.A.","cnpj":"20339203000114","city":"SERRA DO MEL","stateCode":"RN","buscaAdicional":"EOL VILA AMAZONAS V 15197 EOL VILA AMAZONAS V 901834 EOL.CV.RN.031750-0.01"},{"id":"d1fa2256-bff7-4c52-5e60-08d5ad2bf6ba","name":"USINA DE ENERGIA EOLICA VILA ACRE I SPE S.A.","commercialName":"USINA DE ENERGIA EOLICA VILA ACRE I SPE S.A.","cnpj":"24061085000186","city":"SERRA DO MEL","stateCode":"RN","buscaAdicional":"EOL ACRE I 52344 VILA ACRE 1 908483 EOL.CV.RN.033752-8.01"},{"id":"d83262b2-3885-413b-55b7-08d5ad2bf6ba","name":"USINA DE ENERGIA EOLICA SANTO CRISTO SPE S.A","commercialName":"USINA DE ENERGIA EOLICA SANTO CRISTO SPE S.A","cnpj":"14535540000184","city":"TOUROS","stateCode":"RN","buscaAdicional":"SANTO CRISTO 6025 SANTO CRISTO 893427 EOL.CV.RN.030849-8.01"},{"id":"1e8f62fd-b29c-419f-5424-08d5ad2bf6ba","name":"NOVA EURUS IV ENERGIAS RENOVAVEIS S.A","commercialName":"NOVA EURUS","cnpj":"12802866000103","city":"TOUROS","stateCode":"RN","buscaAdicional":"NOVA EURUS IV 4030 EURUS IV 891945 EOL.CV.RN.030509-0.01"},{"id":"eb8eb7a6-7198-4eb1-59c6-08d5ad2bf6ba","name":"ELIZABETH CIMENTOS LTDA","commercialName":"CIMENTO ELIZABETH","cnpj":"12186380000180","city":"ALHANDRA","stateCode":"PB","buscaAdicional":"ELIZABETH CIMENTOS 15535 ELIZABETH CIMENTOS 895024"},{"id":"8917786e-5ece-4d8f-63b4-08d5ad2bf6ba","name":"CAMBUCI S/A","commercialName":"PENALTY","cnpj":"61088894002402","city":"BAYEUX","stateCode":"PB","buscaAdicional":"CAMBUCI BAYEUX 55573 CAMBUCI BAYEUX 909287"},{"id":"2ebdaa8a-c760-4c0a-68e5-08d5ad2bf6ba","name":"USINA MONTE ALEGRE SA","commercialName":"","cnpj":"09094632000136","city":"BAYEUX","stateCode":"PB","buscaAdicional":"UTE MONTE ALEGRE MATRIZ 60534 USINA MONTE ALEGRE 910453 UTE.AI.PB.034891-0.01"},{"id":"1a822001-764c-429b-6281-08d5ad2bf6ba","name":"SAO BRAZ S/A INDUSTRIA E COMERCIO DE ALIMENTOS","commercialName":"CAFE SAO BRAZ","cnpj":"08811226001903","city":"CABEDELO","stateCode":"PB","buscaAdicional":"SAO BRAZ PB 54787 SAO BRAZ PB 904463"},{"id":"d5311634-ff77-42d3-68c3-08d5ad2bf6ba","name":"FIACAO PATAMUTE LTDA","commercialName":"","cnpj":"70112925000100","city":"CAJAZEIRAS","stateCode":"PB","buscaAdicional":"PATAMUTE 60397 FIACAO PATAMUTE LTDA 911955"},{"id":"474b6789-db8b-4b9d-638a-08d5ad2bf6ba","name":"INDUSTRIA E COMERCIO MARAGOGI LTDA","commercialName":"EVEREST","cnpj":"06039172000155","city":"CAMPINA GRANDE","stateCode":"PB","buscaAdicional":"MARAGOGI 55459 MARAGOGI 907147"},{"id":"e25cd770-2f35-4e99-6436-08d5ad2bf6ba","name":"BENTONIT UNIAO NORDESTE INDUSTRIA E COMERCIO LTDA","commercialName":"BUN","cnpj":"08811119000156","city":"CAMPINA GRANDE","stateCode":"PB","buscaAdicional":"BENTONIT 55881 BENTONIT UNIAO 906833"},{"id":"a28e75ad-2b29-4b86-5dff-08d5ad2bf6ba","name":"CONDOMINIO DO PARTAGE SHOPPING CAMPINA GRANDE","commercialName":"","cnpj":"03493009000170","city":"CAMPINA GRANDE","stateCode":"PB","buscaAdicional":"PSCG 52145 PARTAGE SHOP 899774"},{"id":"6dee9084-a741-4693-4ee5-08d5ad2bf6ba","name":"ENERGISA BORBOREMA - DISTRIBUIDORA DE ENERGIA S.A","commercialName":"ENERGISA","cnpj":"08826596000195","city":"CAMPINA GRANDE","stateCode":"PB","buscaAdicional":"ENERGISA BO 13 ENERGISA BO 22"},{"id":"1f8b7935-fb56-4c98-5179-08d5ad2bf6ba","name":"BORBOREMA ENERGETICA S.A.","commercialName":"BORBOREMA ENERGETICA","cnpj":"09036424000180","city":"CAMPINA GRANDE","stateCode":"PB","buscaAdicional":"UTE BORBOREMA 2198 CAMPINA GRANDE 8574 UTE.PE.PB.000612-2.01"},{"id":"d9dab63b-2368-4f49-5655-08d5ad2bf6ba","name":"ELIZABETH PORCELANATO LTDA.","commercialName":"","cnpj":"02357659000125","city":"CONDE","stateCode":"PB","buscaAdicional":"ELIZABETHPOR 6917 ELIZABETH PORCELANA 888292"},{"id":"ab732a91-5cc4-415f-887d-08d5ae44ed50","name":"REPET NORDESTE RECICLAGEM LTDA EM RECUPERACAO JUDICIAL","commercialName":"","cnpj":"02645573000106","city":"CONDE","stateCode":"PB","buscaAdicional":"REPET 8813 REPET 889127"},{"id":"e4c51715-bdd6-4f4f-72eb-08d5cf600bef","name":"CONPEL CIA NORDESTINA DE PAPEL","commercialName":"","cnpj":"09116278000101","city":"CONDE","stateCode":"PB","buscaAdicional":""},{"id":"41dbbb85-c799-4963-5a2b-08d5ad2bf6ba","name":"COREMAS I GERACAO DE ENERGIA SPE S.A","commercialName":"","cnpj":"14285232000148","city":"COREMAS","stateCode":"PB","buscaAdicional":"COREMAS I 17185"},{"id":"4b4bae2f-978c-4865-5c49-08d5ad2bf6ba","name":"COREMAS II GERACAO DE ENERGIA SPE S.A","commercialName":"","cnpj":"14285242000183","city":"COREMAS","stateCode":"PB","buscaAdicional":"COREMAS II 51251"},{"id":"602b589f-d34f-400f-5c22-08d5ad2bf6ba","name":"A L PLAST - INDUSTRIA E COMERCIO DE PLASTICOS LTDA","commercialName":"ALPLAST","cnpj":"11108619000130","city":"GUARABIRA","stateCode":"PB","buscaAdicional":"ALPLAST 51115 ALPLAST 899747"},{"id":"fdd317a7-a315-4f50-5b37-08d5ad2bf6ba","name":"PLASTEX INDUSTRIA E COMERCIO DE MATERIAIS PLASTICOS LTDA","commercialName":"PLASTEX LTDA","cnpj":"05889784000174","city":"JOÃO PESSOA","stateCode":"PB","buscaAdicional":"PLASTEX 50528 PLASTEX 898209"},{"id":"68574ac0-b13a-40bd-5918-08d5ad2bf6ba","name":"CONDOMINIO EMPRESARIAL SHOPPING","commercialName":"CONDOMINIO MAG SHOPPING","cnpj":"05629163000151","city":"JOÃO PESSOA","stateCode":"PB","buscaAdicional":"MAG SHOPPING 13774 MAG SHOPPING 894382"},{"id":"eb3212ea-528e-4b8f-5824-08d5ad2bf6ba","name":"CENESUP - CENTRO NACIONAL DE ENSINO SUPERIOR LTDA","commercialName":"CENESUP - CENTRO NACIONAL DE ENSINO SUPERIOR","cnpj":"05474470000100","city":"JOÃO PESSOA","stateCode":"PB","buscaAdicional":"CENESUP 10829 CENESUP 890440"},{"id":"ed84bcde-cfbc-478a-5c9c-08d5ad2bf6ba","name":"GRAFICA SANTA MARTA LTDA","commercialName":"GRAFICA SANTA MARTA","cnpj":"09098419000100","city":"JOÃO PESSOA","stateCode":"PB","buscaAdicional":"SANTA MARTA 51399 GRAFICA STA MARTA 899230"},{"id":"45f8f956-9494-4e04-6054-08d5ad2bf6ba","name":"GRAFICA J B LTDA","commercialName":"","cnpj":"08540403000135","city":"JOÃO PESSOA","stateCode":"PB","buscaAdicional":"GRAFICA JB 53467 GRAFICA JB 901173"},{"id":"f778aee1-37b3-46c8-562c-08d5ad2bf6ba","name":"SHOPPING CENTER TAMBIA LTDA","commercialName":"SHOPING CENTER TAMBIA","cnpj":"03999542000108","city":"JOÃO PESSOA","stateCode":"PB","buscaAdicional":"TAMBIA 6720 SHOP TAMBIA 72383"},{"id":"6aed5f1c-5312-4a7f-56f4-08d5ad2bf6ba","name":"OPHBRAS COMPANHIA BRASILEIRA DE PRODUTOS OFTALMICOS","commercialName":"","cnpj":"41219148000107","city":"JOÃO PESSOA","stateCode":"PB","buscaAdicional":"OPHBRAS 8020 OPHBRAS 888332"},{"id":"6253bbef-41fa-4931-5777-08d5ad2bf6ba","name":"BRASTEX S/A","commercialName":"","cnpj":"09258807000101","city":"JOÃO PESSOA","stateCode":"PB","buscaAdicional":"BRASTEX 8889 BRASTEX I 889298 BRASTEX II 889319"},{"id":"e0a27ea1-76ac-4dfc-5400-08d5ad2bf6ba","name":"CONDOMINIO MANAIRA","commercialName":"CONDOMINIO MANAIRA","cnpj":"07770585000178","city":"JOÃO PESSOA","stateCode":"PB","buscaAdicional":"MANAIRA 3948 CONDOMINIO MANAIRA 71374"},{"id":"eca1dc1d-0271-40c9-526c-08d5ad2bf6ba","name":"CENTRAIS ELETRICAS DA PARAIBA S.A. - EPASA","commercialName":"CENTRAIS ELETRICAS DA PARAIBA S.A. - EPASA","cnpj":"10366780000141","city":"JOÃO PESSOA","stateCode":"PB","buscaAdicional":"EPASA 3051 TERMOPARAIBA 8565 UTE.PE.PB.029638-4.01 TERMONORDESTE 8566 UTE.PE.PB.029641-4.01"},{"id":"0cb02f8b-4882-4ab2-4f0f-08d5ad2bf6ba","name":"ENERGISA PARAIBA - DISTRIBUIDORA DE ENERGIA S.A","commercialName":"ENERGISA","cnpj":"09095183000140","city":"JOÃO PESSOA","stateCode":"PB","buscaAdicional":"ENERGISA PB 68 ENERGISA PB 23 ENERGISA DITC SC 72310"},{"id":"8e1d9531-96e8-4ba5-501f-08d5ad2bf6ba","name":"NORFIL S/A INDUSTRIA TEXTIL","commercialName":"","cnpj":"02341494000101","city":"JOÃO PESSOA","stateCode":"PB","buscaAdicional":"NORFIL 1458 NORFIL-JPESSOA 7851"},{"id":"aab89f52-78ae-47fa-68f5-08d5ad2bf6ba","name":"ASPEC SOCIEDADE PARAIBANA DE EDUCACAO E CULTURA LTDA","commercialName":"","cnpj":"05247100000130","city":"JOÃO PESSOA","stateCode":"PB","buscaAdicional":"ASPEC 60650 ASPEC 912513"},{"id":"2024e452-6ff4-4526-6832-08d5ad2bf6ba","name":"CONDOMINIO MANGABEIRA SHOPPING CENTER","commercialName":"CONDOMINIO MANGABEIRA","cnpj":"21205484000185","city":"JOÃO PESSOA","stateCode":"PB","buscaAdicional":"MANGABEIRA SHOPPING 59462 COND MANGABEIRA SHOP 910263"},{"id":"0ff52acd-3cae-4793-6633-08d5ad2bf6ba","name":"GENERGIA COMERCIALIZADORA DE ENERGIA LTDA","commercialName":"GCE COMERCIALIZADORA","cnpj":"26464333000165","city":"JOÃO PESSOA","stateCode":"PB","buscaAdicional":"GCE COMERCIALIZADORA 57388"},{"id":"9f841e2c-48e0-4e36-6781-08d5ad2bf6ba","name":"UNIMED JOAO PESSOA COOPERATIVA DE TRABALHO MEDICO","commercialName":"HOSPITAL ALBERTO URQUIZA WANDERLEY","cnpj":"08680639000339","city":"JOÃO PESSOA","stateCode":"PB","buscaAdicional":"UNIMED JP 58232 UNIMED JOAO PESSOA 908580"},{"id":"5482801f-699a-42fd-66e1-08d5ad2bf6ba","name":"CONDOMINIO ECO MEDICAL CENTER CARTAXO","commercialName":"ECO MEDICAL CENTER CARTAXO","cnpj":"11323041000135","city":"JOÃO PESSOA","stateCode":"PB","buscaAdicional":"ECO MEDICAL 57865 ECO MEDICAL CARTAXO 911268"},{"id":"d1c82682-b63b-48d5-6573-08d5ad2bf6ba","name":"MONTE ALEGRE FIOS LTDA","commercialName":"MATESA FIOS","cnpj":"09351366000180","city":"JOÃO PESSOA","stateCode":"PB","buscaAdicional":"MAFIOS PB 56732 MONTE ALEGRE FIOS 906344"},{"id":"6318bb0f-e6fa-40eb-627c-08d5ad2bf6ba","name":"IPE EDUCACIONAL LTDA","commercialName":"IPE","cnpj":"08679557000102","city":"JOÃO PESSOA","stateCode":"PB","buscaAdicional":"INST. PARAIBANOS 54782 INSTITUTO PARAIBANOS 904141"},{"id":"55098135-a49f-4935-622b-08d5ad2bf6ba","name":"NOVA DIAGNOSTICO POR IMAGEM LTDA","commercialName":"NOVA DIAGNOSTICO POR IMAGEM","cnpj":"04489715000100","city":"JOÃO PESSOA","stateCode":"PB","buscaAdicional":"NOVA DIAGNOSTICO 54602 NOVA DIAGNOSTICO IMA 904464"},{"id":"d285199c-8be4-4829-6705-08d5ad2bf6ba","name":"CRISTAL PIGMENTOS DO BRASIL S.A.","commercialName":"CRISTAL MINERACAO DO BRASIL","cnpj":"15115504000205","city":"MATARACA","stateCode":"PB","buscaAdicional":"CRISTAL PARAIBA 57929 CRISTAL MINEIRACAO 901374"},{"id":"16b3988c-bcae-4337-6348-08d5ad2bf6ba","name":"COMPANHIA BRASILEIRA DE VIDROS PLANOS - CBVP","commercialName":"VIVIX VIDROS PLANOS","cnpj":"10858291000379","city":"PEDRAS DE FOGO","stateCode":"PB","buscaAdicional":"VIVIXBENEF 55288 CIA BRAS DE VIDROS 906885"},{"id":"f684d5d7-1f27-42f5-59c3-08d5ad2bf6ba","name":"COMPANHIA DE CIMENTO DA PARAIBA - CCP","commercialName":"COMPANHIA DE CIMENTO DA PARAIBA","cnpj":"12616864000200","city":"PITIMBU","stateCode":"PB","buscaAdicional":"CIA CIMENTO PARAIBA 15475 BRENNAND - CCP 895023"},{"id":"96fe5d03-6c38-4dcf-5c44-08d5ad2bf6ba","name":"JAPUNGU AGROINDUSTRIAL LTDA","commercialName":"JAPUNGU","cnpj":"09357997000106","city":"SANTA RITA","stateCode":"PB","buscaAdicional":"UTE JAPUNGU 51238 JAPUNGU 898964 UTE.AI.PB.028515-3.01"},{"id":"59192f49-66dc-4af4-6108-08d5ad2bf6ba","name":"TEXNOR - TEXTIL DO NORDESTE S/A","commercialName":"TEXNOR","cnpj":"02667971000115","city":"SANTA RITA","stateCode":"PB","buscaAdicional":"TEXNOR 53976 TEXNOR TEXTIL NE 904465"},{"id":"fd5eb69e-eb2a-48f4-5eb1-08d5ad2bf6ba","name":"ADIMAX - INDUSTRIA E COMERCIO DE ALIMENTOS LTDA.","commercialName":"","cnpj":"03887324000262","city":"ABREU E LIMA","stateCode":"PE","buscaAdicional":"ADIMAX PE 52509 ADIMAX PE 905969"},{"id":"fd1b53f8-d5d0-47b6-62e1-08d5ad2bf6ba","name":"GI - INDUSTRIA DE PLASTICOS S/A","commercialName":"","cnpj":"11957833000161","city":"ABREU E LIMA","stateCode":"PE","buscaAdicional":"GI INDUSTRIA 55022 GI - INDUSTRIA 905047"},{"id":"7f6f2b40-d66a-4016-1cd3-08d5b8870181","name":"INDUSTRIAS REUNIDAS RENDA S/A","commercialName":"","cnpj":"11445160000160","city":"ABREU E LIMA","stateCode":"PE","buscaAdicional":"INDUSTRIAS RENDA 61970 INDUSTRIAS RENDA 912842"},{"id":"04d93e71-284c-478b-55ff-08d5ad2bf6ba","name":"COMPANHIA TEXTIL PE DE SERRA - EM RECUPERACAO JUDICIAL","commercialName":"","cnpj":"09570649000112","city":"ARARIPINA","stateCode":"PE","buscaAdicional":"PE DE SERRA 6492 PE DE SERRA 908494"},{"id":"068bc248-2a2a-4218-55c8-08d5ad2bf6ba","name":"ASA INDUSTRIA E COMERCIO LTDA","commercialName":"","cnpj":"01551272000819","city":"BELO JARDIM","stateCode":"PE","buscaAdicional":"COG-PALMEIRON 6117 ASA PALMEIRON-B JDM 71997"},{"id":"95df448a-1e1e-4d0c-5192-08d5ad2bf6ba","name":"ACUMULADORES MOURA S A","commercialName":"BATERIAS MOURA","cnpj":"09811654000170","city":"BELO JARDIM","stateCode":"PE","buscaAdicional":"ACUM MOURA 2377 AC. MOURA-BJARDIM-PE 70566 ACUM MOURA FILIAL 05 889245"},{"id":"1e419f47-d324-4aff-522d-08d5ad2bf6ba","name":"NOTARO ALIMENTOS LTDA","commercialName":"","cnpj":"01682695000100","city":"BELO JARDIM","stateCode":"PE","buscaAdicional":"NOTARO 2910 NOTARO ALIMENTOS 70771"},{"id":"0a7cdb38-9dae-4c87-6142-08d5ad2bf6ba","name":"NOTARO ALIMENTOS LTDA","commercialName":"NOTARO ALIMENTOS LTDA","cnpj":"01682695000878","city":"BELO JARDIM","stateCode":"PE","buscaAdicional":"NOTARO MATRIZEIRO BJ 54077 NOTARO MATRIZEIRO 905968"},{"id":"6c8234b7-53e1-4b3d-6286-08d5ad2bf6ba","name":"CRISTALPET DO BRASIL INDUSTRIA DE EMBALAGENS LTDA.","commercialName":"","cnpj":"09428630000136","city":"CABO DE SANTO AGOSTINHO","stateCode":"PE","buscaAdicional":"CRISTALPET DO BRASIL CE 54793 CRISTALPET DO BRASIL 905060"},{"id":"fef124ee-afd8-44aa-65eb-08d5ad2bf6ba","name":"CBMC EMPRESA DE MATERIAIS DE CONSTRUCAO LTDA","commercialName":"","cnpj":"13196196000183","city":"CABO DE SANTO AGOSTINHO","stateCode":"PE","buscaAdicional":"CBMC 57195 CBMC 906997"},{"id":"ee213529-911e-4384-6831-08d5ad2bf6ba","name":"SHOPPING CENTER COSTA DOURADA S/A","commercialName":"","cnpj":"03326640000346","city":"CABO DE SANTO AGOSTINHO","stateCode":"PE","buscaAdicional":"HOTEL INTERCITY 59459 INTERCITY CABO ST 911317"},{"id":"b69edc03-08ab-4ec7-7778-08d5d5286869","name":"CONE S.A.","commercialName":"","cnpj":"11860795000124","city":"CABO DE SANTO AGOSTINHO","stateCode":"PE","buscaAdicional":""},{"id":"7ea55a4c-25ed-4bda-a405-08d5d085fadd","name":"CONDOMINIO LOGISTICO CONE PLUG & PLAY 2","commercialName":"","cnpj":"20936943000138","city":"CABO DE SANTO AGOSTINHO","stateCode":"PE","buscaAdicional":""},{"id":"0a68c0d8-0d7e-403f-51b2-08d5ad2bf6ba","name":"ENERGETICA SUAPE II S.A.","commercialName":"","cnpj":"09373678000194","city":"CABO DE SANTO AGOSTINHO","stateCode":"PE","buscaAdicional":"SUAPE II 2513 SUAPE II 8909 UTE.PE.PE.029719-4.01"},{"id":"fada5e7f-323a-4595-51c9-08d5ad2bf6ba","name":"M&G FIBRAS BRASIL LTDA.","commercialName":"","cnpj":"04241585000192","city":"CABO DE SANTO AGOSTINHO","stateCode":"PE","buscaAdicional":"M&G BRASIL 2591 MEG BRASIL PE 7963"},{"id":"26400ef8-4ed2-4ae8-5278-08d5ad2bf6ba","name":"PAMESA DO BRASIL S/A","commercialName":"","cnpj":"03428529000107","city":"CABO DE SANTO AGOSTINHO","stateCode":"PE","buscaAdicional":"PAMESA APE 3077 PAMESA PE 70664 PAMESA-EXCEDENTE 8102 UTE.GN.PE.029189-7.01"},{"id":"b8e7e19f-7f89-46b2-4fa9-08d5ad2bf6ba","name":"MEXICHEM BRASIL INDUSTRIA DE TRANSFORMACAO PLASTICA LTDA","commercialName":"","cnpj":"58514928003785","city":"CABO DE SANTO AGOSTINHO","stateCode":"PE","buscaAdicional":"MEXICHEM SUAPE 1216 AMANCO PE 7839"},{"id":"a1b9c459-092a-4ca4-55b1-08d5ad2bf6ba","name":"MAXPET NORDESTE PLASTICOS E ENERGIA LTDA","commercialName":"","cnpj":"07788452000129","city":"CABO DE SANTO AGOSTINHO","stateCode":"PE","buscaAdicional":"MAXPET 6018 MAXPET-CB AGOSTINHO 71940"},{"id":"a4dd62f6-09cb-45b4-55fe-08d5ad2bf6ba","name":"AMCOR DO NORDESTE - INDUSTRIA E COMERCIO DE EMBALAGENS LTDA","commercialName":"","cnpj":"12350811000100","city":"CABO DE SANTO AGOSTINHO","stateCode":"PE","buscaAdicional":"AMCOR SUAPE 6491 AMCOR SUAPE 888391"},{"id":"4ca70f5e-d0ae-45cd-57c0-08d5ad2bf6ba","name":"CONDOMINIO DO SHOPPING CENTER COSTA DOURADA S/A","commercialName":"","cnpj":"11737619000108","city":"CABO DE SANTO AGOSTINHO","stateCode":"PE","buscaAdicional":"COSTADOURADA 9571 COSTA DOURADA 891483"},{"id":"fda99939-0d26-49f4-53b0-08d5ad2bf6ba","name":"TERPHANE LTDA","commercialName":"","cnpj":"02429732000127","city":"CABO DE SANTO AGOSTINHO","stateCode":"PE","buscaAdicional":"TERPHANE NE 3773 TERPHANE- AGOSTINHO 71308"},{"id":"8f1c3a43-7154-4901-53c1-08d5ad2bf6ba","name":"DURATEX S.A.","commercialName":"","cnpj":"97837181002948","city":"CABO DE SANTO AGOSTINHO","stateCode":"PE","buscaAdicional":"DECA LR 3825 DECA LR 70765"},{"id":"1729ffcd-b0a1-4ea2-5380-08d5ad2bf6ba","name":"CERAMICA PORTO RICO LTDA","commercialName":"","cnpj":"70237185000138","city":"CABO DE SANTO AGOSTINHO","stateCode":"PE","buscaAdicional":"PORTO RICO 3660 PORTO RICO 71372"},{"id":"65163bc0-0174-4c51-5549-08d5ad2bf6ba","name":"SIMISA SIMIONI METALURGICA LTDA EM RECUPERACAO JUDICIAL","commercialName":"","cnpj":"55820583000350","city":"CABO DE SANTO AGOSTINHO","stateCode":"PE","buscaAdicional":"SIMISA PE 5249 SIMISA 72285"},{"id":"ea0e0871-2569-4d66-5e2b-08d5ad2bf6ba","name":"PERNOD RICARD BRASIL INDUSTRIA E COMERCIO LTDA","commercialName":"","cnpj":"33856394000133","city":"CABO DE SANTO AGOSTINHO","stateCode":"PE","buscaAdicional":"PERNOD RICARD 52241 PERNOD RICARD - RES 899943 PERNOD RICARD 899761"},{"id":"efb4ddad-664f-4faa-5bb5-08d5ad2bf6ba","name":"EMPLAL NORDESTE EMBALAGENS PLASTICAS LTDA","commercialName":"","cnpj":"05644020000119","city":"CABO DE SANTO AGOSTINHO","stateCode":"PE","buscaAdicional":"EMPLAL NE 50869 EMPLAL NORDESTE 899812"},{"id":"4817ddaf-9c0a-4559-58f0-08d5ad2bf6ba","name":"VENTOS DE SANTA BRIGIDA I ENERGIAS RENOVAVEIS S.A","commercialName":"","cnpj":"17875304000103","city":"CAETÉS","stateCode":"PE","buscaAdicional":"VENTOS DE SANTA BRIGIDA I 13478 SANTA BRIGIDA I 896544 EOL.CV.PE.031365-3.01"},{"id":"cccdc6d4-4ef9-4443-58f1-08d5ad2bf6ba","name":"VENTOS DE SANTA BRIGIDA II ENERGIAS RENOVAVEIS S.A","commercialName":"","cnpj":"17875194000171","city":"CAETÉS","stateCode":"PE","buscaAdicional":"VENTOS DE SANTA BRIGIDA II 13479 SANTA BRIGIDA II 896547 EOL.CV.PE.031363-7.01"},{"id":"b7ad06d9-1006-4b02-59fb-08d5ad2bf6ba","name":"USINA CENTRAL OLHO D'AGUA S/A","commercialName":"","cnpj":"11797222000101","city":"CAMUTANGA","stateCode":"PE","buscaAdicional":"USICODA 16255 UTE OLHO DAGUA 895124 UTE.AI.PE.028692-3.01"},{"id":"ebacae1b-5a3d-4c77-5bc0-08d5ad2bf6ba","name":"MINERADORA VALE DO PAJEU LTDA","commercialName":"","cnpj":"07387064000136","city":"CARNAÍBA","stateCode":"PE","buscaAdicional":"PAJEU 50882 PAJEU 898838"},{"id":"8a86c4e7-9fb9-4569-5aed-08d5ad2bf6ba","name":"AGIR AGRESTE INDUSTRIAL DE RAFIA S/A","commercialName":"AGIR","cnpj":"24111809000230","city":"CARUARU","stateCode":"PE","buscaAdicional":"TRA-AGIR 50356 AGIR AGRESTE 898090"},{"id":"436df018-5d15-415d-5af4-08d5ad2bf6ba","name":"ETICAL-ETIQUETAS CARUARU LTDA","commercialName":"","cnpj":"41241266000103","city":"CARUARU","stateCode":"PE","buscaAdicional":"TRA-ETICAL 50371 ETICAL ETIQUETAS 898042"},{"id":"1961cdca-3038-4ef5-8874-08d5ae44ed50","name":"CONDOMINIO SHOPPING CARUARU","commercialName":"","cnpj":"11077028000143","city":"CARUARU","stateCode":"PE","buscaAdicional":"SHOP CARUARU 6798"},{"id":"7b94b3ab-5120-43e1-6722-08d5ad2bf6ba","name":"SUBCONDOMINIO DO CARUARU SHOPPING","commercialName":"SUBCONDOMINIO DO CARUARU SHOPPING","cnpj":"24631801000113","city":"CARUARU","stateCode":"PE","buscaAdicional":"CARUARU SHOPPING 57973 SHOPPING CARUARU 72219"},{"id":"a5ba161e-27aa-4692-6733-08d5ad2bf6ba","name":"SOCIEDADE DE EDUCACAO DO VALE DO IPOJUCA S/A","commercialName":"UNIFAVIP","cnpj":"02738361000165","city":"CARUARU","stateCode":"PE","buscaAdicional":"UNIFAVIP 58001 SOC EDUC VALE IPOJUC 909291"},{"id":"b9807e36-cf3a-4612-66f0-08d5ad2bf6ba","name":"EPLAST NORDESTE S/A","commercialName":"EPLAST NORDESTE","cnpj":"15395884000106","city":"ESCADA","stateCode":"PE","buscaAdicional":"EPLAST NORDESTE S/A 57891 EPLAST NORDESTE 909998"},{"id":"a1a5e092-06ec-4f6c-65fd-08d5ad2bf6ba","name":"DAIRY PARTNERS AMERICAS NORDESTE - PRODUTOS ALIMENTICIOS LTDA.","commercialName":"DPA NORDESTE","cnpj":"10331731000173","city":"GARANHUNS","stateCode":"PE","buscaAdicional":"DPA NE 57256 DPA NE 907126"},{"id":"9388cc6a-43e1-41ea-5a7a-08d5ad2bf6ba","name":"UNILEVER BRASIL INDUSTRIAL LTDA","commercialName":"","cnpj":"01615814004433","city":"GARANHUNS","stateCode":"PE","buscaAdicional":"UNIGARANHUNS 49744 UNIGARANHUNS 896446"},{"id":"deaa56ec-578d-43c8-5929-08d5ad2bf6ba","name":"FERREIRA COSTA & CIA LTDA","commercialName":"","cnpj":"10230480000130","city":"GARANHUNS","stateCode":"PE","buscaAdicional":"FERREIRA COSTA 13938 F COSTA IMBIRIBEIRA 893226 F COSTA TAMARINEIRA 893263 F COSTA GARANHUNS 893264 F COSTA PARALELA 895026 F COSTA SE 905800"},{"id":"ed698a88-2fd4-4977-52a1-08d5ad2bf6ba","name":"NOTARO ALIMENTOS LTDA","commercialName":"NOTARO ALIMENTOS LTDA","cnpj":"01682695000525","city":"GARANHUNS","stateCode":"PE","buscaAdicional":"NOTARO GARAN 3190 NOTARO GARANHUNS 71036"},{"id":"c41f1b5c-8c44-4793-5261-08d5ad2bf6ba","name":"EMPRESA ENERGETICA STA. TERESA LTDA","commercialName":"","cnpj":"05462677000165","city":"GOIANA","stateCode":"PE","buscaAdicional":"SANTA TERESA 3038 SANTA TERESA 8744 UTE.AI.PE.028933-7.01"},{"id":"c7fcf5a9-f743-4d8a-509c-08d5ad2bf6ba","name":"ITAPESSOCA AGRO INDUSTRIAL SA","commercialName":"","cnpj":"10318806000186","city":"GOIANA","stateCode":"PE","buscaAdicional":"ITAPESSOCA 1747 ITAPESSOCA AGRO IND 70112"},{"id":"12580e40-527b-406e-636f-08d5ad2bf6ba","name":"COMPANHIA BRASILEIRA DE VIDROS PLANOS - CBVP","commercialName":"VIVIX VIDROS PLANOS","cnpj":"10858291000298","city":"GOIANA","stateCode":"PE","buscaAdicional":"VIVIXFAB 55350 CBVP - VIVIX FABRICA 906996"},{"id":"0020c2e8-cf6c-46f1-549e-08d5ad2bf6ba","name":"CENTRAL GERADORA HIDRELETRICA POCO DA CRUZ LTDA","commercialName":"CGH POCO DA CRUZ","cnpj":"12902200000119","city":"IBIMIRIM","stateCode":"PE","buscaAdicional":"CGHPCRUZ 4385 POCO DA CRUZ 8889 CGH.PH.PE.030539-1.01"},{"id":"102de125-d9a5-48cf-5392-08d5ad2bf6ba","name":"PRODUQUIMICA INDUSTRIA E COMERCIO S/A","commercialName":"","cnpj":"60398138001275","city":"IGARASSU","stateCode":"PE","buscaAdicional":"PRODUQUIMICA 3700 PRODUQUIMICA IND COM 71218"},{"id":"9ec6c1b1-e3ea-4c25-57ee-08d5ad2bf6ba","name":"MUSASHI DO BRASIL LTDA","commercialName":"","cnpj":"10963007000162","city":"IGARASSU","stateCode":"PE","buscaAdicional":"MUSASHI 10129 MUSASHI DO BRASIL 889278"},{"id":"eb9490b3-76e1-4403-55e2-08d5ad2bf6ba","name":"INDUSTRIA DE BEBIDAS IGARASSU LTDA","commercialName":"","cnpj":"07050184000143","city":"IGARASSU","stateCode":"PE","buscaAdicional":"HEINEKEN IGARASSU 6273 SCHIN-IGARASSU 71949"},{"id":"e19461cc-123d-4fb6-55ec-08d5ad2bf6ba","name":"TERMELETRICA PERNAMBUCO III S.A.","commercialName":"","cnpj":"10502676000137","city":"IGARASSU","stateCode":"PE","buscaAdicional":"PERNAMBUCO 3 6311 PERNAMBUCO III 888048 UTE.PE.PE.030120-5.01"},{"id":"f4e30d9a-7a1b-416f-52fe-08d5ad2bf6ba","name":"ONDUNORTE CIA DE PAPEIS E PAPELAO ONDULADO DO NORTE EM RECUPERACAO JUDICIAL","commercialName":"","cnpj":"10808699000174","city":"IGARASSU","stateCode":"PE","buscaAdicional":"ONDUNORTE 3426 ONDUNORTE IGARASSU 71055"},{"id":"1cd91515-9cfb-4410-58af-08d5ad2bf6ba","name":"UNILEVER BRASIL INDUSTRIAL LTDA","commercialName":"","cnpj":"01615814008005","city":"IGARASSU","stateCode":"PE","buscaAdicional":"UNILEVER IGARASSU 12872 UNIIGARASSU-PE 71462"},{"id":"921efdb5-67bb-40aa-57f3-08d5ad2bf6ba","name":"SAINT-GOBAIN DO BRASIL PRODUTOS INDUSTRIAIS E PARA CONSTRUCAO LTDA","commercialName":"SAINT-GOBAIN","cnpj":"61064838012069","city":"IGARASSU","stateCode":"PE","buscaAdicional":"SGABR IGARASSU 10209 S GOBAIN IGARASSU 889636"},{"id":"1cb349d5-9a21-47da-6167-08d5ad2bf6ba","name":"HARYON INDUSTRIA E COMERCIO DE FRALDAS E COSMETICOS LTDA","commercialName":"BABY ROGER","cnpj":"08405510000150","city":"IGARASSU","stateCode":"PE","buscaAdicional":"BABY ROGER 54175 HARYON 905050"},{"id":"993333e7-a3fa-4bb8-63e5-08d5ad2bf6ba","name":"SUATA SERVICO UNIFICADO DE ARMAZENAGEM E TERMINAL ALFANDEGADO S A","commercialName":"","cnpj":"03928105000101","city":"IPOJUCA","stateCode":"PE","buscaAdicional":"SUATA SERVICO 55695 SUATA - IPOJUCA - PE 907127"},{"id":"16912900-9109-4ed5-6807-08d5ad2bf6ba","name":"VARD PROMAR S.A.","commercialName":"","cnpj":"11084194000177","city":"IPOJUCA","stateCode":"PE","buscaAdicional":"VARD PROMAR SA 59193 VARD PROMAR 908621"},{"id":"d68ee307-cd93-4857-60bc-08d5ad2bf6ba","name":"LM WIND POWER DO BRASIL S.A.","commercialName":"","cnpj":"17596025000100","city":"IPOJUCA","stateCode":"PE","buscaAdicional":"LM WIND POWER 53652 LM WIND POWER 907124"},{"id":"349b5e97-ee3e-4a68-515d-08d5ad2bf6ba","name":"M&G POLIMEROS BRASIL S.A.","commercialName":"","cnpj":"07079511000190","city":"IPOJUCA","stateCode":"PE","buscaAdicional":"M G IPOJUCA 2138 MG-IPOJUCA 71785"},{"id":"5d47a93c-6586-45c8-56d8-08d5ad2bf6ba","name":"TECON SUAPE S/A","commercialName":"","cnpj":"04471564000163","city":"IPOJUCA","stateCode":"PE","buscaAdicional":"TECON SUAPE 7822 TECON SUAPE I 72384"},{"id":"cf61556b-7415-42c6-53a1-08d5ad2bf6ba","name":"UNILEVER BRASIL INDUSTRIAL LTDA","commercialName":"RMB LTDA","cnpj":"01615814006800","city":"IPOJUCA","stateCode":"PE","buscaAdicional":"UNIIPOJUCA 3739 UNILEVER IPOJUCA 71568 UNIPOJUCA 906238"},{"id":"c24e327d-9181-4321-54e8-08d5ad2bf6ba","name":"ESTALEIRO ATLANTICO SUL S/A","commercialName":"","cnpj":"07699082000153","city":"IPOJUCA","stateCode":"PE","buscaAdicional":"EAS 4584 ESTALEIRO ATLANTICO 71708"},{"id":"f5775052-f532-4804-65dd-08d5ad2bf6ba","name":"CERVEJARIA PETROPOLIS DE PERNAMBUCO LTDA","commercialName":"","cnpj":"16622166000180","city":"ITAPISSUMA","stateCode":"PE","buscaAdicional":"CP MATRIZ_PE 57178 CP ITAPISSUMA - PE 906977"},{"id":"3302f847-8f9b-46dd-6204-08d5ad2bf6ba","name":"BIMBO DO BRASIL LTDA","commercialName":"","cnpj":"35402759000690","city":"JABOATÃO DOS GUARARAPES","stateCode":"PE","buscaAdicional":"BIMBO PE 54505 BIMBO GUARARAPES 904301"},{"id":"12c4eb73-6f13-4042-53a2-08d5ad2bf6ba","name":"UNILEVER BRASIL GELADOS DO NORDESTE S/A","commercialName":"","cnpj":"11173911000137","city":"JABOATÃO DOS GUARARAPES","stateCode":"PE","buscaAdicional":"UNISORVANE 3740 UNISORVANE 71366"},{"id":"1c935537-6b07-4925-5711-08d5ad2bf6ba","name":"REFRESCOS GUARARAPES LTDA","commercialName":"","cnpj":"08715757000173","city":"JABOATÃO DOS GUARARAPES","stateCode":"PE","buscaAdicional":"REFR GUARARAPE 8185 REFR GUARAP J PESSOA 889252"},{"id":"1743af98-796f-49ba-573f-08d5ad2bf6ba","name":"TINTAS IQUINE LTDA.","commercialName":"","cnpj":"09722463000131","city":"JABOATÃO DOS GUARARAPES","stateCode":"PE","buscaAdicional":"COG IQUINEPE 8389 TINTAS IQUINE 889061"},{"id":"203b97c8-3bdb-4a3f-5203-08d5ad2bf6ba","name":"CELULOSE E PAPEL DE PERNAMBUCO S/A- CEPASA","commercialName":"","cnpj":"10422699000131","city":"JABOATÃO DOS GUARARAPES","stateCode":"PE","buscaAdicional":"CEPASA 2790 CEPASA JABOATAO 70718"},{"id":"d1a13ccb-ae66-4973-52b1-08d5ad2bf6ba","name":"WHITE MARTINS GASES INDUSTRIAIS DO NORDESTE LTDA.","commercialName":"","cnpj":"24380578000189","city":"JABOATÃO DOS GUARARAPES","stateCode":"PE","buscaAdicional":"WMGINE 3245 WHITE MARTINS CABO 70975 W MARTINS COPENE 71752"},{"id":"a62712f8-6550-4c18-5df1-08d5ad2bf6ba","name":"SUPERMERCADO DA FAMILIA LTDA","commercialName":"SUPERMERCADO DA FAMILIA LTDA","cnpj":"05677591002799","city":"JABOATÃO DOS GUARARAPES","stateCode":"PE","buscaAdicional":"ARCOMIX-CD 52078 ARCOVITA 899216 ARCOMIX-CD 899217 ARCOMIXLJ22 904469 ARCOMIX LJ 07 905354"},{"id":"dab04e95-8f44-4380-5db8-08d5ad2bf6ba","name":"FIABESA GUARARAPES S/A","commercialName":"","cnpj":"03083850000270","city":"JABOATÃO DOS GUARARAPES","stateCode":"PE","buscaAdicional":"FIABESA 51965 FIABESA AGUAS BELAS 900474 FIABESA GUARARAPES 900674"},{"id":"2df127fa-da27-44a8-5dcb-08d5ad2bf6ba","name":"ALPHA PLAST-INDUSTRIA E COMERCIO LTDA","commercialName":"","cnpj":"03357873000144","city":"JABOATÃO DOS GUARARAPES","stateCode":"PE","buscaAdicional":"ALPHA PLAST 51988 ALPHA PLAST 899220 ALPHA PLAST IND 900012"},{"id":"f0565b8c-8b9d-4031-5b95-08d5ad2bf6ba","name":"CONDOMINIO DO SHOPPING CENTER GUARARAPES","commercialName":"","cnpj":"41090689000170","city":"JABOATÃO DOS GUARARAPES","stateCode":"PE","buscaAdicional":"SHOPPING GUARARAPES 50772 SHOPPING GUARARAPES 899316"},{"id":"2812441d-e7dd-4b31-5b66-08d5ad2bf6ba","name":"RUPLAST INDUSTRIA E COMERCIO LTDA","commercialName":"RUPLAST","cnpj":"05559838000133","city":"JABOATÃO DOS GUARARAPES","stateCode":"PE","buscaAdicional":"RUPLAST 50694 RUPLAST 899298"},{"id":"08676059-c616-4a61-694b-08d5ad2bf6ba","name":"TERMOELETRICA ITAENGA LTDA","commercialName":"","cnpj":"04847997000170","city":"LAGOA DE ITAENGA","stateCode":"PE","buscaAdicional":"ITAENGA 2 61027 ITAENGA 8217 UTE.AI.PE.028539-0.01"},{"id":"d7b2bc59-bfda-4e3a-ad24-08d5d70c553b","name":"USINA PETRIBU SA","commercialName":"","cnpj":"10645075000183","city":"LAGOA DE ITAENGA","stateCode":"PE","buscaAdicional":""},{"id":"56641b4f-5ba2-4c97-6477-08d5ad2bf6ba","name":"GL INDUSTRIA E DISTRIBUICAO DE ALIMENTOS S.A","commercialName":"","cnpj":"17090600000190","city":"MORENO","stateCode":"PE","buscaAdicional":"CAPRICCHE 56018 GL IND DIST ALIMENTO 907136"},{"id":"b5d68d41-657f-4d9a-5aa0-08d5ad2bf6ba","name":"ONDUNORTE CIA DE PAPEIS E PAPELAO ONDULADO DO NORTE EM RECUPERACAO JUDICIAL","commercialName":"ONDUNORTE UNIDADE III","cnpj":"10808699000336","city":"MORENO","stateCode":"PE","buscaAdicional":"ONDUNORTE III 50118 ONDUNORTE MORENO 897707"},{"id":"f8b983cc-1cc6-438e-604d-08d5ad2bf6ba","name":"PINCEIS ROMA LTDA","commercialName":"PINCEIS ROMA NORDESTE","cnpj":"01829476000283","city":"NAZARÉ DA MATA","stateCode":"PE","buscaAdicional":"PINCEIS ROMA NORDESTE 53457 PINCEIS ROMA 900834"},{"id":"e7099e5c-9d19-4b05-5ef9-08d5ad2bf6ba","name":"EMPRESA DE TURISMO DE PERNAMBUCO GOVERNADOR EDUARDO CAMPOS - EMPETUR","commercialName":"EMPETUR","cnpj":"10931533000140","city":"OLINDA","stateCode":"PE","buscaAdicional":"EMPETUR 52673 EMPETUR 899852"},{"id":"c799ed2a-8667-4bdd-62fa-08d5ad2bf6ba","name":"MOINHOS CRUZEIRO DO SUL S A","commercialName":"MOINHOS CRUZEIRO DO SUL S/A","cnpj":"88301155002233","city":"OLINDA","stateCode":"PE","buscaAdicional":"M CRUZEIRO PE 55066 MOINHOS CRUZEIRO 905061"},{"id":"374815b6-063f-4b26-58f2-08d5ad2bf6ba","name":"VENTOS DE SANTA BRIGIDA III ENERGIAS RENOVAVEIS S.A","commercialName":"","cnpj":"17875184000136","city":"PARANATAMA","stateCode":"PE","buscaAdicional":"VENTOS DE SANTA BRIGIDA III 13480 SANTA BRIGIDA III 896548 EOL.CV.PE.031354-8.01"},{"id":"e44ece40-f970-4311-58f3-08d5ad2bf6ba","name":"VENTOS DE SANTA BRIGIDA IV ENERGIAS RENOVAVEIS S.A","commercialName":"","cnpj":"17875122000124","city":"PARANATAMA","stateCode":"PE","buscaAdicional":"VENTOS DE SANTA BRIGIDA IV 13481 SANTA BRIGIDA IV 896549 EOL.CV.PE.031370-0.01"},{"id":"5ed7b52b-ec8a-4137-58f4-08d5ad2bf6ba","name":"VENTOS DE SANTA BRIGIDA V ENERGIAS RENOVAVEIS S.A","commercialName":"","cnpj":"17875103000106","city":"PARANATAMA","stateCode":"PE","buscaAdicional":"VENTOS DE SANTA BRIGIDA V 13482 SANTA BRIGIDA 5 896550 EOL.CV.PE.031346-7.01"},{"id":"21073abd-645b-4360-58f5-08d5ad2bf6ba","name":"VENTOS DE SANTA BRIGIDA VI ENERGIAS RENOVAVEIS S.A","commercialName":"","cnpj":"17875341000103","city":"PARANATAMA","stateCode":"PE","buscaAdicional":"VENTOS DE SANTA BRIGIDA VI 13483 SANTA BRIGIDA VI 896564 EOL.CV.PE.031353-0.01"},{"id":"06908fd8-c86e-46df-58f6-08d5ad2bf6ba","name":"VENTOS DE SANTA BRIGIDA VII ENERGIAS RENOVAVEIS S.A","commercialName":"","cnpj":"17875270000149","city":"PARANATAMA","stateCode":"PE","buscaAdicional":"VENTOS DE SANTA BRIGIDA VII 13484 SANTA BRIGIDA VII 896551 EOL.CV.PE.031422-6.01"},{"id":"6c01c7df-e7a8-4a80-5b70-08d5ad2bf6ba","name":"SANDENE S.A. INDUSTRIA E COMERCIO","commercialName":"","cnpj":"08365633000105","city":"PAULISTA","stateCode":"PE","buscaAdicional":"SANDENE 50705 SANDENE 900074 SANDENE - PAULISTA 913433"},{"id":"5afca556-04c3-4b57-5e17-08d5ad2bf6ba","name":"PISANI PLASTICOS S.A","commercialName":"","cnpj":"87833737000416","city":"PAULISTA","stateCode":"PE","buscaAdicional":"PISANI PE 52193 PISANI PLASTICOS SA 901373"},{"id":"4595b8c4-3ad0-4524-56f7-08d5ad2bf6ba","name":"INDUSTRIAS REUNIDAS RAYMUNDO DA FONTE SA","commercialName":"","cnpj":"11507415000172","city":"PAULISTA","stateCode":"PE","buscaAdicional":"RAYMUNDO FONTE 8041 RAYMUNDO FONTE 72430"},{"id":"dec3d175-a5cb-4a6e-53b6-08d5ad2bf6ba","name":"SANTISTA WORK SOLUTION S.A.","commercialName":"","cnpj":"61520607000600","city":"PAULISTA","stateCode":"PE","buscaAdicional":"TAVEX PTA 3794 TAVEX BRAIL S/A 70900"},{"id":"4a19683a-0e90-4137-616a-08d5ad2bf6ba","name":"GLOBALPACK DO NORDESTE INDUSTRIA E COMERCIO LTDA","commercialName":"","cnpj":"02385898000199","city":"PAULISTA","stateCode":"PE","buscaAdicional":"GLOBALPACK NORDESTE 54178 GLOBALPACK NORDESTE 903440 GLOBALPACK BAHIA 907145 GLOBALPACK PE 907841"},{"id":"d219e3e6-bcdf-4d0c-6558-08d5ad2bf6ba","name":"SUPERFIOS TEXTIL LTDA","commercialName":"","cnpj":"01912239000109","city":"PAULISTA","stateCode":"PE","buscaAdicional":"SUPERFIOS 56661 SUPERFIOS 908262"},{"id":"07c4b49a-7daf-4c63-63d4-08d5ad2bf6ba","name":"CONDOMINIO DO NORTH WAY SHOPPING","commercialName":"","cnpj":"22424335000170","city":"PAULISTA","stateCode":"PE","buscaAdicional":"PAULISTA NORTH WAY SHOPPING 55645 CONDOMINIO NORTH WAY 906329"},{"id":"19b81304-a158-4512-6945-08d5ad2bf6ba","name":"CONDOMINIO DO COMPLEXO INDUSTRIAL E EMPRESARIAL NORTE","commercialName":"CONDOMINIO INDUSTRIAL VICUNHA","cnpj":"11428803000168","city":"PAULISTA","stateCode":"PE","buscaAdicional":"CCIEN 60953 CCIEN 912494"},{"id":"c0653598-d77f-4faf-d6da-08d5c71061c2","name":"PAULISTEX INDUSTRIAL LTDA","commercialName":"PAULISTEX INDUSTRIAL","cnpj":"01800067000173","city":"PAULISTA","stateCode":"PE","buscaAdicional":""},{"id":"cdc64448-1991-408f-5c62-08d5ad2bf6ba","name":"BETANIA LACTEOS S.A.","commercialName":"","cnpj":"10483444000774","city":"PEDRA","stateCode":"PE","buscaAdicional":"CBL PEDRA 51291 CBL PEDRA ALIMENTOS 898780"},{"id":"99d67e32-dac1-41fd-5793-08d5ad2bf6ba","name":"PEPSICO AMACOCO BEBIDAS DO BRASIL LTDA","commercialName":"","cnpj":"09644104000375","city":"PETROLINA","stateCode":"PE","buscaAdicional":"PEPSICO PETROL 9070 PEPSICO AMACOCO 889038"},{"id":"366e3ce1-2ff7-44c4-5246-08d5ad2bf6ba","name":"SAO FRANCISCO TEXTIL S/A","commercialName":"","cnpj":"02710680000162","city":"PETROLINA","stateCode":"PE","buscaAdicional":"SAOFRANCISCO 2985 SAO FRANCISCO TEXTIL 70801"},{"id":"9715c340-8213-4e79-4f99-08d5ad2bf6ba","name":"COMPANHIA ENERGETICA DE PETROLINA","commercialName":"","cnpj":"04811856000106","city":"PETROLINA","stateCode":"PE","buscaAdicional":"PETROLINA 1181 PETROLINA 8412 UTE.PE.PE.028584-6.01 PETROLINA EXP. 88273 UTE.PE.PE.028584-6.01"},{"id":"d96078ae-415c-429d-4ee8-08d5ad2bf6ba","name":"COMPANHIA ENERGETICA DE PERNAMBUCO","commercialName":"CELPE","cnpj":"10835932000108","city":"RECIFE","stateCode":"PE","buscaAdicional":"CELPE 17 CELPE 20 CELPE DITC 70759"},{"id":"dbf2bca8-a632-4646-4ef1-08d5ad2bf6ba","name":"COMPANHIA HIDRO ELETRICA DO SAO FRANCISCO","commercialName":"CHESF","cnpj":"33541368000116","city":"RECIFE","stateCode":"PE","buscaAdicional":"CHESF 26 XINGO 218 UHE.PH.SE.027053-9.01 PEDRA 222 UHE.PH.BA.027052-0.01 PA 1+2+3+4+AP. SALES 212 UHE.PH.BA.002012-5.01, UHE.PH.BA.027048-2.01, UHE.PH.BA.027049-0.01, UHE.PH.BA.027050-4.01, UHE.PH.AL.001510-5.01 ITAPARICA 217 UHE.PH.PE.001174-6.01 FUNIL (COTA) 379 UHE.PH.BA.027046-6.01 BOA ESPERANCA 220 UHE.PH.PI.000267-4.01 PEDRA (ACL) 889273 UHE.PH.BA.027052-0.01 CUREMAS 378 PCH.PH.PB.027402-0.01 FUNIL (LIVRE) 889275 UHE.PH.BA.027046-6.01 ARARAS 380 PCH.PH.CE.027943-9.01 CASA NOVA 2 909107 EOL.CV.BA.031519-2.01 CASA NOVA 3 909108 EOL.CV.BA.031524-9.01 PA IAIV+A.S. (CHESF) 889272 UHE.PH.BA.002012-5.01, UHE.PH.BA.027048-2.01, UHE.PH.BA.027049-0.01, UHE.PH.BA.027050-4.01, UHE.PH.AL.001510-5.01 ITAPARICA (LIVRE) 889276 UHE.PH.PE.001174-6.01 XINGO (ACL) 889277 UHE.PH.SE.027053-9.01 SOBRADINHO 219 UHE.PH.BA.002755-3.01 BOA ESPERANCA (ACL) 889274 UHE.PH.PI.000267-4.01 CAMACARI 221 UTE.GN.BA.000602-5.01"},{"id":"8de06c00-c133-4746-50d8-08d5ad2bf6ba","name":"EMPRESA ENERGETICA PORTO DAS PEDRAS S.A.","commercialName":"","cnpj":"05774615000199","city":"RECIFE","stateCode":"PE","buscaAdicional":"EEPP 1869 PORTO DAS PEDRAS 8395 PCH.PH.MS.028995-7.01"},{"id":"a28a38b1-9acd-4d0c-50dc-08d5ad2bf6ba","name":"CENTRAIS ELETRICAS DE PERNAMBUCO S.A. - EPESA","commercialName":"","cnpj":"06212748000134","city":"RECIFE","stateCode":"PE","buscaAdicional":"EPESA 1875 PAU FERRO I 8418 UTE.PE.PE.029561-2.01 TERMOMANAUS 8419 UTE.PE.PE.029562-0.01"},{"id":"720aded5-74be-4842-5111-08d5ad2bf6ba","name":"VOTORANTIM CIMENTOS N/NE S/A","commercialName":"","cnpj":"10656452000180","city":"RECIFE","stateCode":"PE","buscaAdicional":"VCNNE 1974 CIMESA-FAZ BRANDAO 7240 VCNNE SOBRAL 71423 VCNNE POTY PAULISTA 72025 VCNNE POTY-SOBRAL 71554 VCNNE PECEM 901022 VCNNE-PORTO VELHO 71782 VCNNE PRIMAVERA 907710 VCNNE XAMBOA 908435 MAVCPEENTR101 913352 PEDRA DO CAVALO 8054 UHE.PH.BA.028565-0.01"},{"id":"fbed4e87-7fd5-4ddf-51c4-08d5ad2bf6ba","name":"KROMA COMERCIALIZADORA DE ENERGIA LTDA","commercialName":"KROMA ENERGIA","cnpj":"10202852000115","city":"RECIFE","stateCode":"PE","buscaAdicional":"KROMA 2579 IPOJUCA 342 UTE.AI.PE.028707-5.01 UNIAO INDUSTRIA 543 CGH.PH.PE.028695-8.01 e CGH.PH.PE.028693-1.01 CETRELBIO 889619 UTE.AI.PE.030940-0.01"},{"id":"64ae0186-4e8b-4ae8-51de-08d5ad2bf6ba","name":"BRENNAND ENERGIA COMERCIALIZADORA S/A","commercialName":"","cnpj":"10359788000180","city":"RECIFE","stateCode":"PE","buscaAdicional":"BE COM 2690"},{"id":"b2d1dda8-08fb-4059-51df-08d5ad2bf6ba","name":"BRENNAND INVESTIMENTOS COMERCIALIZADORA S/A","commercialName":"","cnpj":"10359802000146","city":"RECIFE","stateCode":"PE","buscaAdicional":"BI COM 2691"},{"id":"0423e32b-25d7-4a49-51e3-08d5ad2bf6ba","name":"PLANALTO ENERGETICA S.A.","commercialName":"","cnpj":"07953660000136","city":"RECIFE","stateCode":"PE","buscaAdicional":"PCH PLANALTO 2698 PLANALTO 8532 PCH.PH.GO.028737-7.01"},{"id":"48cb8778-bd27-43fd-5139-08d5ad2bf6ba","name":"ENERGIANE LTDA","commercialName":"ENERGIA-NE","cnpj":"06030459000114","city":"RECIFE","stateCode":"PE","buscaAdicional":"ENERGIA-NE 2054"},{"id":"e9c51f99-2f74-49f5-5198-08d5ad2bf6ba","name":"OURO ENERGETICA S/A.","commercialName":"","cnpj":"06087883000103","city":"RECIFE","stateCode":"PE","buscaAdicional":"OURO 2425 OURO 8505 PCH.PH.RS.028968-0.01"},{"id":"76026440-cbb8-48e3-519f-08d5ad2bf6ba","name":"VARZEA DO JUBA ENERGETICA S/A","commercialName":"","cnpj":"06941602000120","city":"RECIFE","stateCode":"PE","buscaAdicional":"GRACA I5 2437 TERRA SANTA 8342 PCH.PH.MT.029367-9.01"},{"id":"2d40e50d-9f7c-43ba-516e-08d5ad2bf6ba","name":"IBIRAMA ENERGETICA S/A.","commercialName":"","cnpj":"05515009000159","city":"RECIFE","stateCode":"PE","buscaAdicional":"IBIRAMA 2167 IBIRAMA 8789 PCH.PH.SC.029049-1.01"},{"id":"0e649628-858d-4819-516f-08d5ad2bf6ba","name":"PAMPEANA ENERGETICA S/A","commercialName":"","cnpj":"07512519000106","city":"RECIFE","stateCode":"PE","buscaAdicional":"PAMPEANA 2168 PAMPEANA 8494 PCH.PH.MT.029376-8.01"},{"id":"74922668-c2ca-4029-516b-08d5ad2bf6ba","name":"PEDRA FURADA ENERGIA S.A.","commercialName":"PEDRA FURADA ENERGIA","cnpj":"08995894000109","city":"RECIFE","stateCode":"PE","buscaAdicional":"PF ENERGIA 2164 PEDRA FURADA 8926 PCH.PH.PE.029666-0.01"},{"id":"27818dd1-89dd-4375-57e4-08d5ad2bf6ba","name":"ATIAIA COMERCIALIZADORA DE ENERGIA S/A","commercialName":"","cnpj":"15728576000147","city":"RECIFE","stateCode":"PE","buscaAdicional":"ATIAIA 9949"},{"id":"c5545af0-e11e-48a7-57b3-08d5ad2bf6ba","name":"SUBCONDOMINIO RIOMAR RECIFE","commercialName":"","cnpj":"16888022000170","city":"RECIFE","stateCode":"PE","buscaAdicional":"RIOMAR 9370 SHOPPING RIOMAR 889261"},{"id":"422cb455-dfb9-4233-56d2-08d5ad2bf6ba","name":"TRAMONTINA DELTA S/A","commercialName":"","cnpj":"02508145000123","city":"RECIFE","stateCode":"PE","buscaAdicional":"TRAMONTINA PE 7800 TRAMONTINA DELTA 72371 TRAMONTINA MORENO 905049"},{"id":"68c6e463-bbe7-4853-572c-08d5ad2bf6ba","name":"TOCANTINS ENERGETICA S/A","commercialName":"","cnpj":"01673025000119","city":"RECIFE","stateCode":"PE","buscaAdicional":"TOCANTINS ENER 8289 DIANOPOLIS 8248 PCH.PH.TO.027227-2.01 SOBRADO 8249 PCH.PH.TO.002756-1.01 DIACAL II 8250 PCH.PH.TO.027411-9.01"},{"id":"b1efbd45-7637-4372-5710-08d5ad2bf6ba","name":"SAINT-GOBAIN DO BRASIL PRODUTOS INDUSTRIAIS E PARA CONSTRUCAO LTDA","commercialName":"FABRICA CAXANGA","cnpj":"61064838000567","city":"RECIFE","stateCode":"PE","buscaAdicional":"SGQUART RECIFE 8184 SGBRAS RECIFE 888286"},{"id":"35fa837f-85a9-41bd-55f6-08d5ad2bf6ba","name":"ECEL - ELETRON COMERCIALIZADORA DE ENERGIA LTDA","commercialName":"ELETRON ENERGY","cnpj":"15087610000141","city":"RECIFE","stateCode":"PE","buscaAdicional":"ELETRON 6391 ITAIPAVA 8282 PCH.PH.SP.027984-6.01 WWP TAIBA 908883 EOL.CV.CE.002801-0.01"},{"id":"96ff3ab3-cffa-4a95-565a-08d5ad2bf6ba","name":"BOMPRECO SUPERMERCADOS DO NORDESTE LTDA","commercialName":"SUPERMERCADOS BOMPRECO","cnpj":"13004510000189","city":"RECIFE","stateCode":"PE","buscaAdicional":"BOMPRECO NE 6938 B PRECO B034A-JPESS 72070 BOMPREC O06 B VIAGEM 72155 BOMPRECO 397 PETROL 72156 BOMPRECO 7464 MURIB 72158 BOMPRECO B029 72375 BOMPRECO B041 72376 BOMPRECO B341(A) 72377 BOMPRECO B019 72378 BOM PRECO B096 72416 BOMPRECO B035 888403 BOMPRECO B352 888404 BOMPRECO B031(A) 888405 BOMPRECO B339 888407 BOMPRECO B270 888943 BOMPRECO LJ B102 888976 BOMPRECO B355 889141 B017 - AFLITOS 889602 BOMPRECO B020 889738 BOMPRECO B337 889739 BOMPRECO B160 889740 BOMPRECO B037 889741 BOMPRECO B094 889962 BOMPRECO B000 PE 889965 BOMPRECO B121 890155 BOMPRECO B122 890156 BOMPRECO JUAZEIRO 890897 HIP CASA FORTE B310 908563 HIPER OLINDA B350 908571 B307 MARANGUAPE 910365 B320 HIPER RECIFE 910379 B009 HIPER CAXANGA 910617 B140 HIPER SAO LUIZ 892902 B132 SUPER S. FRANC. 910857"},{"id":"87bd1dc0-200a-4afa-568d-08d5ad2bf6ba","name":"REAL HOSPITAL PORTUGUES DE BENEFICENCIA EM PERNAMBUCO","commercialName":"HOSPITAL PORTUGUES","cnpj":"10892164000124","city":"RECIFE","stateCode":"PE","buscaAdicional":"HPORTUGUES 7232 HOSP PORTUGUES REC 72196"},{"id":"85781591-7491-44f7-53c8-08d5ad2bf6ba","name":"UNAI BAIXO ENERGETICA S/A","commercialName":"","cnpj":"09509052000162","city":"RECIFE","stateCode":"PE","buscaAdicional":"UNAI 3847 UNAI BAIXO 8979 PCH.PH.MG.028673-7.01"},{"id":"4e61be67-ecf2-48de-538f-08d5ad2bf6ba","name":"CONDOMINIO PLAZA SHOPPING CASA FORTE","commercialName":"","cnpj":"03841406000195","city":"RECIFE","stateCode":"PE","buscaAdicional":"PLAZA SHOPPING 3695 PLAZA SH. CASA FORTE 71285"},{"id":"10387fc7-8190-4442-5407-08d5ad2bf6ba","name":"SETE GAMELEIRAS S/A","commercialName":"SETE GAMELEIRAS S/A","cnpj":"12710327000136","city":"RECIFE","stateCode":"PE","buscaAdicional":"SETE GAMELEIRA 3956 SETE GAMELEIRAS 888107 EOL.CV.BA.030455-7.01"},{"id":"ae008d80-3db3-4387-540f-08d5ad2bf6ba","name":"PEDRA BRANCA S/A","commercialName":"PEDRA BRANCA S/A","cnpj":"12709996000198","city":"RECIFE","stateCode":"PE","buscaAdicional":"PEDRA BRANCA 3985 PEDRA BRANCA 888111 EOL.CV.BA.030443-3.01"},{"id":"6de5aa71-82e6-47d7-5410-08d5ad2bf6ba","name":"SAO PEDRO DO LAGO S/A","commercialName":"EOLICA SAO PEDRO DO LAGO S/A","cnpj":"12709813000134","city":"RECIFE","stateCode":"PE","buscaAdicional":"SAO PEDRO LAGO 3986 SAO PEDRO DO LAGO 888108 EOL.CV.BA.030456-5.01"},{"id":"7522791a-001e-4803-554b-08d5ad2bf6ba","name":"TRADER ENERGIA LTDA","commercialName":"TRADER ENERGIA","cnpj":"14297687000183","city":"RECIFE","stateCode":"PE","buscaAdicional":"TRADER 5269"},{"id":"f47fd741-28c1-4469-5bf5-08d5ad2bf6ba","name":"PAULISTA PRAIA HOTEL S/A","commercialName":"","cnpj":"00338915000101","city":"RECIFE","stateCode":"PE","buscaAdicional":"PAULISTA PRAIA HOTEL 50998 HOTEL ATLANTE 898686 MAR HOTEL 898687 PAULISTA SUMMERVILLE 898840"},{"id":"941ee568-11a0-4d7a-5bbf-08d5ad2bf6ba","name":"CONDOMINIO DO SHOPPING CENTER RECIFE","commercialName":"","cnpj":"08961229000102","city":"RECIFE","stateCode":"PE","buscaAdicional":"SHOPPING RECIFE 50881 SHOPPING RECIFE PE 898552"},{"id":"1db93663-862b-4213-5ad0-08d5ad2bf6ba","name":"OMBREIRAS ENERGETICA S/A","commercialName":"","cnpj":"04760363000186","city":"RECIFE","stateCode":"PE","buscaAdicional":"OMBREIRAS 50255 OMBREIRAS 8135 PCH.PH.MT.027216-7.01"},{"id":"93213b7e-8e82-4117-5ac4-08d5ad2bf6ba","name":"ALTO JAURU ENERGETICA S/A","commercialName":"","cnpj":"01395648000177","city":"RECIFE","stateCode":"PE","buscaAdicional":"ALTO JAURU 50234 ALTO JAURU 8134 PCH.PH.MT.000077-9.01"},{"id":"62429ae0-228d-4bbe-5ac2-08d5ad2bf6ba","name":"INDIAVAI ENERGETICA S.A.","commercialName":"","cnpj":"04760345000102","city":"RECIFE","stateCode":"PE","buscaAdicional":"INDIAVAI 50232 INDIAVAI 8085 PCH.PH.MT.027370-8.01"},{"id":"f96738a0-adcb-4292-5a85-08d5ad2bf6ba","name":"ACANTHUS PARTICIPACOES S/A","commercialName":"","cnpj":"13531585000118","city":"RECIFE","stateCode":"PE","buscaAdicional":"ACANTHUS 49970"},{"id":"0580382f-0038-43b3-5b3d-08d5ad2bf6ba","name":"MASTERBOI LTDA.","commercialName":"MASTERBOI","cnpj":"03721769000278","city":"RECIFE","stateCode":"PE","buscaAdicional":"TRA-MASTERBOIPE 50534 MASTERBOI PE 898551"},{"id":"0102e339-883b-4f7a-58dc-08d5ad2bf6ba","name":"MORRO BRANCO I ENERGETICA S/A","commercialName":"MORRO BRANCO I ENERGETICA S/A","cnpj":"19353878000139","city":"RECIFE","stateCode":"PE","buscaAdicional":"MBRANCO1 13432 MORRO BRANCO I 896284 EOL.CV.BA.031336-0.01"},{"id":"8a7f7882-65cc-4e5b-58dd-08d5ad2bf6ba","name":"BARAUNAS I ENERGETICA S/A","commercialName":"BARAUNAS I ENERGETICA S/A","cnpj":"19354626000124","city":"RECIFE","stateCode":"PE","buscaAdicional":"BARAUNAS1 13452 BARAUNAS I 896347 EOL.CV.BA.031335-1.01"},{"id":"184f2f6c-bfb4-4207-58de-08d5ad2bf6ba","name":"MUSSAMBE ENERGETICA S/A","commercialName":"MUSSAMBE ENERGETICA S/A","cnpj":"19353849000177","city":"RECIFE","stateCode":"PE","buscaAdicional":"MUSSAMBE 13453 MUSSAMBE 896248 EOL.CV.BA.031352-1.01"},{"id":"a267af3b-d756-4d5c-58d7-08d5ad2bf6ba","name":"CANTU ENERGETICA S/A","commercialName":"","cnpj":"04502574000119","city":"RECIFE","stateCode":"PE","buscaAdicional":"CANTU2 13394 PCH CANTU 2 897406 PCH.PH.PR.029180-3.01"},{"id":"2420a26d-e0e5-4e7e-58d8-08d5ad2bf6ba","name":"BRENNAND ENERGIA MANOPLA S/A","commercialName":"","cnpj":"05643940000112","city":"RECIFE","stateCode":"PE","buscaAdicional":"PCH LUIZ DIAS LINS 13395 PCH LUIZ DIAS LINS 898607 PCH.PH.PE.030572-3.01"},{"id":"8579c9b6-901a-48ab-5825-08d5ad2bf6ba","name":"SER EDUCACIONAL S.A.","commercialName":"UNINABUCO RECIFE","cnpj":"04986320001438","city":"RECIFE","stateCode":"PE","buscaAdicional":"SER EDUCACIONAL 10830 SER EDUCACIONAL 890443 SER GRACAS 895128"},{"id":"1a08593f-a14f-4b59-5861-08d5ad2bf6ba","name":"CIPER - CIA DE PAPEIS E EMBALAGENS DO RECIFE EM RECUPERACAO JUDICIAL","commercialName":"CIPER - CIA DE PAPEIS E EMBALAGENS DO RECIFE","cnpj":"09464315000164","city":"RECIFE","stateCode":"PE","buscaAdicional":"CIPER 11589 CIPER 890318"},{"id":"f1b996fc-17f4-4335-5914-08d5ad2bf6ba","name":"AKZO NOBEL LTDA","commercialName":"","cnpj":"60561719009422","city":"RECIFE","stateCode":"PE","buscaAdicional":"AKZO NOBEL RECIFE 13675 AKZO NOBEL 894891"},{"id":"d872abd2-df5d-4ee9-5951-08d5ad2bf6ba","name":"ACAUA ENERGIA S/A","commercialName":"","cnpj":"19517173000100","city":"RECIFE","stateCode":"PE","buscaAdicional":"ACAUA 14255"},{"id":"4ed21b22-059c-4799-5952-08d5ad2bf6ba","name":"TEIU 2 ENERGIA S/A","commercialName":"","cnpj":"19517324000120","city":"RECIFE","stateCode":"PE","buscaAdicional":"TEIU2 14256"},{"id":"bca9ae6c-419e-4373-5953-08d5ad2bf6ba","name":"CORRUPIAO 3 ENERGIA S/A","commercialName":"","cnpj":"19517183000145","city":"RECIFE","stateCode":"PE","buscaAdicional":"CORRUPIAO3 14257"},{"id":"7cd76db1-01bc-470f-5954-08d5ad2bf6ba","name":"CAITITU 2 ENERGIA S/A","commercialName":"","cnpj":"19517279000103","city":"RECIFE","stateCode":"PE","buscaAdicional":"CAITITU2 14258"},{"id":"3ec0f927-8e07-4f0a-5955-08d5ad2bf6ba","name":"CAITITU 3 ENERGIA S/A","commercialName":"","cnpj":"19526401000108","city":"RECIFE","stateCode":"PE","buscaAdicional":"CAITITU3 14259"},{"id":"b8098054-76c2-4048-5956-08d5ad2bf6ba","name":"CARCARA ENERGIA S/A","commercialName":"","cnpj":"19517245000119","city":"RECIFE","stateCode":"PE","buscaAdicional":"CARCARA 14275"},{"id":"12c65bb9-aeb4-4879-5957-08d5ad2bf6ba","name":"ARAPAPA ENERGIA S/A","commercialName":"","cnpj":"19526384000109","city":"RECIFE","stateCode":"PE","buscaAdicional":"ARAPAPA 14276"},{"id":"5b6ad05f-11be-401f-5958-08d5ad2bf6ba","name":"ANGICAL 2 ENERGIA S/A","commercialName":"","cnpj":"19526394000144","city":"RECIFE","stateCode":"PE","buscaAdicional":"ANGICAL2 14277"},{"id":"ee1bf2eb-1d94-49a9-596a-08d5ad2bf6ba","name":"COQUEIRINHO 2 ENERGIA S.A.","commercialName":"","cnpj":"19962277000123","city":"RECIFE","stateCode":"PE","buscaAdicional":"COQUEIRINHO2 14406"},{"id":"455aad3d-5cf7-47be-596b-08d5ad2bf6ba","name":"PAPAGAIO ENERGIA S.A.","commercialName":"","cnpj":"19962303000113","city":"RECIFE","stateCode":"PE","buscaAdicional":"PAPAGAIO 14416"},{"id":"f88bd706-1be1-41c9-596d-08d5ad2bf6ba","name":"EOLICA TECNOLOGIA LTDA","commercialName":"","cnpj":"04135980000190","city":"RECIFE","stateCode":"PE","buscaAdicional":"EOL TECNOLOGIA 14487"},{"id":"7d61fba2-d3d8-45fe-5964-08d5ad2bf6ba","name":"BANDA DE COURO ENERGETICA S/A","commercialName":"BANDA DE COURO","cnpj":"19905727000146","city":"RECIFE","stateCode":"PE","buscaAdicional":"BANDACOURO 14397 EOL BANDA DE COURO 898006 EOL.CV.BA.031607-5.01"},{"id":"4b85a344-4482-4d18-5965-08d5ad2bf6ba","name":"BARAUNAS II ENERGETICA S/A","commercialName":"BARAUNAS II","cnpj":"19905679000196","city":"RECIFE","stateCode":"PE","buscaAdicional":"BARAUNAS2 14398 BARAUNAS II 897987 EOL.CV.BA.031667-9.01"},{"id":"3cc70365-38d4-4d30-5a43-08d5ad2bf6ba","name":"EOLICA ENERGIA LTDA","commercialName":"","cnpj":"09621876000120","city":"RECIFE","stateCode":"PE","buscaAdicional":"EOLICA ENERGIA 17240"},{"id":"68be0b62-5c61-453b-59e1-08d5ad2bf6ba","name":"AGENCIA DE DESENVOLV ECO DE PERNAMBUCO S A-AD/DIPER","commercialName":"AD DIPER","cnpj":"10848646000187","city":"RECIFE","stateCode":"PE","buscaAdicional":"AD DIPER 15758"},{"id":"a3b00ff1-eebc-4f7d-59ea-08d5ad2bf6ba","name":"SANTA GABRIELA ENERGETICA S/A","commercialName":"","cnpj":"07835806000149","city":"RECIFE","stateCode":"PE","buscaAdicional":"PCH SANTA GABRIELA 15855 SANTA GABRIELA 8583 PCH.PH.MT.028996-5.01"},{"id":"1ff3a00b-aed7-4738-5db2-08d5ad2bf6ba","name":"CONDOMINIO DO SHOPPING CENTER BOA VISTA","commercialName":"CONDOMINIO DO SHOPPING CENTER BOA VISTA","cnpj":"02679948000140","city":"RECIFE","stateCode":"PE","buscaAdicional":"BOA VISTA SHOP 51959 BOA VISTA SHOP 1 899751 BOA VISTA SHOP 2 899768"},{"id":"f0fef661-5ea1-4008-5df5-08d5ad2bf6ba","name":"HOSPITAIS ASSOCIADOS DE PERNAMBUCO LTDA","commercialName":"HOSPITAL SANTA JOANA RECIFE","cnpj":"10839561000132","city":"RECIFE","stateCode":"PE","buscaAdicional":"HOSP STA JOANA RECIFE 52092 HOSP STA JOANA RECIF 904054"},{"id":"c326f5ff-b180-4835-5d18-08d5ad2bf6ba","name":"NOTARO ALIMENTOS LTDA","commercialName":"NOTARO ALIMENTOS LTDA","cnpj":"01682695000959","city":"RECIFE","stateCode":"PE","buscaAdicional":"NOTARO PAULISTA 51700 NOTARO PAULISTA 898867"},{"id":"c5a50e6c-b2a6-43fa-5eff-08d5ad2bf6ba","name":"ASA INDUSTRIA E COMERCIO LTDA","commercialName":"","cnpj":"01551272000142","city":"RECIFE","stateCode":"PE","buscaAdicional":"ASA 52700 ASA RUA DA PAZ 902294 ASA RUA NICOLAU PERE 903593 ASA PB 906832"},{"id":"204ea6d1-10d1-4bb4-5edb-08d5ad2bf6ba","name":"EMPRESA BRASILEIRA DE BEBIDAS E ALIMENTOS S/A","commercialName":"","cnpj":"07604556000136","city":"RECIFE","stateCode":"PE","buscaAdicional":"EBBA 52586 EBBA ARAGUARI I 902895 EBBA ARAGUARI 2 902917 EBBA ARAQUATI CE 902520"},{"id":"98b73393-7e3e-41c6-7016-08d5c7c81a03","name":"LITERAL DESENVOLVIMENTO DE SOFTWARE LTDA","commercialName":"LITERAL SOFTWARE","cnpj":"22749566000153","city":"RECIFE","stateCode":"PE","buscaAdicional":""},{"id":"86b8013d-0a9e-432e-1cde-08d5b8870181","name":"PORTO NOVO RECIFE S/A","commercialName":"","cnpj":"15151317000104","city":"RECIFE","stateCode":"PE","buscaAdicional":"PORTO NOVO RECIFE 62931 PORTO NOVO ARMAZ 13 912839 PORTO NOVO ARMAZ 12 912841 PORTO NOVO ARMAZ 09 912855 PORTO NOVO ARMAZ 14 912856"},{"id":"8eb30960-2aea-49b5-1cdb-08d5b8870181","name":"DATAMETRICA TELEATENDIMENTO S/A","commercialName":"DATAMETRICA","cnpj":"01077145000153","city":"RECIFE","stateCode":"PE","buscaAdicional":"DATAMETRICA 62470 OLINDA 1 912840 OLINDA 2 912891"},{"id":"bba655b7-6d61-4cf9-7018-08d5c7c81a03","name":"S R P V N FILHO DESENVOLVIMENTO DE SOFTWARE","commercialName":"","cnpj":"24981764000173","city":"RECIFE","stateCode":"PE","buscaAdicional":""},{"id":"5c6e43d9-b3d1-4a0e-b9c1-08d5caef97db","name":"RELEVOS PECAS TECNICAS LTDA","commercialName":"RELEVO'S","cnpj":"04853444000120","city":"RECIFE","stateCode":"PE","buscaAdicional":""},{"id":"5ccbdca4-8408-4789-720e-08d5cf600bef","name":"SHOPPING CENTER TACARUNA S/A","commercialName":"","cnpj":"00115890000187","city":"RECIFE","stateCode":"PE","buscaAdicional":""},{"id":"459e9f44-65f5-4bb5-731f-08d5cf600bef","name":"MOURA DUBEUX ENGENHARIA S/A","commercialName":"","cnpj":"12049631000184","city":"RECIFE","stateCode":"PE","buscaAdicional":""},{"id":"3954468b-efa7-4ab7-729f-08d5cf600bef","name":"SER EDUCACIONAL S.A.","commercialName":"","cnpj":"04986320000113","city":"RECIFE","stateCode":"PE","buscaAdicional":""},{"id":"0f5d706c-5b57-4098-9f7d-08d5d7870f30","name":"INSTITUTO DE MEDICINA INTEGRAL PROFESSOR FERNANDO FIGUEIRA - IMIP","commercialName":"IMIP","cnpj":"10988301000129","city":"RECIFE","stateCode":"PE","buscaAdicional":""},{"id":"c3f159cb-be6f-4128-73c8-08d5cf600bef","name":"BRAMEX - BRASIL MERCANTIL S/A","commercialName":"ATLANTIS AQUACULTURA","cnpj":"70216429000104","city":"RECIFE","stateCode":"PE","buscaAdicional":""},{"id":"0de70dd2-0ee8-45d4-6826-08d5ad2bf6ba","name":"MERCANTIL ENERGIA LTDA","commercialName":"","cnpj":"21730065000162","city":"RECIFE","stateCode":"PE","buscaAdicional":"PCH PAU SANGUE MERCANTIL ENERG 59441 PAU SANGUE - CUCAU 541 PCH.PH.PE.002008-7.01"},{"id":"f51c9125-420d-4fd8-68a2-08d5ad2bf6ba","name":"LUMEN COMERCIALIZADORA DE ENERGIA LTDA","commercialName":"LUMEN ENERGIA","cnpj":"27927563000186","city":"RECIFE","stateCode":"PE","buscaAdicional":"LUMEN ENERGIA 60234"},{"id":"63f8298e-a425-45ae-6734-08d5ad2bf6ba","name":"FBV - FACULDADE BOA VIAGEM S.A.","commercialName":"","cnpj":"11405837000137","city":"RECIFE","stateCode":"PE","buscaAdicional":"FBV 58002 FBV FAC BOA VISTA 910210"},{"id":"32bae7b8-c58d-4d09-6723-08d5ad2bf6ba","name":"SERVICO DE IMAGENS RADIOGRAFICAS DO RECIFE LTDA","commercialName":"","cnpj":"24392243000180","city":"RECIFE","stateCode":"PE","buscaAdicional":"UNINEURO 57974 UNINEURO 908001"},{"id":"77119e78-900c-49ea-66d5-08d5ad2bf6ba","name":"CONDOMINIO DO BEACH CLASS CONVENTION & FLATS","commercialName":"CONDOMINIO DO BEACH CLASS CONVENTION & FLATS","cnpj":"18631284000180","city":"RECIFE","stateCode":"PE","buscaAdicional":"BEACH CLASS PE 57847 COND BEACH CLASS 908000"},{"id":"5a35c48d-dcbb-481d-6407-08d5ad2bf6ba","name":"CONDOMINIO SHOPPING CENTER TACARUNA","commercialName":"","cnpj":"01783999000155","city":"RECIFE","stateCode":"PE","buscaAdicional":"SHOP TACARUNA 55794 COND SP CT TACARUNA 906995"},{"id":"a680ccd4-83f3-4f4b-6449-08d5ad2bf6ba","name":"COLEGIO SANTA MARIA LTDA","commercialName":"COLEGIO SANTA MARIA","cnpj":"10870228000196","city":"RECIFE","stateCode":"PE","buscaAdicional":"COLEGIO SANTA MARIA 55910 COLEGIO SANTA MARIA 907125"},{"id":"72b09ff8-b99e-4c5b-650f-08d5ad2bf6ba","name":"VEGA COMERCIALIZADORA DE ENERGIA LTDA","commercialName":"","cnpj":"18651613000154","city":"RECIFE","stateCode":"PE","buscaAdicional":"VEGA ENERGY 56457"},{"id":"63012477-ad40-43f1-6493-08d5ad2bf6ba","name":"SIMPLES ENERGIA LTDA","commercialName":"SIMPLES ENERGIA","cnpj":"25355691000177","city":"RECIFE","stateCode":"PE","buscaAdicional":"SIMPLES ENERGIA 56110"},{"id":"e4052c32-db7f-41c9-6495-08d5ad2bf6ba","name":"ESTIVAS NOVO PRADO LTDA","commercialName":"EXTRABOM SUPERMERCADOS","cnpj":"08029696000352","city":"RECIFE","stateCode":"PE","buscaAdicional":"ESTIVAS NOVO PRADO 56112 ESTIVAS NOVO PRADO 905925"},{"id":"dcec2cc4-6c1d-49d2-631c-08d5ad2bf6ba","name":"UNIAO NORTE BRASILEIRA DE EDUCACAO E CULTURA","commercialName":"UNBEC","cnpj":"10847382000147","city":"RECIFE","stateCode":"PE","buscaAdicional":"UNBEC 55173 UNBEC PATAMARES 906283"},{"id":"9674f958-45df-468a-583a-08d5ad2bf6ba","name":"INVIVO NUTRICAO E SAUDE ANIMAL LTDA","commercialName":"","cnpj":"06066837000705","city":"SÃO LOURENÇO DA MATA","stateCode":"PE","buscaAdicional":"INVIVO SLMATA 11070 INVIVO SLMATA 889284 INVIVO NUTRICAO 899299"},{"id":"72d0c978-6555-408d-57ed-08d5ad2bf6ba","name":"MAJE DO NORDESTE INDUSTRIA E COMERCIO DE MATERIAIS ELETRICOS LTDA","commercialName":"","cnpj":"04900482000197","city":"SÃO LOURENÇO DA MATA","stateCode":"PE","buscaAdicional":"MEC TRONIC 10109 MEC TRONIC FILIAL 889981 MEC TRONIC SLM PE 889982"},{"id":"3b8705bd-f4fb-488d-57dd-08d5ad2bf6ba","name":"MONDELEZ BRASIL NORTE NORDESTE LTDA","commercialName":"MONDELEZ NORTE NORDESTE","cnpj":"10144076000144","city":"VITÓRIA DE SANTO ANTÃO","stateCode":"PE","buscaAdicional":"MONDELEZ_VSA 9829 KRAFT VSA 889549"},{"id":"5b355bda-8ba9-42de-51b0-08d5ad2bf6ba","name":"PIRAPAMA BIOENERGIA LTDA","commercialName":"","cnpj":"09043891000138","city":"VITÓRIA DE SANTO ANTÃO","stateCode":"PE","buscaAdicional":"UTE PIRAPAMA I5 2503 PIRAPAMA 8384 UTE.AI.PE.029715-1.01"},{"id":"79f9c053-f646-4ba4-5eab-08d5ad2bf6ba","name":"ARAFORROS IND E COMERCIO DE PERFILADOS LTDA","commercialName":"ARAFORROS","cnpj":"00321975000111","city":"ARAPIRACA","stateCode":"AL","buscaAdicional":"ARAFORROS 52493 ARAFORROS ARAPIRACA 906903"},{"id":"5490e423-d5e3-412e-6352-08d5ad2bf6ba","name":"CONDOMINIO DO SHOPPING PATIO ARAPIRACA","commercialName":"","cnpj":"18235741000117","city":"ARAPIRACA","stateCode":"AL","buscaAdicional":"SHOP PATIO ARAPIRACA 55311 SHOP PATIO ARAPIRACA 907023"},{"id":"0ba6fd7e-863a-40b5-8d80-08d5d060706e","name":"INDUSTRIAS REUNIDAS CORINGA LTDA","commercialName":"GRUPO CORINGA","cnpj":"12213443000140","city":"ARAPIRACA","stateCode":"AL","buscaAdicional":"GRUPO CORINGA 58876 GRUPO CORINGA 913585"},{"id":"7ff05206-9e15-499b-7777-08d5d5286869","name":"NORSA REFRIGERANTES S.A","commercialName":"","cnpj":"07196033005400","city":"ARAPIRACA","stateCode":"AL","buscaAdicional":""},{"id":"539f1754-666d-4fdc-59ec-08d5ad2bf6ba","name":"S A USINA CORURIPE ACUCAR E ALCOOL","commercialName":"USINA CORURIPE","cnpj":"12229415000110","city":"CORURIPE","stateCode":"AL","buscaAdicional":"CORURIPE ACUCAR E ALCOOL 15935 CARNEIRINHO 8349 UTE.AI.MG.029619-8.01 CORURIPE ACU ALCOOL 8860 UTE.AI.MG.030533-2.01 CORURIPE C FLORIDO 8117 UTE.AI.MG.028478-5.01"},{"id":"7e9c2177-43f6-4c22-5a0d-08d5ad2bf6ba","name":"ADEA - SOCIEDADE DE DESENVOLVIMENTO EDUCACIONAL AVANCADO LTDA","commercialName":"ADEA","cnpj":"07991012000174","city":"MACEIÓ","stateCode":"AL","buscaAdicional":"ADEA 16406 ADEA FAROL 897064 ADEA PONTA VERDE 897426"},{"id":"d6d3e4fe-423a-4dcd-5e8e-08d5ad2bf6ba","name":"USINA CAETE S A","commercialName":"USINA CAETE","cnpj":"12282034000103","city":"MACEIÓ","stateCode":"AL","buscaAdicional":"CAETE 52447 CAETE MARITUBA 8052 UTE.AI.AL.028542-0.01 PAULICEIA 888194 UTE.AI.SP.030683-5.01"},{"id":"4d6fb476-6501-4421-4ee3-08d5ad2bf6ba","name":"COMPANHIA ENERGETICA DE ALAGOAS - CEAL","commercialName":"ELETROBRAS DISTRIBUICAO ALAGOAS","cnpj":"12272084000100","city":"MACEIÓ","stateCode":"AL","buscaAdicional":"CEAL 10 CEAL 17 CEAL DITC 70760"},{"id":"cc784ead-6820-4b22-56e3-08d5ad2bf6ba","name":"LOJAS RENNER S.A.","commercialName":"RENNER","cnpj":"92754738010710","city":"MACEIÓ","stateCode":"AL","buscaAdicional":"RENNER 96 7900 RENNER 116 889121 RENNER LOJA 84 890184"},{"id":"db23acef-19f9-4e65-5561-08d5ad2bf6ba","name":"CONDOMINIO EDILICIO SHOPPING PATIO MACEIO","commercialName":"SHOPPING PATIO MACEIO","cnpj":"11862955000174","city":"MACEIÓ","stateCode":"AL","buscaAdicional":"SHOP PATIO MACEIO 5471 PATIO MACEIO 70842"},{"id":"c8c72575-b7fc-4fe9-643f-08d5ad2bf6ba","name":"PARQUE SHOPPING MACEIO S.A.","commercialName":"HALEIWA EMPREENDIMENTOS IMOBILIARIOS S.A","cnpj":"09511067000246","city":"MACEIÓ","stateCode":"AL","buscaAdicional":"SHOPPING MACEIO 55896 PARQUE SHOP MACEIO 907429"},{"id":"cfaa80bc-476a-40c7-6464-08d5ad2bf6ba","name":"CARAJAS MATERIAL DE CONSTRUCAO LTDA","commercialName":"CARAJAS CONSTRUCOES","cnpj":"03656804000131","city":"MACEIÓ","stateCode":"AL","buscaAdicional":"CARAJAS 55973 CARAJAS CAMPINA GRAN 909795 CARAJAS JOAO PESSOA 910029 CARAJAS MATRIZ 910396 CARAJAS ARAPIRACA 910397 DONA VALMIRA 910580 CARAJAS CABEDELO 911269"},{"id":"efad151f-acaa-42c0-654e-08d5ad2bf6ba","name":"HOTEL JATIUCA S/A","commercialName":"","cnpj":"11197308000357","city":"MACEIÓ","stateCode":"AL","buscaAdicional":"HOTEL JATIUCA 56648 HOTEL JATIUCA 912036"},{"id":"66ae4a3a-614a-479f-6766-08d5ad2bf6ba","name":"DIAGNOSE CENTRO DE DIAGNOSTICO POR IMAGEM LTDA","commercialName":"","cnpj":"35741024000267","city":"MACEIÓ","stateCode":"AL","buscaAdicional":"DIAGNOSE 58076 DIAGNOSE CENTRO 909362"},{"id":"8ebdf2e6-efec-4763-65c6-08d5ad2bf6ba","name":"CONDOMINIO EDIFICIO RITZ SUITES HOME SERVICE","commercialName":"CONDOMINIO EDIFICIO RITZ SUITES HOME SERVICE","cnpj":"14061388000145","city":"MACEIÓ","stateCode":"AL","buscaAdicional":"RITZ SUITES 57076 COND EDIF RITZ 908514"},{"id":"621230e0-f238-443c-65c7-08d5ad2bf6ba","name":"LAGOA DA ANTA EMPREENDIMENTOS HOTELEIROS LTDA","commercialName":"CANA CAFE","cnpj":"35632819000156","city":"MACEIÓ","stateCode":"AL","buscaAdicional":"RITZ LAGOA DA ANTA 57077 LAGOA DA ANTA 909363"},{"id":"2cdf3b35-fc92-41e2-6744-08d5ad2bf6ba","name":"E-PALETES FABRICACAO E COMERCIO ATACADISTA DE PALETES DE MADEIRA LTDA.","commercialName":"E-PALETES","cnpj":"18675185000108","city":"MARECHAL DEODORO","stateCode":"AL","buscaAdicional":"E.PALETES 58022 E PALETES 909361"},{"id":"1aab691d-6cb7-43ca-88e1-08d5ae44ed50","name":"NORDEPLAST INDUSTRIA E COMERCIO DE PLASTICOS LTDA","commercialName":"NORDEPLAST","cnpj":"09041908000118","city":"MARECHAL DEODORO","stateCode":"AL","buscaAdicional":"NORDEPLAST 54173"},{"id":"c6ff6f10-e60e-4313-5d7e-08d5ad2bf6ba","name":"CORR PLASTIK NORDESTE INDUSTRIAL LTDA","commercialName":"CORR PLASTIK","cnpj":"08984318000166","city":"MARECHAL DEODORO","stateCode":"AL","buscaAdicional":"CORR PLASTIK NOR 51838 CORR PLASTIC MACEIO 904123"},{"id":"a797f877-a463-4724-557b-08d5ad2bf6ba","name":"CIA ALAGOANA DE EMPREENDIMENTOS","commercialName":"","cnpj":"12270195000179","city":"RIO LARGO","stateCode":"AL","buscaAdicional":"CGH G PAIVA 5694 GUSTAVO PAIVA 8986 CGH.PH.AL.030112-4.01"},{"id":"69e179b7-e372-456d-595a-08d5ad2bf6ba","name":"COMPANHIA ENERGETICA DE SAO MIGUEL DOS CAMPOS","commercialName":"","cnpj":"18053794000117","city":"SÃO MIGUEL DOS CAMPOS","stateCode":"AL","buscaAdicional":"CESMC 14279 BIOFLEX CAETE 894129 UTE.AI.AL.031371-8.01"},{"id":"04695d92-c841-4c37-51d6-08d5ad2bf6ba","name":"BEN - BIOENERGIA, GERACAO E COMERCIALIZACAO DE ENERGIA DO NORDESTE S.A","commercialName":"BEN","cnpj":"09315209000119","city":"TEOTÔNIO VILELA","stateCode":"AL","buscaAdicional":"BEN 2617 BEN BIOENERGIA 8639 UTE.AI.AL.030048-9.01"},{"id":"b0795b9f-9d97-469c-4f02-08d5ad2bf6ba","name":"ENERGISA SERGIPE - DISTRIBUIDORA DE ENERGIA S.A","commercialName":"ENERGISA","cnpj":"13017462000163","city":"ARACAJU","stateCode":"SE","buscaAdicional":"ENERGISA SE 51 ENERGISA SE 24 SULGIPE 25 ENERGISA SE DITC 70761"},{"id":"95c63e80-7262-4ed4-562b-08d5ad2bf6ba","name":"CONDOMINIO SHOPPING RIOMAR","commercialName":"","cnpj":"32752602000191","city":"ARACAJU","stateCode":"SE","buscaAdicional":"SHOP RIOMAR ARACAJU 6718 SHOPG RIOMA ARACAJU 72089"},{"id":"9aafe138-ef76-43ea-7335-08d5cf600bef","name":"BANCO DO ESTADO DE SERGIPE S/A","commercialName":"","cnpj":"13009717000146","city":"ARACAJU","stateCode":"SE","buscaAdicional":""},{"id":"2d4fb527-de59-42ee-675d-08d5ad2bf6ba","name":"ARACAJU INVESTIMENTOS LTDA","commercialName":"ARACAJU INVESTIMENTOS LTDA","cnpj":"17333406000199","city":"ARACAJU","stateCode":"SE","buscaAdicional":"ARACAJU PARQUE SHOPPING 58062 ARACAJU INVESTIMENTO 909266"},{"id":"47370541-5de9-4a47-6565-08d5ad2bf6ba","name":"SAO LUCAS MEDICO HOSPITALAR LTDA","commercialName":"HOSPITAL SAO LUCAS","cnpj":"13131370000100","city":"ARACAJU","stateCode":"SE","buscaAdicional":"HOSPITAL SAO LUCAS 56710 HOSPITAL SAO LUCAS 907461"},{"id":"187c6f99-1a74-4009-63c2-08d5ad2bf6ba","name":"SANTA MONICA INDUSTRIA TEXTIL E COMERCIO LTDA","commercialName":"SANTA MONICA INDUSTRIA E COMERCIO LTDA","cnpj":"11958084000197","city":"ARACAJU","stateCode":"SE","buscaAdicional":"SANTA MONICA MATRIZ 55599 SANTA MONICA MATRIZ 908144 SANTA MONICA FILIAL 908146"},{"id":"b2585be0-43d9-4b33-5474-08d5ad2bf6ba","name":"AGRO INDUSTRIAL CAPELA LTDA","commercialName":"DESTILARIA TAQUARI","cnpj":"07461344000147","city":"CAPELA","stateCode":"SE","buscaAdicional":"UTE TAQUARI 4262 TAQUARI 8924 UTE.AI.SE.030677-0.01"},{"id":"ea6608cf-f846-4e3f-62ff-08d5ad2bf6ba","name":"COMPANHIA INDUSTRIAL TEXTIL","commercialName":"CIT","cnpj":"14674839000110","city":"ESTÂNCIA","stateCode":"SE","buscaAdicional":"CIT69 55071 COMP IND TEXTIL 905180"},{"id":"52483fef-8e63-4852-62e5-08d5ad2bf6ba","name":"TROPFRUIT NORDESTE S/A","commercialName":"TROPFRUIT","cnpj":"16460081000142","city":"ESTÂNCIA","stateCode":"SE","buscaAdicional":"TROPFRUIT 55026 TROPFRUIT 905181"},{"id":"0e5e1ddd-18de-4d6f-62e9-08d5ad2bf6ba","name":"DUAS RODAS NORDESTE INDUSTRIA DE ALIMENTOS LTDA","commercialName":"DUAS RODAS NORDESTE","cnpj":"04764392000116","city":"ESTÂNCIA","stateCode":"SE","buscaAdicional":"DUAS RODAS NORDESTE 55030 DUAS RODAS NE 905814"},{"id":"33151eb1-7b88-4388-5a91-08d5ad2bf6ba","name":"COMPANHIA INDUSTRIAL DE CELULOSE E PAPEL EM RECUPERACAO JUDICIAL","commercialName":"","cnpj":"13004304000250","city":"ITAPORANGA D'AJUDA","stateCode":"SE","buscaAdicional":"CICP 50086 COMP IND DE CELULOSE 897264"},{"id":"09801e73-1298-49fb-5219-08d5ad2bf6ba","name":"USINA SAO JOSE DO PINHEIRO LTDA","commercialName":"USINA SAO JOSE DO PINHEIRO","cnpj":"13324215000100","city":"LARANJEIRAS","stateCode":"SE","buscaAdicional":"UTE PINHEIRO 2872 SAO JOSE DO PINHEIRO 8610 UTE.AI.SE.029685-6.01"},{"id":"11367df2-b9d0-472c-5fcd-08d5ad2bf6ba","name":"PEIXOTO GONCALVES S/A INDUSTRIA E COMERCIO","commercialName":"","cnpj":"13342076000147","city":"NEÓPOLIS","stateCode":"SE","buscaAdicional":"PEIXOTO GONCALVES 53230 PEIXOTO GONCALVES 903452"},{"id":"2a9655a8-03d4-4a10-5349-08d5ad2bf6ba","name":"AGRO INDUSTRIAL CAMPO LINDO LTDA.","commercialName":"AGRO INDUSTRIAL CAMPO LINDO","cnpj":"07454414000130","city":"NOSSA SENHORA DAS DORES","stateCode":"SE","buscaAdicional":"CAMPO LINDO 3556 CAMPO LINDO 8805 UTE.AI.SE.030396-8.01"},{"id":"87e4d8dc-7f12-4ff2-569b-08d5ad2bf6ba","name":"CENCOSUD BRASIL COMERCIAL LTDA","commercialName":"","cnpj":"39346861000161","city":"NOSSA SENHORA DO SOCORRO","stateCode":"SE","buscaAdicional":"CENCOSUD GBARBOSA 004 7321 CENCOSUD LOJA 014 888282 CENCOSUD LOJA 020 888283 CENCOSUD LJ 710 899627 CENCOSUD LOJA 731 899686 CENCOSUD LJ 721 899777 CENCOSUD LJ 717 899854 CENCOSUD LJ 732 899855 CENCOSUD LJ 706 899869 CENCOSUD LJ 725 899870 CENCOSUD - LJ718 900088 CENCOSUD LOJA 705 900153 CENCOSUD LOJA 724 900154 CENCOSUD LJ 709 900177 CENCOSUD LOJA 719 900193 CENCOSUD LJ 703A 900195 CENCOSUD LJ 720 900921 CENCOSUD PREZUNI 728 900954 CENCOSUD PREZUNI 702 900955 CENCOSUD PENHA 703 901176 CENCOSUD PREZUNI 714 901178 CENCOSUD LOJA 734 901360 CENCOSUD LOJA 715 901677 CENCOSUD LOJA 704 902614 CENCOSUD LOJA 712 903375 CENCOSUD LOJA 733 903619 CENCOSUD PREZUN 708 903993 CENCOSUD PREZUN 726 904017 CENCOSUD LOJA 723 904409 CENCOSUD LOJA 716 904410 CENCOSUD LOJA 729 904434 CENCOSUD LJ 707 904483 CENCOSUD L711 906656 CENCOSUD LOJA 713 907100 CENCOSUD LOJA 638 888277 CENCOSUD LOJA 620 888278 CENCOSUD LOJA 618 888279 CENCOSUD LOJA 614 888280 CENCOSUD LOJA 613 888281 CENCOSUD LOJA 530 889419 CENCOSUD ITABIRA 890916 CENCOSUD LOJA 523 898774 CENCOSUD LOJA 526 898775 CENCOSUD LOJA 539 898776 CENCOSUD LOJA 627 898777 CENCOSUD LJ 579 899108 CENCOSUD LOJA 660 899109 CENCOSUD LOJA 639 899110 CENCOSUD LOJA 647 899128 CENCOSUD LOJA 558 899167 CENCOSUD LOJA 616 899186 CENCOSUD LJ 515 899187 CENCOSUD 550 899229 CENCOSUD LOJA 501 899270 CENCOSUD LOJA 508 899271 CENCOSUD LOJA 623 899277 CENCOSUD LOJA 629 899310 CENCOSUD 507 899311 CENCOSUD LOJA 628 899433 CENCOSUD LOJA 533 900753 CENCOSUD LOJA 625 900754 CENCOSUD LOJA 522 900755 CENCOSUD LOJA 562 900756 CENCOSUD LOJA 624 900757 CENCOSUD LOJA 636 900758 CENCOSUD BRETA 511 903966 CENCOSUD LJ 622 905319 CENCOSUD LOJA 617 905666 CENCOSUD L520 906525 CENCOSUD LJ 544 906825 GBARBOSA LJ 542 907056 GBARBOSA LJ 509 907057 BRETAS LJ 607 907072 CENCOSUD LJ 611 909245 CENCOSUD 649 909612 CENCOSUD LOJA 8 899063 CENCOSUD LOJA 27 899114 CENCOSUD LOJA 13 899132 CENCOSUD LOJA 34 899134 CENCOSUD LOJA 19 899135 CENCOSUD LOJA 4 899528 CENCOSUD LOJA 1 899573 CENCOSUD LJ 90 899856 CENCOSUD LJ 030 899857 CENCOSUD LJ 006 899871 CENCOSUD LOJA 276 900514 CENCOSUD PAU LIMA153 901216 CENCOSUD LOJA 31 902515 CENCOSUD LOJA 151 902933 CENCOSUD LOJA 37 903433 CENCOSUD GBARBOSA108 903964 CENCOSUD GBARBOSA 35 904018 CENCOSUD GBARBOSA112 904035 CENCOSUD LOJA 139 904094 CENCOSUD LOJA 036 904412 CENCOSUD LJ 730 899694 CENCOSUD LOJA 722 900174"},{"id":"ff8d8677-2ea5-4e50-5781-08d5ad2bf6ba","name":"CERAMICA SERRA AZUL LTDA","commercialName":"","cnpj":"07378783000190","city":"NOSSA SENHORA DO SOCORRO","stateCode":"SE","buscaAdicional":"SERRA AZUL 8970 CERAMICA SERRA AZUL 898965"},{"id":"4d5f4d66-16dd-46f0-5c2b-08d5ad2bf6ba","name":"CERAMICA SERGIPE INDUSTRIA E COMERCIO LTDA","commercialName":"","cnpj":"15104383000115","city":"NOSSA SENHORA DO SOCORRO","stateCode":"SE","buscaAdicional":"ESCURIAL 51132 CERAMICA SERGIPE 898044"},{"id":"2f572a66-3751-4b7e-883f-08d5ae44ed50","name":"ITAGUASSU AGRO INDUSTRIAL S/A","commercialName":"","cnpj":"27184951000114","city":"NOSSA SENHORA DO SOCORRO","stateCode":"SE","buscaAdicional":"ITAGUASSU CE 1749 ITAGUASSU AGRO IND 70299"},{"id":"066fcc4d-7643-4ec3-56d5-08d5ad2bf6ba","name":"SERGIPE INDUSTRIAL TEXTIL LTDA","commercialName":"","cnpj":"13006218000286","city":"RIACHUELO","stateCode":"SE","buscaAdicional":"SISA 7804 SISA - 2921 - SERGIP 888401"},{"id":"5281b0a2-906d-4b7d-5639-08d5ad2bf6ba","name":"FIACAO ITABAIANA LTDA","commercialName":"","cnpj":"03403794000122","city":"RIBEIRÓPOLIS","stateCode":"SE","buscaAdicional":"F ITABAIANA 6797 FIACAO ITABAIANA 72423"},{"id":"cd391ea1-f589-4172-63d3-08d5ad2bf6ba","name":"FRUTEB S/A","commercialName":"","cnpj":"02779781000190","city":"SÃO CRISTÓVÃO","stateCode":"SE","buscaAdicional":"FRUTEB 55644 FRUTEB 906255"},{"id":"031e6392-f911-4692-6003-08d5ad2bf6ba","name":"LATAS INDUSTRIA DE EMBALAGENS DE ALUMINIO DO BRASIL LTDA.","commercialName":"LATAS DE ALUMINIO DO BRASIL","cnpj":"24168115000158","city":"ALAGOINHAS","stateCode":"BA","buscaAdicional":"LATAS DO BRASIL 53348 LATAPA JAC 70799 LATAS BRASIL ALAGOIN 905579"},{"id":"79993d20-621e-43e1-5e94-08d5ad2bf6ba","name":"CERVEJARIA PETROPOLIS DA BAHIA LTDA","commercialName":"","cnpj":"15350602000146","city":"ALAGOINHAS","stateCode":"BA","buscaAdicional":"CP MATRIZ_BA 52454 CP ALAGOINHAS BA 900914"},{"id":"b57f0b17-987d-4e68-5634-08d5ad2bf6ba","name":"CARGILL AGRICOLA S A","commercialName":"CARGILL AGRICOLA","cnpj":"60498706025907","city":"BARREIRAS","stateCode":"BA","buscaAdicional":"CARGILL BRS 6761 CARGILL-BARREIROS 72241"},{"id":"fee445a8-971b-435d-6523-08d5ad2bf6ba","name":"FAZENDA BRASILEIRO DESENVOLVIMENTO MINERAL LTDA","commercialName":"FAZENDA BRASILEIRO DESENVOLVIMENTO MINERAL","cnpj":"22104045000149","city":"BARROCAS","stateCode":"BA","buscaAdicional":"FAZENDA BRASILEIRO 56515 FAZENDA BRASILEIRO 907024"},{"id":"8e6803b6-83b3-4c7f-5dd7-08d5ad2bf6ba","name":"CENTRAL FOTOVOLTAICA SAO PEDRO II LTDA","commercialName":"","cnpj":"24068977000109","city":"BOM JESUS DA LAPA","stateCode":"BA","buscaAdicional":"UFV SAO PEDRO II 52022"},{"id":"fb2a673d-b6ce-497b-5dd8-08d5ad2bf6ba","name":"CENTRAL FOTOVOLTAICA SAO PEDRO IV LTDA","commercialName":"","cnpj":"24069089000100","city":"BOM JESUS DA LAPA","stateCode":"BA","buscaAdicional":"UFV SAO PEDRO IV 52023"},{"id":"b459042a-6a96-4c8e-5976-08d5ad2bf6ba","name":"PARQUE EOLICO COLINA S.A.","commercialName":"EMPREENDIMENTO EOLICO VENTOS DA BAHIA IV","cnpj":"20081762000177","city":"BONITO","stateCode":"BA","buscaAdicional":"EOL COLINA 14557 VENTOS DA BAHIA 4 910083 EOL.CV.BA.031770-5.01"},{"id":"5e34a289-2190-4c3d-5b9a-08d5ad2bf6ba","name":"MAGNESITA MINERACAO S.A.","commercialName":"","cnpj":"00592603000120","city":"BRUMADO","stateCode":"BA","buscaAdicional":"MAGNESITA MINERACAO 50777 MAGNESITA-BRUMADO 71765"},{"id":"7a559ca3-b02c-4b39-6597-08d5ad2bf6ba","name":"IMI FABI TALCO S.A.","commercialName":"","cnpj":"24809672000100","city":"BRUMADO","stateCode":"BA","buscaAdicional":"IMI FABI TALCO 56851 IMI FABI TALCO 906411"},{"id":"d19d5cd1-c30b-499a-88af-08d5ae44ed50","name":"CENTRAIS EOLICAS ITAPUA V LTDA.","commercialName":"CENTRAIS EOLICAS ITAPUA V","cnpj":"18560100000138","city":"CAETITÉ","stateCode":"BA","buscaAdicional":"CE ITAPUA V 17339"},{"id":"f901f687-685b-4f9f-88b0-08d5ae44ed50","name":"CENTRAIS EOLICAS ITAPUA IV LTDA.","commercialName":"CENTRAIS EOLICAS ITAPUA IV","cnpj":"18560507000165","city":"CAETITÉ","stateCode":"BA","buscaAdicional":"CE ITAPUA IV 17351"},{"id":"255be20d-5f2f-4a62-5a50-08d5ad2bf6ba","name":"CENTRAIS EOLICAS ITAPUA VII LTDA.","commercialName":"CENTRAIS EOLICAS ITAPUA VII","cnpj":"18560032000107","city":"CAETITÉ","stateCode":"BA","buscaAdicional":"CE ITAPUA VII 17340"},{"id":"e1999831-e5b0-4a6d-5934-08d5ad2bf6ba","name":"CENTRAIS EOLICAS TABOQUINHA S.A.","commercialName":"CENTRAIS EOLICAS BELA VISTA XIX","cnpj":"18870116000147","city":"CAETITÉ","stateCode":"BA","buscaAdicional":"UEE TABOQUINHA 14135"},{"id":"184be41d-9cde-45a8-58fd-08d5ad2bf6ba","name":"CENTRAIS EOLICAS ACACIA S.A.","commercialName":"CENTRAIS EOLICAS BELA VISTA XII","cnpj":"18919425000164","city":"CAETITÉ","stateCode":"BA","buscaAdicional":"UEE ACACIA 13553"},{"id":"4745f363-e5f0-42e8-58fe-08d5ad2bf6ba","name":"CENTRAIS EOLICAS ANGICO S.A.","commercialName":"CENTRAIS EOLICAS BELA VISTA XIII","cnpj":"18870073000108","city":"CAETITÉ","stateCode":"BA","buscaAdicional":"UEE ANGICO 13554"},{"id":"d7943d94-55d0-4f58-58ff-08d5ad2bf6ba","name":"CENTRAIS EOLICAS VAQUETA S.A.","commercialName":"CENTRAIS EOLICAS ITAPUA VIII","cnpj":"18684356000157","city":"CAETITÉ","stateCode":"BA","buscaAdicional":"UEE VAQUETA 13555"},{"id":"8ec2ddd8-c1eb-45d7-5900-08d5ad2bf6ba","name":"CENTRAIS EOLICAS TABUA S.A.","commercialName":"CENTRAIS EOLICAS BELA VISTA XX","cnpj":"18870007000120","city":"CAETITÉ","stateCode":"BA","buscaAdicional":"UEE TABUA 13556"},{"id":"eda0fbd8-8dee-4f91-5901-08d5ad2bf6ba","name":"CENTRAIS EOLICAS ABIL S.A.","commercialName":"CENTRAIS EOLICAS BELA VISTA VIII","cnpj":"18911031000160","city":"CAETITÉ","stateCode":"BA","buscaAdicional":"UEE ABIL 13557"},{"id":"663015ad-f890-4e90-5902-08d5ad2bf6ba","name":"CENTRAIS EOLICAS JABUTICABA S.A.","commercialName":"CENTRAIS EOLICAS BELA VISTA XVII","cnpj":"18870194000141","city":"CAETITÉ","stateCode":"BA","buscaAdicional":"UEE JABUTICABA 13558"},{"id":"9eafa7ce-71b3-4a12-5903-08d5ad2bf6ba","name":"CENTRAIS EOLICAS FOLHA DA SERRA S.A","commercialName":"CENTRAIS EOLICAS FOLHA DA SERRA","cnpj":"18910740000120","city":"CAETITÉ","stateCode":"BA","buscaAdicional":"UEE FOLHA 13559"},{"id":"0c5bd48f-edc6-4bf0-5904-08d5ad2bf6ba","name":"CENTRAIS EOLICAS JACARANDA DO SERRADO S.A.","commercialName":"CENTRAIS EOLICAS BELA VISTA XVIII","cnpj":"18870265000106","city":"CAETITÉ","stateCode":"BA","buscaAdicional":"UEE JACARANDA 13560"},{"id":"697070c8-5266-4735-5601-08d5ad2bf6ba","name":"CENTRAIS EOLICAS MARON S.A","commercialName":"","cnpj":"12041214000195","city":"CAETITÉ","stateCode":"BA","buscaAdicional":"UEE MARON 6494 MARON 892105 EOL.CV.BA.030768-8.01"},{"id":"72793b08-9562-4c3e-5605-08d5ad2bf6ba","name":"CENTRAIS EOLICAS PILOES S.A","commercialName":"","cnpj":"11201797000101","city":"CAETITÉ","stateCode":"BA","buscaAdicional":"UEE PILOES 6498 PILOES 892106 EOL.CV.BA.030776-9.01"},{"id":"de5c8f3f-a014-41e0-5442-08d5ad2bf6ba","name":"CENTRAIS EOLICAS TANQUE S.A","commercialName":"","cnpj":"12048059000139","city":"CAETITÉ","stateCode":"BA","buscaAdicional":"UEE TANQUE 4124 TANQUE 3LER 890777 EOL.CV.BA.030544-8.01"},{"id":"4fc2046c-415c-4361-5443-08d5ad2bf6ba","name":"CENTRAIS EOLICAS MORRAO S/A","commercialName":"","cnpj":"12049829000168","city":"CAETITÉ","stateCode":"BA","buscaAdicional":"UEE MORRAO 4125 MORRAO 890758 EOL.CV.BA.030506-5.01"},{"id":"9bc47a54-833f-42f4-543f-08d5ad2bf6ba","name":"CENTRAIS EOLICAS DOS ARACAS S.A","commercialName":"CENTRAIS EOLICAS DOS ARACAS","cnpj":"11201833000137","city":"CAETITÉ","stateCode":"BA","buscaAdicional":"UEE DOS ARACAS 4121 ARACAS 3LER 890750 EOL.CV.BA.030495-6.01"},{"id":"c057523b-03c2-4b18-5440-08d5ad2bf6ba","name":"CENTRAIS EOLICAS VENTOS DO NORDESTE S/A","commercialName":"CENTRAIS EOLICAS VENTOS DO NORDESTE","cnpj":"11204086000190","city":"CAETITÉ","stateCode":"BA","buscaAdicional":"UEE V NORDESTE 4122 V DO NORDESTE 3LER 890778 EOL.CV.BA.030476-0.01"},{"id":"a306623d-dc10-4197-5329-08d5ad2bf6ba","name":"CENTRAIS EOLICAS PAJEU DO VENTO LTDA.","commercialName":"","cnpj":"11365985000175","city":"CAETITÉ","stateCode":"BA","buscaAdicional":"UEE PAJEU 3496 PAJEU DO VENTO 20024 EOL.CV.BA.030319-4.01"},{"id":"55acb5ed-f315-4f0a-5325-08d5ad2bf6ba","name":"CENTRAIS EOLICAS RIO VERDE LTDA.","commercialName":"","cnpj":"11350476000179","city":"CAETITÉ","stateCode":"BA","buscaAdicional":"UEE VERDE 3492 RIO VERDE 20029 EOL.CV.BA.030341-0.01"},{"id":"56e5d76c-3f54-4721-5326-08d5ad2bf6ba","name":"CENTRAIS EOLICAS PLANALTINA LTDA.","commercialName":"","cnpj":"11363327000144","city":"CAETITÉ","stateCode":"BA","buscaAdicional":"UEE PLANALTINA 3493 PLANALTI 20023 EOL.CV.BA.030322-4.01"},{"id":"c5eedaf5-5d2f-4339-532b-08d5ad2bf6ba","name":"CENTRAIS EOLICAS ALVORADA LTDA.","commercialName":"","cnpj":"11349807000150","city":"CAETITÉ","stateCode":"BA","buscaAdicional":"UEE ALVORADA 3498 ALVORADA 20030 EOL.CV.BA.030320-8.01"},{"id":"fa385c1b-e03e-4fda-4f70-08d5ad2bf6ba","name":"BRASKEM S/A","commercialName":"BRASKEM","cnpj":"42150391000170","city":"CAMAÇARI","stateCode":"BA","buscaAdicional":"BRASKEM 1104 BRASKEM-UNIB 7043 BRASKEM UCS-AL 7519 BRASKEM UCS-BA 7521 BRASKEM AL 909476 BRASKEM SUL 7013 COPESUL-TRIUNFO-RS 7497 PETRO TRIUNFO-CANOAS 7516 POLIET.UNIAO S.ANDRE 7204 PETROQ UNIAO S.ANDRE 7223 RIO POLIMEROS 7276 DOW BR CUBATAO 70023 BRASKEM PP3-PAULINIA 70968 BRASKEM TMP 888838 COPESUL 8057 UTE.PE.RS.000827-3.01"},{"id":"747425fb-009c-4f5b-4fec-08d5ad2bf6ba","name":"BAHIA SPECIALTY CELLULOSE SA","commercialName":"","cnpj":"69037133000139","city":"CAMAÇARI","stateCode":"BA","buscaAdicional":"BAHIA SPECIALT 1361 BAHIA PULP-CAMACARI 7076 BAHIA PULP 8328 UTE.FL.BA.000182-1.01"},{"id":"4101146d-5c0b-4767-510a-08d5ad2bf6ba","name":"CONTINENTAL DO BRASIL PRODUTOS AUTOMOTIVOS LTDA","commercialName":"","cnpj":"02036483000614","city":"CAMAÇARI","stateCode":"BA","buscaAdicional":"CONTINENTAL BA 1957 CONTINENTAL BAHIA 889626"},{"id":"1ce1af1a-f642-4b0b-5015-08d5ad2bf6ba","name":"CRISTAL PIGMENTOS DO BRASIL S.A.","commercialName":"","cnpj":"15115504000124","city":"CAMAÇARI","stateCode":"BA","buscaAdicional":"CRISTAL BAHIA 1435 MILLENNIUM IN 888981"},{"id":"dd8a441c-196c-43cb-5016-08d5ad2bf6ba","name":"OXITENO NORDESTE S A INDUSTRIA E COMERCIO","commercialName":"","cnpj":"14109664000106","city":"CAMAÇARI","stateCode":"BA","buscaAdicional":"OXITENO NE 1436 OXITENO NORD TRIUNFO 7413"},{"id":"84ee8afe-f830-420d-54be-08d5ad2bf6ba","name":"BRIDGESTONE DO BRASIL INDUSTRIA E COMERCIO LTDA.","commercialName":"BRIDGESTONE FIRESTONE","cnpj":"57497539000700","city":"CAMAÇARI","stateCode":"BA","buscaAdicional":"BRID CAMACARI 4473 BRIDGESTONE-CAMACARI 71654"},{"id":"89a52777-f7bb-4e68-55c4-08d5ad2bf6ba","name":"BRASKEM PETROQUIMICA LTDA","commercialName":"BRASKEM PETROQUIMICA LTDA","cnpj":"04705090000681","city":"CAMAÇARI","stateCode":"BA","buscaAdicional":"BRASKEM PET 6097 QUATTOR PARTICIP. 7291 SUZANO P DQ CAXIAS 7986 SUZANO P-MAUA-SP 70019"},{"id":"0f64dc4f-fb55-4f4d-56c3-08d5ad2bf6ba","name":"NORDESTE INDUSTRIA E COMERCIO LTDA","commercialName":"FORTLEV","cnpj":"03970326000130","city":"CAMAÇARI","stateCode":"BA","buscaAdicional":"FORTLEV COMPOSTO 7621 NORDESTE IND E COM 908662"},{"id":"894ac55d-7a95-4f14-56c4-08d5ad2bf6ba","name":"FORTLEV INDUSTRIA E COMERCIO DE PLASTICOS LTDA","commercialName":"FORTLEV","cnpj":"10921911000105","city":"CAMAÇARI","stateCode":"BA","buscaAdicional":"FORTLEV MATRIZ 7640 FORTLEV CAMACARI 905483"},{"id":"21b643c3-d9d4-49c1-5761-08d5ad2bf6ba","name":"CERAMUS BAHIA SA PRODUTOS CERAMICOS","commercialName":"CERAMUS","cnpj":"13786785000111","city":"CAMAÇARI","stateCode":"BA","buscaAdicional":"CERAMUS 8750 CERAMUS CAMACARI 888874"},{"id":"0f5d738a-f591-4793-57cd-08d5ad2bf6ba","name":"CATA TECIDOS E EMBALAGENS INDUSTRIAIS LIMITADA","commercialName":"","cnpj":"15689185000160","city":"CAMAÇARI","stateCode":"BA","buscaAdicional":"CATA TECIDOS 9690 CATA CAMACARI 889054"},{"id":"22db2621-0614-42a0-7352-08d5cf600bef","name":"METANOR S A METANOL DO NORDESTE","commercialName":"","cnpj":"16234171000115","city":"CAMAÇARI","stateCode":"BA","buscaAdicional":""},{"id":"1e92ca7f-9b5e-4ad5-7345-08d5cf600bef","name":"SANSUY S/A INDUSTRIA DE PLASTICOS EM RECUPERACAO JUDICIAL","commercialName":"SANSUY DO NORDESTE","cnpj":"14807945000124","city":"CAMAÇARI","stateCode":"BA","buscaAdicional":""},{"id":"0aa18a6d-d772-4a4a-734a-08d5cf600bef","name":"INDUSTRIA DE AZULEJOS DA BAHIA S A","commercialName":"","cnpj":"15126626000116","city":"CAMAÇARI","stateCode":"BA","buscaAdicional":""},{"id":"4bc9f017-78d7-4685-66ca-08d5ad2bf6ba","name":"FLEXNGATE BRASIL INDUSTRIAL LTDA","commercialName":"FLEXNGATE DO BRASIL LTDA","cnpj":"04259490000287","city":"CAMAÇARI","stateCode":"BA","buscaAdicional":"FLEXNGATE 57831 FLEXNGATE BR 908411"},{"id":"9d9134fb-2f12-4ffd-696d-08d5ad2bf6ba","name":"CONDOMINIO CIVIL VOLUNTARIO OUTLET PREMIUM","commercialName":"","cnpj":"21486661000149","city":"CAMAÇARI","stateCode":"BA","buscaAdicional":"OUTLET PREMIUM 61370 OUTLET PREMIUM 912317"},{"id":"9fad33b9-e73f-4042-695c-08d5ad2bf6ba","name":"CETREL S.A.","commercialName":"CETREL","cnpj":"14414973000181","city":"CAMAÇARI","stateCode":"BA","buscaAdicional":"CETREL 61097 CETREL - COMPLEXO BA 911919 CETREL - COBRE 911980"},{"id":"a2ea367f-12ce-45ef-68e7-08d5ad2bf6ba","name":"CORLEX INDUSTRIA E COMERCIO DE PRODUTOS PLASTICOS LTDA","commercialName":"CORLEX","cnpj":"05826228000159","city":"CAMAÇARI","stateCode":"BA","buscaAdicional":"AMPACET 60550 CORPLEX BAHIA 911251"},{"id":"d0b0cdb8-ab2d-4049-6891-08d5ad2bf6ba","name":"VALFILM NORDESTE INDUSTRIA E COMERCIO DE PLASTICOS LTDA.","commercialName":"TECNOVAL","cnpj":"04613520000120","city":"CAMAÇARI","stateCode":"BA","buscaAdicional":"VALFILM NE 60156 VALFILM NE PLAST 910125"},{"id":"c528925c-d23f-4ac7-650e-08d5ad2bf6ba","name":"BMD TEXTEIS LTDA","commercialName":"","cnpj":"03156784000130","city":"CAMAÇARI","stateCode":"BA","buscaAdicional":"BMD 56456 BMD TEXTEIS 907741"},{"id":"f0182fe8-5a13-40bd-6544-08d5ad2bf6ba","name":"PEROXY BAHIA INDUSTRIA QUIMICA LTDA","commercialName":"PEROXY","cnpj":"08290429000172","city":"CAMAÇARI","stateCode":"BA","buscaAdicional":"PEROXY 56635 PEROXY BAHIA IND QMC 907151"},{"id":"7fe491eb-7b86-4414-63fd-08d5ad2bf6ba","name":"SODECIA DA BAHIA LTDA","commercialName":"","cnpj":"04095571000299","city":"CAMAÇARI","stateCode":"BA","buscaAdicional":"SODECIA BAHIA 55770 SODECIA BAHIA 905886"},{"id":"7f2c19c6-c9c1-4deb-62ee-08d5ad2bf6ba","name":"KNAUF DO BRASIL LTDA","commercialName":"","cnpj":"02082558000865","city":"CAMAÇARI","stateCode":"BA","buscaAdicional":"KNAUF BA 55035 KNAUF DO BRASIL 905069"},{"id":"996d4387-6233-4f90-629d-08d5ad2bf6ba","name":"TIMAC AGRO INDUSTRIA E COMERCIO DE FERTILIZANTES LTDA","commercialName":"ROULLIER","cnpj":"02329713002253","city":"CANDEIAS","stateCode":"BA","buscaAdicional":"TIMAC BA 54826 TIMAC BA 903262"},{"id":"686050fc-a888-4cd6-6896-08d5ad2bf6ba","name":"COMPANHIA ENERGETICA CANDEIAS","commercialName":"COMPANHIA ENERGETICA CANDEIAS","cnpj":"10508162000199","city":"CANDEIAS","stateCode":"BA","buscaAdicional":"CEC CANDEIAS 60187 GLOBAL II 8572 UTE.PE.BA.029639-2.01 GLOBAL I 8573 UTE.PE.BA.029653-8.01"},{"id":"10c84b91-5131-4bb3-5342-08d5ad2bf6ba","name":"PROQUIGEL QUIMICA S/A","commercialName":"POLICARBONATOS","cnpj":"27515154001225","city":"CANDEIAS","stateCode":"BA","buscaAdicional":"PROQUIGEL 3541 PROQUIGEL QUIMICA 71215"},{"id":"f04e97a0-d55c-4a03-5268-08d5ad2bf6ba","name":"DOW BRASIL INDUSTRIA E COMERCIO DE PRODUTOS QUIMICOS LTDA","commercialName":"","cnpj":"60435351001714","city":"CANDEIAS","stateCode":"BA","buscaAdicional":"DOW BRASIL 3046 DOW BRASIL-BA 70870"},{"id":"6964c9d2-d305-4a70-5888-08d5ad2bf6ba","name":"ERB ARATINGA S/A","commercialName":"ERB AGROFLORESTAL","cnpj":"12901925000192","city":"CANDEIAS","stateCode":"BA","buscaAdicional":"ERB ARATINGA 12252 ERB CANDEIAS 893022 UTE.FL.BA.030979-6.01"},{"id":"db2c449a-7200-4dbb-63e8-08d5ad2bf6ba","name":"AVIGRO AVICOLA AGROINDUSTRIAL LTDA","commercialName":"AVIGRO","cnpj":"16127441000199","city":"CONCEIÇÃO DA FEIRA","stateCode":"BA","buscaAdicional":"AVIGRO 55712 AVIGRO INCUBATORIO 907141 AVIGRO ABATEDOURO 907152"},{"id":"3768bf80-2cdb-43db-b9bf-08d5caef97db","name":"MK ELETRODOMESTICOS MONDIAL S.A.","commercialName":"MK ELETRODOMESTICOS","cnpj":"07666567000221","city":"CONCEIÇÃO DO JACUÍPE","stateCode":"BA","buscaAdicional":""},{"id":"b7942f28-d6ee-400d-659e-08d5ad2bf6ba","name":"FRYSK INDUSTRIAL LTDA","commercialName":"","cnpj":"14034584000120","city":"CONDE","stateCode":"BA","buscaAdicional":"FRYSK 56870 FRYSK INDUSTRIAL LTD 907139"},{"id":"6402faae-f471-4412-5e76-08d5ad2bf6ba","name":"CALCADOS BIBI NORDESTE LTDA","commercialName":"","cnpj":"02279361000144","city":"CRUZ DAS ALMAS","stateCode":"BA","buscaAdicional":"BIBI NORDESTE 52394 BIBI NORDESTE CALCAD 906860"},{"id":"417494b9-2830-493c-5cde-08d5ad2bf6ba","name":"PELZER DA BAHIA LTDA","commercialName":"","cnpj":"02441724000104","city":"DIAS D'ÁVILA","stateCode":"BA","buscaAdicional":"PELZERBAHIA 51596 PELZER DA BAHIA 899409"},{"id":"9c957332-3107-4d0c-6038-08d5ad2bf6ba","name":"TECNOGRES REVESTIMENTOS CERAMICOS LTDA.","commercialName":"","cnpj":"04390556000192","city":"DIAS D'ÁVILA","stateCode":"BA","buscaAdicional":"TECNOGRES 53427 TECNOGRES 901498"},{"id":"6deb27f1-31af-4ecb-5c63-08d5ad2bf6ba","name":"FAURECIA AUTOMOTIVE DO BRASIL LTDA","commercialName":"FAURECIA AUTOMOTIVE DO BRASIL LTDA","cnpj":"01178298001088","city":"DIAS D'ÁVILA","stateCode":"BA","buscaAdicional":"FAURECIA DDA 51292 FAURECIA DDA 903438"},{"id":"1fc29299-020e-4cd2-5292-08d5ad2bf6ba","name":"PARANAPANEMA S/A","commercialName":"","cnpj":"60398369000479","city":"DIAS D'ÁVILA","stateCode":"BA","buscaAdicional":"PARANAPAN 3149 PARANAPANEMA-BA 7194"},{"id":"de7ac0cb-ea34-484e-5594-08d5ad2bf6ba","name":"INCENOR INDUSTRIA CERAMICA DO NORDESTE LTDA.","commercialName":"","cnpj":"04496698000139","city":"DIAS D'ÁVILA","stateCode":"BA","buscaAdicional":"INCENOR 5839 INCENOR-DIAS DAVILA 71948"},{"id":"295bcef8-3355-427b-63b9-08d5ad2bf6ba","name":"SISA SAUIPE INDUSTRIAL S/A","commercialName":"","cnpj":"11174306000180","city":"DIAS D'ÁVILA","stateCode":"BA","buscaAdicional":"SISA SAUIPE 55588 SISA SAUIPE IND S.A. 907465"},{"id":"2e205ae4-3bb2-47a9-6116-08d5ad2bf6ba","name":"AUTOMETAL S/A","commercialName":"","cnpj":"59104513000780","city":"DIAS D'ÁVILA","stateCode":"BA","buscaAdicional":"AUTOMETAL DIAS DAVILA 54005 AUTOMETAL DDA 904822"},{"id":"0fc078cc-0e8c-4146-6919-08d5ad2bf6ba","name":"RONDELI & RONDELLI LTDA","commercialName":"SUPERMERCADOS RONDELLI","cnpj":"01993183000156","city":"EUNÁPOLIS","stateCode":"BA","buscaAdicional":"RONDELLI E RONDELLI 60769 RONDELLI - LOJA 01 912411 RONDELLI - LOJA 04 912413 RONDELLI - LOJA 02 912415 RONDELLI - LOJA 10 912431"},{"id":"ff655e7e-a209-4ca9-693a-08d5ad2bf6ba","name":"CESCONETTO INDUSTRIA E COMERCIO DE ALIMENTOS LTDA","commercialName":"","cnpj":"11727497000160","city":"EUNÁPOLIS","stateCode":"BA","buscaAdicional":"NATURAVES 60851 NATURAVES 911981"},{"id":"0ff9026b-1455-4f4d-5034-08d5ad2bf6ba","name":"VERACEL CELULOSE S.A.","commercialName":"","cnpj":"40551996000148","city":"EUNÁPOLIS","stateCode":"BA","buscaAdicional":"VERACEL 1512 VERACEL 7435 VERACEL CONV 8096 UTE.FL.BA.029014-9.01 VERACEL INCENTIVADA 8688 UTE.FL.BA.029014-9.01"},{"id":"afbbacf4-e730-43ba-4fc8-08d5ad2bf6ba","name":"AKZO NOBEL PULP AND PERFORMANCE QUIMICA BAHIA LTDA","commercialName":"","cnpj":"05869996000190","city":"EUNÁPOLIS","stateCode":"BA","buscaAdicional":"EKA BAHIA 1275 EKA BAHIA 7881"},{"id":"6ca0af4f-7d9c-4c2c-554a-08d5ad2bf6ba","name":"BORRACHAS VIPAL NORDESTE S.A.","commercialName":"BORRACHAS VIPAL NORDESTE","cnpj":"07857217000161","city":"FEIRA DE SANTANA","stateCode":"BA","buscaAdicional":"VIPAL NE 5251 VIPAL-FEIRA SANTANA 71807"},{"id":"111166ca-8c49-4085-551a-08d5ad2bf6ba","name":"PIRELLI PNEUS LTDA.","commercialName":"","cnpj":"59179838002857","city":"FEIRA DE SANTANA","stateCode":"BA","buscaAdicional":"PIRELLI 5050 PIRELLI-F SANTANA 71777"},{"id":"296350bb-0190-4750-588b-08d5ad2bf6ba","name":"PLACO DO BRASIL LTDA","commercialName":"","cnpj":"00700460000718","city":"FEIRA DE SANTANA","stateCode":"BA","buscaAdicional":"PLACO FS 12352 PLACO FS 892244"},{"id":"96fe790f-4acd-4ec5-5f32-08d5ad2bf6ba","name":"CERVEJARIAS KAISER NORDESTE S/A","commercialName":"","cnpj":"21900899000179","city":"FEIRA DE SANTANA","stateCode":"BA","buscaAdicional":"KAISER NORDESTE 52842 HEINEKEN SANTANA 899741"},{"id":"b72ff0d5-bcd3-49ef-692d-08d5ad2bf6ba","name":"PENHA EMBALAGENS BAHIA LTDA.","commercialName":"PENHA FEIRA DE SANTANA","cnpj":"06043069000189","city":"FEIRA DE SANTANA","stateCode":"BA","buscaAdicional":"PENHA FEIRA DE SANTANA 60832 PENHA BAHIA 910887"},{"id":"6c15941b-17d6-42a6-65f4-08d5ad2bf6ba","name":"NESTLE NORDESTE ALIMENTOS E BEBIDAS LTDA.","commercialName":"NESTLE NORDESTE ALIMENTOS E BEBIDAS LTDA.","cnpj":"08334818000152","city":"FEIRA DE SANTANA","stateCode":"BA","buscaAdicional":"NESTLE NE 57235 NESTLE RIB PRETO 71291 NESTLE FEIRA SANTANA 905868 NESTLE NE FILIAL 906135"},{"id":"b9b71a04-588a-48ca-62e3-08d5ad2bf6ba","name":"BRASFRUT-FRUTOS DO BRASIL LTDA","commercialName":"","cnpj":"32677726000150","city":"FEIRA DE SANTANA","stateCode":"BA","buscaAdicional":"BRASFRUT 55024 BRASFRUT 904082"},{"id":"2a4a17c0-6649-4d03-643c-08d5ad2bf6ba","name":"CONDOMINIO BOULEVARD SHOPPING FEIRA DE SANTANA","commercialName":"","cnpj":"03871681000151","city":"FEIRA DE SANTANA","stateCode":"BA","buscaAdicional":"BOULEVARD FEIRA DE SANTANA 55887 COND BOULEVARD SHOP 906859"},{"id":"a747806b-4c75-4d8c-88bc-08d5ae44ed50","name":"O L INDUSTRIA DE PAPEIS LTDA","commercialName":"O L INDUSTRIA DE PAPEIS","cnpj":"08855790000107","city":"FEIRA DE SANTANA","stateCode":"BA","buscaAdicional":"OL INDUSTRIA DE PAPEIS 50461 OL INDUSTRIA PAPEIS 904178"},{"id":"57ab94f7-15c9-4564-58ce-08d5ad2bf6ba","name":"PARQUE EOLICO ASSURUA VII S.A.","commercialName":"","cnpj":"19246849000178","city":"GENTIO DO OURO","stateCode":"BA","buscaAdicional":"ASSURUA VII 13352 ASSURUA VII 896553 EOL.CV.BA.031356-4.01"},{"id":"55cbb76f-719e-4ced-58cf-08d5ad2bf6ba","name":"PARQUE EOLICO ASSURUA V S.A.","commercialName":"","cnpj":"19246831000176","city":"GENTIO DO OURO","stateCode":"BA","buscaAdicional":"ASSURUA V 13353 ASSURUA V 896552 EOL.CV.BA.031341-6.01"},{"id":"9a72bd58-fe1c-44b8-58d0-08d5ad2bf6ba","name":"PARQUE EOLICO ASSURUA II S.A.","commercialName":"","cnpj":"19246799000129","city":"GENTIO DO OURO","stateCode":"BA","buscaAdicional":"ASSURUA II 13354 ASSURUA II 893943 EOL.CV.BA.031343-2.01"},{"id":"153ee100-61fd-4bfe-5a37-08d5ad2bf6ba","name":"PARQUE EOLICO LARANJEIRAS I S.A.","commercialName":"","cnpj":"21544025000126","city":"GENTIO DO OURO","stateCode":"BA","buscaAdicional":"LARANJEIRAS I 17228 LARANJEIRAS 1 909502 EOL.CV.BA.032349-7.01"},{"id":"14045677-fd3c-47bb-5a38-08d5ad2bf6ba","name":"PARQUE EOLICO LARANJEIRAS II S.A.","commercialName":"","cnpj":"21544159000147","city":"GENTIO DO OURO","stateCode":"BA","buscaAdicional":"LARANJEIRAS II 17229 LARANJEIRAS 2 909543 EOL.CV.BA.032350-0.01"},{"id":"344f2824-9ae0-4e27-5a39-08d5ad2bf6ba","name":"PARQUE EOLICO DIAMANTE II S.A.","commercialName":"","cnpj":"21544216000198","city":"GENTIO DO OURO","stateCode":"BA","buscaAdicional":"DIAMANTE II 17230 DIAMANTE II 909538 EOL.CV.BA.032347-0.01"},{"id":"beb357c4-5bd0-43f5-5a3a-08d5ad2bf6ba","name":"PARQUE EOLICO CURRAL DE PEDRAS II S.A.","commercialName":"","cnpj":"21544255000195","city":"GENTIO DO OURO","stateCode":"BA","buscaAdicional":"CURRAL DE PEDRAS II 17231 CURRAL DE PEDRAS 2 909537 EOL.CV.BA.032346-2.01"},{"id":"670bca36-646e-4bdc-5a2e-08d5ad2bf6ba","name":"PARQUE EOLICO ASSURUA III S.A.","commercialName":"","cnpj":"21544084000102","city":"GENTIO DO OURO","stateCode":"BA","buscaAdicional":"ASSURUA III 17206 ASSURUA 3 909535 EOL.CV.BA.032343-8.01"},{"id":"325b1d7e-1c8d-42fd-5a2f-08d5ad2bf6ba","name":"PARQUE EOLICO ASSURUA IV S.A.","commercialName":"","cnpj":"21544129000130","city":"GENTIO DO OURO","stateCode":"BA","buscaAdicional":"ASSURUA IV 17207 ASSURUA IV 910155 EOL.CV.BA.032343-8.01"},{"id":"7ab7a736-dd12-480a-5a30-08d5ad2bf6ba","name":"PARQUE EOLICO CAPOEIRAS III S.A.","commercialName":"","cnpj":"21543971000158","city":"GENTIO DO OURO","stateCode":"BA","buscaAdicional":"CAPOEIRAS III 17212 CAPOEIRAS 3 909499 EOL.CV.BA.032344-6.01"},{"id":"532c39ab-03db-4bdb-5a31-08d5ad2bf6ba","name":"PARQUE EOLICO LARANJEIRAS V S.A.","commercialName":"","cnpj":"21544060000145","city":"GENTIO DO OURO","stateCode":"BA","buscaAdicional":"LARANJEIRAS V 17213 LARANJEIRAS 5 909544 EOL.CV.BA.032351-9.01"},{"id":"89419945-b0d2-42ed-5a32-08d5ad2bf6ba","name":"PARQUE EOLICO DIAMANTE III S.A.","commercialName":"","cnpj":"21543994000162","city":"GENTIO DO OURO","stateCode":"BA","buscaAdicional":"DIAMANTE III 17214 DIAMANTE III 909539 EOL.CV.BA.032348-9.01"},{"id":"15e12d71-38ff-46be-5a33-08d5ad2bf6ba","name":"PARQUE EOLICO CURRAL DE PEDRAS I S.A.","commercialName":"","cnpj":"21541973000108","city":"GENTIO DO OURO","stateCode":"BA","buscaAdicional":"CURRAL DE PEDRAS I 17215 CURRAL DE PEDRAS 1 909536 EOL.CV.BA.032345-4.01"},{"id":"ded664ca-37bf-4cd4-60f5-08d5ad2bf6ba","name":"UFV VERDE VALE III ENERGIA SOLAR S/A","commercialName":"UFV VERDE VALE III","cnpj":"21830784000155","city":"GUANAMBI","stateCode":"BA","buscaAdicional":"VALE III 53919"},{"id":"e8caf35b-3e9a-4e26-5444-08d5ad2bf6ba","name":"CENTRAIS EOLICAS SERAIMA S.A","commercialName":"","cnpj":"12047526000106","city":"GUANAMBI","stateCode":"BA","buscaAdicional":"UEE SERAIMA 4126 SERAIMA 890773 EOL.CV.BA.030546-4.01"},{"id":"9dc40806-2b33-4da3-5600-08d5ad2bf6ba","name":"CENTRAIS EOLICAS DOURADOS S.A","commercialName":"","cnpj":"12041319000144","city":"GUANAMBI","stateCode":"BA","buscaAdicional":"UEE DOURADOS 6493 DOURADOS (UEE DOURA) 892110 EOL.CV.BA.030778-5.01"},{"id":"c8b2befd-4a04-4d9d-5602-08d5ad2bf6ba","name":"CENTRAIS EOLICAS AMETISTA S.A","commercialName":"CENTRAIS EOLICAS AMETISTA","cnpj":"11201885000103","city":"GUANAMBI","stateCode":"BA","buscaAdicional":"UEE AMETISTA 6495 AMETISTA 892082 EOL.CV.BA.030779-3.01"},{"id":"46a5ff7e-0358-4d02-532c-08d5ad2bf6ba","name":"CENTRAIS EOLICAS GUIRAPA LTDA.","commercialName":"","cnpj":"11345796000130","city":"GUANAMBI","stateCode":"BA","buscaAdicional":"UEE GUIRAPA 3499 GUIRAPA 20031 EOL.CV.BA.030342-9.01"},{"id":"23af8ad3-2fd6-4ff9-532d-08d5ad2bf6ba","name":"CENTRAIS EOLICAS PINDAI LTDA.","commercialName":"CENTRAIS EOLICAS PINDAI","cnpj":"11350542000100","city":"GUANAMBI","stateCode":"BA","buscaAdicional":"UEE PINDAI 3500 PINDAI 20032 EOL.CV.BA.030324-0.01"},{"id":"5bd9eb6b-f67b-4511-5327-08d5ad2bf6ba","name":"CENTRAIS EOLICAS LICINIO DE ALMEIDA LTDA.","commercialName":"","cnpj":"11349904000143","city":"GUANAMBI","stateCode":"BA","buscaAdicional":"UEE LICINIO 3494 LICINIO DE ALMEIDA 20025 EOL.CV.BA.030317-8.01"},{"id":"e033f6ae-c46b-400d-5320-08d5ad2bf6ba","name":"CENTRAIS EOLICAS CANDIBA LTDA.","commercialName":"","cnpj":"11349756000167","city":"GUANAMBI","stateCode":"BA","buscaAdicional":"UEE CANDIBA 3486 CANDIBA 20027 EOL.CV.BA.030316-0.01"},{"id":"4b275c98-d804-482b-5322-08d5ad2bf6ba","name":"CENTRAIS EOLICAS GUANAMBI LTDA.","commercialName":"CENTRAIS EOLICAS GUANAMBI","cnpj":"11350499000183","city":"GUANAMBI","stateCode":"BA","buscaAdicional":"UEE GUANAMBI 3489 GUANAMBI 20026 EOL.CV.BA.030328-3.01"},{"id":"9d7438ca-2000-44ec-5323-08d5ad2bf6ba","name":"CENTRAIS EOLICAS SERRA DO SALTO LTDA.","commercialName":"","cnpj":"11349836000112","city":"GUANAMBI","stateCode":"BA","buscaAdicional":"UEE SERRA 3490 SERRA DO SALTO 20028 EOL.CV.BA.030314-3.01"},{"id":"7c9cfebe-7e29-45b9-5324-08d5ad2bf6ba","name":"CENTRAIS EOLICAS IGAPORA LTDA.","commercialName":"CENTRAIS EOLICAS IGAPORA","cnpj":"11366011000106","city":"IGAPORÃ","stateCode":"BA","buscaAdicional":"UEE IGAPORA 3491 IGAPORA 20022 EOL.CV.BA.030321-6.01"},{"id":"b34a344b-d93b-4b9d-5321-08d5ad2bf6ba","name":"CENTRAIS EOLICAS PORTO SEGURO LTDA.","commercialName":"CENTRAIS EOLICAS PORTO SEGURO","cnpj":"11366056000180","city":"IGAPORÃ","stateCode":"BA","buscaAdicional":"UEE PORTO 3487 PORTO SEGURO 20019 EOL.CV.BA.030323-2.01"},{"id":"bd11bbe1-355d-49ce-5328-08d5ad2bf6ba","name":"CENTRAIS EOLICAS NOSSA SENHORA DA CONCEICAO LTDA.","commercialName":"CENTRAIS EOLICAS NOSSA SENHORA CONCEICAO","cnpj":"11371340000145","city":"IGAPORÃ","stateCode":"BA","buscaAdicional":"UEE CONCEICAO 3495 N SRA CONCEIC 20020 EOL.CV.BA.030318-6.01"},{"id":"e2bd6de5-3061-46ab-532a-08d5ad2bf6ba","name":"CENTRAIS EOLICAS ILHEUS LTDA.","commercialName":"CENTRAIS EOLICAS ILHEUS","cnpj":"11366468000110","city":"IGAPORÃ","stateCode":"BA","buscaAdicional":"UEE ILHEUS 3497 ILHEUS (ILHEUS) 20021 EOL.CV.BA.030315-1.01"},{"id":"fdb0ad90-693e-4af0-5441-08d5ad2bf6ba","name":"CENTRAIS EOLICAS DA PRATA S.A","commercialName":"CENTRAIS EOLICAS DA PRATA","cnpj":"11366231000130","city":"IGAPORÃ","stateCode":"BA","buscaAdicional":"UEE DA PRATA 4123 DA PRATA 890751 EOL.CV.BA.030490-5.01"},{"id":"6b47c01b-ff30-4fa1-584a-08d5ad2bf6ba","name":"CENTRAIS EOLICAS SAO SALVADOR S.A","commercialName":"CENTRAIS EOLICAS SAO SALVADOR","cnpj":"11197380000112","city":"IGAPORÃ","stateCode":"BA","buscaAdicional":"UEE SALVADOR 11229"},{"id":"9a9898fe-2180-4d67-56fb-08d5ad2bf6ba","name":"BARRY CALLEBAUT BRASIL INDUSTRIA E COMERCIO DE PRODUTOS ALIMENTICIOS LTDA","commercialName":"","cnpj":"33163908007005","city":"ILHÉUS","stateCode":"BA","buscaAdicional":"BARRY ILHEUS 8062 BARRY CALLEBAUT 888573"},{"id":"a5a819b8-264e-4e13-516a-08d5ad2bf6ba","name":"CARGILL AGRICOLA S A","commercialName":"CARGILL AGRICOLA","cnpj":"60498706002524","city":"ILHÉUS","stateCode":"BA","buscaAdicional":"CARGILL ILHE 2162 CARGIL ILHEUS 71458"},{"id":"17bc5d9c-0598-45da-66ec-08d5ad2bf6ba","name":"OLAM AGRICOLA LTDA.","commercialName":"","cnpj":"07028528003133","city":"ILHÉUS","stateCode":"BA","buscaAdicional":"OLAM 57885 OLAM - ILHEUS - BA 907757"},{"id":"f1151b95-5978-4491-68c2-08d5ad2bf6ba","name":"CONDOMINIO DO JEQUITIBA PLAZA SHOPPING","commercialName":"JEQUITIBA PLAZA SHOPPING","cnpj":"03932417000180","city":"ITABUNA","stateCode":"BA","buscaAdicional":"SHOPPING JEQUITIBA 60393 JEQUITIBA PLAZA SHOP 910413"},{"id":"87a5e017-6288-4107-6434-08d5ad2bf6ba","name":"CAMBUCI S/A","commercialName":"","cnpj":"61088894002828","city":"ITABUNA","stateCode":"BA","buscaAdicional":"CAMBUCI ITABUNA 1 55879 CAMBUCI ITABUNA 1 909326"},{"id":"3e9c9583-e679-4d3e-6239-08d5ad2bf6ba","name":"BARRY CALLEBAUT BRASIL INDUSTRIA E COMERCIO DE PRODUTOS ALIMENTICIOS LTDA","commercialName":"BARRY CALLEBAUT IND. E COM. DE PROD ALIM. LTDA","cnpj":"33163908009121","city":"ITABUNA","stateCode":"BA","buscaAdicional":"BARRY ITABUNA 54626 BARRY ITABUNA 903219"},{"id":"c473c341-9108-41f5-553b-08d5ad2bf6ba","name":"ITABUNA TEXTIL LTDA","commercialName":"","cnpj":"01933349000149","city":"ITABUNA","stateCode":"BA","buscaAdicional":"TRIFIL BA 5188 ITABUNA TEXTIL 71784"},{"id":"ce2d439f-0d33-46d4-523c-08d5ad2bf6ba","name":"MIRABELA MINERACAO DO BRASIL LTDA","commercialName":"MIRABELA MINERACAO DO BRASIL","cnpj":"74127010000471","city":"ITAGIBÁ","stateCode":"BA","buscaAdicional":"MIRABELA 2961 MIRABELA 70768"},{"id":"c023bb2a-4e24-4b6d-5d0c-08d5ad2bf6ba","name":"SPE ASSURUA GERADORA DE ENERGIA SOLAR S.A","commercialName":"","cnpj":"23965886000103","city":"ITAGUAÇU DA BAHIA","stateCode":"BA","buscaAdicional":"SPE ASSURUA 51687 ASSURUA 909767 UFV.RS.BA.034120-7.01"},{"id":"e3e20e03-54be-439a-63b0-08d5ad2bf6ba","name":"CAMBUCI S/A","commercialName":"","cnpj":"61088894002909","city":"ITAJUÍPE","stateCode":"BA","buscaAdicional":"CAMBUCI ITAJUIPE 55524 CAMBUCI 909325"},{"id":"94b72b85-7ab3-4057-55bb-08d5ad2bf6ba","name":"VULCABRAS AZALEIA-BA,CALCADOS E ARTIGOS ESPORTIVOS S/A","commercialName":"","cnpj":"00733658000102","city":"ITAPETINGA","stateCode":"BA","buscaAdicional":"VULC AZALE BA 6040 VULCBRAS-ITAPETINGA 71943"},{"id":"c49665c6-9e31-49e4-4fc7-08d5ad2bf6ba","name":"JACOBINA MINERACAO E COMERCIO LTDA","commercialName":"","cnpj":"42463174000130","city":"JACOBINA","stateCode":"BA","buscaAdicional":"JACOBINA 1273 JACOBINA MIN E COMER 906345"},{"id":"c2368141-3e64-419f-5141-08d5ad2bf6ba","name":"MINERACAO CARAIBA S/A","commercialName":"","cnpj":"42509257000113","city":"JAGUARARI","stateCode":"BA","buscaAdicional":"MCSA 2074 MCSA MINERAC CARAIBA 70489"},{"id":"91919dc4-c399-40c9-522b-08d5ad2bf6ba","name":"AGRO INDUSTRIAS DO VALE DO SAO FRANCISCO SA AGROVALE","commercialName":"","cnpj":"13642699000135","city":"JUAZEIRO","stateCode":"BA","buscaAdicional":"UTE AGROVALE 2903 AGROVALE 307 UTE.AI.BA.028696-6.01"},{"id":"2adcdbf4-5651-4130-64f2-08d5ad2bf6ba","name":"ASSOCIACAO DO JUA GARDEN SHOPPING","commercialName":"ASSOCIACAO DO JUA GARDEN SHOPPING","cnpj":"22647489000120","city":"JUAZEIRO","stateCode":"BA","buscaAdicional":"SHOP JUA GARDEN 56322 JUA GARDEN 905481"},{"id":"2a3a5ad8-5efd-4148-086b-08d5d8340ed3","name":"ICOFORT - AGROINDUSTRIAL LTDA","commercialName":"ICOFORT","cnpj":"02952466000112","city":"JUAZEIRO","stateCode":"BA","buscaAdicional":""},{"id":"ae9a07bf-998d-453f-6608-08d5ad2bf6ba","name":"EXTRATIVA METALQUIMICA S/A","commercialName":"GRAFITE DO BRASIL","cnpj":"03711590000310","city":"MAIQUINIQUE","stateCode":"BA","buscaAdicional":"GRAFITE DO BRASIL 57274 EXTRATIVA METALQUIMI 907740"},{"id":"52f4678e-8bd6-4a28-6790-08d5ad2bf6ba","name":"VANADIO DE MARACAS S/A","commercialName":"","cnpj":"15191786000220","city":"MARACÁS","stateCode":"BA","buscaAdicional":"VMSA 58310 VANADIO DE MARACAS 908664"},{"id":"27ece9bf-7c47-42cc-65cc-08d5ad2bf6ba","name":"NOLANDIS EMPREENDIMENTOS E PARTICIPACOES LTDA.","commercialName":"IBEROSTAR","cnpj":"05581720000101","city":"MATA DE SÃO JOÃO","stateCode":"BA","buscaAdicional":"IBEROSTAR 57138 IBEROSTAR HOTEL BAHI 907143 IBEROSTAR HT PR FORT 907144 IBEROSTAR ALOJAMENTO 907155"},{"id":"7b38b636-39e2-4a77-1cc2-08d5b8870181","name":"UHT - INVESTIMENTOS, PARTICIPACOES E EMPREENDIMENTOS HOTELEIROS LTDA.","commercialName":"GRAND PALLADIUM IMBASSAI RESORT & SPA","cnpj":"07224103000184","city":"MATA DE SÃO JOÃO","stateCode":"BA","buscaAdicional":"GRAND PALLADIUM 61175 GRAND PALLADIUM 912863"},{"id":"aaefde77-6394-496b-5582-08d5ad2bf6ba","name":"SAUIPE S/A","commercialName":"","cnpj":"00866577000180","city":"MATA DE SÃO JOÃO","stateCode":"BA","buscaAdicional":"COSTA SAUIPE 5720 SAUIPE PARK HVNPRAIA 889185 CS SAUIPE PREMIUM 889186 C S ALL INCLUSIVE 889187 CS SUPER CLUBS 889188 CS SAUIPE CLASS 889189 CS COSTA CONVENTIONS 889190"},{"id":"83e5dbff-276d-42af-5b57-08d5ad2bf6ba","name":"PETRORECONCAVO S.A.","commercialName":"PETRORECONCAVO","cnpj":"03342704000130","city":"MATA DE SÃO JOÃO","stateCode":"BA","buscaAdicional":"PETRORECONCAVO 50616 PETRORECONCAVO TAQUI 904468 PETRORECONCAVO 898168"},{"id":"16319bff-0f89-4d13-5977-08d5ad2bf6ba","name":"PARQUE EOLICO BOA VISTA S.A.","commercialName":"EMPREENDIMENTO EOLICO VENTOS DA BAHIA VIII","cnpj":"20088432000103","city":"MULUNGU DO MORRO","stateCode":"BA","buscaAdicional":"EOL BOA VISTA 14558 VENTOS DA BAHIA 8 909792 EOL.CV.BA.031771-3.01"},{"id":"6280536c-86b9-4ab6-5978-08d5ad2bf6ba","name":"PARQUE EOLICO ALTO DO BONITO S.A.","commercialName":"EMPREENDIMENTO EOLICO VENTOS DA BAHIA II","cnpj":"20081333000108","city":"MULUNGU DO MORRO","stateCode":"BA","buscaAdicional":"EOL ALTO DO BONITO 14559 VENTOS DA BAHIA 2 909383 EOL.CV.BA.031758-6.01"},{"id":"9754bcc1-baff-400c-5603-08d5ad2bf6ba","name":"CENTRAIS EOLICAS BORGO S.A","commercialName":"","cnpj":"12041341000194","city":"PINDAÍ","stateCode":"BA","buscaAdicional":"UEE BORGO 6496 BORGO 892083 EOL.CV.BA.030837-4.01"},{"id":"4f5a1d7b-e2fb-4528-5604-08d5ad2bf6ba","name":"CENTRAIS EOLICAS SERRA DO ESPINHACO S.A","commercialName":"","cnpj":"12049958000156","city":"PINDAÍ","stateCode":"BA","buscaAdicional":"UEE SERRA ESP 6497 SERRA DO ESPINHACO 892114 EOL.CV.BA.030802-1.01"},{"id":"16da13dd-31ef-4998-5606-08d5ad2bf6ba","name":"CENTRAIS EOLICAS PELOURINHO S.A","commercialName":"","cnpj":"12048031000100","city":"PINDAÍ","stateCode":"BA","buscaAdicional":"UEE PELOURINHO 6499 PELOURINHO 892102 EOL.CV.BA.030793-9.01"},{"id":"7cd73fde-5228-4e13-5607-08d5ad2bf6ba","name":"CENTRAIS EOLICAS CAETITE S.A","commercialName":"CENTRAIS EOLICAS CAETITE","cnpj":"11201767000103","city":"PINDAÍ","stateCode":"BA","buscaAdicional":"UEE CAETITE 6500 CAETITE 892084 EOL.CV.BA.030792-0.01"},{"id":"b9a5378f-4c4b-4cea-5608-08d5ad2bf6ba","name":"CENTRAIS EOLICAS ESPIGAO S.A","commercialName":"CENTRAIS EOLICAS ESPIGAO","cnpj":"11197321000144","city":"PINDAÍ","stateCode":"BA","buscaAdicional":"UEE ESPIGAO 6501 ESPIGAO 892118 EOL.CV.BA.030803-0.01"},{"id":"a94b7a20-b1e6-4280-5013-08d5ad2bf6ba","name":"CIA DE FERRO LIGAS DA BAHIA FERBASA","commercialName":"","cnpj":"15141799000103","city":"POJUCA","stateCode":"BA","buscaAdicional":"FERBASA 1426 FERBASA BA 177 FERBASA ANDORINHA BA 70261"},{"id":"33d7f994-9ad1-4657-5000-08d5ad2bf6ba","name":"SUZANO PAPEL E CELULOSE S.A.","commercialName":"SUZANO PAPEL E CELULOSE","cnpj":"16404287000155","city":"SALVADOR","stateCode":"BA","buscaAdicional":"SUZANO CEL N 1395 BAHIA SUL CELU LIVRE 7056 SUZANO - LIMEIRA SP 7090 SUZANO IMPERATRIZ 889973 PAPEL SUZANO 7225 SUZANO MIGUEL BADRA 899359 SUZANO MUCURI 893724 UTE.FL.BA.000187-2.01 SUZANO MARANHAO 891582 UTE.FL.MA.030959-1.01"},{"id":"d164bb7f-3fde-4daa-4ef2-08d5ad2bf6ba","name":"COMPANHIA DE ELETRICIDADE DO ESTADO DA BAHIA COELBA","commercialName":"","cnpj":"15139629000194","city":"SALVADOR","stateCode":"BA","buscaAdicional":"COELBA 30 COELBA 7 COELBA DITC 70758 COELBA ICG-IGAPORA 897026"},{"id":"e1c2f847-97af-499d-5214-08d5ad2bf6ba","name":"CONDOMINIO DO SALVADOR SHOPPING","commercialName":"","cnpj":"08867234000142","city":"SALVADOR","stateCode":"BA","buscaAdicional":"COND SALVADOR 2858 COND SALV SHOPPING 70732"},{"id":"8ebab680-0b57-45ce-521c-08d5ad2bf6ba","name":"TERMOVERDE SALVADOR S.A.","commercialName":"","cnpj":"10267349000148","city":"SALVADOR","stateCode":"BA","buscaAdicional":"TERMOVERDE I1 2875 SALVADOR 8812 UTE.RU.BA.002683-2.01"},{"id":"f986f232-b990-4b41-51e4-08d5ad2bf6ba","name":"ELETROGOES S/A","commercialName":"","cnpj":"32923187000191","city":"SALVADOR","stateCode":"BA","buscaAdicional":"ELETROGOES 2700 RONDON II 8824 UHE.PH.RO.027448-8.01"},{"id":"ccf12271-486d-4ba1-52f2-08d5ad2bf6ba","name":"MOINHO CANUELAS LTDA","commercialName":"MOINHO CANUELAS","cnpj":"03763491000200","city":"SALVADOR","stateCode":"BA","buscaAdicional":"CANUELAS 3363 MOINHO CANUELAS 71053"},{"id":"c57a5a87-c743-45b8-5294-08d5ad2bf6ba","name":"TELEVISAO BAHIA S.A.","commercialName":"TVBAHIA","cnpj":"13425269000161","city":"SALVADOR","stateCode":"BA","buscaAdicional":"TV BAHIA 3157 TV-BAHIA 904353"},{"id":"21a4f149-00a2-45ff-55c0-08d5ad2bf6ba","name":"SUB-CONDOMINIO SHOPPING CENTER SALVADOR NORTE SHOPPING","commercialName":"SUB - CONDOMINIO SHOPPING CENTER","cnpj":"13039848000176","city":"SALVADOR","stateCode":"BA","buscaAdicional":"SALVADOR NSHOP 6060 SALVADOR NSHOP 71916"},{"id":"7b63060d-4d43-4e44-56c9-08d5ad2bf6ba","name":"BOMIX INDUSTRIA DE EMBALAGENS LTDA","commercialName":"BOMIX","cnpj":"01561279000145","city":"SALVADOR","stateCode":"BA","buscaAdicional":"BOMIX 7683 BOEMIX SALVADOR 72385"},{"id":"83b504fe-be96-4e5b-5664-08d5ad2bf6ba","name":"BOMPRECO BAHIA SUPERMERCADOS LTDA","commercialName":"BOMPRECO","cnpj":"97422620000150","city":"SALVADOR","stateCode":"BA","buscaAdicional":"BOMPRECO BA 7000 BOM PRECO B593 ARACA 72355 BOMPRECO B515 888402 BOMPRECO B520 888596 BOMPRECO B517 888634 BOMPRECO B584 889955 BOMPRECO B524 890134 BOMPRECO B589 890135 BOMPRECO B510 890153 BOMPRECO B558 890297 BOMPRECO B554 890601 BOMPRECO B528 891083 B PRECO B560 892926 BOMPRECO B529 893822 BOMPRECO B564 894162 BOMPRECO B571 894482 BOMPRECO B579 894883 BOMPRECO B525 CANELA 894884 BOMPRECO B563 894923 B7458 CD SALVADOR 913592"},{"id":"4be4b93d-c612-4755-575c-08d5ad2bf6ba","name":"SANTA CASA DE MISERICORDIA DA BAHIA","commercialName":"ADMINISTRACAO CENTRAL","cnpj":"15153745000168","city":"SALVADOR","stateCode":"BA","buscaAdicional":"SANTA CASA 8669 ST CASA BA INTERNATO 888625 ST CASA MISERICORDIA 888626"},{"id":"f45e49c9-5845-46a6-576b-08d5ad2bf6ba","name":"JACOBS DOUWE EGBERTS BR COMERCIALIZACAO DE CAFES LTDA.","commercialName":"","cnpj":"02333707003675","city":"SALVADOR","stateCode":"BA","buscaAdicional":"DEMB SALVADOR 8814 DEMB SALVADOR 889129"},{"id":"88f64c94-7307-42a5-57a2-08d5ad2bf6ba","name":"CONDOMINIO SALVADOR TRADE CENTER","commercialName":"CONDOMINIO DO SALVADOR TRADE CENTER","cnpj":"05246359000167","city":"SALVADOR","stateCode":"BA","buscaAdicional":"SSA TRADE 9269 SSA TRADE CENTER 889612"},{"id":"6f64b6b0-2289-42b6-5563-08d5ad2bf6ba","name":"ASBEC-SOCIEDADE BAIANA DE EDUCACAO E CULTURA LTDA","commercialName":"CENTRO UNIVERSITARIO JORGE AMADO","cnpj":"01120386000138","city":"SALVADOR","stateCode":"BA","buscaAdicional":"UNIJORGE 5473 ASBEC-TROBOGY 72120 UNIJORGE COMERCIO BA 899611"},{"id":"80ce5724-42ef-46dc-5597-08d5ad2bf6ba","name":"CONDOMINIO CIVIL SHOPPING CENTER","commercialName":"CONDOMINIO CIVIL SHOPPING CENTER PARALELA","cnpj":"08401841000112","city":"SALVADOR","stateCode":"BA","buscaAdicional":"SHOP PARALELA 5879 SHOP PARALELA SALVD 71942"},{"id":"724eaa64-6687-4fde-554c-08d5ad2bf6ba","name":"CONDOMINIO BARRA","commercialName":"","cnpj":"16275232000192","city":"SALVADOR","stateCode":"BA","buscaAdicional":"COND BARRA 5274 COND BARRA LOJAS-BA 71797 COND BARRA ADM-BA 71798"},{"id":"e08aedd3-df67-476d-5557-08d5ad2bf6ba","name":"SOCIEDADE ANONIMA HOSPITAL ALIANCA","commercialName":"HOSPITAL ALIANCA","cnpj":"13016092000140","city":"SALVADOR","stateCode":"BA","buscaAdicional":"HOSP ALIANCA 5389 HSP ALIANCA-SALVADOR 72288 HSP ALIANCA - PEDIAT 72336"},{"id":"abc6573e-4aa6-416b-58c3-08d5ad2bf6ba","name":"FACS SERVICOS EDUCACIONAIS LTDA","commercialName":"FACS","cnpj":"13526884000164","city":"SALVADOR","stateCode":"BA","buscaAdicional":"FACS 13195 FACS PA - 06 892502 FACS 09 NORTE 892702 FACS 892703 FACS PA-07 895025 FACS CTN 901537 FACS PA-10 908826 PA1 911278 PA2 911297 POS 912991 FEIRA SANTA MONICA 913341"},{"id":"7b750bd8-d690-44bd-5a95-08d5ad2bf6ba","name":"CONDOMINIO SHOPPING BELA VISTA","commercialName":"","cnpj":"14919379000142","city":"SALVADOR","stateCode":"BA","buscaAdicional":"SHOPPING BELA VISTA 50090 COND SHOP BELA VISTA 72094"},{"id":"20d3c8b6-4566-4376-5abc-08d5ad2bf6ba","name":"ENEL GREEN POWER CRISTALANDIA II EOLICA S.A","commercialName":"","cnpj":"23049225000138","city":"SALVADOR","stateCode":"BA","buscaAdicional":"CRISTALANDIA II 50215 CRISTALANDIA II 909555 EOL.CV.BA.032082-0.01 CRISTALANDIA III 909556 EOL.CV.BA.032083-8.01"},{"id":"894f1f68-1665-4aef-5d68-08d5ad2bf6ba","name":"MERCANTIL RODRIGUES COMERCIAL LTDA","commercialName":"MERCANTIL RODRIGUES","cnpj":"09182947000135","city":"SALVADOR","stateCode":"BA","buscaAdicional":"MERCANTIL RODRIGUES 51810 MERCANTIL RODRIGUES 900994 MERCANTIL LJ 815 906396"},{"id":"4274e75b-55dd-4f7f-6104-08d5ad2bf6ba","name":"CONDOMINIO SHOPPING CENTER LAPA","commercialName":"SHOPPING CENTER LAPA","cnpj":"01143325000196","city":"SALVADOR","stateCode":"BA","buscaAdicional":"SHOPPING LAPA 53957 SHOP CENTER LAPA SER 903441 SHOP CENTER LAPA LOJ 903455"},{"id":"70ddb466-1b35-4862-6039-08d5ad2bf6ba","name":"ASSA ABLOY BRASIL INDUSTRIA E COMERCIO LTDA","commercialName":"","cnpj":"02214604000166","city":"SALVADOR","stateCode":"BA","buscaAdicional":"PAPAIZ SALVADOR 53430 PAPAIZ SALVADOR 904099"},{"id":"c08a5392-9e0b-47e3-5fe5-08d5ad2bf6ba","name":"FONTE NOVA NEGOCIOS E PARTICIPACOES S.A. - FNP","commercialName":"","cnpj":"08906994000111","city":"SALVADOR","stateCode":"BA","buscaAdicional":"FONTE NOVA 53279 ARENA FONTE NOVA 900637"},{"id":"841f8aaf-ff01-4e96-b9c0-08d5caef97db","name":"MONTE PASCOAL HOTEIS LTDA","commercialName":"MONTE PASCOAL PRAIA HOTEL","cnpj":"03361880000110","city":"SALVADOR","stateCode":"BA","buscaAdicional":""},{"id":"4be1f55d-8160-45c6-7237-08d5cf600bef","name":"COMPANHIA DE PARTICIPACOES ALIANCA DA BAHIA","commercialName":"ALIANCA PARTICIPACOES","cnpj":"01938783000111","city":"SALVADOR","stateCode":"BA","buscaAdicional":""},{"id":"6d388d04-140e-4385-734b-08d5cf600bef","name":"COMPANHIA DE SEGUROS ALIANCA DA BAHIA","commercialName":"","cnpj":"15144017000190","city":"SALVADOR","stateCode":"BA","buscaAdicional":""},{"id":"8371e278-29a6-4656-7342-08d5cf600bef","name":"PARTICIPACOES INDUSTRIAIS DO NORDESTE S/A","commercialName":"","cnpj":"14308514000113","city":"SALVADOR","stateCode":"BA","buscaAdicional":""},{"id":"07e9c297-18f0-435e-7349-08d5cf600bef","name":"CORREA RIBEIRO SA COMERCIO E INDUSTRIA","commercialName":"","cnpj":"15101405000193","city":"SALVADOR","stateCode":"BA","buscaAdicional":""},{"id":"a4bd7a4c-cda2-408b-730c-08d5cf600bef","name":"VIABAHIA CONCESSIONARIA DE RODOVIAS S.A.","commercialName":"","cnpj":"10670314000155","city":"SALVADOR","stateCode":"BA","buscaAdicional":""},{"id":"3914c332-bd08-48fe-423c-08d5e5532bcf","name":"SMF LTDA","commercialName":"ECOPOTENCO ENERGIA SUSTENTAVEL","cnpj":"30173278000121","city":"SALVADOR","stateCode":"BA","buscaAdicional":""},{"id":"7056f964-8df5-491c-4f0e-08d5d159243d","name":"OLEOS DE PALMA S A AGRO INDUSTRIAL","commercialName":"","cnpj":"15151269000146","city":"SALVADOR","stateCode":"BA","buscaAdicional":""},{"id":"2ca3610b-e998-445c-8d7d-08d5d060706e","name":"IUNI EDUCACIONAL - UNIME SALVADOR LTDA","commercialName":"IUNI EDUCACIONAL - UNIME SALVADOR","cnpj":"03395289000183","city":"SALVADOR","stateCode":"BA","buscaAdicional":"UNIME SALVADOR 58180 UNIME SALVADOR 3 913417"},{"id":"2b59a388-4944-44c4-65d3-08d5ad2bf6ba","name":"TECON SALVADOR S/A","commercialName":"TECON","cnpj":"03642342000101","city":"SALVADOR","stateCode":"BA","buscaAdicional":"TECON 57153 TECON SALVADOR S/A 906838"},{"id":"2bece315-ae4b-4fff-661c-08d5ad2bf6ba","name":"CBES - CENTRO BAIANO DE ENSINO SUPERIOR LTDA","commercialName":"AREA I - FACULDADE DE CIENCIA E TECNOLOGIA","cnpj":"02250176000127","city":"SALVADOR","stateCode":"BA","buscaAdicional":"AREA 1 57314 CBES 908656"},{"id":"8d45d36e-39ac-4576-661d-08d5ad2bf6ba","name":"ABEP - ACADEMIA BAIANA DE ENSINO PESQUISA E EXTENSAO LTDA","commercialName":"FACULDADE RUY BARBOSA","cnpj":"13477369000131","city":"SALVADOR","stateCode":"BA","buscaAdicional":"ABEP 57315 RUIBARBOSA4842163 909772 RUIBARBOSA10015087 909776"},{"id":"abc4d8c6-da3c-4993-66fd-08d5ad2bf6ba","name":"CONDOMINIO SHOPPING ITAIGARA","commercialName":"","cnpj":"13501226000118","city":"SALVADOR","stateCode":"BA","buscaAdicional":"SHOPPING ITAIGARA 57910 SHOPPING ITAIGARA 908207"},{"id":"b67092f1-5ede-4685-6914-08d5ad2bf6ba","name":"INDUSTRIA BAIANA DE COLCHOES E ESPUMAS LTDA","commercialName":"","cnpj":"02748342000110","city":"SALVADOR","stateCode":"BA","buscaAdicional":"ORTOBOM SALVADOR1 60762 ORTOBOM SALVADOR 1 F 911285 ORTOBOM SALVADOR 1 911339"},{"id":"1d04d156-6405-439c-6969-08d5ad2bf6ba","name":"BAHIA STELLA ADMINISTRACAO DE HOTEIS, BARES E RESTAURANTE LTDA.","commercialName":"GRAN HOTEL STELLA MARIS RESORT & CONVENTIONS","cnpj":"11050832000139","city":"SALVADOR","stateCode":"BA","buscaAdicional":"GRAN HOTEL STELLA MARIS 61230 BAHIA STELLA ADMINIS 911918"},{"id":"01e77c25-52ec-494d-8869-08d5ae44ed50","name":"SHOPPING BELA VISTA LTDA","commercialName":"","cnpj":"09389814000134","city":"SALVADOR","stateCode":"BA","buscaAdicional":"HORTO B VISTA 5670"},{"id":"64a62b86-be67-427e-6808-08d5ad2bf6ba","name":"GJP ADMINISTRADORA DE HOTEIS LTDA","commercialName":"GJP HOTEIS E RESORTS","cnpj":"07687928001107","city":"SALVADOR","stateCode":"BA","buscaAdicional":"SHERATON 59210 SHERATON 910399"},{"id":"8902b48d-b88a-43a0-654d-08d5ad2bf6ba","name":"EMPRESA BAIANA DE AGUAS E SANEAMENTO SA","commercialName":"EMBASA","cnpj":"13504675000110","city":"SALVADOR","stateCode":"BA","buscaAdicional":"EMBASA 56644 EMBASA PEDRA CAVALO 906754 EMBASA BOLANDEIRA 906911 EMBASA PRINCIPAL 906945 EMBASA FEIRA DE SANT 906916 EMBASA R7 908452 EMBASA ALPHA 908560"},{"id":"b302a90a-890a-4f26-647e-08d5ad2bf6ba","name":"CIAPLAST COMPANHIA DE PLASTICOS INDUSTRIA E COMERCIO LTDA","commercialName":"CIAPLAST","cnpj":"02779315000104","city":"SALVADOR","stateCode":"BA","buscaAdicional":"ORTOBOM SALVADOR 2 56031 ORTOBOM CIAPLAST 907140"},{"id":"1484db90-251f-474d-643e-08d5ad2bf6ba","name":"CONDOMINIO SHOPPING DA BAHIA","commercialName":"","cnpj":"14804587000104","city":"SALVADOR","stateCode":"BA","buscaAdicional":"COND SHOPPING BAHIA 55895 SHOPPING DA BAHIA 906990 SHOPPING DA BAHIA 2 906992"},{"id":"d523c194-e720-4d6a-6415-08d5ad2bf6ba","name":"M DIAS BRANCO S.A. INDUSTRIA E COMERCIO DE ALIMENTOS","commercialName":"GRANDE MOINHO ARATU","cnpj":"07206816003050","city":"SALVADOR","stateCode":"BA","buscaAdicional":"M DIAS BRANCO BA 55834 MOINHO DIAS BRANCO 906991"},{"id":"9c318856-b51d-4469-6302-08d5ad2bf6ba","name":"INDUSTRIAS REUNIDAS RAYMUNDO DA FONTE SA","commercialName":"","cnpj":"11507415000253","city":"SALVADOR","stateCode":"BA","buscaAdicional":"RAYMUNDOFONTE BA 55077 RAYMUNDO DA FONTE 904297"},{"id":"4329f115-79c4-4504-6199-08d5ad2bf6ba","name":"CONDOMINIO MUNDO PLAZA","commercialName":"CONDOMINIO MUNDO PLAZA","cnpj":"13281747000107","city":"SALVADOR","stateCode":"BA","buscaAdicional":"MUNDO PLAZA 54258 CONDOMINIO MUNDO PLA 903100"},{"id":"95d69deb-034c-43b3-6524-08d5ad2bf6ba","name":"SANTA LUZ DESENVOLVIMENTO MINERAL LTDA","commercialName":"SANTA LUZ DESENVOLVIMENTO MINERAL","cnpj":"22103965000142","city":"SANTALUZ","stateCode":"BA","buscaAdicional":"SANTA LUZ 56528 SANTA LUZ MINERAL 905887"},{"id":"81ae972d-8a50-484c-5ba7-08d5ad2bf6ba","name":"PENHA PAPEIS E EMBALAGENS LTDA","commercialName":"PENHA PAPEIS","cnpj":"03990321000179","city":"SANTO AMARO","stateCode":"BA","buscaAdicional":"PENHA STO AMARO 50811 PENHA PAPEIS 899081"},{"id":"5ea1b819-e22f-4f43-579f-08d5ad2bf6ba","name":"GUJAO ALIMENTOS S/A","commercialName":"GUJAO ALIMENTOS","cnpj":"34149823000448","city":"SÃO GONÇALO DOS CAMPOS","stateCode":"BA","buscaAdicional":"GUJAO 9249 GUJAO ALIMENTOS 889257"},{"id":"27685846-b589-4abb-55a8-08d5ad2bf6ba","name":"CROMEX S/A","commercialName":"CROMEX","cnpj":"02271463000466","city":"SIMÕES FILHO","stateCode":"BA","buscaAdicional":"CROMEX FILIAL 5957 CROMEX FILIAL NOVA 71917 CROMEX FILIAL 71918"},{"id":"cf9c4ad9-7ea0-4c85-54ae-08d5ad2bf6ba","name":"BALL EMBALAGENS LTDA","commercialName":"BALL","cnpj":"00835301000135","city":"SIMÕES FILHO","stateCode":"BA","buscaAdicional":"BALL EMBALAGENS 4435 BALL - TRES RIOS 71614 LATAPACK-S FILHO 71754"},{"id":"699e0bdc-2ce7-4d55-526d-08d5ad2bf6ba","name":"SICBRAS - CARBETO DE SILICIO DO BRASIL LTDA","commercialName":"SICBRAS","cnpj":"07305883000197","city":"SIMÕES FILHO","stateCode":"BA","buscaAdicional":"SICBRAS 3052 SICBRAS 903153"},{"id":"4d4b3660-2332-4ce4-4f9c-08d5ad2bf6ba","name":"VALE MANGANES S.A","commercialName":"VALE MANGANES","cnpj":"15144306000199","city":"SIMÕES FILHO","stateCode":"BA","buscaAdicional":"RIO DOCE 1185 VALE MANGANES-BA 70195 R DOCE MANG BARBACEN 7765 RDOCE MANG O PRETO 7761"},{"id":"d994403b-76f5-433e-62ec-08d5ad2bf6ba","name":"ROBERT BOSCH LIMITADA","commercialName":"","cnpj":"45990181002718","city":"SIMÕES FILHO","stateCode":"BA","buscaAdicional":"BOSCH ARATU 55033 ROBERT BOSCH LTDA 905275"},{"id":"d389e35f-3575-458d-67e2-08d5ad2bf6ba","name":"COBREMACK INDUSTRIA DE CONDUTORES ELETRICOS EIRELI","commercialName":"COBREMACK","cnpj":"11065453000112","city":"SIMÕES FILHO","stateCode":"BA","buscaAdicional":"COBREMACK 58793 COBREMACK INDUSTRIA 909838 COBREMACK CONDUTORES 911956"},{"id":"32ff8e0c-6314-40b9-6927-08d5ad2bf6ba","name":"RONDELLI CENTER LTDA","commercialName":"RONDELLI CENTER","cnpj":"08274692000178","city":"TEIXEIRA DE FREITAS","stateCode":"BA","buscaAdicional":"RONDELLI CENTER 60810 RONDELLI - LOJA 20 912412 RONDELLI - LOJA 22 912414 RONDELLI - LOJA 24 912416 RONDELLI - LOJA 25 912417"},{"id":"d26d077c-b123-41fd-6285-08d5ad2bf6ba","name":"JPI PARTICIPACOES LTDA","commercialName":"JPI PARTICIPACOES","cnpj":"15100660000200","city":"TEIXEIRA DE FREITAS","stateCode":"BA","buscaAdicional":"JPI BA 54792 JPI PARTICIPACOES 903135"},{"id":"39ec30bc-92a6-433a-423b-08d5e5532bcf","name":"ECOVOLTY ENGENHARIA LTDA","commercialName":"","cnpj":"27991008000113","city":"TEIXEIRA DE FREITAS","stateCode":"BA","buscaAdicional":""},{"id":"d11120eb-547a-410a-5f7b-08d5ad2bf6ba","name":"COMPANHIA VALENCA INDUSTRIAL","commercialName":"","cnpj":"15102098000165","city":"VALENÇA","stateCode":"BA","buscaAdicional":"CVI VALENCA 52984 CIA IND VALENCA 908215"},{"id":"ceca4ea9-2104-4941-5e96-08d5ad2bf6ba","name":"COMPANHIA BRASILEIRA DE BENTONITA LTDA","commercialName":"COMPANHIA DE BENTONITA","cnpj":"04885978000139","city":"VITÓRIA DA CONQUISTA","stateCode":"BA","buscaAdicional":"CIA BENTONITA 52456 BENTONITA 900655"},{"id":"bdce41a8-87bf-442e-56e9-08d5ad2bf6ba","name":"PLASCHIO PLASTICOS CHIACCHIO LTDA","commercialName":"PLASCHIO EMBALAGENS","cnpj":"07276075000149","city":"VITÓRIA DA CONQUISTA","stateCode":"BA","buscaAdicional":"PLASCHIO 7987 PLASCHIO PLASTICOS 889529"},{"id":"30f6b987-b551-4e7a-5927-08d5ad2bf6ba","name":"PCH DOURADOS USINA LTDA","commercialName":"","cnpj":"07331935000108","city":"ABADIA DOS DOURADOS","stateCode":"MG","buscaAdicional":"PCH DOURADOS 13935 CGH DOURADOS 911902 CGH.PH.MG.029271-0.01"},{"id":"50cbbb0d-ecf3-40ba-5d44-08d5ad2bf6ba","name":"UNISSUL SUPERMERCADOS S/A","commercialName":"UNISSUL","cnpj":"06311489000107","city":"ALFENAS","stateCode":"MG","buscaAdicional":"UNISSUL SM 51753 UNISSUL ALFENAS 908611 UNISSUL PARAISOPOLIS 908612 UNISSUL CAMPOS GERAI 908613 UNISSUL BOA ESPERANC 908631 UNISSUL PASSOS 908632"},{"id":"197f3ef6-2c54-4cc3-6482-08d5ad2bf6ba","name":"COFCO INTERNATIONAL COMERCIO E ARMAZENAGEM DE GRAOS LTDA.","commercialName":"","cnpj":"08963419000150","city":"ALFENAS","stateCode":"MG","buscaAdicional":"COFCO AGRI 56051 COFCO AGRI ALFENAS 908260"},{"id":"4b6e6b23-11f3-4f78-56d0-08d5ad2bf6ba","name":"KOHLER PRODUTOS PARA COZINHAS E BANHEIROS LTDA","commercialName":"FIORI","cnpj":"20373585000100","city":"ANDRADAS","stateCode":"MG","buscaAdicional":"FIORI 7781 FIORI 2 888121 FIORI 1 888141"},{"id":"e6a308ff-b3cb-4632-53a6-08d5ad2bf6ba","name":"ICASA INDUSTRIA CERAMICA ANDRADENSE S/A","commercialName":"ICASA","cnpj":"17884560000159","city":"ANDRADAS","stateCode":"MG","buscaAdicional":"ICASA 3746 ICASA 71276"},{"id":"0b84f440-da56-4b94-6534-08d5ad2bf6ba","name":"GO4 PARTICIPACOES E EMPREENDIMENTOS S.A","commercialName":"GO4 MINA BARATINHA","cnpj":"09303353000305","city":"ANTÔNIO DIAS","stateCode":"MG","buscaAdicional":"BEMISA 56590 GO4 PARTICIPACOES 905890"},{"id":"308ed45f-9f68-417e-5a9c-08d5ad2bf6ba","name":"FITECA-FIACAO E TECELAGEM ARACAI LTDA","commercialName":"","cnpj":"02350191000147","city":"ARAÇAÍ","stateCode":"MG","buscaAdicional":"FITECA 50105 FITECA 898010"},{"id":"7c584ce5-a69b-452e-523b-08d5ad2bf6ba","name":"MATABOI ALIMENTOS LTDA","commercialName":"","cnpj":"16820052000144","city":"ARAGUARI","stateCode":"MG","buscaAdicional":"MATABOIARI 2950 FRIGORIFICO MATABOI 70795"},{"id":"8363b6e5-8193-454f-4f56-08d5ad2bf6ba","name":"COMPANHIA BRASILEIRA DE METALURGIA E MINERACAO","commercialName":"","cnpj":"33131541000108","city":"ARAXÁ","stateCode":"MG","buscaAdicional":"CBMM 1060 CBMM-ARAXA 7603"},{"id":"72dc167f-02f5-42a3-5d3b-08d5ad2bf6ba","name":"BEM BRASIL ALIMENTOS LTDA","commercialName":"","cnpj":"06004860000180","city":"ARAXÁ","stateCode":"MG","buscaAdicional":"BEM BRASIL 51743 BEM BRASIL ALIMENTOS 900529"},{"id":"26b42a7b-a086-4c54-6355-08d5ad2bf6ba","name":"TAUA GRANDE HOTEL DE ARAXA E TERMAS LTDA","commercialName":"","cnpj":"11677228000137","city":"ARAXÁ","stateCode":"MG","buscaAdicional":"TAUA HOTEL ARAXA 55314 TAUA HOTEL ARAXA 02 906986"},{"id":"b57f8b9c-3dc0-41e2-6389-08d5ad2bf6ba","name":"SERYA ALIMENTOS S.A.","commercialName":"SERYA ALIMENTOS","cnpj":"09613040000183","city":"ARAXÁ","stateCode":"MG","buscaAdicional":"SERYA ALIMENTOS 55458 SERYA ALIMENTOS 906550"},{"id":"95412f24-92cf-43e8-64fd-08d5ad2bf6ba","name":"REI AUTO PARTS INDUSTRIA E COMERCIO S/A","commercialName":"REI AUTO PARTS","cnpj":"71403133000157","city":"ARCEBURGO","stateCode":"MG","buscaAdicional":"REI AUTO PARTS 56364 REI AUTO PARTS 908142"},{"id":"a0826944-bdb0-43ca-5a71-08d5ad2bf6ba","name":"SM GERAÇÃO DE ENERGIA LTDA","commercialName":"","cnpj":"07398638000171","city":"ARCEBURGO","stateCode":"MG","buscaAdicional":"SM GERACAO 49644 CGH DR TITO II 901873 CGH.PH.MG.029661-9.01 SERRANIA 8674 CGH.PH.MG.029881-6.01"},{"id":"3fa8e0c7-34bf-4f68-5b4f-08d5ad2bf6ba","name":"FOS-QUIMICA E DERIVADOS LTDA","commercialName":"","cnpj":"04437440000161","city":"ARCOS","stateCode":"MG","buscaAdicional":"FOS-QUIMICA 50596 FOS-QUIMICA 898546"},{"id":"d197961a-9913-4f87-5af1-08d5ad2bf6ba","name":"AGRIMIG CALCARIO AGRICOLA LIMITADA","commercialName":"","cnpj":"21580469000117","city":"ARCOS","stateCode":"MG","buscaAdicional":"AGRIMIG 50365 AGRIMIG 899075"},{"id":"670a7f95-3219-4e48-5ec9-08d5ad2bf6ba","name":"MINERACAO JOAO VAZ SOBRINHO LTDA","commercialName":"","cnpj":"20651683000154","city":"ARCOS","stateCode":"MG","buscaAdicional":"MINERACAO JOAO VAZ 52551 MINERACAO JOAO VAZ 903434"},{"id":"a7fdebca-271b-44a2-6025-08d5ad2bf6ba","name":"ACTBOR FABRICACAO DE ARTEFATOS DE BORRACHA EIRELI","commercialName":"","cnpj":"10724739000108","city":"ARCOS","stateCode":"MG","buscaAdicional":"ACTBOR 53402 ACTBOR PNEUS 905885"},{"id":"77fb45b3-a0c4-4122-568e-08d5ad2bf6ba","name":"LAGOS INDUSTRIA QUIMICA LTDA","commercialName":"","cnpj":"05460666000146","city":"ARCOS","stateCode":"MG","buscaAdicional":"LAGOS 7233 LAGOS ARCOS 72209"},{"id":"c9ddb79b-9a5d-45a5-6221-08d5ad2bf6ba","name":"MINASOL INDUSTRIA E COMERCIO DE PRODUTOS MINERAIS LTDA","commercialName":"","cnpj":"04357004000182","city":"ARCOS","stateCode":"MG","buscaAdicional":"MINASOL 54590 MINASOL 906828"},{"id":"b291355c-041d-4b8f-5621-08d5ad2bf6ba","name":"BAMBUI BIOENERGIA S.A.","commercialName":"","cnpj":"07930999000117","city":"BAMBUÍ","stateCode":"MG","buscaAdicional":"BBIO 6658 TOTAL 8717 UTE.AI.MG.029724-0.01 BAMBUI 893182 UTE.AI.MG.031413-7.01"},{"id":"ac01d31c-9534-4bec-5908-08d5ad2bf6ba","name":"NOGUEIRA RIVELLI IRMAOS LTDA","commercialName":"","cnpj":"21005582000179","city":"BARBACENA","stateCode":"MG","buscaAdicional":"RIVELLI 13612 RIVELLI RESSAQUINHA 897647 NOGUEIRA RIVELLI MG 897570"},{"id":"74012ad6-ab49-4c7a-5872-08d5ad2bf6ba","name":"SAINT-GOBAIN DO BRASIL PRODUTOS INDUSTRIAIS E PARA CONSTRUCAO LTDA","commercialName":"","cnpj":"61064838008541","city":"BARBACENA","stateCode":"MG","buscaAdicional":"SGBRAS-BARBACENA 11809 S GOBAIN BARBACENA 7695"},{"id":"21a9341c-09b9-41de-7356-08d5cf600bef","name":"FIACAO E TECELAGEM SAO JOSE S/A - EM RECUPERACAO JUDICIAL","commercialName":"","cnpj":"17159005000164","city":"BARBACENA","stateCode":"MG","buscaAdicional":""},{"id":"91ed1005-ac64-4021-7358-08d5cf600bef","name":"MENDES JUNIOR ENGENHARIA S.A","commercialName":"","cnpj":"17162082000173","city":"BELO HORIZONTE","stateCode":"MG","buscaAdicional":""},{"id":"ba7b206a-dc11-4154-735b-08d5cf600bef","name":"BANCO MERCANTIL DO BRASIL SA","commercialName":"","cnpj":"17184037000110","city":"BELO HORIZONTE","stateCode":"MG","buscaAdicional":""},{"id":"080f9db2-173a-4819-735d-08d5cf600bef","name":"COMPANHIA DE SANEAMENTO DE MINAS GERAIS COPASA MG","commercialName":"COPASA MG","cnpj":"17281106000103","city":"BELO HORIZONTE","stateCode":"MG","buscaAdicional":""},{"id":"f086f98d-057b-47ad-7360-08d5cf600bef","name":"MGI MINAS GERAIS PARTICIPACOES SA","commercialName":"","cnpj":"19296342000129","city":"BELO HORIZONTE","stateCode":"MG","buscaAdicional":""},{"id":"57fbc0d5-1b91-4bd3-7366-08d5cf600bef","name":"WEMBLEY SOCIEDADE ANONIMA","commercialName":"","cnpj":"25329319000196","city":"BELO HORIZONTE","stateCode":"MG","buscaAdicional":""},{"id":"716af615-fa0b-45a9-7374-08d5cf600bef","name":"MERCANTIL DO BRASIL FINANCEIRA SA CREDITO FIN E INVEST","commercialName":"","cnpj":"33040601000187","city":"BELO HORIZONTE","stateCode":"MG","buscaAdicional":""},{"id":"696ae90f-0f4f-4cb4-7353-08d5cf600bef","name":"AREZZO INDUSTRIA E COMERCIO S.A.","commercialName":"AREZZO","cnpj":"16590234000176","city":"BELO HORIZONTE","stateCode":"MG","buscaAdicional":""},{"id":"a1aa0473-d872-4e9a-7354-08d5cf600bef","name":"DIRECIONAL ENGENHARIA S/A","commercialName":"","cnpj":"16614075000100","city":"BELO HORIZONTE","stateCode":"MG","buscaAdicional":""},{"id":"db42dc13-c607-4a49-7355-08d5cf600bef","name":"LOCALIZA RENT A CAR SA","commercialName":"LOCALIZA RENT A CAR","cnpj":"16670085000155","city":"BELO HORIZONTE","stateCode":"MG","buscaAdicional":""},{"id":"0be805aa-7433-447f-734e-08d5cf600bef","name":"MBK SECURITIZADORA S/A","commercialName":"","cnpj":"15688041000190","city":"BELO HORIZONTE","stateCode":"MG","buscaAdicional":""},{"id":"a426b374-12a3-4299-737e-08d5cf600bef","name":"HOTEIS E TURISMO DA GUANABARA SA","commercialName":"HOTEL NACIONAL RIO","cnpj":"33858168000191","city":"BELO HORIZONTE","stateCode":"MG","buscaAdicional":""},{"id":"bdd2d2c9-c629-496b-7380-08d5cf600bef","name":"BANCO MERCANTIL DE INVESTIMENTOS SA","commercialName":"","cnpj":"34169557000172","city":"BELO HORIZONTE","stateCode":"MG","buscaAdicional":""},{"id":"dca582db-d027-4243-7319-08d5cf600bef","name":"SAAG INVESTIMENTOS S/A","commercialName":"","cnpj":"11616840000108","city":"BELO HORIZONTE","stateCode":"MG","buscaAdicional":""},{"id":"5f3e236c-a01e-4dfb-72ec-08d5cf600bef","name":"OMEGA GERACAO S.A.","commercialName":"","cnpj":"09149503000106","city":"BELO HORIZONTE","stateCode":"MG","buscaAdicional":""},{"id":"9cc1cc35-df7f-4280-72e7-08d5cf600bef","name":"LOG COMMERCIAL PROPERTIES E PARTICIPACOES S.A","commercialName":"LOG COMMERCIAL PROPERTIES","cnpj":"09041168000110","city":"BELO HORIZONTE","stateCode":"MG","buscaAdicional":""},{"id":"c70c5158-d19e-49ff-7285-08d5cf600bef","name":"ANDRADE GUTIERREZ CONCESSOES S/A","commercialName":"","cnpj":"03601314000138","city":"BELO HORIZONTE","stateCode":"MG","buscaAdicional":""},{"id":"2ecda91d-0243-4bd5-728d-08d5cf600bef","name":"ANDRADE GUTIERREZ PARTICIPACOES S/A","commercialName":"","cnpj":"04031960000170","city":"BELO HORIZONTE","stateCode":"MG","buscaAdicional":""},{"id":"045ea4de-ea22-4071-7271-08d5cf600bef","name":"KROTON EDUCACIONAL S/A","commercialName":"","cnpj":"02800026000140","city":"BELO HORIZONTE","stateCode":"MG","buscaAdicional":""},{"id":"60412d3b-1cb1-4390-88a5-08d5ae44ed50","name":"CEDRO ENERGIA S. A.","commercialName":"","cnpj":"13663285000192","city":"BELO HORIZONTE","stateCode":"MG","buscaAdicional":"CGH CEDRO 15695 CGH CEDRO 895481 CGH.PH.MG.031906-6.01"},{"id":"f1960e2a-4e47-43bd-88de-08d5ae44ed50","name":"VB EMPREENDIMENTOS E PARTICIPACOES LTDA","commercialName":"","cnpj":"21215224000190","city":"BELO HORIZONTE","stateCode":"MG","buscaAdicional":"VB 53656"},{"id":"e6be6fa0-172c-4470-4f0b-08d5d159243d","name":"CENTRO DE IMAGEM DIAGNOSTICOS S/A.","commercialName":"AXIAL - CENTRO DE IMAGEM","cnpj":"42771949000135","city":"BELO HORIZONTE","stateCode":"MG","buscaAdicional":""},{"id":"dc27a023-4eec-45d5-680f-08d5d153df4d","name":"BANCO INTER S.A.","commercialName":"","cnpj":"00416968000101","city":"BELO HORIZONTE","stateCode":"MG","buscaAdicional":""},{"id":"52cb0d7b-8bec-45a8-61a9-08d5ad2bf6ba","name":"DIVINAL MINEIRA VIDROS E ESPELHOS LTDA","commercialName":"","cnpj":"10013849000153","city":"BELO HORIZONTE","stateCode":"MG","buscaAdicional":"DIVINAL MINEIRA 54333 DIVINAL MINEIRA 905372"},{"id":"4d403039-64a7-43aa-6300-08d5ad2bf6ba","name":"FERROVIA CENTRO-ATLANTICA S.A","commercialName":"EST UNIF","cnpj":"00924429000175","city":"BELO HORIZONTE","stateCode":"MG","buscaAdicional":"FCA OFICINAS 55074 FCA TI GUARA 907974 FCA PAULINIA 907975 FCA TI UBERABA 909239 FCA TI ARAGUARI 909250 FCA TI STA LUZIA 909600 FCA BH SEDE 909611 FCA TI PIRAPORA 909754 OFICINA LAVRAS 909896"},{"id":"0c9d8af0-9ed6-4371-64f3-08d5ad2bf6ba","name":"DECORALITA INDUSTRIA E COMERCIO S.A.","commercialName":"","cnpj":"17222720000102","city":"BELO HORIZONTE","stateCode":"MG","buscaAdicional":"DECORALITA 56323 DECORALITA IND E COM 906506"},{"id":"c2a1d8b9-8c8b-47f4-654b-08d5ad2bf6ba","name":"BRASIL EDUCACAO S/A","commercialName":"","cnpj":"05648257000178","city":"BELO HORIZONTE","stateCode":"MG","buscaAdicional":"ANIMA UNA 56642 MG EDUCACAO 907204"},{"id":"6b306d67-eabd-49b7-6550-08d5ad2bf6ba","name":"EMPREENDIMENTOS MEDICOS LTDA","commercialName":"","cnpj":"04638610000923","city":"BELO HORIZONTE","stateCode":"MG","buscaAdicional":"UNIMED CMU 56651 EMPREEND MEDICOS LTD 908116"},{"id":"2ba8563a-7651-44e4-6548-08d5ad2bf6ba","name":"UNIMED BELO HORIZONTE COOPERATIVA DE TRABALHO MEDICO","commercialName":"ESTABELECIMENTO UNIFICADO","cnpj":"16513178000176","city":"BELO HORIZONTE","stateCode":"MG","buscaAdicional":"UNIMED BH 56639 UNIMED CPSSF 907773 UNIMED HUBH 907774 UNIMED MATER 908073 UNIMED CPSCT 908352 UNIMED BH 908558 UNIMED CPSDP 908707 UNIMED RD 908124"},{"id":"7d367653-7689-4319-6564-08d5ad2bf6ba","name":"TORRES EOLICAS DO NORDESTE S/A","commercialName":"","cnpj":"13892216000150","city":"BELO HORIZONTE","stateCode":"MG","buscaAdicional":"TORRES EOLICAS 56709 TORRES EOLICAS JACOB 907142"},{"id":"07504f4d-ecab-4e9c-6353-08d5ad2bf6ba","name":"CONDOMINIO VILLAGGIO ANCHIETA","commercialName":"","cnpj":"07669962000187","city":"BELO HORIZONTE","stateCode":"MG","buscaAdicional":"VILLAGGIO ANCHIETA 55312 VILLAGIO ANCHIETA 907201"},{"id":"ecf661ab-9a94-48c9-639d-08d5ad2bf6ba","name":"CONDOMINIO DO SHOPPING TUPINAMBAS","commercialName":"","cnpj":"11119676000115","city":"BELO HORIZONTE","stateCode":"MG","buscaAdicional":"TUPINAMBAS 55483 SHOPPING TUPINAMBAS 906577"},{"id":"3a808f77-20da-4ac8-63fb-08d5ad2bf6ba","name":"COLORTEXTIL PARTICIPACOES LTDA","commercialName":"","cnpj":"42789628000168","city":"BELO HORIZONTE","stateCode":"MG","buscaAdicional":"COLOR TEXTIL 55762 COLOR TEXTIL 905345"},{"id":"612ae3a5-181e-4121-643a-08d5ad2bf6ba","name":"ORGANIZACAO VERDEMAR LTDA","commercialName":"","cnpj":"65124307001464","city":"BELO HORIZONTE","stateCode":"MG","buscaAdicional":"ORG VERDEMAR 55885 VERDEMAR LOJA 02 891902 VERDEMAR LOJA 01 891903 VERDEMAR LOJA 03 891904 VERDEMAR LOJA 05 891905 VERDEMAR LOJA 07 891906 VERDEMAR CD STAR 891907 VERDEMAR LOJA 04 891908 VERDEMAR LOJA 09 904674 VERDEMAR LOJA 08 905681 VERDEMAR - LOJA 11 908731 VERDEMAR LOJA 10 909243 VERDEMAR - LOJA 12 911594 VERDEMAR - LOJA 13 911722"},{"id":"8e957af1-a5c2-461f-6952-08d5ad2bf6ba","name":"CONDOMINIO EMPREENDIMENTO COMERCIAL CENTER MINAS-BLOCO 1 POWER","commercialName":"COMERCIAL CENTER MINAS- BLOCO 1 POWER","cnpj":"17008888000101","city":"BELO HORIZONTE","stateCode":"MG","buscaAdicional":"CENTERMINAS 61054 CENTERMINAS 911718"},{"id":"43cb15e3-1831-414f-6955-08d5ad2bf6ba","name":"FUNDACAO FELICE ROSSO","commercialName":"HOSPITAL FELICIO ROCHO","cnpj":"17214149000176","city":"BELO HORIZONTE","stateCode":"MG","buscaAdicional":"FELICIO ROCHO 61057 FELICIO ROCHO 911717"},{"id":"980a23e6-0986-44bc-68dd-08d5ad2bf6ba","name":"NEWCAST INDUSTRIA, COMERCIO E PARTICIPACOES LTDA","commercialName":"","cnpj":"17465932000102","city":"BELO HORIZONTE","stateCode":"MG","buscaAdicional":"NEWCAST 60515 NEWCAST 910285"},{"id":"422d5ba1-7847-46b6-68f0-08d5ad2bf6ba","name":"INSTITUTO HERMES PARDINI S/A","commercialName":"","cnpj":"19378769000176","city":"BELO HORIZONTE","stateCode":"MG","buscaAdicional":"HERMES PARDINI 60595 3009015777 - IHP AIM 911283 3011082580 - IHP BER 911302"},{"id":"9079c3ec-ebda-46e7-882c-08d5ae44ed50","name":"VALLOUREC TUBOS DO BRASIL LTDA.","commercialName":"VALLOUREC DO BRASIL","cnpj":"17170150000146","city":"BELO HORIZONTE","stateCode":"MG","buscaAdicional":"VM 1081"},{"id":"ea9a16dd-cc83-47bd-680b-08d5ad2bf6ba","name":"ARCELORMITTAL BRASIL S.A.","commercialName":"","cnpj":"17469701018890","city":"BELO HORIZONTE","stateCode":"MG","buscaAdicional":"AMB ARCELORMITTAL 59230"},{"id":"e55ad85b-887f-451a-68be-08d5ad2bf6ba","name":"PACIFICO MASCARENHAS ENERGETICA LTDA.","commercialName":"CGH PACIFICO MASCARENHAS LTDA","cnpj":"28030106000157","city":"BELO HORIZONTE","stateCode":"MG","buscaAdicional":"PACIFICO MASCARENHAS 60383 PACIFICO MASCARENHAS 909888 CGH.PH.MG.001928-3.02"},{"id":"2737f888-377f-44be-6742-08d5ad2bf6ba","name":"PROSEGUR BRASIL S/A - TRANSPORTADORA DE VAL E SEGURANCA","commercialName":"","cnpj":"17428731000135","city":"BELO HORIZONTE","stateCode":"MG","buscaAdicional":"PROSEGUR 58018 PROSEGUR R JANEIRO 908266"},{"id":"a71eeedd-a621-4f07-6675-08d5ad2bf6ba","name":"MINAS ARENA - GESTAO DE INSTALACOES ESPORTIVAS S.A.","commercialName":"MINAS ARENA","cnpj":"13012956000155","city":"BELO HORIZONTE","stateCode":"MG","buscaAdicional":"MINAS ARENA 57579 MINAS ARENA 908833"},{"id":"033b4c17-05ab-4ffe-65a9-08d5ad2bf6ba","name":"CONDOMINIO MINASCASA O SHOPPING DO LAR","commercialName":"","cnpj":"00173119000166","city":"BELO HORIZONTE","stateCode":"MG","buscaAdicional":"MINASCASA 56908 COND MINAS CASA SHOP 908123"},{"id":"5f21f48d-ecd5-47a5-65aa-08d5ad2bf6ba","name":"PLASTIFICA INDUSTRIAL LTDA","commercialName":"","cnpj":"25791955000135","city":"BELO HORIZONTE","stateCode":"MG","buscaAdicional":"PLASTIFICA 56909 PLASTIFICA INDUSTRIA 908350"},{"id":"e7d67c0b-b9dc-46a8-58be-08d5ad2bf6ba","name":"GV ENERGIA LTDA","commercialName":"","cnpj":"18185035000108","city":"BELO HORIZONTE","stateCode":"MG","buscaAdicional":"GV ENERGIA 13112"},{"id":"4af926fc-bece-48e7-58ad-08d5ad2bf6ba","name":"SIMONESIA ENERGIA S.A.","commercialName":"","cnpj":"10982434000198","city":"BELO HORIZONTE","stateCode":"MG","buscaAdicional":"CGH SIMONESIA 12813 SIMONESIA 892604 CGH.PH.MG.031334-3.01"},{"id":"c9dd03e3-20d4-4b5f-58b5-08d5ad2bf6ba","name":"ANGLO AMERICAN MINERIO DE FERRO BRASIL S/A","commercialName":"","cnpj":"02359572000430","city":"BELO HORIZONTE","stateCode":"MG","buscaAdicional":"ANGLO MINAS RIO 12952 ANGLO MINAS RIO - RB 891262 SE BOMBEAMENTO II 892254 PORTO FILTRAGEM 893563"},{"id":"f180235e-5f70-4795-588a-08d5ad2bf6ba","name":"GRAO MOGOL ENERGIA LTDA","commercialName":"","cnpj":"11267987000121","city":"BELO HORIZONTE","stateCode":"MG","buscaAdicional":"GRAO MOGOL ENERGIA 12313 FLORESTA 893523 CGH.PH.MG.031641-5.01 POSSES 893882 CGH.PH.MG.031281-9.01"},{"id":"057b6209-4ff4-495b-5899-08d5ad2bf6ba","name":"SANTA HELENA ENERGIA S/A","commercialName":"","cnpj":"14016288000105","city":"BELO HORIZONTE","stateCode":"MG","buscaAdicional":"PCH SANTA HELENA 12672 PCH SANTA HELENA 893684 PCH.PH.MG.030961-3.01"},{"id":"0d0c4782-8003-4d93-5979-08d5ad2bf6ba","name":"TESTA BRANCA I ENERGIA S.A.","commercialName":"","cnpj":"18501753000146","city":"BELO HORIZONTE","stateCode":"MG","buscaAdicional":"TESTA I 14560 EOL TESTA BRANCA I 904143 EOL.CV.PI.031666-0.01"},{"id":"7297ff2d-a08d-4399-597b-08d5ad2bf6ba","name":"SIGMA ENERGIA S.A.","commercialName":"","cnpj":"03803650000163","city":"BELO HORIZONTE","stateCode":"MG","buscaAdicional":"SIGMA 14562 PCH SERRA DAS AGULHA 908271 PCH.PH.MG.031207-0.01"},{"id":"e1304251-1414-427b-595d-08d5ad2bf6ba","name":"MINAS GERACAO E ENGENHARIA LTDA","commercialName":"MINAS GERACAO","cnpj":"16933627000135","city":"BELO HORIZONTE","stateCode":"MG","buscaAdicional":"MINAS GERACAO 14316"},{"id":"fdb97553-a21e-4a7f-5985-08d5ad2bf6ba","name":"ALIANCA GERACAO DE ENERGIA S.A.","commercialName":"","cnpj":"12009135000105","city":"BELO HORIZONTE","stateCode":"MG","buscaAdicional":"ALIANCA GERACAO 14755 IGARAPAVA (ALIANCA) 894724 UHE.PH.SP.001098-7.01 CAPIM BRANCO1-ALIANC 8132 UHE.PH.MG.027483-6.01 CAPIM BRANCO2-ALIAN 8219 UHE.PH.MG.027484-4.01 RISOLETA- ALIANCA 8270 UHE.PH.MG.000641-6.01 AIMORES 8429 UHE.PH.MG.000042-6.01 PORTO ESTRELA-ALIANC 8430 UHE.PH.MG.027196-9.01 FUNIL (ALIANCA) 8443 UHE.PH.MG.001006-5.01"},{"id":"dd76bc1b-d868-4147-5a40-08d5ad2bf6ba","name":"MACAUBAS ENERGIA RENOVAVEL SPE LTDA","commercialName":"","cnpj":"11293816000177","city":"BELO HORIZONTE","stateCode":"MG","buscaAdicional":"PCH CAQUENDE 17237 PCH CAQUENDE 907900 PCH.PH.MG.030556-1.01"},{"id":"63080ae4-298b-4134-5a02-08d5ad2bf6ba","name":"ATMO COMERCIALIZADORA DE ENERGIA LTDA","commercialName":"","cnpj":"11322550000143","city":"BELO HORIZONTE","stateCode":"MG","buscaAdicional":"ATMO 16338"},{"id":"d7b4bac1-af7e-4a8d-5b16-08d5ad2bf6ba","name":"MATE COURO S A","commercialName":"","cnpj":"17177296000113","city":"BELO HORIZONTE","stateCode":"MG","buscaAdicional":"MATECOURO 50458 MATE COURO 897677"},{"id":"b924d79d-719b-470e-5b10-08d5ad2bf6ba","name":"BELOACO INDUSTRIA E COMERCIO LTDA","commercialName":"","cnpj":"17532854000111","city":"BELO HORIZONTE","stateCode":"MG","buscaAdicional":"BELOACO 50434 BELOACO 898367"},{"id":"d6317fa7-592e-4f18-5b12-08d5ad2bf6ba","name":"RONA EDITORA LTDA","commercialName":"","cnpj":"19270206000160","city":"BELO HORIZONTE","stateCode":"MG","buscaAdicional":"RONAEDITORA 50451 RONA EDITORA 898029"},{"id":"b72d27e6-e349-4951-5b61-08d5ad2bf6ba","name":"HOSPITAL MATER DEI SA","commercialName":"","cnpj":"16676520000159","city":"BELO HORIZONTE","stateCode":"MG","buscaAdicional":"MATER DEI 50652 MATER DEI 897706 MATER DEI MG 897709"},{"id":"05ca75dd-3a2b-452c-5a8f-08d5ad2bf6ba","name":"DOXO COMERCIALIZADORA DE ENERGIA LTDA","commercialName":"","cnpj":"20420214000124","city":"BELO HORIZONTE","stateCode":"MG","buscaAdicional":"DOXO 50064 CEL AMERICO TEIXEIRA 898530 PCH.PH.MG.000836-2.02"},{"id":"3fdaf83e-ab6d-4af2-5a2d-08d5ad2bf6ba","name":"MF PROJETOS EM ENERGIA LTDA","commercialName":"","cnpj":"08027306000143","city":"BELO HORIZONTE","stateCode":"MG","buscaAdicional":"PCH JULIOES 17204 PCH JULIOES 897926 PCH.PH.MG.030542-1.01"},{"id":"9ec1a2c4-57f0-4a33-5bc7-08d5ad2bf6ba","name":"DELTA 3 II ENERGIA S.A.","commercialName":"","cnpj":"23598858000103","city":"BELO HORIZONTE","stateCode":"MG","buscaAdicional":"DELTA 3 II 50894 EOL DELTA 3 02 908981 EOL.CV.MA.033683-1.01"},{"id":"19fb57bf-9051-4a6f-5bc8-08d5ad2bf6ba","name":"DELTA 3 III ENERGIA S.A.","commercialName":"","cnpj":"23598847000115","city":"BELO HORIZONTE","stateCode":"MG","buscaAdicional":"DELTA 3 III 50895 EOL DELTA 3 03 908978 EOL.CV.MA.033684-0.01"},{"id":"40c29aa7-240e-4962-5bcb-08d5ad2bf6ba","name":"TESTA BRANCA III ENERGIA S.A.","commercialName":"","cnpj":"18495534000100","city":"BELO HORIZONTE","stateCode":"MG","buscaAdicional":"TESTA III 50913 EOL TESTA BRANCA III 901937 EOL.CV.PI.033479-0.01"},{"id":"7bd26281-3a8b-4487-5bcc-08d5ad2bf6ba","name":"DELTA 3 I ENERGIA S.A.","commercialName":"","cnpj":"23598517000120","city":"BELO HORIZONTE","stateCode":"MG","buscaAdicional":"DELTA 3 I 50914 EOL DELTA 3 01 908976 EOL.CV.MA.033682-3.01"},{"id":"32ac85c3-6cf5-4249-5bcd-08d5ad2bf6ba","name":"DELTA 3 IV ENERGIA S.A.","commercialName":"","cnpj":"23598842000192","city":"BELO HORIZONTE","stateCode":"MG","buscaAdicional":"DELTA 3 IV 50917 EOL DELTA 3 IV 908979 EOL.CV.MA.033685-8.01"},{"id":"14985e9d-0d2e-4e6e-5bce-08d5ad2bf6ba","name":"DELTA 3 V ENERGIA S.A.","commercialName":"","cnpj":"23598829000133","city":"BELO HORIZONTE","stateCode":"MG","buscaAdicional":"DELTA 3 V 50918 EOL DELTA 3 05 909012 EOL.CV.MA.033675-0.01"},{"id":"93d2b37f-1ee6-45bf-5bcf-08d5ad2bf6ba","name":"DELTA 3 VI ENERGIA S.A.","commercialName":"","cnpj":"23598831000102","city":"BELO HORIZONTE","stateCode":"MG","buscaAdicional":"DELTA 3 VI 50924 EOL DELTA 3 06 909011 EOL.CV.MA.033673-4.01"},{"id":"cfdca658-efb4-495a-5bd0-08d5ad2bf6ba","name":"DELTA 3 VII ENERGIA S.A.","commercialName":"","cnpj":"23598844000181","city":"BELO HORIZONTE","stateCode":"MG","buscaAdicional":"DELTA 3 VII 50929 EOL DELTA 3 07 908946 EOL.CV.MA.033680-7.01"},{"id":"5e56a9c1-fdf9-4e49-5bea-08d5ad2bf6ba","name":"FCE COMERCIALIZADORA DE ENERGIA LTDA.","commercialName":"","cnpj":"23473053000125","city":"BELO HORIZONTE","stateCode":"MG","buscaAdicional":"FCE ENERGIA 50981"},{"id":"ba3b4176-d05a-46eb-5bd2-08d5ad2bf6ba","name":"LIFECENTER SISTEMA DE SAUDE S/A","commercialName":"LIFECENTER","cnpj":"04123021000155","city":"BELO HORIZONTE","stateCode":"MG","buscaAdicional":"HOSPITAL LIFECENTER 50938 LIFECENTER 898093"},{"id":"e4a551dc-6a92-4c44-5fff-08d5ad2bf6ba","name":"MRV ENGENHARIA E PARTICIPACOES SA","commercialName":"","cnpj":"08343492000120","city":"BELO HORIZONTE","stateCode":"MG","buscaAdicional":"MRV 53332 MRV ENGENHARIA PART 903255"},{"id":"ff58d961-c1dc-4801-60fe-08d5ad2bf6ba","name":"CONDOMINIO BH OUTLET PLUS","commercialName":"BH OUTLET PLUS","cnpj":"21465149000116","city":"BELO HORIZONTE","stateCode":"MG","buscaAdicional":"BH OUTLET 53946 BH OUTLET PLUS 904119"},{"id":"08d7d409-c071-42eb-60ca-08d5ad2bf6ba","name":"POWER TRADE CONSULTORIA E COMERCIALIZACAO DE ENERGIA LTDA","commercialName":"POWER TRADE","cnpj":"22153641000119","city":"BELO HORIZONTE","stateCode":"MG","buscaAdicional":"POWER TRADE 53724"},{"id":"ba342b75-dcca-4695-5fd9-08d5ad2bf6ba","name":"VIDRACARIA PESTANA LTDA","commercialName":"VIDRACARIA PESTANA","cnpj":"17407214000180","city":"BELO HORIZONTE","stateCode":"MG","buscaAdicional":"VIDRACARIA PESTANA LTDA 53242 VIDRACARIA PESTANA 903384"},{"id":"4bd7b301-2051-4e3a-5fda-08d5ad2bf6ba","name":"DELTA FILMES LTDA","commercialName":"CINEART","cnpj":"01735159000117","city":"BELO HORIZONTE","stateCode":"MG","buscaAdicional":"DELTA FILMES CINEART 53243 DELTA FILMES - MINAS 904762 DELTA FILMES-MONTE C 904774 DELTA FILMES SERRA S 906740 DELTA FILMES-CINEART 906767 DELTA FILME CONTAGEM 907584"},{"id":"ef639ce4-6643-48b9-5ed8-08d5ad2bf6ba","name":"CEMIG GERACAO TRES MARIAS S.A.","commercialName":"","cnpj":"24263197000110","city":"BELO HORIZONTE","stateCode":"MG","buscaAdicional":"CEMIG GERA TRES MARIAS CONV 52579 TRES MARIAS 235 UHE.PH.MG.027113-6.01 TRES MARIAS ACL 895861 UHE.PH.MG.027113-6.01"},{"id":"2bc1380b-029a-4d27-5ed5-08d5ad2bf6ba","name":"CEMIG GERACAO SUL S.A.","commercialName":"","cnpj":"24263183000104","city":"BELO HORIZONTE","stateCode":"MG","buscaAdicional":"CEMIG GERA SUL 52575 JOASAL 476 UHE.PH.MG.001255-6.02 PACIENCIA 479 UHE.PH.MG.001927-5.02 PIAU 8072 UHE.PH.MG.002052-4.02 MARMELOS 8068 UHE.PH.MG.001420-6.02 JOASAL ACL 895782 UHE.PH.MG.001255-6.02 PACIENCIA ACL 895801 UHE.PH.MG.001927-5.02 CORONEL DOMICIANOACL 895902 UHE.PH.MG.000838-9.02 MARMELOS ACL 895742 UHE.PH.MG.001420-6.02 PIAU ACL 895821 UHE.PH.MG.002052-4.02 CORONEL DOMICIANO 8031 UHE.PH.MG.000838-9.02 JOASAL ACL 895782 UHE.PH.MG.001255-6.02 PACIENCIA ACL 895801 UHE.PH.MG.001927-5.02 CORONEL DOMICIANOACL 895902 UHE.PH.MG.000838-9.02 MARMELOS ACL 895742 UHE.PH.MG.001420-6.02 PIAU ACL 895821 UHE.PH.MG.002052-4.02"},{"id":"eded8b59-6fbb-4fb0-5ef7-08d5ad2bf6ba","name":"COMPANHIA FABRIL MASCARENHAS","commercialName":"","cnpj":"16718231000175","city":"BELO HORIZONTE","stateCode":"MG","buscaAdicional":"CFM 52671 FABRIL MASCARENHAS 902329"},{"id":"5f6f7768-12c4-42c0-5eae-08d5ad2bf6ba","name":"CEMIG GERACAO LESTE S.A.","commercialName":"","cnpj":"24286169000118","city":"BELO HORIZONTE","stateCode":"MG","buscaAdicional":"CEMIG GERA LESTE 52501 PETI 481 UHE.PH.MG.002047-8.01 TRONQUEIRAS 487 UHE.PH.MG.002886-0.02 DONA RITA 474 UHE.PH.MG.028084-4.02 SINCERIDADE 8230 UHE.PH.MG.002751-0.02 NEBLINA 8030 UHE.PH.MG.001533-4.02 SINCERIDADE ACL 889928 UHE.PH.MG.002751-0.02 SINCERIDADE ACL 889928 UHE.PH.MG.002751-0.02 DONA RITA ACL 892282 UHE.PH.MG.028084-4.02 PETI ACL 895744 UHE.PH.MG.002047-8.01 TRONQUEIRAS ACL 895842 UHE.PH.MG.002886-0.02 ERVALIA ACL 895961 UHE.PH.MG.027034-2.02 NEBLINA ACL 889927 UHE.PH.MG.001533-4.02 ERVALIA 8029 UHE.PH.MG.027034-2.02 DONA RITA ACL 892282 UHE.PH.MG.028084-4.02 PETI ACL 895744 UHE.PH.MG.002047-8.01 TRONQUEIRAS ACL 895842 UHE.PH.MG.002886-0.02 ERVALIA ACL 895961 UHE.PH.MG.027034-2.02 NEBLINA ACL 889927 UHE.PH.MG.001533-4.02"},{"id":"203024fc-5c9e-4d66-5eaf-08d5ad2bf6ba","name":"CEMIG GERACAO OESTE S.A.","commercialName":"","cnpj":"24286218000112","city":"BELO HORIZONTE","stateCode":"MG","buscaAdicional":"CEMIG GERA OESTE 52506 CAJURU (CEMIG) 473 UHE.PH.MG.000597-5.01 GAFANHOTO 475 UHE.PH.MG.001011-1.02 MARTINS 8071 UHE.PH.MG.001427-3.02 CAJURU (CEMIG) ACL 895762 UHE.PH.MG.000597-5.01 GAFANHOTO ACL 895741 UHE.PH.MG.001011-1.02 MARTINS ACL 895743 UHE.PH.MG.001427-3.02 CAJURU (CEMIG) ACL 895762 UHE.PH.MG.000597-5.01 GAFANHOTO ACL 895741 UHE.PH.MG.001011-1.02 MARTINS ACL 895743 UHE.PH.MG.001427-3.02"},{"id":"547fad86-9ef4-4fdb-5eba-08d5ad2bf6ba","name":"CEMIG GERACAO SALTO GRANDE S.A.","commercialName":"","cnpj":"24286083000195","city":"BELO HORIZONTE","stateCode":"MG","buscaAdicional":"CEMIG GERA SALTO GRANDE CONV 52529 SALTO GRANDE (CEMIG) 237 UHE.PH.MG.027210-8.01 SALTO GRANDE ACL 895745 UHE.PH.MG.027210-8.01"},{"id":"fb06a500-e8bd-4f53-5ebb-08d5ad2bf6ba","name":"CEMIG GERACAO CAMARGOS S.A.","commercialName":"","cnpj":"24286195000146","city":"BELO HORIZONTE","stateCode":"MG","buscaAdicional":"CEMIG GERA CAMARGOS CONV 52530 CAMARGOS 239 UHE.PH.MG.000608-4.01 CAMARGOS ACL 895761 UHE.PH.MG.000608-4.01 CAMARGOS ACL 895761 UHE.PH.MG.000608-4.01"},{"id":"afa6bc4b-fc8c-4197-5ebc-08d5ad2bf6ba","name":"CEMIG GERACAO ITUTINGA S.A.","commercialName":"","cnpj":"24285911000170","city":"BELO HORIZONTE","stateCode":"MG","buscaAdicional":"CEMIG GERA ITUTINGA CONV 52531 ITUTINGA 238 UHE.PH.MG.001197-5.01 ITUTINGA ACL 895781 UHE.PH.MG.001197-5.01"},{"id":"60a170e7-a8e0-40af-5e5b-08d5ad2bf6ba","name":"EDITORA E DISTRIBUIDORA EDUCACIONAL S/A","commercialName":"","cnpj":"38733648000140","city":"BELO HORIZONTE","stateCode":"MG","buscaAdicional":"EDITORA KROTON 52339 UNOPAR SALVADOR 908824 CORPORATIVO BH1 909948 PITAGORAS DIVINOPOL 910007 UNOPAR SH BOULEVARD 910295 UNOPAR ARAPOANGAS 908866 EDITORA KROTON PARIS 909131 EDITORA KROTON TIETE 909606 EDITORA KROTON - PIT 909714 UNOPAR P CAPRI 910265"},{"id":"353009d0-f872-495d-5d0f-08d5ad2bf6ba","name":"ANGLO AMERICAN NIQUEL BRASIL LTDA","commercialName":"","cnpj":"42184226001969","city":"BELO HORIZONTE","stateCode":"MG","buscaAdicional":"ANGLO NIQUEL MINAS 51691 ANGLO AMERICAN CODEM 7098 ANGLO AMERICAN BARRO 71155"},{"id":"f0c4f14d-cb1e-49cf-5ce3-08d5ad2bf6ba","name":"EMATEX INDUSTRIAL E COMERCIAL TEXTIL LTDA.","commercialName":"","cnpj":"07590753000143","city":"BELO HORIZONTE","stateCode":"MG","buscaAdicional":"EMATEX 51603 EMATEX - FABRICA 898796 JOAO DE DEUS 8757 PCH.PH.MG.001252-1.01"},{"id":"4b4d975a-ed3c-4a9d-5cb8-08d5ad2bf6ba","name":"ATIVAS DATA CENTER S.A.","commercialName":"","cnpj":"10587932000136","city":"BELO HORIZONTE","stateCode":"MG","buscaAdicional":"ATIVAS 51540 ATIVAS DATA CENTER 899064"},{"id":"76ad944e-21a5-4103-56b1-08d5ad2bf6ba","name":"USINAS SIDERURGICAS DE MINAS GERAIS S/A. USIMINAS","commercialName":"","cnpj":"60894730000105","city":"BELO HORIZONTE","stateCode":"MG","buscaAdicional":"USIMINAS BH AP 7521 USIMINAS-IPATINGA 7751 UTE USI2 20009 UTE.FL.MG.029480-2.01"},{"id":"7a6d3abc-7510-44c4-563e-08d5ad2bf6ba","name":"ESTACAO BH ADMINISTRACAO LTDA","commercialName":"","cnpj":"11668630000155","city":"BELO HORIZONTE","stateCode":"MG","buscaAdicional":"ESTACAO BH 6819 ESTACAO BH ADM 899324"},{"id":"c9f7cef4-32ff-40f2-56cd-08d5ad2bf6ba","name":"POLARIS ENERGIA LTDA","commercialName":"","cnpj":"09163747000135","city":"BELO HORIZONTE","stateCode":"MG","buscaAdicional":"POLARIS 7741 BOA VISTA DA CAPEADA 888393 CGH.PH.MG.030919-2.01"},{"id":"7e129aaf-3334-4090-57a0-08d5ad2bf6ba","name":"ST JUDE MEDICAL BRASIL LTDA","commercialName":"","cnpj":"00986846000908","city":"BELO HORIZONTE","stateCode":"MG","buscaAdicional":"ST JUDE 9250 ST JUDE MEDICAL 889119"},{"id":"48cff974-5cca-4da1-57a8-08d5ad2bf6ba","name":"ITAMBE ALIMENTOS S/A","commercialName":"","cnpj":"16849231000104","city":"BELO HORIZONTE","stateCode":"MG","buscaAdicional":"ITAMBEALIMEN 9292 ITAMBE PARA DE MINAS 7908 ITAMBE UBERLANDIA 7975 ITAMBE GUANHAES MG 70888 ITAMBE 7 LAGOAS MG 70889 ITAMBE GOIANIA I 898069 ITAMBE GOIANIA II 898070"},{"id":"cb518179-3646-472c-578e-08d5ad2bf6ba","name":"LIMOEIRO ENERGIA S. A.","commercialName":"","cnpj":"10938296000140","city":"BELO HORIZONTE","stateCode":"MG","buscaAdicional":"LIMOEIRO 9039 LIMOEIRO (AMERICA) 889449 CGH.PH.MG.030983-4.01"},{"id":"318fe765-1ea3-488b-578f-08d5ad2bf6ba","name":"CACHOEIRINHA ENERGIA S. A.","commercialName":"","cnpj":"11050208000131","city":"BELO HORIZONTE","stateCode":"MG","buscaAdicional":"CACHOEIRINHA 9040 CGH CACHOEIRINHA 889418 CGH.PH.MG.030242-2.01"},{"id":"eb4dfe3b-c17e-4c09-537b-08d5ad2bf6ba","name":"BAGUARI ENERGIA S.A.","commercialName":"","cnpj":"09568947000178","city":"BELO HORIZONTE","stateCode":"MG","buscaAdicional":"BAGUARI ENERG 3654 BAGUARI-CEMIG 8540 UHE.PH.MG.029453-5.01 BAGUARI-FURNAS 8541 UHE.PH.MG.029453-5.01"},{"id":"a31f94ea-13f2-417d-53be-08d5ad2bf6ba","name":"ASJA BRASIL SERVICOS PARA O MEIO AMBIENTE LTDA","commercialName":"","cnpj":"07695457000107","city":"BELO HORIZONTE","stateCode":"MG","buscaAdicional":"ASJA BRASIL 3815 HORIZONTE ASJA-ARIA 8762 UTE.RU.MG.030191-4.01"},{"id":"89ceb47c-e00a-43f2-53ec-08d5ad2bf6ba","name":"CONDOMINIO PONTEIO LAR SHOPPING","commercialName":"","cnpj":"00699724000175","city":"BELO HORIZONTE","stateCode":"MG","buscaAdicional":"PONTEIO LAR 3916 PONTEIO LAR SHOPPING 71390"},{"id":"38a25d2f-aab0-4845-544d-08d5ad2bf6ba","name":"MINERACAO USIMINAS S.A.","commercialName":"","cnpj":"12056613000120","city":"BELO HORIZONTE","stateCode":"MG","buscaAdicional":"MUSA 4155 MUSA - USIMINAS 889680"},{"id":"fb442e0d-5405-4191-545c-08d5ad2bf6ba","name":"CMU TRADING COMERCIALIZADORA DE ENERGIA LTDA","commercialName":"","cnpj":"13137827000193","city":"BELO HORIZONTE","stateCode":"MG","buscaAdicional":"CMU TR 4191"},{"id":"7c62ceba-9823-44d5-546b-08d5ad2bf6ba","name":"CONDOMINIO MINAS SHOPPING","commercialName":"","cnpj":"65162380000106","city":"BELO HORIZONTE","stateCode":"MG","buscaAdicional":"MINAS SHOPPING 4233 MINAS SHOPPING-LOJAS 71467 MINAS SHOP-BH 72023 MINAS SHOPPING 897506"},{"id":"5fe60e67-1a08-4116-5486-08d5ad2bf6ba","name":"MADSON ELETROMETALURGICA LTDA","commercialName":"","cnpj":"20520367000143","city":"BELO HORIZONTE","stateCode":"MG","buscaAdicional":"SUGGAR 4323 MADSON SUGGAR 71617"},{"id":"cff4c22d-4b86-49f2-54a2-08d5ad2bf6ba","name":"CONDOMINIO DO SHOPPING CIDADE","commercialName":"","cnpj":"38723904000118","city":"BELO HORIZONTE","stateCode":"MG","buscaAdicional":"SHOP CIDADE BH 4398 SHOPPING CIDADE-BH 71634"},{"id":"8b02a288-871e-4635-54aa-08d5ad2bf6ba","name":"DMA DISTRIBUIDORA S/A","commercialName":"","cnpj":"01928075000108","city":"BELO HORIZONTE","stateCode":"MG","buscaAdicional":"DMA EPA 4421 DMA EPA LJ 73 - LINH 71591 DMA EPA LJ 56 SERRA 71593 DMA EPA LJ 61 71594 DMA EPA LJ 93 - SERR 71595 DMA EPA LJ 98 - SERR 71648 DMA EPA LJ 12-BH 72043 DMA EPA LJ 83-BETIM 72045 DMA EPA LJ 82-BH 72046 DMA EPA LJ 02-BH 72047 DMA EPA LJ 26-BH 72050 DMA EPA LJ 86-NLIMA 72051 DMA EPA LJ 81-BH 72052 DMA EPA LJ 13-BH 72079 DMA EPA LJ 19-BH 72080 DMA EPA LJ 16-BH 72081 DMA EPA LJ 08-BH 72082 DMA EPA LJ 87-BH 72083 DMA EPA LJ14-BH 72085 DMA EPA LJ 21 BETIM 72134 DMA EPA-PRAIA ITAPOA 71592 DMA EPA CONSOLACAO 71733 DMA EPA J.CAMBURI 71734 DMA EPA-CARIACICA 71750 DMA EPA L58-VITORIA 71769 DMA EPA L63-V VELHA 71770 DMA EPA L76-V VELHA 71771 DMA EPA L90-V VELHA 71772 DMA EPA L55-VITORIA 71787 CENCOSUD LOJA 549 888647 DMA EPA LOJA 42 898537 DMA LOJA 37 898574 DMA LOJA 112 898585 DMA EPA - LOJA 27 900135 DMA LOJA 77 905198 DMA EPA LOJA 119 907496 DMA BH LOJA 78 907590 DMA EPA - LOJA 125 908709 DMA EPA LOJA 20 908714 DMA EPA LOJA 128 908732 DMA EPA LOJA 127 908733 DMA EPA LOJA 45 908734 DMA EPA LOJA 124 908841 DMA EPA LOJA 132 908842 DMA EPA LOJA 05 909247 DMA EPA LOJA 131 909248 DMA EPA 118 909364 DMA EPA 140 910336 DMA EPA 139 910337 DMA EPA 137 910339 DMA EPA LOJA 136 910572 DMA EPA LJ 17 910806 DMA EPA LJ 68 910807 DMA EPA LJ 24 910808 DMA EPA LJ 18 910809 DMA EPA LJ 46 910810 DMA EPA LJ 65 910812 DMA EPA LJ 50 910813 DMA EPA LJ 06 910814 DMA EPA LOJA 109 910822 DMA EPA LOJA 100 910823 DMA EPA LJ 03 910831 DMA EPA LJ 07 910832 DMA EPA LJ 51 910833 DMA EPA LJ 106 910834 DMA EPA LOJA 113 910858 DMA EPA LOJA 40 910859 DMA EPA LOJA 44 910870 DMA EPA LOJA 35 910884 DMA EPA LOJA 47 910885 DMA EPA LOJA 84 910886 DMA EPA LOJA 34 910891 DMA EPA LOJA 126 910892 DMA EPA LOJA 102 910893 DMA EPA 115 911131 DMA EPA LOJA 114 911132 DMA EPA LOJA 31 911133 DMA EPA LOJA 138 911260 DMA EPA LJ 70 911272 DMA_EPA_LOJA29 911273 DMA_EPA_LOJA23 911274 DMA_EPA_LOJA33 911275 DMA_EPA_LOJA105 911293 DMA_EPA_LOJA11 911294 DMA_EPA_LOJA79 911312 DMA_EPA_LOJA36 911313 DMA_EPA_LOJA85 911314 DMA_EPA_LOJA49 911331 DMA_EPA_LOJA38 911332 DMA_EPA_LOJA38 911333 DMA EPA LOJA 30 911337 DMA EPA LOJA 99 911394 DMA EPA LOJA 67 911395 DMA EPA LOJA 101 911411 DMA_EPA_LOJA122 911457 DMA_EPA_LOJA110 911458 DMA_EPA_LOJA80 911593 DMA_EPA_LOJA107 911595 DMA_EPA_LOJA123 911618 DMA_EPA_LOJA121 911699 DMA_EPA_LOJA 141 911701 DMA_EPA_LOJA108 911716 DMA_EPA_LOJA32 911723 DMA_EPA_LOJA144 911724 DMA_EPA_LOJA39 911725 DMA EPA LOJA88 911726 DMA EPA LOJA 116 912355 DMA EPA 20-2-CNTAGEM 72048 DMA_EPA_LOJA134 912753 DMA_EPA_LOJA41 913491 DMA_EPA_LOJA48 913492"},{"id":"f6787714-1876-4e40-5490-08d5ad2bf6ba","name":"INDAIAZINHO ENERGIA S.A.","commercialName":"INDAIAZINHO ENERGIA S.A.","cnpj":"11254582000159","city":"BELO HORIZONTE","stateCode":"MG","buscaAdicional":"IDZ 4343 INDAIAZINHO 8990 PCH.PH.MS.030079-9.01"},{"id":"6ddf6db4-844a-4426-5491-08d5ad2bf6ba","name":"INDAIA GRANDE ENERGIA S/A","commercialName":"INDAIA GRANDE ENERGIA S/A","cnpj":"10400065000188","city":"BELO HORIZONTE","stateCode":"MG","buscaAdicional":"IDG 4344 INDAIA GRANDE 8976 PCH.PH.MS.030078-0.01"},{"id":"0525e92f-2511-4da1-558b-08d5ad2bf6ba","name":"BOLSA BRASILEIRA DE ENERGIA INCENTIVADA LTDA","commercialName":"","cnpj":"12019580000148","city":"BELO HORIZONTE","stateCode":"MG","buscaAdicional":"BBEI 5778"},{"id":"50e88363-808b-4a7e-557d-08d5ad2bf6ba","name":"MINERACAO SERRAS DO OESTE EIRELI","commercialName":"","cnpj":"28917748000172","city":"BELO HORIZONTE","stateCode":"MG","buscaAdicional":"MSOL-SDO 5711 MSOL-SDO-CAETE 71869 TURMALINA-C. PARA 71870 MSOL PACIENCIA-ITBIR 71868 MSOL MINA DO PILAR 900962"},{"id":"5cd002d5-ba31-46a5-4f63-08d5ad2bf6ba","name":"USIMINAS MECANICA SA","commercialName":"","cnpj":"17500224000165","city":"BELO HORIZONTE","stateCode":"MG","buscaAdicional":"UMSA 1082 USIMINAS MECAN IPAT 7787"},{"id":"44184091-ac44-4733-4f4e-08d5ad2bf6ba","name":"ENECEL ENERGIA, COMERCIALIZACAO E CONSULTORIA ENERGETICA EIRELI","commercialName":"","cnpj":"25466251000197","city":"BELO HORIZONTE","stateCode":"MG","buscaAdicional":"ENECEL 1040 REPI 890762 PCH.PH.MG.002070-2.01"},{"id":"d1c4bfb1-267e-4132-4f52-08d5ad2bf6ba","name":"APERAM INOX AMERICA DO SUL S.A.","commercialName":"APERAM SOUTH AMERICA","cnpj":"33390170000189","city":"BELO HORIZONTE","stateCode":"MG","buscaAdicional":"APERAM 1052 ACESITA TIMOTEO 7767"},{"id":"0004a3a6-3d65-47e8-4f54-08d5ad2bf6ba","name":"ARCELORMITTAL BRASIL S.A.","commercialName":"","cnpj":"17469701000177","city":"BELO HORIZONTE","stateCode":"MG","buscaAdicional":"ARCELOR JF COM 1056 ARCELOR MITTAL-TU 79 ARCELOR MITTAL-CA 7213 BELGO MINEIRA PIRACI 7387 BELGO M SABARA 7709 ARCELOR ITAUNA 7715 BMP SIDERURGIA JF 7717 CSBM-J.MONLEVADE-MG 7791 VEGA SF SUL 70503 ARCELOR IRACEMAPOLIS 890073 ARCELOR AM SP 71886 ARCELORMITTAL BRASIL 901450 CST 346 UTE.PE.ES.027054-7.01 SOL 8237 UTE.OF.ES.029273-7.01 GUILMAN-AMORIM-BMP 240 UHE.PH.MG.001079-0.01"},{"id":"2e16db98-31ed-4dcf-4f34-08d5ad2bf6ba","name":"HORIZONTES ENERGIA S/A","commercialName":"","cnpj":"04451926000154","city":"BELO HORIZONTE","stateCode":"MG","buscaAdicional":"HORIZONTES 132 MACHADO MINEIRO 478 PCH.PH.MG.001361-7.01 SALTO PASSO VELHO 254 PCH.PH.SC.002173-3.01 SALTO VOLTAO 255 PCH.PH.SC.003047-3.01"},{"id":"9f1d7d9d-cc42-49ca-4eec-08d5ad2bf6ba","name":"COMPANHIA ENERGETICA DE MINAS GERAIS-CEMIG","commercialName":"EST UNIF","cnpj":"17155730000164","city":"BELO HORIZONTE","stateCode":"MG","buscaAdicional":"CEMIG 21"},{"id":"77d11584-3268-4d0e-4f0e-08d5ad2bf6ba","name":"ROSAL ENERGIA S/A","commercialName":"","cnpj":"03475839000174","city":"BELO HORIZONTE","stateCode":"MG","buscaAdicional":"ROSAL 67 ROSAL 373 UHE.PH.ES.002553-4.01"},{"id":"b9578bfa-5c1f-48a9-4f1a-08d5ad2bf6ba","name":"SA CARVALHO S/A","commercialName":"","cnpj":"03907799000192","city":"BELO HORIZONTE","stateCode":"MG","buscaAdicional":"SA CARVALHO 91 SA CARVALHO 538 UHE.PH.MG.002563-1.01"},{"id":"6b31f847-e96c-4406-4f82-08d5ad2bf6ba","name":"CEMIG GERACAO E TRANSMISSAO S.A","commercialName":"CEMIG GT","cnpj":"06981176000158","city":"BELO HORIZONTE","stateCode":"MG","buscaAdicional":"CEMIG GERACAO 1140 MINEIRAO 894983 UFV.RS.MG.031760-8.01 SANTA LUZIA (CEMIG) 214 CGH.PH.MG.027421-6.01 PICARRAO 216 CGH.PH.MG.002055-9.01 SANTA MARTA 485 CGH.PH.MG.026725-2.02 JACUTINGA 8066 CGH.PH.MG.001220-3.01 RIO DE PEDRAS 482 PCH.PH.MG.002345-0.01 MIRANDA (CEMIG) 911195 UHE.PH.MG.001469-9.01 JAGUARA (CEMIG) 911211 UHE.PH.SP.001225-4.01 PANDEIROS 480 PCH.PH.MG.001952-6.01 LAGES COROMANDEL 8067 CGH.PH.MG.002225-0.01 PARAUNA 8069 PCH.PH.MG.001977-1.01 IRAPE 8145 UHE.PH.MG.001146-0.01 QUEIMADO - CEMIG 8292 UHE.PH.MG.002176-8.01 SAO SIMAO (CEMIG) 230 UHE.PH.GO.002704-9.01 PCH LUIZ DIAS 909943 PCH.PH.MG.001344-7.01 POQUIM 8074 CGH.PH.MG.002109-1.02 TEODOMIRO C SAMPAIO 231 UHE.PH.MG.027115-2.01 NOVA PONTE 232 UHE.PH.MG.001574-1.01 IGARAPE 242 UTE.PE.MG.001100-2.01 IGARAPE EXP 80242 UTE.PE.MG.001100-2.01 SAO BERNARDO(CEMIG) 483 PCH.PH.MG.026798-8.01 SALTO DE MORAES 484 PCH.PH.MG.002656-5.01 SUMIDOURO 486 CGH.PH.MG.002782-0.02 XICAO 488 PCH.PH.MG.003059-7.01 ANIL 8065 CGH.PH.MG.000103-1.02 POCO FUNDO 8073 PCH.PH.MG.002092-3.01"},{"id":"55e2828b-3630-4de6-4f83-08d5ad2bf6ba","name":"CEMIG DISTRIBUICAO S.A","commercialName":"CEMIG D","cnpj":"06981180000116","city":"BELO HORIZONTE","stateCode":"MG","buscaAdicional":"CEMIG DISTRIB 1141 CEMIG 8"},{"id":"480a531b-da7e-4714-4f89-08d5ad2bf6ba","name":"SAMARCO MINERACAO S.A.","commercialName":"SAMARCO","cnpj":"16628281000161","city":"BELO HORIZONTE","stateCode":"MG","buscaAdicional":"SAMARCO 1149 SAMARCO UBU 7007 SAMARCO-MATIPO-MG 7515 SAMARCO SUB B BRANCO 890977 GUIL. AMOR.-SAMARCO 20008 UHE.PH.MG.001079-0.01 MUNIZ FREIRE 574 UHE.PH.ES.001518-0.01"},{"id":"899da434-a31a-4c9f-4f8b-08d5ad2bf6ba","name":"STOLA DO BRASIL LTDA","commercialName":"","cnpj":"02069153000110","city":"BELO HORIZONTE","stateCode":"MG","buscaAdicional":"STOLA 1151 STOLA BH 7741 STOLA-BETIM 72024"},{"id":"a5267bf0-2226-4c63-4f8d-08d5ad2bf6ba","name":"CEMIG TRADING S.A.","commercialName":"CEMIG TRADING S.A.","cnpj":"05263973000137","city":"BELO HORIZONTE","stateCode":"MG","buscaAdicional":"CEMIG TRADING 1155"},{"id":"72f8535b-986e-4aa9-4ff3-08d5ad2bf6ba","name":"ULTRAFERTIL SA","commercialName":"ULTRAFERTIL","cnpj":"02476026000136","city":"BELO HORIZONTE","stateCode":"MG","buscaAdicional":"ULTRAFERTIL 1370 ULTRAFERTIL 898169"},{"id":"a4d1a80f-420b-4244-4fd2-08d5ad2bf6ba","name":"COOPERATIVA CENTRAL DOS PRODUTORES RURAIS DE MINAS GERAIS LTDA","commercialName":"","cnpj":"17249111000139","city":"BELO HORIZONTE","stateCode":"MG","buscaAdicional":"COOP ITAMBE 1294 COOP ITAMBE CONTAGEM 70885"},{"id":"b3d2f18d-6229-4769-5035-08d5ad2bf6ba","name":"MINAS TENIS CLUBE","commercialName":"","cnpj":"17217951000110","city":"BELO HORIZONTE","stateCode":"MG","buscaAdicional":"MINAS TENIS 1513 MINAS TENIS CLUBE 2 7924 MINAS TENIS CLUBE 1 7926"},{"id":"490d0476-bc2c-4925-5075-08d5ad2bf6ba","name":"CONDOMINIO DO SHOPPING DEL REY","commercialName":"","cnpj":"65161515000119","city":"BELO HORIZONTE","stateCode":"MG","buscaAdicional":"SHOP DEL REY 1635 SHOP. DEL REY-BH-MG 70030"},{"id":"45c661a3-27c4-4fa1-505a-08d5ad2bf6ba","name":"CIA DE FIACAO E TECIDOS CEDRO E CACHOEIRA","commercialName":"","cnpj":"17245234000100","city":"BELO HORIZONTE","stateCode":"MG","buscaAdicional":"CEDROMATRIZ APE 1585 CEDRO CACH 7 LAGOAS 7892 CEDRO CACH CAETANOPO 7894 CEDRO E CACHOEIRA 7174"},{"id":"7897744d-60ce-4bd3-50eb-08d5ad2bf6ba","name":"CONSORCIO MTS - IBR","commercialName":"DIAMONDMALL","cnpj":"42929588000102","city":"BELO HORIZONTE","stateCode":"MG","buscaAdicional":"DIAMONDMALL 1906 DIAMONDMALL MTZ BH 70259"},{"id":"040ed583-6050-41b4-50a2-08d5ad2bf6ba","name":"CEMIG PCH S/A","commercialName":"","cnpj":"04739936000190","city":"BELO HORIZONTE","stateCode":"MG","buscaAdicional":"CEMIG PCH 1758 PAI JOAQUIM 8021 PCH.PH.MG.001934-8.01"},{"id":"a97dc8dc-ce75-4c6f-5238-08d5ad2bf6ba","name":"ELO COMERCIALIZADORA DE ENERGIA LTDA","commercialName":"","cnpj":"10315558000110","city":"BELO HORIZONTE","stateCode":"MG","buscaAdicional":"ELO 2944"},{"id":"2e34f091-865b-48f8-5217-08d5ad2bf6ba","name":"REOBOTE RECUPERACAO DE UTENSILIOS PLASTICOS LTDA","commercialName":"","cnpj":"05849540000168","city":"BELO HORIZONTE","stateCode":"MG","buscaAdicional":"ANTARES PLAST 2867 ANTARES REOBOTE 70780"},{"id":"06d553f8-a572-4946-5200-08d5ad2bf6ba","name":"LUZBOA S/A","commercialName":"","cnpj":"04779802000100","city":"BELO HORIZONTE","stateCode":"MG","buscaAdicional":"LUZBOA 2785 OLIVEIRA 8628 PCH.PH.MG.030148-5.01"},{"id":"39a8bbff-379a-40fd-51c3-08d5ad2bf6ba","name":"CONDOMINIO PATIO SAVASSI","commercialName":"","cnpj":"05520209000108","city":"BELO HORIZONTE","stateCode":"MG","buscaAdicional":"PATIO SAVASSI 2578 PATIO SAVASSI 70670"},{"id":"8311c55b-2194-4ff5-5161-08d5ad2bf6ba","name":"CONDOMINIO DO SHOPPING CENTER DE BELO HORIZONTE","commercialName":"","cnpj":"19715374000111","city":"BELO HORIZONTE","stateCode":"MG","buscaAdicional":"BH SHOPPING 2146 BH SHOPPING 70505"},{"id":"50ff1bb0-72d8-4318-515e-08d5ad2bf6ba","name":"RIO BRANCO ALIMENTOS S/A","commercialName":"PIF PAF","cnpj":"05017780000104","city":"BELO HORIZONTE","stateCode":"MG","buscaAdicional":"PIFPAFMATRIZ 2141 RIO BRANCO ALIMENTOS 70405 PIF PAF VICOSA 71474"},{"id":"67b06271-f3e2-4428-519e-08d5ad2bf6ba","name":"GRIFO COMERCIALIZADORA DE ENERGIA LTDA","commercialName":"","cnpj":"05334452000123","city":"BELO HORIZONTE","stateCode":"MG","buscaAdicional":"GRIFO 2436"},{"id":"25179e8f-e60e-4598-524d-08d5ad2bf6ba","name":"CONDOMINIO OPERACIONAL VIASHOPPING PAMPULHA","commercialName":"VIASHOPPING PAMPULHA","cnpj":"05285401000159","city":"BELO HORIZONTE","stateCode":"MG","buscaAdicional":"VIASHOP PAMP 2996 VIA SHOP PAMPULHA 70966"},{"id":"d64fb649-6752-4572-524e-08d5ad2bf6ba","name":"CONDOMINIO OPERACIONAL VIASHOPPING BARREIRO","commercialName":"VIASHOPPING BARREIRO","cnpj":"05333674000121","city":"BELO HORIZONTE","stateCode":"MG","buscaAdicional":"VIASHOP BAR 2997 VIA SHOPP BARREIRO 70911"},{"id":"a1b82293-3ef2-499a-52a7-08d5ad2bf6ba","name":"HIDRELETRICA PIPOCA S.A.","commercialName":"HIDRELETRICA PIPOCA","cnpj":"06814778000110","city":"BELO HORIZONTE","stateCode":"MG","buscaAdicional":"PIPOCA 3201 PIPOCA 8742 PCH.PH.MG.002069-9.01"},{"id":"8f55e0f9-aa7a-42b6-52aa-08d5ad2bf6ba","name":"VALLOUREC SOLUCOES TUBULARES DO BRASIL S.A.","commercialName":"","cnpj":"08689024000101","city":"BELO HORIZONTE","stateCode":"MG","buscaAdicional":"VSB BARREIRO 3211 V E M-BH 7748"},{"id":"3d18a285-c29e-4717-5346-08d5ad2bf6ba","name":"PITAGORAS - SISTEMA DE EDUCACAO SUPERIOR SOCIEDADE LTDA","commercialName":"","cnpj":"03239470000109","city":"BELO HORIZONTE","stateCode":"MG","buscaAdicional":"PITAGORAS 3547 PITAGORAS R GABAGLIA 71186 PITAGORAS IPATINGA 71187 PITAGORAS BETIM 71188 PITAGORAS VOTORANTIM 909347 PITAGORAS VARGINHA 909946 PITAGORAS REZENDE 910218"},{"id":"7d804bd0-294e-45ca-535b-08d5ad2bf6ba","name":"BOULEVARD SHOPPING S/A","commercialName":"","cnpj":"08824115000102","city":"BELO HORIZONTE","stateCode":"MG","buscaAdicional":"BOULEVARD BH 3593 BOULEVARD BH 71316"},{"id":"87ad76a4-862e-4331-50c1-08d5ad2bf6ba","name":"CELULOSE NIPO BRASILEIRA S A CENIBRA","commercialName":"CELULOSE NIPO BRASILEIRA S/A CENIBRA EST UNIF","cnpj":"42278796000199","city":"BELO ORIENTE","stateCode":"MG","buscaAdicional":"CENIBRA 1825 CENIBRA BELO ORIENTE 70204"},{"id":"249755aa-f0e7-464e-504b-08d5ad2bf6ba","name":"FCA FIAT CHRYSLER AUTOMOVEIS BRASIL LTDA.","commercialName":"","cnpj":"16701716003333","city":"BETIM","stateCode":"MG","buscaAdicional":"FA FILIAL MEC 1560 POWERTRAIN-BETIM-MG 7687"},{"id":"0a48d84e-5c29-4a9a-4f8e-08d5ad2bf6ba","name":"FCA FIAT CHRYSLER AUTOMOVEIS BRASIL LTDA.","commercialName":"FIASA","cnpj":"16701716000156","city":"BETIM","stateCode":"MG","buscaAdicional":"FIAT AUTO 1156 FIAT-BETIM-MG 7685 FIAT PE 901493 FCA JABOATAO 912838"},{"id":"01324d46-a4bb-4290-4f72-08d5ad2bf6ba","name":"TEKSID DO BRASIL LTDA","commercialName":"","cnpj":"16694812000114","city":"BETIM","stateCode":"MG","buscaAdicional":"TEKSID 1108 TEKSID BR BETIM 7631"},{"id":"ecb199d3-e995-4cde-4f6a-08d5ad2bf6ba","name":"NEMAK ALUMINIO DO BRASIL LTDA","commercialName":"","cnpj":"04721073000123","city":"BETIM","stateCode":"MG","buscaAdicional":"NEMAK 1091 TEKSID ALUMIN BETIM 7633"},{"id":"5fa87791-5f73-44dc-5310-08d5ad2bf6ba","name":"INBRASP - INDUSTRIA BRASILEIRA DE PLASTICOS LTDA.","commercialName":"","cnpj":"59941799000244","city":"BETIM","stateCode":"MG","buscaAdicional":"INBRASP FILIA 3464 INBRASP BETIM MG 71048"},{"id":"ca0329a6-70f6-4b68-524f-08d5ad2bf6ba","name":"METALSIDER LTDA","commercialName":"","cnpj":"17635277000193","city":"BETIM","stateCode":"MG","buscaAdicional":"METALSIDER 2998 METALSIDER BETIM MG 888124 METALSIDER LTDA 896707 METALSIDER 8707 UTE.CM.MG.030256-2.01"},{"id":"b81edbe9-1514-44d4-5248-08d5ad2bf6ba","name":"CONDOMINIO INDIVISO BETIM SHOPPING","commercialName":"BETIM SHOPPING","cnpj":"03009014000164","city":"BETIM","stateCode":"MG","buscaAdicional":"BETIM SHOPPING 2988 BETIM SHOPPING 70850"},{"id":"71d03f7c-3c9d-49c8-526b-08d5ad2bf6ba","name":"FORMTAP INDUSTRIA E COMERCIO S/A","commercialName":"","cnpj":"53808697000600","city":"BETIM","stateCode":"MG","buscaAdicional":"FORMTAP 3050 FORMTAP IND. E COM. 70872"},{"id":"7c181942-8e21-4e37-5385-08d5ad2bf6ba","name":"AETHRA SISTEMAS AUTOMOTIVOS S.A.","commercialName":"","cnpj":"41757527000142","city":"BETIM","stateCode":"MG","buscaAdicional":"AETHRA 3677 AETHRA MATRIZ 71277 AETHRA FILIAL CINCO 71278 AETHRA FILIAL COTIA 71279 AETHRA 70658"},{"id":"f014d7da-6660-49ef-5c89-08d5ad2bf6ba","name":"KEIPER FABRICACAO DE PECAS AUTOMOTIVAS LTDA.","commercialName":"","cnpj":"23655106000129","city":"BETIM","stateCode":"MG","buscaAdicional":"KEIPER PECAS 51376 TOWER AUTO BETIM MG 889320 TOWER AUTO CONTAGEM 889321"},{"id":"7cdab156-eb94-40b6-5da5-08d5ad2bf6ba","name":"CONDOMINIO DO PARTAGE SHOPPING BETIM","commercialName":"","cnpj":"17916600000105","city":"BETIM","stateCode":"MG","buscaAdicional":"PARTAGEMSB 51944 PARTAGE SHOPPING 899224"},{"id":"8648df51-aff2-4f7d-5e02-08d5ad2bf6ba","name":"GE POWER CONVERSION BRASIL LTDA.","commercialName":"","cnpj":"07608927000824","city":"BETIM","stateCode":"MG","buscaAdicional":"GE POWER 52148 GE POWER 900697"},{"id":"2a26d527-3711-411d-60cb-08d5ad2bf6ba","name":"JABIL DO BRASIL INDUSTRIA ELETROELETRONICA LTDA","commercialName":"","cnpj":"04854120000298","city":"BETIM","stateCode":"MG","buscaAdicional":"JABIL MG 53727 JABIL MG 904959"},{"id":"a3678b4c-6e24-4004-5b64-08d5ad2bf6ba","name":"BREMBO DO BRASIL LTDA","commercialName":"","cnpj":"03645767000166","city":"BETIM","stateCode":"MG","buscaAdicional":"BREMBO MG 50691 BREMBO 898007"},{"id":"bd0e1600-68f2-4d26-5c1f-08d5ad2bf6ba","name":"SUPERMERCADO SUPER LUNA S.A","commercialName":"","cnpj":"71385637000191","city":"BETIM","stateCode":"MG","buscaAdicional":"SUPERLUNA 51095 SUPERLUNA BAND 898368 SUPERLUNA TULIO 898369 SUPERLUNA BRUM 898389 SUPERLUNA DIAS 899071"},{"id":"cd6e2e44-dc94-4bdb-5b3c-08d5ad2bf6ba","name":"SUPERGASBRAS ENERGIA LTDA","commercialName":"","cnpj":"19791896000100","city":"BETIM","stateCode":"MG","buscaAdicional":"SUPERGASBRAS 50533 SGASBRAS CAXIAS ENG 898039 SGBCAXIASARM 898040 SGBQUALIVAL 898075 SGBSERRA 898076 SGBSAOJOSE 898077 SGB PAULINIA 898105 SGBMAUA SP 899052 SGBCANOAS 899115 SGBARAUCARIA 899446 SGB BRASILIA 899647 SGBLONDRINA 899767 SUPERGASBRAS 900866 SGBBETIMARM 900995 SUPERGASBRAS CUIABA 910044 SUPERGASBRAS RIBEIR 910308 SUPERGASBRAS UBERLAN 910332"},{"id":"4a40e5d9-3df4-44d6-5b14-08d5ad2bf6ba","name":"RACRI INDUSTRIA DE RECICLAGEM LTDA","commercialName":"","cnpj":"03291021000100","city":"BETIM","stateCode":"MG","buscaAdicional":"RACRI 50455 RACRI 897675"},{"id":"e803c250-5cf2-4f9f-64fc-08d5ad2bf6ba","name":"MINERACAO MONTREAL LTDA","commercialName":"","cnpj":"70967971000190","city":"BETIM","stateCode":"MG","buscaAdicional":"MONTREAL 56363 MINERACAO MONTREAL 907193"},{"id":"8f0b478b-0921-4cad-6509-08d5ad2bf6ba","name":"USIBRITA LTDA","commercialName":"","cnpj":"18820688000111","city":"BETIM","stateCode":"MG","buscaAdicional":"USIBRITA 56391 USIBRITA LTDA 906504"},{"id":"093fd18c-404c-4d47-61bc-08d5ad2bf6ba","name":"SAE TOWERS BRASIL TORRES DE TRANSMISSAO LTDA","commercialName":"SAE TOWERS BRASIL","cnpj":"07758028000131","city":"BETIM","stateCode":"MG","buscaAdicional":"SAE TOWERS 54354 SAE TOWERS BRASIL 904135"},{"id":"d9eeb2dc-6ea1-4621-6117-08d5ad2bf6ba","name":"BETIM EMPREENDIMENTOS E PARTICIPACOES S.A.","commercialName":"","cnpj":"12457068000183","city":"BETIM","stateCode":"MG","buscaAdicional":"MONTECARMO SHOP 54009 MONTECARMO SHOP 905889"},{"id":"57ba1832-bdd9-40e6-4f2f-08d5ad2bf6ba","name":"RIMA ENERGETICA LTDA","commercialName":"","cnpj":"05209046000139","city":"BOCAIÚVA","stateCode":"MG","buscaAdicional":"RIMA 125"},{"id":"6799915f-d6b2-47ab-4f93-08d5ad2bf6ba","name":"RIMA INDUSTRIAL S/A","commercialName":"","cnpj":"18279158000108","city":"BOCAIÚVA","stateCode":"MG","buscaAdicional":"RIAL 1164 RIMA C ENEAS 7041 RIMA VARZEA PALMA 7601 RIMA BOCAIUVA 7609"},{"id":"c521a9cc-09fa-4d52-626b-08d5ad2bf6ba","name":"ANIMALL INDUSTRIA E COMERCIO DE RACOES LTDA","commercialName":"ANIMALL NUTRICAO & SAUDE","cnpj":"07099466000135","city":"BOM DESPACHO","stateCode":"MG","buscaAdicional":"ANIMALLRACOES 54755 ANIMALL RACOES 906547"},{"id":"c9092381-b692-42af-88a0-08d5ae44ed50","name":"PONTE QUEIMADA ENERGIA S. A.","commercialName":"","cnpj":"14697307000106","city":"BOM JESUS DO GALHO","stateCode":"MG","buscaAdicional":"CGH PONTE QUEIMADA 14821 PONTE QUEIMADA 895083 CGH.PH.MG.031693-8.01"},{"id":"fd569f09-acae-4b79-59fe-08d5ad2bf6ba","name":"BOM JESUS ENERGIA S.A.","commercialName":"BOM JESUS ENERGIA","cnpj":"97542603000157","city":"BOM JESUS DO GALHO","stateCode":"MG","buscaAdicional":"CGH BOM JESUS 16295 BOM JESUS 896126 CGH.PH.MG.032564-3.01"},{"id":"c0f15000-af25-4c02-5431-08d5ad2bf6ba","name":"SANTA TEREZINHA GERACAO DE ENERGIA LTDA","commercialName":"","cnpj":"11181215000172","city":"BORDA DA MATA","stateCode":"MG","buscaAdicional":"STA TEREZINHA 4074 STA TEREZINHA (ST T) 888452 CGH.PH.MG.028242-1.01"},{"id":"8d4682e0-0c93-4d48-512e-08d5ad2bf6ba","name":"VALLOUREC MINERACAO LTDA","commercialName":"","cnpj":"22931380000110","city":"BRUMADINHO","stateCode":"MG","buscaAdicional":"VMMN 2035 VMMN BRUMADINHO 71123"},{"id":"61937739-fb82-4bc3-5b53-08d5ad2bf6ba","name":"INSTITUTO INHOTIM","commercialName":"","cnpj":"05422243000131","city":"BRUMADINHO","stateCode":"MG","buscaAdicional":"INHOTIM 50601 INST INHOTIM 898696"},{"id":"cd01f4d2-cf61-4faf-6663-08d5ad2bf6ba","name":"MINERACAO MORRO DO IPE S.A.","commercialName":"","cnpj":"22902554000117","city":"BRUMADINHO","stateCode":"MG","buscaAdicional":"MINA TICO TICO CE 57517 MINA DO TICO-TICO 70846 MINA DO IPE 70901"},{"id":"60bb4c7f-97e4-4191-7361-08d5cf600bef","name":"CACHOEIRA VELONORTE SA","commercialName":"","cnpj":"20933354000104","city":"CACHOEIRA DA PRATA","stateCode":"MG","buscaAdicional":""},{"id":"1ffea4f7-99da-4f64-54ac-08d5ad2bf6ba","name":"MEGACABOS INDUSTRIA E COMERCIO DE CABOS ESPECIAIS LTDA","commercialName":"MEGATRON","cnpj":"07642862000167","city":"CACHOEIRA DE MINAS","stateCode":"MG","buscaAdicional":"MEGACABOS 4433 MEGACABOS CACHOEIRA 71627"},{"id":"0d82d679-7664-4747-6343-08d5ad2bf6ba","name":"TAUA RESORT CAETE LTDA","commercialName":"","cnpj":"22488316000107","city":"CAETÉ","stateCode":"MG","buscaAdicional":"TAUA HOTEL CAETE 55275 TAUA HOTEL CAETE 905893"},{"id":"1c8cffcf-bedc-43f8-8877-08d5ae44ed50","name":"SAO JOAO ENERGIA S. A.","commercialName":"","cnpj":"11299657000118","city":"CAIANA","stateCode":"MG","buscaAdicional":"CGH SAO JOAO 7583 SAO JOAO DE CAIANA 888915 CGH.PH.MG.030862-5.01"},{"id":"3ce8de51-fd47-4106-4fa7-08d5ad2bf6ba","name":"UNIMINAS AGRO-INDUSTRIAL LTDA","commercialName":"","cnpj":"02236833000181","city":"CAMANDUCAIA","stateCode":"MG","buscaAdicional":"UNIMINAS AGRO 1213 UNIMINAS-CAMANDUCAIA 7560"},{"id":"3a8e59ee-35a0-473a-5c6d-08d5ad2bf6ba","name":"MELHORAMENTOS FLORESTAL LTDA.","commercialName":"","cnpj":"02440482000479","city":"CAMANDUCAIA","stateCode":"MG","buscaAdicional":"MELHORAMENTOS FLORESTAL 51313 MELHORAMENTOS FLORES 898829"},{"id":"26f78b0f-f8a0-466f-60e3-08d5ad2bf6ba","name":"INDUSTRIA DE EMBALAGENS TOCANTINS LTDA","commercialName":"","cnpj":"55417521000211","city":"CAMANDUCAIA","stateCode":"MG","buscaAdicional":"EMBALAGENS TOCANTINS 53844 EMBALAGENS TOCANTINS 905172"},{"id":"35903c90-378f-4a9c-5ffd-08d5ad2bf6ba","name":"LEGGETT & PLATT DO BRASIL LTDA","commercialName":"","cnpj":"03213075000149","city":"CAMANDUCAIA","stateCode":"MG","buscaAdicional":"LEGGETT & PLATT 53330 LEGGET & PLATT 900702"},{"id":"e15aff77-8f6e-451e-5e9c-08d5ad2bf6ba","name":"SOUFER INDUSTRIAL LTDA.","commercialName":"SOUFER","cnpj":"45987062000681","city":"CAMBUÍ","stateCode":"MG","buscaAdicional":"SOUFER CAMBUI 52463 SOUFER INDUSTRIAL 902321"},{"id":"8cb313c8-6219-4e15-690a-08d5ad2bf6ba","name":"ADICAO DISTRIBUICAO EXPRESS LTDA","commercialName":"SUPERMERCADOS ABC","cnpj":"04149637004516","city":"CAMBUÍ","stateCode":"MG","buscaAdicional":"SUPER ABC CAMBUI 60739 SUPER ABC CAMBUI 907413"},{"id":"431ad731-2796-44ac-6432-08d5ad2bf6ba","name":"RHODES S/A","commercialName":"","cnpj":"60657624000108","city":"CAMBUÍ","stateCode":"MG","buscaAdicional":"RHODES 55877 RHODES 906293"},{"id":"a9ac3b7d-109b-4eb7-63d9-08d5ad2bf6ba","name":"JA TRANSFORMACAO E RECICLAGEM DE PLASTICOS LTDA","commercialName":"JA TRANSFORMACAO E RECICLAGEM DE PLASTICOS","cnpj":"21528422000104","city":"CAMBUÍ","stateCode":"MG","buscaAdicional":"JA PLASTICOS 55681 JA PLASTICOS 906711"},{"id":"88903003-ed28-4987-5a48-08d5ad2bf6ba","name":"PORTO ENERGETICA LTDA","commercialName":"PORTO ENERGETICA","cnpj":"13523977000135","city":"CAMPESTRE","stateCode":"MG","buscaAdicional":"PORTO 17324 CGH JOAO FRANCO 897205 CGH.PH.MG.029644-9.01"},{"id":"d284aacc-44e8-4526-5863-08d5ad2bf6ba","name":"CGH PEDACINHO DO CEU SPE ENERGIA ELETRICA LTDA","commercialName":"","cnpj":"12578404000146","city":"CAMPESTRE","stateCode":"MG","buscaAdicional":"PEDACINHO DO CEU 11629 PEDACINHO DO CEU 891865 CGH.PH.MG.031265-7.01"},{"id":"7b304d2b-0889-4c29-5f7a-08d5ad2bf6ba","name":"MINERVA S.A.","commercialName":"MINERVA S.A.","cnpj":"67620377004969","city":"CAMPINA VERDE","stateCode":"MG","buscaAdicional":"MINERVA CPV 52969 MINERVA S/A 903174"},{"id":"d72a15f5-e957-4318-5bbe-08d5ad2bf6ba","name":"DOCE MINEIRO LTDA","commercialName":"DOCE TRIANGULO MINEIRO","cnpj":"22335392000182","city":"CANÁPOLIS","stateCode":"MG","buscaAdicional":"DOCE MINEIRO 50880 DOCE MINEIRO 898684"},{"id":"04a04544-4b1d-4331-8883-08d5ae44ed50","name":"DIVINO ENERGIA LTDA","commercialName":"","cnpj":"13923205000190","city":"CARANGOLA","stateCode":"MG","buscaAdicional":"CGH DIVINO 9870 DIVINO 889698 CGH.PH.MG.031007-7.01"},{"id":"7ecef95f-4e85-4e42-5f77-08d5ad2bf6ba","name":"LIDER MINAS INDUSTRIA E COMERCIO DE PRODUTOS ALIMENTICIOS LTDA","commercialName":"","cnpj":"20330551000120","city":"CARATINGA","stateCode":"MG","buscaAdicional":"LIDER MINAS 52966 LIDER MINAS 904127"},{"id":"a5ba2480-6de8-4532-60b6-08d5ad2bf6ba","name":"AFER INDUSTRIAL EIRELI","commercialName":"","cnpj":"03992516000158","city":"CARMO DA MATA","stateCode":"MG","buscaAdicional":"AFER INDUSTRIAL 53645 AFER INDUSTRIAL 903159"},{"id":"d8cba384-0a2b-4f63-67c5-08d5ad2bf6ba","name":"ALIMENTA NUTRICAO ANIMAL S/A","commercialName":"ALIMENTA AVICOLA","cnpj":"22458798000152","city":"CARMO DO CAJURU","stateCode":"MG","buscaAdicional":"ALIMENTA NUTRICAO 58630 ALIMENTA NUTR ANIMAL 908377"},{"id":"310d9773-1b99-4acb-73ba-08d5cf600bef","name":"REDE ENERGIA PARTICIPACOES S.A.","commercialName":"","cnpj":"61584140000149","city":"CATAGUASES","stateCode":"MG","buscaAdicional":""},{"id":"c5f864b8-ddd6-4e48-721e-08d5cf600bef","name":"ENERGISA S/A","commercialName":"","cnpj":"00864214000106","city":"CATAGUASES","stateCode":"MG","buscaAdicional":""},{"id":"147f077a-1b20-4eae-4f9a-08d5ad2bf6ba","name":"COMPANHIA INDUSTRIAL CATAGUASES","commercialName":"","cnpj":"19526748000150","city":"CATAGUASES","stateCode":"MG","buscaAdicional":"CIC MATRIZ 1183 IND CATAG MATRIZ 7081"},{"id":"c8929636-901a-4155-4f9b-08d5ad2bf6ba","name":"COMPANHIA INDUSTRIAL CATAGUASES","commercialName":"","cnpj":"19526748000665","city":"CATAGUASES","stateCode":"MG","buscaAdicional":"CIC FILIAL 1184 IND CATAG FILIAL 7087"},{"id":"40759056-8d51-499f-4ee1-08d5ad2bf6ba","name":"ENERGISA MINAS GERAIS - DISTRIBUIDORA DE ENERGIA S.A.","commercialName":"EST UNIF","cnpj":"19527639000158","city":"CATAGUASES","stateCode":"MG","buscaAdicional":"ENERGISA MG 8 ENERGISA MG 5"},{"id":"c347055a-72b2-4ac5-58fc-08d5ad2bf6ba","name":"GESM - GERACAO DE ENERGIA SUL DE MINAS S/A","commercialName":"","cnpj":"16365836000120","city":"CAXAMBU","stateCode":"MG","buscaAdicional":"GESM 13532 HENRIQUE PORTUGAL 349 CGH.PH.MG.028022-4.01 PIRAMBEIRA 572 CGH.PH.MG.028018-6.01 RIBEIRAO 573 CGH.PH.MG.028019-4.01 CONGONHAL II 8086 CGH.PH.MG.028020-8.01 CONGONHAL I 348 PCH.PH.MG.028036-4.01 PAES LEME 350 PCH.PH.MG.001932-1.01"},{"id":"48e010f5-9d9a-4033-883e-08d5ae44ed50","name":"CEI MINAS PCH ENERGIA LTDA","commercialName":"","cnpj":"04825696000146","city":"CAXAMBU","stateCode":"MG","buscaAdicional":"CEI MINAS 1732 CAQUENDE 8175 CGH.PH.MG.027505-0.01"},{"id":"960e363d-1ffc-400c-683a-08d5ad2bf6ba","name":"CODEAGUAS AGUAS MINERAIS LTDA.","commercialName":"","cnpj":"24248457000269","city":"CAXAMBU","stateCode":"MG","buscaAdicional":"CODEAGUAS AGUAS MINERAIS 59497 CODEAGUAS 910219"},{"id":"b9a77d4e-4a1c-47cc-64c5-08d5ad2bf6ba","name":"CURTUME TOINZINHO LTDA","commercialName":"CURTUME TOINZINHO","cnpj":"20709374000198","city":"CLARAVAL","stateCode":"MG","buscaAdicional":"CURTUME TOINZINHO 56216 CURTUME 3011187325 909950 CURTUME 3009011278 910009"},{"id":"7c47beac-f295-4118-6445-08d5ad2bf6ba","name":"PALMA POLIETILENOS LTDA","commercialName":"","cnpj":"25142465000108","city":"CLÁUDIO","stateCode":"MG","buscaAdicional":"PALMA POLIETILENO 55902 PALMA POLIETILENOS 898709"},{"id":"492cda89-b4d3-4a44-62a5-08d5ad2bf6ba","name":"METALURGICA AMAPA LTDA","commercialName":"","cnpj":"19219229000140","city":"CLÁUDIO","stateCode":"MG","buscaAdicional":"METALURGICA AMAPA 54896 METALURGICA AMAPA LT 905867"},{"id":"8b2a87e3-5e85-4556-61d6-08d5ad2bf6ba","name":"ISOACO INDUSTRIA E COMERCIO DE FUNDIDOS LTDA","commercialName":"","cnpj":"21746198000127","city":"CLÁUDIO","stateCode":"MG","buscaAdicional":"ISOACO 54443 ISOACO FUNDIDOS 906566"},{"id":"b1079067-da0c-4ca5-5b46-08d5ad2bf6ba","name":"FUNDICAO ARAGUAIA LTDA","commercialName":"","cnpj":"19931971000183","city":"CLÁUDIO","stateCode":"MG","buscaAdicional":"ARAGUAIA 50557 FUND ARAGUAIA 898704"},{"id":"59d071f4-28f5-478c-5b47-08d5ad2bf6ba","name":"RECICLAGEM PALMA LTDA","commercialName":"","cnpj":"06243335000117","city":"CLÁUDIO","stateCode":"MG","buscaAdicional":"RECICLAGEM PALMA 50558 RECICLAGEM PALMA I 898708"},{"id":"7f816141-0542-4c18-5dc7-08d5ad2bf6ba","name":"FUNDICAO SANTANA LTDA","commercialName":"","cnpj":"21476627000193","city":"CLÁUDIO","stateCode":"MG","buscaAdicional":"FUNDICAO SANTANA 51984 FUNDICAO SANTANA MG 902395"},{"id":"86ad2509-c80c-4821-4f59-08d5ad2bf6ba","name":"FUNDIMIG EIRELI","commercialName":"","cnpj":"17381542000154","city":"CLÁUDIO","stateCode":"MG","buscaAdicional":"FUNDIMIG 1065 FUNDIMIG-CLAUDIO-MG 7605 FUNDIMIG C.MATA MG 72105"},{"id":"9289668b-b014-41c7-5469-08d5ad2bf6ba","name":"FORNO DE MINAS ALIMENTOS S/A","commercialName":"","cnpj":"03870455000156","city":"CONCEIÇÃO DO PARÁ","stateCode":"MG","buscaAdicional":"FORNO MINAS MT 4218 LATIC CONDESSA LIVRE 70831 FORNO MINAS MATRIZ 71562"},{"id":"8da1bd46-ef29-4180-519d-08d5ad2bf6ba","name":"METAGAL INDUSTRIA E COMERCIO LTDA","commercialName":"METAGAL","cnpj":"59106377000849","city":"CONCEIÇÃO DOS OUROS","stateCode":"MG","buscaAdicional":"METAGAL CONC 2433 METAGAL C OUROS 70575"},{"id":"0b42dbe5-7ef2-42df-647a-08d5ad2bf6ba","name":"CONCESSIONARIA DO AEROPORTO INTERNACIONAL DE CONFINS S/A","commercialName":"","cnpj":"19674909000153","city":"CONFINS","stateCode":"MG","buscaAdicional":"BH-AIRPORT 56021 BH AIRPORT 907618"},{"id":"51a8afa3-1ddd-4260-6191-08d5ad2bf6ba","name":"FERROUS RESOURCES DO BRASIL S.A","commercialName":"","cnpj":"08852207000368","city":"CONGONHAS","stateCode":"MG","buscaAdicional":"FERROUS VIGA 54244 FERROUS VIGA 904126"},{"id":"fbf328ba-be56-4b15-5bb9-08d5ad2bf6ba","name":"CSN MINERACAO S.A.","commercialName":"","cnpj":"08902291000115","city":"CONGONHAS","stateCode":"MG","buscaAdicional":"CSN MINERACAO 50874 CONGONHAS MINERIOS 7745 TECAR 71012"},{"id":"539249ba-da89-4f49-4f8f-08d5ad2bf6ba","name":"GRANHA LIGAS LTDA","commercialName":"GRANHA LIGAS","cnpj":"05833746000108","city":"CONSELHEIRO LAFAIETE","stateCode":"MG","buscaAdicional":"GRANHA1 1158 GRANHA LIGAS LAFAIET 7681 FERNANDO G NOGUEIRA 7733 GRANHA LIGAS 898387"},{"id":"0c1328ce-82ea-430d-4f53-08d5ad2bf6ba","name":"BELGO BEKAERT ARAMES LTDA","commercialName":"","cnpj":"61074506000130","city":"CONTAGEM","stateCode":"MG","buscaAdicional":"BELGO CONT 1053 BBA-CONTAGEM-MG 7735 BB ARAMES-OSASCO T51 7838 BELGO ARAMES HORTOL 7982 BELGO DSIC MG 70556 BELGO BEKAERT NE FIL 70916 BELGO BEKAERT NE 71383"},{"id":"42e4e31a-1cff-43ee-4f5e-08d5ad2bf6ba","name":"MAGOTTEAUX BRASIL LTDA","commercialName":"","cnpj":"43790666000101","city":"CONTAGEM","stateCode":"MG","buscaAdicional":"MAGOTTEAUX 1072 MAGOTTEAUX CONTAGEM 7664"},{"id":"9b666c08-d7cd-4c8b-51af-08d5ad2bf6ba","name":"MAGNETI MARELLI SISTEMAS AUTOMOTIVOS INDUSTRIA E COMERCIO LTDA","commercialName":"","cnpj":"02990605000100","city":"CONTAGEM","stateCode":"MG","buscaAdicional":"MMSA 2502 MAGNETI MAR CONTAGEM 70656 MM SUSPENSAO 70819"},{"id":"0cc5913d-53f9-4fa1-5180-08d5ad2bf6ba","name":"CMP COMPONENTES E MODULOS PLASTICOS INDUSTRIA E COMERCIO LTDA","commercialName":"","cnpj":"07374996000144","city":"CONTAGEM","stateCode":"MG","buscaAdicional":"CMP 2211 CMP - CONTAGEM 7652 CMP MATEUS LEME 910286"},{"id":"26b8e2c4-e303-4ab5-51ed-08d5ad2bf6ba","name":"MAGNESITA REFRATARIOS S.A.","commercialName":"","cnpj":"08684547000165","city":"CONTAGEM","stateCode":"MG","buscaAdicional":"MAGNESITA REFR 2726 REFRATEC CONTAGEM 7781 MAGNESITA CONTAGEM 7783"},{"id":"b10c71b7-a202-4d70-5205-08d5ad2bf6ba","name":"IOCHPE-MAXION S.A.","commercialName":"","cnpj":"61156113000680","city":"CONTAGEM","stateCode":"MG","buscaAdicional":"MAXION FILIAL 2795 IOCHPE MAXION LIVRE 70763"},{"id":"c1431114-3758-48e2-5236-08d5ad2bf6ba","name":"DOMINGOS COSTA INDUSTRIAS ALIMENTICIAS SA","commercialName":"PASTIFICIO VILMA","cnpj":"17159518000175","city":"CONTAGEM","stateCode":"MG","buscaAdicional":"VILMA ALIM 2924 VILMA ALIMENTOS 70824"},{"id":"9346b111-6a3f-448f-525e-08d5ad2bf6ba","name":"UNOCANN TUBOS E CONEXOES LTDA","commercialName":"","cnpj":"86632239000108","city":"CONTAGEM","stateCode":"MG","buscaAdicional":"UNOCANN 3031 UNOCANN TUBOS CONEX 71062"},{"id":"82bb3ed6-eb6b-4038-5289-08d5ad2bf6ba","name":"ESTAMPARIA SA","commercialName":"ESTAMPARIA","cnpj":"19791987000138","city":"CONTAGEM","stateCode":"MG","buscaAdicional":"ESTAMPARIA 3114 ESTAMPARIA-GOUVEIA 70931 ESTAMPARIA-CONTAGEM 70942"},{"id":"51274f96-f2e1-4f6f-5316-08d5ad2bf6ba","name":"FIACAO E TECELAGEM SAO GERALDO LTDA","commercialName":"","cnpj":"19791227000120","city":"CONTAGEM","stateCode":"MG","buscaAdicional":"FIATECE SG 3475 FIAC TEC S GERALDO 71170"},{"id":"868462fd-3f0a-4609-5468-08d5ad2bf6ba","name":"GE TRANSPORTES FERROVIARIOS S.A","commercialName":"","cnpj":"02167325000199","city":"CONTAGEM","stateCode":"MG","buscaAdicional":"GETF 4216 GE TRANSP-CONTAGEM 71526"},{"id":"8032fa1b-e90c-4adb-53c4-08d5ad2bf6ba","name":"GENERAL ELECTRIC DO BRASIL LTDA","commercialName":"","cnpj":"33482241002621","city":"CONTAGEM","stateCode":"MG","buscaAdicional":"GE DISJUNTOR 3829 GE DISJUNTOR 71412"},{"id":"9a35e748-ba1d-468a-548f-08d5ad2bf6ba","name":"CENTRAIS DE ABASTECIMENTO DE MINAS GERAIS S/A - CEASAMINAS","commercialName":"CEASAMINAS","cnpj":"17504325000104","city":"CONTAGEM","stateCode":"MG","buscaAdicional":"CEASAMINAS 4341 CEASAMINAS-CONTAGEM 71658"},{"id":"b5ac5828-aa5d-4560-5508-08d5ad2bf6ba","name":"INDUSTRIA SANTA CLARA SA","commercialName":"","cnpj":"17156696000142","city":"CONTAGEM","stateCode":"MG","buscaAdicional":"ISC 4940 IND S CLARA-CONTAGEM 71836"},{"id":"de7d318f-0df0-447f-575b-08d5ad2bf6ba","name":"CONDOMINIO ITAUPOWER SHOPPING","commercialName":"","cnpj":"05599839000101","city":"CONTAGEM","stateCode":"MG","buscaAdicional":"ITAUPOWER 8651 ITOWER SHOPPING 904960"},{"id":"d5094661-84e4-453f-55aa-08d5ad2bf6ba","name":"AMERICAN DIE CASTING DO BRASIL LTDA","commercialName":"","cnpj":"03456663000103","city":"CONTAGEM","stateCode":"MG","buscaAdicional":"GIBBSBRASIL 5978 GIBBS BR DIE CASTING 71930"},{"id":"ee6d8bbd-2d47-4855-5be5-08d5ad2bf6ba","name":"J.M.E-EMPREENDIMENTOS PARTICIPACOES E SERVICOS S/A","commercialName":"J.M.E.DISTRIBUIDORA","cnpj":"08342257000214","city":"CONTAGEM","stateCode":"MG","buscaAdicional":"JME 50976 JME DISTRIBUIDORA 898102"},{"id":"f16bb3e6-be1d-42ce-5b77-08d5ad2bf6ba","name":"DELP ENGENHARIA MECANICA S/A","commercialName":"","cnpj":"17161936000105","city":"CONTAGEM","stateCode":"MG","buscaAdicional":"DELP 50712 DELP VESPASIANO 898027 DELP ENG MEC 898047"},{"id":"850c9c1d-96b3-4a38-5c37-08d5ad2bf6ba","name":"GONTEN EMPREENDIMENTOS IMOBILIARIOS E PARTICIPACOES LTDA","commercialName":"","cnpj":"17298831000194","city":"CONTAGEM","stateCode":"MG","buscaAdicional":"SHOP CONTAGEM 51192 SHOP CONTAGEM 898250"},{"id":"f71bb02b-005b-447b-5b52-08d5ad2bf6ba","name":"SEMPRE EDITORA LTDA","commercialName":"","cnpj":"26198515000484","city":"CONTAGEM","stateCode":"MG","buscaAdicional":"SEMPRE EDITORA 50600 SEMPRE EDITORA 898251"},{"id":"9fdae9ed-efd8-4bce-5b20-08d5ad2bf6ba","name":"PETRONAS LUBRIFICANTES BRASIL S.A","commercialName":"PETRONAS LUBRICANTS BRAZIL","cnpj":"03613421000186","city":"CONTAGEM","stateCode":"MG","buscaAdicional":"PETRONAS 50480 PETRONAS 898064"},{"id":"bcfbab5b-4cb2-41d7-5e40-08d5ad2bf6ba","name":"ARCELORMITTAL CONTAGEM S.A","commercialName":"","cnpj":"25878901000101","city":"CONTAGEM","stateCode":"MG","buscaAdicional":"AMC 52296 ARCELORMITTAL CONTAG 901593 ARCELORMITTAL 901613"},{"id":"62c778ac-043a-4079-5d29-08d5ad2bf6ba","name":"ESAB INDUSTRIA E COMERCIO LTDA","commercialName":"ESAB","cnpj":"29799921000148","city":"CONTAGEM","stateCode":"MG","buscaAdicional":"ESAB 51723 ESAB BELO II 901093 ESAB BELO I 903382"},{"id":"eddf8394-f5cf-4c62-5d4c-08d5ad2bf6ba","name":"CONDOMINIO CONTAGEM BIGSHOPPING","commercialName":"","cnpj":"00193039000172","city":"CONTAGEM","stateCode":"MG","buscaAdicional":"BIGSHOPPING 51775 BIG SHOPPING LOJAS 899820 BIG SHOPPING COND 899822"},{"id":"9bb7c06c-0294-4f32-5f95-08d5ad2bf6ba","name":"ADICAO DISTRIBUICAO EXPRESS LTDA","commercialName":"SUPERMERCADOS ABC","cnpj":"04149637000103","city":"CONTAGEM","stateCode":"MG","buscaAdicional":"SUPERMERCADOS ABC 53039 LOJA 34 - PASSOS 896425 SUP ABC LOJA 03 905676 SUP ABC LOJA 07 905677 SUP ABC LOJA 02 905684 SUP ABC LOJA 11 905693 SUP ABC NOSSA SRA CO 905697 SAO JOSE L01 DIVINOP 906316 ABC LOJA 15 - ITAUNA 906503 ABC LOJA 23 - LAVRAS 906543 LOJA 14 ARCOS 907586 SUP ABC LOJA 32 908353 S ANT DO MONTE LJ 31 908375 LJ 25 CENTRO PASSOS 910811"},{"id":"b072a197-31d2-4be1-5f37-08d5ad2bf6ba","name":"RARO INDUSTRIA DE ALIMENTOS LTDA","commercialName":"","cnpj":"11483174000179","city":"CONTAGEM","stateCode":"MG","buscaAdicional":"SUPER NOSSO 52849 SUPER NOSSO 901080"},{"id":"befbf934-86b7-48e8-5f40-08d5ad2bf6ba","name":"MULTI FORMATO DISTRIBUIDORA SOCIEDADE ANONIMA","commercialName":"","cnpj":"10319375000172","city":"CONTAGEM","stateCode":"MG","buscaAdicional":"MULTI FORMATO 52875 MULTI FORMATO LJ 408 901069 MULTI FORMATO LJ 502 901070 MULTI FORMATO LJ 410 901101 MULTI FORMATO LJ 401 901102 MULTI FORMATO LJ 403 901447"},{"id":"f4c5fc35-30c3-4d6f-61d3-08d5ad2bf6ba","name":"FERROSIDER COMPONENTES LTDA","commercialName":"FERROSIDER COMPONENTES","cnpj":"05847800000166","city":"CONTAGEM","stateCode":"MG","buscaAdicional":"FERROSIDER COMPONENTES 54439 FERROSIDER COMPONENT 906829"},{"id":"609c748a-30ca-4b02-6484-08d5ad2bf6ba","name":"PIPE SISTEMAS TUBULARES LTDA","commercialName":"","cnpj":"02226707000146","city":"CONTAGEM","stateCode":"MG","buscaAdicional":"PIPE 56055 PIPE 907199"},{"id":"907aeca5-5e79-49d8-657d-08d5ad2bf6ba","name":"LINCON INDUSTRIA E COMERCIO LTDA","commercialName":"","cnpj":"38711826000131","city":"CONTAGEM","stateCode":"MG","buscaAdicional":"TROPEIRA 56743 LINCON IND E COMERC 906571 TROPEIRA II 908078"},{"id":"f67e49f2-eab1-43df-654c-08d5ad2bf6ba","name":"TECIDOS E ARMARINHOS MIGUEL BARTOLOMEU SA","commercialName":"","cnpj":"17359233000188","city":"CONTAGEM","stateCode":"MG","buscaAdicional":"TAMBASA 56643 TAMBASA 2 909252 TAMBASA 1 909253"},{"id":"05dbf8e5-ff84-4332-635e-08d5ad2bf6ba","name":"BLYDE COMERCIAL EIRELI","commercialName":"BLYDE","cnpj":"04593171000122","city":"CONTAGEM","stateCode":"MG","buscaAdicional":"BLYDE 55328 BLYDE COMERCIAL 908579"},{"id":"250e56cf-90ae-4213-6951-08d5ad2bf6ba","name":"CONDOMINIO DO SHOPPING CONTAGEM","commercialName":"","cnpj":"28112396000188","city":"CONTAGEM","stateCode":"MG","buscaAdicional":"COND SHOPPING CONTAGEM 61049"},{"id":"322d848d-3a96-4306-67bc-08d5ad2bf6ba","name":"GE HEALTHCARE DO BRASIL COMERCIO E SERVICOS PARA EQUIPAMENTOS MEDICO-HOSPITALARES LTDA","commercialName":"","cnpj":"00029372000221","city":"CONTAGEM","stateCode":"MG","buscaAdicional":"GE HEALTHCARE 58592 GE HEALTHCARE 908459"},{"id":"51cdb900-bbf9-43e2-6731-08d5ad2bf6ba","name":"ZAP GRAFICA E EDITORA EIRELI","commercialName":"GRAFICA E EDITORA ZAP","cnpj":"10588201000105","city":"CONTAGEM","stateCode":"MG","buscaAdicional":"ZAP GRAFICA E EDITORA 57997 ZAP GRAFICA EDITORA 907775"},{"id":"8fef05ee-9cb0-4eb8-6724-08d5ad2bf6ba","name":"REFLEX TEMPERVIDROS INDUSTRIA E COMERCIO DE VIDROS LTDA","commercialName":"REFLEX TEMPERVIDROS","cnpj":"04545217000138","city":"CONTAGEM","stateCode":"MG","buscaAdicional":"REFLEX TEMPERVIDROS 57978 REFLEX TEMPERVIDROS 908128"},{"id":"6651e57e-bac4-44db-668a-08d5ad2bf6ba","name":"RIO BRANCO ALIMENTOS S/A","commercialName":"PIF PAF","cnpj":"05017780000368","city":"CONTAGEM","stateCode":"MG","buscaAdicional":"PIFPAFCON 57638 RIO BRANCO ALIMENTO 909236"},{"id":"05ed9205-a4db-420e-7357-08d5cf600bef","name":"MINASMAQUINAS SA","commercialName":"","cnpj":"17161241000115","city":"CONTAGEM","stateCode":"MG","buscaAdicional":""},{"id":"e0a95dd6-2d59-4ad5-8da0-08d5d060706e","name":"ASSOCIACAO MANTENEDORA DO BRESCO CONTAGEM PARQUE LOGISTICO","commercialName":"","cnpj":"27608360000127","city":"CONTAGEM","stateCode":"MG","buscaAdicional":"BRESCO 61590"},{"id":"a57011ca-dda2-4667-56bc-08d5ad2bf6ba","name":"CAL OESTE LTDA","commercialName":"","cnpj":"16784001000104","city":"CÓRREGO FUNDO","stateCode":"MG","buscaAdicional":"CAL OESTE 7562 CAL OESTE - C FUNDO 72255"},{"id":"b7187b09-7e5f-46bb-5687-08d5ad2bf6ba","name":"INDUSTRIA DE CAL CRUZEIRO LTDA","commercialName":"INDUSTRIA DE CAL CRUZEIRO","cnpj":"19514579000139","city":"CÓRREGO FUNDO","stateCode":"MG","buscaAdicional":"CAL CRUZEIRO 7226 CAL CRUZEIRO C FUNDO 72208"},{"id":"22dfd528-7812-450e-5823-08d5ad2bf6ba","name":"USINA DELTA S.A.","commercialName":"USINA DELTA","cnpj":"13537735000109","city":"DELTA","stateCode":"MG","buscaAdicional":"UTE DELTA 10812 VOLTA GRANDE-I5 8299 UTE.AI.MG.028540-4.01 DELTA 8301 UTE.AI.MG.028219-7.01"},{"id":"b8f8bdb0-cfef-4b19-5844-08d5ad2bf6ba","name":"ICOPLAS INDUSTRIA DE FRASCOS LTDA","commercialName":"ICOT","cnpj":"11629048000180","city":"DIVINÓPOLIS","stateCode":"MG","buscaAdicional":"ICOPLAS 11149 ICOPLAS-DIVINOPOLIS 72256"},{"id":"aaf44fbd-e0c9-45fe-5a23-08d5ad2bf6ba","name":"SIDERURGICA VALINHO SA","commercialName":"VALINHO","cnpj":"20144085000946","city":"DIVINÓPOLIS","stateCode":"MG","buscaAdicional":"SIDERURGICA VALINHO 16534 SIDERURGICA VALINHOS 896304 UTE.FL.MG.029595-7.02"},{"id":"3c190433-e8d7-4667-5c3f-08d5ad2bf6ba","name":"DIVINE VIDROS DE SEGURANCA LTDA","commercialName":"DIVINE","cnpj":"04408172000150","city":"DIVINÓPOLIS","stateCode":"MG","buscaAdicional":"DIVINE VIDROS 51228 DIVINE VIDROS 899711"},{"id":"c54d23d1-91c7-4c86-56ba-08d5ad2bf6ba","name":"DISTRIBUIDORA AMARAL LTDA","commercialName":"FARMAX","cnpj":"21759758000188","city":"DIVINÓPOLIS","stateCode":"MG","buscaAdicional":"DAMARAL 7560 DISTRIBUIDORA AMARAL 897669"},{"id":"49943a50-1604-4f6a-56b0-08d5ad2bf6ba","name":"PLASDIL - PLASTICOS DIVINOPOLIS S/A - EM RECUPERACAO JUDICIAL","commercialName":"PLASDIL - PLASTICOS DIVINOPOLIS S/A","cnpj":"19757541000197","city":"DIVINÓPOLIS","stateCode":"MG","buscaAdicional":"PLASDIL 7520 PLASDIL-DIVINOPOLIS 72268"},{"id":"0d7a74ad-00a4-4790-544b-08d5ad2bf6ba","name":"CONDOMINIO DO TERRA PARQUE SHOPPING","commercialName":"SHOPPING PATIO DIVINOPOLIS","cnpj":"08154896000175","city":"DIVINÓPOLIS","stateCode":"MG","buscaAdicional":"PATIO DIVINOPOLIS 4142 TERRA PARQUE SHOP 71483"},{"id":"d03e7197-9645-458d-4f58-08d5ad2bf6ba","name":"FITEDI CONFECCOES S/A","commercialName":"FITEDI TEXTIL","cnpj":"20147161000110","city":"DIVINÓPOLIS","stateCode":"MG","buscaAdicional":"FITEDI 1064 FITEDI 900636"},{"id":"a206955c-46c4-4639-5054-08d5ad2bf6ba","name":"PLURAL LTDA","commercialName":"","cnpj":"04316992000111","city":"DIVINÓPOLIS","stateCode":"MG","buscaAdicional":"PLURAL 1573 DIVINOPOLIS 8240 CGH.PH.MG.029234-6.01"},{"id":"0ee4147c-3d8a-4f64-4ed5-08d5d159243d","name":"CONCESSIONARIA DA RODOVIA MG-050 S/A","commercialName":"CONCESSIONARIA NASCENTES DAS GERAIS","cnpj":"08822767000108","city":"DIVINÓPOLIS","stateCode":"MG","buscaAdicional":""},{"id":"c95441b9-7fa9-470a-6853-08d5ad2bf6ba","name":"SIDERCENTRO FERRO E ACO LTDA","commercialName":"","cnpj":"01977472000161","city":"DIVINÓPOLIS","stateCode":"MG","buscaAdicional":"SIDERCENTRO 59792 SIDERCENTRO FERRO 909945"},{"id":"9d74d041-283a-4a28-644e-08d5ad2bf6ba","name":"FUNFER FUNDICAO DE FERRO LIMITADA","commercialName":"FUNFER","cnpj":"16583312000105","city":"DIVINÓPOLIS","stateCode":"MG","buscaAdicional":"FUNFER 55922 FUNFER FERRO 907170"},{"id":"0ca9da06-b7a5-4765-6335-08d5ad2bf6ba","name":"PEMILL FUNDICAO E USINAGEM LTDA","commercialName":"","cnpj":"08515480000216","city":"DIVINÓPOLIS","stateCode":"MG","buscaAdicional":"PEMILL 55245 PEMILL FUNDICAO USIN 907776"},{"id":"91d238ed-1d88-4fe0-5d8e-08d5ad2bf6ba","name":"L-IMERYS INDUSTRIA E COMERCIO DE CAL LTDA","commercialName":"","cnpj":"14373046000160","city":"DORESÓPOLIS","stateCode":"MG","buscaAdicional":"IMERYS DORESOPOLIS 51911 IMERYS DORESOPOLIS 902495"},{"id":"2aaf7375-710d-424d-5993-08d5ad2bf6ba","name":"INGA - MIRIM ENERGIA S. A.","commercialName":"","cnpj":"13673002000193","city":"DURANDÉ","stateCode":"MG","buscaAdicional":"CGH INGA MIRIM 14918 INGA MIRIM 894966 CGH.PH.MG.031677-6.01"},{"id":"2a9b262a-4f16-4e5a-5913-08d5ad2bf6ba","name":"INGA ENERGIA S. A.","commercialName":"","cnpj":"13656261000106","city":"DURANDÉ","stateCode":"MG","buscaAdicional":"CGH INGA 13674 INGA 894042 CGH.PH.MG.031318-1.01"},{"id":"31960ce7-3bcb-4809-5c0f-08d5ad2bf6ba","name":"PANASONIC DO BRASIL LIMITADA","commercialName":"","cnpj":"04403408001307","city":"EXTREMA","stateCode":"MG","buscaAdicional":"PANASONIC MG 51061 PANASONIC - EXTREMA 898104"},{"id":"6cf049c6-6327-419f-5f2a-08d5ad2bf6ba","name":"MULTILASER INDUSTRIAL S.A.","commercialName":"","cnpj":"59717553000617","city":"EXTREMA","stateCode":"MG","buscaAdicional":"MULTILASER 52815 MULTILASER 901053"},{"id":"e443ea7e-42c6-4b75-5f02-08d5ad2bf6ba","name":"GRANASA MINAS INDUSTRIA E COMERCIO LTDA","commercialName":"","cnpj":"25291311000188","city":"EXTREMA","stateCode":"MG","buscaAdicional":"GRANASA 52703 GRANASA 902498"},{"id":"028cc92f-6528-42a3-5014-08d5ad2bf6ba","name":"FAGOR EDERLAN BRASILEIRA AUTO-PECAS LTDA.","commercialName":"","cnpj":"61082723000171","city":"EXTREMA","stateCode":"MG","buscaAdicional":"FAGOR 1434 FAGOR 7299 FAGOR-USINAGEM-EXTRM 71517"},{"id":"35c79f40-5ccb-4558-531e-08d5ad2bf6ba","name":"BALL DO BRASIL LTDA","commercialName":"BALL","cnpj":"00771979000282","city":"EXTREMA","stateCode":"MG","buscaAdicional":"BALL DO BRASIL 3483 REXAM EXTREMA 71125"},{"id":"727e397c-b83c-4853-5267-08d5ad2bf6ba","name":"INDUSTRIA METALURGICA FRUM LTDA","commercialName":"","cnpj":"61421418000167","city":"EXTREMA","stateCode":"MG","buscaAdicional":"FRUM D 3045 FRUM 70854"},{"id":"8d1f447e-3667-4959-555a-08d5ad2bf6ba","name":"SOFT FILM INDUSTRIA E COMERCIO DE PLASTICOS LTDA","commercialName":"","cnpj":"10829587000108","city":"EXTREMA","stateCode":"MG","buscaAdicional":"SOFT FILM 5397 SOFT FILM-EXTREMA 71934"},{"id":"7a25eb2c-c9be-4899-55de-08d5ad2bf6ba","name":"EXCIL COMERCIO E INDUSTRIA LTDA","commercialName":"EXCIL","cnpj":"09350617000101","city":"EXTREMA","stateCode":"MG","buscaAdicional":"EXCIL 6269 EXCIL EXTREMA 899763"},{"id":"d29d90bd-e0e8-42a2-67e4-08d5ad2bf6ba","name":"DELO INDUSTRIA E COMERCIO LTDA","commercialName":"","cnpj":"01856241000108","city":"EXTREMA","stateCode":"MG","buscaAdicional":"DELO 58795 DELO 908881"},{"id":"a1f20e9c-0af8-4124-887c-08d5ae44ed50","name":"FARIA LEMOS ENERGIA S.A.","commercialName":"","cnpj":"12026278000117","city":"FARIA LEMOS","stateCode":"MG","buscaAdicional":"CGH FARIA LEMO 8629 FARIA LEMOS 888552 CGH.PH.MG.030935-4.01"},{"id":"919b6abf-c79e-42e1-5237-08d5ad2bf6ba","name":"PRIMO ENERGETICA LTDA","commercialName":"","cnpj":"05500207000149","city":"FLORESTAL","stateCode":"MG","buscaAdicional":"PRIMO 2943 FLORESTAL 888451 CGH.PH.MG.030621-5.01 SAMBURA 893842 CGH.PH.MG.031044-1.01"},{"id":"8161c808-c0fc-4f7b-52e3-08d5ad2bf6ba","name":"CAL ARCO IRIS LTDA","commercialName":"","cnpj":"19281807000178","city":"FORMIGA","stateCode":"MG","buscaAdicional":"CAL ARCOIRIS 3344 CAL ARCO IRIS 71047"},{"id":"37848f81-0397-4fa7-527f-08d5ad2bf6ba","name":"USINA FRUTAL ACUCAR E ALCOOL LTDA.","commercialName":"USINA FRUTAL","cnpj":"07455944000100","city":"FRUTAL","stateCode":"MG","buscaAdicional":"USFRUTAL 3094 UTE FRUTAL 71847 FRUTAL 8672 UTE.AI.MG.029290-7.01"},{"id":"dc064862-f45b-441c-601e-08d5ad2bf6ba","name":"BIOENERGIA CERRADAO LTDA","commercialName":"BIOENERGIA CERRADAO","cnpj":"23156463000142","city":"FRUTAL","stateCode":"MG","buscaAdicional":"UTE BIO CERRADAO 53392 CERRADAO 8608 UTE.AI.MG.029709-7.01"},{"id":"6388dbbf-9df7-4e70-1cb7-08d5b8870181","name":"PREMIUM INDUSTRIA, COMERCIO E PARTICIPACAO LTDA","commercialName":"","cnpj":"11654122000118","city":"FRUTAL","stateCode":"MG","buscaAdicional":"CERVEJARIA PREMIUM 60973 PREMIUM INDUSTRIA 912453"},{"id":"b0736c40-b846-4296-88db-08d5ae44ed50","name":"LATICINIOS BELA VISTA LTDA","commercialName":"LATICINIOS BELA VISTA","cnpj":"02089969001340","city":"GOVERNADOR VALADARES","stateCode":"MG","buscaAdicional":"PIRACANJUBA MG 53374"},{"id":"c668ab25-0797-4e95-63bc-08d5ad2bf6ba","name":"SUPERMERCADO COELHO DINIZ LTDA","commercialName":"","cnpj":"41930199000134","city":"GOVERNADOR VALADARES","stateCode":"MG","buscaAdicional":"SUPERMERCADO COELHO DINIZ 55592 SUPER COELHO 07 907598 SUPER COELHO 09 907599 SUPER COELHO 12 907600 SUPER COELHO 13 907601 SUPER COELHO 06 907602 SUPER COELHO 05 907619 SUPER COELHO 10 907620 SUPER COELHO 11 907621 SUP COELHO LJ 03 908334 SUP COELHO LJ 14 908354 SUP COELHO DINIZ 908355 SUPER COELHO 04 908446 SUP COELHO LJ 02 908711"},{"id":"690a50a8-148b-4643-64a9-08d5ad2bf6ba","name":"CONDOMINIO GV SHOPPING","commercialName":"GV SHOPPING","cnpj":"03523170000149","city":"GOVERNADOR VALADARES","stateCode":"MG","buscaAdicional":"GVSHOPPING 56147 CONDOMINIO GV SHOPPI 905866"},{"id":"123d713f-757b-448f-6074-08d5ad2bf6ba","name":"BIG MAIS SUPERMERCADOS LTDA","commercialName":"BIG MAIS SUPERMERCADOS","cnpj":"07263762000120","city":"GOVERNADOR VALADARES","stateCode":"MG","buscaAdicional":"BIG MAIS 53515 LOJA 4 - LAGOA SANTA 905882 DEPOSITO CENTRAL L3 905883 ALTINOPOLIS - LOJA 5 905884 TREZE DE MAIO LOJA 2 908715"},{"id":"be58147f-1f3c-4eff-5f70-08d5ad2bf6ba","name":"ABC ARTEFATOS DE BORRACHA COELHO LTDA","commercialName":"ABC","cnpj":"18422469000184","city":"GOVERNADOR VALADARES","stateCode":"MG","buscaAdicional":"ABC BORRACHA 52957 ABC BORRACHA 904106"},{"id":"547d166a-a9d7-4ca6-5912-08d5ad2bf6ba","name":"INDUSTRIAS TUDOR M. G. DE BATERIAS LTDA","commercialName":"","cnpj":"20278271000110","city":"GOVERNADOR VALADARES","stateCode":"MG","buscaAdicional":"TUDORMG 13673 TUDOR MG 894886"},{"id":"6ded772f-b1cf-487c-5373-08d5ad2bf6ba","name":"BARBOSA & MARQUES S A","commercialName":"","cnpj":"19273747000141","city":"GOVERNADOR VALADARES","stateCode":"MG","buscaAdicional":"BARBOSA 3639 BARBOSA E MARQUES 71173 BARBOSA FILIAL 905322"},{"id":"3444af7e-1f4d-4ca0-5851-08d5ad2bf6ba","name":"ANJOS ENERGETICA LTDA","commercialName":"ANJOS ENERGETICA","cnpj":"11934933000172","city":"GUARACIABA","stateCode":"MG","buscaAdicional":"CGH ANJOS 11350 ANJOS 891507 CGH.PH.MG.031130-8.01"},{"id":"c8296d50-155f-4789-5a0a-08d5ad2bf6ba","name":"RP GERADORA DE ENERGIA ELETRICA LTDA","commercialName":"RP GERADORA DE ENERGIA ELETRICA","cnpj":"21553997000187","city":"GUARANÉSIA","stateCode":"MG","buscaAdicional":"RP ENERGIA 16384 SANTA CLEONICE 889553 CGH.PH.MG.029216-8.01"},{"id":"b48460f0-a620-401e-542c-08d5ad2bf6ba","name":"JF PASQUA CONDUTORES ELETRICOS LTDA","commercialName":"","cnpj":"03981899000169","city":"GUAXUPÉ","stateCode":"MG","buscaAdicional":"JF PASQUA EI 4045 JF PASQUA 72443"},{"id":"fa84a2e1-33db-4bd0-518e-08d5ad2bf6ba","name":"COOPERATIVA REGIONAL DE CAFEICULTORES EM GUAXUPE LTDA COOXUPE","commercialName":"COOXUPE","cnpj":"20770566000100","city":"GUAXUPÉ","stateCode":"MG","buscaAdicional":"COOXUPE 2371 COOP CAFEIC GUAXUPE 70570 COOXUPE MONTE CARMEL 891464 COOXUPE JAPY 891466"},{"id":"4a00b548-dd0a-43a5-504a-08d5ad2bf6ba","name":"TEXTILNOVA FIACAO LTDA","commercialName":"","cnpj":"60182904000107","city":"GUAXUPÉ","stateCode":"MG","buscaAdicional":"KDB FIACAO 1559 KDB FIACAO GUAXUPE 70414"},{"id":"c6eb8e94-eab6-4e4d-59cf-08d5ad2bf6ba","name":"THYSSENKRUPP BRASIL LTDA.","commercialName":"","cnpj":"47366273001190","city":"IBIRITÉ","stateCode":"MG","buscaAdicional":"THYSSENKRUPP BRASIL MG 15616 THYSSEN BILST MOLAS 71049"},{"id":"b114f332-91b3-40d0-888d-08d5ae44ed50","name":"COSMA DO BRASIL PRODUTOS E SERVICOS AUTOMOTIVOS LTDA.","commercialName":"","cnpj":"02591818000909","city":"IBIRITÉ","stateCode":"MG","buscaAdicional":"COSMA MG 12992"},{"id":"d65b2696-6353-4c31-522f-08d5ad2bf6ba","name":"FORNAC LTDA","commercialName":"","cnpj":"01040520000271","city":"IGARAPÉ","stateCode":"MG","buscaAdicional":"FORNAC 2915 FORNAC 70782"},{"id":"491fbce9-29be-4fac-5cf5-08d5ad2bf6ba","name":"SERTEX FIACAO E TECELAGEM LTDA","commercialName":"FIACAO E TECELAGEM INIMUTABA","cnpj":"03126940000110","city":"INIMUTABA","stateCode":"MG","buscaAdicional":"SERTEX 51631 SERTEX - FABRICA 899369"},{"id":"82798c0f-34d5-4ebe-5e93-08d5ad2bf6ba","name":"CIPALAM INDUSTRIA E COMERCIO DE LAMINADOS LTDA","commercialName":"CIPALAM INDUSTRIA E COMERCIO DE LAMINADOS LTDA","cnpj":"06943259000152","city":"IPATINGA","stateCode":"MG","buscaAdicional":"CIPALAM 52452 CIPALAM III ACIARIA 902985 CIPALAM MATRIZ MG 903053 CIPALAM II LAMINACAO 902986"},{"id":"cad7a31f-61b6-436a-608a-08d5ad2bf6ba","name":"FUNDACAO SAO FRANCISCO XAVIER","commercialName":"HOSPITAL MARCIO CUNHA","cnpj":"19878404000100","city":"IPATINGA","stateCode":"MG","buscaAdicional":"HOSPITAL MARCIO CUNHA 53582 HOSP MARCIO CUNHA 1 904758 HOSP MARCIO CUNHA 2 904759"},{"id":"7d1f3310-ae32-4506-5c5d-08d5ad2bf6ba","name":"PCH DORES DE GUANHAES S.A.","commercialName":"","cnpj":"18471058000189","city":"IPATINGA","stateCode":"MG","buscaAdicional":"PCH DORES DE GUANHAES 51285"},{"id":"75d2a7df-827b-48bc-5c5e-08d5ad2bf6ba","name":"PCH SENHORA DO PORTO S.A.","commercialName":"","cnpj":"18471070000193","city":"IPATINGA","stateCode":"MG","buscaAdicional":"PCH SENHORA DO PORTO 51286"},{"id":"50294be8-2023-4aeb-5c5f-08d5ad2bf6ba","name":"PCH FORTUNA II S.A.","commercialName":"","cnpj":"18471053000156","city":"IPATINGA","stateCode":"MG","buscaAdicional":"PCH FORTUNA II 51287"},{"id":"7380cee1-7383-49cf-5c60-08d5ad2bf6ba","name":"PCH JACARE S.A.","commercialName":"","cnpj":"18471064000136","city":"IPATINGA","stateCode":"MG","buscaAdicional":"PCH JACARE 51288"},{"id":"8ea0b94c-5c9e-4ac1-6932-08d5ad2bf6ba","name":"UNIMED VALE DO ACO COOPERATIVA DE TRABALHO MEDICO","commercialName":"","cnpj":"16991945000152","city":"IPATINGA","stateCode":"MG","buscaAdicional":"UNIMED VALE DO ACO 60837 UNIMED NED 911990 UNIMED HMU 912011"},{"id":"369fd374-f159-4fbe-6854-08d5ad2bf6ba","name":"FUNDACAO EDUCACIONAL SAO FRANCISCO XAVIER","commercialName":"COLEGIO SAO FRANCISCO XAVIER - UNIDADE I","cnpj":"11508880000128","city":"IPATINGA","stateCode":"MG","buscaAdicional":"CSFX 59810 FSFX 904757"},{"id":"5385a3cf-cfcf-4c2e-674e-08d5ad2bf6ba","name":"COOPERATIVA DE CONSUMO DOS EMPREGADOS DA USIMINAS LTDA","commercialName":"","cnpj":"19860683000185","city":"IPATINGA","stateCode":"MG","buscaAdicional":"CONSUL 58036 CONSUL INDUSTRIAL 908458 CONSUL CARIRU 908460 CONSUL IDEAL 908484"},{"id":"54249433-8a1b-473f-6321-08d5ad2bf6ba","name":"CONDOMINIO DO CONJUNTO DO SHOPPING DO VALE DO ACO","commercialName":"CONDOMINIO DO VALE DO ACO","cnpj":"02632185000182","city":"IPATINGA","stateCode":"MG","buscaAdicional":"SHOPPING VALE DO ACO 55179 SHOP VALE DO ACO 905368 SHOP VALE DO ACO 1 905680"},{"id":"1fd20016-6b1f-4e39-6279-08d5ad2bf6ba","name":"BELMONT MINERACAO LTDA","commercialName":"","cnpj":"16941833000197","city":"ITABIRA","stateCode":"MG","buscaAdicional":"BELMONT 54771 BELMONT MINERACAO LT 906502"},{"id":"7301fe67-cdda-4fa4-5b15-08d5ad2bf6ba","name":"FERMAG FERRITAS MAGNETICAS LTDA","commercialName":"FERMAG","cnpj":"19160126000151","city":"ITABIRA","stateCode":"MG","buscaAdicional":"FERMAG 50456 FERMAG 900663"},{"id":"005ae8bb-9158-458f-585e-08d5ad2bf6ba","name":"CENTRAL GERADORA HIDRELETRICA BRACAO LTDA","commercialName":"CGH BRACAO","cnpj":"17132700000132","city":"ITABIRITO","stateCode":"MG","buscaAdicional":"CGH BRACAO 11529 BRACAO 909813 CGH.PH.MG.031023-9.0"},{"id":"7d2bf2ee-5e0e-4854-6193-08d5ad2bf6ba","name":"SIDERURGICA ITABIRITO LTDA","commercialName":"SIDERURGICA ITABIRITO","cnpj":"02702798000149","city":"ITABIRITO","stateCode":"MG","buscaAdicional":"SIDERURGICA ITABIRITO 54246 SIDERURGICA ITABIRIT 905320"},{"id":"4fe147f5-0b7f-468e-671b-08d5ad2bf6ba","name":"IRMAOS FARID LTDA","commercialName":"CASA DA CONCORRENCIA","cnpj":"21000468000156","city":"ITABIRITO","stateCode":"MG","buscaAdicional":"FARID 57962 FARID MATRIZ 911987 FARID CACHOEIRA 911988 FARID BEIRA RIO 911989 FARID PRAIA 911992"},{"id":"6dcf59ec-6119-4f1a-63e6-08d5ad2bf6ba","name":"APP RECICLAGEM DE PLASTICOS LTDA","commercialName":"APP RECICLAGEM DE PLASTICOS","cnpj":"05906993000189","city":"ITAGUARA","stateCode":"MG","buscaAdicional":"APP RECICLAGEM 55710 APP RECICLAGEM DE PL 906545"},{"id":"f56e005d-e9bc-4e2a-61d8-08d5ad2bf6ba","name":"HELICOPTEROS DO BRASIL S/A","commercialName":"HELIBRAS","cnpj":"20367629000181","city":"ITAJUBÁ","stateCode":"MG","buscaAdicional":"HELIBRAS 54446 HELICOPTEROS DO BR 904957"},{"id":"c6742638-2ff6-4956-678e-08d5ad2bf6ba","name":"BALTEAU PRODUTOS ELETRICOS LTDA.","commercialName":"","cnpj":"13434970000147","city":"ITAJUBÁ","stateCode":"MG","buscaAdicional":"BALTEAU 58276 BALTEAU 908376"},{"id":"65c80686-38d6-4aa5-65a3-08d5ad2bf6ba","name":"GERMINIANI - RACOES E ALIMENTOS LTDA","commercialName":"RACOES GERMINIANI","cnpj":"15722207000147","city":"ITAJUBÁ","stateCode":"MG","buscaAdicional":"GERMINIANI 56896 GERMINIANI RACOES 909740"},{"id":"0aa81ea1-4a7a-4800-522a-08d5ad2bf6ba","name":"SAFIRA TRADING DE ENERGIA LTDA","commercialName":"","cnpj":"10938805000134","city":"ITAJUBÁ","stateCode":"MG","buscaAdicional":"SAFIRA TRADING 2901"},{"id":"a07c51d8-b774-4c9b-52c6-08d5ad2bf6ba","name":"GRID SOLUTIONS TRANSMISSAO DE ENERGIA LTDA","commercialName":"","cnpj":"05356949000223","city":"ITAJUBÁ","stateCode":"MG","buscaAdicional":"GE ALSTOM ITAJUBA 3284 AREVA ITAJUBA MG 71001"},{"id":"83cdb632-b12e-421d-5487-08d5ad2bf6ba","name":"MAHLE METAL LEVE S.A.","commercialName":"","cnpj":"60476884001582","city":"ITAJUBÁ","stateCode":"MG","buscaAdicional":"MAHLE ITA 4324 MAHLE ITAJUBA 7665"},{"id":"1e1ca674-da47-4912-56dc-08d5ad2bf6ba","name":"FRIGORIFICO VALE DO SAPUCAI LTDA","commercialName":"FRIVASA","cnpj":"01702122000192","city":"ITAJUBÁ","stateCode":"MG","buscaAdicional":"FRIVASA 7862 FRIVASA ITAJUBA 72349"},{"id":"199cd6eb-47db-46bb-51c5-08d5ad2bf6ba","name":"SADA BIO-ENERGIA E AGRICULTURA LTDA","commercialName":"","cnpj":"06044698000123","city":"ITAMARANDIBA","stateCode":"MG","buscaAdicional":"SADA BIO-ENERG 2581 SADA BIO - CONSUMO 899629 SAO JUDAS TADEU 8503 UTE.AI.MG.029759-3.01"},{"id":"89824879-74cd-4ffc-50d4-08d5ad2bf6ba","name":"VALFILM - MG INDUSTRIA DE EMBALAGENS LTDA","commercialName":"VALFILM - MG","cnpj":"07183852000100","city":"ITAMONTE","stateCode":"MG","buscaAdicional":"VALFILM 1865 VALFILM ITAMONTE 70275"},{"id":"90875098-fc4a-484d-61a3-08d5ad2bf6ba","name":"REFRIGERANTES ITAMONTE LTDA","commercialName":"","cnpj":"18623157000139","city":"ITAMONTE","stateCode":"MG","buscaAdicional":"REFRIGERANTES ITAMONTE 54308 REFRI MANTIQUEIRA FL 907777 REFRI MANTIQUEIRA FB 907778"},{"id":"24a85959-26be-41fe-621e-08d5ad2bf6ba","name":"VAL-BAGS INDUSTRIA E COMERCIO DE PLASTICOS LTDA","commercialName":"","cnpj":"07383192000373","city":"ITAMONTE","stateCode":"MG","buscaAdicional":"VAL-BAGS 54573 VAL-BAGS 905280"},{"id":"2d808804-0a11-48ce-61f8-08d5ad2bf6ba","name":"E S INDUSTRIA E COMERCIO DE PLASTICOS LTDA","commercialName":"E S INDUSTRIA E COMERCIO","cnpj":"07375605000106","city":"ITANHANDU","stateCode":"MG","buscaAdicional":"ES PLASTICOS 54489 ES INDUSTRIA 904958"},{"id":"b8800131-173a-4a23-5d6d-08d5ad2bf6ba","name":"MANTIQUEIRA ALIMENTOS LTDA.","commercialName":"","cnpj":"04747794000102","city":"ITANHANDU","stateCode":"MG","buscaAdicional":"GRANJA MANTIQUEIRA 51816 GRAN MANTIQUEIRA MT 899731"},{"id":"c2aa96c7-98f2-41e1-5de1-08d5ad2bf6ba","name":"ASPERBRAS ALIMENTOS LACTEOS S.A","commercialName":"","cnpj":"12361072000143","city":"ITAPAGIPE","stateCode":"MG","buscaAdicional":"ASPERBRASMG 52055 ASPERBRAS ALIMENTOS 901496"},{"id":"52840853-f960-4a0b-5e7e-08d5ad2bf6ba","name":"NACIONAL DE GRAFITE LTDA","commercialName":"GRAFITE","cnpj":"21228861000100","city":"ITAPECERICA","stateCode":"MG","buscaAdicional":"GRAFITE 52402 NACIONAL DE GRAFITE 900639 GRAFITE SALTO DA DIV 901359 GRAFITE PEDRA AZUL 901375"},{"id":"dcec5385-2e74-473b-5897-08d5ad2bf6ba","name":"PAPI TEXTIL LTDA","commercialName":"","cnpj":"18309666000191","city":"ITAÚNA","stateCode":"MG","buscaAdicional":"PAPI TEXTIL 12572 IMFRAL MIRAI 72352 PAPI TEXTIL 893542"},{"id":"c5587c37-5c4b-4537-4f6d-08d5ad2bf6ba","name":"SAINT-GOBAIN CANALIZACAO LTDA","commercialName":"BARBARA","cnpj":"28672087007507","city":"ITAÚNA","stateCode":"MG","buscaAdicional":"SGOBAIN CAN 1097 SAINT GLOBAN ITAUNA 7607"},{"id":"12f75ce9-3e11-4d0f-4f5a-08d5ad2bf6ba","name":"INTERCAST S/A","commercialName":"","cnpj":"02326750000183","city":"ITAÚNA","stateCode":"MG","buscaAdicional":"INTERCAST 1066 INTERCAST-ITAUNA-MG 7713"},{"id":"3ef46cee-a42d-49ec-4f41-08d5ad2bf6ba","name":"CMU ENERGIA LTDA","commercialName":"CMU COMERCIALIZADORA DE ENERGIA","cnpj":"05827554000180","city":"ITAÚNA","stateCode":"MG","buscaAdicional":"CMU 155 SELECTA 8831 UTE.AI.MG.030450-6.01"},{"id":"f0891529-3c63-4b3a-5231-08d5ad2bf6ba","name":"INCOMFRAL - INDUSTRIA E COMERCIO DE FRALDAS LTDA","commercialName":"","cnpj":"17245051000186","city":"ITAÚNA","stateCode":"MG","buscaAdicional":"INCOMFRAL 2917 INCOMFRAL 70772"},{"id":"b0c4d259-b650-40ad-5297-08d5ad2bf6ba","name":"TECELAGEM MINASREY LTDA","commercialName":"","cnpj":"41847658000110","city":"ITAÚNA","stateCode":"MG","buscaAdicional":"MINASREY 3164 TECELAGEM MINAS REY 70913"},{"id":"ee1f6247-96ed-4161-5280-08d5ad2bf6ba","name":"MAGNETI MARELLI COMPONENTES PLASTICOS LTDA.","commercialName":"","cnpj":"01111971000171","city":"ITAÚNA","stateCode":"MG","buscaAdicional":"ERGOM 3095 ERGOM ITAUNA 70882"},{"id":"13671a69-07a6-4973-526e-08d5ad2bf6ba","name":"PERIPAN INDUSTRIAL LTDA","commercialName":"","cnpj":"16768319000100","city":"ITAÚNA","stateCode":"MG","buscaAdicional":"PERIPAN 3055 PERIPAN 904294"},{"id":"66b97e60-afc6-4d4a-67a6-08d5ad2bf6ba","name":"CURTIDORA ITAUNA LIMITADA","commercialName":"","cnpj":"21253596000101","city":"ITAÚNA","stateCode":"MG","buscaAdicional":"CIL 58395 CURTIDORA ITAUNA 908789"},{"id":"d33faab8-dba6-41dd-4f12-08d5d159243d","name":"COMPANHIA INDUSTRIAL ITAUNENSE - EM RECUPERACAO JUDICIAL","commercialName":"SEDE","cnpj":"21254073000180","city":"ITAÚNA","stateCode":"MG","buscaAdicional":""},{"id":"84cf7a3c-2a92-4f21-8db5-08d5d060706e","name":"B.S. ENERGIA RENOVAVEL LTDA","commercialName":"","cnpj":"02994298000128","city":"ITAÚNA","stateCode":"MG","buscaAdicional":"B.S. ENERGIA RENOVAVEL 63252"},{"id":"99655896-e2a1-4382-51f2-08d5ad2bf6ba","name":"BP BIOENERGIA ITUIUTABA LTDA.","commercialName":"","cnpj":"08164344000148","city":"ITUIUTABA","stateCode":"MG","buscaAdicional":"BP ITT 2734 ITUIUTABA (CNAA) 72331 ITUIUTABA 8686 UTE.AI.MG.030094-2.01"},{"id":"28c0bc41-ff06-4299-5072-08d5ad2bf6ba","name":"CORURIPE ENERGETICA S.A.","commercialName":"","cnpj":"04808949000173","city":"ITURAMA","stateCode":"MG","buscaAdicional":"CORURIPE ENERGETICA 1632 CORURIPE ITURAMA 8208 UTE.AI.MG.028479-3.01 ENERGETICA C FLORIDO 8370 UTE.AI.MG.029703-8.01"},{"id":"ce13bcef-2b79-4bf6-66f5-08d5ad2bf6ba","name":"INCOMFIO LTDA","commercialName":"","cnpj":"17352063000100","city":"JACUTINGA","stateCode":"MG","buscaAdicional":"INCOMFIO 57900 INCOMFIO 908839"},{"id":"d11d7c73-4e13-49e1-6297-08d5ad2bf6ba","name":"CONDUTEC INDUSTRIA DE MATERIAIS FERROVIARIOS EIRELI","commercialName":"CONDUTEC SOLUCOES EM FIXACAO","cnpj":"66278680000118","city":"JACUTINGA","stateCode":"MG","buscaAdicional":"CONDUTEC 54811 CONDUTEC 905898"},{"id":"f9efee4c-9e8a-4b4e-6426-08d5ad2bf6ba","name":"MINAS PACK FILMES E EMBALAGENS LTDA","commercialName":"AZUL PACK","cnpj":"19500329000140","city":"JACUTINGA","stateCode":"MG","buscaAdicional":"MINAS PACK 55858 MINAS PACK 905892"},{"id":"b28a77ad-be96-4b6f-6536-08d5ad2bf6ba","name":"OLGA ALUMINIO LTDA.","commercialName":"","cnpj":"03105276000122","city":"JACUTINGA","stateCode":"MG","buscaAdicional":"OLGA ALUMINIO 56592 OLGA ALUMINIO MG 908256"},{"id":"4b257f7e-59a0-4f47-5f85-08d5ad2bf6ba","name":"MINERVA S.A.","commercialName":"MINERVA S.A.","cnpj":"67620377006155","city":"JANAÚBA","stateCode":"MG","buscaAdicional":"MINERVA JNB 53010 MINERVA 904486"},{"id":"f18d386d-bcde-4148-5a3f-08d5ad2bf6ba","name":"FCR VII USINA DE ENERGIA FOTOVOLTAICA LTDA","commercialName":"ENERGIA SOLAR GOIAS-GOIASSOL-USINA DE ENER FOTOVOLTAICA","cnpj":"20589037000104","city":"JANUÁRIA","stateCode":"MG","buscaAdicional":"FCR III ITAPURANGA 17236"},{"id":"8aba6f50-c7e1-4cce-56e5-08d5ad2bf6ba","name":"VALLOUREC SOLUCOES TUBULARES DO BRASIL S.A.","commercialName":"","cnpj":"08689024000292","city":"JECEABA","stateCode":"MG","buscaAdicional":"VSB JECEABA 7920 VSB JECEABA 71169"},{"id":"0a8218b5-d57e-4f6f-65ee-08d5ad2bf6ba","name":"ORGANIZACAO DE CEREAIS MONLEVADE LTDA","commercialName":"","cnpj":"18107045000125","city":"JOÃO MONLEVADE","stateCode":"MG","buscaAdicional":"COMERCIAL MONLEVADE 57212 HIPER MONLEVADE 907942 SUPER MONLEVADE 907966"},{"id":"e08ab625-b068-48ed-56be-08d5ad2bf6ba","name":"CENTRAL BIOENERGETICA ENERVALE S/A","commercialName":"","cnpj":"10511512000176","city":"JOÃO PINHEIRO","stateCode":"MG","buscaAdicional":"ENERVALE 7581 ENERVALE CONSUMO 72342 ENERVALE 20068 UTE.AI.MG.030850-1.01"},{"id":"31060f9b-e334-4764-51d8-08d5ad2bf6ba","name":"BIOENERGETICA VALE DO PARACATU SA","commercialName":"BIOENERGETICA VALE DO PARACATU SA","cnpj":"08793343000162","city":"JOÃO PINHEIRO","stateCode":"MG","buscaAdicional":"BEVAP 2621 V.PARACATU-BEVAP 8660 UTE.AI.MG.030063-2.01"},{"id":"0063c1ab-3670-4e01-5c1c-08d5ad2bf6ba","name":"WD AGROINDUSTRIAL LTDA","commercialName":"","cnpj":"01105558000102","city":"JOÃO PINHEIRO","stateCode":"MG","buscaAdicional":"UTE WD 51090 UTE WD 909069 UTE.AI.MG.029122-6.01"},{"id":"998fbf35-fb15-4035-5de8-08d5ad2bf6ba","name":"S RIKO AUTOMOTIVE HOSE DO BRASIL LTDA","commercialName":"SRK-HDB","cnpj":"02236908000124","city":"JUATUBA","stateCode":"MG","buscaAdicional":"DYTECH DO BRASIL 52064 DYTECH DO BRASIL 899061"},{"id":"c4ea6f0a-1ac8-4158-5d46-08d5ad2bf6ba","name":"S RIKO AUTOMOTIVE HOSE TECALON BRASIL S.A.","commercialName":"SRK-HTB","cnpj":"60689346000170","city":"JUATUBA","stateCode":"MG","buscaAdicional":"DYTECH 51755 DYTECH FILIAL 898678 DYTECH MATRIZ 898697"},{"id":"cb12a02e-42cd-4cfb-5548-08d5ad2bf6ba","name":"INOVA BIOTECNOLOGIA SAUDE ANIMAL LTDA","commercialName":"","cnpj":"08109685000110","city":"JUATUBA","stateCode":"MG","buscaAdicional":"INOVABIO 5248 INOVA BIO - BH 72242"},{"id":"1c0e4e98-7383-47a8-6957-08d5ad2bf6ba","name":"TIBERINA AUTOMOTIVE MG - COMPONENTES METALICOS PARA INDUSTRIA AUTOMOTIVA LTDA.","commercialName":"","cnpj":"11812870000262","city":"JUATUBA","stateCode":"MG","buscaAdicional":"TIBERINA 61061 TIBERINA 911326"},{"id":"a48dfbec-c787-43ee-6360-08d5ad2bf6ba","name":"CEVA VETERINARIA S/A","commercialName":"","cnpj":"07086487000116","city":"JUATUBA","stateCode":"MG","buscaAdicional":"HERTAPE 55330 HERTAPE 904239"},{"id":"08d20d43-9172-4066-6472-08d5ad2bf6ba","name":"PAPELEIRA SANTA RITA LTDA","commercialName":"","cnpj":"10671781000108","city":"JUIZ DE FORA","stateCode":"MG","buscaAdicional":"PAPELEIRA SANTA RITA 56008 PAPELEIRA SANTA RITA 904961"},{"id":"8498d4ef-70cd-4f1d-62a3-08d5ad2bf6ba","name":"CONDOMINIO DO SHOPPING JARDIM NORTE","commercialName":"","cnpj":"24518364000126","city":"JUIZ DE FORA","stateCode":"MG","buscaAdicional":"JARDIM NORTE 54842 COND SHOP JARDIM N 904453"},{"id":"d37190bb-0aa0-467b-8888-08d5ae44ed50","name":"MONTE VERDE ENERGIA S/A","commercialName":"","cnpj":"15282554000104","city":"JUIZ DE FORA","stateCode":"MG","buscaAdicional":"CGH MONTE VERDE 11151 MONTE VERDE (CGH) 890392 CGH.PH.MG.031089-1.01"},{"id":"052f01d6-b552-4e7e-68a9-08d5ad2bf6ba","name":"INSTITUTO DE CLINICAS E CIRURGIA DE JUIZ DE FORA LTDA","commercialName":"","cnpj":"25415993000193","city":"JUIZ DE FORA","stateCode":"MG","buscaAdicional":"HMS 60262 HMS 911111"},{"id":"0080d8b0-9ce2-4c79-67ca-08d5ad2bf6ba","name":"CODEME ENGENHARIA S/A","commercialName":"","cnpj":"16521601000694","city":"JUIZ DE FORA","stateCode":"MG","buscaAdicional":"CODEME 58638 CODEME ENGENHARIA 911727"},{"id":"c0807375-02c1-4d4b-6736-08d5ad2bf6ba","name":"HOSPITAL ALBERT SABIN LTDA","commercialName":"","cnpj":"17268871000193","city":"JUIZ DE FORA","stateCode":"MG","buscaAdicional":"HAS 58004 HAS 910013"},{"id":"07cdefb2-58e2-4f44-4ed7-08d5d159243d","name":"INTER CONSTRUTORA E INCORPORADORA S.A","commercialName":"","cnpj":"09611768000176","city":"JUIZ DE FORA","stateCode":"MG","buscaAdicional":""},{"id":"b9eb11a0-e81b-468c-520b-08d5ad2bf6ba","name":"CONDOMINIO DO INDEPENDENCIA SHOPPING","commercialName":"","cnpj":"09462547000183","city":"JUIZ DE FORA","stateCode":"MG","buscaAdicional":"INDEPEND SHOP 2822 SHOP INDEPEND LIVRE 70578"},{"id":"7c10135a-d744-4ff5-5125-08d5ad2bf6ba","name":"BECTON DICKINSON INDUSTRIAS CIRURGICAS LTDA","commercialName":"","cnpj":"21551379000106","city":"JUIZ DE FORA","stateCode":"MG","buscaAdicional":"BD 2022 BD MTZ JUIZ DE FORA 70397"},{"id":"776c96f4-0750-4495-512a-08d5ad2bf6ba","name":"ZONA DA MATA GERACAO S/A","commercialName":"","cnpj":"04677733000116","city":"JUIZ DE FORA","stateCode":"MG","buscaAdicional":"ZONA DA MATA 2029 CACH. DO EMBOQUE 8032 UHE.PH.MG.000473-1.01 SANTA CECILIA 8157 CGH.PH.MG.027928-5.01 MIGUEL PEREIRA 8158 CGH.PH.MG.001462-1.01 MATIPO 8159 CGH.PH.MG.001438-9.01 ROCA GRANDE 8231 CGH.PH.MG.002535-6.01 CACHOEIRA ALTA 8232 CGH.PH.MG.000404-9.01 MAURICIO 8233 CGH.PH.MG.001446-0.01"},{"id":"23b79b0a-e24e-4f44-4f67-08d5ad2bf6ba","name":"MERCEDES-BENZ DO BRASIL LTDA.","commercialName":"","cnpj":"59104273003730","city":"JUIZ DE FORA","stateCode":"MG","buscaAdicional":"MERCEDES-BENZ 1087 DAIMLER JUIZ DE FORA 7703"},{"id":"b89bfa6a-7856-4689-4f87-08d5ad2bf6ba","name":"INDUSTRIA DE PAPEIS SUDESTE LTDA","commercialName":"","cnpj":"02886413000493","city":"JUIZ DE FORA","stateCode":"MG","buscaAdicional":"PAPEIS SUDESTE 1145 PAPEIS SUDESTE JF 7795"},{"id":"7f612f54-d2c3-49a1-5c94-08d5ad2bf6ba","name":"S A FABRICA DE TECIDOS SAO JOAO EVANGELISTA","commercialName":"SAO JOAO EVANGELISTA","cnpj":"21555008000194","city":"JUIZ DE FORA","stateCode":"MG","buscaAdicional":"SAOJOAOEVANGELISTA 51388 SAO JOAO EVANGELISTA 898785"},{"id":"4dae43fb-d709-43ff-5ca9-08d5ad2bf6ba","name":"AG PET INDUSTRIA DE EMBALAGENS LTDA.","commercialName":"","cnpj":"07078130000196","city":"JUIZ DE FORA","stateCode":"MG","buscaAdicional":"AG PET 51481 AG PET MG 898534"},{"id":"36f4e647-de2d-402f-5cab-08d5ad2bf6ba","name":"SUPERMERCADO BAHAMAS S/A","commercialName":"","cnpj":"17745613000150","city":"JUIZ DE FORA","stateCode":"MG","buscaAdicional":"BAHAMAS 51494 BAHAMAS LJ 036 899169 BAHAMAS LJ 032 899170 BAHAMAS LJ 041 899190 SUPER BAHAMAS LJ 8 899764 BAHAMAS LOJA 06 899776 SUPER BAHAMAS MATRIZ 899782 BAHAMAS LJ 26 900080 BAHAMAS LJ 15 900081 BAHAMAS LJ 28 900097 BAHAMAS LJ 21 900113 BAHAMAS LJ 07 900114 BAHAMAS LJ 24 900931 BAHAMAS LJ 29 900961 BAHAMAS LJ 17 904909 BAHAMAS LJ 23 904910 BAHAMAS LJ 40 904977 BAHAMAS LJ 35 904979 BAHAMAS LJ 42 904981 BAHAMAS LJ 34 904982 BAHAMAS LJ 30 904999 BAHAMAS 39 909203"},{"id":"a647433a-e05e-45ff-5dbb-08d5ad2bf6ba","name":"EPM EMBALAGENS DE POLPA MOLDADA LTDA","commercialName":"","cnpj":"08578991000104","city":"JUIZ DE FORA","stateCode":"MG","buscaAdicional":"EPM 51970 EPM 899320"},{"id":"5bc07391-ce89-403e-5c65-08d5ad2bf6ba","name":"ESDEVA INDUSTRIA GRAFICA LTDA.","commercialName":"","cnpj":"17153081000162","city":"JUIZ DE FORA","stateCode":"MG","buscaAdicional":"ESDEVA 51297 ESDEVA 900694"},{"id":"f5766fab-1b26-46bb-5849-08d5ad2bf6ba","name":"VALORGAS - ENERGIA E BIOGAS SPE LTDA","commercialName":"","cnpj":"15348536000170","city":"JUIZ DE FORA","stateCode":"MG","buscaAdicional":"VALORGAS 11213 CTR JUIZ DE FORA 890957 UTE.RU.MG.031206-1.01"},{"id":"d24890e1-2e30-4022-5271-08d5ad2bf6ba","name":"EMBARE INDUSTRIAS ALIMENTICIAS S/A","commercialName":"ESTABELECIMENTO UNIFICADO","cnpj":"21992946000151","city":"LAGOA DA PRATA","stateCode":"MG","buscaAdicional":"EMBARE 3061 EMBARE 70841"},{"id":"f3d2e3be-374d-4fb4-5975-08d5ad2bf6ba","name":"MARANGONI TREAD LATINO AMERICA INDUSTRIA E COMERCIO DE ARTEFATOS DE BORRACHA LTDA - EM RECUPERACAO JUDICIAL","commercialName":"MARANGONI TREAD LATINO AMERICA","cnpj":"02551474000157","city":"LAGOA SANTA","stateCode":"MG","buscaAdicional":"MARANGONI 14555 MARANGONI 893682"},{"id":"342621da-6875-439b-5cfa-08d5ad2bf6ba","name":"INJESUL PLASTICOS INDUSTRIA E COMERCIO LTDA","commercialName":"","cnpj":"21063839000149","city":"LAMBARI","stateCode":"MG","buscaAdicional":"INJESUL 51639 INJESUL PLASTICOS 899710"},{"id":"f0eaafd8-dac5-4385-1ccd-08d5b8870181","name":"CICLOPE COMPONENTES AUTOMOTIVOS LTDA","commercialName":"CICLOPE AUTOMOTIVE","cnpj":"71337356000163","city":"LAVRAS","stateCode":"MG","buscaAdicional":"CICLOPE 61750 CICLOPE 912795"},{"id":"23d9b30a-a4cd-4f76-888a-08d5ae44ed50","name":"TRW AUTOMOTIVE LTDA","commercialName":"T R W","cnpj":"60857349000842","city":"LAVRAS","stateCode":"MG","buscaAdicional":"TRW LAVRAS 12395 TRW LAVRAS 891862"},{"id":"ef4f5df4-1fc9-47e4-68df-08d5ad2bf6ba","name":"J.A.C INDUSTRIA E COMERCIO DE ALIMENTOS LTDA","commercialName":"JEITO CASEIRO ALIMENTOS","cnpj":"07874295000174","city":"LAVRAS","stateCode":"MG","buscaAdicional":"JEITO CASEIRO ALIMENTOS 60518 JEITO CASEIRO 911698"},{"id":"d59186e8-b3db-4927-597e-08d5ad2bf6ba","name":"APA CONFECCOES LTDA","commercialName":"","cnpj":"33835497000389","city":"LEOPOLDINA","stateCode":"MG","buscaAdicional":"APA CONFECCOES 14616 APA CONFECCOES 893824"},{"id":"850ac99d-ba2b-45c1-5287-08d5ad2bf6ba","name":"RIO BRANCO ALIMENTOS S/A","commercialName":"PIF PAF","cnpj":"05017780002301","city":"LEOPOLDINA","stateCode":"MG","buscaAdicional":"PIFPAF LEO 3107 PIFPAF LEO 70919"},{"id":"40e0d20f-c09f-4dcd-56ac-08d5ad2bf6ba","name":"COOP DOS PRODUTORES DE LEITE DE LEOPOLDINA DE RESP LTDA","commercialName":"COOPERATIVA DE LEOPOLDINA","cnpj":"22149603000192","city":"LEOPOLDINA","stateCode":"MG","buscaAdicional":"LEITE LAC 7500 LEITE LAC-LEOPOLDINA 72273"},{"id":"18cdd5b9-bad0-426f-63aa-08d5ad2bf6ba","name":"INDUSTRIA MINEIRA DE RACOES LTDA","commercialName":"VITAMINAS RACOES","cnpj":"07525287000112","city":"LUZ","stateCode":"MG","buscaAdicional":"VITAMINAS 55507 VITAMINAS 907195"},{"id":"a9a9483b-c096-4442-5e14-08d5ad2bf6ba","name":"PASTIFICIO SANTA AMALIA S/A.","commercialName":"","cnpj":"22229207000175","city":"MACHADO","stateCode":"MG","buscaAdicional":"PSTAMALIA 52190 PASTIFICIO STA AMALI 900835"},{"id":"dc8a60f8-f466-452c-5ce4-08d5ad2bf6ba","name":"ARMAZENS GERAIS LESTE DE MINAS LIMITADA","commercialName":"","cnpj":"17370354000120","city":"MANHUAÇU","stateCode":"MG","buscaAdicional":"AGL MINAS 51604 AGL VARGINHA 903037 AGL MANHUACU 904061 AGL PATROCINIO 911985"},{"id":"82d9fa0f-3362-499d-5503-08d5ad2bf6ba","name":"GULOZITOS ALIMENTOS LTDA","commercialName":"GULOZITOS","cnpj":"22245245000111","city":"MANHUAÇU","stateCode":"MG","buscaAdicional":"GULOZITOS 4881 GULOZITOS-MANHUACU 71776"},{"id":"2a65b4cc-c457-41bb-60b7-08d5ad2bf6ba","name":"SUMIRIKO DO BRASIL INDUSTRIA DE BORRACHAS LTDA","commercialName":"SRK-BI","cnpj":"00322648000184","city":"MATEUS LEME","stateCode":"MG","buscaAdicional":"TOKAI 53646 TOKAI IND BORRACHAS 904436"},{"id":"a9b5d2f2-c7d0-4684-51c8-08d5ad2bf6ba","name":"CACHOEIRA DO BRUMADO ENERGIA ELETRICA LTDA","commercialName":"","cnpj":"04266548000139","city":"MATIAS BARBOSA","stateCode":"MG","buscaAdicional":"CBRUMADO 2589 CACH DO BRUMADO 8624 PCH.PH.MG.029723-2.01"},{"id":"cce1182a-e774-4fed-4f75-08d5ad2bf6ba","name":"BR METALS FUNDICOES LTDA","commercialName":"","cnpj":"19811058000224","city":"MATOZINHOS","stateCode":"MG","buscaAdicional":"BR METALS 1113 TKRUPP FUNDICOES 13 7646"},{"id":"8deaaf5a-5e2e-4425-5a55-08d5ad2bf6ba","name":"CRH SUDESTE INDUSTRIA DE CIMENTOS S.A.","commercialName":"","cnpj":"21109697000103","city":"MATOZINHOS","stateCode":"MG","buscaAdicional":"CRH SUDESTE 17352 LAFARGE ARCOS MAUA 7671 LAFARGE MATOZINHOS 7675 LAFARGE S LUZIA 70276 CRH SUDESTE CANTAGAL 898184"},{"id":"67010918-06cc-462c-625b-08d5ad2bf6ba","name":"FERGUBEL FERRO GUSA BELA VISTA LTDA","commercialName":"FERGUBEL","cnpj":"06368447000102","city":"MATOZINHOS","stateCode":"MG","buscaAdicional":"FERGUBEL 54712 FERGUBEL BELA VISTA 908840"},{"id":"de7eaf26-7223-404d-616c-08d5ad2bf6ba","name":"COSIMAT SIDERURGICA DE MATOZINHOS LTDA","commercialName":"","cnpj":"03200559000153","city":"MATOZINHOS","stateCode":"MG","buscaAdicional":"COSIMAT 54180 COSIMAT SIDERURGIA 908837"},{"id":"08fdcbeb-295e-4d1f-686e-08d5ad2bf6ba","name":"AUSTEN PROCESSOS METALURGICOS LTDA","commercialName":"","cnpj":"19991918000178","city":"MATOZINHOS","stateCode":"MG","buscaAdicional":"AUSTEN 60032 AUSTEN 910099"},{"id":"d98ff1c0-446e-4a08-5893-08d5ad2bf6ba","name":"SANTA BARBARA ENERGIA S. A.","commercialName":"","cnpj":"15346705000132","city":"MIRADOURO","stateCode":"MG","buscaAdicional":"CGH SANTA BARBARA 12492 CGH SANTA BARBARA 892263 CGH.PH.MG.031277-0.01"},{"id":"4f239886-d79a-4e02-55e3-08d5ad2bf6ba","name":"MIRADOURO ENERGIA S.A.","commercialName":"","cnpj":"12796475000115","city":"MIRADOURO","stateCode":"MG","buscaAdicional":"CGH MIRADOURO 6274 MIRADOURO 20005 CGH.PH.MG.030847-1.01"},{"id":"1bf0ca2b-ad00-41ea-60ae-08d5ad2bf6ba","name":"FORTUCE & FORTUCE LTDA","commercialName":"EMBALAGEM FORTUCE","cnpj":"07209957000191","city":"MIRAÍ","stateCode":"MG","buscaAdicional":"FORTUCE MATRIZ 53633 FORTUCE MATRIZ 904901 FORTUCE & FORTUCE 904946"},{"id":"7b333890-a154-4ef2-650c-08d5ad2bf6ba","name":"GUARANIPLAST INDUSTRIA DE EMBALAGENS LTDA","commercialName":"GUARANIPLAST","cnpj":"10660037000108","city":"MIRAÍ","stateCode":"MG","buscaAdicional":"GUARANIPLAST 56454 GUARANI EMBALAGENS 906737"},{"id":"ed5c1647-bc3c-4116-610c-08d5ad2bf6ba","name":"MGM PRODUTOS SIDERURGICOS S/A","commercialName":"","cnpj":"22541783000153","city":"MONSENHOR PAULO","stateCode":"MG","buscaAdicional":"MGM 53980 MGM DIVISAO FECHADUR 904955 MGM DIVISAO ACO 904956 MGM - BAEPENDI 905673 MGM - DIVISAO PVC 905674"},{"id":"05642be7-1cc3-413a-682d-08d5ad2bf6ba","name":"COBUCCIO E ALMEIDA ENERGIA LTDA","commercialName":"CGH RIO PARDO","cnpj":"24565247000113","city":"MONTE BELO","stateCode":"MG","buscaAdicional":"CGH RIO PARDO 59454 CORUMBATAI 8367 PCH.PH.SP.000868-0.01 SAO VALENTIM 8587 PCH.PH.SP.002707-3.01"},{"id":"f0ee2093-8c92-4ce9-5210-08d5ad2bf6ba","name":"USINA MONTE ALEGRE LTDA","commercialName":"USINA MONTE ALEGRE","cnpj":"22587687000146","city":"MONTE BELO","stateCode":"MG","buscaAdicional":"MONTE ALEGRE 2841 MONTE ALEGRE 8506 UTE.AI.MG.029688-0.01"},{"id":"e5b15252-ec44-404e-1cd7-08d5b8870181","name":"CERAMICA ART-PLAN LTDA","commercialName":"","cnpj":"26064287000107","city":"MONTE CARMELO","stateCode":"MG","buscaAdicional":"CERAMICA ART-PLAN 62330 CERAMICA ARTPLAN 912852"},{"id":"8db4675d-66c2-4ed7-7362-08d5cf600bef","name":"ELETROSOM S/A","commercialName":"ELETROSOM","cnpj":"22164990000136","city":"MONTE CARMELO","stateCode":"MG","buscaAdicional":""},{"id":"e87b3b46-f680-43d4-7363-08d5cf600bef","name":"COMPANHIA DE TECIDOS NORTE DE MINAS COTEMINAS","commercialName":"COTEMINAS","cnpj":"22677520000176","city":"MONTES CLAROS","stateCode":"MG","buscaAdicional":""},{"id":"b385f5cb-8a7e-42d0-72c4-08d5cf600bef","name":"SPRINGS GLOBAL PARTICIPACOES S.A.","commercialName":"","cnpj":"07718269000157","city":"MONTES CLAROS","stateCode":"MG","buscaAdicional":""},{"id":"b5c4f205-163c-4e1b-8dae-08d5d060706e","name":"SOMAI NORDESTE S/A","commercialName":"SOMAI","cnpj":"22673347000138","city":"MONTES CLAROS","stateCode":"MG","buscaAdicional":"SOMAI NORDESTE 62690 OMAI NORDEST 913335"},{"id":"252dc565-82db-44e0-6858-08d5ad2bf6ba","name":"VIDROBOX TEMPER DE MONTES CLAROS LTDA","commercialName":"","cnpj":"09200174000172","city":"MONTES CLAROS","stateCode":"MG","buscaAdicional":"VIDROBOX MC 59836 VIDROBOX TEMPER MONT 909771"},{"id":"a3dea7e9-c9ee-4a6f-68c5-08d5ad2bf6ba","name":"FABRICA MINEIRA DE ELETRODOS E SOLDAS DENVER SA","commercialName":"","cnpj":"22671564000199","city":"MONTES CLAROS","stateCode":"MG","buscaAdicional":"DENVER MOC 60402 SOLDAS DENVER 910331"},{"id":"0f8caaba-2738-440a-6971-08d5ad2bf6ba","name":"JLX MINERACAO S/A","commercialName":"","cnpj":"09545681000148","city":"MONTES CLAROS","stateCode":"MG","buscaAdicional":"JLX MINERACAO 61653 JLX MINERACAO 912215"},{"id":"0a74ecbf-f3d2-410e-6740-08d5ad2bf6ba","name":"ELSTER MEDICAO DE AGUA LTDA.","commercialName":"","cnpj":"21581509000145","city":"MONTES CLAROS","stateCode":"MG","buscaAdicional":"ELSTER 58015 ELSTER MED DE AGUA 908831"},{"id":"f29902db-32cd-4482-5088-08d5ad2bf6ba","name":"COTEMINAS S.A.","commercialName":"COTEMINAS","cnpj":"07663140000199","city":"MONTES CLAROS","stateCode":"MG","buscaAdicional":"COTEMINAS SA 1678 COTEMINAS M CLAROS 90 COTEMINAS II RN 7063 COTEMINAS BLUMENAU 7066 COTEMINAS JPESSOA 7440 COTEMINAS-C GRANDE 7492 COTEMINAS COTENOR 70946 P ESTRELA-COTEMINAS 8431 UHE.PH.MG.027196-9.01 MACAIBA 8323 UTE.GN.RN.028324-0.01"},{"id":"9d57f880-d303-48cf-5101-08d5ad2bf6ba","name":"COMPANHIA TECIDOS SANTANENSE","commercialName":"","cnpj":"21255567000189","city":"MONTES CLAROS","stateCode":"MG","buscaAdicional":"SANTANENSE 1945 SANTANENSE 888627 SANTANENSE J. OTONI 888628 SANTANENSE PA MINAS 888630 SANTANENSE M CLAROS 888831"},{"id":"28fbf25d-84eb-4f98-550c-08d5ad2bf6ba","name":"NOVO NORDISK PRODUCAO FARMACEUTICA DO BRASIL LTDA.","commercialName":"NOVO NORDISK PRODUCAO FARMACEUTICA DO BRASIL LTDA.","cnpj":"16921603000166","city":"MONTES CLAROS","stateCode":"MG","buscaAdicional":"NOVONORDISK 4961 N NORDISK M CLAROS 71732"},{"id":"d035f78b-5b97-4c55-54d5-08d5ad2bf6ba","name":"CONDOMINIO DE ADMINISTRACAO DO MONTES CLAROS SHOPPING CENTER","commercialName":"","cnpj":"02786850000192","city":"MONTES CLAROS","stateCode":"MG","buscaAdicional":"CAMCS 4524 MONTES CLAROS SHOP 71735"},{"id":"c2088bf9-b40b-4a19-5f3e-08d5ad2bf6ba","name":"INSTITUTO EDUCACIONAL SANTO AGOSTINHO LTDA","commercialName":"","cnpj":"03735981000103","city":"MONTES CLAROS","stateCode":"MG","buscaAdicional":"IESA 52873 IESA JK 905881 IESA 2 907191"},{"id":"b3a9a0d6-d238-44b6-6029-08d5ad2bf6ba","name":"PARANA INDUSTRIA DE PAPEIS UNID II EIRELI","commercialName":"PARANA PAPEIS UNID II","cnpj":"17287963000110","city":"MUNHOZ","stateCode":"MG","buscaAdicional":"PARANA PAPEIS 53408 PARANA IND PAPEIS II 907788"},{"id":"3c682a31-c1a6-4c5c-548d-08d5ad2bf6ba","name":"MURIAE COMERCIO E INDUSTRIA DE VIDROS S. A.","commercialName":"","cnpj":"10657085000139","city":"MURIAÉ","stateCode":"MG","buscaAdicional":"CRISTALTEMPER 4331 CRISTAL TEMP-MURIAE 71551"},{"id":"ac49d57c-ac5d-4715-57e3-08d5ad2bf6ba","name":"PIRAPANEMA ENERGIA S. A.","commercialName":"","cnpj":"14697279000119","city":"MURIAÉ","stateCode":"MG","buscaAdicional":"CGH PIRAPANEMA 9930 PIRAPANEMA 890487 CGH.PH.MG.031051-4.01"},{"id":"e84fe45e-d52a-448a-528b-08d5ad2bf6ba","name":"AMG MINERACAO S/A","commercialName":"AMG MINERACAO","cnpj":"11224676000185","city":"NAZARENO","stateCode":"MG","buscaAdicional":"AMG MINERACAO 3119 CIF NAZARENO 70979"},{"id":"0b68affd-dad3-4507-4fde-08d5ad2bf6ba","name":"NOVA ERA SILICON S/A","commercialName":"","cnpj":"19795665000167","city":"NOVA ERA","stateCode":"MG","buscaAdicional":"SILICON 1324 NOVA ERA SILICON 77"},{"id":"e3c53bc4-4d8e-4953-5c93-08d5ad2bf6ba","name":"FUNDACAO DOM CABRAL","commercialName":"","cnpj":"19268267000192","city":"NOVA LIMA","stateCode":"MG","buscaAdicional":"FDC 51387 FUNDACAO CABRAL 898690"},{"id":"cb8fc61c-05a9-45d0-58b3-08d5ad2bf6ba","name":"GASCOM COMERCIALIZADORA DE GAS LTDA.","commercialName":"GASCOM","cnpj":"18747456000185","city":"NOVA LIMA","stateCode":"MG","buscaAdicional":"CMU VAREJISTA 12914"},{"id":"07b76432-b74b-4094-6820-08d5ad2bf6ba","name":"CNH INDUSTRIAL BRASIL LTDA.","commercialName":"","cnpj":"01844555000182","city":"NOVA LIMA","stateCode":"MG","buscaAdicional":"CNH INDUSTRIAL 59374 CNH SETE LAGOAS 70052 CNH-CURITIBA 71866 CNH L AMERICA CONT 70185 CNH SOROCABA 888162 CNH LATIN AMERICA 898080"},{"id":"4d6f6ef2-505c-46bb-64a8-08d5ad2bf6ba","name":"INSTITUTO MATERNO INFANTIL DE MINAS GERAIS S/A","commercialName":"HOSPITAL VILA DA SERRA","cnpj":"01067064000172","city":"NOVA LIMA","stateCode":"MG","buscaAdicional":"HOSPITAL VILA DA SERRA 56146 INSTITUTO MATERNO IN 908117"},{"id":"5dc901ef-7962-4671-4ee5-08d5d159243d","name":"CONCESSIONARIA BR-040 S.A.","commercialName":"","cnpj":"19726048000100","city":"NOVA LIMA","stateCode":"MG","buscaAdicional":""},{"id":"22003ae6-881d-410b-729a-08d5cf600bef","name":"BIOMM S/A","commercialName":"","cnpj":"04752991000110","city":"NOVA LIMA","stateCode":"MG","buscaAdicional":""},{"id":"e7f5be41-78c8-4789-62d2-08d5ad2bf6ba","name":"BAPTISTA DE ALMEIDA COMERCIO E INDUSTRIA LTDA","commercialName":"BALAS SANTA RITA","cnpj":"22983753000105","city":"OLIVEIRA","stateCode":"MG","buscaAdicional":"BAPTISTADEALMEIDA 54980 BAPTISTA DE ALMEIDA 904164"},{"id":"42e3d94e-466f-4265-4fa4-08d5ad2bf6ba","name":"GERDAU ACOMINAS S/A","commercialName":"GERDAU","cnpj":"17227422000105","city":"OURO BRANCO","stateCode":"MG","buscaAdicional":"GACO 1208 GERDAU ACOMIN OBRANC 7697 GERDAU ACOMINAS 898791 GERDAU ACOSMINAS MVL 910282"},{"id":"27172340-eb93-4ba1-88a7-08d5ae44ed50","name":"OURO FINO GERACAO DE ENERGIA SPE LTDA","commercialName":"","cnpj":"13009242000198","city":"OURO FINO","stateCode":"MG","buscaAdicional":"OURO FINO GERACAO 15915 CGH OURO FINO 897806 CGH.PH.MG.031804-3.01"},{"id":"2ad670bb-2b75-42c0-6953-08d5ad2bf6ba","name":"PEDREIRA IRMAOS MACHADO LTDA","commercialName":"PEDREIRA IRMAOS MACHADO","cnpj":"19257633000108","city":"OURO PRETO","stateCode":"MG","buscaAdicional":"IRMAOS MACHADO 61055 IRMAOS MACHADO 911721"},{"id":"479e43a2-fbf1-4d72-6954-08d5ad2bf6ba","name":"BEMIL - BENEFICIAMENTO DE MINERIOS LTDA","commercialName":"","cnpj":"23064231000164","city":"OURO PRETO","stateCode":"MG","buscaAdicional":"BEMIL 61056 BEMIL 911991"},{"id":"5c5a7200-931c-4abd-58b7-08d5ad2bf6ba","name":"FERRO + MINERACAO S.A.","commercialName":"","cnpj":"21256870000287","city":"OURO PRETO","stateCode":"MG","buscaAdicional":"FERROMAIS 12993 FERROMAIS OURO PRETO 892002"},{"id":"7cc1b719-afed-4b66-5881-08d5ad2bf6ba","name":"HINDALCO DO BRASIL INDUSTRIA E COMERCIO DE ALUMINA LTDA.","commercialName":"","cnpj":"17720994000113","city":"OURO PRETO","stateCode":"MG","buscaAdicional":"HINDALCO 12092 HINDALCO 891562"},{"id":"67cb623c-4785-48a9-59cb-08d5ad2bf6ba","name":"MAYNART ENERGETICA LTDA.","commercialName":"","cnpj":"20227915000141","city":"OURO PRETO","stateCode":"MG","buscaAdicional":"MAYNART 15597 FUMACA 894785 PCH.PH.MG.027957-9.01 FURQUIM 894786 PCH.PH.MG.028175-1.01 CACHOEIRA PRAZERES 894762 CGH.PH.MG.000526-6.02 CABOCLO 894782 PCH.PH.MG.000345-0.01 FUNIL (OURO PRETO) 894783 PCH.PH.MG.027066-0.01 SALTO (OURO PRETO) 894784 PCH.PH.MG.027719-3.01"},{"id":"46d5dfc1-3f2b-4465-5b27-08d5ad2bf6ba","name":"GECAL INDUSTRIA E COMERCIO DE PRODUTOS MINERAIS LTDA","commercialName":"GECAL","cnpj":"20302873000166","city":"PAINS","stateCode":"MG","buscaAdicional":"GECAL 50498 GECAL - FILIAL 898825 GECAL - MATRIZ 898832"},{"id":"169e6e04-0ffa-40a8-527b-08d5ad2bf6ba","name":"MINERADORA CARMOCAL LTDA","commercialName":"","cnpj":"05353326000116","city":"PAINS","stateCode":"MG","buscaAdicional":"CARMOCAL 3083 CARMOCAL 70855"},{"id":"611f562a-6bea-470f-6869-08d5ad2bf6ba","name":"T.M.F. INDUSTRIA DE FERTILIZANTES INTELIGENTES LTDA","commercialName":"T.M.F. FERTILIZANTES INTELIGENTES","cnpj":"07858383000182","city":"PAINS","stateCode":"MG","buscaAdicional":"TMF 59915 TMF FERTILIZANTES 909947"},{"id":"52a0812e-2c6c-4e93-610b-08d5ad2bf6ba","name":"SOLO-FERTIL INDUSTRIA E COMERCIO LTDA","commercialName":"","cnpj":"21652599000118","city":"PAINS","stateCode":"MG","buscaAdicional":"SOLO FERTIL 53979 SOLO FERTIL 905337"},{"id":"0e8b0620-e25f-45b2-5357-08d5ad2bf6ba","name":"DESTILARIA VALE DO PARACATU - AGROENERGIA S.A.","commercialName":"VALE DO PARACATU - AGROENERGIA","cnpj":"07459492000127","city":"PARACATU","stateCode":"MG","buscaAdicional":"PARACATU 3587 PARACATU CL 71407 DESTILARIA PARACATU 8752 UTE.AI.MG.030266-0.01"},{"id":"daa8d553-145e-4aad-4f73-08d5ad2bf6ba","name":"KINROSS BRASIL MINERACAO S/A","commercialName":"","cnpj":"20346524000146","city":"PARACATU","stateCode":"MG","buscaAdicional":"KINROSS 1109 RPM-PARACATU-MG 7683 PARNAIBA IV-PARACATU 893042 UTE.GN.MA.031193-6.01"},{"id":"490c2165-f3f6-4e57-51f4-08d5ad2bf6ba","name":"SIDERURGICA ALTEROSA S/A","commercialName":"","cnpj":"23117229000106","city":"PARÁ DE MINAS","stateCode":"MG","buscaAdicional":"ALTEROSA I5 2740 ALTEROSA 8534 UTE.PE.MG.029991-0.01"},{"id":"95cb3524-540e-43c6-5bf0-08d5ad2bf6ba","name":"ORGANIZACOES FRANCAP S/A","commercialName":"GRANJA PARA DE MINAS FAZENDA DA LAGOA","cnpj":"19498344000109","city":"PARÁ DE MINAS","stateCode":"MG","buscaAdicional":"FRANCAP 50992 FRANCAP JPII 898149 FRANCAP 898151"},{"id":"460abc7f-1534-45fe-62c9-08d5ad2bf6ba","name":"FUNDICAO BATISTA INDUSTRIA COMERCIO E TRANSPORTES LTDA","commercialName":"","cnpj":"23117419000123","city":"PARÁ DE MINAS","stateCode":"MG","buscaAdicional":"FUNDICAO BATISTA 54969 FUNDICAO BATISTA 904279"},{"id":"d6a8390d-0829-4bfe-681e-08d5ad2bf6ba","name":"LAMIL ESPECIALIDADES MINERAIS LTDA","commercialName":"","cnpj":"11141856000101","city":"PARÁ DE MINAS","stateCode":"MG","buscaAdicional":"LAMIL 59371 LAMIL MINERAIS 909898"},{"id":"4ef5105c-d397-4741-66d7-08d5ad2bf6ba","name":"LEV TERMOPLASTICOS LTDA","commercialName":"","cnpj":"05936089000116","city":"PARÁ DE MINAS","stateCode":"MG","buscaAdicional":"LEV TERMOPLASTICOS LTDA 57851 LEV TERMOPLASTICOS 907615"},{"id":"c93ca915-95b4-472f-5b80-08d5ad2bf6ba","name":"LINHANYL PARAGUACU SA","commercialName":"","cnpj":"00139737000270","city":"PARAGUAÇU","stateCode":"MG","buscaAdicional":"LINHANYL 50735 LINHANYL 897682"},{"id":"521b6e7e-9930-40bb-5270-08d5ad2bf6ba","name":"PARAGUACU TEXTIL LTDA","commercialName":"","cnpj":"96368816000222","city":"PARAGUAÇU","stateCode":"MG","buscaAdicional":"A PARAGUACU 3060 PARAGUACU 70837"},{"id":"d595a9ef-d9ed-475d-5260-08d5ad2bf6ba","name":"TEAR TEXTIL INDUSTRIA E COMERCIO LTDA","commercialName":"","cnpj":"03123987000120","city":"PARAOPEBA","stateCode":"MG","buscaAdicional":"TEAR TEXTIL MT 3035 TEAR TEXTIL 70833"},{"id":"161dd198-b657-4df7-5a49-08d5ad2bf6ba","name":"INDUSTRIA DE PAPEIS P/ EMBALAGENS IRMAOS SIQUEIRA LTDA","commercialName":"IPAPEIS","cnpj":"17919549000187","city":"PASSA QUATRO","stateCode":"MG","buscaAdicional":"IPAPEIS M 17325 PAPEIS SIQUEIRA 891703 IPAPEIS PAULO D LUCA 895585 IPAPEIS RODOLFO HESS 895601"},{"id":"41e22755-eef6-453d-6691-08d5ad2bf6ba","name":"MGPET INDUSTRIA E COMERCIO DE EMBALAGENS PLASTICAS LTDA","commercialName":"MGPET","cnpj":"10712606000103","city":"PASSA QUATRO","stateCode":"MG","buscaAdicional":"MGPET 57657 MGPET 907211"},{"id":"9edf0808-dc91-4131-6173-08d5ad2bf6ba","name":"COMERCIO INDUSTRIA DE BEBIDAS AUREA LTDA","commercialName":"CIBAL","cnpj":"23243959000153","city":"PASSA QUATRO","stateCode":"MG","buscaAdicional":"CIBAL 54195 CIBAL BEBIDAS AUREA 904489"},{"id":"6943ea44-ad67-4ab2-61a1-08d5ad2bf6ba","name":"MINERACAO AGUA PADRE MANOEL LTDA","commercialName":"","cnpj":"17315060000104","city":"PASSA QUATRO","stateCode":"MG","buscaAdicional":"AGUA PASSA QUATRO 54306 AGUA PASSA QUATRO 905870"},{"id":"a66c685d-12e8-42d5-4f5b-08d5ad2bf6ba","name":"FERLIG - FERRO LIGA LTDA","commercialName":"","cnpj":"22482228000106","city":"PASSA TEMPO","stateCode":"MG","buscaAdicional":"FERLIG 1067 FERLIG-BARREIRO-MG 7667 FERLIG PASSA TEMP 72392"},{"id":"c30823c7-d236-47ef-5275-08d5ad2bf6ba","name":"CONDOMINIO-EMPREENDEDORES DO PATIO CENTRAL SHOPPING","commercialName":"PATIO CENTRAL SHOPPING","cnpj":"09480439000133","city":"PATOS DE MINAS","stateCode":"MG","buscaAdicional":"CEPCS 3067 PATIO CENTRAL SHOP 71042"},{"id":"21596923-1dee-4465-567b-08d5ad2bf6ba","name":"INDUSTRIA DE RACOES PATENSE LTDA","commercialName":"","cnpj":"23357072000196","city":"PATOS DE MINAS","stateCode":"MG","buscaAdicional":"PATENSE MG 7183 PATENSE - ITAUNA PAT 72175 PATENSE - P MINAS 72176 PATENSE TANGUA 910341 UTE PATENSE 898161 UTE.FL.MG.032981-9.02"},{"id":"803cd9e9-31d3-4c46-5b76-08d5ad2bf6ba","name":"FUNDACAO EDUCACIONAL DE PATOS DE MINAS","commercialName":"","cnpj":"23354848000114","city":"PATOS DE MINAS","stateCode":"MG","buscaAdicional":"UNIPAM 50711 FUND EDU PATO DE MIN 901517"},{"id":"2c810121-1dee-4352-5cea-08d5ad2bf6ba","name":"COOPERATIVA CENTRAL MINEIRA DE LATICINIOS LTDA","commercialName":"CEMIL","cnpj":"42942235000142","city":"PATOS DE MINAS","stateCode":"MG","buscaAdicional":"CEMIL 51610 CEMIL 900654"},{"id":"693e8f85-f97d-4b17-5d54-08d5ad2bf6ba","name":"COOPERATIVA MISTA AGRO PECUARIA DE PATOS DE MINAS LTDA","commercialName":"COOPATOS","cnpj":"23338189000122","city":"PATOS DE MINAS","stateCode":"MG","buscaAdicional":"COOPATOS 51784 COOPATOS 900634"},{"id":"fd14a1a5-360f-4b7a-5f26-08d5ad2bf6ba","name":"MINAS MAIS ALIMENTOS LTDA","commercialName":"","cnpj":"11701319000160","city":"PATOS DE MINAS","stateCode":"MG","buscaAdicional":"PREDILECTA MINAS 52792 MINAS MAIS ALIMENTOS 903776"},{"id":"b0d7a396-55e9-4758-62d4-08d5ad2bf6ba","name":"LABORATORIO DE BIO CONTROLE FARROUPILHA LTDA.","commercialName":"","cnpj":"07983734000187","city":"PATOS DE MINAS","stateCode":"MG","buscaAdicional":"FARROUPILHA 54982 LAB BIO CONTR FARROU 906535"},{"id":"c95028ab-d538-476c-653e-08d5ad2bf6ba","name":"SUINCO - COOPERATIVA DE SUINOCULTORES LTDA","commercialName":"SUINCO","cnpj":"06067949000195","city":"PATOS DE MINAS","stateCode":"MG","buscaAdicional":"SUINCO 56616 SUINCO COOP SUINOCUL 907163"},{"id":"bf2de6b0-aa88-445e-6942-08d5ad2bf6ba","name":"REINA SEMENTES LTDA","commercialName":"REINA SEMENTES","cnpj":"20057786000190","city":"PATOS DE MINAS","stateCode":"MG","buscaAdicional":"REINA SEMENTES 60948 REINA SEMENTES 911720"},{"id":"07468252-0c6d-4258-1ca3-08d5b8870181","name":"SUPERMERCADO BERNARDAO LTDA","commercialName":"SUPERMERCADO BERNARDAO","cnpj":"18468199000142","city":"PATROCÍNIO","stateCode":"MG","buscaAdicional":"SUPERMERCADO BERNARDAO 60174 SUPERMER BERNARDAO 3 912831 SUPERMER BERNARDAO 4 912832 SUPERMER BERNARDAO 5 912833 SUPERMERC BERNARDAO 912851"},{"id":"b3cc8f7f-48e7-4e27-5239-08d5ad2bf6ba","name":"RIO BRANCO ALIMENTOS S/A","commercialName":"PIF PAF","cnpj":"05017780001178","city":"PATROCÍNIO","stateCode":"MG","buscaAdicional":"PIFPAFPATR 2945 R BRANCO ALIMENTOS 70796"},{"id":"04d0b462-211f-4d18-5b3e-08d5ad2bf6ba","name":"GODIVA ALIMENTOS LTDA","commercialName":"LATICINIOS GODIVA","cnpj":"01892202000158","city":"PATROCÍNIO DO MURIAÉ","stateCode":"MG","buscaAdicional":"GODIVA 50535 GODIVA 898092"},{"id":"ac17c333-e761-4232-5272-08d5ad2bf6ba","name":"TANSAN INDUSTRIA QUIMICA LTDA","commercialName":"SIBELCO BRASIL","cnpj":"20927059000137","city":"PEDRA DO INDAIÁ","stateCode":"MG","buscaAdicional":"TANSANPEDRA 3063 TANSAN QUIMICA 70876 TANSAN JARINU SP 911255"},{"id":"fb69588d-deba-43af-5642-08d5ad2bf6ba","name":"UNICAL-UNIAO PRODUTORA DE CAL LTDA.","commercialName":"UNICAL","cnpj":"08175256000141","city":"PEDRO LEOPOLDO","stateCode":"MG","buscaAdicional":"UNICAL 6824 UNICAL P LEOPOLDO 72215"},{"id":"038263a7-e5f6-481b-5643-08d5ad2bf6ba","name":"MINERACAO LAPA VERMELHA LTDA","commercialName":"","cnpj":"23453897000104","city":"PEDRO LEOPOLDO","stateCode":"MG","buscaAdicional":"LAPA VERMELHA 6825 LAPA VERM PLEOPOLDO 72130"},{"id":"48acfaac-d46e-4468-5b29-08d5ad2bf6ba","name":"BRITADORA BORGES LTDA.","commercialName":"","cnpj":"14458349000186","city":"PEDRO LEOPOLDO","stateCode":"MG","buscaAdicional":"BRITADORABORGES 50501 BRITADORA BORGES 898174"},{"id":"3673cf1f-66ea-4a5b-5b4c-08d5ad2bf6ba","name":"PRECON INDUSTRIAL SA","commercialName":"PRECON","cnpj":"23452238000153","city":"PEDRO LEOPOLDO","stateCode":"MG","buscaAdicional":"PRECON 50572 PRECON 897674 PRECON INDUSTRIAL MG 897770"},{"id":"a137ed1e-d059-4416-6032-08d5ad2bf6ba","name":"CITYGUSA SIDERURGIA LTDA","commercialName":"","cnpj":"02167722000160","city":"PEDRO LEOPOLDO","stateCode":"MG","buscaAdicional":"CITYGUSA 53421 CITYGUSA SIDERURGIA 905888"},{"id":"75c065c6-90ea-4e84-58b4-08d5ad2bf6ba","name":"U.S.A. - USINA SANTO ANGELO LTDA","commercialName":"","cnpj":"19537471000161","city":"PIRAJUBA","stateCode":"MG","buscaAdicional":"USANGELO 12933 USINA SANTO ANGELO 908076 SANTO ANGELO - USA 893843 UTE.AI.MG.029116-1.01"},{"id":"0e846260-29ff-43b2-4fbe-08d5ad2bf6ba","name":"INPA - INDUSTRIA DE EMBALAGENS SANTANA S/A","commercialName":"","cnpj":"23524952000100","city":"PIRAPETINGA","stateCode":"MG","buscaAdicional":"INPA 1258 INPA-PIRAPETINGA-MG 7535"},{"id":"ff9a9217-9bb2-483f-4f71-08d5ad2bf6ba","name":"COMPANHIA FERROLIGAS MINAS GERAIS","commercialName":"","cnpj":"16933590000145","city":"PIRAPORA","stateCode":"MG","buscaAdicional":"MINASLIGAS 1106 MINAS LIGAS PIRAPORA 7625"},{"id":"6f7fb630-4637-4728-4f5c-08d5ad2bf6ba","name":"LIGAS DE ALUMINIO SA LIASA","commercialName":"","cnpj":"17221771000101","city":"PIRAPORA","stateCode":"MG","buscaAdicional":"LIASA 1068 LIASA-PIRAPORA-MG 7656"},{"id":"72e2ca7d-e41b-4c7a-4f68-08d5ad2bf6ba","name":"COMPANHIA DE FIACAO E TECIDOS SANTO ANTONIO","commercialName":"","cnpj":"25582727000155","city":"PIRAPORA","stateCode":"MG","buscaAdicional":"CEDRO SANTO 1089 FIAC TECEL S ANTONIO 7654"},{"id":"7de9d4c6-2373-4749-4f65-08d5ad2bf6ba","name":"INONIBRAS INOCULANTES E FERRO LIGAS NIPO BRASILEIROS SA","commercialName":"","cnpj":"18891036000178","city":"PIRAPORA","stateCode":"MG","buscaAdicional":"INONIBRAS 1085 INONIBRAS PIRAPORA 7747"},{"id":"2cd03798-ccda-4205-60fd-08d5ad2bf6ba","name":"REAL MINAS TEXTIL INDUSTRIA E COMERCIO - EIRELI","commercialName":"","cnpj":"02419624000254","city":"PIRAPORA","stateCode":"MG","buscaAdicional":"REAL MINAS TEXTIL 53945 REAL MINAS TEXTIL 904953"},{"id":"cf120183-8301-4b7c-8d75-08d5d060706e","name":"PIRAPORA II ENERGIAS RENOVAVEIS S.A.","commercialName":"","cnpj":"23984342000199","city":"PIRAPORA","stateCode":"MG","buscaAdicional":"PIRAPORA II ENERGIAS 51714 PIRAPORA 2 910730 UFV.RS.MG.033185-6.01"},{"id":"b1a98524-b6b5-4641-8d76-08d5d060706e","name":"PIRAPORA III ENERGIAS RENOVAVEIS S.A.","commercialName":"","cnpj":"23983428000105","city":"PIRAPORA","stateCode":"MG","buscaAdicional":"PIRAPORA III ENERGIAS 51715 PIRAPORA 3 910671 UFV.RS.MG.033186-4.01"},{"id":"2e633a7e-4362-4e5a-8d77-08d5d060706e","name":"PIRAPORA IV ENERGIAS RENOVAVEIS S.A.","commercialName":"","cnpj":"23975390000110","city":"PIRAPORA","stateCode":"MG","buscaAdicional":"PIRAPORA IV ENERGIAS 51737 PIRAPORA 4 910672 UFV.RS.MG.033187-2.01"},{"id":"86483ae1-9ca8-4453-5928-08d5ad2bf6ba","name":"USIPAR INDUSTRIA E COMERCIO LTDA","commercialName":"","cnpj":"21587696000174","city":"PITANGUI","stateCode":"MG","buscaAdicional":"USIPAR IND 13936 SIDERPITA 8673 UTE.FL.MG.029473-0.01"},{"id":"fb079ab7-e59a-4cd5-6082-08d5ad2bf6ba","name":"FERRERO DO BRASIL INDUSTRIA DOCEIRA E ALIMENTAR LTDA","commercialName":"FERRERO","cnpj":"43816719000108","city":"POÇOS DE CALDAS","stateCode":"MG","buscaAdicional":"FERRERO 53574 FERRERO POCOS DE CAL 901439"},{"id":"a6c4160f-7680-43ce-5f6d-08d5ad2bf6ba","name":"GENERAL CABLE BRASIL INDUSTRIA E COMERCIO DE CONDUTORES ELETRICOS LTDA.","commercialName":"GENERAL CABLE BRASIL","cnpj":"02180624000163","city":"POÇOS DE CALDAS","stateCode":"MG","buscaAdicional":"GENERAL CABLE 52951 GENERAL CABLE 901284"},{"id":"a477aa57-d603-4d5f-5fa4-08d5ad2bf6ba","name":"CONDOMINIO OPERACIONAL DO MINAS SUL SHOPPING","commercialName":"CONVENCAO DE CONDOMINIO DO MINAS SUL SHOPPING","cnpj":"07626049000101","city":"POÇOS DE CALDAS","stateCode":"MG","buscaAdicional":"SHOPPING POCOS DE CALDAS 53059 CONDOMINIO MINAS SUL 901995 SEVERINI COMERCIAL 903313"},{"id":"47a87404-c427-44aa-5e50-08d5ad2bf6ba","name":"DECKEL INDUSTRIA E COMERCIO DE PLASTICOS TECNICOS LTDA","commercialName":"","cnpj":"03735194000161","city":"POÇOS DE CALDAS","stateCode":"MG","buscaAdicional":"DECKEL 52328 DECKEL 900602"},{"id":"f77095bd-2ae7-4725-4f20-08d5ad2bf6ba","name":"ALCOA ALUMINIO S/A","commercialName":"","cnpj":"23637697000101","city":"POÇOS DE CALDAS","stateCode":"MG","buscaAdicional":"ALCOA 102 ALCOA P CALDAS 71 ALUMAR REFINAR ALCOA 70612 ALUMAR REDUCAO ALCOA 70615"},{"id":"cd1cebb9-97be-42b4-4f21-08d5ad2bf6ba","name":"DME DISTRIBUICAO S.A. - DMED","commercialName":"","cnpj":"23664303000104","city":"POÇOS DE CALDAS","stateCode":"MG","buscaAdicional":"DMED 103 DME 186 BORTOLAN 8998 CGH.PH.MG.000298-4.01 VEU DAS NOIVAS 8999 CGH.PH.MG.027139-0.01 ANTAS 2 9000 UHE.PH.MG.000110-4.01"},{"id":"3bdd0558-8c82-488e-5122-08d5ad2bf6ba","name":"DME ENERGETICA S.A. - DMEE","commercialName":"DME ENERGETICA S.A.","cnpj":"03966583000106","city":"POÇOS DE CALDAS","stateCode":"MG","buscaAdicional":"DMEE 2015 ANTAS 1 8997 UHE.PH.MG.000109-0.01 SALTO PILAO-DMEE 8597 UHE.PH.SC.028564-1.01 ROLADOR 8330 PCH.PH.MG.027870-0.01"},{"id":"1a7fb0c2-86af-4b6e-51e6-08d5ad2bf6ba","name":"M&G FIBRAS BRASIL LTDA.","commercialName":"M&G FIBRAS BRASIL","cnpj":"04241585000354","city":"POÇOS DE CALDAS","stateCode":"MG","buscaAdicional":"M&G 2713 M E G FIBRAS 910001 RHODIA-P.CALDAS-MG 7689"},{"id":"07cf6b14-4100-45b1-5455-08d5ad2bf6ba","name":"MINERACAO CURIMBABA LTDA","commercialName":"USINA PONTE PRETA","cnpj":"23640204000192","city":"POÇOS DE CALDAS","stateCode":"MG","buscaAdicional":"MIN CURIMBABA 4170 MINER CURIMBABA 910000 MIN CURIMBABA 898106 MITSUIFERTIL PCALDAS 7475"},{"id":"047dd823-dc68-485c-542d-08d5ad2bf6ba","name":"ESTREITO ENERGIA S.A.","commercialName":"","cnpj":"07089298000105","city":"POÇOS DE CALDAS","stateCode":"MG","buscaAdicional":"EESA 4046 ESTREITO EESA 8825 UHE.PH.MA.028863-2.01"},{"id":"3771ac95-8653-4e29-51b6-08d5ad2bf6ba","name":"HIDRELETRICA CACHOEIRAO SA","commercialName":"HIDRELETRICA CACHOEIRAO SA","cnpj":"08596628000103","city":"POCRANE","stateCode":"MG","buscaAdicional":"PCH CACHOEIRAO 2533 CACHOEIRAO 8451 PCH.PH.MG.027940-4.01"},{"id":"88494bcf-0df6-43dd-518a-08d5ad2bf6ba","name":"RETIRO BAIXO ENERGETICA S.A.","commercialName":"","cnpj":"07783055000164","city":"POMPÉU","stateCode":"MG","buscaAdicional":"RBE 2251 RETIRO BAIXO 8629 UHE.PH.MG.029457-8.01"},{"id":"9d8d9006-74ea-44f1-5a6f-08d5ad2bf6ba","name":"AGROPEU-AGRO INDUSTRIAL DE POMPEU S/A","commercialName":"","cnpj":"16617789000164","city":"POMPÉU","stateCode":"MG","buscaAdicional":"UTE AGROPEU 49585 AGROPEU 905799 UTE.AI.MG.032677-1.01"},{"id":"4ce9ab15-884a-4c23-5b36-08d5ad2bf6ba","name":"FRIGORIFICO INDUSTRIAL VALE DO PIRANGA S/A","commercialName":"SAUDALI","cnpj":"00763832000160","city":"PONTE NOVA","stateCode":"MG","buscaAdicional":"SAUDALI 50519 FRIG VALE PIRANGA 898028"},{"id":"d382caca-a2a0-4316-5baa-08d5ad2bf6ba","name":"LATICINIOS PORTO ALEGRE INDUSTRIA E COMERCIO S/A","commercialName":"","cnpj":"66301334000103","city":"PONTE NOVA","stateCode":"MG","buscaAdicional":"LPA 50815 LPA MATRIZ 897991 LPA FILIAL MUTUM 899860"},{"id":"ae43f082-dcff-4d42-59cc-08d5ad2bf6ba","name":"BRITO ENERGETICA LTDA.","commercialName":"","cnpj":"20292993000120","city":"PONTE NOVA","stateCode":"MG","buscaAdicional":"BRITO 15598 BRITO 894787 CGH.PH.MG.000318-2.02"},{"id":"1b683d47-92e4-44c7-60e6-08d5ad2bf6ba","name":"INDUSTRIA DE PAPEIS E EMBALAGENS PONTE NOVA LTDA","commercialName":"","cnpj":"02625899000163","city":"PONTE NOVA","stateCode":"MG","buscaAdicional":"PONTE NOVA PAPEIS 53870 PONTE NOVA PAPEIS 904755"},{"id":"9e040c41-3c6c-4e9f-5a06-08d5ad2bf6ba","name":"COMPANHIA PROVIDENCIA INDUSTRIA E COMERCIO","commercialName":"","cnpj":"76500180001376","city":"POUSO ALEGRE","stateCode":"MG","buscaAdicional":"PROVIDENCIA K12 16378 PROVIDENCIA K12 891482"},{"id":"9ca37f84-4dc2-450f-5a07-08d5ad2bf6ba","name":"COMPANHIA PROVIDENCIA INDUSTRIA E COMERCIO","commercialName":"","cnpj":"76500180000809","city":"POUSO ALEGRE","stateCode":"MG","buscaAdicional":"PROVIDENCIA K10 16380 PROVIDENCIA K10 70750"},{"id":"0b257dca-7218-4c3a-5841-08d5ad2bf6ba","name":"LOCOMOTIVA INDUSTRIA E COMERCIO DE TEXTEIS INDUSTRIAIS LTDA.","commercialName":"","cnpj":"09381723000152","city":"POUSO ALEGRE","stateCode":"MG","buscaAdicional":"LOCOMOTIVA 11111 LOCOMOTIVA 890209"},{"id":"f71cd45f-eb30-43a2-5bf2-08d5ad2bf6ba","name":"REC POUSO ALEGRE S.A.","commercialName":"","cnpj":"13099762000210","city":"POUSO ALEGRE","stateCode":"MG","buscaAdicional":"SERRASUL SHOPPING 50995 SERRASUL SHOP 898274"},{"id":"1b5f8e91-5fba-4fee-5a7b-08d5ad2bf6ba","name":"UNILEVER BRASIL LTDA.","commercialName":"","cnpj":"61068276003707","city":"POUSO ALEGRE","stateCode":"MG","buscaAdicional":"UNILEVER CD POUSO 49745 UNILEVER CD POUSO 895881"},{"id":"49aba74d-3617-4054-5206-08d5ad2bf6ba","name":"UNILEVER BRASIL INDUSTRIAL LTDA","commercialName":"","cnpj":"01615814004514","city":"POUSO ALEGRE","stateCode":"MG","buscaAdicional":"UNIPOUSO 2796 UNILEVER P ALEGRE 7679"},{"id":"8b407080-a270-4f47-4f5f-08d5ad2bf6ba","name":"FLAMMA AUTOMOTIVA S/A","commercialName":"","cnpj":"01002612000186","city":"POUSO ALEGRE","stateCode":"MG","buscaAdicional":"FLAMMA AUTOMOTIVA 1074 USIPARTS POUSO ALEGR 7779"},{"id":"9b4bf2b7-c9fb-4beb-5506-08d5ad2bf6ba","name":"LABORATORIO SANOBIOL LTDA","commercialName":"","cnpj":"21561931000309","city":"POUSO ALEGRE","stateCode":"MG","buscaAdicional":"SANOBIOL 4921 SANOBIOL-P ALEGRE 71802"},{"id":"2a79da44-558a-4b06-56d1-08d5ad2bf6ba","name":"UNIAO QUIMICA FARMACEUTICA NACIONAL S A","commercialName":"","cnpj":"60665981000541","city":"POUSO ALEGRE","stateCode":"MG","buscaAdicional":"UNIAO QUIMICA 7782 UNIAO QUIMICA 888396"},{"id":"59f15974-3e5b-4958-740e-08d5cf600bef","name":"PRATICA PARTICIPACOES S.A.","commercialName":"PRATICA PARTICIPACOES","cnpj":"10747021000129","city":"POUSO ALEGRE","stateCode":"MG","buscaAdicional":""},{"id":"3ab6a019-e640-4fb6-6816-08d5d153df4d","name":"PRATICA KLIMAQUIP INDUSTRIA E COMERCIO S.A.","commercialName":"","cnpj":"08574411000100","city":"POUSO ALEGRE","stateCode":"MG","buscaAdicional":""},{"id":"91bf00e0-b652-4bb2-72f5-08d5cf600bef","name":"AUTOPISTA FERNAO DIAS S.A.","commercialName":"","cnpj":"09326342000170","city":"POUSO ALEGRE","stateCode":"MG","buscaAdicional":""},{"id":"11144695-cfc5-4b4c-882d-08d5ae44ed50","name":"SOBRAL INVICTA SOCIEDADE ANONIMA","commercialName":"","cnpj":"60594538000950","city":"POUSO ALEGRE","stateCode":"MG","buscaAdicional":"SOBRAL INVICTA 1088"},{"id":"eb68d283-445f-4c70-679b-08d5ad2bf6ba","name":"SOBRAL INVICTA SOCIEDADE ANONIMA","commercialName":"","cnpj":"60594538000284","city":"POUSO ALEGRE","stateCode":"MG","buscaAdicional":"SOBRAL INVICTA SOCIEDADE 58333 SOBRAL INVICTA MG 70531"},{"id":"c3b7b221-abc2-431e-6174-08d5ad2bf6ba","name":"MAXIBOM ALIMENTOS LTDA","commercialName":"","cnpj":"04590925000190","city":"POUSO ALEGRE","stateCode":"MG","buscaAdicional":"MAXIBOM 54196 MAXIBOM ALIMENTOS 904503"},{"id":"bcc933d5-e115-463c-6194-08d5ad2bf6ba","name":"CIMED INDUSTRIA DE MEDICAMENTOS LTDA","commercialName":"","cnpj":"02814497000298","city":"POUSO ALEGRE","stateCode":"MG","buscaAdicional":"CIMED PA 54247 CIMED PA - IND MEDIC 905880"},{"id":"63450420-455b-4f61-618d-08d5ad2bf6ba","name":"XCMG BRASIL INDUSTRIA LTDA","commercialName":"","cnpj":"14707364000110","city":"POUSO ALEGRE","stateCode":"MG","buscaAdicional":"XCMG 54233 XCMG BRASIL 904502"},{"id":"145449af-3b3e-4434-66c5-08d5ad2bf6ba","name":"INDUSTRIA E COMERCIO DE ALIMENTOS IANA LTDA.","commercialName":"","cnpj":"06296177000163","city":"POUSO ALTO","stateCode":"MG","buscaAdicional":"IANA ALIMENTOS 57810 IANA ALIMENTOS 909242"},{"id":"3c9ff484-0892-471c-5b3b-08d5ad2bf6ba","name":"ABATEDOURO PRADENSE LTDA","commercialName":"FRANGO ATALAIA","cnpj":"70986302000166","city":"PRADOS","stateCode":"MG","buscaAdicional":"ATALAIA ALIMENTOS 50532 ABATEDOURO PRADENSE 900525"},{"id":"28f78fb4-eeef-422b-5f96-08d5ad2bf6ba","name":"COOPERATIVA DOS PRODUTORES RURAIS DO PRATA LTDA","commercialName":"","cnpj":"24021677000174","city":"PRATA","stateCode":"MG","buscaAdicional":"COOPRATA 53040 COOPRATA FAB RACAO 906582 COOPRATA LATICINIOS 906583"},{"id":"f7305d1b-636a-45c9-517b-08d5ad2bf6ba","name":"A.W. FABER CASTELL S.A.","commercialName":"FABRICA IV-PRATA","cnpj":"59596908001396","city":"PRATA","stateCode":"MG","buscaAdicional":"AWFC 2206 AWFC-PRATA-MG 70654"},{"id":"32df0a6e-f8a9-4c9f-64fe-08d5ad2bf6ba","name":"EIMCAL - EMPRESA INDUSTRIAL DE MINERACAO CALCARIA LTDA","commercialName":"EIMCAL","cnpj":"17335274000215","city":"PRUDENTE DE MORAIS","stateCode":"MG","buscaAdicional":"EIMCAL 56366 EIMCAL - CALCINACAO 906505 EIMCAL BRITAGEM 907527"},{"id":"f57450ef-a37d-472a-6505-08d5ad2bf6ba","name":"CEMA CENTRAL MINEIRA ATACADISTA LTDA","commercialName":"VILLEFORT ATACADISTA","cnpj":"03083231000790","city":"RIBEIRÃO DAS NEVES","stateCode":"MG","buscaAdicional":"VILLEFORT 56383 VILLEFORT SION 908125 VILLEFORT JUSTINOPOL 908126 VILLEFORT BRIGADEIRO 908335 VILLEFORT VAZ DE MEL 908336 VILLEFORT JF 908349 VILLEFORT DULCE 908356 VILLEFORT DIVINOPOL 908373 VILLEFORT TITO 908428 VILLEFORT COF 908443 VILLEFORT CEANORTE 908541 VILLEFORT VEREDA 909366"},{"id":"345eb0fb-fb31-4073-65a0-08d5ad2bf6ba","name":"SUPERMERCADOS BH COMERCIO DE ALIMENTOS LTDA","commercialName":"SUPERMERCADOS BH","cnpj":"04641376000136","city":"RIBEIRÃO DAS NEVES","stateCode":"MG","buscaAdicional":"SUPER BH 001 56872 SUPER BH - LJ 165 72044 SUPER BH - LOJA 99 906507 SUPER BH - LOJA 140 906508 SUPER BH - LOJA 147 906509 SUPER BH - LOJA 150 906510 SUPER BH - LOJA 158 906511 SUPER BH - LJ 164 906538 SUPER BH - LOJA 101 906564 SUPER BH - LOJA 200 906565 SUPER BH L29 NV LIMA 907091 SUPER BH LJ 144 PARA 907092 SUPER BH BURITIS 163 907162 SUPER BH PRADO 92 907194 SUPER BH LOJA 115 907588 SUPER BH LOJA 156 907589 SUPER BH LOJA 64 908055 SUPER BH - LOJA 125 908071 SUPER BH - LOJA 106 908331 SUPER BH - LOJA 111 908332 SUPER BH - LOJA 121 908333 SUPER BH - LOJA 120 908351 SUPER BH - LOJA 12 908689 SUPER BH - LOJA 137 908706 SUPER BH - LOJA 15 911451 SUPER BH - LOJA 168 911452 SUPER BH - LOJA 63 911453 SUPER BH - LOJA 172 911454 SUPER BH - LOJA 173 911455 SUPER BH LOJA 49 911456 SUPER BH - LOJA 19 911471 SUPER BH - LOJA 75 911472 SUPER BH - LOJA 170 911473 SUPER BH - LOJA 169 911474 SUPER BH - LOJA 202 911475 SUPER BH - LOJA 43 911491 SUPER BH - LOJA 167 911492 SUPER BH - LOJA 171 911617"},{"id":"ab78091b-3cc4-4c23-51ff-08d5ad2bf6ba","name":"BELO HORIZONTE REFRIGERANTES LTDA","commercialName":"","cnpj":"02091715000203","city":"RIBEIRÃO DAS NEVES","stateCode":"MG","buscaAdicional":"DEL REY 2781 REFRIGERANTES D REY 70747"},{"id":"6b4ef1f3-0c17-4b85-5f41-08d5ad2bf6ba","name":"COMERCIAL DAHANA LIMITADA","commercialName":"","cnpj":"00070509000100","city":"RIBEIRÃO DAS NEVES","stateCode":"MG","buscaAdicional":"DAHANA 52876 DAHANA LJ 56 901275 DAHANA LJ 96 901276 DAHANA LJ 85 901278 DAHANA LJ 66 901313"},{"id":"6df402b0-b1a5-4e46-55cd-08d5ad2bf6ba","name":"ENERGIA LIMPA PARTICIPACOES LTDA","commercialName":"","cnpj":"10871186000108","city":"RIO CASCA","stateCode":"MG","buscaAdicional":"ENERGIA LIMP 6161 PONTE QUEIMADA I 8966 CGH.PH.MG.028569-2.01 PONTE QUEIMADA II 8967 CGH.PH.MG.028570-6.01"},{"id":"04b09015-f45b-4195-5215-08d5ad2bf6ba","name":"SOMA INDUSTRIA E COMERCIO DE ALIMENTOS EIRELI","commercialName":"","cnpj":"64322423000100","city":"RIO POMBA","stateCode":"MG","buscaAdicional":"SOMA 2861 SOMA ALIMENTOS 70766"},{"id":"58605d27-dfd8-48b0-5466-08d5ad2bf6ba","name":"COMERCIO, INDUSTRIA E TRANSPORTE LOPAS S/A","commercialName":"LOPAS","cnpj":"21473590000140","city":"RODEIRO","stateCode":"MG","buscaAdicional":"LOPAS 4210 LOPAS 71471 LOPAS II 71589"},{"id":"460ea5bb-de8a-40ab-5651-08d5ad2bf6ba","name":"LIMEIRA ENERGIA S.A","commercialName":"LIMEIRA ENERGIA","cnpj":"13327920000160","city":"ROSÁRIO DA LIMEIRA","stateCode":"MG","buscaAdicional":"CGH LIMEIRA 6898 LIMEIRA 20055 CGH.PH.MG.030866-8.01"},{"id":"fa7f5414-8732-4d25-5b11-08d5ad2bf6ba","name":"DISTRIBUIDORA DE CARNES SABARA EIRELI","commercialName":"DICASA ALIMENTOS","cnpj":"11408281000132","city":"SABARÁ","stateCode":"MG","buscaAdicional":"DICASA 50435 SABARA DIST CARNES 907202"},{"id":"92bfe3c8-bdfb-49c2-643d-08d5ad2bf6ba","name":"ASJA SABARA SERVICOS PARA O MEIO AMBIENTE S/A","commercialName":"","cnpj":"23752380000116","city":"SABARÁ","stateCode":"MG","buscaAdicional":"ASJA SABARA 55894 ASJA SABARA 909199 UTE.RU.MG.035528-3.01"},{"id":"17da923e-c7fc-46bf-63e3-08d5ad2bf6ba","name":"SCALON & CERCHI LTDA","commercialName":"LATICINIO SCALA","cnpj":"24333411000167","city":"SACRAMENTO","stateCode":"MG","buscaAdicional":"LATICINIO SCALA 55693 SCALA FILIAL 1 906569 SCALA FILIAL 2 906579 SCALA FILIAL 4 906580 SCALA MATRIZ 907048 SCALA FILIAL 5 907198 SCALA FILIAL 3 907208"},{"id":"ac82c06e-c602-48b1-522e-08d5ad2bf6ba","name":"ECO VIDA LTDA","commercialName":"ECO VIDA","cnpj":"02790006000135","city":"SACRAMENTO","stateCode":"MG","buscaAdicional":"ECOVIDA 2913 ECO VIDA CAJURU 8199 CGH.PH.MG.029326-1.01"},{"id":"b1bed65a-d887-4460-6857-08d5ad2bf6ba","name":"TELHAS SALINAS PRODUTOS CERAMICOS LTDA","commercialName":"CERAMICA TELHAS SALINAS","cnpj":"09029511000100","city":"SALINAS","stateCode":"MG","buscaAdicional":"TELHAS SALINAS 59835 TELHAS SALINAS 910003"},{"id":"ec8e082b-930d-4346-4f61-08d5ad2bf6ba","name":"ANGLOGOLD ASHANTI CORREGO DO SITIO MINERACAO S.A.","commercialName":"","cnpj":"18565382000166","city":"SANTA BÁRBARA","stateCode":"MG","buscaAdicional":"ANGLOGOLD CSM 1079 ANGLOGOLD N LIMA 7662 ANGLOGOLD S. BARBARA 7721 ANGLOGOLD ASHANTI 70366 ANGLOGOLD AS S BENTO 71078"},{"id":"2f679050-0e6c-4fb6-5256-08d5ad2bf6ba","name":"AGROINDUSTRIAL SANTA JULIANA LTDA","commercialName":"","cnpj":"05980986000127","city":"SANTA JULIANA","stateCode":"MG","buscaAdicional":"SANTA JULIANA 3013 SANTA JULIANA CONS 71764 SANTA JULIANA 8738 UTE.AI.MG.030166-3.01"},{"id":"b3ec9b72-fa76-44f9-4f60-08d5ad2bf6ba","name":"THYSSENKRUPP METALURGICA SANTA LUZIA LTDA","commercialName":"","cnpj":"18206524000107","city":"SANTA LUZIA","stateCode":"MG","buscaAdicional":"THYSSEN METAL 1078 THYSSENKRUPP S LUZIA 7743"},{"id":"06d3868b-96d3-47ad-5638-08d5ad2bf6ba","name":"SAINT-GOBAIN DO BRASIL PRODUTOS INDUSTRIAIS E PARA CONSTRUCAO LTDA","commercialName":"","cnpj":"61064838008622","city":"SANTA LUZIA","stateCode":"MG","buscaAdicional":"SGQUART SLUZIA 6765 S GOBAIN SLUZIA 72096"},{"id":"88c8213a-69a6-49b0-5371-08d5ad2bf6ba","name":"CAFE TRES CORACOES S.A","commercialName":"","cnpj":"17467515000107","city":"SANTA LUZIA","stateCode":"MG","buscaAdicional":"TRES CORACOES 3637 CAFE TRES CORACOES 71224"},{"id":"b1ae55d8-98fc-4dbb-5b8f-08d5ad2bf6ba","name":"ACOFORJA INDUSTRIA DE FORJADOS SA","commercialName":"","cnpj":"16716417000195","city":"SANTA LUZIA","stateCode":"MG","buscaAdicional":"ACOFORJA 50762 ACOFORJA 898059"},{"id":"3b604b82-dee3-4ec6-5f18-08d5ad2bf6ba","name":"CIFARMA CIENTIFICA FARMACEUTICA LTDA","commercialName":"","cnpj":"17562075000320","city":"SANTA LUZIA","stateCode":"MG","buscaAdicional":"TRD-CIFARMAMG 52734 CIFARMA CIENTIFICA F 903453"},{"id":"7a64dcc8-feb5-4a92-5fc6-08d5ad2bf6ba","name":"HG FOODS LTDA","commercialName":"","cnpj":"21718267000199","city":"SANTA LUZIA","stateCode":"MG","buscaAdicional":"HG FOODS 53217 HG FOODS STA LUZIDA 903139 HG FOODS PITANGUI I 903960 HG FOODS PITANGUI II 903961 HG FOODS - FAZ BOA 905264"},{"id":"b9c2c0d1-6be4-4255-6921-08d5ad2bf6ba","name":"MEGA GELOTIMO MINAS LTDA","commercialName":"MEGA GELOTIMO MINAS","cnpj":"14286194000148","city":"SANTA LUZIA","stateCode":"MG","buscaAdicional":"GELOTIMO BH 60781 MEGA GELOTIMO MINAS 911986"},{"id":"a29b7f66-fbdc-486f-64cf-08d5ad2bf6ba","name":"TRIGO & CIA LTDA","commercialName":"TRIGO ARTE & CIA LTDA","cnpj":"00085740000178","city":"SANTA LUZIA","stateCode":"MG","buscaAdicional":"TAC 56236 TRIGO E CIA 907613"},{"id":"6f194e02-c77a-401a-62cc-08d5ad2bf6ba","name":"PETISCO E MARA S A","commercialName":"","cnpj":"19315811000100","city":"SANTA RITA DE MINAS","stateCode":"MG","buscaAdicional":"PETISCOMARA 54974 PETISCO E MARA 909897"},{"id":"b75cdb82-4c32-4ff8-61a0-08d5ad2bf6ba","name":"COOP.REGIONAL AGRO-PECUARIA DE SANTA RITA DO SAPUCAI LTDA","commercialName":"","cnpj":"24490401000135","city":"SANTA RITA DO SAPUCAÍ","stateCode":"MG","buscaAdicional":"COOPERRITA 54305 COOPER RITA STA RITA 905895"},{"id":"537e07ee-ab16-4827-60c3-08d5ad2bf6ba","name":"MAGLIONI RIBEIRO & CIA LTDA","commercialName":"CASA ALVORADA","cnpj":"21414958000107","city":"SANTA RITA DO SAPUCAÍ","stateCode":"MG","buscaAdicional":"ALVORADA SM 53660 ALVORADA SM - MR01 904245 ALVORADA SM FILIAL 4 904395 ALVORADA SM FILIAL 5 904396 ALVORADA FILIAL 14 904397 ALVORADA SM FILIAL 3 904414 ALVORADA SM FILIAL 2 904415 ALVORADA SM FILIAL 6 904417 ALVORADA FILIAL 16 904418"},{"id":"a61b8afe-5689-4b3f-512c-08d5ad2bf6ba","name":"METAGAL INDUSTRIA E COMERCIO LTDA","commercialName":"","cnpj":"59106377000172","city":"SANTA RITA DO SAPUCAÍ","stateCode":"MG","buscaAdicional":"METAGAL 2033 METAGAL LIVRE 70420"},{"id":"e45a0465-e19f-4305-51ca-08d5ad2bf6ba","name":"COMPANHIA ENERGETICA VALE DO SAO SIMAO","commercialName":"COMPANHIA ENERGETICA VALE DO SAO SIMAO","cnpj":"08215996000164","city":"SANTA VITÓRIA","stateCode":"MG","buscaAdicional":"SAO SIMAO 2592 VALE DO SAO SIMAO 8665 UTE.AI.MG.030046-2.01"},{"id":"ccb827a9-787a-4079-59b5-08d5ad2bf6ba","name":"ERB MG ENERGIAS S.A","commercialName":"","cnpj":"15419901000190","city":"SANTA VITÓRIA","stateCode":"MG","buscaAdicional":"UTE STA VITORIA ERB MG 15415 SANTA VITORIA 895043 UTE.AI.MG.031268-1.01"},{"id":"707466b4-e52d-4849-5b38-08d5ad2bf6ba","name":"ELETROLIGAS LTDA","commercialName":"","cnpj":"17785304000104","city":"SÃO GOTARDO","stateCode":"MG","buscaAdicional":"ELETROLIGAS 50529 ELETROLIGAS 898091"},{"id":"757a99e4-5c53-4b34-5212-08d5ad2bf6ba","name":"BOZEL BRASIL S.A.","commercialName":"","cnpj":"08090788000267","city":"SÃO JOÃO DEL REI","stateCode":"MG","buscaAdicional":"BOZEL M 2851 R DOCE MANG SJDREY 7763"},{"id":"882670a0-4111-4baa-635d-08d5ad2bf6ba","name":"CALCINACAO VITORIA LTDA","commercialName":"CALCINACAO VITORIA","cnpj":"24729451000122","city":"SÃO JOÃO DEL REI","stateCode":"MG","buscaAdicional":"CALCINACAO VITORIA 55327 CALCINACAO VITORIA 904136"},{"id":"b4092a46-04ad-4600-8893-08d5ae44ed50","name":"MAGNA DO BRASIL PRODUTOS E SERVICOS AUTOMOTIVOS LTDA","commercialName":"","cnpj":"00970934000580","city":"SÃO JOAQUIM DE BICAS","stateCode":"MG","buscaAdicional":"MAGNA MG 14295"},{"id":"5e1bf7a8-5a81-4478-5262-08d5ad2bf6ba","name":"SEOYON INTECH FABRICACAO DE SISTEMA INTERIOR AUTOMOTIVO BRASIL LTDA","commercialName":"SEOYON INTECH AUTOMOTIVE DO BRASIL","cnpj":"07385124000181","city":"SÃO JOAQUIM DE BICAS","stateCode":"MG","buscaAdicional":"SEOYON CE 3040 INJEPLASTIC 70848 INJEPLASTIC SJ BICAS 71879"},{"id":"6ae33a1c-0b38-42a8-5e59-08d5ad2bf6ba","name":"PLASTZAN INDUSTRIA E COMERCIO DE PLASTICOS LTDA","commercialName":"COPOPLAST, COPOFLEX E COPO NOBRE","cnpj":"07399260000120","city":"SÃO JOAQUIM DE BICAS","stateCode":"MG","buscaAdicional":"PLASTZAN 52337 PLASTZAN INDUSTRIA 900651"},{"id":"bbf157d3-3908-4d95-4f57-08d5ad2bf6ba","name":"ICAL INDUSTRIA DE CALCINACAO LTDA","commercialName":"","cnpj":"17157264000156","city":"SÃO JOSÉ DA LAPA","stateCode":"MG","buscaAdicional":"ICAL 1061 ICAL S J LAPA 7623 ICAL-PAINS-MG 7799"},{"id":"9dc3cdf4-629c-4cfa-4f95-08d5ad2bf6ba","name":"MINERACAO BELOCAL LTDA","commercialName":"","cnpj":"06730693000154","city":"SÃO JOSÉ DA LAPA","stateCode":"MG","buscaAdicional":"BELOCAL 1167 CIM ITAU S J LAPA 7258 MINER BELOCAL ARCOS 7650 BELOCAL MATOZINHOS 70883 BELOCAL ARCOS EI 70595"},{"id":"73ced64c-8c07-420b-644d-08d5ad2bf6ba","name":"LABORATORIO GLOBO LTDA","commercialName":"","cnpj":"17115437000173","city":"SÃO JOSÉ DA LAPA","stateCode":"MG","buscaAdicional":"LABORATORIO GLOBO 55921 LABORATORIO GLOBO LT 906585"},{"id":"e84610bc-ac1e-468f-61c4-08d5ad2bf6ba","name":"N F SUPERMERCADOS LTDA","commercialName":"CARROSSEL SUPERMERCADOS","cnpj":"17943291000154","city":"SÃO LOURENÇO","stateCode":"MG","buscaAdicional":"CARROSSEL 54388 CARROSSEL LOJA 3 906540 CARROSSEL - LOJA 1 906541 CARROSSEL LOJA 4 906544 CARROSSEL - LOJA II 906576"},{"id":"fe9f3b25-6004-4dbf-6543-08d5ad2bf6ba","name":"FRIGORIFICO FRANBOM LTDA","commercialName":"FRANBOM","cnpj":"24873010000361","city":"SÃO PEDRO DOS FERROS","stateCode":"MG","buscaAdicional":"FRANBOM 56634 FRIGORIFICO FRANBOM 908834"},{"id":"ec988836-0a26-47cd-58ba-08d5ad2bf6ba","name":"GERAES ENERGETICA LTDA","commercialName":"","cnpj":"09614511000178","city":"SÃO ROQUE DE MINAS","stateCode":"MG","buscaAdicional":"GERAES ENERGETICA 13032 SAMBURA 893842 CGH.PH.MG.031044-1.01"},{"id":"af4dc2e4-7cf4-4c07-5631-08d5ad2bf6ba","name":"AVIVAR ALIMENTOS LTDA","commercialName":"","cnpj":"42816108000105","city":"SÃO SEBASTIÃO DO OESTE","stateCode":"MG","buscaAdicional":"AVIVAR 6739 AVIVAR ALIM- SSOESTE 72097 AVIVAR SSOESTE 72063 AVIVAR ALIM INCUB 72150 AVIVAR INCUBATORIO 2 910338"},{"id":"9d953eaa-ef42-4acb-5fbd-08d5ad2bf6ba","name":"LUIZ TONIN ATACADISTA E SUPERMERCADOS S. A.","commercialName":"","cnpj":"24896425000199","city":"SÃO SEBASTIÃO DO PARAÍSO","stateCode":"MG","buscaAdicional":"TONIN 53205 TONIN VIEIRA FRANCA 905587 TONIN SAO CARLOS 905590 TONIN RIBEIRAO 905591 TONIN RIO PRETO 905592 TONIN RP LOJA 8 905613 TONIN ARARAS 18 905654 TONIN ARACATUBA 905662 TONIN ARARAQUARA 905663 TONIN FRANCA 905664 TONIN CATANDUVA LJ19 905795 TONIN MONTE SANTO MG 905796"},{"id":"a41216d0-7b23-43e5-67dd-08d5ad2bf6ba","name":"ARMAZENS GERAIS PENEIRA ALTA LTDA","commercialName":"PENEIRA ALTA","cnpj":"04485441000181","city":"SÃO SEBASTIÃO DO PARAÍSO","stateCode":"MG","buscaAdicional":"PENEIRA ALTA 58732 PENEIRA ALTA MATRIZ 912419"},{"id":"1b28f38b-008f-4fd5-88bb-08d5ae44ed50","name":"MINAS DO PARAOPEBA LIMITADA","commercialName":"","cnpj":"21867189000194","city":"SARZEDO","stateCode":"MG","buscaAdicional":"MIPASA 50436"},{"id":"1bbcd279-1336-4a19-5f9b-08d5ad2bf6ba","name":"DATA ENGENHARIA LTDA","commercialName":"","cnpj":"26389015000187","city":"SARZEDO","stateCode":"MG","buscaAdicional":"DATA ENGENHARIA 53046 DATA ENGENHARIA 900661"},{"id":"79ea5b3b-4cd6-4875-538e-08d5ad2bf6ba","name":"ITAMINAS COMERCIO DE MINERIOS SA","commercialName":"ITAMINAS","cnpj":"18752824000183","city":"SARZEDO","stateCode":"MG","buscaAdicional":"ITAMINAS 3694 ITAMINAS 71271 ITAMINAS FILIAL 899117"},{"id":"dd8b3ffe-e781-4657-5480-08d5ad2bf6ba","name":"CISER FIXADORES AUTOMOTIVOS S/A","commercialName":"CISER AUTOMOTIVE","cnpj":"12457996000148","city":"SARZEDO","stateCode":"MG","buscaAdicional":"CISER NEDS 4303 CISER NEDSCHROEF-SZD 71519"},{"id":"8ed931b6-0ab8-4d36-52c2-08d5ad2bf6ba","name":"LONAX- INDUSTRIA BRASILEIRA DE LONAS LTDA","commercialName":"","cnpj":"04784711000155","city":"SARZEDO","stateCode":"MG","buscaAdicional":"LONAX 3275 LONAX 71094"},{"id":"f83d0fd6-b7d3-4bec-5295-08d5ad2bf6ba","name":"BOMBRIL S/A","commercialName":"","cnpj":"50564053000537","city":"SETE LAGOAS","stateCode":"MG","buscaAdicional":"BOMBRIL MG 3160 BOMBRIL SETE LAGOAS 70915"},{"id":"c60ee20c-cb22-44c5-529c-08d5ad2bf6ba","name":"OMR - COMPONENTES AUTOMOTIVOS LTDA.","commercialName":"","cnpj":"03023840000168","city":"SETE LAGOAS","stateCode":"MG","buscaAdicional":"OMR 3183 OMR SETE LAGOAS 70952"},{"id":"c0588e79-adad-4ce5-5352-08d5ad2bf6ba","name":"SODECIA MINAS GERAIS INDUSTRIA DE COMPONENTES AUTOMOTIVOS LTDA","commercialName":"","cnpj":"02454348000184","city":"SETE LAGOAS","stateCode":"MG","buscaAdicional":"SODECIA 3579 SODECIA 71126"},{"id":"076fc770-2405-4e31-523a-08d5ad2bf6ba","name":"AUTO FORJAS LTDA","commercialName":"","cnpj":"25308198000368","city":"SETE LAGOAS","stateCode":"MG","buscaAdicional":"AUTO FORJAS 2946 AUTO FORJAS 70788"},{"id":"41860912-e47f-4d6a-5507-08d5ad2bf6ba","name":"COMPANHIA NACIONAL DE CIMENTO - CNC","commercialName":"CNC","cnpj":"07957149000293","city":"SETE LAGOAS","stateCode":"MG","buscaAdicional":"CNC 4922 CNC-SETE LAGOAS MG 71723"},{"id":"395bdad6-5f38-4a04-5708-08d5ad2bf6ba","name":"MULTITECNICA INDUSTRIAL LTDA","commercialName":"MULTITECNICA NUTRIENTES MINERAIS","cnpj":"71013916000124","city":"SETE LAGOAS","stateCode":"MG","buscaAdicional":"MULTITECNICA 8163 MULTITECNICA 7 LG 72427"},{"id":"c950ca1d-545f-44c3-5f7e-08d5ad2bf6ba","name":"TREVO LACTEOS S.A.","commercialName":"TREVO ALIMENTOS","cnpj":"04892455000110","city":"SETE LAGOAS","stateCode":"MG","buscaAdicional":"TREVO ALIMENTOS 52998 NOGUEIRA E REZENDE 904133"},{"id":"8efc44c8-704c-40ef-5d3d-08d5ad2bf6ba","name":"ELETRO MINERAL INDUSTRIAL LTDA","commercialName":"ELETRO MINERAL","cnpj":"05697346000104","city":"SETE LAGOAS","stateCode":"MG","buscaAdicional":"ELETRO MINERAL 51745 ELETRO MINERAL 899222"},{"id":"f12dd582-9f8c-489c-5cfc-08d5ad2bf6ba","name":"TECNOSULFUR SISTEMA DE TRATAMENTO DE METAIS LIQUIDOS S/A","commercialName":"TECNOSULFUR S/A","cnpj":"38639811000100","city":"SETE LAGOAS","stateCode":"MG","buscaAdicional":"TECNOSULFUR 51648 TECNOSULFUR 898799"},{"id":"d0598aa1-ba4e-4450-590a-08d5ad2bf6ba","name":"AVG SIDERURGIA LTDA","commercialName":"","cnpj":"20176160000284","city":"SETE LAGOAS","stateCode":"MG","buscaAdicional":"AVG SIDERURGIA 13632 AVG I-II 894565 UTE.FL.MG.031329-7.01"},{"id":"c2507cba-eada-48ad-6825-08d5ad2bf6ba","name":"CONDOMINIO DO SHOPPING SETE LAGOAS","commercialName":"CONDOMINIO DO SHOPPING SETE LAGOAS","cnpj":"23820713000105","city":"SETE LAGOAS","stateCode":"MG","buscaAdicional":"SHOP SETE LAGOAS 59440 SHOPPING SETE LAGOAS 71472"},{"id":"1d5d86cb-b1aa-4163-885a-08d5ae44ed50","name":"CONDOMINIO DO SHOPPING CENTER SETE LAGOAS","commercialName":"","cnpj":"12520668000149","city":"SETE LAGOAS","stateCode":"MG","buscaAdicional":"SHOPPING 7L 4188"},{"id":"b5810f78-e9fb-47a7-8849-08d5ae44ed50","name":"CNH INDUSTRIAL BRASIL LTDA.","commercialName":"IVECO FAB SETE LAGOAS","cnpj":"01844555000506","city":"SETE LAGOAS","stateCode":"MG","buscaAdicional":"IVECO LATIN 2369"},{"id":"5d04bf5c-ac0c-4bdf-6756-08d5ad2bf6ba","name":"METALSETE SIDERURGIA S/A","commercialName":"","cnpj":"23335979000154","city":"SETE LAGOAS","stateCode":"MG","buscaAdicional":"METALSETE 58053 METALSETE SIDERURGIA 908838 METALSETE 7 LAGOAS 912754"},{"id":"ea20740d-c2dc-4667-676f-08d5ad2bf6ba","name":"SAMA SANTA MARTA SIDERURGIA LTDA","commercialName":"SAMA","cnpj":"19881671000137","city":"SETE LAGOAS","stateCode":"MG","buscaAdicional":"SAMA MG 58096 SAMA STA MARTA SIDER 909241"},{"id":"abdbf63d-6d51-4074-6404-08d5ad2bf6ba","name":"CLUBE NAUTICO DE SETE LAGOAS","commercialName":"","cnpj":"21140033000107","city":"SETE LAGOAS","stateCode":"MG","buscaAdicional":"CLUBENAUTICOSL 55787 CLUBE NAUTICO SETE L 906578"},{"id":"307aa2a9-750d-469b-61d4-08d5ad2bf6ba","name":"TECNOSIDER SIDERURGIA LTDA","commercialName":"","cnpj":"03857484000188","city":"SETE LAGOAS","stateCode":"MG","buscaAdicional":"TECNOSIDER 54440 TECNOSIDER 908836"},{"id":"d5779c40-0288-4d2c-625a-08d5ad2bf6ba","name":"SIDERMIN - SIDERURGICA MINEIRA LTDA","commercialName":"SIDERMIN","cnpj":"04735087000104","city":"SETE LAGOAS","stateCode":"MG","buscaAdicional":"SIDERMIN 54709 SIDERMIN 908790"},{"id":"200c5269-20c9-435f-5817-08d5ad2bf6ba","name":"MANGELS INDUSTRIAL S.A.,","commercialName":"","cnpj":"61065298001508","city":"TRÊS CORAÇÕES","stateCode":"MG","buscaAdicional":"MANGELS 3C MG SP 10669 MANGELS RODAS 3 COR 7948 MANGELS CILIND 3 COR 7950"},{"id":"b2756177-7f82-449c-5730-08d5ad2bf6ba","name":"KERRY DO BRASIL LTDA","commercialName":"","cnpj":"02332686000909","city":"TRÊS CORAÇÕES","stateCode":"MG","buscaAdicional":"KERRY TC 8312 KERRY 70706"},{"id":"a467dad5-f699-4f08-5037-08d5ad2bf6ba","name":"SAO MARCO INDUSTRIA E COMERCIO LTDA","commercialName":"","cnpj":"54022744000136","city":"TRÊS CORAÇÕES","stateCode":"MG","buscaAdicional":"SAO MARCO 1519 SAO MARCO 3 COR 7952"},{"id":"524d4250-5ea0-4feb-5038-08d5ad2bf6ba","name":"NEOVIA NUTRICAO E SAUDE ANIMAL LTDA.","commercialName":"","cnpj":"18631739000167","city":"TRÊS CORAÇÕES","stateCode":"MG","buscaAdicional":"NEOVIA MG 1520 TOTAL ALIM 3 COR 7946"},{"id":"7e64304a-1975-4cbb-4ef7-08d5ad2bf6ba","name":"VOTORANTIM METAIS ZINCO S.A.","commercialName":"","cnpj":"42416651000107","city":"TRÊS MARIAS","stateCode":"MG","buscaAdicional":"VMZ 36 VMZ-JUIZ DE FORA-MG 48 VMZ TRES MARIAS 138 7648 VMZ-VAZANTE-MG 7707 VMZ-M AG-PARACATU 7711 SERRA DA FORTALEZA 7759 IGARAPAVA (VMZ) 894723 UHE.PH.SP.001098-7.01 CAPIM BRANCO1-VMZ 8133 UHE.PH.MG.027483-6.01 CAPIM BRANCO2-VMZ 8222 UHE.PH.MG.027484-4.01 PICADA 8156 UHE.PH.MG.002053-2.01"},{"id":"3364ac10-0d25-431c-53c3-08d5ad2bf6ba","name":"BIOENERGETICA AROEIRA S.A.","commercialName":"BIOENERGETICA AROEIRA","cnpj":"08355201000113","city":"TUPACIGUARA","stateCode":"MG","buscaAdicional":"UTE BIOENERGETICA AROEIRA 3827 UTE BIOENERG AROEIRA 892622 UTE.AI.MG.030313-5.01"},{"id":"d19952f3-f9a4-4a36-53a0-08d5ad2bf6ba","name":"ITATIAIA MOVEIS S A","commercialName":"ITATIAIA","cnpj":"25331521000152","city":"UBÁ","stateCode":"MG","buscaAdicional":"ITATIAIA 3734 ITATIAIA 71237"},{"id":"d3facd51-629e-4eda-545d-08d5ad2bf6ba","name":"TCIL MOVEIS LTDA","commercialName":"","cnpj":"38542932000139","city":"UBÁ","stateCode":"MG","buscaAdicional":"TCIL 4192 TCIL-UBA 71466 TCIL FILIAL 899084"},{"id":"1d3d475c-5175-4061-5512-08d5ad2bf6ba","name":"PALMEIRA INDUSTRIA E COMERCIO DE MOVEIS LTDA","commercialName":"MOVEIS PALMEIRAS","cnpj":"20354981000425","city":"UBÁ","stateCode":"MG","buscaAdicional":"PALMEIRA 5003 PALMEIRA-UBA MG 71932"},{"id":"1aa9b8e2-ef08-4b47-5554-08d5ad2bf6ba","name":"FAENZA PLANEJADOS LTDA","commercialName":"","cnpj":"02900570000163","city":"UBÁ","stateCode":"MG","buscaAdicional":"FAENZA 5351 FAENZA PLANEJADO-UBA 71953"},{"id":"d5b8f080-c162-4497-5578-08d5ad2bf6ba","name":"VALVERDE INDUSTRIA E TRANSPORTES LTDA","commercialName":"","cnpj":"25474875000156","city":"UBÁ","stateCode":"MG","buscaAdicional":"VALVERDE 5691 VALVERDE-UBA 71950"},{"id":"520d8074-3eda-4299-5587-08d5ad2bf6ba","name":"MOVEIS NOVO HORIZONTE LTDA","commercialName":"","cnpj":"19672054000121","city":"UBÁ","stateCode":"MG","buscaAdicional":"NOVO HORIZONTE 5757 NOVO HORIZONTE -UBA 71910"},{"id":"a8224591-e878-4a69-5713-08d5ad2bf6ba","name":"HOME DESIGN MOVEIS LTDA","commercialName":"","cnpj":"09360522000179","city":"UBÁ","stateCode":"MG","buscaAdicional":"HOME DESIGN 8189 HOME DESIGN 888331"},{"id":"a356cacd-897e-4911-56f5-08d5ad2bf6ba","name":"IMOP IND DE MOVEIS PASCHOALINO LTDA","commercialName":"","cnpj":"25721960000171","city":"UBÁ","stateCode":"MG","buscaAdicional":"IMOP 8021 MOVEIS PASCHOALINO 72426"},{"id":"6e5c23c5-8d17-49d0-5820-08d5ad2bf6ba","name":"SIER MOVEIS LTDA","commercialName":"","cnpj":"38705406000142","city":"UBÁ","stateCode":"MG","buscaAdicional":"SIER MOVEIS 10809 SIER MOVEIS 01 889627 SIER II 890008"},{"id":"108dbad0-ec20-407a-587e-08d5ad2bf6ba","name":"CAROLINA MOVEIS INDUSTRIA E COMERCIO LTDA","commercialName":"","cnpj":"86420056000110","city":"UBÁ","stateCode":"MG","buscaAdicional":"CAROLINA MOVEIS 12012 CAROLINA MOVEIS 890707"},{"id":"9b98b60c-a88b-4c3d-5f12-08d5ad2bf6ba","name":"MADEMARQUES MOVEIS LTDA","commercialName":"","cnpj":"25760786000176","city":"UBÁ","stateCode":"MG","buscaAdicional":"MADEMARCS 52724 MADEMARCS 903436"},{"id":"845dfbda-3b72-4457-620a-08d5ad2bf6ba","name":"UBA-FERROMINAS PERFILADOS LTDA.","commercialName":"FERROMINAS PERFILADOS","cnpj":"15562372000189","city":"UBÁ","stateCode":"MG","buscaAdicional":"FERROMINAS PERFILADOS 54518 FERROMINAS 906738"},{"id":"5db631ef-147b-44a2-6762-08d5ad2bf6ba","name":"VALDEMOVEIS INDUSTRIA, COMERCIO, TRANSP. IMPORTACAO E EXPORTACAO DE MOVEIS LTDA","commercialName":"VALDEMOVEIS","cnpj":"64359235000157","city":"UBÁ","stateCode":"MG","buscaAdicional":"VALDEMOVEIS 58072 VALDEMOVEIS 909272"},{"id":"d1aa32ed-446f-4057-672d-08d5ad2bf6ba","name":"INDUSTRIA E COMERCIO DE MOVEIS EUROPA LTDA","commercialName":"","cnpj":"25777392000120","city":"UBÁ","stateCode":"MG","buscaAdicional":"EUROPA 57992 MOVEIS EUROPA 909406"},{"id":"6d8c890b-af5d-4fea-65f3-08d5ad2bf6ba","name":"MINASTEX INDUSTRIA DE CORTE E PAINEIS LTDA","commercialName":"","cnpj":"06340287000185","city":"UBÁ","stateCode":"MG","buscaAdicional":"MINASTEX 57234 MINASTEX 907148"},{"id":"fbde3b5c-3b34-4b27-6862-08d5ad2bf6ba","name":"D DORO MOVEIS LTDA","commercialName":"D DORO MOVEIS","cnpj":"02534930000150","city":"UBÁ","stateCode":"MG","buscaAdicional":"D DORO MOVEIS 59892 D DORO MOVEIS 910894"},{"id":"7515ebcd-4184-4830-693f-08d5ad2bf6ba","name":"OURO FINO QUIMICA LTDA.","commercialName":"OURO FINO QUIMICA","cnpj":"09100671000107","city":"UBERABA","stateCode":"MG","buscaAdicional":"OURO FINO QUIMICA 60938 OURO FINO QUIMICA 911286"},{"id":"d2e711aa-f4b5-4726-662b-08d5ad2bf6ba","name":"FMC QUIMICA DO BRASIL LTDA.","commercialName":"","cnpj":"04136367000511","city":"UBERABA","stateCode":"MG","buscaAdicional":"FMC 57379 FMC QUIMICA BRASIL 908374"},{"id":"08a5d77f-a7b0-41ae-64db-08d5ad2bf6ba","name":"CCM INDUSTRIA E COMERCIO DE PRODUTOS DESCARTAVEIS S.A.","commercialName":"","cnpj":"12288046000137","city":"UBERABA","stateCode":"MG","buscaAdicional":"CCM DESCARTAVEIS 56282 CCM DESCARTAVEIS 906581"},{"id":"f8a56b76-3cff-4ea8-7409-08d5cf600bef","name":"COMPANHIA MINEIRA DE ACUCAR E ALCOOL PARTICIPACOES","commercialName":"","cnpj":"08493364000162","city":"UBERABA","stateCode":"MG","buscaAdicional":""},{"id":"508900da-e5a2-4bfb-60e7-08d5ad2bf6ba","name":"PRACA UBERABA SHOPPING CENTER LTDA","commercialName":"","cnpj":"13901908000207","city":"UBERABA","stateCode":"MG","buscaAdicional":"PCA UBERABA SHOPPING 53875 PRACA UBERABA SHOP 904952"},{"id":"7833a76b-ee24-4bea-56b6-08d5ad2bf6ba","name":"INPA - INDUSTRIA DE EMBALAGENS SANTANA S/A","commercialName":"INPA","cnpj":"23524952000703","city":"UBERABA","stateCode":"MG","buscaAdicional":"INPA INDUSTRIA 7526 INPA-UBERABA 72282"},{"id":"2a9ec3a0-a560-42c2-538d-08d5ad2bf6ba","name":"SIPCAM NICHINO BRASIL S.A.","commercialName":"","cnpj":"23361306000179","city":"UBERABA","stateCode":"MG","buscaAdicional":"SIB 3693 SIPCAM ISAGRO BRASIL 71239"},{"id":"72532fa7-cb56-4b88-51dc-08d5ad2bf6ba","name":"VALE DO TIJUCO ACUCAR E ALCOOL S.A.","commercialName":"USINA VALE DO TIJUCO","cnpj":"08493354000127","city":"UBERABA","stateCode":"MG","buscaAdicional":"VALE TIJUCO 2631 VALE TIJUCO II CONS 888250 VALE DO TIJUCO II 8991 UTE.AI.MG.030473-5.01 VALE DO TIJUCO 8664 UTE.AI.MG.030034-9.01"},{"id":"320ff208-e8c6-4401-5183-08d5ad2bf6ba","name":"BLACK & DECKER DO BRASIL LTDA","commercialName":"","cnpj":"53296273000191","city":"UBERABA","stateCode":"MG","buscaAdicional":"BLACKEDECKER 2223 BLACK E DECKER 70676"},{"id":"846dc6b7-ac3a-4718-51a4-08d5ad2bf6ba","name":"SOCIEDADE EDUCACIONAL UBERABENSE","commercialName":"UNIUBE - UNIVERSIDADE DE UBERABA","cnpj":"25452301000187","city":"UBERABA","stateCode":"MG","buscaAdicional":"SEU 2456 UNIVERS. UBERABA 70743 POCOES 8526 CGH.PH.MG.029231-1.01"},{"id":"7e95afd8-95b7-4547-525f-08d5ad2bf6ba","name":"POLYVIN PLASTICOS E DERIVADOS LTDA","commercialName":"","cnpj":"41664871000197","city":"UBERABA","stateCode":"MG","buscaAdicional":"POLYVIN 3032 POLYVIN PLAST/DERIV 70852"},{"id":"0687245d-b848-4e2e-527d-08d5ad2bf6ba","name":"CONDOMINIO DO SHOPPING CENTER UBERABA","commercialName":"","cnpj":"03038362000160","city":"UBERABA","stateCode":"MG","buscaAdicional":"SHOP UBERABA 3091 SHOPPING C. UBERABA 70858"},{"id":"464a6eba-9f92-4b3b-5283-08d5ad2bf6ba","name":"CENTER SHOPPING S/A","commercialName":"CENTER SHOPPING","cnpj":"38720884000121","city":"UBERLÂNDIA","stateCode":"MG","buscaAdicional":"CENTER SHOP 3098 CENTER SHOP UBERLAND 70860"},{"id":"6f81089b-34a1-4587-52c8-08d5ad2bf6ba","name":"MARTINS COMERCIO E SERVICOS DE DISTRIBUICAO S/A","commercialName":"ARMAZENS MARTINS","cnpj":"43214055000107","city":"UBERLÂNDIA","stateCode":"MG","buscaAdicional":"MARTINS 3309 MARTINS MATRIZ-DI 71226 MARTINS-CA 71227 MARTINS D13 71234 MARTINS VENDAS 908309"},{"id":"1896dae3-213c-44c4-52c1-08d5ad2bf6ba","name":"ALGAR TECNOLOGIA E CONSULTORIA S.A.","commercialName":"","cnpj":"21246699000144","city":"UBERLÂNDIA","stateCode":"MG","buscaAdicional":"ALGAR TECNOLOGIA 3273 ALGAR TECNOLOGIA 899204 ALGAR SEDE 902918"},{"id":"4511555f-61cb-4601-52f3-08d5ad2bf6ba","name":"ALGAR CELULAR S/A","commercialName":"ALGAR TELECOM","cnpj":"05835916000185","city":"UBERLÂNDIA","stateCode":"MG","buscaAdicional":"ALGAR CELULAR 3364 CTBC CELULAR ULA236 71015 CTBC CELULAR ULA232 71016"},{"id":"03b285c3-b9ae-43fd-52d6-08d5ad2bf6ba","name":"ALGAR TELECOM S/A","commercialName":"ALGAR TELECOM","cnpj":"71208516000174","city":"UBERLÂNDIA","stateCode":"MG","buscaAdicional":"ALGAR TELECOM 3329 CTBC TELECOM ITUIUTA 71003 CTBC TELECOM UBERL 71004 CTBC TELECOM P MINAS 71014 CTBC TELECOM-FRANCA 71160 ALGAR TELECOM UBERAB 900078 ALGAR TELECOM CDI 913299 ALGAR TELECOM IMAGE 913334"},{"id":"c01eee47-b8ee-4250-5234-08d5ad2bf6ba","name":"HIDRELETRICA MALAGONE S.A","commercialName":"","cnpj":"09251924000135","city":"UBERLÂNDIA","stateCode":"MG","buscaAdicional":"HMSA 2922 MALAGONE 8682 PCH.PH.MG.029646-5.01"},{"id":"a4bbb2b2-7bd3-441b-4f90-08d5ad2bf6ba","name":"CARGILL AGRICOLA S A","commercialName":"CARGILL","cnpj":"60498706013488","city":"UBERLÂNDIA","stateCode":"MG","buscaAdicional":"CARGILL ULA 1159 CARGILL AGR UBERLAND 7785"},{"id":"d048d516-5525-4e3b-4fd3-08d5ad2bf6ba","name":"SOUZA CRUZ LTDA","commercialName":"","cnpj":"33009911001887","city":"UBERLÂNDIA","stateCode":"MG","buscaAdicional":"SOUZA CRUZ 1295 SOUZA CRUZ UBERLANDI 7797"},{"id":"fe234b2c-8ebc-4b6a-503d-08d5ad2bf6ba","name":"ABC-INDUSTRIA E COMERCIO S/A-ABC-INCO","commercialName":"","cnpj":"17835042000145","city":"UBERLÂNDIA","stateCode":"MG","buscaAdicional":"ABC INCO 1534 ABC INCO UBERLANDIA 7954 ABC INDUSTRIA E COM 907571 UTE ALGAR AGRO 912091 UTE.FL.MG.035567-4.01"},{"id":"21297bf7-9931-49f7-5522-08d5ad2bf6ba","name":"ENERGAS GERACAO DE ENERGIA LTDA.","commercialName":"ENERGAS","cnpj":"13729756000118","city":"UBERLÂNDIA","stateCode":"MG","buscaAdicional":"ENERGAS 5109 UBERLANDIA 8968 UTE.RU.MG.030728-9.01"},{"id":"d9a11934-e768-4232-54a1-08d5ad2bf6ba","name":"PRAIA CLUBE","commercialName":"PRAIA CLUBE","cnpj":"25762741000130","city":"UBERLÂNDIA","stateCode":"MG","buscaAdicional":"PRAIA CLUBE 4397 PRAIA CLUBE-UBERLND 71558"},{"id":"9cfcc10b-62db-4a3f-54ba-08d5ad2bf6ba","name":"EPS EMPREENDIMENTOS S/A","commercialName":"","cnpj":"06252519000143","city":"UBERLÂNDIA","stateCode":"MG","buscaAdicional":"EPS 4466 EPS CONVENCOES HOTEL 71621 EPS EMPREENDIMENTOS 890202"},{"id":"1bad0f21-ab59-422f-570f-08d5ad2bf6ba","name":"UBERLANDIA REFRESCOS LTDA.","commercialName":"","cnpj":"23814940000110","city":"UBERLÂNDIA","stateCode":"MG","buscaAdicional":"UBERLANDIAREF 8183 UBERLANDIA REF 888160"},{"id":"2048aacd-5795-494d-60e8-08d5ad2bf6ba","name":"REPET INDUSTRIA DE EMBALAGENS E FRASCOS PLASTICOS LTDA","commercialName":"REPET EMBALAGENS","cnpj":"09170802000467","city":"UBERLÂNDIA","stateCode":"MG","buscaAdicional":"REPET INDUSTRIA 53877 REPET INDUSTRIA 904954"},{"id":"fce00f07-e060-455e-5ef8-08d5ad2bf6ba","name":"D'VILLE SUPERMERCADOS S.A.","commercialName":"","cnpj":"07799905000112","city":"UBERLÂNDIA","stateCode":"MG","buscaAdicional":"DVILLE UBERLANDIA 52672 DVILLE UBERLANDIA 902981 DVILLE TIBERY 903033 DVILLE KARAIBA MG 903034 DVILLE SARAIVA MG 903035"},{"id":"4621a8fb-ee1e-48fd-5f35-08d5ad2bf6ba","name":"ADIMAX - INDUSTRIA E COMERCIO DE ALIMENTOS LTDA.","commercialName":"","cnpj":"03887324000696","city":"UBERLÂNDIA","stateCode":"MG","buscaAdicional":"ADIMAX MG 52847 ADIMAX MG 906563"},{"id":"f82720e0-fe9b-401e-5ea0-08d5ad2bf6ba","name":"TECNOSEEDS BRASIL SEMENTES & SERVICOS LTDA","commercialName":"TECNOSEEDS","cnpj":"14411002000269","city":"UBERLÂNDIA","stateCode":"MG","buscaAdicional":"TECNOSEEDS 52467 TECNOSSEDS UBERLANDI 901504"},{"id":"84e90ab7-8f4a-49cd-5b48-08d5ad2bf6ba","name":"CONDOMINIO UBERLANDIA SHOPPING","commercialName":"","cnpj":"18614523000193","city":"UBERLÂNDIA","stateCode":"MG","buscaAdicional":"COND UBERLANDIA SHOPPING 50560 UBERLANDIA SHOPPING 897446"},{"id":"e504d7ee-7190-42d2-5c81-08d5ad2bf6ba","name":"CALLINK SERVICOS DE CALL CENTER LTDA","commercialName":"CALLINK","cnpj":"08331318000167","city":"UBERLÂNDIA","stateCode":"MG","buscaAdicional":"CALLINK 51362 CALLING CALL CENTER 898957"},{"id":"ce1c5236-16de-4b26-8db1-08d5d060706e","name":"REAL DISTRIBUIDORA DE CARNES LTDA","commercialName":"FRIGORIFICO REAL","cnpj":"21465927000177","city":"UBERLÂNDIA","stateCode":"MG","buscaAdicional":"FRIGORIFICO REAL 62771 FRIGORIFICO REAL 913472"},{"id":"8d23c9dc-db2d-4250-4ee2-08d5d159243d","name":"CONCESSIONARIA DE RODOVIAS MINAS GERAIS GOIAS S/A","commercialName":"","cnpj":"19208022000170","city":"UBERLÂNDIA","stateCode":"MG","buscaAdicional":""},{"id":"c2d6b053-4bef-484d-64cb-08d5ad2bf6ba","name":"HOSPITAL SANTA GENOVEVA LTDA","commercialName":"","cnpj":"18484378000173","city":"UBERLÂNDIA","stateCode":"MG","buscaAdicional":"HSG - UBERLANDIA 56224 HOSP STA GENOVEVA 906236"},{"id":"6cd8210f-7901-4f2e-882e-08d5ae44ed50","name":"DAIWA DO BRASIL TEXTIL LTDA. EM LIQUIDACAO","commercialName":"","cnpj":"43628429000130","city":"UBERLÂNDIA","stateCode":"MG","buscaAdicional":"DAIWA 1116 DAIWA-UBERLANDIA-MG 7660"},{"id":"502ad9a7-aa9f-49c8-696b-08d5ad2bf6ba","name":"HOSPITAL E MATERNIDADE SANTA CLARA LTDA","commercialName":"","cnpj":"25761040000187","city":"UBERLÂNDIA","stateCode":"MG","buscaAdicional":"HOSP SANTA CLARA UBERLANDIA 61291 HOSPITAL STA CLARA 912454"},{"id":"86d6abd3-fc4d-45d8-684d-08d5ad2bf6ba","name":"BESTWAY DO BRASIL LOGISTICA LTDA","commercialName":"BESTWAY LOGISTICA DO BRASIL","cnpj":"12115869000160","city":"UBERLÂNDIA","stateCode":"MG","buscaAdicional":"BEST WAY 59690 BEST WAY - FILIAL 3 912213 BEST WAY - FILIAL 4 912214"},{"id":"bb6aebc5-3414-4de1-681d-08d5ad2bf6ba","name":"ARCOM S/A","commercialName":"ARCOM","cnpj":"25769266000124","city":"UBERLÂNDIA","stateCode":"MG","buscaAdicional":"ARCOM 59363 ARCOM SA 909202"},{"id":"d99e089f-93c4-4040-6817-08d5ad2bf6ba","name":"PRACA UBERLANDIA SHOPPING CENTER LTDA","commercialName":"","cnpj":"97527149000246","city":"UBERLÂNDIA","stateCode":"MG","buscaAdicional":"PRACA UBERLANDIA SHOPPING 59342 PRACA UBERLANDIA SH 909204"},{"id":"f48fbd19-f9ed-40fd-635f-08d5ad2bf6ba","name":"COOPERATIVA AGROPECUARIA UNAI LTDA","commercialName":"CAPUL","cnpj":"25834847000100","city":"UNAÍ","stateCode":"MG","buscaAdicional":"CAPUL 55329 CAPUL RACAO 907166 CAPUL LATICINIOS 907167"},{"id":"3bce06af-f885-4cdd-58da-08d5ad2bf6ba","name":"MATA VELHA ENERGETICA S/A","commercialName":"","cnpj":"11083857000139","city":"UNAÍ","stateCode":"MG","buscaAdicional":"CPFL MATA VELHA 13412 MATA VELHA 898954 PCH.PH.MG.028607-9.01"},{"id":"4fc416ec-afaa-4883-686c-08d5ad2bf6ba","name":"FRIGORIFICO SAO JOAQUIM LTDA","commercialName":"CIACARNE ALIMENTOS","cnpj":"07946019000174","city":"URUCÂNIA","stateCode":"MG","buscaAdicional":"CIACARNE ALIMENTOS 59991 FRIGORIFICO SAO JOAQ 911697"},{"id":"e63405f8-c52d-48ba-6849-08d5ad2bf6ba","name":"COLECAO INDUSTRIA E COMERCIO DE INFORMATICA, TELECOMUNICACOES E ELETRONICA LTDA","commercialName":"COLETEK","cnpj":"06043130000198","city":"VARGINHA","stateCode":"MG","buscaAdicional":"COLETEK 59665 COLETEK 909200"},{"id":"85038e38-94f8-4188-5e00-08d5ad2bf6ba","name":"MOINHO SUL MINEIRO SA","commercialName":"SM ALIMENTOS","cnpj":"25860305000102","city":"VARGINHA","stateCode":"MG","buscaAdicional":"SM ALIMENTOS 52146 MOINHO SUL MINEIRO 900841"},{"id":"20222055-9ef0-4da2-5d4a-08d5ad2bf6ba","name":"ASSOCIACAO DO VIA CAFE GARDEN SHOPPING","commercialName":"","cnpj":"23066373000160","city":"VARGINHA","stateCode":"MG","buscaAdicional":"SHOP CAFE GARDEN 51773 SHOP GARDEN VARGINHA 903223"},{"id":"2479e620-899a-4900-60ea-08d5ad2bf6ba","name":"FERMAVI ELETROQUIMICA LTDA","commercialName":"","cnpj":"23759905000145","city":"VARGINHA","stateCode":"MG","buscaAdicional":"FERMAVI 53898 FERMAVI 904124"},{"id":"ad9247a6-37d7-46cc-50af-08d5ad2bf6ba","name":"PHILIPS DO BRASIL LTDA","commercialName":"WALITA","cnpj":"61086336014406","city":"VARGINHA","stateCode":"MG","buscaAdicional":"DIVISAO WALITA 1783 WALITA VARGINHA 70175"},{"id":"7c6c3efb-d7cd-4b7a-5298-08d5ad2bf6ba","name":"COOPER-STANDARD AUTOMOTIVE BRASIL SEALING LTDA","commercialName":"COOPER STANDARD AUTOMOTIVE","cnpj":"00362831000103","city":"VARGINHA","stateCode":"MG","buscaAdicional":"COOPERSTANDARD 3168 COOPSTANDARD VARGINH 70936 COOPER STANDARD 905581"},{"id":"adfbdf93-77b7-4281-504c-08d5ad2bf6ba","name":"SADA SIDERURGIA LTDA","commercialName":"","cnpj":"06069703000152","city":"VÁRZEA DA PALMA","stateCode":"MG","buscaAdicional":"SADA SIDER 1561 SADA SIDER V PALMA 7639"},{"id":"3ab66bda-fbe7-4ed0-4f69-08d5ad2bf6ba","name":"EMPRESA DE CIMENTOS LIZ S.A","commercialName":"","cnpj":"33920299000313","city":"VESPASIANO","stateCode":"MG","buscaAdicional":"ECLSA 1090 SOEICOM LIVRE 7617"},{"id":"77c830d2-8409-4c94-4f55-08d5ad2bf6ba","name":"BMB BELGO MINEIRA BEKAERT ARTEFATOS DE ARAME LTDA","commercialName":"BELGO MINEIRA BEKAERT BMB","cnpj":"18786988000121","city":"VESPASIANO","stateCode":"MG","buscaAdicional":"BMB VESP 1058 BMB-VESPASIANO-MG 7693 BMB-ITAUNA-MG 7793"},{"id":"fc562fec-3ffa-4599-514b-08d5ad2bf6ba","name":"STEPAN QUIMICA LTDA.","commercialName":"","cnpj":"01898598000221","city":"VESPASIANO","stateCode":"MG","buscaAdicional":"STEPAN 2101 STEPAN QUIMICA 70443"},{"id":"34b4fa25-1e8c-476d-55bc-08d5ad2bf6ba","name":"TECNOMETAL ENGENHARIA E CONSTRUCOES MECANICAS LTDA","commercialName":"","cnpj":"38625489000160","city":"VESPASIANO","stateCode":"MG","buscaAdicional":"TECNOMETAL 6041 TECNOMETAL VESPASIAN 71902"},{"id":"e7f442e6-2f36-4e66-5cb7-08d5ad2bf6ba","name":"INSTITUTO HERMES PARDINI S/A","commercialName":"","cnpj":"19378769005305","city":"VESPASIANO","stateCode":"MG","buscaAdicional":"HERMES PARDINI - NTO 51539 HERMES PARDINI - NTO 898294"},{"id":"60b24a53-087d-40aa-5859-08d5ad2bf6ba","name":"GLOBALFRUIT INDUSTRIA E COMERCIO LTDA","commercialName":"GLOBALFRUIT","cnpj":"04963806000136","city":"VISCONDE DO RIO BRANCO","stateCode":"MG","buscaAdicional":"GLOBALFRUIT 11449 GLOBALFRUIT 890211"},{"id":"33a6e980-2ef1-47db-5465-08d5ad2bf6ba","name":"MOVEIS B P LTDA","commercialName":"MOVEIS BOM PASTOR","cnpj":"01610917000170","city":"VISCONDE DO RIO BRANCO","stateCode":"MG","buscaAdicional":"BOM PASTOR 4208 BOM PASTOR-MATRIZ 71468 BOM PASTOR-FILIAL 71469"},{"id":"09d95760-7186-48a8-5286-08d5ad2bf6ba","name":"RIO BRANCO ALIMENTOS S/A","commercialName":"PIF PAF","cnpj":"05017780000449","city":"VISCONDE DO RIO BRANCO","stateCode":"MG","buscaAdicional":"PIFPAFRARB 3106 PIF PAF RACOES 70921"},{"id":"c836320a-6c18-4d77-6727-08d5ad2bf6ba","name":"MEGA PACK EMBALAGENS LTDA","commercialName":"","cnpj":"11790756000106","city":"VISCONDE DO RIO BRANCO","stateCode":"MG","buscaAdicional":"MEGA PACK 57983 MEGA PACK 909269"},{"id":"eddefa8a-21ee-4f23-6623-08d5ad2bf6ba","name":"TOLEDO MINERACAO LTDA","commercialName":"","cnpj":"04760993000150","city":"ÁGUA DOCE DO NORTE","stateCode":"ES","buscaAdicional":"TOLEDO MINERACAO 57370 TOLEDO MATRIZ 906407 TOLEDO INDUSTRIAL 906436"},{"id":"169c3405-1d5b-4aa6-4ef8-08d5d159243d","name":"VENTURE CAPITAL PARTICIPACOES E INVESTIMENTOS S/A","commercialName":"","cnpj":"24241659000106","city":"ALFREDO CHAVES","stateCode":"ES","buscaAdicional":""},{"id":"ce75bf2f-5896-478b-64ac-08d5ad2bf6ba","name":"IMETAME METALMECANICA LTDA","commercialName":"","cnpj":"31790710000196","city":"ARACRUZ","stateCode":"ES","buscaAdicional":"IMETAME METAL 56150 IMETAME ARACRUZ 906406"},{"id":"598f22c4-7335-465e-4f4a-08d5ad2bf6ba","name":"CHEMTRADE BRASIL LTDA","commercialName":"","cnpj":"03461875000189","city":"ARACRUZ","stateCode":"ES","buscaAdicional":"CHEMTRADE 201 NEXEN LIVRE 7008"},{"id":"bdc23100-3b25-492d-507f-08d5ad2bf6ba","name":"EVONIK BRASIL LTDA","commercialName":"","cnpj":"62695036004858","city":"ARACRUZ","stateCode":"ES","buscaAdicional":"EVONIK DBR 1655 DEGUSSA-ARACRUZ-ES 7166"},{"id":"13079592-ae08-489f-5a04-08d5ad2bf6ba","name":"ESTALEIRO JURONG ARACRUZ LTDA.","commercialName":"","cnpj":"11200595000145","city":"ARACRUZ","stateCode":"ES","buscaAdicional":"EJA 16375 ESTALEIRO JURONG 895643"},{"id":"030eddf6-9642-4827-5d14-08d5ad2bf6ba","name":"IMETAME ENERGIA LTDA.","commercialName":"IMETAME ENERGIA","cnpj":"00271847000100","city":"ARACRUZ","stateCode":"ES","buscaAdicional":"IMETAME 51696"},{"id":"31fe0479-8bf4-4311-5d40-08d5ad2bf6ba","name":"CONDOMINIO DO SHOPPING ORIUNDI","commercialName":"","cnpj":"21512981000126","city":"ARACRUZ","stateCode":"ES","buscaAdicional":"SHOPPING ORIUNDI 51748 SHOPPING ORIUNDI 898801"},{"id":"c5c8a203-8144-44fa-5ca3-08d5ad2bf6ba","name":"ABAV-ABATEDOURO ATILIO VIVACQUA LTDA","commercialName":"","cnpj":"02838996000134","city":"ATILIO VIVACQUA","stateCode":"ES","buscaAdicional":"ABAV 51455 ABAV ATILIO VIVACQUA 898705"},{"id":"7f89d532-fdeb-4b6d-5f9e-08d5ad2bf6ba","name":"TOLEDO GRANITOS DO BRASIL LTDA","commercialName":"","cnpj":"03848164000161","city":"BARRA DE SÃO FRANCISCO","stateCode":"ES","buscaAdicional":"TOLEDO GRANITOS 53049 TOLEDO GRANITOS 901085"},{"id":"44d753b6-e82f-4fc1-5c6e-08d5ad2bf6ba","name":"IGM-INTERNACIONAL GRANITOS E MARMORES LTDA","commercialName":"","cnpj":"04935022000102","city":"BARRA DE SÃO FRANCISCO","stateCode":"ES","buscaAdicional":"IGM INTERNACIONAL 51315 IGM INTERNACIONAL ES 898578"},{"id":"768133b8-a11f-46a5-6363-08d5ad2bf6ba","name":"THORGRAN GRANITOS LTDA","commercialName":"THORGRAN GRANITOS","cnpj":"03980822000174","city":"BARRA DE SÃO FRANCISCO","stateCode":"ES","buscaAdicional":"THORGRAN GRANITOS 55333 THORGRAN GRANITOS 905832 THORGRAN GRANITOS BR 905837"},{"id":"9adfe814-187b-4809-6364-08d5ad2bf6ba","name":"THOR NORTE GRANITOS LTDA","commercialName":"","cnpj":"04712800000196","city":"BARRA DE SÃO FRANCISCO","stateCode":"ES","buscaAdicional":"THORNORTE GRANITOS 55334 THOR NORTE GRANITOS 905834 THOR NORTE GRAN ST 905853"},{"id":"f8507338-24c3-4afa-68f7-08d5ad2bf6ba","name":"MINERACAO THOMAZINI LTDA","commercialName":"MINERACAO THOMAZINI","cnpj":"36346393000137","city":"BARRA DE SÃO FRANCISCO","stateCode":"ES","buscaAdicional":"MINERACAO THOMAZINI 60654 MINERACAO THOMAZINI 910584"},{"id":"01a04cf1-ee1c-4adb-883d-08d5ae44ed50","name":"ITABIRA AGRO INDUSTRIAL S A","commercialName":"","cnpj":"27175959000114","city":"CACHOEIRO DE ITAPEMIRIM","stateCode":"ES","buscaAdicional":"ITABIRA CI 1724 ITABIRA ITAPEMIRIM 70095"},{"id":"19c118ef-bf02-42c4-65b8-08d5ad2bf6ba","name":"INDUSTRIA DE MARMORES ITALVA LTDA","commercialName":"IMIL","cnpj":"28932846000189","city":"CACHOEIRO DE ITAPEMIRIM","stateCode":"ES","buscaAdicional":"IMIL 56994 MARMORES ITALVA 905840"},{"id":"d3356a9e-9b60-40df-6730-08d5ad2bf6ba","name":"MARBRASA MARMORES E GRANITOS DO BRASIL S.A","commercialName":"MARBRASA","cnpj":"27189489000148","city":"CACHOEIRO DE ITAPEMIRIM","stateCode":"ES","buscaAdicional":"MARBRASA MARMORES 57996 MARBRASA CACHOEIRO 910585"},{"id":"78cf5502-ab39-4d2e-67a4-08d5ad2bf6ba","name":"MULTI SERVICE MARMORES E GRANITOS EIRELI","commercialName":"","cnpj":"23571937000112","city":"CACHOEIRO DE ITAPEMIRIM","stateCode":"ES","buscaAdicional":"MULTI SERVICE 58379 MULTI SERVICE GRANIT 911959"},{"id":"8b5f6908-0391-4b4c-678d-08d5ad2bf6ba","name":"SANTO ANTONIO GRANITOS LTDA","commercialName":"","cnpj":"27188739000125","city":"CACHOEIRO DE ITAPEMIRIM","stateCode":"ES","buscaAdicional":"SANTO ANTONIO GRANITOS 58275 STO ANT GRAN FILIAL 908100 STO ANT GRAN MATRIZ 908119"},{"id":"7d1cc8a8-41ee-4d13-63bb-08d5ad2bf6ba","name":"SB MINERACAO LTDA","commercialName":"","cnpj":"02614827000110","city":"CACHOEIRO DE ITAPEMIRIM","stateCode":"ES","buscaAdicional":"SB MINERACAO 55591 SB MINERACAO 904357"},{"id":"77f0e317-87e8-429a-63f7-08d5ad2bf6ba","name":"PROVALE DISTRIBUIDORA DE CARBONATOS LTDA","commercialName":"","cnpj":"05593782000133","city":"CACHOEIRO DE ITAPEMIRIM","stateCode":"ES","buscaAdicional":"PROVALE GIRONDA 55758 PROVALE PROBARI 905810 PROVALE GIRONDA 905829"},{"id":"b81c81a6-e025-4784-63f8-08d5ad2bf6ba","name":"PROVALE INDUSTRIA E COMERCIO S A","commercialName":"PROVALE","cnpj":"27071778000148","city":"CACHOEIRO DE ITAPEMIRIM","stateCode":"ES","buscaAdicional":"PROVALE 55759 PROVALE MATRIZ 904084 PROVALE INDUSTRIA 904093"},{"id":"0a224ebb-b466-47b7-63ed-08d5ad2bf6ba","name":"FUNDICAO MUNDIAL LTDA","commercialName":"","cnpj":"07470286000118","city":"CACHOEIRO DE ITAPEMIRIM","stateCode":"ES","buscaAdicional":"FUNDICAO MUNDIAL 55718 FUNDICAO MUNDIAL 905855"},{"id":"8d80a6eb-c283-41ee-64c2-08d5ad2bf6ba","name":"SIMBRAEX MARMORES E GRANITOS - EIRELI","commercialName":"","cnpj":"07427584000125","city":"CACHOEIRO DE ITAPEMIRIM","stateCode":"ES","buscaAdicional":"SIMBRAEX 56196 SIMBRAEX CACHOEIRO 905000"},{"id":"e216e054-06fb-49cc-64eb-08d5ad2bf6ba","name":"GRAN SOLAR - GRANITOS E MARMORES LTDA","commercialName":"","cnpj":"17506413000145","city":"CACHOEIRO DE ITAPEMIRIM","stateCode":"ES","buscaAdicional":"GRAN SOLAR 56314 GRAN SOLAR 905013"},{"id":"5bd37edf-f4d0-4b09-62fd-08d5ad2bf6ba","name":"GRANITOS COLODETTI LTDA","commercialName":"","cnpj":"03562171000100","city":"CACHOEIRO DE ITAPEMIRIM","stateCode":"ES","buscaAdicional":"GRANITOS COLLODETTI 55069 GRANITOS COLLODETTI 904097"},{"id":"63d1f604-f1f4-4bc6-6332-08d5ad2bf6ba","name":"STONEMIX MARMORES E GRANITOS EIRELI","commercialName":"","cnpj":"12324688000144","city":"CACHOEIRO DE ITAPEMIRIM","stateCode":"ES","buscaAdicional":"STONEMIX 55241 STONEMIX 903437"},{"id":"5d065773-461e-49b8-8db7-08d5d060706e","name":"UNIAO SOCIAL CAMILIANA","commercialName":"CENTRO UNIVERSITARIO SAO CAMILO - ESPIRITO SANTO","cnpj":"58250689000788","city":"CACHOEIRO DE ITAPEMIRIM","stateCode":"ES","buscaAdicional":"UNIAO SOCIAL CAMILIANA 63414 SAO CAMILO CACHOEIRO 913555"},{"id":"c96ab33d-c690-4ed2-1cca-08d5b8870181","name":"DECOLORES MARMORES E GRANITOS DO BRASIL LTDA","commercialName":"DECOLORES MARMORES E GRANITOS DO BRASIL","cnpj":"04023387000152","city":"CACHOEIRO DE ITAPEMIRIM","stateCode":"ES","buscaAdicional":"DECOLORES MARMORES 61636 DECOLORES CACHOEIRO 912878"},{"id":"625bfc73-d1cf-4b69-5a27-08d5ad2bf6ba","name":"MICRON-ITA INDUSTRIA E COMERCIO DE MINERAIS LTDA.","commercialName":"MICRON-ITA","cnpj":"36398113000134","city":"CACHOEIRO DE ITAPEMIRIM","stateCode":"ES","buscaAdicional":"MICRON ITA 16584 MICRON ITA 895221"},{"id":"467b66c5-b701-4c52-5f9a-08d5ad2bf6ba","name":"MAGBAN MARMORES E GRANITOS AQUIDABAN LTDA","commercialName":"","cnpj":"31292568000157","city":"CACHOEIRO DE ITAPEMIRIM","stateCode":"ES","buscaAdicional":"MAG BAN 53044 MAG BAN 902712"},{"id":"9e08b6a4-e35c-476d-5f34-08d5ad2bf6ba","name":"MINERASUL INDUSTRIA E COMERCIO DE AGREGADOS LTDA","commercialName":"","cnpj":"27193630000186","city":"CACHOEIRO DE ITAPEMIRIM","stateCode":"ES","buscaAdicional":"MINERASUL 52844 MINERASUL 904086"},{"id":"ec444517-edca-4af7-5ca8-08d5ad2bf6ba","name":"FRIGORIFICO COFRIL LTDA","commercialName":"","cnpj":"28485498000149","city":"CACHOEIRO DE ITAPEMIRIM","stateCode":"ES","buscaAdicional":"COFRIL 51480 COFRIL AEROPORTO 898679 COFRIL MONTE LIBANO 898680"},{"id":"8c1394a3-f284-46a5-5d81-08d5ad2bf6ba","name":"EDK MINERACAO LTDA","commercialName":"","cnpj":"03018137000161","city":"CACHOEIRO DE ITAPEMIRIM","stateCode":"ES","buscaAdicional":"EDK MINERACAO 51842 EDK DUAS BARRAS 898685 EDK ITAOCA 898706 EDK MINERACAO PE 899225"},{"id":"5a9c0250-9b7f-4aeb-5df6-08d5ad2bf6ba","name":"MG2 MARMORES E GRANITOS LTDA","commercialName":"","cnpj":"07803841000186","city":"CACHOEIRO DE ITAPEMIRIM","stateCode":"ES","buscaAdicional":"MG2GRANITOS 52093 MG2GRANITOS ES 900038"},{"id":"50cb7bc4-6fa7-4be4-5e6d-08d5ad2bf6ba","name":"OSVALDO PERIM SUPERMERCADOS LTDA","commercialName":"SUPERMERCADOS PERIM","cnpj":"27735448000100","city":"CACHOEIRO DE ITAPEMIRIM","stateCode":"ES","buscaAdicional":"PERIMSUPER 52382 PERIMSUPER MATRIZ 901151 PERIMSUPER CASTELO I 901194 PERIMSUPER CASTELO 2 901195 PERIMSUPER CAICARA 901213"},{"id":"fb54394f-f2e7-4456-5438-08d5ad2bf6ba","name":"BRK AMBIENTAL - CACHOEIRO DE ITAPEMIRIM S.A.","commercialName":"","cnpj":"02628150000170","city":"CACHOEIRO DE ITAPEMIRIM","stateCode":"ES","buscaAdicional":"PCH ILHA LUZ 4098 PCH ILHA LUZ CEL BOR 901716 ILHA DA LUZ UN 0631 901994 ILHA DA LUZ 8943 PCH.PH.ES.030265-1.01"},{"id":"3586abeb-14c0-4efb-5716-08d5ad2bf6ba","name":"COOPERATIVA DE LATICINIOS SELITA","commercialName":"","cnpj":"27178359000100","city":"CACHOEIRO DE ITAPEMIRIM","stateCode":"ES","buscaAdicional":"SELITA 8192 LATICINIOS SELITA 888170"},{"id":"33fecbc1-7833-425d-5f3a-08d5ad2bf6ba","name":"BRASITALIA - AGREGADOS PARA CONSTRUCAO LTDA","commercialName":"","cnpj":"27169879000156","city":"CARIACICA","stateCode":"ES","buscaAdicional":"BRASITALIA 52869 BRASITALIA 900782"},{"id":"c808acfc-afbc-40a1-5b72-08d5ad2bf6ba","name":"SC2 SHOPPING CARIACICA LTDA","commercialName":"","cnpj":"09616801000150","city":"CARIACICA","stateCode":"ES","buscaAdicional":"SHOP MOXUARA 50707 SHOPPING CARIACICA 897668"},{"id":"0305ada0-e583-48c6-8db6-08d5d060706e","name":"VIACAO AGUIA BRANCA S A","commercialName":"AGUIA BRANCA","cnpj":"27486182000109","city":"CARIACICA","stateCode":"ES","buscaAdicional":"AGUIA BRANCA 63334 AGUIA BRANCA GARAGEM 913490 AGUIA BRANCA MATRIZ 913505"},{"id":"5232d9f6-fb8d-4bb5-6197-08d5ad2bf6ba","name":"MARCA AMBIENTAL LTDA","commercialName":"MARCA AMBIENTAL","cnpj":"07333485000184","city":"CARIACICA","stateCode":"ES","buscaAdicional":"MARCA AMBIENTAL 54250 MARCA AMBIENTAL LTDA 905811"},{"id":"7dab85ba-3e82-4a21-6556-08d5ad2bf6ba","name":"PRYSMIAN CABOS E SISTEMAS DO BRASIL S/A","commercialName":"","cnpj":"61150751003102","city":"CARIACICA","stateCode":"ES","buscaAdicional":"PRYSMIAN CARIACICA 56657 PRYSMIAN MANG-CARIAC 71531"},{"id":"956423cb-18fd-4edc-63a5-08d5ad2bf6ba","name":"HORTIGIL HORTIFRUTI S/A","commercialName":"","cnpj":"31487473000199","city":"CARIACICA","stateCode":"ES","buscaAdicional":"HORTIFRUTI 55500 HORTIFRUTI - LOJA 48 906848 HORTIFRUTI - LOJA 67 906863 HORTIFRUTI - LOJA 17 906866 HORTIFRUTI - LOJA 55 906867 HORTIFRUTI- LOJA 72 906881 HORTIFRUTI LOJA 45 907307 HORTIFRUTI LOJA 31 907685 HORTIFRUTI LOJA 22 907700 HORTIFRUTI LOJA 32 908095 HORTIFRUTI LJ06 910557"},{"id":"50787eee-4d20-4f93-691b-08d5ad2bf6ba","name":"SUPERMERCADOS CAMPO GRANDE EIRELI","commercialName":"","cnpj":"26941332000164","city":"CARIACICA","stateCode":"ES","buscaAdicional":"SUPERMERCADO SCHOWAMBACH 60771 SCHOWAMBACH CG 911807"},{"id":"edbe53f0-abcf-4b84-690d-08d5ad2bf6ba","name":"IGRAMAR - INDUSTRIA DE GRANITOS E MARMORES LTDA","commercialName":"","cnpj":"01885369000191","city":"CASTELO","stateCode":"ES","buscaAdicional":"IGRAMAR 60754 IGRAMAR 911280"},{"id":"6b1a25a6-23b2-4ec3-630b-08d5ad2bf6ba","name":"CS3 MARMORES E GRANITOS LTDA","commercialName":"","cnpj":"07599291000125","city":"CASTELO","stateCode":"ES","buscaAdicional":"CS3 GRANITOS 55112 CS3 GRANITOS 904319"},{"id":"a9207e6d-3265-493b-5ee6-08d5ad2bf6ba","name":"COMPANHIA DE ALIMENTOS UNIAVES","commercialName":"","cnpj":"07144671000175","city":"CASTELO","stateCode":"ES","buscaAdicional":"CIA UNIAVES 52604 UNIAVES 900054 UNIAVES VNI 910264"},{"id":"c9cd1723-386c-4afb-5df2-08d5ad2bf6ba","name":"BRAMAGRAN - BRASILEIRO MARMORE E GRANITO LTDA","commercialName":"","cnpj":"35989540000124","city":"CASTELO","stateCode":"ES","buscaAdicional":"BRAMAGRAN 52079 BRAMAGRAN 900017"},{"id":"02dd247c-9fb6-4544-5fa0-08d5ad2bf6ba","name":"GRANLATINA GRANITOS E MARMORES DO BRASIL EIRELI","commercialName":"GRANLATINA GRANITOS E MARMORES DO BRASIL","cnpj":"09041650000150","city":"COLATINA","stateCode":"ES","buscaAdicional":"GRANLATINA 53054 GRANLATINA 901147"},{"id":"52c7bede-f4dd-412d-5745-08d5ad2bf6ba","name":"EMPRESA LUZ E FORCA SANTA MARIA S A","commercialName":"","cnpj":"27485069000109","city":"COLATINA","stateCode":"ES","buscaAdicional":"ELFSM 8469 ELFSM - SANTA MARIA 898071"},{"id":"83e43327-dad2-42ab-696c-08d5ad2bf6ba","name":"FRISA FRIGORIFICO RIO DOCE S A","commercialName":"FRISA","cnpj":"27497684000135","city":"COLATINA","stateCode":"ES","buscaAdicional":"FRISA 61311 FRISA ES COLATINA 911971"},{"id":"cd6d4f6e-0d59-4172-6848-08d5ad2bf6ba","name":"METALOSA INDUSTRIA METALURGICA SA","commercialName":"METALOSA","cnpj":"27485374000109","city":"COLATINA","stateCode":"ES","buscaAdicional":"METALOSA 59664 METALOSA 909308"},{"id":"5aa72d55-d932-49c5-68bd-08d5ad2bf6ba","name":"GRANIBRAS.ES-GRANITOS BRASILEIROS LTDA","commercialName":"GRANIBRAS","cnpj":"09225888000135","city":"COLATINA","stateCode":"ES","buscaAdicional":"GRANIBRAS 60370 GRANIBRAS 911951"},{"id":"113c5d68-ae37-41b4-6772-08d5ad2bf6ba","name":"MARBRASA NORTE MINERADORA LTDA","commercialName":"MARBRASA NORTE","cnpj":"06867144000126","city":"COLATINA","stateCode":"ES","buscaAdicional":"MARBRASA NORTE 58111 MARBRASA NORTE 908770"},{"id":"335bdeaa-9048-48d6-51a6-08d5ad2bf6ba","name":"ALCON-COMPANHIA DE ALCOOL CONCEICAO DA BARRA","commercialName":"","cnpj":"30974737000176","city":"CONCEIÇÃO DA BARRA","stateCode":"ES","buscaAdicional":"ALCON I5 2470 ALCON CONSUMO 908358 ALCON 8591 UTE.AI.ES.029150-1.01"},{"id":"7ba37bf2-5a9d-4c9d-614e-08d5ad2bf6ba","name":"REFRIGERANTES COROA LTDA","commercialName":"","cnpj":"27657485000147","city":"DOMINGOS MARTINS","stateCode":"ES","buscaAdicional":"REFRIG COROA 54110 REFRIG. COROA - ES 905836"},{"id":"a9795bc0-3ced-4d03-5f33-08d5ad2bf6ba","name":"FORTE BOI - INDUSTRIA DE ALIMENTOS LTDA","commercialName":"FORTE BOI","cnpj":"05975865000197","city":"FUNDÃO","stateCode":"ES","buscaAdicional":"FORTEBOI 52843 FORTEBOI 902005"},{"id":"58da892b-c887-4d81-5ff2-08d5ad2bf6ba","name":"GRANVITORIA ALIMENTOS RECICLAGEM INDUSTRIA E COMERCIO DE SUB-PRODUTOS BOVINOS LTDA","commercialName":"GRANVITORIA ALIMENTOS","cnpj":"08366612000104","city":"FUNDÃO","stateCode":"ES","buscaAdicional":"GRANVITORIA 53308 GRANVITORIA ALIMENTO 905830"},{"id":"7e2de1e5-76e0-4e9e-5924-08d5ad2bf6ba","name":"CBF INDUSTRIA DE GUSA S/A","commercialName":"CBF","cnpj":"36312056000552","city":"JOÃO NEIVA","stateCode":"ES","buscaAdicional":"CBF 13875 JOAO NEIVA (CBF) 894043 UTE.FL.ES.028347-9.01"},{"id":"e9944929-523f-46e4-6067-08d5ad2bf6ba","name":"PAPELIAL INDUSTRIA E COMERCIO LTDA","commercialName":"PAPELIAL","cnpj":"04455607000117","city":"LINHARES","stateCode":"ES","buscaAdicional":"PAPELIAL 53494 PAPELIAL LINHARES 904103"},{"id":"a5fd7d27-d0e6-4284-60d9-08d5ad2bf6ba","name":"A.C.P. INDUSTRIA DE MOVEIS LTDA","commercialName":"","cnpj":"30746945000118","city":"LINHARES","stateCode":"ES","buscaAdicional":"ACP MOVEIS 53770 ACP MOVEIS 905033"},{"id":"b5b7f443-b47a-45f2-60da-08d5ad2bf6ba","name":"RIMO S.A -INDUSTRIA E COMERCIO","commercialName":"","cnpj":"32430993000128","city":"LINHARES","stateCode":"ES","buscaAdicional":"MOVEIS RIMO 53773 MOVEIS RIMO 905020"},{"id":"cef70c1e-b6dd-41d0-60db-08d5ad2bf6ba","name":"DOCELAR MOVEIS EIRELI","commercialName":"","cnpj":"28485746000151","city":"LINHARES","stateCode":"ES","buscaAdicional":"DOCELAR MOVEIS 53774 DOCELAR MOVEIS 909716"},{"id":"3b4e73c6-ac73-44b3-60dc-08d5ad2bf6ba","name":"CIMOL - COMERCIO E INDUSTRIA DE MOVEIS LTDA","commercialName":"","cnpj":"36398527000163","city":"LINHARES","stateCode":"ES","buscaAdicional":"CIMOL MOVEIS 53781 CIMOL 905812"},{"id":"dee5d9ee-9861-45c2-60ff-08d5ad2bf6ba","name":"TROP FRUTAS DO BRASIL LTDA","commercialName":"TROP BRASIL","cnpj":"07757005000102","city":"LINHARES","stateCode":"ES","buscaAdicional":"TROP 53947 TROP BRASIL 906660"},{"id":"a60e60a1-4a9c-44f5-5fa5-08d5ad2bf6ba","name":"PANAN - INDUSTRIA DE MADEIRAS E MOVEIS LTDA","commercialName":"","cnpj":"36343960000100","city":"LINHARES","stateCode":"ES","buscaAdicional":"PANAN MOVEIS 53061 PANAN 905019"},{"id":"7f0f0671-34da-46af-5fa8-08d5ad2bf6ba","name":"MGM MOVEIS LTDA","commercialName":"MGM MOVEIS","cnpj":"06107255000134","city":"LINHARES","stateCode":"ES","buscaAdicional":"MGM MOVEIS 53070 MGM MOVEIS 905018"},{"id":"81af7fc5-9f48-4f92-5fd8-08d5ad2bf6ba","name":"IMOPEL MOVEIS E MOLDURAS LTDA","commercialName":"IMOPEL MOVEIS E MOLDURAS","cnpj":"03512299000151","city":"LINHARES","stateCode":"ES","buscaAdicional":"IMOPEL MOVEIS 53241 IMOPEL 905016"},{"id":"8c733b9b-2809-4dc0-5ded-08d5ad2bf6ba","name":"LEAO ALIMENTOS E BEBIDAS LTDA.","commercialName":"","cnpj":"76490184003445","city":"LINHARES","stateCode":"ES","buscaAdicional":"LEAO LINHARES 52072 LEAO ALIMENTOS 901150"},{"id":"3974d7a0-1cfb-48ef-5e3a-08d5ad2bf6ba","name":"PROTEINORTE ALIMENTOS SA","commercialName":"KIFRANGO","cnpj":"27275197000128","city":"LINHARES","stateCode":"ES","buscaAdicional":"PROTEINORTE 52289 KIFRANGO INTERLAGOS 900026"},{"id":"702c3297-e16f-4095-520d-08d5ad2bf6ba","name":"LINHARES GERACAO SA","commercialName":"LINHARES GERACAO SA","cnpj":"10472905000118","city":"LINHARES","stateCode":"ES","buscaAdicional":"LINHARES GERA 2829 LINHARES 8773 UTE.GN.ES.030054-3.01"},{"id":"a51a0bd0-15d0-4f3e-566a-08d5ad2bf6ba","name":"WEG LINHARES EQUIPAMENTOS ELETRICOS S/A","commercialName":"","cnpj":"10885321000174","city":"LINHARES","stateCode":"ES","buscaAdicional":"WEG LINHARES 7041 WEG - LINHARES 72198"},{"id":"cdb3e0a3-d4de-495f-611a-08d5ad2bf6ba","name":"DUCOCO ALIMENTOS S/A","commercialName":"","cnpj":"63460299000187","city":"LINHARES","stateCode":"ES","buscaAdicional":"DUCOCO ES 54014 DUCOCO ALIMENTOS 904313"},{"id":"6dcaaaea-d4e1-4cfa-6539-08d5ad2bf6ba","name":"SUPERMERCADOS CASAGRANDE LTDA","commercialName":"SUPERMERCADOS CASAGRANDE","cnpj":"27473669000157","city":"LINHARES","stateCode":"ES","buscaAdicional":"SUPERMERCADOS CASAGRANDE 56610 SUPMERC CASAGRANDE 7 905839 SUPERMERC CADAGRANDE 905854 SUPER CASAGRANDE 01 906351 SUPER CASAGRANDE 16 906352 SUPER CASAGRANDE 10 906373 SUPER CASAGRANDE 06 906374 SUPER CASAGRANDE 11 906375 SUPER CASAGRANDE 14 906376 SUPER CASAGRANDE 12 906387 CASAGRANDE 15 906434 SUPERMERC CASAGRND 3 907064 SUP CASAGRANDE 19 908721 SUPER CASAGRANDE 18 910860 SUPER CASAGRANDE 17 910861 CASAGRANDE 02 911852"},{"id":"7ac2c579-7ef6-42dd-66cd-08d5ad2bf6ba","name":"PERFILADOS RIO DOCE LTDA","commercialName":"","cnpj":"03461082000160","city":"LINHARES","stateCode":"ES","buscaAdicional":"PERFILADOS RIO DOCE 57834 PERF RIO DOCE SERRA 908295 PERFILADOS LINHARES 908311"},{"id":"9b14109e-ad95-4ea3-68b4-08d5ad2bf6ba","name":"LASA LINHARES AGROINDUSTRIAL SA","commercialName":"","cnpj":"27291400000150","city":"LINHARES","stateCode":"ES","buscaAdicional":"LASA AGRO 60307"},{"id":"63e45896-cb16-4291-693e-08d5ad2bf6ba","name":"INDUSTRIA DE MOVEIS PEROBA LTDA","commercialName":"MOVEIS PEROBA","cnpj":"06368547000120","city":"LINHARES","stateCode":"ES","buscaAdicional":"PEROBA 60859 INDUSTRIA DE MOVEIS 911960"},{"id":"1e91b8d1-4acf-472d-6185-08d5ad2bf6ba","name":"DOMART ALIMENTOS LTDA","commercialName":"DOMART ALIMENTOS","cnpj":"11671820000121","city":"MARECHAL FLORIANO","stateCode":"ES","buscaAdicional":"DOMART ALIMENTOS 54219 DOMART ALIMENTOS 901980"},{"id":"8401fca0-1834-4174-5f9f-08d5ad2bf6ba","name":"MARMIL MARMORE MIMOSO COMERCIO EXP E IMP LTDA","commercialName":"","cnpj":"32473118000123","city":"MIMOSO DO SUL","stateCode":"ES","buscaAdicional":"MARMIL 53053 MARMIL MIMOSO DO SUL 900641"},{"id":"abca41e4-d0ae-4b96-5835-08d5ad2bf6ba","name":"CAJUGRAM GRANITOS E MARMORES DO BRASIL LTDA","commercialName":"","cnpj":"32440901000190","city":"MIMOSO DO SUL","stateCode":"ES","buscaAdicional":"CAJUGRAM 11011 CAJUGRAM 889856"},{"id":"ef9aa582-902c-4a42-6367-08d5ad2bf6ba","name":"LATICINIOS REZENDE LTDA","commercialName":"","cnpj":"03619140000130","city":"MONTANHA","stateCode":"ES","buscaAdicional":"LATICINIOS REZENDE 55337 LATICINIOS REZENDE 905831 DAMARE MG 913415"},{"id":"69e7ab07-7053-4aca-65df-08d5ad2bf6ba","name":"VENEZA - COOPERATIVA AGROPECUARIA DO NORTE DO ESPIRITO SANTO","commercialName":"VENEZA","cnpj":"27996594000199","city":"NOVA VENÉCIA","stateCode":"ES","buscaAdicional":"VENEZA 57180 VENEZA 906887"},{"id":"515c951a-5767-47c7-8db0-08d5d060706e","name":"PLACAS DO BRASIL S.A.","commercialName":"PLACAS DO BRASIL","cnpj":"14792934000118","city":"PINHEIROS","stateCode":"ES","buscaAdicional":"PLACAS DO BRASIL 62693 PLACAS DO BRASIL 913343"},{"id":"813da6fc-10a9-4a73-63ec-08d5ad2bf6ba","name":"INDUSTRIA DE MARMORES E GRANITOS PEDRA DO FRADE LTDA","commercialName":"MARMORES E GRANITOS JC","cnpj":"00722494000118","city":"RIO NOVO DO SUL","stateCode":"ES","buscaAdicional":"PEDRA DO FRADE 55717 PEDRA DO FRADE 907000"},{"id":"6820a92f-6a4d-47d3-5efc-08d5ad2bf6ba","name":"MAMERI ROCHAS LTDA","commercialName":"","cnpj":"01923470000190","city":"RIO NOVO DO SUL","stateCode":"ES","buscaAdicional":"MAMERI ROCHAS 52697 MAMERI ROCHAS 902753"},{"id":"b307ca62-0654-46c4-6913-08d5ad2bf6ba","name":"COOPERATIVA AGROPECUARIA CENTRO SERRANA","commercialName":"COOPEAVI","cnpj":"27942085000183","city":"SANTA MARIA DE JETIBÁ","stateCode":"ES","buscaAdicional":"COOPEAVI 60761 BAIXO GUANDU 911298 STA MARIA - ENTREPOS 911300 STA MARIA - FABRICA 911324"},{"id":"e36a0348-e36a-4885-5f99-08d5ad2bf6ba","name":"GUIDONI ORNAMENTAL ROCKS LTDA","commercialName":"GUIDONI ORNAMENTAL ROCKS","cnpj":"00264528000178","city":"SÃO DOMINGOS DO NORTE","stateCode":"ES","buscaAdicional":"GUIDONI 53043 GUIDONI S DOMINGOS 901023 GUIDONI BS FRANCISCO 904551 GUIDONI FORTALEZINHA 905558 GUIDONI ITAPERUNA 905562"},{"id":"f5ed1fab-d984-467d-5931-08d5ad2bf6ba","name":"PEPSICO AMACOCO BEBIDAS DO BRASIL LTDA","commercialName":"","cnpj":"09644104000294","city":"SÃO MATEUS","stateCode":"ES","buscaAdicional":"PEPSICO AMACOCO 14035 SAO MATEUS 895027"},{"id":"c3765368-392a-4ea3-656c-08d5ad2bf6ba","name":"OXFORD PORCELANAS ESPIRITO SANTO LTDA","commercialName":"OXFORD PORCELANAS ES","cnpj":"19934117000170","city":"SÃO MATEUS","stateCode":"ES","buscaAdicional":"OXFORD PORCELANAS 56723 OXFORD PORCELANAS ES 906902"},{"id":"30557fd5-d021-4952-6512-08d5ad2bf6ba","name":"BRASIGRAN BRASILEIRA DE GRANITOS LTDA","commercialName":"","cnpj":"32476525000194","city":"SERRA","stateCode":"ES","buscaAdicional":"TRA-BRASIGRAN 56463 BRASIGRAN BR GRANITO 906324"},{"id":"5a46431e-0a62-4e9a-646f-08d5ad2bf6ba","name":"VITORIA APART HOSPITAL S/A","commercialName":"","cnpj":"02209094000139","city":"SERRA","stateCode":"ES","buscaAdicional":"HOSP VITORIA APART 56005 HOSP VITORIA - SERRA 905835"},{"id":"739b558d-d5ed-4c7e-63ce-08d5ad2bf6ba","name":"HOSPITAL METROPOLITANO S/A","commercialName":"","cnpj":"32402414000133","city":"SERRA","stateCode":"ES","buscaAdicional":"HOSPITAL METROPOLITANO 55638 HOSP METROPOLITANO 904339 HOSPITAL METROPOLITA 905548"},{"id":"5b5ef0de-73e9-41cf-62f5-08d5ad2bf6ba","name":"VITORIA STONE INDUSTRIA E COMERCIO S/A","commercialName":"","cnpj":"00338678000189","city":"SERRA","stateCode":"ES","buscaAdicional":"VITORIA STONE 55060 VITORIA STONE SERRA 904326"},{"id":"8b8fb12a-4a17-4535-6911-08d5ad2bf6ba","name":"METALURGICA TECNOSTEEL LTDA","commercialName":"","cnpj":"07545610000110","city":"SERRA","stateCode":"ES","buscaAdicional":"TECNOSTEEL 60759 METALURG TECNOSTEEL 910563"},{"id":"2fc8eb66-f87d-413a-8842-08d5ae44ed50","name":"TUBOS SOLDADOS ATLANTICO S/A","commercialName":"","cnpj":"61142766000103","city":"SERRA","stateCode":"ES","buscaAdicional":"TSA 1855"},{"id":"c3803769-4d1d-4aee-6816-08d5ad2bf6ba","name":"ARCELORMITTAL BRASIL S.A.","commercialName":"","cnpj":"17469701018700","city":"SERRA","stateCode":"ES","buscaAdicional":"AMB COM 59337"},{"id":"555bf9f2-6ebd-40c3-67da-08d5ad2bf6ba","name":"VALLOUREC SOLUCOES TUBULARES DO BRASIL S.A.","commercialName":"","cnpj":"08689024000616","city":"SERRA","stateCode":"ES","buscaAdicional":"VSB SERRA 58692 TSA CARAPINA SERRA 70305"},{"id":"b9036d3a-5c26-4dd0-65a5-08d5ad2bf6ba","name":"LEVANTINA NATURAL STONE BRASIL LTDA","commercialName":"","cnpj":"04746729000162","city":"SERRA","stateCode":"ES","buscaAdicional":"LEVANTINA 56901 LEVANTINA SERRA 906882"},{"id":"4634a191-effb-4603-66a1-08d5ad2bf6ba","name":"GRANICAP GRANITOS CAPIXABA LTDA","commercialName":"GRANICAP","cnpj":"27462217000170","city":"SERRA","stateCode":"ES","buscaAdicional":"GRANICAP 57710 GRANICAP GRANITOS 907818"},{"id":"3d8cc068-4e31-4d48-678a-08d5ad2bf6ba","name":"ECO101 CONCESSIONARIA DE RODOVIAS S/A","commercialName":"ECO101 CONCESSIONARIA DE RODOVIAS S/A","cnpj":"15484093000144","city":"SERRA","stateCode":"ES","buscaAdicional":"ECO101 58257 PRACA 1 911788 PRACA 7 911789 PRACA 3 911808 PRACA 4 911809 PRACA 2 911810 PRACA 5 911851 PRACA 6 911871"},{"id":"dc659e07-45c0-4be1-6795-08d5ad2bf6ba","name":"COSENTINO LATINA LTDA","commercialName":"","cnpj":"04885413000151","city":"SERRA","stateCode":"ES","buscaAdicional":"COSENTINO 58322 COSENTINO LATINA 908278"},{"id":"55a2af55-e9b7-4fcf-5922-08d5ad2bf6ba","name":"SC2 SHOPPING MONTSERRAT S.A","commercialName":"","cnpj":"14723899000185","city":"SERRA","stateCode":"ES","buscaAdicional":"SHOPPING MONTSERRAT 13856 SHOPPING MONTSERRAT 892923"},{"id":"c66f9d26-cf47-4041-5c3b-08d5ad2bf6ba","name":"METALURGICA USISTEEL LTDA","commercialName":"","cnpj":"04744310000171","city":"SERRA","stateCode":"ES","buscaAdicional":"METALURGICA USISTEEL 51203 USISTEEL 898820"},{"id":"781d04fb-bb6e-493e-5b5a-08d5ad2bf6ba","name":"INDUSTRIA DE BEBIDAS MESTRE ALVARO LTDA","commercialName":"","cnpj":"05275975000146","city":"SERRA","stateCode":"ES","buscaAdicional":"REFRIGERANTES UAI 50620 REFRIGERANTES UAI 900034"},{"id":"6cc2efa1-5dec-4d87-5f9d-08d5ad2bf6ba","name":"NOVAFORMA PLASTICOS LTDA","commercialName":"NOVAFORMA QUIMICA E RECICLAGEM","cnpj":"03845190000136","city":"SERRA","stateCode":"ES","buscaAdicional":"NOVAFORMA 53048 NOVAFORMA 905017"},{"id":"4f9d1d3a-57fc-4a33-6027-08d5ad2bf6ba","name":"FORTLEV INDUSTRIA E COMERCIO DE PLASTICOS LTDA","commercialName":"FORTLEV INDUSTRIA E COMERCIO DE PLASTICOS LTDA","cnpj":"10921911000539","city":"SERRA","stateCode":"ES","buscaAdicional":"TRA-FORTLEV-ES 53404 FORTLEV IND PLASTICO 906999"},{"id":"72058468-4b90-43c5-5e1e-08d5ad2bf6ba","name":"CONDOMINIO DO CENTRO EMPRESARIAL DO SHOPPING MESTRE ALVARO","commercialName":"","cnpj":"15468730000199","city":"SERRA","stateCode":"ES","buscaAdicional":"COND M ALVARO 52224 SHOP MESTRE ALVARO 71814"},{"id":"ceec0904-392e-4b59-5df7-08d5ad2bf6ba","name":"VIMINAS VIDROS ESPECIAIS LTDA","commercialName":"","cnpj":"31702947000330","city":"SERRA","stateCode":"ES","buscaAdicional":"TRA-VIMINAS 52094 VIMINAS VIDROS 901077"},{"id":"c361230e-589e-414c-5e6a-08d5ad2bf6ba","name":"REALMAR DISTRIBUIDORA LTDA.","commercialName":"EXTRABOM SUPERMERCADOS","cnpj":"03845717000122","city":"SERRA","stateCode":"ES","buscaAdicional":"GRUPO EXTRABOM 52378 EXTRABOM GOIABEIRAS 902173 EXTRABOM - CRUZEIRO 902174 EXTRABOM - S SILVANO 902175 EXTRABOM 902178 EXTRABOM - S MATEUS 902181 EXTRABOM - ITARARE 902214 EXTRABOM TOP LIFE 902333 EXTRABOM - GUARAPARI 902573 EXTRABOM - V RUBIM 904712 EXTRABOM - VALPARAIS 905565 EXTRABOM SAO MATEUS 906435 EXTRABOM - ITAPOA 907595 EXTRABOM PORTO CANOA 908121 EXTRABOM ITACIBA 909470 EXTRABOM - CRUZEIRO 912478"},{"id":"01bc26eb-ecda-4f19-5e7b-08d5ad2bf6ba","name":"PBA SERVICOS E COMERCIO DE PEDRAS ORNAMENTAIS LTDA","commercialName":"PBA STONES","cnpj":"07214630000108","city":"SERRA","stateCode":"ES","buscaAdicional":"PBA STONES 52399 PBA STONES 902008"},{"id":"97ae0d68-ac81-4f00-5cb6-08d5ad2bf6ba","name":"SERRANO DISTRIBUIDORA S/A","commercialName":"","cnpj":"09397586000144","city":"SERRA","stateCode":"ES","buscaAdicional":"SERRANO 51514 OK SUPER LINHARES 898587 OK SUP CARIACICA 898588"},{"id":"d9b58edd-5bc6-4c44-5d09-08d5ad2bf6ba","name":"ELKEM PARTICIPACOES, INDUSTRIA E COMERCIO LTDA","commercialName":"CARBOINDUSTRIAL","cnpj":"42593061000150","city":"SERRA","stateCode":"ES","buscaAdicional":"ELKEM CARBOINDUSTRIAL 51683 ELKEM - ECI 900002"},{"id":"b1d7245c-defb-44ff-5d0a-08d5ad2bf6ba","name":"ELKEM PARTICIPACOES, INDUSTRIA E COMERCIO LTDA","commercialName":"UNIDADE CARBODERIVADOS","cnpj":"42593061000400","city":"SERRA","stateCode":"ES","buscaAdicional":"ELKEM CARBODERIVADOS 51684 ELKEM - ECD 899304"},{"id":"7f76649a-e7b5-4c57-5cd9-08d5ad2bf6ba","name":"FIBRASA S.A.","commercialName":"FIBRASA SUDESTE","cnpj":"04221067000107","city":"SERRA","stateCode":"ES","buscaAdicional":"FIBRASA 51590 FIBRASA SE 899302 FIBRASA NE 900517"},{"id":"c96f46e4-5d88-4557-51b5-08d5ad2bf6ba","name":"BIANCOGRES CERAMICA S/A","commercialName":"","cnpj":"02077546000176","city":"SERRA","stateCode":"ES","buscaAdicional":"BIANCOGRES 2532 BIANCOGRES LIVRE 70644 BIANCOGRES 8401 UTE.GN.ES.029586-8.01"},{"id":"c670883e-30e4-4445-51b3-08d5ad2bf6ba","name":"SANTA FE ENERGIA S/A","commercialName":"SANTA FE ENERGIA","cnpj":"08944243000190","city":"SERRA","stateCode":"ES","buscaAdicional":"SANTA FE 2522 SANTA FE 8422 PCH.PH.ES.028380-0.01"},{"id":"a2053e46-e01d-4685-6814-08d5ad2bf6ba","name":"ITATIAIA MOVEIS S A","commercialName":"ITATIAIA","cnpj":"25331521001124","city":"SOORETAMA","stateCode":"ES","buscaAdicional":"ITATIAIA MOVEIS 59334 ITATIAIA SOORETAMA 908720"},{"id":"ec7412b9-f24a-4c2f-658f-08d5ad2bf6ba","name":"FERTILIZANTES HERINGER S.A.","commercialName":"FERTILIZANTES HERINGER","cnpj":"22266175000188","city":"VIANA","stateCode":"ES","buscaAdicional":"HERINGER 56829 HERINGER PAULINIA 2 907973 HERINGER PAULINIA 1 907992 HERINGER CANDEIAS 908047 HERINGER OURINHOS 908115 HERINGER VIANA 908120 HERINGER MANHUACU 908141 HERINGER ROSARIO 908143 HERINGER DOURADOS 908340 HERINGER IGUATAMA 909238 HERINGER RONDONOP 2 909446 HERINGER 3 CORACOES 909895 HERINGER UBERABA 909944 HERINGER RIO GRANDE 910422 HERINGER POA 910423 CATALAO 910848"},{"id":"f7d61443-4445-4b18-61c7-08d5ad2bf6ba","name":"REALCAFE SOLUVEL DO BRASIL S A","commercialName":"","cnpj":"28154847000301","city":"VIANA","stateCode":"ES","buscaAdicional":"REALCAFE 54425 REALCAFE SOLUVEL DBR 905809"},{"id":"2d82925c-bf2c-4fed-5e38-08d5ad2bf6ba","name":"NUTRIAVE ALIMENTOS LTDA","commercialName":"","cnpj":"27250737000119","city":"VIANA","stateCode":"ES","buscaAdicional":"NUTRIAVE 52287 NUTRIAVE 900028"},{"id":"dbbc7490-8ca7-4371-5cd5-08d5ad2bf6ba","name":"ITAPOA SUPERMERCADO LTDA.","commercialName":"SUPERMERCADO PERIM","cnpj":"06955576000199","city":"VILA VELHA","stateCode":"ES","buscaAdicional":"SUPERMERCADO PERIM 51582 PERIM ARIBIRI 899883 MATA DA PRAIA ES 899884 SUPERMERCADO CENTRO 899885 PERIM ITAPARICA 899899 PERIM JABURUNA 909471"},{"id":"923bfa0a-a0ec-4729-5f68-08d5ad2bf6ba","name":"TANGARA IMPORTADORA E EXPORTADORA SA","commercialName":"TANGARA IMP. E EXP. S/A, TANGARA OU TANGARA FOODS","cnpj":"39787056000173","city":"VILA VELHA","stateCode":"ES","buscaAdicional":"TANGARA FOODS 52930 TANGARA VV 905014"},{"id":"0542e755-d6ae-41da-5a9f-08d5ad2bf6ba","name":"PERFIL ALUMINIO DO BRASIL S/A","commercialName":"","cnpj":"05069718000158","city":"VILA VELHA","stateCode":"ES","buscaAdicional":"PERFIL ALUM 50113 PERFIL ALUMINIO 897184"},{"id":"5fb02fa3-51f7-401d-535e-08d5ad2bf6ba","name":"CHOCOLATES GAROTO SA","commercialName":"","cnpj":"28053619000183","city":"VILA VELHA","stateCode":"ES","buscaAdicional":"GAROTO 3596 GAROTO MATRIZ 71139 GAROTO 2- 34,5 KV 71253 GAROTO FILIAL II 910793"},{"id":"ad94d42f-40b0-43ff-56ad-08d5ad2bf6ba","name":"CONDOMINIO DO SHOPPING PRAIA DA COSTA","commercialName":"","cnpj":"05391884000176","city":"VILA VELHA","stateCode":"ES","buscaAdicional":"SHOP PRAIA 7502 SHP P COSTA-VL VELHA 72291"},{"id":"333186ec-c5c4-4d84-5747-08d5ad2bf6ba","name":"CONSORCIO BOULEVARD SHOPPING VILA VELHA","commercialName":"","cnpj":"15091769000130","city":"VILA VELHA","stateCode":"ES","buscaAdicional":"SHOPPVILAVELHA 8471 SHOPPING VILA VELHA 889246"},{"id":"424d90d1-c5ac-4aac-638b-08d5ad2bf6ba","name":"BRITO E CIA LTDA","commercialName":"CALCADOS PIMPOLHO","cnpj":"28053601000181","city":"VILA VELHA","stateCode":"ES","buscaAdicional":"CALCADOS PIMPOLHO 55461 BRITO E CIA LTDA 906880"},{"id":"b62497b0-3a61-4a88-6555-08d5ad2bf6ba","name":"PRYSMIAN CABOS E SISTEMAS DO BRASIL S/A","commercialName":"","cnpj":"61150751003528","city":"VILA VELHA","stateCode":"ES","buscaAdicional":"PRYSMIAN VILA VELHA 56656 PRYSMIAN SUR V VELHA 71530"},{"id":"664f99d9-6372-40dc-677f-08d5ad2bf6ba","name":"ASSOCIACAO EVANGELICA BENEFICENTE ESPIRITO-SANTENSE - AEBES","commercialName":"HOSPITAL EVANGELICO DE VILA VELHA","cnpj":"28127926000161","city":"VILA VELHA","stateCode":"ES","buscaAdicional":"AEBES 58230 AEBES 909088"},{"id":"ac67558f-5469-4ab4-6893-08d5ad2bf6ba","name":"T V V - TERMINAL DE VILA VELHA S.A","commercialName":"T V V","cnpj":"02639850000160","city":"VILA VELHA","stateCode":"ES","buscaAdicional":"TVV 60167 TERMINAL VILA VELHA 909937"},{"id":"7b6dbe18-3a3e-4273-aa58-08d5d76be85f","name":"CIA SIDERURGICA SANTA BARBARA","commercialName":"","cnpj":"04765856000109","city":"VILA VELHA","stateCode":"ES","buscaAdicional":""},{"id":"acbcd97c-3b94-4cfe-7371-08d5cf600bef","name":"VIX LOGISTICA S/A","commercialName":"","cnpj":"32681371000172","city":"VITÓRIA","stateCode":"ES","buscaAdicional":""},{"id":"fe5844e7-131d-4143-7369-08d5cf600bef","name":"BANESTES SA BANCO DO ESTADO DO ESPIRITO SANTO","commercialName":"BANESTES","cnpj":"28127603000178","city":"VITÓRIA","stateCode":"ES","buscaAdicional":""},{"id":"ff029ded-0cb1-48de-6877-08d5ad2bf6ba","name":"IRMANDADE DA SANTA CASA DE MISERICORDIA DE VITORIA","commercialName":"IRMANDADE DA SANTA CASA DE MISERICORDIA DE VITORIA","cnpj":"28141190000186","city":"VITÓRIA","stateCode":"ES","buscaAdicional":"SANTA CASA VITORIA 60093 STA CASA MISERIC VIT 909717 STA CASA 9502532 912251"},{"id":"cc12c6ee-54de-49ae-67c4-08d5ad2bf6ba","name":"HOTELARIA PRAIA COMPRIDA LTDA","commercialName":"HOTELARIA PRAIA COMPRIDA LTDA","cnpj":"08805504000190","city":"VITÓRIA","stateCode":"ES","buscaAdicional":"SHERATON VITORIA 58611 SHERATON VITORIA 908444"},{"id":"62cd979f-a6a0-49b4-65de-08d5ad2bf6ba","name":"NEFFA GESTAO,TURISMO E NEGOCIOS S/A","commercialName":"NEFFA GESTAO TURISMO E NEGOCIOS","cnpj":"12851850000182","city":"VITÓRIA","stateCode":"ES","buscaAdicional":"NEFFA 57179 HOTEL ALICE VITORIA 906884 CENTRO DE CONVENCOES 906886"},{"id":"0fae6744-de54-4ea0-6458-08d5ad2bf6ba","name":"UNIMED VITORIA COOPERATIVA DE TRABALHO MEDICO","commercialName":"UNIMED VITORIA EST UNIF","cnpj":"27578434000120","city":"VITÓRIA","stateCode":"ES","buscaAdicional":"UNIMED 55939 UNIMED DIAGNOSTICO 904984 UNIMED CIAS 905021"},{"id":"7ca58045-56a0-44ef-5799-08d5ad2bf6ba","name":"S A A GAZETA","commercialName":"","cnpj":"28133619000193","city":"VITÓRIA","stateCode":"ES","buscaAdicional":"S A A GAZETA 9129 S A A GAZETA 889058"},{"id":"d141492e-4885-4590-5160-08d5ad2bf6ba","name":"CONDOMINIO DO SHOPPING VITORIA","commercialName":"","cnpj":"39780879000177","city":"VITÓRIA","stateCode":"ES","buscaAdicional":"SHOP VITORIA 2145 SHOP VITORIA ES 70507"},{"id":"11b078db-a150-446d-50ab-08d5ad2bf6ba","name":"BUAIZ S/A INDUSTRIA E COMERCIO","commercialName":"","cnpj":"28126928000136","city":"VITÓRIA","stateCode":"ES","buscaAdicional":"BUAIZ S/A 1776 BUAIZ 889013"},{"id":"d776e4fd-7713-4d64-4f4f-08d5ad2bf6ba","name":"ADM DO BRASIL LTDA","commercialName":"A D M","cnpj":"02003402000175","city":"VITÓRIA","stateCode":"ES","buscaAdicional":"ADM 1044 ADM-RONDONOPOLIS-MT 7476 ADM-CAMPO GRANDE-MS 7510 ADM-UBERLANDIA-MG 7873 ADM PORTO SANTOS 907604"},{"id":"0dc704f5-eb35-4af4-4f05-08d5ad2bf6ba","name":"EDP ESPIRITO SANTO DISTRIBUICAO DE ENERGIA S.A.","commercialName":"EDP ESPIRITO SANTO DISTRIBUICAO DE ENERGIA","cnpj":"28152650000171","city":"VITÓRIA","stateCode":"ES","buscaAdicional":"ESCELSA 55 ESCELSA 6"},{"id":"3c212858-8a62-4fef-5921-08d5ad2bf6ba","name":"DM EMPREENDIMENTOS COMERCIAIS S/A","commercialName":"","cnpj":"28410926000174","city":"VITÓRIA","stateCode":"ES","buscaAdicional":"DM EMP 13855 DM EMPREENDIMENTOS 892704 DM EMP 898286"},{"id":"6015686d-19cb-4500-5f87-08d5ad2bf6ba","name":"MMS EMPREENDIMENTOS IMOBILIARIOS LTDA","commercialName":"","cnpj":"21613661000162","city":"VITÓRIA","stateCode":"ES","buscaAdicional":"MMS EMP 53012 MMS EMPREENDIMENTOS 902293"},{"id":"ddafd66f-e6d5-494c-60d6-08d5ad2bf6ba","name":"FUNDACAO DE ASSISTENCIA E EDUCACAO - FAESA","commercialName":"FAESA","cnpj":"27014042000138","city":"VITÓRIA","stateCode":"ES","buscaAdicional":"FAESA 53753 FAESA BL 6 906404 FAESA CENTRAL 906405"},{"id":"4c5d15e9-7e23-4d91-5d2a-08d5ad2bf6ba","name":"A GAZETA DO ESPIRITO SANTO RADIO E TV LTDA","commercialName":"TV GAZETA","cnpj":"27063726000120","city":"VITÓRIA","stateCode":"ES","buscaAdicional":"TV GAZETA 51724 TV GAZETA SEDE 898701 TV GAZETA FONTE GRAN 898702"},{"id":"b97c9ff0-1021-406b-61b1-08d5ad2bf6ba","name":"CONCESSIONARIA AGUAS DE JUTURNAIBA S/A","commercialName":"","cnpj":"02013199000118","city":"ARARUAMA","stateCode":"RJ","buscaAdicional":"AGUAS DE JUTURNAIBA 54342 BOOSTER BACAXA 904831 BOOSTER IGUABA 904846 ETA JUTURNAIBA 904853 BOOSTER ARARUAMA 904856"},{"id":"0da7a51f-90e3-4095-5071-08d5ad2bf6ba","name":"QUANTA GERACAO S/A","commercialName":"","cnpj":"07642982000164","city":"AREAL","stateCode":"RJ","buscaAdicional":"QUANTA GERACAO 1630 PIABANHA 8104 PCH.PH.RJ.002051-6.01 TOMBOS 8105 PCH.PH.MG.002856-8.01 MACABU 8106 PCH.PH.RJ.001347-1.01 AREAL (QUANTA) 8107 PCH.PH.RJ.000140-6.01 FAGUNDES 8108 PCH.PH.RJ.000928-8.01 EUCLIDELANDIA 8109 PCH.PH.RJ.000922-9.01 CHAVE DO VAZ 8110 PCH.PH.RJ.000765-0.01 FRANCA AMARAL 8111 PCH.PH.RJ.000992-0.01"},{"id":"e585def5-2ffb-49cb-6973-08d5ad2bf6ba","name":"CONDOMINIO BREEZES BUZIOS RESORT","commercialName":"BREEZES BUZIOS RESORT","cnpj":"11461279000127","city":"ARMAÇÃO DOS BÚZIOS","stateCode":"RJ","buscaAdicional":"BUZIOS RESORT 61671 BUZIOS RESORT 912335"},{"id":"798de4eb-56ef-4dbd-8863-08d5ae44ed50","name":"BR METALS FUNDICOES LTDA","commercialName":"","cnpj":"19811058000143","city":"BARRA DO PIRAÍ","stateCode":"RJ","buscaAdicional":"BR METALS PIR 4780 BR METALS-B PIRAI 71811"},{"id":"f3bf905a-3573-4332-6838-08d5ad2bf6ba","name":"METALURGICA BARRA DO PIRAI S/A","commercialName":"","cnpj":"28566933000160","city":"BARRA DO PIRAÍ","stateCode":"RJ","buscaAdicional":"MPB 59495 METALURGICA BARRA DO 910142"},{"id":"95438bae-49bb-4983-663f-08d5ad2bf6ba","name":"SCHIOPPA 19 DO BRASIL LTDA","commercialName":"","cnpj":"16624584000106","city":"BARRA DO PIRAÍ","stateCode":"RJ","buscaAdicional":"SCHIOPPA 57418 SCHIOPPA B DO PIRAI 908440"},{"id":"a210bb93-641b-4917-67ae-08d5ad2bf6ba","name":"H S COUTINHO INDUSTRIA E COMERCIO LTDA","commercialName":"","cnpj":"28580702000100","city":"BARRA DO PIRAÍ","stateCode":"RJ","buscaAdicional":"CASA DO ARROZ 58430 CASA ARROZ BARRA PIR 909283 CASA ARROZ FILIAL 2 909284 CASA ARROZ FILIAL 1 909302 CASA DO ARROZ MATRIZ 909735"},{"id":"54ca5215-fc03-45bf-5db4-08d5ad2bf6ba","name":"QUIMVALE QUIMICA INDUSTRIAL VALE DO PARAIBA LTDA","commercialName":"QUIMVALE","cnpj":"29041324000150","city":"BARRA DO PIRAÍ","stateCode":"RJ","buscaAdicional":"QUIMVALE 51961 QUIMVALE 899794"},{"id":"f080c188-8679-41af-4ff7-08d5ad2bf6ba","name":"SAINT-GOBAIN CANALIZACAO LTDA","commercialName":"BARBARA","cnpj":"28672087000162","city":"BARRA MANSA","stateCode":"RJ","buscaAdicional":"SGOBAIN CAN MT 1377 S GOBAIN CANALIZ BM 7277"},{"id":"1971a7d9-f560-4b06-68c6-08d5ad2bf6ba","name":"AMANPLAST INDUSTRIA E COMERCIO DE PLASTICOS LTDA","commercialName":"","cnpj":"39758685000175","city":"BARRA MANSA","stateCode":"RJ","buscaAdicional":"AMANPLAST 60403 AMANPLAST 911262"},{"id":"ca426883-2c8e-49d2-64c7-08d5ad2bf6ba","name":"COOPERATIVA AGRO PECUARIA DE BARRA MANSA LTDA","commercialName":"COBAMA","cnpj":"28672996000109","city":"BARRA MANSA","stateCode":"RJ","buscaAdicional":"BARRA MANSA 56218 COOP AGRO PEC BARRA 907781"},{"id":"4a49d79f-40dc-4853-64c6-08d5ad2bf6ba","name":"W.K. A BARATEIRA DE NILOPOLIS LTDA","commercialName":"GRIPPON","cnpj":"11687101000107","city":"BELFORD ROXO","stateCode":"RJ","buscaAdicional":"BARATEIRA 56217 WKA BARATEIRA NILOP 909867"},{"id":"a55c1e31-e6e2-4de3-6552-08d5ad2bf6ba","name":"LUBRIZOL DO BRASIL ADITIVOS LTDA","commercialName":"","cnpj":"42593962000141","city":"BELFORD ROXO","stateCode":"RJ","buscaAdicional":"LUBRIZOL 56653 LUBRIZOL 909911"},{"id":"ed28d717-facb-4661-6211-08d5ad2bf6ba","name":"SHOPPING PARK LAGOS S/A","commercialName":"","cnpj":"11323246000110","city":"CABO FRIO","stateCode":"RJ","buscaAdicional":"PARK LAGOS 54535 SHOPPING PARK LAGOS 904576"},{"id":"39a2120b-d869-410f-1cbf-08d5b8870181","name":"FIAMMA INDUSTRIA E COMERCIO DE ALIMENTOS LTDA","commercialName":"","cnpj":"16920268000181","city":"COMENDADOR LEVY GASPARIAN","stateCode":"RJ","buscaAdicional":"FIAMMA 61126 FIAMMA 912598"},{"id":"dd75c780-a123-4378-61ac-08d5ad2bf6ba","name":"AGUAS DO PARAIBA SA","commercialName":"","cnpj":"01280003000199","city":"CAMPOS DOS GOYTACAZES","stateCode":"RJ","buscaAdicional":"AGUAS DO PARAIBA 54336 EEEB CENTRAL 904868 ETA COROA 904869 CAPTACAO ETA COROA 904876 ETA DONANA 904877 ETE CHATUBA 904878"},{"id":"19a5db45-c8ab-4ebe-62f4-08d5ad2bf6ba","name":"BARCELOS & CIA LTDA","commercialName":"SUPER BOM SUPERMERCADOS","cnpj":"28598795000109","city":"CAMPOS DOS GOYTACAZES","stateCode":"RJ","buscaAdicional":"BARCELOS 55059 BARCELOS E CIA LTDA 906614 BARCELOS ALB TORRES 906622 BARCELOS ALB LAMEGO 906623 BACELOS JOSE ALVES 906626 BARCELOS RAUL SOUTO 906629 BARCELOS SILVIO BAST 906635 BARCELOS B TARCISIO 906636 BARCELOS 13 DE MAIO 906637"},{"id":"d64fc6d5-6cc5-47a7-63f9-08d5ad2bf6ba","name":"PROFINE INDUSTRIA DE ADITIVOS MINERAIS LTDA","commercialName":"","cnpj":"08888916000131","city":"CAMPOS DOS GOYTACAZES","stateCode":"RJ","buscaAdicional":"PROFINE 55760 PROFINE 905295"},{"id":"5ce1c555-23ee-4ed8-543a-08d5ad2bf6ba","name":"CANABRAVA ENERGETICA S/A","commercialName":"","cnpj":"11235729000163","city":"CAMPOS DOS GOYTACAZES","stateCode":"RJ","buscaAdicional":"CANABRAVA 4105 CANABRAVA 8859 UTE.AI.RJ.030066-7.01"},{"id":"9529a1d3-9110-4acb-595c-08d5ad2bf6ba","name":"PURAC SINTESES INDUSTRIA E COMERCIO LIMITADA","commercialName":"PURAC SINTESES","cnpj":"28942225000267","city":"CAMPOS DOS GOYTACAZES","stateCode":"RJ","buscaAdicional":"CORBION PURAC 14315 CORBION PURAC 893643"},{"id":"2b123cab-0a3c-45e4-58b6-08d5ad2bf6ba","name":"BRASALPLA RIO DE JANEIRO - INDUSTRIA DE EMBALAGENS LTDA.","commercialName":"","cnpj":"11767105000197","city":"DUQUE DE CAXIAS","stateCode":"RJ","buscaAdicional":"BRASALPLA RIO 12973 BRASALPLA D CAXIAS 892025"},{"id":"9c28eb41-351a-481e-5b05-08d5ad2bf6ba","name":"INDUSTRIA DE PLASTICO E VIDRO BRACO LTDA","commercialName":"","cnpj":"33303231000123","city":"DUQUE DE CAXIAS","stateCode":"RJ","buscaAdicional":"VIBRACO 50391 VIBRACO RJ 897670"},{"id":"e05af9d9-dc82-499f-5b06-08d5ad2bf6ba","name":"RAIZES IND E COM DE EMBALAGENS E SERVICOS LTDA","commercialName":"","cnpj":"36547966000190","city":"DUQUE DE CAXIAS","stateCode":"RJ","buscaAdicional":"RAIZESRJ 50392 RAIZES RJ 898177"},{"id":"5edf5733-ce6b-4617-5c78-08d5ad2bf6ba","name":"EXPOENTE 1000 EMPREENDIMENTOS E PARTICIPACOES S/A","commercialName":"","cnpj":"04009191000103","city":"DUQUE DE CAXIAS","stateCode":"RJ","buscaAdicional":"CAXIAS SHOPPING 51330 EXPOENTE 1000 900653"},{"id":"1859bc3a-babe-402c-5dc6-08d5ad2bf6ba","name":"GAS VERDE S/A","commercialName":"","cnpj":"11131464000234","city":"DUQUE DE CAXIAS","stateCode":"RJ","buscaAdicional":"GAS VERDE 51983 GAS VERDE 902976"},{"id":"be7ff046-01e9-4f39-5f8e-08d5ad2bf6ba","name":"CEMED CARE - EMPRESA DE ATENDIMENTO CLINICO GERAL LTDA","commercialName":"","cnpj":"07794623000122","city":"DUQUE DE CAXIAS","stateCode":"RJ","buscaAdicional":"CEMED CARE 53021 CEMED PASTEUR TIJUCA 905842 CEMED MARIO LIONI 905843 CEMED CAMPO GRANDE 906658"},{"id":"4b26f4ca-5a67-4da3-551f-08d5ad2bf6ba","name":"CIFERAL INDUSTRIA DE ONIBUS LTDA","commercialName":"","cnpj":"30314561000126","city":"DUQUE DE CAXIAS","stateCode":"RJ","buscaAdicional":"CIFERAL 5088 CIFERAL-D CAXIAS 71775"},{"id":"d0f3cbdc-f1b0-4e18-55a7-08d5ad2bf6ba","name":"ESHO EMPRESA DE SERVICOS HOSPITALARES S.A.","commercialName":"","cnpj":"29435005000129","city":"DUQUE DE CAXIAS","stateCode":"RJ","buscaAdicional":"ESHO 5941 ESHO H PAULISTANO 72035 ESHO H VITORIA - SP 72103 ESHO CARLOS CHAGAS 905761 HOSPITAL SAMARITANO 906219 ESHO MARIO LIONI 907101 HOSPITAL MTE KLINIKU 908069 ESHO PASTEUR MEIER 908254 HOSP VITORIA SANTOS 908338 ESHO 908703"},{"id":"86dd3bf4-cd7b-433e-4fdc-08d5ad2bf6ba","name":"NITRIFLEX S A INDUSTRIA E COMERCIO","commercialName":"NITRIFLEX","cnpj":"42147496000170","city":"DUQUE DE CAXIAS","stateCode":"RJ","buscaAdicional":"NITRIFLEX 1322 NITRIFLEX-DQ CAXIAS 7804"},{"id":"1e81ead7-cca3-46ec-500e-08d5ad2bf6ba","name":"ARLANXEO BRASIL S.A.","commercialName":"","cnpj":"29667227000177","city":"DUQUE DE CAXIAS","stateCode":"RJ","buscaAdicional":"ARLANXEO TSR CAXIAS 1415 PETROFLEX-DQ CAXIAS 7215"},{"id":"d722f4ca-4615-455e-513d-08d5ad2bf6ba","name":"CPR INDUSTRIA E COMERCIO DE PLASTICO LTDA","commercialName":"","cnpj":"04285109000173","city":"DUQUE DE CAXIAS","stateCode":"RJ","buscaAdicional":"CPR 2060 CPR MTZ D CAXIAS LIV 70398"},{"id":"d0ca3ca6-8ee2-4a49-648e-08d5ad2bf6ba","name":"COMERCIAL MILANO BRASIL LTDAA","commercialName":"","cnpj":"01920177000179","city":"DUQUE DE CAXIAS","stateCode":"RJ","buscaAdicional":"COMERCIAL MILANO 56085 MILANO DUQUE DE CAX 907574 MILANO NOGUEIRA 908101"},{"id":"0cf66133-47aa-4159-6327-08d5ad2bf6ba","name":"CASALITE IND E COM DE MATERIAIS DE CONSTRUCAO LTDA","commercialName":"CASALITE","cnpj":"27895762000150","city":"DUQUE DE CAXIAS","stateCode":"RJ","buscaAdicional":"CASALITE 55191 CASALITE CONSTR 907298"},{"id":"6b977d0b-418c-46ef-6175-08d5ad2bf6ba","name":"FRIGORIFICO JAHU LTDA","commercialName":"","cnpj":"61286613000121","city":"DUQUE DE CAXIAS","stateCode":"RJ","buscaAdicional":"FRIGORIFICO JAHU 54197 FRIGORIFICO JAHU 904870"},{"id":"84b34efd-4410-4f30-6146-08d5ad2bf6ba","name":"DIAGNOSTICOS DA AMERICA S.A .","commercialName":"","cnpj":"61486650049867","city":"DUQUE DE CAXIAS","stateCode":"RJ","buscaAdicional":"DASA DUQUE CAXIAS 54098 DASA CAXIAS 905377"},{"id":"26bccff4-8b53-44b9-65cd-08d5ad2bf6ba","name":"IBF INDUSTRIA BRASILEIRA DE FILMES S/A.","commercialName":"","cnpj":"33255787000191","city":"DUQUE DE CAXIAS","stateCode":"RJ","buscaAdicional":"IBF 57139 IBF FILMES 907308"},{"id":"c37d89a7-dd79-4a18-1cae-08d5b8870181","name":"SAFRAN HELICOPTER ENGINES INDUSTRIA E COMERCIO DO BRASIL LTDA","commercialName":"","cnpj":"48090120000153","city":"DUQUE DE CAXIAS","stateCode":"RJ","buscaAdicional":"SAFRAN 60808 SAFRAN DUQUE CAXIAS 912776"},{"id":"5cb308f0-311a-46c4-736e-08d5cf600bef","name":"NORTEC QUIMICA S.A.","commercialName":"NORTEC","cnpj":"29950060000157","city":"DUQUE DE CAXIAS","stateCode":"RJ","buscaAdicional":""},{"id":"1ccf79c5-99ee-4521-6506-08d5ad2bf6ba","name":"GUAPI PAPEIS INDUSTRIA DE PAPEL E PAPELAO LTDA","commercialName":"GUAPI PAPEIS","cnpj":"09470092000148","city":"GUAPIMIRIM","stateCode":"RJ","buscaAdicional":"GUAPI PAPEIS 56384 GUAPI PAPEIS 907689"},{"id":"43448712-d24f-49c1-1cbc-08d5b8870181","name":"SUPERMERCADOS ALVORADA EIRELI","commercialName":"SUPERMARKET","cnpj":"17833301000107","city":"ITABORAÍ","stateCode":"RJ","buscaAdicional":"SM ALVORADA 61100 MAGE I 912783 ITABORAI 912792"},{"id":"da06c1b8-9aa4-489d-59a1-08d5ad2bf6ba","name":"SUBCONDOMINIO ITABORAI PLAZA","commercialName":"BLOCO SHOPPING E BLOCO ANCORA","cnpj":"20042660000142","city":"ITABORAÍ","stateCode":"RJ","buscaAdicional":"SHOPPING ITABORAI PLAZA 15198 SHOPPING ITABORAI 894885"},{"id":"13503861-bf81-4d3b-5984-08d5ad2bf6ba","name":"PORTO SUDESTE DO BRASIL SA","commercialName":"","cnpj":"08310839000138","city":"ITAGUAÍ","stateCode":"RJ","buscaAdicional":"PORTO SUDESTE 14735 PORTO SUDESTE 893742"},{"id":"fdf29a57-ed4d-495b-4ede-08d5d159243d","name":"PORTO SUDESTE V.M. S/A","commercialName":"","cnpj":"18494485000182","city":"ITAGUAÍ","stateCode":"RJ","buscaAdicional":""},{"id":"e5a1790b-1e65-47a3-6508-08d5ad2bf6ba","name":"ITAGUAI CONSTRUCOES NAVAIS S/A","commercialName":"ITAGUAI CONSTRUCOES NAVAIS S/A","cnpj":"10827182000203","city":"ITAGUAÍ","stateCode":"RJ","buscaAdicional":"ICN 56390 ITAGUAI CONST NAVAIS 908222"},{"id":"c523d8c9-b816-4f10-6803-08d5ad2bf6ba","name":"FRINENSE ALIMENTOS LTDA","commercialName":"","cnpj":"07042642000364","city":"ITAPERUNA","stateCode":"RJ","buscaAdicional":"FRINENSE 59183 FRINENSE 910955"},{"id":"2d8febbf-ad79-4c34-6912-08d5ad2bf6ba","name":"SUPERMERCADO FLUMINENSE DE ITAPERUNA LTDA","commercialName":"MERCADO FLUMINENSE","cnpj":"32336794000155","city":"ITAPERUNA","stateCode":"RJ","buscaAdicional":"SUPERMERCADO FLUMINENSE 60760 LOJA 1 - 2219850-4 911691 LOJA 2 - 2902043-3 911711"},{"id":"56ce3b59-50ed-4fff-5d25-08d5ad2bf6ba","name":"HYUNDAI HEAVY INDUSTRIES BRASIL INDUSTRIA E COMERCIO DE EQUIPAMENTOS DE CONSTRUCAO S.A.","commercialName":"HHI BRASIL","cnpj":"13837846000122","city":"ITATIAIA","stateCode":"RJ","buscaAdicional":"HYUNDAI HIB 51717 HYUNDAI MATRIZ 899804"},{"id":"8b4d9e01-d3ce-473c-5cce-08d5ad2bf6ba","name":"IBRAME INDUSTRIA BRASILEIRA DE METAIS S/A","commercialName":"","cnpj":"60846599000704","city":"ITATIAIA","stateCode":"RJ","buscaAdicional":"IBRAME METAIS 51575 IBRAME METAIS 899296"},{"id":"6fa586ca-8ab9-44fc-691f-08d5ad2bf6ba","name":"POLY FFS EMBALAGENS PLASTICAS LTDA.","commercialName":"","cnpj":"07046827000185","city":"JAPERI","stateCode":"RJ","buscaAdicional":"POLY FFS 60779 POLY FFS 910674"},{"id":"83aa244f-0f18-4a44-6805-08d5ad2bf6ba","name":"SCHLUMBERGER SERVICOS DE PETROLEO LTDA","commercialName":"","cnpj":"32319931002863","city":"MACAÉ","stateCode":"RJ","buscaAdicional":"SCHLUMBERGER MACAE CIO 59186 SCHLUMBERGER 908778"},{"id":"4b3eea3e-53a5-4899-53f9-08d5ad2bf6ba","name":"CONDOMINIO PLAZA MACAE","commercialName":"CONDOMINIO PLAZA MACAE","cnpj":"08931921000180","city":"MACAÉ","stateCode":"RJ","buscaAdicional":"PLAZA MACAE 3939 COND. PLAZA MACAE 71402"},{"id":"e4114c58-eca5-451a-5907-08d5ad2bf6ba","name":"FABRICAS UNIDAS ENERGIA LTDA.","commercialName":"","cnpj":"33248238000190","city":"MAGÉ","stateCode":"RJ","buscaAdicional":"CGH ANDORINHAS II 13592 CGH ANDORINHAS II 896127 CGH.PH.RJ.000769-2.01"},{"id":"de18204a-c78c-41fa-5b94-08d5ad2bf6ba","name":"EMPRESA DE MINERACAO DE AGUAS SANT'ANNA LTDA","commercialName":"","cnpj":"04574135000200","city":"MAGÉ","stateCode":"RJ","buscaAdicional":"SANTANNA 50771 AGUAS SANTANNA 899278"},{"id":"9d554162-706e-4ad8-5b8a-08d5ad2bf6ba","name":"ATLANTICA INDUSTRIA E COMERCIO DE AGUAS MINERAIS LTDA","commercialName":"","cnpj":"13708133000169","city":"MAGÉ","stateCode":"RJ","buscaAdicional":"ATLANTICA 50756 ATLANTICA AGUAS 899065"},{"id":"b4183a3f-e982-4a56-7221-08d5cf600bef","name":"CONCESSIONARIA RIO TERESOPOLIS S A","commercialName":"","cnpj":"00938574000105","city":"MAGÉ","stateCode":"RJ","buscaAdicional":""},{"id":"ca772cb3-bb41-448d-5e24-08d5ad2bf6ba","name":"FABRICA DE GELO RAMIA E MARQUES EIRELI","commercialName":"GELOTIMO","cnpj":"39180625000118","city":"MARICÁ","stateCode":"RJ","buscaAdicional":"GELOTIMO 52234 GELOTIMO 899859"},{"id":"096ffe21-a2ba-4b31-5c8c-08d5ad2bf6ba","name":"ENEL GREEN POWER MOURAO S.A.","commercialName":"","cnpj":"23842022000102","city":"NITERÓI","stateCode":"RJ","buscaAdicional":"MOURAO CONV 51379 MOURAO I 513 UHE.PH.PR.001509-1.02 MOURAO ACL 906281 UHE.PH.PR.001509-1.02 MOURAO ACL 906281 UHE.PH.PR.001509-1.02"},{"id":"bcb87850-ec62-4f98-5c8d-08d5ad2bf6ba","name":"ENEL GREEN POWER PARANAPANEMA S/A","commercialName":"","cnpj":"23842003000178","city":"NITERÓI","stateCode":"RJ","buscaAdicional":"ENEL PARANAPANEMA CONV 51380 PARANAPANEMA 427 UHE.PH.SP.001972-0.01 PARANAPANEMA ACL 906282 UHE.PH.SP.001972-0.01 PARANAPANEMA ACL 906282 UHE.PH.SP.001972-0.01"},{"id":"0b847d55-79f4-4aa9-607c-08d5ad2bf6ba","name":"EMPRESA BRASILEIRA DE REPAROS NAVAIS S A RENAVE","commercialName":"","cnpj":"42362160000201","city":"NITERÓI","stateCode":"RJ","buscaAdicional":"RENAVI 53534 RENAVE EMP BR REPARO 906330"},{"id":"16d64f95-76b4-4cd9-5c3c-08d5ad2bf6ba","name":"COMPANHIA BRASILEIRA DE AMARRAS BRASILAMARRAS","commercialName":"","cnpj":"29566858000108","city":"NITERÓI","stateCode":"RJ","buscaAdicional":"BRASILAMARRAS 51206 BRASILAMARRAS 899214 BRASILAMARRAS2 899215"},{"id":"d47ff266-009b-4226-5c0d-08d5ad2bf6ba","name":"ENEL GREEN POWER NOVA LAPA SOLAR S/A","commercialName":"","cnpj":"23509564000150","city":"NITERÓI","stateCode":"RJ","buscaAdicional":"NOVA LAPA 51050 UFV LAPA 2 908972 UFV.RS.BA.034437-0.01 UFV LAPA 3 908971 UFV.RS.BA.034333-1.01"},{"id":"431db103-4b00-451c-5c01-08d5ad2bf6ba","name":"ENEL GREEN POWER BOM JESUS DA LAPA SOLAR S.A.","commercialName":"","cnpj":"23266854000110","city":"NITERÓI","stateCode":"RJ","buscaAdicional":"BOM JESUS DA LAPA 51033 UFV BOM JESUS LAPA 1 908531 UFV.RS.BA.032892-8.01 UFV BOM JESUS LAPA 2 908532 UFV.RS.BA.032893-6.01"},{"id":"8764424f-4e6e-45dd-5c02-08d5ad2bf6ba","name":"ENEL GREEN POWER HORIZONTE MP SOLAR S.A.","commercialName":"","cnpj":"23399589000148","city":"NITERÓI","stateCode":"RJ","buscaAdicional":"HORIZONTE MP 51034 HORIZONTE MP 1 909580 UFV.RS.BA.033757-9.01 HORIZONTE MP 11 909743 UFV.RS.BA.033777-3.01 HORIZONTE MP 2 909744 UFV.RS.BA.033759-5.01"},{"id":"251511f3-bcf2-4332-5c03-08d5ad2bf6ba","name":"ENEL GREEN POWER NOVA OLINDA SUL SOLAR S.A","commercialName":"","cnpj":"23399563000108","city":"NITERÓI","stateCode":"RJ","buscaAdicional":"NOVA OLINDA SUL 51035 NOVA OLINDA 14 909887 UFV.RS.PI.033133-3.01"},{"id":"7834aff4-a14b-41ce-5c04-08d5ad2bf6ba","name":"ENEL GREEN POWER NOVA OLINDA C SOLAR S/A","commercialName":"","cnpj":"23414549000128","city":"NITERÓI","stateCode":"RJ","buscaAdicional":"NOVA OLINDA C 51036 NOVA OLINDA 12 909885 UFV.RS.PI.033131-7.01 NOVA OLINDA 13 909886 UFV.RS.PI.033132-5.01"},{"id":"45c77b1b-c9e4-41d0-5c05-08d5ad2bf6ba","name":"ENEL GREEN POWER NOVA OLINDA B SOLAR S.A","commercialName":"","cnpj":"23416727000150","city":"NITERÓI","stateCode":"RJ","buscaAdicional":"NOVA OLINDA B 51037 NOVA OLINDA 10 909884 UFV.RS.PI.033129-5.01 NOVA OLINDA 11 909883 UFV.RS.PI.033130-9.01"},{"id":"ff7463ec-a4b4-4152-5c06-08d5ad2bf6ba","name":"ENEL GREEN POWER NOVA OLINDA NORTE SOLAR S.A.","commercialName":"","cnpj":"23566105000108","city":"NITERÓI","stateCode":"RJ","buscaAdicional":"NOVA OLINDA NORTE 51039 NOVA OLINDA 8 909881 UFV.RS.PI.033127-9.01 NOVA OLINDA 9 909882 UFV.RS.PI.033128-7.01"},{"id":"50f1cc40-86d0-48bb-5b3a-08d5ad2bf6ba","name":"ASSOCIACAO SHOPPING BAY MARKET CENTER","commercialName":"","cnpj":"20739535000196","city":"NITERÓI","stateCode":"RJ","buscaAdicional":"SC BAY MARKET 50531 SHOP BAY MARKET 898179"},{"id":"26cae62f-7359-4b4c-5aa6-08d5ad2bf6ba","name":"ENEL GREEN POWER CRISTALANDIA I EOLICA S.A.","commercialName":"","cnpj":"22499471000129","city":"NITERÓI","stateCode":"RJ","buscaAdicional":"CRISTALANDIA I 50136 CRISTALANDIA I 909586 EOL.CV.BA.032081-1.01"},{"id":"e59a22b7-b342-4518-5a69-08d5ad2bf6ba","name":"IMPAR SERVICOS HOSPITALARES S/A","commercialName":"CHN - COMPLEXO HOSPITALAR DE NITEROI","cnpj":"60884855001207","city":"NITERÓI","stateCode":"RJ","buscaAdicional":"HCN IMPAR 17446 H CLINICAS NITEROI 71555"},{"id":"708a306e-f066-4391-5a46-08d5ad2bf6ba","name":"ENEL GREEN POWER MORRO DO CHAPEU II EOLICA S.A","commercialName":"","cnpj":"21869008000169","city":"NITERÓI","stateCode":"RJ","buscaAdicional":"MORRO DO CHAPEU II 17264 VENTOS DA STA DULCE 911671 EOL.CV.BA.033648-3.01 VENT DA ST ESPERANCA 911973 EOL.CV.BA.033649-1.01"},{"id":"69a71a51-f2f2-4a61-58d1-08d5ad2bf6ba","name":"ENEL GREEN POWER ESPERANCA EOLICA S.A.","commercialName":"","cnpj":"19011517000104","city":"NITERÓI","stateCode":"RJ","buscaAdicional":"ESPERANCA EOLICA 13372 EOL ESPERANCA 896468 EOL.CV.BA.031355-6.01"},{"id":"83b790ea-5ced-4a3b-58d2-08d5ad2bf6ba","name":"ENEL GREEN POWER MANICOBA EOLICA S.A.","commercialName":"","cnpj":"19011479000190","city":"NITERÓI","stateCode":"RJ","buscaAdicional":"MANICOBA EOLICA 13373 MANICOBA 896469 EOL.CV.BA.031337-8.01"},{"id":"a1594476-631b-4943-58d3-08d5ad2bf6ba","name":"ENEL GREEN POWER SALTO APIACAS S.A.","commercialName":"","cnpj":"17832065000104","city":"NITERÓI","stateCode":"RJ","buscaAdicional":"SALTO APIACAS 13374 SALTO APIACAS 898926 UHE.PH.MT.031401-3.01"},{"id":"0eb2ba6f-799c-45dc-58d4-08d5ad2bf6ba","name":"ENEL GREEN POWER FAZENDA S.A","commercialName":"","cnpj":"17018327000193","city":"NITERÓI","stateCode":"RJ","buscaAdicional":"FAZENDA 13375 DA FAZENDA 898927 PCH.PH.MT.029734-8.01"},{"id":"5e9a0c79-21a3-4df6-58d5-08d5ad2bf6ba","name":"ENEL GREEN POWER DAMASCENA EOLICA S.A.","commercialName":"","cnpj":"19046080000144","city":"NITERÓI","stateCode":"RJ","buscaAdicional":"DAMASCENA EOLICA 13392 DAMASCENA 896467 EOL.CV.BA.031338-6.01"},{"id":"9aa2d2b8-949c-4e9a-58d6-08d5ad2bf6ba","name":"ENEL GREEN POWER CABECA DE BOI S.A","commercialName":"","cnpj":"16993629000110","city":"NITERÓI","stateCode":"RJ","buscaAdicional":"CABECA DE BOI 13393 CABECA DE BOI 898928 PCH.PH.MT.029733-0.01"},{"id":"718a0606-3d19-43d7-586d-08d5ad2bf6ba","name":"ENEL GREEN POWER DOIS RIACHOS EOLICA S.A.","commercialName":"","cnpj":"17018370000159","city":"NITERÓI","stateCode":"RJ","buscaAdicional":"EGP DOIS RIACHOS 11750 DOIS RIACHOS 890997 EOL.CV.BA.031121-9.01"},{"id":"01aa9773-ba32-463f-592a-08d5ad2bf6ba","name":"ENEL SOLUCOES ENERGETICAS LTDA","commercialName":"","cnpj":"18303676000110","city":"NITERÓI","stateCode":"RJ","buscaAdicional":"ENEL 13955 FOTE SOLAR I 895982 UFV.RS.PE.032372-1.01 FONTES SOLAR II 895983 UFV.RS.PE.032373-0.01"},{"id":"2565f2fc-e815-475b-5a24-08d5ad2bf6ba","name":"ENEL GREEN POWER DELFINA C EOLICA S.A.","commercialName":"","cnpj":"21553603000190","city":"NITERÓI","stateCode":"RJ","buscaAdicional":"EOL DELFINA C 16544 DELFINA 4 910130 EOL.CV.BA.032522-8.01"},{"id":"35eec316-2d52-4351-5a25-08d5ad2bf6ba","name":"ENEL GREEN POWER ITUVERAVA SUL SOLAR S A","commercialName":"","cnpj":"21619125000174","city":"NITERÓI","stateCode":"RJ","buscaAdicional":"ENEL SUL SOLAR 16564 ITUVERAVA 05 909384 UFV.RS.BA.032320-9.01 ITUVERAVA 6 909385 UFV.RS.BA.032321-7.01 ITUVERAVA 07 909832 UFV.RS.BA.032322-5.01"},{"id":"7298af3f-9517-4512-5a1d-08d5ad2bf6ba","name":"ENEL GREEN POWER DELFINA A EOLICA S.A.","commercialName":"","cnpj":"21552886000156","city":"NITERÓI","stateCode":"RJ","buscaAdicional":"EOL DELFINA A 16528 DELFINA 1 910134 EOL.CV.BA.032357-8.01 DELFINA 2 910136 EOL.CV.BA.032358-6.01 DELFINA 5 910138 EOL.CV.BA.032359-4.01"},{"id":"c96d4062-bdfe-4d4d-5a1e-08d5ad2bf6ba","name":"ENEL GREEN POWER DELFINA B EOLICA S.A.","commercialName":"","cnpj":"21556441000144","city":"NITERÓI","stateCode":"RJ","buscaAdicional":"EOL DELFINA B 16529 DELFINA 3 910139 EOL.CV.BA.032521-0.01"},{"id":"f77b63ef-2454-4a59-5a1f-08d5ad2bf6ba","name":"ENEL GREEN POWER ITUVERAVA NORTE SOLAR S A","commercialName":"","cnpj":"21619094000151","city":"NITERÓI","stateCode":"RJ","buscaAdicional":"ENEL NORTE SOLAR 16530 ITUVERAVA 1 909288 UFV.RS.BA.032316-0.01 ITUVERAVA 2 909306 UFV.RS.BA.032317-9.01"},{"id":"6bffd45e-d229-4c06-5a20-08d5ad2bf6ba","name":"ENEL GREEN POWER DELFINA D EOLICA S.A.","commercialName":"","cnpj":"21553640000107","city":"NITERÓI","stateCode":"RJ","buscaAdicional":"EOL DELFINA D 16531 DELFINA 6 910171 EOL.CV.BA.032523-6.01"},{"id":"88f01301-51ca-467e-5a21-08d5ad2bf6ba","name":"ENEL GREEN POWER DELFINA E EOLICA S.A.","commercialName":"","cnpj":"21599114000170","city":"NITERÓI","stateCode":"RJ","buscaAdicional":"EOL DELFINA E 16532 DELFINA 7 910120 EOL.CV.BA.032524-4.01"},{"id":"4928a348-03de-4c07-5a22-08d5ad2bf6ba","name":"ENEL GREEN POWER ITUVERAVA SOLAR S A","commercialName":"","cnpj":"21602288000144","city":"NITERÓI","stateCode":"RJ","buscaAdicional":"ENEL ITUVERAVA SOLAR 16533 ITUVERAVA 3 909289 UFV.RS.BA.032318-7.01 ITUVERAVA 4 909833 UFV.RS.BA.032319-5.01"},{"id":"44fb25a5-b4a8-4ebb-5a44-08d5ad2bf6ba","name":"ENEL GREEN POWER MORRO DO CHAPEU I EOLICA S.A.","commercialName":"","cnpj":"21868992000143","city":"NITERÓI","stateCode":"RJ","buscaAdicional":"MORRO DO CHAPEU I 17244 VENTOS DO SAO PAULO 911952 EOL.CV.BA.033652-1.01"},{"id":"1375f1e7-5796-4c54-5408-08d5ad2bf6ba","name":"ENEL GREEN POWER PRIMAVERA EOLICA S/A","commercialName":"","cnpj":"12851871000106","city":"NITERÓI","stateCode":"RJ","buscaAdicional":"EGPPE 3959 PRIMAVERA 3LER 890757 EOL.CV.BA.030726-2.01"},{"id":"3fcddda3-2d38-4103-5409-08d5ad2bf6ba","name":"ENEL GREEN POWER CRISTAL EOLICA S/A","commercialName":"","cnpj":"12851920000100","city":"NITERÓI","stateCode":"RJ","buscaAdicional":"EGPCE 3960 CRISTAL 3LER 890747 EOL.CV.BA.030727-0.01"},{"id":"28e90258-5286-43ef-540a-08d5ad2bf6ba","name":"ENEL GREEN POWER SAO JUDAS EOLICA S/A","commercialName":"","cnpj":"12851951000153","city":"NITERÓI","stateCode":"RJ","buscaAdicional":"EGPSJE 3962 SAO JUDAS 3LER 890748 EOL.CV.BA.030725-4.01"},{"id":"0a01fe0d-d463-48da-5526-08d5ad2bf6ba","name":"ENEL GREEN POWER PAU FERRO EOLICA S.A.","commercialName":"","cnpj":"14422424000159","city":"NITERÓI","stateCode":"RJ","buscaAdicional":"EGP PAUFERRO 5149 PAU FERRO 892120 EOL.CV.PE.030805-6.01"},{"id":"b5184cd2-bd26-4aa2-5527-08d5ad2bf6ba","name":"ENEL GREEN POWER PEDRA DO GERONIMO EOLICA S.A.","commercialName":"","cnpj":"14422483000127","city":"NITERÓI","stateCode":"RJ","buscaAdicional":"EGP GERONIMO 5150 PEDRA DO GERONIMO 892302 EOL.CV.PE.030806-4.01"},{"id":"e5a3c401-86b0-4a69-5529-08d5ad2bf6ba","name":"ENEL GREEN POWER TACAICO EOLICA S.A.","commercialName":"","cnpj":"14411251000173","city":"NITERÓI","stateCode":"RJ","buscaAdicional":"EGP TACAICO 5153 TACAICO 892183 EOL.CV.PE.030789-0.01"},{"id":"5c7eeb6b-bff9-4d6c-552d-08d5ad2bf6ba","name":"ENEL GREEN POWER MODELO I EOLICA S.A.","commercialName":"","cnpj":"14512809000107","city":"NITERÓI","stateCode":"RJ","buscaAdicional":"EGP MODELO I 5158 MODELO I 892112 EOL.CV.RN.030787-4.01"},{"id":"e798a654-2fde-45d6-553c-08d5ad2bf6ba","name":"ENEL GREEN POWER MODELO II EOLICA S.A.","commercialName":"","cnpj":"14504489000143","city":"NITERÓI","stateCode":"RJ","buscaAdicional":"EGP MODELOII 5191 MODELO II 892182 EOL.CV.RN.030788-2.01"},{"id":"2d0eb412-e930-4ebd-553e-08d5ad2bf6ba","name":"ENEL GREEN POWER JOANA EOLICA S.A.","commercialName":"","cnpj":"14423010000144","city":"NITERÓI","stateCode":"RJ","buscaAdicional":"EGP JOANA 5194 JOANA 892104 EOL.CV.BA.030801-3.01"},{"id":"a4649ca1-0182-4aa7-552b-08d5ad2bf6ba","name":"ENEL GREEN POWER EMILIANA EOLICA S.A.","commercialName":"","cnpj":"14422996000138","city":"NITERÓI","stateCode":"RJ","buscaAdicional":"EGP EMILIANA 5156 EMILIANA 892108 EOL.CV.BA.030807-2.01"},{"id":"cf3415da-e95b-48c9-51be-08d5ad2bf6ba","name":"CONDOMINIO DO EDIFICIO PLAZA SHOPPING","commercialName":"","cnpj":"30183867000190","city":"NITERÓI","stateCode":"RJ","buscaAdicional":"COND PLAZA NIT 2561 COND PLAZA NITEROI 7179"},{"id":"b3bc5971-ea5e-4969-51b9-08d5ad2bf6ba","name":"CARTA GOIAS INDUSTRIA E COMERCIO DE PAPEIS S.A.","commercialName":"CARTA FABRIL","cnpj":"03752385000131","city":"NITERÓI","stateCode":"RJ","buscaAdicional":"CARTA FABRIL CL 2549 CARTA FABRIL LIVRE 70647 CARTA GOIAS PAPEIS 899648 CARTA FABRIL PIRAI 913503"},{"id":"e5f664e1-5a73-4d38-5069-08d5ad2bf6ba","name":"SOCIBE ENERGIA S.A.","commercialName":"","cnpj":"02131646000133","city":"NITERÓI","stateCode":"RJ","buscaAdicional":"SOCIBE 1614 AGRO TRAFO 909787 PCH.PH.TO.000031-0.01"},{"id":"1131cf8b-02b2-4dcf-506a-08d5ad2bf6ba","name":"QUATIARA ENERGIA S.A.","commercialName":"","cnpj":"07282383000187","city":"NITERÓI","stateCode":"RJ","buscaAdicional":"QUATIARA ENERG 1615 QUATIARA 8803 CGH.PH.SP.002164-4.02 PARI 8801 CGH.PH.SP.001988-7.02 LARANJA DOCE 8802 CGH.PH.SP.001310-2.01"},{"id":"15012cbe-65cd-4c02-506b-08d5ad2bf6ba","name":"PRIMAVERA ENERGIA S.A.","commercialName":"","cnpj":"07283830000112","city":"NITERÓI","stateCode":"RJ","buscaAdicional":"PRIMAVERA 1616"},{"id":"9bb5db5e-a7f2-448d-506c-08d5ad2bf6ba","name":"APIACAS ENERGIA S.A.","commercialName":"","cnpj":"07283824000165","city":"NITERÓI","stateCode":"RJ","buscaAdicional":"APIACAS 1620"},{"id":"9f0fc2a7-8c57-45ab-506d-08d5ad2bf6ba","name":"ALVORADA ENERGIA S.A.","commercialName":"","cnpj":"04946784000104","city":"NITERÓI","stateCode":"RJ","buscaAdicional":"ALVORADA 1621"},{"id":"b787532e-5175-470c-4eef-08d5ad2bf6ba","name":"AMPLA ENERGIA E SERVICOS S.A.","commercialName":"ENEL","cnpj":"33050071000158","city":"NITERÓI","stateCode":"RJ","buscaAdicional":"AMPLA 24 AMPLA 1 AMPLA DITC AMP-LIGH 72315"},{"id":"1268bc98-2b31-4502-1c9e-08d5b8870181","name":"ISAMU IKEDA ENERGIA S.A.","commercialName":"","cnpj":"04158565000152","city":"NITERÓI","stateCode":"RJ","buscaAdicional":"ISAMU IKEDA 1617"},{"id":"9aa818f0-a019-41a5-72f3-08d5cf600bef","name":"AUTOPISTA FLUMINENSE S/A","commercialName":"","cnpj":"09324949000111","city":"NITERÓI","stateCode":"RJ","buscaAdicional":""},{"id":"eec0da0a-5571-48d7-68c1-08d5ad2bf6ba","name":"UNIDAS EMPREENDIMENTOS E PARTICIPACOES LTDA","commercialName":"","cnpj":"68766161000124","city":"NITERÓI","stateCode":"RJ","buscaAdicional":"UNIDAS EMP E PART 60392 UNIDAS EMP E PART 910613"},{"id":"03491206-ce13-44d0-6958-08d5ad2bf6ba","name":"ENEL GREEN POWER PROJETOS I S.A.","commercialName":"","cnpj":"25176391000120","city":"NITERÓI","stateCode":"RJ","buscaAdicional":"VOLTA GRANDE 61063 V GRANDE ACL 907911 UHE.PH.SP.003045-7.01 VOLTA GRANDE (COTAS) 236 UHE.PH.SP.003045-7.01"},{"id":"502f540f-c897-4460-6787-08d5ad2bf6ba","name":"CONCESSIONARIA PONTE RIO-NITEROI S.A. - ECOPONTE","commercialName":"","cnpj":"22163297000149","city":"NITERÓI","stateCode":"RJ","buscaAdicional":"ECOPONTE 58247 ECOPONTE 909624"},{"id":"21e6bb2d-6928-450d-63ee-08d5ad2bf6ba","name":"CONDOMINIO DO ITAIPU MULTICENTER","commercialName":"","cnpj":"03352782000116","city":"NITERÓI","stateCode":"RJ","buscaAdicional":"SHOPPING ITAIPU 55719 SHOPPING ITAIPU 905694"},{"id":"72cc4445-fe13-4550-61b3-08d5ad2bf6ba","name":"AGUAS DE NITEROI S/A","commercialName":"","cnpj":"02150336000166","city":"NITERÓI","stateCode":"RJ","buscaAdicional":"AGUAS DE NITEROI 54344 BOOSTER CAVALAO 904850 BOOSTER SANTA BARBAR 904852 BOOSTER MARIA PAULA 904857 BOOSTER CORRECAO 904859 ETE ICARAI 904860 BOOSTER BARRETO 904862 ETE TOQUE TOQUE 904863 BOOSTER CORRECAO I 904865 ETE ITAIPU 904875"},{"id":"ea9ac1e0-8dc2-441d-6326-08d5ad2bf6ba","name":"CASA DE SAUDE E MATERNIDADE SANTA MARTHA SA","commercialName":"","cnpj":"30079461000162","city":"NITERÓI","stateCode":"RJ","buscaAdicional":"SANTA MARTHA 55190 SANTA MARTHA 905936"},{"id":"60df2d01-5f27-49a4-6231-08d5ad2bf6ba","name":"ENEL GREEN POWER SAO ABRAAO EOLICA S.A","commercialName":"","cnpj":"21869030000109","city":"NITERÓI","stateCode":"RJ","buscaAdicional":"SAO ABRAAO 54616 VENTOS DE SAO ABRAAO 912051 EOL.CV.BA.032884-7.01"},{"id":"211cf584-e455-4e66-6232-08d5ad2bf6ba","name":"ENEL GREEN POWER BOA VISTA EOLICA S A","commercialName":"","cnpj":"21996671000124","city":"NITERÓI","stateCode":"RJ","buscaAdicional":"BOA VISTA 54617 BOA VISTA DA LAGOINH 912476 EOL.CV.BA.032759-0.01"},{"id":"19842b6a-b712-4bb4-61b4-08d5ad2bf6ba","name":"AGUAS DE NOVA FRIBURGO LTDA.","commercialName":"","cnpj":"03119806000191","city":"NOVA FRIBURGO","stateCode":"RJ","buscaAdicional":"AGUAS DE NOVA FRIBURGO 54345 AGUAS NOVA FRIGURGO 904942"},{"id":"1283055f-5674-4433-620f-08d5ad2bf6ba","name":"HAGA S/A INDUSTRIA E COMERCIO","commercialName":"","cnpj":"30540991000166","city":"NOVA FRIBURGO","stateCode":"RJ","buscaAdicional":"HAGA 54533 HAGA 904951"},{"id":"610462f3-7dd9-4f3d-6370-08d5ad2bf6ba","name":"FERRAGENS 3F DO BRASIL EIRELI","commercialName":"","cnpj":"02464189000107","city":"NOVA FRIBURGO","stateCode":"RJ","buscaAdicional":"FERRAGENS 3F DO BRASIL EIRELI 55351 FERRAGENS 3F 905695"},{"id":"bcad0838-06ba-459c-673e-08d5ad2bf6ba","name":"HAK FABRICA DE FUSOS E PASSAMANARIA LTDA","commercialName":"HAK","cnpj":"30542161000178","city":"NOVA FRIBURGO","stateCode":"RJ","buscaAdicional":"HAK 58013 HAK FABRICA DE FUSOS 909412"},{"id":"6f44fe0d-80ee-4838-6812-08d5ad2bf6ba","name":"STAM METALURGICA S/A","commercialName":"","cnpj":"30560205000192","city":"NOVA FRIBURGO","stateCode":"RJ","buscaAdicional":"STAM 59332 STAM METALURGICA 910227 STAMP & MOLDE 910953"},{"id":"900736c3-3f20-4b66-8da9-08d5d060706e","name":"FECHADURAS HELA DE FRIBURGO FERRAGENS LTDA","commercialName":"HELA","cnpj":"07754075000107","city":"NOVA FRIBURGO","stateCode":"RJ","buscaAdicional":"HELA 62236 FECHADURAS HELA 913580"},{"id":"b28db28b-98f7-400a-68e8-08d5ad2bf6ba","name":"RIOPET EMBALAGENS S.A.","commercialName":"","cnpj":"00771482000183","city":"NOVA IGUAÇU","stateCode":"RJ","buscaAdicional":"RIOPET 60564 RIOPET RJ 911906"},{"id":"e641f836-bd83-42d5-634c-08d5ad2bf6ba","name":"PHITOTERAPHIA BIOFITOGENIA LABORATORIAL BIOTA LTDA","commercialName":"","cnpj":"00104603000133","city":"NOVA IGUAÇU","stateCode":"RJ","buscaAdicional":"PHITOTERAPHIA 55296 EMBELLEZE 906640"},{"id":"bbb10fc2-86b2-4430-634d-08d5ad2bf6ba","name":"CENTRAL DE TRATAMENTO DE RESIDUOS NOVA IGUACU S.A.","commercialName":"","cnpj":"07085695000109","city":"NOVA IGUAÇU","stateCode":"RJ","buscaAdicional":"CTR NOVA IGUACU 55299 CTR NI 906987"},{"id":"bd95c517-128e-416e-63af-08d5ad2bf6ba","name":"COMPANHIA DE CANETAS COMPACTOR","commercialName":"COMPACTOR","cnpj":"30742555000170","city":"NOVA IGUAÇU","stateCode":"RJ","buscaAdicional":"COMPACTOR 55520 COMP DE CANETAS COMP 906332"},{"id":"5eee1a12-1d2d-4685-6465-08d5ad2bf6ba","name":"SUPERMERCADOS VIANENSE LTDA","commercialName":"","cnpj":"27881408000176","city":"NOVA IGUAÇU","stateCode":"RJ","buscaAdicional":"SUPERMERCADOS VIANENSE 55976 SUPER VIANENSE 09 908619 SUPER VIANENSE 14 908651 SUPER VIANENSE 10 908746 SUPER VIANENSE 16 908747 SUPER VIANENSE 5 909080 SUPER VIANENSE 8 909274 SUPER VIANENSE 3 909738 SUPER VIANENSE 13 910056 SUP VIANENSE FL 4 910202 SUPERMERCADOS VIAN11 910431 SUPER VIANENSE 27 910491 SUPER VIANENSE FL 7 911011 SUPER VIANENSE FL 12 911219 SUPERMERCADOS VIANEN 911533 SUP. VIANENSE FL 15 912331"},{"id":"abf1f871-7c9c-49a9-647b-08d5ad2bf6ba","name":"FABRICADORA DE POLIURETANO RIO SUL LTDA","commercialName":"","cnpj":"02895152000125","city":"NOVA IGUAÇU","stateCode":"RJ","buscaAdicional":"ORTOBOM NOVA IGUACU 56022 ORTOBOM NOVA IGUACU 909275"},{"id":"84cd682d-17d5-4d2c-62f2-08d5ad2bf6ba","name":"CASAS GUANABARA COMESTIVEIS LTDA","commercialName":"SUPERMERCADOS GUANABARA","cnpj":"33130543004501","city":"NOVA IGUAÇU","stateCode":"RJ","buscaAdicional":"SUPERMERCADOS GUANABARA 55057 SUPER GUANABARA 23 909278 SUPERMERCADOS GUANAB 911793"},{"id":"d1c9abd0-4041-4e19-5476-08d5ad2bf6ba","name":"IGUACU TOP SHOPPING","commercialName":"","cnpj":"01422848000171","city":"NOVA IGUAÇU","stateCode":"RJ","buscaAdicional":"TOP SHOPPING 4274 IGUACU TOP SHOPPING 71560"},{"id":"e79bf81d-42d3-470c-5c0a-08d5ad2bf6ba","name":"SOMOLD NEGOCIOS E PARTICIPACOES LTDA","commercialName":"","cnpj":"01355576000134","city":"NOVA IGUAÇU","stateCode":"RJ","buscaAdicional":"SOMOLD 51043 SOMOLD 899267"},{"id":"56e19d81-5305-41ac-6016-08d5ad2bf6ba","name":"GRANDE RIO ALIMENTOS LTDA","commercialName":"","cnpj":"30224372000162","city":"NOVA IGUAÇU","stateCode":"RJ","buscaAdicional":"GRANDE RIO ALIMENTOS 53372 GRANDE RIO ALIMENTOS 903628"},{"id":"c02fc193-80c0-452a-60aa-08d5ad2bf6ba","name":"NIELY DO BRASIL INDUSTRIAL LTDA","commercialName":"","cnpj":"30153506000100","city":"NOVA IGUAÇU","stateCode":"RJ","buscaAdicional":"NIELY 53629 NIELY NOVA IGUACU 907302 HARGUS NOVA IGUACU 909066 NIELY - BARROS JR 911574"},{"id":"89f82fc3-f958-46ab-60b0-08d5ad2bf6ba","name":"GGP INDUSTRIAL LTDA","commercialName":"CERAMICA GGP","cnpj":"31076938000461","city":"PARAÍBA DO SUL","stateCode":"RJ","buscaAdicional":"GGP 53638 GGP INDUSTRIAL LTDA 906862"},{"id":"3c3fdda6-cbdd-440e-622d-08d5ad2bf6ba","name":"ELC PRODUTOS DE SEGURANCA - INDUSTRIA E COMERCIO LTDA","commercialName":"","cnpj":"73323404000190","city":"PARAÍBA DO SUL","stateCode":"RJ","buscaAdicional":"ELC 54604 ELC PARAIBA SUL 906221"},{"id":"f9551123-033e-4379-65a8-08d5ad2bf6ba","name":"CONDOMINIO LARANJEIRAS","commercialName":"","cnpj":"30322150000182","city":"PARATY","stateCode":"RJ","buscaAdicional":"CONDOMINIO LARANJEIRAS 56907 CONDOMINIO LARANJEIR 907691"},{"id":"97c7f97e-f06e-4bdf-63df-08d5ad2bf6ba","name":"IRMAOS PORTO & CIA LTDA","commercialName":"ANTAS","cnpj":"29081445000125","city":"PATY DO ALFERES","stateCode":"RJ","buscaAdicional":"IRMAOS PORTO 55689 IRMAOS PORTO 907782"},{"id":"d060f9f2-d36b-4ec7-634a-08d5ad2bf6ba","name":"GE CELMA LTDA.","commercialName":"GE CELMA","cnpj":"33435231000187","city":"PETRÓPOLIS","stateCode":"RJ","buscaAdicional":"GE CELMA 55294 GE CELMA 904899"},{"id":"c7fd29f2-dd14-4686-61b6-08d5ad2bf6ba","name":"AGUAS DO IMPERADOR SA","commercialName":"","cnpj":"02150327000175","city":"PETRÓPOLIS","stateCode":"RJ","buscaAdicional":"AGUAS DO IMPERADOR 54347 EA PONTE DE FERRO 904848 ETE PALATINATO 904849 EA RIO DA CIDADE 904858"},{"id":"db8a92cc-f6c9-4ff0-6977-08d5ad2bf6ba","name":"CARL ZEISS VISION BRASIL INDUSTRIA OPTICA LTDA","commercialName":"","cnpj":"28826394000150","city":"PETRÓPOLIS","stateCode":"RJ","buscaAdicional":"CARL ZEISS 61851 CARL ZEISS - PETROPO 912491"},{"id":"17da8479-fed8-4a02-6847-08d5ad2bf6ba","name":"INSTITUICAO ADVENTISTA ESTE BRAS. DE PREV E ASS. A SAUDE","commercialName":"","cnpj":"73696718000138","city":"PETRÓPOLIS","stateCode":"RJ","buscaAdicional":"HOSPITAL ADVENTISTA SILVESTRE 59662 HOSP ADVEN SILVESTRE 910057"},{"id":"913d1296-2847-4a41-5b21-08d5ad2bf6ba","name":"XERIUM TECHNOLOGIES BRASIL INDUSTRIA E COMERCIO S/A","commercialName":"XERIUM","cnpj":"58309998000786","city":"PETRÓPOLIS","stateCode":"RJ","buscaAdicional":"XERIUM PETROPOLIS 50488 XERIUM PETROPOLIS RJ 897769"},{"id":"9dc84f14-c162-41ef-59b3-08d5ad2bf6ba","name":"RIO BONITO TRES VALES BIOENERGIA LTDA","commercialName":"RIO BONITO TRES VALES BIOENERGIA LTDA EPP","cnpj":"12526347000151","city":"PETRÓPOLIS","stateCode":"RJ","buscaAdicional":"RIO BONITO BIOENERGIA 15377 RIO BONITO BIO 895162 CGH.PH.RJ.030620-7.01"},{"id":"d4a99e9a-3857-47fb-5c42-08d5ad2bf6ba","name":"LAJES ENERGIA SA","commercialName":"","cnpj":"19984571000136","city":"PIRAÍ","stateCode":"RJ","buscaAdicional":"LAJES ENERGIA 51236 PCH LAJES 910971 PCH.PH.RJ.001306-4.01"},{"id":"476bf7ce-add9-4363-50aa-08d5ad2bf6ba","name":"SCHWEITZER-MAUDUIT DO BRASIL INDUSTRIA E COMERCIO DE PAPEL LTDA.","commercialName":"SCHWEITZER-MAUDUIT DO BRASIL","cnpj":"33073008000137","city":"PIRAÍ","stateCode":"RJ","buscaAdicional":"SCHWEITZER 1774 SCHWEITZER PIRAI 70124"},{"id":"aa5c33e8-3896-4102-63ff-08d5ad2bf6ba","name":"TUKO PIRAI INDUSTRIA E COMERCIO DE ALIMENTOS LTDA","commercialName":"TUKO","cnpj":"07316858000109","city":"PIRAÍ","stateCode":"RJ","buscaAdicional":"TUKO PIRAI 55772 TUKO PIRAI ALIMENTOS 907747"},{"id":"04e23d48-bce3-4f4b-645f-08d5ad2bf6ba","name":"MA AUTOMOTIVE BRASIL LTDA.","commercialName":"","cnpj":"03571044000160","city":"PORTO REAL","stateCode":"RJ","buscaAdicional":"MA AUTOMOTIVE 55955 MA AUTOMOTIVE 907511"},{"id":"8bd3a5b7-1600-48bd-4f79-08d5ad2bf6ba","name":"GUARDIAN DO BRASIL VIDROS PLANOS LTDA","commercialName":"","cnpj":"01410577000134","city":"PORTO REAL","stateCode":"RJ","buscaAdicional":"GUARDIAN 1127 GUARDIAN PORTO REAL 889542"},{"id":"62873682-50cd-4ed7-54d6-08d5ad2bf6ba","name":"PEUGEOT-CITROEN DO BRASIL AUTOMOVEIS LTDA","commercialName":"","cnpj":"67405936000173","city":"PORTO REAL","stateCode":"RJ","buscaAdicional":"PEUGEOT CPPR 4534 PEUGEOT-P REAL-RJ 7513"},{"id":"f99970e0-0e44-487a-5d70-08d5ad2bf6ba","name":"OLFAR S/A - ALIMENTO E ENERGIA","commercialName":"","cnpj":"91830836004085","city":"PORTO REAL","stateCode":"RJ","buscaAdicional":"OLFAR RJ 51820 OLFAR ALIMENTO 907296"},{"id":"ab7cff1d-3eb8-4c22-5f51-08d5ad2bf6ba","name":"SANES BRASIL AGROINDUSTRIAL S/A","commercialName":"","cnpj":"03718276000106","city":"QUEIMADOS","stateCode":"RJ","buscaAdicional":"SANES 52901 SANES 904949"},{"id":"d5ea7a7c-1657-4831-5095-08d5ad2bf6ba","name":"MAHLE HIRSCHVOGEL FORJAS S.A.","commercialName":"","cnpj":"33035130000119","city":"QUEIMADOS","stateCode":"RJ","buscaAdicional":"FORJAS 1734 FORJAS BR QUEIMADOS 70101"},{"id":"3e4a0bea-ed8c-4466-5249-08d5ad2bf6ba","name":"XANTOCARPA PARTICIPACOES LTDA","commercialName":"ASSAI","cnpj":"10246989000171","city":"QUEIMADOS","stateCode":"RJ","buscaAdicional":"XANTOCARPA 2990 SENDAS 1627 TIJUCA 70054 SENDAS EXTRA 1332 RJ 70355 XANTO CARPA 2271 72400"},{"id":"8067983d-a677-4936-619d-08d5ad2bf6ba","name":"PETRA AGREGADOS RJ LTDA","commercialName":"","cnpj":"13410313000160","city":"QUEIMADOS","stateCode":"RJ","buscaAdicional":"PETRA 54291 PETRA AGREGADOS RJ 904333"},{"id":"1e11bf4b-d155-4c9f-62dd-08d5ad2bf6ba","name":"KNAUF DO BRASIL LTDA","commercialName":"","cnpj":"02082558000199","city":"QUEIMADOS","stateCode":"RJ","buscaAdicional":"KNAUF RJ 55018 KNAUF 904903"},{"id":"9bb2e992-1946-44fd-6644-08d5ad2bf6ba","name":"INDUSTRIA BRASILEIRA DE COLCHOES E ESPUMA DE POLIURETANO LTDA","commercialName":"","cnpj":"14294395000197","city":"QUEIMADOS","stateCode":"RJ","buscaAdicional":"ORTOBOM QUEIMADOS 57453 ORTOBOM QUEIMADOS 912032"},{"id":"8664744f-b39e-4c13-66e9-08d5ad2bf6ba","name":"CONDOMINIO EDILICIO DO PATIOMIX RESENDE SHOPPING CENTER","commercialName":"","cnpj":"16692874000197","city":"RESENDE","stateCode":"RJ","buscaAdicional":"PATIOMIX RESENDE 57882 PATIOMIX RESENDE 908492"},{"id":"0f74d94d-4c83-4c8e-61bb-08d5ad2bf6ba","name":"AGUAS DAS AGULHAS NEGRAS S.A","commercialName":"","cnpj":"09195493000137","city":"RESENDE","stateCode":"RJ","buscaAdicional":"AGUAS DAS AGULHAS NEGRAS 54352 CAPTACAO ETA ALEGRIA 904827 AGUAS LIBERDADE 904828"},{"id":"9328c639-45cd-4246-4f40-08d5ad2bf6ba","name":"ARCELORMITTAL SUL FLUMINENSE S.A.","commercialName":"","cnpj":"60892403000114","city":"RESENDE","stateCode":"RJ","buscaAdicional":"VS CL 154 SIDERURGICA UNIAO 70830 SID B MANSA LIVRE 7256 SBM VS RESENDE 70776 VS CURVELO 889661"},{"id":"863b2c97-bf0b-4f07-577f-08d5ad2bf6ba","name":"RESENDE SHOPPING EMPREENDIMENTOS LTDA.","commercialName":"","cnpj":"14068823000163","city":"RESENDE","stateCode":"RJ","buscaAdicional":"RESENDE SHOP 8955 RESENDE SHOPPING 889039"},{"id":"60b5e8a0-8d44-46c0-68e9-08d5ad2bf6ba","name":"NEW TEMPER NOROESTE INDUSTRIA E COMERCIO DE VIDROS LTDA","commercialName":"NEWTEMPER NOROESTE","cnpj":"08488511000106","city":"RIO DAS OSTRAS","stateCode":"RJ","buscaAdicional":"NEW TEMPER NO 60566 NEW TEMPER NO 910816"},{"id":"55d1142f-9d71-4e63-68e0-08d5ad2bf6ba","name":"MIRAGE EMPREENDIMENTOS IMOBILIARIOS LTDA","commercialName":"","cnpj":"03470450000136","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":"MIRAGE 60520 MIRAGE CURICICA 910638 MIRAGE CAMPO GRANDE 910695"},{"id":"761e1906-6218-43b4-68f6-08d5ad2bf6ba","name":"SUPERMERCADOS MUNDIAL LTDA","commercialName":"","cnpj":"33304981000110","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":"MUNDIAL SUPERMERCADOS 60653 MUNDIAL SANTO AFONSO 911305 MUNDIAL COPACABANA 911338 MUNDIAL IRAJA 911512 MUNDIAL MATOSO 911573 MUNDIAL CURICICA 911591 MUNDIAL VAZ LOBO 911611 MUNDIAL BARRINHA 911794 MUNDIAL RECREIO 911795 MUNDIAL TAUA 911796 MUNDIAL CONDE DE BON 911833 MUNDIAL CENTRAL 912114 MUNDIAL CACUIA 912134 MUNDIAL PRACA SECA 912135 MUNDIAL BOTAFOGO 912332 MUNDIAL RIACHUELO 912351 MUNDIAL RAMOS 912474 MUNDIAL ABELARDO BUE 912551 MUNDIAL ERICO VERISS 912758 MUNDIAL ENGENHO NOVO 912798 MUNDIAL FREGUESIA 912812"},{"id":"54f330b5-b7b4-465c-68f1-08d5ad2bf6ba","name":"CONTINENTE SUPERMERCADOS LTDA","commercialName":"","cnpj":"31546666000173","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":"CONTINENTE 60645 CONTINENTE 910850"},{"id":"80e6595c-30bf-4765-691e-08d5ad2bf6ba","name":"INSTITUTO BIOCHIMICO INDUSTRIA FARMACEUTICA LTDA","commercialName":"","cnpj":"33258401000103","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":"BIOCHIMICO CORDOVIL 60774 BIOCHIMICO CORDOVIL 911811"},{"id":"dd94560f-d90e-4252-690e-08d5ad2bf6ba","name":"CCN CENTRO DE CONVENCOES LTDA.","commercialName":"CONVENTION CENTER NETWORK","cnpj":"06149097000185","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":"CCN 60755 CCN 912475"},{"id":"fcbe8b82-5d73-4fa6-68fc-08d5ad2bf6ba","name":"JM EMPREENDIMENTOS E PARTICIPACOES DE BENS LTDA","commercialName":"","cnpj":"01260788000138","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":"JM 60681 JM 911194"},{"id":"303a3098-e6d3-46bc-6926-08d5ad2bf6ba","name":"GLOBOSAT PROGRAMADORA LTDA","commercialName":"GLOBOSAT","cnpj":"00811990000148","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":"GLOBOSAT 60809 GLOBOSAT - RJ 911831"},{"id":"e7fc36e5-f657-487d-8859-08d5ae44ed50","name":"TRANSPORTADORA ASSOCIADA DE GAS S.A. - TAG","commercialName":"","cnpj":"06248349000123","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":"TAG 4141"},{"id":"e854fe8c-7828-41cd-885c-08d5ae44ed50","name":"SIGNO PROPERTIES INVESTIMENTOS IMOBILIARIOS LTDA","commercialName":"","cnpj":"27781293000148","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":"HCN 4286"},{"id":"a92cd389-20c4-4760-884d-08d5ae44ed50","name":"PAN-AMERICANA INDUSTRIAS QUIMICAS LTDA","commercialName":"","cnpj":"50142223000161","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":"PAN-AMERICANA 3018"},{"id":"e1320aa2-7888-4db9-8894-08d5ae44ed50","name":"CARNAUBA III EOLICA S.A.","commercialName":"","cnpj":"19390222000196","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":"CARNAUBA III 14475"},{"id":"89f0b1ba-ae2b-4960-8895-08d5ae44ed50","name":"CARNAUBA I EOLICA S.A.","commercialName":"","cnpj":"19443862000117","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":"CARNAUBA I 14476"},{"id":"ab8f6b27-bc2e-457b-8896-08d5ae44ed50","name":"CARNAUBA II EOLICA S.A.","commercialName":"","cnpj":"19443884000187","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":"CARNAUBA II 14477"},{"id":"9ae3ceba-f024-4210-8897-08d5ae44ed50","name":"CARNAUBA V EOLICA S.A.","commercialName":"","cnpj":"19390294000133","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":"CARNAUBA V 14478"},{"id":"cce7dd05-64f2-4abb-8898-08d5ae44ed50","name":"CERVANTES I EOLICA S.A.","commercialName":"","cnpj":"19446879000128","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":"CERVANTES I 14479"},{"id":"c50914f2-f106-4e60-8899-08d5ae44ed50","name":"CERVANTES II EOLICA S.A.","commercialName":"","cnpj":"19390672000189","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":"CERVANTES II 14480"},{"id":"f8ea8753-4d77-47b2-889a-08d5ae44ed50","name":"SAO GALVAO EOLICA S.A.","commercialName":"","cnpj":"19390265000171","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":"SAO GALVAO 14481"},{"id":"b9235e1b-5223-43ff-889b-08d5ae44ed50","name":"SAO CAETANO I EOLICA S.A.","commercialName":"","cnpj":"19375545000100","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":"SAO CAETANO I 14482"},{"id":"daaf3442-187f-481d-889c-08d5ae44ed50","name":"SAO CAETANO EOLICA S.A.","commercialName":"","cnpj":"19388557000170","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":"SAO CAETANO 14483"},{"id":"bf830964-fb95-463f-889d-08d5ae44ed50","name":"CACHOEIRA EOLICA S.A.","commercialName":"","cnpj":"19376510000196","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":"CACHOEIRA 14484"},{"id":"356629a4-e83b-4c5a-889e-08d5ae44ed50","name":"BOM JESUS EOLICA S.A.","commercialName":"","cnpj":"19389517000142","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":"BOM JESUS 14485"},{"id":"be12727c-bd60-417e-889f-08d5ae44ed50","name":"PITIMBU EOLICA S.A.","commercialName":"","cnpj":"19375531000197","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":"PITIMBU 14486"},{"id":"d0fb12c0-65ed-455e-88a3-08d5ae44ed50","name":"ASSET ALLOCATION ASSESSORIA E PARTICIPACOES S.A.","commercialName":"","cnpj":"06788070000132","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":"CGH CACHOEIRA DO FAGUNDES 15015 CACHOEIRA FAGUNDES 897346 CGH.PH.MG.000475-8.01"},{"id":"5f21a266-04e0-4052-88a4-08d5ae44ed50","name":"PUNAU I EOLICA S.A.","commercialName":"","cnpj":"19446932000190","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":"PUNAU I 15276"},{"id":"7b812aed-2dc0-49c4-888e-08d5ae44ed50","name":"CONDOMINIO DO EDIFICIO DO SHOPPING VILLAGEMALL","commercialName":"","cnpj":"19034351000141","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":"SHOPPING VILLAGEMALL 13133"},{"id":"6cc9c1bb-5853-44a0-6835-08d5ad2bf6ba","name":"SUPER MERCADO ZONA SUL S A","commercialName":"","cnpj":"33381286000151","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":"SUPERMERCADO ZONA SUL 59471 ZONA SUL 19 909280 ZONA SUL CD 909282 ZONA SUL 24 909297 ZONA SUL 36 909298 ZONA SUL 30 909299 ZONA SUL 39 909301 ZONA SUL 14 909427 ZONA SUL 29 909428 ZONA SUL 18 909429 ZONA SUL 08 909625 ZONA SUL 04 909635 ZONA SUL 26 909636 SUPER ZONA SUL 38 909753 ZONA SUL 01 909869 ZONA SUL 37 910023 ZONA SUL 12 910050 ZONA SUL 07 910051 ZONA SUL 11 910052 ZONA SUL 16 910053 ZONA SUL 3 910201 ZONA SUL 10 910205 ZONA SUL 25 910208 ZONA SUL 13 910288 ZONA SUL 31 910299 ZONA SUL 33 910407 ZONA SUL 17 910417 ZONA SUL 20 910511 ZONA SUL 23 910559 ZONA SUL 9 911783 ZONA SUL 22 911791"},{"id":"2d25ec41-d99c-4765-6836-08d5ad2bf6ba","name":"JOCKEY CLUB BRASILEIRO","commercialName":"","cnpj":"33621756000107","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":"JOCKEY CLUB 59472 JOCKEY CLUB 1 910198 JOCKEY CLUB 2 910199 JOCKEY CLUB 3 910200 JOCKEY CLUB GAVEA 910300"},{"id":"d1ff70ef-2f88-4761-6821-08d5ad2bf6ba","name":"ASSOCIACAO SALGADO DE OLIVEIRA DE EDUCACAO E CULTURA","commercialName":"","cnpj":"28638393000182","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":"ASOEC 59414 ASOEC RECIFE 909733 ASOEC JF 909949 ASOEC BH 910011 ASOEC UDI 910012 ASOEC RJ 910226 ASOEC BA 910279 ASOEC CGY 910301 ASOEC NTI 2 910302 ASOEC NTI I 910303 ASOEC GO 912473 ASOEC NT 3 913418"},{"id":"50630b94-218c-48bb-6809-08d5ad2bf6ba","name":"VIDROS COMERCIO E INDUSTRIA BELEM LIMITADA","commercialName":"","cnpj":"33052515000356","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":"VIDROS BELEM 59211 VIDROS BELEM 909637"},{"id":"3bc47d25-9a04-4f20-67fe-08d5ad2bf6ba","name":"FARMOQUIMICA S A","commercialName":"","cnpj":"33349473000158","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":"FQM FARMOQUIMICA 59170 FARMOQUIMICA SA 908491"},{"id":"ae851cfa-fae2-40f1-68c7-08d5ad2bf6ba","name":"BRISA BARRA HOTEL LTDA","commercialName":"","cnpj":"07356838000161","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":"BRISA 60410 BRISA 420074414 912318 BRISA 400353256 912371"},{"id":"2e99d24a-87f3-4aab-68d3-08d5ad2bf6ba","name":"COSTAZUL ALIMENTOS EIRELI","commercialName":"","cnpj":"17493338000125","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":"COSTAZUL 60445 COSTAZUL SAO PEDRO 910289 COSTAZUL SAO GONCALO 910290 COSTAZUL ITABORAI 910344"},{"id":"bdcb29d1-720f-4472-68ad-08d5ad2bf6ba","name":"BRASFRAN INDUSTRIA DE PLASTICOS LTDA","commercialName":"","cnpj":"02244316000154","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":"BRASFRAN 60270 BRASFRAN 910350"},{"id":"27fe7481-cd2f-42d5-68a4-08d5ad2bf6ba","name":"GL EVENTS EMPREENDIMENTOS IMOBILIARIOS LTDA.","commercialName":"GRAND MERCURE RIOCENTRO","cnpj":"15453068000101","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":"GL EVENTS HOTEL 60236 GL EVENTS HOTEL BARR 912333"},{"id":"120c43af-9ad7-447f-689f-08d5ad2bf6ba","name":"GL EVENTS CENTRO DE CONVENCOES S.A.","commercialName":"","cnpj":"05495076000159","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":"GL EVENTS 60214 GL EVENTS CENTRO 911905"},{"id":"8209ca46-6bcf-4ed3-6872-08d5ad2bf6ba","name":"JOLIMODE ROUPAS S A","commercialName":"","cnpj":"33016494000151","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":"DULOREN 60053 DULOREN 910612"},{"id":"e59d48d8-febf-48e7-687c-08d5ad2bf6ba","name":"SHELL ENERGY DO BRASIL LTDA","commercialName":"","cnpj":"27796415000170","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":"SEB - SHELL ENERGY BRASIL 60100"},{"id":"2cdd2254-68dc-4787-688a-08d5ad2bf6ba","name":"ASSOCIACAO NOBREGA DE EDUCACAO E ASSISTENCIA SOCIAL - ANEAS","commercialName":"COLEGIO SANTO INACIO","cnpj":"33544370003164","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":"COLEGIO SANTO INACIO 60120 COLEGIO SANTO INACIO 911172"},{"id":"f55ef363-c3e0-4e6c-6886-08d5ad2bf6ba","name":"ARIS INDUSTRIA E COMERCIO DE GELO LTDA","commercialName":"","cnpj":"32122715000103","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":"GELO ARIS 60116 ARIS GELO 910606"},{"id":"12840682-d3ad-4a9c-6850-08d5ad2bf6ba","name":"CONDOMINIO DO EDIFICIO AVENIDA CENTRAL","commercialName":"CEAC","cnpj":"28713998000190","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":"EDIFICIO AVENIDA CENTRAL 59747 COND ED AV CENTRAL 911263"},{"id":"a1557b2a-1047-4410-66e8-08d5ad2bf6ba","name":"PATIOMIX LINHARES SHOPPING CENTER SPE LTDA.","commercialName":"","cnpj":"14159728000175","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":"PATIOMIX LINHARES 57881 PATIOMIX LINHARES 908259"},{"id":"0adfaf95-7a85-45c0-66e0-08d5ad2bf6ba","name":"RIBALTA EVENTOS LTDA","commercialName":"RIBALTA","cnpj":"03545842000117","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":"RIBALTA 57864 RIBALTA 908701"},{"id":"69bfe7e5-33c1-417f-66b3-08d5ad2bf6ba","name":"2 ALIANCAS ARMAZENS GERAIS LTDA","commercialName":"","cnpj":"00719887000253","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":"2 ALIANCAS 57747 2ALIANCAS ARMAZENS G 909737"},{"id":"0bc57d27-4931-42b1-671e-08d5ad2bf6ba","name":"CDG CENTRO COMERCIAL LTDA.","commercialName":"CDG","cnpj":"02961306000130","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":"SHOP BOULEVARD CAMPOS I 57969 SHOP BOULEVARD 1 908463 SHOP BOULEVARD EXPAN 908464"},{"id":"7533821e-5a3c-4ce0-674f-08d5ad2bf6ba","name":"COMPANHIA PALMARES HOTEIS E TURISMO","commercialName":"SHERATON","cnpj":"33791591000111","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":"SHERATON GRAND RIO 58037 CIA PALMARES HOTEIS 909736"},{"id":"807c8316-9db0-4ba2-6779-08d5ad2bf6ba","name":"COSAN LUBRIFICANTES E ESPECIALIDADES S.A.","commercialName":"MOOVE","cnpj":"33000092000169","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":"COSAN LUBRIFICANTES 58172 COSAN LUBRIFICANTES 908745"},{"id":"89bbb47d-47d9-4ebf-678b-08d5ad2bf6ba","name":"CONDOMINIO TORRE ALMIRANTE","commercialName":"","cnpj":"07123702000101","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":"TORRE ALMIRANTE 58271 PETROBRAS EI EDITA 70867"},{"id":"498540ad-fd5e-48d4-678c-08d5ad2bf6ba","name":"CONDOMINIO EDIFICIO CASTELO","commercialName":"","cnpj":"10141403000104","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":"ED CASTELO 58273 PETROBRAS CASTELO 71564"},{"id":"e3ef6325-78f3-40f5-6645-08d5ad2bf6ba","name":"ASSOCIACAO SAO VICENTE DE PAULO","commercialName":"","cnpj":"33570052000152","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":"ASVP 57454 ASS S VICENTE PAULA 908818"},{"id":"6fae4efa-5225-4c74-663e-08d5ad2bf6ba","name":"PIER MAUA S/A","commercialName":"","cnpj":"02434768000107","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":"PIER MAUA 57417 PIER MAUA 908620"},{"id":"e5d71d6d-7242-489b-6649-08d5ad2bf6ba","name":"RIO HOTEL BRASIL EMPREENDIMENTOS IMOBILIARIOS LTDA.","commercialName":"","cnpj":"20864251000121","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":"MARRIOTT PQ OL 57464 PARQUE OLIMPICO 908462"},{"id":"9ab9a97d-5674-4b82-664b-08d5ad2bf6ba","name":"HHR BT RIO DE JANEIRO INVESTIMENTOS HOTELEIROS LTDA","commercialName":"","cnpj":"15051092000106","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":"ACCOR PO 57472 NOVOTEL PQ OLIMPICO 909907 IBIS PQ OLIMPICO 909912"},{"id":"e10c4489-b83a-4020-6657-08d5ad2bf6ba","name":"DROGARIAS PACHECO S/A","commercialName":"DROGARIAS PACHECO","cnpj":"33438250000167","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":"DROGARIAS PACHECO 57505 DROG PACHECO MATRIZ 908268"},{"id":"946f6904-83e3-4ff4-6636-08d5ad2bf6ba","name":"DART DO BRASIL INDUSTRIA E COMERCIO LIMITADA","commercialName":"","cnpj":"42179671000101","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":"TUPPERWARE 57391 TUPPERWARE RJ 907581"},{"id":"e90cac39-5682-4274-6668-08d5ad2bf6ba","name":"MG VIDROS AUTOMOTIVOS LTDA","commercialName":"","cnpj":"07571746000102","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":"AUTOGLASS 57531 MG VIDROS AUTOMOTIV 908626"},{"id":"df287e70-9448-40d6-667f-08d5ad2bf6ba","name":"SUPERPRIX LOJAS DE ALIMENTOS LTDA","commercialName":"SUPERPRIX SUPERMERCADOS","cnpj":"02618563000173","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":"SUPERPRIX 57622 SUPERPRIX 04 909294 SUPERPRIX 11 909295 SUPERPRIX 09 909296 SUPERPRIX 06 909319 SUPERPRIX SOJA 909868 SUPERPRIX 07 910055 SUPERPRIX L10 910076 SUPERPRIX L13 910080"},{"id":"a46aff4b-b58a-4b0e-65bb-08d5ad2bf6ba","name":"BRASTURINVEST INVESTIMENTOS TURISTICOS S/A","commercialName":"","cnpj":"03422594000117","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":"PESTANASP 57009 HOTEL PESTANA SP 908283"},{"id":"3ec06d0b-76d9-4d9c-6584-08d5ad2bf6ba","name":"MULTI-RIO OPERACOES PORTUARIAS S/A","commercialName":"","cnpj":"02877283000260","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":"MULTI RIO 56794 MULTI RIO 906644"},{"id":"53e86b21-5a3c-430a-65ca-08d5ad2bf6ba","name":"LITOGRAFIA VALENCA LTDA","commercialName":"","cnpj":"02712119000112","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":"LITOGRAFIA VALENCA 57132 LITOGRAFIA VALENCA 908850 LITOGRAFIA VALENCA 909068"},{"id":"763de600-249a-46c4-65e5-08d5ad2bf6ba","name":"FACULDADES CATOLICAS","commercialName":"","cnpj":"33555921000170","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":"PUC-RIO 57188 PUC - RIO 908549"},{"id":"ce57bd50-39e1-4d96-65e7-08d5ad2bf6ba","name":"DANCOR S A INDUSTRIA MECANICA","commercialName":"BOMBAS DANCOR","cnpj":"33561853000151","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":"DANCOR 57190 DANCOR 907580"},{"id":"d3951b23-7eb5-4775-65f2-08d5ad2bf6ba","name":"HHR JW RIO DE JANEIRO INVESTIMENTOS HOTELEIROS LTDA","commercialName":"","cnpj":"12575480000106","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":"MARRIOTT 57233 JW MARRIOT R JANEIRO 908819"},{"id":"ec22c5d9-0c34-4770-6609-08d5ad2bf6ba","name":"NOVA TRANSPORTADORA DO SUDESTE S/A - NTS","commercialName":"","cnpj":"04992714000184","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":"NTS 57279 TAG-GUARAREMA-SP 71546"},{"id":"89b7adbb-3b02-4793-660f-08d5ad2bf6ba","name":"ORGANIZACAO EMPRESARIAL BARROS E MENDES COMERCIO DE GENEROS ALIMENTICIOS LTDA","commercialName":"REDE MULTI MARKET","cnpj":"13156467000177","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":"MULTIMARKET 57286 MEGAMARKET GARDENIA 911134 MEGAMARKET MAGARCA 911135 MEGAMARKET BARROS 911171 MEGAMARKET AUGUSTO 911191 MEGAMARKET CESARIO 911193"},{"id":"6c4dafa9-3a79-4039-6606-08d5ad2bf6ba","name":"VALID SOLUCOES E SERVICOS DE SEGURANCA EM MEIOS DE PAGAMENTO E IDENTIFICACAO S.A.","commercialName":"VALID","cnpj":"33113309000147","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":"VALID 57272 VALID SBC 908363 VALID SOROCABA 908396 VALID RJ 909067"},{"id":"981110bf-c791-42e3-61d9-08d5ad2bf6ba","name":"CONCESSIONARIA DO VLT CARIOCA S.A.","commercialName":"","cnpj":"18201378000119","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":"VLT CARIOCA 54447 VLT CARIOCA 905501 CONC VLT CARIOCA SA 908237"},{"id":"f4469f56-a064-4954-6216-08d5ad2bf6ba","name":"EDIFICIO CENTRO EMPRESARIAL BOTAFOGO","commercialName":"","cnpj":"05335029000148","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":"EDIFICIO BOTAFOGO 54551 ED BOTAFOGO 905860"},{"id":"ff34967b-32d4-47ba-6218-08d5ad2bf6ba","name":"CONDOMINIO DO CENTRO EMPRESARIAL PASSEIO I","commercialName":"","cnpj":"21175573000126","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":"CONDOMINIO PASSEIO I 54555 COND PASSEIO I 905380"},{"id":"ba356a0c-da36-4f52-6219-08d5ad2bf6ba","name":"CONDOMINIO DO CENTRO ADMINISTRATIVO CIDADE NOVA","commercialName":"","cnpj":"21722161000169","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":"CONDOMINIO CIDADE NOVA 54556 COND RIO CIDADE NOVA 905393"},{"id":"7218549b-dccc-462d-6202-08d5ad2bf6ba","name":"BIMBO DO BRASIL LTDA","commercialName":"","cnpj":"35402759001580","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":"BIMBO RJ 54503 BIMBO INHAUMA 904851"},{"id":"8f8b8726-932a-4f61-6123-08d5ad2bf6ba","name":"JARDIM GUADALUPE ADMINISTRADORA E INCORPORADORA S.A","commercialName":"","cnpj":"11024120000145","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":"GUADALUPE SHOP 54033 GUADALUPE SHOP 905352"},{"id":"af59dbdf-221d-4ef3-62dc-08d5ad2bf6ba","name":"LOGUM LOGISTICA S A","commercialName":"","cnpj":"09584935000137","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":"LOGUM I5 55017 LOGUM RIBEIRAO PRETO 906355 LOGUM UBERABA 905891"},{"id":"98118c99-16ba-4fd5-6346-08d5ad2bf6ba","name":"HOTEIS OTHON S A","commercialName":"","cnpj":"33200049000147","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":"OTHON 55286 OTHON BAHIA 906661 OTHON RIO 907576 OTHON SAVOY 907577 OTHON BH 908372"},{"id":"a9b97dba-b599-4967-6320-08d5ad2bf6ba","name":"FABRICA CARIOCA DE CATALISADORES S.A.","commercialName":"","cnpj":"28944734000148","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":"FCC 55177 FB CARIOCA CATALISAD 906849"},{"id":"c68c6b39-6f6c-449a-6233-08d5ad2bf6ba","name":"CICLUS AMBIENTAL DO BRASIL S.A.","commercialName":"CICLUS","cnpj":"10319900000150","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":"CICLUS 54618 SERB CTR SEROPEDICA 906631 SERB BARROS FILHO 908208 SERB SANTA CRUZ 908220 SERB SANTISSIMO 908221"},{"id":"9bd1ed2b-03cb-4f25-6291-08d5ad2bf6ba","name":"RECOFARMA INDUSTRIA DO AMAZONAS LTDA","commercialName":"RECOFARMA","cnpj":"61454393000602","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":"RECOFARMA 54805 RECOFARMA 905527"},{"id":"51002a8f-1b4b-458e-645d-08d5ad2bf6ba","name":"CIBRAPEL SA INDUSTRIA DE PAPEL E EMBALAGENS","commercialName":"","cnpj":"33352881000169","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":"CIBRAPEL 55953 CIBRAPEL TRATAMENTO 906627 CIBRAPEL FL MAIOR 906638 CIBRAPEL 908575"},{"id":"460409b3-f23f-444d-6438-08d5ad2bf6ba","name":"CONDOMINIO CITTA AMERICA","commercialName":"","cnpj":"03496829000115","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":"SHOP CITTA AMERICA 55883 SHOP CITTA AMERIC RJ 906634"},{"id":"4fae27d1-0a50-4c50-6431-08d5ad2bf6ba","name":"CONDOMINIO DO EDIFICIO DO SHOPPING CENTER DA GAVEA","commercialName":"","cnpj":"28248938000144","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":"SHOP CENTER DA GAVEA 55876 SHOPPING DA GAVEA 905850"},{"id":"16941143-1fa7-43c5-642a-08d5ad2bf6ba","name":"CONTROLES GRAFICOS DARU S A","commercialName":"","cnpj":"61793691000112","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":"DARU 55862 DARU 906871"},{"id":"ae521ca7-2908-4598-63f2-08d5ad2bf6ba","name":"TIVIT TERCEIRIZACAO DE PROCESSOS, SERVICOS E TECNOLOGIA S.A.","commercialName":"","cnpj":"07073027000587","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":"TIVIT SENADOR 55733 TIVIT SENADOR 905502"},{"id":"e908a05f-c7f4-42ec-63f4-08d5ad2bf6ba","name":"TIVIT TERCEIRIZACAO DE PROCESSOS, SERVICOS E TECNOLOGIA S.A.","commercialName":"","cnpj":"07073027001044","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":"TIVIT BARRA 55735 TIVIT BARRA 907362"},{"id":"96974fbb-01fd-4c60-638d-08d5ad2bf6ba","name":"SCHOTT BRASIL LTDA","commercialName":"DIVISAO VITROFARMA","cnpj":"33144437000743","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":"SCHOTT BRASIL 55463 SCHOTT RIO DE JANEIR 907364"},{"id":"4d19f5a0-2b71-40e4-6395-08d5ad2bf6ba","name":"TORRE E CIA SUPERMERCADOS S/A","commercialName":"SUPERMARKET","cnpj":"07760885000176","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":"TORRE E CIA 55475 TORRE E CIA 2 906641 TORRE E CIA 3 906642 TORRE E CIA 9 906643 TORRE E CIA 906655 TORRE E CIA 18 906744 TORRE E CIA 13 906745 TORRE E CIA 6 906746 TORRE E CIA 11 906799 TORRE E CIA 10 906824 TORRE E CIA 4 907965 TORRE E CIA 5 910077"},{"id":"fea4ed78-7a57-4ac0-64cc-08d5ad2bf6ba","name":"TIM S/A","commercialName":"","cnpj":"02421421000111","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":"INTELIG 56225 INTELIG LAPA 906397 INTELIG ROCHA 908257 INTELIG M EDNA 908272 INTELIG GUARATIBA 908275 INTELIG AQUILES LOBO 909240 INTELIG BRASILIA 910356 INTELIG IMIGRANTES 911228 INTELIG TELECOM 906817 INTELIG VOLUNTARIOS 908053 INTEL_SENADOR LEMOS 912374"},{"id":"46fe212a-d1da-4519-64b4-08d5ad2bf6ba","name":"TEADIT INDUSTRIA E COMERCIO LTDA","commercialName":"","cnpj":"36193928000187","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":"TEADIT 56171 TEADIT 907290"},{"id":"17e3b7ac-de91-4327-64dd-08d5ad2bf6ba","name":"TIJUCA TENIS CLUBE","commercialName":"","cnpj":"34055590000171","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":"TTC 56285 TIJUCA TENIS CLUBE 910207"},{"id":"fcb52ca6-d8db-4fdc-64f8-08d5ad2bf6ba","name":"LABORATORIOS SERVIER DO BRASIL LTDA","commercialName":"","cnpj":"42374207000176","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":"SERVIER 56333 LAB SERVIER JACAREPA 908269"},{"id":"783ebd21-e144-48eb-6525-08d5ad2bf6ba","name":"BANCO BTG PACTUAL S.A.","commercialName":"","cnpj":"30306294000145","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":"BANCO BTG PACTUAL 56529"},{"id":"7a30853b-e88d-4cd0-6516-08d5ad2bf6ba","name":"HALLIBURTON SERVICOS LTDA","commercialName":"","cnpj":"29504214000187","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":"HALLIBURTON 56467 HALLIBURTON MACAE 907299 HALLIBURTON SERVICOS 907363"},{"id":"48ed4ff3-fdc2-406f-651a-08d5ad2bf6ba","name":"CONDOMINIO DO BOTAFOGO PRAIA SHOPPING","commercialName":"CONDOMINIO DO BOTAFOGO PRAIA SHOPPING.","cnpj":"15206473000117","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":"CONDBPS 56473 BPS SHOPPING MTZ 70383"},{"id":"2f3910da-1274-446d-651c-08d5ad2bf6ba","name":"GE CENTRO BRASILEIRO DE PESQUISAS LTDA.","commercialName":"","cnpj":"14039955000167","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":"GE RESEARCH 56475 GE RESEARCH 907941"},{"id":"2f44590c-a102-4dcf-653f-08d5ad2bf6ba","name":"REFRIGERANTES CONVENCAO RIO LTDA","commercialName":"","cnpj":"28293066000136","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":"CONVENCAO RJ 56617 REFRIGERANTES CONVEN 907336"},{"id":"afd4fcb2-a447-4e4d-6546-08d5ad2bf6ba","name":"GE OIL & GAS DO BRASIL LTDA","commercialName":"","cnpj":"05635291000370","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":"GE WELLSTREAM 56637 GE WELLSTREAM 3290 908087 GE WELLSTREAM 3894 908088 GE WELLSTREAM 4238 908089"},{"id":"c5772b80-6eec-4f86-6561-08d5ad2bf6ba","name":"KATRIUM INDUSTRIAS QUIMICAS S.A.","commercialName":"","cnpj":"28789998000255","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":"KATRIUM 56704 PAN AMERICANA 70815"},{"id":"4594e7b7-147c-4e9c-656a-08d5ad2bf6ba","name":"EMPRESA CINEMAS SAO LUIZ S.A.","commercialName":"","cnpj":"33497660000189","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":"KINOPLEX 56720 KINOPLEX PRAIA COSTA 908118 KINOPLEX - DOM PEDRO 908130 KINOPLEX GRANDE RIO 909444"},{"id":"a33ae84c-15c9-4a40-6566-08d5ad2bf6ba","name":"CLUB MED BRASIL S/A","commercialName":"CLUB MED","cnpj":"03010384000111","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":"CLUB MED 56711 CLUB MED - RIO DAS P 907852 CLUB MED BRASIL S/A 911895"},{"id":"36effa28-036a-4353-657f-08d5ad2bf6ba","name":"GLAXOSMITHKLINE BRASIL LTDA","commercialName":"GLAXOSMITHKLINE E/OU GSK","cnpj":"33247743000110","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":"GSK JPA 56745 GSK JPA 908108"},{"id":"d46ade95-5278-4031-8d96-08d5d060706e","name":"RIO JV PARTNERS PARTICIPACOES LTDA.","commercialName":"","cnpj":"12020002000121","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":"HYATT RJ 61171 HYATT RJ 913339"},{"id":"fc9252ce-24fd-4785-8d98-08d5d060706e","name":"VESUVIUS REFRATARIOS LTDA","commercialName":"","cnpj":"30511844000168","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":"VESUVIUS 61313 VESUVIUS 913582"},{"id":"727bd992-30d1-4008-8d9a-08d5d060706e","name":"FMC TECHNOLOGIES DO BRASIL LTDA.","commercialName":"","cnpj":"48122295000103","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":"TECHNIPFMC 61350 TECHNIPFMC MATRIZ 913500 TECHNIPFMC MATRIZFAS 913501 TECHNIP FMC 5421 913614"},{"id":"91c56d1e-9ff2-41cf-8d9d-08d5d060706e","name":"VIFRIO ARMAZENS GERAIS FRIGORIFICOS LTDA","commercialName":"","cnpj":"27688712000100","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":"VIFRIO 61395 VIFRIO IRAJA 913477 VIFRIO QUEIMADOS 913502"},{"id":"7ccd0173-5210-49ea-8d85-08d5d060706e","name":"ACADEMIA BRASILEIRA DE LETRAS","commercialName":"","cnpj":"40262404000178","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":"ABL 60758 ABL 913338"},{"id":"2fc1c016-42f8-461d-740b-08d5cf600bef","name":"LINHAS DE MACAPA TRANSMISSORA DE ENERGIA S.A.","commercialName":"","cnpj":"10234027000100","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":""},{"id":"87058f5a-5620-4bbf-740c-08d5cf600bef","name":"LINHAS DE XINGU TRANSMISSORA DE ENERGIA S.A.","commercialName":"","cnpj":"10240186000100","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":""},{"id":"6581b429-3b7d-40c3-73fd-08d5cf600bef","name":"DOMMO ENERGIA S.A.","commercialName":"","cnpj":"08926302000105","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":""},{"id":"2466b3c0-1e8e-41bd-73f7-08d5cf600bef","name":"CEMEPE INVESTIMENTOS SA","commercialName":"","cnpj":"93828986000173","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":""},{"id":"570055a3-3ccf-4987-73f8-08d5cf600bef","name":"LIBRA TERMINAL RIO S/A","commercialName":"","cnpj":"02373517000151","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":""},{"id":"2ba8f3d7-95d6-4028-4edc-08d5d159243d","name":"OCEANA OFFSHORE S.A.","commercialName":"","cnpj":"14882295000181","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":""},{"id":"fbee364f-2add-41ae-4ee0-08d5d159243d","name":"PRINER SERVICOS INDUSTRIAIS S.A","commercialName":"","cnpj":"18593815000197","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":""},{"id":"a95fee08-4860-464f-4ef6-08d5d159243d","name":"COMPANHIA CARIOCA DE SECURITIZACAO","commercialName":"RIO SECURITIZACAO","cnpj":"22983283000171","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":""},{"id":"cddae3a2-f3a9-4734-4f10-08d5d159243d","name":"SPE AKRO SECURITIZADORA S.A","commercialName":"","cnpj":"19511433000130","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":""},{"id":"4f5ca0bb-359f-4a3c-4f07-08d5d159243d","name":"IRB BRASIL RESSEGUROS S/A","commercialName":"IRB BRASIL RE","cnpj":"33376989000191","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":""},{"id":"924ea657-e4e5-4404-4f08-08d5d159243d","name":"PETROBRAS DISTRIBUIDORA SA","commercialName":"BR","cnpj":"34274233000102","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":""},{"id":"a27e7055-15cf-4ecd-9f83-08d5d7870f30","name":"INDUSTRIA DE PRODUTOS ALIMENTICIOS PIRAQUE S A","commercialName":"","cnpj":"33040122000160","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":""},{"id":"e8c54748-888c-4f4d-72f0-08d5cf600bef","name":"TECHNOS SA","commercialName":"","cnpj":"09295063000197","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":""},{"id":"aa938795-4832-4a8d-7299-08d5cf600bef","name":"NOVA ACAO PARTICIPACOES SA","commercialName":"","cnpj":"04634250000134","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":""},{"id":"5ae59fd1-f2dd-43b4-7301-08d5cf600bef","name":"INVITEL LEGACY S.A - EM LIQUIDACAO","commercialName":"","cnpj":"10242478000181","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":""},{"id":"1c7df717-37e3-4ba9-7302-08d5cf600bef","name":"NPF CONSULTORIA EM SECURITIZACAO LTDA","commercialName":"","cnpj":"10337440000192","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":""},{"id":"2cf67aa5-fda7-42c3-7303-08d5cf600bef","name":"AFLUENTE TRANSMISSAO DE ENERGIA ELETRICA S.A.","commercialName":"","cnpj":"10338320000100","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":""},{"id":"e0abd1af-f088-4c39-72ea-08d5cf600bef","name":"OSX BRASIL SA EM RECUPERACAO JUDICIAL","commercialName":"","cnpj":"09112685000132","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":""},{"id":"dfac9ddb-2738-4723-72f7-08d5cf600bef","name":"CETIP S.A. - MERCADOS ORGANIZADOS","commercialName":"","cnpj":"09358105000191","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":""},{"id":"a28b0db6-6b2e-44fe-731a-08d5cf600bef","name":"QGEP PARTICIPACOES S.A","commercialName":"","cnpj":"11669021000110","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":""},{"id":"36a5bf58-186c-4e46-7324-08d5cf600bef","name":"POLO CAPITAL SECURITIZADORA S.A.","commercialName":"","cnpj":"12261588000116","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":""},{"id":"0c62ab93-f56e-4247-7329-08d5cf600bef","name":"UTILIUM PARTICIPACOES S.A.","commercialName":"","cnpj":"12394991000113","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":""},{"id":"bb53d7ad-2539-4f44-7309-08d5cf600bef","name":"PETRO RIO S.A.","commercialName":"","cnpj":"10629105000168","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":""},{"id":"6ae519b1-cf60-46a5-7311-08d5cf600bef","name":"EBX BRASIL SA","commercialName":"","cnpj":"10847761000137","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":""},{"id":"20bce7c5-1527-4a23-7312-08d5cf600bef","name":"BOLERO PARTICIPACOES S.A.","commercialName":"","cnpj":"10894123000177","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":""},{"id":"6528946d-9625-4335-7318-08d5cf600bef","name":"3A CONSULTORIA FINANCEIRA LTDA","commercialName":"TRIPLO A COMPANHIA SECURITIZADORA","cnpj":"11396633000187","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":""},{"id":"6938f6a1-4cd1-4dd1-72a8-08d5cf600bef","name":"UNIVERCIDADE TRUST DE RECEBIVEIS S/A","commercialName":"","cnpj":"06027566000193","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":""},{"id":"77bd99a1-a61d-4444-72a9-08d5cf600bef","name":"TSL SECURITIZADORA E PARTICIPACOES S.A.","commercialName":"","cnpj":"06033448000198","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":""},{"id":"a8e45260-668e-47bf-72aa-08d5cf600bef","name":"ALIANSCE SHOPPING CENTERS S.A.","commercialName":"","cnpj":"06082980000103","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":""},{"id":"b7b71474-63e4-426c-72b7-08d5cf600bef","name":"BTG PACTUAL HOLDING PARTICIPACOES S/A.","commercialName":"","cnpj":"07110438000171","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":""},{"id":"01c85c85-2237-4e9f-72b1-08d5cf600bef","name":"BR MALLS PARTICIPACOES S.A.","commercialName":"","cnpj":"06977745000191","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":""},{"id":"d8045c66-5b15-4d6a-7282-08d5cf600bef","name":"LIGHT S/A","commercialName":"","cnpj":"03378521000175","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":""},{"id":"06e58e63-ed0a-48fe-7283-08d5cf600bef","name":"XX DE NOVEMBRO INVESTIMENTOS E PARTICIPACOES S.A.","commercialName":"","cnpj":"03538833000107","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":""},{"id":"143aacb4-0db0-4c3c-7297-08d5cf600bef","name":"ENEVA S.A.","commercialName":"","cnpj":"04423567000121","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":""},{"id":"ebe0bb78-7678-4ffc-72a0-08d5cf600bef","name":"CACHOEIRA PAULISTA TRANSMISSORA DE ENERGIA S.A.","commercialName":"","cnpj":"05336882000184","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":""},{"id":"2d1f339d-95c5-4fac-72c5-08d5cf600bef","name":"CR2 EMPREENDIMENTOS IMOBILIARIOS S/A","commercialName":"","cnpj":"07820907000146","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":""},{"id":"70587c34-1f67-4191-72c6-08d5cf600bef","name":"ACRUX SECURITIZADORA S.A.","commercialName":"","cnpj":"07825881000129","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":""},{"id":"04e25c7e-a21b-4918-72c7-08d5cf600bef","name":"TRANSMISSORA ALIANCA DE ENERGIA ELETRICA S/A","commercialName":"","cnpj":"07859971000130","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":""},{"id":"c8fbcd8c-9401-4b34-72c9-08d5cf600bef","name":"CCX CARVAO DA COLOMBIA S.A.","commercialName":"","cnpj":"07950674000104","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":""},{"id":"faed912e-418b-4bf7-72ca-08d5cf600bef","name":"OLEO E GAS PARTICIPACOES S.A. - EM RECUPERACAO JUDICIAL EM RECUPERACAO JUDICIAL","commercialName":"","cnpj":"07957093000196","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":""},{"id":"b80f1831-6fa2-4cfa-72c1-08d5cf600bef","name":"DINAMICA ENERGIA S.A.","commercialName":"","cnpj":"07659538000151","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":""},{"id":"bfbe5dcf-0ca6-4370-72ce-08d5cf600bef","name":"RJCP EQUITY S.A.","commercialName":"","cnpj":"08281683000104","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":""},{"id":"5c439e38-eebb-4af7-72dd-08d5cf600bef","name":"ESTACIO PARTICIPACOES S/A","commercialName":"","cnpj":"08807432000110","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":""},{"id":"585855d2-57b9-4b12-72df-08d5cf600bef","name":"CENTENNIAL ASSET PARTICIPACOES ACU SA","commercialName":"","cnpj":"08835366000192","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":""},{"id":"1683cb90-4667-45b6-72d4-08d5cf600bef","name":"BRASIL BROKERS PARTICIPACOES S.A.","commercialName":"","cnpj":"08613550000198","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":""},{"id":"509a3602-0542-4b87-72d8-08d5cf600bef","name":"BHG S.A. BRAZIL HOSPITALITY GROUP","commercialName":"","cnpj":"08723106000125","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":""},{"id":"22bbb600-cb02-49b8-72d9-08d5cf600bef","name":"PRUMO LOGISTICA S/A","commercialName":"LLX LOGISTICA S/A","cnpj":"08741499000108","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":""},{"id":"d08c0051-59de-4ef2-736f-08d5cf600bef","name":"SUL AMERICA S A","commercialName":"","cnpj":"29978814000187","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":""},{"id":"c6e8d617-ff96-4288-7372-08d5cf600bef","name":"SOUZA CRUZ LTDA","commercialName":"","cnpj":"33009911000139","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":""},{"id":"7e1ac49c-9c4f-4f60-7373-08d5cf600bef","name":"JOAO FORTES ENGENHARIA S A","commercialName":"","cnpj":"33035536000100","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":""},{"id":"7c38eaec-6647-43d4-7375-08d5cf600bef","name":"MONTEIRO ARANHA SA","commercialName":"","cnpj":"33102476000192","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":""},{"id":"c7494fc0-995c-4cf2-7376-08d5cf600bef","name":"TECNOSOLO ENGENHARIA S.A. EM RECUPERACAO JUDICIAL","commercialName":"TECNOSOLO","cnpj":"33111246000190","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":""},{"id":"ba8ed5b8-aa7e-4d05-7377-08d5cf600bef","name":"SERGEN SERVICOS GERAIS DE ENGENHARIA S A","commercialName":"ESTABELECIMENTO UNIFICADO","cnpj":"33161340000153","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":""},{"id":"1b0073a4-f346-4488-7378-08d5cf600bef","name":"WLM PARTICIPACOES E COMERCIO DE MAQUINAS E VEICULOS S.A.","commercialName":"WLM","cnpj":"33228024000151","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":""},{"id":"4d6d1220-087f-40f0-7368-08d5cf600bef","name":"MILLS ESTRUTURAS E SERVICOS DE ENGENHARIA S/A","commercialName":"","cnpj":"27093558000115","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":""},{"id":"de0fd486-c0a5-49e5-736b-08d5cf600bef","name":"INDUSTRIA VEROLME S.A - IVESA","commercialName":"IVESA","cnpj":"28500320000120","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":""},{"id":"752c9094-b282-4baa-7351-08d5cf600bef","name":"FINPAR PARTICIPACOES SA","commercialName":"","cnpj":"16103773000133","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":""},{"id":"d9212ff4-67c4-4bbe-7348-08d5cf600bef","name":"RIO MONSARAS PARTICIPACOES S.A.","commercialName":"RIO MONSARAS PARTICIPACOES S.A.","cnpj":"14969641000163","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":""},{"id":"91d2bb14-4227-4713-7336-08d5cf600bef","name":"REIT SECURITIZADORA DE RECEBIVEIS IMOBILIARIOS S.A","commercialName":"REIT","cnpj":"13349677000181","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":""},{"id":"2c157fe8-118b-4395-7338-08d5cf600bef","name":"MLOG S.A.","commercialName":"","cnpj":"13444994000187","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":""},{"id":"cf7da215-5ad2-46a7-733c-08d5cf600bef","name":"SEABRAS SERVICOS DE PETROLEO S.A.","commercialName":"","cnpj":"14042551000122","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":""},{"id":"f3630303-472d-419e-737f-08d5cf600bef","name":"COMPANHIA DISTRIBUIDORA DE GAS DO RIO DE JANEIRO - CEG","commercialName":"* CEG *","cnpj":"33938119000169","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":""},{"id":"022bc497-72e8-4e09-737a-08d5cf600bef","name":"COMPANHIA ESTADUAL DE AGUAS E ESGOTOS CEDAE","commercialName":"","cnpj":"33352394000104","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":""},{"id":"5f66a154-5ca4-49f3-737b-08d5cf600bef","name":"SONDOTECNICA ENGENHARIA DE SOLOS S A","commercialName":"","cnpj":"33386210000119","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":""},{"id":"526844e8-bc16-495d-737c-08d5cf600bef","name":"REFINARIA DE PETROLEOS DE MANGUINHOS S/A - EM RECUPERACAO JUDICIAL","commercialName":"","cnpj":"33412081000196","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":""},{"id":"e96fe39a-f8fe-44f5-737d-08d5cf600bef","name":"DOCAS INVESTIMENTOS S/A","commercialName":"","cnpj":"33433665000148","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":""},{"id":"c0764ea5-25ec-4b65-7389-08d5cf600bef","name":"PROFARMA DISTRIBUIDORA DE PRODUTOS FARMACEUTICOS SA","commercialName":"","cnpj":"45453214000151","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":""},{"id":"cd618d51-b42a-41aa-7385-08d5cf600bef","name":"LOG-IN - LOGISTICA INTERMODAL S/A","commercialName":"LOG-IN","cnpj":"42278291000124","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":""},{"id":"03ff785d-78a6-47ce-7382-08d5cf600bef","name":"QUALITY SOFTWARE S/A","commercialName":"","cnpj":"35791391000194","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":""},{"id":"8fe9262d-6eb6-4db3-1ca1-08d5b8870181","name":"CONDOMINIO DOWNTOWN","commercialName":"","cnpj":"02686197000190","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":"DOWNTOWN 60055 DOWNTOWN 421322252 912872 DOWNTOWN 420112580 912912 DOWNTOWN 400227617 912932 DOWNTOWN 421322246 912933 DOW 421322264 913475 DOW 420112732 913476"},{"id":"4ee8c27f-11db-479f-1caf-08d5b8870181","name":"DFL INDUSTRIA E COMERCIO S/A","commercialName":"NOVA DFL INDUSTRIA E COMERCIO S.A.","cnpj":"33112665000146","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":"NOVA DFL 60840 CARJ912911 912911"},{"id":"396785e4-56fd-4688-1cb1-08d5b8870181","name":"IRMAOS BENASSI PRODUTORA E DISTRIBUIDORA DE FRUTAS LTDA","commercialName":"","cnpj":"29020880000140","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":"BENASSI 60846 IRMAOS BENASSI 912931"},{"id":"7da61eef-8735-4a79-1cc9-08d5b8870181","name":"LUPUS DESENVOLVIMENTO EM ALIMENTOS LTDA","commercialName":"","cnpj":"11120258000148","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":"LUPUS 61631 LUPUS RIO BONITO 912751 LUPUS SANTA LUZIA 912794"},{"id":"72ab5a62-6cc5-460e-88b1-08d5ae44ed50","name":"DRACENA III PARQUE SOLAR S.A.","commercialName":"","cnpj":"21977169000176","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":"DRACENA III 17427"},{"id":"9b6f10e0-88ca-44a9-88b2-08d5ae44ed50","name":"SOLAR CAETITE 1 S.A.","commercialName":"","cnpj":"21573814000195","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":"SOLAR CAETITE 1 17444"},{"id":"680b8e94-6160-4565-88b4-08d5ae44ed50","name":"SOLAR CAETITE 2 S.A.","commercialName":"","cnpj":"21603007000178","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":"SOLAR CAETITE 2 17464"},{"id":"97ed90bb-ea59-4f86-88b5-08d5ae44ed50","name":"SOLAR CAETITE 3 S.A.","commercialName":"","cnpj":"21589589000185","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":"SOLAR CAETITE 3 17465"},{"id":"8c32a164-cb16-4f94-88d5-08d5ae44ed50","name":"ALVEAR PARTICIPACOES S/A","commercialName":"","cnpj":"03195007000102","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":"SHOP CATUAI MARINGA 52751"},{"id":"0125c1fa-6084-46ab-7225-08d5cf600bef","name":"NEOENERGIA S.A","commercialName":"","cnpj":"01083200000118","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":""},{"id":"d5819a39-bf89-4c95-7226-08d5cf600bef","name":"ELETROBRAS PARTICIPACOES S/A","commercialName":"ELETROPAR","cnpj":"01104937000170","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":""},{"id":"b3f7e924-2651-4e71-7238-08d5cf600bef","name":"SUL 116 PARTICIPACOES SA","commercialName":"","cnpj":"01957772000189","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":""},{"id":"7a4d4530-8512-4062-723a-08d5cf600bef","name":"SUDESTE S.A.","commercialName":"","cnpj":"02062747000108","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":""},{"id":"346d41d4-746e-4543-7240-08d5cf600bef","name":"UPTICK PARTICIPACOES S/A","commercialName":"","cnpj":"02162616000194","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":""},{"id":"312e0226-77e0-42a2-7241-08d5cf600bef","name":"GPC PARTICIPACOES S/A EM RECUPERACAO JUDICIAL","commercialName":"","cnpj":"02193750000152","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":""},{"id":"204b95f0-7dae-4aad-7242-08d5cf600bef","name":"CEL PARTICIPACOES S.A CELPAR","commercialName":"","cnpj":"02201787000185","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":""},{"id":"f084e12e-e6af-42fc-7243-08d5cf600bef","name":"ALEF S.A","commercialName":"","cnpj":"02217319000107","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":""},{"id":"bc82bb41-f025-45bb-7233-08d5cf600bef","name":"524 PARTICIPACOES S/A","commercialName":"","cnpj":"01851771000155","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":""},{"id":"5ef1d220-3492-448c-722d-08d5cf600bef","name":"521 PARTICIPACOES S/A - EM LIQUIDACAO EXTRAJUDICIAL","commercialName":"","cnpj":"01547749000116","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":""},{"id":"50c27105-fc1d-4e6b-722f-08d5cf600bef","name":"BELAPART S.A.","commercialName":"","cnpj":"01608571000176","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":""},{"id":"5688fef0-d6ed-4aad-720f-08d5cf600bef","name":"PARCOM PARTICIPACOES SA","commercialName":"","cnpj":"00185475000108","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":""},{"id":"3d265b76-0c70-44cb-7211-08d5cf600bef","name":"FORPART S/A","commercialName":"","cnpj":"00249786000185","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":""},{"id":"c8db1442-3fc2-47ef-7212-08d5cf600bef","name":"CIMS S.A.","commercialName":"","cnpj":"00272185000193","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":""},{"id":"9d248315-69c7-4663-721b-08d5cf600bef","name":"LITEL PARTICIPACOES S/A","commercialName":"","cnpj":"00743065000127","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":""},{"id":"e91af58f-d077-441a-7216-08d5cf600bef","name":"BNDES PARTICIPACOES SA BNDESPAR","commercialName":"BNDESPAR","cnpj":"00383281000109","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":""},{"id":"b51b8e5a-82b9-4ba7-7217-08d5cf600bef","name":"ELETRON S A","commercialName":"","cnpj":"00514998000142","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":""},{"id":"67c186e6-7508-48a5-7270-08d5cf600bef","name":"GAMA PARTICIPACOES S.A","commercialName":"","cnpj":"02796775000140","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":""},{"id":"d81d1c52-32f5-4d87-7265-08d5cf600bef","name":"TERMINAL GARAGEM MENEZES CORTES S.A.","commercialName":"TERMINAL GARAGEM MENEZES CORTES","cnpj":"02664042000152","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":""},{"id":"d089d489-e70e-4c46-726b-08d5cf600bef","name":"MMX MINERACAO E METALICOS S/A","commercialName":"","cnpj":"02762115000149","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":""},{"id":"10997dd3-319e-4146-726d-08d5cf600bef","name":"BETAPART PARTICIPACOES S/A","commercialName":"","cnpj":"02762124000130","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":""},{"id":"352a52de-3335-4930-7287-08d5cf600bef","name":"INVESTIMENTOS E PARTICIPACOES EM INFRAESTRUTURA S.A - INVEPAR","commercialName":"INVEPAR","cnpj":"03758318000124","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":""},{"id":"9c39aa0d-a717-4598-727a-08d5cf600bef","name":"PROMPT PARTICIPACOES S.A.","commercialName":"","cnpj":"02992449000109","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":""},{"id":"c0023094-23bb-4386-7249-08d5cf600bef","name":"PRODUTORES ENERGETICOS DE MANSO S/A - PROMAN","commercialName":"","cnpj":"02291077000193","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":""},{"id":"274956bf-5c93-4fd5-723e-08d5cf600bef","name":"BONAIRE PARTICIPACOES S/A","commercialName":"","cnpj":"02117801000167","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":""},{"id":"4e2f4241-dc9f-4080-724b-08d5cf600bef","name":"OPPORTUNITY ENERGIA E PARTICIPACOES S.A.","commercialName":"","cnpj":"02318346000168","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":""},{"id":"85fe0057-f6ec-4e59-724f-08d5cf600bef","name":"ZAIN PARTICIPACOES S/A","commercialName":"","cnpj":"02363918000120","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":""},{"id":"5086aa3b-a1d6-420d-7250-08d5cf600bef","name":"IDEIASNET S/A","commercialName":"","cnpj":"02365069000144","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":""},{"id":"a02dfa21-b7db-4a47-7263-08d5cf600bef","name":"NEWTEL PARTICIPACOES S/A","commercialName":"","cnpj":"02604997000114","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":""},{"id":"ae0b3419-8996-4b1e-7257-08d5cf600bef","name":"FUTURETEL S/A","commercialName":"","cnpj":"02465783000104","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":""},{"id":"2449fbc5-9da3-4804-725f-08d5cf600bef","name":"TIM PARTICIPACOES S.A","commercialName":"","cnpj":"02558115000121","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":""},{"id":"4dd45115-d8ce-4b4b-5782-08d5ad2bf6ba","name":"ARAUCARIA NITROGENADOS S.A.","commercialName":"","cnpj":"12984254000170","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":"ARAUCARIA NITR 8972 ARAUCARIA NITRO PR 7105"},{"id":"ee9d60ab-ade0-4d01-57d0-08d5ad2bf6ba","name":"CONDOMINIO DO EDIFICIO RIO DESIGN BARRA","commercialName":"","cnpj":"04504741000160","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":"R DESIGN BAR 9694 R DESIGN BAR 889540"},{"id":"8d569e81-4db5-4f47-57b7-08d5ad2bf6ba","name":"PROCOSA PRODUTOS DE BELEZA LTDA","commercialName":"","cnpj":"33306929000100","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":"LOREAL 9409 LOREAL FABRICA 889860 LOREAL FABRICA SP 892362"},{"id":"d165172b-a14d-4d8a-57c8-08d5ad2bf6ba","name":"CASA DE SAUDE LARANJEIRAS LTDA","commercialName":"LARANJEIRAS CLINICA PERINATAL","cnpj":"33419482000178","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":"PERINATAL 9611 PERINATAL 889629 PERINATAL LARANJEIRA 890011"},{"id":"6bf4c262-acdc-4402-5726-08d5ad2bf6ba","name":"MOINHOS CRUZEIRO DO SUL S A","commercialName":"","cnpj":"88301155002071","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":"MOINHOS CRUZEI 8266 MOINHO CRUZEIRO 888388"},{"id":"0ec908b7-236e-4a75-56fe-08d5ad2bf6ba","name":"MRS LOGISTICA S/A","commercialName":"ESTABELECIMENTO UNIFICADO","cnpj":"01417222000177","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":"MRS 8120 MRS HORTO 888623 MRS P1-07 889396 MRS CREMALHEIRA 889078 MRS KM 64 913305"},{"id":"73e48739-a1d2-4e9f-566b-08d5ad2bf6ba","name":"GERAMAMORE PARTICIPACOES E COMERCIALIZADORA DE ENERGIA LTDA","commercialName":"","cnpj":"09625739000163","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":"GERAMAMORE 7042"},{"id":"7dd41a0b-7f6b-47a9-564b-08d5ad2bf6ba","name":"CONDOMINIO DO EDIFICIO ILHA PLAZA SHOPPING CENTER","commercialName":"","cnpj":"68568419000188","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":"SHOPILHA PLAZA 6841 SHOPPING ILHA PLAZA 72207"},{"id":"a55410bd-c4b5-4c3f-55d0-08d5ad2bf6ba","name":"BRASTURINVEST INVESTIMENTOS TURISTICOS S/A","commercialName":"PESTANA RIO ATLANTICA","cnpj":"03422594000389","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":"PRA 6182 PESTANA 890219"},{"id":"2354be96-e165-4117-563c-08d5ad2bf6ba","name":"CONDOMINIO DO SHOPPING CENTER TIJUCA","commercialName":"","cnpj":"01870834000110","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":"SHOP TIJUCA 6817 SHP TIJUCA 72286"},{"id":"034865dc-d29d-4c74-55f5-08d5ad2bf6ba","name":"FGW COMERCIALIZADORA DE ENERGIA ELETRICA LTDA","commercialName":"FGW COMERCIALIZADORA DE ENERGIA ELETRICA","cnpj":"15054480000140","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":"FGW COM 6390"},{"id":"03776947-f33f-4c0d-550b-08d5ad2bf6ba","name":"EDRE - BR COMERCIALIZADORA E SERVICOS DE ENERGIA LTDA","commercialName":"","cnpj":"12437849000106","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":"EDRE - BR 4960"},{"id":"be82d15f-5d0a-4081-54c1-08d5ad2bf6ba","name":"LIGHTGER SA","commercialName":"","cnpj":"04430725000170","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":"PCH PARACAMBI 4480 PARACAMBI 8970 PCH.PH.RJ.001959-3.01"},{"id":"22c09c03-c065-485a-54ca-08d5ad2bf6ba","name":"PRODUTOS ROCHE QUIMICOS E FARMACEUTICOS S A","commercialName":"","cnpj":"33009945002339","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":"ROCHE 4499 LABORATORIO ROCHE-RJ 71721"},{"id":"7a6673a3-6500-4a9d-54cb-08d5ad2bf6ba","name":"IBM BRASIL-INDUSTRIA MAQUINAS E SERVICOS LIMITADA","commercialName":"IBM BRASIL INDUSTRIA MAQUINAS","cnpj":"33372251000156","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":"IBM 4500 IBM BRASIL TUTOIA 71873 IBM PASTEUR RJ 889960 IBM II-HORTOLANDIA 71666"},{"id":"22e8db64-1410-4ff1-54a6-08d5ad2bf6ba","name":"CONDOMINIO NEW YORK CITY CENTER","commercialName":"","cnpj":"03474240000116","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":"NYC CENTER 4411 NEW YORK CENTER-RJ 71557"},{"id":"b4451d72-8036-408b-552c-08d5ad2bf6ba","name":"CENTRAL EOLICA INHAMBU S/A","commercialName":"","cnpj":"14572367000194","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":"INHAMBU 5157 INHAMBU 893363 EOL.CV.BA.030751-3.01"},{"id":"e61b72c1-0278-47f0-5531-08d5ad2bf6ba","name":"CENTRAL EOLICA TAMANDUA MIRIM S/A","commercialName":"","cnpj":"14571068000135","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":"TAMANDUA 5162 TAMANDUA MIRIM 893402 EOL.CV.BA.030753-0.01"},{"id":"c75d38b9-0c7b-403b-5532-08d5ad2bf6ba","name":"CENTRAL EOLICA CAITITU S/A","commercialName":"","cnpj":"14570861000110","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":"CAITITU 5163 CAITITU 893362 EOL.CV.BA.030739-4.01"},{"id":"79b330e9-d362-4b8e-5534-08d5ad2bf6ba","name":"CENTRAL EOLICA COQUEIRINHO S/A","commercialName":"","cnpj":"14570819000107","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":"COQUEIRINHO 5165 COQUEIRINHO 893324 EOL.CV.BA.030738-6.01"},{"id":"2e856fed-2b96-45ad-552e-08d5ad2bf6ba","name":"CENTRAL EOLICA CORRUPIAO S/A","commercialName":"","cnpj":"14570800000152","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":"CORRUPIAO 5159 CORRUPIAO 893423 EOL.CV.BA.030752-1.01"},{"id":"c562c136-511a-46b4-552f-08d5ad2bf6ba","name":"CENTRAL EOLICA ANGICAL S/A","commercialName":"","cnpj":"14570783000153","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":"ANGICAL 5160 ANGICAL 893282 EOL.CV.BA.030732-7.01"},{"id":"11ecbae4-2c7f-4cf7-552a-08d5ad2bf6ba","name":"CENTRAL EOLICA TEIU S/A","commercialName":"","cnpj":"14570839000170","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":"TEIU 5154 EOLICA TEIU 893462 EOL.CV.BA.030731-9.01"},{"id":"e270b88c-f160-466e-554e-08d5ad2bf6ba","name":"BALL BEVERAGE CAN SOUTH AMERICA S.A.","commercialName":"BALL","cnpj":"29506474000191","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":"BALL BCSA 5309 REXAM JACAREI 7389 REXAM-RECIFE 71796 REXAM SANTA CRUZ 891484 REXAM BRASILIA 892983 REXAM AGUAS CLARAS 900642 REXAM POUSO ALEGRE 890055"},{"id":"79e03708-6836-41d1-559c-08d5ad2bf6ba","name":"COMPANHIA HOTEIS PALACE","commercialName":"COPACABANA PALACE HOTEL","cnpj":"33374984000120","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":"HOTEIS PALACE 5897 H COPACABANA ATL 72424 H COPACABANA COP 72425"},{"id":"548929bf-a9c1-4ce1-559e-08d5ad2bf6ba","name":"AMPERIA COMERCIALIZADORA DE ENERGIA LTDA","commercialName":"","cnpj":"14393564000146","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":"AMPERIA 5899"},{"id":"9b86a873-bf78-40c9-5479-08d5ad2bf6ba","name":"SOLENERGIAS COMERCIALIZADORA DE ENERGIA S.A.","commercialName":"SOLENERGIAS","cnpj":"13459301000120","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":"SOLENERGIAS 4293"},{"id":"11b8c28e-3569-434f-544f-08d5ad2bf6ba","name":"SOCIEDADE DE ENSINO SUPERIOR ESTACIO DE SA LTDA","commercialName":"UNIVERSIDADE ESTACIO DE SA","cnpj":"34075739000184","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":"ESTACIO 4160 EST DE SA-I.GOVERNAD 71454 EST DE SA-MADUREIRA 71455 EST DE SA -N.IGUACU 71456 EST DE SA-REBOUCAS 71457 ESTACIO DE SA-MERITI 71464 ESTACIO DUQUE CAXIAS 71486 ESTACIO NOVA AMERICA 71487 ESTACIO TAQUARA 890317 ESTACIO CAMPO GRD 2 893602 ESTACIO VILA VELHA 897307 ESTACIO PETROPOLIS 898577 ESTACIO OURINHOS 898681 ESTACIO CAMPO GRANDE 898682 ESTACIO CABO FRIO 898683 ESTACIO NITEROI 899026 ESTACIO C GOYTACAZES 899027 ESTACIO ALCANTARA 899046 ESTACIO N. FRIBURGO 899783 ESTACIO JUIZ DE FORA 900115 ESTACIO VITORIA 900273 ESTACIO RESENDE 906398 ESTACIO PRADO 906546 ESTACIO MACAE 907491 ESTACIO FLORESTA 907528 ESTACIO VARGEM PEQ 909426 ESTACIO VIA BRASIL 910049 ESTACIO NITEROI II 910340 ESTACIO SANTA CRUZ 911792 ESTACIO-SANTA CRUZ 71478 ESTACIO SA-JACAREPG 72058"},{"id":"57c91fa9-9838-41f2-5449-08d5ad2bf6ba","name":"COMPANHIA HIDRELETRICA TELES PIRES","commercialName":"","cnpj":"12810896000153","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":"TELES PIRES 4138 TELES PIRES 894624 UHE.PH.PA.030557-0.01"},{"id":"014ca426-4b4b-4964-5402-08d5ad2bf6ba","name":"GERACAO CENTRAL EOLICA RENASCENCA I S.A.","commercialName":"","cnpj":"12831777000187","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":"BROOKFIELD RE I 3950 RENASCENCA I 890937 EOL.CV.RN.030515-4.01"},{"id":"a0202a0a-edae-4d8a-5403-08d5ad2bf6ba","name":"GERACAO EOLICA RENASCENCA II S.A.","commercialName":"","cnpj":"12831668000160","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":"BROOKFIELD RE II 3951 RENASCENCA II 890938 EOL.CV.RN.030516-2.01"},{"id":"c26b6893-20ac-4be8-5404-08d5ad2bf6ba","name":"GERACAO CENTRAL EOLICA PARQUE RENASCENCA III S.A.","commercialName":"","cnpj":"12833445000131","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":"BROOKFIELD RE III 3952 RENASCENCA III 890939 EOL.CV.RN.030527-8.01"},{"id":"6256c19d-fedc-46e9-5405-08d5ad2bf6ba","name":"GERACAO CENTRAL EOLICA COMPLEXO RENASCENCA IV S.A.","commercialName":"","cnpj":"12833899000102","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":"BROOKFIELD RE IV 3954 RENASCENCA IV 890940 EOL.CV.RN.030551-0.01"},{"id":"990cc953-84e7-4d20-5406-08d5ad2bf6ba","name":"GERACAO CENTRAL EOLICA VENTOS DE SAO MIGUEL S.A.","commercialName":"","cnpj":"12833419000103","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":"BROOKFIELD VSM 3955 VENTOS DE SAO MIGUEL 890941 EOL.CV.RN.030514-6.01"},{"id":"84d77736-8d74-4a69-5435-08d5ad2bf6ba","name":"GERDAU S.A.","commercialName":"GERDAU COSIGUA","cnpj":"33611500000119","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":"GSA 4084 ACOS ANHANGUERA 7340 GERDAU PINDA 7341"},{"id":"d87c1c25-a58d-4542-5436-08d5ad2bf6ba","name":"CONDOMINIO DO ED DE SERV DO BNDES NO R DE JANEIRO-CEDSE","commercialName":"CEDSERJ","cnpj":"29170776000131","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":"BNDES 4089 BNDS-CEDSERJ 13,8 KV 71431"},{"id":"f6a5fce8-ef8f-4343-53d6-08d5ad2bf6ba","name":"CALANGO 4 ENERGIA RENOVAVEL S/A.","commercialName":"","cnpj":"12106862000182","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":"CALANGO 4 3877 CALANGO 4 2LFA 890628 EOL.CV.RN.030537-5.01"},{"id":"fe0e7da5-23dd-49fc-53d3-08d5ad2bf6ba","name":"SALOBO METAIS S/A","commercialName":"","cnpj":"33931478000194","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":"SALOBO 3874 SALOBO METAIS-MARABA 71534"},{"id":"5a732311-e55e-4022-53c7-08d5ad2bf6ba","name":"OI S.A. - EM RECUPERACAO JUDICIAL","commercialName":"OI","cnpj":"76535764000143","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":"BRASIL TELECOM 3846 CAPOEIRAS 13,8 KV 71425 BRASIL TELECOM-P OLV 71510 BRASIL TELECOM-CXIAS 71515 ELEUTERIO RS 899069 QUINZE NOVEMBRO 901222 ARTHUR DA SILVA PR 901393 SILVA JARDIM 906321 ANDRADAS 906341 OI OSVALDO CRUZ 906349 OI JOVINO DO ROSARIO 906959 VENANCIO AIRES 907070 OI TEIXEIRA DE FREIT 907095 ANITA GARIBALDI 907452 OI NEO ALVES 907670 OI SALDANHA MARINHO 908012 OI LEONIA MILITO 908013 OI JOAO CANDIDO 908033 JARIVATUBA 908037 JOSE B BORMANN 908361 OI JOSE MARIA 908404 NEREU RAMOS 908516 OI CRICIUMA 908858 REPUBLICA ARGENTINA 909336 IRMAOS PEREIRA 910261 RODRI BRASIL 910271 TELECOM CAXIAS 911316 OI JOAO BAUER 911336 IRINEU PACHECO -GRAV 911619 MARIO MONACO - BENTO 911620 TIRADENTES - ERECHIM 911621 BRASIL JACAREZINHO 912035 BRASIL TELECOM-CUIAB 71677 BRASIL TELECOM C GRD 71714 ADALTO BOTELHO 909699 GASPAR MARTINS 913395"},{"id":"b2923110-2d3d-492e-53d9-08d5ad2bf6ba","name":"CAETITE 3 ENERGIA RENOVAVEL S/A.","commercialName":"","cnpj":"12106879000130","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":"CAETITE 3 3880 CAETITE 3 888103 EOL.CV.BA.030448-4.01"},{"id":"406022af-c688-4f83-53da-08d5ad2bf6ba","name":"CAETITE 2 ENERGIA RENOVAVEL S/A","commercialName":"","cnpj":"12106989000100","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":"CAETITE 2 3881 CAETITE 2 888101 EOL.CV.BA.030437-9.01"},{"id":"52d2c130-d094-4820-53db-08d5ad2bf6ba","name":"MEL 2 ENERGIA RENOVAVEL S/A","commercialName":"","cnpj":"12107032000170","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":"MEL 2 3882 MEL 2 888114 EOL.CV.RN.030454-9.01"},{"id":"40205606-c9cb-4354-53dc-08d5ad2bf6ba","name":"ARIZONA 1 ENERGIA RENOVAVEL S/A","commercialName":"","cnpj":"11944524000157","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":"ARIZONA 1 3883 ARIZONA 1 890458 EOL.CV.RN.030622-3.01"},{"id":"9527e472-4f25-4151-53dd-08d5ad2bf6ba","name":"CALANGO 5 ENERGIA RENOVAVEL S/A.","commercialName":"","cnpj":"12159338000170","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":"CALANGO 5 3884 CALANGO 5 2LFA 890629 EOL.CV.RN.030552-9.01"},{"id":"ed213cdf-99f9-48e4-53de-08d5ad2bf6ba","name":"CALANGO 1 ENERGIA RENOVAVEL S/A.","commercialName":"","cnpj":"12106898000166","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":"CALANGO 1 3885 CALANGO 1 2LFA 890625 EOL.CV.RN.030511-1.01"},{"id":"8617fa24-e310-4a7a-53df-08d5ad2bf6ba","name":"CALANGO 2 ENERGIA RENOVAVEL S/A","commercialName":"","cnpj":"12107047000138","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":"CALANGO 2 3886 CALANGO 2 2LFA 890626 EOL.CV.RN.030519-7.01"},{"id":"6261eac1-1d9f-43c6-53e0-08d5ad2bf6ba","name":"CALANGO 3 ENERGIA RENOVAVEL S/A.","commercialName":"","cnpj":"12106962000109","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":"CALANGO 3 3887 CALANGO 3 2LFA 890627 EOL.CV.RN.030545-6.01"},{"id":"a2860676-dd16-4508-53af-08d5ad2bf6ba","name":"PEQUENA CENTRAL HIDROELETRICA RIO DO BRACO S.A","commercialName":"","cnpj":"09024809000128","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":"PCH BRACO 3768 BRACO 8799 PCH.PH.RJ.030001-2.01"},{"id":"45f4e91e-5875-49f6-4f43-08d5ad2bf6ba","name":"TERMOCABO S.A.","commercialName":"TERMOCABO","cnpj":"04623135000164","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":"TERMOCABO 182 TERMOCABO 8277 UTE.GN.PE.028326-6.01 TERMOCABO EXP. 88277 UTE.GN.PE.028326-6.01"},{"id":"71a05919-512a-4bef-4f48-08d5ad2bf6ba","name":"SOUTH32 MINERALS SA","commercialName":"","cnpj":"42105890000146","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":"BHP BILLITON CL 196 ALUMAR REFINAR BHP 70611 ALUMAR REDUCAO BHP 70616"},{"id":"3675b013-ae32-4d86-4f33-08d5ad2bf6ba","name":"TANGARA ENERGIA S/A","commercialName":"","cnpj":"03573381000196","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":"TANGARA 130 GUAPORE (TANGARA) 566 UHE.PH.MT.001066-9.01"},{"id":"be32a35f-88f9-449a-4f35-08d5ad2bf6ba","name":"USINA TERMELETRICA NORTE FLUMINENSE S/A","commercialName":"EDF NORTE FLUMINENSE S.A.","cnpj":"03258983000159","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":"NORTE FLU 134 NORTE FLUMINENSE 1 8165 UTE.GN.RJ.001544-0.01 NORTE FLUMINENSE 2 8166 UTE.GN.RJ.001544-0.01 NORTE FLUMINENSE 3 8167 UTE.GN.RJ.001544-0.01 NORTE FLUMINENSE 4 8168 UTE.GN.RJ.001544-0.01 NORTE FLU EXP 1 8486 UTE.GN.RJ.001544-0.01 NORTE FLU EXP 3 902180 UTE.GN.RJ.001544-0.01 NORTE FLU EXP 2 902195 UTE.GN.RJ.001544-0.01 NORTE FLU EXP 4 902198 UTE.GN.RJ.001544-0.01"},{"id":"3d728083-6184-4c37-4f36-08d5ad2bf6ba","name":"PETROLEO BRASILEIRO S A PETROBRAS","commercialName":"PETROBRAS","cnpj":"33000167000101","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":"PETROBRAS PIE 135 RECAP CAPUAVA-PETROB 7010 REPLAN PAULINIA 7059 PETROBRAS ATALAIA 7145 FAFEN CARGA 7211 REGAP 7220 PETROBRAS RPBC 7259 TRANSPETRO CABIUNAS 7311 PETROBRAS SIX SM SUL 7318 PETROBRAS CARMOPOLIS 7371 PETR REVAP 7820 RLAM 7835 REPAR CAPTACAO AGUA 7836 REPAR_PR 7837 PETROBRAS A RODRIG 7848 PETROBRAS FURADO 7971 PETROBRAS C AMARO 7973 PETROBRAS FAZ BELEM 7974 PETROBRAS PILAR 7998 PETROBRAS R DA FORQ 70096 PETROBR FAFEN LARANJ 70166 REDUC 70374 PETROBRAS GUAMARE 70822 CENPES 71320 PETROBRAS PECEM 71565 UO-CACIMBAS-LINHARES 71651 PETROB RPBC-CUBATAO 71788 PETRO ALTO DA PEDRA 72399 UFN3 TRES LAGOAS 888174 REDUC CAPTACAO 888806 RNEST CONSUMO 889135 PETROBRAS COMPERJ 889855 EDISA 900647 PETROBRAS SANTIAGO 95 PTRBRAS EI SEVERINA 70907 PETROBRAS EI EDISE 70944 PETROBRAS EDIHB 71077 PETROBRAS CAJU 71202 PETROBRAS EI IMBSSCA 71203 PETROBRAS EI IMBTBA 71204 PETROBRAS PRD IMBSSA 71355 PETROBRAS PRD IMBTBA 71356 PETROBRAS PREDIO CCO 71357 PETROBRAS EDICIN 71539 PETROBRAS EDIVIT VIT 72223 EDICA 890632 EDISEN - PETRORAS 897679 EDINC 898591 TMA 888974 PETROBRAS EDIBA 889618 UTGSUL 912514 ALTO DO RODRIGUES 893783 UFV.RS.RN.031694-6.01 RLAM 8053 UTE.PE.BA.002197-0.01 REPAR 8093 UTE.PE.PR.002195-4.01 REFAP 8229 UTE.PE.RS.002192-0.01 REGAP (UTE) 889233 UTE.PE.MG.028596-0.01 U-50 (RNEST) 896928 UTE.PE.PE.030438-7.01 CAMAC POLO I 8421 UTE.PE.BA.029555-8.01 CAMAC MURIC I 8420 UTE.PE.BA.029554-0.01 BAHIA I 8760 UTE.PE.BA.028615-0.01 TERMOCEARA EXP 8728 UTE.GN.CE.028358-4.01 ELETROBOLT 13LEE EXP 902473 UTE.GN.RJ.027952-8.01 TRES LAGOAS EXP 8727 UTE.GN.MS.027975-7.01 TERMO CUBATAO EXP 8713 UTE.GN.SP.028014-3.01 CUBATAO 13LEE EXP 902557 UTE.GN.SP.028014-3.01 B.FLUMINENSE EXP 903899 UTE.GN.RJ.030769-6.01 JUIZ DE FORA EXP. 8487 UTE.GN.MG.001276-9.01 IBIRITE EXPORTACAO 84097 UTE.GN.MG.001096-0.01 TERMORIO 13LEE 892862 UTE.GN.RJ.027888-2.01 TERMORIO 13LEE EXP 902554 UTE.GN.RJ.027888-2.01 ELETROBOLT EXP 880302 UTE.GN.RJ.027952-8.01 TERMORIO 15LEE EXP 902555 UTE.GN.RJ.027888-2.01 NOVA PIRATININGA 578 UTE.GN.SP.028191-3.01 N PIRATININGA EXP 880578 UTE.GN.SP.028191-3.01 VALE ACU 8373 UTE.GN.RN.028225-1.01 VALE ACU EXP 8714 UTE.GN.RN.028225-1.01 TERMOMACAE EXP 8589 UTE.GN.RJ.028029-1.01 BAIXADA FLUMINENSE 888068 UTE.GN.RJ.030769-6.01 JUIZ DE FORA 312 UTE.GN.MG.001276-9.01 TERMOBAHIA 399 UTE.GN.BA.027263-9.01 TERMOBAHIA EXP 8696 UTE.GN.BA.027263-9.01 IBIRITE 409 UTE.GN.MG.001096-0.01 CANOAS 571 UTE.GN.RS.028038-0.01 TERMOCEARA 3466 895581 UTE.GN.CE.028358-4.01 TERMO CUBATAO 13LEE 892822 UTE.GN.SP.028014-3.01 TERMOMACAE 8761 UTE.GN.RJ.028029-1.01 TERMORIO 8286 UTE.GN.RJ.027888-2.01 TERMORIO EXP 888046 UTE.GN.RJ.027888-2.01 TERMORIO 15LEE 897966 UTE.GN.RJ.027888-2.01 FAFEN ENERGIA 257 UTE.GN.BA.028206-5.01 ELETROBOLT 8407 UTE.GN.RJ.027952-8.01 ELETROBOLT 13LEE 892802 UTE.GN.RJ.027952-8.01 TRES LAGOAS 8409 UTE.GN.MS.027975-7.01 TRES LAGOAS 13LEE 892863 UTE.GN.MS.027975-7.01 TERMOCEARA 8411 UTE.GN.CE.028358-4.01 TERMO CUBATAO 8575 UTE.GN.SP.028014-3.01"},{"id":"85a2aa1a-8a87-44af-4f37-08d5ad2bf6ba","name":"TERMOPERNAMBUCO S/A","commercialName":"","cnpj":"03795050000109","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":"TERMOPE 137 TERMOPERNAMBUCO 8020 UTE.GN.PE.028031-3.01"},{"id":"596403d4-1624-47ef-4f27-08d5ad2bf6ba","name":"BROOKFIELD ENERGIA COMERCIALIZADORA LTDA","commercialName":"","cnpj":"03780401000108","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":"BROOKFIELDC 117"},{"id":"002de5e8-d83c-4d91-4f29-08d5ad2bf6ba","name":"ITAPEBI GERACAO DE ENERGIA SA","commercialName":"","cnpj":"02397080000196","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":"ITAPEBI 119 ITAPEBI - HIDR 568 UHE.PH.BA.001175-4.01"},{"id":"6e672359-d3bc-46f4-4f2a-08d5ad2bf6ba","name":"VALE ENERGIA S.A","commercialName":"","cnpj":"02207392000190","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":"VALE ENERGIA 120"},{"id":"6e67dd13-fd64-4fe6-4f2b-08d5ad2bf6ba","name":"BROOKFIELD ENERGIA RENOVAVEL S.A.","commercialName":"","cnpj":"02808298000196","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":"BROOKFIELD 121 SANTA CANDIDA I 408 UTE.AI.SP.027767-3.01 ANNA MARIA 8033 PCH.PH.MG.000104-0.01 GUARY 8034 PCH.PH.MG.001078-2.01 PARAISO I 8044 PCH.PH.MS.027587-5.01 TRIUNFO 8060 PCH.PH.MG.027532-8.01 SALTO CORGAO 8095 PCH.PH.MT.027326-0.01 PALESTINA 8036 PCH.PH.MG.027727-4.01 NOVA SINCERIDADE 8037 PCH.PH.MG.027207-8.01 BARRA DO BRAUNA 8612 UHE.PH.MG.000215-1.01 MIMOSO 469 UHE.PH.MS.028012-7.01 RIO PEDRINHO I 8008 PCH.PH.PR.002028-1.01 PASSO DO MEIO 8010 PCH.PH.RS.001999-2.01 SALTO NATAL 8011 PCH.PH.PR.027879-3.01 PONTE 8018 PCH.PH.MG.027534-4.01 GRANADA 8019 PCH.PH.MG.001047-2.01 CACH. ENCOBERTA 8035 PCH.PH.MG.027958-7.01 SACRE II 8170 PCH.PH.MT.028796-2.01 SALTO JAURU 8257 PCH.PH.MT.028203-0.01 SANTA EDWIGES I 8267 PCH.PH.GO.028184-0.01 PORTOBELLO-C. ENCANO 8605 PCH.PH.SC.002133-4.01 SANTA ANA 8675 PCH.PH.SC.029778-0.01 CAJU (ENERGISA) 8818 PCH.PH.RJ.029726-7.01 S SEBASTIAO DO ALTO 8883 PCH.PH.RJ.029727-5.01 CRISTINA 8920 PCH.PH.MG.027730-4.01 S.ANTONIO (ENERGISA) 8960 PCH.PH.RJ.029728-3.01 PEZZI 888208 PCH.PH.RS.028988-4.01 ZE TUNIN 888920 PCH.PH.MG.030597-9.01 SERRA CAVALINHOS II 889423 PCH.PH.RS.030337-2.01"},{"id":"e8edfbdd-bc6d-4a9a-4f2c-08d5ad2bf6ba","name":"PETROBRAS COMERCIALIZADORA DE ENERGIA LTDA.","commercialName":"","cnpj":"05195759000190","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":"PBEN 122"},{"id":"99930269-c5a8-4e41-4f66-08d5ad2bf6ba","name":"WHITE MARTINS GASES INDUSTRIAIS LTDA","commercialName":"","cnpj":"35820448000136","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":"WHITE MARTINS 1086 WHITEMARTINS AMERIC 83 WHITE M. CAPUAVA 191 WHITE JAC 193 WHITEMARTINS PAULIN 7139 WHITE M OURO BRANCO 7699 WHITE MARTINS SB 7723 WHITE M BARREIRO 7725 WHITE M DIVINOPOLIS 7727 WHITE M JUIZ DE FORA 7729 WHITE M IGUATAMA 7731 W MARTINS-IPATINGA 7753 W MARTINS-J MONL 7789 WHITEMARTINS PIRAC 70892 W MARTINS-CUBATAO 71773 WHITE MARTINS JECEAB 891722 WHITE MARTINS COPESU 7834 W MARTINS JOINVILLE 71396 WHITEMARTINS R.CLARO 70247 WHITE M CONTAGEM 70559 WHITE MARTINS-CBT 1 71512 WHITE MARTINS-CBT 2 71513 WHITE MART ARAUCARIA 903358 WHITE MARTINS SUZANO 903675 WHITE MARTINS CARBOR 903955 WHITE MARTINS-BETIM 71537"},{"id":"f1ad93ba-d57d-4800-4f62-08d5ad2bf6ba","name":"CIMENTO TUPI SA","commercialName":"","cnpj":"33039223000111","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":"TUPI 1080 CIMENTO TUPI P SINO 7615"},{"id":"f3ff4510-7d83-4b9e-4ef8-08d5ad2bf6ba","name":"CSN ENERGIA S/A","commercialName":"","cnpj":"03537249000129","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":"CSN ENERGIA 37"},{"id":"b7b39493-facb-47b3-4ef9-08d5ad2bf6ba","name":"VALE S.A.","commercialName":"","cnpj":"33592510000154","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":"CVRD 39 VALE - ITABIRA 144 ALEGRIA MARIANA 7232 VALE SA FABRICA 7432 AGUA LIMPA-J MONL 7464 FABRICA NOVA MARIANA 7583 MDR TAMANDUA N LIMA 7773 MINA DE BRUCUTU 70118 VALE S SOSSEGO 70550 VALE CARAJAS 70552 VALE SAO LUIS 70554 MINERACAO ONCA PUMA 70631 VALE PELOT USINA 8 71844 ITABIRITOS CONCEICAO 891304 VALE VARGEM GRANDE 899626 FERTECO FEIJAO 7236 TIMBOPEBA MARIANA 7456 CDM-SANTA LUZIA-MG 7462 GONGO SOCO COCAIS 7463 MBR-MANGARATIBA-RJ 7937 CARAJAS SERRA SUL 890197 SE RECEPTORA I 70034 SE RECEPTORA II 70036 VALE TERMINAIS PORT. 70039 VALE MINA DE AGUAS C 907495 VALE MINA JANGADA 907611 RISOLETA - VALE 8271 UHE.PH.MG.000641-6.01 ESTREITO VALE 8827 UHE.PH.MA.028863-2.01 MELLO 344 PCH.PH.MG.001454-0.01 NOVA MAURICIO 374 PCH.PH.MG.027722-3.01 GLORIA 376 UHE.PH.MG.001034-0.01 ITUERE 377 UHE.PH.MG.001192-4.01"},{"id":"0ba319d7-99e9-45c2-4efc-08d5ad2bf6ba","name":"TERMOMACAE COMERCIALIZADORA DE ENERGIA LTDA","commercialName":"","cnpj":"02290789000198","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":"MACAE COM 45"},{"id":"2e87bf5d-e5d0-4d37-4efe-08d5ad2bf6ba","name":"CENTRAIS ELETRICAS BRASILEIRAS SA","commercialName":"ELETROBRAS ESTABELECIMENTOS UNIFICADOS","cnpj":"00001180000207","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":"ELETROBRAS 47 MARACAI (ACEP) 8180 UTE.AI.SP.001405-2.01 CORURIPE (ACEP) 8128 UTE.AI.AL.029161-7.01 PIONEIROS 8148 UTE.AI.SP.028047-0.01 S TEREZINHA (ACEP) 8152 UTE.AI.PR.028149-2.01 RUETTE 8153 UTE.AI.SP.027345-7.01 AGUA BONITA 8154 UTE.AI.SP.027891-2.01 SAO SIMAO (ACEP) 8518 PCH.PH.ES.028171-9.01 SAPEZAL 8896 PCH.PH.MT.028821-7.01 SETE QUEDAS ALT ACEP 8795 PCH.PH.MT.028853-5.01 TELEGRAFICA 8913 PCH.PH.MT.028820-9.01 TUDELANDIA 8705 PCH.PH.RJ.028798-9.01 SANTA LAURA 8256 PCH.PH.SC.027972-2.01 SANTA ROSA II 8327 PCH.PH.RJ.026732-5.01 SAO BERNARDO (ACEP) 8176 PCH.PH.RS.028431-9.01 S JOAQUIM (ACEP) 8333 PCH.PH.ES.027985-4.01 ZE FERNANDO (ACEP) 8521 PCH.PH.MT.028825-0.01 SAO PEDRO (ACEP) 8525 PCH.PH.ES.028986-8.01 PIRANHAS 8212 PCH.PH.GO.027533-6.01 PLANO ALTO XAVANTINA 8303 PCH.PH.SC.028754-7.01 RETIRO VELHO 8522 PCH.PH.GO.028771-7.01 RONDON 8898 PCH.PH.MT.002547-0.01 SALTO DAS FLORES 8925 PCH.PH.SC.028831-4.01 SANTA FE I 8305 PCH.PH.RJ.028752-0.01 LINHA EMILIA 8523 PCH.PH.RS.027876-9.01 LUDESA (ACEP) 8254 PCH.PH.SC.028801-2.01 MAMBAI II 8439 PCH.PH.GO.028829-2.01 MONTE SERRAT 8520 PCH.PH.RJ.001498-2.01 MOSQUITAO 8211 PCH.PH.GO.028541-2.01 PARECIS 8897 PCH.PH.MT.028819-5.01 FUMACA IV 8453 PCH.PH.ES.027575-1.01 FUNIL (ACEP) 8332 PCH.PH.MG.027645-6.01 DA ILHA 8325 PCH.PH.RS.028725-3.01 IRARA 8392 PCH.PH.GO.001147-9.01 JARARACA 8326 PCH.PH.RS.028715-6.01 JATAI (ACEP) 8378 PCH.PH.GO.028834-9.01 COLINO 1 8391 PCH.PH.BA.029004-1.01 COLINO 2 8361 PCH.PH.BA.028997-3.01 COTIPORA 8455 PCH.PH.RS.027877-7.01 ESMERALDA 8214 PCH.PH.RS.028430-0.01 FIGUEIROPOLIS 8756 PCH.PH.MT.029145-5.01 FLOR SERTAO 8246 PCH.PH.SC.028852-7.01 CACHOEIRA DA LIXA 8336 PCH.PH.BA.028999-0.01 CALHEIROS 8386 PCH.PH.RJ.027672-3.01 CARANGOLA 8345 PCH.PH.MG.027731-2.01 CARLOS GONZATTO 8140 PCH.PH.RS.028030-5.01 CIDEZAL 8895 PCH.PH.MT.028836-5.01 COCAIS GRANDE 8524 PCH.PH.MG.027728-2.01 AQUARIUS 8187 PCH.PH.MS.000859-1.01 AREIA 8901 PCH.PH.TO.028446-7.01 AREIA BRANCA 8643 PCH.PH.MG.027910-2.01 BONFANTE 8374 PCH.PH.MG.000291-7.01 BURITI (ACEP) 8225 PCH.PH.MS.028753-9.01 CACADOR 8403 PCH.PH.RS.027878-5.01 CONVERSORA MELO 896404 RIVERA E MELO BLOCO1 909151 RIVERA E MELO BLOCO2 909152 AGUA LIMPA 8792 PCH.PH.TO.028447-5.01 ALTO IRANI 8404 PCH.PH.SC.028748-2.01 ALTO SUCURIU 8402 PCH.PH.MS.028817-9.01 RIO DO FOGO 8163 EOL.CV.RN.028424-6.01 OSORIO 8164 EOL.CV.RS.028810-1.01 CANAA 8177 UTE.AI.SP.029138-2.01 GOIASA 8178 UTE.AI.GO.028118-2.01 ITAIPU 416 UHE.PH.PR.001161-4.01 CONV. RIVERA 384 SEN JONAS PINHEIRO 8184 PCH.PH.MT.028393-2.01 SANGRADOURO 8188 EOL.CV.RS.028811-0.01 JB AC E ALC 8189 UTE.AI.PE.028392-4.01 GIASA II 8192 UTE.AI.PB.028957-4.01 MANDU PROINFA 8155 UTE.AI.SP.027787-8.01 JALLES MACH -ACEP 8162 UTE.AI.GO.028112-3.01 CANOA QUEBR (H-ACEP) 8213 PCH.PH.MT.000646-7.01 JOSE GELASIO ROCHA 8226 PCH.PH.MT.028845-4.01 PONTE ALTA 8239 PCH.PH.MS.029013-0.01 FART MEND - ACEP 8252 UTE.AI.SP.029203-6.01 AGUA DOCE 8181 EOL.CV.SC.028793-8.01 CATANDUVA -ACEP 8182 UTE.AI.SP.028042-9.01 MILLENNIUM 8265 EOL.CV.PB.029041-6.01 JITITUBA 8275 UTE.AI.AL.028708-3.01 RONDONOPOLIS 8278 PCH.PH.MT.028848-9.01 IOLANDO LEITE 8283 UTE.AI.SE.029152-8.01 VOLTA GRANDE-ACEP 8193 UTE.AI.MG.028540-4.01 INDIOS 8210 EOL.CV.RS.028864-0.01 LAGOA GRANDE 8390 PCH.PH.TO.029057-2.01 BEBERIBE - ACEP 8393 EOL.CV.CE.028174-3.01 TAIBA ALBATROZ 8437 EOL.CV.CE.028858-6.01 BOA SORTE 8438 PCH.PH.TO.029060-2.01 PARACURU (ACEP) 8440 EOL.CV.CE.028706-7.01 USACIGA 8263 UTE.AI.PR.029144-7.01 PEDRA DO SAL 8456 EOL.CV.PI.028731-8.01 ALBATROZ 8507 EOL.CV.PB.029085-8.01 ATLANTICA 8508 EOL.CV.PB.029088-2.01 CAMURIM 8509 EOL.CV.PB.029084-0.01 CARAVELA 8510 EOL.CV.PB.029089-0.01 RIACHO PRETO 8389 PCH.PH.TO.029058-0.01 COELHOS II 8512 EOL.CV.PB.029090-4.01 COELHOS III 8513 EOL.CV.PB.029087-4.01 COELHOS IV 8514 EOL.CV.PB.029091-2.01 MATARACA 8515 EOL.CV.PB.029092-0.01 PRESIDENTE 8516 EOL.CV.PB.029083-1.01 CANOAQUBR(E-RV-ACEP) 8450 EOL.CV.CE.028649-4.01 FOZ DO RIO CHORO 8519 EOL.CV.CE.028630-3.01 PRAIAS DE PARAJURU 8584 EOL.CV.CE.028724-5.01 PRAIA FORMOSA 8585 EOL.CV.CE.028631-1.01 ICARAIZINHO 8602 EOL.CV.CE.028699-0.01 PORTO FRANCO 8604 PCH.PH.TO.029059-9.01 COELHOS I 8511 EOL.CV.PB.029086-6.01 BONS VENTOS 8627 EOL.CV.CE.028887-0.01 ENACEL 8645 EOL.CV.CE.028770-9.01 SAO LUIZ -ACEP 8754 UTE.AI.SP.026869-0.01 XAVANTE POMBOS 8677 EOL.CV.PE.029011-4.01 GRAVATA 8678 EOL.CV.PE.029020-3.01 LAGOA DO MATO 8517 EOL.CV.CE.028652-4.01 SANTA MARIA 8680 EOL.CV.PE.029019-0.01 PIRAUA MACAPARANA 8685 EOL.CV.PE.028481-5.01 PRAIA DO MORGADO 8691 EOL.CV.CE.028440-8.01 VOLTA DO RIO 8743 EOL.CV.CE.028441-6.01 GARGAU 8755 EOL.CV.RJ.028730-0.01 CANOAQUBR(E-BV-ACEP) 8620 EOL.CV.CE.028788-1.01 VITORIA 8785 EOL.CV.PB.029075-0.01 SAO TADEU I 8796 PCH.PH.MT.028806-3.01 PARQUE EOL PALMARES 8797 EOL.CV.RS.028855-1.01 ALEGRIA I 8798 EOL.CV.RN.028444-0.01 ELEBRAS CIDREIRA 1 8850 EOL.CV.RS.028712-1.01 MANDACARU 8679 EOL.CV.PE.029015-7.01"},{"id":"de412b62-5f7f-4052-4f06-08d5ad2bf6ba","name":"FURNAS-CENTRAIS ELETRICAS S.A.","commercialName":"FURNAS - SEDE - ESCRITORIO CENTRAL","cnpj":"23274194000119","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":"FURNAS 56 PORTO COLOMBIA 204 UHE.PH.MG.002117-2.01 MARIMBONDO 205 UHE.PH.MG.001417-6.01 FURNAS 201 UHE.PH.MG.001007-3.01 FUNIL (FURNAS) 207 UHE.PH.RJ.027118-7.01 ESTREITO 203 UHE.PH.SP.000917-2.01 CORUMBA I - FURNAS 209 UHE.PH.GO.000866-4.01 CAMPOS 211 UTE.GN.RJ.027935-8.01 MANSO 450 UHE.PH.MT.001401-0.01 SANTA CRUZ NOVA EXP 88063 UTE.GN.RJ.027243-4.01 BATALHA 8542 UHE.PH.MG.029454-3.01 SIMPLICIO ANTA 8543 UHE.PH.MG.029458-6.01 SANTA CRUZ NOVA 8063 UTE.GN.RJ.027243-4.01 PEIXOTO 202 UHE.PH.MG.002038-9.01 ITUMBIARA (FURNAS) 206 UHE.PH.MG.001194-0.01 SERRA DA MESA 208 UHE.PH.GO.002731-6.01 SANTA CRUZ-FURNAS 210 UTE.GN.RJ.027243-4.01 SANTA CRUZ FRN EXP. 80210 UTE.GN.RJ.027243-4.01"},{"id":"bf7d6f0f-e2ff-4556-4f08-08d5ad2bf6ba","name":"NC ENERGIA S.A.","commercialName":"NC ENERGIA","cnpj":"04023261000188","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":"NC ENERGIA 58 SERRA GRANDE 287 UTE.AI.AL.028543-9.01 ORIENTAL 288 PCH.PH.AL.028557-9.01 CUCAU 294 UTE.AI.PE.028558-7.01 PEDROSA 540 CGH.PH.PE.028359-2.01 TRAPICHE 542 PCH.PH.PE.028091-7.01 CORURIPE ACU ALCOOL 8860 UTE.AI.MG.030533-2.01 ENERGETICA C FLORIDO 8370 UTE.AI.MG.029703-8.01 CORURIPE C FLORIDO 8117 UTE.AI.MG.028478-5.01 SANTA LUZIA (NC ) 8946 CGH.PH.BA.030590-1.01 CORURIPE ITURAMA 8208 UTE.AI.MG.028479-3.01 CARNEIRINHO 8349 UTE.AI.MG.029619-8.01 VARGIDO 8353 CGH.PH.BA.029699-6.01 JULIANA I 8354 CGH.PH.BA.029698-8.01 JULIANA II 8355 CGH.PH.BA.029697-0.01"},{"id":"0b7ba5e8-070a-46ee-4f0c-08d5ad2bf6ba","name":"LIGHT SERVICOS DE ELETRICIDADE S A","commercialName":"ESTABELECIMENTO UNIFICADO","cnpj":"60444437000146","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":"LIGHT 64 LIGHT 2 LIGHT DITC AMP-LIGH 72307"},{"id":"2096a613-532e-4ddf-4f8a-08d5ad2bf6ba","name":"SOCIEDADE MICHELIN DE PARTICIPACOES INDUST E COMERCIO LTDA","commercialName":"","cnpj":"50567288000159","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":"MICHELIN 1150 MICHELIN C GRANDE 70216 MICHELIN RESENDE 71758"},{"id":"f8f0a43e-78d8-4aa0-4f88-08d5ad2bf6ba","name":"LAFARGEHOLCIM (BRASIL) S.A.","commercialName":"LAFARGEHOLCIM","cnpj":"60869336000117","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":"HOLCIM 1148 HOLCIM PLEOPOLDO LIV 7619 HOLCIM-BARROSO-MG 7621 LAFARGE BR-CANTAGALO 7216 LAFARGE M CLAROS 7673 HOLCIM BRASIL - SERR 905572 CIPASA-CAAPORA 7442 CACH DOS MACACOS 8495 CGH.PH.MG.028381-9.02"},{"id":"063c95b4-8f23-4b07-4f94-08d5ad2bf6ba","name":"PETROBRAS TRANSPORTE S.A - TRANSPETRO","commercialName":"TRANSPETRO","cnpj":"02709449000159","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":"TRANSPETRO 1165 PETROB SSE 7062 PETROB RIP 7067 PETROB GUA 7068 TRANSPETRO ANGRA 7310 ETC TRANSPETRO ALEMO 7350 PETROBRASC ELISEOS 7565 TRANSPETRO-S ISABEL 71675 TRANSPETRO TAPINHOA 889958 TRANSPETRO ITA-PR 7862 TRANSPETRO-S.FR.SUL 70167 TRANSPETRO T OSORIO 891222 TEMADRE BA 70061"},{"id":"a0c30170-6d27-4d6f-4fae-08d5ad2bf6ba","name":"ENGUIA GEN CE LTDA","commercialName":"","cnpj":"04735629000130","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":"ENGUIA GEN CE 1227 ENGUIA PECEM EXP. 80394 UTE.PE.CE.028533-1.01 ARACATI EXP. 80390 UTE.PE.CE.028531-5.01 BATURITE EXP. 80391 UTE.PE.CE.028529-3.01 CAUCAIA EXP. 80392 UTE.PE.CE.028528-5.01 CRATO EXP. 80393 UTE.PE.CE.028530-7.01 IGUATU EXP. 80395 UTE.PE.CE.028532-3.01 IGUATU 395 UTE.PE.CE.028532-3.01 JUAZEIRO DO NORTE 396 UTE.PE.CE.028534-0.01 JUAZEIRO NORTE EXP. 80396 UTE.PE.CE.028534-0.01 ARACATI 390 UTE.PE.CE.028531-5.01 BATURITE 391 UTE.PE.CE.028529-3.01 CAUCAIA 392 UTE.PE.CE.028528-5.01 CRATO 393 UTE.PE.CE.028530-7.01 ENGUIA PECEM 394 UTE.PE.CE.028533-1.01"},{"id":"91f478d0-74ed-42be-5096-08d5ad2bf6ba","name":"BAGUARI I GERACAO DE ENERGIA ELETRICA S.A.","commercialName":"","cnpj":"07799995000141","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":"BAGUARI 1739 BAGUARI-BAGUARI 8548 UHE.PH.MG.029453-5.01"},{"id":"e1c64709-8599-4706-50ac-08d5ad2bf6ba","name":"TELEMAR NORTE LESTE S/A. - EM RECUPERACAO JUDICIAL","commercialName":"OI","cnpj":"33000118000179","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":"TELEMAR 1778 TELEMAR PRAIA 70126 TELEMAR BOTAFOGO 70127 TELEMAR POLIDORO 70128 TELEMAR IPANEMA 70130 TELEMAR LEBLON 70131 TELEMAR FLORIANO 70132 TELEMAR S RITA 70133 TELEMAR TIRADENTES 70134 TELEMAR ARCOS 70135 TELEMAR CID NOVA 70136 TELEMAR ENG DENTRO 70137 TELEMAR TIJUCA 70138 TELEMAR ENGENHO NOVO 70139 TELEMAR COLEGIO 70140 TELEMAR IRAJA 70141 TELEMAR RAMOS 70142 TELEMAR BENTO RIBEIR 70143 TELEMAR DUQUE CAXIAS 70144 TELEMAR NOVA IGUACU 70145 TELEMAR CID DEUS 70146 TELEMAR MARACANA 70147 TAMOIOS 70572 DOIS DE DEZEMBRO 71079 TELEMAR ZACARIAS 71080 TELEMAR-PIRAPETINGA 71713 TELEMAR M CAMPOS 71832 TELEMAR M AVIDOS 71863 TELEMAR COST PEREIRA 889003 TELEMAR ROSARIO 889004 TELEMAR 400027022 899670 TELEMAR 400123340 900176 TELEMAR CABO AILSON 900454 TELEMAR 3009001092 900993 TELEMAR JULIO DINIZ 901202 PAULO E SILVA 902616 TELEMAR 400167614 902682 TELEMAR 400171085 902916 TELEMAR 3009014745 903775 TELEMAR PECHINCHA 904036 TELEMAR DELFIM MOREI 904693 BARAO DO RIO BRANCO 904769 TELEMAR 1066281 905586 TELEMAR GAL BRUCE 907579 TELEMAR SAO PEDRO 907718 TELEMAR BERNARDO GM 909249 10 DE MAIO 911178 MARICA 911235 SAO JANUARIO - NITER 911236 FRANCISCO PORTELA 911237 LEMOS CUNHA 911254 FLORIANO PEIXOTO 911322 RAUL POMPEIA - ANGRA 911672 TELEMAR P.MORAIS 70238 TELEMAR JOAQUIM FELI 70266 TELEMAR BOA VIAGEM 70289 TORRES CAMARA 70871 TELEMAR SILVEIRA MAR 899365 OI PROF TEODORICO 908082 TELEMAR ARQUIME GONC 70268 TELEMAR PITUBA LIVRE 70269 BOLANDEIRA 71246 GETULIO VARGAS 71247 TELEMAR LEME 70129 TELEMAR S PEDRO-NTR 70940 IMPERATRIZ ITZ 906602 TAVARES BASTOS 910817 BRAZ DE AGUIAR 910818 LAGARTO - SE 913171 HERMES FONTES - SE 913191 JOAQUIM FELICIO 913471 JAPAO 913493 PRESIDENTE KUBITSCHE 913511"},{"id":"c56a809f-d1d0-4510-50b0-08d5ad2bf6ba","name":"ENERGISA COMERCIALIZADORA DE ENERGIA LTDA.","commercialName":"","cnpj":"07685694000197","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":"ENERGISA COM 1784 HANS 889989 CGH.PH.RJ.001083-9.01"},{"id":"7d108c2c-3692-4a77-50c4-08d5ad2bf6ba","name":"GLOBO COMUNICACAO E PARTICIPACOES S/A","commercialName":"GCP,TV GLOBO, REDE GLOBO, GLOBO.COM, SOM LIVRE","cnpj":"27865757000102","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":"TV GLOBO 1833 TV GLOBO J BOTANICO 70226 GLOBO COM. PART. 70300 TV GLOBO RJ 892550 GLOBO SUMARE 898065 TV GLOBO LOPES 898096 GLOBO JARAGUA 898186 TV GLOBO PQ RIA 898469 S CURRAL 3009004400 910283 GLOBO COMUNICACAO 910371 TV GLOBO PROJAC 898318 TV GLOBO 3191451 902625 GLOBO MORRO PELUDO 902662"},{"id":"b398eed8-8c34-464f-510b-08d5ad2bf6ba","name":"CONDOMINIO DO CENTER SHOPPING - RIO","commercialName":"","cnpj":"04299191000195","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":"CENTER RIO 1958 CENTER RIO MTZ 70323"},{"id":"225c1c15-8e52-4733-5112-08d5ad2bf6ba","name":"CONDOMINIO BOULEVARD RIO SHOPPING","commercialName":"BOULEVARD RIO SHOPPING","cnpj":"04814282000111","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":"IGUATEMI RIO 1983 IGUATEMI RJ 70368"},{"id":"930fa189-5a08-45c6-50e9-08d5ad2bf6ba","name":"ELETROBRAS TERMONUCLEAR S.A. - ELETRONUCLEAR","commercialName":"","cnpj":"42540211000167","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":"ELETRONUCLEAR 1901 ANGRA I 417 UTN.UR.RJ.000100-7.01 ANGRA II 418 UTN.UR.RJ.000101-5.01"},{"id":"3b25faf5-ec32-4990-5061-08d5ad2bf6ba","name":"DIFERENCIAL COMERCIALIZADORA DE ENERGIA LTDA","commercialName":"","cnpj":"07393256000155","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":"DIFERENCIAL 1600"},{"id":"475987d8-addc-4878-5066-08d5ad2bf6ba","name":"LIGHT ENERGIA S.A","commercialName":"","cnpj":"01917818000136","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":"LIGHT ENERGIA 1608 FONTES NOVA A+BC+SC 889778 UHE.PH.RJ.000973-3.01 NILO PECANHA+VIGARIO 889779 UHE.PH.RJ.001536-9.01, UHE.PH.RJ.002982-3.01 PEREIRA PASSOS 245 UHE.PH.RJ.002043-5.01 ILHA DOS POMBOS 246 UHE.PH.RJ.001113-4.01 STA BRANCA 247 UHE.PH.SP.002696-4.01"},{"id":"3b80fa27-61ad-4223-505e-08d5ad2bf6ba","name":"VULCAN MATERIAL PLASTICO LTDA. EM RECUPERACAO JUDICIAL","commercialName":"","cnpj":"33066952000167","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":"VULCAN 1590 VULCAN COLEGIO 70028"},{"id":"fd867625-e7b4-49e9-5080-08d5ad2bf6ba","name":"HNK BR BEBIDAS LTDA.","commercialName":"","cnpj":"02864417000128","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":"HEINEKEN RJ MATRIZ 1660 SCHINCARIOL-MACACU 70080 SCHINCARIOL-HORIZ 71504 SCHINCARIOL BENEV 72200 SCHINCARIOL-CAXIAS 72335"},{"id":"ff22f9ba-4bb4-4513-508a-08d5ad2bf6ba","name":"LIGHT ESCO - PRESTACAO DE SERVICOS S.A.","commercialName":"","cnpj":"73688855000120","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":"LIGHT ESCO 1684 RJR RESERVA 893722 LIGHT ESCO PRESTACAO 899688 RJR 891602 UTE.GN.RJ.031153-7.01"},{"id":"67122587-d6f4-4e2c-5094-08d5ad2bf6ba","name":"GERDAU ACOS LONGOS S.A.","commercialName":"GERDAU COSIGUA","cnpj":"07358761000169","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":"GALB 1733 GERDAU DIVINOPOLIS 7737 GERDAU B COCAIS 7739 GERDAU ARACARIGUAMA 7829 GERDAU COSIGUA SCRUZ 70094 GALB-SJC 72019 GALB COTIA 906769 GERDAU ACOSLONGOS-PE 7461 GERDAU-MARACANAU-CE 70010 GERDAU ACOSLONGOS-BA 70012 GERDAU SAPUCAIA SUL 71751 GERDAU-ARAUCARIA PR 71831 GERDAU GRU 899309 BARRA DOS COQUEIROS 8693 UHE.PH.GO.028757-1.01 CACU (GALB) 8699 UHE.PH.GO.028756-3.01"},{"id":"5c453138-cfca-47a7-508d-08d5ad2bf6ba","name":"ENGUIA GEN PI LTDA","commercialName":"","cnpj":"04735623000163","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":"ENGUIA GEN PI 1713 ALTOS EXP. 80589 UTE.PE.PI.028538-2.01 NAZARIA EXP. 80590 UTE.PE.PI.028536-6.01 MARAMBAIA EXP. 80591 UTE.PE.PI.028535-8.01 CAMPO MAIOR EXP. 80592 UTE.PE.PI.028537-4.01 ALTOS 589 UTE.PE.PI.028538-2.01 NAZARIA 590 UTE.PE.PI.028536-6.01 MARAMBAIA 591 UTE.PE.PI.028535-8.01 CAMPO MAIOR 592 UTE.PE.PI.028537-4.01"},{"id":"8ce1ef4e-97cc-48c6-5282-08d5ad2bf6ba","name":"CONDOMINIO DO EDIFICIO RIO SUL CENTER","commercialName":"RIO SUL","cnpj":"28128791000159","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":"RIO SUL 3097 COND RIO SUL CENTER 70866"},{"id":"624e1c81-9d51-435d-5290-08d5ad2bf6ba","name":"DIX ADMINISTRACAO E EMPREENDIMENTOS IMOBILIARIOS LTDA","commercialName":"","cnpj":"33010836000126","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":"DIX 3147 DIX-RJ 70918"},{"id":"a7991805-0c9b-499a-5359-08d5ad2bf6ba","name":"CONDOMINIO SAO CONRADO FASHION MALL","commercialName":"","cnpj":"29269610000177","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":"FASHION MALL 3591 SC FASHION MALL 71180"},{"id":"58a9c3fe-bc17-4bc3-534d-08d5ad2bf6ba","name":"CONCESSAO METROVIARIA DO RIO DE JANEIRO S.A.","commercialName":"","cnpj":"10324624000118","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":"METRO-RIO 3567 METRO BOTAFOGO RIO 7265 METRO FREI CANECA 7266 METRO COLEGIO 7267 METRO RIO DE JANEIRO 902253"},{"id":"cc366993-1f46-49c1-5302-08d5ad2bf6ba","name":"BSC SHOPPING CENTER SA","commercialName":"","cnpj":"04556724000177","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":"BSC SHOPPING 3430 BSC SHOPPING 899087"},{"id":"55b7a212-1d56-476b-5315-08d5ad2bf6ba","name":"METALISUL INDUSTRIA E COMERCIO LTDA","commercialName":"","cnpj":"11590543000122","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":"METALISUL 3472 METALISUL 75"},{"id":"e2bcf0d6-a35c-4df6-51ba-08d5ad2bf6ba","name":"ENERGIA SUSTENTAVEL DO BRASIL S.A.","commercialName":"","cnpj":"09029666000147","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":"ESBR 2553 JIRAU 890337 UHE.PH.RO.029736-4.01 AMPLIACAO JIRAU 891284 UHE.PH.RO.029736-4.01"},{"id":"dae040dc-32d5-4314-5218-08d5ad2bf6ba","name":"EDIGRAFICA GRAFICA E EDITORA LTDA","commercialName":"EDIGRAFICA","cnpj":"04218430000135","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":"EDIOURO 2868 EDIOURO 70756"},{"id":"b983fbc3-cfc0-408f-5126-08d5ad2bf6ba","name":"TERNIUM BRASIL LTDA.","commercialName":"","cnpj":"07005330000119","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":"DO ATLANTICO 2023 DO ATLANTICO COSMOS 70754 DO ATLANTICO APE 8692 UTE.PE.RJ.029587-6.01 DO ATLANTICO PIE 8770 UTE.PE.RJ.029587-6.01"},{"id":"52d5104b-ce1d-43d7-5129-08d5ad2bf6ba","name":"CERVEJARIA PETROPOLIS S/A","commercialName":"","cnpj":"73410326000160","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":"CP MATRIZ 2026 CP PETROPOLIS-RJ 70903 CP BTV LABRON 902133 CP BTV REFEITORIO 904535 CP BTV BELACOR 904536 CP BTV ACADEMIA 904537 CP BTV CONDOMINIO 904538 CP BTV CHACARA 904539 CP BTV CRYSTAL 21 904540 CP BTV CRYSTAL 22 904729 CP PTR FAZENDA 901713 CP PTR ETDI 901733 CP BTV REVENDA 904534 CP SCV REVENDA 907873 CP TERESOPOLIS - RJ 904752 PETROPOLIS CAMBE 907800 CERVEJ PETROPOLIS 904730 CERV PETROPOLIS ARAU 907380 CERV PETROPOLIS BARR 908028 CP BOITUVA 70403"},{"id":"9f5b4ea4-82a6-409f-51a7-08d5ad2bf6ba","name":"GERACAO CIII S/A","commercialName":"","cnpj":"08274591000105","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":"GERACAO CIII 2471 CORUMBA III-GCIII 8594 UHE.PH.GO.028352-5.01"},{"id":"79cab598-d8d4-4e18-51a1-08d5ad2bf6ba","name":"CONDOMINIO DO SHOPPING CENTER DA BARRA","commercialName":"","cnpj":"28248086000195","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":"BARRA SHOPPING 2444 BARRA SHOPPING UC 70607 BARRA SHOPP UC67962 70632 BARRA SHOPP UC68098 70753 BARRA SHOPPING EXP 7 908508"},{"id":"50847aff-e31c-4674-519c-08d5ad2bf6ba","name":"ENEVA COMERCIALIZADORA DE ENERGIA LTDA","commercialName":"","cnpj":"09185485000100","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":"ENEVA COM 2430"},{"id":"05ae83e7-23b6-4acb-517a-08d5ad2bf6ba","name":"TERMELETRICA VIANA S/A","commercialName":"TEVISA","cnpj":"09043782000110","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":"UTE VIANA 2199 VIANA 8563 UTE.PE.ES.029664-3.01"},{"id":"16387e83-73f6-481d-5f4f-08d5ad2bf6ba","name":"CONDOMINIO EDILICIO DO AMERICAS SHOPPING","commercialName":"","cnpj":"20748818000102","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":"AMERICAS SHOPPING 52899 AMERICAS SHOPPING RJ 901293"},{"id":"d5224dea-340d-4999-5f55-08d5ad2bf6ba","name":"CONDOMINIO DO WEST SHOPPING - RIO","commercialName":"","cnpj":"01946522000143","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":"WEST SHOPPING 52905 WEST SHOPPING 900855"},{"id":"eca97602-cb4a-40dd-5f8d-08d5ad2bf6ba","name":"BRASILCENTER COMUNICACOES LTDA","commercialName":"","cnpj":"02917443000177","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":"BRASIL CENTER 53019 BRASIL CENTER DOLORE 904226 BRASIL CENTER R SOL 904274"},{"id":"e08efd2c-9cd1-4032-5fb5-08d5ad2bf6ba","name":"PRINCESA AUTO SERVICO DE COMESTIVEIS LTDA","commercialName":"","cnpj":"27833615000155","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":"PRINCESA SUPERMERCADOS 53192 PRINCESA ARRAIAL CAB 903080 PRINCESA FONSECA 903081 PRINCESA CABO FRIO 903082 PRINCESA INGA 903083 PRINCESA BACAXA 903084 PRINCESA SUP ARARUAM 903093 PRINCESA MARICA 903094 COPACABANA 134 908109 PRINCESA-PENHA 908253 PRINC COPACABANA 34 908255 LARANJEIRAS 218 908542 FLAMENGO 908543 PRINCESA PECHINCHA 908585 LARANJEIRAS 519 908688 PRINCESA CATETE 908744"},{"id":"389e78f7-6259-49fb-6083-08d5ad2bf6ba","name":"L'OREAL BRASIL COMERCIAL DE COSMETICOS LTDA","commercialName":"L'OREAL BRASIL","cnpj":"30278428000161","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":"LOREAL BRASIL 53575 LOREAL DUQUE DE CAX 905915"},{"id":"1aab4369-ad0d-4d02-6092-08d5ad2bf6ba","name":"CEZANNE EMPREENDIMENTOS E PARTICIPACOES LTDA.","commercialName":"CEZANNE EMPREENDIMENTOS E PARTICIPACOES LTDA.","cnpj":"14750461000196","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":"CARIOCA SHOPPING CL 53604 CEZANNE EMP E PARTIC 906331"},{"id":"d7b4916f-a898-439e-60fc-08d5ad2bf6ba","name":"SHELL BRASIL PETROLEO LTDA","commercialName":"","cnpj":"10456016000167","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":"SHELL BRASIL 53943 SHELL-ICOLUB 72274"},{"id":"82328279-7e44-421b-6102-08d5ad2bf6ba","name":"NISSAN DO BRASIL AUTOMOVEIS LTDA","commercialName":"","cnpj":"04104117000842","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":"NISSAN 53954 NISSAN RESENDE 900847"},{"id":"6278e817-98d3-49c0-6008-08d5ad2bf6ba","name":"FABRIMAR S A INDUSTRIA E COMERCIO","commercialName":"","cnpj":"33064262000179","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":"FABRIMAR 53354 FABRIMAR 903936 FIBRAMAR 2 903962"},{"id":"efcace59-8ac3-419c-604e-08d5ad2bf6ba","name":"GOL LINHAS AEREAS S.A.","commercialName":"","cnpj":"07575651000159","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":"GOL MATRIZ 53458 SE VRG GOL 902295 GOL TANCREDO NEVES 904760"},{"id":"9e82f0f7-9a52-40da-5d24-08d5ad2bf6ba","name":"PIRAPORA V ENERGIAS RENOVAVEIS S.A.","commercialName":"","cnpj":"23842814000179","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":"PIRAPORA V ENERGIAS 51716 PIRAPORA 5 909757 UFV.RS.MG.033188-0.01"},{"id":"b8cec00d-e0c0-44b6-5d33-08d5ad2bf6ba","name":"PIRAPORA VII ENERGIAS RENOVAVEIS S.A.","commercialName":"","cnpj":"23852003000159","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":"PIRAPORA VII ENERGIAS 51733 PIRAPORA 7 909759 UFV.RS.MG.033190-2.01"},{"id":"d45d9c4d-a6bb-449c-5d34-08d5ad2bf6ba","name":"PIRAPORA X ENERGIAS RENOVAVEIS S.A.","commercialName":"","cnpj":"23842888000105","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":"PIRAPORA X ENERGIAS 51734 PIRAPORA 10 909761 UFV.RS.MG.033193-7.01"},{"id":"42178881-afac-4510-5d37-08d5ad2bf6ba","name":"PIRAPORA VI ENERGIAS RENOVAVEIS S.A.","commercialName":"","cnpj":"23851950000125","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":"PIRAPORA VI ENERGIAS 51738 PIRAPORA 6 909758 UFV.RS.MG.033189-9.01"},{"id":"d0c8f9e7-6951-4a6a-5d38-08d5ad2bf6ba","name":"PIRAPORA IX ENERGIAS RENOVAVEIS S.A.","commercialName":"","cnpj":"23842939000107","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":"PIRAPORA IX ENERGIAS 51739 PIRAPORA 9 909760 UFV.RS.MG.033192-9.01"},{"id":"9331c859-ffa4-434c-5d4f-08d5ad2bf6ba","name":"SERTAO I SOLAR ENERGIA SPE LTDA.","commercialName":"SERTAO I SPE","cnpj":"23907723000174","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":"SERTAO I SOLAR 51778 SERTAO 1 909889 UFV.RS.PI.034384-6.01"},{"id":"466ea8d6-0b9e-4f91-5d50-08d5ad2bf6ba","name":"SOBRAL I SOLAR ENERGIA SPE LTDA.","commercialName":"SOBRAL I SPE","cnpj":"23912366000132","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":"SOBRAL I SOLAR 51779 SOBRAL 1 909890 UFV.RS.PI.034388-9.01"},{"id":"c14df8f1-8697-46a3-5c8e-08d5ad2bf6ba","name":"M. M. A BARATEIRA DE MADUREIRA COMERCIO DE ROUPAS EM GERAL LTDA","commercialName":"GRIPPON ROUPAS","cnpj":"09039219000179","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":"MADUREIRA 51382 MMA BARATEIRA ROUPAS 906633"},{"id":"63595f2e-cec2-4119-5cc3-08d5ad2bf6ba","name":"CONDOMINIO VENTURA CORPORATE TOWERS","commercialName":"","cnpj":"11605833000100","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":"CONDOMINIO VENTURA 51562 VENTURA TORRE LESTE 899765 CONDOMINIO VENTURA 906240"},{"id":"499b9adf-0f20-4249-5dce-08d5ad2bf6ba","name":"CONCESSIONARIA AEROPORTO RIO DE JANEIRO S.A.","commercialName":"","cnpj":"19726111000108","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":"RIOGALEAO 51992 RIOGALEAO AERO 900021"},{"id":"bed3b2b9-4a31-4b92-5dbe-08d5ad2bf6ba","name":"CONDOMINIO RECREIO SHOPPING CENTER","commercialName":"","cnpj":"02210210000130","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":"RECREIO SHOPPING 51973 RECREIO SHOP CENTER 902675"},{"id":"e1e02a3e-409f-4a5d-5dbf-08d5ad2bf6ba","name":"CONDOMINIO DO VIA BRASIL SHOPPING RIO","commercialName":"","cnpj":"13726639000109","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":"VIA BRASIL 51974 VIA BRASIL SHOPPING 901512"},{"id":"2459758f-c78b-4377-5dec-08d5ad2bf6ba","name":"LIMPPANO S A","commercialName":"","cnpj":"33033556000133","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":"LIMPPANO 52070 LIMPPANO SA 901098"},{"id":"5b523f71-f12e-41ca-5e5c-08d5ad2bf6ba","name":"CASA GRANADO LABORATORIOS FARMACIAS E DROGARIAS S A","commercialName":"","cnpj":"33109356000117","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":"GRANADO 52340 CASA GRANADO 901794 PONTELAND JAPERI RJ 906347 CASA GRANADO BELEM 902199"},{"id":"ce6da900-f5c3-4fd0-5e51-08d5ad2bf6ba","name":"LOJAS AMERICANAS S.A.","commercialName":"","cnpj":"33014556000196","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":"LASA MATRIZ 52329 LASA LOJA 69 904902 LASA LOJA 12 904950 LASA LOJA 32 904973 LOJA 36 A 906241 LASA LOJA 16 906921 LASA LOJA 165 907094 LASA LOJA 61 907412 LASA LOJA 38 907500 LASA LOJA 132 II 907593 LASA LOJA 155 907623 LASA LOJA 125 907624 LASA LOJA 08 907744 LASA LOJA 21 907819 LASA LOJA 9 907972 LASA LOJA 150 908046 LASA LOJA 1 908305 LASA LOJA 180 908451 LASA LJ 29 908536 LASA LOJA 57 908566 LASA LOJA 67 908629 LASA LOJA 46 908649 LOJA 31L 908704 LASA LOJA 65 909075 LASA LOJA 24 909180 LASA LOJA 85 I 909223 LASA LOJA 19 I 909277 LASA LOJA 54 909279 LASA - LOJA 173 909846 SPSIG-ALLAS03 909851 LASA LOJA 103 909936 LASA LOJA 138 910008 LASA LOJA 151 910048 LASA LOJA 23 I 910284 LASA LOJA 3 910305 LASA LOJA 220 910334 LASA LOJA 47 910368 LASA LOJA 148 910387 LASA LOJA 37 910618 LASA LOJA 45 910821 LASA LOJA 308 910841 LASA LOJA 464 910842 LASA LOJA 187 910856 LASA LOJA 387 911223 LASA LOJA 307 911301 LASA LOJA 294 911391 LOJA 40I 911700 LASA LOJA 48 911901 LASA LOJA 184 912034 LASA LOJA 59 912481 LASA LOJA 159 912512 LASA LOJA 41 912799 LASA LOJA 15 912800 LASA LOJA 63 913432"},{"id":"66ace64c-6f40-4db9-5e4a-08d5ad2bf6ba","name":"CASA & VIDEO RIO DE JANEIRO S.A.","commercialName":"","cnpj":"11114284000163","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":"CASA E VIDEO RJ 52321 CASA & VIDEO RJ ADM 906839 CASA & VIDEO RJ CXS 906861 CASA E VIDEO CAMPO G 907304 CASA & VIDEO RJ - CD 913337"},{"id":"17d0e1e3-2a66-40ce-5c4e-08d5ad2bf6ba","name":"CONDOMINIO CIVIL VOLUNTARIO DO PARQUE SHOPPING SULACAP","commercialName":"PARQUE SHOPPING SULACAP","cnpj":"12772196000111","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":"SULACAP 51257 SHOPPING SULACAP 899281"},{"id":"7da587ce-c3fb-444c-5c79-08d5ad2bf6ba","name":"CONDOMINIO DO SHOPPING LEBLON","commercialName":"","cnpj":"08471923000133","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":"SHOPPING LEBLON 51336 SHOPPING LEBLON RJ 899139"},{"id":"88babf3c-4784-45ca-5c69-08d5ad2bf6ba","name":"ADMINISTRADORA SHOPPING NOVA AMERICA LTDA","commercialName":"","cnpj":"00078218000169","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":"SHOPPING NOVA AMERICA 51303 SHOPPING NOVA 899006 SHOP NOVA AMERICA 902709"},{"id":"4fe7e1b3-0f00-47fc-5c0c-08d5ad2bf6ba","name":"IMPAR SERVICOS HOSPITALARES S/A","commercialName":"HOSPITAL SAO LUCAS","cnpj":"60884855001630","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":"HSLC IMPAR 51045 HSLC-RIO DE JANEIRO 71516"},{"id":"db250814-8c52-4c5c-5b82-08d5ad2bf6ba","name":"DRIFT COMERCIO DE ALIMENTOS S/A.","commercialName":"SUPERMERCADO CARONE","cnpj":"28129260000180","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":"SUPERMERCADOS CARONE 50737 CARONE GAIVOTAS 899182 CARONE JD CAMBURI 899183 CARONE JD DA PENHA 899191 CARONE STA LUCIA 899192 CARONE COQUEIRAL 899193 CARONE CAMPO GRANDE 899194 CARONE ITAPOA 899196 CARONE LARANJEIRAS 899206 CARONE PR DA COSTA 899207 CARONE DEP CENTRAL 899208 SUP CARONE JARDIM 908341"},{"id":"0ddfbeff-cfe4-4656-5be4-08d5ad2bf6ba","name":"COMPANHIA PORTUARIA BAIA DE SEPETIBA","commercialName":"","cnpj":"72372998000166","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":"CPBS MATRIZ 50974 CPBS ITAGUAI 898227"},{"id":"43f24fc9-478a-4545-5beb-08d5ad2bf6ba","name":"ANTARES EDUCACIONAL S.A.","commercialName":"","cnpj":"34185306000181","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":"UVA 50983 UVA SUBSTACAO 898670 UVA CS 908722"},{"id":"288ede09-5b99-4478-5bc6-08d5ad2bf6ba","name":"CONDOMINIO VIA PARQUE SHOPPING CENTER","commercialName":"","cnpj":"02284436000185","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":"CVPSC 50893 COND PARQ SHOP 898147"},{"id":"90ff1f68-a902-4ed1-5b2b-08d5ad2bf6ba","name":"GTW GERAÇÃO E SERVIÇOS LTDA.","commercialName":"BRASIL GTW","cnpj":"13332930000194","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":"GTW 50503 PCT CANARIO I 903227 UTE.GN.BA.035617-4.01"},{"id":"e8d20f50-30c3-45aa-5b25-08d5ad2bf6ba","name":"CONDOMINIO DO EDIFICIO MADUREIRA SHOPPING RIO","commercialName":"","cnpj":"00451208000127","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":"MADUREIRA SHOPPING 50496 MADUREIRA SHOPPING 898089"},{"id":"5660702e-f3d8-46e8-5aea-08d5ad2bf6ba","name":"HOSPITAL DR. BALBINO LTDA.","commercialName":"HOSPITAL BALBINO","cnpj":"42297507000107","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":"HOSPITAL BALBINO 50352 HOSPITAL BALBINO 898529"},{"id":"d7bb11a6-7be8-422d-5a57-08d5ad2bf6ba","name":"VAZANTE I ENERGIAS RENOVAVEIS S.A.","commercialName":"","cnpj":"21784326000127","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":"VAZANTE I 17358 VAZANTE 1 909557 UFV.RS.MG.032339-0.01"},{"id":"4579810e-5649-4f9d-5a59-08d5ad2bf6ba","name":"VAZANTE II ENERGIAS RENOVAVEIS S.A.","commercialName":"","cnpj":"21784311000169","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":"VAZANTE II 17360 VAZANTE 2 909773 UFV.RS.MG.032340-3.01"},{"id":"6acefe05-e26c-4282-5a5a-08d5ad2bf6ba","name":"VAZANTE III ENERGIAS RENOVAVEIS S.A.","commercialName":"","cnpj":"21784307000109","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":"VAZANTE III 17363 VAZANTE 3 909748 UFV.RS.MG.032341-1.01"},{"id":"a957fc7d-1962-4f55-5a5d-08d5ad2bf6ba","name":"THENZA ENERGIA S/A.","commercialName":"","cnpj":"21145555000100","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":"THENZA ENERGIA 17405"},{"id":"57e397a2-67a8-42d9-5a5e-08d5ad2bf6ba","name":"LAGOA 1 ENERGIA RENOVAVEL S.A.","commercialName":"","cnpj":"21540697000163","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":"LAGOA 1 17406 LAGOA 1 909579 EOL.CV.PB.033664-5.01"},{"id":"b794a4f4-9ef0-4760-5a5f-08d5ad2bf6ba","name":"LAGOA 2 ENERGIA RENOVAVEL S.A.","commercialName":"","cnpj":"21540731000108","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":"LAGOA 2 17407 LAGOA 2 909578 EOL.CV.PB.033665-3.01"},{"id":"ab996c81-f150-49fc-5a60-08d5ad2bf6ba","name":"GUAIMBE I PARQUE SOLAR S.A.","commercialName":"","cnpj":"21983240000123","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":"GUAIMBE I 17408 GUAIMBE 1 909381 UFV.RS.SP.032326-8.01"},{"id":"d44d9da3-1cfd-43b2-5a61-08d5ad2bf6ba","name":"GUAIMBE II PARQUE SOLAR S.A.","commercialName":"","cnpj":"21904039000103","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":"GUAIMBE II 17409 GUAIMBE 2 909765 UFV.RS.SP.032327-6.01"},{"id":"edad7198-b318-4df8-5a62-08d5ad2bf6ba","name":"GUAIMBE III PARQUE SOLAR S.A.","commercialName":"","cnpj":"22011002000119","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":"GUAIMBE III 17410 GUAIMBE 3 909766 UFV.RS.SP.032328-4.01"},{"id":"71a20640-3656-4431-5a63-08d5ad2bf6ba","name":"CANOAS ENERGIA RENOVAVEL S.A.","commercialName":"","cnpj":"21540713000118","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":"CANOAS 17424 EOL CANOAS 909553 EOL.CV.PB.033663-7.01"},{"id":"563b0d11-904c-4934-5a64-08d5ad2bf6ba","name":"GUAIMBE IV PARQUE SOLAR S.A.","commercialName":"","cnpj":"21983147000119","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":"GUAIMBE IV 17425 GUAIMBE 4 909745 UFV.RS.SP.032329-2.01"},{"id":"8afd61f2-9c93-416e-5a65-08d5ad2bf6ba","name":"DRACENA IV PARQUE SOLAR S.A.","commercialName":"","cnpj":"21983207000101","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":"DRACENA IV 17426"},{"id":"dd114004-184b-4677-5a66-08d5ad2bf6ba","name":"DRACENA II PARQUE SOLAR S.A.","commercialName":"","cnpj":"21977147000106","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":"DRACENA II 17428"},{"id":"50fe3de5-c9e8-41c4-5a67-08d5ad2bf6ba","name":"DRACENA I PARQUE SOLAR S.A.","commercialName":"","cnpj":"22010949000105","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":"DRACENA I 17429"},{"id":"241eecc4-ea3c-4428-5a68-08d5ad2bf6ba","name":"GUAIMBE V PARQUE SOLAR S.A.","commercialName":"","cnpj":"22010973000144","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":"GUAIMBE V 17430 GUAIMBE 5 909746 UFV.RS.SP.032330-6.01"},{"id":"292dd392-9c65-49bd-5a70-08d5ad2bf6ba","name":"CONDOMINIO DO PARKSHOPPING CAMPO GRANDE","commercialName":"","cnpj":"20102243000148","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":"PARKSHOPPING CAMPO GRANDE 49624 PARKSHOPPING CG 891883"},{"id":"8b1eaa52-aca2-4e2e-5a7d-08d5ad2bf6ba","name":"GERACAO BIOELETRICIDADE VISTA ALEGRE II S.A.","commercialName":"","cnpj":"15103714000100","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":"UTE VISTA ALEGRE II 49785 VISTA ALEGRE II 895149 UTE.AI.MS.031702-0.01"},{"id":"8fd2e96d-4bb1-4e82-5a8e-08d5ad2bf6ba","name":"BHG IMOBILIARIA HOTELARIA E TURISMO S/A","commercialName":"","cnpj":"33957796000477","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":"ROYAL TULIP RIO DE JANEIRO 50046 ROYAL TULIP RJ 70783"},{"id":"54730a39-4d61-445a-5aba-08d5ad2bf6ba","name":"SERRA DOS CAVALINHOS I ENERGETICA S.A.","commercialName":"","cnpj":"09199675000186","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":"SERRA DOS CAVALINHOS I 50213 SERRA CAVALINHOS 1 906795 PCH.PH.RS.031324-6.01"},{"id":"696b6fb8-7bf7-40c8-5abb-08d5ad2bf6ba","name":"PHOENIX GERACAO DE ENERGIA S.A.","commercialName":"","cnpj":"11150969000165","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":"VERDE 4A 50214 VERDE 4A 909507 PCH.PH.MS.029261-3.01"},{"id":"f040aa3b-516f-48f7-5ac0-08d5ad2bf6ba","name":"MULTI OPTICA DISTRIBUIDORA LTDA","commercialName":"MULTIOPTICA","cnpj":"30260871000105","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":"MULTIOPTICA 50219 MULTI OPTICA 898061 MULTI OPTICA BH 910006 MULTI OPTICA PINHAIS 909842 MULTI OPTICA POA 909843"},{"id":"c18a51a5-e8cf-4c2b-5abe-08d5ad2bf6ba","name":"GERACAO BIOMASSA SANTA CANDIDA II S.A.","commercialName":"","cnpj":"14759176000136","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":"UTE SANTA CANDIDA II 50217 SANTA CANDIDA II 904177 UTE.AI.SP.031739-0.02"},{"id":"99b6c9f9-99e8-43e8-59e9-08d5ad2bf6ba","name":"LIQ CORP S.A.","commercialName":"","cnpj":"67313221000190","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":"CONTAX MOBITEL 15815 TNL CONTAX-SCRISTOV 71108 TNL CONTAX-ALEGRIA 71163 TNL CONTAX-MAUA 71164 CONTAX LAPA 71214 TNL CONTAX-PADRO II 71298 TNL CONTAX COMERCIO 70707 TNL CONTAX FORTALEZA 70868 CONTAX JOAO PESSOA 897285 BOA VIAGEM OPE 907154 BOA VIAGEM ADM 907415 TNL CONTAX-RECIFE 71508 CONTAX MOBITEL S.A 906114 CONTAX NAVEGANTES 909660 CONTAX B.FUNDA-SP 70450 TNL CONTAX PRADO 70542 TNL CONTAX-13,8KV 71422"},{"id":"b2332ab1-202f-4081-59dc-08d5ad2bf6ba","name":"CIA POSITIVA DE ENERGIA","commercialName":"","cnpj":"19560848000101","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":"CIAPOSITIVA 15696"},{"id":"3c1eedfd-c7bf-4014-59de-08d5ad2bf6ba","name":"CALANGO 6 ENERGIA RENOVAVEL S.A.","commercialName":"","cnpj":"19560837000113","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":"CALANGO 6 15755 CALANGO 6 904074 EOL.CV.RN.031812-4.01"},{"id":"2e922510-720a-4a9f-59df-08d5ad2bf6ba","name":"SANTANA 1 ENERGIA RENOVAVEL S.A.","commercialName":"","cnpj":"19560874000121","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":"SANTANA 1 15756 SANTANA 1 904069 EOL.CV.RN.031810-8.01"},{"id":"087d73af-1ccd-4479-59e0-08d5ad2bf6ba","name":"SANTANA 2 ENERGIA RENOVAVEL S.A.","commercialName":"","cnpj":"19588049000135","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":"SANTANA 2 15757 SANTANA 2 904070 EOL.CV.RN.031811-6.01"},{"id":"16690568-b126-40a3-59e2-08d5ad2bf6ba","name":"EOLICA ITAREMA IX S.A.","commercialName":"","cnpj":"20533377000113","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":"ITAREMA IX 15775 ITAREMA IX 900173 EOL.CV.CE.031814-0.01"},{"id":"1283dfe1-9f82-4e05-59e3-08d5ad2bf6ba","name":"EOLICA ITAREMA IV S.A.","commercialName":"","cnpj":"20553751000142","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":"ITAREMA IV 15776 ITAREMA IV 899705 EOL.CV.CE.031813-2.01"},{"id":"f0e1481a-2b50-47a3-59e4-08d5ad2bf6ba","name":"EOLICA ITAREMA VI S.A","commercialName":"","cnpj":"20533879000144","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":"ITAREMA VI 15777 ITAREMA VI 899727 EOL.CV.CE.031815-9.01"},{"id":"69d60f5f-5d61-4649-59e5-08d5ad2bf6ba","name":"EOLICA ITAREMA VII S.A","commercialName":"","cnpj":"20533473000161","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":"ITAREMA VII 15778 ITAREMA VII 900175 EOL.CV.CE.031816-7.01"},{"id":"87007a43-ec79-48eb-59e6-08d5ad2bf6ba","name":"EOLICA ITAREMA VIII S.A.","commercialName":"","cnpj":"20533310000189","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":"ITAREMA VIII 15779 ITAREMA VIII 900736 EOL.CV.CE.031817-5.01"},{"id":"79ee7fb3-6d0f-46da-5a10-08d5ad2bf6ba","name":"OER MINEIROS ENERGIA S.A.","commercialName":"","cnpj":"15864683000100","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":"OER MINEIROS 16449 COSTA RICA-CONSUMO 71678 AGUA EMENDADA - CONS 889195 MORRO VERMELHO-CONS 889196 ALTO TAQUARI - CONS 889197 ALTO TAQUARI 8651 UTE.AI.MT.030038-1.01 MORRO VERMELHO 8653 UTE.AI.GO.030040-3.01 AGUA EMENDADA 8655 UTE.AI.GO.030039-0.01 COSTA RICA (BRENCO) 8652 UTE.AI.MS.030037-3.01"},{"id":"685c0735-16ce-4fc9-5a15-08d5ad2bf6ba","name":"CELER GESTAO E COMERCIALIZACAO DE ENERGIA LTDA.","commercialName":"","cnpj":"21314033000186","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":"CELER GESTAO 16454"},{"id":"840b0617-bd5f-42fc-5a1b-08d5ad2bf6ba","name":"EVM COMERCIALIZADORA DE ENERGIA LTDA.","commercialName":"EVM","cnpj":"11924293000110","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":"EVM COMERCIALIZADORA 16526"},{"id":"0c7ceb9a-0356-4460-592b-08d5ad2bf6ba","name":"EMPRESA DE ENERGIA SAO MANOEL S.A.","commercialName":"","cnpj":"18494537000110","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":"SAO MANOEL 13975 SAO MANOEL 908948 UHE.PH.PA.031444-7.01"},{"id":"4ebfc3bc-44dc-4e57-591a-08d5ad2bf6ba","name":"MAGATEC SERVICOS TECNICOS LTDA","commercialName":"MAGATEC","cnpj":"30669162000188","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":"CGH BOM JARDIM 13815 CGH BOM JARDIM 897164 CGH.PH.RJ.030997-4.01"},{"id":"2ac20ac1-72de-404a-5941-08d5ad2bf6ba","name":"EOLICA ITAREMA I S.A.","commercialName":"","cnpj":"19560032000170","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":"ITAREMA I 14219 ITAREMA I 895301 EOL.CV.CE.031485-4.01"},{"id":"ff51efaf-8188-4c4b-5942-08d5ad2bf6ba","name":"EOLICA ITAREMA II S.A.","commercialName":"","cnpj":"19560074000100","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":"ITAREMA II 14220 ITAREMA II 895302 EOL.CV.CE.031483-8.01"},{"id":"e07ea194-b8bd-488d-5943-08d5ad2bf6ba","name":"EOLICA ITAREMA III S.A.","commercialName":"","cnpj":"19560839000102","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":"ITAREMA III 14221 ITAREMA III 896908 EOL.CV.CE.031484-6.01"},{"id":"726b08bb-9caf-49cc-5944-08d5ad2bf6ba","name":"EOLICA ITAREMA V S.A.","commercialName":"","cnpj":"19560868000174","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":"ITAREMA V 14222 ITAREMA V 895304 EOL.CV.CE.031482-0.01"},{"id":"7dca06c8-8af2-4762-5945-08d5ad2bf6ba","name":"EOLICA CAETITE C S.A.","commercialName":"","cnpj":"19560109000101","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":"CAETITE C 14223 CAETITE C 896264 EOL.CV.BA.031523-0.01"},{"id":"304823b3-c3fe-41ab-59a4-08d5ad2bf6ba","name":"MULTIPLAN EMPREENDIMENTOS IMOBILIARIOS S/A","commercialName":"MULTIPLAN EMPREENDIMENTOS","cnpj":"07816890000153","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":"MULTIPLAN 15282 SHOPPING VILLAGEMALL 891882"},{"id":"d91c6b24-dcae-444b-597f-08d5ad2bf6ba","name":"GERACAO BIOMASSA VISTA ALEGRE I S.A.","commercialName":"","cnpj":"14180940000114","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":"UTE VIST ALEG I 14636 VISTA ALEGRE I VIST 8545 UTE.AI.MS.029994-4.01"},{"id":"a8acfb75-6f24-4467-582c-08d5ad2bf6ba","name":"HELIOS ENERGIA COMERCIALIZADORA E SERVICOS LTDA.","commercialName":"HELIOS ENERGIA","cnpj":"16881198000108","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":"HELIOS ENERGIA 10893"},{"id":"0cc94360-ccb3-47cd-58e7-08d5ad2bf6ba","name":"EOLICA CAETITE B S.A.","commercialName":"","cnpj":"19235607000189","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":"CAETITE B 13464 CAETITE B 896247 EOL.CV.BA.031342-4.01"},{"id":"838186c2-a7d3-43a7-58e8-08d5ad2bf6ba","name":"EOLICA CAETITE A S.A.","commercialName":"","cnpj":"19233858000124","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":"CAETITE A 13465 CAETITE A 896246 EOL.CV.BA.031344-0.01"},{"id":"e4ad41ba-e188-45a8-58b0-08d5ad2bf6ba","name":"CELER COMERCIALIZADORA DE ENERGIA ELETRICA LTDA","commercialName":"","cnpj":"18483400000160","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":"CELER 12873"},{"id":"cb71285c-1001-4da7-58c0-08d5ad2bf6ba","name":"FERROPORT LOGISTICA COMERCIAL EXPORTADORA S.A","commercialName":"FERROPORT","cnpj":"08807683000103","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":"FERROPORT 13172 LLX - PORTO 893562"},{"id":"c15e79f4-c75b-415d-58c1-08d5ad2bf6ba","name":"CAETITE 1 ENERGIA RENOVAVEL S/A","commercialName":"","cnpj":"12158428000146","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":"CAETITE 1 13173 CAETITE 1 894022 EOL.CV.BA.030976-1.01"},{"id":"4e8125e7-4387-49f1-588d-08d5ad2bf6ba","name":"SETOR LOJAS DO CONDOMINIO DO EDIFICIO RIO FLAT SERVICE","commercialName":"","cnpj":"29269792000186","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":"SHOPPING RIO DESIGN LEBLON 12394 SHOPPING RIO LEBLON 893223"},{"id":"63101796-7f17-4e1b-588e-08d5ad2bf6ba","name":"CONDOMINIO GERAL NORTESHOPPING","commercialName":"","cnpj":"29209285000157","city":"RIO DE JANEIRO","stateCode":"RJ","buscaAdicional":"NORTESHOPPING GERAL 12412 NORTE SHOP GERAL 70296"},{"id":"ba47c36b-c157-483b-5c4a-08d5ad2bf6ba","name":"HAROLPEL INDUSTRIA DE PAPEIS LTDA","commercialName":"HAROLPEL","cnpj":"08508086000170","city":"SANTO ANTÔNIO DE PÁDUA","stateCode":"RJ","buscaAdicional":"HAROLPEL 51252 HAROLPEL 898579"},{"id":"3ab2650e-a6b5-4541-607b-08d5ad2bf6ba","name":"INPEL DE PADUA INDUSTRIA DE PAPEIS LTDA","commercialName":"INPEL INDUSTRIA DE PAPEIS","cnpj":"06194089000150","city":"SANTO ANTÔNIO DE PÁDUA","stateCode":"RJ","buscaAdicional":"INPEL PAPEIS 53530 INPEL PAPEIS 903495"},{"id":"0b6f015b-f257-4e5a-51b8-08d5ad2bf6ba","name":"COPAPA CIA PADUANA DE PAPEIS","commercialName":"COPAPA","cnpj":"31590862000145","city":"SANTO ANTÔNIO DE PÁDUA","stateCode":"RJ","buscaAdicional":"COPAPA 2548 COPAPA LIVRE 70641 COPAPA CE 910228"},{"id":"ed2a6470-d48f-4f0e-6651-08d5ad2bf6ba","name":"CIPEL DE PADUA - INDUSTRIA DE PAPEIS LTDA","commercialName":"CIPEL INDUSTRIA DE PAPEIS","cnpj":"03618805000191","city":"SANTO ANTÔNIO DE PÁDUA","stateCode":"RJ","buscaAdicional":"CIPEL 57492 CIPEL DE PADUA PAPEL 907693"},{"id":"81a2ac4b-49a5-4860-68e3-08d5ad2bf6ba","name":"M.H.M. DISTRIBUIDORA DE ALIMENTOS LTDA.","commercialName":"","cnpj":"07427095000173","city":"SÃO GONÇALO","stateCode":"RJ","buscaAdicional":"FRIGOCENTER 60529 FRIGOSG 911213 FRIGOGUARAPARI 911224"},{"id":"7b10df2e-2d3f-416f-6323-08d5ad2bf6ba","name":"LABORATORIOS B BRAUN SA","commercialName":"","cnpj":"31673254000102","city":"SÃO GONÇALO","stateCode":"RJ","buscaAdicional":"BBRAUN 55181 LABORATORIO B BRAUN 905916 LAB BBRAUN 905937 LABORATORIO BBRAUN 905938"},{"id":"50225895-17fa-436e-6225-08d5ad2bf6ba","name":"GARDA EMPREENDIMENTOS E PARTICIPACOES S/A","commercialName":"","cnpj":"10477737000153","city":"SÃO GONÇALO","stateCode":"RJ","buscaAdicional":"SHOPPING PATIO ALCANTARA 54594 SHOP PATIO ALCANTARA 904100"},{"id":"2f4f586f-5120-4850-1cba-08d5b8870181","name":"INDUSTRIA DE BEBIDAS REFLEXA LTDA","commercialName":"","cnpj":"06929454000128","city":"SÃO GONÇALO","stateCode":"RJ","buscaAdicional":"REFLEXA 61041 REFLEXA 912793"},{"id":"14c92743-fe5e-4dc4-56d4-08d5ad2bf6ba","name":"CASAS GUANABARA COMESTIVEIS LTDA","commercialName":"CASAS GUANABARA","cnpj":"33130543002045","city":"SÃO GONÇALO","stateCode":"RJ","buscaAdicional":"CASA GUANABARA 7803 CASAS GUANABARA 72381"},{"id":"202d6171-2856-4fba-57a9-08d5ad2bf6ba","name":"CONDOMINIO DO SAO GONCALO SHOPPING RIO","commercialName":"","cnpj":"06068650000155","city":"SÃO GONÇALO","stateCode":"RJ","buscaAdicional":"SG SHOPPING 9294 SAO GONCALO SHOP 889008"},{"id":"2765c744-fbe6-46e1-5e5d-08d5ad2bf6ba","name":"CENTRO COMERCIAL BOULEVARD SHOPPING SAO GONCALO","commercialName":"","cnpj":"12945474000195","city":"SÃO GONÇALO","stateCode":"RJ","buscaAdicional":"PSSG 52341 ADMP LJ36 899874 LOJA P INFERIOR (38) 899877 CAG P SUPERIOR (037) 899893"},{"id":"2cf11cce-cfe5-4371-5ecd-08d5ad2bf6ba","name":"BELL FISH COMERCIO E INDUSTRIA DE GELO EIRELI","commercialName":"JB GELO","cnpj":"04562571000170","city":"SÃO GONÇALO","stateCode":"RJ","buscaAdicional":"BELL FISH 52555 BELL FISH 900593"},{"id":"7a6344ab-ea89-4f5b-5d72-08d5ad2bf6ba","name":"VEDAPACK EMBALAGENS INDUSTRIAIS LTDA","commercialName":"VEDAPACK","cnpj":"02033695000133","city":"SÃO GONÇALO","stateCode":"RJ","buscaAdicional":"VEDAPACK 51822 VEDAPACK EMBALAGENS 902477"},{"id":"33d60d08-d0ec-48ce-5cfb-08d5ad2bf6ba","name":"CONDOMINIO DO COMPLEXO COMERCIAL COLINA","commercialName":"","cnpj":"01125289000138","city":"SÃO JOÃO DE MERITI","stateCode":"RJ","buscaAdicional":"CCCC 51647 COMP COMERC COLINA 903756"},{"id":"4f25f027-e23f-4306-5026-08d5ad2bf6ba","name":"SENDAS DISTRIBUIDORA S/A","commercialName":"","cnpj":"06057223000171","city":"SÃO JOÃO DE MERITI","stateCode":"RJ","buscaAdicional":"SENDAS 1477 SENDAS 1634 MEIER II 70491"},{"id":"2265c592-ba8b-4021-694a-08d5ad2bf6ba","name":"ENGETECH COMERCIO E INDUSTRIA DE PLASTICOS LTDA.","commercialName":"","cnpj":"01144673000188","city":"SÃO JOÃO DE MERITI","stateCode":"RJ","buscaAdicional":"ENGETECH 60987 ENGETECH 911832"},{"id":"e10779b0-3dac-461f-73f9-08d5cf600bef","name":"PROLAGOS S/A - CONCESSIONARIA DE SERVICOS PUBLICOS DE AGUA E ESGOTO","commercialName":"","cnpj":"02382073000110","city":"SÃO PEDRO DA ALDEIA","stateCode":"RJ","buscaAdicional":""},{"id":"06d3597d-0d5f-44dc-6735-08d5ad2bf6ba","name":"BYWER INDUSTRIA DE PLASTICOS LTDA","commercialName":"","cnpj":"11303619000191","city":"SAQUAREMA","stateCode":"RJ","buscaAdicional":"BYWER 58003 BYWER PLASTICOS 910840"},{"id":"83094520-6724-4274-5f3b-08d5ad2bf6ba","name":"EMFOL - EMPRESA DE MINERACAO FONTE LIMPA LTDA","commercialName":"EMFOL","cnpj":"27945740000157","city":"SEROPÉDICA","stateCode":"RJ","buscaAdicional":"EMFOL 52870 EMFOL 903840"},{"id":"a3b8054e-d738-4fd3-5d28-08d5ad2bf6ba","name":"ARBOR BRASIL INDUSTRIA DE BEBIDAS LTDA","commercialName":"ARBOR BRASIL","cnpj":"29588019000182","city":"TERESÓPOLIS","stateCode":"RJ","buscaAdicional":"ARBOR BRASIL 51722 ARBOR BRASIL BEBIDAS 900025"},{"id":"c8abe870-8f29-485a-6844-08d5ad2bf6ba","name":"ENVASADORA NATALIA LTDA","commercialName":"ENVASADORA NATALIA","cnpj":"11899391000144","city":"TERESÓPOLIS","stateCode":"RJ","buscaAdicional":"ENVASADORA 59653 ACQUAMAX 900001"},{"id":"9a0ab76e-c88a-4f89-88ce-08d5ae44ed50","name":"ACQUAMAX COMERCIAL LTDA","commercialName":"","cnpj":"11153614000120","city":"TERESÓPOLIS","stateCode":"RJ","buscaAdicional":"ACQUAMAX COM 52222"},{"id":"976f790a-20d7-4f6a-1cdd-08d5b8870181","name":"ENVASADORA RENATA LTDA","commercialName":"ENVASADORA RENATA","cnpj":"11907968000112","city":"TERESÓPOLIS","stateCode":"RJ","buscaAdicional":"ENVASADORA RENATA 62864"},{"id":"e7453233-5b43-444e-8dab-08d5d060706e","name":"CERAMICA ARGIBEM LTDA","commercialName":"","cnpj":"31142292000120","city":"TRÊS RIOS","stateCode":"RJ","buscaAdicional":"ARGIBEM 62458 CERAMICA ARGIBEM 913579"},{"id":"0d1393c2-1bbf-413e-66a9-08d5ad2bf6ba","name":"GUANAPACK - INDUSTRIA DE EMBALAGENS PLASTICAS LTDA","commercialName":"GUANAPACK","cnpj":"11790941000192","city":"TRÊS RIOS","stateCode":"RJ","buscaAdicional":"GUANAPACK 57728 GUANAPACK 908848"},{"id":"1fb4cc81-0bd7-42fe-678f-08d5ad2bf6ba","name":"FERREIRA INTERNATIONAL LTDA","commercialName":"","cnpj":"04431781000120","city":"TRÊS RIOS","stateCode":"RJ","buscaAdicional":"FERREIRA INTERNATIONAL 58290 FERREIRA INTER RJ 908820"},{"id":"6d3eb2c2-3f91-4e93-6278-08d5ad2bf6ba","name":"TTR VIDROS LTDA","commercialName":"","cnpj":"09416805000195","city":"TRÊS RIOS","stateCode":"RJ","buscaAdicional":"TTR 54769 TTR VIDROS 907338"},{"id":"75bbeb32-8728-4997-639f-08d5ad2bf6ba","name":"CEREAIS BRAMIL LTDA","commercialName":"","cnpj":"32296378000170","city":"TRÊS RIOS","stateCode":"RJ","buscaAdicional":"BRAMIL 55485 CEREAIS BRAMIL PV 04 907280 CEREAIS BRAMIL PV 23 907281 CEREAIS BRAMIL PV02 907317 CEREAIS BRAMIL PV07 907339 CEREAIS BRAMIL PV11 907340 CEREAIS BRAMIL PV12 907341 CEREAIS BRAMIL PV21 907342 CEREAIS BRAMIL PV35 907343 CEREAIS BRAMIL PV34 907344 CEREAIS BRAMIL PV17 907345 CEREAIS BRAMIL MATRI 907416 CEREAIS BRAMIL PV20 907417 CEREAIS BRAMIL PV01 907492 CEREAIS BRAMIL PV27 907578 CEREAIS BRAMIL PV22 907684 CEREAIS BRAMIL PV18 907915 CEREAIS BRAMIL A-SOR 908099 CEREAIS BRAMIL PV15 908379 CEREAIS BRAMIL PV05 908540 CEREAIS BRAMIL ACO M 908702"},{"id":"669c53ca-5385-4527-63a1-08d5ad2bf6ba","name":"PEDREIRA SAO SEBASTIAO LTDA","commercialName":"","cnpj":"32289829000142","city":"TRÊS RIOS","stateCode":"RJ","buscaAdicional":"PEDREIRA SAO SEBASTIAO 55487 PEDREIRA MATRIZ 907337 PEDREIRA PADUA 908085"},{"id":"e6a54768-726a-4029-5bee-08d5ad2bf6ba","name":"VDP INDUSTRIA DE EMBALAGENS LTDA","commercialName":"","cnpj":"10519603000158","city":"TRÊS RIOS","stateCode":"RJ","buscaAdicional":"VDP INDUSTRIA 50989 VDP IND TRES RIOS RJ 900649"},{"id":"14397746-1160-40bb-5bc1-08d5ad2bf6ba","name":"SR EMBALAGENS PLASTICAS TRES RIOS LTDA","commercialName":"","cnpj":"11363676000166","city":"TRÊS RIOS","stateCode":"RJ","buscaAdicional":"SR TRES RIOS 50883 SR EMBALAGENS 898783"},{"id":"531a0f13-4165-46d5-62b4-08d5ad2bf6ba","name":"MOTECH PLASTICOS LTDA","commercialName":"","cnpj":"11387944000180","city":"VALENÇA","stateCode":"RJ","buscaAdicional":"MOTECH 54934 IND PLAST VALENCA 908438"},{"id":"386dedb5-22af-495b-6341-08d5ad2bf6ba","name":"CERAMICA PORTO VELHO LTDA","commercialName":"FILIAL N 02","cnpj":"32287575000395","city":"VASSOURAS","stateCode":"RJ","buscaAdicional":"PORTO VELHO 55272 CERAMICA PORTO VELHO 907940"},{"id":"4c66d7f6-6d75-4dfb-6905-08d5ad2bf6ba","name":"BLUECOM SOLUCOES DE CONECTIVIDADE E INFORMATICA LTDA","commercialName":"NETSYS TECNOLOGIA","cnpj":"02686151000170","city":"VASSOURAS","stateCode":"RJ","buscaAdicional":"BLUECOM 60721 BLUECOM 910696"},{"id":"90451def-027d-472b-72f9-08d5cf600bef","name":"ACCIONA CONCESSOES RODOVIA DO ACO S A","commercialName":"","cnpj":"09414761000164","city":"VASSOURAS","stateCode":"RJ","buscaAdicional":""},{"id":"3e0dcaa5-adae-4ed9-8d84-08d5d060706e","name":"FUNDACAO EDUCACIONAL ROSEMAR PIMENTEL","commercialName":"FERP","cnpj":"28577153000115","city":"VOLTA REDONDA","stateCode":"RJ","buscaAdicional":"UGB 60509 FERP BP 913303 FERP NI 913304 FERP VR 913321"},{"id":"1d2203e3-1ea8-4c87-67ea-08d5ad2bf6ba","name":"ROYAL COMERCIO E DISTRIBUIDORA LTDA","commercialName":"SUPERMERCADOS ROYAL","cnpj":"08842314000143","city":"VOLTA REDONDA","stateCode":"RJ","buscaAdicional":"SUPERMERCADO ROYAL 58882 AMARAL PEIXOTO 909908 ATERRADO 909909 SAO LUCAS 909913 NOVA IGUACU 909931"},{"id":"8d144024-c548-4b85-67eb-08d5ad2bf6ba","name":"NAOMI COMERCIO DE ALIMENTOS LTDA","commercialName":"","cnpj":"39553144000100","city":"VOLTA REDONDA","stateCode":"RJ","buscaAdicional":"NAOMI SUPERMERCADO 58883 BARRA MANSA 909910 NAOMI RETIRO 909932 SESSENTA 909933 RESENDE 910304"},{"id":"20fd0c46-7cd3-4539-6851-08d5ad2bf6ba","name":"SUL GAS - COMERCIO DE COMBUSTIVEIS LTDA","commercialName":"","cnpj":"39194238000130","city":"VOLTA REDONDA","stateCode":"RJ","buscaAdicional":"POSTO AP 59750 SUL GAS 910140 CONFORTACO 910141"},{"id":"20fa81a5-b75a-47e0-675e-08d5ad2bf6ba","name":"FUNDACAO OSWALDO ARANHA","commercialName":"FOA","cnpj":"32504995000114","city":"VOLTA REDONDA","stateCode":"RJ","buscaAdicional":"FOA 58065 FOA VOLTA REDONDA 908437"},{"id":"f4ca775f-cd81-4419-6602-08d5ad2bf6ba","name":"A ABREU BENEFICIAMENTOS LTDA","commercialName":"","cnpj":"01585178000104","city":"VOLTA REDONDA","stateCode":"RJ","buscaAdicional":"AABREU 57263 A ABREU BENEFICIAMEN 907311"},{"id":"756b80b4-3677-491d-617e-08d5ad2bf6ba","name":"FLORESTA COMERCIO E INDUSTRIA S A","commercialName":"CEABFLOR","cnpj":"32500977000164","city":"VOLTA REDONDA","stateCode":"RJ","buscaAdicional":"SUPERMERCADOS FLORESTA 54211 FLORESTA COM 12 908102 FLORESTA COM 36 908103 FLORESTA COM 02 908104 FLORESTA COM 10 908105 FLORESTA COM 24 908106 FLORESTA COM 31 908107 S FLORESTA RESENDE 908111 FLORESTA COM 01 908122 FLORESTA COM 05 908569 FLORESTA COM 03 908576 FLORESTA COM 07 908650"},{"id":"71f10709-dece-4618-645b-08d5ad2bf6ba","name":"UNIMED DE VOLTA REDONDA COOPERATIVA DE TRABALHO MEDICO","commercialName":"","cnpj":"35917970000130","city":"VOLTA REDONDA","stateCode":"RJ","buscaAdicional":"UNIMED VR 55950 UNIMED VOLTA REDOND 908705"},{"id":"548958c1-e68f-42e0-5bef-08d5ad2bf6ba","name":"INCOFLANDRES INDUSTRIA E COMERCIO DE FLANDRES LTDA","commercialName":"CINBAL","cnpj":"62100581000190","city":"VOLTA REDONDA","stateCode":"RJ","buscaAdicional":"CINBAL 50990 INCOFLANDRES 900656"},{"id":"fa0a176b-c65d-4fbd-548c-08d5ad2bf6ba","name":"CONDOMINIO DO SIDER SHOPPING CENTER","commercialName":"","cnpj":"01964081000102","city":"VOLTA REDONDA","stateCode":"RJ","buscaAdicional":"CSSC 4330 SIDER SHOPP CENTER 71552"},{"id":"4710da6d-ed8f-431e-5f3f-08d5ad2bf6ba","name":"ADASEBO-INDUSTRIA E COMERCIO DE PRODUTOS ANIMAIS LTDA","commercialName":"ADASEBO-INDUSTRIA E COMERCIO DE PRODUTOS ANIMAIS","cnpj":"71966071000191","city":"ADAMANTINA","stateCode":"SP","buscaAdicional":"ADASEBO 52874 ADASEBO ANIMAIS 900773"},{"id":"9530659c-f22e-4bba-5e26-08d5ad2bf6ba","name":"PAULISPELL INDUSTRIA PAULISTA DE PAPEIS E PAPELAO LTDA.","commercialName":"","cnpj":"43088798000188","city":"AGUAÍ","stateCode":"SP","buscaAdicional":"PAULISPELL 52236 PAULISPEL INDUSTRIA 902620"},{"id":"26faa8b1-e365-4ed5-5a90-08d5ad2bf6ba","name":"UNILEVER BRASIL INDUSTRIAL LTDA","commercialName":"","cnpj":"01615814009230","city":"AGUAÍ","stateCode":"SP","buscaAdicional":"UNIAGUAI 50085 UNIGUAI 896426"},{"id":"80e49da6-6647-4314-663a-08d5ad2bf6ba","name":"IBERIA INDUSTRIA DE EMBALAGENS LTDA.","commercialName":"","cnpj":"57940546000220","city":"AGUAÍ","stateCode":"SP","buscaAdicional":"IBERIA EMBALAGENS 57401 IBERIA EMBALAGENS 906723"},{"id":"fa049d1f-997c-42de-67d3-08d5ad2bf6ba","name":"LIDERKRAFT INDUSTRIA DE EMBALAGENS LTDA","commercialName":"LIDERKRAFT EMBALAGENS","cnpj":"01986096000171","city":"AGUAÍ","stateCode":"SP","buscaAdicional":"LIDERKRAFT 58659 LIDERKRAFT 908880"},{"id":"07bdd8a3-0267-429b-54d1-08d5ad2bf6ba","name":"ASB BEBIDAS E ALIMENTOS LTDA","commercialName":"ASB BEBIDAS E ALIMENTOS LTDA","cnpj":"09285874000107","city":"ÁGUAS DE SANTA BÁRBARA","stateCode":"SP","buscaAdicional":"ASB BEBIDAS 4519 ASB BEBIDAS 71585"},{"id":"1783e1a3-9146-4540-52a5-08d5ad2bf6ba","name":"DURATEX S.A.","commercialName":"","cnpj":"97837181001976","city":"AGUDOS","stateCode":"SP","buscaAdicional":"DURA FA 3198 DURATEX DX62 AGUDOS 7249"},{"id":"98c59e34-fc5b-4f94-62b7-08d5ad2bf6ba","name":"COM IND MATSUDA IMP EXPORTADORA LTDA","commercialName":"","cnpj":"43206069000189","city":"ÁLVARES MACHADO","stateCode":"SP","buscaAdicional":"MATSUDA 54937 MATSUDA 905067 MATSUDA IMP 905193"},{"id":"c263abce-2380-4cbe-6330-08d5ad2bf6ba","name":"PARAMOUNT INDUSTRIA E COMERCIO DE PLASTICOS LTDA","commercialName":"","cnpj":"05588978000130","city":"AMERICANA","stateCode":"SP","buscaAdicional":"PARAMOUNT 55239 PARAMOUNT 905109"},{"id":"7867939c-0db5-4784-645e-08d5ad2bf6ba","name":"TEXTIL FAVERO LTDA","commercialName":"","cnpj":"43248764000103","city":"AMERICANA","stateCode":"SP","buscaAdicional":"TEXTIL FAVERO 55954 TEXTIL FAVERO LTDA. 907236"},{"id":"5844c0f9-a382-4241-642d-08d5ad2bf6ba","name":"GREINER BIO-ONE BRASIL PRODUTOS MEDICOS HOSPITALARES LTDA","commercialName":"","cnpj":"71957310000147","city":"AMERICANA","stateCode":"SP","buscaAdicional":"GREINER 55865 GREINER BIO ONE 906416"},{"id":"9a12f3a7-731e-42e5-6500-08d5ad2bf6ba","name":"TINTURARIA E ESTAMPARIA PRIMOR LTDA","commercialName":"","cnpj":"43265578000182","city":"AMERICANA","stateCode":"SP","buscaAdicional":"PRIMOR 56370 TINTURARIA E ESTAMPA 906019"},{"id":"e5dbcb40-d155-4b99-692f-08d5ad2bf6ba","name":"BRAND TEXTIL LTDA","commercialName":"","cnpj":"07258383000141","city":"AMERICANA","stateCode":"SP","buscaAdicional":"BRAND TEXTIL 60834 BRAND TEXTIL 911814"},{"id":"8b5c5ca2-143f-42e4-88ad-08d5ae44ed50","name":"GOODYEAR DO BRASIL PRODUTOS DE BORRACHA LTDA","commercialName":"","cnpj":"60500246001630","city":"AMERICANA","stateCode":"SP","buscaAdicional":"GOODYEAR AM 17284"},{"id":"08e43800-1045-4273-6775-08d5ad2bf6ba","name":"VIVO SABOR ALIMENTACAO LTDA","commercialName":"VIVO SABOR ALIMENTACAO","cnpj":"01827489000132","city":"AMERICANA","stateCode":"SP","buscaAdicional":"VIVO SABOR 58134 VIVO SABOR 907993"},{"id":"de59a0e1-69bf-4f2a-6711-08d5ad2bf6ba","name":"CRUZEIRO DO SUL INDUSTRIA TEXTIL SA","commercialName":"","cnpj":"43248129000126","city":"AMERICANA","stateCode":"SP","buscaAdicional":"CRUZEIRO DO SUL 57946 CRUZEIRO DO SUL IND 907932"},{"id":"c25b71b9-6762-443d-8da4-08d5d060706e","name":"SOLENIS DO BRASIL QUIMICAS LTDA.","commercialName":"","cnpj":"03945556000149","city":"AMERICANA","stateCode":"SP","buscaAdicional":"SOLENIS AMERICANA 61850 SOLENIS AMERICANA 913399"},{"id":"d5aa78ab-5b42-432d-52c4-08d5ad2bf6ba","name":"KSB BRASIL LTDA.","commercialName":"KSB","cnpj":"60680873000467","city":"AMERICANA","stateCode":"SP","buscaAdicional":"KSB BOMBAS 3280 KSB BOMBAS AMERICANA 71067"},{"id":"a450c771-434f-4ccb-52d7-08d5ad2bf6ba","name":"SALTORELLI TINTURARIA TEXTIL LTDA.","commercialName":"","cnpj":"00698389000190","city":"AMERICANA","stateCode":"SP","buscaAdicional":"SALTORELLI TIN 3330 SALTORELLI TINTURAR 71219"},{"id":"841a2eb1-34e6-4339-52d8-08d5ad2bf6ba","name":"SALTORELLI DO BRASIL INDUSTRIA TEXTIL LTDA.","commercialName":"","cnpj":"05049758000138","city":"AMERICANA","stateCode":"SP","buscaAdicional":"SALTORELLI TEX 3331 SALTORELLI TEXTIL 71220"},{"id":"18c08293-3e3c-4c07-533c-08d5ad2bf6ba","name":"ITRON SOLUCOES PARA ENERGIA E AGUA LTDA","commercialName":"","cnpj":"60882719000630","city":"AMERICANA","stateCode":"SP","buscaAdicional":"ITRON 3532 ITRON AMERICANA 71102"},{"id":"eadb957a-6fcd-4324-502a-08d5ad2bf6ba","name":"UNITIKA DO BRASIL INDUSTRIA TEXTIL LTDA","commercialName":"","cnpj":"43248525000153","city":"AMERICANA","stateCode":"SP","buscaAdicional":"UNITIKA 1484 UNITIKA AMERICANA 7913"},{"id":"7e6df32c-cd2f-4328-510e-08d5ad2bf6ba","name":"UMICORE BRASIL LTDA.","commercialName":"","cnpj":"96206313000765","city":"AMERICANA","stateCode":"SP","buscaAdicional":"UMICORE 1964 UMICORE AMERICANA 70321"},{"id":"19ffa873-1a2e-4452-510f-08d5ad2bf6ba","name":"FERRO ENAMEL DO BRASIL INDUSTRIA E COMERCIO LTDA","commercialName":"FERRO ENAMEL","cnpj":"59272849000167","city":"AMERICANA","stateCode":"SP","buscaAdicional":"FERRO ENAMEL 1965 FERRO ENAMEL AMERIC. 70320"},{"id":"17f8bd83-f94e-4152-510c-08d5ad2bf6ba","name":"EVONIK BRASIL LTDA","commercialName":"EVONIK","cnpj":"62695036004009","city":"AMERICANA","stateCode":"SP","buscaAdicional":"EVONIK AM 1961 DEGUSSA AMERICANA 70317"},{"id":"510e4dfe-a562-41b9-511c-08d5ad2bf6ba","name":"VICUNHA SERVICOS LTDA.","commercialName":"","cnpj":"03719063000190","city":"AMERICANA","stateCode":"SP","buscaAdicional":"VICUNHA SERVICOS 1999 BUCKEYE AMERICANA 70377 VICUNHA FIBRACEL 71168"},{"id":"d694d19e-c195-4982-4fe9-08d5ad2bf6ba","name":"TOYOBO DO BRASIL LTDA.","commercialName":"","cnpj":"55014609000101","city":"AMERICANA","stateCode":"SP","buscaAdicional":"TOYOBO 1354 TOYOBO AMERICANA 7429 TOYOBO SALTO 906913"},{"id":"16d29b5a-0586-4f4b-55a2-08d5ad2bf6ba","name":"TOPACK DO BRASIL LTDA","commercialName":"","cnpj":"01625072000197","city":"AMERICANA","stateCode":"SP","buscaAdicional":"TOPACK 5918 TOPACK-AMERICANA 72042"},{"id":"4c4ebe93-eea6-45cf-53b1-08d5ad2bf6ba","name":"TEXTIL IRINEU MENEGHEL LTDA","commercialName":"TEXTIL IRINEU MENEGHEL","cnpj":"48640130000115","city":"AMERICANA","stateCode":"SP","buscaAdicional":"IMETEXTIL 3775 TEXTIL IRIN MENEGHEL 71267"},{"id":"cf494746-02f5-4cb4-5388-08d5ad2bf6ba","name":"TASA TINTURARIA AMERICANA LTDA","commercialName":"","cnpj":"43257310000107","city":"AMERICANA","stateCode":"SP","buscaAdicional":"TASA 3686 TASA TINT AMERICANA 71242"},{"id":"2a7c6be8-373a-4fb4-5389-08d5ad2bf6ba","name":"TEXTIL WALFRAN MENEGHEL LTDA","commercialName":"","cnpj":"74297854000118","city":"AMERICANA","stateCode":"SP","buscaAdicional":"WALFRAN 3688 TEXTIL WALF MENEGHEL 71222"},{"id":"801ab5f6-fcb7-47ac-55ed-08d5ad2bf6ba","name":"NICOLETTI TEXTIL LTDA","commercialName":"","cnpj":"43256171000199","city":"AMERICANA","stateCode":"SP","buscaAdicional":"NICOLETTI 6313 NICOLETTI-AMERICANA 71912"},{"id":"1fb3fccb-d4b2-4b4c-5a7f-08d5ad2bf6ba","name":"TECELAGEM JOLITEX LTDA","commercialName":"JOLITEX","cnpj":"43237254000300","city":"AMERICANA","stateCode":"SP","buscaAdicional":"JOLITEX AMERICANA 49790 JOLITEX AMERICANA 897526"},{"id":"8ff24c28-d50d-4724-5a99-08d5ad2bf6ba","name":"NILIT AMERICANA FIBRAS DE POLIAMIDA LTDA.","commercialName":"","cnpj":"21103316000189","city":"AMERICANA","stateCode":"SP","buscaAdicional":"NILIT 50097 NILIT AMERICANA 898100"},{"id":"8ee6d657-fe35-4397-59c5-08d5ad2bf6ba","name":"NEXANS BRASIL S/A","commercialName":"NEXANS BRASIL S/A","cnpj":"31860364001228","city":"AMERICANA","stateCode":"SP","buscaAdicional":"NEXANS BRASIL 15517 NEXANS AMERICANA 7374 NEXANS UNIDADE RIO 70271"},{"id":"b2ed2fae-7845-488a-5e63-08d5ad2bf6ba","name":"INDUSTRIAS TEXTEIS NAJAR LTDA","commercialName":"","cnpj":"43237064000113","city":"AMERICANA","stateCode":"SP","buscaAdicional":"TEXTEIS NAJAR 52347 TEXTEIS NAJAR 899851"},{"id":"eed61322-7a4e-4cea-5d4b-08d5ad2bf6ba","name":"SUPERMERCADOS CAVICCHIOLLI LTDA","commercialName":"SUPERMERCADO SAO VICENTE","cnpj":"43259548000163","city":"AMERICANA","stateCode":"SP","buscaAdicional":"SUPER CAVICCHIOLLI 51774 SUPER SAO VICENTE 1 899858 CAVICCIOLLI LJ 04 899873 CAVICCHIOLLI LJ 06 899876 CAVICCHIOLLI LJ 07 899878 CAVICCHIOLLI LJ 11 899881 CAVICCHIOLLI LJ 18 899882 CAVICCHIOLLI LJ 12 899895 CAVICCHIOLLI LJ 13 899896 CAVICCHIOLLI LJ 19 899898 SUPER S VICENTE L08 900086 SUPER S VICENTE L10 900087 SUPER S VICENTE L16 900134 SUPER S VICENTE L15 900136 SUPER S VICENTE L14 900978 SUPER S VICENTE L03 901001 SUPER S VICENTE L02 901002 SUPER S VICENTE L22 904356 SUPER CAVICCHIOLLI 905197 SUPER SAO VICENTE 17 906920 SUP S VICENTE 5 SALT 910017 SUPER S VICENTE L09 901003"},{"id":"c55b2090-235b-4292-609d-08d5ad2bf6ba","name":"SORVETES SKIMIL & SKIMONI LTDA","commercialName":"SORVETES SKIMONI","cnpj":"43257591000190","city":"AMERICANA","stateCode":"SP","buscaAdicional":"SKIMONI 53616 SORVETES SKIMIL 901838"},{"id":"3e032cf7-fcc7-452f-5492-08d5ad2bf6ba","name":"CIA. BIOENERGETICA SANTA CRUZ 1","commercialName":"BIOENERGETICA SANTA CRUZ","cnpj":"10763227000142","city":"AMÉRICO BRASILIENSE","stateCode":"SP","buscaAdicional":"UTE SANTA CRUZ 4346 UTE STA CRUZ - CARGA 899570 OMETTO 8339 UTE.AI.SP.001609-8.01"},{"id":"fe0c4f30-4e95-4494-4fc2-08d5ad2bf6ba","name":"QUIMICA AMPARO LTDA","commercialName":"","cnpj":"43461789000190","city":"AMPARO","stateCode":"SP","buscaAdicional":"YPE - QUIMICA 1264 QUIMICA AMPARO 7140"},{"id":"67372cb5-3e5d-4de4-5345-08d5ad2bf6ba","name":"ROUSSELOT GELATINAS DO BRASIL LTDA","commercialName":"","cnpj":"06538082000109","city":"AMPARO","stateCode":"SP","buscaAdicional":"ROUSSELOT 3546 ROUSSELOT 71310 ROUSSELOT AMPARO 71333 ROUSSELOT-BAM 889530"},{"id":"e95698f0-b8d0-41cf-5144-08d5ad2bf6ba","name":"CIFA FIOS E LINHAS LTDA","commercialName":"","cnpj":"43461698000155","city":"AMPARO","stateCode":"SP","buscaAdicional":"CIFA 2082 CIFA AMPARO 70482"},{"id":"44416164-6c13-4a9f-5149-08d5ad2bf6ba","name":"MAGNETI MARELLI SISTEMAS AUTOMOTIVOS INDUSTRIA E COMERCIO LTDA","commercialName":"","cnpj":"02990605000798","city":"AMPARO","stateCode":"SP","buscaAdicional":"MMESCAPAMENTOS 2099 MM ESCAPAMENTOS AMP. 70486"},{"id":"b705def5-1f8e-4d5a-57fb-08d5ad2bf6ba","name":"FERNANDEZ SOCIEDADE ANONIMA INDUSTRIA DE PAPEL","commercialName":"FERNANDEZ SA","cnpj":"43468701000162","city":"AMPARO","stateCode":"SP","buscaAdicional":"FERNANDEZ S.A 10330 FERNANDEZ UNID. I 889460 FERNANDEZ UNID. II 889461 FERNANDEZ UNID. III 890385"},{"id":"f970840f-b7c2-4197-6693-08d5ad2bf6ba","name":"B A BARBOSA SUPERMERCADO LTDA","commercialName":"SUPERMERCADO GUARANI","cnpj":"43462720000181","city":"AMPARO","stateCode":"SP","buscaAdicional":"BARBOSA SUPERMERCADO 57670 BARBOSA MATRIZ 908724 BARBOSA FILIAL I 908727 BARBOSA FILIALII 908739 MODELO GBA 913571"},{"id":"3d52f3d8-5827-445c-6871-08d5ad2bf6ba","name":"CASP SA INDUSTRIA E COMERCIO","commercialName":"","cnpj":"61106043000140","city":"AMPARO","stateCode":"SP","buscaAdicional":"CASP 60037 CASP IND E COM 909665"},{"id":"2b371448-ebb5-4f3d-582d-08d5ad2bf6ba","name":"MINERACAO JUNDU LTDA","commercialName":"","cnpj":"60628468002281","city":"ANALÂNDIA","stateCode":"SP","buscaAdicional":"SGJUNANALANDIA 10894 SG MINERACAO JUNDU 889705"},{"id":"04af0ac0-de33-4db7-59d1-08d5ad2bf6ba","name":"TIJOA PARTICIPACOES E INVESTIMENTOS S.A.","commercialName":"","cnpj":"14522198000188","city":"ANDRADINA","stateCode":"SP","buscaAdicional":"TIJOA 15636 TRES IRMAOS 889906 UHE.PH.SP.002873-8.01"},{"id":"d559a7ba-4a8f-4350-593a-08d5ad2bf6ba","name":"BIOENERGIA GASA LTDA.","commercialName":"","cnpj":"18753157000153","city":"ANDRADINA","stateCode":"SP","buscaAdicional":"BIO GASA 14141 GASA CONSUMO 910805 GASA 8366 UTE.AI.SP.027950-1.01"},{"id":"0612e76f-54f4-4a57-659f-08d5ad2bf6ba","name":"CITROPLAST IND E COMERCIO DE PAPEIS E PLASTICOS LTDA","commercialName":"","cnpj":"46149456000380","city":"ANDRADINA","stateCode":"SP","buscaAdicional":"CITROPLAST 56871 CITROPLAST 906721"},{"id":"799facb6-707d-4317-66df-08d5ad2bf6ba","name":"MINERMIX - MINERACAO LTDA","commercialName":"","cnpj":"04548659000138","city":"ANHEMBI","stateCode":"SP","buscaAdicional":"MINERMIX ANHEMBI 57863 MINERMIX CAPIVARI 908736 MINERMIX 909419"},{"id":"b627acb9-885c-4c0c-58cd-08d5ad2bf6ba","name":"MOXBA METALURGICA DO BRASIL LTDA.","commercialName":"MMB METALS","cnpj":"13009445000184","city":"ARAÇARIGUAMA","stateCode":"SP","buscaAdicional":"MMB MOXBA 13332 MOXBA METALURGICA 891802"},{"id":"a3d3842f-5b56-460a-54bc-08d5ad2bf6ba","name":"ISOCOAT TINTAS E VERNIZES LTDA","commercialName":"","cnpj":"69284248000128","city":"ARAÇARIGUAMA","stateCode":"SP","buscaAdicional":"ISOCOAT 4468 ISOCOAT TINTAS-ARACA 71743"},{"id":"bf5b024f-1a3f-416d-5540-08d5ad2bf6ba","name":"METALEX LTDA.","commercialName":"METALEX","cnpj":"03486563000120","city":"ARAÇARIGUAMA","stateCode":"SP","buscaAdicional":"METALEX 5208 METALEX - ARACARIGMA 72115"},{"id":"381f3905-06cd-45b9-5533-08d5ad2bf6ba","name":"COLOR VISAO DO BRASIL INDUSTRIA ACRILICA LIMITADA","commercialName":"COLOR VISAO DO BRASIL","cnpj":"47747969000194","city":"ARAÇATUBA","stateCode":"SP","buscaAdicional":"COLORMAQ 5164 COLORMAQ-ARACATUBA 71800"},{"id":"96fe30d4-54a1-4c39-673d-08d5ad2bf6ba","name":"SUPERMERCADO RONDON LTDA","commercialName":"SUPERMERCADO RONDON LTDA","cnpj":"51010502000991","city":"ARAÇATUBA","stateCode":"SP","buscaAdicional":"SUPERMERCADO RONDON 58012 SUPER RONDON 909442"},{"id":"9a437a3d-fad8-422e-679f-08d5ad2bf6ba","name":"ZBN INDUSTRIA MECANICA LTDA","commercialName":"","cnpj":"64822810000106","city":"ARAÇATUBA","stateCode":"SP","buscaAdicional":"ZBN INDUSTRIA MECANICA 58349 ZBN FUNDICAO 909063 ZBN MATRIZ 909065 ZBN USINAGEM 909078"},{"id":"9a17ee18-05eb-4bf4-658a-08d5ad2bf6ba","name":"UNIMED DE ARACATUBA - COOPERATIVA DE TRABALHO MEDICO","commercialName":"UNIMED DE ARACATUBA","cnpj":"51093193000103","city":"ARAÇATUBA","stateCode":"SP","buscaAdicional":"UNIMED ARACATUBA 56815 UNIMED ARACATUBA 907999"},{"id":"9fe8f576-243d-43c5-642c-08d5ad2bf6ba","name":"CONDOMINIO SHOPPING PRACA NOVA ARACATUBA","commercialName":"","cnpj":"22990102000134","city":"ARAÇATUBA","stateCode":"SP","buscaAdicional":"SHOPPING PRACA NOVA ARACATUBA 55864 SHOP NOVA ARACATUBA 905077"},{"id":"a120ff0c-597e-4e9d-67ac-08d5ad2bf6ba","name":"JOHN BEAN TECHNOLOGIES MAQUINAS E EQUIPAMENTOS INDUSTRIAIS LTDA.","commercialName":"","cnpj":"09688218000155","city":"ARARAQUARA","stateCode":"SP","buscaAdicional":"JOHN BEAN 58414 JOHN BEAN TECH MAQ 909670"},{"id":"b55a37a7-0a17-4864-66eb-08d5ad2bf6ba","name":"ALUMINIO RAMOS INDUSTRIA E COMERCIO LTDA","commercialName":"ALUMINIO RAMOS","cnpj":"45273406000186","city":"ARARAQUARA","stateCode":"SP","buscaAdicional":"ALUMINIO RAMOS 57884 ALUMINIO RAMOS 908873"},{"id":"639c3dff-1a0d-4f5c-6855-08d5ad2bf6ba","name":"HYUNDAI ROTEM BRASIL INDUSTRIA E COMERCIO DE TRENS LTDA.","commercialName":"HYUNDAI ROTEM BRASIL","cnpj":"17866875000173","city":"ARARAQUARA","stateCode":"SP","buscaAdicional":"HYUNDAY ROTEM BRASIL 59830 HYUNDAI ROTEM 911804"},{"id":"716a5ef6-9c23-4891-696f-08d5ad2bf6ba","name":"GNV AROEIRAS LTDA","commercialName":"IGAS","cnpj":"07141961000165","city":"ARARAQUARA","stateCode":"SP","buscaAdicional":"IGAS 61438 GNV AROEIRAS LTDA - 912033"},{"id":"da6862d3-b75a-49de-51a0-08d5ad2bf6ba","name":"CERVEJARIAS KAISER BRASIL S.A.","commercialName":"","cnpj":"19900000001733","city":"ARARAQUARA","stateCode":"SP","buscaAdicional":"KAISER SP 2438 KAISER ARARAQUARA 70591"},{"id":"9cb49c06-9b4d-4b8e-4f7e-08d5ad2bf6ba","name":"IESA PROJETOS, EQUIPAMENTOS E MONTAGENS S/A.","commercialName":"","cnpj":"29918943000856","city":"ARARAQUARA","stateCode":"SP","buscaAdicional":"IESAARARAQUARA 1136 IESA ARARAQUARA 7540"},{"id":"fae22fb5-be4a-447b-50f8-08d5ad2bf6ba","name":"LUPO S.A.","commercialName":"LUPO","cnpj":"43948405000169","city":"ARARAQUARA","stateCode":"SP","buscaAdicional":"LUPO 1926 LUPO MTZ ARARAQUARA 70306"},{"id":"8e9403ed-f1a1-43c1-5960-08d5ad2bf6ba","name":"ZF DO BRASIL LTDA.","commercialName":"ZF DO BRASIL LTDA","cnpj":"59280685001515","city":"ARARAQUARA","stateCode":"SP","buscaAdicional":"ZF ARARAQUARA 14336 ZF ARARAQUARA 71217"},{"id":"838ec7a5-2733-4063-605d-08d5ad2bf6ba","name":"EMPRESA PAULISTA DE EMBALAGENS AGROINDUSTRIAIS LTDA","commercialName":"EPEMA","cnpj":"58426545000144","city":"ARARAQUARA","stateCode":"SP","buscaAdicional":"EPEMA 53479 EMB AGROINDUSTRIAIS 903837"},{"id":"a784c453-9258-44e1-5eee-08d5ad2bf6ba","name":"INDUSTRIA DE PISTOES ROCATTI LTDA.","commercialName":"PISTOES ROCATTI","cnpj":"43949825000160","city":"ARARAQUARA","stateCode":"SP","buscaAdicional":"ROCATTI 52615 PISTOES ROCATTI 899906"},{"id":"b5ba35ff-90ba-42cf-5f78-08d5ad2bf6ba","name":"MINERVA S.A.","commercialName":"MINERVA S.A.","cnpj":"67620377005183","city":"ARARAQUARA","stateCode":"SP","buscaAdicional":"MINERVA ARA 52967 MINERVA ARARAQUARA 904361"},{"id":"9a1498f0-8cbb-4c97-5a97-08d5ad2bf6ba","name":"J O BIOENERGIA S.A.","commercialName":"J O BIOENERGIA","cnpj":"15869520000102","city":"ARARAS","stateCode":"SP","buscaAdicional":"J O BIOENERGIA 50092 UTE N O BIOENERGIA 900778 UTE.AI.SP.032525-2.01"},{"id":"9f722476-eba4-4bda-5bf6-08d5ad2bf6ba","name":"SUCORRICO CITRUS INDUSTRIAL E AGRICOLA LTDA.","commercialName":"SUCORRICO CITRUS INDUSTRIAL E AGRICOLA LTDA.","cnpj":"16930087000136","city":"ARARAS","stateCode":"SP","buscaAdicional":"SUCORRICO 51002 SUCORRICO COLINA 901594 SUCORRICO ARARAS 901615"},{"id":"36c6c701-511a-448f-535a-08d5ad2bf6ba","name":"DAIRY PARTNERS AMERICAS BRASIL LTDA.","commercialName":"","cnpj":"05300331000241","city":"ARARAS","stateCode":"SP","buscaAdicional":"DAIRY 3592 DAIRY PARTNERS-ARAR 71115"},{"id":"a4270772-f3b6-47ef-5393-08d5ad2bf6ba","name":"HELPTECH INDUSTRIA E COMERCIO DE PLASTICOS LTDA","commercialName":"","cnpj":"02577923000136","city":"ARARAS","stateCode":"SP","buscaAdicional":"HELPTECH 3701 HELPTECH 898188"},{"id":"eff94d50-7ded-4248-546e-08d5ad2bf6ba","name":"FOR-PLAS INDUSTRIA DE EMBALAGENS LTDA","commercialName":"","cnpj":"12987182000115","city":"ARARAS","stateCode":"SP","buscaAdicional":"FOR-PLAS 4248 FOR-PLAS INDUSTRIA 911325"},{"id":"c9532c6c-393a-482a-56a5-08d5ad2bf6ba","name":"FEDERAL-MOGUL SISTEMAS AUTOMOTIVOS LTDA.","commercialName":"FEDERAL MOGUL MATERIAIS DE FRICCAO LTDA","cnpj":"00747901000222","city":"ARARAS","stateCode":"SP","buscaAdicional":"F MOGUL ARARAS 7423 FEDERAL MOGUL ARARAS 72258"},{"id":"8993c087-ff4b-4cc3-573c-08d5ad2bf6ba","name":"LOGOPLASTE DO BRASIL LTDA","commercialName":"","cnpj":"00359256001080","city":"ARARAS","stateCode":"SP","buscaAdicional":"LOGOPLASTE 8373 LOGOPLASTE - ARARAS 888549"},{"id":"828da8ca-15e7-4501-574d-08d5ad2bf6ba","name":"ABC GROUP DO BRASIL LTDA","commercialName":"ABC GROUP","cnpj":"02679320000145","city":"ARARAS","stateCode":"SP","buscaAdicional":"ABC GROUP 8510 ABC GROUP - ARARAS 888547"},{"id":"b59982eb-bbb2-4559-626c-08d5ad2bf6ba","name":"ALUMINIO ARARAS LTDA","commercialName":"","cnpj":"51045029000120","city":"ARARAS","stateCode":"SP","buscaAdicional":"ALUMINIO ARARAS 54756 ALUMINIO ARARAS 904108"},{"id":"e0db1fa1-a629-44a3-6242-08d5ad2bf6ba","name":"TEXTIL NORBERTO SIMIONATO S A","commercialName":"","cnpj":"44207389000116","city":"ARARAS","stateCode":"SP","buscaAdicional":"SIMIONATO 54661 TEXTIL SIMIONATO 905658"},{"id":"5498f846-9ac5-4d8c-727f-08d5cf600bef","name":"CONCESSIONARIA DE RODOVIAS DO INTERIOR PAULISTA S/A.","commercialName":"INTERVIAS","cnpj":"03207703000183","city":"ARARAS","stateCode":"SP","buscaAdicional":""},{"id":"1f236382-29ba-4e16-525c-08d5ad2bf6ba","name":"USINA COLOMBO S/A. - ACUCAR E ALCOOL","commercialName":"USINA COLOMBO","cnpj":"44330975000153","city":"ARIRANHA","stateCode":"SP","buscaAdicional":"COLOMBO I5 3022 COLOMBO ARIRANHA 1 908574 COLOMBO ARIRANHA 2 908265 COLOMBO PALESTINA 8882 UTE.AI.SP.030032-2.01 ARIRANHA I 530 UTE.AI.SP.000796-0.01 COLOMBO S ALBERTINA 8790 UTE.AI.SP.030267-8.01 ARIRANHA 895281 UTE.AI.SP.031112-0.01"},{"id":"d211a520-9367-4ffd-673b-08d5ad2bf6ba","name":"PEDREIRA NOGUEIRENSE LTDA","commercialName":"","cnpj":"10795477000164","city":"ARTUR NOGUEIRA","stateCode":"SP","buscaAdicional":"PEDREIRA NOGUEIRENSE 58010 PEDREIRA NOGUEIRENSE 908700"},{"id":"b1531bef-b138-445e-6928-08d5ad2bf6ba","name":"FAIG - FUNDICAO DE ACO INOX LTDA.","commercialName":"FAIG","cnpj":"03122300000131","city":"ARUJÁ","stateCode":"SP","buscaAdicional":"FAIG 60811 FAIG FUND. INOX 02 910798 FAIG FUND. INOX 01 910804"},{"id":"aca3d604-2e46-4251-630c-08d5ad2bf6ba","name":"COMERCIAL ESPERANCA ATACADISTA IMPORTACAO E EXPORTACAO LTDA","commercialName":"COMERCIAL ESPERANCA ATACADISTA","cnpj":"49092398000394","city":"ARUJÁ","stateCode":"SP","buscaAdicional":"COMERCIAL ESPERANCA 55113 COMERCIAL ESPERANCA 907793"},{"id":"bc2ce90e-73af-469b-652b-08d5ad2bf6ba","name":"MEIWA INDUSTRIA E COMERCIO LTDA","commercialName":"","cnpj":"55078307000105","city":"ARUJÁ","stateCode":"SP","buscaAdicional":"MEIWA 56574 MEIWA IND E COM LTDA 906705"},{"id":"e4780087-0fb5-4263-5133-08d5ad2bf6ba","name":"TOWER AUTOMOTIVE DO BRASIL LTDA.","commercialName":"TOWER","cnpj":"61142287000189","city":"ARUJÁ","stateCode":"SP","buscaAdicional":"TOWER AUTOMOTIVE 2045 TOWER AUTOMOTIVE ARU 889840"},{"id":"dda534d5-23d7-4290-570d-08d5ad2bf6ba","name":"SAGE BRASIL INTERIORES AUTOMOTIVOS INDUSTRIA E COMERCIO LTDA.","commercialName":"","cnpj":"11006489000206","city":"ARUJÁ","stateCode":"SP","buscaAdicional":"SAGE 8168 SAGE - ARUJA 72436"},{"id":"51738a64-16d8-4fd7-548b-08d5ad2bf6ba","name":"MAHLE BEHR GERENCIAMENTO TERMICO BRASIL LTDA","commercialName":"","cnpj":"56167091000109","city":"ARUJÁ","stateCode":"SP","buscaAdicional":"MAHLE BEHR 4329 MAHLE BEHR SP 897771"},{"id":"d964373a-729b-451c-5fd0-08d5ad2bf6ba","name":"PREMIUMPLASTIC EMBALAGENS LTDA","commercialName":"PREMIUMPLASTIC","cnpj":"05740789000130","city":"ARUJÁ","stateCode":"SP","buscaAdicional":"PREMIUMPLASTIC 53233 PREMIUMPLASTIC 902315"},{"id":"1019a678-b09a-4d6e-60ba-08d5ad2bf6ba","name":"ST FLEX EMBALAGENS FLEXIVEIS EIRELI","commercialName":"","cnpj":"62877956000123","city":"ARUJÁ","stateCode":"SP","buscaAdicional":"ST FLEX 53650 ST FLEX 906717"},{"id":"2da1c4f9-52ce-43e7-60f6-08d5ad2bf6ba","name":"CASA AVENIDA COMERCIO E IMPORTACAO LTDA.","commercialName":"SUPERMERCADOS AVENIDA","cnpj":"44358067000178","city":"ASSIS","stateCode":"SP","buscaAdicional":"CASA AVENIDA MATRIZ 53920 CASA AVENIDA LJ 26 903556 CASA AVENIDA LJ 14 903557 CASA AVENIDA L 23 903613 CASA AVENIDA LJ 20 903629 CASA AVENIDA LJ 04 903638 CASA AVENIDA LJ 21 903639 CASA AVENIDA LJ 25 903693 CASA AVENIDA LJ 27 903953 CASA AVENIDA LJ 18 907946 CASA AVENIDA LOJA 11 908136 CASA AVENIDA LOJA 08 908137 CASA AVENIDA LOJA 02 908138 CASA AVENIDA LOJA 13 908139 CASA AVENIDA MATRIZ 908140 CASA AVENIDA LOJA 5 908158 CASA AVENIDA LOJA 10 908159 CASA AVENIDA LOJA 07 908160 CASA AVENIDA LOJA 09 908161 CASA AVENIDA LOJA 03 908429 CASA AVENIDA LOJA 12 908430"},{"id":"fccbe9da-1306-49a1-5bd3-08d5ad2bf6ba","name":"SINTO BRASIL PRODUTOS LIMITADA.","commercialName":"SINTO BRASIL PRODUTOS LIMITADA","cnpj":"43735901000304","city":"ATIBAIA","stateCode":"SP","buscaAdicional":"SINTO ATIBAIA 50939 SINTO BRASIL 898101"},{"id":"9b50a538-d3f4-4e8f-63a2-08d5ad2bf6ba","name":"SMART MODULAR TECHNOLOGIES INDUSTRIA DE COMPONENTES ELETRONICOS LTDA.","commercialName":"","cnpj":"06103827000107","city":"ATIBAIA","stateCode":"SP","buscaAdicional":"SMART MODULAR 55488 SMART MODULAR TEC 905171"},{"id":"3232f229-9031-433a-63a3-08d5ad2bf6ba","name":"SMART MODULAR TECHNOLOGIES DO BRASIL - INDUSTRIA E COMERCIO DE COMPONENTES LTDA.","commercialName":"","cnpj":"11576445000130","city":"ATIBAIA","stateCode":"SP","buscaAdicional":"SMART DO BRASIL 55489 SMART MODULAR 905177"},{"id":"42a268e4-1050-4236-6260-08d5ad2bf6ba","name":"SELETA INDUSTRIA E COMERCIO DE PLASTICOS EIRELI","commercialName":"","cnpj":"14311664000186","city":"ATIBAIA","stateCode":"SP","buscaAdicional":"LAR PLASTICOS 54739 LARPLASTICOS 905584 SELETA 913577"},{"id":"cab0c3fa-51c1-4723-65c3-08d5ad2bf6ba","name":"TAUA HOTEL E CONVENTION ATIBAIA LTDA","commercialName":"","cnpj":"13415304000161","city":"ATIBAIA","stateCode":"SP","buscaAdicional":"TAUA HOTEL ATIB 57073 TAUA HOTEL ATIBAIA 906081"},{"id":"a7198476-dd47-45f9-65fa-08d5ad2bf6ba","name":"ACUMENT BRASIL SISTEMAS DE FIXACAO S.A.","commercialName":"","cnpj":"61526836000119","city":"ATIBAIA","stateCode":"SP","buscaAdicional":"ACUMENT 57253 ACUMENT - ATIBAIA SP 907820 ACUMENT - CONTAGEM 911431"},{"id":"f3d6a5ae-d3d4-478d-5870-08d5ad2bf6ba","name":"FRISOKAR EQUIPAMENTOS PLASTICOS S.A.","commercialName":"FRISOKAR S.A.","cnpj":"55088157000102","city":"BARIRI","stateCode":"SP","buscaAdicional":"FRISOKAR 11771 FRISOKAR MATRIZ 890480 FRISOKAR FILIAL 890481"},{"id":"51c0f9b0-f7f6-4dfd-5871-08d5ad2bf6ba","name":"CERANTOLA DO BRASIL INDUSTRIA E COMERCIO LTDA.","commercialName":"","cnpj":"05038737000117","city":"BARIRI","stateCode":"SP","buscaAdicional":"CERANTOLA 11772 CERANTOLA BARIRI 890479"},{"id":"c6901f34-8e11-4ed9-5722-08d5ad2bf6ba","name":"INDUSTRIA DE PLASTICOS BARIRI LTDA","commercialName":"","cnpj":"71527618000152","city":"BARIRI","stateCode":"SP","buscaAdicional":"BARIRI 8245 PLASTICOS BARIRI 888867"},{"id":"683cff13-4c31-46e1-5939-08d5ad2bf6ba","name":"BIOENERGIA BARRA LTDA.","commercialName":"","cnpj":"18788137000118","city":"BARRA BONITA","stateCode":"SP","buscaAdicional":"BIO BARRA 14140 IPAUSSU-CONSUMO 71679 IPAUSSU 8647 UTE.AI.SP.030199-0.01 BARRA (BIO BARRA) 8648 UTE.AI.SP.030047-0.01 BONFIM 8649 UTE.AI.SP.029665-1.01"},{"id":"23379589-a89b-4d2c-5bb6-08d5ad2bf6ba","name":"MARIOL EMBALAGENS LTDA","commercialName":"","cnpj":"09507378000150","city":"BARRETOS","stateCode":"SP","buscaAdicional":"MARIOL EMBALAGENS 50870 MARIOL BARRETOS 898266"},{"id":"3b15a46a-6428-49b4-5baf-08d5ad2bf6ba","name":"S.R. EMBALAGENS PLASTICAS LTDA","commercialName":"","cnpj":"50418557000115","city":"BARRETOS","stateCode":"SP","buscaAdicional":"SR BARRETOS 50828 EMBALAGENS BARRETOS 898248"},{"id":"3d248c29-1636-4b7c-56cf-08d5ad2bf6ba","name":"FUNDACAO PIO XII","commercialName":"FUNDACAO PIO XII","cnpj":"49150352000112","city":"BARRETOS","stateCode":"SP","buscaAdicional":"HOSP CANCER 7761 HOSP. CANCER BARRETO 72362 HOSP CANCER 4 904634 HOSP CANCER 6 904635 HOSP CANCER 7 904636 HOSP CANCER 5 904750"},{"id":"6f024cd8-e5dd-433e-564a-08d5ad2bf6ba","name":"NORTH SHOPPING BARRETOS SPE LTDA.","commercialName":"","cnpj":"11754427000100","city":"BARRETOS","stateCode":"SP","buscaAdicional":"NORTH SHOP 6840 NORTH SHOP BARRETOS 72180"},{"id":"23e48c3d-7b59-4b44-52ae-08d5ad2bf6ba","name":"MINERVA DAWN FARMS INDUSTRIA E COMERCIO DE PROTEINAS S/A","commercialName":"","cnpj":"09104182000115","city":"BARRETOS","stateCode":"SP","buscaAdicional":"MDF 3226 DAWN FARMS 71068"},{"id":"fd49d88b-05a9-4fa9-50df-08d5ad2bf6ba","name":"MINERVA S.A.","commercialName":"","cnpj":"67620377000114","city":"BARRETOS","stateCode":"SP","buscaAdicional":"MINERVA BARRET 1880 MINERVA J BONIFACIO 70523 MINERVA BARRETOS 70240 MINERVA PALMEIRAS GO 70898"},{"id":"016cf9e6-679f-44e1-6294-08d5ad2bf6ba","name":"MARIOL INDUSTRIAL LTDA","commercialName":"","cnpj":"04656253000179","city":"BARRETOS","stateCode":"SP","buscaAdicional":"MARIOL INDUSTRIAL 54808 MARIOL INDUSTRIAL 906053"},{"id":"30066486-c39b-4ce9-6298-08d5ad2bf6ba","name":"COMPANHIA CACIQUE DE CAFE SOLUVEL","commercialName":"DIVISAO ALIMENTOS","cnpj":"78588415002088","city":"BARUERI","stateCode":"SP","buscaAdicional":"CACIQUE BARUERI 54812 CIA CACIQUE CAFE SOL 906338"},{"id":"41fc5c87-e5b3-478b-627e-08d5ad2bf6ba","name":"BK BRASIL OPERACAO E ASSESSORIA A RESTAURANTES S.A.","commercialName":"","cnpj":"13574594000196","city":"BARUERI","stateCode":"SP","buscaAdicional":"BURGER KING 54784 BURGER KING FLORIDA 906391 BURGER KING CAMPINAS 906392 BURGER KING PORTUGAL 906400 BURGER KING CAMP NS 906413 BURGER KING BARAO 906414 BURGER KING BADY BAS 906417 BURGER KING ARACATUB 906424 BK SOROCABA DRIVE 906597 BK DRIVE MARILIA 910306 BK JOHN BOYD 910307 BK SANTA BARBARA 910310 BK PIR DRIVE 910390 BK JAU 910499 BK LUGANO VINHEDO DR 910533 BK MARGINAL TIETE 910899 BK BIG BOM MOGI GUA 911612 BK JD CLAR RIO CLARO 911613 BK S J DA BOA VISTA 911615 BK GAVIAO PEIXOTO II 910636 BK BARRA MANSA 912115 BK AMERICAS RECREIO 912801 BK VOLUNTARIOS 913499"},{"id":"a47cdae5-782a-4083-6151-08d5ad2bf6ba","name":"UNIMIN DO BRASIL LTDA","commercialName":"SIBELCO BRASIL","cnpj":"56139066000111","city":"BARUERI","stateCode":"SP","buscaAdicional":"UNIMIN 54120 UNIMIN JAGUARUNA 903038"},{"id":"f630316c-8ec8-4f1b-61dc-08d5ad2bf6ba","name":"ALPHAVILLE TENIS CLUBE","commercialName":"ATC","cnpj":"48745913000163","city":"BARUERI","stateCode":"SP","buscaAdicional":"ALPHAVILLE TENIS CLUBE 54450 ALPHAVILLE TENIS CLU 905546"},{"id":"b479a57d-d09e-4ea3-6572-08d5ad2bf6ba","name":"SOCIEDADE BIBLICA DO BRASIL","commercialName":"","cnpj":"33579376000151","city":"BARUERI","stateCode":"SP","buscaAdicional":"SBB 56730 SOCIEDADE BIBLICA BR 907955"},{"id":"24d28cec-0be4-4f56-64c8-08d5ad2bf6ba","name":"V.M. BUSINESS IMOVEIS EMPREENDIMENTOS E PARTICIPACOES EIRELI","commercialName":"V.M. BUSINESS HOLDING","cnpj":"14214354000143","city":"BARUERI","stateCode":"SP","buscaAdicional":"BUSINESS 56219 BUSINESS 01 906988 BUSINESS 02 907021 BUSINESS 03 907022 BUSINESS 6281848 908068 BUSINESS 04 908556 BUSINESS 05 908557"},{"id":"e48ca53f-3ce1-4795-65a4-08d5ad2bf6ba","name":"INDUSTRIA GRAFICA BRASILEIRA LTDA","commercialName":"","cnpj":"61418141000113","city":"BARUERI","stateCode":"SP","buscaAdicional":"IGB 56900 IGB CAIAPOS 907609 IGB ARAPOEMA 907610"},{"id":"be8537c8-7953-470c-669f-08d5ad2bf6ba","name":"BRASILGRAFICA S/A INDUSTRIA E COMERCIO","commercialName":"","cnpj":"61192696000190","city":"BARUERI","stateCode":"SP","buscaAdicional":"BRASILGRAFICA 57696 BRASILGRAFICA 907836"},{"id":"7c5d6f17-33cd-4b69-6778-08d5ad2bf6ba","name":"CONDOMINIO COMPLEXO MADEIRA.","commercialName":"CONDOMINIO COMERCIAL","cnpj":"22575576000110","city":"BARUERI","stateCode":"SP","buscaAdicional":"TORRE COMERCIAL ALPHAVILLE 58170 COMPLEXO MADEIRA ALP 907463"},{"id":"6327f1a4-63fb-48e1-66dc-08d5ad2bf6ba","name":"DAIICHI SANKYO BRASIL FARMACEUTICA LTDA.","commercialName":"SANKYO","cnpj":"60874187000184","city":"BARUERI","stateCode":"SP","buscaAdicional":"DAIICHI 57860 DAIICHI BARUERI 909072"},{"id":"e77e04f4-6eb9-458e-6712-08d5ad2bf6ba","name":"CONDOMINIO COMPLEXO MADEIRA","commercialName":"CONDOMINIO RESIDENCIAL","cnpj":"22456758000171","city":"BARUERI","stateCode":"SP","buscaAdicional":"BLUE TREE ALPHAVILLE 57947 COMPLEXO MADEIRA 907462"},{"id":"ac1bece4-86b5-4c1d-6916-08d5ad2bf6ba","name":"FOXX URE-BA AMBIENTAL LTDA","commercialName":"BARUERI ENERGIA","cnpj":"14641895000158","city":"BARUERI","stateCode":"SP","buscaAdicional":"FOXX URE-BA 60764"},{"id":"be4cdeac-acd3-4f0e-6917-08d5ad2bf6ba","name":"CONDOMINIO MEDIC LIFE","commercialName":"","cnpj":"15682436000185","city":"BARUERI","stateCode":"SP","buscaAdicional":"CONDOMINIO MEDIC LIFE 60765 MEDIC LIFE 911751"},{"id":"cbf3d4f6-46c4-4fc7-8862-08d5ae44ed50","name":"HEWLETT-PACKARD BRASIL LTDA","commercialName":"","cnpj":"61797924000155","city":"BARUERI","stateCode":"SP","buscaAdicional":"HP 4602"},{"id":"095f266f-7ac7-4abc-8880-08d5ae44ed50","name":"SPUMAPAC - INDUSTRIAL E DISTRIBUIDORA DE ARTEFATOS PLASTICOS LTDA","commercialName":"","cnpj":"04861729000294","city":"BARUERI","stateCode":"SP","buscaAdicional":"SPUMAPAC 9270"},{"id":"a4f87080-bd22-4290-7254-08d5cf600bef","name":"CONCESSIONARIA DE RODOVIAS DO OESTE DE SAO PAULO - VIAOESTE S/A","commercialName":"VIAOESTE","cnpj":"02415408000150","city":"BARUERI","stateCode":"SP","buscaAdicional":""},{"id":"c8087934-1081-4775-7234-08d5cf600bef","name":"BV LEASING - ARRENDAMENTO MERCANTIL S/A","commercialName":"BV LEASING","cnpj":"01858774000110","city":"BARUERI","stateCode":"SP","buscaAdicional":""},{"id":"25115818-b6d5-49ab-7235-08d5cf600bef","name":"CSU CARDSYSTEM S/A","commercialName":"","cnpj":"01896779000138","city":"BARUERI","stateCode":"SP","buscaAdicional":""},{"id":"50f092b1-f5b1-4afb-7236-08d5cf600bef","name":"AES ELPA S/A","commercialName":"","cnpj":"01917705000130","city":"BARUERI","stateCode":"SP","buscaAdicional":""},{"id":"952dd769-1efc-45e6-7224-08d5cf600bef","name":"CIELO S.A.","commercialName":"","cnpj":"01027058000191","city":"BARUERI","stateCode":"SP","buscaAdicional":""},{"id":"ccc0e5f9-f056-4152-7313-08d5cf600bef","name":"MULTIPLUS S.A.","commercialName":"","cnpj":"11094546000175","city":"BARUERI","stateCode":"SP","buscaAdicional":""},{"id":"ee4f2013-de4e-4862-7391-08d5cf600bef","name":"NUTRIPLANT INDUSTRIA E COMERCIO S/A","commercialName":"","cnpj":"51128999000190","city":"BARUERI","stateCode":"SP","buscaAdicional":""},{"id":"3c84f493-428a-42d2-739d-08d5cf600bef","name":"ODONTOPREV S.A.","commercialName":"","cnpj":"58119199000151","city":"BARUERI","stateCode":"SP","buscaAdicional":""},{"id":"cd5427f4-a47e-4736-8d9b-08d5d060706e","name":"AGEL ANEIS GAXETAS EQUIPAMENTOS LTDA","commercialName":"","cnpj":"51938702000151","city":"BARUERI","stateCode":"SP","buscaAdicional":"AGEL MAT 61390 AGEL ANEIS 913400"},{"id":"4d5ba48a-5fa5-4788-6812-08d5d153df4d","name":"SMILES FIDELIDADE S.A.","commercialName":"WEBJET","cnpj":"05730375000120","city":"BARUERI","stateCode":"SP","buscaAdicional":""},{"id":"56db658f-31b0-4870-73c7-08d5cf600bef","name":"CCB BRASIL ARRENDAMENTO MERCANTIL S/A","commercialName":"","cnpj":"69720910000145","city":"BARUERI","stateCode":"SP","buscaAdicional":""},{"id":"1a1e4220-5b6e-417f-4f09-08d5d159243d","name":"BRQ SOLUCOES EM INFORMATICA S.A","commercialName":"","cnpj":"36542025000164","city":"BARUERI","stateCode":"SP","buscaAdicional":""},{"id":"b50703c2-afea-494f-6817-08d5d153df4d","name":"BRASILIANA PARTICIPACOES S. A.","commercialName":"","cnpj":"08773191000136","city":"BARUERI","stateCode":"SP","buscaAdicional":""},{"id":"e520ef2c-32b6-4e41-4ed6-08d5d159243d","name":"AZUL S.A.","commercialName":"","cnpj":"09305994000129","city":"BARUERI","stateCode":"SP","buscaAdicional":""},{"id":"1db2dab5-6034-4a39-50a9-08d5ad2bf6ba","name":"JACOBS DOUWE EGBERTS BR COMERCIALIZACAO DE CAFES LTDA.","commercialName":"","cnpj":"02333707000145","city":"BARUERI","stateCode":"SP","buscaAdicional":"DEMB JUNDIAI 1772 SARA LEE JUNDIAI 70158"},{"id":"e02cd476-f1dc-4831-4f7f-08d5ad2bf6ba","name":"LINDE GASES LTDA","commercialName":"","cnpj":"60619202000148","city":"BARUERI","stateCode":"SP","buscaAdicional":"LINDE GASES 1137 LINDE SANTA CRUZ 7883 LINDE GAN RIO 72022 ASU SALVADOR LG 888450 AGA JUNDIAI 13KV 70043 LINDE GASES EI SBC 911760 LINDE GASES RJ BF 907851 ASU CURITIBA 891803 ASU-TIMOTEO 7768 AGA CUBATAO 7242"},{"id":"7b4e1ea4-d415-4f05-4f00-08d5ad2bf6ba","name":"ELETROPAULO METROPOLITANA ELETRICIDADE DE SAO PAULO S.A.","commercialName":"ELETROPAULO METROPOLITANA","cnpj":"61695227000193","city":"BARUERI","stateCode":"SP","buscaAdicional":"ELETROPAULO 49 ELETROPAULO 10 ELETROPAULO DITCSP 72305"},{"id":"bedec731-deb8-485b-524a-08d5ad2bf6ba","name":"NORTENE PLASTICOS LTDA","commercialName":"","cnpj":"46188199000124","city":"BARUERI","stateCode":"SP","buscaAdicional":"NORTENE 2992 NORTENE-BARUERI 70927"},{"id":"bbfe30e9-e62d-4ce9-51a9-08d5ad2bf6ba","name":"SAFIRA ADMINISTRACAO E COMERCIALIZACAO DE ENERGIA S.A.","commercialName":"SAFIRA COMERCIALIZADORA","cnpj":"09495582000107","city":"BARUERI","stateCode":"SP","buscaAdicional":"SAFIRA COM 2473"},{"id":"aa02c5d7-2cda-41a5-51e8-08d5ad2bf6ba","name":"ENERCASA - ENERGIA CAIUA S/A","commercialName":"","cnpj":"09217210000100","city":"BARUERI","stateCode":"SP","buscaAdicional":"ENERCASA 2715 DECASA 8637 UTE.AI.SP.028051-8.01"},{"id":"ddaa9add-1f92-4d34-565c-08d5ad2bf6ba","name":"AGEL ANEIS GAXETAS EQUIPAMENTOS LTDA","commercialName":"","cnpj":"51938702000232","city":"BARUERI","stateCode":"SP","buscaAdicional":"AGEL 6957 AGEL-BARUERI 72240"},{"id":"5b63be7e-5209-497d-5663-08d5ad2bf6ba","name":"WAL MART BRASIL LTDA","commercialName":"","cnpj":"00063960000109","city":"BARUERI","stateCode":"SP","buscaAdicional":"WALMART BRASIL 6999 WALMART AGUAS CLARAS 72192 WALMART RIB PRETO 72193 WALMART 1029 888507 WAL 3710 - CONTAGEM 888508 WAL 1016 - SOROCABA 888509 WAL 1274 - PAMPULHA 888510 WALMART S089 888636 WALMART 1047 888637 WALMART 2801 889455 WAL MART 1022 889456 WALMART 1018 889615 HO BARUERI 889820 WALMART RIBEIRAO PRE 889821 WALMART CAMPINAS 889822 WALMART BETIM 890386 WALMART PIRACICABA 890899 WALMART 1017 890900 WM 3700 SUPERCENT SB 908218 WM 3702 SUPERCENTER 908236 SUPERCENTER ITU 1307 908342 SUPERCENTER LIMEIRA 908387 3705 SUPERCENTER PAC 908554 SUPERCENTER VITORIA 908659 1039 SUPERCENTER CGY 910277 6268 SAMS NITEROI 910335 1001 SUPERCENTER IND 910351 1308 SUPERCENTER PRD 910375 4933 SAMS VITORIA 910376 WALMART ARARAS 910377 1019 SUPERCENTER MRB 910503 WALMART NORTE 910560 WAL VILA LEOPOLDINA 910570 WALMART 1008 SUPERCE 910579 WAL ARICANDUVA 910591 WALMART 4938 SAMS 910621 WALMART 113 SUPERCEN 910701 WALMART 1023 GRANJA 910703 WALMART 1005 TAMBORE 910704 1007 SUPERCENTER 910794 2800 SUPERCENTER 910795 1200 SUPERCENTER 910843 WALMART ASSIS 911315 1146 SUPERCENTER UBE 911702 WALMART WASHINGTON 911777 SUPERCENTER JACAREI 911903 WALMART 5837 888577 WALMART 5724 888676 WALMART 3706 888897 WALMART SAMS BARIGU 908679 WALMART SAMS ATUBA 908680 WALMART 4936 895004 4941 SAMS RECIFE 910378 WALMART AMERICANA 890914 WALMART 1519 SUPERCE 912571 6278 SAMS CONTAGEM 912796"},{"id":"e42e60b0-b329-4764-55d1-08d5ad2bf6ba","name":"CONDOMINIO SHOPPING CENTER IGUATEMI ALPHAVILLE","commercialName":"CONDOMINIO SHOPPING CENTER IGUATEMI ALPHAVILLE","cnpj":"13966712000101","city":"BARUERI","stateCode":"SP","buscaAdicional":"IGUATEMI ALPHA 6221 IGUATEMI-ALPHAVILLE 71939"},{"id":"4d98ab66-52bf-4f51-55df-08d5ad2bf6ba","name":"CONSÓRCIO CONDOMÍNIO TAMBORÉ","commercialName":"","cnpj":"08984503000150","city":"BARUERI","stateCode":"SP","buscaAdicional":"SHOP TAMBORE 6270 SHP TAMBORE-BARUERI 72292"},{"id":"e7c0d962-877d-4e54-55ad-08d5ad2bf6ba","name":"CONDOMINIO CIVIL VOLUNTARIO DO 'PARQUE SHOPPING BARUERI '","commercialName":"","cnpj":"10387288000152","city":"BARUERI","stateCode":"SP","buscaAdicional":"PARQUE BARUERI 5998 SHOPPING BARUERI 71689"},{"id":"b9bb19a1-c0e9-4e9a-562a-08d5ad2bf6ba","name":"SAO ROQUE ENERGETICA S.A.","commercialName":"","cnpj":"15116321000123","city":"BARUERI","stateCode":"SP","buscaAdicional":"SAO ROQUE 6717"},{"id":"93f9a7dd-1fd9-4e17-5756-08d5ad2bf6ba","name":"CAMPARI DO BRASIL LTDA","commercialName":"","cnpj":"50706019000126","city":"BARUERI","stateCode":"SP","buscaAdicional":"CAMPARI 8609 CAMPARI SOROCABA 888318"},{"id":"d300e867-3f00-4fc7-5416-08d5ad2bf6ba","name":"C&A MODAS LTDA.","commercialName":"C E A","cnpj":"45242914000105","city":"BARUERI","stateCode":"SP","buscaAdicional":"C&A MODAS LTDA 3999 C&A MODAS RAO220 RPO 71433 CA MODAS SJRP 71435 C&A MODAS-JUNDIAI-SP 71436 CAS210-IGUATEMI-CAMP 71442 C&A N SHOP R PRETO 71496 CA-SHOP ATLANTICO 71511 CA BANGU SHOPPING-RJ 71548 CA ARA 363 S JARAGUA 71603 CA TIV183 S BARBARA 71604 CA SPI395 SHOP PIRAC 71605 CA BAU363 BAURU SHOP 71606 C&A TIJ510 CENTRO RJ 71652 C&A CDR050 CENTRO RJ 71653 C&A BARRA SHOP 71680 C&A GRANDE RIO 71681 C&A WEST PLAZA 71700 C&A SHOPP BONSUCESSO 71709 C&A W SHOPPING RIO 71710 C&A-RUA GOITACAZES 71718 C&A-AV PARANA MG 71719 C&A CAXIAS SHOP D 71744 C&A SHOP GRANDE RIO 71745 C&A NORTE SHOPPING 71746 C&A-MDU540 71834 C&A MINAS SHP-BHM640 71848 C&A CAMPO GRANDE 72056 C&A NILOPOLIS 72057 C&A PRAIA DA COSTA 888109 C&A SHOP INDAIATUBA 888110 C&A UBERABA SHOPP 888433 C&A SHOP M ALVARO 888689 C&A MONTES CLAROS 888691 C&A BOULEVARD SHOP 888692 C&A SHOP 7 LAGOAS 888693 C&A VITORIA 888724 C&A SHOP HORTOLANDIA 888895 C&A LJ. SCS197 888982 C&A MAR573 888996 C&A SJC 230 889442 C&A TBT 165 889444 C&A LITORAL PGS185 889810 C&A ILHA GOV SHOP 890602 PATIO MIX ITAGUAI 890755 FCA163 FRANCA SHOP 891142 C&A SHOPPING PARQUE 891264 C&A SIDER SHOP 892482 CEA 653 MOXUARA 898045 C&A VMS649 900354 C&A MODAS GYN710 900379 CEA SHOP PLAZA SUL 900925 C&A MODAS ARI290 901655 C&A MODAS EC010 901676 C&A MODAS VVE656 902001 C&A MODAS NIT560 903354 C&A MODAS CPP592 903753 C&A MODAS CGE225 903845 C&A MODAS CGC227 904340 C&A MODAS GPA123 904595 C&A MODAS NOV580 904861 C&A MODAS UBC707 905296 C&A MODAS JFC615 905321 C&A MODAS AME536 905525 CEA MODAS CPB287 906362 C&A MODAS GBU705 906409 C&A MODAS ALC323 906437 C&A MODAS BHE763 906524 C&A MODAS UBE605 906531 C&A MODAS BET713 907071 CEA MODAS IPS645 907585 CEA MODAS SHC703 907587 C&A MODAS ACT237 907912 CEA MODAS BHD630 909365 C&A CENTRO-SBC 71824 C&A SHOP INTERLAGOS 71958 CEA SHOPG ITAQUERA 72118 C&A MAUA PLAZA SHOP 888112 C&A GUA355 889441 C&A MRB140 MORUMBI 899506 C&A MODAS SMO153 899526 C&A MODAS CAC200 900381 C&A MODAS CDT020 901621 C&A CBC400 888944 C&A IGUATEMI CXS563 889808 C&A SHOPPING CATUAI 890730 C&A MODAS S PAC300 900913 CEA SHOPP CURITIBA 900923 CEA SHOPP PALLADIUM 900958 C&A MODAS S PEL350 901185 C&A MODAS S FLC777 901442 C&A MODAS S BCA303 901637 C&A MODAS S JOI247 901638 C&A MODAS S PAB310 902094 CEA MODAS N SLS439 900059 C&A MODAS N BEC425 901175 C&A MODAS N MBA737 901177 C&A MODAS N SLC505 902216 C&A MODAS N SRA507 904045 C&A MODAS N SLI407 904046 C&A MODAS N IPZ417 904058 C&A MODAS N BEL635 904756 C&A MODAS AMAZONAS 906294 CEA MODAS SLZ435 906606 C&A MODAS N MAC695 907114 CEA NORTE STR736 907705 CEA MODAS BBO427 907978 CEA MODAS N BEI430 909952 C&A MODAS -SALVADOR 71440 C&A MODAS NE RET750 898526 C&A MODAS 480 898950 CEA BOA VIAGEM 900924 C&A MODAS NE FEI495 901179 C&A MODAS CPC665 901395 C&A MODAS NE VCO437 901499 C&A MODAS NE ITB497 901518 C&A MODAS NE SVB490 902913 C&A MODAS NE REI485 903573 C&A MODAS NE REG475 903678 C&A MODAS NE FOC420 903715 C&A MODAS NE FOS380 903957 C&A MODAS WASHINGTON 904037 C&A MODAS NE AJR327 904341 C&A MODAS NE NAM 765 904411 C&A MODAS NE FOP688 904754 C&A MODAS NE TEC335 904773 C&A MODAS NAS575 905757 C&A MODAS NE MNU689 905798 CEA MODAS AJU660 908307 CEA MODAS NE JOA670 910366 C&A MODAS BRX566 912132 C&A SHOP VIA BRASIL 892251 C&A MODAS BVN766 904496 C&A MODAS S ANT399 901184 C&A MODAS NIR797 912814"},{"id":"41862029-b5f2-4852-53bf-08d5ad2bf6ba","name":"SAFIRA GESTAO E CONSULTORIA EM ENERGIA LTDA","commercialName":"","cnpj":"11482752000152","city":"BARUERI","stateCode":"SP","buscaAdicional":"SAFIRA GEST 3822"},{"id":"c2197187-89f8-4668-551e-08d5ad2bf6ba","name":"ESTOK COMERCIO E REPRESENTACOES S.A.","commercialName":"TOK & STOK","cnpj":"49732175000182","city":"BARUERI","stateCode":"SP","buscaAdicional":"TOK E STOK 5070 TOK E STOK B TIJUCA 71716 TOK E STOK MARGINAL 72224 TOK STOK FLORIA SC 898580 TOK STOK POA 899697 TOK STOK CURITIBA 900926 TOK STOK CAMPINAS 898068 TOK E STOK SOROCABA 898087"},{"id":"88075bdd-c5b7-4aae-54d3-08d5ad2bf6ba","name":"GUALA CLOSURES DO BRASIL LTDA.","commercialName":"","cnpj":"46664330000182","city":"BARUERI","stateCode":"SP","buscaAdicional":"GUALA 4521 GUALA-BARUERI SP 71625"},{"id":"33d82c80-b02b-49bc-5c7a-08d5ad2bf6ba","name":"AES TIETE ENERGIA S.A.","commercialName":"","cnpj":"04128563000110","city":"BARUERI","stateCode":"SP","buscaAdicional":"AES TIETE ENERGIA 51341 AGUA VERMELHA 321 UHE.PH.MG.000041-8.01 EUCLIDES DA CUNHA 328 UHE.PH.SP.000923-7.01 LIMOEIRO 329 UHE.PH.SP.001328-5.01 MOGI GUACU 330 PCH.PH.SP.001479-6.01 S JOAQUIM(AES TIETE) 8894 PCH.PH.SP.028826-8.01 SAO JOSE (AES TIETE) 8969 PCH.PH.SP.028823-3.01 BARRA BONITA 322 UHE.PH.SP.000208-9.01 BARIRI 323 UHE.PH.SP.000203-8.01 IBITINGA 324 UHE.PH.SP.001097-9.01 PROMISSAO 325 UHE.PH.SP.002158-0.01 NOVA AVANHANDAVA 326 UHE.PH.SP.001552-0.01 GRAMINHA 327 UHE.PH.SP.000588-6.01"},{"id":"ba6a8b50-46a7-46dc-5a6d-08d5ad2bf6ba","name":"TECIPAR ENGENHARIA E MEIO AMBIENTE LTDA.","commercialName":"","cnpj":"61149829000145","city":"BARUERI","stateCode":"SP","buscaAdicional":"TECIPAR 17451 TECIPAR 898541 UTE.RU.SP.035080-0.01"},{"id":"349a44c8-f95b-45ab-59c7-08d5ad2bf6ba","name":"OT COMERCIALIZADORA DE ENERGIA LTDA.","commercialName":"","cnpj":"20240096000172","city":"BARUERI","stateCode":"SP","buscaAdicional":"OT ENERGIA 15555"},{"id":"eb8634da-bf8d-40c9-59f1-08d5ad2bf6ba","name":"TELEFONICA DATA S.A.","commercialName":"","cnpj":"04027547003661","city":"BARUERI","stateCode":"SP","buscaAdicional":"TELEFONICA DATA 16055 TELEF. EMP. BARUERI 70110"},{"id":"3754e235-0faf-4304-5a45-08d5ad2bf6ba","name":"RHOTOPLAS INDUSTRIA E COMERCIO DE EMBALAGENS LTDA","commercialName":"","cnpj":"64822521000107","city":"BARUERI","stateCode":"SP","buscaAdicional":"RHOTOPLAS MATRIZ 17248 RHOTOPLAS 71171"},{"id":"bbc559af-5de1-4c1d-57fa-08d5ad2bf6ba","name":"DU PONT DO BRASIL S A","commercialName":"DU PONT","cnpj":"61064929000179","city":"BARUERI","stateCode":"SP","buscaAdicional":"DUPONT 10312 DUPONT MATRIZ 890093 DU PONT-FORMOSA-GO 910524"},{"id":"566b2c91-dbe0-4b8e-608c-08d5ad2bf6ba","name":"CONDOMINIO ITOWER IGUATEMI ALPHAVILLE","commercialName":"CONDOMINIO ITOWER IGUATEMI ALPHAVILLE","cnpj":"13805493000189","city":"BARUERI","stateCode":"SP","buscaAdicional":"COND ITOWER 53584 COND ITOWER 902275"},{"id":"717fdf60-d9a6-4e25-6042-08d5ad2bf6ba","name":"DESLEECLAMA BRAZIL INDUSTRIA E COMERCIO DE ARTIGOS TEXTEIS LTDA","commercialName":"DESLEECLAMA BRAZIL","cnpj":"04816261000135","city":"BARUERI","stateCode":"SP","buscaAdicional":"DESLEECLAMA 53439 DESLEECLAMA SUMARE 900604"},{"id":"06aa26d8-ff6c-4ffe-6014-08d5ad2bf6ba","name":"SARPAV-MINERADORA LTDA","commercialName":"","cnpj":"66742636000117","city":"BARUERI","stateCode":"SP","buscaAdicional":"SARPAV 53370 SARPAV 904547"},{"id":"a4da7910-7112-4edd-5f81-08d5ad2bf6ba","name":"DIAGNOSTICOS DA AMERICA S.A .","commercialName":"","cnpj":"61486650000183","city":"BARUERI","stateCode":"SP","buscaAdicional":"DASA 53003 DASA RICARDO JAFET 903764 DASA JURUA 903788 DASA COPACABANA 903897 DASA LEBLON 904180 DASA ITACAIUNA 904512 DASA DARZAN 905564 DASA SERRA BRAGANCA 909076 DASA ILHA DO GOVERNA 910694 DASA IPANEMA II 910849"},{"id":"557cb87f-27f4-45b4-5f67-08d5ad2bf6ba","name":"MICROSERVICE TECNOLOGIA DIGITAL LTDA","commercialName":"","cnpj":"43359926000180","city":"BARUERI","stateCode":"SP","buscaAdicional":"MICROSERVICE SP 52929 MICROSERVICE 904216"},{"id":"8b26f009-4947-4d3d-5f90-08d5ad2bf6ba","name":"GRAFICA EDITORA AQUARELA LTDA","commercialName":"GRAFICA AQUARELA","cnpj":"60794732000122","city":"BARUERI","stateCode":"SP","buscaAdicional":"GRAFICA AQUARELA 53023 GRAFICA AQUARELA 901797"},{"id":"dbc22e2d-4bfd-4d31-5f5a-08d5ad2bf6ba","name":"HEINZ BRASIL S.A.","commercialName":"","cnpj":"50955707000120","city":"BARUERI","stateCode":"SP","buscaAdicional":"HEINZ 52910 HEINZ CD 900937 HEINZ ETE GO 900977 HEINZ BRASIL FABRICA 900979"},{"id":"59b174c1-b667-4589-5e0c-08d5ad2bf6ba","name":"ARFRIO S/A ARMAZENS GERAIS FRIGORIFICOS","commercialName":"","cnpj":"61024295000120","city":"BARUERI","stateCode":"SP","buscaAdicional":"ARFRIO 52181 ARFRIO SA ARMAZENS 900813 ARFRIO SANTOS I 901982 ARFRIO BRX I 902073 ARFRIO ITAJAI 905475 ARFRIO BRX III 905499 ARFRIO QUEIMADOS 905696 ARFRIO (SANTOS II) 910627"},{"id":"a5dc9e03-fba2-4451-6879-08d5ad2bf6ba","name":"CARNEMI FUNDICAO INDUSTRIA E COMERCIO LTDA","commercialName":"","cnpj":"55892905000105","city":"BATATAIS","stateCode":"SP","buscaAdicional":"CARNEMI 60095 CARNEMI BATATAIS 910196"},{"id":"08aba528-e782-4ad4-66cf-08d5ad2bf6ba","name":"SUPERMERCADO REAL DE BATATAIS LTDA","commercialName":"SUPEMERCADO REAL","cnpj":"00163986000110","city":"BATATAIS","stateCode":"SP","buscaAdicional":"REAL SUPERMERCADOS 57836 REAL SUPERMERCADO 03 909179 REAL SUPER LJ 01 910875"},{"id":"b418572c-2a1d-417d-667b-08d5ad2bf6ba","name":"JOSE CARLOS NORI & CIA LTDA","commercialName":"SUPERMERCADO","cnpj":"60177862000116","city":"BATATAIS","stateCode":"SP","buscaAdicional":"SUPERMERCADOS NORI 57618 NORI AEROPORTO 909594 NORI DOS PUPIN 909595 NORI NOVA LIDIA 909596 NORI ALTINOPOLIS 909597 NORI CENTRO 909598 NORI VILA MARIA 909599"},{"id":"7c4db577-1835-4d7f-67a5-08d5ad2bf6ba","name":"STAR TEMPER VIDROS LTDA","commercialName":"STAR TEMPER","cnpj":"04666832000100","city":"BAURU","stateCode":"SP","buscaAdicional":"STAR TEMPER 58394 STAR TEMPER BAURU 908454"},{"id":"21494eda-2153-43c5-68db-08d5ad2bf6ba","name":"PEDREIRA NOVA FORTALEZA LTDA","commercialName":"PEDREIRA NOVA FORTALEZA","cnpj":"46082624000104","city":"BAURU","stateCode":"SP","buscaAdicional":"PEDREIRA NOVA FORTALEZA MATRIZ 60494 PEDREIRA NV FTZ 910148"},{"id":"43259f8f-c9bf-446d-6381-08d5ad2bf6ba","name":"J. BUENO E MANDALITI SOCIEDADE DE ADVOGADOS","commercialName":"","cnpj":"10508423000170","city":"BAURU","stateCode":"SP","buscaAdicional":"JBM 55418 J. BUENO E MANDALITI 906676 JBM PEDERNEIRAS 911787"},{"id":"f1f074ad-7bc0-4b4c-634e-08d5ad2bf6ba","name":"SUPERMERCADO VIEIRA DIAS DA SILVA DE BAURU LTDA","commercialName":"","cnpj":"69061547000101","city":"BAURU","stateCode":"SP","buscaAdicional":"SUPERMERCADO PANELAO 55300 PANELAO LOJA 2 908135 PANELAO LOJA 4 908156 PANELAO LOJA 1 908157"},{"id":"8a82b885-29f2-4aac-6369-08d5ad2bf6ba","name":"LANCHES ALAMEDA QUALITY CENTER LTDA","commercialName":"ALAMEDA QUALITY CENTER","cnpj":"23229844000104","city":"BAURU","stateCode":"SP","buscaAdicional":"ALAMEDA QUALITY CENTER 55341 RODOSERV 909974"},{"id":"545185aa-66ff-46bf-7307-08d5cf600bef","name":"CONCESSIONARIA AUTO RAPOSO TAVARES S.A.","commercialName":"CART","cnpj":"10531501000158","city":"BAURU","stateCode":"SP","buscaAdicional":""},{"id":"530929ae-85d6-4d47-5e01-08d5ad2bf6ba","name":"SUPERBOM SUPERMERCADOS LTDA","commercialName":"","cnpj":"55839922000189","city":"BAURU","stateCode":"SP","buscaAdicional":"SUPERBOM 52147 SUPERBOM LOJA 3 903871 SUPERBOM LOJA 2 903872"},{"id":"2680f3b2-e5f6-4e82-5df3-08d5ad2bf6ba","name":"FOUNTAIN AGUA MINERAL LTDA","commercialName":"FOUNTAIN S/A","cnpj":"10622118000105","city":"BAURU","stateCode":"SP","buscaAdicional":"FOUNTAIN 52080 FOUNTAIN UF BAURU SP 900932"},{"id":"37ecb8d9-12a9-4f54-5e57-08d5ad2bf6ba","name":"JAD ZOGHEIB & CIA LTDA","commercialName":"","cnpj":"53045266000117","city":"BAURU","stateCode":"SP","buscaAdicional":"CONFIANCA SUPERMERCADOS 52335 CONFIANCA FALCAO 903716 CONFIANCA JAU 903717 CONFIANCA RODOVIARIA 903718 CONFIANCA MAX 903736 CONFIANCA FLEX 903737 CONFIANCA ESMERALDA 903877 CONFIANCA ALIMENTOS 903893 CONFIANCA CASTELO 903894 CONFIANCA MARY DOTA 903895 CONFIANCA PEDERNEIRA 903896 CONFIANCA AQUARIUS 907690 CONFIANCA CUESTA 909682"},{"id":"873be5c0-e6cf-469d-5d10-08d5ad2bf6ba","name":"PLASUNIT-INDUSTRIA E COMERCIO DE PLASTICOS LTDA","commercialName":"PLASUNIT","cnpj":"67323642000100","city":"BAURU","stateCode":"SP","buscaAdicional":"PLASUNIT 51692 PLASUNIT BAURU 898814"},{"id":"bdbd4dfd-e192-4fb3-5f28-08d5ad2bf6ba","name":"BARRACAO SUPERMERCADO LTDA","commercialName":"","cnpj":"62375191000123","city":"BAURU","stateCode":"SP","buscaAdicional":"BARRACAO 52799 BARRACAO POTUNDUVA 905078 BARRACAO 905128 BARRACAO NOVA JAU 905129"},{"id":"6def9213-2ad8-48b6-5efd-08d5ad2bf6ba","name":"MEZZANI ALIMENTOS LTDA","commercialName":"MEZZANI MASSAS SEMPRE FRESCAS","cnpj":"44991743000146","city":"BAURU","stateCode":"SP","buscaAdicional":"MEZZANI 52698 MEZZANI 905107"},{"id":"f5604ecd-3d22-409e-5fef-08d5ad2bf6ba","name":"SERVIMED COMERCIAL LTDA","commercialName":"SERVIMED COMERCIAL LTDA.","cnpj":"44463156000184","city":"BAURU","stateCode":"SP","buscaAdicional":"SERVIMED 53289 SERVIMED 905131 SERVIMED HPC 905132 SERVIMED MATRIZ 905133"},{"id":"ce25ba3f-5780-4d18-58c5-08d5ad2bf6ba","name":"UNIMED DE BAURU COOPERATIVA DE TRABALHO MEDICO","commercialName":"HOSPITAL UNIMED","cnpj":"44456036000311","city":"BAURU","stateCode":"SP","buscaAdicional":"UNIMED BAURU 13252 UNIMED BAURU 891763"},{"id":"8767aeac-9e49-4392-5ae8-08d5ad2bf6ba","name":"VERTICO BAURU EMPREENDIMENTOS IMOBILIARIOS LTDA.","commercialName":"","cnpj":"10193021000124","city":"BAURU","stateCode":"SP","buscaAdicional":"BOULEVARD SHOP BAURU 50336 SHOP NACOES BAURU SP 897567"},{"id":"9732c2f0-ade0-4c06-5556-08d5ad2bf6ba","name":"INDUSTRIAS TUDOR S.P. DE BATERIAS LTDA","commercialName":"BATERIAS TUDOR","cnpj":"96195615000190","city":"BAURU","stateCode":"SP","buscaAdicional":"TUDOR 5370 TUDOR-BAURU 71837"},{"id":"12a50ec7-4c9a-4365-558e-08d5ad2bf6ba","name":"MONDELEZ BRASIL LTDA","commercialName":"MONDELEZ BRASIL","cnpj":"33033028004252","city":"BAURU","stateCode":"SP","buscaAdicional":"MONDELEZ BAURU 5798 KRAFT - BAURU 7171"},{"id":"2da6dd37-95d4-4261-5394-08d5ad2bf6ba","name":"MONDELLI INDUSTRIA DE ALIMENTOS S.A.","commercialName":"","cnpj":"45007630000479","city":"BAURU","stateCode":"SP","buscaAdicional":"MONDELLI 3702 MONDELLI-BAURU-SP 71544"},{"id":"9b837b66-aa5f-4452-55c1-08d5ad2bf6ba","name":"SINA INDUSTRIA DE ALIMENTOS LTDA","commercialName":"SINA BAURU","cnpj":"10156658000221","city":"BAURU","stateCode":"SP","buscaAdicional":"SINA BAURU 6079 SINA-BAURU 71957"},{"id":"825f9bc1-82dd-47d2-5188-08d5ad2bf6ba","name":"TILIBRA PRODUTOS DE PAPELARIA LTDA.","commercialName":"TILIBRA","cnpj":"44990901000143","city":"BAURU","stateCode":"SP","buscaAdicional":"TILIBRA 2235 TILIBRA BAURU 70567 TILIBRA CD 903902"},{"id":"12cd1e92-3824-4c86-529a-08d5ad2bf6ba","name":"PLAJAX INDUSTRIA E COMERCIO DE PLASTICOS LTDA","commercialName":"PLAJAX","cnpj":"45341526000173","city":"BAURU","stateCode":"SP","buscaAdicional":"PJX 3171 PLAJAX I C PLASTICOS 71460"},{"id":"04a6d925-6a1f-4735-533d-08d5ad2bf6ba","name":"SUKEST INDUSTRIA DE ALIMENTOS E FARMA LTDA","commercialName":"SUKEST","cnpj":"55692537000151","city":"BAURU","stateCode":"SP","buscaAdicional":"SUKEST 3533 SUKEST BAURU 71124"},{"id":"4bf61c84-acb9-41e7-5cf8-08d5ad2bf6ba","name":"COMFRIO SOLUCOES LOGISTICAS S/A","commercialName":"","cnpj":"01413969000157","city":"BEBEDOURO","stateCode":"SP","buscaAdicional":"COMFRIO 51636 COMFRIO - BEBEDOURO 899291 COMFRIO BEBEDOURO 2 899507 COMFRIO - JARINU 899916 COMFRIO - MONTE AZUL 899939 COMFRIO LIMEIRA SP 900353 COMFRIO - UBERLANDIA 905817"},{"id":"df9d32e3-f43e-4f26-63ab-08d5ad2bf6ba","name":"ASSOCIACAO DE EDUCACAO E CULTURA DO NORTE PAULISTA","commercialName":"CENTRO UNIVERSITARIO UNIFAFIBE","cnpj":"57713281000147","city":"BEBEDOURO","stateCode":"SP","buscaAdicional":"UNIFAFIBE 55510 UNIFAFIBE 906840"},{"id":"d06d711e-eb3a-49df-6145-08d5ad2bf6ba","name":"INDUSTRIA E COMERCIO DE PRODUTOS ALIMENTICIOS FRUTAP LTDA","commercialName":"FRUTAP","cnpj":"00158635000111","city":"BERNARDINO DE CAMPOS","stateCode":"SP","buscaAdicional":"FRUTAP 54095 FRUTAP ALIMENTOS 906707"},{"id":"ca2d3a09-8072-4c29-695f-08d5ad2bf6ba","name":"CONDOM CIVIL SHOPPING CENTER RIVIERA DE SAO LOURENCO","commercialName":"","cnpj":"64609928000150","city":"BERTIOGA","stateCode":"SP","buscaAdicional":"SHOPPING RIVIERA 61103 SHOPPING RIVIERA 912026"},{"id":"96356cd0-efa0-4971-5e86-08d5ad2bf6ba","name":"KILBRA TRADING EQUIPAMENTOS PARA AVICULTURA LTDA","commercialName":"","cnpj":"56169790000198","city":"BIRIGUI","stateCode":"SP","buscaAdicional":"KILBRA 52415 KILBRA 903763"},{"id":"02defe7c-8707-4292-5f1e-08d5ad2bf6ba","name":"PAMPILI PRODUTOS PARA MENINAS LTDA","commercialName":"PAMPILI","cnpj":"56794084000137","city":"BIRIGUI","stateCode":"SP","buscaAdicional":"PAMPILI 52755 PAMPILI 899815 PAMPILI UNIDADE 02 900044 PAMPILI 03 907454"},{"id":"6b1ecf09-0095-464b-5806-08d5ad2bf6ba","name":"I.T.B. - EQUIPAMENTOS ELETRICOS LTDA","commercialName":"ITB","cnpj":"46151130000126","city":"BIRIGUI","stateCode":"SP","buscaAdicional":"ITB 10431 ITB BIRIGUI 889641"},{"id":"6621bb29-7632-4ad4-5309-08d5ad2bf6ba","name":"TIPTOE INDUSTRIA E COMERCIO DE CALCADOS LTDA","commercialName":"RISSYBEL","cnpj":"45384096000177","city":"BIRIGUI","stateCode":"SP","buscaAdicional":"TIPTOE 3449 TIP TOE-BIRIGUI 71172"},{"id":"b0b7b21f-4251-4f2f-52b4-08d5ad2bf6ba","name":"KIDY BIRIGUI CALCADOS INDUSTRIA E COMERCIO LTDA","commercialName":"KIDY CALCADOS","cnpj":"96261607000102","city":"BIRIGUI","stateCode":"SP","buscaAdicional":"KIDY CALCADOS 3251 KIDY CALCADOS 70995 LOG 3 71597 KIDY TRES LAGOAS 899593"},{"id":"15c38ca7-b729-452f-537d-08d5ad2bf6ba","name":"KLIN PRODUTOS INFANTIS LTDA","commercialName":"","cnpj":"52717659000167","city":"BIRIGUI","stateCode":"SP","buscaAdicional":"KLIN 3657 KLIN CAMALEOA 71230 KLIN 01 71231 KLIN COLIBRI 71232 KLIN ANGRA 71233 KLIN TRES LAGOAS 901221"},{"id":"c1237e01-a8bf-42d6-5637-08d5ad2bf6ba","name":"SAINT-GOBAIN DO BRASIL PRODUTOS INDUSTRIAIS E PARA CONSTRUCAO LTDA","commercialName":"","cnpj":"61064838005950","city":"BOFETE","stateCode":"SP","buscaAdicional":"SGQUART BOFETE 6764 S GOBAIN BOFETE 72093"},{"id":"e04578c5-c48f-4804-55d7-08d5ad2bf6ba","name":"TOYPLAST PLASTICOS LTDA","commercialName":"TOYPLAST","cnpj":"07046041000168","city":"BOITUVA","stateCode":"SP","buscaAdicional":"TOYPLAST 6232 TOYPLAST-BOITUVA 72011 TOYPLAST FAV-BOITUVA 72053 TOYPLAST BOITUVA 3 902013"},{"id":"fc664927-cfe5-46c7-5703-08d5ad2bf6ba","name":"ZANCHETTA ALIMENTOS LTDA","commercialName":"","cnpj":"69258911000462","city":"BOITUVA","stateCode":"SP","buscaAdicional":"ZANCHETTA 8125 ZANCHETTA BOITUVA 72429"},{"id":"4a012392-f923-4b31-53a7-08d5ad2bf6ba","name":"INTERNATIONAL PLASTICS INDUSTRIA & COMERCIO LTDA","commercialName":"","cnpj":"09169096000190","city":"BOITUVA","stateCode":"SP","buscaAdicional":"PLASTSHOW 3749 PLASTSHOW 23,1 KV 71317"},{"id":"977c8f29-2886-4c6a-5187-08d5ad2bf6ba","name":"ELECTRA POWER GERACAO DE ENERGIA S.A","commercialName":"","cnpj":"07356196000109","city":"BOITUVA","stateCode":"SP","buscaAdicional":"EPOWER 2232"},{"id":"033ed9c4-4c0c-4d96-5b97-08d5ad2bf6ba","name":"ZANCHETTA ALIMENTOS LTDA","commercialName":"ZANCHETTA ALIMENTOS LTDA.","cnpj":"69258911000543","city":"BOITUVA","stateCode":"SP","buscaAdicional":"ZANCHETTA RACOES 50774 ZANCHETTA ALIMENTOS 897311"},{"id":"12e97911-616a-4d29-5e8f-08d5ad2bf6ba","name":"GP COMERCIALIZADORA DE ENERGIA LTDA","commercialName":"","cnpj":"22297784000102","city":"BOITUVA","stateCode":"SP","buscaAdicional":"GP COMERCIALIZADORA 52448"},{"id":"e164e26b-cd96-4e62-61b0-08d5ad2bf6ba","name":"ACE SCHMERSAL ELETROELETRONICA INDUSTRIAL LTDA","commercialName":"","cnpj":"61854147000133","city":"BOITUVA","stateCode":"SP","buscaAdicional":"ACE SCHMERSAL 54341 ACE SCHMERSAL 905153"},{"id":"4276574a-704c-4982-6372-08d5ad2bf6ba","name":"POLIFORTE INDUSTRIA E COMERCIO DE FIOS TECNICOS LTDA","commercialName":"","cnpj":"03605694000189","city":"BOM JESUS DOS PERDÕES","stateCode":"SP","buscaAdicional":"POLIFORTE 55370 POLIFORTE FIOS TEC 907303"},{"id":"7b76d940-75c1-4bfc-5bfa-08d5ad2bf6ba","name":"UNIPEL INDUSTRIA E COMERCIO LTDA","commercialName":"","cnpj":"43123272000272","city":"BOM JESUS DOS PERDÕES","stateCode":"SP","buscaAdicional":"UNIPEL BJP 51008 UNIPEL 10618821 898293 UNIPEL 386235 898316"},{"id":"b7234ddb-9660-4893-58c7-08d5ad2bf6ba","name":"CARVALHEIRA INDUSTRIA DE PAPEIS LTDA","commercialName":"CARVALHEIRA PAPEIS","cnpj":"11405532000125","city":"BOM JESUS DOS PERDÕES","stateCode":"SP","buscaAdicional":"CARVALHEIRA PAPEIS 13293 CARVALHEIRA PAPEIS 892247"},{"id":"ceff8244-0999-499d-5ed0-08d5ad2bf6ba","name":"MINERACAO SAO JUDAS LTDA","commercialName":"MINERACAO SAO JUDAS","cnpj":"43363381000186","city":"BOM SUCESSO DE ITARARÉ","stateCode":"SP","buscaAdicional":"SAO JUDAS 52559 SAO JUDAS MATRIZ 900016 SAO JUDAS SENGES 901997 SAO JUDAS PONTA GRO 901998"},{"id":"cbbc7d90-36ac-4f39-5fd5-08d5ad2bf6ba","name":"TEC GLASS COMPONENTES INDUSTRIAIS LTDA","commercialName":"","cnpj":"18356464000109","city":"BOTUCATU","stateCode":"SP","buscaAdicional":"TEC GLASS 53238 TEC GLASS 903791"},{"id":"2c480a5a-a80d-419e-6010-08d5ad2bf6ba","name":"COMERCIAL SALOMAO LTDA","commercialName":"CENTRAL SUPERMERCADOS","cnpj":"45517083000129","city":"BOTUCATU","stateCode":"SP","buscaAdicional":"SALOMAO 53362 SALOMAO MATRIZ 904691 SALOMAO UNIDADE 02 904692 SALOMAO UNIDADE 03 904707 SALOMAO UNIDADE 04 904713 SALOMAO UNIDADE 06 904715"},{"id":"965f73b5-4fc6-4394-60ef-08d5ad2bf6ba","name":"MSA EMPRESA CINEMATOGRAFICA LTDA","commercialName":"","cnpj":"03608600000125","city":"BOTUCATU","stateCode":"SP","buscaAdicional":"CINE ARAUJO 53905 CINE ARAUJO MAUA 905504 CINE ARAUJO CAMPO LI 905505 CINE ARAUJO SERRA 905544 CINE ARAUJO CAMPINAS 905578 CINE ARAUJO BAURU 905596 CINE ARAUJO SOROCABA 905780 CINE ARAUJO SJRP 906361 CINE ARAUJO GUADALUP 907286 CINE ARAUJO D CAXIAS 907573 CINE ARAUJO CAMPOS 908086"},{"id":"ff15f431-5ab0-4d24-5cdc-08d5ad2bf6ba","name":"SHOPPING BOTUCATU EMPREENDIMENTOS S.A.","commercialName":"","cnpj":"14245894000194","city":"BOTUCATU","stateCode":"SP","buscaAdicional":"SC BOTUCATU 51593 SHOPPING BOTUCATU 900015"},{"id":"8c6da39a-fd8d-418e-5145-08d5ad2bf6ba","name":"CAIO - INDUSCAR INDUSTRIA E COMERCIO DE CARROCERIAS LTDA","commercialName":"","cnpj":"02907841000102","city":"BOTUCATU","stateCode":"SP","buscaAdicional":"INDUSCAR 2084 INDUSCAR CARROCERIAS 70456 INDUSCAR CHASSIS 908953"},{"id":"5110aaf1-76cb-4617-526a-08d5ad2bf6ba","name":"INBRASP - INDUSTRIA BRASILEIRA DE PLASTICOS LTDA.","commercialName":"","cnpj":"59941799000163","city":"BOTUCATU","stateCode":"SP","buscaAdicional":"INBRASP 3048 INBRASP 70879"},{"id":"aac3c9be-c466-4693-5355-08d5ad2bf6ba","name":"DURATEX S.A.","commercialName":"","cnpj":"97837181002000","city":"BOTUCATU","stateCode":"SP","buscaAdicional":"DURA PS 3585 DURATEX DX3 BOTUCATU 7246"},{"id":"17a01fbb-b6bf-4ed5-5451-08d5ad2bf6ba","name":"FIBERBUS INDUSTRIA E COMERCIO DE FIBRAS DE VIDRO LTDA","commercialName":"","cnpj":"10350401000125","city":"BOTUCATU","stateCode":"SP","buscaAdicional":"FIBERBUS 4164 FIBERBUS-BOTUCATU SP 71567"},{"id":"324e7609-ee14-4843-6135-08d5ad2bf6ba","name":"BLOWPET TRANSFORMACOES PLASTICAS LTDA","commercialName":"BLOWPET","cnpj":"02560432000182","city":"BOTUCATU","stateCode":"SP","buscaAdicional":"BLOWPET 54055 BLOWPET 905691"},{"id":"ade7277b-75f6-4208-6125-08d5ad2bf6ba","name":"TECNAUT INDUSTRIA E COMERCIO DE METAIS LTDA","commercialName":"TECNAUT","cnpj":"73056731000122","city":"BOTUCATU","stateCode":"SP","buscaAdicional":"TECNAUT 54035 TECNAUT 905117"},{"id":"babd4365-49ce-4a7d-64cd-08d5ad2bf6ba","name":"IMBRAMIL - INDUSTRIA E COMERCIO LTDA.","commercialName":"","cnpj":"59227728000101","city":"BRAGANÇA PAULISTA","stateCode":"SP","buscaAdicional":"IMBRAMIL 56226 IMBRAMIL IND E COM 907794"},{"id":"0fcd50ed-38cb-465f-68dc-08d5ad2bf6ba","name":"N.E INDUSTRIA DE ALIMENTOS LTDA","commercialName":"","cnpj":"10778359000148","city":"BRAGANÇA PAULISTA","stateCode":"SP","buscaAdicional":"NOVA ERA ALIMENTOS 60511 NOVA ERA IND DE ALIM 910869"},{"id":"bffd75a2-5b6f-41e9-691c-08d5ad2bf6ba","name":"SUPERMERCADO MW METEORO LTDA","commercialName":"MATRIZ - LOJA 1","cnpj":"02889779000173","city":"BRAGANÇA PAULISTA","stateCode":"SP","buscaAdicional":"METEORO 60772 METEORO 5 911904 METEORO 9/3018293-5 911993 METEORO 9/3022910-8 911994 METEORO 9/3001807-1 912012 METORO 4 912013"},{"id":"ba9724c7-02f0-4aa0-6619-08d5ad2bf6ba","name":"ASSOCIACAO DO BRAGANCA GARDEN SHOPPING","commercialName":"","cnpj":"23743547000182","city":"BRAGANÇA PAULISTA","stateCode":"SP","buscaAdicional":"SHOP BRAGANCA 57311 SHOP BRAGANCA 907822"},{"id":"e980fcbd-8ecd-4b11-5696-08d5ad2bf6ba","name":"OSG SULAMERICANA DE FERRAMENTAS LTDA","commercialName":"","cnpj":"44078640000270","city":"BRAGANÇA PAULISTA","stateCode":"SP","buscaAdicional":"OSG SULAMERICA 7260 OSG SULAMERICANA 888163"},{"id":"63189f8c-8e7b-4584-4f84-08d5ad2bf6ba","name":"ARCOR DO BRASIL LTDA.","commercialName":"","cnpj":"54360656001701","city":"BRAGANÇA PAULISTA","stateCode":"SP","buscaAdicional":"ARCOR 1142 ARCOR BRAGANCA 7549"},{"id":"612787fb-ce2a-411d-5201-08d5ad2bf6ba","name":"REVATI GERADORA DE ENERGIA ELETRICA LTDA-EM RECUPERACAO JUDICIAL","commercialName":"","cnpj":"10651227000150","city":"BREJO ALEGRE","stateCode":"SP","buscaAdicional":"REVATI 2786 REVATI-BIOPAV II 72239 CHAPADAO AGRO 8667 UTE.AI.SP.030041-1.01 BIOPAV II 8666 UTE.AI.SP.030053-5.01"},{"id":"a67474db-ea33-47b0-561f-08d5ad2bf6ba","name":"COGERACAO DE ENERGIA ELETRICA RHODIA BROTAS S.A.","commercialName":"","cnpj":"12244251000109","city":"BROTAS","stateCode":"SP","buscaAdicional":"UTE BROTAS 6638 BROTAS II - CARGA 907471 BROTAS I - CONSUMO 908264 BROTAS 888677 UTE.AI.SP.030782-3.01 BROTAS II 897747 UTE.AI.SP.034649-7.01"},{"id":"c1af56b8-15c0-44fd-5e95-08d5ad2bf6ba","name":"EDENTEC INDUSTRIA E COMERCIO LTDA","commercialName":"","cnpj":"47799028000285","city":"BURI","stateCode":"SP","buscaAdicional":"EDENTEC 52455 EDENTEC 902197"},{"id":"cb6f2b0f-7db0-4159-5477-08d5ad2bf6ba","name":"BCE - BURITIZAL CENTRAL ENERGETICA S/A","commercialName":"BCE","cnpj":"12013570000103","city":"BURITIZAL","stateCode":"SP","buscaAdicional":"BCE 4278 BURITI-CONSUMO 71693 BURITI BCE 8934 UTE.AI.SP.030420-4.01"},{"id":"bafd0f14-8824-49aa-5489-08d5ad2bf6ba","name":"METALURGICA NAKAYONE LTDA","commercialName":"","cnpj":"57373375000203","city":"CABREÚVA","stateCode":"SP","buscaAdicional":"NAKAYONE 4326 NAKAYONE-CABREUVA 71533"},{"id":"ad7ab682-2405-4f1c-52bb-08d5ad2bf6ba","name":"CROWN EMBALAGENS METALICAS DA AMAZONIA S/A","commercialName":"","cnpj":"33174335000347","city":"CABREÚVA","stateCode":"SP","buscaAdicional":"CROWN CABREUVA 3263 CROWN CABREUVA 910126"},{"id":"0e709caa-0809-4e59-5dfa-08d5ad2bf6ba","name":"ALIMENTOS DALLAS INDUSTRIA E COMERCIO LTDA","commercialName":"ALIMENTOS DALLAS","cnpj":"03938789000629","city":"CABREÚVA","stateCode":"SP","buscaAdicional":"DALLAS CABREUVA 52129 ALIMENTOS DALLAS 903979"},{"id":"c7fd35a7-4954-4d30-5d06-08d5ad2bf6ba","name":"SIGNODE BRASILEIRA LTDA","commercialName":"SIGNODE","cnpj":"02274937000180","city":"CABREÚVA","stateCode":"SP","buscaAdicional":"SIGNODE 51680 SIGNODE 899886"},{"id":"1787932c-cb04-4dc9-5d7f-08d5ad2bf6ba","name":"CORR PLASTIK INDUSTRIAL LIMITADA","commercialName":"CORR PLASTIK","cnpj":"67731091000106","city":"CABREÚVA","stateCode":"SP","buscaAdicional":"CORR PLASTIK 51840 CORR PLASTIC CABREUV 899319"},{"id":"9c97ae78-1acc-4be4-5f74-08d5ad2bf6ba","name":"G-KT DO BRASIL LTDA","commercialName":"","cnpj":"01524606000199","city":"CABREÚVA","stateCode":"SP","buscaAdicional":"G-KT DO BRASIL 52961 G-KT BRASIL CABREUVA 901155"},{"id":"4d36c4db-d096-453c-5c10-08d5ad2bf6ba","name":"MIRVI BRASIL LTDA.","commercialName":"MIRVI BRASIL LTDA.","cnpj":"03529311000130","city":"CABREÚVA","stateCode":"SP","buscaAdicional":"MIRVI BRASIL 51062 MIRVI BRASIL 898265"},{"id":"1f845b2a-18e6-4526-5c4b-08d5ad2bf6ba","name":"FLAMBOIA ALIMENTOS LTDA","commercialName":"","cnpj":"61252540000157","city":"CABREÚVA","stateCode":"SP","buscaAdicional":"FLAMBOIA ALIMENTOS 51253 FLAMBOIA CABREUVA SP 900009"},{"id":"c9987102-7c24-449d-5a6e-08d5ad2bf6ba","name":"AVON COSMETICOS LTDA.","commercialName":"","cnpj":"56991441000823","city":"CABREÚVA","stateCode":"SP","buscaAdicional":"AVON CABREUVA 17467 AVON CABREUVA 896204"},{"id":"2a569a4a-5426-4916-65da-08d5ad2bf6ba","name":"TRAMAR INDUSTRIAL LTDA","commercialName":"","cnpj":"47454467000175","city":"CABREÚVA","stateCode":"SP","buscaAdicional":"TRAMAR 57168 TRAMAR INDUSTRIAL 907333"},{"id":"6ae114a0-df93-4df9-65d7-08d5ad2bf6ba","name":"FABRICA DE TRANCAS BRASIL LTDA","commercialName":"FABRICA DE TRANCAS BRASIL","cnpj":"45831575000194","city":"CABREÚVA","stateCode":"SP","buscaAdicional":"TRANCAS BRASIL 57158 FAB TRANCAS BR LTDA 907332"},{"id":"c6f66874-ac39-4660-68d5-08d5ad2bf6ba","name":"BELLOCOPO DESCARTAVEIS LTDA","commercialName":"","cnpj":"22624940000194","city":"CABREÚVA","stateCode":"SP","buscaAdicional":"BELLOCOPO 60470 BELLOCOPO 910897"},{"id":"2cb6bcba-c06d-4a0e-636d-08d5ad2bf6ba","name":"ISOFORMA PLASTICOS INDUSTRIAIS LTDA","commercialName":"","cnpj":"68176072000128","city":"CABREÚVA","stateCode":"SP","buscaAdicional":"ISOFORMA 55348 ISOFORMA PLASTICOS 906693"},{"id":"bd71bc49-8268-4c46-6526-08d5ad2bf6ba","name":"CABLETECH CABOS LTDA","commercialName":"","cnpj":"00797490000107","city":"CAÇAPAVA","stateCode":"SP","buscaAdicional":"CABLETECH CABOS 56534 CABLETECH CABOS 904824"},{"id":"881a85ad-e098-41b2-629e-08d5ad2bf6ba","name":"LEAR DO BRASIL INDUSTRIA E COMERCIO DE INTERIORES AUTOMOTIVOS LTDA.","commercialName":"LEAR","cnpj":"01998585000143","city":"CAÇAPAVA","stateCode":"SP","buscaAdicional":"LEAR 54827 LEAR NAVEGANTES 905493 LEAR BETIM 905683 LEAR CACAPAVA 905742"},{"id":"f696e2d3-3ced-402c-6318-08d5ad2bf6ba","name":"SHIBATA CACAPAVA ATACADO E VAREJO DE MERCADORIAS EM GERAL LTDA","commercialName":"","cnpj":"15061363000104","city":"CAÇAPAVA","stateCode":"SP","buscaAdicional":"SHIBATA CACAPAVA 55133 SHIBATA CACAPAVA 904807"},{"id":"301835e5-701a-42a5-6944-08d5ad2bf6ba","name":"TRIMTEC LTDA","commercialName":"","cnpj":"00783986000113","city":"CAÇAPAVA","stateCode":"SP","buscaAdicional":"TRIMTEC 60952 TRIMTEC - CACAPAVA 912492"},{"id":"c3748704-f224-467e-8d94-08d5d060706e","name":"INTERTRIM LTDA","commercialName":"","cnpj":"01105075000108","city":"CAÇAPAVA","stateCode":"SP","buscaAdicional":"INTERTRIM 61094 INTERTRIM - CACAPAVA 913506"},{"id":"778af432-a366-4c3e-4f9f-08d5ad2bf6ba","name":"PILKINGTON BRASIL LTDA","commercialName":"","cnpj":"61736732000139","city":"CAÇAPAVA","stateCode":"SP","buscaAdicional":"PILKINGTON 1189 PILKINGTON LAM-CACAP 7542"},{"id":"36e4531c-fb5d-447b-505f-08d5ad2bf6ba","name":"MWL BRASIL RODAS & EIXOS LTDA.","commercialName":"","cnpj":"03234027000137","city":"CAÇAPAVA","stateCode":"SP","buscaAdicional":"MWL BRASIL 1594 MWL BR CA 70041"},{"id":"c8e2c965-460b-4231-54e1-08d5ad2bf6ba","name":"CPW BRASIL LTDA","commercialName":"","cnpj":"01446396000168","city":"CAÇAPAVA","stateCode":"SP","buscaAdicional":"CPW BRASIL 4558 CPW CACAP 70640"},{"id":"3ca2a4e8-5103-42d0-54f0-08d5ad2bf6ba","name":"VIAPOL LTDA","commercialName":"","cnpj":"58681867000130","city":"CAÇAPAVA","stateCode":"SP","buscaAdicional":"VIAPOL 4601 VIAPOL-CACAPAVA 71846"},{"id":"2cde5fce-6e95-411f-549c-08d5ad2bf6ba","name":"SIMOLDES PLASTICOS INDUSTRIA LIMITADA","commercialName":"","cnpj":"01214052000204","city":"CAÇAPAVA","stateCode":"SP","buscaAdicional":"SPI 4366 SIMOLDES CACAPAVA 71618"},{"id":"ca45114b-2c7f-40b9-56de-08d5ad2bf6ba","name":"WOW NUTRITION INDUSTRIA E COMERCIO S.A - EM RECUPERACAO JUDICIAL","commercialName":"","cnpj":"02338823000238","city":"CAÇAPAVA","stateCode":"SP","buscaAdicional":"WOW 7865 WOW NUTRITION 888629"},{"id":"69c6333d-9a8c-41d2-57a4-08d5ad2bf6ba","name":"SAINT-GOBAIN DO BRASIL PRODUTOS INDUSTRIAIS E PARA CONSTRUCAO LTDA","commercialName":"","cnpj":"61064838011178","city":"CAIEIRAS","stateCode":"SP","buscaAdicional":"SGABR CAIEIRAS 9272 ST GOBAIN CAIEIRAS 888826"},{"id":"be562fe2-c742-466b-501d-08d5ad2bf6ba","name":"MD PAPEIS LTDA.","commercialName":"","cnpj":"72907595000417","city":"CAIEIRAS","stateCode":"SP","buscaAdicional":"MD PAPEIS 1451 MD PAPEIS CAIEIRAS 7092"},{"id":"0e8ad159-9683-4c46-5aa4-08d5ad2bf6ba","name":"TERMOVERDE CAIEIRAS LTDA","commercialName":"","cnpj":"10490040000112","city":"CAIEIRAS","stateCode":"SP","buscaAdicional":"TERMOVERDE CAIEIRAS 50134 TERMO VERDE CAIEIRAS 900734 UTE.RU.SP.031436-6.01"},{"id":"ad8592ff-346c-4f25-5f88-08d5ad2bf6ba","name":"POLYPLASTIC INDUSTRIA E COMERCIO LTDA.","commercialName":"","cnpj":"60650074000103","city":"CAIEIRAS","stateCode":"SP","buscaAdicional":"POLYPLASTIC 53013 POLYPLASTIC 904316"},{"id":"b3a60dec-88f3-4075-5dbc-08d5ad2bf6ba","name":"MAZDA EMBALAGENS LTDA EM RECUPERACAO JUDICIAL","commercialName":"","cnpj":"53635272000124","city":"CAIEIRAS","stateCode":"SP","buscaAdicional":"MAZDA 51971 MAZDA 899911"},{"id":"f1d218e6-8bf6-4551-6889-08d5ad2bf6ba","name":"PLASTINCOLOR INDUSTRIA E COMERCIO LTDA","commercialName":"","cnpj":"58290545000160","city":"CAIEIRAS","stateCode":"SP","buscaAdicional":"PLASTINCOLOR 60119 PLASTINCOLOR 910280"},{"id":"2a799da9-2e8d-4b0b-65f6-08d5ad2bf6ba","name":"MINERADORA PEDRIX LTDA","commercialName":"","cnpj":"01290096000132","city":"CAIEIRAS","stateCode":"SP","buscaAdicional":"PEDRIX 57237 MINERADORA PEDRIX 906722"},{"id":"5d589d57-6ab2-4865-6680-08d5ad2bf6ba","name":"MARTINS & LOCOCO LAVANDERIA LTDA","commercialName":"","cnpj":"59951822000109","city":"CAIEIRAS","stateCode":"SP","buscaAdicional":"MARTINS E LOCOCO 57623 MARTINS E LOCOCO 908878"},{"id":"a19a48a4-c5c5-48c6-65ed-08d5ad2bf6ba","name":"GLOBALPLASTIC AUTOPECAS LTDA.","commercialName":"","cnpj":"21392921000117","city":"CAJAMAR","stateCode":"SP","buscaAdicional":"GLOBALPLASTIC 57211 COMPONIAN 889638"},{"id":"f9078f7c-206f-4045-6976-08d5ad2bf6ba","name":"3PL BRASIL LOGISTICA S.A.","commercialName":"","cnpj":"23429671000178","city":"CAJAMAR","stateCode":"SP","buscaAdicional":"3PL LOGISTICA 61797"},{"id":"6439a2aa-3d1f-4c95-62ae-08d5ad2bf6ba","name":"METALGRAFICA ROJEK LTDA","commercialName":"","cnpj":"52502978000155","city":"CAJAMAR","stateCode":"SP","buscaAdicional":"METALGRAFICA ROJEK 54917 METALGRAFICA ROJEK 906268"},{"id":"f3a3ab3b-fb2a-4062-615a-08d5ad2bf6ba","name":"RENNER SAYERLACK S/A","commercialName":"","cnpj":"61142865000691","city":"CAJAMAR","stateCode":"SP","buscaAdicional":"SAYERLACK 54145 RENNER SAYERLACK 902622 RENNER SAYERLACK1500 902677"},{"id":"40f5a8c0-c767-451d-657e-08d5ad2bf6ba","name":"D'ARTHY EDITORA E GRAFICA LTDA","commercialName":"","cnpj":"01692620000100","city":"CAJAMAR","stateCode":"SP","buscaAdicional":"D ARTHY 56744 D ARTHY 905566"},{"id":"3fed433a-4225-43c9-5d04-08d5ad2bf6ba","name":"CMP - COMPANHIA METALGRAPHICA PAULISTA","commercialName":"","cnpj":"61161139000101","city":"CAJAMAR","stateCode":"SP","buscaAdicional":"CMP METALGRAPHICA 51678 CMP METALGRAPHICA 901933"},{"id":"062211e8-b28a-4159-60df-08d5ad2bf6ba","name":"ANHANGUERA.SC EMPREENDIMENTOS IMOBILIARIOS LTDA","commercialName":"","cnpj":"14266246000114","city":"CAJAMAR","stateCode":"SP","buscaAdicional":"ANHANGUERA.SC 53816 ANHANGUERA SC 904554"},{"id":"97c7442a-c123-4890-5046-08d5ad2bf6ba","name":"IMPACTA S A INDUSTRIA E COMERCIO","commercialName":"","cnpj":"61194494000187","city":"CAJAMAR","stateCode":"SP","buscaAdicional":"IMPACTA 1549 IMPACTA 889074"},{"id":"7633de12-a36a-4f4b-4fba-08d5ad2bf6ba","name":"INDUSTRIA E COMERCIO DE COSMETICOS NATURA LTDA","commercialName":"NATURA","cnpj":"00190373000172","city":"CAJAMAR","stateCode":"SP","buscaAdicional":"NATURA 1254 NATURA CAJAMAR 7533"},{"id":"3c371f77-4efd-4e28-5411-08d5ad2bf6ba","name":"SKF DO BRASIL LTDA","commercialName":"","cnpj":"61077327000156","city":"CAJAMAR","stateCode":"SP","buscaAdicional":"SK F 3987 SKF 71370 SK F 201735774 903380"},{"id":"f8a6efd5-f665-420a-5adb-08d5ad2bf6ba","name":"ICL BRASIL LTDA","commercialName":"","cnpj":"03353785000506","city":"CAJATI","stateCode":"SP","buscaAdicional":"ICL CAJATI 50291 ICL BRASIL 896689"},{"id":"f49f351a-3d70-4113-610a-08d5ad2bf6ba","name":"CAJURU INDUSTRIA E COMERCIO DE ALIMENTOS LTDA","commercialName":"","cnpj":"04662776000128","city":"CAJURU","stateCode":"SP","buscaAdicional":"GOLD MEAT 53978 GOLD MEAT 905124"},{"id":"3b469a41-9a58-4d0e-50be-08d5ad2bf6ba","name":"ITACA ENERGIA EIRELI","commercialName":"","cnpj":"04601388000137","city":"CAJURU","stateCode":"SP","buscaAdicional":"CGH CAJURU 545-13 1815 CAJURU RIO CUBATAO 8025 CGH.PH.SP.028719-9.01 CAJURU RIO CUBATAO 8025 CGH.PH.SP.028719-9.01"},{"id":"af0300d1-9a77-440f-50ce-08d5ad2bf6ba","name":"IMERYS DO BRASIL COMERCIO DE EXTRACAO DE MINERIOS LTDA","commercialName":"","cnpj":"61327904000110","city":"CAMPINAS","stateCode":"SP","buscaAdicional":"IMERYS_MATRIZ 1852 IMERYS MC 70239"},{"id":"c88144d7-266b-4149-50c8-08d5ad2bf6ba","name":"GEVISA S A","commercialName":"","cnpj":"68059674000103","city":"CAMPINAS","stateCode":"SP","buscaAdicional":"GEVISA 1845 GEVISA CAMPINAS 70220"},{"id":"fbff24a7-a6ef-42a5-511e-08d5ad2bf6ba","name":"SABIC INNOVATIVE PLASTICS SOUTH AMERICA - INDUSTRIA E COMERCIO DE PLASTICOS LTDA.","commercialName":"","cnpj":"58088733000290","city":"CAMPINAS","stateCode":"SP","buscaAdicional":"SABIC 2006 SABIC 70221"},{"id":"5c0315c7-c0cd-4c0e-5007-08d5ad2bf6ba","name":"UNIVERSIDADE ESTADUAL DE CAMPINAS","commercialName":"","cnpj":"46068425000133","city":"CAMPINAS","stateCode":"SP","buscaAdicional":"UNICAMP 1407 UNICAMP 81"},{"id":"8640a736-2343-4f3e-5008-08d5ad2bf6ba","name":"''CONDOMINIO SHOPPING PARQUE D. PEDRO''","commercialName":"","cnpj":"04895134000179","city":"CAMPINAS","stateCode":"SP","buscaAdicional":"SHOP PARQUE DOM PEDRO 1408 SHOP. PARQUE D.PEDRO 906012"},{"id":"aa0884ab-b989-4695-5004-08d5ad2bf6ba","name":"RIGESA CELULOSE PAPEL E EMBALAGENS LTDA","commercialName":"RIGESA","cnpj":"45989050000181","city":"CAMPINAS","stateCode":"SP","buscaAdicional":"RIGESA 1403 RIGESA 1 7348 RIGESA ARACATUBA 889851 RIGESA TRES BARRAS 888195 RIGESA BLUMENAU 71379 RIGESA 3 EFLUENTES 7484"},{"id":"8fe50df8-d84b-433a-4ff4-08d5ad2bf6ba","name":"ROBERT BOSCH LIMITADA","commercialName":"","cnpj":"45990181000189","city":"CAMPINAS","stateCode":"SP","buscaAdicional":"BOSCH 1372 ROBERT BOSCH CAMPIN 7295"},{"id":"1fc5fcb2-c407-40e0-4f1b-08d5ad2bf6ba","name":"COMPANHIA PIRATININGA DE FORCA E LUZ","commercialName":"CPFL - COMPANHIA PIRATININGA DE FORCA E LUZ","cnpj":"04172213000151","city":"CAMPINAS","stateCode":"SP","buscaAdicional":"CPFL PIRATINGA 94 CPFL-PIRATININGA 63 CPFL PIRATING DITCSP 72302"},{"id":"e4890336-bf3e-4418-4efd-08d5ad2bf6ba","name":"ELEKTRO REDES S.A.","commercialName":"ELEKTRO REDES S.A.","cnpj":"02328280000197","city":"CAMPINAS","stateCode":"SP","buscaAdicional":"ELEKTRO 46 ELEKTRO 12 ELEKTRO DITCSP 72304 ELEKTRO SEDE 71075"},{"id":"93a5f453-1638-4589-4ef5-08d5ad2bf6ba","name":"COMPANHIA PAULISTA DE FORCA E LUZ","commercialName":"","cnpj":"33050196000188","city":"CAMPINAS","stateCode":"SP","buscaAdicional":"CPFL PAULISTA 34 CPFL PAULISTA 9 CPFL PAULISTA DITCSP 72301"},{"id":"71f69922-2ad0-442f-4ef6-08d5ad2bf6ba","name":"CPFL GERACAO DE ENERGIA S/A","commercialName":"","cnpj":"03953509000147","city":"CAMPINAS","stateCode":"SP","buscaAdicional":"CPFL GERACAO 35 CARIOBA 223 UTE.PE.SP.000678-5.01 MACACO BRANCO 889137 UHE.PH.SP.001349-8.01 RIO DO PEIXE (CPFL) 889139 UHE.PH.SP.002353-1.01"},{"id":"01adfc84-d4ff-498f-4f5d-08d5ad2bf6ba","name":"CPFL COMERCIALIZACAO CONE SUL S.A.","commercialName":"","cnpj":"02190883000175","city":"CAMPINAS","stateCode":"SP","buscaAdicional":"CPFL CONE SUL 1069"},{"id":"86f10d42-4749-4961-4f28-08d5ad2bf6ba","name":"CPFL COMERCIALIZACAO BRASIL S.A.","commercialName":"","cnpj":"04973790000142","city":"CAMPINAS","stateCode":"SP","buscaAdicional":"CPFL BRASIL 118 VIRALCOOL PITANG. 403 UTE.AI.SP.003035-0.01 BALDIN-CPFL BIOENER 8725 UTE.AI.SP.030169-8.01 VIRALCOOL 2 20073 UTE.AI.SP.030851-0.01"},{"id":"f7653c81-f337-434c-4f39-08d5ad2bf6ba","name":"ELEKTRO COMERCIALIZADORA DE ENERGIA LTDA.","commercialName":"","cnpj":"01644193000186","city":"CAMPINAS","stateCode":"SP","buscaAdicional":"EKCE 142 TH BUSCHINELLI STA G 902894 TH BUSCHINELLI ARARA 902914"},{"id":"59961975-ee3a-4f4f-52c7-08d5ad2bf6ba","name":"MINASA TRADING INTERNATIONAL LTDA","commercialName":"SINASA TRADING","cnpj":"47496286000101","city":"CAMPINAS","stateCode":"SP","buscaAdicional":"AMPARO MATR 3304 FIOS AMPARO-ITAPIRA 71095 FIOS AMPARO-AMPARO 71096"},{"id":"7234344b-acfb-4a26-5264-08d5ad2bf6ba","name":"CONDOMINIO SHOPPING CENTER IGUATEMI CAMPINAS","commercialName":"SHOPPING CENTER IGUATEMI CAMPINAS","cnpj":"52363629000108","city":"CAMPINAS","stateCode":"SP","buscaAdicional":"IGUATEMI CAMPI 3042 IGUATEMI CAMPINAS 70844"},{"id":"cece7dde-1083-42d9-523f-08d5ad2bf6ba","name":"ASSOCIATED SPRING DO BRASIL LTDA","commercialName":"","cnpj":"48610521000197","city":"CAMPINAS","stateCode":"SP","buscaAdicional":"ASBG BR 2972 ASSOCIATED SPRING 70812"},{"id":"56ad032b-fdc0-43d5-525d-08d5ad2bf6ba","name":"KERRY DO BRASIL LTDA","commercialName":"","cnpj":"02332686000143","city":"CAMPINAS","stateCode":"SP","buscaAdicional":"KERRY BRASIL 3023 KERRY DO BRASIL 70499 KERRY COTIA 909462"},{"id":"5c2a4ce8-c1ed-46fd-5350-08d5ad2bf6ba","name":"BAGLEY DO BRASIL ALIMENTOS LTDA","commercialName":"","cnpj":"06042467000180","city":"CAMPINAS","stateCode":"SP","buscaAdicional":"BAGLEY 3575 BAGLEY CAMPINAS 71113 BAGLEY CONTAGEM 71114"},{"id":"5a3d9e8e-864a-4e72-5300-08d5ad2bf6ba","name":"ASA ALUMINIO S/A","commercialName":"","cnpj":"68205509000104","city":"CAMPINAS","stateCode":"SP","buscaAdicional":"ASA ALUMINIO 3428 ASA ALUMINIO 71111 ASA ALUMINIO 72374"},{"id":"b6f24c76-e619-4777-53aa-08d5ad2bf6ba","name":"TRANSITIONS OPTICAL DO BRASIL LTDA","commercialName":"","cnpj":"00786201000166","city":"CAMPINAS","stateCode":"SP","buscaAdicional":"TRANSITIONS 3753 TRANSITIONS SUMARE 71280"},{"id":"d6b5c7b4-f388-4d1c-54a8-08d5ad2bf6ba","name":"BRIDGESTONE DO BRASIL INDUSTRIA E COMERCIO LTDA.","commercialName":"BRIDGESTONE CAMPINAS - BANDAS","cnpj":"57497539001359","city":"CAMPINAS","stateCode":"SP","buscaAdicional":"BRID CAMPINAS 4414 BANDAG DO BRASIL 71099"},{"id":"86091f7a-5b4c-4efc-550e-08d5ad2bf6ba","name":"AB SISTEMA DE FREIOS LTDA","commercialName":"CHASSIS BRAKES INTERNATIONAL BRASIL","cnpj":"13625300000108","city":"CAMPINAS","stateCode":"SP","buscaAdicional":"AB FREIOS 4965 AB FREIOS CAMP 70485"},{"id":"d16eba00-8e14-4914-577c-08d5ad2bf6ba","name":"ZOETIS INDUSTRIA DE PRODUTOS VETERINARIOS LTDA","commercialName":"","cnpj":"43588045000131","city":"CAMPINAS","stateCode":"SP","buscaAdicional":"ZOETIS 8951 FORT DODGE 888973"},{"id":"1468be09-b999-4e7a-57af-08d5ad2bf6ba","name":"CRODA DO BRASIL LTDA","commercialName":"","cnpj":"44144293000156","city":"CAMPINAS","stateCode":"SP","buscaAdicional":"CRODA MATRIZ 9332 CRODA MATRIZ 889242"},{"id":"007289f7-abd4-4b4f-57dc-08d5ad2bf6ba","name":"ENXUTO SUPERMERCADOS LTDA","commercialName":"","cnpj":"05789313000780","city":"CAMPINAS","stateCode":"SP","buscaAdicional":"ENXUTO 9810 ENXUTO 889280"},{"id":"42b08a72-2879-4f13-57e9-08d5ad2bf6ba","name":"SUPERMERCADOS DALBEN LTDA","commercialName":"SUPER MERCADO DALBEN","cnpj":"46241741000165","city":"CAMPINAS","stateCode":"SP","buscaAdicional":"DALBEN 10049 DALBEN ALBINO 889338 DALBEN PE JOAO 889339 SUPERMERCADOS DALBEN 897676"},{"id":"ce896bd8-34b9-4e63-5704-08d5ad2bf6ba","name":"MIRACEMA NUODEX INDUSTRIA QUIMICA LTDA","commercialName":"","cnpj":"46040242000100","city":"CAMPINAS","stateCode":"SP","buscaAdicional":"MIRACEMA 8140 MIRACEMA - CABINE I 888392 MIRACEMA - CABINE II 888394"},{"id":"01323b16-3e26-47ed-561e-08d5ad2bf6ba","name":"JSP BRASIL INDUSTRIA DE PLASTICOS LTDA","commercialName":"","cnpj":"01599556000109","city":"CAMPINAS","stateCode":"SP","buscaAdicional":"JSP BRASIL 6637 JSP IND PLAST - CAMP 72074"},{"id":"500227ce-fed2-43b9-563a-08d5ad2bf6ba","name":"AMPHENOL TFC DO BRASIL LTDA","commercialName":"","cnpj":"44603447000120","city":"CAMPINAS","stateCode":"SP","buscaAdicional":"AMPHENOL 6800 MPHENOL TFC - CAMP 72072"},{"id":"684e928b-d8c6-46aa-564c-08d5ad2bf6ba","name":"LOJAS RENNER S.A.","commercialName":"RENNER","cnpj":"92754738006527","city":"CAMPINAS","stateCode":"SP","buscaAdicional":"RENNER 6857 RENNER-L77-C GRANDE 72264 RENNER L63-SJR PRETO 72327 RENNER LOJA 32 888440 RENNER LOJA 58 888441 RENNER LJ 101 888655 RENNER LJ 153 888804 RENNER LJ 73 889502 RENNER LJ 040 889977 RENNER 70 890200 RENNER 173 890201 RENNER 046 890518 RENNER LJ 115 890558 RENNER LJ 130 891204 RENNER LOJA 145 893646"},{"id":"819aec91-326d-4ce1-6000-08d5ad2bf6ba","name":"SAMSUNG ELETRONICA DA AMAZONIA LTDA","commercialName":"","cnpj":"00280273000218","city":"CAMPINAS","stateCode":"SP","buscaAdicional":"SAMSUNG 53334 SAMSUNG ELETRONICA 905079 SAMSUNG 905102"},{"id":"93a3853b-29f6-44d8-6064-08d5ad2bf6ba","name":"IMERYS ITATEX SOLUCOES MINERAIS LTDA","commercialName":"ITATEX","cnpj":"48633713000119","city":"CAMPINAS","stateCode":"SP","buscaAdicional":"IMERYS ITATEX 53488 IMERYS ITATEX 904023"},{"id":"7007a915-9351-40a4-5f46-08d5ad2bf6ba","name":"TECIDOS FIAMA LIMITADA","commercialName":"","cnpj":"45986718000137","city":"CAMPINAS","stateCode":"SP","buscaAdicional":"FIAMA 52882 FIAMA 25 900695 FIAMA 235 900696"},{"id":"41509254-4995-45b1-5cd8-08d5ad2bf6ba","name":"SPAZIO OURO VERDE EMPREENDIMENTOS E PARTICIPACOES S.A.","commercialName":"","cnpj":"08736012000190","city":"CAMPINAS","stateCode":"SP","buscaAdicional":"SPAZIO SHOP 51589 REC SPAZIO 898804"},{"id":"ecd8cdb6-c410-41c3-5ccc-08d5ad2bf6ba","name":"CONDOMINIO CAMPINAS SHOPPING CENTER","commercialName":"CAMPINAS SHOPPING CENTER","cnpj":"00273712000184","city":"CAMPINAS","stateCode":"SP","buscaAdicional":"CAMPINAS SHOPPING 51573 CAMPINAS SHOPPING 899904 CAMP SHOP 0009783253 903914"},{"id":"cbc9943d-c6a3-4395-5c90-08d5ad2bf6ba","name":"DIVIMAX KANON - INDUSTRIA E COMERCIO DE VIDROS E ESPELHOS LTDA","commercialName":"KANON CAMPINAS","cnpj":"12939804000130","city":"CAMPINAS","stateCode":"SP","buscaAdicional":"DIVIMAX 51384 DIVIMAX KANON 899559"},{"id":"613be3ea-5fd5-47fd-5c9e-08d5ad2bf6ba","name":"COPPERSTEEL BIMETALICOS LTDA","commercialName":"","cnpj":"49808421000132","city":"CAMPINAS","stateCode":"SP","buscaAdicional":"COPPERSTEEL 51426 COPPERSTEEL 905097"},{"id":"b7c6660b-405c-421c-5da3-08d5ad2bf6ba","name":"MERCK SHARP & DOHME FARMACEUTICA LTDA","commercialName":"","cnpj":"45987013000304","city":"CAMPINAS","stateCode":"SP","buscaAdicional":"MSD CAMPINAS 51942 MERCK SHARP 899368"},{"id":"d2fad0a3-fb95-4a3e-5def-08d5ad2bf6ba","name":"ASCENTY DATA CENTERS E TELECOMUNICACOES S/A","commercialName":"","cnpj":"13743550000142","city":"CAMPINAS","stateCode":"SP","buscaAdicional":"ASCENTY TELECOM 52074 ASCENTY TELECOM SP 900011 ASCENTY DATA CENTERS 906386 ASCENTY DATA CT JND 907846"},{"id":"9aa81c13-d2ae-4b42-5eb3-08d5ad2bf6ba","name":"BROTO LEGAL ALIMENTOS S.A.","commercialName":"","cnpj":"62901210000108","city":"CAMPINAS","stateCode":"SP","buscaAdicional":"BROTO LEGAL 52511 BROTO CAMPINAS 900475 BROTO PORTO FERREIRA 900595"},{"id":"a71d2fcc-4da6-474b-5a8b-08d5ad2bf6ba","name":"EVEREST COMERCIALIZACAO DE ENERGIA LTDA","commercialName":"","cnpj":"21256386000177","city":"CAMPINAS","stateCode":"SP","buscaAdicional":"EVEREST ENERGIA 50003"},{"id":"43e2ee0f-b3ee-4a35-5a82-08d5ad2bf6ba","name":"CPFL BRASIL VAREJISTA S.A.","commercialName":"","cnpj":"22141909000100","city":"CAMPINAS","stateCode":"SP","buscaAdicional":"CPFL BRASIL VAREJISTA 49924 LINHASITA ITATIBA 72369 JACTO UN 8 904425 JACTO UN 2 904427 JACTO UN 7 904447 JACTO UN 4 904473 JACTO UN 6 904633 BRUDDEN 905116 JACTO UN 1 907901 JACTO UNIDADE 03 908273 JACTO UNIDADE 05 908274 ALCA FOODS 908378 VIRALCOOL UTE2 909997 INDUSTRIAS GRANFINO 910204 KI KAKAU UN 2 910881 KI-KAKAU 1 910888"},{"id":"c4fcd84e-0f60-4328-5c6f-08d5ad2bf6ba","name":"UNIPLAZA-EMPREEN.PART.E.ADMIN. CENTROS DE COMPRA LTDA","commercialName":"UNIPLAZA","cnpj":"62064225000169","city":"CAMPINAS","stateCode":"SP","buscaAdicional":"UNIMART 51316 SHOPPING UNIMART SP 898536"},{"id":"5c22f3b9-ae5a-4729-5c0b-08d5ad2bf6ba","name":"MOGIANA ALIMENTOS S/A","commercialName":"","cnpj":"45710423000133","city":"CAMPINAS","stateCode":"SP","buscaAdicional":"MOGIANA ALIMENTOS 51044 MOGIANA 898259"},{"id":"62e0037c-19a8-40d6-58ab-08d5ad2bf6ba","name":"BENTELER COMPONENTES AUTOMOTIVOS LTDA","commercialName":"BENTELER","cnpj":"00853157000160","city":"CAMPINAS","stateCode":"SP","buscaAdicional":"BENTELER 12793 CASPBENTEL 891864"},{"id":"3c8bc947-168b-4555-5852-08d5ad2bf6ba","name":"CPFL CENTRAIS GERADORAS LTDA.","commercialName":"","cnpj":"17578855000105","city":"CAMPINAS","stateCode":"SP","buscaAdicional":"CPFL CENTRAIS GERADORAS 11351 TURVINHO 890519 CGH.PH.SP.002896-7.01 LAVRINHA (CPFL) 890578 CGH.PH.SP.001317-0.01 SAO JOSE (CPFL) 890579 CGH.PH.SP.026849-6.01 SANTA ALICE 890580 CGH.PH.SP.002693-0.01 PINHEIRINHO 890660 CGH.PH.MG.002065-6.01 SAO SEBASTIAO (CPFL) 891163 CGH.PH.MG.028023-2.01"},{"id":"daedbe97-60b5-4a19-5839-08d5ad2bf6ba","name":"JOHN DEERE BRASIL LTDA","commercialName":"JOHN DEERE BRASIL LTDA","cnpj":"89674782001391","city":"CAMPINAS","stateCode":"SP","buscaAdicional":"JDBC 11069 JOHN DEERE CAMPINAS 889858"},{"id":"5a51faf6-5f62-4bb8-59ed-08d5ad2bf6ba","name":"Medley Farmacêutica Ltda.","commercialName":"MEDLEY FARMACEUTICA LTDA.","cnpj":"10588595000797","city":"CAMPINAS","stateCode":"SP","buscaAdicional":"MEDLEY COM 15975 MEDLEY CAMPINAS 70565"},{"id":"6fbd1020-a385-41c4-64ec-08d5ad2bf6ba","name":"QUINTA DO MARQUES ANHANGUERA RESTAURANTE E LANCHES LTDA","commercialName":"QUINTA DO MARQUES","cnpj":"16720384000157","city":"CAMPINAS","stateCode":"SP","buscaAdicional":"QUINTA DO MARQUES ANHANGUERA 56315 QUINTA MARQUES ANHAN 907686"},{"id":"132213ba-4a88-4693-63c8-08d5ad2bf6ba","name":"DNA BRASIL COMERCIO DE ALIMENTOS LTDA","commercialName":"ARMAZEM DA MARIA","cnpj":"05926986000149","city":"CAMPINAS","stateCode":"SP","buscaAdicional":"ARMAZEN DA MARIA 55630 DNA BRASIL COM ALIM 908168"},{"id":"bf132f98-db6d-40a1-6421-08d5ad2bf6ba","name":"ENXUTO SUPERMERCADOS LTDA","commercialName":"","cnpj":"05789313000194","city":"CAMPINAS","stateCode":"SP","buscaAdicional":"ENXUTO SUPER 55853 ENXUTO COSMOPOLIS 905080 ENXUTO SUPER 905134 ENXUTO CAMPINAS 905678 ENXUTO RIO CLARO 907029 ENXUTO SUPER LIMEIRA 907813"},{"id":"4fd628c6-8d28-4522-63e0-08d5ad2bf6ba","name":"SUPERMERCADO GALASSI LTDA","commercialName":"","cnpj":"64599871000156","city":"CAMPINAS","stateCode":"SP","buscaAdicional":"SUPERMERCADOS GALASSI 55690 GALASSI LJ 02 907519 GALASSI LJ 03 907520 GALASSI LJ 04 907521 GALASSI LJ 01 907522"},{"id":"6b27e9df-8fee-42bd-6182-08d5ad2bf6ba","name":"GUABI NUTRICAO E SAUDE ANIMAL S/A","commercialName":"","cnpj":"02918654001104","city":"CAMPINAS","stateCode":"SP","buscaAdicional":"GUABI 54216 GUABI SALES DE OLIVE 902979 GUABI PARA DE MINAS 903919 GUABI ALEM PARAIBA 904014 GUABI ANAPOLIS 904673"},{"id":"e34061d8-4605-49ea-62a1-08d5ad2bf6ba","name":"CONDOMINIO SHOPPING CENTER GALLERIA","commercialName":"SHOPPING CENTER GALLERIA","cnpj":"01529699000144","city":"CAMPINAS","stateCode":"SP","buscaAdicional":"SHOPPING CENTER GALLERIA 54839 GALLERIA CAMPINAS 905720"},{"id":"71586360-22d5-4845-6256-08d5ad2bf6ba","name":"ALGAR TI CONSULTORIA S/A","commercialName":"","cnpj":"05510654000693","city":"CAMPINAS","stateCode":"SP","buscaAdicional":"ALGAR TI 54689 ALGAR TI 904155"},{"id":"8395988f-a91f-464f-6324-08d5ad2bf6ba","name":"ALIBRA INGREDIENTES LTDA","commercialName":"ALIBRA","cnpj":"03645657000102","city":"CAMPINAS","stateCode":"SP","buscaAdicional":"ALIBRA INGREDIENTES 55182 ALIBRA INGREDIENTES 907396"},{"id":"522cc085-07bf-4b35-687f-08d5ad2bf6ba","name":"AEROPORTOS BRASIL - VIRACOPOS S.A.","commercialName":"","cnpj":"14522178000107","city":"CAMPINAS","stateCode":"SP","buscaAdicional":"VIRACOPOS 60103 VIRACOPOS 910598"},{"id":"8c517561-c0ee-423c-6874-08d5ad2bf6ba","name":"VITORIA HOTEIS LTDA","commercialName":"VITORIA NEW PORT RESIDENCE","cnpj":"03639008000190","city":"CAMPINAS","stateCode":"SP","buscaAdicional":"VITORIA HOTEIS MATRIZ 60075 VITORIA HOTEIS 910526"},{"id":"7dbd7ad8-dedd-4d7f-680a-08d5ad2bf6ba","name":"SOCIEDADE HIPICA DE CAMPINAS","commercialName":"","cnpj":"46017588000197","city":"CAMPINAS","stateCode":"SP","buscaAdicional":"HIPICA CAMPINAS 59212 SOC HIPICA CAMPINAS 910195"},{"id":"3c2ef5b9-a332-4e2c-6845-08d5ad2bf6ba","name":"BYD ENERGY DO BRASIL LTDA.","commercialName":"","cnpj":"21858948000152","city":"CAMPINAS","stateCode":"SP","buscaAdicional":"BYD 59656 BYD ENERGY BRASIL 909980"},{"id":"46e1c167-5ef2-46e3-658e-08d5ad2bf6ba","name":"EMPRESA PAULISTA DE TELEVISAO S/A","commercialName":"EPTV CAMPINAS","cnpj":"46242004000187","city":"CAMPINAS","stateCode":"SP","buscaAdicional":"EPTV 56828 EPTV CAMPINAS 907695 EPTV PARANA 907698 EPTV JAVARI 907699 EPTV SERTAOZINHO 907967"},{"id":"313fb385-5983-412d-65c0-08d5ad2bf6ba","name":"ASK PRODUTOS QUIMICOS DO BRASIL LTDA","commercialName":"ASK CHEMICALS DO BRASIL","cnpj":"43110170000131","city":"CAMPINAS","stateCode":"SP","buscaAdicional":"ASK 57051 ASK PRODUTO QUIMICO 907026"},{"id":"e3516a22-246e-421a-6757-08d5ad2bf6ba","name":"ASSOCIACAO DO CONDOMINIO DO SHOPPING PARQUE DAS BANDEIRAS","commercialName":"ACPB","cnpj":"16904176000108","city":"CAMPINAS","stateCode":"SP","buscaAdicional":"SHOP PQ DAS BANDEIRAS 58055 SHOP PQ BANDEIRAS 908400"},{"id":"ec1acfb0-b986-497e-66c4-08d5ad2bf6ba","name":"LIBRAPORT CAMPINAS S.A","commercialName":"","cnpj":"03795647000226","city":"CAMPINAS","stateCode":"SP","buscaAdicional":"LIBRA CAMPINAS 57792 LIBRA CAMPINAS 908456"},{"id":"fa567694-097e-4ccf-6701-08d5ad2bf6ba","name":"FUNDACAO CPQD - CENTRO DE PESQUISA E DESENVOLVIMENTO EM TELECOMUNICACOES","commercialName":"CPQD","cnpj":"02641663000110","city":"CAMPINAS","stateCode":"SP","buscaAdicional":"CPQD 57920 FUNDACAO CPQD UN 1 908151 CPQD UN 2 908729"},{"id":"dced7ae5-4d0c-4710-8daf-08d5d060706e","name":"HOSPITAL VERA CRUZ S A","commercialName":"","cnpj":"46009718000140","city":"CAMPINAS","stateCode":"SP","buscaAdicional":"VERA CRUZ 62691 VERA CRUZ 913552"},{"id":"0e433058-0eb0-4d1e-738b-08d5cf600bef","name":"CONSTRUTORA LIX DA CUNHA S/A.","commercialName":"","cnpj":"46014635000149","city":"CAMPINAS","stateCode":"SP","buscaAdicional":""},{"id":"30ddf7f3-df57-48c7-738c-08d5cf600bef","name":"SOCIEDADE DE ABASTECIMENTO DE AGUA E SANEAMENTO SA","commercialName":"SANASA CAMPINAS","cnpj":"46119855000137","city":"CAMPINAS","stateCode":"SP","buscaAdicional":""},{"id":"e90bc768-4b46-422c-7393-08d5cf600bef","name":"PLASCAR PARTICIPACOES INDUSTRIAIS S/A","commercialName":"PLASCAR S/A","cnpj":"51928174000150","city":"CAMPINAS","stateCode":"SP","buscaAdicional":""},{"id":"dc1ab4e8-61c7-49d2-7255-08d5cf600bef","name":"CPFL ENERGIA S.A.","commercialName":"","cnpj":"02429144000193","city":"CAMPINAS","stateCode":"SP","buscaAdicional":""},{"id":"222290f4-20d8-44bd-6480-08d5ad2bf6ba","name":"VITROTEC INDUSTRIA E COMERCIO EIRELI","commercialName":"VITROTEC","cnpj":"58610338000145","city":"CAMPO LIMPO PAULISTA","stateCode":"SP","buscaAdicional":"VITROTEC 56033 VITROTEC IND COM 908181"},{"id":"6c563ca7-85ea-4b19-5d75-08d5ad2bf6ba","name":"SUPERTEC EQUIPAMENTOS DE PROTECAO EIRELI","commercialName":"SUPERTEC EQUIPAMENTOS DE PROTECAO EIRELI","cnpj":"03310062000198","city":"CAMPO LIMPO PAULISTA","stateCode":"SP","buscaAdicional":"SUPERTEC 51827 SUPERTEC EQUIPAMENTO 898816"},{"id":"2add84ca-5048-4dd3-5032-08d5ad2bf6ba","name":"THYSSENKRUPP METALURGICA CAMPO LIMPO LTDA","commercialName":"","cnpj":"50942135000144","city":"CAMPO LIMPO PAULISTA","stateCode":"SP","buscaAdicional":"TKMCL 1509 THYSSENKRUPP C.LIMPO 7911"},{"id":"4be36bde-778b-4632-5e4f-08d5ad2bf6ba","name":"CASA DI CONTI LTDA","commercialName":"CONTINI","cnpj":"46842894000168","city":"CÂNDIDO MOTA","stateCode":"SP","buscaAdicional":"CONTINI 52327 CASA DI CONTI 900935"},{"id":"a3bad87d-771b-4fb1-6385-08d5ad2bf6ba","name":"INDUSTRIA DE PRODUTOS DE MANDIOCA SOL LTDA","commercialName":"","cnpj":"46061669000194","city":"CÂNDIDO MOTA","stateCode":"SP","buscaAdicional":"SOL 55426 SOL IND PRO MANDIOCA 906710"},{"id":"a6a3a50e-b115-42e7-62c1-08d5ad2bf6ba","name":"LOTUS COMERCIO E INDUSTRIA DE PRODS DE MANDIOCA LTDA","commercialName":"","cnpj":"49119969000175","city":"CÂNDIDO MOTA","stateCode":"SP","buscaAdicional":"LOTUS 1 54955 LOTUS MADIOCA 904948"},{"id":"53c71030-1533-47b4-61ff-08d5ad2bf6ba","name":"SICAD DO BRASIL FITAS AUTO ADESIVAS LTDA","commercialName":"","cnpj":"02485346000152","city":"CAPIVARI","stateCode":"SP","buscaAdicional":"SICAD 54500 SICAD DO BRASIL 906018"},{"id":"1d9290e2-8c6f-4b0e-6489-08d5ad2bf6ba","name":"MICROSAL INDUSTRIA E COMERCIO LTDA","commercialName":"","cnpj":"54111737000100","city":"CAPIVARI","stateCode":"SP","buscaAdicional":"MICROSAL 56079 MICROSAL IND COM LTD 907220"},{"id":"3a460b0a-0287-4934-67e3-08d5ad2bf6ba","name":"BTL INDUSTRIA E COMERCIO DE ACO LTDA","commercialName":"BTL STEEL WORKS","cnpj":"11041102000171","city":"CAPIVARI","stateCode":"SP","buscaAdicional":"BTL 58794 BTL ACO CAPIVARI 909189"},{"id":"fdd107b6-1822-462d-68bb-08d5ad2bf6ba","name":"LOLLY BABY PRODUTOS INFANTIS LTDA","commercialName":"","cnpj":"62367032000187","city":"CAPIVARI","stateCode":"SP","buscaAdicional":"LOLLY BABY 60358 LOLLY BABY 911803"},{"id":"4a01bb96-4c7b-471d-5fdd-08d5ad2bf6ba","name":"CONFECCOES CAPRICHO LTDA","commercialName":"","cnpj":"46365045000160","city":"CAPIVARI","stateCode":"SP","buscaAdicional":"CAPRICHO 53250 CAPRICHO 905098"},{"id":"c8d50e5a-e83e-43ff-514a-08d5ad2bf6ba","name":"CPIC BRASIL FIBRAS DE VIDRO LTDA.","commercialName":"CPIC BRASIL","cnpj":"08670308000156","city":"CAPIVARI","stateCode":"SP","buscaAdicional":"CPIC 2100 S GOBAIN CAPIVARI 7217"},{"id":"96038fcc-d78b-438d-5648-08d5ad2bf6ba","name":"SAINT-GOBAIN DO BRASIL PRODUTOS INDUSTRIAIS E PARA CONSTRUCAO LTDA","commercialName":"FABRICA CAPIVARI","cnpj":"61064838003906","city":"CAPIVARI","stateCode":"SP","buscaAdicional":"SGBRAS CAPIVAR 6838 SAINT GOBAIN CAPIV 72213"},{"id":"17fa3c59-048c-436b-5568-08d5ad2bf6ba","name":"BRANYL COMERCIO E INDUSTRIA TEXTIL LTDA","commercialName":"","cnpj":"43631191000100","city":"CAPIVARI","stateCode":"SP","buscaAdicional":"BRANYL 5531 BRANYL MATRIZ-CAPIV 71835 BRANYL CAPIVARI II 71878"},{"id":"d8690916-9bcf-4519-59cd-08d5ad2bf6ba","name":"CONDOMINIO DO SERRAMAR PARQUE SHOPPING","commercialName":"","cnpj":"16807903000119","city":"CARAGUATATUBA","stateCode":"SP","buscaAdicional":"COND SERRAMAR 15600 SERRAMAR CARAGUA 889093"},{"id":"cf9e9a09-6079-4e7d-6316-08d5ad2bf6ba","name":"SHIBATA COMERCIAL ATACADISTA DE MERCADORIAS EM GERAL LTDA","commercialName":"","cnpj":"09358143000144","city":"CARAGUATATUBA","stateCode":"SP","buscaAdicional":"SHIBATA CARAGUA 55131 SHIBATA CARAGUA 904812"},{"id":"c26539e9-87db-4255-6317-08d5ad2bf6ba","name":"COMERCIAL OSVALDO TARORA LTDA","commercialName":"SUPERMERCADOS SHIBATA","cnpj":"00185682000154","city":"CARAGUATATUBA","stateCode":"SP","buscaAdicional":"OSVALDO TARORA 55132 OSVALDO CARAGUA 904810 OSVALDO TARORA MOGI 904811"},{"id":"a7604104-5143-42f2-6329-08d5ad2bf6ba","name":"COFIBAM INDUSTRIA E COMERCIO DE FIOS E CABOS LTDA.","commercialName":"","cnpj":"43563840000175","city":"CARAPICUÍBA","stateCode":"SP","buscaAdicional":"COFIBAM 55195 COFIBAM 904966 COFIBAM 0022031936 907913"},{"id":"f10d797d-0e9f-4519-61ee-08d5ad2bf6ba","name":"ANTILHAS GRAFICA E EMBALAGENS LTDA","commercialName":"","cnpj":"02096748000165","city":"CARAPICUÍBA","stateCode":"SP","buscaAdicional":"ANTILHAS 54473 ANTILHAS EMBALAGENS 906258"},{"id":"91411b4d-09bc-4521-6660-08d5ad2bf6ba","name":"COMERCIAL CHAMA LTDA","commercialName":"CHAMA SUPERMERCADOS","cnpj":"60175221000122","city":"CARAPICUÍBA","stateCode":"SP","buscaAdicional":"CHAMA4 57514 COMERCIAL CHAMA 908302"},{"id":"b519ebdf-44a7-470d-1cc5-08d5b8870181","name":"KIM NETO INDUSTRIA E COMERCIO DE PANIFICACAO LTDA","commercialName":"","cnpj":"02867469000158","city":"CARAPICUÍBA","stateCode":"SP","buscaAdicional":"KIM PAES 61393 KIM PAES 912632"},{"id":"ff747a3d-89c0-4ea4-5dfb-08d5ad2bf6ba","name":"ALTACOPPO INDUSTRIA E COMERCIO DE PRODUTOS DESCARTAVEIS LTDA","commercialName":"","cnpj":"07711478000250","city":"CARAPICUÍBA","stateCode":"SP","buscaAdicional":"ALTACOPPO 52133 ALTACOPPO 899802"},{"id":"b4091f26-c842-4cb5-56bb-08d5ad2bf6ba","name":"VIRALCOOL - ACUCAR E ALCOOL LTDA.","commercialName":"","cnpj":"53811006000296","city":"CASTILHO","stateCode":"SP","buscaAdicional":"VIRAL CASTILHO 7561 VIRALCOOL CASTILHO C 908310 VIRALCOOL CASTILHO 891382 UTE.AI.SP.030445-0.01"},{"id":"e2fea182-e35f-4ed0-574a-08d5ad2bf6ba","name":"COCAM CIA DE CAFE SOLUVEL E DERIVADOS","commercialName":"COCAM","cnpj":"60421161000180","city":"CATANDUVA","stateCode":"SP","buscaAdicional":"COCAM 8490 COCAM SOLUVEL 888320 COCAM CATANDUVA 2 903880"},{"id":"dce113f4-3635-4e4f-571e-08d5ad2bf6ba","name":"LATICINIOS MATINAL LTDA","commercialName":"MATINAL","cnpj":"47081427000125","city":"CATANDUVA","stateCode":"SP","buscaAdicional":"MATILAT 8228 LATICINIOS MATINAL 904573"},{"id":"9de2faaa-afff-4279-5181-08d5ad2bf6ba","name":"USINA SAO DOMINGOS-ACUCAR E ETANOL S/A","commercialName":"","cnpj":"47063128000168","city":"CATANDUVA","stateCode":"SP","buscaAdicional":"SAO DOMINGOS I5 2212 SAO DOMINGOS -S. DOM 8241 UTE.AI.SP.027867-0.01"},{"id":"ec385874-858a-4764-603f-08d5ad2bf6ba","name":"FRUCAMP INDUSTRIA E COMERCIO LTDA","commercialName":"","cnpj":"01069184000109","city":"CATANDUVA","stateCode":"SP","buscaAdicional":"FRUCAMP 53436 FRUCAMP - CATANDUVA 904582"},{"id":"a2b86389-3661-43ca-68c8-08d5ad2bf6ba","name":"QUALYTUBO INDUSTRIA E COMERCIO DE TUBOS LTDA.","commercialName":"QUALYTUBO","cnpj":"05601998000101","city":"CEDRAL","stateCode":"SP","buscaAdicional":"QUALYTUBO 60413 QUALYTUBO CEDRAL 909992"},{"id":"47f4102b-1c54-45e8-672f-08d5ad2bf6ba","name":"GRAN CORTE ALIMENTOS, IMPORTACAO E EXPORTACAO LTDA","commercialName":"GRAN CORTE ALIMENTOS","cnpj":"17098519000157","city":"CERQUEIRA CÉSAR","stateCode":"SP","buscaAdicional":"GRAN CORTE 57995 GRAN CORTE 909307"},{"id":"a3f1b5a5-8106-4935-598d-08d5ad2bf6ba","name":"ALBIOMA RIO PARDO TERMOELETRICA LTDA","commercialName":"","cnpj":"18811751000153","city":"CERQUEIRA CÉSAR","stateCode":"SP","buscaAdicional":"PARDO TERMOELETRICA 14855 UTE RIO PARDO RC 71661 RIO PARDO 8603 UTE.AI.SP.030065-9.01"},{"id":"b4211e18-e28d-41c6-5cf4-08d5ad2bf6ba","name":"SELENE INDUSTRIA TEXTIL S A","commercialName":"","cnpj":"47254545000198","city":"CERQUILHO","stateCode":"SP","buscaAdicional":"SELENE 51630 SELENE INDUSTRIA 901142 SELENE IND TEXTIL 901144"},{"id":"5b4395a9-13da-47f4-4fb9-08d5ad2bf6ba","name":"PPE FIOS ESMALTADOS S.A","commercialName":"","cnpj":"62255682000130","city":"CERQUILHO","stateCode":"SP","buscaAdicional":"PPE FIOS 1253 PPE INVEX CERQUILHO 7334"},{"id":"418a1105-25de-4868-4f76-08d5ad2bf6ba","name":"FERRO LIGAS PIRACICABA LTDA.","commercialName":"FERRO LIGAS","cnpj":"54410899000140","city":"CERQUILHO","stateCode":"SP","buscaAdicional":"FERRO LIGAS 1122 LUIZ DE QUEIROZ 8284 PCH.PH.SP.001343-9.01 SAN JUAN 896128 PCH.PH.SP.002688-3.02"},{"id":"4a473b35-8eca-47e0-567e-08d5ad2bf6ba","name":"ELANTAS ISOLANTES ELETRICOS DO BRASIL LTDA.","commercialName":"ELANTAS DO BRASIL.","cnpj":"07682369000170","city":"CERQUILHO","stateCode":"SP","buscaAdicional":"ELANTAS 7204 ELANTAS - CERQUILHO 72166"},{"id":"70185e1e-49e7-4621-5384-08d5ad2bf6ba","name":"FIBERTEX NAOTECIDOS LTDA.","commercialName":"","cnpj":"04210314000170","city":"CERQUILHO","stateCode":"SP","buscaAdicional":"DUCI 3676 DUPONT CIPATEX 71199"},{"id":"de27a407-4193-43c7-537c-08d5ad2bf6ba","name":"CIPATEX IMPREGNADORA DE PAPEIS E TECIDOS LTDA","commercialName":"","cnpj":"47254461000154","city":"CERQUILHO","stateCode":"SP","buscaAdicional":"CIPATEX 3655 CIPATEX PAP TECIDOS 71197 CIPATEX SV FILIAL 2 71198 CIPATEX SNT VINILICO 71200"},{"id":"986c997c-b114-4f87-542b-08d5ad2bf6ba","name":"CORRADI MAZZER TEXTIL LTDA","commercialName":"","cnpj":"03731548000108","city":"CERQUILHO","stateCode":"SP","buscaAdicional":"CORRADI MAZZER 4042 CORRADI MAZZER-TIETE 71430 CORRADI MAZZER 2 CRQ 71572 CORRADI MAZZER3 CRQ 71573 CORRADI ESUL 1 TIETE 901714"},{"id":"617323aa-4f24-47a3-5ced-08d5ad2bf6ba","name":"CERAMICA CITY LTDA","commercialName":"","cnpj":"59324897000151","city":"CESÁRIO LANGE","stateCode":"SP","buscaAdicional":"CITY 51614 CITY 899276"},{"id":"38122d57-1710-44bf-5e54-08d5ad2bf6ba","name":"ASSOCIACAO TORRE DE VIGIA DE BIBLIAS E TRATADOS","commercialName":"","cnpj":"33755687000124","city":"CESÁRIO LANGE","stateCode":"SP","buscaAdicional":"ATV 52332 ASSOC TORRE DE VIGIA 903817"},{"id":"9aee1002-d032-408d-6763-08d5ad2bf6ba","name":"MCM QUIMICA INDUSTRIAL LTDA","commercialName":"","cnpj":"44917714000134","city":"CESÁRIO LANGE","stateCode":"SP","buscaAdicional":"MCM QUIMICA 58073 MCM QUIMICA INDUSTR 909728"},{"id":"9cbf62f2-41cb-4981-6377-08d5ad2bf6ba","name":"VIBEOLI CERAMICA LTDA","commercialName":"","cnpj":"06194838000140","city":"CESÁRIO LANGE","stateCode":"SP","buscaAdicional":"VIBEOLI CERAMICA 55378 CERAMICA VIBEOLI EPP 907305"},{"id":"bc9b7f0c-299d-4988-66c0-08d5ad2bf6ba","name":"A DAHER & CIA LTDA","commercialName":"SUPERMERCADO TO ME LEVE","cnpj":"45291341000100","city":"COLINA","stateCode":"SP","buscaAdicional":"TOME LEVE 57785 TOME LEVE LOJA 03 911786 TOME LEVE LOJA 02 911799 TOME LEVE LOJA 01 911800 TOME LEVE LOJA 05 911801 TOME LEVE LOJA 07 911806 TOME LEVE LOJA 04 911812 TOME LEVE LOJA 08 912016 TOME LEVE LOJA 06 912271"},{"id":"563e90b8-83cc-411e-541d-08d5ad2bf6ba","name":"TEREOS ACUCAR E ENERGIA SAO JOSE S.A.","commercialName":"","cnpj":"05266880000166","city":"COLINA","stateCode":"SP","buscaAdicional":"SJCOLINA 4019 SAO JOSE COLINA 8045 UTE.AI.SP.028975-2.01"},{"id":"34cd1729-3e5b-4ae9-55e9-08d5ad2bf6ba","name":"INDUSTRIA CERAMICA FRAGNANI LTDA","commercialName":"INCEFRA","cnpj":"47333539000126","city":"CORDEIRÓPOLIS","stateCode":"SP","buscaAdicional":"INCEFRA 6296 INCEFRA CORDEIROP 72210"},{"id":"4f60e8a8-e5ec-479e-50fe-08d5ad2bf6ba","name":"ARTEC PISOS E REVESTIMENTOS LTDA","commercialName":"ARTEC","cnpj":"03548440000176","city":"CORDEIRÓPOLIS","stateCode":"SP","buscaAdicional":"ARTEC 1939 ARTEC PISOS E REVEST 906703"},{"id":"fddd9800-d452-4e89-5cc7-08d5ad2bf6ba","name":"RUY R DA ROCHA PRODUTOS CERAMICOS LTDA","commercialName":"","cnpj":"57107609000343","city":"CORDEIRÓPOLIS","stateCode":"SP","buscaAdicional":"RUY ROCHA 51566 RUY R DA ROCHA 898826"},{"id":"d82f6db6-258c-4ee7-6015-08d5ad2bf6ba","name":"CERAMICA CARMELO FIOR LTDA","commercialName":"","cnpj":"60519634000187","city":"CORDEIRÓPOLIS","stateCode":"SP","buscaAdicional":"CARMELO FIOR 53371 CARMELO FIOR 900785 CARMELO FIOR CORDEIR 904680"},{"id":"d5267eb7-6dfe-4d57-6107-08d5ad2bf6ba","name":"CERAMICA RAMOS LTDA","commercialName":"","cnpj":"00278016000160","city":"CORDEIRÓPOLIS","stateCode":"SP","buscaAdicional":"CERAMOS 53974 CERAMICA RAMOS 905176"},{"id":"8826f39e-7a17-4e44-60fb-08d5ad2bf6ba","name":"VIVA PISOS E REVESTIMENTOS LTDA","commercialName":"","cnpj":"14274947000103","city":"CORDEIRÓPOLIS","stateCode":"SP","buscaAdicional":"VIVA PISOS 53936 VIVA PISOS 905164 VIVA PISOS REV 905168"},{"id":"4a959685-09fd-4776-5b18-08d5ad2bf6ba","name":"INDUSTRIA DE URNAS BIGNOTTO LTDA","commercialName":"BIGNOTTO","cnpj":"51049401000177","city":"CORDEIRÓPOLIS","stateCode":"SP","buscaAdicional":"IUB 50460 IND URNAS BIGNOTTO 898320"},{"id":"ea1608a4-154b-46f5-660b-08d5ad2bf6ba","name":"CEZAN EMBALAGENS LTDA","commercialName":"CEZAN EMBALAGENS","cnpj":"47331640000148","city":"CORDEIRÓPOLIS","stateCode":"SP","buscaAdicional":"CEZAN 57281 CEZAN SP 907314 CEZAN MG 908717"},{"id":"9de3240e-2c9b-4f25-6866-08d5ad2bf6ba","name":"CICOPLAST INDUSTRIA E COMERCIO DE PLASTICOS LTDA","commercialName":"CICOPLAST","cnpj":"02573636000158","city":"CORDEIRÓPOLIS","stateCode":"SP","buscaAdicional":"CICOPLAST 59912 CICOPLAST 910224"},{"id":"fbf6ae32-ed45-49e1-6176-08d5ad2bf6ba","name":"MINERADORA AGUA BRANCA LTDA","commercialName":"","cnpj":"19347955000148","city":"CORDEIRÓPOLIS","stateCode":"SP","buscaAdicional":"AGUA BRANCA 54198 MINERADORA AGUA BRAN 902685"},{"id":"daeb3cc2-8fbd-47a3-631f-08d5ad2bf6ba","name":"INDUSTRIAS DE PAPEL R RAMENZONI S/A","commercialName":"","cnpj":"58910316000877","city":"CORDEIRÓPOLIS","stateCode":"SP","buscaAdicional":"RAMENZONI FILIAL CL 55176 RAMENZONI FILIAL 906093"},{"id":"3f61be0c-49a5-4fed-5b13-08d5ad2bf6ba","name":"GRAMATURA PAPEIS E ARTEFATOS LTDA","commercialName":"","cnpj":"61793667000183","city":"COROADOS","stateCode":"SP","buscaAdicional":"GRAMATURA 50454 GRAMATURA 898079"},{"id":"417de21e-7f45-44e5-5d12-08d5ad2bf6ba","name":"ANTIBIOTICOS DO BRASIL LTDA.","commercialName":"","cnpj":"05439635000103","city":"COSMÓPOLIS","stateCode":"SP","buscaAdicional":"ANTIBIOTICOS DO BRASIL 51694 ANTIBIOTICOS BRASIL 899568 ANTIBIOTICOS SUMARE 899569"},{"id":"ed71ee42-0d17-4608-5de2-08d5ad2bf6ba","name":"NEWSUL S/A EMBALAGENS E COMPONENTES","commercialName":"","cnpj":"00386430000355","city":"COSMÓPOLIS","stateCode":"SP","buscaAdicional":"NEWSUL SP 52056 NEWSUL EMBALAGENS 901573"},{"id":"b083e696-782f-4d9c-5169-08d5ad2bf6ba","name":"USINA ACUCAREIRA ESTER S A","commercialName":"","cnpj":"60892098000160","city":"COSMÓPOLIS","stateCode":"SP","buscaAdicional":"USINA ESTER 2161 CARGA USINA ESTER 71351"},{"id":"c79e55aa-24a0-4d6e-6562-08d5ad2bf6ba","name":"GLOBE QUIMICA S.A.","commercialName":"","cnpj":"03198606000171","city":"COSMÓPOLIS","stateCode":"SP","buscaAdicional":"GLOBE QUIMICA 56705 GLOBE QUIMICA SA 908153"},{"id":"de93765d-4f65-47b1-88df-08d5ae44ed50","name":"COSMO INDUSTRIA E COMERCIO DE EMBALAGENS PLASTICAS EIRELI","commercialName":"COSMO EMBALAGENS","cnpj":"08914082000191","city":"COSMÓPOLIS","stateCode":"SP","buscaAdicional":"COSMO 53745 COSMO IND E COM EMB. 906013"},{"id":"dedcd62a-11c7-441e-1cd4-08d5b8870181","name":"DELPHI POWERTRAIN SYSTEM INDUSTRIA E COMERCIO LTDA.","commercialName":"DELPHI POWERTRAIN SYSTEM INDUSTRIA E COMERCIO LTDA.","cnpj":"25043386000220","city":"COTIA","stateCode":"SP","buscaAdicional":"DELPHI AUTO 2 62110"},{"id":"a4171b01-406e-4011-73f5-08d5cf600bef","name":"SPRINGER S.A.","commercialName":"","cnpj":"92929520000100","city":"COTIA","stateCode":"SP","buscaAdicional":""},{"id":"3a632764-2d02-4b4d-6553-08d5ad2bf6ba","name":"METALURGICA ONNIX INDUSTRIA E COMERCIO EIRELI","commercialName":"","cnpj":"60596434000128","city":"COTIA","stateCode":"SP","buscaAdicional":"METALURGICA ONNIX 56654 METALURGICA ONNIX 905844"},{"id":"59b1a4ac-5eea-4e21-6462-08d5ad2bf6ba","name":"REHAU INDUSTRIA LTDA","commercialName":"","cnpj":"47419270000103","city":"COTIA","stateCode":"SP","buscaAdicional":"REHAU 55970 REHAU INDUSTRIA LTDA 906878"},{"id":"dd5fd8e4-7037-4a8f-62e0-08d5ad2bf6ba","name":"DANISCO BRASIL LTDA","commercialName":"","cnpj":"46278016000161","city":"COTIA","stateCode":"SP","buscaAdicional":"DANISCO 55021 DANISCO PIRAPOZINHO 906094"},{"id":"341881de-c384-4890-6184-08d5ad2bf6ba","name":"CENTURYLINK COMUNICACOES DO BRASIL LTDA.","commercialName":"","cnpj":"72843212000141","city":"COTIA","stateCode":"SP","buscaAdicional":"LEVEL 3 54218 LEVEL 3 903461 LEVEL 3 PRAIA GRANDE 908395 LEVEL 3 CRISTOVAO 908439 LEVEL 3-BANDEIRANTES 908548"},{"id":"f0b33e68-30c4-4edc-6137-08d5ad2bf6ba","name":"DENVER ESPECIALIDADES QUIMICAS LTDA.","commercialName":"","cnpj":"09471917000149","city":"COTIA","stateCode":"SP","buscaAdicional":"DENVER 54057 COTIA 902518 ITAPEVI 902763"},{"id":"211c79c8-096d-4250-61d5-08d5ad2bf6ba","name":"ASTRAZENECA DO BRASIL LTDA.","commercialName":"","cnpj":"60318797000100","city":"COTIA","stateCode":"SP","buscaAdicional":"ASTRAZENECA 54441 ASTRAZENECA 905549"},{"id":"095a1cb7-5094-425a-68b8-08d5ad2bf6ba","name":"ALFA COMERCIALIZADORA DE ENERGIA LTDA","commercialName":"","cnpj":"27880428000122","city":"COTIA","stateCode":"SP","buscaAdicional":"ALFA ENERGIA 60354"},{"id":"175341e4-7dad-47d2-68cc-08d5ad2bf6ba","name":"STYROPLAST - ESPUMAS INDUSTRIAIS LTDA.","commercialName":"STYROPLAST MATRIZ CAUCAIA DO ALTO","cnpj":"04074553000140","city":"COTIA","stateCode":"SP","buscaAdicional":"STYROPLAST 60418 STYROPLAST COTIA 910065"},{"id":"216e84fe-ce72-43d7-689b-08d5ad2bf6ba","name":"KLOCKNER PENTAPLAST DO BRASIL LTDA","commercialName":"","cnpj":"59201087000108","city":"COTIA","stateCode":"SP","buscaAdicional":"KLOCKNER PENTAPLAST 60203 KLOKCNER PENTAPLAST 911212"},{"id":"062b5bf4-ce55-49ab-67e1-08d5ad2bf6ba","name":"NOVA NORDEPLAST INDUSTRIA E COMERCIO DE PLASTICOS LTDA","commercialName":"","cnpj":"26608960000122","city":"COTIA","stateCode":"SP","buscaAdicional":"NOVA NORDEPLAST 58791 NORDEPLAST COTIA 903217"},{"id":"860dd4ed-6fd0-4d1d-52af-08d5ad2bf6ba","name":"DELPHI AUTOMOTIVE SYSTEMS DO BRASIL LTDA","commercialName":"","cnpj":"00857758002194","city":"COTIA","stateCode":"SP","buscaAdicional":"DELPHI AUTO 3232 DELPHI AUTO 71104"},{"id":"d7d25ffb-8408-480c-563d-08d5ad2bf6ba","name":"CONDOMINIO DO SHOPPING CENTER GRANJA VIANNA","commercialName":"CONDOMINIO DO SHOPPING CENTER GRANJA VIANNA","cnpj":"12546508000179","city":"COTIA","stateCode":"SP","buscaAdicional":"SHOP GRANJA VI 6818 SHP G VIANNA-COTIA 72290"},{"id":"2dd96e40-7cd0-47b2-5632-08d5ad2bf6ba","name":"GELITA DO BRASIL LTDA.","commercialName":"GELITA","cnpj":"12199337000159","city":"COTIA","stateCode":"SP","buscaAdicional":"GELITA 6757 GELITA - MOCOCA A 72270 GELITA - MOCOCA B 72271 GELITA COTIA 889007"},{"id":"db5120b8-9387-4ece-5db7-08d5ad2bf6ba","name":"NOVA ERA INDUSTRIA E COMERCIO DE EMBALAGENS PLASTICAS EIRELI","commercialName":"NOVA ERA","cnpj":"04596745000116","city":"COTIA","stateCode":"SP","buscaAdicional":"NOVA ERA 51964 NOVA ERA 901817 NOVA ERA FILIAL 909638"},{"id":"5dd2410e-6095-4c58-5eb4-08d5ad2bf6ba","name":"RAPOSO INDUSTRIA E COMERCIO DE PLASTICOS EIRELI","commercialName":"","cnpj":"62165881000158","city":"COTIA","stateCode":"SP","buscaAdicional":"RAPOSO PLASTICOS 52512 RAPOSO PLASTICOS 901833"},{"id":"a9c7a814-292e-4a7d-5cd1-08d5ad2bf6ba","name":"GREAT FOOD PRODUTOS ALIMENTICIOS LTDA","commercialName":"","cnpj":"71815229000122","city":"COTIA","stateCode":"SP","buscaAdicional":"GREAT FOOD 51578 GREAT FOOD 898767 GREAT FOOD - GUARUJA 901396"},{"id":"ebd3c563-8233-4c1b-60bf-08d5ad2bf6ba","name":"SEDER INDUSTRIA E COMERCIO DE MOVEIS LTDA","commercialName":"","cnpj":"59738740000172","city":"COTIA","stateCode":"SP","buscaAdicional":"SEDER 53655 SEDER 904541"},{"id":"95f880d3-e392-4e27-6041-08d5ad2bf6ba","name":"ZANAFLEX BORRACHAS LTDA","commercialName":"ZANAFLEX","cnpj":"62055710000176","city":"COTIA","stateCode":"SP","buscaAdicional":"ZANAFLEX 53438 ZANAFLEX 904968"},{"id":"5d637e9f-bf6a-450d-57f6-08d5ad2bf6ba","name":"FLINT GROUP TINTAS DE IMPRESSAO LTDA.","commercialName":"","cnpj":"33084922000183","city":"COTIA","stateCode":"SP","buscaAdicional":"FLINT 10269 FLINT 907329"},{"id":"2770f001-674a-4160-585f-08d5ad2bf6ba","name":"ZANINI RENK EQUIPAMENTOS INDUSTRIAIS LTDA","commercialName":"ZANINI RENK","cnpj":"47038294000104","city":"CRAVINHOS","stateCode":"SP","buscaAdicional":"ZANINI RENK 11549 RENK ZANINI 889997"},{"id":"e804ef28-a54f-4f1f-5370-08d5ad2bf6ba","name":"OURO FINO SAUDE ANIMAL LTDA","commercialName":"","cnpj":"57624462000105","city":"CRAVINHOS","stateCode":"SP","buscaAdicional":"OURO FINO 3636 OURO FINO S ANIMAL 71190"},{"id":"faa48d85-f331-4810-4ee8-08d5d159243d","name":"OURO FINO SAUDE ANIMAL PARTICIPACOES S.A.","commercialName":"","cnpj":"20258278000170","city":"CRAVINHOS","stateCode":"SP","buscaAdicional":""},{"id":"50e245ab-500f-4c0f-73b3-08d5cf600bef","name":"IOCHPE-MAXION S.A.","commercialName":"","cnpj":"61156113000175","city":"CRUZEIRO","stateCode":"SP","buscaAdicional":""},{"id":"231df60d-df8f-439a-5746-08d5ad2bf6ba","name":"CRUZEIRO PAPEIS INDUSTRIAIS LTDA","commercialName":"","cnpj":"48410211000200","city":"CRUZEIRO","stateCode":"SP","buscaAdicional":"CPI 8470 CPI 888696"},{"id":"eed3fefa-d000-41f4-504e-08d5ad2bf6ba","name":"AMSTED-MAXION FUNDICAO E EQUIPAMENTOS FERROVIARIOS S/A","commercialName":"","cnpj":"01599436000101","city":"CRUZEIRO","stateCode":"SP","buscaAdicional":"AMSTED MATRIZ 1564 AMST MTZCR 7983"},{"id":"ec3742d6-3b77-484f-5c45-08d5ad2bf6ba","name":"DAN VIGOR INDUSTRIA E COMERCIO DE LATICINIOS LTDA","commercialName":"","cnpj":"55566871000169","city":"CRUZEIRO","stateCode":"SP","buscaAdicional":"DAN VIGOR 51240 VIGOR BELENZINHO 70999 DAN VIGOR - S.C.SUL 71000 DAN VIGOR 898165 VIGOR SAPUCAI MG 899112 VIGOR - ANAPOLIS 903575 DAN VIGOR - EMBU 910098 DAN VIGOR - BARRA PI 911575"},{"id":"3c64b11e-260b-4af7-5802-08d5ad2bf6ba","name":"COMPANHIA BRASILEIRA DE ESTIRENO","commercialName":"","cnpj":"61079232000252","city":"CUBATÃO","stateCode":"SP","buscaAdicional":"CBE CUBATAO 10392 CIA BRAS. ESTIRENO 889520"},{"id":"f8b4a4cc-b232-4d53-508c-08d5ad2bf6ba","name":"BAIXADA SANTISTA ENERGIA S.A.","commercialName":"","cnpj":"03059729000121","city":"CUBATÃO","stateCode":"SP","buscaAdicional":"BSE 1711 PIRATININGA 12 8338 UTE.PE.SP.002082-6.01"},{"id":"2fdf564a-2328-442d-5233-08d5ad2bf6ba","name":"USINAS SIDERURGICAS DE MINAS GERAIS S/A. USIMINAS","commercialName":"","cnpj":"60894730006308","city":"CUBATÃO","stateCode":"SP","buscaAdicional":"USIMINAS SP 2921 COSIPA CUBATAO 7532"},{"id":"37163520-b469-4f88-56e1-08d5ad2bf6ba","name":"PETROCOQUE S A INDUSTRIA E COMERCIO","commercialName":"PETROCOQUE","cnpj":"43218296000124","city":"CUBATÃO","stateCode":"SP","buscaAdicional":"PETROCOQUE 7868 PETROCOQUE 888334 UTE PETROCOQUE 899107 UTE.PE.SP.031229-0.01"},{"id":"9c3137d8-de0e-4e02-5386-08d5ad2bf6ba","name":"NIOBRAS MINERACAO LTDA.","commercialName":"MINERACAO CATALAO DE GOIAS","cnpj":"07171562000147","city":"CUBATÃO","stateCode":"SP","buscaAdicional":"ANGLO NIOBIO 3679 ANGLO AMERICAN CATAL 7149 TAILINGS 71137 NIOBIO MINA CATALAO 909711"},{"id":"8a260b1f-22d8-4462-536f-08d5ad2bf6ba","name":"VALE CUBATAO FERTILIZANTES LTDA.","commercialName":"","cnpj":"11403023000163","city":"CUBATÃO","stateCode":"SP","buscaAdicional":"VALE CUBATAO 3635 VALE CUBATAO - CUB2 157 VALE CUBATAO - CUB1 7014 VALE CUBATAO - CUB3 70213 VALE CUBATAO - CUB4 70476"},{"id":"9a9467e0-1bae-4d8d-5596-08d5ad2bf6ba","name":"LINDE BOC GASES LTDA","commercialName":"","cnpj":"02605266000274","city":"CUBATÃO","stateCode":"SP","buscaAdicional":"LINDE CO2CUB 5877 LINDE CO2-CUBATAO 71944"},{"id":"20df6eb1-5378-49f3-62c4-08d5ad2bf6ba","name":"CEFERTIL-CESARI FERTILIZANTES LTDA","commercialName":"CEFERTIL","cnpj":"03359531000163","city":"CUBATÃO","stateCode":"SP","buscaAdicional":"CEFERTIL 54959 CEFERTIL - CEZARI 906598"},{"id":"66d259ce-0ebf-4668-5584-08d5ad2bf6ba","name":"ROYAL CANIN DO BRASIL INDUSTRIA E COMERCIO LTDA","commercialName":"","cnpj":"62527619000106","city":"DESCALVADO","stateCode":"SP","buscaAdicional":"ROYAL CANIN 5737 ROYAL CANIN-DESCALV 72015"},{"id":"5d10bcf2-b840-4c7e-5560-08d5ad2bf6ba","name":"MINERACAO DESCALVADO LIMITADA","commercialName":"","cnpj":"54114475000138","city":"DESCALVADO","stateCode":"SP","buscaAdicional":"DESCALVADO 5470 MINERACAO DESCALVADO 71984"},{"id":"3698a96e-6f4c-4c9a-5509-08d5ad2bf6ba","name":"IBG CRYO INDUSTRIA DE GASES LTDA","commercialName":"IBG CRYO INDUSTRIA DE GASES","cnpj":"74481011000177","city":"DESCALVADO","stateCode":"SP","buscaAdicional":"IBG CRYO 4941 INTERGAS-DESCALVADO 71857"},{"id":"17dbd842-3815-46cb-572d-08d5ad2bf6ba","name":"SPF DO BRASIL INDUSTRIA E COMERCIO LTDA","commercialName":"","cnpj":"00981411000105","city":"DESCALVADO","stateCode":"SP","buscaAdicional":"SPF 8309 SPF DESCALVADO 888325"},{"id":"b55cd103-b6f3-47a1-583b-08d5ad2bf6ba","name":"INVIVO NUTRICAO E SAUDE ANIMAL LTDA","commercialName":"","cnpj":"06066837001000","city":"DESCALVADO","stateCode":"SP","buscaAdicional":"INVIVO DESCALVADO 11071 INVIVO DESCALVADO 71051"},{"id":"ae47555a-fcc7-408a-58c9-08d5ad2bf6ba","name":"MINERACAO JUNDU LTDA","commercialName":"","cnpj":"60628468000157","city":"DESCALVADO","stateCode":"SP","buscaAdicional":"SGJUNDU MAT 13312 SGJUNDU BOM 891844 JUNDU SJDR 895007 JUNDU BARRA DO SUL 893063 JUNDU VIAMAO 894442 JUNDU DESCALVADO 894562"},{"id":"70e097cd-763f-4107-5ef1-08d5ad2bf6ba","name":"SCALLA CERAMICA ARTISTICA LTDA","commercialName":"","cnpj":"56520703000103","city":"DESCALVADO","stateCode":"SP","buscaAdicional":"SCALLA 52619 SCALLA 902259"},{"id":"c3baf0de-12a7-4c98-5f22-08d5ad2bf6ba","name":"MAZZAFERRO IND. E COM. DE PRODUTOS PARA PESCA S/A","commercialName":"","cnpj":"61274247000190","city":"DIADEMA","stateCode":"SP","buscaAdicional":"MAZZAFERRO PESCA 52774 MAZZAFERRO - DIADEMA 902978"},{"id":"1941f6b8-2e1a-49b5-5f38-08d5ad2bf6ba","name":"ITAESBRA INDUSTRIA MECANICA LTDA","commercialName":"","cnpj":"61381323000248","city":"DIADEMA","stateCode":"SP","buscaAdicional":"ITAESBRA 52850 ITAESBRA 903780"},{"id":"52c10538-99dc-486e-5f72-08d5ad2bf6ba","name":"CONTINENTAL PARAFUSOS S/A","commercialName":"","cnpj":"45580693000177","city":"DIADEMA","stateCode":"SP","buscaAdicional":"CONTI PARAFUSOS 52959 CONTINENTAL PARAFUSO 903451 CONTI PARAFUSOS G9 903631"},{"id":"f284f2d6-2d24-4b11-5f58-08d5ad2bf6ba","name":"CONDOMINIO DO SHOPPING PRACA DA MOCA","commercialName":"","cnpj":"09281025000185","city":"DIADEMA","stateCode":"SP","buscaAdicional":"SC PRACA DA MOCA 52908 SHOPPING PRACA MOCA 899952"},{"id":"1d170ae1-4210-4e1d-5e9e-08d5ad2bf6ba","name":"METALTORK INDUSTRIA E COMERCIO DE AUTO PECAS LIMITADA","commercialName":"","cnpj":"59160069000125","city":"DIADEMA","stateCode":"SP","buscaAdicional":"METALTORK 52465 METALTORK INDUSTRIA 901039"},{"id":"6007d310-7df1-4b74-5e99-08d5ad2bf6ba","name":"TTB INDUSTRIA E COMERCIO DE PRODUTOS METALICOS LTDA","commercialName":"","cnpj":"59108837000100","city":"DIADEMA","stateCode":"SP","buscaAdicional":"TTB 52460 TTBTTB - DIADEMA 902631"},{"id":"f6a3ad29-a0e9-462b-5e29-08d5ad2bf6ba","name":"PAPAIZ - UDINESE METAIS INDUSTRIA E COMERCIO LTDA.","commercialName":"","cnpj":"61553301000137","city":"DIADEMA","stateCode":"SP","buscaAdicional":"UDINESE 52239 UDINESE PAPAIZ SP 899613"},{"id":"6c0b9619-c340-48d6-5b99-08d5ad2bf6ba","name":"WEST PHARMACEUTICAL SERVICES BRASIL LTDA","commercialName":"","cnpj":"61417150000190","city":"DIADEMA","stateCode":"SP","buscaAdicional":"WEST PHARMA 50776 WESTPHARMA 898073"},{"id":"fb485147-3128-415c-56df-08d5ad2bf6ba","name":"ISRINGHAUSEN INDUSTRIAL LTDA","commercialName":"","cnpj":"61036141000159","city":"DIADEMA","stateCode":"SP","buscaAdicional":"ISRINGHAUSEN 7866 ISRINGHAUSEN DIADEMA 72382"},{"id":"de8b030b-e223-4bdd-5630-08d5ad2bf6ba","name":"FREUDENBERG-NOK COMPONENTES BRASIL LTDA","commercialName":"FREUDENBERG-NOK","cnpj":"59112359000101","city":"DIADEMA","stateCode":"SP","buscaAdicional":"FREUDENBERG 6738 FREUDENBERG-NOK 72084"},{"id":"36d2eeeb-11d0-4936-560f-08d5ad2bf6ba","name":"WAELZHOLZ BRASMETAL LAMINACAO LTDA","commercialName":"","cnpj":"12763658000134","city":"DIADEMA","stateCode":"SP","buscaAdicional":"BW 6577 BRASMETAL BW 70391"},{"id":"645fa7ae-915f-47d3-55ce-08d5ad2bf6ba","name":"RESIL COMERCIAL INDUSTRIAL LTDA","commercialName":"","cnpj":"68124858000100","city":"DIADEMA","stateCode":"SP","buscaAdicional":"RCI 6178 RESIL COML-DIADEMA 72243"},{"id":"23277ed0-0e95-4c08-5667-08d5ad2bf6ba","name":"DELGA INDUSTRIA E COMERCIO S/A","commercialName":"","cnpj":"61532198000149","city":"DIADEMA","stateCode":"SP","buscaAdicional":"DELGA DIADEMA 7017 DELGA LAPA 71927 DELGA PIRATININGA SP 72159 DELGA FERRAZ 888406 DELGA DIADEMA MATRIZ 888863 DELGA JARINU 910061 DELGA SAO LEOPOLDO 888680"},{"id":"2c520c88-dd0f-42e9-56a4-08d5ad2bf6ba","name":"FEDERAL-MOGUL SISTEMAS AUTOMOTIVOS LTDA.","commercialName":"FEDERAL MOGUL MATERIAIS DE FRICCAO LTDA","cnpj":"00747901000303","city":"DIADEMA","stateCode":"SP","buscaAdicional":"F MOGUL DIAD 7422 FEDERAL MOGUL 71309"},{"id":"b1facc90-786b-4aaa-54ea-08d5ad2bf6ba","name":"ESCALA 7 EDITORA GRAFICA LTDA","commercialName":"","cnpj":"48575260000111","city":"DIADEMA","stateCode":"SP","buscaAdicional":"ESCALA 7 4591 ESCALA 7-SAO PAULO 71781"},{"id":"58c39fce-adf7-4182-5590-08d5ad2bf6ba","name":"COMPONENT INDUSTRIA E COMERCIO LTDA","commercialName":"","cnpj":"62672415000169","city":"DIADEMA","stateCode":"SP","buscaAdicional":"COMPONENT 5801 COMPONENT 889621"},{"id":"c8d16ef9-ad62-40f7-5225-08d5ad2bf6ba","name":"METAGAL INDUSTRIA E COMERCIO LTDA","commercialName":"METAGAL","cnpj":"59106377000253","city":"DIADEMA","stateCode":"SP","buscaAdicional":"METAGAL SP EI 2886 METAGAL DIADEMA 70773"},{"id":"f958f3f3-1aea-4b36-5182-08d5ad2bf6ba","name":"INDUSTRIA DE PLASTICOS INDEPLAST EIRELI","commercialName":"","cnpj":"48938724000107","city":"DIADEMA","stateCode":"SP","buscaAdicional":"INDEPLAST 2213 IND PLAST.INDEPLAST 70546"},{"id":"d9ca4e20-1b35-495f-52a2-08d5ad2bf6ba","name":"EMBALAGENS FLEXIVEIS DIADEMA S/A","commercialName":"","cnpj":"04716366000112","city":"DIADEMA","stateCode":"SP","buscaAdicional":"EMBDIADEMA 3192 EMB. DIADEMA 71037"},{"id":"379de433-2b54-4833-530a-08d5ad2bf6ba","name":"MULT TEMPERA COAT TECNOLOGIA EM TRATAMENTO TERMICO E REVESTIMENTOS SUPERFICIAIS LTDA","commercialName":"MULT TEMPERA COAT TRATAMENTO TERMICO","cnpj":"01573478000173","city":"DIADEMA","stateCode":"SP","buscaAdicional":"MTC TRAT 3450 MULT TEMPERA-DIADEMA 71166"},{"id":"2b7d52cc-6603-4e41-5082-08d5ad2bf6ba","name":"TRW AUTOMOTIVE LTDA","commercialName":"TRW","cnpj":"60857349000923","city":"DIADEMA","stateCode":"SP","buscaAdicional":"TRW DIADEMA 1666 TRW AUTOM.-DIADEMA 7176"},{"id":"07482279-7019-43e7-507a-08d5ad2bf6ba","name":"AUTOMETAL S/A","commercialName":"","cnpj":"59104513000195","city":"DIADEMA","stateCode":"SP","buscaAdicional":"AUTOMETAL 1645 AUTOMETAL-DIADEMA 70064"},{"id":"976c6643-1b49-4308-5067-08d5ad2bf6ba","name":"COOP. CENTRAL DE PROD. INDL. DE TRAB. EM METALURGIA - UNIFORJA","commercialName":"","cnpj":"04136535000145","city":"DIADEMA","stateCode":"SP","buscaAdicional":"UNIFORJA 1609 UNIFORJA-DIADEMA-SP 70031"},{"id":"cdc1bc43-fe0e-40fb-5064-08d5ad2bf6ba","name":"INYLBRA INDUSTRIA E COMERCIO LTDA","commercialName":"","cnpj":"59135509000194","city":"DIADEMA","stateCode":"SP","buscaAdicional":"INYLBRA 1604 INYLBRA-DIADEMA-SP 70049 INYLBRA JACAREI 72391 INYLBRA GRAVATAI RS 906922 INYLBRA - SJ PINHAIS 907015"},{"id":"39f579bb-1af9-4d84-50f0-08d5ad2bf6ba","name":"WICKBOLD & NOSSO PAO INDUSTRIAS ALIMENTICIAS LTDA","commercialName":"NOSSO PAO","cnpj":"62691043000118","city":"DIADEMA","stateCode":"SP","buscaAdicional":"WICKBOLD MAT 1913 WICKBOLD E NOSSO PAO 71100 WICKBOLD HORTOLANDIA 71251 WICKBOLD MATRIZ 71755 WICKBOLD CONTAGEM 911261"},{"id":"d513254f-74b9-4ad9-4fc6-08d5ad2bf6ba","name":"PRODUFLEX INDUSTRIA DE BORRACHAS LTDA","commercialName":"","cnpj":"44031201000121","city":"DIADEMA","stateCode":"SP","buscaAdicional":"PRODUFLEX 1272 PRODUFLEX BORRACHAS 910064"},{"id":"56c7812d-0bd1-4b44-6238-08d5ad2bf6ba","name":"ZINCAGEM MARTINS LTDA","commercialName":"","cnpj":"51127579000270","city":"DIADEMA","stateCode":"SP","buscaAdicional":"ZINCAGEM MARTINS 54625 ZINCAGEM MARTINS 904900"},{"id":"eb2cb461-244c-42c1-6119-08d5ad2bf6ba","name":"AUTOMETAL S/A","commercialName":"","cnpj":"59104513000276","city":"DIADEMA","stateCode":"SP","buscaAdicional":"AUTOLINER 54013 AUTOLINER 904967"},{"id":"65c098f9-768d-43e0-644f-08d5ad2bf6ba","name":"PORTALPLAST INDUSTRIA E COMERCIO DE LAMINADOS PLASTICOS LTDA.","commercialName":"","cnpj":"05988913000181","city":"DIADEMA","stateCode":"SP","buscaAdicional":"PORTALPLAST 55923 PORTALPLAST 906879"},{"id":"614dac0f-42a3-4813-6846-08d5ad2bf6ba","name":"OLSA BRASIL INDUSTRIA E COMERCIO LTDA.","commercialName":"","cnpj":"03479456000174","city":"DIADEMA","stateCode":"SP","buscaAdicional":"OLSA BRASIL 59660 OLSA BRASIL I 910209 OLSA - UC 0200325700 910521"},{"id":"dd79dad6-615f-41eb-884f-08d5ae44ed50","name":"PROL EDITORA GRAFICA LTDA","commercialName":"","cnpj":"52007010000152","city":"DIADEMA","stateCode":"SP","buscaAdicional":"PROL EDITORA 3195 PROL EDITORA-PAPAIZ 70959 PROL EDITORA-PRESTES 70960"},{"id":"fd657900-bbc7-4041-8853-08d5ae44ed50","name":"F.JOHNSON FERRAMENTARIA E INJECAO DE PLASTICOS LTDA","commercialName":"F.JOHNSON","cnpj":"07477753000131","city":"DIADEMA","stateCode":"SP","buscaAdicional":"F JOHNSON 3534 F JOHNSON DIADEMA 71098"},{"id":"563521cc-038e-4f6d-68ec-08d5ad2bf6ba","name":"PRENSAS SCHULER S A","commercialName":"","cnpj":"61068342000138","city":"DIADEMA","stateCode":"SP","buscaAdicional":"PRENSAS SCHULER 60572 PRENSAS SCHULER 911779"},{"id":"e657291f-4a29-4011-6662-08d5ad2bf6ba","name":"REVPACK TECNOLOGIA E COMERCIO DE COMPONENTES PLASTICOS LTDA","commercialName":"","cnpj":"03524760000196","city":"DIADEMA","stateCode":"SP","buscaAdicional":"REVPACK 57516 REVPACK TECNOLOGIA 908572"},{"id":"e1f12204-37cd-42ef-670f-08d5ad2bf6ba","name":"FASTPLAS AUTOMOTIVE LTDA.","commercialName":"","cnpj":"03760713000141","city":"DIADEMA","stateCode":"SP","buscaAdicional":"FASTPLAS 57941 FASTPLAS FAB DIADEMA 909402 FASTPLAS DIADEMA 909422"},{"id":"d2038af9-bb88-473c-5fac-08d5ad2bf6ba","name":"SEBO JALES INDUSTRIA E COMERCIO DE PRODUTOS ANIMAIS LTD","commercialName":"SEBO JALES","cnpj":"60995891000195","city":"DIRCE REIS","stateCode":"SP","buscaAdicional":"SEBO JALES 53080 SEBO JALES 902691"},{"id":"a88eb494-1954-46ad-64f6-08d5ad2bf6ba","name":"TECPOLPA INDUSTRIA E COMERCIO DE SUCOS LTDA","commercialName":"","cnpj":"14848969000121","city":"DOBRADA","stateCode":"SP","buscaAdicional":"TECPOLPA 56330 TECPOLPA 907994"},{"id":"f6c83923-f99e-4c28-634f-08d5ad2bf6ba","name":"MILENIO COMPONENTES PLASTICOS EIRELI","commercialName":"","cnpj":"10364979000130","city":"DOIS CÓRREGOS","stateCode":"SP","buscaAdicional":"MILENIO PLASTICOS 55303 MILENIO PLASTICOS 910420"},{"id":"6eabf9d9-d66e-4b3f-5770-08d5ad2bf6ba","name":"P B ZANZINI & CIA LTDA","commercialName":"INDUSTRIA E COMERCIO DE MOVEIS ZANZINI","cnpj":"54113683000112","city":"DOIS CÓRREGOS","stateCode":"SP","buscaAdicional":"ZANZINI 8819 ZANZINI 888613"},{"id":"916fb670-9fc9-412d-5874-08d5ad2bf6ba","name":"GRANDFOOD INDUSTRIA E COMERCIO LTDA","commercialName":"","cnpj":"46325254000180","city":"DOURADO","stateCode":"SP","buscaAdicional":"GRANDFOOD 11850 GRANDFOOD 890213"},{"id":"c78a04e2-fc64-4b89-5c80-08d5ad2bf6ba","name":"GOTA DOCE AGROINDUSTRIAL LTDA","commercialName":"GOTA DOCE","cnpj":"14410012000107","city":"DUARTINA","stateCode":"SP","buscaAdicional":"GOTA DOCE 51357 GOTA DOCE 901815"},{"id":"02c1d7c2-cef6-4dff-605a-08d5ad2bf6ba","name":"TERRANUTS AGROINDUSTRIAL S.A.","commercialName":"TERRANUTS","cnpj":"21238227000140","city":"DUMONT","stateCode":"SP","buscaAdicional":"TERRANUTS 53476 TERRANUTS 905125"},{"id":"68054fe2-1895-4eb3-50b5-08d5ad2bf6ba","name":"IGARATIBA INDUSTRIA E COMERCIO LTDA","commercialName":"","cnpj":"47855507000786","city":"ELIAS FAUSTO","stateCode":"SP","buscaAdicional":"IGARATIBA 1792 IGARATIBA IC 138KV 70186"},{"id":"f2443b73-40d0-4f84-649a-08d5ad2bf6ba","name":"CERAMICA PALMA DE OURO LTDA","commercialName":"","cnpj":"66138785000171","city":"ELIAS FAUSTO","stateCode":"SP","buscaAdicional":"CERAMICA PDO 56131 CERAMICA PALMA OURO 906418"},{"id":"8db263b0-8e87-4e06-626f-08d5ad2bf6ba","name":"PLATEX PROCESSOS PLASTICOS LTDA","commercialName":"","cnpj":"05259711000107","city":"EMBU-GUAÇU","stateCode":"SP","buscaAdicional":"PLATEX 54759 PLATEX PROC PLASTICO 906254"},{"id":"dc47371c-5696-45ea-6968-08d5ad2bf6ba","name":"UNIAO QUIMICA FARMACEUTICA NACIONAL S A","commercialName":"GENOM","cnpj":"60665981000118","city":"EMBU-GUAÇU","stateCode":"SP","buscaAdicional":"UNIAO QUIMICA MATRIZ 61174 UNIAO QUIMICA EMBU 911780 UNIAO QUIMICA BRASIL 911979"},{"id":"afdc4f53-0669-4221-6828-08d5ad2bf6ba","name":"INSTITUTO ADVENTISTA DE ENSINO","commercialName":"UNASP - UNIDADE DE ENSINO DE ENGENHEIRO COELHO","cnpj":"43586056001405","city":"ENGENHEIRO COELHO","stateCode":"SP","buscaAdicional":"UNASP 59443 UNASP INS ADVENTISTA 909730"},{"id":"5ebf174d-57c3-419b-6567-08d5ad2bf6ba","name":"TRELICAMP INDUSTRIA E COMERCIO LTDA","commercialName":"TRELICAMP","cnpj":"05430618000105","city":"ENGENHEIRO COELHO","stateCode":"SP","buscaAdicional":"TRELICAMP 56717 TRELICAMP 906692"},{"id":"73ce2de7-47a8-4cc9-5559-08d5ad2bf6ba","name":"DELPHI AUTOMOTIVE SYSTEMS DO BRASIL LTDA","commercialName":"DELPHI AUTOMOTIVE SYSTEMS DO BRASIL LTDA","cnpj":"00857758001031","city":"ESPÍRITO SANTO DO PINHAL","stateCode":"SP","buscaAdicional":"DELPHI PINHAL 5391 DELPHI-PINHAL 71801"},{"id":"9fb61c3f-a53c-4481-8d88-08d5d060706e","name":"LEGUS AGROINDUSTRIAL LTDA","commercialName":"LEGUS SOLUCOES EM ALIMENTOS","cnpj":"00988729000118","city":"FERNANDO PRESTES","stateCode":"SP","buscaAdicional":"LEGUS 60857 LEGUS - FERNANDO PRE 913551"},{"id":"14a91eff-8ed2-4e5e-8db2-08d5d060706e","name":"NEWFIX INDUSTRIA E COMERCIO LTDA .","commercialName":"NEWFIX","cnpj":"04024914000143","city":"FERRAZ DE VASCONCELOS","stateCode":"SP","buscaAdicional":"NEWFIX 62772 NEWFIX F VAS 913507"},{"id":"d4f96fd7-b621-46cd-63b7-08d5ad2bf6ba","name":"DINI TEXTIL INDUSTRIA E COMERCIO LTDA.","commercialName":"","cnpj":"65538209000159","city":"FERRAZ DE VASCONCELOS","stateCode":"SP","buscaAdicional":"DINI TEXTIL 55586 DINI TEXTIL 904837"},{"id":"b1b7b220-2a85-48a2-6420-08d5ad2bf6ba","name":"METALLICA INDUSTRIAL S/A","commercialName":"","cnpj":"03282398000194","city":"FERRAZ DE VASCONCELOS","stateCode":"SP","buscaAdicional":"METALLICA 55849 METALLICA FERRAZ 903844"},{"id":"a606ba29-7d07-4a7d-6315-08d5ad2bf6ba","name":"SHIBATA COMERCIO E ATACADO DE PRODUTOS EM GERAL LTDA","commercialName":"","cnpj":"20276483000169","city":"FERRAZ DE VASCONCELOS","stateCode":"SP","buscaAdicional":"SHIBATA FERRAZ 55130 SHIBATA FERRAZ 904808"},{"id":"e4928a3d-4507-4416-6975-08d5ad2bf6ba","name":"PLASTICOS DO CARMO EIRELI","commercialName":"","cnpj":"07788451000184","city":"FERRAZ DE VASCONCELOS","stateCode":"SP","buscaAdicional":"PLASTICOS DO CARMO 61730 PLASTICOS DO CARMO 912477"},{"id":"5f73e524-f47c-4f68-55e0-08d5ad2bf6ba","name":"BRINQUEDOS BANDEIRANTE SA","commercialName":"","cnpj":"61068557000582","city":"FERRAZ DE VASCONCELOS","stateCode":"SP","buscaAdicional":"BRINQBAND 6271 BRINQ BAND F VASCONC 72111"},{"id":"7950421f-3c08-4110-5ce9-08d5ad2bf6ba","name":"CORDEIRO CABOS ELETRICOS S.A.","commercialName":"CORDEIRO","cnpj":"14197209000100","city":"FERRAZ DE VASCONCELOS","stateCode":"SP","buscaAdicional":"CORDEIRO CABOS 51609 CORDEIRO MATRIZ 898572 CORDEIRO UNID 2 898573"},{"id":"ae33b55a-77c7-4fef-5b19-08d5ad2bf6ba","name":"EVASOLA INDUSTRIA DE BORRACHAS LTDA","commercialName":"","cnpj":"05866984000101","city":"FRANCA","stateCode":"SP","buscaAdicional":"EVASOLA 50462 EVASOLA BORRACHAS SP 900033 EVASOLA UN 2 906401"},{"id":"cf1bd98f-1232-4830-54b6-08d5ad2bf6ba","name":"AMAZONAS INDUSTRIA E COMERCIO LTDA","commercialName":"AMAZONAS","cnpj":"47959697000196","city":"FRANCA","stateCode":"SP","buscaAdicional":"AMAZONAS 4452 AMAZONAS QUIMICA-FCA 71582 AMAZONAS MATRIZ-FRCA 71583 AMAZONAS BA 888398 AMAZONAS INDUSTRIA 904679"},{"id":"42c15bf5-b0c3-48a8-51fd-08d5ad2bf6ba","name":"MAGAZINE LUIZA S/A","commercialName":"MAGAZINE LUIZA","cnpj":"47960950000121","city":"FRANCA","stateCode":"SP","buscaAdicional":"MAGAZINE LUIZA 2772 MAG LUIZA V GUILHERM 905506 MAGAZINE LUIZA 400 907377 MAGAZINE LUIZA 835 907657 MAGAZINE LUIZA - 975 907682 MAGAZINE LUIZA - 298 907683 MG LUIZA STA BARBARA 907703 MG LUIZA SERTAOZINHO 907704 MG LUIZA FRANCA 500 907707 MG LUIZA BAURU 907709 MG LUIZA RIB PRETO 907711 MG LUIZA RIB PTO 116 907712 MG LUIZA RIB PTO 003 907715 MG LUIZA RIB PTO 005 907716 MG LUIZA CAMPINAS 32 907717 MG LUIZA ARACATUBA 907731 MG LUIZA BARRETOS 907732 MG LUIZA FRANCA 1 907733 MG LUIZA SJ RIO PRET 907734 MG LUIZA FRANCA 48 907735 MAGAZINE LUIZA 708 907759 MAGAZINE LUIZA LAPA 907845 MG LUIZA LIMEIRA 977 907895 MG LUIZA 995 SIMOES 907903 MGLUIZA-235-SOROCABA 908048 MG LUIZA FCO MORATO 908147 MG LUIZA JALES - 157 908162 MGLUIZA-301-CHAPECO 908175 MGLUIZA-468-BLUMENAU 908176 MAGAZINE LUIZA - 007 908559 MAG LUIZA 28 LIMEIRA 908699 MAGAZINE LUIZA - 211 908716 MAGAZINE LUIZA 14 908832 MAGAZINE LUIZA 238 909251 MAGAZINE LUIZA CNTGM 909454 MAGAZINE LUIZA 110 909613 MAGAZINE LUIZA 484 909755 MAGAZINE LUIZA 425 910493 MAGAZINE LUIZA 416 910494 MAGAZINE LUIZA 94 910495 MAGAZINE LUIZA 85 910496 MAGAZINE LUIZA 68 910835"},{"id":"269f6635-c6bb-45e7-682a-08d5ad2bf6ba","name":"CURTUME CUBATAO LTDA","commercialName":"","cnpj":"47988423000125","city":"FRANCA","stateCode":"SP","buscaAdicional":"CURTUME CUBATAO 59451 CURTUME CUBATAO 2 909861 CURTUME CUBATAO 1 909981"},{"id":"34a86e8b-02b3-4e71-67e7-08d5ad2bf6ba","name":"CURTUME DELLA TORRE LTDA","commercialName":"","cnpj":"47953765000100","city":"FRANCA","stateCode":"SP","buscaAdicional":"CURTUME DELLA TORRE 58875 CURTUME DELLA TORRE 909859"},{"id":"13886c56-ce98-4c0b-62ca-08d5ad2bf6ba","name":"COUROQUIMICA COUROS E ACABAMENTOS LTDA","commercialName":"COUROQUIMICA","cnpj":"50719061000181","city":"FRANCA","stateCode":"SP","buscaAdicional":"COUROQUIMICA 54972 COUROQUIMICA FRANCA 906390"},{"id":"5d047f6b-69e2-4868-6057-08d5ad2bf6ba","name":"COFRATEC INDUSTRIA TEXTIL LTDA.","commercialName":"COFRATEC ADMINISTRACAO E PARTICIPACOES LTDA.","cnpj":"19541444000162","city":"FRANCO DA ROCHA","stateCode":"SP","buscaAdicional":"COFRATEC 53471 COFRATEC 905088"},{"id":"24546624-0326-4737-5f65-08d5ad2bf6ba","name":"ORLANDO ZANCOPE & CIA. LTDA.","commercialName":"PASTIFICIO PAULISTA","cnpj":"48205157000180","city":"GARÇA","stateCode":"SP","buscaAdicional":"MASSAS PAULISTA 52927 ORLANDO ZANCOPE 905112"},{"id":"f6e0a8bb-2bcd-440f-5e3e-08d5ad2bf6ba","name":"GAREN AUTOMACAO S/A","commercialName":"GAREN AUTOMACAO","cnpj":"13246724000161","city":"GARÇA","stateCode":"SP","buscaAdicional":"GAREN 52294 GAREN AUTOMACAO 901999"},{"id":"6559a2bb-c95f-43f5-67ba-08d5ad2bf6ba","name":"MOTOPPAR INDUSTRIA E COMERCIO DE AUTOMATIZADORES LTDA","commercialName":"MOTOPPAR","cnpj":"52605821000155","city":"GARÇA","stateCode":"SP","buscaAdicional":"MOTOPPAR 58552 MOTOPPAR SP 909989"},{"id":"319e9b3b-c97d-4e06-641a-08d5ad2bf6ba","name":"MINA MERCANTIL INDUSTRIALE AGRICOLA LIMITADA","commercialName":"","cnpj":"48340384000118","city":"GUAÍRA","stateCode":"SP","buscaAdicional":"MINA MERCANTIL 55843 MINA MERCANTIL GUAIR 906673"},{"id":"4e0e4d10-a1c2-4d1e-5862-08d5ad2bf6ba","name":"SO FRUTA ALIMENTOS LTDA","commercialName":"","cnpj":"11085742000183","city":"GUAÍRA","stateCode":"SP","buscaAdicional":"TOMILHO 11609 TOMILHO 890218"},{"id":"dca1e4c8-af7c-4a6d-5204-08d5ad2bf6ba","name":"CENTRAL ENERGETICA GUAIRA LTDA","commercialName":"CENTRAL ENERGETICA GUAIRA LTDA","cnpj":"09270654000100","city":"GUAÍRA","stateCode":"SP","buscaAdicional":"CEG 2794 CEG CARGA 889681 GUAIRA ENERGETICA 8669 UTE.AI.SP.030026-8.01"},{"id":"b035a8cb-ee88-47b7-50d7-08d5ad2bf6ba","name":"ACUCAR E ALCOOL OSWALDO RIBEIRO DE MENDONCA LTDA","commercialName":"","cnpj":"51990778000126","city":"GUAÍRA","stateCode":"SP","buscaAdicional":"UTE COLORADO 1868 USINA COLORADO 900380 COLORADO 8352 UTE.AI.SP.028094-1.01"},{"id":"4ab345de-ac51-4e5a-66d2-08d5ad2bf6ba","name":"MOVEIS PROVINCIA INDUSTRIA E COMERCIO LTDA","commercialName":"","cnpj":"48315477000192","city":"GUAPIAÇU","stateCode":"SP","buscaAdicional":"MOVEIS PROVINCIA 57843 MOVEIS PROVINCIA 909064"},{"id":"db046f1c-69f5-415b-50ed-08d5ad2bf6ba","name":"USINA VERTENTE LTDA.","commercialName":"USINA VERTENTE LTDA.","cnpj":"05242560000176","city":"GUARACI","stateCode":"SP","buscaAdicional":"USVERTENTE 1909 VERTENTE 8200 UTE.AI.SP.029270-2.01"},{"id":"0622ba34-b115-4621-5269-08d5ad2bf6ba","name":"OLEOS MENU INDUSTRIA E COMERCIO LIMITADA","commercialName":"","cnpj":"62045026000294","city":"GUARARAPES","stateCode":"SP","buscaAdicional":"OLEOS MENU 3047 OLEOS GUARARAPES 70932"},{"id":"68c23314-17f7-4c7b-6412-08d5ad2bf6ba","name":"TINTURARIA INDUSTRIAL GUARAREMA LTDA","commercialName":"","cnpj":"50609304000129","city":"GUARAREMA","stateCode":"SP","buscaAdicional":"TINTURARIA GUARAREMA 55830 TINTURARIA GUARAREMA 904840"},{"id":"fd5fa8dd-9f42-43d3-5341-08d5ad2bf6ba","name":"LIEBHERR BRASIL GUINDASTES E MAQUINAS OPERATRIZES LTDA","commercialName":"","cnpj":"44021095000103","city":"GUARATINGUETÁ","stateCode":"SP","buscaAdicional":"LIEBHERR 3538 LIEBHERR GUINDASTES 71085 LIEBHERR AEROSPACE 71086"},{"id":"1b39d512-c4e4-40c5-57e0-08d5ad2bf6ba","name":"AGC VIDROS DO BRASIL LTDA.","commercialName":"AGC BRASIL","cnpj":"13198370000127","city":"GUARATINGUETÁ","stateCode":"SP","buscaAdicional":"AGC BRASIL MATRIZ 9869 AGC BRASIL MATRIZ 891742"},{"id":"632f0322-b795-493b-5a36-08d5ad2bf6ba","name":"CONDOMINIO DE ADMINISTRACAO DO BURITI SHOPPING GUARA","commercialName":"CONDOMINIO DE ADMINISTRACAO DO BURITI SHOPPING GUARA","cnpj":"20423203000106","city":"GUARATINGUETÁ","stateCode":"SP","buscaAdicional":"SHOPPING BURITI 17218 SHOP GUARA 72160"},{"id":"8fcbbe3c-faa8-4ef2-5e6f-08d5ad2bf6ba","name":"TEAG - TERMINAL DE EXPORTACAO DE ACUCAR DO GUARUJA LTDA.","commercialName":"TEAG - GUARUJA","cnpj":"04721589000178","city":"GUARUJÁ","stateCode":"SP","buscaAdicional":"TEAG 52384 TEAG GUARUJA SP 900014"},{"id":"189ecd98-2f7d-43e6-5e70-08d5ad2bf6ba","name":"TEG - TERMINAL EXPORTADOR DO GUARUJA LTDA.","commercialName":"TEG - TERMINAL EXPORTADOR DO GUARUJA LTDA.","cnpj":"09079434000101","city":"GUARUJÁ","stateCode":"SP","buscaAdicional":"TEG 52385 TEG 899998"},{"id":"20858b84-7d3e-4c37-5576-08d5ad2bf6ba","name":"SANTOS BRASIL PARTICIPACOES S.A.","commercialName":"","cnpj":"02762121000953","city":"GUARUJÁ","stateCode":"SP","buscaAdicional":"SANTOS BRASIL 5689 SANTOS BR GUARUJA 70024 SANTOS GUARUJA - EK 898626"},{"id":"e731b523-7107-4ce1-50fb-08d5ad2bf6ba","name":"TERMINAL MARITIMO DO GUARUJA S/A - TERMAG","commercialName":"","cnpj":"05535627000160","city":"GUARUJÁ","stateCode":"SP","buscaAdicional":"TERMAG 1933 TERMAG GUARUJA 71477"},{"id":"4b28f067-1963-49bb-63f5-08d5ad2bf6ba","name":"ASSOCIACAO VILLA JEQUITIMAR","commercialName":"","cnpj":"08961824000130","city":"GUARUJÁ","stateCode":"SP","buscaAdicional":"SHOPPING JEQUITI 55751 SHOPPING JEQUITI 906074"},{"id":"1beb9ba1-e41f-40ea-641e-08d5ad2bf6ba","name":"JOMARCA INDUSTRIAL DE PARAFUSOS LTDA","commercialName":"","cnpj":"43298975000150","city":"GUARULHOS","stateCode":"SP","buscaAdicional":"JOMARCA 55847 JOMARCA GUARULHOS 904821"},{"id":"4ff5155c-4a43-4f9b-642b-08d5ad2bf6ba","name":"ROSIL EMBALAGENS PLÁSTICAS EIRELI","commercialName":"","cnpj":"43871946000136","city":"GUARULHOS","stateCode":"SP","buscaAdicional":"ROSIL 55863 ROSIL 905741"},{"id":"490c10da-25ad-4ac9-63a6-08d5ad2bf6ba","name":"MODINE DO BRASIL SISTEMAS TERMICOS LTDA.","commercialName":"","cnpj":"03310685000241","city":"GUARULHOS","stateCode":"SP","buscaAdicional":"MODINE 55501 MODINE 905760"},{"id":"57f94ff9-e350-45b9-635a-08d5ad2bf6ba","name":"ACOTUBO INDUSTRIA E COMERCIO LTDA","commercialName":"","cnpj":"43919968000129","city":"GUARULHOS","stateCode":"SP","buscaAdicional":"ACOTUBO 55324 ACOTUBO 906686 ARTEX 906687 INCOTEP 906688"},{"id":"59d6d18f-3312-4075-6380-08d5ad2bf6ba","name":"RFR COMERCIO E RECICLAGEM DE RESIDUOS LTDA.","commercialName":"RFR RECICLAGEM","cnpj":"07100026000150","city":"GUARULHOS","stateCode":"SP","buscaAdicional":"RFR 55417 RFR RECICLAGEM 906729"},{"id":"1a8ba355-edb2-4f1b-637b-08d5ad2bf6ba","name":"SILVA E BARBOSA COMERCIO DE ALIMENTOS LTDA","commercialName":"","cnpj":"60437647000107","city":"GUARULHOS","stateCode":"SP","buscaAdicional":"BARBOSA 1 55383 BARBOSA LOJA 04 904797 BARBOSA LOJA 11 904799 BARBOSA LOJA 1 906358 BARBOSA LOJA 03 909866 BARBOSA LOJA 18 910015"},{"id":"e49ff7c2-d534-4b4e-6542-08d5ad2bf6ba","name":"CROMA REVESTIMENTOS TECNICOS LTDA","commercialName":"CROMA REVESTIMENTOS TECNICOS LTDA","cnpj":"07347306000320","city":"GUARULHOS","stateCode":"SP","buscaAdicional":"CROMA 56633 CROMA REVESTIMENTOS 907284"},{"id":"16c567b3-fa66-4168-6545-08d5ad2bf6ba","name":"A CARNEVALLI CIA LTDA","commercialName":"","cnpj":"61372058000150","city":"GUARULHOS","stateCode":"SP","buscaAdicional":"CARNEVALLI 56636 CARNEVALLI GUARULHOS 905983"},{"id":"9f08f549-4f25-4a42-6476-08d5ad2bf6ba","name":"FITA FORT COMERCIO E INDUSTRIA DE EMBALAGENS EIRELI","commercialName":"","cnpj":"66748609000151","city":"GUARULHOS","stateCode":"SP","buscaAdicional":"FITA FORT 56012 FITA FORT EMBALAGENS 907282"},{"id":"bcffd80a-0112-4935-6479-08d5ad2bf6ba","name":"ANIN INDUSTRIA E COMERCIO DE PAPEL LTDA","commercialName":"","cnpj":"39285002000100","city":"GUARULHOS","stateCode":"SP","buscaAdicional":"ANIN 56020 S MIGUEL-GUARULHOS 72275"},{"id":"7e7b8d0b-2fe2-4066-64d5-08d5ad2bf6ba","name":"VIBRACOUSTIC SOUTH AMERICA LTDA","commercialName":"VIBRACOUSTIC","cnpj":"03249921000180","city":"GUARULHOS","stateCode":"SP","buscaAdicional":"VIBRACOUSTIC 56261 VIBRACOUSTIC 905988 VIBRACOUSTIC TAUBATE 910873"},{"id":"c4171626-fc7b-42db-64d7-08d5ad2bf6ba","name":"BRISTOL PARTS INDUSTRIA E COMERCIO LTDA","commercialName":"BRISTOL PARTS","cnpj":"04247586000144","city":"GUARULHOS","stateCode":"SP","buscaAdicional":"BRISTOL 56278 BRISTOL 906689 BRISTOL PANAMBI 906697"},{"id":"868470c7-b3e6-4bb1-62eb-08d5ad2bf6ba","name":"ZINNI E GUELL LTDA","commercialName":"","cnpj":"61603288000183","city":"GUARULHOS","stateCode":"SP","buscaAdicional":"ZINNI E GUELL 55032 ZINNI E GUELL 906727"},{"id":"d982541f-093b-4880-630e-08d5ad2bf6ba","name":"ATACADO E AUTO SERVICO ESPERANCA LTDA.","commercialName":"","cnpj":"05264937000198","city":"GUARULHOS","stateCode":"SP","buscaAdicional":"ATACADO ESPERANCA 55121 ATACADO GUARULHOS 904841 ATACADO ESPERANCA SJ 904842 ATACADO SUZANO 904843 ATACADO SOROCABA 905084 ATACADO AMERICANA 905115 ATACADO GUAPIRA 906592 ATACADO MATEO BEI 906593 ATACADO IPANEMA 907626"},{"id":"759f3d5e-ff45-4256-6310-08d5ad2bf6ba","name":"ROSSETTI EQUIPAMENTOS RODOVIARIOS LTDA","commercialName":"","cnpj":"59884502000175","city":"GUARULHOS","stateCode":"SP","buscaAdicional":"ROSSETTI EQUIPAMENTOS 55125 ROSSETTI - GUARULHOS 904906"},{"id":"7e593af0-fdfb-4b32-632d-08d5ad2bf6ba","name":"PLAST LUCAS INDUSTRIA E COMERCIO LTDA","commercialName":"","cnpj":"65667651000185","city":"GUARULHOS","stateCode":"SP","buscaAdicional":"PLASTLUCAS 55235 PLAST LUCAS 904107"},{"id":"56022c2d-241c-43df-625d-08d5ad2bf6ba","name":"ANGLO INDUSTRIA E COMERCIO DE METAIS LTDA.","commercialName":"","cnpj":"66678459000157","city":"GUARULHOS","stateCode":"SP","buscaAdicional":"ANGLO METAIS 54714 ANGLO METAIS GUA 904309"},{"id":"68b041de-1479-4560-623b-08d5ad2bf6ba","name":"JOALMI INDUSTRIA E COMERCIO LIMITADA","commercialName":"","cnpj":"60980240000121","city":"GUARULHOS","stateCode":"SP","buscaAdicional":"JOALMI 54630 JOALMI GUARULHOS 904506"},{"id":"ff0c4470-17ce-4e37-624d-08d5ad2bf6ba","name":"SUPERMERCADOS IRMAOS LOPES S/A","commercialName":"","cnpj":"45827425000107","city":"GUARULHOS","stateCode":"SP","buscaAdicional":"LOPES SUPERMERCADOS 54677 LOPES - LOJA 4 906572 LOPES - LOJA 15 906587 LOPES - LOJA 17 906588 LOPES - LOJA 22 906589 LOPES - LOJA 6 906590 LOPES - LOJA 26 906591 LOPES LJ 5 906698 LOPES LJ 1 906699 LOPES LJ 8 906700 LOPES LJ 27 908288 LOPES LOJA 03 912671 LOPES LOJA 13 912672 LOPES LOJA 11 912673 LOPES LOJA 12 912674 LOPES LOJA 14 912675 LOPES LOJA 07 912691 LOPES LOJA 10 912711 LOPES LOJA 20 912712 LOPES LOJA 16 912731 LOPES LOJA 09 913508 LOPES LOJA 19 913509 LOPES LOJA 21 913510 LOPES LOJA 18 913525 LOPES LOJA 24 913526 LOPES LOJA 25 913527 LOPES LOJA 23 913529"},{"id":"306d8c05-6a86-4de6-6293-08d5ad2bf6ba","name":"ALLERGAN PRODUTOS FARMACEUTICOS LTDA.","commercialName":"","cnpj":"43426626000924","city":"GUARULHOS","stateCode":"SP","buscaAdicional":"ALLERGAN 54807 ALLERGAN 905752"},{"id":"0b40d20d-dc1b-4c57-6296-08d5ad2bf6ba","name":"VASITEX VASILHAMES LTDA","commercialName":"","cnpj":"65629040000142","city":"GUARULHOS","stateCode":"SP","buscaAdicional":"VASITEX VASILHAMES 54810 VASITEX GUARULHOS 904115"},{"id":"8c27ba94-5298-4feb-619c-08d5ad2bf6ba","name":"CINDUMEL INDUSTRIAL DE METAIS E LAMINADOS LTDA","commercialName":"","cnpj":"49814056000179","city":"GUARULHOS","stateCode":"SP","buscaAdicional":"CINDUMEL 54290 CINDUMEL ADM 902320 CINDUMEL 1 902323"},{"id":"a560960e-fe0d-4542-61de-08d5ad2bf6ba","name":"MAGGION INDUSTRIAS DE PNEUS E MAQUINAS LTDA","commercialName":"","cnpj":"61077079000143","city":"GUARULHOS","stateCode":"SP","buscaAdicional":"MAGGION 54452 MAGGION 904976"},{"id":"7dfd3fe0-8a06-43e4-61f5-08d5ad2bf6ba","name":"BM STRAP INDUSTRIA E COMERCIO DE PLASTICOS LTDA","commercialName":"","cnpj":"18821545000124","city":"GUARULHOS","stateCode":"SP","buscaAdicional":"BM STRAP 54486 BM STRAP INDUSTRIA 902522"},{"id":"7c698b72-1644-4a08-6725-08d5ad2bf6ba","name":"SHOPPING PATEO GUARULHOS S.A.","commercialName":"SHOPPING PATEO GUARULHOS","cnpj":"15448906000140","city":"GUARULHOS","stateCode":"SP","buscaAdicional":"PATEO GUARULHOS 57979 SHOP PATEO GUARULHOS 911271"},{"id":"8b756122-0754-47e5-6741-08d5ad2bf6ba","name":"DYNA INDUSTRIA E COMERCIO LTDA.","commercialName":"","cnpj":"61354148000119","city":"GUARULHOS","stateCode":"SP","buscaAdicional":"DYNA 58017 DYNA 909864"},{"id":"b9d20ce7-d904-4f9d-6632-08d5ad2bf6ba","name":"FRASQUIM INDUSTRIA E COMERCIO LTDA","commercialName":"","cnpj":"57227134000167","city":"GUARULHOS","stateCode":"SP","buscaAdicional":"FRASQUIM 57387 FRASQUIM 907785"},{"id":"3fd912a7-3cab-4ab0-65e4-08d5ad2bf6ba","name":"CAE SOUTH AMERICA FLIGHT TRAINING DO BRASIL LTDA","commercialName":"","cnpj":"03538995000137","city":"GUARULHOS","stateCode":"SP","buscaAdicional":"CAE 57187 CAE - SAO PAULO - SP 908217 CAE GUARULHOS 908432"},{"id":"df5d10b0-665c-4570-65e2-08d5ad2bf6ba","name":"TEXTIL TECNICOR LTDA","commercialName":"","cnpj":"56548472000138","city":"GUARULHOS","stateCode":"SP","buscaAdicional":"TEXTIL TECNICOR 57185 TEXTIL TECNICOR 906730"},{"id":"0ec601e9-9a09-4f58-65c9-08d5ad2bf6ba","name":"LABORATORIOS STIEFEL LTDA","commercialName":"","cnpj":"63064653000154","city":"GUARULHOS","stateCode":"SP","buscaAdicional":"GSK GRU 57131 GSK GRU 908183"},{"id":"3f6e7c4a-0bf8-49ce-65b6-08d5ad2bf6ba","name":"ELLECE LOGISTICA LTDA","commercialName":"ELLECE LOGISTICA LTDA","cnpj":"13930232000190","city":"GUARULHOS","stateCode":"SP","buscaAdicional":"ELLECE 56992 ELLECE 905993"},{"id":"7d681320-2e61-44f1-65ad-08d5ad2bf6ba","name":"KITCHENS INDUSTRIA E COMERCIO LTDA","commercialName":"KITCHENS","cnpj":"60848991000199","city":"GUARULHOS","stateCode":"SP","buscaAdicional":"KITCHENS 56927 KITCHENS GUARULHOS 908184"},{"id":"9b0cda9c-7a65-4371-659d-08d5ad2bf6ba","name":"INDUSTRIA DE FELTROS SANTA FE S A","commercialName":"","cnpj":"60730512000135","city":"GUARULHOS","stateCode":"SP","buscaAdicional":"FELTROS SANTA FE 56862 FELTRO SANTA FE GRU 906685 FELTRO SANTA FE 906696"},{"id":"86ad2fb5-8df4-484d-67f5-08d5ad2bf6ba","name":"FARMARIN INDUSTRIA E COMERCIO LTDA","commercialName":"","cnpj":"58635830000175","city":"GUARULHOS","stateCode":"SP","buscaAdicional":"FARMARIN 59083 FARMARIN IND E COM 909425"},{"id":"31d15219-6e40-4d44-6843-08d5ad2bf6ba","name":"MMS SP INDUSTRIA E COMERCIO DE PLASTICOS EIRELI","commercialName":"","cnpj":"06149977000402","city":"GUARULHOS","stateCode":"SP","buscaAdicional":"MMS PLASTICOS 59633 MMS PLASTICOS 909649"},{"id":"3670bab9-ca3d-4aa1-682e-08d5ad2bf6ba","name":"DAICAST INDUSTRIA E COMERCIO LTDA","commercialName":"","cnpj":"60480746000171","city":"GUARULHOS","stateCode":"SP","buscaAdicional":"DAICAST 59456 DAICAST 909905"},{"id":"626d2114-7be3-4a80-68ab-08d5ad2bf6ba","name":"INAPEL EMBALAGENS LTDA","commercialName":"","cnpj":"43063858000108","city":"GUARULHOS","stateCode":"SP","buscaAdicional":"INAPEL 60264 INAPEL JUNDIAI 910033"},{"id":"3296e34f-9e5d-42f3-68a6-08d5ad2bf6ba","name":"CAMELON MAMUT TINTURARIA E MALHARIA LTDA","commercialName":"","cnpj":"01200788000142","city":"GUARULHOS","stateCode":"SP","buscaAdicional":"CAMELON MAMUT 60239 CAMELON MAMUT 910699"},{"id":"6d6be3b6-bdb1-4fe9-68d0-08d5ad2bf6ba","name":"NTN DO BRASIL PRODUCAO DE SEMI-EIXOS LTDA.","commercialName":"NTN DRIVESHAFT DO BRASIL","cnpj":"12010714000160","city":"GUARULHOS","stateCode":"SP","buscaAdicional":"NTN DO BRASIL 60435 NTN DO BRASIL 910866"},{"id":"d50f2dc9-d528-416b-6885-08d5ad2bf6ba","name":"ADECOL INDUSTRIA QUIMICA LTDA","commercialName":"","cnpj":"50851955000120","city":"GUARULHOS","stateCode":"SP","buscaAdicional":"ADECOL 60115 ADECOL GUARULHOS 909902"},{"id":"162e15cd-6320-4496-8875-08d5ae44ed50","name":"METALURGICA DE TUBOS DE PRECISAO LTDA. EM RECUPERACAO JUDICIAL","commercialName":"","cnpj":"02269509000160","city":"GUARULHOS","stateCode":"SP","buscaAdicional":"MTP 6958 MTP PECAS GUARULHOS 72351"},{"id":"84508b6d-ee61-40ee-68f9-08d5ad2bf6ba","name":"NEUPLAST INDUSTRIA E COMERCIO DE PLASTICOS LTDA","commercialName":"","cnpj":"54304431000170","city":"GUARULHOS","stateCode":"SP","buscaAdicional":"NEUPLAST 60656 NEUPLAST GARULHOS 910506"},{"id":"0b0bee98-be25-4d59-6906-08d5ad2bf6ba","name":"INOVAT INDUSTRIA FARMACEUTICA LTDA.","commercialName":"","cnpj":"27864378000190","city":"GUARULHOS","stateCode":"SP","buscaAdicional":"INOVAT FARMA 60722 INOVAT GRU 907285"},{"id":"e428c454-8bdf-43d5-6963-08d5ad2bf6ba","name":"CONDOMINIO CIVIL VOLUNTARIO DO ''SHOPPING BONSUCESSO''","commercialName":"","cnpj":"17082930000134","city":"GUARULHOS","stateCode":"SP","buscaAdicional":"SHOPPING BONSUCESSO 61121 CONDOMINIO CIVIL V S 912021"},{"id":"417c0e2f-e900-4368-73a7-08d5cf600bef","name":"BARDELLA SA INDUSTRIAS MECANICAS","commercialName":"","cnpj":"60851615000153","city":"GUARULHOS","stateCode":"SP","buscaAdicional":""},{"id":"3425693e-70bf-4261-1ca4-08d5b8870181","name":"DANTRY COMERCIALIZADORA DE ENERGIA LTDA","commercialName":"DANTRY ENERGIA","cnpj":"27932761000138","city":"GUARULHOS","stateCode":"SP","buscaAdicional":"DANTRY 60309"},{"id":"4a5434f0-4401-44c8-88f7-08d5ae44ed50","name":"ZOETIS INDUSTRIA DE PRODUTOS VETERINARIOS LTDA","commercialName":"ZOETIS","cnpj":"43588045002185","city":"GUARULHOS","stateCode":"SP","buscaAdicional":"ZOETIS GUA 57238"},{"id":"744e76f0-cad6-48e1-50f6-08d5ad2bf6ba","name":"KARINA INDUSTRIA E COMERCIO DE PLASTICOS LTDA","commercialName":"KARINA","cnpj":"51254159000173","city":"GUARULHOS","stateCode":"SP","buscaAdicional":"KARINA 1922 KARINA MTZ 70319"},{"id":"e05ffe92-a1a0-480c-505c-08d5ad2bf6ba","name":"CONDOMINIO CIVIL DO INTERNACIONAL GUARULHOS SHOPPING CENTER","commercialName":"","cnpj":"01677206000113","city":"GUARULHOS","stateCode":"SP","buscaAdicional":"INTERSHOPGUA 1587 SHOPPI GRU 7596"},{"id":"1eaeb2a0-4664-4bdc-5033-08d5ad2bf6ba","name":"PHIBRO SAUDE ANIMAL INTERNACIONAL LTDA.","commercialName":"","cnpj":"04076904000151","city":"GUARULHOS","stateCode":"SP","buscaAdicional":"PHIBRO 1511 PHIBRO GRU 70006"},{"id":"ae4f26b0-853b-44e0-4fb7-08d5ad2bf6ba","name":"VISTEON SISTEMAS AUTOMOTIVOS LTDA.","commercialName":"","cnpj":"03509521000167","city":"GUARULHOS","stateCode":"SP","buscaAdicional":"VISTEON 1247 VISTEON GU 7075"},{"id":"1aab485c-59de-4f13-4f49-08d5ad2bf6ba","name":"CUMMINS BRASIL LIMITADA","commercialName":"","cnpj":"43201151000110","city":"GUARULHOS","stateCode":"SP","buscaAdicional":"CUMMINS 198 CUMMINS GUARULHOS 899945"},{"id":"3efd6b93-bfd1-452a-529b-08d5ad2bf6ba","name":"ROMAPACK IMPORTACAO, EXPORTACAO E INDUSTRIA DE EMBALAGENS LTDA.","commercialName":"","cnpj":"04798581000100","city":"GUARULHOS","stateCode":"SP","buscaAdicional":"ROMAPACK 3175 ROMAPACK 70988"},{"id":"f3d94cdc-78ce-4183-5591-08d5ad2bf6ba","name":"PLASTICOS DESCARTAVEIS INDUSTRIA E COMERCIO LTDA.","commercialName":"","cnpj":"43510163000127","city":"GUARULHOS","stateCode":"SP","buscaAdicional":"PLAST DESCAR 5802 PLASTICOS DESCART 888329"},{"id":"d351ce03-5278-411f-54bf-08d5ad2bf6ba","name":"LEPE INDUSTRIA E COMERCIO LTDA","commercialName":"","cnpj":"60678471000185","city":"GUARULHOS","stateCode":"SP","buscaAdicional":"LEPE 4474 LEPE 71588"},{"id":"72ee3bf7-6bd3-474b-54cf-08d5ad2bf6ba","name":"SCALINA LTDA","commercialName":"","cnpj":"61149886000124","city":"GUARULHOS","stateCode":"SP","buscaAdicional":"SCALINA 4510 SCALINA F1-GUARULHOS 71645"},{"id":"8f739fc2-a332-40fe-54e3-08d5ad2bf6ba","name":"LINCOLN ELECTRIC DO BRASIL INDUSTRIA E COMERCIO LTDA","commercialName":"LINCOLN","cnpj":"53910899000146","city":"GUARULHOS","stateCode":"SP","buscaAdicional":"LINCOLN 4569 LINCOLN-GUARULHOS 71644"},{"id":"e5db31f2-30ef-4925-546c-08d5ad2bf6ba","name":"PANDURATA ALIMENTOS LTDA","commercialName":"","cnpj":"70940994000101","city":"GUARULHOS","stateCode":"SP","buscaAdicional":"PANDITAPEGIC 4241 PANDURATA-EXTREMA MG 71731 PANDITAPEG BAUDUCCO 888862 BAUDUCCO ARGENTINA 889805 BAUDUCCO ENDRES 889807"},{"id":"a873bde7-e48a-4067-57ec-08d5ad2bf6ba","name":"UMICORE BRASIL LTDA.","commercialName":"UMICORE","cnpj":"96206313000170","city":"GUARULHOS","stateCode":"SP","buscaAdicional":"UMICORE BRASIL 10089 UMICORE BARAO RIO BR 889457 UMICORE LOUR RICCO 889458"},{"id":"21203e79-995d-42db-5798-08d5ad2bf6ba","name":"SOFAPE FABRICANTE DE FILTROS LTDA.","commercialName":"","cnpj":"04155026000160","city":"GUARULHOS","stateCode":"SP","buscaAdicional":"TECFIL 9114 TECFIL GUARULHOS 889036 TECFIL FABRICA II 898470"},{"id":"6e7b42e5-6a6e-466a-55f8-08d5ad2bf6ba","name":"EDITORA FTD S A","commercialName":"","cnpj":"61186490001633","city":"GUARULHOS","stateCode":"SP","buscaAdicional":"EDITORA FTD 6410 EDIT FTD - GUARULHOS 72140"},{"id":"6c93f33d-dc72-4e32-56cc-08d5ad2bf6ba","name":"TENDA ATACADO LTDA","commercialName":"TENDA ATACADO","cnpj":"01157555000104","city":"GUARULHOS","stateCode":"SP","buscaAdicional":"TENDA 7722 TENDA - SAO CARLOS 72433 TENDA - DIADEMA 72434 TENDA GUARAPIRANGA 888688 TENDA R. KENNEDY 888690 TENDA MOGI GUACU 888896 TENDA BAURU 889010 TENDA STA BARBARA 889236 TENDA CARAPICUIBA 889459 TENDA ITU 889803 TENDA INDAIATUBA 889841 TENDA AMOREIRAS 890178 TENDA CEASA CAMPINAS 890393 TENDA ITANHAEM 890478 TENDA SUMARE 892250 TENDA PINDAMONHANGAB 906346 TENDA HORTOLANDIA 906926 TENDA PIRACICABA 907060 TENDA BOTUCATU 909468 TENDA RIBEIRAO PRETO 909589 TENDA SALTO 910418 TENDA TAUBATE 888864 TENDA GUARATINGUETA 888865 TENDA BONSUCESSO 889683 TENDA JACAREI 890834"},{"id":"231ed5f0-2c15-4443-5e91-08d5ad2bf6ba","name":"CAMESA INDUSTRIA TEXTIL LTDA","commercialName":"CAMESA","cnpj":"43672716000148","city":"GUARULHOS","stateCode":"SP","buscaAdicional":"CAMESA 52450 CAMESA 150052116 900597 CAMESA 150139034 900598"},{"id":"515d47e9-5187-42a1-5cd6-08d5ad2bf6ba","name":"INDUSTRIA BANDEIRANTE DE PLASTICOS LTDA","commercialName":"","cnpj":"66989245000100","city":"GUARULHOS","stateCode":"SP","buscaAdicional":"BANFILME GRU 51584 BANFILME GRU 899819 BANFILME MG 911276"},{"id":"17bffe35-a128-4ff4-5d08-08d5ad2bf6ba","name":"AXALTA COATING SYSTEMS BRASIL LTDA.","commercialName":"","cnpj":"15373395000145","city":"GUARULHOS","stateCode":"SP","buscaAdicional":"AXALTA 51682 AXALTA 899288"},{"id":"7f8e4b13-2543-44fb-5cf3-08d5ad2bf6ba","name":"FACCHINI S/A","commercialName":"FACCHINI","cnpj":"03509978000171","city":"GUARULHOS","stateCode":"SP","buscaAdicional":"FACCHINI 51627 FACCHINI 1 898255 FACCHINI 2 898256 FACCHINI MIRASSOL 898275 FACCHINI VOT2 902770 FACCHINI VOT4 903900 FACCHINI VOT1 910593 FACCHINI VOT5 910912 FACCHINI COSMORAMA 909443"},{"id":"491fa2a5-a1fa-4826-5d97-08d5ad2bf6ba","name":"CONVERPLAST EMBALAGENS LTDA","commercialName":"","cnpj":"52616232000172","city":"GUARULHOS","stateCode":"SP","buscaAdicional":"CONVERPLAST 51928 CONVERPLAST GUARULHO 899973 CONVERPLAST AMANCIO 905763"},{"id":"63a30a2c-9d02-452d-5d2d-08d5ad2bf6ba","name":"INDUSTRIAS TEXTEIS SUECO LTDA","commercialName":"SUECO","cnpj":"62781778000132","city":"GUARULHOS","stateCode":"SP","buscaAdicional":"SUECO 51727 SUECO GUARULHOS SP 898540"},{"id":"9af19c8a-0869-49b9-5fbe-08d5ad2bf6ba","name":"CONTINENTAL BRASIL INDUSTRIA AUTOMOTIVA LTDA","commercialName":"CONTINENTAL BRASIL","cnpj":"48754139000157","city":"GUARULHOS","stateCode":"SP","buscaAdicional":"CONT ROTARY 53206 CONTINENTAL BRASIL 903013"},{"id":"260de15a-caf2-4883-5fe3-08d5ad2bf6ba","name":"DOREMUS ALIMENTOS LTDA","commercialName":"","cnpj":"54289830000100","city":"GUARULHOS","stateCode":"SP","buscaAdicional":"DOREMUS 53265 DOREMUS FILIAL 904802 DOREMUS 01 904838"},{"id":"56af44a0-472d-4027-5fe4-08d5ad2bf6ba","name":"CYBERGLASS INDUSTRIA E COMERCIO DE VIDROS LTDA.","commercialName":"","cnpj":"05252087000108","city":"GUARULHOS","stateCode":"SP","buscaAdicional":"CYBERGLASS 53278 CYBERGLASS 901915"},{"id":"9b4aa69d-0856-4c87-5ef3-08d5ad2bf6ba","name":"FANAVID FABRICA NACIONAL DE VIDROS DE SEGURANCA LTDA.","commercialName":"FANAVID","cnpj":"02286613000162","city":"GUARULHOS","stateCode":"SP","buscaAdicional":"FANAVID 52623 FANAVID 904085"},{"id":"16cf967a-cbb9-430b-5f04-08d5ad2bf6ba","name":"STEEL ROL INDUSTRIA E COMERCIO DE EMBALAGENS METALICAS LTDA","commercialName":"","cnpj":"58954850000109","city":"GUARULHOS","stateCode":"SP","buscaAdicional":"STEEL ROL 52705 STEEL ROL 902194"},{"id":"1769f0b0-3c95-4d9a-6072-08d5ad2bf6ba","name":"CONCESSIONARIA DO AEROPORTO INTERNACIONAL DE GUARULHOS S.A.","commercialName":"","cnpj":"15578569000106","city":"GUARULHOS","stateCode":"SP","buscaAdicional":"GRU 53513 AEROP GUARULHOS 903903"},{"id":"739111ec-f44d-4656-6073-08d5ad2bf6ba","name":"C. SCOPE ARTEFATOS ELASTOMEROS LTDA","commercialName":"","cnpj":"02200718000157","city":"GUARULHOS","stateCode":"SP","buscaAdicional":"CSCOPE 53514 SCOPE ARTEFATOS 901996"},{"id":"b5df54d8-f87c-4987-60bb-08d5ad2bf6ba","name":"POLIPRINT IND E COM DE EMBALAGENS PLASTICAS LTDA","commercialName":"","cnpj":"49336605000147","city":"GUARULHOS","stateCode":"SP","buscaAdicional":"POLIPRINT 53651 POLIPRINT EMBALAGENS 906702"},{"id":"44e53bcf-185f-4a6e-6089-08d5ad2bf6ba","name":"RAFT EMBALAGENS LTDA","commercialName":"","cnpj":"02496442000104","city":"GUARULHOS","stateCode":"SP","buscaAdicional":"RAFT 53581 RAFT 150107687 904772 RAFT 508179 904806 RAFT 905378"},{"id":"3001f048-35b6-44da-60f8-08d5ad2bf6ba","name":"GATE GOURMET LTDA","commercialName":"","cnpj":"69012656000120","city":"GUARULHOS","stateCode":"SP","buscaAdicional":"GATE GOURMET 53923 GATE GOURMET 905774"},{"id":"17b77c1e-11c5-4bcc-5848-08d5ad2bf6ba","name":"MAXION WHEELS DO BRASIL LTDA.","commercialName":"","cnpj":"02234234000390","city":"GUARULHOS","stateCode":"SP","buscaAdicional":"MAXION GUARULHOS 11189 HAYES GUARULHOS 7502"},{"id":"9553913a-43de-4cfd-5856-08d5ad2bf6ba","name":"PLASTICOS DANUBIO IND E COMERCIO LTDA","commercialName":"","cnpj":"54867601000125","city":"GUARULHOS","stateCode":"SP","buscaAdicional":"DANUBIO 11389 DANUBIO GUARULHOS SP 889971"},{"id":"050d167c-52f1-4c66-5829-08d5ad2bf6ba","name":"U-SHIN DO BRASIL SISTEMAS AUTOMOTIVOS LTDA","commercialName":"","cnpj":"17465122000156","city":"GUARULHOS","stateCode":"SP","buscaAdicional":"USHIN 10890 VALEO GRU 70180"},{"id":"d5c41954-383c-4816-57f2-08d5ad2bf6ba","name":"SAINT-GOBAIN DO BRASIL PRODUTOS INDUSTRIAIS E PARA CONSTRUCAO LTDA","commercialName":"","cnpj":"61064838011763","city":"GUARULHOS","stateCode":"SP","buscaAdicional":"SGABR GUARULHOS 10189 S GOBAIN GUARULHOS 889244"},{"id":"ab6e396e-fb21-4e25-5801-08d5ad2bf6ba","name":"ARO EXPORTACAO, IMPORTACAO, INDUSTRIA E COMERCIO LTDA","commercialName":"ARO","cnpj":"61075552000153","city":"GUARULHOS","stateCode":"SP","buscaAdicional":"ARO 10391 ARO EXPORTACAO 889522"},{"id":"d640af90-4fa7-4646-5b42-08d5ad2bf6ba","name":"IDEIAS VIDROS INDUSTRIA E COMERCIO EIRELI","commercialName":"","cnpj":"10924726000174","city":"GUARULHOS","stateCode":"SP","buscaAdicional":"IDEIAS VIDROS 50553 IDEIAS VIDROS 898314"},{"id":"d9c58bdc-bbfd-4aa6-5a9e-08d5ad2bf6ba","name":"INDUSTRIAL LEVORIN S A","commercialName":"","cnpj":"49032337000170","city":"GUARULHOS","stateCode":"SP","buscaAdicional":"LEVORIN 50112 INDUSTRIAL LEVORIN 907034"},{"id":"2620e8c5-163c-4151-5c71-08d5ad2bf6ba","name":"ACHE LABORATORIOS FARMACEUTICOS SA","commercialName":"","cnpj":"60659463000191","city":"GUARULHOS","stateCode":"SP","buscaAdicional":"ACHE 51318 ACHE 899202"},{"id":"3d979cf6-908b-4e6f-5c13-08d5ad2bf6ba","name":"SCHUTZ VASITEX INDUSTRIA DE EMBALAGENS S.A.","commercialName":"SCHUTZ VASITEX","cnpj":"06255543000136","city":"GUARULHOS","stateCode":"SP","buscaAdicional":"SCHUTZ VASITEX 51074 SCHUTZ GUARULHOS SP 898538"},{"id":"f12c58a2-9327-49a5-5c21-08d5ad2bf6ba","name":"DAMAPEL INDUSTRIA COMERCIO E DISTRIBUICAO DE PAPEIS LTDA","commercialName":"","cnpj":"02969683000115","city":"GUARULHOS","stateCode":"SP","buscaAdicional":"DAMAPEL 51097 DAMAPEL 898081"},{"id":"e7486c91-b92b-434f-5ba5-08d5ad2bf6ba","name":"ELETRICA DANUBIO INDUSTRIA E COMERCIO DE MATERIAIS ELETRICOS LTDA.","commercialName":"SIL FIOS E CABOS","cnpj":"61310256000190","city":"GUARULHOS","stateCode":"SP","buscaAdicional":"SIL FIOS E CABOS CL 50807 SIL CABOS GARULHOS 898208 SIL CABOS 898207"},{"id":"7b3067e7-b4fc-436c-5b9b-08d5ad2bf6ba","name":"CONDOMINIO CIVIL VOLUNTARIO DO '' PARQUE SHOPPING MAIA''","commercialName":"","cnpj":"17825521000180","city":"GUARULHOS","stateCode":"SP","buscaAdicional":"SHOP MAIA 50785 SHOPPING MAIA SP 898539"},{"id":"2bbc0219-d95b-4842-5b93-08d5ad2bf6ba","name":"CERVIFLAN INDUSTRIAL E COMERCIAL LIMITADA","commercialName":"","cnpj":"48510937000133","city":"GUARULHOS","stateCode":"SP","buscaAdicional":"CERVIFLAN 50770 CERVIFLAN 898181"},{"id":"3f6bcae8-36f4-433a-5905-08d5ad2bf6ba","name":"GUATAPARA ENERGIA S.A.","commercialName":"","cnpj":"17080857000161","city":"GUATAPARÁ","stateCode":"SP","buscaAdicional":"GUATAPARA 13561 GUATAPARA 892942 UTE.RU.SP.031440-4.01"},{"id":"082c41af-ed9b-4596-585d-08d5ad2bf6ba","name":"DOW CORNING DO BRASIL LTDA","commercialName":"","cnpj":"61204657000165","city":"HORTOLÂNDIA","stateCode":"SP","buscaAdicional":"DC HORTOLANDIA 11492 DC HORTOLANDIA 889991"},{"id":"518ee12b-cc33-4a66-5925-08d5ad2bf6ba","name":"BT LATAM BRASIL LTDA","commercialName":"BT","cnpj":"74280256000136","city":"HORTOLÂNDIA","stateCode":"SP","buscaAdicional":"BT LATAM 13895 LATAM HORTOLANDIA SP 892546"},{"id":"e77ab50d-147c-4a8c-5a77-08d5ad2bf6ba","name":"GREENBRIER MAXION - EQUIPAMENTOS E SERVICOS FERROVIARIOS S.A.","commercialName":"","cnpj":"21042930000188","city":"HORTOLÂNDIA","stateCode":"SP","buscaAdicional":"GREENBRIER MAXION 49706 AMSTED HORTOLANDIA 71045"},{"id":"1a095011-17cc-4614-5d73-08d5ad2bf6ba","name":"SHOPPING HORTOLANDIA EMPREENDIMENTO IMOBILIARIO LTDA.","commercialName":"","cnpj":"08983903000141","city":"HORTOLÂNDIA","stateCode":"SP","buscaAdicional":"SHOP HORTOLANDIA 51823 SHOP HORTOLANDIA 898292"},{"id":"3d3aff09-ba3f-4e50-53b8-08d5ad2bf6ba","name":"GKN SINTER METALS LTDA.","commercialName":"","cnpj":"02778274000131","city":"HORTOLÂNDIA","stateCode":"SP","buscaAdicional":"GKN SM 3796 GKN SINTER METALS 71305"},{"id":"f071bc57-2dfc-488b-5164-08d5ad2bf6ba","name":"MAGNETI MARELLI SISTEMAS AUTOMOTIVOS INDUSTRIA E COMERCIO LTDA","commercialName":"","cnpj":"02990605000950","city":"HORTOLÂNDIA","stateCode":"SP","buscaAdicional":"CONTROLEMOTOR 2150 MAGNETI MARELLI HORT 7586"},{"id":"8dfd8bff-044e-4c78-88f1-08d5ae44ed50","name":"ARCELORMITTAL GONVARRI BRASIL PRODUTOS SIDERURGICOS S/A","commercialName":"GONVARRI","cnpj":"02235994000312","city":"HORTOLÂNDIA","stateCode":"SP","buscaAdicional":"AM GONVARRI BRASIL 56222"},{"id":"314766cd-a96e-4c1b-62b6-08d5ad2bf6ba","name":"CONFIBRA INDUSTRIA E COMERCIO LTDA","commercialName":"","cnpj":"45828654000146","city":"HORTOLÂNDIA","stateCode":"SP","buscaAdicional":"CONFIBRA 54936 CONFIBRA 905120"},{"id":"36d43e9a-7f5d-4af0-642f-08d5ad2bf6ba","name":"LANMAR INDUSTRIA METALURGICA LTDA","commercialName":"","cnpj":"44630044000170","city":"HORTOLÂNDIA","stateCode":"SP","buscaAdicional":"LANMAR 55874 LANMAR METALURGICA 905660"},{"id":"d96e37df-4840-47b1-6443-08d5ad2bf6ba","name":"SANMINA-SCI DO BRASIL INTEGRATION LTDA","commercialName":"ADVANCED","cnpj":"01498525000161","city":"HORTOLÂNDIA","stateCode":"SP","buscaAdicional":"SANMINA 55900 SANMINA 905118"},{"id":"9e4ab788-21b4-4470-6936-08d5ad2bf6ba","name":"IPIRANGA BIOENERGIA S.A.","commercialName":"","cnpj":"25206734000152","city":"IACANGA","stateCode":"SP","buscaAdicional":"IACANGA BIO 60842 IACANGA 8579 UTE.AI.SP.029636-8.01"},{"id":"df924ce1-c707-4cad-8846-08d5ae44ed50","name":"IPIRANGA AGROINDUSTRIAL S.A.","commercialName":"","cnpj":"07280328000158","city":"IACANGA","stateCode":"SP","buscaAdicional":"IACANGA 2158"},{"id":"c5bd20a9-bede-48fb-5edf-08d5ad2bf6ba","name":"IBAPLAC PRODUTOS RECICLAVEIS LTDA","commercialName":"","cnpj":"71679260000183","city":"IBATÉ","stateCode":"SP","buscaAdicional":"IBAPLAC 52593 IBAPLAC 902707"},{"id":"1e4bd96b-6567-4cc8-6220-08d5ad2bf6ba","name":"RUDOLF-SIZING AMIDOS DO BRASIL LTDA.","commercialName":"BERMAVE","cnpj":"53420477000192","city":"IBIRAREMA","stateCode":"SP","buscaAdicional":"RUDOLF SIZING 54575 RUDOLF-SIZING IBIRA 906356"},{"id":"fb1cf878-bac6-4fbd-5158-08d5ad2bf6ba","name":"OLIVEIRA & LOPES LTDA","commercialName":"ANDREZA ENXOVAIS","cnpj":"54514294000107","city":"IBITINGA","stateCode":"SP","buscaAdicional":"OLIVEIRA LOPES 2131 OLIVEIRA E LOPES 70533 OLIVEIRA LOPES 2 71833 OLIVEIRA ITATIBA 903673"},{"id":"d7e7c6ae-db0b-4223-5bec-08d5ad2bf6ba","name":"KARINA PISOS E REVESTIMENTOS CERAMICOS LTDA","commercialName":"KARINA TELHAS","cnpj":"00585121000142","city":"IGARAÇU DO TIETÊ","stateCode":"SP","buscaAdicional":"KARINA PISOS 50986 KARINA 898103 KARINA PISOS 899073 KARINA PISOS REVESTI 904637"},{"id":"c156eb43-29ef-453f-5bbd-08d5ad2bf6ba","name":"SUBCONDOMINIO SHOPPING CENTER - SUBCONDOMINIO POLO SHOPPING INDAIATUBA","commercialName":"SUBCONDOMINIO POLO SHOPPING INDAIATUBA","cnpj":"17332581000161","city":"INDAIATUBA","stateCode":"SP","buscaAdicional":"POLO SHOPPING 50879 SUB SHOP INDAIATUBA 898822"},{"id":"3a2fe76d-53f7-4ba2-585c-08d5ad2bf6ba","name":"FUPRESA S.A.","commercialName":"","cnpj":"62576327000830","city":"INDAIATUBA","stateCode":"SP","buscaAdicional":"FUPRESA 11491 FUPRESA INDAIATUBA 889993"},{"id":"34379b05-fb73-4116-5f0e-08d5ad2bf6ba","name":"GERRESHEIMER SISTEMAS PLASTICOS MEDICINAIS SAO PAULO LTDA.","commercialName":"GERRESHEIMER SISTEMAS PLASTICOS MEDICINAIS SAO PAULO LT","cnpj":"11171922000188","city":"INDAIATUBA","stateCode":"SP","buscaAdicional":"GERRESHEIMER 52719 GERRESHEIMER SISTEMA 900013"},{"id":"6b3ffabe-3a56-4447-5ef4-08d5ad2bf6ba","name":"TWINGLASS VIDROS LTDA","commercialName":"","cnpj":"03061254000108","city":"INDAIATUBA","stateCode":"SP","buscaAdicional":"TWINGLASS 52624 TWINGLASS 901016"},{"id":"352d8a82-56e1-445b-5f8a-08d5ad2bf6ba","name":"ZEKAMETAL METALURGICA EIRELI","commercialName":"","cnpj":"23817173000100","city":"INDAIATUBA","stateCode":"SP","buscaAdicional":"ZEKAMETAL 53016 ZEKAMETAL SP 888861"},{"id":"01af7cb3-9a4c-4939-5cf0-08d5ad2bf6ba","name":"SEW-EURODRIVE BRASIL LTDA","commercialName":"","cnpj":"50981018002052","city":"INDAIATUBA","stateCode":"SP","buscaAdicional":"SEW 51618 SEW - EURODRIVE 899356"},{"id":"c3da3965-779a-4d55-5e45-08d5ad2bf6ba","name":"JOHN DEERE BRASIL LTDA","commercialName":"","cnpj":"89674782001472","city":"INDAIATUBA","stateCode":"SP","buscaAdicional":"JDB INDAIATUBA 52308 JDB INDAIATUBA SP 900007"},{"id":"9ea91469-8dbd-4032-5e4b-08d5ad2bf6ba","name":"DEERE-HITACHI MAQUINAS DE CONSTRUCAO DO BRASIL S.A.","commercialName":"","cnpj":"03982513000133","city":"INDAIATUBA","stateCode":"SP","buscaAdicional":"DEERE HITACHI 52322 DEERE HITACHI 899947"},{"id":"194937f4-b845-4e82-5132-08d5ad2bf6ba","name":"TMD FRICTION DO BRASIL S.A.","commercialName":"","cnpj":"33060716000133","city":"INDAIATUBA","stateCode":"SP","buscaAdicional":"TMD FRICTION 2043 TMD FRICT. MTZ INDAI 70427 TMD FRICTION SALTO 908077"},{"id":"8d7aed9c-8e5e-4513-5041-08d5ad2bf6ba","name":"MANN+HUMMEL BRASIL LTDA.","commercialName":"","cnpj":"57014862000190","city":"INDAIATUBA","stateCode":"SP","buscaAdicional":"MANN HUMMEL 1540 MANN HUMMEL BRASIL 7987 MANN HUMMEL 902742"},{"id":"0f1c2c14-8b28-4eaa-50ef-08d5ad2bf6ba","name":"PLASTEK DO BRASIL INDUSTRIA E COMERCIO LTDA","commercialName":"","cnpj":"02978706000158","city":"INDAIATUBA","stateCode":"SP","buscaAdicional":"PLASTEK 1912 PLASTEK MTZ INDAIATU 70290"},{"id":"b263b6a6-5857-40ef-5367-08d5ad2bf6ba","name":"SCHOTT FLAT GLASS DO BRASIL LTDA","commercialName":"","cnpj":"01245657000181","city":"INDAIATUBA","stateCode":"SP","buscaAdicional":"SCHOTT 3616 SCHOTT FLAT GLASS 71183"},{"id":"1dff4258-b621-4415-542e-08d5ad2bf6ba","name":"BASF SA","commercialName":"","cnpj":"48539407002919","city":"INDAIATUBA","stateCode":"SP","buscaAdicional":"BASF SA 4058 BASF-INDAIATUBA SP 71576"},{"id":"4f2ca93a-de83-4572-54dc-08d5ad2bf6ba","name":"MIBA SINTER BRASIL LTDA","commercialName":"MIBA BRASIL","cnpj":"45542453000188","city":"INDAIATUBA","stateCode":"SP","buscaAdicional":"MIBA SINTER 4546 MIBA SINTER - INDAIA 71647"},{"id":"46660aad-b093-4c8c-54de-08d5ad2bf6ba","name":"UNILEVER BRASIL INDUSTRIAL LTDA","commercialName":"","cnpj":"01615814002813","city":"INDAIATUBA","stateCode":"SP","buscaAdicional":"UNIINDAIA 4549 UNILEVER INDAIATUBA 7252"},{"id":"a9138d91-6f2b-4c73-557c-08d5ad2bf6ba","name":"CEBI BRASIL LTDA","commercialName":"","cnpj":"03171093000105","city":"INDAIATUBA","stateCode":"SP","buscaAdicional":"CEBI 5709 CEBI BRASIL-INDAIATB 71954"},{"id":"1619683c-07f3-48db-57c4-08d5ad2bf6ba","name":"PLASTICOS ITAQUITI LTDA.","commercialName":"ITAQUITI","cnpj":"03662365000170","city":"INDAIATUBA","stateCode":"SP","buscaAdicional":"PLAST ITAQUITI 9592 PLASTICOS ITAQUITI 889076"},{"id":"fef5381c-fe34-481f-63fe-08d5ad2bf6ba","name":"SINGER DO BRASIL INDUSTRIA E COMERCIO LTDA","commercialName":"SINGER","cnpj":"61432506000164","city":"INDAIATUBA","stateCode":"SP","buscaAdicional":"SINGER DO BRASIL 55771 SINGER DO BRASIL 905931"},{"id":"b62c9e69-6d4f-4ac7-6519-08d5ad2bf6ba","name":"ELDOR DO BRASIL COMPONENTES AUTOMOTIVOS INDUSTRIA E COMERCIO LTDA","commercialName":"","cnpj":"13353050000102","city":"INDAIATUBA","stateCode":"SP","buscaAdicional":"ELDOR 56472 ELDOR INDAIATUBA 908072"},{"id":"7eec96f5-ab0a-4341-6842-08d5ad2bf6ba","name":"TUBERFIL INDUSTRIA E COMERCIO DE TUBOS LTDA","commercialName":"","cnpj":"59300962000109","city":"INDAIATUBA","stateCode":"SP","buscaAdicional":"TUBERFIL 59631 TUBERFIL FILIAL INDA 908973 TUBERFIL FILIAL SALT 908974 TUBERFIL MATRIZ INDA 908975"},{"id":"1dc6ee97-050d-454f-1ccf-08d5b8870181","name":"PECVAL INDUSTRIA LTDA","commercialName":"PECVAL","cnpj":"02224977000118","city":"INDAIATUBA","stateCode":"SP","buscaAdicional":"PECVAL 61793 PECVAL INDUSTRIA 912858"},{"id":"79eaa45c-2f05-4a3a-739b-08d5cf600bef","name":"BICICLETAS MONARK S A","commercialName":"","cnpj":"56992423000190","city":"INDAIATUBA","stateCode":"SP","buscaAdicional":""},{"id":"1a07aa19-13b7-467a-8da6-08d5d060706e","name":"FUNDITUBA INDUSTRIA METALURGICA LTDA","commercialName":"","cnpj":"46958708000150","city":"INDAIATUBA","stateCode":"SP","buscaAdicional":"FUNDITUBA 62011 FUNDITUBA 913398"},{"id":"1e8b9376-d592-4734-4efd-08d5d159243d","name":"LGT HUB PARTICIPACOES S.A.","commercialName":"","cnpj":"26173550000104","city":"INDAIATUBA","stateCode":"SP","buscaAdicional":""},{"id":"ec80238a-88d7-4f88-4ef0-08d5d159243d","name":"GPR - PINHEIRO & RINALDO CAPITAL S/A","commercialName":"","cnpj":"21903297000175","city":"INDAIATUBA","stateCode":"SP","buscaAdicional":""},{"id":"c0f9bc2c-3c2f-48df-61a8-08d5ad2bf6ba","name":"ASSOCIACAO DAS EMPRESAS DE GEORGE OETTERER","commercialName":"","cnpj":"14339358000158","city":"IPERÓ","stateCode":"SP","buscaAdicional":"OETTERER 54332 ARTEFACTO 906596"},{"id":"cba669fb-5d76-4cf6-5815-08d5ad2bf6ba","name":"PROGERAL INDUSTRIA DE ARTEFATOS PLASTICOS LTDA","commercialName":"PROGERAL","cnpj":"61309746000338","city":"IPERÓ","stateCode":"SP","buscaAdicional":"PROGERAL 10609 PROGERAL FABRICA II 889703"},{"id":"2744a25f-224c-42a0-5b8d-08d5ad2bf6ba","name":"CERAMICA ALFAGRES INDUSTRIA E COMERCIO LTDA","commercialName":"ALFAGRES","cnpj":"01703119000193","city":"IPEÚNA","stateCode":"SP","buscaAdicional":"ALFAGRES 50760 CERAMICA ALFAGRES SP 897773"},{"id":"33853f8f-97c5-4986-61d2-08d5ad2bf6ba","name":"9INJET INJECAO DE PECAS PLASTICAS LTDA.","commercialName":"9INJET","cnpj":"07591645000195","city":"IPEÚNA","stateCode":"SP","buscaAdicional":"9INJET 54438 9INJET INJECAO DE PC 906077"},{"id":"bf742b1f-6740-48ce-68e4-08d5ad2bf6ba","name":"EMAR INDUSTRIA E COMERCIO DE PLASTICOS EIRELI","commercialName":"","cnpj":"52107364000179","city":"IPIGUÁ","stateCode":"SP","buscaAdicional":"EMAR 60530 EMAR II 910622 EMAR IV 910623 EMAR I 912759 EMAR III 912811"},{"id":"91b6e571-203b-4f12-1cad-08d5b8870181","name":"SAO MARTINHO S/A","commercialName":"","cnpj":"51466860002957","city":"IRACEMÁPOLIS","stateCode":"SP","buscaAdicional":"USINA IRACEMA 60807 US IRACEMA - SAO MAR 912875"},{"id":"6ca9268b-a2fa-4db3-641d-08d5ad2bf6ba","name":"CITRUS JUICE EIRELI","commercialName":"CITRUS JUICE","cnpj":"11186770000197","city":"ITAJOBI","stateCode":"SP","buscaAdicional":"CITRUS JUICE 55846 CITRUS JUICE 907789"},{"id":"f6401fd3-9d57-4c78-5e4c-08d5ad2bf6ba","name":"FARMACAP INDUSTRIA E COMERCIO LTDA.","commercialName":"","cnpj":"59910554000179","city":"ITAPECERICA DA SERRA","stateCode":"SP","buscaAdicional":"FARMACAP 52323 FARMACAP 902183"},{"id":"c93716b8-9995-4a22-5dfd-08d5ad2bf6ba","name":"FRESENIUS HEMOCARE BRASIL LTDA.","commercialName":"ASEM","cnpj":"49601107000184","city":"ITAPECERICA DA SERRA","stateCode":"SP","buscaAdicional":"FRESENIUS HEMOCARE 52136 FRESENIUS HEMOCARE 901502"},{"id":"508f7aa5-9a5b-41a3-5e03-08d5ad2bf6ba","name":"LEGAL INDUSTRIA E COMERCIO DE EMBALAGENS LTDA","commercialName":"","cnpj":"05797607000168","city":"ITAPECERICA DA SERRA","stateCode":"SP","buscaAdicional":"LEGAL EMBALAGENS 52149 LEGAL EMBALAGENS SP 901007"},{"id":"869c6ff9-f8b1-44ae-504d-08d5ad2bf6ba","name":"REFRIO ARMAZENS GERAIS LTDA.","commercialName":"REFRIO","cnpj":"49363468000130","city":"ITAPECERICA DA SERRA","stateCode":"SP","buscaAdicional":"REFRIO 1562 REFRIO ITAPECERIC U1 903615 REFRIO ITAPECERIC U4 903616 REFRIO ITAPECERIC U2 903633 REFRIO ITAPECERIC U3 903634 REFRIO - ARAUCARIA 904796"},{"id":"cfbc0d39-b8fe-453d-52ab-08d5ad2bf6ba","name":"BOEHRINGER INGELHEIM DO BRASIL QUIMICA E FARMACEUTICA LTDA.","commercialName":"","cnpj":"60831658002110","city":"ITAPECERICA DA SERRA","stateCode":"SP","buscaAdicional":"BOEHRINGER 3212 BOEHRINGER-ITAPECERI 70963"},{"id":"0868c0d7-b3ab-4828-52a6-08d5ad2bf6ba","name":"DURATEX S.A.","commercialName":"","cnpj":"97837181002433","city":"ITAPETININGA","stateCode":"SP","buscaAdicional":"DURA FI 3199 DURATEX-ITP 56"},{"id":"40b4faa5-fcac-4ab4-52a8-08d5ad2bf6ba","name":"AGROINDUSTRIAL VISTA ALEGRE S.A. EM RECUPERACAO JUDICIAL","commercialName":"USINA VISTA ALEGRE","cnpj":"44836856000177","city":"ITAPETININGA","stateCode":"SP","buscaAdicional":"VISTA ALEGRE 3206 VISTA ALEGRE (AGRO) 8171 UTE.AI.SP.028462-9.01"},{"id":"02755db3-66df-4378-57d1-08d5ad2bf6ba","name":"MOURA BATERIAS AUTOMOTIVAS E INDUSTRIAIS - COMERCIO, EXPORTACAO E IMPORTACAO LTDA","commercialName":"","cnpj":"15459513000132","city":"ITAPETININGA","stateCode":"SP","buscaAdicional":"ACUM MOURA SP 9695 MOURA BATERIAS 889282"},{"id":"2aebc0f1-6bbd-412b-5318-08d5ad2bf6ba","name":"MARINGA FERRO-LIGA S.A","commercialName":"FABRICA","cnpj":"61082988000250","city":"ITAPEVA","stateCode":"SP","buscaAdicional":"MARINGA APE 3477 MARINGA ITAPEV LIVRE 7093"},{"id":"31d267ae-33ba-450f-5e18-08d5ad2bf6ba","name":"TAQUARI INDUSTRIA E COMERCIO DE PAPEIS LTDA","commercialName":"","cnpj":"15755306000125","city":"ITAPEVA","stateCode":"SP","buscaAdicional":"TAQUARI 52194 TAQUARI ITAPEVA 899362"},{"id":"3e505ab9-37a9-43cf-5d32-08d5ad2bf6ba","name":"I.B.A.C. INDUSTRIA BRASILEIRA DE ALIMENTOS E CHOCOLATES LTDA.","commercialName":"","cnpj":"61472205000164","city":"ITAPEVI","stateCode":"SP","buscaAdicional":"IBAC 51732 IBAC CHOCOLATES SP 899141"},{"id":"8700c876-292d-4829-60ac-08d5ad2bf6ba","name":"HENKEL LTDA","commercialName":"","cnpj":"02777131000105","city":"ITAPEVI","stateCode":"SP","buscaAdicional":"HENKEL 53631 HENKEL DIADEMA 904240 HENKEL ITAPEVI 904497 HENKEL JUNDIAI 906335"},{"id":"86d25cba-9560-4655-5036-08d5ad2bf6ba","name":"CECIL S/A - LAMINACAO DE METAIS","commercialName":"","cnpj":"61554028000165","city":"ITAPEVI","stateCode":"SP","buscaAdicional":"CECIL 1517 CECIL-SAO PAULO-SP 7978 CECIL - JOINVILLE - 72329"},{"id":"d5cf3b3c-9169-403d-50d3-08d5ad2bf6ba","name":"BRASALPLA BRASIL - INDUSTRIA DE EMBALAGENS LTDA.","commercialName":"ALPLA BRASIL","cnpj":"01377724000111","city":"ITAPEVI","stateCode":"SP","buscaAdicional":"BRASALPLA 1864 BRASALPLA-ITAPEVI-SP 70228 BRASALPLA-LOUVEIRA 71682 BRASALPLA S AGOSTIN 893823"},{"id":"bd8529b1-032a-4c0b-68b0-08d5ad2bf6ba","name":"ITACEL FARMOQUIMICA LTDA.","commercialName":"ROQUETTE BRASIL","cnpj":"26900420000118","city":"ITAPEVI","stateCode":"SP","buscaAdicional":"ITACEL 60273 ITACEL ITAPEVI 71364"},{"id":"f25401fe-d5c0-411d-1cce-08d5b8870181","name":"BIOMEDICAL DISTRIBUTION MERCOSUR LTDA","commercialName":"BOMI BRASIL","cnpj":"02426290000165","city":"ITAPEVI","stateCode":"SP","buscaAdicional":"BIOMEDICAL MERCOSUR 61771 BIOMEDICAL MERCOSUL 912772"},{"id":"85455a0d-d368-457f-65d1-08d5ad2bf6ba","name":"TEXTIL CARMEM LTDA","commercialName":"","cnpj":"59466003000168","city":"ITAPIRA","stateCode":"SP","buscaAdicional":"TEXTIL CARMEM 57150 TEXTIL CARMEM 907269"},{"id":"eb39901c-2b82-436f-6751-08d5ad2bf6ba","name":"FABRICA DE PAPEL E PAPELAO NOSSA SENHORA DA PENHA SA","commercialName":"","cnpj":"49912199000113","city":"ITAPIRA","stateCode":"SP","buscaAdicional":"PENHA ITAPIRA 58039 PENHA PAPEL ITAPIRA 70920"},{"id":"b732acc2-8a29-40d7-6179-08d5ad2bf6ba","name":"CRISTALIA PRODUTOS QUIMICOS FARMACEUTICOS LTDA","commercialName":"LABORATORIO CRISTALIA","cnpj":"44734671000151","city":"ITAPIRA","stateCode":"SP","buscaAdicional":"CRISTALIA 54201 CRISTALIA 903881"},{"id":"a982e7a8-c04b-4767-6115-08d5ad2bf6ba","name":"IRMAOS CAIO -INDUSTRIA E COMERCIO DE ALGODAO LTDA","commercialName":"","cnpj":"49911498000133","city":"ITAPIRA","stateCode":"SP","buscaAdicional":"IRMAOS CAIO 53998 IRMAOS CAIO 905122 IRMAOS CAIO FILIAL 905123"},{"id":"6838bbd7-742b-42bc-6268-08d5ad2bf6ba","name":"NB MAQUINAS LTDA","commercialName":"JF MAQUINAS","cnpj":"46127635000155","city":"ITAPIRA","stateCode":"SP","buscaAdicional":"NB MAQUINAS 54747 NB MAQUINAS SAO JOAO 905657 NB MAQUINAS 905699"},{"id":"4eb04cee-a0d5-4b0d-626e-08d5ad2bf6ba","name":"CERAMICA FORMIGARI LTDA","commercialName":"CERAMICA FORMIGARI","cnpj":"49920531000191","city":"ITAPIRA","stateCode":"SP","buscaAdicional":"CERAMICA FORMIGARI 54758 CERAMICA FORMIGARI 906423"},{"id":"b98f13b0-8bc9-4267-62f3-08d5ad2bf6ba","name":"JAMPAC INDUSTRIA E COMERCIO DE ALIMENTOS LTDA","commercialName":"","cnpj":"20844980000116","city":"ITAPIRA","stateCode":"SP","buscaAdicional":"JAMPAC 55058 JAMPAC ALIMENTOS 907259"},{"id":"a2cf2c38-c753-4bab-57d2-08d5ad2bf6ba","name":"ANTONELLI SUPERMERCADO LTDA","commercialName":"","cnpj":"07732866000136","city":"ITAPIRA","stateCode":"SP","buscaAdicional":"ANTONELLI SUPER 9709 ANTONELLI S AMPARO 889251 ANTONELLI SUPER 889255 ANTONELLI JACUTINGA 900997"},{"id":"79c44741-95ce-4b6c-57b6-08d5ad2bf6ba","name":"CARGILL ALIMENTOS LTDA","commercialName":"","cnpj":"01961898000127","city":"ITAPIRA","stateCode":"SP","buscaAdicional":"NUTRON ITP 9389 NUTRON ITP 890208 NUTRON TLD 43894437 911252"},{"id":"5ef3b47e-2f3d-467d-5e90-08d5ad2bf6ba","name":"IMBIL INDUSTRIA E MANUTENCAO DE BOMBAS ITA LTDA","commercialName":"","cnpj":"51482776000126","city":"ITAPIRA","stateCode":"SP","buscaAdicional":"IMBIL 52449 IMBIL ITAPIRA SP 901004"},{"id":"ca35fb2c-35df-42ac-606a-08d5ad2bf6ba","name":"INDUSTRIA DE TRANSFORMADORES ITAIPU LTDA","commercialName":"ITAIPU TRANSFORMADORES","cnpj":"46958948000155","city":"ITÁPOLIS","stateCode":"SP","buscaAdicional":"TRANSFORMADORES ITAIPU 53498 TRAFO ITAIPU 905573"},{"id":"62b0efe1-ad22-41f8-5f27-08d5ad2bf6ba","name":"STELLA D'ORO ALIMENTOS LTDA","commercialName":"STELLA D'ORO","cnpj":"05117323000183","city":"ITÁPOLIS","stateCode":"SP","buscaAdicional":"PREDILECTA STELLA DORO 52795 STELLA DORO 904558"},{"id":"1505eaf0-5e27-4931-66ae-08d5ad2bf6ba","name":"P V T INDUSTRIA TEXTIL LTDA.","commercialName":"P V T TEXTIL","cnpj":"07457208000183","city":"ITÁPOLIS","stateCode":"SP","buscaAdicional":"PVT IND 57742 PVT ITAPOLIS 909077"},{"id":"df3d2070-b3f5-48ae-66fb-08d5ad2bf6ba","name":"ATOMIZACAO DE METAIS OMEGA EIRELI","commercialName":"OMEGA","cnpj":"09239933000100","city":"ITAQUAQUECETUBA","stateCode":"SP","buscaAdicional":"METAIS OMEGA 57908 ATOMIZ METAIS OMEGA 909261 ATOMIZ MET OMEGA F 2 909262"},{"id":"47006b14-b1fe-438d-6764-08d5ad2bf6ba","name":"CONCESSIONARIA DAS RODOVIAS AYRTON SENNA E CARVALHO PINTO S/A - ECOPISTAS","commercialName":"","cnpj":"10841050000155","city":"ITAQUAQUECETUBA","stateCode":"SP","buscaAdicional":"ECOPISTAS 58074 ECOPISTAS 107956 910564 ECOPISTAS 503304 910565 ECOPISTAS 502243 910566 ECOPISTAS 503291 910567 ECOPISTAS 503673 910568 ECOPISTAS 503754 910569 ECOPISTAS 105805 910583 ECOPISTAS 503312 910587 ECOPISTAS 500313 910589 ECOPISTAS 175307 910590"},{"id":"7851c0d7-a483-4371-684a-08d5ad2bf6ba","name":"ASSOCIACAO DO ITAQUA GARDEN SHOPPING","commercialName":"","cnpj":"26213899000114","city":"ITAQUAQUECETUBA","stateCode":"SP","buscaAdicional":"SHOP GARDEN ITAQUA 59666 GARDEN ITAQUA 909209"},{"id":"7e4ed8f4-2348-441c-6313-08d5ad2bf6ba","name":"SUPERMERCADO SHIBATA LTDA","commercialName":"","cnpj":"48093892000149","city":"ITAQUAQUECETUBA","stateCode":"SP","buscaAdicional":"SHIBATA SUPER 55128 SHIBATA JACAREI 904835 SHIBATA SUPER ITAQUA 904836"},{"id":"6aa9e4b9-eb1d-419a-6322-08d5ad2bf6ba","name":"NOLD POLITECH FILMES E EMBALAGENS LTDA","commercialName":"","cnpj":"04370098000120","city":"ITAQUAQUECETUBA","stateCode":"SP","buscaAdicional":"NOLD POLITECH 55180 NOLD POLITECH 905930"},{"id":"643415b7-122b-44c9-61a7-08d5ad2bf6ba","name":"SIVA INDUSTRIA E COMERCIO DE ARTEFATOS DE ARAME E ACO LTDA.","commercialName":"SIVA CABOS DE ACO","cnpj":"62576749000139","city":"ITAQUAQUECETUBA","stateCode":"SP","buscaAdicional":"SIVA 54331 SIVA ITAQUAQUECETUBA 904839"},{"id":"5b5a9b32-1b47-4eb9-6560-08d5ad2bf6ba","name":"ZEVIPLAST INDUSTRIA E COMERCIO DE PLASTICOS EIRELI","commercialName":"","cnpj":"62934294000186","city":"ITAQUAQUECETUBA","stateCode":"SP","buscaAdicional":"ZEVIPLAST 56703 ZEVIPLAST 908198"},{"id":"b1f7d39a-fbe5-4377-1cd1-08d5b8870181","name":"GALVANIZACAO JOSITA LTDA","commercialName":"","cnpj":"62988365000123","city":"ITAQUAQUECETUBA","stateCode":"SP","buscaAdicional":"JOSITA 61830 JOSITA INDUSTRIAL 912676 SPJSCBENTR101 912733"},{"id":"3e4d5b25-46da-489c-88ed-08d5ae44ed50","name":"MERCANTIL DE ALIMENTOS ZQ LTDA.","commercialName":"","cnpj":"22885575000171","city":"ITAQUAQUECETUBA","stateCode":"SP","buscaAdicional":"GRUPO SETA 55504 MERCANTIL ZQ 905928"},{"id":"235805ec-b576-45bb-5f21-08d5ad2bf6ba","name":"MAJICPLAST EMBALAGENS LTDA","commercialName":"","cnpj":"53031654000149","city":"ITAQUAQUECETUBA","stateCode":"SP","buscaAdicional":"MAJICPLAST 52771 MAJICPLAST 903981"},{"id":"cd15f224-a552-4508-5f92-08d5ad2bf6ba","name":"JAL INDUSTRIA E COMERCIO DE FERRO E ACO LTDA","commercialName":"JAL INDUSTRIAL","cnpj":"05817664000161","city":"ITAQUAQUECETUBA","stateCode":"SP","buscaAdicional":"JAL INDUSTRIAL 53029 JAL INDUSTRIA 900713"},{"id":"303a72c1-4b08-40b9-60d8-08d5ad2bf6ba","name":"CROMO AZUL INDUSTRIA E COMERCIO DE ART DE ARAME LTDA","commercialName":"CROMO AZUL","cnpj":"00901682000103","city":"ITAQUAQUECETUBA","stateCode":"SP","buscaAdicional":"CROMO AZUL 53762 CROMO AZUL FILIAL 904975 CROMO AZUL MATRIZ 904978"},{"id":"6e22856a-d610-480a-60e2-08d5ad2bf6ba","name":"TREMPS ARTEFATOS DE ARAME LTDA","commercialName":"","cnpj":"05641425000101","city":"ITAQUAQUECETUBA","stateCode":"SP","buscaAdicional":"TREMPS 53833 TREMPS 904804"},{"id":"8fb63264-dd7f-4f72-5e33-08d5ad2bf6ba","name":"INDUSTRIA E COMERCIO DE PLASTICOS IBIRA LTDA","commercialName":"","cnpj":"61478467000136","city":"ITAQUAQUECETUBA","stateCode":"SP","buscaAdicional":"PLASTICOS IBIRA 52276 IBIRA PLASTICOS 902009"},{"id":"ad5c148b-bdc8-4e52-5b90-08d5ad2bf6ba","name":"STARPACK PLASTICOS INDUSTRIAIS EIRELI","commercialName":"","cnpj":"67038844000100","city":"ITAQUAQUECETUBA","stateCode":"SP","buscaAdicional":"STARPACK PLASTICOS 50765 STARPACK 898307"},{"id":"5d43cee0-8561-4f4c-54e4-08d5ad2bf6ba","name":"PLASTICOS ITAQUA PRODUTOS SINTETICOS EIRELI","commercialName":"","cnpj":"61427258000759","city":"ITAQUAQUECETUBA","stateCode":"SP","buscaAdicional":"MARFINITE 4572 MARFINITE-ITAQUA 71670"},{"id":"d4b68bfe-166a-45be-54e2-08d5ad2bf6ba","name":"SOCIEDADE ANONIMA FABRIL SCAVONE","commercialName":"LANIFICIO LUIZ SCAVONE","cnpj":"50115849000189","city":"ITATIBA","stateCode":"SP","buscaAdicional":"SCAVONE 4568 SCAVONE-ITATIBA SP 71724"},{"id":"bd6868cb-7d9b-4956-54e9-08d5ad2bf6ba","name":"BOREALIS BRASIL S.A.","commercialName":"","cnpj":"13204698000109","city":"ITATIBA","stateCode":"SP","buscaAdicional":"BOREALIS 4588 BOREALIS-ITATIBA SP 71715"},{"id":"988990f8-624f-4198-551c-08d5ad2bf6ba","name":"TIMAVO DO BRASIL SA INDUSTRIA TEXTIL","commercialName":"","cnpj":"44740066000193","city":"ITATIBA","stateCode":"SP","buscaAdicional":"TIMAVO 5068 TIMAVO-ITATIBA SP 71890"},{"id":"ce7e7033-34a0-463f-50a7-08d5ad2bf6ba","name":"VALEO SISTEMAS AUTOMOTIVOS LTDA.","commercialName":"TERMICO MOTOR MATRIZ","cnpj":"57010662000160","city":"ITATIBA","stateCode":"SP","buscaAdicional":"VALEO MATRIZ 1766 VALEO TRASM.CAMPINAS 70122 VALEO ARCOND.ITATIBA 70494 VALEO MOTOR ITATIBA 70827 VALEO ILUMINA 70800"},{"id":"ea3bb4fc-8e53-48cc-5301-08d5ad2bf6ba","name":"MALIBER INDUSTRIA E COMERCIO TEXTIL LTDA","commercialName":"","cnpj":"47938840000163","city":"ITATIBA","stateCode":"SP","buscaAdicional":"MALIBER 3429 MALIBER 71130 MALIBER MORUNGABA 904475"},{"id":"435bcab4-73df-4f06-5339-08d5ad2bf6ba","name":"PLIMAX INDUSTRIA DE EMBALAGENS PLASTICAS LTDA","commercialName":"","cnpj":"50973684000186","city":"ITATIBA","stateCode":"SP","buscaAdicional":"PLIMAX 3523 PLIMAX 71054"},{"id":"116b4e43-acda-4191-5d55-08d5ad2bf6ba","name":"KROMBERG & SCHUBERT DO BRASIL LTDA.","commercialName":"","cnpj":"03574096000190","city":"ITATIBA","stateCode":"SP","buscaAdicional":"KSBR 51787 KSBR ITATIBA 899360 KSBR OLIVEIRA 904047"},{"id":"1faadf41-3b6f-4bb7-5d05-08d5ad2bf6ba","name":"COLOROBBIA BRASIL PRODUTOS PARA CERAMICA LTDA","commercialName":"","cnpj":"47939855000146","city":"ITATIBA","stateCode":"SP","buscaAdicional":"COLOROBBIA 51679 COLOROBBIA BRASIL 899318 COLOROBBIA BRA UNID2 899691"},{"id":"083ccd73-a631-4447-602a-08d5ad2bf6ba","name":"RHODIA POLIAMIDA E ESPECIALIDADES SA","commercialName":"","cnpj":"15179682002910","city":"ITATIBA","stateCode":"SP","buscaAdicional":"RHODIA ITATIBA 53409 RHODIA POLIAMIDA 902317"},{"id":"201ce622-7c35-4570-1cda-08d5b8870181","name":"FRANCO AGROPECUARIA LTDA","commercialName":"","cnpj":"64633373000182","city":"ITATIBA","stateCode":"SP","buscaAdicional":"MISTER GELO 62433 FRANCO AGRO 912600"},{"id":"b839e823-ca86-43a4-739c-08d5cf600bef","name":"PRO METALURGIA S. A. - EM LIQUIDACAO EXTRAJUDICIAL","commercialName":"PRO METALURGIA","cnpj":"56994924000105","city":"ITATIBA","stateCode":"SP","buscaAdicional":""},{"id":"62536765-97a5-42f2-730b-08d5cf600bef","name":"CONCESSIONARIA ROTA DAS BANDEIRAS S.A.","commercialName":"","cnpj":"10647979000148","city":"ITATIBA","stateCode":"SP","buscaAdicional":""},{"id":"7f769671-772e-488a-6497-08d5ad2bf6ba","name":"COVABRA SUPERMERCADOS LTDA","commercialName":"","cnpj":"61233151000184","city":"ITATIBA","stateCode":"SP","buscaAdicional":"SUPERMERCADO COVABRA 56114 COVABRA LOJA 16 907821 COVABRA - LOJA 7 907823 COVABRA - LOJA 12 907825 COVABRA - LOJA 4 907826 COVABRA - LOJA 11 907827 COVABRA - LOJA 03 907847 COVABRA - LOJA 02 907848 COVABRA - LOJA 09 907894 COVABRA LJ6 CAPIVARI 907902 COVABRA LOJA 10 CP 907934 COVABRA JUNDIAI LJ17 908075 COVABRA PEDREIRA L19 908165 COVABRA SUMARE 908403 COVABRA 5 ITATIBA 909591"},{"id":"2d2e73fa-fc91-4434-6222-08d5ad2bf6ba","name":"WISEWOOD - SOLUCOES ECOLOGICAS S.A.","commercialName":"","cnpj":"04053268000142","city":"ITATIBA","stateCode":"SP","buscaAdicional":"WISEWOOD 54591 WISEWOOD 905121"},{"id":"e189aa3c-48c4-44a1-627f-08d5ad2bf6ba","name":"AZ ARMATUREN DO BRASIL LTDA","commercialName":"","cnpj":"03674465000116","city":"ITATIBA","stateCode":"SP","buscaAdicional":"AZ ARMATUREN 54785 AZ ARMATUREN BR LTDA 906671"},{"id":"c430202a-1f8f-49ab-68ce-08d5ad2bf6ba","name":"INDUSTRIA DE PRODUTOS ALIMENTICIOS MAVALERIO LTDA","commercialName":"","cnpj":"62379037000120","city":"ITATIBA","stateCode":"SP","buscaAdicional":"MAVALERIO 60433 MAVALERIO ITATIBA 910876 MAVALERIO FABRICA 910877"},{"id":"91d6c101-bca0-4fc7-8879-08d5ae44ed50","name":"LINHASITA INDUSTRIA DE LINHAS PARA COSER LTDA","commercialName":"","cnpj":"46645768000113","city":"ITATIBA","stateCode":"SP","buscaAdicional":"LINHASITA VAREJISTA 7863"},{"id":"e92c63d1-eb99-43e9-67a8-08d5ad2bf6ba","name":"INDUSTRIA TEXTIL NOSSA SENHORA DO BELEM LTDA","commercialName":"","cnpj":"50115823000130","city":"ITATIBA","stateCode":"SP","buscaAdicional":"TEXTIL BELEM 58399 IND TEX N SRA BELEM 908280"},{"id":"35143d10-5ff4-46eb-6726-08d5ad2bf6ba","name":"TERA METAIS ALUMINIO LTDA.","commercialName":"","cnpj":"11859487000189","city":"ITATIBA","stateCode":"SP","buscaAdicional":"TERA 57980 TERA ITATIBA 909691"},{"id":"830e8333-8720-42aa-725e-08d5cf600bef","name":"CENTROVIAS SISTEMAS RODOVIARIOS S/A","commercialName":"CENTROVIAS","cnpj":"02555926000179","city":"ITIRAPINA","stateCode":"SP","buscaAdicional":""},{"id":"65cb2ec3-5ca8-4935-727e-08d5cf600bef","name":"RODOVIAS DAS COLINAS S/A","commercialName":"","cnpj":"03025305000146","city":"ITU","stateCode":"SP","buscaAdicional":""},{"id":"0d6f34d3-c177-4682-6753-08d5ad2bf6ba","name":"FIDELITY SERVICOS E CONTACT CENTER S.A.","commercialName":"","cnpj":"23532312000575","city":"ITU","stateCode":"SP","buscaAdicional":"FIDELITY ITU 58045 FIDELITY ITU 891842"},{"id":"2d727daf-537f-495a-65b2-08d5ad2bf6ba","name":"BRAVOX S A INDUSTRIA E COMERCIO ELETRONICO","commercialName":"","cnpj":"60854833000141","city":"ITU","stateCode":"SP","buscaAdicional":"BRAVOX 56950 BRAVOX S.A. IND&COM 907459"},{"id":"686719d9-bcf4-4856-6616-08d5ad2bf6ba","name":"PORCHER DO BRASIL TECIDOS DE VIDRO LTDA","commercialName":"PORCHER","cnpj":"47820592000151","city":"ITU","stateCode":"SP","buscaAdicional":"PORCHER 57300 PORCHER 908677"},{"id":"cb781261-56f5-4087-6677-08d5ad2bf6ba","name":"STARRETT INDUSTRIA E COMERCIO LTDA","commercialName":"","cnpj":"56994700000101","city":"ITU","stateCode":"SP","buscaAdicional":"STARRETT 57587 STARRET IND COM LTDA 908180"},{"id":"ccd778bb-4d0e-416d-68b3-08d5ad2bf6ba","name":"COMPANHIA ITUANA DE SANEAMENTO - CIS","commercialName":"CIS","cnpj":"26938926000116","city":"ITU","stateCode":"SP","buscaAdicional":"CIS 60306 CIS PCA MAL RONDON 890483 CIS - EST MUNICIPAL 890484 CIS RDV SALTO ITU 890485 CIS EST PAU DALHO 890486 CIS AV MONCOES 890488 CIS PCA JULIO MESQ 890894"},{"id":"5868c1aa-ae91-444f-6824-08d5ad2bf6ba","name":"SAKURA TECH BRASIL FERRAMENTARIA E MOLDAGEM PLASTICA EIRELI","commercialName":"SAKURA TECH BRASIL FERRAMENTARIA E MOLD. PLASTICA LTDA.","cnpj":"13233468000178","city":"ITU","stateCode":"SP","buscaAdicional":"SAKURA TECH 59417 SAKURA TECH 908692"},{"id":"001142b6-f756-4b1b-6255-08d5ad2bf6ba","name":"AISIN AUTOMOTIVE LTDA.","commercialName":"","cnpj":"14011603000101","city":"ITU","stateCode":"SP","buscaAdicional":"AISIN 54687 AISIN AUTOMOTIVE LTD 905979"},{"id":"1d543499-a172-4066-62d5-08d5ad2bf6ba","name":"SUMITOMO INDUSTRIAS PESADAS DO BRASIL LTDA.","commercialName":"","cnpj":"12525361000130","city":"ITU","stateCode":"SP","buscaAdicional":"SUMITOMO 54985 SUMITOMO - ITU - SP 905985"},{"id":"dad00a21-7136-4881-61f3-08d5ad2bf6ba","name":"ACOKORTE IND METALURGICA E COMERCIO LTDA","commercialName":"","cnpj":"66081894000108","city":"ITU","stateCode":"SP","buscaAdicional":"ACOKORTE 54484 ACOKORTE 905154"},{"id":"c04f8809-027a-4f97-617f-08d5ad2bf6ba","name":"I.F.C. INDUSTRIA E COMERCIO DE CONDUTORES ELETRICOS LTDA","commercialName":"","cnpj":"02544042000119","city":"ITU","stateCode":"SP","buscaAdicional":"IFC COBRECOM 54212 IFC 2036282070 904234 IFC 33095540 904188"},{"id":"ba1fb114-3fb0-4a24-6466-08d5ad2bf6ba","name":"IPS EMPREENDIMENTOS S/A","commercialName":"ITU PLAZA SHOPPING","cnpj":"03140367000107","city":"ITU","stateCode":"SP","buscaAdicional":"PLAZA SHOPPING ITU 55977 PLAZA SHOP ITU 905159"},{"id":"3f7ebd7c-2f18-4973-63ac-08d5ad2bf6ba","name":"VISCOFAN DO BRASIL SOCIEDADE COMERCIAL E IND. LTDA.","commercialName":"","cnpj":"65019655000238","city":"ITU","stateCode":"SP","buscaAdicional":"VISCOFAN ITU 55512 VISCOFAN DO BR SOC 907216"},{"id":"4164f198-9933-4a9a-5eea-08d5ad2bf6ba","name":"EMICOL ELETRO ELETRONICA S.A.","commercialName":"","cnpj":"61685723000166","city":"ITU","stateCode":"SP","buscaAdicional":"EMICOL 52608 EMICOL ELETRO 899835"},{"id":"7885bb72-e534-4e10-5c18-08d5ad2bf6ba","name":"INPET BRASIL EMBALAGENS PLASTICAS S.A.","commercialName":"INPET","cnpj":"06539526000120","city":"ITU","stateCode":"SP","buscaAdicional":"INPET BRASIL 51081 INPET BRASIL ITU 898811"},{"id":"5d2505fd-dfca-4284-582f-08d5ad2bf6ba","name":"GUARANY INDUSTRIA E COMERCIO LTDA","commercialName":"GUARANY","cnpj":"61089835000154","city":"ITU","stateCode":"SP","buscaAdicional":"GUARANY 10911 GUARANY 889637"},{"id":"8b890d50-0fcf-49a5-5140-08d5ad2bf6ba","name":"INDUSTRIAS MANGOTEX LTDA","commercialName":"INDUSTRIAS MANGOTEX","cnpj":"00841654000148","city":"ITU","stateCode":"SP","buscaAdicional":"MANGOTEX 2073 MANGOTEX MTZ ITU 70555"},{"id":"a244e45b-a10d-41cf-5103-08d5ad2bf6ba","name":"ELETRICIDADE SAO PEDRO LTDA","commercialName":"","cnpj":"05992709000134","city":"ITU","stateCode":"SP","buscaAdicional":"SAO PEDRO 1947 SAO PEDRO (S PEDRO) 8297 PCH.PH.SP.027096-2.01"},{"id":"79cc5db1-80ca-4c78-501c-08d5ad2bf6ba","name":"HNK BR INDUSTRIA DE BEBIDAS LTDA.","commercialName":"","cnpj":"50221019000136","city":"ITU","stateCode":"SP","buscaAdicional":"HEINEKEN ITU 1448 ETC SCHIN ITU 88KV 7372 SCHINCARIOL-IGREJINH 70047 SCHINCARIOL - RECIFE 72334 SCHINCARIOL ALEXANIA 888129 SCHINCARIOL BA 70666"},{"id":"0e314386-7cdd-4424-55a0-08d5ad2bf6ba","name":"HYDRO EXTRUSION BRASIL S/A","commercialName":"","cnpj":"50155134000150","city":"ITU","stateCode":"SP","buscaAdicional":"SAPA 5901 HYDRO I 72220 HYDRO II 72320 HYDRO III 72321"},{"id":"e0edfb0a-bfc2-49a3-5671-08d5ad2bf6ba","name":"ESTRUTURAL BLOCOS E TELHAS LTDA.","commercialName":"","cnpj":"02577442000120","city":"ITU","stateCode":"SP","buscaAdicional":"ESTRUTURAL 7100 ESTRUTURAL-EMICL-ITU 72257 ESTRUTURAL BLOCOS 907603"},{"id":"97dc144e-75e0-414f-5676-08d5ad2bf6ba","name":"DYNATECH INDUSTRIAS QUIMICAS LTDA","commercialName":"DYNATECH","cnpj":"09054341000114","city":"ITUPEVA","stateCode":"SP","buscaAdicional":"DYNATECH 7105 DYNATECH ITUPEVA 72067"},{"id":"13abbe1f-aa3a-49f2-576a-08d5ad2bf6ba","name":"ROCHLING PLASTICOS DE ENGENHARIA DO BRASIL LTDA","commercialName":"","cnpj":"14359842000149","city":"ITUPEVA","stateCode":"SP","buscaAdicional":"ROCHLING 8812 ROCHLING 888605"},{"id":"9e4e4407-c785-440f-5543-08d5ad2bf6ba","name":"MFG COMERCIALIZADORA DE ENERGIA LTDA.","commercialName":"MFG ENERGIA","cnpj":"13076126000191","city":"ITUPEVA","stateCode":"SP","buscaAdicional":"MFG 5213"},{"id":"e1ef2e94-34fc-45af-5305-08d5ad2bf6ba","name":"CONDOMINIO CIVIL VOLUNTARIO DO OUTLET PREMIUM SAO PAULO","commercialName":"","cnpj":"10830864000194","city":"ITUPEVA","stateCode":"SP","buscaAdicional":"SHOP PREMIUM 3437 SHOP PREMIUM-ITUPEVA 71281"},{"id":"edd93bc3-aed3-4ecc-59db-08d5ad2bf6ba","name":"B B C INDUSTRIA E COMERCIO LTDA","commercialName":"","cnpj":"53350047000141","city":"ITUPEVA","stateCode":"SP","buscaAdicional":"BBC 15675 BBC 894887"},{"id":"61c1fd70-9a9d-427f-5fbb-08d5ad2bf6ba","name":"SORVETES JUNDIA INDUSTRIA E COMERCIO LTDA","commercialName":"SORVETES JUNDIA","cnpj":"05058229000109","city":"ITUPEVA","stateCode":"SP","buscaAdicional":"JUNDIA 53202 JUNDIA 903761 CD JUNDIA 908904"},{"id":"29ec3ec0-e0c8-4c11-5c9f-08d5ad2bf6ba","name":"CPQ BRASIL S/A","commercialName":"","cnpj":"74552068000110","city":"ITUPEVA","stateCode":"SP","buscaAdicional":"CPQ BRASIL 51430 CPQ BRASIL 898310"},{"id":"46e1102f-6a32-44ed-5da4-08d5ad2bf6ba","name":"FINEPACK INDUSTRIA TECNICA DE EMBALAGENS LIMITADA","commercialName":"FINEPACK","cnpj":"67867762000160","city":"ITUPEVA","stateCode":"SP","buscaAdicional":"FINEPACK 51943 FINEPACK 898784"},{"id":"91c12add-520f-4265-5de9-08d5ad2bf6ba","name":"PLASTAMP - INDUSTRIA E COMERCIO DE PLASTICOS LTDA","commercialName":"","cnpj":"53513230000544","city":"ITUPEVA","stateCode":"SP","buscaAdicional":"PLASTAMP 52066 PLASTAMP 903787 PLASTAMP 903797"},{"id":"da281128-e6dc-4592-6408-08d5ad2bf6ba","name":"SCHOTT BRASIL LTDA","commercialName":"DIVISAO EMBALAGENS","cnpj":"33144437000581","city":"ITUPEVA","stateCode":"SP","buscaAdicional":"SCHOTT BRA 55795 SCHOTT BRASIL LTDA 907217"},{"id":"f7ed5e09-6995-4f2f-646d-08d5ad2bf6ba","name":"KNORR-BREMSE BRASIL (HOLDING) ADMINISTRACAO E PARTICIPACAO LTDA","commercialName":"","cnpj":"62662531000105","city":"ITUPEVA","stateCode":"SP","buscaAdicional":"KNORR BREMSE 56003 KNORR BREMSE ITUPEVA 906608"},{"id":"1277cf49-ef92-4a16-657b-08d5ad2bf6ba","name":"KOLPLAST C I S.A.","commercialName":"KOLPLAST","cnpj":"59231530000193","city":"ITUPEVA","stateCode":"SP","buscaAdicional":"KOLPLAST 56740 KOLPLAST CI 909684"},{"id":"ed11c450-4c13-4338-6557-08d5ad2bf6ba","name":"SENPAR TERRAS DE SAO JOSE EMPREENDIMENTOS TURISTICOS LT","commercialName":"SENTER","cnpj":"50363803000774","city":"ITUPEVA","stateCode":"SP","buscaAdicional":"SENPAR 1 56659 SENPAR TERRAS DE SJ 905764"},{"id":"9fc02dce-abd0-453c-6198-08d5ad2bf6ba","name":"COMEP INDUSTRIA E COMERCIO LTDA","commercialName":"","cnpj":"00641088000120","city":"ITUPEVA","stateCode":"SP","buscaAdicional":"COMEP MATRIZ 54257 COMEP FILIAL 903846 COMEP MATRIZ 903869"},{"id":"fc9e46ad-29b5-4169-615b-08d5ad2bf6ba","name":"BOSAL DO BRASIL LTDA.","commercialName":"BOSAL","cnpj":"56993868000194","city":"ITUPEVA","stateCode":"SP","buscaAdicional":"BOSAL 54146 BOSAL 905927"},{"id":"88fe820e-a7ec-4fc0-6713-08d5ad2bf6ba","name":"LINDAL DO BRASIL LTDA","commercialName":"","cnpj":"02679339000191","city":"ITUPEVA","stateCode":"SP","buscaAdicional":"LINDAL 57948 LINDAL DO BRASIL 910016"},{"id":"30fbe5ee-cb53-445f-66bc-08d5ad2bf6ba","name":"VTC TECNOLOGIA DE VIDROS TEMPERADOS EIRELI","commercialName":"VTC TECNOLOGIA DE VIDROS","cnpj":"05739900000179","city":"ITUPEVA","stateCode":"SP","buscaAdicional":"VTC VIDROS 57769 VTC MATRIZ 908992 VTC FILIAL 909192"},{"id":"7ee9b2ae-a09e-4502-7218-08d5cf600bef","name":"SERRA AZUL WATER PARK S/A","commercialName":"","cnpj":"00545378000170","city":"ITUPEVA","stateCode":"SP","buscaAdicional":""},{"id":"bb36a449-c1ee-4cf1-5f2b-08d5ad2bf6ba","name":"INDUSTRIA E COM.SANTA MARIA LTDA","commercialName":"","cnpj":"49211717000171","city":"ITUVERAVA","stateCode":"SP","buscaAdicional":"SANTA MARIA IND 52824 SANTA MARIA IND 903860"},{"id":"e2fe1dc5-4f70-49bb-50e4-08d5ad2bf6ba","name":"TERMOELETRICA SANTA ADELIA LTDA","commercialName":"","cnpj":"04710129000144","city":"JABOTICABAL","stateCode":"SP","buscaAdicional":"TESA 1885 SANTA ADELIA 532 UTE.AI.SP.027343-0.01"},{"id":"757eb1d3-c148-4c4f-4f96-08d5ad2bf6ba","name":"FIBRIA CELULOSE S/A","commercialName":"","cnpj":"60643228017440","city":"JACAREÍ","stateCode":"SP","buscaAdicional":"FIBRIA JACAREI 1175 VCP JACARE 145"},{"id":"53863e35-c439-4c83-4fb4-08d5ad2bf6ba","name":"CEBRACE CRISTAL PLANO LTDA","commercialName":"CEBRACE","cnpj":"45070190000151","city":"JACAREÍ","stateCode":"SP","buscaAdicional":"CEBRACE 1243 CEBRACE CACAPAVA 7555 CEBRAC JAC 70436 CEBRACE BARRA VELHA 70337"},{"id":"b53be1bb-127b-471b-57a3-08d5ad2bf6ba","name":"SAINT-GOBAIN DO BRASIL PRODUTOS INDUSTRIAIS E PARA CONSTRUCAO LTDA","commercialName":"","cnpj":"61064838001296","city":"JACAREÍ","stateCode":"SP","buscaAdicional":"SGBRAS JACAREI 9271 SAINT GOBAIN JACAREI 888825"},{"id":"585c51a1-2169-4b50-6023-08d5ad2bf6ba","name":"CAOA CHERY AUTOMOVEIS LTDA.","commercialName":"","cnpj":"12637366000155","city":"JACAREÍ","stateCode":"SP","buscaAdicional":"CHERY 53399 CHERY JACAREI SP 900019"},{"id":"925d6fe9-8547-465f-5de5-08d5ad2bf6ba","name":"IKK DO BRASIL INDUSTRIA E COMERCIO LTDA","commercialName":"","cnpj":"43812411000275","city":"JACAREÍ","stateCode":"SP","buscaAdicional":"IKK DO BRASIL 52059 IKK DO BRASIL 899828"},{"id":"3490edc4-e780-4b32-5d36-08d5ad2bf6ba","name":"TARKETT BRASIL REVESTIMENTOS LTDA","commercialName":"TARKETT","cnpj":"61452199000345","city":"JACAREÍ","stateCode":"SP","buscaAdicional":"TARKETT 51736 TARKETT JACAREI 899363"},{"id":"59bbd8cd-3665-4fda-5acd-08d5ad2bf6ba","name":"CERVEJARIAS KAISER BRASIL S.A.","commercialName":"ESCRITORIO ADMINISTRATIVO","cnpj":"19900000000176","city":"JACAREÍ","stateCode":"SP","buscaAdicional":"HEINEKEN 50246 KAISER BRASIL 897067 HEINEKEN PACATUBA 899594 HEINEKEN PONTA GROS 900434"},{"id":"607dbb95-5fbf-48d4-6153-08d5ad2bf6ba","name":"ADATEX S A INDUSTRIAL E COMERCIAL","commercialName":"ADATEX","cnpj":"50464734000108","city":"JACAREÍ","stateCode":"SP","buscaAdicional":"ADATEX 54127 ADATEX 904117 ADATEX JACAREI 906900"},{"id":"c24577c8-d9af-471f-633f-08d5ad2bf6ba","name":"LANOBRASIL INDUSTRIA E COMERCIO DE PRODUTOS TEXTEIS LTDA","commercialName":"LANOBRASIL","cnpj":"47539028000165","city":"JACAREÍ","stateCode":"SP","buscaAdicional":"LANOBRASIL 55270 LANOBRASIL JACAREI 906706"},{"id":"94e144d2-d860-4d49-64a7-08d5ad2bf6ba","name":"WANA INDUSTRIA E COMERCIO DE PRODUTOS QUIMICOS LTDA","commercialName":"","cnpj":"07009769000209","city":"JACAREÍ","stateCode":"SP","buscaAdicional":"WANA QUIMICOS 56144 WANA QUIMICO JACAREI 905989"},{"id":"2bda3ec5-6713-4989-64ce-08d5ad2bf6ba","name":"FREUDENBERG NAO-TECIDOS LTDA.","commercialName":"","cnpj":"62174644000153","city":"JACAREÍ","stateCode":"SP","buscaAdicional":"FREUDENBERG NAO TECIDOS 56230 FREUNDENBERG JACAREI 904907"},{"id":"962369ae-d647-4497-631e-08d5ad2bf6ba","name":"HEVEA-TEC INDUSTRIA E COMERCIO LTDA.","commercialName":"HEVEA - TEC","cnpj":"03083960000150","city":"JACI","stateCode":"SP","buscaAdicional":"HEVEATEC 55175 HEVEA TEC 225 907278 HEVEA TEC 376 907293 HEVEA TEC 226 907294"},{"id":"e5583d13-c168-4545-6648-08d5ad2bf6ba","name":"LUKALIAM MOVEIS LTDA","commercialName":"","cnpj":"00025372000172","city":"JACI","stateCode":"SP","buscaAdicional":"LUKALIAM 57463 LUKALIAM MOVEIS LTDA 908578"},{"id":"034c2caa-4da2-4ebd-666f-08d5ad2bf6ba","name":"MAHLE COMPRESSORES DO BRASIL LTDA.","commercialName":"","cnpj":"20985558000180","city":"JAGUARIÚNA","stateCode":"SP","buscaAdicional":"MAHLE COMPRESSORES 57570 MAHLE JAGUARIUNA 908914"},{"id":"7dfa879d-6832-45ca-66ac-08d5ad2bf6ba","name":"INSTITUTO EDUCACIONAL JAGUARY LTDA","commercialName":"IEJ","cnpj":"03211847000103","city":"JAGUARIÚNA","stateCode":"SP","buscaAdicional":"FAJ 57739 IEJ FAJ CAMPUS I 909267 IEJ FAJ CAMPUS II 909268"},{"id":"ae06d335-8cc6-4c6f-66fc-08d5ad2bf6ba","name":"CRYOVAC BRASIL LTDA","commercialName":"","cnpj":"02178092000804","city":"JAGUARIÚNA","stateCode":"SP","buscaAdicional":"SEALED AIR CRYOVAC 57909 CRYOVAC BRASIL 909715"},{"id":"61a796fe-f454-48b4-67fa-08d5ad2bf6ba","name":"JAGUARPACK INDUSTRIA E COMERCIO DE PLASTICOS LTDA.","commercialName":"","cnpj":"23762865000190","city":"JAGUARIÚNA","stateCode":"SP","buscaAdicional":"JAGUARPACK 59113 JAGUAR 71176"},{"id":"437d6ddb-f5ae-4010-6280-08d5ad2bf6ba","name":"UNICHARM DO BRASIL INDUSTRIA E COMERCIO DE PRODUTOS DE HIGIENE LTDA.,","commercialName":"","cnpj":"13884068000122","city":"JAGUARIÚNA","stateCode":"SP","buscaAdicional":"UNICHARM 54786 UNICHARM 906904"},{"id":"66fca942-f46a-4cbf-5ea2-08d5ad2bf6ba","name":"PAPEIS AMALIA LTDA","commercialName":"","cnpj":"46031357000138","city":"JAGUARIÚNA","stateCode":"SP","buscaAdicional":"TERUEL 52469 TERUEL 903765"},{"id":"2df9b970-7ad3-4170-5ea9-08d5ad2bf6ba","name":"SMR AUTOMOTIVE BRASIL LTDA.","commercialName":"","cnpj":"11554758000198","city":"JAGUARIÚNA","stateCode":"SP","buscaAdicional":"SMR 52476 SMR JAGUARIUNA 900058"},{"id":"c6b453db-8d7f-4fd3-4f18-08d5ad2bf6ba","name":"PAULISTA LAJEADO ENERGIA S/A","commercialName":"","cnpj":"03491603000121","city":"JAGUARIÚNA","stateCode":"SP","buscaAdicional":"CPFL LAJEADO 89 LAJEADO CPFL 8291 UHE.PH.TO.001304-8.01"},{"id":"33572b8c-ee73-4f25-4f1e-08d5ad2bf6ba","name":"CPFL PLANALTO LTDA","commercialName":"","cnpj":"02150562000147","city":"JAGUARIÚNA","stateCode":"SP","buscaAdicional":"CPFL PLANALTO 98"},{"id":"d2186314-b070-43d2-4f0b-08d5ad2bf6ba","name":"COMPANHIA JAGUARI DE ENERGIA","commercialName":"CPFL SANTA CRUZ","cnpj":"53859112000169","city":"JAGUARIÚNA","stateCode":"SP","buscaAdicional":"CPFL JAGUARI 63 CPFL JAGUARI 32 CLFSC 47 CPFL STA CRUZ DITCSP 72303 CPFL MOCOCA 36 CPFL LESTE PTA 34 CPFL SUL PTA 33"},{"id":"b3697f2f-4180-40bb-5364-08d5ad2bf6ba","name":"JAGUAR INDUSTRIA E COMERCIO DE PLASTICOS LTDA","commercialName":"JAGUAR PLASTICO","cnpj":"48839872000174","city":"JAGUARIÚNA","stateCode":"SP","buscaAdicional":"JAGUAR 3609 JAGUAR INDUSTRIA 896724"},{"id":"36a22596-31fb-48db-56c1-08d5ad2bf6ba","name":"FRIOPART ARMAZENS FRIGORIFICOS LTDA.","commercialName":"","cnpj":"14605065000175","city":"JANDIRA","stateCode":"SP","buscaAdicional":"FRIOPART 7600 FRIOPART SBCPO 899412 FRIOPART JANDIRA 899413"},{"id":"edec0b71-7c13-45f2-5e7a-08d5ad2bf6ba","name":"METALURGICA SAO RAPHAEL LTDA","commercialName":"","cnpj":"61370615000102","city":"JANDIRA","stateCode":"SP","buscaAdicional":"MET S.RAPHAEL 52398 MET SAO RAPHAEL 904337"},{"id":"2745042e-9dfc-4dcf-580a-08d5ad2bf6ba","name":"SAINT-GOBAIN DO BRASIL PRODUTOS INDUSTRIAIS E PARA CONSTRUCAO LTDA","commercialName":"","cnpj":"61064838003400","city":"JANDIRA","stateCode":"SP","buscaAdicional":"SGBRAS JANDIRA 10489 SAINT GOBAIN JANDIRA 889624"},{"id":"5f48f829-0dab-4cba-8832-08d5ae44ed50","name":"ACOTECNICA S/A INDUSTRIA E COMERCIO","commercialName":"","cnpj":"59451724000102","city":"JANDIRA","stateCode":"SP","buscaAdicional":"ACOTECNICA 1270 ACOTECNICA-JANDIRA 7801"},{"id":"129e7fc5-38be-450f-666a-08d5ad2bf6ba","name":"GE OIL & GAS DO BRASIL LTDA","commercialName":"","cnpj":"05635291000108","city":"JANDIRA","stateCode":"SP","buscaAdicional":"GE JANDIRA 57550 GE JANDIRA 908362"},{"id":"861036a5-a393-424b-652d-08d5ad2bf6ba","name":"ARTEMPER INDUSTRIA E COMERCIO DE VIDROS LTDA","commercialName":"ARTEMPER VIDROS TEMPERADOS","cnpj":"03956636000108","city":"JARDINÓPOLIS","stateCode":"SP","buscaAdicional":"ARTEMPER 56576 ARTEMPER VIDROS LTDA 907256"},{"id":"1ac5766d-f955-4a04-5d03-08d5ad2bf6ba","name":"CINBOR INDUSTRIA DE PNEUS - EIRELI","commercialName":"CINBORG","cnpj":"01480091000172","city":"JARDINÓPOLIS","stateCode":"SP","buscaAdicional":"CINBORG PNEUS 51677 CINBOR 899317"},{"id":"975f853b-f13a-4465-53b7-08d5ad2bf6ba","name":"SOGEFI FILTRATION DO BRASIL LTDA","commercialName":"SOGEFI","cnpj":"66975699000113","city":"JARINU","stateCode":"SP","buscaAdicional":"SOGEFI MATEUS LEME 3795 SOGEFI ML 71312 SOGEFI JARINU 901200 SOGEFI SBC 71421"},{"id":"e0f2fd12-0e70-4503-6700-08d5ad2bf6ba","name":"NATURAL ONE S.A.","commercialName":"","cnpj":"08192116000343","city":"JARINU","stateCode":"SP","buscaAdicional":"NATURAL ONE 57916 NATURA ONE JARINU 909973"},{"id":"8392602f-36a3-44ea-66ef-08d5ad2bf6ba","name":"I. J. MAZZEI INDUSTRIA PLASTICA EIRELI","commercialName":"","cnpj":"06288733000150","city":"JAÚ","stateCode":"SP","buscaAdicional":"UTILIPLAST 57890 UTILIPLAST MATRIZ 909667 UTILIPLAST FL 1 909669"},{"id":"4372790e-fcb1-4a28-6947-08d5ad2bf6ba","name":"FUNDACAO DOUTOR AMARAL CARVALHO","commercialName":"","cnpj":"50753755000135","city":"JAÚ","stateCode":"SP","buscaAdicional":"HAC JAHU 60956 HAC JAHU 911813"},{"id":"fdd67c22-08b7-4a67-67ce-08d5ad2bf6ba","name":"EMBRASIL IMPRESSORA LTDA","commercialName":"","cnpj":"04948053000190","city":"JAÚ","stateCode":"SP","buscaAdicional":"EMBRASIL IMPRESSORA 58645 EMBRASIL IMPRESSORA 910398"},{"id":"c1d43273-f0d9-458c-6236-08d5ad2bf6ba","name":"SUPERMERCADOS FURLANETTI LTDA","commercialName":"","cnpj":"50751908000105","city":"JAÚ","stateCode":"SP","buscaAdicional":"SUPERMERCADOS FURLANETTI 54623 FURLANETTI LOJA 01 907814 FURLANETTI LOJA 02 907815 FURLANETTI LOJA 03 907817"},{"id":"9bac9431-467e-4d96-61f0-08d5ad2bf6ba","name":"ASSOCIACAO CONDOMINIO JAU SHOPPING CENTER","commercialName":"","cnpj":"51526309000150","city":"JAÚ","stateCode":"SP","buscaAdicional":"JAU SHOPPING 54475 JAU SHOPPING 907316"},{"id":"ff081da9-9ffe-4275-61ae-08d5ad2bf6ba","name":"SANEJ - SANEAMENTO DE JAU LTDA","commercialName":"SANEJ - SANEAMENTO DE JAU","cnpj":"03708169000199","city":"JAÚ","stateCode":"SP","buscaAdicional":"SANEJ 54338 SANEJ JAU LTDA 906651"},{"id":"5bfe575f-b741-418b-61b5-08d5ad2bf6ba","name":"AGUAS DE JAHU S/A","commercialName":"","cnpj":"20918034000177","city":"JAÚ","stateCode":"SP","buscaAdicional":"AGUAS DE JAHU 54346 CAPTACAO PAINEIRAS 905103 JAHU ETA 1 905104 RP4 SANTO ANTONIO 905105 RP8 POCO NOVA JAHU 905106"},{"id":"9c260ea4-9a06-4a2f-61da-08d5ad2bf6ba","name":"RECICLAVEL INDUSTRIA E COMERCIO DE EMBALAGENS EIRELI","commercialName":"RECICLAVEL","cnpj":"74278219000193","city":"JAÚ","stateCode":"SP","buscaAdicional":"RECICLAVEL INDUSTRIA 54448 RECICLAVEL - JAU 905127"},{"id":"98abbf2e-565a-415e-56a7-08d5ad2bf6ba","name":"CARTONAGEM JAUENSE LTDA","commercialName":"CARTONAGEM JAUENSE","cnpj":"50748748000145","city":"JAÚ","stateCode":"SP","buscaAdicional":"CARTONAGEM 7441 CARTONAGEM JAUENSE 72217"},{"id":"b5590a68-6001-460c-6075-08d5ad2bf6ba","name":"SUPERMERCADOS JAU SERVE LTDA","commercialName":"JAU SERVE","cnpj":"03640467000194","city":"JAÚ","stateCode":"SP","buscaAdicional":"JAU SERVE 53516 JAU SERVE LJ 19 905977 JAU SERVE LOJA 03 905997 JAU SERVE LOJA 04 905999 JAU SERVE LOJA 06 906000 JAU SERVE LOJA 12 906001 JAU SERVE LOJA 18 906003 JAU SERVE LOJA 21 906005 JAU SERVE LOJA 22 906006 JAU SERVE LOJA 25 906008 JAU SERVE LOJA 15 906009 JAU SERVE LOJA 16 906010 JAU SERVE LOJA 30 906011 JAU SERVE LOJA 11 906022 JAU SERVE LOJA 01 906024 JAU SERVE MATRIZ 906026 JAU SERVE LOJA 07 906028 JAU SERVE LOJA 08 906029 JAU SERVE LOJA 02 906030 JAU SERVE LOJA 13 906032 JAU SERVE LOJA 14 906033 JAU SERVE LOJA 17 906034 JAU SERVE LOJA 20 906037 JAU SERVE LOJA 23 906042 JAU SERVE LOJA 26 906045 JAU SERVE LOJA 31 906601 JAU SERVE LOJA 24 907074 JAU SERVE 34 909441 JAU SERVE LOJA 9 909848 JAU SERVE LOJA 10 909849 JAU SERVE LOJA 32 909850 JAU SERVE LOJA 5 909862 JAU SERVE LOJA 28 909875 JAU SERVE - LJ27 910386 JAU SERVE LOJA 33 910880"},{"id":"8813f0ff-3bfa-4b81-6077-08d5ad2bf6ba","name":"TOFFANO PRODUTOS ALIMENTICIOS LTDA","commercialName":"BALAS TOFFANO","cnpj":"50747922000135","city":"JAÚ","stateCode":"SP","buscaAdicional":"TOFFANO 53518 TOFFANO 905114"},{"id":"f7f7ce91-15e3-4e14-59d0-08d5ad2bf6ba","name":"COSAN BIOMASSA S/A","commercialName":"","cnpj":"12489586000260","city":"JAÚ","stateCode":"SP","buscaAdicional":"COSAN BIOMASSA 15635 COSAN BIOMASSA 895441"},{"id":"22859ef6-5327-461d-59c4-08d5ad2bf6ba","name":"ENEX RENOVAVEIS COMERCIALIZADORA DE ENERGIA LTDA.","commercialName":"ENEX RENOVAVEIS COMERCIALIZADORA DE ENERGIA LTDA.","cnpj":"18822520000145","city":"JUNDIAÍ","stateCode":"SP","buscaAdicional":"ENEX RENOVAVEIS 15497"},{"id":"4286f3ba-5253-4676-5805-08d5ad2bf6ba","name":"CASTELO ALIMENTOS S/A","commercialName":"CASTELO","cnpj":"07814284000107","city":"JUNDIAÍ","stateCode":"SP","buscaAdicional":"CASTELO ALIM 10430 CASTELO ALIMENTOS 889499"},{"id":"6e78f6b1-137c-4be8-57f7-08d5ad2bf6ba","name":"FIACAO FIDES LTDA","commercialName":"","cnpj":"50391150000141","city":"JUNDIAÍ","stateCode":"SP","buscaAdicional":"FIACAO FIDES 10309 FIACAO FIDES JUNDIAI 889258 FIACAO FIDES 903553"},{"id":"a65ce4c5-f6ae-4964-58b2-08d5ad2bf6ba","name":"SAINT-GOBAIN DISTRIBUICAO BRASIL LTDA","commercialName":"","cnpj":"03840986000104","city":"JUNDIAÍ","stateCode":"SP","buscaAdicional":"TELHANORTE CL 12912 TELHANORTE MARGINAL 891682 TELHANORTE TATUAPE 891683 TELHANORTE SANTO 891725 TELHANORTE GUARULHOS 892243 SG GUARULHOS 892342 TELHA N PRO MARGINAL 892407 TELHA RIBERAO PRETO 892408 SG OSASCO 892562 SG - S J CAMPOS 892582 SG IMIGRANTES 892924 SAINT-GOBAIN JUNDIAI 892970 TELHANORTE BELVEDERE 893242 TELHANORTE PAMPULHA 893243 TELHANORTE UBERLANDI 893244 SG TELHANORTE 893702 SG TAMBORE 893825 TELHA N - ARICANDUVA 894062 TELHANORTE SG CONTAG 894130 SG - ANHANGUERA 894184 SG - PRAIA GRANDE 894185 SG DOM PEDRO 894502 TELHANORTE SG ZONA 894788 TELHANORTE SG MORUMB 894804 TELHANORTE RODA VIVA 906393 TELHANORTE S CARLOS 908061 TELHANORTE RAPOSO 908206 TELHANORTE NOVO CLA 911551"},{"id":"645f04a9-06fd-45db-5884-08d5ad2bf6ba","name":"ROCA SANITARIOS BRASIL LTDA","commercialName":"","cnpj":"75801902000126","city":"JUNDIAÍ","stateCode":"SP","buscaAdicional":"ROCA SANIT 12132 ROCA SANTA LUZIA 71132 ROCA SERRA 71133 ROCA JUNDIAI 71208 ROCA-RECIFE 71514"},{"id":"1291bf53-f402-4adb-5a72-08d5ad2bf6ba","name":"ASTRA S A INDUSTRIA E COMERCIO","commercialName":"ASTRA S/A. INDUSTRIA E COMERCIO","cnpj":"50949528001666","city":"JUNDIAÍ","stateCode":"SP","buscaAdicional":"ASTRA II 49645 ASTRAII JUNDIAI 895664"},{"id":"71697621-e294-4002-5b4d-08d5ad2bf6ba","name":"MINERACAO JOANA LEITE LTDA","commercialName":"","cnpj":"57397150000106","city":"JUNDIAÍ","stateCode":"SP","buscaAdicional":"MINER J LEITE 50573 MINER J LEITE 898159"},{"id":"bb94ceb4-3755-4c52-5ae6-08d5ad2bf6ba","name":"SANCHEZ CANO LTDA","commercialName":"","cnpj":"03594123000196","city":"JUNDIAÍ","stateCode":"SP","buscaAdicional":"SANCHEZ CANO 50334 SANCHEZ CANO JUNDIAI 897490"},{"id":"b65cadcc-3946-422d-5be0-08d5ad2bf6ba","name":"ASTRA S A INDUSTRIA E COMERCIO","commercialName":"","cnpj":"50949528001313","city":"JUNDIAÍ","stateCode":"SP","buscaAdicional":"ASTRA VII 50970 ASTRA JUNDIAI SP 897787"},{"id":"bb203f49-875c-4d42-6046-08d5ad2bf6ba","name":"IRMAOS BOA LTDA","commercialName":"ARMAZEM SANTA ROSA","cnpj":"50948371000178","city":"JUNDIAÍ","stateCode":"SP","buscaAdicional":"IRMAOS BOA 53446 IRMAOS BOA UNID 2 904687 IRMAOS BOA UNID 3 904688 IRMAOS BOA UNID 7 904689 IRMAOS BOA UNID 6 904690 IRMAOS BOA JUNDIAI 904705 IRMAOS BOA UNID 5 904706 IRMAOS BOA UNID 4 905639 IRMAOS BOA UNID 8 912857"},{"id":"61e9023f-461c-4621-6013-08d5ad2bf6ba","name":"DAE SA - AGUA E ESGOTO","commercialName":"DAE","cnpj":"03582243000173","city":"JUNDIAÍ","stateCode":"SP","buscaAdicional":"DAE AGUA ESGOTO 53365 DAE AGUA E ESGOTO SP 902688"},{"id":"c17cdcfc-76c3-48d9-601d-08d5ad2bf6ba","name":"PLATLOG IMPORTACAO, LOGISTICA E DISTRIBUICAO LTDA","commercialName":"","cnpj":"02229804000192","city":"JUNDIAÍ","stateCode":"SP","buscaAdicional":"PLATLOG 53384 PLATLOG JUNDIAI 903863"},{"id":"ebf6667f-b3ea-4cbe-6086-08d5ad2bf6ba","name":"BERCAMP TEXTIL LTDA","commercialName":"","cnpj":"00225205000175","city":"JUNDIAÍ","stateCode":"SP","buscaAdicional":"BERCAMP 53578 BERCAMP 903818"},{"id":"8b1b0b3f-25de-42d4-5efb-08d5ad2bf6ba","name":"CLUBE JUNDIAIENSE","commercialName":"","cnpj":"50935683000147","city":"JUNDIAÍ","stateCode":"SP","buscaAdicional":"CLUBE JUNDIAIENSE 52679 CLUBE JUNDIAIENSE 900897"},{"id":"bb3948ec-70b7-4d0d-5eb6-08d5ad2bf6ba","name":"FEDRIGONI BRASIL PAPEIS LTDA","commercialName":"FEDRIGONI BRASIL","cnpj":"02364069000120","city":"JUNDIAÍ","stateCode":"SP","buscaAdicional":"ARCONVERT 52521 FEDRIGONI BRASIL 900079"},{"id":"e873fdef-c0ec-4ad5-5e2d-08d5ad2bf6ba","name":"CAVNIC SP PARTICIPACOES S/A.","commercialName":"","cnpj":"16834280000173","city":"JUNDIAÍ","stateCode":"SP","buscaAdicional":"CAVNIC 52250 CAVNIC PARTICIPACOES 900878"},{"id":"932f3207-3a22-4e6b-56b5-08d5ad2bf6ba","name":"COMPALEAD ELETRONICA DO BRASIL INDUSTRIA E COMERCIO LTDA.","commercialName":"","cnpj":"10142624000105","city":"JUNDIAÍ","stateCode":"SP","buscaAdicional":"COMPALEAD 7525 COMPALEAD-JUNDIAI 72272"},{"id":"cd1c04c9-ec87-44c4-56c8-08d5ad2bf6ba","name":"JMC - INDUSTRIA DE EMBALAGENS PLASTICAS LTDA","commercialName":"BOMIX","cnpj":"09029276000177","city":"JUNDIAÍ","stateCode":"SP","buscaAdicional":"JMC SP 7682 JMC SP 889389"},{"id":"c45a0047-a4a9-4438-56b7-08d5ad2bf6ba","name":"HELLERMANNTYTON LTDA","commercialName":"","cnpj":"62895792000167","city":"JUNDIAÍ","stateCode":"SP","buscaAdicional":"HELLERMANNTYTON 7527 HELLERMANNTYTON 889702"},{"id":"4eeb680f-ce21-41cb-55fd-08d5ad2bf6ba","name":"AMCOR RIGID PLASTICS DO BRASIL LTDA","commercialName":"","cnpj":"00245980000192","city":"JUNDIAÍ","stateCode":"SP","buscaAdicional":"AMCOR JUNDIAI 6490 AMCOR JUNDIAI 888387"},{"id":"2ee37924-01a1-4ec0-5628-08d5ad2bf6ba","name":"WEIR DO BRASIL LTDA.","commercialName":"","cnpj":"00212562001413","city":"JUNDIAÍ","stateCode":"SP","buscaAdicional":"WEIR 6697 WEIR BRASIL JUNDIAI 72194"},{"id":"3a4e50f7-2f4a-4253-55d2-08d5ad2bf6ba","name":"MACCAFERRI DO BRASIL LTDA","commercialName":"","cnpj":"43876960000122","city":"JUNDIAÍ","stateCode":"SP","buscaAdicional":"MACCAFERRI 6222 MACCFERRI-JUNDIAI 71983"},{"id":"3e8240e9-f8a0-4434-579b-08d5ad2bf6ba","name":"BRASMOLDE INDUSTRIA E COMERCIO DE PLASTICOS LTDA","commercialName":"BRASMOLDE","cnpj":"49467749000132","city":"JUNDIAÍ","stateCode":"SP","buscaAdicional":"BRASMOLDE 9169 BRASMOLDE 888853 SPBMDJENTR101 913342"},{"id":"73b64834-182e-499c-57bb-08d5ad2bf6ba","name":"ENGEPACK EMBALAGENS SAO PAULO S.A.","commercialName":"","cnpj":"59791962000159","city":"JUNDIAÍ","stateCode":"SP","buscaAdicional":"ENGEPACK 9509 ENGEPACK S FILHO 889117"},{"id":"a7e9cb08-17f7-4aaa-56fd-08d5ad2bf6ba","name":"GRAHAM PACKAGING DO BRASIL INDUSTRIA E COMERCIO LTDA.","commercialName":"","cnpj":"01728444000100","city":"JUNDIAÍ","stateCode":"SP","buscaAdicional":"GRAHAM PACKAGING 8100 GRAHAN 898992 GRAHAM DUQUE DE CAX 912752"},{"id":"2050c7f4-de04-4e6e-5718-08d5ad2bf6ba","name":"CRS BRANDS INDUSTRIA E COMERCIO LTDA","commercialName":"CRS BRANDS","cnpj":"50930072000106","city":"JUNDIAÍ","stateCode":"SP","buscaAdicional":"CERESER 8204 VITI CERESER 889081"},{"id":"050e1e70-c4cb-48d6-574e-08d5ad2bf6ba","name":"ECOFABRIL INDUSTRIA E COMERCIO LTDA","commercialName":"","cnpj":"00308527000188","city":"JUNDIAÍ","stateCode":"SP","buscaAdicional":"ECOFABRIL CL 8513 ECOFABRIL 889525"},{"id":"3476a711-1ff4-4631-53c5-08d5ad2bf6ba","name":"DURATEX S.A.","commercialName":"","cnpj":"97837181003162","city":"JUNDIAÍ","stateCode":"SP","buscaAdicional":"DECA LI 3834 DECA JUNDIAI 13KV 70062"},{"id":"f5082c68-d549-45a5-53ee-08d5ad2bf6ba","name":"ATMOSFERA GESTAO E HIGIENIZACAO DE TEXTEIS S.A.","commercialName":"","cnpj":"00886257000192","city":"JUNDIAÍ","stateCode":"SP","buscaAdicional":"ATMOSFERA 3925 ATMOSFERA 71369 ATMOSFERA DIADEMA 903383 ATMOSFERA ENG NOGUEI 905667 ATMOSFERA DOM SILVEI 905675 ATMOSFERA XEREM 908267"},{"id":"2f0dab5d-4f1c-4fc3-554d-08d5ad2bf6ba","name":"MAHLE METAL LEVE S.A.","commercialName":"","cnpj":"60476884003798","city":"JUNDIAÍ","stateCode":"SP","buscaAdicional":"MAHLE JUND 5289 MAHLE METAL -JUNDIAI 71792"},{"id":"795934e4-b08b-4c7b-5558-08d5ad2bf6ba","name":"APTAR DO BRASIL EMBALAGENS LTDA.","commercialName":"APTAR JUNDIAI","cnpj":"06148069000143","city":"JUNDIAÍ","stateCode":"SP","buscaAdicional":"GRAPHOCOLOR 5390 GRAPHCOLOR-JUNDIAI 71864"},{"id":"c00f0e42-2178-48c3-54c4-08d5ad2bf6ba","name":"ALBEA DO BRASIL EMBALAGENS LTDA.","commercialName":"","cnpj":"60760642000110","city":"JUNDIAÍ","stateCode":"SP","buscaAdicional":"ALBEA 4490 REXAM EMB.-JUNDIAI 71449 ALBEA-MOGI CRUZES 71619"},{"id":"c49dd5b9-eed0-4f05-534c-08d5ad2bf6ba","name":"CONDOMINIO MAXI SHOPPING JUNDIAI","commercialName":"","cnpj":"58387614000158","city":"JUNDIAÍ","stateCode":"SP","buscaAdicional":"MAXI SHOPPING 3566 MAXI SHOP JUNDIAI 71221"},{"id":"27649ce0-72ce-4eef-52f7-08d5ad2bf6ba","name":"CLOSURE SYSTEMS INTERNATIONAL (BRAZIL) SISTEMAS DE VEDACAO LTDA.","commercialName":"","cnpj":"09074885000148","city":"JUNDIAÍ","stateCode":"SP","buscaAdicional":"CSI 3381 CSI JUNDIAI 889826"},{"id":"20a3ea11-3f5f-417f-52ad-08d5ad2bf6ba","name":"BIGNARDI - INDUSTRIA E COMERCIO DE PAPEIS E ARTEFATOS LTDA.","commercialName":"BIGNARDI PAPEIS","cnpj":"61192522000127","city":"JUNDIAÍ","stateCode":"SP","buscaAdicional":"BIGNARDI 3218 BIGNARDI-JUNDIAI 70957 BIGNARDI - CAIEIRAS 901143"},{"id":"28b0c375-a8dc-4496-5273-08d5ad2bf6ba","name":"DURATEX S.A.","commercialName":"","cnpj":"97837181002271","city":"JUNDIAÍ","stateCode":"SP","buscaAdicional":"DECA LOUCAS 3064 DECA LOUCAS JUNDIAI 70808"},{"id":"d0a8582d-5d58-4bc7-5274-08d5ad2bf6ba","name":"DURATEX S.A.","commercialName":"","cnpj":"97837181002190","city":"JUNDIAÍ","stateCode":"SP","buscaAdicional":"DECA METAIS 3066 DECA METAIS JUNDIAI 70807"},{"id":"40bedb7a-b349-4980-513b-08d5ad2bf6ba","name":"BERRY DO BRASIL LTDA.","commercialName":"","cnpj":"04970016000269","city":"JUNDIAÍ","stateCode":"SP","buscaAdicional":"BERRY 2056 CLOPAY JUNDIAI SP 70429"},{"id":"5cbae8de-bb83-45a6-4faa-08d5ad2bf6ba","name":"PLASCAR INDUSTRIA DE COMPONENTES PLASTICOS LTDA","commercialName":"PLASCAR COMPONENTES PLASTICOS","cnpj":"50935576000119","city":"JUNDIAÍ","stateCode":"SP","buscaAdicional":"PLASCAR 1217 PLASCAR JUNDIAI 7585 PLASCAR VARGINH LIVR 70349 PLASCAR BETIM MG 70421"},{"id":"bb20b03c-58b2-456a-4f74-08d5ad2bf6ba","name":"IBG INDUSTRIA BRASILEIRA DE GASES LTDA","commercialName":"","cnpj":"67423152000178","city":"JUNDIAÍ","stateCode":"SP","buscaAdicional":"IBG 1112 IBG JUNDIAI SP 7493"},{"id":"a5fd5123-1a2f-4ca4-50e5-08d5ad2bf6ba","name":"TAKATA BRASIL LTDA","commercialName":"TAKATA BRASIL","cnpj":"59106245000140","city":"JUNDIAÍ","stateCode":"SP","buscaAdicional":"TAKATA 1891 TAKATA PETRI JUNDIAI 70265"},{"id":"b8a415fb-ecb6-4576-50fa-08d5ad2bf6ba","name":"ASTRA S A INDUSTRIA E COMERCIO","commercialName":"","cnpj":"50949528000180","city":"JUNDIAÍ","stateCode":"SP","buscaAdicional":"ASTRA SA 1930 ASTRA UN3 JUNDIAI 70292 ASTRA UN1 MTZ JUNDIA 70382"},{"id":"d60cc677-f78b-447f-50bb-08d5ad2bf6ba","name":"UNIVERSAL INDUSTRIAS GERAIS LTDA","commercialName":"","cnpj":"50948819000153","city":"JUNDIAÍ","stateCode":"SP","buscaAdicional":"UNIVERSAL 1810 UNIV. IG JUNDIAI 13K 70191"},{"id":"ac0caa16-3020-4326-500c-08d5ad2bf6ba","name":"CIA. SANEAMENTO DE JUNDIAI","commercialName":"","cnpj":"01201289000170","city":"JUNDIAÍ","stateCode":"SP","buscaAdicional":"CSJ 1412 CIA SANEAM JUNDIAI 905083 CSJ - EST VARJAO 452 7823"},{"id":"3f166128-aaf9-4f8a-507b-08d5ad2bf6ba","name":"AKZO NOBEL PULP AND PERFORMANCE QUIMICA LTDA","commercialName":"","cnpj":"43818418000113","city":"JUNDIAÍ","stateCode":"SP","buscaAdicional":"EKA CHEMICALS 1646 EKA CHEM. JUNDIAI 7157"},{"id":"18feecdc-024a-4a8e-6154-08d5ad2bf6ba","name":"ALPINO INDUSTRIA METALURGICA LTDA","commercialName":"","cnpj":"61451027000195","city":"JUNDIAÍ","stateCode":"SP","buscaAdicional":"ALPINO 54128 ALPINO FILIAL 905767 ALPINO MATRIZ 905777"},{"id":"be10eb35-adfe-439a-6270-08d5ad2bf6ba","name":"EMULZINT ADITIVOS ALIMENTICIOS IND E COMERCIO LTDA","commercialName":"EMULZINT","cnpj":"42597823000196","city":"JUNDIAÍ","stateCode":"SP","buscaAdicional":"EMULZINT 54761 EMULZINT JUNDIAI SP 906605"},{"id":"69d260fa-a6e8-4557-6309-08d5ad2bf6ba","name":"CORREIAS MERCURIO SA INDUSTRIA E COMERCIO","commercialName":"","cnpj":"50937564000123","city":"JUNDIAÍ","stateCode":"SP","buscaAdicional":"CORREIAS MERCURIO 55108 CORREIA MERCURIO SA 905978"},{"id":"6edb3758-4012-40df-6334-08d5ad2bf6ba","name":"TRIMPLAS PERFILADOS PLASTICOS INDUSTRIA E COMERCIO LTDA","commercialName":"","cnpj":"01414296000150","city":"JUNDIAÍ","stateCode":"SP","buscaAdicional":"TRIMPLAS 55244 TRIMPLAS 908794"},{"id":"d26a414d-8ebb-47e2-6538-08d5ad2bf6ba","name":"SUBCONDOMINIO SHOPPING CENTER JUNDIAI SHOPPING","commercialName":"","cnpj":"23236097000131","city":"JUNDIAÍ","stateCode":"SP","buscaAdicional":"SUBCONDOMINIO JUNDIAI 56596 JUNDIAI SHOPPING 902713"},{"id":"94221a7a-775f-4c8d-6515-08d5ad2bf6ba","name":"SIRMAX DO BRASIL COMERCIO E INDUSTRIA DE PLASTICOS LTDA.","commercialName":"","cnpj":"17133267000150","city":"JUNDIAÍ","stateCode":"SP","buscaAdicional":"SIRMAX 56466 SIRMAX DO BRASIL JUN 908049"},{"id":"826869e4-ab7e-41fb-649e-08d5ad2bf6ba","name":"PROTURBO USINAGEM DE PRECISAO LTDA","commercialName":"","cnpj":"02455462000129","city":"JUNDIAÍ","stateCode":"SP","buscaAdicional":"PROTURBO 56135 PROTURBO USINAGEM 907507"},{"id":"3dd11be7-1c4f-4736-6437-08d5ad2bf6ba","name":"CERAMICA GRESCA LTDA","commercialName":"","cnpj":"00828487000103","city":"JUNDIAÍ","stateCode":"SP","buscaAdicional":"CERAMICA GRESCA 55882 CERAMICA GRESCA LTDA 905987"},{"id":"3e12ad76-8f44-4507-6447-08d5ad2bf6ba","name":"CERAMICA GRESCA G3 LTDA","commercialName":"","cnpj":"12989740000181","city":"JUNDIAÍ","stateCode":"SP","buscaAdicional":"CERAMICA GRESCA G3 55904 CERAMICA GRESCA G3 905087"},{"id":"6b57051f-3219-494c-6448-08d5ad2bf6ba","name":"CERAMICA GRESCA G2 LTDA","commercialName":"CERAMICA GRESCA G2","cnpj":"52215621000196","city":"JUNDIAÍ","stateCode":"SP","buscaAdicional":"CERAMICA GRESCA G2 55905 CERAMICA GRESCA G2 L 905932"},{"id":"8803534a-85cc-4717-6391-08d5ad2bf6ba","name":"DESTRO BRASIL DISTRIBUICAO LTDA","commercialName":"DESTRO BRASIL DISTRIBUICAO","cnpj":"13495487000172","city":"JUNDIAÍ","stateCode":"SP","buscaAdicional":"DESTRO BRASIL 55470 DESTRO BRASIL 909173"},{"id":"a6942055-bbfe-43a7-6393-08d5ad2bf6ba","name":"DE MARCHI INDUSTRIA E COMERCIO DE FRUTAS LTDA","commercialName":"","cnpj":"52884061000162","city":"JUNDIAÍ","stateCode":"SP","buscaAdicional":"DE MARCHI 55473 DE MARCHI 906852"},{"id":"1ad26dcd-c331-4333-63d2-08d5ad2bf6ba","name":"JERUEL PLASTICOS INDUSTRIA E COMERCIO LTDA","commercialName":"JERUEL PLASTICOS","cnpj":"08357463000117","city":"JUNDIAÍ","stateCode":"SP","buscaAdicional":"JERUEL 55643 JERUEL PLASTICOS 907606"},{"id":"6fe48792-c506-487b-6841-08d5ad2bf6ba","name":"LOS GROBO AGROINDUSTRIAL DO BRASIL S.A.","commercialName":"","cnpj":"07924215000148","city":"JUNDIAÍ","stateCode":"SP","buscaAdicional":"LOSGROBO 59613 LOS GROBO AGROINDUST 909815"},{"id":"9e5bd085-d4a0-4e1a-688e-08d5ad2bf6ba","name":"CPE PLASTICOS LTDA","commercialName":"SPUMAPAC","cnpj":"10756910000233","city":"JUNDIAÍ","stateCode":"SP","buscaAdicional":"CPE PLASTICOS 60148 CPE - SPUMAPAC 888989"},{"id":"3bd1c635-98f5-42ab-6930-08d5ad2bf6ba","name":"FUNDACAO DR. JAYME RODRIGUES","commercialName":"FUNDACAO DR. JAYME RODRIGUES","cnpj":"04831032000190","city":"JUNDIAÍ","stateCode":"SP","buscaAdicional":"FDR JAYME RODRIGUES 60835 FUND DR JAYME RODRIG 912450"},{"id":"05b9a084-e107-4272-690c-08d5ad2bf6ba","name":"BOLLHOFF SERVICE CENTER LTDA.","commercialName":"","cnpj":"57879843000127","city":"JUNDIAÍ","stateCode":"SP","buscaAdicional":"BOLLHOFF 60753 BOLLHOFF - JUNDIAI 912493"},{"id":"6a7921fb-211e-4dac-8872-08d5ae44ed50","name":"ALUJET INDUSTRIAL E COMERCIAL LTDA.","commercialName":"","cnpj":"00452047000196","city":"JUNDIAÍ","stateCode":"SP","buscaAdicional":"ALUJET 6722"},{"id":"b23ec192-a7ec-475c-66f1-08d5ad2bf6ba","name":"TOYO INK BRASIL LTDA.","commercialName":"","cnpj":"11592963000148","city":"JUNDIAÍ","stateCode":"SP","buscaAdicional":"TOYO INK 57892 TOYO INK BRASIL LTDA 908196"},{"id":"abcd4748-5495-4547-6789-08d5ad2bf6ba","name":"CBC INDUSTRIAS PESADAS S A","commercialName":"","cnpj":"60501707000103","city":"JUNDIAÍ","stateCode":"SP","buscaAdicional":"CBC 58249 CBC IND PESADAS 908511"},{"id":"488cd103-1776-495b-6655-08d5ad2bf6ba","name":"COOPERATIVA DE CONSUMO COOPERCICA","commercialName":"COOPERCICA","cnpj":"50974732000150","city":"JUNDIAÍ","stateCode":"SP","buscaAdicional":"COOPERCICA 57496 COOPERCICA 203627425 907206 COOPERCICA 203627471 907207 COOPERCICA 400071466 907212 COOPERCICA 203627521 907213 COOPERCICA 203629699 907214 COOPERCICA 400001837 907215"},{"id":"e0e5c0fc-4b41-4215-6590-08d5ad2bf6ba","name":"SIGVARIS DO BRASIL INDUSTRIA E COMERCIO LIMITADA","commercialName":"SIGVARIS","cnpj":"46144622000194","city":"JUNDIAÍ","stateCode":"SP","buscaAdicional":"SIGVARIS 56830 SIGVARIS BRASIL JUND 908393"},{"id":"5005308c-3c38-40a1-65cb-08d5ad2bf6ba","name":"HMY DO BRASIL LTDA.","commercialName":"","cnpj":"01476925000176","city":"JUNDIAÍ","stateCode":"SP","buscaAdicional":"HMY 57137 HMY BRASIL 907508"},{"id":"d34c3202-5bd5-4bda-6607-08d5ad2bf6ba","name":"NEUMAYER TEKFOR AUTOMOTIVE BRASIL LTDA.","commercialName":"NEUMAYER TEKFOR","cnpj":"61096996000175","city":"JUNDIAÍ","stateCode":"SP","buscaAdicional":"NEUMAYER 57273 NEUMAYER JUNDIAI 908276 NEUMAYER JUNDIAI 2 911511 NEUMAYER BETIM 911392"},{"id":"7b280aee-4770-4a2d-6610-08d5ad2bf6ba","name":"CERAMICA ERMIDA LTDA","commercialName":"","cnpj":"50968643000100","city":"JUNDIAÍ","stateCode":"SP","buscaAdicional":"CERAMICA ERMIDA 57287 CERAMICA ERMIDA 908420"},{"id":"3b74303e-0494-4785-7256-08d5cf600bef","name":"CONCESSIONARIA DO SISTEMA ANHANGUERA-BANDEIRANTES S/A","commercialName":"","cnpj":"02451848000162","city":"JUNDIAÍ","stateCode":"SP","buscaAdicional":""},{"id":"8bac14c0-78f8-4032-7390-08d5cf600bef","name":"VULCABRAS AZALEIA S/A","commercialName":"","cnpj":"50926955000142","city":"JUNDIAÍ","stateCode":"SP","buscaAdicional":""},{"id":"af7c7bdf-8e74-4272-5779-08d5ad2bf6ba","name":"GLENCANE BIOENERGIA S.A.","commercialName":"UNIDADE RIO VERMELHO","cnpj":"68316801000102","city":"JUNQUEIRÓPOLIS","stateCode":"SP","buscaAdicional":"UTE RIO VERMEL 8929 RIO VERMELHO SP 893142 UTE.AI.SP.030543-0.01 RIO VERMELHO 2 SP 894805 UTE.AI.SP.031793-4.01"},{"id":"f323f9c3-c522-4dac-4fb6-08d5ad2bf6ba","name":"AJINOMOTO DO BRASIL INDUSTRIA E COMERCIO DE ALIMENTOS LTDA.","commercialName":"AJINOMOTO DO BRASIL","cnpj":"46344354000154","city":"LARANJAL PAULISTA","stateCode":"SP","buscaAdicional":"AJINOMOTO 1 1245 AJINOMOTO LARANJAL 7050 AJINOMOTO VALPARAISO 7260 AJINOMOTO LIMEIRA 7278"},{"id":"5b00c100-770c-43d5-5aa3-08d5ad2bf6ba","name":"Q.G.P. QUIMICA GERAL LTDA","commercialName":"","cnpj":"01272356000147","city":"LARANJAL PAULISTA","stateCode":"SP","buscaAdicional":"QGP 50131 QGP QUIMICA 896710"},{"id":"34386961-b1b2-4741-662c-08d5ad2bf6ba","name":"USUAL PLASTIC - INDUSTRIA E COMERCIO DE ARTEFATOS PLASTICOS LTDA","commercialName":"USUAL PLASTIC","cnpj":"04062314000170","city":"LARANJAL PAULISTA","stateCode":"SP","buscaAdicional":"USUAL PLASTIC 57380 USUAL PLASTIC 908561"},{"id":"112a31ad-a64f-4048-6617-08d5ad2bf6ba","name":"NEWAGE INDUSTRIA DE BEBIDAS LTDA.","commercialName":"","cnpj":"01307936000122","city":"LEME","stateCode":"SP","buscaAdicional":"NEWAGE 57302 NEWAGE BEBIDAS ALIME 906725"},{"id":"1c17e54f-a8be-4102-66fa-08d5ad2bf6ba","name":"POLYSACK INDUSTRIAS LTDA.","commercialName":"","cnpj":"03278910000129","city":"LEME","stateCode":"SP","buscaAdicional":"POLYSACK 57907 POLYSACK INDUSTRIAS 909418"},{"id":"68a09d8f-ded5-48c5-64c1-08d5ad2bf6ba","name":"TS TECH DO BRASIL LTDA","commercialName":"TS TECH","cnpj":"01511345000172","city":"LEME","stateCode":"SP","buscaAdicional":"TS TECH 56195 TS TECH 906082"},{"id":"d0204327-fe63-4da7-6271-08d5ad2bf6ba","name":"POLITEJO BRASIL - INDUSTRIA DE PLASTICOS LTDA.","commercialName":"POLITEJO BRASIL - INDUSTRIA DE PLASTICOS LTDA.","cnpj":"14482258000186","city":"LEME","stateCode":"SP","buscaAdicional":"POLITEJO BRASIL 54762 POLITEJO BRASIL 903442"},{"id":"187c0cdd-cde7-4832-6277-08d5ad2bf6ba","name":"MECANICA BONFANTI SA","commercialName":"","cnpj":"51378321000165","city":"LEME","stateCode":"SP","buscaAdicional":"BONFANTI 54768 BONFANTI MATRIZ 906078 BONFANTI ANHANGUERA 906079 BONFANTI FILIAL 2 906080"},{"id":"5a5c2809-6513-4c91-62bb-08d5ad2bf6ba","name":"MINERACAO BOM RETIRO LTDA","commercialName":"","cnpj":"56763790000111","city":"LEME","stateCode":"SP","buscaAdicional":"BOM RETIRO 54941 MINERACAO BOM RETIRO 904285"},{"id":"eb64c729-62f8-44c6-1cbd-08d5b8870181","name":"NAANDAN JAIN BRASIL INDUSTRIA E COMERCIO DE EQUIPAMENTOS PARA IRRIGACAO LTDA.","commercialName":"","cnpj":"60991965000115","city":"LEME","stateCode":"SP","buscaAdicional":"NAANDAN JAIN 61118 NAANDAN JAIN 912874"},{"id":"f0d37230-0ff7-477e-60a4-08d5ad2bf6ba","name":"INFIBRA S/A","commercialName":"INFIBRA COMERCIAL","cnpj":"04277941000128","city":"LEME","stateCode":"SP","buscaAdicional":"INFIBRA 53623 INFIBRA FILIAL 903193 INFIBRA MATRIZ 903213"},{"id":"5649fe1f-0911-4df4-60a5-08d5ad2bf6ba","name":"MARISTELA TELHAS LTDA","commercialName":"TOP TELHA","cnpj":"04035155000114","city":"LEME","stateCode":"SP","buscaAdicional":"MARISTELA TELHAS 53624 MARISTELA TELHAS LEM 902354"},{"id":"00386ad1-b215-4268-529f-08d5ad2bf6ba","name":"BIOSEV S.A.","commercialName":"BIOSEV S.A.","cnpj":"15527906003666","city":"LEME","stateCode":"SP","buscaAdicional":"LDC BIO LEME 3188 LDC BIOENERGIA LEME 8146 UTE.AI.SP.027059-8.01"},{"id":"ac63f751-8162-41c5-5253-08d5ad2bf6ba","name":"LWARCEL CELULOSE LTDA","commercialName":"","cnpj":"53943098000187","city":"LENÇÓIS PAULISTA","stateCode":"SP","buscaAdicional":"UTE LWARCEL 3002 LWARCEL RC 138 KV 71321 LWARCEL 8758 UTE.FL.SP.028620-6.01"},{"id":"5699b56f-b811-4f29-4f2d-08d5ad2bf6ba","name":"USINA BARRA GRANDE DE LENCOIS S A","commercialName":"","cnpj":"51422921000183","city":"LENÇÓIS PAULISTA","stateCode":"SP","buscaAdicional":"BARRA GRANDE 123 BARRA GRANDE LENCOIS 525 UTE.AI.SP.027055-5.01"},{"id":"8cedf9bd-1675-44aa-4f2e-08d5ad2bf6ba","name":"ACUCAREIRA ZILLO LORENZETTI S A","commercialName":"","cnpj":"51422988000118","city":"LENÇÓIS PAULISTA","stateCode":"SP","buscaAdicional":"ZILLO LORENZET 124 SAO JOSE (ZILLO) 8413 UTE.AI.SP.026847-0.01"},{"id":"92eabcac-ccbf-4816-5025-08d5ad2bf6ba","name":"OMI DO BRASIL TEXTIL S.A.","commercialName":"","cnpj":"51422970000116","city":"LENÇÓIS PAULISTA","stateCode":"SP","buscaAdicional":"OMI-ZILLO 1476 OMI ZILLO LOREN.LENC 7903"},{"id":"1c2911b4-a8d2-4249-5123-08d5ad2bf6ba","name":"ACUCAREIRA QUATA S/A","commercialName":"USINA QUATA","cnpj":"60855574000173","city":"LENÇÓIS PAULISTA","stateCode":"SP","buscaAdicional":"UTE QUATA CONV 2019 QUATA 8483 UTE.AI.SP.028288-0.01"},{"id":"321ed817-6643-4aa0-55b2-08d5ad2bf6ba","name":"LUTEPEL INDUSTRIA E COMERCIO DE PAPEL LTDA","commercialName":"","cnpj":"51425130000298","city":"LENÇÓIS PAULISTA","stateCode":"SP","buscaAdicional":"LUTEPEL 6020 LUTEPEL-LCO PAULISTA 72014"},{"id":"b2a0a3b6-de3f-46c8-5fa2-08d5ad2bf6ba","name":"THOMRISS EMBALAGENS PLASTICAS LTDA","commercialName":"","cnpj":"62309299000118","city":"LENÇÓIS PAULISTA","stateCode":"SP","buscaAdicional":"THOMRISS 53056 THOMRISS 905108"},{"id":"d409b1a0-7a25-4dd9-631a-08d5ad2bf6ba","name":"COMERCIAL SANTA CATARINA DE SECOS E MOLHADOS LIMITADA","commercialName":"SUPERMERCADO SANTA CATARINA","cnpj":"51423812000180","city":"LENÇÓIS PAULISTA","stateCode":"SP","buscaAdicional":"SANTA CATARINA SUPERMERCADOS 55171 SANTA CATARINA LJ 01 907027 SANTA CATARINA LJ 02 907035 SANTA CATARINA LJ 03 907036"},{"id":"9e485313-8edb-4acd-6823-08d5ad2bf6ba","name":"VINAGRE BELMONT SA","commercialName":"","cnpj":"44806784000115","city":"LENÇÓIS PAULISTA","stateCode":"SP","buscaAdicional":"VINAGRE BELMONT 59416 VINAGRE BELMONT 910412"},{"id":"3757cbfa-9261-4d31-6704-08d5ad2bf6ba","name":"PLASTCOR DO BRASIL LTDA","commercialName":"PLASTCOR","cnpj":"04704457000138","city":"LIMEIRA","stateCode":"SP","buscaAdicional":"PLASTCOR 57925 PLASTCOR DO BRASIL 908562"},{"id":"4ebdae9c-55a3-4ff7-6670-08d5ad2bf6ba","name":"S.S.B. ENERGIA RENOVAVEL LTDA","commercialName":"SSB ENERGIA","cnpj":"53905543000114","city":"LIMEIRA","stateCode":"SP","buscaAdicional":"SSB ENERGIA RENOVAVEL 57571 SSB ENERGIA ITAUNA 908835 SSB CORDEIROPOLIS 910027 SSB LIMEIRA 910028"},{"id":"e2c1f996-65e8-4867-65ef-08d5ad2bf6ba","name":"PRALANA INDUSTRIA E COMERCIO LTDA.","commercialName":"PRALANA","cnpj":"03910100000143","city":"LIMEIRA","stateCode":"SP","buscaAdicional":"PRALANA 57213 PRALANA 907812"},{"id":"ca82179b-7443-4690-629f-08d5ad2bf6ba","name":"COMERCIAL DELTA PONTO CERTO LTDA","commercialName":"SEMPREVALE SUPERMERCADOS","cnpj":"62488937000105","city":"LIMEIRA","stateCode":"SP","buscaAdicional":"SEMPRE VALE SUPERMERCADOS 54828 SEMPRE VALE - LJ22 907266 SEMPRE VALE - LJ24 907267 SEMPRE VALE - LJ25 907268 SEMPRE VALE - LJ06 907334 SEMPRE VALE L 23 907518 SEMPRE VALE L 21 907976 SEMPRE VALE L 9 908567 SEMPRE VALE - LJ2 910382 SEMPRE VALE LJ 17 910799 SEMPRE VALE LJ 01 910800 SEMPRE VALE LJ 07 910801 SEMPRE VALE LJ 10 910802 SEMPRE VALE LJ 12 910803 SEMPRE VALE 19 910898 SEMPRE VALE 3 910913 SEMPRE VALE LOJA 4 911220 SEMPRE VALE LOJA 14 911256 SEMPRE VALE LOJA 27 911321 SEMPRE VALE -LOJA 15 911913"},{"id":"84dae7fd-c88a-4302-6283-08d5ad2bf6ba","name":"INDUSTRIAS MACHINA ZACCARIA S A","commercialName":"MACHINA ZACCARIA","cnpj":"51466324000150","city":"LIMEIRA","stateCode":"SP","buscaAdicional":"ZACCARIA 54790 ZACCARIA 905583"},{"id":"498b134c-4f3c-4eaf-64e2-08d5ad2bf6ba","name":"BGL - BERTOLOTO & GROTTA LTDA","commercialName":"BGL","cnpj":"51469377000125","city":"LIMEIRA","stateCode":"SP","buscaAdicional":"BGL 56292 BGL 18459005 907309 BGL 18459021 907310"},{"id":"bfa84818-a73f-4654-64a0-08d5ad2bf6ba","name":"MANDO CORPORATION DO BRASIL INDUSTRIA E COMERCIO DE AUTO PECAS LTDA.","commercialName":"","cnpj":"12319411000123","city":"LIMEIRA","stateCode":"SP","buscaAdicional":"MANDO 56137 MANDO CORPORATION 905655"},{"id":"3893b534-4320-4d2e-653c-08d5ad2bf6ba","name":"MAHLE METAL LEVE S.A.","commercialName":"","cnpj":"60476884003364","city":"LIMEIRA","stateCode":"SP","buscaAdicional":"MAHLE AFT 56614 MAHLE AFT LIMEIRA SP 906718"},{"id":"3cb5b429-01a6-4b8d-63e9-08d5ad2bf6ba","name":"CONDOMINIO CIVIL CENTER PLAZA SHOPPING","commercialName":"CENTER PLAZA SHOPPING","cnpj":"07348740000162","city":"LIMEIRA","stateCode":"SP","buscaAdicional":"SHOPPING LIMEIRA 55713 SHOP LIMEIRA 905170"},{"id":"c584bd3c-8a91-41c6-5ff6-08d5ad2bf6ba","name":"FAURECIA EMISSIONS CONTROL TECHNOLOGIES DO BRASIL S.A.","commercialName":"","cnpj":"02308873000191","city":"LIMEIRA","stateCode":"SP","buscaAdicional":"FAURECIA LIM 53315 FAURECIA LIM 900927"},{"id":"0e59c88f-8dfe-4a10-5e9d-08d5ad2bf6ba","name":"PEDREIRA SERTAOZINHO LTDA","commercialName":"","cnpj":"60481264000136","city":"LIMEIRA","stateCode":"SP","buscaAdicional":"PEDREIRA SERTAOZINHO 52464 PEDR SERTAOZINHO 905090"},{"id":"3669e23c-7eef-47bf-5d74-08d5ad2bf6ba","name":"CATION INDUSTRIA E COMERCIO LTDA","commercialName":"","cnpj":"01303034000118","city":"LIMEIRA","stateCode":"SP","buscaAdicional":"CATION 51824 CATION LIMEIRA 899748"},{"id":"49dff732-7a29-43c0-5b7d-08d5ad2bf6ba","name":"LUME CERAMICA LTDA","commercialName":"CERAMICA LUME","cnpj":"04201168000116","city":"LIMEIRA","stateCode":"SP","buscaAdicional":"LUME 50732 LUME CERAMICA SP 897708"},{"id":"c674a4a9-6635-4b6f-5622-08d5ad2bf6ba","name":"STAMPLINE METAIS ESTAMPADOS LTDA","commercialName":"STAMPLINE","cnpj":"73070294000100","city":"LIMEIRA","stateCode":"SP","buscaAdicional":"STAMPLINE 6659 STAMPLINE FAB II 72071 STAMPLINE FB I-LIM 72127 STAMPLINE FB III-LIM 72128"},{"id":"2b57675f-06f7-4735-5758-08d5ad2bf6ba","name":"CP KELCO BRASIL S/A.","commercialName":"","cnpj":"54105671000146","city":"LIMEIRA","stateCode":"SP","buscaAdicional":"CP KELCO 8631 CP KELCO LIMEIRA 888621 CP KELKO - LIMEIRA 2 898575"},{"id":"ab705e0f-fdcf-41b7-56ce-08d5ad2bf6ba","name":"MIGRATIO GESTAO E COMERCIALIZACAO DE ENERGIA ELETRICA LTDA.","commercialName":"MIGRATIO","cnpj":"15458171000136","city":"LIMEIRA","stateCode":"SP","buscaAdicional":"MIGRATIO 7760"},{"id":"7a2de1e8-8587-48a6-5453-08d5ad2bf6ba","name":"CCS TECNOLOGIA E SERVICOS LTDA","commercialName":"","cnpj":"00964350000178","city":"LIMEIRA","stateCode":"SP","buscaAdicional":"CCS 4167 CSS TEC E SERVICO 892024 CCS - UNIDADE 2 892411 CCS UN3 LIMEIRA - SP 892548 CCS PALMEIRAS 908406"},{"id":"8f066c6e-23c7-4e70-53bd-08d5ad2bf6ba","name":"MD PAPEIS LTDA.","commercialName":"MD PAPEIS LIMEIRA","cnpj":"72907595000840","city":"LIMEIRA","stateCode":"SP","buscaAdicional":"MD LIMEIRA 3814 MD PAPEIS LIMEIRA 71315"},{"id":"21eb44d9-501a-43fd-4fa1-08d5ad2bf6ba","name":"TRW AUTOMOTIVE LTDA","commercialName":"ZF TRW","cnpj":"60857349000176","city":"LIMEIRA","stateCode":"SP","buscaAdicional":"TRW 1199 TRW- ENG. COELHO 7579 TRW- LIMEIRA 7578"},{"id":"b15d78d3-509b-4233-4fbd-08d5ad2bf6ba","name":"PAPIRUS INDUSTRIA DE PAPEL SA","commercialName":"","cnpj":"60856077000190","city":"LIMEIRA","stateCode":"SP","buscaAdicional":"PAPIRUS 1257 PAPIRUS-LIMEIRA 7534"},{"id":"5cdd703d-21fd-4ef2-4fce-08d5ad2bf6ba","name":"COMPANHIA ENERGETICA SALTO DO LOBO LTDA","commercialName":"","cnpj":"05468321000139","city":"LIMEIRA","stateCode":"SP","buscaAdicional":"SALTO DO LOBO 1288 SALTO DO LOBO 563 PCH.PH.SP.028585-4.01 RIBEIRAO DO PINHAL 8151 PCH.PH.SP.002238-1.01 FEIXOS 8763 PCH.PH.SP.030260-0.01"},{"id":"885037e9-299c-4527-528e-08d5ad2bf6ba","name":"IOCHPE-MAXION S.A.","commercialName":"","cnpj":"61156113000760","city":"LIMEIRA","stateCode":"SP","buscaAdicional":"FUMAGALLI 3141 IOCHPE LIMEIRA SP 70119"},{"id":"81770080-27f0-4953-63a9-08d5ad2bf6ba","name":"FLAMIN MINERACAO LTDA","commercialName":"","cnpj":"68248210000137","city":"LINDÓIA","stateCode":"SP","buscaAdicional":"FLAMIN 55505 FLAMIN MINERACAO LTD 907270"},{"id":"6e598863-4dd6-4eb5-685c-08d5ad2bf6ba","name":"TRES RIOS COMERCIALIZADORA DE ENERGIA ELETRICA LTDA","commercialName":"","cnpj":"27614096000134","city":"LINS","stateCode":"SP","buscaAdicional":"TRES RIOS ENERGIA 59859"},{"id":"54cb0a16-4358-4b1b-68a3-08d5ad2bf6ba","name":"PROPACK INDUSTRIA TEXTIL DO BRASIL LTDA","commercialName":"PROPACK","cnpj":"24947838000155","city":"LINS","stateCode":"SP","buscaAdicional":"PROPACK 60235 PROPACK IND TEXTIL 910629"},{"id":"8f49edd8-d527-423c-730a-08d5cf600bef","name":"VIARONDON CONCESSIONARIA DE RODOVIA S/A","commercialName":"VIARONDON","cnpj":"10635691000153","city":"LINS","stateCode":"SP","buscaAdicional":""},{"id":"354e794c-54ec-4396-72e9-08d5cf600bef","name":"TRANSBRASILIANA - CONCESSIONARIA DE RODOVIA S.A.","commercialName":"","cnpj":"09074183000164","city":"LINS","stateCode":"SP","buscaAdicional":""},{"id":"0db1ae46-320c-4c9e-526f-08d5ad2bf6ba","name":"ALPHALINS TURISMO LTDA","commercialName":"ALPHALINS TURISMO LTDA","cnpj":"04291622000177","city":"LINS","stateCode":"SP","buscaAdicional":"ALPHALINS 3056 ALPHALINS 71109"},{"id":"636de6bb-6fb4-4341-5467-08d5ad2bf6ba","name":"VALFILM - MG INDUSTRIA DE EMBALAGENS LTDA","commercialName":"VALFILM - MG","cnpj":"07183852000704","city":"LORENA","stateCode":"SP","buscaAdicional":"VALFILM MG 74 4215 VALFILM - LORENA 7904"},{"id":"44ba2f35-2400-4404-5521-08d5ad2bf6ba","name":"YAKULT S/A. INDUSTRIA E COMERCIO","commercialName":"","cnpj":"60723061055868","city":"LORENA","stateCode":"SP","buscaAdicional":"YAKULT 5091 YAKULT LORENA 908635"},{"id":"a95387e8-eeb3-4877-57d5-08d5ad2bf6ba","name":"SAINT-GOBAIN DO BRASIL PRODUTOS INDUSTRIAIS E PARA CONSTRUCAO LTDA","commercialName":"","cnpj":"61064838010791","city":"LORENA","stateCode":"SP","buscaAdicional":"SGABR LORENA 9749 SAINT GOBAIN LORENA 889014"},{"id":"dd379a35-8e87-49b7-55d8-08d5ad2bf6ba","name":"TECNOVAL LAMINADOS PLASTICOS LTDA","commercialName":"","cnpj":"00455984000367","city":"LORENA","stateCode":"SP","buscaAdicional":"TECNOVAL FIL 6233 TECNOVAL LAM-LORENA 72114"},{"id":"522c93df-8e62-4c94-623e-08d5ad2bf6ba","name":"INDUSTRIA E COMERCIO DE ARTEFATOS PLASTICOS VELAPLAST LTDA","commercialName":"VELAPLAST","cnpj":"03923437000276","city":"LORENA","stateCode":"SP","buscaAdicional":"VELAPLAST 54633 IND VELAPLAST 905753"},{"id":"9007870d-3c3c-42f4-6212-08d5ad2bf6ba","name":"ECO VALLE SFA EMPREENDIMENTOS IMOBILIARIOS SPE LTDA","commercialName":"","cnpj":"19439252000140","city":"LORENA","stateCode":"SP","buscaAdicional":"ECO VALLE 54538 ECO VALLE 904081"},{"id":"f55947eb-a691-46e0-63ad-08d5ad2bf6ba","name":"MAGAZINE LUIZA S/A","commercialName":"MAGAZINE LUIZA","cnpj":"47960950044927","city":"LOUVEIRA","stateCode":"SP","buscaAdicional":"MAGAZINE LUIZA CD 55518 MAG.LUIZA LOUVEIRA 70711"},{"id":"f9da41a5-e239-4cdb-68aa-08d5ad2bf6ba","name":"DINOPLAST INDUSTRIA E COMERCIO DE PLASTICOS LTDA","commercialName":"DINOPLAST","cnpj":"53775003000163","city":"LOUVEIRA","stateCode":"SP","buscaAdicional":"DINOPLAST 60263 DINOPLAST LOUVEIRA 910236"},{"id":"301e9362-6916-480c-65af-08d5ad2bf6ba","name":"COOPERATIVA DE PRODUCAO AGROPECUARIA DE ITATIBA","commercialName":"COOPERAVI","cnpj":"02864605000156","city":"LOUVEIRA","stateCode":"SP","buscaAdicional":"COOPERAVI 56930 COOPERAVI 908670"},{"id":"aa42cd06-3142-402b-5154-08d5ad2bf6ba","name":"DOLFIN INDUSTRIA E COMERCIO LTDA","commercialName":"DOLFIN","cnpj":"62359591000145","city":"LOUVEIRA","stateCode":"SP","buscaAdicional":"DOLFIN 2117 DOLFIN LOUVEIRA 70480"},{"id":"5b199474-0270-41da-5232-08d5ad2bf6ba","name":"AMCOR PACKAGING DO BRASIL LTDA","commercialName":"","cnpj":"43235795000120","city":"LOUVEIRA","stateCode":"SP","buscaAdicional":"AMCOR P 2920 AMCOR PLV 71444"},{"id":"609c83ae-f074-4d6d-5d1e-08d5ad2bf6ba","name":"UNILEVER BRASIL LTDA.","commercialName":"INDUSTRIAS GESSY LEVER LTDA","cnpj":"61068276030780","city":"LOUVEIRA","stateCode":"SP","buscaAdicional":"UNILEVER CD LOUVEIRA 51708 UNILEVER LOUVEIRA 898795"},{"id":"cc4442f8-02f6-4ef1-5f49-08d5ad2bf6ba","name":"MULTIVETRO INDUSTRIA E COMERCIO DE VIDROS ESPECIAIS LTDA","commercialName":"MULTIVETRO","cnpj":"60678877000168","city":"LOUVEIRA","stateCode":"SP","buscaAdicional":"MULTIVETRO 52887 MULTIVETRO IND COM. 905779"},{"id":"c4e181d1-b62b-424d-5735-08d5ad2bf6ba","name":"BIOENERGIA DO BRASIL S/A","commercialName":"","cnpj":"08046650000180","city":"LUCÉLIA","stateCode":"SP","buscaAdicional":"UTE LUCELIA 8350 LUCELIA 398 UTE.AI.SP.027338-4.01"},{"id":"526e64ab-b7b8-43ec-517e-08d5ad2bf6ba","name":"INTERNATIONAL PAPER DO BRASIL LTDA.","commercialName":"","cnpj":"52736949001987","city":"LUÍS ANTÔNIO","stateCode":"SP","buscaAdicional":"IP LUIZANTONIO 2209 VCP L.ANTONIO CELPAV 192"},{"id":"e03d5039-47bc-4683-500a-08d5ad2bf6ba","name":"CARGILL AGRICOLA S A","commercialName":"","cnpj":"60498706007836","city":"MAIRINQUE","stateCode":"SP","buscaAdicional":"CARGILL MAIRIN 1410 ETC CARGIL MAIRINQUE 7373"},{"id":"f11bc699-5475-4b30-5fa3-08d5ad2bf6ba","name":"CEFRI - LOGISTICA, ARMAZENAGEM FRIGORIFICADA E AGROINDUSTRIA LTDA.","commercialName":"","cnpj":"57046955000105","city":"MAIRINQUE","stateCode":"SP","buscaAdicional":"CEFRI 53058 CEFRI LOGISTICA FRIG 902657"},{"id":"718a186a-0f4b-4580-58ae-08d5ad2bf6ba","name":"DSM PRODUTOS NUTRICIONAIS BRASIL S.A.","commercialName":"","cnpj":"56992951001978","city":"MAIRINQUE","stateCode":"SP","buscaAdicional":"DSM MAIRINQUE 12832 TORTUGA-MAIRINQUE 71987"},{"id":"1b82ddbe-6050-475f-6653-08d5ad2bf6ba","name":"ETRURIA INDUSTRIA DE FIBRAS E FIOS SINTETICOS LTDA","commercialName":"ETRURIA","cnpj":"45723541000186","city":"MAIRINQUE","stateCode":"SP","buscaAdicional":"ETRURIA 57494 ETRURIA FIBRAS 908674"},{"id":"3408bb0a-0bbc-4176-66bf-08d5ad2bf6ba","name":"INDUSTRIA DE TAPETES LANCER S/A","commercialName":"LANCER","cnpj":"01174145000171","city":"MAIRINQUE","stateCode":"SP","buscaAdicional":"TAPETES LANCER 57779 LANCER TAPETES 910035"},{"id":"1c5ab666-528c-4dea-54a4-08d5ad2bf6ba","name":"PRAFESTA INDUSTRIA E COMERCIO DE DESCARTAVEIS LTDA.","commercialName":"","cnpj":"56173131000125","city":"MAIRIPORÃ","stateCode":"SP","buscaAdicional":"PRAFESTA 4406 PRAFESTA-MAIRIPORA 71550"},{"id":"d9394bb5-4da9-47cd-5935-08d5ad2bf6ba","name":"BIOENERGIA MARACAI LTDA.","commercialName":"","cnpj":"18734168000196","city":"MARACAÍ","stateCode":"SP","buscaAdicional":"BIO MARACAI 14136 MARACAI CONSUMO 910874 TARUMA CONSUMO 910868 NOVA AMERICA 521 UTE.AI.SP.028096-8.01 ZANIN 8928 UTE.AI.SP.028325-8.01 SERRA (BIO SERRA) 407 UTE.AI.SP.028209-0.01 MARACAI (REDE COM) 426 UTE.AI.SP.001405-2.01"},{"id":"a6d366eb-e732-43c3-5fbc-08d5ad2bf6ba","name":"MARCON INDUSTRIA METALURGICA LTDA","commercialName":"MARCON INDUSTRIA METALURGICA","cnpj":"57211997000146","city":"MARÍLIA","stateCode":"SP","buscaAdicional":"MARCON 53204 MARCON FUNDICAO 904676 MARCON 905110 MARCON 47 905111"},{"id":"23782870-6cb6-41ee-5e2c-08d5ad2bf6ba","name":"TAUSTE SUPERMERCADOS LTDA","commercialName":"TAUSTE SUPERMERCADOS","cnpj":"65897910000164","city":"MARÍLIA","stateCode":"SP","buscaAdicional":"TAUSTE MATRIZ 52242 TAUSTE OZANAN 70459 TAUSTE MARILIA SP 72010 TAUSTE REP MARILIA 889324 TAUSTE RIO BRANCO SP 890630 TAUSTE CAMPOLIM 900035 TAUSTE ITAVUVU - SOR 905778 TAUSTE ADM 910454"},{"id":"fb0e9279-8f93-41fe-5571-08d5ad2bf6ba","name":"SASAZAKI INDUSTRIA E COMERCIO LTDA.","commercialName":"","cnpj":"52045697000110","city":"MARÍLIA","stateCode":"SP","buscaAdicional":"SASAZAKI 5612 SASAZAKI-MARILIA 71842 SASAZAKI II 889504"},{"id":"0f4e9c0e-f3af-477c-55e8-08d5ad2bf6ba","name":"SPILTAG INDUSTRIAL LTDA","commercialName":"","cnpj":"00573283000160","city":"MARÍLIA","stateCode":"SP","buscaAdicional":"SPILTAG 6294 SPILTAG INDUSTRIAL 72107"},{"id":"c53632e2-4ff8-4fb7-56b8-08d5ad2bf6ba","name":"SUPERMERCADOS KAWAKAMI LTDA","commercialName":"SUPERMERCADO KAWAKAMI","cnpj":"46136925000165","city":"MARÍLIA","stateCode":"SP","buscaAdicional":"KAWAKAMI 7540 SUPERMERCADO KAWAKAM 889559 SUPER KAWAKAM FILIAL 889578 SUPER KAWAKAMI TUPA 889758 KAWAKAMI PARAGUACU 898628 KAWAKAMI BASTOS 902760 KAWAKAMI LINS 911279"},{"id":"58435d31-3969-4af7-52cb-08d5ad2bf6ba","name":"ZD ALIMENTOS S.A","commercialName":"GRUPO ZDA","cnpj":"56073307000177","city":"MARÍLIA","stateCode":"SP","buscaAdicional":"BEL 3315 BEL-MARILIA 71116 BEL-HERCULANDIA 71117"},{"id":"86365929-52d5-4b88-5308-08d5ad2bf6ba","name":"MARILAN ALIMENTOS S/A","commercialName":"MARILAN","cnpj":"52034139000150","city":"MARÍLIA","stateCode":"SP","buscaAdicional":"MARILAN 3445 MARILAN 71119"},{"id":"d305b94a-57e4-4d23-6637-08d5ad2bf6ba","name":"BOVIMEX - COMERCIAL LTDA","commercialName":"","cnpj":"52035581000109","city":"MARÍLIA","stateCode":"SP","buscaAdicional":"BOVIMEX 57392 BOVIMEX COMERCIAL 908471"},{"id":"b246aa7a-4692-4301-68ae-08d5ad2bf6ba","name":"CONDOMINIO ESMERALDA PLAZA SHOPPING","commercialName":"CONDOMINIO ESMERALDA PLAZA SHOPPING","cnpj":"03491470000193","city":"MARÍLIA","stateCode":"SP","buscaAdicional":"ESMERALDA PLAZA SHOPPPING 60271 ESMERALDA PLAZA SHOP 910414"},{"id":"12e39231-cff2-4f2e-635c-08d5ad2bf6ba","name":"MANIBOM ALIMENTOS LTDA.","commercialName":"MANIBOM","cnpj":"01949444000130","city":"MARÍLIA","stateCode":"SP","buscaAdicional":"MANIBOM CARINO 55326 MANIBOM 6681433 905995 MANIBOM 4000161295 906016"},{"id":"9282159f-2b47-4867-4f00-08d5d159243d","name":"ENTREVIAS CONCESSIONARIA DE RODOVIAS S.A.","commercialName":"","cnpj":"26664057000189","city":"MARÍLIA","stateCode":"SP","buscaAdicional":""},{"id":"cae52bde-7de3-4cb3-725a-08d5cf600bef","name":"TRIANGULO DO SOL AUTO - ESTRADAS S/A","commercialName":"","cnpj":"02509186000134","city":"MATÃO","stateCode":"SP","buscaAdicional":""},{"id":"a3b3a58d-a0ce-4cf7-64e0-08d5ad2bf6ba","name":"BRASILUX TINTAS TECNICAS LTDA","commercialName":"BRASILUX TINTAS TECNICAS","cnpj":"72770878000117","city":"MATÃO","stateCode":"SP","buscaAdicional":"BRASILUX 56288 BRASILUX MATRIZ 2 907997 BRASILUX RESINA 907998 BRASILUX MATRIZ 1 908080"},{"id":"5bdbc26d-abf5-4a82-665a-08d5ad2bf6ba","name":"BALDAN IMPLEMENTOS AGRICOLAS S A","commercialName":"BIA","cnpj":"52311347000159","city":"MATÃO","stateCode":"SP","buscaAdicional":"BALDAN AGRICOLAS 57508 BALDAN MATAO SP 907995"},{"id":"0c29dfd8-6728-4deb-52df-08d5ad2bf6ba","name":"PREDILECTA ALIMENTOS LTDA","commercialName":"","cnpj":"62546387000133","city":"MATÃO","stateCode":"SP","buscaAdicional":"PREDILECTA PIE 3339 PREDILECTA MATAO 70982"},{"id":"0e532987-0075-4b94-51c6-08d5ad2bf6ba","name":"CITROSUCO S/A AGROINDUSTRIA","commercialName":"FABRICA MATAO MATRIZ","cnpj":"33010786000187","city":"MATÃO","stateCode":"SP","buscaAdicional":"CITROSUCO AGRO APE 2582 FISHER MATAO 138 KV 70207 CITROSUCO CARGIL BEB 7355 CITROVITA 70814 CITROSUCO-CATANDUVA 71817 FISCHER MATAO 71703 CITROSUCO SANTOS 906919 CITROVITA CATANDUVA 8822 UTE.AI.SP.029572-8.01"},{"id":"6dd23725-bf94-413b-50cc-08d5ad2bf6ba","name":"FISCHER S/A - AGROINDUSTRIA","commercialName":"","cnpj":"52311529000120","city":"MATÃO","stateCode":"SP","buscaAdicional":"GRUPO FISCHER 1849 FISCHER AGROIND 906527 FISCHER SA - AGROIND 908041 FISCHER S/A FRAIBURG 908416"},{"id":"1a3c18e1-abb2-4405-569c-08d5ad2bf6ba","name":"HDS MECPAR INDUSTRIA E COMERCIO - EIRELI","commercialName":"HDS MECPAR","cnpj":"04774509000142","city":"MATÃO","stateCode":"SP","buscaAdicional":"HDS MECPAR 7323 HDS MECPAR II 888138 HDS MECPAR I 888196"},{"id":"c2f72798-42c1-428d-573e-08d5ad2bf6ba","name":"NILPEL INDUSTRIA E COMERCIO DE PAPEIS LTDA","commercialName":"","cnpj":"59261388000127","city":"MAUÁ","stateCode":"SP","buscaAdicional":"NILPEL 8375 NILPEL - MAUA 888530 NILPEL 14655 889682"},{"id":"79345774-7770-46e9-53b4-08d5ad2bf6ba","name":"FERKODA S A ARTEFATOS DE METAIS","commercialName":"","cnpj":"57506115000170","city":"MAUÁ","stateCode":"SP","buscaAdicional":"FERKODA 3787 FERKODA 71371"},{"id":"39714f31-47f3-40e8-5087-08d5ad2bf6ba","name":"CABOT BRASIL INDUSTRIA E COMERCIO LTDA","commercialName":"CABOT","cnpj":"61741690000124","city":"MAUÁ","stateCode":"SP","buscaAdicional":"CABOT 1673 CABOT-MAUA-SP 7153"},{"id":"e39a12e3-1e62-4847-508e-08d5ad2bf6ba","name":"VITOPEL DO BRASIL LTDA","commercialName":"","cnpj":"03206039000158","city":"MAUÁ","stateCode":"SP","buscaAdicional":"VITOPEL 1717 VOTOCEL VOTORANTIN 7360 VITOPEL-MAUA-SP 70108"},{"id":"86b795d4-f9ed-4167-517c-08d5ad2bf6ba","name":"JARDIM SISTEMAS AUTOMOTIVOS E INDUSTRIAIS S.A.","commercialName":"","cnpj":"03290201000169","city":"MAUÁ","stateCode":"SP","buscaAdicional":"JARDIM SISTEMA 2207 JARDIM MTZ SIST MAUA 70568"},{"id":"a7f56b12-1f8a-4b7f-5e32-08d5ad2bf6ba","name":"PAUMAR S.A - INDUSTRIA E COMERCIO","commercialName":"","cnpj":"60621141000153","city":"MAUÁ","stateCode":"SP","buscaAdicional":"PAUMAR 52274 PAUMAR MAUA 899944"},{"id":"d5936ddf-2bef-4c0c-5e5a-08d5ad2bf6ba","name":"CROMUS EMBALAGENS IND E COM LTDA","commercialName":"","cnpj":"73196644000170","city":"MAUÁ","stateCode":"SP","buscaAdicional":"CROMUS 52338 CROMUS EMBALAGENS 899827"},{"id":"ab1e52d0-7d8c-40ae-6099-08d5ad2bf6ba","name":"MASTICMOL INDUSTRIA E COMERCIO LTDA.","commercialName":"","cnpj":"74454950000122","city":"MAUÁ","stateCode":"SP","buscaAdicional":"MASTICMOL 53612 MASTICMOL 904545"},{"id":"eda86f33-49b9-45be-5909-08d5ad2bf6ba","name":"SAINT-GOBAIN DO BRASIL PRODUTOS INDUSTRIAIS E PARA CONSTRUCAO LTDA","commercialName":"SEKURIT","cnpj":"61064838008975","city":"MAUÁ","stateCode":"SP","buscaAdicional":"BRASILIT SG MAUA 13613 SG SEKURIT MAUA 7281"},{"id":"ab33a381-8c9e-41ea-67d0-08d5ad2bf6ba","name":"PLASTICOS LEANGE INDUSTRIA E COMERCIO EIRELI","commercialName":"","cnpj":"10557461000113","city":"MAUÁ","stateCode":"SP","buscaAdicional":"LEANGE 58652 LEANGE PLASTICOS 909639"},{"id":"4165fdc1-c43c-4e46-6931-08d5ad2bf6ba","name":"BRASOXIDOS INDUSTRIA QUIMICA LTDA","commercialName":"","cnpj":"53739652000109","city":"MAUÁ","stateCode":"SP","buscaAdicional":"BRASOXIDOS 60836 BRASOXIDOS INDUSTRIA 912472"},{"id":"20f551e1-7fe0-4e17-6308-08d5ad2bf6ba","name":"PICHININ INDUSTRIA E COMERCIO LTDA","commercialName":"","cnpj":"61225728000106","city":"MAUÁ","stateCode":"SP","buscaAdicional":"PICHININ 55107 PICHININ 905857"},{"id":"81f89c11-b016-4a1b-1cbe-08d5b8870181","name":"RESIPLASTIC INDUSTRIA E COMERCIO LTDA","commercialName":"","cnpj":"57159923000108","city":"MAUÁ","stateCode":"SP","buscaAdicional":"RESIPLASTIC 61120 RESIPLASTIC INDUSTRI 912836"},{"id":"473a0451-5a5e-47f4-88d9-08d5ae44ed50","name":"REPET RECICLAGEM DE TERMOPLASTICOS LTDA. EM RECUPERACAO JUDICIAL","commercialName":"","cnpj":"01316344000177","city":"MAUÁ","stateCode":"SP","buscaAdicional":"REPET MAUA 53002 REPET RECICLAGEM 904095"},{"id":"96534bbf-7621-487b-67d2-08d5ad2bf6ba","name":"COSGRAF INDUSTRIA GRAFICA LTDA","commercialName":"COSGRAF","cnpj":"46199337000170","city":"MINEIROS DO TIETÊ","stateCode":"SP","buscaAdicional":"COSGRAF 58656 COSGRAF INDUSTRIA GR 912445"},{"id":"5fe10a59-b326-4488-4239-08d5e5532bcf","name":"VALDEVINO ALVES MIRANDA","commercialName":"","cnpj":"20519741000190","city":"MIRANDÓPOLIS","stateCode":"SP","buscaAdicional":""},{"id":"5c272ac4-ba1c-448a-51d3-08d5ad2bf6ba","name":"USINA CONQUISTA DO PONTAL S.A.","commercialName":"","cnpj":"07298800000180","city":"MIRANTE DO PARANAPANEMA","stateCode":"SP","buscaAdicional":"UCP 2607 CONQUISTA DO PONTAL 8650 UTE.AI.SP.030024-1.01"},{"id":"5c194f89-f304-4ed2-1cdc-08d5b8870181","name":"FABRIMOVEIS INDUSTRIAL LTDA","commercialName":"","cnpj":"43072990000186","city":"MIRASSOL","stateCode":"SP","buscaAdicional":"FABRIMOVEIS 62532 FABRIMOVEIS FILIAL 2 912782 FABRIMOVEIS MATRIZ 912813"},{"id":"d2c99e40-2783-4715-664f-08d5ad2bf6ba","name":"CASA D INDUSTRIA DE MOVEIS - EIRELI","commercialName":"CASA D","cnpj":"52440971000156","city":"MIRASSOL","stateCode":"SP","buscaAdicional":"CASA D 57490 CASA D 908728"},{"id":"63838840-41fb-42fb-67ab-08d5ad2bf6ba","name":"COZIMAX MOVEIS MIRASSOL LTDA","commercialName":"","cnpj":"02043201000100","city":"MIRASSOL","stateCode":"SP","buscaAdicional":"COZIMAX 58410 COZIMAX MIRASSOL 1 909876 COZIMAX MIRASSOL 909877"},{"id":"6625919e-60a9-413a-6227-08d5ad2bf6ba","name":"TROUW NUTRITION BRASIL NUTRICAO ANIMAL LTDA","commercialName":"","cnpj":"03022008000147","city":"MIRASSOL","stateCode":"SP","buscaAdicional":"NUTRECO MIRASSOL 54598 NUTRECO BRASIL SP 897786 NUTRECO MIRASSOL 906672"},{"id":"624c6f12-3c46-4572-6511-08d5ad2bf6ba","name":"ASK TRADING INDUSTRIA E COMERCIO IMPORTACAO E EXPORTACAO LTDA.","commercialName":"ASK TRADING","cnpj":"08335198000257","city":"MIRASSOL","stateCode":"SP","buscaAdicional":"ASK TRADING 56462 ASK TRADING COM IMP 906683"},{"id":"d6ac12b3-0d07-4ed0-5544-08d5ad2bf6ba","name":"METALURGICA MOCOCA SA","commercialName":"","cnpj":"52502945000105","city":"MOCOCA","stateCode":"SP","buscaAdicional":"MET MOCOCA 5214 METALURGICA MOCOCA 71793"},{"id":"eed1f91f-368a-441a-54c0-08d5ad2bf6ba","name":"MULTIVERDE PAPEIS ESPECIAIS LTDA","commercialName":"","cnpj":"08698947000120","city":"MOGI DAS CRUZES","stateCode":"SP","buscaAdicional":"MULTIVERDE 4479 MULTIVERDE 71586"},{"id":"1545621e-4878-4d88-5666-08d5ad2bf6ba","name":"PLACO DO BRASIL LTDA","commercialName":"PLACO DO BRASIL","cnpj":"00700460000122","city":"MOGI DAS CRUZES","stateCode":"SP","buscaAdicional":"SGPLACO MOGI 7002 PLACO - MOGI CRUZES 72182"},{"id":"54b0b66a-f4cd-4162-533b-08d5ad2bf6ba","name":"ASSOCIACAO DOS CONDOMINOS DO MOGI SHOPPING CENTER","commercialName":"","cnpj":"66652488000140","city":"MOGI DAS CRUZES","stateCode":"SP","buscaAdicional":"MOGI SHOP 3526 MOGI SHOPPING 71083"},{"id":"d81c11ab-bb9d-4bb9-52bf-08d5ad2bf6ba","name":"HOGANAS BRASIL LTDA","commercialName":"","cnpj":"52555711000126","city":"MOGI DAS CRUZES","stateCode":"SP","buscaAdicional":"HOGANAS 3270 HOGANAS M DAS CRUZES 72414"},{"id":"84a4642e-c305-4f93-4fac-08d5ad2bf6ba","name":"PETROM PETROQUIMICA MOGI DAS CRUZES S/A","commercialName":"","cnpj":"02340752000127","city":"MOGI DAS CRUZES","stateCode":"SP","buscaAdicional":"PETROM 1219 PETROM MC 7577"},{"id":"be4b799a-ca00-4da1-5e10-08d5ad2bf6ba","name":"DIATOM MINERACAO LTDA","commercialName":"","cnpj":"43338797000144","city":"MOGI DAS CRUZES","stateCode":"SP","buscaAdicional":"DIATOM 52186 DIATOM MOGI 904102"},{"id":"a9155b9a-6290-4390-640e-08d5ad2bf6ba","name":"EQUIPAMENTOS PARA PINTURA MAJAM LTDA","commercialName":"","cnpj":"60576790000180","city":"MOGI DAS CRUZES","stateCode":"SP","buscaAdicional":"MAJAM 55811 MAJAM 907591"},{"id":"a291441c-3ded-4643-6312-08d5ad2bf6ba","name":"SK SUPERMERCADOS LTDA","commercialName":"","cnpj":"17349548000144","city":"MOGI DAS CRUZES","stateCode":"SP","buscaAdicional":"SHIBATA SK 55127 SHIBATA SK APARECIDA 904833 SHIBATA SK MOGI 904834"},{"id":"d2ba5f95-e0cf-46ba-62a2-08d5ad2bf6ba","name":"REICHHOLD DO BRASIL LTDA","commercialName":"","cnpj":"59186981000156","city":"MOGI DAS CRUZES","stateCode":"SP","buscaAdicional":"REICHHOLD 54840 REICHHOLD 905762"},{"id":"b4d24be9-29ef-4c65-66c7-08d5ad2bf6ba","name":"NEOBPO SERVICOS DE PROCESSOS DE NEGOCIOS E TECNOLOGIA S.A.","commercialName":"","cnpj":"24765823000176","city":"MOGI DAS CRUZES","stateCode":"SP","buscaAdicional":"NEOBPO 57813 NEOBPO BARRA FUNDA 3 904588 TIVIT SAO JOAO 904714 NEOBPO BARRA FUNDA I 904722 TIVIT MOGI I 904734 TIVIT SANTOS 904735"},{"id":"7cc28832-2f97-4448-66ff-08d5ad2bf6ba","name":"P.K.O. DO BRASIL IMPORTACAO E EXPORTACAO LTDA","commercialName":"","cnpj":"00007750000195","city":"MOGI DAS CRUZES","stateCode":"SP","buscaAdicional":"PKO DO BRASIL 57915 PKO DO BRASIL 910255"},{"id":"59e9aa66-8b2e-4c41-6897-08d5ad2bf6ba","name":"CERAMICA E VELAS DE IGNICAO NGK DO BRASIL LTDA","commercialName":"","cnpj":"52541760000100","city":"MOGI DAS CRUZES","stateCode":"SP","buscaAdicional":"NGKNTK 60188 NGK MOGI 909906"},{"id":"4212da19-c57e-48cf-68c0-08d5ad2bf6ba","name":"RUD CORRENTES INDUSTRIAIS LTDA","commercialName":"","cnpj":"89519706000178","city":"MOGI DAS CRUZES","stateCode":"SP","buscaAdicional":"RUD 60391 RUD CORRENTES 911311"},{"id":"1e5a5917-871a-435f-6939-08d5ad2bf6ba","name":"SOCIEDADE EDUCACIONAL BRAZ CUBAS LTDA.","commercialName":"UNIVERSIDADE BRAZ CUBAS - UBC","cnpj":"52556412000106","city":"MOGI DAS CRUZES","stateCode":"SP","buscaAdicional":"BRAZ CUBAS 60848 U BRAZ CUBAS-MOGI 71613"},{"id":"1e19dfdd-fa3d-4fa5-738f-08d5cf600bef","name":"HELBOR EMPREENDIMENTOS S.A.","commercialName":"","cnpj":"49263189000102","city":"MOGI DAS CRUZES","stateCode":"SP","buscaAdicional":""},{"id":"5b4269dc-a109-416f-7394-08d5cf600bef","name":"CERAMICA CHIARELLI SA","commercialName":"","cnpj":"52736840000110","city":"MOGI GUAÇU","stateCode":"SP","buscaAdicional":""},{"id":"4eeb349c-4978-4b8d-62bc-08d5ad2bf6ba","name":"MINERACAO CAJU LTDA","commercialName":"","cnpj":"09425531000109","city":"MOGI GUAÇU","stateCode":"SP","buscaAdicional":"CAJU 54942 CAJU 33148171 904092 MINERACAO CAJU 904101"},{"id":"425e662c-df51-4940-5d3c-08d5ad2bf6ba","name":"ENDEKA CONSULTORIA E PARTICIPACOES LTDA","commercialName":"","cnpj":"23826603000142","city":"MOGI GUAÇU","stateCode":"SP","buscaAdicional":"ENDEKA CERAMICA 51744 ENDEKA - MOGI GUACU 899361"},{"id":"2b782706-dfed-4914-5d99-08d5ad2bf6ba","name":"SHOPPING BURITI MOGI EMPREENDIMENTO IMOBILIARIO SPE LTDA","commercialName":"","cnpj":"08406122000194","city":"MOGI GUAÇU","stateCode":"SP","buscaAdicional":"SC BURITI MOGI 51930 SHOPPING BURITI MOGI 898818"},{"id":"e1ff1a29-b26a-4d8e-610e-08d5ad2bf6ba","name":"SUPERMERCADO BIG BOM LTDA","commercialName":"SUPERMERCADO BIG BOM","cnpj":"50582170000108","city":"MOGI GUAÇU","stateCode":"SP","buscaAdicional":"BIG BOM 53987 BIG BOM CAPELA 905166 BIG BOM MOGI 905167 BIG BOM SAO JOAO 905175"},{"id":"e6e916ea-e0b8-44a9-603d-08d5ad2bf6ba","name":"PACKSEVEN - INDUSTRIA E COMERCIO LTDA","commercialName":"PACKSEVEN","cnpj":"01352926000109","city":"MOGI GUAÇU","stateCode":"SP","buscaAdicional":"PACKSEVEN 53434 PACKSEVEN 904223 PACKSEVEN INDUSTRIAL 904472"},{"id":"1f219d7d-ff61-4ebb-4fc0-08d5ad2bf6ba","name":"INTERNATIONAL PAPER DO BRASIL LTDA.","commercialName":"","cnpj":"52736949000158","city":"MOGI GUAÇU","stateCode":"SP","buscaAdicional":"IPAPER 1261 MOGI GUACU-CHAMPION 58 JARI CELULOSE N CAMP 71730 ORSA FRANCO ROCHA 72222 IPAPER RIO VERDE 907763"},{"id":"21ae107a-af95-4dde-535d-08d5ad2bf6ba","name":"MAHLE METAL LEVE S.A.","commercialName":"","cnpj":"60476884000187","city":"MOGI GUAÇU","stateCode":"SP","buscaAdicional":"MAHLE MET 3595 MMG-MAHLE 71129"},{"id":"7b877416-d840-475b-52be-08d5ad2bf6ba","name":"SOGEFI SUSPENSION BRASIL LTDA.","commercialName":"","cnpj":"02042860000113","city":"MOJI MIRIM","stateCode":"SP","buscaAdicional":"SOGEFI SUSPENSION 3269 ALLEVARD-MOGI MIRIM 70994"},{"id":"9d8bb009-b904-4c55-50bd-08d5ad2bf6ba","name":"TENNECO AUTOMOTIVE BRASIL LTDA","commercialName":"","cnpj":"44023471000190","city":"MOJI MIRIM","stateCode":"SP","buscaAdicional":"TENNECO 1813 TENNECO MOGI MIRIM 70198 TENNECO 906267"},{"id":"c32edd42-5226-432d-5098-08d5ad2bf6ba","name":"FUNDICAO REGALI BRASIL LTDA.","commercialName":"","cnpj":"07702969000153","city":"MOJI MIRIM","stateCode":"SP","buscaAdicional":"REGALI 1743 FUNDICAO REGALI 7531"},{"id":"9f004693-d39a-48b7-5768-08d5ad2bf6ba","name":"SOMAR - COOPERATIVA DE ENERGIA ELETRICA E DESENVOLVIMENTO","commercialName":"","cnpj":"08436783000162","city":"MOJI MIRIM","stateCode":"SP","buscaAdicional":"SOMAR ENERGIA 8810 APIAI 889060 CGH.PH.SP.000116-3.01"},{"id":"03dc80e3-5e23-493a-53c6-08d5ad2bf6ba","name":"MASTERFOODS BRASIL ALIMENTOS LTDA.","commercialName":"MARS BRASIL","cnpj":"29737368000119","city":"MOJI MIRIM","stateCode":"SP","buscaAdicional":"MARS BRASIL 3842 MARS RECIFE 71343 MASTERFOODS M.MIRIM 7095 MARS BRASIL 890013"},{"id":"501671c6-38ec-409f-62da-08d5ad2bf6ba","name":"SUPERMERCADOS LAVAPES SA","commercialName":"","cnpj":"52823770000138","city":"MOJI MIRIM","stateCode":"SP","buscaAdicional":"LAVAPES 55015 LAVAPES MOGI MIRIM 2 906691 LAVAPES RIO CLARO L7 906694 LAVAPES MATRIZ LJ 1 906701 LAVAPES VL CRIST. L8 906715"},{"id":"26195046-90f3-410d-6209-08d5ad2bf6ba","name":"CONSTRUTORA SIMOSO LTDA","commercialName":"","cnpj":"48169536000161","city":"MOJI MIRIM","stateCode":"SP","buscaAdicional":"SIMOSO 54510 CONSTRUTORA SIMOSO 904296"},{"id":"34007a81-a6df-4efe-6908-08d5ad2bf6ba","name":"INDUSTRIA ELETROMECANICA BALESTRO LTDA","commercialName":"BALESTRO","cnpj":"52770948000200","city":"MOJI MIRIM","stateCode":"SP","buscaAdicional":"BALESTRO 60734 BALESTRO FILIAL 912442"},{"id":"013b30ef-7874-430e-674b-08d5ad2bf6ba","name":"IRMAOS QUAGLIO CIA LTDA","commercialName":"","cnpj":"52769833000115","city":"MOJI MIRIM","stateCode":"SP","buscaAdicional":"IRMAOS QUAGLIO 58032 IRMAOS QUAGLIO 909460"},{"id":"b5ecbf94-4fe3-4501-73b7-08d5cf600bef","name":"BAUMER S A","commercialName":"","cnpj":"61374161000130","city":"MOJI MIRIM","stateCode":"SP","buscaAdicional":""},{"id":"8feafcce-3417-4483-6457-08d5ad2bf6ba","name":"NEOTILENO INDUSTRIA E COMERCIO LTDA","commercialName":"","cnpj":"96556949000141","city":"MOMBUCA","stateCode":"SP","buscaAdicional":"NEOTILENO 55938 NEOTILENO IND COM LT 907233"},{"id":"dfc86a23-f7b8-4b7b-616b-08d5ad2bf6ba","name":"FUNDICAO ZUBELA EIRELI","commercialName":"","cnpj":"56720287000189","city":"MONTE ALTO","stateCode":"SP","buscaAdicional":"FUNDICAO ZUBELA 54179 FUNDICAO ZUBELA 906399"},{"id":"ea901d3f-175e-4191-6887-08d5ad2bf6ba","name":"WABTEC BRASIL FABRICACAO E MANUTENCAO DE EQUIPAMENTOS LTDA.","commercialName":"","cnpj":"10763773000345","city":"MONTE ALTO","stateCode":"SP","buscaAdicional":"WABTEC 60117 WABTEC BRASIL FABRIC 910630"},{"id":"e98f32bd-6e11-444b-687e-08d5ad2bf6ba","name":"FUNDICAO B. B. LTDA.","commercialName":"","cnpj":"54560487000196","city":"MONTE ALTO","stateCode":"SP","buscaAdicional":"FUNDICAO BB 60102 FUNDICAO BB 910879"},{"id":"d206db56-52e1-401a-57cb-08d5ad2bf6ba","name":"WEG-CESTARI REDUTORES E MOTORREDUTORES S.A.","commercialName":"WEG-CESTARI","cnpj":"14759173000100","city":"MONTE ALTO","stateCode":"SP","buscaAdicional":"WEG-CESTARI 9669 WEG MONTE ALTO 889634"},{"id":"7814efe7-53cc-4fa1-5175-08d5ad2bf6ba","name":"HBA HUTCHINSON BRASIL AUTOMOTIVE LTDA","commercialName":"","cnpj":"52850682000125","city":"MONTE ALTO","stateCode":"SP","buscaAdicional":"HBA 2191 HBA FABRICA IV 70564 HBA FAB V-EXTREMA 71876 HBA FAB I-MONTE ALTO 72020 HBA CASA BRANCA 888456 HBA FAB 2-MONTE ALTO 71830"},{"id":"505c60a1-0339-437d-5dc9-08d5ad2bf6ba","name":"FUGINI ALIMENTOS LTDA","commercialName":"","cnpj":"00588458000103","city":"MONTE ALTO","stateCode":"SP","buscaAdicional":"FUGINI 51986 FUGINI 901816"},{"id":"1466e0e6-62c7-4a70-5e9f-08d5ad2bf6ba","name":"IND E COM DE PROD ALIM CEPERA LTDA","commercialName":"INDUSTRIA E COM. DE PRODUTOS ALIMENTICIOS CEPERA LTDA","cnpj":"62162243000345","city":"MONTE ALTO","stateCode":"SP","buscaAdicional":"CEPERA 52466 CEPERA ALIMENTOS 902003"},{"id":"b83ac19a-a8bc-4218-550f-08d5ad2bf6ba","name":"MONTE AZUL EMPREENDIMENTOS IMOBILIARIOS E GERACAO DE ENERGIA LTDA","commercialName":"","cnpj":"13963234000186","city":"MONTE AZUL PAULISTA","stateCode":"SP","buscaAdicional":"MONTE AZUL 4980 BERNARDO FIGUEIREDO 8947 CGH.PH.SP.000884-2.01"},{"id":"3ba4edf7-7e6a-4b1d-54cd-08d5ad2bf6ba","name":"G V S DO BRASIL LTDA","commercialName":"","cnpj":"02527107000118","city":"MONTE MOR","stateCode":"SP","buscaAdicional":"GVS 4508 GVS DO BRASIL-M MOR 71720"},{"id":"5ecaadff-53cb-4b5a-511a-08d5ad2bf6ba","name":"TETRA PAK LTDA","commercialName":"","cnpj":"61528030000160","city":"MONTE MOR","stateCode":"SP","buscaAdicional":"TETRA PAK 1996 TETRAPACK MTZ MONTEM 70373 TETRA PACK-P GROSSA 71888"},{"id":"bfe1cf33-4c7e-4833-504f-08d5ad2bf6ba","name":"MARTINREA HONSEL BRASIL FUNDICAO E COMERCIO DE PECAS EM ALUMINIO LTDA.","commercialName":"MARTINREA-HONSEL","cnpj":"56990526000110","city":"MONTE MOR","stateCode":"SP","buscaAdicional":"MARTINREA 1565 MAGAL MONTE MOR 70007"},{"id":"b9af2b7c-c636-48b9-666d-08d5ad2bf6ba","name":"STRUCS E MONTEIRO COMERCIO E INDUSTRIA DE PECAS EM FERRO E ACO LTDA","commercialName":"STRUCS E MONTEIRO","cnpj":"23159930000198","city":"MONTE MOR","stateCode":"SP","buscaAdicional":"FUNDICAO LTK 57555 STRUCS 908465"},{"id":"3ded37fc-6ac9-4eb7-65f7-08d5ad2bf6ba","name":"SINTER FUTURA LTDA","commercialName":"","cnpj":"74222563000160","city":"MONTE MOR","stateCode":"SP","buscaAdicional":"SINTER FUTURA 57239 SINTER FUTURA MG 908110 SINTER FUTURA M MOR 908152"},{"id":"ca576041-3945-440c-6150-08d5ad2bf6ba","name":"ASVOTEC TERMOINDUSTRIAL LTDA","commercialName":"","cnpj":"56995681000200","city":"MONTE MOR","stateCode":"SP","buscaAdicional":"ASVOTEC 54119 ASVOTEC TERMO 905735"},{"id":"1b6b7c50-9fb9-469d-51ae-08d5ad2bf6ba","name":"BIOSEV BIOENERGIA S.A.","commercialName":"BIOSEV BIOENERGIA","cnpj":"49213747011585","city":"MORRO AGUDO","stateCode":"SP","buscaAdicional":"MB 2496 BIOSEV CONSUMO MB 908906 MB 562 UTE.AI.SP.001449-4.01"},{"id":"4860acf7-ad33-4573-50d0-08d5ad2bf6ba","name":"FIACAO ALPINA LTDA","commercialName":"","cnpj":"49418890000145","city":"MORUNGABA","stateCode":"SP","buscaAdicional":"ALPINA 1856 ALPINA FIAC. VOTORAN 70233 FIACAO ALPINA MORUNG 70762"},{"id":"44944740-9ae1-4854-5c15-08d5ad2bf6ba","name":"GRECO & GUERREIRO LTDA","commercialName":"GUERREIRO","cnpj":"62321138000140","city":"MORUNGABA","stateCode":"SP","buscaAdicional":"GRECO & GUERREIRO 51078 GRECO E GUERREIRO 898263 GRECO GUERREIRO FILI 905713 CRA MAIS 909433"},{"id":"73c3b3b8-4622-4438-5675-08d5ad2bf6ba","name":"UMOE BIOENERGY S.A.","commercialName":"","cnpj":"03445208000102","city":"NARANDIBA","stateCode":"SP","buscaAdicional":"UMOE BIOENERGY 7104 UMOE BIOENERGY S.A. 907811 PARANAPANEMA UMOE 8994 UTE.AI.SP.030561-8.01"},{"id":"49742fe2-2ddd-49a9-6087-08d5ad2bf6ba","name":"GIOPLAST INDUSTRIA E COMERCIO LTDA","commercialName":"","cnpj":"03959052000188","city":"NAZARÉ PAULISTA","stateCode":"SP","buscaAdicional":"GIOPLAST 53579 GIOPLAST INDUSTRIA 902687"},{"id":"40467f4d-8d9f-47d3-5478-08d5ad2bf6ba","name":"CENI - CENTRAL ENERGETICA NOVA INDEPENDENCIA S/A","commercialName":"CENI","cnpj":"10746559000119","city":"NOVA INDEPENDÊNCIA","stateCode":"SP","buscaAdicional":"CENI 4279 BIO IPE (CENI) 8996 UTE.AI.SP.030268-6.01"},{"id":"6740fb8c-0447-4d10-1cd6-08d5b8870181","name":"BVE - BELA VISTA ENERGETICA S/A","commercialName":"","cnpj":"29294622000151","city":"NOVA INDEPENDÊNCIA","stateCode":"SP","buscaAdicional":"BVE 62235 CENI (BVE) 913251 UTE.AI.SP.037341-9.01"},{"id":"39717a00-5ee1-487e-73e4-08d5cf600bef","name":"LUPATECH S/A","commercialName":"","cnpj":"89463822000112","city":"NOVA ODESSA","stateCode":"SP","buscaAdicional":""},{"id":"91611edb-0997-496c-6168-08d5ad2bf6ba","name":"PROFIL INDUSTRIA E COMERCIO DE FIOS LTDA.","commercialName":"","cnpj":"64064777000100","city":"NOVA ODESSA","stateCode":"SP","buscaAdicional":"PROFIL 54176 PROFIL 905100"},{"id":"aacb800d-b8fc-43b3-632f-08d5ad2bf6ba","name":"SENIR EMBALAGENS LTDA","commercialName":"","cnpj":"05953723000129","city":"NOVA ODESSA","stateCode":"SP","buscaAdicional":"SENIR 55238 SENIR EMBALAGENS LTD 906015"},{"id":"9869732e-35d8-49e7-649b-08d5ad2bf6ba","name":"COOPERATIVA NOVA ESPERANCA","commercialName":"CONES","cnpj":"02756023000156","city":"NOVA ODESSA","stateCode":"SP","buscaAdicional":"CONES 56132 CONES FILIAL 908154 CONES MATRIZ 908155"},{"id":"5370774f-9ad4-4abb-6749-08d5ad2bf6ba","name":"METROVAL CONTROLE DE FLUIDOS LTDA","commercialName":"","cnpj":"58762956000100","city":"NOVA ODESSA","stateCode":"SP","buscaAdicional":"METROVAL 58030 METROVAL CON FLUIDOS 909988"},{"id":"6d9ebd99-b6b3-49e0-674a-08d5ad2bf6ba","name":"PEDREIRA FAZENDA VELHA LTDA","commercialName":"","cnpj":"43249366000101","city":"NOVA ODESSA","stateCode":"SP","buscaAdicional":"PEDREIRA FAZENDA VELHA 58031 PEDREIRA FAZ VELHA 910400"},{"id":"f50c6b05-912c-4f39-66f7-08d5ad2bf6ba","name":"BEFITEX BENEFICIAMENTO DE FIOS TEXTEIS LTDA","commercialName":"","cnpj":"52022134000107","city":"NOVA ODESSA","stateCode":"SP","buscaAdicional":"BEFITEX 57902 BEFITEX 907460"},{"id":"1438e6c8-b2cf-4deb-539d-08d5ad2bf6ba","name":"NOVA PLAST INDUSTRIA E COMERCIO LTDA","commercialName":"","cnpj":"43265313000184","city":"NOVA ODESSA","stateCode":"SP","buscaAdicional":"NOVA PLAST 3730 NOVA PLAST N ODESSA 71274"},{"id":"40f3e924-dd4c-4ff2-5577-08d5ad2bf6ba","name":"JOFEGE FIACAO E TECELAGEM LTDA","commercialName":"","cnpj":"65577892000303","city":"NOVA ODESSA","stateCode":"SP","buscaAdicional":"JOFEGE FILIAL 5690 JOFEGE FIL-N ODESSA 71838"},{"id":"2e6bffd2-b3e7-40e4-558a-08d5ad2bf6ba","name":"TINTEX TINTURARIA TEXTIL LTDA","commercialName":"","cnpj":"65613960000172","city":"NOVA ODESSA","stateCode":"SP","buscaAdicional":"TINTEX 5761 TINTEX-NOVA ODESSA 71845"},{"id":"ab1b89f3-6dd9-45cd-57b1-08d5ad2bf6ba","name":"BENEFICIADORA DE TECIDOS SAO JOSE LTDA","commercialName":"","cnpj":"68185693000178","city":"NOVA ODESSA","stateCode":"SP","buscaAdicional":"BENEFICIADORA 9349 BENEFICIADORA S JOSE 888832"},{"id":"daea1b8c-b177-49d6-5749-08d5ad2bf6ba","name":"ORTOFIO INDUSTRIA COMERCIO E SERVICOS LTDA","commercialName":"","cnpj":"01888285000101","city":"NOVA ODESSA","stateCode":"SP","buscaAdicional":"ORTOFIO 8489 ORTOFIO NOVA ODESSA 888319"},{"id":"c9e6a7cf-6790-4e6e-50a1-08d5ad2bf6ba","name":"TECELAGEM DE FITAS SANTA JULIA LTDA","commercialName":"SANTA JULIA","cnpj":"43245992000120","city":"NOVA ODESSA","stateCode":"SP","buscaAdicional":"HUDTELFA 1757 TEC.S.JULIA N.ODESSA 70224"},{"id":"4fddcf0b-9f4d-4a97-4fd4-08d5ad2bf6ba","name":"KSPG AUTOMOTIVE BRAZIL LTDA.","commercialName":"","cnpj":"57576274000140","city":"NOVA ODESSA","stateCode":"SP","buscaAdicional":"KS PISTOES 1298 KS PISTOES 138KV NO 7917"},{"id":"5ff0bb20-bc58-41c5-5002-08d5ad2bf6ba","name":"OBER SA INDUSTRIA E COMERCIO","commercialName":"OBER","cnpj":"43238138000136","city":"NOVA ODESSA","stateCode":"SP","buscaAdicional":"OBER 1401 OBER NOVA ODESSA 7428"},{"id":"eab399c9-dc7e-4165-52b0-08d5ad2bf6ba","name":"GUERREIRO INDUSTRIA COMERCIO IMPORTACAO E EXPORTACAO LTDA","commercialName":"","cnpj":"46529590000307","city":"NOVA ODESSA","stateCode":"SP","buscaAdicional":"GUERREIRO 3239 GUERREIRO INDUSTRIAL 71038"},{"id":"208b92a5-cb93-4362-5a81-08d5ad2bf6ba","name":"TECELAGEM JOLITEX LTDA","commercialName":"","cnpj":"43237254000564","city":"NOVA ODESSA","stateCode":"SP","buscaAdicional":"JOLITEX NOVA ODESSA 49845 JOLITEX NOVA ODESSA 897452"},{"id":"367043b3-0227-433d-50d5-08d5ad2bf6ba","name":"USINA SANTA ISABEL S/A","commercialName":"USINA SANTA ISABEL - UNIDADE NOVO HORIZONTE","cnpj":"47524632000118","city":"NOVO HORIZONTE","stateCode":"SP","buscaAdicional":"SANTAISABEL 1866 SANTA ISABEL RC 70821 UTE FARTURA - CONS 71490 F. MEND - S. ISABEL 8751 UTE.AI.SP.029203-6.01 UTE SANTA ISABEL 8415 UTE.AI.SP.028401-7.01"},{"id":"fba0733f-8e1a-4d38-54b2-08d5ad2bf6ba","name":"UTE SAO JOSE DA ESTIVA S.A.","commercialName":"UTE SAO JOSE DA ESTIVA","cnpj":"12013814000140","city":"NOVO HORIZONTE","stateCode":"SP","buscaAdicional":"UTE S.J.ESTIVA 4443 SAO JOSE DA ESTIVA 546 UTE.AI.SP.027814-9.01"},{"id":"88bb1551-5161-4306-541e-08d5ad2bf6ba","name":"TEREOS ACUCAR E ENERGIA BRASIL S.A.","commercialName":"GUARANI S.A.","cnpj":"47080619000117","city":"OLÍMPIA","stateCode":"SP","buscaAdicional":"GUARANI 4020 MANDU GR 888135 UTE.AI.SP.027787-8.01 GUARANI OLIMPIA 8004 UTE.AI.SP.027796-7.01 GUARANI TANABI 892646 UTE.AI.SP.030095-0.01 GUARANI TANABI 2 895701 UTE.AI.SP.031445-5.01"},{"id":"19faadb2-bdc4-4896-6692-08d5ad2bf6ba","name":"CONDUMAX - ELETRO METALURGICA CIAFUNDI LTDA","commercialName":"","cnpj":"53224127000584","city":"OLÍMPIA","stateCode":"SP","buscaAdicional":"CONDUMAX E 57658 CONDUMAX 903815"},{"id":"bc1dddb0-65a3-490f-6621-08d5ad2bf6ba","name":"CIA FERRASA DE EMPREENDIMENTOS TURISTICOS","commercialName":"","cnpj":"19046302000129","city":"OLÍMPIA","stateCode":"SP","buscaAdicional":"HOT BEACH 57332 CIA FERRASA HOTBEACH 906684"},{"id":"a292d559-fd8b-4537-6965-08d5ad2bf6ba","name":"PLANETUR PLANEJAMENTO E DESENVOLVIMENTO URBANO LTDA","commercialName":"PLANETUR","cnpj":"04131308000127","city":"OLÍMPIA","stateCode":"SP","buscaAdicional":"PLANETUR 61137 PLANETUR 911802"},{"id":"ac0ef4cb-2ccd-40de-64bd-08d5ad2bf6ba","name":"FIBRA OLIMPIA ADMINISTRACAO E PARTICIPACOES LTDA","commercialName":"ACQUA THERMAS","cnpj":"14095553000180","city":"OLÍMPIA","stateCode":"SP","buscaAdicional":"THERMAS 56190 ACQUA THERMAS 907271"},{"id":"dcf5d792-15ed-4f98-5114-08d5ad2bf6ba","name":"USINA MOEMA ACUCAR E ALCOOL LTDA","commercialName":"USINA MOEMA","cnpj":"49972326000170","city":"ORINDIÚVA","stateCode":"SP","buscaAdicional":"USMOEMA 1985 MOEMA ORINDIUVA 8224 UTE.AI.SP.027886-6.01"},{"id":"49e5c180-a637-48d0-57c6-08d5ad2bf6ba","name":"MORLAN S/A","commercialName":"USINA SAO BENEDITO","cnpj":"53309795000180","city":"ORLÂNDIA","stateCode":"SP","buscaAdicional":"MORLAN 9609 MORLAN AV9 901695 MORLAN 889080"},{"id":"46b32098-de4c-42bd-55e4-08d5ad2bf6ba","name":"SINA INDUSTRIA DE ALIMENTOS LTDA","commercialName":"SINA ORLANDIA","cnpj":"10156658000302","city":"ORLÂNDIA","stateCode":"SP","buscaAdicional":"SINA ORLANDIA 6290 SINA ALIM-ORLANDIA 72008"},{"id":"35ca52c7-ec9c-4e8c-5c9b-08d5ad2bf6ba","name":"INTELLI INDUSTRIA DE TERMINAIS ELETRICOS LTDA","commercialName":"INTELLI","cnpj":"46754545000194","city":"ORLÂNDIA","stateCode":"SP","buscaAdicional":"INTELLI 51398 INTELLI 901081 INTELLI COBREACAO 904408"},{"id":"6b720fd9-0935-44d8-64ee-08d5ad2bf6ba","name":"PRODUTOS ALIMENTICIOS ORLANDIA S A COMERCIO E INDUSTRIA","commercialName":"ARROZ BREJEIRO","cnpj":"53309845000120","city":"ORLÂNDIA","stateCode":"SP","buscaAdicional":"BREJEIRO 56317 BREJEIRO 906865"},{"id":"c992a56d-f4cc-4600-6351-08d5ad2bf6ba","name":"EDIFICIO GALERIA FUAD AUADA","commercialName":"","cnpj":"59061259000195","city":"OSASCO","stateCode":"SP","buscaAdicional":"EDIFICIO GALERIA FUAD AUADA 55309 ED GALERIA FUAD 905848"},{"id":"c7d89cc3-fa5b-4c18-62fb-08d5ad2bf6ba","name":"BRASPOR GRAFICA E EDITORA LTDA.","commercialName":"","cnpj":"07263666000181","city":"OSASCO","stateCode":"SP","buscaAdicional":"BRASPOR 55067 BRASPOR 904765"},{"id":"69231866-0530-4cbb-62ef-08d5ad2bf6ba","name":"RFG COMERCIO, TRANSPORTES E SERVICOS LTDA.","commercialName":"","cnpj":"49319411000133","city":"OSASCO","stateCode":"SP","buscaAdicional":"MARTIN BROWER 55050 M. BROWER 201217944 906265 M BROWER 201384878 906275 MARTIN BROWER CTB 906234"},{"id":"e2a371f9-1936-4d13-62b0-08d5ad2bf6ba","name":"CONDOMINIO ORDINARIO DO SHOPPING UNIAO DE OSASCO","commercialName":"","cnpj":"13383188000146","city":"OSASCO","stateCode":"SP","buscaAdicional":"SHOPPING UNIAO 54921 SHOP UNIAO DE OSASCO 906440"},{"id":"90c05ff1-9865-4520-6263-08d5ad2bf6ba","name":"DACARTO BENVIC LTDA.","commercialName":"","cnpj":"62143847000182","city":"OSASCO","stateCode":"SP","buscaAdicional":"DACARTO 54742 DACARTO OSASCO SP 905856"},{"id":"e1c7ffb8-519d-4bcb-67d4-08d5ad2bf6ba","name":"DROGARIA SAO PAULO S.A.","commercialName":"DROGARIA SAO PAULO","cnpj":"61412110052384","city":"OSASCO","stateCode":"SP","buscaAdicional":"DROGARIA SP 58662 DROGARIA SAO PAULO 908303"},{"id":"bef39fce-652b-43c2-6810-08d5d153df4d","name":"NCF PARTICIPACOES S.A.","commercialName":"","cnpj":"04233319000118","city":"OSASCO","stateCode":"SP","buscaAdicional":""},{"id":"0648d3ff-b3f7-492c-721c-08d5cf600bef","name":"B2W COMPANHIA DIGITAL","commercialName":"","cnpj":"00776574000156","city":"OSASCO","stateCode":"SP","buscaAdicional":""},{"id":"b2302fbc-6335-4ad8-73af-08d5cf600bef","name":"COBRASMA S A","commercialName":"","cnpj":"61080313000191","city":"OSASCO","stateCode":"SP","buscaAdicional":""},{"id":"896e5818-5bed-4b86-73a5-08d5cf600bef","name":"BANCO BRADESCO S.A.","commercialName":"BRADESCO EST UNIF","cnpj":"60746948000112","city":"OSASCO","stateCode":"SP","buscaAdicional":""},{"id":"8587758c-9c32-4d00-738e-08d5cf600bef","name":"BRADESCO LEASING S.A. - ARRENDAMENTO MERCANTIL","commercialName":"","cnpj":"47509120000182","city":"OSASCO","stateCode":"SP","buscaAdicional":""},{"id":"9bd431d5-13d6-4896-5e64-08d5ad2bf6ba","name":"POLI-NUTRI ALIMENTOS S.A.","commercialName":"","cnpj":"60210515000148","city":"OSASCO","stateCode":"SP","buscaAdicional":"POLI-NUTRI 52348 POLINUTRI ALIMENTOS 900022 POLINUTRI 902733 POLI NUTRI ALIMENTO 900640"},{"id":"60eaffbc-d9bb-4cf7-5e85-08d5ad2bf6ba","name":"ADMINISTRADORA OSASCO PLAZA SHOPPING LTDA","commercialName":"ADMINISTRADORA OSASCO PLAZA SHOPPING LTDA","cnpj":"00633053000140","city":"OSASCO","stateCode":"SP","buscaAdicional":"OSASCO PLAZA 52413 OSASCO PLAZA 901979"},{"id":"ee37d8c2-26bf-4282-5e6e-08d5ad2bf6ba","name":"CONDOMINIO PRO INDIVISO DO SUPERSHOPPING OSASCO","commercialName":"","cnpj":"08174968000146","city":"OSASCO","stateCode":"SP","buscaAdicional":"SUPERSHOPPING OSASCO 52383 SUPERSHOPPING OSASCO 904422"},{"id":"d12c7e18-1b73-4779-5e66-08d5ad2bf6ba","name":"TVSBT CANAL 4 DE SAO PAULO S/A","commercialName":"TVS - EMISSORA DO SISTEMA BRASILEIRO DE TELEVISAO","cnpj":"45039237000114","city":"OSASCO","stateCode":"SP","buscaAdicional":"SBT 52351 SBT 901818 SBT SUMARE 904546"},{"id":"18dcf066-aefc-406e-60a2-08d5ad2bf6ba","name":"RR DONNELLEY EDITORA E GRAFICA LTDA.","commercialName":"","cnpj":"62004395000158","city":"OSASCO","stateCode":"SP","buscaAdicional":"RR DONNELLEY MATRIZ 53621 RR DONNELLEY BARUERI 900056 RR DONNELEY FILIAL 908918"},{"id":"f33d4480-a4ca-4f95-5ef6-08d5ad2bf6ba","name":"INDUSTRIAS ANHEMBI LTDA.","commercialName":"ANHEMBI","cnpj":"55116131000120","city":"OSASCO","stateCode":"SP","buscaAdicional":"ANHEMBI 52670 INDUSTRIAS ANHEMBI 900532"},{"id":"10df0ab0-49e3-4bfe-5c19-08d5ad2bf6ba","name":"CONDOMINIO OPERACIONAL FOODTOWN OSASCO","commercialName":"","cnpj":"02633258000150","city":"OSASCO","stateCode":"SP","buscaAdicional":"COND FOODTOWN 51082 CD. FOODTOWN OSASCO 898566"},{"id":"6f542c1b-146f-4fdc-5ba8-08d5ad2bf6ba","name":"METALSA BRASIL INDUSTRIA E COMERCIO DE AUTOPECAS LTDA.","commercialName":"","cnpj":"11352784000133","city":"OSASCO","stateCode":"SP","buscaAdicional":"METALSA 50813 METALSA 898260"},{"id":"5735cff0-11b2-4a6b-591c-08d5ad2bf6ba","name":"BBRG OSASCO CABOS LTDA","commercialName":"","cnpj":"19552481000176","city":"OSASCO","stateCode":"SP","buscaAdicional":"BEKAERT C 13835 BEKAERT C 892943"},{"id":"e65fa8b2-f947-4ca8-50c2-08d5ad2bf6ba","name":"TEC2DOC SERVICOS DE TECNOLOGIA E DOCUMENTOS LTDA","commercialName":"AGAPRINT","cnpj":"18204610000172","city":"OSASCO","stateCode":"SP","buscaAdicional":"CERTA 1826 AGAPRINT-OSASCO 72017"},{"id":"1c3312a8-a592-4b3a-5048-08d5ad2bf6ba","name":"MERITOR DO BRASIL SISTEMAS AUTOMOTIVOS LTDA.","commercialName":"","cnpj":"56669187000922","city":"OSASCO","stateCode":"SP","buscaAdicional":"ARVINMERITOR 1555 ARVINMERITOR-OSASCO 7979"},{"id":"e0704819-c905-4538-5211-08d5ad2bf6ba","name":"USINA SAO LUIZ S A","commercialName":"","cnpj":"53408860000125","city":"OURINHOS","stateCode":"SP","buscaAdicional":"SAO LUIZ I5 2844 USINA SAO LUIZ CARGA 905353 SAO LUIZ-OURINHOS 8539 UTE.AI.SP.028060-7.01"},{"id":"e79ef152-94c2-4c41-54b4-08d5ad2bf6ba","name":"INJEX INDUSTRIAS CIRURGICAS LTDA","commercialName":"","cnpj":"59309302000199","city":"OURINHOS","stateCode":"SP","buscaAdicional":"INJEX 4448 INJEX-OURINHOS SP 71575 INJEX PEN - OURINHOS 908098"},{"id":"6a52444b-f011-41f6-65ce-08d5ad2bf6ba","name":"DISTRIBUIDORA DE BEBIDAS MAITAN LTDA","commercialName":"MAITAN ATACADO E VAREJO","cnpj":"45963444000160","city":"OURINHOS","stateCode":"SP","buscaAdicional":"MAITAN ATACADO E VAREJO 57140 MAITAN MATRIZ 909413 MAITAN FILIAL 909414"},{"id":"7e54b6dd-0378-4d8c-66f8-08d5ad2bf6ba","name":"INDUSTRIAL E COMERCIAL MARVI LTDA","commercialName":"","cnpj":"53408654000115","city":"OURINHOS","stateCode":"SP","buscaAdicional":"MARVI 57905 MARVI OURINHOS 908742"},{"id":"49fff3d5-db3e-4589-66c1-08d5ad2bf6ba","name":"CERAMICA TETO FORTE LTDA.","commercialName":"","cnpj":"14153094000143","city":"OURINHOS","stateCode":"SP","buscaAdicional":"CERAMICA TETO FORTE 57787 TETO FORTE 908743"},{"id":"58679570-e92d-4b19-618e-08d5ad2bf6ba","name":"CERAMICA DE TELHAS SANTA BARBARA LTDA","commercialName":"","cnpj":"51991958000122","city":"OURINHOS","stateCode":"SP","buscaAdicional":"CERAMICA SANTA BARBARA 54240 CERAMICA STA BARBARA 907360"},{"id":"736bda5a-1e37-413a-618a-08d5ad2bf6ba","name":"CERAMICA SAO SEBASTIAO DE OURINHOS LTDA","commercialName":"CERAMICA SAO SEBASTIAO","cnpj":"05789150000140","city":"OURINHOS","stateCode":"SP","buscaAdicional":"CERAMICA SAO SEBASTIAO 54229 CERAMICA S SEBASTIAO 907059"},{"id":"5798bffc-ca20-4d73-640b-08d5ad2bf6ba","name":"IND E COM DE COLCHOES CASTOR LTDA","commercialName":"COLCHOES CASTOR","cnpj":"53424594000124","city":"OURINHOS","stateCode":"SP","buscaAdicional":"COLCHOES CASTOR 55807 COLCHOES CASTOR 906895 COLCHOES CASTOR 2 906896"},{"id":"363e8db9-0d1b-42e9-541c-08d5ad2bf6ba","name":"USINA OUROESTE - ACUCAR E ALCOOL LTDA","commercialName":"USINA OUROESTE","cnpj":"05553456000100","city":"OUROESTE","stateCode":"SP","buscaAdicional":"OUROESTE 4016 OUROESTE 8840 UTE.AI.SP.029292-3.01"},{"id":"dd07d43e-2948-42ac-5729-08d5ad2bf6ba","name":"TEREOS AMIDO E ADOCANTES BRASIL S.A.","commercialName":"","cnpj":"65882680000160","city":"PALMITAL","stateCode":"SP","buscaAdicional":"SYRAL HALOTEK 8269 SYRAL HALOTEK 889398"},{"id":"0506c399-1a32-4a9d-53ba-08d5ad2bf6ba","name":"COCAL COMERCIO INDUSTRIA CANAA ACUCAR E ALCOOL LTDA","commercialName":"COCAL","cnpj":"44373108000103","city":"PARAGUAÇU PAULISTA","stateCode":"SP","buscaAdicional":"UTE CANAA 3808 COCAL II 8499 UTE.AI.SP.029713-5.01"},{"id":"d369a3b0-88d1-45dd-4f46-08d5ad2bf6ba","name":"COCAL TERMOELETRICA S/A","commercialName":"COCAL","cnpj":"04813138000160","city":"PARAGUAÇU PAULISTA","stateCode":"SP","buscaAdicional":"UTE COCAL 192 UTE COCAL 8298 UTE.AI.SP.027974-9.01"},{"id":"b0748987-5bdc-408e-6347-08d5ad2bf6ba","name":"RODOSERV STAR LTDA","commercialName":"RODOSERV STAR","cnpj":"04341874000163","city":"PARDINHO","stateCode":"SP","buscaAdicional":"RODOSERV STAR 55287 RODOSERV STAR 907796"},{"id":"89bd76a1-1d72-465f-52c5-08d5ad2bf6ba","name":"CENTRAL ENERGETICA VALE DO SAPUCAI LTDA","commercialName":"","cnpj":"00372496000124","city":"PATROCÍNIO PAULISTA","stateCode":"SP","buscaAdicional":"UTE CEVASA 3281 UTE CEVASA - CONSUMO 904533 CEVASA 8719 UTE.AI.SP.028458-0.01"},{"id":"06288bea-29b4-4402-538c-08d5ad2bf6ba","name":"USINA DE LATICINIOS JUSSARA SA","commercialName":"","cnpj":"47964911000100","city":"PATROCÍNIO PAULISTA","stateCode":"SP","buscaAdicional":"JUSSARA 3692 JUSSARA ARAXA 891704 JUSSARA 71365"},{"id":"ea357054-cd57-4a85-5f4a-08d5ad2bf6ba","name":"PERFETTO ALIMENTOS S.A.","commercialName":"","cnpj":"02115262000127","city":"PATROCÍNIO PAULISTA","stateCode":"SP","buscaAdicional":"PERFETTO 52888 PERFETTO 905099"},{"id":"bb6f4378-2e3e-4969-60f1-08d5ad2bf6ba","name":"SOLENIS ESPECIALIDADES QUIMICAS LTDA.","commercialName":"","cnpj":"55720908000242","city":"PAULÍNIA","stateCode":"SP","buscaAdicional":"HERCULES QUIMICOS 53909 SOLENIS PAULINIA 901508"},{"id":"1c5bc775-4407-4967-604a-08d5ad2bf6ba","name":"IMERYS PERLITA PAULINIA MINERAIS LTDA","commercialName":"","cnpj":"01045120000178","city":"PAULÍNIA","stateCode":"SP","buscaAdicional":"IMERYS PAULINIA 53453 IMERYS PAULINI 904025"},{"id":"8ec2d72e-48bb-4078-5d3e-08d5ad2bf6ba","name":"BONSUCESSO INDUSTRIA TEXTIL LTDA","commercialName":"BONSUCESSO","cnpj":"04323586000186","city":"PAULÍNIA","stateCode":"SP","buscaAdicional":"BONSUCESSO 51746 BONSUCESSO INDUSTRIA 898730"},{"id":"9267ec7c-836d-4129-59ee-08d5ad2bf6ba","name":"INVISTA FIBRAS E POLIMEROS BRASIL LTDA.","commercialName":"","cnpj":"00021096000417","city":"PAULÍNIA","stateCode":"SP","buscaAdicional":"INVISTA FIBRAS 15995 INVISTA NYLON 7196"},{"id":"ae1de9dc-464c-4d7c-580f-08d5ad2bf6ba","name":"BRASWELL PAPEL E CELULOSE LTDA.","commercialName":"","cnpj":"11778932000186","city":"PAULÍNIA","stateCode":"SP","buscaAdicional":"BRASWELL 10512 BRASWELL 890913"},{"id":"824133fb-f634-45bc-583c-08d5ad2bf6ba","name":"INVIVO NUTRICAO E SAUDE ANIMAL LTDA","commercialName":"","cnpj":"06066837000896","city":"PAULÍNIA","stateCode":"SP","buscaAdicional":"INVIVO PAULINIA 11072 INVIVO PAULINIA 71060"},{"id":"c4b40732-6a8a-4233-5b8e-08d5ad2bf6ba","name":"STEEL WAREHOUSE CISA INDUSTRIAS DE ACO LTDA.","commercialName":"","cnpj":"21109652000139","city":"PAULÍNIA","stateCode":"SP","buscaAdicional":"SWC 50761 STEEL WAREHOUSE SP 898835"},{"id":"497e3c00-3953-45f9-5375-08d5ad2bf6ba","name":"ORION ENGINEERED CARBONS LTDA.","commercialName":"","cnpj":"11931402000126","city":"PAULÍNIA","stateCode":"SP","buscaAdicional":"ORION CARBONS 3641 ORION CARBONS 70246"},{"id":"e4a0d925-dbc5-4627-55d3-08d5ad2bf6ba","name":"KRATON POLYMERS DO BRASIL INDUSTRIA E COMERCIO DE PRODUTOS PETROQUIMICOS LTDA.","commercialName":"","cnpj":"03528802000167","city":"PAULÍNIA","stateCode":"SP","buscaAdicional":"KRATON 6223 KRATON POLYMERS 72086"},{"id":"77f594d5-f5f2-47c2-52f6-08d5ad2bf6ba","name":"BOEHRINGER INGELHEIM ANIMAL HEALTH DO BRASIL LTDA.","commercialName":"","cnpj":"57600249000155","city":"PAULÍNIA","stateCode":"SP","buscaAdicional":"MERIAL 3378 MERIAL 70697"},{"id":"c9478e7c-8531-4a9a-51cd-08d5ad2bf6ba","name":"GALVANI INDUSTRIA, COMERCIO E SERVICOS S.A.","commercialName":"","cnpj":"00546997000180","city":"PAULÍNIA","stateCode":"SP","buscaAdicional":"UTE GALVANI 2598 LAGAMAR I 71209 LAGAMAR II 71299 GALVANI CARGA 898166 GALVANI - ANGICO 897986 UTE GALVANI-CARGA 71391 GALVANI - CILEM 889659 UTE.PE.BA.030174-4.01 GALVANI 8376 UTE.AI.SP.001017-0.01"},{"id":"e7be3f48-bbbf-46a4-4fa6-08d5ad2bf6ba","name":"PLASTIPAK PACKAGING DO BRASIL LTDA","commercialName":"","cnpj":"01115825000114","city":"PAULÍNIA","stateCode":"SP","buscaAdicional":"PLASTIPAK PAULINIA 1212 PLASTIPAK PAULINIA 7561 PLASTIPAK AGOSTINHO 71767"},{"id":"58059dbb-f15e-4e8b-503f-08d5ad2bf6ba","name":"TEREFTALICOS INDUSTRIAS QUIMICAS LTDA","commercialName":"","cnpj":"57617565000130","city":"PAULÍNIA","stateCode":"SP","buscaAdicional":"TEREFTALICOS 1538 RHODIACO PAULINIA 7984"},{"id":"8f7d6114-1f7d-4992-66ad-08d5ad2bf6ba","name":"LUBRIFICANTES FENIX LTDA","commercialName":"","cnpj":"59723874000110","city":"PAULÍNIA","stateCode":"SP","buscaAdicional":"LUBRIFICANTES FENIX 57741 LUBR FENIX PAULINIA 908577"},{"id":"e62d36da-e74a-46d5-66d0-08d5ad2bf6ba","name":"GALVANI MINERACAO E PARTICIPACOES LTDA.","commercialName":"","cnpj":"44632347000122","city":"PAULÍNIA","stateCode":"SP","buscaAdicional":"GALVANI MINERACAO 57837 GALVANI MINERACAO 908871"},{"id":"0cf39224-9096-4228-66fe-08d5ad2bf6ba","name":"SUPERMERCADO JARDIM DOS CALEGARIS LTDA","commercialName":"","cnpj":"54255906000186","city":"PAULÍNIA","stateCode":"SP","buscaAdicional":"SUPERMERCADO CALEGARIS 57914 CALEGARIS MATRIZ 909177 CALEGARIS FILIAL 909181"},{"id":"d528a74c-d4da-41f6-6767-08d5ad2bf6ba","name":"SUOMINEN BRASIL INDUSTRIA E COMERCIO DE NAO-TECIDOS LTDA.","commercialName":"SUOMINEN NONWOVENS","cnpj":"14405122000172","city":"PAULÍNIA","stateCode":"SP","buscaAdicional":"SUOMINEN BRASIL 58077 SUOMINEN PAULINIA 909061"},{"id":"29c75585-def5-4963-6638-08d5ad2bf6ba","name":"SESPO INDUSTRIA E COMERCIO LIMITADA","commercialName":"","cnpj":"50464692000105","city":"PAULÍNIA","stateCode":"SP","buscaAdicional":"SESPO 57398 SESPO - CEVA 907261"},{"id":"a53cc03a-e3ec-4835-8873-08d5ae44ed50","name":"SYNGENTA PROTECAO DE CULTIVOS LTDA","commercialName":"","cnpj":"60744463001080","city":"PAULÍNIA","stateCode":"SP","buscaAdicional":"SYNGENTA 6777"},{"id":"1f365802-a13e-4ab3-7350-08d5cf600bef","name":"AR CAPITAL SECURITIES COMPANHIA SECURITIZADORA S.A.","commercialName":"AUREA SECURITIES COMPANHIA SECURITIZADORA","cnpj":"15914972000169","city":"PAULÍNIA","stateCode":"SP","buscaAdicional":""},{"id":"141b326a-b9f3-4451-66ea-08d5ad2bf6ba","name":"VOLVO DO BRASIL VEICULOS LTDA","commercialName":"","cnpj":"43999424000971","city":"PEDERNEIRAS","stateCode":"SP","buscaAdicional":"VOLVO PEDERNEIRAS 57883 VOLVO PERDENEIRAS 909062"},{"id":"fd151a45-5371-41f3-6414-08d5ad2bf6ba","name":"SEGATO & FRASCARELI EMBALAGENS PLASTICAS LTDA","commercialName":"","cnpj":"08675997000191","city":"PEDERNEIRAS","stateCode":"SP","buscaAdicional":"EMBAPLASTIK 55833 I.M.SEGATO EMBAL PL 906994"},{"id":"736e7b29-33ca-4c5d-5cbc-08d5ad2bf6ba","name":"AJINOMOTO ANIMAL NUTRITION DO BRASIL INDUSTRIA E COMERCIO LTDA.","commercialName":"","cnpj":"22992227000101","city":"PEDERNEIRAS","stateCode":"SP","buscaAdicional":"AJINOMOTO NUTRITION 51544 AJINOMOTO PEDERN. 70082"},{"id":"2206b419-86c1-4388-5d48-08d5ad2bf6ba","name":"BISPHARMA EMBALAGENS LTDA","commercialName":"BISPHARMA PACKAGING","cnpj":"59610485000188","city":"PEDREIRA","stateCode":"SP","buscaAdicional":"BISPHARMA 51757 BISPHARMA EMBALAGEM 899289"},{"id":"e0eb8c3a-b3a6-41fa-5f29-08d5ad2bf6ba","name":"PLASTICOS M B LTDA.","commercialName":"","cnpj":"00570834000132","city":"PEDREIRA","stateCode":"SP","buscaAdicional":"PLASTICOS MB 52811 PLASTICOS MB 905179"},{"id":"3603c212-4a58-401f-6234-08d5ad2bf6ba","name":"RISCHIOTO INDUSTRIA E COMERCIO DE PLASTICOS LTDA","commercialName":"","cnpj":"02557995000111","city":"PEDREIRA","stateCode":"SP","buscaAdicional":"RISCHIOTO 54619 RISCHIOTO 905194"},{"id":"747a59f2-a449-4b3a-614f-08d5ad2bf6ba","name":"PLASNEW UTILIDADES DOMESTICAS LTDA.","commercialName":"PLASNEW","cnpj":"03640671000105","city":"PEDREIRA","stateCode":"SP","buscaAdicional":"PLASNEW 54118 PLASNEW 902319"},{"id":"2bbefe2f-9da0-41fa-613e-08d5ad2bf6ba","name":"PENAPOLIS GARDEN SHOPPING SPE INCORPORACAO, CONSTRUCAO E LOCACAO LTDA","commercialName":"","cnpj":"12482552000162","city":"PENÁPOLIS","stateCode":"SP","buscaAdicional":"PENAPOLIS SHOP 54071 PENAPOLIS GARDEN SPG 906675"},{"id":"8cf92c2b-cd8d-4239-6822-08d5ad2bf6ba","name":"RETESP INDUSTRIA DE VEDANTES LTDA","commercialName":"RETESP","cnpj":"62125836000170","city":"PENÁPOLIS","stateCode":"SP","buscaAdicional":"RETESP 59415 RETESP VEDANTES 909666"},{"id":"59c4c9dd-756c-4f78-5812-08d5ad2bf6ba","name":"BNEF COMERCIALIZADORA DE ENERGIA ELETRICA LTDA","commercialName":"","cnpj":"16987782000134","city":"PENÁPOLIS","stateCode":"SP","buscaAdicional":"BNEF 10570"},{"id":"119c2dd2-0edb-4436-5846-08d5ad2bf6ba","name":"TERMOELETRICA INTERLAGOS LTDA.","commercialName":"TERMOELETRICA INTERLAGOS","cnpj":"14827148000109","city":"PEREIRA BARRETO","stateCode":"SP","buscaAdicional":"TERMO INTERLAGOS 11153 INTERLAGOS 8238 UTE.AI.SP.029461-6.01"},{"id":"bec9003d-3958-4e65-691a-08d5ad2bf6ba","name":"LOPES SUPERMERCADOS LTDA","commercialName":"SUPERMERCADO PROENCA","cnpj":"53963443000144","city":"PEREIRA BARRETO","stateCode":"SP","buscaAdicional":"PROENCA 60770 LOPES SUPERMER VOTUP 911914 LOPES SUPERMERC JALE 911915 LOPES SUPER 3 LAGOAS 911933"},{"id":"79443351-e2d9-477d-5afa-08d5ad2bf6ba","name":"ALTESO GERACAO E COMERCIALIZACAO DE ENERGIA LTDA","commercialName":"ALTESO ENERGIES","cnpj":"22397150000113","city":"PILAR DO SUL","stateCode":"SP","buscaAdicional":"ALTESO 50377 PILAR 8615 PCH.PH.SP.028188-3.01 JORDA FLOR 8616 PCH.PH.SP.001257-2.01 BATISTA 8617 PCH.PH.SP.028187-5.01"},{"id":"19f5856c-5984-4a20-5961-08d5ad2bf6ba","name":"GV DO BRASIL INDUSTRIA E COMERCIO DE ACO LTDA","commercialName":"GV DO BRASIL","cnpj":"12884632000144","city":"PINDAMONHANGABA","stateCode":"SP","buscaAdicional":"GV DO BRASIL 14337 GV BRASIL SP 895005"},{"id":"84fd4f57-c2f2-4bf8-605e-08d5ad2bf6ba","name":"SHOPPING PATIO PINDA EMPREENDIMENTOS IMOBILIARIOS LTDA.","commercialName":"","cnpj":"11158171000160","city":"PINDAMONHANGABA","stateCode":"SP","buscaAdicional":"SHOPPING PINDA 53480 SHOP PATIO PINDA 905744"},{"id":"22f3f9bf-b9e9-45cc-5c92-08d5ad2bf6ba","name":"PISANI PLASTICOS S.A","commercialName":"","cnpj":"87833737000335","city":"PINDAMONHANGABA","stateCode":"SP","buscaAdicional":"PISANISP 51386 PISANI PINDAMONHANGA 898830"},{"id":"a59c5d26-d91d-48d9-4fcb-08d5ad2bf6ba","name":"TENARIS COATING DO BRASIL SA","commercialName":"SOCOTHERM","cnpj":"02837836000170","city":"PINDAMONHANGABA","stateCode":"SP","buscaAdicional":"TENARIS COATING 1278 SOCORI PIN 7593"},{"id":"94534308-d948-4c98-6964-08d5ad2bf6ba","name":"ZODIAC-PRODUTOS FARMACEUTICOS S.A.","commercialName":"","cnpj":"55980684000127","city":"PINDAMONHANGABA","stateCode":"SP","buscaAdicional":"ZODIAC 61136 ZODIAC 911958"},{"id":"e1fb4933-4548-4c9e-8833-08d5ae44ed50","name":"CONFAB INDUSTRIAL SOCIEDADE ANONIMA","commercialName":"","cnpj":"60882628004268","city":"PINDAMONHANGABA","stateCode":"SP","buscaAdicional":"CONFAB 1279"},{"id":"328ad025-c28b-4810-670d-08d5ad2bf6ba","name":"DECO COMERCIO DE MATERIAIS PLASTICOS LTDA","commercialName":"","cnpj":"00425544000103","city":"PINDAMONHANGABA","stateCode":"SP","buscaAdicional":"DECO 57938 DECO PLASTICOS 909263"},{"id":"882ba7c6-3485-4969-6157-08d5ad2bf6ba","name":"BASELL POLIOLEFINAS LTDA.","commercialName":"","cnpj":"13583323000105","city":"PINDAMONHANGABA","stateCode":"SP","buscaAdicional":"BASELL 54142 BASELL PINDAMONHANGA 904114"},{"id":"af075c17-824a-4fde-6269-08d5ad2bf6ba","name":"NOVAMETAL DO BRASIL LTDA.","commercialName":"","cnpj":"03590147000177","city":"PINDAMONHANGABA","stateCode":"SP","buscaAdicional":"NOVA METAL 54748 NOVA METAL PINDA 905994"},{"id":"c2ee3a33-ce3d-48e1-6892-08d5ad2bf6ba","name":"INDUSTRIAS REUNIDAS COLOMBO LTDA","commercialName":"MIAC","cnpj":"45127545000100","city":"PINDORAMA","stateCode":"SP","buscaAdicional":"REUNIDAS COLOMBO 60166 REUNIDAS COLOMBO 909983 REUNIDAS COLOMBO 2 909984 REUNIDAS COLOMBO 3 909985"},{"id":"d46182dc-35c8-4199-691d-08d5ad2bf6ba","name":"UNISUPER UNIAO SUPERMERCADO LTDA","commercialName":"","cnpj":"72995475000176","city":"PINHALZINHO","stateCode":"SP","buscaAdicional":"UNISUPER SUPERMERCADO 60773 UNIAO SERRA NEGRA 911289 UNISUPER UNIAO 911306 SAUL GRABLER 911307 UNIAO PINHALZINHO 911308 UNI SUP 14323770 911309 4000322067 911310 31548903 911652 UNISUPER JUSCELINO K 912517 9/3001582-0 913051"},{"id":"0b1144e3-29c2-474f-6978-08d5ad2bf6ba","name":"DELPHI POWERTRAIN SYSTEM INDUSTRIA E COMERCIO LTDA.","commercialName":"","cnpj":"25043386000140","city":"PIRACICABA","stateCode":"SP","buscaAdicional":"DELPHI I SP 62130"},{"id":"b218b25a-9291-4c1c-688d-08d5ad2bf6ba","name":"HWASHIN FABRICANTE DE PECAS AUTOMOTIVAS BRASIL LTDA","commercialName":"HWASHIN AUTOMOTIVAS BRASIL","cnpj":"11482618000151","city":"PIRACICABA","stateCode":"SP","buscaAdicional":"HWASHIN 60146 HWASHIN AUTO 910147"},{"id":"7b690ad0-777f-45df-66db-08d5ad2bf6ba","name":"ASSOCIACAO DOS FORNECEDORES DE CANA DE PIRACICABA","commercialName":"","cnpj":"54384631000261","city":"PIRACICABA","stateCode":"SP","buscaAdicional":"HOSPITAL DOS FORN DE CANA 57858 HOSP FORNEC DE CANA 908423"},{"id":"8b5f96a0-edaf-4230-662f-08d5ad2bf6ba","name":"UNIMIL INDUSTRIA E COMERCIO DE PECAS DE MAQUINAS AGRICOLAS LTDA.","commercialName":"","cnpj":"03350300000865","city":"PIRACICABA","stateCode":"SP","buscaAdicional":"UNIMIL 57384 UNIMIL 908646"},{"id":"dbfc84cc-5ed4-48de-668c-08d5ad2bf6ba","name":"GENERAL CHAINS DO BRASIL LTDA.","commercialName":"","cnpj":"00994571000199","city":"PIRACICABA","stateCode":"SP","buscaAdicional":"GENERAL CHAINS 57650 GENERAL CHAINS FIL 908296 GENERAL CHAINS MTZ 908297"},{"id":"c57e1907-61a2-41d8-660c-08d5ad2bf6ba","name":"ANANDA METAIS LTDA","commercialName":"","cnpj":"04215721000170","city":"PIRACICABA","stateCode":"SP","buscaAdicional":"ANANDA METAIS 57283 ANANDA METAIS 908298"},{"id":"57c4a70a-d32e-45ec-6133-08d5ad2bf6ba","name":"LUBRASIL LUBRIFICANTES LTDA","commercialName":"","cnpj":"49396591000157","city":"PIRACICABA","stateCode":"SP","buscaAdicional":"LUBRASIL 54053 LUBRASIL 905692"},{"id":"9627be53-1ad8-47ca-620b-08d5ad2bf6ba","name":"MEFSA MECANICA E FUNDICAOSANTO ANTONIO LTDA","commercialName":"","cnpj":"54378195000137","city":"PIRACICABA","stateCode":"SP","buscaAdicional":"MEFSA 54519 MEFSA 905113"},{"id":"e31ef87f-706c-47aa-6439-08d5ad2bf6ba","name":"IPLASA INDUSTRIA E COMERCIO DE PRODUTOS DOMISSANITARIOS LTDA","commercialName":"","cnpj":"45445210000121","city":"PIRACICABA","stateCode":"SP","buscaAdicional":"CANDURA 55884 IPLASA IND E COMERC 906993"},{"id":"6a7c627b-80e1-4e20-64d1-08d5ad2bf6ba","name":"BOM PEIXE INDUSTRIA E COMERCIO LTDA","commercialName":"BOM PEIXE","cnpj":"45666419000115","city":"PIRACICABA","stateCode":"SP","buscaAdicional":"BOM PEIXE 56249 ANTONIO BORJA 907025 ERMINIO PERTIN 907223"},{"id":"4abbbd3a-0b5b-4625-6575-08d5ad2bf6ba","name":"SEOYON E-HWA FABRICACAO DE SISTEMA INTERIOR AUTOMOTIVO BRASIL LTDA","commercialName":"SEOYON E-HWA AUTOMOTIVE DO BRASIL","cnpj":"11482614000173","city":"PIRACICABA","stateCode":"SP","buscaAdicional":"SEOYON 56734 SEOYON PIRACICABA 906422"},{"id":"30e49ef2-7e0a-4bb8-4fd8-08d5ad2bf6ba","name":"DEDINI S/A INDUSTRIAS DE BASE EM RECUPERACAO JUDICIAL","commercialName":"","cnpj":"50109271001472","city":"PIRACICABA","stateCode":"SP","buscaAdicional":"DEDINI 1306 DEDINI PIRAC. BASE 7356 DEDINI SERTAOZINHO 71011"},{"id":"a613316a-58f9-4c06-4f9d-08d5ad2bf6ba","name":"CATERPILLAR BRASIL LTDA","commercialName":"","cnpj":"61064911000177","city":"PIRACICABA","stateCode":"SP","buscaAdicional":"CATERPILLAR 1187 CATERPILLAR PIRAC. 7451"},{"id":"a44b5152-600c-4896-5056-08d5ad2bf6ba","name":"LEF PISOS E REVESTIMENTOS LTDA","commercialName":"","cnpj":"74423880000145","city":"PIRACICABA","stateCode":"SP","buscaAdicional":"LEF PISOS 1580 LEF PISOS PIRACICABA 70002"},{"id":"f112f864-9e1f-4843-50b6-08d5ad2bf6ba","name":"BORGWARNER EMISSIONS SYSTEMS LTDA.","commercialName":"","cnpj":"46242558000184","city":"PIRACICABA","stateCode":"SP","buscaAdicional":"BORGWARNER 1794 WAHLER MET. PIRAC. 70202"},{"id":"f94854c0-1a85-4e92-5166-08d5ad2bf6ba","name":"TECTEXTIL EMBALAGENS TEXTEIS LTDA","commercialName":"TECTEXTIL","cnpj":"59264051000173","city":"PIRACICABA","stateCode":"SP","buscaAdicional":"TECTEXTIL 2153 TECTEXTIL PIRACICABA 70516"},{"id":"1030be25-a05b-49da-512b-08d5ad2bf6ba","name":"CJ DO BRASIL INDUSTRIA E COMERCIO DE PRODUTOS ALIMENTICIOS LTDA.","commercialName":"","cnpj":"07450031000193","city":"PIRACICABA","stateCode":"SP","buscaAdicional":"CJBRASIL 2032 CJ DO BRASIL PIRAC. 70389"},{"id":"4cbd7c6d-090d-4549-530b-08d5ad2bf6ba","name":"CONDOMINIO SHOPPING CENTER PIRACICABA","commercialName":"","cnpj":"55349526000173","city":"PIRACICABA","stateCode":"SP","buscaAdicional":"SHOPPIRACICABA 3451 SHOP PIRACICABA 2 71056 SHOP PIRACICABA 1 71073 SHOP PIRACICABA 3 892583"},{"id":"7336acd4-0ff4-4938-5356-08d5ad2bf6ba","name":"WEIDPLAS BRASIL INDUSTRIA E COMERCIO DE PLASTICOS LTDA.","commercialName":"WEIDPLAS BRASIL","cnpj":"02414452000145","city":"PIRACICABA","stateCode":"SP","buscaAdicional":"WEIDPLAS 3586 WEIDMANN PIRACICABA 71122"},{"id":"10dd44e5-f929-4cfd-55e6-08d5ad2bf6ba","name":"BIOMIN DO BRASIL NUTRICAO ANIMAL LTDA.","commercialName":"","cnpj":"07738662000102","city":"PIRACICABA","stateCode":"SP","buscaAdicional":"BIOMIN 6292 BIOMIN-PIRACICABA 72102"},{"id":"2dd74850-ecd2-4119-55b0-08d5ad2bf6ba","name":"HYUNDAI STEEL INDUSTRIA E COMERCIO DE ACO BRASIL LTDA.","commercialName":"HYUNDAI STEEL BRAZIL","cnpj":"13356439000101","city":"PIRACICABA","stateCode":"SP","buscaAdicional":"HYUNDAI STEEL 6017 HYSCO - PIRACICABA 71699"},{"id":"28b5d8fb-8152-405f-5635-08d5ad2bf6ba","name":"MONDELEZ BRASIL LTDA","commercialName":"MONDELEZ BRASIL","cnpj":"33033028008169","city":"PIRACICABA","stateCode":"SP","buscaAdicional":"MONDELEZ_PIRA 6762 KRAFT-PIRACICABA 72001"},{"id":"1fbb648d-1c65-41b6-5668-08d5ad2bf6ba","name":"DANNAPLAS - INDUSTRIA E COMERCIO DE PLASTICOS RECICLADOS LTDA","commercialName":"","cnpj":"05790426000100","city":"PIRACICABA","stateCode":"SP","buscaAdicional":"DANNAPLAS 7020 DANNAPLAS PIRACICAB 72164"},{"id":"e14c17d1-4ec9-4834-569d-08d5ad2bf6ba","name":"CATALISE INDUSTRIA E COMERCIO DE METAIS LTDA","commercialName":"","cnpj":"45357407000109","city":"PIRACICABA","stateCode":"SP","buscaAdicional":"CATALISE 7324 CATALISE PIRACICABA 72359"},{"id":"199c46c9-d8ef-4fa9-5695-08d5ad2bf6ba","name":"XERIUM TECHNOLOGIES BRASIL INDUSTRIA E COMERCIO S/A","commercialName":"XERIUM","cnpj":"58309998000190","city":"PIRACICABA","stateCode":"SP","buscaAdicional":"XERIUM 7243 XERIUM PIRACICABA 72195"},{"id":"4042fd31-1213-4325-5715-08d5ad2bf6ba","name":"ELRING KLINGER DO BRASIL LTDA","commercialName":"ELRING KLINGER","cnpj":"01576749000144","city":"PIRACICABA","stateCode":"SP","buscaAdicional":"ELRING 8191 ELRING KLINGER 888622"},{"id":"1e1cd63d-cb39-4d85-5706-08d5ad2bf6ba","name":"SPGPRINTS BRASIL LTDA","commercialName":"","cnpj":"61939419000106","city":"PIRACICABA","stateCode":"SP","buscaAdicional":"SPGPRINTS 8161 STORK PIRA 888168"},{"id":"08d5a0df-7f9d-46d1-57de-08d5ad2bf6ba","name":"NG METALURGICA S.A.","commercialName":"","cnpj":"01939979000120","city":"PIRACICABA","stateCode":"SP","buscaAdicional":"NG METALURGICA 9830 NG METALURGICA 889271 NG META UNID 2 889843"},{"id":"183fe241-e3e8-4d28-542f-08d5ad2bf6ba","name":"DELPHI AUTOMOTIVE SYSTEMS DO BRASIL LTDA","commercialName":"DELPHI AUTOMOTIVE SYSTEMS DO BRASIL LTDA.","cnpj":"00857758000817","city":"PIRACICABA","stateCode":"SP","buscaAdicional":"DELPHI I 4059 DELPHI I-11,9KV 71415"},{"id":"06437e10-2c77-45f8-54b5-08d5ad2bf6ba","name":"MOBIS BRASIL FABRICACAO DE AUTO PECAS LTDA","commercialName":"MOBIS PARTS BRAZIL","cnpj":"08585033000152","city":"PIRACICABA","stateCode":"SP","buscaAdicional":"MOBIS 4451 MOBIS-PIRACICABA 71697"},{"id":"9a7c33d2-8955-4d3f-54c2-08d5ad2bf6ba","name":"HYUNDAI MOTOR BRASIL MONTADORA DE AUTOMOVEIS LTDA","commercialName":"HYUNDAI MOTOR BRASIL - HMB","cnpj":"10394422000142","city":"PIRACICABA","stateCode":"SP","buscaAdicional":"HYUNDAI 4481 HYUNDAI-PIRACICABA 71696"},{"id":"7ff767f1-37af-4c1b-54c6-08d5ad2bf6ba","name":"OJI PAPEIS ESPECIAIS LTDA","commercialName":"","cnpj":"11547756000171","city":"PIRACICABA","stateCode":"SP","buscaAdicional":"OJI PAPEIS 4493 OJI PAPEIS 7323"},{"id":"22130576-d055-437f-5c9a-08d5ad2bf6ba","name":"MYOUNG SHIN FABRICANTE DE CARROCERIA AUTOMOTIVA LTDA","commercialName":"MSB","cnpj":"11510416000176","city":"PIRACICABA","stateCode":"SP","buscaAdicional":"MSB 51397 MSB 898779"},{"id":"2897d94d-f4b0-4de7-5d15-08d5ad2bf6ba","name":"INDUSTRIAS MARRUCCI LTDA","commercialName":"MARRUCCI","cnpj":"54368212000155","city":"PIRACICABA","stateCode":"SP","buscaAdicional":"MARRUCCI 51697 MARRUCCI FUNDICAO 899553 MARRUCCI HIDRAULICA 899567"},{"id":"18beb6e8-7677-4549-5ddf-08d5ad2bf6ba","name":"REIPEL - RECICLAGEM E INDUSTRIA DE PAPEIS ESPECIAIS LTDA","commercialName":"REIPEL","cnpj":"07087629000160","city":"PIRACICABA","stateCode":"SP","buscaAdicional":"REIPEL 52053 REIPEL PIRACICABA 900791"},{"id":"be3bf11e-bb3b-494a-5ffc-08d5ad2bf6ba","name":"THERMIX TRATAMENTO TERMICO LTDA.","commercialName":"","cnpj":"03924876000112","city":"PIRACICABA","stateCode":"SP","buscaAdicional":"THERMIX 53329 THERMIX 901054"},{"id":"e60515a7-14a3-46b4-5938-08d5ad2bf6ba","name":"BIOENERGIA COSTA PINTO LTDA.","commercialName":"","cnpj":"18645875000106","city":"PIRACICABA","stateCode":"SP","buscaAdicional":"BIO COSTA PINTO 14139 COSTA PINTO CONSUMO 910698 COSTA PINTO 8400 UTE.AI.SP.028221-9.01"},{"id":"4a99afcd-c6a2-42f3-59f3-08d5ad2bf6ba","name":"PIRACICABA GERADORA DE ENERGIA ELETRICA LTDA","commercialName":"","cnpj":"09489886000153","city":"PIRACICABA","stateCode":"SP","buscaAdicional":"PCH PIRACICABA 16075 PIRACICABA 895241 PCH.PH.SP.028024-0.01"},{"id":"1c3b58a6-58a0-4d92-5c72-08d5ad2bf6ba","name":"SUPERMERCADO DELTA MAX LTDA","commercialName":"","cnpj":"00286528000179","city":"PIRACICABA","stateCode":"SP","buscaAdicional":"DELTA SUPERMERCADO 51319 DELTA SUPERMERCADO 898254 DELTA PORTO 898276 DELTA CHARQUEADA 898700 DELTA CECAP 898707 DELTA SUP ARARAS 905659 DELTA MAX 905737"},{"id":"a61cae5f-12a4-4db6-5259-08d5ad2bf6ba","name":"ABATEDOURO DE AVES CALIFORNIA LTDA","commercialName":"GONZALEZ","cnpj":"65790610000181","city":"PIRANGI","stateCode":"SP","buscaAdicional":"FGONZALEZ 3017 ABATED CALIFORNIA 70947 F GONZALEZ PIRANGI 907468"},{"id":"390282b6-9b59-4fb9-561d-08d5ad2bf6ba","name":"SINA INDUSTRIA DE ALIMENTOS LTDA","commercialName":"SINA PIRAPOZINHO","cnpj":"10156658000574","city":"PIRAPOZINHO","stateCode":"SP","buscaAdicional":"SINA INDUST 6619 SINA PIRAPOZINHO 70956"},{"id":"17829d96-2689-4959-5398-08d5ad2bf6ba","name":"FERRARI TERMOELETRICA S/A","commercialName":"","cnpj":"08791234000106","city":"PIRASSUNUNGA","stateCode":"SP","buscaAdicional":"FERRARI TERMO 3709 FERRARI 8497 UTE.AI.SP.028058-5.01"},{"id":"95616dfb-c951-4775-52cd-08d5ad2bf6ba","name":"BALDIN BIOENERGIA S.A.","commercialName":"","cnpj":"54844360000107","city":"PIRASSUNUNGA","stateCode":"SP","buscaAdicional":"BALDIN 3317 BALDIN RC 71174 BALDIN-BALDIN 8724 UTE.AI.SP.030169-8.01"},{"id":"df2fc89a-0005-445f-52b7-08d5ad2bf6ba","name":"COSTAPACKING INDUSTRIA E COMERCIO DE PLASTICOS LTDA","commercialName":"COSTAPACKING","cnpj":"03535396000160","city":"PIRASSUNUNGA","stateCode":"SP","buscaAdicional":"COSTAPLASTIC 3256 COSTAPLASTIC PIRASSU 70996"},{"id":"0bec453f-89c8-4496-5cbd-08d5ad2bf6ba","name":"COMPANHIA MULLER DE BEBIDAS","commercialName":"","cnpj":"03485775000192","city":"PIRASSUNUNGA","stateCode":"SP","buscaAdicional":"CIA MULLER 51545 CIA MULLER 899908"},{"id":"d738c168-5c15-4143-51ce-08d5ad2bf6ba","name":"TEREOS ACUCAR E ENERGIA ANDRADE S.A.","commercialName":"DESTILARIA ANDRADE","cnpj":"54929021000115","city":"PITANGUEIRAS","stateCode":"SP","buscaAdicional":"ANDRADE 2601 IBITIUVA-ANDR 8661 UTE.AI.SP.027768-1.01"},{"id":"4ca1a8fc-9f70-4bef-5084-08d5ad2bf6ba","name":"PITANGUEIRAS ACUCAR E ALCOOL LTDA","commercialName":"USINA PITANGUEIRAS","cnpj":"44870939000182","city":"PITANGUEIRAS","stateCode":"SP","buscaAdicional":"PITANGUEIRAS 1668 PITANGUEIRAS 8003 UTE.AI.SP.028859-4.01"},{"id":"1abb1ac2-cf9f-4b12-6350-08d5ad2bf6ba","name":"AMARELINHA SUPERMERCADOS LTDA.","commercialName":"AMARELINHA SUPERMERCADOS","cnpj":"05149841000189","city":"PITANGUEIRAS","stateCode":"SP","buscaAdicional":"AMARELINHA SUPERMERCADOS 55308 AMARELINHA LOJA 01 906845 AMARELINHA LOJA 02 906846 AMARELINHA LOJA 03 906868 AMARELINHA L 6 909593"},{"id":"6d237f43-3edc-47f1-6864-08d5ad2bf6ba","name":"MARDAM INDUSTRIA E COMERCIO DE PRODUTOS DE HIGIENE LTDA","commercialName":"","cnpj":"03713939000191","city":"POÁ","stateCode":"SP","buscaAdicional":"MARDAM 59910 MARDAM 910254"},{"id":"d7ff9e0a-9623-4bf6-6922-08d5ad2bf6ba","name":"TMKT SERVICOS DE MARKETING LTDA.","commercialName":"","cnpj":"03790408000100","city":"POÁ","stateCode":"SP","buscaAdicional":"TMKT 60784 TMKT 911953"},{"id":"03597014-8bc6-4464-73c3-08d5cf600bef","name":"DIBENS LEASING S/A - ARRENDAMENTO MERCANTIL","commercialName":"","cnpj":"65654303000173","city":"POÁ","stateCode":"SP","buscaAdicional":""},{"id":"ffe4faa0-7ceb-4434-5086-08d5ad2bf6ba","name":"INDUSTRIAS BRASILEIRAS DE ARTIGOS REFRATARIOS - IBAR - LTDA","commercialName":"","cnpj":"61442737000230","city":"POÁ","stateCode":"SP","buscaAdicional":"IBAR LTDA 1671 IBAR POA 7182"},{"id":"5640053b-e856-4d6d-511d-08d5ad2bf6ba","name":"AUNDE BRASIL S.A.","commercialName":"","cnpj":"48131296000106","city":"POÁ","stateCode":"SP","buscaAdicional":"AUNDE 2000 AUNDE POA 70381"},{"id":"5bc3f5e5-dcb3-4bb8-56a1-08d5ad2bf6ba","name":"INDUSCABOS CONDUTORES ELETRICOS LIMITADA","commercialName":"INDUSCABOS","cnpj":"48063416000185","city":"POÁ","stateCode":"SP","buscaAdicional":"INDUSCABOS 7400 INDUSCABOS-POA 72260"},{"id":"67ab836c-9e77-4f0d-5dd5-08d5ad2bf6ba","name":"TINTURARIA E ESTAMPARIA DE TECIDOS ARTEC LTDA","commercialName":"","cnpj":"43388974000105","city":"POÁ","stateCode":"SP","buscaAdicional":"TINTURARIA ARTEC 52016 TINTURARIA ARTEC 902493"},{"id":"8f82c375-410d-4521-5f03-08d5ad2bf6ba","name":"LEAO & JETEX INDUSTRIA TEXTIL LTDA","commercialName":"","cnpj":"62825864000108","city":"POÁ","stateCode":"SP","buscaAdicional":"LEAO & JETEX 52704 LEAO & JETEX 904905"},{"id":"fe0d5693-4320-4583-57d7-08d5ad2bf6ba","name":"CONFINA ALIMENTOS INDUSTRIAL LTDA","commercialName":"CONFINA ALIMENTOS","cnpj":"74657784000161","city":"POLONI","stateCode":"SP","buscaAdicional":"CONFINA 9769 CONFINA 889524"},{"id":"6253bb0a-a068-4f7c-673f-08d5ad2bf6ba","name":"SUPERMERCADO CARNEIRO LTDA","commercialName":"SUPERMERCADO CARNEIRO","cnpj":"55322150000103","city":"PONTAL","stateCode":"SP","buscaAdicional":"SUPERMERCADO CARNEIRO 58014 FILIAL ANANIAS 910867 MATRIZ MARCYR 910878"},{"id":"a9d88f42-ade2-47d4-5fb1-08d5ad2bf6ba","name":"USINA GUARIROBA LTDA.","commercialName":"USINA GUARIROBA","cnpj":"07398533000112","city":"PONTES GESTAL","stateCode":"SP","buscaAdicional":"UTE GUARIROBA 53179 UTE GUARIROBA 906117 UTE.AI.SP.029766-6.01"},{"id":"685e3a26-0ff9-4c4b-5eb2-08d5ad2bf6ba","name":"METALURGICA SCHADEK LTDA","commercialName":"SCHADEK AUTOMOTIVE","cnpj":"60851417000190","city":"PORTO FELIZ","stateCode":"SP","buscaAdicional":"METAL SCHADEK 52510 MET SCHADEK 900703 M SCHADEK P FELIZ 2 911221"},{"id":"d05c9f4c-6725-4508-5a96-08d5ad2bf6ba","name":"VIDROPORTO S.A.","commercialName":"","cnpj":"48845556000105","city":"PORTO FERREIRA","stateCode":"SP","buscaAdicional":"VIDROPORTO 50091 VIDROPORTO S.A. 896604"},{"id":"99b72513-2cae-4829-57c3-08d5ad2bf6ba","name":"SAINT-GOBAIN VIDROS S.A.","commercialName":"VERALLIA","cnpj":"60853942001388","city":"PORTO FERREIRA","stateCode":"SP","buscaAdicional":"SGVID-PFERREIRA 9591 SAINT GOBAIN PORTO F 889055"},{"id":"87d06cb1-257f-4faf-5377-08d5ad2bf6ba","name":"CERAMICA PORTO FERREIRA S. A. EM RECUPERACAO JUDICIAL","commercialName":"PORTO FERREIRA","cnpj":"55186423000130","city":"PORTO FERREIRA","stateCode":"SP","buscaAdicional":"PORTO FERREIRA 3644 CERAMICA P FERREIRA 898253"},{"id":"88526f45-bdbb-448d-546a-08d5ad2bf6ba","name":"CARGILL AGRICOLA S A","commercialName":"","cnpj":"60498706015189","city":"PORTO FERREIRA","stateCode":"SP","buscaAdicional":"CARGILL POF 4225 CARGILL POF 71503"},{"id":"6929716d-6c90-4409-5488-08d5ad2bf6ba","name":"MAR GIRIUS CONTINENTAL INDUSTRIA DE CONT ELETRICOS LTDA","commercialName":"","cnpj":"61093001000112","city":"PORTO FERREIRA","stateCode":"SP","buscaAdicional":"MAR-GIRIUS 4325 MARGIRIUS-P FERREIRA 71528"},{"id":"60e82afd-b272-47ab-661a-08d5ad2bf6ba","name":"PORTO BRASIL CERAMICA LTDA","commercialName":"PORTO BRASIL CERAMICA","cnpj":"08520654000158","city":"PORTO FERREIRA","stateCode":"SP","buscaAdicional":"PORTO BRASIL 57312 PORTO BRASIL 907313"},{"id":"2c5cd8bb-68f1-4cda-6226-08d5ad2bf6ba","name":"BEBIDAS POTY LTDA","commercialName":"REFRIGERANTES POTY","cnpj":"55223127000242","city":"POTIRENDABA","stateCode":"SP","buscaAdicional":"POTY 54595 BEBIDAS POTY 903868"},{"id":"e22179e4-0757-4b72-5743-08d5ad2bf6ba","name":"SAO MARTINHO S/A","commercialName":"SAO MARTINHO","cnpj":"51466860000156","city":"PRADÓPOLIS","stateCode":"SP","buscaAdicional":"SMSA 8451 S. MARTINHO INTERLIG 894662 SAO MARTINHO S.A. 913392 SME INTERLIGACAO 894682 SAO MARTINHO 8329 UTE.AI.SP.026874-7.01 S MARTINHO ENERG 889980 UTE.AI.SP.030994-0.01"},{"id":"71c55d3e-b9a6-416e-534e-08d5ad2bf6ba","name":"USINA BOA VISTA S/A","commercialName":"","cnpj":"07603999000102","city":"PRADÓPOLIS","stateCode":"SP","buscaAdicional":"USINA BOAVISTA 3570 USI BOA VISTA FILIAL 908391 BOA VISTA (B VISTA) 8348 UTE.AI.GO.029588-4.01"},{"id":"4a7e5fe9-b03e-4319-4f8c-08d5ad2bf6ba","name":"LITORAL PLAZA ADMINISTRADORA DE SHOPPING CENTERS LTDA.","commercialName":"","cnpj":"02884951000104","city":"PRAIA GRANDE","stateCode":"SP","buscaAdicional":"LITORAL PLAZA 1154 LITORAL PLAZA PG 7544 LIT PLAZA SATELITE 2 7866 LIT PLAZA SATELITE 1 7867 MAUA PLZ SHOPP 89.2 7306"},{"id":"aaf743ff-b353-4b88-512f-08d5ad2bf6ba","name":"ENERGISA SUL-SUDESTE - DISTRIBUIDORA DE ENERGIA S.A.","commercialName":"","cnpj":"07282377000120","city":"PRESIDENTE PRUDENTE","stateCode":"SP","buscaAdicional":"ENERGISA SUL-SUDESTE 2036 CAIUA 46 EDEVP RB 910862 EDEVP 45 BRAGANTINA 44 CNEE 43 ENERGISA SUL 909780"},{"id":"3917bcfb-77ed-499a-563f-08d5ad2bf6ba","name":"ALIMENTOS WILSON LTDA EM RECUPERACAO JUDICIAL","commercialName":"","cnpj":"55323216000180","city":"PRESIDENTE PRUDENTE","stateCode":"SP","buscaAdicional":"WILSON 6821 WILSON RFEIJO 72064"},{"id":"f832b951-c2ac-4a86-5494-08d5ad2bf6ba","name":"PRUDENSHOPPING S.A.","commercialName":"PRUDENSHOPPING","cnpj":"54584404000107","city":"PRESIDENTE PRUDENTE","stateCode":"SP","buscaAdicional":"PRUDENSHOPP 4348 PRUDENSHOPPING-SP 71559"},{"id":"cddb50fc-380e-48ed-557e-08d5ad2bf6ba","name":"USINA ALTO ALEGRE S/A - ACUCAR E ALCOOL","commercialName":"USINA ALTO ALEGRE S/A - ACUCAR E ALCOOL","cnpj":"48295562000136","city":"PRESIDENTE PRUDENTE","stateCode":"SP","buscaAdicional":"UAA USI 5712 US ALTO ALEGRE USBIO 907876 USINA FLORESTOPOLIS 907076 USINA ALTO ALEGRE SA 908223 CONSUMO USINA ALTO A 907799 ALTO ALEGRE-UFA 8049 UTE.AI.SP.028366-5.01 USI 8259 UTE.AI.PR.029575-2.01 UFL 893003 UTE.AI.PR.031034-4.01 USI BIO 895502 UTE.AI.PR.031968-6.01"},{"id":"44aa5295-f9ba-47cf-636c-08d5ad2bf6ba","name":"FOSFERPET - INDUSTRIA, COMERCIO, IMPORTACAO E EXPORTACAO DE RACAO ANIMAL LTDA","commercialName":"","cnpj":"09170450000105","city":"PRESIDENTE PRUDENTE","stateCode":"SP","buscaAdicional":"FOSFERPET 55345 FOSFERPET 904559"},{"id":"9d46d4c2-4809-4f4c-63bf-08d5ad2bf6ba","name":"INDUSTRIAS ALIMENTICIAS LIANE LTDA","commercialName":"LIANE","cnpj":"59478198000166","city":"PRESIDENTE PRUDENTE","stateCode":"SP","buscaAdicional":"LIANE 55596 LIANE 904580"},{"id":"8174bd8c-8cb9-443d-6873-08d5ad2bf6ba","name":"A. R. C. LOGISTICA E ALIMENTOS LTDA","commercialName":"","cnpj":"11609581000260","city":"PRESIDENTE PRUDENTE","stateCode":"SP","buscaAdicional":"LIDER ALIMENTOS PRUDENTE 60071 A.R.C. LOGISTICA PPE 910637"},{"id":"a03715e0-eda5-434b-68d7-08d5ad2bf6ba","name":"CONDOMINIO PARQUE SHOPPING PRUDENTE","commercialName":"CONDOMINIO PARQUE SHOPPING PRUDENTE","cnpj":"24716928000135","city":"PRESIDENTE PRUDENTE","stateCode":"SP","buscaAdicional":"CPSP 60473 PRUDENTE PARQUE SHOP 905195"},{"id":"49b37fe1-38cb-4230-1ca8-08d5b8870181","name":"BON-MART FRIGORIFICO LTDA","commercialName":"BON-MART","cnpj":"04304360000219","city":"PRESIDENTE PRUDENTE","stateCode":"SP","buscaAdicional":"BON-MART 60651 FRIGORIFICO BON MART 912880"},{"id":"c6fa7baa-baa7-4e33-88ee-08d5ae44ed50","name":"CONDOMINIO CIVIL VOLUNTARIO DO PRUDENTE PARQUE SHOPPING","commercialName":"","cnpj":"10806789000126","city":"PRESIDENTE PRUDENTE","stateCode":"SP","buscaAdicional":"PARQUE SHOP PRUDENTE 55590"},{"id":"97e156d0-ffab-4256-5151-08d5ad2bf6ba","name":"RENUKA DO BRASIL S.A.","commercialName":"","cnpj":"43932102000581","city":"PROMISSÃO","stateCode":"SP","buscaAdicional":"RENUKA 2112 EQUIPAV 303 UTE.AI.SP.028101-8.01"},{"id":"52404c3e-a096-4e0b-5152-08d5ad2bf6ba","name":"RENUKA GERADORA DE ENERGIA ELETRICA LTDA - EM RECUPERACAO JUDICIAL","commercialName":"","cnpj":"45898574000167","city":"PROMISSÃO","stateCode":"SP","buscaAdicional":"RENUKA GERA 2114 EQUIPAV II 8436 UTE.AI.SP.029765-8.01"},{"id":"f27e4a41-28c1-4884-5397-08d5ad2bf6ba","name":"CLEALCO ACUCAR E ALCOOL S/A","commercialName":"CLEALCO","cnpj":"45483450002164","city":"QUEIROZ","stateCode":"SP","buscaAdicional":"CLEALCOQUEIROZ 3708 CLEALCO QUEIROZ CONS 71005 CLEALCO 8498 UTE.AI.SP.030036-5.01"},{"id":"96772c91-0b0e-44a6-5936-08d5ad2bf6ba","name":"BIOENERGIA RAFARD LTDA.","commercialName":"","cnpj":"18794615000100","city":"RAFARD","stateCode":"SP","buscaAdicional":"BIO RAFARD 14137 RAFARD CONSUMO 910700 RAFARD 8399 UTE.AI.SP.002903-3.01"},{"id":"bfc081f6-633e-4db6-5b9c-08d5ad2bf6ba","name":"AGROINDUSTRIAL IRMAOS DALLA COSTA LTDA.","commercialName":"PALMALI","cnpj":"07851247000160","city":"RANCHARIA","stateCode":"SP","buscaAdicional":"RANCHARIA 50787 RANCHARIA SP 898535 PALMAS PALMALI 899597 MARINGA PALMALI 899996"},{"id":"db58d5c4-5f18-47e9-72f6-08d5cf600bef","name":"AUTOPISTA REGIS BITTENCOURT S/A","commercialName":"","cnpj":"09336431000106","city":"REGISTRO","stateCode":"SP","buscaAdicional":""},{"id":"3195e38f-3039-4053-64b8-08d5ad2bf6ba","name":"AMP INDUSTRIA E COMERCIO DE PECAS AUTOMOTIVAS LTDA","commercialName":"","cnpj":"07752881000146","city":"RIBEIRÃO PIRES","stateCode":"SP","buscaAdicional":"AMP PECAS 56176 AMP PECAS AUTOMOTIV 907372"},{"id":"c8a9a4c4-afe9-4a91-6152-08d5ad2bf6ba","name":"SOMA SOLUCOES MAGNETICAS INDUSTRIA E COMERCIO LTDA.","commercialName":"","cnpj":"54472873000126","city":"RIBEIRÃO PIRES","stateCode":"SP","buscaAdicional":"SOMA SOLUCOES 54126 SOMA SOLUCOES 903448"},{"id":"d019308d-84fd-457e-58f9-08d5ad2bf6ba","name":"OURO FINO INDUSTRIA E COMERCIO LTDA. - EM RECUPERACAO JUDICIAL","commercialName":"","cnpj":"45783289000109","city":"RIBEIRÃO PIRES","stateCode":"SP","buscaAdicional":"OURO FINO INDUSTRIA 13494 OURO FINO RP 891964"},{"id":"4ddc8b1f-0093-4b85-5eca-08d5ad2bf6ba","name":"ALUMINIO MARCOLAR LTDA","commercialName":"","cnpj":"43066372000123","city":"RIBEIRÃO PIRES","stateCode":"SP","buscaAdicional":"ALUMINIO MARCOLAR 52552 ALUMINIO MARCOLAR 901935"},{"id":"9e92dde6-dd9d-4521-5da9-08d5ad2bf6ba","name":"SOCIEDADE DE ENSINO SUPERIOR ESTACIO RIBEIRAO PRETO LTDA","commercialName":"ESTACIO RIBEIRAO PRETO","cnpj":"07195358000166","city":"RIBEIRÃO PRETO","stateCode":"SP","buscaAdicional":"ESTACIO UNISEB 51948 UNISEB CURSOS SP 900953"},{"id":"6aac9186-49b4-4184-5c59-08d5ad2bf6ba","name":"CONDOMINIO COMPLEXO IGUATEMI RIBEIRAO PRETO","commercialName":"","cnpj":"20472864000113","city":"RIBEIRÃO PRETO","stateCode":"SP","buscaAdicional":"IGUATEMI RIBEIRAO PRETO 51281 IGUATEMI RIB PRETO 902739"},{"id":"036a599d-e794-4091-5ae2-08d5ad2bf6ba","name":"SANEN ENGENHARIA LTDA EM RECUPERACAO JUDICIAL","commercialName":"SANEN OBRAS SP","cnpj":"06249465000167","city":"RIBEIRÃO PRETO","stateCode":"SP","buscaAdicional":"SANEN 50330 LEAO ENGENHARIA 888833 LEAO ENG 888995 SANEN ENG 899558 SANEN ARARAQUARA 904423"},{"id":"a1f1a78c-263d-461a-5ae3-08d5ad2bf6ba","name":"SANTA HELENA INDUSTRIA DE ALIMENTOS S/A","commercialName":"","cnpj":"45256997000183","city":"RIBEIRÃO PRETO","stateCode":"SP","buscaAdicional":"SANTA HELENA IND 50331 SANTA HELENA INDUST 897566"},{"id":"f5eb2908-2596-4878-53e4-08d5ad2bf6ba","name":"AGROENERGIA COMERCIALIZADORA DE ENERGIA LTDA","commercialName":"","cnpj":"12422540000142","city":"RIBEIRÃO PRETO","stateCode":"SP","buscaAdicional":"AGROENERGIA 3893"},{"id":"773b8b7a-80fa-42f1-54fc-08d5ad2bf6ba","name":"ALLIAGE S/A INDUSTRIAS MEDICO ODONTOLOGICA","commercialName":"DABI","cnpj":"55979736000145","city":"RIBEIRÃO PRETO","stateCode":"SP","buscaAdicional":"ALLIAGE 4700 DABI ATLANTE RPR 71717 ALLIAGE RIBEIRAO PTO 907247"},{"id":"87f8ecc8-b7b2-465a-55f7-08d5ad2bf6ba","name":"SAO FRANCISCO GRAFICA E EDITORA LTDA","commercialName":"TIPOGRAFIA E OFFSET SAO FRANCISCO","cnpj":"49234487000166","city":"RIBEIRÃO PRETO","stateCode":"SP","buscaAdicional":"SAO FRAN GRAF 6392 S FRANCISCO GRAF RPR 71985"},{"id":"08dfc2ad-baf2-4771-55ac-08d5ad2bf6ba","name":"JP INDUSTRIA FARMACEUTICA S/A","commercialName":"","cnpj":"55972087000150","city":"RIBEIRÃO PRETO","stateCode":"SP","buscaAdicional":"JP FARMA 5981 JP FARMA - RPR 72108 JP FARMA UNIDADE 2 900645"},{"id":"d57bf819-7ce1-4970-515a-08d5ad2bf6ba","name":"CONDOMINIO DO SHOPPING CENTER RIBEIRAO PRETO","commercialName":"RIBEIRAOSHOPPING","cnpj":"52392164000105","city":"RIBEIRÃO PRETO","stateCode":"SP","buscaAdicional":"RIBEIRAO SHOPP CL 2133 SHOPPING RIB. PRETO 70483 7EXPANSAO 891504"},{"id":"cc8114da-5f31-44bc-50b7-08d5ad2bf6ba","name":"CONDOMINIO ORDINARIO DO NOVO SHOPPING CENTER RIBEIRAO PRETO","commercialName":"CONDOMINIO ORDINARIO NOVO SHOPPING CENTER RIB PRETO","cnpj":"03480244000107","city":"RIBEIRÃO PRETO","stateCode":"SP","buscaAdicional":"NOVO SHOPPING 1796 N.SHOPPING RIB.PRETO 70157"},{"id":"832a04f1-3100-4ec8-6214-08d5ad2bf6ba","name":"SUPERMERCADOS MIALICH LTDA","commercialName":"","cnpj":"52004785000174","city":"RIBEIRÃO PRETO","stateCode":"SP","buscaAdicional":"SUPER MIALICH 54547 SUPER MIALICH LJ 10 906046 SUPER MIALICH LOJA 7 906047 SUPER MIALICH LOJA 8 906048 SUPER MIALICH LOJA 5 906049 SUPER MIALICH LOJA 1 906050 SUPER MIALICH LOJA 6 906054 SUPER MIALICH LOJA 2 906055 SUPER MIALICH LOJA 9 906056 SUPER MIALICH LOJA 3 906057 SUPER MIALICH LOJA 4 906060"},{"id":"d33ac7d0-bd44-4988-6275-08d5ad2bf6ba","name":"IRPAO FABRICACAO E COMERCIO DE MASSAS ALIMENTICIAS LTDA","commercialName":"","cnpj":"96259643000123","city":"RIBEIRÃO PRETO","stateCode":"SP","buscaAdicional":"IRPAO 54766 IRPAO RIB PRETO 906420"},{"id":"fcc03ee9-fa97-4c61-62a0-08d5ad2bf6ba","name":"RIO DE JANEIRO REFRESCOS LTDA","commercialName":"","cnpj":"00074569005080","city":"RIBEIRÃO PRETO","stateCode":"SP","buscaAdicional":"RIO DE JANEIRO REFRESCOS 54830 RJ REFRESCOS LTDA 906654"},{"id":"f6060275-a8f9-443f-6554-08d5ad2bf6ba","name":"COPERSUCAR ARMAZENS GERAIS S.A.","commercialName":"","cnpj":"02822024004068","city":"RIBEIRÃO PRETO","stateCode":"SP","buscaAdicional":"COPERSUCAR RP 56655 COPERSUCAR 906841"},{"id":"5a81f2d9-987c-47ae-6451-08d5ad2bf6ba","name":"CONDOMINIO DO SHOPPING SANTA URSULA","commercialName":"","cnpj":"24501569000107","city":"RIBEIRÃO PRETO","stateCode":"SP","buscaAdicional":"SHOP SANTA URSULA 55931 SHOPP S.URSULA RP 7809"},{"id":"0647419d-096f-474b-6856-08d5ad2bf6ba","name":"NETAFIM BRASIL SISTEMAS E EQUIPAMENTOS DE IRRIGACAO LTDA.","commercialName":"","cnpj":"00549740000181","city":"RIBEIRÃO PRETO","stateCode":"SP","buscaAdicional":"NETAFIM 59832 NETAFIM BRASIL 910278"},{"id":"8d16f1f0-caec-410a-6948-08d5ad2bf6ba","name":"UNIMED DE RIBEIRAO PRETO COOPERATIVA DE TRABALHO MEDICO","commercialName":"","cnpj":"45232246000127","city":"RIBEIRÃO PRETO","stateCode":"SP","buscaAdicional":"UNIMED RIBEIRAO 60971 UNIMED RIBEIRAO 911805"},{"id":"fe4cc100-8500-4d83-665f-08d5ad2bf6ba","name":"RIBEIRAO ENERGIA COMERCIALIZACAO LTDA","commercialName":"","cnpj":"26526999000109","city":"RIBEIRÃO PRETO","stateCode":"SP","buscaAdicional":"RIBEIRAO 57513"},{"id":"768172cb-ca98-4456-667a-08d5ad2bf6ba","name":"RIBERBALL MERCANTIL E INDUSTRIAL LTDA","commercialName":"","cnpj":"48460745000160","city":"RIBEIRÃO PRETO","stateCode":"SP","buscaAdicional":"RIBERBALL 57610 RIBERBALL 908725"},{"id":"8d4ac755-95b9-422a-65e0-08d5ad2bf6ba","name":"SAO FRANCISCO SISTEMAS DE SAUDE SOCIEDADE EMPRESARIA LIMITADA","commercialName":"","cnpj":"01613433000185","city":"RIBEIRÃO PRETO","stateCode":"SP","buscaAdicional":"HOSP SAO FRANCISCO SAUDE 57183 HOSP SAO FRANCISCO 1 906678 DOCUMENTA 906679 HOSP SAO FRANCISCO 908067"},{"id":"385edab4-3e6a-4a46-672b-08d5ad2bf6ba","name":"ASSOCIACAO DE ENSINO DE RIBEIRAO PRETO","commercialName":"UNAERP","cnpj":"55983670000167","city":"RIBEIRÃO PRETO","stateCode":"SP","buscaAdicional":"UNAERP 57990 UNAERP 1 909186 UNAERP 2 909187 UNAERP 3 909188 UNAERP 4 909729"},{"id":"f892bbad-5f57-41ab-7266-08d5cf600bef","name":"AUTOVIAS S/A","commercialName":"","cnpj":"02679185000138","city":"RIBEIRÃO PRETO","stateCode":"SP","buscaAdicional":""},{"id":"74c10022-89a8-49bc-633c-08d5ad2bf6ba","name":"TUBOS TIGRE-ADS DO BRASIL LIMITADA","commercialName":"","cnpj":"11069316000156","city":"RIO CLARO","stateCode":"SP","buscaAdicional":"TIGRE-ADS MATRIZ 55254 TIGRE-ADS 903937"},{"id":"4600223b-71e0-4866-62be-08d5ad2bf6ba","name":"CERAMICA CRISTOFOLETTI LTDA","commercialName":"CERAMICA CRISTOFOLETTI","cnpj":"48173223000187","city":"RIO CLARO","stateCode":"SP","buscaAdicional":"CRISTOFOLETTI 54952 CRISTOFOLETTI - UN I 906704 CRISTOFOLETTI - UN 2 908164"},{"id":"468da0fc-9a39-47d8-6170-08d5ad2bf6ba","name":"ARKEMA QUIMICA LTDA.","commercialName":"","cnpj":"45259983000385","city":"RIO CLARO","stateCode":"SP","buscaAdicional":"ARKEMA 54188 ARKEMA QUIMICA LTDA 906076"},{"id":"cf2e3670-2046-4846-52bc-08d5ad2bf6ba","name":"RICLAN S.A.","commercialName":"","cnpj":"56370364000118","city":"RIO CLARO","stateCode":"SP","buscaAdicional":"RICLAN 3266 RICLAN-RIO CLARO 70985 RICLAN UN2 RIO CLARO 71159"},{"id":"e43ba4d4-a131-4a15-52ba-08d5ad2bf6ba","name":"SI GROUP CRIOS RESINAS S.A","commercialName":"","cnpj":"44246528000110","city":"RIO CLARO","stateCode":"SP","buscaAdicional":"SIGROUP 3259 SI GROUP 896709"},{"id":"646db18e-7644-4c9e-5550-08d5ad2bf6ba","name":"OWENS CORNING FIBERGLAS A S LTDA","commercialName":"","cnpj":"62647052000292","city":"RIO CLARO","stateCode":"SP","buscaAdicional":"OWENS CORNING 5312 OWENS CORNING-RCLARO 71795"},{"id":"4f050145-0811-4302-548a-08d5ad2bf6ba","name":"BRASCABOS COMPONENTES ELETRICOS E ELETRONICOS LTDA","commercialName":"BRASCABOS","cnpj":"68149228000181","city":"RIO CLARO","stateCode":"SP","buscaAdicional":"BRASCABOS 4328 BRASCABOS RCLARO 71569"},{"id":"9bb8c224-0809-4a2b-5a2c-08d5ad2bf6ba","name":"ALDORO INDUSTRIA DE POS E PIGMENTOS METALICOS LTDA","commercialName":"","cnpj":"47340930000158","city":"RIO CLARO","stateCode":"SP","buscaAdicional":"ALDORO INDUSTRIA 17186 ALDORO 895421"},{"id":"ded1b925-adca-4021-5d2e-08d5ad2bf6ba","name":"BULK MOLDING COMPOUNDS DO BRASIL INDUSTRIA DE PLASTICOS REFORCADOS LTDA","commercialName":"BMC DO BRASIL","cnpj":"02034743000108","city":"RIO CLARO","stateCode":"SP","buscaAdicional":"SCHULMAN 51728 BULK MOLDING 898813"},{"id":"2e5bfd59-8ece-46ec-5d1b-08d5ad2bf6ba","name":"ALISUL ALIMENTOS SA","commercialName":"SUPRA","cnpj":"89548523004259","city":"RIO CLARO","stateCode":"SP","buscaAdicional":"ALISUL RIO CLARO 51704 ALISUL ALIMENTOS 900527"},{"id":"fa5c5a99-1629-4a7d-5d13-08d5ad2bf6ba","name":"CHEMSON LTDA","commercialName":"CHEMSON","cnpj":"03761677000130","city":"RIO CLARO","stateCode":"SP","buscaAdicional":"CHEMSON 51695 CHENSOM - RIO CLARO 899357"},{"id":"6b50b634-4e08-4b03-5dc8-08d5ad2bf6ba","name":"CERAMICA SAVANE LTDA","commercialName":"","cnpj":"74562745000180","city":"RIO CLARO","stateCode":"SP","buscaAdicional":"SAVANE 51985 CERAMICA SAVANE 902623"},{"id":"ff06d805-b9b1-479d-60d7-08d5ad2bf6ba","name":"TREBOL BRASIL LTDA","commercialName":"","cnpj":"04658640000144","city":"RIO CLARO","stateCode":"SP","buscaAdicional":"TREBOL 53761 TREBOL RIO CLARO 904332"},{"id":"72fc823c-0c69-4028-5c4f-08d5ad2bf6ba","name":"LINK STEEL EQUIPAMENTOS INDUSTRIAIS LTDA","commercialName":"","cnpj":"46889424000150","city":"RIO DAS PEDRAS","stateCode":"SP","buscaAdicional":"LINK STEEL 51258 LINK STEEL 898810"},{"id":"0a905489-5420-4272-50c3-08d5ad2bf6ba","name":"ARCOR DO BRASIL LTDA.","commercialName":"","cnpj":"54360656000144","city":"RIO DAS PEDRAS","stateCode":"SP","buscaAdicional":"ARCOR R.PEDRAS 1831 ARCOR RIO DAS PEDRAS 70201 ARCOR-IPOJUCA PE 71712"},{"id":"63f91982-95b4-483c-6688-08d5ad2bf6ba","name":"PAINCO INDUSTRIA E COMERCIO SOCIEDADE ANONIMA","commercialName":"","cnpj":"56563976000127","city":"RIO DAS PEDRAS","stateCode":"SP","buscaAdicional":"PAINCO 57635 PAINCO MATRIZ 908737 PAINCO FILIAL 908738"},{"id":"e858db42-b40d-4045-5029-08d5ad2bf6ba","name":"DURA AUTOMOTIVE SYSTEMS DO BRASIL LTDA","commercialName":"","cnpj":"57501207000167","city":"RIO GRANDE DA SERRA","stateCode":"SP","buscaAdicional":"DURA AUTO 1482 DURA AUTO RGSERRA-SP 7930"},{"id":"1fdcd5de-6e16-4b49-5a54-08d5ad2bf6ba","name":"AREVALE INDUSTRIA E COMERCIO DE ARTEFATOS DE CONCRETO LTDA","commercialName":"","cnpj":"08686911000207","city":"ROSEIRA","stateCode":"SP","buscaAdicional":"AREVALE 17350 UTE AREVALE 900733 UTE.AI.SP.032860-0.01"},{"id":"a5409cfd-e6fa-4226-5c74-08d5ad2bf6ba","name":"IBER-OLEFF BRASIL LTDA","commercialName":"","cnpj":"02511054000147","city":"SALTO","stateCode":"SP","buscaAdicional":"IBER-OLEFF 51321 IBER-OLEFF 898869"},{"id":"d7ee7217-5983-4e34-5f4d-08d5ad2bf6ba","name":"KANJIKO DO BRASIL INDUSTRIA AUTOMOTIVA LTDA.","commercialName":"","cnpj":"08170305000153","city":"SALTO","stateCode":"SP","buscaAdicional":"KANJIKO SALTO 52891 KANJIKO SALTO 903859"},{"id":"d61cfc92-c4a8-4a61-4fdd-08d5ad2bf6ba","name":"IMERYS FUSED MINERALS SALTO LTDA.","commercialName":"","cnpj":"03625966000102","city":"SALTO","stateCode":"SP","buscaAdicional":"TREIBACHER 1323 ETC TREIBACHER SALTO 146"},{"id":"bc6a92bd-f426-49c3-667c-08d5ad2bf6ba","name":"ARVEDI METALFER DO BRASIL S.A.","commercialName":"","cnpj":"13091683000181","city":"SALTO","stateCode":"SP","buscaAdicional":"ARVEDI 57619 ARVEDI METALFER 908793"},{"id":"87837465-bfe2-41ba-65e1-08d5ad2bf6ba","name":"COPAVE ARTEFATOS DE BORRACHA LTDA.","commercialName":"","cnpj":"59229161000102","city":"SALTO","stateCode":"SP","buscaAdicional":"COPAVE 57184 COPAVE SALTO 908512"},{"id":"d93736cd-e570-47b7-65c5-08d5ad2bf6ba","name":"CONTINENTAL BRASIL INDUSTRIA AUTOMOTIVA LTDA","commercialName":"","cnpj":"48754139000823","city":"SALTO","stateCode":"SP","buscaAdicional":"CONTINENTAL SALTO 57075 CONTINENTAL BR SALTO 906615"},{"id":"95f9cc62-7161-4407-66b4-08d5ad2bf6ba","name":"SOCER RB INDUSTRIA E COMERCIO LTDA.","commercialName":"","cnpj":"01593699000103","city":"SALTO","stateCode":"SP","buscaAdicional":"SOCER 57748 SOCER BRASIL SALTO 908050"},{"id":"497d58b3-a506-47d8-67c0-08d5ad2bf6ba","name":"EXTRABASE EXTRACAO,COMERCIO E TRANSPORTES LTDA","commercialName":"","cnpj":"04298888000141","city":"SALTO","stateCode":"SP","buscaAdicional":"EXTRABASE 58604 EXTRABASE PORTO FLZ 908669 EXTRABASE BOFETE 908861"},{"id":"b99a949d-111b-4070-630a-08d5ad2bf6ba","name":"YORK INDUSTRIA E COMERCIO DE PRODUTOS PLASTICOS S.A.","commercialName":"","cnpj":"11520001000183","city":"SALTO","stateCode":"SP","buscaAdicional":"YORK 55109 YORK SALTO 906875"},{"id":"9db3ab68-0692-42b1-7268-08d5cf600bef","name":"SANESALTO SANEAMENTO S.A.","commercialName":"SANESALTO","cnpj":"02724983000134","city":"SALTO","stateCode":"SP","buscaAdicional":""},{"id":"5df7c8fb-9132-414c-730d-08d5cf600bef","name":"CONCESSIONARIA RODOVIAS DO TIETE S.A.","commercialName":"","cnpj":"10678505000163","city":"SALTO","stateCode":"SP","buscaAdicional":""},{"id":"85ac956f-73d1-44b7-6618-08d5ad2bf6ba","name":"MASSARI MINERACAO PARTICIPACOES LTDA.","commercialName":"","cnpj":"12776168000253","city":"SALTO DE PIRAPORA","stateCode":"SP","buscaAdicional":"MASSARI MINERACAO 57310 MASSARI MINERACAO 908293"},{"id":"c4986a33-ed7d-4ea0-5f3c-08d5ad2bf6ba","name":"ADIMAX - INDUSTRIA E COMERCIO DE ALIMENTOS LTDA.","commercialName":"","cnpj":"03887324000181","city":"SALTO DE PIRAPORA","stateCode":"SP","buscaAdicional":"ADIMAX SP 52871 ADIMAX SP 906603"},{"id":"06a8e242-3c2d-4dd9-5f75-08d5ad2bf6ba","name":"PAGUE MENOS COMERCIO DE PRODUTOS ALIMENTICIOS LTDA","commercialName":"","cnpj":"60494416000135","city":"SANTA BÁRBARA D'OESTE","stateCode":"SP","buscaAdicional":"PAGUE MENOS COMERCIO 52963 PAGUE MENOS 03 889547 PAGUE MENOS 09 889550 PAGUE MENOS LOJA 2 889603 PAGUE MENOS LOJA 10 889604 PAGUE MENOS LOJA 12 889605 PAGUE MENOS LOJA 13 889606 PAGUE MENOS LOJA 08 890896 PAGUE MENOS LJ 04 891762 PAGUE MENOS LOJA 11 891764 PAGUE MENOS LJ 07 891783 PAGUE MENOS LOJA 15 900761 PAGUE MENOS LOJA 05 901417 PAGUE MENOS LJ 19 901953 PAGUE MENOS LJ 22 901978 PAGUE MENOS LOJA 18 903228 PAGUE MENOS LOJA 01 903229 PAGUE MENOS LOJA 14 903333 PAGUE MENOS LOJA 06 903576 PAGUE MENOS LOJA 16 903594 PAGUE MENOS LOJA 21 903878 PAGUE MENOS LOJA 20 905765 PAGUE MENOS LOJA 23 906763 PAGUE MENOS LOJA 24 907096 PAGUE MENOS -LOJA 26 910395 PAGUE MENOS LJ 25 910796"},{"id":"94bd14fb-575f-4578-602b-08d5ad2bf6ba","name":"CONDOMINIO TIVOLI SHOPPING CENTER","commercialName":"","cnpj":"02583678000170","city":"SANTA BÁRBARA D'OESTE","stateCode":"SP","buscaAdicional":"TIVOLI 53412 TIVOLI 905101"},{"id":"64775204-97d9-4b9b-5dcf-08d5ad2bf6ba","name":"SUPERTRAT INDUSTRIA E COMERCIO DE PRODUTOS METALURGICOS LTDA","commercialName":"SUPERTRAT","cnpj":"00016037000108","city":"SANTA BÁRBARA D'OESTE","stateCode":"SP","buscaAdicional":"SUPERTRAT 52001 SUPERTRAT 901015"},{"id":"d1614bc9-c343-4d8f-5cd3-08d5ad2bf6ba","name":"COVOLAN INDUSTRIA TEXTIL LTDA","commercialName":"","cnpj":"56724412001109","city":"SANTA BÁRBARA D'OESTE","stateCode":"SP","buscaAdicional":"COVOLANFILIAL1 51580 COVOLAN 898781"},{"id":"586507b9-601d-4ddb-5da6-08d5ad2bf6ba","name":"TRBR INDUSTRIA E COMERCIO LTDA","commercialName":"","cnpj":"04530816000188","city":"SANTA BÁRBARA D'OESTE","stateCode":"SP","buscaAdicional":"TRBR IND 51945 TRBR S.B.D OESTE 904021"},{"id":"b5aec95a-1792-41cf-58bb-08d5ad2bf6ba","name":"USINA ACUCAREIRA FURLAN SOCIEDADE ANONIMA","commercialName":"USINA FURLAN","cnpj":"56723257000126","city":"SANTA BÁRBARA D'OESTE","stateCode":"SP","buscaAdicional":"UTEFURLANAVARE M 13052 FURLAN AVARE 892682 UTE.AI.SP.031189-8.01"},{"id":"334e3f7a-d156-44c3-5830-08d5ad2bf6ba","name":"TEXFYT INDUSTRIA E COMERCIO LTDA","commercialName":"","cnpj":"02580185000186","city":"SANTA BÁRBARA D'OESTE","stateCode":"SP","buscaAdicional":"TEXFYT 10929 TEXFYT 889625"},{"id":"3ce0f8b1-491c-44c7-581c-08d5ad2bf6ba","name":"CAMAR PLASTICOS LTDA","commercialName":"","cnpj":"52703063000108","city":"SANTA BÁRBARA D'OESTE","stateCode":"SP","buscaAdicional":"CAMAR 10729 CAMAR 889519"},{"id":"a7f42d65-c1d6-424e-4f7d-08d5ad2bf6ba","name":"INDUSTRIAS ROMI S A","commercialName":"","cnpj":"56720428000163","city":"SANTA BÁRBARA D'OESTE","stateCode":"SP","buscaAdicional":"ROMI 1135 ROMI SBO-SP 304 7584 ROMI-SBO-MATRIZ 889554"},{"id":"bfa1f83e-8ccd-4d8a-4f86-08d5ad2bf6ba","name":"TEXTIL CANATIBA LTDA","commercialName":"","cnpj":"56723091000148","city":"SANTA BÁRBARA D'OESTE","stateCode":"SP","buscaAdicional":"TEXTILCANATIBA 1144 TEXTIL CANATIVA SBO 7918 TEX. CANATIVA 2 SBO 70219 TEXTIL CANATIBA SB 71149"},{"id":"862cc01f-1bd3-42f2-50ca-08d5ad2bf6ba","name":"COVOLAN INDUSTRIA TEXTIL LTDA","commercialName":"","cnpj":"56724412000129","city":"SANTA BÁRBARA D'OESTE","stateCode":"SP","buscaAdicional":"COVOLAN 1847 COVOLAN SBO 70288 COVOLAN CAB NOVA-SBO 71542"},{"id":"d48bb118-53af-43eb-55a1-08d5ad2bf6ba","name":"ESPER EMBALAGENS LTDA","commercialName":"","cnpj":"01303404000117","city":"SANTA BÁRBARA D'OESTE","stateCode":"SP","buscaAdicional":"ESPER 5917 ESPER-S B DO OESTE 71926"},{"id":"333b1d64-d258-4ae4-6776-08d5ad2bf6ba","name":"POLLUX PLASTIC LTDA","commercialName":"","cnpj":"10290621000100","city":"SANTA BÁRBARA D'OESTE","stateCode":"SP","buscaAdicional":"POLLUX PLASTIC 58152 POLLUX MATRIZ SBO 910197 POLLUX FILIAL SBO 910222"},{"id":"6de1ce83-3b03-43fc-66f4-08d5ad2bf6ba","name":"VIRONDA CONFECCOES LTDA","commercialName":"","cnpj":"58517798000123","city":"SANTA BÁRBARA D'OESTE","stateCode":"SP","buscaAdicional":"VIRONDA 57899 VIRONDA D MARGARIDA 908455 VIRONDA 908472"},{"id":"8d41cc62-9fe6-406d-62c3-08d5ad2bf6ba","name":"ANGOLINI & ANGOLINI LTDA","commercialName":"ANGOLINI & ANGOLINI LTDA.","cnpj":"44829653000153","city":"SANTA BÁRBARA D'OESTE","stateCode":"SP","buscaAdicional":"ANGOLINI 54958 ANGOLINI 905119"},{"id":"a4ca8979-f81f-4be1-619b-08d5ad2bf6ba","name":"RANER INDUSTRIA COMERCIO IMPORTACAO E EXPORTACAO LTDA","commercialName":"","cnpj":"52431426000101","city":"SANTA BÁRBARA D'OESTE","stateCode":"SP","buscaAdicional":"RANER 54289 RANER 905235"},{"id":"7a6d458e-6592-4e26-63f6-08d5ad2bf6ba","name":"INNOVATIV INDUSTRIA E COMERCIO DE TECIDOS LTDA","commercialName":"","cnpj":"10820791000150","city":"SANTA BÁRBARA D'OESTE","stateCode":"SP","buscaAdicional":"INNOVATIV 55752 INNOVATIV 12492779 907498 INNOVATIV 34964215 907499"},{"id":"c297960a-46d9-4215-64d6-08d5ad2bf6ba","name":"A.A.DE MELO & CIA LTDA","commercialName":"","cnpj":"53533386000163","city":"SANTA BÁRBARA D'OESTE","stateCode":"SP","buscaAdicional":"SUPERMERCADOS CREMA 56270 SUPERM CREMA F ILIAL 907210 SUPERM CREMA MATRIZ 907232"},{"id":"b7ed3b89-8625-4541-88fd-08d5ae44ed50","name":"BLOKS INDUSTRIA CERAMICA LTDA.","commercialName":"BLOKS INDUSTRIA CERAMICA","cnpj":"13365384000198","city":"SANTA CRUZ DA CONCEIÇÃO","stateCode":"SP","buscaAdicional":"BLOKS 58792 BLOKS CERAMICA 908582"},{"id":"864ef9dc-836b-4674-5ae7-08d5ad2bf6ba","name":"CERAMICA BARROBELLO INDUSTRIA E COMERCIO LTDA.","commercialName":"","cnpj":"56649577000183","city":"SANTA CRUZ DA CONCEIÇÃO","stateCode":"SP","buscaAdicional":"BARROBELLO 50335 BARROBELLO - BRULL 897500 BARROBELLO - SITIO 897501"},{"id":"23cc1cd5-6f9d-4303-5366-08d5ad2bf6ba","name":"ABENGOA BIOENERGIA AGROINDUSTRIA LTDA","commercialName":"ABAG","cnpj":"06252818000188","city":"SANTA CRUZ DAS PALMEIRAS","stateCode":"SP","buscaAdicional":"ABENGOA AGROIN 3615 ABENGOA UTE SAO JOAO 908065 ABENGOA UTE SAO LUIZ 908066 SAO LUIZ - ABENGOA 8663 UTE.AI.SP.026869-0.01 S J BOA VISTA 8577 UTE.AI.SP.027709-6.01"},{"id":"57e7b823-d37f-4ad4-5276-08d5ad2bf6ba","name":"AGROTERENAS S.A. INDUSTRIAL CITRUS","commercialName":"AGROTERENAS INDUSTRIAL CITRUS","cnpj":"08079184000139","city":"SANTA CRUZ DO RIO PARDO","stateCode":"SP","buscaAdicional":"AGROTERENAS 3071 F GUACHO- N AMERICA 7293"},{"id":"a39d1007-c9f5-4ce6-5d2f-08d5ad2bf6ba","name":"SAO JOAO ALIMENTOS LTDA","commercialName":"","cnpj":"56814395000110","city":"SANTA CRUZ DO RIO PARDO","stateCode":"SP","buscaAdicional":"SAO JOAO ALIMENTOS 51729 SAO JOAO ALIMENTOS 899284 SAO JOAO ALI FILIAL 905723"},{"id":"d9f2ada2-e836-4952-5e0a-08d5ad2bf6ba","name":"PICININ ALIMENTOS LTDA","commercialName":"PICININ ALIMENTOS","cnpj":"46232021000133","city":"SANTA CRUZ DO RIO PARDO","stateCode":"SP","buscaAdicional":"PICININ 52179 PICININ 901819"},{"id":"f2101a6c-820c-490b-6386-08d5ad2bf6ba","name":"MANFRIM INDUSTRIAL E COMERCIAL LTDA","commercialName":"","cnpj":"56813280000292","city":"SANTA CRUZ DO RIO PARDO","stateCode":"SP","buscaAdicional":"SPECIAL DOG 55429 MANFRIM IND E COM 909687"},{"id":"222e9724-20b1-4a2b-6132-08d5ad2bf6ba","name":"BRASILIA ALIMENTOS LTDA.","commercialName":"BRASILIA ALIMENTOS","cnpj":"56809338000143","city":"SANTA CRUZ DO RIO PARDO","stateCode":"SP","buscaAdicional":"BRASILIA ALIMENTOS 54052 BRASILIA ALIMENTOS 903768"},{"id":"25133e77-0e04-4106-6223-08d5ad2bf6ba","name":"CEREALISTA ROSALITO LTDA","commercialName":"","cnpj":"53622478000110","city":"SANTA CRUZ DO RIO PARDO","stateCode":"SP","buscaAdicional":"CEREALISTA 54592 CEREALISTA ROSALITO 903864"},{"id":"ff809a8d-e2ff-4e5a-61b8-08d5ad2bf6ba","name":"CEREALISTA NARDO LTDA","commercialName":"ALIMENTOS VALE BRANCO","cnpj":"56816085000135","city":"SANTA CRUZ DO RIO PARDO","stateCode":"SP","buscaAdicional":"NARDO 54349 CEREALISTA NARDO 905926"},{"id":"ef95cd47-66f6-45f9-65c8-08d5ad2bf6ba","name":"GUACIRA ALIMENTOS LTDA","commercialName":"ARROZ GUACIRA","cnpj":"48347736000167","city":"SANTA CRUZ DO RIO PARDO","stateCode":"SP","buscaAdicional":"GUACIRA 57130 GUACIRA ENGENHO 907963 GUACIRA SECADOR 908051"},{"id":"fd307826-357d-46cf-6739-08d5ad2bf6ba","name":"EMBRAMACO - EMPRESA BRASILEIRA DE MATERIAIS PARA CONSTRUCAOLTDA.","commercialName":"EMBRAMACO","cnpj":"56883820000204","city":"SANTA GERTRUDES","stateCode":"SP","buscaAdicional":"EMBRAMACO 58007 EMBRAMACO 908879"},{"id":"0b6c4b47-52b5-4c1c-6138-08d5ad2bf6ba","name":"NARDINI PISOS E REVESTIMENTOS LTDA.","commercialName":"NARDINI PISOS E REVESTIMENTOS","cnpj":"03054730000163","city":"SANTA GERTRUDES","stateCode":"SP","buscaAdicional":"NARDINI CERAMICA 54058 NARDINI PISOS E REV. 906726"},{"id":"146caef7-754e-44cf-6254-08d5ad2bf6ba","name":"INCOPISOS INDUSTRIA E COMERCIO DE PISOS LTDA","commercialName":"INCOPISOS","cnpj":"55254825000205","city":"SANTA GERTRUDES","stateCode":"SP","buscaAdicional":"INCOPISOS 54684 INCOPISOS 905184"},{"id":"c5179123-3451-414b-5d1c-08d5ad2bf6ba","name":"CEDASA INDUSTRIA E COMERCIO DE PISOS LTDA","commercialName":"","cnpj":"64700735000291","city":"SANTA GERTRUDES","stateCode":"SP","buscaAdicional":"CEDASA 51705 CEDASA 899386"},{"id":"1628131c-153e-4deb-5b5d-08d5ad2bf6ba","name":"CERAMICA VILLAGRES LTDA","commercialName":"VILLAGRES","cnpj":"48172464000292","city":"SANTA GERTRUDES","stateCode":"SP","buscaAdicional":"VILLAGRES STAGTD 50624 CERAMICA VILLAGRES 898067"},{"id":"60b281b7-8f44-4171-5bb1-08d5ad2bf6ba","name":"CERAMICA ALMEIDA LTDA","commercialName":"","cnpj":"44676633000190","city":"SANTA GERTRUDES","stateCode":"SP","buscaAdicional":"CERAMICA ALMEIDA 50831 CERAMICA ALMEIDA SP 897789 CERAMICA ALMEIDA 898078 CERAMICA ALMEIDA 898315"},{"id":"29b7b6a3-d47d-4dfc-5547-08d5ad2bf6ba","name":"CERAMICA FORMIGRES LTDA.","commercialName":"","cnpj":"01325023000139","city":"SANTA GERTRUDES","stateCode":"SP","buscaAdicional":"FORMIGRES 5230 FORMIGRES GERTRUDES 71760"},{"id":"2a3338a4-3976-4731-4ff0-08d5ad2bf6ba","name":"PARAMOUNT TEXTEIS INDUSTRIA E COMERCIO SA","commercialName":"","cnpj":"61565222000308","city":"SANTA ISABEL","stateCode":"SP","buscaAdicional":"PARAMOUNT STA 1365 SANTA ISABEL-KARIBE 7329"},{"id":"12fd4577-4b98-4ead-5d5e-08d5ad2bf6ba","name":"PELICAN TEXTIL LTDA","commercialName":"","cnpj":"61452868000117","city":"SANTA ISABEL","stateCode":"SP","buscaAdicional":"PELICAN 51799 PELICAN TEXTIL 900003"},{"id":"27ee864b-a2dc-4c42-6047-08d5ad2bf6ba","name":"PEDREIRA SANTA ISABEL LTDA.","commercialName":"","cnpj":"56899602000268","city":"SANTA ISABEL","stateCode":"SP","buscaAdicional":"PSI 53447 PSI SANTA ISABEL 904238"},{"id":"9d01a3e1-b11b-4335-721d-08d5cf600bef","name":"CONCESSIONARIA DA RODOVIA PRESIDENTE DUTRA S/A","commercialName":"","cnpj":"00861626000192","city":"SANTA ISABEL","stateCode":"SP","buscaAdicional":""},{"id":"a0c06a9c-9bb0-4715-632c-08d5ad2bf6ba","name":"IFF ESSENCIAS E FRAGRANCIAS LTDA","commercialName":"","cnpj":"33043951000288","city":"SANTANA DE PARNAÍBA","stateCode":"SP","buscaAdicional":"IFF 55234 IFF BARUERI 906339 IFF TAUBATE 906360 RIO DE JANEIRO 906742"},{"id":"fb6ed68c-22f9-4ef1-60e9-08d5ad2bf6ba","name":"GERALDISCOS COMERCIO, INDUSTRIA E REPRESENTACOES DE CORTICA LTDA","commercialName":"","cnpj":"60774007000192","city":"SANTANA DE PARNAÍBA","stateCode":"SP","buscaAdicional":"GERALDISCOS 53887 GERALDISCOS 903447"},{"id":"8567169b-b39e-4ffe-60a6-08d5ad2bf6ba","name":"GEOCAL MINERACOES LTDA.","commercialName":"","cnpj":"00255910000115","city":"SANTANA DE PARNAÍBA","stateCode":"SP","buscaAdicional":"GEOCAL 53625 GEOCAL 901983"},{"id":"68c5eca9-aad6-44c7-5f76-08d5ad2bf6ba","name":"ENGRECON S A","commercialName":"","cnpj":"60554219000164","city":"SANTANA DE PARNAÍBA","stateCode":"SP","buscaAdicional":"ENGRECON 52965 ENGRECON 904764"},{"id":"b6f865aa-3858-4c0a-5f69-08d5ad2bf6ba","name":"TOPFORM INDÚSTRIA PLÁSTICA LTDA","commercialName":"","cnpj":"09379673000250","city":"SANTANA DE PARNAÍBA","stateCode":"SP","buscaAdicional":"TOPFORM 52931 TOPFORM 904403"},{"id":"841889e0-bf62-4510-5bba-08d5ad2bf6ba","name":"ARIM COMPONENTES S/A","commercialName":"ARIM COMPONENTES S/A","cnpj":"58581406000195","city":"SANTANA DE PARNAÍBA","stateCode":"SP","buscaAdicional":"ARIM COMPONENTES 50875 ARIM COMPONENTES S/A 898567"},{"id":"17ada3f6-998c-46ae-5b7f-08d5ad2bf6ba","name":"CARTONALE INDUSTRIA E BENEFICIAMENTO DE MATERIAIS PLASTICOS LTDA.","commercialName":"","cnpj":"04051261000191","city":"SANTANA DE PARNAÍBA","stateCode":"SP","buscaAdicional":"CARTONALE 50734 CARTONALE 899088"},{"id":"cc000484-5096-46c3-5165-08d5ad2bf6ba","name":"VEYANCE TECHNOLOGIES DO BRASIL PRODUTOS DE ENGENHARIA LTDA","commercialName":"","cnpj":"08832031000463","city":"SANTANA DE PARNAÍBA","stateCode":"SP","buscaAdicional":"CONT VEYANCE PARNAIBA 2151 VVEYANCE TEC BR PROD 907318"},{"id":"96667cc1-6eee-44a0-56b2-08d5ad2bf6ba","name":"HARALD INDUSTRIA E COMERCIO DE ALIMENTOS S.A.","commercialName":"","cnpj":"88304001000251","city":"SANTANA DE PARNAÍBA","stateCode":"SP","buscaAdicional":"HARALD 7522 HARALD S PARNAIBA 72365"},{"id":"e9cf8d59-535c-44c9-6017-08d5ad2bf6ba","name":"Z.P.P. INDUSTRIA DE EMBALAGENS PLASTICAS EIRELI","commercialName":"","cnpj":"00687393000153","city":"SANTA RITA DO PASSA QUATRO","stateCode":"SP","buscaAdicional":"ZPP EMBALAGENS 53373 ZPP EMBALAGENS 900858 ZPP 37552511 903595"},{"id":"ea0dbb14-cc5a-4400-5e1f-08d5ad2bf6ba","name":"ISA INDUSTRIA DE EMBALAGENS LTDA.","commercialName":"","cnpj":"03753284000185","city":"SANTA RITA DO PASSA QUATRO","stateCode":"SP","buscaAdicional":"ISA EMBALAGENS 52225 ISA STA RISA PASSA 4 903215"},{"id":"b7925bd5-a64f-4a7c-73c5-08d5cf600bef","name":"TC SECURITIES CIA. DE SECURITIZACAO","commercialName":"","cnpj":"67437434000124","city":"SANTA RITA DO PASSA QUATRO","stateCode":"SP","buscaAdicional":""},{"id":"e2fc8de4-d494-4496-5285-08d5ad2bf6ba","name":"I&M PAPEIS E EMBALAGENS LTDA","commercialName":"","cnpj":"07277575000103","city":"SANTA ROSA DE VITERBO","stateCode":"SP","buscaAdicional":"ISIDORIO MORAE 3102 ISIDORIO MORAES 7997 ISIDORIO-ITATIBA 71158"},{"id":"90e9ff3a-d882-420b-50f1-08d5ad2bf6ba","name":"TATE & LYLE BRASIL S.A.","commercialName":"","cnpj":"42361873000170","city":"SANTA ROSA DE VITERBO","stateCode":"SP","buscaAdicional":"TATE E LYLE 1914 TATE LYLE BR 70260"},{"id":"36c365c9-d42e-421c-55e5-08d5ad2bf6ba","name":"SINA INDUSTRIA DE OLEOS VEGETAIS LTDA","commercialName":"SINA","cnpj":"06348804000162","city":"SANTO ANASTÁCIO","stateCode":"SP","buscaAdicional":"SINA S ANAST 6291 SINA OLEOS ANASTACIO 72009"},{"id":"63887152-5fc5-41ef-56f9-08d5ad2bf6ba","name":"COOP - COOPERATIVA DE CONSUMO","commercialName":"COOP - COOPERATIVA DE CONSUMO","cnpj":"57508426000178","city":"SANTO ANDRÉ","stateCode":"SP","buscaAdicional":"COOP COPERATIV 8060 COOP ITAVUVU 888901 COOP ITAPARK 888902 COOP VIANAS 888903 COOP CAFE FILHO 888904 COOP ARVORE GRANDE 889062 COOP RIBEIRAO PIRES 889617 COOP DIADEMA 889828 COOP INDUSTRIAL 889964 COOP MAUA 889968 COOP - SANTANA 889969 COOP - MORUMBI 889970 COOP DEPOSITO 890154 COOP CAPUAVA 890185 COOP QUEIROS 890186 COOP J NABUCO 890187 COOP PIRACICABA 890189 COOP NOVO HORIZONTE 894063 COOP CARIJOS 898163 COOP PERIMETRAL 898180 COOP PARQUE NACOES 898252 COOP RUDGE RAMOS 898272 COOP JARDIM ANGELICA 898273 COOP CENTRO ADM 898371 COOP TATUI I 898570 COOP TATUI 2 898571"},{"id":"f00b49ac-4e7d-4efc-5766-08d5ad2bf6ba","name":"MAXION WHEELS DO BRASIL LTDA.","commercialName":"HL HOLDING","cnpj":"02234234000129","city":"SANTO ANDRÉ","stateCode":"SP","buscaAdicional":"MAXION WHEELS 8791 HAYS LEMMERZ 888614"},{"id":"20289e32-5dbd-4f60-5530-08d5ad2bf6ba","name":"CONDOMINIO ESPECIAL SHOPPING ABC","commercialName":"CONDOMINIO ESPECIAL SHOPPING ABC","cnpj":"03773419000174","city":"SANTO ANDRÉ","stateCode":"SP","buscaAdicional":"SHOP ABC 5161 SHOP ABC-STO ANDRE 71937"},{"id":"3e771ed8-fc85-42f9-539b-08d5ad2bf6ba","name":"PARANAPANEMA S/A","commercialName":"","cnpj":"60398369000800","city":"SANTO ANDRÉ","stateCode":"SP","buscaAdicional":"PARANAP MTZ 3728 PARAN I&C - SANDRE 7816 PARAN I&C - CAPUAVA 7827 PARANAPANEMA S A I&C 70508"},{"id":"feb7fd00-387c-480f-50bc-08d5ad2bf6ba","name":"BRIDGESTONE DO BRASIL INDUSTRIA E COMERCIO LTDA.","commercialName":"BRIDGESTONE","cnpj":"57497539000115","city":"SANTO ANDRÉ","stateCode":"SP","buscaAdicional":"BRIDGESTONE 1812 BRIDGESTONE-S. ANDRE 70199 BRIDGESTONE FIPIL 901473"},{"id":"acdb487b-87d4-450f-5099-08d5ad2bf6ba","name":"PIRELLI PNEUS LTDA.","commercialName":"","cnpj":"59179838000137","city":"SANTO ANDRÉ","stateCode":"SP","buscaAdicional":"PIRELLI CAMPINAS 1744 PIRELLI CAMPINAS 7026"},{"id":"1673f70a-248a-42cc-5063-08d5ad2bf6ba","name":"LABORTEX IND E COM DE PRODUTOS DE BORRACHA LTDA","commercialName":"","cnpj":"57494239000182","city":"SANTO ANDRÉ","stateCode":"SP","buscaAdicional":"LABORTEX 1603 LABORTEX-SANTO ANDRE 70072"},{"id":"59522c61-20bd-4d09-4ffd-08d5ad2bf6ba","name":"MAGNETI MARELLI COFAP FABRICADORA DE PECAS LTDA.","commercialName":"","cnpj":"02865246000151","city":"SANTO ANDRÉ","stateCode":"SP","buscaAdicional":"MMCOFAP 1389 COFAP SINT. S ANDRE 7229 COFAP AMORT. MAUA 7230 COFAP LAVRAS 7261"},{"id":"b8a99a6d-a92c-4ca6-4feb-08d5ad2bf6ba","name":"CONDOMINIO GRAND PLAZA SHOPPING","commercialName":"","cnpj":"01993418000100","city":"SANTO ANDRÉ","stateCode":"SP","buscaAdicional":"ABC PLAZA SHOP 1360 COND ABC PLAZA SHOPP 7407"},{"id":"0215b49d-b644-4714-4f6b-08d5ad2bf6ba","name":"PRYSMIAN CABOS E SISTEMAS DO BRASIL S/A","commercialName":"","cnpj":"61150751000260","city":"SANTO ANDRÉ","stateCode":"SP","buscaAdicional":"PRYSMIAN CABOS 1092 PIRELLI CABOS S ANDR 7022"},{"id":"bf54d866-a217-41c0-5d8b-08d5ad2bf6ba","name":"BRYK INDUSTRIA DE PANIFICACAO EIRELI","commercialName":"","cnpj":"55285829000170","city":"SANTO ANDRÉ","stateCode":"SP","buscaAdicional":"BRYK 51869 BRYK INDUSTRIA 900596"},{"id":"caec37a5-fc83-44a0-60e0-08d5ad2bf6ba","name":"ASSOCIACAO ATRIUM SHOPPING SANTO ANDRE","commercialName":"","cnpj":"18605172000154","city":"SANTO ANDRÉ","stateCode":"SP","buscaAdicional":"ATRIUM SANTO ANDRE 53821 ATRIUM SHOP ST ANDRE 909640"},{"id":"038e4bbc-d6bf-46cf-5fcf-08d5ad2bf6ba","name":"IPSIS GRAFICA E EDITORA SA","commercialName":"","cnpj":"61407078000110","city":"SANTO ANDRÉ","stateCode":"SP","buscaAdicional":"IPSIS GRAFICA 53232 IPSIS GRAFICA 903446"},{"id":"77b06113-7efe-47fb-5bf9-08d5ad2bf6ba","name":"PROMETEON TYRE GROUP INDUSTRIA BRASIL LTDA.","commercialName":"","cnpj":"22301988000404","city":"SANTO ANDRÉ","stateCode":"SP","buscaAdicional":"TP PNEUS SANTO ANDRE 51007 PIRELLI PNEUS S.ANDR 7562"},{"id":"bb995a10-9afc-44ab-5a2a-08d5ad2bf6ba","name":"FEDERAL-MOGUL COMPONENTES DE MOTORES LTDA.","commercialName":"","cnpj":"20697193000199","city":"SANTO ANDRÉ","stateCode":"SP","buscaAdicional":"FM COMPONENTES 17174 TRW SANTO ANDRE SP 70330 TRW TC 888293"},{"id":"6108e69a-4367-48e6-730f-08d5cf600bef","name":"CVC BRASIL OPERADORA E AGENCIA DE VIAGENS S.A.","commercialName":"","cnpj":"10760260000119","city":"SANTO ANDRÉ","stateCode":"SP","buscaAdicional":""},{"id":"7bd5d521-b7bc-4bbb-73a9-08d5cf600bef","name":"NORDON INDUSTRIAS METALURGICAS S A","commercialName":"EST UNIF","cnpj":"60884319000159","city":"SANTO ANDRÉ","stateCode":"SP","buscaAdicional":""},{"id":"c593f6b7-ba9a-465f-616d-08d5ad2bf6ba","name":"GJP ADMINISTRADORA DE HOTEIS LTDA","commercialName":"","cnpj":"07687928000135","city":"SANTO ANDRÉ","stateCode":"SP","buscaAdicional":"BOSSANOVA MALL 54181 BOSSANOVA MALL 904873"},{"id":"953fadeb-1e6f-4659-61dd-08d5ad2bf6ba","name":"SUPERMERCADO SAO JUDAS TADEU LIMITADA","commercialName":"","cnpj":"57546715000161","city":"SANTO ANDRÉ","stateCode":"SP","buscaAdicional":"SUPERMERCADO SAO JUDAS TADEU 54451 SAO JUDAS LOJA 4 906708 SAO JUDAS LOJA 5 906734 SAO JUDAS LOJA 6 906735 SAO JUDAS LOJA 8 906736 SAO JUDAS TADEU LJ07 907891"},{"id":"0b0e0e88-0628-4ba6-8844-08d5ae44ed50","name":"UNNAFIBRAS TEXTIL LTDA. EM RECUPERACAO JUDICIAL","commercialName":"","cnpj":"00924545000194","city":"SANTO ANDRÉ","stateCode":"SP","buscaAdicional":"UNNAFIBRAS 2069 UNNAFIBRAS 70478"},{"id":"2a1ad762-5fb2-4ecd-68cb-08d5ad2bf6ba","name":"RHODIA ACETOW BRASIL INDUSTRIA E COMERCIO LTDA.","commercialName":"FIOPART-COMERCIO DE FIOS INDUSTRIAIS LTDA","cnpj":"07794384000100","city":"SANTO ANDRÉ","stateCode":"SP","buscaAdicional":"ACETOW 60416 FIOPART 911234"},{"id":"ca46e5b1-a32c-4619-67f2-08d5ad2bf6ba","name":"DEICMAR ARMAZENAGEM E DISTRIBUICAO LTDA.","commercialName":"DEICMAR","cnpj":"58188756000196","city":"SANTOS","stateCode":"SP","buscaAdicional":"DEICMAR 58991 DEICMAR BK 909373 DEICMAR CLIA 909374"},{"id":"5d7039d8-b1a8-4075-6949-08d5ad2bf6ba","name":"CONDOMINIO THE BLUE OFFICEMALL","commercialName":"","cnpj":"20544289000117","city":"SANTOS","stateCode":"SP","buscaAdicional":"THE BLUE OFFICEMALL 60986 BLUE OFFICEMALL 911984"},{"id":"cc4928e5-b29c-43a0-6748-08d5ad2bf6ba","name":"MITSUI ALIMENTOS LTDA","commercialName":"","cnpj":"58128190000107","city":"SANTOS","stateCode":"SP","buscaAdicional":"MITSUI ALIMENTOS 58027 MITSUI ALIMENTOS 909174 MITSUI ALIMENTOS MT 909292"},{"id":"71951808-c5cf-4fd2-66c8-08d5ad2bf6ba","name":"LIBRA TERMINAL VALONGO S/A","commercialName":"","cnpj":"08809288000151","city":"SANTOS","stateCode":"SP","buscaAdicional":"LIBRA VALONGO 57814 LIBRA VALONGO 907625"},{"id":"c35de803-6954-46a5-66a0-08d5ad2bf6ba","name":"CLINICA MULT IMAGEM LTDA","commercialName":"","cnpj":"64714181000109","city":"SANTOS","stateCode":"SP","buscaAdicional":"MULT IMAGEM 57698 MULT IMAGEM 908668"},{"id":"54b3ab1f-bba2-4850-62c5-08d5ad2bf6ba","name":"SOCIEDADE VISCONDE DE S LEOPOLDO","commercialName":"","cnpj":"58191008000162","city":"SANTOS","stateCode":"SP","buscaAdicional":"LICEU SANTISTA 54965 VISCONDE S LEOPOLDO 906850 VISCONDE S. LEOPOLDO 906872 VISCONDE S LEOP D ID 906873"},{"id":"436acc70-4034-41ee-6299-08d5ad2bf6ba","name":"CITROSUCO SERVICOS PORTUARIOS S.A.","commercialName":"SERVICOS PORTUARIOS","cnpj":"03100114000100","city":"SANTOS","stateCode":"SP","buscaAdicional":"CITROSUCO PORTUARIOS 54814 CITROSUCO PORTUARIOS 905156"},{"id":"ffc6eb31-6600-479c-653a-08d5ad2bf6ba","name":"LIBRA TERMINAIS S.A.","commercialName":"","cnpj":"33813452001032","city":"SANTOS","stateCode":"SP","buscaAdicional":"LIBRA TERMINAIS 56611 LIBRA TERMINAIS SANT 905982"},{"id":"15bffe9c-766e-48ef-6549-08d5ad2bf6ba","name":"COMPANHIA AUXILIAR DE ARMAZENS GERAIS","commercialName":"","cnpj":"61145488000300","city":"SANTOS","stateCode":"SP","buscaAdicional":"COPERSUCAR SANTOS 56640 CIA AUX ARMAZENS GER 907200"},{"id":"14f21d34-404e-40b3-6522-08d5ad2bf6ba","name":"INSTITUTO DE EDUCACAO E CULTURA UNIMONTE S/A","commercialName":"","cnpj":"44952711000131","city":"SANTOS","stateCode":"SP","buscaAdicional":"ANIMA UNIMONTE 56514 INST EDUC UNIMONTE 907780"},{"id":"5d21d3c3-7fa2-4390-57fc-08d5ad2bf6ba","name":"MOINHO PACIFICO INDUSTRIA E COMERCIO LTDA","commercialName":"","cnpj":"60854189000292","city":"SANTOS","stateCode":"SP","buscaAdicional":"MOINHO PACIFICO 10331 MOINHO PACIFICO 889545"},{"id":"02e62f09-bad0-44f2-5f2f-08d5ad2bf6ba","name":"EMBRAPORT EMPRESA BRASILEIRA DE TERMINAIS PORTUARIOS S/A","commercialName":"DP WORLD SANTOS","cnpj":"02805610000198","city":"SANTOS","stateCode":"SP","buscaAdicional":"EMBRAPORT 52838 EMBRAPORT 904308"},{"id":"c8eb5865-148e-4c25-5ec0-08d5ad2bf6ba","name":"MENDES HOTEIS TURISMO E ADMINISTRADORA LTDA","commercialName":"","cnpj":"56067705000180","city":"SANTOS","stateCode":"SP","buscaAdicional":"MENDES HOTEIS 52535 MENDES HOTEIS ESTACI 900852 MENDES H ESCRITORIO 900865 MENDES H PANORAMA 900867 MENDES H PLAZA 900868 MENDES H SHOPPING 900873"},{"id":"37061fa3-ad6d-42bc-5081-08d5ad2bf6ba","name":"MIRAMAR EMPREENDIMENTOS IMOBILIARIOS LTDA","commercialName":"","cnpj":"46206421000174","city":"SANTOS","stateCode":"SP","buscaAdicional":"PRAIAMAR 1665 MIRAMAR PRAIAM. STOS 7175 BRISAMAR SANTOS SVIC 70386"},{"id":"6ead6f0d-1032-4303-54fa-08d5ad2bf6ba","name":"CONDOMINIO SHOPPING PATIO IPORANGA","commercialName":"SHOPPING PATIO IPORANGA","cnpj":"11418940000111","city":"SANTOS","stateCode":"SP","buscaAdicional":"PAT IPORANGA 4640 PATIO IPORANGA 71804"},{"id":"7f46522d-ad0b-42c0-56db-08d5ad2bf6ba","name":"BRASIL TERMINAL PORTUARIO S.A.","commercialName":"","cnpj":"04887625000178","city":"SANTOS","stateCode":"SP","buscaAdicional":"BTP 7861 BTP SANTOS 72380"},{"id":"88ec4ba0-7c90-4449-5714-08d5ad2bf6ba","name":"CONSORCIO EMPREENDEDOR DO SAO BERNARDO PLAZA SHOPPING","commercialName":"","cnpj":"14424018000125","city":"SÃO BERNARDO DO CAMPO","stateCode":"SP","buscaAdicional":"SB PLAZA SHOP 8190 SAO BERNARDO PLAZA 889126"},{"id":"096ec530-545a-45ff-576f-08d5ad2bf6ba","name":"CONDOMINIO CIVIL CENTER SHOP SAO BERNARDO","commercialName":"","cnpj":"71538367000101","city":"SÃO BERNARDO DO CAMPO","stateCode":"SP","buscaAdicional":"SHOP METROPOLE 8818 SHOPPING METROPOLE 888597"},{"id":"ad5f3404-800c-4ea8-57c5-08d5ad2bf6ba","name":"TUBOS IPIRANGA INDUSTRIA E COMERCIO LTDA","commercialName":"","cnpj":"01477885000187","city":"SÃO BERNARDO DO CAMPO","stateCode":"SP","buscaAdicional":"TUBOS IPIRANGA 9593 IPIRANGA RIB PIRES 889033 IPIRANGA PIRAPORINHA 889034 IPIRANGA LEMOS TORRE 889035"},{"id":"b68fd073-584b-4612-55cc-08d5ad2bf6ba","name":"IPERFOR INDUSTRAL LTDA EM RECUPERACAO JUDICIAL","commercialName":"","cnpj":"00009638000193","city":"SÃO BERNARDO DO CAMPO","stateCode":"SP","buscaAdicional":"IPERFOR 6158 IPERFOR-IPERO 72261"},{"id":"845dedb8-424d-4068-54bd-08d5ad2bf6ba","name":"THE VALSPAR CORPORATION LTDA.","commercialName":"","cnpj":"01635544000192","city":"SÃO BERNARDO DO CAMPO","stateCode":"SP","buscaAdicional":"VALSPAR 4469 VALSPAR-SBC 71741"},{"id":"9910c051-76ab-4b08-555d-08d5ad2bf6ba","name":"MANGELS INDUSTRIAL S.A.,","commercialName":"","cnpj":"61065298000455","city":"SÃO BERNARDO DO CAMPO","stateCode":"SP","buscaAdicional":"MANGELS SBC SP 5429 MANGELS -SBC 7815"},{"id":"44fa172f-7f44-4619-5076-08d5ad2bf6ba","name":"TERMOMECANICA SAO PAULO S A","commercialName":"","cnpj":"59106666000171","city":"SÃO BERNARDO DO CAMPO","stateCode":"SP","buscaAdicional":"TERMOMECANICA 1637 TERMOMECANICA II SBC 7163 TERMOMECANICA I MTZ 7164"},{"id":"f65e411a-562e-4f40-500f-08d5ad2bf6ba","name":"WHEATON BRASIL VIDROS LTDA.","commercialName":"","cnpj":"60750056000195","city":"SÃO BERNARDO DO CAMPO","stateCode":"SP","buscaAdicional":"WHEATON MATRIZ 1417 WHEATON VIDROS SBC 7222"},{"id":"1515fe41-a73a-426d-5010-08d5ad2bf6ba","name":"MAHLE METAL LEVE S.A.","commercialName":"","cnpj":"60476884001744","city":"SÃO BERNARDO DO CAMPO","stateCode":"SP","buscaAdicional":"MAHLE SBC 1418 MAHLE-S.B. DO CAMPO 7388"},{"id":"8e04d4d6-5b48-48bf-50e0-08d5ad2bf6ba","name":"PERTECH DO BRASIL LTDA.","commercialName":"","cnpj":"59664391000191","city":"SÃO BERNARDO DO CAMPO","stateCode":"SP","buscaAdicional":"PERTECH 1881 PERTECH-SAO BERNARDO 70227"},{"id":"ab0786ad-766e-4dfa-510d-08d5ad2bf6ba","name":"AUTOMETAL SBC INJECAO E PINTURA DE PLASTICOS LTDA","commercialName":"","cnpj":"03985506000195","city":"SÃO BERNARDO DO CAMPO","stateCode":"SP","buscaAdicional":"AUTOMETAL SBC 1962 AUTOMETAL SBC INJ 70341"},{"id":"9e9fb127-b22d-4835-4fca-08d5ad2bf6ba","name":"FORD MOTOR COMPANY BRASIL LTDA","commercialName":"","cnpj":"03470727000120","city":"SÃO BERNARDO DO CAMPO","stateCode":"SP","buscaAdicional":"FORD 1277 FORD SBC 7082 FORD TAU 7483 FORD CAMACARI 908185"},{"id":"693f9b06-6622-451e-4fbb-08d5ad2bf6ba","name":"VOLKSWAGEN DO BRASIL INDUSTRIA DE VEICULOS AUTOMOTORES LTDA","commercialName":"","cnpj":"59104422000150","city":"SÃO BERNARDO DO CAMPO","stateCode":"SP","buscaAdicional":"VOLKSWAGEN 1255 VOLKS TAU 7471 VOLKSWAGEN S.CARLOS 70789 VOLKS S JOSE PINHAIS 899431 VOLKSWAGEN ANCHIETA 194"},{"id":"7505afff-23db-4c20-4fa0-08d5ad2bf6ba","name":"MERCEDES-BENZ DO BRASIL LTDA.","commercialName":"","cnpj":"59104273000129","city":"SÃO BERNARDO DO CAMPO","stateCode":"SP","buscaAdicional":"MERCEDES SBC 1190 DCBR-S.BERNARDO-SP 7551 DAIMLER CHRYSLER CAM 7591"},{"id":"7058862e-966a-408e-52c0-08d5ad2bf6ba","name":"EMS S/A","commercialName":"GRUPO EMS SIGMA PHARMA","cnpj":"57507378000101","city":"SÃO BERNARDO DO CAMPO","stateCode":"SP","buscaAdicional":"EMS 3271 EMS S BERNARDO CAMPO 71040 EMS HORTOLANDIA 71039"},{"id":"bf00fcd1-8019-4423-5340-08d5ad2bf6ba","name":"TOYOTA DO BRASIL LTDA","commercialName":"","cnpj":"59104760000191","city":"SÃO BERNARDO DO CAMPO","stateCode":"SP","buscaAdicional":"TOYOTA 3537 TOYOTA SBC 71146 TOYOTA IDT 71381 TOYOTA PFZ 898127 TOYOTA-SOROCABA 71874"},{"id":"65ae9b06-596d-4ff8-5344-08d5ad2bf6ba","name":"RASSINI-NHK AUTOPECAS LTDA.","commercialName":"RASSINI - NHK AUTOMOTIVE","cnpj":"61142063000177","city":"SÃO BERNARDO DO CAMPO","stateCode":"SP","buscaAdicional":"RASSINI-NHK 3545 RASSINI NHK 71097 RASSINI NHK-RIO 71342"},{"id":"9d0f3f7c-712a-4d9b-5100-08d5ad2bf6ba","name":"BOMBRIL S/A","commercialName":"","cnpj":"50564053000103","city":"SÃO BERNARDO DO CAMPO","stateCode":"SP","buscaAdicional":"BOMBRIL 1944 BOMBRIL MTZ SBC 70322 BOMBRIL ABREU LIMA 888127"},{"id":"19e93f04-4b2b-4cb7-513f-08d5ad2bf6ba","name":"KOSTAL ELETROMECANICA LTDA","commercialName":"","cnpj":"60852274000130","city":"SÃO BERNARDO DO CAMPO","stateCode":"SP","buscaAdicional":"KOSTAL 2072 KOSTAL SBC 70451 KOSTAL CRAVINHOS 907516 KOSTAL CRAVINHOS II 911225"},{"id":"2190102a-5e75-478b-51e1-08d5ad2bf6ba","name":"COLGATE PALMOLIVE INDUSTRIAL LTDA","commercialName":"COLGATE PALMOLIVE INDUSTRIAL","cnpj":"03816532000190","city":"SÃO BERNARDO DO CAMPO","stateCode":"SP","buscaAdicional":"COLGATE PALM 2694 COLGATE 430-JAGUARE 7506 COLGATE 51N-SBC-SP 7507"},{"id":"01fb0a4a-5c31-4c8f-5ec4-08d5ad2bf6ba","name":"GENERAL MILLS BRASIL ALIMENTOS LTDA.","commercialName":"YOKI ALIMENTOS","cnpj":"61586558001329","city":"SÃO BERNARDO DO CAMPO","stateCode":"SP","buscaAdicional":"YOKI 52539 GEN MILLS EMBALAGENS 902316 GEN MILLS ALIMENTOS 902318 GENERAL MILLS NPA 907503 GENERAL MILLS POU 907597"},{"id":"162f72c6-f88a-4eb7-5e75-08d5ad2bf6ba","name":"CONDOMINIO GOLDEN SQUARE","commercialName":"","cnpj":"10912680000173","city":"SÃO BERNARDO DO CAMPO","stateCode":"SP","buscaAdicional":"GOLDEN SQUARE SHOP 52393 CONDOMINIO SQUARE 900638"},{"id":"bbaad287-9643-4d22-5e08-08d5ad2bf6ba","name":"METALURGICA NHOZINHO LIMITADA","commercialName":"NHOZINHO","cnpj":"59283671000150","city":"SÃO BERNARDO DO CAMPO","stateCode":"SP","buscaAdicional":"NHOZINHO 52155 NHOZINHO 901094"},{"id":"20c2dbbd-6e85-42ae-5dcc-08d5ad2bf6ba","name":"B GROB DO BRASIL S A IND COM MAQS OPERAT E FERRAMENTAS","commercialName":"","cnpj":"60586450000130","city":"SÃO BERNARDO DO CAMPO","stateCode":"SP","buscaAdicional":"GROB 51990 B GROB DO BRASIL 899796"},{"id":"ccea2f06-dde7-4dc6-5f11-08d5ad2bf6ba","name":"MORGANITE BRASIL LTDA.","commercialName":"","cnpj":"57008948000100","city":"SÃO BERNARDO DO CAMPO","stateCode":"SP","buscaAdicional":"MORGANITE 52723 MORGANITE STA CRUZ 901146 MORGANITE - SBC 902413"},{"id":"ee907bf1-3fbf-4490-5f9c-08d5ad2bf6ba","name":"FAURECIA AUTOMOTIVE DO BRASIL LTDA","commercialName":"FAURECIA AUTOMOTIVE DO BRASIL","cnpj":"01178298000782","city":"SÃO BERNARDO DO CAMPO","stateCode":"SP","buscaAdicional":"FAURECIA SBC 53047 FAURECIA SBC 903839"},{"id":"2252d3b3-e039-4308-6094-08d5ad2bf6ba","name":"LINHAS SETTA LTDA","commercialName":"","cnpj":"60887189000108","city":"SÃO BERNARDO DO CAMPO","stateCode":"SP","buscaAdicional":"SETTA 53606 LINHAS SETTA 904795"},{"id":"1d8b8c31-a206-4924-602c-08d5ad2bf6ba","name":"SHERWIN-WILLIAMS DO BRASIL INDUSTRIA E COMERCIO LTDA.","commercialName":"","cnpj":"60872306004076","city":"SÃO BERNARDO DO CAMPO","stateCode":"SP","buscaAdicional":"SW 53413 SHERWIN-WILLIAMS 904767"},{"id":"7eb74293-40d6-4eb4-6076-08d5ad2bf6ba","name":"INCOM - INDUSTRIAL EIRELI","commercialName":"INCOM","cnpj":"04676345000110","city":"SÃO BERNARDO DO CAMPO","stateCode":"SP","buscaAdicional":"INCOM 53517 INCOM INDUSTRIAL 905508"},{"id":"8ba44eec-c4e8-4120-5858-08d5ad2bf6ba","name":"FIBAM COMPANHIA INDUSTRIAL","commercialName":"","cnpj":"61410395000195","city":"SÃO BERNARDO DO CAMPO","stateCode":"SP","buscaAdicional":"FIBAM 11429 FIBAM SBC 889992"},{"id":"d9d8932e-862a-4b39-5c1d-08d5ad2bf6ba","name":"SCANIA LATIN AMERICA LTDA","commercialName":"","cnpj":"59104901000176","city":"SÃO BERNARDO DO CAMPO","stateCode":"SP","buscaAdicional":"SCANIA 51093 SCANIA 898270"},{"id":"25a7ee35-09d8-45ee-5bac-08d5ad2bf6ba","name":"SAARGUMMI DO BRASIL LTDA","commercialName":"","cnpj":"03488562000114","city":"SÃO BERNARDO DO CAMPO","stateCode":"SP","buscaAdicional":"SAARGUMMI 50822 SAARGUMMI 898287"},{"id":"1767393b-8ca3-4ea1-6535-08d5ad2bf6ba","name":"OLGA COLOR SPA LTDA","commercialName":"","cnpj":"71815161000262","city":"SÃO BERNARDO DO CAMPO","stateCode":"SP","buscaAdicional":"OLGA COLOR FILIAL 56591 OLGA COLOR FILIAL SP 907464"},{"id":"a56d2b22-85f6-47d3-6510-08d5ad2bf6ba","name":"COSMA DO BRASIL PRODUTOS E SERVICOS AUTOMOTIVOS LTDA.","commercialName":"","cnpj":"02591818000151","city":"SÃO BERNARDO DO CAMPO","stateCode":"SP","buscaAdicional":"COSMA MATRIZ 56458 COSMA MG 71282 COSMA S J PINHAIS 909086 COSMA CAMACARI 909094 COSMA DO BRASIL SANT 909678 COSMA JOINVILLE 909844 COSMA SP 910153"},{"id":"7ea91145-608c-412b-64ae-08d5ad2bf6ba","name":"SO GELO INDUSTRIA E COMERCIO EIRELI","commercialName":"","cnpj":"43736610000241","city":"SÃO BERNARDO DO CAMPO","stateCode":"SP","buscaAdicional":"SOGELO IND 56152 SO GELO INDUSTRIA 904113"},{"id":"87edc438-4e4a-4cae-6494-08d5ad2bf6ba","name":"SERAL OTIS INDUSTRIA METALURGICA LTDA","commercialName":"","cnpj":"46382206000124","city":"SÃO BERNARDO DO CAMPO","stateCode":"SP","buscaAdicional":"OTIS 56111 OTIS SBC 904969"},{"id":"c8e0c44c-25c3-4660-62f0-08d5ad2bf6ba","name":"ACRILEX TINTAS ESPECIAIS S A","commercialName":"","cnpj":"60779014000187","city":"SÃO BERNARDO DO CAMPO","stateCode":"SP","buscaAdicional":"ACRILEX 55052 ACRILEX TINTAS 906854"},{"id":"ed2c2748-e9e3-408d-6206-08d5ad2bf6ba","name":"ALUMBRA PRODUTOS ELETRICOS E ELETRONICOS LTDA","commercialName":"ALUMBRA","cnpj":"59114777000120","city":"SÃO BERNARDO DO CAMPO","stateCode":"SP","buscaAdicional":"ALUMBRA 54507 ALUMBRA 903867"},{"id":"6977376e-0f89-4024-6171-08d5ad2bf6ba","name":"D M I ISOLANTES ELETRICOS LTDA.","commercialName":"DMI","cnpj":"05213735000117","city":"SÃO BERNARDO DO CAMPO","stateCode":"SP","buscaAdicional":"DMI ISOLANTES 54191 DMI ISOLANTES - SBC 906853"},{"id":"4f82cabe-4034-48b7-6118-08d5ad2bf6ba","name":"ADIENT DO BRASIL BANCOS AUTOMOTIVOS LTDA.","commercialName":"","cnpj":"00514820000100","city":"SÃO BERNARDO DO CAMPO","stateCode":"SP","buscaAdicional":"ADIENT 54011 ADIENT DO BRASIL BAN 904962"},{"id":"b46e04c4-eb51-4557-66e5-08d5ad2bf6ba","name":"FRIGORIFICO MARBA LTDA","commercialName":"","cnpj":"61270393000148","city":"SÃO BERNARDO DO CAMPO","stateCode":"SP","buscaAdicional":"MARBA 57878 MARBA 908564"},{"id":"1efc4c00-caf6-4933-6709-08d5ad2bf6ba","name":"ENTERPRISE SERVICES BRASIL SERVICOS DE TECNOLOGIA LTDA","commercialName":"","cnpj":"02833315000145","city":"SÃO BERNARDO DO CAMPO","stateCode":"SP","buscaAdicional":"DXC 57934 HP SAMUEL AIZEMBERG 71749 BDC VIA ANCHIETA-SP 71728 HP ALPHAVILLE 71729"},{"id":"8c656cac-ec92-42cc-6707-08d5ad2bf6ba","name":"INTERGRAF INDUSTRIA GRAFICA S.A.","commercialName":"","cnpj":"01996104000160","city":"SÃO BERNARDO DO CAMPO","stateCode":"SP","buscaAdicional":"INTERGRAF 57931 INTERGRAF S BERNARDO 908573"},{"id":"72718bd1-124d-4314-73ad-08d5cf600bef","name":"MANGELS INDUSTRIAL S.A.,","commercialName":"","cnpj":"61065298000102","city":"SÃO BERNARDO DO CAMPO","stateCode":"SP","buscaAdicional":""},{"id":"918e87d1-df2f-45ca-7315-08d5cf600bef","name":"BSI CAPITAL SECURITIZADORA S/A","commercialName":"BSI CAPITAL SECURITIZADORA","cnpj":"11257352000143","city":"SÃO BERNARDO DO CAMPO","stateCode":"SP","buscaAdicional":""},{"id":"ae4dedd2-d89d-47dd-72e0-08d5cf600bef","name":"ECORODOVIAS CONCESSOES E SERVICOS S/A","commercialName":"","cnpj":"08873873000110","city":"SÃO BERNARDO DO CAMPO","stateCode":"SP","buscaAdicional":""},{"id":"bffe4a0a-8471-4e5e-725b-08d5cf600bef","name":"CONCESSIONARIA ECOVIAS DOS IMIGRANTES S.A.","commercialName":"","cnpj":"02509491000126","city":"SÃO BERNARDO DO CAMPO","stateCode":"SP","buscaAdicional":""},{"id":"cb2dda10-9f33-41c0-724d-08d5cf600bef","name":"TEGMA GESTAO LOGISTICA S.A.","commercialName":"","cnpj":"02351144000118","city":"SÃO BERNARDO DO CAMPO","stateCode":"SP","buscaAdicional":""},{"id":"7a293583-95b8-4a10-66c2-08d5ad2bf6ba","name":"CONFAB INDUSTRIAL SOCIEDADE ANONIMA","commercialName":"","cnpj":"60882628000190","city":"SÃO CAETANO DO SUL","stateCode":"SP","buscaAdicional":"CONFAB INDUSTRIAL 57789 CONFAB PIN 7594 CONFAB INDUSTRIAL 909079"},{"id":"49acc018-d2b8-41b7-669d-08d5ad2bf6ba","name":"S.G. - INDUSTRIA E COMERCIO DE PLASTICOS E ELASTOMEROS LTDA","commercialName":"","cnpj":"43037720000134","city":"SÃO CAETANO DO SUL","stateCode":"SP","buscaAdicional":"SG PLASTICOS SC 57693 SG PLAST SAO CAETANO 908915"},{"id":"4f902ab1-0868-4608-664a-08d5ad2bf6ba","name":"CRESCO COMERCIO DE ALIMENTOS LTDA","commercialName":"CRESCO COMERCIO DE ALIMENTOS LTDA","cnpj":"18303320000186","city":"SÃO CAETANO DO SUL","stateCode":"SP","buscaAdicional":"CRESCO 57471 CRESCO RICARDO JAFET 911753 CRESCO SUMARE 911754 CRESCO SAO GABRIEL 911755 CRESCO SAO CAETANO 911771 CRESCO ANALIA 911772 CRESCO SOCRATES 911773 CRESCO ALPHAVILLE 911774 CRESCO COTOXO 911775"},{"id":"339db4f8-db8f-4ca7-630d-08d5ad2bf6ba","name":"FC INDUSTRIA E COMERCIO DE ALIMENTOS PARA ANIMAIS EIRELI","commercialName":"","cnpj":"23965799000156","city":"SÃO CAETANO DO SUL","stateCode":"SP","buscaAdicional":"BILISKO 55114 BILISKO FC S CAETANO 908304"},{"id":"0d9066dc-2ab1-420f-630f-08d5ad2bf6ba","name":"CARDEAL INDUSTRIA E COMERCIO DE ALIMENTOS LTDA","commercialName":"","cnpj":"59281857000170","city":"SÃO CAETANO DO SUL","stateCode":"SP","buscaAdicional":"CARDEAL MATRIZ 55124 CARDEAL ALIMENTOS 908287"},{"id":"8e143b19-a576-4441-646e-08d5ad2bf6ba","name":"RICHARD SAIGH INDUSTRIA ECOMERCIO S A","commercialName":"","cnpj":"61206397000167","city":"SÃO CAETANO DO SUL","stateCode":"SP","buscaAdicional":"MOINHO SANTA CLARA 56004 MOINHO SANTA CLARA 906897"},{"id":"345162cc-f3f2-4b48-6520-08d5ad2bf6ba","name":"DIAMANTE TEMPERA DE VIDROS LTDA.","commercialName":"","cnpj":"56695711000182","city":"SÃO CAETANO DO SUL","stateCode":"SP","buscaAdicional":"DIAMANTE 56491 DIAMANTE TEMPERA 906883"},{"id":"0b206502-7673-44e0-5c68-08d5ad2bf6ba","name":"VIA VAREJO S/A","commercialName":"","cnpj":"33041260065290","city":"SÃO CAETANO DO SUL","stateCode":"SP","buscaAdicional":"VIAVAREJO 51302 VIA VAREJO - JUNDIAI 899875 VIAVAREJO S BERNARDO 901048 VIAVAREJO MACAE 1339 902033 VIA VAREJO MADUREIRA 906870 MEGASTORE SP 78 908672 VIA VAREJO - CD 1760 908710 VIA VAREJO CD 1760 909082 PREDIO MAGAZINE 1000 909221 VIA VAREJO ADM 0650 909222 CENTR TEC VIA VAREJO 909370 VIA VAREJO CAMACARI 903357 VIA VAREJO LAUR 1466 908825 VIA VAREJO DUQUE CAX 902011 VIAVAREJO RIO OSTRAS 902012 VIAVAREJO ALCANTARA2 902034 VIAVAREJO MARICA 902053 VIAVAREJO SAQ1495 902054 VIAVAREJO STA CRUZ 2 903834"},{"id":"1af07206-b895-4957-5cca-08d5ad2bf6ba","name":"INDUSTRIA AGRO-QUIMICA BRAIDO LTDA","commercialName":"","cnpj":"59274167000193","city":"SÃO CAETANO DO SUL","stateCode":"SP","buscaAdicional":"BRAIDO 51570 BRAIDO 899427"},{"id":"1d31225d-a15f-4b28-530d-08d5ad2bf6ba","name":"INDUSTRIA DE MOVEIS BARTIRA LTDA","commercialName":"","cnpj":"59105825000113","city":"SÃO CAETANO DO SUL","stateCode":"SP","buscaAdicional":"BARTIRA 3453 BARTIRA 71052"},{"id":"f36f6256-5009-48c9-5001-08d5ad2bf6ba","name":"GENERAL MOTORS DO BRASIL LTDA","commercialName":"GENERAL MOTORS MERCOSUL","cnpj":"59275792000150","city":"SÃO CAETANO DO SUL","stateCode":"SP","buscaAdicional":"GM SCS 1400 GM S.CAETANO DO SUL 197 GM SJCAMP 199 GM-MOGI DAS CRUZES 72054 GMB INDAIATUBA 70519 GM-SOROCABA 71880 GM CT 898947 GM JOINVILLE 899649"},{"id":"dc73ee73-caa0-46ee-5028-08d5ad2bf6ba","name":"DELPHI AUTOMOTIVE SYSTEMS DO BRASIL LTDA","commercialName":"","cnpj":"00857758000140","city":"SÃO CAETANO DO SUL","stateCode":"SP","buscaAdicional":"DELPHI 1481 DELPHI PARAISOPOLIS 7902"},{"id":"8f9f7553-bb14-4e9f-57d6-08d5ad2bf6ba","name":"SAINT-GOBAIN DO BRASIL PRODUTOS INDUSTRIAIS E PARA CONSTRUCAO LTDA","commercialName":"EUROVEDER","cnpj":"61064838009190","city":"SÃO CAETANO DO SUL","stateCode":"SP","buscaAdicional":"SGBRAS CAETANO 9750 SAINT GOBAIN SCS 889037"},{"id":"d2e0321b-37df-43d4-5736-08d5ad2bf6ba","name":"CONSORCIO SHOPPING SAO CAETANO","commercialName":"","cnpj":"14351504000160","city":"SÃO CAETANO DO SUL","stateCode":"SP","buscaAdicional":"PARKSHOPPING 8351 PARK SHOP S CAETANO 889134"},{"id":"7ed7ee86-4eae-4696-5391-08d5ad2bf6ba","name":"SAO CARLOS S/A INDUSTRIA DE PAPEL E EMBALAGENS","commercialName":"","cnpj":"59596619000153","city":"SÃO CARLOS","stateCode":"SP","buscaAdicional":"SAOCARLOSSA 3697 S CARLOS PAPEL EMBAL 71283"},{"id":"33657994-160a-4428-53bc-08d5ad2bf6ba","name":"TEXTIL ROSSIGNOLO LTDA","commercialName":"","cnpj":"54635354000131","city":"SÃO CARLOS","stateCode":"SP","buscaAdicional":"ROSSIGNOLO 3812 ROSSIGNOLO TEXTIL 71413"},{"id":"f7ba3f59-e342-443e-50b3-08d5ad2bf6ba","name":"A.W. FABER CASTELL S.A.","commercialName":"FABER CASTELL","cnpj":"59596908000152","city":"SÃO CARLOS","stateCode":"SP","buscaAdicional":"FABER CASTELL 1787 F.CASTELL FIL S.CARL 70159"},{"id":"caa58b5d-b2d3-4b2e-4fcc-08d5ad2bf6ba","name":"TECUMSEH DO BRASIL LTDA","commercialName":"","cnpj":"45361425000164","city":"SÃO CARLOS","stateCode":"SP","buscaAdicional":"TECUMSEH 1280 TECUMSEH FAB1 S.CARL 7802 TECUMSEH FAB2 S.CARL 7803"},{"id":"62b4b5a5-fa71-45ea-52bd-08d5ad2bf6ba","name":"TAPETES SAO CARLOS LTDA","commercialName":"","cnpj":"05414377000100","city":"SÃO CARLOS","stateCode":"SP","buscaAdicional":"TAP S CARLOS 3268 TAPETES SAO CARLOS 70987"},{"id":"1325665d-7f83-4ab5-5263-08d5ad2bf6ba","name":"CONDOMINIO DO SHOPPING CENTER IGUATEMI SAO CARLOS","commercialName":"","cnpj":"03008173000144","city":"SÃO CARLOS","stateCode":"SP","buscaAdicional":"IGUATEMI S CAR 3041 IGUATEMI SAO CARLOS 70843"},{"id":"d3f348a4-85d9-4ad4-515b-08d5ad2bf6ba","name":"TECELAGEM SAO CARLOS SA","commercialName":"TOALHAS SAO CARLOS","cnpj":"59596395000180","city":"SÃO CARLOS","stateCode":"SP","buscaAdicional":"SAO CARLOS 2136 TECELAGEM S.CARLOS 70514"},{"id":"3161c365-1109-404e-5837-08d5ad2bf6ba","name":"ENGEMASA ENGENHARIA E MATERIAIS LTDA","commercialName":"","cnpj":"47034509000119","city":"SÃO CARLOS","stateCode":"SP","buscaAdicional":"ENGEMASA 11050 ENGEMASA 889639"},{"id":"4a250a15-dbf0-4805-587a-08d5ad2bf6ba","name":"TAM LINHAS AEREAS S/A.","commercialName":"","cnpj":"02012862006109","city":"SÃO CARLOS","stateCode":"SP","buscaAdicional":"TAM SAO CARLOS 11954 TAM SAO CARLOS 890221"},{"id":"ca517ca7-5f2b-4b41-62db-08d5ad2bf6ba","name":"SMALTE METALURGICA INDUSTRIA E COMERCIO LTDA.","commercialName":"","cnpj":"03128054000206","city":"SÃO CARLOS","stateCode":"SP","buscaAdicional":"SMALTE 55016 SMALTE SAO CARLOS 905661"},{"id":"b3811991-90bc-4033-623d-08d5ad2bf6ba","name":"GLOBAL PET RECICLAGEM SA","commercialName":"GLOBAL PET RECICLAGEM","cnpj":"07222521000132","city":"SÃO CARLOS","stateCode":"SP","buscaAdicional":"GLOBALPET 54632 GLOBALPET RECICLAGEM 905577"},{"id":"b3908a52-f5a4-4bca-6124-08d5ad2bf6ba","name":"FIACAO ROSSIGNOLO LTDA","commercialName":"","cnpj":"14009152000160","city":"SÃO CARLOS","stateCode":"SP","buscaAdicional":"ROSSIGNOLO COT 54034 ROSSIGNOLO SAO CARLO 903493"},{"id":"c8496d81-b338-443d-61a4-08d5ad2bf6ba","name":"METALMA EMBALAGENS E COMPONENTES LTDA.","commercialName":"","cnpj":"45355211000185","city":"SÃO CARLOS","stateCode":"SP","buscaAdicional":"METALMA SCA 54309 METALMA EMBALAGENS 904241"},{"id":"ccefbebb-d6ad-489a-67b4-08d5ad2bf6ba","name":"LUPERPLAS INDUSTRIA E COMERCIO DE PLASTICOS LTDA","commercialName":"","cnpj":"00029898000120","city":"SÃO CARLOS","stateCode":"SP","buscaAdicional":"LUPERPLAS 58502 LUPERPLAS SAO CARLOS 909982"},{"id":"32c62d18-f74e-4d2c-1cc8-08d5b8870181","name":"MAQLLUX FUNDICAO DE METAIS EIRELI","commercialName":"MAQLLUX","cnpj":"09217323000106","city":"SÃO CARLOS","stateCode":"SP","buscaAdicional":"MAQLLUX 61556 MAQLLUX FUNDICAO 912779"},{"id":"f2783584-46c2-467d-4fc5-08d5ad2bf6ba","name":"ELFUSA GERAL DE ELETROFUSAO LTDA","commercialName":"ELFUSA","cnpj":"59752048000107","city":"SÃO JOÃO DA BOA VISTA","stateCode":"SP","buscaAdicional":"ELFUSA 1271 ELFUSA S.J.BOA VISTA 7477"},{"id":"a2da97da-165e-4e06-5447-08d5ad2bf6ba","name":"USINA ALTA MOGIANA S/A-ACUCAR E ALCOOL","commercialName":"USINA ALTA MOGIANA","cnpj":"53009825000133","city":"SÃO JOAQUIM DA BARRA","stateCode":"SP","buscaAdicional":"UTE MOGIANA 4135 USINA ALTA MOGIANA 907991 ALTA MOGIANA 404 UTE.AI.SP.000060-4.01 MOGIANA BIOENERGIA 8833 UTE.AI.SP.030447-6.01"},{"id":"fda6c461-1dd5-4e7f-5ddb-08d5ad2bf6ba","name":"BEMA-FUNDICAO LTDA","commercialName":"BEMA-FUNDICAO","cnpj":"01485633000108","city":"SÃO JOAQUIM DA BARRA","stateCode":"SP","buscaAdicional":"BEMA 52026 BEMA FUNDICAO 899975"},{"id":"7ce3473d-a2e1-436f-6685-08d5ad2bf6ba","name":"VITTIA FERTILIZANTES E BIOLOGICOS LTDA","commercialName":"BIOSOJA","cnpj":"45365558000109","city":"SÃO JOAQUIM DA BARRA","stateCode":"SP","buscaAdicional":"VITTIA 57628 BIO SOJA 903986 BIO SOJA IND 1 907292 BIO SOJA IND 2 907335"},{"id":"8309b91e-dba7-423d-65db-08d5ad2bf6ba","name":"VENTUROSO, VALENTINI & CIA LTDA","commercialName":"V.V","cnpj":"59850115000118","city":"SÃO JOAQUIM DA BARRA","stateCode":"SP","buscaAdicional":"VENTUROSO VALENTINI 57169 VENTUROSO VALENTINI 907263"},{"id":"191a27d4-8cd6-4ce6-53e1-08d5ad2bf6ba","name":"INDUSTRIA E COMERCIO DE PLASTICOS RIO PARDO EIRELI","commercialName":"RIOPLASTIC","cnpj":"60348695000129","city":"SÃO JOSÉ DO RIO PARDO","stateCode":"SP","buscaAdicional":"RIOPLASTIC 3888 PLASTICOS RIO PARDO 71303 RIOPLASTIC UNID III 910262 RIOPLASTIC UNI II 888142"},{"id":"8ef75f2f-46a0-40b6-535f-08d5ad2bf6ba","name":"PLAZA AVENIDA SHOPPING","commercialName":"","cnpj":"01331288000140","city":"SÃO JOSÉ DO RIO PRETO","stateCode":"SP","buscaAdicional":"PLAZA AVENIDA 3599 PLAZA AVENIDA 71120"},{"id":"8efb968f-912d-433a-5d9b-08d5ad2bf6ba","name":"FUNDACAO FACULDADE REGIONAL DE MEDICINA S J RIO PRETO","commercialName":"HOSPITAL DE BASE","cnpj":"60003761000129","city":"SÃO JOSÉ DO RIO PRETO","stateCode":"SP","buscaAdicional":"HOSPITAL BASE 51933 HOSPITAL BASE 898675 HOSPITAL BASE 3 898676 HOSPITAL BASE 1 898677 HOSPITAL BASE 2 898692"},{"id":"10e45e07-7b4a-474e-5d5a-08d5ad2bf6ba","name":"ULLIAN ESQUADRIAS METALICA LTDA","commercialName":"","cnpj":"45517000000444","city":"SÃO JOSÉ DO RIO PRETO","stateCode":"SP","buscaAdicional":"ULLIAN 51795 ULLIAN ESQUADRIAS 898815"},{"id":"48bfef11-ac09-4f6a-665b-08d5ad2bf6ba","name":"ASSOCIACAO PORTUGUESA DE BENEFICENCIA DE SAO JOSE DO RIO PRETO","commercialName":"HOSPITAL INFANTE DOM HENRIQUE","cnpj":"59972307000105","city":"SÃO JOSÉ DO RIO PRETO","stateCode":"SP","buscaAdicional":"HOSP BENF PORT SJRP 57509 BENEF PORT SJRP 1 907977 BENEF PORT SJRP 3 907996 BENEF PORT SJRP 2 908079"},{"id":"f6e0e381-121e-4bf1-67c3-08d5ad2bf6ba","name":"J. C. DE OLIVEIRA & ALBANO LTDA.","commercialName":"POLIMETAL - INDUSTRIA DE COMUNICACAO VISUAL","cnpj":"58568130000105","city":"SÃO JOSÉ DO RIO PRETO","stateCode":"SP","buscaAdicional":"POLIMETAL JC 58609 POLIMETAL JC SJRP 909873"},{"id":"a7c409c2-e6fa-4bec-66be-08d5ad2bf6ba","name":"CIDADE NORTE PARTICIPACOES E ADMINISTRACAO SPE LTDA","commercialName":"","cnpj":"13473271000106","city":"SÃO JOSÉ DO RIO PRETO","stateCode":"SP","buscaAdicional":"SHOPPING CIDADE NORTE 57772 SHOP CIDADE NORTE 909348"},{"id":"c5b83c16-d308-4735-6895-08d5ad2bf6ba","name":"UNIMED SJRPRETO COOPERATIVA DE TRABALHO MEDICO","commercialName":"UNIMED SJRPRETO","cnpj":"45100138000109","city":"SÃO JOSÉ DO RIO PRETO","stateCode":"SP","buscaAdicional":"UNIMED SJRP 60175 UNIMED SJRP ADM 909986 UNIMED SJRP HOSP 909987"},{"id":"7c0ffdad-992b-426d-612d-08d5ad2bf6ba","name":"REFRIGERANTES ARCO IRIS LTDA","commercialName":"REFRIGERANTES ARCO IRIS","cnpj":"72077514000156","city":"SÃO JOSÉ DO RIO PRETO","stateCode":"SP","buscaAdicional":"ARCO IRIS 54046 ARCO IRIS 905076"},{"id":"be05600f-f61d-4a08-6284-08d5ad2bf6ba","name":"ROBEL INDUSTRIA DE MOVEIS LTDA","commercialName":"ROBEL MOVEIS","cnpj":"46932208000140","city":"SÃO JOSÉ DO RIO PRETO","stateCode":"SP","buscaAdicional":"ROBEL 54791 ROBEL MOVEIS 906421"},{"id":"620c267b-4889-40c6-62bf-08d5ad2bf6ba","name":"RIOQUIMICA S.A.","commercialName":"","cnpj":"55643555000143","city":"SÃO JOSÉ DO RIO PRETO","stateCode":"SP","buscaAdicional":"RIOQUIMICA 54953 RIOQUIMICA S JOSE RP 906677"},{"id":"14fb7a09-0186-4adf-73c4-08d5cf600bef","name":"RNI NEGOCIOS IMOBILIARIOS S.A.","commercialName":"RNI NEGOCIOS IMOBILIARIOS S.A.","cnpj":"67010660000124","city":"SÃO JOSÉ DO RIO PRETO","stateCode":"SP","buscaAdicional":""},{"id":"cbb06cb8-4d2c-4702-8da2-08d5d060706e","name":"CLARITY - IMPORTACAO E EXPORTACAO DE VIDROS LTDA","commercialName":"","cnpj":"04950182000112","city":"SÃO JOSÉ DOS CAMPOS","stateCode":"SP","buscaAdicional":"CLARITY 61770 CLARITY - SAO JOSE 913531"},{"id":"f028fa11-344d-470e-652a-08d5ad2bf6ba","name":"GLASS VALE INDUSTRIA E COMERCIO DE VIDROS LTDA","commercialName":"","cnpj":"11164128000107","city":"SÃO JOSÉ DOS CAMPOS","stateCode":"SP","buscaAdicional":"GLASS VALE 56573 GLASS VALE 907055"},{"id":"8b828ac3-ebe4-4ced-64f1-08d5ad2bf6ba","name":"YORG PARTICIPACOES DO BRASIL LTDA","commercialName":"","cnpj":"05526979000150","city":"SÃO JOSÉ DOS CAMPOS","stateCode":"SP","buscaAdicional":"YORG 56321 YORG PARTICIPACOES 905776"},{"id":"4bfabe82-ce9e-4d29-63cb-08d5ad2bf6ba","name":"PANASONIC DO BRASIL LIMITADA","commercialName":"","cnpj":"04403408000912","city":"SÃO JOSÉ DOS CAMPOS","stateCode":"SP","buscaAdicional":"PANASONIC SP 1 55633 PANASONIC SP 904328"},{"id":"c158a38a-e939-454d-6754-08d5ad2bf6ba","name":"JOHNSON CONTROLS-HITACHI AR CONDICIONADO DO BRASIL LTDA.","commercialName":"","cnpj":"33284522000626","city":"SÃO JOSÉ DOS CAMPOS","stateCode":"SP","buscaAdicional":"HITACHI 58048 HITACHI SJC 909901"},{"id":"2da99098-5ec3-42b0-6622-08d5ad2bf6ba","name":"MAGNAGHI AERONAUTICA DO BRASIL INDUSTRIA E COMERCIO LTDA","commercialName":"","cnpj":"57069650000100","city":"SÃO JOSÉ DOS CAMPOS","stateCode":"SP","buscaAdicional":"FRIULI 57333 IND METAL FRIULI LTD 907032"},{"id":"d7830259-615d-49e1-5d93-08d5ad2bf6ba","name":"COMERCIAL ZARAGOZA IMPORTACAO E EXPORTACAO LIMITADA","commercialName":"","cnpj":"05868574000108","city":"SÃO JOSÉ DOS CAMPOS","stateCode":"SP","buscaAdicional":"SPANI 51924 SPANI PINDAMONHANGAB 899201 SPANI VILLA EMA 899209 SPANI GUARATINGUETA 899210 SPANI S J VISTA VERD 899211 SPANI CD TAUBATE 899212 SPANI LORENA 899213 SPANI CARAGUATATUBA 899562 SPANI CRUZEIRO 900005 SPANI RESENDE 900179 SPANI ATIBAIA 901097 SPANI VOLTA REDONDA 901654 SPANI MOGI 902313 SPANI VILLARREAL TAU 902314 SPANI AQUARIUS 909424"},{"id":"2e78cf26-ebb8-4d70-5cfe-08d5ad2bf6ba","name":"ORION S.A.","commercialName":"","cnpj":"61082863000140","city":"SÃO JOSÉ DOS CAMPOS","stateCode":"SP","buscaAdicional":"ORION SA 51650 ORION SJC 899322"},{"id":"40490df0-2f11-478d-5eaa-08d5ad2bf6ba","name":"PARKER HANNIFIN INDUSTRIA E COMERCIO LTDA","commercialName":"","cnpj":"54823455000136","city":"SÃO JOSÉ DOS CAMPOS","stateCode":"SP","buscaAdicional":"PARKER HANNIFIN 52491 PARKER HANNIFIN 899955 PARKER HANNIF PERUS 903381 PARKER CACHOEIRINHA 903614 PARKER HANNIFIN SJC 905732"},{"id":"04a03136-56c4-4b63-60d1-08d5ad2bf6ba","name":"PROLIND INDUSTRIAL LTDA","commercialName":"","cnpj":"03031662000117","city":"SÃO JOSÉ DOS CAMPOS","stateCode":"SP","buscaAdicional":"PROLIND 53747 PROLIND 904770"},{"id":"8c96395e-c94e-49b5-5f5e-08d5ad2bf6ba","name":"SOPECAERO - SOBRAER PECAS AERONAUTICAS LTDA","commercialName":"","cnpj":"06247612000160","city":"SÃO JOSÉ DOS CAMPOS","stateCode":"SP","buscaAdicional":"SOPECAERO 52915 SOPECAERO SAO JOSE 902593 SOBRAER S J CAMPOS 904613"},{"id":"bc6955a5-1de3-458c-5f0b-08d5ad2bf6ba","name":"COOPERATIVA LATICINIOS DE SAO JOSE DOS CAMPOS","commercialName":"","cnpj":"60179462000140","city":"SÃO JOSÉ DOS CAMPOS","stateCode":"SP","buscaAdicional":"COOPER LATICINIOS 52716 COOP LATICINIO USINA 902533"},{"id":"14ae23aa-6e11-455d-5f52-08d5ad2bf6ba","name":"CONDOMINIO SHOPPING COLINAS","commercialName":"SHOPPING COLINAS","cnpj":"01930701000192","city":"SÃO JOSÉ DOS CAMPOS","stateCode":"SP","buscaAdicional":"SHOP COLINAS 52902 SHOPPING COLINAS 902756"},{"id":"7cede09e-4aa1-40de-5a9d-08d5ad2bf6ba","name":"CENTERVALE ADMINISTRACAO E PARTICIPACOES LTDA.","commercialName":"","cnpj":"45401007000153","city":"SÃO JOSÉ DOS CAMPOS","stateCode":"SP","buscaAdicional":"CENTERVALE 50111 CENTERVALE 908681"},{"id":"9827c655-b4ea-4ac3-4fcd-08d5ad2bf6ba","name":"RADICIFIBRAS INDUSTRIA E COMERCIO LTDA","commercialName":"","cnpj":"02663810000153","city":"SÃO JOSÉ DOS CAMPOS","stateCode":"SP","buscaAdicional":"RADICI 1283 RADICI SJC 7810"},{"id":"d9d5444a-f801-4aaf-4fb0-08d5ad2bf6ba","name":"JOHNSON & JOHNSON INDUSTRIAL LTDA","commercialName":"","cnpj":"59748988000114","city":"SÃO JOSÉ DOS CAMPOS","stateCode":"SP","buscaAdicional":"J E J 1235 JOHNSON SJ 140"},{"id":"25bde2be-c72e-402b-503e-08d5ad2bf6ba","name":"MONSANTO DO BRASIL LTDA","commercialName":"","cnpj":"64858525000226","city":"SÃO JOSÉ DOS CAMPOS","stateCode":"SP","buscaAdicional":"MONSANTO 1536 MONSAN SJC 7961"},{"id":"9d5849dc-5960-4afa-5012-08d5ad2bf6ba","name":"KODAK BRASILEIRA COMERCIO DE PRODUTOS PARA IMAGEM E SERVICOS LTDA","commercialName":"","cnpj":"61186938000132","city":"SÃO JOSÉ DOS CAMPOS","stateCode":"SP","buscaAdicional":"KODAK 1423 KODAK SJC 7227"},{"id":"09eaabd6-cf72-4602-54af-08d5ad2bf6ba","name":"HEATCRAFT DO BRASIL LTDA","commercialName":"","cnpj":"60179488000198","city":"SÃO JOSÉ DOS CAMPOS","stateCode":"SP","buscaAdicional":"HEATCRAFT 4437 HEATCRAFT-S JCAMPOS 71577"},{"id":"c6c32e9f-2008-4df4-5504-08d5ad2bf6ba","name":"MEXICHEM BRASIL INDUSTRIA DE TRANSFORMACAO PLASTICA LTDA","commercialName":"MEXICHEM BRASIL","cnpj":"58514928004404","city":"SÃO JOSÉ DOS CAMPOS","stateCode":"SP","buscaAdicional":"MEXICHEM SJC 4900 MEXICHEM SJC 7599"},{"id":"a5eca9e2-ed55-42a4-57e6-08d5ad2bf6ba","name":"ELEB EQUIPAMENTOS LTDA","commercialName":"EMBRAER DIVISAO EQUIPAMENTOS","cnpj":"55763775000100","city":"SÃO JOSÉ DOS CAMPOS","stateCode":"SP","buscaAdicional":"ELEB 9990 ELEB SJ CAMPOS 890053"},{"id":"6a22a710-c05c-43a3-55ab-08d5ad2bf6ba","name":"EMBRAER S.A.","commercialName":"","cnpj":"07689002000189","city":"SÃO JOSÉ DOS CAMPOS","stateCode":"SP","buscaAdicional":"EMBRAER 5980 EMBRAER-GAV PEIXOTO 71998 EMBRAER F LIMA-SJC 71999 EMBRAER-BOTUCATU 72016 EMBRAER 889130 EMBRAER TAUBATE 889420"},{"id":"3b7ff76b-e5fc-4125-55af-08d5ad2bf6ba","name":"ACE COMERCIALIZADORA LTDA","commercialName":"","cnpj":"14402579000123","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"ACE 6001"},{"id":"2a2b2641-c21b-4b62-55c2-08d5ad2bf6ba","name":"BOVEN COMERCIALIZADORA DE ENERGIA LTDA.","commercialName":"BOVEN ENERGIA","cnpj":"14609649000119","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"BOVEN ENERGIA 6080"},{"id":"4cef9c4d-1822-4977-55c3-08d5ad2bf6ba","name":"NOVA ENERGIA TRADING LTDA","commercialName":"","cnpj":"13394073000157","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"NOVATRADE 6081"},{"id":"bfee826f-27b1-4ff8-55d9-08d5ad2bf6ba","name":"DSM PRODUTOS NUTRICIONAIS BRASIL S.A.","commercialName":"","cnpj":"56992951000149","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"DSM MATRIZ 6248 DSM CAMPINAS SP 900916"},{"id":"94bf50fe-2df2-4516-55dd-08d5ad2bf6ba","name":"BATERIAS CRAL LTDA","commercialName":"BATERIAS CRAL","cnpj":"71683379000120","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"CRAL 6268 CRAL-BAURU 72000"},{"id":"50c6285e-12e9-4612-55eb-08d5ad2bf6ba","name":"BRAZILIAN FINANCIAL CENTER","commercialName":"","cnpj":"11923940000179","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"BFC 6310 BRAZILIAN FIN CENTER 72149"},{"id":"183a0d81-8098-43b2-5620-08d5ad2bf6ba","name":"BIO ENERGIAS RENOVAVEIS LTDA.","commercialName":"","cnpj":"10216578000133","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"BIO RENOV II 6657"},{"id":"71b70774-2990-49fc-5624-08d5ad2bf6ba","name":"IMPAR SERVICOS HOSPITALARES S/A","commercialName":"","cnpj":"60884855000154","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"H9JULHO 6677 HSP NOVE DE JULHO 72280"},{"id":"800f7ae5-c504-4867-5636-08d5ad2bf6ba","name":"SAINT-GOBAIN DO BRASIL PRODUTOS INDUSTRIAIS E PARA CONSTRUCAO LTDA","commercialName":"ISOVER","cnpj":"61064838009009","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"SGISOVER 6763 S GOBAIN S AMARO 72092"},{"id":"39628216-c3aa-47ef-562e-08d5ad2bf6ba","name":"ELI LILLY DO BRASIL LTDA","commercialName":"","cnpj":"43940618000144","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"LILLY 6723 ELI LILLY - JACACIAS 72091"},{"id":"a69d8d26-f3a2-4b3a-56ca-08d5ad2bf6ba","name":"DEAL GESTAO DE ENERGIA LTDA","commercialName":"DEAL GESTAO","cnpj":"14689857000175","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"DEAL GESTAO 7700"},{"id":"6da7f797-a788-4bc8-56c5-08d5ad2bf6ba","name":"NOVACKI PAPEL E EMBALAGENS S.A.","commercialName":"","cnpj":"13987350000135","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"NOVACKI 7660 NOVACKI PORTO UNIAO 897324 NOVACKI UN. VITORIA 897344 NOVACKI - MONTE MOR 72266"},{"id":"17c7707e-0d45-4e84-56c6-08d5ad2bf6ba","name":"PENNACCHI & CIA LTDA","commercialName":"","cnpj":"95410163000159","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"PENNACCHI 7680 PENNACCHI 888975 PENNACCHI E CIA ROL 905749"},{"id":"57962d52-c7d4-4ba9-56a6-08d5ad2bf6ba","name":"INOWATT COMERCIALIZADORA DE ENERGIA S.A.","commercialName":"INOWATT COMERCIALIZADORA DE ENERGIA","cnpj":"14213018000186","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"INNOVAT COM 7440"},{"id":"fe9052bb-e678-4cd1-5697-08d5ad2bf6ba","name":"CONDOMINIO SHOPPING CENTER PLAZA SUL","commercialName":"","cnpj":"00787330000179","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"SHOP PLAZA SUL 7300 SHOP PLAZA SUL PRINC 72225 SHOP PLAZA SUL EXPCO 72226"},{"id":"7463541e-c9bc-4aea-568a-08d5ad2bf6ba","name":"DIA BRASIL SOCIEDADE LIMITADA","commercialName":"DIA BRASIL SOCIEDADE LIMITADA","cnpj":"03476811000151","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"DIA BRASIL 7229 DIA BRASIL AMERICANA 72165 CD RIBEIRAO PRETO 898187 CD GUARULHOS 898468 DIA CD OSASCO 898576 DIA BRASIL LOJA 275 908616 DIA BRASIL LOJA 390 908617 DIA BRASIL LOJA 346 908618 DIA BRASIL LOJA 408 908645 DIA BRASIL LOJA 70 908647 DIA BRASIL LOJA 439 908648 DIA BRASIL 107 IND 908673 DIA BRASIL LOJA 322 908726 DIA BRASIL LOJA 029 908756 DIA BRASIL 453 IBITI 908830 DIA BRASIL LJ 356 908872 DIA BRASIL SOROCABA 909172 DIA BRASIL 103 COSMO 909693 DIA BRASIL LOJA 363 909814 DIA BRASIL 297 SJB 909860 DIA BRASIL LJ 4 909975 DIA BRASIL LJ 368 909977 DIA BRASIL 438 ITU 910014 DIA BRASIL 381 JUND 910034 DIA BRASIL CD MAUA 910230 DIA BRASIL LOJA 449 912418 DIA BRASIL LOJA 441 912452 DIA BRASIL LOJA 393 912651 DIA BRASIL LOJA 343 912873 DIA BRASIL LOJA 385 912935 DIA BRASIL LOJA 365 912953 DIA BRASIL LOJA 348 913613"},{"id":"5966560f-cdf1-408f-568b-08d5ad2bf6ba","name":"MONTEPINO PERFIS ESPECIAIS S.A.","commercialName":"","cnpj":"61184891000178","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"MONTEPINO 7230 MONTEPINO SAO PAULO 72221"},{"id":"63f6b3c1-0ec1-4a33-5652-08d5ad2bf6ba","name":"CONDOMINIO SHOPPING CAMPO LIMPO","commercialName":"","cnpj":"08140551000162","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"SHOP CAMPO LIM 6899 SHOPG CAMPO LIMPO 72151"},{"id":"1b25bc5a-fe43-4ca2-5653-08d5ad2bf6ba","name":"ACOS VIC LTDA","commercialName":"","cnpj":"60608866000101","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"ACOS VIC 6900 ACOS VIC - SP 72162"},{"id":"00fd2dea-bca3-4500-565e-08d5ad2bf6ba","name":"ENERGIA DOS VENTOS X S.A","commercialName":"","cnpj":"15253350000137","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"VENTOS X 6977"},{"id":"5f745d1f-1c4e-42cc-565f-08d5ad2bf6ba","name":"ENERGIA DOS VENTOS III S.A","commercialName":"","cnpj":"15321146000106","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"VENTOS III 6981"},{"id":"c3cf2509-9b75-4def-5660-08d5ad2bf6ba","name":"ENERGIA DOS VENTOS IV S.A","commercialName":"","cnpj":"15320903000127","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"VENTOS IV 6982"},{"id":"5820f516-282d-44b1-5661-08d5ad2bf6ba","name":"ENERGIA DOS VENTOS II S.A","commercialName":"","cnpj":"15319876000172","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"VENTOS II 6997"},{"id":"be2bdb6f-058e-4f1a-5662-08d5ad2bf6ba","name":"ENERGIA DOS VENTOS I S.A","commercialName":"","cnpj":"15321064000161","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"VENTOS I 6998"},{"id":"620a2361-6cdf-4a4a-5673-08d5ad2bf6ba","name":"DESA MORRO DOS VENTOS II S.A.","commercialName":"","cnpj":"15207271000190","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"CPFL MORRO DOS VENTOS II 7102 MORRO DOS VENTOS 2 889780 EOL.CV.RN.030889-7.01"},{"id":"b15ceb9f-a848-44f4-5674-08d5ad2bf6ba","name":"RIO JORDAO PAPEIS S.A.","commercialName":"","cnpj":"77961431000149","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"RIO JORDAO 7103 RIO JORDAO CANELA 7165 BARRA CANDOI 537 UHE.PH.PR.027174-8.01"},{"id":"70f5b446-9a6d-4ca4-5678-08d5ad2bf6ba","name":"SUPERMERCADOS MAMBO LTDA.","commercialName":"SUPERMERCADOS MAMBO","cnpj":"71676316000146","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"SUPER MAMBO 7180 MAMBO AURELIA 888284 MAMBO GIOVANNI 888285 MAMBO LACERDA 888927 MAMBO ALIANCA 888928 MAMBO BROOKLIN 889972 SUPER MAMBO TATUAPE 903833"},{"id":"1dc8b740-175e-454a-567f-08d5ad2bf6ba","name":"BAY HILL SP ADMINISTRACAO LTDA","commercialName":"","cnpj":"13258605000129","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"MOOCA SHOPPING 7205 SHOP MOOCA - ADM 72294"},{"id":"8aa87f2e-d9a5-4c17-5681-08d5ad2bf6ba","name":"CENTRAL EOLICA BAIXA DO FEIJAO II S.A.","commercialName":"","cnpj":"14496545000145","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"EOL BAIXA II 7220 BAIXA DO FEIJAO 2 889846 EOL.CV.RN.030933-8.01"},{"id":"74bba8c2-1bd6-40db-5682-08d5ad2bf6ba","name":"CENTRAL EOLICA BAIXA DO FEIJAO III S.A.","commercialName":"","cnpj":"14496290000110","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"EOL BAIXA III 7221 BAIXA DO FEIJAO 3 889845 EOL.CV.RN.030934-6.01"},{"id":"5e17830e-965e-4193-5683-08d5ad2bf6ba","name":"CENTRAL EOLICA BAIXA DO FEIJAO IV S.A.","commercialName":"","cnpj":"14496317000175","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"EOL BAIXA IV 7222 BAIXA DO FEIJAO IV 889849 EOL.CV.RN.030931-1.01"},{"id":"f2f3e68f-b6fa-4fcf-5684-08d5ad2bf6ba","name":"CENTRAL EOLICA BAIXA DO FEIJAO I S.A.","commercialName":"","cnpj":"14496492000162","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"EOL BAIXA I 7223 BAIXA DO FEIJAO 1 889848 EOL.CV.RN.030932-0.01"},{"id":"e6f69ef8-4ca2-471c-57ef-08d5ad2bf6ba","name":"GIGA BR DISTRIBUIDOR E ATACADISTA LTDA","commercialName":"","cnpj":"10194833000194","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"GIGA BR 10149 GIGA LIMAO 889241 GIGA - ARAGUAIA 905559"},{"id":"65583709-4ee0-40e0-57e8-08d5ad2bf6ba","name":"CITIBANK N A","commercialName":"CITIBANK, N.A. - FILIAL BRASILEIRA","cnpj":"33042953000171","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"CITIBANK 10029 CITIBANK PAULISTA 889232"},{"id":"4bf390bb-f573-4c02-57d4-08d5ad2bf6ba","name":"NESTLE SUDESTE ALIMENTOS E BEBIDAS LTDA.","commercialName":"","cnpj":"11799788000164","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"NESTLE SUDESTE 9729 NESTLE TRES RIOS 889862"},{"id":"ce9c24fb-dc2b-41d3-57ca-08d5ad2bf6ba","name":"SJC BIOENERGIA LTDA","commercialName":"","cnpj":"10249419000135","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"SJC BIOENERGIA 9649 QUIRINOPOLIS CONSUMO 71543 CACHOEIRA DOURADA LE 8658 UTE.AI.GO.030033-0.01 QUIRINOPOLIS-QUIRI 8276 UTE.AI.GO.029268-0.01"},{"id":"30b11467-cf06-4a34-57c7-08d5ad2bf6ba","name":"SEARA ALIMENTOS LTDA","commercialName":"SEARA ALIMENTOS LTDA","cnpj":"02914460011276","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"SEARA MATRIZ 9610 SEARA-SIDROLANDIA-MS 70050 SEARA SUINOS SC 70899 SEARA FREDERICO 71334 SEARA CAMPO MOURAO 71906 SEARA - ITAIOPOLIS 72039 SEARA IPUMIRIM 72353 SEARA DQ CAXIAS RJ 70370 SEARA NUPORANGA 70099 SEARA PASSOS RUR 71244 SEARA 898099 SEARA GUAPIACU 902233 SEARA ANH OSASCO 905861 SEARA ITAPIRANGA 70894 SEARA LAGES 71341 SEARA - SEA IPX SUI 71403 SEARA CAXIAS PERUS 71426 SEARA - SAO JOSE SC 71905 SEARA ARARANGUA 888442 SEARA - XANXERE - SC 901535 SEARA GARIBALDI 901793 SEARA LAPA 902734 SEARA LAPA II 904088 SEARA ITAPIRANGA RAC 907721 SEARA S.MIGUEL DOEST 908024 SEARA BOM RETIRO 909132 SEARA S JOSE PINHAIS 909228 SEARA INCUB LAPA 910294 SEARA WESTPHALEN 910512 SEARA SAO JOSE RACAO 911072 SEARA AL JACAREZINHO 70183 SEARA JCZ FR 888444 SEARA AMPARO SILV 71225 SEARA - UBERABA I 71570 SEARA AMP R-AMPARO 72005 SEARA-JAGUARIUNA 72006 SEARA-PAULINIA SP 72007 SEARA JCZ CI 888443 SEARA AMPARO 888846 SEARA JUNDIAI SP 906942 SEARA - VERISSIMO MG 908127 SEARA INC NUPORANGA 909465 SEARA INC IPIGUA 909466 SEARA SIDROLANDIA 909847 SEARA NUPORANGA SP 909990 SEARA BARAO GERALDO 910221 SEARA-DOURADOS-MS 7517 SEARA - ITAPETININGA 71805 SEARA PENASUL 71141 CAXIAS DESVIO RACAO 71707 SEARA-TRES PASSOS-RS 70070 SEARA ROCA SALES 71418 SEARA-ABATEDOURO-DF 912324 SEARA - RACAO - MG 912326"},{"id":"7037d57d-2a9f-43c2-57cc-08d5ad2bf6ba","name":"CONDOMINIO EDIFICIO NOVA SAO PAULO","commercialName":"","cnpj":"00924493000156","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"CONDOMINIO NOVA SAO PAULO 9689 COND. NOVA SAO PAULO 889079"},{"id":"948fdf14-7bbe-449a-57bf-08d5ad2bf6ba","name":"LEROY MERLIN COMPANHIA BRASILEIRA DE BRICOLAGEM","commercialName":"","cnpj":"01438784000105","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"L MERLIN 9570 L MERLIN ANHANGUERA 889240 L MERLIN SOROCABA 889322 L MERLIN RIB PRETO 889323 L MERLIN MARG TIETE 889614 L MERLIN SAO CAETANO 890133 LEROY MERLIN RAPOSO 890195 LEROY MERLIN D PEDRO 890198 L MERLIN JACAREPAGUA 890833 L MERLIN S J CAMPOS 890854 L MERLIN TAGUATINGA 891723 LEROY MERLIN BANGU 892242 RIO BARRA 896249 RIO NORTE - CASTILHO 896427 LEROY MERLIN POA 890598"},{"id":"1fbe6727-be6d-47a0-57c1-08d5ad2bf6ba","name":"FLORA PRODUTOS DE HIGIENE E LIMPEZA S.A","commercialName":"FLORA PRODUTOS DE HIGIENE E LIMPEZA","cnpj":"08505736000123","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"FLORA 9589 FLORA ITAJAI 898160 FLORA LUZIANIA 904699"},{"id":"81ec0727-74b4-4a6c-57bc-08d5ad2bf6ba","name":"CORTTEX INDUSTRIA TEXTIL LTDA","commercialName":"","cnpj":"48606503000131","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"CORTTEX IND 9510 CORTTEX TRES LAGOAS 889116"},{"id":"cc505ec5-6aa0-41d0-57b2-08d5ad2bf6ba","name":"SIMPLE ENERGY COMERCIALIZADORA DE ENERGIA LTDA","commercialName":"SIMPLE ENERGY COMERCIALIZADORA DE ENERGIA","cnpj":"17112981000161","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"SIMPLE 9369"},{"id":"056a9ed0-63e5-4727-57b0-08d5ad2bf6ba","name":"SPE BIO COOPCANA S.A.","commercialName":"","cnpj":"12235807000192","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"CPFL BIOCOOPCANA 9334 BIO COOPCANA CONSUMO 890599 BIO COOPCANA 890600 UTE.AI.PR.028148-4.01"},{"id":"4148a0fe-e8b8-4dbb-57ad-08d5ad2bf6ba","name":"SPE BIO ALVORADA S.A.","commercialName":"","cnpj":"12419243000148","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"CPFL BIOALVORADA 9330 BIO ALVORADA CONS 891182 BIO ALVORADA 891181 UTE.AI.MG.030975-3.01"},{"id":"f795d56e-80c5-46a5-5775-08d5ad2bf6ba","name":"GATES DO BRASIL INDUSTRIA E COMERCIO LTDA","commercialName":"","cnpj":"61083804000196","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"GATES 8869 GATES JACAREI 888615"},{"id":"d2dfb8fe-c67d-4381-577b-08d5ad2bf6ba","name":"COMATI COMERCIAL DE ALIMENTOS LTDA","commercialName":"","cnpj":"00724959000170","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"COMATI 8950 COMATI UC 6100872 889610 COMATI UC 10569370 889611 COMATI UC 3539369 890853"},{"id":"239bec0d-5bff-4c6d-5783-08d5ad2bf6ba","name":"MOSAIC FERTILIZANTES P&K S.A.","commercialName":"","cnpj":"33931486000130","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"FERTILIZANTES 8973 FERTILIZANTESCATALAO 7080 VALE FERT CAJATI 7269 VALE FERT ARAXA 7701 VALE FERT UBERABA 7970 VALE FERT TAPIRA 70066 FERTILIZANTES TAQUAR 70390"},{"id":"5151addd-43e3-4b72-5771-08d5ad2bf6ba","name":"CAMIL ALIMENTOS S.A.","commercialName":"","cnpj":"64904295000103","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"CAMIL MATRIZ 8849 CAMIL - S GONCALO-RJ 7324 UTE ITAQUI CONSUMO 890298 CAMIL UNIDADE VIII 891542 CAMIL RIO GRANDE 893265 CAMIL UNID 7 893802 CAMIL UNID 41 906353 CAMIL MARANHAO 891162 CAMIL CUIABA MT 892544 CAMIL SAO PAULO 903444 CAMIL NAVEGANTES 908039 CAMIL CAMAQUA 894483 ITAQUI CAMIL 8114 UTE.AI.RS.027948-0.01"},{"id":"469903a0-90ad-4980-576e-08d5ad2bf6ba","name":"TIM CELULAR S.A.","commercialName":"","cnpj":"04206050000180","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"TIM 8817 TIM PISA - S. ANDRE 888553 TIM GG 890338 TIM 1_SC - RJ 894964 TIM LAUDELINO 907674 TIM SANTOS SARAIVA 908011 TIM ANTONIO TREIS 908415 TIM ANDARAI 908509 TIM MARINGA 910839 TIM VILA VELHA 906714 TIM VILA MARIANA 906751 TIM VILA ANASTACIO 906752 TIM ANTONIO RAHE 906820 TIM HELENA TIRELLO 906901 TIM BARAO DE MELGACO 907156 TIM GAMBOA 907582 TIM SOROCABA 907607 TIM BAURU 908059 TIM DR QUIRINO 908060 TIM HERCULES VIEIRA 908074 TIM XANGRILA 908348 TIM - BENFICA 908687 TIM RAJA GABAGLIA 908708 TIM VARGINHA 910032 TIM BRASILIA 910517 TIM_COM ARAUJO 912756 TIM GIOANIA 912862 TIM_WALTER PEREIRA 913434"},{"id":"dfaf69a7-d4b5-4b0a-579c-08d5ad2bf6ba","name":"SOCIEDADE BENEF ISRAELITABRAS HOSPITAL ALBERT EINSTEIN","commercialName":"HOSPITAL ISRAELITA ALBERTEINSTEIN","cnpj":"60765823000130","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"HOSP ALB EINST 9189 HIAE-MORATO 888991 HIAE-ALPHAVILLE 888992 HIAE-JARDINS 888993 HIAE-IBIRAPUERA 888994 HIAE - VL MARIANA 889015 HIAE - PERDIZES 889016 HIAE - SBIBHAE 889017"},{"id":"182b6cd6-0775-460e-57a1-08d5ad2bf6ba","name":"CINERGY COMERCIALIZADORA DE ENERGIA LTDA.","commercialName":"CINERGY ENERGIA","cnpj":"11199567000155","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"CINERGY COM 9251"},{"id":"eb56a35b-905c-4004-579e-08d5ad2bf6ba","name":"ALPEX ALUMINIO S.A","commercialName":"","cnpj":"68100064000106","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"ALPEX 9209 ALPEX ALUMINIO 888857"},{"id":"6d814e2f-2a4e-4225-5790-08d5ad2bf6ba","name":"CPFL BIO ESTER LTDA.","commercialName":"","cnpj":"14205729000109","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"CPFL BIOESTER 9049 ESTER 553 UTE.AI.SP.000912-1.01"},{"id":"88ab36b0-8c71-4d53-5791-08d5ad2bf6ba","name":"INDUSTRIA E COMERCIO GRAFICA CONSELHEIRO LTDA","commercialName":"CONGRAF","cnpj":"43336056000124","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"CONGRAF 9050 CONGRAF 888856"},{"id":"f5575aed-e471-43ae-5795-08d5ad2bf6ba","name":"SPE CPFL SOLAR 1 ENERGIA S.A.","commercialName":"","cnpj":"12620297000177","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"CPFL SOLAR I 9073 TANQUINHO 888923 UFV.RS.SP.030977-0.01"},{"id":"a68ed33e-d016-42d1-5732-08d5ad2bf6ba","name":"OMEGA COMERCIALIZADORA DE ENERGIA LTDA.","commercialName":"","cnpj":"14797440000126","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"OMEGA COM 8330"},{"id":"7e75573a-0550-4011-573b-08d5ad2bf6ba","name":"SDB COMERCIO DE ALIMENTOS LTDA","commercialName":"","cnpj":"09477652000196","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"SDB ALIMENTOS 8372 SDB ALIMENTOS GEISEL 889380 SDB ALIMENTOS GURY 889381 SDB UC 30818633 889579 SDB BRILHANTE 889948 UC 90019482 890113 SDB CAMPO GRANDE 890179 SDB UC 30228506 890631 SDB VARZEA GRANDE 891242 SDB UC 3536963 891726 SDB UC 17878395 892062 SDB UC 19903958 894144 SDB UC12993765 894422 SDB ALIMEN UC 682977 899614 SDB UC 2132508 902494 SDB UC 30259002 909940 SDB UC 90020499 909941 SDB JARAGUA 893685 SDB UC 49405928 902255 SDB ALIM UC 50242935 907849 SDB BALNEARIO CAMBOR 909646 SDB UC 48669611 910045 UC 44041 911625"},{"id":"2d00da0d-8ec4-4f7a-5738-08d5ad2bf6ba","name":"DOU TEX SA INDUSTRIA TEXTIL","commercialName":"","cnpj":"61217261000152","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"DOUTEX 8369 DOUTEX 888327"},{"id":"c3cf6999-8c38-466e-5739-08d5ad2bf6ba","name":"BOLT BCE COMERCIALIZADORA DE ENERGIA LTDA","commercialName":"","cnpj":"12545944000123","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"BOLT BCE 8370"},{"id":"45c506e4-d62f-4033-574b-08d5ad2bf6ba","name":"INDUSTRIA MECANICA SAMOT LTDA","commercialName":"SAMOT","cnpj":"56912124000106","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"SAMOT 8491 SAMOT ALTREF 888858 SAMOT LIEGE 888859 SAMOT DOM JAIME I 891263 SAMOT DOM JAIME II 889847"},{"id":"99766f89-5549-42c7-5741-08d5ad2bf6ba","name":"SUB-CONDOMINIO DO SHOPPING VILLA-LOBOS","commercialName":"","cnpj":"09226749000126","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"SHOP VILA LOBO 8430 SHP VILLA LOBOS 889041"},{"id":"255f9101-1056-4ec4-5752-08d5ad2bf6ba","name":"FDR COMERCIALIZADORA DE ENERGIA LTDA","commercialName":"","cnpj":"14704926000172","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"FDR COM 8553"},{"id":"ea05eeca-40c5-4534-575d-08d5ad2bf6ba","name":"AGORA GERADORA E COMERCIALIZADORA DE ENERGIA ELETRICA LTDA","commercialName":"","cnpj":"15623286000139","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"AGORA ENERGIA 8709"},{"id":"1fc1ef6e-a10f-4e35-5705-08d5ad2bf6ba","name":"EUCATEX INDUSTRIA E COMERCIO LTDA","commercialName":"","cnpj":"14675270000107","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"ECTX 8160 EUCATEX SALTO 88 EUCATEX BOTUCATU 7002 ECTX RECICLAGEM 903225 ECTX QUIMICA 903293 ECTX LAGOA 906595"},{"id":"345983c3-67b0-43f7-56fc-08d5ad2bf6ba","name":"GAVEA COMERCIALIZADORA DE ENERGIA LTDA","commercialName":"","cnpj":"14901621000150","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"GAVEA 8080"},{"id":"644eeeb3-d1a1-49a8-5702-08d5ad2bf6ba","name":"LINKX COMERCIALIZADORA DE ENERGIA LTDA","commercialName":"","cnpj":"15836276000181","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"LINKX 8124"},{"id":"d2b85d8d-fbb9-453b-56e0-08d5ad2bf6ba","name":"COMPANHIA METRO NORTE","commercialName":"","cnpj":"07486185000135","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"SHOP M TUCURUV 7867 SHOP M TUCURUV - SP 888550"},{"id":"42626f9d-959a-47ad-56e4-08d5ad2bf6ba","name":"HIDROTERMICA COMERCIALIZADORA DE ENERGIA S.A","commercialName":"","cnpj":"15274167000118","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"HTCOM 7903"},{"id":"125b8500-f380-4f33-5501-08d5ad2bf6ba","name":"VENTOS POTIGUARES COMERCIALIZADORA DE ENERGIA S/A","commercialName":"","cnpj":"12623165000107","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"00_VPCOM 4800 UNIAO DOS VENTOS 10 892463 EOL.CV.RN.030571-5.01 UNIAO DOS VENTOS 03 892470 EOL.CV.RN.030564-2.01 UNIAO DOS VENTOS 02 892471 EOL.CV.RN.030563-4.01 UNIAO DOS VENTOS 01 892472 EOL.CV.RN.030562-6.01 UNIAO DOS VENTOS 09 892464 EOL.CV.RN.030570-7.01 UNIAO DOS VENTOS 08 892465 EOL.CV.RN.030569-3.01 UNIAO DOS VENTOS 07 892466 EOL.CV.RN.030568-5.01 UNIAO DOS VENTOS 06 892467 EOL.CV.RN.030567-7.01 UNIAO DOS VENTOS 05 892468 EOL.CV.RN.030566-9.01 UNIAO DOS VENTOS 04 892469 EOL.CV.RN.030565-0.01"},{"id":"002ce1d5-0ac3-4250-5517-08d5ad2bf6ba","name":"TREC COMERCIALIZADORA DE ENERGIAS RENOVAVEIS E COMMODITIES LTDA.","commercialName":"TREC TRADE RENEWABLE ENERGY & COMMODITIES","cnpj":"13832352000155","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"TREC ENERGIAS 5028"},{"id":"e03dde0c-f05a-4fa9-54f9-08d5ad2bf6ba","name":"C & C CASA E CONSTRUCAO LTDA.","commercialName":"","cnpj":"63004030000196","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"CEC CONSTRUCAO 4622 C&C ARICANDUVA 71683 CC NOVA TIETE 72018 C&C GUARULHOS 888835 C&C SHOP. DOM PEDRO 889823 CEC S JOSE RIO PRETO 901448 C&C - SERRA - ES 905802 CEC CAMPINAS 906439 CEC SAO GONCALO 910143 CEC MACAE 910156 C&C SAO VICENTE 912334 C&C RIBEIRAO PRETO 900707"},{"id":"5985be53-dd69-4d6b-54eb-08d5ad2bf6ba","name":"WX ENERGY COMERCIALIZADORA DE ENERGIA LTDA","commercialName":"WX ENERGY","cnpj":"13777004000122","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"WXE 4593"},{"id":"201019f2-e2e7-4aa0-54ee-08d5ad2bf6ba","name":"CLARIANT ADMINISTRACAO DE BENS LTDA","commercialName":"","cnpj":"08742331000109","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"CLARIANT ADM 4596 CLARIANT ADM-SP 71727"},{"id":"f3a13e40-1b73-46d3-54f2-08d5ad2bf6ba","name":"BIOENERGY COMERCIALIZADORA DE ENERGIA S/A","commercialName":"","cnpj":"13881714000106","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"BIO COMERC 4608"},{"id":"a33671b8-a3c1-4d03-54d8-08d5ad2bf6ba","name":"AMIL ASSISTENCIA MEDICA INTERNACIONAL S.A.","commercialName":"","cnpj":"29309127000179","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"AMIL 4538 AMIL - POSSOLO 904864 AMIL BARRA 909276"},{"id":"4083828a-e92a-495b-54d9-08d5ad2bf6ba","name":"BRASIL COMERCIALIZADORA DE ENERGIAS LTDA","commercialName":"","cnpj":"13145928000106","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"BRASIL COM 4539 CACHOEIRA PAULISTA 895542 CGH.PH.SP.027476-3.01"},{"id":"e08b573a-983c-4507-54c5-08d5ad2bf6ba","name":"BRASIL TELECOM COMUNICACAO MULTIMIDIA LTDA.","commercialName":"OI","cnpj":"02041460000193","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"BRT MULTIMIDIA 4491 BRT MULTIMD G CALOI 71726"},{"id":"bb743433-68fb-46a7-54cc-08d5ad2bf6ba","name":"SABO INDUSTRIA E COMERCIO DE AUTOPECAS S.A.","commercialName":"RETENTORES SABO","cnpj":"60860681000190","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"SABO 4501 SABO LAPA SP 70301 SABO MOGI MIRIM 70363"},{"id":"12eccd72-c851-4186-5495-08d5ad2bf6ba","name":"CHIMAY EMPREENDIMENTOS E PARTICIPACOES LTDA.","commercialName":"","cnpj":"13326039000145","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"CPFL CHIMAY 4349 BURITIS 454 UHE.PH.SP.000336-0.01 DOURADOS 457 PCH.PH.SP.027065-2.01 ESMERIL 459 PCH.PH.SP.000904-0.01 LENCOIS 462 PCH.PH.SP.001322-6.01 SAO JOAQUIM (CHIMAY) 466 PCH.PH.SP.026844-5.01 GAVIAO PEIXOTO 8245 PCH.PH.SP.001025-1.01 CHIBARRO 8279 PCH.PH.SP.000768-4.01 CAPAO PRETO 8285 PCH.PH.SP.027107-1.01"},{"id":"31d87f5d-8d46-4c67-5496-08d5ad2bf6ba","name":"JAYADITYA EMPREENDIMENTOS E PARTICIPACOES LTDA.","commercialName":"","cnpj":"13271413000152","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"CPFL JAYADITYA 4350 AMERICANA 453 PCH.PH.SP.000089-2.01 S GRANDE (JAYADITYA) 464 PCH.PH.SP.027172-1.01 SANTANA 465 PCH.PH.SP.027415-1.01 TRES SALTOS 468 UHE.PH.SP.002877-0.01"},{"id":"a78bea53-8de7-4b6b-5499-08d5ad2bf6ba","name":"ALMAVIVA DO BRASIL TELEMARKETING E INFORMATICA S/A","commercialName":"","cnpj":"08174089000114","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"ALMAVIVA 4358 ALMAVIVA-B HORIZONTE 71639 ALMAVIVA-JUIZ FORA 71640 ALMAVIVA GUARULHOS 899205 ALMAVIVA ARACAJU 898446 ALMAVIVA TERESINA 2 900786 ALMAVIVA TERESINA 1 900973 ALMAVIVA MACEIO 2 903733 ALMAVIVA MACEIO 3 906350"},{"id":"1e18e50c-4587-44af-5493-08d5ad2bf6ba","name":"MOHINI EMPREENDIMENTOS E PARTICIPACOES LTDA.","commercialName":"","cnpj":"13438769000138","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"CPFL MOHINI 4347 ELOY CHAVES 458 PCH.PH.SP.027108-0.01 JAGUARI (MOHINI) 461 PCH.PH.SP.027109-8.01 PINHAL 463 PCH.PH.SP.027228-0.01 SOCORRO 467 UHE.PH.SP.002762-6.01 MONJOLINHO (MOHINI) 8051 UHE.PH.SP.001486-9.01"},{"id":"3fa6e56c-a341-47e1-549b-08d5ad2bf6ba","name":"MELITTA DO BRASIL INDUSTRIA E COMERCIO LIMITADA","commercialName":"MELITTA","cnpj":"62000278000116","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"MELITTA 4360 MELITTA AVARE 889842 MELITTA-BOM JESUS-RS 71545"},{"id":"04750906-4b2a-4b91-54a0-08d5ad2bf6ba","name":"BOLT SERVICOS E COMERCIALIZACAO DE ENERGIA LTDA","commercialName":"","cnpj":"13700609000115","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"BOLT 4393 BRACO NORTE III 8112 PCH.PH.MT.027176-4.01"},{"id":"091d3e38-3d42-4d13-54a7-08d5ad2bf6ba","name":"TITAN PNEUS DO BRASIL LTDA","commercialName":"","cnpj":"11385941000107","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"TITAN 4412 TITAN - BELENZINHO 7940"},{"id":"55f20274-74e6-4fbc-555e-08d5ad2bf6ba","name":"CTG BRASIL NEGOCIOS DE ENERGIA S.A.","commercialName":"","cnpj":"14295008000137","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"CTGBRNE 5449"},{"id":"7fd4c2de-75dc-4d9f-555b-08d5ad2bf6ba","name":"TE CONNECTIVITY BRASIL INDUSTRIA DE ELETRONICOS LTDA","commercialName":"TE CONNECTIVITY BRASIL","cnpj":"00907845000165","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"TE CONNECTIVITY 5398 TE BRAGANCA PAULISTA 71865"},{"id":"699d012d-ba10-43fc-555c-08d5ad2bf6ba","name":"KEIPER TECNOLOGIA DE ASSENTOS AUTOMOTIVOS LTDA.","commercialName":"","cnpj":"04527572000184","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"KEIPER 5409 KEIPER-MAUA 71882 KEIPER-S J PINHAIS 71839"},{"id":"c992c769-4026-47b2-5553-08d5ad2bf6ba","name":"BEP COMERCIALIZADORA DE ENERGIA ELETRICA LTDA","commercialName":"","cnpj":"14555633000170","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"BEP 5349 DONA MIRIAN 8304 CGH.PH.RS.028941-8.01 CONRADO HEITOR 8311 CGH.PH.MT.000816-8.01 VARGINHA JELU 8341 PCH.PH.SC.029158-7.01 SAO PEDRO I (BEP) 894342 CGH.PH.PR.031470-6.01 SANTA LUCIA I 8143 PCH.PH.MT.027987-0.01 SANTA LUCIA II 8144 PCH.PH.MT.028395-9.01"},{"id":"3289a31d-9b8d-4e02-5545-08d5ad2bf6ba","name":"GAMA COMERCIALIZADORA DE ENERGIA LTDA.","commercialName":"GAMA ENERGIA","cnpj":"11251784000147","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"GAMA 5228"},{"id":"5a56a8ab-6447-4597-5551-08d5ad2bf6ba","name":"INTERNATIONAL INDUSTRIA AUTOMOTIVA DA AMERICA DO SUL LTDA.","commercialName":"MWM MOTORES DIESEL","cnpj":"02162259000750","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"MWM 5313 MWM SAO PAULO 72366"},{"id":"79553d0c-c473-4654-5535-08d5ad2bf6ba","name":"PORTO DAS BARCAS ENERGIA S.A.","commercialName":"","cnpj":"14567884000175","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"PBEE 5166 PORTO DAS BARCAS 892107 EOL.CV.PI.030827-7.01"},{"id":"2b3685e3-157f-47cf-5538-08d5ad2bf6ba","name":"PORTO DO PARNAIBA ENERGIA S.A.","commercialName":"","cnpj":"14567883000120","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"PPEE 5169 DELTA DO PARNAIBA 892119 EOL.CV.PI.030838-2.01"},{"id":"70935729-8640-4d8a-5539-08d5ad2bf6ba","name":"PORTO SALGADO ENERGIA S.A.","commercialName":"","cnpj":"14567882000186","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"PSEE 5170 PORTO SALGADO 892109 EOL.CV.PI.030830-7.01"},{"id":"9c4f145a-c89f-42f7-55a4-08d5ad2bf6ba","name":"FRIGORIFICO BETTER BEEF LTDA","commercialName":"","cnpj":"05826986000177","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"BETTERBEEF 5937 BETTER BEEF-RANCH 71889"},{"id":"260465c0-3205-46d9-55a5-08d5ad2bf6ba","name":"AMICO SAUDE LTDA","commercialName":"","cnpj":"51722957000182","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"AMICO 5939 AMICO HSP METRP LAPA 72254 AMICO HOSP LUZ 72402 AMICO AZEVEDO MACEDO 900233 HOSPITAL TATUAPE 904596 HOSPITAL IPIRANGA 906821 HC CAIEIRAS 907945"},{"id":"d537b632-67b9-405b-55a6-08d5ad2bf6ba","name":"HOSPITAL ALVORADA TAGUATINGA LTDA","commercialName":"HOSPITAL ALVORADA TAGUATINGA","cnpj":"08100676000169","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"HOSP ALVORADA 5940 ALVORADA TAGUATINGA 71980 HOSPITAL BUTANTA HAT 902553 HOSP NEXT SAO BERNAR 903376 HOSPITAL AMERICAS 905851"},{"id":"76a53db2-5804-4f2e-5598-08d5ad2bf6ba","name":"SUSTENTA COMERCIALIZADORA DE ENERGIA S.A.","commercialName":"","cnpj":"14568419000159","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"SUSTENTA 5880"},{"id":"f84f30c2-7975-44fc-5592-08d5ad2bf6ba","name":"COMERCIAL DE ALIMENTOS CARREFOUR LTDA.","commercialName":"","cnpj":"62545579000125","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"CARREFOUR II 5817 CARREFOUR II EPP 902658 CARREFOUR II ECG 903856 CARREFOUR CAMPN ECP 71951 CARREFOUR PAMPL EPL 71952 CARREFOUR II EST 900374 CARREFOUR II ECN 901445"},{"id":"497a8fca-e97e-4272-5579-08d5ad2bf6ba","name":"MUCURI ENERGETICA S/A","commercialName":"","cnpj":"09259407000102","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"MUCURI 5692 MUCURI 890257 PCH.PH.MG.028842-0.01"},{"id":"e85546a0-6217-4a7f-5570-08d5ad2bf6ba","name":"PIRAPORA ENERGIA S.A","commercialName":"","cnpj":"13187847000179","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"PESA 5611 PIRAPORA 894623 PCH.PH.SP.029721-6.01"},{"id":"2817c4e6-53cb-4b62-5566-08d5ad2bf6ba","name":"BSB PRODUTORA DE EQUIPAMENTOS DE PROTECAO INDIVIDUAL S.A.","commercialName":"BSB","cnpj":"10472968000174","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"BSB 5529 BSB-LINS 71853 BSB-APUCARANA 72137 BSB ELDORADO 890754"},{"id":"6e48903a-2a1e-423a-5567-08d5ad2bf6ba","name":"PRIME ENERGY COMERCIALIZADORA DE ENERGIA LTDA","commercialName":"PRIME ENERGY","cnpj":"12809025000110","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"PRIME ENERGY 5530"},{"id":"2f8e2860-8ab5-46d8-556b-08d5ad2bf6ba","name":"MOCOCA S/A PRODUTOS ALIMENTICIOS","commercialName":"","cnpj":"52502507000147","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"MOCOCA 5569 LATICINIOS MOCOCA 71840 MOCOCA CERQ. CESAR 898817"},{"id":"0891a0e1-e648-4efb-53e2-08d5ad2bf6ba","name":"COWAT COMERCIALIZADORA DE ENERGIA LTDA","commercialName":"","cnpj":"10874441000176","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"COWAT 3889 SODRE 890499 CGH.PH.SP.031099-9.01"},{"id":"7da055b3-d9b7-47b4-53fa-08d5ad2bf6ba","name":"GALHEIROS GERACAO DE ENERGIA ELETRICA S.A","commercialName":"","cnpj":"08851565000194","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"GLH 3940 GALHEIROS I 888528 PCH.PH.GO.030312-7.01"},{"id":"a1a3874b-61a7-4529-53fb-08d5ad2bf6ba","name":"ASA BRANCA IV ENERGIAS RENOVAVEIS S.A.","commercialName":"","cnpj":"11681456000180","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"ASAIV 3941 ASA BRANCA 4 2LFA 890655 EOL.CV.RN.030498-0.01"},{"id":"e5ff128b-55ca-4370-53fc-08d5ad2bf6ba","name":"ASA BRANCA V ENERGIAS RENOVAVEIS S.A.","commercialName":"","cnpj":"11681458000170","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"ASAV 3942 ASA BRANCA 5 2LFA 890654 EOL.CV.RN.030507-3.01"},{"id":"ce535998-198d-4a8f-53fd-08d5ad2bf6ba","name":"ASA BRANCA VI ENERGIAS RENOVAVEIS S.A.","commercialName":"","cnpj":"11694617000170","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"ASAVI 3943 ASA BRANCA 6 2LFA 890653 EOL.CV.RN.030520-0.01"},{"id":"40b78553-1d3a-4386-53fe-08d5ad2bf6ba","name":"ASA BRANCA VII ENERGIAS RENOVAVEIS S.A.","commercialName":"","cnpj":"11694618000115","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"ASAVII 3944 ASA BRANCA 7 2LFA 890652 EOL.CV.RN.030513-8.01"},{"id":"b1bf6224-ecb2-4952-53ff-08d5ad2bf6ba","name":"ASA BRANCA VIII ENERGIAS RENOVAVEIS S.A.","commercialName":"","cnpj":"11694621000139","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"ASAVIII 3945 ASA BRANCA 8 2LFA 890651 EOL.CV.RN.030508-1.01"},{"id":"82bd816a-b36b-4ab3-53eb-08d5ad2bf6ba","name":"CPFL BIO PEDRA LTDA.","commercialName":"BIO PEDRA","cnpj":"11631680000168","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"CPFL BIOPEDRA 3911 DA PEDRA CONSUMO 72178 DA PEDRA 8964 UTE.AI.SP.030453-0.01"},{"id":"6e10bb24-a081-491e-53b9-08d5ad2bf6ba","name":"VOTORANTIM CIMENTOS S.A.","commercialName":"VOTORAN","cnpj":"01637895000132","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"VCSA 3801 VCSA CAMPO GRANDE 909938 VCSA EI CT CURITIBA 910574 VCB ARACARIGUAMA ETC 7392 VCSA BARUERI 72403 VCB VILA ISABEL 71153 VCB LAVRINHA ITAPEVA 71074 VCSA CAJAMAR 71459 VCB RIO NEGRO 7558 VCB TOCANTINS 71405 VCSA - PARANA 889191 VCB ITAJAI 70085 VCB CUBATAO 7869 VCB CMAG NOBRES 7200 VCB ITAU DE MINAS 7257 VCSA IMBITUBA 71499 VCSA-VIDAL RAMOS 71536 VCB CORUMBA 7203 VCSA CUIABA 888489 VCB S.PIRAPORA 7361 VCB SANTA HELENA 7297 VCSA CCRG 71762 VCSA PINHEIRO MACHAD 891471 VCSA CAJAMAR II 898590 VCSA ESTEIO 900793 VCSA EDEALINA 905808 VCSA SEROPEDICA 904904 VCSA PONTE ALTA 910603"},{"id":"bc81ed39-f710-45be-53ae-08d5ad2bf6ba","name":"COMPASS ENERGIA LTDA","commercialName":"","cnpj":"11830358000168","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"CPAS ENERGIA 3765"},{"id":"2eae565f-d814-4f68-53b2-08d5ad2bf6ba","name":"EUCATEX COMERCIALIZADORA DE ENERGIA ELETRICA LTDA","commercialName":"EUCATEX COMERCIALIZADORA DE ENERGIA ELETRICA","cnpj":"11782147000105","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"EUCA COM 3778"},{"id":"0c205aa6-c6ec-4ac6-53c0-08d5ad2bf6ba","name":"CPFL BIO FORMOSA LTDA","commercialName":"","cnpj":"11352989000119","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"CPFL BIOFORMOSA 3824 UTE BIOFORMOSA 71859 BAIA FORMOSA 8764 UTE.AI.RN.028605-2.01"},{"id":"42168e05-ac16-4c13-53c2-08d5ad2bf6ba","name":"FERREIRA GOMES ENERGIA S.A.","commercialName":"","cnpj":"12489315000123","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"FERREIRA GOMES 3826 FERREIRA GOMES 893062 UHE.PH.AP.030385-2.01"},{"id":"585dadf5-e538-4d9b-53cc-08d5ad2bf6ba","name":"ROMAFILM IND E COM DE PLASTICOS LTDA","commercialName":"","cnpj":"01133282000168","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"ROMAFILM 3866 ROMAFILM 71335"},{"id":"7c47f075-64e3-431c-53ce-08d5ad2bf6ba","name":"SPE JUREMAS ENERGIA S.A.","commercialName":"","cnpj":"09665446000100","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"CPFL JUREMAS 3869 JUREMAS 2LFA 890670 EOL.CV.RN.030660-6.01"},{"id":"b674af30-ea3a-4b84-53cf-08d5ad2bf6ba","name":"SPE COSTA BRANCA ENERGIA S.A.","commercialName":"","cnpj":"09665392000182","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"CPFL COSTA BRANCA 3870 COSTA BRANCA 2LFA 890624 EOL.CV.RN.030672-0.01"},{"id":"f6424ada-c0c7-4959-53d0-08d5ad2bf6ba","name":"SPE SALTO GOES ENERGIA S.A.","commercialName":"","cnpj":"08933585000104","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"CPFL SALTO GOES 3871 SALTO GOES 888924 PCH.PH.SC.030338-0.01"},{"id":"d6441da2-9369-48a5-53d1-08d5ad2bf6ba","name":"SPE MACACOS ENERGIA S.A.","commercialName":"SERRA VERDE ENERGIA","cnpj":"07091059000181","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"CPFL MACACOS 3872 MACACOS 2LFA 890669 EOL.CV.RN.030661-4.01"},{"id":"d053c67e-4373-464e-53d2-08d5ad2bf6ba","name":"SPE PEDRA PRETA ENERGIA S.A.","commercialName":"","cnpj":"09665342000103","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"CPFL PEDRA PRETA 3873 PEDRA PRETA 2LFA 890668 EOL.CV.RN.030671-1.01"},{"id":"36782146-a976-422c-5395-08d5ad2bf6ba","name":"TROMBINI EMBALAGENS S/A","commercialName":"TESA","cnpj":"11252642000102","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"TROMBEMB 3705 TROMBINI FRAIBURGO 7876 TROMBINI FARROUPILHA 70262 TROMBINI SACOS 888839 TROMBINI PAPEL 889193 TROMBINI PAPELAO 890010"},{"id":"51e1e1de-3c1f-4a44-539c-08d5ad2bf6ba","name":"ARTHUR LUNDGREN TECIDOS S A CASAS PERNAMBUCANAS","commercialName":"CASAS PERNAMBUCANAS","cnpj":"61099834000190","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"PERNAMBUCANAS 3729 PERNAMB SH INTRLAGOS 71323 PERNAMB CAMPINAS 71324 PER CONV CAMPINAS 71325 PERNAMBUCANAS BAURU 71326 PER RIBEIRAO PRETO 71327 PER SHOPPING RP 71328 PERNAMB OSASCO 71385 PERNAMBUCANAS-ANEXO 71610 PERNAMB-EC MATRIZ 71611 PER SANTO AMARO 71623 PER CAMPO GRANDE 902153 PERNAMB NOVO CD 903574 PER SHOPPING TAUBATE 903719 PER SHOPPING SERRAMA 903735 PER SHOPPING CAMPO G 905214 PER SAO VICENTE 906918 PER PENHA 906935 PER TUCURUVI 906936 PER SHOPPING SOROCAB 906937 PER SHOPPING PRAIA G 906956 PER UNIVERSIDADE 907046 PER SAO JOSE DO RIO 907093 PER SOROCABA 907102 PER SHOPPING PLAZA 907473 PER SHOPPING METRO I 907628 PER SHOPPING LESTE 907654 PER MARINGA 907420 PER SHOPPING MARINGA 907644 PER FOZ IGUACU 907671 PER LONDRINA 907672"},{"id":"bb41e251-2473-404b-5372-08d5ad2bf6ba","name":"LEROS ENERGIA E PARTICIPACOES S.A.","commercialName":"","cnpj":"11017349000152","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"LEROS ENERGIA 3638"},{"id":"00ff3218-fe93-4806-5374-08d5ad2bf6ba","name":"ASSOCIACAO LARGO XIII","commercialName":"","cnpj":"11927223000115","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"LARGO XIII 3640 LARGO XIII 71245"},{"id":"c00237c5-f46c-4175-5369-08d5ad2bf6ba","name":"DANONE LTDA","commercialName":"","cnpj":"23643315000152","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"DANONE 3619 DANONE POCOS CALDAS 71179 DANONE JACUTINGA 891724 DANONE ITAPECERICA 905507 DANONE-MARACANAU 71753 DANONE CALDAS MG 898824"},{"id":"e4ee3d10-77df-4bdd-536c-08d5ad2bf6ba","name":"CAPITALE ENERGIA COMERCIALIZADORA LTDA.","commercialName":"","cnpj":"11599292000147","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"CAPITALE 3630"},{"id":"e04109da-bd90-4c91-5383-08d5ad2bf6ba","name":"ENGELETRICA INDUSTRIA , COMERCIO E SERVICOS ELETRICOS LTDA.","commercialName":"","cnpj":"58687609000160","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"ENGELETRICA 3675"},{"id":"44c5bf2f-8478-4ade-5448-08d5ad2bf6ba","name":"MAXIMA ENERGIA COMERCIALIZADORA LTDA.","commercialName":"","cnpj":"12630054000110","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"MAXIMA ENERGIA 4136"},{"id":"34ab9225-3051-4039-5432-08d5ad2bf6ba","name":"MAIS ENERGIA BRASIL - COMERCIALIZADORA DE ENERGIA E DISTRIBUIDORA DE SOLUCOES LTDA.","commercialName":"","cnpj":"12402158000177","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"FORTE ENERGIA 4075"},{"id":"49f8ff09-086c-4bdf-5428-08d5ad2bf6ba","name":"ATLANTICA V PARQUE EOLICO S/A","commercialName":"","cnpj":"12864421000140","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"CPFL ATLANTICA V 4035 ATLANTICA 5 2LFA 890650 EOL.CV.RS.030480-8.01"},{"id":"0241a656-193d-42eb-5429-08d5ad2bf6ba","name":"ATLANTICA II PARQUE EOLICO S/A","commercialName":"","cnpj":"12963869000110","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"CPFL ATLANTICA II 4037 ATLANTICA 2 890648 EOL.CV.RS.030462-0.01"},{"id":"fdaa31a1-32ed-427e-542a-08d5ad2bf6ba","name":"ATLANTICA IV PARQUE EOLICO S/A","commercialName":"","cnpj":"12981225000155","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"CPFL ATLANTICA IV 4038 ATLANTICA 4 890649 EOL.CV.RS.030461-1.01"},{"id":"3112e4ae-b1e7-4675-5419-08d5ad2bf6ba","name":"ATLANTICA I PARQUE EOLICO S A","commercialName":"","cnpj":"12773558000199","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"CPFL ATLANTICA I 4008 ATLANTICA 1 2LFA 890647 EOL.CV.RS.030457-3.01"},{"id":"d59ac3cd-821f-4f27-5412-08d5ad2bf6ba","name":"NEW ENERGY OPTIONS GERACAO DE ENERGIA S.A","commercialName":"","cnpj":"04245220000136","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"NEW ENERGY 3991 ALEGRIA II 20075 EOL.CV.RN.028443-2.01"},{"id":"6bb3b85e-8605-44ae-5414-08d5ad2bf6ba","name":"CPFL ENERGIAS RENOVAVEIS S.A.","commercialName":"CPFL RENOVAVEIS","cnpj":"08439659000150","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"CPFL RENOVAVEIS 3993 PARACURU (CPFL) 20010 EOL.CV.CE.028706-7.01"},{"id":"05bef6af-ae98-4e6a-540d-08d5ad2bf6ba","name":"DESA EURUS I S/A","commercialName":"","cnpj":"12652614000137","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"CPFL EURUS I 3983 EURUS 1 3LER 890749 EOL.CV.RN.030503-0.01"},{"id":"ffd2db31-1202-49da-540e-08d5ad2bf6ba","name":"DESA EURUS III S/A","commercialName":"","cnpj":"12652634000108","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"CPFL EURUS III 3984 EURUS 3 3LER 890760 EOL.CV.RN.030504-9.01"},{"id":"57d3d8af-6726-43e9-53ef-08d5ad2bf6ba","name":"ENEX COMERCIALIZADORA DE ENERGIA LTDA.","commercialName":"ENEX COMERCIALIZADORA DE ENERGIA LTDA.","cnpj":"12458962000178","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"ENEX 3926"},{"id":"8324684b-4247-4c6e-53f0-08d5ad2bf6ba","name":"CAMPO DOS VENTOS II ENERGIAS RENOVAVEIS S.A.","commercialName":"","cnpj":"10797889000133","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"CPFL CAMPOS DOS VENTOS II 3927 C DOS VENTOS 2 3LER 890752 EOL.CV.RN.030500-6.01"},{"id":"f853108f-1236-4502-53f2-08d5ad2bf6ba","name":"COMERC POWER TRADING LTDA","commercialName":"","cnpj":"10732440000197","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"COMERC POWER 3929 FAZENDA COLORADO 902769 BODYTECH - RECIFE 910251 BODYTECH - CAMPINAS 910527 BODYTECH - MARISTA 910558 BODYTECH RIBEIRAO PT 910697 BODYTECH BELVEDERE 910882 BODYTECH SAVASSI 910883 BODYTECH - ICARAI 911214 BODYTECH - AV DAS AM 913391 BODYTECH - ERICO VER 913411 BODYTECH PRAIA COSTA 913489"},{"id":"a75e6bab-c31f-4b52-53f3-08d5ad2bf6ba","name":"IGUACU MINAS ENERGETICA LTDA.","commercialName":"","cnpj":"11493603000199","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"IGUACU MINAS 3931 LAVRAS 8842 PCH.PH.MG.028105-0.01 ILHEUS 8843 PCH.PH.MG.001122-3.01 AREAL (IGUACU) 8886 PCH.PH.MG.000141-4.01 INHAPIM 894742 PCH.PH.MG.028987-6.01"},{"id":"5c4c4fac-c998-4570-540b-08d5ad2bf6ba","name":"COMPANHIA ENERGETICA NOVO HORIZONTE","commercialName":"","cnpj":"06340397000147","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"CPFL NOVO HORIZONTE 3968 NOVO HORIZONTE 8841 PCH.PH.PR.028782-2.01"},{"id":"d03f75bf-8328-468d-5483-08d5ad2bf6ba","name":"INGREDION BRASIL INGREDIENTES INDUSTRIAIS LTDA","commercialName":"","cnpj":"01730520000112","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"INGREDION MATRIZ 4309 INGREDION ALCANTAR 899602 NATIONAL-TROMBUDO 70828 CORN CABO 888997"},{"id":"472abf33-1e27-4169-5484-08d5ad2bf6ba","name":"MAZZAFERRO MONOFILAMENTOS TECNICOS LTDA","commercialName":"","cnpj":"53865531000294","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"MAZZAFERRO 4311 MAZZAFERRO-S PAULO 71563"},{"id":"45a21607-68e0-41c8-5456-08d5ad2bf6ba","name":"CONDOMINIO PANAMERICA PARK","commercialName":"CONDOMINIO PANAMERICA PARK","cnpj":"04406405000185","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"CPP 4171 COND PANAMERICA PARK 71497"},{"id":"99bfba14-7b89-4293-5458-08d5ad2bf6ba","name":"CPFL BIO IPE LTDA.","commercialName":"BIO IPE","cnpj":"11631679000133","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"CPFL BIOIPE 4176 BIO IPE (CPFL) 8995 UTE.AI.SP.030268-6.01"},{"id":"d1f6d2b7-d9b4-4f5a-544a-08d5ad2bf6ba","name":"CPFL BIO BURITI LTDA","commercialName":"BIO BURITI","cnpj":"11631681000102","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"CPFL BIOBURITI 4140 BURITI CPFL 8933 UTE.AI.SP.030420-4.01"},{"id":"a41d2a71-2c7e-4812-544e-08d5ad2bf6ba","name":"ECE PARTICIPACOES S.A","commercialName":"","cnpj":"09333996000121","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"ECE 4158 STO ANTONIO DO JARI 891001 UHE.PH.AP.026792-9.01 STO ANT D JARI - RRH 907551 UHE.PH.AP.026792-9.01"},{"id":"ca650588-30c8-4f0a-500d-08d5ad2bf6ba","name":"SANTISTA WORK SOLUTION S.A.","commercialName":"","cnpj":"61520607000197","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"SANTISTA WORK 1413 TAVEX AMERICANA 7247 TAVEX TATUI 7357 TAVEX ARACAJU 72106"},{"id":"8a85fe0b-dc40-409f-4fef-08d5ad2bf6ba","name":"SANTHER FABRICA DE PAPEL SANTA THEREZINHA S/A","commercialName":"","cnpj":"61101895000145","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"SANTHER MATRIZ 1364 SANTHER SAO PAULO 7380 SANTHER-BRAGANCA 7490 SANTHER GUAIBA 7363 SANTHER G VALADARES 7909"},{"id":"3d49bac5-78fe-4bd8-5006-08d5ad2bf6ba","name":"RHODIA POLIAMIDA E ESPECIALIDADES SA","commercialName":"","cnpj":"15179682000119","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"RHODIA POLIAM 1406 RHODIA-S.ANDRE 196 RHODIA PAULINIA SP 7044 RHODIA-S.B. CAMPO-SP 7344 RHODIA PAULINIA 8484 UTE.GN.SP.027956-0.01"},{"id":"f10677f9-a6ad-4997-5023-08d5ad2bf6ba","name":"BASF SA","commercialName":"","cnpj":"48539407000118","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"BASF SBC 1473 BASF-S.BERNARDO 7861 BASF GUARA 7863 BASF JACAREI 888511"},{"id":"82065f81-6e62-4b26-501e-08d5ad2bf6ba","name":"SANOFI-AVENTIS FARMACEUTICA LTDA","commercialName":"","cnpj":"02685377000157","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"SANOFI-AVENTIS 1455 AVENTIS PH 7327"},{"id":"9049488d-8835-489a-501b-08d5ad2bf6ba","name":"ARMCO DO BRASIL S/A","commercialName":"G&D","cnpj":"71586952000187","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"ARMCO 1446 ARMCO V PRUDENTE 7280 ARMCO JACAREI 900413"},{"id":"c1dacb76-a69c-4d9c-5018-08d5ad2bf6ba","name":"COMPANHIA BRASILEIRA DE DISTRIBUICAO","commercialName":"","cnpj":"47508411000156","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"CBD 1442 CBD GA 4711 7172 EXTRA TIETE 7186 CBD ANHANGUERA 1307 7187 CBD L1315 S. CAETANO 7965 CBD COTIA 7966 CBD PENHA 7967 CBD L1314 ANCHIETA 7968 CBD-LJ 304-BRASILIA 7977 CBD - LOJA 1516 70055 CBD - LOJA 5268 70056 CBD - LOJA 1340 70057 CBD - LOJA 5267 70058 CBD - LOJA 1500 70059 CBD - LOJA 1495 70060 CBD EXTRA 1301 MS 70313 CBD EXTRA 1336 RJ 70346 CBD EXT 1331 SGON 70347 CBD EXTRA S. AMARO 70354 CBD EXTRA 0978 70369 CBD EXTRA 1378 UBERL 70413 CBD SEDE 0907 BRIG 70440 CBD CONTAGEM 70447 CBD1374 EXTRA JUNDIA 70596 CBD EXTRA ARARAQUARA 70597 PAO ACUCAR INDAIATUB 70601 CBD EXTRA ITATIBA 70602 CBD EXTRA S CARLOS 70603 CBD SJCOLI 70604 CBD EXTRA NOVA SOROC 70630 CBD - LOJA 1502 70722 CBD - LOJA 5270 70723 CBD - LOJA 1417 PA B 70724 CBD - LOJA 5264 70726 CBD - LOJA 1514 70727 CBD1325 EXTRA ITU 70730 CBD1348 EXTRA SANTOS 70731 CBD - LOJA 1803 70746 CBD - LOJA 1496 70752 CBD EXTRA AMOREIRAS 70803 CBD EXTRA ABOLICAO 70823 EXTRA FIUSA 70971 CBD EXTRA SOROC-1346 71071 EXTRA PRAIA GRANDE 71076 CBD - LOJA 1635 71105 CBD - LOJA 1509 71150 EXTRA BRIGADEIRO 71161 EXTRA ITAIM 71162 PA CASA VERDE 2318 71338 EXTRA ARICANDUV 1309 71359 PA P ANTONIO 1770 71380 PA VILA ROMANA 2068 71392 PA V CLEMENTINO 2053 71393 CBD 1640 INGA 71399 EXTRA CUIABA-2136 71535 CBD PA C ALMEIDA 150 71877 PA ANA ROSA 1017 72322 CBD - LOJA 5263 - 72323 CBD - LOJA 1856 72324 CBD - LOJA 1735 - OL 72325 CBD - LOJA 1511 72326 PA AUG TOLLE 2073 72333 PA IBIRAPUERA 1205 72340 CBD PA CERRO CORA 72395 CBD PA MOEMA 1221 72396 CBD EXTRA TAUBATE 72401 CBD - LOJA 3312 72409 CBD EX PETROPOLIS 72410 CBD - LOJA 1513 72412 CBD EX JQ MURTINHO 888434 CBD - LOJA 1515 888446 EX DOURADOS 2147 888576 CBD PA TAMBORE 888616 PA PIRACICABA - 2329 888617 PA S VICENTE ITARARE 888673 PA CAMPINAS CAMBUI 888674 CBD PA 2383 888805 CBD EX 1342 888830 CBD - LOJA 5063 888873 CBD - LOJA 1797 888894 CBD PA 0186 888947 CBD 1384 888948 CBD PA 1885 889115 CBD EX AERO 1337 889247 CBD 12925 889248 CBD - LOJA 1736 889394 CBD PA 2384 889400 CBD ES 1757 889401 EX JUNDIAI 1386 889424 CBD ES P GRANDE 1773 889450 PA CANTAREIRA 1291 889451 PA JD PAULISTANO 009 889607 ES BOTAFOGO 1629 890620 CBD - LOJA 1505 892409 GPA CD 1 - 1965 898467 CBD 913 898778 CBD EX RAPOSO TAVARE 898886 CBD EX JAGUARE - 135 898887 CBD EX FREGUESIA 899716 CD 2 - 903 899745 GPA CD 4 - 930 899790 CBD TERESOPOLIS 900673 CBD EX RICARDO JAFET 901152 CBD EX MORUMBI 901181 CBD PA OURINHOS 2484 901633 CBD RIB PRETO 901657 CBD PA DAMHA - 2424 901696 CBD - LOJA 1416 903439 CBD S J RIO PRETO 903466 CBD EX PIRACICABA 903467 CBD SEDE TI - 7746 903618 CBD CARANDA BOSQUE 904500 CBD CAMPINAS 904513 CBD JOAO DIAS 904548 CBD EX SANTA ROSA 904574 CDB GUARUJA 905092 CBD NOVA ALIANCA 003 905277 CBD EX BARRETOS 2485 905278 CBD PA RIB PRETO 905294 CBD GUARUJA 2354 905653 CBD GUARUJA 1853 905656 CBD EX PAULINIA 905685 CBD PA CAMPINAS ITAP 905687 CBD PA BOTUCATU 905689 CBD PA BAURU JD EST 905700 CBD PA BARAO GERALDO 905706 CBD PA VALINHOS PORT 905707 CBD ES PG AVIACAO 905781 CBD PA SANTOS EPIT 905782 CBD EXTRA GUAIANAZES 906273 CBD MOGI BRAS 1343 906343 CBDEX GUARULHOS 1612 906359 CBD PA TAUBATE 2333 906728 CBD PA AVARE 906733 CBD MACAE 1657 907650 CBD EX TABOAO DA SER 907655 CBD EX ITAIPAVA 5274 908096 CBD PA ALPHAVILLE I 908537 CBD ALPHAVILLE 1222 908538 CBD W LUIZ 2409 908568 CBD S CAETANO 2469 908583 CBD BARRA DA TIJUCA 908652 METRO ITAQUERA 1377 909058 CBD PARQUE REAL 1299 909059 CBD - CD 1979 909647 CBD EX TANCREDO NEVE 909854 CBD ES PRIMITIVA 232 909855 CBD PA AQUARIUS 0361 909865 EX CEILANDIA 1372 910024 CBD PORTAL 1216 910231 CBD MARIA AMALIA 238 910232 CD03 GUARULHOS 0957 910256 CBD ES RIO DAS OSTRA 910345 EX TAGUATINGA 1603 910355 CBD PA GOIANIA 1018 910358 CBD EX CAMPINAS CENT 910411 CBD PA TATUAPE 128 910497 CBD CID DUTRA 1321 910519 CBD ARARAQUARA 1182 910528 CBD RIC JAFET 1717 910532 CBD EX GOIANIA-1354 910631 CBD SAO MATHEUS 1718 910702 EX BASILIA PARK 1366 911259 EX BENFICA -1371 911277 CBD PANAM 1207 911532 CBD ES ITATIBA 1739 911592 CBD BORBA GATO 911758 SEZEFREDO FAGUN 911776 EX BRASILIA NORTE 911785 1355 -EXTRA BRAS SUL 911899 CBD MACAE CENTR 1829 911907 CBD 1005 ES PERUIBE 911916 CBD 2071 RIVIERA S.L 911932 CBD EPITACIO JPESSOA 70404 CBD EXTRA 1375 CE 70418 CBD EXTRA 1209 FORTA 70433 CBD EXTRA P NEGRA 70518 CBD EX 1300 889124 CBD PA 1298 889399 PA COCO 1253 889452 CBD ES CAXANGA 1379 889453 ES ESPINHEIRO 1383 889454 ES RODOVIARIA - 1404 889608 CBD PA ROSA E SILVA 890299 PANAUTICO 891283 CBD EX FORTALEZA1339 903617 CBD EX MONTESE -1344 903635 CBD MISTER HULL 2059 907634 EXTRA BOA VIAGEM 909270 CBD PIEDADE 1003 909999 CBD MIRAMAR 1283 910030 EX CAMPINA GDE 1728 910070 EX MACEIO FAROL 1392 910213 EX MACEIO 1363 910214 CBD 1410 PAPICU 911976 CBD EX CURITIBA KENN 905494 SENDAS SAO GONCALO 899571 CBD CABO FRIO RJ 899572 CBD ITANHAEM 2078 899922 CBD ITAIPU 1656 900041 CBD CAMPOS TURFE 900650 SENDAS S GONCALO1362 901839 CBD ALTO DA SERRA 902015 ASSAI PALMAS 71488 EXTRA PALMAS 2076 71489 CBD CD 8 - 1974 901180 CBD EX CURITIBA 901026 CBD REP ARGENTINA 901333 CBD TEODORO-2349 912212 JABAQUARA-2336 912311 CBD SAO GERALDO 2375 912336 EX TUCURUVI 2075 72332 CBD GOIANIA PCA TAMA 913396 CBD EX PRAIA GRANDE 913583 CBD MUCURIPE 1257 913513"},{"id":"d6c60a40-b897-4d70-5040-08d5ad2bf6ba","name":"BIRLA CARBON BRASIL LTDA.","commercialName":"","cnpj":"02634915000184","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"COLUMBIAN 1539 COLUMBIAN CUBATAO 7964 COLUMBIAN 8103 UTE.CM.SP.000825-7.01"},{"id":"6ee1cc54-d297-45ed-5042-08d5ad2bf6ba","name":"CONDOMINIO CENTRO ADMINISTRATIVO SANTO AMARO","commercialName":"","cnpj":"06019015000188","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"CAD STO AMARO 1542 C.C. A.SANTO AMARO 7991"},{"id":"7262d027-837f-42c8-5043-08d5ad2bf6ba","name":"CONDOMINIO SHOPPING JARDIM SUL","commercialName":"SHOPPING JARDIM SUL","cnpj":"64032790000170","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"S JARDIM SUL 1543 COND. SHOP JARD.SUL 7992"},{"id":"7ab1a778-b002-49a4-5047-08d5ad2bf6ba","name":"ENERGEST S.A.","commercialName":"","cnpj":"04029601000188","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"ENERGEST 1551 MASCARENHAS 368 UHE.PH.ES.001432-0.01"},{"id":"9a042c8d-46d0-4bef-502f-08d5ad2bf6ba","name":"NESTLE WATERS BRASIL - BEBIDAS E ALIMENTOS LTDA.","commercialName":"","cnpj":"33062464000181","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"NESTLE WATERS 1497 NESTLE WATERS MCLARO 7960 NESTLE WATERS PERUS 901500 NESTLE WATERS SAO LO 904083 NESTLE WATERS PETROP 910287"},{"id":"75fdce7b-4a5d-4e87-5030-08d5ad2bf6ba","name":"DAIRY PARTNERS AMERICAS MANUFACTURING BRASIL LTDA.","commercialName":"","cnpj":"05300340000151","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"DPAM 1500 DPAM GOIANIA 901553 DPAM JATAI 904059 DPAM PALM. MISSOES 910852"},{"id":"367da977-dbd1-4d03-5077-08d5ad2bf6ba","name":"SANTA CRUZ GERACAO DE ENERGIA S.A..","commercialName":"","cnpj":"07614088000180","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"SCGE 1640 BOA VISTA 8204 CGH.PH.SP.029628-7.01 RIO NOVO 8205 CGH.PH.SP.002428-7.02"},{"id":"bf517805-dd29-4273-5079-08d5ad2bf6ba","name":"TEXTIL J SERRANO LTDA","commercialName":"","cnpj":"49870173000150","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"J SERRANO 1644 TEXTIL J.SERRANO 7162"},{"id":"0474f1ee-bc26-4d0f-5083-08d5ad2bf6ba","name":"ARATU GERACAO S.A.","commercialName":"","cnpj":"07732105000184","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"ARATU GERA 1667 LOBO ITIRAPINA 8129 UHE.PH.SP.001335-8.01"},{"id":"a720f182-896f-4f4d-5085-08d5ad2bf6ba","name":"CPFL SUL CENTRAIS ELETRICAS LTDA","commercialName":"","cnpj":"05441551000104","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"CPFL SUL CENTRAIS 1670 GUAPORE (CPFL SUL) 8121 CGH.PH.RS.001067-7.01 PIRAPO 8122 CGH.PH.RS.028089-5.01 SALTINHO 8123 CGH.PH.RS.002572-0.01 ANDORINHAS 8124 CGH.PH.RS.000702-1.01 CAMARGO CORREA 8125 PCH.PH.MT.000607-6.01"},{"id":"74827aeb-6bf4-4ec2-5089-08d5ad2bf6ba","name":"SEB DO BRASIL PRODUTOS DOMESTICOS LTDA","commercialName":"","cnpj":"61077830000101","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"GRUPO SEB 1679 GRUPO SEB FAB 1 70192 ARNO FABRICA 2 7900 GRUPO SEB PANEX 70071 GRUPO SEB JABOATAO 908791 ARNO ITATIAIA 905588"},{"id":"bf57d959-984d-459f-508f-08d5ad2bf6ba","name":"U.S.J. - ACUCAR E ALCOOL S/A","commercialName":"USINA SAO JOAO","cnpj":"44209336000134","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"UTE USJ 1720 SAO JOAO (USJ) 896165 UTE.AI.SP.026832-1.01"},{"id":"8ea83155-0e5d-41d7-5068-08d5ad2bf6ba","name":"CENTER NORTE S/A CONSTRUCAO EMPREEND ADM E PARTICIPACAO","commercialName":"CENTER NORTE","cnpj":"45246402000109","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"CENTER NORTE 1610 CENTER NORTE S PAULO 70027"},{"id":"7b178a10-b33a-492f-506e-08d5ad2bf6ba","name":"SIEMENS LTDA","commercialName":"SIEMENS","cnpj":"44013159000116","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"SIEMENS CE 1622 SIEMENS 888977 SIEMENS ANHANGUERA 902813"},{"id":"c7c2213f-d7c1-4b43-5053-08d5ad2bf6ba","name":"LEDERVIN INDUSTRIA E COMERCIO LTDA.","commercialName":"LEDERVIN","cnpj":"00965703000154","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"LEDERVIN 1572 LEDERVIN-SUMARE 71156"},{"id":"7abd15e8-865c-4382-5055-08d5ad2bf6ba","name":"ENERPEIXE S.A.","commercialName":"","cnpj":"04426411000102","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"ENERPEIXE 1578 PEIXE ANGICAL 8141 UHE.PH.TO.028353-3.01"},{"id":"c921ab9a-fc27-4374-505d-08d5ad2bf6ba","name":"COENERGY COMERCIALIZADORA DE ENERGIA LTDA.","commercialName":"","cnpj":"07298835000119","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"COENERGY 1589"},{"id":"cf1e4bbc-4f14-4f96-50cb-08d5ad2bf6ba","name":"CONDOMINIO DO CONJUNTO COMERCIAL MARKET PLACE","commercialName":"SAO PAULO MARKET PLACE","cnpj":"00102759000185","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"MARKET PLACE 1848 MARKET PLACE-SP 70206"},{"id":"20c9eb38-56e9-4337-50d6-08d5ad2bf6ba","name":"SAO JOAO ENERGIA AMBIENTAL S/A","commercialName":"","cnpj":"06215456000155","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"SJE AMBIENTAL 1867 S. JOAO BIOGAS 8312 UTE.RU.SP.028648-6.01 BANDEIRANTES 896644 UTE.RU.SP.031732-2.01"},{"id":"5eae51cc-939a-41a1-50da-08d5ad2bf6ba","name":"PIEDADE USINA GERADORA DE ENERGIA S/A","commercialName":"","cnpj":"05345447000116","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"PIEDADE 1872 PIEDADE 8720 PCH.PH.MG.028807-1.01"},{"id":"312898bd-bd44-4448-509d-08d5ad2bf6ba","name":"WHIRLPOOL S.A","commercialName":"UNIDADE DE ELETRODOMESTICOS","cnpj":"59105999000186","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"WHIRLPOOL MAT 1751 WHIRPOOL-BT TF2-SC 70097 WHIRPOOL RIO CLARO 70123 EMBRACO F. UN.II-JOI 7989 EMBRACO JOINVILLE 7394 WHIRLPOLL-ITAIOPOLIS 72026"},{"id":"08dba97d-622c-4c91-509e-08d5ad2bf6ba","name":"SAS - SOCIEDADE ADMINISTRADORA DE CENTROS COMERCIAIS S.A.","commercialName":"","cnpj":"03969764000188","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"SAS 1753 SAS-SHOP S. CRUZ 70111"},{"id":"f94b7c9f-8c39-4da1-50a0-08d5ad2bf6ba","name":"FOZ DO RIO CLARO ENERGIA S.A.","commercialName":"","cnpj":"07823262000103","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"RIO CLARO 1756 FOZ RIO CLARO 8709 UHE.PH.GO.029455-1.01"},{"id":"7f184c34-ba75-4e73-50a3-08d5ad2bf6ba","name":"IJUI ENERGIA S.A.","commercialName":"","cnpj":"07823304000106","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"IJUI 1762 SAO JOSE (IJUI) 8553 UHE.PH.RS.029459-4.01"},{"id":"195f6fa4-9a70-4c7d-50b1-08d5ad2bf6ba","name":"AFLUENTE GERACAO DE ENERGIA ELETRICA S.A.","commercialName":"AFLUENTE GERACAO E TRANSMISSAO DE ENERGIA ELETRICA S.A.","cnpj":"07620094000140","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"AFLUENTE 1785 ALTO FEMEAS I 8160 UHE.PH.BA.027414-3.01 CORRENTINA 8161 PCH.PH.BA.002146-6.01"},{"id":"02af0417-8670-4484-50ae-08d5ad2bf6ba","name":"CONDOMINIO ORDINARIO DO CENTRAL PLAZA SHOPPING CENTER","commercialName":"CENTRAL PLAZA SHOPPING CENTER","cnpj":"03421538000168","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"CENTRAL PLAZA 1781 CENTRAL PLAZA SHOPP 70148"},{"id":"699229df-9b21-48b4-5104-08d5ad2bf6ba","name":"BRASIMET PROCESSAMENTO TERMICO LTDA","commercialName":"","cnpj":"60856820000101","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"BRASIMET SP 1948 BRASIMET CAMPINAS 70481 BRASIMET JUNDIAI 913584"},{"id":"277451e0-701e-47c0-5102-08d5ad2bf6ba","name":"CONDOMINIO CENTRO EMPRESARIAL NACOES UNIDAS S/C","commercialName":"","cnpj":"03368787000137","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"CENU 1946 CENU 70811"},{"id":"34cdf546-63c7-46e3-5108-08d5ad2bf6ba","name":"CARREFOUR COMERCIO E INDUSTRIA LTDA","commercialName":"","cnpj":"45543915000181","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"CARREFOUR 1953 CARREFOUR BARRA RJB 71288 CARREFOUR CAL 900085 CARREFOUR GUA 901033 CARREFOUR GSD 904718 CARREFOUR GOP 906410 CARREFOUR VVS 906433 CARREFOUR RJM 907692 CARREFOUR SULACAP 70372 CARREFOUR ARICANDUV 71008 CARREFOUR OSASCO OSC 71013 CARREFOUR BH SHOP 71027 CARREFOUR D CAXIAS 71284 CARREFOUR S CAETANO 71441 CARREFOUR CAXIAS BRG 71445 CARREFOUR ANL FRANCO 71959 CARREFOUR ANCHIETA 71960 CARREFOUR BUTANTA 71961 CARREFOUR DEMARCHI 71963 CARREFOUR DIADEMA 71964 CARREFOUR IMIGRANTES 71965 CARREFOUR G GRONCHI 71966 CARREFOUR INTERLAGOS 71967 CARREFOUR ORATORIO 71968 CARREFOUR PENHA 71969 CARREFOUR PESSEGO 71970 CARREFOUR RAPOSO SPO 71971 CARREFOUR BROOKLIN 71972 CARREFOUR SBC 71973 CARREFOUR TAB SERRA 71974 CARREFOUR TIETE SPT 71975 CARREFOUR TUCURUVI 71976 CARREFOUR PINHEIROS 71977 CARREFOUR V LOBOS 71979 CARREFOUR PIRITUBA 72142 CARREFOUR PAULICEIA 72418 CARREFOUR BST 890873 CARREFOUR TAU 899578 CARREFOUR SJC 899879 CARREFOUR MTZ 899897 CARREFOUR BCV 900253 CARREFOUR BSP 900373 CARREFOUR SON 900375 CARREFOUR CTB 900378 CARREFOUR JDI 900393 CARREFOUR CIN 900519 CARREFOUR CIT 900520 CARREFOUR CPR 900533 CARREFOUR CST 900534 CARREFOUR CVN 900920 CARREFOUR CVA 901013 CARREFOUR SPL 901034 CARREFOUR BGU 901035 CARREFOUR BTA 901444 CARREFOUR SJA 901446 CARREFOUR BSA 901458 CARREFOUR BAN 901674 CARREFOUR CDA 902762 CARREFOUR CNT 904555 CARREFOUR CMO 905054 CARREFOUR CSM 905055 CARREFOUR CDD 905254 CARREFOUR CSA 905530 CARREFOUR CSB 906252 CARREFOUR MCE 908442 CARREFOUR TBE 910229 CARREFOUR PN4 911215 CARREFOUR SN BSB 911216 CARREFOUR PBM 911217 CARREFOUR PS2 911257 CARREFOUR PN2 911258 CARREFOUR D FERREIRA 71020 CARREFOUR B VIAGEM 71023 CARREFOUR J PESSOA 71035 CARREFOUR JPB 907971 CARREFOUR GRAVATAI 71322 CARREFOUR - P AREIA 72113 CARREFOUR - SMA - RS 889966 CARREFOUR CNS 901353 CARREFOUR POA 904893 CARREFOUR NATAL NTL 71006 CARREFOUR NATAL NZN 71009 CARREFOUR FOR 71019 CARREFOUR RECIFE 71021 CARREFOUR FOB 904736 CARREFOUR CWC 901014 CARREFOUR CWB 902757 CARREFOUR LDB 903620 CARREFOUR CWP 904685 CARREFOUR CXS 905255 CARREFOUR CMC 904751 CARREFOUR MAD 905282 CARREFOUR MPN 905356 CARREFOUR CMS 907116 CARREFOUR CDAM 907658 CARREFOUR MNS 907831 CARREFOUR RJS 70356 CARREFOUR B ROXO CBR 70973 CAPOEIRAS C GDE CCP 70974 CARREFOUR RPS 71022 CARREFOUR S VICENTE 71024 CARREFOUR BHC 71025 CARREFOUR BHP 71026 CARREFOUR UBERLANDIA 71028 CARREFOUR SJR PRETO 71029 CARREFOUR RPN 71030 CARREFOUR SJP SHOP 71031 CARREFOUR SOROCABA 71032 CARREFOUR DELREY BHD 71033 CARREFOUR JUIZ FORA 71034 CARREFOUR N PIRACICA 71061 CARREFOUR AMERICA 71484 CARREFOUR VALINHOS 71826 CARREFOUR D. PEDRO 71827 CARREFOUR CAMBUCI 71962 CARREFOUR S ANDRE 71978 CARREFOUR GRU 899529 CARREFOUR CAP 900473 CARREFOUR GSF 900493 CARREFOUR CRB 900513 CARREFOUR GSC 900515 CARREFOUR CMM 901893 CARREFOUR GOS 906438 CARREFOUR CDMG 907616 CARREFOUR CCM 907694 CARREFOUR MEU 908368 CARREFOUR MRG 908712 CARREFOUR MGU 908713 CARREFOUR MSC 908788 CARREFOUR MGJ 909081 CARREFOUR MAK 909237 CARREFOUR MBZ 909473 CARREFOUR MFL 911295 CARREFOUR PS1 912338 CARREFOUR CDBR 912456"},{"id":"a8fb41c0-516b-47f9-5109-08d5ad2bf6ba","name":"EUROFARMA LABORATORIOS S.A.","commercialName":"EUROFARMA LABORATORIOS","cnpj":"61190096000192","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"EUROFARMA 1956 EUROFARMA JURUBATUBA 70325 EUROFARMA CPO BELO 70326 EUROFARMA RIB PRETO 71138 EUROFARMA ITAPEVI 70972"},{"id":"8d13b3bb-ac66-40d6-5120-08d5ad2bf6ba","name":"CONDOMINIO CONTINENTAL SQUARE FARIA LIMA","commercialName":"","cnpj":"05978315000121","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"CONTSQUARE 2008 C. CONTIN. F. LIMA 70384"},{"id":"10bc709a-1341-44c7-5116-08d5ad2bf6ba","name":"COMPANHIA BRASILEIRA DE ESTIRENO","commercialName":"CBE","cnpj":"61079232000171","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"CBE GUARUJA 1987 COMPANHIA BR ESTIREN 906083"},{"id":"f6c724db-2483-4594-5117-08d5ad2bf6ba","name":"LOUIS DREYFUS COMPANY SUCOS S.A","commercialName":"LOUIS DREYFUS COMPANY SUCOS","cnpj":"00831373000104","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"LOUIS DREYFUS 1989 LOUIS DREYFUS BEBED 70406 LOUIS ENG COELHO 898710 LOUIS PARANAVAI 898703 LOUIS DREYFUS MATAO 70407 L DREYFUS MATAO 2 898812 LOUIS DREYFUS SP 898584"},{"id":"3cd579d0-7bb6-48f7-5118-08d5ad2bf6ba","name":"COMPANHIA METALURGICA PRADA","commercialName":"PRADA","cnpj":"56993900000131","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"COMPANHIA METALURGICA PRADA 1990 PRADA RESENDE 905918 PRADA MOGI 905984 PRADA UBERLANDIA 906363 PRADA - SAO PAULO 908216 PRADA LINS META 909976 PRADA LUZIANIA 911227"},{"id":"5e5c9eac-cabd-4e29-50e1-08d5ad2bf6ba","name":"CONDOMINIO ORDINARIO DO SHOPPING INTERLAR ARICANDUVA","commercialName":"INTERLAR HOME & OFFICE","cnpj":"02211656000189","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"SHOP INTERLAR 1882 SHOP.INTERL.ARICAND. 70257"},{"id":"e3e0671c-3e72-4c13-50e2-08d5ad2bf6ba","name":"CONDOMINIO ORDINARIO DO SHOPPING LESTE ARICANDUVA","commercialName":"CONDORSHOPPING","cnpj":"01597336000146","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"SHOP LESTE 1883 SHOPP LESTE ARICAND. 70256"},{"id":"26eb3bf3-9641-4e26-50e3-08d5ad2bf6ba","name":"CONDOMINIO ORDINARIO DO AUTO SHOPPING SAO PAULO LESTE","commercialName":"AUTO SHOPPING","cnpj":"02465869000137","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"AUTO SHOP 1884 AUTO SHOPPING LESTE 70258"},{"id":"8b5ca269-2d9a-43fc-50dd-08d5ad2bf6ba","name":"SANTA CRUZ POWER CORPORATION USINAS HIDROELETRICAS S.A","commercialName":"","cnpj":"02150533000185","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"SCP 1876 SAO DOMINGOS II 8426 PCH.PH.GO.028388-6.01"},{"id":"dd2f99b2-3d1b-4d52-50de-08d5ad2bf6ba","name":"MASH INDUSTRIA E COMERCIO LTDA","commercialName":"","cnpj":"03125730000107","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"MASH 1879 MASH-SAO PAULO-SP 70244"},{"id":"f529a76f-5063-442b-50e7-08d5ad2bf6ba","name":"OPERADORA DE SHOPPING CENTER ELDORADO LTDA","commercialName":"","cnpj":"46365524000187","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"SC ELDORADO 1893 SHOPP ELDORADO SP 70281"},{"id":"c4518efb-e65e-45c5-4fad-08d5ad2bf6ba","name":"COMPANHIA SIDERURGICA NACIONAL","commercialName":"ESTABELECIMENTO UNIFICADO","cnpj":"33042730000104","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"CSN SIDERURGIC 1225 CSN 49 CSN-ARCOS-MG 7719 CSN GALVASUD-RJ 7808 CISA 230KV 168 IGARAPAVA (CSN) 894722 UHE.PH.SP.001098-7.01"},{"id":"187288d7-58c8-44be-4faf-08d5ad2bf6ba","name":"TEKNO S.A. INDUSTRIA E COMERCIO","commercialName":"","cnpj":"33467572000134","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"TEKNO 1232 TEKNO CONS 7574"},{"id":"19550972-bf24-4619-4fab-08d5ad2bf6ba","name":"NESTLE BRASIL LTDA.","commercialName":"","cnpj":"60409075000152","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"NESTLE 1218 NESTLE CAC 7505 NESTLE ARARAS 7870 NESTLE ARACATUBA 70465 NESTLE S.B.DO CAMPO 70316 NESTLE MARILIA 71289 NESTLE ARARAQUARA 71290 NESTLE RIO PARDO 71382 NESTLE RP II 888136 NESTLE CORDEIROPOLIS 910225 NESTLE IBIA-MG 7871 NESTLE ITUIUTABA-MG 7910 NESTLE MATRIZ 888598"},{"id":"ea8d8d0a-030a-4946-4fa8-08d5ad2bf6ba","name":"COMPANHIA DO METROPOLITANO DE SAO PAULO METRO","commercialName":"","cnpj":"62070362000106","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"METRO SP 1215 METRO SP 71622 METRO PRIMARIA BAND 911626"},{"id":"0068a452-59e8-44b1-4fa2-08d5ad2bf6ba","name":"COMPANHIA NITRO QUIMICA BRASILEIRA","commercialName":"","cnpj":"61150348000150","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"NITROQUIMICA 1204 NITROQUIMICA SP 7300"},{"id":"26e363d3-8f74-498d-4fa3-08d5ad2bf6ba","name":"NADIR FIGUEIREDO IND COM S A","commercialName":"","cnpj":"61067161000197","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"NADIR FIGUEIRE 1207 NADIR FIG 70719"},{"id":"c10d5687-2d38-4d43-4f91-08d5ad2bf6ba","name":"OXITENO S A INDUSTRIA E COMERCIO","commercialName":"","cnpj":"62545686000153","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"OXITENO 1160 OXITENO-MAUA 7058 OXITENO-TREMEMBE SP 71615"},{"id":"92d1b616-28ae-4b99-4f7b-08d5ad2bf6ba","name":"PROCTER & GAMBLE INDUSTRIAL E COMERCIAL LTDA","commercialName":"PROCTER & GAMBLE","cnpj":"01358874000188","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"PROCTER&GAMBLE 1133 P E G ITATIAIA 910206 PROCTER GAMBLE LOUVE 70075 P & G - IC-SACOMA 7545"},{"id":"65e02cd9-ac99-4927-4fcf-08d5ad2bf6ba","name":"VISCOFAN DO BRASIL SOCIEDADE COMERCIAL E IND. LTDA.","commercialName":"","cnpj":"65019655000319","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"VISCOFAN 1289 VISCOFAN DO BRASIL 7814"},{"id":"c94a9faa-80e3-4781-4fdb-08d5ad2bf6ba","name":"AIR PRODUCTS BRASIL LTDA.","commercialName":"","cnpj":"43843358000199","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"AIR PRODUCTS 1321 AIRPROD MC 7321 AIR PRODUCTS GUAIBA 7359"},{"id":"999de192-720d-404c-4fd9-08d5ad2bf6ba","name":"MELHORAMENTOS CMPC LTDA","commercialName":"MELHORAMENTOS","cnpj":"44145845000140","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"MELHORAMENTOS 1318 MELHORAMENT CAIEIRAS 173 MELHORAMENTOS N CAIE 71695 MELHORAMENTOS MOGI C 70076"},{"id":"9e6518d1-c090-459e-4fc3-08d5ad2bf6ba","name":"IBS COMERCIALIZADORA LTDA.","commercialName":"IBS TRADING","cnpj":"04462976000137","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"IBS-ENERGY 1265"},{"id":"82709f98-9a82-4816-4fc4-08d5ad2bf6ba","name":"COMPANHIA PAULISTA DE TRENS METROPOLITANOS - CPTM","commercialName":"","cnpj":"71832679000123","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"CPTM 1269 CPTM CVPOA 7575 CPTM BCUBA 7576 CPTM IMP. LEOPOLDINA 7874 CPTM SANTA RITA 7879 CPTM STA TEREZINHA 7880 CPTM MORUMBI 7882 CPTM ITAQUERA 7884 CPTM ERM. MATARAZZO 7885 CPTM TIETE 7886 CPTM PARI 7887 CPTM SAO CAETANO 7888 CPTM BARRA FUNDA 7889 CPTM OSASCO 7890 CPTM PATRIARCA-SP 70018 CPTM JANDIRA 888899 SUB AYRTON SENNA L13 913091"},{"id":"b882fd53-bb39-4ee7-4fbc-08d5ad2bf6ba","name":"AIR LIQUIDE BRASIL LTDA","commercialName":"","cnpj":"00331788000119","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"AIR LIQUIDE SP 1256 AIR LIQUID PAULINIA 91 AIR LIQUID BELF ROXO 149 AIR LIQUIDE-JUNDIAI 7452 AIR LIQUID-FORT MG 7469 AIR LIQ PAULINIA II 888764 AIR LIQUIDE SJ CAMPO 72405 AIR LIQUIDE GRU 908723 AIR LIQUIDE SPO 910062 AIR LIQ UAR 72790857 910216 AIR LIQUIDE CAR 910342 AIR LIQUID ITABIRITO 892969 UTE UGPU ITABIRITO 907622 UTE.GN.MG.032658-5.01"},{"id":"362a3a25-f02c-4592-4fc1-08d5ad2bf6ba","name":"JBS S/A","commercialName":"","cnpj":"02916265000160","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"JBS FRIBOI AUT 1263 JBS - MOZARLANDIA 7850 JBS - ITUIUTABA 7872 FRIBOI C GRANDE 7907 JBS BARRETOS 70939 JBS CARNES-B GARCA 71286 JBS CARNE DIAMANTINO 71287 JBS C GRANDE II 890207 JBS FRIBOI AND 898175 JBS VILHENA FRIG RO 905727 JBS FRIG CUBATAO 909469 JBS - GOIANIA - GO 910847 JBS FRIG PIMEN BUENO 911270 JBS - GUAICARA SP 70857 JBS-PEDRA PRETA 71107 JBS CARNE ARAPUTNGA 71340 JBS CARNES-ITURAMA 71363 JBS CARNES-FLORESTA 71428 JBS CARNES AGUA BOA 71494 JBS FRIBOI-JUARA 71673 JBS ANHANGUERA SP 899051 JBS SEN CANEDO 904684 JBS - PONTA PORA-MS 905279 JBS NOVA ANDRADINA 2 906385 JBS FRIG ANASTACIO 907947 JBS FRIG CASSILANDIA 907968 JBS - COLIDER 908337 JBS SAO MIGUEL GUAPO 909171 JBS FRIG CAJAMAR 909440 JBS - ETE - NOVA AND 910556 JBS - CHARQUE 911231 BIOLINS RC-LINS 70958 JBS CARNE P EPITACIO 71387 JBS CARNES - NAVIRAI 7509 JBS CARNE S J 4M 71339 JBS FRIBOI-CUIABA 71674 JBS COUROS CACOAL RO 901134 JBS COUROS COLIDER 901193 JBS COUROS CURTUME 901653 JBS COUROS MONTES BE 903713 JBS NOVA ANDRADINA 904329 JBS COURO UBERLANDIA 907192 JBS ESTAMPARIA BRRTS 907265 JBS MONTENEGRO 899717 JBS CASCAVEL 904507 JBS COUROS MARABA 899148 JBS SANTA FE SUL 904511 JBS TUCUMA FRIG 909622 JBS - COLORADO OESTE 913420 UTE BIOLINS 8632 UTE.AI.SP.030125-6.01"},{"id":"6757fffb-bcd1-48ed-4ffe-08d5ad2bf6ba","name":"PEPSICO DO BRASIL LTDA","commercialName":"","cnpj":"31565104000177","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"PEPSICO 1390 PEPSICO ITU 23KV 7313 PEPSICO SETE LAGOAS 891468 PEPSICO GUARULHOS 909648 PEPSICO FEIRA SANT 897505 PEPSICO CTB PR 888118 PEPSICO - PORTO ALEG 897568 PEPSICO STO AGOSTINH 889264 PEPSICO DO BRASIL 890199"},{"id":"40efeb6a-61b0-4953-4fff-08d5ad2bf6ba","name":"TELEFONICA BRASIL S.A.","commercialName":"","cnpj":"02558157000162","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"TELEFONICA 1391 TEL XV NOV ARACATUBA 7030 TELE W. LUIS SANTOS 7031 TELEF LGAM 7078 TELEFONICA B.FUNDA 7180 TELEFONICA TAMANDARE 7205 TELEFONICA PENHA-SP 7207 TELEFONICA BRAS 7264 TELEFONICA BCONSTANT 7283 TELEFONICA VILA PAUL 7284 TELEFONICA MORUMBI 7285 TELEFONICA ANHANG. 7286 TELEFONICA PALMEIRAS 7287 TELEFONICA LIBERDADE 7288 TELEFONICA V. ESPER. 7289 TELEFONICA LAPA-SP 7290 TELEFONICA OSASCO 7294 TELEFONICA JABAQUARA 7314 TELEFONICA MARTINIAN 7315 TELEFONICA S.AMARO 7316 TELEFONICA V.GUSTAVO 7337 TELEFONICA SANTANA 7338 TELEFONICA IBIRAP. 7339 TELEFONICA PARAISO 7365 TELEFONICA PINHEIROS 7399 TELEFONICA V MORAIS 7418 TELE GEN CARN JUNDIA 7419 TELEF.J.ANCH.MARILIA 7420 TELEF.FONTE ARARAQ. 7421 TELEF. VOL.SJRPRETO 7422 TELEF. CASTELO CAMP. 7423 TELEF. ALTOS BAURU 7424 TELEF. CENTRO CAMP. 7425 TELEF.CAMBUI CAMP. 7426 TELEF HUMA 7470 TELEF C SALLES SJBV 71884 TELEF PERNAMBUCO VOT 71885 TELEF C. GOMES-LIM 71893 TELEF VL CAICARA PG 71894 TELEFONICA AMERICANP 72027 TELEFONICA CHC S ANT 72028 TELEFONICA BERRINI 72029 TELEFONICA CID LIDER 72030 TELEFONICA JARDIM 72031 TELEFONICA S J ATIB 72032 TELEFONICA J VIRG GJ 72033 TELEFONICA SATELITE 72037 TELEFONICA TATETUBA 72038 TELEF SAMARO GUARUJA 72121 TELEF VOLUNT PIRACIC 72122 TELEF PARADA INGLESA 72123 TELEF ANCHIETA 72124 TELEFONICA PERDIZES 72125 TELEFONICA ITM BIBI 72132 TELEF M MIRIM P JOSE 72228 TELEF SBC FERRAZOP 72229 TELEF CASA VERDE 72230 TELEF STA IFIGENIA 72231 TELEF GUARANI 72232 TELEF REAL PARQUE 72233 TELEFONICA S MIGUEL 72234 TELEF TREMEMBE 72235 TELEF VILA MARIANA 72236 TELEF VILA PRUDENTE 72237 TELEF SBC CENTRO 72238 TELEF-GUAIANAZES 72246 TELEF-PARELHEIROS 72247 TELEF BOTUCATU J PAS 72248 TELEF C ELISEOS CMP 72249 TELEF JD ELITE PIRAC 72250 TELEF RIB PRETO 72251 TELEF CERRADO SORCBA 72252 TELEF MOGI GUACU 72253 TEL PORCINO RODRIGUE 888090 TELEF ST AND CAMP 888091 TEL N CACHOEIRINHA 888092 TELEF JACANA 888093 TEL ITAQUERA 888094 TEL ERM MATARAZZO 888095 TELEF JD HELENA 888096 TEL DUTRA 888097 TEL ANHANGUERA 888098 TELEF ANGELA 888099 TELEF ROBRU 888100 TELEF PENHA FRANCA 888102 TELEF ANALIA FRANCO 888104 TELEF PAPA J XXIII 888105 TELEF BENED CALIXTO 888106 TEL SBC - CASTELO BR 888427 TEL SBC - DEMARCHI 888428 TEL HOMERO THOM 888429 TEL VILA PIRES 888430 TEL CASA GRANDE 888436 TEL JD BONFIGLIOLI 888437 TEL GUARAPIRANGA 888438 TEL SAUDE 888439 TEL MOOCA 888643 TEL JARAGUA 888646 TEL CONSOLACAO 888648 TEL BILLINGS 888650 TEL SAO CAETANO SUL 888652 TEL SBC ASSUNCAO 888653 TEL RIB PIRES CENTRO 888654 TEL OSASCO STO ANTON 888656 TEL OSASCO ROCHDALLE 888657 TEL AVENTISTA 888675 TEL TAUBATE 888725 TEL VILA OLIVEIRA 888916 TEL JD SAO PEDRO 888917 TEL JOAQUIM SIQUEIRA 888919 TEL PICANCO 888929 TEL MESQUITA 888930 TEL VILA UNIAO 888931 TEL MOEMA 888932 TEL JARDIM MIRIAM 888934 TEL JAGUARE 888935 TEL IMIRIM 888936 TEL IPIRANGA 888937 TEL CAXINGUI 888938 TEL AGUA BRANCA 888939 TEL RUDGE RAMOS 888940 TEL PLANALTO 888941 TEL MAUA CENTRO 888942 TEL SANTOS J MENINO 889445 TEL SANTOS P PRAIA 889446 TEL SANTOS TOCANTIS 889447 TEL RIO CLARO AV 2 889448 TELEFONICA MADALENA 889824 TELEF PQ ORATORIO 889850 TELEFONICA VVJ 901420 TELEFONICA CAIUA 905818 TELEFONICA BARAO H M 907466 TELEFONICA CTP 907469 TELEFONICA LUE 907612 TELEFONICA BON 907914 TELEFONICA BLO 910333 TELESP CEL. RPETRONI 70282 TELERJ BARRA MTZ RJ 70284 TELEFONICA BVT 904015 TELEFONICA IND 904016 TELEFONICA MAL FLORI 906984 TELEFONICA LOURENCO 907402 TELEFONICA 24 MAIO 907403 TELEFONICA VISC NASC 907404 TELEFONICA ACCIOLY 907642 TELEFONICA JOAO PAUL 907679 TELEFONICA FRANCISCO 908025 TELEFONICA CTA 909605 TELEFONICA TEN FRANC 909894 TELEFONICA LDA 910234 TCS CABUL SALVADOR 911334 TELEFONICA BR ECO 899085 TELEFONICA CENTER 901017"},{"id":"7a06b6c4-2161-4fea-4ffa-08d5ad2bf6ba","name":"UNIPAR INDUPA DO BRASIL S.A.","commercialName":"ELCLOR","cnpj":"61460325000141","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"INDUPA 1382 SOLVAY 7052"},{"id":"c57feccc-3b08-4198-4ffb-08d5ad2bf6ba","name":"KLABIN S.A.","commercialName":"","cnpj":"89637490000145","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"KLABIN PUMA 1383 KLABIN ANGATUBA 7046 KLABIN-PIRACICABA 71296 KLABIN-GOIANA-PE 7825 KLABIN-O COSTA-SC 7472 KLABIN JUNDIAI D.I, 71300 KLABIN JUNDIAI T.P. 71301 KLABIN ITAJAI 71258 KLABIN LAGES I 71450 KLABIN LAGES II 71451 KLABIN SAO LEOPOLDO 889543 KLABIN BETIN 7084 KLABIN-FEIRA SANTANA 72021 KLABIN-T. BORBA PR 7841 KLABIN CP 138KV 7074 KLABIN PUMA 896205 EMBALPLAN 898183 KLABIN CELULOSE 898176 UTE.FL.PR.031098-0.01"},{"id":"72483d60-a151-4b2e-4ffc-08d5ad2bf6ba","name":"KIMBERLY -CLARK BRASIL INDUSTRIA E COMERCIO DE PRODUTOS DE HIGIENE LTDA","commercialName":"","cnpj":"02290277000121","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"KIMBERLY CLARK 1384 KLABIN MC 175 KIMBERLY KENKO SUZ 70453 KMBERLY CLARK PINTO 7054 KIMBERLY ELDORADO S 905373 KIMB.CLARK CAMACARI 906662"},{"id":"36c61c60-a001-409b-4ff8-08d5ad2bf6ba","name":"MANIKRAFT GUAIANAZES INDUSTRIA DE CELULOSE E PAPEL LTDA","commercialName":"","cnpj":"71900237000339","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"MANIKRAFT 1379 MANIKRAFT-GUAIANAZES 7485"},{"id":"a78fd03b-b0b9-43f6-4fed-08d5ad2bf6ba","name":"CONDOMINIO SHOPPING CENTER ''D''","commercialName":"SHOPPING CENTER ''D''","cnpj":"00087900000118","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"SHOPPING D 1362 SHOPPING D 7383"},{"id":"27df9f24-62af-4f18-4fe8-08d5ad2bf6ba","name":"CONDOMINIO SP MARKET CENTER","commercialName":"","cnpj":"01086381000136","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"SP MARKET 1353 SP MARKET 7077"},{"id":"2ffb1171-666f-464d-4fdf-08d5ad2bf6ba","name":"SAINT-GOBAIN VIDROS S.A.","commercialName":"VERALLIA","cnpj":"60853942000144","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"SGOBAIN VID 1326 S GOBAIN A BRANCA 7282"},{"id":"6b578865-2c25-439b-4fe0-08d5ad2bf6ba","name":"VOITH PAPER MAQUINAS E EQUIPAMENTOS LTDA","commercialName":"","cnpj":"61243119000180","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"VOITH PAPER 1327 VOITH PAPER-JARAGUA 7039"},{"id":"05ed8f3e-b918-45af-4fe4-08d5ad2bf6ba","name":"GOODYEAR DO BRASIL PRODUTOS DE BORRACHA LTDA","commercialName":"","cnpj":"60500246000154","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"GOODYEAR 1337 GOODYEAR SOB SP 888139 GOODYEAR AMERICANA 7941"},{"id":"28e01d5c-f53c-436c-4f64-08d5ad2bf6ba","name":"UNIFI DO BRASIL LTDA.","commercialName":"UNIFI","cnpj":"03013973000153","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"UNIFI 1083 UNIFI BR ALFENAS 7677"},{"id":"0e326ca4-1fb1-47a1-4f50-08d5ad2bf6ba","name":"DURATEX S.A.","commercialName":"","cnpj":"97837181000147","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"DURA UBE 1046 SATIPEL UBERABA 7637 SATIPEL TAQUARI RS 7640"},{"id":"a6376d15-2ca1-46c7-4f51-08d5ad2bf6ba","name":"CIA DE SANEAMENTO BASICO DO ESTADO DE SAO PAULO SABESP","commercialName":"SABESP","cnpj":"43776517000180","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"SABESP 1051 SABESP TAI 7390 SABES SIFA 7401 SABESP-EEAB TAQUACE. 7408 SABESP RIO GRANDE 7409 SABESP GUARAPIRANGA 7410 SABESP P NOVO MUNDO 7411 SABESP BMI 7482 SABESP S.INES MAIRIP 7504 SABESP ABC-SBC 7569 SABESP-TEODORO RAMOS 7598 SABESP 46R-BARUERI 7920 SABESP EEA ITAQUERA 899667 SABESP PINHEIROS 901634 SABESP - ETE SUZANO 908634 SABESP ETE S MIGUEL 909071 SABESP EEAT J XXIII 910063 SABESP-EEAT JD DAMAS 910677 SABESP EEAB-PAULINIA 72339 SABESP EEAB CANOAS I 72393 SABESP EEAB CANOA II 72394 SABESP SJBV 899303 SABESP USINA EPC 899574 SABESP - ETA 3 - CB 899579 SABESP PRAIA GRANDE 900922 SABESP GUARUJA 900956 SABESP ITAPEVA 900957 SABESP VZP 901133 SABESP TAUBATE 901975 SABESP FCO MORATO 902115 SABESP LAGOA CASQ 903464 SABESP HTL ETE HORTO 903465 SABESP STA ETELVINA 903656 SABESP FERRAZ VASCO 903789 SABESP ETE SJB VISTA 903855 SABESP POA 904214 SABESP VALE PINHEIRO 904491 SABESP ITAQUAQUECETU 904677 SABESP - EEAT R1 904696 SABESP VICENTE DE CA 904709 SABESP JURUBATUBA 905338 SABESP FRANCA 909978 SABESP ETE FRANCA 909979 SABESP ETE PAULINIA 910309 SABESP JD SAO LUIZ 910914 SABESP ETE MARABA 911296 SABESP - ETA CAMPO L 912320 SABESP - ETE VARZEA 912353 SABESP - ETE CAMPOS 912377 SABESP - EEAB MANDAC 912443 SABESP - ETE LIMOEIR 912531"},{"id":"4ca51e01-3392-45ed-4f45-08d5ad2bf6ba","name":"IGUACU COMERCIALIZADORA DE ENERGIA ELETRICA LTDA","commercialName":"","cnpj":"04569045000132","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"ICEE 190"},{"id":"20d5b391-ebbb-486f-4f47-08d5ad2bf6ba","name":"SERVICE ENERGY GESTAO DE ENERGIA S/A.","commercialName":"SERVICE ENERGY","cnpj":"03358698000100","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"SERVICE ENERGY 195 BARRA CLARA 8640 PCH.PH.SC.029764-0.01"},{"id":"71a094de-0879-41a1-4f3a-08d5ad2bf6ba","name":"ECOM ENERGIA LTDA.","commercialName":"","cnpj":"05352237000155","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"ECOM 143 FREDERICO J. CERUTTI 898150 CGH.PH.RS.029037-8.01 S JOSE IGARASSU (NC) 8280 UTE.AI.PE.029113-7.01"},{"id":"543c6e3f-c103-4a99-4f3d-08d5ad2bf6ba","name":"NOVELIS DO BRASIL LTDA.","commercialName":"","cnpj":"60561800000103","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"NOVELIS 151 NOVELIS O PRETO 142 ALCAN PIND 169 NOVELIS-SANTO ANDRE 70068 NOVELIS CANDEIAS 7439 BRECHA 894802 UHE.PH.MG.000315-8.01"},{"id":"7b6f5fa9-3478-4827-4f3e-08d5ad2bf6ba","name":"COMPANHIA ENERGETICA CHAPECO - CEC","commercialName":"","cnpj":"04041804000190","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"CEC 152 QUEBRA QUEIXO 8014 UHE.PH.SC.002167-9.01"},{"id":"1de1fff3-5200-4af4-4f25-08d5ad2bf6ba","name":"DELTA COMERCIALIZADORA DE ENERGIA LTDA.","commercialName":"","cnpj":"04802543000183","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"DELTA ENERGIA 115"},{"id":"fac24ec4-2ab6-4b50-4f32-08d5ad2bf6ba","name":"QUEIROZ GALVAO ENERGETICA S/A","commercialName":"","cnpj":"03299819000190","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"QGE 128 JAURU-QGE 567 UHE.PH.MT.001245-9.01"},{"id":"63cd830f-6314-4ea9-4f09-08d5ad2bf6ba","name":"ITA ENERGETICA S/A","commercialName":"ITA","cnpj":"01355994000121","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"ITASA 61"},{"id":"71fc4bc3-c21b-45ca-4f01-08d5ad2bf6ba","name":"EMAE - EMPRESA METROPOLITANA DE AGUAS E ENERGIA SA","commercialName":"","cnpj":"02302101000142","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"EMAE 50 RASGAO 333 UHE.PH.SP.002187-3.01 PORTO GOES 334 UHE.PH.SP.002123-7.01 HB+PEDREIRA+TRAICAO 331 UHE.PH.SP.001084-7.01 + pedreira + traição"},{"id":"6cc480df-17a4-438c-4efb-08d5ad2bf6ba","name":"RIO PARANAPANEMA ENERGIA S.A.","commercialName":"","cnpj":"02998301000181","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"RIO PARANAPAN 41 JURUMIRIM 313 UHE.PH.SP.001285-8.01 CANOAS I 314 UHE.PH.SP.000647-5.01 SALTO GRANDE 315 UHE.PH.SP.002648-4.01 CHAVANTES 316 UHE.PH.SP.000764-1.01 CAPIVARA 317 UHE.PH.SP.000657-2.01 CANOAS II 318 UHE.PH.SP.027092-0.01 TAQUARUCU 319 UHE.PH.SP.002821-5.01 ROSANA 320 UHE.PH.SP.002555-0.01"},{"id":"04c0a002-2916-4839-4f04-08d5ad2bf6ba","name":"EDP - COMERCIALIZACAO E SERVICOS DE ENERGIA LTDA.","commercialName":"","cnpj":"04149295000113","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"EDP C 53"},{"id":"9d3d60b6-f6a9-40a1-4f1f-08d5ad2bf6ba","name":"VOTENER-VOTORANTIM COMERCIALIZADORA DE ENERGIA LTDA.","commercialName":"","cnpj":"03984862000194","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"VOTENER 101"},{"id":"4923d592-009b-4cbf-4f19-08d5ad2bf6ba","name":"LAJEADO ENERGIA S/A","commercialName":"LAJEADO ENERGIA","cnpj":"03460864000184","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"LAJEADO ENERG 90 LAJEADO REDE 8289 UHE.PH.TO.001304-8.01"},{"id":"60a083ca-697f-4444-4f22-08d5ad2bf6ba","name":"INTERCEMENT BRASIL S.A.","commercialName":"","cnpj":"62258884000136","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"ICB COM 104 CCC-IJACI-MG 163 CCC APIAI 188 CCC BODOQUENA 189 CCC CAJATI 7212 CCC - PEDRO LEOPOLDO 7345 CCC - CEZARINA - GO 7806 CCC - NOVA SANTA RIT 7843 CCC SANTANA PARAISO 70069 CCC - CAMPO FORMOSO 71780 CCC - SAO MIGUEL DOS 889265 CCC - CANDIOTA - RS 889266 CCC - JOAO PESSOA 894890 CCC - BRUMADO - BA 896088 CCC-CUBATAO 71828 INTERCEMENT SUAPE 71989 INTERCEMENT JACAREI 72077"},{"id":"8b20203c-2539-47fb-4f1c-08d5ad2bf6ba","name":"COMPANHIA ENERGETICA SANTA CLARA","commercialName":"","cnpj":"02881800000194","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"CESC 96 SANTA CLARA (CESC) 339 UHE.PH.MG.002699-9.01"},{"id":"4a62b4e7-9538-4a49-4f1d-08d5ad2bf6ba","name":"COMERC COMERCIALIZADORA DE ENERGIA ELETRICA LTDA","commercialName":"","cnpj":"58177643000195","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"COMERC 97"},{"id":"6ca53aa6-b21f-4370-4f12-08d5ad2bf6ba","name":"COMPANHIA BRASILEIRA DE ALUMINIO","commercialName":"","cnpj":"61409892000173","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"CBA 72 CBA 50 CBA MIRAI 889267 CNT NIQUELANDIA-GO 7148 NIQUEL TOC. S MIGUEL 166 SALTO PILAO-CBA 8598 UHE.PH.SC.028564-1.01 SALTO RIO VERDINHO 8706 UHE.PH.GO.028760-1.01 SOBRAGI 413 UHE.PH.MG.002757-0.01 PIRAJU 536 UHE.PH.SP.002077-0.01 OURINHOS 8113 UHE.PH.SP.027872-6.01"},{"id":"9439e195-0bd3-4b7b-4ee2-08d5ad2bf6ba","name":"FOX ENERGY COMERCIALIZADORA DE ENERGIA LTDA.","commercialName":"","cnpj":"03295499000108","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"FOX 9"},{"id":"30e26ebe-4ef5-4cd3-4ee0-08d5ad2bf6ba","name":"EDP SAO PAULO DISTRIBUICAO DE ENERGIA S.A.","commercialName":"EDP SAO PAULO DISTRIBUICAO DE ENERGIA","cnpj":"02302100000106","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"BANDEIRANTE 5 BANDEIRANTE 11 BANDEIRANTE DITCSP 72316"},{"id":"a241de34-2dc2-421b-4eee-08d5ad2bf6ba","name":"CESP COMPANHIA ENERGETICA DE SAO PAULO","commercialName":"","cnpj":"60933603000178","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"CESP 23 PORTO PRIMAVERA 227 UHE.PH.SP.002127-0.01 PARAIBUNA 228 UHE.PH.SP.027122-5.01 JAGUARI (CESP) 229 UHE.PH.SP.027131-4.01"},{"id":"4d9d1061-5d85-4e21-5365-08d5ad2bf6ba","name":"DEAL COMERCIALIZADORA DE ENERGIA LTDA","commercialName":"DEAL COMERCIALIZADORA","cnpj":"10671322000116","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"DEAL COMERCIALIZADORA 3612"},{"id":"e21a72c0-b563-448c-5358-08d5ad2bf6ba","name":"A.T.P. INDUSTRIA E COMERCIO DE PLASTICOS LTDA.","commercialName":"","cnpj":"04995392000127","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"ALTAPLAST 3589 ALTAPLAST 71112"},{"id":"3f05665f-24de-4035-534a-08d5ad2bf6ba","name":"BRASCADM GESTAO LTDA","commercialName":"","cnpj":"09067645000116","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"SPP 3561 SHOP PATIO PAULISTA 71175"},{"id":"8cf4ee25-8221-417c-534b-08d5ad2bf6ba","name":"CONDOMINIO WEST PLAZA SHOPPING CENTER I","commercialName":"WEST PLAZA SHOPPING","cnpj":"09043953000101","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"SHOP WEST PLAZA 3564 WEST PLAZA LIVRE 71331"},{"id":"f5281cf4-237b-4cc0-5333-08d5ad2bf6ba","name":"PEPSICO DO BRASIL LTDA","commercialName":"","cnpj":"31565104030670","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"PEPS 3508 PEPSICO BR ITAQUERA 71134"},{"id":"bde67b6b-9571-433e-5335-08d5ad2bf6ba","name":"COFCO INTERNATIONAL BRASIL S.A.","commercialName":"COFCO INTL","cnpj":"06315338000119","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"COFCO BRASIL 3511 NOROESTE PAULISTA C 70945 MERIDIANO+NOBL EN II 72227 POTIRENDABA CONS 901853 CATANDUVA CONSUMO 904577 CATANDUVA-NOBLE 397 UTE.AI.SP.028042-9.01 POTIRENDABA 8371 UTE.AI.SP.029655-4.01 NOBLE ENERGIA 8630 UTE.AI.SP.030004-7.01 UTE NOROESTE PTA 8611 UTE.AI.SP.029775-5.01 MERIDIANO 20004 UTE.AI.SP.030303-8.01 NOBLE EN II 20003 UTE.AI.SP.030271-6.01"},{"id":"ab8c55bf-2586-46f5-5317-08d5ad2bf6ba","name":"DESA MORRO DOS VENTOS IV S/A","commercialName":"DESA MORRO DOS VENTOS IV S/A","cnpj":"11686202000155","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"CPFL MORRO DOS VENTOS IV 3476 MORRO DOS VENTOS IV 20042 EOL.CV.RN.030311-9.01"},{"id":"0db36e35-74fe-4cdc-532e-08d5ad2bf6ba","name":"AUTONEUM BRASIL TEXTEIS ACUSTICOS LTDA","commercialName":"","cnpj":"01935393000198","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"AUTONEUM 3501 RIETER TAU-13,8 KV 71211 RIETER BET 13,8 KV 71336 AUTONEUM SP 897648"},{"id":"ae913bff-ce8d-4460-530f-08d5ad2bf6ba","name":"FIBRIA CELULOSE S/A","commercialName":"","cnpj":"60643228000121","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"FIBRIA 3463 FIBRIA ARACRUZ 7009 ARACRUZ 575 UTE.FL.ES.000127-9.01 FIBRIA-MS (H1) 8493 UTE.FL.MS.029694-5.01 FIBRIA (H2) 910094 UTE.FL.MS.037624-8.01"},{"id":"b5a1f585-9bed-486d-5319-08d5ad2bf6ba","name":"DESA MORRO DOS VENTOS VI S/A.","commercialName":"DESA MORRO DOS VENTOS VI","cnpj":"11686150000117","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"CPFL MORRO DOS VENTOS VI 3478 MORRO DOS VENTOS VI 20043 EOL.CV.RN.030300-3.01"},{"id":"902530ee-5f99-419b-531a-08d5ad2bf6ba","name":"DESA MORRO DOS VENTOS III S/A.","commercialName":"DESA MORRO DOS VENTOS III","cnpj":"11686100000130","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"CPFL MORRO DOS VENTOS III 3479 MORRO DOS VENTOS III 20041 EOL.CV.RN.030310-0.01"},{"id":"8c4cdce4-6cac-4cd4-531b-08d5ad2bf6ba","name":"DESA MORRO DOS VENTOS IX S/A.","commercialName":"DESA MORRO DOS VENTOS IX","cnpj":"11686103000173","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"CPFL MORRO DOS VENTOS IX 3480 MORRO DOS VENTOS IX 20044 EOL.CV.RN.030302-0.01"},{"id":"a9cba81b-012f-45c0-531c-08d5ad2bf6ba","name":"DESA MORRO DOS VENTOS I S/A","commercialName":"DESA MORRO DOS VENTOS I S/A","cnpj":"11686050000190","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"CPFL MORRO DOS VENTOS I 3481 MORRO DOS VENTOS I 20040 EOL.CV.RN.030301-1.01"},{"id":"cea004bd-ee3d-4476-52fd-08d5ad2bf6ba","name":"MARFRIG GLOBAL FOODS S.A.","commercialName":"MARFRIG","cnpj":"03853896000140","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"MARFRIG 3425 MARFRIG CHUPINGUAIA 907458 MARFRIG SAO GABRIEL 908045 MARFRIG ITUPEVA 908277 MARFRIG ALIMENTOS 71394 MARFRIG TANGARA MT 71461 MARFRIG BATAGUASSU 71463 MARFRIG-PARANATINGA 71506"},{"id":"71cdd8a8-02e4-43ca-5303-08d5ad2bf6ba","name":"BLANVER FARMOQUIMICA E FARMACEUTICA S.A.","commercialName":"BLANVER S.A.","cnpj":"53359824000119","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"BLANVER 3433 BLANVER TABOAO 906243"},{"id":"53e96647-d4ae-4ac0-52e1-08d5ad2bf6ba","name":"SANTA CLARA V ENERGIAS RENOVAVEIS LTDA","commercialName":"","cnpj":"10797909000176","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"CPFL SANTA CLARA V 3341 STA CLARA V 20050 EOL.CV.RN.030378-0.01"},{"id":"a9d0555b-d992-486b-52e4-08d5ad2bf6ba","name":"SANTA CLARA I ENERGIAS RENOVAVEIS LTDA","commercialName":"","cnpj":"10797899000179","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"CPFL SANTA CLARA I 3345 STA CLARA I (SCLARA) 20046 EOL.CV.RN.030292-9.01"},{"id":"213c4685-a3df-4b58-52e5-08d5ad2bf6ba","name":"SANTA CLARA II ENERGIAS RENOVAVEIS LTDA","commercialName":"","cnpj":"10797908000121","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"CPFL SANTA CLARA II 3346 STA CLARA II 20047 EOL.CV.RN.030308-9.01"},{"id":"6249dfca-135f-470b-52e6-08d5ad2bf6ba","name":"SANTA CLARA III ENERGIAS RENOVAVEIS LTDA","commercialName":"","cnpj":"10797910000109","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"CPFL SANTA CLARA III 3347 STA CLARA III 20048 EOL.CV.RN.030293-7.01"},{"id":"60d3d7db-6352-47b9-52e7-08d5ad2bf6ba","name":"SANTA CLARA IV ENERGIAS RENOVAVEIS LTDA","commercialName":"","cnpj":"10797907000187","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"CPFL SANTA CLARA IV 3349 STA CLARA IV 20049 EOL.CV.RN.030307-0.01"},{"id":"63c07c50-c4b2-436a-52e8-08d5ad2bf6ba","name":"SANTA CLARA VI ENERGIAS RENOVAVEIS LTDA","commercialName":"","cnpj":"10797906000132","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"CPFL SANTA CLARA VI 3350 STA CLARA VI 20051 EOL.CV.RN.030304-6.01"},{"id":"86ac540e-cd0a-4a90-52e9-08d5ad2bf6ba","name":"EURUS VI ENERGIAS RENOVAVEIS LTDA","commercialName":"","cnpj":"10797905000198","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"CPFL EURUS VI 3351 EURUS VI 20045 EOL.CV.RN.030351-8.01"},{"id":"404a373a-e9de-4381-5258-08d5ad2bf6ba","name":"BANCO SANTANDER (BRASIL) S.A.","commercialName":"","cnpj":"90400888000142","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"SANTANDER 3016 SANTANDER TORRE 70895 SANTANDER CDP 905580 BANCO SANTANDER C I 70950 SANTANDER CASA III 71070 SANTANDER SUMARE 890054 SANTANDER SANTOS 890180 SANTANDER ARARAQUARA 890181 SANTANDER ARACATUBA 890182 SANTANDER BAURU 890183 SANTANDER OURINHOS 890729 SANTANDER SJR PRETO 890902 SANTANDER SOROCABA 891101 SANTANDER PIRACICABA 891102 SANTANDER CAMPINAS 891121 SANTANDER B ITAPURA 891124 SANTANDER MARILIA 891125 SANTANDER R PRETO 891126 SANTANDER SJ CAMPOS 891462 SANTANDER GUARULHOS 891463 SANTANDER V. REDONDA 892249 SANTANDER V REDONDA 892925 SANTANDER OUVIDOR 894182 SANTANDER RIO BRANCO 894183 SANTANDER - 130 908730 SANTANDER - 332 908740 SANTANDER 221 908741 SANTANDER - 30 908751 SANTANDER - 193 908752 SANTANDER - 285 908753 SANTANDER - 3311 908754 SANTANDER OLIMPIA 20 909183 SANTANDER BAURU 3051 909194 SANTANDER 257 909590 3083 - CAMPINAS 910415"},{"id":"145a9180-ab7d-48e1-5254-08d5ad2bf6ba","name":"CROMEX S/A","commercialName":"","cnpj":"02271463000113","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"CROMEX 3003 CROMEX 70802"},{"id":"f2c0ba94-b270-4b68-5242-08d5ad2bf6ba","name":"RIO SAPUCAI MIRIM ENERGIA LTDA.","commercialName":"","cnpj":"06308734000119","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"RIO SAPUCAIM 2979 PALMEIRAS (DEB) 8939 PCH.PH.SP.028800-4.01 RETIRO 890793 PCH.PH.SP.028738-5.01"},{"id":"8a0308ae-f10a-44f6-5250-08d5ad2bf6ba","name":"AMERICA ENERGIA S/A","commercialName":"AMERICA ENERGIA","cnpj":"11085823000183","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"AMERICA 2999 ANTONIO PRADO 894803 CGH.PH.MG.031618-0.01 PARDO - MG 891064 CGH.PH.MG.031249-5.01 ESPRAIADO 8776 CGH.PH.MG.030245-7.01 BREJAUBA 8948 CGH.PH.MG.030688-6.01 ALTO BREJAUBA 8949 CGH.PH.MG.030687-8.01 CGH VISTA VERDE 901920 CGH.PH.MG.031970-8.01 CGH PEDRA LAVADA 897185 CGH.PH.RJ.032035-8.01 PITANGAS 8950 CGH.PH.MG.030689-4.01 CORRENTE GRANDE 8989 CGH.PH.MG.030781-5.01 FARIAS 888149 CGH.PH.MG.030404-2.01 ANTONIO DIAS 888918 CGH.PH.MG.030954-0.01 DURANDE 890357 CGH.PH.MG.031144-8.01 VERMELHO VELHO 894322 CGH.PH.MG.031566-4.01"},{"id":"b90f69c6-2dd5-4e49-5281-08d5ad2bf6ba","name":"LIGHTCOM COMERCIALIZADORA DE ENERGIA S.A.","commercialName":"","cnpj":"11315117000180","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"LIGHTCOM 3096"},{"id":"b765a392-b174-4875-5277-08d5ad2bf6ba","name":"NOVA ENERGIA COMERCIALIZADORA S.A.","commercialName":"NOVA ENERGIA","cnpj":"11182210000164","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"NOVA ENERGIA 3076"},{"id":"00152d32-549a-4cb7-527c-08d5ad2bf6ba","name":"COMBUSTOL INDUSTRIA E COMERCIO LTDA.","commercialName":"COMBUSTOL","cnpj":"61479689000173","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"COMBUSTOL 3090 COMBUSTOL 905555"},{"id":"73192b15-f9a3-4c5c-52b6-08d5ad2bf6ba","name":"BAXTER HOSPITALAR LTDA","commercialName":"BAXTER","cnpj":"49351786000261","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"BAXTER 3255 BAXTER JURUBATUBA 71002"},{"id":"ddb3ce11-00e4-4ff6-52b9-08d5ad2bf6ba","name":"ITAU UNIBANCO S.A.","commercialName":"EST UNIF","cnpj":"60701190000104","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"ITAU CL 3258 ITAU P AMORIM RECIFE 72206 ITAU ITAIM SP 899486 ITAU FL3500 902324 ITAU - RUDGE RAMOS 906915 ITAU JD PAULISTA 898170 ITAU TEODORO 898946 ITAU MOGI MIRIM 899466 UNIBANCO EUSEBIO 7346 UNIBANCO ITM EXPO 70248 ITAU TATUAPE 71063 ITAU EDF COMERCIAL 72138 ITAU BRIGADEIRO 72146 ITAU C. EMPRESARIAL 72147 ITAU CPSA RIB PRETO 72202 ITAU 2 R. CLAUDIA 72397 ITAU RIO BRANCO 72398 ITAU J. PAULINO 72421 TAU - CTO 888453 ITAU JOAO NEGRAO CTB 906280 ITAU CAS CAMPINAS 72201 ITAU - LAPA 905528"},{"id":"69e991b5-3745-40a9-52b2-08d5ad2bf6ba","name":"EMPREENDIMENTO RAPOSO SHOPPING","commercialName":"RAPOSO SHOPPING","cnpj":"01195612000140","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"RAPOSO C 3248 RAPOSO SHOPPING 70998"},{"id":"57407e08-fc19-4be1-52ac-08d5ad2bf6ba","name":"SYKUE GERACAO DE ENERGIA LTDA.","commercialName":"","cnpj":"07777342000161","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"SYKUE 3217 SYKUE I 8718 UTE.AI.BA.029634-1.01"},{"id":"6672e2f9-7043-4ec6-52c9-08d5ad2bf6ba","name":"TERRA ENERGY COMERCIALIZADORA DE ENERGIA LTDA.","commercialName":"","cnpj":"11154502000193","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"TERRA ENERGY 3312"},{"id":"6f32db9a-5330-4d85-5291-08d5ad2bf6ba","name":"CONDOMINIO SHOPPING CIDADE JARDIM","commercialName":"","cnpj":"10739781000194","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"CIDADE JARDIM 3148 SHOPP C. JARDIM-SP 70937"},{"id":"794e1b43-b285-4904-5288-08d5ad2bf6ba","name":"CONDOMINIO COMERCIAL SHOPPING PATIO HIGIENOPOLIS","commercialName":"SHOPPING PATIO HIGIENOPOLIS","cnpj":"09101925000101","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"SHOP HIGIENOP 3113 SHOPP HIGIENOPOLIS 7895"},{"id":"e8e3ffe6-23a9-4120-528a-08d5ad2bf6ba","name":"DURATEX S.A.","commercialName":"","cnpj":"97837181001895","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"DECA MSI 3115 DECA MSIII 70863 DECA MSII 70864 DECA MSI 71151"},{"id":"ad6a5775-b34b-47ca-5299-08d5ad2bf6ba","name":"ZARAPLAST S.A","commercialName":"ZARAPLAST","cnpj":"61827663000179","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"ZARAPLAST 3169 ZARAPLAST CUMBICA 71294 ZARAPLAST-GUARULHOS 71561 ZARAPLAST -SP 70954 ZARAPLAST LAMIN-FIL 71257"},{"id":"6f6d6160-57eb-4d0a-52a3-08d5ad2bf6ba","name":"S ENERGY COMERCIALIZADORA LTDA","commercialName":"SERVICE ENERGY COMERCIALIZADORA","cnpj":"10869424000140","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"S ENERGY 3194"},{"id":"25c1dc49-9750-4b00-52a4-08d5ad2bf6ba","name":"GREIF EMBALAGENS INDUSTRIAIS DO BRASIL LTDA.","commercialName":"","cnpj":"59320820000103","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"GREIF 3197 GREIF-SP 70938 CIMPLAST 71235 GREIF LONDRINA 899610 GREIF UBERABA 899809 GREIF MARACANAU 901055 GREIF TRISURE 903494"},{"id":"0165fdf8-7a57-4ba4-515c-08d5ad2bf6ba","name":"BRASILATA S A EMBALAGENS METALICAS","commercialName":"BRASILATA","cnpj":"61160438000121","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"BRASILATA SE 2137 BRASILATA 903473 BRASILATA GO 907069"},{"id":"de825a25-8f43-4443-515f-08d5ad2bf6ba","name":"TRANSAMERICA EXPO CENTER LTDA.","commercialName":"","cnpj":"55257059000151","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"TRANS EXPO 2142 TRANSAMERICA EXPO 70504"},{"id":"b7dbfde9-0dab-49bd-5153-08d5ad2bf6ba","name":"WHEATON VRS VIDROS LTDA","commercialName":"","cnpj":"08802283000105","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"SGFRASCOS 2115 SGFRASCOS 70487"},{"id":"7ebc3ce1-769b-4607-5148-08d5ad2bf6ba","name":"SANTACONSTANCIA TECELAGEM LTDA.","commercialName":"","cnpj":"61105474000192","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"SANTACONSM 2098 SANTACONSF 71127 STA CONSTANC TECELAG 71128 F9 - SOLDADO 903630 F3 SARGENTO 903377"},{"id":"c6d7ecbf-53c7-4dc0-5138-08d5ad2bf6ba","name":"SHOPPING METRO TATUAPE","commercialName":"","cnpj":"02248827000144","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"SMT 2053 SHOP METRO TAT MTZ 70416"},{"id":"e7549ba8-f655-4125-513a-08d5ad2bf6ba","name":"P.2 - ADMINISTRACAO EM COMPLEXOS IMOBILIARIOS LTDA","commercialName":"","cnpj":"06098102000178","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"HOLIDAY 2055 HOLIDAY M RODRIGUES 70444"},{"id":"0e8e526a-0cc6-46fa-5136-08d5ad2bf6ba","name":"BEMIS DO BRASIL INDUSTRIA E COMERCIO DE EMBALAGENS LTDA.","commercialName":"","cnpj":"60394723000144","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"BEMIS DO BRASIL 2050 DIXIE-TOGA SP-LIVRE 70448 DIXIE MAUA SP 70460 DIXIE TOGA - PINHAIS 7430 DIXIE TOGA-LONDRINA 71883 BEMIS - PARANAGUA PR 907950"},{"id":"157921d6-85e1-4033-5128-08d5ad2bf6ba","name":"CONDOMINIO JARDIM ANALIA FRANCO","commercialName":"","cnpj":"03573756000118","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"SAF 2025 COND. J. A.FRANCO 70399"},{"id":"ebe17fec-c539-4ffe-5131-08d5ad2bf6ba","name":"ATENTO BRASIL S/A","commercialName":"","cnpj":"02879250000179","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"ATENTO 2042 ATENTO BARRA FUNDA 70400 ATENTO-SAO BERNARDO 70454 ATENTO REPUBLICA 70522 SAO BENTO 70527 ATENTO RIBEIRAO PRET 888468 ATENTO - BELEM 888602 ATENTO STO ANTONIO 888658 ATENTO LIBERDADE 888925 ATENTO SANTANA 889498 ATENTO SANTO ANDRE 889601 ATENTO SANTOS 900795 ATENTO GUARULHOS 901099 ATENTO - MADUREIRA 901148 ATENTO PRADO 901354 ATENTO CAMPO GRANDE 901555 ATENTO PENHA 902093 ATENTO OLIV COUTINHO 910353 ATENTO DEL CASTILHO 910360 ATENTO ZN SUL 910424 ATENTO S CAETANO SUL 910518 ATENTO URUGUAY 902773 ATENTO FEIRA DE SANT 903443"},{"id":"7b7c088e-e05e-4440-51aa-08d5ad2bf6ba","name":"CLIME TRADING COMERCIALIZADORA DE ENERGIA LTDA","commercialName":"","cnpj":"05689495000121","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"CLIME TR 2475"},{"id":"b9dc6a5f-c2f6-4320-51ab-08d5ad2bf6ba","name":"CENTRAL ELETRICA ANHANGUERA S.A.","commercialName":"","cnpj":"06308698000193","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"CELAN 2479 ANHANGUERA-GUARA-SJQ 8626 PCH.PH.SP.028734-2.01"},{"id":"66587647-c7c6-4711-51a2-08d5ad2bf6ba","name":"RAHCROL COMERCIALIZACAO DE ENERGIA EIRELI","commercialName":"","cnpj":"09222477000196","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"RAHCROL 2446"},{"id":"bdc73386-36db-4270-51a3-08d5ad2bf6ba","name":"TUPY S/A","commercialName":"","cnpj":"84683374000149","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"TUPY SA 2449 TUPY JOINVILLE 72152 TUPY FUNDICOES-MAUA 7589"},{"id":"f4831e9e-363f-4990-51a8-08d5ad2bf6ba","name":"RIO PCH I S.A.","commercialName":"","cnpj":"08656307000157","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"RIO PCH 2472 PEDRA GARRAFAO 8423 PCH.PH.ES.028805-5.01 PIRAPETINGA 8424 PCH.PH.ES.028804-7.01"},{"id":"28f2df12-5a2b-43ba-518f-08d5ad2bf6ba","name":"LOJAS RIACHUELO SA","commercialName":"LOJAS RIACHUELO","cnpj":"33200056000149","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"RIACHUELO 2373 RIACHUELO FILIAL 55 70579 RIACH FL165 VOTORANT 70580 RIACHUELO FL 52 CAMP 70581 RIACHUELO FL 49 SJRP 70582 RIACHUELO FL 2 SBC 70635 RIACHUELO C GRANDE 70677 RIACHUELO 72 DOURADO 70686 RIACHUELO 70 SHOP CG 70687 RIACHUELO - LOJA 24 894822 RIACHUELO - LOJA 35 894823 RIACHUELO - LOJA 192 894882 RIACHUELO LOJA 124 894892 RIACHUELO - LOJA 017 897192 RIACHUELO L 123 897449 RIACHUELO L 173 897450 RIACHUELO 1851799 897494 RIACHUELO 160241150 897495 RIACHUELO LJ 32 897546 RIACHUELO L 95 897726 RIACHUELO LOJA 078 897790 RIACHUELO LJ 76 898035 RIACHUELO LJ 42 898037 RIACHUELO LJ 77 898049 RIACHUELO LJ 154 898050 RIACHUELO L137 898154 RIACHUELO LJ 169 899136 RIACHUELO LOJA 029 899272 RIACHUELO LOJA 069 899693 RIACHUELO - LOJA 117 902660 RIACHUELO LOJA 115 902759 RIACHUELO LOJA 47 902774 RIACHUELO LOJA 043 904487 RIACHUELO LOJA 044 904494 RIACHUELO - LOJA 167 905679 RIACHUELO - LOJA 046 905688 RIACHUELO LOLA 155 906542 RIACHUELO - LOJA 150 906584 RIACHUELO LJ 116 908424 RIACHUELO S TACARUNA 71148 RIACHUELO LOJA 135 71250 RIACHUELO LOJA 106 71400 RIACHUELO LOJA 164 71419 RIACHUELO LOJA 161 71420 RIACHUELO L85 SLUIZ 71443 RIACHUELO 103 RECIFE 71465 RIACHUELO LOJA 108 71601 RIACHUELO LOJA 87 71607 RIACHUELO LOJA 147 71612 RIACHUELO 138 FRTLZA 71624 RIACHUELO L111 SALV 72076 RIACHUELO LOJA 83 888445 RIACHUELO LJ 146 889391 RIACHUELO LOJA 130 889809 RIACHUELO L 121 897628 RIACHUELO LOJA 139 897927 RIACHUELO LOJA 140 897946 RIACHUELO LJ 67 898032 RIACHUELO LJ 75 898034 RIACHUELO LJ 144 898036 RIACHUELO LOJA 082 899286 RCHLO LOJA 216 912319 LOJA 280 - 5965698 912352 RCHLO LOJA 134 912373 RIACH GRU 70626 RIACHUELO - FL 291 913419 RIACHUELO FILIAL 109 913497 RIACHUELO FILIAL 222 913514 RIACHUELO FIL 175 913515"},{"id":"aa091f34-c680-4ad7-5195-08d5ad2bf6ba","name":"ATACADAO S.A.","commercialName":"GRUPO CARREFOUR BRASIL","cnpj":"75315333000109","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"ATACADAO 2420 CARREFOUR AUTOCLUBE 70357 ATACADAO LJ 145 904424 ATACADAO LJ 166 904449 ATACADAO LJ 105 904450 ATACADAO LJ 71 904451 ATACADAO LJ 23 904452 ATACADAO LJ 134 904474 ATACADAO LJ 85 904478 ATACADAO LJ 139 904479 ATACADAO LJ 17 904480 ATACADAO LJ 46 904481 ATACADAO LJ 163 904482 ATACADAO LJ 143 904485 ATACADAO LJ 49 904490 ATACADAO LJ 54 904653 ATACADAO LJ 140 904710 ATACADAO LJ 92 904711 ATACADAO LJ 91 904719 ATACADAO LJ 4 904720 ATACADAO LJ32 905196 ATACADAO LJ 133 905512 ATACADAO LJ 48 905533 ATACADAO LJ 120 905534 ATACADAO LJ 6 905535 ATACADAO LJ 151 905536 ATACADAO LJ 86 905537 ATACADAO LJ 20 905542 ATACADAO LJ 35 905543 ATACADAO LJ 43 905545 ATACADAO LJ 97 905553 ATACADAO LJ 21 905554 ATACADAO LJ 57 906232 ATACADAO LJ 59 906248 ATACADAO LJ 60 906249 ATACADAO LJ 1 906253 ATACADAO LOJA 65 907288 ATACADAO LJ 61 910058 ATACADAO LOJA 8 910516 ATACADAO LJ 157 904404 ATACADAO LJ 53 905640 ATACADAO LJ 156 906323 ATACADAO LJ 78 906334 ATACADAO LJ 30 906513 ATACADAO LJ 147 906514 ATACADAO LJ 170 906575 ATACADAO LOJA 7 906955 ATACADAO LOJA 136 907289 ATACADAO LOJA 67 907361 ATACADAO LOJA 169 907494 ATACADAO LOJA 137 907760 ATACADAO LOJA 117 907761 ATACADAO LOJA 77 907764 ATACADAO LOJA 131 907765 ATACADAO LOJA 161 907766 ATACADAO LOJA 64 907787 ATACADAO LOJA 168 906516 ATACADAO LJ 172 906647 ATACADAO LOJA 135 906815 ATACADAO LJ 42 906834 ATACADAO LOJA 171 906912 ATACADAO LJ 39 906944 ATACADAO LOJA 107 906314 ATACADAO LJ 88 906389 ATACADAO LJ 122 906395 ATACADAO LOJA 123 906458 ATACADAO LOJA 75 906489 ATACADAO LOJA 132 906490 ATACADAO LJ 121 906753 ATACADAO LJ 158 907874 ATACADAO LJ 80 907875 ATACADAO LJ 82 907897"},{"id":"f9082db8-9a0d-43cc-517f-08d5ad2bf6ba","name":"CONDOMINIO SHOPPING CENTER FIESTA","commercialName":"","cnpj":"01086379000167","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"SHOP FIESTA 2210 SHOP. FIESTA 70535"},{"id":"4763cadf-d710-46a0-5185-08d5ad2bf6ba","name":"AGUA PAULISTA GERACAO DE ENERGIA LTDA.","commercialName":"","cnpj":"08930210000190","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"AG PAULISTA 545-13 2229 SALESOPOLIS 8375 PCH.PH.SP.002570-4.01 JACARE PEPIRA 8618 PCH.PH.SP.029296-6.01"},{"id":"0ddc9b77-416f-4314-516c-08d5ad2bf6ba","name":"GOIAS SUL GERACAO DE ENERGIA S.A.","commercialName":"GOIAS SUL GERACAO DE ENERGIA","cnpj":"07836421000104","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"GOIAS SUL 2165 GOIAS SUL GOIANDIRA 8736 PCH.PH.GO.028803-9.01 NOVA AURORA 8788 PCH.PH.GO.029066-1.01"},{"id":"a56a5a51-5cf1-4db1-5171-08d5ad2bf6ba","name":"CONDOMINIO SHOPPING CENTER IGUATEMI","commercialName":"SHOPPING CENTER IGUATEMI","cnpj":"53991378000160","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"IGUATEMI SP 2173 IGUATEMI SP 70517 IGUATEMI TORRE II SP 902618"},{"id":"f8757215-880b-4818-51dd-08d5ad2bf6ba","name":"MORUMBY HOTEIS LTDA","commercialName":"GRAND HYATT SAO PAULO","cnpj":"60342425000100","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"GRAND HYATT SP 2643 GRAND HYATT SP 70662"},{"id":"922e7643-5f96-46b4-51d5-08d5ad2bf6ba","name":"COSTA RICA ENERGETICA LTDA","commercialName":"COSTA RICA ENERGETICA LTDA","cnpj":"02993750000137","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"COSTA RICA I5 2612 COSTA RICA (C RICA) 8169 PCH.PH.MS.000872-9.01"},{"id":"a38e295d-aafc-4ce4-51d9-08d5ad2bf6ba","name":"BIO ENERGIAS COMERCIALIZADORA DE ENERGIA LTDA","commercialName":"","cnpj":"09571846000156","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"BIO ENERGIAS 2625"},{"id":"8269c649-34aa-40a8-51da-08d5ad2bf6ba","name":"ALCOA WORLD ALUMINA BRASIL LTDA","commercialName":"","cnpj":"06167730000168","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"AWA 2627 ALUMAR REFINA ABALCO 70614"},{"id":"f3b39be6-b421-485c-51ee-08d5ad2bf6ba","name":"USINA PAULISTA LAVRINHAS DE ENERGIA S.A.","commercialName":"","cnpj":"06976406000190","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"LAVRINHAS I5 2727 LAVRINHAS 8890 PCH.PH.SP.029114-5.01"},{"id":"25b5c98c-1bfa-4db7-51ef-08d5ad2bf6ba","name":"USINA PAULISTA QUELUZ DE ENERGIA S.A.","commercialName":"","cnpj":"06976417000170","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"QUELUZ I5 2728 QUELUZ 8884 PCH.PH.SP.029115-3.01"},{"id":"628a238f-42d3-4ece-51f3-08d5ad2bf6ba","name":"SAINT-GOBAIN DO BRASIL PRODUTOS INDUSTRIAIS E PARA CONSTRUCAO LTDA","commercialName":"","cnpj":"61064838000133","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"BRASILIT SG 2739 SGBRAS MOGI 892542 SGBRAS JUNDIAI 892547 SGBRAS CUIABA 892602 SGBRAS ARACRUZ 892722 SGBRAS QUEIMADOS 892922 SGBRAS SEROPEDICA 895663 SGBRAS ANAPOLIS I 896206 FLEXPOLIMEROS SUMARE 910311 SGBRAS PAULISTA 892262 SGBRAS ABREU E LIMA 893623 SGBRAS PACATUBA 894888 SGBRAS CAMACARI 894965 SGBRAS IBIPORA 894186 SGBRAS VIAMAO 894824 SGBRAS TUBARAO 895641 S GOBAIN BELEM 72090 SGBRAS BENEVIDES 896346 SGBRAS MATRIZ 898048 S GOBAIN BRASILIT 907160 SG CPED 908755 WEBER ITABORAI 912323"},{"id":"6a62a6bf-f448-4c0d-51f7-08d5ad2bf6ba","name":"SANTO ANTONIO ENERGIA S.A.","commercialName":"","cnpj":"09391823000160","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"SANTO ANTONIO 2746 S ANTONIO (STOANT) 8944 UHE.PH.RO.029707-0.01 S. ANTONIO EXPANSAO 894102 UHE.PH.RO.029707-0.01"},{"id":"5fa5b1bc-aca1-4ef1-51d0-08d5ad2bf6ba","name":"SAO FERNANDO ACUCAR E ALCOOL LTDA","commercialName":"","cnpj":"05894060000119","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"UTE SAO FERNAN 545-2013 2603 SAO FERNANDO 8600 UTE.AI.MS.030044-6.01"},{"id":"e138aa4f-daae-412b-51b4-08d5ad2bf6ba","name":"SANTA LUZIA ENERGETICA S/A","commercialName":"","cnpj":"08377974000109","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"CPFL SANTA LUZIA 2529 S.LUZIA ALTO 8879 PCH.PH.SC.029652-0.01"},{"id":"77d456ec-64f7-4d0f-51b1-08d5ad2bf6ba","name":"FOCUS ENERGIA LTDA","commercialName":"","cnpj":"07760179000124","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"FOCUS 2506"},{"id":"9873937b-3ae3-4fba-51bb-08d5ad2bf6ba","name":"SPE VARGINHA ENERGIA S.A.","commercialName":"","cnpj":"09119054000145","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"CPFL VARGINHA 2554 VARGINHA 8747 PCH.PH.MG.027729-0.01"},{"id":"8596aa3e-1650-4766-51bc-08d5ad2bf6ba","name":"SPE ARVOREDO ENERGIA S.A.","commercialName":"","cnpj":"09076988000147","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"CPFL ARVOREDO 2555 ARVOREDO 8670 PCH.PH.SC.028755-5.01"},{"id":"a9f720a9-0667-417b-520e-08d5ad2bf6ba","name":"ENERGYWORKS DO BRASIL LTDA","commercialName":"","cnpj":"01825701000122","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"ENERGYWORKS RC 2835 ENERGYWORKS RC 70736 ENERGYWORKS MOGI 906443 ENERGY WORKS 8269 UTE.GN.SP.028076-3.01"},{"id":"6e205967-18f4-4688-521d-08d5ad2bf6ba","name":"SPE CORRENTE GRANDE ENERGIA S.A.","commercialName":"","cnpj":"09076938000160","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"CPFL CORRENTE GRANDE 2876 CORRENTE GRANDE CPFL 8813 PCH.PH.MG.027842-4.01"},{"id":"18da9f21-8bf7-4912-521e-08d5ad2bf6ba","name":"SPE PAIOL ENERGIA S.A.","commercialName":"","cnpj":"08933597000139","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"CPFL PAIOL 2877 PAIOL 8641 PCH.PH.MG.028670-2.01"},{"id":"1de7bee4-bbe0-4e89-521f-08d5ad2bf6ba","name":"SPE BARRA DA PACIENCIA ENERGIA S.A.","commercialName":"","cnpj":"09079142000160","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"CPFL BARRA DA PACIENCIA 2878 BARRA DA PACIENCIA 8816 PCH.PH.MG.027530-1.01"},{"id":"f97c7563-9662-4cba-5220-08d5ad2bf6ba","name":"SPE NINHO DA AGUIA ENERGIA S.A.","commercialName":"","cnpj":"09079118000121","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"CPFL NINHO DA AGUIA 2880 NINHO DA AGUIA 8793 PCH.PH.MG.027576-0.01"},{"id":"c565a276-c2f4-46d7-5221-08d5ad2bf6ba","name":"SPE SAO GONCALO ENERGIA S.A.","commercialName":"","cnpj":"09076941000183","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"CPFL SAO GONCALO 2881 SAO GONCALO 8690 PCH.PH.MG.027673-1.01"},{"id":"d70011b7-6510-48cd-5222-08d5ad2bf6ba","name":"SPE VARZEA ALEGRE ENERGIA S.A.","commercialName":"","cnpj":"09079069000127","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"CPFL VARZEA ALEGRE 2882 VARZEA ALEGRE 8817 PCH.PH.MG.027572-7.01"},{"id":"9ade3436-9c85-427c-5208-08d5ad2bf6ba","name":"BAHIA PCH I S.A.","commercialName":"","cnpj":"08747075000142","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"BAHIA PCH I 2809 SITIO GRANDE 8753 PCH.PH.BA.002754-5.01"},{"id":"33ee5ec9-df78-49b1-5230-08d5ad2bf6ba","name":"COMPASS COMERCIALIZADORA DE ENERGIA LTDA","commercialName":"","cnpj":"10966735000128","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"COMPASS 2916"},{"id":"32302e0a-4c14-4a9f-523d-08d5ad2bf6ba","name":"BIOSEV S.A.","commercialName":"BIOSEV S.A.","cnpj":"15527906000136","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"LDC BIO 2962 LAGOA DA PRATA CONSU 901973 RIO BRILHANTE CONSUM 911292 PASSA TEMPO CONSUMO 913151 PASSA TEMPO 888490 UTE.AI.MS.028111-5.01 LDC BIO RIO BRILH 8470 UTE.AI.MS.029718-6.01 ESTIVAS 311 UTE.AI.RN.028660-5.01 L. DREYFUS L. PRATA 8492 UTE.AI.MG.029717-8.01 PASSA TEMPO 888490 UTE.AI.MS.028111-5.01"},{"id":"c22cacc5-45f8-4339-523e-08d5ad2bf6ba","name":"ILUMINATTI COMERCIALIZADORA DE ENERGIA ELETRICA LTDA","commercialName":"ILUMINATTI","cnpj":"10877169000188","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"ILUMINATTI 2971"},{"id":"5dc3fa66-4d68-415e-5226-08d5ad2bf6ba","name":"BAYER S.A.","commercialName":"","cnpj":"18459628000115","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"BAYER SP 2887 BAYER BELFORD ROXO 7985 BAYER S.A. 898729"},{"id":"bc9922aa-a5a3-4e15-5227-08d5ad2bf6ba","name":"ELECTRO PLASTIC LTDA.","commercialName":"","cnpj":"61421657000117","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"ELECTRO PLASTI 2888 ELECTROPLASTIC 70751 ELECTRO PLASTIC 906826"},{"id":"09e886b1-a6cd-4fbc-5229-08d5ad2bf6ba","name":"MABE BRASIL ELETRODOMESTICOS S/A EM RECUPERACAO JUDICIAL","commercialName":"","cnpj":"60736279000106","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"MABE HTL 2893 MABE HORTOLANDIA 71044 MABE CAMPINAS 70150 MABE BRASIL 896385"},{"id":"c9b55df2-d583-4a65-521b-08d5ad2bf6ba","name":"CARGILL COMERCIALIZADORA DE ENERGIA LTDA.","commercialName":"","cnpj":"08333323000109","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"CARGILL TRADE 2874"},{"id":"792ded96-7b3b-46f4-5a98-08d5ad2bf6ba","name":"MACQUARIE ENERGIA BRASIL COMERCIALIZADORA LTDA.","commercialName":"","cnpj":"22084882000153","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"MACQUARIE ENERGIA 50096"},{"id":"51c92498-8cca-40ee-5ab7-08d5ad2bf6ba","name":"T.H.R. INDUSTRIA E COMERCIO DE EMBALAGENS LTDA","commercialName":"","cnpj":"00314544000128","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"T.H.R. 50198 THR ITATIBA 897289"},{"id":"2c64860a-2d6c-4d62-5a87-08d5ad2bf6ba","name":"LOG ENERGIA COMERCIALIZADORA LTDA","commercialName":"","cnpj":"15042149000100","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"LOG ENERGIA 49994"},{"id":"bf613aec-32f9-40fb-5a8c-08d5ad2bf6ba","name":"WEENER BRASIL INDUSTRIA E COMERCIO DE EMBALAGENS PLASTICAS LTDA","commercialName":"","cnpj":"21735277000132","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"WEENER 50004 GLOBALPACK MAT 71167"},{"id":"c3f5c12a-1a17-4d25-5a89-08d5ad2bf6ba","name":"PRIME ENERGY CONSULTORIA E COMERCIO DE ENERGIA LTDA","commercialName":"PRIME ENERGY CONSULTORIA","cnpj":"17040615000144","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"PRIME ENERGY CON 49996"},{"id":"9469e8f9-b86a-4cd9-5b59-08d5ad2bf6ba","name":"HOSPITAL SANTA PAULA S/A","commercialName":"","cnpj":"60777901000116","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"HOSP STAPAULA 50619 SANTA PAULA 898246"},{"id":"8a9ac6f7-123e-4196-5b2a-08d5ad2bf6ba","name":"IREP SOCIEDADE DE ENSINO SUPERIOR, MEDIO E FUNDAMENTAL LTDA.","commercialName":"","cnpj":"02608755000107","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"ESTACIO IREP 50502 ESTACIO GILBERTO 888165 ESTACIO DE SA FRATEL 891472 ESTACIO CORPVS II 899671 ESTACIO CORPVS I 899689 ESTACIO PARANGABA 901037 ESTACIO IREP 905339 ESTACIO IREP ABADIAS 908199 ESTACIO IREP FORTALE 908388 ESTACIO MOREIRA CAMP 908655 ESTACIO FAP 1 910596"},{"id":"13ee05da-bc20-40c3-5b40-08d5ad2bf6ba","name":"BR ENERGIAS COMERCIALIZADORA DE ENERGIA EIRELI","commercialName":"","cnpj":"07416174000189","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"BR ENERGIAS 50551"},{"id":"a6f6c31e-3f80-4e4c-5b1f-08d5ad2bf6ba","name":"MART MINAS DISTRIBUICAO LTDA","commercialName":"","cnpj":"04737552000804","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"MARTMINAS 50477 LOJA 202 RIACHO 898989 LOJA 207 UBERABA 1 899070 LOJA 201 DIVINOPOLIS 899266 LOJA 211 SAO JOAQUIM 906512"},{"id":"4ce729e7-144e-4506-5b24-08d5ad2bf6ba","name":"SAO BENEDITO ENERGIAS RENOVAVEIS S.A.","commercialName":"","cnpj":"12053657000104","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"CPFL SAO BENEDITO 50495 EOL SAO BENEDITO 901418 EOL.CV.RN.031373-4.01"},{"id":"046d68de-1160-4045-5b2e-08d5ad2bf6ba","name":"CAMPOS DOS VENTOS V ENERGIAS RENOVAVEIS S.A.","commercialName":"","cnpj":"10797888000199","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"CPFL CAMPOS DOS VENTOS V 50511 CAMPO DOS VENTOS V 899527 EOL.CV.RN.031069-7.01"},{"id":"fe61dd5f-59f1-4d4c-5b2f-08d5ad2bf6ba","name":"SAO DOMINGOS ENERGIAS RENOVAVEIS S.A.","commercialName":"","cnpj":"12053825000153","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"CPFL SAO DOMINGOS 50512 SAO DOMINGOS 902814 EOL.CV.RN.032215-6.01"},{"id":"22a4a1b9-fb87-4abb-5b30-08d5ad2bf6ba","name":"CAMPO DOS VENTOS I ENERGIA RENOVAVEIS S.A.","commercialName":"","cnpj":"10797890000168","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"CPFL CAMPOS DOS VENTOS I 50513 CAMPO DOS VENTOS I 900293 EOL.CV.RN.031072-7.01"},{"id":"f7eb156b-329b-4ddd-5b31-08d5ad2bf6ba","name":"VENTOS DE SAO MARTINHO ENERGIAS RENOVAVEIS S.A.","commercialName":"","cnpj":"13330011000181","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"CPFL VENTOS DE SAO MARTINHO 50514 VENTOS SAO MARTINHO 904654 EOL.CV.RN.031412-9.01"},{"id":"be9112ff-1c26-4d20-5b32-08d5ad2bf6ba","name":"SANTA MONICA ENERGIAS RENOVAVEIS S.A.","commercialName":"","cnpj":"12053687000102","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"CPFL SANTA MONICA 50515 EOL SANTA MONICA 905804 EOL.CV.RN.031427-7.01"},{"id":"99fb1467-0f14-49d0-5b33-08d5ad2bf6ba","name":"SANTA URSULA ENERGIAS RENOVAVEIS S.A.","commercialName":"","cnpj":"12053891000123","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"CPFL SANTA URSULA 50516 EOL SANTA URSULA 905433 EOL.CV.RN.031425-0.01"},{"id":"98f6bcdc-85cc-4ffa-5b34-08d5ad2bf6ba","name":"VENTOS DE SANTO DIMAS ENERGIAS RENOVAVEIS S.A.","commercialName":"","cnpj":"13329931000180","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"CPFL VENTOS DE SANTO DIMAS 50517 VENTOS SANTO DIMAS 904173 EOL.CV.RN.031372-6.01"},{"id":"368c6b0e-deef-4e1e-5b35-08d5ad2bf6ba","name":"CAMPOS DOS VENTOS III ENERGIAS RENOVAVEIS S.A.","commercialName":"","cnpj":"10797891000102","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"CPFL CAMPOS DOS VENTOS III 50518 CAMPO DOS VENTOS III 898906 EOL.CV.RN.031071-9.01"},{"id":"e2f87958-8e9e-4327-5afd-08d5ad2bf6ba","name":"THOR COMERCIALIZADORA DE ENERGIA S.A.","commercialName":"","cnpj":"21744451000103","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"THOR COMERCIALIZADORA 50380"},{"id":"3162c146-0bf3-4c4d-5c6c-08d5ad2bf6ba","name":"PLASTIRRICO INDUSTRIA E COMERCIO LTDA","commercialName":"","cnpj":"59247502000164","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"PLASTIRRICO 51312 PLASTIRRICO 901082"},{"id":"3eb4b7d7-05a9-4311-5c3e-08d5ad2bf6ba","name":"RECKITT BENCKISER ( BRASIL ) LTDA.","commercialName":"","cnpj":"59557124000115","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"RECKITT BENCKISER 51227 RECKITT COTIA SP 899285"},{"id":"947b9398-dabe-415c-5c58-08d5ad2bf6ba","name":"SJRP IGUATEMI EMPREENDIMENTOS LTDA.","commercialName":"","cnpj":"09719913000137","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"IGUATEMI SJRP 51280 IGUATEMI SJRP 901145"},{"id":"f13b85cf-0652-466c-5c70-08d5ad2bf6ba","name":"BIOSINTETICA FARMACEUTICA LTDA","commercialName":"","cnpj":"53162095000106","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"BIOSINTETICA 51317 BIOSINTETICA 898956"},{"id":"0bfa60e8-47d4-4c40-5c76-08d5ad2bf6ba","name":"POLISOPRO EMBALAGENS LTDA","commercialName":"","cnpj":"04655413000165","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"POLISOPRO 51324 POLISOPRO EMBALAGENS 907058 POLISOPRO 898823"},{"id":"f145c89d-b129-4ed6-5c5a-08d5ad2bf6ba","name":"CONDOMINIO WTORRE JK","commercialName":"","cnpj":"10915358000106","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"SHOP JK IGUATEMI 51282 IGUATEMI JK TORRE 2 901515 IGUATEMI JK TORRE 1 901025"},{"id":"043d04e0-4700-4033-5c5b-08d5ad2bf6ba","name":"CSC 41 PARTICIPACOES LTDA.","commercialName":"","cnpj":"09631610000168","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"IGUATEMI ESPLANADA 51283 IGUATEMI ESPLANADA 2 905161 IGUATEMI ESPLANADA 1 905160"},{"id":"e81c936b-6d07-4e60-5c56-08d5ad2bf6ba","name":"FREI CANECA COMERCIAL LTDA","commercialName":"","cnpj":"04346338000150","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"SHOP FREICANECA 51267 CAG CONVENCOES 898797 FREI CANECA TEATRO 904405 FREI CANECA TS 904406 FREI CANECA PV 1 904407 202047763 - 3 PV LOJ 907837 FR CANECA 202047745 907842 202047744 - 3 PV RES 907855 ADM GERADOR 907949 FREI CANECA ADM 907969 SH FREI CANECA 2 PV 910520 SHP FREI CANECA ADM2 910607 SHOP FREI CANECA - 2 910705"},{"id":"3d96b6f3-e22c-4696-5c1b-08d5ad2bf6ba","name":"SPAL INDUSTRIA BRASILEIRA DE BEBIDAS S/A","commercialName":"SPAL","cnpj":"61186888000193","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"SPAL 51084 SPAL - UO MACRO CD 903677 SPAL JURUBATUBA 904413 SPAL UO SANTOS 906594 SPAL SUMARE 907106 SPAL - UF MARILIA 901981 SPAL - UF PORTO REAL 899323 SPAL UF CG1 899595 SPAL CG 2 899785 SPAL - UF CURITIBA 901441 SPAL - UF BH 7769 SPAL - MOGI 899596 ESTANCIA - UF MOGI 899808 SPAL MARINGA 899934 SPAL-UF SANTO ANGELO 72117"},{"id":"51b1496d-872f-4a47-5c38-08d5ad2bf6ba","name":"SIG COMBIBLOC DO BRASIL LTDA","commercialName":"","cnpj":"01861489000159","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"SIG COMBIBLOC 51195 CPO LARGO PR 1604542 901074"},{"id":"7ff39336-204d-4f53-5c39-08d5ad2bf6ba","name":"COMBIO ENERGIA S.A.","commercialName":"","cnpj":"10376555000196","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"COMBIO ENERGIA 51198 COMBIO BOITUVA SP 900018"},{"id":"f95f10c2-d401-4e38-5c36-08d5ad2bf6ba","name":"MOINHO PAULISTA SA","commercialName":"","cnpj":"33390527000129","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"MOINHO PAULISTA 51191 MOINHO PAULISTA SP 901024"},{"id":"65cd9d90-d6b5-4000-5c27-08d5ad2bf6ba","name":"ANOBRIL ANODIZACAO PINTURA E EXTRUSAO DE ALUMINIO LTDA","commercialName":"","cnpj":"54890397000163","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"ANOBRIL 51120 ANOBRIL 898261"},{"id":"9c713e5d-c6e3-4150-5c08-08d5ad2bf6ba","name":"EOLICA SERRA DAS VACAS V S.A.","commercialName":"EOLICA SERRA DAS VACAS V S.A.","cnpj":"22357375000146","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"ESV V 51041 SERRA DAS VACAS V 910191 EOL.CV.PE.032360-8.01"},{"id":"b3c57154-c632-4f10-5c09-08d5ad2bf6ba","name":"EOLICA SERRA DAS VACAS VII S/A","commercialName":"EOLICA SERRA DAS VACAS VII","cnpj":"22193319000113","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"ESV VII 51042 SERRA DAS VACAS VII 910129 EOL.CV.PE.032361-6.01"},{"id":"abeca696-542f-428a-5c17-08d5ad2bf6ba","name":"ARGON COMERCIALIZADORA DE ENERGIA LTDA","commercialName":"","cnpj":"21642355000154","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"ARGON 51080"},{"id":"66b212f8-97a3-4534-5c14-08d5ad2bf6ba","name":"HOSPITAL ALEMAO OSWALDO CRUZ","commercialName":"HOSPITAL ALEMAO OSWALDO CRUZ","cnpj":"60726502000126","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"HOSP OSWALDO CRUZ 51076 HOSP OSWALDO CRUZ 899738"},{"id":"a7c7c45c-376d-477c-5bb3-08d5ad2bf6ba","name":"EDIFICIO JK 1455","commercialName":"CONDOMINIO EDIFICIO JK 1455","cnpj":"09664106000164","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"JK 1455 50867 EDIFICIO JK 1455 905838"},{"id":"287ee3d4-40c1-4153-5bb4-08d5ad2bf6ba","name":"CONDOMINIO EDIFICIO FARIA LIMA FINANCIAL CENTER","commercialName":"EDIFICIO FARIA LIMA FINANCIAL CENTER","cnpj":"05778098000126","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"FINANCIAL CENTER 50868 COND FARIA LIMA 898185"},{"id":"469be37b-b3f0-4de5-5bbb-08d5ad2bf6ba","name":"CONDOMINIO MORUMBI CORPORATE TOWERS","commercialName":"","cnpj":"19328990000110","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"MORUMBI CORPORATE 50877 MORUMBI TORRE A 899176 MORUMBI TORRE B 899177 MORUMBI ADM 899179"},{"id":"08993bdb-44d6-40a3-5bb7-08d5ad2bf6ba","name":"ARENA FUNDO DE INVESTIMENTO IMOBILIARIO - FII","commercialName":"","cnpj":"14149745000121","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"ARENA CORINTHIANS 50871 ARENA CORINTHIANS 898063"},{"id":"58dd0143-075c-4e92-5be6-08d5ad2bf6ba","name":"ASSOCIACAO DO SHOPPING LIGHT","commercialName":"ASSOCIACAO DO SHOPPING LIGHT","cnpj":"23537156000101","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"SHOPPING LIGHT 50977 ASSOCIACAO SHP LIGHT 70573"},{"id":"d5318842-9a2d-4fa4-5be8-08d5ad2bf6ba","name":"ALPARGATAS S.A.","commercialName":"","cnpj":"61079117000105","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"ALPARGATAS 50979 ALPARGATAS - CARPINA 898728 ALPARGATAS CAMPINA G 904678 ALPARGATAS CAMPINA 2 905041 ALPARGATAS STA RITA 906892 ALPARGATAS MONTES CL 906215"},{"id":"b02c3f47-dc7d-4a0d-5bdf-08d5ad2bf6ba","name":"UNIAO BRASILEIRA DE VIDROS S.A.","commercialName":"","cnpj":"60837689000135","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"UBV 50956 UBV - SP 899784"},{"id":"d8913665-6fb4-4b8a-5b9d-08d5ad2bf6ba","name":"EATALY BRASIL COMERCIO E DISTRIBUICAO DE ALIMENTOS LTDA","commercialName":"","cnpj":"15504701000135","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"EATALY 50788 EATALY 899305"},{"id":"6d24a130-90ef-4d3d-5b9f-08d5ad2bf6ba","name":"EDP PEQUENAS CENTRAIS HIDROELETRICAS S.A.","commercialName":"","cnpj":"21813271000136","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"EDP PCH 50791 BICAME 8002 PCH.PH.ES.000261-5.01 JUCU 500 PCH.PH.ES.001272-6.01 SUICA 501 UHE.PH.ES.002781-2.01 FRUTEIRAS 502 PCH.PH.ES.000999-7.01 RIO BONITO 508 PCH.PH.ES.002293-4.02 ALEGRE CASTELO 8047 PCH.PH.ES.000048-5.01 SAO JOAO 8228 PCH.PH.ES.026834-8.01"},{"id":"9e4507d9-f0c7-427e-5bab-08d5ad2bf6ba","name":"EDIFICIO FARIA LIMA SQUARE","commercialName":"","cnpj":"08333582000130","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"FARIA LIMA SQUARE 50821 FARIA LIMA SQUARE 64 898249 FARIA LIMA SQUARE 62 898269"},{"id":"205ad11a-f3e4-427a-5b85-08d5ad2bf6ba","name":"MAKRO ATACADISTA SOCIEDADE ANONIMA","commercialName":"","cnpj":"47427653000115","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"MAKRO ATACADISTA 50750 MAKRO L02 898288 MAKRO L49 898289 MAKRO L01 898306 MAKRO L10 898308 MAKRO L27 898309 MAKRO L51 898311 MAKRO LOJA 43 898366 MAKRO L06 898426 MAKRO L37 898427 MAKRO L71 898486 MAKRO L11 898506 MAKRO L40 898583 MAKRO L81 898586 MAKRO L69 898673 MAKRO L21 898689 MAKRO L26 898766 MAKRO L17 SP 898847 MAKRO L09 898966 MAKRO L30 898994 MAKRO L16 899047 MAKRO L22 899048 MAKRO L12 899049 MAKRO L79 899050 MAKRO L65 899054 MAKRO L72 899057 MAKRO L84 899060 MAKRO L60 899067 MAKRO L66 899068 MAKRO L15 899072 MAKRO L82 899074 MAKRO L58 899113 MAKRO L86 899129 MAKRO L67 899130 MAKRO L18 899131 MAKRO L70 899609 MAKRO L28 899754 MAKRO L83 899755 MAKRO L08 899756 MAKRO L59 899759 MAKRO L62 899760 MAKRO L23 899771 MAKRO L46 899772 MAKRO L41 899773 MAKRO L20 900871 MAKRO L68 900872 MAKRO L24 900875 MAKRO L35 900876 MAKRO L42 900933 MAKRO L57 901071 MAKRO L61 901113 MAKRO L38 901253 MAKRO L25 901356 MAKRO L64 901451 MAKRO L47 901619 MAKRO L32 901675 MAKRO L07 901694 MAKRO LOJA 80 901974 MAKRO L55 902953 MAKRO L36 903621 MAKRO L53 903917 MAKRO L29 904174 MAKRO L45 904488 MAKRO L63 904501 MAKRO L39 904874 MAKRO L19 905257 MAKRO L52 905379 MAKRO L05 905503 MAKRO L04 905665 MAKRO L44 905702 MAKRO LOJA 73 906134 MAKRO LOJA 33 906378 MAKRO L34 907047 MAKRO LOJA 48 907719 MAKRO LOJA 13 908380 MAKRO LOJA 56 908381"},{"id":"464592cc-1996-4e91-5860-08d5ad2bf6ba","name":"EMPRESA CATARINENSE DE SUPERMERCADOS LTDA.","commercialName":"","cnpj":"07751607000152","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"EMPRESA CATARINENSE 11569 UC 24702707 894242 UC 32476589 894743 UC 2764310 896064 UC 4688428 896084 UC 3213309 896086 E CATARINENSE ITAJAI 909645"},{"id":"3d4b4dd2-fc3c-4ce5-5838-08d5ad2bf6ba","name":"TRINITY COMERCIALIZADORA DE ENERGIA ELETRICA LTDA","commercialName":"","cnpj":"17077752000153","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"TRINITY ENERGIA 11051"},{"id":"704d1c0a-f291-4f49-57fd-08d5ad2bf6ba","name":"CAPRICORNIO TEXTIL S.A","commercialName":"","cnpj":"60745411000138","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"CAPRICORNIO 10332 CAPRICORNIO S CARLOS 889239 CAPRICORNIO II 899077 CAPRICORNIO BRAGANCA 900382"},{"id":"95089da3-6636-49d2-5810-08d5ad2bf6ba","name":"ABRIL COMUNICACOES S.A.","commercialName":"","cnpj":"44597052007922","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"ABRILCOM 10549 EDITORA ABRIL-SP 7811"},{"id":"459eac13-490b-4feb-580d-08d5ad2bf6ba","name":"SANTA ROSA EMBALAGENS FLEXIVEIS LTDA","commercialName":"SANTA ROSA","cnpj":"60570884000141","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"SANTA ROSA EMB 10510 STA ROSA EMBALAGENS 889539"},{"id":"046fadc0-6dc6-404d-5804-08d5ad2bf6ba","name":"NEXT ENERGIA COMERCIALIZADORA LTDA","commercialName":"","cnpj":"17141651000102","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"NEXTCOM 10429"},{"id":"c78cb9e9-4918-4ae5-5808-08d5ad2bf6ba","name":"CONDOMINIO EDIFICIO JK FINANCIAL CENTER","commercialName":"CONDOMINIO JK FINANCIAL CENTER","cnpj":"03800330000150","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"CONDOMINIO JK FINANCIAL CENTER 10451 CONDOMINIO JKFC 889523"},{"id":"cfe06548-42d0-442c-581d-08d5ad2bf6ba","name":"CONDOMINIO CENTRO EMPRESARIAL DE SAO PAULO","commercialName":"","cnpj":"53820585000152","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"CENESP 10750 CENESP C EMPRESARIAL 889825"},{"id":"234b19b1-247e-4abf-5819-08d5ad2bf6ba","name":"CONDOMINIO DO SHOPPING CENTER MORUMBI","commercialName":"","cnpj":"53825121000139","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"MORUMBISHOPPING 10689 MORUMBI SHOPPING ADM 889558"},{"id":"6eb2211d-7901-433b-581a-08d5ad2bf6ba","name":"D' ENERGY COMERCIALIZADORA DE ENERGIA LTDA","commercialName":"","cnpj":"16950956000194","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"D ENERGY 10690"},{"id":"6f91a2e9-ce0d-4082-5816-08d5ad2bf6ba","name":"RENOVA COMERCIALIZADORA DE ENERGIA S.A.","commercialName":"","cnpj":"17204923000168","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"RENOVA COM 10629"},{"id":"57760271-7257-4253-5814-08d5ad2bf6ba","name":"CONDOMINIO BOAVISTA SHOPPING","commercialName":"","cnpj":"06261948000187","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"SHOP BOAVISTA 10590 SHOP.BOA VISTA 889541"},{"id":"5b4403d8-d724-4646-5827-08d5ad2bf6ba","name":"AVON INDUSTRIAL LTDA","commercialName":"","cnpj":"00680516000124","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"AVON 10849 AVON INTERLAGOS 889633"},{"id":"c9ad6ea3-d87c-4282-5828-08d5ad2bf6ba","name":"EBS SUPERMERCADOS LTDA.","commercialName":"","cnpj":"07751593000177","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"EBS SUPERMERCADOS 10889 EBS CEARA CMP GRD MS 889976 EBS MASCA CMP GRD MS 889978 EBS EDELZAHR CPGD MS 889979 EBS RUBENS M 890358"},{"id":"e9034434-f7ac-4fc4-5831-08d5ad2bf6ba","name":"MARISA LOJAS S.A.","commercialName":"LOJAS MARISA","cnpj":"61189288000189","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"MARISA 10969 MARISA M625 891642 MARISA M652 891662 MARISA M635 891684 MARISA VENDA NOVA 899669 MARISA M692 892545 MARISA MADUREIRA 893683 MARISA M571 - BANGU 894163 MARISA M597 - IGUACU 894264 MARISA ITABORAI 896687 MARISA M039 DUQUE CX 906632 MARISA CHAPECO 891925 MARISA TUBARAO 891942 MARISA SC M594 895150 MARISA M603 902613 MARISA BARRA FUNDA 892402 MARISA SANTO AMARO 892403 MARISA M520 - MAUA 892404 MARISA M546 DEODORO 892405 MARISA M626 ITAQUERA 892406 MARISA M586 TATUAPE 892523 MARISA M797 904675 MARISA M662 - LAPA 904753 MARISA M510 ARICANDU 905858 MARISA INTERLAG M133 909400 MARISA M512 892522 MARISA VARZEA GRANDE 897606 MARISA M551 899678 MARISA CAMPINAS M576 898290 MARISA M537 SANTOS 905758 MARISA M503 - SANTOS 905769 MARISA SAO VICENTE 906271 MARISA ITAQUQ 897304 MARISA M608 TAUBATE 903879 MARISA M882 904819 MARISA M864 899695 MARISA MESTRE ALVARO 897649 MARISA M946 899066 MARISA M916 SH VILA 901274 MARISA M708 VITORIA 903901 MARISA M697 892603"},{"id":"774efad1-8f4f-4ede-5832-08d5ad2bf6ba","name":"CONDOMINIO SHOPPING CENTER PENHA","commercialName":"SHOPPING CENTER PENHA","cnpj":"67969964000113","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"SHOP PENHA 10989 SHOP PENHA PRINCIPAL 889642 SHOP PENHA EXPANSAO 889643"},{"id":"eaaf0806-3b0a-4fc4-58b8-08d5ad2bf6ba","name":"UNIPAR CARBOCLORO S.A.","commercialName":"","cnpj":"33958695000178","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"UNIPAR CARBOCLORO 13012 CARBOCLORO-CUBATAO 7488"},{"id":"80a579f3-bcf1-469f-589b-08d5ad2bf6ba","name":"DELTA TRADING COMERCIALIZADORA DE ENERGIA LTDA.","commercialName":"","cnpj":"17386017000121","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"DELTA TRADING ENERGIA 12712"},{"id":"8871529b-9272-4ba8-589c-08d5ad2bf6ba","name":"BETA COMERCIALIZADORA DE ENERGIA S.A.","commercialName":"","cnpj":"17431261000169","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"BETA ENERGIA 12713"},{"id":"47dd2e9c-119d-4c45-5882-08d5ad2bf6ba","name":"IPCOM COMERCIALIZADORA DE ENERGIA LTDA","commercialName":"IPCOM ENERGIA","cnpj":"17509190000170","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"IPCOM 12094"},{"id":"37f9e5fd-9907-4529-5887-08d5ad2bf6ba","name":"MOMENTA FARMACEUTICA LTDA.","commercialName":"","cnpj":"14806008000154","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"MOMENTA ESPECIAL 12232 MOMENTA ESPECIAL SP 70327"},{"id":"927a9929-a10e-4836-588c-08d5ad2bf6ba","name":"COMPASS GERACAO LTDA","commercialName":"","cnpj":"18416364000112","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"COMPASS GERACAO 12372"},{"id":"0fbdc63b-3cec-437a-5891-08d5ad2bf6ba","name":"SAO JOAO ENERGIA LTDA.","commercialName":"","cnpj":"17309729000147","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"SAO JOAO ENERGIA 12452 SAO JOAO I 470 CGH.PH.MS.026842-9.01 SAO JOAO II 471 CGH.PH.MS.027184-5.01"},{"id":"5959ed02-0cf7-4c14-5895-08d5ad2bf6ba","name":"3G - TERCEIRA GERACAO COMERCIALIZADORA DE ENERGIA LTDA","commercialName":"3G ENERGIA","cnpj":"17838938000188","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"3G ENERGIA 12532"},{"id":"23ecbdff-418a-417c-5896-08d5ad2bf6ba","name":"EXPK INDUSTRIA E COMERCIO DE EMBALAGENS LTDA","commercialName":"EXTRUSA-PACK","cnpj":"17104971000184","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"EXPK 12552 EXPK 71368"},{"id":"3051a318-166e-455f-58db-08d5ad2bf6ba","name":"ALUPAR INVESTIMENTO S.A.","commercialName":"","cnpj":"08364948000138","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"ALUPAR 13413"},{"id":"0da73f5c-e95e-4845-58d9-08d5ad2bf6ba","name":"JBS AVES LTDA.","commercialName":"JBS FRANGOSUL","cnpj":"08199996000118","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"JBS AVES 13396 JBS AVES N VENEZA 70933 JBS AVES MULITERNO 70152 JBS AVES RIO GRANDE 70153 FRINAL FRIGORIFICO 71088 JBS AVES NOVA BASSAN 901813 JBS MONT RACOES 905724 JBS CAXIAS DO SUL 908638 JBS SN CAXIAS DO SUL 909205 JBS MONTENEGRO INCUB 909459 JBS AVES CAARAPO 70249 JBS AVES-RAC-CAARAPO 910676 JBS AVES -MONTENEGRO 897486 FRINAL 2 890688"},{"id":"b4c077b2-3bf4-4b3d-590f-08d5ad2bf6ba","name":"MATRIX COMERCIALIZADORA DE ENERGIA ELETRICA S/A","commercialName":"","cnpj":"17858631000149","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"MATRIX COM 13653"},{"id":"789b6c09-617e-4c99-590b-08d5ad2bf6ba","name":"QUEIROZ GALVAO COMERCIALIZADORA DE ENERGIA LTDA","commercialName":"QUEIROZ GALVAO ENERGIA","cnpj":"11820864000176","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"QUEIROZ GALVAO ENERGIA 13633"},{"id":"80174e90-d631-4aba-590c-08d5ad2bf6ba","name":"ENERSEA COMERCIALIZADORA DE ENERGIA LTDA","commercialName":"ENERSEA","cnpj":"18912993000133","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"ENERSEA 13634"},{"id":"5152a98a-6a87-4f8d-58df-08d5ad2bf6ba","name":"VENTOS DE SANTA JOANA IX ENERGIAS RENOVAVEIS S.A.","commercialName":"VENTOS DE SANTA JOANA IX ENERGIAS RENOVAVEIS S.A.","cnpj":"19082784000172","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"SANTAJOANA IX 13455 SANTA JOANA IX 896344 EOL.CV.PI.031417-0.01"},{"id":"af256f83-0490-443f-58e0-08d5ad2bf6ba","name":"VENTOS DE SANTA JOANA X ENERGIAS RENOVAVEIS S.A.","commercialName":"VENTOS DE SANTA JOANA X ENERGIAS RENOVAVEIS S.A.","cnpj":"19082754000166","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"SANTAJOANA X 13456 VENTOS STA JOANA X 895942 EOL.CV.PI.031393-9.01"},{"id":"5f8605b1-b189-4045-58e1-08d5ad2bf6ba","name":"VENTOS DE SANTA JOANA XI ENERGIAS RENOVAVEIS S.A.","commercialName":"VENTOS DE SANTA JOANA XI ENERGIAS RENOVAVEIS S.A.","cnpj":"19082675000155","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"SANTAJOANA XI 13457 SANTA JOANA XI 896044 EOL.CV.PI.031388-2.01"},{"id":"f23a66fb-80b9-439c-58e2-08d5ad2bf6ba","name":"VENTOS DE SANTA JOANA XII ENERGIAS RENOVAVEIS S.A.","commercialName":"VENTOS DE SANTA JOANA ENERGIAS RENOVAVEIS S.A","cnpj":"19082701000145","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"SANTAJOANA XII 13458 SANTA JOANA XII 896025 EOL.CV.PI.031414-5.01"},{"id":"9d898c2d-7d64-4645-58e3-08d5ad2bf6ba","name":"VENTOS DE SANTA JOANA XIII ENERGIAS RENOVAVEIS S.A.","commercialName":"VENTOS DE SANTA JOANA XIII ENERGIAS RENOVAVEIS S.A.","cnpj":"19082800000127","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"SANTAJOANA XIII 13459 VENTOS ST JOANA XIII 896026 EOL.CV.PI.031394-7.01"},{"id":"0aed3423-3b7f-431f-58e4-08d5ad2bf6ba","name":"VENTOS DE SANTA JOANA XV ENERGIAS RENOVAVEIS S.A.","commercialName":"VENTOS DE SANTA JOANA XV ENERGIAS RENOVAVEIS S.A.","cnpj":"19082728000138","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"SANTAJOANA XV 13460 SANTA JOANA XV 896087 EOL.CV.PI.031416-1.01"},{"id":"4898c7bd-55b8-4c39-58e5-08d5ad2bf6ba","name":"VENTOS DE SANTA JOANA XVI ENERGIAS RENOVAVEIS S.A.","commercialName":"VENTOS DE SANTA JOANA XVI ENERGIAS RENOVAVEIS S.A.","cnpj":"19082822000197","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"SANTAJOANA XVI 13461 SANTA JOANA XVI 896089 EOL.CV.PI.031392-0.01"},{"id":"36417aed-4f6a-425c-5a1c-08d5ad2bf6ba","name":"UTE IGUACU BORJA ENERGETICA LTDA","commercialName":"","cnpj":"10348446000165","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"UTE IGUACU BORJA 16527 SAO BORJA 8832 UTE.AI.RS.029583-3.01"},{"id":"dd776086-7042-4691-5a16-08d5ad2bf6ba","name":"ACAPURANA PARTICIPACOES S.A.","commercialName":"","cnpj":"08281830000227","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"ACAPURANA 16455 SHOP SANTANA 70767"},{"id":"bd26bb8e-9299-495d-5a09-08d5ad2bf6ba","name":"VALORA ENERGIA LTDA.","commercialName":"VALORA ENERGIA","cnpj":"21265165000165","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"VALORA 16383"},{"id":"2acdd230-628c-44e6-5a05-08d5ad2bf6ba","name":"FC ONE ENERGIA LTDA","commercialName":"","cnpj":"21005308000108","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"FC ONE 16377"},{"id":"3f6e1990-8458-449c-59fa-08d5ad2bf6ba","name":"MAN LATIN AMERICA INDUSTRIA E COMERCIO DE VEICULOS LTDA","commercialName":"","cnpj":"06020318000110","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"MAN LTDA 16215 MAN RESENDE 7292"},{"id":"a4bd268c-4105-4605-59ef-08d5ad2bf6ba","name":"TESLA COMERCIALIZADORA DE ENERGIA LTDA","commercialName":"TESLA COMERCIALIZADORA DE ENERGIA","cnpj":"20726794000182","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"TESLACOM 16015"},{"id":"3016a879-6cee-41e6-59b1-08d5ad2bf6ba","name":"PEDRA CHEIROSA I ENERGIA S.A.","commercialName":"","cnpj":"10883378000134","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"CPFL PEDRA CHEIROSA 15375 PEDRA CHEIROSA 1 909391 EOL.CV.CE.031736-5.01"},{"id":"1c3ef9de-580d-4cd0-59b2-08d5ad2bf6ba","name":"PEDRA CHEIROSA II ENERGIA S.A.","commercialName":"","cnpj":"10883587000188","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"CPFL PEDRA CHEIROSA II 15376 PEDRA CHEIROSA 2 909379 EOL.CV.CE.031698-9.01"},{"id":"ecfb067a-2683-472a-59c9-08d5ad2bf6ba","name":"ADN BIOENERGY COMERCIALIZADORA LTDA.","commercialName":"","cnpj":"20591154000102","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"ADN ENERGIA 15595"},{"id":"ad9d019f-00fe-4aff-59b9-08d5ad2bf6ba","name":"PAULISTA COMERCIALIZADORA DE ENERGIA LTDA","commercialName":"BLUE ENERGY SERVICE LTDA","cnpj":"15732189000184","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"PAULISTA ENERGIA 15438"},{"id":"98cc82ef-103f-425a-5932-08d5ad2bf6ba","name":"OWENS-ILLINOIS DO BRASIL INDUSTRIA E COMERCIO LTDA","commercialName":"","cnpj":"08910541000169","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"OWENS ILLINOIS 14055 CISPER-AV. O. ARANHA 7018 OI-RJ 70865 OWENS RECIFE 7352 CIV-VIT SANTO ANTAO 71307"},{"id":"e4a78936-ac1d-43c2-5948-08d5ad2bf6ba","name":"VENTOS DE SANTO AUGUSTO V ENERGIAS RENOVAVEIS S.A","commercialName":"","cnpj":"17875427000136","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"SANTOAUGUSTO V 14226 EOL SANTO AUGUSTO V 896952 EOL.CV.PI.031661-0.01"},{"id":"8a2554c7-3352-4210-5946-08d5ad2bf6ba","name":"VENTOS DE SANTO AUGUSTO III ENERGIAS RENOVAVEIS S.A","commercialName":"","cnpj":"17875483000170","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"SANTOAUGUSTO III 14224 EOL SANTO AUGUSTO 3 896951 EOL.CV.PI.031662-8.01"},{"id":"ec30d912-a933-48cb-593d-08d5ad2bf6ba","name":"EOLICA SERRA DAS VACAS I S.A.","commercialName":"","cnpj":"18127269000107","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"SDV I 14215 SERRA DAS VACAS 1 896942 EOL.CV.PE.031537-0.01"},{"id":"f409131e-8f50-4bb5-593e-08d5ad2bf6ba","name":"EOLICA SERRA DAS VACAS II S.A.","commercialName":"","cnpj":"19224741000184","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"SDV II 14216 SERRA DAS VACAS 2 896941 EOL.CV.PE.031540-0.01"},{"id":"14fc26ea-93ac-4da3-593f-08d5ad2bf6ba","name":"EOLICA SERRA DAS VACAS III S.A.","commercialName":"","cnpj":"19694110000129","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"SDV III 14217 SERRA DAS VACAS 3 896940 EOL.CV.PE.031560-5.01"},{"id":"296738aa-d9bb-4f1f-5940-08d5ad2bf6ba","name":"EOLICA SERRA DAS VACAS IV S.A.","commercialName":"","cnpj":"19694146000102","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"SDV IV 14218 SERRA DAS VACAS 4 896943 EOL.CV.PE.031574-5.01"},{"id":"89733216-25d0-4833-597c-08d5ad2bf6ba","name":"CENTRAL EOLICA JAU S.A.","commercialName":"CENTRAL EOLICA JAU","cnpj":"17227909000180","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"EOLICA JAU 14595 EOL AROEIRA 908867 EOL.CV.RN.031801-9.01 JERICO 909109 EOL.CV.RN.031802-7.01 UMBUZEIROS 909110 EOL.CV.RN.031826-4.01"},{"id":"ddb85e9a-a1c0-4d98-597a-08d5ad2bf6ba","name":"PORTO DO DELTA ENERGIA S.A.","commercialName":"","cnpj":"09438017000108","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"PDEE 14561 EOL PORTO DO DELTA 905213 EOL.CV.PI.030639-8.01"},{"id":"a2e09619-6c3c-4513-5972-08d5ad2bf6ba","name":"CENTRAL EOLICA AVENTURA I S.A","commercialName":"","cnpj":"19980957000170","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"EOLICA AVENTURA I 14538 AVENTURA I 911051 EOL.CV.RN.031887-6.01"},{"id":"63ab5eff-17d6-4ccf-59a5-08d5ad2bf6ba","name":"ECOGEN BRASIL SOLUCOES ENERGETICAS S.A.","commercialName":"","cnpj":"05401842000179","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"ECOGEN 15301 UTE LEVORIN 907003 UTE.GN.SP.030197-3.01"},{"id":"56efb5fd-49db-49fe-599a-08d5ad2bf6ba","name":"AMBEV S.A.","commercialName":"","cnpj":"07526557000100","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"AMBEV SA 15095 AMBEV JACAREI 7083 ETC AMBEV JUNDIAI 7254 AMBEV-JAGUARIUNA-SP 7564 AMBEV CAMPO GDE 70408 AMBEV VIDROS 70497 AMBEV AGUDOS 71072 AMBEV-PIRAI RJ 71806 AMBEV CONTAGEM 71201 AMBEV NAVEGANTES 7548 AMBEV-VIAMAO-RS 7550 AMBEV-SAPUCAIA-RS 7557 AMBEV-LAGES-SC 70017 AMBEV EQUATORIAL 72379 AMBEV-JUATUBA-MG 70162 AMBEV SETE LAGOAS 70725 AMBEV UBERLANDIA 911393 AMBEV AQUIRAZ 907321 AMBEV PONTA GROSSA 913413"},{"id":"1a62e0eb-8a5d-4bb0-5992-08d5ad2bf6ba","name":"GALICIA DESENVOLVIMENTO IMOBILIARIO LTDA.","commercialName":"","cnpj":"08081619000180","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"GALICIA 14917 GALICIA 7981 GALICIA - VGP - SP 70576"},{"id":"788e7d8d-59f3-4d38-5f53-08d5ad2bf6ba","name":"SYNGENTA PROTECAO DE CULTIVOS LTDA","commercialName":"","cnpj":"60744463000190","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"SYNGENTA PROT 52903 SYNGENTA - PAULINIA 72100 SYNGENTA FORMOSA 897687 SYNGENTA MATAO 899948 SYNGENTA ITAPOLIS 900523 SYNGENTA - ITUIUTABA 901036"},{"id":"580e9086-9f0a-4deb-5f5b-08d5ad2bf6ba","name":"PADO S A INDUSTRIAL COMERCIAL E IMPORTADORA","commercialName":"PADO S A","cnpj":"61144150000163","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"PADO 52911 PADO CAMBE 903935"},{"id":"a52f8677-0fe7-4910-5f57-08d5ad2bf6ba","name":"ALPES INDUSTRIA E COMERCIO DE PLASTICOS LTDA","commercialName":"","cnpj":"02877500000131","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"ALPES 52907 ALPES 901796"},{"id":"e7610505-2a1e-4609-5f2d-08d5ad2bf6ba","name":"LIBRA COMERCIALIZADORA DE ENERGIA LTDA.","commercialName":"","cnpj":"20557422000170","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"LIBRA ENERGIA 52832"},{"id":"d328c31e-8e71-4ca6-5f19-08d5ad2bf6ba","name":"UNIVERSO ONLINE S/A","commercialName":"","cnpj":"01109184000195","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"UOL 52735 UOL 903760"},{"id":"1e88dd92-c3eb-4533-5f1a-08d5ad2bf6ba","name":"ABB LTDA","commercialName":"ADMINISTRACAO CENTRAL","cnpj":"61074829000123","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"ABB 52737 ABB GRU150387487 903734 ABB CITY AMERICA 903816 ABB SOROCABA 903820 ABB BLUMENAU 908360 ABB CECAP 904398"},{"id":"20f0d782-5c83-4b93-5f08-08d5ad2bf6ba","name":"ANGELO AURICCHIO COMPANHIA LTDA","commercialName":"PRODUTOS OLE","cnpj":"62598586000195","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"CONSERVAS OLE 52713 CONSERVAS OLE MORRIN 901438"},{"id":"eed614c7-2f6b-4cc5-5f14-08d5ad2bf6ba","name":"NOVALATA BENEFICIAMENTO E COMERCIO DE EMBALAGENS - EIRELI","commercialName":"NOVALATA","cnpj":"74396318000170","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"NOVALATA 52726 NOVALATA MATRIZ 900738 NOVALATA FILIAL 901041"},{"id":"e4c833db-6f88-4c38-5ef5-08d5ad2bf6ba","name":"LOUIS DREYFUS COMPANY BRASIL S.A.","commercialName":"LOUIS DREYFUS COMPANY BRASIL","cnpj":"47067525000108","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"LDC BRASIL 52630 LDC PARAGUACU 898698 LDC BRASIL PONTA 898967 LDC BRASIL RIO VERDE 904698 LDC BRASIL JATAI 904704 LDC PARANA 898699 LDC APUCARANA II 899219 LDC APUCARANA III 899218 LDC APUCARANA 899274 LDC BRASIL - APUCARA 899608 LDC ITUMBIARA 908057"},{"id":"d496e9d4-23b3-4474-5ee3-08d5ad2bf6ba","name":"BJL11 SOLAR S.A.","commercialName":"BJL11 SOLAR","cnpj":"23932419000187","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"BJL11 SOLAR 52601 BJL 11 909768 UFV.RS.BA.034153-3.01"},{"id":"2b945b4c-fec3-4d6c-5f6a-08d5ad2bf6ba","name":"EMBALATEC INDUSTRIAL LTDA","commercialName":"EMBALATEC","cnpj":"69020915000165","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"EMBALATEC 52933 EMBALATEC ITARARE 899995 EMBALATEC SALTO 900333 EMBALATEC MOGI 902273"},{"id":"2c5412fb-186b-4e2f-5f6e-08d5ad2bf6ba","name":"MOINHO DE TRIGO CORINA LTDA.","commercialName":"","cnpj":"08158596000164","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"CORINA 52955 CORINA 902330"},{"id":"9f96206f-b61b-48c3-5f6f-08d5ad2bf6ba","name":"ETERNIT S A","commercialName":"ETERNIT","cnpj":"61092037000181","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"ETERNIT SA 52956 ETERNIT GOIANIA 903103 ETERNIT RJ 906925 ETERNIT COLOMBO 903918"},{"id":"33738ba2-2fcf-43a4-5f8b-08d5ad2bf6ba","name":"BIMBO DO BRASIL LTDA","commercialName":"","cnpj":"35402759000185","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"BIMBO 53017 BIMBO DO BRASIL 903414 BIMBO MOGI DAS CRUZE 904476"},{"id":"b470963c-8635-4cea-5f8f-08d5ad2bf6ba","name":"CLARO S.A.","commercialName":"CLARO","cnpj":"40432544000147","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"CLARO 53022 CLARO MORUMBI 902325 CLARO AMADOR 902373 CLARO LARANJAL PTA 902695 CLARO KENKITI 902764 CLARO COSTA GOMES 902765 CLARO GRAJAU 902766 CLARO GOYTACAZES 902767 CLARO EMILIO MALLET 902768 CLARO CONS RAMALHO 902793 CLARO R VARZEA 902794 CLARO JOSE CABALLERO 902795 CLARO ESE ITAPORANGA 902833 CLARO MANOEL COIMBRA 903379 CLARO CPFL NACOES 903393 CLARO MIRANDA 903459 CLARO TIBIRICA 903460 CLARO WASHINGTON LUI 903462 CLARO JOSE MENEGHEL 903513 CLARO PENHA 903533 CLARO MARECHAL 903640 CLARO BERNARDINO 903653 CLARO XV DE NOVEMBRO 903674 CLARO 15 DE NOVEMBRO 903754 CLARO ENG AFONSO 903755 CLARO MARECHAL FLORI 903773 CLARO SILVEIRO 903774 CLARO JERONIMO MONTE 903799 CLARO - CEMAR - 485 903841 CLARO CARLOS OLAVO 903857 CLARO HUMBERTO I 903858 CLARO CORREA LIMA 903913 CLARO RUI BARBOSA 903933 CLARO PONTES VIEIRA 903934 CLARO GUTEMBERG 903939 CLARO AME BELEM 903978 CLARO PERNAMBUCO 904034 CLARO P.OLIVEIRA 904038 CLARO JOAQUIM NABUCO 904041 CLARO ALTINO SERBETO 904042 CLARO UBERLANDIA 904043 CLARO FARMACEUTICO 904044 CLARO RIO BRANCO 904055 CLARO MAURO 904056 CLARO FARQUAR 904057 CLARO ALDO AZEVEDO 904276 CLARO RUA DO CARRO 904466 CLARO PROF LYCIO 904470 CLARO GABRIEL DE LAR 904471 CLARO - FIDELIS REIS 904493 CLARO - TANGUA 904498 CLARO MARIA CAROLINA 904586 CLARO 24 DE AGOSTO 904587 CLARO AGAMENON 904593 CLARO SAO FRANCISCO 904724 CLARO MANOEL RIBAS 904725 CLARO LIVRAMENTO 904738 CLARO VARGAS 980 904740 CLARO PARANA 904741 CLARO JUIZ DE FORA 904742 CLARO EMILIO MOREIRA 904743 CLARO R JUNDIAI 904744 CLARO TEIXEIRA FREIT 904745 CLARO DEP NEO 904746 CLARO MAMORE 904747 CLARO BARAO R BRANCO 904748 CLARO - CAMERINO 905281 CLARO QUINTINO 905297 CLARO SILVINO 905342 CLARO VOLUNTARIOS 905351 CLARO BANDEIRANTES 905374 CLARO VARGAS 905375 CLARO RIOS 905376 CLARO DUQUE CAXIAS 905522 CLARO INGLESES 905526 CLARO - ESCELSA - HI 905569 CLARO RENASCENCA 905589 CLARO EPB TRINCHEIRA 905708 CLARO GOIANIA R. 2 905709 CLARO ANDRADAS 905718 CLARO ANGELO BOLSON 905725 CLARO SACRAMENTO 905746 CLARO EUGENIO 905747 CLARO 20 DE SETEMBRO 905748 CLARO JOAO NICHELE 905755 CLARO MT MARCILIO DI 905759 CLARO MT BR364 905773 CLARO CURITIBA JAIME 906116 CLARO GUARATIBA 906133 CLARO DQ DE CAXIAS 906214 CLARO ARAUJO PINHO 906228 CLARO RONDONOPOLIS 906250 CLARO BAURU 906415 CLARO - CEMIG - 925 906567 CLARO - CEMIG - 599 906568 CLARO - EPB - BRITO 906741 CLARO MARECHAL MS 906796 CLARO CORPORATE T A 906893 CLARO CORPORATE ADM 906894 CLARO CORPORATE T B 906906 CLARO BAND VL LOBOS 907044 CLARO JI PARANA 907078 CLARO VOLTA REDONDA 907099 CLARO SCS BRASILIA 907632 CLARO BRASILIA 3 907633 CLARO BRASILIA EMBR 907656 CLARO PALMAS TO 907828 CLARO - LIGHT - SENA 907843 CLARO SANTOS DUMONT 908040 CLARO MARABA 908043 CLARO CONTAGEM CEMIG 908054 CLARO ARLINDO CRUZ 908133 CLARO - CEMIG - GV 908370 CLARO JOSE ZACARIAS 908690 CLARO CEB 725 908903 CLARO LONDR 5328802 910292 CLARO SOBRAD 4665287 910354 CLARO CEB 4993543 910452 CLARO PRAIA BOTAFOGO 910851 CLARO - LIGHT - MENA 911834 CLARO R FLORIDA 902374"},{"id":"e8338f6e-4455-4e48-5f84-08d5ad2bf6ba","name":"MINERVA COMERCIALIZADORA DE ENERGIA LTDA.","commercialName":"","cnpj":"24510849000173","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"MINERVA COM 53008"},{"id":"c1a8d6d7-7e53-416e-5fc8-08d5ad2bf6ba","name":"DOW BRASIL SUDESTE INDUSTRIAL LTDA.","commercialName":"","cnpj":"53877627000191","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"DOW SUDESTE 53219 DOW GUARUJA - SP 903216"},{"id":"883a1f0d-4ad3-4140-5fc9-08d5ad2bf6ba","name":"PATIO LONDRINA EMPREENDIMENTOS E PARTICIPACOES LTDA","commercialName":"","cnpj":"09191802000109","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"SHOP PATIO LONDRINA 53220 SHOP LONDRINA FILIAL 903218 SHOP PATIO LONDRINA 903373"},{"id":"87b0600c-dc9e-4b5a-5fd1-08d5ad2bf6ba","name":"PLD CAJAMAR II B EMPREENDIMENTOS IMOBILIARIOS LTDA.","commercialName":"","cnpj":"14225070000152","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"PROLOGIS CAJAMAR 2 53234 PROLOGIS CAJAMAR 901217 PROLOGIS BIBLION 901201 UPS 910233"},{"id":"3d489d50-3f32-4e21-5fb2-08d5ad2bf6ba","name":"SOCICAM ADMINISTRACAO PROJETOS E REPRESENTACOES LTDA","commercialName":"","cnpj":"43217280002906","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"TERMINAL TIETE 53180 SOCIAM TERM TIETE 901282"},{"id":"cad930b8-113e-4571-5fa6-08d5ad2bf6ba","name":"ARCONIC INDUSTRIA E COMERCIO DE METAIS LTDA.","commercialName":"","cnpj":"05342105000142","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"ARCONIC 53065 ARCONIC MATRIZ 7192 ALCOA-TUBARAO SC 71819 ALCOA-ITAPISSUMA 71759"},{"id":"04453339-c7f7-4eb7-5fb7-08d5ad2bf6ba","name":"HM HOTEIS E TURISMO S A","commercialName":"","cnpj":"47396635000113","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"MAKSOUD 53194 HM HOTEIS E TURISMO 903457"},{"id":"78cb082e-6272-4b8d-60d2-08d5ad2bf6ba","name":"ARYZTA DO BRASIL ALIMENTOS LTDA","commercialName":"","cnpj":"57016578000153","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"ARYZTA 53749 ARYZTA OSASCO 903676 ARYZTA SANTO AMARO 903655 ARYZTA JAGUARIUNA 903654"},{"id":"86ec63ad-e798-44b1-60e1-08d5ad2bf6ba","name":"CONDOMINIO CIDADE JARDIM CORPORATE CENTER","commercialName":"","cnpj":"14296145000196","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"CIDADE JARDIM CENTER 53828 CIDADE JARDIM CENTER 902517"},{"id":"aa36293a-86ad-4b1b-60fa-08d5ad2bf6ba","name":"MOTOROLA MOBILITY COMERCIO DE PRODUTOS ELETRONICOS LTDA","commercialName":"","cnpj":"01472720000384","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"MOTOROLA 53932 MOTOROLA 906063"},{"id":"e9b4cf49-bae5-4522-6106-08d5ad2bf6ba","name":"SUBCONDOMINIO SHOPPING CIDADE SAO PAULO","commercialName":"","cnpj":"21314882000130","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"SHOPPING CIDADE SP 53965 SHOPPING CIDADE SP 906224"},{"id":"6ff6bcf6-e2d8-4781-6095-08d5ad2bf6ba","name":"PRESMAK TECNICA EM INJETADOS LTDA.","commercialName":"","cnpj":"07651602000158","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"PRESMAK 53607 PRESMAK 904798"},{"id":"3a3f45c4-95bf-4916-609a-08d5ad2bf6ba","name":"RIO ALTO COMERCIALIZADORA DE ENERGIA LTDA","commercialName":"","cnpj":"11210322000181","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"RIO ALTO 53613"},{"id":"a7a3e947-e1b2-467f-6085-08d5ad2bf6ba","name":"EMBU S A ENGENHARIA E COMERCIO","commercialName":"","cnpj":"61322558000188","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"EMBU ENG E COM 53577 EMBU SA EMBU DAS ART 903873 EMBU SA MOGI DAS CRU 903874 EMBU JURUACU SP 907745 EMBU ITUPEVA SP 909191"},{"id":"becf7307-87b6-4ab8-60c4-08d5ad2bf6ba","name":"IGON COMERCIALIZADORA DE ENERGIA LTDA","commercialName":"","cnpj":"24633389000170","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"IGON COMERCIALIZADORA 53661"},{"id":"873599f3-4415-49b0-60c6-08d5ad2bf6ba","name":"ROLDAO AUTO SERVICO COMERCIO DE ALIMENTOS LTDA.","commercialName":"","cnpj":"05800256000105","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"ROLDAO ATACADISTA 53702 ROLDAO BUTANTA SP 902988 ROLDAO FREGUESIA SP 902989 ROLDAO MOOCA SP 902990 ROLDAO CAMPO LIMPO 902991 ROLDAO CUPECE SP 902992 ROLDAO IPIRANGA SP 903085 ROLDAO GUARULHOS SP 903095 ROLDAO GUARUJA SP 903097 ROLDAO FRANCO ROCHA 903099 ROLDAO SANTO ANDRE 903101 ROLDAO SANTOS SP 903106 ROLDAO SOROCABA SP 903107 ROLDAO TAIPAS SP 903113 ROLDAO JUNDIAI SP 903136 ROLDAO TITO SP 903137 ROLDAO PRAIA GRANDE 903138 ROLDAO NACOES UNIDAS 903156 ROLDAO ITAPEVI 903158 ROLDAO OSASCO 903374 ROLDAO JANDIRA 903622"},{"id":"3a76fa54-7d0a-41c4-606c-08d5ad2bf6ba","name":"KHS INDUSTRIA DE MAQUINAS LTDA","commercialName":"","cnpj":"61081253000121","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"KHS 53500 KHS INDUSTRIA 904550"},{"id":"d63316aa-38ef-4cca-6045-08d5ad2bf6ba","name":"BRASPER ATIVIDADES IMOBILIARIAS LTDA","commercialName":"","cnpj":"08440725000102","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"BRASPER 53442 BRASPER 900594"},{"id":"59b882fd-2015-4e19-6055-08d5ad2bf6ba","name":"AKZO NOBEL LTDA","commercialName":"","cnpj":"60561719000123","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"AKZO NOBEL 53468 AKZO SANTO ANDRE 903847 AKZO MAUA 903848 AKZO ITUPEVA 905082 AKZO SBC 907746 AKZO NOBEL SAO ROQUE 908398"},{"id":"a36feec5-3196-4725-602d-08d5ad2bf6ba","name":"T.K.S. SISTEMAS HOSPITALARES E CONSULTORIOS MEDICOS LTDA.","commercialName":"CDB - CENTRO DE DIAGNOSTICOS BRASIL","cnpj":"02162577000125","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"TKS BRASIL350 53414 TKS BRASIL350 901798 TKS BORBAGATO 901835 TKS PREMIUM 901836 TKS TATUAPE 901837"},{"id":"d2bd44df-444f-4fd1-601f-08d5ad2bf6ba","name":"PRODUQUIMICA INDUSTRIA E COMERCIO S/A","commercialName":"","cnpj":"60398138000112","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"PRODUQUIMICA MATRIZ 53395 PRODUQUIMICA - MAUA 902004 PRODUQ SUZANO 1 902256 PRODUQUIMICA SUZANO2 902257 PROD JACAREI 1 902258 PROD JACAREI 2 902274"},{"id":"f36bada0-330b-42c0-6012-08d5ad2bf6ba","name":"EXPOAQUA - EXPOSICAO DE AQUARIO DE SAO PAULO LTDA","commercialName":"AQUARIO DE SAO PAULO","cnpj":"07558344000160","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"EXPOAQUA 53364 EXPOAQUA 905846"},{"id":"3be115d8-b64e-44de-6019-08d5ad2bf6ba","name":"METROPOLITANO ADMINISTRADORA LTDA","commercialName":"","cnpj":"17799741000187","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"SHOPPING METROPOLITANO 53376 SHOP METROPOLITANO 904974"},{"id":"a8face1a-e190-48db-5fdc-08d5ad2bf6ba","name":"UNINJET INDUSTRIA E COMERCIO DE PLASTICOS LTDA","commercialName":"","cnpj":"01355480000176","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"UNINJET 53245 UNINJET SAO LOURENCO 901556"},{"id":"0e0618ce-dd2f-4447-6005-08d5ad2bf6ba","name":"METALFRIO SOLUTIONS S.A.","commercialName":"METALFRIO SOLUTIONS S.A.","cnpj":"04821041000108","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"METALFRIO 53350 METALFRIO SOLUTIONS 903259"},{"id":"a3be0194-eaa9-4617-5ec5-08d5ad2bf6ba","name":"LABORPRINT GRAFICA E EDITORA EIRELI","commercialName":"","cnpj":"00460424000139","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"LABORPRINT 52547 LABORPRINT BARUERI 902740"},{"id":"87a5e97a-b396-4545-5ecb-08d5ad2bf6ba","name":"IND DE TORRONE NOSSA SENHORA DE MONTEVERGINE LTDA","commercialName":"","cnpj":"43643857000132","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"MONTEVERGINE 52553 MONTEVERGINE 901061"},{"id":"4770248c-5c54-48ff-5e8d-08d5ad2bf6ba","name":"DAVO SUPERMERCADOS LTDA","commercialName":"","cnpj":"52130481000153","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"DAVO ITAQUERA 52430 DAVO SUPERMERCADOS 899355 DAVO SUP LTDA 904342 DAVO SUP MOGI 904448 DAVO SUP SUZANO 904477 DAVO ITAIM 904556 DAVO SBC 905532 DAVO TABOAO 905538 DAVO GUAIANASES 908063 DAVO SAO MIGUEL 908238 DAVO ITAQUERA 909836"},{"id":"b7360818-316f-402f-5e98-08d5ad2bf6ba","name":"TOTVS S.A.","commercialName":"TOTVS S/A","cnpj":"53113791000122","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"TOTVS 52459 TOTVS 901091 TOTVS SA 902393"},{"id":"10fa698a-14bc-4a6b-5e7c-08d5ad2bf6ba","name":"VERT ENERGIE COMERCIALIZADORA LTDA","commercialName":"","cnpj":"23188648000139","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"VERTENERGIECOM 52400"},{"id":"3c6a140f-3606-414d-5e69-08d5ad2bf6ba","name":"BRINK'S SEGURANCA E TRANSPORTE DE VALORES LTDA","commercialName":"","cnpj":"60860087000107","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"BRINKS 52377 BRINKS CASA VERDE 906425"},{"id":"051f1b81-b7d3-431b-5e77-08d5ad2bf6ba","name":"FLC COMERCIO DE PLASTICOS LTDA","commercialName":"","cnpj":"06225746000180","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"FLC INDUSTRIA 52395 FLC INDUSTRIA 904078"},{"id":"27185f8d-8ceb-4f78-5e37-08d5ad2bf6ba","name":"MALTA ENERGIAS RENOVAVEIS LTDA.","commercialName":"","cnpj":"23866219000173","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"MALTA 52286"},{"id":"b021135a-0a56-4cbc-5de0-08d5ad2bf6ba","name":"EMPRESA FOLHA DA MANHA S.A.","commercialName":"","cnpj":"60579703000148","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"FOLHA DA MANHA 52054 FOLHA DA MANHA SP 900930 FOLHA DA MANHA BARAO 907515"},{"id":"b6a0036d-5cca-42be-5de4-08d5ad2bf6ba","name":"NOVARTIS BIOCIENCIAS SA","commercialName":"","cnpj":"56994502000130","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"NOVARTIS 52058 NOVARTIS BUTANTA 899890 NOVARTIS SANTO AMARO 899909"},{"id":"5e5e0520-de58-4851-5e04-08d5ad2bf6ba","name":"A.T.P. INDUSTRIA E COMERCIO DE PLASTICOS LTDA.","commercialName":"A.T.P.","cnpj":"04995392000399","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"ATP IND 52150 ATP IND 898568"},{"id":"08563888-dfa5-4aa2-5dfe-08d5ad2bf6ba","name":"KONECTA BRAZIL OUTSOURCING LTDA.","commercialName":"","cnpj":"08911199000111","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"KONECTA 52137 KONECTA 900037"},{"id":"a21ae8d1-4be1-4e7a-5e19-08d5ad2bf6ba","name":"TRANSFORMADORES E SERVICOS DE ENERGIA DAS AMERICAS LTDA.","commercialName":"TOSHIBA AMERICA DO SUL LTDA.","cnpj":"08870769000415","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"TOSHIBA 52210 TOSHIBA CONTAGEM 899936 TOSHIBA BETIM 899805"},{"id":"61964f6f-5687-41cf-5e23-08d5ad2bf6ba","name":"ENERGETICA COMERCIALIZADORA DE ENERGIA LTDA","commercialName":"","cnpj":"20978264000121","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"ENERGETICA COMERCIALIZADORA 52233"},{"id":"48050ecb-e2bb-45fc-5e31-08d5ad2bf6ba","name":"MUSEU DE ARTE DE SAO PAULO ASSIS CHATEAUBRIAND - MASP","commercialName":"","cnpj":"60664745000187","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"MASP 52273 MASP SAO PAULO SP 900986"},{"id":"2b5faf5e-2242-4310-5e35-08d5ad2bf6ba","name":"ANGICO ENERGIAS RENOVAVEIS LTDA.","commercialName":"","cnpj":"23881499000199","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"ANGICO 52283"},{"id":"b09603e0-6bb3-4b76-5e41-08d5ad2bf6ba","name":"MONTANA QUIMICA SA","commercialName":"","cnpj":"60884459000127","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"MONTANA 52297 MONTANA QUIMICA 901047"},{"id":"160dc94f-7a78-4d91-5cfd-08d5ad2bf6ba","name":"MADEPAR PAPEL E CELULOSE S/A.","commercialName":"","cnpj":"96288675000157","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"MADEPAR 51649 MADEPAR 899977"},{"id":"527d9f04-34f6-4308-5cf9-08d5ad2bf6ba","name":"AGROPECUARIA SCHIO LTDA","commercialName":"","cnpj":"91501783000142","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"SCHIO MATRIZ 51637 SCHIO SJ 898993"},{"id":"e86f2105-e1ac-4d57-5ceb-08d5ad2bf6ba","name":"EDIFICIO INTERNATIONAL PLAZA","commercialName":"","cnpj":"08882124000150","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"INTERNATIONAL PLAZA 51611 INTERNATIONAL PLAZA 899293"},{"id":"0117df05-41c3-4160-5ce6-08d5ad2bf6ba","name":"ALSCO TOALHEIRO BRASIL LTDA.","commercialName":"","cnpj":"33325184000119","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"ALSCO 51606 ALSCO - ARUJA - SP 899221 ALSCO - VILA MARIA 904416 ALSCO RJ 906220 ALSCO BH 907196"},{"id":"218d1cb0-904b-4bd1-5ce7-08d5ad2bf6ba","name":"IND BANDEIRANTE DE ARTEFATOS DE PLASTICOS E MADEIRA LTD","commercialName":"","cnpj":"61551172000148","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"BANFILME SP 51607 BANFILME SP 901357"},{"id":"3cfbc564-dc8e-447d-5ce0-08d5ad2bf6ba","name":"DC MATRIX INTERNET S/A","commercialName":"DC MATRIX","cnpj":"10666296000138","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"DC MATRIX 51598 DC MATRIX 906876"},{"id":"3ef5d80a-50a6-4eea-5cc8-08d5ad2bf6ba","name":"CLUBE ATLETICO MONTE LIBANO","commercialName":"","cnpj":"60782778000121","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"CAML 51567 CLUBE MONTE LIBANO 900599"},{"id":"a2268aff-ec35-41a7-5ca1-08d5ad2bf6ba","name":"SINTO BRASIL PRODUTOS LIMITADA.","commercialName":"WHEELABRATOR SINTO DO BRASIL","cnpj":"43735901000134","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"SINTO SP 51441 SINTO BRASIL LTD 899080"},{"id":"9670292e-90fc-4580-5c96-08d5ad2bf6ba","name":"BARRA GRANDE PARTICIPACOES S.A.","commercialName":"","cnpj":"22686328000146","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"BARRA GRANDE PART 51393"},{"id":"bd08cbf5-79c1-4d15-5c8f-08d5ad2bf6ba","name":"DIVIBRAS COMERCIO DE VIDROS TEMPERADOS E METAIS BRASIL LTDA","commercialName":"","cnpj":"72823461000175","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"DIVIBRAS 51383 DIVIBRAS 899701"},{"id":"ef9840a5-197c-472d-5c88-08d5ad2bf6ba","name":"PANCROM INDUSTRIA GRAFICA LTDA","commercialName":"","cnpj":"61155925000104","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"PANCROM 51375 PANCROM 898839"},{"id":"b8cfd546-2c49-4479-5c8b-08d5ad2bf6ba","name":"RIO PARANA ENERGIA S.A.","commercialName":"","cnpj":"23096269000119","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"REPESA 51378 ILHA SOLTEIRA ACL 896145 UHE.PH.SP.001120-7.01 JUPIA ACL 896144 UHE.PH.SP.001282-3.01 ILHA SOLTEIRA 224 UHE.PH.SP.001120-7.01 JUPIA 225 UHE.PH.SP.001282-3.01"},{"id":"365cb008-7c1f-4eca-5d9a-08d5ad2bf6ba","name":"LATICINIOS TIROLEZ LTDA","commercialName":"LATICINIOS TIROLEZ","cnpj":"55885321000102","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"TIROLEZ 51931 TIROLEZ MTE APRAZIVE 899367 TIROLEZ ARAPUA MG 900194 TIROLEZ TIROS 907203"},{"id":"ec746f4d-88fc-41b9-5d84-08d5ad2bf6ba","name":"UOL DIVEO TECNOLOGIA LTDA.","commercialName":"","cnpj":"01588770000160","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"UOL DIVEO 51846 UOL DIVEO 900843 UOL DIVEO TAMBORE 909401"},{"id":"3b6388c1-4dd5-4cf9-5d87-08d5ad2bf6ba","name":"PLENA ALIMENTOS LTDA","commercialName":"","cnpj":"10198974000266","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"PLENA ALIMEN 51849 PLENA CONTAGEM 899174 PLENA ARAGUARI 899246"},{"id":"8cb02850-0a20-47dc-5d17-08d5ad2bf6ba","name":"NISSIN FOODS DO BRASIL LTDA","commercialName":"","cnpj":"60945169000146","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"NISSIN 51699 NISSIN FOODS 899282 NISSIN GG 904749"},{"id":"e6d2a91d-fdc0-4806-5d39-08d5ad2bf6ba","name":"MDL COMERCIALIZADORA DE ENERGIA S.A.","commercialName":"","cnpj":"19604583000198","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"MDL COMERCIALIZADORA 51741"},{"id":"ae28e07e-4aed-417e-6605-08d5ad2bf6ba","name":"MAGAZINE TORRA TORRA LTDA","commercialName":"TORRA TORRA","cnpj":"22685030000111","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"TORRATORRA 57267 TORRATORRA ARARAQUAR 909857 TORRATORRA BOTUCATU 909858 TORRATORRA RPRETO 909871 TORRATORRA FRANCA 909872 TORRATORRA SAO JOSE 910220 TORRATORRA CAMPINAS 910223 TORRATORRA PINHEIROS 910352 TORRATORRA MAUA 910498 TORRATORRA BAURU 910502 TORRATORRA MARILIA 910529 TORRATORRA RCLARO 910551 TORRATORRA SBCAMPO 910611 TORRATORRA JUNDIAI 910628 TORRATORRA ITAQUA 912171 TORRATORRA SUZANO 912191 TORRATORRA GUARULHOS 912291 TORRATORRA MOGI 912732 TORRATORRA PENHA 912834"},{"id":"0fed1e4f-05ea-4e28-661f-08d5ad2bf6ba","name":"JSL S/A.","commercialName":"JSL","cnpj":"52548435000179","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"JSL 57330 JSL MOGI DAS CRUZES 907033"},{"id":"322209b0-f59d-4496-662d-08d5ad2bf6ba","name":"ROHM AND HAAS QUIMICA LTDA.","commercialName":"","cnpj":"00310651000188","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"ROHM AND HAAS 57381 ROHM E HASS JACAREI 907283"},{"id":"58b3f2f3-e9f6-40e2-662e-08d5ad2bf6ba","name":"WYETH INDUSTRIA FARMACEUTICA LTDA","commercialName":"","cnpj":"61072393000133","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"WYETH 57383 WYETH ITAPEVI SP 908285"},{"id":"bb352d3c-b84f-4ffa-6639-08d5ad2bf6ba","name":"SAP BRASIL LTDA","commercialName":"","cnpj":"74544297000192","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"SAP 57400 SAP SAO LEOPOLDO 909672"},{"id":"a3823b16-ce36-4686-665e-08d5ad2bf6ba","name":"MERCEARIA CHAMA LTDA","commercialName":"","cnpj":"03205493000194","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"CHAMA8 57512 MERCEARIA CHAMA LTDA 907323"},{"id":"49b984db-f570-4cfa-6656-08d5ad2bf6ba","name":"CONDOMINIO EDIFICIOS NEW YORK E LOS ANGELES","commercialName":"","cnpj":"05339136000144","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"COND NEW YORK 57501 CONDOMINIO NY LA SP 908916"},{"id":"d4e72e8b-17e3-4848-664d-08d5ad2bf6ba","name":"VIRTUS COMERCIO DE ALIMENTOS LTDA.","commercialName":"","cnpj":"11317530000184","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"VIRTUS ALIMENTOS 57474 VIRTUS - ALDEIA - SP 911735 VIRTUS - JAUAPERI 911759 VIRTUS - PAVAO - SP 911781 VIRTUS - MOOCA - SP 911782"},{"id":"8469999a-70a2-4267-6696-08d5ad2bf6ba","name":"DELTA INDUSTRIA CERAMICA LTDA,","commercialName":"","cnpj":"47595863000112","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"DELTA CERAMICA 57675 DELTA-RIO CLARO SP 71763 DELTA CERAMICA 2 907085"},{"id":"eb66e679-de3e-4e77-6697-08d5ad2bf6ba","name":"HM HM SUPERMERCADOS LTDA","commercialName":"EMPORIO SAO PAULO","cnpj":"02299215000180","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"HM HM SUPERMERCADOS 57679 HM HM SUPERMERCADOS 911175"},{"id":"dcacd8e9-a09d-405a-667d-08d5ad2bf6ba","name":"GLOW COMERCIALIZADORA DE ENERGIA LTDA","commercialName":"","cnpj":"21986619000197","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"GLOW COMERCIALIZADORA 57620"},{"id":"e8036b60-52f6-4eb2-6661-08d5ad2bf6ba","name":"MERITO COMERCIALIZACAO DE ENERGIA ELETRICA LTDA.","commercialName":"","cnpj":"26474919000100","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"MERITO ENERGIA 57515"},{"id":"bd10525b-98d0-454b-666b-08d5ad2bf6ba","name":"NEO-PLASTIC FILMES E EMBALAGENS PLASTICAS LTDA","commercialName":"NEOPLASTIC","cnpj":"11453489000173","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"NEO FILMES 57551 NEOPLASTIC F ROCHA 71909"},{"id":"569b440e-38f8-46ac-65dc-08d5ad2bf6ba","name":"MM GLOBAL GYM LTDA.","commercialName":"","cnpj":"03602928000134","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"REEBOK SPORTS CLUB CJ 57177 MM GLOBAL GYM LTDA. 907956"},{"id":"a1289dc6-1c9c-48a0-65d4-08d5ad2bf6ba","name":"CONDOMINIO CENTRO EMPRESARIAL BERRINI","commercialName":"CENTRO EMPRESARIAL BERRINI","cnpj":"11979386000141","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"SETOR TNU 57154 COND CENTRO EMP TNU 907348"},{"id":"9c082e8d-d892-407a-65e8-08d5ad2bf6ba","name":"METALURGICA CARTEC LTDA","commercialName":"","cnpj":"61299178000170","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"MET CARTEC 57191 METALURGICA CARTEC 906453"},{"id":"2d42618b-b385-44ed-65ea-08d5ad2bf6ba","name":"SHOPPING METRO ITAQUERA","commercialName":"SHOPPING METRO ITAQUERA","cnpj":"10341684000149","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"SHOPPING METRO ITAQUERA 57194 SHOPP METRO ITAQUERA 70520"},{"id":"d867878c-4921-4a8c-660d-08d5ad2bf6ba","name":"LIBBS FARMACEUTICA LTDA","commercialName":"LIBBS","cnpj":"61230314000175","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"LIBBS 57284 LIBBS SAO PAULO 907652 LIBBS EMBU 907653"},{"id":"3bea6262-871e-4651-660e-08d5ad2bf6ba","name":"IFLY BRAZIL INDOOR SKYDIVING LTDA.","commercialName":"","cnpj":"21423941000108","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"IFLY 57285 IFLY BRAZIL INDOOR S 907959"},{"id":"2dfda53b-48be-407a-6611-08d5ad2bf6ba","name":"SCHERING-PLOUGH INDUSTRIA FARMACEUTICA LTDA","commercialName":"","cnpj":"03560974000118","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"SCHERING PLOUGH 57290 SCHERING PLOUGH 906905"},{"id":"ffd5e3dd-c993-432e-65f8-08d5ad2bf6ba","name":"MONTE LIBANO INDUSTRIA E COMERCIO DE BRINQUEDOS LTDA","commercialName":"MONTE LIBANO","cnpj":"48925192000173","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"MONTE LIBANO 57240 MONTE LIBANO FILIAL 909051 MONTE LIBANO MATRIZ 909052"},{"id":"e372d55d-d1bc-4819-65f9-08d5ad2bf6ba","name":"SUPERGAUSS PRODUTOS MAGNETICOS LTDA","commercialName":"","cnpj":"63082325000180","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"SUPERGAUSS 57252 SUPERGAUSS - SAO PAU 907957 SUPERGAUSS - ITAPEVI 907958"},{"id":"a05e6aa6-b245-4eb8-65f1-08d5ad2bf6ba","name":"CONGREGACAO DE SANTA CRUZ","commercialName":"COLEGIO SANTA CRUZ","cnpj":"60993193000231","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"COLEGIO SANTA CRUZ 57230 CONGR STA CRUZ 908284"},{"id":"f6d849d0-797d-4fc8-65bc-08d5ad2bf6ba","name":"CYRELA GREENWOOD DE INVESTIMENTOS IMOBILIARIOS LTDA","commercialName":"","cnpj":"04512523000178","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"CYRELA 57010 CYRELA GRENWOOD 907513"},{"id":"89ec44b0-3035-4b35-65b0-08d5ad2bf6ba","name":"COMERCIALIZA ENERGIA LTDA","commercialName":"","cnpj":"26306760000115","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"COMERCIALIZA 56947"},{"id":"5d648b3d-7d32-416b-65b4-08d5ad2bf6ba","name":"WORLD TRADE CENTER DE SAO PAULO","commercialName":"","cnpj":"67630558000121","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"WORLD TRADE 56989 WORLD TRADE CENTER 905849"},{"id":"572f0bd6-7769-4b12-658b-08d5ad2bf6ba","name":"ABBOTT LABORATORIOS DO BRASIL LTDA","commercialName":"","cnpj":"56998701000116","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"ABBOTT 56817 ABBOT - RIO DE JANEI 908461"},{"id":"7bece881-f08c-4d7c-6587-08d5ad2bf6ba","name":"VIDRARIA ANCHIETA LTDA","commercialName":"ANCHIETA","cnpj":"60891108000143","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"VIDRARIA ANCHIETA 56808 VIDRARIA ANCHIETA LT 908213"},{"id":"82321928-4f83-465e-6755-08d5ad2bf6ba","name":"HOSPITAL SAMARITANO DE SAO PAULO LTDA","commercialName":"","cnpj":"24344124000152","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"HOSP SAMARITANO SP 58052 HOSP SAMARITANO SP 909628"},{"id":"775b64bc-0580-4095-6737-08d5ad2bf6ba","name":"KELLOGG BRASIL LTDA.","commercialName":"KELLOGG'S","cnpj":"55002133000199","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"KELLOGG 58005 KELLOGG SP 909190"},{"id":"d403a084-5ea3-4b66-6771-08d5ad2bf6ba","name":"NOVA TROPI GESTAO DE EMPREENDIMENTOS LTDA.","commercialName":"TROPICARGAS","cnpj":"10393022000112","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"NOVA TROPI MATRIZ 58104 NOVA TROPI 907514"},{"id":"f89d6ae1-948b-460f-677a-08d5ad2bf6ba","name":"DR. OETKER BRASIL LTDA.","commercialName":"DR. OETKER","cnpj":"61193496000151","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"OETKER 58183 DR OETKER BRASIL 909053"},{"id":"b568b823-28e7-4579-67c2-08d5ad2bf6ba","name":"ASSOCIACAO DE BENEFICENCIA E FILANTROPIA SAO CRISTOVAO","commercialName":"","cnpj":"60975174000100","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"SAO CRISTOVAO 58608 SAO CRISTOVAO - AMER 909796 SAO CRISTOVAO-TERENA 909797"},{"id":"f01a0afa-2a9a-4c54-67b5-08d5ad2bf6ba","name":"CONDOMINIO JATOBA","commercialName":"EDIFICIO COMERCIAL","cnpj":"08919536000117","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"JATOBA 58520 CONDOMINIO JATOBA 910346"},{"id":"fd4b1930-55d4-42d7-67aa-08d5ad2bf6ba","name":"TARGUS COMERCIALIZADORA DE ENERGIA LTDA","commercialName":"","cnpj":"26268886000142","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"TARGUS ENERGIA 58405"},{"id":"0cd1e5cd-7487-4864-6798-08d5ad2bf6ba","name":"ESSITY DO BRASIL INDUSTRIA E COMERCIO LTDA","commercialName":"ESSITY DO BRASIL","cnpj":"72899016000199","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"ESSITY DO BRASIL 58330 SCA DO BRASIL 907816"},{"id":"1aeefe84-532c-4b59-679c-08d5ad2bf6ba","name":"ESKENAZI INDUSTRIA GRAFICA LTDA","commercialName":"","cnpj":"61069100000169","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"ESKENAZI 58334 ESKENAZI GRAFICA 909627"},{"id":"6a3a450d-2298-43be-679d-08d5ad2bf6ba","name":"LUXOTTICA BRASIL PRODUTOS OTICOS E ESPORTIVOS LTDA","commercialName":"","cnpj":"04692027000143","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"LUXOTTICA 58336 LUXOTTICA 908402"},{"id":"0a0ce67b-22d8-476c-66b6-08d5ad2bf6ba","name":"SCHNEIDER ELECTRIC BRASIL LTDA","commercialName":"","cnpj":"82743287000104","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"SCHNEIDER 57751 SCHNEIDER ELET BLUME 908173 SCHNEIDER ELET GUARA 908197"},{"id":"209433dd-77b8-4fa2-66aa-08d5ad2bf6ba","name":"ZARA BRASIL LTDA","commercialName":"","cnpj":"02952485000149","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"ZARA 57729 ZARA MORUMBI 909372 ZARA SH METROP BARRA 910054 ZARA PASSEIO DAS AGU 910074 ZARA - BARRA SHOP 910203 ZARA SHOP LEBLON 910359 ZARA SHOP RIO SUL 911218 ZARA JUNDIAI SHOP 909193 ZARA IGUATEMI ESPLAN 909176 ZARA SAO JOSE RIO PR 909195 ZARA RIBEIRAO PRETO 909182 ZARA IGUATEMI CAMPIN 909184 ZARA PARQUE D PEDRO 909185 ZARA JK IGUATEMI 909215 ZARA CAJAMAR 909216 ZARA SAO CAETANO 909217 ZARA ANALIA FRANCO 909218 ZARA IGUATEMI ALPHA 909219 ZARA UBERLANDIA SHOP 909254 ZARA BH SHOP 909614 ZARA CONTINENTE P SH 909652 ZARA GARTEN SHOP 909653 ZARA - SHOP BALNEARI 909793 ZARA BARIGUI 909863 ZARA MUELLER 909893 ZARA PATIO BATEL 909892"},{"id":"9bcb3bc5-426e-451a-66ab-08d5ad2bf6ba","name":"OPERSAN RESIDUOS INDUSTRIAIS S.A.","commercialName":"","cnpj":"07234499000140","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"OPERSAN 57732 OPERSAN BLUMENAU SC 909314"},{"id":"8fcc51ef-c97d-472d-66cc-08d5ad2bf6ba","name":"RR COMERCIALIZADORA DE ENERGIA E PARTICIPACOES S.A.","commercialName":"","cnpj":"08773135000100","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"RRCOM 57833"},{"id":"83ec16f0-ad7e-4327-66d8-08d5ad2bf6ba","name":"PHOSFAZ FERTILIZANTES LTDA","commercialName":"","cnpj":"22957955000174","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"PHOSFAZ 57852 B&A MINERACAO BONITO 908113"},{"id":"4c1664e2-30b2-4777-6706-08d5ad2bf6ba","name":"DECS ENERGIA LTDA.","commercialName":"","cnpj":"13482034000101","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"CGH DONA ENEDINA 57930 CGH DONA ENEDINA 911371 CGH.PH.MG.037400-8.01"},{"id":"6d364390-eb28-446b-670b-08d5ad2bf6ba","name":"IATE CLUBE DE SANTOS","commercialName":"","cnpj":"48693832000167","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"IATE CLUBE 57936 IATE CLUBE GUARUJA 909398 IATE CLUBE 5627516 909399"},{"id":"f6e19da2-c5ec-4115-6729-08d5ad2bf6ba","name":"PLASUTIL-INDUSTRIA E COMERCIO DE PLASTICOS LTDA","commercialName":"","cnpj":"56450877000139","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"PLASUTIL PLASTICOS 57987 PLASUTIL UNIDADE 1 907272 PLASUTIL UNIDADE 2 907291"},{"id":"fe8ff9b7-d028-486c-6718-08d5ad2bf6ba","name":"VILLA COUNTRY MACLEMON LTDA","commercialName":"","cnpj":"04706822000143","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"VILLA COUNTRY 57957 VILLA COUNTRY 908630"},{"id":"c479a43f-e049-46b1-68b1-08d5ad2bf6ba","name":"FISHER ENERGY COMERCIALIZADORA DE ENERGIA ELETRICA LTDA","commercialName":"FISHER ENERGY","cnpj":"24783827000187","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"FISHER ENERGY 60292"},{"id":"2d7fedcc-6188-45fe-68cf-08d5ad2bf6ba","name":"NOVA MIX INDUSTRIAL E COMERCIAL DE ALIMENTOS LTDA","commercialName":"NOVA MIX","cnpj":"08142803000192","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"NOVAMIX MATRIZ 60434 NOVA MIX - ITAPERUNA 911692 NOVA MIX - VAZANTE 911719 NOVA MIX - TEOD SAM 911931 NOVA MIX-CAMPO BELO 912354"},{"id":"eea486dd-2483-4985-68d9-08d5ad2bf6ba","name":"GOLD ENERGY COMERCIALIZADORA DE ENERGIA LTDA.","commercialName":"","cnpj":"27690671000188","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"GOLD ENERGY 60491"},{"id":"42eb82d6-896a-429d-68d4-08d5ad2bf6ba","name":"NEWHAMPSHIRE COMERCIALIZADORA DE ENERGIA LTDA.","commercialName":"","cnpj":"28120534000170","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"NEWHAMPSHIRE 60450"},{"id":"27dbfd79-ce88-4917-68c9-08d5ad2bf6ba","name":"CRM INDUSTRIA E COMERCIO DE ALIMENTOS LTDA","commercialName":"GRUPO CRM INDUSTRIA E COMERCIO DE ALIMENTOS","cnpj":"61158283000199","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"KOPENHAGEN 60414 KOPENHAGEN EXTREMA 911281"},{"id":"43ca5293-688a-4e19-68ba-08d5ad2bf6ba","name":"CILASI ALIMENTOS S/A","commercialName":"BELA VISTA","cnpj":"60618436000170","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"CILASI ALIMENTOS 60357 CILASI ALIMENTOS 911731"},{"id":"9c248709-9ee0-466e-685d-08d5ad2bf6ba","name":"CTG - COMPANHIA DE TRANSPORTE DE GAS S/A","commercialName":"","cnpj":"05350199000100","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"CTG 59861 CTG - ITATIBA - SP 910501"},{"id":"f047b3cf-17e7-4290-685f-08d5ad2bf6ba","name":"PREMIER FOODS LTDA","commercialName":"","cnpj":"23285781000103","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"PREMIER FOODS 59870 PREMIER FOODS 909367"},{"id":"446a1e93-dbc6-425a-6865-08d5ad2bf6ba","name":"CONDOMINIO EDIFICIO PALACIO DAS AMERICAS E VITRINE DA IGUATEMY","commercialName":"","cnpj":"54239389000151","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"VITRINE IGUATEMY 59911 VITRI DA IGUATEMY 909742"},{"id":"f75f01f3-02aa-4fb7-6868-08d5ad2bf6ba","name":"CONDOMINIO EDIFICIO PEDRA GRANDE","commercialName":"","cnpj":"86952975000135","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"PEDRA GRANDE 59914 COND. PEDRA GRANDE 910791"},{"id":"a269ba40-f6ef-4847-6881-08d5ad2bf6ba","name":"I5 ENERGIA COMERCIALIZADORA LTDA","commercialName":"","cnpj":"27691770000184","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"I5 COMERCIALIZADORA 60105"},{"id":"9c00c0e0-2c4c-401f-67f1-08d5ad2bf6ba","name":"ESFERA COMERCIALIZADORA DE ENERGIA LTDA","commercialName":"ESFERA COMERCIALIZADORA","cnpj":"26940979000171","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"ESFERA COM 58990"},{"id":"d682945f-a862-429d-6806-08d5ad2bf6ba","name":"ITW DELFAST DO BRASIL LTDA.","commercialName":"","cnpj":"33034935000148","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"ITW 59192 ITW 909837"},{"id":"17cde95e-614d-4383-67e9-08d5ad2bf6ba","name":"HYAT EMPREENDIMENTOS LTDA.","commercialName":"AVANT","cnpj":"11836797000188","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"HYAT 58881 HYAT - SAO PAULO 909840"},{"id":"2942c6be-4013-44b7-67d9-08d5ad2bf6ba","name":"CONDOMINIO PATIO VICTOR MALZONI","commercialName":"","cnpj":"17895648000176","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"CONDOMINIO MALZONI 58691 COND VICTOR MALZONI 908364"},{"id":"dd2a78bd-7863-4c49-6810-08d5ad2bf6ba","name":"MOSAIC FERTILIZANTES DO BRASIL LTDA.","commercialName":"MOSAIC","cnpj":"61156501000156","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"MOSAIC FERTILIZANTES 59308 MOSAIC CATALAO 909696 MOSAIC RIO VERDE 909697 MOSAIC RONDONOPOLIS 909700 MOSAIC SORRISO 909915 MOSAIC UBERABA I 910004 MOSAIC UBERABA 2 910005 MOSAIC ARAGUAIA 911715 MOSAIC SAO JOAO 910117 MOSAIC PORTO 910118"},{"id":"b3b4e040-c670-4717-683f-08d5ad2bf6ba","name":"SUB-CONDOMINIO EDIFICIO SAO LUIS DE GONZAGA","commercialName":"","cnpj":"05141327000105","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"ED SAO LUIS GONZAGA 59550 ED SAO LUIS GONZAGA 909220"},{"id":"da660247-3046-47d1-6837-08d5ad2bf6ba","name":"RP COMERCIALIZADORA DE ENERGIA LTDA.","commercialName":"RP ENERGIA","cnpj":"27073191000178","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"RP COM 59494"},{"id":"a2621b38-20d9-4392-683b-08d5ad2bf6ba","name":"FACULDADES METROPOLITANAS UNIDAS EDUCACIONAIS LTDA.","commercialName":"F.M.U.","cnpj":"63063689000113","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"F.M.U DIREITO 59499 MTE TAGUA 4102 909403 MTE LIBERDADE 909421"},{"id":"adfcb902-8e5b-49a6-683c-08d5ad2bf6ba","name":"ISCP - SOCIEDADE EDUCACIONAL LTDA.","commercialName":"UNIVERSIDADE ANHEMBI MORUMBI","cnpj":"62596408000125","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"UAM 59512 MTE VILA OLIMPICA 909404 MTE VILA OLIMPICA 6 909405 UAM-MTE0015016 909794 MTE0002271 960 A 910792"},{"id":"21f7dbef-9ec6-4f4d-683d-08d5ad2bf6ba","name":"CLUBE PAINEIRAS DO MORUMBY","commercialName":"","cnpj":"52400207000157","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"CLUBE PAINEIRAS 59535 CLUBE PAINEIRAS 908917"},{"id":"ff33859c-35f5-4771-694d-08d5ad2bf6ba","name":"SHOPPING METRO BOULEVARD TATUAPE","commercialName":"SHOPPING METRO BOULEVARD TATUAPE","cnpj":"10254617000197","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"SMBT 61033 SMBT 70393"},{"id":"d7d69063-acc0-453c-694f-08d5ad2bf6ba","name":"QUANTUM ENERGIAS S.A","commercialName":"","cnpj":"29000095000125","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"QUANTUM ENERGIAS 61047"},{"id":"4da8ca1e-e2e5-4f14-696a-08d5ad2bf6ba","name":"COATS CORRENTE LTDA","commercialName":"CORRENTE","cnpj":"61148052002300","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"COATS CORRENTE SP IPIRANGA 61231 COATS CORRENTE SP 905841"},{"id":"3554191b-a55d-4c01-6962-08d5ad2bf6ba","name":"SANTA CLARA MANUFATURA E COSMETICOS LTDA","commercialName":"","cnpj":"57407397000158","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"SANTA CLARA MAN 61119 SANTA CLARA MAN 912312"},{"id":"6c85ec15-dae0-4cb4-6967-08d5ad2bf6ba","name":"SUPERMERCADO OURINHOS LTDA","commercialName":"","cnpj":"46951943000109","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"OURINHOS 61170 SUPERMERCADO OURINHO 912313"},{"id":"da48738f-1396-43ba-695e-08d5ad2bf6ba","name":"UHE SAO SIMAO ENERGIA S.A.","commercialName":"","cnpj":"27352303000120","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"UHE SAO SIMAO 61101"},{"id":"db2e631a-48fa-4cfe-6923-08d5ad2bf6ba","name":"GRUPO IBMEC EDUCACIONAL S.A","commercialName":"","cnpj":"04298309000160","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"IBMEC 60791 IBMEC CENTRO 912113 IBMEC BARRA 912133"},{"id":"1278ae3a-f774-4f34-6924-08d5ad2bf6ba","name":"DAMASIO EDUCACIONAL S.A.","commercialName":"","cnpj":"07912676000109","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"DAMASIO LIBERDADE 60792 DAMASIO LIBERDADE 911752"},{"id":"3860449e-ad47-40f8-692a-08d5ad2bf6ba","name":"POJUCA S/A","commercialName":"TIVOLI SAO PAULO - MOFARREJ","cnpj":"13250998000558","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"TIVOLI MOFARREJ 60815 TIVOLI MOFARREJ 911756"},{"id":"93cc166a-c933-49f5-692e-08d5ad2bf6ba","name":"TEXTIL DALUTEX LTDA","commercialName":"","cnpj":"43390996000100","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"DALUTEX 60833 TEXTIL DALUTEX 910951"},{"id":"b46ab5da-31b0-46f7-6934-08d5ad2bf6ba","name":"SUBCONDOMINIO THERA CORPORATE","commercialName":"","cnpj":"22274768000196","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"THERA CORPORATE SUB 60839 THERA CORPORATE 911734"},{"id":"f1a57cf1-6d1b-4ee3-693b-08d5ad2bf6ba","name":"TECNOPLAST INDUSTRIA E COMERCIO LTDA","commercialName":"TECNOPLAST","cnpj":"60569845000124","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"TECNOPLAST 60853 TECNOPLAST INDUSTRIA 7865"},{"id":"9de0572c-ad84-4be1-690f-08d5ad2bf6ba","name":"ANDORINHA SUPERMERCADO LTDA","commercialName":"","cnpj":"44480747000160","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"ANDORINHA SUPERMERCADO 60756 ANDORINHA MERCADO 911732 ANDORINHA MERCADO 911733"},{"id":"f71a70ef-a5ba-48d1-68e1-08d5ad2bf6ba","name":"CHRIS CINTOS DE SEGURANCA LTDA","commercialName":"","cnpj":"49729718000102","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"CHRIS CINTOS 60524 CHRIS CINTOS 911232"},{"id":"1ec777bf-e105-4e26-68ef-08d5ad2bf6ba","name":"CONDOMINIO ROCHAVERA CORPORATE TOWERS","commercialName":"","cnpj":"11523063000149","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"ROCHAVERA 60590 ROCHAVERA 911233"},{"id":"56238ba1-ac29-40dd-68f4-08d5ad2bf6ba","name":"LUA NOVA IND E COMERCIO DE PRODUTOS ALIMENTICIOS LTDA","commercialName":"","cnpj":"62461140000114","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"PANCO 60648 PANCO - CAMBARA 911340"},{"id":"a5920534-fb8b-42bd-68f2-08d5ad2bf6ba","name":"REAL COMERCIAL EIRELI","commercialName":"","cnpj":"02780640000197","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"LA PASTINA 60646 LA PASTINA 912439"},{"id":"be798768-0518-4e68-8847-08d5ae44ed50","name":"CONSORCIO SHOPPING METRO ITAQUERA","commercialName":"","cnpj":"05603974000183","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"SMI 2163"},{"id":"52729622-d6cd-4f65-8843-08d5ae44ed50","name":"CONDESHOP CONSORCIO DE DESENVOLVIM.DE SHOPPING CENTERS","commercialName":"","cnpj":"65855199000185","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"CONDESHOP 2018"},{"id":"8948229e-db34-4eec-8836-08d5ae44ed50","name":"ANGLO AMERICAN NIQUEL BRASIL LTDA","commercialName":"","cnpj":"42184226000130","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"ANGLO NIQUEL 1385"},{"id":"ed4d0e3e-0559-4ec8-8854-08d5ae44ed50","name":"TECSIS TECNOLOGIA E SISTEMAS AVANCADOS S.A.","commercialName":"","cnpj":"00469550000154","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"TECSIS 3631 TECSIS P7 71185"},{"id":"839b876e-6aa6-42b0-885e-08d5ae44ed50","name":"RUBI GERADORA E COMERCIALIZADORA DE ENERGIA LTDA","commercialName":"","cnpj":"12823650000116","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"RUBI COM 4377"},{"id":"310de8dc-b9e1-46dd-882f-08d5ae44ed50","name":"PLASTICOS MUELLER S/A IND E COM","commercialName":"","cnpj":"61187043000112","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"PLAST MUELLER 1147"},{"id":"77acc2ba-99f3-4bc8-8834-08d5ae44ed50","name":"SIFCO SA","commercialName":"","cnpj":"60499605000109","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"SIFCO 1348"},{"id":"0fba0cc6-cbdd-4127-6974-08d5ad2bf6ba","name":"ATIVUS FARMACEUTICA LTDA.","commercialName":"","cnpj":"64088172000141","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"ATIVUS 61690 ATIVUS 912444"},{"id":"850e75b9-5e06-47f7-882b-08d5ae44ed50","name":"COPEN COMPANHIA DE PETROLEO, GAS E ENERGIA S/A.","commercialName":"COPEN COMPANHIA PAULISTA ENERGIA","cnpj":"00996174000156","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"COPEN 147"},{"id":"53b61c52-722d-4ed4-8868-08d5ae44ed50","name":"GAIA ENERGIA E PARTICIPACOES S.A.","commercialName":"","cnpj":"09504914000164","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"GAIA ENERGIA 545-2013 5649 ECOLUZ 8980 UTE.FL.PR.028246-4.01"},{"id":"7064b38a-3ee5-4261-8860-08d5ae44ed50","name":"WALMA INDUSTRIA E COMERCIO LIMITADA","commercialName":"","cnpj":"61204814000132","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"WALMA 4470 WALMA I C LTDA 71590"},{"id":"d6d7b064-6b5a-4841-88a1-08d5ae44ed50","name":"VIGOR ALIMENTOS S.A","commercialName":"","cnpj":"13324184000197","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"VIGOR ALIMENTOS 14876"},{"id":"a7482601-e261-4ecc-888b-08d5ae44ed50","name":"COXIM ENERGIA LTDA.","commercialName":"","cnpj":"17309698000124","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"COXIM ENERGIA 12932 COXIM 472 CGH.PH.MS.028167-0.01"},{"id":"054e5aba-b8f6-4a88-8887-08d5ae44ed50","name":"AGUAS DE ITU GESTAO EMPRESARIAL S.A. - EM RECUPERACAO JUDICIAL","commercialName":"","cnpj":"08455185000130","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"AGUAS DE ITU 10909"},{"id":"3bbb250b-aba4-4752-8885-08d5ae44ed50","name":"ODEBRECHT COMERCIALIZADORA DE ENERGIA S.A. EM LIQUIDACAO","commercialName":"","cnpj":"14770709000180","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"OCE 10749"},{"id":"3ccc07c5-2249-4f64-63ca-08d5ad2bf6ba","name":"1001 INDUSTRIA DE ARTEFATOS DE BORRACHA LTDA","commercialName":"","cnpj":"61508537000151","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"1001 INDUSTRIA 55632 1001 INDUSTRIA 904090"},{"id":"44ea7fc4-c444-45ad-63c5-08d5ad2bf6ba","name":"REAL ARENAS EMPREENDIMENTOS IMOBILIARIOS S.A.","commercialName":"","cnpj":"09355015000147","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"ALLIANZ PARQUE 55622 REAL ARENAS EMP IMOB 907351"},{"id":"8ed74a1c-cb73-450f-6392-08d5ad2bf6ba","name":"CLUB ATHLETICO PAULISTANO","commercialName":"","cnpj":"60927472000116","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"CLUB PAULISTANO 55472 CLUB PAULISTANO 905556"},{"id":"82ffce0a-2a06-4bca-6387-08d5ad2bf6ba","name":"JAGUAR E LAND ROVER BRASIL INDUSTRIA E COMERCIO DE VEICULOS LTDA","commercialName":"JAGUAR E LAND ROVER BRASIL","cnpj":"10313717000147","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"JAGUAR LR 55450 JAGUAR XEROX 904945 JAGUAR LR EAST 910844"},{"id":"b6b30acc-31d4-4546-6384-08d5ad2bf6ba","name":"STIMA ENERGIA LTDA","commercialName":"","cnpj":"25099255000184","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"STIMA ENERGIA 55421"},{"id":"7d081f1c-09b5-41c7-6379-08d5ad2bf6ba","name":"MENU MODERNO ARMAZENS GERAIS FRIGORIFICOS EIRELI","commercialName":"","cnpj":"58279134000173","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"MENU MODERNO 55380 MENU MODERNO 904275"},{"id":"f439ca17-81d7-4a86-637a-08d5ad2bf6ba","name":"SERVICOS CENTRAL LOGISTICA E ARMAZENS GERAIS LTDA","commercialName":"","cnpj":"02267811000189","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"LOGISTICA 55382 CENTRAL LOGISTICA 904504"},{"id":"6ba8f2e5-a96f-42ab-6375-08d5ad2bf6ba","name":"SONDA SUPERMERCADOS EXPORTACAO E IMPORTACAO S.A.","commercialName":"","cnpj":"01937635000182","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"SONDA 55376 SONDA AGUA BRANCA 906245 SONDA JACANA 906229 SONDA MARIA CANDIDA 906246 SONDA MOOCA 906226 SONDA POMPEIA 906274 SONDA SANTO AMARO 906230 SONDA SAO BERNARDO 906227 SONDA TATUAPE 906231 SONDA VILA CARRAO 906247 SONDA VILA RIO 906367 SONDA RM0497709 908684 SONDA CAJAMAR 1 909214 CD GALERIA SONDA 909073 SONDA CD 909211 SONDA SOROCABA 910602 COBAL PENHA SONDA 909054 SONDA INDAIATUBA 909369 SONDA VILA BARROS 908682 SONDA SJC 908633 SONDA SANTO ANDRE 909055 COBAL GUARULHOS 908683 SONDA PENHA 909212 SONDA ITABERABA 909074 SONDA CIDADE DUTRA 909056 SONDA CARAPICUIBA 2 909213 SONDA VILA S JOSE 909057 TAIPAS 910079 SONDA CARAPICUIBA I 913530"},{"id":"74f8d77f-2bef-41b3-6354-08d5ad2bf6ba","name":"TIETE ADMINISTRADORA LTDA","commercialName":"","cnpj":"17799179000191","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"TIETE ADM 55313 TIETE ADM LTDA 907948"},{"id":"c733c906-e146-4ca1-63f3-08d5ad2bf6ba","name":"TIVIT TERCEIRIZACAO DE PROCESSOS, SERVICOS E TECNOLOGIA S.A.","commercialName":"","cnpj":"07073027001982","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"TIVIT TRANSAMERICA 55734 TIVIT TRANSAMERICA 906251"},{"id":"6d5c7a7d-d874-40b7-63eb-08d5ad2bf6ba","name":"T-SYSTEMS DO BRASIL LTDA.","commercialName":"","cnpj":"04426565000196","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"T-SYSTEMS 55716 T­SYSTEMS DO BRASIL 906259"},{"id":"423be6e3-a1a9-4d11-63e4-08d5ad2bf6ba","name":"LOCALFRIO S.A. ARMAZENS GERAIS FRIGORIFICOS.","commercialName":"LOCALFRIO LOGISTICA","cnpj":"58317751000116","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"LOCALFRIO 55694 LOCALFRIO SAO PAULO 906910 LOCALFRIO ITAJAI 907065 LOCALFRIO IPOJUCA PE 906998 FRIO - GUARUJA 913401"},{"id":"747a6e88-39e4-4517-63da-08d5ad2bf6ba","name":"SOUZA CRUZ LTDA","commercialName":"","cnpj":"33009911030631","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"SOUZA CRUZ TATUAPE 55684 SOUZA CRUZ TATUAPE 906586"},{"id":"f8dedafe-8693-441a-6413-08d5ad2bf6ba","name":"CORRECTA INDUSTRIA E COMERCIO LTDA.","commercialName":"","cnpj":"02957104000114","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"CORRECTA 55832 CORRECTA JAGUARE 905845"},{"id":"57adc191-fb77-44eb-640a-08d5ad2bf6ba","name":"QUANTIQ DISTRIBUIDORA LTDA","commercialName":"QUANTIQ","cnpj":"62227509000129","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"QUANTIQ 55798 QUANTIQ- QTD2 - RJ 907834 QUANTIQ - QTQ1- GRU 907835"},{"id":"3380bdbb-c7d6-485f-6419-08d5ad2bf6ba","name":"GE ENERGIAS RENOVAVEIS LTDA.","commercialName":"","cnpj":"17692901000356","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"GE ALSTOM BANDEIRANTE 55840 ALSTOM BANDEIRANTE 906847"},{"id":"d8aeea82-46ba-4462-641c-08d5ad2bf6ba","name":"M CASSAB COMERCIO E INDUSTRIA LTDA","commercialName":"M CASSAB","cnpj":"49698723000103","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"MCASSAB 55845 M CASSAB COM IND LTD 906260 MCASSAB COM IND LTDA 907237"},{"id":"e1b415ce-5c94-400e-6405-08d5ad2bf6ba","name":"ADMINISTRADORA DO CONTINENTAL SHOPPING LTDA","commercialName":"","cnpj":"47187794000108","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"CONTINENTAL SHOPPING 55789 ADM CONTINENTAL SHOP 906244"},{"id":"e440c51d-3553-4c24-6401-08d5ad2bf6ba","name":"HOTEL JEQUITIMAR LTDA.","commercialName":"","cnpj":"02414419000115","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"HOTEL JEQUITIMAR 55774 HOTEL JEQUITIMAR 907287"},{"id":"4181b881-63f2-49da-63f1-08d5ad2bf6ba","name":"TIVIT TERCEIRIZACAO DE PROCESSOS, SERVICOS E TECNOLOGIA S.A.","commercialName":"","cnpj":"07073027002105","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"TIVIT CENESP 55732 TIVIT CENESP 905557"},{"id":"1a056b42-4338-4edf-6450-08d5ad2bf6ba","name":"AMC - SERVICOS EDUCACIONAIS LTDA","commercialName":"UNIVERSIDADE SAO JUDAS TADEU","cnpj":"43045772000152","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"ANIMA USJT 55930 AMC SERV EDU 905847 AMC SERV EDUC BUTANT 908666"},{"id":"84885c68-096c-44d7-645c-08d5ad2bf6ba","name":"TERRITORIAL SAO PAULO MINERACAO LTDA.","commercialName":"","cnpj":"60874229000349","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"TERRITORIAL 55951 TERRITORIAL 906442"},{"id":"8eae1363-fbc1-4973-643b-08d5ad2bf6ba","name":"SHOPPING CENTER VILA OLIMPIA","commercialName":"CONDOMINIO","cnpj":"23481596000194","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"CENTER VILA OLIMPIA 55886 SHOP VILA OLIMPIA 888870"},{"id":"6ae5181c-e824-4974-6435-08d5ad2bf6ba","name":"BUN-TECH, TECNOLOGIA EM INSUMOS LTDA.","commercialName":"","cnpj":"56998438000165","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"BUNTECH 55880 BUNTECH INSUMOS 907529"},{"id":"9e455d60-9874-47aa-64f7-08d5ad2bf6ba","name":"RENAISSANCE DO BRASIL HOTELARIA LTDA","commercialName":"","cnpj":"64089824000324","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"RENAISSANCE 56331 RENAISSANCE 907373"},{"id":"2922ad4f-d801-478f-6502-08d5ad2bf6ba","name":"ASSOCIACAO CONGREGACAO DESANTA CATARINA","commercialName":"","cnpj":"60922168000186","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"ACSC CORPORATIVO 56372 HOSP SANTA CATARINA 907045 MADRE REGINA PROTMAN 907067 HOSP SAO JOSE 907300 HSL CACERES 907457 HOSP SANTA TERESA 907493 CASA DE SAUDE S JOSE 907583 HAM AMPARO MATERNAL 908453 STA ISABEL BLUMENAU 907227 HNSC TUBARAO 907241 HSC CINCINATO BRAGA 912314 HCNSC TRES RIOS 912777"},{"id":"bfd5cfd1-38b4-4df0-6503-08d5ad2bf6ba","name":"EDIFICIO TORRE SUL","commercialName":"","cnpj":"07602483000143","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"TORRE SUL 56380 TORRE SUL 906891"},{"id":"3553252e-3686-4ed1-6504-08d5ad2bf6ba","name":"VIP VII - EMPREENDIMENTOS E PARTICIPACOES S/A.","commercialName":"VIP VII","cnpj":"11284022000147","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"CONDOMINIO VIP VII 56381 VIP VII EMPREEND 909626"},{"id":"51d4e32a-1c2a-4a16-64fa-08d5ad2bf6ba","name":"BARRY CALLEBAUT BRASIL INDUSTRIA E COMERCIO DE PRODUTOS ALIMENTICIOS LTDA","commercialName":"","cnpj":"33163908000175","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"BARRY CALLEBAUT 56335 BARRY CALLEBAUT EXTR 905805"},{"id":"bcc4bc1d-9093-4458-64fb-08d5ad2bf6ba","name":"FLEURY S.A.","commercialName":"FLEURY MEDICINA E SAUDE","cnpj":"60840055000131","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"FLEURY 56362 FLEURY JABAQUARA 907356 FLEURY PARAISO 907371 FLEURY SAO GONCALO 907687 FLEURO OTAVIO CARNEI 907688 FLEURY XV NOVEMBRO 907701 FLEURY CAMPINAS 907702 FLEURY ITAIM BIBI 907933 FLEURY 400084280 908550 FLEURY BOTAFOGO 908570"},{"id":"820e713c-90b4-4877-6514-08d5ad2bf6ba","name":"HOTELARIA ACCOR BRASIL S/A","commercialName":"ACCORHOTELS","cnpj":"09967852000127","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"ACCOR 56465 ACCOR SOROCABA 907168 ACCOR - PAULINIA 907226 ACCOR - SJRP 907228 ACCOR - INTERLAGOS 907319 ACCOR MANAUS 907414 ACCOR - SJC - DUTRA 907592"},{"id":"3cf23b29-d987-4e99-650a-08d5ad2bf6ba","name":"ESTREITO PARTICIPACOES S.A.","commercialName":"","cnpj":"22686355000119","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"USINA ESTREITO 56392 ESTREITO US ESTREITO 8826 UHE.PH.MA.028863-2.01"},{"id":"db99c143-4226-4784-650b-08d5ad2bf6ba","name":"MACHADINHO PARTICIPACOES S.A.","commercialName":"","cnpj":"22686342000140","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"MACHADINHO PART 56393"},{"id":"058e434c-0e5a-45a9-6528-08d5ad2bf6ba","name":"CONDOMINIO EDIFICIO INTERNATIONAL PLAZA II","commercialName":"","cnpj":"13625544000190","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"INTERNATIONAL PLAZA II 56537 INTERNATIONAL PLZ 2 906907"},{"id":"a803eb40-523a-4d41-6531-08d5ad2bf6ba","name":"HOSPITAL BANDEIRANTES S.A","commercialName":"HOSPITAL LEFORTE - LIBERDADE","cnpj":"21371777000132","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"HOSPITAL BANDEIRANTES 56587 HOSP BANDEIRANTES SA 907425"},{"id":"0ea8d114-4bd8-4b62-6532-08d5ad2bf6ba","name":"HOSPITAL LEFORTE S.A","commercialName":"","cnpj":"19803199000114","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"HOSPITAL LEFORTE 56588 HOSPITAL LEFORTE S.A 907327"},{"id":"5d7ad371-dda8-44c8-6521-08d5ad2bf6ba","name":"CONDOMINIO SHOPPING CENTER LAPA","commercialName":"","cnpj":"53817748000148","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"SHOPPING CENTER LAPA 56513 SHOPPING LAPA 908062"},{"id":"4f664452-e98f-4093-651b-08d5ad2bf6ba","name":"POLENGHI INDUSTRIAS ALIMENTICIAS LTDA","commercialName":"","cnpj":"24949232000159","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"POLENGHI 56474 POLENGHI - ANGATUBA 906075 POLENGHI GOIATUBA 907016 POLENGHI S V MINAS 909246"},{"id":"bc9586bb-4f63-4708-6547-08d5ad2bf6ba","name":"CONCESSIONARIA DA LINHA 4 DO METRO DE SAO PAULO S.A.","commercialName":"","cnpj":"07682638000107","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"VIAQUATRO 56638 VIA QUATRO YVB 907853 VIA QUATRO PTA 909942 VIA QUATRO LUZ 909971 VIA QUATRO REP 909972"},{"id":"f2270d86-6193-47b1-655c-08d5ad2bf6ba","name":"NATURA COSMETICOS S/A","commercialName":"NATURA","cnpj":"71673990000177","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"NATURA SP 56673 NATURA COSMETICOS SA 907346"},{"id":"0858a6da-c222-4d7c-6574-08d5ad2bf6ba","name":"LAR'S EMPREENDIMENTOS LTDA","commercialName":"","cnpj":"01215670000198","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"LARS EMPREENDIMENTOS 56733 LARS - SAO PAULO 906908"},{"id":"79bc7dfa-36ef-4b22-6568-08d5ad2bf6ba","name":"ANACONDA INDUSTRIAL E AGRICOLA DE CEREAIS S A","commercialName":"","cnpj":"60728029000116","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"ANACONDA 56718 ANACONDA - SAO PAULO 906909 ANACONDA CURITIBA PR 906858"},{"id":"6128dd89-2830-407e-6569-08d5ad2bf6ba","name":"ESPORTE CLUBE SIRIO","commercialName":"","cnpj":"61006839000121","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"CLUBE SIRIO 56719 CLUBE SIRIO - SP 907358"},{"id":"1f2f37ae-4bd9-4a2e-656b-08d5ad2bf6ba","name":"LATICINIOS MILKREME LTDA.","commercialName":"","cnpj":"11459825000195","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"MILKREME 56722 MILKREME - LINS - SP 907250"},{"id":"7d91d1b6-96b2-46ed-6470-08d5ad2bf6ba","name":"S/A O ESTADO DE S.PAULO","commercialName":"","cnpj":"61533949000141","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"ESTADAO 56006 ESTADAO - SAO PAULO 906269"},{"id":"a825771e-01a6-4baa-6473-08d5ad2bf6ba","name":"DELTA 3 VIII ENERGIA S.A.","commercialName":"","cnpj":"15190472000121","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"DELTA 3 VIII 56009 DELTA 3 VIII 910082 EOL.CV.MA.033686-6.01"},{"id":"2e59c537-9806-4377-646c-08d5ad2bf6ba","name":"IDEAL ENERGIA COMERCIALIZADORA LTDA.","commercialName":"IDEAL ENERGIA","cnpj":"17070597000143","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"IDEAL ENERGIA 55993"},{"id":"2ab618d5-4958-4162-6468-08d5ad2bf6ba","name":"ESTRE AMBIENTAL S/A","commercialName":"ESTRE AMBIENTAL","cnpj":"03147393000159","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"ESTRE 55979 ESTRE PAULINIA 907517 ESTRE CURITIBA 908020"},{"id":"1fc19048-ac6f-4375-6469-08d5ad2bf6ba","name":"RESICONTROL SOLUCOES AMBIENTAIS S.A.","commercialName":"","cnpj":"00957744000107","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"RESICONTROL 55980 RESICONTROL SOLUCOES 907530"},{"id":"adef2661-2a42-4fe7-648d-08d5ad2bf6ba","name":"ESPORTE CLUBE PINHEIROS","commercialName":"","cnpj":"60854205000166","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"ESPORTE CLUBE PINHEIROS 56084 ESP CLUBE PINHEIROS 906877"},{"id":"a09f2119-f0f1-4f33-64a3-08d5ad2bf6ba","name":"MARLES INDUSTRIA TEXTIL ECOMERCIO LIMITADA","commercialName":"","cnpj":"43156819000155","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"MARLES 56140 MARLES AMERICANA 907501 MARLES SP 907512"},{"id":"02b79869-910a-46c4-64a6-08d5ad2bf6ba","name":"CONDOMINIO CENTRO TEXTIL INTERNACIONAL","commercialName":"","cnpj":"01147000000181","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"ITM 1 56143 ITM 907935"},{"id":"f8010bb8-c82c-48aa-64b1-08d5ad2bf6ba","name":"ETNA COMERCIO DE MOVEIS E ARTIGOS PARA DECORACAO S.A.","commercialName":"ETNA","cnpj":"13477066000119","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"ETNA COMERCIO DE MOVEIS 56163 ETNA SOE VOTORANTIM 907605 ETNA BER SAO PAULO 907629 ETNA MAT SAO PAULO 907630 ETNA CDB BARUERI 907631 ETNA CAE - CAMPINAS 907696 ETNA RPE - RIB PRETO 907697 ETNA BHE BELO HORIZ 909602 ETNA BARRA DA TIJUCA 910492 ETNA FTE FORTALEZA 910819"},{"id":"ce596ce4-5edc-447e-64aa-08d5ad2bf6ba","name":"SERBOM ARMAZENS GERAIS FRIGORIFICOS LTDA","commercialName":"","cnpj":"01628604000140","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"SERBOM 56148 SERBOM 905859"},{"id":"dfed98b8-9eeb-4eae-64b7-08d5ad2bf6ba","name":"VS EMPREENDIMENTOS E PARTICIPACOES LTDA","commercialName":"","cnpj":"00651385000157","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"VS EMPREENDIMENTOS 56174 VS EMPREENDIMENTOS 907043 SEARA - ANHANGUERA 906761"},{"id":"70ee8950-4179-41ea-64be-08d5ad2bf6ba","name":"IBIRAPUERA PARK HOTEL LTDA","commercialName":"GRAND MERCURE HOTEL SAO PAULO IBIRAPUERA","cnpj":"53355004000159","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"GRAND MERCURE 56191 IBIRAPUERA PARK HOTE 906898"},{"id":"1cb50ce6-b808-4a64-64c0-08d5ad2bf6ba","name":"FOCUS TECNOLOGIA DE PLASTICOS S/A","commercialName":"","cnpj":"59257972000109","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"FOCUS TECNOLOGIA 56193 FOCUS TECNOLOGIA 905065"},{"id":"142fe8c6-5250-4e2e-64d8-08d5ad2bf6ba","name":"BASALTO PEDREIRA E PAVIMENTACAO LTDA","commercialName":"","cnpj":"48302640000182","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"BASALTO 56279 BASALTO 03 AMERICANA 907931 BASALTO 06 CAMPINAS 907951 BASALTO 07 ITAPECIRI 907952 BASALTO 14 CACHOEIRA 907953 BASALTO 15 PARELHEIR 907954 BASALTO LINTEC 908234 BASALTO JAGUARIUNA 908289 BASALTO 04 LIMEIRA 908382 BASALTO 13 BURITAMA 908383 BASALTO 01 LEME 908384 BASALTO 11 MIRACATU 908385 BASALTO 16 ST ISABEL 908386"},{"id":"1d330dd9-d136-4a88-64e7-08d5ad2bf6ba","name":"CONDOMINIO EDIFICIO MORUMBI SQUARE","commercialName":"","cnpj":"73937484000173","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"MORUMBI SQUARE 56300 COND ED MORUMBI SQ 907352"},{"id":"88eb2a5c-b48b-44ed-64e8-08d5ad2bf6ba","name":"TELEPERFORMANCE CRM S.A.","commercialName":"","cnpj":"06975199000150","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"TELEPERFORMANCE 56302 TELEPERFORMANCE CRM 906262 TELEPERFORMANCE ABI 906756 TELEPERFORMANCE VP 906748 TELEPERFORMANCE SGA 908290 TELEPERFORMANCE ABII 906757 TELEPERFORMANCE CRM 911624"},{"id":"05034660-a6a6-4026-64e4-08d5ad2bf6ba","name":"LOJAS BELIAN MODA LTDA.","commercialName":"BESNI","cnpj":"46469748000139","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"BESNI 56297 BESNI 24 DE MAIO 907030 BESNI LJ 38 MOGI 907031 BESNI LAPA 907037 BESNI FLORIANO 907038 BESNI SAO BERNARDO 907039 BESNI CACHOEIRINHA 907040 BESNI LARGO 13 MAIO 907041 BESNI CAPAO REDONDO 907042 BESNI 57 SAO VICENTE 907467 BESNI LJ 47 SANTOS 907472"},{"id":"4f4b79f6-0598-4563-64e5-08d5ad2bf6ba","name":"PRINCIPAL COMERCIALIZADORA DE ENERGIA LTDA","commercialName":"","cnpj":"24616097000120","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"PRINCIPAL ENERGIA 56298"},{"id":"3603b228-106d-4198-62d6-08d5ad2bf6ba","name":"DELFIM COMERCIO E INDUSTRIA LTDA","commercialName":"","cnpj":"57010480000199","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"DELFIM 54986 DELFIM - SOROCABA SP 906604"},{"id":"04dc59e5-4603-46cb-62d8-08d5ad2bf6ba","name":"ALSTOM BRASIL ENERGIA E TRANSPORTE LTDA","commercialName":"ALSTOM","cnpj":"88309620000158","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"ALSTOM TRANSPORTE 54991 ALSTOM TRANSP 904970"},{"id":"470f7eb5-8793-4c30-62ed-08d5ad2bf6ba","name":"SARAIVA E SICILIANO S/A","commercialName":"LIVRARIA SARAIVA","cnpj":"61365284000104","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"SARAIVA 55034 SARAIVA - IGUATEMI 905293 SARAIVA CD CAJAMAR 905561 SARAIVA SAO CAETANO 905563 SARAIVA SHOP VILA VE 905594 SARAIVA SHOPPING JND 905771"},{"id":"e9ddbf93-f3dd-49fb-6304-08d5ad2bf6ba","name":"PORTO SEGURO COMPANHIA DE SEGUROS GERAIS","commercialName":"","cnpj":"61198164000160","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"PORTO SEGURO 55079 PORTO SEGURO TAGIPUR 903632 PORTO SEGURO RIBEIRO 903876 PORTO SEGURO GLETE 904585 PORTO SEG GUAIANASES 907748 PORTO SEG CANTAREIRA 907749 PORTO SEG RIO BRANCO 907783 PORTO SEG PACAEMBU 907784 UNIDAE BARAO DE PIRA 907844"},{"id":"12e0e2e3-b12b-48c5-6305-08d5ad2bf6ba","name":"MATERNIDADE DO BRAZ LTDA","commercialName":"HOSPITAL SALVALUS","cnpj":"61342507000118","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"MATERNIDADE BRAZ 55103 MATERNIDADE DO BRAZ 906257"},{"id":"504c8de5-9326-49fb-6319-08d5ad2bf6ba","name":"ASSOCIACAO FUNDO DE INCENTIVO A PESQUISA","commercialName":"","cnpj":"47673793000173","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"MARSELHESA 55170 MARSELHESA 904273"},{"id":"2c804294-1ea8-4016-6336-08d5ad2bf6ba","name":"KALIMO TEXTIL LTDA","commercialName":"","cnpj":"52747607000133","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"KALIMO 55246 KALIMO TINTURARIA 904731 KALIMO MALHARIA 904732"},{"id":"94b15c88-4094-49f2-632a-08d5ad2bf6ba","name":"NOBELPLAST EMBALAGENS EIRELI","commercialName":"NOBELPLAST","cnpj":"47577531000105","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"NOBELPLAST 55196 NOBELPLAST 904768"},{"id":"1f26f598-d132-4b3c-6290-08d5ad2bf6ba","name":"NOVODISC MIDIA DIGITAL LTDA.","commercialName":"NOVODISC MD","cnpj":"02073507000109","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"NOVODISC 54804 NOVODISC MIDIA DIGIT 906261"},{"id":"f6d6ef5c-033e-411d-628e-08d5ad2bf6ba","name":"MONSANTO DO BRASIL LTDA","commercialName":"","cnpj":"64858525000145","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"MONSANTO SEMENTES 54802 MONSANTO SEMENTES 905682 MONSANTO SEMENTES CV 905775 MONSANTO SEMENTES PC 906317 MONSANTO SHG 905803 MONSANTO SHG2 906325 MONSANTO CHD 906570"},{"id":"01053081-5ad4-41be-62a9-08d5ad2bf6ba","name":"IGUASPORT LTDA","commercialName":"","cnpj":"02314041002202","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"IGUASPORT 54904 IGUASPORT LTDA 905015 IGUA SOROCABA 905253 IGUASPORT SJC 957 906747 IGUASPORT SJRP 906798 IGUASPORT CAMPINAS 906823 IGUASPORT RIBEIRAO 906842 IGUA BARRA 400336858 906869 IGUA FLORIANOPOLIS 907066 IGUASPORT GOIANIA 907174 IGUASPORT LONDRINA 907397 IGUASPORT BARIGUI 907398 IGUASPORT BH 907617 IGUA JOIN 47510643 908719 IGUASPORT PRAIA GRD 908792 MTE0018640 906750 201106401- IGUA SBC 906759 MTE0014546 906760 IGUA EMBU 202373955 906768 IGUA ALPHAVILLE 913300"},{"id":"59ebc308-4a3c-4629-6243-08d5ad2bf6ba","name":"EQUINIX DO BRASIL SOLUCOES DE TECNOLOGIA EM INFORMATICA LTDA.","commercialName":"","cnpj":"03672254000144","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"EQUINIX SP1 54664 EQUINIX 70813 EQUINIX SP1 901622 EQUINIX SP2 901639 EQUINIX RJ2 908851"},{"id":"86459bd4-8f56-4e0a-626d-08d5ad2bf6ba","name":"SPICE INDUSTRIA QUIMICA LTDA.","commercialName":"","cnpj":"17701516000166","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"SPICE INDUSTRIA 54757 SPICE - RESENDE - RJ 904947"},{"id":"da6bffa6-68f6-42ac-6265-08d5ad2bf6ba","name":"TIVIT TERCEIRIZACAO DE PROCESSOS, SERVICOS E TECNOLOGIA S.A.","commercialName":"","cnpj":"07073027000153","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"TIVIT BPM 54744 TIVIT EUSEBIO 904723 TIVIT JABOATAO 904737"},{"id":"45a67527-ceac-4633-6130-08d5ad2bf6ba","name":"COMPANHIA AGRICOLA USINA JACAREZINHO","commercialName":"USINA JACAREZINHO","cnpj":"61231478000117","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"JACAREZINHO 54049 JACAREZINHO 905178"},{"id":"85bdf6e0-7ad4-4420-6131-08d5ad2bf6ba","name":"HOSPITAL E MATERNIDADE SANTA JOANA S/A","commercialName":"","cnpj":"60678604000113","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"HOSP SANTA JOANA 54051 HOSP MAT STA JOANA 904542"},{"id":"34761c56-725f-4b47-612a-08d5ad2bf6ba","name":"SOC BENEFICIENTE DE SENHORAS HOSPITAL SIRIO LIBANES","commercialName":"","cnpj":"61590410000124","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"SBHSL 54043 HSL PEIXOTO GOMIDE 901214 HSL ADM JAFET 901215"},{"id":"a90bed63-be96-465e-6122-08d5ad2bf6ba","name":"SUPERMERCADO HIROTA LTDA","commercialName":"HIROTA SUPERMERCADOS - LOJA 03","cnpj":"56527062000100","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"HIROTA SUPERMERCADOS 54032 HIROTA - LOJA 04 905509 HIROTA - LOJA 07 905510 HIROTA - LOJA 12 905511"},{"id":"dc913a3a-3a52-4e17-6128-08d5ad2bf6ba","name":"RESTOQUE COMERCIO E CONFECCOES DE ROUPAS S/A","commercialName":"","cnpj":"49669856000143","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"RESTOQUE 54040 RESTOQUE 904543"},{"id":"bfb95225-f04c-491b-614b-08d5ad2bf6ba","name":"AGUAS PETROPOLIS PAULISTA LTDA","commercialName":"","cnpj":"61072898000106","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"AGUAS PETROPOLIS 54103 AGUAS PETROPOLIS 903450"},{"id":"84a1272d-861e-4d1f-6162-08d5ad2bf6ba","name":"INFINITY DO BRASIL COMERCIALIZADORA DE ENERGIA LTDA.","commercialName":"","cnpj":"24479976000157","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"INFINITYENERGIAS 54159"},{"id":"3f94127c-f2f3-4f70-6190-08d5ad2bf6ba","name":"CLUBE DE CAMPO DE SAO PAULO","commercialName":"","cnpj":"61655742000140","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"CLUBE DE CAMPO DE SP 54243 CLUBE DE CAMPO SP 904963"},{"id":"afaf2df5-378d-4bca-617d-08d5ad2bf6ba","name":"GL ELETRO-ELETRONICOS LTDA.","commercialName":"PIAL LEGRAND","cnpj":"52618139000105","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"GL ELETRO 54210 LEGRAND DIADEMA 633 904971 LEGRAND DIADEMA 661 904972 CEMAR LEGR-CAX SUL 71867 LEGRAND POA 415 900032 LEGRAND POA 306 900073"},{"id":"7bd5820c-8a0a-4427-61a5-08d5ad2bf6ba","name":"DIVINAL DISTRIBUIDORA DE VIDROS NACIONAL LTDA","commercialName":"","cnpj":"60500915000511","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"DIVINAL 54329 DIVINAL 905539"},{"id":"b439967d-c320-4588-61a2-08d5ad2bf6ba","name":"PLASTICOS METALMA S A","commercialName":"","cnpj":"61432118000183","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"METALMA PR 54307 PLASTICOS METALMA 904242"},{"id":"1b8a5c3b-3d41-416a-61aa-08d5ad2bf6ba","name":"LOCAWEB SERVICOS DE INTERNET S.A.","commercialName":"LOCAWEB","cnpj":"02351877000152","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"LOCAWEB 54334 LOCAWEB 903842"},{"id":"8cc038b3-5a6e-4f66-61b9-08d5ad2bf6ba","name":"ARTHI COMERCIAL LTDA","commercialName":"ARTHI","cnpj":"58508748000180","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"ARTHI 54350 ARTHI 905163"},{"id":"8bb9d720-e660-448a-61df-08d5ad2bf6ba","name":"FRIGOL S.A.","commercialName":"FRIGOL","cnpj":"68067446001220","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"FRIGOL 54453 FRIGOL CACHOEIRA ALT 905711 FRIGOL BOVINOS LP 906674 FRIGOL BOVINOS ETE L 906680 FRIGOL GRAXARIA LP 906681 FRIGOL SUINOS LP 906682 FRIGOL BOVINOS AAN 907524 FRIGOL BOVINOS SFX 907713"},{"id":"fa402e3a-da2f-4792-61d1-08d5ad2bf6ba","name":"CLARIANT S.A","commercialName":"","cnpj":"31452113000151","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"CLARIANT S.A 54437 CLARIANT JACAREI 901511"},{"id":"d11f078f-145a-490f-620d-08d5ad2bf6ba","name":"TEKLA INDUSTRIAL TEXTIL LTDA.","commercialName":"TEKLA INDUSTRIAL","cnpj":"07669515000128","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"TEKLA 54521 TEKLA INDUSTRIAL 905540 TEKLA FILIAL 905541"},{"id":"89dc3163-16a9-4792-620e-08d5ad2bf6ba","name":"ASSOCIACAO BRASILEIRA DE EDUCACAO E CULTURA -ABEC","commercialName":"","cnpj":"60982352000111","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"ABEC 54530 ABEC GLORIA 904243 ABEC RIBEIRAO PRETO 904244 ABEC ARQUIDIOCESANO 904402 ABEC MARISTINHA 908884 ABEC MARISTAO 909951"},{"id":"c0466cee-2f39-41c7-61f6-08d5ad2bf6ba","name":"FRASCOMAR-JULYPLASTIC INDUSTRIA E COMERCIO DE PLASTICOS LTDA","commercialName":"FRASCOMAR","cnpj":"02197891000143","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"FRASCOMAR 54487 FRASCOMAR 904964"},{"id":"3e4681f3-eccd-43da-6229-08d5ad2bf6ba","name":"ISOTERM INDUSTRIA E COMERCIO DE EMBALAGENS LTDA.","commercialName":"","cnpj":"56415979000113","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"ISOTERM 54600 ISOTERM STA GERTRUDE 904334 ISOTERM ARAQUARI SC 905739"},{"id":"7b9fa0c5-de14-4e71-622a-08d5ad2bf6ba","name":"ASSOCIACAO CULTURA INGLESA - SAO PAULO","commercialName":"CULTURA INGLESA","cnpj":"61793907000140","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"CULTURA INGLESA 54601 ASS. CULT INGLESA SP 906256"},{"id":"fa650e5f-3a7b-4a50-621a-08d5ad2bf6ba","name":"HOTEL MARCO INTERNACIONAL S.A.","commercialName":"HOTEL FASANO","cnpj":"03221095000161","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"FASANO 54559 HOTEL FASANO 904544"},{"id":"235fa3c9-4fe6-414f-6217-08d5ad2bf6ba","name":"CONDOMINIO DO CENTRO EMPRESARIAL DO ACO","commercialName":"","cnpj":"04370035000173","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"CONDOMINIO DO ACO 54552 CONDOMINIO DO ACO 904965"},{"id":"7d6789cb-5e64-4183-8dac-08d5d060706e","name":"SCHERING DO BRASIL QUIMICA E FARMACEUTICA LTDA.","commercialName":"","cnpj":"56990534000167","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"SCHERING 62527 SCHERING 913319"},{"id":"5aa0c9a1-7ff7-403f-8dad-08d5d060706e","name":"CONDOMINIO CANTAREIRA NORTE SHOPPING","commercialName":"","cnpj":"26406107000128","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"CANTAREIRA NORTE SHOP 62541 CANTAREIRA NORTE SHO 913336"},{"id":"d8645a94-b8cc-4e6f-6813-08d5d153df4d","name":"CTC - CENTRO DE TECNOLOGIA CANAVIEIRA S.A.","commercialName":"","cnpj":"06981381000113","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":""},{"id":"7db6bbcb-80a8-456d-8d9e-08d5d060706e","name":"GPV COMERCIALIZADORA DE ENERGIA LTDA","commercialName":"","cnpj":"26562346000177","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"GPV COM 61397"},{"id":"40b3c79c-e7f2-411a-8d99-08d5d060706e","name":"LATICINIOS CATUPIRY LTDA","commercialName":"","cnpj":"61087367000189","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"CATUPIRY 61330 3009018318 913593"},{"id":"9c52237d-ffe9-462e-8d97-08d5d060706e","name":"FERROLENE SA INDUSTRIA E COMERCIO DE METAIS","commercialName":"","cnpj":"61881017000190","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"FERROLENE 61271"},{"id":"24fbf4e4-7b2c-4a66-8da1-08d5d060706e","name":"ROSSET & CIA LTDA","commercialName":"","cnpj":"61522173000326","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"ROSSET FLIAL 61655"},{"id":"14f0e84a-57f7-4d0c-7405-08d5cf600bef","name":"COSAN S/A INDUSTRIA E COMERCIO","commercialName":"","cnpj":"50746577000115","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":""},{"id":"7445096a-ada8-4fe8-8d95-08d5d060706e","name":"EDIFICIO MEMORIAL OFFICE BUILDING","commercialName":"","cnpj":"03673833000101","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"ED BUILDING 61096 ED BUILDING 913327"},{"id":"fcd54c7f-aa4c-4c07-8d7a-08d5d060706e","name":"CLUBE ATLETICO JUVENTUS","commercialName":"","cnpj":"62863444000108","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"JUVENTUS 58064 CLUBE JUVENTUS 913528"},{"id":"c1cf000c-13fb-4c8b-7410-08d5cf600bef","name":"YOU INC INCORPORADORA E PARTICIPACOES S.A.","commercialName":"","cnpj":"11284204000118","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":""},{"id":"852b307d-a86a-4cf2-7411-08d5cf600bef","name":"TEREOS INTERNACIONAL S.A.","commercialName":"","cnpj":"11566501000156","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":""},{"id":"342d164e-1707-4783-73c6-08d5cf600bef","name":"VIVER INCORPORADORA E CONSTRUTORA S.A. EM RECUPERACAO JUDICIAL","commercialName":"","cnpj":"67571414000141","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":""},{"id":"40739297-d9be-4b93-73c9-08d5cf600bef","name":"CONSTRUTORA TENDA S/A","commercialName":"","cnpj":"71476527000135","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":""},{"id":"88e80658-1e87-465d-73ca-08d5cf600bef","name":"CYRELA BRAZIL REALTY S.A. EMPREENDIMENTOS E PARTICIPACOES","commercialName":"","cnpj":"73178600000118","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":""},{"id":"91e8d845-7b75-4b46-73cc-08d5cf600bef","name":"FENICIAPAR SA","commercialName":"FENICIAPAR","cnpj":"74409467000126","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":""},{"id":"1e14d71e-798d-4bf0-73e3-08d5cf600bef","name":"MUNDIAL S.A. - PRODUTOS DE CONSUMO","commercialName":"","cnpj":"88610191000154","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":""},{"id":"a6c5a100-6a48-4cbc-7402-08d5cf600bef","name":"COSAN LOGISTICA S/A","commercialName":"","cnpj":"17346997000139","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":""},{"id":"97895ca3-a977-40a0-7400-08d5cf600bef","name":"SALUS INFRAESTRUTURA PORTUARIA S.A.","commercialName":"","cnpj":"15494541000190","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":""},{"id":"2739c5c4-f109-4b3f-740d-08d5cf600bef","name":"BS&C EMPREENDIMENTOS E PARTICIPACOES S.A.","commercialName":"","cnpj":"10603674000134","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":""},{"id":"237e8bef-0dcc-40b2-7407-08d5cf600bef","name":"FORNO DE MINAS ALIMENTOS S/A","commercialName":"","cnpj":"03870455000580","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":""},{"id":"feddaac9-472f-4f60-7408-08d5cf600bef","name":"RAIZEN ENERGIA S.A","commercialName":"","cnpj":"08070508000178","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":""},{"id":"4c9f7513-d718-4d67-73fa-08d5cf600bef","name":"CLARO TELECOM PARTICIPACOES S/A","commercialName":"","cnpj":"07043628000113","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":""},{"id":"32fde73d-9d40-4574-73fb-08d5cf600bef","name":"BRASILAGRO - COMPANHIA BRASILEIRA DE PROPRIEDADES AGRICOLAS","commercialName":"","cnpj":"07628528000159","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":""},{"id":"19b5c55f-713d-4a8f-73fc-08d5cf600bef","name":"AEGEA SANEAMENTO E PARTICIPACOES S.A.","commercialName":"","cnpj":"08827501000158","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":""},{"id":"719430c8-08b8-4860-73f1-08d5cf600bef","name":"HERCULES SA FABRICA DE TALHERES","commercialName":"","cnpj":"92749225000163","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":""},{"id":"9bf4dbaf-f127-4ec4-73ea-08d5cf600bef","name":"KEPLER WEBER SA","commercialName":"KEPLER WEBER SA","cnpj":"91983056000169","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":""},{"id":"5361f9b3-746e-40c7-6815-08d5d153df4d","name":"SMARTFIT ESCOLA DE GINASTICA E DANCA S.A","commercialName":"","cnpj":"07594978000178","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":""},{"id":"6d4c7294-dc0d-4f84-4ed8-08d5d159243d","name":"FLEX GESTAO DE RELACIONAMENTOS S.A.","commercialName":"FLEX GESTAO DE RELACIONAMENTOS","cnpj":"10851805000100","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":""},{"id":"9030882c-070c-44f6-4ee9-08d5d159243d","name":"REAG SECURITIES SECURITIZADORA DE CREDITOS","commercialName":"","cnpj":"20451953000183","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":""},{"id":"b81b564e-bb64-4c55-4eea-08d5d159243d","name":"GAIA CRED SECURITIZADORA DE CREDITOS FINANCEIROS S.A.","commercialName":"","cnpj":"20646442000117","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":""},{"id":"3f7a2c68-312e-4fcb-4eeb-08d5d159243d","name":"ENCALSO PARTICIPACOES EM CONCESSOES S.A.","commercialName":"","cnpj":"21262638000170","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":""},{"id":"f001840e-5a4c-40cb-4eec-08d5d159243d","name":"MOVIDA PARTICIPACOES S.A.","commercialName":"","cnpj":"21314559000166","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":""},{"id":"ae447243-6f10-475f-4eed-08d5d159243d","name":"LEADS CIA. SECURITIZADORA","commercialName":"LEADS CIA SECURITIZADORA","cnpj":"21414457000112","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":""},{"id":"0e92d3a6-682e-4fda-4eee-08d5d159243d","name":"FORTUNATO SECURITIZADORA S.A.","commercialName":"FORTUNATO SECURITIZADORA","cnpj":"21610416000100","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":""},{"id":"bfeb687e-7233-4a03-4eef-08d5d159243d","name":"PACIFIC RDSL PARTICIPACOES S.A","commercialName":"","cnpj":"21728500000114","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":""},{"id":"5bb289e4-5b62-480e-4ee1-08d5d159243d","name":"RENOVA COMPANHIA SECURITIZADORA DE CREDITOS FINANCEIROS S.A.","commercialName":"","cnpj":"19133012000112","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":""},{"id":"78e4e240-4cef-42fc-4edb-08d5d159243d","name":"SUGOI INCORPORADORA E CONSTRUTORA S.A","commercialName":"","cnpj":"13584310000142","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":""},{"id":"ad2599aa-4789-46b8-4efe-08d5d159243d","name":"CRUZE PARTICIPACOES S.A.","commercialName":"","cnpj":"26398143000197","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":""},{"id":"2f01d620-2c77-4e05-4eff-08d5d159243d","name":"TRAVESSIA SECURITIZADORA S.A.","commercialName":"","cnpj":"26609050000164","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":""},{"id":"ceae77ef-2eb9-4895-4ef1-08d5d159243d","name":"BTGI QUARTZO PARTICIPACOES S.A.","commercialName":"","cnpj":"21948105000147","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":""},{"id":"7c25e5c9-2f31-4d81-4ef2-08d5d159243d","name":"BTGI SAFIRA PARTICIPACOES S.A.","commercialName":"","cnpj":"21976510000179","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":""},{"id":"8e9c2f4f-07ea-48ff-4ef3-08d5d159243d","name":"FINSBURY PARTICIPACOES S.A.","commercialName":"FINSBURY","cnpj":"21987030000103","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":""},{"id":"633fe30f-26e9-49b6-4ef9-08d5d159243d","name":"ARGO TRANSMISSAO DE ENERGIA S.A.","commercialName":"","cnpj":"24624490000165","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":""},{"id":"bf379907-da2d-484f-4efa-08d5d159243d","name":"ARGO ENERGIA EMPREENDIMENTOS E PARTICIPACOES S.A.","commercialName":"","cnpj":"24624551000194","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":""},{"id":"90ecc08f-ad9e-4037-4efb-08d5d159243d","name":"VERT COMPANHIA SECURITIZADORA","commercialName":"","cnpj":"25005683000109","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":""},{"id":"325f08e9-bb5f-4d98-4f06-08d5d159243d","name":"RIOLOAN 2 COMPANHIA SECURITIZADORA DE CREDITOS FINANCEIROS","commercialName":"RIOLOAN 2 COMPANHIA SECURITIZADORA DE CREDITOS FINANCEI","cnpj":"28442718000157","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":""},{"id":"2a70c61a-8e3d-4d4d-4f02-08d5d159243d","name":"EDAFO SECURITIZADORA S.A.","commercialName":"EDAFO SECURITIZADORA","cnpj":"27092587000162","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":""},{"id":"1b138767-3c70-4678-4f03-08d5d159243d","name":"COMPANHIA SECURITIZADORA DE CREDITOS FINANCEIROS CARTOES CONSIGNADOS BMG","commercialName":"","cnpj":"27137879000174","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":""},{"id":"3de157b0-01e1-46d8-4ee7-08d5d159243d","name":"NOTRE DAME INTERMEDICA PARTICIPACOES S.A.","commercialName":"","cnpj":"19853511000184","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":""},{"id":"6827a86f-45ac-45aa-4f16-08d5d159243d","name":"PERDIZES - SECURITIZADORA DE RECEBIVEIS COMERCIAIS S/A","commercialName":"","cnpj":"13878847000115","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":""},{"id":"8c2c103b-99ca-4e35-1cd0-08d5b8870181","name":"VEDRA ENERGIA LTDA","commercialName":"","cnpj":"29229364000120","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"VEDRA ENERGIA 61810"},{"id":"977d583b-cbfd-4dd1-1cb6-08d5b8870181","name":"CINEPOLIS OPERADORA DE CINEMAS DO BRASIL LTDA.","commercialName":"","cnpj":"09652820000132","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"CINEPOLIS 60972 CINEPOLIS MTRO ITAQU 912837 CINEPOLIS IGUAT ALPH 912854 CINEPOLIS - LARGO 13 913301 CINEPOLIS - IGUATEMI 913320 CINEPOLIS - CAMPINAS 913431"},{"id":"d4cc0866-68ef-4258-1cc7-08d5b8870181","name":"MAXIMA ENERGIA COMERCIALIZADORA E SERVICOS LTDA","commercialName":"","cnpj":"28503205000109","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"MAXIMA SERVICOS 61510"},{"id":"b914f6eb-4fff-4bd3-88f6-08d5ae44ed50","name":"CLARO CORPORATE EMPREENDIMENTOS IMOBILIARIOS LTDA.","commercialName":"","cnpj":"17849320000113","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"CLARO CORPORATE 57152"},{"id":"22a0647b-4b2d-4dbc-1cab-08d5b8870181","name":"KNAUF ISOPOR LTDA","commercialName":"","cnpj":"01685556000121","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"KNAUF 60725 KNAUF ATIBAIA 912876 KNAUF SAO SIMAO 912952 KNAUF SARZEDO 912853 KNAUF SAPUCAIA 913480 KNAUF JOINVILLE 913495"},{"id":"9224a70e-2d3a-4b50-88f0-08d5ae44ed50","name":"NAVI CARNES - INDUSTRIA E COMERCIO LTDA","commercialName":"NAVI CARNES","cnpj":"02982267000157","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"NAVI CARNES 55952"},{"id":"76e4cf52-131f-483b-88e2-08d5ae44ed50","name":"COATS CORRENTE LTDA","commercialName":"","cnpj":"61148052000102","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"COATS CORRENTE SP 54435"},{"id":"2fe6da6a-4373-4dc2-88b8-08d5ae44ed50","name":"BLUMENAU NORTE SHOPPING PARTICIPACOES LTDA.","commercialName":"","cnpj":"11140451000140","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"SHOP BLUMENAU NORTE 50395"},{"id":"0630c3e4-d83e-43ff-88b9-08d5ae44ed50","name":"JOINVILLE SHOPPING PARTICIPACOES LTDA.","commercialName":"","cnpj":"10257908000139","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":"SHOP GARTEN JOINVILLE 50398"},{"id":"6f164ad0-0d46-4a14-724e-08d5cf600bef","name":"RET PARTICIPACOES S.A.","commercialName":"","cnpj":"02363917000186","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":""},{"id":"02c36460-b6a9-4396-724c-08d5cf600bef","name":"LONGDIS S/A","commercialName":"","cnpj":"02338534000158","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":""},{"id":"48c57ec0-95ec-4376-723f-08d5cf600bef","name":"PORTO SEGURO S/A","commercialName":"","cnpj":"02149205000169","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":""},{"id":"c455405d-3036-4648-7246-08d5cf600bef","name":"INEPAR EQUIPAMENTOS E MONTAGENS S/A - EM RECUPERACAO JUDICIAL","commercialName":"","cnpj":"02258422000197","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":""},{"id":"995dcc6a-3b43-424a-725c-08d5cf600bef","name":"MAORI S/A","commercialName":"","cnpj":"02535295000126","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":""},{"id":"fad1f092-618f-4a25-725d-08d5cf600bef","name":"SOMOS EDUCACAO S.A.","commercialName":"","cnpj":"02541982000154","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":""},{"id":"ca650912-778a-4136-7258-08d5cf600bef","name":"TELINVEST S/A","commercialName":"","cnpj":"02476710000118","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":""},{"id":"3fb0d3a4-c79e-4b52-7259-08d5cf600bef","name":"RUMO MALHA PAULISTA S.A.","commercialName":"","cnpj":"02502844000166","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":""},{"id":"c4c0efcd-caf7-4145-7264-08d5cf600bef","name":"REAL AI PIC SECURITIZADORA DE CRÉDITOS IMOBILIÁRIOS S.A.","commercialName":"","cnpj":"02643896000152","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":""},{"id":"8fafbc9d-1195-4d11-7261-08d5cf600bef","name":"CAPITALPART PARTICIPACOES S/A","commercialName":"","cnpj":"02591787000139","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":""},{"id":"0f545106-2cfa-4593-7262-08d5cf600bef","name":"INNCORP S.A.","commercialName":"","cnpj":"02604860000160","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":""},{"id":"98e5dc22-b250-4c96-7269-08d5cf600bef","name":"PATRIA COMPANHIA SECURITIZADORA DE CREDITOS IMOBILIARIOS","commercialName":"","cnpj":"02736470000143","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":""},{"id":"8068ecfe-d0bb-453b-726a-08d5cf600bef","name":"BRAZILIAN FINANCE & REAL ESTATE S.A.","commercialName":"","cnpj":"02762113000150","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":""},{"id":"2b1f7353-f254-4b34-7267-08d5cf600bef","name":"PAN ARRENDAMENTO MERCANTIL S.A.","commercialName":"","cnpj":"02682287000102","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":""},{"id":"0af8f839-c178-40a5-726e-08d5cf600bef","name":"RB CAPITAL COMPANHIA DE SECURITIZACAO","commercialName":"","cnpj":"02773542000122","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":""},{"id":"2d8c5ca2-cc1b-451d-726f-08d5cf600bef","name":"ALTERE SECURITIZADORA S.A.","commercialName":"","cnpj":"02783423000150","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":""},{"id":"559c3337-9c3f-4e48-726c-08d5cf600bef","name":"SANTOS BRASIL PARTICIPACOES S.A.","commercialName":"","cnpj":"02762121000104","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":""},{"id":"2c694d53-ac79-4fbe-7273-08d5cf600bef","name":"CCR S.A.","commercialName":"","cnpj":"02846056000197","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":""},{"id":"7060b971-6e19-4870-7274-08d5cf600bef","name":"T4F ENTRETENIMENTO S.A.","commercialName":"","cnpj":"02860694000162","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":""},{"id":"8252df51-e4f4-4abe-7276-08d5cf600bef","name":"ARTERIS S.A.","commercialName":"","cnpj":"02919555000167","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":""},{"id":"2f593da4-0793-4b34-7277-08d5cf600bef","name":"HYPERA S.A.","commercialName":"HYPERA PHARMA","cnpj":"02932074000191","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":""},{"id":"8e7f91a2-f507-43c9-7278-08d5cf600bef","name":"PDG REALTY S/A EMPREENDIMENTOS E PARTICIPACOES","commercialName":"","cnpj":"02950811000189","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":""},{"id":"3baa4281-87b7-4ada-727c-08d5cf600bef","name":"CTEEP - COMPANHIA DE TRANSMISSAO DE ENERGIA ELETRICA PAULISTA","commercialName":"TRANSMISSAO PAULISTA","cnpj":"02998611000104","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":""},{"id":"de1be695-180d-40a5-727d-08d5cf600bef","name":"TPI - TRIUNFO PARTICIPACOES E INVESTIMENTOS S.A.","commercialName":"TRIUNFO PARTICIPACOES S.A.","cnpj":"03014553000191","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":""},{"id":"38aa27a6-5158-4f0a-7288-08d5cf600bef","name":"BRAZILIAN SECURITIES COMPANHIA DE SECURITIZACAO","commercialName":"","cnpj":"03767538000114","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":""},{"id":"b1ce2bed-fe78-4190-7289-08d5cf600bef","name":"BRADESPAR S.A.","commercialName":"BRADESPAR S.A.","cnpj":"03847461000192","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":""},{"id":"3e891191-aa89-47ee-728a-08d5cf600bef","name":"EDP - ENERGIAS DO BRASIL S.A.","commercialName":"","cnpj":"03983431000103","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":""},{"id":"ff3e29de-4cb3-45b5-728b-08d5cf600bef","name":"CABINDA PARTICIPACOES S/A","commercialName":"","cnpj":"04030182000102","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":""},{"id":"e133c44f-d4a1-48b9-728c-08d5cf600bef","name":"CACONDE PARTICIPACOES S/A","commercialName":"","cnpj":"04031213000131","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":""},{"id":"12e8097d-1a3d-4769-728e-08d5cf600bef","name":"LIQ PARTICIPACOES S.A.","commercialName":"","cnpj":"04032433000180","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":""},{"id":"8d57c7a2-7aa9-4b78-728f-08d5cf600bef","name":"DOMMO EMPREENDIMENTOS IMOBILIARIOS LTDA.","commercialName":"","cnpj":"04034792000176","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":""},{"id":"40d25a2f-3863-4db8-7290-08d5cf600bef","name":"CAIANDA PARTICIPACOES S/A","commercialName":"","cnpj":"04038763000182","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":""},{"id":"d21f2e78-1a0b-44f1-7291-08d5cf600bef","name":"SENIOR SOLUTION S.A.","commercialName":"SENIOR","cnpj":"04065791000199","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":""},{"id":"56e2153c-1de1-41e4-7292-08d5cf600bef","name":"ECORODOVIAS INFRAESTRUTURA E LOGISTICA S/A","commercialName":"","cnpj":"04149454000180","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":""},{"id":"610e5198-7200-4ab7-7214-08d5cf600bef","name":"KOSMOS COMERCIO DE VESTUARIO S/A - EM RECUPERACAO JUDICIAL","commercialName":"","cnpj":"00354053000100","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":""},{"id":"5d5546cf-fef9-45a7-7223-08d5cf600bef","name":"COMERCIAL QUINTELLA COMERCIO E EXPORTACAO S.A.- EM LIQUIDACAO","commercialName":"","cnpj":"00994533000136","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":""},{"id":"98bce39b-5fa3-467f-7227-08d5cf600bef","name":"ITAITINGA PARTICIPACOES S.A.","commercialName":"","cnpj":"01258943000181","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":""},{"id":"b2745c87-3eb6-41dc-722c-08d5cf600bef","name":"GAFISA S/A.","commercialName":"","cnpj":"01545826000107","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":""},{"id":"2747b70a-4462-4249-7229-08d5cf600bef","name":"GRUCAI PARTICIPACOES S/A","commercialName":"","cnpj":"01258945000170","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":""},{"id":"edbe0c21-d2a0-4973-722a-08d5cf600bef","name":"WTC AMAZONAS SUITE HOTEL S.A.","commercialName":"WTC AMAZONAS","cnpj":"01319044000141","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":""},{"id":"f90b04f6-e16e-48ac-722e-08d5cf600bef","name":"INVESTIMENTOS BEMGE S/A","commercialName":"","cnpj":"01548981000179","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":""},{"id":"696db5e4-c4d6-4d1e-723b-08d5cf600bef","name":"NUMERAL 80 PARTICIPACOES S/A","commercialName":"","cnpj":"02084220000176","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":""},{"id":"7d94fbac-e996-4e2e-723c-08d5cf600bef","name":"CIBRASEC-COMPANHIA BRASILEIRA DE SECURITIZACAO","commercialName":"CIBRASEC","cnpj":"02105040000123","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":""},{"id":"08f21534-84b5-4c0f-7239-08d5cf600bef","name":"WTC RIO EMPREENDIMENTOS E PARTICIPACOES S.A.","commercialName":"WTC RIO","cnpj":"01989044000159","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":""},{"id":"adc688e8-2461-48a5-72e1-08d5cf600bef","name":"NOVA SECURITIZACAO S.A.","commercialName":"","cnpj":"08903116000142","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":""},{"id":"1e757e02-0905-45d8-72e3-08d5cf600bef","name":"MULTINER S.A.","commercialName":"","cnpj":"08935054000150","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":""},{"id":"5342870b-e2a7-4308-72de-08d5cf600bef","name":"TRISUL S.A.","commercialName":"","cnpj":"08811643000127","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":""},{"id":"adac8d90-8175-443b-72d2-08d5cf600bef","name":"RENOVA ENERGIA S/A","commercialName":"","cnpj":"08534605000174","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":""},{"id":"82a241f9-f220-4462-72da-08d5cf600bef","name":"GENERAL SHOPPING E OUTLETS DO BRASIL S.A","commercialName":"","cnpj":"08764621000153","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":""},{"id":"89f2a40d-6173-4474-72db-08d5cf600bef","name":"ISEC SECURITIZADORA S.A.","commercialName":"","cnpj":"08769451000108","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":""},{"id":"0318433d-b2d8-44e4-72dc-08d5cf600bef","name":"CYRELA COMMERCIAL PROPERTIES S.A. EMPREENDIMENTOS E PARTICIPACOES","commercialName":"","cnpj":"08801621000186","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":""},{"id":"c74bd0c3-61a8-4e19-72d5-08d5cf600bef","name":"SETIBA PARTICIPACOES S.A.","commercialName":"","cnpj":"08638269000100","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":""},{"id":"31f372e7-8e34-44d2-72d6-08d5cf600bef","name":"ALLIS PARTICIPACOES S.A.","commercialName":"","cnpj":"08648295000119","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":""},{"id":"6589097a-54c2-4324-72d7-08d5cf600bef","name":"BRC SECURITIZADORA S.A.","commercialName":"","cnpj":"08653753000108","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":""},{"id":"c1a5e492-3ab9-4b8c-72cf-08d5cf600bef","name":"JHS F PARTICIPACOES S.A.","commercialName":"","cnpj":"08294224000165","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":""},{"id":"f57b61ab-c264-4b33-72d0-08d5cf600bef","name":"EZ TEC EMPREENDIMENTOS E PARTICIPACOES S/A","commercialName":"","cnpj":"08312229000173","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":""},{"id":"838fb29b-37bf-4958-72c2-08d5cf600bef","name":"TEGRA INCORPORADORA S.A.","commercialName":"","cnpj":"07700557000184","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":""},{"id":"1780acac-562e-4980-72c3-08d5cf600bef","name":"BRPR 55 SECURITIZADORA DE CREDITOS IMOBILIARIOS S.A.","commercialName":"","cnpj":"07710591000130","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":""},{"id":"1c6e2741-4975-4ee8-72cb-08d5cf600bef","name":"TECNISA S.A.","commercialName":"","cnpj":"08065557000112","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":""},{"id":"82e625be-82af-44c6-72cc-08d5cf600bef","name":"LPS BRASIL - CONSULTORIA DE IMOVEIS S/A.","commercialName":"","cnpj":"08078847000109","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":""},{"id":"eec0c13a-9423-4418-72cd-08d5cf600bef","name":"IGUA SANEAMENTO S.A.","commercialName":"","cnpj":"08159965000133","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":""},{"id":"1617180f-5a70-4a14-72be-08d5cf600bef","name":"UNI CIDADE SP TRUST DE RECEBIVEIS S A","commercialName":"","cnpj":"07394616000133","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":""},{"id":"2c7225b0-c3bb-4153-72bf-08d5cf600bef","name":"CHINA CONSTRUCTION BANK (BRASIL) BANCO MULTIPLO S/A","commercialName":"CCB BRASIL","cnpj":"07450604000189","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":""},{"id":"0bf49250-85bf-4395-72c0-08d5cf600bef","name":"GAIA SECURITIZADORA S.A.","commercialName":"GAIA SECURITIZADORA S.A.","cnpj":"07587384000130","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":""},{"id":"66cdb87b-0fdf-4851-72a1-08d5cf600bef","name":"TARPON INVESTIMENTOS S.A.","commercialName":"","cnpj":"05341549000163","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":""},{"id":"0f0516c4-97d9-4c33-72a3-08d5cf600bef","name":"TERRA SANTA AGRO S.A.","commercialName":"","cnpj":"05799312000120","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":""},{"id":"3c379c36-fde5-4ec8-72a4-08d5cf600bef","name":"SONAE SIERRA BRASIL S.A.","commercialName":"","cnpj":"05878397000132","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":""},{"id":"130abe6a-08dd-47ec-72a5-08d5cf600bef","name":"CSA - COMPANHIA SECURITIZADORA DE ATIVOS","commercialName":"","cnpj":"05889284000132","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":""},{"id":"f74f6b12-606c-447b-72a6-08d5cf600bef","name":"PIPA SERVICOS EMPRESARIAIS LTDA.","commercialName":"","cnpj":"05918309000189","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":""},{"id":"c5097e2b-6ea0-43fb-72a7-08d5cf600bef","name":"FIBRA COMPANHIA SECURITIZADORA DE CREDITOS IMOBILIARIOS","commercialName":"","cnpj":"06018000000103","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":""},{"id":"2b79df5e-0174-4dc9-7298-08d5cf600bef","name":"UNIDAS S.A.","commercialName":"UNIDAS RENT A CAR","cnpj":"04437534000130","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":""},{"id":"b3ee3819-5493-46e1-7296-08d5cf600bef","name":"REC SAO BERNARDO S.A.","commercialName":"","cnpj":"04370450000127","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":""},{"id":"5ffbd4d3-2448-4b3c-7284-08d5cf600bef","name":"RB CAPITAL SECURITIZADORA S.A.","commercialName":"","cnpj":"03559006000191","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":""},{"id":"e49b0ff9-968f-4ddb-72b2-08d5cf600bef","name":"BR PROPERTIES S.A.","commercialName":"","cnpj":"06977751000149","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":""},{"id":"302e7ea7-b712-4d5d-72b3-08d5cf600bef","name":"BETA SECURITIZADORA S.A.","commercialName":"","cnpj":"07021459000110","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":""},{"id":"0afec7a9-b198-42cd-72b4-08d5cf600bef","name":"BRE PONTE IV EMPREENDIMENTOS E PARTICIPACOES S.A","commercialName":"","cnpj":"07033882000130","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":""},{"id":"c9a4d497-0bf4-445a-72b8-08d5cf600bef","name":"B.I. COMPANHIA SECURITIZADORA S/A","commercialName":"","cnpj":"07112325000105","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":""},{"id":"3860b4c7-7e54-4215-72b9-08d5cf600bef","name":"BRAZIL REALTY - COMPANHIA SECURITIZADORA DE CREDITOS IMOBILIARIOS","commercialName":"","cnpj":"07119838000148","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":""},{"id":"1d0ba4d0-b096-4861-72b6-08d5cf600bef","name":"BRPR 45 EMPREENDIMENTOS IMOBILIARIOS E PARTICIPACOES LTDA","commercialName":"","cnpj":"07088416000152","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":""},{"id":"e784f401-3329-47e7-72ab-08d5cf600bef","name":"BRPR 56 SECURITIZADORA DE CREDITOS IMOBILIARIOS S.A.","commercialName":"","cnpj":"06137677000152","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":""},{"id":"a8dc457f-00e1-4c28-72ac-08d5cf600bef","name":"GOL LINHAS AEREAS INTELIGENTES S.A.","commercialName":"","cnpj":"06164253000187","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":""},{"id":"39bea80a-d2c3-484e-72ad-08d5cf600bef","name":"REC 844 EMPREENDIMENTOS E PARTICIPACOES S.A.","commercialName":"","cnpj":"06349242000171","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":""},{"id":"c5ebb545-c17b-4175-729b-08d5cf600bef","name":"BRE PONTE III EMPREENDIMENTOS E PARTICIPACOES S.A","commercialName":"","cnpj":"04800265000125","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":""},{"id":"b1a0e9d2-3c48-4016-72af-08d5cf600bef","name":"LINX S.A.","commercialName":"","cnpj":"06948969000175","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":""},{"id":"1c8bb02e-4082-4e39-7316-08d5cf600bef","name":"COMPANHIA PAULISTA DE SECURITIZACAO","commercialName":"COMPANHIA PAULISTA DE SECURITIZACAO","cnpj":"11274829000107","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":""},{"id":"9d7ed15b-9342-4ec9-7317-08d5cf600bef","name":"BRASIL PHARMA S.A.","commercialName":"","cnpj":"11395624000171","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":""},{"id":"0070ae6c-59cb-4197-7310-08d5cf600bef","name":"BRAZAL - BRASIL ALIMENTOS S.A.","commercialName":"","cnpj":"10826798000189","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":""},{"id":"bd5554af-5532-4e4c-730e-08d5cf600bef","name":"ECO SECURITIZADORA DE DIREITOS CREDITORIOS DO AGRONEGOCIO SA","commercialName":"ECO SECURITIZADORA","cnpj":"10753164000143","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":""},{"id":"5edfa851-2201-4663-7308-08d5cf600bef","name":"BARIGUI SECURITIZADORA S.A.","commercialName":"","cnpj":"10608405000160","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":""},{"id":"1153abc6-2f09-4b1c-7325-08d5cf600bef","name":"OURINVEST SECURITIZADORA S.A.","commercialName":"","cnpj":"12320349000190","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":""},{"id":"e62a6119-627b-4350-731b-08d5cf600bef","name":"TRX SECURITIZADORA S.A.","commercialName":"","cnpj":"11716471000117","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":""},{"id":"a64e4f94-4245-4869-731c-08d5cf600bef","name":"BR INSURANCE CORRETORA DE SEGUROS S.A.","commercialName":"","cnpj":"11721921000160","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":""},{"id":"a8d292cb-afd1-4e44-731d-08d5cf600bef","name":"QUALICORP S.A.","commercialName":"","cnpj":"11992680000193","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":""},{"id":"3ef6ace3-f770-4025-7322-08d5cf600bef","name":"APICE SECURITIZADORA S.A.","commercialName":"","cnpj":"12130744000100","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":""},{"id":"4a36920d-ecb7-4615-7323-08d5cf600bef","name":"OCTANTE SECURITIZADORA S.A","commercialName":"","cnpj":"12139922000163","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":""},{"id":"6eb71b8c-a602-420f-72f1-08d5cf600bef","name":"HABITASEC SECURITIZADORA S.A.","commercialName":"","cnpj":"09304427000158","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":""},{"id":"62216c4b-e1d0-4780-72ef-08d5cf600bef","name":"ANIMA HOLDING S.A.","commercialName":"","cnpj":"09288252000132","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":""},{"id":"a8c016a0-7494-4102-72ed-08d5cf600bef","name":"MONTICIANO PARTICIPACOES S.A.","commercialName":"","cnpj":"09191251000175","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":""},{"id":"26cea2a3-6168-4f4f-72e8-08d5cf600bef","name":"INBRANDS S.A","commercialName":"","cnpj":"09054385000144","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":""},{"id":"4411f3a0-17c8-42df-72e5-08d5cf600bef","name":"VISION SECURITIZADORA S.A.","commercialName":"","cnpj":"08937002000113","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":""},{"id":"3ebc166b-5e13-46bb-72fa-08d5cf600bef","name":"AQUILLA SECURITIZADORA S.A.","commercialName":"","cnpj":"09439783000189","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":""},{"id":"f972cf62-da3b-4fc4-72fb-08d5cf600bef","name":"BASEL PARTICIPACOES S.A.","commercialName":"","cnpj":"09462140000156","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":""},{"id":"904774ca-3ed2-4f69-72fd-08d5cf600bef","name":"PDG COMPANHIA SECURITIZADORA","commercialName":"","cnpj":"09538973000153","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":""},{"id":"c7fc14f7-26bc-402f-7304-08d5cf600bef","name":"SWEET COSMETICOS S.A.","commercialName":"SWEET COSMETICS","cnpj":"10345009000198","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":""},{"id":"2ed48e60-5de9-4337-7306-08d5cf600bef","name":"INFRASEC SECURITIZADORA S.A.","commercialName":"","cnpj":"10488244000119","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":""},{"id":"4e2712cf-9fe1-4693-7300-08d5cf600bef","name":"COMPANHIA DE LOCACAO DAS AMERICAS","commercialName":"","cnpj":"10215988000160","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":""},{"id":"98264590-c7e0-4233-73ae-08d5cf600bef","name":"ROSSI RESIDENCIAL SA","commercialName":"","cnpj":"61065751000180","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":""},{"id":"10eb062e-97ef-46f1-73a8-08d5cf600bef","name":"ITAU UNIBANCO HOLDING S.A.","commercialName":"","cnpj":"60872504000123","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":""},{"id":"d1ad953c-4797-4cb9-73aa-08d5cf600bef","name":"BANCO SOFISA S.A.","commercialName":"","cnpj":"60889128000180","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":""},{"id":"7d468807-0b7a-4ef1-73ab-08d5cf600bef","name":"CONSTRUTORA ADOLPHO LINDENBERG S/A","commercialName":"CAL S/A","cnpj":"61022042000118","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":""},{"id":"c6228634-37cb-4544-73ac-08d5cf600bef","name":"BANCO INDUSVAL SA","commercialName":"","cnpj":"61024352000171","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":""},{"id":"c689f344-bbeb-44f7-73a6-08d5cf600bef","name":"BANCO ALFA DE INVESTIMENTO S.A.","commercialName":"","cnpj":"60770336000165","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":""},{"id":"04950148-a6e5-4ea5-7395-08d5cf600bef","name":"HSBC BRASIL S.A. - BANCO DE INVESTIMENTO","commercialName":"","cnpj":"53518684000184","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":""},{"id":"4416adff-4a2d-4937-7396-08d5cf600bef","name":"VERTERE PARTICIPACOES S.A.","commercialName":"","cnpj":"53790218000153","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":""},{"id":"5ae6397a-d086-4064-7397-08d5cf600bef","name":"ITAUTEC S.A. - GRUPO ITAUTEC","commercialName":"","cnpj":"54526082000131","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":""},{"id":"f8c464e5-84df-4e2b-7398-08d5cf600bef","name":"HAUSCENTER S/A.","commercialName":"HAUSCENTER","cnpj":"56444250000175","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":""},{"id":"255a5cb2-1482-4cbf-7399-08d5cf600bef","name":"EUCATEX S A INDUSTRIA E COMERCIO","commercialName":"","cnpj":"56643018000166","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":""},{"id":"727604e8-7f0c-44d7-73b0-08d5cf600bef","name":"MANUFATURA DE BRINQUEDOS ESTRELA S A","commercialName":"BRINQUEDOS ESTRELA","cnpj":"61082004000150","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":""},{"id":"0d3c6f1a-a133-4877-73b1-08d5cf600bef","name":"BRASMOTOR S A","commercialName":"","cnpj":"61084984000120","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":""},{"id":"e1a7af4e-833d-4c04-73b2-08d5cf600bef","name":"CAMBUCI S/A","commercialName":"PENALTY","cnpj":"61088894000108","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":""},{"id":"501f4414-d7a8-4577-73b4-08d5cf600bef","name":"SIDERURGICA J L ALIPERTI S A","commercialName":"","cnpj":"61156931000178","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":""},{"id":"03a31b49-c46d-4c68-73b5-08d5cf600bef","name":"CONSTRUTORA BETER S A","commercialName":"","cnpj":"61192373000104","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":""},{"id":"0e2498c6-d932-4df4-73b6-08d5cf600bef","name":"AZEVEDO & TRAVASSOS S/A","commercialName":"","cnpj":"61351532000168","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":""},{"id":"43ca9dc9-0804-4d92-73b8-08d5cf600bef","name":"ITAUSA-INVESTIMENTOS ITAU S/A.","commercialName":"","cnpj":"61532644000115","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":""},{"id":"3300cbdc-8697-4a61-73b9-08d5cf600bef","name":"PARAMOUNT TEXTEIS INDUSTRIA E COMERCIO SA","commercialName":"","cnpj":"61565222000146","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":""},{"id":"d5ede0a8-1a65-429f-73bb-08d5cf600bef","name":"RAIA DROGASIL S/A","commercialName":"","cnpj":"61585865000151","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":""},{"id":"5d382bbc-00b7-4cdb-73bd-08d5cf600bef","name":"COMPANHIA DE GAS DE SAO PAULO COMGAS","commercialName":"","cnpj":"61856571000117","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":""},{"id":"58c8a982-5b8f-454c-73be-08d5cf600bef","name":"SAO PAULO TURISMO S/A","commercialName":"PARQUE ANHEMBI","cnpj":"62002886000160","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":""},{"id":"bc49da15-6a74-482d-73bf-08d5cf600bef","name":"SAFRA LEASING SA ARRENDAMENTO MERCANTIL","commercialName":"","cnpj":"62063177000194","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":""},{"id":"534e86b1-afae-4558-73c0-08d5cf600bef","name":"BANCO PINE S/A","commercialName":"","cnpj":"62144175000120","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":""},{"id":"6bd6ad3d-ab44-44dc-73c1-08d5cf600bef","name":"BANCO DAYCOVAL S/A","commercialName":"","cnpj":"62232889000190","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":""},{"id":"f771e3e7-666a-4034-738d-08d5cf600bef","name":"SANTANDER LEASING S.A. ARRENDAMENTO MERCANTIL","commercialName":"","cnpj":"47193149000106","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":""},{"id":"668d0e22-3c43-4bed-7392-08d5cf600bef","name":"IGUATEMI EMPRESA DE SHOPPING CENTERS S/A","commercialName":"","cnpj":"51218147000193","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":""},{"id":"348676b1-4ae5-40d8-739e-08d5cf600bef","name":"BANCO PAN S.A.","commercialName":"","cnpj":"59285411000113","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":""},{"id":"4052874e-8b4f-426b-739f-08d5cf600bef","name":"POLPAR S/A","commercialName":"","cnpj":"59789545000171","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":""},{"id":"3a27379a-bfcc-4f5b-73a0-08d5cf600bef","name":"SARAIVA SA LIVREIROS EDITORES","commercialName":"","cnpj":"60500139000126","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":""},{"id":"93604d34-3edd-4fc0-73a1-08d5cf600bef","name":"JEREISSATI PARTICIPACOES S.A","commercialName":"","cnpj":"60543816000193","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":""},{"id":"e834dbc1-4622-4b9d-73a2-08d5cf600bef","name":"INDUSTRIAS J.B. DUARTE S/A.","commercialName":"","cnpj":"60637238000154","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":""},{"id":"c407617e-4a1b-4d28-73a3-08d5cf600bef","name":"SUZANO HOLDING S.A.","commercialName":"","cnpj":"60651809000105","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":""},{"id":"83263bed-81cf-4aad-73a4-08d5cf600bef","name":"COMPANHIA MELHORAMENTOS DE SAO PAULO","commercialName":"MELHORAMENTOS","cnpj":"60730348000166","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":""},{"id":"fbc3c03d-00db-40b2-7384-08d5cf600bef","name":"RUMO MALHA OESTE S.A.","commercialName":"","cnpj":"39115514000128","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":""},{"id":"3c5e4a5d-6563-4aeb-738a-08d5cf600bef","name":"BAHEMA SA","commercialName":"","cnpj":"45987245000192","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":""},{"id":"bc8b9b1e-c75e-4d65-7388-08d5cf600bef","name":"EVEN CONSTRUTORA E INCORPORADORA S/A","commercialName":"EVEN","cnpj":"43470988000165","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":""},{"id":"368c7d6b-f7fc-4b4c-7381-08d5cf600bef","name":"BMG LEASING SA ARRENDAMENTO MERCANTIL","commercialName":"","cnpj":"34265561000134","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":""},{"id":"97f958d4-55c0-4ae1-7346-08d5cf600bef","name":"GAIA AGRO SECURITIZADORA S.A.","commercialName":"","cnpj":"14876090000193","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":""},{"id":"5ff81c30-dd88-478e-7347-08d5cf600bef","name":"FRIGOL FOODS PARTICIPACOES S.A.","commercialName":"FRIGOL FOODS","cnpj":"14962356000110","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":""},{"id":"fcf8ad85-3cd2-4bd1-733e-08d5cf600bef","name":"NAOMI PARTICIPACOES S.A.","commercialName":"","cnpj":"14200586000142","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":""},{"id":"cb78347f-ea74-414d-733f-08d5cf600bef","name":"BELEZA PARTICIPACOES S.A.","commercialName":"","cnpj":"14200618000100","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":""},{"id":"872f540d-24d1-4020-7340-08d5cf600bef","name":"NOAH PARTICIPACOES S.A.","commercialName":"","cnpj":"14200699000148","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":""},{"id":"de38a923-4d15-40e8-7341-08d5cf600bef","name":"BR TOWERS SPE1 S.A.","commercialName":"","cnpj":"14206371000139","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":""},{"id":"220a35a3-5f4f-473f-7337-08d5cf600bef","name":"HARPIA OMEGA PARTICIPACOES S.A.","commercialName":"","cnpj":"13407573000186","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":""},{"id":"efeadb93-4522-4c3f-7333-08d5cf600bef","name":"HIDROVIAS DO BRASIL S.A.","commercialName":"","cnpj":"12648327000153","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":""},{"id":"b208c5f1-ea86-4b83-7334-08d5cf600bef","name":"FORTE SECURITIZADORA S.A.","commercialName":"","cnpj":"12979898000170","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":""},{"id":"8e9ddfd1-da60-41bf-7331-08d5cf600bef","name":"BRASIL PLURAL SECURITIZADORA S.A.","commercialName":"","cnpj":"12610764000188","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":""},{"id":"5fb2a40e-e1df-4cf9-735c-08d5cf600bef","name":"CONSORCIO ALFA DE ADMINISTRACAO S.A","commercialName":"","cnpj":"17193806000146","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":""},{"id":"c38c2a86-1fcd-4077-7359-08d5cf600bef","name":"ALFA HOLDINGS S.A.","commercialName":"","cnpj":"17167396000169","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":""},{"id":"d5f37d93-53ef-4ee7-735a-08d5cf600bef","name":"FINANCEIRA ALFA S.A. CREDITO, FINANCIAMENTO E INVESTIMENTOS","commercialName":"","cnpj":"17167412000113","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":""},{"id":"cd873cdc-2e41-4e03-735e-08d5cf600bef","name":"INTERNATIONAL MEAL COMPANY ALIMENTACAO S.A.","commercialName":"","cnpj":"17314329000120","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":""},{"id":"cacfcdf4-77e8-41c0-736d-08d5cf600bef","name":"SAO CARLOS EMPREENDIMENTOS E PARTICIPACOES S.A","commercialName":"","cnpj":"29780061000109","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":""},{"id":"31d36b88-9e4d-4d38-736a-08d5cf600bef","name":"BANCO ABC BRASIL S.A.","commercialName":"","cnpj":"28195667000106","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":""},{"id":"4f37fd69-7ebd-4cd1-7379-08d5cf600bef","name":"ULTRAPAR PARTICIPACOES S/A","commercialName":"","cnpj":"33256439000139","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":""},{"id":"a4b7139c-083f-4964-7370-08d5cf600bef","name":"BANCO INDUSTRIAL DO BRASIL S/A","commercialName":"","cnpj":"31895683000116","city":"SÃO PAULO","stateCode":"SP","buscaAdicional":""},{"id":"29c60661-ba1b-4b53-6640-08d5ad2bf6ba","name":"ORGANIZACAO HOTELEIRA FONTE COLINA VERDE LTDA","commercialName":"","cnpj":"49631344000198","city":"SÃO PEDRO","stateCode":"SP","buscaAdicional":"HOTEL COLINA VERDE 57419 HOT COLINA VERISSIMO 908299 HOT COLINA FRANZIM 908300"},{"id":"81ab5808-eb96-402a-6620-08d5ad2bf6ba","name":"SUPER MERCADO SAO ROQUE LTDA.","commercialName":"","cnpj":"45495694000113","city":"SÃO ROQUE","stateCode":"SP","buscaAdicional":"SUPER SAO ROQUE 57331 SUPER S ROQUE AVENID 908417 SUPER S ROQUE MAIRIN 908418 SUPER S ROQUE IBIUNA 908394 SUPER S ROQUE CENTRO 908419 SAO ROQUE 2036288833 911982"},{"id":"21064693-acce-41d2-674c-08d5ad2bf6ba","name":"LAVSIM - HIGIENIZACAO TEXTIL S.A.","commercialName":"LAVSIM","cnpj":"03545820000157","city":"SÃO ROQUE","stateCode":"SP","buscaAdicional":"LAVSIM 58033 LAVSIM SAO ROQUE 909417"},{"id":"a932893d-6e02-4674-68a1-08d5ad2bf6ba","name":"FABRICA DE ARTEFATOS DE LATEX SAO ROQUE LTDA","commercialName":"","cnpj":"70939574000105","city":"SÃO ROQUE","stateCode":"SP","buscaAdicional":"LATEX SR 60232 LATEX SR 910404"},{"id":"cba31622-6e77-4219-64ed-08d5ad2bf6ba","name":"QUINTA DO MARQUES RESTAURANTE E LANCHES LTDA","commercialName":"QUINTA DO MARQUES","cnpj":"11384785000160","city":"SÃO ROQUE","stateCode":"SP","buscaAdicional":"QUINTA DO MARQUES CASTELO 56316 QUINTA DO MARQUES 907668"},{"id":"37787f3b-551d-42c8-6433-08d5ad2bf6ba","name":"CAMBUCI S/A","commercialName":"","cnpj":"61088894000884","city":"SÃO ROQUE","stateCode":"SP","buscaAdicional":"CAMBUCI SAO ROQUE 55878 CAMBUCI SA 907960"},{"id":"eaa3116c-dde1-4a42-5d35-08d5ad2bf6ba","name":"HERSHEY DO BRASIL LTDA","commercialName":"","cnpj":"04429377000111","city":"SÃO ROQUE","stateCode":"SP","buscaAdicional":"HERSHEY 51735 HERSHEY S ROQUE 898806"},{"id":"bfc07b6d-9770-4d41-5d16-08d5ad2bf6ba","name":"METALURGICA METALVIC LIMITADA","commercialName":"METALVIC","cnpj":"43977305000160","city":"SÃO ROQUE","stateCode":"SP","buscaAdicional":"METALVIC 51698 METALURGICA METALVIC 900040"},{"id":"4aabb0d1-a932-4c20-5898-08d5ad2bf6ba","name":"CONSORCIO CONDOMINIO CATARINA FASHION OUTLET","commercialName":"","cnpj":"18626057000166","city":"SÃO ROQUE","stateCode":"SP","buscaAdicional":"OUTLET CATARINA 12652 OUTLET CATARINA 894002"},{"id":"9b689f9d-1ad3-4c12-563b-08d5ad2bf6ba","name":"SAINT-GOBAIN DO BRASIL PRODUTOS INDUSTRIAIS E PARA CONSTRUCAO LTDA","commercialName":"GLASS","cnpj":"61064838008460","city":"SÃO VICENTE","stateCode":"SP","buscaAdicional":"SGGLASS SVICEN 6802 SAINT GOBAIN S VIC 72116"},{"id":"8b55ae5d-7cc1-468a-6530-08d5ad2bf6ba","name":"UNIMETAL SAO VICENTE INDUSTRIA, COMERCIO E EMPREENDIMENTOS LTDA.","commercialName":"","cnpj":"03116586000142","city":"SÃO VICENTE","stateCode":"SP","buscaAdicional":"LITORAL COQUE 56586 LITORAL COQUE S VICE 907608"},{"id":"fce21a93-d5df-4a4f-5ece-08d5ad2bf6ba","name":"PNEUS SARAPUI COMERCIO E RECICLAGEM DE BORRACHAS EIRELI","commercialName":"","cnpj":"00278019000102","city":"SARAPUÍ","stateCode":"SP","buscaAdicional":"PNEUS SARAPUI 52557 PNEUS SARAPUI SP 901073"},{"id":"3eb3a49f-0d54-42d7-518c-08d5ad2bf6ba","name":"CERPA CENTRAL ENERGETICA RIO PARDO S/A","commercialName":"CERPA","cnpj":"04685041000110","city":"SERRANA","stateCode":"SP","buscaAdicional":"CERPA 2365 CONSUMO PEDRA SERRAN 909852 USINA DA PEDRA 8335 UTE.AI.SP.002019-2.01 PEDRA INTERLIG 895621"},{"id":"5d84d7c5-4603-45c4-5170-08d5ad2bf6ba","name":"FUNDICAO MORENO LTDA","commercialName":"","cnpj":"02483898000121","city":"SERTÃOZINHO","stateCode":"SP","buscaAdicional":"FUNDICAO MORENO 2170 FUNDICAO MORENO 892022"},{"id":"0d87934d-994d-40e0-51ad-08d5ad2bf6ba","name":"BIOSEV BIOENERGIA S.A.","commercialName":"BIOSEV BIOENERGIA","cnpj":"49213747011828","city":"SERTÃOZINHO","stateCode":"SP","buscaAdicional":"SANTELISA 2495 BIOSEV BIOENERGIA 909407 VALE DO ROSARIO CONS 912835 SANTA ELISA 528 UTE.AI.SP.028232-4.01 VALE DO ROSARIO 524 UTE.AI.SP.002958-0.01"},{"id":"9687cbe1-d065-4d29-5ee9-08d5ad2bf6ba","name":"COOPERATIVA DOS PLANTADORES DE CANA DO OESTE DO ESTADO DE SAO PAULO","commercialName":"COPERCANA","cnpj":"71320915000122","city":"SERTÃOZINHO","stateCode":"SP","buscaAdicional":"COPERCANA 52607 COPECARNA UNAME 900844 COPERCANA PITANGUEIR 900846 COPERCANA JABOTICABA 900854 COPERCANA SERRANA 900856 COPERCANA PONTAL 900857 COPERCANA FERRAGENS 900859 COPERCANA SERTAOZINH 900860"},{"id":"9a17f5ca-3620-4feb-58c4-08d5ad2bf6ba","name":"TGM INDUSTRIA E COMERCIO DE TURBINAS E TRANSMISSOES LTDA","commercialName":"TGM INDUSTRIA","cnpj":"05729768000114","city":"SERTÃOZINHO","stateCode":"SP","buscaAdicional":"TGM 13232 TGM SERTAOZINHO 891402 TGM SERTAOZINHO 2 901635"},{"id":"c012ff42-45aa-4c50-591d-08d5ad2bf6ba","name":"SAVEGNAGO-SUPERMERCADOS LTDA","commercialName":"SUPER MERCADO SAVEGNAGO","cnpj":"71322150000160","city":"SERTÃOZINHO","stateCode":"SP","buscaAdicional":"SAVEGNAGO 13836 SAVEGNAGO LJ08 892663 SAVEGNAGO LJ09 892683 SAVEGNAGO LJ16 892684 SAVEGNAGO LJ26 892685 SAVEGNAGO LJ05 892705 SAVEGNAGO LJ06 892706 SAVEGNAGO LJ14 892962 SAVEGNAGO LJ15 892963 SAVEGNAGO LJ18 892964 SAVEGNAGO LJ20 892965 SAVEGNAGO LJ27 892966 SAVEGNAGO LJ23 892967 SAVEGNAGO LJ25 892968 SAVEGNAGO LJ28 892982 SAVEGNAGO LJ30 894082 SAVEGNAGO LJ 01 894122 SAVEGNAGO LJ 11 894123 SAVEGNAGO LJ 12 894124 SAVEGNAGO LJ 13 894125 SAVEGNAGO LJ 17 894126 SAVEGNAGO LJ 19 894127 SAVEGNAGO LJ 22 894128 SAVEGNAGO LJ31 894563 SAVEGNAGO LJ29 894564 SAVEGNAGO 511 CD 894826 SAVEGNAGO LJ04 894845 SAVEGNAGO LJ02 895006 SAVEGNAGO LJ21 895008 SAVEGNAGO LJ10 895028 SAVEGNAGO LJ03 895129 SAVEGNAGO LJ24 895362 SAVEGNAGO LJ07 895501 SAVEGNAGO LJ32 898527 SAVEGNAGO LJ34 899126 SAVEGNAGO LJ35 899603 SAVEGNAGO LJ37 900735 SAVEGNAGO CA 900737 SAVEGNAGO LJ600 900760 SAVEGNAGO LJ36 902435 SAVEGNAGO LJ33 904694 SAVEGNAGO LOJA 38 909178 SAVEGNAGO 39 909588 SAVEGNAGO LJ40 910797 SAVEGNAGO 41252802 912376"},{"id":"c7e78beb-d3bb-49f5-5a5b-08d5ad2bf6ba","name":"USINA SAO FRANCISCO S/A","commercialName":"USINA SAO FRANCISCO","cnpj":"71324792000106","city":"SERTÃOZINHO","stateCode":"SP","buscaAdicional":"UTE SAO FRANCISCO 17364 S FRANCISCO CONSUMO 889194 S.FRANCISCO (BIOCOG) 529 UTE.AI.SP.027335-0.01"},{"id":"24a5055e-1f14-43b0-61e3-08d5ad2bf6ba","name":"IRMAOS TONIELLO LTDA","commercialName":"DESTILARIA SANTA INES","cnpj":"71321566000163","city":"SERTÃOZINHO","stateCode":"SP","buscaAdicional":"DESTILARIA SANTA INES 54457 DESTILARIA SANTA INE 905126"},{"id":"fddbae55-4146-4e97-6196-08d5ad2bf6ba","name":"SERT PLAST INDUSTRIA E COMERCIO LTDA","commercialName":"","cnpj":"64851884000170","city":"SERTÃOZINHO","stateCode":"SP","buscaAdicional":"SERT PLAST 54249 SERT PLAST 905130"},{"id":"6c91c8f0-a328-4f87-68da-08d5ad2bf6ba","name":"FAV - FUNDICAO AGUA VERMELHA EIRELI","commercialName":"FUNDICAO AGUA VERMELHA","cnpj":"61665527000120","city":"SERTÃOZINHO","stateCode":"SP","buscaAdicional":"FAV 60492 FAV - SERTAOZINHO - 912455"},{"id":"f5be43ed-0540-4775-68e6-08d5ad2bf6ba","name":"POLIPET - EMBALAGENS PLASTICAS LTDA","commercialName":"POLIPET","cnpj":"08915525000169","city":"SERTÃOZINHO","stateCode":"SP","buscaAdicional":"POLIPET 60535 POLIPET 902006"},{"id":"c886297a-e2da-4c14-663b-08d5ad2bf6ba","name":"USINA SANTO ANTONIO S/A","commercialName":"USINA SANTO ANTONIO","cnpj":"71324784000151","city":"SERTÃOZINHO","stateCode":"SP","buscaAdicional":"USINA SANTO ANTONIO 57410 SANTO ANTONIO (CPFL) 405 UTE.AI.SP.028344-4.01"},{"id":"1a339692-295a-42e5-7251-08d5cf600bef","name":"VIANORTE S/A","commercialName":"","cnpj":"02366097000186","city":"SERTÃOZINHO","stateCode":"SP","buscaAdicional":""},{"id":"89389121-f9b9-4546-88cf-08d5ae44ed50","name":"PLAST-RC TRANSPORTE RODOVIARIO DE CARGAS EIRELI","commercialName":"","cnpj":"05273995000188","city":"SERTÃOZINHO","stateCode":"SP","buscaAdicional":"PLAST RC 52230"},{"id":"74a2260d-286a-4b0a-673c-08d5ad2bf6ba","name":"SOCORRO INDUSTRIA DE BEBIDAS LTDA.","commercialName":"","cnpj":"12314267000132","city":"SOCORRO","stateCode":"SP","buscaAdicional":"SOCORRO BEBIDAS 58011 SOCORRO BEBIDAS 909060"},{"id":"55ccb77d-7215-416d-66d6-08d5ad2bf6ba","name":"HURTH INFER INDUSTRIA DE MAQUINAS E FERRAMENTAS LTDA","commercialName":"","cnpj":"61241279000190","city":"SOROCABA","stateCode":"SP","buscaAdicional":"HURTH INFER 57850 HURTH INFER IND MAQ 907961"},{"id":"964ca54b-1b2c-4b74-658c-08d5ad2bf6ba","name":"JULIO JULIO MINERACAO LTDA","commercialName":"","cnpj":"10697220000170","city":"SOROCABA","stateCode":"SP","buscaAdicional":"JULIO JULIO 56818 JULIO JULIO SOROCABA 907779"},{"id":"cda508aa-3bfb-42e0-65c1-08d5ad2bf6ba","name":"PRYSMIAN CABOS E SISTEMAS DO BRASIL S/A","commercialName":"","cnpj":"61150751003366","city":"SOROCABA","stateCode":"SP","buscaAdicional":"PRYSMIAN CL 57052 PRYSMIAN CABOS E SIS 905772 PRYSMIAN SOROCABA 906822"},{"id":"e3d63c62-ace7-4de9-6612-08d5ad2bf6ba","name":"INTERPRINT LTDA","commercialName":"","cnpj":"42123091004513","city":"SOROCABA","stateCode":"SP","buscaAdicional":"INTERPRINT SOROCABA 57291 INTERPRINT SOROCABA 908513"},{"id":"bc95d30d-de6d-4470-65ec-08d5ad2bf6ba","name":"INSER INDUSTRIA, COMERCIO E SERVICOS LTDA.","commercialName":"INSER","cnpj":"05571100000191","city":"SOROCABA","stateCode":"SP","buscaAdicional":"INSER 57210 INSER SOROCABA 908294"},{"id":"62dc49e6-d3da-4c2d-65d5-08d5ad2bf6ba","name":"MOTO PECAS TRANSMISSOES SA","commercialName":"MOTO PECAS","cnpj":"16236440000182","city":"SOROCABA","stateCode":"SP","buscaAdicional":"MOTO PECAS 57155 MOTO PECAS 908676"},{"id":"9d1b6401-3ea4-4472-6956-08d5ad2bf6ba","name":"LINHANYL S A LINHAS PARA COSER","commercialName":"","cnpj":"61135315000130","city":"SOROCABA","stateCode":"SP","buscaAdicional":"LINHANYL MATRIZ 61058 LINHANYL PORT FELIZ 912951"},{"id":"249f9306-c293-4f2f-6813-08d5ad2bf6ba","name":"TAMBORE ALUMINIO LTDA","commercialName":"","cnpj":"20922940000145","city":"SOROCABA","stateCode":"SP","buscaAdicional":"TAMBORE ALUMINIO 59333 TAMBORE ALUMINIO SOR 909464"},{"id":"c0653563-b590-40f2-6829-08d5ad2bf6ba","name":"SIDOR INDUSTRIA E COMERCIO LTDA","commercialName":"RODIS IND E COMERCIO","cnpj":"61064846000180","city":"SOROCABA","stateCode":"SP","buscaAdicional":"SIDOR 59444 SIDOR IND E COM 909685"},{"id":"9db09caf-733a-4fa4-6140-08d5ad2bf6ba","name":"INTACTA SISTEMAS DE EMBALAGENS LTDA","commercialName":"","cnpj":"08049995000197","city":"SOROCABA","stateCode":"SP","buscaAdicional":"INTACTA EMBALAGENS 54073 INTACTA EMBALAGENS 903921"},{"id":"91cab4e6-d311-4ff9-6113-08d5ad2bf6ba","name":"ENGELO INDUSTRIA E COMERCIO LTDA","commercialName":"","cnpj":"64954266000237","city":"SOROCABA","stateCode":"SP","buscaAdicional":"ENGELO 53995 ENGELO 905162"},{"id":"f6a88d9d-4d12-41e2-611e-08d5ad2bf6ba","name":"CATALENT BRASIL LTDA.","commercialName":"CATALENT","cnpj":"45569555000197","city":"SOROCABA","stateCode":"SP","buscaAdicional":"CATALENT 54027 CATALENT 901063 CATALENT INDAIATUBA 903463"},{"id":"145e90d2-1127-44bf-6251-08d5ad2bf6ba","name":"SHOPPING CIDADE - SOROCABA","commercialName":"SHOPPING CIDADE - SOROCABA","cnpj":"13655148000106","city":"SOROCABA","stateCode":"SP","buscaAdicional":"SHOPPING CIDADE SOROCABA 54681 SHOP CIDADE SOROCABA 903821"},{"id":"94c051de-8f79-4597-6337-08d5ad2bf6ba","name":"INDUSTRIAS PGG - TECNOLOGIA EM ARAMES E CABOS ESPECIAIS LTDA","commercialName":"","cnpj":"22401311000103","city":"SOROCABA","stateCode":"SP","buscaAdicional":"INDUSTRIAS PGG 55247 INDUSTRIAS PGG - SOR 905980"},{"id":"3ed22542-464e-4f95-651f-08d5ad2bf6ba","name":"UNIMED DE SOROCABA COOPERATIVA DE TRABALHO MEDICO","commercialName":"UNIMED","cnpj":"45399961000230","city":"SOROCABA","stateCode":"SP","buscaAdicional":"UNIMED SOROCABA 56490 UNIMED SOROCABA 907936"},{"id":"073986dc-9e69-4746-64bf-08d5ad2bf6ba","name":"PLASTIC OMNIUM AUTO INERGY DO BRASIL LTDA.","commercialName":"","cnpj":"02814286000174","city":"SOROCABA","stateCode":"SP","buscaAdicional":"INERGY SOROCABA 56192 PLAS OMNIUM AUTO INE 910432"},{"id":"4d6366f6-6eff-4aba-648f-08d5ad2bf6ba","name":"DENTAL MORELLI LTDA","commercialName":"MORELLI ORTODONTIA","cnpj":"65441255000135","city":"SOROCABA","stateCode":"SP","buscaAdicional":"DENTAL MORELLI 56086 DENTAL MORELLI SOROC 907169"},{"id":"fdb7ba33-c98e-4ace-6362-08d5ad2bf6ba","name":"METALAC SPS INDUSTRIA E COMERCIO LTDA.","commercialName":"","cnpj":"44068211000131","city":"SOROCABA","stateCode":"SP","buscaAdicional":"METALAC SP 55332 METALAC 898828"},{"id":"eada1877-bc39-428b-637c-08d5ad2bf6ba","name":"BERICAP DO BRASIL LTDA","commercialName":"","cnpj":"02375722000156","city":"SOROCABA","stateCode":"SP","buscaAdicional":"BERICAP 55384 BERICAP 906851"},{"id":"30539d49-24b2-40fd-63b3-08d5ad2bf6ba","name":"FLEXTRONICS INTERNATIONAL TECNOLOGIA LTDA","commercialName":"","cnpj":"74404229000128","city":"SOROCABA","stateCode":"SP","buscaAdicional":"FLEXTRONICS 1 55529 FLEXTRONICS SP 905981"},{"id":"b684d8cb-7b4f-49bd-88f5-08d5ae44ed50","name":"CHEMYUNION LTDA","commercialName":"","cnpj":"58309709000587","city":"SOROCABA","stateCode":"SP","buscaAdicional":"CHEMYUNION LTDA 56931"},{"id":"4fc95bd2-4bb5-42f4-7215-08d5cf600bef","name":"ATOM EMPREENDIMENTOS E PARTICIPACOES S.A.","commercialName":"","cnpj":"00359742000108","city":"SOROCABA","stateCode":"SP","buscaAdicional":""},{"id":"64820dec-e8dd-4715-5bdd-08d5ad2bf6ba","name":"METAFILM EMBALAGENS PLASTICAS LTDA","commercialName":"","cnpj":"55834337000196","city":"SOROCABA","stateCode":"SP","buscaAdicional":"METAFILM 50954 HERMANPLAST 898082"},{"id":"0d5fa0e6-ad4f-4365-5919-08d5ad2bf6ba","name":"TEMPERMAX INDUSTRIA E COMERCIO DE VIDROS TEMPERADOS LTDA","commercialName":"","cnpj":"05511755000174","city":"SOROCABA","stateCode":"SP","buscaAdicional":"TEMPERMAX 13777 TEMPERMAX VIDROS 893102"},{"id":"a5a78352-94ef-475b-598b-08d5ad2bf6ba","name":"SHOPPING PATIO CIANE EMPREENDIMENTOS IMOBILIARIOS S.A.","commercialName":"","cnpj":"11024112000107","city":"SOROCABA","stateCode":"SP","buscaAdicional":"CIANE SHOP 14820 CIANE SHOP 894704"},{"id":"21fbc8e4-1f4f-4ce0-59c8-08d5ad2bf6ba","name":"FURUKAWA ELECTRIC LATAM S.A.","commercialName":"FURUKAWA INDUSTRIAL S/A PRODUTOS ELETRICOS","cnpj":"51775690001830","city":"SOROCABA","stateCode":"SP","buscaAdicional":"FURUKAWA SOR 15575 FURUKAWA SOR D 894842"},{"id":"7985e876-bcd7-4948-582b-08d5ad2bf6ba","name":"SUBCONDOMINIO DO ESPLANADA SHOPPING CENTER","commercialName":"","cnpj":"66844820000178","city":"SOROCABA","stateCode":"SP","buscaAdicional":"SHOP ESPLANADA 10892 SHOPPING ESPLANADA 889865"},{"id":"c60613ea-819f-4144-580e-08d5ad2bf6ba","name":"ALBERFLEX INDUSTRIA DE MOVEIS LTDA","commercialName":"","cnpj":"60656774000105","city":"SOROCABA","stateCode":"SP","buscaAdicional":"ALBERFLEX 10511 ALBERFLEX 889518"},{"id":"d8e38446-1009-474d-5843-08d5ad2bf6ba","name":"LORDPLASTICS EMBALAGENS PLASTICAS S.A","commercialName":"","cnpj":"16986171000252","city":"SOROCABA","stateCode":"SP","buscaAdicional":"LORDPLASTICS 11130 LORDPLASTICS 889857"},{"id":"8cdf15d8-3d4e-45be-5f44-08d5ad2bf6ba","name":"KANJIKO DO BRASIL INDUSTRIA AUTOMOTIVA LTDA.","commercialName":"KANJIKO DO BRASIL INDUSTRIA AUTOMOTIVA LTDA.","cnpj":"08170305000234","city":"SOROCABA","stateCode":"SP","buscaAdicional":"KANJIKO SOROCABA 52880 KANJIKO SOROCABA 900701"},{"id":"d73131a8-de7e-4a21-5f94-08d5ad2bf6ba","name":"LINHANYL S A LINHAS PARA COSER","commercialName":"","cnpj":"61135315000564","city":"SOROCABA","stateCode":"SP","buscaAdicional":"LINHANYL LINHAS 53038 LINHANYL LINHAS 903792"},{"id":"15aa44a9-b478-478b-5fa1-08d5ad2bf6ba","name":"CHEMYUNION LTDA","commercialName":"","cnpj":"58309709000153","city":"SOROCABA","stateCode":"SP","buscaAdicional":"CHEMYUNION 53055 CHEMYUNION QUIMICA 906989"},{"id":"405a2ccf-2b2e-4867-603e-08d5ad2bf6ba","name":"REAL ALIMENTOS LTDA .","commercialName":"","cnpj":"71451926000141","city":"SOROCABA","stateCode":"SP","buscaAdicional":"PADARIA REAL 53435 PAD REAL VILA AUGUST 905085 PAD REAL CONVENIENCI 905086 PAD REAL MATRIZ 905157 PAD REAL BOA VISTA 905158"},{"id":"61865760-51ec-4e30-5e89-08d5ad2bf6ba","name":"SANTO COMERCIO E IMPORTACAO DE PRODUTOS ALIMENTICIOS LTDA","commercialName":"SANTO SUPERMERCADO ECONOMIA SEM LIMITES","cnpj":"50368976000190","city":"SOROCABA","stateCode":"SP","buscaAdicional":"SANTO SUPERMERCADOS 52419 WANEL VILLE 902496 SANTO SUP BARCELONA 902556"},{"id":"005a688d-1af9-46f4-5e30-08d5ad2bf6ba","name":"JCB DO BRASIL LTDA","commercialName":"","cnpj":"02833372000124","city":"SOROCABA","stateCode":"SP","buscaAdicional":"JCB 52272 JCB DO BRASIL 900700"},{"id":"220f8f66-911f-4388-5e25-08d5ad2bf6ba","name":"MELIDA COMERCIO E INDUSTRIA LTDA","commercialName":"","cnpj":"61574372000116","city":"SOROCABA","stateCode":"SP","buscaAdicional":"MELIDA 52235 MELIDA SOROCABA 899321"},{"id":"ec425997-4f2f-486f-5e21-08d5ad2bf6ba","name":"CODAP BRASIL LTDA","commercialName":"","cnpj":"04412044000180","city":"SOROCABA","stateCode":"SP","buscaAdicional":"CODAP 52231 CODAP - SOROCABA 899358"},{"id":"10ee8acc-9d3d-4358-5df0-08d5ad2bf6ba","name":"APEX TOOL GROUP INDUSTRIA E COMERCIO DE FERRAMENTAS LTDA.","commercialName":"","cnpj":"43408590000107","city":"SOROCABA","stateCode":"SP","buscaAdicional":"APEX 52077 APEX TOOL GROUP INDU 899556"},{"id":"ddc9e1ad-fec4-48fa-5dd3-08d5ad2bf6ba","name":"SOROCABA REFRESCOS S.A.","commercialName":"","cnpj":"45913696000185","city":"SOROCABA","stateCode":"SP","buscaAdicional":"SOROCABA REFRESCOS 52014 SOROCABA REFRESCOS 899951"},{"id":"567b4b04-3878-4247-514e-08d5ad2bf6ba","name":"SANOVO GREENPACK EMBALAGENS DO BRASIL LTDA","commercialName":"","cnpj":"61585931000193","city":"SOROCABA","stateCode":"SP","buscaAdicional":"SANOVO 2108 SANOVO 908691"},{"id":"6a1c0782-85b7-4ebc-5157-08d5ad2bf6ba","name":"ARBEIT COMERCIALIZADORA DE ENERGIA ELETRICA LTDA.","commercialName":"","cnpj":"08811924000180","city":"SOROCABA","stateCode":"SP","buscaAdicional":"ARBEIT 2130"},{"id":"0bacc04b-5aaf-4798-52b8-08d5ad2bf6ba","name":"MONDICAP PLASTIC PACKAGING LTDA","commercialName":"","cnpj":"08619010000111","city":"SOROCABA","stateCode":"SP","buscaAdicional":"MONDICAP 3257 MONDICAP PLASTI PACK 71216"},{"id":"799926d2-f325-479a-5265-08d5ad2bf6ba","name":"AB BRASIL INDUSTRIA E COMERCIO DE ALIMENTOS LTDA","commercialName":"","cnpj":"60934551000154","city":"SOROCABA","stateCode":"SP","buscaAdicional":"ABBRASIL 3043 AB BRASIL PEDERN 70835 ABBRASIL SOROCABA 70948"},{"id":"2646377a-3448-4a3b-5003-08d5ad2bf6ba","name":"JOHNSON CONTROLS PS DO BRASIL LTDA.","commercialName":"","cnpj":"01376079000112","city":"SOROCABA","stateCode":"SP","buscaAdicional":"JOHNSON 1402 ETC ENERTEC SOROCABA 7253"},{"id":"c167131b-9f01-4d4a-4fb8-08d5ad2bf6ba","name":"PRYSMIAN CABOS E SISTEMAS DO BRASIL S/A","commercialName":"","cnpj":"61150751009135","city":"SOROCABA","stateCode":"SP","buscaAdicional":"PRYSMIAN SORO 1252 PIRELLI SOROCABA 7035"},{"id":"09d4ebad-ff7e-4720-4fc9-08d5ad2bf6ba","name":"COMPANHIA ENERGETICA PAULISTA","commercialName":"","cnpj":"03022093000143","city":"SOROCABA","stateCode":"SP","buscaAdicional":"CIA EP 1276 COMENDADOR VENANCIO 8089 PCH.PH.RJ.029111-0.01"},{"id":"288143da-b7e3-4d39-4fda-08d5ad2bf6ba","name":"DANA INDUSTRIAS LTDA","commercialName":"","cnpj":"00253137000158","city":"SOROCABA","stateCode":"SP","buscaAdicional":"DANA GRAVATAI 1320 DANA ALBARUS-GRAVAT. 7155"},{"id":"60275084-af47-4385-4fb2-08d5ad2bf6ba","name":"SCHAEFFLER BRASIL LTDA.","commercialName":"","cnpj":"57000036000192","city":"SOROCABA","stateCode":"SP","buscaAdicional":"SCHAEFFLER 1241 INA BR SOROCABA 7571"},{"id":"83c6d048-62c8-4e5c-5062-08d5ad2bf6ba","name":"ROBERT BOSCH DIRECAO AUTOMOTIVA LTDA","commercialName":"","cnpj":"01930685000138","city":"SOROCABA","stateCode":"SP","buscaAdicional":"ROBERT BOSCH 1602 ZF DIRECAO SOROCABA 70053"},{"id":"2f7d43dd-3ee9-46d8-5031-08d5ad2bf6ba","name":"ZF DO BRASIL LTDA.","commercialName":"","cnpj":"59280685000110","city":"SOROCABA","stateCode":"SP","buscaAdicional":"ZF 1504 ZF SACHS-S.BERNARDO 70013 ZF BR SOROCABA 70042 ZF BRASIL 898295"},{"id":"8f8a4b47-03e2-432f-5633-08d5ad2bf6ba","name":"PRISMATIC VIDROS PRISMATICOS DE PRECISAO LTDA (EM RECUPERACAO JUDICIAL)","commercialName":"PRISMATIC","cnpj":"57010670000106","city":"SOROCABA","stateCode":"SP","buscaAdicional":"PRISMATIC 6759 PRISMATIC SOROCABA 72075"},{"id":"301ea6d9-2f8b-4b1c-560e-08d5ad2bf6ba","name":"IHARABRAS SA INDUSTRIAS QUIMICAS","commercialName":"IHARABRAS","cnpj":"61142550000130","city":"SOROCABA","stateCode":"SP","buscaAdicional":"IHARA 6563 IHARABRAS-SOROCABA 72013"},{"id":"c5733ef6-a96c-4962-560a-08d5ad2bf6ba","name":"NIPRO MEDICAL LTDA","commercialName":"NIPRO","cnpj":"00762455000144","city":"SOROCABA","stateCode":"SP","buscaAdicional":"NIPRO 6503 NIPRO-SOROCABA 72098"},{"id":"2333bfc7-078d-4eaf-572f-08d5ad2bf6ba","name":"YKK DO BRASIL LTDA","commercialName":"","cnpj":"43444348000342","city":"SOROCABA","stateCode":"SP","buscaAdicional":"YKK DO BRASIL 8311 YKK SOROCABA 889387"},{"id":"0440460c-1542-4001-5450-08d5ad2bf6ba","name":"BPREX PLASTICOS DO BRASIL LTDA","commercialName":"BERRY PLASTICS","cnpj":"01832309000100","city":"SOROCABA","stateCode":"SP","buscaAdicional":"BPREX PLAST 4162 REXAM PLASTIC-SRCBA 71448"},{"id":"6953652a-03bc-41b8-5434-08d5ad2bf6ba","name":"METSO BRASIL INDUSTRIA E COMERCIO LTDA","commercialName":"","cnpj":"16622284000198","city":"SOROCABA","stateCode":"SP","buscaAdicional":"METSO BR 4083 ETC METSO SOROCABA88 7905 METSO MAT SOROCABA13 70190"},{"id":"e6ce9564-f9ab-4787-5536-08d5ad2bf6ba","name":"UNIMETAL INDUSTRIA COMERCIO E EMPREENDIMENTOS LTDA","commercialName":"","cnpj":"15181688000120","city":"SOROCABA","stateCode":"SP","buscaAdicional":"UNIMETAL 5167 UNIMETAL-SOROCABA 71988"},{"id":"78f49f81-449b-411a-54c3-08d5ad2bf6ba","name":"DANA INDUSTRIAS LTDA","commercialName":"","cnpj":"00253137000239","city":"SOROCABA","stateCode":"SP","buscaAdicional":"DANA SOROCABA 4482 DANA-SOROCABA 71789"},{"id":"f9fe3f4d-db2d-4b66-54da-08d5ad2bf6ba","name":"BELMETAL INDUSTRIA E COMERCIO LTDA.","commercialName":"ALUMINIO BELMETAL","cnpj":"61091906002288","city":"SOROCABA","stateCode":"SP","buscaAdicional":"BELMETAL 4540 BELMETAL-SOROCABA 71799"},{"id":"5c8e72ff-933d-4381-5202-08d5ad2bf6ba","name":"PIONEIROS TERMOELETRICA ILHA SOLTEIRA S.A.","commercialName":"PIONEIROS TERMOELETRICA ILHA SOLTEIRA S.A.","cnpj":"10235093000197","city":"SUD MENNUCCI","stateCode":"SP","buscaAdicional":"UTE ILHA 2789 PIONEIROS II 1LFA10 8578 UTE.AI.SP.029642-2.01"},{"id":"d07eecab-22cd-43f5-522c-08d5ad2bf6ba","name":"SATA BRASIL LTDA","commercialName":"","cnpj":"51835007000164","city":"SUMARÉ","stateCode":"SP","buscaAdicional":"SATA 2908 SATA BRASIL SUMARE 70806"},{"id":"555b98b3-0f62-443a-524b-08d5ad2bf6ba","name":"EMBRASATEC INDUSTRIA E COMERCIO DE EMBALAGENS LTDA","commercialName":"","cnpj":"05989100000106","city":"SUMARÉ","stateCode":"SP","buscaAdicional":"EMBRASATEC 2993 EMBRASATEC 70845 EMBRASATEC ARTHUR 899601"},{"id":"93678d79-e5f8-4b9e-524c-08d5ad2bf6ba","name":"EMBRASA EMBALAGEM BRASILEIRA IND COM LIMITADA","commercialName":"EMBRASA","cnpj":"46237566000132","city":"SUMARÉ","stateCode":"SP","buscaAdicional":"EMBRASA 2994 EMBRASA 70875"},{"id":"dcdd83ad-10f5-4216-5255-08d5ad2bf6ba","name":"PPG INDUSTRIAL DO BRASIL - TINTAS E VERNIZES - LTDA.","commercialName":"","cnpj":"43996693000127","city":"SUMARÉ","stateCode":"SP","buscaAdicional":"PPGSUM 3004 PPG GRAVATAI 905236 PPG INDUSTRIAL 70924"},{"id":"6c8cc4ef-047d-436f-52b5-08d5ad2bf6ba","name":"3M DO BRASIL LTDA","commercialName":"","cnpj":"45985371000108","city":"SUMARÉ","stateCode":"SP","buscaAdicional":"3M 3252 3M SUMARE 70990 3M-MAIRINQUE 71599 3M SAO JOSE DO RIO 904426 3M RIBEIRAO PRETO 70989 3M-ITAPETININGA 34 71154"},{"id":"1bf8a65b-fd23-46ec-5362-08d5ad2bf6ba","name":"WABCO DO BRASIL IND. COM. FREIOS LTDA","commercialName":"","cnpj":"08779349000185","city":"SUMARÉ","stateCode":"SP","buscaAdicional":"WABCO 3605 WABCO-SUMARE 71165"},{"id":"b00250ea-b288-4cc0-502d-08d5ad2bf6ba","name":"MEXICHEM BRASIL INDUSTRIA DE TRANSFORMACAO PLASTICA LTDA","commercialName":"","cnpj":"58514928003351","city":"SUMARÉ","stateCode":"SP","buscaAdicional":"MEXICHEM SP 1492 AMANCO SUMARE 7912"},{"id":"3b64362c-3d00-4a3b-5005-08d5ad2bf6ba","name":"VILLARES METALS SA","commercialName":"","cnpj":"42566752000407","city":"SUMARÉ","stateCode":"SP","buscaAdicional":"VILLARES SUMAR 1405 VILLARES SUMARE 7468"},{"id":"fc8e34e5-1ad3-48c8-5092-08d5ad2bf6ba","name":"VALBORMIDA BRASIL METALURGICA LTDA.","commercialName":"","cnpj":"07269864000152","city":"SUMARÉ","stateCode":"SP","buscaAdicional":"VALBORMIDA 1726 VALBORMIDA SUMARE 70089"},{"id":"4f326678-3f5d-40db-5093-08d5ad2bf6ba","name":"PASTIFICIO SELMI SA","commercialName":"","cnpj":"46025722000100","city":"SUMARÉ","stateCode":"SP","buscaAdicional":"SELMI 1730 SELMI SUMARE 70090 SELMI ROLANDIA 903916"},{"id":"9712f84f-3c33-4ab2-4fd1-08d5ad2bf6ba","name":"HONDA AUTOMOVEIS DO BRASIL LTDA","commercialName":"","cnpj":"01192333000122","city":"SUMARÉ","stateCode":"SP","buscaAdicional":"HONDA 1292 HONDA AUTOMOVEIS 7812 HONDA ITIRAPINA 907063"},{"id":"6605d309-e952-4da1-55f9-08d5ad2bf6ba","name":"LAHUMAN INDUSTRIA E COMERCIO DE PLASTICOS LIMITADA","commercialName":"","cnpj":"61863130000142","city":"SUMARÉ","stateCode":"SP","buscaAdicional":"LAHUMAN 6430 LAHUMAN PLASTICO 72087"},{"id":"bb560752-5148-4edc-569a-08d5ad2bf6ba","name":"ADERE PRODUTOS AUTO ADESIVOS LTDA","commercialName":"","cnpj":"46062030000123","city":"SUMARÉ","stateCode":"SP","buscaAdicional":"ADERE ADESIVOS 7320 ADERE ADESIVOS SUM 72163"},{"id":"81f9c080-56ef-4994-5dc3-08d5ad2bf6ba","name":"A. SCHULMAN PLASTICOS DO BRASIL LTDA.","commercialName":"","cnpj":"02376055000800","city":"SUMARÉ","stateCode":"SP","buscaAdicional":"ASCHULMAN 51980 A SCHULMAN PLASTICOS 899999"},{"id":"2cd81a8f-4ac0-4e46-5e8a-08d5ad2bf6ba","name":"XERIUM TECHNOLOGIES BRASIL INDUSTRIA E COMERCIO S/A","commercialName":"XERIUM","cnpj":"58309998000603","city":"SUMARÉ","stateCode":"SP","buscaAdicional":"XERIUM SUMARE 52422 XERIUM TECHNOLOGIES 902516"},{"id":"85c75512-d913-494f-5fb8-08d5ad2bf6ba","name":"LSL TRANSPORTES LTDA.","commercialName":"","cnpj":"04548589000118","city":"SUMARÉ","stateCode":"SP","buscaAdicional":"LSL TRANSPORTES 53197 LSL TRANSPORTES 902514"},{"id":"229ead86-e013-4cc7-57ff-08d5ad2bf6ba","name":"PLANMAR INDUSTRIA E COMERCIO DE PRODUTOS PLASTICOS LIMITADA","commercialName":"''PLANMAR''","cnpj":"00553934000150","city":"SUMARÉ","stateCode":"SP","buscaAdicional":"PLANMAR MATRIZ 10389 PLANMAR MATRIZ 889544 PLANMAR II 891127"},{"id":"a1e40798-fbd6-446b-581f-08d5ad2bf6ba","name":"BUCKMAN LABORATORIOS LTDA","commercialName":"","cnpj":"44589885000181","city":"SUMARÉ","stateCode":"SP","buscaAdicional":"BUCKMAN 10789 BUCKMAN 889521"},{"id":"b48ecbbb-4549-478c-635b-08d5ad2bf6ba","name":"GOOD BOM SUPERMERCADOS LTDA","commercialName":"GOOD BOM SUPERMERCADOS","cnpj":"56794852000152","city":"SUMARÉ","stateCode":"SP","buscaAdicional":"GOODBOM 55325 GOODBOM LJ 08 BOM RE 905570 GOODBOM LJ 10 SIT SA 905571 GOODBOM LJ11 HORTOLA 905574 GOODBOM LJ 01 REBOUC 905575 GOODBOM LJ 04 HORTOL 905576 GOODBOM LJ2 JD STA M 905593 GOODBOM LJ 09 SAN MA 905595 GOODBOM LJ 12 INDAIA 905766 GOOD BOM LOJ 13 MOGI 911616"},{"id":"7471fa0c-6d71-44af-6241-08d5ad2bf6ba","name":"BARREFLEX RECICLAGEM CAMPINAS LTDA","commercialName":"","cnpj":"14983273000108","city":"SUMARÉ","stateCode":"SP","buscaAdicional":"BARREFLEX 54660 BARREFLEX - SUMARE 905722"},{"id":"cda78afd-40ea-4b51-6752-08d5ad2bf6ba","name":"COMERCIO DE GENEROS ALIMENTICIOS PARANA LTDA","commercialName":"SUPERMERCADO PARANA","cnpj":"06959577000101","city":"SUMARÉ","stateCode":"SP","buscaAdicional":"SUPERMERCADOS PARANA 58044 SUPER PARANA LJ 02 909874 SUPER PARANA 04 909878 SUPER PARANA 05 909879 SUPER PARANA MATRIZ 909880"},{"id":"ad5143c4-c1d4-4ae1-671d-08d5ad2bf6ba","name":"EMIBRA IND E COM DE EMBALAGENS LTDA","commercialName":"","cnpj":"45972312000103","city":"SUZANO","stateCode":"SP","buscaAdicional":"EMIBRA 57964 EMIBRA SUZANO 908182"},{"id":"13ed8a16-e64c-4e0e-65ae-08d5ad2bf6ba","name":"NIKEN INDUSTRIA E COMERCIO METALURGICA LTDA","commercialName":"","cnpj":"02481644000174","city":"SUZANO","stateCode":"SP","buscaAdicional":"NIKEN 56928 NIKEN METALURGICA 906732"},{"id":"5ad7e99e-31ec-4995-6694-08d5ad2bf6ba","name":"TEXTIL JF LTDA","commercialName":"JF TEXTIL","cnpj":"26105453000176","city":"SUZANO","stateCode":"SP","buscaAdicional":"JF TEXTIL 57673 JF TEXTIL SUZANO 908507"},{"id":"d4826aa2-92d8-4939-6935-08d5ad2bf6ba","name":"ELASFIL DO BRASIL LTDA","commercialName":"","cnpj":"02208876000153","city":"SUZANO","stateCode":"SP","buscaAdicional":"ELASFIL DO BRASIL LTDA 60841 ELASFIL DO BRASIL 911291"},{"id":"02da90c9-1a71-4fb0-623c-08d5ad2bf6ba","name":"ENGRATECH TECNOLOGIA EM EMBALAGENS PLASTICAS S/A","commercialName":"","cnpj":"05825478000689","city":"SUZANO","stateCode":"SP","buscaAdicional":"ENGRATECH TEC 54631 ENGRATECH TECNOLOGIA 901358"},{"id":"64c53ddf-3cad-4b6d-5cc4-08d5ad2bf6ba","name":"FORMILINE INDUSTRIA DE LAMINADOS LTDA","commercialName":"","cnpj":"55183248001018","city":"SUZANO","stateCode":"SP","buscaAdicional":"FORMILINE 51563 FORMILINE 898262"},{"id":"67213b98-4778-46a9-55ae-08d5ad2bf6ba","name":"CONDOMINIO CIVIL VOLUNTARIO DO SUZANO SHOPPING CENTER","commercialName":"SUZANO SHOPPING CENTER","cnpj":"14800245000108","city":"SUZANO","stateCode":"SP","buscaAdicional":"SHOP SUZANO 5999 SHOP SUZANO 70720"},{"id":"3f1eca9d-f301-489b-57e1-08d5ad2bf6ba","name":"ECOLAB QUIMICA LTDA","commercialName":"","cnpj":"00536772003249","city":"SUZANO","stateCode":"SP","buscaAdicional":"ECOLAB 9909 ECOLAB 890687"},{"id":"82851f09-2188-4267-507d-08d5ad2bf6ba","name":"CLARIANT S.A","commercialName":"","cnpj":"31452113001395","city":"SUZANO","stateCode":"SP","buscaAdicional":"CLARIANT 1652 CLARIA SUZ 7181"},{"id":"1d808ccb-6514-47be-5022-08d5ad2bf6ba","name":"KOMATSU DO BRASIL LTDA","commercialName":"KOMATSU","cnpj":"44410199000100","city":"SUZANO","stateCode":"SP","buscaAdicional":"KOMATSU 1472 KOMAT SJC 7878"},{"id":"69998854-1ae2-4c03-5106-08d5ad2bf6ba","name":"NSK BRASIL LTDA","commercialName":"","cnpj":"71917181000163","city":"SUZANO","stateCode":"SP","buscaAdicional":"NSK 1950 NSK BRASIL 70307"},{"id":"99d3a368-7717-481e-62f1-08d5ad2bf6ba","name":"BRASIL CITRUS INDUSTRIA E COMERCIO EIRELI","commercialName":"BRASIL CITRUS","cnpj":"04234931000105","city":"TABATINGA","stateCode":"SP","buscaAdicional":"BRASIL CITRUS 55056 BRASIL CITRUS 906419"},{"id":"494f28ca-6fcb-4ec3-6966-08d5ad2bf6ba","name":"ANOVIS INDUSTRIAL FARMACEUTICA LTDA.","commercialName":"","cnpj":"19426695000104","city":"TABOÃO DA SERRA","stateCode":"SP","buscaAdicional":"ANOVIS 61145 ANOVIS 912027"},{"id":"11615e28-f421-481d-68ac-08d5ad2bf6ba","name":"CONDULLI S/A IMOVEIS E PARTICIPACOES","commercialName":"","cnpj":"61085031000187","city":"TABOÃO DA SERRA","stateCode":"SP","buscaAdicional":"CONDULLI 60267 CONDULLI IMOVEIS PAR 910505"},{"id":"0f54e1a1-38ca-4bd8-66f6-08d5ad2bf6ba","name":"BIOLAB SANUS FARMACEUTICA LTDA","commercialName":"","cnpj":"49475833000106","city":"TABOÃO DA SERRA","stateCode":"SP","buscaAdicional":"BIOLAB 57901 BIOLAB - BRAG PTA 907943 BIOLAB EXTREMA MG 910144"},{"id":"09724140-1c13-4666-66b8-08d5ad2bf6ba","name":"VINIFLEX INDUSTRIA COMERCIO E SERVICOS LTDA","commercialName":"","cnpj":"02372161000131","city":"TABOÃO DA SERRA","stateCode":"SP","buscaAdicional":"VINIFLEX 57753 VINIFLEX 908671"},{"id":"9bc819c9-9c90-43e4-679e-08d5ad2bf6ba","name":"SDT 3 CENTRO COMERCIAL LTDA.","commercialName":"","cnpj":"02463746000167","city":"TABOÃO DA SERRA","stateCode":"SP","buscaAdicional":"SHOP TABOAO 58337 SHOP TABOAO DA SERRA 908286"},{"id":"2304498b-7b3a-4233-509a-08d5ad2bf6ba","name":"SHERWIN-WILLIAMS DO BRASIL INDUSTRIA E COMERCIO LTDA.","commercialName":"","cnpj":"60872306000160","city":"TABOÃO DA SERRA","stateCode":"SP","buscaAdicional":"SHERWIN W 1745 SHERWIN W. SUMARE 70098 SHERWIN W TABOAO-SP 70242"},{"id":"0c96912b-c3af-4337-50c0-08d5ad2bf6ba","name":"CINPAL COMPANHIA INDUSTRIAL DE PECAS PARA AUTOMOVEIS","commercialName":"","cnpj":"49656192000269","city":"TABOÃO DA SERRA","stateCode":"SP","buscaAdicional":"CINPAL SERRA 1822 CINPAL FILIAL 70179"},{"id":"313f5909-7b5e-4642-505b-08d5ad2bf6ba","name":"CINPAL COMPANHIA INDUSTRIAL DE PECAS PARA AUTOMOVEIS","commercialName":"","cnpj":"49656192000188","city":"TABOÃO DA SERRA","stateCode":"SP","buscaAdicional":"CINPAL 1586 CINPAL-TAB. DA SERRA 70008"},{"id":"784b041a-f3e1-47c7-5ca2-08d5ad2bf6ba","name":"LABORATORIO QUIMICO FARMACEUTICO BERGAMO LTDA","commercialName":"","cnpj":"61282661000141","city":"TABOÃO DA SERRA","stateCode":"SP","buscaAdicional":"BERGAMO 51454 BERGAMO TABOAO 899076"},{"id":"4cc439e5-61c3-4cb3-5b92-08d5ad2bf6ba","name":"CINPAL COMPANHIA INDUSTRIAL DE PECAS PARA AUTOMOVEIS","commercialName":"","cnpj":"49656192000501","city":"TABOÃO DA SERRA","stateCode":"SP","buscaAdicional":"CINPAL CIA 50768 CINPAL PLANTA 3 908665"},{"id":"3b1dce46-d4eb-44a5-672e-08d5ad2bf6ba","name":"FUNDICAO TAIUVA LTDA","commercialName":"","cnpj":"01988404000106","city":"TAIÚVA","stateCode":"SP","buscaAdicional":"FUNDICAO TAIUVA 57993 FUNDICAO TAIUVA 908421"},{"id":"18096dfd-ce22-4c6c-5fc4-08d5ad2bf6ba","name":"CERAMICA ATLAS LTDA","commercialName":"","cnpj":"72050636000159","city":"TAMBAÚ","stateCode":"SP","buscaAdicional":"CERAMICA ATLAS 53215 CERAMICA ATLAS 902696"},{"id":"e6893fb2-e97b-437b-5fab-08d5ad2bf6ba","name":"TECELAGEM ROMA LTDA","commercialName":"","cnpj":"00193273000108","city":"TATUÍ","stateCode":"SP","buscaAdicional":"TECELAGEM ROMA 53078 ROMA TATUI 902632"},{"id":"68ff9845-b69a-4201-5d41-08d5ad2bf6ba","name":"INDUSTRIA CERAMICA FUTURA DE TATUI EIRELI","commercialName":"","cnpj":"13047496000109","city":"TATUÍ","stateCode":"SP","buscaAdicional":"CERAMICA FUTURA DE TATUI 51749 CERAMICA FUTURA TATU 907792"},{"id":"4eda38ee-8ce1-4d5a-57ab-08d5ad2bf6ba","name":"COMPANHIA ENERGETICA TATUI LTDA","commercialName":"","cnpj":"08059450000161","city":"TATUÍ","stateCode":"SP","buscaAdicional":"CETL 9310 SANTA ADELIA (CETL) 890917 CGH.PH.SP.028186-7.01"},{"id":"ae7faf0a-7379-4b58-5518-08d5ad2bf6ba","name":"GUARDIAN DO BRASIL VIDROS PLANOS LTDA","commercialName":"GUARDIAN VIDROS","cnpj":"01410577000568","city":"TATUÍ","stateCode":"SP","buscaAdicional":"GUARDIAN TATUI 5048 GUARDIAN-TATUI SP 71761"},{"id":"47881acf-64f4-42e4-668b-08d5ad2bf6ba","name":"CERAMICA STRUFALDI LTDA","commercialName":"","cnpj":"00841607000102","city":"TATUÍ","stateCode":"SP","buscaAdicional":"CERAMICA STRUFALDI 57649 CERAMICA STRUFALDI 908145"},{"id":"fb884792-c1d0-4628-62c8-08d5ad2bf6ba","name":"LOPESCO INDUSTRIA DE SUBPRODUTOS ANIMAIS LTDA.","commercialName":"","cnpj":"44885291002838","city":"TATUÍ","stateCode":"SP","buscaAdicional":"LOPESCO 54968 LOPESCO 904053"},{"id":"547bc4f7-b4c7-461f-6120-08d5ad2bf6ba","name":"CERAMICA NOVA FIRENZE LTDA.","commercialName":"CERAMICA NOVA FIRENZE","cnpj":"03995512000123","city":"TATUÍ","stateCode":"SP","buscaAdicional":"CERAMICA NOVA FIRENZE 54030 CERAMICA NOVA FIRENZ 908493"},{"id":"fd9dd8b6-31f8-41fd-6121-08d5ad2bf6ba","name":"CERAMICA MONACO LTDA","commercialName":"","cnpj":"00443930000110","city":"TATUÍ","stateCode":"SP","buscaAdicional":"CERAMICA MONACO 54031 CERAMICA MONACO 905091"},{"id":"e80fbeb0-bc63-41c7-61f1-08d5ad2bf6ba","name":"CERAMICA MARIAH LTDA","commercialName":"","cnpj":"00267964000109","city":"TATUÍ","stateCode":"SP","buscaAdicional":"CERAMICA MARIAH 54482 CERAMICA MARIAH LTDA 907312"},{"id":"68ce0868-4b27-4193-649c-08d5ad2bf6ba","name":"ARTECOLA QUIMICA S.A.","commercialName":"ARTECOLA INDUSTRIAS QUIMICAS","cnpj":"44699346000952","city":"TATUÍ","stateCode":"SP","buscaAdicional":"ARTECOLA QUIMICA SA 56133 ARTECOLA LAMINADOS 897190"},{"id":"61955f59-ed3f-402f-653b-08d5ad2bf6ba","name":"CERAMICA NOVA CONQUISTA DE TATUI LTDA","commercialName":"","cnpj":"61758066000130","city":"TATUÍ","stateCode":"SP","buscaAdicional":"CERAMICA NOVA CONQUISTA 56613 CERAMICA NV CONQUIST 907306 MANUFATTI TATUI 907795 CERAMICA NOVA UNIAO 907797"},{"id":"6e487bcc-4fb9-4498-6541-08d5ad2bf6ba","name":"MX TUBOS DE PVC LTDA","commercialName":"MX TUBOS E CONEXOES DE PVC","cnpj":"11404491000152","city":"TATUÍ","stateCode":"SP","buscaAdicional":"MX TUBOS 56631 MX TUBOS 908686"},{"id":"bf8a1f1b-dd43-4f57-62fe-08d5ad2bf6ba","name":"ASSOCIACAO DO VIA VALE GARDEN SHOPPING","commercialName":"","cnpj":"16830406000131","city":"TAUBATÉ","stateCode":"SP","buscaAdicional":"SHOP VIA VALE GARDEN 55070 VIA VALE GARDEN SHOP 904908"},{"id":"e933a734-d948-482e-633e-08d5ad2bf6ba","name":"AUTOLIV DO BRASIL LTDA","commercialName":"","cnpj":"01340384000154","city":"TAUBATÉ","stateCode":"SP","buscaAdicional":"AUTOLIV 55256 AUTOLIV DO BRASIL 907301"},{"id":"0de83d68-b53f-48d8-6314-08d5ad2bf6ba","name":"SUPERMERCADO SHIBATA TAUBATE LTDA","commercialName":"","cnpj":"07424394000154","city":"TAUBATÉ","stateCode":"SP","buscaAdicional":"SHIBATA TAUBATE 55129 SHIBATA TAUBATE 904809"},{"id":"cba8bfe5-e7a3-4726-625e-08d5ad2bf6ba","name":"MORPHO DO BRASIL S/A","commercialName":"MORPHO","cnpj":"02997156000114","city":"TAUBATÉ","stateCode":"SP","buscaAdicional":"IDEMIA 54737 MORPHO DO BRASIL 905986"},{"id":"ffb4e168-314e-4c02-67df-08d5ad2bf6ba","name":"LG ELECTRONICS DO BRASIL LTDA","commercialName":"","cnpj":"01166372000155","city":"TAUBATÉ","stateCode":"SP","buscaAdicional":"LG ELECTRONICS 58770 LG ELECTRONICS AM 908498"},{"id":"7debc02c-c71c-400e-88ec-08d5ae44ed50","name":"PEDREIRA PEDRA NEGRA LTDA","commercialName":"","cnpj":"09248567000156","city":"TAUBATÉ","stateCode":"SP","buscaAdicional":"PPN 55413 PPN TAUBATE 905754"},{"id":"4056f28f-02bc-461b-549d-08d5ad2bf6ba","name":"MALTERIA SOUFFLET BRASIL LTDA.","commercialName":"","cnpj":"01780732000295","city":"TAUBATÉ","stateCode":"SP","buscaAdicional":"MALTERIA 4380 SE FORD- MALTERIA 70716"},{"id":"3683898a-da42-4121-556d-08d5ad2bf6ba","name":"FABINJECT INDUSTRIA PLASTICA LTDA","commercialName":"","cnpj":"56413990000144","city":"TAUBATÉ","stateCode":"SP","buscaAdicional":"FABINJECT 5590 FABINJECT TAUBATE 72360"},{"id":"ea17082f-289e-486e-5767-08d5ad2bf6ba","name":"AUTOCOM COMPONENTES AUTOMOTIVOS DO BRASIL LTDA","commercialName":"","cnpj":"02582890000112","city":"TAUBATÉ","stateCode":"SP","buscaAdicional":"AUTOCOM 8792 AUTOCOM 888618"},{"id":"bc174b0f-f747-4abf-5694-08d5ad2bf6ba","name":"PLASTIC OMNIUM DO BRASIL LTDA","commercialName":"","cnpj":"02645941000108","city":"TAUBATÉ","stateCode":"SP","buscaAdicional":"PLASTIC OMNIUM 7242 PLASTIC OMNIUM TAUB 72197"},{"id":"bdf693c8-d508-4d21-52f4-08d5ad2bf6ba","name":"AUTOMETAL S/A","commercialName":"","cnpj":"59104513000519","city":"TAUBATÉ","stateCode":"SP","buscaAdicional":"AUTOMETAL TAUBATE 3365 CATAUBE TAUBATE 71066"},{"id":"1388dd36-04fa-4dee-5de7-08d5ad2bf6ba","name":"SOCIEDADE EXTRATIVA DOLOMIA LIMITADA","commercialName":"","cnpj":"72277254000162","city":"TAUBATÉ","stateCode":"SP","buscaAdicional":"DOLOMIA 52061 DOLIMIA TAUBATE 900605"},{"id":"6036bca1-f3c7-417b-5fc7-08d5ad2bf6ba","name":"MUBEA DO BRASIL LTDA","commercialName":"","cnpj":"01776765000180","city":"TAUBATÉ","stateCode":"SP","buscaAdicional":"MUBEA 53218 MUBEA TAUBATE 900714"},{"id":"1e09d70f-aed3-4017-5b04-08d5ad2bf6ba","name":"ITW FLUIDS & HYGIENE SOLUTIONS LTDA.","commercialName":"","cnpj":"07125955000114","city":"TAUBATÉ","stateCode":"SP","buscaAdicional":"PROPAPER 50390 PROPAPER 898134"},{"id":"77ecbddb-2509-4bad-5ade-08d5ad2bf6ba","name":"PROLIM COMERCIO DE HIGIENE E LIMPEZA LTDA","commercialName":"","cnpj":"08486693000186","city":"TAUBATÉ","stateCode":"SP","buscaAdicional":"PROLIM 50294 PROLIM 897288"},{"id":"ebc453c8-9afb-4870-581b-08d5ad2bf6ba","name":"CAMPO LIMPO - RECICLAGEM E TRANSFORMACAO DE PLASTICOS S.A.","commercialName":"","cnpj":"09456668000112","city":"TAUBATÉ","stateCode":"SP","buscaAdicional":"CAMPOLIMPO 10709 CAMPOLIMPO TAUBATE 889988"},{"id":"7ad8e9f4-ed25-4fe0-5a18-08d5ad2bf6ba","name":"GE ENERGIAS RENOVAVEIS LTDA.","commercialName":"","cnpj":"17692901000437","city":"TAUBATÉ","stateCode":"SP","buscaAdicional":"GE TAUBATE 16466 ALSTOM RENOVAVEIS 7481 GE TAUBATE (NOVO) 911320"},{"id":"b88db598-18f0-43cf-8d73-08d5d060706e","name":"DESTILARIA ALCIDIA SA","commercialName":"","cnpj":"46448270000160","city":"TEODORO SAMPAIO","stateCode":"SP","buscaAdicional":"UAL 3604 ALCIDIA 8791 UTE.AI.SP.027913-7.01"},{"id":"7a9007f3-b598-47d0-6160-08d5ad2bf6ba","name":"LEANDRO DIANA","commercialName":"","cnpj":"08649681000125","city":"TERRA ROXA","stateCode":"SP","buscaAdicional":"LEANDRO DIANA 54157 LEANDRO DIANA 905736"},{"id":"7da6f52c-9030-4840-624c-08d5ad2bf6ba","name":"BRUNO BIAGIONI PAPEIS E PAPELOES ESPECIAIS LTDA","commercialName":"","cnpj":"72455918000136","city":"TIETÊ","stateCode":"SP","buscaAdicional":"BRUNO BIAGIONI 54676 BRUNO BIAGIONI 905174"},{"id":"b750ed70-b145-4039-624e-08d5ad2bf6ba","name":"BIATEX IMPREGNADORA LTDA","commercialName":"","cnpj":"04095330000169","city":"TIETÊ","stateCode":"SP","buscaAdicional":"BIATEX 54678 BIATEX IMPREGNADORA 904040 BIATEX FILIAL 906336"},{"id":"c9482e1d-e117-4ddf-6340-08d5ad2bf6ba","name":"CAMARGO COMPANHIA DE EMBALAGENS LTDA.","commercialName":"","cnpj":"05437703000103","city":"TIETÊ","stateCode":"SP","buscaAdicional":"CAMARGO EMBALAGENS 55271 CAMARGO EMBALAGENS 905169"},{"id":"1f05831a-375b-4f52-1ccc-08d5b8870181","name":"CALCARIO DIAMANTE LTDA","commercialName":"","cnpj":"46986451000140","city":"TIETÊ","stateCode":"SP","buscaAdicional":"CALCARIO DIAMANTE 61731 CALCARIO DIAMANTE 912778"},{"id":"1c96c805-aadb-48f7-5da2-08d5ad2bf6ba","name":"REFRIX ENVASADORA DE BEBIDAS LTDA","commercialName":"REFRIX","cnpj":"72459878000109","city":"TIETÊ","stateCode":"SP","buscaAdicional":"REFRIX 51941 REFRIX TIETE 898821"},{"id":"1eeb917a-ecc1-41cf-5ccb-08d5ad2bf6ba","name":"INDUSPARQUET INDUSTRIA E COMERCIO DE MADEIRAS LTDA","commercialName":"","cnpj":"72459373000136","city":"TIETÊ","stateCode":"SP","buscaAdicional":"INDUSPARQUET 51572 INDUSPARQUET 898808"},{"id":"cefad98a-9e38-4642-587f-08d5ad2bf6ba","name":"ANHANGUERA EDUCACIONAL LTDA","commercialName":"","cnpj":"05808792000149","city":"VALINHOS","stateCode":"SP","buscaAdicional":"ANHANGUERA 12052 ANHANGUERA - OSASCO 71446 ANHANGUERA ABC 71602 ANHANGUERA UNIDERP 894145 ANHANGUERA UNIDE AGR 894402 ANHANGUERA IRIS 908365 ANHANGUERA STA TERES 908366 ANHANGUERA ST ANDRE 908661 ANHANGUERA INDAIATUB 909175 ANHANGUERA S BARBARA 909197 ANHANGUERA CAMPINAS4 909198 ANHANGUERA NITEROI 909346 ANHANGUERA JARAGUA S 909546 ANHANGUERA PICADAS S 909547 ANHANGUERA PELOTAS 909548 ANHANGUERA RIO GRAND 909673 ANHANGUERA C GRANDE 909939 ANH CAMPINAS 5 909991 ANH RIBEIRAO PRETO 909993 ANH BAURU 909994 ANH CORP VALINHOS I 909995 ANH PIRACICABA 909996 ANH PASSO FUNDO 910018 ANH SOROCABA 1 910036 ANH JUNDIAI 910037 ANH CAXIAS DO SUL 910042 ANH CAMPO LIMPO 910066 ANH SBC ANCHIETA 1 910067 ANH SP VILA MARIANA 910343 ANH JACAREI 1 910393 ANH GUARULHOS 1 910394 ANH CAMPINAS 3 910530 ANH PINDAMONHANGABA 910588 ANH SBC UNIBAN 2 910592 ANH RIO CLARO 910594 ANH CAMPINAS 1 910599 ANH VALINHOS 1 910619 ANH VALINHOS 2 910620 ANH SUMARE 911318"},{"id":"a41c0636-3453-459b-5906-08d5ad2bf6ba","name":"SILGAN DISPENSING SYSTEMS BRAZIL INDUSTRIA DE EMBALAGENS LTDA.","commercialName":"MWV","cnpj":"01795995000430","city":"VALINHOS","stateCode":"SP","buscaAdicional":"SILGAN 13562 RIGESA 2 7349"},{"id":"72768b73-38cb-4a71-5bed-08d5ad2bf6ba","name":"ASSOCIACAO SHOPPING VALINHOS","commercialName":"","cnpj":"09213967000126","city":"VALINHOS","stateCode":"SP","buscaAdicional":"SC VALINHOS 50988 SHOPPING VALINHOS 898313"},{"id":"02e2c635-d606-4722-5009-08d5ad2bf6ba","name":"EATON LTDA","commercialName":"ESCRITORIO CENTRAL","cnpj":"54625819000173","city":"VALINHOS","stateCode":"SP","buscaAdicional":"EATON 1409 EATON TRANSMISSOES 82 EATON CAXIAS DO SUL 70264 EATON MOGI MIRIM 7270 EATON - SJ CAMPOS 72133"},{"id":"ffb7879f-a8cb-4523-567a-08d5ad2bf6ba","name":"CARTONIFICIO VALINHOS S A","commercialName":"","cnpj":"45992476000194","city":"VALINHOS","stateCode":"SP","buscaAdicional":"CARTONIFICIO 7182 CARTONIFICIO VALINH 72218"},{"id":"1e2cc3f1-863c-4e10-54dd-08d5ad2bf6ba","name":"UNILEVER BRASIL INDUSTRIAL LTDA","commercialName":"RMB LTDA","cnpj":"01615814006215","city":"VALINHOS","stateCode":"SP","buscaAdicional":"UNIVAL 4548 UNILEVER VALINHOS 7244"},{"id":"b91e5860-b507-48a3-1ca6-08d5b8870181","name":"SOPROVAL EMBALAGENS PLASTICAS LTDA","commercialName":"SOPROVAL","cnpj":"56173370000185","city":"VALINHOS","stateCode":"SP","buscaAdicional":"SOPROVAL 60417 SOPROVAL 912934"},{"id":"02571613-d83a-47bd-7294-08d5cf600bef","name":"ANHANGUERA EDUCACIONAL PARTICIPACOES S/A","commercialName":"","cnpj":"04310392000146","city":"VALINHOS","stateCode":"SP","buscaAdicional":""},{"id":"76dcdac3-be26-454a-623f-08d5ad2bf6ba","name":"SUPERMERCADOS CAETANO LTDA","commercialName":"SUPERMERCADOS CAETANO","cnpj":"49618556000135","city":"VALINHOS","stateCode":"SP","buscaAdicional":"SUPERMERCADOS CAETANO1 54658 SUPERMERCADOS CAETAN 906051 SUPERMERCADOS CTN FL 906073"},{"id":"95a4829d-efb4-4c64-67dc-08d5ad2bf6ba","name":"GLOBO BRASIL INDUSTRIA DE PAINEIS SOLARES E ACM LTDA","commercialName":"GLOBO BRASIL PAINEIS SOLARES","cnpj":"38876124000108","city":"VALINHOS","stateCode":"SP","buscaAdicional":"GLOBO BRASIL 58731 GLOBO BRASIL PAINEIS 909196"},{"id":"77dc2069-0a05-4149-51d4-08d5ad2bf6ba","name":"DA MATA S.A. - ACUCAR E ALCOOL","commercialName":"DA MATA S.A. - ACUCAR E ALCOOL","cnpj":"08110543000173","city":"VALPARAÍSO","stateCode":"SP","buscaAdicional":"DA MATA I5 2608 MATA ACUCAR E ALCOOL 8586 UTE.AI.SP.029774-7.01 DA MATA II 905990 UTE.AI.SP.035773-1.01"},{"id":"848a378d-b2b9-4e59-5994-08d5ad2bf6ba","name":"BIOENERGIA UNIVALEM LTDA","commercialName":"","cnpj":"18753150000131","city":"VALPARAÍSO","stateCode":"SP","buscaAdicional":"BIO UNIVALEM 14919 UNIVALEM CONSUMO 72343 UNIVALEM 20072 UTE.AI.SP.030264-3.01"},{"id":"c219e9de-8951-4c7c-632b-08d5ad2bf6ba","name":"SUPERFRIO ARMAZENS GERAIS S.A.","commercialName":"","cnpj":"02060862000135","city":"VARGEM GRANDE DO SUL","stateCode":"SP","buscaAdicional":"SUPERFRIO 55197 SUPERFRIO RIB PRETO 906402 SUPERFRIO RIB PRTO 2 906403 SUPERFRIO VARGEM GD 906719 SUPERFRIO MOGI GUACU 906720 SUPERFRIO JACAREI 906731"},{"id":"cbdb6744-3376-43eb-62b8-08d5ad2bf6ba","name":"NOVOFLEX INDUSTRIA E COMERCIO DE PRODUTOS PLASTICOS LTDA.","commercialName":"NOVOFLEX","cnpj":"07148146000128","city":"VÁRZEA PAULISTA","stateCode":"SP","buscaAdicional":"NOVOFLEX 54938 NOVOFLEX 903843"},{"id":"a9abb1a3-d5f8-4272-733b-08d5cf600bef","name":"ELEKEIROZ S/A","commercialName":"ELEKEIROZ","cnpj":"13788120000147","city":"VÁRZEA PAULISTA","stateCode":"SP","buscaAdicional":""},{"id":"9414896b-726f-42cb-58c2-08d5ad2bf6ba","name":"ROGER DO BRASIL INDUSTRIA DE COSMETICOS E PRODUTOS DE HIGIENE PESSOAL LTDA","commercialName":"","cnpj":"04716511000165","city":"VÁRZEA PAULISTA","stateCode":"SP","buscaAdicional":"ROGER DO BRASIL 13194 ROGER DO BRASIL 891765"},{"id":"f6f1de0d-44ab-49ba-5eda-08d5ad2bf6ba","name":"AD'ORO S.A.","commercialName":"AD'ORO","cnpj":"60037058000131","city":"VÁRZEA PAULISTA","stateCode":"SP","buscaAdicional":"ADORO 52584 ADORO SA VP 903714 ADORO SAO CARLOS 903875 ADORO 18461174 904763"},{"id":"441b1a74-2781-41bf-512d-08d5ad2bf6ba","name":"ADVANCE - INDUSTRIA TEXTIL LTDA","commercialName":"ADVANCE","cnpj":"49311558000187","city":"VÁRZEA PAULISTA","stateCode":"SP","buscaAdicional":"ADVANCE 2034 ADVANCE VARZEA PTA 70544"},{"id":"2f7c40a7-9781-4b60-53a3-08d5ad2bf6ba","name":"CONTINENTAL AUTOMOTIVE DO BRASIL LTDA.","commercialName":"","cnpj":"11111752000146","city":"VÁRZEA PAULISTA","stateCode":"SP","buscaAdicional":"CONTINENTAL 3742 CONTINENTAL 71411"},{"id":"05397911-66ac-4428-53d5-08d5ad2bf6ba","name":"UNILEVER BRASIL INDUSTRIAL LTDA","commercialName":"RMB LTDA","cnpj":"01615814006487","city":"VINHEDO","stateCode":"SP","buscaAdicional":"UNIVINHEDO 3876 UNIVINHEDO 71376"},{"id":"4e25d63f-6e4a-4ea0-568c-08d5ad2bf6ba","name":"ATCO PLASTICOS LTDA","commercialName":"ATCO","cnpj":"00385650000100","city":"VINHEDO","stateCode":"SP","buscaAdicional":"ATCO 7231 ATCO PLAST VINHEDO 72203 ATCO 4000245472 905770"},{"id":"2c45320b-e795-426d-56a0-08d5ad2bf6ba","name":"BELENUS DO BRASIL S.A.","commercialName":"","cnpj":"05151518000140","city":"VINHEDO","stateCode":"SP","buscaAdicional":"BELENUS 7380 BELENUS VINHEDO 72346 BELENUS DO BRASIL 2 889198"},{"id":"e5994fd5-1de3-4985-5647-08d5ad2bf6ba","name":"SAINT-GOBAIN DO BRASIL PRODUTOS INDUSTRIAIS E PARA CONSTRUCAO LTDA","commercialName":"SAINT-GOBAIN DO BRASIL - DIVISAO CERAMICAS & PLASTICOS","cnpj":"61064838004201","city":"VINHEDO","stateCode":"SP","buscaAdicional":"SGCERPLA VINHE 6837 SAINT GOBAIN VINHEDO 72214"},{"id":"dc120e02-5a35-4b6c-5623-08d5ad2bf6ba","name":"AVERY DENNISON DO BRASIL LTDA","commercialName":"","cnpj":"43999630000124","city":"VINHEDO","stateCode":"SP","buscaAdicional":"AVERY DENN 6660 AVERY DENNISON 72066"},{"id":"116c5e04-7453-44ee-5712-08d5ad2bf6ba","name":"AGV LOGISTICA S.A","commercialName":"AGV LOGISTICA","cnpj":"02905424000120","city":"VINHEDO","stateCode":"SP","buscaAdicional":"AGV 8188 AGV - VINHEDO 888159 AGV CACHOEIRINHA 907970 AGV CAJAMAR 908081 AGV BARUERI 908214"},{"id":"bb547212-59da-4919-513c-08d5ad2bf6ba","name":"ADELBRAS INDUSTRIA E COMERCIO DE ADESIVOS LTDA","commercialName":"ADELBRAS","cnpj":"73077299000156","city":"VINHEDO","stateCode":"SP","buscaAdicional":"ADELBRAS 2057 ADELBRAS MTZ VINHEDO 70431"},{"id":"d21df388-e3bc-4738-52f5-08d5ad2bf6ba","name":"GLOBALPACK INDUSTRIA E COMERCIO LTDA","commercialName":"","cnpj":"04558449000392","city":"VINHEDO","stateCode":"SP","buscaAdicional":"GLOBALPACK 3370 GLOBALPACK VINHEDO 71050 GLOBALPACK MG 909601"},{"id":"170686a8-4623-4327-5f25-08d5ad2bf6ba","name":"PERFETTI VAN MELLE BRASIL LTDA.","commercialName":"","cnpj":"02097007000107","city":"VINHEDO","stateCode":"SP","buscaAdicional":"PERFETTI BRASIL EI 52787 PERFETTI VAN MELLE 903767"},{"id":"6780a161-2fed-46e5-60af-08d5ad2bf6ba","name":"UNIFRAX BRASIL LTDA","commercialName":"","cnpj":"01013724000132","city":"VINHEDO","stateCode":"SP","buscaAdicional":"UNIFRAX 53637 UNIFRAX 906600"},{"id":"6410fc1d-6ec8-4452-5ca6-08d5ad2bf6ba","name":"PLASTIMIL INDUSTRIA E COMERCIO DE PLASTICOS LTDA","commercialName":"PLASTIMIL INDUSTRIA E COMERCIO DE PLASTICOS LTDA.","cnpj":"10351274000189","city":"VINHEDO","stateCode":"SP","buscaAdicional":"PLASTIMIL 51460 PLASTIMIL 902535"},{"id":"e64e2711-e4e2-4f65-5ec7-08d5ad2bf6ba","name":"CCL INDUSTRIES DO BRASIL S/A","commercialName":"CCL LABEL","cnpj":"07593518000125","city":"VINHEDO","stateCode":"SP","buscaAdicional":"CCL INDUSTRIES 52549 CCL LABEL VINHEDO 900600 CCL LABEL CRICIUMA 905730"},{"id":"beaeb9dd-bb9a-47d1-5917-08d5ad2bf6ba","name":"LOG & PRINT GRAFICA, DADOS VARIAVEIS E LOGISTICA S.A.","commercialName":"LOG & PRINT","cnpj":"66079609000106","city":"VINHEDO","stateCode":"SP","buscaAdicional":"LOGPRINT 13734 LOGPRINT VINHEDO 892412"},{"id":"8340f104-ebde-483e-7220-08d5cf600bef","name":"HOPI HARI S/A","commercialName":"HOPI HARI","cnpj":"00924432000199","city":"VINHEDO","stateCode":"SP","buscaAdicional":""},{"id":"6beb2009-f3bf-43bf-629b-08d5ad2bf6ba","name":"INDUSTRIA E COMERCIO DE BEBIDAS E CONEXOS GERMANIA LTDA.","commercialName":"","cnpj":"96366174000141","city":"VINHEDO","stateCode":"SP","buscaAdicional":"GERMANIA 54822 GERMANIA BEBIDAS 906272"},{"id":"310eda2a-e2a0-4bf4-6306-08d5ad2bf6ba","name":"MARBEL - INDUSTRIA E COMERCIO DE ARTEFATOS DE PLASTICO LTDA.","commercialName":"","cnpj":"06323871000122","city":"VINHEDO","stateCode":"SP","buscaAdicional":"MARBEL 55104 MARBEL 908795"},{"id":"aa675fa1-00f4-43a2-62d9-08d5ad2bf6ba","name":"COIM BRASIL LTDA","commercialName":"POLIMIND","cnpj":"65426538000108","city":"VINHEDO","stateCode":"SP","buscaAdicional":"COIM 55014 COIM BRASIL 905081"},{"id":"644744ba-c1fc-4acb-6139-08d5ad2bf6ba","name":"OMAMORI INDUSTRIA DE ALIMENTOS LTDA.","commercialName":"","cnpj":"05205107000270","city":"VINHEDO","stateCode":"SP","buscaAdicional":"CERATTI 54059 CERATTI 905155"},{"id":"406355d1-60be-49c1-6213-08d5ad2bf6ba","name":"COORSTEK DO BRASIL MATERIAIS AVANCADOS LTDA","commercialName":"","cnpj":"12081776000162","city":"VINHEDO","stateCode":"SP","buscaAdicional":"COORSTEK 54540 COORSTEK BR MATERIAI 905929"},{"id":"1881e8fc-d1e0-4b19-669e-08d5ad2bf6ba","name":"NEO RODAS S.A.","commercialName":"NEO RODAS S.A.","cnpj":"14591542000271","city":"VINHEDO","stateCode":"SP","buscaAdicional":"NEO RODAS 57694 ALUJET-VINHEDO 71996"},{"id":"40a42e6f-316c-43bc-66a3-08d5ad2bf6ba","name":"MAGNA DO BRASIL PRODUTOS E SERVICOS AUTOMOTIVOS LTDA","commercialName":"","cnpj":"00970934000156","city":"VINHEDO","stateCode":"SP","buscaAdicional":"MAGNA CLOSURES 57715 RESIL MINAS 70880 MAGNA CLOSURES VINHE 908397"},{"id":"675cb83b-aff1-4400-695a-08d5ad2bf6ba","name":"COMPANHIA ENERGETICA NARDINI","commercialName":"COMPANHIA ENERGETICA NARDINI","cnpj":"28127776000196","city":"VISTA ALEGRE DO ALTO","stateCode":"SP","buscaAdicional":"NARDINI ENERGETICA 61085 NARDINI CARGA 908990 NARDINI 522 UTE.AI.SP.001528-8.01"},{"id":"5ed600f4-e994-4e7a-884b-08d5ae44ed50","name":"NARDINI AGROINDUSTRIAL LTDA","commercialName":"","cnpj":"48708267000164","city":"VISTA ALEGRE DO ALTO","stateCode":"SP","buscaAdicional":"NARDINI I5 2784 NARDINI 522 UTE.AI.SP.001528-8.01"},{"id":"fd1d8a47-63ef-4b25-641b-08d5ad2bf6ba","name":"INDUSTRIA DE POLPAS E CONSERVAS VAL LTDA","commercialName":"","cnpj":"71841902000107","city":"VISTA ALEGRE DO ALTO","stateCode":"SP","buscaAdicional":"POLPAS E CONSERVAS VAL 55844 POLPAS VAL 906844"},{"id":"cef3f927-d65c-464b-62cf-08d5ad2bf6ba","name":"AGUAS DE VOTORANTIM S/A","commercialName":"","cnpj":"14192039000162","city":"VOTORANTIM","stateCode":"SP","buscaAdicional":"AGUAS DE VOTORANTIM 54977 AGUAS VOTORANTIM CEN 907161 AG VOTORANTIM VOTOCE 907164 AG VOTORANTIM CAP CT 907165 AG VOTORANTIM GUIMAR 907197"},{"id":"9e9ef228-b054-42a2-8837-08d5ae44ed50","name":"BEMIS DO BRASIL INDUSTRIA E COMERCIO DE EMBALAGENS LTDA.","commercialName":"","cnpj":"60394723000659","city":"VOTORANTIM","stateCode":"SP","buscaAdicional":"DIXIE TOGA 1392 ETC DIXIETOGA VOTORA 7268"},{"id":"fca8e37f-155f-4ee3-5f59-08d5ad2bf6ba","name":"SEIREN PRODUTOS AUTOMOTIVOS LTDA","commercialName":"SEIREN","cnpj":"02029581000110","city":"VOTORANTIM","stateCode":"SP","buscaAdicional":"SEIREN 52909 SEIREN VOTORANTIM 902743"},{"id":"749d4c64-90c2-46b1-5360-08d5ad2bf6ba","name":"SR COMERCIALIZADORA DE ENERGIA ELETRICA LTDA.","commercialName":"","cnpj":"11588141000193","city":"VOTORANTIM","stateCode":"SP","buscaAdicional":"SR COM 3601"},{"id":"e22ab525-cb57-460f-603b-08d5ad2bf6ba","name":"SUPERMERCADO PORECATU LTDA","commercialName":"SUPERMERCADO PORECATU","cnpj":"72954308000187","city":"VOTUPORANGA","stateCode":"SP","buscaAdicional":"PORECATU 53432 PORECATU VOTUP 1 902621 PORECATU SJRP 2 902681 SUPER PORECATU BR 902684 PORECATU SJRP 1 902694 PORECATU VOTUP 2 906690"},{"id":"3172e333-be83-4658-6009-08d5ad2bf6ba","name":"COFCO INTERNATIONAL BRASIL S.A.","commercialName":"COFCO INTL","cnpj":"06315338006400","city":"VOTUPORANGA","stateCode":"SP","buscaAdicional":"COFCO VOTUPORANGA 53355 VOTUPORANGA 903838"},{"id":"1c8178d0-b2a4-4260-5b91-08d5ad2bf6ba","name":"FRIGORIFICO AVICOLA VOTUPORANGA LTDA","commercialName":"FRIGORIFICO AVICOLA VOTUPORANGA","cnpj":"56431364000180","city":"VOTUPORANGA","stateCode":"SP","buscaAdicional":"FRANGO RICO 50766 FRIG. VOTUPORANGA 898803"},{"id":"141c63a1-cdfb-40af-6882-08d5ad2bf6ba","name":"MARTINS DELGADO & CIA LTDA","commercialName":"","cnpj":"01229326000158","city":"VOTUPORANGA","stateCode":"SP","buscaAdicional":"SANTA CRUZ SUP 60106 STA CRUZ SUP 2 910370 STA CRUZ SUP 1 910388 STA CRUZ SUP 3 910391 STA CRUZ SUP 4 910392"},{"id":"0a810e73-f138-46e3-6358-08d5ad2bf6ba","name":"MARGEM COMPANHIA DE MINERACAO","commercialName":"","cnpj":"06635659000109","city":"ADRIANÓPOLIS","stateCode":"PR","buscaAdicional":"MARGEM MINERACAO 55322 MARGEM ADRIANOPOLIS 906041"},{"id":"b7dcd580-2858-4753-62d0-08d5ad2bf6ba","name":"INDUSTRIA DE CAL RIO GRANDE LTDA","commercialName":"","cnpj":"75066142000150","city":"ALMIRANTE TAMANDARÉ","stateCode":"PR","buscaAdicional":"CAL RIO GRANDE 54978 CAL RIO GRANDE IND 909224"},{"id":"335639cf-b0ba-4d79-62c2-08d5ad2bf6ba","name":"EBCAL INDUSTRIA E COMERCIO DE CAL E CORRETIVO LTDA","commercialName":"","cnpj":"81717134000120","city":"ALMIRANTE TAMANDARÉ","stateCode":"PR","buscaAdicional":"EBCAL 54956 EBCAL IND COM DE CAL 906455"},{"id":"f6b2b6bc-9acc-4976-612b-08d5ad2bf6ba","name":"MACPET EMBALAGENS LTDA","commercialName":"MACPET","cnpj":"11659958000105","city":"ALMIRANTE TAMANDARÉ","stateCode":"PR","buscaAdicional":"MACPET 54044 MACPET EMBALAGENS 905991"},{"id":"8873fb4f-ae59-49a7-5ba9-08d5ad2bf6ba","name":"KAPAZI INDUSTRIA E COMERCIO DE CAPACHOS LTDA","commercialName":"","cnpj":"80051824000120","city":"ALMIRANTE TAMANDARÉ","stateCode":"PR","buscaAdicional":"KAPAZI 50814 KAPAZI 898669"},{"id":"9583d2f0-fcd2-49ae-5d26-08d5ad2bf6ba","name":"TERRA RICA - INDUSTRIA E COMERCIO DE CALCARIOS E FERTILIZANTES DO SOLO LTDA","commercialName":"","cnpj":"77388874000192","city":"ALMIRANTE TAMANDARÉ","stateCode":"PR","buscaAdicional":"TERRA RICA 51718 TERRA RICA MATRIZ 899795"},{"id":"bdd52faa-1991-4a00-5cb3-08d5ad2bf6ba","name":"INDUSTRIA DE MOVEIS NOTAVEL LTDA","commercialName":"MOVEIS NOTAVEL","cnpj":"00303732000150","city":"AMPÉRE","stateCode":"PR","buscaAdicional":"NOTAVEL 51511 IND MOVEIS NOTAVEL 899729"},{"id":"97cf62b0-14c1-4e8b-73de-08d5cf600bef","name":"TERMINAIS PORTUARIOS DA PONTA DO FELIX S/A","commercialName":"","cnpj":"85041333000111","city":"ANTONINA","stateCode":"PR","buscaAdicional":""},{"id":"2680d0a3-fb60-41e2-88c9-08d5ae44ed50","name":"CARAMURU ALIMENTOS S.A.","commercialName":"CARAMURU","cnpj":"00080671001343","city":"APUCARANA","stateCode":"PR","buscaAdicional":"CARAMURU OLEOS 51719"},{"id":"5e0a74a9-75eb-40cd-88ca-08d5ae44ed50","name":"CARAMURU ALIMENTOS S.A.","commercialName":"CARAMURU","cnpj":"00080671001262","city":"APUCARANA","stateCode":"PR","buscaAdicional":"CARAMURU ALIMENTOS 51720"},{"id":"fea386c7-2226-442a-652f-08d5ad2bf6ba","name":"PLASTICOS MAGNO LTDA.","commercialName":"PLASTICOS MAGNO","cnpj":"01099822000134","city":"APUCARANA","stateCode":"PR","buscaAdicional":"PLASTICOS MAGNO 56578 PLASTICOS MAGNO 907315"},{"id":"0637410d-b75a-436c-68a5-08d5ad2bf6ba","name":"RECAUCHUTAGEM RANK LTDA","commercialName":"","cnpj":"84941236000112","city":"APUCARANA","stateCode":"PR","buscaAdicional":"RANK PNEUS 60238 RECAUCHUTAGEM RANK 912025"},{"id":"f908c259-3cd8-4cfc-66a2-08d5ad2bf6ba","name":"A.M. ARMAZENS GERAIS FRIGORIFICOS LTDA","commercialName":"","cnpj":"07213540000100","city":"APUCARANA","stateCode":"PR","buscaAdicional":"AM ARMAZENS GERAIS FRIGORIFICO 57711 ARMAZENS FRIGORIFICO 910896"},{"id":"b5098267-b1d6-46f5-5d1f-08d5ad2bf6ba","name":"CRISTAL SETE VIDROS TEMPERADOS EIRELI","commercialName":"","cnpj":"03196363000132","city":"APUCARANA","stateCode":"PR","buscaAdicional":"CRISTAL SETE 51709 CRISTAL SETE 899736"},{"id":"ddce1592-fcce-4464-5c46-08d5ad2bf6ba","name":"FAMA DO BRASIL INDUSTRIA DE MOLAS E AUTO PECAS LTDA","commercialName":"MOLAS FAMA","cnpj":"75267096000158","city":"APUCARANA","stateCode":"PR","buscaAdicional":"FAMA BRASIL 51241 FAMA BRASIL 899786"},{"id":"ffc20732-53ef-4ec5-5c4c-08d5ad2bf6ba","name":"FAMA METALS INDÚSTRIA DE ARTEFATOS E FUNDIDOS LTDA.","commercialName":"","cnpj":"79641288000133","city":"APUCARANA","stateCode":"PR","buscaAdicional":"FAMA METALS 51255 FAMA METALS 899791"},{"id":"c23035f5-bb22-46b5-5c84-08d5ad2bf6ba","name":"APUCARANA LEATHER S/A","commercialName":"","cnpj":"09271307000100","city":"APUCARANA","stateCode":"PR","buscaAdicional":"APUCALEATHER 51366 APUCALEATHER 899891"},{"id":"a7c97da9-b6ab-4ea7-5b39-08d5ad2bf6ba","name":"PARANATEX INDUSTRIA TEXTIL LTDA","commercialName":"PARANATEX","cnpj":"81672099000170","city":"APUCARANA","stateCode":"PR","buscaAdicional":"PARANATEX 50530 PARANATEX 898129"},{"id":"3bbadecc-2a81-488d-5b26-08d5ad2bf6ba","name":"INDUSTRIA TEXTIL APUCARANA LTDA","commercialName":"","cnpj":"75284224000171","city":"APUCARANA","stateCode":"PR","buscaAdicional":"TEXTIL APUCARANA 50497 TEXTIL APUCARANA 898054"},{"id":"23095dca-2992-4b1b-5ab3-08d5ad2bf6ba","name":"ELETRAN INDUSTRIA E COMERCIO DE ACUMULADORES S.A.","commercialName":"ELETRAN","cnpj":"75263475000170","city":"APUCARANA","stateCode":"PR","buscaAdicional":"ELETRAN 50191 ELETRAN 897287"},{"id":"26fd9fb5-6db5-4a93-58aa-08d5ad2bf6ba","name":"FUZION BATERIAS AUTOMOTIVAS LTDA","commercialName":"FUZION BATERIAS AUTOMOTIVAS","cnpj":"08978872000130","city":"APUCARANA","stateCode":"PR","buscaAdicional":"BRANGER 12792 BRANGER APUCARANA 892003"},{"id":"365b3626-0ead-4920-5ab9-08d5ad2bf6ba","name":"LINEA BRASIL IND E COM DE MOVEIS LTDA","commercialName":"LINEA BRASIL","cnpj":"95387569000168","city":"ARAPONGAS","stateCode":"PR","buscaAdicional":"LINEA MOVEIS 50210 LINEA BRASIL 897503"},{"id":"cc181208-587d-4070-5c77-08d5ad2bf6ba","name":"CAEMMUN INDUSTRIA E COMERCIO DE MOVEIS LTDA","commercialName":"INDUSTRIA DE MOVEIS CAEMMUN","cnpj":"81904948000173","city":"ARAPONGAS","stateCode":"PR","buscaAdicional":"CAEMMUN 51325 CAEMMUN SABAUDIA 899300 CAEMMUN ARAPONGAS 899301"},{"id":"2d38e560-b499-40c5-5c6a-08d5ad2bf6ba","name":"KIT S PARANA-INDUSTRIA E COMERCIO DE MOVEIS LTDA","commercialName":"KITS PARANA","cnpj":"79460192000179","city":"ARAPONGAS","stateCode":"PR","buscaAdicional":"KITS PARANA 51304 KITS PARANA MARACANA 899552 KITS PARANA SARACURA 899566"},{"id":"14e903bd-6903-4ea2-5c54-08d5ad2bf6ba","name":"DEMOBILE - INDUSTRIA DE MOVEIS LTDA.","commercialName":"","cnpj":"75069849000110","city":"ARAPONGAS","stateCode":"PR","buscaAdicional":"DEMOBILE 51264 DEMOBILE 39057640 899171 DEMOBILE - ARAPACU 899172 DEMOBILE ROD PR 444 899175"},{"id":"e0735066-9061-43c0-5c64-08d5ad2bf6ba","name":"NICIOLI-INDUSTRIA E COMERCIO DE MOVEIS LTDA","commercialName":"","cnpj":"76622968000111","city":"ARAPONGAS","stateCode":"PR","buscaAdicional":"NICIOLI 51296 NICIOLI 899587"},{"id":"be2bf9fa-2b9d-4e11-5c40-08d5ad2bf6ba","name":"PONTALTI - INDUSTRIA E COMERCIO DE RESIDUOS DE MADEIRAS LTDA","commercialName":"","cnpj":"02224840000163","city":"ARAPONGAS","stateCode":"PR","buscaAdicional":"PONTALTI 51229 PONTALTI ARAPONGAS 901285"},{"id":"d29ad54e-039d-46d0-5b81-08d5ad2bf6ba","name":"MOVAL MOVEIS ARAPONGAS LTDA","commercialName":"MOVAL","cnpj":"75400903000169","city":"ARAPONGAS","stateCode":"PR","buscaAdicional":"MOVAL MAT 50736 MOVAL MOVEIS 897587"},{"id":"e6506d2c-5f1a-4907-5bc4-08d5ad2bf6ba","name":"MADETEC MOVEIS LTDA","commercialName":"","cnpj":"02624729000164","city":"ARAPONGAS","stateCode":"PR","buscaAdicional":"MADETEC 50890 MADETEC 898800"},{"id":"1580e696-cbc8-4347-5d5f-08d5ad2bf6ba","name":"POQUEMA INDUSTRIA E COMERCIO DE MOVEIS LTDA","commercialName":"MOVEIS POQUEMA","cnpj":"79189957000188","city":"ARAPONGAS","stateCode":"PR","buscaAdicional":"POQUEMA 51800 POQUEMA ARAPONGAS 899797"},{"id":"005ced5f-14a7-4dee-5d60-08d5ad2bf6ba","name":"STAR PLAST INDL E COML PARANAENSE DE PLASTICOS LTDA","commercialName":"","cnpj":"79620159000169","city":"ARAPONGAS","stateCode":"PR","buscaAdicional":"STARPLAST 51801 STARPLAST ARAPONGAS 900213"},{"id":"1da960f7-9f22-4b94-5d76-08d5ad2bf6ba","name":"D J LAMINACAO DE PNEUS LTDA","commercialName":"DJ LAMINACAO DE PNEUS","cnpj":"76745850000180","city":"ARAPONGAS","stateCode":"PR","buscaAdicional":"RECIBRAS 51828 RECIBRAS 900836 RECIBRAS FILIAL 901773"},{"id":"ea1076d3-a8e5-438b-5ca7-08d5ad2bf6ba","name":"PRODUTOS ALIMENTICIOS ARAPONGAS SA PRODASA","commercialName":"","cnpj":"75404814000352","city":"ARAPONGAS","stateCode":"PR","buscaAdicional":"PRODASA 51479 PRODASA - ARAPONGAS 899591"},{"id":"942cc313-ba27-47b5-5e88-08d5ad2bf6ba","name":"COLIBRI INDUSTRIA E COMERCIO DE MOVEIS LTDA","commercialName":"COLIBRI MOVEIS","cnpj":"82368283000193","city":"ARAPONGAS","stateCode":"PR","buscaAdicional":"COLIBRI MOVEIS 52418 COLIBRI MOVEIS 900601"},{"id":"e7561d68-a8c6-4c8b-5db6-08d5ad2bf6ba","name":"DJ INDUSTRIA E COMERCIO DE MOVEIS LTDA","commercialName":"DJ MOVEIS","cnpj":"85074623000161","city":"ARAPONGAS","stateCode":"PR","buscaAdicional":"DJ MOVEIS 51963 DJ MOVEIS ARAPONGAS 899889 DJ MOVEIS SABAUDIA 899910"},{"id":"fd9da59f-f9aa-4d64-6030-08d5ad2bf6ba","name":"MOINHO ARAPONGAS S/A","commercialName":"","cnpj":"76125244000162","city":"ARAPONGAS","stateCode":"PR","buscaAdicional":"MOINHO ARAPONGAS 53419 MOINHO ARAPONGAS 903256"},{"id":"00d8aef5-99f9-41ae-610f-08d5ad2bf6ba","name":"GRAPPA - INDUSTRIA E COMERCIO DE MOVEIS LTDA.","commercialName":"","cnpj":"04861226000138","city":"ARAPONGAS","stateCode":"PR","buscaAdicional":"GRAPPA 53988 GRAPPA MOVEIS 906043"},{"id":"055138e2-bf55-4789-67d1-08d5ad2bf6ba","name":"V L MUNHOZ & CIA LTDA","commercialName":"","cnpj":"80843550000101","city":"ARAPONGAS","stateCode":"PR","buscaAdicional":"VILA RICA 58653 V L MUNHOZ E CIA 909616"},{"id":"72efa309-d742-4cc0-6429-08d5ad2bf6ba","name":"QMOVI INDUSTRIA MOVELEIRA LTDA.","commercialName":"","cnpj":"05611883000190","city":"ARAPONGAS","stateCode":"PR","buscaAdicional":"QMOVI 55861 QMOVI IND MOVELEIRA 906382"},{"id":"95347ebe-1bfa-416a-61ef-08d5ad2bf6ba","name":"BORTOLLOTI INDUSTRIA E COMERCIO DE MOVEIS LTDA","commercialName":"H.B. MOVEIS","cnpj":"03971957000173","city":"ARAPONGAS","stateCode":"PR","buscaAdicional":"HB MOVEIS 54474 BORTOLLOTI INDUSTRIA 906487"},{"id":"24830f79-d269-464f-624b-08d5ad2bf6ba","name":"INCORPLAC IND. E COM. DE MOVEIS LTDA","commercialName":"","cnpj":"02554882000162","city":"ARAPONGAS","stateCode":"PR","buscaAdicional":"INCORPLAC 54675 INCORPLAC MOVEIS LTD 906456"},{"id":"80e32d88-f04e-4eb0-64a5-08d5ad2bf6ba","name":"CAPAL COOPERATIVA AGROINDUSTRIAL","commercialName":"","cnpj":"78320397000196","city":"ARAPOTI","stateCode":"PR","buscaAdicional":"CAPAL 56142 CAPAL - TAQUARIVAI 907892 CAPAL WENCESLAU BRAZ 908263 CAPAL ITARARE 909420"},{"id":"5d60879e-2c54-4eac-5090-08d5ad2bf6ba","name":"B.O PAPER BRASIL INDUSTRIA DE PAPEIS LTDA","commercialName":"B.O PAPER","cnpj":"07632665000167","city":"ARAPOTI","stateCode":"PR","buscaAdicional":"BO PAPER 1721 STORAENSO-ARAPOTI-PR 174"},{"id":"dc5cc735-67cd-47c8-5d11-08d5ad2bf6ba","name":"A J RORATO & CIA LTDA","commercialName":"FABRICA DE MOVEIS RORATO","cnpj":"76295344000137","city":"ARARUNA","stateCode":"PR","buscaAdicional":"AJ RORATO 51693 A J RORATO 902179"},{"id":"6c7a8720-9977-437c-627b-08d5ad2bf6ba","name":"PINDUCA INDUSTRIA ALIMENTICIA LTDA","commercialName":"FARINHA PINDUCA","cnpj":"75875773000110","city":"ARARUNA","stateCode":"PR","buscaAdicional":"FARINHA PINDUCA 54773 PINDUCA UC 31347797 907418 PINDUCA UC 68199449 907419"},{"id":"8e4e116e-492d-4019-62b9-08d5ad2bf6ba","name":"IMPRESS DECOR BRASIL - INDUSTRIA DE PAPEIS DECORATIVOS LTDA","commercialName":"IMPRESS DECOR BRASIL LTDA","cnpj":"02644907000119","city":"ARAUCÁRIA","stateCode":"PR","buscaAdicional":"IMPRESS DECOR 54939 IMPRESS DECOR 905064"},{"id":"b61bc859-fae4-4126-61cc-08d5ad2bf6ba","name":"RISOTOLANDIA INDUSTRIA E COMERCIO DE ALIMENTOS LTDA","commercialName":"","cnpj":"76900463000171","city":"ARAUCÁRIA","stateCode":"PR","buscaAdicional":"RISOTOLANDIA 54430 RISOTOLANDIA UC44686 906061"},{"id":"08599121-828c-483f-63e1-08d5ad2bf6ba","name":"ARCELORMITTAL GONVARRI BRASIL PRODUTOS SIDERURGICOS S/A","commercialName":"","cnpj":"02235994000150","city":"ARAUCÁRIA","stateCode":"PR","buscaAdicional":"AM GONVARRI 55691 ARCELORMITTAL GONV 908865 ARCELORMITTAL GONVAR 908874"},{"id":"ea76987e-d87a-479f-63e7-08d5ad2bf6ba","name":"INGERSOLL-RAND INDUSTRIA, COMERCIO E SERVICOS DE AR CONDICIONADO, AR COMPRIMIDO E REFRIGERACAO LTDA","commercialName":"","cnpj":"01610517000165","city":"ARAUCÁRIA","stateCode":"PR","buscaAdicional":"INGERSOLL 55711 INGERSOLL 907680"},{"id":"dcaf1310-58b1-44cc-6815-08d5ad2bf6ba","name":"ALCABRAS INDUSTRIA E COMERCIO LTDA","commercialName":"","cnpj":"06110207000103","city":"ARAUCÁRIA","stateCode":"PR","buscaAdicional":"ALCABRAS 59336 ALCABRAS - ARAUCARIA 909668"},{"id":"a446a195-38f8-463c-6818-08d5ad2bf6ba","name":"PROCOPIO EMBALAGENS LTDA","commercialName":"","cnpj":"03941878000110","city":"ARAUCÁRIA","stateCode":"PR","buscaAdicional":"PROCOPIO EMB 59350 PROCOP EMB ARAUCARI 910137"},{"id":"ade73924-7cf9-425f-65a2-08d5ad2bf6ba","name":"NOVOZYMES LATIN AMERICA LTDA","commercialName":"","cnpj":"47247705000171","city":"ARAUCÁRIA","stateCode":"PR","buscaAdicional":"NOVOZYMES 56875 NOVOZYMES 908169"},{"id":"79b580bd-3ad5-4faf-1cc1-08d5b8870181","name":"ALLTECH DO BRASIL AGROINDUSTRIAL LTDA.","commercialName":"ALLTECH","cnpj":"72058241000100","city":"ARAUCÁRIA","stateCode":"PR","buscaAdicional":"ALLTECH 61144 ALLTECH UC94987971 912860"},{"id":"667f67ef-2343-4e93-5ecc-08d5ad2bf6ba","name":"PARNAPLAST INDUSTRIA DE PLASTICOS LTDA","commercialName":"","cnpj":"75029595000107","city":"ARAUCÁRIA","stateCode":"PR","buscaAdicional":"PARNAPLAST 52554 PARNAPLAST 902497"},{"id":"9cf05598-65a6-42fa-60eb-08d5ad2bf6ba","name":"EMBALAGENS INDUSTRIAIS ADESI COATING LTDA.","commercialName":"EMBALAGENS INDUSTRIAIS ADESI COATING","cnpj":"11325407000105","city":"ARAUCÁRIA","stateCode":"PR","buscaAdicional":"ADESI 53899 ADESI COATING 905992"},{"id":"fb7c5bf7-2cb8-4c53-5fb9-08d5ad2bf6ba","name":"KAPERSUL INDUSTRIA E COMERCIO DE PAPEIS S/A.","commercialName":"","cnpj":"78381613000103","city":"ARAUCÁRIA","stateCode":"PR","buscaAdicional":"KAPERSUL ARA 53200 KAPERSUL 902678 KAPERSUL UC 45959757 908034"},{"id":"8e99fdbf-d8c5-4817-5f17-08d5ad2bf6ba","name":"STYLO - INDUSTRIA E COMERCIO DE VIDROS EIRELI","commercialName":"STYLO FERRAGENS","cnpj":"16925894000160","city":"ARAUCÁRIA","stateCode":"PR","buscaAdicional":"STYLO 52733 STYLO INDUSTRIA PR 901076"},{"id":"09b354ae-fc2a-49f7-5c55-08d5ad2bf6ba","name":"HUBNER COMPONENTES E SISTEMAS AUTOMOTIVOS S/A","commercialName":"","cnpj":"06886749000407","city":"ARAUCÁRIA","stateCode":"PR","buscaAdicional":"HUBNER 51265 HUBNER UC 61436887 900082 HUBNER UC 68376189 900083 HUBNER UC 68382529 899836"},{"id":"b93fc871-9c6d-4dd3-597d-08d5ad2bf6ba","name":"BRAFER CONSTRUCOES METALICAS S A","commercialName":"BRAFER","cnpj":"77153773000132","city":"ARAUCÁRIA","stateCode":"PR","buscaAdicional":"BRAFER 14615 BRAFER 893622 BRAFER RJ 894922 BRAFER JUIZ DE FORA 909375"},{"id":"650ad062-a30c-4d82-501a-08d5ad2bf6ba","name":"BERNECK S.A. PAINEIS E SERRADOS","commercialName":"","cnpj":"81905176000194","city":"ARAUCÁRIA","stateCode":"PR","buscaAdicional":"BERNECK I5 1444 BERNECK CONSUMO 62 BERNECK-CURITIBANOS 71813 BERNECK 8625 UTE.FL.PR.029993-6.01"},{"id":"ae40895f-0262-4cf0-5717-08d5ad2bf6ba","name":"AAM DO BRASIL LTDA.","commercialName":"","cnpj":"03368638000178","city":"ARAUCÁRIA","stateCode":"PR","buscaAdicional":"AAM 8193 AAM 888399"},{"id":"5859f854-54a2-4ba0-63bd-08d5ad2bf6ba","name":"TECNOTAM - EMBALAGENS INDUSTRIAIS LTDA","commercialName":"TECNOTAM - EMBALAGENS INDUSTRIAIS","cnpj":"04621481000103","city":"BALSA NOVA","stateCode":"PR","buscaAdicional":"TECNOTAM 55594 TECNOTAM 907130"},{"id":"da444896-36b1-4112-617b-08d5ad2bf6ba","name":"PEDREIRA SAO JORGE LTDA","commercialName":"","cnpj":"76485408000162","city":"BALSA NOVA","stateCode":"PR","buscaAdicional":"SAO JORGE 54206 PEDREIRA SAO JORGE 905996"},{"id":"db44134f-caf1-4868-6492-08d5ad2bf6ba","name":"NUTRITOP INDUSTRIA E COM.ALIMENTOS LTDA","commercialName":"NUTRITOP","cnpj":"00736358000187","city":"BANDEIRANTES","stateCode":"PR","buscaAdicional":"NUTRITOP 56092 NUTRITOP 907645"},{"id":"b2a3163b-24ef-444f-5c28-08d5ad2bf6ba","name":"ZENAPLAST IND COM DE ARTEFATOS DE PLASTICO LTDA","commercialName":"","cnpj":"72225683000196","city":"BANDEIRANTES","stateCode":"PR","buscaAdicional":"ZENAPLAST 51121 ZENAPLAST ARTEFATOS 899737"},{"id":"15f19b08-4dd4-44eb-5f8c-08d5ad2bf6ba","name":"BRASFIBRA INDUSTRIA E COMERCIO DE CHAPAS DE MADEIRA LTDA","commercialName":"BRASFIBRA","cnpj":"79129151000102","city":"BITURUNA","stateCode":"PR","buscaAdicional":"BRASFIBRA 53018 BRASFIBRA 902980"},{"id":"dc464094-e44a-4fe5-681b-08d5ad2bf6ba","name":"DALGALLO COMPENSADOS E PORTAS LTDA","commercialName":"DALCOMAD","cnpj":"97458749000119","city":"BITURUNA","stateCode":"PR","buscaAdicional":"DALCOMAD 59353 DALGALLO COMPENSADOS 910119"},{"id":"7a9bba7e-7cb6-40a7-682f-08d5ad2bf6ba","name":"PINUSTAN INDUTRIA E COMERCIO DE MADEIRAS LTDA","commercialName":"","cnpj":"03298956000100","city":"BOCAIÚVA DO SUL","stateCode":"PR","buscaAdicional":"PINUSTAN 59457 PINUSTAN UC 33540764 910635"},{"id":"d34cef52-7af2-4683-8d81-08d5d060706e","name":"USINA DE BENEFICIAMENTO DE LEITE BOM SUCESSO LTDA","commercialName":"LATICINIO BOM SUCESSO","cnpj":"08290831000157","city":"BOM SUCESSO DO SUL","stateCode":"PR","buscaAdicional":"BOM SUCESSO 59082 USINA BOM SUCESSO 913524"},{"id":"08367703-7dbe-4a87-6478-08d5ad2bf6ba","name":"COPACOL-COOPERATIVA AGROINDUSTRIAL CONSOLATA","commercialName":"COPACOL","cnpj":"76093731000190","city":"CAFELÂNDIA","stateCode":"PR","buscaAdicional":"COPACOL 56019 COPACOL - CAFELANDIA 907012 COPACOL - INCUB GOIO 906982 COPACOL FAB JESUITAS 907011 COPACOL - ABATEDOURO 907013 COPACOL -NOVA AURORA 907014"},{"id":"7754b16c-3a04-44de-687b-08d5ad2bf6ba","name":"F. A. C. FABRICA DE ACUMULADORES CALIFORNIA LTDA","commercialName":"","cnpj":"04708093000245","city":"CALIFÓRNIA","stateCode":"PR","buscaAdicional":"ACUMULADORES CALIFORNIA 60099 ACUMULADORES CALIFOR 899086"},{"id":"68ac8059-27c8-4b18-88c1-08d5ae44ed50","name":"R.B.C.L. - RENOVADORA DE BATERIAS CALIFORNIA EIRELI","commercialName":"","cnpj":"02189661000132","city":"CALIFÓRNIA","stateCode":"PR","buscaAdicional":"BATERIAS BATS 50866"},{"id":"488b3794-6c58-4b24-62b3-08d5ad2bf6ba","name":"FORMAPLAST INDUSTRIA E COMERCIO DE EMBALAGENS PLASTICAS EIRELI","commercialName":"","cnpj":"06537335000120","city":"CAMBÉ","stateCode":"PR","buscaAdicional":"FORMAPLAST 54933 FORMAPLAST 906023"},{"id":"70246123-f401-47fe-5fe6-08d5ad2bf6ba","name":"HYDRONORTH S/A","commercialName":"","cnpj":"01618551000690","city":"CAMBÉ","stateCode":"PR","buscaAdicional":"HYDRONORTH 53280 HYDRONORTH 909430"},{"id":"b3bd4c4e-b7e2-419b-5df8-08d5ad2bf6ba","name":"SANDOZ DO BRASIL INDUSTRIA FARMACEUTICA LTDA.","commercialName":"","cnpj":"61286647000116","city":"CAMBÉ","stateCode":"PR","buscaAdicional":"SANDOZ 52095 SANDOZ 899994"},{"id":"4bea7689-0651-4944-5d94-08d5ad2bf6ba","name":"TEMPERBRAS - INDUSTRIA E COMERCIO DE VIDROS LTDA","commercialName":"TEMPERBRAS - INDUSTRIA DE COMERCIO DE VIDROS","cnpj":"10660705000199","city":"CAMBÉ","stateCode":"PR","buscaAdicional":"TEMPERBRAS 51925 TEMPERBRAS 899801"},{"id":"f942ae15-0bd6-4122-5b7e-08d5ad2bf6ba","name":"AMCOR FLEXIBLES BRASIL LTDA","commercialName":"","cnpj":"05818423000137","city":"CAMBÉ","stateCode":"PR","buscaAdicional":"AMCOR FLEXIBLES 50733 AMCOR FLEXIBLES 899199"},{"id":"54cb7f5c-2b03-4728-5b79-08d5ad2bf6ba","name":"PLM PLASTICOS LTDA","commercialName":"P L M","cnpj":"02385570000172","city":"CAMPINA GRANDE DO SUL","stateCode":"PR","buscaAdicional":"PLM MAT 50714 PLM CAMPINA GRANDE 898955"},{"id":"7ae37fbb-e76d-4da6-5e12-08d5ad2bf6ba","name":"MINATTI FUNDICAO TECNICA LTDA","commercialName":"","cnpj":"81205619000134","city":"CAMPINA GRANDE DO SUL","stateCode":"PR","buscaAdicional":"MINATTI FUNDICAO 52188 MINATTI FUNDICAO 900526"},{"id":"b62322f0-3ed6-49c7-6396-08d5ad2bf6ba","name":"SOCIEDADE HOSPITALAR ANGELINA CARON","commercialName":"HOSPITAL ANGELINA CARON","cnpj":"07088017000191","city":"CAMPINA GRANDE DO SUL","stateCode":"PR","buscaAdicional":"ANGELINA CARON 55476 HOSPITAL ANGELINA 907276"},{"id":"db915943-b0a1-4c45-67b8-08d5ad2bf6ba","name":"REFORPAN INDUSTRIA E COMERCIO DE PRODUTOS ALIMENTICIOS LTDA","commercialName":"REFORPAN INDUSTRIA E COMERCIO DE PRODUTOS ALIMENTICIOS","cnpj":"09274367000178","city":"CAMPINA GRANDE DO SUL","stateCode":"PR","buscaAdicional":"REFORPAN INDUSTRIA 58550 REFORPAN 899426 REFORPAN CAMPINA GRD 909091 REFORPAN - CAMBORIU 913351"},{"id":"8159c728-1edd-4c74-613d-08d5ad2bf6ba","name":"MATERNIDADE E CIRURGIA N. S. DO ROCIO S/A","commercialName":"","cnpj":"75802348000100","city":"CAMPO LARGO","stateCode":"PR","buscaAdicional":"HOSPITAL DO ROCIO 54070 MATERNIDADE ROCIO 905043"},{"id":"6be89d38-a4fe-4754-7320-08d5cf600bef","name":"COMPANHIA AURIFERA BRASILEIRA S.A","commercialName":"","cnpj":"12078880000106","city":"CAMPO LARGO","stateCode":"PR","buscaAdicional":""},{"id":"cbd0de45-a3a7-41d0-5e39-08d5ad2bf6ba","name":"PROCOPIO INDUSTRIA E COMERCIO LTDA","commercialName":"","cnpj":"76642891000141","city":"CAMPO LARGO","stateCode":"PR","buscaAdicional":"PROCOPIO 52288 PROCOPIO CAMPO LARGO 900894"},{"id":"5c7983cd-36ce-46b2-5d9e-08d5ad2bf6ba","name":"PITLAK & CIA. LTDA","commercialName":"PITLAK","cnpj":"01570343000154","city":"CAMPO LARGO","stateCode":"PR","buscaAdicional":"PITLAK 51936 CERTO SABOR ALIMENTO 900648"},{"id":"73dba85e-55ba-4cb9-5e61-08d5ad2bf6ba","name":"FCA POWERTRAIN BRASIL INDUSTRIA E COMERCIO DE MOTORES LTDA","commercialName":"FPT POWERTRAIN DO BRASIL","cnpj":"01655350000159","city":"CAMPO LARGO","stateCode":"PR","buscaAdicional":"FIAT CAMPO LARGO 52345 FIAT CAMPO LARGO 902322"},{"id":"a2522d37-baba-4a64-5d0b-08d5ad2bf6ba","name":"INCEPA REVESTIMENTOS CERAMICOS LTDA","commercialName":"","cnpj":"76610062000187","city":"CAMPO LARGO","stateCode":"PR","buscaAdicional":"INCEPA 51685 INCEPA SMS PR 900983 INCEPA CL 901461"},{"id":"f5bd1e76-1b0e-4422-5cbb-08d5ad2bf6ba","name":"INDUSTRIA DE PAPELAO HORLLE LTDA","commercialName":"","cnpj":"76489533000140","city":"CAMPO LARGO","stateCode":"PR","buscaAdicional":"PAPELAO HORLLE 51543 PAPELAO HORLLE 900833"},{"id":"63c3732d-6db6-481d-5bca-08d5ad2bf6ba","name":"CATERPILLAR BRASIL LTDA","commercialName":"CATERPILLAR BRASIL LTDA.","cnpj":"61064911001734","city":"CAMPO LARGO","stateCode":"PR","buscaAdicional":"CATERPILLAR BRASIL 50912 CATERPILLAR BRA PR 898532"},{"id":"b364c1c8-686d-4b35-5760-08d5ad2bf6ba","name":"AUTO ADESIVOS PARANA S.A","commercialName":"COLACRIL","cnpj":"03514129000106","city":"CAMPO MOURÃO","stateCode":"PR","buscaAdicional":"AUTO ADESIVOS 8749 AUDO ADESIVOS PR 901513"},{"id":"6e554ae4-b66c-4948-5019-08d5ad2bf6ba","name":"COAMO AGROINDUSTRIAL COOPERATIVA","commercialName":"COAMO","cnpj":"75904383000121","city":"CAMPO MOURÃO","stateCode":"PR","buscaAdicional":"COAMO 1443 COAMO IND PARANAGUA 906981 COAMO TERM PARANAGUA 907382"},{"id":"31586469-f263-47f0-646a-08d5ad2bf6ba","name":"TONELLO E MACHADO DA LUZ LTDA","commercialName":"PARANA SUPERMERCADO","cnpj":"76260017000140","city":"CAMPO MOURÃO","stateCode":"PR","buscaAdicional":"PARANA SUPERMERCADO 55985 TONELLO 83788255 907006 TONELLO 94183848 907007 TONELLO 96360550 907008 PARANA UC 81973446 913523"},{"id":"917e48a3-bc86-422a-8882-08d5ae44ed50","name":"COAMO AGROINDUSTRIAL COOPERATIVA","commercialName":"COAMO","cnpj":"75904383000636","city":"CAMPO MOURÃO","stateCode":"PR","buscaAdicional":"COAMO AGRO 9489 SE COAMO 889132"},{"id":"e6c34dab-8c6d-4e32-5ea4-08d5ad2bf6ba","name":"SANTA CLARA INDUSTRIA DE PASTA E PAPEL LTDA","commercialName":"","cnpj":"77883189000132","city":"CANDÓI","stateCode":"PR","buscaAdicional":"SANTA CLARA 52471 SANTA CLARA 907387"},{"id":"1ff03f76-b5d7-47c4-8892-08d5ae44ed50","name":"MADEIREIRA RICKLI LTDA","commercialName":"","cnpj":"78127271000108","city":"CARAMBEÍ","stateCode":"PR","buscaAdicional":"MADEIREIRA RICKLI 14195 RICKLI 895642 UTE.FL.PR.028503-0.01"},{"id":"8124e635-21a5-4ced-6195-08d5ad2bf6ba","name":"FRISIA COOPERATIVA AGROINDUSTRIAL","commercialName":"COOPERATIVA FRISIA","cnpj":"76107770000108","city":"CARAMBEÍ","stateCode":"PR","buscaAdicional":"FRISIA 54248 FRISIA CARAMBEI I 905315 FRISIA CARAMBEI 2 905316 FRISIA TIBAGI I 905317 FRISIA TIBAGI II 905334 FRISIA P GROSSA III 905335 FRISIA P GROSSA I 905336 FRISIA PTA GROSSA 4 905518 FRISIA PTA GROSSA 2 905519"},{"id":"af46e029-19ee-4bbf-6499-08d5ad2bf6ba","name":"PEDRO MUFFATO & CIA LTDA","commercialName":"MUFFATAO","cnpj":"81433765000117","city":"CASCAVEL","stateCode":"PR","buscaAdicional":"MUFFATAO 56130 MUFFATAO WEST SIDE 907378 MUFFATAO NEVA 907379 MUFFATAO CANCELI 907393"},{"id":"fa11aec5-d597-4f5a-887f-08d5ae44ed50","name":"COOPAVEL COOPERATIVA AGROINDUSTRIAL","commercialName":"COOPAVEL","cnpj":"76098219002695","city":"CASCAVEL","stateCode":"PR","buscaAdicional":"COOPAVEL 9229"},{"id":"fd4b92cf-abf2-4e14-687a-08d5ad2bf6ba","name":"FELIX ADMINISTRACAO DE BENS LTDA","commercialName":"FELIX CONSTRUCOES CIVIS","cnpj":"08380802000186","city":"CASCAVEL","stateCode":"PR","buscaAdicional":"FELIX 60098 JOTA ELE IMOBILIARIA 903119"},{"id":"ffd0181e-cc05-4aa9-67d5-08d5ad2bf6ba","name":"COOPAVEL COOPERATIVA AGROINDUSTRIAL","commercialName":"COOPAVEL","cnpj":"76098219000137","city":"CASCAVEL","stateCode":"PR","buscaAdicional":"COOPAVEL COOPERATIVA 58671 COOPAVEL AGROINDUSTR 910060 COOPAVEL UC 55379702 910274 COOPAVEL UC 77192680 910296 COOPAVEL UC 96661941 911177 COOPAVEL UC 74274520 911673 COOPAVEL UC 97213748 911695 COOPAVEL UC 97743194 911714 COOPAVEL 889059 COOPAVEL UC 19908881 912211 COOPAVEL UC 96628081 912232"},{"id":"ea8bb3aa-aed9-442b-67b0-08d5ad2bf6ba","name":"COTRIGUACU COOPERATIVA CENTRAL","commercialName":"COTRIGUACU","cnpj":"77118131000100","city":"CASCAVEL","stateCode":"PR","buscaAdicional":"COTRIGUACU 58471 COTRIGUACU PALOTINA 909607 COTRIGUACU CASCAVEL 909617 COTRIGUACU - PARANAG 912321"},{"id":"dd2d0626-91a4-430e-6665-08d5ad2bf6ba","name":"MOVISTAR COMERCIO DE MATERIAL DE CONSTRUCAO LTDA","commercialName":"","cnpj":"10434193000495","city":"CASCAVEL","stateCode":"PR","buscaAdicional":"MOVISTAR JD HOME 57520 MOVISTAR 911713"},{"id":"31c36f6d-5c64-4440-734c-08d5cf600bef","name":"CAPITALE SECURITIZADORA DE CREDITO S.A.","commercialName":"CAPITALE SECURITIZADORA","cnpj":"15229110000105","city":"CASCAVEL","stateCode":"PR","buscaAdicional":""},{"id":"227fd009-35f8-4d3d-88e0-08d5ae44ed50","name":"JOTA ELE IMOBILIARIA E ADMINISTRADORA LTDA","commercialName":"","cnpj":"80800923000167","city":"CASCAVEL","stateCode":"PR","buscaAdicional":"CATARATAS ADM 53940"},{"id":"7a7c1474-2511-4c58-5ea8-08d5ad2bf6ba","name":"NUTRIPLAST INDUSTRIA E COMERCIO LTDA","commercialName":"NUTRIPLAN - MATRIZ","cnpj":"78575511000129","city":"CASCAVEL","stateCode":"PR","buscaAdicional":"NUTRIPLAST 52475 NUTRIPLAST 903076"},{"id":"6055adb6-39fb-4593-5e7d-08d5ad2bf6ba","name":"UNIAO EDUCACIONAL DE CASCAVEL - UNIVEL LTDA","commercialName":"UNIVEL","cnpj":"80882772000133","city":"CASCAVEL","stateCode":"PR","buscaAdicional":"UNIVEL 52401 UNIVEL CASCAVEL PR 903261"},{"id":"ac15a334-4eff-420f-5e42-08d5ad2bf6ba","name":"TEMPERLINE INDUSTRIA E COMERCIO DE VIDROS LTDA","commercialName":"TEMPERLINE","cnpj":"04951088000188","city":"CASCAVEL","stateCode":"PR","buscaAdicional":"TEMPERLINE 52298 FG VIDROS 902982 TEMPERLINE 903078"},{"id":"42a39688-9c8c-46ea-5e05-08d5ad2bf6ba","name":"CENTRAIS ELETRICAS PADOVANI LTDA","commercialName":"CEPI ENERGIA","cnpj":"04326452000119","city":"CASCAVEL","stateCode":"PR","buscaAdicional":"CGH PADOVANI 52151 CGH PADOVANI 906743 CGH.PH.PR.031187-1.01"},{"id":"66802f7a-16fa-4ffe-5d86-08d5ad2bf6ba","name":"ESPACOFRIO ARMAZENAGEM FRIGORIFICA LTDA","commercialName":"ESPACOFRIO","cnpj":"05146605000109","city":"CASCAVEL","stateCode":"PR","buscaAdicional":"ESPACOFRIO 51848 ESPACOFRIO FRIGORIF 902619"},{"id":"7cdb4d58-a437-46be-5d6f-08d5ad2bf6ba","name":"MASCARELLO - CARROCERIAS E ONIBUS LTDA","commercialName":"MASCARELLO","cnpj":"05440065000171","city":"CASCAVEL","stateCode":"PR","buscaAdicional":"MASCARELLO 51818 MASCARELLO ONIBUS PR 901008"},{"id":"6794e73b-6b9d-4caa-5d57-08d5ad2bf6ba","name":"COMIL SILOS E SECADORES LTDA","commercialName":"COMIL SILOS","cnpj":"76061480000162","city":"CASCAVEL","stateCode":"PR","buscaAdicional":"COMIL SILOS 51792 COMIL SECADORES 900934"},{"id":"07bbed05-e567-44d9-5fb0-08d5ad2bf6ba","name":"INDUSTRIA DE PLASTICOS ELIZA LTDA","commercialName":"","cnpj":"03102539000140","city":"CASCAVEL","stateCode":"PR","buscaAdicional":"ELIZA PLASTICOS 53114 IND PLASTICOS ELIZA 902683"},{"id":"ab548c53-c9e3-4ed6-6021-08d5ad2bf6ba","name":"SUPERMERCADOS IRANI LTDA","commercialName":"","cnpj":"75864728000160","city":"CASCAVEL","stateCode":"PR","buscaAdicional":"IRANI SUPERMERCADOS 53397 IRANI LOJA 3 905052 IRANI LOJA 1 905066"},{"id":"3e088402-1b28-449c-5ff5-08d5ad2bf6ba","name":"CIA BEAL DE ALIMENTOS","commercialName":"","cnpj":"78116670000165","city":"CASCAVEL","stateCode":"PR","buscaAdicional":"CIA BEAL 53314 CIA BEAL FACULDADE 903108 CIA BEAL TANCREDO 903109 CIA BEAL BARIGUI 903110 CIA BEAL CD/CWB 903111 CIA BEAL AV BRASIL 903155 CIA BEAL STA FELIC 903157 BEAL BRIGADEIRO FRAN 906322 FESTVAL BEAL MERCES 906427 CIA BEAL ALIMENTOS 906482 FESTVAL BEAL AGUA V 906755 CIA BEAL CURITIBA 910515"},{"id":"f5ee5447-5f05-40a7-5b65-08d5ad2bf6ba","name":"FLEXIBAG INDUSTRIA E COMERCIO DE EMBALAGENS LTDA","commercialName":"FLEXIBAG INDUSTRIA E COMERCIO DE EMBALAGENS LTDA","cnpj":"10237164000190","city":"CASCAVEL","stateCode":"PR","buscaAdicional":"FLEXIBAG 50692 FLEXIBAG 899407"},{"id":"6e8d5aca-0086-47be-5b4b-08d5ad2bf6ba","name":"IRMAOS MUFFATO CIA LTDA","commercialName":"SUPER MUFFATO","cnpj":"76430438000171","city":"CASCAVEL","stateCode":"PR","buscaAdicional":"MUFFATO 50571 S081 MARINGA 889844 MUFFATO LOJA 68 898372 MUFFATO LOJA 32 898406 MUFFATO LOJA 38 898948 MUFFATO L29 899055 MUFFATO LOJA 37 899058 MUFFATO LOJA 06 899059 MUFFATO LOJA 61 899414 MUFFATO LOJA 39 899415 MUFFATO LOJA 49 899416 MUFFATO UN 58 899417 MUFFATO LOJA 51 899430 MUFFATO LOJA 65 899546 MUFFATO LOJA 53 899547 MUFFATO LOJA 67 899548 MUFFATO UN 55 899549 MUFFATO UN 63 899550 MUFFATO LOJA 64 899551 MUFFATO LJ70 899598 MUFFATO L44 899607 MUFFATO 27 899766 MUFFATO 07 899814 MUFFATO L23 899829 MUFFATO L57 899830 MUFFATO L30 899831 MUFFATO LOJA 59 900094 MUFFATO LOJA 60 900095 MUFFATO LOJA 54 900096 MUFFATO UN 18 900974 MUFFATO LOJA 26 901100 MUFFATO LOJA 35 902627 MUFFATO UN 66 902736 MUFFATO UN 25 902915 MUFFATO LOJA 56 903793 MUFFATO LOJA 46 904761 MUFFATO UN 28 905756 MUFFATO UN 45 906113 MUFFATO UN 48 906277 MUFFATO UN 47 906296 MUFFATO 33 906816 MUFFATO UN 40 907251 MUFFATO UN 04 908544 MUFFATO 72 909085 MUFFATO 76 909087 MUFFATO 74 909445 MUFFATO UN 75 910836 MUFFATO UN 79 910837 MUFFATO UN 83 911693 IRMAO MUFFATO SP 897672 MUFFATO LOJA 50 898051 MUFFATO LOJA 36 898052 MUFFATO 71 906384 MUFFATO 73 907899 MUFFATO 80 909592"},{"id":"8c97b6d3-ba20-45d2-56a3-08d5ad2bf6ba","name":"KAEFER AGRO INDUSTRIAL LTDA","commercialName":"","cnpj":"84874726000143","city":"CASCAVEL","stateCode":"PR","buscaAdicional":"KAEFER 7421 KAEFER LARANJEIRAS 72367 KAEFER CASCAVEL 72368"},{"id":"a531cd1b-d3cf-4e40-5f4b-08d5ad2bf6ba","name":"CASTROLANDA - COOPERATIVA AGROINDUSTRIAL LTDA","commercialName":"CASTROLANDA - COOPERATIVA AGROINDUSTRIAL","cnpj":"76108349000103","city":"CASTRO","stateCode":"PR","buscaAdicional":"CASTROLANDA 52889 CASTROLANDA UNF 903214 CASTROLANDA PIRAI 903356 CASTROLANDIA FAB RAC 903766 CASTROLANDA UBL 903915 CASTROLANDA PGROSSA 904020 CASTROLANDA SOCAVAO 904087 CASTROLANDA VENTANIA 904435 CASTROLANDA - ULB 904454 CASTROLANDIA ITABERA 907824 CASTROLANDA - ITAB 2 908685 CASTROLANDA UIC 903378 CASTROLANDIA ITAPETI 908860 CASTROLANDA UBL ETE 903260"},{"id":"87dbb3d5-78b0-439c-6750-08d5ad2bf6ba","name":"CARGILL AGRICOLA S A","commercialName":"","cnpj":"60498706039010","city":"CASTRO","stateCode":"PR","buscaAdicional":"CARGILL CST 58038 CARGILL CST 909084"},{"id":"6a0e6538-c005-4116-6460-08d5ad2bf6ba","name":"CASTRO ENERGIA LTDA","commercialName":"PCH CASTRO","cnpj":"08017729000182","city":"CASTRO","stateCode":"PR","buscaAdicional":"PCH CASTRO 55962 PCH CASTRO 910451 PCH.PH.PR.032513-9.01"},{"id":"7a2bfc7d-adb0-4574-61fb-08d5ad2bf6ba","name":"EVONIK BRASIL LTDA","commercialName":"","cnpj":"62695036005404","city":"CASTRO","stateCode":"PR","buscaAdicional":"EVONIK CASTRO 54496 EVONIK CASTRO PR 906058"},{"id":"7d1bf176-5a2e-46d9-608b-08d5ad2bf6ba","name":"REFARE LTDA","commercialName":"MOINHO RIO AZUL","cnpj":"81678302000115","city":"CÉU AZUL","stateCode":"PR","buscaAdicional":"REFARE 53583 REFARE 906036"},{"id":"d4567f22-c123-4abf-608e-08d5ad2bf6ba","name":"ARAUCARIA INDUSTRIA E COMERCIO DE PAPEIS LTDA","commercialName":"PAPEIS ARAUCARIA","cnpj":"03505376000146","city":"CHOPINZINHO","stateCode":"PR","buscaAdicional":"ARAUCARIA PAPEIS CE 53586 ARAUCARIA PAPEIS 905276"},{"id":"9b4cd793-a27b-4983-6063-08d5ad2bf6ba","name":"BRASMACOL INDUSTRIA E COMERCIO LTDA","commercialName":"BRASMACOL","cnpj":"84968338000121","city":"CHOPINZINHO","stateCode":"PR","buscaAdicional":"BRASMACOL 53487 BRASMACOL 905273"},{"id":"08a0c8b1-49ad-4525-61bf-08d5ad2bf6ba","name":"UPA COUROS - INDUSTRIA E COMERCIO LTDA.","commercialName":"UPA COUROS","cnpj":"06125043000180","city":"CHOPINZINHO","stateCode":"PR","buscaAdicional":"UPA COUROS 54368 UPA COUROS 907244"},{"id":"5d630bef-8340-478e-6635-08d5ad2bf6ba","name":"INDUSTRIA DE ALIMENTOS EL-SHADAI LTDA","commercialName":"","cnpj":"04182987000163","city":"CHOPINZINHO","stateCode":"PR","buscaAdicional":"DOCE DOCE 57390 SHADAI 908812"},{"id":"2b74ef21-7be8-43e4-62b1-08d5ad2bf6ba","name":"JUPITER BATERIAS E COMPONENTES LTDA","commercialName":"BATERIAS JUPITER","cnpj":"02468496000158","city":"CIANORTE","stateCode":"PR","buscaAdicional":"BATERIAS JUPITER 54931 JUPITER UC69817200 906059 JUPITER UC59111593 906062"},{"id":"723eb478-7bd1-4e85-6559-08d5ad2bf6ba","name":"NERIAL INDUSTRIA E COMERCIO DE ALIMENTOS LTDA","commercialName":"","cnpj":"00086338000108","city":"CIANORTE","stateCode":"PR","buscaAdicional":"NERIAL 56670 NERIAL ALIMENTOS 909232"},{"id":"36bd4cf6-05ab-42d0-6098-08d5ad2bf6ba","name":"AVENORTE AVICOLA CIANORTE LTDA","commercialName":"","cnpj":"01682147000171","city":"CIANORTE","stateCode":"PR","buscaAdicional":"AVENORTE 53610 AVENORTE - CIANORTE 905259"},{"id":"185af230-7a70-45ee-60e5-08d5ad2bf6ba","name":"LAVANDERIA E TINTURARIA LAVINORTE LTDA.","commercialName":"","cnpj":"00667476000180","city":"CIANORTE","stateCode":"PR","buscaAdicional":"LAVINORTE 53867 LAVINORTE 905063"},{"id":"68ec05cd-38e8-47c6-5f5c-08d5ad2bf6ba","name":"AMAFIL INDUSTRIA E COMERCIO DE ALIMENTOS LTDA","commercialName":"AMAFIL INDUSTRIA E COMERCIO DE ALIMENTOS","cnpj":"75784140000105","city":"CIANORTE","stateCode":"PR","buscaAdicional":"AMAFIL 52912 AMAFIL UC 30756138 906468 AMAFIL UC 95770925 906492 AMAFIL UC 25392239 906646 AMAFIL UC 42085390 906749"},{"id":"8f4893f1-0ae0-47df-51fe-08d5ad2bf6ba","name":"USACIGA - ACUCAR, ALCOOL E ENERGIA ELETRICA LTDA.","commercialName":"USACIGA","cnpj":"75031633000166","city":"CIDADE GAÚCHA","stateCode":"PR","buscaAdicional":"USACIGA 2776 USACIGA CARGA 912484"},{"id":"e14aa095-304c-4062-611c-08d5ad2bf6ba","name":"SOMAVE AGROINDUSTRIAL LTDA","commercialName":"","cnpj":"06353241000109","city":"CIDADE GAÚCHA","stateCode":"PR","buscaAdicional":"SOMAVE 54025 SOMAVE 906004"},{"id":"a03039ca-e052-45b2-65d8-08d5ad2bf6ba","name":"AGRICOLA FECAMIL LTDA","commercialName":"","cnpj":"21164683000192","city":"CIDADE GAÚCHA","stateCode":"PR","buscaAdicional":"FECAMIL 57162 AGRICOLA FECAMIL 908813"},{"id":"f6eac70d-c747-47dc-6144-08d5ad2bf6ba","name":"RECRIAR RECUPERACAO COM. IND. DE PLASTICOS LTDA","commercialName":"","cnpj":"82590969000124","city":"COLOMBO","stateCode":"PR","buscaAdicional":"RECRIAR 54094 RECRIAR COLOMBO 904335"},{"id":"6cddb65e-6184-4695-61ce-08d5ad2bf6ba","name":"J P MOCELIM INDUSTRIA DE CALCARIO LTDA","commercialName":"","cnpj":"01250565000190","city":"COLOMBO","stateCode":"PR","buscaAdicional":"GRUPO MOCELIM 54433 J P MOCELIM 905074"},{"id":"bb72ecc0-02b2-4cdf-6230-08d5ad2bf6ba","name":"CIBRACAL INDUSTRIA BRASILEIRA DE CAL LTDA","commercialName":"CIBRACAL LTDA","cnpj":"77501856000175","city":"COLOMBO","stateCode":"PR","buscaAdicional":"CIBRACAL 54615 CIBRACAL 906021"},{"id":"8ba711b2-925d-436b-6246-08d5ad2bf6ba","name":"COLORFIX ITAMASTER INDUSTRIA DE MASTERBATCHES LIMITADA","commercialName":"","cnpj":"01182867000178","city":"COLOMBO","stateCode":"PR","buscaAdicional":"COLORFIX 54670 COLORFIX COLOMBO 907384"},{"id":"411867c9-fdba-4769-6262-08d5ad2bf6ba","name":"SANTA MONICA CLUBE DE CAMPO","commercialName":"","cnpj":"75031278000125","city":"COLOMBO","stateCode":"PR","buscaAdicional":"SAN MONICA 54741 ST MONICA CLUBE CAMP 906837"},{"id":"add4cb8b-912e-45b9-6333-08d5ad2bf6ba","name":"THERMOPLAST INDUSTRIAL DE PLASTICOS LTDA","commercialName":"","cnpj":"80052657000131","city":"COLOMBO","stateCode":"PR","buscaAdicional":"THERMOPLAST 55242 THERMOPLAST 907676"},{"id":"a66066f3-321f-4f6c-6577-08d5ad2bf6ba","name":"BELLSTECH LTDA","commercialName":"","cnpj":"07062708000116","city":"COLOMBO","stateCode":"PR","buscaAdicional":"PLASTCORE 56736 PLASTCORE 908486"},{"id":"fa1ac4ce-ccee-4987-6578-08d5ad2bf6ba","name":"BELLS INDUSTRIA E COMERCIO DE PLASTICOS E METAIS LTDA.","commercialName":"","cnpj":"04168163000139","city":"COLOMBO","stateCode":"PR","buscaAdicional":"BELLS 56737 BELLS PLASTICOS 907010"},{"id":"3f994dc0-f9c5-4ffc-5e3d-08d5ad2bf6ba","name":"RMBPACK MAQUINAS E EMBALAGENS LTDA","commercialName":"RMBPACK","cnpj":"07680669000110","city":"COLOMBO","stateCode":"PR","buscaAdicional":"RMBPACK 52292 RMBPACK-COLOMBO-PR 901538 RMBPACK COLOMBO PR 910815"},{"id":"11ddc3d8-36f4-42f7-51f9-08d5ad2bf6ba","name":"USINA ALTO ALEGRE S/A - ACUCAR E ALCOOL","commercialName":"","cnpj":"48295562001450","city":"COLORADO","stateCode":"PR","buscaAdicional":"AAL 2753 USINA JUNQUEIRA 907077 ALTO ALEGRE-UJU 8094 UTE.AI.PR.028367-3.01"},{"id":"1e31e361-e0ec-451b-6417-08d5ad2bf6ba","name":"WORK LEATHER INDUSTRIA E COMERCIO DE COUROS LTDA","commercialName":"CURTUME COLORADO","cnpj":"12110903000295","city":"COLORADO","stateCode":"PR","buscaAdicional":"WORKLEATHER 55838 WORKLEATHER 909225"},{"id":"91df067c-5851-41e6-64e9-08d5ad2bf6ba","name":"WESTAFLEX TUBOS FLEXIVEIS LTDA","commercialName":"","cnpj":"75024521000188","city":"CONTENDA","stateCode":"PR","buscaAdicional":"WESTAFLEX 56303 WESTAFLEX TUBOS LTDA 907833"},{"id":"717c76d4-1020-4257-5e58-08d5ad2bf6ba","name":"CONPLY INDUSTRIA DE COMPENSADOS LTDA","commercialName":"CONPLY","cnpj":"05234373000655","city":"CONTENDA","stateCode":"PR","buscaAdicional":"CONGUASUL 52336 CONGUASUL INDUSTRIA 901509"},{"id":"e0d66060-4edf-4cc1-5f2e-08d5ad2bf6ba","name":"CIA. IGUACU DE CAFE SOLUVEL","commercialName":"","cnpj":"76255926000190","city":"CORNÉLIO PROCÓPIO","stateCode":"PR","buscaAdicional":"IGUACU CAFE 52837 IGUACU CAFE 904314"},{"id":"a06c16cf-00ed-4f1c-6533-08d5ad2bf6ba","name":"COMTRAFO INDUSTRIA DE TRANSFORMADORES ELETRICOS S.A.","commercialName":"COMTRAFO","cnpj":"00138806000140","city":"CORNÉLIO PROCÓPIO","stateCode":"PR","buscaAdicional":"COMTRAFO 56589 COMTRAFO 907279 COMTRAFO FAB 02 907381"},{"id":"f65f3d4f-8ab7-425d-63ba-08d5ad2bf6ba","name":"PEDREIRA PEDRANORTE LTDA","commercialName":"PEDREIRA PEDRANORTE","cnpj":"10902331000170","city":"CORNÉLIO PROCÓPIO","stateCode":"PR","buscaAdicional":"PEDRANORTE 55589 PEDREIRA PEDRANORTE 908022"},{"id":"4fbc21a1-031f-47ad-676d-08d5ad2bf6ba","name":"AGUATIVA GOLF RESORT S/A","commercialName":"AGUATIVA GOLF RESORT","cnpj":"77424992000290","city":"CORNÉLIO PROCÓPIO","stateCode":"PR","buscaAdicional":"AGUATIVA 58093 AGUATIVA 910275"},{"id":"23d160ae-f96d-4c2b-5ddc-08d5ad2bf6ba","name":"FABRICA DE PAPEL E PAPELAO NOSSA SENHORA DA PENHA SA","commercialName":"PENHA S/A","cnpj":"49912199000466","city":"CORONEL VIVIDA","stateCode":"PR","buscaAdicional":"PENHA PR 52027 PAPEL E PAPELAO PENH 900646"},{"id":"d08d6e5d-c269-4052-5a19-08d5ad2bf6ba","name":"FORCA E LUZ CORONEL VIVIDA LTDA","commercialName":"FORCEL","cnpj":"79850574000109","city":"CORONEL VIVIDA","stateCode":"PR","buscaAdicional":"FORCEL 16485 FORCEL 910149"},{"id":"e54d28d8-c53a-4e5a-6507-08d5ad2bf6ba","name":"ENERGIAS RENOVAVEIS MAZP LTDA","commercialName":"MAZP ENERGIAS","cnpj":"18464779000161","city":"CRUZEIRO DO IGUAÇU","stateCode":"PR","buscaAdicional":"CGH GENEROSO 56389 CGH GENEROSO 909790 CGH.PH.PR.037573-0.01"},{"id":"b8a62d8f-10c9-47cf-61e8-08d5ad2bf6ba","name":"CRUZEIRO AGROAVICOLA LTDA","commercialName":"","cnpj":"09023309000171","city":"CRUZEIRO DO IGUAÇU","stateCode":"PR","buscaAdicional":"CRUZEIRO AGROAVICOLA 54463 CRUZEIRO AGROAVICOLA 906473"},{"id":"f1ba0255-4d00-41e6-60a0-08d5ad2bf6ba","name":"LATCO BEVERAGES INDUSTRIA E COMERCIO DE BEBIDAS E ALIMENTOS IMPORTACAO E EXPORTACAO EIRELI","commercialName":"LATCO BEVERAGES","cnpj":"01046213000206","city":"CRUZEIRO DO OESTE","stateCode":"PR","buscaAdicional":"LATCO BEVERAGES 53619 LATCO BEVERAGES 904220"},{"id":"eee80cfe-fff6-4204-6091-08d5ad2bf6ba","name":"PCH BV II - GERACAO DE ENERGIA LTDA","commercialName":"PCH BOA VISTA II","cnpj":"22091543000102","city":"CURITIBA","stateCode":"PR","buscaAdicional":"PCH BV II 53589 BOA VISTA II (IENER) 889360 PCH.PH.PR.000273-9.01 CACHOEIRA 889361 PCH.PH.PR.028010-0.01"},{"id":"a2c57fc5-f234-4822-6110-08d5ad2bf6ba","name":"ROMANI SA INDUSTRIA E COMERCIO DE SAL","commercialName":"","cnpj":"76491836000106","city":"CURITIBA","stateCode":"PR","buscaAdicional":"ROMANI 53989 ROMANI 904354"},{"id":"0edb8a28-68d7-4947-6036-08d5ad2bf6ba","name":"BRASILSAT HARALD S A","commercialName":"BRASILSAT HARALD","cnpj":"78404860000188","city":"CURITIBA","stateCode":"PR","buscaAdicional":"BRASILSAT 53425 BRASILSAT HARALD 902738 BRASILSAT 45720010 904063"},{"id":"3d24954c-9bf0-4379-6037-08d5ad2bf6ba","name":"GRACIOSA COUNTRY CLUB","commercialName":"GRACIOSA COUNTRY CLUB","cnpj":"76590306000107","city":"CURITIBA","stateCode":"PR","buscaAdicional":"GRACIOSA 53426 GRACIOSA COUNTRY CLU 903794"},{"id":"7a8b1505-539a-4c9c-6048-08d5ad2bf6ba","name":"MARINGA SOLDAS S/A","commercialName":"","cnpj":"79142139000120","city":"CURITIBA","stateCode":"PR","buscaAdicional":"MARINGA SOLDAS 53448 MARINGA SOLDAS 902714"},{"id":"85202cec-87ff-4184-5fee-08d5ad2bf6ba","name":"PROPEX DO BRASIL LTDA.","commercialName":"","cnpj":"04671122000160","city":"CURITIBA","stateCode":"PR","buscaAdicional":"PROPEX 53288 PROPEX DO BRASIL 904793"},{"id":"1112f5b1-bf97-4ecb-6004-08d5ad2bf6ba","name":"COMPENSADOS IMPERIO LTDA","commercialName":"","cnpj":"80813710000170","city":"CURITIBA","stateCode":"PR","buscaAdicional":"COMPENSADOS IMPERIO 53349 COMPENSADOS IMPERIO 902276"},{"id":"baa00196-8a6e-4413-5f1d-08d5ad2bf6ba","name":"ISDRALIT INDUSTRIA E COMERCIO LTDA - GRUPO ISDRA","commercialName":"","cnpj":"89938500000697","city":"CURITIBA","stateCode":"PR","buscaAdicional":"GRUPO ISDRA 52749 ISDRALIT CURITIBA 900528"},{"id":"3a602ab1-2d91-4c52-5f06-08d5ad2bf6ba","name":"CALAMO DISTRIBUIDORA DE PRODUTOS DE BELEZA S.A.","commercialName":"","cnpj":"06147451001104","city":"CURITIBA","stateCode":"PR","buscaAdicional":"CALAMO 52711 CALAMO 900055 CALAMO BA 910401"},{"id":"6e0990c1-09db-4eea-5faf-08d5ad2bf6ba","name":"MANULI FITASA DO BRASIL S/A","commercialName":"FITASA MANULI DO BRASIL","cnpj":"04807000000159","city":"CURITIBA","stateCode":"PR","buscaAdicional":"MANULI FITASA 53113 MANULI FITASA 902676"},{"id":"64e7394f-0503-45af-5fe1-08d5ad2bf6ba","name":"DE AMORIM CONSTRUTORA DE OBRAS LTDA","commercialName":"DE AMORIM","cnpj":"77577419000135","city":"CURITIBA","stateCode":"PR","buscaAdicional":"DE AMORIM 53263 DE AMORIM CONSTRUTOR 903133"},{"id":"e551aa72-b426-4bbf-5dd6-08d5ad2bf6ba","name":"ROBERT BOSCH LIMITADA","commercialName":"","cnpj":"45990181001231","city":"CURITIBA","stateCode":"PR","buscaAdicional":"BOSCH CURITIBA 52017 ROBERT BOSCH CURITIB 7322"},{"id":"6ced7af7-ecc7-4850-5e07-08d5ad2bf6ba","name":"MILI S/A","commercialName":"MILI S/A","cnpj":"78908266000124","city":"CURITIBA","stateCode":"PR","buscaAdicional":"MILI-CB 52154 MILI SA 901089"},{"id":"b9673ae5-8b7e-4a12-5e15-08d5ad2bf6ba","name":"COPEL COMERCIALIZACAO S.A.","commercialName":"COPEL ENERGIA","cnpj":"19125927000186","city":"CURITIBA","stateCode":"PR","buscaAdicional":"COPEL COM 52191 REINHOFER UC89522389 8937 CGH.PH.PR.030069-1.01"},{"id":"b3d68986-1f2d-48cc-5e4e-08d5ad2bf6ba","name":"METALURGICA VOIGT - EIRELI","commercialName":"METALURGICA VOIGT","cnpj":"02759989000147","city":"CURITIBA","stateCode":"PR","buscaAdicional":"MET VOIGT 52326 METALURGICA VOIGT 899813"},{"id":"eff1700e-ea73-4d2e-5ead-08d5ad2bf6ba","name":"CLUBE CURITIBANO","commercialName":"","cnpj":"76493626000149","city":"CURITIBA","stateCode":"PR","buscaAdicional":"CURITIBANO 52500 CURITIBANO 900010 CLUBE CURITIBANO 901062"},{"id":"d8977aa5-1e80-4b03-5d56-08d5ad2bf6ba","name":"VIDROLAR COMERCIAL DE VIDROS LTDA","commercialName":"","cnpj":"77948750000114","city":"CURITIBA","stateCode":"PR","buscaAdicional":"VIDROLAR 51790 VIDROLAR 899803"},{"id":"1440d927-1103-47a2-5d47-08d5ad2bf6ba","name":"BALAROTI - COMERCIO DE MATERIAIS DE CONSTRUCAO S.A.","commercialName":"BALAROTI","cnpj":"77044618000188","city":"CURITIBA","stateCode":"PR","buscaAdicional":"BALAROTI 51756 BALAROTI 01 904187 BALAROTI 24927423 904215 BALAROTI 2 904233 BALAROTI 04 908023 BALAROTI 05 908693"},{"id":"0c2713c3-b8bb-4ad8-5d49-08d5ad2bf6ba","name":"TRIANGULO PISOS E PAINEIS LTDA.","commercialName":"","cnpj":"75059857000186","city":"CURITIBA","stateCode":"PR","buscaAdicional":"TRIANGULO 51772 TRIANGULO PISOS 900531"},{"id":"39235d92-bc9f-4c9e-5d2b-08d5ad2bf6ba","name":"CASC ADMINISTRADORA DE SHOPPING CENTERS S/A","commercialName":"CASC","cnpj":"76694983000175","city":"CURITIBA","stateCode":"PR","buscaAdicional":"SHOPPING MUELLER 51725 SHOPPING MUELLER 899762 SHOPPING MUELLER 623 899779"},{"id":"4d0a9fc1-2278-42dd-5d91-08d5ad2bf6ba","name":"DEVILLE HOTEIS E TURISMO LTDA","commercialName":"DEVILLE HOTEIS E TURISMO LTDA","cnpj":"81071623000157","city":"CURITIBA","stateCode":"PR","buscaAdicional":"DEVILLE 51922 DEVILLE CASCAVEL 900790 DEVILLE PORTO ALEGRE 900837 DEVILLE MARINGA 900838 DEVILLE CWB 903940 DEVILLE GUARULHOS 900789 DEVILLE CUIABA 900792 DEVILLE CAMPO GRANDE 900839 DEVILLE SALVADOR 900788"},{"id":"4bf97f62-a93a-4fda-5dae-08d5ad2bf6ba","name":"CONDOMINIO SHOPPING ESTACAO","commercialName":"","cnpj":"13474276000153","city":"CURITIBA","stateCode":"PR","buscaAdicional":"ESTACAO CURITIBA 51954 SHOPPING ESTACAO PR 900918"},{"id":"34bc4810-096e-444d-5daf-08d5ad2bf6ba","name":"CONDOMINIO ESTACAO OFFICE","commercialName":"","cnpj":"14788243000140","city":"CURITIBA","stateCode":"PR","buscaAdicional":"ESTACAO OFFICE 51955 ESTACAO OFFICE 901056"},{"id":"fc35465c-8851-4996-5a17-08d5ad2bf6ba","name":"SERTAO ENERGIAS RENOVAVEIS S.A.","commercialName":"SERTAO ENERGIAS RENOVAVEIS S.A.","cnpj":"17613432000170","city":"CURITIBA","stateCode":"PR","buscaAdicional":"EOL SERTAO 16465 V SERTAO 13LEN 890388 EOL.CV.BA.030946-0.01"},{"id":"d4c843ab-6ab0-4ad8-5a11-08d5ad2bf6ba","name":"CAMPO FORMOSO I ENERGIAS RENOVAVEIS S.A.","commercialName":"CAMPO FORMOSO I ENERGIAS RENOVAVEIS S.A.","cnpj":"17613280000106","city":"CURITIBA","stateCode":"PR","buscaAdicional":"EOL FORMOSO I 16450 V C FORMOSO 1 13 LEN 890380 EOL.CV.BA.030943-5.01"},{"id":"064e3692-123c-4210-5a12-08d5ad2bf6ba","name":"ANDORINHA ENERGIAS RENOVAVEIS S.A.","commercialName":"ANDORINHA ENERGIAS RENOVAVEIS S.A.","cnpj":"17613512000126","city":"CURITIBA","stateCode":"PR","buscaAdicional":"EOL ANDORINHA 16451 VENTOS ANDORINHA 890378 EOL.CV.BA.030944-3.01"},{"id":"99d19a7b-da53-477e-5a13-08d5ad2bf6ba","name":"MORRINHOS ENERGIAS RENOVAVEIS S.A.","commercialName":"MORRINHOS ENERGIAS RENOVAVEIS S.A.","cnpj":"17613286000183","city":"CURITIBA","stateCode":"PR","buscaAdicional":"EOL MORRINHOS 16452 VMORRINHOS 13LEN 890384 EOL.CV.BA.030945-1.01"},{"id":"dd80e242-32de-473e-5a14-08d5ad2bf6ba","name":"CAMPO FORMOSO II ENERGIAS RENOVAVEIS S. A.","commercialName":"CAMPO FORMOS II ENERGIAS RENOVAVEIS","cnpj":"17613629000100","city":"CURITIBA","stateCode":"PR","buscaAdicional":"EOL FORMOSO II 16453 V C FORMOSO 2 13LEN 890382 EOL.CV.BA.031010-7.01"},{"id":"2cda75a6-3eda-4e2e-5a00-08d5ad2bf6ba","name":"SANTA VITORIA DO PALMAR XI ENERGIAS RENOVAVEIS S.A.","commercialName":"SANTA VITORIA DO PALMAR XI ENERGIAS RENOVAVEIS S.A.","cnpj":"20593647000181","city":"CURITIBA","stateCode":"PR","buscaAdicional":"STA VITORIA PALMAR XI 16335 AURA MANGUEIRA VII 904073 EOL.CV.RS.031805-1.01"},{"id":"660cb327-32aa-4811-5a01-08d5ad2bf6ba","name":"SANTA VITORIA DO PALMAR XII ENERGIAS RENOVAVEIS S.A.","commercialName":"SANTA VITORIA DO PALMAR XII ENERGIAS RENOVAVEIS S.A.","cnpj":"20586118000150","city":"CURITIBA","stateCode":"PR","buscaAdicional":"STA VITORIA PALMAR XII 16336 AURA MIRIM II 904064 EOL.CV.RS.031806-0.01"},{"id":"cdba873f-265c-4fc2-5a29-08d5ad2bf6ba","name":"IRMANDADE DA SANTA CASA DE MISERICORDIA DE CURITIBA","commercialName":"","cnpj":"76613835000189","city":"CURITIBA","stateCode":"PR","buscaAdicional":"IRMANDADE 16605 ISCMC HNSL 895661 ISMC HSC 895662"},{"id":"7470f729-f0e7-42df-598a-08d5ad2bf6ba","name":"VENTOS DOS GUARAS I ENERGIAS RENOVAVEIS S.A.","commercialName":"VENTOS DOS GUARAS I ENERGIAS RENOVAVEIS S.A.","cnpj":"13344343000115","city":"CURITIBA","stateCode":"PR","buscaAdicional":"VENTOS DOS GUARAS I 14819 VENTOS DE GUARAS I 896926 EOL.CV.BA.031563-0.01"},{"id":"6dd05b87-457b-479b-59a6-08d5ad2bf6ba","name":"SANTA VITORIA DO PALMAR I ENERGIAS RENOVAVEIS S.A.","commercialName":"SANTA VITORIA DO PALMAR I ENERGIAS RENOVAVEIS S.A.","cnpj":"19869355000140","city":"CURITIBA","stateCode":"PR","buscaAdicional":"STA VITORIA PALMAR I 15315 AURA MANGUEIRA 4 910154 EOL.CV.RS.031700-4.01"},{"id":"a81b4f45-6fab-4da6-59a7-08d5ad2bf6ba","name":"SANTA VITORIA DO PALMAR IX ENERGIAS RENOVAVEIS S.A.","commercialName":"SANTA VITORIA DO PALMAR IX ENERGIAS RENOVAVEIS S.A.","cnpj":"19891491000136","city":"CURITIBA","stateCode":"PR","buscaAdicional":"STA VITORIA PALMAR IX 15316 EOL AURA MIRIM VI 908908 EOL.CV.RS.031701-2.01"},{"id":"d604606c-e154-4125-59a8-08d5ad2bf6ba","name":"SANTA VITORIA DO PALMAR II ENERGIAS RENOVAVEIS S.A.","commercialName":"SANTA VITORIA DO PALMAR ENERGIAS RENOVAVEIS S.A.","cnpj":"19888311000167","city":"CURITIBA","stateCode":"PR","buscaAdicional":"STA VITORIA PALMAR II 15317 AURA MANGUEIRA 6 910100 EOL.CV.RS.031696-2.01"},{"id":"9e77263d-18c4-476d-59a9-08d5ad2bf6ba","name":"SANTA VITORIA DO PALMAR X ENERGIAS RENOVAVEIS S.A.","commercialName":"SANTA VITORIA DO PALMAR X ENERGIAS RENOVAVEIS S.A.","cnpj":"19917214000155","city":"CURITIBA","stateCode":"PR","buscaAdicional":"STA VITORIA PALMAR X 15318 AURA MIRIM VIII 908781 EOL.CV.RS.031699-7.01"},{"id":"da04cadd-7f48-4437-59aa-08d5ad2bf6ba","name":"SANTA VITORIA DO PALMAR III ENERGIAS RENOVAVEIS S.A.","commercialName":"SANTA VITORIA DO PALMAR III ENERGIAS RENOVAVEIS S.A.","cnpj":"19869512000117","city":"CURITIBA","stateCode":"PR","buscaAdicional":"STA VITORIA PALMAR III 15319 AURA MANGUEIRA XI 906776 EOL.CV.RS.031719-5.01"},{"id":"38184a71-68ee-495c-59ab-08d5ad2bf6ba","name":"SANTA VITORIA DO PALMAR IV ENERGIAS RENOVAVEIS S.A.","commercialName":"SANTA VITORIA DO PALMAR IV ENERGIAS RENOVAVEIS S.A.","cnpj":"19888199000164","city":"CURITIBA","stateCode":"PR","buscaAdicional":"STA VITORIA PALMAR IV 15320 EOL AURA MANGUEIRA12 908779 EOL.CV.RS.031653-9.01"},{"id":"527c2d91-2e2f-4ad7-59ac-08d5ad2bf6ba","name":"SANTA VITORIA DO PALMAR V ENERGIAS RENOVAVEIS S.A.","commercialName":"SANTA VITORIA DO PALMAR V ENERGIAS RENOVAVEIS S.A.","cnpj":"19868433000191","city":"CURITIBA","stateCode":"PR","buscaAdicional":"STA VITORIA PALMAR V 15321 EOL AURA MANG 13 908552 EOL.CV.RS.031646-6.01"},{"id":"218a1c18-3324-42bb-59ad-08d5ad2bf6ba","name":"SANTA VITORIA DO PALMAR VI ENERGIAS RENOVAVEIS S.A.","commercialName":"SANTA VITORIA DO PALMAR VI ENERGIAS RENOVAVEIS S.A.","cnpj":"19944650000113","city":"CURITIBA","stateCode":"PR","buscaAdicional":"STA VITORIA PALMAR VI 15322 AURA MANGUEIRA XV 907433 EOL.CV.RS.031647-4.01"},{"id":"f134b4c6-476a-452c-59ae-08d5ad2bf6ba","name":"SANTA VITORIA DO PALMAR VII ENERGIAS RENOVAVEIS S.A.","commercialName":"SANTA VITORIA DO PALMAR VII ENERGIAS RENOVAVEIS S.A.","cnpj":"19896691000181","city":"CURITIBA","stateCode":"PR","buscaAdicional":"STA VITORIA PALMAR VII 15323 EOL AURA MANG 17 909376 EOL.CV.RS.031705-5.01"},{"id":"23eb62ae-1dc4-4e52-59af-08d5ad2bf6ba","name":"SANTA VITORIA DO PALMAR VIII ENERGIAS RENOVAVEIS S.A.","commercialName":"SANTA VITORIA DO PALMAR VIII ENERGIAS RENOVAVEIS S.A.","cnpj":"19941770000167","city":"CURITIBA","stateCode":"PR","buscaAdicional":"STA VITORIA PALMAR VIII 15324 EOL AURA MIRIM IV 906777 EOL.CV.RS.031663-6.01"},{"id":"ec268aca-19bb-4a2f-58c6-08d5ad2bf6ba","name":"ITAJAI BIOGAS E ENERGIA S.A.","commercialName":"ITAJAI BIOGAS E ENERGIA S.A.","cnpj":"17336254000188","city":"CURITIBA","stateCode":"PR","buscaAdicional":"ITAJAI BIOGAS 545-2013 13272 ITAJAI BIOGAS 892882 UTE.RU.SC.031321-1.02"},{"id":"d9dbfd25-2460-4143-57f9-08d5ad2bf6ba","name":"ASSOCIACAO PARANAENSE DE CULTURA - APC","commercialName":"","cnpj":"76659820000151","city":"CURITIBA","stateCode":"PR","buscaAdicional":"APC 10311 APC TECNOPARQUE 889852 APC PQ TECNOLOGICO 889853 CAMPUS TOLEDO - PR 889907 APC CURITIBA - PR 889952 APC HOSPUNIVCAJ - PR 889956 CAMPUS LONDRINA 891081 APC MARINGA 903922"},{"id":"f3aa66eb-8e65-4e37-5b62-08d5ad2bf6ba","name":"SIM ESTEARINA INDUSTRIA E COMERCIO LTDA","commercialName":"","cnpj":"04942328000188","city":"CURITIBA","stateCode":"PR","buscaAdicional":"SIM ESTEARINA 50653 SIM ESTEARINA 898960"},{"id":"c0c71228-f28f-43f5-5b22-08d5ad2bf6ba","name":"DARNEL EMBALAGENS LTDA.","commercialName":"DARNEL EMBALAGENS LTDA","cnpj":"02538436000164","city":"CURITIBA","stateCode":"PR","buscaAdicional":"DARNEL 50493 DARNEL 898041"},{"id":"d0577352-f5e8-4199-5a94-08d5ad2bf6ba","name":"EMEWE COMERCIALIZACAO DE ENERGIA LTDA","commercialName":"","cnpj":"22154826000148","city":"CURITIBA","stateCode":"PR","buscaAdicional":"EMEWE 50089"},{"id":"06aea124-60a4-4a28-5aa8-08d5ad2bf6ba","name":"BUNDY REFRIGERACAO BRASIL INDUSTRIA E COMERCIO LTDA.","commercialName":"","cnpj":"08320017000138","city":"CURITIBA","stateCode":"PR","buscaAdicional":"BUNDY MAT 50138 BUNDY - CURITIBA PR 897386 BUNDY PIND 898182"},{"id":"c8b0becf-22e2-40f0-5a8a-08d5ad2bf6ba","name":"DIRECIONAL COMERCIALIZADORA DE ENERGIA LTDA","commercialName":"DIRECIONAL COMERCIALIZADORA","cnpj":"20533523000100","city":"CURITIBA","stateCode":"PR","buscaAdicional":"SUL ENERGIA 49997"},{"id":"cab6da3d-8804-40e9-5a76-08d5ad2bf6ba","name":"MERCATTO COMERCIALIZADORA DE ENERGIA LTDA","commercialName":"","cnpj":"21484454000155","city":"CURITIBA","stateCode":"PR","buscaAdicional":"MERCATTO 49668"},{"id":"5928d967-c1f9-4256-5a79-08d5ad2bf6ba","name":"BRITANIA ELETRODOMESTICOS SA","commercialName":"","cnpj":"76492701000157","city":"CURITIBA","stateCode":"PR","buscaAdicional":"BRITANIA ELETRO 49725 BRITANIA ELETRODOMES 71903 BRITANIA LEBLON SC 899800 BRITANIA DIAMOND 902353"},{"id":"ee1bef09-94f4-432d-5b75-08d5ad2bf6ba","name":"PATIO BATEL SHOPPING LTDA","commercialName":"","cnpj":"79536553000113","city":"CURITIBA","stateCode":"PR","buscaAdicional":"PATIO BATEL 50710 PATIO BATEL 898963"},{"id":"8c36c867-23c0-4a82-5b7b-08d5ad2bf6ba","name":"BIGFER PARANA INDUSTRIA E COMERCIO LTDA","commercialName":"HETTICH","cnpj":"78578614000142","city":"CURITIBA","stateCode":"PR","buscaAdicional":"BIGFER PR 50730 BIGFER PARANA 898569"},{"id":"6d4a0ff5-2467-46a6-5c51-08d5ad2bf6ba","name":"CENTRO DE ESTUDOS SUPERIORES POSITIVO LTDA","commercialName":"","cnpj":"78791712000325","city":"CURITIBA","stateCode":"PR","buscaAdicional":"POSITIVO UNIV 51261 CENTRO POSITIVO 900521 POSITIVO TEATRO 905793 POSITIVO EXPOTIBA 905794"},{"id":"06ae9a30-b74c-42c3-5c52-08d5ad2bf6ba","name":"BECTON DICKINSON INDUSTRIAS CIRURGICAS LTDA","commercialName":"","cnpj":"21551379001331","city":"CURITIBA","stateCode":"PR","buscaAdicional":"BECTON DICKINSON CURITIBA 51262 BECTON DICKINSON 899880"},{"id":"97b33e5d-3fee-4c2f-5186-08d5ad2bf6ba","name":"RIO VERDE ENERGIA S/A","commercialName":"","cnpj":"05252008000169","city":"CURITIBA","stateCode":"PR","buscaAdicional":"RVESA 2231 SALTO (RVESA) 8687 UHE.PH.GO.028758-0.01"},{"id":"77cedf6f-333f-4a50-52fb-08d5ad2bf6ba","name":"GRAFICA E EDITORA POSIGRAF LTDA","commercialName":"","cnpj":"75104422000106","city":"CURITIBA","stateCode":"PR","buscaAdicional":"POSIGRAF 3402 POSIGRAF 71059 POSIGRAF CIC 898627"},{"id":"2cf056bb-f21f-4623-52c3-08d5ad2bf6ba","name":"PALLADIUM ADMINISTRADORA DE SHOPPING CENTERS LTDA.","commercialName":"","cnpj":"07026097000150","city":"CURITIBA","stateCode":"PR","buscaAdicional":"PALLADIUM SHOP 3276 PALLADIUM-CONDOMINIO 71143 PALLADIUM-AR-COND 71144"},{"id":"15249de3-0419-4f4d-5266-08d5ad2bf6ba","name":"CRAVARI GERACAO DE ENERGIA S.A.","commercialName":"CRAVARI","cnpj":"08703867000115","city":"CURITIBA","stateCode":"PR","buscaAdicional":"CRAVARI 3044 BOCAIUVA 8689 PCH.PH.MT.029184-6.01"},{"id":"b90df6c1-9685-4cf1-50db-08d5ad2bf6ba","name":"UEG ARAUCARIA LTDA","commercialName":"","cnpj":"02743574000185","city":"CURITIBA","stateCode":"PR","buscaAdicional":"UEG ARAUCARIA 1874 ARAUCARIA 8243 UTE.GN.PR.027733-9.01 ARAUCARIA EXP 88243 UTE.GN.PR.027733-9.01"},{"id":"9192de73-0609-4a04-50f2-08d5ad2bf6ba","name":"ELECTROLUX DO BRASIL S/A","commercialName":"","cnpj":"76487032000125","city":"CURITIBA","stateCode":"PR","buscaAdicional":"ELUXCTBA 1916 ELECTROLUX S CARLOS 70339 ELECTROLUX-CURITIBA 71887 ELECTROLUX BRASIL 908179 ELECTROLUX AM 910531"},{"id":"5dd2c630-cc10-45a0-4fe6-08d5ad2bf6ba","name":"CIA DE CIMENTO ITAMBE","commercialName":"CIMENTO ITAMBE","cnpj":"76630573000160","city":"CURITIBA","stateCode":"PR","buscaAdicional":"CIMENTO ITAMBE 1347 ITAMBE LIVRE CURITIB 172"},{"id":"522ad191-57b8-49fc-4fb3-08d5ad2bf6ba","name":"VOLVO DO BRASIL VEICULOS LTDA","commercialName":"","cnpj":"43999424000114","city":"CURITIBA","stateCode":"PR","buscaAdicional":"VOLVO 1242 SE VOLVO 889128"},{"id":"5e60e85a-7a66-40ad-4fb1-08d5ad2bf6ba","name":"FURUKAWA ELECTRIC LATAM S.A.","commercialName":"","cnpj":"51775690000191","city":"CURITIBA","stateCode":"PR","buscaAdicional":"FURUKAWA CUR D 1240 FURUKAWA 899273"},{"id":"f455b70f-51d8-4f67-4fb5-08d5ad2bf6ba","name":"MONDELEZ BRASIL LTDA","commercialName":"MONDELEZ BRASIL","cnpj":"33033028000184","city":"CURITIBA","stateCode":"PR","buscaAdicional":"MONDELEZ 1244 KRAFT MTZ CURITIB PR 70285"},{"id":"8505630f-d164-40bf-4f78-08d5ad2bf6ba","name":"ELEJOR - CENTRAIS ELETRICAS DO RIO JORDAO S.A.","commercialName":"ELEJOR","cnpj":"04557307000149","city":"CURITIBA","stateCode":"PR","buscaAdicional":"ELEJOR 1125 SANTA CLARA I 8100 PCH.PH.PR.028850-0.01 FUNDAO I 8196 PCH.PH.PR.028846-2.01 SANTA CLARA (ELEJOR) 8099 UHE.PH.PR.028361-4.01 FUNDAO 8150 UHE.PH.PR.028360-6.01"},{"id":"15b51afb-af6c-4edc-4f15-08d5ad2bf6ba","name":"COPEL DISTRIBUICAO S.A.","commercialName":"COPEL-DIS","cnpj":"04368898000106","city":"CURITIBA","stateCode":"PR","buscaAdicional":"COPEL DISTRIB 81 COPEL 15 COPEL DITCSP 72314"},{"id":"caa3e29c-a311-48a4-4f16-08d5ad2bf6ba","name":"COPEL GERACAO E TRANSMISSAO S.A.","commercialName":"COPEL-GER","cnpj":"04370282000170","city":"CURITIBA","stateCode":"PR","buscaAdicional":"COPEL GET 82 RIO DOS PATOS 505 PCH.PH.PR.002360-4.01 SAO JORGE 504 PCH.PH.PR.027153-5.01 PITANGUI 506 CGH.PH.PR.002085-0.01 SALTO DO VAU 507 CGH.PH.PR.002642-5.01 CHAMINE 511 PCH.PH.PR.000753-6.01 APUCARANINHA 512 PCH.PH.PR.000122-8.01 GUARICANA 510 UHE.PH.PR.001075-8.01 MAUA (COPEL) 888271 UHE.PH.PR.029598-1.01 GOV. PARIGOT 251 UHE.PH.PR.001042-1.01 FOZ DO AREIA (GBM) 248 UHE.PH.PR.000984-9.01 SEGREDO (GNB) 249 UHE.PH.PR.002715-4.01 SALTO CAXIAS (GJR) 250 UHE.PH.PR.002591-7.01 GOV. PARIGOT S ACL 895941 UHE.PH.PR.001042-1.01 FIGUEIRA (FRA) 252 UTE.CM.PR.000955-5.01 MARUMBI 503 PCH.PH.PR.001501-6.01 DESVIO RIO JORDAO 514 PCH.PH.PR.002398-1.01 CHOPIM I 515 CGH.PH.PR.000771-4.02 CAVERNOSO 516 PCH.PH.PR.000729-3.01 MELISSA 517 CGH.PH.PR.001452-4.01 PALMAS 8351 EOL.CV.PR.027908-0.01 CAVERNOSO 2 889462 PCH.PH.PR.030458-1.01"},{"id":"ed264db5-4f25-4c34-4f23-08d5ad2bf6ba","name":"ELECTRA COMERCIALIZADORA DE ENERGIA LTDA","commercialName":"","cnpj":"04518259000180","city":"CURITIBA","stateCode":"PR","buscaAdicional":"ELECTRA ENERGY 112 CARANDAI 8490 PCH.PH.MG.000667-0.01 RIO BONITO (ELECTRA) 20069 PCH.PH.SC.030132-9.01 BAITACA (ELECTRA) 20070 PCH.PH.SC.030153-1.01 CAAL 889422 UTE.AI.RS.028600-1.01 REINHOFER UC89522389 8937 CGH.PH.PR.030069-1.01"},{"id":"7d1007eb-bbe6-4f7f-4f24-08d5ad2bf6ba","name":"FOZ DO CHOPIM ENERGETICA LTDA.","commercialName":"","cnpj":"03507699000179","city":"CURITIBA","stateCode":"PR","buscaAdicional":"FOZ DO CHOPIM 114 FOZ DO CHOPIM 557 PCH.PH.PR.001278-5.01"},{"id":"5919cdee-ed8f-41ad-4f0a-08d5ad2bf6ba","name":"ITAMBE ENERGETICA S/A","commercialName":"","cnpj":"03926572000194","city":"CURITIBA","stateCode":"PR","buscaAdicional":"ITAMBE 62"},{"id":"678e7036-dae9-4ca9-4f10-08d5ad2bf6ba","name":"TRADENER LIMITADA","commercialName":"","cnpj":"02691745000170","city":"CURITIBA","stateCode":"PR","buscaAdicional":"TRADENER 69 RIVERA EXP. SUL 70332 RIVERA EXP. SUDESTE 70475 GARABI II EXP SUL 70584 GARABI II EXP NE 70585 GARABI II EXP SE 70586 GARABI I EXP NE 70587 GARABI I EXP SE 70588 GARABI I EXP SUL 70589 RIVERA EXP. NORDESTE 70592 SALTO PINTADO 8726 CGH.PH.SC.002665-4.01 PICADA 48 889995 CGH.PH.RS.002054-0.01 RP 1 891164 CGH.PH.RS.031695-4.01 CONV. RIVERA IMP 8369 SETE QUEDAS ALT TDNR 888551 PCH.PH.MT.028853-5.01"},{"id":"92298ece-156d-45d3-4f4d-08d5ad2bf6ba","name":"PIERP COMERCIALIZADORA DE ENERGIA S/A","commercialName":"","cnpj":"04810290000190","city":"CURITIBA","stateCode":"PR","buscaAdicional":"PIE - RP 1037"},{"id":"78422af1-a3aa-406f-55f0-08d5ad2bf6ba","name":"PEROXIDOS DO BRASIL LTDA","commercialName":"","cnpj":"51784262000125","city":"CURITIBA","stateCode":"PR","buscaAdicional":"PEROXIDOS 6351 PEROXIDOS-CURITIBA 72055"},{"id":"932bb55f-c624-47db-578d-08d5ad2bf6ba","name":"IMARIBO SA INDUSTRIA E COMERCIO","commercialName":"","cnpj":"76486463000177","city":"CURITIBA","stateCode":"PR","buscaAdicional":"IMARIBO 9035 IMARIBO 888854"},{"id":"4ad16113-f59f-41d7-570c-08d5ad2bf6ba","name":"CRYSTAL ADMINISTRADORA DE SHOPPING CENTERS LTDA","commercialName":"","cnpj":"68821685000170","city":"CURITIBA","stateCode":"PR","buscaAdicional":"CRYSTAL PLAZA 8167 SHOP CRYSTAL 888166"},{"id":"7aff9bb0-8043-4e02-56f2-08d5ad2bf6ba","name":"CONDOMINIO COMPLEXO SHOPPING CURITIBA","commercialName":"","cnpj":"01426138000110","city":"CURITIBA","stateCode":"PR","buscaAdicional":"SHOP CURITIBA 8005 SHOP CURITIBA 888295 SHOP CURITIBA ESP 888893"},{"id":"af4405f5-957a-4a64-56e6-08d5ad2bf6ba","name":"CONDOMINIO PARKSHOPPINGBARIGUI","commercialName":"PARKSHOPPINGBARIGUI","cnpj":"05805071000185","city":"CURITIBA","stateCode":"PR","buscaAdicional":"CPKB 7921 CPKB - CURITIBA 72431"},{"id":"16241635-709d-41d2-53d4-08d5ad2bf6ba","name":"TURVO ENERGIA S.A.","commercialName":"MISSOES","cnpj":"10890065000103","city":"CURITIBA","stateCode":"PR","buscaAdicional":"TURVO 3875 MARCO BALDO 8835 PCH.PH.RS.028967-1.01"},{"id":"9841f462-6e07-4077-53ea-08d5ad2bf6ba","name":"CONDOR SUPER CENTER LTDA","commercialName":"","cnpj":"76189406000126","city":"CURITIBA","stateCode":"PR","buscaAdicional":"CONDOR 3910 CONDOR PARANAGUA 71367 CONDOR-SJP 71747 CONDOR CDD-CURITIBA 71895 CONDOR M AFONSO CUR 71896 CONDOR N PECANHA CUR 71897 CONDOR - PINHAIS 72143 CONDOR-LONDRINA 72144 CONDOR CAMP COMPRID 72428 CONDOR COLOMBO 888431 CONDOR CAJURU 888432 CONDOR CASTRO 888834 CONDOR ARAUCARIA 889963 CONDOR AGUA VERDE 891822 CONDOR AV COLOMBO 897586 CONDOR UVARANAS 897684 CONDOR TORRES PR 897710 CONDOR OFICINAS 898157 CONDOR NOVO MUNDO 898178 CONDOR STA CANDIDA 898312 CONDOR ALMIRANTE 898326 CONDOR JD CARVALHO 898792 CONDOR CAMPO LSJ 899690"},{"id":"950a1bf3-8426-4b27-53c9-08d5ad2bf6ba","name":"RIO CANOAS ENERGIA S.A.","commercialName":"RIO CANOAS ENERGIA S.A","cnpj":"11316814000156","city":"CURITIBA","stateCode":"PR","buscaAdicional":"RCESA 3850 GARIBALDI 891063 UHE.PH.SC.030415-8.01"},{"id":"27e2577c-e39d-4e20-53b5-08d5ad2bf6ba","name":"CITYSPACE EMPREENDIMENTOS - EIRELI","commercialName":"CITYSPACE","cnpj":"10236004000127","city":"CURITIBA","stateCode":"PR","buscaAdicional":"SHOP CIDADE 3792 SHOP CIDADE 13,8 KV 71270"},{"id":"4b432118-b339-496d-5396-08d5ad2bf6ba","name":"GENESIS ENERGETICA SA.","commercialName":"GENESIS","cnpj":"04944877000191","city":"CURITIBA","stateCode":"PR","buscaAdicional":"GENESIS ENERG 3706 SAO FRANCISCO 8786 PCH.PH.PR.028747-4.01"},{"id":"6be4c0a9-48a4-4be0-538b-08d5ad2bf6ba","name":"ARAUCO DO BRASIL S.A.","commercialName":"","cnpj":"76518836000144","city":"CURITIBA","stateCode":"PR","buscaAdicional":"ARAUCO 3691 TAFISA-PIEN-PR 7170 ARAUCO JAGUARIAIVA 889192 ARAUCO DO BRASIL 900029"},{"id":"f1028b3b-f2c7-4e1c-541b-08d5ad2bf6ba","name":"IBEMA COMPANHIA BRASILEIRA DE PAPEL","commercialName":"IBEMA","cnpj":"80228885000110","city":"CURITIBA","stateCode":"PR","buscaAdicional":"IBEMA CL 4015 IBEMA TURVO 889359"},{"id":"ff14a726-7795-4ea2-5464-08d5ad2bf6ba","name":"NORDICA ENERGIA LTDA.","commercialName":"","cnpj":"12368097000179","city":"CURITIBA","stateCode":"PR","buscaAdicional":"NORDICA 4206"},{"id":"20bc5065-b82a-4253-5470-08d5ad2bf6ba","name":"IGUACU CELULOSE PAPEL S/A","commercialName":"IGUACU CELULOSE","cnpj":"81304727000164","city":"CURITIBA","stateCode":"PR","buscaAdicional":"IGUACU CPSA 4251 IGUACU CPSA-C NOVOS 71502 IGUACU CELULOSE 902113 IGUACU PAPEL PIRAI 907497"},{"id":"27f7574d-2f08-490c-5586-08d5ad2bf6ba","name":"WHB AUTOMOTIVE S.A - EM RECUPERACAO JUDICIAL","commercialName":"WHB FUNDICAO","cnpj":"01261681000104","city":"CURITIBA","stateCode":"PR","buscaAdicional":"WHB 5739 WHB FUND-CURITIBA 71843"},{"id":"07279c15-7740-47e0-61f9-08d5ad2bf6ba","name":"CIRCUIBRAS IND COM DE CIRCUITOS IMP PROFISSIONAIS LTDA","commercialName":"","cnpj":"79077343000104","city":"CURITIBA","stateCode":"PR","buscaAdicional":"CIRCUIBRAS 54493 CIRCUIBRAS 77675487 904459"},{"id":"d9797881-73ca-4c09-620c-08d5ad2bf6ba","name":"VAPZA ALIMENTOS S/A","commercialName":"VAPZA","cnpj":"00186720000193","city":"CURITIBA","stateCode":"PR","buscaAdicional":"VAPZA 54520 VAZPA ALIMENTOS SA 906233"},{"id":"c9cc0533-c60a-4479-618f-08d5ad2bf6ba","name":"CONDOMINIO JARDIM DAS AMERICAS SHOPPING CENTER","commercialName":"CONDOMINIO JARDIM DAS AMERICAS SHOPPING","cnpj":"02597043000121","city":"CURITIBA","stateCode":"PR","buscaAdicional":"AMERICAS 54241 SHOPPING AMERICA 905480"},{"id":"7ed91543-9bae-4ba1-6339-08d5ad2bf6ba","name":"VITAO ALIMENTOS LTDA","commercialName":"","cnpj":"04869719000114","city":"CURITIBA","stateCode":"PR","buscaAdicional":"VITAO 55251 VITAO ALIMENTOS LTDA 906466"},{"id":"43550e25-f0d2-4c22-633b-08d5ad2bf6ba","name":"INSTITUTO DE TECNOLOGIA PARA O DESENVOLVIMENTO","commercialName":"INSTITUTOS LACTEC","cnpj":"01715975000169","city":"CURITIBA","stateCode":"PR","buscaAdicional":"INSTITUTOS LACTEC 55253 INST LACTEC 46493859 907385 INST LACTEC 50013092 907386 INST LACTEC 45030553 907406"},{"id":"227d4b8f-acdf-4007-6311-08d5ad2bf6ba","name":"EDIFICIO EXECUTIVE CENTER TORONTO","commercialName":"CONDOMINIO EDIFICIO CENTER TORONTO","cnpj":"21558426000135","city":"CURITIBA","stateCode":"PR","buscaAdicional":"EDIFICIO TORONTO 55126 EDIFICIO TORONTO 907243"},{"id":"4da43d2c-5b43-477a-62c7-08d5ad2bf6ba","name":"EMPRESA HOTELEIRA MABU LTDA","commercialName":"MABU CURITIBA BUSINESS","cnpj":"75047498000147","city":"CURITIBA","stateCode":"PR","buscaAdicional":"MABU HOTEIS 54967 MABU EXPRESS 907274 MABU THERMAS 907275"},{"id":"78c78c73-402d-4be8-62e7-08d5ad2bf6ba","name":"SOCIEDADE RADIO EMISSORA PARANAENSE SA","commercialName":"TV PARANAENSE, REDE PARANAENSE","cnpj":"76494806000145","city":"CURITIBA","stateCode":"PR","buscaAdicional":"TV PARANAENSE CE 55028 TV PARANAENSE 905274 RADIO PARANAENSE 905497"},{"id":"ca1c76bb-d4f4-4baa-6292-08d5ad2bf6ba","name":"ARAMEPAR INDUSTRIA E COMERCIO DE ARAMES LTDA","commercialName":"","cnpj":"03169698000161","city":"CURITIBA","stateCode":"PR","buscaAdicional":"ARAMEPAR 54806 ARAMEPAR - CURITIBA 904766 ARAMEPAR - JK - CTBA 910500"},{"id":"7579c539-5820-4c5d-64ff-08d5ad2bf6ba","name":"HOSPITAL SANTA CRUZ SOCIEDADE ANONIMA","commercialName":"","cnpj":"76555069000143","city":"CURITIBA","stateCode":"PR","buscaAdicional":"HOSP SANTA CRUZ 56367 HOSP SANTA CRUZ 907395"},{"id":"0c4ed5c1-2923-45b7-64d3-08d5ad2bf6ba","name":"COONAGRO COOPERATIVA NACIONAL AGROINDUSTRIAL","commercialName":"COONAGRO","cnpj":"84828003000108","city":"CURITIBA","stateCode":"PR","buscaAdicional":"COONAGRO 56259 COONAGRO 908172"},{"id":"db5774bf-01d1-463f-64a1-08d5ad2bf6ba","name":"TAMPAFLEX INDUSTRIAL - EIRELI","commercialName":"TAMPAFLEX","cnpj":"02903943000150","city":"CURITIBA","stateCode":"PR","buscaAdicional":"TAMPAFLEX 56138 TAMPAFLEX 908487"},{"id":"e3c66f3d-b590-46f9-647f-08d5ad2bf6ba","name":"DENSO DO BRASIL LTDA","commercialName":"DENSO","cnpj":"43375930000132","city":"CURITIBA","stateCode":"PR","buscaAdicional":"DENSO 56032 DENSO CURITIBA 907675 DENSO S BAR DO OESTE 908279 DENSO CURITIBA 909409"},{"id":"5bab765d-afb4-480a-637d-08d5ad2bf6ba","name":"HOTEL BOURBON DE CURITIBA LTDA","commercialName":"HOTEL BOURBON","cnpj":"78943321000117","city":"CURITIBA","stateCode":"PR","buscaAdicional":"BOURBON CURITIBA 55390 BOURBON CURITIBA 909229"},{"id":"5c2c95a5-e614-4f48-6461-08d5ad2bf6ba","name":"PORTO SHOP S/A","commercialName":"PORTO SHOP","cnpj":"05047690000158","city":"CURITIBA","stateCode":"PR","buscaAdicional":"PORTO SHOP 55966 PORTO SHOP 905958"},{"id":"48949f0e-653d-434b-65d0-08d5ad2bf6ba","name":"IMPORTADORA DE FRUTAS LA VIOLETERA LTDA","commercialName":"","cnpj":"79638524000162","city":"CURITIBA","stateCode":"PR","buscaAdicional":"LA VIOLETERA 57143 LA VIOLETERA FRUTAS 908193"},{"id":"046c7872-6508-4f21-65f0-08d5ad2bf6ba","name":"DESTRO BRASIL DISTRIBUICAO LTDA","commercialName":"DESTRO BRASIL DISTRIBUICAO","cnpj":"13495487000253","city":"CURITIBA","stateCode":"PR","buscaAdicional":"DESTRO BRASIL CURITIBA 57214 DESTRO CURITIBA 908166"},{"id":"09656741-fc3f-44f6-6591-08d5ad2bf6ba","name":"RITMO COMERCIALIZADORA DE ENERGIA LTDA.","commercialName":"","cnpj":"23722405000139","city":"CURITIBA","stateCode":"PR","buscaAdicional":"RITMO COMERCIALIZADORA 56832"},{"id":"adc51409-905f-47a8-685b-08d5ad2bf6ba","name":"LAREDO ADMINISTRADORA DE SHOPPING CENTERS LTDA.","commercialName":"","cnpj":"27188442000160","city":"CURITIBA","stateCode":"PR","buscaAdicional":"LAREDO 59854 LAREDO ADM SHOPPING 71346"},{"id":"117592b6-11be-4f7e-68a8-08d5ad2bf6ba","name":"HEXION QUIMICA DO BRASIL LTDA","commercialName":"","cnpj":"61460150000172","city":"CURITIBA","stateCode":"PR","buscaAdicional":"HEXION QUIMICA 60251 HEXION QUIMICA BRA 900980 MONTENEGRO 911576"},{"id":"07f109ba-40a0-446c-8857-08d5ae44ed50","name":"ALAMO ADMINISTRACAO E PARTICIPACOES EIRELI","commercialName":"","cnpj":"02190526000107","city":"CURITIBA","stateCode":"PR","buscaAdicional":"ALAMO 3772"},{"id":"d9dcd68c-9954-4e8b-88cb-08d5ae44ed50","name":"HEXION QUIMICA DO BRASIL LTDA","commercialName":"","cnpj":"61460150001578","city":"CURITIBA","stateCode":"PR","buscaAdicional":"HEXION 51912"},{"id":"40ab953f-9d53-46c5-88d0-08d5ae44ed50","name":"PECCIN AGRO INDUSTRIAL LTDA","commercialName":"PECCIN","cnpj":"09237048000192","city":"CURITIBA","stateCode":"PR","buscaAdicional":"PECCIN AGRO 52275 PECCIN AGRO 901065"},{"id":"0c198226-54e9-408b-1cc6-08d5b8870181","name":"CWB ENERGIA COMERCIALIZADORA DE ENERGIA S.A.","commercialName":"UPSIDE TRADING","cnpj":"29152742000114","city":"CURITIBA","stateCode":"PR","buscaAdicional":"UPSIDETRD 61491"},{"id":"4c2be7bf-5673-4340-1caa-08d5b8870181","name":"MAXI GRAFICA E EDITORA LTDA","commercialName":"","cnpj":"82523317000177","city":"CURITIBA","stateCode":"PR","buscaAdicional":"MAXI GRAFICA 60678 MAXI GRAFICA - CURIT 912757"},{"id":"9bfcab03-b60d-43f7-7228-08d5cf600bef","name":"RUMO MALHA SUL S.A","commercialName":"","cnpj":"01258944000126","city":"CURITIBA","stateCode":"PR","buscaAdicional":""},{"id":"cc8e92a8-00bb-4afe-7252-08d5cf600bef","name":"RUMO S.A","commercialName":"","cnpj":"02387241000160","city":"CURITIBA","stateCode":"PR","buscaAdicional":""},{"id":"ad078832-6178-4441-7344-08d5cf600bef","name":"PARANA BANCO S/A","commercialName":"","cnpj":"14388334000199","city":"CURITIBA","stateCode":"PR","buscaAdicional":""},{"id":"1b5f7b3c-7d8e-4259-7339-08d5cf600bef","name":"TECNO WASTE S.A.","commercialName":"","cnpj":"13720879000198","city":"CURITIBA","stateCode":"PR","buscaAdicional":""},{"id":"8038f6e9-277b-491e-733a-08d5cf600bef","name":"ATIVOS BRASILEIROS S.A.","commercialName":"ATIVOS BRASILEIROS","cnpj":"13720918000157","city":"CURITIBA","stateCode":"PR","buscaAdicional":""},{"id":"bf81744b-d34a-400a-7332-08d5cf600bef","name":"COMPANHIA FERRIRERA BRASILEIRA S.A.","commercialName":"","cnpj":"12646054000108","city":"CURITIBA","stateCode":"PR","buscaAdicional":""},{"id":"6c12d4cc-0bdf-4699-732e-08d5cf600bef","name":"EKOPARKING S.A.","commercialName":"","cnpj":"12610097000133","city":"CURITIBA","stateCode":"PR","buscaAdicional":""},{"id":"5ed59ae9-6bf9-4d7d-732f-08d5cf600bef","name":"INTERCOSMETIC HOLDING S.A","commercialName":"","cnpj":"12610116000121","city":"CURITIBA","stateCode":"PR","buscaAdicional":""},{"id":"6e45271f-2591-4644-7330-08d5cf600bef","name":"ATLETAS BRASILEIROS S.A.","commercialName":"","cnpj":"12610165000164","city":"CURITIBA","stateCode":"PR","buscaAdicional":""},{"id":"496fe03d-1e70-46a7-73c2-08d5cf600bef","name":"BANCO RCI BRASIL S.A","commercialName":"","cnpj":"62307848000115","city":"CURITIBA","stateCode":"PR","buscaAdicional":""},{"id":"eb96d592-116d-48c9-7326-08d5cf600bef","name":"INTERMULTIMODAL S.A. OPERADORA DE PLATAFORMAS INTERNACIONAIS E LOGISTICA MULTIMODAL","commercialName":"","cnpj":"12394916000152","city":"CURITIBA","stateCode":"PR","buscaAdicional":""},{"id":"29975829-665d-4267-7327-08d5cf600bef","name":"EOX ENERGIA EOLICA S.A.","commercialName":"","cnpj":"12394936000123","city":"CURITIBA","stateCode":"PR","buscaAdicional":""},{"id":"06d4251a-914f-48ad-7328-08d5cf600bef","name":"FOSFATO BRASILEIRO S.A.","commercialName":"","cnpj":"12394972000197","city":"CURITIBA","stateCode":"PR","buscaAdicional":""},{"id":"c56bdb3a-fe15-464e-732a-08d5cf600bef","name":"DELUXE MOTORS S.A.","commercialName":"","cnpj":"12395010000152","city":"CURITIBA","stateCode":"PR","buscaAdicional":""},{"id":"d11f7bc0-cba8-4ea6-732b-08d5cf600bef","name":"INTELLECTUAL SERVICES S.A. - GESTAO DE ATIVOS DO CONHECIMENTO","commercialName":"","cnpj":"12395063000173","city":"CURITIBA","stateCode":"PR","buscaAdicional":""},{"id":"e474c013-7f29-4bc8-732c-08d5cf600bef","name":"DROGARIAS AMERICANAS S.A.","commercialName":"","cnpj":"12492734000114","city":"CURITIBA","stateCode":"PR","buscaAdicional":""},{"id":"659c8a29-4377-4206-7314-08d5cf600bef","name":"SUL INVEST SERVICOS FINANCEIROS S.A.","commercialName":"SUL INVEST","cnpj":"11181400000167","city":"CURITIBA","stateCode":"PR","buscaAdicional":""},{"id":"66ff9b8f-13c1-47f1-8d83-08d5d060706e","name":"PHILCO ELETRONICOS SA","commercialName":"","cnpj":"11283356000104","city":"CURITIBA","stateCode":"PR","buscaAdicional":"PHILCO MATRIZ 60493"},{"id":"d1f2b04a-3def-4afe-73cd-08d5cf600bef","name":"OURO VERDE LOCACAO E SERVICO S.A.","commercialName":"","cnpj":"75609123000123","city":"CURITIBA","stateCode":"PR","buscaAdicional":""},{"id":"cbbe2c73-453e-4206-73ce-08d5cf600bef","name":"COMPANHIA PARANAENSE DE ENERGIA","commercialName":"COPEL","cnpj":"76483817000120","city":"CURITIBA","stateCode":"PR","buscaAdicional":""},{"id":"9b6ebd3a-81f1-45ac-73cf-08d5cf600bef","name":"COMPANHIA DE SANEAMENTO DO PARANA SANEPAR","commercialName":"SANEPAR","cnpj":"76484013000145","city":"CURITIBA","stateCode":"PR","buscaAdicional":""},{"id":"cc7b7f71-da48-40e9-73d0-08d5cf600bef","name":"INEPAR S.A. INDUSTRIA E CONSTRUCOES - EM RECUPERACAO JUDICIAL","commercialName":"","cnpj":"76627504000106","city":"CURITIBA","stateCode":"PR","buscaAdicional":""},{"id":"43c12274-efe8-4f21-73d1-08d5cf600bef","name":"POSITIVO TECNOLOGIA S.A.","commercialName":"","cnpj":"81243735000148","city":"CURITIBA","stateCode":"PR","buscaAdicional":""},{"id":"cd705a1a-f9eb-4558-7404-08d5cf600bef","name":"CONSULT SERVICOS ADMINISTRATIVOS LTDA","commercialName":"","cnpj":"17632564000140","city":"CURITIBA","stateCode":"PR","buscaAdicional":""},{"id":"b434e286-072d-4c15-73fe-08d5cf600bef","name":"GAVEA SECURITIZADORA S/A","commercialName":"GAVEA SECURITIZADORA","cnpj":"11193684000101","city":"CURITIBA","stateCode":"PR","buscaAdicional":""},{"id":"69c12c4a-6b7f-467b-4f04-08d5d159243d","name":"FELCAR SECURITIZADORA S. A.","commercialName":"FELCAR SECURITIZADORA S. A.","cnpj":"27956690000103","city":"CURITIBA","stateCode":"PR","buscaAdicional":""},{"id":"5e823594-8b5b-469c-4ef4-08d5d159243d","name":"SENECA COMPANHIA SECURITIZADORA","commercialName":"SENECA COMPANHIA SECURITIZADORA","cnpj":"22495265000140","city":"CURITIBA","stateCode":"PR","buscaAdicional":""},{"id":"8a25e534-6757-46c5-4ef7-08d5d159243d","name":"COMPANHIA PARANAENSE DE SECURITIZACAO - PRSEC","commercialName":"","cnpj":"23043212000151","city":"CURITIBA","stateCode":"PR","buscaAdicional":""},{"id":"0949af1f-e0e7-4242-4ee6-08d5d159243d","name":"LOGOS COMPANHIA SECURITIZADORA S/A","commercialName":"LOGOS COMPANHIA SECURITIZADORA","cnpj":"19851496000135","city":"CURITIBA","stateCode":"PR","buscaAdicional":""},{"id":"6e18128d-aa9a-487c-6253-08d5ad2bf6ba","name":"PLUMA AGRO AVICOLA LTDA","commercialName":"PLUMA AGROAVICOLA LTDA","cnpj":"04656883000143","city":"DOIS VIZINHOS","stateCode":"PR","buscaAdicional":"PLUMA 54683 PLUMA2 DOIS VIZINHOS 906462 PLUMA 3 ENEAS MARQUE 906766 PLUMA DOIS VIZINHOS 908031"},{"id":"e5fb4869-d9a3-43fd-614d-08d5ad2bf6ba","name":"NUTRIPAR LTDA","commercialName":"NUTRIPAR","cnpj":"10529215000158","city":"DOIS VIZINHOS","stateCode":"PR","buscaAdicional":"NUTRIPAR 54105 NUTRIPAR 906014"},{"id":"4446eab3-7599-4d16-60a3-08d5ad2bf6ba","name":"GAZIN INDUSTRIA E COMERCIO DE MOVEIS E ELETRODOMESTICOS LTDA","commercialName":"MOVEIS GAZIN","cnpj":"77941490000155","city":"DOURADINA","stateCode":"PR","buscaAdicional":"GAZIN MOVEIS 53622 GAZIN 907242"},{"id":"3ae87c47-b6f8-430f-60b1-08d5ad2bf6ba","name":"GAZIN INDUSTRIA E COMERCIO DE MOLAS LTDA","commercialName":"GAZIN MOLAS","cnpj":"13348112000180","city":"DOURADINA","stateCode":"PR","buscaAdicional":"GAZIN MOLAS 53639 GAZIN MOLAS LTDA 906739"},{"id":"29445268-d6df-405c-696e-08d5ad2bf6ba","name":"FOLEM INDUSTRIA E COMERCIO S/A","commercialName":"","cnpj":"03498116000190","city":"ENÉAS MARQUES","stateCode":"PR","buscaAdicional":"FOLEM 61398 FOLEM - IPUACU - UC 912438"},{"id":"3e6d0608-be3e-4d19-61fd-08d5ad2bf6ba","name":"PLASKAPER TERMOPLASTICOS S/A","commercialName":"","cnpj":"05165324000101","city":"FAZENDA RIO GRANDE","stateCode":"PR","buscaAdicional":"PLASKAPER 54498 PLASKAPER 904277"},{"id":"e3442ae5-9f8f-4c37-64d9-08d5ad2bf6ba","name":"SUMITOMO RUBBER DO BRASIL LTDA.","commercialName":"","cnpj":"13816470000170","city":"FAZENDA RIO GRANDE","stateCode":"PR","buscaAdicional":"SUMITOMO RUBBER 56280 SUMITOMO RUBBER - PR 907854"},{"id":"30e0c269-c899-46eb-5b8c-08d5ad2bf6ba","name":"SNR ROLAMENTOS DO BRASIL LTDA","commercialName":"","cnpj":"02995040000146","city":"FAZENDA RIO GRANDE","stateCode":"PR","buscaAdicional":"SNR ROLAMENTOS 50758 SNR ROLAMENTOS 898841"},{"id":"13caf281-b20e-4090-5bb0-08d5ad2bf6ba","name":"ANTEX LTDA","commercialName":"","cnpj":"03129424000149","city":"FAZENDA RIO GRANDE","stateCode":"PR","buscaAdicional":"ANTEX 50829 ANTEX RIO GRANDE 898986"},{"id":"d50eab67-f929-4eb4-5ab6-08d5ad2bf6ba","name":"PLASTILIT PRODUTOS PLASTICOS DO PARANA S/A","commercialName":"","cnpj":"80550452000186","city":"FAZENDA RIO GRANDE","stateCode":"PR","buscaAdicional":"PLASTILIT MAT 50197 PLASTILIT RIO GRANDE 897387"},{"id":"6cc82da0-e2e2-447f-5abd-08d5ad2bf6ba","name":"CURITIBA ENERGIA SPE LTDA.","commercialName":"","cnpj":"17692840000165","city":"FAZENDA RIO GRANDE","stateCode":"PR","buscaAdicional":"UTE CURITIBA ENERGIA 50216 UTE CURITIBA ENERGIA 899133 UTE.RU.PR.035069-9.04"},{"id":"2a37f0fc-2b95-4a2d-60b2-08d5ad2bf6ba","name":"CARBONIFERA DO CAMBUI LTDA","commercialName":"","cnpj":"60820198000262","city":"FIGUEIRA","stateCode":"PR","buscaAdicional":"CAMBUI 53641 CAMBUI - FIGUEIRA 904794"},{"id":"7b0ae495-2927-4407-6006-08d5ad2bf6ba","name":"M A C GARCIA & CIA LTDA","commercialName":"MADEIRAS E TRANSPORTES GARCIA","cnpj":"04249693000101","city":"FIGUEIRA","stateCode":"PR","buscaAdicional":"MAC GARCIA 53351 MAC GARCIA E CIA LTD 906213"},{"id":"6128f30b-16df-434a-5e81-08d5ad2bf6ba","name":"BELMOND BRASIL HOTEIS SA","commercialName":"HOTEL DAS CATARATAS","cnpj":"32579013000234","city":"FOZ DO IGUAÇU","stateCode":"PR","buscaAdicional":"CATARATAS 52405 BELMOND BRASIL HOTEI 903054"},{"id":"41538ca5-c940-4945-636e-08d5ad2bf6ba","name":"HOTEL BOURBON DE FOZ DO IGUACU LTDA","commercialName":"","cnpj":"77768943000193","city":"FOZ DO IGUAÇU","stateCode":"PR","buscaAdicional":"BOURBON FOZ 55349 BOURBON FOZ - 1 906941 BOURBON FOZ - 2 907669 BOURBON ATIBAIA 904318"},{"id":"b56c6cab-4a25-4827-65b1-08d5ad2bf6ba","name":"MAREL INDUSTRIA DE MOVEIS S.A.","commercialName":"","cnpj":"77808640000238","city":"FRANCISCO BELTRÃO","stateCode":"PR","buscaAdicional":"MAREL 56949 MAREL MOVEIS 908844"},{"id":"6974f521-822d-4f3b-5ce5-08d5ad2bf6ba","name":"ALCAST DO BRASIL LTDA.","commercialName":"ALCAST","cnpj":"01836843000195","city":"FRANCISCO BELTRÃO","stateCode":"PR","buscaAdicional":"ALCAST 51605 ALCAST DO BRASIL 899173 ALCAST PALMAS 905318"},{"id":"1ef24bce-087f-40d2-6026-08d5ad2bf6ba","name":"PLAST'BEL LTDA","commercialName":"","cnpj":"81472243000124","city":"FRANCISCO BELTRÃO","stateCode":"PR","buscaAdicional":"PLASTBEL 53403 PLASTBEL LTDA EPP 904438 VERSARE PLAST EPP 904455"},{"id":"d232d4a2-4fbd-4467-605c-08d5ad2bf6ba","name":"LATICINIOS LATCO LTDA","commercialName":"LATCO","cnpj":"78900511000157","city":"FRANCISCO BELTRÃO","stateCode":"PR","buscaAdicional":"LATCO 53478 LATCO MARIPA 902975 LATCO CRUZEIRO OESTE 903625 LATCO MATRIZ 903626 LATCO REALEZA 903790 LATCO AYRTON SENNA 908405"},{"id":"25403acc-dc36-4edb-60a7-08d5ad2bf6ba","name":"DALBA ENGENHARIA E EMPREENDIMENTOS LTDA","commercialName":"DALBA ENGENHARIA E EMPREENDIMENTOS","cnpj":"03222465000185","city":"FRANCISCO BELTRÃO","stateCode":"PR","buscaAdicional":"DALBA 53626 DALBA ENGENHARIA 905515"},{"id":"4f4cbd25-b35e-4579-68ee-08d5ad2bf6ba","name":"FIACAO GOIOERE - INDUSTRIA DE FIOS LTDA.","commercialName":"FIACAO GOIOERE","cnpj":"26060377000120","city":"GOIOERÊ","stateCode":"PR","buscaAdicional":"FIACAO GOIOERE 60575 FIACAO GOIOERE 910838"},{"id":"a15086b1-e9da-48a9-6518-08d5ad2bf6ba","name":"LATICINIOS GUAIRA LTDA.","commercialName":"REAL INDUSTRIA E COMERCIO","cnpj":"04781257000189","city":"GUAÍRA","stateCode":"PR","buscaAdicional":"GUAIRA 56469 LATICINIOS GUAIRA 908232"},{"id":"38ae1b87-3f65-49ee-6373-08d5ad2bf6ba","name":"COOPERATIVA AGRARIA AGROINDUSTRIAL","commercialName":"CEREAIS CENTRAL","cnpj":"77890846000179","city":"GUARAPUAVA","stateCode":"PR","buscaAdicional":"AGRARIA ENERGIA 55372 COOP AGRARIA UG UV 906478 COOP. AGRARIA 907297 AGRARIA UG IO 907427 COOP AGRARIA UG UP 906457 AGRARIA UGC 907111 AGRARIA AGROIND UGGF 909235 CURUCACA (CEREAIS) 905188 UHE.PH.PR.028994-9.01"},{"id":"1be13d7f-8a80-40a6-63ae-08d5ad2bf6ba","name":"MARY ART SAO PAULO INDUSTRIA E COMERCIO LTDA","commercialName":"","cnpj":"75643072000156","city":"GUARAPUAVA","stateCode":"PR","buscaAdicional":"MARY ART 55519 MARY ART SAO PAULO 906758"},{"id":"349d927e-97e4-4ab0-6180-08d5ad2bf6ba","name":"IBERKRAFT INDUSTRIA DE PAPEL E CELULOSE LTDA","commercialName":"","cnpj":"77124634000180","city":"GUARAPUAVA","stateCode":"PR","buscaAdicional":"IBERKRAFT 54214 IBERKRAFT IND PAPEL 904443"},{"id":"91f11742-7c60-4c01-62b2-08d5ad2bf6ba","name":"TROPICOS INDUSTRIAL E COMERCIAL LTDA","commercialName":"","cnpj":"05520733000170","city":"GUARAPUAVA","stateCode":"PR","buscaAdicional":"TROPICOS 54932 TROPICOS 906380"},{"id":"7f0182e4-cfd3-4105-67fc-08d5ad2bf6ba","name":"POLIJUTA INDUSTRIA E COMERCIO DE EMBALAGENS LTDA","commercialName":"","cnpj":"82270281000167","city":"GUARAPUAVA","stateCode":"PR","buscaAdicional":"POLIJUTA 59130 POLIJUTA GUARAPUAVA 909559"},{"id":"3ffae4a0-b242-46f7-683e-08d5ad2bf6ba","name":"PINHO PAST LTDA","commercialName":"","cnpj":"77883478000131","city":"GUARAPUAVA","stateCode":"PR","buscaAdicional":"PINHO PAST 59536 PINHO PAST LTDA 909781"},{"id":"d6f71098-8f05-4a3a-65b5-08d5ad2bf6ba","name":"L.F.R.CARLI & CIA. LTDA.","commercialName":"","cnpj":"80051295000164","city":"GUARAPUAVA","stateCode":"PR","buscaAdicional":"CARLI 56990 LFR CARLI E CIA 908407"},{"id":"9076e9d3-196c-4b8c-6585-08d5ad2bf6ba","name":"BENDERPLAST - INDUSTRIA E COMERCIO DE EMBALAGENS - EIRELI","commercialName":"BENDERPLAST","cnpj":"07106525000155","city":"GUARAPUAVA","stateCode":"PR","buscaAdicional":"BENDERPLAST 56795 BENDERPL GUARAPUAVA 908480 BENDERPL 35515011 908481"},{"id":"9030dca2-4538-4762-65fc-08d5ad2bf6ba","name":"CELPLAC INDUSTRIA E COMERCIO - EIRELI","commercialName":"","cnpj":"75113647000129","city":"GUARAPUAVA","stateCode":"PR","buscaAdicional":"CELPLAC 57255 CELPAC IND E COM EI 907005"},{"id":"059cf117-8b8a-4f2c-679a-08d5ad2bf6ba","name":"ARAUPEL S.A.","commercialName":"ARAUPEL S.A.","cnpj":"87102810003233","city":"GUARAPUAVA","stateCode":"PR","buscaAdicional":"ARAUPEL SA 58332 ARAUPEL GUARAPUAVA 909070"},{"id":"671557bb-a187-4891-8d8a-08d5d060706e","name":"HIDRELETRICA VALE DO JORDAO LTDA","commercialName":"PCH PARQUE","cnpj":"14867538000102","city":"GUARAPUAVA","stateCode":"PR","buscaAdicional":"PARQUE 60995"},{"id":"69728bfd-4717-4ccd-60a8-08d5ad2bf6ba","name":"PEDREIRA PEROLA LTDA","commercialName":"PEDREIRA PEROLA","cnpj":"77001105000190","city":"GUARAPUAVA","stateCode":"PR","buscaAdicional":"PEDREIRA PEROLA 53627 PEDREIRA PEROLA 905263"},{"id":"4e642074-0f87-4bac-60c5-08d5ad2bf6ba","name":"SUPERMERCADO SUPERPAO LTDA","commercialName":"SUPERMERCADO SUPERPAO","cnpj":"77883320000161","city":"GUARAPUAVA","stateCode":"PR","buscaAdicional":"SUPERPAO 53685 SUPER PAO FILIAL 19 905062 SUPER PAO FILIAL 08 905073 SUPER PAO FILIAL 11 907391 SUPER PAO FILIAL 07 907392 SUPER PAO FILIAL 09 907407 SUPER PAO 16 908371 SUPER PAO FILIAL 10 908591 SUPER PAO FILIAL 12 908592 SUPER PAO FILIAL 06 908636 SUPER PAO FILIAL 02 908695 SUPER PAO FILIAL 04 908696 SUPER PAO FILIAL 13 908697 SUPER PAO FIL 13-2 908698 SUPER PAO FILIAL 01 908718 SUPER PAO FILIAL 03 908814 SUPER PAO FILIAL 05 908815 SUPER PAO FILIAL 28 908816 SUPER PAO FILIAL 21 909226 SUPER PAO FILIAL 15 913512"},{"id":"b41e5804-5645-4251-5d71-08d5ad2bf6ba","name":"REPINHO REFLORESTADORA MADEIRAS E COMPENSADOS LTDA","commercialName":"","cnpj":"82196510000221","city":"GUARAPUAVA","stateCode":"PR","buscaAdicional":"REPINHO FILIAL 51821 REPINHO FILIAL 899592"},{"id":"30f259eb-7e72-4188-5d58-08d5ad2bf6ba","name":"GUARATU INDUSTRIA E COMERCIO DE MADEIRAS E COMPENSADOS LTDA","commercialName":"GUARATU","cnpj":"03430928000102","city":"GUARAPUAVA","stateCode":"PR","buscaAdicional":"GUARATU 51793 GUARATU 899090"},{"id":"f95ac2aa-f85a-43e2-5d5b-08d5ad2bf6ba","name":"REPINHO REFLORESTADORA MADEIRAS E COMPENSADOS LTDA","commercialName":"","cnpj":"82196510000140","city":"GUARAPUAVA","stateCode":"PR","buscaAdicional":"REPINHO MATRIZ 51796 REPINHO MATRIZ 899079"},{"id":"f124254f-adf0-41f3-5df4-08d5ad2bf6ba","name":"CURUCACA GERADORA S.A.","commercialName":"CURUCACA GERADORA","cnpj":"14657364000153","city":"GUARAPUAVA","stateCode":"PR","buscaAdicional":"CURUCACA 52090 CURUCACA (CURUCACA) 900057 UHE.PH.PR.028994-9.01"},{"id":"f7a352c8-5737-4dfe-5892-08d5ad2bf6ba","name":"LCP ENERGIA S/A","commercialName":"LCP ENERGIA","cnpj":"08298254000140","city":"GUARAPUAVA","stateCode":"PR","buscaAdicional":"LCP ENERGIA 12472 RIO DAS MORTES 895461 CGH.PH.PR.030241-4.01"},{"id":"321501dc-352b-4088-587d-08d5ad2bf6ba","name":"DALBA ENERGETICA LTDA","commercialName":"PCH DALBA","cnpj":"12278190000192","city":"GUARAPUAVA","stateCode":"PR","buscaAdicional":"CGH DALBA 11997 DALBA 892382 CGH.PH.PR.030577-4.01"},{"id":"db1a3dbf-e92d-4a84-539a-08d5ad2bf6ba","name":"SANTA MARIA CIA DE PAPEL E CELULOSE","commercialName":"","cnpj":"77887917000184","city":"GUARAPUAVA","stateCode":"PR","buscaAdicional":"SANTA MARIA AUTOPRODUTOR 3721 S MARIA-GUARAPUAV-PR 70005 SALTO SAO PEDRO 900433 CGH.PH.PR.026885-2.01 CURUCACA (STA MARIA) 905187 UHE.PH.PR.028994-9.01"},{"id":"a54c461f-e687-45ee-5ba0-08d5ad2bf6ba","name":"PEDREIRA ICA LTDA","commercialName":"","cnpj":"75218453000198","city":"IBIPORÃ","stateCode":"PR","buscaAdicional":"PEDREIRA ICA 50795 PEDREIRA ICA 899675"},{"id":"3429bdf1-ddcf-42a5-6650-08d5ad2bf6ba","name":"ACOME DO BRASIL LTDA.","commercialName":"","cnpj":"02554135000124","city":"IRATI","stateCode":"PR","buscaAdicional":"ACOME 57491 ACOME DO BRASIL 908291"},{"id":"8f6d3771-d964-4fe1-63c0-08d5ad2bf6ba","name":"BOSCARDIN & CIA","commercialName":"","cnpj":"78142734000100","city":"IRATI","stateCode":"PR","buscaAdicional":"BOSCARDIN 55597 BOSCARDIN PONTA GROS 907277"},{"id":"54223308-0638-4bfd-5ecf-08d5ad2bf6ba","name":"M. DE COL - MAQUINAS E PLASTICOS","commercialName":"RECYCLE POLIMEROS DO BRASIL","cnpj":"05022285000185","city":"ITAPEJARA D'OESTE","stateCode":"PR","buscaAdicional":"RECYCLE 52558 M DE COL MAQUINAS 905042"},{"id":"a4fa7e1c-5a19-4c70-56c0-08d5ad2bf6ba","name":"HIDRELETRICA RIO VITORINO LTDA","commercialName":"HIDRELETRICA RIO VITORINO","cnpj":"14724412000189","city":"ITAPEJARA D'OESTE","stateCode":"PR","buscaAdicional":"VITORINO 7584 VITORINO 8026 PCH.PH.PR.027549-2.01"},{"id":"12c5243c-90fe-451b-4f85-08d5ad2bf6ba","name":"ANHAMBI ALIMENTOS LTDA","commercialName":"","cnpj":"78569688000112","city":"ITAPEJARA D'OESTE","stateCode":"PR","buscaAdicional":"ANHAMBI ALIM 1143 ANHAMBI RACOES- PR 7305"},{"id":"5d364561-69de-4957-6366-08d5ad2bf6ba","name":"CALTEC QUIMICA INDUSTRIAL S/A","commercialName":"CALTEC","cnpj":"03713592000187","city":"ITAPERUÇU","stateCode":"PR","buscaAdicional":"CALTEC 55336 CALTEC QUIMICA 908485"},{"id":"1ec2cfa0-809e-4c8a-676b-08d5ad2bf6ba","name":"BBA INDUSTRIA QUIMICA LTDA.","commercialName":"B B A","cnpj":"00623492000171","city":"JACAREZINHO","stateCode":"PR","buscaAdicional":"BBA QUIMICA 58085 BBA QUIMICA 909290"},{"id":"4c2be4c6-5b86-4487-5da0-08d5ad2bf6ba","name":"DALLON METAIS E DERIVADOS EIRELI","commercialName":"DALLON METAIS E DERIVADOS EIRELI","cnpj":"02631144000171","city":"JACAREZINHO","stateCode":"PR","buscaAdicional":"DALLON METAIS 51938 DALLON METAIS - J 899872"},{"id":"fde771f4-2431-4110-65b3-08d5ad2bf6ba","name":"JAGUAFRANGOS INDUSTRIA E COMERCIO DE ALIMENTOS LTDA","commercialName":"","cnpj":"85090033000122","city":"JAGUAPITÃ","stateCode":"PR","buscaAdicional":"JAGUAFRANGOS 56951 JAGUAFRANGOS INCUBAT 908457 JAGUAFRANGOS MATRIZ 908482 JAGUAFRANGOS - RACAO 911253"},{"id":"83829738-c987-41db-67f9-08d5ad2bf6ba","name":"BRASPINE MADEIRAS LTDA","commercialName":"","cnpj":"01203549000227","city":"JAGUARIAÍVA","stateCode":"PR","buscaAdicional":"BRASPINE 59112 BRASPINE 909690"},{"id":"59020ecb-301f-4844-656d-08d5ad2bf6ba","name":"JAGUARIAIVA ENERGIA SPE LTDA","commercialName":"","cnpj":"19552162000160","city":"JAGUARIAÍVA","stateCode":"PR","buscaAdicional":"CGH USINA VELHA 56724 CGH USINA VELHA 908565 CGH.PH.PR.033372-7.01"},{"id":"5ce0e47b-5f29-4e67-4f97-08d5ad2bf6ba","name":"PESQUEIRO ENERGIA S/A","commercialName":"PESQUEIRO","cnpj":"04019594000133","city":"JAGUARIAÍVA","stateCode":"PR","buscaAdicional":"PCH PESQUEIRO 1177 PESQUEIRO 564 PCH.PH.PR.002046-0.01"},{"id":"a8b553e2-5f29-426b-5011-08d5ad2bf6ba","name":"PISA INDUSTRIA DE PAPEIS LTDA.","commercialName":"","cnpj":"31985633000120","city":"JAGUARIAÍVA","stateCode":"PR","buscaAdicional":"PISA 1420 NORSKE PISA JAG 7224"},{"id":"0c90c2c8-7b88-4316-549a-08d5ad2bf6ba","name":"PARANA GERACAO DE ENERGIA ELETRICA LTDA.","commercialName":"","cnpj":"13468377000111","city":"JAGUARIAÍVA","stateCode":"PR","buscaAdicional":"PARANA 4359 NOVA JAGUAR-CHAMPION 8022 CGH.PH.PR.001549-0.02"},{"id":"c0bb9064-1cba-4a63-6156-08d5ad2bf6ba","name":"N. ZEPPONE & CIA LTDA","commercialName":"POLPANORTE","cnpj":"00674246000149","city":"JAPURÁ","stateCode":"PR","buscaAdicional":"POLPANORTE 54141 N. ZEPPONE & CIA LTD 906475"},{"id":"584cf94f-1a74-45dd-617c-08d5ad2bf6ba","name":"FRANGOS PIONEIRO INDUSTRIA E COMERCIO DE ALIMENTOS LTDA","commercialName":"FRANGOS PIONEIRO","cnpj":"00974731000138","city":"JOAQUIM TÁVORA","stateCode":"PR","buscaAdicional":"FRANGOS PIONEIRO 54207 FRANGOS PIONEIRO 903795 FRANGOS PIONEIRO MTZ 908026 FRANGOS PIONEIRO RAC 908038"},{"id":"2d308ad0-2a41-4b0e-6785-08d5ad2bf6ba","name":"POTENCIAL BIODIESEL LTDA","commercialName":"PB-BIOS","cnpj":"12613484000123","city":"LAPA","stateCode":"PR","buscaAdicional":"POTENCIAL BIODIESEL 58244 POTENCIAL BIODIESEL 908614"},{"id":"1aaa0bf6-e39d-4c87-5fa7-08d5ad2bf6ba","name":"A. R. C. LOGISTICA E ALIMENTOS LTDA","commercialName":"","cnpj":"11609581000422","city":"LOBATO","stateCode":"PR","buscaAdicional":"LIDER ALIMENTOS LOBATO 53068 ARC LOGISTICA 906027"},{"id":"d54201da-e080-418d-6056-08d5ad2bf6ba","name":"PEDREIRA EXPRESSA LTDA","commercialName":"","cnpj":"81671125000145","city":"LONDRINA","stateCode":"PR","buscaAdicional":"PEDREIRA EXPRESSA 53469 PEDREIRA EXPRESSA 904800"},{"id":"7e3e43d6-13ec-47d4-6018-08d5ad2bf6ba","name":"CRYOVAC LONDRINA LTDA","commercialName":"","cnpj":"00200283000115","city":"LONDRINA","stateCode":"PR","buscaAdicional":"CRYOVAC 53375 DELTAPLAM EMBALAGENS 906020"},{"id":"b36f9313-0fef-4a36-5d92-08d5ad2bf6ba","name":"INSTITUTO FILADELFIA DE LONDRINA","commercialName":"","cnpj":"78624202000100","city":"LONDRINA","stateCode":"PR","buscaAdicional":"INSTITUTO FILADELFIA DE LONDRI 51923 INST FILADELFIA LOND 906472 INST FILAD 68175450 906496"},{"id":"96f3ca50-52e2-4cce-5ba1-08d5ad2bf6ba","name":"ELEVADORES ATLAS SCHINDLER LTDA.","commercialName":"","cnpj":"00028986014753","city":"LONDRINA","stateCode":"PR","buscaAdicional":"ATLAS SCHINDLER 50803 ELEVADORES SCHINDLER 898672"},{"id":"423ced8a-cd7f-49ad-5c00-08d5ad2bf6ba","name":"BENVENHO & CIA LTDA","commercialName":"MIDIOGRAF II","cnpj":"00350242000105","city":"LONDRINA","stateCode":"PR","buscaAdicional":"MIDIOGRAF 51032 MIDIOGRAF BENVENHO 899752"},{"id":"cd577f17-a1d1-4a0a-5ac1-08d5ad2bf6ba","name":"RONDOPAR ENERGIA ACUMULADA LTDA","commercialName":"","cnpj":"76466929000172","city":"LONDRINA","stateCode":"PR","buscaAdicional":"RONDOPAR 50220 RONDOPAR LONDRINA 898009"},{"id":"82d6bfbd-8efb-4c52-5ab1-08d5ad2bf6ba","name":"LONDRINA NORTE ADMINISTRADORA DE SHOPPING CENTERS LTDA.","commercialName":"","cnpj":"15868074000111","city":"LONDRINA","stateCode":"PR","buscaAdicional":"LONDRINA NORTE SHOPPING 50178 LONDRINA NORTE SHOP 897306"},{"id":"cf527d4b-6712-4606-5ae1-08d5ad2bf6ba","name":"BELAGRICOLA COMERCIO E REPRESENTACOES DE PRODUTOS AGRICOLAS S.A.","commercialName":"BELAGRICOLA","cnpj":"79038097000181","city":"LONDRINA","stateCode":"PR","buscaAdicional":"BELAGRICOLA 50311 BELAGRICOLA PRIM MAI 898074 BELAGRICOLA MAUA 898098 BELAGRICOLA IMBITUVA 898267 BELAGRICOLA NANTES 898390 BELAGRICOLA SERTANEJ 898952 BELAGRICOLA - IEPE 899297 BELAGRICOLA PARAISO 899817 BELAGRICOLA FATIMA 899833 BELAGRICOLA CAMBE 900984 BELAGRICOLA IBIPORA 900985 BELAGRICOLA SERTANOP 902010 BELAGRICOLA TEIXEIRA 902628 BELAGRICOLA CANDIDO 903226 BELAGRICOLA TAMARANA 904024 BELAGRICOLA TIBAGI 904703 BELAGRICOLA SABAUDIA 905313 BELAGRICOLA RIBEIRAO 905797 BELAGRICOLA ITABERA 906713 BELAGRICOLA ASTORGA 906819 BELAGRICOLA APUCARAN 907394 BELAGRICOLA ARAPONGA 909408 BELAGRICOLA ALVORADA 909603 BELAGRICOLA MATRIZ 909604 BELAGRICOLA LONDRINA 909615 BELAGRICOLA SC PAVAO 909621 BELAGRICOLA MARIALVA 909632 BELAGRICOLA CRUZALIA 909726 BELAGRICOLA ASSAI 910025 BELAGRICOLA PRADO FR 910059"},{"id":"d3ad0e8f-f463-4195-5b0d-08d5ad2bf6ba","name":"PEVESUL INDUSTRIA DE TUBOS E CONEXOES LTDA","commercialName":"","cnpj":"79754750000109","city":"LONDRINA","stateCode":"PR","buscaAdicional":"PEVESUL 50403 PEVESUL 899406"},{"id":"e82ee126-3641-4be6-5b0e-08d5ad2bf6ba","name":"TEX CARD COMERCIO DE LINHAS LTDA","commercialName":"","cnpj":"04398339000149","city":"LONDRINA","stateCode":"PR","buscaAdicional":"TEX CARD 50410 TEX CARD 898388"},{"id":"1edc22ae-563c-44f8-5af8-08d5ad2bf6ba","name":"CONDOMINIO SHOPPING ROYAL PLAZA LONDRINA","commercialName":"","cnpj":"00908059000182","city":"LONDRINA","stateCode":"PR","buscaAdicional":"SHOPPING ROYAL PLAZA 50375 SHOP ROYALPLAZA 898155"},{"id":"af848ede-25b1-4953-5555-08d5ad2bf6ba","name":"GEO ELETRICA TAMBOARA BIOENERGIA SPE LTDA","commercialName":"GEO ELETRICA TAMBOARA","cnpj":"12415018000133","city":"LONDRINA","stateCode":"PR","buscaAdicional":"GEO ELETRICA 5353 GEO ELETR TAMBOARA 8975 UTE.AI.PR.030724-6.01"},{"id":"c94006d3-43fc-4350-545e-08d5ad2bf6ba","name":"CONDOMINIO DO CATUAI SHOPPING CENTER LONDRINA","commercialName":"","cnpj":"81764136000170","city":"LONDRINA","stateCode":"PR","buscaAdicional":"CATUAISHOPPING 4194 CATUAI SHOP-LONDRINA 71523"},{"id":"0e15c2e4-379b-4216-571f-08d5ad2bf6ba","name":"COMPANHIA CACIQUE DE CAFE SOLUVEL","commercialName":"","cnpj":"78588415000115","city":"LONDRINA","stateCode":"PR","buscaAdicional":"CIA CACIQUE 8229 CIA CACIQUE 889084"},{"id":"336b8ddf-57fa-4736-572e-08d5ad2bf6ba","name":"SONOCO DO BRASIL LTDA","commercialName":"SONOCO DO BRASIL LTDA","cnpj":"00496586000631","city":"LONDRINA","stateCode":"PR","buscaAdicional":"SONOCO PR 8310 SONOCO 888448"},{"id":"33735a89-978e-48e4-6794-08d5ad2bf6ba","name":"NUTRI 100 AGRO LTDA","commercialName":"","cnpj":"03518381000193","city":"LONDRINA","stateCode":"PR","buscaAdicional":"AGRO 100 58320 AGRO 100 - LONDRINA 909683 AGRO 100 - CAMBE 909686 AGRO 100 - PRIMEIRO 909688 AGRO 100 SERTANOP 910293"},{"id":"55bfe4dd-732d-4e2c-6702-08d5ad2bf6ba","name":"PEDREIRA LERROVILLE LTDA","commercialName":"MINERADORA JUNDIAI","cnpj":"14800351000191","city":"LONDRINA","stateCode":"PR","buscaAdicional":"PEDREIRA LERROVILLE 57921 PEDREIRA LERROVILLE 911694"},{"id":"4f51774e-03ae-4c38-6682-08d5ad2bf6ba","name":"G.N.B. INDUSTRIA DE BATERIAS EIRELI","commercialName":"","cnpj":"05697322000155","city":"LONDRINA","stateCode":"PR","buscaAdicional":"REIFOR BATERIAS 57625 BATERIAS REIFOR GNB 908192"},{"id":"703e5271-299c-4645-67d6-08d5ad2bf6ba","name":"CONFEPAR AGRO-INDUSTRIAL COOPERATIVA CENTRAL","commercialName":"CONFEPAR","cnpj":"76531581000150","city":"LONDRINA","stateCode":"PR","buscaAdicional":"CONFEPAR 58672 CONFEPAR UC 738490 909582"},{"id":"eb561ac4-350e-4614-6878-08d5ad2bf6ba","name":"REDECINE BRA CINEMATOGRAFICA S.A","commercialName":"CINESYSTEM CINEMAS","cnpj":"15422993000167","city":"LONDRINA","stateCode":"PR","buscaAdicional":"CINESYSTEM 60094 CINESYSTEM SANTAREM 911267 1000005095 912992 CINESYSTEM LONDRINA 913412"},{"id":"d0b1b2f1-e831-4e98-6901-08d5ad2bf6ba","name":"FAST GONDOLAS EQUIPAMENTOS LTDA","commercialName":"FAST GONDOLAS & CHECK - OUTS","cnpj":"76902204000180","city":"LONDRINA","stateCode":"PR","buscaAdicional":"FAST GONDOLAS 60717 FAST GONDOLAS 912322"},{"id":"2b28270f-e624-4a9f-6224-08d5ad2bf6ba","name":"INTEGRADA COOPERATIVA AGROINDUSTRIAL","commercialName":"INTEGRADA","cnpj":"00993264000193","city":"LONDRINA","stateCode":"PR","buscaAdicional":"INTEGRADA 54593 INTEGRADA UC 9501070 906494 INTEGRADA UC 7055957 906469 INTEGRADA UC 5365982 906471 INTEGRADA UC 7385013 906495 INTEGRADA UC 4466349 906648 INTEGRADA 69414793 906818 INTEGRADA 99068850 906957 INTEGRADA 70759359 907104"},{"id":"ef9c76c9-7602-48bf-6266-08d5ad2bf6ba","name":"ASSOCIACAO EVANGELICA BENEFICENTE DE LONDRINA","commercialName":"HOSPITAL EVANGELICO DE LONDRINA","cnpj":"78613841000161","city":"LONDRINA","stateCode":"PR","buscaAdicional":"HOSPITAL EVANGELICO 54745 HOSP EVANG LONDRINA 906835"},{"id":"3af8e126-fa7b-47e6-62cd-08d5ad2bf6ba","name":"LABORATORIOS VENCOFARMA DO BRASIL LTDA","commercialName":"","cnpj":"79578266000176","city":"LONDRINA","stateCode":"PR","buscaAdicional":"VENCO 54975 LAB VENCOFARMA 906381"},{"id":"cfc602ad-60f2-4c89-656e-08d5ad2bf6ba","name":"BRUXELAS COMERCIO DE ALIMENTOS LTDA","commercialName":"","cnpj":"07306828000111","city":"LONDRINA","stateCode":"PR","buscaAdicional":"SUPERGOLFF 56725 SUPERGOLFF MATRIZ 908015 SUPERGOLFF BRASIL 908016 SUPERGOLFF GABRIEL F 908017 SUPERGOLFF SAUL ELKI 908018 SUPERGOLFF ARTHUR TH 908019"},{"id":"179a79c5-34f7-4382-649d-08d5ad2bf6ba","name":"PEDREIRA GUARAVERA LTDA","commercialName":"PEDREIRA GUARAVERA","cnpj":"04144773000100","city":"LONDRINA","stateCode":"PR","buscaAdicional":"PEDREIRA GUARAVERA 56134 PED GUARAVERA IBIPOR 908292 PEDREIRA GUARAVERA 908410"},{"id":"de225109-b62d-443e-63db-08d5ad2bf6ba","name":"FIACAO DE SEDA BRATAC S A","commercialName":"","cnpj":"61080735000833","city":"LONDRINA","stateCode":"PR","buscaAdicional":"BRATAC 55685 BRATAC 907677 BRATAC BASTOS 909727"},{"id":"bd4f80b6-0212-4180-63fa-08d5ad2bf6ba","name":"LABMED LABORATORIO MEDICO DE LONDRINA LTDA","commercialName":"LABIMAGEM DIAGNOSTICO AVANCADO EM MEDICINA","cnpj":"77348738000179","city":"LONDRINA","stateCode":"PR","buscaAdicional":"LABMED 55761 LABMED 908811"},{"id":"f66ca8eb-5554-4939-7245-08d5cf600bef","name":"EMPRESA CONCESSIONARIA DE RODOVIAS DO NORTE S/A - ECONORTE","commercialName":"","cnpj":"02222736000130","city":"LONDRINA","stateCode":"PR","buscaAdicional":""},{"id":"4d88bca9-f1ff-414d-60a9-08d5ad2bf6ba","name":"SEPAC SERRADOS E PASTA DE CELULOSE LTDA","commercialName":"","cnpj":"75655720000194","city":"MALLET","stateCode":"PR","buscaAdicional":"SEPAC 53628 SEPAC MALLET 908409"},{"id":"49144aae-b182-4552-5fb4-08d5ad2bf6ba","name":"ROMAGNOLE PRODUTOS ELETRICOS S.A.","commercialName":"ROMAGNOLE","cnpj":"78958717000138","city":"MANDAGUARI","stateCode":"PR","buscaAdicional":"ROMAGNOLE 53191 ROMAGNOLE MANDAGUA 2 901018 ROMAGNOLE MANDAGUARI 901038"},{"id":"efde5888-d6e0-4078-6237-08d5ad2bf6ba","name":"MINORGAN INDUSTRIA E COMERCIO DE FERTILIZANTES S.A.","commercialName":"MINORGAN INDUSTRIA E COMERCIO DE FERTILIZANTES","cnpj":"02599378000189","city":"MANDAGUARI","stateCode":"PR","buscaAdicional":"MINORGAN 54624 MINORGAN 907113"},{"id":"77e824b0-8133-4d1e-6282-08d5ad2bf6ba","name":"COCARI - COOPERATIVA AGROPECUARIA E INDUSTRIAL","commercialName":"","cnpj":"78956968000183","city":"MANDAGUARI","stateCode":"PR","buscaAdicional":"COCARI 54789 COCARI 41473159 907405"},{"id":"741a232f-44be-47d1-6463-08d5ad2bf6ba","name":"CANHADAO PRODUCAO DE ENERGIA ELETRICA LTDA","commercialName":"CANHADAO PRODUCAO DE ENERGIA ELETRICA","cnpj":"05516658000174","city":"MANGUEIRINHA","stateCode":"PR","buscaAdicional":"CANHADAO 55971 CANHADAO 910956 PCH.PH.PR.032511-2.01"},{"id":"57ba79d3-6bdd-4924-5aa5-08d5ad2bf6ba","name":"TIGRE PRODUCAO DE ENERGIA ELETRICA LTDA","commercialName":"TIGRE PRODUCAO DE ENERGIA ELETRICA","cnpj":"05545260000166","city":"MANGUEIRINHA","stateCode":"PR","buscaAdicional":"PCH DO TIGRE 50135 TIGRE 905215 PCH.PH.PR.029222-2.01"},{"id":"906842e5-277f-42b6-5044-08d5ad2bf6ba","name":"CRISTALINO ENERGIA LTDA","commercialName":"CRISTALINO ENERGIA","cnpj":"05042517000167","city":"MANOEL RIBAS","stateCode":"PR","buscaAdicional":"PCH CRISTALINO 1547 CRISTALINO 8101 PCH.PH.PR.028783-0.01"},{"id":"889791f7-8b19-48c7-59f7-08d5ad2bf6ba","name":"COOP. DE ELETRIF. E DESENV. ECONOMICO DE MAL. CDO. RONDON - CERCAR","commercialName":"CERCAR","cnpj":"76879295000180","city":"MARECHAL CÂNDIDO RONDON","stateCode":"PR","buscaAdicional":"PCH CERCAR 16175 MOINHO (PCH CERCAR) 895681 PCH.PH.PR.030836-6.01"},{"id":"c8cf82c2-a877-41fc-62ce-08d5ad2bf6ba","name":"COOPERATIVA AGROINDUSTRIAL COPAGRIL","commercialName":"COPAGRIL","cnpj":"81584278004061","city":"MARECHAL CÂNDIDO RONDON","stateCode":"PR","buscaAdicional":"COPAGRIL 54976 COPAGRIL CAND RONDON 905333"},{"id":"58bc8c9b-d466-47ca-66d9-08d5ad2bf6ba","name":"AMIFEC ALIMENTOS LTDA","commercialName":"AMIFEC","cnpj":"05693158000370","city":"MARIA HELENA","stateCode":"PR","buscaAdicional":"AMIFEC FILIAL 57853 AMIFEC 908810"},{"id":"57b52ae4-1e4d-4e5d-5ed3-08d5ad2bf6ba","name":"TERMINAL MARINGA S/A","commercialName":"TERMINAL MARINGA","cnpj":"17731972000159","city":"MARIALVA","stateCode":"PR","buscaAdicional":"TERM MARINGA 52566 TERMINAL MARINGA 903154"},{"id":"313087c4-02bd-4325-5ea7-08d5ad2bf6ba","name":"FRAVI INDUSTRIA E COMERCIO DE EQUIPAMENTOS AGRICOLAS LTDA","commercialName":"","cnpj":"05108075000104","city":"MARIALVA","stateCode":"PR","buscaAdicional":"PLANTI CENTER 52474 FRAVI INDUSTRIA 901934"},{"id":"3673bbed-e7af-4d76-5e4d-08d5ad2bf6ba","name":"FLEXOPRINT ETIQUETAS LTDA.","commercialName":"FLEXOPRINT ETIQUETAS","cnpj":"01733454000134","city":"MARIALVA","stateCode":"PR","buscaAdicional":"FLEXOPRINT 52324 FLEXOPRINT 902331"},{"id":"56c0a4d7-6043-490d-5e6b-08d5ad2bf6ba","name":"CAPELLA PRODUTOS PLASTICOS - EIRELI","commercialName":"","cnpj":"18748235000121","city":"MARINGÁ","stateCode":"PR","buscaAdicional":"CAPELLA PLASTICOS 52379 CAPPELA PLASTICOS 903273"},{"id":"c61a20d1-1cf9-4bbc-5eb7-08d5ad2bf6ba","name":"MBF EMBALAGENS LTDA.","commercialName":"APTAR MARINGA","cnpj":"01777872000123","city":"MARINGÁ","stateCode":"PR","buscaAdicional":"APTAR 52522 MBF EMBALAGENS 901614"},{"id":"bee1df79-268d-4e5b-5dc1-08d5ad2bf6ba","name":"COMPANHIA SULAMERICANA DE DISTRIBUICAO","commercialName":"COMPANHIA SULAMERICANA DE DISTRIBUICAO","cnpj":"11517841000197","city":"MARINGÁ","stateCode":"PR","buscaAdicional":"CIA SULAMERICANA DISTRIB 51978 CIA SUL OURO BRANCO 900851 CIA SUL DOURADOS 900862 CIA SUL EDSON LIMA 900863 CIA SUL ARAPONGAS 900864 CIA SUL TOLEDO 900869 CIA SUL ASSIS 900870 CIA SUL FERNANDOPOLI 900874 CIDADE CANCAO UMUARA 900893 CIA SUL CID CANCAO 901135 CIA JANDAIA 901136 CIA LONDRINA 901137 CIA ROCHA POMBO 901138 CIA MORANGUEIRA 901153 CIA CERRO AZUL 901154 CIDADE CANCAO LOND 901413 CIDADE CORNELIO II 901414 CIDADE BENTO MUNHOZ 901415 CIDADE CANCAO 901440 CID CANCAO PROMISSAO 901977 CID CANCAO ARACATUBA 901993 CIDADE CANCAO LINS 902000 CIA ARACATUBA 902014 CIDADE CANCAO AMG 902635 CID CANCAO MARILIA 902653 CIDADE CANCAO BAND 903355 CANCAO - BIRIGUI 905550 CANCAO - LINS 905551 CANCAO - SILVARES 905552 CANCAO - FLORIADO 905567 CANCAO - AMG 905568 CIDADE CANCAO MARING 906765 CIDADE CANCAO MANDAG 906770 CIDADE CANCAO BRASIL 906775 CIDADE CANCAO SARAND 906958 CIDADE CANCAO TUIUTI 907004 CIDADE CANCAO NEY BR 907009 CID CANCAO PALMEIRAS 907073 CIDADE CANCAO TAMAND 907079 CIDADE CANCAO DOMING 907103 CIDADE CANCAO - APUC 907112 CIDADE CANCAO - MARI 907131 CIDADE CANCAO ALVORA 907937 CIDADE CANCAO PVAI 908021 CIDADE CANCAO CORNEL 908035 CIDADE CANCAO MANDAC 908654 CID CANCAO CIANORTE 910194 CIDADE CANCAO - ROL 911176"},{"id":"61f85e16-1ef3-477c-5d3f-08d5ad2bf6ba","name":"MARIMED SERVICOS MEDICOS S/A","commercialName":"HOSPITAL PARANA","cnpj":"77265361000194","city":"MARINGÁ","stateCode":"PR","buscaAdicional":"HOSPITAL PARANA 51747 HOSPITAL PARANA 900981"},{"id":"e43d25a3-3686-44ec-5d20-08d5ad2bf6ba","name":"GONCALVES & TORTOLA S/A","commercialName":"","cnpj":"85070068000108","city":"MARINGÁ","stateCode":"PR","buscaAdicional":"GTFOODS 51710 GTFOODS PARAISO NORT 901174 GTFOODS PARANAVAI 901233 GTFOODS MARINGA 900848 GTFOODS INDIANOPOLIS 900849 GTFOODS TERRA BOA 900850 GTFOODS SAO MANOEL 901394"},{"id":"be975ee7-2fe1-4bfc-5f47-08d5ad2bf6ba","name":"PERFIBRAS INDUSTRIA E COMERCIO DE ALUMINIO LTDA","commercialName":"","cnpj":"05112486000173","city":"MARINGÁ","stateCode":"PR","buscaAdicional":"PERFIBRAS 52883 PERFIBRAS 903770"},{"id":"d2d25cf8-7bb8-49d7-5f48-08d5ad2bf6ba","name":"ANODIZACAO E COLORACAO DE METAIS MARINGA LTDA","commercialName":"ALUDIZA","cnpj":"00684513000169","city":"MARINGÁ","stateCode":"PR","buscaAdicional":"ALUDIZA 52884 ANODIZACAO MARINGA 903771"},{"id":"1246dbd0-e3fb-49af-6043-08d5ad2bf6ba","name":"CIMFLEX-INDUSTRIA E COMERCIO DE PLASTICOS LTDA","commercialName":"","cnpj":"07009980000132","city":"MARINGÁ","stateCode":"PR","buscaAdicional":"CIMFLEX 53440 CIMFLEX - MARINGA 903435"},{"id":"8cdf8bc4-e135-481a-5bf8-08d5ad2bf6ba","name":"GONZALES, SENDESKI & CIA LTDA","commercialName":"ALUMINIO PERFILEVE","cnpj":"03336687000129","city":"MARINGÁ","stateCode":"PR","buscaAdicional":"PERFILEVE 51005 GONZALES SENDESKI 899612"},{"id":"fc00d386-c51e-4852-5017-08d5ad2bf6ba","name":"COCAMAR COOPERATIVA AGROINDUSTRIAL","commercialName":"","cnpj":"79114450000165","city":"MARINGÁ","stateCode":"PR","buscaAdicional":"COCAMAR 1439 COCAMAR--MARINGA 7818 COCAMAR CIANORTE 907080 COCAMAR FLORESTA 907081 COCAMAR CAMBE 907389 COCAMAR IPORA 907390 COCAMAR S JORGE IVAI 907409 COCAMAR ASSAI 908014 COCAMAR APUCARANA 908032 COCAMAR MARINGA POCO 908270"},{"id":"a45c995a-81aa-4f75-6769-08d5ad2bf6ba","name":"GTB EMPREENDIMENTOS S.A.","commercialName":"","cnpj":"18229784000190","city":"MARINGÁ","stateCode":"PR","buscaAdicional":"GTB FOODS 58081"},{"id":"7d4e3efb-2888-4241-686d-08d5ad2bf6ba","name":"ABATEDOURO COROAVES LTDA","commercialName":"","cnpj":"75729038000107","city":"MARINGÁ","stateCode":"PR","buscaAdicional":"COROAVES 60030 ABATEDOURO COROAVES 910273"},{"id":"2ebd6ec5-29b8-4e25-68b2-08d5ad2bf6ba","name":"DINAMICA ECOSOLUTION LTDA","commercialName":"","cnpj":"86685245000115","city":"MARINGÁ","stateCode":"PR","buscaAdicional":"DINAMICA 60305 DINAMICA ECOSOLUTION 910575"},{"id":"5baecadd-19eb-4511-6827-08d5ad2bf6ba","name":"ALISUL ALIMENTOS SA","commercialName":"SUPRA","cnpj":"89548523002477","city":"MARINGÁ","stateCode":"PR","buscaAdicional":"ALISUL ALIN MARINGA 59442 ALISUL MARINGA 909681"},{"id":"32c2df4a-7387-45ba-62f6-08d5ad2bf6ba","name":"FA MARINGA LTDA","commercialName":"","cnpj":"79124079000112","city":"MARINGÁ","stateCode":"PR","buscaAdicional":"FA MARINGA 55061 FA MARINGA PR317 907388 FA MARINGA CONTORNO 907408 FA MARINGA COLOMBO 908653"},{"id":"98de5822-8e85-452b-62ac-08d5ad2bf6ba","name":"INDUSTRIA DE MOVEIS LEAO LTDA","commercialName":"","cnpj":"79130514000111","city":"MARINGÁ","stateCode":"PR","buscaAdicional":"MOVEIS LEAO 54915 IND DE MOVEIS LEAO 906856"},{"id":"cedf158e-ce05-4ecb-640c-08d5ad2bf6ba","name":"CESUMAR - CENTRO DE ENSINO SUPERIOR DE MARINGA LTDA","commercialName":"UNICESUMAR","cnpj":"79265617000199","city":"MARINGÁ","stateCode":"PR","buscaAdicional":"CESUMAR 55808 CESUMAR 907962"},{"id":"63aefe7e-971b-45c6-64da-08d5ad2bf6ba","name":"MGF PROMOCOES E EVENTOS LTDA","commercialName":"","cnpj":"04566746000118","city":"MARINGÁ","stateCode":"PR","buscaAdicional":"SHOP MARINGA PARK 56281 SHOP MARINGA PARK 908408"},{"id":"e28ef429-581a-431d-656f-08d5ad2bf6ba","name":"ASSOCIACAO DOS LOJISTAS DO SHOPPING CIDADE - ALOSC","commercialName":"ALOSC","cnpj":"06204573000113","city":"MARINGÁ","stateCode":"PR","buscaAdicional":"SHOPPING CIDADE MARINGA 56726 SHOP CIDADE MARINGA 907230"},{"id":"c2bdc06c-b795-4823-655e-08d5ad2bf6ba","name":"CONDOMINIO DO CATUAI SHOPPING CENTER MARINGA","commercialName":"CATUAI SHOPPING CENTER MARINGA","cnpj":"13687914000114","city":"MARINGÁ","stateCode":"PR","buscaAdicional":"COND CATUAI MARINGA 56699 COND CATUAI SHOP 900853"},{"id":"9b6ef02f-3d20-468e-653d-08d5ad2bf6ba","name":"CEREALISTA FEIJAO DE OURO LTDA","commercialName":"","cnpj":"77934503000169","city":"MARINGÁ","stateCode":"PR","buscaAdicional":"FEIJAODEOURO 56615 CEREAL FEIJAO DE OUR 908233"},{"id":"1a56dcfd-4708-483d-8d8b-08d5d060706e","name":"USINA DE ACUCAR SANTA TEREZINHA LTDA","commercialName":"","cnpj":"75717355000103","city":"MARINGÁ","stateCode":"PR","buscaAdicional":"USINA SANTA TEREZINHA 61032 USINA SANTA TEREZINH 913353"},{"id":"dfc6d14b-18e1-476e-6814-08d5d153df4d","name":"CINESYSTEM S.A.","commercialName":"","cnpj":"07437016000105","city":"MARINGÁ","stateCode":"PR","buscaAdicional":""},{"id":"903d7b05-be60-4fe9-5bfd-08d5ad2bf6ba","name":"CARELLI & CIA LTDA","commercialName":"","cnpj":"75021188000587","city":"MATELÂNDIA","stateCode":"PR","buscaAdicional":"CARELLI MATELANDIA 51011 CARELLI & CIA LTDA 900633"},{"id":"3bc2e83c-d78c-4f93-5ebf-08d5ad2bf6ba","name":"SL CEREAIS E ALIMENTOS LTDA","commercialName":"","cnpj":"81066938000106","city":"MAUÁ DA SERRA","stateCode":"PR","buscaAdicional":"SL ALIMENTOS 52534 SL CEREAIS E ALIMENT 901936"},{"id":"26d83323-db19-4d4d-5ee1-08d5ad2bf6ba","name":"SEMENTES PARANA LTDA","commercialName":"SEMENTES PARANA","cnpj":"04415166000120","city":"MAUÁ DA SERRA","stateCode":"PR","buscaAdicional":"SL SEMENTES 52599 SEMENTES PARANA 901914"},{"id":"5f927a44-ef48-4d51-5ff3-08d5ad2bf6ba","name":"LAR COOPERATIVA AGROINDUSTRIAL","commercialName":"LAR","cnpj":"77752293000198","city":"MEDIANEIRA","stateCode":"PR","buscaAdicional":"LAR CE 53309 LAR 7 MATELANDIA 905314 LAR 6 - MISSAL 904137 LAR 7 - XAXIM 904139 LAR 1 - MEDIANEIRA 904156 LAR 4 STA TEREZINHA 904157 LAR 5 - MEDIANEIRA 904159 LAR 9 - SANTA HELENA 904160 LAR 2 - CEU AZUL 904161 LAR 3 - SAO MIGUEL 904162 LAR 10 - SAO MIGUEL 904163 LAR 8 - SANTA HELENA 904442 LAR CE SUL 46242651 909608 LAR CE SUL 19729944 909609 LAR CE SUL 38614677 909610 LAR CE SUL 99564009 909618 LAR CE SUL 20772394 909619 LAR CE SUL 814 909620 LAR CE SUL 19701225 909631 LAR CE SUL IGUATEMI 909719 LAR CE SUL 19745710 910215 LAR CE SUL 19745702 910514 LAR CE SECO 11202874 909701 LAR CE SECO 31883907 909702 LAR CE SECO 31920659 909703 LAR CE SECO 32545444 909704 LAR CE SECO 90011295 909705 LAR CE SECO 90011287 909706 LAR CE SECO 90013701 909707 LAR SE SECO 90011368 909708 LAR CE SECO 90008669 909709 LAR CE SECO 14753758 909720 LAR CE SECO 31883893 909721 LAR CE SECO 90009037 909722 LAR CE SECO 9000957 909723 LAR CE SECO 90001320 909724 LAR CE SECO 90019750 909725"},{"id":"acf631b8-290d-4d74-608d-08d5ad2bf6ba","name":"FRIMESA COOPERATIVA CENTRAL","commercialName":"FRIMESA","cnpj":"77595395000147","city":"MEDIANEIRA","stateCode":"PR","buscaAdicional":"FRIMESA 53585 FRIMESA 1 905513 FRIMESA 3 905517 FRIMESA 2 905520"},{"id":"38873a3e-9dc1-4f7f-623a-08d5ad2bf6ba","name":"TEMPERMED INDUSTRIA E COMERCIO DE VIDROS LTDA","commercialName":"TEMPERMED","cnpj":"02148510000136","city":"MEDIANEIRA","stateCode":"PR","buscaAdicional":"TEMPERMED 54628 OMEGA 905260 TEMPERMED 905261"},{"id":"969401c0-79dd-4241-6870-08d5ad2bf6ba","name":"NINFA INDUSTRIA DE ALIMENTOS LTDA","commercialName":"","cnpj":"78099777000142","city":"MEDIANEIRA","stateCode":"PR","buscaAdicional":"NINFA ALIMENTOS 60036 NINFA ALIMENTOS 910523"},{"id":"83161dd1-60ab-4e25-5f82-08d5ad2bf6ba","name":"FRIGORIFICO BIG BOI - EIRELI","commercialName":"","cnpj":"13373017000136","city":"PAIÇANDU","stateCode":"PR","buscaAdicional":"FRIGORIFICO BIG BOI 53004 FRIGORIFICO BIG BOI 905051"},{"id":"2ecbc1e6-6342-4e9f-5e5f-08d5ad2bf6ba","name":"INDUSTRIAL ARBHORES COMPENSADOS - EIRELI","commercialName":"INDUSTRIAL ARBHORES","cnpj":"10887398000183","city":"PALMAS","stateCode":"PR","buscaAdicional":"ARBHORES COMPENSADOS 52343 ARBHORES COMPENSADOS 902629"},{"id":"09827481-77b7-4b80-5e62-08d5ad2bf6ba","name":"MARINI INDUSTRIA DE COMPENSADOS LTDA","commercialName":"MARINI COMPENSADOS","cnpj":"05552102000133","city":"PALMAS","stateCode":"PR","buscaAdicional":"MARINI COMPENSADOS 52346 MARINI COMPENSADOS 902624"},{"id":"005fb5fd-c3e7-43b4-5e65-08d5ad2bf6ba","name":"REFLORASUL AGROFLORESTAL S.A","commercialName":"REFLORA-SUL","cnpj":"80362601000183","city":"PALMAS","stateCode":"PR","buscaAdicional":"REFLORASUL 52350 REFLORASUL 901044"},{"id":"2d7f3581-734d-456c-5b58-08d5ad2bf6ba","name":"INDUSTRIA DE COMPENSADOS SUDATI LTDA","commercialName":"","cnpj":"02314153000139","city":"PALMAS","stateCode":"PR","buscaAdicional":"SUDPLY 50618 VENTANIA SUDPLY 897681 SUDPLY PALMAS 897746 SUDATI BARRO PRETO 897907 IBAITI SUDPLY 898038 SUDATI TELEMACO BORB 909891"},{"id":"5f98fb84-ea8b-437b-555f-08d5ad2bf6ba","name":"INDUSTRIA DE COMPENSADOS GUARARAPES LTDA","commercialName":"COMPENSADOS GUARARAPES","cnpj":"77911261000198","city":"PALMAS","stateCode":"PR","buscaAdicional":"GUARARAPES PALMAS 5469 GUARARAPES-PALMAS PR 71812"},{"id":"ac44adb2-78bb-4689-5c91-08d5ad2bf6ba","name":"HUHTAMAKI DO BRASIL LTDA.","commercialName":"","cnpj":"82618455000563","city":"PALMEIRA","stateCode":"PR","buscaAdicional":"HUHTAMAKI FILIAL 51385 HUHTAMAKI F 899228"},{"id":"dc282dae-7f2d-46d6-5ff7-08d5ad2bf6ba","name":"ITESAPAR FUNDICAO S.A.","commercialName":"ITESAPAR FUNDICAO S.A","cnpj":"17578354000110","city":"PALMEIRA","stateCode":"PR","buscaAdicional":"ITESAPAR 53317 ITESAPAR FUNDICAO 901314"},{"id":"49590618-1c4e-4d1e-61ec-08d5ad2bf6ba","name":"INDUSTRIA PAPELEIRA CIDADE CLIMA LTDA.","commercialName":"CLIMAPEL","cnpj":"09303344000144","city":"PALMEIRA","stateCode":"PR","buscaAdicional":"CLIMAPEL 54471 CLIMAPEL 906217"},{"id":"4bc267cd-2a7f-4cbd-6416-08d5ad2bf6ba","name":"BASTON INDUSTRIA DE AEROSSOIS LTDA","commercialName":"BASTON AEROSSOL","cnpj":"05855974000170","city":"PALMEIRA","stateCode":"PR","buscaAdicional":"BASTON 55837 BASTON AEROSOL 910573"},{"id":"73452e82-d184-4aa6-60d4-08d5ad2bf6ba","name":"C.VALE - COOPERATIVA AGROINDUSTRIAL","commercialName":"C.VALE","cnpj":"77863223004366","city":"PALOTINA","stateCode":"PR","buscaAdicional":"CVALE 53751 CVALE - PALOTINA PR 907273"},{"id":"8d5019b0-dedc-4063-5207-08d5ad2bf6ba","name":"USINA DE ACUCAR SANTA TEREZINHA LTDA","commercialName":"","cnpj":"75717355000286","city":"PARANACITY","stateCode":"PR","buscaAdicional":"USA PARANACITY 2803 STEREZIN(PARANACITY) 8562 UTE.AI.PR.028139-5.01"},{"id":"66de30d7-d779-4d44-5251-08d5ad2bf6ba","name":"FERTILIZANTES HERINGER S.A.","commercialName":"","cnpj":"22266175003101","city":"PARANAGUÁ","stateCode":"PR","buscaAdicional":"HERINGER-PGA 3000 HERINGER RC 70853 HERINGER 8613 UTE.PE.PR.029927-8.01"},{"id":"b067bbfa-50ec-41ca-56ab-08d5ad2bf6ba","name":"FOSPAR S/A","commercialName":"","cnpj":"76204130000108","city":"PARANAGUÁ","stateCode":"PR","buscaAdicional":"FOSPAR 7482 FOSPAR PARANAGUA 72361 FOSPAR TERMINAL 910522"},{"id":"9f1f6f1e-d3ef-4710-5ed4-08d5ad2bf6ba","name":"TERMINAL PORTUARIO SEARA S/A","commercialName":"TERMINAL SEARA","cnpj":"15135897000138","city":"PARANAGUÁ","stateCode":"PR","buscaAdicional":"TERM PARANAGUA 52571 TERMINAL PARANAGUA 903221"},{"id":"0f436cec-3f5c-4e67-5855-08d5ad2bf6ba","name":"TCP - TERMINAL DE CONTEINERES DE PARANAGUA S/A","commercialName":"","cnpj":"12919786000124","city":"PARANAGUÁ","stateCode":"PR","buscaAdicional":"TCP 11371 TCP PARANAGUA 1 889959 TCP PARANAGUA 2 889998"},{"id":"278694ee-4d5b-4cc4-648b-08d5ad2bf6ba","name":"MARTINI MEAT S/A ARMAZENS GERAIS","commercialName":"MARTINI MEAT","cnpj":"75294801000106","city":"PARANAGUÁ","stateCode":"PR","buscaAdicional":"MARTINIMEAT PR 56081 MARTINI MEAT 907673 MARTINI MEAT ARMAZEM 907722 MARTINI MEAT ARMAZEN 907893"},{"id":"4ef7b7ae-b2fe-4013-6289-08d5ad2bf6ba","name":"MINERACAO NOVA PRATA LTDA","commercialName":"NOVA PRATA MINERACAO","cnpj":"82514795000110","city":"PARANAGUÁ","stateCode":"PR","buscaAdicional":"NOVA PRATA 54796 MINERACAO NOVA PRATA 906017"},{"id":"a3b8b7a8-7571-445d-62fc-08d5ad2bf6ba","name":"CATTALINI TERMINAIS MARITIMOS S.A.","commercialName":"TERMINAIS","cnpj":"75633560000182","city":"PARANAGUÁ","stateCode":"PR","buscaAdicional":"CATTALINI 55068 CATTALINI MATRIZ 905998 CATTALINI CT3A 906002 CATTALINI CT2 906031 CATTALINI CT3B 906035"},{"id":"8d0afc5b-2ee4-42f7-621d-08d5ad2bf6ba","name":"AGROINDUSTRIAL E COMERCIAL DERIMAM LTDA","commercialName":"DERIMAM","cnpj":"08326364000178","city":"PARANAVAÍ","stateCode":"PR","buscaAdicional":"DERIMAM 54572 DERIMAM UC 92580858 907245"},{"id":"9b0d5ad4-7582-4c7b-66c9-08d5ad2bf6ba","name":"CITRI AGROINDUSTRIAL S/A","commercialName":"","cnpj":"04040239000146","city":"PARANAVAÍ","stateCode":"PR","buscaAdicional":"CITRI 57815 CITRI - CM3 908678 CITRI 909689"},{"id":"ce9cc3df-13e3-4d3c-88fa-08d5ae44ed50","name":"CM3 COOPERATIVA AGROINDUSTRIAL","commercialName":"","cnpj":"07326636000177","city":"PARANAVAÍ","stateCode":"PR","buscaAdicional":"CM3 57758"},{"id":"0e08eeb3-a042-49de-5d6e-08d5ad2bf6ba","name":"INDEMIL INDUSTRIA E COMERCIO S/A","commercialName":"","cnpj":"61887899000109","city":"PARANAVAÍ","stateCode":"PR","buscaAdicional":"INDEMIL 51817 INDEMIL GUAIRA 899744 INDEMIL PARANAVAI 901058"},{"id":"c6caa761-58f2-407a-5e82-08d5ad2bf6ba","name":"INPLASUL INDUSTRIA DE PLASTICOS SUDOESTE LTDA","commercialName":"","cnpj":"75635144000113","city":"PATO BRANCO","stateCode":"PR","buscaAdicional":"INPLASUL 52410 INPLASUL 899746"},{"id":"46f50f62-204f-4b2e-5e80-08d5ad2bf6ba","name":"ATLAS INDUSTRIA DE ELETRODOMESTICOS LTDA.","commercialName":"ATLAS ELETRODOMESTICOS","cnpj":"78242849000169","city":"PATO BRANCO","stateCode":"PR","buscaAdicional":"ATLAS INDUSTRIA 52404 ATLAS INDUSTRIA 899753"},{"id":"5c15dc72-c9d7-423d-5e73-08d5ad2bf6ba","name":"FERSUL MANUFATURADOS DE FERRO LTDA","commercialName":"","cnpj":"04589908000133","city":"PATO BRANCO","stateCode":"PR","buscaAdicional":"FERSUL 52388 FERSUL MANUFATURADOS 899912"},{"id":"dd647b15-b6d2-439e-5e74-08d5ad2bf6ba","name":"ARAMART INDUSTRIA DE ARAMADOS LTDA","commercialName":"ARAMART INDUSTRIA DE ARAMADOS LTDA","cnpj":"13416922000398","city":"PATO BRANCO","stateCode":"PR","buscaAdicional":"ARAMART FILIAL II 52389 ARAMART FILIAL II 899780"},{"id":"fe558333-4c0d-4e51-5fc0-08d5ad2bf6ba","name":"AVICOLA PATO BRANCO LTDA","commercialName":"","cnpj":"79865366000183","city":"PATO BRANCO","stateCode":"PR","buscaAdicional":"PATO BRANCO AVIC 53208 AVICOLA PATO BRANCO 900006"},{"id":"f219d67d-eda1-4b03-63b1-08d5ad2bf6ba","name":"ASSOCIACAO PATOBRANQUENSE DE ENSINO SUPERIOR S.C. LTDA","commercialName":"","cnpj":"03420225000195","city":"PATO BRANCO","stateCode":"PR","buscaAdicional":"FADEP 55527 ASSOC PATOBRANQUENSE 905496"},{"id":"00a52083-13ae-404a-5c26-08d5ad2bf6ba","name":"FAMOSSUL MADEIRAS S/A","commercialName":"FAMOSSUL","cnpj":"75190983000175","city":"PIÊN","stateCode":"PR","buscaAdicional":"FAMOSSUL 51119 FAMOSSUL 899180 FAMOSSUL MADEIRAS 899600"},{"id":"16023fb8-5037-452c-5574-08d5ad2bf6ba","name":"TIMBER CREEK FARMS, INDUSTRIAL, COMERCIAL, IMPORTACAO E EXPORTACAO S/A.","commercialName":"TCF PELLETS","cnpj":"10435853000100","city":"PIÊN","stateCode":"PR","buscaAdicional":"TIMBER 5630 TIMBER CREEK 901040"},{"id":"a37e85f7-c90b-491d-5707-08d5ad2bf6ba","name":"GRAFFO PARANAENSE DE EMBALAGENS S.A.","commercialName":"","cnpj":"04676488000122","city":"PINHAIS","stateCode":"PR","buscaAdicional":"GRAFFO 8162 GRAFFO - PINHAIS PR 888116"},{"id":"638117c9-7b00-4eab-5bd1-08d5ad2bf6ba","name":"PLAST & PACK INDUSTRIA E COMERCIO LTDA","commercialName":"PLAST & PACK","cnpj":"01875588000190","city":"PINHAIS","stateCode":"PR","buscaAdicional":"PLAST & PACK 50935 PLAST & PACK - CAMP 899588"},{"id":"794ba970-3d2e-4d87-5b0a-08d5ad2bf6ba","name":"MADEIREIRA BASE SOLIDA DO BRASIL - EIRELI","commercialName":"MBS DO BRASIL","cnpj":"04308184000102","city":"PINHAIS","stateCode":"PR","buscaAdicional":"UTE CONSELVAN 50399 UTE CONSELVAN 898148 UTE.FL.MT.030928-1.01"},{"id":"8586fbff-4ebb-462b-5f1b-08d5ad2bf6ba","name":"COMP - INDUSTRIA E COMERCIO DE METAIS LTDA","commercialName":"","cnpj":"82439134000178","city":"PINHAIS","stateCode":"PR","buscaAdicional":"COMP METAIS 52745 COMP METAIS 900658"},{"id":"92eae4df-4237-4fb8-5cef-08d5ad2bf6ba","name":"STOCK TECH S.A. ARMAZENS GERAIS","commercialName":"COMFRIO SOLUCOES LOGISTICAS","cnpj":"01306014000109","city":"PINHAIS","stateCode":"PR","buscaAdicional":"STOCK TECH 51617 STOCK TECH - PINHAIS 901516 STOCK TECH - CAUCAIA 908339"},{"id":"33421649-7938-4b07-628f-08d5ad2bf6ba","name":"GEMALTO DO BRASIL CARTOES E TERMINAIS LTDA.","commercialName":"","cnpj":"01586633000196","city":"PINHAIS","stateCode":"PR","buscaAdicional":"GEMALTO 54803 GEMALTO BR CARTOES 906857"},{"id":"6437e7af-1061-4109-6627-08d5ad2bf6ba","name":"PRAXAIR SURFACE TECHNOLOGIES DO BRASIL LTDA","commercialName":"PRAXAIR","cnpj":"77679686000113","city":"PINHAIS","stateCode":"PR","buscaAdicional":"PRAXAIR 57375 PRAXAIR UC 30477310 908149"},{"id":"1913fa28-fdfa-42a5-88bf-08d5ae44ed50","name":"REFORPAN INDUSTRIA E COMERCIO DE PRODUTOS ALIMENTICIOS LTDA","commercialName":"REFORPAN INDUSTRIA E COMERCIO DE PRODUTOS ALIMENTICIOS","cnpj":"09274367000259","city":"PIRAQUARA","stateCode":"PR","buscaAdicional":"REFORPAN PIRAQUARA 50693"},{"id":"2d5df840-c5ed-4aa7-56f1-08d5ad2bf6ba","name":"PLASTIC OMNIUM AUTO INERGY DO BRASIL LTDA.","commercialName":"","cnpj":"02814286000255","city":"PIRAQUARA","stateCode":"PR","buscaAdicional":"INERGY 8004 INERGY PR 888137"},{"id":"1c99c6c5-b8e2-4ce5-57da-08d5ad2bf6ba","name":"ITAGUACU ENERGIA S/A","commercialName":"ITAGUACU","cnpj":"04971987000142","city":"PITANGA","stateCode":"PR","buscaAdicional":"ITAGUACU 9772 ITAGUACU 890439 PCH.PH.PR.028921-3.01"},{"id":"fe1c54f3-aacf-40c3-61c8-08d5ad2bf6ba","name":"FRIGODASKO INDUSTRIA E COMERCIO DE CARNES LTDA.","commercialName":"FRIGODASKO","cnpj":"08916434000148","city":"PITANGA","stateCode":"PR","buscaAdicional":"FRIGODASKO 54426 FRIGODASKO 81090382 906044"},{"id":"2b949b1b-c1ba-42b1-6356-08d5ad2bf6ba","name":"CONTINENTAL DO BRASIL PRODUTOS AUTOMOTIVOS LTDA","commercialName":"","cnpj":"02036483000290","city":"PONTA GROSSA","stateCode":"PR","buscaAdicional":"CONTINENTAL PG 55320 CONTINENTAL PONTA GR 903796"},{"id":"4f409a57-91a1-42bb-638e-08d5ad2bf6ba","name":"METALGRAFICA IGUACU S A","commercialName":"","cnpj":"80227184000166","city":"PONTA GROSSA","stateCode":"PR","buscaAdicional":"METAL IGUACU PG 55464 METALGRAFICA IGUACU 907411"},{"id":"ecaf73f1-179f-4819-661e-08d5ad2bf6ba","name":"L'ACQUA LAVANDERIAS LTDA","commercialName":"L'ACQUA LAVANDERIAS","cnpj":"04573039000159","city":"PONTA GROSSA","stateCode":"PR","buscaAdicional":"LACQUA 57316 LACQUA LAVANDERIAS 908167"},{"id":"799f7350-5ded-4061-6625-08d5ad2bf6ba","name":"DURSKI INDUSTRIA E COMERCIO S.A.","commercialName":"GRUPO DURSKI","cnpj":"13783221000478","city":"PONTA GROSSA","stateCode":"PR","buscaAdicional":"MADERO 57372 MADERO IND E COM SA 907938"},{"id":"2e31b225-6c09-47f1-6659-08d5ad2bf6ba","name":"PONTA GROSSA ADMINISTRADORA DE SHOPPING CENTERS LTDA","commercialName":"","cnpj":"04013911000104","city":"PONTA GROSSA","stateCode":"PR","buscaAdicional":"PALLADIUM PONTA GROSSA 57507 PONTA GROSSA SHOP AD 909233"},{"id":"2c1301f9-d296-4c3d-7244-08d5cf600bef","name":"RODONORTE - CONCESSIONARIA DE RODOVIAS INTEGRADAS S/A","commercialName":"","cnpj":"02221531000130","city":"PONTA GROSSA","stateCode":"PR","buscaAdicional":""},{"id":"6fed046b-364a-4257-5216-08d5ad2bf6ba","name":"L.P BRASIL OSB INDUSTRIA E COMERCIO S.A.","commercialName":"","cnpj":"09408913000116","city":"PONTA GROSSA","stateCode":"PR","buscaAdicional":"LP BRASIL 2865 LP PONTA GROSSA 70774"},{"id":"9dc69100-ab19-4717-4fe2-08d5ad2bf6ba","name":"ARAUCO INDUSTRIA DE PAINEIS LTDA","commercialName":"","cnpj":"00606549000124","city":"PONTA GROSSA","stateCode":"PR","buscaAdicional":"ARAUCO PAINEIS 1332 MASISA-PONTA GROSSA 7817 MASISA 889388"},{"id":"92cebc14-c457-4550-5f39-08d5ad2bf6ba","name":"W3 INDUSTRIA METALURGICA LTDA","commercialName":"","cnpj":"81114803000179","city":"PONTA GROSSA","stateCode":"PR","buscaAdicional":"W3 METALURGICA 52851 W3 903813"},{"id":"ad4fa500-8599-4623-5fd4-08d5ad2bf6ba","name":"TOZETTO & CIA LTDA","commercialName":"SUPERMERCADOS TOZETTO","cnpj":"80221013000120","city":"PONTA GROSSA","stateCode":"PR","buscaAdicional":"TOZETTO 53237 TOZETTO AMAZONAS 904439 TOZETTO CARLOS CAVAL 904440 TOZETTO MONTEIRO LOB 904441 TOZETTO ERNESTO V. 904457 TOZETTO DR FRANCO G. 904458"},{"id":"f4ca345f-dba0-4744-60ce-08d5ad2bf6ba","name":"CROWN EMBALAGENS METALICAS DA AMAZONIA S/A","commercialName":"CROWN PTA GROSSA","cnpj":"33174335001076","city":"PONTA GROSSA","stateCode":"PR","buscaAdicional":"CROWN EMBALAGENS 53743 CROWN PG 905262"},{"id":"403e952b-ed75-4cf6-60ab-08d5ad2bf6ba","name":"AGUIA SISTEMAS DE ARMAZENAGEM S/A","commercialName":"","cnpj":"81075137000107","city":"PONTA GROSSA","stateCode":"PR","buscaAdicional":"AGUIA 53630 AGUIA SIST ARMAZENAG 906216 AGUIA SIST ARMAZ II 906237"},{"id":"3a5a0116-6340-496d-60b3-08d5ad2bf6ba","name":"DAF CAMINHOES BRASIL INDUSTRIA LTDA.","commercialName":"DAF BRASIL","cnpj":"13114506000173","city":"PONTA GROSSA","stateCode":"PR","buscaAdicional":"DAF CAMINHOES 53642 DAF CAMINHOES 910369"},{"id":"2ec5dccc-e9cd-40b2-601a-08d5ad2bf6ba","name":"OMYA DO BRASIL IMPORTACAO, EXPORTACAO E COMERCIO DE MINERAIS LTDA.","commercialName":"","cnpj":"05969945000130","city":"PONTA GROSSA","stateCode":"PR","buscaAdicional":"OMYA 53378 OMYA - PTA GROSSA 903772"},{"id":"5152d7e2-00b6-4ccd-6051-08d5ad2bf6ba","name":"MAKITA DO BRASIL FERRAMENTAS ELETRICAS LTDA","commercialName":"MAKITA","cnpj":"45865920000615","city":"PONTA GROSSA","stateCode":"PR","buscaAdicional":"MAKITA 53464 MAKITA 905048"},{"id":"2e8c5173-3aae-43b1-5b01-08d5ad2bf6ba","name":"MOINHO CIDADE BELLA LTDA","commercialName":"MOINHO CIDADE BELLA","cnpj":"05444083000121","city":"PONTA GROSSA","stateCode":"PR","buscaAdicional":"MOINHO CIDADE BELLA 50384 MOINHO CID BELLA 898264"},{"id":"07c4be43-b448-41a6-5b5b-08d5ad2bf6ba","name":"SGS AGRICULTURA E INDUSTRIA LTDA","commercialName":"","cnpj":"88370945000146","city":"PONTA GROSSA","stateCode":"PR","buscaAdicional":"SGS AGRICULTURA E INDUSTRIA 50621 SGS AGRICULTURA PR 898533"},{"id":"0baaaee5-c800-47cf-5aa7-08d5ad2bf6ba","name":"CARGILL AGRICOLA S A","commercialName":"","cnpj":"60498706004144","city":"PONTA GROSSA","stateCode":"PR","buscaAdicional":"CARGILL PGO 50137 CARGILL AGRICOLA PR 897671"},{"id":"f264f521-3301-40af-5ab4-08d5ad2bf6ba","name":"KURASHIKI DO BRASIL TEXTIL LTDA.","commercialName":"KURASHIKI","cnpj":"89729156000464","city":"PONTA GROSSA","stateCode":"PR","buscaAdicional":"KURASHIKI II 50192 KURASHIKI 897244"},{"id":"8cac62c5-2edb-44c8-5c41-08d5ad2bf6ba","name":"METALURGICA SCHWARZ S/A","commercialName":"","cnpj":"72242621000192","city":"QUATRO BARRAS","stateCode":"PR","buscaAdicional":"SCHWARZ 51232 METALURGICA SCHWARZ 899606"},{"id":"68e05ffd-c1d9-4192-5c87-08d5ad2bf6ba","name":"METALKRAFT S/A SISTEMAS AUTOMOTIVOS","commercialName":"","cnpj":"77529584000111","city":"QUATRO BARRAS","stateCode":"PR","buscaAdicional":"METALKRAFT 51371 METALKRAFT 899429"},{"id":"f642e783-b6b7-4bd0-5fde-08d5ad2bf6ba","name":"ZIVALPLAST INDUSTRIA E COMERCIO DE PLASTICOS LTDA","commercialName":"ZIVALPLAST","cnpj":"02266944000130","city":"QUATRO BARRAS","stateCode":"PR","buscaAdicional":"ZIVALPLAST 53251 ZIVALPLAST PLASTICOS 904437"},{"id":"cc6c7fdb-d4c6-40aa-5e44-08d5ad2bf6ba","name":"IBQ - INDUSTRIAS QUIMICAS S/A","commercialName":"","cnpj":"78391612000140","city":"QUATRO BARRAS","stateCode":"PR","buscaAdicional":"IBQ 52307 IBQ - QUATRO BARRAS 902679"},{"id":"a7548723-8e0f-4421-57e7-08d5ad2bf6ba","name":"FAURECIA AUTOMOTIVE DO BRASIL LTDA","commercialName":"BERTRAND FAURE","cnpj":"01178298000197","city":"QUATRO BARRAS","stateCode":"PR","buscaAdicional":"FAURECIA QB 10009 FAURECIA QB 899576 FAURECIA PTR INT 907801 FAURECIA PTR BANCOS 907829"},{"id":"2960f0bc-3604-4f4a-7281-08d5cf600bef","name":"DTCOM DIRECT TO COMPANY S/A.","commercialName":"","cnpj":"03303999000136","city":"QUATRO BARRAS","stateCode":"PR","buscaAdicional":""},{"id":"742d9044-ac71-4648-6181-08d5ad2bf6ba","name":"IBERSUL INDUSTRIA DE PAPEL E CELULOSE LTDA","commercialName":"IBERSUL","cnpj":"08988218000108","city":"QUEDAS DO IGUAÇU","stateCode":"PR","buscaAdicional":"IBERSUL 54215 IBERSUL 905182"},{"id":"334c698f-2c07-42d6-6096-08d5ad2bf6ba","name":"ARAUPEL S.A.","commercialName":"MANUFATURADO","cnpj":"87102810001028","city":"QUEDAS DO IGUAÇU","stateCode":"PR","buscaAdicional":"ARAUPEL MANUFATURADO 53608 ARAUPEL 905183"},{"id":"82305a7b-d7fa-4e6d-62e8-08d5ad2bf6ba","name":"LATICINIOS CAROLINA LTDA","commercialName":"LATICINIOS CAROLINA","cnpj":"77655009000165","city":"RIBEIRÃO CLARO","stateCode":"PR","buscaAdicional":"LATCAROLINA 55029 LATICINIOS CAROLINA 904327"},{"id":"503eeb3b-d48f-4450-61c9-08d5ad2bf6ba","name":"MINERACAO RIO BRANCO DO SUL LTDA","commercialName":"MINERACAO RIO BRANCO","cnpj":"78420718000124","city":"RIO BRANCO DO SUL","stateCode":"PR","buscaAdicional":"MINERACAO RIO BRANCO 54427 RIO BRANCO 79001076 906052"},{"id":"3ad0e769-81e2-4cad-63de-08d5ad2bf6ba","name":"SOUZA CRUZ LTDA","commercialName":"","cnpj":"33009911008385","city":"RIO NEGRO","stateCode":"PR","buscaAdicional":"SOUZA CRUZ RIO NEGRO 55688 SOUZA CRUZ RIO NEGRO 906523"},{"id":"aa1f0358-9a33-45ed-72f4-08d5cf600bef","name":"AUTOPISTA PLANALTO SUL S.A.","commercialName":"","cnpj":"09325109000173","city":"RIO NEGRO","stateCode":"PR","buscaAdicional":""},{"id":"94d99635-89de-460c-5fdf-08d5ad2bf6ba","name":"AGM INDUSTRIA E COMERCIO DE EMBALAGENS LTDA","commercialName":"A G M","cnpj":"01070163000103","city":"RIO NEGRO","stateCode":"PR","buscaAdicional":"AGM 53252 AGM EMBALAGENS 900774"},{"id":"cebb145c-6610-4947-5dda-08d5ad2bf6ba","name":"VIDRACARIA LINDE LTDA","commercialName":"","cnpj":"83743138000108","city":"RIO NEGRO","stateCode":"PR","buscaAdicional":"LINDE VIDROS 52025 LINDE 899807 VIDRACARIA LINDE 900553"},{"id":"b409ec33-ff78-42f5-5e97-08d5ad2bf6ba","name":"M. E. GONCALVES INDUSTRIA DE MOVEIS LTDA.","commercialName":"ESTOFADOS ESTRELA","cnpj":"75394502000143","city":"ROLÂNDIA","stateCode":"PR","buscaAdicional":"ME GONCALVES 52457 ME GONCALVES 902701"},{"id":"d84a52d1-2de1-4833-5d90-08d5ad2bf6ba","name":"DALLON PLASTICOS LTDA","commercialName":"","cnpj":"08393617000126","city":"ROLÂNDIA","stateCode":"PR","buscaAdicional":"DALLON PLASTICOS 51921 DALLON PLASTICOS 900076"},{"id":"cf63dbcd-ab9d-46dd-6001-08d5ad2bf6ba","name":"TEMPERLANDIA TEMPERA VIDROLANDIA LTDA","commercialName":"","cnpj":"03309277000199","city":"ROLÂNDIA","stateCode":"PR","buscaAdicional":"TEMPERLANDIA 53337 TEMPERLANDIA TEMPERA 903096"},{"id":"26aa8c37-1ca0-4a9b-5c86-08d5ad2bf6ba","name":"INDUSTRIA E COMERCIO DE COUROS INTERNACIONAL LTDA.","commercialName":"INTERNACIONAL COUROS","cnpj":"07143575000102","city":"ROLÂNDIA","stateCode":"PR","buscaAdicional":"INTERNACIONAL 51370 COUROS INTERNACIONAL 900699"},{"id":"cfeb1768-5f0c-4f4e-5c7d-08d5ad2bf6ba","name":"VANCOUROS INDUSTRIA E COMERCIO DE COUROS LTDA.","commercialName":"VANCOUROS","cnpj":"03731287000118","city":"ROLÂNDIA","stateCode":"PR","buscaAdicional":"VANCOUROS 51349 VANCOUROS 900877"},{"id":"33f9d504-b67b-4c1d-63ea-08d5ad2bf6ba","name":"GRANJEIRO ALIMENTOS LTDA","commercialName":"","cnpj":"81035388000168","city":"ROLÂNDIA","stateCode":"PR","buscaAdicional":"GRANJEIRO 55715 GRANJEIRO FRIGORIFIC 907400 GRANJEIRO ALIMENTOS 907399"},{"id":"b2d30353-ab39-4073-64de-08d5ad2bf6ba","name":"AGRICOLA JANDELLE S/A","commercialName":"AGRICOLA JANDELLE S/A","cnpj":"74101569002476","city":"ROLÂNDIA","stateCode":"PR","buscaAdicional":"JANDELE MATRIZ 56286 JANDELLE ROLANDIA 904359 JANDELLE ROLANDIA 906426 JANDELLE INCUB ROL 908308 JANDELLE 889253 AVEBOM - JAGUAPITA 899287 JANDELLE STO INACIO 908622"},{"id":"aa11e948-424a-498e-655b-08d5ad2bf6ba","name":"ITAMARATY INDUSTRIA E COMERCIO S/A","commercialName":"ITAMARATY","cnpj":"75222901000127","city":"ROLÂNDIA","stateCode":"PR","buscaAdicional":"ITAMARATY 56672 ITAMARATY IND E COM 907401"},{"id":"c8e890ac-4d1f-45fb-628d-08d5ad2bf6ba","name":"EUROFRAL INDUSTRIA DE PRODUTOS HIGIENICOS E TERMOPLASTICOS LTDA","commercialName":"EUROFRAL","cnpj":"07125645000108","city":"ROLÂNDIA","stateCode":"PR","buscaAdicional":"EUROFRAL 54801 EUROFRAL 905046"},{"id":"9ae32228-b98a-4577-6588-08d5ad2bf6ba","name":"M DIAS BRANCO S.A. INDUSTRIA E COMERCIO DE ALIMENTOS","commercialName":"","cnpj":"07206816006237","city":"ROLÂNDIA","stateCode":"PR","buscaAdicional":"MDB PARANA 56809 M DIAS BRANCO IND CO 907646"},{"id":"f7b2cb70-a88e-4515-8881-08d5ae44ed50","name":"AGRICOLA JANDELLE S/A","commercialName":"JANDELLE","cnpj":"74101569000341","city":"ROLÂNDIA","stateCode":"PR","buscaAdicional":"JANDELLE 9469"},{"id":"0167975b-3bad-493f-60a1-08d5ad2bf6ba","name":"BARRA VELHA INDUSTRIAL LTDA","commercialName":"INDUSTRIA BARRA VELHA","cnpj":"03028278000165","city":"RONDON","stateCode":"PR","buscaAdicional":"BARRA VELHA ALIMENTOS 53620 BARRA VELHA ALIMENTO 905044"},{"id":"42ba7fb5-9b1a-467c-5df9-08d5ad2bf6ba","name":"SANTA FE ENERGETICA LTDA","commercialName":"","cnpj":"05932450000136","city":"SANTA FÉ","stateCode":"PR","buscaAdicional":"PCH SALTO BANDEIRANTES 52096 PCH SALTO BANDEIRANT 906139 PCH.PH.PR.029686-4.01"},{"id":"68482ce5-d388-49c1-5307-08d5ad2bf6ba","name":"COESEX GERACAO DE ENERGIA LTDA","commercialName":"","cnpj":"10488784000100","city":"SANTA MARIA DO OESTE","stateCode":"PR","buscaAdicional":"COESEX 3443 SANTO EXPEDITO 8702 CGH.PH.PR.030186-8.01"},{"id":"078ba5b4-f563-45e7-5f5d-08d5ad2bf6ba","name":"JOPLLAM - INDUSTRIA E COMERCIO DE ALIMENTOS LTDA","commercialName":"JOPLLAM","cnpj":"05119521000186","city":"SANTA MÔNICA","stateCode":"PR","buscaAdicional":"JOPLLAM 52913 JOPLLAM STA MONICA 903814"},{"id":"3a7194d7-f292-4a38-5c29-08d5ad2bf6ba","name":"INFASA INDUSTRIA DE FARINHAS S.A.","commercialName":"","cnpj":"08220994000163","city":"SANTA TEREZA DO OESTE","stateCode":"PR","buscaAdicional":"INFASA 51122 INFASA 900660"},{"id":"2f37c28d-42e4-4301-6058-08d5ad2bf6ba","name":"COASUL COOPERATIVA AGROINDUSTRIAL","commercialName":"SAO JOAO - SEDE","cnpj":"79863569000130","city":"SÃO JOÃO","stateCode":"PR","buscaAdicional":"COASUL 53474 COASUL 2 905498 COASUL 1 - SAO JOAO 905495 COASUL 3 905516"},{"id":"f5e2f6f5-b071-4f74-605b-08d5ad2bf6ba","name":"SMP AUTOMOTIVE PRODUTOS AUTOMOTIVOS DO BRASIL LTDA.","commercialName":"","cnpj":"00786246000130","city":"SÃO JOSÉ DOS PINHAIS","stateCode":"PR","buscaAdicional":"SMP AUTOMOTIVE 53477 SMP AUTO PRODUTOS PR 903233 SMP AUTO PRODUTOS SP 903234"},{"id":"3030b844-3ce4-4a23-6035-08d5ad2bf6ba","name":"COMPORTA LTDA","commercialName":"","cnpj":"77048015000154","city":"SÃO JOSÉ DOS PINHAIS","stateCode":"PR","buscaAdicional":"COMPORTA 53424 COMPORTA 905057"},{"id":"08cd471b-fa19-4ed9-6033-08d5ad2bf6ba","name":"IP COMERCIO EXTERIOR LTDA","commercialName":"CARTOES MAIS BARATO","cnpj":"11795118000170","city":"SÃO JOSÉ DOS PINHAIS","stateCode":"PR","buscaAdicional":"IP-SJP 53422 IP-SJP COM EXTERIOR 904456"},{"id":"e132acff-62d0-441a-609c-08d5ad2bf6ba","name":"JTEKT AUTOMOTIVA BRASIL LTDA","commercialName":"","cnpj":"02638940000306","city":"SÃO JOSÉ DOS PINHAIS","stateCode":"PR","buscaAdicional":"JTEKT CE 53615 JTEKT S J PINHAIS 905258"},{"id":"04b6cd27-545f-4069-6084-08d5ad2bf6ba","name":"FRIGORIFICO ARGUS LTDA","commercialName":"","cnpj":"81304552000195","city":"SÃO JOSÉ DOS PINHAIS","stateCode":"PR","buscaAdicional":"ARGUS 53576 FRIGORIFICO ARGUS 902332 FRIGORIFICO ARGUS 85 907647"},{"id":"2424550a-aaf8-4e5f-5f36-08d5ad2bf6ba","name":"BROSE DO BRASIL LTDA","commercialName":"","cnpj":"02258243000150","city":"SÃO JOSÉ DOS PINHAIS","stateCode":"PR","buscaAdicional":"BROSE 52848 BROSE DO BRASIL 900783"},{"id":"218beaf6-60b9-46c1-5f1f-08d5ad2bf6ba","name":"JULIATTO,FOGGIATTO & CIA LTDA","commercialName":"FRIGORIFICO JULIATTO","cnpj":"80189178000161","city":"SÃO JOSÉ DOS PINHAIS","stateCode":"PR","buscaAdicional":"JULIATTO 52759 JULIATTO 904186"},{"id":"7efeaf66-18f4-42ee-5f07-08d5ad2bf6ba","name":"BOTICA COMERCIAL FARMACEUTICA LTDA","commercialName":"O BOTICARIO","cnpj":"77388007000157","city":"SÃO JOSÉ DOS PINHAIS","stateCode":"PR","buscaAdicional":"BOTICARIO 52712 BOTICA FARMACEUTICA 901090"},{"id":"591cbdc1-9f13-46f2-5f7c-08d5ad2bf6ba","name":"CAP LOGISTICA FRIGORIFICADA S.A.","commercialName":"CAP - CENTRAL DE ARMAZENAGEM PARANA LTDA","cnpj":"02956834000109","city":"SÃO JOSÉ DOS PINHAIS","stateCode":"PR","buscaAdicional":"CAP LOGISTICA 52996 CAP UC 41602544 904189 CAP UC 79201814 904190"},{"id":"27a25f13-4a03-4bb6-5dde-08d5ad2bf6ba","name":"PERIN PLASTICOS LTDA","commercialName":"","cnpj":"03260359000196","city":"SÃO JOSÉ DOS PINHAIS","stateCode":"PR","buscaAdicional":"PERIN 52029 PERIN S J PINHAIS 901533"},{"id":"61e5ce3f-d642-4173-5e9b-08d5ad2bf6ba","name":"ARTELY MOVEIS LTDA","commercialName":"ARTELY MOVEIS","cnpj":"01419940000182","city":"SÃO JOSÉ DOS PINHAIS","stateCode":"PR","buscaAdicional":"ARTELY MOVEIS 52462 ARTELY MOVEIS 903758"},{"id":"7659e17b-59dd-4a5d-5d5d-08d5ad2bf6ba","name":"MAGIUS METALURGICA INDUSTRIAL S/A.","commercialName":"","cnpj":"81312894000157","city":"SÃO JOSÉ DOS PINHAIS","stateCode":"PR","buscaAdicional":"MAGIUS 51798 MAGIUS METALURGICA 900644"},{"id":"f5ff702c-6345-4b09-5d00-08d5ad2bf6ba","name":"NORMATIC TRATAMENTOS TERMICOS LTDA.","commercialName":"","cnpj":"09394052000164","city":"SÃO JOSÉ DOS PINHAIS","stateCode":"PR","buscaAdicional":"NORMATIC 51674 NORMATIC 901045"},{"id":"b38dd71f-1764-4396-5c2c-08d5ad2bf6ba","name":"PLASFLEX INDUSTRIA E COMERCIO LTDA","commercialName":"PLASFLEX INDUSTRIA E COMERCIO LTDA","cnpj":"09041943000137","city":"SÃO JOSÉ DOS PINHAIS","stateCode":"PR","buscaAdicional":"PLASFLEX 51133 PLASFLEX 899788"},{"id":"0a494397-736e-4c3d-5c2d-08d5ad2bf6ba","name":"MULTILIT FIBROCIMENTO LTDA","commercialName":"","cnpj":"72071541000111","city":"SÃO JOSÉ DOS PINHAIS","stateCode":"PR","buscaAdicional":"FIBROCIMENTO 51134 FIBROCIMENTO 899770"},{"id":"45451155-6045-4bb9-5c2e-08d5ad2bf6ba","name":"MULTILIT INDUSTRIA E COMERCIO LTDA","commercialName":"","cnpj":"81067860000144","city":"SÃO JOSÉ DOS PINHAIS","stateCode":"PR","buscaAdicional":"MULTILIT 51135 MULTILIT 899733"},{"id":"b99baca4-98c6-4fa9-5c1a-08d5ad2bf6ba","name":"SIMOLDES PLASTICOS BRASIL LTDA.","commercialName":"","cnpj":"01640335000137","city":"SÃO JOSÉ DOS PINHAIS","stateCode":"PR","buscaAdicional":"SIMOLDES 51083 SIMOLDES 898991"},{"id":"3bf4872f-04dc-47aa-5c66-08d5ad2bf6ba","name":"TEMPER SUL - COMERCIO DE VIDROS LTDA","commercialName":"","cnpj":"10287442000114","city":"SÃO JOSÉ DOS PINHAIS","stateCode":"PR","buscaAdicional":"TEMPER SUL 51298 TEMPER SUL 899846"},{"id":"ac5f85de-b8e4-46a7-5ba2-08d5ad2bf6ba","name":"NUTRIMENTAL SA INDUSTRIA E COMERCIO DE ALIMENTOS","commercialName":"","cnpj":"76633890002699","city":"SÃO JOSÉ DOS PINHAIS","stateCode":"PR","buscaAdicional":"NUTRIMENTAL 50804 NUTRIMENTAL 898131"},{"id":"e0cd63bc-7dfb-48a4-5b96-08d5ad2bf6ba","name":"ZANINI DO BRASIL LTDA","commercialName":"","cnpj":"03209267000181","city":"SÃO JOSÉ DOS PINHAIS","stateCode":"PR","buscaAdicional":"ZANINI 50773 ZANINI DO BRASIL 899692"},{"id":"1c2cdfeb-aaf6-44e3-5b5e-08d5ad2bf6ba","name":"FAURECIA AUTOMOTIVE DO BRASIL LTDA","commercialName":"","cnpj":"01178298000600","city":"SÃO JOSÉ DOS PINHAIS","stateCode":"PR","buscaAdicional":"FAURECIA SJP 50631 FAURECIA SJP 898271"},{"id":"d6bc192d-ca9c-4ec6-5877-08d5ad2bf6ba","name":"GESTAMP BRASIL INDUSTRIA DE AUTOPECAS S/A","commercialName":"","cnpj":"02147467000194","city":"SÃO JOSÉ DOS PINHAIS","stateCode":"PR","buscaAdicional":"GESTAMP AUTOPECAS 11872 GESTAMP GRAVATAI II 890489 GESTAMP GRAVATAI I 891782 GESTAMP AUTOPECAS SP 899094 GESTAMP SANTA ISABEL 899993 GESTAMP TAUBATE II 900377 GESTAMP AUTOPECAS 902761"},{"id":"305ffac2-5675-42d4-5296-08d5ad2bf6ba","name":"RENAULT DO BRASIL S.A","commercialName":"","cnpj":"00913443000173","city":"SÃO JOSÉ DOS PINHAIS","stateCode":"PR","buscaAdicional":"RENAULT 3163 RENAULT-S.J PINHAIS 70951"},{"id":"2c47f987-99f8-4618-57ae-08d5ad2bf6ba","name":"COMPANHIA PROVIDENCIA INDUSTRIA E COMERCIO","commercialName":"","cnpj":"76500180000132","city":"SÃO JOSÉ DOS PINHAIS","stateCode":"PR","buscaAdicional":"PROVIDENCIA 9331 PROVIDENCIA 889085"},{"id":"bcf841e8-5e8f-4ae6-5650-08d5ad2bf6ba","name":"AMERICAN GLASS PRODUCTS DO BRASIL LTDA","commercialName":"AGP DO BRASIL","cnpj":"01483048000160","city":"SÃO JOSÉ DOS PINHAIS","stateCode":"PR","buscaAdicional":"AMERICAN GLASS 6897 AMERICAN GLASS SJPNH 72062"},{"id":"7a9b75b0-ddab-4476-54b8-08d5ad2bf6ba","name":"SHOPPING SAO JOSE LTDA","commercialName":"","cnpj":"76639798000188","city":"SÃO JOSÉ DOS PINHAIS","stateCode":"PR","buscaAdicional":"SHOPSAOJOSE 4459 SHOPPING SAO JOSE-PR 71656"},{"id":"02562081-d17b-40fa-680e-08d5ad2bf6ba","name":"BATZ LIGHTWEIGHT SYSTEMS DO BRASIL LTDA","commercialName":"","cnpj":"02226126000104","city":"SÃO JOSÉ DOS PINHAIS","stateCode":"PR","buscaAdicional":"BATZ 59299 BATZ - SAO JOSE PINH 909692"},{"id":"ebd38efb-a015-4bb6-65ac-08d5ad2bf6ba","name":"INTERPRINT DO BRASIL INDUSTRIA DE PAPEIS DECORATIVOS LTDA.","commercialName":"INTERPRINTDECOR","cnpj":"14119602000177","city":"SÃO JOSÉ DOS PINHAIS","stateCode":"PR","buscaAdicional":"INTERPRINT 56926 INTERPRINTDECOR 42 907681"},{"id":"4e132253-b82b-42f0-65bf-08d5ad2bf6ba","name":"PROADEC BRASIL LTDA","commercialName":"","cnpj":"03821074000187","city":"SÃO JOSÉ DOS PINHAIS","stateCode":"PR","buscaAdicional":"PROADEC 57050 PROADEC BRASIL 908177"},{"id":"be87a249-f7ed-4dda-6183-08d5ad2bf6ba","name":"KUHN-MONTANA INDUSTRIA DE MAQUINAS S/A","commercialName":"MONTANA","cnpj":"01186305000100","city":"SÃO JOSÉ DOS PINHAIS","stateCode":"PR","buscaAdicional":"KUHN MONTANA 54217 KUHN MONTANA IND MAQ 906488"},{"id":"0fae4385-47bf-4564-618b-08d5ad2bf6ba","name":"DACAR QUIMICA DO BRASIL S/A","commercialName":"","cnpj":"78949013000107","city":"SÃO JOSÉ DOS PINHAIS","stateCode":"PR","buscaAdicional":"DACAR 54230 DACAR QUIMICA 903079"},{"id":"d6f9500f-4503-4cb3-615f-08d5ad2bf6ba","name":"PLASMATON INDUSTRIA E COMERCIO DE PLASTICOS LTDA","commercialName":"","cnpj":"00697435000137","city":"SÃO JOSÉ DOS PINHAIS","stateCode":"PR","buscaAdicional":"PLASMATON 54156 PLASMATON 903769"},{"id":"b0750499-589c-4cc1-6501-08d5ad2bf6ba","name":"HUGO CINI SA INDUSTRIA DE BEBIDAS E CONEXOS","commercialName":"","cnpj":"76490572000168","city":"SÃO JOSÉ DOS PINHAIS","stateCode":"PR","buscaAdicional":"CINI 56371 HUGO CINI BEBIDAS 907410"},{"id":"0d225437-44e8-4787-64b6-08d5ad2bf6ba","name":"DURLICOUROS IND E COM DE COUROS, EXP E IMPORTACAO LTDA","commercialName":"BRASCOUROS","cnpj":"00105229000190","city":"SÃO JOSÉ DOS PINHAIS","stateCode":"PR","buscaAdicional":"DURLICOUROS PR 56173 DURLICOUROS PA 906609 DURLICOUROS TO 906625"},{"id":"4966b848-9942-4966-64b9-08d5ad2bf6ba","name":"CODIFLEX INDUSTRIA E COMERCIO DE MANUFATURADOS S/A","commercialName":"CODIFLEX","cnpj":"07714426000156","city":"SÃO JOSÉ DOS PINHAIS","stateCode":"PR","buscaAdicional":"CODIFLEX 56177 CODIFLEX 907649"},{"id":"8a629ef4-83a1-490c-648c-08d5ad2bf6ba","name":"MADEIRAS EULIDE LTDA","commercialName":"","cnpj":"77625762000108","city":"SÃO JOSÉ DOS PINHAIS","stateCode":"PR","buscaAdicional":"EULIDE 56083 MADEIRAS EULIDE 907295"},{"id":"3899b038-ed31-477c-7386-08d5cf600bef","name":"BATTISTELLA ADMINISTRACAO E PARTICIPACOES S/A","commercialName":"","cnpj":"42331462000131","city":"SÃO JOSÉ DOS PINHAIS","stateCode":"PR","buscaAdicional":""},{"id":"fc60931e-0ee0-4a64-73d2-08d5cf600bef","name":"BEMATECH S.A","commercialName":"","cnpj":"82373077000171","city":"SÃO JOSÉ DOS PINHAIS","stateCode":"PR","buscaAdicional":""},{"id":"1fff1f7e-af3f-40f6-675c-08d5ad2bf6ba","name":"CERAMICA CIDADE NOVA LTDA","commercialName":"CERAMICA CIDADE NOVA","cnpj":"02598520000173","city":"SAPOPEMA","stateCode":"PR","buscaAdicional":"CERAMICA CIDADE NOVA 58061 CERAMICA CIDADE NOVA 909234"},{"id":"20c08c19-f3bc-4b33-604b-08d5ad2bf6ba","name":"TR FUNDICAO DE FERRO E ACO LTDA","commercialName":"3E FOGOES","cnpj":"04617292000167","city":"SAUDADE DO IGUAÇU","stateCode":"PR","buscaAdicional":"TR FUNDICAO 53455 TR FUNDICAO 903779"},{"id":"f0ac2806-fbdc-4318-651d-08d5ad2bf6ba","name":"MIRALUZ IND E COM DE MADEIRAS LTDA","commercialName":"","cnpj":"75596106000107","city":"SENGÉS","stateCode":"PR","buscaAdicional":"MIRALUZ 56488 MIRALUZ 907648"},{"id":"7bec00d2-7540-4903-4ed9-08d5d159243d","name":"MALUI ILHA DO SOL EMPREENDIMENTOS IMOBILIARIOS SPE S.A.","commercialName":"MALUI ILHA DO SOL EMPREENDIMENTOS IMOBILIARIOS","cnpj":"12827269000125","city":"SERTANEJA","stateCode":"PR","buscaAdicional":""},{"id":"ffa086b9-a20b-4115-61ca-08d5ad2bf6ba","name":"L.C.A-IND.E COM. DE PRODUTOS ALIMENTICIOS LTDA","commercialName":"L.C.A.","cnpj":"80851439000167","city":"SERTANÓPOLIS","stateCode":"PR","buscaAdicional":"L.C.A. 54428 LCA UC 92039448 906470 LCA 0003 UC 23338415 906486 LCA UC 52988791 906712"},{"id":"74017c86-d0b3-4d18-5fb6-08d5ad2bf6ba","name":"MOINHO GLOBO ALIMENTOS S/A","commercialName":"MOINHO GLOBO ALIMENTOS","cnpj":"81442014000167","city":"SERTANÓPOLIS","stateCode":"PR","buscaAdicional":"MOINHO GLOBO 53193 MOINHO GLOBO GOIAS 905477 MOINHO GLOBO SENADOR 905514"},{"id":"2f416d07-4bd8-46fe-5e34-08d5ad2bf6ba","name":"SEARA-IND. E COMERCIO DE PRODUTOS AGRO-PECUARIOS LTDA","commercialName":"SEARA","cnpj":"75739086000178","city":"SERTANÓPOLIS","stateCode":"PR","buscaAdicional":"SEARA AGRO-INDUSTRIA 52277 SEARA AGRO IBIPORA 903115 SEARA AGRO LONDRINA 903224"},{"id":"7caf6f94-0928-49cb-5acb-08d5ad2bf6ba","name":"TAMARANA TECNOLOGIA E SOLUCOES AMBIENTAIS LTDA","commercialName":"","cnpj":"15329878000142","city":"TAMARANA","stateCode":"PR","buscaAdicional":"TAMARANA 50244 TAMARANA TECNO PR 897608"},{"id":"72b9e886-8c64-491c-6626-08d5ad2bf6ba","name":"BELA SEMENTES INDUSTRIA E COMERCIO DE SEMENTES LTDA","commercialName":"BELA SEMENTES","cnpj":"24692714000176","city":"TAMARANA","stateCode":"PR","buscaAdicional":"BELA SEMENTES 57374 BELAGRICOLA - TAMARA 899557"},{"id":"9cc7f647-5298-4926-5eb0-08d5ad2bf6ba","name":"LACTOJARA INDUSTRIA E COMERCIO DE LATICINIOS S.A.","commercialName":"LACTOJARA","cnpj":"05321589000143","city":"TAPEJARA","stateCode":"PR","buscaAdicional":"LACTOJARA 52508 LACTOJARA 902974"},{"id":"3635b305-977f-442c-5f98-08d5ad2bf6ba","name":"ONZE INDÚSTRIA E COMÉRCIO DE CELULOSE E ARTEFATOS DE PAPEL - EIRELI","commercialName":"ONZE INDUSTRIAS E COMERCIO","cnpj":"82221730000187","city":"TELÊMACO BORBA","stateCode":"PR","buscaAdicional":"REVITA 53042 ONZE INDUSTRIA 904400"},{"id":"7ac554f9-0add-4017-67f8-08d5ad2bf6ba","name":"BRASLUMBER INDUSTRIA DE MOLDURAS LTDA","commercialName":"","cnpj":"05265768000291","city":"TELÊMACO BORBA","stateCode":"PR","buscaAdicional":"BRASLUMBER 59111 BRASLUMBER 909712"},{"id":"c0ca2859-a292-467d-520c-08d5ad2bf6ba","name":"USINA DE ACUCAR SANTA TEREZINHA LTDA","commercialName":"USACUCAR - TERRA RICA","cnpj":"75717355000871","city":"TERRA RICA","stateCode":"PR","buscaAdicional":"USA TERRARICA1 2826 USACUCAR-TERRA RICA 8590 UTE.AI.PR.029780-1.01"},{"id":"4422b66a-6fc6-433d-600a-08d5ad2bf6ba","name":"CENTRALPACK EMBALAGENS LTDA","commercialName":"CENTRALPACK EMBALAGENS","cnpj":"07227026000116","city":"TOLEDO","stateCode":"PR","buscaAdicional":"CENTRALPACK 53356 CENTRAL PACK 903866"},{"id":"0e505fdd-4c38-4b14-600b-08d5ad2bf6ba","name":"PRATI, DONADUZZI & CIA LTDA","commercialName":"PRATI, DONADUZZI","cnpj":"73856593000166","city":"TOLEDO","stateCode":"PR","buscaAdicional":"DONADUZZI 53357 PRATI DONADUZZI 903865"},{"id":"a1c019c7-8a9e-461b-5d85-08d5ad2bf6ba","name":"FIASUL INDUSTRIA DE FIOS LTDA","commercialName":"","cnpj":"00080782000116","city":"TOLEDO","stateCode":"PR","buscaAdicional":"FIASUL 51847 FIASUL 899561"},{"id":"956537a5-7104-47d9-63ef-08d5ad2bf6ba","name":"SPERAFICO AGROINDUSTRIAL LTDA.","commercialName":"","cnpj":"75215756000157","city":"TOLEDO","stateCode":"PR","buscaAdicional":"SPERAFICO PARANA 55720 SPERAFICO RONDON 906007"},{"id":"1886f7b7-7921-4e1e-6394-08d5ad2bf6ba","name":"PRIMATO COOPERATIVA AGROINDUSTRIAL","commercialName":"PRIMATO","cnpj":"02168202000172","city":"TOLEDO","stateCode":"PR","buscaAdicional":"PRIMATO 55474 CEREALISTA CECCON 906477 PRIMATO COOPERATIVA 906836 PRIMATO UC 68823649 906855"},{"id":"5492a312-c25d-4964-692b-08d5ad2bf6ba","name":"MADEIREIRA MARACANA FLORESTAL LTDA","commercialName":"","cnpj":"07199149000190","city":"TUNAS DO PARANÁ","stateCode":"PR","buscaAdicional":"MADEIREIRA MARACANA FLORESTAL 60830 MADEIREIRA MARACANA 907643"},{"id":"89d6231f-3d0f-42d7-88ef-08d5ae44ed50","name":"INDUSTRIA MADEIREIRA MARACANA EIRELI","commercialName":"P R K LAMINADOS","cnpj":"07139227000161","city":"TUNAS DO PARANÁ","stateCode":"PR","buscaAdicional":"MADEIREIRA MARACANA 55940"},{"id":"15995efd-3b76-45ec-6155-08d5ad2bf6ba","name":"CABEÇA DE PATO GERAÇAO DE ENERGIA SPE LTDA","commercialName":"","cnpj":"23819456000183","city":"TURVO","stateCode":"PR","buscaAdicional":"CABECA DE PATO GERACAO 54138 CGH CABECA DE PATO 908224 CGH.PH.PR.035484-8.01"},{"id":"d01e2633-02c5-436c-6695-08d5ad2bf6ba","name":"UNITA COOPERATIVA CENTRAL","commercialName":"UNITA","cnpj":"14532494000160","city":"UBIRATÃ","stateCode":"PR","buscaAdicional":"UNITA 57674 UNITA UBIRATA 908036"},{"id":"893d4318-6af6-440b-6307-08d5ad2bf6ba","name":"J MARTINS SUPERMERCADOS PLANALTO LTDA","commercialName":"SUPERMERCADOS PLANALTO","cnpj":"76361807000111","city":"UMUARAMA","stateCode":"PR","buscaAdicional":"S PLANALTO 55105 SUPERM. PLANALTO ROL 906278 SUPERM. PLANALTO BR 906279 SUP PLANALTO CAST BR 910276 SUP PLANALTO TIRADEN 910297 SUP PLANALTO PIONEIR 910298"},{"id":"c607ca68-e672-4674-6342-08d5ad2bf6ba","name":"BATERAX INDUSTRIA E COMERCIO DE ACUMULADORES LTDA","commercialName":"BATERAX","cnpj":"77366664000101","city":"UMUARAMA","stateCode":"PR","buscaAdicional":"BATERAX 55274 BATERAX 905075"},{"id":"1f390e93-9361-40d0-64ef-08d5ad2bf6ba","name":"ALIMENTOS ZAELI LTDA","commercialName":"ZAELI","cnpj":"77917680005104","city":"UMUARAMA","stateCode":"PR","buscaAdicional":"ZAELI 56319 ALIMENTOS ZAELI 906025"},{"id":"eb625830-f4f0-412a-5ed7-08d5ad2bf6ba","name":"ASSOCIACAO PARANAENSE DE ENSINO E CULTURA","commercialName":"UNIVERSIDADE PARANAENSE - UNIPAR","cnpj":"75517151000110","city":"UMUARAMA","stateCode":"PR","buscaAdicional":"UNIPAR 52578 UNIPAR CAMPUS III 903257 UNIPAR UC CIANORTE 903258 UNIPAR PARANAVAI 905813 UNIPAR 45896372 907082 UNIPAR CASCAVEL 908694 UNIP F BELT 45297959 910217"},{"id":"30db11d9-1158-47f0-5bda-08d5ad2bf6ba","name":"MADEIRA PLASTICA AMBIENTAL S.A.","commercialName":"INBRASIL","cnpj":"17214638000128","city":"UNIÃO DA VITÓRIA","stateCode":"PR","buscaAdicional":"MADEIRA PLASTICA 50947 MADEIRA PLASTICA 899198"},{"id":"23e06208-1229-4b28-5764-08d5ad2bf6ba","name":"IN-BR INDUSTRIA E COMERCIO DE PLASTICOS EIRELI","commercialName":"IN BRAZIL","cnpj":"00199301000196","city":"UNIÃO DA VITÓRIA","stateCode":"PR","buscaAdicional":"INBRASIL 8771 INBRASIL 888914"},{"id":"80baea54-0326-42b1-610d-08d5ad2bf6ba","name":"MADEIREIRA ROCHEMBACH LTDA","commercialName":"COMPENSADOS ROCHEMBACH","cnpj":"76915123000114","city":"UNIÃO DA VITÓRIA","stateCode":"PR","buscaAdicional":"MADEIREIRA ROCHEMBACH 53981 MADEIREIRA ROCHEMBAC 906235"},{"id":"3588ed02-4a08-4acc-617a-08d5ad2bf6ba","name":"SOMAPAR SOCIEDADE MADEIREIRA PARANAENSE LTDA","commercialName":"","cnpj":"76743012000178","city":"UNIÃO DA VITÓRIA","stateCode":"PR","buscaAdicional":"SOMAPAR 54202 SOMAPAR 906476"},{"id":"7cf34f94-aac7-4e26-61fe-08d5ad2bf6ba","name":"PLACA COMERCIO DE MADEIRAS E COMPENSADOS LTDA","commercialName":"","cnpj":"03323576000188","city":"UNIÃO DA VITÓRIA","stateCode":"PR","buscaAdicional":"PLACA 54499 PLACA MADEIRAS 905894"},{"id":"9236cc27-b335-4676-6604-08d5ad2bf6ba","name":"PORMADE PORTAS DE MADEIRAS DECORATIVAS LTDA","commercialName":"","cnpj":"81639023000142","city":"UNIÃO DA VITÓRIA","stateCode":"PR","buscaAdicional":"PORMADE 57265 PORMADE UNIAO DA VIT 908148"},{"id":"aba208ba-e2d9-444a-88d3-08d5ae44ed50","name":"SAO GABRIEL PAPEIS LTDA","commercialName":"","cnpj":"04346278000176","city":"UNIÃO DA VITÓRIA","stateCode":"PR","buscaAdicional":"SAO GABRIEL 52720 SAO GABRIEL PAPEIS 905045"},{"id":"c2000545-2ffc-4cd6-6267-08d5ad2bf6ba","name":"CHESIWOOD INDUSTRIA MADEIREIRA LTDA","commercialName":"","cnpj":"08297366000186","city":"VENTANIA","stateCode":"PR","buscaAdicional":"CHESIWOOD 54746 CHESIWOOD 906379"},{"id":"dbe59cf0-9975-4fde-88eb-08d5ae44ed50","name":"CEREALISTA CECCON VERE LTDA","commercialName":"CECCON AGRONEGOCIOS IMP & EXP","cnpj":"06050449000140","city":"VERÊ","stateCode":"PR","buscaAdicional":"CECCON 55373"},{"id":"c8bec55e-9664-4b92-6664-08d5ad2bf6ba","name":"HIDROELETRICA ERNESTO LAVRATTI NETTO SPE LTDA","commercialName":"CGH ERNESTO LAVRATTI NETO SPE LTDA","cnpj":"26375585000118","city":"ABELARDO LUZ","stateCode":"SC","buscaAdicional":"CGH ERNESTO LAVRETTI NETTO 57518 ERNESTO L NETTO 909812 CGH.PH.SC.029800-0.01"},{"id":"4e45066a-92bc-47e4-5347-08d5ad2bf6ba","name":"DA LUZ ENERGIA LTDA","commercialName":"DA LUZ ENERGIA","cnpj":"07923905000182","city":"ABELARDO LUZ","stateCode":"SC","buscaAdicional":"DA LUZ ENERGIA 3550 PACHECO 8745 CGH.PH.SC.030171-0.01"},{"id":"f22ccc44-ce0e-41a7-53a9-08d5ad2bf6ba","name":"MULTICOLOR TEXTIL LTDA.","commercialName":"","cnpj":"80666324000100","city":"AGROLÂNDIA","stateCode":"SC","buscaAdicional":"MULTICOLOR 3751 MULTICOLOR 71273"},{"id":"43aad200-64b2-465a-56a8-08d5ad2bf6ba","name":"SALTO ENERGIA EOLICA S.A.","commercialName":"","cnpj":"08720143000180","city":"ÁGUA DOCE","stateCode":"SC","buscaAdicional":"UEE SALTO 7465 PULPITO 8929 EOL.CV.SC.029051-3.01 BOM JARDIM 8930 EOL.CV.SC.029062-9.01 SANTO ANTONIO -SALTO 8931 EOL.CV.SC.029053-0.01 RIO DO OURO 8932 EOL.CV.SC.029055-6.01 AQUIBATA 8951 EOL.CV.SC.029052-1.01 CAMPO BELO 8952 EOL.CV.SC.029065-3.01 CASCATA (SALTO) 8953 EOL.CV.SC.029054-8.01 CRUZ ALTA 8954 EOL.CV.SC.029070-0.01 SALTO (UEE SALTO) 8955 EOL.CV.SC.029056-4.01 AMPARO 8956 EOL.CV.SC.029069-6.01"},{"id":"b6caa686-b428-4eb0-5a47-08d5ad2bf6ba","name":"PIONEIRO ECOMETAIS INDUSTRIAL LTDA","commercialName":"PIONEIRO ECOMETAIS","cnpj":"18254143000195","city":"ÁGUA DOCE","stateCode":"SC","buscaAdicional":"ECOMETAIS 17304 BAT AGUA DOCE 888454"},{"id":"321055bb-6f63-4bfc-67db-08d5ad2bf6ba","name":"BIOBASE ALIMENTACAO ANIMAL LTDA","commercialName":"","cnpj":"12401698000217","city":"ÁGUAS FRIAS","stateCode":"SC","buscaAdicional":"BIOBASE 58730 BIOBASE ALIMENTACAO 910021"},{"id":"f2344efb-4c53-4ff1-63a0-08d5ad2bf6ba","name":"COQUEIRAL ENERGETICA LTDA.","commercialName":"","cnpj":"09416837000190","city":"ANGELINA","stateCode":"SC","buscaAdicional":"PCH COQUEIRAL 55486 COQUEIRAL 8787 PCH.PH.SC.029769-0.01"},{"id":"1c4ff3ac-5984-4b61-5b0b-08d5ad2bf6ba","name":"VONPAR REFRESCOS S A","commercialName":"","cnpj":"91235549001192","city":"ANTÔNIO CARLOS","stateCode":"SC","buscaAdicional":"VONPAR REFRESC ANC 50400 VONPAR REFRESCOS 897305"},{"id":"1b43768b-f635-4094-55d5-08d5ad2bf6ba","name":"CATIVA BENEFICIAMENTOS TEXTEIS LTDA.","commercialName":"","cnpj":"10467099000190","city":"APIÚNA","stateCode":"SC","buscaAdicional":"CATIVA BENEF 6227 CATIVA BENEF 897045"},{"id":"0975451f-6127-4b52-55fc-08d5ad2bf6ba","name":"BRANDILI TEXTIL LTDA","commercialName":"","cnpj":"84229889000173","city":"APIÚNA","stateCode":"SC","buscaAdicional":"BRANDILI 6472 BRANDILI - APIUNA 72205"},{"id":"0e275a33-bd0a-481b-543b-08d5ad2bf6ba","name":"COMPANHIA GERACAO DE ENERGIA PILAO","commercialName":"","cnpj":"11792578000144","city":"APIÚNA","stateCode":"SC","buscaAdicional":"CGEP 4117 SALTO PILAO-CCGE 8596 UHE.PH.SC.028564-1.01"},{"id":"047e508c-ed4d-40fe-546d-08d5ad2bf6ba","name":"HYOSUNG BRASIL INDUSTRIA E COMERCIO DE FIBRAS LTDA","commercialName":"HYOSUNG BRASIL","cnpj":"11703922000181","city":"ARAQUARI","stateCode":"SC","buscaAdicional":"HYOSUNG 4247 HYOSUNG-ARAQUARI SC 71616"},{"id":"a63f77da-3fd7-471b-5669-08d5ad2bf6ba","name":"RF REFLORESTADORA LTDA","commercialName":"","cnpj":"13772125000181","city":"ARAQUARI","stateCode":"SC","buscaAdicional":"REFLORESTADORA 7040 REFLORESTAMENTO SC 899978"},{"id":"ba2a7502-3878-4af1-5bd5-08d5ad2bf6ba","name":"MINERACAO VEIGA LTDA.","commercialName":"","cnpj":"75399758000143","city":"ARAQUARI","stateCode":"SC","buscaAdicional":"MINERACAO VEIGA 50941 MINERACAO VEIGA ARAQ 899325 MINERACAO 30760921 901554"},{"id":"d8459fea-aef8-4a28-5fad-08d5ad2bf6ba","name":"BMW DO BRASIL LTDA","commercialName":"","cnpj":"00882430001156","city":"ARAQUARI","stateCode":"SC","buscaAdicional":"BMW 53082 BMW ARAQUARI 899894"},{"id":"dd5ff313-1648-4629-5d6b-08d5ad2bf6ba","name":"FUTURA FUNDICAO LTDA","commercialName":"","cnpj":"06935509000102","city":"ARAQUARI","stateCode":"SC","buscaAdicional":"FUTURA 51814 FUTURA FUNDICAO 899758"},{"id":"b35d5031-aef2-4734-5cb2-08d5ad2bf6ba","name":"FEBRATEC INDUSTRIA E COMERCIO LTDA","commercialName":"","cnpj":"57645962000115","city":"ARAQUARI","stateCode":"SC","buscaAdicional":"FEBRATEC 51510 FEBRATEC 898987"},{"id":"525216d3-791d-472c-63b2-08d5ad2bf6ba","name":"CCP - INDUSTRIA E COMERCIO DE COMPOSTOS DE PVC LTDA","commercialName":"","cnpj":"08048078000198","city":"ARAQUARI","stateCode":"SC","buscaAdicional":"CCP COMPOSTOS 55528 CCP ARAQUARI 905869 CCP COMPOSTOS FILIAL 909439"},{"id":"deb2d5ea-0cf9-46ed-6615-08d5ad2bf6ba","name":"FORTLEV INDUSTRIA E COMERCIO DE PLASTICOS LTDA","commercialName":"FORTLEV INDUSTRIA E COMERCIO DE PLASTICOS LTDA","cnpj":"10921911000709","city":"ARAQUARI","stateCode":"SC","buscaAdicional":"FORTLEV ARAQUARI 57295 FORTLEV ARAQUI 888604"},{"id":"1b53fe0e-8342-485e-63b6-08d5ad2bf6ba","name":"CEREALISTA VISTA ALEGRE LTDA","commercialName":"","cnpj":"73252520000165","city":"ARARANGUÁ","stateCode":"SC","buscaAdicional":"CEREALISTA VISTA ALEGRE 55584 CEREALISTA V ALEGRE 906537"},{"id":"362af14d-cf96-40b9-621f-08d5ad2bf6ba","name":"CENTER FABRICAS ADMINISTRACAO DE IMOVEIS S/A","commercialName":"CENTER SHOPPING","cnpj":"14870322000104","city":"ARARANGUÁ","stateCode":"SC","buscaAdicional":"CENTER FABRICAS 54574 CENTER FABRICAS ARAR 906536"},{"id":"d8d2a44c-5fba-4daf-586c-08d5ad2bf6ba","name":"COOPERZEM COOPERATIVA DE GERACAO DE ENERGIA E DESENVOLVIMENTO","commercialName":"COOPERZEM GERACAO","cnpj":"11282430000160","city":"ARMAZÉM","stateCode":"SC","buscaAdicional":"COOPERZEM 11749 RIO PONCHO I 890033 CGH.PH.SC.030368-2.01 RIO PONCHO II 890236 CGH.PH.SC.029592-2.01 PCH VOLTA GRANDE 904594 PCH.PH.SC.030494-8.01"},{"id":"c0de5cde-7a59-4ed1-5885-08d5ad2bf6ba","name":"CGH ARROIO TRINTA ENERGETICA LTDA","commercialName":"","cnpj":"10556779000180","city":"ARROIO TRINTA","stateCode":"SC","buscaAdicional":"CGH ARROIO TRINTA 12172 ARROIO TRINTA 891161 CGH.PH.SC.031216-9.01"},{"id":"d4245acb-6122-4436-6105-08d5ad2bf6ba","name":"TEXTIL FARBE LTDA","commercialName":"","cnpj":"81303463000124","city":"ATALANTA","stateCode":"SC","buscaAdicional":"TEXTIL FARBE 53958 TEXTIL FARBE INDAIAL 902758"},{"id":"053b5ad9-15a9-4af2-671c-08d5ad2bf6ba","name":"JUNIOR INDUSTRIA E COMERCIO DE PLASTICOS LTDA","commercialName":"JUNIOR RAFIA","cnpj":"02553302000112","city":"AURORA","stateCode":"SC","buscaAdicional":"JUNIOR RAFIA 57963 JUNIOR RAFIA AURORA 909630"},{"id":"614d7c05-ca96-4d7a-66dd-08d5ad2bf6ba","name":"CONDOMINIO RESIDENCIAL E COMERCIAL EDIFICIO ATLANTICO SHOPPING CENTER","commercialName":"ATLANTICO SHOPPING CENTER","cnpj":"76709435000171","city":"BALNEÁRIO CAMBORIÚ","stateCode":"SC","buscaAdicional":"ATLANTICO SHOP 57861 ATLANTICO BALNEARIO 909642"},{"id":"bffd796d-fe0b-4db1-5b08-08d5ad2bf6ba","name":"CONDOMINIO COMERCIAL DO BALNEARIO CAMBORIU SHOPPING","commercialName":"CONDOMINIO COMERCIAL DO BCS","cnpj":"09002565000182","city":"BALNEÁRIO CAMBORIÚ","stateCode":"SC","buscaAdicional":"SHOP BALN CAMBORIU 50396 SHOP BALN CAMBORIU 897489"},{"id":"3ab572c5-5e9f-4ec5-5b51-08d5ad2bf6ba","name":"FUNDACAO UNIVERSIDADE DO VALE DO ITAJAI","commercialName":"CAMPUS II","cnpj":"84307974000374","city":"BALNEÁRIO CAMBORIÚ","stateCode":"SC","buscaAdicional":"UNIVALI BC 50599 UNIV VALE ITAJAI 897686"},{"id":"adf9851d-de1c-4bcd-5679-08d5ad2bf6ba","name":"COMPANHIA ENERGETICA BANDEIRANTE","commercialName":"CEB","cnpj":"12850712000189","city":"BANDEIRANTE","stateCode":"SC","buscaAdicional":"CBN 7181 BANDEIRANTE (CBN) 20071 PCH.PH.SC.030092-6.01"},{"id":"d3066d1f-79b8-4487-66da-08d5ad2bf6ba","name":"VISAO MOVEIS INDUSTRIA COMERCIO E TRANSPORTES LTDA","commercialName":"MOVEIS AIMARX INDUSTRIA E COMERCIO LTDA","cnpj":"01717285000220","city":"BANDEIRANTE","stateCode":"SC","buscaAdicional":"VISAO MOVEIS 57854 VISAO MOVEIS BANDEIR 909339"},{"id":"9489125b-7a15-4979-664e-08d5ad2bf6ba","name":"SUL MAR PESCADOS LTDA","commercialName":"SUL MAR","cnpj":"11284075000168","city":"BARRA VELHA","stateCode":"SC","buscaAdicional":"SUL MAR 57477 SUL MAR 908857"},{"id":"b9045e80-af61-4896-518b-08d5ad2bf6ba","name":"CEESAM GERADORA S.A.","commercialName":"","cnpj":"06990026000100","city":"BENEDITO NOVO","stateCode":"SC","buscaAdicional":"CEESAM 2358 ALTO BENEDITO NOVO I 8331 PCH.PH.SC.028802-0.01"},{"id":"9cd81f9b-5efe-4b8b-580b-08d5ad2bf6ba","name":"COOPERATIVA GERADORA DE ENERGIA ELETRICA E DESENVOLVIMENTO SANTA MARIA","commercialName":"","cnpj":"85937316000167","city":"BENEDITO NOVO","stateCode":"SC","buscaAdicional":"CEESAM GER 10490 SANTA MARIA (CEESAM) 890581 PCH.PH.SC.030681-9.01 ALTO BENEDITO NOVO 890397 PCH.PH.SC.000068-0.01"},{"id":"75972c47-505e-4e61-5980-08d5ad2bf6ba","name":"HIDRELETRICA SENS LTDA","commercialName":"","cnpj":"02444931000104","city":"BENEDITO NOVO","stateCode":"SC","buscaAdicional":"UHE SENS 14638 BENEDITO ALTO 895148 CGH.PH.SC.028172-7.01 ALTO BENEDITO II 913615 PCH.PH.SC.033599-1.01"},{"id":"dd69d192-d7d2-4ecb-5b8b-08d5ad2bf6ba","name":"PLASC - PLASTICOS SANTA CATARINA LTDA","commercialName":"","cnpj":"79427589000169","city":"BIGUAÇU","stateCode":"SC","buscaAdicional":"PLASC 50757 PLASC 897310"},{"id":"9a2fb807-7a9e-43aa-605f-08d5ad2bf6ba","name":"MONDIANA INDUSTRIA DE PLASTICOS EIRELI","commercialName":"MONDIANA","cnpj":"01442702000198","city":"BIGUAÇU","stateCode":"SC","buscaAdicional":"MONDIANA 53481 MONDIANA 902705"},{"id":"c5fde587-34d7-410e-57db-08d5ad2bf6ba","name":"INPLAC INDUSTRIA DE PLASTICOS S A","commercialName":"INPLAC","cnpj":"82956889000140","city":"BIGUAÇU","stateCode":"SC","buscaAdicional":"INPLAC 9809 INPLAC 889256"},{"id":"b9435c92-eed2-4bf5-68fb-08d5ad2bf6ba","name":"BENEFICENCIA CAMILIANA DO SUL","commercialName":"HOSPITAL REGIONAL HELMUTH NASS","cnpj":"83506030001769","city":"BIGUAÇU","stateCode":"SC","buscaAdicional":"BENEFICENCIA CAMILIANA DO SUL 60679 BENEFICENCIA CAMILIA 910902"},{"id":"0004e396-b712-4f5a-645a-08d5ad2bf6ba","name":"METALURGICA SARAIVA INDUSTRIA E COMERCIO LTDA","commercialName":"SARAIVA","cnpj":"50185891000176","city":"BIGUAÇU","stateCode":"SC","buscaAdicional":"METALURGICA SARAIVA 55942 METALURGICA SARAIVA 907730"},{"id":"8a846690-4d64-4529-88e9-08d5ae44ed50","name":"INCOVISA COMERCIO IMPORTACAO E EXPORTACAO LTDA","commercialName":"INCOVISA VIDROS","cnpj":"07756543000182","city":"BIGUAÇU","stateCode":"SC","buscaAdicional":"INCOVISA 54911"},{"id":"13ecef2e-4c0e-4cbc-7210-08d5cf600bef","name":"NEUMARKT TRADE END FINANCIAL CENTER S/A","commercialName":"NEUMARKT TRADE","cnpj":"00192769000159","city":"BLUMENAU","stateCode":"SC","buscaAdicional":""},{"id":"bd372acc-2da4-4346-4f11-08d5d159243d","name":"TWO HOLDING PARTICIPACOES S/A","commercialName":"TWO HOLDING PARTICIPACOES S/A","cnpj":"20445827000116","city":"BLUMENAU","stateCode":"SC","buscaAdicional":""},{"id":"5967b335-de80-4d58-73cb-08d5cf600bef","name":"S.N.B. PARTICIPACOES SA","commercialName":"","cnpj":"73903718000161","city":"BLUMENAU","stateCode":"SC","buscaAdicional":""},{"id":"e6d71b17-8c42-4825-73d4-08d5cf600bef","name":"TEKA TECELAGEM KUEHNRICH SA - EM RECUPERACAO JUDICIAL","commercialName":"TEKA EST UNIF","cnpj":"82636986000155","city":"BLUMENAU","stateCode":"SC","buscaAdicional":""},{"id":"9dd42bfe-fb8a-461b-73d5-08d5cf600bef","name":"LOJAS HERING S A","commercialName":"","cnpj":"82640632000184","city":"BLUMENAU","stateCode":"SC","buscaAdicional":""},{"id":"6f8df2e8-29ab-422c-8d82-08d5d060706e","name":"F M G ENERGIA LTDA","commercialName":"F M G ENERGIA","cnpj":"03707553000177","city":"BLUMENAU","stateCode":"SC","buscaAdicional":"F M G ENERGIA 60230"},{"id":"6e49a7bb-93f0-4e59-63dd-08d5ad2bf6ba","name":"SOUZA CRUZ LTDA","commercialName":"","cnpj":"33009911007818","city":"BLUMENAU","stateCode":"SC","buscaAdicional":"SOUZA CRUZ BLUMENAU CE 55687 SOUZA CRUZ BLUMENAU 907235"},{"id":"91931116-401d-4e18-63be-08d5ad2bf6ba","name":"FORNOS JUNG LTDA","commercialName":"","cnpj":"75277525000178","city":"BLUMENAU","stateCode":"SC","buscaAdicional":"FORNOS JUNG 55595 FORNOS JUNG 905036"},{"id":"32bbb313-2f5a-49e9-6383-08d5ad2bf6ba","name":"SUPER SUPERMERCADOS LTDA","commercialName":"GALEGAO SUPERMERCADO","cnpj":"01662221000198","city":"BLUMENAU","stateCode":"SC","buscaAdicional":"GALEGAO 55420 GALEGAO ESCOLA AGRIC 906500"},{"id":"0c2529c1-a97a-4fec-64bc-08d5ad2bf6ba","name":"BAUMGARTEN GRAFICA LTDA","commercialName":"","cnpj":"82637109000107","city":"BLUMENAU","stateCode":"SC","buscaAdicional":"BAUMGARTEN 56181 BAUMGARTEN BLUMENAU 906560"},{"id":"c1b69461-9399-4d88-6148-08d5ad2bf6ba","name":"SHOPPING PARK EUROPEU S/A","commercialName":"","cnpj":"11096279000175","city":"BLUMENAU","stateCode":"SC","buscaAdicional":"PARK EUROPEU 54100 SHOP PARK EUROPEU 905037"},{"id":"07302e46-a232-463d-6143-08d5ad2bf6ba","name":"ALTENBURG TEXTIL LTDA","commercialName":"","cnpj":"75293662000104","city":"BLUMENAU","stateCode":"SC","buscaAdicional":"ALTENBURG 54093 ALTENBURG 905863 ALTENBURG MATRIZ 905879"},{"id":"89a2b359-4386-4fcc-68fa-08d5ad2bf6ba","name":"CONDOMINIO BLUMENAU NORTE SHOPPING","commercialName":"CONDOMINIO BLUMENAU NORTE SHOPPING","cnpj":"26469651000119","city":"BLUMENAU","stateCode":"SC","buscaAdicional":"SHOP BLUMENAU 60677 BLUMENAU NORTE SHOP 897504"},{"id":"ed161598-8e21-46ff-669b-08d5ad2bf6ba","name":"VERA CRUZ GERACAO DE ENERGIA LTDA","commercialName":"","cnpj":"24955565000190","city":"BLUMENAU","stateCode":"SC","buscaAdicional":"VERACRUZ GERACAO 57683 BRANCHER 895306 CGH.PH.SC.031513-3.01"},{"id":"b2e829b3-bf02-44ee-66e3-08d5ad2bf6ba","name":"NATHOR INDUSTRIA E COMERCIO DE BICICLETAS EIRELI","commercialName":"","cnpj":"04039380000129","city":"BLUMENAU","stateCode":"SC","buscaAdicional":"NATHOR 57867 NATHOR 908475"},{"id":"7273d6fa-22de-4b84-6796-08d5ad2bf6ba","name":"SENIOR SISTEMAS S/A","commercialName":"SENIOR SISTEMAS","cnpj":"80680093000181","city":"BLUMENAU","stateCode":"SC","buscaAdicional":"SENIOR SISTEMAS 58323 SENIOR SIST BLUMENAU 908856"},{"id":"54746789-c1ea-478a-6792-08d5ad2bf6ba","name":"HOSPITAL SANTA CATARINA","commercialName":"","cnpj":"01880344000103","city":"BLUMENAU","stateCode":"SC","buscaAdicional":"HOSP SANTA CATARINA 58312 HOSP STA CATARINA SC 908476"},{"id":"be6679ef-ecf1-4bf4-67c6-08d5ad2bf6ba","name":"LOGHAUS COMERCIO DE ARTIGOS DO VESTUARIO LTDA","commercialName":"LOGHAUS LTDA","cnpj":"80462138000141","city":"BLUMENAU","stateCode":"SC","buscaAdicional":"LOGHAUS 58631 LOGHAUS VESTUARIO 909845"},{"id":"19ff0614-557e-4db3-56bd-08d5ad2bf6ba","name":"TAMBAU ENERGETICA SA","commercialName":"","cnpj":"05081798000167","city":"BLUMENAU","stateCode":"SC","buscaAdicional":"PCH TAMBAU 7580 TAMBAU 889161 PCH.PH.RS.030064-0.01"},{"id":"f80adb2e-8ae4-4440-5430-08d5ad2bf6ba","name":"PASSO FERRAZ ENERGIA SA","commercialName":"PCH PASSO FERRAZ","cnpj":"08022479000179","city":"BLUMENAU","stateCode":"SC","buscaAdicional":"PASSO FERRAZ 4067 PASSO FERRAZ 8837 PCH.PH.SC.030183-3.01"},{"id":"9484af2e-ac0d-4be9-548e-08d5ad2bf6ba","name":"LULI INDUSTRIA E COMERCIO DE CONFECCOES EIRELI - EM RECUPERACAO JUDICIAL","commercialName":"LULI","cnpj":"78644424000186","city":"BLUMENAU","stateCode":"SC","buscaAdicional":"LULI 4333 LULI-BLUMENAU SC 71566 LULI RODEIO 899083"},{"id":"24251ece-b217-4c54-5177-08d5ad2bf6ba","name":"LANCASTER BENEFICIAMENTOS TEXTEIS LTDA","commercialName":"","cnpj":"76541317000105","city":"BLUMENAU","stateCode":"SC","buscaAdicional":"LANCASTER 2196 LANCASTER 893844"},{"id":"bfed91a0-f9d1-49cc-5199-08d5ad2bf6ba","name":"CORONEL ARAUJO ENERGETICA S.A","commercialName":"","cnpj":"07659452000129","city":"BLUMENAU","stateCode":"SC","buscaAdicional":"CORONEL ARAUJO 2426 CORONEL ARAUJO 8261 PCH.PH.SC.029163-3.01"},{"id":"ee0d8948-7557-4088-519a-08d5ad2bf6ba","name":"CONTESTADO ENERGETICA S.A","commercialName":"","cnpj":"07659489000157","city":"BLUMENAU","stateCode":"SC","buscaAdicional":"CONTESTADO 2427 CONTESTADO 8262 PCH.PH.SC.029165-0.01"},{"id":"5cd2a27e-70c1-4e40-4ff1-08d5ad2bf6ba","name":"ELECTRO ACO ALTONA S A","commercialName":"","cnpj":"82643537000134","city":"BLUMENAU","stateCode":"SC","buscaAdicional":"ALTONA 1367 ALTONA BLUMENAU 7405"},{"id":"40b76fd3-c6f4-4e41-4ff5-08d5ad2bf6ba","name":"CREMER S.A.","commercialName":"","cnpj":"82641325000118","city":"BLUMENAU","stateCode":"SC","buscaAdicional":"CREMER 1373 CREMER TEXTIL 70902 CREMER ADESIVOS- BLU 70304"},{"id":"127c5688-1faa-4c28-4fa5-08d5ad2bf6ba","name":"KARSTEN S.A.","commercialName":"","cnpj":"82640558000104","city":"BLUMENAU","stateCode":"SC","buscaAdicional":"KARSTEN 1211 KARSTEN-BLUMENAU-SC 7556"},{"id":"a6cadf20-579f-44d9-5065-08d5ad2bf6ba","name":"CONDOMINIO COMERCIAL DO SHOPPING CENTER NEUMARKT BNU","commercialName":"CONDOMINIO COMERCIAL-SCNB","cnpj":"01172255000102","city":"BLUMENAU","stateCode":"SC","buscaAdicional":"SHOP NEUMARKT 1607 SHOP NEUMARKT-BLU 70020"},{"id":"ba922d81-a204-49f5-509f-08d5ad2bf6ba","name":"CIA. HERING","commercialName":"","cnpj":"78876950000171","city":"BLUMENAU","stateCode":"SC","buscaAdicional":"HERING MAT 1755 HERING MALHARIA-BLU 70177 HERING -ITORORO-BLU 70178 HERING MTZ BLUMENAU 70392 HERING PARNAMIRIM 911598 HERING CD 912440"},{"id":"2f3337b1-c5c7-49ad-6007-08d5ad2bf6ba","name":"PACIFICO SUL INDUSTRIA TEXTIL E CONFECCOES LTDA","commercialName":"PACIFICO SUL","cnpj":"81336398000133","city":"BLUMENAU","stateCode":"SC","buscaAdicional":"PACIFICO SUL 53353 PACIFICO SUL 905872"},{"id":"70528f32-7055-4553-5f6c-08d5ad2bf6ba","name":"BELLA JANELA INDUSTRIA DE CORTINAS LTDA","commercialName":"","cnpj":"72344591000125","city":"BLUMENAU","stateCode":"SC","buscaAdicional":"BELLA JANELA 52939 BELLA JANELA LAGES 902699 BELLA RUY BARBOSA 903973"},{"id":"ea47e266-f9c6-41cd-5ed2-08d5ad2bf6ba","name":"TECNOBLU S/A INDUSTRIA E COMERCIO","commercialName":"","cnpj":"00056633000111","city":"BLUMENAU","stateCode":"SC","buscaAdicional":"TECNOBLU 52563 TECNOBLU 903073"},{"id":"669616ac-cae2-4218-5edd-08d5ad2bf6ba","name":"HACO ETIQUETAS LTDA","commercialName":"","cnpj":"82645862000136","city":"BLUMENAU","stateCode":"SC","buscaAdicional":"HACO ETIQUETAS 52589 HACO ETIQ MASSANRAND 899917 HACO ETIQUETAS BLUM 899938"},{"id":"d1b115b8-198f-4135-5d80-08d5ad2bf6ba","name":"GIPLAS INDUSTRIA E COMERCIO LTDA","commercialName":"","cnpj":"00863529000139","city":"BLUMENAU","stateCode":"SC","buscaAdicional":"GIPLAS 51841 GIPLAS INDUSTRIA 902002"},{"id":"cc34916a-a070-46b2-5d8c-08d5ad2bf6ba","name":"COOPERATIVA DE PRODUCAO E ABASTECIMENTO DO VALE DO ITAJAI","commercialName":"COOPER","cnpj":"82647165000114","city":"BLUMENAU","stateCode":"SC","buscaAdicional":"COOPER 51890 COOPER MAFISO 899707 COOPER VELHA - AV 899708 COOPER GARCIA 899918 COOPER INDAIAL 900635 COOPER NACOES 900657 COOPER JARAGUA SUL 903980 COOPER J S VILA NOVA 903984 COOPER OMINO 905357 COOPER VILA NOVA 909644 COOPER CD BLUMENAU 912774"},{"id":"f473db0a-d3db-4113-5d21-08d5ad2bf6ba","name":"ECOFIBRAS INDUSTRIA TEXTIL EIRELI","commercialName":"EUROFIOS","cnpj":"07182774000120","city":"BLUMENAU","stateCode":"SC","buscaAdicional":"EUROFIOS 51711 ECOFIBRAS IND EIRELI 900919"},{"id":"5bc17fc9-a105-4c2e-5dd2-08d5ad2bf6ba","name":"SCHWANKE INDUSTRIAL LTDA","commercialName":"","cnpj":"82639477000186","city":"BLUMENAU","stateCode":"SC","buscaAdicional":"SCHWANKE 52013 SCHWANKE 901057"},{"id":"ebe0f67c-509f-42ad-5bde-08d5ad2bf6ba","name":"43 SA GRAFICA E EDITORA","commercialName":"","cnpj":"82641606000170","city":"BLUMENAU","stateCode":"SC","buscaAdicional":"43 SA 50955 43 SA BLUMENAU SC 898848"},{"id":"dc80caef-e2c6-422d-5c73-08d5ad2bf6ba","name":"CARTONDRUCK GRAFICA LTDA","commercialName":"","cnpj":"10693693000107","city":"BLUMENAU","stateCode":"SC","buscaAdicional":"CARTONDRUCK 51320 CARTONDRUCK GRAFICA 899089"},{"id":"5b4766ca-cdda-4350-5c7e-08d5ad2bf6ba","name":"HUVISPAN INDUSTRIA E COMERCIO DE FIOS LTDA","commercialName":"HUVISPAN TEXTIL","cnpj":"05810004000159","city":"BLUMENAU","stateCode":"SC","buscaAdicional":"HUVISPAN 51350 HUVISPAN BLUMENAU 899935"},{"id":"a4c6ab5d-26ee-450e-5a83-08d5ad2bf6ba","name":"RIO DO SAPO ENERGIA S.A","commercialName":"PCH RIO DO SAPO","cnpj":"09322423000100","city":"BLUMENAU","stateCode":"SC","buscaAdicional":"PCH RIO DO SAPO 49926 PCH RIO DO SAPO 897748 PCH.PH.MT.030408-5.01"},{"id":"c656e94a-4d3e-4d13-5a0b-08d5ad2bf6ba","name":"CENTRAL GERADORA HIDRELETRICA DAS PEDRAS S.A","commercialName":"CGH DAS PEDRAS","cnpj":"11591106000123","city":"BLUMENAU","stateCode":"SC","buscaAdicional":"CGH PEDRAS 16404 CGH PEDRAS 896884 CGH.PH.SC.032084-6.01"},{"id":"83298d94-e372-4d0e-5991-08d5ad2bf6ba","name":"FIACAO AGUAS NEGRAS LTDA","commercialName":"","cnpj":"80096050000153","city":"BOTUVERÁ","stateCode":"SC","buscaAdicional":"AGUAS NEGRAS 14916 AGUAS NEGRAS 895153"},{"id":"0b4438e7-433a-4ff4-598e-08d5ad2bf6ba","name":"VARGAS INDUSTRIA E COMERCIO DE PRODUTOS TEXTEIS LTDA","commercialName":"VARGAS TEXTIL","cnpj":"07692354000193","city":"BOTUVERÁ","stateCode":"SC","buscaAdicional":"VARGAS INDUSTRIA 14856 VARGAS INDUSTRIA 894703"},{"id":"9b67e274-2764-4ab4-5b49-08d5ad2bf6ba","name":"N & B TEXTIL LTDA","commercialName":"N B TEXTIL","cnpj":"05481537000134","city":"BOTUVERÁ","stateCode":"SC","buscaAdicional":"NB TEXTIL MATRIZ 50561 N&B TEXTIL SC 897607"},{"id":"fe2d4a87-fc1d-4838-5c31-08d5ad2bf6ba","name":"CALWER MINERACAO LTDA","commercialName":"","cnpj":"78994456000101","city":"BOTUVERÁ","stateCode":"SC","buscaAdicional":"CALWER MINERACAO 51145 CALWER BOTUVERA 900784"},{"id":"bd5b54b3-3f39-4ff7-5ea6-08d5ad2bf6ba","name":"FIACAO BOTUVERA LTDA","commercialName":"FIBLA","cnpj":"79012571000104","city":"BOTUVERÁ","stateCode":"SC","buscaAdicional":"FIACAO BOTUVERA 52473 FIACAO BOTUVERA SC 900960"},{"id":"c162a6ee-cbf6-4149-5ce8-08d5ad2bf6ba","name":"BOTUVERA METAIS INDUSTRIA E RECUPERADORA DE SUCATAS LTDA","commercialName":"","cnpj":"17645625000103","city":"BOTUVERÁ","stateCode":"SC","buscaAdicional":"BOTUVERA METAIS 51608 BOTUVERA METAIS SC 899714"},{"id":"8daea1df-b572-43c4-5cd7-08d5ad2bf6ba","name":"BOTUVERA INDUSTRIA E COMERCIO DE ACUMULADORES E COMPONENTES LTDA","commercialName":"","cnpj":"05730180000180","city":"BOTUVERÁ","stateCode":"SC","buscaAdicional":"BOTUVERA ACUMULADORES 51586 BOTUVERA ACUMULADORE 901495"},{"id":"2e8aee0d-f156-4fa0-60d5-08d5ad2bf6ba","name":"FIACAO E TINTURARIA IRMAOS ASSINI LTDA","commercialName":"ASSINI FIOS E TINTURARIA","cnpj":"07592990000143","city":"BOTUVERÁ","stateCode":"SC","buscaAdicional":"IRMAOS ASSINI 53752 FIACAO IRMAOS ASSINI 904460 IRMAOS ASSINI TINTUR 905474"},{"id":"d4d8797d-3fcb-497e-6745-08d5ad2bf6ba","name":"FIACAO ALLIANCE LTDA","commercialName":"","cnpj":"05297665000122","city":"BOTUVERÁ","stateCode":"SC","buscaAdicional":"FIACAO ALLIANCE 58023 FIACAO ALLIANCE 911873"},{"id":"30d63dbc-168b-49c1-6165-08d5ad2bf6ba","name":"MINERACAO RIO DO OURO LTDA","commercialName":"CALCARIO BOTUVERA","cnpj":"78266566000157","city":"BOTUVERÁ","stateCode":"SC","buscaAdicional":"MIN RIO DO OURO 54171 MIN RIO DO OURO 903134"},{"id":"2277c824-63a7-451c-61ed-08d5ad2bf6ba","name":"DALFIOS FIACAO LTDA","commercialName":"DALFIOS","cnpj":"07807149000126","city":"BOTUVERÁ","stateCode":"SC","buscaAdicional":"DALFIOS FIACAO 54472 DALFIOS FIACAO LTDA 905359"},{"id":"b08a7289-a3f4-4b96-88e5-08d5ae44ed50","name":"CERBRANORTE GERACAO S.A.","commercialName":"","cnpj":"05699630000110","city":"BRAÇO DO NORTE","stateCode":"SC","buscaAdicional":"CERBRANORTE G 54620 CAPIVARI CEBRANORTE 904122 PCH.PH.SC.000659-9.01"},{"id":"83615019-d82f-4ab8-599b-08d5ad2bf6ba","name":"USINA THEODORO SCHLICKMANN S/A","commercialName":"PCH TEODORO SCHLICKMANN","cnpj":"09570577000103","city":"BRAÇO DO NORTE","stateCode":"SC","buscaAdicional":"TEODORO S 15115 TEODORO SCHLICKMANN 894044 CGH.PH.SC.030591-0.01"},{"id":"2fe94d3e-7e7a-4a91-57e5-08d5ad2bf6ba","name":"METALBO INDUSTRIA DE FIXADORES METALICOS LTDA","commercialName":"","cnpj":"75483040000130","city":"BRAÇO DO TROMBUDO","stateCode":"SC","buscaAdicional":"METALBO 9989 REX MAQUINAS 889527"},{"id":"c1ef613c-4af0-483a-57bd-08d5ad2bf6ba","name":"STAACK TINTURARIA LTDA","commercialName":"","cnpj":"03061133000166","city":"BRUSQUE","stateCode":"SC","buscaAdicional":"STAACK 9529 STAACK 889045"},{"id":"a259d95b-0f89-4015-5787-08d5ad2bf6ba","name":"TINTURARIA FLORISA LTDA","commercialName":"","cnpj":"82725128000187","city":"BRUSQUE","stateCode":"SC","buscaAdicional":"FLORISA 9010 FLORISA BRUSQUE 889120"},{"id":"c0ad0927-efe1-4bb5-5797-08d5ad2bf6ba","name":"IRMAOS FISCHER SA IND E COM","commercialName":"","cnpj":"82984287000104","city":"BRUSQUE","stateCode":"SC","buscaAdicional":"IRMAOS FISCHER 9113 IRMAOS FISCHER 889125"},{"id":"197a836c-aea8-4aea-56d3-08d5ad2bf6ba","name":"HG TEXTIL LTDA","commercialName":"","cnpj":"07292446000186","city":"BRUSQUE","stateCode":"SC","buscaAdicional":"HG TEXTIL 7801 HG TEXTIL BRUSQUE 72350"},{"id":"ca25681f-cedf-449a-574c-08d5ad2bf6ba","name":"INDUSTRIAL IRMAOS HORT LIMITADA","commercialName":"","cnpj":"03634530000180","city":"BRUSQUE","stateCode":"SC","buscaAdicional":"IRMAOS HORT 8509 IRMAOS HORT 888324"},{"id":"ffa16328-b6b6-4eb1-54c9-08d5ad2bf6ba","name":"HAVAN LOJAS DE DEPARTAMENTOS LTDA","commercialName":"","cnpj":"79379491000183","city":"BRUSQUE","stateCode":"SC","buscaAdicional":"HAVAN 4498 HAVAN-ITAJAI 71737 HAVAN XAXIM-CURITIBA 71738 HAVAN-BLUMENAU 71739 HAVAN-PARANAGUA 71740 HAVAN-BARRA VELHA 71757 HAVAN 24-MARINGA PR 71820 HAVAN MARINGA CENTER 71821 HAVAN 21-FLORIPA 71825 HAVAN 05-BRUSQUE 71881 HAVAN 41 - P GROSSA 72141 HAVAN 28 - BLUMENAU 72161 HAVAN 27 SAO JOSE 72406 HAVAN 43 ARAUCARIA 72407 HAVAN 19 F IGUACU 72408 HAVAN 42 JOINVILLE S 72411 HAVAN 32 BOM RETIRO 888115 HAVAN 06 - JOINVILLE 888132 HAVAN-05-FLORIPA 888649 HAVAN-03-BARIGUI 888651 HAVAN 54 888685 HAVAN 08 888694 HAVAN 31 888695 HAVAN 4 PAROLIN 888913 HAVAN 49 888998 HAVAN 52 888999 HAVAN 21 PALHOCA 889000 HAVAN 29 889001 HAVAN 51 889234 HAVAN 14 889392 HAVAN 16 889800 HAVAN 07 889801 HAVAN 50 889802 HAVAN 9 BAL CAMBORIU 890727 HAVAN 12 CHAPECO 890728 HAVAN UMUARAMA 897291 HAVAN 26 897906 HAVAN ARAPONGAS 897990 HAVAN TUBARAO 18 899352 HAVAN ARARANGUA 97 899353 HAVAN CRICIUMA 64 899354 HAVAN CAMPO LARGO 899432 HAVAN JARAGUA 01 899687 HAVAN JARAGUA 75 900453 HAVAN PATO 102 902634 HAVAN COLOMBO 60 903778 HAVAN PORTO UNIAO 94 904077 HAVAN FOZ CATUAI 114 910026 HAVAN 46 888593 HAVAN 45 888594 HAVAN 47 889002 HAVAN 39 889358 HAVAN 53 889385 HAVAN 48 LIMEIRA 890394 HAVAN FRANCA 897491 HAVAN PIRACICABA 897492 HAVAN SOROCABA 897493 HAVAN TRES LAGOAS 897527 HAVAN RIBERAO PRETO 897528 HAVAN HORTOLANDIA 897529 HAVAN LUCAS RIO VERD 897867 HAVAN S PEDRO 92 898164 HAVAN DOURADOS 55 898466 HAVAN LINHARES 105 899312 HAVAN S J CAMPOS 67 899314 HAVAN STA BARBARA 62 899315 HAVAN MOGI CRUZES 66 899577 HAVAN BG 85 899715 HAVAN TANGARA L97 899850 HAVAN SINOP L57 899867 HAVAN LORENA 88 901051 HAVAN BAURU 901197 HAVAN CUIABA 58 901673 HAVAN RONDONOPOLIS59 901715 HAVAN CAMPO GRANDE72 901913 HAVAN CAMPO GRANDE84 903394 HAVAN UBERLANDIA 76 903956 HAVAN JUIZ FORA 89 903959 HAVAN UBERABA 98 903963 HAVAN VALPARAISO 74 904048 HAVAN RIO VERDE 77 904049 HAVAN ANAPOLIS 63 904062 HAVAN PORTO VELHO 80 904420 HAVAN PRAIA GRANDE 908675 HAVAN ITAQUA 115 910675 HAVAN MARABA 83 898606 HAVAN PARAUAPEBAS 82 899313 HAVAN PALMAS 79 902633 HAVAN BARREIRAS 90 903353 HAVAN PETROLINA 101 904321 HAVAN CACOAL 107 912421"},{"id":"0ad7ae68-1dd7-47f7-5969-08d5ad2bf6ba","name":"INDUSTRIA E COMERCIO DE MALHAS MH LTDA.","commercialName":"","cnpj":"81321549000180","city":"BRUSQUE","stateCode":"SC","buscaAdicional":"MALHAS MH 14405 MALHAS MH 894004"},{"id":"ad67b184-493a-42ca-582a-08d5ad2bf6ba","name":"BENETEX RECICLAGEM TEXTIL EIRELI","commercialName":"","cnpj":"02742731000138","city":"BRUSQUE","stateCode":"SC","buscaAdicional":"BENETEX 10891 BENETEX 889635"},{"id":"11abadb2-6791-4157-586e-08d5ad2bf6ba","name":"INDUSTRIA E COMERCIO DE MALHAS RVB LTDA","commercialName":"","cnpj":"83203992000181","city":"BRUSQUE","stateCode":"SC","buscaAdicional":"RVB MALHAS 11769 RVB MALHAS FILIAL 890501 RVB MALHAS MATRIZ 890502"},{"id":"bcd7afdb-c2a9-4b0f-5889-08d5ad2bf6ba","name":"BENEPET RECICLAGEM LTDA","commercialName":"","cnpj":"04082966000176","city":"BRUSQUE","stateCode":"SC","buscaAdicional":"BENEPET REC 12272 BENEPET 890482"},{"id":"841508e0-0a8f-4b9f-5c53-08d5ad2bf6ba","name":"ZM SA","commercialName":"","cnpj":"76812379000104","city":"BRUSQUE","stateCode":"SC","buscaAdicional":"ZM 51263 ZM BRUSQUE SC 899145"},{"id":"0b9b3597-17b6-41fc-5c43-08d5ad2bf6ba","name":"CONDOMINIO FEIRA INDUSTRIAL PERMANENTE DE BRUSQUE","commercialName":"FIPE","cnpj":"81288961000145","city":"BRUSQUE","stateCode":"SC","buscaAdicional":"FIP 51237 FEIRA INDUSTRIAL 899789"},{"id":"426bb2a2-94b1-4dbe-5b55-08d5ad2bf6ba","name":"HAVAN COMERCIALIZADORA DE ENERGIA LTDA","commercialName":"","cnpj":"21962548000192","city":"BRUSQUE","stateCode":"SC","buscaAdicional":"HAVAN COMERCIALIZADORA 50611"},{"id":"7b0e5de8-b280-49cc-5afc-08d5ad2bf6ba","name":"H J MALHAS LTDA","commercialName":"","cnpj":"85335487000116","city":"BRUSQUE","stateCode":"SC","buscaAdicional":"HJ MALHAS 50379 HJ MALHAS 898581"},{"id":"4d34319f-0f2f-4d43-5b0f-08d5ad2bf6ba","name":"UNIFIOS TEXTIL LTDA","commercialName":"","cnpj":"14038093000158","city":"BRUSQUE","stateCode":"SC","buscaAdicional":"UNIFIOS 50411 UNIFIOS BRUSQUE SC 897569"},{"id":"db9b00e3-0782-4597-5ffb-08d5ad2bf6ba","name":"CONDOMINIO STOP SHOP","commercialName":"","cnpj":"02129852000109","city":"BRUSQUE","stateCode":"SC","buscaAdicional":"STOP SHOP 53322 COND STOP SHOP 908479"},{"id":"a29728a1-f415-433f-5ed6-08d5ad2bf6ba","name":"FUNDACAO EDUCACIONAL DE BRUSQUE FEBE","commercialName":"","cnpj":"83128769000117","city":"BRUSQUE","stateCode":"SC","buscaAdicional":"UNIFEBE 52577 UNIFEBE 902673"},{"id":"b337eb10-07e1-4c5c-5f71-08d5ad2bf6ba","name":"SANCRIS LINHAS E FIOS LTDA","commercialName":"","cnpj":"80446990000125","city":"BRUSQUE","stateCode":"SC","buscaAdicional":"SANCRIS LINHAS E FIOS 52958 SANCRIS 29106177 905026 SANCRIS BRUSQUE SOUZ 907728"},{"id":"008d3034-2e2d-4bde-5d02-08d5ad2bf6ba","name":"ZEN S.A. INDUSTRIA METALURGICA","commercialName":"","cnpj":"57006264000170","city":"BRUSQUE","stateCode":"SC","buscaAdicional":"ZEN 51676 ZEN METALURGICA SC 899118"},{"id":"19cde94c-a561-4d1e-5cc6-08d5ad2bf6ba","name":"PHB INDUSTRIA TEXTIL LIMITADA","commercialName":"PHB INDUSTRIA TEXTIL","cnpj":"12440143000101","city":"BRUSQUE","stateCode":"SC","buscaAdicional":"PHB TEXTIL 51565 PHB INDUSTRIAL 899351"},{"id":"359a2aea-260f-44c6-5c8a-08d5ad2bf6ba","name":"HEIL MALHAS LTDA","commercialName":"LITORAL TINTURARIA","cnpj":"06079036000270","city":"BRUSQUE","stateCode":"SC","buscaAdicional":"HEIL MALHAS 51377 HEIL MALHAS LTDA 900573"},{"id":"de3f08d1-0903-4191-5d6c-08d5ad2bf6ba","name":"GIRACOR TEXTIL LTDA","commercialName":"","cnpj":"07598373000155","city":"BRUSQUE","stateCode":"SC","buscaAdicional":"GIRACOR 51815 GIRACOR TEXTIL 900698"},{"id":"e95573f0-84ee-452a-5eb5-08d5ad2bf6ba","name":"TINTURARIA E LAVANDERIA PEDRINI LTDA","commercialName":"","cnpj":"03173370000119","city":"BRUSQUE","stateCode":"SC","buscaAdicional":"PEDRINI 52516 TINTURARIA PEDRINI 902984"},{"id":"0d29023e-a0e0-4254-73d6-08d5cf600bef","name":"FABRICA DE TECIDOS CARLOS RENAUX S/A EM LIQUIDACAO","commercialName":"","cnpj":"82981671000145","city":"BRUSQUE","stateCode":"SC","buscaAdicional":""},{"id":"bd64dd9a-a9fb-4a3f-73d7-08d5cf600bef","name":"BUETTNER S/A - INDUSTRIA E COMERCIO - EM RECUPERACAO JUDICIAL","commercialName":"","cnpj":"82981812000120","city":"BRUSQUE","stateCode":"SC","buscaAdicional":""},{"id":"8fb113b5-aeb0-4f2c-73d8-08d5cf600bef","name":"COMPANHIA INDUSTRIAL SCHLOSSER SA.","commercialName":"","cnpj":"82981929000103","city":"BRUSQUE","stateCode":"SC","buscaAdicional":""},{"id":"82420fc2-53ce-4604-73d9-08d5cf600bef","name":"TEXTIL RENAUXVIEW SA","commercialName":"RENAUXVIEW","cnpj":"82982075000180","city":"BRUSQUE","stateCode":"SC","buscaAdicional":""},{"id":"56fb897b-b147-4cfc-61fa-08d5ad2bf6ba","name":"MAROMA INDUSTRIA E COMERCIO DE SORVETES LTDA","commercialName":"","cnpj":"79685467000172","city":"BRUSQUE","stateCode":"SC","buscaAdicional":"MAROMA 54495 MAROMA 904253"},{"id":"62677d14-0950-41fd-61bd-08d5ad2bf6ba","name":"DECKER TINGIMENTOS LTDA","commercialName":"","cnpj":"81850141000103","city":"BRUSQUE","stateCode":"SC","buscaAdicional":"DECKER 54357 DECKER 904224"},{"id":"ac54e4ce-49c4-4265-6288-08d5ad2bf6ba","name":"WILLRICH INDUSTRIA E COMERCIO TEXTIL LTDA","commercialName":"","cnpj":"79393864000170","city":"BRUSQUE","stateCode":"SC","buscaAdicional":"WILLRICH 54795 WILLRICH TEXTIL 904293"},{"id":"ac21be61-996b-41c1-6481-08d5ad2bf6ba","name":"SUPERMERCADOS ARCHER SA","commercialName":"","cnpj":"79257291000158","city":"BRUSQUE","stateCode":"SC","buscaAdicional":"ARCHER 56041 ARCHER LJ 03 907739 ARCHER LJ 07 907754 ARCHER LJ 01 907755 ARCHER LJ 04 907756"},{"id":"a243a2e7-647b-48bb-6371-08d5ad2bf6ba","name":"INDUSTRIA E COMERCIO DE PLASTICOS CAJOVIL LTDA.","commercialName":"","cnpj":"02575998000188","city":"BRUSQUE","stateCode":"SC","buscaAdicional":"CAJOVIL 55352 CAJOVIL PLASTICOS 906558"},{"id":"eae1d84a-2187-4886-63dc-08d5ad2bf6ba","name":"SOUZA CRUZ LTDA","commercialName":"","cnpj":"33009911011416","city":"BRUSQUE","stateCode":"SC","buscaAdicional":"SOUZA CRUZ BRUSQUE 55686 SOUZA CRUZ BRUSQUE 907218"},{"id":"50839aaa-6da1-47cc-640d-08d5ad2bf6ba","name":"CORETEX INDUSTRIA TEXTIL LTDA","commercialName":"MARAZUL MALHAS","cnpj":"83445288000135","city":"BRUSQUE","stateCode":"SC","buscaAdicional":"CORETEX 55810 CORETEX 906557"},{"id":"b228eb71-9c61-42d5-67bf-08d5ad2bf6ba","name":"INDUSTRIA DE VINAGRE E PLASTICOS HEINIG LTDA","commercialName":"","cnpj":"78990421000102","city":"BRUSQUE","stateCode":"SC","buscaAdicional":"VINAGRE HEINIG 58603 VINAGRE HEINIG 908477"},{"id":"fccf7aba-6a73-4121-67af-08d5ad2bf6ba","name":"COPACABANA INDUSTRIA E COMERCIO DE ARTIGOS DE CAMA E BANHO EIRELI","commercialName":"COPACABANA TEXTIL","cnpj":"06376714000185","city":"BRUSQUE","stateCode":"SC","buscaAdicional":"COPACABANA 58470 COPACABANA 909335"},{"id":"839432b3-893a-4560-66ba-08d5ad2bf6ba","name":"CMJ TEXTIL LTDA","commercialName":"","cnpj":"81616062000124","city":"BRUSQUE","stateCode":"SC","buscaAdicional":"CMJ 57760 CMJ BRUSQUE 909397"},{"id":"9d390437-63c9-4cc8-6970-08d5ad2bf6ba","name":"PETROPLAST INDUSTRIA DE FITAS E SELOS LTDA","commercialName":"PETROPLAST FITAS E SELOS","cnpj":"08228625000117","city":"BRUSQUE","stateCode":"SC","buscaAdicional":"PETROPLAST 61634 PETROPLAST 912435"},{"id":"270dd95c-e557-4b7a-67cb-08d5ad2bf6ba","name":"METALURGICA SIEMSEN LIMITADA","commercialName":"METALURGICA SKYMSEN LTDA","cnpj":"82983032000119","city":"BRUSQUE","stateCode":"SC","buscaAdicional":"METALURGICA SIEMSEN 58640 METALURGICA SKYCUT 899589"},{"id":"e59166ed-1b05-4a11-6867-08d5ad2bf6ba","name":"ELETRO INDUSTRIAL LTDA","commercialName":"SMALTE","cnpj":"05409888000215","city":"BRUSQUE","stateCode":"SC","buscaAdicional":"ELETRO INDUSTRIAL 59913 ELETRO INDUSTRIAL 910553"},{"id":"02c326c9-3465-4494-88a2-08d5ae44ed50","name":"SANTA ROSA GERADORA DE ENERGIA LTDA","commercialName":"","cnpj":"01710644000136","city":"CAÇADOR","stateCode":"SC","buscaAdicional":"CGH TAQUARA VERDE 14915 TAQUARA VERDE 894203 CGH.PH.SC.031620-2.01"},{"id":"f19b13b6-7e05-4c9a-6452-08d5ad2bf6ba","name":"BIOMASTERPLAST INDUSTRIA E COMERCIO DE PLASTICOS LTDA","commercialName":"","cnpj":"76843168000120","city":"CAÇADOR","stateCode":"SC","buscaAdicional":"BIOMASTERPLAST 55932 BIOMASTERPLAST 908306"},{"id":"62eb6ad9-4484-4aa1-64ad-08d5ad2bf6ba","name":"ASSOCIACAO FRANCO BRASILEIRA","commercialName":"HOSPITAL MAICE","cnpj":"33543356002093","city":"CAÇADOR","stateCode":"SC","buscaAdicional":"HOSPITAL MAICE 56151 ASSOCIACAO FRANCO BR 906556"},{"id":"e6e50982-96c7-4641-625f-08d5ad2bf6ba","name":"MATISA BRASIL INDUSTRIA E COMERCIO DE MADEIRAS LTDA","commercialName":"MATISA MADEIRAS","cnpj":"07386344000120","city":"CAÇADOR","stateCode":"SC","buscaAdicional":"MATISA 54738 MATISA 906517"},{"id":"a221bdb9-ac56-49c6-6186-08d5ad2bf6ba","name":"ARTEPINUS INDUSTRIA E COMERCIO DE MADEIRAS LTDA","commercialName":"ARTEPINUS","cnpj":"76848506000117","city":"CAÇADOR","stateCode":"SC","buscaAdicional":"ARTEPINUS 54225 ARTPINUS CACADOR 906526"},{"id":"00a7b987-6f5d-4bf6-612c-08d5ad2bf6ba","name":"PRIMO TEDESCO SA","commercialName":"","cnpj":"83056804000130","city":"CAÇADOR","stateCode":"SC","buscaAdicional":"PRIMO TEDESCO 54045 PRIMO TEDESCO SACOS 901620 PRIMO TEDESCO 901636 PRIMO TEDESCO PAPELA 907258"},{"id":"92cb2b8f-4d49-4495-5cc5-08d5ad2bf6ba","name":"ELETROCAL INDUSTRIA E COMERCIO DE MATERIAIS ELETRICOS LTDA","commercialName":"","cnpj":"83060012000139","city":"CAÇADOR","stateCode":"SC","buscaAdicional":"ELETROCAL 51564 ELETROCAL 898386 ELETROCAL-ANDRADINA 902007"},{"id":"2dfcecfe-5a10-490b-5f0c-08d5ad2bf6ba","name":"INDUSTRIA DE MOVEIS ROTTA LTDA","commercialName":"ROTTA MOVEIS","cnpj":"83081786000146","city":"CAÇADOR","stateCode":"SC","buscaAdicional":"MOVEIS ROTTA 52717 MOVEIS ROTTA 904218"},{"id":"10b6fbd7-c096-4f07-5f0d-08d5ad2bf6ba","name":"NARCISO ROTTA MADEIRAS LTDA","commercialName":"ROTTA MADEIRAS","cnpj":"03699509000162","city":"CAÇADOR","stateCode":"SC","buscaAdicional":"ROTTA MADEIRAS 52718 NARCISO ROTTA MADEIR 904142"},{"id":"4d7b090a-7145-4873-5f10-08d5ad2bf6ba","name":"LAMIPACK EMBALAGENS E LAMINADOS PLASTICOS LTDA","commercialName":"","cnpj":"85140739000151","city":"CAÇADOR","stateCode":"SC","buscaAdicional":"LAMIPACK 52722 LAMIPACK CACADOR 905873"},{"id":"e1185b6d-84c8-4583-5ff8-08d5ad2bf6ba","name":"MADEIRAS SALAMONI LTDA","commercialName":"","cnpj":"83054544000163","city":"CAÇADOR","stateCode":"SC","buscaAdicional":"MADEIRAS SALAMONI 53319 MADEIRAS SALAMONI 903104"},{"id":"aa8179c7-6755-41b9-6071-08d5ad2bf6ba","name":"FRAME MADEIRAS ESPECIAIS LTDA","commercialName":"FRAMEPORT","cnpj":"83684191000185","city":"CAÇADOR","stateCode":"SC","buscaAdicional":"FRAME 53512 FRAMO MADEIRAS 901507"},{"id":"3d5bb7c9-35ec-47dc-6088-08d5ad2bf6ba","name":"TESSER INDUSTRIA DE MADEIRAS LTDA","commercialName":"","cnpj":"85205144000137","city":"CAÇADOR","stateCode":"SC","buscaAdicional":"TESSER 53580 TESSER 903117"},{"id":"e46c37a2-c891-4a27-5af3-08d5ad2bf6ba","name":"INDUSTRIA E COMERCIO DE EMBALAGENS MAXIPLAST LTDA","commercialName":"","cnpj":"01731676000118","city":"CAÇADOR","stateCode":"SC","buscaAdicional":"MAXIPLAST MAT 50370 MAXPLAST - SERAFINA 898528 MAXPLAST CACADOR 898370 MAXPLAST - RAFIA 897447"},{"id":"68323fad-2e4b-4278-5b23-08d5ad2bf6ba","name":"TEMASA INDUSTRIA DE MOVEIS LTDA","commercialName":"","cnpj":"81834152000191","city":"CAÇADOR","stateCode":"SC","buscaAdicional":"TEMASA 50494 TEMASA 898666"},{"id":"4a0041ac-fd43-4177-5575-08d5ad2bf6ba","name":"ADAMI SA MADEIRAS","commercialName":"","cnpj":"83054478000806","city":"CAÇADOR","stateCode":"SC","buscaAdicional":"ADAMI 5669 ADAMI MADEIRAS-CACAD 71914"},{"id":"a4e2bac2-7742-42e0-547d-08d5ad2bf6ba","name":"GUARARAPES PAINEIS S/A","commercialName":"GUARARAPES PAINEIS S/A","cnpj":"08810422000134","city":"CAÇADOR","stateCode":"SC","buscaAdicional":"GUARARAPES 4300 GUARARAPES-CACADOR 71501"},{"id":"b95ae88d-4293-46aa-545b-08d5ad2bf6ba","name":"PASSOS MAIA ENERGETICA S.A.","commercialName":"","cnpj":"08542325000108","city":"CAÇADOR","stateCode":"SC","buscaAdicional":"PASSOS MAIA 4190 VICTOR B ADAMI 8962 PCH.PH.SC.029072-6.01"},{"id":"24c5a4f5-a869-477d-5733-08d5ad2bf6ba","name":"CORFIO INDUSTRIA E COMERCIO DE MATERIAIS ELETRICOS LTDA","commercialName":"","cnpj":"06296755000161","city":"CAÇADOR","stateCode":"SC","buscaAdicional":"CORFIO 8331 CORFIO CACADOR 888294"},{"id":"4799e8e9-0a74-42f2-50ec-08d5ad2bf6ba","name":"SINCOL SA INDUSTRIA E COMERCIO","commercialName":"","cnpj":"83053660000168","city":"CAÇADOR","stateCode":"SC","buscaAdicional":"SINCOL 1907 SINCOL-CACADOR-SC 70263"},{"id":"d61ffa93-a9c3-4f98-65e6-08d5ad2bf6ba","name":"PRINTBAG EMBALAGENS LTDA","commercialName":"","cnpj":"07599090000128","city":"CAMBORIÚ","stateCode":"SC","buscaAdicional":"PRINTBAG 57189 PRINTBAG CAMBORIU 907729"},{"id":"eb4e74c7-a8de-45cd-6915-08d5ad2bf6ba","name":"BOA ESPERANCA INDUSTRIA COM E EXPORT DE MADEIRAS LTDA","commercialName":"","cnpj":"95758017000119","city":"CAPÃO ALTO","stateCode":"SC","buscaAdicional":"BOA ESPERANCA 60763 BOA ESPERANCA 911872"},{"id":"41e6a532-bbb6-482f-616f-08d5ad2bf6ba","name":"INDUSTRIA DE MOVEIS 3 IRMAOS SOCIEDADE ANONIMA","commercialName":"","cnpj":"82767641000130","city":"CAMPO ALEGRE","stateCode":"SC","buscaAdicional":"MOV 3 IRMAOS 54185 MOVEIS TRES IRMAOS 905852"},{"id":"21dfef7a-bed6-4003-5381-08d5ad2bf6ba","name":"BUDDEMEYER ACABAMENTO TEXTIL LTDA","commercialName":"","cnpj":"79865465000165","city":"CAMPO ALEGRE","stateCode":"SC","buscaAdicional":"BUDDEMEYER A 3672 BUDDEMEYER TEXTIL 71229"},{"id":"a6a09cb2-26af-4333-5059-08d5ad2bf6ba","name":"CAMPOS NOVOS ENERGIA S.A.","commercialName":"ENERCAN","cnpj":"03356967000107","city":"CAMPOS NOVOS","stateCode":"SC","buscaAdicional":"ENERCAN 1583 CAMPOS NOVOS 8138 UHE.PH.SC.027401-1.01"},{"id":"d87c5788-3964-47c2-5973-08d5ad2bf6ba","name":"PINHAL GERADORA DE ENERGIA S A","commercialName":"PINHAL GERADORA DE ENERGIA S A","cnpj":"12979342000184","city":"CAMPOS NOVOS","stateCode":"SC","buscaAdicional":"PGE 14543 PCH PITO 896554 PCH.PH.SC.030794-7.01"},{"id":"41490005-9be3-4047-6024-08d5ad2bf6ba","name":"COOPERATIVA REGIONAL AGROPECUARIA DE CAMPOS NOVOS - COPERCAMPOS","commercialName":"COPERCAMPOS","cnpj":"83158824000111","city":"CAMPOS NOVOS","stateCode":"SC","buscaAdicional":"COPERCAMPOS 53401 COPERCAMPOS FILIAL 1 905473 COPERCAMPOS FILIAL 2 905476 COPERCAMPOS SCHIO RS 899953"},{"id":"a1eaa24c-f916-49e8-6287-08d5ad2bf6ba","name":"COOPERATIVA AGROPECUARIA CAMPONOVENSE","commercialName":"","cnpj":"95851390000110","city":"CAMPOS NOVOS","stateCode":"SC","buscaAdicional":"COOCAM 54794 COOP CAMPONOVENSE 905878"},{"id":"7a5ab2ff-2c88-4bf8-51e2-08d5ad2bf6ba","name":"ENERGIA MADEIRAS - INDUSTRIAL E COMERCIAL S A","commercialName":"","cnpj":"10432020000195","city":"CANOINHAS","stateCode":"SC","buscaAdicional":"UTE MADEIRAS 2695 ENERGIA MADEIRAS 8087 UTE.FL.SC.028140-9.01"},{"id":"131ec38d-88cf-4ada-5785-08d5ad2bf6ba","name":"CIA CANOINHAS DE PAPEL","commercialName":"","cnpj":"76827344000130","city":"CANOINHAS","stateCode":"SC","buscaAdicional":"CANOINHAS 8989 CIA CANOINHAS 888860"},{"id":"f8b286a0-1b8f-46c0-5b07-08d5ad2bf6ba","name":"KLEINER SCHEIN INDUSTRIA DE MOVEIS E DECORACOES LTDA","commercialName":"FOCO DECORACOES","cnpj":"04721465000192","city":"CAPIVARI DE BAIXO","stateCode":"SC","buscaAdicional":"KLEINER SCHEIN 50393 KLEINER SCHEIN 897309"},{"id":"a352391a-0c26-4e2d-54b1-08d5ad2bf6ba","name":"CHALANA ENERGETICA LTDA","commercialName":"","cnpj":"09310523000109","city":"CAXAMBU DO SUL","stateCode":"SC","buscaAdicional":"CHALANA 4442 LAMBEDOR 8911 CGH.PH.SC.030151-5.01"},{"id":"ef0b97ff-901d-4fbf-5ef0-08d5ad2bf6ba","name":"ANTUNES ENERGIA LTDA","commercialName":"CGH ANTUNES","cnpj":"11844091000168","city":"CELSO RAMOS","stateCode":"SC","buscaAdicional":"ANTUNES ENERGIA 52617 CGH ANTUNES 908539 CGH.PH.SC.030880-3.01"},{"id":"dc660199-e213-47b0-5cd4-08d5ad2bf6ba","name":"CONDOMINIO SHOPPING PATIO CHAPECO","commercialName":"","cnpj":"13791890000149","city":"CHAPECÓ","stateCode":"SC","buscaAdicional":"PATIO CHAPECO 51581 SHOP PATIO CHAPECO 899178"},{"id":"02c6f043-9e0b-4759-5d30-08d5ad2bf6ba","name":"BRASPLAST IND & COM DE PLASTICOS LTDA","commercialName":"","cnpj":"80933179000179","city":"CHAPECÓ","stateCode":"SC","buscaAdicional":"BRASPLAST 51730 BRASPLAST 899793"},{"id":"525660b8-0107-4279-5b1e-08d5ad2bf6ba","name":"SAFRIO SERVICOS DE ARMAZENAGEM FRIGORIFICADA LTDA","commercialName":"SAFRIO","cnpj":"03984880000176","city":"CHAPECÓ","stateCode":"SC","buscaAdicional":"SAFRIO 50474 SAFRIO CHAPECO 897866 SAFRIO ITAJAI 897448"},{"id":"4c0ffec6-af6a-437e-5a84-08d5ad2bf6ba","name":"IPE ENERGIA LTDA","commercialName":"IPE ENERGIA","cnpj":"10545810000187","city":"CHAPECÓ","stateCode":"SC","buscaAdicional":"IPE ENERGIA 49944 RONDINHA CHALANA 905056 CGH.PH.SC.034056-1.01"},{"id":"04b3f493-f669-4b4c-5c0e-08d5ad2bf6ba","name":"BUGIO AGROPECUARIA LTDA","commercialName":"","cnpj":"82996521000105","city":"CHAPECÓ","stateCode":"SC","buscaAdicional":"ECOFRIGO 51051 BUGIO AGROPECUARIA 898959"},{"id":"17ea0941-91cb-471d-5485-08d5ad2bf6ba","name":"FUNDACAO UNIVERSITARIA DO DESENVOLVIMENTO DO OESTE","commercialName":"FUNDESTE","cnpj":"82804642000108","city":"CHAPECÓ","stateCode":"SC","buscaAdicional":"UNOCHAPECO 4322 UNOCHAPECO 71532"},{"id":"81e52e5c-7976-47fa-5670-08d5ad2bf6ba","name":"AZEPLAST INDUSTRIA E COMERCIO LTDA","commercialName":"","cnpj":"83062174000106","city":"CHAPECÓ","stateCode":"SC","buscaAdicional":"AZEPLAST 7080 AZEPLAST - CHAPECO 72204"},{"id":"d8bc7fc5-b099-461d-51f0-08d5ad2bf6ba","name":"RODEIO BONITO HIDRELETRICA LTDA","commercialName":"","cnpj":"09127923000183","city":"CHAPECÓ","stateCode":"SC","buscaAdicional":"R BONITO 2731 RODEIO BONITO 8592 PCH.PH.SC.029159-5.01"},{"id":"6bc8b206-d0f0-4459-51cb-08d5ad2bf6ba","name":"CHAPECO GERACAO DE ENERGIA LTDA","commercialName":"CHAPECO ENERGIAS","cnpj":"08347345000128","city":"CHAPECÓ","stateCode":"SC","buscaAdicional":"CHAPECO GERA 2596 INDIO CONDA 8593 CGH.PH.SC.029590-6.01"},{"id":"91b4490f-9d94-45fb-503b-08d5ad2bf6ba","name":"COOPERATIVA CENTRAL AURORA ALIMENTOS","commercialName":"AURORA ALIMENTOS","cnpj":"83310441000117","city":"CHAPECÓ","stateCode":"SC","buscaAdicional":"AURORA MATRIZ 1530 AURORA FAAL 907222 AURORA FACH 1 907752 AURORA FACH 2 907238 AURORA FAG 907224 AURORA FAMH 907753 AURORA FAQUI 907240 AURORA ILAPZO 907225"},{"id":"c85ce635-c951-446b-64ca-08d5ad2bf6ba","name":"TIMBO ENERGIA LTDA","commercialName":"TIMBO ENERGIA","cnpj":"09365459000163","city":"CHAPECÓ","stateCode":"SC","buscaAdicional":"TGE 56223 CGH BARRA CARNEIRO 908863 CGH.PH.SC.037315-0.01"},{"id":"1cdf4af1-2df0-4b19-6411-08d5ad2bf6ba","name":"A.P CHAPECO SERVICOS DE LOGISTICA LTDA","commercialName":"","cnpj":"22735063000129","city":"CHAPECÓ","stateCode":"SC","buscaAdicional":"AP CHAPECO 55816 AP CHAPECO 907724"},{"id":"e160cf22-ba89-4921-6359-08d5ad2bf6ba","name":"BRASAO SUPERMERCADOS S/A","commercialName":"SUPERMERCADO BRASAO","cnpj":"83307926000151","city":"CHAPECÓ","stateCode":"SC","buscaAdicional":"BRASAO SUPERMERCADOS 55323 BRASAO CHAPECO 906532 BRASAO JD AMERICA 906533"},{"id":"72d8b4c6-8394-48d2-673a-08d5ad2bf6ba","name":"ENERGETICA UVAIA LTDA","commercialName":"ENERGETICA UVAIA","cnpj":"10980551000112","city":"CHAPECÓ","stateCode":"SC","buscaAdicional":"UVAIA 58008 CGH UVAIA 908991 CGH.PH.SC.035739-1.01"},{"id":"00f395a4-5632-4e8c-502b-08d5ad2bf6ba","name":"ELIANE S/A - REVESTIMENTOS CERAMICOS","commercialName":"","cnpj":"86532538000162","city":"COCAL DO SUL","stateCode":"SC","buscaAdicional":"ELIANE 1485 ELIANE-COCAL DO SUL 7875 ELIANE-CRICIUMA-SC 70176"},{"id":"0fd3c4dd-d7f1-4c17-5d4d-08d5ad2bf6ba","name":"COOPERATIVA DE PRODUCAO E CONSUMO CONCORDIA","commercialName":"","cnpj":"83573212000195","city":"CONCÓRDIA","stateCode":"SC","buscaAdicional":"COPERDIA 51776 COOPERATIVA CONCOR 900936 COPERDIA MAFRA 901693 CONCORDIA 903554 SUPERMERCADO 910845"},{"id":"f5c2ae35-fa1e-46c7-5fc1-08d5ad2bf6ba","name":"KERBERMIX - SERVICOS DE CONCRETAGEM LTDA","commercialName":"","cnpj":"79280459000146","city":"CONCÓRDIA","stateCode":"SC","buscaAdicional":"KERBERMIX 53209 KERBERMIX CONCORDIA 907209"},{"id":"a7fb44a0-3c77-4c1c-609b-08d5ad2bf6ba","name":"INCOBIO INDUSTRIA E COMERCIO DE BIOMASSA COMBUSTIVEL LTDA","commercialName":"","cnpj":"03391986000166","city":"CONCÓRDIA","stateCode":"SC","buscaAdicional":"INCOBIO 53614 INCOBIO - CONCORDIA 904312"},{"id":"c61de85b-9516-4e9f-60c9-08d5ad2bf6ba","name":"PASSARELA CENTER LTDA.","commercialName":"","cnpj":"03107202000125","city":"CONCÓRDIA","stateCode":"SC","buscaAdicional":"PASSARELA 53721 PASSARELA CONCORDIA 904282"},{"id":"5c305945-d71b-48a9-6273-08d5ad2bf6ba","name":"BRASIL SUL GERACAO DE ENERGIA LTDA","commercialName":"","cnpj":"18900686000132","city":"CONCÓRDIA","stateCode":"SC","buscaAdicional":"CGH PINHAL 54764 CGH PINHAL 908515 CGH.PH.SC.037420-2.01"},{"id":"bd782278-3640-41dd-6159-08d5ad2bf6ba","name":"GRAFICA ESTRELA LTDA","commercialName":"","cnpj":"83571539000128","city":"CONCÓRDIA","stateCode":"SC","buscaAdicional":"GRAFICA ESTRELA 54144 GRAFICA ESTRELA 905862"},{"id":"8dcbf373-2c2d-448e-6215-08d5ad2bf6ba","name":"VIERO MOVEIS INDUSTRIA E COMERCIO LTDA","commercialName":"","cnpj":"83571471000187","city":"CONCÓRDIA","stateCode":"SC","buscaAdicional":"VIERO MOVEIS 54549 VIERO MOVEIS CONCORD 904358"},{"id":"275e991e-c549-4817-5d45-08d5ad2bf6ba","name":"FUNDICAO FUNDIFER LTDA","commercialName":"","cnpj":"02205767000182","city":"CORUPÁ","stateCode":"SC","buscaAdicional":"FUNDIFER 51754 FUNDIFER 899279"},{"id":"5566e21d-164c-48e9-6331-08d5ad2bf6ba","name":"NEREU RODRIGUES & CIA LTDA","commercialName":"MADEIREIRA RODRIGUES","cnpj":"72207632000131","city":"CORREIA PINTO","stateCode":"SC","buscaAdicional":"MADEREIRA RODRIGUES 55240 NEREU RODRIGUES 905865"},{"id":"2f7ec80d-5eb9-4f49-6264-08d5ad2bf6ba","name":"INDUSTRIA E COMERCIO DE CONFECCOES LA MODA LTDA","commercialName":"INDUSTRIA E COMERCIO DE CONFECCOES LA MODA","cnpj":"79653119000113","city":"CRICIÚMA","stateCode":"SC","buscaAdicional":"LA MODA 54743 LA MODA 905028"},{"id":"fcb1b6fd-fe42-472e-61f2-08d5ad2bf6ba","name":"SALVARO INDUSTRIA E COMERCIO DE MADEIRA LTDA","commercialName":"","cnpj":"80142250000103","city":"CRICIÚMA","stateCode":"SC","buscaAdicional":"SALVARO 54483 SALVARO CRICIUMA 905876"},{"id":"38fa6192-90eb-461b-615c-08d5ad2bf6ba","name":"ASSOCIACAO BENEFICENTE DA INDUSTRIA CARBONIFERA DE SANTA CATARINA (SATC)","commercialName":"COLEGIO SATC","cnpj":"83649830000171","city":"CRICIÚMA","stateCode":"SC","buscaAdicional":"SATC 54153 SATC CRICIUMA 904302"},{"id":"223bc1ba-471a-4f16-6361-08d5ad2bf6ba","name":"SBM - SUL BRASILEIRA DE MINERACAO LTDA","commercialName":"","cnpj":"14779384000105","city":"CRICIÚMA","stateCode":"SC","buscaAdicional":"SBM 1 55331 SBM VARGEM BONITA 905913 SBM MARACAJA 909856 SBM CAMPOS NOVOS 910571 SBM URUSSANGA 905877"},{"id":"23366b92-e466-4049-674d-08d5ad2bf6ba","name":"SOCIEDADE LITERARIA E CARITATIVA SANTO AGOSTINHO","commercialName":"HOSPITAL SAO JOSE","cnpj":"92736040000890","city":"CRICIÚMA","stateCode":"SC","buscaAdicional":"HOSPITAL SAO JOSE 58035 SOC. LITERARIA E CAR 911957"},{"id":"26f83cb4-c7c1-4110-670e-08d5ad2bf6ba","name":"GRAFAPLAST EMBALAGENS EIRELI","commercialName":"GRAFAPLAST EMBALAGENS","cnpj":"07134878000169","city":"CRICIÚMA","stateCode":"SC","buscaAdicional":"GRAFAPLAST 57940 GRAFAPLAST 911853"},{"id":"fc5cf274-b1be-4345-6859-08d5ad2bf6ba","name":"ALTHOFF SUPERMERCADOS LTDA","commercialName":"ALTHOFF","cnpj":"83646604000137","city":"CRICIÚMA","stateCode":"SC","buscaAdicional":"ALTHOFF SUPERMERCADOS 59852 ALTHOFF L01 - IMBITU 912432 ALTHOFF L14 - TUBARA 912433 ALTHOFF L12 - LAGUNA 912451"},{"id":"25a43e82-da49-4c92-88fb-08d5ae44ed50","name":"SULACO FUNDICAO DE FERRO E ACO LTDA","commercialName":"","cnpj":"10291625000103","city":"CRICIÚMA","stateCode":"SC","buscaAdicional":"SULACO 58157 SULACO 909315"},{"id":"994407d3-ecdb-4729-5ce1-08d5ad2bf6ba","name":"CARBONIFERA METROPOLITANA S/A","commercialName":"","cnpj":"83647917000100","city":"CRICIÚMA","stateCode":"SC","buscaAdicional":"CARB. METROPOLITANA 51599 CARBONIFERA TREVISO 899974"},{"id":"94b9b84d-b7a1-488e-5e71-08d5ad2bf6ba","name":"FUNDACAO EDUCACIONAL DE CRICIUMA","commercialName":"UNIVERSIDADE DO EXTREMO SUL CATARINENSE - UNESC","cnpj":"83661074000104","city":"CRICIÚMA","stateCode":"SC","buscaAdicional":"UNESC 52386 UNESC 900895"},{"id":"56125008-8194-4134-60c8-08d5ad2bf6ba","name":"SIDERURGICA CATARINENSE LTDA","commercialName":"","cnpj":"83663625000160","city":"CRICIÚMA","stateCode":"SC","buscaAdicional":"SIDER CATARINENSE 53720 SIDER CATARINENSE 904153"},{"id":"92d07ad0-0dc1-4f8a-5fed-08d5ad2bf6ba","name":"PIERINI REVESTIMENTOS CERAMICOS LTDA","commercialName":"","cnpj":"81766156000180","city":"CRICIÚMA","stateCode":"SC","buscaAdicional":"PIERINI 53287 PIERINI 901140"},{"id":"8620e078-9e5d-43d6-6069-08d5ad2bf6ba","name":"CONDOMINIO DO CRICIUMA SHOPPING CENTER","commercialName":"","cnpj":"01453070000168","city":"CRICIÚMA","stateCode":"SC","buscaAdicional":"SHOP CRICIUMA 53497 SHOP CRICIUMA 902697"},{"id":"2d6464bf-9aa2-49f2-5b78-08d5ad2bf6ba","name":"INDUSTRIA CARBONIFERA RIO DESERTO LTDA","commercialName":"","cnpj":"83286500000169","city":"CRICIÚMA","stateCode":"SC","buscaAdicional":"IND RIO DESERTO 50713 RIO DESERTO 898130"},{"id":"bee9b9c9-7f48-4921-5aa2-08d5ad2bf6ba","name":"ANJO QUIMICA DO BRASIL LTDA","commercialName":"ANJO TINTAS E SOLVENTES","cnpj":"02921346000158","city":"CRICIÚMA","stateCode":"SC","buscaAdicional":"ANJO 50123 ANJO QUIMICA 01 897224 ANJO QUIMICA UN 3 897284 ANJO QUIMICA 2 898109"},{"id":"34c06da2-9ca9-4a64-5959-08d5ad2bf6ba","name":"INDUSTRIA DE EMBALAGENS PLASTICAS GUARA LTDA","commercialName":"GUARA EMBALAGENS","cnpj":"78813789000197","city":"CRICIÚMA","stateCode":"SC","buscaAdicional":"GUARA MATRIZ 14278 GUARA CRICIUMA 893662"},{"id":"5761828b-de80-48d7-5027-08d5ad2bf6ba","name":"CECRISA REVESTIMENTOS CERAMICOS S.A","commercialName":"","cnpj":"79655916000130","city":"CRICIÚMA","stateCode":"SC","buscaAdicional":"CECRISA MAT 1479 CECRISA ELDORADO-SC 7877 CECRISA PORTINARI CR 70365 CECRISA S.LUZIA MG 70441 CECRISA-TUBARAO-SC 7897 CECRISA ANAPOLIS 7595"},{"id":"994b4ced-a3f4-4792-50fd-08d5ad2bf6ba","name":"IMBRALIT INDUSTRIA E COMERCIO DE ARTEFATOS E FRIBROCIMENTO LTDA EM RECUPERACAO JUDICIAL","commercialName":"IMBRALIT","cnpj":"83724302000130","city":"CRICIÚMA","stateCode":"SC","buscaAdicional":"IMBRALIT 1937 IMBRALIT 897487"},{"id":"03b56d17-68ba-4aed-5656-08d5ad2bf6ba","name":"CERAMICA ELIZABETH SUL LTDA","commercialName":"CERAMICA ELIZABETH SUL LTDA","cnpj":"08944802000161","city":"CRICIÚMA","stateCode":"SC","buscaAdicional":"ELIZABETHSUL 6918 CERAMICA ELIZABETH 72372"},{"id":"bfd0b529-70b6-418f-54f8-08d5ad2bf6ba","name":"A. ANGELONI & CIA. LTDA","commercialName":"SUPERMERCADOS ANGELONI","cnpj":"83646984000100","city":"CRICIÚMA","stateCode":"SC","buscaAdicional":"ANGELONI 4621 ANGELONI LJ22-JGSUL 71668 ANGELONI LJ11 FLORPA 71822 ANGELONI CD 52 888400 ANGELONI LJ 15 888744 ANGELONI LJ 23 888746 ANGELONI LJ 20 888829 ANGELONI LJ 13 889113 ANGELONI LJ 19 889114 ANGELONI LJ 2 889250 ANGELONI LJ 18 889383 ANGELONI LJ 14 889384 ANGELONI LJ 17 889438 ANGELONI LJ 10 889439 ANGELONI LJ 06 889440 ANGELONI LJ 04 889599 ANGELONI LJ 09 889600 ANGELONI LJ 21 889804 ANGELONI LJ 08 889806 ANGELONI BIGUACU25 890009 ANGELONI INGLESES 891041 ANGELONI ARARANGUA 891303 ANGELONI CRICIUMA 891465 ANGELONI MARINGA 892410 ANGELONI LOJA 24 893002 ANGELONI LOJA 16 893582 ANGELONI LAGES 894064 ANGELONI POSTO 63 894893 ANGELONI POSTO 64 895147 ANGELONI - ACAC 895841 ANGELONI - POSTO 71 897366 ANGELONI - POSTO 60 897367 ANGELONI BRUSQUE 33 903958"},{"id":"12102aa3-ac5d-445f-550a-08d5ad2bf6ba","name":"MAROMBAS INDUSTRIA E COMERCIO DE PAPELAO LTDA.","commercialName":"","cnpj":"83752618000135","city":"CURITIBANOS","stateCode":"SC","buscaAdicional":"MAROMBAS 4943 BOSSARDI 8918 CGH.PH.SC.028082-8.01 RIO DAS PEDRAS (MAR) 8919 CGH.PH.SC.002340-0.01"},{"id":"2564ff7b-82d7-453d-5974-08d5ad2bf6ba","name":"COMPANHIA ENERGETICA CANOAS","commercialName":"COMPANHIA ENERGETICA CANOAS","cnpj":"10618009000114","city":"CURITIBANOS","stateCode":"SC","buscaAdicional":"CEC CANOAS 14545 ADO POPINHAK 908902 PCH.PH.SC.031598-2.01"},{"id":"67c0cfcc-d5b8-431b-67e0-08d5ad2bf6ba","name":"UNIAO FOSFOREIRA LTDA.","commercialName":"","cnpj":"03518203000162","city":"CURITIBANOS","stateCode":"SC","buscaAdicional":"UNIAO FOSFOREIRA 58790 UNIAO FOSFOREIRA 909651"},{"id":"69123afa-743c-44e3-59ff-08d5ad2bf6ba","name":"FI BRA GERACAO LTDA","commercialName":"","cnpj":"11815365000190","city":"DONA EMMA","stateCode":"SC","buscaAdicional":"FIBRA GERACAO 16315 HELENA KUHLEMANN 895161 CGH.PH.SC.030387-9.02"},{"id":"efd989d8-c072-45a6-5854-08d5ad2bf6ba","name":"HYDRO KUHLEMANN GERACAO LTDA","commercialName":"","cnpj":"11810477000159","city":"DONA EMMA","stateCode":"SC","buscaAdicional":"HYDRO KUHLEMANN 11370 KARL KUHLEMANN 891505 CGH.PH.SC.030394-1.02"},{"id":"9f782bea-4526-4a16-5247-08d5ad2bf6ba","name":"COOPERATIVA DE GERACAO DE ENERGIA ELETRICA SALTO DONNER","commercialName":"CERSAD GERADORA","cnpj":"85937290000157","city":"DOUTOR PEDRINHO","stateCode":"SC","buscaAdicional":"CERSAD GERADORA 2986 SALTO DONNER I 8227 PCH.PH.SC.028931-0.01 S DONNER II 8988 PCH.PH.SC.030353-4.01"},{"id":"b4a5e7b1-8be1-43f6-581e-08d5ad2bf6ba","name":"CENTRAIS CANDEEIRO DE ENERGIA S.A","commercialName":"","cnpj":"08683786000109","city":"ERVAL VELHO","stateCode":"SC","buscaAdicional":"CANDEEIRO 10770 CAMBOATA 890398 CGH.PH.SC.030172-8.02"},{"id":"e0d5fe7c-ccf1-4da8-603a-08d5ad2bf6ba","name":"AVELINO BRAGAGNOLO S A INDUSTRIA E COMERCIO","commercialName":"ABRASA","cnpj":"84586833000257","city":"FAXINAL DOS GUEDES","stateCode":"SC","buscaAdicional":"BRAGAGNOLO 53431 BRAGAGNOLO COMERCIO 900613"},{"id":"bd4981bc-ef36-4718-5d8f-08d5ad2bf6ba","name":"SUPERMERCADO FELIPE ROYER LTDA","commercialName":"MERCADO HIPER BOM","cnpj":"04031026000158","city":"FLORIANÓPOLIS","stateCode":"SC","buscaAdicional":"HIPERBOM 51913 HIPERBOM LOJA 3 904129 HIPERBOM 31054923 913473"},{"id":"2e5543fa-d210-4702-5826-08d5ad2bf6ba","name":"PCH SANTA ROSA S/A","commercialName":"","cnpj":"09037826000108","city":"FLORIANÓPOLIS","stateCode":"SC","buscaAdicional":"PCH SANTA ROSA 10831 SANTA ROSA (STAROSA) 891322 PCH.PH.SC.028844-6.01"},{"id":"37ac79df-f74d-4194-59a3-08d5ad2bf6ba","name":"LEAO BRANCO GERACAO DE ENERGIA S/A","commercialName":"","cnpj":"05729514000104","city":"FLORIANÓPOLIS","stateCode":"SC","buscaAdicional":"PCH SPESSATTO 15275 SPESSATTO 896844 CGH.PH.SC.029771-2.02"},{"id":"1374ef4f-0dd5-4539-5990-08d5ad2bf6ba","name":"GARCA BRANCA ENERGETICA SA","commercialName":"","cnpj":"10514202000105","city":"FLORIANÓPOLIS","stateCode":"SC","buscaAdicional":"PCH GARCA BRANCA 14895"},{"id":"dc8b613e-5995-4a1d-5986-08d5ad2bf6ba","name":"EOLICA HERMENEGILDO II S.A.","commercialName":"EOLICA HERMENEGILDO II","cnpj":"19660985000100","city":"FLORIANÓPOLIS","stateCode":"SC","buscaAdicional":"HERMENEGILDO II 14797 VERACE 28 896933 EOL.CV.RS.031578-8.01 VERACE 29 896934 EOL.CV.RS.031557-5.01 VERACE 30 896935 EOL.CV.RS.031602-4.01 VERACE 31 896936 EOL.CV.RS.031558-3.01"},{"id":"0d083a52-2428-4abf-5987-08d5ad2bf6ba","name":"EOLICA HERMENEGILDO III S.A.","commercialName":"EOLICA HERMENEGILDO III","cnpj":"19660995000145","city":"FLORIANÓPOLIS","stateCode":"SC","buscaAdicional":"HERMENEGILDO III 14815 VERACE 34 896937 EOL.CV.RS.031601-6.01 VERACE 36 896938 EOL.CV.RS.031610-5.01 VERACE 35 896939 EOL.CV.RS.031539-7.01"},{"id":"00f8b556-3a30-4948-5988-08d5ad2bf6ba","name":"EOLICA CHUI IX S.A.","commercialName":"EOLICA CHUI IX","cnpj":"19661005000193","city":"FLORIANÓPOLIS","stateCode":"SC","buscaAdicional":"CHUI IX 14817 CHUI IX 896306 EOL.CV.RS.031517-6.01"},{"id":"0f8b62eb-f9b1-4e9b-5989-08d5ad2bf6ba","name":"EOLICA HERMENEGILDO I S.A.","commercialName":"EOLICA HERMNEGILDO I","cnpj":"19661000000160","city":"FLORIANÓPOLIS","stateCode":"SC","buscaAdicional":"HERMENEGILDO I 14818 VERACE 24 896932 EOL.CV.RS.031561-3.01 VERACE 25 896930 EOL.CV.RS.031541-9.01 VERACE 26 896931 EOL.CV.RS.031559-1.01 VERACE 27 896929 EOL.CV.RS.031600-8.01"},{"id":"626daedc-8306-4558-5b7a-08d5ad2bf6ba","name":"CENTRAL EOLICA ESTRELA S.A.","commercialName":"","cnpj":"09265464000102","city":"FLORIANÓPOLIS","stateCode":"SC","buscaAdicional":"EOLICA ESTRELA 50715 ESTRELA 906175 EOL.CV.CE.032010-2.01"},{"id":"5b9e976e-c812-4b15-5b67-08d5ad2bf6ba","name":"CENTRAL EOLICA OURO VERDE SPE S.A.","commercialName":"","cnpj":"16849271000156","city":"FLORIANÓPOLIS","stateCode":"SC","buscaAdicional":"EOLICA OURO VERDE 50696 EOLICA OURO VERDE 906645 EOL.CV.CE.032012-9.01"},{"id":"43576936-aaac-4c79-5b68-08d5ad2bf6ba","name":"CENTRAL EOLICA CACIMBAS S.A.","commercialName":"","cnpj":"13389543000194","city":"FLORIANÓPOLIS","stateCode":"SC","buscaAdicional":"EOLICA CACIMBAS 50697 EOL CACIMBAS 1 905233 EOL.CV.CE.032011-0.01"},{"id":"8329183d-7e0b-4dd4-5b69-08d5ad2bf6ba","name":"CENTRAL EOLICA SANTA MONICA SPE S.A.","commercialName":"CENTRAL EOLICA SANTA MONICA SPE","cnpj":"12445328000109","city":"FLORIANÓPOLIS","stateCode":"SC","buscaAdicional":"EOLICA SANTA MONICA 50698 SANTA MONICA I 901795 EOL.CV.CE.032013-7.01"},{"id":"ad4060b5-df99-407d-5ba6-08d5ad2bf6ba","name":"PESQUEIRA PIONEIRA DA COSTA SA","commercialName":"","cnpj":"83897710000193","city":"FLORIANÓPOLIS","stateCode":"SC","buscaAdicional":"PIONEIRA MATRIZ 50809 PESQ PIONEIRA COSTA 911816"},{"id":"d1a1b854-f74f-4451-52cc-08d5ad2bf6ba","name":"ENERGEN ENERGIAS RENOVAVEIS S/A","commercialName":"","cnpj":"08207876000115","city":"FLORIANÓPOLIS","stateCode":"SC","buscaAdicional":"ENERGEN 3316 B COQUEIROS (ENERG) 20033 EOL.CV.SE.030296-1.01"},{"id":"1d5136fc-68a7-4e15-52e2-08d5ad2bf6ba","name":"SEABRA ENERGETICA S/A","commercialName":"","cnpj":"09196341000159","city":"FLORIANÓPOLIS","stateCode":"SC","buscaAdicional":"EOL SEABRA 3342 SEABRA 20012 EOL.CV.BA.030306-2.01"},{"id":"9be72981-9340-4284-52e0-08d5ad2bf6ba","name":"NOVO HORIZONTE ENERGETICA S/A","commercialName":"","cnpj":"09214349000109","city":"FLORIANÓPOLIS","stateCode":"SC","buscaAdicional":"EOL NOVO HORIZ 3340 N.HORIZONTE - EOL NH 20013 EOL.CV.BA.030305-4.01"},{"id":"e1441115-35c9-4107-52de-08d5ad2bf6ba","name":"MACAUBAS ENERGETICA SA","commercialName":"","cnpj":"09194393000196","city":"FLORIANÓPOLIS","stateCode":"SC","buscaAdicional":"EOL MACAUBAS 3338 MACAUBAS 20011 EOL.CV.BA.030283-0.01"},{"id":"06d2b7cd-b89e-42b3-51cf-08d5ad2bf6ba","name":"IBITIUVA BIOENERGETICA S.A.","commercialName":"","cnpj":"09541336000136","city":"FLORIANÓPOLIS","stateCode":"SC","buscaAdicional":"IBITIUVA 2602 IBITIUVA-IBITL 8662 UTE.AI.SP.027768-1.01"},{"id":"ee9d18d6-ab37-439a-518d-08d5ad2bf6ba","name":"COMPANHIA ENERGETICA ESTREITO","commercialName":"CEE","cnpj":"08976022000101","city":"FLORIANÓPOLIS","stateCode":"SC","buscaAdicional":"CEE 2366 ESTREITO CEE 8828 UHE.PH.MA.028863-2.01"},{"id":"43746d03-bbe6-4745-5189-08d5ad2bf6ba","name":"FOZ DO CHAPECO ENERGIA S.A.","commercialName":"","cnpj":"04591168000170","city":"FLORIANÓPOLIS","stateCode":"SC","buscaAdicional":"FOZ DO CHAPECO 2236 FOZ CHAPECO 889213 UHE.PH.RS.028354-1.01"},{"id":"d9ad002f-b79e-47a2-50fc-08d5ad2bf6ba","name":"CELESC DISTRIBUICAO S.A","commercialName":"CELESC DISTRIBUICAO S.A","cnpj":"08336783000190","city":"FLORIANÓPOLIS","stateCode":"SC","buscaAdicional":"CELESC DIST 1936 CELESC 42"},{"id":"2edb0c1d-2d25-4aa9-50f7-08d5ad2bf6ba","name":"CELESC GERACAO S.A","commercialName":"CELESC GERACAO S.A","cnpj":"08336804000178","city":"FLORIANÓPOLIS","stateCode":"SC","buscaAdicional":"CELESC GERA 1924 GARCIA ACL 895721 UHE.PH.SC.001019-7.02 BRACINHO ACL 905964 UHE.PH.SC.000302-6.02 CEDROS ACL 906038 UHE.PH.SC.000737-4.02 SALTO WEISSBACH 8082 UHE.PH.SC.002682-4.02 PERY 8079 PCH.PH.SC.002045-1.01 RIO DO PEIXE 8084 CGH.PH.SC.029368-7.01 GRANJA SAO ROQUE 8847 UTE.RA.SC.030848-0.01 GARCIA 347 UHE.PH.SC.001019-7.02 BRACINHO 8070 UHE.PH.SC.000302-6.02 CEDROS 8075 UHE.PH.SC.000737-4.02 PALMEIRAS (CELESC) 8081 UHE.PH.SC.001945-3.01 PALMEIRAS ACL 906039 UHE.PH.SC.001945-3.01 SALTO ACL 906040 UHE.PH.SC.002682-4.02 CELSO RAMOS 8076 PCH.PH.SC.000742-0.01 IVO SILVEIRA 8078 CGH.PH.SC.001202-5.02 PIRAI 8080 CGH.PH.SC.002076-1.02 SAO LOURENCO(CELESC) 8083 CGH.PH.SC.027186-1.01 PALMEIRAS ACL 906039 UHE.PH.SC.001945-3.01 SALTO ACL 906040 UHE.PH.SC.002682-4.02 CAVEIRAS 8077 UHE.PH.SC.000728-5.01 GARCIA ACL 895721 UHE.PH.SC.001019-7.02 BRACINHO ACL 905964 UHE.PH.SC.000302-6.02 CEDROS ACL 906038 UHE.PH.SC.000737-4.02"},{"id":"1d89244e-0969-416a-5115-08d5ad2bf6ba","name":"CONDOMINIO CIVIL DO SHOPPING CENTER IGUATEMI FLORIANOPOLIS","commercialName":"","cnpj":"08507747000142","city":"FLORIANÓPOLIS","stateCode":"SC","buscaAdicional":"IGUATEMI FLOR 1986 IGUATEMI-FLORIANOP 70364"},{"id":"9feaacaa-940e-43d1-5121-08d5ad2bf6ba","name":"MONEL MONJOLINHO ENERGETICA S/A","commercialName":"","cnpj":"04834395000189","city":"FLORIANÓPOLIS","stateCode":"SC","buscaAdicional":"MONEL 2012 MONJOLINHO (MONEL) 8554 UHE.PH.RS.028562-5.01"},{"id":"89ebc6bd-98db-4b87-4f4b-08d5ad2bf6ba","name":"CERAN - COMPANHIA ENERGETICA RIO DAS ANTAS","commercialName":"","cnpj":"04237975000199","city":"FLORIANÓPOLIS","stateCode":"SC","buscaAdicional":"CERAN 202 MONTE CLARO 8056 UHE.PH.RS.027968-4.01 CASTRO ALVES 8306 UHE.PH.RS.000718-8.01 14 DE JULHO 8452 UHE.PH.RS.000012-4.01"},{"id":"d075f410-28fd-4173-4f26-08d5ad2bf6ba","name":"ENGIE BRASIL ENERGIA COMERCIALIZADORA LTDA","commercialName":"","cnpj":"04100556000100","city":"FLORIANÓPOLIS","stateCode":"SC","buscaAdicional":"ENGIE BR COM 116 GUAJIRU 891201 EOL.CV.CE.030663-0.01 TRAIRI 891202 EOL.CV.CE.030662-2.01 FLEIXEIRAS I 891506 EOL.CV.CE.030670-3.01 MUNDAU 892322 EOL.CV.CE.030656-8.01 BEBERIBE - TEC 8394 EOL.CV.CE.028174-3.01 BEBERIBE - TEC 8394 EOL.CV.CE.028174-3.01"},{"id":"6ff73eda-011d-4b4e-4f44-08d5ad2bf6ba","name":"ELETROSUL CENTRAIS ELETRICAS S/A","commercialName":"ELETROSUL","cnpj":"00073957000168","city":"FLORIANÓPOLIS","stateCode":"SC","buscaAdicional":"ELETROSUL 187 SEDE ELETROSUL 891442 ELETROSUL M SERTAO 913340 MEGAWATT 893504 UFV.RS.SC.031635-0.01 COXILHA NEGRA VII 8854 EOL.CV.RS.030350-0.01 COXILHA NEGRA VI 8900 EOL.CV.RS.030349-6.01 COXILHA NEGRA V 8957 EOL.CV.RS.030348-8.01 SAO DOMINGOS (ESUL) 888272 UHE.PH.MS.028761-0.01 BARRA DO RIO CHAPEU 888921 PCH.PH.SC.029141-2.01 JOAO BORGES 889957 PCH.PH.SC.029332-6.01 GALPOES 896788 EOL.CV.RS.031477-3.01 COXILHA SECA 896787 EOL.CV.RS.031487-0.01 CAPAO DO INGLES 896785 EOL.CV.RS.031510-9.01 PASSO SAO JOAO 8972 UHE.PH.RS.029456-0.01 MAUA (ELETROSUL) 888270 UHE.PH.PR.029598-1.01"},{"id":"e2ffa251-666b-4a59-4f07-08d5ad2bf6ba","name":"ENGIE BRASIL ENERGIA S.A.","commercialName":"","cnpj":"02474103000119","city":"FLORIANÓPOLIS","stateCode":"SC","buscaAdicional":"ENGIE BR GER 57 TBLE - SEDE 890196 TUBARAO 895123 EOL.CV.SC.032016-1.01 UFV NOVA AURORA 892971 UFV.RS.SC.031430-7.01 MACHADINHO 352 UHE.PH.SC.001356-0.01 CANA BRAVA 353 UHE.PH.GO.000630-0.01 SALTO SANTIAGO 359 UHE.PH.PR.002672-7.01 SALTO OSORIO 360 UHE.PH.PR.002659-0.01 SAO SALVADOR 8504 UHE.PH.TO.028567-6.01 JORGE LACERDA B EXP. 8363 UTE.CM.SC.027093-8.01 JORGE LACERDA C EXP. 8364 UTE.CM.SC.027094-6.01 JORGE LACERDA A2 EXP 8704 UTE.CM.SC.001260-2.01 ALEGRETE 366 UTE.PE.RS.000049-3.01 JORGE LACERDA C 364 UTE.CM.SC.027094-6.01 CHARQUEADAS 365 UTE.CM.RS.000760-9.01 MODULAR C. GRANDE 367 UTE.GN.MS.027075-0.01 ITA 414 UHE.PH.RS.001152-5.01 PONTE DE PEDRA 8050 UHE.PH.MT.002103-2.01 PASSO FUNDO 361 UHE.PH.RS.002001-0.01 JORGE LACERDA B 363 UTE.CM.SC.027093-8.01 ALEGRETE EXP. 80366 UTE.PE.RS.000049-3.01 JORGE LACERDA A2 8622 UTE.CM.SC.001260-2.01 JORGE LACERDA A1 8623 UTE.CM.SC.001260-2.01 JORGE LACERDA A1 EXP 8703 UTE.CM.SC.001260-2.01"},{"id":"7b2f577b-2ff2-4573-54fd-08d5ad2bf6ba","name":"COTESA GERADORA DE ENERGIA - PCH SAO SEBASTIAO S/A","commercialName":"","cnpj":"09442769000134","city":"FLORIANÓPOLIS","stateCode":"SC","buscaAdicional":"COTSEBASTIAO 4720 SAO SEBASTIAO 8971 PCH.PH.SC.029712-7.01"},{"id":"7a753b91-5f27-4416-54fe-08d5ad2bf6ba","name":"COTESA GERADORA DE ENERGIA - PCH SAO VALENTIN S/A","commercialName":"","cnpj":"09428250000100","city":"FLORIANÓPOLIS","stateCode":"SC","buscaAdicional":"COTVALENTIM 4721 SAO VALENTIM (COTVA) 890418 PCH.PH.SC.029710-0.01"},{"id":"d64e0d5b-8c8a-4b74-5565-08d5ad2bf6ba","name":"COSTAO DO SANTINHO TURISMO E LAZER LTDA","commercialName":"","cnpj":"04908757000139","city":"FLORIANÓPOLIS","stateCode":"SC","buscaAdicional":"CSANTINHO 5509 COSTAO SANTINHO FLOP 71911"},{"id":"7d78dca8-be64-45d8-547c-08d5ad2bf6ba","name":"COMPANHIA ENERGETICA RIO DAS FLORES","commercialName":"COMPANHIA ENERGETICA RIO DAS FLORES","cnpj":"09324664000180","city":"FLORIANÓPOLIS","stateCode":"SC","buscaAdicional":"CRF 4297 PRATA 8861 PCH.PH.SC.030093-4.01 BELMONTE 8977 PCH.PH.SC.030091-8.01"},{"id":"41712672-00e0-4bee-5463-08d5ad2bf6ba","name":"COTESA GERADORA DE ENERGIA - PCH AGUTI S/A","commercialName":"","cnpj":"09428267000159","city":"FLORIANÓPOLIS","stateCode":"SC","buscaAdicional":"COTAGUTI 4203 AGUTI 8881 PCH.PH.SC.029711-9.01"},{"id":"cedbfd63-9009-4c73-540c-08d5ad2bf6ba","name":"SAO SEBASTIAO EMPREENDIMENTOS S.A","commercialName":"","cnpj":"10488040000188","city":"FLORIANÓPOLIS","stateCode":"SC","buscaAdicional":"S SEBASTIAO 3981 SSEBASTIAO GERC 3LER 888638 PCH.PH.SC.030526-0.01"},{"id":"3e754f70-9c94-44a4-53bb-08d5ad2bf6ba","name":"MOINHO S/A","commercialName":"","cnpj":"09196223000140","city":"FLORIANÓPOLIS","stateCode":"SC","buscaAdicional":"PCH MOINHO 3811 MOINHO (PCH MOINHO) 8905 PCH.PH.RS.029725-9.01"},{"id":"e207c05d-9163-47de-5645-08d5ad2bf6ba","name":"EOLICA CERRO CHATO IV S.A.","commercialName":"","cnpj":"14620866000100","city":"FLORIANÓPOLIS","stateCode":"SC","buscaAdicional":"ECCIV 6827 CERRO CHATO IV 891522 EOL.CV.RS.030784-0.01"},{"id":"6a3bf86b-caaf-4534-5646-08d5ad2bf6ba","name":"EOLICA CERRO CHATO V S.A.","commercialName":"","cnpj":"14606642000143","city":"FLORIANÓPOLIS","stateCode":"SC","buscaAdicional":"ECCV 6828 CERRO CHATO V 892303 EOL.CV.RS.030786-6.01"},{"id":"9ae2a7b6-8698-43ab-566e-08d5ad2bf6ba","name":"EOLICA CHUI VII S.A.","commercialName":"","cnpj":"14606706000106","city":"FLORIANÓPOLIS","stateCode":"SC","buscaAdicional":"ECHVII 7062 MINUANO II 892162 EOL.CV.RS.030791-2.01"},{"id":"bd99291d-7ecd-410e-566f-08d5ad2bf6ba","name":"EOLICA CHUI II S.A.","commercialName":"","cnpj":"14606986000152","city":"FLORIANÓPOLIS","stateCode":"SC","buscaAdicional":"ECHII 7063 CHUI II 892325 EOL.CV.RS.030790-4.01"},{"id":"81a9ac91-439f-413a-5698-08d5ad2bf6ba","name":"EOLICA CHUI VI S.A.","commercialName":"","cnpj":"14606932000197","city":"FLORIANÓPOLIS","stateCode":"SC","buscaAdicional":"ECHVI 7301 MINUANO I 892223 EOL.CV.RS.030844-7.01"},{"id":"df49919e-1402-4a41-5699-08d5ad2bf6ba","name":"EOLICA GERIBATU V S.A.","commercialName":"","cnpj":"14608082000166","city":"FLORIANÓPOLIS","stateCode":"SC","buscaAdicional":"EGERIV 7302 VERACE 5 892202 EOL.CV.RS.030829-3.01"},{"id":"7933cdb7-f0f0-4f9d-5610-08d5ad2bf6ba","name":"EOLICA GERIBATU IV S.A.","commercialName":"","cnpj":"14606657000101","city":"FLORIANÓPOLIS","stateCode":"SC","buscaAdicional":"EGERIIV 6578 VERACE IV 892116 EOL.CV.RS.030741-6.01"},{"id":"0bfb3782-3198-4bf6-5611-08d5ad2bf6ba","name":"EOLICA CERRO CHATO VI S.A.","commercialName":"","cnpj":"14607742000194","city":"FLORIANÓPOLIS","stateCode":"SC","buscaAdicional":"ECCVI 6579 CERRO CHATO VI 892111 EOL.CV.RS.030756-4.01"},{"id":"568a9b4d-dec5-4a09-5612-08d5ad2bf6ba","name":"EOLICA IBIRAPUITA S.A.","commercialName":"","cnpj":"14608116000112","city":"FLORIANÓPOLIS","stateCode":"SC","buscaAdicional":"EIBIRAPUITA 6580 IBIRAPUITA 892184 EOL.CV.RS.030750-5.01"},{"id":"31df061e-53d8-48b1-5613-08d5ad2bf6ba","name":"EOLICA GERIBATU I S.A.","commercialName":"","cnpj":"14608104000198","city":"FLORIANÓPOLIS","stateCode":"SC","buscaAdicional":"EGERIT 6581 VERACE I 892123 EOL.CV.RS.030745-9.01"},{"id":"1e30bc41-c0b5-4eae-5614-08d5ad2bf6ba","name":"EOLICA GERIBATU VI S.A.","commercialName":"","cnpj":"14607768000132","city":"FLORIANÓPOLIS","stateCode":"SC","buscaAdicional":"EGERIVI 6582 VERACE VI 892143 EOL.CV.RS.030740-8.01"},{"id":"4e96d2f8-096a-4982-5615-08d5ad2bf6ba","name":"EOLICA GERIBATU II S.A.","commercialName":"","cnpj":"14606692000120","city":"FLORIANÓPOLIS","stateCode":"SC","buscaAdicional":"EGERIII 6583 VERACE II 892323 EOL.CV.RS.030742-4.01"},{"id":"c93c9326-9932-4006-5616-08d5ad2bf6ba","name":"EOLICA GERIBATU III S.A.","commercialName":"","cnpj":"14606670000160","city":"FLORIANÓPOLIS","stateCode":"SC","buscaAdicional":"EGERIIII 6584 VERACE III 892113 EOL.CV.RS.030746-7.01"},{"id":"34907c01-7058-4095-5617-08d5ad2bf6ba","name":"EOLICA GERIBATU VII S.A.","commercialName":"","cnpj":"14608060000104","city":"FLORIANÓPOLIS","stateCode":"SC","buscaAdicional":"EGERIVII 6585 VERACE VII 892324 EOL.CV.RS.030747-5.01"},{"id":"4aa9b486-6f1d-4727-5618-08d5ad2bf6ba","name":"EOLICA GERIBATU IX S.A.","commercialName":"","cnpj":"14607730000160","city":"FLORIANÓPOLIS","stateCode":"SC","buscaAdicional":"EGERIIX 6586 VERACE IX 892122 EOL.CV.RS.030748-3.01"},{"id":"09ed058f-28f1-40b9-5619-08d5ad2bf6ba","name":"EOLICA GERIBATU VIII S.A.","commercialName":"","cnpj":"14610234000165","city":"FLORIANÓPOLIS","stateCode":"SC","buscaAdicional":"EGERIVIII 6587 VERACE VIII 892115 EOL.CV.RS.030755-6.01"},{"id":"8960bb01-5f81-412c-561a-08d5ad2bf6ba","name":"EOLICA GERIBATU X S.A.","commercialName":"","cnpj":"14610139000161","city":"FLORIANÓPOLIS","stateCode":"SC","buscaAdicional":"EGERIX 6588 VERACE 10 892222 EOL.CV.RS.030749-1.01"},{"id":"c0c26c58-c5cb-4eea-561b-08d5ad2bf6ba","name":"EOLICA CHUI IV S.A.","commercialName":"","cnpj":"14606953000102","city":"FLORIANÓPOLIS","stateCode":"SC","buscaAdicional":"ECHIV 6589 CHUI IV 892117 EOL.CV.RS.030754-8.01"},{"id":"21d6f514-3a91-4b65-5625-08d5ad2bf6ba","name":"EOLICA CERRO DOS TRINDADE S.A.","commercialName":"","cnpj":"14610172000191","city":"FLORIANÓPOLIS","stateCode":"SC","buscaAdicional":"ECTRINDADE 6679 CERRO DOS TRINDADE 890753 EOL.CV.RS.030762-9.01"},{"id":"3b7c90ff-19fd-499c-5626-08d5ad2bf6ba","name":"EOLICA CHUI I S.A.","commercialName":"","cnpj":"14607000000169","city":"FLORIANÓPOLIS","stateCode":"SC","buscaAdicional":"ECHI I 6680 CHUI I 892144 EOL.CV.RS.030767-0.01"},{"id":"9353e608-4a9f-40a2-5627-08d5ad2bf6ba","name":"EOLICA CHUI V S.A.","commercialName":"","cnpj":"14606945000166","city":"FLORIANÓPOLIS","stateCode":"SC","buscaAdicional":"ECHV 6681 CHUI V 892142 EOL.CV.RS.030760-2.01"},{"id":"c8df30b2-e040-49bc-56da-08d5ad2bf6ba","name":"MEGA WATT COMERCIALIZACAO DE ENERGIA LTDA","commercialName":"MEGA WATT","cnpj":"15027346000150","city":"FLORIANÓPOLIS","stateCode":"SC","buscaAdicional":"MEGA WATT 7860 CANGURU PLASTICOS 909344 MAXEL MOVEIS 911071 FERRO SUL MW 909345 PEDERTRACTOR 912760 BRUNO HEIDRICH 888145 CGH.PH.SC.029356-3.01"},{"id":"388fe4f1-f097-4c12-56e2-08d5ad2bf6ba","name":"CONDOMINIO FLORIANOPOLIS SHOPPING CENTER","commercialName":"FLORIANOPOLIS SHOPPING CENTER","cnpj":"09541728000103","city":"FLORIANÓPOLIS","stateCode":"SC","buscaAdicional":"SHOP FLORIPA 7869 SHOP FLORIPA SC 888140"},{"id":"79923e0c-b4fe-4f86-570a-08d5ad2bf6ba","name":"STATKRAFT ENERGIA DO BRASIL LTDA.","commercialName":"STATKRAFT BRASIL","cnpj":"08573833000153","city":"FLORIANÓPOLIS","stateCode":"SC","buscaAdicional":"STATKRAFT 8165"},{"id":"424ed68d-2844-4870-6960-08d5ad2bf6ba","name":"COMPANHIA ENERGETICA MIRANDA","commercialName":"","cnpj":"28942127000149","city":"FLORIANÓPOLIS","stateCode":"SC","buscaAdicional":"UHE MIRANDA 61114 MIRANDA (MIRANDA L) 911136 UHE.PH.MG.001469-9.01 MIRANDA (MIRANDA C) 233 UHE.PH.MG.001469-9.01"},{"id":"ee1cfc8e-1f2f-427f-6961-08d5ad2bf6ba","name":"COMPANHIA ENERGETICA JAGUARA","commercialName":"","cnpj":"28925264000175","city":"FLORIANÓPOLIS","stateCode":"SC","buscaAdicional":"UHE JAGUARA 61116 JAGUARA (JAGUARA L) 911174 UHE.PH.SP.001225-4.01 JAGUARA (JAGUARA C) 234 UHE.PH.SP.001225-4.01"},{"id":"42be01c5-b0a9-4da9-88ae-08d5ae44ed50","name":"USINA TERMELETRICA PAMPA SUL S/A","commercialName":"","cnpj":"04739720000124","city":"FLORIANÓPOLIS","stateCode":"SC","buscaAdicional":"PAMPA SUL 17334"},{"id":"27b19655-86ba-4d0d-65d6-08d5ad2bf6ba","name":"ENGIE COMERCIALIZADORA VAREJISTA DE ENERGIA LTDA.","commercialName":"","cnpj":"26263019000114","city":"FLORIANÓPOLIS","stateCode":"SC","buscaAdicional":"ENGIE BR CVE 57157"},{"id":"c10dff44-2132-41fe-63c9-08d5ad2bf6ba","name":"SOS CARDIO SERVICOS HOSPITALARES LTDA","commercialName":"","cnpj":"85307098000187","city":"FLORIANÓPOLIS","stateCode":"SC","buscaAdicional":"SOS CARDIO 55631 SOS CARDIO FLORIANOP 907219"},{"id":"1a6765c0-9d94-4d6a-63c7-08d5ad2bf6ba","name":"IMAGEM CENTRO DE DIAGNOSTICO MEDICO LTDA","commercialName":"","cnpj":"72366818000133","city":"FLORIANÓPOLIS","stateCode":"SC","buscaAdicional":"CLINICA IMAGEM 55624 CLINICA IMAGEM FL SC 906549"},{"id":"b5392e25-9b56-41b2-6441-08d5ad2bf6ba","name":"CENTRAL FOTOVOLTAICA ASSU V LTDA","commercialName":"","cnpj":"23844275000107","city":"FLORIANÓPOLIS","stateCode":"SC","buscaAdicional":"FOTOVOLTAICA ASSU V 55898 ASSU 5 910706 UFV.RS.RN.034184-3.01"},{"id":"1c039f4d-b219-47b9-6483-08d5ad2bf6ba","name":"NC COMUNICACOES SA","commercialName":"","cnpj":"79227963000182","city":"FLORIANÓPOLIS","stateCode":"SC","buscaAdicional":"NC COMUNICACOES 56054 NC COMUNICACOES - TV 899892 NC COMUNICACOES - PQ 899907"},{"id":"af1113b6-554c-48be-6583-08d5ad2bf6ba","name":"COTESA COMERCIALIZADORA DE ENERGIA LTDA","commercialName":"","cnpj":"85235430000145","city":"FLORIANÓPOLIS","stateCode":"SC","buscaAdicional":"COTESA 56793"},{"id":"f961d80d-02ac-4397-61eb-08d5ad2bf6ba","name":"DIGITRO TECNOLOGIA S.A.","commercialName":"DIGITRO","cnpj":"83472803000176","city":"FLORIANÓPOLIS","stateCode":"SC","buscaAdicional":"DIGITRO 54470 DIGITRO 905038"},{"id":"3f8d48b1-2f0f-41b4-61a6-08d5ad2bf6ba","name":"CONDOMINIO COMPLEXO TURISTICO IL CAMPANARIO","commercialName":"CONDOMINIO COMPLEXO TURISTICO IL CAMPANARIO","cnpj":"10529232000195","city":"FLORIANÓPOLIS","stateCode":"SC","buscaAdicional":"IL CAMPANARIO 54330 CAMPANARIO 905362"},{"id":"a46bb628-3423-4072-61e5-08d5ad2bf6ba","name":"LABORATORIO FARMACEUTICO ELOFAR LTDA.","commercialName":"","cnpj":"83874628000143","city":"FLORIANÓPOLIS","stateCode":"SC","buscaAdicional":"ELOFAR 54459 ELOFAR 905896"},{"id":"f38f2887-720e-4d73-6338-08d5ad2bf6ba","name":"CONDOMINIO BEIRAMAR SHOPPING CENTER","commercialName":"BEIRAMAR SHOPPING","cnpj":"73370991000178","city":"FLORIANÓPOLIS","stateCode":"SC","buscaAdicional":"BEIRAMAR 55250 CONDOMINIO BEIRAMAR 906225"},{"id":"db52deb5-38ea-4f8a-1cc0-08d5b8870181","name":"DIAMANTE GERACAO DE ENERGIA LTDA.","commercialName":"","cnpj":"27093977000157","city":"FLORIANÓPOLIS","stateCode":"SC","buscaAdicional":"DIAMANTE GERACAO 61139 JORGE LACERDA B 363 UTE.CM.SC.027093-8.01 JORGE LACERDA C 364 UTE.CM.SC.027094-6.01 JORGE LACERDA A2 8622 UTE.CM.SC.001260-2.01 JORGE LACERDA A1 8623 UTE.CM.SC.001260-2.01"},{"id":"36119b08-a703-41f8-7219-08d5cf600bef","name":"STATKRAFT ENERGIAS RENOVAVEIS S/A","commercialName":"","cnpj":"00622416000141","city":"FLORIANÓPOLIS","stateCode":"SC","buscaAdicional":""},{"id":"0a9423b0-70fa-452f-721f-08d5cf600bef","name":"SANTA CATARINA PARTICIPACAO E INVESTIMENTOS SA INVESC","commercialName":"INVESC","cnpj":"00897864000158","city":"FLORIANÓPOLIS","stateCode":"SC","buscaAdicional":""},{"id":"19f3d406-f9a7-45e0-73da-08d5cf600bef","name":"CENTRAIS ELETRICAS DE SANTA CATARINA SA","commercialName":"CELESC","cnpj":"83878892000155","city":"FLORIANÓPOLIS","stateCode":"SC","buscaAdicional":""},{"id":"ae69ccbb-f272-4922-73d3-08d5cf600bef","name":"COMPANHIA CATARINENSE DE AGUAS E SANEAMENTO CASAN","commercialName":"CASAN","cnpj":"82508433000117","city":"FLORIANÓPOLIS","stateCode":"SC","buscaAdicional":""},{"id":"b88017a7-bf75-4adb-73df-08d5cf600bef","name":"POMI FRUTAS S/A","commercialName":"","cnpj":"86550951000150","city":"FRAIBURGO","stateCode":"SC","buscaAdicional":""},{"id":"43fd4357-f8f7-4181-5cd2-08d5ad2bf6ba","name":"RELIX INDUSTRIA E COMERCIO DE PLASTICOS LTDA","commercialName":"RELIX INDUSTRIA E COMERCIO DE PLASTICOS","cnpj":"07646232000160","city":"FRAIBURGO","stateCode":"SC","buscaAdicional":"RELIX 51579 RELIX 901497"},{"id":"90536e7d-63c9-4275-6034-08d5ad2bf6ba","name":"RENAR MOVEIS LTDA","commercialName":"","cnpj":"82827007000146","city":"FRAIBURGO","stateCode":"SC","buscaAdicional":"RENAR 53423 RENAR 904229"},{"id":"a7e0c66f-5223-49a6-5c97-08d5ad2bf6ba","name":"GARUVA ABRASIVOS LTDA","commercialName":"","cnpj":"82715863000100","city":"GARUVA","stateCode":"SC","buscaAdicional":"GARUVAABRASIVOS 51394 GARUVA ABRASIVOS 899195"},{"id":"b94ffa43-c8ec-43ae-576d-08d5ad2bf6ba","name":"MARCEGAGLIA DO BRASIL LTDA","commercialName":"","cnpj":"02173216000184","city":"GARUVA","stateCode":"SC","buscaAdicional":"MARCEGAGLIA 8816 MARCEGAGLIA 888824"},{"id":"d026ee63-9b0e-46be-5748-08d5ad2bf6ba","name":"CIRCULO S/A.","commercialName":"LINHAS CIRCULO","cnpj":"84043009000170","city":"GASPAR","stateCode":"SC","buscaAdicional":"CIRCULO 8472 CIRCULO 888296"},{"id":"2c4dd9e8-c43b-4317-4f9e-08d5ad2bf6ba","name":"BUNGE ALIMENTOS S/A","commercialName":"","cnpj":"84046101000193","city":"GASPAR","stateCode":"SC","buscaAdicional":"BUNGE ALIMENTO 1188 BUNGE ALIM.-JAGUARE 7326 BUNGE RONDONOPOLIS 70717 BUNGE NOVA MUTUM 70775 BUNGE ALIMENTO SUAPE 71823 BUNGE ALIM LEM BA 72112 BUNGE URUCUI 909349 BUNGE - IPOJUCA 911319 BUNGE RIO GRANDE 7375 BUNGE ALIM-PFUNDO-RS 70045 BUNGE ALIM GASPAR 70287 BUNGE ALI-P GROSSA 71756 BUNGE PONTA GROSSA 904060 BUNGE MARINGA 907383 BUNGE ALIM SANTOS 71337 BUNGE ALIMENTO TATUI 902114 BUNGE LUZIANIA 907159 BUNGE VERA CRUZ 910031 BUNGE ALIM DOURADOS 7547 BUNGE ETTI 889609 BUNGE ALIM FLUMINENS 70908"},{"id":"96b4298d-a478-4b96-5d31-08d5ad2bf6ba","name":"GS TINTURARIA E TEXTIL LTDA","commercialName":"GS TINTURARIA","cnpj":"08153018000135","city":"GASPAR","stateCode":"SC","buscaAdicional":"GS TINTURARIA 51731 GS TINTURARIA GASPAR 899292"},{"id":"ecac262c-c6b4-400d-5dfc-08d5ad2bf6ba","name":"BELLA ARTE UTILIDADES PARA O LAR LTDA","commercialName":"","cnpj":"07215271000103","city":"GASPAR","stateCode":"SC","buscaAdicional":"BELLA ARTE 52134 BELLA ARTE 904254"},{"id":"2ce5bf83-5157-4be7-5f3d-08d5ad2bf6ba","name":"BRITAGEM E PAVIMENTADORA BARRACAO LTDA","commercialName":"","cnpj":"06053093000107","city":"GASPAR","stateCode":"SC","buscaAdicional":"BRITAGEM BARRACAO 52872 BRITAGEM BARRACAO 905034"},{"id":"54beed48-f1d3-4783-5af2-08d5ad2bf6ba","name":"INDUSTRIA DE PLASTICOS DO VALE DO ITAJAI LTDA","commercialName":"","cnpj":"83495085000153","city":"GASPAR","stateCode":"SC","buscaAdicional":"PLASVALE 50366 PLASTICO ITAJAI 897168"},{"id":"b4181bd4-ef47-4b5b-6527-08d5ad2bf6ba","name":"REAL PLASTIC INDUSTRIA DE PLASTICOS LTDA","commercialName":"REAL PLASTIC","cnpj":"83098715000156","city":"GASPAR","stateCode":"SC","buscaAdicional":"REAL PLASTIC 56535 REAL PLASTI BELCHIOR 906553 REAL P POCO GRANDE 910525"},{"id":"35a7fbdc-6051-4fbc-65ab-08d5ad2bf6ba","name":"ARVAL BENEFICIAMENTOS TEXTEIS S/A","commercialName":"ARVAL PARTICIPACOES","cnpj":"17713089000136","city":"GASPAR","stateCode":"SC","buscaAdicional":"ARVAL 56925 ARVAL 910625"},{"id":"9a7a43e0-8347-47bd-6721-08d5ad2bf6ba","name":"FAZZENDA PARK HOTEL LTDA","commercialName":"FAZZENDA PARK HOTEL","cnpj":"01235218000198","city":"GASPAR","stateCode":"SC","buscaAdicional":"FAZZENDA HOTEL 57972 FAZZENDA HOTEL 912014"},{"id":"43492ff1-ec02-493f-67ad-08d5ad2bf6ba","name":"FUNDICAO SANTA TEREZINHA LTDA","commercialName":"","cnpj":"02335262000132","city":"GASPAR","stateCode":"SC","buscaAdicional":"FST 58415 FUND STA TEREZINHA 908478"},{"id":"be5df623-e3a5-487b-66d1-08d5ad2bf6ba","name":"NIPON PLATING TRATAMENTOS SUPERFICIAIS LTDA","commercialName":"NIPON PLATING","cnpj":"04080298000148","city":"GUABIRUBA","stateCode":"SC","buscaAdicional":"NIPON PLATING 57839 NIPON PLATING 911282"},{"id":"e8a7bd28-1a74-4334-6634-08d5ad2bf6ba","name":"KOHMATEX TINTURARIA LTDA","commercialName":"","cnpj":"04385881000167","city":"GUABIRUBA","stateCode":"SC","buscaAdicional":"KOHMATEX TINTURARIA 57389 KOHMATEX 909342"},{"id":"1216c694-8052-4deb-652e-08d5ad2bf6ba","name":"ESTAMPARIA CORES & TONS LTDA","commercialName":"CORES E TONS ESTAMPARIA ROTATIVA E TINTURARIA","cnpj":"00074023000140","city":"GUABIRUBA","stateCode":"SC","buscaAdicional":"CORES E TONS 56577 CORES E TONS 906529"},{"id":"284efacb-d4ca-400e-6164-08d5ad2bf6ba","name":"BL TEXTEIS LTDA","commercialName":"","cnpj":"16926278000124","city":"GUABIRUBA","stateCode":"SC","buscaAdicional":"BL TEXTEIS 54170 BL TEXTEIS GUABIRUBA 904310"},{"id":"80f7a5e2-0abc-4d8d-5f20-08d5ad2bf6ba","name":"TINTURARIA WILLRICH LTDA","commercialName":"TINTURARIA WILLRICH","cnpj":"20665566000140","city":"GUABIRUBA","stateCode":"SC","buscaAdicional":"TINTURARIA WILLRICH 52768 TINTURARIA WILLRICH 904131"},{"id":"8541d218-2849-41b9-5f91-08d5ad2bf6ba","name":"TINTURARIA E ESTAMPARIA HOLSTEIN LTDA","commercialName":"","cnpj":"85401602000103","city":"GUABIRUBA","stateCode":"SC","buscaAdicional":"HOLSTEIN 53026 TINTURARIA HOLSTEIN 903074"},{"id":"95a767e5-473f-447e-56f3-08d5ad2bf6ba","name":"ACOPECAS INDUSTRIA DE PECAS DE ACO LTDA","commercialName":"","cnpj":"75883975000104","city":"GUABIRUBA","stateCode":"SC","buscaAdicional":"ACO PECAS 8006 ACO PECAS SC 888131"},{"id":"15850741-6673-4771-55fa-08d5ad2bf6ba","name":"KOHLER TINTURARIA LTDA","commercialName":"KOHLER & CIA","cnpj":"82982307000108","city":"GUABIRUBA","stateCode":"SC","buscaAdicional":"KOHLER 6432 KOHLER GUABIRUBA 888161"},{"id":"be545145-6b56-4cc3-626a-08d5ad2bf6ba","name":"METALURGICA IMAM LTDA","commercialName":"","cnpj":"84094242000181","city":"GUARAMIRIM","stateCode":"SC","buscaAdicional":"IMAM 54754 METALURGICA IMAM 906520"},{"id":"dca10567-809b-4108-63a4-08d5ad2bf6ba","name":"TECNOTEMPERA TRATAMENTOS TERMICOS LTDA","commercialName":"","cnpj":"04719223000164","city":"GUARAMIRIM","stateCode":"SC","buscaAdicional":"TECNOTEMPERA 55499 TECNOTEMPERA 905904"},{"id":"dc3259bf-e7b5-4b8b-4eda-08d5d159243d","name":"BRASIL SECURITIZADORA S.A.","commercialName":"BRASIL SECURITIZADORA","cnpj":"13483537000100","city":"GUARAMIRIM","stateCode":"SC","buscaAdicional":""},{"id":"62396198-c942-445f-5bf1-08d5ad2bf6ba","name":"BRASPET INDUSTRIA E COMERCIO DE EMBALAGENS LTDA","commercialName":"","cnpj":"13123801000196","city":"GUARUJÁ DO SUL","stateCode":"SC","buscaAdicional":"BRASPET 50994 BRASPET 904140"},{"id":"6ebc5905-7478-47ff-5cee-08d5ad2bf6ba","name":"PAPELAO UNIAO IND COM LTDA","commercialName":"","cnpj":"80995228000106","city":"GUATAMBÚ","stateCode":"SC","buscaAdicional":"TONA 51616 PAPELAO UNIAO IND 900031"},{"id":"7ee900af-62ba-4581-5759-08d5ad2bf6ba","name":"SAO VALENTIM GERACAO DE ENERGIA S.A.","commercialName":"","cnpj":"09328488000155","city":"GUATAMBÚ","stateCode":"SC","buscaAdicional":"SAO VALENTIM 8649 MACUCO 8927 CGH.PH.SC.030598-7.01 PARISOTTO 891061 CGH.PH.SC.030998-2.01"},{"id":"b60d9e5d-bbc5-4d68-51e5-08d5ad2bf6ba","name":"CENTRAIS ELETRICAS RIO TIGRE S.A - CERT","commercialName":"","cnpj":"07801099000170","city":"GUATAMBÚ","stateCode":"SC","buscaAdicional":"CERT 2701 RIO TIGRE 8347 PCH.PH.SC.002514-3.01"},{"id":"3d31bda0-ace5-4730-5b02-08d5ad2bf6ba","name":"MAFRAS ENERGIA LTDA","commercialName":"","cnpj":"15226569000147","city":"IBIRAMA","stateCode":"SC","buscaAdicional":"PCH MAFRAS 50385 MAFRAS 8039 PCH.PH.SC.027711-8.01"},{"id":"7117f1fd-ac4e-49dc-8d7b-08d5d060706e","name":"MAQUINAS OMIL LTDA","commercialName":"","cnpj":"84148485000155","city":"IBIRAMA","stateCode":"SC","buscaAdicional":"MAQUINAS OMIL 58150 MAQUINAS OMIL 913496"},{"id":"e46db6fd-90a9-49e8-689d-08d5ad2bf6ba","name":"COMERCIAL DACLANDE LTDA","commercialName":"","cnpj":"03222166000140","city":"IBIRAMA","stateCode":"SC","buscaAdicional":"DACLANDE 60212 COMERCIAL DACLANDE 910624"},{"id":"8492ce68-27bc-4dcd-65c4-08d5ad2bf6ba","name":"AMBONI ALIMENTOS LTDA","commercialName":"AMBONI ALIMENTOS","cnpj":"09409634000177","city":"IÇARA","stateCode":"SC","buscaAdicional":"AMBONI ALIMENTOS 57074 AMBONI ALIMENTOS 906562"},{"id":"fd369628-f7ec-4772-64e3-08d5ad2bf6ba","name":"SMALTICERAM UNICER DO BRASIL LTDA.","commercialName":"","cnpj":"02750009000145","city":"IÇARA","stateCode":"SC","buscaAdicional":"SMALTICERAM 56293 SMALTICERAM ICARA SC 907428"},{"id":"2a64477e-3e01-4b86-1cb9-08d5b8870181","name":"LIBRELATO S.A. IMPLEMENTOS RODOVIARIOS","commercialName":"FABRICA DE CARROCERIAS LIBRELATO","cnpj":"75274316000170","city":"IÇARA","stateCode":"SC","buscaAdicional":"LIBRELATO 61000 LIBRELATO - ICARA 912775"},{"id":"13d052f3-d6fc-463e-88f3-08d5ae44ed50","name":"CHROMO INDUSTRIA E COMERCIO DE EMBALAGENS EIRELI","commercialName":"CHROMO EMBALAGENS","cnpj":"04546378000146","city":"IÇARA","stateCode":"SC","buscaAdicional":"CHROMO 56751 CHROMO EMBALAGENS PL 906337"},{"id":"27efb7d5-c502-4dc1-88dd-08d5ae44ed50","name":"FERRO SUL INDUSTRIA DE FUNDIDOS LTDA","commercialName":"","cnpj":"09038924000151","city":"IÇARA","stateCode":"SC","buscaAdicional":"FERRO SUL 53611 FERRO SUL 900659"},{"id":"78a93063-5539-42f6-5aac-08d5ad2bf6ba","name":"TORRECID DO BRASIL FRITAS ESMALTES E CORANTES LTDA","commercialName":"","cnpj":"73912859000140","city":"IÇARA","stateCode":"SC","buscaAdicional":"TORRECID 50150 TORRECID 897006 TORRRECID ARARAS 906716"},{"id":"b3c9a3fe-a46d-4857-5cf6-08d5ad2bf6ba","name":"BUDNY INDUSTRIA E COMERCIO EIRELI","commercialName":"","cnpj":"95863684000161","city":"IÇARA","stateCode":"SC","buscaAdicional":"BUDNY 51632 BUDNY ICARA SC 901067"},{"id":"b82c59e3-493e-47a2-5e2e-08d5ad2bf6ba","name":"USIPE INDUSTRIA E COMERCIO DE PECAS LTDA","commercialName":"USIPE- FUNDIDOS E USINADOS","cnpj":"80432099000130","city":"IÇARA","stateCode":"SC","buscaAdicional":"USIPE 52251 USIPE 899749"},{"id":"158a97a8-b32f-4564-5dc5-08d5ad2bf6ba","name":"GIASSI & CIA LTDA","commercialName":"","cnpj":"83648477000105","city":"IÇARA","stateCode":"SC","buscaAdicional":"GIASSI 51982 GIASSI L03 ARARANGUA 902771 GIASSI L11 CRICIUMA 902772 GIASSI L12 SAO JOSE 902853 GIASSI L13 TUBARAO 902873 GIASSI L08 JOINVILLE 902893 GIASSI L06 TUBARAO 903954 GIASSI L14 JOINVILLE 903977 GIASSI L05 CRICIUMA 904716 GIASSI L09 BLUMENAU 904717 GIASSI L10 PALHOCA 905343 GIASSI 07 CAMPINAS 906499 GIASSI 899849 GIASSI LOJA 01 900004"},{"id":"c00ad3a5-e8d8-4348-5e56-08d5ad2bf6ba","name":"COLORMINAS COLORIFICIO E MINERACAO S/A","commercialName":"","cnpj":"80084809000188","city":"IÇARA","stateCode":"SC","buscaAdicional":"COLORMINAS 52334 COLORMINAS RIO CLARO 899769"},{"id":"c4c098db-d937-443f-5fe0-08d5ad2bf6ba","name":"COPAZA DESCARTAVEIS PLASTICOS LTDA","commercialName":"","cnpj":"85151504000165","city":"IÇARA","stateCode":"SC","buscaAdicional":"COPAZA 53253 COPAZA 899950"},{"id":"8da911ef-5709-4cd4-60f7-08d5ad2bf6ba","name":"FARBEN SA INDUSTRIA QUIMICA","commercialName":"","cnpj":"85111441000113","city":"IÇARA","stateCode":"SC","buscaAdicional":"FARBEN 53922 FARBEN 903098"},{"id":"6d918727-2361-4afb-54e5-08d5ad2bf6ba","name":"CRISTALCOPO DESCARTAVEIS S/A","commercialName":"CRISTALCOPO","cnpj":"05316470000182","city":"IÇARA","stateCode":"SC","buscaAdicional":"CRISTALSUL 4577 CRISTALCOPO-ICARA SC 71659 CRISTALSUL - 7 SET 896945"},{"id":"d712c213-96ff-4571-5af9-08d5ad2bf6ba","name":"TEXTIL CRISTINA LTDA","commercialName":"","cnpj":"09571292000197","city":"ILHOTA","stateCode":"SC","buscaAdicional":"TEXTIL CRISTINA 50376 TEXTIL CRISTINA 898126"},{"id":"e156fc20-f2dc-4089-64d2-08d5ad2bf6ba","name":"VALLE D'ORO AGROINDUSTRIAL LTDA","commercialName":"","cnpj":"09148052000184","city":"ILHOTA","stateCode":"SC","buscaAdicional":"VALLE DORO 56258 VALLE DORO ILHOTAS 907231"},{"id":"c2451b4d-a531-4f83-73db-08d5cf600bef","name":"COMPANHIA DOCAS DE IMBITUBA","commercialName":"","cnpj":"84208123000102","city":"IMBITUBA","stateCode":"SC","buscaAdicional":""},{"id":"cd1d13cb-3fd6-4df7-63c3-08d5ad2bf6ba","name":"RECICLATEX INDUSTRIA E COMERCIO TEXTIL LTDA","commercialName":"","cnpj":"73216913000113","city":"INDAIAL","stateCode":"SC","buscaAdicional":"RECICLATEX 55600 RECICLATEX 905053"},{"id":"7956f32a-50d8-47ff-65fb-08d5ad2bf6ba","name":"PLASTIAL INDUSTRIA E COMERCIO DE PLASTICOS INDAIAL LTDA","commercialName":"","cnpj":"04415372000130","city":"INDAIAL","stateCode":"SC","buscaAdicional":"PLASTIAL 57254 PLASTIAL INDAIAL 908170"},{"id":"3d03dc6b-bf77-4b88-666e-08d5ad2bf6ba","name":"PRENSA INDUSTRIA METALMECANICA LTDA","commercialName":"","cnpj":"73322430000101","city":"INDAIAL","stateCode":"SC","buscaAdicional":"PRENSA INDUSTRIA 57560 PRENSA IND INDAIAL 908855"},{"id":"1054362b-f1c0-4ff9-66ee-08d5ad2bf6ba","name":"BRASILUX IND COMERCIO IMPORTACAO E EXPORTACAO LTDA","commercialName":"","cnpj":"00374121000101","city":"INDAIAL","stateCode":"SC","buscaAdicional":"TASCHIBRA 57889 TASCHIBRA 909112"},{"id":"926d2e05-c888-4af3-8891-08d5ae44ed50","name":"DOPEL INDUSTRIA E COMERCIO DE PAPEIS EIRELI","commercialName":"INDUSTRIA DE PAPEL DOPEL","cnpj":"85283430000110","city":"INDAIAL","stateCode":"SC","buscaAdicional":"DOPEL 14075 ARROIO DOS CACHORROS 895682 CGH.PH.SC.030423-9.01"},{"id":"80b4ab14-430d-4004-5b63-08d5ad2bf6ba","name":"BENEX BENEFICIAMENTO TEXTIL LTDA","commercialName":"BENEX","cnpj":"05783903000100","city":"INDAIAL","stateCode":"SC","buscaAdicional":"BENEX 50654 BENEX 898094"},{"id":"d853ed38-2e1b-44a1-5836-08d5ad2bf6ba","name":"BELLOTA BRASIL LTDA","commercialName":"","cnpj":"02588815000169","city":"INDAIAL","stateCode":"SC","buscaAdicional":"BELLOTA 11049 BELLOTA 889854"},{"id":"a8b24faf-b686-49a5-60f4-08d5ad2bf6ba","name":"WANKE S.A.","commercialName":"","cnpj":"84228105000192","city":"INDAIAL","stateCode":"SC","buscaAdicional":"WANKE 53918 WANKE SA 904221"},{"id":"acdf1cc2-63c1-4f98-5ffe-08d5ad2bf6ba","name":"MALHARIA INDAIAL LTDA","commercialName":"","cnpj":"86799814000153","city":"INDAIAL","stateCode":"SC","buscaAdicional":"MALHARIA INDAIAL 53331 MALHARIA IND FILIAL 902715"},{"id":"33524309-8d48-4444-5f73-08d5ad2bf6ba","name":"GONCALVES & TORTOLA S/A","commercialName":"FRANGOS CANCAO","cnpj":"85070068001171","city":"INDAIAL","stateCode":"SC","buscaAdicional":"GTBFOODS 52960 GTBFOODS IPUACU SC 901149"},{"id":"38bfb491-3da9-43f4-5e72-08d5ad2bf6ba","name":"FIOBRAS LTDA","commercialName":"","cnpj":"01475188000197","city":"INDAIAL","stateCode":"SC","buscaAdicional":"FIOBRAS 52387 FIOBRAS INDAIAL SC 900929"},{"id":"4d486780-c35d-4305-538a-08d5ad2bf6ba","name":"INDAIAL PAPEL EMBALAGENS LTDA","commercialName":"IPEL","cnpj":"78534674000163","city":"INDAIAL","stateCode":"SC","buscaAdicional":"IPEL 3690 IPEL 71241"},{"id":"0a11e391-2e76-43cb-53ac-08d5ad2bf6ba","name":"BENVETEX TEXTIL LTDA","commercialName":"","cnpj":"85347284000140","city":"INDAIAL","stateCode":"SC","buscaAdicional":"BENVETEX 3763 BENVETEX 71304"},{"id":"7a3623c8-10e2-4a87-565b-08d5ad2bf6ba","name":"INCOFIOS INDUSTRIA E COMERCIO DE FIOS LTDA","commercialName":"INCOFIOS","cnpj":"04432327000193","city":"INDAIAL","stateCode":"SC","buscaAdicional":"INCOFIOS 6939 INCOFIOS INDAIAL 72373"},{"id":"b86fccfd-4936-491b-5130-08d5ad2bf6ba","name":"ALBANY INTERNATIONAL TECIDOS TECNICOS LTDA.","commercialName":"","cnpj":"60580263000149","city":"INDAIAL","stateCode":"SC","buscaAdicional":"ALBANY 2041 ALBANY MTZ INDAIAL 70532"},{"id":"3e6fc33c-7aff-4dcf-5241-08d5ad2bf6ba","name":"METALURGICA FEY LTDA","commercialName":"","cnpj":"84229624000175","city":"INDAIAL","stateCode":"SC","buscaAdicional":"METAL FEY 2978 METALURGICA FEY 70909"},{"id":"daaab359-8485-4304-6240-08d5ad2bf6ba","name":"CAPRIMA - INDUSTRIA DE PAPEL LTDA","commercialName":"","cnpj":"10316811000150","city":"IOMERÊ","stateCode":"SC","buscaAdicional":"CAPRIMA 54659 CAPRIMA IOMERE 906534"},{"id":"3d5a7f51-cccf-44a7-62de-08d5ad2bf6ba","name":"CEREALISTA MARX EIRELI","commercialName":"","cnpj":"80730054000141","city":"IPORÃ DO OESTE","stateCode":"SC","buscaAdicional":"CEREALISTA MARX 55019 CEREALISTA MARX 905024"},{"id":"45b11fc2-b818-4359-511b-08d5ad2bf6ba","name":"LUDESA ENERGETICA S.A.","commercialName":"LUDESA","cnpj":"05313891000150","city":"IPUAÇU","stateCode":"SC","buscaAdicional":"CPFL LUDESA 1997 LUDESA (LUDESA) 8253 PCH.PH.SC.028801-2.01"},{"id":"7543a79d-a0bd-4d0e-5d43-08d5ad2bf6ba","name":"INDUSTRIA DE MADEIRAS FAQUEADAS IPUMIRIM SA","commercialName":"","cnpj":"83568246000191","city":"IPUMIRIM","stateCode":"SC","buscaAdicional":"FAQUEADAS 51751 FAQUEADAS 899826 FAQUEADAS EXPORTACAO 900023"},{"id":"5c8825d6-f3ba-4b5a-62df-08d5ad2bf6ba","name":"SUL PORTAS INDUSTRIA DE PORTAS LTDA","commercialName":"","cnpj":"83572826000152","city":"IPUMIRIM","stateCode":"SC","buscaAdicional":"SUL PORTAS 55020 SUL PORTAS IPUMIRIM 905864"},{"id":"ac41dc25-0f7b-4ba2-547b-08d5ad2bf6ba","name":"GELNEX INDUSTRIA E COMERCIO LTDA","commercialName":"","cnpj":"02001597000114","city":"ITÁ","stateCode":"SC","buscaAdicional":"GELNEX 4295 GELNEX-ITA 71520 GELNEX-ARAGUAINA 72040 GELNEX NAZARIO 902744"},{"id":"1d354e4e-fc41-4bb5-54e0-08d5ad2bf6ba","name":"FUNDACAO UNIVERSIDADE DO VALE DO ITAJAI","commercialName":"UNIVALI","cnpj":"84307974000102","city":"ITAJAÍ","stateCode":"SC","buscaAdicional":"UNIVALI 4557 UNIVALI-ITAJAI 71671"},{"id":"e73341f7-b05f-4de2-54c7-08d5ad2bf6ba","name":"APM TERMINALS ITAJAI S.A.","commercialName":"","cnpj":"04700714000163","city":"ITAJAÍ","stateCode":"SC","buscaAdicional":"APM TERMINALS 4494 APM TERMINALS-ITJ 71620"},{"id":"eea15124-d530-4a14-52b3-08d5ad2bf6ba","name":"GDC ALIMENTOS S.A","commercialName":"","cnpj":"02279324000136","city":"ITAJAÍ","stateCode":"SC","buscaAdicional":"GDC MATRIZ 3249 GDC FILIAL ITAJAI 70986 GDC ALIMENTOS 903854"},{"id":"6109bca0-9721-43f3-5209-08d5ad2bf6ba","name":"BRF S.A.","commercialName":"","cnpj":"01838723000127","city":"ITAJAÍ","stateCode":"SC","buscaAdicional":"BRF CPZ 2813 BRF-TOLEDO-PR 7495 BRF-CHAPECO-SC 70169 BRF FRIG. CAPINZAL 71397 BRF FRIG. VIDEIRA 71417 BRF LAJEADO 898949 BRF RACOES VIDEIRA 71398 BRF CATANDUVAS 905801 BRF SANTA GEMA 905819 AVIPAL-DOURADOS-MS 7508 BRF VIT SNT ANTAO 72330 367 FRIG BOV IND VG 7369 387 FRIG L RIO VERDE 70904 BRF RIO VERDE 907020 376 FRIG SUINOS 7447 216 FAB RACAO 7613 BRF JUNDIAI 906270 BRF CONCORDIA SC 7319 PERDIGAO MARAU AVES 70352 BRF - CAMPOS NOVOS 897124 BRF APARECIDA GOIANI 900518 BRF RIBEIRAO NEVES 901183 CD DUQUE DE CAXIAS 902154 BRF MINEIROS GO 902954 BRF-P. GROSSA-PR 7494 BRF SALVADOR 905482 BRF RACOES MARAU 70215 215 BRF FAB RACAO FA 71252 BRF - ITAJAI - SC 899605 BRF - HERVAL DOESTE 900996 BRF FRCO BELTRAO 904013 BRF - SJ DOS PINHAIS 910889 BRF SUINOS - MARAU 70214 BRF SERAFINA CORREA 71587 BRF - ARROIO DO MEIO 899290 120 INCUB AVES MARAU 902615 BRF RACOES GAURAMA 71361 BRF FRCO BELTRAO 2 904033 BRF NOVA SANTA RITA 907664 BRF - EMBU DAS ARTES 901536 BRF RACAO MINEIROS 902710 BRF VARZEA GRANDE 903458 BRF DOURADOS MS 907510 BRF 194 INC FGO CORT 907850 364 FAB MARGARINAS 71254"},{"id":"117741a5-cc82-4349-5f23-08d5ad2bf6ba","name":"MULTILOG S/A","commercialName":"","cnpj":"78614229000103","city":"ITAJAÍ","stateCode":"SC","buscaAdicional":"MULTILOG 52777 MULTILOG - ITAJAI 899739"},{"id":"3176d7ed-47fd-40cb-5f4e-08d5ad2bf6ba","name":"INCOTEXTIL INDUSTRIAL LTDA","commercialName":"INCOTEX","cnpj":"08080487000171","city":"ITAJAÍ","stateCode":"SC","buscaAdicional":"INCOTEXTIL 52892 INCOTEXTIL INDUSTRIA 901006"},{"id":"1da5a765-d3c7-437b-6066-08d5ad2bf6ba","name":"INDUSTRIA E COMERCIO RIOMAR CORDAS EIRELI","commercialName":"RIOMAR CORDAS","cnpj":"84298926000103","city":"ITAJAÍ","stateCode":"SC","buscaAdicional":"RIOMAR CORDAS 53490 RIOMAR CORDAS ITAJAI 906552"},{"id":"ab541627-42b0-41bb-6097-08d5ad2bf6ba","name":"BRASFRIGO S/A","commercialName":"","cnpj":"19166180000376","city":"ITAJAÍ","stateCode":"SC","buscaAdicional":"BRASFRIGO SA 53609 BRASFRIGO SA 900781"},{"id":"fb5f972b-90bd-46d8-62ea-08d5ad2bf6ba","name":"INSTITUTO DAS PEQUENAS MISSIONARIAS DE MARIA IMACULADA","commercialName":"HOSPITAL E MATERNIDADE MARIETA KONDER BORNHAUSEN","cnpj":"60194990002200","city":"ITAJAÍ","stateCode":"SC","buscaAdicional":"HOSPITAL MARIETA 55031 HOSPITAL MARIETA 905027"},{"id":"e4e9616d-1d87-408b-68fd-08d5ad2bf6ba","name":"RODOCORDAS INDUSTRIA E COMERCIO DE CORDAS LTDA.","commercialName":"","cnpj":"81588071000159","city":"ITAJAÍ","stateCode":"SC","buscaAdicional":"RODOCORDAS 60682 RODOCORDAS 911874"},{"id":"4b1935ec-679d-4f31-6884-08d5ad2bf6ba","name":"CRISTALPET SUL INDUSTRIA COMERCIO DE EMBALAGENS LTDA","commercialName":"","cnpj":"19328827000157","city":"ITAJAÍ","stateCode":"SC","buscaAdicional":"CRISTALPET 60110 CRISTALPET SUL 910552"},{"id":"5bec8ed1-779a-4bf4-6674-08d5ad2bf6ba","name":"BRF ENERGIA S.A.","commercialName":"","cnpj":"05449127000106","city":"ITAJAÍ","stateCode":"SC","buscaAdicional":"BRF COM 57578"},{"id":"eab091ef-c549-4700-664c-08d5ad2bf6ba","name":"SHB COMERCIO E INDUSTRIA DE ALIMENTOS S.A.","commercialName":"","cnpj":"26176436000120","city":"ITAJAÍ","stateCode":"SC","buscaAdicional":"SHB 57473 BRF CARAMBEI 904733 SHB FCO BELTRAO 907678 BRF FRIG. NOVA MUTUM 71389 BRF - DOIS VIZINHOS 898746 377 FRIG AVES PERUS 7445 BRF BURITI ALEGRE 907019 SHB - FRIG AVES JATA 909309 SHB INCUB DIAMANTE 911151"},{"id":"7f15adaa-37bc-4daf-6658-08d5ad2bf6ba","name":"ITAJAI ADMINSTRADORA DE SHOPPING CENTERS LTDA","commercialName":"","cnpj":"03043201000164","city":"ITAJAÍ","stateCode":"SC","buscaAdicional":"PALLADIUM ITAJAI 57506 ITAJAI ADM SHOP CENT 908171"},{"id":"4d36dee6-d5b2-43a9-8d9f-08d5d060706e","name":"CORDOARIA BRASIL INDUSTRIA E COMERCIO DE CORDAS EIRELI","commercialName":"","cnpj":"09454624000153","city":"ITAJAÍ","stateCode":"SC","buscaAdicional":"CORDOARIA BRASIL 61439 CORDOARIA 913323"},{"id":"af448f2b-2442-4642-732d-08d5cf600bef","name":"PLAY BEVERAGE SOUTH AMERICA S.A.","commercialName":"","cnpj":"12610072000130","city":"ITAJAÍ","stateCode":"SC","buscaAdicional":""},{"id":"7c959b2b-9f9b-40c1-547f-08d5ad2bf6ba","name":"ITAPOA TERMINAIS PORTUARIOS S/A","commercialName":"","cnpj":"01317277000105","city":"ITAPOÁ","stateCode":"SC","buscaAdicional":"PORTO DE ITAPOA 4302 ITAPOA PORTUARIOS 903077"},{"id":"aa7cc7d4-cb0e-41b0-608f-08d5ad2bf6ba","name":"AGUAS NEGRAS SA INDUSTRIA DE PAPEL","commercialName":"","cnpj":"82757907000164","city":"ITUPORANGA","stateCode":"SC","buscaAdicional":"AGUAS NEGRAS PAPEL 53587 AGUAS NEGRAS INDUSTR 902475"},{"id":"776e36b7-0955-4906-88a8-08d5ae44ed50","name":"IRMAOS BRANCHER PASTA MECANICA, MADEIRAS E PAPELAO LTDA","commercialName":"IRMAOS BRANCHER","cnpj":"84590165000150","city":"JABORÁ","stateCode":"SC","buscaAdicional":"BRANCHER 16444"},{"id":"d00f3a85-13d2-4d79-682b-08d5ad2bf6ba","name":"ARGEPASI ALIMENTOS INDUSTRIA E COMERCIO LTDA","commercialName":"","cnpj":"05096536000176","city":"JABORÁ","stateCode":"SC","buscaAdicional":"ARGEPASI 59452 ARGEPASI JABORA 909629"},{"id":"1aa22cb2-f78e-44b9-6188-08d5ad2bf6ba","name":"COOPERATIVA AGROINDUSTRIAL COOPERJA","commercialName":"COOPERJA","cnpj":"85667947000103","city":"JACINTO MACHADO","stateCode":"SC","buscaAdicional":"COOPERJA 54227 COOPERJA - PATRULHA 904996"},{"id":"cd08d261-d24c-452f-5e83-08d5ad2bf6ba","name":"CERAMICA FELISBINO LTDA","commercialName":"","cnpj":"72567662000159","city":"JAGUARUNA","stateCode":"SC","buscaAdicional":"FELISBINO 52411 FELISBINO JAGUARUNA 900959"},{"id":"9d125bea-1083-4b85-58f7-08d5ad2bf6ba","name":"SAN MARCOS REVESTIMENTOS CERAMICOS LTDA","commercialName":"SAN MARCOS","cnpj":"03952525000115","city":"JAGUARUNA","stateCode":"SC","buscaAdicional":"SAN MARCOS 13492 SAN MARCOS JAGUARUNA 892642"},{"id":"5411d853-2e0b-400d-591e-08d5ad2bf6ba","name":"INDUSTRIA DE ARTEFATOS DE BORRACHA WOLF LTDA","commercialName":"","cnpj":"84430024000170","city":"JARAGUÁ DO SUL","stateCode":"SC","buscaAdicional":"WOLF 13837 WOLF BORRACHA 907720"},{"id":"83ec3d7f-d584-410c-5ab2-08d5ad2bf6ba","name":"DELMAX PAPELAO E EMBALAGENS LTDA","commercialName":"","cnpj":"00693104000129","city":"JARAGUÁ DO SUL","stateCode":"SC","buscaAdicional":"DELMAX 50179 CGH ITAPOCUZINHO II 908473 CGH.PH.SC.035335-3.01 CGH ITAPOCUZINHO I 908627 CGH.PH.SC.028727-0.01"},{"id":"1bb034b3-5362-4aa9-5a75-08d5ad2bf6ba","name":"LUNELLI INDUSTRIA DO VESTUARIO LTDA.","commercialName":"LUNELLI COLORS","cnpj":"12213317000195","city":"JARAGUÁ DO SUL","stateCode":"SC","buscaAdicional":"LUNELLI 49667 LUNELLI - GUARAMIRIM 72002 LUNELLI CORUPA 889006"},{"id":"e6f3de53-7a25-4705-5c6b-08d5ad2bf6ba","name":"URBANO AGROINDUSTRIAL LTDA","commercialName":"","cnpj":"84432111000167","city":"JARAGUÁ DO SUL","stateCode":"SC","buscaAdicional":"URBANO AUTOPRODUTOR 51305 URBANO 899408 URBANO NOVA TRENTO 900455 URBANO SAO GABRIEL 900998 URBANO CABO 904433 URBANO SINOP 905740 URBANO GUARULHOS G1 909903 URBANO GUARULHOS G2 909904"},{"id":"c97ea50a-6004-426b-5cf2-08d5ad2bf6ba","name":"ASSOCIACAO HOSPITALAR SAO JOSE DE JARAGUA DO SUL","commercialName":"ASSOCIACAO HOSPITALAR SAO JOSE DE JARAGUA DO SUL","cnpj":"12846027000189","city":"JARAGUÁ DO SUL","stateCode":"SC","buscaAdicional":"HOSPITAL SAO JOSE JAGUARA 51620 HOSP SAO JOSE 911323"},{"id":"b106c561-d68a-408f-6050-08d5ad2bf6ba","name":"COMUNIDADE EVANGELICA LUTERANA DE JARAGUA DO SUL","commercialName":"","cnpj":"84433945000197","city":"JARAGUÁ DO SUL","stateCode":"SC","buscaAdicional":"HOSP JARAGUA DO SUL 53460 HOSP JARAGUA SUL 902993"},{"id":"fb9fbbe9-7ebd-4fa7-5fe9-08d5ad2bf6ba","name":"MALHAS MENEGOTTI INDUSTRIA TEXTIL LTDA","commercialName":"","cnpj":"10474553000130","city":"JARAGUÁ DO SUL","stateCode":"SC","buscaAdicional":"MALHAS MENEGOTTI 53283 MALHAS MENEGOTTI 902693"},{"id":"a8fb8527-a451-4ae4-56a2-08d5ad2bf6ba","name":"NANETE TEXTIL LTDA","commercialName":"","cnpj":"84432434000150","city":"JARAGUÁ DO SUL","stateCode":"SC","buscaAdicional":"NANETE TEXTIL 7401 NANET TEXTIL 72265"},{"id":"62ef36bc-80c3-4092-57cf-08d5ad2bf6ba","name":"DALILA TEXTIL LTDA EM RECUPERACAO JUDICIAL","commercialName":"","cnpj":"82740903000173","city":"JARAGUÁ DO SUL","stateCode":"SC","buscaAdicional":"DALILA 9693 DALILA PRES. GETULIO 889056 DALILA JARAGUA SUL 889613"},{"id":"f20844bd-a672-42b3-5173-08d5ad2bf6ba","name":"CONDOMINIO COMERCIAL DO JARAGUA DO SUL PARK SHOPPING","commercialName":"CONDOMINIO COMERCIAL DO JARAGUA DO SUL PARK SHOPPING","cnpj":"03434343000152","city":"JARAGUÁ DO SUL","stateCode":"SC","buscaAdicional":"JSPS 2177 BREITHAUPT J.SUL-SC 70539"},{"id":"94740380-2edb-41b4-535c-08d5ad2bf6ba","name":"WEG EQUIPAMENTOS ELETRICOS S/A","commercialName":"CORPORATIVO","cnpj":"07175725000160","city":"JARAGUÁ DO SUL","stateCode":"SC","buscaAdicional":"WEG 3594 WEG JARAGUADO SUL 7450 WEG GUARAMIRIM SC 7473 WEG BLUMENAU 71157 WEG ITAJAI 71491 WEG MAQUINAS SBCAMPO 7185 WEG GRAVATAI 71509 WEG GRAVATAI II 899650"},{"id":"d3ab76fc-a5c4-45c5-5336-08d5ad2bf6ba","name":"MARISOL VESTUARIO SA","commercialName":"MARISOL","cnpj":"02045487000154","city":"JARAGUÁ DO SUL","stateCode":"SC","buscaAdicional":"MARISOL 3517 MARISOL 71275"},{"id":"bbe71fe6-63e2-4844-50ee-08d5ad2bf6ba","name":"DUAS RODAS INDUSTRIAL LTDA","commercialName":"DUAS RODAS","cnpj":"84430149000109","city":"JARAGUÁ DO SUL","stateCode":"SC","buscaAdicional":"DUAS RODAS 1911 DUAS RODAS-JARAG SUL 70273"},{"id":"6462de63-f651-450e-50a4-08d5ad2bf6ba","name":"ZANOTTI S.A.","commercialName":"","cnpj":"78256336000107","city":"JARAGUÁ DO SUL","stateCode":"SC","buscaAdicional":"ZANOTTI 1763 ZANOTTI-JARAGUA SUL 70115"},{"id":"f4a9e625-4162-4da8-50a6-08d5ad2bf6ba","name":"MALWEE MALHAS LTDA","commercialName":"MALWEE","cnpj":"84429737000114","city":"JARAGUÁ DO SUL","stateCode":"SC","buscaAdicional":"MALWEE 1765 MALWEE-JARAGUA SUL 70116 MALWEE II JARAGUA 71007"},{"id":"b5cd004d-2f2b-4749-61c3-08d5ad2bf6ba","name":"P.P. PLAST INDUSTRIAL EIRELI","commercialName":"","cnpj":"04695105000163","city":"JARAGUÁ DO SUL","stateCode":"SC","buscaAdicional":"PPPLAST 54384 PPPLAST INDUSTRIAL 905874"},{"id":"8b51781b-e35d-451b-6272-08d5ad2bf6ba","name":"TRITEC INDUSTRIAL DE PLASTICOS LTDA","commercialName":"TRITEC INDUSTRIAL LTDA","cnpj":"11490214000100","city":"JARAGUÁ DO SUL","stateCode":"SC","buscaAdicional":"TRITEC 54763 TRITEC RESINAS 905901"},{"id":"e756afa4-86b4-4599-625c-08d5ad2bf6ba","name":"FUNDACAO EDUCACIONAL REGIONAL JARAGUAENSE","commercialName":"CATOLICA DE SANTA CATARINA EM JARAGUA DO SUL","cnpj":"83130229000178","city":"JARAGUÁ DO SUL","stateCode":"SC","buscaAdicional":"FERJ 54713 FERJ JOINVILLE 906521 FERJ JARAGUA 906522"},{"id":"b9207951-aeba-4fa4-6403-08d5ad2bf6ba","name":"OESA COMERCIO E REPRESENTACOES S/A","commercialName":"","cnpj":"81611931000128","city":"JARAGUÁ DO SUL","stateCode":"SC","buscaAdicional":"OESA 55786 OESA 905902"},{"id":"787f4c80-064d-4b2e-64f9-08d5ad2bf6ba","name":"CSM-COMPONENTES SISTEMAS E MAQUINAS PARA CONSTRUCAO LTD","commercialName":"","cnpj":"76840537000121","city":"JARAGUÁ DO SUL","stateCode":"SC","buscaAdicional":"CSM 56334 CSM JARAGUA DO SUL 908150"},{"id":"ed7c7f2c-d976-47f2-6563-08d5ad2bf6ba","name":"POSTO AGRICOPEL LTDA.","commercialName":"POSTO AGRICOPEL","cnpj":"83488882000103","city":"JARAGUÁ DO SUL","stateCode":"SC","buscaAdicional":"GRUPO MIME 56708 AGRICOPEL MIME 907726 MIME JARAGUA 0294 907727 MIME 2661 908414"},{"id":"bba10fb2-53e5-4191-655a-08d5ad2bf6ba","name":"METALURGICA TRAPP LTDA","commercialName":"","cnpj":"83238832000178","city":"JARAGUÁ DO SUL","stateCode":"SC","buscaAdicional":"TRAPP 56671 METALURGICA TRAPP 907725"},{"id":"ca9b6552-b455-4521-655d-08d5ad2bf6ba","name":"TEXTILFIO MALHAS LTDA","commercialName":"","cnpj":"00214242000188","city":"JARAGUÁ DO SUL","stateCode":"SC","buscaAdicional":"TEXTILFIO 56698 TEXTILFIO 907221"},{"id":"e2a1c867-4792-4e68-654f-08d5ad2bf6ba","name":"EDEPEL COMERCIO DE APARAS EIRELI","commercialName":"","cnpj":"83151704000192","city":"JARAGUÁ DO SUL","stateCode":"SC","buscaAdicional":"EDEPEL 56649 EDEPEL EMBALAGENS 906559"},{"id":"b78ea862-1a01-45cb-6654-08d5ad2bf6ba","name":"INCATEX INDUSTRIA DE ACABAMENTO TEXTIL LTDA","commercialName":"","cnpj":"76840701000109","city":"JARAGUÁ DO SUL","stateCode":"SC","buscaAdicional":"INCATEX 57495 INCATEX 909317"},{"id":"80beb7b7-ea0d-475d-65d2-08d5ad2bf6ba","name":"A.J. BENEFICIAMENTO TEXTIL LTDA","commercialName":"","cnpj":"02548987000109","city":"JARAGUÁ DO SUL","stateCode":"SC","buscaAdicional":"AJ TEXTIL 57151 A.J. BENEFICIAMENTO 910349"},{"id":"21ca69b3-d2e8-403e-88c5-08d5ae44ed50","name":"LMG ROUPAS LTDA","commercialName":"","cnpj":"83108712000156","city":"JARAGUÁ DO SUL","stateCode":"SC","buscaAdicional":"LMG ROUPAS 51310 LMG ROUPAS - JARAGUA 898582"},{"id":"946dd6a1-9074-4e21-88ea-08d5ae44ed50","name":"BAUMANN INDUSTRIA E COMERCIO DE ACOS LTDA","commercialName":"","cnpj":"03749237000168","city":"JARAGUÁ DO SUL","stateCode":"SC","buscaAdicional":"BAUMANN 55065 BAUMANN 908474"},{"id":"b6d3cd99-6d3c-43a6-73dc-08d5cf600bef","name":"WEG SA","commercialName":"WEG","cnpj":"84429695000111","city":"JARAGUÁ DO SUL","stateCode":"SC","buscaAdicional":""},{"id":"f770d38b-555d-46a8-677d-08d5ad2bf6ba","name":"COMPANHIA ENERGETICA APARECIDA","commercialName":"CGH APARECIDA","cnpj":"23776082000166","city":"JARDINÓPOLIS","stateCode":"SC","buscaAdicional":"ENERGETICA APARECIDA 58223 CGH APARECIDA 910172 CGH.PH.SC.035736-7.01"},{"id":"bc73db62-6c75-4e0e-5755-08d5ad2bf6ba","name":"HIDRAULICA INDUSTRIAL - INDUSTRIA E COMERCIO LTDA","commercialName":"","cnpj":"84584994000120","city":"JOAÇABA","stateCode":"SC","buscaAdicional":"HISA 8590 HISA JOACABA 888330"},{"id":"f2959b57-7871-452b-53e7-08d5ad2bf6ba","name":"SPECHT PRODUTOS ALIMENTICIOS LTDA","commercialName":"","cnpj":"84584515000176","city":"JOAÇABA","stateCode":"SC","buscaAdicional":"SPECHT 3902 MARIO FETT (R PEIXE) 910595 CGH.PH.SC.002354-0.01"},{"id":"a0056c74-ebe8-466d-5b5f-08d5ad2bf6ba","name":"ADM DO BRASIL LTDA","commercialName":"ADM DO BRASIL","cnpj":"02003402004677","city":"JOAÇABA","stateCode":"SC","buscaAdicional":"ADM BRASIL 50650 ADM BRASIL 898726"},{"id":"9c213b7b-38c1-4761-59a2-08d5ad2bf6ba","name":"FRANCISCO LINDNER S A INDUSTRIA E COMERCIO","commercialName":"","cnpj":"84584473000173","city":"JOAÇABA","stateCode":"SC","buscaAdicional":"FRANCISCO LINDNER 15235 FRANCISCO LINDNER 894967 UHE.PH.SC.027620-0.01 e UHE.PH.SC.032561-9.01"},{"id":"e4768a82-8b24-4e66-58fb-08d5ad2bf6ba","name":"SOCIEDADE EDUCACIONAL DE SANTA CATARINA SOCIESC SS LTDA","commercialName":"SOCIESC, ESCOLA TECNICA TUPY E COLEGIO TUPY","cnpj":"84684182000157","city":"JOINVILLE","stateCode":"SC","buscaAdicional":"SOCIESC 13513 SOCIESC1 JOINVILLE 892023"},{"id":"a74d038b-9820-41c2-58c8-08d5ad2bf6ba","name":"IRCE INDUSTRIA DE CONDUTORES ELETRICOS LTDA","commercialName":"IRCE LTDA","cnpj":"07384404000175","city":"JOINVILLE","stateCode":"SC","buscaAdicional":"IRCEIND 13294 IRCEIND 891884"},{"id":"405c688c-0d32-4d8d-5853-08d5ad2bf6ba","name":"MICRO JUNTAS INDUSTRIA E COMERCIO LTDA","commercialName":"","cnpj":"80976483000101","city":"JOINVILLE","stateCode":"SC","buscaAdicional":"MICRO JUNTAS 11369 MICRO JUNTAS 889994"},{"id":"7fae42ad-6702-48f3-5845-08d5ad2bf6ba","name":"DRAKA COMTEQ CABOS BRASIL S.A.","commercialName":"","cnpj":"00017734000183","city":"JOINVILLE","stateCode":"SC","buscaAdicional":"DRAKA 11152 DRAKA JOINVILLE 71663"},{"id":"0710ebde-2bc7-4310-5879-08d5ad2bf6ba","name":"BRUNSWICK INDUSTRIA DE EMBARCACOES DO BRASIL LTDA","commercialName":"LIFE FITNESS","cnpj":"14462144000174","city":"JOINVILLE","stateCode":"SC","buscaAdicional":"BRUNSWICK 11953 BRUNSWICK 890500"},{"id":"323f783f-d1cc-40e0-5aa9-08d5ad2bf6ba","name":"LABORATORIO CATARINENSE LTDA","commercialName":"","cnpj":"84684620000187","city":"JOINVILLE","stateCode":"SC","buscaAdicional":"CATARINENSE PHARMA 50139 LAB CATARINENSE 897066"},{"id":"d6f1128a-d18d-4256-5fdb-08d5ad2bf6ba","name":"KAVO DO BRASIL INDUSTRIA E COMERCIO LTDA","commercialName":"","cnpj":"84683556000110","city":"JOINVILLE","stateCode":"SC","buscaAdicional":"KAVO 53244 KAVO DO BRASIL 902987"},{"id":"b2336377-f447-4457-5f45-08d5ad2bf6ba","name":"UNIMED DE JOINVILLE COOPERATIVA DE TRABALHO MEDICO","commercialName":"CENTRO HOSPITALAR UNIMED","cnpj":"82602327000360","city":"JOINVILLE","stateCode":"SC","buscaAdicional":"UNIMED JOINVILLE 52881 UNIMED DE JOINVILLE 904158"},{"id":"16dd5f6f-8d14-4a79-60f9-08d5ad2bf6ba","name":"LINKPLAS INDUSTRIA DE PLASTICOS LTDA","commercialName":"","cnpj":"04992664000135","city":"JOINVILLE","stateCode":"SC","buscaAdicional":"LINKPLAS 53930 LINKPLAS 902706"},{"id":"1421e6ed-f385-41c0-5c98-08d5ad2bf6ba","name":"COMPANHIA FABRIL LEPPER","commercialName":"","cnpj":"84683887000150","city":"JOINVILLE","stateCode":"SC","buscaAdicional":"LEPPER 51395 COMPANHIA LEPPER 901280"},{"id":"a758f036-e5a0-4744-5c99-08d5ad2bf6ba","name":"COPPER INDUSTRIA E COMERCIO DE VERGALHOES EIRELI","commercialName":"","cnpj":"10193734000198","city":"JOINVILLE","stateCode":"SC","buscaAdicional":"COPPER 51396 COPPER 899410"},{"id":"4a55514a-e7bc-4a8a-5d5c-08d5ad2bf6ba","name":"ILPEA DO BRASIL LTDA","commercialName":"ILPEA","cnpj":"02547509000184","city":"JOINVILLE","stateCode":"SC","buscaAdicional":"ILPEA 51797 ILPEA - JOINVILLE 904134"},{"id":"1eddf682-4c08-4827-5d53-08d5ad2bf6ba","name":"CRISTAL MASTER INDUSTRIA E COMERCIO LTDA","commercialName":"CRISTAL MASTER","cnpj":"05378317000180","city":"JOINVILLE","stateCode":"SC","buscaAdicional":"CRISTALMASTER 51783 CRISTAL MASTER 899411"},{"id":"6525df6e-332d-4a7e-5d23-08d5ad2bf6ba","name":"HOSPITAL DE OLHOS SADALLA AMIN GHANEM LTDA","commercialName":"HOSPITAL DE OLHOS SADALLA AMIN GHANEM","cnpj":"00750846000149","city":"JOINVILLE","stateCode":"SC","buscaAdicional":"SADALLA 51713 HOSP OLHOS SADALLA 899197"},{"id":"7c09461d-1ff9-4f5d-5e78-08d5ad2bf6ba","name":"FRANKE SISTEMAS DE COZINHAS DO BRASIL LTDA","commercialName":"","cnpj":"02314099000121","city":"JOINVILLE","stateCode":"SC","buscaAdicional":"FRANKE 52396 FRANKE 904125"},{"id":"82b8cef2-cabb-43f1-5e5e-08d5ad2bf6ba","name":"CONDOMINIO SHOPPING CENTER CIDADE DAS FLORES","commercialName":"","cnpj":"00107799000110","city":"JOINVILLE","stateCode":"SC","buscaAdicional":"SHOP CIDADE DAS FLORES 52342 SHOP CIDADE DAS FLOR 901503"},{"id":"6a5933c0-8dff-4b0c-5e09-08d5ad2bf6ba","name":"PAVILOCHE INDUSTRIAL LTDA","commercialName":"PAVILOCHE","cnpj":"01761298000115","city":"JOINVILLE","stateCode":"SC","buscaAdicional":"PAVILOCHE 52156 PAVILOCHE 901494"},{"id":"0282493e-8d7f-40f9-5e0b-08d5ad2bf6ba","name":"PLASBOHN INDUSTRIA DE PLASTICOS LTDA","commercialName":"","cnpj":"82183716000136","city":"JOINVILLE","stateCode":"SC","buscaAdicional":"PLASBOHN 52180 PLASBOHN 903036"},{"id":"ad5a4503-ac04-4a0a-5e0d-08d5ad2bf6ba","name":"MALHARIA CARYMA LTDA","commercialName":"","cnpj":"79386678000104","city":"JOINVILLE","stateCode":"SC","buscaAdicional":"CARYMA 52182 MALHARIA CARYMA 899775"},{"id":"c5d721e6-663c-4f22-5471-08d5ad2bf6ba","name":"GRANACO FUNDICAO LTDA.","commercialName":"GRANACO","cnpj":"95877973000110","city":"JOINVILLE","stateCode":"SC","buscaAdicional":"GRANACO 4256 GRANACO FUNDICAO-JV 71521"},{"id":"a1f48b25-ef64-4ab2-5462-08d5ad2bf6ba","name":"KRONA TUBOS E CONEXOES S.A.","commercialName":"","cnpj":"00145602000137","city":"JOINVILLE","stateCode":"SC","buscaAdicional":"KRONA 4202 KRONA JOINVILLE 71505"},{"id":"8e94ff27-4889-4368-54ed-08d5ad2bf6ba","name":"AB PLAST MANUFATURADOS PLASTICOS LTDA","commercialName":"","cnpj":"76343748000159","city":"JOINVILLE","stateCode":"SC","buscaAdicional":"AB PLAST 4595 AB PLAST 897004"},{"id":"96de1cb4-e02a-45ef-54e6-08d5ad2bf6ba","name":"JOFUND S/A","commercialName":"JOFUND","cnpj":"79230678000110","city":"JOINVILLE","stateCode":"SC","buscaAdicional":"JOFUND 4578 JOFUND - JOINVILLE 72095"},{"id":"03c2893e-2137-45a2-54d7-08d5ad2bf6ba","name":"RBE GESTAO ESTRATEGICA DE ENERGIA LTDA.","commercialName":"RBE COMERCIALIZADORA DE ENERGIA","cnpj":"13338734000127","city":"JOINVILLE","stateCode":"SC","buscaAdicional":"RBE ENERGIA 4537"},{"id":"0941594a-1b08-405d-5585-08d5ad2bf6ba","name":"TIGRE MATERIAIS E SOLUCOES PARA CONSTRUCAO LTDA.","commercialName":"TIGRE","cnpj":"08862530000150","city":"JOINVILLE","stateCode":"SC","buscaAdicional":"TIGRE MATERIAIS 5738 SILVER-POUSO ALEGRE 71913 TIGRE-JOINVILLE-SC 70149 TIGRE RIO CLARO - SP 7378 TIGRE ESCADAS 889395 TIGRE CASTRO 72277 TIGRE MAT - MANAUS 913618"},{"id":"fc9d9152-2ead-4e2f-5589-08d5ad2bf6ba","name":"ASSOCIACAO BENEFICENTE EVANGELICA DE JOINVILLE","commercialName":"HOSPITAL DONA HELENA","cnpj":"84694405000167","city":"JOINVILLE","stateCode":"SC","buscaAdicional":"HOSP D HELENA 5760 HOSP D HELENA-JOINV 71855 HOSP DONA HELENA JV2 906554"},{"id":"e89061ed-7bc4-41cb-559f-08d5ad2bf6ba","name":"FUNDACAO EDUCACIONAL DA REGIAO DE JOINVILLE","commercialName":"FURJ/UNIVILLE","cnpj":"84714682000194","city":"JOINVILLE","stateCode":"SC","buscaAdicional":"FURJ 5900 FURJ UNIVILLE 71928"},{"id":"b11f46bd-db8b-4d86-570e-08d5ad2bf6ba","name":"DOCOL METAIS SANITARIOS LTDA","commercialName":"","cnpj":"75339051000141","city":"JOINVILLE","stateCode":"SC","buscaAdicional":"DOCOL 8169 DOCOL - JOINVILLE 888189"},{"id":"8328a8e3-cb91-426e-5776-08d5ad2bf6ba","name":"VIQUA INDUSTRIA DE PLASTICOS LTDA","commercialName":"","cnpj":"00477761000139","city":"JOINVILLE","stateCode":"SC","buscaAdicional":"VIQUA 8870 VIQUA 888599"},{"id":"0709aa83-1380-4a68-5778-08d5ad2bf6ba","name":"PLASTICOVILLE IND E COM DE PRODUTOS PLASTICOS LTDA","commercialName":"","cnpj":"86775343000143","city":"JOINVILLE","stateCode":"SC","buscaAdicional":"PLASTICOVILLE 8909 PLASTICOVILLE 888606"},{"id":"ce1f9e4a-f085-46ba-5693-08d5ad2bf6ba","name":"IBRAME INDUSTRIA BRASILEIRA DE METAIS S/A","commercialName":"","cnpj":"60846599000534","city":"JOINVILLE","stateCode":"SC","buscaAdicional":"IBRAMEIND 7241 IBRAME IND JOINVILLE 72174"},{"id":"9d795f6f-0cd9-486a-569e-08d5ad2bf6ba","name":"HENGST INDUSTRIA DE FILTROS LTDA","commercialName":"HENGST DO BRASIL","cnpj":"03429968000126","city":"JOINVILLE","stateCode":"SC","buscaAdicional":"HENGST 7325 HENGST-JOINVILLE 72259"},{"id":"418cff97-ff6b-47f6-50a8-08d5ad2bf6ba","name":"TERMOTECNICA LTDA","commercialName":"","cnpj":"83636019000156","city":"JOINVILLE","stateCode":"SC","buscaAdicional":"TERMOTECNICA 1770 TERMOTECNICA - RIO C 72154 TERMOTECNICA JLLE SC 888117 TERMOTECNICA INDAIA 889379"},{"id":"9d5f85b0-8f02-4413-50b9-08d5ad2bf6ba","name":"WETZEL S/A EM RECUPERACAO JUDICIAL","commercialName":"","cnpj":"84683671000194","city":"JOINVILLE","stateCode":"SC","buscaAdicional":"WETZEL 1799 WETZEL-JOINVILLE-SC 70168 WETZEL ALUMINIO 71395 WETZEL ELETRONICA 888575"},{"id":"76d67996-20a3-45dc-4f7c-08d5ad2bf6ba","name":"MEXICHEM BRASIL INDUSTRIA DE TRANSFORMACAO PLASTICA LTDA","commercialName":"MEXICHEM BRASIL","cnpj":"58514928000174","city":"JOINVILLE","stateCode":"SC","buscaAdicional":"MEXICHEM JLLE 1134 AMANCO-JOINVILLE-SC 7566 AMANCO CONEXOES JOI 7990 PLASTUBOS 71178 MEXICHEM ANAPOLIS 904739"},{"id":"662eed01-2f95-46e9-4fee-08d5ad2bf6ba","name":"SCHULZ S/A","commercialName":"SCHULZ","cnpj":"84693183000168","city":"JOINVILLE","stateCode":"SC","buscaAdicional":"SCHULZ 1363 SCHULZ JOINVILLE 7480"},{"id":"89317a2c-3513-462c-4fd5-08d5ad2bf6ba","name":"DOHLER S.A.","commercialName":"","cnpj":"84683408000103","city":"JOINVILLE","stateCode":"SC","buscaAdicional":"DOHLER 1300 DOHLER-JOINVILLE-SC 7417"},{"id":"7b558f51-1462-47ee-4fd6-08d5ad2bf6ba","name":"COMFIO COMPANHIA CATARINENSE DE FIACAO","commercialName":"","cnpj":"82607847000101","city":"JOINVILLE","stateCode":"SC","buscaAdicional":"COMFIO 1301 COMFIO-JOINVILLE-SC 7414"},{"id":"01f145b0-c2c2-4d7d-533f-08d5ad2bf6ba","name":"COND. DO EDIFICIO MUELLER SHOPPING CENTER DE JOINVILLE","commercialName":"COND. DO EDIFICIO MUELLER SHOPPING CENTER DE JOINVILLE","cnpj":"01154428000151","city":"JOINVILLE","stateCode":"SC","buscaAdicional":"SHOP MUELLER 3536 SHO MUELLER JOINVILE 71103"},{"id":"ddc21bdd-42ff-4df8-528d-08d5ad2bf6ba","name":"CIA INDUSTRIAL H. CARLOS SCHNEIDER","commercialName":"CISER","cnpj":"84709955000102","city":"JOINVILLE","stateCode":"SC","buscaAdicional":"CISER 3138 CISER JOINVILLE 70934 CISER MATRIZ 71081 CARLOS SCHNEIDER FA4 901501"},{"id":"d0eabfc3-2984-435a-6765-08d5ad2bf6ba","name":"INDUSTRIA DE BORRACHAS NSO LTDA","commercialName":"","cnpj":"75272013000119","city":"JOINVILLE","stateCode":"SC","buscaAdicional":"NSO 58075 INDUSTRIA DE BORRACH 912471"},{"id":"fa7e4321-a305-4b2c-67c7-08d5ad2bf6ba","name":"FABIO PERINI INDUSTRIA E COMERCIO DE MAQUINAS LTDA","commercialName":"FABIO PERINI LTDA","cnpj":"46861449000145","city":"JOINVILLE","stateCode":"SC","buscaAdicional":"FABIO PERINI 58632 FABIO PERINI 912434"},{"id":"54d2f972-63a6-4f74-66f3-08d5ad2bf6ba","name":"LEAS INDUSTRIAL LTDA","commercialName":"","cnpj":"06134049000113","city":"JOINVILLE","stateCode":"SC","buscaAdicional":"LEAS 57898 LEAS INDUSTRIAL 910626"},{"id":"0e7ed34c-4efe-4148-6708-08d5ad2bf6ba","name":"ARGENTAUREOS DOURACAO E PRATEACAO LTDA","commercialName":"BOREAL PECAS & SISTEMAS","cnpj":"80705700000110","city":"JOINVILLE","stateCode":"SC","buscaAdicional":"BOREAL 57932 BOREAL ARGENTAUREOS 909654"},{"id":"c39cb47e-fe8f-4c54-66bb-08d5ad2bf6ba","name":"DIKLATEX INDUSTRIAL TEXTIL S/A","commercialName":"","cnpj":"72020118000192","city":"JOINVILLE","stateCode":"SC","buscaAdicional":"DIKLATEX 57761 DIKLATEX JOINVILLE 909396"},{"id":"fc5b995a-2f6d-4bc3-66bd-08d5ad2bf6ba","name":"SEW-EURODRIVE BRASIL LTDA","commercialName":"SEW-EURODRIVE","cnpj":"50981018000947","city":"JOINVILLE","stateCode":"SC","buscaAdicional":"SEW JOINVILLE 57770 SEW JOINVILLE 909334"},{"id":"a57b49cf-c9cb-4d8a-6900-08d5ad2bf6ba","name":"CONDOMINIO DO JOINVILLE GARTEN SHOPPING","commercialName":"","cnpj":"24649850000183","city":"JOINVILLE","stateCode":"SC","buscaAdicional":"SHOP JOINVILLE 60712 GARTEN JOINVILLE 897497"},{"id":"9617a0bb-c592-41ec-695d-08d5ad2bf6ba","name":"DURMETAL INDUSTRIA E COMERCIO DE PECAS E MAQUINAS LTDA","commercialName":"DURMETAL INDUSTRIA COMERCIO E REPRESENTACOES LTDA","cnpj":"72484355000104","city":"JOINVILLE","stateCode":"SC","buscaAdicional":"DURMETAL 61099 DURMETAL 912437"},{"id":"93ed83a7-41df-45d3-8840-08d5ae44ed50","name":"TIGRE S.A. PARTICIPACOES","commercialName":"","cnpj":"84684455000163","city":"JOINVILLE","stateCode":"SC","buscaAdicional":"TIGRE SA 1791 TIGRE - CAMACARI 72148"},{"id":"dcb5c7ca-bac5-4666-64b0-08d5ad2bf6ba","name":"L. M. COSTA FARIA & CIA LTDA","commercialName":"","cnpj":"00743768000155","city":"JOINVILLE","stateCode":"SC","buscaAdicional":"L M COSTA FARIA 56154 MINEIRINHO PANIFICAC 905903"},{"id":"f2774b67-f726-457e-6400-08d5ad2bf6ba","name":"INFRASUL - INFRAESTRUTURA E EMPREENDIMENTOS LTDA","commercialName":"ENGEPASA INFRAESTRUTURA","cnpj":"03094645000200","city":"JOINVILLE","stateCode":"SC","buscaAdicional":"INFRASUL 55773 INFRASUL 906889"},{"id":"1b35c124-ea5a-4064-63a8-08d5ad2bf6ba","name":"ATRIO HOTEIS S.A.","commercialName":"","cnpj":"80732928000108","city":"JOINVILLE","stateCode":"SC","buscaAdicional":"ATRIO HOTEIS 55503 ATRIO ARACATUBA 906864 ATRIO JUNDIAI 906874 ATRIO GUARATINGUETA 906899"},{"id":"29152e78-1789-46e9-627a-08d5ad2bf6ba","name":"INPLAVEL INDUSTRIA DE PLASTICOS LTDA","commercialName":"INPLAVEL","cnpj":"76360874000111","city":"JOINVILLE","stateCode":"SC","buscaAdicional":"INPLAVEL 54772 INPLAVEL 904225"},{"id":"62956a0c-cbc3-4b0e-61ba-08d5ad2bf6ba","name":"FOCUS SUL TECNOLOGIA DE TERMOPLASTICOS S/A","commercialName":"","cnpj":"18821388000157","city":"JOINVILLE","stateCode":"SC","buscaAdicional":"FOCUS SUL 54351 FOCUS SUL TERMOPLAST 906539"},{"id":"5f98c5e2-ee37-4f7a-73dd-08d5cf600bef","name":"METALURGICA DUQUE SA","commercialName":"","cnpj":"84683762000120","city":"JOINVILLE","stateCode":"SC","buscaAdicional":""},{"id":"93596a5a-f2e9-4792-8d8f-08d5d060706e","name":"TECIDOS DONA FRANCISCA LTDA","commercialName":"","cnpj":"84692268000121","city":"JOINVILLE","stateCode":"SC","buscaAdicional":"TECIDOS D FRANCISCA 61040 TECIDOS D FRANC SC 913435"},{"id":"9fbc28f8-5c6e-470c-72f2-08d5cf600bef","name":"AUTOPISTA LITORAL SUL S.A.","commercialName":"","cnpj":"09313969000197","city":"JOINVILLE","stateCode":"SC","buscaAdicional":""},{"id":"3a2bc8b3-006f-449f-6040-08d5ad2bf6ba","name":"MADEIRAS BAGATTOLI LTDA","commercialName":"","cnpj":"84151000000182","city":"JOSÉ BOITEUX","stateCode":"SC","buscaAdicional":"MADEIRAS BAGATTOLI 53437 MADEIRAS BAGATOLLI 904331"},{"id":"641d674d-67ac-443f-684f-08d5ad2bf6ba","name":"LUZIVAN MARCIO SANTIAN & CIA LTDA","commercialName":"","cnpj":"01990844000190","city":"JUPIÁ","stateCode":"SC","buscaAdicional":"LUZIVAN 59716 LUZIVAN - JUPIA - SC 910372"},{"id":"74131d3c-f814-4e68-61c1-08d5ad2bf6ba","name":"JJ THOMAZI & CIA LTDA","commercialName":"","cnpj":"02927182000176","city":"LAGES","stateCode":"SC","buscaAdicional":"JJ THOMAZI 54382 JJ THOMAZI 910918"},{"id":"af89fd07-5f6d-4881-62b5-08d5ad2bf6ba","name":"FRUTICULTURA MALKE LTDA","commercialName":"","cnpj":"83680033000157","city":"LAGES","stateCode":"SC","buscaAdicional":"FRUTICULTURA MALKE 54935 FRUTICULTURA MALKE 905875"},{"id":"a0cb713d-3328-4bdb-6357-08d5ad2bf6ba","name":"ASSOCIACAO DO LAGES GARDEN SHOPPING","commercialName":"","cnpj":"20659994000160","city":"LAGES","stateCode":"SC","buscaAdicional":"SHOP LAGES GARDEN 55321 LAGES GARDEN SHOP 905039"},{"id":"ab6eb366-e103-4ed2-8d86-08d5d060706e","name":"PANDOLFO MADEIRAS LTDA","commercialName":"","cnpj":"92678440000897","city":"LAGES","stateCode":"SC","buscaAdicional":"PANDOLFO MADEIRAS 60852 PANDOLFO 913322"},{"id":"a9137907-bd99-4722-8d7c-08d5d060706e","name":"P&P MOVEIS E CONFECCOES LTDA","commercialName":"","cnpj":"00911409000160","city":"LAGES","stateCode":"SC","buscaAdicional":"PEP MOVEIS 58151 P&P MOVEIS E CONFEC 913494"},{"id":"09aa8b6b-f387-471c-5920-08d5ad2bf6ba","name":"MINUSA INDUSTRIAS MECANICAS S.A.","commercialName":"","cnpj":"81585671000163","city":"LAGES","stateCode":"SC","buscaAdicional":"MINUSA 13839 MINUSA LAGES 892662"},{"id":"5675fd8d-76ce-4a2b-4f42-08d5ad2bf6ba","name":"LAGES BIOENERGETICA LTDA","commercialName":"","cnpj":"05210535000100","city":"LAGES","stateCode":"SC","buscaAdicional":"LAGES BIOENERG 156 LAGES (LAGES BIO) 8023 UTE.FL.SC.028745-8.01"},{"id":"fccdcede-e1c7-4970-56ef-08d5ad2bf6ba","name":"VOSSKO DO BRASIL ALIMENTOS CONGELADOS LTDA.","commercialName":"VOSSKO DO BRASIL","cnpj":"05532428000107","city":"LAGES","stateCode":"SC","buscaAdicional":"VOSSKO 8002 VOSSKO 888321"},{"id":"230d457f-3f7a-410b-1cd2-08d5b8870181","name":"AVICOLA CATARINENSE S.A.","commercialName":"","cnpj":"81616807000155","city":"LAURO MULLER","stateCode":"SC","buscaAdicional":"AVICOLA CATARINENSE 61890 INCUBATORIO-SC 912771"},{"id":"2f8e62b9-4149-4926-59f6-08d5ad2bf6ba","name":"LINDNER GERACAO DE ENERGIA ELETRICA LTDA.","commercialName":"USINA RUDOLF LINDNER","cnpj":"10282859000194","city":"LEBON RÉGIS","stateCode":"SC","buscaAdicional":"CGH RUDOLF LINDNER 16135 RUDOLF LINDNER 896305 CGH.PH.SC.032070-6.01"},{"id":"0b4a9c1a-bf8e-437a-5f13-08d5ad2bf6ba","name":"METALCAVA FUNDICAO DE METAIS EIRELI","commercialName":"","cnpj":"00899825000190","city":"LONTRAS","stateCode":"SC","buscaAdicional":"METALCAVA 52725 METALCAVA 900987"},{"id":"7c8ec514-9223-4f00-5659-08d5ad2bf6ba","name":"ROVITEX IND E COM DE MALHAS LTDA","commercialName":"ROVITEX","cnpj":"79233672000105","city":"LUIZ ALVES","stateCode":"SC","buscaAdicional":"ROVITEX 6937 ROVITEX LUIZ ALVES 888164"},{"id":"b2b18de5-9e67-46c3-5390-08d5ad2bf6ba","name":"ACEARIA FREDERICO MISSNER LTDA","commercialName":"","cnpj":"82719956000102","city":"LUIZ ALVES","stateCode":"SC","buscaAdicional":"AFM 3696 AFM 71302"},{"id":"02197a58-7ea5-450d-5e2f-08d5ad2bf6ba","name":"FUNDIMET INDUSTRIA E COMERCIO LTDA","commercialName":"FUNDIMET","cnpj":"02312019000107","city":"LUZERNA","stateCode":"SC","buscaAdicional":"FUNDIMET 52271 FUNDIMET LUZERNA SC 901139"},{"id":"6a85e6ff-3003-4ebb-6187-08d5ad2bf6ba","name":"MEDAL FUNDICAO LTDA","commercialName":"MEDAL FUNDICAO","cnpj":"14921288000141","city":"LUZERNA","stateCode":"SC","buscaAdicional":"MEDAL FUNDICAO 54226 MEDAL FUNDICAO LUZER 904324"},{"id":"bbd323c2-803b-4715-5db5-08d5ad2bf6ba","name":"BRIDGESTONE DO BRASIL INDUSTRIA E COMERCIO LTDA.","commercialName":"BRIDGESTONE","cnpj":"57497539001600","city":"MAFRA","stateCode":"SC","buscaAdicional":"BRID MAFRA 51962 BRID MAFRA 904132"},{"id":"908ba779-b45e-4a65-60e4-08d5ad2bf6ba","name":"MADEIREIRA EK LTDA","commercialName":"","cnpj":"75025734000124","city":"MAFRA","stateCode":"SC","buscaAdicional":"MADEIREIRA EK 53854 MADEIREIRA EK 904222"},{"id":"8c10e902-3911-46b0-5a26-08d5ad2bf6ba","name":"NB GERACAO DE ENERGIA LTDA","commercialName":"","cnpj":"08302031000109","city":"MAFRA","stateCode":"SC","buscaAdicional":"NB GERACAO 16565"},{"id":"3c3092ba-4b3b-4822-5a9a-08d5ad2bf6ba","name":"MOINHO CATARINENSE S A","commercialName":"","cnpj":"85129518000182","city":"MAFRA","stateCode":"SC","buscaAdicional":"MOINHO CATARINENSE 50103 MOINHO CATARINENSE 896684 MOINHO CATARI PRODUC 896685"},{"id":"1ff4e664-592e-4b14-600c-08d5ad2bf6ba","name":"LATICINIOS BELA VISTA LTDA","commercialName":"LATICINIOS BELA VISTA FILIAL 09","cnpj":"02089969001005","city":"MARAVILHA","stateCode":"SC","buscaAdicional":"PIRACANJUBA SC 53358 PIRACANJUBA SC 904192"},{"id":"b8a9f97a-87a9-44cf-66ce-08d5ad2bf6ba","name":"COOPERATIVA JURITI","commercialName":"COOPERJURITI","cnpj":"84093137000128","city":"MASSARANDUBA","stateCode":"SC","buscaAdicional":"COOPER JURITI 57835 COOP JURITI MATRIZ 909415 COOP JURITI FILIAL 909416"},{"id":"f65c96b2-eac7-4bc3-6673-08d5ad2bf6ba","name":"HENN INDUSTRIA MOVELEIRA LTDA","commercialName":"","cnpj":"08008273000194","city":"MONDAÍ","stateCode":"SC","buscaAdicional":"HENN INDUSTRIA 57576 MOVEIS HENN 897488"},{"id":"7fcaecc3-8d16-482d-5923-08d5ad2bf6ba","name":"INDUSTRIA TEXTIL OESTE LTDA","commercialName":"","cnpj":"85217404000194","city":"MONDAÍ","stateCode":"SC","buscaAdicional":"TEXTIL OESTE 13857 TEXTIL OESTE 892927"},{"id":"2b9bb0ff-0819-4f8d-595f-08d5ad2bf6ba","name":"ESMALGLASS DO BRASIL - FRITAS, ESMALTES E CORANTES CERAMICOS LTDA","commercialName":"ESMALGLASS DO BRASIL","cnpj":"86981966000172","city":"MORRO DA FUMAÇA","stateCode":"SC","buscaAdicional":"ESMALGLASS 14335 ESMALGLASS 893644"},{"id":"166d3f3b-2462-41ad-66b9-08d5ad2bf6ba","name":"FUMACENSE ALIMENTOS LTDA","commercialName":"FUMACENSE ALIMENTOS","cnpj":"76828201000143","city":"MORRO DA FUMAÇA","stateCode":"SC","buscaAdicional":"FUMACENSE ALIMENTOS 57759 CEREALISTA ALEGRETE 904896"},{"id":"9af9034b-04ad-41bb-680f-08d5ad2bf6ba","name":"PORTONAVE S/A - TERMINAIS PORTUARIOS DE NAVEGANTES","commercialName":"","cnpj":"01335341000180","city":"NAVEGANTES","stateCode":"SC","buscaAdicional":"PORTONAVE 59300 PORTONAVE NAVEGANTES 909835"},{"id":"71eafce5-22ce-4907-62d7-08d5ad2bf6ba","name":"GARTHEN INDUSTRIA E COMERCIO DE MAQUINAS LTDA","commercialName":"","cnpj":"82981721000194","city":"NAVEGANTES","stateCode":"SC","buscaAdicional":"GARTHEN 54990 GARTHEN 905032"},{"id":"e99e0678-c3bd-4ebc-63c6-08d5ad2bf6ba","name":"ESTALEIRO NAVSHIP LTDA","commercialName":"","cnpj":"07171021000119","city":"NAVEGANTES","stateCode":"SC","buscaAdicional":"NAVSHIP 55623 NAVSHIP 906561"},{"id":"6167f747-9415-4708-6475-08d5ad2bf6ba","name":"EVEREST INDUSTRIA DE ALIMENTOS LTDA","commercialName":"SABOR SUL ALIMENTOS","cnpj":"05938805000102","city":"NAVEGANTES","stateCode":"SC","buscaAdicional":"EVEREST 56011 EVEREST 910253"},{"id":"8df29f51-920f-44b9-5459-08d5ad2bf6ba","name":"LEARDINI PESCADOS LTDA EM RECUPERACAO JUDICIAL EM RECUPERACAO JUDICIAL","commercialName":"","cnpj":"80727720000192","city":"NAVEGANTES","stateCode":"SC","buscaAdicional":"LEARDINI 4186 LEARDINI 71470"},{"id":"b7886e91-51d9-42e1-5aa1-08d5ad2bf6ba","name":"COSTA RICA MALHAS E CONFECCOES LTDA","commercialName":"","cnpj":"02944599002867","city":"NOVA TRENTO","stateCode":"SC","buscaAdicional":"COSTA RICA MALHAS 50119 COSTA RICA MALHAS 897024"},{"id":"ff019414-ef33-4767-5e7f-08d5ad2bf6ba","name":"BISTEK - SUPERMERCADOS LTDA.","commercialName":"","cnpj":"83261420000159","city":"NOVA VENEZA","stateCode":"SC","buscaAdicional":"BISTEK 52403 BISTEK LJ 18 903835 BISTEK LJ 18 CONDOMI 903853 BISTEK LJ 10 903974 BISTEK LJ 17 903975 BISTEK LJ 20 903976 BISTEK LJ 12 904682 BISTEK LJ 11 904683 BISTEK LJ 16 904700 BISTEK LJ 07 906649 BISTEK LOJA 4 907068 BISTEK ICARA SC 901087"},{"id":"4ae8709d-4717-467c-6149-08d5ad2bf6ba","name":"GHISLANDI - EMPREENDIMENTOS IMOBILIARIOS LTDA.","commercialName":"GEI","cnpj":"08376978000164","city":"NOVA VENEZA","stateCode":"SC","buscaAdicional":"GHISLANDI 54101 GHISLANDI 905029"},{"id":"f5c276b3-a234-4eeb-6161-08d5ad2bf6ba","name":"INDUSTRIA E COMERCIO DE PLASTICOS ZANINI LTDA","commercialName":"COPOZAN DESCARTAVEIS PLASTICOS","cnpj":"01883423000160","city":"ORLEANS","stateCode":"SC","buscaAdicional":"COPOZAN 54158 COPOZAN 904311"},{"id":"1d9307de-768f-4b78-672a-08d5ad2bf6ba","name":"FUNDACAO EDUCACIONAL BARRIGA VERDE","commercialName":"UNIBAVE,CENTRO DE EDUCACAO TECNICA-CETEC-UNIBAVE,EBV","cnpj":"82975236000108","city":"ORLEANS","stateCode":"SC","buscaAdicional":"FEBAVE 57989 BARRIGA VERDE 911817"},{"id":"45d5b473-1871-4a4d-55da-08d5ad2bf6ba","name":"ORLEPLAST INDUSTRIA E COMERCIO DE PLASTICOS LTDA","commercialName":"","cnpj":"85228880000100","city":"ORLEANS","stateCode":"SC","buscaAdicional":"ORLEPLAST 6249 ORLEPLAST-ORLEANS 72267"},{"id":"ab9e2297-cac3-497c-55dc-08d5ad2bf6ba","name":"PLASZOM ZOMER INDUSTRIA DE PLASTICOS LTDA","commercialName":"ZOMER INDUSTRIA DE PLATICOS","cnpj":"85285963000131","city":"ORLEANS","stateCode":"SC","buscaAdicional":"PLASZOM MATRIZ 6251 PLASZOM I-ORLEANS 72004 PLASZOM II-ORLEANS 72263 PLASZOM III ORLEANS 72388"},{"id":"82a28ca0-8613-4ef2-55e7-08d5ad2bf6ba","name":"GDM INDUSTRIA E COMERCIO DE PLASTICOS LTDA.","commercialName":"GDM PLASTICOS","cnpj":"07955100000110","city":"ORLEANS","stateCode":"SC","buscaAdicional":"GDM 6293 GDM 897104"},{"id":"3d4d4d79-d587-4c93-54f6-08d5ad2bf6ba","name":"SUDATI PAINEIS LTDA","commercialName":"SUDATI","cnpj":"08803452000113","city":"OTACÍLIO COSTA","stateCode":"SC","buscaAdicional":"SUDATI MDF 4619 SUDATI MDF 897683"},{"id":"889e4baa-a943-4b77-5243-08d5ad2bf6ba","name":"HIDRELETRICA ROSSI LTDA.","commercialName":"PCH FAXINAL DOS GUEDES","cnpj":"05311754000186","city":"OURO VERDE","stateCode":"SC","buscaAdicional":"PCH FAXINAL DOS GUEDES 2980 FAXINAL DOS GUEDES 8216 PCH.PH.SC.028830-6.01"},{"id":"f5db21a1-6ef3-4fc2-5fbf-08d5ad2bf6ba","name":"MUNDIALMIX COMERCIO DE ALIMENTOS LTDA","commercialName":"","cnpj":"82956160000173","city":"PALHOÇA","stateCode":"SC","buscaAdicional":"IMPERATRIZ 53207 IMPERATRIZ MATRIZ SC 903253 IMPERATRIZ LOJA 22 903254 IMPERATRIZ LOJA 16 904050 IMPERATRIZ LOJA 12 904052 IMPERATRIZ LOJA 3 906501 IMPERATRIZ LOJA 23 906555 IMPERATRIZ LOJA 8 907084"},{"id":"27ed6933-76a8-4572-688f-08d5ad2bf6ba","name":"IMAX INDUSTRIAL IMPORTADORA E EXPORTADORA DE VIDROS LTDA","commercialName":"IMAX INDUSTRIAL IMPORTADORA E EXPORTADORA","cnpj":"03046744000135","city":"PALHOÇA","stateCode":"SC","buscaAdicional":"IMAX 60154 IMAX INCOVISA 905040"},{"id":"c5528b70-29c5-479b-61e9-08d5ad2bf6ba","name":"CONDOMINIO DO CONJUNTO COMERCIAL SHOPPING VIA CATARINA","commercialName":"SHOPPING VIA CATARINA","cnpj":"12202724000105","city":"PALHOÇA","stateCode":"SC","buscaAdicional":"SHOPPING VIA CATARINA 54465 VIA CATARINA PALHOCA 906530"},{"id":"b277e3f5-5a6f-441c-5224-08d5ad2bf6ba","name":"HIDRELETRICA DETOFOL LTDA.","commercialName":"","cnpj":"08270140000191","city":"PALMA SOLA","stateCode":"SC","buscaAdicional":"DETOFOL 2885 DETOFOL 8582 CGH.PH.SC.029605-8.01"},{"id":"a234a59a-eb19-48d2-60c7-08d5ad2bf6ba","name":"RECICLA BRASIL LTDA","commercialName":"","cnpj":"04056176000116","city":"PAPANDUVA","stateCode":"SC","buscaAdicional":"RECICLA BRASIL 53719 RECICLA BRASIL 904336"},{"id":"e307d6ff-6ad3-4575-5833-08d5ad2bf6ba","name":"RONDINHA ENERGETICA S.A.","commercialName":"","cnpj":"10759764000119","city":"PASSOS MAIA","stateCode":"SC","buscaAdicional":"RONDINHA ENERG 11009 RONDINHA 892842 PCH.PH.SC.030382-8.01"},{"id":"56d3cf17-76ee-4639-5bfc-08d5ad2bf6ba","name":"J.B.WORLD ENTRETENIMENTOS S/A","commercialName":"BETO CARRERO WORLD","cnpj":"85248987000110","city":"PENHA","stateCode":"SC","buscaAdicional":"JBWORLD 51010 JB WORLD 898171"},{"id":"e4d7e48c-8454-4b18-6177-08d5ad2bf6ba","name":"PLAST - CENSI RECUPERADORA E IMPORTADORA DE PLASTICOS LTDA","commercialName":"PLAST-CENSI","cnpj":"07734900000101","city":"PENHA","stateCode":"SC","buscaAdicional":"PLAST - CENSI 54199 PLAST CENSI PENHA 904338"},{"id":"c376444b-ffa3-4d7d-5e67-08d5ad2bf6ba","name":"TAKATA BRASIL LTDA","commercialName":"TAKATA BRASIL","cnpj":"59106245000817","city":"BALNEÁRIO PIÇARRAS","stateCode":"SC","buscaAdicional":"TAKATA SC 52370 TAKATA SC 901078"},{"id":"1371f474-c8c1-4328-6802-08d5ad2bf6ba","name":"CLARICE ELETRODOMESTICOS LTDA","commercialName":"CLARICE ELETRODOMESTICOS","cnpj":"00851124000180","city":"PINHALZINHO","stateCode":"SC","buscaAdicional":"CLARICE 59181 CLARICE ELETRO 910046"},{"id":"a5b9df8b-4a03-45cb-6716-08d5ad2bf6ba","name":"SERPIL MOVEIS LTDA","commercialName":"SERPIL MOVEIS","cnpj":"79807350000114","city":"PINHALZINHO","stateCode":"SC","buscaAdicional":"SERPIL 57954 SERPIL MOVEIS LTDA 909333"},{"id":"143b543c-c603-4c29-6496-08d5ad2bf6ba","name":"RANDON EMBALAGENS PLASTICAS LTDA","commercialName":"","cnpj":"73379380000190","city":"PINHEIRO PRETO","stateCode":"SC","buscaAdicional":"RANDON EMBALAGENS 56113 RANDON EMBALAGENS 906551"},{"id":"92ac1c43-9bbd-4186-62e2-08d5ad2bf6ba","name":"POMERPLAST IND. E COM. DE PLASTICOS LTDA.","commercialName":"","cnpj":"02278437000117","city":"POMERODE","stateCode":"SC","buscaAdicional":"POMERPLAST 55023 POMERPLAST PLASTICO 909318"},{"id":"30020f8e-bbf9-495d-67fd-08d5ad2bf6ba","name":"CALESITA INDUSTRIA DE BRINQUEDOS LTDA","commercialName":"","cnpj":"00202187000106","city":"POMERODE","stateCode":"SC","buscaAdicional":"CALESITA 59132 CALESITA BRINQUEDOS 909641"},{"id":"449705a0-09b4-4633-8d78-08d5d060706e","name":"KYLY INDUSTRIA TEXTIL LTDA","commercialName":"MALHARIA KYLY","cnpj":"78855830000198","city":"POMERODE","stateCode":"SC","buscaAdicional":"KYLY 55943"},{"id":"16a9d560-b975-4dd9-5e20-08d5ad2bf6ba","name":"NETZSCH DO BRASIL INDUSTRIA E COMERCIO LTDA","commercialName":"","cnpj":"82749987000106","city":"POMERODE","stateCode":"SC","buscaAdicional":"NETZSCH 52226 NETZSCH 899223"},{"id":"61f794fb-5de9-4b2f-5d0e-08d5ad2bf6ba","name":"FKN TEXTIL LTDA","commercialName":"","cnpj":"00317596000158","city":"POMERODE","stateCode":"SC","buscaAdicional":"FAKINI 51689 FKN TEXTIL LTDA 900030"},{"id":"d9acec43-f59b-4867-5d69-08d5ad2bf6ba","name":"CENTERPLAST EMBALAGENS PLASTICAS LTDA","commercialName":"CP EMBALAGENS","cnpj":"04376684000181","city":"POMERODE","stateCode":"SC","buscaAdicional":"CENTERPLAST 51811 CENTERPLAST 904138"},{"id":"666febe1-b11e-45c9-6011-08d5ad2bf6ba","name":"OURO PRETO MINERACAO LTDA","commercialName":"PEDREIRA OURO PRETO","cnpj":"83493973000137","city":"POMERODE","stateCode":"SC","buscaAdicional":"OURO PRETO 53363 OURO PRETO 904228"},{"id":"c11331ab-7007-4e1a-583f-08d5ad2bf6ba","name":"HITECH ETIQUETAS LTDA","commercialName":"","cnpj":"06295068000121","city":"POMERODE","stateCode":"SC","buscaAdicional":"HITECH 11090 HITECH 897084"},{"id":"4e56096d-36a0-4e60-54fb-08d5ad2bf6ba","name":"CATIVA TEXTIL INDUSTRIA E COMERCIO LTDA","commercialName":"","cnpj":"80959513000163","city":"POMERODE","stateCode":"SC","buscaAdicional":"CATIVA 4660 CATIVA-POMEDORE 71685"},{"id":"00cd4a6d-b0e4-454d-545f-08d5ad2bf6ba","name":"SUPREMO CIMENTOS S.A.","commercialName":"","cnpj":"05798883000140","city":"POMERODE","stateCode":"SC","buscaAdicional":"SUPREMO 4199 SUPREMO CIMENTOS-SC 71475"},{"id":"3345fac2-39ca-42e5-560b-08d5ad2bf6ba","name":"BOSCH REXROTH LTDA","commercialName":"BOSCH REXROTH","cnpj":"72908817000416","city":"POMERODE","stateCode":"SC","buscaAdicional":"BOSCH REXROTH 6517 BOSCH REXROTH 72356"},{"id":"f81c0219-58a4-4148-59e7-08d5ad2bf6ba","name":"CGH CASAGRANDE ENERGETICA S/A","commercialName":"","cnpj":"14773910000111","city":"PONTE ALTA DO NORTE","stateCode":"SC","buscaAdicional":"CGH CASAGRANDE 15780 CASAGRANDE 896664 CGH.PH.SC.033998-9.01"},{"id":"78dc9a0a-f0e8-497b-5930-08d5ad2bf6ba","name":"USINA RIO DO MATO LTDA","commercialName":"RIO DO MATO ENERGIA","cnpj":"09517838000121","city":"PONTE SERRADA","stateCode":"SC","buscaAdicional":"CGH RIO DO MATO 14015 RIO DO MATO 893162 CGH.PH.SC.029945-6.01"},{"id":"7349eef7-4738-41fb-5fd2-08d5ad2bf6ba","name":"SANTA CATARINA INDUSTRIA E COMERCIO DE COMPENSADOS LTDA.","commercialName":"SANTA CATARINA COMPENSADOS","cnpj":"09509277000119","city":"PORTO UNIÃO","stateCode":"SC","buscaAdicional":"SC COMPENSADOS 53235 SC COMPENSADOS 907737"},{"id":"b289b3ca-5dec-48e9-577d-08d5ad2bf6ba","name":"ABBASPEL INDUSTRIA E COMERCIO DE PAPEIS LTDA.","commercialName":"ABBASPEL INDUSTRIA E COMERCIO DE PAPEIS","cnpj":"04490046000197","city":"PORTO UNIÃO","stateCode":"SC","buscaAdicional":"ABBASPEL 8952 ABBASPEL 898156"},{"id":"7788ea90-d63c-4e6a-54d2-08d5ad2bf6ba","name":"HIDROELETRICA PARDOS S/A","commercialName":"PCH PARDOS","cnpj":"06374036000111","city":"PORTO UNIÃO","stateCode":"SC","buscaAdicional":"PARDOS 4520 PARDOS 888687 PCH.PH.SC.030123-0.01"},{"id":"f36f0e33-064d-497f-6925-08d5ad2bf6ba","name":"R C M CABOS ELETRICOS LTDA","commercialName":"","cnpj":"11792286000101","city":"PORTO UNIÃO","stateCode":"SC","buscaAdicional":"RCM CABOS 60794 RCM CABOS ELETRICOS 912436"},{"id":"fbb89e8f-f975-4904-66de-08d5ad2bf6ba","name":"KERBER & CIA LTDA","commercialName":"","cnpj":"78408960000182","city":"PORTO UNIÃO","stateCode":"SC","buscaAdicional":"KERBER E CIA 57862 KERBER E CIA 910895"},{"id":"2be22dfa-7e4d-4599-61b7-08d5ad2bf6ba","name":"COMPENSA IND E COM DE COMPENSADOS LTDA","commercialName":"","cnpj":"00107365000110","city":"PORTO UNIÃO","stateCode":"SC","buscaAdicional":"COMPENSA 54348 COMPENSA 905871"},{"id":"d1c6ab9a-c749-4b47-6112-08d5ad2bf6ba","name":"ROHDEN VIDROS LTDA","commercialName":"","cnpj":"05959604000264","city":"POUSO REDONDO","stateCode":"SC","buscaAdicional":"ROHDEN VIDROS II 53991 ROHDEN VIDROS 2 904299"},{"id":"b4693f3d-d429-49a7-1ca0-08d5b8870181","name":"FRIGORIFICO VERDI LTDA.","commercialName":"","cnpj":"85641066000113","city":"POUSO REDONDO","stateCode":"SC","buscaAdicional":"FRIGO VERDI 57859 FRIGORIFICO VERDI 912773"},{"id":"28fc8596-731b-4e7d-6109-08d5ad2bf6ba","name":"ROHDEN PORTAS E PAINEIS LTDA","commercialName":"","cnpj":"01735959000138","city":"POUSO REDONDO","stateCode":"SC","buscaAdicional":"ROHDEN PORTAS 53977 ROHDEN PORTA PAINEL 904278"},{"id":"a603ad65-03cb-46be-5e55-08d5ad2bf6ba","name":"CERAMICA LORENZETTI LTDA","commercialName":"","cnpj":"75364455000195","city":"POUSO REDONDO","stateCode":"SC","buscaAdicional":"CERAMICA LORENZETTI 52333 CERAMICA LORENZETTI 899866"},{"id":"5f1b34c7-59f0-44cb-5e43-08d5ad2bf6ba","name":"CARACOL GEOLOGIA E MINERACAO LTDA","commercialName":"","cnpj":"80068471000170","city":"PRESIDENTE GETÚLIO","stateCode":"SC","buscaAdicional":"CARACOL 52306 CARACOL 899946"},{"id":"cf870f7f-df94-4473-54df-08d5ad2bf6ba","name":"PAMPLONA ALIMENTOS S/A","commercialName":"","cnpj":"85782878002475","city":"PRESIDENTE GETÚLIO","stateCode":"SC","buscaAdicional":"PAMPLONA PG 4556 PAMPLONA PRD GETULIO 71655"},{"id":"ae0aa0e5-2ed3-481e-68ea-08d5ad2bf6ba","name":"G 13 MADEIRAS LTDA","commercialName":"","cnpj":"04167644000120","city":"PRESIDENTE GETÚLIO","stateCode":"SC","buscaAdicional":"G13 MADEIRAS 60570 G13 MADEIRAS PG 911815"},{"id":"ab6893d3-b1b8-46ec-60f0-08d5ad2bf6ba","name":"KRAFTWERK GERACAO ELETRICA LTDA","commercialName":"","cnpj":"09435549000183","city":"PRESIDENTE NEREU","stateCode":"SC","buscaAdicional":"KRAFTWERK 53907 BERTOLDO JACOBSEN 910128 CGH.PH.SC.037406-7.01"},{"id":"d9c08387-5df7-4113-5cb5-08d5ad2bf6ba","name":"GW EMBALAGENS PLASTICAS EIRELI","commercialName":"GW EMBALAGENS PLASTICAS","cnpj":"83206219000179","city":"RIO DAS ANTAS","stateCode":"SC","buscaAdicional":"GW EMBALAGENS 51513 GW EMBALAGENS 899698"},{"id":"66426635-e67f-459c-599c-08d5ad2bf6ba","name":"G & D GERADORA DE ENERGIA ELETRICA LTDA.","commercialName":"G & D USINA HIDRELETRICA","cnpj":"08939523000100","city":"RIO DO CAMPO","stateCode":"SC","buscaAdicional":"G&D 15156 G&D 894522 CGH.PH.SC.031623-7.01"},{"id":"6bf7a6f7-3a54-40f0-5d6a-08d5ad2bf6ba","name":"ESQUADRIBRAS - INDUSTRIA DE ESQUADRIAS LTDA","commercialName":"","cnpj":"83115303000187","city":"RIO DOS CEDROS","stateCode":"SC","buscaAdicional":"ESQUADRIBRAS 51813 ESQUADRIBRAS 902973"},{"id":"73449e9c-cb33-45c9-5f80-08d5ad2bf6ba","name":"MOCAM SUPERMERCADOS LTDA","commercialName":"","cnpj":"86378429000132","city":"RIO DOS CEDROS","stateCode":"SC","buscaAdicional":"MOCAM SUPERMERCADOS 53000 MOCAM 29169055 900861 MOCAM 23573229 901020 MOCAM 45134490 901021 MOCAM 32440690 901043 MOCAM 24462005 901220 MOCAM 27154190 901443 MOCAM 49961715 901618"},{"id":"0249ce19-9f74-45f4-6938-08d5ad2bf6ba","name":"TERCILIO MARCHETTI INDUSTRIA E COMERCIO DE AUTOPECAS LTDA","commercialName":"MOLAS MARCHETTI","cnpj":"86377470000518","city":"RIO DOS CEDROS","stateCode":"SC","buscaAdicional":"MOLAS MARCHETTI IND 60845 TERCILIO MARCHETTI I 911284"},{"id":"dfec911b-8385-4301-6418-08d5ad2bf6ba","name":"TEXTIL RIO DOS CEDROS LTDA","commercialName":"","cnpj":"85400547000137","city":"RIO DOS CEDROS","stateCode":"SC","buscaAdicional":"TEXTIL RIO DOS CEDROS 55839 TEXTIL RIO CEDROS 907229"},{"id":"70dcfe5c-4b09-4fa9-6580-08d5ad2bf6ba","name":"HERGEN S A MAQUINAS E EQUIPAMENTOS","commercialName":"","cnpj":"83141507000273","city":"RIO DO SUL","stateCode":"SC","buscaAdicional":"HERGEN 56750 HERGEN SA MAQUINAS 908829"},{"id":"92803bd5-cf05-4209-6059-08d5ad2bf6ba","name":"ROYAL CICLO INDUSTRIA DE COMPONENTES LTDA","commercialName":"","cnpj":"00637261000117","city":"RIO DO SUL","stateCode":"SC","buscaAdicional":"ROYAL CICLO 53475 ROYAL CICLO 901916"},{"id":"56b6b42a-1490-408b-5cac-08d5ad2bf6ba","name":"INDUSTRIA AGRO COMERCIAL CASSAVA SA","commercialName":"","cnpj":"85778595000163","city":"RIO DO SUL","stateCode":"SC","buscaAdicional":"CASSAVA 51501 AGRO CASSAVA 900787"},{"id":"c936b33a-008c-4b4b-5e11-08d5ad2bf6ba","name":"METALURGICA RIOSULENSE SA","commercialName":"RIOSULENSE","cnpj":"85778074000106","city":"RIO DO SUL","stateCode":"SC","buscaAdicional":"METALURGICA RIOSULENSE 52187 METALURGICA RIOSULEN 900999"},{"id":"e146f85a-720f-48a3-5e53-08d5ad2bf6ba","name":"CERAMICA PRINCESA E TRANSPORTE LTDA","commercialName":"","cnpj":"83631051000149","city":"RIO DO SUL","stateCode":"SC","buscaAdicional":"PRINCESA 52331 PRINCESA SC 899757"},{"id":"ab114093-672c-4fdb-558f-08d5ad2bf6ba","name":"COOPERATIVA REGIONAL AGROPECUARIA VALE DO ITAJAI","commercialName":"CRAVIL","cnpj":"85789782000142","city":"RIO DO SUL","stateCode":"SC","buscaAdicional":"CRAVIL MATRIZ 5800 CRAVIL-RIO DO SUL 71925 CRAVIL POUSO REDONDO 889658 SUPER CRAVIL 888784"},{"id":"96e82f19-1982-4e01-5235-08d5ad2bf6ba","name":"PAMPLONA ALIMENTOS S/A","commercialName":"","cnpj":"85782878000189","city":"RIO DO SUL","stateCode":"SC","buscaAdicional":"PAMPLONA 2923 PAMPLONA MATRIZ 889075 PAMPLONA ALIMENTOS 900516"},{"id":"318d8ff9-a6f2-409f-5304-08d5ad2bf6ba","name":"INDUMA S/A INDUSTRIA DE PAPEL E PAPELAO","commercialName":"INDUMA","cnpj":"82643255000137","city":"RIO DO SUL","stateCode":"SC","buscaAdicional":"INDUMA 3435 INDUMA 71135 HORST PURNHAGEN 895541 CGH.PH.SC.032085-4.01"},{"id":"95194255-a8d4-44e6-4f80-08d5ad2bf6ba","name":"MAFRAS ENERGIA E REFLORESTAMENTO LTDA","commercialName":"","cnpj":"76312008000155","city":"RIO DO SUL","stateCode":"SC","buscaAdicional":"CGH WILLY FALLER 1138 CGH WILLY FALLER 908251 CGH.PH.SC.030845-5.01"},{"id":"cf20c867-2782-47f5-52fa-08d5ad2bf6ba","name":"GERADORA DE ENERGIA SAO MAURICIO S/A","commercialName":"PCH SAO MAURICIO","cnpj":"06171739000142","city":"RIO FORTUNA","stateCode":"SC","buscaAdicional":"SAO MAURICIO 3395 SAO MAURICIO 8676 PCH.PH.SC.029137-4.01"},{"id":"6e8fdb72-9b0c-4c01-51fc-08d5ad2bf6ba","name":"CENTRAL GERADORA HIDROELETRICA J E LTDA","commercialName":"C.G.H. RIO CHAPEU","cnpj":"07908086000102","city":"RIO FORTUNA","stateCode":"SC","buscaAdicional":"CGH RIO CHAPEU 2770 RIO CHAPEU 8294 CGH.PH.SC.029425-0.01"},{"id":"de62e4c8-303f-42fe-56cb-08d5ad2bf6ba","name":"GERADORA DE ENERGIA RIO FORTUNA S/A","commercialName":"PCH RIO FORTUNA","cnpj":"06172042000196","city":"RIO FORTUNA","stateCode":"SC","buscaAdicional":"PCH R FORTUNA 7720 RIO FORTUNA 20006 PCH.PH.SC.029140-4.01"},{"id":"a9cb805f-0a00-4df0-5aaf-08d5ad2bf6ba","name":"VALMIRO WIGGERS & CIA LTDA","commercialName":"COMERCIAL SANTA ROSA","cnpj":"85138238000130","city":"RIO FORTUNA","stateCode":"SC","buscaAdicional":"WIGGERS 50175 CGH WIGGERS 904118 CGH.PH.SC.029384-9.01"},{"id":"c587f05e-5611-4410-5e84-08d5ad2bf6ba","name":"BACIC INDUSTRIAL DE PLASTICOS LTDA.","commercialName":"","cnpj":"07365641000199","city":"RIO NEGRINHO","stateCode":"SC","buscaAdicional":"BACIC 52412 BACIC 903075"},{"id":"4b0a197e-4ad1-4331-5ccd-08d5ad2bf6ba","name":"CAHDAM VOLTA GRANDE S.A.","commercialName":"","cnpj":"00433450000178","city":"RIO NEGRINHO","stateCode":"SC","buscaAdicional":"CAHDAM 51574 CAHDAM VOLTA GRANDE 898731"},{"id":"c77a7c1d-58a6-4f39-5cdd-08d5ad2bf6ba","name":"C.V.G.CIA VOLTA GRANDE DE PAPEL","commercialName":"","cnpj":"85906329000330","city":"RIO NEGRINHO","stateCode":"SC","buscaAdicional":"CVG 51595 CIA VOLTA GRANDE 898789"},{"id":"5bd8383f-a6c8-47e7-5d1a-08d5ad2bf6ba","name":"SOLIDA BRASIL MADEIRAS LTDA","commercialName":"","cnpj":"10556018000209","city":"RIO NEGRINHO","stateCode":"SC","buscaAdicional":"SOLIDA 51702 SOLIDA BRASIL SC 898554"},{"id":"466622ec-43c9-4a3f-6784-08d5ad2bf6ba","name":"WIND INDUSTRIAL EIRELI","commercialName":"","cnpj":"03351783000146","city":"RIO NEGRINHO","stateCode":"SC","buscaAdicional":"WIND 58235 WIND INDUSTRIAL 909337"},{"id":"27cc7be2-5ad0-438d-5e22-08d5ad2bf6ba","name":"CS SILVA LTDA","commercialName":"CERAMICA SILVA","cnpj":"02108321000130","city":"SANGÃO","stateCode":"SC","buscaAdicional":"CS SILVA 52232 CERAMICA SILVA 901182"},{"id":"5a3df01c-a73a-40f9-5dcd-08d5ad2bf6ba","name":"TERRACOTAGRES CERAMICA LTDA","commercialName":"","cnpj":"15119903000163","city":"SANGÃO","stateCode":"SC","buscaAdicional":"ICETEC 51991 TERRACOTAGRES 904913"},{"id":"a45fcd9c-f8ed-4ee5-5add-08d5ad2bf6ba","name":"H.F.SISTEMAS DE FREIO LTDA","commercialName":"","cnpj":"09075317000242","city":"SANGÃO","stateCode":"SC","buscaAdicional":"HIPPER FREIOS 50293 HIPPER FREIOS 898133"},{"id":"1ca1e4a1-0167-42cb-58f8-08d5ad2bf6ba","name":"CERAMICA CEJATEL LTDA.","commercialName":"","cnpj":"85147627000122","city":"SANGÃO","stateCode":"SC","buscaAdicional":"CERAMICA CEJATEL 13493 CEJATEL CERAMICA 892643"},{"id":"69a3c9cb-8e0a-4b5e-59e8-08d5ad2bf6ba","name":"FRASCAL GERACAO DE ENERGIAS RENOVAVEIS LTDA","commercialName":"FRASCAL ENERGIAS RENOVAVEIS","cnpj":"85996171000175","city":"SANTA CECÍLIA","stateCode":"SC","buscaAdicional":"FRASCAL 15795 FRASCAL 895521 CGH.PH.SC.031041-7.01"},{"id":"22d16bf5-f83e-4569-5db3-08d5ad2bf6ba","name":"INDUSTRIA DE COMPENSADOS GUARARAPES LTDA","commercialName":"COMPENSADOS GUARARAPES","cnpj":"77911261000350","city":"SANTA CECÍLIA","stateCode":"SC","buscaAdicional":"GUARARAPES STACECILIA 51960 IND COMP GUARARAPES 899280"},{"id":"3a2f2d13-8536-483e-558c-08d5ad2bf6ba","name":"GERADORA DE ENERGIA NOVA FATIMA S/A","commercialName":"PCH NOVA FATIMA","cnpj":"06171774000161","city":"SANTA ROSA DE LIMA","stateCode":"SC","buscaAdicional":"PCH NOVA FATIMA 5779 NOVA FATIMA 8987 PCH.PH.SC.029139-0.01"},{"id":"0ae62056-ea05-4830-51cc-08d5ad2bf6ba","name":"HIDRELETRICA SENS LTDA","commercialName":"","cnpj":"02444931000376","city":"SANTA TEREZINHA","stateCode":"SC","buscaAdicional":"SENS 2597 RIO ITAIOZINHO 8307 CGH.PH.SC.029756-9.01"},{"id":"a2afea43-30d3-41b6-681f-08d5ad2bf6ba","name":"FLEXICOTTON INDUSTRIA E COMERCIO DE PRODUTOS DE HIGIENE PESSOAL S/A","commercialName":"","cnpj":"02003095000122","city":"SANTO AMARO DA IMPERATRIZ","stateCode":"SC","buscaAdicional":"FLEXICOTTON 59373 FLEXICOTTON - STO AM 910123"},{"id":"5ecc3f15-8af5-4bda-6894-08d5ad2bf6ba","name":"VIDRACARIA PRIMOS LTDA","commercialName":"","cnpj":"80934375000168","city":"SÃO BENTO DO SUL","stateCode":"SC","buscaAdicional":"PRIMOS 60168 PRIMOS 910347"},{"id":"a931e495-c6b7-45d0-644b-08d5ad2bf6ba","name":"CONDOR S.A","commercialName":"CONDOR","cnpj":"86046448000161","city":"SÃO BENTO DO SUL","stateCode":"SC","buscaAdicional":"CONDOR IND 55914 CONDOR SA 905025"},{"id":"7a068a59-41c9-4d0d-644c-08d5ad2bf6ba","name":"CONDOR INDUSTRIA DE PLASTICOS LTDA.","commercialName":"","cnpj":"12073475000197","city":"SÃO BENTO DO SUL","stateCode":"SC","buscaAdicional":"CONDOR PLAST 55915 CONDOR INDUSTRIA 904820"},{"id":"e9e5966e-e68d-41ff-62a7-08d5ad2bf6ba","name":"METALURGICA DENK LTDA","commercialName":"","cnpj":"82770017000192","city":"SÃO BENTO DO SUL","stateCode":"SC","buscaAdicional":"DENK 54898 DENK FABRICA 2 905897 DENK FABRICA 1 905900"},{"id":"6c89922b-6902-443f-5337-08d5ad2bf6ba","name":"FIACAO SAO BENTO SA","commercialName":"","cnpj":"86046414000177","city":"SÃO BENTO DO SUL","stateCode":"SC","buscaAdicional":"FIACAO S BENTO 3518 FSB MATRIZ 71136"},{"id":"5d57b50a-cefe-47cc-5244-08d5ad2bf6ba","name":"USINA RIO VERMELHO DE ENERGIA LTDA.","commercialName":"URVE","cnpj":"07206715000144","city":"SÃO BENTO DO SUL","stateCode":"SC","buscaAdicional":"RIO VERMELHO 2981 RIO VERMELHO 8447 PCH.PH.SC.029729-1.01 RIO VERMELHO CGH 892442 CGH.PH.SC.031376-9.01"},{"id":"bf047f0a-e807-4c2d-54b0-08d5ad2bf6ba","name":"TUPER S/A","commercialName":"TUPER - DIVISAO TUBOS","cnpj":"81315426000136","city":"SÃO BENTO DO SUL","stateCode":"SC","buscaAdicional":"TUPER 4440 TUPER ESCAPAMENTOS 71641 TUPER TUBOS-SC 71642"},{"id":"38e21290-a99e-4a47-5497-08d5ad2bf6ba","name":"BUDDEMEYER S/A","commercialName":"BUDDEMEYER","cnpj":"86047198000184","city":"SÃO BENTO DO SUL","stateCode":"SC","buscaAdicional":"BUDDEMEYER 4354 BUDDEMEYER-S B SUL 71633"},{"id":"8faab954-d18d-4288-536e-08d5ad2bf6ba","name":"OXFORD PORCELANAS INDUSTRIAL LTDA.","commercialName":"","cnpj":"12128514000106","city":"SÃO BENTO DO SUL","stateCode":"SC","buscaAdicional":"OXFORD 3634 OXFORD 71196"},{"id":"800d3af3-cf3e-4480-57b4-08d5ad2bf6ba","name":"MOVEIS RUDNICK S A","commercialName":"","cnpj":"86046612000130","city":"SÃO BENTO DO SUL","stateCode":"SC","buscaAdicional":"RUDNICK 9372 RUDNICK S BENTO SUL 888836 RUDNICK CRUZEIRO 902523 RUDNICK BELA ALIANCA 902626"},{"id":"12d1227c-6d34-4fb4-5dea-08d5ad2bf6ba","name":"INDUSTRIAS ARTEFAMA S.A.","commercialName":"","cnpj":"86046562000191","city":"SÃO BENTO DO SUL","stateCode":"SC","buscaAdicional":"INDUSTRIAS ARTEFAMA 52068 IND ARTEFAMA 899976"},{"id":"bf73aa3c-d8a0-4d71-5e3b-08d5ad2bf6ba","name":"MOVEIS WEIHERMANN S A","commercialName":"","cnpj":"86047362000153","city":"SÃO BENTO DO SUL","stateCode":"SC","buscaAdicional":"MOVEIS WEIHERMANN 52290 MOVEIS WEIHERMANN 904179"},{"id":"5678efd0-8d95-4af4-5e46-08d5ad2bf6ba","name":"STEELMAST METALURGICA LTDA","commercialName":"","cnpj":"07229006000184","city":"SÃO BENTO DO SUL","stateCode":"SC","buscaAdicional":"STEELMAST 52309 KM 26 SAO BENTO 899704"},{"id":"f0fe8fb9-c992-42df-602f-08d5ad2bf6ba","name":"INTER LINK DO BRASIL INDUSTRIA E COMERCIO DE MOVEIS LTDA","commercialName":"INTER LINK GROUP OF PRODUCTION","cnpj":"05559064000140","city":"SÃO BENTO DO SUL","stateCode":"SC","buscaAdicional":"INTER LINK 53418 INTER LINK 904317"},{"id":"3909ead2-b37f-434b-67be-08d5ad2bf6ba","name":"ROVER ENERGIA LTDA","commercialName":"","cnpj":"02367784000116","city":"SÃO CRISTOVÃO DO SUL","stateCode":"SC","buscaAdicional":"ROVER ENERGIA 58598 CGH APOLO 910972 CGH.PH.SC.035531-3.01"},{"id":"5eefb3ef-185d-49f3-8d9c-08d5d060706e","name":"SA FOSFOROS GABOARDI","commercialName":"","cnpj":"83754986000112","city":"SÃO CRISTOVÃO DO SUL","stateCode":"SC","buscaAdicional":"GABOARDI 61392 GABOARDI 12352948 913397 GABOARDI 12352956 913416"},{"id":"2f81a403-0ff2-40ce-6782-08d5ad2bf6ba","name":"SAO DOMINGOS GERACAO DE ENERGIAS RENOVAVEIS LTDA","commercialName":"","cnpj":"25163982000163","city":"SÃO DOMINGOS","stateCode":"SC","buscaAdicional":"SAO DOMINGOS GERACAO 58233 CGH SAO DOMINGOS 910291 CGH.PH.SC.037229-3.01"},{"id":"ac6acfed-238b-4997-6100-08d5ad2bf6ba","name":"NUTRIFORTE LTDA","commercialName":"","cnpj":"03644285000191","city":"SÃO DOMINGOS","stateCode":"SC","buscaAdicional":"NUTRIFORTE 53948 NUTRIFORTE 903120"},{"id":"1f6dd212-cf6d-40f4-61be-08d5ad2bf6ba","name":"LATICINIOS SAO JOAO S/A","commercialName":"","cnpj":"78269545000195","city":"SÃO JOÃO DO OESTE","stateCode":"SC","buscaAdicional":"LAC LELO 54364 LATICINIOS SAO JOAO 904227"},{"id":"c5a1099c-94df-471f-6570-08d5ad2bf6ba","name":"CARTONAGEM BATISTENSE LTDA","commercialName":"CARTONAGEM BATISTENSE","cnpj":"82576588000190","city":"SÃO JOÃO BATISTA","stateCode":"SC","buscaAdicional":"CARTONAGEM BATISTENSE 56728 CARTONAGEM BATISTENS 908027"},{"id":"2ff41fd6-86c1-4604-67bb-08d5ad2bf6ba","name":"INDUSTRIA E COMERCIO DE CALCADOS VIASCARPA LTDA","commercialName":"DIA A DIA","cnpj":"85275386000105","city":"SÃO JOÃO BATISTA","stateCode":"SC","buscaAdicional":"VIA SCARPA 58590 VIA SCARPA 909340"},{"id":"c9d19f1e-0d68-43ea-67c1-08d5ad2bf6ba","name":"INDUSTRIA E COMERCIO DE CALCADOS ALA LTDA","commercialName":"","cnpj":"78658846000100","city":"SÃO JOÃO BATISTA","stateCode":"SC","buscaAdicional":"CALCADOS ALA 58605 CALCADOS ALA 909316"},{"id":"bdd509ab-4455-4e97-67f7-08d5ad2bf6ba","name":"LR INDUSTRIA DE SOLADOS EIRELI","commercialName":"","cnpj":"09049532000198","city":"SÃO JOÃO BATISTA","stateCode":"SC","buscaAdicional":"LR SOLADOS 59110 LR SOLADOS 909341"},{"id":"81bf2098-0a51-4af1-5edc-08d5ad2bf6ba","name":"FRISAJO AGRO PECUARIA INDUSTRIAL LTDA","commercialName":"FRIGORIFICO SAO JOAO","cnpj":"83796763000118","city":"SÃO JOÃO DO ITAPERIÚ","stateCode":"SC","buscaAdicional":"FRISAJO 52588 FRISAJO S J ITAPERIU 902686"},{"id":"c9693994-1c31-494b-5640-08d5ad2bf6ba","name":"RONDINHA GERADORA DE ENERGIA LTDA","commercialName":"","cnpj":"07969746000157","city":"SÃO JOAQUIM","stateCode":"SC","buscaAdicional":"RONDINHA 6822 INVERNADINHA 20001 PCH.PH.SC.030261-9.01"},{"id":"ffcddb63-5c51-4611-63e2-08d5ad2bf6ba","name":"COOPERATIVA REGIONAL AGROPECUARIA SERRANA","commercialName":"COOPERSERRA","cnpj":"83294215000190","city":"SÃO JOAQUIM","stateCode":"SC","buscaAdicional":"COOPERSERRA 55692 COOPER SERRA 906979"},{"id":"8b91c55d-7428-4318-886b-08d5ae44ed50","name":"SEARA COMERCIO DE ALIMENTOS LTDA","commercialName":"FRANGOS MACEDO","cnpj":"83044016000123","city":"SÃO JOSÉ","stateCode":"SC","buscaAdicional":"MACEDO AGROIN 5858"},{"id":"1fe8edc8-36b6-4d49-665c-08d5ad2bf6ba","name":"CONDOMINIO SHOPPING CENTER ITAGUACU","commercialName":"","cnpj":"83816694000167","city":"SÃO JOSÉ","stateCode":"SC","buscaAdicional":"SHOP ITAGUACU 57510 SH ITAGUACU S JOSE 2 907738 SH ITAGUACU S JOSE 1 907751"},{"id":"c02c261d-b35a-4c73-54e7-08d5ad2bf6ba","name":"INTELBRAS S.A. INDUSTRIA DE TELECOMUNICACAO ELETRONICA BRASILEIRA","commercialName":"INTELBRAS","cnpj":"82901000000127","city":"SÃO JOSÉ","stateCode":"SC","buscaAdicional":"INTELBRAS 4580 INTELBRAS 899185"},{"id":"460db393-1c26-4410-559b-08d5ad2bf6ba","name":"C - PACK CREATIVE PACKAGING S/A","commercialName":"","cnpj":"03364555000100","city":"SÃO JOSÉ","stateCode":"SC","buscaAdicional":"C PACK 5883 C PACK-SAO JOSE 71849"},{"id":"363ba178-b91d-46aa-6103-08d5ad2bf6ba","name":"CONDOMINIO SHOPPING IDEAL","commercialName":"SHOPPING IDEAL","cnpj":"10738709000142","city":"SÃO JOSÉ","stateCode":"SC","buscaAdicional":"SHOP IDEAL 53956 COND SHOP IDEAL 905030"},{"id":"f258c3ba-b7b3-43ff-60d0-08d5ad2bf6ba","name":"HIGIE PLUS COTTONBABY INDUSTRIA E COMERCIO LTDA","commercialName":"COTTONBABY","cnpj":"95837316000149","city":"SÃO JOSÉ","stateCode":"SC","buscaAdicional":"COTTONBABY 53746 COTTONBABY 904281"},{"id":"51363402-1268-4e1d-6070-08d5ad2bf6ba","name":"USICAST - INDUSTRIA E COMERCIO LTDA.","commercialName":"PRECICAST","cnpj":"03682863000184","city":"SÃO JOSÉ","stateCode":"SC","buscaAdicional":"PRECICAST 53511 PRECICAST 904307"},{"id":"958e0473-1e68-47d6-5e52-08d5ad2bf6ba","name":"PLASTICOM PLASTICOS INDUSTRIA E COMERCIO LTDA","commercialName":"PLASTICON","cnpj":"80474042000101","city":"SÃO JOSÉ","stateCode":"SC","buscaAdicional":"PLASTICOM 52330 PLASTICOM 899837"},{"id":"6c730bf9-040c-4c67-5ae9-08d5ad2bf6ba","name":"CASSOL MATERIAIS DE CONSTRUCAO LTDA","commercialName":"","cnpj":"75400218000132","city":"SÃO JOSÉ","stateCode":"SC","buscaAdicional":"CASSOL 50350 CASSOL F20 - SC 897626 CASSOL F18 897685 CASSOL F19 897749 CASSOL SAO JOSE SC 897788 CASSOL F08 - S JOSE 899726 CASSOL F21 ZONA SUL 899732 CASSOL F15 SHOP TOTA 901279 CASSOL F25 CRICIUMA 901459 CASSOL F24 CAXIAS 906193 CASSOL F26 LIN VERDE 910235"},{"id":"d649e31a-f975-4567-5b09-08d5ad2bf6ba","name":"CONDOMINIO CONTINENTE PARK SHOPPING","commercialName":"","cnpj":"20211636000190","city":"SÃO JOSÉ","stateCode":"SC","buscaAdicional":"SHOP CONTINENTE 50397 SHOP CONTINENTE PARK 897496"},{"id":"f3a30bb5-145d-42c1-5c24-08d5ad2bf6ba","name":"NUTRISUL SA PRODUTOS ALIMENTICIOS","commercialName":"","cnpj":"80972078000107","city":"SÃO LOURENÇO DO OESTE","stateCode":"SC","buscaAdicional":"NUTRISUL 51117 NUTRISUL NEREU SC 898553 NUTRISUL SAO MIGUEL 898786"},{"id":"05ff9f83-424c-4f49-5657-08d5ad2bf6ba","name":"PARATI INDUSTRIA E COMERCIO DE ALIMENTOS LTDA","commercialName":"","cnpj":"82945932000171","city":"SÃO LOURENÇO DO OESTE","stateCode":"SC","buscaAdicional":"PARATI 6919 PARATI S L D OESTE 72181"},{"id":"3a42fb02-bafe-42e0-537a-08d5ad2bf6ba","name":"CERP - ENERGETICA RIO PINHEIROS LTDA","commercialName":"CERP - CIA ENERGETICA RIO PINHEIRO","cnpj":"05122331000118","city":"SÃO LUDGERO","stateCode":"SC","buscaAdicional":"CERP 3652 RIO DAS FURNAS 8733 CGH.PH.SC.028778-4.01 PINHEIROS II 8750 CGH.PH.SC.028776-8.01"},{"id":"b4a4839b-3048-4765-5b03-08d5ad2bf6ba","name":"COPOBRAS S/A. INDUSTRIA E COMERCIO DE EMBALAGENS","commercialName":"INCOPLAST-SC","cnpj":"86445822000100","city":"SÃO LUDGERO","stateCode":"SC","buscaAdicional":"COPOBRAS 50386 SBDE 70770 INCOPLAST PR 898173 COPOBRAS PB 901204"},{"id":"961cec04-19e1-4edb-64a4-08d5ad2bf6ba","name":"SOCIEDADE URBANO CERBRANORTE - GERACAO DE ENERGIA ELETRICA SPE LTDA","commercialName":"","cnpj":"25383792000151","city":"SÃO MARTINHO","stateCode":"SC","buscaAdicional":"URBANO CERBRANORTE SPE 56141 PCH CAPIVARI 904121 PCH.PH.SC.000659-9.01"},{"id":"a387e16b-335c-4088-88e8-08d5ae44ed50","name":"URBANO AGROINDUSTRIAL LTDA","commercialName":"URBANO ENERGIA","cnpj":"84432111001724","city":"SÃO MARTINHO","stateCode":"SC","buscaAdicional":"URBANO AGROINDUSTRIAL 54760"},{"id":"e6a00aeb-2cda-43c3-5786-08d5ad2bf6ba","name":"COOPERATIVA REGIONAL DE COMERCIALIZACAO DO EXTREMO OESTE","commercialName":"COOPEROESTE","cnpj":"01435328000101","city":"SÃO MIGUEL DO OESTE","stateCode":"SC","buscaAdicional":"COOP OESTE 9009 COOPEROESTE 888601"},{"id":"11940675-4ddc-4b86-5174-08d5ad2bf6ba","name":"MAUE S/A - GERADORA E FORNECEDORA DE INSUMOS","commercialName":"","cnpj":"07004149000198","city":"SAUDADES","stateCode":"SC","buscaAdicional":"MAUE 2179 SAO JORGE SC 893104 PCH.PH.SC.030379-8.01"},{"id":"5efa3b32-f132-44a2-5124-08d5ad2bf6ba","name":"ENERGETICA SAUDADES S/A","commercialName":"PCH BARRA ESCONDIDA","cnpj":"08641893000166","city":"SAUDADES","stateCode":"SC","buscaAdicional":"SAUDADES 2020 BARRA ESCONDIDA 8427 PCH.PH.SC.029560-4.01"},{"id":"9f54db29-4f45-4a98-61d0-08d5ad2bf6ba","name":"FINESTRA INDUSTRIA E COMERCIO DE MADEIRAS LTDA","commercialName":"FINESTRA","cnpj":"80143548000120","city":"SAUDADES","stateCode":"SC","buscaAdicional":"FINESTRA INDUSTRIA 54436 FINESTRA 905031"},{"id":"8f00dfbd-a95e-4e54-66b0-08d5ad2bf6ba","name":"DASS SUL CALCADOS E ARTIGOS ESPORTIVOS LTDA","commercialName":"","cnpj":"81786121000102","city":"SAUDADES","stateCode":"SC","buscaAdicional":"DASS SUL 57744 DASS VENANCIO AIRES 909663 DASS SAUDADES 911534"},{"id":"965dee46-0e88-45b4-67d8-08d5ad2bf6ba","name":"ADELTEX ACABAMENTOS TEXTEIS EIRELI","commercialName":"","cnpj":"04064638000147","city":"SCHROEDER","stateCode":"SC","buscaAdicional":"ADELTEX 58690 ADELTEX SCHROEDER 909643"},{"id":"ab9afb92-4002-424c-5439-08d5ad2bf6ba","name":"MENEGOTTI INDUSTRIAS METALURGICAS LTDA EM RECUPERACAO JUDICIAL","commercialName":"","cnpj":"84431154000632","city":"SCHROEDER","stateCode":"SC","buscaAdicional":"MENEGOTTI 4100 MENEGOTTI FUNDICAO 71452"},{"id":"9cad6d82-20cc-4f90-5c83-08d5ad2bf6ba","name":"CAIMAN INDUSTRIA E COMERCIO DE MALHAS LTDA","commercialName":"CAIMAN MALHAS","cnpj":"75370437000116","city":"SCHROEDER","stateCode":"SC","buscaAdicional":"CAIMAN TEXTIL 51365 CAIMAN SCHROEDER 898790"},{"id":"433a27b0-be68-4cce-5d8d-08d5ad2bf6ba","name":"SERRA BRASIL USINA ELETRICA LTDA","commercialName":"","cnpj":"13823218000198","city":"SERRA ALTA","stateCode":"SC","buscaAdicional":"SERRA BRASIL 51910 CGH BURRO BRANCO I 900759 CGH.PH.SC.035415-5.01"},{"id":"666b2a68-e4e0-4d93-5ca5-08d5ad2bf6ba","name":"OLIVO S/A - PRODUTOS ELETRICOS","commercialName":"","cnpj":"09134437000192","city":"SIDERÓPOLIS","stateCode":"SC","buscaAdicional":"OLIVO 51457 OLIVO PROD ELETRICOS 899735"},{"id":"67ea1f96-2ee8-4cf1-6491-08d5ad2bf6ba","name":"OLIVO S/A INDUSTRIA DE IMPLEMENTOS RODOVIARIOS","commercialName":"OLIVO S/A INDUSTRIA DE IMPLEMENTOS RODOVIARIOS","cnpj":"24626523000106","city":"SIDERÓPOLIS","stateCode":"SC","buscaAdicional":"OLIVO IMPLEMENTOS 56091 OLIVO METALURGICOS 899887"},{"id":"cdef5dca-351f-44d4-6513-08d5ad2bf6ba","name":"HEIDRICH S/A CARTOES RECICLADOS - HCR","commercialName":"H C R","cnpj":"75491266000183","city":"TAIÓ","stateCode":"SC","buscaAdicional":"HCR 56464 HCR CARTOES 910047"},{"id":"053bd739-78a1-4ff6-6811-08d5ad2bf6ba","name":"HEIDRICH & HEIDRICH LTDA","commercialName":"HEIDRICH ELETRICA","cnpj":"00690006000138","city":"TAIÓ","stateCode":"SC","buscaAdicional":"HEIDRICH E HEIDRICH 59309 PCH RUDOLF 909394 PCH.PH.SC.031208-8.01"},{"id":"04d66bef-24dc-4573-8d8d-08d5d060706e","name":"NUTRIFARMA NUTRICAO E SAUDE ANIMAL S/A","commercialName":"NUTRIFARMA","cnpj":"03279946000127","city":"TAIÓ","stateCode":"SC","buscaAdicional":"NUTRIFARMA 61038 NUTRIFARMA 913324"},{"id":"b444a699-5149-4f41-8d92-08d5d060706e","name":"HCR- HEIDRICH INDUSTRIA, COMERCIO E REPRESENTACAO DE PAPEL LTDA","commercialName":"","cnpj":"27118434000147","city":"TAIÓ","stateCode":"SC","buscaAdicional":"HCR 2 61044"},{"id":"fbe444c5-f184-4ba8-6111-08d5ad2bf6ba","name":"ROHDEN VIDROS LTDA","commercialName":"","cnpj":"05959604000183","city":"TAIÓ","stateCode":"SC","buscaAdicional":"ROHDEN VIDROS 53990 ROHDEN VIDROS 904298"},{"id":"e38d5761-ae22-463d-4f3f-08d5ad2bf6ba","name":"HEIDRICH GERACAO ELETRICA LTDA","commercialName":"","cnpj":"04554491000173","city":"TAIÓ","stateCode":"SC","buscaAdicional":"HGE 153 ERNA HEIDRICH 8048 CGH.PH.SC.028681-8.01 CURT LINDNER 8544 CGH.PH.SC.029781-0.02 RIO DAS PACAS 894222 CGH.PH.SC.031735-7.01 CACH. DO RIO RAUEN 8215 CGH.PH.SC.028618-4.02"},{"id":"3552812e-94f1-49ef-574f-08d5ad2bf6ba","name":"VALPASA INDUSTRIA DE PAPEL LTDA","commercialName":"","cnpj":"85155414000142","city":"TANGARÁ","stateCode":"SC","buscaAdicional":"VALPASA CL 8549 VALPASA 898066"},{"id":"d9773ade-971b-446a-60d3-08d5ad2bf6ba","name":"SOPASTA SA IND E COM","commercialName":"","cnpj":"86352069000108","city":"TANGARÁ","stateCode":"SC","buscaAdicional":"SOPASTA 53750 SOPASTA TANGARA SC 906519"},{"id":"e8287fb2-b3bd-466c-596f-08d5ad2bf6ba","name":"C2LG GERACAO DE ENERGIA LTDA","commercialName":"C2LG GERACAO DE ENERGIA","cnpj":"11745925000188","city":"TANGARÁ","stateCode":"SC","buscaAdicional":"C2LG 14515 SANTO TESSARO 907107 CGH.PH.SC.031429-3.01"},{"id":"dfc54667-fad1-453f-592d-08d5ad2bf6ba","name":"SEBO TANGARA LTDA","commercialName":"","cnpj":"07742285000185","city":"TANGARÁ","stateCode":"SC","buscaAdicional":"SEBO TANGARA 13996 SEBO TANGARA 892645"},{"id":"8d4b9bda-cc7d-4b77-619f-08d5ad2bf6ba","name":"CENTRAL GERADORA HIDRELETRICA DONA AMELIA LTDA","commercialName":"CGH DONA AMELIA","cnpj":"24715030000142","city":"TANGARÁ","stateCode":"SC","buscaAdicional":"CGH DONA AMELIA 54303 CGH DONA AMELIA 910653 CGH.PH.SC.029100-5.01"},{"id":"992168d5-e4d9-4d16-5962-08d5ad2bf6ba","name":"PBG S/A","commercialName":"","cnpj":"83475913000191","city":"TIJUCAS","stateCode":"SC","buscaAdicional":"PORTOBELLO 14378 PORTOBELLO TIJUCAS 893862 PORTOBELLO AL 911577"},{"id":"19e285e7-a3af-4a85-5d9d-08d5ad2bf6ba","name":"PERCI REIS & CIA LTDA","commercialName":"CERAMICA REIS","cnpj":"09307345000167","city":"TIJUCAS","stateCode":"SC","buscaAdicional":"PERCI REIS 51935 PERCI REIS 904128"},{"id":"60de91ba-c1bf-475c-5eb9-08d5ad2bf6ba","name":"KOCH HIPERMERCADO LTDA","commercialName":"SUPERMERCADOS KOCH","cnpj":"02831172000132","city":"TIJUCAS","stateCode":"SC","buscaAdicional":"KOCH HIPERMERCADO 52524 KOCH LJ 11 899920 KOCH LJ05 899921 KOCH LJ09 900093 KOCH HIPERMERCADO 01 900456 KOCH LJ10 900457 KOCH TIJUCAS 901219 KOCH HIPERMERCADO 905344 KOCH SUPER 13 909343 KOCH HIPER 14 910022 KOCH HIPERMERCADO 15 910078 KOCH HIPERMERCA LJ16 910601 KOCH HIPERMERCA LJ18 912755 KOCH HIPERMERCA LJ17 912797 KOCH LJ04 913474"},{"id":"c3fef4e3-3073-4215-5e0e-08d5ad2bf6ba","name":"CERAMICA TUPY LTDA","commercialName":"CERAMICA TUPI-GUARANI","cnpj":"86367067000184","city":"TIJUCAS","stateCode":"SC","buscaAdicional":"CERAMICA TUPY 52183 CERAMICA TUPY 907234"},{"id":"2edd8ce2-77aa-48c8-5ec8-08d5ad2bf6ba","name":"INDUSTRIA DE MASSAS ALIMENTICIAS ROSANE EIRELI","commercialName":"","cnpj":"83633552000164","city":"TIMBÓ","stateCode":"SC","buscaAdicional":"MASSAS ROSANE 52550 IND DE MASSAS ROSANE 900988"},{"id":"cd8fc68b-b341-4f79-5fe2-08d5ad2bf6ba","name":"MALHARIA DIANA LTDA","commercialName":"GRUPO DIANA TEXTIL","cnpj":"86375789000180","city":"TIMBÓ","stateCode":"SC","buscaAdicional":"DIANA 53264 MALHARIA DIANA 906518"},{"id":"482d615e-e043-4011-5fae-08d5ad2bf6ba","name":"BUTZKE IMPORTACAO E EXPORTACAO LTDA","commercialName":"","cnpj":"86375078000106","city":"TIMBÓ","stateCode":"SC","buscaAdicional":"BUTZKE 53089 BUTZKE 901574"},{"id":"2b3c4e95-c1c2-4321-5803-08d5ad2bf6ba","name":"HERCULES MOTORES ELETRICOS LTDA","commercialName":"","cnpj":"07442711000165","city":"TIMBÓ","stateCode":"SC","buscaAdicional":"HERCULES 10409 HERCULES MOTORES 889620"},{"id":"9db4c20a-601c-47ad-57f1-08d5ad2bf6ba","name":"PORCELANAS INDUSTRIAIS GERMER S/A","commercialName":"","cnpj":"86378189000176","city":"TIMBÓ","stateCode":"SC","buscaAdicional":"GERMER 10169 GERMER ISOLADORES 889181"},{"id":"b128168a-09e8-4abc-5387-08d5ad2bf6ba","name":"MUELLER FOGOES LTDA.","commercialName":"","cnpj":"04565361000136","city":"TIMBÓ","stateCode":"SC","buscaAdicional":"MUELLER FOGOES 3683 MUELLER FOGOES 71243"},{"id":"b69f43f7-1b47-4c11-50cf-08d5ad2bf6ba","name":"METISA METALURGICA TIMBOENSE S/A","commercialName":"","cnpj":"86375425000109","city":"TIMBÓ","stateCode":"SC","buscaAdicional":"METISA 1853 METISA-TIMBO-SC 70208"},{"id":"4a758836-243f-4902-5135-08d5ad2bf6ba","name":"RUDOLPH USINADOS S/A","commercialName":"","cnpj":"02839894000133","city":"TIMBÓ","stateCode":"SC","buscaAdicional":"RUDOLPH 2048 RUDOLPH MTZ-TIMBO 70428"},{"id":"1ad38277-bdeb-4112-527a-08d5ad2bf6ba","name":"MUELLER ELETRODOMESTICOS LTDA","commercialName":"","cnpj":"86375912000163","city":"TIMBÓ","stateCode":"SC","buscaAdicional":"MUELLER 3081 MUELLER MATRIZ 70949"},{"id":"8bca68fe-3394-4e8e-62e4-08d5ad2bf6ba","name":"PGFIOS RECICLAGEM TEXTIL LTDA","commercialName":"","cnpj":"06752238000150","city":"TIMBÓ","stateCode":"SC","buscaAdicional":"PG FIOS 55025 PG FIOS TEXTIL 905899"},{"id":"50701759-f240-44e3-6804-08d5ad2bf6ba","name":"LIBERDADE GERACAO DE ENERGIA LTDA.","commercialName":"CGH LIBERDADE","cnpj":"20439581000170","city":"TIMBÓ","stateCode":"SC","buscaAdicional":"LIBERDADE 59184 LIBERDADE 912131 CGH.PH.SC.038207-8.01"},{"id":"158bbdc1-2617-4161-66f2-08d5ad2bf6ba","name":"S.A FABRICA DE PAPELAO TIMBO","commercialName":"PAPELAO TIMBO","cnpj":"86376217000116","city":"TIMBÓ","stateCode":"SC","buscaAdicional":"PAPELAO TIMBO 57894 FABR PAPELAO TIMBO 910357"},{"id":"40aa3702-9ef3-4af8-525b-08d5ad2bf6ba","name":"BRASENERG GERADORA DE ENERGIA ELETRICA LTDA","commercialName":"","cnpj":"04544111000110","city":"TIMBÓ GRANDE","stateCode":"SC","buscaAdicional":"SALTO DO TIMBO 3021 SALTO DO TIMBO 8609 CGH.PH.SC.028646-0.01"},{"id":"08ae32a9-13b2-4f81-4fe3-08d5ad2bf6ba","name":"MILI S/A","commercialName":"","cnpj":"78908266000205","city":"TRÊS BARRAS","stateCode":"SC","buscaAdicional":"MILI 3 BARRAS 1333 MILI TRES BARRAS SC 7449"},{"id":"1af6c2b0-46da-4779-64af-08d5ad2bf6ba","name":"BRASNILE INDUSTRIAL LTDA","commercialName":"","cnpj":"78549615000169","city":"TRÊS BARRAS","stateCode":"SC","buscaAdicional":"BRASNILE 56153 BRASNILE TRES BARRAS 908178"},{"id":"11c85c9b-d837-4f8d-5926-08d5ad2bf6ba","name":"TREZE DE MAIO GERACAO DE ENERGIA SPE LTDA","commercialName":"TREZE DE MAIO GERACAO DE ENERGIA SPE LTDA","cnpj":"17743216000140","city":"TREZE DE MAIO","stateCode":"SC","buscaAdicional":"TREZE DE MAIO 13915 TREZE DE MAIO 893647 CGH.PH.SC.031118-9.01"},{"id":"1553d8f1-65bf-49d8-5ac3-08d5ad2bf6ba","name":"LACTICINIOS TIROL LTDA","commercialName":"","cnpj":"83011247000130","city":"TREZE TÍLIAS","stateCode":"SC","buscaAdicional":"LATIC TIROL 50233 TIROL - TREZE TILIAS 897466 TIROL - CHAPECO 897451"},{"id":"df1e621d-f93c-4b5b-565d-08d5ad2bf6ba","name":"BATERIAS PIONEIRO INDUSTRIAL LTDA","commercialName":"","cnpj":"82927385000100","city":"TREZE TÍLIAS","stateCode":"SC","buscaAdicional":"PIONEIRO BATER 6959 BATERIAS PIONEIRO 888126"},{"id":"46590cc6-f33b-4673-5796-08d5ad2bf6ba","name":"COAN INDUSTRIA GRAFICA LTDA","commercialName":"COAN GRAFICA","cnpj":"86444791000164","city":"TUBARÃO","stateCode":"SC","buscaAdicional":"COAN 9110 COAN SC 897025"},{"id":"d1474c3f-94ad-4fab-5b84-08d5ad2bf6ba","name":"CONDOMINIO FAROL SHOPPING","commercialName":"","cnpj":"08258075000189","city":"TUBARÃO","stateCode":"SC","buscaAdicional":"SHOP FAROL 50739 SHOP FAROL 898146"},{"id":"eaae97c1-25db-4f85-649f-08d5ad2bf6ba","name":"SOCIMED SERVICOS HOSPITALARES S.A","commercialName":"","cnpj":"01595799000179","city":"TUBARÃO","stateCode":"SC","buscaAdicional":"SOCIMED 56136 SOCIMED SERVICOS 906528"},{"id":"c9e68fd0-35b4-40e6-88c6-08d5ae44ed50","name":"MCC INDUSTRIA DE PLASTICOS EIRELI","commercialName":"","cnpj":"19822614000187","city":"URUSSANGA","stateCode":"SC","buscaAdicional":"MCC 51569 MCC INDUSTRIA 899706"},{"id":"dfd5a62a-37f9-4701-5afe-08d5ad2bf6ba","name":"THERMOVAC EMBALAGENS PLASTICAS LTDA","commercialName":"THERMOVAC","cnpj":"01813368000131","city":"URUSSANGA","stateCode":"SC","buscaAdicional":"THERMOVAC 50381 THERMOVAC URUSSANGA 897499"},{"id":"d2d1f7c5-ca33-4b19-5f64-08d5ad2bf6ba","name":"MAESTRO DO BRASIL INDUSTRIA METALURGICA LTDA","commercialName":"MAESTRO DO BRASIL","cnpj":"83046656000172","city":"URUSSANGA","stateCode":"SC","buscaAdicional":"MAESTRO 52926 MAESTRO 900662"},{"id":"3d6cb3d6-523c-4f00-5754-08d5ad2bf6ba","name":"ALUMASA INDUSTRIA DE PLASTICO E ALUMINIO LTDA","commercialName":"","cnpj":"80718984000180","city":"URUSSANGA","stateCode":"SC","buscaAdicional":"ALUMASA 8589 ALUMASA 897044"},{"id":"033a6d42-c44d-49c3-50d9-08d5ad2bf6ba","name":"ANTONIO FORNASA ADMINISTRADORA DE BENS LTDA","commercialName":"","cnpj":"83705152000117","city":"URUSSANGA","stateCode":"SC","buscaAdicional":"FORNASA 1870 RIO PALMEIRAS I 8139 CGH.PH.SC.028195-6.02 RIO PALMEIRAS II 8190 CGH.PH.SC.029377-6.02"},{"id":"b6251f47-6b5b-49ea-50c5-08d5ad2bf6ba","name":"CERAMICA URUSSANGA S/A","commercialName":"","cnpj":"86530318000108","city":"URUSSANGA","stateCode":"SC","buscaAdicional":"URUSSANGA 1840 CEUSA URUSSANGA SC 897498"},{"id":"76b9c752-1d7a-406e-509b-08d5ad2bf6ba","name":"IBRAP INDUSTRIA BRASILEIRA DE ALUMINIO E PLASTICOS SA","commercialName":"","cnpj":"00130132000138","city":"URUSSANGA","stateCode":"SC","buscaAdicional":"IBRAP 1746 IBRAP-URUSSANGA 70922"},{"id":"5a41b8b7-184b-42dd-529d-08d5ad2bf6ba","name":"MINAPLAST MAQUINAS IND E ARTEFATOS PLASTICOS LTDA","commercialName":"","cnpj":"83463034000140","city":"URUSSANGA","stateCode":"SC","buscaAdicional":"MINAPLAST 3185 MINAPLAST 70983"},{"id":"81df61c2-22b4-475a-5172-08d5ad2bf6ba","name":"MASSIMA REVESTIMENTOS CERAMICOS LTDA.","commercialName":"MASSIMA REVESTIMENTOS CERAMICOS","cnpj":"08240356000104","city":"URUSSANGA","stateCode":"SC","buscaAdicional":"MASSIMA 2175 NOVAGRES URUSSANGA 70205"},{"id":"74301739-73fb-4a16-5aeb-08d5ad2bf6ba","name":"MASTER AGROINDUSTRIAL LTDA","commercialName":"","cnpj":"02011086000183","city":"VIDEIRA","stateCode":"SC","buscaAdicional":"MASTER AGRO 50354 M AGRO MONTE BERICO 897290 MASTER AGRO 898095 MASTER AGRO QUEIMADO 902708"},{"id":"e477f3d1-cade-4e33-5bf7-08d5ad2bf6ba","name":"VIDEPLAST INDUSTRIA DE EMBALAGENS LTDA","commercialName":"","cnpj":"79687588000153","city":"VIDEIRA","stateCode":"SC","buscaAdicional":"VIDEPLAST INDUSTRIA 51004 VIDEPLAST VIDEIRA 899119 VIDEPLAST UNIAO VIT 899120 VIDEPLAST VIDEIRA 2 904708 VIDEPLAST RIO VERDE 901277"},{"id":"b3b6ff94-78a4-4de2-6344-08d5ad2bf6ba","name":"LAVEBRAS GESTAO DE TEXTEIS S.A.","commercialName":"","cnpj":"06272575000140","city":"VIDEIRA","stateCode":"SC","buscaAdicional":"LAVEBRAS 55277 LAVEBRAS TEXTEIS 907651"},{"id":"b452a9ae-df65-44f6-67b1-08d5ad2bf6ba","name":"CENTRAL GERADORA HIDRELETRICA ESTREITO LTDA","commercialName":"","cnpj":"11591169000180","city":"VIDEIRA","stateCode":"SC","buscaAdicional":"CGH ESTREITO 58472 CGH ESTREITO 910651 CGH.PH.SC.035075-3.01"},{"id":"5db4d7fe-92b5-44bd-8d90-08d5d060706e","name":"BID COMERCIALIZADORA DE ENERGIA ELETRICA LTDA","commercialName":"BID ENERGIA","cnpj":"14023604000168","city":"XANXERÊ","stateCode":"SC","buscaAdicional":"BID 61042"},{"id":"c5224690-0b01-44d3-5c7f-08d5ad2bf6ba","name":"COOPERATIVA AGRARIA XANXERE - COOPERXANXERE - EM LIQUIDACAO","commercialName":"COOPERXANXERE","cnpj":"01656444000576","city":"XANXERÊ","stateCode":"SC","buscaAdicional":"COOPERXANXERE 51352 COOPERATIVA XANXERE 899673"},{"id":"f07b8dfb-c2f2-4f70-5bf3-08d5ad2bf6ba","name":"ALCAPLAS INDUSTRIA DE PLASTICOS LTDA","commercialName":"","cnpj":"03943986000121","city":"XANXERÊ","stateCode":"SC","buscaAdicional":"ALCAPLAS 50996 ALCAPLAS 898547"},{"id":"e54673e6-0963-41c7-5bf4-08d5ad2bf6ba","name":"COOPERATIVA AGRARIA XANXERE - COOPERXANXERE - EM LIQUIDACAO","commercialName":"COOPERXANXERE","cnpj":"01656444000142","city":"XANXERÊ","stateCode":"SC","buscaAdicional":"COOP XANXERE 50997 COOP XANXERE PRATA 899730"},{"id":"d1b9f330-6fbc-4637-5b56-08d5ad2bf6ba","name":"EUCLIDES MACIEL ENERGETICA S.A.","commercialName":"EUCLIDES MACIEL ENERGETICA","cnpj":"08812700000192","city":"XANXERÊ","stateCode":"SC","buscaAdicional":"E.M. ENERGETICA 50614 PCH PEDRAS 909015 PCH.PH.SC.030575-8.0"},{"id":"32d8b85a-e305-402c-5a74-08d5ad2bf6ba","name":"CAJU ENERGIA LTDA","commercialName":"CAJU ENERGIA","cnpj":"19815187000100","city":"XANXERÊ","stateCode":"SC","buscaAdicional":"CAJU ENERGIA 49666 CAJU (HACKER) 8235 PCH.PH.SC.029217-6.01"},{"id":"3ed78e61-e80b-421a-5a28-08d5ad2bf6ba","name":"XAVANTINA ENERGETICA S.A.","commercialName":"","cnpj":"08988322000100","city":"XANXERÊ","stateCode":"SC","buscaAdicional":"XAVANTINA 16604 XAVANTINA 896124 PCH.PH.SC.030263-5.01"},{"id":"146fbcfa-0874-4232-5811-08d5ad2bf6ba","name":"MOINHO XANXERE IND. E COM. LTDA","commercialName":"MOINHO XANXERE","cnpj":"04256422000183","city":"XANXERÊ","stateCode":"SC","buscaAdicional":"CGH LONTRAS 10569 MOINHO XANXERE 900178 LONTRAS 890235 CGH.PH.SC.029303-2.01"},{"id":"c1c12bfc-db5b-4b24-5223-08d5ad2bf6ba","name":"WASSER KRAFT GERACAO DE ENERGIA ELETRICA LTDA","commercialName":"WK ENERGIA","cnpj":"08252466000196","city":"XANXERÊ","stateCode":"SC","buscaAdicional":"WASSER KRAFT 2883 WASSER KRAFT 8533 CGH.PH.SC.029589-2.01 CGH MARIA PRETA 908660 CGH.PH.SC.029988-0.01"},{"id":"3910efc1-305f-40de-525a-08d5ad2bf6ba","name":"HACKER INDUSTRIAL LTDA","commercialName":"","cnpj":"83430355000148","city":"XANXERÊ","stateCode":"SC","buscaAdicional":"HACKER 3020 HACKER 894963 PCH.PH.SC.029172-2.01"},{"id":"a8b76f7d-669f-49d1-4f3c-08d5ad2bf6ba","name":"IGUACU DISTRIBUIDORA DE ENERGIA ELETRICA LTDA.","commercialName":"IGUACU ENERGIA","cnpj":"83855973000130","city":"XANXERÊ","stateCode":"SC","buscaAdicional":"IENERGIA 146 IGUACU ENERGIA 7237"},{"id":"91b0065e-e047-4c76-586f-08d5ad2bf6ba","name":"COOPERATIVA CENTRAL AURORA ALIMENTOS","commercialName":"AURORA ALIMENTOS","cnpj":"83310441006662","city":"XAXIM","stateCode":"SC","buscaAdicional":"AURORA XAXIM 11770 AURORA XAXIM 890157"},{"id":"145b1252-05fb-4c52-5b2c-08d5ad2bf6ba","name":"RAFITEC S/A INDUSTRIA E COMERCIO DE SACARIAS","commercialName":"RAFITEC SA","cnpj":"00763251000128","city":"XAXIM","stateCode":"SC","buscaAdicional":"RAFITEC 50504 RAFITEC FB1 898158 RAFITEC FB2 898172"},{"id":"8be2ace2-5f9e-4789-5a1a-08d5ad2bf6ba","name":"S.P.V.R - GERACAO E COMERCIALIZACAO DE ENERGIA ELETRICA LTDA","commercialName":"HIDROELETRICA POUSO ALTO","cnpj":"08378532000179","city":"ZORTÉA","stateCode":"SC","buscaAdicional":"SPVR GERACAO 16525 PCH AGUDO 897204 PCH.PH.SC.031040-9.01"},{"id":"f9d93990-670e-41d1-6703-08d5ad2bf6ba","name":"COOPERATIVA AGRICOLA MISTA AGUDO LTDA","commercialName":"COOPERAGUDO","cnpj":"00212727000132","city":"AGUDO","stateCode":"RS","buscaAdicional":"COOP AGUDO 57924 COOPERAGUDO 910043"},{"id":"7b1d0a04-dbaf-4213-634b-08d5ad2bf6ba","name":"DICKOW ALIMENTOS LTDA.","commercialName":"","cnpj":"87067187000129","city":"AGUDO","stateCode":"RS","buscaAdicional":"DICKOW 55295 DICKOW 905952"},{"id":"7aa7a211-1cba-471a-88d1-08d5ae44ed50","name":"CEREALISTA FUMACENSE LTDA","commercialName":"FUMACENSE ALIMENTOS","cnpj":"00720580000191","city":"ALEGRETE","stateCode":"RS","buscaAdicional":"CEREALISTA FUMACENSE 52585"},{"id":"b4b85e1e-42f6-4b99-51e7-08d5ad2bf6ba","name":"SILICA VERDE DO ARROZ LTDA.","commercialName":"SVA","cnpj":"04905729000168","city":"ALEGRETE","stateCode":"RS","buscaAdicional":"UTE SVA 2714 GEEA ALEGRETE 8449 UTE.AI.RS.029148-0.01"},{"id":"4863b0d7-d9ce-4a91-5d22-08d5ad2bf6ba","name":"KLL EQUIPAMENTOS PARA TRANSPORTE S/A","commercialName":"","cnpj":"92327410000160","city":"ALVORADA","stateCode":"RS","buscaAdicional":"KLL 51712 KLL EQUIPAMENTOS 901814"},{"id":"79a0f0b6-71b9-4d2f-73e5-08d5cf600bef","name":"DIGITEL S A INDUSTRIA ELETRONICA","commercialName":"DIGITEL","cnpj":"89547269000104","city":"ALVORADA","stateCode":"RS","buscaAdicional":""},{"id":"6d4678d2-6830-4895-5970-08d5ad2bf6ba","name":"HIDRELETRICA JARDIM LTDA","commercialName":"PCH JARDIM","cnpj":"08805726000103","city":"ANDRÉ DA ROCHA","stateCode":"RS","buscaAdicional":"PCH JARDIM 14536 PCH JARDIM 910212 PCH.PH.RS.030887-0.01"},{"id":"45e32d80-f271-4db3-5e06-08d5ad2bf6ba","name":"MAIS FRUTA INDUSTRIA E COMERCIO S.A","commercialName":"","cnpj":"93651958000123","city":"ANTÔNIO PRADO","stateCode":"RS","buscaAdicional":"MAIS FRUTA 52153 MAIS FRUTA 899326"},{"id":"2616cd83-3519-4440-5744-08d5ad2bf6ba","name":"VIPRADO INDUSTRIA E COMERCIO DE VIDROS LTDA","commercialName":"","cnpj":"94352903000185","city":"ANTÔNIO PRADO","stateCode":"RS","buscaAdicional":"VIPRADO 8452 VIPRADO - RS 889528"},{"id":"1ece9a0e-bbf8-43f5-57ea-08d5ad2bf6ba","name":"MOINHO DO NORDESTE S/A","commercialName":"","cnpj":"87274817000136","city":"ANTÔNIO PRADO","stateCode":"RS","buscaAdicional":"NORDESTEALIMENTOS 10050 MOINHO NE PINHAIS 889237 MOINHO DO NORDESTE 889259"},{"id":"1c749ab7-98a1-4c76-564f-08d5ad2bf6ba","name":"UNIVERSUM DO BRASIL INDUSTRIA MOVELEIRA LTDA","commercialName":"","cnpj":"87215281000188","city":"ANTÔNIO PRADO","stateCode":"RS","buscaAdicional":"UNIVERSUM 6879 UNIVERSUM A PRADO 72191"},{"id":"c52afa38-e2d4-47bc-8da5-08d5d060706e","name":"METALSINOS INDUSTRIA COMERCIO REPRESENTACOES LTDA","commercialName":"","cnpj":"91437418000116","city":"ARARICÁ","stateCode":"RS","buscaAdicional":"METALSINOS 61932 METALSINOS MATRIZ 1 913478 METALSINOS MATRIZ 2 913479"},{"id":"a1debb93-24e0-4f42-5cba-08d5ad2bf6ba","name":"INDUSTRIA COMERCIO PRODUTOS DE LIMPEZA GIRANDO SOL LTDA","commercialName":"","cnpj":"93973329000110","city":"ARROIO DO MEIO","stateCode":"RS","buscaAdicional":"GIRANDO SOL 51542 GIRANDO SOL 899798"},{"id":"395f2e3f-6cc3-46f5-591b-08d5ad2bf6ba","name":"BREMIL S/A INDUSTRIA DE PRODUTOS ALIMENTICIOS","commercialName":"BREMIL INDUSTRIA","cnpj":"91897876000138","city":"ARROIO DO MEIO","stateCode":"RS","buscaAdicional":"BREMIL2 13816 BREMIL2 891962"},{"id":"ef2faaca-c679-4b9c-5b0c-08d5ad2bf6ba","name":"NEUGEBAUER ALIMENTOS S/A","commercialName":"WALLERIUS","cnpj":"87315834000417","city":"ARROIO DO MEIO","stateCode":"RS","buscaAdicional":"VONPAR ALIMENTOS 50402 VONPAR ALIMENTOS 898802"},{"id":"883fdd95-73ce-485f-586b-08d5ad2bf6ba","name":"MORRINHOS GERACAO E COMERCIO DE ENERGIA ELETRICA LTDA","commercialName":"","cnpj":"08587844000192","city":"BARÃO DO TRIUNFO","stateCode":"RS","buscaAdicional":"PCH MORRINHOS 11729 MORRINHOS 894362 PCH.PH.RS.030407-7.01"},{"id":"f0d355a1-9b7d-408b-5dd4-08d5ad2bf6ba","name":"AGUAS MINERAIS SARANDI LTDA","commercialName":"FONTE SARANDI","cnpj":"97318943000107","city":"BARRA FUNDA","stateCode":"RS","buscaAdicional":"AGUAS SARANDI 52015 AGUAS SARANDI 898727"},{"id":"bc889689-e159-4c62-5e16-08d5ad2bf6ba","name":"MEBER METAIS S/A","commercialName":"","cnpj":"87547907000153","city":"BENTO GONÇALVES","stateCode":"RS","buscaAdicional":"MEBER 52192 MEBER METAIS 902176"},{"id":"a15541f6-9c38-4684-57f4-08d5ad2bf6ba","name":"SCA-INDUSTRIA DE MOVEIS LTDA","commercialName":"S C A","cnpj":"87552170000167","city":"BENTO GONÇALVES","stateCode":"RS","buscaAdicional":"SCA INDUSTRIA 10229 SCA BENTO GONCALVES 889704"},{"id":"bab56368-33d8-47a8-5a88-08d5ad2bf6ba","name":"GEREMIA REDUTORES LTDA","commercialName":"GEREMIA","cnpj":"87848222000147","city":"BENTO GONÇALVES","stateCode":"RS","buscaAdicional":"GEREMIA 49995 GEREMIA 897065"},{"id":"7d91f5c0-4a5c-4ef0-5ac7-08d5ad2bf6ba","name":"VITOR CARLOS TRES & CIA LTDA","commercialName":"CASA DO VIDRO","cnpj":"02745261000166","city":"BENTO GONÇALVES","stateCode":"RS","buscaAdicional":"CASADOVIDRO 50237 VITOR CARLOS TRES 898291"},{"id":"5cf3cf9a-b1cb-4d98-5c67-08d5ad2bf6ba","name":"TONDO S/A.","commercialName":"","cnpj":"88618285000331","city":"BENTO GONÇALVES","stateCode":"RS","buscaAdicional":"TONDOBENTO 51299 TONDO SA - RS 898833"},{"id":"d07c681b-701c-4f9a-5644-08d5ad2bf6ba","name":"ASSOCIACAO DR BARTHOLOMEU TACCHINI","commercialName":"","cnpj":"87547444000120","city":"BENTO GONÇALVES","stateCode":"RS","buscaAdicional":"TACCHINI 6826 TACCHINI B GONCALVES 72061"},{"id":"a3649d42-f4f8-4514-56c7-08d5ad2bf6ba","name":"M DIAS BRANCO S.A. INDUSTRIA E COMERCIO DE ALIMENTOS","commercialName":"FILIAL BENTO GONCALVES","cnpj":"07206816004293","city":"BENTO GONÇALVES","stateCode":"RS","buscaAdicional":"MDIASBRANCO405 7681 MDIASBRANCO405 71043"},{"id":"98d61411-da74-454c-57d8-08d5ad2bf6ba","name":"DAL MOBILE LTDA","commercialName":"","cnpj":"89042618000128","city":"BENTO GONÇALVES","stateCode":"RS","buscaAdicional":"DAL MOBILE 9770 DAL MOBILE BENTO GO 889057"},{"id":"b13dad2a-9528-4fe7-57b5-08d5ad2bf6ba","name":"CINEX INDUSTRIA DO MOBILIARIO LTDA","commercialName":"CINEX DESIGN EM ALUMINIO","cnpj":"93993731000166","city":"BENTO GONÇALVES","stateCode":"RS","buscaAdicional":"CINEX 9373 CINEX 888837"},{"id":"0d05bc64-b679-497b-53d7-08d5ad2bf6ba","name":"VINICOLA SALTON S.A.","commercialName":"","cnpj":"87547428000137","city":"BENTO GONÇALVES","stateCode":"RS","buscaAdicional":"SALTON 3878 VINHOS SALTON S.A. 71349"},{"id":"63418d86-b4b5-46b8-5482-08d5ad2bf6ba","name":"TODESCHINI SA INDUSTRIA E COMERCIO","commercialName":"TODESCHINI","cnpj":"87547170000179","city":"BENTO GONÇALVES","stateCode":"RS","buscaAdicional":"TODESCHINI 4307 TODESCHINI BENTO GON 71686"},{"id":"74b6c2b9-d552-4d99-54f3-08d5ad2bf6ba","name":"NOVA PACK PRODUTOS PLASTICOS LTDA.","commercialName":"NOVA PACK EMBALAGENS","cnpj":"06133155000182","city":"BENTO GONÇALVES","stateCode":"RS","buscaAdicional":"NOVA PACK 4615 NOVA PACK-BENTO GON 71701 IDEALPLAST BGONCALVS 72069"},{"id":"5cc1ff30-338e-4e6d-51fa-08d5ad2bf6ba","name":"AKEO INDUSTRIAL LTDA","commercialName":"","cnpj":"89340921000107","city":"BENTO GONÇALVES","stateCode":"RS","buscaAdicional":"AKEO 2763 PLASTIBENTO 70734"},{"id":"4f14e2a9-b628-4699-520a-08d5ad2bf6ba","name":"UNICASA INDUSTRIA DE MOVEIS S/A","commercialName":"UNICASA","cnpj":"90441460000148","city":"BENTO GONÇALVES","stateCode":"RS","buscaAdicional":"UNICA MOVEIS 2819 UNICA MOVEIS 70735"},{"id":"e98fbf30-afe5-4e98-52a0-08d5ad2bf6ba","name":"RINALDI SA-INDUSTRIA DE PNEUMATICOS","commercialName":"","cnpj":"87556601000163","city":"BENTO GONÇALVES","stateCode":"RS","buscaAdicional":"RINALDI PNEUS 3189 RINALDI PNEUMATICOS 71101"},{"id":"33e09f6c-bb42-461b-50d2-08d5ad2bf6ba","name":"MOVEIS CARRARO LTDA","commercialName":"","cnpj":"87548814000143","city":"BENTO GONÇALVES","stateCode":"RS","buscaAdicional":"CARRARO 1860 CARRARO-B GONCALVES 70230 CARRARO-CRIARE 71292 CARRARO-TUBULARES 71293"},{"id":"c0a29935-7571-4b95-511f-08d5ad2bf6ba","name":"FARINA S/A COMPONENTES AUTOMOTIVOS","commercialName":"","cnpj":"87546636000111","city":"BENTO GONÇALVES","stateCode":"RS","buscaAdicional":"FARINA 2007 FARINA BG 71118"},{"id":"ec80cdf7-0708-488a-50e8-08d5ad2bf6ba","name":"PAEMA EMBALAGENS LTDA","commercialName":"","cnpj":"94551850000121","city":"BENTO GONÇALVES","stateCode":"RS","buscaAdicional":"PAEMA 1894 PAEMA EMBALAGENS LTD 70272"},{"id":"2f09d8b8-efd3-487c-6406-08d5ad2bf6ba","name":"ZEGLA - INDUSTRIA DE MAQUINAS PARA BEBIDAS LTDA","commercialName":"","cnpj":"88250147000180","city":"BENTO GONÇALVES","stateCode":"RS","buscaAdicional":"ZEGLA 55793 ZEGLA IND MAQ BEBIDA 905348 ZEGLA IND MAQ BEBIDA 905349"},{"id":"8d0d3b11-2bb5-4b81-628a-08d5ad2bf6ba","name":"TECNOVIN DO BRASIL LTDA","commercialName":"","cnpj":"92320233000190","city":"BENTO GONÇALVES","stateCode":"RS","buscaAdicional":"TECNOVIN M 54797 TECNOVIN 904322"},{"id":"f4e8eb3f-e601-4698-66b7-08d5ad2bf6ba","name":"ARTEFATOS DE BORRACHA PCR LTDA","commercialName":"PCR","cnpj":"91831016000100","city":"BENTO GONÇALVES","stateCode":"RS","buscaAdicional":"PCR 57752 PCR ARTEFATOS DE BOR 909207"},{"id":"1115be4e-6c99-49ae-66a8-08d5ad2bf6ba","name":"HOTEL DALL ONDER LTDA","commercialName":"","cnpj":"89340913000160","city":"BENTO GONÇALVES","stateCode":"RS","buscaAdicional":"HOTEL DALL ONDER 57723 HOTEL DALL ONDER 1 909256 HOTEL DALL ONDER 2 909257"},{"id":"9fd81049-bbae-4e01-65e3-08d5ad2bf6ba","name":"FUNDACAO PARQUE DE EVENTOS E DESENV DE BENTO GONCALVES","commercialName":"FUNDAPARQUE","cnpj":"01096109000137","city":"BENTO GONÇALVES","stateCode":"RS","buscaAdicional":"FUNDAPARQUE 57186 FUNDAPARQUE BENTO GO 907523"},{"id":"6b746adb-abc0-4cfb-6875-08d5ad2bf6ba","name":"FARFRI INDUSTRIA E COMERCIO LTDA","commercialName":"FARFRI","cnpj":"02925993000138","city":"BOA VISTA DO SUL","stateCode":"RS","buscaAdicional":"FARFRI 60091 FARFRI IND E COM 910040"},{"id":"48a560fb-4459-4624-5ee5-08d5ad2bf6ba","name":"CARRER ALIMENTOS LTDA","commercialName":"","cnpj":"07520001000106","city":"BOA VISTA DO SUL","stateCode":"RS","buscaAdicional":"CARRER BOA VISTA 52603 CARRER ALIMENTOS 903782"},{"id":"1db1ccb7-89ca-486c-5cf1-08d5ad2bf6ba","name":"M D MOVEIS LTDA","commercialName":"","cnpj":"89042642000400","city":"BOM PRINCÍPIO","stateCode":"RS","buscaAdicional":"MADESA FILIAL 51619 MADESA MOVEIS FILIAL 900043"},{"id":"f5278740-934a-4668-5af6-08d5ad2bf6ba","name":"CERAMICA KASPARY LTDA","commercialName":"","cnpj":"90954892000152","city":"BOM PRINCÍPIO","stateCode":"RS","buscaAdicional":"KASPARYMATRIZ 50373 CERAMICA KASPARY LTD 903798"},{"id":"172eff65-6de2-402e-5800-08d5ad2bf6ba","name":"M D MOVEIS LTDA","commercialName":"","cnpj":"89042642000167","city":"BOM PRINCÍPIO","stateCode":"RS","buscaAdicional":"MADESA MATRIZ 10390 MADESA MOVEIS 904295"},{"id":"a3367b3c-f5ae-402d-6593-08d5ad2bf6ba","name":"FIBRAFORM INDUSTRIA DE EMBALAGENS PLASTICAS LTDA.","commercialName":"FIBRAFORM","cnpj":"10655578000130","city":"BOM PRINCÍPIO","stateCode":"RS","buscaAdicional":"FIBRAFORM 56834 FIBRAFORM 907255"},{"id":"3ab666aa-c8f5-414c-6719-08d5ad2bf6ba","name":"MINERACAO MONEGO LTDA","commercialName":"","cnpj":"88142708000128","city":"CAÇAPAVA DO SUL","stateCode":"RS","buscaAdicional":"MONEGO 57959 MINERACAO MONEGO 910116"},{"id":"9e89fb1b-e93d-4fc2-671a-08d5ad2bf6ba","name":"COMPANHIA BRASILEIRA DO COBRE","commercialName":"","cnpj":"87678207000106","city":"CAÇAPAVA DO SUL","stateCode":"RS","buscaAdicional":"CIA DO COBRE 57961 CBC FILIAL 5 909675"},{"id":"a4bd41db-b19e-4fa0-5aae-08d5ad2bf6ba","name":"DAGOBERTO BARCELLOS S/A","commercialName":"","cnpj":"87678934000165","city":"CAÇAPAVA DO SUL","stateCode":"RS","buscaAdicional":"DB SA 50174 DB 899091"},{"id":"522d58d3-4cb0-4b75-5e79-08d5ad2bf6ba","name":"IRMAOS CIOCCARI E CIA LTDA","commercialName":"CAL FIDA","cnpj":"87675831000141","city":"CAÇAPAVA DO SUL","stateCode":"RS","buscaAdicional":"IRMAOS CIOCCARI 52397 IRMAOS CIOCCARI MAT 904933 IRMAOS CIOCCARI CIA 906354"},{"id":"00bb32ac-9407-4ac7-5f6b-08d5ad2bf6ba","name":"COOPERATIVA TRITICOLA CACAPAVANA LTDA","commercialName":"COTRISUL","cnpj":"87678132000155","city":"CAÇAPAVA DO SUL","stateCode":"RS","buscaAdicional":"COTRISUL GRANEIRO 52938 COOPERATIVA CACAPAVA 904894"},{"id":"c84c8def-9661-4593-66a7-08d5ad2bf6ba","name":"HOSPITAL DE CARIDADE E BENEFICENCIA","commercialName":"","cnpj":"87768735000148","city":"CACHOEIRA DO SUL","stateCode":"RS","buscaAdicional":"HOSPITAL HCB 57722 HOSPITAL HCB 909356"},{"id":"4749287f-d95b-4610-614a-08d5ad2bf6ba","name":"SULINA DE METAIS SA","commercialName":"","cnpj":"92660893000110","city":"CACHOEIRINHA","stateCode":"RS","buscaAdicional":"SULINA 54102 SULINA ARROIO RATOS 902326 SULINA CACHOEIRINHA 902394"},{"id":"74d19ccc-77f2-4ac9-614c-08d5ad2bf6ba","name":"INBRACELL IND BRASIL DE ACUMULADORES ELETRICOS LTDA","commercialName":"INBRACELL","cnpj":"94328580000194","city":"CACHOEIRINHA","stateCode":"RS","buscaAdicional":"INBRACELL 54104 INBRACELL 902741"},{"id":"17988c61-fafb-417b-6200-08d5ad2bf6ba","name":"RITTER ALIMENTOS S/A","commercialName":"RITTER ALIMENTOS","cnpj":"90286139000136","city":"CACHOEIRINHA","stateCode":"RS","buscaAdicional":"RITTER 54501 RITTER 904805"},{"id":"481649d9-509b-464f-6376-08d5ad2bf6ba","name":"BLEISTAHL BRASIL METALURGIA LTDA","commercialName":"","cnpj":"87888772000190","city":"CACHOEIRINHA","stateCode":"RS","buscaAdicional":"BLEISTAHL 55377 BLEISTAHL CACHOEIR 906318"},{"id":"595d2e58-7e1e-47d0-63b8-08d5ad2bf6ba","name":"METALURGICA ECOPLAN.LTDA.","commercialName":"","cnpj":"91506246000195","city":"CACHOEIRINHA","stateCode":"RS","buscaAdicional":"ECOPLAN 55587 METALURGICA ECOPLAN 905369"},{"id":"def4b8b4-a990-4649-5f5f-08d5ad2bf6ba","name":"ELETROFORJA INDUSTRIA MECANICA S.A.","commercialName":"ELETROFORJA INDUSTRIA MECANICA S/A","cnpj":"05958978000265","city":"CACHOEIRINHA","stateCode":"RS","buscaAdicional":"ELETROFORJA 52921 ELETROFORJA 905946"},{"id":"6cfa7ea3-0b98-4468-5c75-08d5ad2bf6ba","name":"METALTECNICA METALURGICA LTDA","commercialName":"METALTECICA METALURGICA","cnpj":"02984383000105","city":"CACHOEIRINHA","stateCode":"RS","buscaAdicional":"METALTECNICA 51322 METALTECNICA 898819"},{"id":"0f6054d8-53bc-46bb-5045-08d5ad2bf6ba","name":"SOUZA CRUZ LTDA","commercialName":"","cnpj":"33009911035277","city":"CACHOEIRINHA","stateCode":"RS","buscaAdicional":"SOUZA CRUZ RS 1548 SOUZA CRUZ-CACHOEIRI 7944"},{"id":"17967041-a5f0-439b-534f-08d5ad2bf6ba","name":"CONDOMINIO DO SHOPPING DO VALE","commercialName":"","cnpj":"00995983000143","city":"CACHOEIRINHA","stateCode":"RS","buscaAdicional":"SHOPP VALE 3573 SHOP V CACHOEIRINHA 71181"},{"id":"312ef529-1592-4d8a-5573-08d5ad2bf6ba","name":"METALURGICA FALLGATTER LTDA","commercialName":"","cnpj":"92794437000243","city":"CACHOEIRINHA","stateCode":"RS","buscaAdicional":"FALLGATTER 5629 FALLGATTER-CACH 71815 FALLGATTER 930 72145"},{"id":"2d50094d-ba0b-4081-5734-08d5ad2bf6ba","name":"DOORMANN S/A EMBALAGENS PLASTICAS","commercialName":"","cnpj":"91490516000117","city":"CACHOEIRINHA","stateCode":"RS","buscaAdicional":"DOORMANN 8349 DOORMANN 888322"},{"id":"0016d8d9-848b-4366-5f54-08d5ad2bf6ba","name":"VIVIANA ALIMENTOS LTDA","commercialName":"","cnpj":"94825114000114","city":"CAMAQUÃ","stateCode":"RS","buscaAdicional":"VIVIANA ALIM 52904 VIVIANA ALIMENTOS 903222"},{"id":"d8ca224c-6089-4515-6328-08d5ad2bf6ba","name":"INDUSTRIA DE MOVEIS THB LTDA","commercialName":"MOVEIS THB","cnpj":"72144066000166","city":"CAMAQUÃ","stateCode":"RS","buscaAdicional":"IND. DE MOVEIS THB 55194 THB MOVEIS 906975"},{"id":"370ec155-a534-4e46-6819-08d5ad2bf6ba","name":"CLW ALIMENTOS LTDA","commercialName":"CLW","cnpj":"05252578000159","city":"CAMAQUÃ","stateCode":"RS","buscaAdicional":"CLW 59351 CLW ALIMENTOS 910385"},{"id":"6e2db994-359d-436a-681a-08d5ad2bf6ba","name":"HELMUT TESSMANN IND E COM DE OLEOS VEGETAIS LTDA","commercialName":"","cnpj":"91597617000191","city":"CAMAQUÃ","stateCode":"RS","buscaAdicional":"HELMUT 59352 HELMUT TESSMANN 910367"},{"id":"33b27b83-d10e-46ea-1cb2-08d5b8870181","name":"SANTALUCIA ALIMENTOS LTDA","commercialName":"SANTALUCIA","cnpj":"90471798000495","city":"CAMAQUÃ","stateCode":"RS","buscaAdicional":"SANTALUCIA 60850 SANTA LUCIA 912593 SANTA LUCIA 912594"},{"id":"7f639549-9cf0-4988-5cdb-08d5ad2bf6ba","name":"REFLORESTADORES UNIDOS SA","commercialName":"","cnpj":"88647896000146","city":"CAMBARÁ DO SUL","stateCode":"RS","buscaAdicional":"UNIDOS 51592 REFLOR UNIDOS 899275"},{"id":"c8879602-b7d3-4e5e-5867-08d5ad2bf6ba","name":"VINICOLA CAMPESTRE LTDA","commercialName":"","cnpj":"98521909000190","city":"CAMPESTRE DA SERRA","stateCode":"RS","buscaAdicional":"CAMPESTRE 11671 CAMPESTRE 890731"},{"id":"96e5791d-2e8a-40c8-58bd-08d5ad2bf6ba","name":"IPE GERACAO DE ENERGIA ELETRICA LTDA","commercialName":"","cnpj":"13089676000145","city":"CAMPESTRE DA SERRA","stateCode":"RS","buscaAdicional":"CGH TRABUCO 13092 TRABUCO 894142 CGH.PH.RS.031330-0.01"},{"id":"95c7e3cb-89fd-4ce7-5ab0-08d5ad2bf6ba","name":"MICROONDULADOS BOX PRINT LTDA","commercialName":"MICROONDULADOS BOX PRINT LTDA","cnpj":"08512168000198","city":"CAMPO BOM","stateCode":"RS","buscaAdicional":"MICROONDULADOS 50177 MICROONDULADOS 898347"},{"id":"4e5471c5-a783-4f24-5aaa-08d5ad2bf6ba","name":"BOX PRINT LTDA","commercialName":"","cnpj":"92750629000177","city":"CAMPO BOM","stateCode":"RS","buscaAdicional":"BOXPRINT 50140 BOX PRINT 898031"},{"id":"562d36e9-5e5c-463a-5aab-08d5ad2bf6ba","name":"NEW PRINT EMBALAGENS E DISPLAYS LTDA","commercialName":"","cnpj":"11807326000141","city":"CAMPO BOM","stateCode":"RS","buscaAdicional":"NEWPRINT 50141 NEW PRINT 898346"},{"id":"936bd13d-2d24-4643-5cf7-08d5ad2bf6ba","name":"FCC - INDUSTRIA E COMERCIO LTDA.","commercialName":"","cnpj":"03281950000472","city":"CAMPO BOM","stateCode":"RS","buscaAdicional":"FCC CAMPO BOM 51635 FCC INDUSTRIA RS 901103"},{"id":"4290364d-f4a5-4941-5cb1-08d5ad2bf6ba","name":"MATS BENEFICIAMENTO DE COURO LTDA","commercialName":"","cnpj":"92632512000199","city":"CAMPO BOM","stateCode":"RS","buscaAdicional":"MATSCOUROS 51508 MATS BENEFICIAMENTO 900024"},{"id":"194c0a25-478d-4538-5fcb-08d5ad2bf6ba","name":"FLECKSTEEL INDUSTRIA DE ARTEFATOS METALICOS LTDA","commercialName":"FLECKSTEEL","cnpj":"88242862000171","city":"CAMPO BOM","stateCode":"RS","buscaAdicional":"FLECKSTEEL 53223 FLECKSTEEL 902476"},{"id":"6422a248-a763-4ba0-60c0-08d5ad2bf6ba","name":"BOXFLEX COMPONENTES PARA CALCADOS LTDA","commercialName":"BOXFLEX","cnpj":"92088509000156","city":"CAMPO BOM","stateCode":"RS","buscaAdicional":"BOXFLEX 53657 BOXFLEX 902702"},{"id":"647ec97f-920b-43f2-5773-08d5ad2bf6ba","name":"SAINT-GOBAIN VIDROS S.A.","commercialName":"VERALLIA","cnpj":"60853942000730","city":"CAMPO BOM","stateCode":"RS","buscaAdicional":"SGVIDROS-CBOM 8852 ST GOBAIN CAMPO BOM 888872"},{"id":"5d538244-47fb-4320-66a5-08d5ad2bf6ba","name":"ANIGER - CALCADOS, SUPRIMENTOS E EMPREENDIMENTOS LTDA.","commercialName":"","cnpj":"94316999000126","city":"CAMPO BOM","stateCode":"RS","buscaAdicional":"ANIGER 57720 ANIGER - MATRIZ 910820"},{"id":"db9f7fd8-865a-4017-62d1-08d5ad2bf6ba","name":"BEST BOX EMBALAGENS EIRELI","commercialName":"","cnpj":"09664934000283","city":"CAMPO BOM","stateCode":"RS","buscaAdicional":"BEST BOX 1 54979 BEST BOX 1 904509"},{"id":"1b9b3d24-89c1-47e2-613f-08d5ad2bf6ba","name":"ARTECOLA QUIMICA S.A.","commercialName":"","cnpj":"44699346000103","city":"CAMPO BOM","stateCode":"RS","buscaAdicional":"ARTECOLA QUIMICA 54072 ARTECOLA 904934"},{"id":"d69a8343-aa43-4297-6425-08d5ad2bf6ba","name":"REGINATO METAIS INDUSTRIA E COMERCIO LTDA","commercialName":"REGINATO METAIS","cnpj":"14804535000120","city":"CAMPO BOM","stateCode":"RS","buscaAdicional":"REGINATO METAIS 55857 REGINATO METAIS 907666"},{"id":"a5fdcc2e-5408-4c64-647d-08d5ad2bf6ba","name":"CENTRO DE PRODUCAO RIO GRANDENSE DE ESPUMAS INDUSTRIAIS LTDA","commercialName":"","cnpj":"03636724000114","city":"CAMPO BOM","stateCode":"RS","buscaAdicional":"RIOGRANDENSE 56030 ORTOBOM RIOGRANDENSE 907640"},{"id":"18ed760e-a5e3-421c-5f43-08d5ad2bf6ba","name":"CALCADOS BEIRA RIO S/A","commercialName":"CALCADOS BEIRA RIO S.A.","cnpj":"88379771003955","city":"CANDELÁRIA","stateCode":"RS","buscaAdicional":"BEIRA RIO CANDELARIA 52879 BEIRA RIO CANDELARIA 906485"},{"id":"0b9a9b6a-aa42-45a9-4ef0-08d5ad2bf6ba","name":"COMPANHIA DE GERACAO TERMICA DE ENERGIA ELETRICA","commercialName":"","cnpj":"02016507000169","city":"CANDIOTA","stateCode":"RS","buscaAdicional":"CGTEE 25 PRES MEDICI (FASE C) 8581 UTE.CM.RS.029767-4.01 CANDIOTA II 356 UTE.CM.RS.002150-4.01 NUTEPA 358 UTE.PE.RS.001595-4.01 CANDIOTA II EXP 8356 UTE.CM.RS.002150-4.01"},{"id":"98a57d61-a221-4411-5058-08d5ad2bf6ba","name":"MAXIFORJA COMPONENTES AUTOMOTIVOS LTDA","commercialName":"","cnpj":"88303375000171","city":"CANOAS","stateCode":"RS","buscaAdicional":"MAXIFORJA 1582 MAXIFORJA-CANOAS-RS 7197"},{"id":"10dd262a-bb25-42f7-561c-08d5ad2bf6ba","name":"ENGEPOL GEOSSINTETICOS LTDA","commercialName":"ENGEPOL","cnpj":"93273985000100","city":"CANOAS","stateCode":"RS","buscaAdicional":"ENGEPOL 6618 ENGEPOL CANOAS 888900"},{"id":"bc9539e6-9a1a-4b7f-54ab-08d5ad2bf6ba","name":"GRID SOLUTIONS TRANSMISSAO DE ENERGIA LTDA","commercialName":"","cnpj":"05356949000908","city":"CANOAS","stateCode":"RS","buscaAdicional":"GE GRID CANOAS 4425 ALSTOM ENERG CANOAS 71672"},{"id":"7feb72ac-31e5-476d-5eef-08d5ad2bf6ba","name":"SOCIEDADE PORVIR CIENTIFICO","commercialName":"UNIVERSIDADE LA SALLE (UNILASALLE)","cnpj":"92741990004043","city":"CANOAS","stateCode":"RS","buscaAdicional":"UNILASALLE 52616 PORVIR CIENTIFICO 906464"},{"id":"6c51f9db-8252-4ba4-5dee-08d5ad2bf6ba","name":"MOINHOS CRUZEIRO DO SUL S A","commercialName":"MOINHOS CRUZEIRO DO SUL","cnpj":"88301155000109","city":"CANOAS","stateCode":"RS","buscaAdicional":"M CRUZEIRO RS 52073 M CRUZEIRO DO SUL RS 905939"},{"id":"3f3c0834-6f93-4256-5be7-08d5ad2bf6ba","name":"PONCHO VERDE ARMAZENS GERAIS LTDA","commercialName":"","cnpj":"07429291000187","city":"CANOAS","stateCode":"RS","buscaAdicional":"PONCHO VERDE 50978 PONCHO VERDE 899787"},{"id":"8e67ac9d-7133-4a76-6440-08d5ad2bf6ba","name":"CANOAS SHOPPING CENTER","commercialName":"CANOAS SHOPPING","cnpj":"09457452000171","city":"CANOAS","stateCode":"RS","buscaAdicional":"CANOAS SHOPPING 55897 CANOAS SHOPPING 907262"},{"id":"42d27faa-d2c3-42fa-6189-08d5ad2bf6ba","name":"MOINHO ESTRELA LTDA","commercialName":"","cnpj":"89776991000102","city":"CANOAS","stateCode":"RS","buscaAdicional":"MOINHO ESTRELA 54228 MOINHO ESTRELA LTDA 905919 MOINHO ESTRELA FILIA 905953"},{"id":"cccd2af7-3e3b-4104-6247-08d5ad2bf6ba","name":"PANFACIL ALIMENTOS LTDA","commercialName":"","cnpj":"05957878000133","city":"CANOAS","stateCode":"RS","buscaAdicional":"PANFACIL 54671 PANFACIL ALIMENTOS 905945"},{"id":"ae3e5d97-13ea-4723-68d6-08d5ad2bf6ba","name":"IRIEL INDUSTRIA E COMERCIO DE SISTEMAS ELETRICOS LTDA","commercialName":"","cnpj":"06005455000186","city":"CANOAS","stateCode":"RS","buscaAdicional":"IRIEL 60472 IRIEL CANOAS 910974"},{"id":"a68be3c3-8536-4cf1-1cd8-08d5b8870181","name":"AGCO DO BRASIL SOLUCOES AGRICOLAS LTDA.","commercialName":"","cnpj":"55962369001491","city":"CANOAS","stateCode":"RS","buscaAdicional":"AGCO DO BRASIL CANOAS 62417"},{"id":"690f8ed9-cd0f-40ed-73f0-08d5cf600bef","name":"BANRISUL-ARMAZENS GERAIS S/A","commercialName":"","cnpj":"92721232000157","city":"CANOAS","stateCode":"RS","buscaAdicional":""},{"id":"7760c267-6494-429a-64ab-08d5ad2bf6ba","name":"FRIGORIFICO EXTREMO SUL S A","commercialName":"","cnpj":"87452710000130","city":"CAPÃO DO LEÃO","stateCode":"RS","buscaAdicional":"FRIG EXTREMO SUL 56149 FRIGORIFICO EXTR SUL 907504"},{"id":"c8a9477d-1f5e-4ff9-5971-08d5ad2bf6ba","name":"SLC ALIMENTOS LTDA","commercialName":"SLC ALIMENTOS","cnpj":"04107020001784","city":"CAPÃO DO LEÃO","stateCode":"RS","buscaAdicional":"SLC ALIMENTOS 14537 PCT SLC ALIMENTOS 896559 UTE.AI.RS.031292-4.01"},{"id":"aa4d187c-9f1b-4f86-65fe-08d5ad2bf6ba","name":"NESTLE SUL - ALIMENTOS E BEBIDAS LTDA","commercialName":"","cnpj":"11051859000146","city":"CARAZINHO","stateCode":"RS","buscaAdicional":"NESTLE SUL CL 57257 NESTLE SUL CARAZINHO 906978"},{"id":"32e07b00-7fd8-4ee1-6592-08d5ad2bf6ba","name":"COOPERATIVA SANTA CLARA LTDA","commercialName":"SANTA CLARA","cnpj":"88587357000169","city":"CARLOS BARBOSA","stateCode":"RS","buscaAdicional":"COOP SANTA CLARA 56833 COOPERATIVA S CLARA 71265 COOPER SANTA CLARA 897191 COOP SANTA CLARA 901059 SANTA CLARA BARBOSA 906515"},{"id":"b3c2ac66-cfeb-47d8-54d4-08d5ad2bf6ba","name":"GALVANOTEK EMBALAGENS LTDA.","commercialName":"","cnpj":"94319589000139","city":"CARLOS BARBOSA","stateCode":"RS","buscaAdicional":"GALVANOTEK 4523 GALVANOTEK-C BARB 71687"},{"id":"d1cff958-9adb-4fa9-502e-08d5ad2bf6ba","name":"TRAMONTINA MULTI S/A","commercialName":"","cnpj":"88037668000154","city":"CARLOS BARBOSA","stateCode":"RS","buscaAdicional":"TRAMONTINA MULTI 1495 TRAMONTINA MULTFERRA 7972"},{"id":"d3d35e2e-f2d9-465d-4f92-08d5ad2bf6ba","name":"TRAMONTINA SA CUTELARIA","commercialName":"","cnpj":"90050238000114","city":"CARLOS BARBOSA","stateCode":"RS","buscaAdicional":"TRAMONTINA 1162 TRAMONTINA CUTELARIA 7805 TRAMONTINA D.MACHADO 70798"},{"id":"72489ea7-f65a-48f7-5155-08d5ad2bf6ba","name":"TRAMONTINA ELETRIK S.A.","commercialName":".","cnpj":"88674080000101","city":"CARLOS BARBOSA","stateCode":"RS","buscaAdicional":"TRAMONTINA ELETRIK 2120 TRAMONTINA ELETRIK 70196"},{"id":"2f8c0c13-0d9c-4966-5162-08d5ad2bf6ba","name":"IRWIN INDUSTRIAL TOOL FERRAMENTAS DO BRASIL LTDA","commercialName":"","cnpj":"90049289000126","city":"CARLOS BARBOSA","stateCode":"RS","buscaAdicional":"IRWIN 2147 IRWIN TOOL DO BRASIL 70506"},{"id":"90df7c54-34e7-4fcf-5167-08d5ad2bf6ba","name":"TRAMONTINA TEEC S/A.","commercialName":"","cnpj":"01554846000136","city":"CARLOS BARBOSA","stateCode":"RS","buscaAdicional":"TEEC 2155 TRAMONTINA TEEC-RS 70197"},{"id":"0fc81bb3-2b06-466e-5792-08d5ad2bf6ba","name":"MOINHO CASQUENSE LTDA","commercialName":"","cnpj":"00333653000192","city":"CASCA","stateCode":"RS","buscaAdicional":"CASQUENSE 9069 CASQUENSE 889005"},{"id":"69b680a5-3f25-43d4-5fc5-08d5ad2bf6ba","name":"MIG PLUS AGROINDUSTRIAL LTDA","commercialName":"","cnpj":"93976017000160","city":"CASCA","stateCode":"RS","buscaAdicional":"MIG PLUS 53216 MIG PLUS AGRO 901042"},{"id":"719f4537-6da2-42f4-5eed-08d5ad2bf6ba","name":"MARELLI MOVEIS PARA ESCRITORIO S/A","commercialName":"","cnpj":"88766936000179","city":"CAXIAS DO SUL","stateCode":"RS","buscaAdicional":"MARELLI 52611 MARELLI 904089"},{"id":"7c6b231c-ea47-4b2d-5f4c-08d5ad2bf6ba","name":"IRMAOS AMALCABURIO LTDA","commercialName":"","cnpj":"88623996000132","city":"CAXIAS DO SUL","stateCode":"RS","buscaAdicional":"AMALCABURIO 52890 AMALCABURIO 904816"},{"id":"2e575b2f-3470-4a3e-5ec2-08d5ad2bf6ba","name":"SAVIPLAST INDUSTRIA E COMERCIO DE PLASTICOS EIRELI","commercialName":"","cnpj":"88305719000181","city":"CAXIAS DO SUL","stateCode":"RS","buscaAdicional":"SAVIPLAST 52537 SAVIPLAST 902155"},{"id":"9a40921d-4ef2-4d3a-5d96-08d5ad2bf6ba","name":"UNIMED NORDESTE RS SOCIEDADE COOP DE SERV MEDICOS LTDA","commercialName":"","cnpj":"87827689000100","city":"CAXIAS DO SUL","stateCode":"RS","buscaAdicional":"UNIMED NORDESTE 51927 UNIMED NORDESTE RS 901079"},{"id":"ac9ac2a4-f061-42f6-5dac-08d5ad2bf6ba","name":"AUTOTRAVI BORRACHAS E PLASTICOS EIRELI","commercialName":"","cnpj":"88614078000147","city":"CAXIAS DO SUL","stateCode":"RS","buscaAdicional":"AUTOTRAVI 51952 AUTOTRAVI 904079"},{"id":"9aaf5874-d7f4-4eea-5d8a-08d5ad2bf6ba","name":"TRICHES FERRO E ACO LTDA","commercialName":"","cnpj":"88610605000145","city":"CAXIAS DO SUL","stateCode":"RS","buscaAdicional":"TRICHES 51868 TRICHES 899307"},{"id":"85f9d77e-9231-4f50-5998-08d5ad2bf6ba","name":"RANDON SA IMPLEMENTOS E PARTICIPACOES","commercialName":"","cnpj":"89086144000620","city":"CAXIAS DO SUL","stateCode":"RS","buscaAdicional":"RANDON SUSPENSYS 15055 SUSPENSYS-CAX DO SUL 7511"},{"id":"5b13261f-d2fa-4b40-5875-08d5ad2bf6ba","name":"MOINHOS GALOPOLIS SA","commercialName":"ROSEFLOR ALIMENTOS","cnpj":"88614557000163","city":"CAXIAS DO SUL","stateCode":"RS","buscaAdicional":"MOGASA 11851 MOINHOS GALOPOLIS 890220"},{"id":"cfa720ca-2751-425d-5876-08d5ad2bf6ba","name":"WEATHERFORD INDUSTRIA E COMERCIO LTDA","commercialName":"PRODUCTION ENGEMAQ","cnpj":"93189694000138","city":"CAXIAS DO SUL","stateCode":"RS","buscaAdicional":"WEATHERFORD 11852 WEATHERFORD 890893"},{"id":"f11b15c9-2519-4ebc-584b-08d5ad2bf6ba","name":"BRINOX METALURGICA SA","commercialName":"","cnpj":"92038108000191","city":"CAXIAS DO SUL","stateCode":"RS","buscaAdicional":"BRINOX 11249 BRINOX 889827"},{"id":"f88b0ef5-05c9-4bad-584e-08d5ad2bf6ba","name":"MECANICA INDUSTRIAL COLAR LTDA","commercialName":"","cnpj":"88611876000115","city":"CAXIAS DO SUL","stateCode":"RS","buscaAdicional":"COLAR 11298 COLAR CAXIAS DO SUL 889990"},{"id":"68015e48-3db3-4727-580c-08d5ad2bf6ba","name":"VIDROFORTE INDUSTRIA E COMERCIO DE VIDROS LTDA.","commercialName":"","cnpj":"92639954000167","city":"CAXIAS DO SUL","stateCode":"RS","buscaAdicional":"VIDROFORTE 10509 VIDROFORTE CAXIAS 889500"},{"id":"2bf88cad-8fd1-4a5e-582e-08d5ad2bf6ba","name":"UNYLASER - INDUSTRIA METALURGICA LTDA","commercialName":"","cnpj":"05897063000106","city":"CAXIAS DO SUL","stateCode":"RS","buscaAdicional":"UNYLASER 10910 UNYLASER 889628"},{"id":"6a417fbe-1544-4f78-5c57-08d5ad2bf6ba","name":"TONDO S/A.","commercialName":"","cnpj":"88618285000412","city":"CAXIAS DO SUL","stateCode":"RS","buscaAdicional":"TONDOCAXIAS 51268 TONDO CAXIAS RS 899144"},{"id":"509abdbb-e428-4a9b-5a92-08d5ad2bf6ba","name":"FRANZOI CIA LTDA","commercialName":"MOINHO SANTO ANTONIO","cnpj":"88613096000104","city":"CAXIAS DO SUL","stateCode":"RS","buscaAdicional":"MOINHO STO ANTONIO 50087 GERMANI -CAXIAS - RS 888548"},{"id":"1236dae7-3a12-4b41-5acf-08d5ad2bf6ba","name":"TECNOHARD INDUSTRIA METALURGICA LTDA","commercialName":"","cnpj":"04275914000116","city":"CAXIAS DO SUL","stateCode":"RS","buscaAdicional":"TECNOHARD 50248 TECNOHARD 898831"},{"id":"ef22ca9a-5bee-471b-5b00-08d5ad2bf6ba","name":"ACO PECAS DEMORE LTDA","commercialName":"","cnpj":"89089668000160","city":"CAXIAS DO SUL","stateCode":"RS","buscaAdicional":"DEMORE 50383 ACOS DEMORE 900603"},{"id":"20bdd536-04ee-468b-5afb-08d5ad2bf6ba","name":"QUALY FOODS LTDA","commercialName":"","cnpj":"08996020000176","city":"CAXIAS DO SUL","stateCode":"RS","buscaAdicional":"LOVATO 50378 LOVATO 898043"},{"id":"2428f7a6-9048-461f-57aa-08d5ad2bf6ba","name":"SUBCONDOMINIO DO CENTRO COMERCIAL DO SHOPPING CENTER IGUATEMI CAXIAS","commercialName":"","cnpj":"01868136000180","city":"CAXIAS DO SUL","stateCode":"RS","buscaAdicional":"SHOP IGUATEMI 9309 IGUATEMI CAXIAS SUL 888827"},{"id":"338f167c-f558-4664-57ba-08d5ad2bf6ba","name":"INDUSTRIA MECANICA NTC LTDA","commercialName":"","cnpj":"92225259000159","city":"CAXIAS DO SUL","stateCode":"RS","buscaAdicional":"NTC 9491 IND MECANICA NTC 889243"},{"id":"e55fd624-2bf3-4cf2-57c9-08d5ad2bf6ba","name":"CROMOFIX CROMO DURO LTDA","commercialName":"","cnpj":"88112313000263","city":"CAXIAS DO SUL","stateCode":"RS","buscaAdicional":"CROMOFIX 9629 CROMOFIX 889082"},{"id":"8877a001-7310-4c6d-5731-08d5ad2bf6ba","name":"FABRICA NACIONAL DE AMORTECEDORES LTDA","commercialName":"FNA","cnpj":"88617329000147","city":"CAXIAS DO SUL","stateCode":"RS","buscaAdicional":"FNA 8329 FNA 888871"},{"id":"5c2854e4-d433-40b3-5727-08d5ad2bf6ba","name":"SHOPPING CAXIAS EMPREENDIMENTOS IMOBILIARIOS LTDA.","commercialName":"","cnpj":"09050227000116","city":"CAXIAS DO SUL","stateCode":"RS","buscaAdicional":"SANPELEGRINO 8267 SAN PELEGRINO 888395"},{"id":"14a3c8c5-7307-434b-56d9-08d5ad2bf6ba","name":"HIDRO FILTROS DO BRASIL INDUSTRIA E COMERCIO DE FILTROS LTDA","commercialName":"HIDRO FILTROS","cnpj":"00192861000119","city":"CAXIAS DO SUL","stateCode":"RS","buscaAdicional":"PENTAIR HIDRO FILTROS 7840 HIDROFILTRO CAXIAS 72370"},{"id":"45e583b9-59f3-4999-55db-08d5ad2bf6ba","name":"SAN MARINO ONIBUS LTDA","commercialName":"","cnpj":"93785822000106","city":"CAXIAS DO SUL","stateCode":"RS","buscaAdicional":"SAN MARINO 6250 SAN MARINO - CAXIAS 72101"},{"id":"c4185255-6561-4910-55b8-08d5ad2bf6ba","name":"ACRILYS DO BRASIL LAMINADOS PLASTICOS LTDA","commercialName":"","cnpj":"93831832000130","city":"CAXIAS DO SUL","stateCode":"RS","buscaAdicional":"ACRILYS 6037 ACRILYS-CAXIAS SUL 71981"},{"id":"a9609839-f2fd-4cd1-55bd-08d5ad2bf6ba","name":"FUNDACAO UNIVERSIDADE DE CAXIAS DO SUL","commercialName":"UCS","cnpj":"88648761000103","city":"CAXIAS DO SUL","stateCode":"RS","buscaAdicional":"UCS 6043 UNIV CAXIAS DO SUL 71929"},{"id":"6d66f38c-3c7e-4bf0-56c2-08d5ad2bf6ba","name":"DANFOSS POWER SOLUTIONS INDUSTRIA E COMERCIO ELETROHIDRAULICA LTDA.","commercialName":"","cnpj":"04529320000194","city":"CAXIAS DO SUL","stateCode":"RS","buscaAdicional":"DANFOSS 7602 VALMOVA CAXIAS 888169"},{"id":"06ea7424-e3a1-4c1f-56b3-08d5ad2bf6ba","name":"LAMINA INDUSTRIA PLASTICA LTDA","commercialName":"","cnpj":"05853030000164","city":"CAXIAS DO SUL","stateCode":"RS","buscaAdicional":"LAMINA 7523 LAMINA-CAXIAS DO SUL 72278"},{"id":"c826085d-3081-4d6a-5692-08d5ad2bf6ba","name":"DUROLINE SA","commercialName":"DUROLINE","cnpj":"00795288000138","city":"CAXIAS DO SUL","stateCode":"RS","buscaAdicional":"DUROLINE 7240 DUROLINE CAXIAS 888190"},{"id":"f20a3f69-a51a-4892-54f5-08d5ad2bf6ba","name":"SUSIN FRANCESCUTTI METALURGICA LTDA","commercialName":"","cnpj":"88628805000125","city":"CAXIAS DO SUL","stateCode":"RS","buscaAdicional":"SUSIN 4618 SUSIN-CAXIAS DO SUL 71722"},{"id":"05fe0383-80a8-44b0-54ec-08d5ad2bf6ba","name":"MICROINOX - FUNDICAO DE PRECISAO E USINAGEM LTDA.","commercialName":"MICROINOX","cnpj":"13785854000172","city":"CAXIAS DO SUL","stateCode":"RS","buscaAdicional":"MICROINOX 4594 MICROINOX CAXIAS SUL 70468"},{"id":"f3b04105-fd70-4a91-54b9-08d5ad2bf6ba","name":"MADAL PALFINGER S/A","commercialName":"MADAL","cnpj":"88613856000183","city":"CAXIAS DO SUL","stateCode":"RS","buscaAdicional":"MADAL 4461 MADAL-CAXIAS DO SUL 71578"},{"id":"ad78eb3f-ebd4-46f3-556c-08d5ad2bf6ba","name":"D'ZAINER PRODUTOS PLASTICOS LTDA","commercialName":"D'ZAINER","cnpj":"73960874000164","city":"CAXIAS DO SUL","stateCode":"RS","buscaAdicional":"DZAINER 5572 DZAINER-CAXIAS SUL 71856"},{"id":"29e1d4b1-3eed-4696-5588-08d5ad2bf6ba","name":"BAZEI PLASTICOS E EMBALAGENS LTDA","commercialName":"BAZEI EMBALAGENS","cnpj":"94319555000144","city":"CAXIAS DO SUL","stateCode":"RS","buscaAdicional":"BAZEI 5759 BAZEI-CAXIAS DO SUL 71851"},{"id":"9124e638-04e2-4701-5583-08d5ad2bf6ba","name":"MUNDIAL S.A. - PRODUTOS DE CONSUMO","commercialName":"FABRICA SAO CIRO","cnpj":"88610191000405","city":"CAXIAS DO SUL","stateCode":"RS","buscaAdicional":"MUNDIAL CX 5721 MUNDIAL-CAXIAS SUL 71907"},{"id":"b4dd45ca-9d2c-4cea-559d-08d5ad2bf6ba","name":"SOPRANO MATERIAIS ELETRICOS LTDA.","commercialName":"","cnpj":"12901774000172","city":"CAXIAS DO SUL","stateCode":"RS","buscaAdicional":"SOPRANO OLEO 5898 SOPRANO-HIDRAULICA 70645"},{"id":"a019a4c6-a8b6-4369-5552-08d5ad2bf6ba","name":"PANATLANTICA INDUSTRIA E COMERCIO DE TUBOS S.A.","commercialName":"PANATLANTICA TUBOS","cnpj":"03684007000168","city":"CAXIAS DO SUL","stateCode":"RS","buscaAdicional":"PANATLANTICA 5329 ATKORE-CAXIAS SUL 71875"},{"id":"1b7e94e0-2988-4701-5546-08d5ad2bf6ba","name":"TABONE INDUSTRIA E COMERCIO DE PLASTICOS LTDA","commercialName":"","cnpj":"90102609000164","city":"CAXIAS DO SUL","stateCode":"RS","buscaAdicional":"TABONE 5229 TABONE EXTRUDADOS CX 71742 TABONE INJETORA 72390"},{"id":"e1da7404-1baf-49f3-536b-08d5ad2bf6ba","name":"PISANI PLASTICOS S.A","commercialName":"","cnpj":"87833737000173","city":"CAXIAS DO SUL","stateCode":"RS","buscaAdicional":"PISANI 3624 PISANI PLASTICOS 71189"},{"id":"d1fc3847-65fd-435f-5163-08d5ad2bf6ba","name":"SERRANA ENERGETICA S/A.","commercialName":"","cnpj":"07094597000120","city":"CAXIAS DO SUL","stateCode":"RS","buscaAdicional":"PALANQUINHO 2148 PALANQUINHO 8708 PCH.PH.RS.029001-7.01"},{"id":"0bc72a89-0ed3-424d-5137-08d5ad2bf6ba","name":"VOGES METALURGIA LTDA - EM RECUPERACAO JUDICIAL","commercialName":"VOGES","cnpj":"04654447000488","city":"CAXIAS DO SUL","stateCode":"RS","buscaAdicional":"VOGES MOT 2052 METALCORTE MOTORES 70435"},{"id":"824178c4-3fbb-4aff-5143-08d5ad2bf6ba","name":"MARCOPOLO SA","commercialName":"MARCOPOLO","cnpj":"88611835000129","city":"CAXIAS DO SUL","stateCode":"RS","buscaAdicional":"MARCOPOLO 2078 MARCOPOLAR RS 70439 MARCOPOLO MATRIZ 892584"},{"id":"63c4d177-ed06-4418-520f-08d5ad2bf6ba","name":"CASTERTECH FUNDICAO E TECNOLOGIA LTDA","commercialName":"CASTERTECH","cnpj":"08304706000159","city":"CAXIAS DO SUL","stateCode":"RS","buscaAdicional":"CASTERTECH 2836 CASTERTECH 70793"},{"id":"95c32265-a27f-4b0c-51b7-08d5ad2bf6ba","name":"GALOPOLIS ENERGIA SA","commercialName":"","cnpj":"09113777000137","city":"CAXIAS DO SUL","stateCode":"RS","buscaAdicional":"GESA 2544 GALOPOLIS 8448 PCH.PH.RS.029714-3.01"},{"id":"52fd3034-4577-4910-52f8-08d5ad2bf6ba","name":"DAMBROZ SA INDUSTRIA MECANICA E METALURGICA","commercialName":"","cnpj":"88613716000105","city":"CAXIAS DO SUL","stateCode":"RS","buscaAdicional":"DAMBROZ 3390 DAMBROZ 71092"},{"id":"1ec96428-4c54-43d2-4f81-08d5ad2bf6ba","name":"HIDRELETRICA RIO SAO MARCOS LTDA","commercialName":"","cnpj":"04198857000119","city":"CAXIAS DO SUL","stateCode":"RS","buscaAdicional":"HIDROMARCOS 1139 SAO MARCOS 8055 PCH.PH.RS.029077-7.01"},{"id":"ef9ff1df-2438-4f69-4f0d-08d5ad2bf6ba","name":"RIO GRANDE ENERGIA SA","commercialName":"","cnpj":"02016439000138","city":"CAXIAS DO SUL","stateCode":"RS","buscaAdicional":"RGE 66 RGE 30 RGE DITC CAC 70683 RGE DITC JAC 70685"},{"id":"95418aa0-9417-4da8-4f30-08d5ad2bf6ba","name":"CLION ASSESSORIA E COMERCIALIZACAO DE ENERGIA ELETRICA LTDA","commercialName":"","cnpj":"04785914000166","city":"CAXIAS DO SUL","stateCode":"RS","buscaAdicional":"CPFL MERIDION 126"},{"id":"8eee0206-360c-4b29-4f6e-08d5ad2bf6ba","name":"JOST BRASIL SISTEMAS AUTOMOTIVOS LTDA","commercialName":"","cnpj":"00843966000190","city":"CAXIAS DO SUL","stateCode":"RS","buscaAdicional":"JOST 1098 JOST BRASIL CAX. SUL 7546"},{"id":"5f2fa94a-e4e5-4139-4f6f-08d5ad2bf6ba","name":"RANDON SA IMPLEMENTOS E PARTICIPACOES","commercialName":"","cnpj":"89086144000116","city":"CAXIAS DO SUL","stateCode":"RS","buscaAdicional":"RANDON 1101 RANDON I.P.-CAX. SUL 7500 RANDON EXP 910038"},{"id":"98778b25-d9c1-48de-50f5-08d5ad2bf6ba","name":"GUERRA S/A IMPLEMENTOS RODOVIARIOS","commercialName":"","cnpj":"88665146000105","city":"CAXIAS DO SUL","stateCode":"RS","buscaAdicional":"GUERRA 1921 AGUERRA MTZ CAX. SUL 70278 AGUERRA IMPLEM RODOV 70298 AGUERRA FAB II CAX 70430"},{"id":"d08a20b0-620e-4bcc-50f9-08d5ad2bf6ba","name":"SULBRAS MOLDES E PLASTICOS LTDA","commercialName":"","cnpj":"89729867000196","city":"CAXIAS DO SUL","stateCode":"RS","buscaAdicional":"SULBRAS 1928 SULBRAS MTZ CAX. SUL 70329 SULBRAS SAPUCAIA SUL 71206 SULBRAS JOINVILLE 71598 SULBRAS SALTO SP 70328"},{"id":"f1a36eac-5a51-49aa-50ff-08d5ad2bf6ba","name":"MASTER SISTEMAS AUTOMOTIVOS LTDA","commercialName":"","cnpj":"90852914000173","city":"CAXIAS DO SUL","stateCode":"RS","buscaAdicional":"MASTER 1943 MASTER SIST.AUT. CAX 70353"},{"id":"48af9a23-8115-4172-5105-08d5ad2bf6ba","name":"VOESTALPINE MEINCOL S/A","commercialName":"MEINCOL","cnpj":"88614342000142","city":"CAXIAS DO SUL","stateCode":"RS","buscaAdicional":"MEINCOL 1949 MEINCOL CAX. DO SUL 70334 MEINCOL VOLESTALPINE 889526"},{"id":"5cf4a4a2-148e-4fea-50ba-08d5ad2bf6ba","name":"FRAS-LE SA","commercialName":"","cnpj":"88610126000129","city":"CAXIAS DO SUL","stateCode":"RS","buscaAdicional":"FRAS LE 1808 FRAS LE-CX DO SUL-RS 70163"},{"id":"a9b13137-7498-43d6-659a-08d5ad2bf6ba","name":"PROGAS - INDUSTRIA METALURGICA LTDA","commercialName":"","cnpj":"92724517000141","city":"CAXIAS DO SUL","stateCode":"RS","buscaAdicional":"PROGAS 56855 PROGAS 908431"},{"id":"8adccc5e-448f-4f3b-6699-08d5ad2bf6ba","name":"FOSCARINI E CIA LTDA","commercialName":"","cnpj":"88598230000145","city":"CAXIAS DO SUL","stateCode":"RS","buscaAdicional":"FOSCARINI 57681 FOSCARINI 909208"},{"id":"e7f3cefb-b792-47ee-669a-08d5ad2bf6ba","name":"PEDREIRA E CONCRETOS CAXIENSE LTDA","commercialName":"","cnpj":"88831888000155","city":"CAXIAS DO SUL","stateCode":"RS","buscaAdicional":"PEDREIRA CAXIENSE 57682 PEDREIRA CAXIENSE 909260"},{"id":"5282d2a0-a63e-4d81-68d1-08d5ad2bf6ba","name":"MERCO ENERGIA LTDA","commercialName":"","cnpj":"27807596000192","city":"CAXIAS DO SUL","stateCode":"RS","buscaAdicional":"MERCO 60443"},{"id":"c33a5ff8-c1a7-47b3-688c-08d5ad2bf6ba","name":"PETTENATI SA INDUSTRIA TEXTIL","commercialName":"","cnpj":"88613658000110","city":"CAXIAS DO SUL","stateCode":"RS","buscaAdicional":"PETTENATI TEXTIL 60131 PETTENATI FILIAL 71082 PETTENATI MATRIZ 910041"},{"id":"17501260-3589-43eb-8851-08d5ae44ed50","name":"PETTENATI SA INDUSTRIA TEXTIL","commercialName":"","cnpj":"88613658002678","city":"CAXIAS DO SUL","stateCode":"RS","buscaAdicional":"PETTENATI 3438"},{"id":"55927c3e-4fb9-4d3e-8835-08d5ae44ed50","name":"TOME S/A INDUSTRIA DE AUTO PECAS","commercialName":"","cnpj":"88628243000110","city":"CAXIAS DO SUL","stateCode":"RS","buscaAdicional":"TOME CAXIAS 1357 TOME-CAXIAS DO SUL 7377"},{"id":"1146297b-ecc6-4484-8831-08d5ae44ed50","name":"VOGES METALURGIA LTDA - EM RECUPERACAO JUDICIAL","commercialName":"VOGES FUNDICAO","cnpj":"04654447000305","city":"CAXIAS DO SUL","stateCode":"RS","buscaAdicional":"VOGES 1210 METALCORTE-CAXIAS-RS 7391"},{"id":"142785a2-2f42-4807-64b5-08d5ad2bf6ba","name":"COPRAL - ADMINISTRACAO E PARTICIPACOES LTDA","commercialName":"","cnpj":"72362288000155","city":"CAXIAS DO SUL","stateCode":"RS","buscaAdicional":"PRATAVIERA 56172 PRATAVIERA SHOPPING 905350"},{"id":"9d3154c2-0f31-4e81-64df-08d5ad2bf6ba","name":"DOMPEL INDUSTRIA PLASTICA E METALURGICA LTDA","commercialName":"","cnpj":"87203121000119","city":"CAXIAS DO SUL","stateCode":"RS","buscaAdicional":"DOMPEL 56287 DOMPEL PLAST E METAL 907502"},{"id":"7685f021-05ff-4291-6537-08d5ad2bf6ba","name":"ENGATCAR INDUSTRIA DE AUTO PECAS LTDA.","commercialName":"ENGATCAR","cnpj":"91215046000183","city":"CAXIAS DO SUL","stateCode":"RS","buscaAdicional":"ENGATCAR 56593 ENGATCAR AUTO PECAS 908488 ENGATCAR 908489"},{"id":"6c5cca35-9d93-4ec8-6423-08d5ad2bf6ba","name":"MAQUINAS SANMARTIN LTDA","commercialName":"","cnpj":"89086672000175","city":"CAXIAS DO SUL","stateCode":"RS","buscaAdicional":"SANMARTIN 55855 MAQUINAS SANMARTIN 905923"},{"id":"00e08538-cfd5-4d6d-63cf-08d5ad2bf6ba","name":"LABORATORIO FARMACEUTICO VITAMED LTDA","commercialName":"VITAMED","cnpj":"29346301000153","city":"CAXIAS DO SUL","stateCode":"RS","buscaAdicional":"VITAMED 55639 LAB FARMAC VITAMED 908202"},{"id":"869789dd-a24f-4f72-636b-08d5ad2bf6ba","name":"MARTIPLAST INDUSTRIA E COMERCIO DE PLASTICOS LTDA","commercialName":"MARTIPLAST","cnpj":"73445454000140","city":"CAXIAS DO SUL","stateCode":"RS","buscaAdicional":"MARTIPLAST 55344 MARTIPLAST 904815"},{"id":"e4ff6cb4-6b68-4659-6252-08d5ad2bf6ba","name":"PRODUTOS ALIMENTICIOS MACORTEZA LTDA","commercialName":"","cnpj":"88665674000156","city":"CAXIAS DO SUL","stateCode":"RS","buscaAdicional":"SORVELANDIA 54682 MACORTEZA 904814"},{"id":"e3e385ad-225f-479e-61f4-08d5ad2bf6ba","name":"BLS INDUSTRIA E COMERCIO DE PLASTICOS LTDA","commercialName":"BLYSTER SUL","cnpj":"12660422000172","city":"CAXIAS DO SUL","stateCode":"RS","buscaAdicional":"BLS PLASTICOS 54485 BLS IND PLASTICO 904462"},{"id":"fd391779-7c26-4f80-622f-08d5ad2bf6ba","name":"PLASMOSUL INDUSTRIA DE PLASTICOS LTDA","commercialName":"","cnpj":"13107569000100","city":"CAXIAS DO SUL","stateCode":"RS","buscaAdicional":"PLASMOSUL 54614 PLASMOSUL 904080"},{"id":"380b1a54-61b0-48a0-61e2-08d5ad2bf6ba","name":"INTRAL SA INDUSTRIA DE MATERIAIS ELETRICOS","commercialName":"","cnpj":"88611264000122","city":"CAXIAS DO SUL","stateCode":"RS","buscaAdicional":"INTRAL FAB1 54456 INTRAL 3082203495 904445 INTRAL 3082652533 904461"},{"id":"7740b302-a55b-4b79-61c2-08d5ad2bf6ba","name":"TRAVI PLASTICOS INDUSTRIAIS LTDA","commercialName":"","cnpj":"10528220000227","city":"CAXIAS DO SUL","stateCode":"RS","buscaAdicional":"TRAVI 54383 TRAVI PLASTICOS 905941"},{"id":"7c013fcb-b120-48b1-1c9f-08d5b8870181","name":"AGRALE SOCIEDADE ANONIMA","commercialName":"","cnpj":"88610324000192","city":"CAXIAS DO SUL","stateCode":"RS","buscaAdicional":"AGRALE 1863 AGRALE SA 912877"},{"id":"4aae810f-934d-40f7-6147-08d5ad2bf6ba","name":"PAMPA GERADORA DE ENERGIA ELETRICA LTDA","commercialName":"PAMPA ENERGETICA LTDA","cnpj":"11783832000148","city":"CONDOR","stateCode":"RS","buscaAdicional":"PAMPA ENERGETICA 54099 MAMBUCA 905521 CGH.PH.RS.037128-9.01"},{"id":"cfc97c78-c25e-4ca3-5f1c-08d5ad2bf6ba","name":"HIDROPAN GERACAO DE ENERGIA ELETRICA LTDA.","commercialName":"HIGEE","cnpj":"08438804000189","city":"CONDOR","stateCode":"RS","buscaAdicional":"CGH RIO ALEGRE 52747 CGH RIO ALEGRE 908281 CGH.PH.RS.002280-2.01"},{"id":"a5ed8327-d50d-4756-57fe-08d5ad2bf6ba","name":"J. H. M. GERACAO ELETRICA LTDA","commercialName":"J H M GERACAO ELETRICA","cnpj":"05147507000196","city":"CRISSIUMAL","stateCode":"RS","buscaAdicional":"CGH CAA-YARI 10369 CAA-YARI 892422 CGH.PH.RS.029212-5.01"},{"id":"0098ff47-a110-41ca-6459-08d5ad2bf6ba","name":"FUNDICAO GIROS POLIAS E PECAS LTDA","commercialName":"","cnpj":"01290581000106","city":"CRUZEIRO DO SUL","stateCode":"RS","buscaAdicional":"FUNDICAO GIROS PECAS 55941 FUNDIC GIROS POLIAS 909329"},{"id":"b75e6cd5-8fa8-4d27-6876-08d5ad2bf6ba","name":"FAROS INDUSTRIA DE FARINHA DE OSSOS LTDA","commercialName":"FAROS","cnpj":"89892566000189","city":"CRUZEIRO DO SUL","stateCode":"RS","buscaAdicional":"FAROS 60092 FAROS IND FARIN OSSO 910691"},{"id":"79d7f78c-048c-4a67-5818-08d5ad2bf6ba","name":"HERVAL INDUSTRIA DE MOVEIS, COLCHOES E ESPUMAS LTDA.","commercialName":"","cnpj":"16670753000144","city":"DOIS IRMÃOS","stateCode":"RS","buscaAdicional":"HERVAL 10670 HERVAL NH 890188 HERVAL MATRIZ 890203 MADEIREIRA HERVAL 890205"},{"id":"a8a352b1-bbd8-45f5-5d95-08d5ad2bf6ba","name":"INDUSTRIA E COMERCIO DE COUROS DOWIDI LTDA.","commercialName":"WELLOUR COUROS","cnpj":"00342143000181","city":"DOIS IRMÃOS","stateCode":"RS","buscaAdicional":"WELLOUR 51926 WELLOUR 901196"},{"id":"93e7b021-93ba-459b-5dc4-08d5ad2bf6ba","name":"HENRICH E CIA LTDA.","commercialName":"","cnpj":"89238133000104","city":"DOIS IRMÃOS","stateCode":"RS","buscaAdicional":"HENRICH 51981 HENRICH E CIA LTDA 902704"},{"id":"bcb417a9-be48-45f0-88ba-08d5ae44ed50","name":"ENGENHO CORADINI LTDA","commercialName":"","cnpj":"89889869000142","city":"DOM PEDRITO","stateCode":"RS","buscaAdicional":"UTE ENGENHO CORADINI 50430 UTE ENGENHO CORADINI 898667 UTE.AI.RS.031795-0.01"},{"id":"c2c3297c-9476-45c5-6698-08d5ad2bf6ba","name":"QUINTA DO VALE ALIMENTOS LTDA","commercialName":"","cnpj":"00218077000132","city":"DOUTOR RICARDO","stateCode":"RS","buscaAdicional":"QUINTA DO VALE 57680 QUINTA DO VALE - FIL 910115 QUINTA DO VALE - MAT 910135"},{"id":"fcfb8c69-f4dd-4643-622e-08d5ad2bf6ba","name":"ELDORADO MINERACAO LTDA","commercialName":"","cnpj":"94100328000123","city":"ELDORADO DO SUL","stateCode":"RS","buscaAdicional":"ELDORADO MINERACAO 54609 ELDORADO MINERACAO 904315"},{"id":"c6e67ef6-57f5-480d-73ed-08d5cf600bef","name":"DIMED S/A - DISTRIBUIDORA DE MEDICAMENTOS","commercialName":"PANVEL FARMACIAS","cnpj":"92665611000177","city":"ELDORADO DO SUL","stateCode":"RS","buscaAdicional":""},{"id":"19d19b3f-94ca-42c4-5bd6-08d5ad2bf6ba","name":"CONSERVAS ODERICH SA","commercialName":"","cnpj":"97191902000780","city":"ELDORADO DO SUL","stateCode":"RS","buscaAdicional":"ODERICH ELDORADO 50943 ODERICH ELDORADO 897772"},{"id":"dd312024-def5-4642-585b-08d5ad2bf6ba","name":"FONTANA SA","commercialName":"FONTANA INDUSTRIA DE PERFUMARIAS","cnpj":"89305197000180","city":"ENCANTADO","stateCode":"RS","buscaAdicional":"FONTANA 11490 FONTANA 890619"},{"id":"573f13e9-9c69-45b7-5f16-08d5ad2bf6ba","name":"PONTO BOM INDUSTRIA DE PRODUTOS ALIMENTICIOS LTDA","commercialName":"","cnpj":"01013406000171","city":"ENCANTADO","stateCode":"RS","buscaAdicional":"SABORY 52729 PONTO BOM SABORY 904039"},{"id":"f8856a6d-4fbf-4b9d-5750-08d5ad2bf6ba","name":"COOPERATIVA DOS SUINOCULTORES DE ENCANTADO LTDA","commercialName":"","cnpj":"89305239000183","city":"ENCANTADO","stateCode":"RS","buscaAdicional":"DALIA 8550 DALIA PRINCIPAL 889040 DALIA LATICINIOS 889501 DALIA LEITE EM PO 898609 DALIA MERCADO 904721"},{"id":"be50fc7a-b62e-4903-68cd-08d5ad2bf6ba","name":"BALDISSERA & FILHO LTDA","commercialName":"","cnpj":"08837771000140","city":"ENCANTADO","stateCode":"RS","buscaAdicional":"GELICIA 60432 BALDISSERA 911911"},{"id":"9a353af5-36bc-4159-57ac-08d5ad2bf6ba","name":"ABRANJO GERACAO DE ENERGIA S/A","commercialName":"","cnpj":"13562900000174","city":"ENCRUZILHADA DO SUL","stateCode":"RS","buscaAdicional":"ABRANJO I 9329 ABRANJO I 891503 PCH.PH.RS.030400-0.01"},{"id":"bffaa855-95b2-46f9-5740-08d5ad2bf6ba","name":"CASA DE PEDRA ENERGIA S.A","commercialName":"","cnpj":"05632896000145","city":"ERECHIM","stateCode":"RS","buscaAdicional":"PCH RIO INDIOS 8409 RIO DOS INDIOS 888726 PCH.PH.RS.030057-8.01"},{"id":"9323d360-ad64-4282-572a-08d5ad2bf6ba","name":"PLAXMETAL S/A - INDUSTRIA DE CADEIRAS CORPORATIVAS","commercialName":"","cnpj":"91404251000197","city":"ERECHIM","stateCode":"RS","buscaAdicional":"PLAXMETAL 8270 PLAXMETAL - FILIAL 3 904373"},{"id":"5076aa6d-d175-4b15-53a4-08d5ad2bf6ba","name":"CRERAL- COOPERATIVA DE GERACAO DE ENERGIA E DESENVOLVIMENTO","commercialName":"","cnpj":"11192351000168","city":"ERECHIM","stateCode":"RS","buscaAdicional":"CRERAL 3743 CASCATA ANDORINHAS 8746 CGH.PH.RS.028240-5.01 ABAUNA 8748 CGH.PH.RS.000015-9.01"},{"id":"9d6d57ee-4f78-43c4-53ed-08d5ad2bf6ba","name":"COMIL ONIBUS S.A.","commercialName":"COMIL","cnpj":"00940956000173","city":"ERECHIM","stateCode":"RS","buscaAdicional":"COMIL 3918 COMIL ONIBUS ERECHIM 71347"},{"id":"fb0fec47-7f7f-46bf-558d-08d5ad2bf6ba","name":"OLFAR S/A - ALIMENTO E ENERGIA","commercialName":"","cnpj":"91830836000179","city":"ERECHIM","stateCode":"RS","buscaAdicional":"OLFAR 5797 OLFAR-ERECHIM 71841"},{"id":"3ee6eaae-d2b8-4949-5245-08d5ad2bf6ba","name":"PECCIN SA","commercialName":"","cnpj":"89425888000118","city":"ERECHIM","stateCode":"RS","buscaAdicional":"PECCIN 2984 PECCIN ERECHIM 70874"},{"id":"830e6733-6bf7-498b-5868-08d5ad2bf6ba","name":"INTECNIAL S.A.","commercialName":"INTECNIAL","cnpj":"89432702000158","city":"ERECHIM","stateCode":"RS","buscaAdicional":"INTECNIAL 11672 INTECNIAL 890223"},{"id":"e5f71fbd-44ef-4711-5bbc-08d5ad2bf6ba","name":"SEPE GERACAO DE ENERGIA LTDA","commercialName":"SEPE ENERGIA - SEPEENERGIA.COM.BR - SEPEENERGIA.ENG.BR","cnpj":"19660348000133","city":"ERECHIM","stateCode":"RS","buscaAdicional":"SEPE GERACAO 50878"},{"id":"5497869f-77e4-4373-5a58-08d5ad2bf6ba","name":"CAROLINA GERACAO DE ENERGIA LTDA","commercialName":"PCH SANTA CAROLINA","cnpj":"12851232000132","city":"ERECHIM","stateCode":"RS","buscaAdicional":"PCH SANTA CAROLINA 17359 PCH SANTA CAROLINA 897775 PCH.PH.RS.030723-8.01"},{"id":"8f5c2918-d283-4552-67f4-08d5ad2bf6ba","name":"PASTIFICIO NORTESUL INDUSTRIA E COMERCIO DE FARINHAS EIRELI","commercialName":"","cnpj":"06005521000207","city":"ERECHIM","stateCode":"RS","buscaAdicional":"PASTIFICIO NORTESUL 59081 PASTIFICIO NORTE SUL 909206"},{"id":"24242616-d1cf-4ed6-8d8c-08d5d060706e","name":"CERCENA S/A - INDUSTRIA METALURGICA","commercialName":"","cnpj":"89423040000150","city":"ERECHIM","stateCode":"RS","buscaAdicional":"CERCENA 61035 CERCENA 913436"},{"id":"4109d799-726e-4806-8d7e-08d5d060706e","name":"ENERGIR GERACAO DE ENERGIA ELETRICA LTDA","commercialName":"","cnpj":"21426833000199","city":"ERECHIM","stateCode":"RS","buscaAdicional":"UTE ENERGIR 58321 UTE ENERGIR COSNUMO 913586 UTE ENERGIR 913616 UTE.FL.RS.035434-1.01."},{"id":"1348d280-d6d8-4703-4f98-08d5ad2bf6ba","name":"BT GERADORA DE ENERGIA ELETRICA S/A","commercialName":"","cnpj":"03149173000164","city":"ERVAL SECO","stateCode":"RS","buscaAdicional":"PCH FERRADURA 1178 FERRADURA 8016 PCH.PH.RS.027885-8.01"},{"id":"d6d56364-bf08-462d-55be-08d5ad2bf6ba","name":"COOPERATIVA TRITICOLA DE GETULIO VARGAS LTDA","commercialName":"","cnpj":"90155953001355","city":"ESTAÇÃO","stateCode":"RS","buscaAdicional":"COTRIGO 6057 COOP TRICOLA DE GV 71915"},{"id":"7af84611-e8dd-47bc-5ac6-08d5ad2bf6ba","name":"SETA SA EXTRATIVA TANINO DE ACACIA","commercialName":"SETA","cnpj":"89717268000152","city":"ESTÂNCIA VELHA","stateCode":"RS","buscaAdicional":"SETA 50236 SETA 898268"},{"id":"80c1a9c8-7694-4207-5adf-08d5ad2bf6ba","name":"PARTNER INDUSTRIA E COMERCIO DE COUROS LTDA","commercialName":"","cnpj":"02866513000105","city":"ESTÂNCIA VELHA","stateCode":"RS","buscaAdicional":"PARTNER 50295 PARTNER COURO 899189"},{"id":"38188120-402c-4d7d-5be9-08d5ad2bf6ba","name":"PLASTICOS SUZUKI LTDA","commercialName":"","cnpj":"89188973000100","city":"ESTÂNCIA VELHA","stateCode":"RS","buscaAdicional":"PLAS SUZUKI 50980 PLASTICOS SUZIKI 901095"},{"id":"e5643d73-c766-4a27-5ebd-08d5ad2bf6ba","name":"QUIMICOUROS INDUSTRIA COMERCIO E REPRESENTACOES LTDA","commercialName":"","cnpj":"89635015000130","city":"ESTÂNCIA VELHA","stateCode":"RS","buscaAdicional":"QUIMICOUROS 52532 QUIMICOUROS IND. COM 905947"},{"id":"3b173f34-f070-401e-5b73-08d5ad2bf6ba","name":"SANREMO S/A","commercialName":"","cnpj":"89738173000115","city":"ESTEIO","stateCode":"RS","buscaAdicional":"SANREMO 50708 SANREMO 899306"},{"id":"0f581984-9840-4353-5b71-08d5ad2bf6ba","name":"PINCEIS ATLAS SA","commercialName":"","cnpj":"89723837000172","city":"ESTEIO","stateCode":"RS","buscaAdicional":"ATLAS 50706 ATLAS ESTEIO RS 901066 PINCEIS ATLAS - BAIR 911623"},{"id":"2a4130d1-6c63-4e95-5b6f-08d5ad2bf6ba","name":"BETTANIN S.A.","commercialName":"","cnpj":"89724447000117","city":"ESTEIO","stateCode":"RS","buscaAdicional":"BETTANIN 50704 BETTANIN 899834"},{"id":"83df9031-ea57-4079-562d-08d5ad2bf6ba","name":"UNIDASUL DISTRIBUIDORA ALIMENTICIA S/A","commercialName":"","cnpj":"07718633000189","city":"ESTEIO","stateCode":"RS","buscaAdicional":"UNIDASUL 6721 UNIDASUL ESTEIO 72190 UNIDASUL 891302 UNIDASUL FILIAL 38 903445 UNIDASUL FILIAL 43 903456 UNIDASUL FILIAL 59 904213 UNIDASUL FILIAL 35 904505 UNIDASUL FILIAL 27 904583 UNIDASUL FILIAL 32 906320 UNIDASUL FILIAL 54 907641 UNIDASUL FILIAL 03 907838 UNIDASUL FILIAL 28 907857 UNIDASUL FILIAL 24 907871 UNIDASUL FILIAL 02 908203 UNIDASUL 19 909323 UNIDASUL 01 909371 UNIDASUL FILIAL 06 909935 UNIDASUL FILIAL 63 910513 UNIDASUL FILIAL 30 911894 UNIDASUL FILIAL 60 912480 UNIDASUL FILIAL 55 912591"},{"id":"49bc0117-6889-4807-57d3-08d5ad2bf6ba","name":"SAINT-GOBAIN DO BRASIL PRODUTOS INDUSTRIAIS E PARA CONSTRUCAO LTDA","commercialName":"FABRICA ESTEIO","cnpj":"61064838000486","city":"ESTEIO","stateCode":"RS","buscaAdicional":"SGBRAS ESTEIO 9710 S GOBAIN ESTEIO 889249"},{"id":"5d813630-6378-4c60-50bf-08d5ad2bf6ba","name":"SOLAE DO BRASIL INDUSTRIA E COMERCIO DE ALIMENTOS LTDA","commercialName":"","cnpj":"05547514000185","city":"ESTEIO","stateCode":"RS","buscaAdicional":"SOLAE 1816 SOLAE ESTEIO RS 70312"},{"id":"de2b00df-f4cd-4cce-5b89-08d5ad2bf6ba","name":"PLASTRELA EMBALAGENS FLEXIVEIS LTDA","commercialName":"","cnpj":"90816133000557","city":"ESTRELA","stateCode":"RS","buscaAdicional":"PLASTRELA 50755 PLASTRELA EMBALAGENS 900000"},{"id":"342aa97e-4cbc-48e6-5c3a-08d5ad2bf6ba","name":"BRASILATA S A EMBALAGENS METALICAS","commercialName":"BRASILATA","cnpj":"61160438000636","city":"ESTRELA","stateCode":"RS","buscaAdicional":"BRASILATA RS 51200 BRASILATA RS 899200"},{"id":"28961231-5520-4ef2-5ad4-08d5ad2bf6ba","name":"COOPERATIVA LANGUIRU LTDA.","commercialName":"","cnpj":"89774160002650","city":"ESTRELA","stateCode":"RS","buscaAdicional":"LANGUIRU 50271 COOP LANGUIRI 899184"},{"id":"d3e22156-1b24-4c67-5f61-08d5ad2bf6ba","name":"LATICINIOS VALE DO TAQUARI LTDA","commercialName":"LATIVALE","cnpj":"89772842000175","city":"ESTRELA","stateCode":"RS","buscaAdicional":"LATIVALE 52923 TANGARA LATIVALE 902977"},{"id":"1313a18f-aa12-46d4-680d-08d5ad2bf6ba","name":"ROTA INDUSTRIA GRAFICA LTDA","commercialName":"ROTA","cnpj":"04833443000114","city":"ESTRELA","stateCode":"RS","buscaAdicional":"ROTA 59232 ROTA INDUSTRIA GRAFI 910114"},{"id":"6d87e04c-fe7e-4429-6669-08d5ad2bf6ba","name":"INDUSTRIA DE ALIMENTOS ESTRELA S.A.","commercialName":"","cnpj":"07510884000254","city":"ESTRELA","stateCode":"RS","buscaAdicional":"LATVIDA 57533 ESTRELA ALIMENTOS 910373"},{"id":"9137d5a8-5f5a-42d5-66ed-08d5ad2bf6ba","name":"MULTICOLOR - INDUSTRIA E COMERCIO DE PIGMENTOS LTDA.","commercialName":"","cnpj":"89142103000108","city":"FARROUPILHA","stateCode":"RS","buscaAdicional":"MULTICOLOR IND 57888 MULTICOLOR IND 908615"},{"id":"3584457f-d697-4d9f-6920-08d5ad2bf6ba","name":"FRIGOFAR INDUSTRIA DE ALIMENTOS LTDA","commercialName":"","cnpj":"08725249000176","city":"FARROUPILHA","stateCode":"RS","buscaAdicional":"FRIGOFAR 60780 FRIGOFAR IND DE ALIM 911917"},{"id":"6c2602f8-4cef-4429-62ab-08d5ad2bf6ba","name":"SUL PET PLASTICOS LTDA","commercialName":"SUL PET","cnpj":"02857584000141","city":"FARROUPILHA","stateCode":"RS","buscaAdicional":"SUL PET 54913 SUL PET 904330"},{"id":"35547ad1-45d1-4996-5f93-08d5ad2bf6ba","name":"SOPRANO FECHADURAS E FERRAGENS S.A.","commercialName":"","cnpj":"24334092000104","city":"FARROUPILHA","stateCode":"RS","buscaAdicional":"SOPRANO FERRAGENS 53037 SOPRANO-METALICOS 70574 SOPRANO - GALVANICA 895665"},{"id":"847d7afb-924f-453e-5ee7-08d5ad2bf6ba","name":"CARRER ALIMENTOS LTDA","commercialName":"CARRER ALIMENTOS - FILIAL 1","cnpj":"07520001000700","city":"FARROUPILHA","stateCode":"RS","buscaAdicional":"CARRER FARROUPILHA 52605 CARRER ALIMENTOS LTD 903985"},{"id":"0c6f0fd3-1032-45c8-6090-08d5ad2bf6ba","name":"PIOMADE INDUSTRIA DE MADEIRAS LTDA","commercialName":"","cnpj":"94970241000107","city":"FARROUPILHA","stateCode":"RS","buscaAdicional":"PIOMADE 53588 PIOMADE 902260"},{"id":"7b38be52-dafa-4349-5840-08d5ad2bf6ba","name":"MULTINOVA - INDUSTRIA DE EMBALAGENS PLASTICAS LTDA.","commercialName":"","cnpj":"92475250000104","city":"FARROUPILHA","stateCode":"RS","buscaAdicional":"MULTINOVA 11110 MULTINOVA FRP 890212"},{"id":"8b1295d8-9d7a-462c-57f5-08d5ad2bf6ba","name":"GOLDEN SUCOS LTDA","commercialName":"","cnpj":"73420986000122","city":"FARROUPILHA","stateCode":"RS","buscaAdicional":"GOLDEN SUCOS 10249 GOLDEN SUCOS 889231"},{"id":"0b9a7c1a-a5b9-4741-52f9-08d5ad2bf6ba","name":"BIGFER-INDUSTRIA E COMERCIO DE FERRAGENS LTDA","commercialName":"","cnpj":"92534593000194","city":"FARROUPILHA","stateCode":"RS","buscaAdicional":"BIGFER 3393 BIGFER FARROUPILHA 71090 BIGFER UNID. LEMA 71360 BIGFER VICENTINA 889318"},{"id":"29a17cb6-a612-489b-5159-08d5ad2bf6ba","name":"TRAMONTINA FARROUPILHA SA INDUSTRIA METALURGICA","commercialName":"","cnpj":"87834883000113","city":"FARROUPILHA","stateCode":"RS","buscaAdicional":"TRAMONTINA FRP 2132 TRAMONTINA-FARROUP 71861"},{"id":"18dd3250-89ac-43a4-519b-08d5ad2bf6ba","name":"SOPRANO ELETROMETALURGICA E HIDRAULICA LTDA","commercialName":"","cnpj":"88634977000101","city":"FARROUPILHA","stateCode":"RS","buscaAdicional":"SOPRANO 2428 SOPRANO PLASTICO-FRP 71547"},{"id":"47055314-b0b8-49da-5753-08d5ad2bf6ba","name":"FUNDIFAR METALURGIA LTDA","commercialName":"","cnpj":"07498804000101","city":"FARROUPILHA","stateCode":"RS","buscaAdicional":"FUNDIFAR 8569 FUNDIFAR METALURGICA 888603"},{"id":"e1cb0284-eb72-41d1-55cf-08d5ad2bf6ba","name":"TECNOVIDRO INDUSTRIA DE VIDROS LTDA","commercialName":"","cnpj":"91514836000160","city":"FARROUPILHA","stateCode":"RS","buscaAdicional":"TECNOVIDRO 6181 TECNOVIDROS-FARROUP 71908"},{"id":"6d1b6ab3-3f7e-4182-54d0-08d5ad2bf6ba","name":"PLASTICOS ITALIA LTDA","commercialName":"","cnpj":"92534635000197","city":"FARROUPILHA","stateCode":"RS","buscaAdicional":"PLAST ITALIA 4513 PLAST ITALIA FRPILHA 71626"},{"id":"d0b778ea-7392-4b4e-53ca-08d5ad2bf6ba","name":"ITM - INDUSTRIAS TEXTEIS H. MILAGRE LTDA","commercialName":"","cnpj":"89842439000175","city":"FARROUPILHA","stateCode":"RS","buscaAdicional":"ITM 3854 ITM FARROUPILHA 71348"},{"id":"87e5e704-61d2-4b15-5378-08d5ad2bf6ba","name":"MAQUINAS SAZI LTDA","commercialName":"","cnpj":"90064288000150","city":"FARROUPILHA","stateCode":"RS","buscaAdicional":"SAZI 3645 MAQUINAS SAZI LTDA 71240"},{"id":"ef18dd5f-c1d8-4236-5376-08d5ad2bf6ba","name":"FRIGORIFICO CHESINI LTDA","commercialName":"FRIGORIFICO CHESINI","cnpj":"89848782000127","city":"FARROUPILHA","stateCode":"RS","buscaAdicional":"CHESINI 3642 CHESINI FARROUPILHA 71195"},{"id":"a307d972-ced3-4ab8-5a0e-08d5ad2bf6ba","name":"NOVA PALMA ENERGIA LTDA","commercialName":"NOVA PALMA ENERGIA","cnpj":"89889604000144","city":"FAXINAL DO SOTURNO","stateCode":"RS","buscaAdicional":"NOVA PALMA 16424 NOVA PALMA ENERGIA 909457"},{"id":"a3b65dc1-7f84-489c-54a3-08d5ad2bf6ba","name":"HIDRO JET EQUIPAMENTOS HIDRAULICOS LTDA","commercialName":"HIDRO JET","cnpj":"90952052000150","city":"FELIZ","stateCode":"RS","buscaAdicional":"HIDRO JET FELIZ 4405 HIDRO JET-FELIZ 71669"},{"id":"0323c604-2b44-4bd6-56aa-08d5ad2bf6ba","name":"LAURO WEBER & CIA LTDA","commercialName":"","cnpj":"03682759000270","city":"FELIZ","stateCode":"RS","buscaAdicional":"PLASTIWEBER 7481 LAURO WEBBER-FELIZ 72276"},{"id":"c6fa86cd-df32-44a4-566c-08d5ad2bf6ba","name":"SOCIEDADE DE BEBIDAS PANIZZON LTDA","commercialName":"","cnpj":"89962773000162","city":"FLORES DA CUNHA","stateCode":"RS","buscaAdicional":"PANIZZON VINHOS 7060 PANIZZONV SUCO-FLOR 72185"},{"id":"a7137d50-faac-48f8-5742-08d5ad2bf6ba","name":"VINHEDOS INDUSTRIA E COMERCIO DE PAPEIS EIRELI","commercialName":"VINHEDOS","cnpj":"01039778000177","city":"FLORES DA CUNHA","stateCode":"RS","buscaAdicional":"VINHEDOS 8450 VINHEDOS FC 888323 VINHEDOS SC 910252"},{"id":"0aee9c26-52cd-4b82-56eb-08d5ad2bf6ba","name":"TREBOLL MOVEIS LTDA","commercialName":"","cnpj":"01776625000102","city":"FLORES DA CUNHA","stateCode":"RS","buscaAdicional":"TREBOLL 7989 TREBOLL 72432"},{"id":"54f5e371-6c22-40db-56e7-08d5ad2bf6ba","name":"FABRICA DE MOVEIS FLORENSE LTDA","commercialName":"","cnpj":"89962294000146","city":"FLORES DA CUNHA","stateCode":"RS","buscaAdicional":"FLORENSE 7941 FLORENSE RS 888191"},{"id":"6799e765-4243-49fe-56ee-08d5ad2bf6ba","name":"MINERACAO FLORENSE LTDA","commercialName":"","cnpj":"94580479000126","city":"FLORES DA CUNHA","stateCode":"RS","buscaAdicional":"MINFLORENSE 8001 MINERACAO FLORENSE 888397"},{"id":"155955e0-947b-4c8a-54db-08d5ad2bf6ba","name":"PANIZZON INDUSTRIA E COMERCIO DE PLASTICOS LTDA","commercialName":"PLASTICOS PANIZZON","cnpj":"92333822000102","city":"FLORES DA CUNHA","stateCode":"RS","buscaAdicional":"PANIZZON PLASTICOS 4545 PANIZZON-F DA CUNHA 71632"},{"id":"69d270c2-d031-4dd8-5562-08d5ad2bf6ba","name":"KEKO ACESSORIOS S.A","commercialName":"","cnpj":"91013698000135","city":"FLORES DA CUNHA","stateCode":"RS","buscaAdicional":"KEKO 5472 KEKO-F DA CUNHA 71791"},{"id":"cb7ca2a6-35dc-40d3-5a08-08d5ad2bf6ba","name":"MARIA PIANA GERACAO DE ENERGIA SA","commercialName":"","cnpj":"19280354000165","city":"FLORES DA CUNHA","stateCode":"RS","buscaAdicional":"CGH DONA MARIA PIANA 16382 DONA MARIA PIANA 8782 CGH.PH.RS.028204-9.01"},{"id":"c97a3925-832b-4fac-6349-08d5ad2bf6ba","name":"COOPERATIVA AGROINDUSTRIAL NOVA ALIANCA LTDA","commercialName":"","cnpj":"88612486000160","city":"FLORES DA CUNHA","stateCode":"RS","buscaAdicional":"NOVA ALIANCA 55289 COOP NOVA ALIANCA 904944"},{"id":"05ce3dc0-d30a-48da-5b43-08d5ad2bf6ba","name":"ABATEDOURO DE FRANGOS PIOVESAN LTDA","commercialName":"","cnpj":"03142670000130","city":"FREDERICO WESTPHALEN","stateCode":"RS","buscaAdicional":"PIOVESAN 50554 ABATEDOURO PIOVESAN 901009"},{"id":"dce81d9c-7f8c-4580-5ba3-08d5ad2bf6ba","name":"MADEM SA INDUSTRIA E COMERCIO DE MADEIRAS E EMBALAGENS","commercialName":"","cnpj":"87547238000110","city":"GARIBALDI","stateCode":"RS","buscaAdicional":"MADEM 50805 MADEM 898060"},{"id":"0355d6e0-9411-4bd0-586a-08d5ad2bf6ba","name":"NUTRIRE INDUSTRIA DE ALIMENTOS LTDA","commercialName":"NUTRIRE","cnpj":"04693895000148","city":"GARIBALDI","stateCode":"RS","buscaAdicional":"NUTRIRE 11709 NUTRIRE GARIBALDI 891863 NUTRIRE POCOS CALDAS 908200"},{"id":"274341fb-e25a-42a2-60b9-08d5ad2bf6ba","name":"PABOVI INDUSTRIA DE PLASTICOS LTDA","commercialName":"","cnpj":"90586413000192","city":"GARIBALDI","stateCode":"RS","buscaAdicional":"PABOVI 53648 PABOVI 904817"},{"id":"b9fa1ef1-70ab-4308-5db9-08d5ad2bf6ba","name":"MODELO VIDROS INDUSTRIA E COMERCIO LTDA","commercialName":"MODELO VIDROS INDUSTRIA E COMERCIO LTDA","cnpj":"93740801000174","city":"GARIBALDI","stateCode":"RS","buscaAdicional":"MODELO VIDROS 51967 MODELO VIDROS 900704"},{"id":"8dec5835-15a7-4fc5-554f-08d5ad2bf6ba","name":"METALURGICA SIMONAGGIO LTDA","commercialName":"","cnpj":"87859278000105","city":"GARIBALDI","stateCode":"RS","buscaAdicional":"SIMONAGGIO 5310 SIMONAGGIO-GARIBALDI 71783"},{"id":"48fb2450-cf4d-47e0-537f-08d5ad2bf6ba","name":"FRIGORIFICO NICOLINI LTDA","commercialName":"","cnpj":"89751036000110","city":"GARIBALDI","stateCode":"RS","buscaAdicional":"NICOLINI 3659 FRIG NIC GARIBALDI 71266"},{"id":"949865fb-c6ce-4e92-5701-08d5ad2bf6ba","name":"ALEPLAST EMBALAGENS PLASTICAS LTDA.","commercialName":"","cnpj":"01737383000148","city":"GARIBALDI","stateCode":"RS","buscaAdicional":"ALEPLAST 8123 ALEPLAST EMBALAGENS 888315"},{"id":"71c3fe61-6262-4da5-57f0-08d5ad2bf6ba","name":"COOPERATIVA VINICOLA GARIBALDI LTDA","commercialName":"","cnpj":"90049156000150","city":"GARIBALDI","stateCode":"RS","buscaAdicional":"VINICOLA GARIBALDI 10150 VINICOLA GARIBALDI 889548"},{"id":"a60fec68-34ff-46ed-5168-08d5ad2bf6ba","name":"TRAMONTINA GARIBALDI SA INDUSTRIA METALURGICA","commercialName":"","cnpj":"90049792000181","city":"GARIBALDI","stateCode":"RS","buscaAdicional":"TRAMONTINA GDI 2156 TRAMONTINA GARIBALD 70512 TRAMONTINA GDI CENTR 70513"},{"id":"edb2feb1-44bf-4df4-51fb-08d5ad2bf6ba","name":"TELASUL INDUSTRIA DE MOVEIS LTDA","commercialName":"","cnpj":"87846796000186","city":"GARIBALDI","stateCode":"RS","buscaAdicional":"TELASUL EI 2768 TELASUL 70712"},{"id":"bcb15cdb-a93a-430a-50c7-08d5ad2bf6ba","name":"METALURGICA MARTINAZZO LTDA","commercialName":"MARTINAZZO","cnpj":"91505230000168","city":"GARIBALDI","stateCode":"RS","buscaAdicional":"MARTINAZZO 1844 MARTINAZZO-GARIBALDI 70209"},{"id":"3298443f-530b-45f0-636a-08d5ad2bf6ba","name":"BORTOLINI INDUSTRIA DE MOVEIS LTDA","commercialName":"","cnpj":"90051160000152","city":"GARIBALDI","stateCode":"RS","buscaAdicional":"BORTOLINI 55343 BORTOLINI 904818"},{"id":"25237365-0baa-41e6-5f97-08d5ad2bf6ba","name":"WARPOL AGROINDUSTRIAL LTDA","commercialName":"","cnpj":"03714600000614","city":"GIRUÁ","stateCode":"RS","buscaAdicional":"WARPOL 53041 WARPOL 900845"},{"id":"ad084700-c665-4cfd-567c-08d5ad2bf6ba","name":"FAMASTIL PRAT K MOVEIS E FERRAMENTAS LTDA","commercialName":"FAMASTIL","cnpj":"90260985000187","city":"GRAMADO","stateCode":"RS","buscaAdicional":"FAMASTILM 7200 FAMASTIL MTZ GRAMADO 72172"},{"id":"ad919ca4-4f37-436a-567d-08d5ad2bf6ba","name":"PRAT-K UTILIDADES LIMITADA","commercialName":"","cnpj":"06237807000129","city":"GRAMADO","stateCode":"RS","buscaAdicional":"PRATK 7202 PRAT K - GRAMADO 72184"},{"id":"90c1a124-cfe1-4719-5510-08d5ad2bf6ba","name":"SIERRA MOVEIS LTDA","commercialName":"","cnpj":"92726785000100","city":"GRAMADO","stateCode":"RS","buscaAdicional":"SIERRA 4982 SIERRA-GRAMADO 71778"},{"id":"7bbcd984-03f2-44e7-670a-08d5ad2bf6ba","name":"DI SOLLE CUTELARIA LTDA","commercialName":"","cnpj":"01256141000132","city":"GRAMADO","stateCode":"RS","buscaAdicional":"DI SOLLE 57935 DI SOLLE CUTELARIA 909259"},{"id":"89700356-dcec-49f7-68a0-08d5ad2bf6ba","name":"MINERACAO VERA CRUZ LTDA","commercialName":"PEDRA MINERACAO E PAVIMENTACAO","cnpj":"92587062000160","city":"GRAVATAÍ","stateCode":"RS","buscaAdicional":"MINERACAO VERA CRUZ 60215 MINERACAO VERA CRUZ 910152"},{"id":"41e392d1-33b3-4f75-68b6-08d5ad2bf6ba","name":"PANATLANTICA S.A.","commercialName":"PANATLANTICA","cnpj":"92693019000189","city":"GRAVATAÍ","stateCode":"RS","buscaAdicional":"PANATLANTICA GRAV 60310 PANATLANTICA 910361"},{"id":"d0fe0a73-5803-4f63-6427-08d5ad2bf6ba","name":"CARLOS BECKER METALURGICA INDUSTRIAL LTDA","commercialName":"","cnpj":"92752468000150","city":"GRAVATAÍ","stateCode":"RS","buscaAdicional":"CARLOS BECKER 55859 CARLOS BECKER METAL 906498"},{"id":"68213d3a-840a-47fe-6201-08d5ad2bf6ba","name":"BIMBO DO BRASIL LTDA","commercialName":"BIMBO","cnpj":"35402759005810","city":"GRAVATAÍ","stateCode":"RS","buscaAdicional":"BIMBO RS 54502 BIMBO GRAVATAI 904813"},{"id":"c2a8049a-3f46-42ec-53b3-08d5ad2bf6ba","name":"DANA SPICER INDUSTRIA E COMERCIO DE AUTOPECAS LTDA","commercialName":"","cnpj":"61091963000132","city":"GRAVATAÍ","stateCode":"RS","buscaAdicional":"DANA SPICER 3780 DANA SPICER - DIADM 7852"},{"id":"3c707444-0ecd-40a3-50a5-08d5ad2bf6ba","name":"CERVEJARIAS KAISER BRASIL S.A.","commercialName":"","cnpj":"19900000000508","city":"GRAVATAÍ","stateCode":"RS","buscaAdicional":"KAISER RS 1764 KAISER-GRAVATAI-RS 70193"},{"id":"2f1bfc29-f4f0-4dd7-5107-08d5ad2bf6ba","name":"PELZER SISTEMAS DO BRASIL LTDA","commercialName":"","cnpj":"02403175000175","city":"GRAVATAÍ","stateCode":"RS","buscaAdicional":"PELZERGRAVATAI 1951 PELZER SISTEMAS 70302"},{"id":"1e7226eb-211d-4bdb-506f-08d5ad2bf6ba","name":"EPCOS DO BRASIL LTDA.","commercialName":"","cnpj":"90285958000169","city":"GRAVATAÍ","stateCode":"RS","buscaAdicional":"EPCOS 1624 EPCOS GRAVATAI RS 70067"},{"id":"946b41f5-8719-42ec-5142-08d5ad2bf6ba","name":"MUNDIAL S.A. - PRODUTOS DE CONSUMO","commercialName":"","cnpj":"88610191003927","city":"GRAVATAÍ","stateCode":"RS","buscaAdicional":"MUNDIAL 2075 MUNDIAL 70437"},{"id":"315d15e6-2d6e-4a8a-5ca0-08d5ad2bf6ba","name":"PERTO S A PERIFERICOS PARA AUTOMACAO","commercialName":"","cnpj":"92080035000104","city":"GRAVATAÍ","stateCode":"RS","buscaAdicional":"PERTO 51440 PERTO 899350"},{"id":"af88d30e-b830-4bd2-5933-08d5ad2bf6ba","name":"ASTORIA PAPEIS LTDA","commercialName":"ASTORIA","cnpj":"90792797000108","city":"GRAVATAÍ","stateCode":"RS","buscaAdicional":"ASTORIA 14115 ASTORIA 893202"},{"id":"7aec600c-12f2-4d63-5c4d-08d5ad2bf6ba","name":"PROMETEON TYRE GROUP INDUSTRIA BRASIL LTDA.","commercialName":"","cnpj":"22301988000595","city":"GRAVATAÍ","stateCode":"RS","buscaAdicional":"TP PNEUS GRAVATAI 51256 TP PNEUS GRAVATAI 71373"},{"id":"af380bc3-142b-497c-5bdc-08d5ad2bf6ba","name":"GUABIJU PLASTICOS LTDA","commercialName":"","cnpj":"05666650000194","city":"GUABIJU","stateCode":"RS","buscaAdicional":"GUABIJU 50949 GUABIJU 900027"},{"id":"0e8cc333-1c15-4c73-5eb8-08d5ad2bf6ba","name":"INBRAPE TECIDOS INDUSTRIAIS LTDA","commercialName":"","cnpj":"04283165000179","city":"GUAÍBA","stateCode":"RS","buscaAdicional":"INBRAPE 52523 INBRAPE 902717"},{"id":"c11043b3-9d93-4e87-5284-08d5ad2bf6ba","name":"CMPC CELULOSE RIOGRANDENSE LTDA","commercialName":"CELULOSE RIOGRANDENSE","cnpj":"11234954000185","city":"GUAÍBA","stateCode":"RS","buscaAdicional":"CMPC APE 3100 CMPC (REDE BASICA) 893962 CMPC 895483 UTE.FL.RS.030666-5.01"},{"id":"ed305612-ea3d-4d35-569f-08d5ad2bf6ba","name":"CELUPA INDUSTRIAL CELULOSE E PAPEL GUAIBA LTDA","commercialName":"CELUPA","cnpj":"92788009000127","city":"GUAÍBA","stateCode":"RS","buscaAdicional":"CELUPA 7341 CELUPA-GUAIBA 72244"},{"id":"9c5b8eae-54c2-47c2-5454-08d5ad2bf6ba","name":"SAO PAULO ENERGETICA S/A","commercialName":"","cnpj":"07726782000190","city":"GUAPORÉ","stateCode":"RS","buscaAdicional":"SAO PAULO 4168 SAO PAULO 8978 PCH.PH.RS.029067-0.01"},{"id":"ab2d4d0a-6759-40ae-556e-08d5ad2bf6ba","name":"SULMAQ INDUSTRIAL E COMERCIAL SA","commercialName":"","cnpj":"87861324000100","city":"GUAPORÉ","stateCode":"RS","buscaAdicional":"SULMAQ MAT 5609 SULMAQ FIL-GUAPORE 71891"},{"id":"74f9e356-dce4-437f-5ad2-08d5ad2bf6ba","name":"COOPERATIVA DOS SUINOCULTORES DO CAI SUPERIOR LTDA","commercialName":"OURO DO SUL","cnpj":"91360420000134","city":"HARMONIA","stateCode":"RS","buscaAdicional":"OURODOSUL 50269 OURODOSUL 899168"},{"id":"6732b9b0-0270-4a57-5073-08d5ad2bf6ba","name":"JOHN DEERE BRASIL LTDA","commercialName":"JOHN DEERE","cnpj":"89674782000158","city":"HORIZONTINA","stateCode":"RS","buscaAdicional":"JDB HZ 1633 JOHN DEERE-HORIZONT. 7168"},{"id":"576ecc79-be56-49c6-52ff-08d5ad2bf6ba","name":"PAMPEANO ALIMENTOS S/A","commercialName":"PAMPEANO","cnpj":"35768720000186","city":"HULHA NEGRA","stateCode":"RS","buscaAdicional":"PAMPEANO 3427 PAMPEANO ALIMENTOS 71388"},{"id":"821146e0-1729-4905-5dc2-08d5ad2bf6ba","name":"BOCCHI INDUSTRIA E COMERCIO DE CEREAIS LTDA","commercialName":"BOCCHI AGROBIOS","cnpj":"02987873000165","city":"IBIRAIARAS","stateCode":"RS","buscaAdicional":"BOCCHI AGROBIOS 51979 BOCCHI UNID 1 899901 BOCCHI UNID 2 899903"},{"id":"fc886139-8b6e-4105-5963-08d5ad2bf6ba","name":"BME ENERGIA S/A","commercialName":"BME ENERGIA","cnpj":"08696648000156","city":"IBIRUBÁ","stateCode":"RS","buscaAdicional":"BME ENERGIA 14395 ERNESTO JORGE DREHER 8537 PCH.PH.RS.029245-1.01 HENRIQUE KOTZIAN 8737 PCH.PH.RS.029246-0.01"},{"id":"5210cdcc-8d7a-43cd-536a-08d5ad2bf6ba","name":"COPREL COOPERATIVA DE GERACAO DE ENERGIA E DESENVOLVIMENTO","commercialName":"COPREL GERACAO E DESENVOLVIMENTO","cnpj":"08323274000123","city":"IBIRUBÁ","stateCode":"RS","buscaAdicional":"COPREL GERACAO 3622 USINA DO POSTO 8732 CGH.PH.RS.028915-9.01 COTOVELO DO JACUI 8734 PCH.PH.RS.000877-0.01 CASCATA PINHEIRINHO 8735 CGH.PH.RS.000706-4.01"},{"id":"150ee599-2129-4848-5dd0-08d5ad2bf6ba","name":"USAFLEX - INDUSTRIA & COMERCIO S/A","commercialName":"USAFLEX-CALCADOS","cnpj":"86900925000104","city":"IGREJINHA","stateCode":"RS","buscaAdicional":"USAFLEX 52002 USAFLEX 903762"},{"id":"e46330e8-12b7-48ba-5ddd-08d5ad2bf6ba","name":"CALCADOS BEIRA RIO S/A","commercialName":"","cnpj":"88379771000263","city":"IGREJINHA","stateCode":"RS","buscaAdicional":"BEIRA RIO IG 52028 CALCADOS BEIRA RIO 902474"},{"id":"77341f4c-b6da-4578-6259-08d5ad2bf6ba","name":"A. GRINGS S.A.","commercialName":"PICCADILLY COMPANY","cnpj":"97755177000130","city":"IGREJINHA","stateCode":"RS","buscaAdicional":"PICCADILLY 54693 A GRINGS SA 905346 A GRINGS SA 2 905347 PICCADILLY FILIAL 8 912535"},{"id":"9b708371-107c-419b-639c-08d5ad2bf6ba","name":"AGRO LATINA LTDA","commercialName":"","cnpj":"88320536000135","city":"IGREJINHA","stateCode":"RS","buscaAdicional":"AGRO LATINA 55482 AGRO LATINA LTDA 905370"},{"id":"77f185de-89a2-44f1-596e-08d5ad2bf6ba","name":"DEPARTAMENTO MUNICIPAL DE ENERGIA DE IJUI GERACAO","commercialName":"DEMEI GERACAO","cnpj":"19462106000135","city":"IJUÍ","stateCode":"RS","buscaAdicional":"DEMEI-GERACAO 14495 PASSO DO AJURICABA 889138 UHE.PH.RS.001997-6.02"},{"id":"9f85f508-b997-4700-537e-08d5ad2bf6ba","name":"COOPERATIVA DE GERACAO DE ENERGIA E DESENVOLVIMENTO SOCIAL LTDA.","commercialName":"CERILUZ GERACAO","cnpj":"08290060000106","city":"IJUÍ","stateCode":"RS","buscaAdicional":"CERILUZ GER 3658 LINHA 3 LESTE 8741 PCH.PH.RS.028231-6.01 NILO BONFANTI 8800 CGH.PH.RS.029022-0.01 PCH RS-155 20074 PCH.PH.RS.030525-1.01"},{"id":"c409183e-6ce5-4922-5f50-08d5ad2bf6ba","name":"BERTOLINI - INDUSTRIA QUIMICA LTDA","commercialName":"","cnpj":"90051996000157","city":"IMIGRANTE","stateCode":"RS","buscaAdicional":"GOTA LIMPA 52900 GOTA LIMPA 904130"},{"id":"2196cc21-35a1-41c4-66af-08d5ad2bf6ba","name":"METALURGICA HASSMANN SA","commercialName":"","cnpj":"89772065000169","city":"IMIGRANTE","stateCode":"RS","buscaAdicional":"HASSMANN 57743 METALURGICA HASSMANN 909328"},{"id":"e943d466-317f-4bae-6598-08d5ad2bf6ba","name":"DELLA PASQUA ENGENHARIA E CONSTRUCOES LTDA","commercialName":"","cnpj":"00093197000231","city":"ITAARA","stateCode":"RS","buscaAdicional":"DELLA PASQUA 56853 DELLA PASQUA FL 1 909674"},{"id":"ab66da58-fbd7-4dc3-5be2-08d5ad2bf6ba","name":"JOSAPAR JOAQUIM OLIVEIRA SA PARTICIPACOES","commercialName":"SUPRARROZ INDUSTRIA E COMERCIO ITAQUI","cnpj":"87456562000807","city":"ITAQUI","stateCode":"RS","buscaAdicional":"JOSAPAR ITAQUI 50972 JOSAPAR 899743"},{"id":"c83fcad2-d487-4e36-5b6d-08d5ad2bf6ba","name":"HERCOSUL ALIMENTOS LTDA","commercialName":"HERCOSUL","cnpj":"03252545000183","city":"IVOTI","stateCode":"RS","buscaAdicional":"HERCOSUL 50702 HERCOSUL 901506 HERCOSUL FILIAL 03 909472"},{"id":"601a1947-dcbc-4750-56ed-08d5ad2bf6ba","name":"A BUHLER SA CURTUME","commercialName":"","cnpj":"89716583000165","city":"IVOTI","stateCode":"RS","buscaAdicional":"ABUHLER 8000 A BUHLER CURTUME 888274"},{"id":"c1773189-9b3d-429a-68b7-08d5ad2bf6ba","name":"SEAN COUROS LTDA","commercialName":"","cnpj":"90329178000173","city":"IVOTI","stateCode":"RS","buscaAdicional":"SEAN COUROS 60311 SEAN COUROS 911912"},{"id":"31ed0d91-a2af-4402-5024-08d5ad2bf6ba","name":"JAGUARI ENERGETICA SA","commercialName":"","cnpj":"04324226000107","city":"JAGUARI","stateCode":"RS","buscaAdicional":"JESA - JAGUARI 1475 FURNAS DO SEGREDO 8098 PCH.PH.RS.001009-0.01"},{"id":"2411fe6a-c902-4987-570b-08d5ad2bf6ba","name":"NUTRIZ - INDUSTRIA E COMERCIO DE ALIMENTOS LTDA","commercialName":"","cnpj":"05472650000153","city":"LAGOA VERMELHA","stateCode":"RS","buscaAdicional":"NUTRIZ 8166 NUTRIZ 72440"},{"id":"784cb041-b77d-47d2-5809-08d5ad2bf6ba","name":"BARCELLONA INDUSTRIA E COMERCIO DE MOVEIS LTDA.","commercialName":"","cnpj":"02708439000107","city":"LAGOA VERMELHA","stateCode":"RS","buscaAdicional":"BARCELLONA 10452 BARCELLONA 889632"},{"id":"518ebaea-1a9e-491a-5dd1-08d5ad2bf6ba","name":"MOVEIS RODIAL LTDA","commercialName":"","cnpj":"91062497000128","city":"LAGOA VERMELHA","stateCode":"RS","buscaAdicional":"RODIAL 52011 RODIAL 903781"},{"id":"6c3dd8ff-32fd-49e6-6390-08d5ad2bf6ba","name":"MOVEIS DORIPEL LTDA","commercialName":"","cnpj":"90608084000133","city":"LAGOA VERMELHA","stateCode":"RS","buscaAdicional":"DORIPEL 55469 MOVEIS DORIPEL LTDA 907375"},{"id":"6885c083-4392-47d0-6907-08d5ad2bf6ba","name":"SORVEBOM INDUSTRIAL LTDA","commercialName":"SORVEBOM","cnpj":"01967318000109","city":"LAJEADO","stateCode":"RS","buscaAdicional":"SORVEBOM 60723 SORVEBOM INDUSTRIAL 912024"},{"id":"bd4ae0f4-7faa-4878-66b1-08d5ad2bf6ba","name":"SOCIEDADE BENEFICENCIA E CARIDADE DE LAJEADO","commercialName":"HOSPITAL BRUNO BORN","cnpj":"91162511000165","city":"LAJEADO","stateCode":"RS","buscaAdicional":"HOSPITAL BRUNO BORN 57745 HOSPITAL BRUNO BORN 910854"},{"id":"2e9b1754-ed6e-4009-8db3-08d5d060706e","name":"SINDICATO DOS TRABALHADORES RURAIS DE LAJEADO","commercialName":"","cnpj":"91165829000108","city":"LAJEADO","stateCode":"RS","buscaAdicional":"STR 63117 STR 1 913481 STR 2 913482"},{"id":"7ed59480-8754-450c-73e7-08d5cf600bef","name":"MINUPAR PARTICIPACOES SA","commercialName":"MINUANO","cnpj":"90076886000140","city":"LAJEADO","stateCode":"RS","buscaAdicional":""},{"id":"486297fd-0b5b-4b91-1ca7-08d5b8870181","name":"INDUSTRIA DE VINAGRES PRINZ LTDA","commercialName":"","cnpj":"91154823000127","city":"LAJEADO","stateCode":"RS","buscaAdicional":"PRINZ 60431 INDUSTRIA DE VINAGRE 912780"},{"id":"7fc60ef8-93a6-467d-5f7f-08d5ad2bf6ba","name":"COMPANHIA MINUANO DE ALIMENTOS","commercialName":"MINUANO","cnpj":"84430800000132","city":"LAJEADO","stateCode":"RS","buscaAdicional":"MINUANO ALIMENTOS 52999 MINUANO - F2 905721 MINUANO INCUBATORIO 905726 MINUANO FAB DE RACOE 905733 MINUANO - F1 905734"},{"id":"90539b32-3ea6-4e79-5fd3-08d5ad2bf6ba","name":"ITALIANINHO ALIMENTOS LTDA","commercialName":"TRANSITAL","cnpj":"91784405000113","city":"LAJEADO","stateCode":"RS","buscaAdicional":"ITALIANINHO 53236 ITALIANINHO ALIMENTO 902327"},{"id":"5143001e-d51e-43ac-5fd6-08d5ad2bf6ba","name":"IMPORTADORA E EXPORTADORA DE CEREAIS SA","commercialName":"","cnpj":"91156471000149","city":"LAJEADO","stateCode":"RS","buscaAdicional":"IMEC 53239 IMEC 904936 IMEC MATRIZ 904940 IMEC MONTENEGRO I 905719 IMEC DOIS IRMAOS 906120 IMEC SANTA CRUZ 906122 IMEC SAO CRISTOVAO 906123 IMEC VENANCIO AIRES 906137 IMEC CACHOEIRA DO S 906138 IMEC DESCO 906483 IMEC RIO PARDO 2 906976"},{"id":"3ab0be21-5b8f-4491-5bb8-08d5ad2bf6ba","name":"REFRICOMP - INDUSTRIA DE COMPONENTES PARA REFRIGERACAO LTDA","commercialName":"REFRICOMP","cnpj":"07417647000162","city":"LAJEADO","stateCode":"RS","buscaAdicional":"REFRICOMP 50873 REFRICOMP 900008"},{"id":"cdf3b336-0759-4bff-5bfb-08d5ad2bf6ba","name":"DOCILE ALIMENTOS LTDA","commercialName":"","cnpj":"94261534000115","city":"LAJEADO","stateCode":"RS","buscaAdicional":"DOCILE ALIMENTOS 51009 DOCILE LAJEADO 899231"},{"id":"e2efd949-91a2-4c03-56dd-08d5ad2bf6ba","name":"BEBIDAS FRUKI S/A","commercialName":"","cnpj":"87315099000107","city":"LAJEADO","stateCode":"RS","buscaAdicional":"BEBIDAS FRUKI 7864 BEBIDAS FRUKI 72345 FRUKI - CD CANOAS 903413"},{"id":"6e1a32cb-a349-4c5e-54a9-08d5ad2bf6ba","name":"FUNDACAO VALE DO TAQUARI DE EDUCACAO E DESENVOLVIMENTO SOCIAL - FUVATES","commercialName":"UNIVERSIDADE DO VALE DO TAQUARI - UNIVATES","cnpj":"04008342000109","city":"LAJEADO","stateCode":"RS","buscaAdicional":"UNIVATES 4420 UNIVATES-LAJEADO RS 71657 UNIVATES 2 899666"},{"id":"a1e622c3-d7ca-412b-5ad8-08d5ad2bf6ba","name":"INDUSTRIA DE PELES MINUANO LTDA","commercialName":"","cnpj":"88148259000125","city":"LINDOLFO COLLOR","stateCode":"RS","buscaAdicional":"PELESMINUANO 50275 PELES MINUANO 898247"},{"id":"7efea563-f686-4cb5-5cad-08d5ad2bf6ba","name":"CALCADOS MALU LTDA","commercialName":"CALCADOS MALU","cnpj":"87018768001304","city":"LINDOLFO COLLOR","stateCode":"RS","buscaAdicional":"MALU 51502 CALCADOS MALU 901141"},{"id":"5ee3058e-a96d-456b-56ec-08d5ad2bf6ba","name":"FUGA COUROS SA","commercialName":"","cnpj":"91302349000133","city":"MARAU","stateCode":"RS","buscaAdicional":"FUGA COUROS 7990 FUGA BIOFUGA 890210 FUGA COUROS 888192 FUGA COUROS JALES I 902737 JALES 1 907028 FUGA COUROS HIDRO 904051 FUGA PARANAIBA 902754"},{"id":"e09d6598-329f-46c1-56e8-08d5ad2bf6ba","name":"INDUSTRIA DE PLASTICOS MARAU LTDA","commercialName":"PLASTIMARAU","cnpj":"91305730000156","city":"MARAU","stateCode":"RS","buscaAdicional":"PLASTIMARAU 7960 PLASTIMARAU 888624"},{"id":"50c94549-d4db-4850-57b8-08d5ad2bf6ba","name":"GSI BRASIL INDUSTRIA E COMERCIO DE EQUIPAMENTOS AGROPECUARIOS LTDA","commercialName":"","cnpj":"01770039000150","city":"MARAU","stateCode":"RS","buscaAdicional":"AGCO GSI 9429 AGCO GSI 889631"},{"id":"f2348710-1d6d-48d4-5147-08d5ad2bf6ba","name":"METASA SA INDUSTRIA METALURGICA","commercialName":"","cnpj":"88416482000106","city":"MARAU","stateCode":"RS","buscaAdicional":"METASA 2088 METASA MTZ MARAU RS 70477"},{"id":"7f80fc79-598c-4794-6248-08d5ad2bf6ba","name":"SIL - PLAST INDUSTRIA DE PLASTICOS LTDA","commercialName":"","cnpj":"08000956000103","city":"MARAU","stateCode":"RS","buscaAdicional":"SILPLAST 54672 SIL PLAST INDUSTRIA 904098"},{"id":"4d934e58-3de4-4621-64e6-08d5ad2bf6ba","name":"CEREAIS PEGER LTDA","commercialName":"","cnpj":"02394154000130","city":"MATA","stateCode":"RS","buscaAdicional":"PEGER 56299 CEREAIS PEGER 907248"},{"id":"005bd831-a6aa-4dba-5bd7-08d5ad2bf6ba","name":"CALCADOS BEIRA RIO S/A","commercialName":"","cnpj":"88379771000697","city":"MATO LEITÃO","stateCode":"RS","buscaAdicional":"BEIRARIOMT 50944 CALCADOS BEIRO RIO 899188"},{"id":"522a4e05-33df-400e-61db-08d5ad2bf6ba","name":"MAIS FRANGO MIRAGUAI LTDA","commercialName":"","cnpj":"08904113000123","city":"MIRAGUAÍ","stateCode":"RS","buscaAdicional":"MAIS FRANGO 54449 MAIS FRANGO MIRAGUAI 906315"},{"id":"88f70ac9-d585-4c0f-5880-08d5ad2bf6ba","name":"LAMIECCO PLASTICOS S.A.","commercialName":"LAMIECCO PLASTICOS LTDA","cnpj":"08889084000178","city":"MONTAURI","stateCode":"RS","buscaAdicional":"LAMIECCO 12072 LAMIECCO PLASTICOS 890441"},{"id":"c7b40f27-c940-4b18-5113-08d5ad2bf6ba","name":"DITALIA MOVEIS INDUSTRIAL LTDA","commercialName":"","cnpj":"73289050000104","city":"MONTE BELO DO SUL","stateCode":"RS","buscaAdicional":"DITALIA 1984 DITALIA MTZ BELOSUL 70360"},{"id":"d2163d9d-fd21-4dd0-56ff-08d5ad2bf6ba","name":"VIBRA AGROINDUSTRIAL S/A","commercialName":"","cnpj":"93586303000119","city":"MONTENEGRO","stateCode":"RS","buscaAdicional":"VIBRA 8121 VIBRA PATO BRANCO PR 900376 AGROGEN RACOES 888868 AGROGEN FRIGORIFICO 888869 VIBRA FRIG ITAPEJARA 70943 VIBRA INCUBATORIO 906121 VIBRA RACOES - RS 906340 VIBRA - GUARAPUAVA 904072 AGROGEN INCUBAT-PR 7969"},{"id":"c16cab82-4e0c-4255-549f-08d5ad2bf6ba","name":"JOHN DEERE BRASIL LTDA","commercialName":"JOHN DEERE BRASIL LTDA","cnpj":"89674782001200","city":"MONTENEGRO","stateCode":"RS","buscaAdicional":"JDBM 4390 JDB-MONTENEGRO 71790"},{"id":"b078d2bf-1d6a-4551-5adc-08d5ad2bf6ba","name":"ERPLASTI INDUSTRIA E COMERCIO DE PLASTICOS EIRELI","commercialName":"","cnpj":"92185008000198","city":"MONTENEGRO","stateCode":"RS","buscaAdicional":"ERPLASTI 50292 ERPLASTI 898319"},{"id":"dc3e762b-3798-453e-6398-08d5ad2bf6ba","name":"CURTUME NIMO LTDA","commercialName":"","cnpj":"91359679000165","city":"MONTENEGRO","stateCode":"RS","buscaAdicional":"CURTUME NIMO 55478 CURTUME NIMO 907246"},{"id":"31804075-68d9-4e16-677c-08d5ad2bf6ba","name":"UNIMED VALE DO CAI/RS - COOPERATIVA DE ASSISTENCIA A SAUDE LTDA","commercialName":"UNIMED VALE DO CAI","cnpj":"87306361000149","city":"MONTENEGRO","stateCode":"RS","buscaAdicional":"UNIMED VALE DO CAI 58216 UNIMED VALE DO CAI 910855"},{"id":"d168c49f-f82a-4865-68fe-08d5ad2bf6ba","name":"POLO FILMS INDUSTRIA E COMERCIO S/A","commercialName":"POLO FILMS","cnpj":"26051817000263","city":"MONTENEGRO","stateCode":"RS","buscaAdicional":"POLO FILMSF 60690 POLO FILMSF 7358"},{"id":"884bfb13-bf32-47c9-8838-08d5ae44ed50","name":"POLO INDUSTRIA E COMERCIO S.A.","commercialName":"","cnpj":"29510765000587","city":"MONTENEGRO","stateCode":"RS","buscaAdicional":"POLO FILMS 1421"},{"id":"cc904789-0576-4751-5af5-08d5ad2bf6ba","name":"NUTRIFRANGO ALIMENTOS LTDA","commercialName":"NUTRIFRANGO","cnpj":"72535370000134","city":"MORRO REUTER","stateCode":"RS","buscaAdicional":"NUTRIFRANGO 50372 NUTRIFRANGO ALIMENTO 898990"},{"id":"e0755126-3562-4358-5ae0-08d5ad2bf6ba","name":"CURTUME CBR LTDA","commercialName":"","cnpj":"07970099000101","city":"MUÇUM","stateCode":"RS","buscaAdicional":"CURTUME CBR 50310 CURTUME CBR 899062"},{"id":"4931c36c-3aa9-434e-4f0c-08d5d159243d","name":"STARA S.A. - INDUSTRIA DE IMPLEMENTOS AGRICOLAS","commercialName":"STARA","cnpj":"91495499000100","city":"NÃO-ME-TOQUE","stateCode":"RS","buscaAdicional":""},{"id":"46f86686-8437-43c7-5cb0-08d5ad2bf6ba","name":"USINAS HIDRELETRICAS BRINGHENTI LTDA","commercialName":"C G H PASSO DO CERVO","cnpj":"11184905000185","city":"NONOAI","stateCode":"RS","buscaAdicional":"CGH PASSO DO CERVO 51507 PASSO DO CERVO 902328 CGH.PH.RS.035444-9.01"},{"id":"79b461c4-54b0-4f51-5417-08d5ad2bf6ba","name":"FRIGORIFICO NOVA ARACA LTDA","commercialName":"","cnpj":"04239719000130","city":"NOVA ARAÇÁ","stateCode":"RS","buscaAdicional":"NOVA ARACA 4003 ARACA AVES II 71378 ARACA AVES I 71437 ARACA INCUBATORIO 905371"},{"id":"d1ef992a-c476-4146-53e8-08d5ad2bf6ba","name":"BOA FE ENERGETICA S/A","commercialName":"","cnpj":"07647780000105","city":"NOVA BASSANO","stateCode":"RS","buscaAdicional":"BOA FE 3904 BOA FE 8917 PCH.PH.RS.029063-7.01"},{"id":"25a58380-45ed-42fb-59f2-08d5ad2bf6ba","name":"DAGNESE & CIA LTDA","commercialName":"DAGNESE SOLUCOES METALICAS","cnpj":"73325722000190","city":"NOVA BASSANO","stateCode":"RS","buscaAdicional":"DAGNESE 16056 DAGNESE 892042"},{"id":"6b2f2096-b554-4148-5ad9-08d5ad2bf6ba","name":"GOBBA LEATHER INDUSTRIA E COMERCIO LTDA","commercialName":"GOBBA LEATHER INDUSTRIA E COMERCIO LTDA","cnpj":"07956759000515","city":"NOVA ESPERANÇA DO SUL","stateCode":"RS","buscaAdicional":"GOBBA 50276 GOBBA LEATHER RS 898834"},{"id":"f83bdb0c-a3dc-482a-661b-08d5ad2bf6ba","name":"COOPERATIVA AGRICOLA MISTA NOVA PALMA LTDA","commercialName":"","cnpj":"91022632000101","city":"NOVA PALMA","stateCode":"RS","buscaAdicional":"CAMNPAL 57313 CAMNPAL-N.PALMA FILI 910561 CAMNPAL - S.J. POLES 910562 CAMNPAL - D. FRANCIS 910586"},{"id":"6754ad50-89ba-423f-5ae5-08d5ad2bf6ba","name":"GRANJA PINHEIROS LTDA","commercialName":"","cnpj":"87702528000190","city":"NOVA PETRÓPOLIS","stateCode":"RS","buscaAdicional":"GRANJA PINHEIROS 50333 GRANJA PINH 898206"},{"id":"c366b288-cd17-4e3a-59fc-08d5ad2bf6ba","name":"DAKOTA NORDESTE S/A","commercialName":"","cnpj":"00465813000408","city":"NOVA PETRÓPOLIS","stateCode":"RS","buscaAdicional":"DAKOTA NORDESTE 16275 DAKOTA NORDESTE 888188"},{"id":"d66a7bf7-616e-4f8c-54ff-08d5ad2bf6ba","name":"COOPERATIVA AGRO PECUARIA PETROPOLIS LTDA","commercialName":"PIA","cnpj":"91589507000188","city":"NOVA PETRÓPOLIS","stateCode":"RS","buscaAdicional":"PIA 4740 COOPERATIVA PIA 71684 PIA DOCES 889386"},{"id":"a860d5c3-60de-472b-56d6-08d5ad2bf6ba","name":"FUNDICAO ALCA LTDA","commercialName":"","cnpj":"88582291000114","city":"NOVA PETRÓPOLIS","stateCode":"RS","buscaAdicional":"ALCA 7820 FUNDICAO ALCA 72363"},{"id":"e4d6af7c-1c0b-484f-530e-08d5ad2bf6ba","name":"BORRACHAS VIPAL S A","commercialName":"VIPAL","cnpj":"87870952000144","city":"NOVA PRATA","stateCode":"RS","buscaAdicional":"VIPAL 3457 VIPAL-SE NOVA PRATA 71272"},{"id":"f313a77f-f4e0-4d83-587c-08d5ad2bf6ba","name":"P&C ARTEMOBILI S.A.","commercialName":"","cnpj":"87493946000115","city":"NOVA PRATA","stateCode":"RS","buscaAdicional":"P&C ARTEMOBILI 11996 PONZONI NOVA PRATA 890225"},{"id":"4525a260-e830-429b-58bf-08d5ad2bf6ba","name":"USIMONTEC SUL LTDA","commercialName":"","cnpj":"07097542000173","city":"NOVA ROMA DO SUL","stateCode":"RS","buscaAdicional":"USIMONTEC 13152 USIMONTEC 891342"},{"id":"baea9231-e287-437f-604c-08d5ad2bf6ba","name":"PINCEIS ROMA LTDA","commercialName":"","cnpj":"01829476000100","city":"NOVA ROMA DO SUL","stateCode":"RS","buscaAdicional":"PINCEIS ROMA 53456 PINCEIS ROMA MATRIZ 903861"},{"id":"4e2c309a-5474-4f60-6060-08d5ad2bf6ba","name":"HARMAN DO BRASIL INDUSTRIA ELETRONICA E PARTICIPACOES LTDA","commercialName":"","cnpj":"88315379000170","city":"NOVA SANTA RITA","stateCode":"RS","buscaAdicional":"HARMAN DO BRASIL 53483 HARMAN BRASIL 906463"},{"id":"02b5ba52-3394-4d43-5b6c-08d5ad2bf6ba","name":"FIACAO E TECELAGEM GAUCHA LTDA","commercialName":"FTG","cnpj":"88332119000102","city":"NOVA SANTA RITA","stateCode":"RS","buscaAdicional":"FTG 50701 FTG 899347"},{"id":"5c7cf891-cde1-42a3-67a1-08d5ad2bf6ba","name":"REITER TRANSPORTES E LOGISTICA LTDA","commercialName":"REITER LOG","cnpj":"10466983000100","city":"NOVA SANTA RITA","stateCode":"RS","buscaAdicional":"REITER LOG 58374"},{"id":"3fa63163-d7ff-4702-670c-08d5ad2bf6ba","name":"INDUSTRIAL BATISTELLA ARTEFATOS DE BORRACHA LTDA","commercialName":"INDIBA","cnpj":"88318928000160","city":"NOVA SANTA RITA","stateCode":"RS","buscaAdicional":"INDUSTRIAL BATISTELLA 57937 INDUSTRIAL BATISTELL 910132"},{"id":"7e653f96-311e-49a7-6728-08d5ad2bf6ba","name":"UNIMED VALE DO SINOS - COOPERATIVA DE ASSISTENCIA A SAUDE LTDA","commercialName":"UNIMED VALE DO SINOS","cnpj":"88258884000120","city":"NOVO HAMBURGO","stateCode":"RS","buscaAdicional":"UNIMED VALE DO SINOS 57984 PASL UNIMED V SINOS 909664 PANH UNIMED V SINOS 909676 UNIMED V DOS SINOS 912859"},{"id":"2eeb6716-5bb0-4afb-67b2-08d5ad2bf6ba","name":"SOPRASINOS INDUSTRIA E COMERCIO DE PLASTICOS LTDA","commercialName":"","cnpj":"00563273000144","city":"NOVO HAMBURGO","stateCode":"RS","buscaAdicional":"SOPRASINOS 58473 SOPRASINOS 909662"},{"id":"122c5786-e6b6-49e9-668d-08d5ad2bf6ba","name":"GRUPO EDITORIAL SINOS SA","commercialName":"","cnpj":"91665570000156","city":"NOVO HAMBURGO","stateCode":"RS","buscaAdicional":"GRUPO SINOS 57652 GRUPO EDIT SINOS 909092"},{"id":"af9df9bf-afb0-49f1-639a-08d5ad2bf6ba","name":"CBC COUROS E ACABAMENTOS LTDA","commercialName":"","cnpj":"90333758000134","city":"NOVO HAMBURGO","stateCode":"RS","buscaAdicional":"CBC COUROS 55480 CBC COUROS 907254"},{"id":"6e12df64-d175-4fbb-6410-08d5ad2bf6ba","name":"VALESEMI BENEFICIAMENTO DE COUROS LTDA","commercialName":"VALESEMI BENEFICIAMENTO","cnpj":"17969647000129","city":"NOVO HAMBURGO","stateCode":"RS","buscaAdicional":"VALESEMI 55813 VALESEMI BENEF COURO 905917"},{"id":"2b19dc9d-bc44-4fac-64f0-08d5ad2bf6ba","name":"CONSORCIO EMPREENDEDOR DO SHOPPING PLATINUM OUTLET","commercialName":"","cnpj":"17668429000154","city":"NOVO HAMBURGO","stateCode":"RS","buscaAdicional":"PLATINUM OUTLET 56320 PLATINUM OUTLET - NH 908231"},{"id":"d9f7cf54-10d4-42e5-6467-08d5ad2bf6ba","name":"STAMPA ARTEFATOS DE COURO LTDA","commercialName":"","cnpj":"73795486000175","city":"NOVO HAMBURGO","stateCode":"RS","buscaAdicional":"LUZ DA LUA 55978 STAMPA COUROS 909661 STAMPA COUROS 1 909671"},{"id":"7b641463-4c44-4223-5c11-08d5ad2bf6ba","name":"KILLING S.A. TINTAS E ADESIVOS","commercialName":"","cnpj":"91671578000125","city":"NOVO HAMBURGO","stateCode":"RS","buscaAdicional":"TINTAS KILLING 51063 TINTAS KILLING 898962"},{"id":"da8642cd-cb2d-4f98-5b60-08d5ad2bf6ba","name":"METALURGICA DANIEL LTDA","commercialName":"","cnpj":"91687129000175","city":"NOVO HAMBURGO","stateCode":"RS","buscaAdicional":"METALURGICA DANIEL 50651 METALURGICA DANIEL 899116"},{"id":"4679f140-3cb7-4a01-5b41-08d5ad2bf6ba","name":"SMS STAMP INJET METALURGICA LTDA","commercialName":"","cnpj":"03420195000117","city":"NOVO HAMBURGO","stateCode":"RS","buscaAdicional":"SMS 50552 SMS STAMP INJET 900089"},{"id":"a942b2ba-2c01-4577-5acc-08d5ad2bf6ba","name":"COLORGRAF GRAFICA EDITORA LTDA","commercialName":"","cnpj":"73291536000187","city":"NOVO HAMBURGO","stateCode":"RS","buscaAdicional":"COLORGRAF 50245 COLORGRAF 898053"},{"id":"2fca3981-ae8c-4d36-590d-08d5ad2bf6ba","name":"ASSOCIACAO PRO ENSINO SUPERIOR EM NOVO HAMBURGO","commercialName":"ASPEUR","cnpj":"91693531000162","city":"NOVO HAMBURGO","stateCode":"RS","buscaAdicional":"FEEVALE 13636 FEEVALE N HAMBURGO 893122"},{"id":"a2bc00ac-b305-428b-60b8-08d5ad2bf6ba","name":"MERCOPLASA INDUSTRIA DE CONTENTORES EIRELI","commercialName":"","cnpj":"05623823000197","city":"NOVO HAMBURGO","stateCode":"RS","buscaAdicional":"MERCOPLASA 53647 MERCOPLASA IND CONTE 905944"},{"id":"05f563d0-73f1-47a7-6080-08d5ad2bf6ba","name":"CALCADOS BEIRA RIO S/A","commercialName":"","cnpj":"88379771001669","city":"NOVO HAMBURGO","stateCode":"RS","buscaAdicional":"BEIRA RIO NH 53546 CALCADOS BEIRA RIO S 905942"},{"id":"f3b80604-b9f2-4c9a-609f-08d5ad2bf6ba","name":"F & M PANIFICACAO LTDA","commercialName":"","cnpj":"91684126000269","city":"NOVO HAMBURGO","stateCode":"RS","buscaAdicional":"PADARIA BRASIL 53618 F&M PANIFICACAO 903474"},{"id":"7234d6e7-a375-4607-60cf-08d5ad2bf6ba","name":"TACOSOLA BORRACHAS LTDA","commercialName":"","cnpj":"89313720000110","city":"NOVO HAMBURGO","stateCode":"RS","buscaAdicional":"TACOSOLA 53744 TACOSOLA BORRACHAS 905948"},{"id":"7026dfee-7022-40cc-5f2c-08d5ad2bf6ba","name":"CAIMI & LIAISON INDUSTRIA E COMERCIO DE COURO E SINTETICOS LTDA.","commercialName":"CAIMI & LIAISON","cnpj":"07443786000160","city":"NOVO HAMBURGO","stateCode":"RS","buscaAdicional":"CAIMI & LIAISON 52825 CAIMI & LIAISON 904935"},{"id":"4fe53997-eeef-4402-5d82-08d5ad2bf6ba","name":"RUBBERLOSS INDUSTRIA DE CALCADOS E COMPONENTES LTDA","commercialName":"RUBBERLOSS BRASIL","cnpj":"07861712000144","city":"NOVO HAMBURGO","stateCode":"RS","buscaAdicional":"RUBBERLOSS 51843 RUBBERLOS 903938"},{"id":"7a905441-433b-48a4-5e87-08d5ad2bf6ba","name":"LLV INDUSTRIA E COMERCIO DE METAIS LTDA.","commercialName":"L L V COMERCIO E REPRES DE COMPONENTES PARA CALCADOS","cnpj":"94517158000187","city":"NOVO HAMBURGO","stateCode":"RS","buscaAdicional":"LLV METAIS 52417 LLV METAIS 907667"},{"id":"c55a4579-fd21-479b-56b4-08d5ad2bf6ba","name":"BERTEX PRODUTOS PARA CALCADOS LTDA.","commercialName":"","cnpj":"07893101000188","city":"NOVO HAMBURGO","stateCode":"RS","buscaAdicional":"BERTEX 7524 BERTEX NOVO HAMBURGO 72347"},{"id":"40f2ea03-1ac8-42a7-55ee-08d5ad2bf6ba","name":"GRAVASUL PROJETOS E MATRIZES DE SOLADOS LTDA","commercialName":"","cnpj":"90333063000152","city":"NOVO HAMBURGO","stateCode":"RS","buscaAdicional":"GRAVASUL 6331 GRAVASUL N HAMBURGO 72364"},{"id":"96064db7-5b8a-4b65-5ee2-08d5ad2bf6ba","name":"CALCADOS BEIRA RIO S/A","commercialName":"","cnpj":"88379771000425","city":"OSÓRIO","stateCode":"RS","buscaAdicional":"BEIRA RIO OSORIO 52600 CALCADOS BEIRA RIO 905924"},{"id":"66db7ac6-a4a6-4145-67b3-08d5ad2bf6ba","name":"FABRICA DE EMBUTIDOS BORRUSSIA LTDA","commercialName":"","cnpj":"94296456000194","city":"OSÓRIO","stateCode":"RS","buscaAdicional":"BORRUSSIA 58474 BORRUSSIA 909798"},{"id":"7059ad18-dfe6-4ef6-5f24-08d5ad2bf6ba","name":"HIDROELETRICA PALMEIRAS LTDA.","commercialName":"PCH PALMEIRAS","cnpj":"15361032000190","city":"PANAMBI","stateCode":"RS","buscaAdicional":"CGH PALMEIRAS HIDRO 52784 CGH PALMEIRAS 908163 CGH.PH.RS.002430-9.01"},{"id":"27baf36a-abb7-47f3-6101-08d5ad2bf6ba","name":"BRUNING TECNOMETAL LTDA.","commercialName":"","cnpj":"89673164000193","city":"PANAMBI","stateCode":"RS","buscaAdicional":"BRUNING 53949 BRUNING TECNOMETAL 905922 BRUNING TECNOMETAL 905955"},{"id":"b839bdb8-8bc8-40ea-59b4-08d5ad2bf6ba","name":"FOCKINK PARTICIPACOES LTDA","commercialName":"","cnpj":"91986430000180","city":"PANAMBI","stateCode":"RS","buscaAdicional":"PCH CAXAMBU 15378 CAXAMBU 894503 CGH.PH.RS.002317-5.01"},{"id":"5c4277eb-e15e-46bd-61e7-08d5ad2bf6ba","name":"PIAN ALIMENTOS LTDA","commercialName":"","cnpj":"04632445000145","city":"PARAÍ","stateCode":"RS","buscaAdicional":"PIAN 54462 PIAN ALIMENTOS 906313"},{"id":"e8672fce-2bc6-4966-662a-08d5ad2bf6ba","name":"SEFAR - INDUSTRIA E COMERCIO DE FARINHA E SEBO LTDA","commercialName":"SEFAR","cnpj":"05327858000189","city":"PAROBÉ","stateCode":"RS","buscaAdicional":"SEFAR 57378 SEFAR 909255"},{"id":"fbc458bb-1b17-40f7-5aad-08d5ad2bf6ba","name":"CALCADOS BOTTERO LTDA","commercialName":"","cnpj":"90312133000196","city":"PAROBÉ","stateCode":"RS","buscaAdicional":"BOTTERO 50173 CALCADOS BOTTERO 897286"},{"id":"f36a187b-1b02-4fa0-601b-08d5ad2bf6ba","name":"MOSMANN ALIMENTOS LTDA","commercialName":"","cnpj":"97749907000270","city":"PAROBÉ","stateCode":"RS","buscaAdicional":"MOSMANN 53379 MOSMANN 904771"},{"id":"e223c50f-1082-424c-5eeb-08d5ad2bf6ba","name":"FRIGORIFICO ZIMMER LTDA","commercialName":"","cnpj":"97280960000194","city":"PAROBÉ","stateCode":"RS","buscaAdicional":"FRIG ZIMMER 52609 FRIGORIFICO ZIMMER 904283"},{"id":"e93502e6-afb6-4a40-55d4-08d5ad2bf6ba","name":"CALCADOS BIBI LTDA","commercialName":"","cnpj":"97748958000105","city":"PAROBÉ","stateCode":"RS","buscaAdicional":"CALCADOSBIBI 6225 CALCADOS BIBI-PAROBE 72109"},{"id":"dcc85405-81e9-402a-54b3-08d5ad2bf6ba","name":"VULCABRAS AZALEIA-RS,CALCADOS E ARTIGOS ESPORTIVOS S/A","commercialName":"","cnpj":"98408073000111","city":"PAROBÉ","stateCode":"RS","buscaAdicional":"VULC AZALEIA 4444 VULCBRAS-PAROBE RS 71579"},{"id":"38bc0bec-960e-4486-5461-08d5ad2bf6ba","name":"BSBIOS INDUSTRIA E COMERCIO DE BIODIESEL SUL BRASIL S/A","commercialName":"BSBIOS","cnpj":"07322382000119","city":"PASSO FUNDO","stateCode":"RS","buscaAdicional":"BSBIOS 4201 BSBIOS PASSO FUNDO 71473 BSBIOS IND E COMERC 906115"},{"id":"aecfda55-0139-47a0-5dc0-08d5ad2bf6ba","name":"ASSOCIACAO HOSPITALAR BENEFICENTE SAO VICENTE DE PAULO","commercialName":"HOSPITAL SAO VICENTE DE PAULO","cnpj":"92021062000106","city":"PASSO FUNDO","stateCode":"RS","buscaAdicional":"HSVP 51977 HOSP BENEF S VICENTE 899349"},{"id":"5b8428a8-ec96-4c15-6163-08d5ad2bf6ba","name":"SALTON INDUSTRIA DE VIDROS LTDA","commercialName":"SALTON VIDROS","cnpj":"89291850000108","city":"PASSO FUNDO","stateCode":"RS","buscaAdicional":"SALTON VIDRACARIA 54160 SALTON PASSO FUNDO 902755"},{"id":"604499ac-e456-4517-62a4-08d5ad2bf6ba","name":"CONDOMINIO SHOPPING BELLA CITTA","commercialName":"CONDOMINIO BELLA CITTA","cnpj":"04564926000160","city":"PASSO FUNDO","stateCode":"RS","buscaAdicional":"BELLA CITTA 54846 COND BELLA CITTA 906497"},{"id":"5613f943-d0c2-44d9-6517-08d5ad2bf6ba","name":"KUHN DO BRASIL S/A - IMPLEMENTOS AGRICOLAS","commercialName":"","cnpj":"06216625000171","city":"PASSO FUNDO","stateCode":"RS","buscaAdicional":"KUHN 56468 KUHN METASA 905956"},{"id":"4b6dfc8b-8130-410a-73eb-08d5cf600bef","name":"GRAZZIOTIN S A","commercialName":"","cnpj":"92012467000170","city":"PASSO FUNDO","stateCode":"RS","buscaAdicional":""},{"id":"3c9d08cd-3f91-4300-5d1d-08d5ad2bf6ba","name":"CLARAMAX INDUSTRIA E COMERCIO DE PAPEIS LTDA","commercialName":"CLARAMAX PAPEIS","cnpj":"03871187000197","city":"PAULO BENTO","stateCode":"RS","buscaAdicional":"CLARAMAX 51706 CLARAMAX 903783"},{"id":"b8cf3e13-e849-4551-55c9-08d5ad2bf6ba","name":"OURO VERDE INDUSTRIA E COMERCIO DE PAPEIS LTDA","commercialName":"OURO VERDE PAPEIS","cnpj":"89890792000120","city":"PAULO BENTO","stateCode":"RS","buscaAdicional":"OUROVERDE 6137 OURO VERDE-PBENTO 72119"},{"id":"38b3f40c-12e9-4720-6599-08d5ad2bf6ba","name":"LATICINIOS PINHALENSE LTDA.","commercialName":"LATICINIOS FRIZZO","cnpj":"02425993000330","city":"PAVERAMA","stateCode":"RS","buscaAdicional":"FRIZZO PAVERAMA 56854 LATICINIO PINHALENSE 909461"},{"id":"ed5fe6d3-16dd-427d-660a-08d5ad2bf6ba","name":"FUNDICAO CONCORDIA INDUSTRIA E COMERCIO LTDA","commercialName":"FUNDICAO CONCORDIA","cnpj":"06064714000140","city":"PAVERAMA","stateCode":"RS","buscaAdicional":"FUNDICAO CONCORDIA 57280 FUNDICAO CONCORDIA 909089"},{"id":"17656828-657e-4231-6244-08d5ad2bf6ba","name":"MACRO ATACADO KROLOW LTDA","commercialName":"MACRO ATACADO KROLOW","cnpj":"01060735000173","city":"PELOTAS","stateCode":"RS","buscaAdicional":"KROLOW 54665 MACRO ATACADO KROLOW 904306"},{"id":"634ad129-0ebd-4e87-61b2-08d5ad2bf6ba","name":"CEREALISTA POLISUL LTDA","commercialName":"","cnpj":"03639398000107","city":"PELOTAS","stateCode":"RS","buscaAdicional":"CEREALISTA POLISUL 54343 CEREALISTA POLISUL 906481"},{"id":"752da2c2-5857-4fa9-621b-08d5ad2bf6ba","name":"PURO GRAO INDUSTRIA E COMERCIO DE ARROZ E SOJA LTDA","commercialName":"","cnpj":"07287096000160","city":"PELOTAS","stateCode":"RS","buscaAdicional":"PURO GRAO 54568 PURO GRAO MATRIZ 906461 PURO GRAO FILIAL 906480"},{"id":"f9f7b55c-d1d3-4be9-88c7-08d5ae44ed50","name":"IRGOVEL IND RIOGRANDENSE DE OLEOS VEGETAIS LTDA","commercialName":"IRGOVEL","cnpj":"87442430000141","city":"PELOTAS","stateCode":"RS","buscaAdicional":"IRGOVEL 51594 IRGOVEL - PELOTAS 900928"},{"id":"cbe34991-e724-4d0c-5cbe-08d5ad2bf6ba","name":"ARROZEIRA PELOTAS INDUSTRIA E COMERCIO DE CEREAIS LTDA","commercialName":"ARROZEIRA PELOTAS","cnpj":"97371843000136","city":"PELOTAS","stateCode":"RS","buscaAdicional":"ARROZPELOTAS01 51546 ARROZEIRA PELOTAS 899742"},{"id":"95b74ae7-01da-4405-5cbf-08d5ad2bf6ba","name":"ARROZEIRA PELOTAS INDUSTRIA E COMERCIO DE CEREAIS LTDA","commercialName":"","cnpj":"97371843000217","city":"PELOTAS","stateCode":"RS","buscaAdicional":"ARROZPELOTAS02 51551 ARROZEIRA PELOTAS 2 899226"},{"id":"f67d8bfb-e109-485c-5cc0-08d5ad2bf6ba","name":"ARROZEIRA PELOTAS INDUSTRIA E COMERCIO DE CEREAIS LTDA","commercialName":"","cnpj":"97371843000802","city":"PELOTAS","stateCode":"RS","buscaAdicional":"ARROZPELOTAS03 51553 ARROZEIRA PELOTAS 3 899227"},{"id":"83e5f305-a7fe-4442-5ca4-08d5ad2bf6ba","name":"JOSAPAR JOAQUIM OLIVEIRA SA PARTICIPACOES","commercialName":"","cnpj":"87456562003148","city":"PELOTAS","stateCode":"RS","buscaAdicional":"JOSAPAR VILAP 51456 JOAQUIM OLIVEIRA 899902"},{"id":"0f9e7adb-d017-4e03-5f09-08d5ad2bf6ba","name":"EMPRESA PELOTENSE DE SHOPPING CENTERS LTDA","commercialName":"EMPRESA PELOTENSE DE SHOPPING CENTERS LTDA","cnpj":"13025790000101","city":"PELOTAS","stateCode":"RS","buscaAdicional":"SHOPPING PELOTAS 52714 SHOPPING PELOTAS 904280"},{"id":"b0ac66b9-b121-4293-5fd7-08d5ad2bf6ba","name":"TREICHEL MACROMERCADO LTDA","commercialName":"TREICHEL","cnpj":"03204565000189","city":"PELOTAS","stateCode":"RS","buscaAdicional":"TREICHEL 53240 MACRO TREICHEL RS 902689"},{"id":"5a6dbe1c-cc60-4082-5fc2-08d5ad2bf6ba","name":"NELSON WENDT CIA LTDA","commercialName":"","cnpj":"92215763000178","city":"PELOTAS","stateCode":"RS","buscaAdicional":"NELSON WENDT 53213 NELSON WENDT 903920"},{"id":"be2b7edc-547f-49a3-5f62-08d5ad2bf6ba","name":"LIFEMED INDUSTRIAL DE EQUIPAMENTOS E ARTIGOS MEDICOS E HOSPITALARES S.A.","commercialName":"","cnpj":"02357251000153","city":"PELOTAS","stateCode":"RS","buscaAdicional":"LIFEMED 52924 LIFEMED 904911"},{"id":"c60ce3c9-e8c3-4d7a-5f60-08d5ad2bf6ba","name":"IRMAOS RUIVO LTDA","commercialName":"MASSAS E BISCOITOS ZEZE","cnpj":"92226026000170","city":"PELOTAS","stateCode":"RS","buscaAdicional":"IRMAOS RUIVO 52922 IRMAOS RUIVO 904980"},{"id":"be3ccdea-84d4-4601-6079-08d5ad2bf6ba","name":"COOPERATIVA ARROZEIRA EXTREMO SUL LTDA","commercialName":"","cnpj":"92195692000199","city":"PELOTAS","stateCode":"RS","buscaAdicional":"ARROZEIRA EXTREMO SUL 53526 EXTREMO SUL PELOTAS 904995 EXTREMO SUL CAMAQUA 904775"},{"id":"fae0e958-e0b8-4d91-5c20-08d5ad2bf6ba","name":"JOSAPAR JOAQUIM OLIVEIRA SA PARTICIPACOES","commercialName":"SUPRARROZ INDUSTRIA E COMERCIO FABRICA","cnpj":"87456562000637","city":"PELOTAS","stateCode":"RS","buscaAdicional":"JOSAPAR AREAL 51096 JOSAPAR JOAQUIM 900053"},{"id":"a9907a8a-0e04-4411-5bd4-08d5ad2bf6ba","name":"CONSERVAS ODERICH SA","commercialName":"","cnpj":"97191902000860","city":"PELOTAS","stateCode":"RS","buscaAdicional":"ODERICH PELOTAS 50940 ODERICH PELOTAS 897680"},{"id":"61c63b52-c88f-4619-5769-08d5ad2bf6ba","name":"COOPERSHOES - COOPERATIVA DE TRABALHO E INDUSTRIA DE CALCADOS JOANETENSE LTDA","commercialName":"","cnpj":"02675611000165","city":"PICADA CAFÉ","stateCode":"RS","buscaAdicional":"COOPERSHOES 8811 COOPERSHOES 888600"},{"id":"40249652-f8be-4d10-502c-08d5ad2bf6ba","name":"BAESA-ENERGETICA BARRA GRANDE S/A","commercialName":"","cnpj":"04781143000139","city":"PINHAL DA SERRA","stateCode":"RS","buscaAdicional":"BAESA 1488 BARRA GRANDE 8119 UHE.PH.RS.027556-5.01"},{"id":"d82ee368-b00b-4cef-5997-08d5ad2bf6ba","name":"PIRATINI ENERGIA S.A.","commercialName":"","cnpj":"03932239000198","city":"PIRATINI","stateCode":"RS","buscaAdicional":"UTE PIRATINI 15035 PIRATINI 895145 UTE.FL.RS.028239-1.01"},{"id":"bed69b00-ef9b-4fac-5b86-08d5ad2bf6ba","name":"BAZZE INDUSTRIA DE PERFIS EM PVC LTDA","commercialName":"","cnpj":"10973413000106","city":"PORTÃO","stateCode":"RS","buscaAdicional":"BAZZE 50751 BAZZE PORTAO RS 899137"},{"id":"5b229bee-9dc6-46d5-5ad3-08d5ad2bf6ba","name":"CORTUME KRUMENAUER SA","commercialName":"","cnpj":"97191597000130","city":"PORTÃO","stateCode":"RS","buscaAdicional":"KRUMENAUER 50270 CORTUME KRUMENAUER 898961"},{"id":"cb587942-3ade-4f37-5af7-08d5ad2bf6ba","name":"CERAMICA KASPARY LTDA","commercialName":"","cnpj":"90954892000314","city":"PORTÃO","stateCode":"RS","buscaAdicional":"KASPARYFILIAL 50374 CERAMICA KASPARY 900042"},{"id":"e7ab8fe3-cbe4-471e-5aec-08d5ad2bf6ba","name":"MK QUIMICA DO BRASIL LTDA","commercialName":"","cnpj":"92315332000183","city":"PORTÃO","stateCode":"RS","buscaAdicional":"MK QUIMICA 50355 MK QUIMICA RS 898836"},{"id":"df7da57e-d54c-4a28-60b5-08d5ad2bf6ba","name":"SOUBACH BENEFICIAMENTO EM COUROS LTDA","commercialName":"SOUBACH COUROS","cnpj":"93062941000130","city":"PORTÃO","stateCode":"RS","buscaAdicional":"SOUBACH COUROS 53644 SOUBACH BENEF COUROS 905940"},{"id":"f2007ecb-d958-4557-60c2-08d5ad2bf6ba","name":"NATUR INDUSTRIA DE COUROS LTDA","commercialName":"","cnpj":"90309188000147","city":"PORTÃO","stateCode":"RS","buscaAdicional":"NATUR 53659 NATUR 904938"},{"id":"f6be639c-cf40-44fa-5d88-08d5ad2bf6ba","name":"RENOVADORA DE PNEUS HOFF S.A.","commercialName":"","cnpj":"97201362000263","city":"PORTÃO","stateCode":"RS","buscaAdicional":"HOFF PORTAO 51850 PNEUS HOFF 903105"},{"id":"3279df66-9a8c-49f6-5ec3-08d5ad2bf6ba","name":"STAHL BRASIL SA","commercialName":"","cnpj":"89488316000692","city":"PORTÃO","stateCode":"RS","buscaAdicional":"STAHL 52538 STAHL BRASIL 904300"},{"id":"9b1acde2-5b25-4453-61ea-08d5ad2bf6ba","name":"ALTECNICA INDUSTRIA E COMERCIO LTDA","commercialName":"","cnpj":"93719136000307","city":"PORTÃO","stateCode":"RS","buscaAdicional":"ALTECNICA 54466 ALTECNICA IND E COM 906223"},{"id":"55834f00-1096-44b6-621c-08d5ad2bf6ba","name":"COPELMI MINERACAO LTDA","commercialName":"","cnpj":"33059528000195","city":"PORTO ALEGRE","stateCode":"RS","buscaAdicional":"COPELMI 54570 COPELMI CALOMBO 905959 COPELMI MINA 905963 COPELMI RECREIO 905960"},{"id":"c4e12e1a-1780-489d-6529-08d5ad2bf6ba","name":"MATEC - PARTICIPACOES LTDA.","commercialName":"","cnpj":"06111266000198","city":"PORTO ALEGRE","stateCode":"RS","buscaAdicional":"MATEC PART 56572 MATEC HOTEL 904997 MATEC SHOPPING 904998"},{"id":"70145e9a-a466-4dba-64c4-08d5ad2bf6ba","name":"LACTALIS DO BRASIL - COMERCIO, IMPORTACAO E EXPORTACAO DE LATICINIOS LTDA.","commercialName":"LACTALIS DO BRASIL","cnpj":"14049467000130","city":"PORTO ALEGRE","stateCode":"RS","buscaAdicional":"LACTALIS 56199 ELEBAT ITUMBIARA 906366 LACTALIS - ARACANGUA 907239 LACTALIS BARRA MANSA 907331 LACTALIS ANTONIO CAR 907596 ELEBAT SABARA 907614 ELEBAT STA ROSA 906319 ELEBAT CONCORDIA 907723 ELEBAT- BOM CONSELHO 906613 LACTALIS CARAMBEI 908864"},{"id":"386f723f-367e-410e-6424-08d5ad2bf6ba","name":"TONIOLO, BUSNELLO S/A - TUNEIS, TERRAPLENAGENS E PAVIMENTACOES","commercialName":"TONIOLO, BUSNELLO S/A","cnpj":"89723977000140","city":"PORTO ALEGRE","stateCode":"RS","buscaAdicional":"TONIOLO BUSNELLO 55856 TONIOLO BUSNELLO 907253"},{"id":"8f25fbbc-9e39-4af4-63d7-08d5ad2bf6ba","name":"MERIDIONAL MEAT-IMPORTACAO E EXP DE ALIMENTOS LTDA","commercialName":"","cnpj":"01119157000101","city":"PORTO ALEGRE","stateCode":"RS","buscaAdicional":"MERIDIONAL MEAT 55679 MERIDIONAL MEAT 906843"},{"id":"b05c55af-23fb-4c73-6368-08d5ad2bf6ba","name":"KLEY HERTZ FARMACEUTICA S.A","commercialName":"KLEY HERTZ FARMACEUTICA","cnpj":"92695691000103","city":"PORTO ALEGRE","stateCode":"RS","buscaAdicional":"KLEY HERTZ 55338 KLEY HERTZ FARMA 905961"},{"id":"df2557ef-efde-43c3-6365-08d5ad2bf6ba","name":"VIDORA FARMACEUTICA LTDA","commercialName":"","cnpj":"92762277000170","city":"PORTO ALEGRE","stateCode":"RS","buscaAdicional":"VIDORA 55335 VIDORA FARMA 905957"},{"id":"efc3d3f9-5e1c-4ce5-6641-08d5ad2bf6ba","name":"CONDOMINIO EDIFICIO GUAIBA","commercialName":"","cnpj":"22170908000186","city":"PORTO ALEGRE","stateCode":"RS","buscaAdicional":"GUAIBA 57420 COND GUAIBA 908490"},{"id":"e0da9893-7dad-44ed-6671-08d5ad2bf6ba","name":"UNIAO SUL BRASILEIRA DE EDUCACAO E ENSINO","commercialName":"","cnpj":"92706308000175","city":"PORTO ALEGRE","stateCode":"RS","buscaAdicional":"USBEE 57572 USBEE POA II 908862 USBEE POA 908876 USBEE NV HAMBURGO 909133"},{"id":"4e34bb95-5b5a-4d76-6797-08d5ad2bf6ba","name":"ADMINISTRADORA GAUCHA DE SHOPPING CENTERS S.A","commercialName":"","cnpj":"91340117000170","city":"PORTO ALEGRE","stateCode":"RS","buscaAdicional":"IGUATEMI P ALEGRE 58324 IGUATEMI - POA - RS 907770"},{"id":"75311524-cc50-4ec5-6780-08d5ad2bf6ba","name":"ICH ADMINISTRACAO DE HOTEIS S.A.","commercialName":"","cnpj":"02584924000108","city":"PORTO ALEGRE","stateCode":"RS","buscaAdicional":"ICH HOTEIS 58231 ICH CAXIAS DO SUL 909258 ICH PORTO ALEGRE 909320 ICH FLORIANOPOLIS 909338"},{"id":"43aacb84-007e-4b4b-66b2-08d5ad2bf6ba","name":"SOCIEDADE DE GINASTICA PORTO ALEGRE 1867","commercialName":"SOGIPA","cnpj":"92913607000180","city":"PORTO ALEGRE","stateCode":"RS","buscaAdicional":"SOGIPA 57746 SOGIPA 909324"},{"id":"5a2dbc22-9f82-46ed-680c-08d5ad2bf6ba","name":"BRENERGIA ENERGIAS RENOVAVEIS LTDA","commercialName":"BRENERGIA, BRENERGY, BRENERGIA.COM.BR, BRENERGY.COM.BR","cnpj":"21148231000117","city":"PORTO ALEGRE","stateCode":"RS","buscaAdicional":"BRENERGIA 59231"},{"id":"552960cd-c1ed-47a2-1cb4-08d5b8870181","name":"CONDOMINIO INSTITUCIONAL DO SISTEMA FIERGS","commercialName":"CONDOMINIO DO SISTEMA FIERGS","cnpj":"03505886000113","city":"PORTO ALEGRE","stateCode":"RS","buscaAdicional":"FIERGS 60941 FIERGS 912971"},{"id":"9e6f45f9-7511-47bb-7222-08d5cf600bef","name":"CAIXA DE ADMINISTRACAO DA DIVIDA PUBLICA ESTADUAL S/A","commercialName":"CADIP","cnpj":"00979969000156","city":"PORTO ALEGRE","stateCode":"RS","buscaAdicional":""},{"id":"391ec324-25b0-490b-7293-08d5cf600bef","name":"COMPANHIA PROVINCIA DE SECURITIZACAO DE CREDITOS IMOBILIARIOS","commercialName":"","cnpj":"04200649000107","city":"PORTO ALEGRE","stateCode":"RS","buscaAdicional":""},{"id":"570aef1f-0f4a-4f5d-73ec-08d5cf600bef","name":"TREVISA INVESTIMENTOS SA","commercialName":"","cnpj":"92660570000126","city":"PORTO ALEGRE","stateCode":"RS","buscaAdicional":""},{"id":"9dbd42bc-f91a-4865-73ee-08d5cf600bef","name":"METALURGICA GERDAU SOCIEDADE ANONIMA","commercialName":"","cnpj":"92690783000109","city":"PORTO ALEGRE","stateCode":"RS","buscaAdicional":""},{"id":"df91c72a-7f3a-4ce8-73ef-08d5cf600bef","name":"BANCO DO ESTADO DO RIO GRANDE DO SUL SA","commercialName":"BANRISUL","cnpj":"92702067000196","city":"PORTO ALEGRE","stateCode":"RS","buscaAdicional":""},{"id":"47720df9-27c1-4d08-73e9-08d5cf600bef","name":"EVORA S/A","commercialName":"","cnpj":"91820068000172","city":"PORTO ALEGRE","stateCode":"RS","buscaAdicional":""},{"id":"0d25911c-50ad-41b6-73f2-08d5cf600bef","name":"COMPANHIA RIOGRANDENSE DE SANEAMENTO CORSAN","commercialName":"CORSAN EST UNIF","cnpj":"92802784000190","city":"PORTO ALEGRE","stateCode":"RS","buscaAdicional":""},{"id":"c99c645c-f917-4147-73f3-08d5cf600bef","name":"DHB INDUSTRIA E COMERCIO SA","commercialName":"","cnpj":"92825900000196","city":"PORTO ALEGRE","stateCode":"RS","buscaAdicional":""},{"id":"dfa9275b-5b84-49c8-73f6-08d5cf600bef","name":"SDV ADMINISTRADORA DE SHOPPING CENTERS SA","commercialName":"","cnpj":"93167658000173","city":"PORTO ALEGRE","stateCode":"RS","buscaAdicional":""},{"id":"f26a175f-20b7-4542-73e6-08d5cf600bef","name":"CONSTRUTORA SULTEPA SA - EM RECUPERACAO JUDICIAL","commercialName":"","cnpj":"89723993000133","city":"PORTO ALEGRE","stateCode":"RS","buscaAdicional":""},{"id":"b14168b4-c4d8-4147-73e0-08d5cf600bef","name":"SEIVA SA FLORESTAS E INDUSTRIAS","commercialName":"","cnpj":"87043832000173","city":"PORTO ALEGRE","stateCode":"RS","buscaAdicional":""},{"id":"aedffd3a-8c51-41f7-73e1-08d5cf600bef","name":"JOSAPAR JOAQUIM OLIVEIRA SA PARTICIPACOES","commercialName":"","cnpj":"87456562000122","city":"PORTO ALEGRE","stateCode":"RS","buscaAdicional":""},{"id":"7a01818b-eda8-42da-73e2-08d5cf600bef","name":"COMPANHIA HABITASUL DE PARTICIPACOES","commercialName":"","cnpj":"87762563000103","city":"PORTO ALEGRE","stateCode":"RS","buscaAdicional":""},{"id":"d98070fb-f061-495e-8daa-08d5d060706e","name":"UNIAO BRASILEIRA DE EDUCACAO E ASSISTENCIA","commercialName":"","cnpj":"88630413000109","city":"PORTO ALEGRE","stateCode":"RS","buscaAdicional":"UBEA 62391 UNIAO BRASILEIRA EDU 913576"},{"id":"6d544a95-a18e-402d-5ec1-08d5ad2bf6ba","name":"S&P BRASIL VENTILACAO LTDA.","commercialName":"OTAM","cnpj":"92659507000170","city":"PORTO ALEGRE","stateCode":"RS","buscaAdicional":"OTAM 52536 S&P VENTILACAO 904993"},{"id":"3da6ac2a-e3a3-4345-5de6-08d5ad2bf6ba","name":"GREMIO NAUTICO UNIAO","commercialName":"","cnpj":"92841279000154","city":"PORTO ALEGRE","stateCode":"RS","buscaAdicional":"GNU PET 52060 GREMIO NAUTICO 901096"},{"id":"eedfdefe-9ea9-4b11-5d9c-08d5ad2bf6ba","name":"IAT - PANDROL BRASIL FIXACOES ELASTICAS LTDA","commercialName":"","cnpj":"60775293000100","city":"PORTO ALEGRE","stateCode":"RS","buscaAdicional":"IAT 51934 IAT PANDROL 902196"},{"id":"1d480e31-5464-464f-5d51-08d5ad2bf6ba","name":"RBS - ZERO HORA EDITORA JORNALISTICA S.A.","commercialName":"ZERO HORA","cnpj":"92821701000100","city":"PORTO ALEGRE","stateCode":"RS","buscaAdicional":"ZERO HORA 51780 PARQUE GRAFICO POA 899888 CORPORACAO POA 899905 CORPORACAO FLORIPA 899900"},{"id":"4f93e5bd-6845-4b71-5d52-08d5ad2bf6ba","name":"RBS PARTICIPACOES S A","commercialName":"","cnpj":"68737857000122","city":"PORTO ALEGRE","stateCode":"RS","buscaAdicional":"RBS 51782 RBS TV TRANSMISSAO 899913 RBS TV RS - ESTUDIOS 899933"},{"id":"af3f2213-a085-46d7-607f-08d5ad2bf6ba","name":"PAMPARAFIA-INDUSTRIA E COMERCIO DE EMBALAGENS LTDA","commercialName":"PAMPARAFIA-INDUSTRIA DE EMBALAGENS","cnpj":"07944839000127","city":"PORTO ALEGRE","stateCode":"RS","buscaAdicional":"PAMPARAFIA 53545 PAMPARAFIA EMBALAGEM 908201"},{"id":"9f3af3b6-3d72-4cc1-6061-08d5ad2bf6ba","name":"TMSA - TECNOLOGIA EM MOVIMENTACAO S/A","commercialName":"","cnpj":"92782705000126","city":"PORTO ALEGRE","stateCode":"RS","buscaAdicional":"TMSA 53484 TMSA 904912"},{"id":"6285afb7-0e02-4895-6044-08d5ad2bf6ba","name":"LOJAS RENNER S.A.","commercialName":"RENNER","cnpj":"92754738000162","city":"PORTO ALEGRE","stateCode":"RS","buscaAdicional":"RENNER MATRIZ 53441 RENNER L 44-CAMPINAS 72262 RENNER L31 RIB PRETO 72283 RENNER LOJA 37 888642 RENNER LJ 169 888933 RENNER LJ 180 889975 RENNER LOJA 157 903112 RENNER LOJA 48 903555 RENNER LOJA 43 904394 RENNER LOJA 26 904581 RENNER LOJA 86 904695 RENNER LOJA 45 904697 RENNER LOJA 191 905413 RENNER LOJA 114 905500 RENNER LOJA 256 905523 RENNER LOJA 245 905524 RENNER LOJA 189 905547 RENNER LOJA 33 905560 RENNER 113 BAURU 905585 RENNER LOJA 125 905703 RENNER LOJA 295 905704 RENNER LOJA 131 905743 RENNER LOJA 50 905768 RENNER LJ 176 906239 RENNER LOJA 66 906264 RENNER LOJA 149 906388 RENNER LJ 232 907001 RENNER LOJA 302 908056 RENNER LOJA 262 908064 RENNER LOJA 67 908261 RENNER LJ 103 908399 RENNER LOJA 179 908555 RENNER LOJA 197 908735 RENNER LOJA 166 909244 RENNER LOJA 277 909311 RENNER LOJA 39 909458 RENNER LOJA 129 909785 RENNER LOJA 264 909786 RENNER LOJA 111 910002 RENNER LOJA 260 910281 RENNER LOJA 329 910863 RENNER LOJA 127 911226 RENNER LOJA 96 72441 RENNER LOJA 80 72442 RENNER LOJA 87 890319 RENNER LJ 182 908447 RENNER LOJA 105 911631 RENNER LJ 163 892605 RENNER LOJA 233 905361 RENNER LJ 324 907736 RENNER LOJA 68 909230 RENNER LOJA 119 909231 RENNER LOJA 07 909783 RENNER LOJA 192 909802 RENNER LOJA 05 909811 RENNER LOJA 28 910260 RENNER LJ 172 907572 RENNER LOJA 269 908044 RENNER LJ 159 908767 RENNER LOJA 307 909304 RENNER LOJA 47 912448 RENNER LOJA 142 912422 RENNER LOJA 72 913302"},{"id":"66a536c4-5ab0-4681-6028-08d5ad2bf6ba","name":"SUB-CONDOMINIO SHOPPING CENTER BARRASHOPPINGSUL","commercialName":"","cnpj":"10429828000113","city":"PORTO ALEGRE","stateCode":"RS","buscaAdicional":"BARRASHOPPINGSUL 53406 BARRASHOPPINGSUL 902680 BARRASHOPPINSUL 912533"},{"id":"a7c6532b-20ad-447e-600f-08d5ad2bf6ba","name":"SLC AGRICOLA S.A.","commercialName":"","cnpj":"89096457000155","city":"PORTO ALEGRE","stateCode":"RS","buscaAdicional":"SLC AGRICOLA 53361 SLC PARNAIBA 906328"},{"id":"ba2ec231-9ad4-4cab-5ff0-08d5ad2bf6ba","name":"IRMANDADE DA SANTA CASA DE MISERICORDIA DE PORTO ALEGRE","commercialName":"","cnpj":"92815000000168","city":"PORTO ALEGRE","stateCode":"RS","buscaAdicional":"ST CASA PORTO ALEGRE 53291 STA CASA P ALEGRE 900842"},{"id":"6757193d-3d7c-4ddc-5f0a-08d5ad2bf6ba","name":"REAL EMPREENDIMENTOS S A","commercialName":"","cnpj":"92213552000104","city":"PORTO ALEGRE","stateCode":"RS","buscaAdicional":"SHOPPING MONET 52715 REAL EMPREENDIMENTOS 905951"},{"id":"6c0524eb-f43c-484f-5f31-08d5ad2bf6ba","name":"ASSOCIACAO EDUCADORA SAO CARLOS - AESC","commercialName":"HOSPITAL MAE DE DEUS","cnpj":"88625686002443","city":"PORTO ALEGRE","stateCode":"RS","buscaAdicional":"AESC HMD 52841 ASSOCIACAO SAO CARLO 901084"},{"id":"3b11d867-e1ca-477f-5b1d-08d5ad2bf6ba","name":"ASSOCIACAO HOSPITALAR MOINHOS DE VENTO","commercialName":"","cnpj":"92685833000151","city":"PORTO ALEGRE","stateCode":"RS","buscaAdicional":"HOSPITAL MOINHOS 50472 HOSPITAL MOINHOS 897667"},{"id":"4a43641e-9918-46bd-5a4f-08d5ad2bf6ba","name":"GERDAU ACOS ESPECIAIS S.A.","commercialName":"GERDAU ACOS ESPECIAIS PIRATINI","cnpj":"07359641000186","city":"PORTO ALEGRE","stateCode":"RS","buscaAdicional":"GAEB SA 17337 GERDAU ACOS ESPECIAL 896824 GERDAU ACOS 230KV 896864"},{"id":"eff5570f-1260-4474-5c1e-08d5ad2bf6ba","name":"PREDIAL E ADMINISTRADORA HOTEIS PLAZA S A","commercialName":"PLAZA SAO RAFAEL HOTEL E CENTRO DE EVENTOS","cnpj":"92784537000108","city":"PORTO ALEGRE","stateCode":"RS","buscaAdicional":"PLAZA SAO RAFAEL 51094 HOTEIS PLAZA 899712"},{"id":"f6147291-00ad-460d-594e-08d5ad2bf6ba","name":"VENTOS DE POVO NOVO S.A.","commercialName":"","cnpj":"19934269000173","city":"PORTO ALEGRE","stateCode":"RS","buscaAdicional":"VENTOS POVO 14233"},{"id":"29b4bce4-fff9-49aa-594f-08d5ad2bf6ba","name":"VENTOS DE VERA CRUZ S.A.","commercialName":"","cnpj":"19934240000191","city":"PORTO ALEGRE","stateCode":"RS","buscaAdicional":"VENTOS VERA 14234"},{"id":"a4c1e3d9-e584-4006-5950-08d5ad2bf6ba","name":"VENTOS DE CURUPIRA S.A.","commercialName":"","cnpj":"19934261000107","city":"PORTO ALEGRE","stateCode":"RS","buscaAdicional":"VENTOS CURUPIRA 14235"},{"id":"95c2e813-1a6f-47db-59eb-08d5ad2bf6ba","name":"BIOTERMICA ENERGIA S.A.","commercialName":"","cnpj":"09618374000140","city":"PORTO ALEGRE","stateCode":"RS","buscaAdicional":"BIOTERMICA RECREIO 15895 BIOTERMICA RECREIO 895321 UTE.RU.RS.030541-3.01"},{"id":"2f299b77-397c-4163-5a41-08d5ad2bf6ba","name":"ALPHA INFRAESTRUTURA LTDA","commercialName":"ALPHA INFRAESTRUTURA","cnpj":"14391923000126","city":"PORTO ALEGRE","stateCode":"RS","buscaAdicional":"ALPHA INFRAESTRUTURA 17238"},{"id":"51367abe-923f-455e-5883-08d5ad2bf6ba","name":"LOJAS RENNER S.A.","commercialName":"RENNER","cnpj":"92754738001568","city":"PORTO ALEGRE","stateCode":"RS","buscaAdicional":"RENNER RS 12112 RENNER RS 001 890618 RENNER RS 891282 RENNER RS 002 891473 RENNER LOJA 110 892413 RENNER LOJA 15 892549 RENNER LOJA 93 894205"},{"id":"9feea05b-72ea-43cb-5074-08d5ad2bf6ba","name":"YARA BRASIL FERTILIZANTES S/A","commercialName":"","cnpj":"92660604000182","city":"PORTO ALEGRE","stateCode":"RS","buscaAdicional":"YARA BRASIL 1634 YARA-RIO GRANDE 70093 BUNGE FERTIL RGRANDE 70155 BUNGE FERT CANOAS 7441 YARA BRASIL 905256"},{"id":"8a616522-eb0c-4331-5110-08d5ad2bf6ba","name":"COMPANHIA ESTADUAL DE DISTRIBUICAO DE ENERGIA ELETRICA - CEEE-D","commercialName":"CEEE DISTRIBUICAO","cnpj":"08467115000100","city":"PORTO ALEGRE","stateCode":"RS","buscaAdicional":"CEEE DISTRIB 1970 CEEE 29 CEEE DITC SJE 72313"},{"id":"4e46dff9-9036-4f23-5119-08d5ad2bf6ba","name":"BIANCHINI SA INDUSTRIA COMERCIO E AGRICULTURA","commercialName":"","cnpj":"87548020000180","city":"PORTO ALEGRE","stateCode":"RS","buscaAdicional":"BIANCHINI SA 1991 BIANCHINI 888980 BIANCHINI CN 888983"},{"id":"8e9347de-53d7-4de5-50ad-08d5ad2bf6ba","name":"FITESA NAOTECIDOS S/A","commercialName":"","cnpj":"93211084000193","city":"PORTO ALEGRE","stateCode":"RS","buscaAdicional":"FITESA 1779 FITESA GRAVATAI RS 70187 FITESA COSMOPOLIS 908422"},{"id":"d515c882-7fad-4a33-50b8-08d5ad2bf6ba","name":"GKN DO BRASIL LTDA","commercialName":"","cnpj":"58512310000175","city":"PORTO ALEGRE","stateCode":"RS","buscaAdicional":"GKN 1797 GKN POA 899283 GKN CHARQUEADAS 901656"},{"id":"96ad392b-87dd-423b-50d1-08d5ad2bf6ba","name":"ALIBEM ALIMENTOS S.A.","commercialName":"","cnpj":"03941052000150","city":"PORTO ALEGRE","stateCode":"RS","buscaAdicional":"ALIBEM_MATRIZ 1859 ALIBEM-S ANGELO-RS 70231 ALIBEM-SANTA ROSA 70964 ALIBEM-FABR RACOES 71438 ALIBEM - NOVA SANTA 905820"},{"id":"d7de4b8a-7bf9-4bb8-4fea-08d5ad2bf6ba","name":"FIBRAPLAC - PAINEIS DE MADEIRA S/A","commercialName":"FIBRAPLAC","cnpj":"04176791000166","city":"PORTO ALEGRE","stateCode":"RS","buscaAdicional":"FIBRAPLAC 1358 FIBRAPLAC-GLORINHA 7038"},{"id":"48985b63-f90e-4de9-4ee4-08d5ad2bf6ba","name":"COMPANHIA ESTADUAL DE GERACAO E TRANSMISSAO DE ENERGIA ELETRICA - CEEE-GT","commercialName":"CEEE GERACAO E TRANSMISSAO","cnpj":"92715812000131","city":"PORTO ALEGRE","stateCode":"RS","buscaAdicional":"CEEE-GT 12 PASSO REAL 266 UHE.PH.RS.002003-6.01 PASSO DO INFERNO 277 PCH.PH.RS.001998-4.01 JACUI 267 UHE.PH.RS.001217-3.01 IJUIZINHO 279 PCH.PH.RS.027405-4.01 HERVAL 275 PCH.PH.RS.001085-5.01 GUARITA 273 PCH.PH.RS.001076-6.01 ITAUBA 268 UHE.PH.RS.027019-9.01 TOCA 278 CGH.PH.RS.002853-3.01 IVAI 280 CGH.PH.RS.001199-1.01 DONA FRANCISCA 519 UHE.PH.RS.027012-1.01 FORQUILHA 276 PCH.PH.RS.000976-8.01 ERNESTINA 272 PCH.PH.RS.000898-2.01 CAPIGUI 271 PCH.PH.RS.000654-8.01 CANASTRA 270 UHE.PH.RS.000635-1.01 BUGRES 269 UHE.PH.RS.000324-7.01 SANTA ROSA 274 PCH.PH.RS.026730-9.01"},{"id":"ef4b0529-2911-4628-5331-08d5ad2bf6ba","name":"PARQUES EOLICOS PALMARES S/A","commercialName":"PARQUES EOLICOS PALMARES","cnpj":"10754152000133","city":"PORTO ALEGRE","stateCode":"RS","buscaAdicional":"PALMARES 3504 PALMARES EOL (PALM) 889053 EOL.CV.RS.028855-1.01 FAZ ROSARIO 8855 EOL.CV.RS.030343-7.01 FAZ ROSARIO 3 8856 EOL.CV.RS.030334-8.01 FAZ ROSARIO 2 3LER 888228 EOL.CV.RS.030478-6.01"},{"id":"e5a636d5-2eab-4dff-5332-08d5ad2bf6ba","name":"VENTOS DO LITORAL ENERGIA S.A.","commercialName":"VENTOS DO LITORAL","cnpj":"11627075000113","city":"PORTO ALEGRE","stateCode":"RS","buscaAdicional":"LITORAL 3505 OSORIO 3 888113 EOL.CV.RS.030449-2.01 OSORIO 2 20053 EOL.CV.RS.030286-4.01"},{"id":"4c1d4e0b-64f6-4ded-532f-08d5ad2bf6ba","name":"VENTOS DA LAGOA ENERGIA S.A","commercialName":"VENTOS DA LAGOA","cnpj":"11603076000128","city":"PORTO ALEGRE","stateCode":"RS","buscaAdicional":"LAGOA 3502 SANGRADOURO III 8993 EOL.CV.RS.030330-5.01 SANGRADOURO II 20052 EOL.CV.RS.030381-0.01"},{"id":"85f01939-14cd-4cbb-5762-08d5ad2bf6ba","name":"COMPANHIA ZAFFARI COMERCIO E INDUSTRIA","commercialName":"ZAFFARI","cnpj":"93015006000113","city":"PORTO ALEGRE","stateCode":"RS","buscaAdicional":"ZAFFARI 8769 ZAFFARI LJ 32 888840 ZAFFARI LJ 31 888841 ZAFFARI LJ 12 888842 ZAFFARI LJ 14 888843 ZAFFARI LJ 02 888844 LOJA 10 PASSO FUNDO 888845 ZAFFARI LJ 27 - OTTO 888847 ZAFFARI LJ 30 888875 ZAFFARI LJ 28 889073 LJ 33 CAXIAS SINIMBU 890012 BOURBON P F LJ 21 890895 ZAFFARI LJ 06 890915 ZAFFARI LJ 34 891082 ZAFFARI LOJA 29 891221 ZAFFARI LJ 11 891241 ZAFFARI LOJA 03 895984 ZAFFARI LOJA 09 895985 LOJA 15 HIGIENOPOLIS 895986 LOJA 016 CR COLOMBO 895987 LOJA 020 - BOURBON 895988 LOJA 017 - CAVALHADA 896004 LOJA 18 LIMA E SILVA 896006 ZAFFARI LJ 19 896065 LOJA 008 - IPIRANGA 896085 LOJA 007 - CABRAL 896688 ZAFFARI LOJA 37 897908 CD ZAFFARI POA - CD 898110 ZAFFARI LOJA 05 898128 LOJA 004 R DA PRAIA 898608 SHOP NOVO HAMBURGO 900762 ZAFFARI LOJA 39 HIP 906479 CANOAS PARK LJ 042 910693 LOJA 022 BOURBON IPI 896066 LOJA 024 BB COUNTRY 896104 ZAFFARI LJ 61 SP 898629 LOJA 100 - HIPER SP 897502 LOJA 025 - BB WALLIG 899166"},{"id":"240e4f68-359e-4ca5-576c-08d5ad2bf6ba","name":"VONPAR REFRESCOS S A","commercialName":"","cnpj":"91235549002407","city":"PORTO ALEGRE","stateCode":"RS","buscaAdicional":"VONPAR REFRESC 8815 VONPAR REFRESCO 889393"},{"id":"558c52d3-36b6-461a-57c2-08d5ad2bf6ba","name":"SUBCONDOMINIO PRAIA DE BELAS SHOPPING CENTER","commercialName":"PRAIA DE BELAS SHOPPING CENTER","cnpj":"94347283000196","city":"PORTO ALEGRE","stateCode":"RS","buscaAdicional":"SHOP P BELAS 9590 IGUATEMI P BELAS 01 889699 IGUATEMI P BELAS 2 889700"},{"id":"fea68e26-dcf3-43ae-5665-08d5ad2bf6ba","name":"WMS SUPERMERCADOS DO BRASIL LTDA.","commercialName":"","cnpj":"93209765000117","city":"PORTO ALEGRE","stateCode":"RS","buscaAdicional":"WMS SUPER 7001 4 - BIG JOINVILLE 888287 S200 - BIG CAMBORIU 888290 S010 - BIG CFCUNHA 888291 S042 - JUVEVE -PR 888578 S044 - PORTAO - PR 888579 S053 -BOA VISTA - PR 888580 S055 - XAXIM - PR 888581 S090 PINHEIRINHO PR 888582 WMS 144 888645 S006 - AV DAS TORRES 888898 WMS S071 888945 WMS S046 888946 S418 CD PINHAIS 889953 WMS S108 890175 WMS S022 890176 S161 SANTO ANGELO 890390 097A SHOP AMERICANAS 890391 S873 REBOUCAS 890898 WMS S003 891223 S394 - CHAPECO 894825 WMS 97 BIG JOINVILLE 894943 S209 BIG IGUATEMI 908954 BIG FOZ DO IGUACU 909227 BIG CRISTAL 7 909321 BIG VIAMAO 96 909322 BIG SERTORIO S079 909474 CD PORTO ALEGRE S400 909475 S341 BIG SAPIRANGA 910673 S310 BIG SANTA CRUZ 910692 S385 BIG SANTA MARIA 910771 S083 BIG S. LEOPOLDO 910853 BIG ESTEIO 910890 S123 BIG BLUMENAU 911091 S075 BIG CANOAS 911264 S018 BIG NOVO HAMBUR 911597 S227 LAURO D FREITAS 892246 WMS S240 PAU DA LIMA 892248"},{"id":"60344f40-98ac-4e49-564d-08d5ad2bf6ba","name":"HIDRO JET EQUIPAMENTOS HIDRAULICOS LTDA","commercialName":"HIDRO JET","cnpj":"90952052000231","city":"PORTO ALEGRE","stateCode":"RS","buscaAdicional":"HIDRO JET POA 6858 HIDRO JET II - RS 888529"},{"id":"09c9c48c-c621-4e20-5481-08d5ad2bf6ba","name":"CELULOSE IRANI S.A.","commercialName":"IRANI","cnpj":"92791243000103","city":"PORTO ALEGRE","stateCode":"RS","buscaAdicional":"IRANI 4304 IND.PAP. SAO ROBERTO 7921 IRANI-INDAIATUBA SP 71581 IRANI 138 V BONITA 71706 IRANI - S LUZIA 70484"},{"id":"09e96c65-6789-4407-5505-08d5ad2bf6ba","name":"CJ HYDRO - GERACAO DE ENERGIA S.A","commercialName":"CJ HYDRO","cnpj":"11288954000168","city":"PORTO ALEGRE","stateCode":"RS","buscaAdicional":"CJ HYDRO 4901 TOCA DO TIGRE 889211 PCH.PH.RS.028969-8.01"},{"id":"fc44d8c4-cec7-4caf-553f-08d5ad2bf6ba","name":"VENTOS DOS INDIOS ENERGIA S.A.","commercialName":"VENTOS DOS INDIOS","cnpj":"11622264000101","city":"PORTO ALEGRE","stateCode":"RS","buscaAdicional":"INDIOS 5195 INDIOS 3 889889 EOL.CV.RS.030894-3.01 INDIOS 2 893224 EOL.CV.RS.030734-3.01"},{"id":"37900af3-e0ac-4b00-5513-08d5ad2bf6ba","name":"NCER EOLICA CORREDOR DO SENANDES 2 S/A","commercialName":"","cnpj":"14531063000189","city":"RIO GRANDE","stateCode":"RS","buscaAdicional":"NCER CS2 5004 CORREDOR SENANDES 2 893444 EOL.CV.RS.030842-0.01"},{"id":"a1453909-6b8b-4b62-5514-08d5ad2bf6ba","name":"NCER EOLICA CORREDOR DO SENANDES III S.A.","commercialName":"","cnpj":"14492568000181","city":"RIO GRANDE","stateCode":"RS","buscaAdicional":"NCER CSIII 5005 CORREDOR SENANDES 3 893442 EOL.CV.RS.030819-6.01"},{"id":"0bec3d03-f7b6-4462-5515-08d5ad2bf6ba","name":"NCER EOLICA CORREDOR DO SENANDES IV S/A","commercialName":"","cnpj":"14528941000107","city":"RIO GRANDE","stateCode":"RS","buscaAdicional":"NCER CSIV 5006 CORREDOR SENANDES IV 893323 EOL.CV.RS.030840-4.01"},{"id":"e484dfaa-6a59-4360-5516-08d5ad2bf6ba","name":"NCER EOLICA VENTO ARAGANO I S/A","commercialName":"","cnpj":"14492644000159","city":"RIO GRANDE","stateCode":"RS","buscaAdicional":"NCER VAI 5007 VENTO ARAGANO I 893445 EOL.CV.RS.030833-1.01"},{"id":"695db7cf-d96a-4ca7-507c-08d5ad2bf6ba","name":"TIMAC AGRO INDUSTRIA E COMERCIO DE FERTILIZANTES LTDA","commercialName":"","cnpj":"02329713000200","city":"RIO GRANDE","stateCode":"RS","buscaAdicional":"TIMACAGRO RG 1649 TIMAC-RIO GRANDE 7152"},{"id":"6959901b-480e-4180-59b6-08d5ad2bf6ba","name":"EOL VENTO ENERGIAS RENOVAVEIS S.A.","commercialName":"","cnpj":"14095008000193","city":"RIO GRANDE","stateCode":"RS","buscaAdicional":"EOL VENTO 15435 REB CASSINO 1 2LFA 890656 EOL.CV.RS.030469-7.01"},{"id":"40f19dcf-89f7-4ab7-59b7-08d5ad2bf6ba","name":"EOL WIND ENERGIAS RENOVAVEIS S.A.","commercialName":"","cnpj":"14094988000100","city":"RIO GRANDE","stateCode":"RS","buscaAdicional":"EOL WIND 15436 REB CASSINO 2 2LFA 890658 EOL.CV.RS.030477-8.01"},{"id":"c2cf42ae-fb24-4463-59b8-08d5ad2bf6ba","name":"EOL BRISA ENERGIAS RENOVAVEIS S.A.","commercialName":"","cnpj":"14095035000166","city":"RIO GRANDE","stateCode":"RS","buscaAdicional":"EOL BRISA 15437 REB CASSINO 3 2LFA 890657 EOL.CV.RS.030468-9.01"},{"id":"d6d132c5-681e-4342-6498-08d5ad2bf6ba","name":"TECON RIO GRANDE S/A","commercialName":"","cnpj":"01640625000180","city":"RIO GRANDE","stateCode":"RS","buscaAdicional":"TECON RIO GRANDE 56115 TECON RIO GRANDE 905962"},{"id":"afcbc873-79f8-418d-61af-08d5ad2bf6ba","name":"SUPERMERCADO GUANABARA S.A.","commercialName":"SUPERMERCADO GUANABARA","cnpj":"94846755000155","city":"RIO GRANDE","stateCode":"RS","buscaAdicional":"SUPERMERCADO GUANABARA 54340 GUANABARA CASSINO 907742 GUANABARA D.PEDRO II 907743 GUANABARA BRITO 907769 GUANABARA HIPERMERC 908052"},{"id":"e3de3fbb-8f09-4119-62bd-08d5ad2bf6ba","name":"INDUSTRIAS ALIMENTICIAS LEAL SANTOS LTDA","commercialName":"","cnpj":"01499844000191","city":"RIO GRANDE","stateCode":"RS","buscaAdicional":"IND AL LEAL SANTOS 54943 LEAL SANTOS 906460"},{"id":"945796c5-8e4b-4bd1-5ace-08d5ad2bf6ba","name":"FUTURE INDUSTRIA DE COUROS LTDA","commercialName":"","cnpj":"04509941000459","city":"ROCA SALES","stateCode":"RS","buscaAdicional":"FUTURE 50247 FUTURE RS 899111"},{"id":"5ba6fdb7-6f0c-439f-6081-08d5ad2bf6ba","name":"CALCADOS BEIRA RIO S/A","commercialName":"","cnpj":"88379771001588","city":"ROCA SALES","stateCode":"RS","buscaAdicional":"BEIRA RIO ROCA SALES 53551 CALCADOS BEIRA RIO 2 905943"},{"id":"bbab78ab-8219-4b76-53a8-08d5ad2bf6ba","name":"CRELUZ - COOPERATIVA DE GERACAO DE ENERGIA E DESENVOLVIMENTO","commercialName":"CRELUZ-G","cnpj":"10677244000167","city":"RODEIO BONITO","stateCode":"RS","buscaAdicional":"CRELUZ 3750 CASCATA DO BARREIRO 8806 CGH.PH.RS.029551-5.01 MOINHO (CRELUZ) 8807 CGH.PH.RS.028690-7.01 LINHA GRANJA VELHA 8808 CGH.PH.RS.028572-2.01 RIO FORTALEZA 8809 CGH.PH.RS.027100-4.01 CARLOS BEVILACQUA 8810 CGH.PH.RS.028688-5.01 BRAGA 8811 CGH.PH.RS.028510-2.01"},{"id":"f1de5fed-8aef-4324-6471-08d5ad2bf6ba","name":"COOP REGIONAL SANANDUVA DE CARNES E DERIVADOS LTDA","commercialName":"","cnpj":"95323275000172","city":"SANANDUVA","stateCode":"RS","buscaAdicional":"MAJESTADE 56007 COOP SANANDUVA 906474"},{"id":"83118f6a-80bf-436e-6409-08d5ad2bf6ba","name":"PHILIP MORRIS BRASIL INDUSTRIA E COMERCIO LTDA.","commercialName":"","cnpj":"04041933001311","city":"SANTA CRUZ DO SUL","stateCode":"RS","buscaAdicional":"PHILIP MORRIS 55796 PHILIP MORRIS 905950"},{"id":"3682732c-8a58-4560-688b-08d5ad2bf6ba","name":"SULPRINT EMBALAGENS INDUSTRIAIS LTDA","commercialName":"","cnpj":"95422697000103","city":"SANTA CRUZ DO SUL","stateCode":"RS","buscaAdicional":"SULPRINT 60130 SULPRINT EMBALAGENS 910605 SULPRINT VERA CRUZ 910911"},{"id":"62ba794d-2a63-4677-693c-08d5ad2bf6ba","name":"FRIGORIFICO RIO PARDINHO LTDA","commercialName":"","cnpj":"89140388000130","city":"SANTA CRUZ DO SUL","stateCode":"RS","buscaAdicional":"SCHENDER 60854 FRIGORIFICO RIO PARD 912339"},{"id":"e9ff0458-d58a-4e6c-668e-08d5ad2bf6ba","name":"ASSOCIACAO PRO ENSINO EM SANTA CRUZ DO SUL","commercialName":"HOSPITAL SANTA CRUZ","cnpj":"95438412001277","city":"SANTA CRUZ DO SUL","stateCode":"RS","buscaAdicional":"HOSPITAL SANTA CRUZ 57654 HOSPITAL STA CRUZ 909679"},{"id":"9b241e9d-4886-44b2-6689-08d5ad2bf6ba","name":"GASTAO SCHWENGBER & CIA LTDA","commercialName":"","cnpj":"91186445000163","city":"SANTA CRUZ DO SUL","stateCode":"RS","buscaAdicional":"GASTAO 57636 GASTAO SCHWENGBER 909377"},{"id":"0740ebd4-3de9-4516-1cbb-08d5b8870181","name":"JTI PROCESSADORA DE TABACO DO BRASIL LTDA.","commercialName":"JTI BRASIL","cnpj":"03334170000109","city":"SANTA CRUZ DO SUL","stateCode":"RS","buscaAdicional":"JTI LEAF 61095 JTI LEAF 912599 JTI GSC 913516"},{"id":"6720b956-25e8-4832-5593-08d5ad2bf6ba","name":"SOUZA CRUZ LTDA","commercialName":"","cnpj":"33009911033819","city":"SANTA CRUZ DO SUL","stateCode":"RS","buscaAdicional":"SOUZA CRUZ RS2 5838 SOUZA CRUZ SCRUZ SUL 71941"},{"id":"f85ed02c-4913-494b-57df-08d5ad2bf6ba","name":"EXCELSIOR ALIMENTOS SA.","commercialName":"","cnpj":"95426862000197","city":"SANTA CRUZ DO SUL","stateCode":"RS","buscaAdicional":"EXCELSIOR ALIMENTOS 9849 EXCELSIOR STA CRUZ 899268"},{"id":"78da3f59-5c52-4950-573d-08d5ad2bf6ba","name":"PREMIUM TABACOS DO BRASIL S/A","commercialName":"","cnpj":"05325515000185","city":"SANTA CRUZ DO SUL","stateCode":"RS","buscaAdicional":"PREMIUM BRASIL 8374 PREMIUM TABACOS 889390"},{"id":"da842cd0-6697-4126-5751-08d5ad2bf6ba","name":"GERMANI ALIMENTOS LTDA","commercialName":"","cnpj":"90058082000118","city":"SANTA CRUZ DO SUL","stateCode":"RS","buscaAdicional":"GERMANI 8551 GERMANI MATRIZ 889505"},{"id":"e074748d-9854-4d63-575a-08d5ad2bf6ba","name":"MERCUR S A","commercialName":"","cnpj":"93896397000122","city":"SANTA CRUZ DO SUL","stateCode":"RS","buscaAdicional":"MERCUR 8650 MERCUR 1 888990 MERCUR II 889503"},{"id":"09c0e7ee-b568-4a37-5ad6-08d5ad2bf6ba","name":"XALINGO SA INDUSTRIA E COMERCIO","commercialName":"","cnpj":"95425534000176","city":"SANTA CRUZ DO SUL","stateCode":"RS","buscaAdicional":"XALINGO 50273 XALINGO 898798"},{"id":"a9bc9778-977a-488c-5ad7-08d5ad2bf6ba","name":"ASSOCIACAO PRO ENSINO EM SANTA CRUZ DO SUL","commercialName":"","cnpj":"95438412000114","city":"SANTA CRUZ DO SUL","stateCode":"RS","buscaAdicional":"UNISC 50274 UNISC 898868"},{"id":"f36f21b5-c647-44be-583d-08d5ad2bf6ba","name":"METALURGICA MOR SA","commercialName":"","cnpj":"95422218000140","city":"SANTA CRUZ DO SUL","stateCode":"RS","buscaAdicional":"METALURGICA MOR 11073 METALURGICA MOR 889861"},{"id":"572a13b9-b495-4b5c-5aef-08d5ad2bf6ba","name":"CVI REFRIGERANTES LTDA","commercialName":"","cnpj":"72114994000188","city":"SANTA MARIA","stateCode":"RS","buscaAdicional":"CVI 50362 CVI REFRIGERANTES RS 898646"},{"id":"08ad67f1-5ca5-4981-5b1b-08d5ad2bf6ba","name":"CORRIERI ALIMENTOS LTDA.","commercialName":"FABRICA CORRIERI","cnpj":"95592697000143","city":"SANTA MARIA","stateCode":"RS","buscaAdicional":"CORRIERI 50470 CORRIERI ALIMENTOS 899728"},{"id":"e202da30-064b-4104-5b44-08d5ad2bf6ba","name":"ANTONIAZZI E CIA LTDA","commercialName":"MOINHO SANTA MARIA","cnpj":"95597647000159","city":"SANTA MARIA","stateCode":"RS","buscaAdicional":"MOINHO SANTA MARIA 50555 ANTONIAZZI E CIA 900084"},{"id":"fcc086fd-58b9-4fab-5b45-08d5ad2bf6ba","name":"MOINHO DE TRIGO IPIRANGA - EM RECUPERACAO JUDICIAL","commercialName":"MOINHO IPIRANGA","cnpj":"87640637000120","city":"SANTA MARIA","stateCode":"RS","buscaAdicional":"MOINHO IPIRANGA 50556 ADELINO ANTONIAZZI 899942"},{"id":"412dc9bf-91c3-4cb8-5ac5-08d5ad2bf6ba","name":"FRIGORIFICO SILVA INDUSTRIA E COMERCIO LTDA","commercialName":"","cnpj":"88728027000146","city":"SANTA MARIA","stateCode":"RS","buscaAdicional":"FRIGSILVA 50235 FRIGORIFICO SILVA 899147"},{"id":"95b57520-068f-4487-5bd8-08d5ad2bf6ba","name":"HOSPITAL DE CARIDADE DR ASTROGILDO DE AZEVEDO","commercialName":"","cnpj":"95610887000146","city":"SANTA MARIA","stateCode":"RS","buscaAdicional":"HCAA 50945 HCAA 900077"},{"id":"4dcbe376-f294-4371-5eec-08d5ad2bf6ba","name":"SOCIEDADE VICENTE PALLOTTI","commercialName":"GRAFICA EDITORA PALLOTTI, DE SANTA MARIA","cnpj":"95602942001985","city":"SANTA MARIA","stateCode":"RS","buscaAdicional":"GRAFICA PALLOTTI 52610 GRAFICA PALLOTTI 905905"},{"id":"ebb7bc75-9c8b-4ae8-5ee8-08d5ad2bf6ba","name":"SOCIEDADE VICENTE PALLOTTI","commercialName":"CERAMICA PALLOTTI E ARTEFATOS DE CIMENTO","cnpj":"95602942000580","city":"SANTA MARIA","stateCode":"RS","buscaAdicional":"CERAMICA PALLOTTI 52606 CERAMICA PALLOTTI 904105"},{"id":"d296ece1-16cc-42a5-5caa-08d5ad2bf6ba","name":"MARZARI ALIMENTOS LTDA","commercialName":"","cnpj":"95600235000120","city":"SANTA MARIA","stateCode":"RS","buscaAdicional":"MARZARI 51492 MARZARI ALIMENTOS 900039"},{"id":"21005020-9f65-4c55-1ca2-08d5b8870181","name":"LIBRAGA, BRANDAO & CIA LTDA","commercialName":"","cnpj":"91292987000110","city":"SANTA MARIA","stateCode":"RS","buscaAdicional":"LIBRAGA BRANDAO 60089 LIBRAGA - LOJA 16 913483 LIBRAGA - LOJA 31 913484 LIBRAGA - LOJA 01 913504 LIBRAGA - LOJA 18 913517 LIBRAGA - LOJA 03 913518 LIBRAGA - LOJA 20 913519 CGH COLORADO 913402 PCH.PH.RS.000797-8.01 PCH MATA COBRA 913617 PCH.PH.RS.001433-8.01"},{"id":"5542c2ae-e1ef-46e7-8d87-08d5d060706e","name":"SOC CARIT E LIT SAO FRANCISCO DE ASSIS ZONA NORTE","commercialName":"SCALIFRA-ZN","cnpj":"95606380000119","city":"SANTA MARIA","stateCode":"RS","buscaAdicional":"UNIFRA 60855 UNIFRA - NUC 5016661 913485 UNIFRA - NUC 5139065 913520"},{"id":"15a27b38-b90e-46b8-659b-08d5ad2bf6ba","name":"SANTAMATE INDUSTRIA E COMERCIO LTDA","commercialName":"","cnpj":"01706643000118","city":"SANTA MARIA","stateCode":"RS","buscaAdicional":"SANTAMATE 56856 SANTAMATE 911908"},{"id":"b6952de9-9dfd-4d95-65a1-08d5ad2bf6ba","name":"METALURGICA COFELMA LTDA","commercialName":"COFELMA","cnpj":"87030904000148","city":"SANTA MARIA","stateCode":"RS","buscaAdicional":"COFELMA 56874 METALURGICA COFELMA 908204"},{"id":"72f3c41d-ac88-486f-65c2-08d5ad2bf6ba","name":"EDIFICIO SANTA MARIA SHOPPING","commercialName":"","cnpj":"02759271000150","city":"SANTA MARIA","stateCode":"RS","buscaAdicional":"SHOP SANTA MARIA 57053 SHOP SANTA MARIA RS 908547"},{"id":"922d8209-b931-4c37-68bf-08d5ad2bf6ba","name":"SUPERMERCADOS BELTRAME LTDA.","commercialName":"","cnpj":"95597571000161","city":"SANTA MARIA","stateCode":"RS","buscaAdicional":"BELTRAME 60390 BELTRAME - FILIAL 05 911893"},{"id":"a2ad9b3d-c9cc-4542-684b-08d5ad2bf6ba","name":"R044 SANTA MARIA 2 EMPREENDIMENTOS E PARTICIPACOES LTDA.","commercialName":"","cnpj":"21162019000104","city":"SANTA MARIA","stateCode":"RS","buscaAdicional":"SHOP STA SANTA MARIA-ALIANSCE 59667 HOP STA SANTA MARIA 911288"},{"id":"eae643e1-2699-4438-640f-08d5ad2bf6ba","name":"PANIFICIO MALLET LTDA","commercialName":"","cnpj":"02753746000100","city":"SANTA MARIA","stateCode":"RS","buscaAdicional":"MALLET 55812 PANIFICIO MALLET 907252"},{"id":"681ad98a-99f7-47de-639e-08d5ad2bf6ba","name":"CLUBE RECREATIVO DORES","commercialName":"","cnpj":"89248819000186","city":"SANTA MARIA","stateCode":"RS","buscaAdicional":"CLUBE DORES 55484 CLUBE DORES SOCIAL 905921 CLUBE DORES CAMPESTR 907257"},{"id":"c752d934-311a-468f-61e0-08d5ad2bf6ba","name":"ROYAL PLAZA EMPREENDIMENTOS S/A","commercialName":"ROYAL PLAZA SHOPPING CENTER","cnpj":"09208399000175","city":"SANTA MARIA","stateCode":"RS","buscaAdicional":"ROYAL PLAZA 54454 ROYAL PLAZA 906465"},{"id":"9169b51c-b1af-4685-5ac8-08d5ad2bf6ba","name":"FRIGORIFICO E DISTRIBUIDORA DE CARNES BOA VISTA LTDA","commercialName":"","cnpj":"03899917000168","city":"SANTA MARIA DO HERVAL","stateCode":"RS","buscaAdicional":"BOAVISTA CE 50238 CARNES BOA VISTA RS 899140"},{"id":"561f3fe1-7d18-492f-5ba4-08d5ad2bf6ba","name":"METALURGICA CANDEIA LTDA.","commercialName":"","cnpj":"02116027000170","city":"SANTA ROSA","stateCode":"RS","buscaAdicional":"METAL CANDEIA 50806 METALURGICA CANDEIA 902182"},{"id":"244f11ac-ff78-4565-572b-08d5ad2bf6ba","name":"CAMERA AGROALIMENTOS S.A","commercialName":"","cnpj":"98248644000106","city":"SANTA ROSA","stateCode":"RS","buscaAdicional":"CAMERA AGR MAT 8271 CAMERA ESTRELA 888316 CAMERA SAO BORJA 888317 CAMERA STO CRISTO 888574 CAMERA SANTO ANGELO 911596 CAMERA SANTO AUGUSTO 911622"},{"id":"6b6e818b-96e3-4193-5677-08d5ad2bf6ba","name":"CAMERA AGROALIMENTOS S.A","commercialName":"","cnpj":"98248644000602","city":"SANTA ROSA","stateCode":"RS","buscaAdicional":"CAMERA AGRO 7160 CAMERA AGRO STA ROSA 72357 CAMERA AGRO S L GONZ 72358 CAMERA AGROALIMENTOS 72417"},{"id":"a43302dd-e7be-4c4e-53a5-08d5ad2bf6ba","name":"COOPERLUZ- COOPERATIVA DE GERACAO DE ENERGIA E DESENVOLVIMENTO","commercialName":"COOPERLUZ","cnpj":"08925309000102","city":"SANTA ROSA","stateCode":"RS","buscaAdicional":"COOPERLUZ 3744 S.ANTONIO(COOPERLUZ) 8115 PCH.PH.RS.029050-5.01 CARAGUATA 8749 CGH.PH.RS.028740-7.01 BELA UNIAO 895003 PCH.PH.RS.030879-0.01"},{"id":"976e17c7-5e5e-4b5b-1cd9-08d5b8870181","name":"AGCO DO BRASIL SOLUCOES AGRICOLAS LTDA.","commercialName":"","cnpj":"55962369001734","city":"SANTA ROSA","stateCode":"RS","buscaAdicional":"AGCO DO BRASIL SANTA ROSA 62419"},{"id":"0c431d7b-c603-4f49-886c-08d5ae44ed50","name":"VONPAR REFRESCOS S A","commercialName":"","cnpj":"91235549000978","city":"SANTO ÂNGELO","stateCode":"RS","buscaAdicional":"VONPAR 6157"},{"id":"10fdbbea-dbc0-4e68-67a2-08d5ad2bf6ba","name":"UNIVERSAL INDUSTRIA DE PLASTICOS LTDA","commercialName":"","cnpj":"02669452000196","city":"SANTO ÂNGELO","stateCode":"RS","buscaAdicional":"UNIVERSAL PLASTICOS 58375 UNIVERSAL PLASTICOS 909650"},{"id":"a55501bc-b19a-4006-67a9-08d5ad2bf6ba","name":"CALLEGARO & IRMAOS LTDA","commercialName":"MARCHANTERIA CALLEGARO","cnpj":"02999886000154","city":"SANTO ÂNGELO","stateCode":"RS","buscaAdicional":"CALLEGARO 58404 CALLEGARO 908639"},{"id":"3590ef97-7450-427b-50f4-08d5ad2bf6ba","name":"FUNDIMISA - FUNDICAO E USINAGEM LTDA.","commercialName":"","cnpj":"07032076000148","city":"SANTO ÂNGELO","stateCode":"RS","buscaAdicional":"FUNDIMISA RS 1920 FUNDIMISA RS 888347"},{"id":"c53db4c3-df0f-47cc-7231-08d5cf600bef","name":"CONCESSIONARIA DA RODOVIA OSORIO PORTO ALEGRE SA - CONCEPA","commercialName":"","cnpj":"01654604000114","city":"SANTO ANTÔNIO DA PATRULHA","stateCode":"RS","buscaAdicional":""},{"id":"c4213e35-25cf-48f2-68a7-08d5ad2bf6ba","name":"J A TEIXEIRA VETERINARIA LTDA","commercialName":"PURO TRATO NUTRICAO ANIMAL","cnpj":"92730902000100","city":"SANTO AUGUSTO","stateCode":"RS","buscaAdicional":"JA TEIXEIRA 60250 JA TEIXEIRA VETERIN 910039"},{"id":"816b02a6-31ac-45ab-1ca5-08d5b8870181","name":"IMEMBUY ALIMENTOS SA","commercialName":"IMEMBUY ALIMENTOS SA","cnpj":"96486568000133","city":"SÃO BORJA","stateCode":"RS","buscaAdicional":"IMEMBUY 60399 IMEMBUY NUC 2167625 912781"},{"id":"3366446b-6c5a-445e-513e-08d5ad2bf6ba","name":"CRIUVA ENERGETICA S/A.","commercialName":"","cnpj":"07094315000194","city":"SÃO FRANCISCO DE PAULA","stateCode":"RS","buscaAdicional":"PCH CRIUVA 2061 CRIUVA 8683 PCH.PH.RS.029002-5.01"},{"id":"2b8af949-c072-4c37-59d2-08d5ad2bf6ba","name":"CAZUZA FERREIRA ENERGETICA SA","commercialName":"PCH CAZUZA FERREIRA","cnpj":"17201404000146","city":"SÃO FRANCISCO DE PAULA","stateCode":"RS","buscaAdicional":"PCH CAZUZA FERREIRA 15637 CAZUZA FERREIRA 898152 PCH.PH.RS.000735-8.01"},{"id":"151dae2e-2b5c-4194-64d0-08d5ad2bf6ba","name":"SAO GABRIEL SANEAMENTO S.A","commercialName":"","cnpj":"15186494000118","city":"SÃO GABRIEL","stateCode":"RS","buscaAdicional":"SAO GABRIEL SANEAMENTO 56237 SAO GABRIEL SANEAMEN 909355"},{"id":"f6f25f32-a55e-4b44-5842-08d5ad2bf6ba","name":"CERTEL RASTRO DE AUTO GERACAO DE ENERGIA SA.","commercialName":"PCH RASTRO DE AUTO","cnpj":"10973187000163","city":"SÃO JOSÉ DO HERVAL","stateCode":"RS","buscaAdicional":"RASTRO DE AUTO 11129 RASTRO DE AUTO 890444 PCH.PH.RS.030287-2.01"},{"id":"a21f4110-241a-4881-5ed9-08d5ad2bf6ba","name":"MINERACAO ARROIO BONITO LTDA","commercialName":"","cnpj":"07337486000105","city":"SÃO JOSÉ DO HORTÊNCIO","stateCode":"RS","buscaAdicional":"VALLE VITA 52583 VALLE VITA 904484"},{"id":"e49489a2-8b86-476e-5f00-08d5ad2bf6ba","name":"CURTUME SULINO LTDA","commercialName":"","cnpj":"88221494000185","city":"SÃO JOSÉ DO HORTÊNCIO","stateCode":"RS","buscaAdicional":"CURTUME SULINO 52701 CURTUME SULINO LTDA 905949"},{"id":"eec29455-8732-4238-5f56-08d5ad2bf6ba","name":"ZAHONERO INDUSTRIA E COMERCIO DE ESPUMAS LTDA","commercialName":"ZAHONERO BRASIL","cnpj":"87439626000187","city":"SÃO LEOPOLDO","stateCode":"RS","buscaAdicional":"ZAHONERO 52906 ZAHONERO 903757"},{"id":"7592f65e-1fc1-49b5-5fba-08d5ad2bf6ba","name":"FERRAMENTAS GEDORE DO BRASIL SOCIEDADE ANONIMA","commercialName":"GEDORE","cnpj":"96736350000190","city":"SÃO LEOPOLDO","stateCode":"RS","buscaAdicional":"GEDORE 53201 GEDORE 903454"},{"id":"f85f1128-05d6-4784-5fa9-08d5ad2bf6ba","name":"UNIQUE RUBBER TECHNOLOGIES LTDA.","commercialName":"","cnpj":"87235297000152","city":"SÃO LEOPOLDO","stateCode":"RS","buscaAdicional":"UNIQUE CL 53072 UNIQUE RUBBER TECHNO 905954"},{"id":"0b4fc52a-55cf-4797-609e-08d5ad2bf6ba","name":"BOLZANO BRASIL INDUSTRIA DE COUROS E PELES LTDA","commercialName":"BOLZANO BRASIL","cnpj":"04923511000136","city":"SÃO LEOPOLDO","stateCode":"RS","buscaAdicional":"BOLZANO 53617 BOLZANO BRASIL 907249"},{"id":"5e491166-9887-4acf-60c1-08d5ad2bf6ba","name":"LUIZ FUGA INDUSTRIA DE COURO LTDA.","commercialName":"","cnpj":"03324048000143","city":"SÃO LEOPOLDO","stateCode":"RS","buscaAdicional":"LUIZ FUGA 53658 LUIZ FUGA 904284"},{"id":"bdc107f1-d590-4da9-5d0d-08d5ad2bf6ba","name":"SULCROMO REVESTIMENTOS INDUSTRIAIS LTDA","commercialName":"","cnpj":"87827457000314","city":"SÃO LEOPOLDO","stateCode":"RS","buscaAdicional":"SULCROMO 51688 SULCROMO REVESTIMENT 907260"},{"id":"3a86d795-18f7-4613-5cec-08d5ad2bf6ba","name":"ALISUL ALIMENTOS SA","commercialName":"SUPRA","cnpj":"89548523000180","city":"SÃO LEOPOLDO","stateCode":"RS","buscaAdicional":"ALISUL SAO LEOPOLDO 51613 ALISUL SAO LEOPOLDO 901086"},{"id":"ddb740b7-131e-4f77-5ea5-08d5ad2bf6ba","name":"ASSOCIACAO ANTONIO VIEIRA","commercialName":"UNIVERSIDADE DO VALE DO RIO DOS SINOS - UNISINOS","cnpj":"92959006000885","city":"SÃO LEOPOLDO","stateCode":"RS","buscaAdicional":"UNISINOS 52472 UNISINOS CAMPUS 902655 UNISINOS BIBLIOTECA 903967"},{"id":"a93dc71a-38bb-459e-5e8b-08d5ad2bf6ba","name":"STIHL FERRAMENTAS MOTORIZADAS LTDA.","commercialName":"","cnpj":"87235172000122","city":"SÃO LEOPOLDO","stateCode":"RS","buscaAdicional":"STIHL 52423 STIHL 904937"},{"id":"c9663ad6-e565-412e-5866-08d5ad2bf6ba","name":"GREFORTEC FORNOS INDUSTRIAIS E TRATAMENTO TERMICO LTDA","commercialName":"","cnpj":"94089455000179","city":"SÃO LEOPOLDO","stateCode":"RS","buscaAdicional":"GREFORTEC 11670 GREFORTEC 890214"},{"id":"4b23912d-e0ce-447e-5bd9-08d5ad2bf6ba","name":"POLIMETAL METALURGIA E PLASTICOS LTDA.","commercialName":"METALIC","cnpj":"89545511000100","city":"SÃO LEOPOLDO","stateCode":"RS","buscaAdicional":"POLIMETAL METALURGIA 50946 POLIMETAL 908581"},{"id":"4ec0158c-1594-42a5-5ad1-08d5ad2bf6ba","name":"AGROLONAS INDUSTRIA E COMERCIO DE PLASTICOS LTDA","commercialName":"","cnpj":"05005050000185","city":"SÃO LEOPOLDO","stateCode":"RS","buscaAdicional":"AGROLONAS 50268 AGROLONAS 899203"},{"id":"d5a79c9d-4e44-454e-5ad5-08d5ad2bf6ba","name":"WIGGA REVESTIMENTOS E ESQUADRIAS EM PVC LTDA","commercialName":"","cnpj":"07562528000101","city":"SÃO LEOPOLDO","stateCode":"RS","buscaAdicional":"WIGGA 50272 WIGGA 899181"},{"id":"8435dcbc-f706-47e5-5ada-08d5ad2bf6ba","name":"FREIOS CONTROIL LTDA","commercialName":"","cnpj":"90492695000169","city":"SÃO LEOPOLDO","stateCode":"RS","buscaAdicional":"CONTROIL 50290 FREIOS CONTROIL 898033"},{"id":"d0d27062-764c-45c2-5ae4-08d5ad2bf6ba","name":"BINS INDUSTRIA DE ARTEFATOS DE BORRACHA LTDA","commercialName":"BINS","cnpj":"96735162000147","city":"SÃO LEOPOLDO","stateCode":"RS","buscaAdicional":"BINS MAT 50332 BINS SAO LEOPOLDO 897988"},{"id":"143559ff-05ec-4624-5252-08d5ad2bf6ba","name":"PSA INDUSTRIAL DE PAPEL S A","commercialName":"","cnpj":"96735907000178","city":"SÃO LEOPOLDO","stateCode":"RS","buscaAdicional":"PSA 3001 PSA INDUSTRIAL 70977"},{"id":"fca525de-6d50-4593-4ede-08d5ad2bf6ba","name":"RGE SUL DISTRIBUIDORA DE ENERGIA S.A.","commercialName":"RGE SUL","cnpj":"02016440000162","city":"SÃO LEOPOLDO","stateCode":"RS","buscaAdicional":"RGE SUL 3 AES-SUL 28 AES-SUL DITC CAC 70682 AES-SUL DITC JAC 70684 AES-SUL DITC SJE 72312"},{"id":"b54ff649-7fdc-4369-5688-08d5ad2bf6ba","name":"FORJAS TAURUS SA","commercialName":"","cnpj":"92781335000102","city":"SÃO LEOPOLDO","stateCode":"RS","buscaAdicional":"TAURUS 7227 TAURUS SAO LEOPOLDO 908546 FORJAS TAURUS 889254"},{"id":"83866971-4137-4f66-61e1-08d5ad2bf6ba","name":"FRONTEC INDUSTRIA DE COMPONENTES DE FIXACAO LTDA","commercialName":"","cnpj":"72178353000197","city":"SÃO LEOPOLDO","stateCode":"RS","buscaAdicional":"FRONTEC 54455 FRONTEC INDUSTRIA 906467"},{"id":"9687b669-89a2-486e-6276-08d5ad2bf6ba","name":"BEPLAST INDUSTRIA E COMERCIO DE PLASTICOS LTDA","commercialName":"","cnpj":"94272036000178","city":"SÃO LEOPOLDO","stateCode":"RS","buscaAdicional":"BEPLAST 54767 BEPLAST RS 906491"},{"id":"1d3927c6-a531-4fbc-68b5-08d5ad2bf6ba","name":"BIEHL SA METALURGICA","commercialName":"","cnpj":"97276562000102","city":"SÃO LEOPOLDO","stateCode":"RS","buscaAdicional":"BIEHL METALURGICA 60308 BIEHL S METALURGICA 911892"},{"id":"69b98fb6-f6d8-47ad-684c-08d5ad2bf6ba","name":"ENSINGER INDUSTRIA DE PLASTICOS TECNICOS LTDA","commercialName":"","cnpj":"02727984000132","city":"SÃO LEOPOLDO","stateCode":"RS","buscaAdicional":"ENSINGER 59671 ENSINGER 910133"},{"id":"2ef81bdf-6d02-4b49-6690-08d5ad2bf6ba","name":"TFL DO BRASIL INDUSTRIA QUIMICA LTDA","commercialName":"","cnpj":"96734892000123","city":"SÃO LEOPOLDO","stateCode":"RS","buscaAdicional":"TFL DO BRASIL 57656 TFL DO BRASIL 909677"},{"id":"db8a22e3-d375-4ce9-73f4-08d5cf600bef","name":"ALTUS SISTEMAS DE AUTOMACAO S/A","commercialName":"","cnpj":"92859974000143","city":"SÃO LEOPOLDO","stateCode":"RS","buscaAdicional":""},{"id":"a737065a-0f32-458e-55bf-08d5ad2bf6ba","name":"NELSON METALURGIA LTDA","commercialName":"","cnpj":"14598570000130","city":"SÃO MARCOS","stateCode":"RS","buscaAdicional":"MASTER POWER 6058 MASTER POWER-SMARCOS 71955"},{"id":"96f785f2-d623-4651-530c-08d5ad2bf6ba","name":"INSTALADORA SAO MARCOS LTDA","commercialName":"","cnpj":"88624242000105","city":"SÃO MARCOS","stateCode":"RS","buscaAdicional":"BEPO 3452 BEPO SAO MARCOS 71091 BEPO MONTENEGRO 71207 BEPO S MARCOS(BEPO2) 72386"},{"id":"1f764101-1768-4a9d-5a7c-08d5ad2bf6ba","name":"BORGHETTI - TURBOS E SISTEMAS AUTOMOTIVOS LTDA","commercialName":"","cnpj":"05488253000170","city":"SÃO MARCOS","stateCode":"RS","buscaAdicional":"BORGHETTI TURBOS 49784 BORGHETTI TURBOS 896445"},{"id":"8e5ab822-0b74-418e-58b1-08d5ad2bf6ba","name":"FABBOF INDUSTRIA METALURGICA LTDA","commercialName":"","cnpj":"01886356000137","city":"SÃO MARCOS","stateCode":"RS","buscaAdicional":"FABBOF 12892 FABBOF SAO MARCOS 891843"},{"id":"6cd91904-2886-4f56-64dc-08d5ad2bf6ba","name":"PAGLIARIN & CIA LTDA","commercialName":"","cnpj":"97168066000127","city":"SÃO PEDRO DO SUL","stateCode":"RS","buscaAdicional":"PAGLIARIN 56284 PAGLIARIN E CIA 907264"},{"id":"58d0eeb7-3080-41de-668f-08d5ad2bf6ba","name":"MAX METALURGICA LTDA","commercialName":"","cnpj":"91913681000134","city":"SÃO SEBASTIÃO DO CAÍ","stateCode":"RS","buscaAdicional":"MAX METALURGICA 57655 MAX METALURGICA 909354"},{"id":"5ba057bd-f6ac-4e49-5d89-08d5ad2bf6ba","name":"RENOVADORA DE PNEUS HOFF S.A.","commercialName":"","cnpj":"97201362000425","city":"SÃO SEBASTIÃO DO CAÍ","stateCode":"RS","buscaAdicional":"HOFF CAI 51851 RENOVADORA HOFF 902745"},{"id":"5bd80978-c5a1-4850-5fca-08d5ad2bf6ba","name":"INDUSTRIAL SAO SEBASTIAO EIRELI","commercialName":"SAO SEBASTIAO","cnpj":"97192256000180","city":"SÃO SEBASTIÃO DO CAÍ","stateCode":"RS","buscaAdicional":"BALANCAS SAO SEBASTIAO 53222 IND SAO SEBASTIAO 904508"},{"id":"630c9d9b-3bb3-44a6-56f0-08d5ad2bf6ba","name":"AGROSUL AGROAVICOLA INDUSTRIAL S.A.","commercialName":"AGROSUL ALIMENTOS","cnpj":"88369889000634","city":"SÃO SEBASTIÃO DO CAÍ","stateCode":"RS","buscaAdicional":"AGROSUL CL 8003 AGROSUL AGROAVICOLA 888275"},{"id":"7e8bc6f8-1371-46d5-57be-08d5ad2bf6ba","name":"CONSERVAS ODERICH SA","commercialName":"ODERICH","cnpj":"97191902000194","city":"SÃO SEBASTIÃO DO CAÍ","stateCode":"RS","buscaAdicional":"ODERICH 9569 CONSERVAS ODERICH 889083"},{"id":"ce003486-45d9-4d95-6710-08d5ad2bf6ba","name":"ARROZEIRA SEPEENSE S A","commercialName":"","cnpj":"97223382000154","city":"SÃO SEPÉ","stateCode":"RS","buscaAdicional":"ARROZEIRA SEPEENSE 57944 ARROZEIRA SEPEENSE M 909351 ARROZEIRA SEPEENSE 1 909352 ARROZEIRA SEPEENSE 2 909353"},{"id":"46d5a8be-cff9-42a3-607d-08d5ad2bf6ba","name":"CALCADOS BEIRA RIO S/A","commercialName":"CALCADOS BEIRA RIO S/A","cnpj":"88379771003017","city":"SAPIRANGA","stateCode":"RS","buscaAdicional":"BEIRA RIO SAPIRANGA 53536 CALCADOS BEIRA RIO 904895"},{"id":"52d36de8-a669-4c9e-5cb9-08d5ad2bf6ba","name":"PAQUETA CALCADOS LTDA","commercialName":"PAQUETA","cnpj":"01098983009240","city":"SAPIRANGA","stateCode":"RS","buscaAdicional":"PAQUETA SAPIRANGA 51541 PAQUETA CALCADOS 904939"},{"id":"56ae0c86-bfb1-41ab-5e1d-08d5ad2bf6ba","name":"ALTERO DESIGN - INDUSTRIA E COMERCIO LTDA.","commercialName":"","cnpj":"89790356000180","city":"SAPIRANGA","stateCode":"RS","buscaAdicional":"ALTERO 52223 ALTERO DESIGN 903173"},{"id":"b95b649e-3ce2-4f86-5bc9-08d5ad2bf6ba","name":"PACIFIL BRASIL- INDUSTRIA , COMERCIO, IMPORTACAO E EXPORTACAO DE SILOS PLASTICOS LTDA","commercialName":"PACIFIL BRASIL","cnpj":"10940896000142","city":"SAPIRANGA","stateCode":"RS","buscaAdicional":"PACIFIL 50910 PACIFIL BRASIL 900020"},{"id":"47a770f2-6d55-47f0-5b7c-08d5ad2bf6ba","name":"RUBRAS LAMINADOS BRASILEIROS LTDA.","commercialName":"","cnpj":"02084145000143","city":"SAPIRANGA","stateCode":"RS","buscaAdicional":"RUBRAS 50731 RUBRAS SAPIRANGA RS 899604"},{"id":"d5925c9c-2f43-40e4-5b6a-08d5ad2bf6ba","name":"PAULUZZI PRODUTOS CERAMICOS LTDA","commercialName":"PAULUZZI","cnpj":"92275718000109","city":"SAPUCAIA DO SUL","stateCode":"RS","buscaAdicional":"PAULUZZI 50699 PAULUZZI 899308"},{"id":"9e5e5c21-93f0-49a1-56d7-08d5ad2bf6ba","name":"KURASHIKI DO BRASIL TEXTIL LTDA.","commercialName":"KURASHIKI","cnpj":"89729156000383","city":"SAPUCAIA DO SUL","stateCode":"RS","buscaAdicional":"KURASHIKI 7821 KURASHIKI RS 888681"},{"id":"b7ea9447-e7b7-4213-4efa-08d5ad2bf6ba","name":"DONA FRANCISCA ENERGETICA S.A.","commercialName":"","cnpj":"02832860000206","city":"SAPUCAIA DO SUL","stateCode":"RS","buscaAdicional":"DFESA 40"},{"id":"a38768dc-a43b-4e09-4ff9-08d5ad2bf6ba","name":"PARAMOUNT TEXTEIS INDUSTRIA E COMERCIO SA","commercialName":"KARIBE","cnpj":"61565222001380","city":"SAPUCAIA DO SUL","stateCode":"RS","buscaAdicional":"PARAMOUNT SUL 1380 PARAMOUNT SAPUCAIA 7563"},{"id":"7d1e5716-7898-468c-66cb-08d5ad2bf6ba","name":"ISDRALIT INDUSTRIA E COMERCIO LTDA - GRUPO ISDRA","commercialName":"","cnpj":"89938500000778","city":"SAPUCAIA DO SUL","stateCode":"RS","buscaAdicional":"ISDRALIT RS 57832 ISDRALIT 909841"},{"id":"696b4f51-3435-4a8c-62f8-08d5ad2bf6ba","name":"INDUSTRIA DE PECAS INPEL SA","commercialName":"INPEL","cnpj":"89723845000119","city":"SAPUCAIA DO SUL","stateCode":"RS","buscaAdicional":"INPEL 55063 INPEL IND DE PECAS 906484"},{"id":"deb65e58-54c6-4248-73e8-08d5cf600bef","name":"RECRUSUL S/A","commercialName":"","cnpj":"91333666000117","city":"SAPUCAIA DO SUL","stateCode":"RS","buscaAdicional":""},{"id":"a492fe02-29ab-498e-5db1-08d5ad2bf6ba","name":"INDUSTRIA DE MOVEIS FINGER LTDA","commercialName":"FINGER - MOVEIS PLANEJADOS","cnpj":"01559964000137","city":"SARANDI","stateCode":"RS","buscaAdicional":"MOVEIS FINGER 51958 MOVEIS FINGER 899348"},{"id":"400a9d65-4df3-4659-1cb0-08d5b8870181","name":"AGROPARR ALIMENTOS LTDA","commercialName":"","cnpj":"93607398000100","city":"SENTINELA DO SUL","stateCode":"RS","buscaAdicional":"AGROPARR 60844 AGROPARR ALIMENTO 912592"},{"id":"b852ec51-bfd3-445e-6078-08d5ad2bf6ba","name":"GRANO ALIMENTOS S.A.","commercialName":"","cnpj":"02106825000110","city":"SERAFINA CORRÊA","stateCode":"RS","buscaAdicional":"GRANO 53519 GRANO 902215"},{"id":"641f427d-3222-4e73-514f-08d5ad2bf6ba","name":"CREDEAL MANUFATURA DE PAPEIS LTDA","commercialName":"","cnpj":"87864237000107","city":"SERAFINA CORRÊA","stateCode":"RS","buscaAdicional":"CREDEAL 2109 CREDEAL MTZ S CORREA 70490"},{"id":"002b6fe4-90ed-40a1-5f63-08d5ad2bf6ba","name":"LINEU PINZON INDUSTRIA E COMERCIO DE CEREAIS LTDA","commercialName":"","cnpj":"88424585000118","city":"SERTÃO SANTANA","stateCode":"RS","buscaAdicional":"LINEU PINZON 52925 LINEU PINZON 904495"},{"id":"ae352dc4-8421-4156-5c95-08d5ad2bf6ba","name":"ROSINA ALIMENTOS EIRELI","commercialName":"","cnpj":"04253854000130","city":"SERTÃO SANTANA","stateCode":"RS","buscaAdicional":"ROSINA ALIMENTOS 51389 ROSINA ALIMENTOS 899146"},{"id":"2d877721-4876-4509-5bdb-08d5ad2bf6ba","name":"BIANCHINI INDUSTRIA DE PLASTICOS LTDA","commercialName":"PLASBIL","cnpj":"00373732000127","city":"TAPEJARA","stateCode":"RS","buscaAdicional":"PLASBIL 50948 PLASBIL 904019"},{"id":"97d8a4a3-1c31-48f9-5a0c-08d5ad2bf6ba","name":"MUXFELDT MARIN E CIA LTDA","commercialName":"MUXENERGIA","cnpj":"97578090000134","city":"TAPEJARA","stateCode":"RS","buscaAdicional":"MUX ENERGIA 16405 MUX ENERGIA 911572"},{"id":"5a9ccf9c-6e8b-4055-5fcc-08d5ad2bf6ba","name":"BEM ESTAR ALIMENTOS LTDA.","commercialName":"","cnpj":"18700410000100","city":"TAPES","stateCode":"RS","buscaAdicional":"BEM ESTAR 53225 BEM ESTAR ALIMENTOS 904994"},{"id":"16e1bcfd-0e77-44a7-6049-08d5ad2bf6ba","name":"MOINHO TAQUARIENSE LTDA","commercialName":"","cnpj":"97834188000105","city":"TAQUARI","stateCode":"RS","buscaAdicional":"MOTASA 53452 MOTASA 906493"},{"id":"b1a2a350-96e0-4383-5d77-08d5ad2bf6ba","name":"CALCADOS BEBECE LTDA","commercialName":"","cnpj":"90445206000118","city":"TRÊS COROAS","stateCode":"RS","buscaAdicional":"BEBECE 51829 CALCADOS BEBECE 904803"},{"id":"a16c1f30-60e3-41de-5c82-08d5ad2bf6ba","name":"ENDUTEX BRASIL LTDA.","commercialName":"","cnpj":"00849898000177","city":"TRÊS COROAS","stateCode":"RS","buscaAdicional":"ENDUTEX BRASIL 51363 INDUTEX BRASIL 898782"},{"id":"19d9e7d9-1eea-4507-5c85-08d5ad2bf6ba","name":"COOPERATIVA DE DESENVOLVIMENTO SOCIAL ENTRE RIOS LTDA","commercialName":"CERTHIL DESENVOLVIMENTO","cnpj":"10415935000192","city":"TRÊS DE MAIO","stateCode":"RS","buscaAdicional":"CERTHIL DESENVOLVIMENTO 51367 PCH BURICA 908282 PCH.PH.RS.000329-8.01"},{"id":"99b16fd5-932d-40ce-5cb4-08d5ad2bf6ba","name":"VIDEOLAR-INNOVA S/A","commercialName":"INNOVA","cnpj":"04229761001142","city":"TRIUNFO","stateCode":"RS","buscaAdicional":"VIDEOLAR-INNOVA 51512 VIDEOLAR - INNOVA 7070"},{"id":"d3bddfa2-9c89-4810-5cdf-08d5ad2bf6ba","name":"ARLANXEO BRASIL S.A.","commercialName":"","cnpj":"29667227001220","city":"TRIUNFO","stateCode":"RS","buscaAdicional":"ARLANXEO HPE 51597 LANXESS HPE 7406"},{"id":"5337c738-73f8-43b0-5070-08d5ad2bf6ba","name":"ARLANXEO BRASIL S.A.","commercialName":"","cnpj":"29667227000681","city":"TRIUNFO","stateCode":"RS","buscaAdicional":"ARLANXEO TSR TRIUNFO 1625 PETROFLEX-TRIUNFO 7147"},{"id":"548c86db-87e1-40c6-56a9-08d5ad2bf6ba","name":"MOVEIS K1 LTDA","commercialName":"MOVEIS KAPPESBERG","cnpj":"00912882000161","city":"TUPANDI","stateCode":"RS","buscaAdicional":"KAPPESBERG 7480 KAPPESBERG MOVEIS K1 72344 MOVEIS K1 888197"},{"id":"1756a850-091b-438f-4edf-08d5ad2bf6ba","name":"AES URUGUAIANA EMPREENDIMENTOS SA","commercialName":"","cnpj":"01600202000137","city":"URUGUAIANA","stateCode":"RS","buscaAdicional":"AES URUGUAIANA 4 AES URUGUAIANA 281 UTE.GN.RS.002913-0.01 URUGUAIANA EXP 8281 UTE.GN.RS.002913-0.01"},{"id":"1588526f-fe01-401c-5ea1-08d5ad2bf6ba","name":"COOPERATIVA AGRICOLA URUGUAIANA LIMITADA","commercialName":"CAUL","cnpj":"98408610000204","city":"URUGUAIANA","stateCode":"RS","buscaAdicional":"CAUL 52468 COOP AGRI URUGUAIANA 905714"},{"id":"6bc5c97c-b326-49c0-5fb3-08d5ad2bf6ba","name":"SCHIO CEREAIS IMPORTACAO E EXPORTACAO LTDA","commercialName":"SCHIO CEREAIS","cnpj":"55509582000128","city":"VACARIA","stateCode":"RS","buscaAdicional":"SCHIO CEREAIS 53190 SCHIO VACARIA 899346"},{"id":"0f2777b1-1248-405c-5ee0-08d5ad2bf6ba","name":"RASIP ALIMENTOS LTDA","commercialName":"","cnpj":"94789468000150","city":"VACARIA","stateCode":"RS","buscaAdicional":"RASIP POMAR 52598 RASIP POMAR 899816 RASIP INDUSTRIA 904446"},{"id":"c1f126b4-860d-4724-57eb-08d5ad2bf6ba","name":"MOINHO VACARIA INDUSTRIAL E AGRICOLA LTDA","commercialName":"MOINHO VACARIA","cnpj":"98513187000474","city":"VACARIA","stateCode":"RS","buscaAdicional":"MOINHO VACARIA 10069 MOINHO VACARIA 889279"},{"id":"18a499cf-7929-4b6b-579a-08d5ad2bf6ba","name":"RODOPLAST INDUSTRIA E COMERCIO DE COMPONENTES PLASTICOS LTDA","commercialName":"RODOPLAST","cnpj":"05920019000170","city":"VACARIA","stateCode":"RS","buscaAdicional":"RODOPLAST 9149 RODOPLAST 888595"},{"id":"ea0bdae9-58c9-461d-55a9-08d5ad2bf6ba","name":"AGROPECUARIA SCHIO LTDA","commercialName":"","cnpj":"91501783000819","city":"VACARIA","stateCode":"RS","buscaAdicional":"SCHIO 5977 AGROP SCHIO VACARIA 71936"},{"id":"071baadd-bcca-46ae-628b-08d5ad2bf6ba","name":"SUMABRAS DO BRASIL - INDUSTRIA E COMERCIO DE SUCOS DE MACA LTDA.","commercialName":"","cnpj":"17321958000187","city":"VACARIA","stateCode":"RS","buscaAdicional":"SUMABRAS 54798 SUMABRAS DO BRASIL 904943"},{"id":"a676f66b-6c6b-4d16-61c0-08d5ad2bf6ba","name":"COOPERATIVA AGROPECUARIA DOS CAMPOS DE CIMA DA SERRA - COOPAGRO","commercialName":"COOPAGRO","cnpj":"09516099000153","city":"VACARIA","stateCode":"RS","buscaAdicional":"COOPAGRO 54380 COOPAGRO 905920"},{"id":"fb32659c-2e14-4485-63d0-08d5ad2bf6ba","name":"RUBIFRUT AGROINDUSTRIAL LTDA","commercialName":"","cnpj":"91349183000100","city":"VACARIA","stateCode":"RS","buscaAdicional":"RUBIFRUT 55640 RUBIFRUT 905367"},{"id":"8adaf69e-5077-45bd-5ef2-08d5ad2bf6ba","name":"STAR PEX INDUSTRIA DE VIDROS E ABERTURAS LTDA","commercialName":"STAR PEX INDUSTRIA DE VIDROS E ABERTURAS - EPP","cnpj":"14801362000196","city":"VALE REAL","stateCode":"RS","buscaAdicional":"STARPEX 52622 STAR PEX 902716"},{"id":"b1241b07-ff3b-4576-5f42-08d5ad2bf6ba","name":"VENAX ELETRODOMESTICOS LTDA","commercialName":"","cnpj":"90295338000100","city":"VENÂNCIO AIRES","stateCode":"RS","buscaAdicional":"VENAX 52877 VENAX ELETRO 904510"},{"id":"942a8bb4-cdd3-40ae-5fc3-08d5ad2bf6ba","name":"FUNDICAO VENANCIO AIRES LTDA","commercialName":"FAIRES","cnpj":"90689118000161","city":"VENÂNCIO AIRES","stateCode":"RS","buscaAdicional":"FAIRES 53214 FUND VENANCIO AIRES 905716"},{"id":"4e913418-656f-49eb-5e8c-08d5ad2bf6ba","name":"AMERICA TAMPAS S.A.","commercialName":"","cnpj":"01008482000199","city":"VENÂNCIO AIRES","stateCode":"RS","buscaAdicional":"AMERICA TAMPAS 52429 AMERICA TAMPAS 902674"},{"id":"96afba5f-37a8-4a43-5e68-08d5ad2bf6ba","name":"VHM VIDROS LTDA","commercialName":"VA CURVOS","cnpj":"14800964000129","city":"VENÂNCIO AIRES","stateCode":"RS","buscaAdicional":"VHM VIDROS 52371 VHM VIDROS LTDA 901068"},{"id":"534e17a0-82ed-4147-5b1a-08d5ad2bf6ba","name":"METALURGICA VENANCIO LTDA","commercialName":"","cnpj":"93899359000123","city":"VENÂNCIO AIRES","stateCode":"RS","buscaAdicional":"VENANCIO METAL 50464 METALURGICA VENANCIO 898794"},{"id":"028c931b-5d9a-4d9f-5b2d-08d5ad2bf6ba","name":"FAMILIA KROTH INDUSTRIA E COMERCIO DE CARNES LTDA","commercialName":"FRIGORIFICO KROTH","cnpj":"87392338000114","city":"VENÂNCIO AIRES","stateCode":"RS","buscaAdicional":"KROTH 50505 FAMILIA KROTH 898988"},{"id":"a8a5ca34-982c-4668-657c-08d5ad2bf6ba","name":"REFRIMATE ENGENHARIA DO FRIO LTDA","commercialName":"REFRIMATE","cnpj":"03379983000107","city":"VENÂNCIO AIRES","stateCode":"RS","buscaAdicional":"REFRIMATE 56741 REFRIMATE ENG FRIO 909330"},{"id":"dd6dbbd9-00b4-4ec2-66a6-08d5ad2bf6ba","name":"MADEIREIRA HAAS LTDA","commercialName":"","cnpj":"98597917000110","city":"VENÂNCIO AIRES","stateCode":"RS","buscaAdicional":"MADEIREIRA HAAS 57721 MADEIREIRA HAAS 912479"},{"id":"002b598c-0ffd-49f9-56f6-08d5ad2bf6ba","name":"ROMETAL COMPONENTES PARA MOVEIS LTDA","commercialName":"ROMETAL COMPONENTES PARA MOVEIS","cnpj":"06925691000110","city":"VERANÓPOLIS","stateCode":"RS","buscaAdicional":"ROMETAL 8040 ROMETAL FILIAL 72438 ROMETAL VER 898668"},{"id":"4768a5b9-3aca-4215-55ea-08d5ad2bf6ba","name":"OLEOPLAN S.A. OLEOS VEGETAIS PLANALTO","commercialName":"","cnpj":"88676127000257","city":"VERANÓPOLIS","stateCode":"RS","buscaAdicional":"OLEOPLAN 6298 OLEOPLAN-VERANOPOLIS 72003"},{"id":"f7fecd5b-fe96-4332-5127-08d5ad2bf6ba","name":"METALURGICA GOLDEN ART S LTDA","commercialName":"MGA E SUFLON","cnpj":"94354271000199","city":"VERANÓPOLIS","stateCode":"RS","buscaAdicional":"MGA MTA 2024 MGA III VERANOPOLIS 70415 MGA 5-VERANOPOLIS RS 71662"},{"id":"f176e2b9-9612-4296-51e0-08d5ad2bf6ba","name":"MIPEL INDUSTRIA E COMERCIO DE VALVULAS LTDA","commercialName":"","cnpj":"07743815000290","city":"VERANÓPOLIS","stateCode":"RS","buscaAdicional":"MIPEL 2692 MIPEL-VERANOPOLIS-RS 70211"},{"id":"b58cfb6f-f0c0-4a1e-53f1-08d5ad2bf6ba","name":"FORCA DOS VENTOS ENERGIA EOLICA S.A","commercialName":"","cnpj":"12752290000109","city":"VIAMÃO","stateCode":"RS","buscaAdicional":"ENERPLAN 3928 PONTAL 2B 2LFA 890659 EOL.CV.RS.030460-3.01"},{"id":"cfaefc57-6307-41e2-595e-08d5ad2bf6ba","name":"ENERPLAN ENERGIA EOLICA IV S.A.","commercialName":"","cnpj":"15355380000154","city":"VIAMÃO","stateCode":"RS","buscaAdicional":"ENERPLAN IV 14317 PONTAL 2A 896925 EOL.CV.RS.031509-5.01"},{"id":"bce4e82c-8666-4456-58bc-08d5ad2bf6ba","name":"ENERPLAN ENERGIA EOLICA III S.A.","commercialName":"","cnpj":"15355485000103","city":"VIAMÃO","stateCode":"RS","buscaAdicional":"ENERPLAN III 13072 PONTAL 3B 889891 EOL.CV.RS.030901-0.01"},{"id":"b80d4812-afae-492a-624a-08d5ad2bf6ba","name":"TRIVIALY ALIMENTOS LTDA","commercialName":"TRIVIALY-TRIVY","cnpj":"02291422000199","city":"VIAMÃO","stateCode":"RS","buscaAdicional":"TRIVIALY 54674 TRIVIALY 906266"},{"id":"e1e689b9-49bf-43a3-5475-08d5ad2bf6ba","name":"ALUMICONTE COMPONENTES DE ALUMINIO LTDA","commercialName":"","cnpj":"92175892000180","city":"VILA FLORES","stateCode":"RS","buscaAdicional":"ALUMICONTE 4273 ALUMICONTE-V FLORES 71507"},{"id":"cc9e7c64-1c9b-48ce-5498-08d5ad2bf6ba","name":"MICROMAZZA-PMP LTDA","commercialName":"","cnpj":"72096100000174","city":"VILA FLORES","stateCode":"RS","buscaAdicional":"MICROMAZZA 4355 MICROMAZZA-RS 71556"},{"id":"3f14515f-19a8-46ba-550d-08d5ad2bf6ba","name":"SEBO MARIENSE LTDA.","commercialName":"","cnpj":"03119115000198","city":"VILA MARIA","stateCode":"RS","buscaAdicional":"SEBO MARIENSE 4962 SEBO-VILA MARIA RS 71725"},{"id":"be70aa08-fde7-4a07-53e9-08d5ad2bf6ba","name":"AUTODROMO ENERGETICA S/A","commercialName":"","cnpj":"07647793000184","city":"VISTA ALEGRE DO PRATA","stateCode":"RS","buscaAdicional":"AUTODROMO 3905 AUTODROMO 8935 PCH.PH.RS.029071-8.01"},{"id":"dd2da761-4344-4fb1-5995-08d5ad2bf6ba","name":"HONDA ENERGY DO BRASIL LTDA.","commercialName":"","cnpj":"17793994000143","city":"XANGRI-LÁ","stateCode":"RS","buscaAdicional":"HONDA ENERGY 14975 XANGRI-LA 894643 EOL.CV.RS.031302-5.01"},{"id":"14a03b1d-9814-49a0-65cf-08d5ad2bf6ba","name":"GREENPLAC TECNOLOGIA INDUSTRIAL LTDA","commercialName":"GREENPLAC","cnpj":"03801905000582","city":"ÁGUA CLARA","stateCode":"MS","buscaAdicional":"GREENPLAC 57142 GREENPLAC TECNOLOGIA 910954"},{"id":"47612887-46e1-462a-5399-08d5ad2bf6ba","name":"ADECOAGRO VALE DO IVINHEMA S.A.","commercialName":"","cnpj":"07903169000109","city":"ANGÉLICA","stateCode":"MS","buscaAdicional":"UTE ANGELICA 3710 AMANDINA CONSUMO 893502 ANGELICA 8469 UTE.AI.MS.029670-8.01 AMANDINA 893482 UTE.AI.MS.030115-9.01"},{"id":"0995e419-0ac9-47f3-57d9-08d5ad2bf6ba","name":"FRIGOSUL - FRIGORIFICO SUL LTDA","commercialName":"FRIGOSUL","cnpj":"02591772000170","city":"APARECIDA DO TABOADO","stateCode":"MS","buscaAdicional":"FRIGOSUL 9771 FRIGOSUL - MS 902698 FRIGOSUL AP DOESTE 907075"},{"id":"eebd9990-7a4f-47f0-606d-08d5ad2bf6ba","name":"PLASTRELA EMBALAGENS FLEXIVEIS LTDA","commercialName":"PLASTRELA","cnpj":"90816133000123","city":"APARECIDA DO TABOADO","stateCode":"MS","buscaAdicional":"PLASTRELA MS 53504 PLASTRELA MS 911304"},{"id":"aae1a2ad-eff5-4da7-65d9-08d5ad2bf6ba","name":"GALA - IBB INDUSTRIA BRASILEIRA DE BRINQUEDOS E EMBALAGENS LTDA","commercialName":"GALA","cnpj":"05861238000125","city":"APARECIDA DO TABOADO","stateCode":"MS","buscaAdicional":"GALA 57167 GALA BRINQUEDOS EMB 907146"},{"id":"29bc3958-0a83-40bf-6456-08d5ad2bf6ba","name":"GENESEAS AQUACULTURA LTDA","commercialName":"","cnpj":"04459073000369","city":"APARECIDA DO TABOADO","stateCode":"MS","buscaAdicional":"GENESEAS 55937 GENESEAS AQUACULTURA 907790"},{"id":"12266533-159b-423b-88be-08d5ae44ed50","name":"BELLO ALIMENTOS LTDA","commercialName":"FRANGO OURO","cnpj":"08201770000538","city":"APARECIDA DO TABOADO","stateCode":"MS","buscaAdicional":"FRANGO OURO 50623"},{"id":"7e261cb2-6047-4fd3-64e1-08d5ad2bf6ba","name":"LATICINIO VALE DO PARDO LTDA","commercialName":"LATICINIO VALE DO PARDO","cnpj":"02749513000125","city":"BATAGUASSU","stateCode":"MS","buscaAdicional":"VALE DO PARDO 56289 LATICINIO VAL D PARD 912495"},{"id":"4099994d-2e56-4587-5ff4-08d5ad2bf6ba","name":"CERAMICA ISABELA LTDA","commercialName":"CERAMICA ISABELA","cnpj":"06864352000171","city":"BATAYPORÃ","stateCode":"MS","buscaAdicional":"CERAMICA ISABELA 53313 CERAMICA ISABELA 903784"},{"id":"1389bdc4-a90c-4d32-5f79-08d5ad2bf6ba","name":"MINERVA S.A.","commercialName":"INDUSTRIA E COMERCIO DE CARNES MINERVA","cnpj":"67620377001358","city":"BATAYPORÃ","stateCode":"MS","buscaAdicional":"MINERVA BPA 52968 MINERVA SA 904360"},{"id":"01a6efd2-a8eb-4159-650d-08d5ad2bf6ba","name":"MINERACAO ORO-YTE LTDA","commercialName":"","cnpj":"01576503000172","city":"BELA VISTA","stateCode":"MS","buscaAdicional":"ORO YTE 56455 ORO YTE 906222"},{"id":"3b2e2d4a-16c2-43f1-5937-08d5ad2bf6ba","name":"BIOENERGIA CAARAPO LTDA","commercialName":"","cnpj":"19275443000113","city":"CAARAPÓ","stateCode":"MS","buscaAdicional":"BIO CAARAPO 14138 CAARAPO CONSUMO 910266 CAARAPO 8681 UTE.AI.MS.030104-3.01"},{"id":"8bda627b-113b-41f2-589a-08d5ad2bf6ba","name":"ENERGIA MAIA LTDA","commercialName":"","cnpj":"08809676000132","city":"CAMPO GRANDE","stateCode":"MS","buscaAdicional":"CGH ENERGIA MAIA 12692 MAIA 893902 CGH.PH.MS.030049-7.01"},{"id":"fe210747-0ef4-4255-5fea-08d5ad2bf6ba","name":"MIMF INDUSTRIA DE MATERIAIS FERROVIARIOS EIRELI","commercialName":"MATESFERRO","cnpj":"01550182000137","city":"CAMPO GRANDE","stateCode":"MS","buscaAdicional":"MIMF 53284 MIMF INDUSTRIA 904184"},{"id":"ced1136c-5a1a-405b-6053-08d5ad2bf6ba","name":"CONDOMINIO SHOPPING CENTER BOSQUE DOS IPES","commercialName":"CONDOMINIO SHOPPING CENTER BOSQUE DOS IPES","cnpj":"22604658000145","city":"CAMPO GRANDE","stateCode":"MS","buscaAdicional":"SHOP BOSQUE DOS IPES 53466 SHOP BOSQUE DOS IPES 904116"},{"id":"0ec85e8f-d0af-41c0-5757-08d5ad2bf6ba","name":"BRASRAFIA INDUSTRIA E COMERCIO DE EMBALAGENS LTDA","commercialName":"","cnpj":"08672803000102","city":"CAMPO GRANDE","stateCode":"MS","buscaAdicional":"BRASRAFIA 8630 BRASRAFIA 899740"},{"id":"7eda1201-fa54-42ef-564e-08d5ad2bf6ba","name":"VETORIAL SIDERURGIA LTDA","commercialName":"VETORIAL BH","cnpj":"03543379000174","city":"CAMPO GRANDE","stateCode":"MS","buscaAdicional":"VETORIAL 6878 VETORIAL SIDERURGIA 898107 VETORIAL 888682 UTE.FL.MS.029236-2.01 VETORIAL 888682 UTE.FL.MS.029236-2.01"},{"id":"dd169824-5c6f-4dda-54ef-08d5ad2bf6ba","name":"CONDOMINIO NORTE SUL","commercialName":"CONDOMINIO NORTE SUL","cnpj":"13568881000193","city":"CAMPO GRANDE","stateCode":"MS","buscaAdicional":"NORTESULSHOP 4597 COND NORTE SUL 71794"},{"id":"3c828f18-c4b0-45f8-4f03-08d5ad2bf6ba","name":"ENERGISA MATO GROSSO DO SUL - DISTRIBUIDORA DE ENERGIA S.A.","commercialName":"ENERGISA","cnpj":"15413826000150","city":"CAMPO GRANDE","stateCode":"MS","buscaAdicional":"ENERGISA MS 52 ENERSUL-SUL 4 ENERSUL SE 31 ENERSUL DITCSP 72306"},{"id":"a8d4cb83-4463-48dd-4f6c-08d5ad2bf6ba","name":"AGUAS GUARIROBA SA","commercialName":"AGUAS GUARIROBA","cnpj":"04089570000150","city":"CAMPO GRANDE","stateCode":"MS","buscaAdicional":"AGUAS GUARIROBA 1096 AGUAS GUARIROBA 905710"},{"id":"ff093be2-c4b7-493b-641f-08d5ad2bf6ba","name":"SEVEN - ADMINISTRACAO E PARTICIPACAO LTDA","commercialName":"","cnpj":"02139652000137","city":"CAMPO GRANDE","stateCode":"MS","buscaAdicional":"SEVEN 55848 SEVEN NOVOTEL 906628 SEVEN IBIS 906630 SEVEN BUDGET 906639"},{"id":"14978314-5b21-4516-62c0-08d5ad2bf6ba","name":"MISSAO SALESIANA DE MATO GROSSO","commercialName":"INSPETORIA DE CAMPO GRANDE","cnpj":"03226149000181","city":"CAMPO GRANDE","stateCode":"MS","buscaAdicional":"MSMT 54954 UNISALESIANO LINS 906652 UNISALESIANO ARACATU 906653"},{"id":"675bd525-aa1f-40c1-611d-08d5ad2bf6ba","name":"INDUSPAN INDUSTRIA E COMERCIO DE COUROS PANTANAL LTDA","commercialName":"","cnpj":"73737686000171","city":"CAMPO GRANDE","stateCode":"MS","buscaAdicional":"INDUSPAN 54026 INDUSPAN PANTANAL 904557"},{"id":"6b913fb6-c870-4124-6596-08d5ad2bf6ba","name":"SEMALO INDUSTRIA E COMERCIO DE ALIMENTOS LTDA","commercialName":"SEMALO INDUSTRIA E COMERCIO DE ALIMENTOS","cnpj":"36804268000123","city":"CAMPO GRANDE","stateCode":"MS","buscaAdicional":"SEMALO 56837 SEMALO IND COM ALIME 906242"},{"id":"b259c9c0-c2b4-4c2f-6681-08d5ad2bf6ba","name":"PATENA INDUSTRIA E COMERCIO DE RESINAS E FILMES PLASTICOS LTDA","commercialName":"PATENA LTDA","cnpj":"08869805000188","city":"CAMPO GRANDE","stateCode":"MS","buscaAdicional":"PATENA 57624 PATENA 908505"},{"id":"0af07be7-9b25-4d58-665d-08d5ad2bf6ba","name":"TELEVISAO MORENA LIMITADA","commercialName":"REDE MATOGROSSENSE DE TELEVISAO","cnpj":"03229937000121","city":"CAMPO GRANDE","stateCode":"MS","buscaAdicional":"TV MORENA 57511 TELEVISAO MORENA MS 908191"},{"id":"58d2364b-21a6-49d5-66b5-08d5ad2bf6ba","name":"L M VIDROS E CRISTAIS TEMPERADOS LTDA","commercialName":"","cnpj":"33178088000195","city":"CAMPO GRANDE","stateCode":"MS","buscaAdicional":"LM VIDROS 57749 LM VIDROS E CRISTAIS 909286"},{"id":"58c0af96-bc7f-4479-6799-08d5ad2bf6ba","name":"MISSAO SALESIANA DE MATO GROSSO","commercialName":"MSMT - UNIVERSIDADE CATOLICA DOM BOSCO","cnpj":"03226149001587","city":"CAMPO GRANDE","stateCode":"MS","buscaAdicional":"UCDB 58331 UNIV CAT DOM BOSCO 907944"},{"id":"9406847b-ff47-442e-4ee4-08d5d159243d","name":"CONCESSIONARIA DE RODOVIA SUL - MATOGROSSENSE S.A","commercialName":"CONCESSIONARIA DE RODOVIA SUL - MATOGROSSENSE","cnpj":"19642306000170","city":"CAMPO GRANDE","stateCode":"MS","buscaAdicional":""},{"id":"997ec1f4-85a9-4a69-68f3-08d5ad2bf6ba","name":"CASSILANDIA AGROAVICOLA LTDA","commercialName":"PLUMA AGROAVICOLA","cnpj":"07277875000184","city":"CASSILÂNDIA","stateCode":"MS","buscaAdicional":"PLUMA CASSILANDIA 60647 CASSILANDIA MATRIZ 912022 CASSILANDIA AGROAVIC 912023"},{"id":"0e05f515-38a1-4f33-5528-08d5ad2bf6ba","name":"IACO AGRICOLA S/A","commercialName":"","cnpj":"07895728000178","city":"CHAPADÃO DO SUL","stateCode":"MS","buscaAdicional":"UTE IACO 5152 IACO CONSUMO 892742 IACO P1 888487 UTE.AI.MS.030269-4.01 IACO P2 900917 UTE.AI.MS.030269-4.01"},{"id":"f3df3020-782d-490e-5c23-08d5ad2bf6ba","name":"HIDROELETRICA LAJEADO LTDA","commercialName":"PCH LAJEADO","cnpj":"08543477000125","city":"CHAPADÃO DO SUL","stateCode":"MS","buscaAdicional":"LAJEADO 51116 PCH LAJEADO 899467 PCH.PH.MS.031438-2.01"},{"id":"671c3df7-3c30-4be8-6679-08d5ad2bf6ba","name":"MINERACAO CORUMBAENSE REUNIDA S.A.","commercialName":"","cnpj":"03327988000196","city":"CORUMBÁ","stateCode":"MS","buscaAdicional":"MCR 57591 MCR MINERACAO CORUMB 907426 MCR P GREGORIO CURVO 909463 MCR URUCUM 909953"},{"id":"e371bca6-92d6-4c44-60bd-08d5ad2bf6ba","name":"RACOES DOURAMIX LTDA.","commercialName":"DOURAMIX NUTRICAO ANIMAL","cnpj":"02938653000141","city":"DOURADOS","stateCode":"MS","buscaAdicional":"DOURAMIX 53653 DOURAMIX 905712"},{"id":"0f544d4a-6ecd-4e9e-5ec6-08d5ad2bf6ba","name":"DOURAGLASS INDUSTRIA E COMERCIO DE VIDROS LTDA","commercialName":"DOURAGLASS","cnpj":"07210771000152","city":"DOURADOS","stateCode":"MS","buscaAdicional":"DOURAGLASS 52548 DOURAGLASS DOURADOS 899940"},{"id":"e0fabab2-add2-4609-5db0-08d5ad2bf6ba","name":"INFLEX INDUSTRIA E COMERCIO DE EMBALAGENS LTDA","commercialName":"INFLEX","cnpj":"33078767000192","city":"DOURADOS","stateCode":"MS","buscaAdicional":"INFLEX 51956 INFLEX DOURADOS 899781"},{"id":"6a5a070e-6e3b-4535-53f4-08d5ad2bf6ba","name":"SAO FERNANDO ENERGIA I LTDA.","commercialName":"SAO FERNANDO ENERGIA I LTDA","cnpj":"11618210000245","city":"DOURADOS","stateCode":"MS","buscaAdicional":"UTE S FERNANDO 545-13 3932 SAO FERNANDO I 8851 UTE.AI.MS.030479-4.01"},{"id":"06c976c5-901a-48c2-5e48-08d5ad2bf6ba","name":"AGROINDUSTRIAL IGUATEMI EIRELI","commercialName":"AGROINDUSTRIAL IGUATEMI","cnpj":"12593115000116","city":"IGUATEMI","stateCode":"MS","buscaAdicional":"AGRO IGUATEMI 52318 AGRO IGUATEMI 899941"},{"id":"a09bc15e-a4d7-4bbb-5b5c-08d5ad2bf6ba","name":"BELLO ALIMENTOS LTDA","commercialName":"RACOES BELLO","cnpj":"08201770000295","city":"ITAQUIRAÍ","stateCode":"MS","buscaAdicional":"BELLO RACAO 50622 BELLO RACAO MS 897791"},{"id":"b34db23d-bd5d-4dcc-5b54-08d5ad2bf6ba","name":"BELLO ALIMENTOS LTDA","commercialName":"FRANGO BELLO","cnpj":"08201770000104","city":"ITAQUIRAÍ","stateCode":"MS","buscaAdicional":"BELLO ABATEDOURO 50602 BELLO ABATEDOURO 898030 BELLO ALIMEN ELDORAD 911935 BELLO CAMPO GRANDE 912071 BELLO ALIMEN FRANG 897774"},{"id":"00449dc6-aa60-42e6-67cd-08d5ad2bf6ba","name":"COPASUL COOPERATIVA AGRICOLA SUL MATOGROSSENSE","commercialName":"UNIDADE ITAQUIRAI","cnpj":"03902129001821","city":"ITAQUIRAÍ","stateCode":"MS","buscaAdicional":"SILOS ITAQUIRAI 58644 COPASUL ITAQUIRAI 908823"},{"id":"836a35f3-a5a8-466f-57ce-08d5ad2bf6ba","name":"USINA HIDRELETRICA SANTA IZABEL LTDA","commercialName":"ENERGETICA SANTA IZABEL","cnpj":"08698337000126","city":"JARAGUARI","stateCode":"MS","buscaAdicional":"CGH SANTA IZABEL 9692 SANTA IZABEL 889551 CGH.PH.MS.029430-6.01"},{"id":"eb5a4e2d-f581-4343-5228-08d5ad2bf6ba","name":"TONON BIOENERGIA S.A.","commercialName":"TONON BIOENERGIA","cnpj":"07914230000105","city":"MARACAJU","stateCode":"MS","buscaAdicional":"UTE VISTA ALEG 2889 VISTA ALEGRE I VISTA 912112 UTE.AI.MS.029994-4.01"},{"id":"ffbd796c-0862-4184-68af-08d5ad2bf6ba","name":"COPASUL COOPERATIVA AGRICOLA SUL MATOGROSSENSE","commercialName":"COPASUL","cnpj":"03902129000264","city":"MARACAJU","stateCode":"MS","buscaAdicional":"COPASUL MARACAJU 60272 COPASUL MARACAJU 910237"},{"id":"6b30d940-44c7-44e9-55ca-08d5ad2bf6ba","name":"FECULARIA MUNDO NOVO LTDA","commercialName":"AMIDOS MUNDO NOVO","cnpj":"86969144000176","city":"MUNDO NOVO","stateCode":"MS","buscaAdicional":"MUNDO NOVO 6138 FECULARIA MUNDO NOVO 72348"},{"id":"de5efb72-c5c1-40ec-566d-08d5ad2bf6ba","name":"COPASUL COOPERATIVA AGRICOLA SUL MATOGROSSENSE","commercialName":"COPASUL","cnpj":"03902129000183","city":"NAVIRAÍ","stateCode":"MS","buscaAdicional":"COPASUL 7061 COPASUL - NAVIRAI 898958"},{"id":"ce3890b2-5bf9-40e4-67cc-08d5ad2bf6ba","name":"COPASUL COOPERATIVA AGRICOLA SUL MATOGROSSENSE","commercialName":"COPASUL","cnpj":"03902129001660","city":"NAVIRAÍ","stateCode":"MS","buscaAdicional":"COPASUL FECULARIA 58643 COPASUL NAVIRAI 908822"},{"id":"3a150863-a332-4533-6933-08d5ad2bf6ba","name":"COPASUL COOPERATIVA AGRICOLA SUL MATOGROSSENSE","commercialName":"COPASUL","cnpj":"03902129000779","city":"NAVIRAÍ","stateCode":"MS","buscaAdicional":"SILOS AEROPORTO 60838 COPASUL COOP. AGRIC. 911934"},{"id":"31549c68-4c3e-498e-55cb-08d5ad2bf6ba","name":"ALIMENTOS DALLAS INDUSTRIA E COMERCIO LTDA","commercialName":"ALIMENTOS DALLAS","cnpj":"03938789000386","city":"NOVA ALVORADA DO SUL","stateCode":"MS","buscaAdicional":"ALIM DALLAS 6139 ALIM DALLAS 72415 ALIMENTOS DALLAS IND 901203"},{"id":"7f35e2ad-899c-4ec7-51d2-08d5ad2bf6ba","name":"AGRO ENERGIA SANTA LUZIA S.A.","commercialName":"AGRO ENERGIA SANTA LUZIA","cnpj":"08906558000142","city":"NOVA ALVORADA DO SUL","stateCode":"MS","buscaAdicional":"USL 2606 STA LUZIA USL CONS 71344 STA LUZIA I USL 8657 UTE.AI.MS.030006-3.01"},{"id":"772136d3-d28a-43df-5257-08d5ad2bf6ba","name":"MONTEVERDE AGRO-ENERGETICA S.A","commercialName":"","cnpj":"00143381000168","city":"PONTA PORÃ","stateCode":"MS","buscaAdicional":"MONTEVERDE 3015 MONTEVERDE 8700 UTE.AI.MS.029990-1.01"},{"id":"d4f74eb2-2cc3-433a-5502-08d5ad2bf6ba","name":"CORRECTA INDUSTRIA E COMERCIO LTDA.","commercialName":"","cnpj":"02957104001277","city":"PONTA PORÃ","stateCode":"MS","buscaAdicional":"CORRECTA PP 4840 CORRECTA PONTA PORA 72036"},{"id":"88a31ab7-9948-48cb-5689-08d5ad2bf6ba","name":"DELTA BIOCOMBUSTIVEIS INDUSTRIA E COMERCIO LTDA","commercialName":"","cnpj":"11513699000100","city":"RIO BRILHANTE","stateCode":"MS","buscaAdicional":"DELTA BIOCOMBUSTIVEIS 7228 DELTA BIOCOMBUSTIVEL 896690"},{"id":"79481f67-764a-4383-5a42-08d5ad2bf6ba","name":"BIOSEV COMERCIALIZADORA DE ENERGIA S.A.","commercialName":"LDC-SEV PASSATEMPO BIOENERGIA S.A.","cnpj":"13687183000298","city":"RIO BRILHANTE","stateCode":"MS","buscaAdicional":"BIOSEV PASSATEMPO 17239"},{"id":"a54a1a34-c6e3-4f54-694c-08d5ad2bf6ba","name":"USINA ELDORADO S/A","commercialName":"ELDORADO","cnpj":"05620523000154","city":"RIO BRILHANTE","stateCode":"MS","buscaAdicional":"UEL BRILHANTE 61028 ELDORADO UEL CL 71493 ELDORADO 8838 UTE.AI.MS.029193-5.01"},{"id":"40924f47-e267-4f32-6388-08d5ad2bf6ba","name":"NATURAFRIG ALIMENTOS LTDA","commercialName":"NATURAFRIG","cnpj":"18626084000139","city":"ROCHEDO","stateCode":"MS","buscaAdicional":"NATURAFRIG 55457 NATFRIG PIRAPOZINHO 905165 NATURAFRIG 905715 NATURAFRIG NOVA AND 905717 NATURAFRIG BARRA BUG 906118"},{"id":"e2113db8-e39c-42a1-51c2-08d5ad2bf6ba","name":"COOPERATIVA CENTRAL AURORA ALIMENTOS","commercialName":"FRIGORIFICO AURORA","cnpj":"83310441002756","city":"SÃO GABRIEL DO OESTE","stateCode":"MS","buscaAdicional":"AURORA FASGO CL 2577 AURORA FASG SG OESTE 70303"},{"id":"783d7072-ce8d-4efd-1cb5-08d5b8870181","name":"SONORA ESTANCIA S/A","commercialName":"USINA SONORA","cnpj":"47902283000120","city":"SONORA","stateCode":"MS","buscaAdicional":"USINA SONORA 60947 USINA SONORA MS 913071"},{"id":"497263cc-5056-4b02-63b5-08d5ad2bf6ba","name":"FRIZELO FRIGORIFICOS LTDA","commercialName":"FRIZELO","cnpj":"13837014000106","city":"TERENOS","stateCode":"MS","buscaAdicional":"FRIZELO 55574 FRIZELO 905068"},{"id":"dc39045b-38ce-43b8-6261-08d5ad2bf6ba","name":"FATEX INDUSTRIA, COMERCIO, IMPORTACAO, EXPORTACAO LTDA","commercialName":"FATEX INDUSTRIA, COMERCIO, IMPORTACAO, EXPORTACAO LTDA","cnpj":"07280722000196","city":"TRÊS LAGOAS","stateCode":"MS","buscaAdicional":"FATEX 54740 FATEX 905089"},{"id":"df25d4a7-2058-4357-528c-08d5ad2bf6ba","name":"CARGILL AGRICOLA S A","commercialName":"CARGILL AGRICOLA","cnpj":"60498706029481","city":"TRÊS LAGOAS","stateCode":"MS","buscaAdicional":"CARGILL TLG 3135 CARGILL TLG 70862"},{"id":"efd7aca9-189e-447b-56bf-08d5ad2bf6ba","name":"FERAL METALURGICA LTDA","commercialName":"FERAL","cnpj":"07296787000120","city":"TRÊS LAGOAS","stateCode":"MS","buscaAdicional":"FERAL METAL 7582 FERAL METAL-3LAGOAS 72279"},{"id":"4ab7e8aa-e8b3-4dbb-56fa-08d5ad2bf6ba","name":"ELDORADO BRASIL CELULOSE S/A","commercialName":"ELDORADO BRASIL","cnpj":"07401436000131","city":"TRÊS LAGOAS","stateCode":"MS","buscaAdicional":"ELDORADO BR 8061 ELDORADO CONSUMO 889720 ELDORADO CON BR 890237 UTE.FL.MS.030583-9.01"},{"id":"a02b332c-d261-4d26-54b7-08d5ad2bf6ba","name":"EMPLAL C.O. EMBALAGENS PLASTICAS LTDA","commercialName":"EMPLAL C.O.","cnpj":"07552379000191","city":"TRÊS LAGOAS","stateCode":"MS","buscaAdicional":"EMPLAL 4457 EMPLAL-TRES LAGOAS 71596"},{"id":"6f5bcdde-da2a-4d12-5807-08d5ad2bf6ba","name":"SITREL - SIDERURGICA TRES LAGOAS LTDA","commercialName":"SITREL","cnpj":"07084117000140","city":"TRÊS LAGOAS","stateCode":"MS","buscaAdicional":"SITREL 10449 SITRELTLG 889859"},{"id":"e8be3327-c9d3-4079-5aee-08d5ad2bf6ba","name":"NIT FIACAO E COMERCIO LTDA","commercialName":"NIT FIACAO E COMERCIO","cnpj":"13828498000127","city":"TRÊS LAGOAS","stateCode":"MS","buscaAdicional":"NIT FIACAO 50361 NIT FIACAO 898317"},{"id":"e0df2ce3-e405-4ee1-5e49-08d5ad2bf6ba","name":"ADAR INDUSTRIA , COMERCIO IMPORTACAO E EXPORTACAO LTDA","commercialName":"","cnpj":"03442526000110","city":"TRÊS LAGOAS","stateCode":"MS","buscaAdicional":"ADAR 52320 ADAR INDUSTRIA COM 902659"},{"id":"0830c931-4411-4450-5a8d-08d5ad2bf6ba","name":"PB BRASIL INDUSTRIA E COMERCIO DE GELATINAS LTDA","commercialName":"PB LEINER BRASIL","cnpj":"10914514000106","city":"ACORIZAL","stateCode":"MT","buscaAdicional":"PB LEINER 50045 PB LEINER 897005"},{"id":"6e7a4ccd-0991-43c2-5e0f-08d5ad2bf6ba","name":"DEL MORO & DEL MORO LTDA","commercialName":"DEL MORO SUPERMERCADOS","cnpj":"00877761000126","city":"ALTA FLORESTA","stateCode":"MT","buscaAdicional":"DELMOROSUPERMERCADOS 52185 DELMOROSORRISO 901434 DELMOROMUTUM 901435 DELMOROTAPURAH 901436 DEL MORO & DEL MORO 901454 DELMOROLUCAS 901456 DELMOROGUARANTA 901455"},{"id":"12daba4b-1f3f-423c-5911-08d5ad2bf6ba","name":"ARAGUAIA GERADORA DE ENERGIA LTDA","commercialName":"","cnpj":"11441408000115","city":"ALTO ARAGUAIA","stateCode":"MT","buscaAdicional":"COMPLEXO ARAGUAINHA 13672 ARAGUAINHA 895308 CGH.PH.MT.031625-3.01 ARAGUAIA 895307 CGH.PH.MT.032204-0.01 ALTO GARCAS 896067 CGH.PH.MT.032265-2.01"},{"id":"5b29eea9-b636-4e44-59f0-08d5ad2bf6ba","name":"ENERGY GREEN BRASIL ENERGIA RENOVAVEL LTDA","commercialName":"ENERGY GREEN BRASIL","cnpj":"20438972000250","city":"ALTO ARAGUAIA","stateCode":"MT","buscaAdicional":"ENERGYGREEN 545-13 16035 AGRENCO 894843 UTE.AI.MT.029649-0.01"},{"id":"5366a6d3-c19e-4348-5097-08d5ad2bf6ba","name":"LOUIS DREYFUS COMPANY BRASIL S.A.","commercialName":"LOUIS DREYFUS COMPANY BRASIL","cnpj":"47067525016292","city":"ALTO ARAGUAIA","stateCode":"MT","buscaAdicional":"LDC ARAGUAIA 1741 COINBRA ALTO ARAGUAI 70100"},{"id":"954be352-e724-4534-6773-08d5ad2bf6ba","name":"COOPNOROESTE - COOPERATIVA AGROPECUARIA DO OESTE DE MATO GROSSO LTDA","commercialName":"COOPNOROESTE","cnpj":"03548401000179","city":"ARAPUTANGA","stateCode":"MT","buscaAdicional":"COOPNOROESTE 58120 COOPNOROESTE AGRO 908467"},{"id":"6cba0893-63ba-4902-8d89-08d5d060706e","name":"CONSELVAN GERACAO DE ENERGIA EIRELI","commercialName":"UTE CONSELVAN","cnpj":"28038232000158","city":"ARIPUANÃ","stateCode":"MT","buscaAdicional":"UTE CONSELVAN MT 60937 UTE CONSELVAN 898148 UTE.FL.MT.030928-1.01"},{"id":"fb15ba78-2bc4-4fc4-50f3-08d5ad2bf6ba","name":"JURUENA ENERGIA S.A.","commercialName":"","cnpj":"07283842000147","city":"ARIPUANÃ","stateCode":"MT","buscaAdicional":"JURUENA ENERG 1918 CHUPINGUAIA JURUENA 894204 PCH.PH.RO.000775-7.01"},{"id":"73791b42-5bcb-45de-5146-08d5ad2bf6ba","name":"ENERGETICA AGUAS DA PEDRA S./A.","commercialName":"","cnpj":"08768414000177","city":"ARIPUANÃ","stateCode":"MT","buscaAdicional":"EAPSA 2085 DARDANELOS 8887 UHE.PH.MT.029597-3.01"},{"id":"0de38cc6-f26c-49d4-5537-08d5ad2bf6ba","name":"GUACU GERACAO DE ENERGIA S/A","commercialName":"GUACU GERACAO DE ENERGIA","cnpj":"12912915000152","city":"ARIPUANÃ","stateCode":"MT","buscaAdicional":"UTE GUACU 5168 GUACU CE 910019 GUACU 889974 UTE.FL.MT.030863-3.01"},{"id":"12684353-6dbe-41b9-5763-08d5ad2bf6ba","name":"USINA BARRALCOOL S/A","commercialName":"","cnpj":"33664228000135","city":"BARRA DO BUGRES","stateCode":"MT","buscaAdicional":"BARRALCOOL 8770 BARRALCOOL 8058 UTE.AI.MT.000227-5.01"},{"id":"5b153974-6aa2-46c1-55c5-08d5ad2bf6ba","name":"MINERACAO ITAIPU INDUSTRIA E COMERCIO LTDA","commercialName":"ITAIPU","cnpj":"03113347000139","city":"BARRA DO BUGRES","stateCode":"MT","buscaAdicional":"MINERACAO ITAIPU 6098 ITAIPU - B DO BUGRES 72177"},{"id":"1c62087e-7346-49c1-5d59-08d5ad2bf6ba","name":"N. BEVILACQUA JUNIOR EIRELI","commercialName":"NILO SUPERMERCADO","cnpj":"05354945000397","city":"BARRA DO GARÇAS","stateCode":"MT","buscaAdicional":"NILO SUPER 51794 NILO SUPER 900705"},{"id":"bd7d1f01-347f-4cac-67fb-08d5ad2bf6ba","name":"FACULDADE CATHEDRAL DE ENSINO SUPERIOR DE BARRA DO GARCAS","commercialName":"FACULDADE CATHEDRAL","cnpj":"03818726000124","city":"BARRA DO GARÇAS","stateCode":"MT","buscaAdicional":"FACULDADES CATHEDRAL 59115 FACULDADE CATHEDRAL 909934"},{"id":"16acd722-d662-48ba-690b-08d5ad2bf6ba","name":"FUGA E PANORAMA INDUSTRIA DE COUROS LTDA","commercialName":"FUGA & PANORAMA INDUSTRIAL","cnpj":"08857352000170","city":"CÁCERES","stateCode":"MT","buscaAdicional":"FUGA E PANORAMA 60740 FUGA E PANORAMA 912315"},{"id":"1dd2db60-ea6c-4970-55c6-08d5ad2bf6ba","name":"CAMIL CACERES MINERACAO LTDA","commercialName":"CAMIL","cnpj":"00959825000138","city":"CÁCERES","stateCode":"MT","buscaAdicional":"CAMIL MIN 6099 CAMIL CACERES 72216"},{"id":"c90c92d1-ded9-482a-5f01-08d5ad2bf6ba","name":"DUAL DUARTE ALBUQUERQUE COMERCIO E INDUSTRIA LTDA","commercialName":"","cnpj":"24542953000301","city":"CAMPO NOVO DO PARECIS","stateCode":"MT","buscaAdicional":"DUAL CNP 52702 DUAL DUARTE CNP 900652"},{"id":"960bbb1b-786f-4f7d-67e5-08d5ad2bf6ba","name":"COOPERATIVA AGR PROD CANA DE CAMPO NOVO DO PARECIS LTDA","commercialName":"COPRODIA","cnpj":"15043391000107","city":"CAMPO NOVO DO PARECIS","stateCode":"MT","buscaAdicional":"UTE-COPRODIA 58810 COPRODIA 909782 UTE.AI.MT.028120-4.01 COPRODIA 909782 UTE.AI.MT.028120-4.01"},{"id":"de317c35-c885-4c9d-6192-08d5ad2bf6ba","name":"PARECIS S/A","commercialName":"","cnpj":"17536615000130","city":"CAMPO NOVO DO PARECIS","stateCode":"MT","buscaAdicional":"PARECIS 54245 PARECIS MT 904552"},{"id":"37788958-3630-40af-615e-08d5ad2bf6ba","name":"COOPERBEM - COOPERATIVA DE BENEFICIAMENTO DE ALGODAO DO MATO GROSSO","commercialName":"COOPERBEM","cnpj":"07660940000156","city":"CAMPO VERDE","stateCode":"MT","buscaAdicional":"COOPERBEM 54155 COOPERBEM 904575"},{"id":"46c8602c-dcd2-4d3f-6031-08d5ad2bf6ba","name":"COOPERATIVA DOS COTONICULTORES DE CAMPO VERDE","commercialName":"COOPERFIBRA","cnpj":"04476442000160","city":"CAMPO VERDE","stateCode":"MT","buscaAdicional":"COOP CAMPO VERDE 53420 COOP CAMPO VERDE 902700"},{"id":"5be8570a-dcba-410a-5865-08d5ad2bf6ba","name":"HIDROELETRICA RIO GALHEIROS LTDA","commercialName":"","cnpj":"08214303000119","city":"CAMPO VERDE","stateCode":"MT","buscaAdicional":"GALHEIROS 11669 RIO GALHEIROS 890498 CGH.PH.MT.029516-7.01"},{"id":"aa47e705-5658-4371-6676-08d5ad2bf6ba","name":"CALCARIO VALE DO ARAGUAIA LTDA.","commercialName":"CAVASA","cnpj":"05872541000123","city":"COCALINHO","stateCode":"MT","buscaAdicional":"CAVASA 57586 CAVASA 909293"},{"id":"e5ef78d1-9ba3-4dd0-6093-08d5ad2bf6ba","name":"COMERCIAL CARAPA DE SECOS E MOLHADOS LTDA","commercialName":"SUPERMERCADOS MACHADO","cnpj":"03790904000156","city":"COLÍDER","stateCode":"MT","buscaAdicional":"SUPERMACHADOCOLIDER 53605 SUPERMACHADO 3 904726 SUPERMACHADO 2 904727 SUPERMACHADO COLIDE 904728"},{"id":"8ffff07c-460c-44b5-59ca-08d5ad2bf6ba","name":"USIMART - USINA TERMOELETRICA MARTINS LTDA","commercialName":"USIMART","cnpj":"06368249000130","city":"COLNIZA","stateCode":"MT","buscaAdicional":"USIMART 15596 MARTINS - MT 895262 UTE.FL.MT.031486-2.01"},{"id":"101d8dbd-46b4-4c80-5338-08d5ad2bf6ba","name":"HIDRELETRICA RIO PIOLHO LTDA","commercialName":"PCH DR. ROMUALDO","cnpj":"08400951000160","city":"COMODORO","stateCode":"MT","buscaAdicional":"MCH 3521 MIRANDA ESTANCIA 8721 CGH.PH.MT.030227-9.01"},{"id":"eba4b251-6b35-4819-531f-08d5ad2bf6ba","name":"IUNI UNIC EDUCACIONAL LTDA","commercialName":"IUNI UNIC EDUCACIONAL","cnpj":"33005265000131","city":"CUIABÁ","stateCode":"MT","buscaAdicional":"IUNI EDUCAC 3485 IUNI EDUCACIONAL 71087 IUNI EDUC-BARAO 71608 UNIC PANTANAL 913307"},{"id":"47740d4d-cbe2-4a54-5306-08d5ad2bf6ba","name":"CONDOMINIO CIVIL PANTANAL SHOPPING","commercialName":"CONDOMINIO CIVIL PANTANAL SHOPPING","cnpj":"06954647000139","city":"CUIABÁ","stateCode":"MT","buscaAdicional":"PTN 3441 PANTANAL SHOP PTN 71058"},{"id":"865b6770-299e-45be-5240-08d5ad2bf6ba","name":"CERVEJARIAS KAISER BRASIL S.A.","commercialName":"","cnpj":"19900000003787","city":"CUIABÁ","stateCode":"MT","buscaAdicional":"FEMSACUIABA 2974 FEMSACUIABA 71362"},{"id":"b0dad5e1-177e-49ba-50e6-08d5ad2bf6ba","name":"AMAGGI EXPORTACAO E IMPORTACAO LTDA","commercialName":"SEMAGGIL","cnpj":"77294254000194","city":"CUIABÁ","stateCode":"MT","buscaAdicional":"GRUPO MAGGI 1892 AMAGGI ESCRITORIO 72404 AMAGGI SAPEZAL 72420 AMAGGI CAMPOS JULIO 888527 AMAGGI BRASNORTE 888640 AMAGGI CAMPO NOVO 888641"},{"id":"6fe5a00e-1734-430a-4f31-08d5ad2bf6ba","name":"CINCO ESTRELAS AGROPECUARIA E PARTICIPACAO LTDA","commercialName":"","cnpj":"01360601000178","city":"CUIABÁ","stateCode":"MT","buscaAdicional":"CINCO ESTRELAS 127 JAURU-5 ESTRELAS 8064 UHE.PH.MT.001245-9.01"},{"id":"c7093d02-88ec-4711-4eeb-08d5ad2bf6ba","name":"ENERGISA MATO GROSSO - DISTRIBUIDORA DE ENERGIA S.A.","commercialName":"","cnpj":"03467321000199","city":"CUIABÁ","stateCode":"MT","buscaAdicional":"ENERGISA MT 20 ENERGISA MT 40 CEMAT DITC 70694"},{"id":"bb743c33-21e9-496c-562f-08d5ad2bf6ba","name":"AGROPECUARIA MAGGI LTDA","commercialName":"AGROMAGGI","cnpj":"00315457000195","city":"CUIABÁ","stateCode":"MT","buscaAdicional":"AGROMAGGI 6737 ALGODEIRA SAPEZAL 899799 FAZENDA TANGURO 900982 FAZENDA ITAMARATI SE 905751 FAZENDA AGUA QUENTE 908849 FAZENDA TUCUNARE 901005 AGROMAGGI ITAMARATI 904549"},{"id":"d617b27a-41dd-47d7-5629-08d5ad2bf6ba","name":"HIDRELETRICA AGUAS CLARAS LTDA","commercialName":"PCH ESPERANCA","cnpj":"10356461000155","city":"CUIABÁ","stateCode":"MT","buscaAdicional":"PCH ESPERANCA 6698 ESPERANCA 888172 PCH.PH.MT.030042-0.01"},{"id":"bfd52081-97e4-46ca-5654-08d5ad2bf6ba","name":"MISSAO SALESIANA DE MATO GROSSO","commercialName":"MSMT - COLEGIO SALESIANO SAO GONCALO","cnpj":"03226149002206","city":"CUIABÁ","stateCode":"MT","buscaAdicional":"CSSG 6901 CSSG 889640"},{"id":"3c099523-fd43-4b2d-577e-08d5ad2bf6ba","name":"GRAFICA PRINT INDUSTRIA E EDITORA EIRELI","commercialName":"GRAFICA PRINT","cnpj":"73783649000108","city":"CUIABÁ","stateCode":"MT","buscaAdicional":"GRAFICA PRINT 8953 GRAFICA PRINT II 890903 GRAFICA PRINT I 890904"},{"id":"d07885df-530d-4a85-57a5-08d5ad2bf6ba","name":"SEGREDO ENERGIA S/A","commercialName":"","cnpj":"08936816000133","city":"CUIABÁ","stateCode":"MT","buscaAdicional":"PCH SEGREDO 9289 SEGREDO 889552 PCH.PH.MT.028822-5.01"},{"id":"5efdd103-2f36-4bb9-57a6-08d5ad2bf6ba","name":"ARUANA COMERCIALIZADORA DE ENERGIA LTDA","commercialName":"","cnpj":"16587133000146","city":"CUIABÁ","stateCode":"MT","buscaAdicional":"ARUANA COMER 9290"},{"id":"0a0ff491-259f-43bc-57a7-08d5ad2bf6ba","name":"ILHA COMPRIDA ENERGIA S/A","commercialName":"","cnpj":"08936794000101","city":"CUIABÁ","stateCode":"MT","buscaAdicional":"PCH ILHA COMP 9291 ILHA COMPRIDA 890258 PCH.PH.MT.028835-7.01"},{"id":"c14e8ed1-c5fb-4a76-5709-08d5ad2bf6ba","name":"BIMETAL INDUSTRIA METALURGICA LTDA","commercialName":"BIMETAL","cnpj":"01261017000165","city":"CUIABÁ","stateCode":"MT","buscaAdicional":"BIMETAL 8164 BIMETAL CUIABA 888167"},{"id":"39121549-9ff1-497a-5599-08d5ad2bf6ba","name":"PLASTIBRAS INDUSTRIA E COMERCIO LTDA","commercialName":"","cnpj":"05626249000120","city":"CUIABÁ","stateCode":"MT","buscaAdicional":"PLASTIBRAS 5881 PLASTIBRAS CUIABA 72211"},{"id":"c3acf9ca-1c80-4678-54ad-08d5ad2bf6ba","name":"BALL EMBALAGENS AMAZONIA LTDA","commercialName":"BALL","cnpj":"04838649000218","city":"CUIABÁ","stateCode":"MT","buscaAdicional":"REXAM AMAZON 4434 REXAM AMAZON-CUIABA 71660"},{"id":"9ed13a8c-d90c-4079-551b-08d5ad2bf6ba","name":"PLASMEL INDUSTRIA E COMERCIO DE PLASTICOS LTDA","commercialName":"PLASMEL","cnpj":"24965782000161","city":"CUIABÁ","stateCode":"MT","buscaAdicional":"PLASMEL 5051 PLASMEL - CUIABA 72183"},{"id":"02a79b2c-485c-462f-5452-08d5ad2bf6ba","name":"DIVISA ENERGIA S/A","commercialName":"","cnpj":"10431501000186","city":"CUIABÁ","stateCode":"MT","buscaAdicional":"DIVISA 4165 DIVISA 8915 PCH.PH.MT.029048-3.01"},{"id":"718ea66f-249f-4d9b-5a3b-08d5ad2bf6ba","name":"UNIAO EDUCACIONAL CANDIDO RONDON - UNIRONDON LTDA","commercialName":"CENTRO UNIVERSITARIO UNIC","cnpj":"24771792000166","city":"CUIABÁ","stateCode":"MT","buscaAdicional":"UNIRONDON 17232 UNIRONDON 3540561 896207 UNIRONDON 896226"},{"id":"b8440257-d3d1-4ef2-5a34-08d5ad2bf6ba","name":"UNIC EDUCACIONAL LTDA","commercialName":"","cnpj":"14793478000120","city":"CUIABÁ","stateCode":"MT","buscaAdicional":"UNIC MT 17216 UNIME ITABUNA CAMP1 71809 UNIME ITABUNA CAMP2 71810 UNIC RONDONOPOLIS FP 896208 UNIC PRIMAVERA 896224 SINOP AEROPORTO 896225 UNIC TANGARA 896227 UNIC SINOP IND 896245 RONDONOPOLIS AE 896244"},{"id":"dd114785-3c2a-4c18-584c-08d5ad2bf6ba","name":"TEMPERMAT COMERCIO, INDUSTRIA, IMPORTACAO E EXPORTACAO DE VIDROS LTDA.","commercialName":"TEMPERMAT","cnpj":"08711353000101","city":"CUIABÁ","stateCode":"MT","buscaAdicional":"TEMPERMAT 11269 TEMPERMAT CUIABA MT 898589"},{"id":"d33ce8d9-b9ae-4975-5aff-08d5ad2bf6ba","name":"CONDOMINIO GOIABEIRAS SHOPPING CENTER","commercialName":"","cnpj":"33711029000130","city":"CUIABÁ","stateCode":"MT","buscaAdicional":"SHOP GOIABEIRAS 50382 SHOP GOIABEIRAS 898008"},{"id":"e29425df-77ca-4776-5b4e-08d5ad2bf6ba","name":"AMBAR ENERGIA LTDA","commercialName":"","cnpj":"01645009000112","city":"CUIABÁ","stateCode":"MT","buscaAdicional":"AMBAR ENERGIA 50574 CUIABA 8906 UTE.GN.MT.027003-2.01 CUIABA EXP 888249 UTE.GN.MT.027003-2.01"},{"id":"af425a36-8e07-45f4-5c3d-08d5ad2bf6ba","name":"TELEVISAO CENTRO AMERICA LTDA","commercialName":"","cnpj":"03476876000105","city":"CUIABÁ","stateCode":"MT","buscaAdicional":"TELEVISAO CENTRO AMERICA 51226 TELEVISAO AMERICA MT 899949"},{"id":"cf499d08-9d8c-49f8-5c7b-08d5ad2bf6ba","name":"DURLICOUROS IND E COM DE COUROS, EXP E IMPORTACAO LTDA","commercialName":"","cnpj":"00105229000603","city":"CUIABÁ","stateCode":"MT","buscaAdicional":"DURLICOUROS 51345 DURLICOUROS 899811"},{"id":"c0397553-8f62-425c-5c5c-08d5ad2bf6ba","name":"TRAEL TRANSFORMADORES ELETRICOS LTDA","commercialName":"TRAEL TRANSFORMADORES ELETRICOS","cnpj":"37457942000103","city":"CUIABÁ","stateCode":"MT","buscaAdicional":"TRAEL 51284 TRAEL ELETRICOS MT 899138"},{"id":"37039ec0-4829-45bb-5d27-08d5ad2bf6ba","name":"HOTEL GRAN ODARA LTDA","commercialName":"GRAN ODARA","cnpj":"12262251000123","city":"CUIABÁ","stateCode":"MT","buscaAdicional":"HOTEL GRAN ODARA 51721 HOTEL GRAN ODARA 900976"},{"id":"b8ebf48e-d8d4-4de2-5c9d-08d5ad2bf6ba","name":"ACOFER INDUSTRIA E COMERCIO EIRELI","commercialName":"ACOFER","cnpj":"03989217000326","city":"CUIABÁ","stateCode":"MT","buscaAdicional":"ACOFER 51425 ACOFER 899810"},{"id":"09d61543-05ef-42c3-5dba-08d5ad2bf6ba","name":"MOINHO REGIO ALIMENTOS S/A","commercialName":"","cnpj":"07054279000135","city":"CUIABÁ","stateCode":"MT","buscaAdicional":"MOINHO REGIO 51968 MOINHO CASCAVEL 904801 MOINHO REGIO CUIABA 908821"},{"id":"b1449eca-a46f-4e11-6646-08d5ad2bf6ba","name":"CONDOMINIO CIVIL DO BLOCO ''A'' DO SHOPPING CENTER 3 AMERICAS","commercialName":"","cnpj":"08236393000149","city":"CUIABÁ","stateCode":"MT","buscaAdicional":"SHOP 3 AMERICAS 57455 SHOPPING 3 AMERICAS 908623"},{"id":"67f4ccde-e83b-4023-66d3-08d5ad2bf6ba","name":"VIDRACARIA GUAPORE LTDA","commercialName":"GUAPORE VIDROS","cnpj":"03835188000186","city":"CUIABÁ","stateCode":"MT","buscaAdicional":"VIDRACARIA GUAPORE 57845 VIDRACARIA GUAPORE 908624 VIDR GUAPORE SINOP 908625"},{"id":"26e355d9-8f23-4d8f-689c-08d5ad2bf6ba","name":"BELARINA ALIMENTOS S/A","commercialName":"BELARINA ALIMENTOS","cnpj":"02025334000145","city":"CUIABÁ","stateCode":"MT","buscaAdicional":"BELARINA 60210 BELARINA ALIMENTOS 910555"},{"id":"ecaec46f-90de-4f23-8d74-08d5d060706e","name":"JORNAL A GAZETA LTDA","commercialName":"JORNAL A GAZETA","cnpj":"06167347000100","city":"CUIABÁ","stateCode":"MT","buscaAdicional":"JORNAL A GAZETA 5108 JORNAL A GAZETA LTDA 913578"},{"id":"63e6c57a-00e3-415a-4ee3-08d5d159243d","name":"CONCESSIONARIA ROTA DO OESTE S.A.","commercialName":"","cnpj":"19521322000104","city":"CUIABÁ","stateCode":"MT","buscaAdicional":""},{"id":"bdee91ba-5bc7-474b-4edd-08d5d159243d","name":"NASA SECURITIZADORA SA","commercialName":"VILAREAL SECURITIZADORA","cnpj":"15377572000161","city":"CUIABÁ","stateCode":"MT","buscaAdicional":""},{"id":"49749ce1-e825-4cdd-4f17-08d5d159243d","name":"AVAL SECURITIZADORA DE CREDITOS S.A.","commercialName":"AVAL SECURITIZADORA","cnpj":"15011696000129","city":"CUIABÁ","stateCode":"MT","buscaAdicional":""},{"id":"ab87c5eb-59a1-4599-7365-08d5cf600bef","name":"CLARION S/A AGROINDUSTRIAL","commercialName":"","cnpj":"24956666000186","city":"CUIABÁ","stateCode":"MT","buscaAdicional":""},{"id":"20495b1b-0359-4195-5690-08d5ad2bf6ba","name":"HIDROELETRICA NOVO COLORADO LTDA","commercialName":"HIDROELETRICA NOVO COLORADO","cnpj":"10431458000159","city":"DIAMANTINO","stateCode":"MT","buscaAdicional":"NOVO COLORADO 7236 NOVO COLORADO 889718 CGH.PH.MT.030650-9.01"},{"id":"79df1fbf-92e2-449f-4f13-08d5ad2bf6ba","name":"ITIQUIRA ENERGETICA S.A","commercialName":"ITIQUIRA ENERGETICA","cnpj":"00185041000108","city":"ITIQUIRA","stateCode":"MT","buscaAdicional":"ITIQUIRA 77 ITIQUIRA I 558 UHE.PH.MT.027244-2.01 ITIQUIRA II 569 UHE.PH.MT.027244-2.01"},{"id":"34399e1e-f95c-4357-5196-08d5ad2bf6ba","name":"HIDRELETRICA SUCUPIRA S/A","commercialName":"PCH SUCUPIRA","cnpj":"08252113000196","city":"JACIARA","stateCode":"MT","buscaAdicional":"SUCUPIRA 2422 SUCUPIRA 8377 PCH.PH.MT.028837-3.01"},{"id":"77ae09d0-6bb9-4999-5197-08d5ad2bf6ba","name":"HIDRELETRICA PEQUI S/A","commercialName":"PCH PEQUI","cnpj":"08252092000109","city":"JACIARA","stateCode":"MT","buscaAdicional":"PEQUI I5 2423 PEQUI 8397 PCH.PH.MT.028838-1.01"},{"id":"b9b439d5-2ada-4179-56ae-08d5ad2bf6ba","name":"HIDRELETRICA CAMBARA S/A","commercialName":"PCH CAMBARA","cnpj":"09188708000192","city":"JACIARA","stateCode":"MT","buscaAdicional":"PCH CAMBARA 7503 CAMBARA 888633 PCH.PH.MT.030813-7.01"},{"id":"945791d5-dfa6-4a6f-56af-08d5ad2bf6ba","name":"HIDRELETRICA EMBAUBA S/A","commercialName":"PCH EMBAUBA","cnpj":"09188703000160","city":"JACIARA","stateCode":"MT","buscaAdicional":"EMBAUBA 7504 EMBAUBA 888173 PCH.PH.MT.030814-5.01"},{"id":"1a1ab56f-2a05-4f75-5f89-08d5ad2bf6ba","name":"VB ALIMENTOS INDUSTRIA E COMERCIO LTDA","commercialName":"VB ALIMENTOS","cnpj":"04955487000117","city":"JACIARA","stateCode":"MT","buscaAdicional":"VB ALIMENTOS 53015 VB ALIMENTOS IND 901976"},{"id":"99abc419-8641-428b-642e-08d5ad2bf6ba","name":"USINA ELETRICA DO PRATA S/A","commercialName":"P.C.H. - AGUA BRAVA","cnpj":"05646253000150","city":"JUSCIMEIRA","stateCode":"MT","buscaAdicional":"USINAS DO PRATA 55870 AGUA PRATA 909788 PCH.PH.MT.029044-0.01"},{"id":"85c3f1f9-118c-497d-66e4-08d5ad2bf6ba","name":"SOCIEDADE PORVIR CIENTIFICO","commercialName":"FACULDADE LA SALLE","cnpj":"92741990002938","city":"LUCAS DO RIO VERDE","stateCode":"MT","buscaAdicional":"FACULDADE LA SALLE 57877 SOC PORVIR CIENTIFIC 909273"},{"id":"f19198e4-cdce-41e9-6647-08d5ad2bf6ba","name":"AMAZON TEMPER INDUSTRIA DE VIDROS TEMPERADOS LTDA","commercialName":"AMAZON TEMPER","cnpj":"12458237000108","city":"LUCAS DO RIO VERDE","stateCode":"MT","buscaAdicional":"AMAZON TEMPER LUCAS 57456 AMAZON TEMPER LUCAS 908657"},{"id":"6128aa91-e87c-4fbe-6020-08d5ad2bf6ba","name":"FIAGRIL LTDA","commercialName":"FIAGRIL","cnpj":"02734023000821","city":"LUCAS DO RIO VERDE","stateCode":"MT","buscaAdicional":"FIAGRIL 53396 FIAGRIL 902519"},{"id":"cb0bf4c7-bc25-4665-5a86-08d5ad2bf6ba","name":"FS AGRISOLUTIONS INDUSTRIA DE BIOCOMBUSTIVEIS LTDA","commercialName":"FS BIOENERGIA","cnpj":"20003699000150","city":"LUCAS DO RIO VERDE","stateCode":"MT","buscaAdicional":"FS AGRISOLUTIONS 49993 FS AGRISOLUTI CARGA 909834 FS AGRISOLUTIONS 910091 UTE.FL.MT.034035-9.01"},{"id":"7868ce63-6174-4070-5279-08d5ad2bf6ba","name":"AMAGGI EXPORTACAO E IMPORTACAO LTDA","commercialName":"","cnpj":"77294254005587","city":"LUCAS DO RIO VERDE","stateCode":"MT","buscaAdicional":"AMAGGI-LUCAS 3080 AMAGGI LUCAS R VERDE 70923"},{"id":"973a05a1-127a-4b90-55c7-08d5ad2bf6ba","name":"EMAL EMPRESA DE MINERACAO ARIPUANA LTDA","commercialName":"","cnpj":"44026037000164","city":"NOBRES","stateCode":"MT","buscaAdicional":"EMAL 6100 EMAL NOBRES ACUCAR 72168 EMAL PRIMAV LESTE 72169 EMAL NOBRES MATRIZ 72171"},{"id":"a52c81bf-1122-4d79-553d-08d5ad2bf6ba","name":"FIRENZE ENERGETICA S/A","commercialName":"FIRENZE ENERGETICA","cnpj":"03127457000150","city":"NORTELÂNDIA","stateCode":"MT","buscaAdicional":"FIRENZE 5192 SANTANA I 8804 PCH.PH.MT.028971-0.01"},{"id":"e97be135-56d1-4c61-67b9-08d5ad2bf6ba","name":"FLOTAR TECNOLOGIA EM RECUPERACAO MINERAL, COMERCIO E EXPORTACAO DE METAIS PRECIOSOS SPE LTDA.","commercialName":"FLOTAR RECUPERACAO MINERAL","cnpj":"21393119000141","city":"NOSSA SENHORA DO LIVRAMENTO","stateCode":"MT","buscaAdicional":"FLOTAR 58551 FLOTAR 910020"},{"id":"3b1a1b94-80e3-428d-591f-08d5ad2bf6ba","name":"ATOS GERACAO DE ENERGIA LTDA","commercialName":"ATOS ENERGIA","cnpj":"18997370000100","city":"NOVA BANDEIRANTES","stateCode":"MT","buscaAdicional":"ATOS ENERGIA 13838 ATOS ENERGIA 893922 UTE.FL.MT.031471-4.01"},{"id":"d4acac02-44b4-4a0a-58b9-08d5ad2bf6ba","name":"MAXENERGIA GERACAO E COMERCIALIZACAO DE ENERGIA LTDA","commercialName":"MAXENERGIA","cnpj":"12559526000195","city":"NOVA LACERDA","stateCode":"MT","buscaAdicional":"MAXENERGIA 13013 PREFORMAX I 8710 CGH.PH.MT.029696-1.01"},{"id":"542eb2ff-d733-4a64-63d1-08d5ad2bf6ba","name":"INDUSTRIA DE LATICINIOS MARAJOARA DO NORTE LTDA","commercialName":"LATICINIOS MARAJOARA DO NORTE","cnpj":"03374223000107","city":"NOVA CANAÃ DO NORTE","stateCode":"MT","buscaAdicional":"NENE ALIMENTOS 55642 LATICINIOS MARAJOARA 906668"},{"id":"1495c572-9015-46c0-593b-08d5ad2bf6ba","name":"AGROENERGETICA MATO GROSSO LTDA","commercialName":"AGROENERGETICA MATO GROSSO","cnpj":"08939759000146","city":"NOVA MUTUM","stateCode":"MT","buscaAdicional":"PCH NOVA MUTUM 14155 NOVA MUTUM 894642 PCH.PH.MT.031042-5.01"},{"id":"a94e47c7-a7d5-4fae-6068-08d5ad2bf6ba","name":"NATURAL PORK ALIMENTOS S.A.","commercialName":"NATURAL PORK","cnpj":"17356474000173","city":"NOVA MUTUM","stateCode":"MT","buscaAdicional":"NATURAL PORK 53495 NATURAL PORK 901938"},{"id":"6bcc6d0d-62a8-4daf-55a3-08d5ad2bf6ba","name":"USINAS ITAMARATI S/A","commercialName":"","cnpj":"15009178000170","city":"NOVA OLÍMPIA","stateCode":"MT","buscaAdicional":"USI ITAMARATI 5919 ITAMARATI 8974 UTE.AI.MT.028121-2.01"},{"id":"e6a413cf-9718-4069-6678-08d5ad2bf6ba","name":"CALCARIO VALE DO ARAGUAIA LTDA.","commercialName":"MINERADORA RONCADOR","cnpj":"05872541000476","city":"NOVA XAVANTINA","stateCode":"MT","buscaAdicional":"MINERADORA RONCADOR 57590 CALC V DO ARAGUAIA 908468"},{"id":"17024f2e-c7f6-4149-5721-08d5ad2bf6ba","name":"NOVO MUNDO ENERGETICA S/A","commercialName":"NOVO MUNDO ENERGETICA","cnpj":"05105045000144","city":"NOVO MUNDO","stateCode":"MT","buscaAdicional":"NOVO MUNDO 8244 BRACO NORTE IV 8264 PCH.PH.MT.028772-5.01"},{"id":"e17054f0-299b-450b-5213-08d5ad2bf6ba","name":"ELOI BRUNETTA & CIA. LTDA.","commercialName":"","cnpj":"06074064000113","city":"NOVO SÃO JOAQUIM","stateCode":"MT","buscaAdicional":"BRUNETTA 2857 NOIDORE 8027 CGH.PH.MT.028899-3.01 DESIDERIO M BRUNETTA 8716 CGH.PH.MT.030374-7.01 SALTO BELO 893686 PCH.PH.MT.002581-0.01 DONA ASSUNTA 909803 CGH.PH.MT.000040-0.02"},{"id":"2f31d92d-445d-436c-5f0f-08d5ad2bf6ba","name":"DUAL DUARTE ALBUQUERQUE COMERCIO E INDUSTRIA LTDA","commercialName":"","cnpj":"24542953000573","city":"PEDRA PRETA","stateCode":"MT","buscaAdicional":"DUAL PP 52721 DUAL DUARTE PP 900693"},{"id":"3e01315a-1e74-496c-63f0-08d5ad2bf6ba","name":"BRAZSERVICE WET LEATHER S/A","commercialName":"BRAZSERVICE WET LEATHER","cnpj":"06945520000153","city":"PEDRA PRETA","stateCode":"MT","buscaAdicional":"BRAZSERVICE 55721 BRAZSERVICE PEDRA PT 906669"},{"id":"8c05116c-a704-4f75-5c12-08d5ad2bf6ba","name":"L M ORGANIZACAO HOTELEIRA LTDA","commercialName":"PANTANAL MATO GROSSO ECO-LODGE","cnpj":"03372237000191","city":"POCONÉ","stateCode":"MT","buscaAdicional":"L.M. HOTEIS 51064 LM HOTEIS 3537323 899847 LM HOTEIS 3540162 899848 LM HOTEIS 3538290 899868"},{"id":"b9fcab8e-9c66-4f57-52a9-08d5ad2bf6ba","name":"MINERACAO APOENA S.A.","commercialName":"","cnpj":"10302599000171","city":"PONTES E LACERDA","stateCode":"MT","buscaAdicional":"APOENA 3210 MINAS SVIC S.FRANC 70165 PROJ. ERNESTO - MT 888532 PROJETO PAU A PIQUE 889660"},{"id":"8f3393b1-cd81-45d8-5433-08d5ad2bf6ba","name":"CARGILL AGRICOLA S A","commercialName":"","cnpj":"60498706034485","city":"PRIMAVERA DO LESTE","stateCode":"MT","buscaAdicional":"CARGILL PDL 4076 CARGILL PRIMAVERA 71571"},{"id":"a0798d14-e2b1-4aa1-628c-08d5ad2bf6ba","name":"ZOOFORT SUPLEMENTACAO ANIMAL INDUSTRIA E COMERCIO LTDA","commercialName":"ZOOFORT SUPLEMENTACAO ANIMAL","cnpj":"37438843000184","city":"PRIMAVERA DO LESTE","stateCode":"MT","buscaAdicional":"INVIVO PRIMAVERA 54799 INVIVO PRIMAVERA 904584"},{"id":"a284e4ce-b405-4a54-6551-08d5ad2bf6ba","name":"APASA INDUSTRIAL E AGROFLORESTAL LTDA","commercialName":"GUAVIRA","cnpj":"03477155000101","city":"SÃO JOSÉ DO RIO CLARO","stateCode":"MT","buscaAdicional":"APASA 56652 APASA 908195"},{"id":"ad7aff5a-9416-4ce5-695b-08d5ad2bf6ba","name":"INTERCONTINENTAL FOODS - COMERCIO DE ALIMENTOS LTDA","commercialName":"INTERCONTINENTAL FOODS","cnpj":"24013907000153","city":"RONDONÓPOLIS","stateCode":"MT","buscaAdicional":"INTERCONTINENTAL FOODS 61093 INTERCONTINENTAL FOO 893103"},{"id":"79703f93-595c-4dfb-8890-08d5ae44ed50","name":"SUPERFRIGO INDUSTRIA E COMERCIO SA","commercialName":"","cnpj":"03235330000154","city":"RONDONÓPOLIS","stateCode":"MT","buscaAdicional":"SUPERFRIGO 13876"},{"id":"a8bbb31f-e30b-4779-5649-08d5ad2bf6ba","name":"ASSOCIACAO DOS LOJISTAS DO RONDON PLAZA SHOPPING","commercialName":"ASSOCIACAO DOS LOJISTAS DO RONDON PLAZA SHOPPING","cnpj":"04499099000179","city":"RONDONÓPOLIS","stateCode":"MT","buscaAdicional":"RONDON PLAZA 6839 RONDON PLAZA SHOPG 72088"},{"id":"5d51f35b-5fd5-48a1-529e-08d5ad2bf6ba","name":"CERVEJARIA PETROPOLIS DO CENTRO OESTE LTDA","commercialName":"","cnpj":"08415791000122","city":"RONDONÓPOLIS","stateCode":"MT","buscaAdicional":"CP MATRIZ_MT 3186 CERVEJAR PETROPOLIS 71046 ALBANO MACHADO 8781 PCH.PH.RS.029514-0.01"},{"id":"b9a8cf56-6f60-437c-5353-08d5ad2bf6ba","name":"MATABOI ALIMENTOS LTDA","commercialName":"","cnpj":"16820052000730","city":"RONDONÓPOLIS","stateCode":"MT","buscaAdicional":"MATABOI-ROO 3580 MATABOI-ROO 71121 MATABOI - SANTA FE 889949"},{"id":"ece4473b-7bc1-49f9-5348-08d5ad2bf6ba","name":"AGRA AGROINDUSTRIAL DE ALIMENTOS SA","commercialName":"","cnpj":"24746687000177","city":"RONDONÓPOLIS","stateCode":"MT","buscaAdicional":"AGRA 3554 AGRA-RONDONOPOLIS 71110"},{"id":"df3243ac-96d6-4741-514d-08d5ad2bf6ba","name":"SANTANA TEXTIL MATO GROSSO S.A.","commercialName":"","cnpj":"05994794000170","city":"RONDONÓPOLIS","stateCode":"MT","buscaAdicional":"SANTANAMT 2106 SANTANAMT RONDONOPOL 70462"},{"id":"ab755fe3-b08d-428d-50c6-08d5ad2bf6ba","name":"ITAP BEMIS CENTRO OESTE - INDUSTRIA E COMERCIO DE EMBALAGENS LTDA","commercialName":"ITAP BEMIS CENTRO OESTE","cnpj":"06559531000103","city":"RONDONÓPOLIS","stateCode":"MT","buscaAdicional":"ITAP BEMIS 1842 ITAP BEMIS RONDONOPO 70217"},{"id":"3780aa00-ad14-4f74-5b83-08d5ad2bf6ba","name":"RUMO MALHA NORTE S.A","commercialName":"","cnpj":"24962466000136","city":"RONDONÓPOLIS","stateCode":"MT","buscaAdicional":"ALL 50738 ALL AMERICA MT 897673"},{"id":"dd3842ec-b8d2-4c56-5b1c-08d5ad2bf6ba","name":"COFCO INTERNATIONAL BRASIL S.A.","commercialName":"COFCO INTL","cnpj":"06315338002677","city":"RONDONÓPOLIS","stateCode":"MT","buscaAdicional":"COFCO BRASIL FILIAL 50471 NOBLE RONDONOPOLIS 897666"},{"id":"4ee9d095-b2df-4fd1-5915-08d5ad2bf6ba","name":"GERMAT GERADORA DE ENERGIA DO ESTADO DE MATO GROSSO LTDA","commercialName":"","cnpj":"05300357000109","city":"SANTO ANTÔNIO DO LEVERGER","stateCode":"MT","buscaAdicional":"GERMAT 13694 MESTRE 894282 PCH.PH.MT.029154-4.01 SANTA CECILIA MT 895401 PCH.PH.MT.029151-0.01"},{"id":"5027d9c4-da98-44e1-8889-08d5ae44ed50","name":"GLORIA GERADORA DE ENERGIA LTDA","commercialName":"","cnpj":"09602132000168","city":"SANTO ANTÔNIO DO LEVERGER","stateCode":"MT","buscaAdicional":"CGH GLORIA 12192 GLORIA (CGH) 890813 CGH.PH.MT.031142-1.01"},{"id":"35dc35f1-c2a6-4094-68f8-08d5ad2bf6ba","name":"FASIPE CENTRO EDUCACIONAL LTDA","commercialName":"FACULDADE FASIPE","cnpj":"07939776000110","city":"SINOP","stateCode":"MT","buscaAdicional":"FASIPE 60655 FASIPE 910864 UNIFAS 910872"},{"id":"9e2686f1-407c-4216-658d-08d5ad2bf6ba","name":"VALE GRANDE INDUSTRIA E COMERCIO DE ALIMENTOS S/A","commercialName":"","cnpj":"06088741000152","city":"SINOP","stateCode":"MT","buscaAdicional":"FRIALTO 56820 FRIALTO MATUPA 908174 FRIALTO NOVA CANAA 908194"},{"id":"d13165d1-a0a0-4e30-5916-08d5ad2bf6ba","name":"COMPANHIA ENERGETICA SINOP SA","commercialName":"COMPANHIA ENERGETICA SINOP S/A","cnpj":"19527586000175","city":"SINOP","stateCode":"MT","buscaAdicional":"CES 13714"},{"id":"b8ea02cd-18c8-4b2a-5c7c-08d5ad2bf6ba","name":"CURTUME BLUBRAS LTDA","commercialName":"","cnpj":"04778904000101","city":"SINOP","stateCode":"MT","buscaAdicional":"BLUBRAS 51348 CURTUME BLUBRAS 899269"},{"id":"b6905479-8531-4260-5ee4-08d5ad2bf6ba","name":"BOMBONATTO INDUSTRIA DE ALIMENTOS S/A","commercialName":"FRIGOBOM","cnpj":"05920697000132","city":"SINOP","stateCode":"MT","buscaAdicional":"BOMBONATTOSINOP 52602 BOMBONATTO INDUSTRIA 901083"},{"id":"39660cab-0ce2-471c-54ce-08d5ad2bf6ba","name":"MARTINS & MARTINS LTDA","commercialName":"SUPERMERCADOS MACHADO","cnpj":"03790896000148","city":"SINOP","stateCode":"MT","buscaAdicional":"SUPERMACHADO 4509 SUPERMACHADO BARANJ 71690 SUPERMACHADO ITAUBAS 71691 SUPERMACHADO PRIMAV 71692 SUPERMACHADO PRIMAVE 904399 SUPERMACHADO VITORIA 904401 SUPERMACHADO TARUMAS 904419"},{"id":"4d3e913c-5e4e-4b01-4fe5-08d5ad2bf6ba","name":"MAROMBI ALIMENTOS LTDA","commercialName":"MAROMBI ALIMENTOS","cnpj":"03950587000198","city":"SORRISO","stateCode":"MT","buscaAdicional":"MAROMBI ALIMENTOS 1343 ANHAMBI SORRISO 7457 MAROMBI FILIAL 906983"},{"id":"ef341269-c4f5-40b0-5c47-08d5ad2bf6ba","name":"FRIGORIFICO NUTRIBRAS LTDA","commercialName":"NUTRIBRAS ALIMENTOS","cnpj":"08090575000154","city":"SORRISO","stateCode":"MT","buscaAdicional":"NUTRIBRASSORRISO 51242 FRIGORIFICO NUTRIBRA 899142"},{"id":"268a3a62-bb95-45e5-88b6-08d5ae44ed50","name":"CARAMURU ALIMENTOS S.A.","commercialName":"","cnpj":"00080671002668","city":"SORRISO","stateCode":"MT","buscaAdicional":"CARAMURU PIE 50002"},{"id":"ff586d9c-395f-4bb0-6786-08d5ad2bf6ba","name":"CALCARIO TANGARA - INDUSTRIA E COMERCIO LTDA","commercialName":"","cnpj":"03988151000198","city":"TANGARÁ DA SERRA","stateCode":"MT","buscaAdicional":"CALCARIO TANGARA 58245 CALCARIO TANGARA 910403"},{"id":"dbd58c37-6188-4dbf-5060-08d5ad2bf6ba","name":"SEARA ALIMENTOS NORTE LTDA","commercialName":"","cnpj":"36966422000163","city":"TANGARÁ DA SERRA","stateCode":"MT","buscaAdicional":"SEARA NORTE 1595 ANHAMBI TANGARA SERR 7099"},{"id":"fcd3e907-acef-4255-5569-08d5ad2bf6ba","name":"CERAMICA SANTO ANDRE LTDA","commercialName":"CERAMICA SANTO ANDRE","cnpj":"33006073000140","city":"VÁRZEA GRANDE","stateCode":"MT","buscaAdicional":"SANTO ANDRE 5549 CERAMICA ST ANDRE-VG 71892"},{"id":"b175ce41-83f9-4f32-546f-08d5ad2bf6ba","name":"REFRIGERANTES MARAJA S.A.","commercialName":"REFRIGERANTE MARAJA","cnpj":"03835832000116","city":"VÁRZEA GRANDE","stateCode":"MT","buscaAdicional":"REFRI MARAJA 4249 REFRIGERANTE MARAJA 71518"},{"id":"825360d0-5cb3-40e6-55ef-08d5ad2bf6ba","name":"TODIMO MATERIAIS PARA CONSTRUCAO SA","commercialName":"TODIMO","cnpj":"15375991000164","city":"VÁRZEA GRANDE","stateCode":"MT","buscaAdicional":"TODIMO 6350 TODIMO CARMINDO 01 72186 TODIMO COUTO 72187 TODIMO H CENTER 10 72188"},{"id":"d5ea4e14-0120-4fd2-5bfe-08d5ad2bf6ba","name":"VIDEPLAST EMBALAGENS PLASTICAS LTDA","commercialName":"","cnpj":"07634836000197","city":"VÁRZEA GRANDE","stateCode":"MT","buscaAdicional":"VIDEPLAST EMBALAGENS 51030 VIDEPLAST EMBALAGENS 900643"},{"id":"9763da4c-22b0-4277-5bff-08d5ad2bf6ba","name":"CONDOMINIO VARZEA GRANDE SHOPPING","commercialName":"CONDOMINIO VARZEA GRANDE SHOPPING","cnpj":"23302641000104","city":"VÁRZEA GRANDE","stateCode":"MT","buscaAdicional":"VARZEA GRANDE SHOPPING 51031 VARZEA GRANDE SHOP 899364"},{"id":"51c73b6a-7896-4d7a-584d-08d5ad2bf6ba","name":"PANTANEIRA INDUSTRIA E COMERCIO DE CARNES E DERIVADOS LTDA","commercialName":"PANTANEIRA","cnpj":"05111062000194","city":"VÁRZEA GRANDE","stateCode":"MT","buscaAdicional":"PANTANEIRA 11297 PANTANEIRA VG 890238"},{"id":"4c81ae1b-d611-4a96-5813-08d5ad2bf6ba","name":"SEBO VARZEA GRANDE INDUSTRIA E COMERCIO DE PRODUTOS ANIMAIS LTDA","commercialName":"SEBO VARZEA GRANDE IND. E COM. DE PRODUTOS ANIMAIS LTDA","cnpj":"11392754000150","city":"VÁRZEA GRANDE","stateCode":"MT","buscaAdicional":"SEBO VARZEA 10589 SEBO VARZEA GRANDE 889707"},{"id":"07c5ec9a-7a9c-42a4-5f7d-08d5ad2bf6ba","name":"RECICLAGEM INDUSTRIA E COMERCIO DE SUB PRODUTOS DE ANIMAIS DO MATO GROSSO LTDA","commercialName":"","cnpj":"05062988000137","city":"VÁRZEA GRANDE","stateCode":"MT","buscaAdicional":"RECICLAGEM DO MATO GROSSO 52997 RECICLAGEM MT 904183"},{"id":"7815987f-39c5-4fb2-5e92-08d5ad2bf6ba","name":"INSTITUICAO EDUCACIONAL MATOGROSSENSE-IEMAT","commercialName":"","cnpj":"02485183000108","city":"VÁRZEA GRANDE","stateCode":"MT","buscaAdicional":"IEMAT 52451 UNIVAG 900036"},{"id":"19844997-e8f4-4476-9f82-08d5d7870f30","name":"CARNES BOI BRANCO LTDA","commercialName":"CARNES BOI BRANCO","cnpj":"04352277000134","city":"VÁRZEA GRANDE","stateCode":"MT","buscaAdicional":""},{"id":"f07271e1-71f5-44f2-5857-08d5ad2bf6ba","name":"MARACANA ENERGETICA S/A","commercialName":"MARACANA ENERGETICA","cnpj":"08032643000129","city":"NOVA MARILÂNDIA","stateCode":"MT","buscaAdicional":"MARACANA ENERG 11390 MARACANA 890559 PCH.PH.MT.030185-0.01"},{"id":"a60cd715-d54e-4d5e-551d-08d5ad2bf6ba","name":"UNIAO AVICOLA AGROINDUSTRIAL LTDA","commercialName":"UNIAO AVICOLA","cnpj":"07750075000139","city":"NOVA MARILÂNDIA","stateCode":"MT","buscaAdicional":"UNIAOAVICOLA CL 5069 UNIAO AVICOLA N. MAR 71816"},{"id":"6d937d71-19ff-4a5b-5415-08d5ad2bf6ba","name":"INXU GERADORA E COMERCIALIZADORA DE ENERGIA ELETRICA S/A","commercialName":"","cnpj":"12863751000110","city":"NOVA MARINGÁ","stateCode":"MT","buscaAdicional":"INXU 3997 INXU 3LER 895103 PCH.PH.MT.030642-8.01"},{"id":"3f379b47-7dc3-4ff3-5691-08d5ad2bf6ba","name":"HIDROELETRICA RIO ALEGRE LTDA","commercialName":"HIDROELETRICA RIO ALEGRE","cnpj":"10431396000185","city":"NOVA MARINGÁ","stateCode":"MT","buscaAdicional":"RIO ALEGRE 7237 RIO ALEGRE 888683 CGH.PH.MT.030634-7.01"},{"id":"bb4c14f5-9809-4951-88e3-08d5ae44ed50","name":"AGUAS LINDAS PARTICIPACOES E EMPREENDIMENTOS LTDA","commercialName":"AGUAS LINDAS PARTICIPACOES","cnpj":"12541540000161","city":"ÁGUAS LINDAS DE GOIÁS","stateCode":"GO","buscaAdicional":"AGUAS LINDAS SHOPPING 54442"},{"id":"1fd6fea2-9f67-494f-6783-08d5ad2bf6ba","name":"AGUAS LINDAS SHOPPING","commercialName":"CONDOMINIO AGUAS LINDAS SHOPPING","cnpj":"24157581000138","city":"ÁGUAS LINDAS DE GOIÁS","stateCode":"GO","buscaAdicional":"SHOPPING AGUAS LINDAS 58234 SHOP AGUAS LINDAS 905806"},{"id":"54bd7c06-0d43-4821-6129-08d5ad2bf6ba","name":"CONDOMINIO CIVIL VOLUNTARIO OUTLET PREMIUM BRASILIA","commercialName":"CONDOMINIO CIVIL VOLUNTARIO OUTLET PREMIUM BRASILIA","cnpj":"16418101000117","city":"ALEXÂNIA","stateCode":"GO","buscaAdicional":"OUTLET BRASILIA 54042 OUTLET BRASILIA 904826"},{"id":"3db52729-e0dc-4e06-50cd-08d5ad2bf6ba","name":"MINERACAO MARACA INDUSTRIA E COMERCIO S/A","commercialName":"","cnpj":"86902053000113","city":"ALTO HORIZONTE","stateCode":"GO","buscaAdicional":"MARACA 1851 MARACA MINERACAO 70232"},{"id":"195f0147-d46a-4a1d-514c-08d5ad2bf6ba","name":"USINA TERMELETRICA DE ANAPOLIS SOCIEDADE ANONIMA","commercialName":"UTE - DAIA","cnpj":"05250358000196","city":"ANÁPOLIS","stateCode":"GO","buscaAdicional":"UTE DAIA 2104 DAIA EXPORTACAO 88302 UTE.PE.GO.028612-5.01 DAIA 8302 UTE.PE.GO.028612-5.01"},{"id":"a6494eb3-eddf-4145-596c-08d5ad2bf6ba","name":"CAOA MONTADORA DE VEICULOS LTDA","commercialName":"","cnpj":"03471344000177","city":"ANÁPOLIS","stateCode":"GO","buscaAdicional":"CAOA 14462 CAOA - ANAPOLIS GO 893642"},{"id":"d2bbc1fb-75fa-440e-5cff-08d5ad2bf6ba","name":"GEOLAB INDUSTRIA FARMACEUTICA S/A","commercialName":"GEOLAB","cnpj":"03485572000104","city":"ANÁPOLIS","stateCode":"GO","buscaAdicional":"GEOLAB 51652 GEOLAB 900896"},{"id":"ee7e9fa6-38d7-4cf8-5fe7-08d5ad2bf6ba","name":"LABORATORIO TEUTO BRASILEIRO S/A","commercialName":"","cnpj":"17159229000176","city":"ANÁPOLIS","stateCode":"GO","buscaAdicional":"LABORATORIO TEUTO 53281 LAB TEUTO BRASILEIRO 905807 LABORATORIO TEUTO BR 906940"},{"id":"53deca6d-b559-464b-607e-08d5ad2bf6ba","name":"ALISUL ALIMENTOS SA","commercialName":"ALISUL ALIMENTOS","cnpj":"89548523001403","city":"ANÁPOLIS","stateCode":"GO","buscaAdicional":"ALISUL ANAPOLIS 53541 ALISUL ANAPOLIS 906616"},{"id":"3e2b511f-0860-4a83-60de-08d5ad2bf6ba","name":"ROAN ALIMENTOS LTDA","commercialName":"ROAN","cnpj":"01687284000107","city":"ANÁPOLIS","stateCode":"GO","buscaAdicional":"ROAN ALIMENTOS 53807 ROAN ALIMENTOS 908212"},{"id":"8ed15ef0-3427-4b16-60ee-08d5ad2bf6ba","name":"BISNAGO INDUSTRIA DE EMBALAGENS LTDA","commercialName":"BISNAGO","cnpj":"10268112000181","city":"ANÁPOLIS","stateCode":"GO","buscaAdicional":"BISNAGO 53904 BISNAGO IND DE EMBAL 905826"},{"id":"1bf13012-b9ef-4a78-6207-08d5ad2bf6ba","name":"CONDOMINIO DE ADMINISTRACAO DO BRASIL PARK SHOPPING","commercialName":"CONDOMINIO BRASIL PARK","cnpj":"09099926000150","city":"ANÁPOLIS","stateCode":"GO","buscaAdicional":"BRASIL PARK SHOPPING 54508 BRASIL PARK SHOPPING 905340"},{"id":"397693e0-4e01-47e0-6249-08d5ad2bf6ba","name":"CDA - COMPANHIA DE DISTRIBUICAO ARAGUAIA","commercialName":"","cnpj":"26651646000122","city":"ANÁPOLIS","stateCode":"GO","buscaAdicional":"DISTRIB ARAGUAIA 54673 DIST ARAGUAIA ANAPOL 904844 DIST ARAGUAIA L CONF 908084"},{"id":"9881c59d-e491-4069-677b-08d5ad2bf6ba","name":"NOVAFARMA INDUSTRIA FARMACEUTICA LTDA","commercialName":"NOVAFARMA","cnpj":"06629745000109","city":"ANÁPOLIS","stateCode":"GO","buscaAdicional":"NOVAFARMA 58215 NOVA FARMA IND 908853"},{"id":"53bd7cb8-51a2-40cb-675f-08d5ad2bf6ba","name":"REBICA INDUSTRIA E COMERCIO LTDA","commercialName":"REBICA","cnpj":"00969944000252","city":"ANÁPOLIS","stateCode":"GO","buscaAdicional":"REBICA 58067 REBICA ANAPOLIS 908828"},{"id":"e0d7a674-7683-41d2-66e7-08d5ad2bf6ba","name":"KINGSPAN - ISOESTE CONSTRUTIVOS ISOTERMICOS S/A","commercialName":"","cnpj":"00289348000140","city":"ANÁPOLIS","stateCode":"GO","buscaAdicional":"ISOESTE 57880 ISOESTE VIT STO ANTA 908097"},{"id":"e428dda7-5071-407b-671f-08d5ad2bf6ba","name":"COSMED INDUSTRIA DE COSMETICOS E MEDICAMENTOS S.A.","commercialName":"","cnpj":"61082426001602","city":"ANÁPOLIS","stateCode":"GO","buscaAdicional":"COSMED ANS 57970 COSMED ANS 909312"},{"id":"af330b21-2063-4651-6715-08d5ad2bf6ba","name":"HYPERA S.A.","commercialName":"HYPERA PHARMA","cnpj":"02932074004421","city":"ANÁPOLIS","stateCode":"GO","buscaAdicional":"HYPERMARCAS 57953 HYPERMARCAS 909332"},{"id":"f4a32ad0-6988-4767-663c-08d5ad2bf6ba","name":"PRECON GOIAS INDUSTRIAL LTDA","commercialName":"PRECON GOIAS","cnpj":"02116952000109","city":"ANÁPOLIS","stateCode":"GO","buscaAdicional":"PRECON GOIAS 57412 PRECON GOIAS 907762"},{"id":"a9337590-0b6e-448d-6863-08d5ad2bf6ba","name":"GENIX - INDUSTRIA FARMACEUTICA LTDA","commercialName":"","cnpj":"04376121000193","city":"ANÁPOLIS","stateCode":"GO","buscaAdicional":"GENIX 59893 GENIX 909713"},{"id":"751009d2-84c7-4942-67f3-08d5ad2bf6ba","name":"EMBALAGENS ALLBOX LTDA","commercialName":"ALLBOX INDUSTRIA GRAFICA","cnpj":"07570962000125","city":"ANÁPOLIS","stateCode":"GO","buscaAdicional":"ALLBOX 59080 ALLBOX EMBALAGENS 909695"},{"id":"058f13c4-12f5-4d02-9f80-08d5d7870f30","name":"BRAINFARMA INDUSTRIA QUIMICA E FARMACEUTICA S.A.","commercialName":"NEO QUIMICA","cnpj":"05161069000110","city":"ANÁPOLIS","stateCode":"GO","buscaAdicional":""},{"id":"7ad5c56f-de2d-4d77-9f81-08d5d7870f30","name":"BRAINFARMA INDUSTRIA QUIMICA E FARMACEUTICA S.A.","commercialName":"NEO QUIMICA","cnpj":"05161069000544","city":"ANÁPOLIS","stateCode":"GO","buscaAdicional":""},{"id":"c3868304-6fef-4c85-8d79-08d5d060706e","name":"HOME CENTER BRASIL MATERIAIS PARA CONSTRUCAO LTDA","commercialName":"HOME CENTER TENDTUDO","cnpj":"83817858000170","city":"APARECIDA DE GOIÂNIA","stateCode":"GO","buscaAdicional":"HOME CENTER BRASIL 56053"},{"id":"5ff11103-c91e-4417-740f-08d5cf600bef","name":"BR HOME CENTERS S/A","commercialName":"","cnpj":"11102250000159","city":"APARECIDA DE GOIÂNIA","stateCode":"GO","buscaAdicional":""},{"id":"27851581-2ef7-4c93-6684-08d5ad2bf6ba","name":"APARECIDA SHOPPING S.A","commercialName":"FIVE PARTICIPACOES","cnpj":"97525711000111","city":"APARECIDA DE GOIÂNIA","stateCode":"GO","buscaAdicional":"APARECIDA SHOPPING 57627 APARECIDA SHOPPING 909698"},{"id":"c4f14a6e-fc16-4b0e-6257-08d5ad2bf6ba","name":"CONDOMINIO DO BURITI SHOPPING","commercialName":"CONDOMINIO BURITI SHOPPING","cnpj":"01003352000163","city":"APARECIDA DE GOIÂNIA","stateCode":"GO","buscaAdicional":"BURITI SHOPPING AP GO 54690 SHOP BURITI AP GOIAN 907768"},{"id":"142393f8-d710-42f8-62e6-08d5ad2bf6ba","name":"CEPALGO EMBALAGENS FLEXIVEIS LTDA.","commercialName":"","cnpj":"00122473000161","city":"APARECIDA DE GOIÂNIA","stateCode":"GO","buscaAdicional":"CEPALGO 55027 CEPALGO 905824"},{"id":"ac9a5417-dd00-4e2a-6486-08d5ad2bf6ba","name":"HOME CENTER NACIONAL MATERIAIS PARA CONSTRUCAO LIMITADA","commercialName":"","cnpj":"28200947000165","city":"APARECIDA DE GOIÂNIA","stateCode":"GO","buscaAdicional":"TENDTUDO 28 56057 TENDTUDO S J MERITI 909281 TENDTUDO ILHA DO GOV 909300 TENDTUDO TIJUCA 909870 TENDTUDO S GONCALO 910124 TENDTUDO CAMPO GRAND 912391"},{"id":"1abb17a8-d87d-4c49-6488-08d5ad2bf6ba","name":"EQUIPLEX INDUSTRIA FARMACEUTICA LTDA -","commercialName":"","cnpj":"01784792000103","city":"APARECIDA DE GOIÂNIA","stateCode":"GO","buscaAdicional":"EQUIPLEX 56078 EQUIPLEX 907017"},{"id":"8e0d16f8-dfea-4a78-6382-08d5ad2bf6ba","name":"GSA GAMA SUCOS E ALIMENTOS LTDA.","commercialName":"","cnpj":"00774265000147","city":"APARECIDA DE GOIÂNIA","stateCode":"GO","buscaAdicional":"GSA GAMA 55419 GSA GAMA 907832"},{"id":"824fa732-2002-4a65-60be-08d5ad2bf6ba","name":"DURO PVC LTDA","commercialName":"DURO PVC","cnpj":"00426978000110","city":"APARECIDA DE GOIÂNIA","stateCode":"GO","buscaAdicional":"DURO PVC 53654 DURO PVC 904091"},{"id":"2f5bd667-fe81-491f-601c-08d5ad2bf6ba","name":"ALL NUTRI ALIMENTOS EIRELI","commercialName":"","cnpj":"05965693000170","city":"APARECIDA DE GOIÂNIA","stateCode":"GO","buscaAdicional":"ALL NUTRI 53380 ALL NUTRI ALIMENTOS 904104"},{"id":"d815f157-bdb8-4d15-5fe8-08d5ad2bf6ba","name":"LF PLASTICOS LTDA","commercialName":"JBM SACOLAS E EMBALAGENS","cnpj":"06947499000125","city":"APARECIDA DE GOIÂNIA","stateCode":"GO","buscaAdicional":"LF PLASTICOS 53282 LF PLASTICOS 904219"},{"id":"3c2f4de2-0479-497b-50b2-08d5ad2bf6ba","name":"BRENTECH ENERGIA S.A.","commercialName":"","cnpj":"07921085000190","city":"APARECIDA DE GOIÂNIA","stateCode":"GO","buscaAdicional":"BRENTECH 1786 GOIANIA II 8417 UTE.PE.GO.029460-8.01 GOIANIA II EXP 8695 UTE.PE.GO.029460-8.01"},{"id":"bb76235a-2c22-4ee4-55f1-08d5ad2bf6ba","name":"CIPA-INDUSTRIAL DE PRODUTOS ALIMENTARES LTDA","commercialName":"BOLACHAS MABEL","cnpj":"01851716000165","city":"APARECIDA DE GOIÂNIA","stateCode":"GO","buscaAdicional":"MABEL 6352 MABEL TRES LAGOS MS 888119 MABEL AP DE GOIANIA 891470"},{"id":"48578be4-8301-4b52-54f1-08d5ad2bf6ba","name":"RIALMA COMPANHIA ENERGETICA V S/A","commercialName":"PCH PONTAL DO PRATA","cnpj":"11040403000180","city":"APORÉ","stateCode":"GO","buscaAdicional":"RIALMA V 4605 ST ANTONIO DO CAIAPO 888922 PCH.PH.GO.029119-6.01 SANTA EDWIGES III 8445 PCH.PH.GO.028182-4.01 SANTA EDWIGES II 8268 PCH.PH.GO.028183-2.01 PONTAL DO PRATA 8973 PCH.PH.GO.029118-8.01"},{"id":"0cbd08ad-9a1a-49eb-4f3b-08d5ad2bf6ba","name":"ESPORA ENERGETICA S.A","commercialName":"ESPORA ENERGETICA","cnpj":"04592906000101","city":"APORÉ","stateCode":"GO","buscaAdicional":"ESPORA 144 ESPORA 8173 UHE.PH.GO.000908-3.01"},{"id":"8853817b-1aed-46cc-592f-08d5ad2bf6ba","name":"CARNAUBA GERACAO DE ENERGIA S/A","commercialName":"CARNAUBA GERACAO DE ENERGIA S/A","cnpj":"14659499000158","city":"ARENÓPOLIS","stateCode":"GO","buscaAdicional":"PCH RENIC 13998 PCH RENIC 899672 PCH.PH.GO.029663-5.01"},{"id":"8db1ab1d-eda7-48a9-5fce-08d5ad2bf6ba","name":"LATICINIOS BELA VISTA LTDA","commercialName":"LATICINIOS BELA VISTA","cnpj":"02089969000530","city":"BELA VISTA DE GOIÁS","stateCode":"GO","buscaAdicional":"PIRACANJUBA GO 53231 LATICINIOS BELA VIST 901046"},{"id":"89506fee-cd0e-4b42-4f11-08d5ad2bf6ba","name":"ENEL GREEN POWER CACHOEIRA DOURADA S.A","commercialName":"ENEL GREEN POWER","cnpj":"01672223000168","city":"CACHOEIRA DOURADA","stateCode":"GO","buscaAdicional":"CDSA 71 CACHOEIRA DOURADA 355 UHE.PH.GO.000528-2.01"},{"id":"6073baeb-9d49-4fcc-51d1-08d5ad2bf6ba","name":"RIO CLARO AGROINDUSTRIAL S.A.","commercialName":"","cnpj":"08598391000108","city":"CAÇU","stateCode":"GO","buscaAdicional":"URC 2605 OER CACU - CARGA 71210 CACU (OER CACU) 8654 UTE.AI.GO.030025-0.01"},{"id":"35af01d9-3b3d-4466-51ac-08d5ad2bf6ba","name":"PCA-PECUARIA COMERCIO E AGRICULTURA LTDA","commercialName":"PCA COMERCIAL","cnpj":"24995516000181","city":"CAIAPÔNIA","stateCode":"GO","buscaAdicional":"PCA I5 2493 RIO BONITO II 8476 CGH.PH.GO.029302-4.01 RIO BONITO I 8965 CGH.PH.GO.028193-0.01"},{"id":"6b7244d0-f566-4eb8-68c4-08d5ad2bf6ba","name":"RIVIERA PARK THERMAS FLAT SERVICE","commercialName":"XXXXXXXXXXXXXXXXXX","cnpj":"18256799000147","city":"CALDAS NOVAS","stateCode":"GO","buscaAdicional":"RIVIERA PARK 60398 WT CONSTRUTORA RIVER 909331"},{"id":"061a0a09-4d02-4d12-98dd-08d5dd07bdf9","name":"CONDOMINIO THERMAS BOULEVARD SUITE HOTEL","commercialName":"","cnpj":"12781891000140","city":"CALDAS NOVAS","stateCode":"GO","buscaAdicional":""},{"id":"1edcc273-b216-4963-88fc-08d5ae44ed50","name":"WT CONSTRUTORA E INCORPORADORA-SPE LTDA","commercialName":"","cnpj":"08862175000110","city":"CALDAS NOVAS","stateCode":"GO","buscaAdicional":"WT CONSTRUTORA 58607"},{"id":"c3bf0a70-276f-4a29-63fc-08d5ad2bf6ba","name":"BW&P SISTEMAS DE SOLDA E PINTURA LTDA","commercialName":"","cnpj":"19416614000187","city":"CATALÃO","stateCode":"GO","buscaAdicional":"BWP 55763 BWP CATALAO 907172"},{"id":"3f308aab-ac05-47f9-6487-08d5ad2bf6ba","name":"JOHN DEERE BRASIL LTDA","commercialName":"","cnpj":"89674782001049","city":"CATALÃO","stateCode":"GO","buscaAdicional":"JD CATALAO 56058 JOHN DEERE CATALAO 906985"},{"id":"7a38412a-cd8e-4245-533e-08d5ad2bf6ba","name":"SERRA DO FACAO ENERGIA S.A.","commercialName":"","cnpj":"07727966000174","city":"CATALÃO","stateCode":"GO","buscaAdicional":"SEFAC 3535 SERRA DO FACAO 8711 UHE.PH.GO.028355-0.01"},{"id":"506cfea6-50a1-4fdf-57e2-08d5ad2bf6ba","name":"COMPANHIA HIDROELETRICA SAO PATRICIO - CHESP","commercialName":"","cnpj":"01377555000110","city":"CERES","stateCode":"GO","buscaAdicional":"CHESP DIST 9929 CHESP 909900"},{"id":"f3170679-b63f-4ee8-5dd9-08d5ad2bf6ba","name":"COMPANHIA SAO PATRICIO DE GERACAO E TRANSMISSAO DE ENERGIA ELETRICA - CSP-G&T","commercialName":"CSP-G&T","cnpj":"18433682000191","city":"CERES","stateCode":"GO","buscaAdicional":"CSP-G&T 52024 SAO PATRICIO 889140 PCH.PH.GO.026879-8.01"},{"id":"b648f4d1-a063-4201-51f8-08d5ad2bf6ba","name":"CERRADINHO BIOENERGIA S.A.","commercialName":"","cnpj":"08322396000103","city":"CHAPADÃO DO CÉU","stateCode":"GO","buscaAdicional":"UTEPORTODAGUAS 2747 PORTO AGUAS CONSUMO 897886 PORTO DAS AGUAS 8656 UTE.AI.GO.029999-5.01"},{"id":"bf9dc572-580a-4104-5ff9-08d5ad2bf6ba","name":"MINERACAO PIRINEUS LTDA","commercialName":"","cnpj":"37588415000308","city":"COCALZINHO DE GOIÁS","stateCode":"GO","buscaAdicional":"MIN PIRINEUS 53320 MINERACAO PIRINEUS 907178"},{"id":"1a71c79c-4088-426b-66f9-08d5ad2bf6ba","name":"GOIASMINAS INDUSTRIA DE LATICINIOS LTDA","commercialName":"ITALAC","cnpj":"01257995000133","city":"CORUMBAÍBA","stateCode":"GO","buscaAdicional":"ITALAC 57906 ITALAC CORUMBAIBA 908211"},{"id":"e5ef006d-b9c9-484b-5dca-08d5ad2bf6ba","name":"CRISTALINA ALIMENTOS LTDA","commercialName":"","cnpj":"10666522000180","city":"CRISTALINA","stateCode":"GO","buscaAdicional":"CRISTALINA 51987 CRISTALINA ALIMENTOS 902661"},{"id":"6d12cd7c-99f2-451b-4f7a-08d5ad2bf6ba","name":"MINERACAO SERRA GRANDE S A","commercialName":"","cnpj":"42445403000194","city":"CRIXÁS","stateCode":"GO","buscaAdicional":"SERRA GRANDE 1131 MSG MIN SERRA GDE CR 7587"},{"id":"08107a2c-66c4-4cfc-51c7-08d5ad2bf6ba","name":"BP BIOENERGIA TROPICAL S.A","commercialName":"TROPICAL BIOENERGIA","cnpj":"08195806000194","city":"EDÉIA","stateCode":"GO","buscaAdicional":"BP TRP 2583 TROPICAL CONSUMO 891502 TROPICAL II 894582 UTE.AI.GO.031769-1.01 TROPICAL 891622 UTE.AI.GO.030080-2.01"},{"id":"31d85b53-e3dd-4507-51c0-08d5ad2bf6ba","name":"JALLES MACHADO S.A.","commercialName":"","cnpj":"02635522000195","city":"GOIANÉSIA","stateCode":"GO","buscaAdicional":"JALLES MACHADO 2572 JALLES MACHADO - JM 545 UTE.AI.GO.028112-3.01"},{"id":"1c3af165-7854-4789-528f-08d5ad2bf6ba","name":"ALBIOMA CODORA ENERGIA S.A","commercialName":"UTE CODORA","cnpj":"07966116000129","city":"GOIANÉSIA","stateCode":"GO","buscaAdicional":"UTE CODORA 3143 ALBIOMA CODORA C 902254 CODORA 8885 UTE.AI.GO.030355-0.01"},{"id":"d72148b0-5d20-4ea6-5a56-08d5ad2bf6ba","name":"USINA GOIANESIA S/A","commercialName":"USINA GOIANESIA","cnpj":"02460988000105","city":"GOIANÉSIA","stateCode":"GO","buscaAdicional":"UTE GOIANESIA 17355 UTE GOIANESIA 897345 UTE.AI.GO.028113-1.01"},{"id":"aac65881-718a-4a93-6613-08d5ad2bf6ba","name":"LIMAGRAIN BRASIL S.A.","commercialName":"LIMAGRAIN BRASIL S.A.","cnpj":"12770927000270","city":"GOIANÉSIA","stateCode":"GO","buscaAdicional":"LIMAGRAIN BRASIL S/A 57292 LIMAGRAIN GOIANESIA 908189"},{"id":"7507971b-a440-4fcb-6589-08d5ad2bf6ba","name":"SPE MEGA MODA SHOPPING LTDA","commercialName":"MEGA MODA","cnpj":"14366423000134","city":"GOIÂNIA","stateCode":"GO","buscaAdicional":"MEGA MODA 56813 MEGA MODA SHOPPING 1 907175 LOJA 907176"},{"id":"3c36a04e-8c7c-4656-6586-08d5ad2bf6ba","name":"MEGA MODA HOTEL LTDA","commercialName":"MEGA MODA HOTEL","cnpj":"17329575000155","city":"GOIÂNIA","stateCode":"GO","buscaAdicional":"HOTEL MEGA MODA 56799 HOTEL MEGA MODA 907177"},{"id":"5d978a0f-2f97-4482-65a7-08d5ad2bf6ba","name":"METALGRAFICA IGUACU S A","commercialName":"","cnpj":"80227184001480","city":"GOIÂNIA","stateCode":"GO","buscaAdicional":"METAL IGUACU GO 56903 METAL IGUACU 909090"},{"id":"37ab907e-4494-4628-6720-08d5ad2bf6ba","name":"COSMED INDUSTRIA DE COSMETICOS E MEDICAMENTOS S.A.","commercialName":"","cnpj":"61082426001289","city":"GOIÂNIA","stateCode":"GO","buscaAdicional":"COSMED GYN 57971 COSMED GYN 909914"},{"id":"64286676-f9be-4073-66c3-08d5ad2bf6ba","name":"CONDOMINIO GOIANIA CORPORATE FINANCIAL CENTER","commercialName":"GOIANIA CORPORATE FINANCIAL CENTER","cnpj":"03532908000134","city":"GOIÂNIA","stateCode":"GO","buscaAdicional":"GOIANIA CORPORATE 57790 GOIANIA CORPORATE 909310"},{"id":"75c0175a-b05b-4250-676a-08d5ad2bf6ba","name":"CENTRO EDUCACIONAL ALVES FARIA LTDA.","commercialName":"FACULDADES ALFA","cnpj":"02850990000182","city":"GOIÂNIA","stateCode":"GO","buscaAdicional":"FACULDADES ALFA 58083 FAC ALFA JOAO VAZ 908852"},{"id":"bd63dd4f-0b28-4c2f-689e-08d5ad2bf6ba","name":"LATICINIOS BELA VISTA LTDA","commercialName":"LATICINIOS BELA VISTA","cnpj":"02089969000106","city":"GOIÂNIA","stateCode":"GO","buscaAdicional":"PIRACANJUBA MATRIZ 60213 PIRACANJUBA MG 906333 PIRACANJUBA QJO2 911299"},{"id":"eb30f21b-8bc2-4152-6860-08d5ad2bf6ba","name":"CONDOMINIO PORTAL SUL SHOPPING","commercialName":"CONDOMINIO PORTAL SUL SHOPPING","cnpj":"22861051000140","city":"GOIÂNIA","stateCode":"GO","buscaAdicional":"SHOP PORTAL SUL 59872 SHOP PORTAL SUL 905827"},{"id":"a43023c8-1a86-4370-6903-08d5ad2bf6ba","name":"TERMOPOT - TERMOFORMAGENS LTDA","commercialName":"","cnpj":"03569492000129","city":"GOIÂNIA","stateCode":"GO","buscaAdicional":"TERMOPOT 60719 TERMOPOT 912441"},{"id":"5285e7cd-7dc1-45bf-64f5-08d5ad2bf6ba","name":"CASTRO HOTEIS E TURISMO LTDA","commercialName":"CASTRO'S PARK HOTEL","cnpj":"02839603000107","city":"GOIÂNIA","stateCode":"GO","buscaAdicional":"CASTRO HOTEIS 56328 CASTRO HOTEIS 906364"},{"id":"c6cdb59c-f39c-4be0-638f-08d5ad2bf6ba","name":"JARDIM GOIAS EMPREENDIMENTOS LTDA","commercialName":"JARDIM GOIAS EMPREENDIMENTOS","cnpj":"02103836000147","city":"GOIÂNIA","stateCode":"GO","buscaAdicional":"JARDIM GOIAS 55465 JARDIM GOIAS 908470 JARDIM GO FLAMBOYANT 908500"},{"id":"05cea94e-8223-473b-632e-08d5ad2bf6ba","name":"CONDOMINIO SHOPPING CENTER CERRADO","commercialName":"","cnpj":"24357174000174","city":"GOIÂNIA","stateCode":"GO","buscaAdicional":"SHOPPING CERRADO 55236 SHOPPING CERRADO 908205"},{"id":"52383927-00a4-4b9f-6295-08d5ad2bf6ba","name":"CONDOMINIO PASSEIO DAS AGUAS SHOPPING","commercialName":"","cnpj":"23282496000139","city":"GOIÂNIA","stateCode":"GO","buscaAdicional":"PASSEIO DAS AGUAS 54809 SHOP PASSEIO AGUAS 905828"},{"id":"e7443584-c91e-4c3d-6208-08d5ad2bf6ba","name":"TELEVISAO ANHANGUERA S/A","commercialName":"","cnpj":"01534510000101","city":"GOIÂNIA","stateCode":"GO","buscaAdicional":"TV ANHANGUERA 54509 TV ANHANGUERA SERRIN 908190"},{"id":"fde0fb78-732d-4c18-1cac-08d5b8870181","name":"IPE COMERCIALIZADORA DE ENERGIA LTDA","commercialName":"IPE COMERCIALIZADORA","cnpj":"28397998000129","city":"GOIÂNIA","stateCode":"GO","buscaAdicional":"IPE COMERCIALIZADORA 60737"},{"id":"0a9268a9-e7bb-41f0-88e6-08d5ae44ed50","name":"PORTAL SUL PARTICIPACOES E EMPREENDIMENTOS SPE - LTDA","commercialName":"","cnpj":"09217249000128","city":"GOIÂNIA","stateCode":"GO","buscaAdicional":"SHOPPING PORTAL SUL 54691"},{"id":"c69a79e4-0535-42f1-7230-08d5cf600bef","name":"SANEAMENTO DE GOIAS S/A","commercialName":"SANEAGO","cnpj":"01616929000102","city":"GOIÂNIA","stateCode":"GO","buscaAdicional":""},{"id":"e2feba99-389d-47f0-b9c2-08d5caef97db","name":"NL - NEGOCIOS IMOBILIARIOS LTDA","commercialName":"NL - IMOBILIARIOS LTDA","cnpj":"09531384000143","city":"GOIÂNIA","stateCode":"GO","buscaAdicional":"OPEN MALL 58080 STREET MALL 913594 OPEN MALL 913595"},{"id":"433f59bb-fd1f-4599-72d3-08d5cf600bef","name":"COMPANHIA CELG DE PARTICIPACOES - CELGPAR","commercialName":"CELGPAR (COMPANHIA)","cnpj":"08560444000193","city":"GOIÂNIA","stateCode":"GO","buscaAdicional":""},{"id":"29512fb1-2ecc-4c7f-712a-08d5e10d149e","name":"PIRINEUS PARTICIPACAO E ADMINISTRACAO LTDA","commercialName":"PIRINEUS PARTICIPACAO","cnpj":"11013559000172","city":"GOIÂNIA","stateCode":"GO","buscaAdicional":""},{"id":"55c8f7d1-a658-4cda-4edf-08d5d159243d","name":"CONCEBRA - CONCESSIONARIA DAS RODOVIAS CENTRAIS DO BRASIL S.A.","commercialName":"CONCEBRA","cnpj":"18572225000188","city":"GOIÂNIA","stateCode":"GO","buscaAdicional":""},{"id":"c1de8136-fef8-45ba-598c-08d5ad2bf6ba","name":"BC COMERCIALIZADORA DE ENERGIA LTDA","commercialName":"BC ENERGIA","cnpj":"18384740000134","city":"GOIÂNIA","stateCode":"GO","buscaAdicional":"GRUPO BC 14836"},{"id":"907b8e0f-b947-4465-5e28-08d5ad2bf6ba","name":"PACTO COMERCIALIZADORA DE ENERGIA ELETRICA E GAS NATURAL S/A","commercialName":"PACTO COMERCIALIZADORA","cnpj":"23412242000198","city":"GOIÂNIA","stateCode":"GO","buscaAdicional":"TOTAL COMERCIALIZADORA 52238"},{"id":"2cc43af4-baa8-4e74-5daa-08d5ad2bf6ba","name":"CONDOMINIO DE ADMINISTRACAO DO GOIANIA SHOPPING","commercialName":"","cnpj":"00902073000179","city":"GOIÂNIA","stateCode":"GO","buscaAdicional":"GOIANIA SHOPPING 51949 GOIANIA SHOPPING 901049"},{"id":"60a715df-f38c-441d-5da8-08d5ad2bf6ba","name":"MAIA E BORBA S/A","commercialName":"","cnpj":"01850114000193","city":"GOIÂNIA","stateCode":"GO","buscaAdicional":"ARAGUAIA SHOPPING 51947 ARAGUAIA SHOPPING 899832"},{"id":"6d6e7917-6a1e-4b35-6022-08d5ad2bf6ba","name":"HALEX ISTAR INDUSTRIA FARMACEUTICA SA","commercialName":"HALEX ISTAR INDUSTRIA FARMACEUTICA","cnpj":"01571702000198","city":"GOIÂNIA","stateCode":"GO","buscaAdicional":"HALEX ISTAR 53398 HALEX ISTAR 904185"},{"id":"e3cdeb94-2f90-43f7-6062-08d5ad2bf6ba","name":"SHOPPING ESTACAO GOIANIA EMPREENDIMENTOS E EVENTOS S/A","commercialName":"ESTACAO GOIANIA","cnpj":"06017828000139","city":"GOIÂNIA","stateCode":"GO","buscaAdicional":"SHOP ESTACAO GOIANIA 53486 SHOP ESTACAO GOIANIA 905022"},{"id":"f038f60c-27f7-49b7-60dd-08d5ad2bf6ba","name":"SORVETERIA CREME MEL S.A","commercialName":"CREME MEL SORVETES","cnpj":"03857539000150","city":"GOIÂNIA","stateCode":"GO","buscaAdicional":"CREME MEL 53790 SORVETERIA CREME MEL 901514"},{"id":"aed033e9-bd7c-42e8-5f05-08d5ad2bf6ba","name":"CIFARMA CIENTIFICA FARMACEUTICA LTDA","commercialName":"","cnpj":"17562075000169","city":"GOIÂNIA","stateCode":"GO","buscaAdicional":"TRD-CIFARMAGO 52707 CIFARMA CIENTIFICA 903116"},{"id":"edb98c4f-3671-42ca-5194-08d5ad2bf6ba","name":"USINA XAVANTES S.A","commercialName":"USINA XAVANTES","cnpj":"08435796000117","city":"GOIÂNIA","stateCode":"GO","buscaAdicional":"UTXA 2390 XAVANTES ARUANA 8300 UTE.PE.GO.028654-0.01 XAVANTES ARUANA EXP 88300 UTE.PE.GO.028654-0.01"},{"id":"d5400ea0-fdc7-40ed-5184-08d5ad2bf6ba","name":"CELG GERACAO E TRANSMISSAO S.A.","commercialName":"CELG GT","cnpj":"07779299000173","city":"GOIÂNIA","stateCode":"GO","buscaAdicional":"CELG GERATRANS 2226 SAO DOMINGOS - CELG 498 UHE.PH.GO.027665-0.01 ROCHEDO ACL 895981 UHE.PH.GO.002537-2.02 ROCHEDO 499 UHE.PH.GO.002537-2.02 ROCHEDO ACL 895981 UHE.PH.GO.002537-2.02"},{"id":"1dadd1f5-8a65-46af-4ee6-08d5ad2bf6ba","name":"CELG DISTRIBUICAO S.A. - CELG D","commercialName":"CELG D","cnpj":"01543032000104","city":"GOIÂNIA","stateCode":"GO","buscaAdicional":"CELG 15 CELG 16 CELG DITC 70695 CELG TER - SE EDEIA 897193"},{"id":"4010e343-3367-4915-54f4-08d5ad2bf6ba","name":"ATUAL COMERCIALIZADORA DE ENERGIA ELETRICA LTDA","commercialName":"ATUAL ENERGIA","cnpj":"14167541000113","city":"GOIÂNIA","stateCode":"GO","buscaAdicional":"ATUAL ENERGIA 4617"},{"id":"eadb2637-87e5-4bee-54bb-08d5ad2bf6ba","name":"UNILEVER BRASIL INDUSTRIAL LTDA","commercialName":"","cnpj":"01615814002066","city":"GOIÂNIA","stateCode":"GO","buscaAdicional":"UNIGOIANIA 4467 UNILEVER - GOIANIA 72167"},{"id":"9038ed86-8f34-455a-545a-08d5ad2bf6ba","name":"CARGILL AGRICOLA S A","commercialName":"CARGILL AGRICOLA S.A.","cnpj":"60498706037077","city":"GOIÂNIA","stateCode":"GO","buscaAdicional":"CARGILL GOIAN 4189 CARGILL - GOIANIA 7298"},{"id":"cc7da529-4843-4f8f-55d6-08d5ad2bf6ba","name":"MARAJOARA INDUSTRIA DE LATICINIOS LTDA","commercialName":"","cnpj":"24849580000154","city":"HIDROLÂNDIA","stateCode":"GO","buscaAdicional":"COG-MARAJOARA 6228 MARAJOARA LATICINIOS 890442"},{"id":"c1e45301-06b7-4056-5ebe-08d5ad2bf6ba","name":"SEBO HIDROLANDIA INDUSTRIA E COMERCIO DE PRODUTOS ANIMAIS LTDA","commercialName":"SEBO HIDROLANDIA","cnpj":"08596902000144","city":"HIDROLÂNDIA","stateCode":"GO","buscaAdicional":"SEBO HIDROLANDIA 52533 SEBO HIROLANDIA 904154"},{"id":"a70a56fe-e507-402b-66e6-08d5ad2bf6ba","name":"MARIZA AGUAS MINERAIS LTDA","commercialName":"MARIZA AGUA MINERAL","cnpj":"07191574000133","city":"HIDROLÂNDIA","stateCode":"GO","buscaAdicional":"MARIZA AGUAS 57879 MARIZA AGUAS 908499"},{"id":"e5943c9d-1a1e-4c71-5ffa-08d5ad2bf6ba","name":"CALCARIO OURO BRANCO LTDA","commercialName":"","cnpj":"37883097000219","city":"INDIARA","stateCode":"GO","buscaAdicional":"OURO BRANCO 53321 OURO BRANCO 909313"},{"id":"493c82f2-0c30-4c4d-5ff1-08d5ad2bf6ba","name":"FILLERCAL MINERACAO E COMERCIO LTDA","commercialName":"FILLERCAL","cnpj":"00420347000274","city":"INDIARA","stateCode":"GO","buscaAdicional":"FILLERCAL 53305 FILLERCAL 904823"},{"id":"1e3f47a0-b0d0-4c1e-5bc5-08d5ad2bf6ba","name":"INVIVO NUTRICAO E SAUDE ANIMAL LTDA","commercialName":"","cnpj":"06066837001191","city":"INHUMAS","stateCode":"GO","buscaAdicional":"INVIVO INHUMAS 50892 INVIVO NUTRICAO GO 899143"},{"id":"18676596-015f-4df4-5401-08d5ad2bf6ba","name":"LASA LAGO AZUL SA","commercialName":"LASA LAGO AZUL SA","cnpj":"02678100000105","city":"IPAMERI","stateCode":"GO","buscaAdicional":"LASA 3949 LAGO AZUL AP 70621 LAGO AZUL 8372 PCH.PH.GO.001298-0.01"},{"id":"68714cf0-2aac-4701-559a-08d5ad2bf6ba","name":"SAO SALVADOR ALIMENTOS S/A","commercialName":"SUPER FRANGO - RACOES","cnpj":"03387396000240","city":"ITABERAÍ","stateCode":"GO","buscaAdicional":"COG-SPFRANGO 5882 S FRANGO RAC ITABERI 72034"},{"id":"dc2100ba-870d-4120-5680-08d5ad2bf6ba","name":"SAO SALVADOR ALIMENTOS S/A","commercialName":"SSA","cnpj":"03387396000160","city":"ITABERAÍ","stateCode":"GO","buscaAdicional":"SSA ABATEDOURO 7206 SAO SALVADOR ALI 903983"},{"id":"ae05b2b6-60e0-4c36-53e5-08d5ad2bf6ba","name":"QUEIXADA ENERGETICA S/A","commercialName":"","cnpj":"11896615000164","city":"ITARUMÃ","stateCode":"GO","buscaAdicional":"QUEIXADA 3896 QUEIXADA 888171 PCH.PH.GO.030272-4.01"},{"id":"e4467c74-e8d7-46da-4f77-08d5ad2bf6ba","name":"CARAMURU ALIMENTOS S.A.","commercialName":"","cnpj":"00080671000100","city":"ITUMBIARA","stateCode":"GO","buscaAdicional":"CARAMURU PIE I 1124 CARAMURU-ITUMBIARA 7503 CAMARURU ALIMENTOS 899702 CARAMURU OLEOS 899703 CARAMURU SAO SIMAO 901092 CARAMURU IPAMERI 908058 UTE CARAMURU SORRISO 904343 UTE.AI.MT.034012-0.01 CARAMURU 909789 UTE.AI.GO.035527-5.01 UTE CARAMURU SORRISO 904343 UTE.AI.MT.034012-0.01"},{"id":"03577a2c-19da-4298-51f1-08d5ad2bf6ba","name":"BP BIOENERGIA ITUMBIARA S.A.","commercialName":"ITUMBIARA BIOENERGIA","cnpj":"08517600000133","city":"ITUMBIARA","stateCode":"GO","buscaAdicional":"BP ITB 2732 ITUMBIARA CNAA 889136 ITUMBIARA (CNAA) 8684 UTE.AI.GO.030090-0.01"},{"id":"cfa39b75-f88a-4ce0-67f0-08d5ad2bf6ba","name":"ACOFERGO TUBOS E PERFILADOS S/A","commercialName":"ACOFERGO TUBOS E PERFILADOS","cnpj":"06881776000144","city":"ITUMBIARA","stateCode":"GO","buscaAdicional":"ACOFERGO 58910 ACOFERGO 909111"},{"id":"0449cf5d-e43f-4aa2-62f7-08d5ad2bf6ba","name":"CARGILL AGRICOLA S A","commercialName":"","cnpj":"60498706013054","city":"ITUMBIARA","stateCode":"GO","buscaAdicional":"CARGILL ITB 55062 CARGILL AGRICOLA 906365"},{"id":"e6b7b02d-6a54-4394-887b-08d5ae44ed50","name":"RIALMA COMPANHIA ENERGETICA IV S/A","commercialName":"RIALMA COMPANHIA ENERGETICA IV","cnpj":"12459354000188","city":"IVOLÂNDIA","stateCode":"GO","buscaAdicional":"RIALMA ENER IV 8431"},{"id":"322f08e7-e52c-49f8-593c-08d5ad2bf6ba","name":"BIOENERGIA JATAI LTDA.","commercialName":"","cnpj":"18686104000167","city":"JATAÍ","stateCode":"GO","buscaAdicional":"BIO JATAI 14175 JATAI - CONSUMO 889679 JATAI (COSAN) 8638 UTE.AI.GO.030043-8.01"},{"id":"69a920fe-93cd-4888-595b-08d5ad2bf6ba","name":"ENERGETICA FAZENDA VELHA S/A","commercialName":"ENERGETICA FAZENDA VELHA","cnpj":"11792420000174","city":"JATAÍ","stateCode":"GO","buscaAdicional":"FAZENDA VELHA 14296 FAZENDA VELHA 898953 PCH.PH.GO.031575-3.01"},{"id":"bb574b66-8f98-4927-884a-08d5ae44ed50","name":"RIALMA COMPANHIA ENERGETICA III S/A","commercialName":"","cnpj":"06572941000186","city":"MAMBAÍ","stateCode":"GO","buscaAdicional":"RIALMA ENER III 2565"},{"id":"24ecbd94-19ad-4f07-8848-08d5ae44ed50","name":"RIALMA COMPANHIA ENERGETICA II S/A","commercialName":"","cnpj":"05365005000131","city":"MAMBAÍ","stateCode":"GO","buscaAdicional":"RIALMA ENER II 2205"},{"id":"9c20f64f-9d8f-4a33-4ff6-08d5ad2bf6ba","name":"SAMA S.A. - MINERACOES ASSOCIADAS","commercialName":"SAMA","cnpj":"15104599000180","city":"MINAÇU","stateCode":"GO","buscaAdicional":"SAMA 1374 SAMA-MINACU-GO 7465"},{"id":"a56621e4-a685-40bf-54c8-08d5ad2bf6ba","name":"COOPERATIVA MISTA DOS PRODUTORES DE LEITE DE MORRINHOS","commercialName":"","cnpj":"02667442000111","city":"MORRINHOS","stateCode":"GO","buscaAdicional":"COG-CPLEMGO 4496 COMPLEM-MORRINHOS 71766"},{"id":"8b7d2411-f911-401d-5700-08d5ad2bf6ba","name":"CENTRAL ENERGETICA MORRINHOS SA","commercialName":"","cnpj":"07130855000186","city":"MORRINHOS","stateCode":"GO","buscaAdicional":"CEM MORRINHOS 8122 CEM 888449 UTE.AI.GO.029546-9.01"},{"id":"393c5cb7-bc32-45c2-6127-08d5ad2bf6ba","name":"BONASA ALIMENTOS S/A","commercialName":"BONASA","cnpj":"03573324002584","city":"NOVA VENEZA","stateCode":"GO","buscaAdicional":"BONASA GO 54038 BONASA GO 907173"},{"id":"a31cb3b3-fb42-48ac-64b3-08d5ad2bf6ba","name":"CONSERVAS ODERICH SA","commercialName":"","cnpj":"97191902001085","city":"ORIZONA","stateCode":"GO","buscaAdicional":"CONSERVAS ODERICH 56165 ODERICH ORIZONA 907158"},{"id":"737883de-a99e-432c-592e-08d5ad2bf6ba","name":"TAMBORIL ENERGETICA S/A","commercialName":"","cnpj":"14897684000180","city":"PALESTINA DE GOIÁS","stateCode":"GO","buscaAdicional":"PCH TAMBORIL 13997 TAMBORIL 895154 PCH.PH.GO.029648-1.01"},{"id":"609e92fd-6ffe-43ae-587b-08d5ad2bf6ba","name":"CENTRAL ENERGETICA PALMEIRAS S.A","commercialName":"","cnpj":"13348048000137","city":"PALMEIRAS DE GOIÁS","stateCode":"GO","buscaAdicional":"CEPAL 11994 PALMEIRAS DE GOIAS 8771 UTE.PE.GO.001946-1.01"},{"id":"93ac58e2-dbaa-45dc-6774-08d5ad2bf6ba","name":"RIO BRANCO ALIMENTOS S/A","commercialName":"PIF PAF","cnpj":"05017780001844","city":"PALMEIRAS DE GOIÁS","stateCode":"GO","buscaAdicional":"PIFPAFFPGO 58121 RIO BRANCO ALIM 909467"},{"id":"9d6b7c59-aa86-4529-5e13-08d5ad2bf6ba","name":"NOVA GALIA BIOENERGIA LTDA","commercialName":"NG BIOENERGIA","cnpj":"11416268000125","city":"PARAÚNA","stateCode":"GO","buscaAdicional":"NOVA GALIA BIOENERGIA 52189 UTE NG BIOENERGIA I 906174 UTE.AI.GO.031033-6.01"},{"id":"2c1da591-1d6b-4c14-5a7e-08d5ad2bf6ba","name":"PILAR DE GOIAS DESENVOLVIMENTO MINERAL S.A","commercialName":"","cnpj":"21823063000118","city":"PILAR DE GOIÁS","stateCode":"GO","buscaAdicional":"PILAR 49789 PROJETO PILAR 890204"},{"id":"92051506-051a-41a9-63cc-08d5ad2bf6ba","name":"LACTOSUL INDUSTRIA DE LATICINIOS -LTDA","commercialName":"LATICINIOS CENTRO OESTE","cnpj":"05915146000180","city":"PIRANHAS","stateCode":"GO","buscaAdicional":"LATICINIOS CENTRO OESTE 55634 LACTOSUL 907767"},{"id":"c580e8b2-c23a-4905-6402-08d5ad2bf6ba","name":"NUTRIZA AGROINDUSTRIAL DE ALIMENTOS S/A","commercialName":"NUTRIZA","cnpj":"37020260000139","city":"PIRES DO RIO","stateCode":"GO","buscaAdicional":"NUTRIZA 55785 NUTRIZA GO 907018"},{"id":"f3843761-23d9-41e8-604f-08d5ad2bf6ba","name":"OLVEGO OLEOS VEGETAIS DE GOIAS LTDA","commercialName":"","cnpj":"02136380000111","city":"PIRES DO RIO","stateCode":"GO","buscaAdicional":"OLVEGO 53459 OLVEGO 903160"},{"id":"1609d8c4-5009-4f0c-5e36-08d5ad2bf6ba","name":"ARAGUAIA MINERACAO E INDUSTRIA LTDA","commercialName":"","cnpj":"05691237000260","city":"PLANALTINA","stateCode":"GO","buscaAdicional":"ARAGUAIA MINERACAO 52284 ARAGUAIA MINERACAO 907171"},{"id":"6859a08d-7a26-4917-5e3c-08d5ad2bf6ba","name":"COMPANHIA THERMAS DO RIO QUENTE","commercialName":"","cnpj":"01540533000129","city":"RIO QUENTE","stateCode":"GO","buscaAdicional":"RIO QUENTE RESORT 52291 RIO QUENTE RESORT 899937"},{"id":"640f719e-014f-4568-5134-08d5ad2bf6ba","name":"CARGILL AGRICOLA S A","commercialName":"CARGILL AGRICOLA","cnpj":"60498706006600","city":"RIO VERDE","stateCode":"GO","buscaAdicional":"CARGILL RVE 2046 CARGILL RVE R VERDE 70409"},{"id":"320544ac-6762-4fef-6172-08d5ad2bf6ba","name":"CEREAL COMERCIO EXPORTACAO E REPRESENTACAO AGROPECUARIA SA","commercialName":"","cnpj":"00012377000160","city":"RIO VERDE","stateCode":"GO","buscaAdicional":"CEREAL COM 54194 CEREAL AGROPECUARIA 905825"},{"id":"61725cbe-6144-4c60-6770-08d5ad2bf6ba","name":"OUROLAC INDUSTRIA DE ALIMENTOS S/A","commercialName":"","cnpj":"04865228000103","city":"RIO VERDE","stateCode":"GO","buscaAdicional":"OUROLAC 58097 OUROLAC 909739"},{"id":"da0af518-31d0-4c58-6747-08d5ad2bf6ba","name":"BURITI SHOPPING RIO VERDE","commercialName":"CONDOMINIO BURITI SHOPPING RIO VERDE","cnpj":"24130714000182","city":"RIO VERDE","stateCode":"GO","buscaAdicional":"SHOPPING BRV 58026 SHOP BURITI RIO VERD 905023"},{"id":"4318161c-dc6a-481c-88e7-08d5ae44ed50","name":"ASSOCIACAO BURITI SHOPPING RIO VERDE","commercialName":"ASSOCIACAO BURITI SHOPPING RIO VERDE","cnpj":"20865574000130","city":"RIO VERDE","stateCode":"GO","buscaAdicional":"SHOP BURITI RIO VERDE 54694"},{"id":"c4f86d63-da36-4f4d-58e6-08d5ad2bf6ba","name":"SANTA HELENA ENERGIA S/A","commercialName":"","cnpj":"12150746000160","city":"SANTA HELENA DE GOIÁS","stateCode":"GO","buscaAdicional":"SANTA HELENA 13462 PCH YPE 909031 PCH.PH.GO.031327-0.01"},{"id":"2e1e2c6b-d642-472c-88da-08d5ae44ed50","name":"CARAMURU ALIMENTOS S.A.","commercialName":"","cnpj":"00080671000371","city":"SÃO SIMÃO","stateCode":"GO","buscaAdicional":"CARAMURU SAO SIMAO 53344"},{"id":"dd2cfe5e-9021-4602-64b2-08d5ad2bf6ba","name":"CICOPAL INDUSTRIA E COMERCIO DE PRODUTOS ALIMENTICIOS E HIGIENE PESSOAL LTDA","commercialName":"CICOPAL","cnpj":"01121175000110","city":"SENADOR CANEDO","stateCode":"GO","buscaAdicional":"CICOPAL 56164 CICOPAL 908469"},{"id":"8be4aa41-82d7-465d-5de3-08d5ad2bf6ba","name":"JAEPEL PAPEIS E EMBALAGENS S.A","commercialName":"","cnpj":"06142539000161","city":"SENADOR CANEDO","stateCode":"GO","buscaAdicional":"JAEPEL 52057 JAEPEL PAPEIS 901060"},{"id":"25d4a228-b5b1-4d96-5af0-08d5ad2bf6ba","name":"ENERGETICA SERRANOPOLIS LTDA","commercialName":"","cnpj":"05643160000172","city":"SERRANÓPOLIS","stateCode":"GO","buscaAdicional":"SERRANOPOLIS 50363 UTE SERRANOPOLIS 909380 UTE.AI.GO.029989-8.01"},{"id":"ec4e0f35-ef27-4227-606b-08d5ad2bf6ba","name":"INDUSTRIA E COMERCIO DE BEBIDAS IMPERIAL S/A","commercialName":"IMPERIAL","cnpj":"00552646000181","city":"TRINDADE","stateCode":"GO","buscaAdicional":"BEBIDAS IMPERIAL 53499 BEBIDAS IMPERIAL 904825"},{"id":"15d2d6d5-0272-4516-676c-08d5ad2bf6ba","name":"REBIC EMBALAGENS INDUSTRIA E COMERCIO LTDA","commercialName":"","cnpj":"01370480000145","city":"TRINDADE","stateCode":"GO","buscaAdicional":"REBIC 58086 REBIC IND EMBALAGENS 908827"},{"id":"b10f6928-939f-4109-6950-08d5ad2bf6ba","name":"REFRESCOS BANDEIRANTES INDUSTRIA E COMERCIO LTDA","commercialName":"REFRESCOS BANDEIRANTES","cnpj":"03380763001507","city":"TRINDADE","stateCode":"GO","buscaAdicional":"REFRESCOS BANDEIRANTES IND 61048 REFRESCOS BANDEIRANT 911287"},{"id":"18f81a21-43ed-484c-6258-08d5ad2bf6ba","name":"CONDOMINIO DO SHOPPING SUL","commercialName":"","cnpj":"74155474000149","city":"VALPARAÍSO DE GOIÁS","stateCode":"GO","buscaAdicional":"SHOPPING SUL 54692 SHOP SUL VALPARAISO 906599"},{"id":"cd160095-44c2-4c3f-631b-08d5ad2bf6ba","name":"UNIAO BRASILEIRA DE EDUCACAO E ENSINO","commercialName":"","cnpj":"17200684000178","city":"BRASÍLIA","stateCode":"DF","buscaAdicional":"UBEE 55172 UBEE LAVRAS 906548 UBEE TIJUCA 908905"},{"id":"8b81911c-5455-41dc-612f-08d5ad2bf6ba","name":"BONASA ALIMENTOS S/A","commercialName":"BONASA","cnpj":"03573324001502","city":"BRASÍLIA","stateCode":"DF","buscaAdicional":"BONASA DF RACAO 54048 BONASA DF RACAO 907157"},{"id":"a633b4e9-beb5-4200-6205-08d5ad2bf6ba","name":"JUNO VELOSO VIDAL DOS SANTOS EIRELI","commercialName":"JVC DISTRIBUIDORA E COMERCIO DE ALIMENTOS","cnpj":"37145968000116","city":"BRASÍLIA","stateCode":"DF","buscaAdicional":"JVC ALIMENTOS 54506 JVC ARMAZEM 01 905821 JVC ARMAZEM 02 905822"},{"id":"010d62c9-4dfe-49d0-6203-08d5ad2bf6ba","name":"BIMBO DO BRASIL LTDA","commercialName":"","cnpj":"35402759004920","city":"BRASÍLIA","stateCode":"DF","buscaAdicional":"BIMBO DF 54504 BIMBO BRASILIA 906831"},{"id":"df1515bf-f439-4f3c-61cf-08d5ad2bf6ba","name":"VITRAL VIDROS PLANOS LTDA","commercialName":"","cnpj":"00033241000137","city":"BRASÍLIA","stateCode":"DF","buscaAdicional":"VITRAL 54434 VITRAL VIDROS PLANOS 904304 VITRAL VIDROS 908301"},{"id":"9f100ddf-528d-4744-64f4-08d5ad2bf6ba","name":"BRASAL REFRIGERANTES S/A","commercialName":"BRASAL REFRIGERANTES","cnpj":"01612795000151","city":"BRASÍLIA","stateCode":"DF","buscaAdicional":"BRASAL REFRIGERANTES 56327 BRASAL DF 905823"},{"id":"99b05368-6d31-4c05-63cd-08d5ad2bf6ba","name":"CONDOMINIO DO CONJUNTO NACIONAL BRASILIA","commercialName":"","cnpj":"00719559000176","city":"BRASÍLIA","stateCode":"DF","buscaAdicional":"CONJUNTO NACIONAL 55635 CN 466467 909434 CN ID 466469-8 909435 CN ID 466463-9 909436 CN ID 1093014-0 909437 CN ID 466474-4 909438 ID 466465-5 909453 CN ID 1650745-2 909455 CN ID 466471-X 909456"},{"id":"217e51d9-3da6-4eae-6397-08d5ad2bf6ba","name":"OTIMA COMERCIO DE ALIMENTOS S/A","commercialName":"ULTRABOX","cnpj":"13197254000193","city":"BRASÍLIA","stateCode":"DF","buscaAdicional":"BIG BOX 55477 BIG BOX - SOBRADINHO 909655 BIG BOX - PLANALTINA 909656 BIG BOX - CEILANDIA 909657 BIG BOX - POLO JK 912325"},{"id":"9fc0938e-42af-422a-68d8-08d5ad2bf6ba","name":"GLOBO COMUNICACAO E PARTICIPACOES S/A","commercialName":"GLOBOPAR, TV GLOBO, REDE GLOBO E GLOBO.COM","cnpj":"27865757002571","city":"BRASÍLIA","stateCode":"DF","buscaAdicional":"GLOBO BRASILIA 60490 EMISSORA GLOBO 911900 TORRE TELEVISAO GLOB 911978"},{"id":"f40d1c07-822c-4745-6746-08d5ad2bf6ba","name":"CONDOMINIO BRASIL 21","commercialName":"CONDOMINIO BRASIL 21","cnpj":"07839422000102","city":"BRASÍLIA","stateCode":"DF","buscaAdicional":"CONDOMINIO BRASIL 21 58024 BRASIL 21 909368"},{"id":"1f915534-8de8-47db-6743-08d5ad2bf6ba","name":"CONDOMINIO DO KUBITSCHEK PLAZA HOTEL","commercialName":"","cnpj":"26502377000132","city":"BRASÍLIA","stateCode":"DF","buscaAdicional":"KUBITSCHEK PLAZA 58020 KUBITSCHEK PLAZA 909658"},{"id":"d1349614-1f0f-42a0-6791-08d5ad2bf6ba","name":"INFRAMERICA CONCESSIONARIA DO AEROPORTO DE BRASILIA S/A","commercialName":"INFRAMERICA","cnpj":"15559082000186","city":"BRASÍLIA","stateCode":"DF","buscaAdicional":"INFRAMERICA 58311 INFRAMERICA - BRASIL 909659"},{"id":"d9d61dea-c586-4d9d-659c-08d5ad2bf6ba","name":"SUBCONDOMINIO COMERCIAL DO JK SHOPPING","commercialName":"SUBCONDOMINIO JK SHOPPING","cnpj":"19340045000133","city":"BRASÍLIA","stateCode":"DF","buscaAdicional":"JK SHOPPING 56860 SHOPPING JK BRASILIA 907939"},{"id":"9bf0b032-6ede-498d-65bd-08d5ad2bf6ba","name":"CONDOMINIO DO COMPLEXO COMERCIAL TAGUATINGA SHOPPING","commercialName":"","cnpj":"07180842000111","city":"BRASÍLIA","stateCode":"DF","buscaAdicional":"TAGUATINGA SHOPPING 57030 COND TAGUATINGA SHOP 907791"},{"id":"06ffd785-4955-4913-65b9-08d5ad2bf6ba","name":"CONDOMINIO DO CONJUNTO COMERCIAL BRASILIA SHOPPING AND TOWERS","commercialName":"","cnpj":"01627946000145","city":"BRASÍLIA","stateCode":"DF","buscaAdicional":"BRASILIA SHOPPING 57007 BRASILIA SHOPPING 908219"},{"id":"54798899-a7c9-45a6-65ba-08d5ad2bf6ba","name":"CONDOMINIO DO COMPLEXO COMERCIAL TERRACO SHOPPING","commercialName":"","cnpj":"03543443000117","city":"BRASÍLIA","stateCode":"DF","buscaAdicional":"TERRACO SHOPPING 57008 TERRACO SHOPPING 907149"},{"id":"c9b7be21-44a4-4542-6603-08d5ad2bf6ba","name":"CONDOMINIO COMPLEXO HOTELEIRO BRASILIA","commercialName":"","cnpj":"03561788000101","city":"BRASÍLIA","stateCode":"DF","buscaAdicional":"COMPLEXO 57264 COMPLEXO HOTEL FLAT 907423 COND CIVIL HOTEL ALV 907455 COND COMPLEXO HOTEL 907456"},{"id":"c6308cb7-47ee-4dc8-6687-08d5ad2bf6ba","name":"MANHATTAN HOTEIS E TURISMO LTDA","commercialName":"MANHATTAN PLAZA","cnpj":"37069853000190","city":"BRASÍLIA","stateCode":"DF","buscaAdicional":"MANHATTAN PLAZA 57633 MANHATTAN PLAZA 910150 MANHATTAN PALACE 910151"},{"id":"c3ddf5fa-4ac4-4840-1cc3-08d5b8870181","name":"CONDOMINIO DO PATIO BRASIL SHOPPING","commercialName":"","cnpj":"02262656000108","city":"BRASÍLIA","stateCode":"DF","buscaAdicional":"SHOPPING PATIO BRASIL 61272 COND SHOP 912843 COND SHOP ADM3 912844 COND SHOP ADM2 912871"},{"id":"071cbd61-4814-4b9a-7209-08d5cf600bef","name":"BANCO DO BRASIL SA","commercialName":"DIRECAO GERAL","cnpj":"00000000000191","city":"BRASÍLIA","stateCode":"DF","buscaAdicional":""},{"id":"b1fa13ac-56c1-45f6-720a-08d5cf600bef","name":"BRB BANCO DE BRASILIA SA","commercialName":"BRB","cnpj":"00000208000100","city":"BRASÍLIA","stateCode":"DF","buscaAdicional":""},{"id":"c8b1e1ab-0b40-4a89-720b-08d5cf600bef","name":"CENTRAIS ELETRICAS BRASILEIRAS SA","commercialName":"ELETROBRAS","cnpj":"00001180000126","city":"BRASÍLIA","stateCode":"DF","buscaAdicional":""},{"id":"1c3de173-4e1f-4032-720c-08d5cf600bef","name":"COMPANHIA ENERGETICA DE BRASILIA","commercialName":"CEB","cnpj":"00070698000111","city":"BRASÍLIA","stateCode":"DF","buscaAdicional":""},{"id":"bba87b87-a927-453c-7213-08d5cf600bef","name":"TELECOMUNICACOES BRASILEIRAS SA TELEBRAS","commercialName":"TELEBRAS","cnpj":"00336701000104","city":"BRASÍLIA","stateCode":"DF","buscaAdicional":""},{"id":"b1870cf1-8d29-4789-735f-08d5cf600bef","name":"BB SEGURIDADE PARTICIPACOES S.A.","commercialName":"BB SEGURIDADE","cnpj":"17344597000194","city":"BRASÍLIA","stateCode":"DF","buscaAdicional":""},{"id":"94959279-6909-4b01-7343-08d5cf600bef","name":"BIAM COMPANHIA SECURITIZADORA S/A","commercialName":"BIAM COMPANHIA SECURITIZADORA S/A","cnpj":"14333683000103","city":"BRASÍLIA","stateCode":"DF","buscaAdicional":""},{"id":"84465e64-f61f-410b-4f0a-08d5d159243d","name":"WIZ SOLUCOES E CORRETAGEM DE SEGUROS S.A","commercialName":"WIZ SOLUCOES E CORRETAGEM DE SEGUROS S.A","cnpj":"42278473000103","city":"BRASÍLIA","stateCode":"DF","buscaAdicional":""},{"id":"99b3229f-45ae-4662-4f01-08d5d159243d","name":"EQUATORIAL TRANSMISSORA 7 SPE S.A.","commercialName":"EQUATORIAL","cnpj":"26845702000160","city":"BRASÍLIA","stateCode":"DF","buscaAdicional":""},{"id":"d00080ff-182a-42af-4ef5-08d5d159243d","name":"CAIXA SEGURIDADE PARTICIPACOES S/A","commercialName":"CAIXA SEGURIDADE","cnpj":"22543331000100","city":"BRASÍLIA","stateCode":"DF","buscaAdicional":""},{"id":"f8dce224-c27b-41f1-9f7e-08d5d7870f30","name":"REGINALDO GOMES DA SILVA","commercialName":"VITAMILHO","cnpj":"08236573000120","city":"BRASÍLIA","stateCode":"DF","buscaAdicional":""},{"id":"0a202423-7c87-4ab3-8d7f-08d5d060706e","name":"SAO CRISTOVAO INVESTIMENTOS E PARTICIPACOES S/A","commercialName":"SAO CRISTOVAO INVESTIMENTOS E PARTICIPACOES","cnpj":"08492764000153","city":"BRASÍLIA","stateCode":"DF","buscaAdicional":"BIG BOX DF 58348 BIG BOX DF - PONTA 913486 BIG BOX DF - PENINSU 913487 BIG BOX DF - VIA PAR 913522"},{"id":"563abb10-b5ae-4305-60f3-08d5ad2bf6ba","name":"BONASA ALIMENTOS S/A","commercialName":"BONASA","cnpj":"03573324001774","city":"BRASÍLIA","stateCode":"DF","buscaAdicional":"BONASA DF UNAI 53917 BONASA DF UNAI 907150"},{"id":"f6f6813a-cbde-4c84-5ea3-08d5ad2bf6ba","name":"CONDOMINIO DO PARKSHOPPING","commercialName":"","cnpj":"00719294000106","city":"BRASÍLIA","stateCode":"DF","buscaAdicional":"PARKSHOPPING BRASILIA 52470 PKS EXPANSAO FRONTAL 903785 PARKSHOPPING EXP VII 907475 PARKSHOPPING LJ SATE 907476 PARKSHOPPING V CONDO 907477 PARKSHOPPING CONDOMI 907478 PARKSHOPPING FASHION 907479 PKS ADEQUACAO 907856 PKS AR CONDICIONADO 907872"},{"id":"273ca8bf-6641-495f-5ce2-08d5ad2bf6ba","name":"2008 EMPREENDIMENTOS COMERCIAIS S.A.","commercialName":"BOULEVARD SHOPPING BRASILIA","cnpj":"08711824000262","city":"BRASÍLIA","stateCode":"DF","buscaAdicional":"BOULEVARD SHOPPING BRASILIA 51600 BOULEVARD SHOP BSB 900530"},{"id":"1c62b9e5-7554-457c-5ab8-08d5ad2bf6ba","name":"IMPAR SERVICOS HOSPITALARES S/A","commercialName":"HOSPITAL BRASILIA","cnpj":"60884855002289","city":"BRASÍLIA","stateCode":"DF","buscaAdicional":"IMPAR 50199 HOSPITAL BRASILIA 888866"},{"id":"16e3684f-6cc5-48b6-5864-08d5ad2bf6ba","name":"LAF COMERCIALIZADORA DE ENERGIA LTDA","commercialName":"RENAULT ENERGIA","cnpj":"00629633000163","city":"BRASÍLIA","stateCode":"DF","buscaAdicional":"RENAULT ENERGIA 11649"},{"id":"3e890507-07f4-4417-5981-08d5ad2bf6ba","name":"COMPANHIA DE DESENVOLVIMENTO DOS VALES DO SAO FRANCISCO E DO PARNAIBA","commercialName":"CODEVASF","cnpj":"00399857000126","city":"BRASÍLIA","stateCode":"DF","buscaAdicional":"CODEVASF 14656 PISF - SAO FRANCISCO 894003"},{"id":"db6af8f7-90ab-4ed7-521a-08d5ad2bf6ba","name":"ENERGETICA CORUMBA III S.A.","commercialName":"ENERGETICA CORUMBA III S.A.","cnpj":"04631430000162","city":"BRASÍLIA","stateCode":"DF","buscaAdicional":"ECIII 2873 CORUMBA III-ECIII 8595 UHE.PH.GO.028352-5.01"},{"id":"764a147a-c7f1-4670-4eff-08d5ad2bf6ba","name":"CENTRAIS ELETRICAS DO NORTE DO BRASIL S/A ELETRONORTE","commercialName":"ELETROBRAS ELETRONORTE","cnpj":"00357038000116","city":"BRASÍLIA","stateCode":"DF","buscaAdicional":"ELETRONORTE 48 COARACY NUNES 896384 UHE.PH.AP.000783-8.01 CURUA UNA 295 UHE.PH.PA.027130-6.01 TUCURUI 282 UHE.PH.PA.002889-4.01 SAMUEL 8601 UHE.PH.RO.002687-5.01 RIO ACRE 8668 UTE.PE.AC.002277-2.01 SANTANA BLOCO I 896364 SANTANA BLOCO II 896365 EMERGENCIAL ARAGUAIA 898671 UTE.PE.MT.035090-7.01"},{"id":"e8ba2a9f-bb78-4a54-4f14-08d5ad2bf6ba","name":"CEB LAJEADO S/A","commercialName":"CEBLAJEADO","cnpj":"03677638000150","city":"BRASÍLIA","stateCode":"DF","buscaAdicional":"CEB LAJEADO 80 LAJEADO CEB 8290 UHE.PH.TO.001304-8.01"},{"id":"80a22b79-c1e1-406d-4f4c-08d5ad2bf6ba","name":"CIPLAN CIMENTO PLANALTO SA","commercialName":"CIPLAN SA","cnpj":"00057240000122","city":"BRASÍLIA","stateCode":"DF","buscaAdicional":"CIPLAN 1036 CIPLAN 7055"},{"id":"e5639b36-8c74-4af8-5050-08d5ad2bf6ba","name":"CEB PARTICIPACOES S/A CEBPAR","commercialName":"","cnpj":"03682014000120","city":"BRASÍLIA","stateCode":"DF","buscaAdicional":"CEB PAR 1569 QUEIMADO-CEB 8293 UHE.PH.MG.002176-8.01"},{"id":"23e6f0d1-d08a-42bd-5051-08d5ad2bf6ba","name":"CEB GERACAO S.A.","commercialName":"","cnpj":"04232314000170","city":"BRASÍLIA","stateCode":"DF","buscaAdicional":"CEB GERACAO 1570 BRASILIA 412 UTE.PE.DF.000312-3.01 PARANOA 8127 UHE.PH.DF.001975-5.01"},{"id":"ca12b7ff-f093-4b41-5052-08d5ad2bf6ba","name":"CEB DISTRIBUICAO S.A.","commercialName":"CEB DISTRIBUICAO S.A.","cnpj":"07522669000192","city":"BRASÍLIA","stateCode":"DF","buscaAdicional":"CEB DISTRIBUIC 1571 CEB 41"},{"id":"768e6332-ac5c-4e1a-5039-08d5ad2bf6ba","name":"CORUMBA CONCESSOES S.A.","commercialName":"","cnpj":"04066598000172","city":"BRASÍLIA","stateCode":"DF","buscaAdicional":"CORUMBA IV 1522 CORUMBA IV 8137 UHE.PH.GO.027795-9.01"},{"id":"ff346b2d-e1c0-4312-5520-08d5ad2bf6ba","name":"CONDOMINIO CIVIL DO SHOPPING CENTER IGUATEMI BRASILIA","commercialName":"","cnpj":"09301520000109","city":"BRASÍLIA","stateCode":"DF","buscaAdicional":"IGUATEMI BRASILIA 5090 IGUATEMI BRASILIA DF 909741"},{"id":"79672499-15be-4976-53d8-08d5ad2bf6ba","name":"NORTE ENERGIA S/A","commercialName":"NORTE ENERGIA","cnpj":"12300288000107","city":"BRASÍLIA","stateCode":"DF","buscaAdicional":"NESA 3879 BELO MONTE 894627 UHE.PH.PA.030354-2.01 BELO MONTE- PIMENTAL 894628 UHE.PH.PA.030354-2.01"},{"id":"122db6c8-55e5-4a25-5ccf-08d5ad2bf6ba","name":"LIOTECNICA TECNOLOGIA EM ALIMENTOS S.A.","commercialName":"","cnpj":"61297784000156","city":"EMBU DAS ARTES","stateCode":"SP","buscaAdicional":"LIOTECNICA 51576 LIOTECNICA 1 898693 LIOTECNICA 2 898694"},{"id":"37651a74-1603-43e2-606f-08d5ad2bf6ba","name":"IBEMA COMPANHIA BRASILEIRA DE PAPEL","commercialName":"","cnpj":"80228885001191","city":"EMBU DAS ARTES","stateCode":"SP","buscaAdicional":"IBEMA EMBU 53510 IBEMA EMBU 901534"},{"id":"e392f158-2d92-4ff4-740a-08d5cf600bef","name":"MAESTRO LOCADORA DE VEICULOS S.A.","commercialName":"MAESTRO TERCEIRIZACAO DE FROTAS","cnpj":"08795211000170","city":"EMBU DAS ARTES","stateCode":"SP","buscaAdicional":""},{"id":"079021f1-7768-48cd-6666-08d5ad2bf6ba","name":"''GERRESHEIMER PLASTICOS SAO PAULO LTDA.''","commercialName":"","cnpj":"04797661000140","city":"EMBU DAS ARTES","stateCode":"SP","buscaAdicional":"GERRESHEIMER GPP 57529 GERRESHEIMER GPP BUT 908535 GERRESHEIMER GPP EMB 908553 GERRESHEIMER GPP 912861"},{"id":"4c155405-f8e9-49fb-618c-08d5ad2bf6ba","name":"TOTAL QUIMICA LIMITADA","commercialName":"","cnpj":"68418433000103","city":"EMBU DAS ARTES","stateCode":"SP","buscaAdicional":"TOTAL QUIMICA 54231 TOTAL QUIMICA 01 905531"}];/* harmony default export */ __webpack_exports__["a"] = (companies);

/***/ }),
/* 654 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;// Diacritics.js
// 
// Started as something to be an equivalent of the Google Java Library diacritics library for JavaScript.
// Found this: http://jsperf.com/diacritics/6 and converted it into a reusable module.
// 
// @author Nijiko Yonskai
// @license MIT
// @copyright Nijikokun 2013 <nijikokun@gmail.com>
(function (name, definition) {
  if (typeof module != 'undefined' && module.exports) module.exports = definition()
  else if (true) !(__WEBPACK_AMD_DEFINE_FACTORY__ = (definition),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
  else this[name] = definition()
})('Diacritics', function () {
  // Create public object
  var output = {
    map: {}
  };

  // Create private reference map.
  var reference = [
    {'base':' ',    'letters':'\u00A0'},
    {'base':'A',    'letters':'\u0041\u24B6\uFF21\u00C0\u00C1\u00C2\u1EA6\u1EA4\u1EAA\u1EA8\u00C3\u0100\u0102\u1EB0\u1EAE\u1EB4\u1EB2\u0226\u01E0\u00C4\u01DE\u1EA2\u00C5\u01FA\u01CD\u0200\u0202\u1EA0\u1EAC\u1EB6\u1E00\u0104\u023A\u2C6F'},
    {'base':'AA',   'letters':'\uA732'},
    {'base':'AE',   'letters':'\u00C6\u01FC\u01E2'},
    {'base':'AO',   'letters':'\uA734'},
    {'base':'AU',   'letters':'\uA736'},
    {'base':'AV',   'letters':'\uA738\uA73A'},
    {'base':'AY',   'letters':'\uA73C'},
    {'base':'B',    'letters':'\u0042\u24B7\uFF22\u1E02\u1E04\u1E06\u0243\u0182\u0181'},
    {'base':'C',    'letters':'\u0043\u24B8\uFF23\u0106\u0108\u010A\u010C\u00C7\u1E08\u0187\u023B\uA73E'},
    {'base':'D',    'letters':'\u0044\u24B9\uFF24\u1E0A\u010E\u1E0C\u1E10\u1E12\u1E0E\u0110\u018B\u018A\u0189\uA779'},
    {'base':'DZ',   'letters':'\u01F1\u01C4'},
    {'base':'Dz',   'letters':'\u01F2\u01C5'},
    {'base':'E',    'letters':'\u0045\u24BA\uFF25\u00C8\u00C9\u00CA\u1EC0\u1EBE\u1EC4\u1EC2\u1EBC\u0112\u1E14\u1E16\u0114\u0116\u00CB\u1EBA\u011A\u0204\u0206\u1EB8\u1EC6\u0228\u1E1C\u0118\u1E18\u1E1A\u0190\u018E'},
    {'base':'F',    'letters':'\u0046\u24BB\uFF26\u1E1E\u0191\uA77B'},
    {'base':'G',    'letters':'\u0047\u24BC\uFF27\u01F4\u011C\u1E20\u011E\u0120\u01E6\u0122\u01E4\u0193\uA7A0\uA77D\uA77E'},
    {'base':'H',    'letters':'\u0048\u24BD\uFF28\u0124\u1E22\u1E26\u021E\u1E24\u1E28\u1E2A\u0126\u2C67\u2C75\uA78D'},
    {'base':'I',    'letters':'\u0049\u24BE\uFF29\u00CC\u00CD\u00CE\u0128\u012A\u012C\u0130\u00CF\u1E2E\u1EC8\u01CF\u0208\u020A\u1ECA\u012E\u1E2C\u0197'},
    {'base':'J',    'letters':'\u004A\u24BF\uFF2A\u0134\u0248'},
    {'base':'K',    'letters':'\u004B\u24C0\uFF2B\u1E30\u01E8\u1E32\u0136\u1E34\u0198\u2C69\uA740\uA742\uA744\uA7A2'},
    {'base':'L',    'letters':'\u004C\u24C1\uFF2C\u013F\u0139\u013D\u1E36\u1E38\u013B\u1E3C\u1E3A\u0141\u023D\u2C62\u2C60\uA748\uA746\uA780'},
    {'base':'LJ',   'letters':'\u01C7'},
    {'base':'Lj',   'letters':'\u01C8'},
    {'base':'M',    'letters':'\u004D\u24C2\uFF2D\u1E3E\u1E40\u1E42\u2C6E\u019C'},
    {'base':'N',    'letters':'\u004E\u24C3\uFF2E\u01F8\u0143\u00D1\u1E44\u0147\u1E46\u0145\u1E4A\u1E48\u0220\u019D\uA790\uA7A4'},
    {'base':'NJ',   'letters':'\u01CA'},
    {'base':'Nj',   'letters':'\u01CB'},
    {'base':'O',    'letters':'\u004F\u24C4\uFF2F\u00D2\u00D3\u00D4\u1ED2\u1ED0\u1ED6\u1ED4\u00D5\u1E4C\u022C\u1E4E\u014C\u1E50\u1E52\u014E\u022E\u0230\u00D6\u022A\u1ECE\u0150\u01D1\u020C\u020E\u01A0\u1EDC\u1EDA\u1EE0\u1EDE\u1EE2\u1ECC\u1ED8\u01EA\u01EC\u00D8\u01FE\u0186\u019F\uA74A\uA74C'},
    {'base':'OI',   'letters':'\u01A2'},
    {'base':'OO',   'letters':'\uA74E'},
    {'base':'OU',   'letters':'\u0222'},
    {'base':'P',    'letters':'\u0050\u24C5\uFF30\u1E54\u1E56\u01A4\u2C63\uA750\uA752\uA754'},
    {'base':'Q',    'letters':'\u0051\u24C6\uFF31\uA756\uA758\u024A'},
    {'base':'R',    'letters':'\u0052\u24C7\uFF32\u0154\u1E58\u0158\u0210\u0212\u1E5A\u1E5C\u0156\u1E5E\u024C\u2C64\uA75A\uA7A6\uA782'},
    {'base':'S',    'letters':'\u0053\u24C8\uFF33\u1E9E\u015A\u1E64\u015C\u1E60\u0160\u1E66\u1E62\u1E68\u0218\u015E\u2C7E\uA7A8\uA784'},
    {'base':'T',    'letters':'\u0054\u24C9\uFF34\u1E6A\u0164\u1E6C\u021A\u0162\u1E70\u1E6E\u0166\u01AC\u01AE\u023E\uA786'},
    {'base':'Th',   'letters':'\u00DE'},
    {'base':'TZ',   'letters':'\uA728'},
    {'base':'U',    'letters':'\u0055\u24CA\uFF35\u00D9\u00DA\u00DB\u0168\u1E78\u016A\u1E7A\u016C\u00DC\u01DB\u01D7\u01D5\u01D9\u1EE6\u016E\u0170\u01D3\u0214\u0216\u01AF\u1EEA\u1EE8\u1EEE\u1EEC\u1EF0\u1EE4\u1E72\u0172\u1E76\u1E74\u0244'},
    {'base':'V',    'letters':'\u0056\u24CB\uFF36\u1E7C\u1E7E\u01B2\uA75E\u0245'},
    {'base':'VY',   'letters':'\uA760'},
    {'base':'W',    'letters':'\u0057\u24CC\uFF37\u1E80\u1E82\u0174\u1E86\u1E84\u1E88\u2C72'},
    {'base':'X',    'letters':'\u0058\u24CD\uFF38\u1E8A\u1E8C'},
    {'base':'Y',    'letters':'\u0059\u24CE\uFF39\u1EF2\u00DD\u0176\u1EF8\u0232\u1E8E\u0178\u1EF6\u1EF4\u01B3\u024E\u1EFE'},
    {'base':'Z',    'letters':'\u005A\u24CF\uFF3A\u0179\u1E90\u017B\u017D\u1E92\u1E94\u01B5\u0224\u2C7F\u2C6B\uA762'},
    {'base':'a',    'letters':'\u0061\u24D0\uFF41\u1E9A\u00E0\u00E1\u00E2\u1EA7\u1EA5\u1EAB\u1EA9\u00E3\u0101\u0103\u1EB1\u1EAF\u1EB5\u1EB3\u0227\u01E1\u00E4\u01DF\u1EA3\u00E5\u01FB\u01CE\u0201\u0203\u1EA1\u1EAD\u1EB7\u1E01\u0105\u2C65\u0250\u0251'},
    {'base':'aa',   'letters':'\uA733'},
    {'base':'ae',   'letters':'\u00E6\u01FD\u01E3'},
    {'base':'ao',   'letters':'\uA735'},
    {'base':'au',   'letters':'\uA737'},
    {'base':'av',   'letters':'\uA739\uA73B'},
    {'base':'ay',   'letters':'\uA73D'},
    {'base':'b',    'letters':'\u0062\u24D1\uFF42\u1E03\u1E05\u1E07\u0180\u0183\u0253'},
    {'base':'c',    'letters':'\u0063\u24D2\uFF43\u0107\u0109\u010B\u010D\u00E7\u1E09\u0188\u023C\uA73F\u2184'},
    {'base':'d',    'letters':'\u0064\u24D3\uFF44\u1E0B\u010F\u1E0D\u1E11\u1E13\u1E0F\u0111\u018C\u0256\u0257\uA77A'},
    {'base':'dz',   'letters':'\u01F3\u01C6'},
    {'base':'e',    'letters':'\u0065\u24D4\uFF45\u00E8\u00E9\u00EA\u1EC1\u1EBF\u1EC5\u1EC3\u1EBD\u0113\u1E15\u1E17\u0115\u0117\u00EB\u1EBB\u011B\u0205\u0207\u1EB9\u1EC7\u0229\u1E1D\u0119\u1E19\u1E1B\u0247\u025B\u01DD'},
    {'base':'f',    'letters':'\u0066\u24D5\uFF46\u1E1F\u0192\uA77C'},
    {'base':'ff',   'letters':'\uFB00'},
    {'base':'fi',   'letters':'\uFB01'},
    {'base':'fl',   'letters':'\uFB02'},
    {'base':'ffi',  'letters':'\uFB03'},
    {'base':'ffl',  'letters':'\uFB04'},
    {'base':'g',    'letters':'\u0067\u24D6\uFF47\u01F5\u011D\u1E21\u011F\u0121\u01E7\u0123\u01E5\u0260\uA7A1\u1D79\uA77F'},
    {'base':'h',    'letters':'\u0068\u24D7\uFF48\u0125\u1E23\u1E27\u021F\u1E25\u1E29\u1E2B\u1E96\u0127\u2C68\u2C76\u0265'},
    {'base':'hv',   'letters':'\u0195'},
    {'base':'i',    'letters':'\u0069\u24D8\uFF49\u00EC\u00ED\u00EE\u0129\u012B\u012D\u00EF\u1E2F\u1EC9\u01D0\u0209\u020B\u1ECB\u012F\u1E2D\u0268\u0131'},
    {'base':'j',    'letters':'\u006A\u24D9\uFF4A\u0135\u01F0\u0249'},
    {'base':'k',    'letters':'\u006B\u24DA\uFF4B\u1E31\u01E9\u1E33\u0137\u1E35\u0199\u2C6A\uA741\uA743\uA745\uA7A3'},
    {'base':'l',    'letters':'\u006C\u24DB\uFF4C\u0140\u013A\u013E\u1E37\u1E39\u013C\u1E3D\u1E3B\u017F\u0142\u019A\u026B\u2C61\uA749\uA781\uA747'},
    {'base':'lj',   'letters':'\u01C9'},
    {'base':'m',    'letters':'\u006D\u24DC\uFF4D\u1E3F\u1E41\u1E43\u0271\u026F'},
    {'base':'n',    'letters':'\x6E\xF1\u006E\u24DD\uFF4E\u01F9\u0144\u00F1\u1E45\u0148\u1E47\u0146\u1E4B\u1E49\u019E\u0272\u0149\uA791\uA7A5\u043B\u0509'},
    {'base':'nj',   'letters':'\u01CC'},
    {'base':'o',    'letters':'\u07C0\u006F\u24DE\uFF4F\u00F2\u00F3\u00F4\u1ED3\u1ED1\u1ED7\u1ED5\u00F5\u1E4D\u022D\u1E4F\u014D\u1E51\u1E53\u014F\u022F\u0231\u00F6\u022B\u1ECF\u0151\u01D2\u020D\u020F\u01A1\u1EDD\u1EDB\u1EE1\u1EDF\u1EE3\u1ECD\u1ED9\u01EB\u01ED\u00F8\u01FF\u0254\uA74B\uA74D\u0275'},
    {'base':'oe',   'letters':'\u0152\u0153'},
    {'base':'oi',   'letters':'\u01A3'},
    {'base':'ou',   'letters':'\u0223'},
    {'base':'oo',   'letters':'\uA74F'},
    {'base':'p',    'letters':'\u0070\u24DF\uFF50\u1E55\u1E57\u01A5\u1D7D\uA751\uA753\uA755'},
    {'base':'q',    'letters':'\u0071\u24E0\uFF51\u024B\uA757\uA759'},
    {'base':'r',    'letters':'\u0072\u24E1\uFF52\u0155\u1E59\u0159\u0211\u0213\u1E5B\u1E5D\u0157\u1E5F\u024D\u027D\uA75B\uA7A7\uA783'},
    {'base':'s',    'letters':'\u0073\u24E2\uFF53\u00DF\u015B\u1E65\u015D\u1E61\u0161\u1E67\u1E63\u1E69\u0219\u015F\u023F\uA7A9\uA785\u1E9B'},
    {'base':'ss',   'letters':'\xDF'},
    {'base':'t',    'letters':'\u0074\u24E3\uFF54\u1E6B\u1E97\u0165\u1E6D\u021B\u0163\u1E71\u1E6F\u0167\u01AD\u0288\u2C66\uA787'},
    {'base':'th',   'letters':'\u00FE'},
    {'base':'tz',   'letters':'\uA729'},
    {'base':'u',    'letters': '\u0075\u24E4\uFF55\u00F9\u00FA\u00FB\u0169\u1E79\u016B\u1E7B\u016D\u00FC\u01DC\u01D8\u01D6\u01DA\u1EE7\u016F\u0171\u01D4\u0215\u0217\u01B0\u1EEB\u1EE9\u1EEF\u1EED\u1EF1\u1EE5\u1E73\u0173\u1E77\u1E75\u0289'},
    {'base':'v',    'letters':'\u0076\u24E5\uFF56\u1E7D\u1E7F\u028B\uA75F\u028C'},
    {'base':'vy',   'letters':'\uA761'},
    {'base':'w',    'letters':'\u0077\u24E6\uFF57\u1E81\u1E83\u0175\u1E87\u1E85\u1E98\u1E89\u2C73'},
    {'base':'x',    'letters':'\u0078\u24E7\uFF58\u1E8B\u1E8D'},
    {'base':'y',    'letters':'\u0079\u24E8\uFF59\u1EF3\u00FD\u0177\u1EF9\u0233\u1E8F\u00FF\u1EF7\u1E99\u1EF5\u01B4\u024F\u1EFF'},
    {'base':'z',    'letters':'\u007A\u24E9\uFF5A\u017A\u1E91\u017C\u017E\u1E93\u1E95\u01B6\u0225\u0240\u2C6C\uA763'}
  ];

  // Generate reference mapping
  for (var i = 0, refLength = reference.length; i < refLength; i++){
    var letters = reference[i].letters.split("");

    for (var j = 0, letLength = letters.length; j < letLength; j++){
      output.map[letters[j]] = reference[i].base;
    }
  }

  /**
   * Clean accents (diacritics) from string.
   * 
   * @param  {String} input String to be cleaned of diacritics.
   * @return {String}
   */
  output.clean = function (input) {
    if (!input || !input.length || input.length < 1) {
      return "";
    }

    var string = "";
    var letters = input.split("");
    var index = 0;
    var length = letters.length;
    var letter;

    for (; index < length; index++) {
      letter = letters[index];
      string += letter in output.map ? output.map[letter] : letter;
    }

    return string;
  };

  return output;
});

/***/ }),
/* 655 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(2);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(6));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(7));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(4));

var _objectSpread2 = _interopRequireDefault(__webpack_require__(17));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _classnames = _interopRequireDefault(__webpack_require__(5));

var _withStyles = _interopRequireDefault(__webpack_require__(3));

var _ListItem = _interopRequireDefault(__webpack_require__(288));

// @inheritedComponent ListItem
var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: (0, _objectSpread2.default)({}, theme.typography.subheading, {
      height: 24,
      boxSizing: 'content-box',
      width: 'auto',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
      paddingLeft: 16,
      paddingRight: 16,
      '&$selected': {
        backgroundColor: theme.palette.action.selected
      }
    }),

    /* Styles applied to the root element if `selected={true}`. */
    selected: {}
  };
};

exports.styles = styles;

function MenuItem(props) {
  var classes = props.classes,
      className = props.className,
      component = props.component,
      selected = props.selected,
      role = props.role,
      other = (0, _objectWithoutProperties2.default)(props, ["classes", "className", "component", "selected", "role"]);
  return _react.default.createElement(_ListItem.default, (0, _extends2.default)({
    button: true,
    role: role,
    tabIndex: -1,
    className: (0, _classnames.default)(classes.root, (0, _defineProperty2.default)({}, classes.selected, selected), className),
    component: component
  }, other));
}

MenuItem.propTypes =  false ? {
  /**
   * Menu item contents.
   */
  children: _propTypes.default.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * The component used for the root node.
   * Either a string to use a DOM element or a component.
   */
  component: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func, _propTypes.default.object]),

  /**
   * @ignore
   */
  role: _propTypes.default.string,

  /**
   * Use to apply selected styling.
   */
  selected: _propTypes.default.bool
} : {};
MenuItem.defaultProps = {
  component: 'li',
  role: 'menuitem',
  selected: false
};

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiMenuItem'
})(MenuItem);

exports.default = _default;

/***/ }),
/* 656 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(2);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(6));

var _objectSpread2 = _interopRequireDefault(__webpack_require__(17));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(7));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(4));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(11));

var _createClass2 = _interopRequireDefault(__webpack_require__(12));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(13));

var _inherits2 = _interopRequireDefault(__webpack_require__(14));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _classnames = _interopRequireDefault(__webpack_require__(5));

var _withStyles = _interopRequireDefault(__webpack_require__(3));

var _ButtonBase = _interopRequireDefault(__webpack_require__(124));

var _reactHelpers = __webpack_require__(184);

var styles = function styles(theme) {
  return {
    /* Styles applied to the (normally root) `component` element. May be wrapped by a `container`. */
    root: {
      display: 'flex',
      justifyContent: 'flex-start',
      alignItems: 'center',
      position: 'relative',
      textDecoration: 'none',
      width: '100%',
      boxSizing: 'border-box',
      textAlign: 'left',
      paddingTop: 12,
      paddingBottom: 12
    },

    /* Styles applied to the `container` element if `children` includes `ListItemSecondaryAction`. */
    container: {
      position: 'relative'
    },
    // TODO: Sanity check this - why is focusVisibleClassName prop apparently applied to a div?

    /* Styles applied to the `component`'s `focusVisibleClassName` property if `button={true}`. */
    focusVisible: {
      backgroundColor: theme.palette.action.hover
    },

    /* Legacy styles applied to the root element. Use `root` instead. */
    default: {},

    /* Styles applied to the `component` element if `dense={true}` or `children` includes `Avatar`. */
    dense: {
      paddingTop: 8,
      paddingBottom: 8
    },

    /* Styles applied to the inner `component` element if `disabled={true}`. */
    disabled: {
      opacity: 0.5
    },

    /* Styles applied to the inner `component` element if `divider={true}`. */
    divider: {
      borderBottom: "1px solid ".concat(theme.palette.divider),
      backgroundClip: 'padding-box'
    },

    /* Styles applied to the inner `component` element if `disableGutters={false}`. */
    gutters: theme.mixins.gutters(),

    /* Styles applied to the inner `component` element if `button={true}`. */
    button: {
      transition: theme.transitions.create('background-color', {
        duration: theme.transitions.duration.shortest
      }),
      '&:hover': {
        textDecoration: 'none',
        backgroundColor: theme.palette.action.hover,
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
          backgroundColor: 'transparent'
        }
      }
    },

    /* Styles applied to the `component` element if `children` includes `ListItemSecondaryAction`. */
    secondaryAction: {
      // Add some space to avoid collision as `ListItemSecondaryAction`
      // is absolutely positionned.
      paddingRight: 32
    }
  };
};

exports.styles = styles;

var ListItem =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(ListItem, _React$Component);

  function ListItem() {
    (0, _classCallCheck2.default)(this, ListItem);
    return (0, _possibleConstructorReturn2.default)(this, (ListItem.__proto__ || Object.getPrototypeOf(ListItem)).apply(this, arguments));
  }

  (0, _createClass2.default)(ListItem, [{
    key: "getChildContext",
    value: function getChildContext() {
      return {
        dense: this.props.dense || this.context.dense || false
      };
    }
  }, {
    key: "render",
    value: function render() {
      var _classNames;

      var _props = this.props,
          button = _props.button,
          childrenProp = _props.children,
          classes = _props.classes,
          classNameProp = _props.className,
          componentProp = _props.component,
          ContainerComponent = _props.ContainerComponent,
          _props$ContainerProps = _props.ContainerProps;
      _props$ContainerProps = _props$ContainerProps === void 0 ? {} : _props$ContainerProps;
      var ContainerClassName = _props$ContainerProps.className,
          ContainerProps = (0, _objectWithoutProperties2.default)(_props$ContainerProps, ["className"]),
          dense = _props.dense,
          disabled = _props.disabled,
          disableGutters = _props.disableGutters,
          divider = _props.divider,
          focusVisibleClassName = _props.focusVisibleClassName,
          other = (0, _objectWithoutProperties2.default)(_props, ["button", "children", "classes", "className", "component", "ContainerComponent", "ContainerProps", "dense", "disabled", "disableGutters", "divider", "focusVisibleClassName"]);
      var isDense = dense || this.context.dense || false;

      var children = _react.default.Children.toArray(childrenProp);

      var hasAvatar = children.some(function (value) {
        return (0, _reactHelpers.isMuiElement)(value, ['ListItemAvatar']);
      });
      var hasSecondaryAction = children.length && (0, _reactHelpers.isMuiElement)(children[children.length - 1], ['ListItemSecondaryAction']);
      var className = (0, _classnames.default)(classes.root, classes.default, (_classNames = {}, (0, _defineProperty2.default)(_classNames, classes.dense, isDense || hasAvatar), (0, _defineProperty2.default)(_classNames, classes.gutters, !disableGutters), (0, _defineProperty2.default)(_classNames, classes.divider, divider), (0, _defineProperty2.default)(_classNames, classes.disabled, disabled), (0, _defineProperty2.default)(_classNames, classes.button, button), (0, _defineProperty2.default)(_classNames, classes.secondaryAction, hasSecondaryAction), _classNames), classNameProp);
      var componentProps = (0, _objectSpread2.default)({
        className: className,
        disabled: disabled
      }, other);
      var Component = componentProp || 'li';

      if (button) {
        componentProps.component = componentProp || 'div';
        componentProps.focusVisibleClassName = (0, _classnames.default)(classes.focusVisible, focusVisibleClassName);
        Component = _ButtonBase.default;
      }

      if (hasSecondaryAction) {
        // Use div by default.
        Component = !componentProps.component && !componentProp ? 'div' : Component; // Avoid nesting of li > li.

        if (ContainerComponent === 'li') {
          if (Component === 'li') {
            Component = 'div';
          } else if (componentProps.component === 'li') {
            componentProps.component = 'div';
          }
        }

        return _react.default.createElement(ContainerComponent, (0, _extends2.default)({
          className: (0, _classnames.default)(classes.container, ContainerClassName)
        }, ContainerProps), _react.default.createElement(Component, componentProps, children), children.pop());
      }

      return _react.default.createElement(Component, componentProps, children);
    }
  }]);
  return ListItem;
}(_react.default.Component);

ListItem.propTypes =  false ? {
  /**
   * If `true`, the list item will be a button (using `ButtonBase`).
   */
  button: _propTypes.default.bool,

  /**
   * The content of the component.
   */
  children: _propTypes.default.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * The component used for the root node.
   * Either a string to use a DOM element or a component.
   * By default, it's a `li` when `button` is `false` and a `div` when `button` is `true`.
   */
  component: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func, _propTypes.default.object]),

  /**
   * The container component used when a `ListItemSecondaryAction` is rendered.
   */
  ContainerComponent: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func, _propTypes.default.object]),

  /**
   * Properties applied to the container element when the component
   * is used to display a `ListItemSecondaryAction`.
   */
  ContainerProps: _propTypes.default.object,

  /**
   * If `true`, compact vertical padding designed for keyboard and mouse input will be used.
   */
  dense: _propTypes.default.bool,

  /**
   * If `true`, the list item will be disabled.
   */
  disabled: _propTypes.default.bool,

  /**
   * If `true`, the left and right padding is removed.
   */
  disableGutters: _propTypes.default.bool,

  /**
   * If `true`, a 1px light border is added to the bottom of the list item.
   */
  divider: _propTypes.default.bool,

  /**
   * @ignore
   */
  focusVisibleClassName: _propTypes.default.string
} : {};
ListItem.defaultProps = {
  button: false,
  ContainerComponent: 'li',
  dense: false,
  disabled: false,
  disableGutters: false,
  divider: false
};
ListItem.contextTypes = {
  dense: _propTypes.default.bool
};
ListItem.childContextTypes = {
  dense: _propTypes.default.bool
};

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiListItem'
})(ListItem);

exports.default = _default;

/***/ }),
/* 657 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_icons_Timeline__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_icons_Timeline___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__material_ui_icons_Timeline__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles_withStyles__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__BreakEvenChart_jsx__ = __webpack_require__(658);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_Checkbox__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_Checkbox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Checkbox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_EnergyCompany_Cards_ECCard_jsx__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_FormControl__ = __webpack_require__(182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_FormControl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_FormControl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_core_FormControlLabel__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_core_FormControlLabel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_FormControlLabel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_Grid_GridContainer_jsx__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__material_ui_core_InputLabel__ = __webpack_require__(185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__material_ui_core_InputLabel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__material_ui_core_InputLabel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_components_Grid_GridItem_jsx__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__material_ui_core_MenuItem__ = __webpack_require__(135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__material_ui_core_MenuItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__material_ui_core_MenuItem__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__material_ui_core_Select__ = __webpack_require__(277);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__material_ui_core_Select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__material_ui_core_Select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_services_companies__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_assets_jss_material_dashboard_pro_react_views_extendedFormsStyle_jsx__ = __webpack_require__(704);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var styles=function styles(theme){return Object.assign({},__WEBPACK_IMPORTED_MODULE_16_assets_jss_material_dashboard_pro_react_views_extendedFormsStyle_jsx__["a" /* default */],{chartsWrapper:_defineProperty({display:"grid",gridTemplateColumns:"48% 48%",gridColumnGap:"25px",gridRowGap:"25px"},theme.breakpoints.down("sm"),{gridTemplateColumns:"100%"}),checkbox:{'& svg':{margin:0}},inputsWrapper:{display:"grid",gridTemplateColumns:"1fr 1fr",gridColumnGap:"25px"}});};var BreakEven=function(_Component){_inherits(BreakEven,_Component);function BreakEven(props){_classCallCheck(this,BreakEven);var _this=_possibleConstructorReturn(this,(BreakEven.__proto__||Object.getPrototypeOf(BreakEven)).call(this,props));_this.handleSelectDistribuidora=function(event){_this.setState({distribuidoraSelect:event.target.value});_this.getBreakEvenHandler(event.target.value);};_this.state={distribuidoraSelect:props.distribuidoraSugeridaId,energiaIncentivadaSelecionada:true,precosPorAno:null,precosPorAnoI50:null};return _this;}_createClass(BreakEven,[{key:"componentDidMount",value:function componentDidMount(){this.getBreakEvenHandler(this.props.distribuidoraSugeridaId);}},{key:"componentDidUpdate",value:function componentDidUpdate(prevProps){if(!Object(__WEBPACK_IMPORTED_MODULE_4_lodash__["isEqual"])(prevProps.distribuidoraSugeridaId,this.props.distribuidoraSugeridaId)){this.setState({distribuidoraSelect:this.props.distribuidoraSugeridaId});this.getBreakEvenHandler(this.props.distribuidoraSugeridaId);}}},{key:"getBreakEvenHandler",value:function getBreakEvenHandler(id){var _this2=this;Object(__WEBPACK_IMPORTED_MODULE_15_services_companies__["c" /* getBreakEven */])(id,this.props.companyId).then(function(_ref){var data=_ref.data;_this2.setState({precosPorAno:data.precosPorAno,precosPorAnoI50:data.precosPorAnoI50});});}},{key:"render",value:function render(){var _this3=this;var _props=this.props,agentesDistribuidores=_props.agentesDistribuidores,classes=_props.classes;var _state=this.state,precosPorAno=_state.precosPorAno,precosPorAnoI50=_state.precosPorAnoI50,energiaIncentivadaSelecionada=_state.energiaIncentivadaSelecionada;var precosSelecionado=energiaIncentivadaSelecionada?precosPorAnoI50:precosPorAno;if(!precosSelecionado)return null;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_Grid_GridContainer_jsx__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_components_Grid_GridItem_jsx__["a" /* default */],{md:12,sm:12,xs:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_EnergyCompany_Cards_ECCard_jsx__["a" /* default */],{actions:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_FormControlLabel___default.a,{control:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Checkbox___default.a,{checked:energiaIncentivadaSelecionada,className:classes.checkbox,onChange:function onChange(e){return _this3.setState({energiaIncentivadaSelecionada:e.target.checked});}}),label:"Incentivada 50%"}),content:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:classes.inputsWrapper},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_FormControl___default.a,{className:classes.selectFormControl,fullWidth:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core_InputLabel___default.a,{className:classes.selectLabel,htmlFor:"distribuidora-select"},"Distribuidora"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__material_ui_core_Select___default.a,{classes:{select:classes.select},inputProps:{id:"distribuidora-select"},MenuProps:{className:classes.selectMenu},onChange:this.handleSelectDistribuidora,value:this.state.distribuidoraSelect},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core_MenuItem___default.a,{classes:{root:classes.selectMenuItem},disabled:true},"Distribuidora"),Object(__WEBPACK_IMPORTED_MODULE_4_lodash__["map"])(Object(__WEBPACK_IMPORTED_MODULE_4_lodash__["sortBy"])(agentesDistribuidores,["nome"]),function(distribuidora){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core_MenuItem___default.a,{classes:{root:classes.selectMenuItem,selected:classes.selectMenuItemSelected},key:distribuidora.id,value:distribuidora.id},distribuidora.nome);})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:classes.chartsWrapper},Object(__WEBPACK_IMPORTED_MODULE_4_lodash__["map"])(precosSelecionado,function(value,key){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__BreakEvenChart_jsx__["a" /* default */],{ano:key,data:value,key:key});}))),icon:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_icons_Timeline___default.a,null),title:"Break Even"})));}}]);return BreakEven;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);;BreakEven.propTypes={agentesDistribuidores:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({id:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,nome:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired})).isRequired,classes:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,companyId:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,distribuidoraSugeridaId:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired};/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles_withStyles___default()(styles)(BreakEven));

/***/ }),
/* 658 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_chart_js__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_chart_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_chart_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_services_utils__ = __webpack_require__(23);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var BreakEvenChart=function(_Component){_inherits(BreakEvenChart,_Component);function BreakEvenChart(){_classCallCheck(this,BreakEvenChart);return _possibleConstructorReturn(this,(BreakEvenChart.__proto__||Object.getPrototypeOf(BreakEvenChart)).apply(this,arguments));}_createClass(BreakEvenChart,[{key:"componentDidMount",value:function componentDidMount(){this.handleChart();}},{key:"componentDidUpdate",value:function componentDidUpdate(prevProps){if(!Object(__WEBPACK_IMPORTED_MODULE_3_lodash__["isEqual"])(prevProps.data,this.props.data)){this.handleChart();}}},{key:"handleChart",value:function handleChart(){var _props=this.props,ano=_props.ano,data=_props.data;var ctx="chart-break-even-"+ano;var labels=['A4 - Azul','A4 - Verde','A3','A2'];if(this.chart){this.chart.destroy();}this.chart=new __WEBPACK_IMPORTED_MODULE_0_chart_js___default.a(ctx,{type:'bar',data:{labels:labels,datasets:[{backgroundColor:'rgb(22, 186, 207)',borderColor:'rgb(22, 186, 207)',borderWidth:1,label:'Break Even',stack:'Stack 1',data:Object(__WEBPACK_IMPORTED_MODULE_3_lodash__["map"])(labels,function(label){return Object(__WEBPACK_IMPORTED_MODULE_3_lodash__["get"])(Object(__WEBPACK_IMPORTED_MODULE_3_lodash__["find"])(data,['subgrupo',label]),'simuladorEconomia');})},{backgroundColor:'rgba(54, 162, 235, 0.4)',borderColor:'rgba(54, 162, 235, 1)',borderWidth:1,label:'Preço de Mercado',stack:'Stack 2',data:Object(__WEBPACK_IMPORTED_MODULE_3_lodash__["map"])(labels,function(label){return Object(__WEBPACK_IMPORTED_MODULE_3_lodash__["get"])(Object(__WEBPACK_IMPORTED_MODULE_3_lodash__["find"])(data,['subgrupo',label]),'curvaForwardBBCE');})}]},options:{scales:{yAxes:[{ticks:{beginAtZero:true,callback:function callback(value){return Object(__WEBPACK_IMPORTED_MODULE_4_services_utils__["g" /* numberToBRL */])(value)+"/MWh";}}}]},title:{display:true,text:ano},tooltips:{callbacks:{label:function label(tooltipItem){return Object(__WEBPACK_IMPORTED_MODULE_4_services_utils__["g" /* numberToBRL */])(tooltipItem.yLabel)+"/MWh";}},intersect:false,mode:'index'}}});}},{key:"render",value:function render(){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("canvas",{id:"chart-break-even-"+this.props.ano}));}}]);return BreakEvenChart;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);;BreakEvenChart.propTypes={ano:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired,data:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({curvaForwardBBCE:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number.isRequired,precoMedioDistribuidora:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number.isRequired,pld:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number.isRequired,simuladorEconomia:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number.isRequired,subgrupo:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired})).isRequired};/* harmony default export */ __webpack_exports__["a"] = (BreakEvenChart);

/***/ }),
/* 659 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var defaults = __webpack_require__(20);

defaults._set('global', {
	responsive: true,
	responsiveAnimationDuration: 0,
	maintainAspectRatio: true,
	events: ['mousemove', 'mouseout', 'click', 'touchstart', 'touchmove'],
	hover: {
		onHover: null,
		mode: 'nearest',
		intersect: true,
		animationDuration: 400
	},
	onClick: null,
	defaultColor: 'rgba(0,0,0,0.1)',
	defaultFontColor: '#666',
	defaultFontFamily: "'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
	defaultFontSize: 12,
	defaultFontStyle: 'normal',
	showLines: true,

	// Element defaults defined in element extensions
	elements: {},

	// Layout options such as padding
	layout: {
		padding: {
			top: 0,
			right: 0,
			bottom: 0,
			left: 0
		}
	}
});

module.exports = function() {

	// Occupy the global variable of Chart, and create a simple base class
	var Chart = function(item, config) {
		this.construct(item, config);
		return this;
	};

	Chart.Chart = Chart;

	return Chart;
};


/***/ }),
/* 660 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var helpers = __webpack_require__(136);

/**
 * Easing functions adapted from Robert Penner's easing equations.
 * @namespace Chart.helpers.easingEffects
 * @see http://www.robertpenner.com/easing/
 */
var effects = {
	linear: function(t) {
		return t;
	},

	easeInQuad: function(t) {
		return t * t;
	},

	easeOutQuad: function(t) {
		return -t * (t - 2);
	},

	easeInOutQuad: function(t) {
		if ((t /= 0.5) < 1) {
			return 0.5 * t * t;
		}
		return -0.5 * ((--t) * (t - 2) - 1);
	},

	easeInCubic: function(t) {
		return t * t * t;
	},

	easeOutCubic: function(t) {
		return (t = t - 1) * t * t + 1;
	},

	easeInOutCubic: function(t) {
		if ((t /= 0.5) < 1) {
			return 0.5 * t * t * t;
		}
		return 0.5 * ((t -= 2) * t * t + 2);
	},

	easeInQuart: function(t) {
		return t * t * t * t;
	},

	easeOutQuart: function(t) {
		return -((t = t - 1) * t * t * t - 1);
	},

	easeInOutQuart: function(t) {
		if ((t /= 0.5) < 1) {
			return 0.5 * t * t * t * t;
		}
		return -0.5 * ((t -= 2) * t * t * t - 2);
	},

	easeInQuint: function(t) {
		return t * t * t * t * t;
	},

	easeOutQuint: function(t) {
		return (t = t - 1) * t * t * t * t + 1;
	},

	easeInOutQuint: function(t) {
		if ((t /= 0.5) < 1) {
			return 0.5 * t * t * t * t * t;
		}
		return 0.5 * ((t -= 2) * t * t * t * t + 2);
	},

	easeInSine: function(t) {
		return -Math.cos(t * (Math.PI / 2)) + 1;
	},

	easeOutSine: function(t) {
		return Math.sin(t * (Math.PI / 2));
	},

	easeInOutSine: function(t) {
		return -0.5 * (Math.cos(Math.PI * t) - 1);
	},

	easeInExpo: function(t) {
		return (t === 0) ? 0 : Math.pow(2, 10 * (t - 1));
	},

	easeOutExpo: function(t) {
		return (t === 1) ? 1 : -Math.pow(2, -10 * t) + 1;
	},

	easeInOutExpo: function(t) {
		if (t === 0) {
			return 0;
		}
		if (t === 1) {
			return 1;
		}
		if ((t /= 0.5) < 1) {
			return 0.5 * Math.pow(2, 10 * (t - 1));
		}
		return 0.5 * (-Math.pow(2, -10 * --t) + 2);
	},

	easeInCirc: function(t) {
		if (t >= 1) {
			return t;
		}
		return -(Math.sqrt(1 - t * t) - 1);
	},

	easeOutCirc: function(t) {
		return Math.sqrt(1 - (t = t - 1) * t);
	},

	easeInOutCirc: function(t) {
		if ((t /= 0.5) < 1) {
			return -0.5 * (Math.sqrt(1 - t * t) - 1);
		}
		return 0.5 * (Math.sqrt(1 - (t -= 2) * t) + 1);
	},

	easeInElastic: function(t) {
		var s = 1.70158;
		var p = 0;
		var a = 1;
		if (t === 0) {
			return 0;
		}
		if (t === 1) {
			return 1;
		}
		if (!p) {
			p = 0.3;
		}
		if (a < 1) {
			a = 1;
			s = p / 4;
		} else {
			s = p / (2 * Math.PI) * Math.asin(1 / a);
		}
		return -(a * Math.pow(2, 10 * (t -= 1)) * Math.sin((t - s) * (2 * Math.PI) / p));
	},

	easeOutElastic: function(t) {
		var s = 1.70158;
		var p = 0;
		var a = 1;
		if (t === 0) {
			return 0;
		}
		if (t === 1) {
			return 1;
		}
		if (!p) {
			p = 0.3;
		}
		if (a < 1) {
			a = 1;
			s = p / 4;
		} else {
			s = p / (2 * Math.PI) * Math.asin(1 / a);
		}
		return a * Math.pow(2, -10 * t) * Math.sin((t - s) * (2 * Math.PI) / p) + 1;
	},

	easeInOutElastic: function(t) {
		var s = 1.70158;
		var p = 0;
		var a = 1;
		if (t === 0) {
			return 0;
		}
		if ((t /= 0.5) === 2) {
			return 1;
		}
		if (!p) {
			p = 0.45;
		}
		if (a < 1) {
			a = 1;
			s = p / 4;
		} else {
			s = p / (2 * Math.PI) * Math.asin(1 / a);
		}
		if (t < 1) {
			return -0.5 * (a * Math.pow(2, 10 * (t -= 1)) * Math.sin((t - s) * (2 * Math.PI) / p));
		}
		return a * Math.pow(2, -10 * (t -= 1)) * Math.sin((t - s) * (2 * Math.PI) / p) * 0.5 + 1;
	},
	easeInBack: function(t) {
		var s = 1.70158;
		return t * t * ((s + 1) * t - s);
	},

	easeOutBack: function(t) {
		var s = 1.70158;
		return (t = t - 1) * t * ((s + 1) * t + s) + 1;
	},

	easeInOutBack: function(t) {
		var s = 1.70158;
		if ((t /= 0.5) < 1) {
			return 0.5 * (t * t * (((s *= (1.525)) + 1) * t - s));
		}
		return 0.5 * ((t -= 2) * t * (((s *= (1.525)) + 1) * t + s) + 2);
	},

	easeInBounce: function(t) {
		return 1 - effects.easeOutBounce(1 - t);
	},

	easeOutBounce: function(t) {
		if (t < (1 / 2.75)) {
			return 7.5625 * t * t;
		}
		if (t < (2 / 2.75)) {
			return 7.5625 * (t -= (1.5 / 2.75)) * t + 0.75;
		}
		if (t < (2.5 / 2.75)) {
			return 7.5625 * (t -= (2.25 / 2.75)) * t + 0.9375;
		}
		return 7.5625 * (t -= (2.625 / 2.75)) * t + 0.984375;
	},

	easeInOutBounce: function(t) {
		if (t < 0.5) {
			return effects.easeInBounce(t * 2) * 0.5;
		}
		return effects.easeOutBounce(t * 2 - 1) * 0.5 + 0.5;
	}
};

module.exports = {
	effects: effects
};

// DEPRECATIONS

/**
 * Provided for backward compatibility, use Chart.helpers.easing.effects instead.
 * @function Chart.helpers.easingEffects
 * @deprecated since version 2.7.0
 * @todo remove at version 3
 * @private
 */
helpers.easingEffects = effects;


/***/ }),
/* 661 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var helpers = __webpack_require__(136);

/**
 * @namespace Chart.helpers.canvas
 */
var exports = module.exports = {
	/**
	 * Clears the entire canvas associated to the given `chart`.
	 * @param {Chart} chart - The chart for which to clear the canvas.
	 */
	clear: function(chart) {
		chart.ctx.clearRect(0, 0, chart.width, chart.height);
	},

	/**
	 * Creates a "path" for a rectangle with rounded corners at position (x, y) with a
	 * given size (width, height) and the same `radius` for all corners.
	 * @param {CanvasRenderingContext2D} ctx - The canvas 2D Context.
	 * @param {Number} x - The x axis of the coordinate for the rectangle starting point.
	 * @param {Number} y - The y axis of the coordinate for the rectangle starting point.
	 * @param {Number} width - The rectangle's width.
	 * @param {Number} height - The rectangle's height.
	 * @param {Number} radius - The rounded amount (in pixels) for the four corners.
	 * @todo handle `radius` as top-left, top-right, bottom-right, bottom-left array/object?
	 */
	roundedRect: function(ctx, x, y, width, height, radius) {
		if (radius) {
			var rx = Math.min(radius, width / 2);
			var ry = Math.min(radius, height / 2);

			ctx.moveTo(x + rx, y);
			ctx.lineTo(x + width - rx, y);
			ctx.quadraticCurveTo(x + width, y, x + width, y + ry);
			ctx.lineTo(x + width, y + height - ry);
			ctx.quadraticCurveTo(x + width, y + height, x + width - rx, y + height);
			ctx.lineTo(x + rx, y + height);
			ctx.quadraticCurveTo(x, y + height, x, y + height - ry);
			ctx.lineTo(x, y + ry);
			ctx.quadraticCurveTo(x, y, x + rx, y);
		} else {
			ctx.rect(x, y, width, height);
		}
	},

	drawPoint: function(ctx, style, radius, x, y) {
		var type, edgeLength, xOffset, yOffset, height, size;

		if (style && typeof style === 'object') {
			type = style.toString();
			if (type === '[object HTMLImageElement]' || type === '[object HTMLCanvasElement]') {
				ctx.drawImage(style, x - style.width / 2, y - style.height / 2, style.width, style.height);
				return;
			}
		}

		if (isNaN(radius) || radius <= 0) {
			return;
		}

		switch (style) {
		// Default includes circle
		default:
			ctx.beginPath();
			ctx.arc(x, y, radius, 0, Math.PI * 2);
			ctx.closePath();
			ctx.fill();
			break;
		case 'triangle':
			ctx.beginPath();
			edgeLength = 3 * radius / Math.sqrt(3);
			height = edgeLength * Math.sqrt(3) / 2;
			ctx.moveTo(x - edgeLength / 2, y + height / 3);
			ctx.lineTo(x + edgeLength / 2, y + height / 3);
			ctx.lineTo(x, y - 2 * height / 3);
			ctx.closePath();
			ctx.fill();
			break;
		case 'rect':
			size = 1 / Math.SQRT2 * radius;
			ctx.beginPath();
			ctx.fillRect(x - size, y - size, 2 * size, 2 * size);
			ctx.strokeRect(x - size, y - size, 2 * size, 2 * size);
			break;
		case 'rectRounded':
			var offset = radius / Math.SQRT2;
			var leftX = x - offset;
			var topY = y - offset;
			var sideSize = Math.SQRT2 * radius;
			ctx.beginPath();
			this.roundedRect(ctx, leftX, topY, sideSize, sideSize, radius / 2);
			ctx.closePath();
			ctx.fill();
			break;
		case 'rectRot':
			size = 1 / Math.SQRT2 * radius;
			ctx.beginPath();
			ctx.moveTo(x - size, y);
			ctx.lineTo(x, y + size);
			ctx.lineTo(x + size, y);
			ctx.lineTo(x, y - size);
			ctx.closePath();
			ctx.fill();
			break;
		case 'cross':
			ctx.beginPath();
			ctx.moveTo(x, y + radius);
			ctx.lineTo(x, y - radius);
			ctx.moveTo(x - radius, y);
			ctx.lineTo(x + radius, y);
			ctx.closePath();
			break;
		case 'crossRot':
			ctx.beginPath();
			xOffset = Math.cos(Math.PI / 4) * radius;
			yOffset = Math.sin(Math.PI / 4) * radius;
			ctx.moveTo(x - xOffset, y - yOffset);
			ctx.lineTo(x + xOffset, y + yOffset);
			ctx.moveTo(x - xOffset, y + yOffset);
			ctx.lineTo(x + xOffset, y - yOffset);
			ctx.closePath();
			break;
		case 'star':
			ctx.beginPath();
			ctx.moveTo(x, y + radius);
			ctx.lineTo(x, y - radius);
			ctx.moveTo(x - radius, y);
			ctx.lineTo(x + radius, y);
			xOffset = Math.cos(Math.PI / 4) * radius;
			yOffset = Math.sin(Math.PI / 4) * radius;
			ctx.moveTo(x - xOffset, y - yOffset);
			ctx.lineTo(x + xOffset, y + yOffset);
			ctx.moveTo(x - xOffset, y + yOffset);
			ctx.lineTo(x + xOffset, y - yOffset);
			ctx.closePath();
			break;
		case 'line':
			ctx.beginPath();
			ctx.moveTo(x - radius, y);
			ctx.lineTo(x + radius, y);
			ctx.closePath();
			break;
		case 'dash':
			ctx.beginPath();
			ctx.moveTo(x, y);
			ctx.lineTo(x + radius, y);
			ctx.closePath();
			break;
		}

		ctx.stroke();
	},

	clipArea: function(ctx, area) {
		ctx.save();
		ctx.beginPath();
		ctx.rect(area.left, area.top, area.right - area.left, area.bottom - area.top);
		ctx.clip();
	},

	unclipArea: function(ctx) {
		ctx.restore();
	},

	lineTo: function(ctx, previous, target, flip) {
		if (target.steppedLine) {
			if ((target.steppedLine === 'after' && !flip) || (target.steppedLine !== 'after' && flip)) {
				ctx.lineTo(previous.x, target.y);
			} else {
				ctx.lineTo(target.x, previous.y);
			}
			ctx.lineTo(target.x, target.y);
			return;
		}

		if (!target.tension) {
			ctx.lineTo(target.x, target.y);
			return;
		}

		ctx.bezierCurveTo(
			flip ? previous.controlPointPreviousX : previous.controlPointNextX,
			flip ? previous.controlPointPreviousY : previous.controlPointNextY,
			flip ? target.controlPointNextX : target.controlPointPreviousX,
			flip ? target.controlPointNextY : target.controlPointPreviousY,
			target.x,
			target.y);
	}
};

// DEPRECATIONS

/**
 * Provided for backward compatibility, use Chart.helpers.canvas.clear instead.
 * @namespace Chart.helpers.clear
 * @deprecated since version 2.7.0
 * @todo remove at version 3
 * @private
 */
helpers.clear = exports.clear;

/**
 * Provided for backward compatibility, use Chart.helpers.canvas.roundedRect instead.
 * @namespace Chart.helpers.drawRoundedRectangle
 * @deprecated since version 2.7.0
 * @todo remove at version 3
 * @private
 */
helpers.drawRoundedRectangle = function(ctx) {
	ctx.beginPath();
	exports.roundedRect.apply(exports, arguments);
	ctx.closePath();
};


/***/ }),
/* 662 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var helpers = __webpack_require__(136);

/**
 * @alias Chart.helpers.options
 * @namespace
 */
module.exports = {
	/**
	 * Converts the given line height `value` in pixels for a specific font `size`.
	 * @param {Number|String} value - The lineHeight to parse (eg. 1.6, '14px', '75%', '1.6em').
	 * @param {Number} size - The font size (in pixels) used to resolve relative `value`.
	 * @returns {Number} The effective line height in pixels (size * 1.2 if value is invalid).
	 * @see https://developer.mozilla.org/en-US/docs/Web/CSS/line-height
	 * @since 2.7.0
	 */
	toLineHeight: function(value, size) {
		var matches = ('' + value).match(/^(normal|(\d+(?:\.\d+)?)(px|em|%)?)$/);
		if (!matches || matches[1] === 'normal') {
			return size * 1.2;
		}

		value = +matches[2];

		switch (matches[3]) {
		case 'px':
			return value;
		case '%':
			value /= 100;
			break;
		default:
			break;
		}

		return size * value;
	},

	/**
	 * Converts the given value into a padding object with pre-computed width/height.
	 * @param {Number|Object} value - If a number, set the value to all TRBL component,
	 *  else, if and object, use defined properties and sets undefined ones to 0.
	 * @returns {Object} The padding values (top, right, bottom, left, width, height)
	 * @since 2.7.0
	 */
	toPadding: function(value) {
		var t, r, b, l;

		if (helpers.isObject(value)) {
			t = +value.top || 0;
			r = +value.right || 0;
			b = +value.bottom || 0;
			l = +value.left || 0;
		} else {
			t = r = b = l = +value || 0;
		}

		return {
			top: t,
			right: r,
			bottom: b,
			left: l,
			height: t + b,
			width: l + r
		};
	},

	/**
	 * Evaluates the given `inputs` sequentially and returns the first defined value.
	 * @param {Array[]} inputs - An array of values, falling back to the last value.
	 * @param {Object} [context] - If defined and the current value is a function, the value
	 * is called with `context` as first argument and the result becomes the new input.
	 * @param {Number} [index] - If defined and the current value is an array, the value
	 * at `index` become the new input.
	 * @since 2.7.0
	 */
	resolve: function(inputs, context, index) {
		var i, ilen, value;

		for (i = 0, ilen = inputs.length; i < ilen; ++i) {
			value = inputs[i];
			if (value === undefined) {
				continue;
			}
			if (context !== undefined && typeof value === 'function') {
				value = value(context);
			}
			if (index !== undefined && helpers.isArray(value)) {
				value = value[index];
			}
			if (value !== undefined) {
				return value;
			}
		}
	}
};


/***/ }),
/* 663 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* global window: false */
/* global document: false */


var color = __webpack_require__(290);
var defaults = __webpack_require__(20);
var helpers = __webpack_require__(15);

module.exports = function(Chart) {

	// -- Basic js utility methods

	helpers.configMerge = function(/* objects ... */) {
		return helpers.merge(helpers.clone(arguments[0]), [].slice.call(arguments, 1), {
			merger: function(key, target, source, options) {
				var tval = target[key] || {};
				var sval = source[key];

				if (key === 'scales') {
					// scale config merging is complex. Add our own function here for that
					target[key] = helpers.scaleMerge(tval, sval);
				} else if (key === 'scale') {
					// used in polar area & radar charts since there is only one scale
					target[key] = helpers.merge(tval, [Chart.scaleService.getScaleDefaults(sval.type), sval]);
				} else {
					helpers._merger(key, target, source, options);
				}
			}
		});
	};

	helpers.scaleMerge = function(/* objects ... */) {
		return helpers.merge(helpers.clone(arguments[0]), [].slice.call(arguments, 1), {
			merger: function(key, target, source, options) {
				if (key === 'xAxes' || key === 'yAxes') {
					var slen = source[key].length;
					var i, type, scale;

					if (!target[key]) {
						target[key] = [];
					}

					for (i = 0; i < slen; ++i) {
						scale = source[key][i];
						type = helpers.valueOrDefault(scale.type, key === 'xAxes' ? 'category' : 'linear');

						if (i >= target[key].length) {
							target[key].push({});
						}

						if (!target[key][i].type || (scale.type && scale.type !== target[key][i].type)) {
							// new/untyped scale or type changed: let's apply the new defaults
							// then merge source scale to correctly overwrite the defaults.
							helpers.merge(target[key][i], [Chart.scaleService.getScaleDefaults(type), scale]);
						} else {
							// scales type are the same
							helpers.merge(target[key][i], scale);
						}
					}
				} else {
					helpers._merger(key, target, source, options);
				}
			}
		});
	};

	helpers.where = function(collection, filterCallback) {
		if (helpers.isArray(collection) && Array.prototype.filter) {
			return collection.filter(filterCallback);
		}
		var filtered = [];

		helpers.each(collection, function(item) {
			if (filterCallback(item)) {
				filtered.push(item);
			}
		});

		return filtered;
	};
	helpers.findIndex = Array.prototype.findIndex ?
		function(array, callback, scope) {
			return array.findIndex(callback, scope);
		} :
		function(array, callback, scope) {
			scope = scope === undefined ? array : scope;
			for (var i = 0, ilen = array.length; i < ilen; ++i) {
				if (callback.call(scope, array[i], i, array)) {
					return i;
				}
			}
			return -1;
		};
	helpers.findNextWhere = function(arrayToSearch, filterCallback, startIndex) {
		// Default to start of the array
		if (helpers.isNullOrUndef(startIndex)) {
			startIndex = -1;
		}
		for (var i = startIndex + 1; i < arrayToSearch.length; i++) {
			var currentItem = arrayToSearch[i];
			if (filterCallback(currentItem)) {
				return currentItem;
			}
		}
	};
	helpers.findPreviousWhere = function(arrayToSearch, filterCallback, startIndex) {
		// Default to end of the array
		if (helpers.isNullOrUndef(startIndex)) {
			startIndex = arrayToSearch.length;
		}
		for (var i = startIndex - 1; i >= 0; i--) {
			var currentItem = arrayToSearch[i];
			if (filterCallback(currentItem)) {
				return currentItem;
			}
		}
	};

	// -- Math methods
	helpers.isNumber = function(n) {
		return !isNaN(parseFloat(n)) && isFinite(n);
	};
	helpers.almostEquals = function(x, y, epsilon) {
		return Math.abs(x - y) < epsilon;
	};
	helpers.almostWhole = function(x, epsilon) {
		var rounded = Math.round(x);
		return (((rounded - epsilon) < x) && ((rounded + epsilon) > x));
	};
	helpers.max = function(array) {
		return array.reduce(function(max, value) {
			if (!isNaN(value)) {
				return Math.max(max, value);
			}
			return max;
		}, Number.NEGATIVE_INFINITY);
	};
	helpers.min = function(array) {
		return array.reduce(function(min, value) {
			if (!isNaN(value)) {
				return Math.min(min, value);
			}
			return min;
		}, Number.POSITIVE_INFINITY);
	};
	helpers.sign = Math.sign ?
		function(x) {
			return Math.sign(x);
		} :
		function(x) {
			x = +x; // convert to a number
			if (x === 0 || isNaN(x)) {
				return x;
			}
			return x > 0 ? 1 : -1;
		};
	helpers.log10 = Math.log10 ?
		function(x) {
			return Math.log10(x);
		} :
		function(x) {
			var exponent = Math.log(x) * Math.LOG10E; // Math.LOG10E = 1 / Math.LN10.
			// Check for whole powers of 10,
			// which due to floating point rounding error should be corrected.
			var powerOf10 = Math.round(exponent);
			var isPowerOf10 = x === Math.pow(10, powerOf10);

			return isPowerOf10 ? powerOf10 : exponent;
		};
	helpers.toRadians = function(degrees) {
		return degrees * (Math.PI / 180);
	};
	helpers.toDegrees = function(radians) {
		return radians * (180 / Math.PI);
	};
	// Gets the angle from vertical upright to the point about a centre.
	helpers.getAngleFromPoint = function(centrePoint, anglePoint) {
		var distanceFromXCenter = anglePoint.x - centrePoint.x;
		var distanceFromYCenter = anglePoint.y - centrePoint.y;
		var radialDistanceFromCenter = Math.sqrt(distanceFromXCenter * distanceFromXCenter + distanceFromYCenter * distanceFromYCenter);

		var angle = Math.atan2(distanceFromYCenter, distanceFromXCenter);

		if (angle < (-0.5 * Math.PI)) {
			angle += 2.0 * Math.PI; // make sure the returned angle is in the range of (-PI/2, 3PI/2]
		}

		return {
			angle: angle,
			distance: radialDistanceFromCenter
		};
	};
	helpers.distanceBetweenPoints = function(pt1, pt2) {
		return Math.sqrt(Math.pow(pt2.x - pt1.x, 2) + Math.pow(pt2.y - pt1.y, 2));
	};
	helpers.aliasPixel = function(pixelWidth) {
		return (pixelWidth % 2 === 0) ? 0 : 0.5;
	};
	helpers.splineCurve = function(firstPoint, middlePoint, afterPoint, t) {
		// Props to Rob Spencer at scaled innovation for his post on splining between points
		// http://scaledinnovation.com/analytics/splines/aboutSplines.html

		// This function must also respect "skipped" points

		var previous = firstPoint.skip ? middlePoint : firstPoint;
		var current = middlePoint;
		var next = afterPoint.skip ? middlePoint : afterPoint;

		var d01 = Math.sqrt(Math.pow(current.x - previous.x, 2) + Math.pow(current.y - previous.y, 2));
		var d12 = Math.sqrt(Math.pow(next.x - current.x, 2) + Math.pow(next.y - current.y, 2));

		var s01 = d01 / (d01 + d12);
		var s12 = d12 / (d01 + d12);

		// If all points are the same, s01 & s02 will be inf
		s01 = isNaN(s01) ? 0 : s01;
		s12 = isNaN(s12) ? 0 : s12;

		var fa = t * s01; // scaling factor for triangle Ta
		var fb = t * s12;

		return {
			previous: {
				x: current.x - fa * (next.x - previous.x),
				y: current.y - fa * (next.y - previous.y)
			},
			next: {
				x: current.x + fb * (next.x - previous.x),
				y: current.y + fb * (next.y - previous.y)
			}
		};
	};
	helpers.EPSILON = Number.EPSILON || 1e-14;
	helpers.splineCurveMonotone = function(points) {
		// This function calculates Bézier control points in a similar way than |splineCurve|,
		// but preserves monotonicity of the provided data and ensures no local extremums are added
		// between the dataset discrete points due to the interpolation.
		// See : https://en.wikipedia.org/wiki/Monotone_cubic_interpolation

		var pointsWithTangents = (points || []).map(function(point) {
			return {
				model: point._model,
				deltaK: 0,
				mK: 0
			};
		});

		// Calculate slopes (deltaK) and initialize tangents (mK)
		var pointsLen = pointsWithTangents.length;
		var i, pointBefore, pointCurrent, pointAfter;
		for (i = 0; i < pointsLen; ++i) {
			pointCurrent = pointsWithTangents[i];
			if (pointCurrent.model.skip) {
				continue;
			}

			pointBefore = i > 0 ? pointsWithTangents[i - 1] : null;
			pointAfter = i < pointsLen - 1 ? pointsWithTangents[i + 1] : null;
			if (pointAfter && !pointAfter.model.skip) {
				var slopeDeltaX = (pointAfter.model.x - pointCurrent.model.x);

				// In the case of two points that appear at the same x pixel, slopeDeltaX is 0
				pointCurrent.deltaK = slopeDeltaX !== 0 ? (pointAfter.model.y - pointCurrent.model.y) / slopeDeltaX : 0;
			}

			if (!pointBefore || pointBefore.model.skip) {
				pointCurrent.mK = pointCurrent.deltaK;
			} else if (!pointAfter || pointAfter.model.skip) {
				pointCurrent.mK = pointBefore.deltaK;
			} else if (this.sign(pointBefore.deltaK) !== this.sign(pointCurrent.deltaK)) {
				pointCurrent.mK = 0;
			} else {
				pointCurrent.mK = (pointBefore.deltaK + pointCurrent.deltaK) / 2;
			}
		}

		// Adjust tangents to ensure monotonic properties
		var alphaK, betaK, tauK, squaredMagnitude;
		for (i = 0; i < pointsLen - 1; ++i) {
			pointCurrent = pointsWithTangents[i];
			pointAfter = pointsWithTangents[i + 1];
			if (pointCurrent.model.skip || pointAfter.model.skip) {
				continue;
			}

			if (helpers.almostEquals(pointCurrent.deltaK, 0, this.EPSILON)) {
				pointCurrent.mK = pointAfter.mK = 0;
				continue;
			}

			alphaK = pointCurrent.mK / pointCurrent.deltaK;
			betaK = pointAfter.mK / pointCurrent.deltaK;
			squaredMagnitude = Math.pow(alphaK, 2) + Math.pow(betaK, 2);
			if (squaredMagnitude <= 9) {
				continue;
			}

			tauK = 3 / Math.sqrt(squaredMagnitude);
			pointCurrent.mK = alphaK * tauK * pointCurrent.deltaK;
			pointAfter.mK = betaK * tauK * pointCurrent.deltaK;
		}

		// Compute control points
		var deltaX;
		for (i = 0; i < pointsLen; ++i) {
			pointCurrent = pointsWithTangents[i];
			if (pointCurrent.model.skip) {
				continue;
			}

			pointBefore = i > 0 ? pointsWithTangents[i - 1] : null;
			pointAfter = i < pointsLen - 1 ? pointsWithTangents[i + 1] : null;
			if (pointBefore && !pointBefore.model.skip) {
				deltaX = (pointCurrent.model.x - pointBefore.model.x) / 3;
				pointCurrent.model.controlPointPreviousX = pointCurrent.model.x - deltaX;
				pointCurrent.model.controlPointPreviousY = pointCurrent.model.y - deltaX * pointCurrent.mK;
			}
			if (pointAfter && !pointAfter.model.skip) {
				deltaX = (pointAfter.model.x - pointCurrent.model.x) / 3;
				pointCurrent.model.controlPointNextX = pointCurrent.model.x + deltaX;
				pointCurrent.model.controlPointNextY = pointCurrent.model.y + deltaX * pointCurrent.mK;
			}
		}
	};
	helpers.nextItem = function(collection, index, loop) {
		if (loop) {
			return index >= collection.length - 1 ? collection[0] : collection[index + 1];
		}
		return index >= collection.length - 1 ? collection[collection.length - 1] : collection[index + 1];
	};
	helpers.previousItem = function(collection, index, loop) {
		if (loop) {
			return index <= 0 ? collection[collection.length - 1] : collection[index - 1];
		}
		return index <= 0 ? collection[0] : collection[index - 1];
	};
	// Implementation of the nice number algorithm used in determining where axis labels will go
	helpers.niceNum = function(range, round) {
		var exponent = Math.floor(helpers.log10(range));
		var fraction = range / Math.pow(10, exponent);
		var niceFraction;

		if (round) {
			if (fraction < 1.5) {
				niceFraction = 1;
			} else if (fraction < 3) {
				niceFraction = 2;
			} else if (fraction < 7) {
				niceFraction = 5;
			} else {
				niceFraction = 10;
			}
		} else if (fraction <= 1.0) {
			niceFraction = 1;
		} else if (fraction <= 2) {
			niceFraction = 2;
		} else if (fraction <= 5) {
			niceFraction = 5;
		} else {
			niceFraction = 10;
		}

		return niceFraction * Math.pow(10, exponent);
	};
	// Request animation polyfill - http://www.paulirish.com/2011/requestanimationframe-for-smart-animating/
	helpers.requestAnimFrame = (function() {
		if (typeof window === 'undefined') {
			return function(callback) {
				callback();
			};
		}
		return window.requestAnimationFrame ||
			window.webkitRequestAnimationFrame ||
			window.mozRequestAnimationFrame ||
			window.oRequestAnimationFrame ||
			window.msRequestAnimationFrame ||
			function(callback) {
				return window.setTimeout(callback, 1000 / 60);
			};
	}());
	// -- DOM methods
	helpers.getRelativePosition = function(evt, chart) {
		var mouseX, mouseY;
		var e = evt.originalEvent || evt;
		var canvas = evt.currentTarget || evt.srcElement;
		var boundingRect = canvas.getBoundingClientRect();

		var touches = e.touches;
		if (touches && touches.length > 0) {
			mouseX = touches[0].clientX;
			mouseY = touches[0].clientY;

		} else {
			mouseX = e.clientX;
			mouseY = e.clientY;
		}

		// Scale mouse coordinates into canvas coordinates
		// by following the pattern laid out by 'jerryj' in the comments of
		// http://www.html5canvastutorials.com/advanced/html5-canvas-mouse-coordinates/
		var paddingLeft = parseFloat(helpers.getStyle(canvas, 'padding-left'));
		var paddingTop = parseFloat(helpers.getStyle(canvas, 'padding-top'));
		var paddingRight = parseFloat(helpers.getStyle(canvas, 'padding-right'));
		var paddingBottom = parseFloat(helpers.getStyle(canvas, 'padding-bottom'));
		var width = boundingRect.right - boundingRect.left - paddingLeft - paddingRight;
		var height = boundingRect.bottom - boundingRect.top - paddingTop - paddingBottom;

		// We divide by the current device pixel ratio, because the canvas is scaled up by that amount in each direction. However
		// the backend model is in unscaled coordinates. Since we are going to deal with our model coordinates, we go back here
		mouseX = Math.round((mouseX - boundingRect.left - paddingLeft) / (width) * canvas.width / chart.currentDevicePixelRatio);
		mouseY = Math.round((mouseY - boundingRect.top - paddingTop) / (height) * canvas.height / chart.currentDevicePixelRatio);

		return {
			x: mouseX,
			y: mouseY
		};

	};

	// Private helper function to convert max-width/max-height values that may be percentages into a number
	function parseMaxStyle(styleValue, node, parentProperty) {
		var valueInPixels;
		if (typeof styleValue === 'string') {
			valueInPixels = parseInt(styleValue, 10);

			if (styleValue.indexOf('%') !== -1) {
				// percentage * size in dimension
				valueInPixels = valueInPixels / 100 * node.parentNode[parentProperty];
			}
		} else {
			valueInPixels = styleValue;
		}

		return valueInPixels;
	}

	/**
	 * Returns if the given value contains an effective constraint.
	 * @private
	 */
	function isConstrainedValue(value) {
		return value !== undefined && value !== null && value !== 'none';
	}

	// Private helper to get a constraint dimension
	// @param domNode : the node to check the constraint on
	// @param maxStyle : the style that defines the maximum for the direction we are using (maxWidth / maxHeight)
	// @param percentageProperty : property of parent to use when calculating width as a percentage
	// @see http://www.nathanaeljones.com/blog/2013/reading-max-width-cross-browser
	function getConstraintDimension(domNode, maxStyle, percentageProperty) {
		var view = document.defaultView;
		var parentNode = domNode.parentNode;
		var constrainedNode = view.getComputedStyle(domNode)[maxStyle];
		var constrainedContainer = view.getComputedStyle(parentNode)[maxStyle];
		var hasCNode = isConstrainedValue(constrainedNode);
		var hasCContainer = isConstrainedValue(constrainedContainer);
		var infinity = Number.POSITIVE_INFINITY;

		if (hasCNode || hasCContainer) {
			return Math.min(
				hasCNode ? parseMaxStyle(constrainedNode, domNode, percentageProperty) : infinity,
				hasCContainer ? parseMaxStyle(constrainedContainer, parentNode, percentageProperty) : infinity);
		}

		return 'none';
	}
	// returns Number or undefined if no constraint
	helpers.getConstraintWidth = function(domNode) {
		return getConstraintDimension(domNode, 'max-width', 'clientWidth');
	};
	// returns Number or undefined if no constraint
	helpers.getConstraintHeight = function(domNode) {
		return getConstraintDimension(domNode, 'max-height', 'clientHeight');
	};
	helpers.getMaximumWidth = function(domNode) {
		var container = domNode.parentNode;
		if (!container) {
			return domNode.clientWidth;
		}

		var paddingLeft = parseInt(helpers.getStyle(container, 'padding-left'), 10);
		var paddingRight = parseInt(helpers.getStyle(container, 'padding-right'), 10);
		var w = container.clientWidth - paddingLeft - paddingRight;
		var cw = helpers.getConstraintWidth(domNode);
		return isNaN(cw) ? w : Math.min(w, cw);
	};
	helpers.getMaximumHeight = function(domNode) {
		var container = domNode.parentNode;
		if (!container) {
			return domNode.clientHeight;
		}

		var paddingTop = parseInt(helpers.getStyle(container, 'padding-top'), 10);
		var paddingBottom = parseInt(helpers.getStyle(container, 'padding-bottom'), 10);
		var h = container.clientHeight - paddingTop - paddingBottom;
		var ch = helpers.getConstraintHeight(domNode);
		return isNaN(ch) ? h : Math.min(h, ch);
	};
	helpers.getStyle = function(el, property) {
		return el.currentStyle ?
			el.currentStyle[property] :
			document.defaultView.getComputedStyle(el, null).getPropertyValue(property);
	};
	helpers.retinaScale = function(chart, forceRatio) {
		var pixelRatio = chart.currentDevicePixelRatio = forceRatio || window.devicePixelRatio || 1;
		if (pixelRatio === 1) {
			return;
		}

		var canvas = chart.canvas;
		var height = chart.height;
		var width = chart.width;

		canvas.height = height * pixelRatio;
		canvas.width = width * pixelRatio;
		chart.ctx.scale(pixelRatio, pixelRatio);

		// If no style has been set on the canvas, the render size is used as display size,
		// making the chart visually bigger, so let's enforce it to the "correct" values.
		// See https://github.com/chartjs/Chart.js/issues/3575
		if (!canvas.style.height && !canvas.style.width) {
			canvas.style.height = height + 'px';
			canvas.style.width = width + 'px';
		}
	};
	// -- Canvas methods
	helpers.fontString = function(pixelSize, fontStyle, fontFamily) {
		return fontStyle + ' ' + pixelSize + 'px ' + fontFamily;
	};
	helpers.longestText = function(ctx, font, arrayOfThings, cache) {
		cache = cache || {};
		var data = cache.data = cache.data || {};
		var gc = cache.garbageCollect = cache.garbageCollect || [];

		if (cache.font !== font) {
			data = cache.data = {};
			gc = cache.garbageCollect = [];
			cache.font = font;
		}

		ctx.font = font;
		var longest = 0;
		helpers.each(arrayOfThings, function(thing) {
			// Undefined strings and arrays should not be measured
			if (thing !== undefined && thing !== null && helpers.isArray(thing) !== true) {
				longest = helpers.measureText(ctx, data, gc, longest, thing);
			} else if (helpers.isArray(thing)) {
				// if it is an array lets measure each element
				// to do maybe simplify this function a bit so we can do this more recursively?
				helpers.each(thing, function(nestedThing) {
					// Undefined strings and arrays should not be measured
					if (nestedThing !== undefined && nestedThing !== null && !helpers.isArray(nestedThing)) {
						longest = helpers.measureText(ctx, data, gc, longest, nestedThing);
					}
				});
			}
		});

		var gcLen = gc.length / 2;
		if (gcLen > arrayOfThings.length) {
			for (var i = 0; i < gcLen; i++) {
				delete data[gc[i]];
			}
			gc.splice(0, gcLen);
		}
		return longest;
	};
	helpers.measureText = function(ctx, data, gc, longest, string) {
		var textWidth = data[string];
		if (!textWidth) {
			textWidth = data[string] = ctx.measureText(string).width;
			gc.push(string);
		}
		if (textWidth > longest) {
			longest = textWidth;
		}
		return longest;
	};
	helpers.numberOfLabelLines = function(arrayOfThings) {
		var numberOfLines = 1;
		helpers.each(arrayOfThings, function(thing) {
			if (helpers.isArray(thing)) {
				if (thing.length > numberOfLines) {
					numberOfLines = thing.length;
				}
			}
		});
		return numberOfLines;
	};

	helpers.color = !color ?
		function(value) {
			console.error('Color.js not found!');
			return value;
		} :
		function(value) {
			/* global CanvasGradient */
			if (value instanceof CanvasGradient) {
				value = defaults.global.defaultColor;
			}

			return color(value);
		};

	helpers.getHoverColor = function(colorValue) {
		/* global CanvasPattern */
		return (colorValue instanceof CanvasPattern) ?
			colorValue :
			helpers.color(colorValue).saturate(0.5).darken(0.1).rgbString();
	};
};


/***/ }),
/* 664 */
/***/ (function(module, exports, __webpack_require__) {

var conversions = __webpack_require__(665);

var convert = function() {
   return new Converter();
}

for (var func in conversions) {
  // export Raw versions
  convert[func + "Raw"] =  (function(func) {
    // accept array or plain args
    return function(arg) {
      if (typeof arg == "number")
        arg = Array.prototype.slice.call(arguments);
      return conversions[func](arg);
    }
  })(func);

  var pair = /(\w+)2(\w+)/.exec(func),
      from = pair[1],
      to = pair[2];

  // export rgb2hsl and ["rgb"]["hsl"]
  convert[from] = convert[from] || {};

  convert[from][to] = convert[func] = (function(func) { 
    return function(arg) {
      if (typeof arg == "number")
        arg = Array.prototype.slice.call(arguments);
      
      var val = conversions[func](arg);
      if (typeof val == "string" || val === undefined)
        return val; // keyword

      for (var i = 0; i < val.length; i++)
        val[i] = Math.round(val[i]);
      return val;
    }
  })(func);
}


/* Converter does lazy conversion and caching */
var Converter = function() {
   this.convs = {};
};

/* Either get the values for a space or
  set the values for a space, depending on args */
Converter.prototype.routeSpace = function(space, args) {
   var values = args[0];
   if (values === undefined) {
      // color.rgb()
      return this.getValues(space);
   }
   // color.rgb(10, 10, 10)
   if (typeof values == "number") {
      values = Array.prototype.slice.call(args);        
   }

   return this.setValues(space, values);
};
  
/* Set the values for a space, invalidating cache */
Converter.prototype.setValues = function(space, values) {
   this.space = space;
   this.convs = {};
   this.convs[space] = values;
   return this;
};

/* Get the values for a space. If there's already
  a conversion for the space, fetch it, otherwise
  compute it */
Converter.prototype.getValues = function(space) {
   var vals = this.convs[space];
   if (!vals) {
      var fspace = this.space,
          from = this.convs[fspace];
      vals = convert[fspace][space](from);

      this.convs[space] = vals;
   }
  return vals;
};

["rgb", "hsl", "hsv", "cmyk", "keyword"].forEach(function(space) {
   Converter.prototype[space] = function(vals) {
      return this.routeSpace(space, arguments);
   }
});

module.exports = convert;

/***/ }),
/* 665 */
/***/ (function(module, exports) {

/* MIT license */

module.exports = {
  rgb2hsl: rgb2hsl,
  rgb2hsv: rgb2hsv,
  rgb2hwb: rgb2hwb,
  rgb2cmyk: rgb2cmyk,
  rgb2keyword: rgb2keyword,
  rgb2xyz: rgb2xyz,
  rgb2lab: rgb2lab,
  rgb2lch: rgb2lch,

  hsl2rgb: hsl2rgb,
  hsl2hsv: hsl2hsv,
  hsl2hwb: hsl2hwb,
  hsl2cmyk: hsl2cmyk,
  hsl2keyword: hsl2keyword,

  hsv2rgb: hsv2rgb,
  hsv2hsl: hsv2hsl,
  hsv2hwb: hsv2hwb,
  hsv2cmyk: hsv2cmyk,
  hsv2keyword: hsv2keyword,

  hwb2rgb: hwb2rgb,
  hwb2hsl: hwb2hsl,
  hwb2hsv: hwb2hsv,
  hwb2cmyk: hwb2cmyk,
  hwb2keyword: hwb2keyword,

  cmyk2rgb: cmyk2rgb,
  cmyk2hsl: cmyk2hsl,
  cmyk2hsv: cmyk2hsv,
  cmyk2hwb: cmyk2hwb,
  cmyk2keyword: cmyk2keyword,

  keyword2rgb: keyword2rgb,
  keyword2hsl: keyword2hsl,
  keyword2hsv: keyword2hsv,
  keyword2hwb: keyword2hwb,
  keyword2cmyk: keyword2cmyk,
  keyword2lab: keyword2lab,
  keyword2xyz: keyword2xyz,

  xyz2rgb: xyz2rgb,
  xyz2lab: xyz2lab,
  xyz2lch: xyz2lch,

  lab2xyz: lab2xyz,
  lab2rgb: lab2rgb,
  lab2lch: lab2lch,

  lch2lab: lch2lab,
  lch2xyz: lch2xyz,
  lch2rgb: lch2rgb
}


function rgb2hsl(rgb) {
  var r = rgb[0]/255,
      g = rgb[1]/255,
      b = rgb[2]/255,
      min = Math.min(r, g, b),
      max = Math.max(r, g, b),
      delta = max - min,
      h, s, l;

  if (max == min)
    h = 0;
  else if (r == max)
    h = (g - b) / delta;
  else if (g == max)
    h = 2 + (b - r) / delta;
  else if (b == max)
    h = 4 + (r - g)/ delta;

  h = Math.min(h * 60, 360);

  if (h < 0)
    h += 360;

  l = (min + max) / 2;

  if (max == min)
    s = 0;
  else if (l <= 0.5)
    s = delta / (max + min);
  else
    s = delta / (2 - max - min);

  return [h, s * 100, l * 100];
}

function rgb2hsv(rgb) {
  var r = rgb[0],
      g = rgb[1],
      b = rgb[2],
      min = Math.min(r, g, b),
      max = Math.max(r, g, b),
      delta = max - min,
      h, s, v;

  if (max == 0)
    s = 0;
  else
    s = (delta/max * 1000)/10;

  if (max == min)
    h = 0;
  else if (r == max)
    h = (g - b) / delta;
  else if (g == max)
    h = 2 + (b - r) / delta;
  else if (b == max)
    h = 4 + (r - g) / delta;

  h = Math.min(h * 60, 360);

  if (h < 0)
    h += 360;

  v = ((max / 255) * 1000) / 10;

  return [h, s, v];
}

function rgb2hwb(rgb) {
  var r = rgb[0],
      g = rgb[1],
      b = rgb[2],
      h = rgb2hsl(rgb)[0],
      w = 1/255 * Math.min(r, Math.min(g, b)),
      b = 1 - 1/255 * Math.max(r, Math.max(g, b));

  return [h, w * 100, b * 100];
}

function rgb2cmyk(rgb) {
  var r = rgb[0] / 255,
      g = rgb[1] / 255,
      b = rgb[2] / 255,
      c, m, y, k;

  k = Math.min(1 - r, 1 - g, 1 - b);
  c = (1 - r - k) / (1 - k) || 0;
  m = (1 - g - k) / (1 - k) || 0;
  y = (1 - b - k) / (1 - k) || 0;
  return [c * 100, m * 100, y * 100, k * 100];
}

function rgb2keyword(rgb) {
  return reverseKeywords[JSON.stringify(rgb)];
}

function rgb2xyz(rgb) {
  var r = rgb[0] / 255,
      g = rgb[1] / 255,
      b = rgb[2] / 255;

  // assume sRGB
  r = r > 0.04045 ? Math.pow(((r + 0.055) / 1.055), 2.4) : (r / 12.92);
  g = g > 0.04045 ? Math.pow(((g + 0.055) / 1.055), 2.4) : (g / 12.92);
  b = b > 0.04045 ? Math.pow(((b + 0.055) / 1.055), 2.4) : (b / 12.92);

  var x = (r * 0.4124) + (g * 0.3576) + (b * 0.1805);
  var y = (r * 0.2126) + (g * 0.7152) + (b * 0.0722);
  var z = (r * 0.0193) + (g * 0.1192) + (b * 0.9505);

  return [x * 100, y *100, z * 100];
}

function rgb2lab(rgb) {
  var xyz = rgb2xyz(rgb),
        x = xyz[0],
        y = xyz[1],
        z = xyz[2],
        l, a, b;

  x /= 95.047;
  y /= 100;
  z /= 108.883;

  x = x > 0.008856 ? Math.pow(x, 1/3) : (7.787 * x) + (16 / 116);
  y = y > 0.008856 ? Math.pow(y, 1/3) : (7.787 * y) + (16 / 116);
  z = z > 0.008856 ? Math.pow(z, 1/3) : (7.787 * z) + (16 / 116);

  l = (116 * y) - 16;
  a = 500 * (x - y);
  b = 200 * (y - z);

  return [l, a, b];
}

function rgb2lch(args) {
  return lab2lch(rgb2lab(args));
}

function hsl2rgb(hsl) {
  var h = hsl[0] / 360,
      s = hsl[1] / 100,
      l = hsl[2] / 100,
      t1, t2, t3, rgb, val;

  if (s == 0) {
    val = l * 255;
    return [val, val, val];
  }

  if (l < 0.5)
    t2 = l * (1 + s);
  else
    t2 = l + s - l * s;
  t1 = 2 * l - t2;

  rgb = [0, 0, 0];
  for (var i = 0; i < 3; i++) {
    t3 = h + 1 / 3 * - (i - 1);
    t3 < 0 && t3++;
    t3 > 1 && t3--;

    if (6 * t3 < 1)
      val = t1 + (t2 - t1) * 6 * t3;
    else if (2 * t3 < 1)
      val = t2;
    else if (3 * t3 < 2)
      val = t1 + (t2 - t1) * (2 / 3 - t3) * 6;
    else
      val = t1;

    rgb[i] = val * 255;
  }

  return rgb;
}

function hsl2hsv(hsl) {
  var h = hsl[0],
      s = hsl[1] / 100,
      l = hsl[2] / 100,
      sv, v;

  if(l === 0) {
      // no need to do calc on black
      // also avoids divide by 0 error
      return [0, 0, 0];
  }

  l *= 2;
  s *= (l <= 1) ? l : 2 - l;
  v = (l + s) / 2;
  sv = (2 * s) / (l + s);
  return [h, sv * 100, v * 100];
}

function hsl2hwb(args) {
  return rgb2hwb(hsl2rgb(args));
}

function hsl2cmyk(args) {
  return rgb2cmyk(hsl2rgb(args));
}

function hsl2keyword(args) {
  return rgb2keyword(hsl2rgb(args));
}


function hsv2rgb(hsv) {
  var h = hsv[0] / 60,
      s = hsv[1] / 100,
      v = hsv[2] / 100,
      hi = Math.floor(h) % 6;

  var f = h - Math.floor(h),
      p = 255 * v * (1 - s),
      q = 255 * v * (1 - (s * f)),
      t = 255 * v * (1 - (s * (1 - f))),
      v = 255 * v;

  switch(hi) {
    case 0:
      return [v, t, p];
    case 1:
      return [q, v, p];
    case 2:
      return [p, v, t];
    case 3:
      return [p, q, v];
    case 4:
      return [t, p, v];
    case 5:
      return [v, p, q];
  }
}

function hsv2hsl(hsv) {
  var h = hsv[0],
      s = hsv[1] / 100,
      v = hsv[2] / 100,
      sl, l;

  l = (2 - s) * v;
  sl = s * v;
  sl /= (l <= 1) ? l : 2 - l;
  sl = sl || 0;
  l /= 2;
  return [h, sl * 100, l * 100];
}

function hsv2hwb(args) {
  return rgb2hwb(hsv2rgb(args))
}

function hsv2cmyk(args) {
  return rgb2cmyk(hsv2rgb(args));
}

function hsv2keyword(args) {
  return rgb2keyword(hsv2rgb(args));
}

// http://dev.w3.org/csswg/css-color/#hwb-to-rgb
function hwb2rgb(hwb) {
  var h = hwb[0] / 360,
      wh = hwb[1] / 100,
      bl = hwb[2] / 100,
      ratio = wh + bl,
      i, v, f, n;

  // wh + bl cant be > 1
  if (ratio > 1) {
    wh /= ratio;
    bl /= ratio;
  }

  i = Math.floor(6 * h);
  v = 1 - bl;
  f = 6 * h - i;
  if ((i & 0x01) != 0) {
    f = 1 - f;
  }
  n = wh + f * (v - wh);  // linear interpolation

  switch (i) {
    default:
    case 6:
    case 0: r = v; g = n; b = wh; break;
    case 1: r = n; g = v; b = wh; break;
    case 2: r = wh; g = v; b = n; break;
    case 3: r = wh; g = n; b = v; break;
    case 4: r = n; g = wh; b = v; break;
    case 5: r = v; g = wh; b = n; break;
  }

  return [r * 255, g * 255, b * 255];
}

function hwb2hsl(args) {
  return rgb2hsl(hwb2rgb(args));
}

function hwb2hsv(args) {
  return rgb2hsv(hwb2rgb(args));
}

function hwb2cmyk(args) {
  return rgb2cmyk(hwb2rgb(args));
}

function hwb2keyword(args) {
  return rgb2keyword(hwb2rgb(args));
}

function cmyk2rgb(cmyk) {
  var c = cmyk[0] / 100,
      m = cmyk[1] / 100,
      y = cmyk[2] / 100,
      k = cmyk[3] / 100,
      r, g, b;

  r = 1 - Math.min(1, c * (1 - k) + k);
  g = 1 - Math.min(1, m * (1 - k) + k);
  b = 1 - Math.min(1, y * (1 - k) + k);
  return [r * 255, g * 255, b * 255];
}

function cmyk2hsl(args) {
  return rgb2hsl(cmyk2rgb(args));
}

function cmyk2hsv(args) {
  return rgb2hsv(cmyk2rgb(args));
}

function cmyk2hwb(args) {
  return rgb2hwb(cmyk2rgb(args));
}

function cmyk2keyword(args) {
  return rgb2keyword(cmyk2rgb(args));
}


function xyz2rgb(xyz) {
  var x = xyz[0] / 100,
      y = xyz[1] / 100,
      z = xyz[2] / 100,
      r, g, b;

  r = (x * 3.2406) + (y * -1.5372) + (z * -0.4986);
  g = (x * -0.9689) + (y * 1.8758) + (z * 0.0415);
  b = (x * 0.0557) + (y * -0.2040) + (z * 1.0570);

  // assume sRGB
  r = r > 0.0031308 ? ((1.055 * Math.pow(r, 1.0 / 2.4)) - 0.055)
    : r = (r * 12.92);

  g = g > 0.0031308 ? ((1.055 * Math.pow(g, 1.0 / 2.4)) - 0.055)
    : g = (g * 12.92);

  b = b > 0.0031308 ? ((1.055 * Math.pow(b, 1.0 / 2.4)) - 0.055)
    : b = (b * 12.92);

  r = Math.min(Math.max(0, r), 1);
  g = Math.min(Math.max(0, g), 1);
  b = Math.min(Math.max(0, b), 1);

  return [r * 255, g * 255, b * 255];
}

function xyz2lab(xyz) {
  var x = xyz[0],
      y = xyz[1],
      z = xyz[2],
      l, a, b;

  x /= 95.047;
  y /= 100;
  z /= 108.883;

  x = x > 0.008856 ? Math.pow(x, 1/3) : (7.787 * x) + (16 / 116);
  y = y > 0.008856 ? Math.pow(y, 1/3) : (7.787 * y) + (16 / 116);
  z = z > 0.008856 ? Math.pow(z, 1/3) : (7.787 * z) + (16 / 116);

  l = (116 * y) - 16;
  a = 500 * (x - y);
  b = 200 * (y - z);

  return [l, a, b];
}

function xyz2lch(args) {
  return lab2lch(xyz2lab(args));
}

function lab2xyz(lab) {
  var l = lab[0],
      a = lab[1],
      b = lab[2],
      x, y, z, y2;

  if (l <= 8) {
    y = (l * 100) / 903.3;
    y2 = (7.787 * (y / 100)) + (16 / 116);
  } else {
    y = 100 * Math.pow((l + 16) / 116, 3);
    y2 = Math.pow(y / 100, 1/3);
  }

  x = x / 95.047 <= 0.008856 ? x = (95.047 * ((a / 500) + y2 - (16 / 116))) / 7.787 : 95.047 * Math.pow((a / 500) + y2, 3);

  z = z / 108.883 <= 0.008859 ? z = (108.883 * (y2 - (b / 200) - (16 / 116))) / 7.787 : 108.883 * Math.pow(y2 - (b / 200), 3);

  return [x, y, z];
}

function lab2lch(lab) {
  var l = lab[0],
      a = lab[1],
      b = lab[2],
      hr, h, c;

  hr = Math.atan2(b, a);
  h = hr * 360 / 2 / Math.PI;
  if (h < 0) {
    h += 360;
  }
  c = Math.sqrt(a * a + b * b);
  return [l, c, h];
}

function lab2rgb(args) {
  return xyz2rgb(lab2xyz(args));
}

function lch2lab(lch) {
  var l = lch[0],
      c = lch[1],
      h = lch[2],
      a, b, hr;

  hr = h / 360 * 2 * Math.PI;
  a = c * Math.cos(hr);
  b = c * Math.sin(hr);
  return [l, a, b];
}

function lch2xyz(args) {
  return lab2xyz(lch2lab(args));
}

function lch2rgb(args) {
  return lab2rgb(lch2lab(args));
}

function keyword2rgb(keyword) {
  return cssKeywords[keyword];
}

function keyword2hsl(args) {
  return rgb2hsl(keyword2rgb(args));
}

function keyword2hsv(args) {
  return rgb2hsv(keyword2rgb(args));
}

function keyword2hwb(args) {
  return rgb2hwb(keyword2rgb(args));
}

function keyword2cmyk(args) {
  return rgb2cmyk(keyword2rgb(args));
}

function keyword2lab(args) {
  return rgb2lab(keyword2rgb(args));
}

function keyword2xyz(args) {
  return rgb2xyz(keyword2rgb(args));
}

var cssKeywords = {
  aliceblue:  [240,248,255],
  antiquewhite: [250,235,215],
  aqua: [0,255,255],
  aquamarine: [127,255,212],
  azure:  [240,255,255],
  beige:  [245,245,220],
  bisque: [255,228,196],
  black:  [0,0,0],
  blanchedalmond: [255,235,205],
  blue: [0,0,255],
  blueviolet: [138,43,226],
  brown:  [165,42,42],
  burlywood:  [222,184,135],
  cadetblue:  [95,158,160],
  chartreuse: [127,255,0],
  chocolate:  [210,105,30],
  coral:  [255,127,80],
  cornflowerblue: [100,149,237],
  cornsilk: [255,248,220],
  crimson:  [220,20,60],
  cyan: [0,255,255],
  darkblue: [0,0,139],
  darkcyan: [0,139,139],
  darkgoldenrod:  [184,134,11],
  darkgray: [169,169,169],
  darkgreen:  [0,100,0],
  darkgrey: [169,169,169],
  darkkhaki:  [189,183,107],
  darkmagenta:  [139,0,139],
  darkolivegreen: [85,107,47],
  darkorange: [255,140,0],
  darkorchid: [153,50,204],
  darkred:  [139,0,0],
  darksalmon: [233,150,122],
  darkseagreen: [143,188,143],
  darkslateblue:  [72,61,139],
  darkslategray:  [47,79,79],
  darkslategrey:  [47,79,79],
  darkturquoise:  [0,206,209],
  darkviolet: [148,0,211],
  deeppink: [255,20,147],
  deepskyblue:  [0,191,255],
  dimgray:  [105,105,105],
  dimgrey:  [105,105,105],
  dodgerblue: [30,144,255],
  firebrick:  [178,34,34],
  floralwhite:  [255,250,240],
  forestgreen:  [34,139,34],
  fuchsia:  [255,0,255],
  gainsboro:  [220,220,220],
  ghostwhite: [248,248,255],
  gold: [255,215,0],
  goldenrod:  [218,165,32],
  gray: [128,128,128],
  green:  [0,128,0],
  greenyellow:  [173,255,47],
  grey: [128,128,128],
  honeydew: [240,255,240],
  hotpink:  [255,105,180],
  indianred:  [205,92,92],
  indigo: [75,0,130],
  ivory:  [255,255,240],
  khaki:  [240,230,140],
  lavender: [230,230,250],
  lavenderblush:  [255,240,245],
  lawngreen:  [124,252,0],
  lemonchiffon: [255,250,205],
  lightblue:  [173,216,230],
  lightcoral: [240,128,128],
  lightcyan:  [224,255,255],
  lightgoldenrodyellow: [250,250,210],
  lightgray:  [211,211,211],
  lightgreen: [144,238,144],
  lightgrey:  [211,211,211],
  lightpink:  [255,182,193],
  lightsalmon:  [255,160,122],
  lightseagreen:  [32,178,170],
  lightskyblue: [135,206,250],
  lightslategray: [119,136,153],
  lightslategrey: [119,136,153],
  lightsteelblue: [176,196,222],
  lightyellow:  [255,255,224],
  lime: [0,255,0],
  limegreen:  [50,205,50],
  linen:  [250,240,230],
  magenta:  [255,0,255],
  maroon: [128,0,0],
  mediumaquamarine: [102,205,170],
  mediumblue: [0,0,205],
  mediumorchid: [186,85,211],
  mediumpurple: [147,112,219],
  mediumseagreen: [60,179,113],
  mediumslateblue:  [123,104,238],
  mediumspringgreen:  [0,250,154],
  mediumturquoise:  [72,209,204],
  mediumvioletred:  [199,21,133],
  midnightblue: [25,25,112],
  mintcream:  [245,255,250],
  mistyrose:  [255,228,225],
  moccasin: [255,228,181],
  navajowhite:  [255,222,173],
  navy: [0,0,128],
  oldlace:  [253,245,230],
  olive:  [128,128,0],
  olivedrab:  [107,142,35],
  orange: [255,165,0],
  orangered:  [255,69,0],
  orchid: [218,112,214],
  palegoldenrod:  [238,232,170],
  palegreen:  [152,251,152],
  paleturquoise:  [175,238,238],
  palevioletred:  [219,112,147],
  papayawhip: [255,239,213],
  peachpuff:  [255,218,185],
  peru: [205,133,63],
  pink: [255,192,203],
  plum: [221,160,221],
  powderblue: [176,224,230],
  purple: [128,0,128],
  rebeccapurple: [102, 51, 153],
  red:  [255,0,0],
  rosybrown:  [188,143,143],
  royalblue:  [65,105,225],
  saddlebrown:  [139,69,19],
  salmon: [250,128,114],
  sandybrown: [244,164,96],
  seagreen: [46,139,87],
  seashell: [255,245,238],
  sienna: [160,82,45],
  silver: [192,192,192],
  skyblue:  [135,206,235],
  slateblue:  [106,90,205],
  slategray:  [112,128,144],
  slategrey:  [112,128,144],
  snow: [255,250,250],
  springgreen:  [0,255,127],
  steelblue:  [70,130,180],
  tan:  [210,180,140],
  teal: [0,128,128],
  thistle:  [216,191,216],
  tomato: [255,99,71],
  turquoise:  [64,224,208],
  violet: [238,130,238],
  wheat:  [245,222,179],
  white:  [255,255,255],
  whitesmoke: [245,245,245],
  yellow: [255,255,0],
  yellowgreen:  [154,205,50]
};

var reverseKeywords = {};
for (var key in cssKeywords) {
  reverseKeywords[JSON.stringify(cssKeywords[key])] = key;
}


/***/ }),
/* 666 */
/***/ (function(module, exports, __webpack_require__) {

/* MIT license */
var colorNames = __webpack_require__(667);

module.exports = {
   getRgba: getRgba,
   getHsla: getHsla,
   getRgb: getRgb,
   getHsl: getHsl,
   getHwb: getHwb,
   getAlpha: getAlpha,

   hexString: hexString,
   rgbString: rgbString,
   rgbaString: rgbaString,
   percentString: percentString,
   percentaString: percentaString,
   hslString: hslString,
   hslaString: hslaString,
   hwbString: hwbString,
   keyword: keyword
}

function getRgba(string) {
   if (!string) {
      return;
   }
   var abbr =  /^#([a-fA-F0-9]{3})$/i,
       hex =  /^#([a-fA-F0-9]{6})$/i,
       rgba = /^rgba?\(\s*([+-]?\d+)\s*,\s*([+-]?\d+)\s*,\s*([+-]?\d+)\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)$/i,
       per = /^rgba?\(\s*([+-]?[\d\.]+)\%\s*,\s*([+-]?[\d\.]+)\%\s*,\s*([+-]?[\d\.]+)\%\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)$/i,
       keyword = /(\w+)/;

   var rgb = [0, 0, 0],
       a = 1,
       match = string.match(abbr);
   if (match) {
      match = match[1];
      for (var i = 0; i < rgb.length; i++) {
         rgb[i] = parseInt(match[i] + match[i], 16);
      }
   }
   else if (match = string.match(hex)) {
      match = match[1];
      for (var i = 0; i < rgb.length; i++) {
         rgb[i] = parseInt(match.slice(i * 2, i * 2 + 2), 16);
      }
   }
   else if (match = string.match(rgba)) {
      for (var i = 0; i < rgb.length; i++) {
         rgb[i] = parseInt(match[i + 1]);
      }
      a = parseFloat(match[4]);
   }
   else if (match = string.match(per)) {
      for (var i = 0; i < rgb.length; i++) {
         rgb[i] = Math.round(parseFloat(match[i + 1]) * 2.55);
      }
      a = parseFloat(match[4]);
   }
   else if (match = string.match(keyword)) {
      if (match[1] == "transparent") {
         return [0, 0, 0, 0];
      }
      rgb = colorNames[match[1]];
      if (!rgb) {
         return;
      }
   }

   for (var i = 0; i < rgb.length; i++) {
      rgb[i] = scale(rgb[i], 0, 255);
   }
   if (!a && a != 0) {
      a = 1;
   }
   else {
      a = scale(a, 0, 1);
   }
   rgb[3] = a;
   return rgb;
}

function getHsla(string) {
   if (!string) {
      return;
   }
   var hsl = /^hsla?\(\s*([+-]?\d+)(?:deg)?\s*,\s*([+-]?[\d\.]+)%\s*,\s*([+-]?[\d\.]+)%\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)/;
   var match = string.match(hsl);
   if (match) {
      var alpha = parseFloat(match[4]);
      var h = scale(parseInt(match[1]), 0, 360),
          s = scale(parseFloat(match[2]), 0, 100),
          l = scale(parseFloat(match[3]), 0, 100),
          a = scale(isNaN(alpha) ? 1 : alpha, 0, 1);
      return [h, s, l, a];
   }
}

function getHwb(string) {
   if (!string) {
      return;
   }
   var hwb = /^hwb\(\s*([+-]?\d+)(?:deg)?\s*,\s*([+-]?[\d\.]+)%\s*,\s*([+-]?[\d\.]+)%\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)/;
   var match = string.match(hwb);
   if (match) {
    var alpha = parseFloat(match[4]);
      var h = scale(parseInt(match[1]), 0, 360),
          w = scale(parseFloat(match[2]), 0, 100),
          b = scale(parseFloat(match[3]), 0, 100),
          a = scale(isNaN(alpha) ? 1 : alpha, 0, 1);
      return [h, w, b, a];
   }
}

function getRgb(string) {
   var rgba = getRgba(string);
   return rgba && rgba.slice(0, 3);
}

function getHsl(string) {
  var hsla = getHsla(string);
  return hsla && hsla.slice(0, 3);
}

function getAlpha(string) {
   var vals = getRgba(string);
   if (vals) {
      return vals[3];
   }
   else if (vals = getHsla(string)) {
      return vals[3];
   }
   else if (vals = getHwb(string)) {
      return vals[3];
   }
}

// generators
function hexString(rgb) {
   return "#" + hexDouble(rgb[0]) + hexDouble(rgb[1])
              + hexDouble(rgb[2]);
}

function rgbString(rgba, alpha) {
   if (alpha < 1 || (rgba[3] && rgba[3] < 1)) {
      return rgbaString(rgba, alpha);
   }
   return "rgb(" + rgba[0] + ", " + rgba[1] + ", " + rgba[2] + ")";
}

function rgbaString(rgba, alpha) {
   if (alpha === undefined) {
      alpha = (rgba[3] !== undefined ? rgba[3] : 1);
   }
   return "rgba(" + rgba[0] + ", " + rgba[1] + ", " + rgba[2]
           + ", " + alpha + ")";
}

function percentString(rgba, alpha) {
   if (alpha < 1 || (rgba[3] && rgba[3] < 1)) {
      return percentaString(rgba, alpha);
   }
   var r = Math.round(rgba[0]/255 * 100),
       g = Math.round(rgba[1]/255 * 100),
       b = Math.round(rgba[2]/255 * 100);

   return "rgb(" + r + "%, " + g + "%, " + b + "%)";
}

function percentaString(rgba, alpha) {
   var r = Math.round(rgba[0]/255 * 100),
       g = Math.round(rgba[1]/255 * 100),
       b = Math.round(rgba[2]/255 * 100);
   return "rgba(" + r + "%, " + g + "%, " + b + "%, " + (alpha || rgba[3] || 1) + ")";
}

function hslString(hsla, alpha) {
   if (alpha < 1 || (hsla[3] && hsla[3] < 1)) {
      return hslaString(hsla, alpha);
   }
   return "hsl(" + hsla[0] + ", " + hsla[1] + "%, " + hsla[2] + "%)";
}

function hslaString(hsla, alpha) {
   if (alpha === undefined) {
      alpha = (hsla[3] !== undefined ? hsla[3] : 1);
   }
   return "hsla(" + hsla[0] + ", " + hsla[1] + "%, " + hsla[2] + "%, "
           + alpha + ")";
}

// hwb is a bit different than rgb(a) & hsl(a) since there is no alpha specific syntax
// (hwb have alpha optional & 1 is default value)
function hwbString(hwb, alpha) {
   if (alpha === undefined) {
      alpha = (hwb[3] !== undefined ? hwb[3] : 1);
   }
   return "hwb(" + hwb[0] + ", " + hwb[1] + "%, " + hwb[2] + "%"
           + (alpha !== undefined && alpha !== 1 ? ", " + alpha : "") + ")";
}

function keyword(rgb) {
  return reverseNames[rgb.slice(0, 3)];
}

// helpers
function scale(num, min, max) {
   return Math.min(Math.max(min, num), max);
}

function hexDouble(num) {
  var str = num.toString(16).toUpperCase();
  return (str.length < 2) ? "0" + str : str;
}


//create a list of reverse color names
var reverseNames = {};
for (var name in colorNames) {
   reverseNames[colorNames[name]] = name;
}


/***/ }),
/* 667 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
	"aliceblue": [240, 248, 255],
	"antiquewhite": [250, 235, 215],
	"aqua": [0, 255, 255],
	"aquamarine": [127, 255, 212],
	"azure": [240, 255, 255],
	"beige": [245, 245, 220],
	"bisque": [255, 228, 196],
	"black": [0, 0, 0],
	"blanchedalmond": [255, 235, 205],
	"blue": [0, 0, 255],
	"blueviolet": [138, 43, 226],
	"brown": [165, 42, 42],
	"burlywood": [222, 184, 135],
	"cadetblue": [95, 158, 160],
	"chartreuse": [127, 255, 0],
	"chocolate": [210, 105, 30],
	"coral": [255, 127, 80],
	"cornflowerblue": [100, 149, 237],
	"cornsilk": [255, 248, 220],
	"crimson": [220, 20, 60],
	"cyan": [0, 255, 255],
	"darkblue": [0, 0, 139],
	"darkcyan": [0, 139, 139],
	"darkgoldenrod": [184, 134, 11],
	"darkgray": [169, 169, 169],
	"darkgreen": [0, 100, 0],
	"darkgrey": [169, 169, 169],
	"darkkhaki": [189, 183, 107],
	"darkmagenta": [139, 0, 139],
	"darkolivegreen": [85, 107, 47],
	"darkorange": [255, 140, 0],
	"darkorchid": [153, 50, 204],
	"darkred": [139, 0, 0],
	"darksalmon": [233, 150, 122],
	"darkseagreen": [143, 188, 143],
	"darkslateblue": [72, 61, 139],
	"darkslategray": [47, 79, 79],
	"darkslategrey": [47, 79, 79],
	"darkturquoise": [0, 206, 209],
	"darkviolet": [148, 0, 211],
	"deeppink": [255, 20, 147],
	"deepskyblue": [0, 191, 255],
	"dimgray": [105, 105, 105],
	"dimgrey": [105, 105, 105],
	"dodgerblue": [30, 144, 255],
	"firebrick": [178, 34, 34],
	"floralwhite": [255, 250, 240],
	"forestgreen": [34, 139, 34],
	"fuchsia": [255, 0, 255],
	"gainsboro": [220, 220, 220],
	"ghostwhite": [248, 248, 255],
	"gold": [255, 215, 0],
	"goldenrod": [218, 165, 32],
	"gray": [128, 128, 128],
	"green": [0, 128, 0],
	"greenyellow": [173, 255, 47],
	"grey": [128, 128, 128],
	"honeydew": [240, 255, 240],
	"hotpink": [255, 105, 180],
	"indianred": [205, 92, 92],
	"indigo": [75, 0, 130],
	"ivory": [255, 255, 240],
	"khaki": [240, 230, 140],
	"lavender": [230, 230, 250],
	"lavenderblush": [255, 240, 245],
	"lawngreen": [124, 252, 0],
	"lemonchiffon": [255, 250, 205],
	"lightblue": [173, 216, 230],
	"lightcoral": [240, 128, 128],
	"lightcyan": [224, 255, 255],
	"lightgoldenrodyellow": [250, 250, 210],
	"lightgray": [211, 211, 211],
	"lightgreen": [144, 238, 144],
	"lightgrey": [211, 211, 211],
	"lightpink": [255, 182, 193],
	"lightsalmon": [255, 160, 122],
	"lightseagreen": [32, 178, 170],
	"lightskyblue": [135, 206, 250],
	"lightslategray": [119, 136, 153],
	"lightslategrey": [119, 136, 153],
	"lightsteelblue": [176, 196, 222],
	"lightyellow": [255, 255, 224],
	"lime": [0, 255, 0],
	"limegreen": [50, 205, 50],
	"linen": [250, 240, 230],
	"magenta": [255, 0, 255],
	"maroon": [128, 0, 0],
	"mediumaquamarine": [102, 205, 170],
	"mediumblue": [0, 0, 205],
	"mediumorchid": [186, 85, 211],
	"mediumpurple": [147, 112, 219],
	"mediumseagreen": [60, 179, 113],
	"mediumslateblue": [123, 104, 238],
	"mediumspringgreen": [0, 250, 154],
	"mediumturquoise": [72, 209, 204],
	"mediumvioletred": [199, 21, 133],
	"midnightblue": [25, 25, 112],
	"mintcream": [245, 255, 250],
	"mistyrose": [255, 228, 225],
	"moccasin": [255, 228, 181],
	"navajowhite": [255, 222, 173],
	"navy": [0, 0, 128],
	"oldlace": [253, 245, 230],
	"olive": [128, 128, 0],
	"olivedrab": [107, 142, 35],
	"orange": [255, 165, 0],
	"orangered": [255, 69, 0],
	"orchid": [218, 112, 214],
	"palegoldenrod": [238, 232, 170],
	"palegreen": [152, 251, 152],
	"paleturquoise": [175, 238, 238],
	"palevioletred": [219, 112, 147],
	"papayawhip": [255, 239, 213],
	"peachpuff": [255, 218, 185],
	"peru": [205, 133, 63],
	"pink": [255, 192, 203],
	"plum": [221, 160, 221],
	"powderblue": [176, 224, 230],
	"purple": [128, 0, 128],
	"rebeccapurple": [102, 51, 153],
	"red": [255, 0, 0],
	"rosybrown": [188, 143, 143],
	"royalblue": [65, 105, 225],
	"saddlebrown": [139, 69, 19],
	"salmon": [250, 128, 114],
	"sandybrown": [244, 164, 96],
	"seagreen": [46, 139, 87],
	"seashell": [255, 245, 238],
	"sienna": [160, 82, 45],
	"silver": [192, 192, 192],
	"skyblue": [135, 206, 235],
	"slateblue": [106, 90, 205],
	"slategray": [112, 128, 144],
	"slategrey": [112, 128, 144],
	"snow": [255, 250, 250],
	"springgreen": [0, 255, 127],
	"steelblue": [70, 130, 180],
	"tan": [210, 180, 140],
	"teal": [0, 128, 128],
	"thistle": [216, 191, 216],
	"tomato": [255, 99, 71],
	"turquoise": [64, 224, 208],
	"violet": [238, 130, 238],
	"wheat": [245, 222, 179],
	"white": [255, 255, 255],
	"whitesmoke": [245, 245, 245],
	"yellow": [255, 255, 0],
	"yellowgreen": [154, 205, 50]
};


/***/ }),
/* 668 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var defaults = __webpack_require__(20);
var Element = __webpack_require__(46);
var helpers = __webpack_require__(15);

defaults._set('global', {
	elements: {
		arc: {
			backgroundColor: defaults.global.defaultColor,
			borderColor: '#fff',
			borderWidth: 2
		}
	}
});

module.exports = Element.extend({
	inLabelRange: function(mouseX) {
		var vm = this._view;

		if (vm) {
			return (Math.pow(mouseX - vm.x, 2) < Math.pow(vm.radius + vm.hoverRadius, 2));
		}
		return false;
	},

	inRange: function(chartX, chartY) {
		var vm = this._view;

		if (vm) {
			var pointRelativePosition = helpers.getAngleFromPoint(vm, {x: chartX, y: chartY});
			var	angle = pointRelativePosition.angle;
			var distance = pointRelativePosition.distance;

			// Sanitise angle range
			var startAngle = vm.startAngle;
			var endAngle = vm.endAngle;
			while (endAngle < startAngle) {
				endAngle += 2.0 * Math.PI;
			}
			while (angle > endAngle) {
				angle -= 2.0 * Math.PI;
			}
			while (angle < startAngle) {
				angle += 2.0 * Math.PI;
			}

			// Check if within the range of the open/close angle
			var betweenAngles = (angle >= startAngle && angle <= endAngle);
			var withinRadius = (distance >= vm.innerRadius && distance <= vm.outerRadius);

			return (betweenAngles && withinRadius);
		}
		return false;
	},

	getCenterPoint: function() {
		var vm = this._view;
		var halfAngle = (vm.startAngle + vm.endAngle) / 2;
		var halfRadius = (vm.innerRadius + vm.outerRadius) / 2;
		return {
			x: vm.x + Math.cos(halfAngle) * halfRadius,
			y: vm.y + Math.sin(halfAngle) * halfRadius
		};
	},

	getArea: function() {
		var vm = this._view;
		return Math.PI * ((vm.endAngle - vm.startAngle) / (2 * Math.PI)) * (Math.pow(vm.outerRadius, 2) - Math.pow(vm.innerRadius, 2));
	},

	tooltipPosition: function() {
		var vm = this._view;
		var centreAngle = vm.startAngle + ((vm.endAngle - vm.startAngle) / 2);
		var rangeFromCentre = (vm.outerRadius - vm.innerRadius) / 2 + vm.innerRadius;

		return {
			x: vm.x + (Math.cos(centreAngle) * rangeFromCentre),
			y: vm.y + (Math.sin(centreAngle) * rangeFromCentre)
		};
	},

	draw: function() {
		var ctx = this._chart.ctx;
		var vm = this._view;
		var sA = vm.startAngle;
		var eA = vm.endAngle;

		ctx.beginPath();

		ctx.arc(vm.x, vm.y, vm.outerRadius, sA, eA);
		ctx.arc(vm.x, vm.y, vm.innerRadius, eA, sA, true);

		ctx.closePath();
		ctx.strokeStyle = vm.borderColor;
		ctx.lineWidth = vm.borderWidth;

		ctx.fillStyle = vm.backgroundColor;

		ctx.fill();
		ctx.lineJoin = 'bevel';

		if (vm.borderWidth) {
			ctx.stroke();
		}
	}
});


/***/ }),
/* 669 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var defaults = __webpack_require__(20);
var Element = __webpack_require__(46);
var helpers = __webpack_require__(15);

var globalDefaults = defaults.global;

defaults._set('global', {
	elements: {
		line: {
			tension: 0.4,
			backgroundColor: globalDefaults.defaultColor,
			borderWidth: 3,
			borderColor: globalDefaults.defaultColor,
			borderCapStyle: 'butt',
			borderDash: [],
			borderDashOffset: 0.0,
			borderJoinStyle: 'miter',
			capBezierPoints: true,
			fill: true, // do we fill in the area between the line and its base axis
		}
	}
});

module.exports = Element.extend({
	draw: function() {
		var me = this;
		var vm = me._view;
		var ctx = me._chart.ctx;
		var spanGaps = vm.spanGaps;
		var points = me._children.slice(); // clone array
		var globalOptionLineElements = globalDefaults.elements.line;
		var lastDrawnIndex = -1;
		var index, current, previous, currentVM;

		// If we are looping, adding the first point again
		if (me._loop && points.length) {
			points.push(points[0]);
		}

		ctx.save();

		// Stroke Line Options
		ctx.lineCap = vm.borderCapStyle || globalOptionLineElements.borderCapStyle;

		// IE 9 and 10 do not support line dash
		if (ctx.setLineDash) {
			ctx.setLineDash(vm.borderDash || globalOptionLineElements.borderDash);
		}

		ctx.lineDashOffset = vm.borderDashOffset || globalOptionLineElements.borderDashOffset;
		ctx.lineJoin = vm.borderJoinStyle || globalOptionLineElements.borderJoinStyle;
		ctx.lineWidth = vm.borderWidth || globalOptionLineElements.borderWidth;
		ctx.strokeStyle = vm.borderColor || globalDefaults.defaultColor;

		// Stroke Line
		ctx.beginPath();
		lastDrawnIndex = -1;

		for (index = 0; index < points.length; ++index) {
			current = points[index];
			previous = helpers.previousItem(points, index);
			currentVM = current._view;

			// First point moves to it's starting position no matter what
			if (index === 0) {
				if (!currentVM.skip) {
					ctx.moveTo(currentVM.x, currentVM.y);
					lastDrawnIndex = index;
				}
			} else {
				previous = lastDrawnIndex === -1 ? previous : points[lastDrawnIndex];

				if (!currentVM.skip) {
					if ((lastDrawnIndex !== (index - 1) && !spanGaps) || lastDrawnIndex === -1) {
						// There was a gap and this is the first point after the gap
						ctx.moveTo(currentVM.x, currentVM.y);
					} else {
						// Line to next point
						helpers.canvas.lineTo(ctx, previous._view, current._view);
					}
					lastDrawnIndex = index;
				}
			}
		}

		ctx.stroke();
		ctx.restore();
	}
});


/***/ }),
/* 670 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var defaults = __webpack_require__(20);
var Element = __webpack_require__(46);
var helpers = __webpack_require__(15);

var defaultColor = defaults.global.defaultColor;

defaults._set('global', {
	elements: {
		point: {
			radius: 3,
			pointStyle: 'circle',
			backgroundColor: defaultColor,
			borderColor: defaultColor,
			borderWidth: 1,
			// Hover
			hitRadius: 1,
			hoverRadius: 4,
			hoverBorderWidth: 1
		}
	}
});

function xRange(mouseX) {
	var vm = this._view;
	return vm ? (Math.abs(mouseX - vm.x) < vm.radius + vm.hitRadius) : false;
}

function yRange(mouseY) {
	var vm = this._view;
	return vm ? (Math.abs(mouseY - vm.y) < vm.radius + vm.hitRadius) : false;
}

module.exports = Element.extend({
	inRange: function(mouseX, mouseY) {
		var vm = this._view;
		return vm ? ((Math.pow(mouseX - vm.x, 2) + Math.pow(mouseY - vm.y, 2)) < Math.pow(vm.hitRadius + vm.radius, 2)) : false;
	},

	inLabelRange: xRange,
	inXRange: xRange,
	inYRange: yRange,

	getCenterPoint: function() {
		var vm = this._view;
		return {
			x: vm.x,
			y: vm.y
		};
	},

	getArea: function() {
		return Math.PI * Math.pow(this._view.radius, 2);
	},

	tooltipPosition: function() {
		var vm = this._view;
		return {
			x: vm.x,
			y: vm.y,
			padding: vm.radius + vm.borderWidth
		};
	},

	draw: function(chartArea) {
		var vm = this._view;
		var model = this._model;
		var ctx = this._chart.ctx;
		var pointStyle = vm.pointStyle;
		var radius = vm.radius;
		var x = vm.x;
		var y = vm.y;
		var color = helpers.color;
		var errMargin = 1.01; // 1.01 is margin for Accumulated error. (Especially Edge, IE.)
		var ratio = 0;

		if (vm.skip) {
			return;
		}

		ctx.strokeStyle = vm.borderColor || defaultColor;
		ctx.lineWidth = helpers.valueOrDefault(vm.borderWidth, defaults.global.elements.point.borderWidth);
		ctx.fillStyle = vm.backgroundColor || defaultColor;

		// Cliping for Points.
		// going out from inner charArea?
		if ((chartArea !== undefined) && ((model.x < chartArea.left) || (chartArea.right * errMargin < model.x) || (model.y < chartArea.top) || (chartArea.bottom * errMargin < model.y))) {
			// Point fade out
			if (model.x < chartArea.left) {
				ratio = (x - model.x) / (chartArea.left - model.x);
			} else if (chartArea.right * errMargin < model.x) {
				ratio = (model.x - x) / (model.x - chartArea.right);
			} else if (model.y < chartArea.top) {
				ratio = (y - model.y) / (chartArea.top - model.y);
			} else if (chartArea.bottom * errMargin < model.y) {
				ratio = (model.y - y) / (model.y - chartArea.bottom);
			}
			ratio = Math.round(ratio * 100) / 100;
			ctx.strokeStyle = color(ctx.strokeStyle).alpha(ratio).rgbString();
			ctx.fillStyle = color(ctx.fillStyle).alpha(ratio).rgbString();
		}

		helpers.canvas.drawPoint(ctx, pointStyle, radius, x, y);
	}
});


/***/ }),
/* 671 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var defaults = __webpack_require__(20);
var Element = __webpack_require__(46);

defaults._set('global', {
	elements: {
		rectangle: {
			backgroundColor: defaults.global.defaultColor,
			borderColor: defaults.global.defaultColor,
			borderSkipped: 'bottom',
			borderWidth: 0
		}
	}
});

function isVertical(bar) {
	return bar._view.width !== undefined;
}

/**
 * Helper function to get the bounds of the bar regardless of the orientation
 * @param bar {Chart.Element.Rectangle} the bar
 * @return {Bounds} bounds of the bar
 * @private
 */
function getBarBounds(bar) {
	var vm = bar._view;
	var x1, x2, y1, y2;

	if (isVertical(bar)) {
		// vertical
		var halfWidth = vm.width / 2;
		x1 = vm.x - halfWidth;
		x2 = vm.x + halfWidth;
		y1 = Math.min(vm.y, vm.base);
		y2 = Math.max(vm.y, vm.base);
	} else {
		// horizontal bar
		var halfHeight = vm.height / 2;
		x1 = Math.min(vm.x, vm.base);
		x2 = Math.max(vm.x, vm.base);
		y1 = vm.y - halfHeight;
		y2 = vm.y + halfHeight;
	}

	return {
		left: x1,
		top: y1,
		right: x2,
		bottom: y2
	};
}

module.exports = Element.extend({
	draw: function() {
		var ctx = this._chart.ctx;
		var vm = this._view;
		var left, right, top, bottom, signX, signY, borderSkipped;
		var borderWidth = vm.borderWidth;

		if (!vm.horizontal) {
			// bar
			left = vm.x - vm.width / 2;
			right = vm.x + vm.width / 2;
			top = vm.y;
			bottom = vm.base;
			signX = 1;
			signY = bottom > top ? 1 : -1;
			borderSkipped = vm.borderSkipped || 'bottom';
		} else {
			// horizontal bar
			left = vm.base;
			right = vm.x;
			top = vm.y - vm.height / 2;
			bottom = vm.y + vm.height / 2;
			signX = right > left ? 1 : -1;
			signY = 1;
			borderSkipped = vm.borderSkipped || 'left';
		}

		// Canvas doesn't allow us to stroke inside the width so we can
		// adjust the sizes to fit if we're setting a stroke on the line
		if (borderWidth) {
			// borderWidth shold be less than bar width and bar height.
			var barSize = Math.min(Math.abs(left - right), Math.abs(top - bottom));
			borderWidth = borderWidth > barSize ? barSize : borderWidth;
			var halfStroke = borderWidth / 2;
			// Adjust borderWidth when bar top position is near vm.base(zero).
			var borderLeft = left + (borderSkipped !== 'left' ? halfStroke * signX : 0);
			var borderRight = right + (borderSkipped !== 'right' ? -halfStroke * signX : 0);
			var borderTop = top + (borderSkipped !== 'top' ? halfStroke * signY : 0);
			var borderBottom = bottom + (borderSkipped !== 'bottom' ? -halfStroke * signY : 0);
			// not become a vertical line?
			if (borderLeft !== borderRight) {
				top = borderTop;
				bottom = borderBottom;
			}
			// not become a horizontal line?
			if (borderTop !== borderBottom) {
				left = borderLeft;
				right = borderRight;
			}
		}

		ctx.beginPath();
		ctx.fillStyle = vm.backgroundColor;
		ctx.strokeStyle = vm.borderColor;
		ctx.lineWidth = borderWidth;

		// Corner points, from bottom-left to bottom-right clockwise
		// | 1 2 |
		// | 0 3 |
		var corners = [
			[left, bottom],
			[left, top],
			[right, top],
			[right, bottom]
		];

		// Find first (starting) corner with fallback to 'bottom'
		var borders = ['bottom', 'left', 'top', 'right'];
		var startCorner = borders.indexOf(borderSkipped, 0);
		if (startCorner === -1) {
			startCorner = 0;
		}

		function cornerAt(index) {
			return corners[(startCorner + index) % 4];
		}

		// Draw rectangle from 'startCorner'
		var corner = cornerAt(0);
		ctx.moveTo(corner[0], corner[1]);

		for (var i = 1; i < 4; i++) {
			corner = cornerAt(i);
			ctx.lineTo(corner[0], corner[1]);
		}

		ctx.fill();
		if (borderWidth) {
			ctx.stroke();
		}
	},

	height: function() {
		var vm = this._view;
		return vm.base - vm.y;
	},

	inRange: function(mouseX, mouseY) {
		var inRange = false;

		if (this._view) {
			var bounds = getBarBounds(this);
			inRange = mouseX >= bounds.left && mouseX <= bounds.right && mouseY >= bounds.top && mouseY <= bounds.bottom;
		}

		return inRange;
	},

	inLabelRange: function(mouseX, mouseY) {
		var me = this;
		if (!me._view) {
			return false;
		}

		var inRange = false;
		var bounds = getBarBounds(me);

		if (isVertical(me)) {
			inRange = mouseX >= bounds.left && mouseX <= bounds.right;
		} else {
			inRange = mouseY >= bounds.top && mouseY <= bounds.bottom;
		}

		return inRange;
	},

	inXRange: function(mouseX) {
		var bounds = getBarBounds(this);
		return mouseX >= bounds.left && mouseX <= bounds.right;
	},

	inYRange: function(mouseY) {
		var bounds = getBarBounds(this);
		return mouseY >= bounds.top && mouseY <= bounds.bottom;
	},

	getCenterPoint: function() {
		var vm = this._view;
		var x, y;
		if (isVertical(this)) {
			x = vm.x;
			y = (vm.y + vm.base) / 2;
		} else {
			x = (vm.x + vm.base) / 2;
			y = vm.y;
		}

		return {x: x, y: y};
	},

	getArea: function() {
		var vm = this._view;
		return vm.width * Math.abs(vm.y - vm.base);
	},

	tooltipPosition: function() {
		var vm = this._view;
		return {
			x: vm.x,
			y: vm.y
		};
	}
});


/***/ }),
/* 672 */
/***/ (function(module, exports) {

/**
 * Platform fallback implementation (minimal).
 * @see https://github.com/chartjs/Chart.js/pull/4591#issuecomment-319575939
 */

module.exports = {
	acquireContext: function(item) {
		if (item && item.canvas) {
			// Support for any object associated to a canvas (including a context2d)
			item = item.canvas;
		}

		return item && item.getContext('2d') || null;
	}
};


/***/ }),
/* 673 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Chart.Platform implementation for targeting a web browser
 */



var helpers = __webpack_require__(15);

var EXPANDO_KEY = '$chartjs';
var CSS_PREFIX = 'chartjs-';
var CSS_RENDER_MONITOR = CSS_PREFIX + 'render-monitor';
var CSS_RENDER_ANIMATION = CSS_PREFIX + 'render-animation';
var ANIMATION_START_EVENTS = ['animationstart', 'webkitAnimationStart'];

/**
 * DOM event types -> Chart.js event types.
 * Note: only events with different types are mapped.
 * @see https://developer.mozilla.org/en-US/docs/Web/Events
 */
var EVENT_TYPES = {
	touchstart: 'mousedown',
	touchmove: 'mousemove',
	touchend: 'mouseup',
	pointerenter: 'mouseenter',
	pointerdown: 'mousedown',
	pointermove: 'mousemove',
	pointerup: 'mouseup',
	pointerleave: 'mouseout',
	pointerout: 'mouseout'
};

/**
 * The "used" size is the final value of a dimension property after all calculations have
 * been performed. This method uses the computed style of `element` but returns undefined
 * if the computed style is not expressed in pixels. That can happen in some cases where
 * `element` has a size relative to its parent and this last one is not yet displayed,
 * for example because of `display: none` on a parent node.
 * @see https://developer.mozilla.org/en-US/docs/Web/CSS/used_value
 * @returns {Number} Size in pixels or undefined if unknown.
 */
function readUsedSize(element, property) {
	var value = helpers.getStyle(element, property);
	var matches = value && value.match(/^(\d+)(\.\d+)?px$/);
	return matches ? Number(matches[1]) : undefined;
}

/**
 * Initializes the canvas style and render size without modifying the canvas display size,
 * since responsiveness is handled by the controller.resize() method. The config is used
 * to determine the aspect ratio to apply in case no explicit height has been specified.
 */
function initCanvas(canvas, config) {
	var style = canvas.style;

	// NOTE(SB) canvas.getAttribute('width') !== canvas.width: in the first case it
	// returns null or '' if no explicit value has been set to the canvas attribute.
	var renderHeight = canvas.getAttribute('height');
	var renderWidth = canvas.getAttribute('width');

	// Chart.js modifies some canvas values that we want to restore on destroy
	canvas[EXPANDO_KEY] = {
		initial: {
			height: renderHeight,
			width: renderWidth,
			style: {
				display: style.display,
				height: style.height,
				width: style.width
			}
		}
	};

	// Force canvas to display as block to avoid extra space caused by inline
	// elements, which would interfere with the responsive resize process.
	// https://github.com/chartjs/Chart.js/issues/2538
	style.display = style.display || 'block';

	if (renderWidth === null || renderWidth === '') {
		var displayWidth = readUsedSize(canvas, 'width');
		if (displayWidth !== undefined) {
			canvas.width = displayWidth;
		}
	}

	if (renderHeight === null || renderHeight === '') {
		if (canvas.style.height === '') {
			// If no explicit render height and style height, let's apply the aspect ratio,
			// which one can be specified by the user but also by charts as default option
			// (i.e. options.aspectRatio). If not specified, use canvas aspect ratio of 2.
			canvas.height = canvas.width / (config.options.aspectRatio || 2);
		} else {
			var displayHeight = readUsedSize(canvas, 'height');
			if (displayWidth !== undefined) {
				canvas.height = displayHeight;
			}
		}
	}

	return canvas;
}

/**
 * Detects support for options object argument in addEventListener.
 * https://developer.mozilla.org/en-US/docs/Web/API/EventTarget/addEventListener#Safely_detecting_option_support
 * @private
 */
var supportsEventListenerOptions = (function() {
	var supports = false;
	try {
		var options = Object.defineProperty({}, 'passive', {
			get: function() {
				supports = true;
			}
		});
		window.addEventListener('e', null, options);
	} catch (e) {
		// continue regardless of error
	}
	return supports;
}());

// Default passive to true as expected by Chrome for 'touchstart' and 'touchend' events.
// https://github.com/chartjs/Chart.js/issues/4287
var eventListenerOptions = supportsEventListenerOptions ? {passive: true} : false;

function addEventListener(node, type, listener) {
	node.addEventListener(type, listener, eventListenerOptions);
}

function removeEventListener(node, type, listener) {
	node.removeEventListener(type, listener, eventListenerOptions);
}

function createEvent(type, chart, x, y, nativeEvent) {
	return {
		type: type,
		chart: chart,
		native: nativeEvent || null,
		x: x !== undefined ? x : null,
		y: y !== undefined ? y : null,
	};
}

function fromNativeEvent(event, chart) {
	var type = EVENT_TYPES[event.type] || event.type;
	var pos = helpers.getRelativePosition(event, chart);
	return createEvent(type, chart, pos.x, pos.y, event);
}

function throttled(fn, thisArg) {
	var ticking = false;
	var args = [];

	return function() {
		args = Array.prototype.slice.call(arguments);
		thisArg = thisArg || this;

		if (!ticking) {
			ticking = true;
			helpers.requestAnimFrame.call(window, function() {
				ticking = false;
				fn.apply(thisArg, args);
			});
		}
	};
}

// Implementation based on https://github.com/marcj/css-element-queries
function createResizer(handler) {
	var resizer = document.createElement('div');
	var cls = CSS_PREFIX + 'size-monitor';
	var maxSize = 1000000;
	var style =
		'position:absolute;' +
		'left:0;' +
		'top:0;' +
		'right:0;' +
		'bottom:0;' +
		'overflow:hidden;' +
		'pointer-events:none;' +
		'visibility:hidden;' +
		'z-index:-1;';

	resizer.style.cssText = style;
	resizer.className = cls;
	resizer.innerHTML =
		'<div class="' + cls + '-expand" style="' + style + '">' +
			'<div style="' +
				'position:absolute;' +
				'width:' + maxSize + 'px;' +
				'height:' + maxSize + 'px;' +
				'left:0;' +
				'top:0">' +
			'</div>' +
		'</div>' +
		'<div class="' + cls + '-shrink" style="' + style + '">' +
			'<div style="' +
				'position:absolute;' +
				'width:200%;' +
				'height:200%;' +
				'left:0; ' +
				'top:0">' +
			'</div>' +
		'</div>';

	var expand = resizer.childNodes[0];
	var shrink = resizer.childNodes[1];

	resizer._reset = function() {
		expand.scrollLeft = maxSize;
		expand.scrollTop = maxSize;
		shrink.scrollLeft = maxSize;
		shrink.scrollTop = maxSize;
	};
	var onScroll = function() {
		resizer._reset();
		handler();
	};

	addEventListener(expand, 'scroll', onScroll.bind(expand, 'expand'));
	addEventListener(shrink, 'scroll', onScroll.bind(shrink, 'shrink'));

	return resizer;
}

// https://davidwalsh.name/detect-node-insertion
function watchForRender(node, handler) {
	var expando = node[EXPANDO_KEY] || (node[EXPANDO_KEY] = {});
	var proxy = expando.renderProxy = function(e) {
		if (e.animationName === CSS_RENDER_ANIMATION) {
			handler();
		}
	};

	helpers.each(ANIMATION_START_EVENTS, function(type) {
		addEventListener(node, type, proxy);
	});

	// #4737: Chrome might skip the CSS animation when the CSS_RENDER_MONITOR class
	// is removed then added back immediately (same animation frame?). Accessing the
	// `offsetParent` property will force a reflow and re-evaluate the CSS animation.
	// https://gist.github.com/paulirish/5d52fb081b3570c81e3a#box-metrics
	// https://github.com/chartjs/Chart.js/issues/4737
	expando.reflow = !!node.offsetParent;

	node.classList.add(CSS_RENDER_MONITOR);
}

function unwatchForRender(node) {
	var expando = node[EXPANDO_KEY] || {};
	var proxy = expando.renderProxy;

	if (proxy) {
		helpers.each(ANIMATION_START_EVENTS, function(type) {
			removeEventListener(node, type, proxy);
		});

		delete expando.renderProxy;
	}

	node.classList.remove(CSS_RENDER_MONITOR);
}

function addResizeListener(node, listener, chart) {
	var expando = node[EXPANDO_KEY] || (node[EXPANDO_KEY] = {});

	// Let's keep track of this added resizer and thus avoid DOM query when removing it.
	var resizer = expando.resizer = createResizer(throttled(function() {
		if (expando.resizer) {
			return listener(createEvent('resize', chart));
		}
	}));

	// The resizer needs to be attached to the node parent, so we first need to be
	// sure that `node` is attached to the DOM before injecting the resizer element.
	watchForRender(node, function() {
		if (expando.resizer) {
			var container = node.parentNode;
			if (container && container !== resizer.parentNode) {
				container.insertBefore(resizer, container.firstChild);
			}

			// The container size might have changed, let's reset the resizer state.
			resizer._reset();
		}
	});
}

function removeResizeListener(node) {
	var expando = node[EXPANDO_KEY] || {};
	var resizer = expando.resizer;

	delete expando.resizer;
	unwatchForRender(node);

	if (resizer && resizer.parentNode) {
		resizer.parentNode.removeChild(resizer);
	}
}

function injectCSS(platform, css) {
	// http://stackoverflow.com/q/3922139
	var style = platform._style || document.createElement('style');
	if (!platform._style) {
		platform._style = style;
		css = '/* Chart.js */\n' + css;
		style.setAttribute('type', 'text/css');
		document.getElementsByTagName('head')[0].appendChild(style);
	}

	style.appendChild(document.createTextNode(css));
}

module.exports = {
	/**
	 * This property holds whether this platform is enabled for the current environment.
	 * Currently used by platform.js to select the proper implementation.
	 * @private
	 */
	_enabled: typeof window !== 'undefined' && typeof document !== 'undefined',

	initialize: function() {
		var keyframes = 'from{opacity:0.99}to{opacity:1}';

		injectCSS(this,
			// DOM rendering detection
			// https://davidwalsh.name/detect-node-insertion
			'@-webkit-keyframes ' + CSS_RENDER_ANIMATION + '{' + keyframes + '}' +
			'@keyframes ' + CSS_RENDER_ANIMATION + '{' + keyframes + '}' +
			'.' + CSS_RENDER_MONITOR + '{' +
				'-webkit-animation:' + CSS_RENDER_ANIMATION + ' 0.001s;' +
				'animation:' + CSS_RENDER_ANIMATION + ' 0.001s;' +
			'}'
		);
	},

	acquireContext: function(item, config) {
		if (typeof item === 'string') {
			item = document.getElementById(item);
		} else if (item.length) {
			// Support for array based queries (such as jQuery)
			item = item[0];
		}

		if (item && item.canvas) {
			// Support for any object associated to a canvas (including a context2d)
			item = item.canvas;
		}

		// To prevent canvas fingerprinting, some add-ons undefine the getContext
		// method, for example: https://github.com/kkapsner/CanvasBlocker
		// https://github.com/chartjs/Chart.js/issues/2807
		var context = item && item.getContext && item.getContext('2d');

		// `instanceof HTMLCanvasElement/CanvasRenderingContext2D` fails when the item is
		// inside an iframe or when running in a protected environment. We could guess the
		// types from their toString() value but let's keep things flexible and assume it's
		// a sufficient condition if the item has a context2D which has item as `canvas`.
		// https://github.com/chartjs/Chart.js/issues/3887
		// https://github.com/chartjs/Chart.js/issues/4102
		// https://github.com/chartjs/Chart.js/issues/4152
		if (context && context.canvas === item) {
			initCanvas(item, config);
			return context;
		}

		return null;
	},

	releaseContext: function(context) {
		var canvas = context.canvas;
		if (!canvas[EXPANDO_KEY]) {
			return;
		}

		var initial = canvas[EXPANDO_KEY].initial;
		['height', 'width'].forEach(function(prop) {
			var value = initial[prop];
			if (helpers.isNullOrUndef(value)) {
				canvas.removeAttribute(prop);
			} else {
				canvas.setAttribute(prop, value);
			}
		});

		helpers.each(initial.style || {}, function(value, key) {
			canvas.style[key] = value;
		});

		// The canvas render size might have been changed (and thus the state stack discarded),
		// we can't use save() and restore() to restore the initial state. So make sure that at
		// least the canvas context is reset to the default state by setting the canvas width.
		// https://www.w3.org/TR/2011/WD-html5-20110525/the-canvas-element.html
		canvas.width = canvas.width;

		delete canvas[EXPANDO_KEY];
	},

	addEventListener: function(chart, type, listener) {
		var canvas = chart.canvas;
		if (type === 'resize') {
			// Note: the resize event is not supported on all browsers.
			addResizeListener(canvas, listener, chart);
			return;
		}

		var expando = listener[EXPANDO_KEY] || (listener[EXPANDO_KEY] = {});
		var proxies = expando.proxies || (expando.proxies = {});
		var proxy = proxies[chart.id + '_' + type] = function(event) {
			listener(fromNativeEvent(event, chart));
		};

		addEventListener(canvas, type, proxy);
	},

	removeEventListener: function(chart, type, listener) {
		var canvas = chart.canvas;
		if (type === 'resize') {
			// Note: the resize event is not supported on all browsers.
			removeResizeListener(canvas, listener);
			return;
		}

		var expando = listener[EXPANDO_KEY] || {};
		var proxies = expando.proxies || {};
		var proxy = proxies[chart.id + '_' + type];
		if (!proxy) {
			return;
		}

		removeEventListener(canvas, type, proxy);
	}
};

// DEPRECATIONS

/**
 * Provided for backward compatibility, use EventTarget.addEventListener instead.
 * EventTarget.addEventListener compatibility: Chrome, Opera 7, Safari, FF1.5+, IE9+
 * @see https://developer.mozilla.org/en-US/docs/Web/API/EventTarget/addEventListener
 * @function Chart.helpers.addEvent
 * @deprecated since version 2.7.0
 * @todo remove at version 3
 * @private
 */
helpers.addEvent = addEventListener;

/**
 * Provided for backward compatibility, use EventTarget.removeEventListener instead.
 * EventTarget.removeEventListener compatibility: Chrome, Opera 7, Safari, FF1.5+, IE9+
 * @see https://developer.mozilla.org/en-US/docs/Web/API/EventTarget/removeEventListener
 * @function Chart.helpers.removeEvent
 * @deprecated since version 2.7.0
 * @todo remove at version 3
 * @private
 */
helpers.removeEvent = removeEventListener;


/***/ }),
/* 674 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* global window: false */


var defaults = __webpack_require__(20);
var Element = __webpack_require__(46);
var helpers = __webpack_require__(15);

defaults._set('global', {
	animation: {
		duration: 1000,
		easing: 'easeOutQuart',
		onProgress: helpers.noop,
		onComplete: helpers.noop
	}
});

module.exports = function(Chart) {

	Chart.Animation = Element.extend({
		chart: null, // the animation associated chart instance
		currentStep: 0, // the current animation step
		numSteps: 60, // default number of steps
		easing: '', // the easing to use for this animation
		render: null, // render function used by the animation service

		onAnimationProgress: null, // user specified callback to fire on each step of the animation
		onAnimationComplete: null, // user specified callback to fire when the animation finishes
	});

	Chart.animationService = {
		frameDuration: 17,
		animations: [],
		dropFrames: 0,
		request: null,

		/**
		 * @param {Chart} chart - The chart to animate.
		 * @param {Chart.Animation} animation - The animation that we will animate.
		 * @param {Number} duration - The animation duration in ms.
		 * @param {Boolean} lazy - if true, the chart is not marked as animating to enable more responsive interactions
		 */
		addAnimation: function(chart, animation, duration, lazy) {
			var animations = this.animations;
			var i, ilen;

			animation.chart = chart;

			if (!lazy) {
				chart.animating = true;
			}

			for (i = 0, ilen = animations.length; i < ilen; ++i) {
				if (animations[i].chart === chart) {
					animations[i] = animation;
					return;
				}
			}

			animations.push(animation);

			// If there are no animations queued, manually kickstart a digest, for lack of a better word
			if (animations.length === 1) {
				this.requestAnimationFrame();
			}
		},

		cancelAnimation: function(chart) {
			var index = helpers.findIndex(this.animations, function(animation) {
				return animation.chart === chart;
			});

			if (index !== -1) {
				this.animations.splice(index, 1);
				chart.animating = false;
			}
		},

		requestAnimationFrame: function() {
			var me = this;
			if (me.request === null) {
				// Skip animation frame requests until the active one is executed.
				// This can happen when processing mouse events, e.g. 'mousemove'
				// and 'mouseout' events will trigger multiple renders.
				me.request = helpers.requestAnimFrame.call(window, function() {
					me.request = null;
					me.startDigest();
				});
			}
		},

		/**
		 * @private
		 */
		startDigest: function() {
			var me = this;
			var startTime = Date.now();
			var framesToDrop = 0;

			if (me.dropFrames > 1) {
				framesToDrop = Math.floor(me.dropFrames);
				me.dropFrames = me.dropFrames % 1;
			}

			me.advance(1 + framesToDrop);

			var endTime = Date.now();

			me.dropFrames += (endTime - startTime) / me.frameDuration;

			// Do we have more stuff to animate?
			if (me.animations.length > 0) {
				me.requestAnimationFrame();
			}
		},

		/**
		 * @private
		 */
		advance: function(count) {
			var animations = this.animations;
			var animation, chart;
			var i = 0;

			while (i < animations.length) {
				animation = animations[i];
				chart = animation.chart;

				animation.currentStep = (animation.currentStep || 0) + count;
				animation.currentStep = Math.min(animation.currentStep, animation.numSteps);

				helpers.callback(animation.render, [chart, animation], chart);
				helpers.callback(animation.onAnimationProgress, [animation], chart);

				if (animation.currentStep >= animation.numSteps) {
					helpers.callback(animation.onAnimationComplete, [animation], chart);
					chart.animating = false;
					animations.splice(i, 1);
				} else {
					++i;
				}
			}
		}
	};

	/**
	 * Provided for backward compatibility, use Chart.Animation instead
	 * @prop Chart.Animation#animationObject
	 * @deprecated since version 2.6.0
	 * @todo remove at version 3
	 */
	Object.defineProperty(Chart.Animation.prototype, 'animationObject', {
		get: function() {
			return this;
		}
	});

	/**
	 * Provided for backward compatibility, use Chart.Animation#chart instead
	 * @prop Chart.Animation#chartInstance
	 * @deprecated since version 2.6.0
	 * @todo remove at version 3
	 */
	Object.defineProperty(Chart.Animation.prototype, 'chartInstance', {
		get: function() {
			return this.chart;
		},
		set: function(value) {
			this.chart = value;
		}
	});

};


/***/ }),
/* 675 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var defaults = __webpack_require__(20);
var helpers = __webpack_require__(15);
var Interaction = __webpack_require__(291);
var layouts = __webpack_require__(106);
var platform = __webpack_require__(292);
var plugins = __webpack_require__(293);

module.exports = function(Chart) {

	// Create a dictionary of chart types, to allow for extension of existing types
	Chart.types = {};

	// Store a reference to each instance - allowing us to globally resize chart instances on window resize.
	// Destroy method on the chart will remove the instance of the chart from this reference.
	Chart.instances = {};

	// Controllers available for dataset visualization eg. bar, line, slice, etc.
	Chart.controllers = {};

	/**
	 * Initializes the given config with global and chart default values.
	 */
	function initConfig(config) {
		config = config || {};

		// Do NOT use configMerge() for the data object because this method merges arrays
		// and so would change references to labels and datasets, preventing data updates.
		var data = config.data = config.data || {};
		data.datasets = data.datasets || [];
		data.labels = data.labels || [];

		config.options = helpers.configMerge(
			defaults.global,
			defaults[config.type],
			config.options || {});

		return config;
	}

	/**
	 * Updates the config of the chart
	 * @param chart {Chart} chart to update the options for
	 */
	function updateConfig(chart) {
		var newOptions = chart.options;

		helpers.each(chart.scales, function(scale) {
			layouts.removeBox(chart, scale);
		});

		newOptions = helpers.configMerge(
			Chart.defaults.global,
			Chart.defaults[chart.config.type],
			newOptions);

		chart.options = chart.config.options = newOptions;
		chart.ensureScalesHaveIDs();
		chart.buildOrUpdateScales();
		// Tooltip
		chart.tooltip._options = newOptions.tooltips;
		chart.tooltip.initialize();
	}

	function positionIsHorizontal(position) {
		return position === 'top' || position === 'bottom';
	}

	helpers.extend(Chart.prototype, /** @lends Chart */ {
		/**
		 * @private
		 */
		construct: function(item, config) {
			var me = this;

			config = initConfig(config);

			var context = platform.acquireContext(item, config);
			var canvas = context && context.canvas;
			var height = canvas && canvas.height;
			var width = canvas && canvas.width;

			me.id = helpers.uid();
			me.ctx = context;
			me.canvas = canvas;
			me.config = config;
			me.width = width;
			me.height = height;
			me.aspectRatio = height ? width / height : null;
			me.options = config.options;
			me._bufferedRender = false;

			/**
			 * Provided for backward compatibility, Chart and Chart.Controller have been merged,
			 * the "instance" still need to be defined since it might be called from plugins.
			 * @prop Chart#chart
			 * @deprecated since version 2.6.0
			 * @todo remove at version 3
			 * @private
			 */
			me.chart = me;
			me.controller = me; // chart.chart.controller #inception

			// Add the chart instance to the global namespace
			Chart.instances[me.id] = me;

			// Define alias to the config data: `chart.data === chart.config.data`
			Object.defineProperty(me, 'data', {
				get: function() {
					return me.config.data;
				},
				set: function(value) {
					me.config.data = value;
				}
			});

			if (!context || !canvas) {
				// The given item is not a compatible context2d element, let's return before finalizing
				// the chart initialization but after setting basic chart / controller properties that
				// can help to figure out that the chart is not valid (e.g chart.canvas !== null);
				// https://github.com/chartjs/Chart.js/issues/2807
				console.error("Failed to create chart: can't acquire context from the given item");
				return;
			}

			me.initialize();
			me.update();
		},

		/**
		 * @private
		 */
		initialize: function() {
			var me = this;

			// Before init plugin notification
			plugins.notify(me, 'beforeInit');

			helpers.retinaScale(me, me.options.devicePixelRatio);

			me.bindEvents();

			if (me.options.responsive) {
				// Initial resize before chart draws (must be silent to preserve initial animations).
				me.resize(true);
			}

			// Make sure scales have IDs and are built before we build any controllers.
			me.ensureScalesHaveIDs();
			me.buildOrUpdateScales();
			me.initToolTip();

			// After init plugin notification
			plugins.notify(me, 'afterInit');

			return me;
		},

		clear: function() {
			helpers.canvas.clear(this);
			return this;
		},

		stop: function() {
			// Stops any current animation loop occurring
			Chart.animationService.cancelAnimation(this);
			return this;
		},

		resize: function(silent) {
			var me = this;
			var options = me.options;
			var canvas = me.canvas;
			var aspectRatio = (options.maintainAspectRatio && me.aspectRatio) || null;

			// the canvas render width and height will be casted to integers so make sure that
			// the canvas display style uses the same integer values to avoid blurring effect.

			// Set to 0 instead of canvas.size because the size defaults to 300x150 if the element is collased
			var newWidth = Math.max(0, Math.floor(helpers.getMaximumWidth(canvas)));
			var newHeight = Math.max(0, Math.floor(aspectRatio ? newWidth / aspectRatio : helpers.getMaximumHeight(canvas)));

			if (me.width === newWidth && me.height === newHeight) {
				return;
			}

			canvas.width = me.width = newWidth;
			canvas.height = me.height = newHeight;
			canvas.style.width = newWidth + 'px';
			canvas.style.height = newHeight + 'px';

			helpers.retinaScale(me, options.devicePixelRatio);

			if (!silent) {
				// Notify any plugins about the resize
				var newSize = {width: newWidth, height: newHeight};
				plugins.notify(me, 'resize', [newSize]);

				// Notify of resize
				if (me.options.onResize) {
					me.options.onResize(me, newSize);
				}

				me.stop();
				me.update(me.options.responsiveAnimationDuration);
			}
		},

		ensureScalesHaveIDs: function() {
			var options = this.options;
			var scalesOptions = options.scales || {};
			var scaleOptions = options.scale;

			helpers.each(scalesOptions.xAxes, function(xAxisOptions, index) {
				xAxisOptions.id = xAxisOptions.id || ('x-axis-' + index);
			});

			helpers.each(scalesOptions.yAxes, function(yAxisOptions, index) {
				yAxisOptions.id = yAxisOptions.id || ('y-axis-' + index);
			});

			if (scaleOptions) {
				scaleOptions.id = scaleOptions.id || 'scale';
			}
		},

		/**
		 * Builds a map of scale ID to scale object for future lookup.
		 */
		buildOrUpdateScales: function() {
			var me = this;
			var options = me.options;
			var scales = me.scales || {};
			var items = [];
			var updated = Object.keys(scales).reduce(function(obj, id) {
				obj[id] = false;
				return obj;
			}, {});

			if (options.scales) {
				items = items.concat(
					(options.scales.xAxes || []).map(function(xAxisOptions) {
						return {options: xAxisOptions, dtype: 'category', dposition: 'bottom'};
					}),
					(options.scales.yAxes || []).map(function(yAxisOptions) {
						return {options: yAxisOptions, dtype: 'linear', dposition: 'left'};
					})
				);
			}

			if (options.scale) {
				items.push({
					options: options.scale,
					dtype: 'radialLinear',
					isDefault: true,
					dposition: 'chartArea'
				});
			}

			helpers.each(items, function(item) {
				var scaleOptions = item.options;
				var id = scaleOptions.id;
				var scaleType = helpers.valueOrDefault(scaleOptions.type, item.dtype);

				if (positionIsHorizontal(scaleOptions.position) !== positionIsHorizontal(item.dposition)) {
					scaleOptions.position = item.dposition;
				}

				updated[id] = true;
				var scale = null;
				if (id in scales && scales[id].type === scaleType) {
					scale = scales[id];
					scale.options = scaleOptions;
					scale.ctx = me.ctx;
					scale.chart = me;
				} else {
					var scaleClass = Chart.scaleService.getScaleConstructor(scaleType);
					if (!scaleClass) {
						return;
					}
					scale = new scaleClass({
						id: id,
						type: scaleType,
						options: scaleOptions,
						ctx: me.ctx,
						chart: me
					});
					scales[scale.id] = scale;
				}

				scale.mergeTicksOptions();

				// TODO(SB): I think we should be able to remove this custom case (options.scale)
				// and consider it as a regular scale part of the "scales"" map only! This would
				// make the logic easier and remove some useless? custom code.
				if (item.isDefault) {
					me.scale = scale;
				}
			});
			// clear up discarded scales
			helpers.each(updated, function(hasUpdated, id) {
				if (!hasUpdated) {
					delete scales[id];
				}
			});

			me.scales = scales;

			Chart.scaleService.addScalesToLayout(this);
		},

		buildOrUpdateControllers: function() {
			var me = this;
			var types = [];
			var newControllers = [];

			helpers.each(me.data.datasets, function(dataset, datasetIndex) {
				var meta = me.getDatasetMeta(datasetIndex);
				var type = dataset.type || me.config.type;

				if (meta.type && meta.type !== type) {
					me.destroyDatasetMeta(datasetIndex);
					meta = me.getDatasetMeta(datasetIndex);
				}
				meta.type = type;

				types.push(meta.type);

				if (meta.controller) {
					meta.controller.updateIndex(datasetIndex);
					meta.controller.linkScales();
				} else {
					var ControllerClass = Chart.controllers[meta.type];
					if (ControllerClass === undefined) {
						throw new Error('"' + meta.type + '" is not a chart type.');
					}

					meta.controller = new ControllerClass(me, datasetIndex);
					newControllers.push(meta.controller);
				}
			}, me);

			return newControllers;
		},

		/**
		 * Reset the elements of all datasets
		 * @private
		 */
		resetElements: function() {
			var me = this;
			helpers.each(me.data.datasets, function(dataset, datasetIndex) {
				me.getDatasetMeta(datasetIndex).controller.reset();
			}, me);
		},

		/**
		* Resets the chart back to it's state before the initial animation
		*/
		reset: function() {
			this.resetElements();
			this.tooltip.initialize();
		},

		update: function(config) {
			var me = this;

			if (!config || typeof config !== 'object') {
				// backwards compatibility
				config = {
					duration: config,
					lazy: arguments[1]
				};
			}

			updateConfig(me);

			// plugins options references might have change, let's invalidate the cache
			// https://github.com/chartjs/Chart.js/issues/5111#issuecomment-355934167
			plugins._invalidate(me);

			if (plugins.notify(me, 'beforeUpdate') === false) {
				return;
			}

			// In case the entire data object changed
			me.tooltip._data = me.data;

			// Make sure dataset controllers are updated and new controllers are reset
			var newControllers = me.buildOrUpdateControllers();

			// Make sure all dataset controllers have correct meta data counts
			helpers.each(me.data.datasets, function(dataset, datasetIndex) {
				me.getDatasetMeta(datasetIndex).controller.buildOrUpdateElements();
			}, me);

			me.updateLayout();

			// Can only reset the new controllers after the scales have been updated
			if (me.options.animation && me.options.animation.duration) {
				helpers.each(newControllers, function(controller) {
					controller.reset();
				});
			}

			me.updateDatasets();

			// Need to reset tooltip in case it is displayed with elements that are removed
			// after update.
			me.tooltip.initialize();

			// Last active contains items that were previously in the tooltip.
			// When we reset the tooltip, we need to clear it
			me.lastActive = [];

			// Do this before render so that any plugins that need final scale updates can use it
			plugins.notify(me, 'afterUpdate');

			if (me._bufferedRender) {
				me._bufferedRequest = {
					duration: config.duration,
					easing: config.easing,
					lazy: config.lazy
				};
			} else {
				me.render(config);
			}
		},

		/**
		 * Updates the chart layout unless a plugin returns `false` to the `beforeLayout`
		 * hook, in which case, plugins will not be called on `afterLayout`.
		 * @private
		 */
		updateLayout: function() {
			var me = this;

			if (plugins.notify(me, 'beforeLayout') === false) {
				return;
			}

			layouts.update(this, this.width, this.height);

			/**
			 * Provided for backward compatibility, use `afterLayout` instead.
			 * @method IPlugin#afterScaleUpdate
			 * @deprecated since version 2.5.0
			 * @todo remove at version 3
			 * @private
			 */
			plugins.notify(me, 'afterScaleUpdate');
			plugins.notify(me, 'afterLayout');
		},

		/**
		 * Updates all datasets unless a plugin returns `false` to the `beforeDatasetsUpdate`
		 * hook, in which case, plugins will not be called on `afterDatasetsUpdate`.
		 * @private
		 */
		updateDatasets: function() {
			var me = this;

			if (plugins.notify(me, 'beforeDatasetsUpdate') === false) {
				return;
			}

			for (var i = 0, ilen = me.data.datasets.length; i < ilen; ++i) {
				me.updateDataset(i);
			}

			plugins.notify(me, 'afterDatasetsUpdate');
		},

		/**
		 * Updates dataset at index unless a plugin returns `false` to the `beforeDatasetUpdate`
		 * hook, in which case, plugins will not be called on `afterDatasetUpdate`.
		 * @private
		 */
		updateDataset: function(index) {
			var me = this;
			var meta = me.getDatasetMeta(index);
			var args = {
				meta: meta,
				index: index
			};

			if (plugins.notify(me, 'beforeDatasetUpdate', [args]) === false) {
				return;
			}

			meta.controller.update();

			plugins.notify(me, 'afterDatasetUpdate', [args]);
		},

		render: function(config) {
			var me = this;

			if (!config || typeof config !== 'object') {
				// backwards compatibility
				config = {
					duration: config,
					lazy: arguments[1]
				};
			}

			var duration = config.duration;
			var lazy = config.lazy;

			if (plugins.notify(me, 'beforeRender') === false) {
				return;
			}

			var animationOptions = me.options.animation;
			var onComplete = function(animation) {
				plugins.notify(me, 'afterRender');
				helpers.callback(animationOptions && animationOptions.onComplete, [animation], me);
			};

			if (animationOptions && ((typeof duration !== 'undefined' && duration !== 0) || (typeof duration === 'undefined' && animationOptions.duration !== 0))) {
				var animation = new Chart.Animation({
					numSteps: (duration || animationOptions.duration) / 16.66, // 60 fps
					easing: config.easing || animationOptions.easing,

					render: function(chart, animationObject) {
						var easingFunction = helpers.easing.effects[animationObject.easing];
						var currentStep = animationObject.currentStep;
						var stepDecimal = currentStep / animationObject.numSteps;

						chart.draw(easingFunction(stepDecimal), stepDecimal, currentStep);
					},

					onAnimationProgress: animationOptions.onProgress,
					onAnimationComplete: onComplete
				});

				Chart.animationService.addAnimation(me, animation, duration, lazy);
			} else {
				me.draw();

				// See https://github.com/chartjs/Chart.js/issues/3781
				onComplete(new Chart.Animation({numSteps: 0, chart: me}));
			}

			return me;
		},

		draw: function(easingValue) {
			var me = this;

			me.clear();

			if (helpers.isNullOrUndef(easingValue)) {
				easingValue = 1;
			}

			me.transition(easingValue);

			if (plugins.notify(me, 'beforeDraw', [easingValue]) === false) {
				return;
			}

			// Draw all the scales
			helpers.each(me.boxes, function(box) {
				box.draw(me.chartArea);
			}, me);

			if (me.scale) {
				me.scale.draw();
			}

			me.drawDatasets(easingValue);
			me._drawTooltip(easingValue);

			plugins.notify(me, 'afterDraw', [easingValue]);
		},

		/**
		 * @private
		 */
		transition: function(easingValue) {
			var me = this;

			for (var i = 0, ilen = (me.data.datasets || []).length; i < ilen; ++i) {
				if (me.isDatasetVisible(i)) {
					me.getDatasetMeta(i).controller.transition(easingValue);
				}
			}

			me.tooltip.transition(easingValue);
		},

		/**
		 * Draws all datasets unless a plugin returns `false` to the `beforeDatasetsDraw`
		 * hook, in which case, plugins will not be called on `afterDatasetsDraw`.
		 * @private
		 */
		drawDatasets: function(easingValue) {
			var me = this;

			if (plugins.notify(me, 'beforeDatasetsDraw', [easingValue]) === false) {
				return;
			}

			// Draw datasets reversed to support proper line stacking
			for (var i = (me.data.datasets || []).length - 1; i >= 0; --i) {
				if (me.isDatasetVisible(i)) {
					me.drawDataset(i, easingValue);
				}
			}

			plugins.notify(me, 'afterDatasetsDraw', [easingValue]);
		},

		/**
		 * Draws dataset at index unless a plugin returns `false` to the `beforeDatasetDraw`
		 * hook, in which case, plugins will not be called on `afterDatasetDraw`.
		 * @private
		 */
		drawDataset: function(index, easingValue) {
			var me = this;
			var meta = me.getDatasetMeta(index);
			var args = {
				meta: meta,
				index: index,
				easingValue: easingValue
			};

			if (plugins.notify(me, 'beforeDatasetDraw', [args]) === false) {
				return;
			}

			meta.controller.draw(easingValue);

			plugins.notify(me, 'afterDatasetDraw', [args]);
		},

		/**
		 * Draws tooltip unless a plugin returns `false` to the `beforeTooltipDraw`
		 * hook, in which case, plugins will not be called on `afterTooltipDraw`.
		 * @private
		 */
		_drawTooltip: function(easingValue) {
			var me = this;
			var tooltip = me.tooltip;
			var args = {
				tooltip: tooltip,
				easingValue: easingValue
			};

			if (plugins.notify(me, 'beforeTooltipDraw', [args]) === false) {
				return;
			}

			tooltip.draw();

			plugins.notify(me, 'afterTooltipDraw', [args]);
		},

		// Get the single element that was clicked on
		// @return : An object containing the dataset index and element index of the matching element. Also contains the rectangle that was draw
		getElementAtEvent: function(e) {
			return Interaction.modes.single(this, e);
		},

		getElementsAtEvent: function(e) {
			return Interaction.modes.label(this, e, {intersect: true});
		},

		getElementsAtXAxis: function(e) {
			return Interaction.modes['x-axis'](this, e, {intersect: true});
		},

		getElementsAtEventForMode: function(e, mode, options) {
			var method = Interaction.modes[mode];
			if (typeof method === 'function') {
				return method(this, e, options);
			}

			return [];
		},

		getDatasetAtEvent: function(e) {
			return Interaction.modes.dataset(this, e, {intersect: true});
		},

		getDatasetMeta: function(datasetIndex) {
			var me = this;
			var dataset = me.data.datasets[datasetIndex];
			if (!dataset._meta) {
				dataset._meta = {};
			}

			var meta = dataset._meta[me.id];
			if (!meta) {
				meta = dataset._meta[me.id] = {
					type: null,
					data: [],
					dataset: null,
					controller: null,
					hidden: null,			// See isDatasetVisible() comment
					xAxisID: null,
					yAxisID: null
				};
			}

			return meta;
		},

		getVisibleDatasetCount: function() {
			var count = 0;
			for (var i = 0, ilen = this.data.datasets.length; i < ilen; ++i) {
				if (this.isDatasetVisible(i)) {
					count++;
				}
			}
			return count;
		},

		isDatasetVisible: function(datasetIndex) {
			var meta = this.getDatasetMeta(datasetIndex);

			// meta.hidden is a per chart dataset hidden flag override with 3 states: if true or false,
			// the dataset.hidden value is ignored, else if null, the dataset hidden state is returned.
			return typeof meta.hidden === 'boolean' ? !meta.hidden : !this.data.datasets[datasetIndex].hidden;
		},

		generateLegend: function() {
			return this.options.legendCallback(this);
		},

		/**
		 * @private
		 */
		destroyDatasetMeta: function(datasetIndex) {
			var id = this.id;
			var dataset = this.data.datasets[datasetIndex];
			var meta = dataset._meta && dataset._meta[id];

			if (meta) {
				meta.controller.destroy();
				delete dataset._meta[id];
			}
		},

		destroy: function() {
			var me = this;
			var canvas = me.canvas;
			var i, ilen;

			me.stop();

			// dataset controllers need to cleanup associated data
			for (i = 0, ilen = me.data.datasets.length; i < ilen; ++i) {
				me.destroyDatasetMeta(i);
			}

			if (canvas) {
				me.unbindEvents();
				helpers.canvas.clear(me);
				platform.releaseContext(me.ctx);
				me.canvas = null;
				me.ctx = null;
			}

			plugins.notify(me, 'destroy');

			delete Chart.instances[me.id];
		},

		toBase64Image: function() {
			return this.canvas.toDataURL.apply(this.canvas, arguments);
		},

		initToolTip: function() {
			var me = this;
			me.tooltip = new Chart.Tooltip({
				_chart: me,
				_chartInstance: me, // deprecated, backward compatibility
				_data: me.data,
				_options: me.options.tooltips
			}, me);
		},

		/**
		 * @private
		 */
		bindEvents: function() {
			var me = this;
			var listeners = me._listeners = {};
			var listener = function() {
				me.eventHandler.apply(me, arguments);
			};

			helpers.each(me.options.events, function(type) {
				platform.addEventListener(me, type, listener);
				listeners[type] = listener;
			});

			// Elements used to detect size change should not be injected for non responsive charts.
			// See https://github.com/chartjs/Chart.js/issues/2210
			if (me.options.responsive) {
				listener = function() {
					me.resize();
				};

				platform.addEventListener(me, 'resize', listener);
				listeners.resize = listener;
			}
		},

		/**
		 * @private
		 */
		unbindEvents: function() {
			var me = this;
			var listeners = me._listeners;
			if (!listeners) {
				return;
			}

			delete me._listeners;
			helpers.each(listeners, function(listener, type) {
				platform.removeEventListener(me, type, listener);
			});
		},

		updateHoverStyle: function(elements, mode, enabled) {
			var method = enabled ? 'setHoverStyle' : 'removeHoverStyle';
			var element, i, ilen;

			for (i = 0, ilen = elements.length; i < ilen; ++i) {
				element = elements[i];
				if (element) {
					this.getDatasetMeta(element._datasetIndex).controller[method](element);
				}
			}
		},

		/**
		 * @private
		 */
		eventHandler: function(e) {
			var me = this;
			var tooltip = me.tooltip;

			if (plugins.notify(me, 'beforeEvent', [e]) === false) {
				return;
			}

			// Buffer any update calls so that renders do not occur
			me._bufferedRender = true;
			me._bufferedRequest = null;

			var changed = me.handleEvent(e);
			// for smooth tooltip animations issue #4989
			// the tooltip should be the source of change
			// Animation check workaround:
			// tooltip._start will be null when tooltip isn't animating
			if (tooltip) {
				changed = tooltip._start
					? tooltip.handleEvent(e)
					: changed | tooltip.handleEvent(e);
			}

			plugins.notify(me, 'afterEvent', [e]);

			var bufferedRequest = me._bufferedRequest;
			if (bufferedRequest) {
				// If we have an update that was triggered, we need to do a normal render
				me.render(bufferedRequest);
			} else if (changed && !me.animating) {
				// If entering, leaving, or changing elements, animate the change via pivot
				me.stop();

				// We only need to render at this point. Updating will cause scales to be
				// recomputed generating flicker & using more memory than necessary.
				me.render(me.options.hover.animationDuration, true);
			}

			me._bufferedRender = false;
			me._bufferedRequest = null;

			return me;
		},

		/**
		 * Handle an event
		 * @private
		 * @param {IEvent} event the event to handle
		 * @return {Boolean} true if the chart needs to re-render
		 */
		handleEvent: function(e) {
			var me = this;
			var options = me.options || {};
			var hoverOptions = options.hover;
			var changed = false;

			me.lastActive = me.lastActive || [];

			// Find Active Elements for hover and tooltips
			if (e.type === 'mouseout') {
				me.active = [];
			} else {
				me.active = me.getElementsAtEventForMode(e, hoverOptions.mode, hoverOptions);
			}

			// Invoke onHover hook
			// Need to call with native event here to not break backwards compatibility
			helpers.callback(options.onHover || options.hover.onHover, [e.native, me.active], me);

			if (e.type === 'mouseup' || e.type === 'click') {
				if (options.onClick) {
					// Use e.native here for backwards compatibility
					options.onClick.call(me, e.native, me.active);
				}
			}

			// Remove styling for last active (even if it may still be active)
			if (me.lastActive.length) {
				me.updateHoverStyle(me.lastActive, hoverOptions.mode, false);
			}

			// Built in hover styling
			if (me.active.length && hoverOptions.mode) {
				me.updateHoverStyle(me.active, hoverOptions.mode, true);
			}

			changed = !helpers.arrayEquals(me.active, me.lastActive);

			// Remember Last Actives
			me.lastActive = me.active;

			return changed;
		}
	});

	/**
	 * Provided for backward compatibility, use Chart instead.
	 * @class Chart.Controller
	 * @deprecated since version 2.6.0
	 * @todo remove at version 3
	 * @private
	 */
	Chart.Controller = Chart;
};


/***/ }),
/* 676 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var helpers = __webpack_require__(15);

module.exports = function(Chart) {

	var arrayEvents = ['push', 'pop', 'shift', 'splice', 'unshift'];

	/**
	 * Hooks the array methods that add or remove values ('push', pop', 'shift', 'splice',
	 * 'unshift') and notify the listener AFTER the array has been altered. Listeners are
	 * called on the 'onData*' callbacks (e.g. onDataPush, etc.) with same arguments.
	 */
	function listenArrayEvents(array, listener) {
		if (array._chartjs) {
			array._chartjs.listeners.push(listener);
			return;
		}

		Object.defineProperty(array, '_chartjs', {
			configurable: true,
			enumerable: false,
			value: {
				listeners: [listener]
			}
		});

		arrayEvents.forEach(function(key) {
			var method = 'onData' + key.charAt(0).toUpperCase() + key.slice(1);
			var base = array[key];

			Object.defineProperty(array, key, {
				configurable: true,
				enumerable: false,
				value: function() {
					var args = Array.prototype.slice.call(arguments);
					var res = base.apply(this, args);

					helpers.each(array._chartjs.listeners, function(object) {
						if (typeof object[method] === 'function') {
							object[method].apply(object, args);
						}
					});

					return res;
				}
			});
		});
	}

	/**
	 * Removes the given array event listener and cleanup extra attached properties (such as
	 * the _chartjs stub and overridden methods) if array doesn't have any more listeners.
	 */
	function unlistenArrayEvents(array, listener) {
		var stub = array._chartjs;
		if (!stub) {
			return;
		}

		var listeners = stub.listeners;
		var index = listeners.indexOf(listener);
		if (index !== -1) {
			listeners.splice(index, 1);
		}

		if (listeners.length > 0) {
			return;
		}

		arrayEvents.forEach(function(key) {
			delete array[key];
		});

		delete array._chartjs;
	}

	// Base class for all dataset controllers (line, bar, etc)
	Chart.DatasetController = function(chart, datasetIndex) {
		this.initialize(chart, datasetIndex);
	};

	helpers.extend(Chart.DatasetController.prototype, {

		/**
		 * Element type used to generate a meta dataset (e.g. Chart.element.Line).
		 * @type {Chart.core.element}
		 */
		datasetElementType: null,

		/**
		 * Element type used to generate a meta data (e.g. Chart.element.Point).
		 * @type {Chart.core.element}
		 */
		dataElementType: null,

		initialize: function(chart, datasetIndex) {
			var me = this;
			me.chart = chart;
			me.index = datasetIndex;
			me.linkScales();
			me.addElements();
		},

		updateIndex: function(datasetIndex) {
			this.index = datasetIndex;
		},

		linkScales: function() {
			var me = this;
			var meta = me.getMeta();
			var dataset = me.getDataset();

			if (meta.xAxisID === null || !(meta.xAxisID in me.chart.scales)) {
				meta.xAxisID = dataset.xAxisID || me.chart.options.scales.xAxes[0].id;
			}
			if (meta.yAxisID === null || !(meta.yAxisID in me.chart.scales)) {
				meta.yAxisID = dataset.yAxisID || me.chart.options.scales.yAxes[0].id;
			}
		},

		getDataset: function() {
			return this.chart.data.datasets[this.index];
		},

		getMeta: function() {
			return this.chart.getDatasetMeta(this.index);
		},

		getScaleForId: function(scaleID) {
			return this.chart.scales[scaleID];
		},

		reset: function() {
			this.update(true);
		},

		/**
		 * @private
		 */
		destroy: function() {
			if (this._data) {
				unlistenArrayEvents(this._data, this);
			}
		},

		createMetaDataset: function() {
			var me = this;
			var type = me.datasetElementType;
			return type && new type({
				_chart: me.chart,
				_datasetIndex: me.index
			});
		},

		createMetaData: function(index) {
			var me = this;
			var type = me.dataElementType;
			return type && new type({
				_chart: me.chart,
				_datasetIndex: me.index,
				_index: index
			});
		},

		addElements: function() {
			var me = this;
			var meta = me.getMeta();
			var data = me.getDataset().data || [];
			var metaData = meta.data;
			var i, ilen;

			for (i = 0, ilen = data.length; i < ilen; ++i) {
				metaData[i] = metaData[i] || me.createMetaData(i);
			}

			meta.dataset = meta.dataset || me.createMetaDataset();
		},

		addElementAndReset: function(index) {
			var element = this.createMetaData(index);
			this.getMeta().data.splice(index, 0, element);
			this.updateElement(element, index, true);
		},

		buildOrUpdateElements: function() {
			var me = this;
			var dataset = me.getDataset();
			var data = dataset.data || (dataset.data = []);

			// In order to correctly handle data addition/deletion animation (an thus simulate
			// real-time charts), we need to monitor these data modifications and synchronize
			// the internal meta data accordingly.
			if (me._data !== data) {
				if (me._data) {
					// This case happens when the user replaced the data array instance.
					unlistenArrayEvents(me._data, me);
				}

				listenArrayEvents(data, me);
				me._data = data;
			}

			// Re-sync meta data in case the user replaced the data array or if we missed
			// any updates and so make sure that we handle number of datapoints changing.
			me.resyncElements();
		},

		update: helpers.noop,

		transition: function(easingValue) {
			var meta = this.getMeta();
			var elements = meta.data || [];
			var ilen = elements.length;
			var i = 0;

			for (; i < ilen; ++i) {
				elements[i].transition(easingValue);
			}

			if (meta.dataset) {
				meta.dataset.transition(easingValue);
			}
		},

		draw: function() {
			var meta = this.getMeta();
			var elements = meta.data || [];
			var ilen = elements.length;
			var i = 0;

			if (meta.dataset) {
				meta.dataset.draw();
			}

			for (; i < ilen; ++i) {
				elements[i].draw();
			}
		},

		removeHoverStyle: function(element, elementOpts) {
			var dataset = this.chart.data.datasets[element._datasetIndex];
			var index = element._index;
			var custom = element.custom || {};
			var valueOrDefault = helpers.valueAtIndexOrDefault;
			var model = element._model;

			model.backgroundColor = custom.backgroundColor ? custom.backgroundColor : valueOrDefault(dataset.backgroundColor, index, elementOpts.backgroundColor);
			model.borderColor = custom.borderColor ? custom.borderColor : valueOrDefault(dataset.borderColor, index, elementOpts.borderColor);
			model.borderWidth = custom.borderWidth ? custom.borderWidth : valueOrDefault(dataset.borderWidth, index, elementOpts.borderWidth);
		},

		setHoverStyle: function(element) {
			var dataset = this.chart.data.datasets[element._datasetIndex];
			var index = element._index;
			var custom = element.custom || {};
			var valueOrDefault = helpers.valueAtIndexOrDefault;
			var getHoverColor = helpers.getHoverColor;
			var model = element._model;

			model.backgroundColor = custom.hoverBackgroundColor ? custom.hoverBackgroundColor : valueOrDefault(dataset.hoverBackgroundColor, index, getHoverColor(model.backgroundColor));
			model.borderColor = custom.hoverBorderColor ? custom.hoverBorderColor : valueOrDefault(dataset.hoverBorderColor, index, getHoverColor(model.borderColor));
			model.borderWidth = custom.hoverBorderWidth ? custom.hoverBorderWidth : valueOrDefault(dataset.hoverBorderWidth, index, model.borderWidth);
		},

		/**
		 * @private
		 */
		resyncElements: function() {
			var me = this;
			var meta = me.getMeta();
			var data = me.getDataset().data;
			var numMeta = meta.data.length;
			var numData = data.length;

			if (numData < numMeta) {
				meta.data.splice(numData, numMeta - numData);
			} else if (numData > numMeta) {
				me.insertElements(numMeta, numData - numMeta);
			}
		},

		/**
		 * @private
		 */
		insertElements: function(start, count) {
			for (var i = 0; i < count; ++i) {
				this.addElementAndReset(start + i);
			}
		},

		/**
		 * @private
		 */
		onDataPush: function() {
			this.insertElements(this.getDataset().data.length - 1, arguments.length);
		},

		/**
		 * @private
		 */
		onDataPop: function() {
			this.getMeta().data.pop();
		},

		/**
		 * @private
		 */
		onDataShift: function() {
			this.getMeta().data.shift();
		},

		/**
		 * @private
		 */
		onDataSplice: function(start, count) {
			this.getMeta().data.splice(start, count);
			this.insertElements(start, arguments.length - 2);
		},

		/**
		 * @private
		 */
		onDataUnshift: function() {
			this.insertElements(0, arguments.length);
		}
	});

	Chart.DatasetController.extend = helpers.inherits;
};


/***/ }),
/* 677 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var defaults = __webpack_require__(20);
var helpers = __webpack_require__(15);
var layouts = __webpack_require__(106);

module.exports = function(Chart) {

	Chart.scaleService = {
		// Scale registration object. Extensions can register new scale types (such as log or DB scales) and then
		// use the new chart options to grab the correct scale
		constructors: {},
		// Use a registration function so that we can move to an ES6 map when we no longer need to support
		// old browsers

		// Scale config defaults
		defaults: {},
		registerScaleType: function(type, scaleConstructor, scaleDefaults) {
			this.constructors[type] = scaleConstructor;
			this.defaults[type] = helpers.clone(scaleDefaults);
		},
		getScaleConstructor: function(type) {
			return this.constructors.hasOwnProperty(type) ? this.constructors[type] : undefined;
		},
		getScaleDefaults: function(type) {
			// Return the scale defaults merged with the global settings so that we always use the latest ones
			return this.defaults.hasOwnProperty(type) ? helpers.merge({}, [defaults.scale, this.defaults[type]]) : {};
		},
		updateScaleDefaults: function(type, additions) {
			var me = this;
			if (me.defaults.hasOwnProperty(type)) {
				me.defaults[type] = helpers.extend(me.defaults[type], additions);
			}
		},
		addScalesToLayout: function(chart) {
			// Adds each scale to the chart.boxes array to be sized accordingly
			helpers.each(chart.scales, function(scale) {
				// Set ILayoutItem parameters for backwards compatibility
				scale.fullWidth = scale.options.fullWidth;
				scale.position = scale.options.position;
				scale.weight = scale.options.weight;
				layouts.addBox(chart, scale);
			});
		}
	};
};


/***/ }),
/* 678 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var defaults = __webpack_require__(20);
var Element = __webpack_require__(46);
var helpers = __webpack_require__(15);
var Ticks = __webpack_require__(107);

defaults._set('scale', {
	display: true,
	position: 'left',
	offset: false,

	// grid line settings
	gridLines: {
		display: true,
		color: 'rgba(0, 0, 0, 0.1)',
		lineWidth: 1,
		drawBorder: true,
		drawOnChartArea: true,
		drawTicks: true,
		tickMarkLength: 10,
		zeroLineWidth: 1,
		zeroLineColor: 'rgba(0,0,0,0.25)',
		zeroLineBorderDash: [],
		zeroLineBorderDashOffset: 0.0,
		offsetGridLines: false,
		borderDash: [],
		borderDashOffset: 0.0
	},

	// scale label
	scaleLabel: {
		// display property
		display: false,

		// actual label
		labelString: '',

		// line height
		lineHeight: 1.2,

		// top/bottom padding
		padding: {
			top: 4,
			bottom: 4
		}
	},

	// label settings
	ticks: {
		beginAtZero: false,
		minRotation: 0,
		maxRotation: 50,
		mirror: false,
		padding: 0,
		reverse: false,
		display: true,
		autoSkip: true,
		autoSkipPadding: 0,
		labelOffset: 0,
		// We pass through arrays to be rendered as multiline labels, we convert Others to strings here.
		callback: Ticks.formatters.values,
		minor: {},
		major: {}
	}
});

function labelsFromTicks(ticks) {
	var labels = [];
	var i, ilen;

	for (i = 0, ilen = ticks.length; i < ilen; ++i) {
		labels.push(ticks[i].label);
	}

	return labels;
}

function getLineValue(scale, index, offsetGridLines) {
	var lineValue = scale.getPixelForTick(index);

	if (offsetGridLines) {
		if (index === 0) {
			lineValue -= (scale.getPixelForTick(1) - lineValue) / 2;
		} else {
			lineValue -= (lineValue - scale.getPixelForTick(index - 1)) / 2;
		}
	}
	return lineValue;
}

module.exports = function(Chart) {

	function computeTextSize(context, tick, font) {
		return helpers.isArray(tick) ?
			helpers.longestText(context, font, tick) :
			context.measureText(tick).width;
	}

	function parseFontOptions(options) {
		var valueOrDefault = helpers.valueOrDefault;
		var globalDefaults = defaults.global;
		var size = valueOrDefault(options.fontSize, globalDefaults.defaultFontSize);
		var style = valueOrDefault(options.fontStyle, globalDefaults.defaultFontStyle);
		var family = valueOrDefault(options.fontFamily, globalDefaults.defaultFontFamily);

		return {
			size: size,
			style: style,
			family: family,
			font: helpers.fontString(size, style, family)
		};
	}

	function parseLineHeight(options) {
		return helpers.options.toLineHeight(
			helpers.valueOrDefault(options.lineHeight, 1.2),
			helpers.valueOrDefault(options.fontSize, defaults.global.defaultFontSize));
	}

	Chart.Scale = Element.extend({
		/**
		 * Get the padding needed for the scale
		 * @method getPadding
		 * @private
		 * @returns {Padding} the necessary padding
		 */
		getPadding: function() {
			var me = this;
			return {
				left: me.paddingLeft || 0,
				top: me.paddingTop || 0,
				right: me.paddingRight || 0,
				bottom: me.paddingBottom || 0
			};
		},

		/**
		 * Returns the scale tick objects ({label, major})
		 * @since 2.7
		 */
		getTicks: function() {
			return this._ticks;
		},

		// These methods are ordered by lifecyle. Utilities then follow.
		// Any function defined here is inherited by all scale types.
		// Any function can be extended by the scale type

		mergeTicksOptions: function() {
			var ticks = this.options.ticks;
			if (ticks.minor === false) {
				ticks.minor = {
					display: false
				};
			}
			if (ticks.major === false) {
				ticks.major = {
					display: false
				};
			}
			for (var key in ticks) {
				if (key !== 'major' && key !== 'minor') {
					if (typeof ticks.minor[key] === 'undefined') {
						ticks.minor[key] = ticks[key];
					}
					if (typeof ticks.major[key] === 'undefined') {
						ticks.major[key] = ticks[key];
					}
				}
			}
		},
		beforeUpdate: function() {
			helpers.callback(this.options.beforeUpdate, [this]);
		},
		update: function(maxWidth, maxHeight, margins) {
			var me = this;
			var i, ilen, labels, label, ticks, tick;

			// Update Lifecycle - Probably don't want to ever extend or overwrite this function ;)
			me.beforeUpdate();

			// Absorb the master measurements
			me.maxWidth = maxWidth;
			me.maxHeight = maxHeight;
			me.margins = helpers.extend({
				left: 0,
				right: 0,
				top: 0,
				bottom: 0
			}, margins);
			me.longestTextCache = me.longestTextCache || {};

			// Dimensions
			me.beforeSetDimensions();
			me.setDimensions();
			me.afterSetDimensions();

			// Data min/max
			me.beforeDataLimits();
			me.determineDataLimits();
			me.afterDataLimits();

			// Ticks - `this.ticks` is now DEPRECATED!
			// Internal ticks are now stored as objects in the PRIVATE `this._ticks` member
			// and must not be accessed directly from outside this class. `this.ticks` being
			// around for long time and not marked as private, we can't change its structure
			// without unexpected breaking changes. If you need to access the scale ticks,
			// use scale.getTicks() instead.

			me.beforeBuildTicks();

			// New implementations should return an array of objects but for BACKWARD COMPAT,
			// we still support no return (`this.ticks` internally set by calling this method).
			ticks = me.buildTicks() || [];

			me.afterBuildTicks();

			me.beforeTickToLabelConversion();

			// New implementations should return the formatted tick labels but for BACKWARD
			// COMPAT, we still support no return (`this.ticks` internally changed by calling
			// this method and supposed to contain only string values).
			labels = me.convertTicksToLabels(ticks) || me.ticks;

			me.afterTickToLabelConversion();

			me.ticks = labels;   // BACKWARD COMPATIBILITY

			// IMPORTANT: from this point, we consider that `this.ticks` will NEVER change!

			// BACKWARD COMPAT: synchronize `_ticks` with labels (so potentially `this.ticks`)
			for (i = 0, ilen = labels.length; i < ilen; ++i) {
				label = labels[i];
				tick = ticks[i];
				if (!tick) {
					ticks.push(tick = {
						label: label,
						major: false
					});
				} else {
					tick.label = label;
				}
			}

			me._ticks = ticks;

			// Tick Rotation
			me.beforeCalculateTickRotation();
			me.calculateTickRotation();
			me.afterCalculateTickRotation();
			// Fit
			me.beforeFit();
			me.fit();
			me.afterFit();
			//
			me.afterUpdate();

			return me.minSize;

		},
		afterUpdate: function() {
			helpers.callback(this.options.afterUpdate, [this]);
		},

		//

		beforeSetDimensions: function() {
			helpers.callback(this.options.beforeSetDimensions, [this]);
		},
		setDimensions: function() {
			var me = this;
			// Set the unconstrained dimension before label rotation
			if (me.isHorizontal()) {
				// Reset position before calculating rotation
				me.width = me.maxWidth;
				me.left = 0;
				me.right = me.width;
			} else {
				me.height = me.maxHeight;

				// Reset position before calculating rotation
				me.top = 0;
				me.bottom = me.height;
			}

			// Reset padding
			me.paddingLeft = 0;
			me.paddingTop = 0;
			me.paddingRight = 0;
			me.paddingBottom = 0;
		},
		afterSetDimensions: function() {
			helpers.callback(this.options.afterSetDimensions, [this]);
		},

		// Data limits
		beforeDataLimits: function() {
			helpers.callback(this.options.beforeDataLimits, [this]);
		},
		determineDataLimits: helpers.noop,
		afterDataLimits: function() {
			helpers.callback(this.options.afterDataLimits, [this]);
		},

		//
		beforeBuildTicks: function() {
			helpers.callback(this.options.beforeBuildTicks, [this]);
		},
		buildTicks: helpers.noop,
		afterBuildTicks: function() {
			helpers.callback(this.options.afterBuildTicks, [this]);
		},

		beforeTickToLabelConversion: function() {
			helpers.callback(this.options.beforeTickToLabelConversion, [this]);
		},
		convertTicksToLabels: function() {
			var me = this;
			// Convert ticks to strings
			var tickOpts = me.options.ticks;
			me.ticks = me.ticks.map(tickOpts.userCallback || tickOpts.callback, this);
		},
		afterTickToLabelConversion: function() {
			helpers.callback(this.options.afterTickToLabelConversion, [this]);
		},

		//

		beforeCalculateTickRotation: function() {
			helpers.callback(this.options.beforeCalculateTickRotation, [this]);
		},
		calculateTickRotation: function() {
			var me = this;
			var context = me.ctx;
			var tickOpts = me.options.ticks;
			var labels = labelsFromTicks(me._ticks);

			// Get the width of each grid by calculating the difference
			// between x offsets between 0 and 1.
			var tickFont = parseFontOptions(tickOpts);
			context.font = tickFont.font;

			var labelRotation = tickOpts.minRotation || 0;

			if (labels.length && me.options.display && me.isHorizontal()) {
				var originalLabelWidth = helpers.longestText(context, tickFont.font, labels, me.longestTextCache);
				var labelWidth = originalLabelWidth;
				var cosRotation, sinRotation;

				// Allow 3 pixels x2 padding either side for label readability
				var tickWidth = me.getPixelForTick(1) - me.getPixelForTick(0) - 6;

				// Max label rotation can be set or default to 90 - also act as a loop counter
				while (labelWidth > tickWidth && labelRotation < tickOpts.maxRotation) {
					var angleRadians = helpers.toRadians(labelRotation);
					cosRotation = Math.cos(angleRadians);
					sinRotation = Math.sin(angleRadians);

					if (sinRotation * originalLabelWidth > me.maxHeight) {
						// go back one step
						labelRotation--;
						break;
					}

					labelRotation++;
					labelWidth = cosRotation * originalLabelWidth;
				}
			}

			me.labelRotation = labelRotation;
		},
		afterCalculateTickRotation: function() {
			helpers.callback(this.options.afterCalculateTickRotation, [this]);
		},

		//

		beforeFit: function() {
			helpers.callback(this.options.beforeFit, [this]);
		},
		fit: function() {
			var me = this;
			// Reset
			var minSize = me.minSize = {
				width: 0,
				height: 0
			};

			var labels = labelsFromTicks(me._ticks);

			var opts = me.options;
			var tickOpts = opts.ticks;
			var scaleLabelOpts = opts.scaleLabel;
			var gridLineOpts = opts.gridLines;
			var display = opts.display;
			var isHorizontal = me.isHorizontal();

			var tickFont = parseFontOptions(tickOpts);
			var tickMarkLength = opts.gridLines.tickMarkLength;

			// Width
			if (isHorizontal) {
				// subtract the margins to line up with the chartArea if we are a full width scale
				minSize.width = me.isFullWidth() ? me.maxWidth - me.margins.left - me.margins.right : me.maxWidth;
			} else {
				minSize.width = display && gridLineOpts.drawTicks ? tickMarkLength : 0;
			}

			// height
			if (isHorizontal) {
				minSize.height = display && gridLineOpts.drawTicks ? tickMarkLength : 0;
			} else {
				minSize.height = me.maxHeight; // fill all the height
			}

			// Are we showing a title for the scale?
			if (scaleLabelOpts.display && display) {
				var scaleLabelLineHeight = parseLineHeight(scaleLabelOpts);
				var scaleLabelPadding = helpers.options.toPadding(scaleLabelOpts.padding);
				var deltaHeight = scaleLabelLineHeight + scaleLabelPadding.height;

				if (isHorizontal) {
					minSize.height += deltaHeight;
				} else {
					minSize.width += deltaHeight;
				}
			}

			// Don't bother fitting the ticks if we are not showing them
			if (tickOpts.display && display) {
				var largestTextWidth = helpers.longestText(me.ctx, tickFont.font, labels, me.longestTextCache);
				var tallestLabelHeightInLines = helpers.numberOfLabelLines(labels);
				var lineSpace = tickFont.size * 0.5;
				var tickPadding = me.options.ticks.padding;

				if (isHorizontal) {
					// A horizontal axis is more constrained by the height.
					me.longestLabelWidth = largestTextWidth;

					var angleRadians = helpers.toRadians(me.labelRotation);
					var cosRotation = Math.cos(angleRadians);
					var sinRotation = Math.sin(angleRadians);

					// TODO - improve this calculation
					var labelHeight = (sinRotation * largestTextWidth)
						+ (tickFont.size * tallestLabelHeightInLines)
						+ (lineSpace * (tallestLabelHeightInLines - 1))
						+ lineSpace; // padding

					minSize.height = Math.min(me.maxHeight, minSize.height + labelHeight + tickPadding);

					me.ctx.font = tickFont.font;
					var firstLabelWidth = computeTextSize(me.ctx, labels[0], tickFont.font);
					var lastLabelWidth = computeTextSize(me.ctx, labels[labels.length - 1], tickFont.font);

					// Ensure that our ticks are always inside the canvas. When rotated, ticks are right aligned
					// which means that the right padding is dominated by the font height
					if (me.labelRotation !== 0) {
						me.paddingLeft = opts.position === 'bottom' ? (cosRotation * firstLabelWidth) + 3 : (cosRotation * lineSpace) + 3; // add 3 px to move away from canvas edges
						me.paddingRight = opts.position === 'bottom' ? (cosRotation * lineSpace) + 3 : (cosRotation * lastLabelWidth) + 3;
					} else {
						me.paddingLeft = firstLabelWidth / 2 + 3; // add 3 px to move away from canvas edges
						me.paddingRight = lastLabelWidth / 2 + 3;
					}
				} else {
					// A vertical axis is more constrained by the width. Labels are the
					// dominant factor here, so get that length first and account for padding
					if (tickOpts.mirror) {
						largestTextWidth = 0;
					} else {
						// use lineSpace for consistency with horizontal axis
						// tickPadding is not implemented for horizontal
						largestTextWidth += tickPadding + lineSpace;
					}

					minSize.width = Math.min(me.maxWidth, minSize.width + largestTextWidth);

					me.paddingTop = tickFont.size / 2;
					me.paddingBottom = tickFont.size / 2;
				}
			}

			me.handleMargins();

			me.width = minSize.width;
			me.height = minSize.height;
		},

		/**
		 * Handle margins and padding interactions
		 * @private
		 */
		handleMargins: function() {
			var me = this;
			if (me.margins) {
				me.paddingLeft = Math.max(me.paddingLeft - me.margins.left, 0);
				me.paddingTop = Math.max(me.paddingTop - me.margins.top, 0);
				me.paddingRight = Math.max(me.paddingRight - me.margins.right, 0);
				me.paddingBottom = Math.max(me.paddingBottom - me.margins.bottom, 0);
			}
		},

		afterFit: function() {
			helpers.callback(this.options.afterFit, [this]);
		},

		// Shared Methods
		isHorizontal: function() {
			return this.options.position === 'top' || this.options.position === 'bottom';
		},
		isFullWidth: function() {
			return (this.options.fullWidth);
		},

		// Get the correct value. NaN bad inputs, If the value type is object get the x or y based on whether we are horizontal or not
		getRightValue: function(rawValue) {
			// Null and undefined values first
			if (helpers.isNullOrUndef(rawValue)) {
				return NaN;
			}
			// isNaN(object) returns true, so make sure NaN is checking for a number; Discard Infinite values
			if (typeof rawValue === 'number' && !isFinite(rawValue)) {
				return NaN;
			}
			// If it is in fact an object, dive in one more level
			if (rawValue) {
				if (this.isHorizontal()) {
					if (rawValue.x !== undefined) {
						return this.getRightValue(rawValue.x);
					}
				} else if (rawValue.y !== undefined) {
					return this.getRightValue(rawValue.y);
				}
			}

			// Value is good, return it
			return rawValue;
		},

		/**
		 * Used to get the value to display in the tooltip for the data at the given index
		 * @param index
		 * @param datasetIndex
		 */
		getLabelForIndex: helpers.noop,

		/**
		 * Returns the location of the given data point. Value can either be an index or a numerical value
		 * The coordinate (0, 0) is at the upper-left corner of the canvas
		 * @param value
		 * @param index
		 * @param datasetIndex
		 */
		getPixelForValue: helpers.noop,

		/**
		 * Used to get the data value from a given pixel. This is the inverse of getPixelForValue
		 * The coordinate (0, 0) is at the upper-left corner of the canvas
		 * @param pixel
		 */
		getValueForPixel: helpers.noop,

		/**
		 * Returns the location of the tick at the given index
		 * The coordinate (0, 0) is at the upper-left corner of the canvas
		 */
		getPixelForTick: function(index) {
			var me = this;
			var offset = me.options.offset;
			if (me.isHorizontal()) {
				var innerWidth = me.width - (me.paddingLeft + me.paddingRight);
				var tickWidth = innerWidth / Math.max((me._ticks.length - (offset ? 0 : 1)), 1);
				var pixel = (tickWidth * index) + me.paddingLeft;

				if (offset) {
					pixel += tickWidth / 2;
				}

				var finalVal = me.left + Math.round(pixel);
				finalVal += me.isFullWidth() ? me.margins.left : 0;
				return finalVal;
			}
			var innerHeight = me.height - (me.paddingTop + me.paddingBottom);
			return me.top + (index * (innerHeight / (me._ticks.length - 1)));
		},

		/**
		 * Utility for getting the pixel location of a percentage of scale
		 * The coordinate (0, 0) is at the upper-left corner of the canvas
		 */
		getPixelForDecimal: function(decimal) {
			var me = this;
			if (me.isHorizontal()) {
				var innerWidth = me.width - (me.paddingLeft + me.paddingRight);
				var valueOffset = (innerWidth * decimal) + me.paddingLeft;

				var finalVal = me.left + Math.round(valueOffset);
				finalVal += me.isFullWidth() ? me.margins.left : 0;
				return finalVal;
			}
			return me.top + (decimal * me.height);
		},

		/**
		 * Returns the pixel for the minimum chart value
		 * The coordinate (0, 0) is at the upper-left corner of the canvas
		 */
		getBasePixel: function() {
			return this.getPixelForValue(this.getBaseValue());
		},

		getBaseValue: function() {
			var me = this;
			var min = me.min;
			var max = me.max;

			return me.beginAtZero ? 0 :
				min < 0 && max < 0 ? max :
				min > 0 && max > 0 ? min :
				0;
		},

		/**
		 * Returns a subset of ticks to be plotted to avoid overlapping labels.
		 * @private
		 */
		_autoSkip: function(ticks) {
			var skipRatio;
			var me = this;
			var isHorizontal = me.isHorizontal();
			var optionTicks = me.options.ticks.minor;
			var tickCount = ticks.length;
			var labelRotationRadians = helpers.toRadians(me.labelRotation);
			var cosRotation = Math.cos(labelRotationRadians);
			var longestRotatedLabel = me.longestLabelWidth * cosRotation;
			var result = [];
			var i, tick, shouldSkip;

			// figure out the maximum number of gridlines to show
			var maxTicks;
			if (optionTicks.maxTicksLimit) {
				maxTicks = optionTicks.maxTicksLimit;
			}

			if (isHorizontal) {
				skipRatio = false;

				if ((longestRotatedLabel + optionTicks.autoSkipPadding) * tickCount > (me.width - (me.paddingLeft + me.paddingRight))) {
					skipRatio = 1 + Math.floor(((longestRotatedLabel + optionTicks.autoSkipPadding) * tickCount) / (me.width - (me.paddingLeft + me.paddingRight)));
				}

				// if they defined a max number of optionTicks,
				// increase skipRatio until that number is met
				if (maxTicks && tickCount > maxTicks) {
					skipRatio = Math.max(skipRatio, Math.floor(tickCount / maxTicks));
				}
			}

			for (i = 0; i < tickCount; i++) {
				tick = ticks[i];

				// Since we always show the last tick,we need may need to hide the last shown one before
				shouldSkip = (skipRatio > 1 && i % skipRatio > 0) || (i % skipRatio === 0 && i + skipRatio >= tickCount);
				if (shouldSkip && i !== tickCount - 1) {
					// leave tick in place but make sure it's not displayed (#4635)
					delete tick.label;
				}
				result.push(tick);
			}
			return result;
		},

		// Actually draw the scale on the canvas
		// @param {rectangle} chartArea : the area of the chart to draw full grid lines on
		draw: function(chartArea) {
			var me = this;
			var options = me.options;
			if (!options.display) {
				return;
			}

			var context = me.ctx;
			var globalDefaults = defaults.global;
			var optionTicks = options.ticks.minor;
			var optionMajorTicks = options.ticks.major || optionTicks;
			var gridLines = options.gridLines;
			var scaleLabel = options.scaleLabel;

			var isRotated = me.labelRotation !== 0;
			var isHorizontal = me.isHorizontal();

			var ticks = optionTicks.autoSkip ? me._autoSkip(me.getTicks()) : me.getTicks();
			var tickFontColor = helpers.valueOrDefault(optionTicks.fontColor, globalDefaults.defaultFontColor);
			var tickFont = parseFontOptions(optionTicks);
			var majorTickFontColor = helpers.valueOrDefault(optionMajorTicks.fontColor, globalDefaults.defaultFontColor);
			var majorTickFont = parseFontOptions(optionMajorTicks);

			var tl = gridLines.drawTicks ? gridLines.tickMarkLength : 0;

			var scaleLabelFontColor = helpers.valueOrDefault(scaleLabel.fontColor, globalDefaults.defaultFontColor);
			var scaleLabelFont = parseFontOptions(scaleLabel);
			var scaleLabelPadding = helpers.options.toPadding(scaleLabel.padding);
			var labelRotationRadians = helpers.toRadians(me.labelRotation);

			var itemsToDraw = [];

			var axisWidth = me.options.gridLines.lineWidth;
			var xTickStart = options.position === 'right' ? me.right : me.right - axisWidth - tl;
			var xTickEnd = options.position === 'right' ? me.right + tl : me.right;
			var yTickStart = options.position === 'bottom' ? me.top + axisWidth : me.bottom - tl - axisWidth;
			var yTickEnd = options.position === 'bottom' ? me.top + axisWidth + tl : me.bottom + axisWidth;

			helpers.each(ticks, function(tick, index) {
				// autoskipper skipped this tick (#4635)
				if (helpers.isNullOrUndef(tick.label)) {
					return;
				}

				var label = tick.label;
				var lineWidth, lineColor, borderDash, borderDashOffset;
				if (index === me.zeroLineIndex && options.offset === gridLines.offsetGridLines) {
					// Draw the first index specially
					lineWidth = gridLines.zeroLineWidth;
					lineColor = gridLines.zeroLineColor;
					borderDash = gridLines.zeroLineBorderDash;
					borderDashOffset = gridLines.zeroLineBorderDashOffset;
				} else {
					lineWidth = helpers.valueAtIndexOrDefault(gridLines.lineWidth, index);
					lineColor = helpers.valueAtIndexOrDefault(gridLines.color, index);
					borderDash = helpers.valueOrDefault(gridLines.borderDash, globalDefaults.borderDash);
					borderDashOffset = helpers.valueOrDefault(gridLines.borderDashOffset, globalDefaults.borderDashOffset);
				}

				// Common properties
				var tx1, ty1, tx2, ty2, x1, y1, x2, y2, labelX, labelY;
				var textAlign = 'middle';
				var textBaseline = 'middle';
				var tickPadding = optionTicks.padding;

				if (isHorizontal) {
					var labelYOffset = tl + tickPadding;

					if (options.position === 'bottom') {
						// bottom
						textBaseline = !isRotated ? 'top' : 'middle';
						textAlign = !isRotated ? 'center' : 'right';
						labelY = me.top + labelYOffset;
					} else {
						// top
						textBaseline = !isRotated ? 'bottom' : 'middle';
						textAlign = !isRotated ? 'center' : 'left';
						labelY = me.bottom - labelYOffset;
					}

					var xLineValue = getLineValue(me, index, gridLines.offsetGridLines && ticks.length > 1);
					if (xLineValue < me.left) {
						lineColor = 'rgba(0,0,0,0)';
					}
					xLineValue += helpers.aliasPixel(lineWidth);

					labelX = me.getPixelForTick(index) + optionTicks.labelOffset; // x values for optionTicks (need to consider offsetLabel option)

					tx1 = tx2 = x1 = x2 = xLineValue;
					ty1 = yTickStart;
					ty2 = yTickEnd;
					y1 = chartArea.top;
					y2 = chartArea.bottom + axisWidth;
				} else {
					var isLeft = options.position === 'left';
					var labelXOffset;

					if (optionTicks.mirror) {
						textAlign = isLeft ? 'left' : 'right';
						labelXOffset = tickPadding;
					} else {
						textAlign = isLeft ? 'right' : 'left';
						labelXOffset = tl + tickPadding;
					}

					labelX = isLeft ? me.right - labelXOffset : me.left + labelXOffset;

					var yLineValue = getLineValue(me, index, gridLines.offsetGridLines && ticks.length > 1);
					if (yLineValue < me.top) {
						lineColor = 'rgba(0,0,0,0)';
					}
					yLineValue += helpers.aliasPixel(lineWidth);

					labelY = me.getPixelForTick(index) + optionTicks.labelOffset;

					tx1 = xTickStart;
					tx2 = xTickEnd;
					x1 = chartArea.left;
					x2 = chartArea.right + axisWidth;
					ty1 = ty2 = y1 = y2 = yLineValue;
				}

				itemsToDraw.push({
					tx1: tx1,
					ty1: ty1,
					tx2: tx2,
					ty2: ty2,
					x1: x1,
					y1: y1,
					x2: x2,
					y2: y2,
					labelX: labelX,
					labelY: labelY,
					glWidth: lineWidth,
					glColor: lineColor,
					glBorderDash: borderDash,
					glBorderDashOffset: borderDashOffset,
					rotation: -1 * labelRotationRadians,
					label: label,
					major: tick.major,
					textBaseline: textBaseline,
					textAlign: textAlign
				});
			});

			// Draw all of the tick labels, tick marks, and grid lines at the correct places
			helpers.each(itemsToDraw, function(itemToDraw) {
				if (gridLines.display) {
					context.save();
					context.lineWidth = itemToDraw.glWidth;
					context.strokeStyle = itemToDraw.glColor;
					if (context.setLineDash) {
						context.setLineDash(itemToDraw.glBorderDash);
						context.lineDashOffset = itemToDraw.glBorderDashOffset;
					}

					context.beginPath();

					if (gridLines.drawTicks) {
						context.moveTo(itemToDraw.tx1, itemToDraw.ty1);
						context.lineTo(itemToDraw.tx2, itemToDraw.ty2);
					}

					if (gridLines.drawOnChartArea) {
						context.moveTo(itemToDraw.x1, itemToDraw.y1);
						context.lineTo(itemToDraw.x2, itemToDraw.y2);
					}

					context.stroke();
					context.restore();
				}

				if (optionTicks.display) {
					// Make sure we draw text in the correct color and font
					context.save();
					context.translate(itemToDraw.labelX, itemToDraw.labelY);
					context.rotate(itemToDraw.rotation);
					context.font = itemToDraw.major ? majorTickFont.font : tickFont.font;
					context.fillStyle = itemToDraw.major ? majorTickFontColor : tickFontColor;
					context.textBaseline = itemToDraw.textBaseline;
					context.textAlign = itemToDraw.textAlign;

					var label = itemToDraw.label;
					if (helpers.isArray(label)) {
						var lineCount = label.length;
						var lineHeight = tickFont.size * 1.5;
						var y = me.isHorizontal() ? 0 : -lineHeight * (lineCount - 1) / 2;

						for (var i = 0; i < lineCount; ++i) {
							// We just make sure the multiline element is a string here..
							context.fillText('' + label[i], 0, y);
							// apply same lineSpacing as calculated @ L#320
							y += lineHeight;
						}
					} else {
						context.fillText(label, 0, 0);
					}
					context.restore();
				}
			});

			if (scaleLabel.display) {
				// Draw the scale label
				var scaleLabelX;
				var scaleLabelY;
				var rotation = 0;
				var halfLineHeight = parseLineHeight(scaleLabel) / 2;

				if (isHorizontal) {
					scaleLabelX = me.left + ((me.right - me.left) / 2); // midpoint of the width
					scaleLabelY = options.position === 'bottom'
						? me.bottom - halfLineHeight - scaleLabelPadding.bottom
						: me.top + halfLineHeight + scaleLabelPadding.top;
				} else {
					var isLeft = options.position === 'left';
					scaleLabelX = isLeft
						? me.left + halfLineHeight + scaleLabelPadding.top
						: me.right - halfLineHeight - scaleLabelPadding.top;
					scaleLabelY = me.top + ((me.bottom - me.top) / 2);
					rotation = isLeft ? -0.5 * Math.PI : 0.5 * Math.PI;
				}

				context.save();
				context.translate(scaleLabelX, scaleLabelY);
				context.rotate(rotation);
				context.textAlign = 'center';
				context.textBaseline = 'middle';
				context.fillStyle = scaleLabelFontColor; // render in correct colour
				context.font = scaleLabelFont.font;
				context.fillText(scaleLabel.labelString, 0, 0);
				context.restore();
			}

			if (gridLines.drawBorder) {
				// Draw the line at the edge of the axis
				context.lineWidth = helpers.valueAtIndexOrDefault(gridLines.lineWidth, 0);
				context.strokeStyle = helpers.valueAtIndexOrDefault(gridLines.color, 0);
				var x1 = me.left;
				var x2 = me.right + axisWidth;
				var y1 = me.top;
				var y2 = me.bottom + axisWidth;

				var aliasPixel = helpers.aliasPixel(context.lineWidth);
				if (isHorizontal) {
					y1 = y2 = options.position === 'top' ? me.bottom : me.top;
					y1 += aliasPixel;
					y2 += aliasPixel;
				} else {
					x1 = x2 = options.position === 'left' ? me.right : me.left;
					x1 += aliasPixel;
					x2 += aliasPixel;
				}

				context.beginPath();
				context.moveTo(x1, y1);
				context.lineTo(x2, y2);
				context.stroke();
			}
		}
	});
};


/***/ }),
/* 679 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var defaults = __webpack_require__(20);
var Element = __webpack_require__(46);
var helpers = __webpack_require__(15);

defaults._set('global', {
	tooltips: {
		enabled: true,
		custom: null,
		mode: 'nearest',
		position: 'average',
		intersect: true,
		backgroundColor: 'rgba(0,0,0,0.8)',
		titleFontStyle: 'bold',
		titleSpacing: 2,
		titleMarginBottom: 6,
		titleFontColor: '#fff',
		titleAlign: 'left',
		bodySpacing: 2,
		bodyFontColor: '#fff',
		bodyAlign: 'left',
		footerFontStyle: 'bold',
		footerSpacing: 2,
		footerMarginTop: 6,
		footerFontColor: '#fff',
		footerAlign: 'left',
		yPadding: 6,
		xPadding: 6,
		caretPadding: 2,
		caretSize: 5,
		cornerRadius: 6,
		multiKeyBackground: '#fff',
		displayColors: true,
		borderColor: 'rgba(0,0,0,0)',
		borderWidth: 0,
		callbacks: {
			// Args are: (tooltipItems, data)
			beforeTitle: helpers.noop,
			title: function(tooltipItems, data) {
				// Pick first xLabel for now
				var title = '';
				var labels = data.labels;
				var labelCount = labels ? labels.length : 0;

				if (tooltipItems.length > 0) {
					var item = tooltipItems[0];

					if (item.xLabel) {
						title = item.xLabel;
					} else if (labelCount > 0 && item.index < labelCount) {
						title = labels[item.index];
					}
				}

				return title;
			},
			afterTitle: helpers.noop,

			// Args are: (tooltipItems, data)
			beforeBody: helpers.noop,

			// Args are: (tooltipItem, data)
			beforeLabel: helpers.noop,
			label: function(tooltipItem, data) {
				var label = data.datasets[tooltipItem.datasetIndex].label || '';

				if (label) {
					label += ': ';
				}
				label += tooltipItem.yLabel;
				return label;
			},
			labelColor: function(tooltipItem, chart) {
				var meta = chart.getDatasetMeta(tooltipItem.datasetIndex);
				var activeElement = meta.data[tooltipItem.index];
				var view = activeElement._view;
				return {
					borderColor: view.borderColor,
					backgroundColor: view.backgroundColor
				};
			},
			labelTextColor: function() {
				return this._options.bodyFontColor;
			},
			afterLabel: helpers.noop,

			// Args are: (tooltipItems, data)
			afterBody: helpers.noop,

			// Args are: (tooltipItems, data)
			beforeFooter: helpers.noop,
			footer: helpers.noop,
			afterFooter: helpers.noop
		}
	}
});

module.exports = function(Chart) {

	/**
 	 * Helper method to merge the opacity into a color
 	 */
	function mergeOpacity(colorString, opacity) {
		var color = helpers.color(colorString);
		return color.alpha(opacity * color.alpha()).rgbaString();
	}

	// Helper to push or concat based on if the 2nd parameter is an array or not
	function pushOrConcat(base, toPush) {
		if (toPush) {
			if (helpers.isArray(toPush)) {
				// base = base.concat(toPush);
				Array.prototype.push.apply(base, toPush);
			} else {
				base.push(toPush);
			}
		}

		return base;
	}

	// Private helper to create a tooltip item model
	// @param element : the chart element (point, arc, bar) to create the tooltip item for
	// @return : new tooltip item
	function createTooltipItem(element) {
		var xScale = element._xScale;
		var yScale = element._yScale || element._scale; // handle radar || polarArea charts
		var index = element._index;
		var datasetIndex = element._datasetIndex;

		return {
			xLabel: xScale ? xScale.getLabelForIndex(index, datasetIndex) : '',
			yLabel: yScale ? yScale.getLabelForIndex(index, datasetIndex) : '',
			index: index,
			datasetIndex: datasetIndex,
			x: element._model.x,
			y: element._model.y
		};
	}

	/**
	 * Helper to get the reset model for the tooltip
	 * @param tooltipOpts {Object} the tooltip options
	 */
	function getBaseModel(tooltipOpts) {
		var globalDefaults = defaults.global;
		var valueOrDefault = helpers.valueOrDefault;

		return {
			// Positioning
			xPadding: tooltipOpts.xPadding,
			yPadding: tooltipOpts.yPadding,
			xAlign: tooltipOpts.xAlign,
			yAlign: tooltipOpts.yAlign,

			// Body
			bodyFontColor: tooltipOpts.bodyFontColor,
			_bodyFontFamily: valueOrDefault(tooltipOpts.bodyFontFamily, globalDefaults.defaultFontFamily),
			_bodyFontStyle: valueOrDefault(tooltipOpts.bodyFontStyle, globalDefaults.defaultFontStyle),
			_bodyAlign: tooltipOpts.bodyAlign,
			bodyFontSize: valueOrDefault(tooltipOpts.bodyFontSize, globalDefaults.defaultFontSize),
			bodySpacing: tooltipOpts.bodySpacing,

			// Title
			titleFontColor: tooltipOpts.titleFontColor,
			_titleFontFamily: valueOrDefault(tooltipOpts.titleFontFamily, globalDefaults.defaultFontFamily),
			_titleFontStyle: valueOrDefault(tooltipOpts.titleFontStyle, globalDefaults.defaultFontStyle),
			titleFontSize: valueOrDefault(tooltipOpts.titleFontSize, globalDefaults.defaultFontSize),
			_titleAlign: tooltipOpts.titleAlign,
			titleSpacing: tooltipOpts.titleSpacing,
			titleMarginBottom: tooltipOpts.titleMarginBottom,

			// Footer
			footerFontColor: tooltipOpts.footerFontColor,
			_footerFontFamily: valueOrDefault(tooltipOpts.footerFontFamily, globalDefaults.defaultFontFamily),
			_footerFontStyle: valueOrDefault(tooltipOpts.footerFontStyle, globalDefaults.defaultFontStyle),
			footerFontSize: valueOrDefault(tooltipOpts.footerFontSize, globalDefaults.defaultFontSize),
			_footerAlign: tooltipOpts.footerAlign,
			footerSpacing: tooltipOpts.footerSpacing,
			footerMarginTop: tooltipOpts.footerMarginTop,

			// Appearance
			caretSize: tooltipOpts.caretSize,
			cornerRadius: tooltipOpts.cornerRadius,
			backgroundColor: tooltipOpts.backgroundColor,
			opacity: 0,
			legendColorBackground: tooltipOpts.multiKeyBackground,
			displayColors: tooltipOpts.displayColors,
			borderColor: tooltipOpts.borderColor,
			borderWidth: tooltipOpts.borderWidth
		};
	}

	/**
	 * Get the size of the tooltip
	 */
	function getTooltipSize(tooltip, model) {
		var ctx = tooltip._chart.ctx;

		var height = model.yPadding * 2; // Tooltip Padding
		var width = 0;

		// Count of all lines in the body
		var body = model.body;
		var combinedBodyLength = body.reduce(function(count, bodyItem) {
			return count + bodyItem.before.length + bodyItem.lines.length + bodyItem.after.length;
		}, 0);
		combinedBodyLength += model.beforeBody.length + model.afterBody.length;

		var titleLineCount = model.title.length;
		var footerLineCount = model.footer.length;
		var titleFontSize = model.titleFontSize;
		var bodyFontSize = model.bodyFontSize;
		var footerFontSize = model.footerFontSize;

		height += titleLineCount * titleFontSize; // Title Lines
		height += titleLineCount ? (titleLineCount - 1) * model.titleSpacing : 0; // Title Line Spacing
		height += titleLineCount ? model.titleMarginBottom : 0; // Title's bottom Margin
		height += combinedBodyLength * bodyFontSize; // Body Lines
		height += combinedBodyLength ? (combinedBodyLength - 1) * model.bodySpacing : 0; // Body Line Spacing
		height += footerLineCount ? model.footerMarginTop : 0; // Footer Margin
		height += footerLineCount * (footerFontSize); // Footer Lines
		height += footerLineCount ? (footerLineCount - 1) * model.footerSpacing : 0; // Footer Line Spacing

		// Title width
		var widthPadding = 0;
		var maxLineWidth = function(line) {
			width = Math.max(width, ctx.measureText(line).width + widthPadding);
		};

		ctx.font = helpers.fontString(titleFontSize, model._titleFontStyle, model._titleFontFamily);
		helpers.each(model.title, maxLineWidth);

		// Body width
		ctx.font = helpers.fontString(bodyFontSize, model._bodyFontStyle, model._bodyFontFamily);
		helpers.each(model.beforeBody.concat(model.afterBody), maxLineWidth);

		// Body lines may include some extra width due to the color box
		widthPadding = model.displayColors ? (bodyFontSize + 2) : 0;
		helpers.each(body, function(bodyItem) {
			helpers.each(bodyItem.before, maxLineWidth);
			helpers.each(bodyItem.lines, maxLineWidth);
			helpers.each(bodyItem.after, maxLineWidth);
		});

		// Reset back to 0
		widthPadding = 0;

		// Footer width
		ctx.font = helpers.fontString(footerFontSize, model._footerFontStyle, model._footerFontFamily);
		helpers.each(model.footer, maxLineWidth);

		// Add padding
		width += 2 * model.xPadding;

		return {
			width: width,
			height: height
		};
	}

	/**
	 * Helper to get the alignment of a tooltip given the size
	 */
	function determineAlignment(tooltip, size) {
		var model = tooltip._model;
		var chart = tooltip._chart;
		var chartArea = tooltip._chart.chartArea;
		var xAlign = 'center';
		var yAlign = 'center';

		if (model.y < size.height) {
			yAlign = 'top';
		} else if (model.y > (chart.height - size.height)) {
			yAlign = 'bottom';
		}

		var lf, rf; // functions to determine left, right alignment
		var olf, orf; // functions to determine if left/right alignment causes tooltip to go outside chart
		var yf; // function to get the y alignment if the tooltip goes outside of the left or right edges
		var midX = (chartArea.left + chartArea.right) / 2;
		var midY = (chartArea.top + chartArea.bottom) / 2;

		if (yAlign === 'center') {
			lf = function(x) {
				return x <= midX;
			};
			rf = function(x) {
				return x > midX;
			};
		} else {
			lf = function(x) {
				return x <= (size.width / 2);
			};
			rf = function(x) {
				return x >= (chart.width - (size.width / 2));
			};
		}

		olf = function(x) {
			return x + size.width + model.caretSize + model.caretPadding > chart.width;
		};
		orf = function(x) {
			return x - size.width - model.caretSize - model.caretPadding < 0;
		};
		yf = function(y) {
			return y <= midY ? 'top' : 'bottom';
		};

		if (lf(model.x)) {
			xAlign = 'left';

			// Is tooltip too wide and goes over the right side of the chart.?
			if (olf(model.x)) {
				xAlign = 'center';
				yAlign = yf(model.y);
			}
		} else if (rf(model.x)) {
			xAlign = 'right';

			// Is tooltip too wide and goes outside left edge of canvas?
			if (orf(model.x)) {
				xAlign = 'center';
				yAlign = yf(model.y);
			}
		}

		var opts = tooltip._options;
		return {
			xAlign: opts.xAlign ? opts.xAlign : xAlign,
			yAlign: opts.yAlign ? opts.yAlign : yAlign
		};
	}

	/**
	 * @Helper to get the location a tooltip needs to be placed at given the initial position (via the vm) and the size and alignment
	 */
	function getBackgroundPoint(vm, size, alignment, chart) {
		// Background Position
		var x = vm.x;
		var y = vm.y;

		var caretSize = vm.caretSize;
		var caretPadding = vm.caretPadding;
		var cornerRadius = vm.cornerRadius;
		var xAlign = alignment.xAlign;
		var yAlign = alignment.yAlign;
		var paddingAndSize = caretSize + caretPadding;
		var radiusAndPadding = cornerRadius + caretPadding;

		if (xAlign === 'right') {
			x -= size.width;
		} else if (xAlign === 'center') {
			x -= (size.width / 2);
			if (x + size.width > chart.width) {
				x = chart.width - size.width;
			}
			if (x < 0) {
				x = 0;
			}
		}

		if (yAlign === 'top') {
			y += paddingAndSize;
		} else if (yAlign === 'bottom') {
			y -= size.height + paddingAndSize;
		} else {
			y -= (size.height / 2);
		}

		if (yAlign === 'center') {
			if (xAlign === 'left') {
				x += paddingAndSize;
			} else if (xAlign === 'right') {
				x -= paddingAndSize;
			}
		} else if (xAlign === 'left') {
			x -= radiusAndPadding;
		} else if (xAlign === 'right') {
			x += radiusAndPadding;
		}

		return {
			x: x,
			y: y
		};
	}

	Chart.Tooltip = Element.extend({
		initialize: function() {
			this._model = getBaseModel(this._options);
			this._lastActive = [];
		},

		// Get the title
		// Args are: (tooltipItem, data)
		getTitle: function() {
			var me = this;
			var opts = me._options;
			var callbacks = opts.callbacks;

			var beforeTitle = callbacks.beforeTitle.apply(me, arguments);
			var title = callbacks.title.apply(me, arguments);
			var afterTitle = callbacks.afterTitle.apply(me, arguments);

			var lines = [];
			lines = pushOrConcat(lines, beforeTitle);
			lines = pushOrConcat(lines, title);
			lines = pushOrConcat(lines, afterTitle);

			return lines;
		},

		// Args are: (tooltipItem, data)
		getBeforeBody: function() {
			var lines = this._options.callbacks.beforeBody.apply(this, arguments);
			return helpers.isArray(lines) ? lines : lines !== undefined ? [lines] : [];
		},

		// Args are: (tooltipItem, data)
		getBody: function(tooltipItems, data) {
			var me = this;
			var callbacks = me._options.callbacks;
			var bodyItems = [];

			helpers.each(tooltipItems, function(tooltipItem) {
				var bodyItem = {
					before: [],
					lines: [],
					after: []
				};
				pushOrConcat(bodyItem.before, callbacks.beforeLabel.call(me, tooltipItem, data));
				pushOrConcat(bodyItem.lines, callbacks.label.call(me, tooltipItem, data));
				pushOrConcat(bodyItem.after, callbacks.afterLabel.call(me, tooltipItem, data));

				bodyItems.push(bodyItem);
			});

			return bodyItems;
		},

		// Args are: (tooltipItem, data)
		getAfterBody: function() {
			var lines = this._options.callbacks.afterBody.apply(this, arguments);
			return helpers.isArray(lines) ? lines : lines !== undefined ? [lines] : [];
		},

		// Get the footer and beforeFooter and afterFooter lines
		// Args are: (tooltipItem, data)
		getFooter: function() {
			var me = this;
			var callbacks = me._options.callbacks;

			var beforeFooter = callbacks.beforeFooter.apply(me, arguments);
			var footer = callbacks.footer.apply(me, arguments);
			var afterFooter = callbacks.afterFooter.apply(me, arguments);

			var lines = [];
			lines = pushOrConcat(lines, beforeFooter);
			lines = pushOrConcat(lines, footer);
			lines = pushOrConcat(lines, afterFooter);

			return lines;
		},

		update: function(changed) {
			var me = this;
			var opts = me._options;

			// Need to regenerate the model because its faster than using extend and it is necessary due to the optimization in Chart.Element.transition
			// that does _view = _model if ease === 1. This causes the 2nd tooltip update to set properties in both the view and model at the same time
			// which breaks any animations.
			var existingModel = me._model;
			var model = me._model = getBaseModel(opts);
			var active = me._active;

			var data = me._data;

			// In the case where active.length === 0 we need to keep these at existing values for good animations
			var alignment = {
				xAlign: existingModel.xAlign,
				yAlign: existingModel.yAlign
			};
			var backgroundPoint = {
				x: existingModel.x,
				y: existingModel.y
			};
			var tooltipSize = {
				width: existingModel.width,
				height: existingModel.height
			};
			var tooltipPosition = {
				x: existingModel.caretX,
				y: existingModel.caretY
			};

			var i, len;

			if (active.length) {
				model.opacity = 1;

				var labelColors = [];
				var labelTextColors = [];
				tooltipPosition = Chart.Tooltip.positioners[opts.position].call(me, active, me._eventPosition);

				var tooltipItems = [];
				for (i = 0, len = active.length; i < len; ++i) {
					tooltipItems.push(createTooltipItem(active[i]));
				}

				// If the user provided a filter function, use it to modify the tooltip items
				if (opts.filter) {
					tooltipItems = tooltipItems.filter(function(a) {
						return opts.filter(a, data);
					});
				}

				// If the user provided a sorting function, use it to modify the tooltip items
				if (opts.itemSort) {
					tooltipItems = tooltipItems.sort(function(a, b) {
						return opts.itemSort(a, b, data);
					});
				}

				// Determine colors for boxes
				helpers.each(tooltipItems, function(tooltipItem) {
					labelColors.push(opts.callbacks.labelColor.call(me, tooltipItem, me._chart));
					labelTextColors.push(opts.callbacks.labelTextColor.call(me, tooltipItem, me._chart));
				});


				// Build the Text Lines
				model.title = me.getTitle(tooltipItems, data);
				model.beforeBody = me.getBeforeBody(tooltipItems, data);
				model.body = me.getBody(tooltipItems, data);
				model.afterBody = me.getAfterBody(tooltipItems, data);
				model.footer = me.getFooter(tooltipItems, data);

				// Initial positioning and colors
				model.x = Math.round(tooltipPosition.x);
				model.y = Math.round(tooltipPosition.y);
				model.caretPadding = opts.caretPadding;
				model.labelColors = labelColors;
				model.labelTextColors = labelTextColors;

				// data points
				model.dataPoints = tooltipItems;

				// We need to determine alignment of the tooltip
				tooltipSize = getTooltipSize(this, model);
				alignment = determineAlignment(this, tooltipSize);
				// Final Size and Position
				backgroundPoint = getBackgroundPoint(model, tooltipSize, alignment, me._chart);
			} else {
				model.opacity = 0;
			}

			model.xAlign = alignment.xAlign;
			model.yAlign = alignment.yAlign;
			model.x = backgroundPoint.x;
			model.y = backgroundPoint.y;
			model.width = tooltipSize.width;
			model.height = tooltipSize.height;

			// Point where the caret on the tooltip points to
			model.caretX = tooltipPosition.x;
			model.caretY = tooltipPosition.y;

			me._model = model;

			if (changed && opts.custom) {
				opts.custom.call(me, model);
			}

			return me;
		},
		drawCaret: function(tooltipPoint, size) {
			var ctx = this._chart.ctx;
			var vm = this._view;
			var caretPosition = this.getCaretPosition(tooltipPoint, size, vm);

			ctx.lineTo(caretPosition.x1, caretPosition.y1);
			ctx.lineTo(caretPosition.x2, caretPosition.y2);
			ctx.lineTo(caretPosition.x3, caretPosition.y3);
		},
		getCaretPosition: function(tooltipPoint, size, vm) {
			var x1, x2, x3, y1, y2, y3;
			var caretSize = vm.caretSize;
			var cornerRadius = vm.cornerRadius;
			var xAlign = vm.xAlign;
			var yAlign = vm.yAlign;
			var ptX = tooltipPoint.x;
			var ptY = tooltipPoint.y;
			var width = size.width;
			var height = size.height;

			if (yAlign === 'center') {
				y2 = ptY + (height / 2);

				if (xAlign === 'left') {
					x1 = ptX;
					x2 = x1 - caretSize;
					x3 = x1;

					y1 = y2 + caretSize;
					y3 = y2 - caretSize;
				} else {
					x1 = ptX + width;
					x2 = x1 + caretSize;
					x3 = x1;

					y1 = y2 - caretSize;
					y3 = y2 + caretSize;
				}
			} else {
				if (xAlign === 'left') {
					x2 = ptX + cornerRadius + (caretSize);
					x1 = x2 - caretSize;
					x3 = x2 + caretSize;
				} else if (xAlign === 'right') {
					x2 = ptX + width - cornerRadius - caretSize;
					x1 = x2 - caretSize;
					x3 = x2 + caretSize;
				} else {
					x2 = vm.caretX;
					x1 = x2 - caretSize;
					x3 = x2 + caretSize;
				}
				if (yAlign === 'top') {
					y1 = ptY;
					y2 = y1 - caretSize;
					y3 = y1;
				} else {
					y1 = ptY + height;
					y2 = y1 + caretSize;
					y3 = y1;
					// invert drawing order
					var tmp = x3;
					x3 = x1;
					x1 = tmp;
				}
			}
			return {x1: x1, x2: x2, x3: x3, y1: y1, y2: y2, y3: y3};
		},
		drawTitle: function(pt, vm, ctx, opacity) {
			var title = vm.title;

			if (title.length) {
				ctx.textAlign = vm._titleAlign;
				ctx.textBaseline = 'top';

				var titleFontSize = vm.titleFontSize;
				var titleSpacing = vm.titleSpacing;

				ctx.fillStyle = mergeOpacity(vm.titleFontColor, opacity);
				ctx.font = helpers.fontString(titleFontSize, vm._titleFontStyle, vm._titleFontFamily);

				var i, len;
				for (i = 0, len = title.length; i < len; ++i) {
					ctx.fillText(title[i], pt.x, pt.y);
					pt.y += titleFontSize + titleSpacing; // Line Height and spacing

					if (i + 1 === title.length) {
						pt.y += vm.titleMarginBottom - titleSpacing; // If Last, add margin, remove spacing
					}
				}
			}
		},
		drawBody: function(pt, vm, ctx, opacity) {
			var bodyFontSize = vm.bodyFontSize;
			var bodySpacing = vm.bodySpacing;
			var body = vm.body;

			ctx.textAlign = vm._bodyAlign;
			ctx.textBaseline = 'top';
			ctx.font = helpers.fontString(bodyFontSize, vm._bodyFontStyle, vm._bodyFontFamily);

			// Before Body
			var xLinePadding = 0;
			var fillLineOfText = function(line) {
				ctx.fillText(line, pt.x + xLinePadding, pt.y);
				pt.y += bodyFontSize + bodySpacing;
			};

			// Before body lines
			ctx.fillStyle = mergeOpacity(vm.bodyFontColor, opacity);
			helpers.each(vm.beforeBody, fillLineOfText);

			var drawColorBoxes = vm.displayColors;
			xLinePadding = drawColorBoxes ? (bodyFontSize + 2) : 0;

			// Draw body lines now
			helpers.each(body, function(bodyItem, i) {
				var textColor = mergeOpacity(vm.labelTextColors[i], opacity);
				ctx.fillStyle = textColor;
				helpers.each(bodyItem.before, fillLineOfText);

				helpers.each(bodyItem.lines, function(line) {
					// Draw Legend-like boxes if needed
					if (drawColorBoxes) {
						// Fill a white rect so that colours merge nicely if the opacity is < 1
						ctx.fillStyle = mergeOpacity(vm.legendColorBackground, opacity);
						ctx.fillRect(pt.x, pt.y, bodyFontSize, bodyFontSize);

						// Border
						ctx.lineWidth = 1;
						ctx.strokeStyle = mergeOpacity(vm.labelColors[i].borderColor, opacity);
						ctx.strokeRect(pt.x, pt.y, bodyFontSize, bodyFontSize);

						// Inner square
						ctx.fillStyle = mergeOpacity(vm.labelColors[i].backgroundColor, opacity);
						ctx.fillRect(pt.x + 1, pt.y + 1, bodyFontSize - 2, bodyFontSize - 2);
						ctx.fillStyle = textColor;
					}

					fillLineOfText(line);
				});

				helpers.each(bodyItem.after, fillLineOfText);
			});

			// Reset back to 0 for after body
			xLinePadding = 0;

			// After body lines
			helpers.each(vm.afterBody, fillLineOfText);
			pt.y -= bodySpacing; // Remove last body spacing
		},
		drawFooter: function(pt, vm, ctx, opacity) {
			var footer = vm.footer;

			if (footer.length) {
				pt.y += vm.footerMarginTop;

				ctx.textAlign = vm._footerAlign;
				ctx.textBaseline = 'top';

				ctx.fillStyle = mergeOpacity(vm.footerFontColor, opacity);
				ctx.font = helpers.fontString(vm.footerFontSize, vm._footerFontStyle, vm._footerFontFamily);

				helpers.each(footer, function(line) {
					ctx.fillText(line, pt.x, pt.y);
					pt.y += vm.footerFontSize + vm.footerSpacing;
				});
			}
		},
		drawBackground: function(pt, vm, ctx, tooltipSize, opacity) {
			ctx.fillStyle = mergeOpacity(vm.backgroundColor, opacity);
			ctx.strokeStyle = mergeOpacity(vm.borderColor, opacity);
			ctx.lineWidth = vm.borderWidth;
			var xAlign = vm.xAlign;
			var yAlign = vm.yAlign;
			var x = pt.x;
			var y = pt.y;
			var width = tooltipSize.width;
			var height = tooltipSize.height;
			var radius = vm.cornerRadius;

			ctx.beginPath();
			ctx.moveTo(x + radius, y);
			if (yAlign === 'top') {
				this.drawCaret(pt, tooltipSize);
			}
			ctx.lineTo(x + width - radius, y);
			ctx.quadraticCurveTo(x + width, y, x + width, y + radius);
			if (yAlign === 'center' && xAlign === 'right') {
				this.drawCaret(pt, tooltipSize);
			}
			ctx.lineTo(x + width, y + height - radius);
			ctx.quadraticCurveTo(x + width, y + height, x + width - radius, y + height);
			if (yAlign === 'bottom') {
				this.drawCaret(pt, tooltipSize);
			}
			ctx.lineTo(x + radius, y + height);
			ctx.quadraticCurveTo(x, y + height, x, y + height - radius);
			if (yAlign === 'center' && xAlign === 'left') {
				this.drawCaret(pt, tooltipSize);
			}
			ctx.lineTo(x, y + radius);
			ctx.quadraticCurveTo(x, y, x + radius, y);
			ctx.closePath();

			ctx.fill();

			if (vm.borderWidth > 0) {
				ctx.stroke();
			}
		},
		draw: function() {
			var ctx = this._chart.ctx;
			var vm = this._view;

			if (vm.opacity === 0) {
				return;
			}

			var tooltipSize = {
				width: vm.width,
				height: vm.height
			};
			var pt = {
				x: vm.x,
				y: vm.y
			};

			// IE11/Edge does not like very small opacities, so snap to 0
			var opacity = Math.abs(vm.opacity < 1e-3) ? 0 : vm.opacity;

			// Truthy/falsey value for empty tooltip
			var hasTooltipContent = vm.title.length || vm.beforeBody.length || vm.body.length || vm.afterBody.length || vm.footer.length;

			if (this._options.enabled && hasTooltipContent) {
				// Draw Background
				this.drawBackground(pt, vm, ctx, tooltipSize, opacity);

				// Draw Title, Body, and Footer
				pt.x += vm.xPadding;
				pt.y += vm.yPadding;

				// Titles
				this.drawTitle(pt, vm, ctx, opacity);

				// Body
				this.drawBody(pt, vm, ctx, opacity);

				// Footer
				this.drawFooter(pt, vm, ctx, opacity);
			}
		},

		/**
		 * Handle an event
		 * @private
		 * @param {IEvent} event - The event to handle
		 * @returns {Boolean} true if the tooltip changed
		 */
		handleEvent: function(e) {
			var me = this;
			var options = me._options;
			var changed = false;

			me._lastActive = me._lastActive || [];

			// Find Active Elements for tooltips
			if (e.type === 'mouseout') {
				me._active = [];
			} else {
				me._active = me._chart.getElementsAtEventForMode(e, options.mode, options);
			}

			// Remember Last Actives
			changed = !helpers.arrayEquals(me._active, me._lastActive);

			// Only handle target event on tooltip change
			if (changed) {
				me._lastActive = me._active;

				if (options.enabled || options.custom) {
					me._eventPosition = {
						x: e.x,
						y: e.y
					};

					me.update(true);
					me.pivot();
				}
			}

			return changed;
		}
	});

	/**
	 * @namespace Chart.Tooltip.positioners
	 */
	Chart.Tooltip.positioners = {
		/**
		 * Average mode places the tooltip at the average position of the elements shown
		 * @function Chart.Tooltip.positioners.average
		 * @param elements {ChartElement[]} the elements being displayed in the tooltip
		 * @returns {Point} tooltip position
		 */
		average: function(elements) {
			if (!elements.length) {
				return false;
			}

			var i, len;
			var x = 0;
			var y = 0;
			var count = 0;

			for (i = 0, len = elements.length; i < len; ++i) {
				var el = elements[i];
				if (el && el.hasValue()) {
					var pos = el.tooltipPosition();
					x += pos.x;
					y += pos.y;
					++count;
				}
			}

			return {
				x: Math.round(x / count),
				y: Math.round(y / count)
			};
		},

		/**
		 * Gets the tooltip position nearest of the item nearest to the event position
		 * @function Chart.Tooltip.positioners.nearest
		 * @param elements {Chart.Element[]} the tooltip elements
		 * @param eventPosition {Point} the position of the event in canvas coordinates
		 * @returns {Point} the tooltip position
		 */
		nearest: function(elements, eventPosition) {
			var x = eventPosition.x;
			var y = eventPosition.y;
			var minDistance = Number.POSITIVE_INFINITY;
			var i, len, nearestElement;

			for (i = 0, len = elements.length; i < len; ++i) {
				var el = elements[i];
				if (el && el.hasValue()) {
					var center = el.getCenterPoint();
					var d = helpers.distanceBetweenPoints(eventPosition, center);

					if (d < minDistance) {
						minDistance = d;
						nearestElement = el;
					}
				}
			}

			if (nearestElement) {
				var tp = nearestElement.tooltipPosition();
				x = tp.x;
				y = tp.y;
			}

			return {
				x: x,
				y: y
			};
		}
	};
};


/***/ }),
/* 680 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var helpers = __webpack_require__(15);

/**
 * Generate a set of linear ticks
 * @param generationOptions the options used to generate the ticks
 * @param dataRange the range of the data
 * @returns {Array<Number>} array of tick values
 */
function generateTicks(generationOptions, dataRange) {
	var ticks = [];
	// To get a "nice" value for the tick spacing, we will use the appropriately named
	// "nice number" algorithm. See http://stackoverflow.com/questions/8506881/nice-label-algorithm-for-charts-with-minimum-ticks
	// for details.

	var spacing;
	if (generationOptions.stepSize && generationOptions.stepSize > 0) {
		spacing = generationOptions.stepSize;
	} else {
		var niceRange = helpers.niceNum(dataRange.max - dataRange.min, false);
		spacing = helpers.niceNum(niceRange / (generationOptions.maxTicks - 1), true);
	}
	var niceMin = Math.floor(dataRange.min / spacing) * spacing;
	var niceMax = Math.ceil(dataRange.max / spacing) * spacing;

	// If min, max and stepSize is set and they make an evenly spaced scale use it.
	if (generationOptions.min && generationOptions.max && generationOptions.stepSize) {
		// If very close to our whole number, use it.
		if (helpers.almostWhole((generationOptions.max - generationOptions.min) / generationOptions.stepSize, spacing / 1000)) {
			niceMin = generationOptions.min;
			niceMax = generationOptions.max;
		}
	}

	var numSpaces = (niceMax - niceMin) / spacing;
	// If very close to our rounded value, use it.
	if (helpers.almostEquals(numSpaces, Math.round(numSpaces), spacing / 1000)) {
		numSpaces = Math.round(numSpaces);
	} else {
		numSpaces = Math.ceil(numSpaces);
	}

	var precision = 1;
	if (spacing < 1) {
		precision = Math.pow(10, spacing.toString().length - 2);
		niceMin = Math.round(niceMin * precision) / precision;
		niceMax = Math.round(niceMax * precision) / precision;
	}
	ticks.push(generationOptions.min !== undefined ? generationOptions.min : niceMin);
	for (var j = 1; j < numSpaces; ++j) {
		ticks.push(Math.round((niceMin + j * spacing) * precision) / precision);
	}
	ticks.push(generationOptions.max !== undefined ? generationOptions.max : niceMax);

	return ticks;
}


module.exports = function(Chart) {

	var noop = helpers.noop;

	Chart.LinearScaleBase = Chart.Scale.extend({
		getRightValue: function(value) {
			if (typeof value === 'string') {
				return +value;
			}
			return Chart.Scale.prototype.getRightValue.call(this, value);
		},

		handleTickRangeOptions: function() {
			var me = this;
			var opts = me.options;
			var tickOpts = opts.ticks;

			// If we are forcing it to begin at 0, but 0 will already be rendered on the chart,
			// do nothing since that would make the chart weird. If the user really wants a weird chart
			// axis, they can manually override it
			if (tickOpts.beginAtZero) {
				var minSign = helpers.sign(me.min);
				var maxSign = helpers.sign(me.max);

				if (minSign < 0 && maxSign < 0) {
					// move the top up to 0
					me.max = 0;
				} else if (minSign > 0 && maxSign > 0) {
					// move the bottom down to 0
					me.min = 0;
				}
			}

			var setMin = tickOpts.min !== undefined || tickOpts.suggestedMin !== undefined;
			var setMax = tickOpts.max !== undefined || tickOpts.suggestedMax !== undefined;

			if (tickOpts.min !== undefined) {
				me.min = tickOpts.min;
			} else if (tickOpts.suggestedMin !== undefined) {
				if (me.min === null) {
					me.min = tickOpts.suggestedMin;
				} else {
					me.min = Math.min(me.min, tickOpts.suggestedMin);
				}
			}

			if (tickOpts.max !== undefined) {
				me.max = tickOpts.max;
			} else if (tickOpts.suggestedMax !== undefined) {
				if (me.max === null) {
					me.max = tickOpts.suggestedMax;
				} else {
					me.max = Math.max(me.max, tickOpts.suggestedMax);
				}
			}

			if (setMin !== setMax) {
				// We set the min or the max but not both.
				// So ensure that our range is good
				// Inverted or 0 length range can happen when
				// ticks.min is set, and no datasets are visible
				if (me.min >= me.max) {
					if (setMin) {
						me.max = me.min + 1;
					} else {
						me.min = me.max - 1;
					}
				}
			}

			if (me.min === me.max) {
				me.max++;

				if (!tickOpts.beginAtZero) {
					me.min--;
				}
			}
		},
		getTickLimit: noop,
		handleDirectionalChanges: noop,

		buildTicks: function() {
			var me = this;
			var opts = me.options;
			var tickOpts = opts.ticks;

			// Figure out what the max number of ticks we can support it is based on the size of
			// the axis area. For now, we say that the minimum tick spacing in pixels must be 50
			// We also limit the maximum number of ticks to 11 which gives a nice 10 squares on
			// the graph. Make sure we always have at least 2 ticks
			var maxTicks = me.getTickLimit();
			maxTicks = Math.max(2, maxTicks);

			var numericGeneratorOptions = {
				maxTicks: maxTicks,
				min: tickOpts.min,
				max: tickOpts.max,
				stepSize: helpers.valueOrDefault(tickOpts.fixedStepSize, tickOpts.stepSize)
			};
			var ticks = me.ticks = generateTicks(numericGeneratorOptions, me);

			me.handleDirectionalChanges();

			// At this point, we need to update our max and min given the tick values since we have expanded the
			// range of the scale
			me.max = helpers.max(ticks);
			me.min = helpers.min(ticks);

			if (tickOpts.reverse) {
				ticks.reverse();

				me.start = me.max;
				me.end = me.min;
			} else {
				me.start = me.min;
				me.end = me.max;
			}
		},
		convertTicksToLabels: function() {
			var me = this;
			me.ticksAsNumbers = me.ticks.slice();
			me.zeroLineIndex = me.ticks.indexOf(0);

			Chart.Scale.prototype.convertTicksToLabels.call(me);
		}
	});
};


/***/ }),
/* 681 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function(Chart) {

	// Default config for a category scale
	var defaultConfig = {
		position: 'bottom'
	};

	var DatasetScale = Chart.Scale.extend({
		/**
		* Internal function to get the correct labels. If data.xLabels or data.yLabels are defined, use those
		* else fall back to data.labels
		* @private
		*/
		getLabels: function() {
			var data = this.chart.data;
			return this.options.labels || (this.isHorizontal() ? data.xLabels : data.yLabels) || data.labels;
		},

		determineDataLimits: function() {
			var me = this;
			var labels = me.getLabels();
			me.minIndex = 0;
			me.maxIndex = labels.length - 1;
			var findIndex;

			if (me.options.ticks.min !== undefined) {
				// user specified min value
				findIndex = labels.indexOf(me.options.ticks.min);
				me.minIndex = findIndex !== -1 ? findIndex : me.minIndex;
			}

			if (me.options.ticks.max !== undefined) {
				// user specified max value
				findIndex = labels.indexOf(me.options.ticks.max);
				me.maxIndex = findIndex !== -1 ? findIndex : me.maxIndex;
			}

			me.min = labels[me.minIndex];
			me.max = labels[me.maxIndex];
		},

		buildTicks: function() {
			var me = this;
			var labels = me.getLabels();
			// If we are viewing some subset of labels, slice the original array
			me.ticks = (me.minIndex === 0 && me.maxIndex === labels.length - 1) ? labels : labels.slice(me.minIndex, me.maxIndex + 1);
		},

		getLabelForIndex: function(index, datasetIndex) {
			var me = this;
			var data = me.chart.data;
			var isHorizontal = me.isHorizontal();

			if (data.yLabels && !isHorizontal) {
				return me.getRightValue(data.datasets[datasetIndex].data[index]);
			}
			return me.ticks[index - me.minIndex];
		},

		// Used to get data value locations.  Value can either be an index or a numerical value
		getPixelForValue: function(value, index) {
			var me = this;
			var offset = me.options.offset;
			// 1 is added because we need the length but we have the indexes
			var offsetAmt = Math.max((me.maxIndex + 1 - me.minIndex - (offset ? 0 : 1)), 1);

			// If value is a data object, then index is the index in the data array,
			// not the index of the scale. We need to change that.
			var valueCategory;
			if (value !== undefined && value !== null) {
				valueCategory = me.isHorizontal() ? value.x : value.y;
			}
			if (valueCategory !== undefined || (value !== undefined && isNaN(index))) {
				var labels = me.getLabels();
				value = valueCategory || value;
				var idx = labels.indexOf(value);
				index = idx !== -1 ? idx : index;
			}

			if (me.isHorizontal()) {
				var valueWidth = me.width / offsetAmt;
				var widthOffset = (valueWidth * (index - me.minIndex));

				if (offset) {
					widthOffset += (valueWidth / 2);
				}

				return me.left + Math.round(widthOffset);
			}
			var valueHeight = me.height / offsetAmt;
			var heightOffset = (valueHeight * (index - me.minIndex));

			if (offset) {
				heightOffset += (valueHeight / 2);
			}

			return me.top + Math.round(heightOffset);
		},
		getPixelForTick: function(index) {
			return this.getPixelForValue(this.ticks[index], index + this.minIndex, null);
		},
		getValueForPixel: function(pixel) {
			var me = this;
			var offset = me.options.offset;
			var value;
			var offsetAmt = Math.max((me._ticks.length - (offset ? 0 : 1)), 1);
			var horz = me.isHorizontal();
			var valueDimension = (horz ? me.width : me.height) / offsetAmt;

			pixel -= horz ? me.left : me.top;

			if (offset) {
				pixel -= (valueDimension / 2);
			}

			if (pixel <= 0) {
				value = 0;
			} else {
				value = Math.round(pixel / valueDimension);
			}

			return value + me.minIndex;
		},
		getBasePixel: function() {
			return this.bottom;
		}
	});

	Chart.scaleService.registerScaleType('category', DatasetScale, defaultConfig);

};


/***/ }),
/* 682 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var defaults = __webpack_require__(20);
var helpers = __webpack_require__(15);
var Ticks = __webpack_require__(107);

module.exports = function(Chart) {

	var defaultConfig = {
		position: 'left',
		ticks: {
			callback: Ticks.formatters.linear
		}
	};

	var LinearScale = Chart.LinearScaleBase.extend({

		determineDataLimits: function() {
			var me = this;
			var opts = me.options;
			var chart = me.chart;
			var data = chart.data;
			var datasets = data.datasets;
			var isHorizontal = me.isHorizontal();
			var DEFAULT_MIN = 0;
			var DEFAULT_MAX = 1;

			function IDMatches(meta) {
				return isHorizontal ? meta.xAxisID === me.id : meta.yAxisID === me.id;
			}

			// First Calculate the range
			me.min = null;
			me.max = null;

			var hasStacks = opts.stacked;
			if (hasStacks === undefined) {
				helpers.each(datasets, function(dataset, datasetIndex) {
					if (hasStacks) {
						return;
					}

					var meta = chart.getDatasetMeta(datasetIndex);
					if (chart.isDatasetVisible(datasetIndex) && IDMatches(meta) &&
						meta.stack !== undefined) {
						hasStacks = true;
					}
				});
			}

			if (opts.stacked || hasStacks) {
				var valuesPerStack = {};

				helpers.each(datasets, function(dataset, datasetIndex) {
					var meta = chart.getDatasetMeta(datasetIndex);
					var key = [
						meta.type,
						// we have a separate stack for stack=undefined datasets when the opts.stacked is undefined
						((opts.stacked === undefined && meta.stack === undefined) ? datasetIndex : ''),
						meta.stack
					].join('.');

					if (valuesPerStack[key] === undefined) {
						valuesPerStack[key] = {
							positiveValues: [],
							negativeValues: []
						};
					}

					// Store these per type
					var positiveValues = valuesPerStack[key].positiveValues;
					var negativeValues = valuesPerStack[key].negativeValues;

					if (chart.isDatasetVisible(datasetIndex) && IDMatches(meta)) {
						helpers.each(dataset.data, function(rawValue, index) {
							var value = +me.getRightValue(rawValue);
							if (isNaN(value) || meta.data[index].hidden) {
								return;
							}

							positiveValues[index] = positiveValues[index] || 0;
							negativeValues[index] = negativeValues[index] || 0;

							if (opts.relativePoints) {
								positiveValues[index] = 100;
							} else if (value < 0) {
								negativeValues[index] += value;
							} else {
								positiveValues[index] += value;
							}
						});
					}
				});

				helpers.each(valuesPerStack, function(valuesForType) {
					var values = valuesForType.positiveValues.concat(valuesForType.negativeValues);
					var minVal = helpers.min(values);
					var maxVal = helpers.max(values);
					me.min = me.min === null ? minVal : Math.min(me.min, minVal);
					me.max = me.max === null ? maxVal : Math.max(me.max, maxVal);
				});

			} else {
				helpers.each(datasets, function(dataset, datasetIndex) {
					var meta = chart.getDatasetMeta(datasetIndex);
					if (chart.isDatasetVisible(datasetIndex) && IDMatches(meta)) {
						helpers.each(dataset.data, function(rawValue, index) {
							var value = +me.getRightValue(rawValue);
							if (isNaN(value) || meta.data[index].hidden) {
								return;
							}

							if (me.min === null) {
								me.min = value;
							} else if (value < me.min) {
								me.min = value;
							}

							if (me.max === null) {
								me.max = value;
							} else if (value > me.max) {
								me.max = value;
							}
						});
					}
				});
			}

			me.min = isFinite(me.min) && !isNaN(me.min) ? me.min : DEFAULT_MIN;
			me.max = isFinite(me.max) && !isNaN(me.max) ? me.max : DEFAULT_MAX;

			// Common base implementation to handle ticks.min, ticks.max, ticks.beginAtZero
			this.handleTickRangeOptions();
		},
		getTickLimit: function() {
			var maxTicks;
			var me = this;
			var tickOpts = me.options.ticks;

			if (me.isHorizontal()) {
				maxTicks = Math.min(tickOpts.maxTicksLimit ? tickOpts.maxTicksLimit : 11, Math.ceil(me.width / 50));
			} else {
				// The factor of 2 used to scale the font size has been experimentally determined.
				var tickFontSize = helpers.valueOrDefault(tickOpts.fontSize, defaults.global.defaultFontSize);
				maxTicks = Math.min(tickOpts.maxTicksLimit ? tickOpts.maxTicksLimit : 11, Math.ceil(me.height / (2 * tickFontSize)));
			}

			return maxTicks;
		},
		// Called after the ticks are built. We need
		handleDirectionalChanges: function() {
			if (!this.isHorizontal()) {
				// We are in a vertical orientation. The top value is the highest. So reverse the array
				this.ticks.reverse();
			}
		},
		getLabelForIndex: function(index, datasetIndex) {
			return +this.getRightValue(this.chart.data.datasets[datasetIndex].data[index]);
		},
		// Utils
		getPixelForValue: function(value) {
			// This must be called after fit has been run so that
			// this.left, this.top, this.right, and this.bottom have been defined
			var me = this;
			var start = me.start;

			var rightValue = +me.getRightValue(value);
			var pixel;
			var range = me.end - start;

			if (me.isHorizontal()) {
				pixel = me.left + (me.width / range * (rightValue - start));
			} else {
				pixel = me.bottom - (me.height / range * (rightValue - start));
			}
			return pixel;
		},
		getValueForPixel: function(pixel) {
			var me = this;
			var isHorizontal = me.isHorizontal();
			var innerDimension = isHorizontal ? me.width : me.height;
			var offset = (isHorizontal ? pixel - me.left : me.bottom - pixel) / innerDimension;
			return me.start + ((me.end - me.start) * offset);
		},
		getPixelForTick: function(index) {
			return this.getPixelForValue(this.ticksAsNumbers[index]);
		}
	});
	Chart.scaleService.registerScaleType('linear', LinearScale, defaultConfig);

};


/***/ }),
/* 683 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var helpers = __webpack_require__(15);
var Ticks = __webpack_require__(107);

/**
 * Generate a set of logarithmic ticks
 * @param generationOptions the options used to generate the ticks
 * @param dataRange the range of the data
 * @returns {Array<Number>} array of tick values
 */
function generateTicks(generationOptions, dataRange) {
	var ticks = [];
	var valueOrDefault = helpers.valueOrDefault;

	// Figure out what the max number of ticks we can support it is based on the size of
	// the axis area. For now, we say that the minimum tick spacing in pixels must be 50
	// We also limit the maximum number of ticks to 11 which gives a nice 10 squares on
	// the graph
	var tickVal = valueOrDefault(generationOptions.min, Math.pow(10, Math.floor(helpers.log10(dataRange.min))));

	var endExp = Math.floor(helpers.log10(dataRange.max));
	var endSignificand = Math.ceil(dataRange.max / Math.pow(10, endExp));
	var exp, significand;

	if (tickVal === 0) {
		exp = Math.floor(helpers.log10(dataRange.minNotZero));
		significand = Math.floor(dataRange.minNotZero / Math.pow(10, exp));

		ticks.push(tickVal);
		tickVal = significand * Math.pow(10, exp);
	} else {
		exp = Math.floor(helpers.log10(tickVal));
		significand = Math.floor(tickVal / Math.pow(10, exp));
	}
	var precision = exp < 0 ? Math.pow(10, Math.abs(exp)) : 1;

	do {
		ticks.push(tickVal);

		++significand;
		if (significand === 10) {
			significand = 1;
			++exp;
			precision = exp >= 0 ? 1 : precision;
		}

		tickVal = Math.round(significand * Math.pow(10, exp) * precision) / precision;
	} while (exp < endExp || (exp === endExp && significand < endSignificand));

	var lastTick = valueOrDefault(generationOptions.max, tickVal);
	ticks.push(lastTick);

	return ticks;
}


module.exports = function(Chart) {

	var defaultConfig = {
		position: 'left',

		// label settings
		ticks: {
			callback: Ticks.formatters.logarithmic
		}
	};

	var LogarithmicScale = Chart.Scale.extend({
		determineDataLimits: function() {
			var me = this;
			var opts = me.options;
			var chart = me.chart;
			var data = chart.data;
			var datasets = data.datasets;
			var isHorizontal = me.isHorizontal();
			function IDMatches(meta) {
				return isHorizontal ? meta.xAxisID === me.id : meta.yAxisID === me.id;
			}

			// Calculate Range
			me.min = null;
			me.max = null;
			me.minNotZero = null;

			var hasStacks = opts.stacked;
			if (hasStacks === undefined) {
				helpers.each(datasets, function(dataset, datasetIndex) {
					if (hasStacks) {
						return;
					}

					var meta = chart.getDatasetMeta(datasetIndex);
					if (chart.isDatasetVisible(datasetIndex) && IDMatches(meta) &&
						meta.stack !== undefined) {
						hasStacks = true;
					}
				});
			}

			if (opts.stacked || hasStacks) {
				var valuesPerStack = {};

				helpers.each(datasets, function(dataset, datasetIndex) {
					var meta = chart.getDatasetMeta(datasetIndex);
					var key = [
						meta.type,
						// we have a separate stack for stack=undefined datasets when the opts.stacked is undefined
						((opts.stacked === undefined && meta.stack === undefined) ? datasetIndex : ''),
						meta.stack
					].join('.');

					if (chart.isDatasetVisible(datasetIndex) && IDMatches(meta)) {
						if (valuesPerStack[key] === undefined) {
							valuesPerStack[key] = [];
						}

						helpers.each(dataset.data, function(rawValue, index) {
							var values = valuesPerStack[key];
							var value = +me.getRightValue(rawValue);
							// invalid, hidden and negative values are ignored
							if (isNaN(value) || meta.data[index].hidden || value < 0) {
								return;
							}
							values[index] = values[index] || 0;
							values[index] += value;
						});
					}
				});

				helpers.each(valuesPerStack, function(valuesForType) {
					if (valuesForType.length > 0) {
						var minVal = helpers.min(valuesForType);
						var maxVal = helpers.max(valuesForType);
						me.min = me.min === null ? minVal : Math.min(me.min, minVal);
						me.max = me.max === null ? maxVal : Math.max(me.max, maxVal);
					}
				});

			} else {
				helpers.each(datasets, function(dataset, datasetIndex) {
					var meta = chart.getDatasetMeta(datasetIndex);
					if (chart.isDatasetVisible(datasetIndex) && IDMatches(meta)) {
						helpers.each(dataset.data, function(rawValue, index) {
							var value = +me.getRightValue(rawValue);
							// invalid, hidden and negative values are ignored
							if (isNaN(value) || meta.data[index].hidden || value < 0) {
								return;
							}

							if (me.min === null) {
								me.min = value;
							} else if (value < me.min) {
								me.min = value;
							}

							if (me.max === null) {
								me.max = value;
							} else if (value > me.max) {
								me.max = value;
							}

							if (value !== 0 && (me.minNotZero === null || value < me.minNotZero)) {
								me.minNotZero = value;
							}
						});
					}
				});
			}

			// Common base implementation to handle ticks.min, ticks.max
			this.handleTickRangeOptions();
		},
		handleTickRangeOptions: function() {
			var me = this;
			var opts = me.options;
			var tickOpts = opts.ticks;
			var valueOrDefault = helpers.valueOrDefault;
			var DEFAULT_MIN = 1;
			var DEFAULT_MAX = 10;

			me.min = valueOrDefault(tickOpts.min, me.min);
			me.max = valueOrDefault(tickOpts.max, me.max);

			if (me.min === me.max) {
				if (me.min !== 0 && me.min !== null) {
					me.min = Math.pow(10, Math.floor(helpers.log10(me.min)) - 1);
					me.max = Math.pow(10, Math.floor(helpers.log10(me.max)) + 1);
				} else {
					me.min = DEFAULT_MIN;
					me.max = DEFAULT_MAX;
				}
			}
			if (me.min === null) {
				me.min = Math.pow(10, Math.floor(helpers.log10(me.max)) - 1);
			}
			if (me.max === null) {
				me.max = me.min !== 0
					? Math.pow(10, Math.floor(helpers.log10(me.min)) + 1)
					: DEFAULT_MAX;
			}
			if (me.minNotZero === null) {
				if (me.min > 0) {
					me.minNotZero = me.min;
				} else if (me.max < 1) {
					me.minNotZero = Math.pow(10, Math.floor(helpers.log10(me.max)));
				} else {
					me.minNotZero = DEFAULT_MIN;
				}
			}
		},
		buildTicks: function() {
			var me = this;
			var opts = me.options;
			var tickOpts = opts.ticks;
			var reverse = !me.isHorizontal();

			var generationOptions = {
				min: tickOpts.min,
				max: tickOpts.max
			};
			var ticks = me.ticks = generateTicks(generationOptions, me);

			// At this point, we need to update our max and min given the tick values since we have expanded the
			// range of the scale
			me.max = helpers.max(ticks);
			me.min = helpers.min(ticks);

			if (tickOpts.reverse) {
				reverse = !reverse;
				me.start = me.max;
				me.end = me.min;
			} else {
				me.start = me.min;
				me.end = me.max;
			}
			if (reverse) {
				ticks.reverse();
			}
		},
		convertTicksToLabels: function() {
			this.tickValues = this.ticks.slice();

			Chart.Scale.prototype.convertTicksToLabels.call(this);
		},
		// Get the correct tooltip label
		getLabelForIndex: function(index, datasetIndex) {
			return +this.getRightValue(this.chart.data.datasets[datasetIndex].data[index]);
		},
		getPixelForTick: function(index) {
			return this.getPixelForValue(this.tickValues[index]);
		},
		/**
		 * Returns the value of the first tick.
		 * @param {Number} value - The minimum not zero value.
		 * @return {Number} The first tick value.
		 * @private
		 */
		_getFirstTickValue: function(value) {
			var exp = Math.floor(helpers.log10(value));
			var significand = Math.floor(value / Math.pow(10, exp));

			return significand * Math.pow(10, exp);
		},
		getPixelForValue: function(value) {
			var me = this;
			var reverse = me.options.ticks.reverse;
			var log10 = helpers.log10;
			var firstTickValue = me._getFirstTickValue(me.minNotZero);
			var offset = 0;
			var innerDimension, pixel, start, end, sign;

			value = +me.getRightValue(value);
			if (reverse) {
				start = me.end;
				end = me.start;
				sign = -1;
			} else {
				start = me.start;
				end = me.end;
				sign = 1;
			}
			if (me.isHorizontal()) {
				innerDimension = me.width;
				pixel = reverse ? me.right : me.left;
			} else {
				innerDimension = me.height;
				sign *= -1; // invert, since the upper-left corner of the canvas is at pixel (0, 0)
				pixel = reverse ? me.top : me.bottom;
			}
			if (value !== start) {
				if (start === 0) { // include zero tick
					offset = helpers.getValueOrDefault(
						me.options.ticks.fontSize,
						Chart.defaults.global.defaultFontSize
					);
					innerDimension -= offset;
					start = firstTickValue;
				}
				if (value !== 0) {
					offset += innerDimension / (log10(end) - log10(start)) * (log10(value) - log10(start));
				}
				pixel += sign * offset;
			}
			return pixel;
		},
		getValueForPixel: function(pixel) {
			var me = this;
			var reverse = me.options.ticks.reverse;
			var log10 = helpers.log10;
			var firstTickValue = me._getFirstTickValue(me.minNotZero);
			var innerDimension, start, end, value;

			if (reverse) {
				start = me.end;
				end = me.start;
			} else {
				start = me.start;
				end = me.end;
			}
			if (me.isHorizontal()) {
				innerDimension = me.width;
				value = reverse ? me.right - pixel : pixel - me.left;
			} else {
				innerDimension = me.height;
				value = reverse ? pixel - me.top : me.bottom - pixel;
			}
			if (value !== start) {
				if (start === 0) { // include zero tick
					var offset = helpers.getValueOrDefault(
						me.options.ticks.fontSize,
						Chart.defaults.global.defaultFontSize
					);
					value -= offset;
					innerDimension -= offset;
					start = firstTickValue;
				}
				value *= log10(end) - log10(start);
				value /= innerDimension;
				value = Math.pow(10, log10(start) + value);
			}
			return value;
		}
	});
	Chart.scaleService.registerScaleType('logarithmic', LogarithmicScale, defaultConfig);

};


/***/ }),
/* 684 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var defaults = __webpack_require__(20);
var helpers = __webpack_require__(15);
var Ticks = __webpack_require__(107);

module.exports = function(Chart) {

	var globalDefaults = defaults.global;

	var defaultConfig = {
		display: true,

		// Boolean - Whether to animate scaling the chart from the centre
		animate: true,
		position: 'chartArea',

		angleLines: {
			display: true,
			color: 'rgba(0, 0, 0, 0.1)',
			lineWidth: 1
		},

		gridLines: {
			circular: false
		},

		// label settings
		ticks: {
			// Boolean - Show a backdrop to the scale label
			showLabelBackdrop: true,

			// String - The colour of the label backdrop
			backdropColor: 'rgba(255,255,255,0.75)',

			// Number - The backdrop padding above & below the label in pixels
			backdropPaddingY: 2,

			// Number - The backdrop padding to the side of the label in pixels
			backdropPaddingX: 2,

			callback: Ticks.formatters.linear
		},

		pointLabels: {
			// Boolean - if true, show point labels
			display: true,

			// Number - Point label font size in pixels
			fontSize: 10,

			// Function - Used to convert point labels
			callback: function(label) {
				return label;
			}
		}
	};

	function getValueCount(scale) {
		var opts = scale.options;
		return opts.angleLines.display || opts.pointLabels.display ? scale.chart.data.labels.length : 0;
	}

	function getPointLabelFontOptions(scale) {
		var pointLabelOptions = scale.options.pointLabels;
		var fontSize = helpers.valueOrDefault(pointLabelOptions.fontSize, globalDefaults.defaultFontSize);
		var fontStyle = helpers.valueOrDefault(pointLabelOptions.fontStyle, globalDefaults.defaultFontStyle);
		var fontFamily = helpers.valueOrDefault(pointLabelOptions.fontFamily, globalDefaults.defaultFontFamily);
		var font = helpers.fontString(fontSize, fontStyle, fontFamily);

		return {
			size: fontSize,
			style: fontStyle,
			family: fontFamily,
			font: font
		};
	}

	function measureLabelSize(ctx, fontSize, label) {
		if (helpers.isArray(label)) {
			return {
				w: helpers.longestText(ctx, ctx.font, label),
				h: (label.length * fontSize) + ((label.length - 1) * 1.5 * fontSize)
			};
		}

		return {
			w: ctx.measureText(label).width,
			h: fontSize
		};
	}

	function determineLimits(angle, pos, size, min, max) {
		if (angle === min || angle === max) {
			return {
				start: pos - (size / 2),
				end: pos + (size / 2)
			};
		} else if (angle < min || angle > max) {
			return {
				start: pos - size - 5,
				end: pos
			};
		}

		return {
			start: pos,
			end: pos + size + 5
		};
	}

	/**
	 * Helper function to fit a radial linear scale with point labels
	 */
	function fitWithPointLabels(scale) {
		/*
		 * Right, this is really confusing and there is a lot of maths going on here
		 * The gist of the problem is here: https://gist.github.com/nnnick/696cc9c55f4b0beb8fe9
		 *
		 * Reaction: https://dl.dropboxusercontent.com/u/34601363/toomuchscience.gif
		 *
		 * Solution:
		 *
		 * We assume the radius of the polygon is half the size of the canvas at first
		 * at each index we check if the text overlaps.
		 *
		 * Where it does, we store that angle and that index.
		 *
		 * After finding the largest index and angle we calculate how much we need to remove
		 * from the shape radius to move the point inwards by that x.
		 *
		 * We average the left and right distances to get the maximum shape radius that can fit in the box
		 * along with labels.
		 *
		 * Once we have that, we can find the centre point for the chart, by taking the x text protrusion
		 * on each side, removing that from the size, halving it and adding the left x protrusion width.
		 *
		 * This will mean we have a shape fitted to the canvas, as large as it can be with the labels
		 * and position it in the most space efficient manner
		 *
		 * https://dl.dropboxusercontent.com/u/34601363/yeahscience.gif
		 */

		var plFont = getPointLabelFontOptions(scale);

		// Get maximum radius of the polygon. Either half the height (minus the text width) or half the width.
		// Use this to calculate the offset + change. - Make sure L/R protrusion is at least 0 to stop issues with centre points
		var largestPossibleRadius = Math.min(scale.height / 2, scale.width / 2);
		var furthestLimits = {
			r: scale.width,
			l: 0,
			t: scale.height,
			b: 0
		};
		var furthestAngles = {};
		var i, textSize, pointPosition;

		scale.ctx.font = plFont.font;
		scale._pointLabelSizes = [];

		var valueCount = getValueCount(scale);
		for (i = 0; i < valueCount; i++) {
			pointPosition = scale.getPointPosition(i, largestPossibleRadius);
			textSize = measureLabelSize(scale.ctx, plFont.size, scale.pointLabels[i] || '');
			scale._pointLabelSizes[i] = textSize;

			// Add quarter circle to make degree 0 mean top of circle
			var angleRadians = scale.getIndexAngle(i);
			var angle = helpers.toDegrees(angleRadians) % 360;
			var hLimits = determineLimits(angle, pointPosition.x, textSize.w, 0, 180);
			var vLimits = determineLimits(angle, pointPosition.y, textSize.h, 90, 270);

			if (hLimits.start < furthestLimits.l) {
				furthestLimits.l = hLimits.start;
				furthestAngles.l = angleRadians;
			}

			if (hLimits.end > furthestLimits.r) {
				furthestLimits.r = hLimits.end;
				furthestAngles.r = angleRadians;
			}

			if (vLimits.start < furthestLimits.t) {
				furthestLimits.t = vLimits.start;
				furthestAngles.t = angleRadians;
			}

			if (vLimits.end > furthestLimits.b) {
				furthestLimits.b = vLimits.end;
				furthestAngles.b = angleRadians;
			}
		}

		scale.setReductions(largestPossibleRadius, furthestLimits, furthestAngles);
	}

	/**
	 * Helper function to fit a radial linear scale with no point labels
	 */
	function fit(scale) {
		var largestPossibleRadius = Math.min(scale.height / 2, scale.width / 2);
		scale.drawingArea = Math.round(largestPossibleRadius);
		scale.setCenterPoint(0, 0, 0, 0);
	}

	function getTextAlignForAngle(angle) {
		if (angle === 0 || angle === 180) {
			return 'center';
		} else if (angle < 180) {
			return 'left';
		}

		return 'right';
	}

	function fillText(ctx, text, position, fontSize) {
		if (helpers.isArray(text)) {
			var y = position.y;
			var spacing = 1.5 * fontSize;

			for (var i = 0; i < text.length; ++i) {
				ctx.fillText(text[i], position.x, y);
				y += spacing;
			}
		} else {
			ctx.fillText(text, position.x, position.y);
		}
	}

	function adjustPointPositionForLabelHeight(angle, textSize, position) {
		if (angle === 90 || angle === 270) {
			position.y -= (textSize.h / 2);
		} else if (angle > 270 || angle < 90) {
			position.y -= textSize.h;
		}
	}

	function drawPointLabels(scale) {
		var ctx = scale.ctx;
		var opts = scale.options;
		var angleLineOpts = opts.angleLines;
		var pointLabelOpts = opts.pointLabels;

		ctx.lineWidth = angleLineOpts.lineWidth;
		ctx.strokeStyle = angleLineOpts.color;

		var outerDistance = scale.getDistanceFromCenterForValue(opts.ticks.reverse ? scale.min : scale.max);

		// Point Label Font
		var plFont = getPointLabelFontOptions(scale);

		ctx.textBaseline = 'top';

		for (var i = getValueCount(scale) - 1; i >= 0; i--) {
			if (angleLineOpts.display) {
				var outerPosition = scale.getPointPosition(i, outerDistance);
				ctx.beginPath();
				ctx.moveTo(scale.xCenter, scale.yCenter);
				ctx.lineTo(outerPosition.x, outerPosition.y);
				ctx.stroke();
				ctx.closePath();
			}

			if (pointLabelOpts.display) {
				// Extra 3px out for some label spacing
				var pointLabelPosition = scale.getPointPosition(i, outerDistance + 5);

				// Keep this in loop since we may support array properties here
				var pointLabelFontColor = helpers.valueAtIndexOrDefault(pointLabelOpts.fontColor, i, globalDefaults.defaultFontColor);
				ctx.font = plFont.font;
				ctx.fillStyle = pointLabelFontColor;

				var angleRadians = scale.getIndexAngle(i);
				var angle = helpers.toDegrees(angleRadians);
				ctx.textAlign = getTextAlignForAngle(angle);
				adjustPointPositionForLabelHeight(angle, scale._pointLabelSizes[i], pointLabelPosition);
				fillText(ctx, scale.pointLabels[i] || '', pointLabelPosition, plFont.size);
			}
		}
	}

	function drawRadiusLine(scale, gridLineOpts, radius, index) {
		var ctx = scale.ctx;
		ctx.strokeStyle = helpers.valueAtIndexOrDefault(gridLineOpts.color, index - 1);
		ctx.lineWidth = helpers.valueAtIndexOrDefault(gridLineOpts.lineWidth, index - 1);

		if (scale.options.gridLines.circular) {
			// Draw circular arcs between the points
			ctx.beginPath();
			ctx.arc(scale.xCenter, scale.yCenter, radius, 0, Math.PI * 2);
			ctx.closePath();
			ctx.stroke();
		} else {
			// Draw straight lines connecting each index
			var valueCount = getValueCount(scale);

			if (valueCount === 0) {
				return;
			}

			ctx.beginPath();
			var pointPosition = scale.getPointPosition(0, radius);
			ctx.moveTo(pointPosition.x, pointPosition.y);

			for (var i = 1; i < valueCount; i++) {
				pointPosition = scale.getPointPosition(i, radius);
				ctx.lineTo(pointPosition.x, pointPosition.y);
			}

			ctx.closePath();
			ctx.stroke();
		}
	}

	function numberOrZero(param) {
		return helpers.isNumber(param) ? param : 0;
	}

	var LinearRadialScale = Chart.LinearScaleBase.extend({
		setDimensions: function() {
			var me = this;
			var opts = me.options;
			var tickOpts = opts.ticks;
			// Set the unconstrained dimension before label rotation
			me.width = me.maxWidth;
			me.height = me.maxHeight;
			me.xCenter = Math.round(me.width / 2);
			me.yCenter = Math.round(me.height / 2);

			var minSize = helpers.min([me.height, me.width]);
			var tickFontSize = helpers.valueOrDefault(tickOpts.fontSize, globalDefaults.defaultFontSize);
			me.drawingArea = opts.display ? (minSize / 2) - (tickFontSize / 2 + tickOpts.backdropPaddingY) : (minSize / 2);
		},
		determineDataLimits: function() {
			var me = this;
			var chart = me.chart;
			var min = Number.POSITIVE_INFINITY;
			var max = Number.NEGATIVE_INFINITY;

			helpers.each(chart.data.datasets, function(dataset, datasetIndex) {
				if (chart.isDatasetVisible(datasetIndex)) {
					var meta = chart.getDatasetMeta(datasetIndex);

					helpers.each(dataset.data, function(rawValue, index) {
						var value = +me.getRightValue(rawValue);
						if (isNaN(value) || meta.data[index].hidden) {
							return;
						}

						min = Math.min(value, min);
						max = Math.max(value, max);
					});
				}
			});

			me.min = (min === Number.POSITIVE_INFINITY ? 0 : min);
			me.max = (max === Number.NEGATIVE_INFINITY ? 0 : max);

			// Common base implementation to handle ticks.min, ticks.max, ticks.beginAtZero
			me.handleTickRangeOptions();
		},
		getTickLimit: function() {
			var tickOpts = this.options.ticks;
			var tickFontSize = helpers.valueOrDefault(tickOpts.fontSize, globalDefaults.defaultFontSize);
			return Math.min(tickOpts.maxTicksLimit ? tickOpts.maxTicksLimit : 11, Math.ceil(this.drawingArea / (1.5 * tickFontSize)));
		},
		convertTicksToLabels: function() {
			var me = this;

			Chart.LinearScaleBase.prototype.convertTicksToLabels.call(me);

			// Point labels
			me.pointLabels = me.chart.data.labels.map(me.options.pointLabels.callback, me);
		},
		getLabelForIndex: function(index, datasetIndex) {
			return +this.getRightValue(this.chart.data.datasets[datasetIndex].data[index]);
		},
		fit: function() {
			if (this.options.pointLabels.display) {
				fitWithPointLabels(this);
			} else {
				fit(this);
			}
		},
		/**
		 * Set radius reductions and determine new radius and center point
		 * @private
		 */
		setReductions: function(largestPossibleRadius, furthestLimits, furthestAngles) {
			var me = this;
			var radiusReductionLeft = furthestLimits.l / Math.sin(furthestAngles.l);
			var radiusReductionRight = Math.max(furthestLimits.r - me.width, 0) / Math.sin(furthestAngles.r);
			var radiusReductionTop = -furthestLimits.t / Math.cos(furthestAngles.t);
			var radiusReductionBottom = -Math.max(furthestLimits.b - me.height, 0) / Math.cos(furthestAngles.b);

			radiusReductionLeft = numberOrZero(radiusReductionLeft);
			radiusReductionRight = numberOrZero(radiusReductionRight);
			radiusReductionTop = numberOrZero(radiusReductionTop);
			radiusReductionBottom = numberOrZero(radiusReductionBottom);

			me.drawingArea = Math.min(
				Math.round(largestPossibleRadius - (radiusReductionLeft + radiusReductionRight) / 2),
				Math.round(largestPossibleRadius - (radiusReductionTop + radiusReductionBottom) / 2));
			me.setCenterPoint(radiusReductionLeft, radiusReductionRight, radiusReductionTop, radiusReductionBottom);
		},
		setCenterPoint: function(leftMovement, rightMovement, topMovement, bottomMovement) {
			var me = this;
			var maxRight = me.width - rightMovement - me.drawingArea;
			var maxLeft = leftMovement + me.drawingArea;
			var maxTop = topMovement + me.drawingArea;
			var maxBottom = me.height - bottomMovement - me.drawingArea;

			me.xCenter = Math.round(((maxLeft + maxRight) / 2) + me.left);
			me.yCenter = Math.round(((maxTop + maxBottom) / 2) + me.top);
		},

		getIndexAngle: function(index) {
			var angleMultiplier = (Math.PI * 2) / getValueCount(this);
			var startAngle = this.chart.options && this.chart.options.startAngle ?
				this.chart.options.startAngle :
				0;

			var startAngleRadians = startAngle * Math.PI * 2 / 360;

			// Start from the top instead of right, so remove a quarter of the circle
			return index * angleMultiplier + startAngleRadians;
		},
		getDistanceFromCenterForValue: function(value) {
			var me = this;

			if (value === null) {
				return 0; // null always in center
			}

			// Take into account half font size + the yPadding of the top value
			var scalingFactor = me.drawingArea / (me.max - me.min);
			if (me.options.ticks.reverse) {
				return (me.max - value) * scalingFactor;
			}
			return (value - me.min) * scalingFactor;
		},
		getPointPosition: function(index, distanceFromCenter) {
			var me = this;
			var thisAngle = me.getIndexAngle(index) - (Math.PI / 2);
			return {
				x: Math.round(Math.cos(thisAngle) * distanceFromCenter) + me.xCenter,
				y: Math.round(Math.sin(thisAngle) * distanceFromCenter) + me.yCenter
			};
		},
		getPointPositionForValue: function(index, value) {
			return this.getPointPosition(index, this.getDistanceFromCenterForValue(value));
		},

		getBasePosition: function() {
			var me = this;
			var min = me.min;
			var max = me.max;

			return me.getPointPositionForValue(0,
				me.beginAtZero ? 0 :
				min < 0 && max < 0 ? max :
				min > 0 && max > 0 ? min :
				0);
		},

		draw: function() {
			var me = this;
			var opts = me.options;
			var gridLineOpts = opts.gridLines;
			var tickOpts = opts.ticks;
			var valueOrDefault = helpers.valueOrDefault;

			if (opts.display) {
				var ctx = me.ctx;
				var startAngle = this.getIndexAngle(0);

				// Tick Font
				var tickFontSize = valueOrDefault(tickOpts.fontSize, globalDefaults.defaultFontSize);
				var tickFontStyle = valueOrDefault(tickOpts.fontStyle, globalDefaults.defaultFontStyle);
				var tickFontFamily = valueOrDefault(tickOpts.fontFamily, globalDefaults.defaultFontFamily);
				var tickLabelFont = helpers.fontString(tickFontSize, tickFontStyle, tickFontFamily);

				helpers.each(me.ticks, function(label, index) {
					// Don't draw a centre value (if it is minimum)
					if (index > 0 || tickOpts.reverse) {
						var yCenterOffset = me.getDistanceFromCenterForValue(me.ticksAsNumbers[index]);

						// Draw circular lines around the scale
						if (gridLineOpts.display && index !== 0) {
							drawRadiusLine(me, gridLineOpts, yCenterOffset, index);
						}

						if (tickOpts.display) {
							var tickFontColor = valueOrDefault(tickOpts.fontColor, globalDefaults.defaultFontColor);
							ctx.font = tickLabelFont;

							ctx.save();
							ctx.translate(me.xCenter, me.yCenter);
							ctx.rotate(startAngle);

							if (tickOpts.showLabelBackdrop) {
								var labelWidth = ctx.measureText(label).width;
								ctx.fillStyle = tickOpts.backdropColor;
								ctx.fillRect(
									-labelWidth / 2 - tickOpts.backdropPaddingX,
									-yCenterOffset - tickFontSize / 2 - tickOpts.backdropPaddingY,
									labelWidth + tickOpts.backdropPaddingX * 2,
									tickFontSize + tickOpts.backdropPaddingY * 2
								);
							}

							ctx.textAlign = 'center';
							ctx.textBaseline = 'middle';
							ctx.fillStyle = tickFontColor;
							ctx.fillText(label, 0, -yCenterOffset);
							ctx.restore();
						}
					}
				});

				if (opts.angleLines.display || opts.pointLabels.display) {
					drawPointLabels(me);
				}
			}
		}
	});
	Chart.scaleService.registerScaleType('radialLinear', LinearRadialScale, defaultConfig);

};


/***/ }),
/* 685 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* global window: false */


var moment = __webpack_require__(34);
moment = typeof moment === 'function' ? moment : window.moment;

var defaults = __webpack_require__(20);
var helpers = __webpack_require__(15);

// Integer constants are from the ES6 spec.
var MIN_INTEGER = Number.MIN_SAFE_INTEGER || -9007199254740991;
var MAX_INTEGER = Number.MAX_SAFE_INTEGER || 9007199254740991;

var INTERVALS = {
	millisecond: {
		common: true,
		size: 1,
		steps: [1, 2, 5, 10, 20, 50, 100, 250, 500]
	},
	second: {
		common: true,
		size: 1000,
		steps: [1, 2, 5, 10, 30]
	},
	minute: {
		common: true,
		size: 60000,
		steps: [1, 2, 5, 10, 30]
	},
	hour: {
		common: true,
		size: 3600000,
		steps: [1, 2, 3, 6, 12]
	},
	day: {
		common: true,
		size: 86400000,
		steps: [1, 2, 5]
	},
	week: {
		common: false,
		size: 604800000,
		steps: [1, 2, 3, 4]
	},
	month: {
		common: true,
		size: 2.628e9,
		steps: [1, 2, 3]
	},
	quarter: {
		common: false,
		size: 7.884e9,
		steps: [1, 2, 3, 4]
	},
	year: {
		common: true,
		size: 3.154e10
	}
};

var UNITS = Object.keys(INTERVALS);

function sorter(a, b) {
	return a - b;
}

function arrayUnique(items) {
	var hash = {};
	var out = [];
	var i, ilen, item;

	for (i = 0, ilen = items.length; i < ilen; ++i) {
		item = items[i];
		if (!hash[item]) {
			hash[item] = true;
			out.push(item);
		}
	}

	return out;
}

/**
 * Returns an array of {time, pos} objects used to interpolate a specific `time` or position
 * (`pos`) on the scale, by searching entries before and after the requested value. `pos` is
 * a decimal between 0 and 1: 0 being the start of the scale (left or top) and 1 the other
 * extremity (left + width or top + height). Note that it would be more optimized to directly
 * store pre-computed pixels, but the scale dimensions are not guaranteed at the time we need
 * to create the lookup table. The table ALWAYS contains at least two items: min and max.
 *
 * @param {Number[]} timestamps - timestamps sorted from lowest to highest.
 * @param {String} distribution - If 'linear', timestamps will be spread linearly along the min
 * and max range, so basically, the table will contains only two items: {min, 0} and {max, 1}.
 * If 'series', timestamps will be positioned at the same distance from each other. In this
 * case, only timestamps that break the time linearity are registered, meaning that in the
 * best case, all timestamps are linear, the table contains only min and max.
 */
function buildLookupTable(timestamps, min, max, distribution) {
	if (distribution === 'linear' || !timestamps.length) {
		return [
			{time: min, pos: 0},
			{time: max, pos: 1}
		];
	}

	var table = [];
	var items = [min];
	var i, ilen, prev, curr, next;

	for (i = 0, ilen = timestamps.length; i < ilen; ++i) {
		curr = timestamps[i];
		if (curr > min && curr < max) {
			items.push(curr);
		}
	}

	items.push(max);

	for (i = 0, ilen = items.length; i < ilen; ++i) {
		next = items[i + 1];
		prev = items[i - 1];
		curr = items[i];

		// only add points that breaks the scale linearity
		if (prev === undefined || next === undefined || Math.round((next + prev) / 2) !== curr) {
			table.push({time: curr, pos: i / (ilen - 1)});
		}
	}

	return table;
}

// @see adapted from http://www.anujgakhar.com/2014/03/01/binary-search-in-javascript/
function lookup(table, key, value) {
	var lo = 0;
	var hi = table.length - 1;
	var mid, i0, i1;

	while (lo >= 0 && lo <= hi) {
		mid = (lo + hi) >> 1;
		i0 = table[mid - 1] || null;
		i1 = table[mid];

		if (!i0) {
			// given value is outside table (before first item)
			return {lo: null, hi: i1};
		} else if (i1[key] < value) {
			lo = mid + 1;
		} else if (i0[key] > value) {
			hi = mid - 1;
		} else {
			return {lo: i0, hi: i1};
		}
	}

	// given value is outside table (after last item)
	return {lo: i1, hi: null};
}

/**
 * Linearly interpolates the given source `value` using the table items `skey` values and
 * returns the associated `tkey` value. For example, interpolate(table, 'time', 42, 'pos')
 * returns the position for a timestamp equal to 42. If value is out of bounds, values at
 * index [0, 1] or [n - 1, n] are used for the interpolation.
 */
function interpolate(table, skey, sval, tkey) {
	var range = lookup(table, skey, sval);

	// Note: the lookup table ALWAYS contains at least 2 items (min and max)
	var prev = !range.lo ? table[0] : !range.hi ? table[table.length - 2] : range.lo;
	var next = !range.lo ? table[1] : !range.hi ? table[table.length - 1] : range.hi;

	var span = next[skey] - prev[skey];
	var ratio = span ? (sval - prev[skey]) / span : 0;
	var offset = (next[tkey] - prev[tkey]) * ratio;

	return prev[tkey] + offset;
}

/**
 * Convert the given value to a moment object using the given time options.
 * @see http://momentjs.com/docs/#/parsing/
 */
function momentify(value, options) {
	var parser = options.parser;
	var format = options.parser || options.format;

	if (typeof parser === 'function') {
		return parser(value);
	}

	if (typeof value === 'string' && typeof format === 'string') {
		return moment(value, format);
	}

	if (!(value instanceof moment)) {
		value = moment(value);
	}

	if (value.isValid()) {
		return value;
	}

	// Labels are in an incompatible moment format and no `parser` has been provided.
	// The user might still use the deprecated `format` option to convert his inputs.
	if (typeof format === 'function') {
		return format(value);
	}

	return value;
}

function parse(input, scale) {
	if (helpers.isNullOrUndef(input)) {
		return null;
	}

	var options = scale.options.time;
	var value = momentify(scale.getRightValue(input), options);
	if (!value.isValid()) {
		return null;
	}

	if (options.round) {
		value.startOf(options.round);
	}

	return value.valueOf();
}

/**
 * Returns the number of unit to skip to be able to display up to `capacity` number of ticks
 * in `unit` for the given `min` / `max` range and respecting the interval steps constraints.
 */
function determineStepSize(min, max, unit, capacity) {
	var range = max - min;
	var interval = INTERVALS[unit];
	var milliseconds = interval.size;
	var steps = interval.steps;
	var i, ilen, factor;

	if (!steps) {
		return Math.ceil(range / (capacity * milliseconds));
	}

	for (i = 0, ilen = steps.length; i < ilen; ++i) {
		factor = steps[i];
		if (Math.ceil(range / (milliseconds * factor)) <= capacity) {
			break;
		}
	}

	return factor;
}

/**
 * Figures out what unit results in an appropriate number of auto-generated ticks
 */
function determineUnitForAutoTicks(minUnit, min, max, capacity) {
	var ilen = UNITS.length;
	var i, interval, factor;

	for (i = UNITS.indexOf(minUnit); i < ilen - 1; ++i) {
		interval = INTERVALS[UNITS[i]];
		factor = interval.steps ? interval.steps[interval.steps.length - 1] : MAX_INTEGER;

		if (interval.common && Math.ceil((max - min) / (factor * interval.size)) <= capacity) {
			return UNITS[i];
		}
	}

	return UNITS[ilen - 1];
}

/**
 * Figures out what unit to format a set of ticks with
 */
function determineUnitForFormatting(ticks, minUnit, min, max) {
	var duration = moment.duration(moment(max).diff(moment(min)));
	var ilen = UNITS.length;
	var i, unit;

	for (i = ilen - 1; i >= UNITS.indexOf(minUnit); i--) {
		unit = UNITS[i];
		if (INTERVALS[unit].common && duration.as(unit) >= ticks.length) {
			return unit;
		}
	}

	return UNITS[minUnit ? UNITS.indexOf(minUnit) : 0];
}

function determineMajorUnit(unit) {
	for (var i = UNITS.indexOf(unit) + 1, ilen = UNITS.length; i < ilen; ++i) {
		if (INTERVALS[UNITS[i]].common) {
			return UNITS[i];
		}
	}
}

/**
 * Generates a maximum of `capacity` timestamps between min and max, rounded to the
 * `minor` unit, aligned on the `major` unit and using the given scale time `options`.
 * Important: this method can return ticks outside the min and max range, it's the
 * responsibility of the calling code to clamp values if needed.
 */
function generate(min, max, capacity, options) {
	var timeOpts = options.time;
	var minor = timeOpts.unit || determineUnitForAutoTicks(timeOpts.minUnit, min, max, capacity);
	var major = determineMajorUnit(minor);
	var stepSize = helpers.valueOrDefault(timeOpts.stepSize, timeOpts.unitStepSize);
	var weekday = minor === 'week' ? timeOpts.isoWeekday : false;
	var majorTicksEnabled = options.ticks.major.enabled;
	var interval = INTERVALS[minor];
	var first = moment(min);
	var last = moment(max);
	var ticks = [];
	var time;

	if (!stepSize) {
		stepSize = determineStepSize(min, max, minor, capacity);
	}

	// For 'week' unit, handle the first day of week option
	if (weekday) {
		first = first.isoWeekday(weekday);
		last = last.isoWeekday(weekday);
	}

	// Align first/last ticks on unit
	first = first.startOf(weekday ? 'day' : minor);
	last = last.startOf(weekday ? 'day' : minor);

	// Make sure that the last tick include max
	if (last < max) {
		last.add(1, minor);
	}

	time = moment(first);

	if (majorTicksEnabled && major && !weekday && !timeOpts.round) {
		// Align the first tick on the previous `minor` unit aligned on the `major` unit:
		// we first aligned time on the previous `major` unit then add the number of full
		// stepSize there is between first and the previous major time.
		time.startOf(major);
		time.add(~~((first - time) / (interval.size * stepSize)) * stepSize, minor);
	}

	for (; time < last; time.add(stepSize, minor)) {
		ticks.push(+time);
	}

	ticks.push(+time);

	return ticks;
}

/**
 * Returns the right and left offsets from edges in the form of {left, right}.
 * Offsets are added when the `offset` option is true.
 */
function computeOffsets(table, ticks, min, max, options) {
	var left = 0;
	var right = 0;
	var upper, lower;

	if (options.offset && ticks.length) {
		if (!options.time.min) {
			upper = ticks.length > 1 ? ticks[1] : max;
			lower = ticks[0];
			left = (
				interpolate(table, 'time', upper, 'pos') -
				interpolate(table, 'time', lower, 'pos')
			) / 2;
		}
		if (!options.time.max) {
			upper = ticks[ticks.length - 1];
			lower = ticks.length > 1 ? ticks[ticks.length - 2] : min;
			right = (
				interpolate(table, 'time', upper, 'pos') -
				interpolate(table, 'time', lower, 'pos')
			) / 2;
		}
	}

	return {left: left, right: right};
}

function ticksFromTimestamps(values, majorUnit) {
	var ticks = [];
	var i, ilen, value, major;

	for (i = 0, ilen = values.length; i < ilen; ++i) {
		value = values[i];
		major = majorUnit ? value === +moment(value).startOf(majorUnit) : false;

		ticks.push({
			value: value,
			major: major
		});
	}

	return ticks;
}

function determineLabelFormat(data, timeOpts) {
	var i, momentDate, hasTime;
	var ilen = data.length;

	// find the label with the most parts (milliseconds, minutes, etc.)
	// format all labels with the same level of detail as the most specific label
	for (i = 0; i < ilen; i++) {
		momentDate = momentify(data[i], timeOpts);
		if (momentDate.millisecond() !== 0) {
			return 'MMM D, YYYY h:mm:ss.SSS a';
		}
		if (momentDate.second() !== 0 || momentDate.minute() !== 0 || momentDate.hour() !== 0) {
			hasTime = true;
		}
	}
	if (hasTime) {
		return 'MMM D, YYYY h:mm:ss a';
	}
	return 'MMM D, YYYY';
}

module.exports = function(Chart) {

	var defaultConfig = {
		position: 'bottom',

		/**
		 * Data distribution along the scale:
		 * - 'linear': data are spread according to their time (distances can vary),
		 * - 'series': data are spread at the same distance from each other.
		 * @see https://github.com/chartjs/Chart.js/pull/4507
		 * @since 2.7.0
		 */
		distribution: 'linear',

		/**
		 * Scale boundary strategy (bypassed by min/max time options)
		 * - `data`: make sure data are fully visible, ticks outside are removed
		 * - `ticks`: make sure ticks are fully visible, data outside are truncated
		 * @see https://github.com/chartjs/Chart.js/pull/4556
		 * @since 2.7.0
		 */
		bounds: 'data',

		time: {
			parser: false, // false == a pattern string from http://momentjs.com/docs/#/parsing/string-format/ or a custom callback that converts its argument to a moment
			format: false, // DEPRECATED false == date objects, moment object, callback or a pattern string from http://momentjs.com/docs/#/parsing/string-format/
			unit: false, // false == automatic or override with week, month, year, etc.
			round: false, // none, or override with week, month, year, etc.
			displayFormat: false, // DEPRECATED
			isoWeekday: false, // override week start day - see http://momentjs.com/docs/#/get-set/iso-weekday/
			minUnit: 'millisecond',

			// defaults to unit's corresponding unitFormat below or override using pattern string from http://momentjs.com/docs/#/displaying/format/
			displayFormats: {
				millisecond: 'h:mm:ss.SSS a', // 11:20:01.123 AM,
				second: 'h:mm:ss a', // 11:20:01 AM
				minute: 'h:mm a', // 11:20 AM
				hour: 'hA', // 5PM
				day: 'MMM D', // Sep 4
				week: 'll', // Week 46, or maybe "[W]WW - YYYY" ?
				month: 'MMM YYYY', // Sept 2015
				quarter: '[Q]Q - YYYY', // Q3
				year: 'YYYY' // 2015
			},
		},
		ticks: {
			autoSkip: false,

			/**
			 * Ticks generation input values:
			 * - 'auto': generates "optimal" ticks based on scale size and time options.
			 * - 'data': generates ticks from data (including labels from data {t|x|y} objects).
			 * - 'labels': generates ticks from user given `data.labels` values ONLY.
			 * @see https://github.com/chartjs/Chart.js/pull/4507
			 * @since 2.7.0
			 */
			source: 'auto',

			major: {
				enabled: false
			}
		}
	};

	var TimeScale = Chart.Scale.extend({
		initialize: function() {
			if (!moment) {
				throw new Error('Chart.js - Moment.js could not be found! You must include it before Chart.js to use the time scale. Download at https://momentjs.com');
			}

			this.mergeTicksOptions();

			Chart.Scale.prototype.initialize.call(this);
		},

		update: function() {
			var me = this;
			var options = me.options;

			// DEPRECATIONS: output a message only one time per update
			if (options.time && options.time.format) {
				console.warn('options.time.format is deprecated and replaced by options.time.parser.');
			}

			return Chart.Scale.prototype.update.apply(me, arguments);
		},

		/**
		 * Allows data to be referenced via 't' attribute
		 */
		getRightValue: function(rawValue) {
			if (rawValue && rawValue.t !== undefined) {
				rawValue = rawValue.t;
			}
			return Chart.Scale.prototype.getRightValue.call(this, rawValue);
		},

		determineDataLimits: function() {
			var me = this;
			var chart = me.chart;
			var timeOpts = me.options.time;
			var unit = timeOpts.unit || 'day';
			var min = MAX_INTEGER;
			var max = MIN_INTEGER;
			var timestamps = [];
			var datasets = [];
			var labels = [];
			var i, j, ilen, jlen, data, timestamp;

			// Convert labels to timestamps
			for (i = 0, ilen = chart.data.labels.length; i < ilen; ++i) {
				labels.push(parse(chart.data.labels[i], me));
			}

			// Convert data to timestamps
			for (i = 0, ilen = (chart.data.datasets || []).length; i < ilen; ++i) {
				if (chart.isDatasetVisible(i)) {
					data = chart.data.datasets[i].data;

					// Let's consider that all data have the same format.
					if (helpers.isObject(data[0])) {
						datasets[i] = [];

						for (j = 0, jlen = data.length; j < jlen; ++j) {
							timestamp = parse(data[j], me);
							timestamps.push(timestamp);
							datasets[i][j] = timestamp;
						}
					} else {
						timestamps.push.apply(timestamps, labels);
						datasets[i] = labels.slice(0);
					}
				} else {
					datasets[i] = [];
				}
			}

			if (labels.length) {
				// Sort labels **after** data have been converted
				labels = arrayUnique(labels).sort(sorter);
				min = Math.min(min, labels[0]);
				max = Math.max(max, labels[labels.length - 1]);
			}

			if (timestamps.length) {
				timestamps = arrayUnique(timestamps).sort(sorter);
				min = Math.min(min, timestamps[0]);
				max = Math.max(max, timestamps[timestamps.length - 1]);
			}

			min = parse(timeOpts.min, me) || min;
			max = parse(timeOpts.max, me) || max;

			// In case there is no valid min/max, set limits based on unit time option
			min = min === MAX_INTEGER ? +moment().startOf(unit) : min;
			max = max === MIN_INTEGER ? +moment().endOf(unit) + 1 : max;

			// Make sure that max is strictly higher than min (required by the lookup table)
			me.min = Math.min(min, max);
			me.max = Math.max(min + 1, max);

			// PRIVATE
			me._horizontal = me.isHorizontal();
			me._table = [];
			me._timestamps = {
				data: timestamps,
				datasets: datasets,
				labels: labels
			};
		},

		buildTicks: function() {
			var me = this;
			var min = me.min;
			var max = me.max;
			var options = me.options;
			var timeOpts = options.time;
			var timestamps = [];
			var ticks = [];
			var i, ilen, timestamp;

			switch (options.ticks.source) {
			case 'data':
				timestamps = me._timestamps.data;
				break;
			case 'labels':
				timestamps = me._timestamps.labels;
				break;
			case 'auto':
			default:
				timestamps = generate(min, max, me.getLabelCapacity(min), options);
			}

			if (options.bounds === 'ticks' && timestamps.length) {
				min = timestamps[0];
				max = timestamps[timestamps.length - 1];
			}

			// Enforce limits with user min/max options
			min = parse(timeOpts.min, me) || min;
			max = parse(timeOpts.max, me) || max;

			// Remove ticks outside the min/max range
			for (i = 0, ilen = timestamps.length; i < ilen; ++i) {
				timestamp = timestamps[i];
				if (timestamp >= min && timestamp <= max) {
					ticks.push(timestamp);
				}
			}

			me.min = min;
			me.max = max;

			// PRIVATE
			me._unit = timeOpts.unit || determineUnitForFormatting(ticks, timeOpts.minUnit, me.min, me.max);
			me._majorUnit = determineMajorUnit(me._unit);
			me._table = buildLookupTable(me._timestamps.data, min, max, options.distribution);
			me._offsets = computeOffsets(me._table, ticks, min, max, options);
			me._labelFormat = determineLabelFormat(me._timestamps.data, timeOpts);

			return ticksFromTimestamps(ticks, me._majorUnit);
		},

		getLabelForIndex: function(index, datasetIndex) {
			var me = this;
			var data = me.chart.data;
			var timeOpts = me.options.time;
			var label = data.labels && index < data.labels.length ? data.labels[index] : '';
			var value = data.datasets[datasetIndex].data[index];

			if (helpers.isObject(value)) {
				label = me.getRightValue(value);
			}
			if (timeOpts.tooltipFormat) {
				return momentify(label, timeOpts).format(timeOpts.tooltipFormat);
			}
			if (typeof label === 'string') {
				return label;
			}

			return momentify(label, timeOpts).format(me._labelFormat);
		},

		/**
		 * Function to format an individual tick mark
		 * @private
		 */
		tickFormatFunction: function(tick, index, ticks, formatOverride) {
			var me = this;
			var options = me.options;
			var time = tick.valueOf();
			var formats = options.time.displayFormats;
			var minorFormat = formats[me._unit];
			var majorUnit = me._majorUnit;
			var majorFormat = formats[majorUnit];
			var majorTime = tick.clone().startOf(majorUnit).valueOf();
			var majorTickOpts = options.ticks.major;
			var major = majorTickOpts.enabled && majorUnit && majorFormat && time === majorTime;
			var label = tick.format(formatOverride ? formatOverride : major ? majorFormat : minorFormat);
			var tickOpts = major ? majorTickOpts : options.ticks.minor;
			var formatter = helpers.valueOrDefault(tickOpts.callback, tickOpts.userCallback);

			return formatter ? formatter(label, index, ticks) : label;
		},

		convertTicksToLabels: function(ticks) {
			var labels = [];
			var i, ilen;

			for (i = 0, ilen = ticks.length; i < ilen; ++i) {
				labels.push(this.tickFormatFunction(moment(ticks[i].value), i, ticks));
			}

			return labels;
		},

		/**
		 * @private
		 */
		getPixelForOffset: function(time) {
			var me = this;
			var size = me._horizontal ? me.width : me.height;
			var start = me._horizontal ? me.left : me.top;
			var pos = interpolate(me._table, 'time', time, 'pos');

			return start + size * (me._offsets.left + pos) / (me._offsets.left + 1 + me._offsets.right);
		},

		getPixelForValue: function(value, index, datasetIndex) {
			var me = this;
			var time = null;

			if (index !== undefined && datasetIndex !== undefined) {
				time = me._timestamps.datasets[datasetIndex][index];
			}

			if (time === null) {
				time = parse(value, me);
			}

			if (time !== null) {
				return me.getPixelForOffset(time);
			}
		},

		getPixelForTick: function(index) {
			var ticks = this.getTicks();
			return index >= 0 && index < ticks.length ?
				this.getPixelForOffset(ticks[index].value) :
				null;
		},

		getValueForPixel: function(pixel) {
			var me = this;
			var size = me._horizontal ? me.width : me.height;
			var start = me._horizontal ? me.left : me.top;
			var pos = (size ? (pixel - start) / size : 0) * (me._offsets.left + 1 + me._offsets.left) - me._offsets.right;
			var time = interpolate(me._table, 'pos', pos, 'time');

			return moment(time);
		},

		/**
		 * Crude approximation of what the label width might be
		 * @private
		 */
		getLabelWidth: function(label) {
			var me = this;
			var ticksOpts = me.options.ticks;
			var tickLabelWidth = me.ctx.measureText(label).width;
			var angle = helpers.toRadians(ticksOpts.maxRotation);
			var cosRotation = Math.cos(angle);
			var sinRotation = Math.sin(angle);
			var tickFontSize = helpers.valueOrDefault(ticksOpts.fontSize, defaults.global.defaultFontSize);

			return (tickLabelWidth * cosRotation) + (tickFontSize * sinRotation);
		},

		/**
		 * @private
		 */
		getLabelCapacity: function(exampleTime) {
			var me = this;

			var formatOverride = me.options.time.displayFormats.millisecond;	// Pick the longest format for guestimation

			var exampleLabel = me.tickFormatFunction(moment(exampleTime), 0, [], formatOverride);
			var tickLabelWidth = me.getLabelWidth(exampleLabel);
			var innerWidth = me.isHorizontal() ? me.width : me.height;

			var capacity = Math.floor(innerWidth / tickLabelWidth);
			return capacity > 0 ? capacity : 1;
		}
	});

	Chart.scaleService.registerScaleType('time', TimeScale, defaultConfig);
};


/***/ }),
/* 686 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var defaults = __webpack_require__(20);
var elements = __webpack_require__(55);
var helpers = __webpack_require__(15);

defaults._set('bar', {
	hover: {
		mode: 'label'
	},

	scales: {
		xAxes: [{
			type: 'category',

			// Specific to Bar Controller
			categoryPercentage: 0.8,
			barPercentage: 0.9,

			// offset settings
			offset: true,

			// grid line settings
			gridLines: {
				offsetGridLines: true
			}
		}],

		yAxes: [{
			type: 'linear'
		}]
	}
});

defaults._set('horizontalBar', {
	hover: {
		mode: 'index',
		axis: 'y'
	},

	scales: {
		xAxes: [{
			type: 'linear',
			position: 'bottom'
		}],

		yAxes: [{
			position: 'left',
			type: 'category',

			// Specific to Horizontal Bar Controller
			categoryPercentage: 0.8,
			barPercentage: 0.9,

			// offset settings
			offset: true,

			// grid line settings
			gridLines: {
				offsetGridLines: true
			}
		}]
	},

	elements: {
		rectangle: {
			borderSkipped: 'left'
		}
	},

	tooltips: {
		callbacks: {
			title: function(item, data) {
				// Pick first xLabel for now
				var title = '';

				if (item.length > 0) {
					if (item[0].yLabel) {
						title = item[0].yLabel;
					} else if (data.labels.length > 0 && item[0].index < data.labels.length) {
						title = data.labels[item[0].index];
					}
				}

				return title;
			},

			label: function(item, data) {
				var datasetLabel = data.datasets[item.datasetIndex].label || '';
				return datasetLabel + ': ' + item.xLabel;
			}
		},
		mode: 'index',
		axis: 'y'
	}
});

/**
 * Computes the "optimal" sample size to maintain bars equally sized while preventing overlap.
 * @private
 */
function computeMinSampleSize(scale, pixels) {
	var min = scale.isHorizontal() ? scale.width : scale.height;
	var ticks = scale.getTicks();
	var prev, curr, i, ilen;

	for (i = 1, ilen = pixels.length; i < ilen; ++i) {
		min = Math.min(min, pixels[i] - pixels[i - 1]);
	}

	for (i = 0, ilen = ticks.length; i < ilen; ++i) {
		curr = scale.getPixelForTick(i);
		min = i > 0 ? Math.min(min, curr - prev) : min;
		prev = curr;
	}

	return min;
}

/**
 * Computes an "ideal" category based on the absolute bar thickness or, if undefined or null,
 * uses the smallest interval (see computeMinSampleSize) that prevents bar overlapping. This
 * mode currently always generates bars equally sized (until we introduce scriptable options?).
 * @private
 */
function computeFitCategoryTraits(index, ruler, options) {
	var thickness = options.barThickness;
	var count = ruler.stackCount;
	var curr = ruler.pixels[index];
	var size, ratio;

	if (helpers.isNullOrUndef(thickness)) {
		size = ruler.min * options.categoryPercentage;
		ratio = options.barPercentage;
	} else {
		// When bar thickness is enforced, category and bar percentages are ignored.
		// Note(SB): we could add support for relative bar thickness (e.g. barThickness: '50%')
		// and deprecate barPercentage since this value is ignored when thickness is absolute.
		size = thickness * count;
		ratio = 1;
	}

	return {
		chunk: size / count,
		ratio: ratio,
		start: curr - (size / 2)
	};
}

/**
 * Computes an "optimal" category that globally arranges bars side by side (no gap when
 * percentage options are 1), based on the previous and following categories. This mode
 * generates bars with different widths when data are not evenly spaced.
 * @private
 */
function computeFlexCategoryTraits(index, ruler, options) {
	var pixels = ruler.pixels;
	var curr = pixels[index];
	var prev = index > 0 ? pixels[index - 1] : null;
	var next = index < pixels.length - 1 ? pixels[index + 1] : null;
	var percent = options.categoryPercentage;
	var start, size;

	if (prev === null) {
		// first data: its size is double based on the next point or,
		// if it's also the last data, we use the scale end extremity.
		prev = curr - (next === null ? ruler.end - curr : next - curr);
	}

	if (next === null) {
		// last data: its size is also double based on the previous point.
		next = curr + curr - prev;
	}

	start = curr - ((curr - prev) / 2) * percent;
	size = ((next - prev) / 2) * percent;

	return {
		chunk: size / ruler.stackCount,
		ratio: options.barPercentage,
		start: start
	};
}

module.exports = function(Chart) {

	Chart.controllers.bar = Chart.DatasetController.extend({

		dataElementType: elements.Rectangle,

		initialize: function() {
			var me = this;
			var meta;

			Chart.DatasetController.prototype.initialize.apply(me, arguments);

			meta = me.getMeta();
			meta.stack = me.getDataset().stack;
			meta.bar = true;
		},

		update: function(reset) {
			var me = this;
			var rects = me.getMeta().data;
			var i, ilen;

			me._ruler = me.getRuler();

			for (i = 0, ilen = rects.length; i < ilen; ++i) {
				me.updateElement(rects[i], i, reset);
			}
		},

		updateElement: function(rectangle, index, reset) {
			var me = this;
			var chart = me.chart;
			var meta = me.getMeta();
			var dataset = me.getDataset();
			var custom = rectangle.custom || {};
			var rectangleOptions = chart.options.elements.rectangle;

			rectangle._xScale = me.getScaleForId(meta.xAxisID);
			rectangle._yScale = me.getScaleForId(meta.yAxisID);
			rectangle._datasetIndex = me.index;
			rectangle._index = index;

			rectangle._model = {
				datasetLabel: dataset.label,
				label: chart.data.labels[index],
				borderSkipped: custom.borderSkipped ? custom.borderSkipped : rectangleOptions.borderSkipped,
				backgroundColor: custom.backgroundColor ? custom.backgroundColor : helpers.valueAtIndexOrDefault(dataset.backgroundColor, index, rectangleOptions.backgroundColor),
				borderColor: custom.borderColor ? custom.borderColor : helpers.valueAtIndexOrDefault(dataset.borderColor, index, rectangleOptions.borderColor),
				borderWidth: custom.borderWidth ? custom.borderWidth : helpers.valueAtIndexOrDefault(dataset.borderWidth, index, rectangleOptions.borderWidth)
			};

			me.updateElementGeometry(rectangle, index, reset);

			rectangle.pivot();
		},

		/**
		 * @private
		 */
		updateElementGeometry: function(rectangle, index, reset) {
			var me = this;
			var model = rectangle._model;
			var vscale = me.getValueScale();
			var base = vscale.getBasePixel();
			var horizontal = vscale.isHorizontal();
			var ruler = me._ruler || me.getRuler();
			var vpixels = me.calculateBarValuePixels(me.index, index);
			var ipixels = me.calculateBarIndexPixels(me.index, index, ruler);

			model.horizontal = horizontal;
			model.base = reset ? base : vpixels.base;
			model.x = horizontal ? reset ? base : vpixels.head : ipixels.center;
			model.y = horizontal ? ipixels.center : reset ? base : vpixels.head;
			model.height = horizontal ? ipixels.size : undefined;
			model.width = horizontal ? undefined : ipixels.size;
		},

		/**
		 * @private
		 */
		getValueScaleId: function() {
			return this.getMeta().yAxisID;
		},

		/**
		 * @private
		 */
		getIndexScaleId: function() {
			return this.getMeta().xAxisID;
		},

		/**
		 * @private
		 */
		getValueScale: function() {
			return this.getScaleForId(this.getValueScaleId());
		},

		/**
		 * @private
		 */
		getIndexScale: function() {
			return this.getScaleForId(this.getIndexScaleId());
		},

		/**
		 * Returns the stacks based on groups and bar visibility.
		 * @param {Number} [last] - The dataset index
		 * @returns {Array} The stack list
		 * @private
		 */
		_getStacks: function(last) {
			var me = this;
			var chart = me.chart;
			var scale = me.getIndexScale();
			var stacked = scale.options.stacked;
			var ilen = last === undefined ? chart.data.datasets.length : last + 1;
			var stacks = [];
			var i, meta;

			for (i = 0; i < ilen; ++i) {
				meta = chart.getDatasetMeta(i);
				if (meta.bar && chart.isDatasetVisible(i) &&
					(stacked === false ||
					(stacked === true && stacks.indexOf(meta.stack) === -1) ||
					(stacked === undefined && (meta.stack === undefined || stacks.indexOf(meta.stack) === -1)))) {
					stacks.push(meta.stack);
				}
			}

			return stacks;
		},

		/**
		 * Returns the effective number of stacks based on groups and bar visibility.
		 * @private
		 */
		getStackCount: function() {
			return this._getStacks().length;
		},

		/**
		 * Returns the stack index for the given dataset based on groups and bar visibility.
		 * @param {Number} [datasetIndex] - The dataset index
		 * @param {String} [name] - The stack name to find
		 * @returns {Number} The stack index
		 * @private
		 */
		getStackIndex: function(datasetIndex, name) {
			var stacks = this._getStacks(datasetIndex);
			var index = (name !== undefined)
				? stacks.indexOf(name)
				: -1; // indexOf returns -1 if element is not present

			return (index === -1)
				? stacks.length - 1
				: index;
		},

		/**
		 * @private
		 */
		getRuler: function() {
			var me = this;
			var scale = me.getIndexScale();
			var stackCount = me.getStackCount();
			var datasetIndex = me.index;
			var isHorizontal = scale.isHorizontal();
			var start = isHorizontal ? scale.left : scale.top;
			var end = start + (isHorizontal ? scale.width : scale.height);
			var pixels = [];
			var i, ilen, min;

			for (i = 0, ilen = me.getMeta().data.length; i < ilen; ++i) {
				pixels.push(scale.getPixelForValue(null, i, datasetIndex));
			}

			min = helpers.isNullOrUndef(scale.options.barThickness)
				? computeMinSampleSize(scale, pixels)
				: -1;

			return {
				min: min,
				pixels: pixels,
				start: start,
				end: end,
				stackCount: stackCount,
				scale: scale
			};
		},

		/**
		 * Note: pixel values are not clamped to the scale area.
		 * @private
		 */
		calculateBarValuePixels: function(datasetIndex, index) {
			var me = this;
			var chart = me.chart;
			var meta = me.getMeta();
			var scale = me.getValueScale();
			var datasets = chart.data.datasets;
			var value = scale.getRightValue(datasets[datasetIndex].data[index]);
			var stacked = scale.options.stacked;
			var stack = meta.stack;
			var start = 0;
			var i, imeta, ivalue, base, head, size;

			if (stacked || (stacked === undefined && stack !== undefined)) {
				for (i = 0; i < datasetIndex; ++i) {
					imeta = chart.getDatasetMeta(i);

					if (imeta.bar &&
						imeta.stack === stack &&
						imeta.controller.getValueScaleId() === scale.id &&
						chart.isDatasetVisible(i)) {

						ivalue = scale.getRightValue(datasets[i].data[index]);
						if ((value < 0 && ivalue < 0) || (value >= 0 && ivalue > 0)) {
							start += ivalue;
						}
					}
				}
			}

			base = scale.getPixelForValue(start);
			head = scale.getPixelForValue(start + value);
			size = (head - base) / 2;

			return {
				size: size,
				base: base,
				head: head,
				center: head + size / 2
			};
		},

		/**
		 * @private
		 */
		calculateBarIndexPixels: function(datasetIndex, index, ruler) {
			var me = this;
			var options = ruler.scale.options;
			var range = options.barThickness === 'flex'
				? computeFlexCategoryTraits(index, ruler, options)
				: computeFitCategoryTraits(index, ruler, options);

			var stackIndex = me.getStackIndex(datasetIndex, me.getMeta().stack);
			var center = range.start + (range.chunk * stackIndex) + (range.chunk / 2);
			var size = Math.min(
				helpers.valueOrDefault(options.maxBarThickness, Infinity),
				range.chunk * range.ratio);

			return {
				base: center - size / 2,
				head: center + size / 2,
				center: center,
				size: size
			};
		},

		draw: function() {
			var me = this;
			var chart = me.chart;
			var scale = me.getValueScale();
			var rects = me.getMeta().data;
			var dataset = me.getDataset();
			var ilen = rects.length;
			var i = 0;

			helpers.canvas.clipArea(chart.ctx, chart.chartArea);

			for (; i < ilen; ++i) {
				if (!isNaN(scale.getRightValue(dataset.data[i]))) {
					rects[i].draw();
				}
			}

			helpers.canvas.unclipArea(chart.ctx);
		},

		setHoverStyle: function(rectangle) {
			var dataset = this.chart.data.datasets[rectangle._datasetIndex];
			var index = rectangle._index;
			var custom = rectangle.custom || {};
			var model = rectangle._model;

			model.backgroundColor = custom.hoverBackgroundColor ? custom.hoverBackgroundColor : helpers.valueAtIndexOrDefault(dataset.hoverBackgroundColor, index, helpers.getHoverColor(model.backgroundColor));
			model.borderColor = custom.hoverBorderColor ? custom.hoverBorderColor : helpers.valueAtIndexOrDefault(dataset.hoverBorderColor, index, helpers.getHoverColor(model.borderColor));
			model.borderWidth = custom.hoverBorderWidth ? custom.hoverBorderWidth : helpers.valueAtIndexOrDefault(dataset.hoverBorderWidth, index, model.borderWidth);
		},

		removeHoverStyle: function(rectangle) {
			var dataset = this.chart.data.datasets[rectangle._datasetIndex];
			var index = rectangle._index;
			var custom = rectangle.custom || {};
			var model = rectangle._model;
			var rectangleElementOptions = this.chart.options.elements.rectangle;

			model.backgroundColor = custom.backgroundColor ? custom.backgroundColor : helpers.valueAtIndexOrDefault(dataset.backgroundColor, index, rectangleElementOptions.backgroundColor);
			model.borderColor = custom.borderColor ? custom.borderColor : helpers.valueAtIndexOrDefault(dataset.borderColor, index, rectangleElementOptions.borderColor);
			model.borderWidth = custom.borderWidth ? custom.borderWidth : helpers.valueAtIndexOrDefault(dataset.borderWidth, index, rectangleElementOptions.borderWidth);
		}
	});

	Chart.controllers.horizontalBar = Chart.controllers.bar.extend({
		/**
		 * @private
		 */
		getValueScaleId: function() {
			return this.getMeta().xAxisID;
		},

		/**
		 * @private
		 */
		getIndexScaleId: function() {
			return this.getMeta().yAxisID;
		}
	});
};


/***/ }),
/* 687 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var defaults = __webpack_require__(20);
var elements = __webpack_require__(55);
var helpers = __webpack_require__(15);

defaults._set('bubble', {
	hover: {
		mode: 'single'
	},

	scales: {
		xAxes: [{
			type: 'linear', // bubble should probably use a linear scale by default
			position: 'bottom',
			id: 'x-axis-0' // need an ID so datasets can reference the scale
		}],
		yAxes: [{
			type: 'linear',
			position: 'left',
			id: 'y-axis-0'
		}]
	},

	tooltips: {
		callbacks: {
			title: function() {
				// Title doesn't make sense for scatter since we format the data as a point
				return '';
			},
			label: function(item, data) {
				var datasetLabel = data.datasets[item.datasetIndex].label || '';
				var dataPoint = data.datasets[item.datasetIndex].data[item.index];
				return datasetLabel + ': (' + item.xLabel + ', ' + item.yLabel + ', ' + dataPoint.r + ')';
			}
		}
	}
});


module.exports = function(Chart) {

	Chart.controllers.bubble = Chart.DatasetController.extend({
		/**
		 * @protected
		 */
		dataElementType: elements.Point,

		/**
		 * @protected
		 */
		update: function(reset) {
			var me = this;
			var meta = me.getMeta();
			var points = meta.data;

			// Update Points
			helpers.each(points, function(point, index) {
				me.updateElement(point, index, reset);
			});
		},

		/**
		 * @protected
		 */
		updateElement: function(point, index, reset) {
			var me = this;
			var meta = me.getMeta();
			var custom = point.custom || {};
			var xScale = me.getScaleForId(meta.xAxisID);
			var yScale = me.getScaleForId(meta.yAxisID);
			var options = me._resolveElementOptions(point, index);
			var data = me.getDataset().data[index];
			var dsIndex = me.index;

			var x = reset ? xScale.getPixelForDecimal(0.5) : xScale.getPixelForValue(typeof data === 'object' ? data : NaN, index, dsIndex);
			var y = reset ? yScale.getBasePixel() : yScale.getPixelForValue(data, index, dsIndex);

			point._xScale = xScale;
			point._yScale = yScale;
			point._options = options;
			point._datasetIndex = dsIndex;
			point._index = index;
			point._model = {
				backgroundColor: options.backgroundColor,
				borderColor: options.borderColor,
				borderWidth: options.borderWidth,
				hitRadius: options.hitRadius,
				pointStyle: options.pointStyle,
				radius: reset ? 0 : options.radius,
				skip: custom.skip || isNaN(x) || isNaN(y),
				x: x,
				y: y,
			};

			point.pivot();
		},

		/**
		 * @protected
		 */
		setHoverStyle: function(point) {
			var model = point._model;
			var options = point._options;

			model.backgroundColor = helpers.valueOrDefault(options.hoverBackgroundColor, helpers.getHoverColor(options.backgroundColor));
			model.borderColor = helpers.valueOrDefault(options.hoverBorderColor, helpers.getHoverColor(options.borderColor));
			model.borderWidth = helpers.valueOrDefault(options.hoverBorderWidth, options.borderWidth);
			model.radius = options.radius + options.hoverRadius;
		},

		/**
		 * @protected
		 */
		removeHoverStyle: function(point) {
			var model = point._model;
			var options = point._options;

			model.backgroundColor = options.backgroundColor;
			model.borderColor = options.borderColor;
			model.borderWidth = options.borderWidth;
			model.radius = options.radius;
		},

		/**
		 * @private
		 */
		_resolveElementOptions: function(point, index) {
			var me = this;
			var chart = me.chart;
			var datasets = chart.data.datasets;
			var dataset = datasets[me.index];
			var custom = point.custom || {};
			var options = chart.options.elements.point;
			var resolve = helpers.options.resolve;
			var data = dataset.data[index];
			var values = {};
			var i, ilen, key;

			// Scriptable options
			var context = {
				chart: chart,
				dataIndex: index,
				dataset: dataset,
				datasetIndex: me.index
			};

			var keys = [
				'backgroundColor',
				'borderColor',
				'borderWidth',
				'hoverBackgroundColor',
				'hoverBorderColor',
				'hoverBorderWidth',
				'hoverRadius',
				'hitRadius',
				'pointStyle'
			];

			for (i = 0, ilen = keys.length; i < ilen; ++i) {
				key = keys[i];
				values[key] = resolve([
					custom[key],
					dataset[key],
					options[key]
				], context, index);
			}

			// Custom radius resolution
			values.radius = resolve([
				custom.radius,
				data ? data.r : undefined,
				dataset.radius,
				options.radius
			], context, index);

			return values;
		}
	});
};


/***/ }),
/* 688 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var defaults = __webpack_require__(20);
var elements = __webpack_require__(55);
var helpers = __webpack_require__(15);

defaults._set('doughnut', {
	animation: {
		// Boolean - Whether we animate the rotation of the Doughnut
		animateRotate: true,
		// Boolean - Whether we animate scaling the Doughnut from the centre
		animateScale: false
	},
	hover: {
		mode: 'single'
	},
	legendCallback: function(chart) {
		var text = [];
		text.push('<ul class="' + chart.id + '-legend">');

		var data = chart.data;
		var datasets = data.datasets;
		var labels = data.labels;

		if (datasets.length) {
			for (var i = 0; i < datasets[0].data.length; ++i) {
				text.push('<li><span style="background-color:' + datasets[0].backgroundColor[i] + '"></span>');
				if (labels[i]) {
					text.push(labels[i]);
				}
				text.push('</li>');
			}
		}

		text.push('</ul>');
		return text.join('');
	},
	legend: {
		labels: {
			generateLabels: function(chart) {
				var data = chart.data;
				if (data.labels.length && data.datasets.length) {
					return data.labels.map(function(label, i) {
						var meta = chart.getDatasetMeta(0);
						var ds = data.datasets[0];
						var arc = meta.data[i];
						var custom = arc && arc.custom || {};
						var valueAtIndexOrDefault = helpers.valueAtIndexOrDefault;
						var arcOpts = chart.options.elements.arc;
						var fill = custom.backgroundColor ? custom.backgroundColor : valueAtIndexOrDefault(ds.backgroundColor, i, arcOpts.backgroundColor);
						var stroke = custom.borderColor ? custom.borderColor : valueAtIndexOrDefault(ds.borderColor, i, arcOpts.borderColor);
						var bw = custom.borderWidth ? custom.borderWidth : valueAtIndexOrDefault(ds.borderWidth, i, arcOpts.borderWidth);

						return {
							text: label,
							fillStyle: fill,
							strokeStyle: stroke,
							lineWidth: bw,
							hidden: isNaN(ds.data[i]) || meta.data[i].hidden,

							// Extra data used for toggling the correct item
							index: i
						};
					});
				}
				return [];
			}
		},

		onClick: function(e, legendItem) {
			var index = legendItem.index;
			var chart = this.chart;
			var i, ilen, meta;

			for (i = 0, ilen = (chart.data.datasets || []).length; i < ilen; ++i) {
				meta = chart.getDatasetMeta(i);
				// toggle visibility of index if exists
				if (meta.data[index]) {
					meta.data[index].hidden = !meta.data[index].hidden;
				}
			}

			chart.update();
		}
	},

	// The percentage of the chart that we cut out of the middle.
	cutoutPercentage: 50,

	// The rotation of the chart, where the first data arc begins.
	rotation: Math.PI * -0.5,

	// The total circumference of the chart.
	circumference: Math.PI * 2.0,

	// Need to override these to give a nice default
	tooltips: {
		callbacks: {
			title: function() {
				return '';
			},
			label: function(tooltipItem, data) {
				var dataLabel = data.labels[tooltipItem.index];
				var value = ': ' + data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index];

				if (helpers.isArray(dataLabel)) {
					// show value on first line of multiline label
					// need to clone because we are changing the value
					dataLabel = dataLabel.slice();
					dataLabel[0] += value;
				} else {
					dataLabel += value;
				}

				return dataLabel;
			}
		}
	}
});

defaults._set('pie', helpers.clone(defaults.doughnut));
defaults._set('pie', {
	cutoutPercentage: 0
});

module.exports = function(Chart) {

	Chart.controllers.doughnut = Chart.controllers.pie = Chart.DatasetController.extend({

		dataElementType: elements.Arc,

		linkScales: helpers.noop,

		// Get index of the dataset in relation to the visible datasets. This allows determining the inner and outer radius correctly
		getRingIndex: function(datasetIndex) {
			var ringIndex = 0;

			for (var j = 0; j < datasetIndex; ++j) {
				if (this.chart.isDatasetVisible(j)) {
					++ringIndex;
				}
			}

			return ringIndex;
		},

		update: function(reset) {
			var me = this;
			var chart = me.chart;
			var chartArea = chart.chartArea;
			var opts = chart.options;
			var arcOpts = opts.elements.arc;
			var availableWidth = chartArea.right - chartArea.left - arcOpts.borderWidth;
			var availableHeight = chartArea.bottom - chartArea.top - arcOpts.borderWidth;
			var minSize = Math.min(availableWidth, availableHeight);
			var offset = {x: 0, y: 0};
			var meta = me.getMeta();
			var cutoutPercentage = opts.cutoutPercentage;
			var circumference = opts.circumference;

			// If the chart's circumference isn't a full circle, calculate minSize as a ratio of the width/height of the arc
			if (circumference < Math.PI * 2.0) {
				var startAngle = opts.rotation % (Math.PI * 2.0);
				startAngle += Math.PI * 2.0 * (startAngle >= Math.PI ? -1 : startAngle < -Math.PI ? 1 : 0);
				var endAngle = startAngle + circumference;
				var start = {x: Math.cos(startAngle), y: Math.sin(startAngle)};
				var end = {x: Math.cos(endAngle), y: Math.sin(endAngle)};
				var contains0 = (startAngle <= 0 && endAngle >= 0) || (startAngle <= Math.PI * 2.0 && Math.PI * 2.0 <= endAngle);
				var contains90 = (startAngle <= Math.PI * 0.5 && Math.PI * 0.5 <= endAngle) || (startAngle <= Math.PI * 2.5 && Math.PI * 2.5 <= endAngle);
				var contains180 = (startAngle <= -Math.PI && -Math.PI <= endAngle) || (startAngle <= Math.PI && Math.PI <= endAngle);
				var contains270 = (startAngle <= -Math.PI * 0.5 && -Math.PI * 0.5 <= endAngle) || (startAngle <= Math.PI * 1.5 && Math.PI * 1.5 <= endAngle);
				var cutout = cutoutPercentage / 100.0;
				var min = {x: contains180 ? -1 : Math.min(start.x * (start.x < 0 ? 1 : cutout), end.x * (end.x < 0 ? 1 : cutout)), y: contains270 ? -1 : Math.min(start.y * (start.y < 0 ? 1 : cutout), end.y * (end.y < 0 ? 1 : cutout))};
				var max = {x: contains0 ? 1 : Math.max(start.x * (start.x > 0 ? 1 : cutout), end.x * (end.x > 0 ? 1 : cutout)), y: contains90 ? 1 : Math.max(start.y * (start.y > 0 ? 1 : cutout), end.y * (end.y > 0 ? 1 : cutout))};
				var size = {width: (max.x - min.x) * 0.5, height: (max.y - min.y) * 0.5};
				minSize = Math.min(availableWidth / size.width, availableHeight / size.height);
				offset = {x: (max.x + min.x) * -0.5, y: (max.y + min.y) * -0.5};
			}

			chart.borderWidth = me.getMaxBorderWidth(meta.data);
			chart.outerRadius = Math.max((minSize - chart.borderWidth) / 2, 0);
			chart.innerRadius = Math.max(cutoutPercentage ? (chart.outerRadius / 100) * (cutoutPercentage) : 0, 0);
			chart.radiusLength = (chart.outerRadius - chart.innerRadius) / chart.getVisibleDatasetCount();
			chart.offsetX = offset.x * chart.outerRadius;
			chart.offsetY = offset.y * chart.outerRadius;

			meta.total = me.calculateTotal();

			me.outerRadius = chart.outerRadius - (chart.radiusLength * me.getRingIndex(me.index));
			me.innerRadius = Math.max(me.outerRadius - chart.radiusLength, 0);

			helpers.each(meta.data, function(arc, index) {
				me.updateElement(arc, index, reset);
			});
		},

		updateElement: function(arc, index, reset) {
			var me = this;
			var chart = me.chart;
			var chartArea = chart.chartArea;
			var opts = chart.options;
			var animationOpts = opts.animation;
			var centerX = (chartArea.left + chartArea.right) / 2;
			var centerY = (chartArea.top + chartArea.bottom) / 2;
			var startAngle = opts.rotation; // non reset case handled later
			var endAngle = opts.rotation; // non reset case handled later
			var dataset = me.getDataset();
			var circumference = reset && animationOpts.animateRotate ? 0 : arc.hidden ? 0 : me.calculateCircumference(dataset.data[index]) * (opts.circumference / (2.0 * Math.PI));
			var innerRadius = reset && animationOpts.animateScale ? 0 : me.innerRadius;
			var outerRadius = reset && animationOpts.animateScale ? 0 : me.outerRadius;
			var valueAtIndexOrDefault = helpers.valueAtIndexOrDefault;

			helpers.extend(arc, {
				// Utility
				_datasetIndex: me.index,
				_index: index,

				// Desired view properties
				_model: {
					x: centerX + chart.offsetX,
					y: centerY + chart.offsetY,
					startAngle: startAngle,
					endAngle: endAngle,
					circumference: circumference,
					outerRadius: outerRadius,
					innerRadius: innerRadius,
					label: valueAtIndexOrDefault(dataset.label, index, chart.data.labels[index])
				}
			});

			var model = arc._model;
			// Resets the visual styles
			this.removeHoverStyle(arc);

			// Set correct angles if not resetting
			if (!reset || !animationOpts.animateRotate) {
				if (index === 0) {
					model.startAngle = opts.rotation;
				} else {
					model.startAngle = me.getMeta().data[index - 1]._model.endAngle;
				}

				model.endAngle = model.startAngle + model.circumference;
			}

			arc.pivot();
		},

		removeHoverStyle: function(arc) {
			Chart.DatasetController.prototype.removeHoverStyle.call(this, arc, this.chart.options.elements.arc);
		},

		calculateTotal: function() {
			var dataset = this.getDataset();
			var meta = this.getMeta();
			var total = 0;
			var value;

			helpers.each(meta.data, function(element, index) {
				value = dataset.data[index];
				if (!isNaN(value) && !element.hidden) {
					total += Math.abs(value);
				}
			});

			/* if (total === 0) {
				total = NaN;
			}*/

			return total;
		},

		calculateCircumference: function(value) {
			var total = this.getMeta().total;
			if (total > 0 && !isNaN(value)) {
				return (Math.PI * 2.0) * (Math.abs(value) / total);
			}
			return 0;
		},

		// gets the max border or hover width to properly scale pie charts
		getMaxBorderWidth: function(arcs) {
			var max = 0;
			var index = this.index;
			var length = arcs.length;
			var borderWidth;
			var hoverWidth;

			for (var i = 0; i < length; i++) {
				borderWidth = arcs[i]._model ? arcs[i]._model.borderWidth : 0;
				hoverWidth = arcs[i]._chart ? arcs[i]._chart.config.data.datasets[index].hoverBorderWidth : 0;

				max = borderWidth > max ? borderWidth : max;
				max = hoverWidth > max ? hoverWidth : max;
			}
			return max;
		}
	});
};


/***/ }),
/* 689 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var defaults = __webpack_require__(20);
var elements = __webpack_require__(55);
var helpers = __webpack_require__(15);

defaults._set('line', {
	showLines: true,
	spanGaps: false,

	hover: {
		mode: 'label'
	},

	scales: {
		xAxes: [{
			type: 'category',
			id: 'x-axis-0'
		}],
		yAxes: [{
			type: 'linear',
			id: 'y-axis-0'
		}]
	}
});

module.exports = function(Chart) {

	function lineEnabled(dataset, options) {
		return helpers.valueOrDefault(dataset.showLine, options.showLines);
	}

	Chart.controllers.line = Chart.DatasetController.extend({

		datasetElementType: elements.Line,

		dataElementType: elements.Point,

		update: function(reset) {
			var me = this;
			var meta = me.getMeta();
			var line = meta.dataset;
			var points = meta.data || [];
			var options = me.chart.options;
			var lineElementOptions = options.elements.line;
			var scale = me.getScaleForId(meta.yAxisID);
			var i, ilen, custom;
			var dataset = me.getDataset();
			var showLine = lineEnabled(dataset, options);

			// Update Line
			if (showLine) {
				custom = line.custom || {};

				// Compatibility: If the properties are defined with only the old name, use those values
				if ((dataset.tension !== undefined) && (dataset.lineTension === undefined)) {
					dataset.lineTension = dataset.tension;
				}

				// Utility
				line._scale = scale;
				line._datasetIndex = me.index;
				// Data
				line._children = points;
				// Model
				line._model = {
					// Appearance
					// The default behavior of lines is to break at null values, according
					// to https://github.com/chartjs/Chart.js/issues/2435#issuecomment-216718158
					// This option gives lines the ability to span gaps
					spanGaps: dataset.spanGaps ? dataset.spanGaps : options.spanGaps,
					tension: custom.tension ? custom.tension : helpers.valueOrDefault(dataset.lineTension, lineElementOptions.tension),
					backgroundColor: custom.backgroundColor ? custom.backgroundColor : (dataset.backgroundColor || lineElementOptions.backgroundColor),
					borderWidth: custom.borderWidth ? custom.borderWidth : (dataset.borderWidth || lineElementOptions.borderWidth),
					borderColor: custom.borderColor ? custom.borderColor : (dataset.borderColor || lineElementOptions.borderColor),
					borderCapStyle: custom.borderCapStyle ? custom.borderCapStyle : (dataset.borderCapStyle || lineElementOptions.borderCapStyle),
					borderDash: custom.borderDash ? custom.borderDash : (dataset.borderDash || lineElementOptions.borderDash),
					borderDashOffset: custom.borderDashOffset ? custom.borderDashOffset : (dataset.borderDashOffset || lineElementOptions.borderDashOffset),
					borderJoinStyle: custom.borderJoinStyle ? custom.borderJoinStyle : (dataset.borderJoinStyle || lineElementOptions.borderJoinStyle),
					fill: custom.fill ? custom.fill : (dataset.fill !== undefined ? dataset.fill : lineElementOptions.fill),
					steppedLine: custom.steppedLine ? custom.steppedLine : helpers.valueOrDefault(dataset.steppedLine, lineElementOptions.stepped),
					cubicInterpolationMode: custom.cubicInterpolationMode ? custom.cubicInterpolationMode : helpers.valueOrDefault(dataset.cubicInterpolationMode, lineElementOptions.cubicInterpolationMode),
				};

				line.pivot();
			}

			// Update Points
			for (i = 0, ilen = points.length; i < ilen; ++i) {
				me.updateElement(points[i], i, reset);
			}

			if (showLine && line._model.tension !== 0) {
				me.updateBezierControlPoints();
			}

			// Now pivot the point for animation
			for (i = 0, ilen = points.length; i < ilen; ++i) {
				points[i].pivot();
			}
		},

		getPointBackgroundColor: function(point, index) {
			var backgroundColor = this.chart.options.elements.point.backgroundColor;
			var dataset = this.getDataset();
			var custom = point.custom || {};

			if (custom.backgroundColor) {
				backgroundColor = custom.backgroundColor;
			} else if (dataset.pointBackgroundColor) {
				backgroundColor = helpers.valueAtIndexOrDefault(dataset.pointBackgroundColor, index, backgroundColor);
			} else if (dataset.backgroundColor) {
				backgroundColor = dataset.backgroundColor;
			}

			return backgroundColor;
		},

		getPointBorderColor: function(point, index) {
			var borderColor = this.chart.options.elements.point.borderColor;
			var dataset = this.getDataset();
			var custom = point.custom || {};

			if (custom.borderColor) {
				borderColor = custom.borderColor;
			} else if (dataset.pointBorderColor) {
				borderColor = helpers.valueAtIndexOrDefault(dataset.pointBorderColor, index, borderColor);
			} else if (dataset.borderColor) {
				borderColor = dataset.borderColor;
			}

			return borderColor;
		},

		getPointBorderWidth: function(point, index) {
			var borderWidth = this.chart.options.elements.point.borderWidth;
			var dataset = this.getDataset();
			var custom = point.custom || {};

			if (!isNaN(custom.borderWidth)) {
				borderWidth = custom.borderWidth;
			} else if (!isNaN(dataset.pointBorderWidth) || helpers.isArray(dataset.pointBorderWidth)) {
				borderWidth = helpers.valueAtIndexOrDefault(dataset.pointBorderWidth, index, borderWidth);
			} else if (!isNaN(dataset.borderWidth)) {
				borderWidth = dataset.borderWidth;
			}

			return borderWidth;
		},

		updateElement: function(point, index, reset) {
			var me = this;
			var meta = me.getMeta();
			var custom = point.custom || {};
			var dataset = me.getDataset();
			var datasetIndex = me.index;
			var value = dataset.data[index];
			var yScale = me.getScaleForId(meta.yAxisID);
			var xScale = me.getScaleForId(meta.xAxisID);
			var pointOptions = me.chart.options.elements.point;
			var x, y;

			// Compatibility: If the properties are defined with only the old name, use those values
			if ((dataset.radius !== undefined) && (dataset.pointRadius === undefined)) {
				dataset.pointRadius = dataset.radius;
			}
			if ((dataset.hitRadius !== undefined) && (dataset.pointHitRadius === undefined)) {
				dataset.pointHitRadius = dataset.hitRadius;
			}

			x = xScale.getPixelForValue(typeof value === 'object' ? value : NaN, index, datasetIndex);
			y = reset ? yScale.getBasePixel() : me.calculatePointY(value, index, datasetIndex);

			// Utility
			point._xScale = xScale;
			point._yScale = yScale;
			point._datasetIndex = datasetIndex;
			point._index = index;

			// Desired view properties
			point._model = {
				x: x,
				y: y,
				skip: custom.skip || isNaN(x) || isNaN(y),
				// Appearance
				radius: custom.radius || helpers.valueAtIndexOrDefault(dataset.pointRadius, index, pointOptions.radius),
				pointStyle: custom.pointStyle || helpers.valueAtIndexOrDefault(dataset.pointStyle, index, pointOptions.pointStyle),
				backgroundColor: me.getPointBackgroundColor(point, index),
				borderColor: me.getPointBorderColor(point, index),
				borderWidth: me.getPointBorderWidth(point, index),
				tension: meta.dataset._model ? meta.dataset._model.tension : 0,
				steppedLine: meta.dataset._model ? meta.dataset._model.steppedLine : false,
				// Tooltip
				hitRadius: custom.hitRadius || helpers.valueAtIndexOrDefault(dataset.pointHitRadius, index, pointOptions.hitRadius)
			};
		},

		calculatePointY: function(value, index, datasetIndex) {
			var me = this;
			var chart = me.chart;
			var meta = me.getMeta();
			var yScale = me.getScaleForId(meta.yAxisID);
			var sumPos = 0;
			var sumNeg = 0;
			var i, ds, dsMeta;

			if (yScale.options.stacked) {
				for (i = 0; i < datasetIndex; i++) {
					ds = chart.data.datasets[i];
					dsMeta = chart.getDatasetMeta(i);
					if (dsMeta.type === 'line' && dsMeta.yAxisID === yScale.id && chart.isDatasetVisible(i)) {
						var stackedRightValue = Number(yScale.getRightValue(ds.data[index]));
						if (stackedRightValue < 0) {
							sumNeg += stackedRightValue || 0;
						} else {
							sumPos += stackedRightValue || 0;
						}
					}
				}

				var rightValue = Number(yScale.getRightValue(value));
				if (rightValue < 0) {
					return yScale.getPixelForValue(sumNeg + rightValue);
				}
				return yScale.getPixelForValue(sumPos + rightValue);
			}

			return yScale.getPixelForValue(value);
		},

		updateBezierControlPoints: function() {
			var me = this;
			var meta = me.getMeta();
			var area = me.chart.chartArea;
			var points = (meta.data || []);
			var i, ilen, point, model, controlPoints;

			// Only consider points that are drawn in case the spanGaps option is used
			if (meta.dataset._model.spanGaps) {
				points = points.filter(function(pt) {
					return !pt._model.skip;
				});
			}

			function capControlPoint(pt, min, max) {
				return Math.max(Math.min(pt, max), min);
			}

			if (meta.dataset._model.cubicInterpolationMode === 'monotone') {
				helpers.splineCurveMonotone(points);
			} else {
				for (i = 0, ilen = points.length; i < ilen; ++i) {
					point = points[i];
					model = point._model;
					controlPoints = helpers.splineCurve(
						helpers.previousItem(points, i)._model,
						model,
						helpers.nextItem(points, i)._model,
						meta.dataset._model.tension
					);
					model.controlPointPreviousX = controlPoints.previous.x;
					model.controlPointPreviousY = controlPoints.previous.y;
					model.controlPointNextX = controlPoints.next.x;
					model.controlPointNextY = controlPoints.next.y;
				}
			}

			if (me.chart.options.elements.line.capBezierPoints) {
				for (i = 0, ilen = points.length; i < ilen; ++i) {
					model = points[i]._model;
					model.controlPointPreviousX = capControlPoint(model.controlPointPreviousX, area.left, area.right);
					model.controlPointPreviousY = capControlPoint(model.controlPointPreviousY, area.top, area.bottom);
					model.controlPointNextX = capControlPoint(model.controlPointNextX, area.left, area.right);
					model.controlPointNextY = capControlPoint(model.controlPointNextY, area.top, area.bottom);
				}
			}
		},

		draw: function() {
			var me = this;
			var chart = me.chart;
			var meta = me.getMeta();
			var points = meta.data || [];
			var area = chart.chartArea;
			var ilen = points.length;
			var i = 0;

			helpers.canvas.clipArea(chart.ctx, area);

			if (lineEnabled(me.getDataset(), chart.options)) {
				meta.dataset.draw();
			}

			helpers.canvas.unclipArea(chart.ctx);

			// Draw the points
			for (; i < ilen; ++i) {
				points[i].draw(area);
			}
		},

		setHoverStyle: function(point) {
			// Point
			var dataset = this.chart.data.datasets[point._datasetIndex];
			var index = point._index;
			var custom = point.custom || {};
			var model = point._model;

			model.radius = custom.hoverRadius || helpers.valueAtIndexOrDefault(dataset.pointHoverRadius, index, this.chart.options.elements.point.hoverRadius);
			model.backgroundColor = custom.hoverBackgroundColor || helpers.valueAtIndexOrDefault(dataset.pointHoverBackgroundColor, index, helpers.getHoverColor(model.backgroundColor));
			model.borderColor = custom.hoverBorderColor || helpers.valueAtIndexOrDefault(dataset.pointHoverBorderColor, index, helpers.getHoverColor(model.borderColor));
			model.borderWidth = custom.hoverBorderWidth || helpers.valueAtIndexOrDefault(dataset.pointHoverBorderWidth, index, model.borderWidth);
		},

		removeHoverStyle: function(point) {
			var me = this;
			var dataset = me.chart.data.datasets[point._datasetIndex];
			var index = point._index;
			var custom = point.custom || {};
			var model = point._model;

			// Compatibility: If the properties are defined with only the old name, use those values
			if ((dataset.radius !== undefined) && (dataset.pointRadius === undefined)) {
				dataset.pointRadius = dataset.radius;
			}

			model.radius = custom.radius || helpers.valueAtIndexOrDefault(dataset.pointRadius, index, me.chart.options.elements.point.radius);
			model.backgroundColor = me.getPointBackgroundColor(point, index);
			model.borderColor = me.getPointBorderColor(point, index);
			model.borderWidth = me.getPointBorderWidth(point, index);
		}
	});
};


/***/ }),
/* 690 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var defaults = __webpack_require__(20);
var elements = __webpack_require__(55);
var helpers = __webpack_require__(15);

defaults._set('polarArea', {
	scale: {
		type: 'radialLinear',
		angleLines: {
			display: false
		},
		gridLines: {
			circular: true
		},
		pointLabels: {
			display: false
		},
		ticks: {
			beginAtZero: true
		}
	},

	// Boolean - Whether to animate the rotation of the chart
	animation: {
		animateRotate: true,
		animateScale: true
	},

	startAngle: -0.5 * Math.PI,
	legendCallback: function(chart) {
		var text = [];
		text.push('<ul class="' + chart.id + '-legend">');

		var data = chart.data;
		var datasets = data.datasets;
		var labels = data.labels;

		if (datasets.length) {
			for (var i = 0; i < datasets[0].data.length; ++i) {
				text.push('<li><span style="background-color:' + datasets[0].backgroundColor[i] + '"></span>');
				if (labels[i]) {
					text.push(labels[i]);
				}
				text.push('</li>');
			}
		}

		text.push('</ul>');
		return text.join('');
	},
	legend: {
		labels: {
			generateLabels: function(chart) {
				var data = chart.data;
				if (data.labels.length && data.datasets.length) {
					return data.labels.map(function(label, i) {
						var meta = chart.getDatasetMeta(0);
						var ds = data.datasets[0];
						var arc = meta.data[i];
						var custom = arc.custom || {};
						var valueAtIndexOrDefault = helpers.valueAtIndexOrDefault;
						var arcOpts = chart.options.elements.arc;
						var fill = custom.backgroundColor ? custom.backgroundColor : valueAtIndexOrDefault(ds.backgroundColor, i, arcOpts.backgroundColor);
						var stroke = custom.borderColor ? custom.borderColor : valueAtIndexOrDefault(ds.borderColor, i, arcOpts.borderColor);
						var bw = custom.borderWidth ? custom.borderWidth : valueAtIndexOrDefault(ds.borderWidth, i, arcOpts.borderWidth);

						return {
							text: label,
							fillStyle: fill,
							strokeStyle: stroke,
							lineWidth: bw,
							hidden: isNaN(ds.data[i]) || meta.data[i].hidden,

							// Extra data used for toggling the correct item
							index: i
						};
					});
				}
				return [];
			}
		},

		onClick: function(e, legendItem) {
			var index = legendItem.index;
			var chart = this.chart;
			var i, ilen, meta;

			for (i = 0, ilen = (chart.data.datasets || []).length; i < ilen; ++i) {
				meta = chart.getDatasetMeta(i);
				meta.data[index].hidden = !meta.data[index].hidden;
			}

			chart.update();
		}
	},

	// Need to override these to give a nice default
	tooltips: {
		callbacks: {
			title: function() {
				return '';
			},
			label: function(item, data) {
				return data.labels[item.index] + ': ' + item.yLabel;
			}
		}
	}
});

module.exports = function(Chart) {

	Chart.controllers.polarArea = Chart.DatasetController.extend({

		dataElementType: elements.Arc,

		linkScales: helpers.noop,

		update: function(reset) {
			var me = this;
			var chart = me.chart;
			var chartArea = chart.chartArea;
			var meta = me.getMeta();
			var opts = chart.options;
			var arcOpts = opts.elements.arc;
			var minSize = Math.min(chartArea.right - chartArea.left, chartArea.bottom - chartArea.top);
			chart.outerRadius = Math.max((minSize - arcOpts.borderWidth / 2) / 2, 0);
			chart.innerRadius = Math.max(opts.cutoutPercentage ? (chart.outerRadius / 100) * (opts.cutoutPercentage) : 1, 0);
			chart.radiusLength = (chart.outerRadius - chart.innerRadius) / chart.getVisibleDatasetCount();

			me.outerRadius = chart.outerRadius - (chart.radiusLength * me.index);
			me.innerRadius = me.outerRadius - chart.radiusLength;

			meta.count = me.countVisibleElements();

			helpers.each(meta.data, function(arc, index) {
				me.updateElement(arc, index, reset);
			});
		},

		updateElement: function(arc, index, reset) {
			var me = this;
			var chart = me.chart;
			var dataset = me.getDataset();
			var opts = chart.options;
			var animationOpts = opts.animation;
			var scale = chart.scale;
			var labels = chart.data.labels;

			var circumference = me.calculateCircumference(dataset.data[index]);
			var centerX = scale.xCenter;
			var centerY = scale.yCenter;

			// If there is NaN data before us, we need to calculate the starting angle correctly.
			// We could be way more efficient here, but its unlikely that the polar area chart will have a lot of data
			var visibleCount = 0;
			var meta = me.getMeta();
			for (var i = 0; i < index; ++i) {
				if (!isNaN(dataset.data[i]) && !meta.data[i].hidden) {
					++visibleCount;
				}
			}

			// var negHalfPI = -0.5 * Math.PI;
			var datasetStartAngle = opts.startAngle;
			var distance = arc.hidden ? 0 : scale.getDistanceFromCenterForValue(dataset.data[index]);
			var startAngle = datasetStartAngle + (circumference * visibleCount);
			var endAngle = startAngle + (arc.hidden ? 0 : circumference);

			var resetRadius = animationOpts.animateScale ? 0 : scale.getDistanceFromCenterForValue(dataset.data[index]);

			helpers.extend(arc, {
				// Utility
				_datasetIndex: me.index,
				_index: index,
				_scale: scale,

				// Desired view properties
				_model: {
					x: centerX,
					y: centerY,
					innerRadius: 0,
					outerRadius: reset ? resetRadius : distance,
					startAngle: reset && animationOpts.animateRotate ? datasetStartAngle : startAngle,
					endAngle: reset && animationOpts.animateRotate ? datasetStartAngle : endAngle,
					label: helpers.valueAtIndexOrDefault(labels, index, labels[index])
				}
			});

			// Apply border and fill style
			me.removeHoverStyle(arc);

			arc.pivot();
		},

		removeHoverStyle: function(arc) {
			Chart.DatasetController.prototype.removeHoverStyle.call(this, arc, this.chart.options.elements.arc);
		},

		countVisibleElements: function() {
			var dataset = this.getDataset();
			var meta = this.getMeta();
			var count = 0;

			helpers.each(meta.data, function(element, index) {
				if (!isNaN(dataset.data[index]) && !element.hidden) {
					count++;
				}
			});

			return count;
		},

		calculateCircumference: function(value) {
			var count = this.getMeta().count;
			if (count > 0 && !isNaN(value)) {
				return (2 * Math.PI) / count;
			}
			return 0;
		}
	});
};


/***/ }),
/* 691 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var defaults = __webpack_require__(20);
var elements = __webpack_require__(55);
var helpers = __webpack_require__(15);

defaults._set('radar', {
	scale: {
		type: 'radialLinear'
	},
	elements: {
		line: {
			tension: 0 // no bezier in radar
		}
	}
});

module.exports = function(Chart) {

	Chart.controllers.radar = Chart.DatasetController.extend({

		datasetElementType: elements.Line,

		dataElementType: elements.Point,

		linkScales: helpers.noop,

		update: function(reset) {
			var me = this;
			var meta = me.getMeta();
			var line = meta.dataset;
			var points = meta.data;
			var custom = line.custom || {};
			var dataset = me.getDataset();
			var lineElementOptions = me.chart.options.elements.line;
			var scale = me.chart.scale;

			// Compatibility: If the properties are defined with only the old name, use those values
			if ((dataset.tension !== undefined) && (dataset.lineTension === undefined)) {
				dataset.lineTension = dataset.tension;
			}

			helpers.extend(meta.dataset, {
				// Utility
				_datasetIndex: me.index,
				_scale: scale,
				// Data
				_children: points,
				_loop: true,
				// Model
				_model: {
					// Appearance
					tension: custom.tension ? custom.tension : helpers.valueOrDefault(dataset.lineTension, lineElementOptions.tension),
					backgroundColor: custom.backgroundColor ? custom.backgroundColor : (dataset.backgroundColor || lineElementOptions.backgroundColor),
					borderWidth: custom.borderWidth ? custom.borderWidth : (dataset.borderWidth || lineElementOptions.borderWidth),
					borderColor: custom.borderColor ? custom.borderColor : (dataset.borderColor || lineElementOptions.borderColor),
					fill: custom.fill ? custom.fill : (dataset.fill !== undefined ? dataset.fill : lineElementOptions.fill),
					borderCapStyle: custom.borderCapStyle ? custom.borderCapStyle : (dataset.borderCapStyle || lineElementOptions.borderCapStyle),
					borderDash: custom.borderDash ? custom.borderDash : (dataset.borderDash || lineElementOptions.borderDash),
					borderDashOffset: custom.borderDashOffset ? custom.borderDashOffset : (dataset.borderDashOffset || lineElementOptions.borderDashOffset),
					borderJoinStyle: custom.borderJoinStyle ? custom.borderJoinStyle : (dataset.borderJoinStyle || lineElementOptions.borderJoinStyle),
				}
			});

			meta.dataset.pivot();

			// Update Points
			helpers.each(points, function(point, index) {
				me.updateElement(point, index, reset);
			}, me);

			// Update bezier control points
			me.updateBezierControlPoints();
		},
		updateElement: function(point, index, reset) {
			var me = this;
			var custom = point.custom || {};
			var dataset = me.getDataset();
			var scale = me.chart.scale;
			var pointElementOptions = me.chart.options.elements.point;
			var pointPosition = scale.getPointPositionForValue(index, dataset.data[index]);

			// Compatibility: If the properties are defined with only the old name, use those values
			if ((dataset.radius !== undefined) && (dataset.pointRadius === undefined)) {
				dataset.pointRadius = dataset.radius;
			}
			if ((dataset.hitRadius !== undefined) && (dataset.pointHitRadius === undefined)) {
				dataset.pointHitRadius = dataset.hitRadius;
			}

			helpers.extend(point, {
				// Utility
				_datasetIndex: me.index,
				_index: index,
				_scale: scale,

				// Desired view properties
				_model: {
					x: reset ? scale.xCenter : pointPosition.x, // value not used in dataset scale, but we want a consistent API between scales
					y: reset ? scale.yCenter : pointPosition.y,

					// Appearance
					tension: custom.tension ? custom.tension : helpers.valueOrDefault(dataset.lineTension, me.chart.options.elements.line.tension),
					radius: custom.radius ? custom.radius : helpers.valueAtIndexOrDefault(dataset.pointRadius, index, pointElementOptions.radius),
					backgroundColor: custom.backgroundColor ? custom.backgroundColor : helpers.valueAtIndexOrDefault(dataset.pointBackgroundColor, index, pointElementOptions.backgroundColor),
					borderColor: custom.borderColor ? custom.borderColor : helpers.valueAtIndexOrDefault(dataset.pointBorderColor, index, pointElementOptions.borderColor),
					borderWidth: custom.borderWidth ? custom.borderWidth : helpers.valueAtIndexOrDefault(dataset.pointBorderWidth, index, pointElementOptions.borderWidth),
					pointStyle: custom.pointStyle ? custom.pointStyle : helpers.valueAtIndexOrDefault(dataset.pointStyle, index, pointElementOptions.pointStyle),

					// Tooltip
					hitRadius: custom.hitRadius ? custom.hitRadius : helpers.valueAtIndexOrDefault(dataset.pointHitRadius, index, pointElementOptions.hitRadius)
				}
			});

			point._model.skip = custom.skip ? custom.skip : (isNaN(point._model.x) || isNaN(point._model.y));
		},
		updateBezierControlPoints: function() {
			var chartArea = this.chart.chartArea;
			var meta = this.getMeta();

			helpers.each(meta.data, function(point, index) {
				var model = point._model;
				var controlPoints = helpers.splineCurve(
					helpers.previousItem(meta.data, index, true)._model,
					model,
					helpers.nextItem(meta.data, index, true)._model,
					model.tension
				);

				// Prevent the bezier going outside of the bounds of the graph
				model.controlPointPreviousX = Math.max(Math.min(controlPoints.previous.x, chartArea.right), chartArea.left);
				model.controlPointPreviousY = Math.max(Math.min(controlPoints.previous.y, chartArea.bottom), chartArea.top);

				model.controlPointNextX = Math.max(Math.min(controlPoints.next.x, chartArea.right), chartArea.left);
				model.controlPointNextY = Math.max(Math.min(controlPoints.next.y, chartArea.bottom), chartArea.top);

				// Now pivot the point for animation
				point.pivot();
			});
		},

		setHoverStyle: function(point) {
			// Point
			var dataset = this.chart.data.datasets[point._datasetIndex];
			var custom = point.custom || {};
			var index = point._index;
			var model = point._model;

			model.radius = custom.hoverRadius ? custom.hoverRadius : helpers.valueAtIndexOrDefault(dataset.pointHoverRadius, index, this.chart.options.elements.point.hoverRadius);
			model.backgroundColor = custom.hoverBackgroundColor ? custom.hoverBackgroundColor : helpers.valueAtIndexOrDefault(dataset.pointHoverBackgroundColor, index, helpers.getHoverColor(model.backgroundColor));
			model.borderColor = custom.hoverBorderColor ? custom.hoverBorderColor : helpers.valueAtIndexOrDefault(dataset.pointHoverBorderColor, index, helpers.getHoverColor(model.borderColor));
			model.borderWidth = custom.hoverBorderWidth ? custom.hoverBorderWidth : helpers.valueAtIndexOrDefault(dataset.pointHoverBorderWidth, index, model.borderWidth);
		},

		removeHoverStyle: function(point) {
			var dataset = this.chart.data.datasets[point._datasetIndex];
			var custom = point.custom || {};
			var index = point._index;
			var model = point._model;
			var pointElementOptions = this.chart.options.elements.point;

			model.radius = custom.radius ? custom.radius : helpers.valueAtIndexOrDefault(dataset.pointRadius, index, pointElementOptions.radius);
			model.backgroundColor = custom.backgroundColor ? custom.backgroundColor : helpers.valueAtIndexOrDefault(dataset.pointBackgroundColor, index, pointElementOptions.backgroundColor);
			model.borderColor = custom.borderColor ? custom.borderColor : helpers.valueAtIndexOrDefault(dataset.pointBorderColor, index, pointElementOptions.borderColor);
			model.borderWidth = custom.borderWidth ? custom.borderWidth : helpers.valueAtIndexOrDefault(dataset.pointBorderWidth, index, pointElementOptions.borderWidth);
		}
	});
};


/***/ }),
/* 692 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var defaults = __webpack_require__(20);

defaults._set('scatter', {
	hover: {
		mode: 'single'
	},

	scales: {
		xAxes: [{
			id: 'x-axis-1',    // need an ID so datasets can reference the scale
			type: 'linear',    // scatter should not use a category axis
			position: 'bottom'
		}],
		yAxes: [{
			id: 'y-axis-1',
			type: 'linear',
			position: 'left'
		}]
	},

	showLines: false,

	tooltips: {
		callbacks: {
			title: function() {
				return '';     // doesn't make sense for scatter since data are formatted as a point
			},
			label: function(item) {
				return '(' + item.xLabel + ', ' + item.yLabel + ')';
			}
		}
	}
});

module.exports = function(Chart) {

	// Scatter charts use line controllers
	Chart.controllers.scatter = Chart.controllers.line;

};


/***/ }),
/* 693 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function(Chart) {

	Chart.Bar = function(context, config) {
		config.type = 'bar';

		return new Chart(context, config);
	};

};


/***/ }),
/* 694 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function(Chart) {

	Chart.Bubble = function(context, config) {
		config.type = 'bubble';
		return new Chart(context, config);
	};

};


/***/ }),
/* 695 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function(Chart) {

	Chart.Doughnut = function(context, config) {
		config.type = 'doughnut';

		return new Chart(context, config);
	};

};


/***/ }),
/* 696 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function(Chart) {

	Chart.Line = function(context, config) {
		config.type = 'line';

		return new Chart(context, config);
	};

};


/***/ }),
/* 697 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function(Chart) {

	Chart.PolarArea = function(context, config) {
		config.type = 'polarArea';

		return new Chart(context, config);
	};

};


/***/ }),
/* 698 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function(Chart) {

	Chart.Radar = function(context, config) {
		config.type = 'radar';

		return new Chart(context, config);
	};

};


/***/ }),
/* 699 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function(Chart) {
	Chart.Scatter = function(context, config) {
		config.type = 'scatter';
		return new Chart(context, config);
	};
};


/***/ }),
/* 700 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {};
module.exports.filler = __webpack_require__(701);
module.exports.legend = __webpack_require__(702);
module.exports.title = __webpack_require__(703);


/***/ }),
/* 701 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Plugin based on discussion from the following Chart.js issues:
 * @see https://github.com/chartjs/Chart.js/issues/2380#issuecomment-279961569
 * @see https://github.com/chartjs/Chart.js/issues/2440#issuecomment-256461897
 */



var defaults = __webpack_require__(20);
var elements = __webpack_require__(55);
var helpers = __webpack_require__(15);

defaults._set('global', {
	plugins: {
		filler: {
			propagate: true
		}
	}
});

var mappers = {
	dataset: function(source) {
		var index = source.fill;
		var chart = source.chart;
		var meta = chart.getDatasetMeta(index);
		var visible = meta && chart.isDatasetVisible(index);
		var points = (visible && meta.dataset._children) || [];
		var length = points.length || 0;

		return !length ? null : function(point, i) {
			return (i < length && points[i]._view) || null;
		};
	},

	boundary: function(source) {
		var boundary = source.boundary;
		var x = boundary ? boundary.x : null;
		var y = boundary ? boundary.y : null;

		return function(point) {
			return {
				x: x === null ? point.x : x,
				y: y === null ? point.y : y,
			};
		};
	}
};

// @todo if (fill[0] === '#')
function decodeFill(el, index, count) {
	var model = el._model || {};
	var fill = model.fill;
	var target;

	if (fill === undefined) {
		fill = !!model.backgroundColor;
	}

	if (fill === false || fill === null) {
		return false;
	}

	if (fill === true) {
		return 'origin';
	}

	target = parseFloat(fill, 10);
	if (isFinite(target) && Math.floor(target) === target) {
		if (fill[0] === '-' || fill[0] === '+') {
			target = index + target;
		}

		if (target === index || target < 0 || target >= count) {
			return false;
		}

		return target;
	}

	switch (fill) {
	// compatibility
	case 'bottom':
		return 'start';
	case 'top':
		return 'end';
	case 'zero':
		return 'origin';
	// supported boundaries
	case 'origin':
	case 'start':
	case 'end':
		return fill;
	// invalid fill values
	default:
		return false;
	}
}

function computeBoundary(source) {
	var model = source.el._model || {};
	var scale = source.el._scale || {};
	var fill = source.fill;
	var target = null;
	var horizontal;

	if (isFinite(fill)) {
		return null;
	}

	// Backward compatibility: until v3, we still need to support boundary values set on
	// the model (scaleTop, scaleBottom and scaleZero) because some external plugins and
	// controllers might still use it (e.g. the Smith chart).

	if (fill === 'start') {
		target = model.scaleBottom === undefined ? scale.bottom : model.scaleBottom;
	} else if (fill === 'end') {
		target = model.scaleTop === undefined ? scale.top : model.scaleTop;
	} else if (model.scaleZero !== undefined) {
		target = model.scaleZero;
	} else if (scale.getBasePosition) {
		target = scale.getBasePosition();
	} else if (scale.getBasePixel) {
		target = scale.getBasePixel();
	}

	if (target !== undefined && target !== null) {
		if (target.x !== undefined && target.y !== undefined) {
			return target;
		}

		if (typeof target === 'number' && isFinite(target)) {
			horizontal = scale.isHorizontal();
			return {
				x: horizontal ? target : null,
				y: horizontal ? null : target
			};
		}
	}

	return null;
}

function resolveTarget(sources, index, propagate) {
	var source = sources[index];
	var fill = source.fill;
	var visited = [index];
	var target;

	if (!propagate) {
		return fill;
	}

	while (fill !== false && visited.indexOf(fill) === -1) {
		if (!isFinite(fill)) {
			return fill;
		}

		target = sources[fill];
		if (!target) {
			return false;
		}

		if (target.visible) {
			return fill;
		}

		visited.push(fill);
		fill = target.fill;
	}

	return false;
}

function createMapper(source) {
	var fill = source.fill;
	var type = 'dataset';

	if (fill === false) {
		return null;
	}

	if (!isFinite(fill)) {
		type = 'boundary';
	}

	return mappers[type](source);
}

function isDrawable(point) {
	return point && !point.skip;
}

function drawArea(ctx, curve0, curve1, len0, len1) {
	var i;

	if (!len0 || !len1) {
		return;
	}

	// building first area curve (normal)
	ctx.moveTo(curve0[0].x, curve0[0].y);
	for (i = 1; i < len0; ++i) {
		helpers.canvas.lineTo(ctx, curve0[i - 1], curve0[i]);
	}

	// joining the two area curves
	ctx.lineTo(curve1[len1 - 1].x, curve1[len1 - 1].y);

	// building opposite area curve (reverse)
	for (i = len1 - 1; i > 0; --i) {
		helpers.canvas.lineTo(ctx, curve1[i], curve1[i - 1], true);
	}
}

function doFill(ctx, points, mapper, view, color, loop) {
	var count = points.length;
	var span = view.spanGaps;
	var curve0 = [];
	var curve1 = [];
	var len0 = 0;
	var len1 = 0;
	var i, ilen, index, p0, p1, d0, d1;

	ctx.beginPath();

	for (i = 0, ilen = (count + !!loop); i < ilen; ++i) {
		index = i % count;
		p0 = points[index]._view;
		p1 = mapper(p0, index, view);
		d0 = isDrawable(p0);
		d1 = isDrawable(p1);

		if (d0 && d1) {
			len0 = curve0.push(p0);
			len1 = curve1.push(p1);
		} else if (len0 && len1) {
			if (!span) {
				drawArea(ctx, curve0, curve1, len0, len1);
				len0 = len1 = 0;
				curve0 = [];
				curve1 = [];
			} else {
				if (d0) {
					curve0.push(p0);
				}
				if (d1) {
					curve1.push(p1);
				}
			}
		}
	}

	drawArea(ctx, curve0, curve1, len0, len1);

	ctx.closePath();
	ctx.fillStyle = color;
	ctx.fill();
}

module.exports = {
	id: 'filler',

	afterDatasetsUpdate: function(chart, options) {
		var count = (chart.data.datasets || []).length;
		var propagate = options.propagate;
		var sources = [];
		var meta, i, el, source;

		for (i = 0; i < count; ++i) {
			meta = chart.getDatasetMeta(i);
			el = meta.dataset;
			source = null;

			if (el && el._model && el instanceof elements.Line) {
				source = {
					visible: chart.isDatasetVisible(i),
					fill: decodeFill(el, i, count),
					chart: chart,
					el: el
				};
			}

			meta.$filler = source;
			sources.push(source);
		}

		for (i = 0; i < count; ++i) {
			source = sources[i];
			if (!source) {
				continue;
			}

			source.fill = resolveTarget(sources, i, propagate);
			source.boundary = computeBoundary(source);
			source.mapper = createMapper(source);
		}
	},

	beforeDatasetDraw: function(chart, args) {
		var meta = args.meta.$filler;
		if (!meta) {
			return;
		}

		var ctx = chart.ctx;
		var el = meta.el;
		var view = el._view;
		var points = el._children || [];
		var mapper = meta.mapper;
		var color = view.backgroundColor || defaults.global.defaultColor;

		if (mapper && color && points.length) {
			helpers.canvas.clipArea(ctx, chart.chartArea);
			doFill(ctx, points, mapper, view, color, el._loop);
			helpers.canvas.unclipArea(ctx);
		}
	}
};


/***/ }),
/* 702 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var defaults = __webpack_require__(20);
var Element = __webpack_require__(46);
var helpers = __webpack_require__(15);
var layouts = __webpack_require__(106);

var noop = helpers.noop;

defaults._set('global', {
	legend: {
		display: true,
		position: 'top',
		fullWidth: true,
		reverse: false,
		weight: 1000,

		// a callback that will handle
		onClick: function(e, legendItem) {
			var index = legendItem.datasetIndex;
			var ci = this.chart;
			var meta = ci.getDatasetMeta(index);

			// See controller.isDatasetVisible comment
			meta.hidden = meta.hidden === null ? !ci.data.datasets[index].hidden : null;

			// We hid a dataset ... rerender the chart
			ci.update();
		},

		onHover: null,

		labels: {
			boxWidth: 40,
			padding: 10,
			// Generates labels shown in the legend
			// Valid properties to return:
			// text : text to display
			// fillStyle : fill of coloured box
			// strokeStyle: stroke of coloured box
			// hidden : if this legend item refers to a hidden item
			// lineCap : cap style for line
			// lineDash
			// lineDashOffset :
			// lineJoin :
			// lineWidth :
			generateLabels: function(chart) {
				var data = chart.data;
				return helpers.isArray(data.datasets) ? data.datasets.map(function(dataset, i) {
					return {
						text: dataset.label,
						fillStyle: (!helpers.isArray(dataset.backgroundColor) ? dataset.backgroundColor : dataset.backgroundColor[0]),
						hidden: !chart.isDatasetVisible(i),
						lineCap: dataset.borderCapStyle,
						lineDash: dataset.borderDash,
						lineDashOffset: dataset.borderDashOffset,
						lineJoin: dataset.borderJoinStyle,
						lineWidth: dataset.borderWidth,
						strokeStyle: dataset.borderColor,
						pointStyle: dataset.pointStyle,

						// Below is extra data used for toggling the datasets
						datasetIndex: i
					};
				}, this) : [];
			}
		}
	},

	legendCallback: function(chart) {
		var text = [];
		text.push('<ul class="' + chart.id + '-legend">');
		for (var i = 0; i < chart.data.datasets.length; i++) {
			text.push('<li><span style="background-color:' + chart.data.datasets[i].backgroundColor + '"></span>');
			if (chart.data.datasets[i].label) {
				text.push(chart.data.datasets[i].label);
			}
			text.push('</li>');
		}
		text.push('</ul>');
		return text.join('');
	}
});

/**
 * Helper function to get the box width based on the usePointStyle option
 * @param labelopts {Object} the label options on the legend
 * @param fontSize {Number} the label font size
 * @return {Number} width of the color box area
 */
function getBoxWidth(labelOpts, fontSize) {
	return labelOpts.usePointStyle ?
		fontSize * Math.SQRT2 :
		labelOpts.boxWidth;
}

/**
 * IMPORTANT: this class is exposed publicly as Chart.Legend, backward compatibility required!
 */
var Legend = Element.extend({

	initialize: function(config) {
		helpers.extend(this, config);

		// Contains hit boxes for each dataset (in dataset order)
		this.legendHitBoxes = [];

		// Are we in doughnut mode which has a different data type
		this.doughnutMode = false;
	},

	// These methods are ordered by lifecycle. Utilities then follow.
	// Any function defined here is inherited by all legend types.
	// Any function can be extended by the legend type

	beforeUpdate: noop,
	update: function(maxWidth, maxHeight, margins) {
		var me = this;

		// Update Lifecycle - Probably don't want to ever extend or overwrite this function ;)
		me.beforeUpdate();

		// Absorb the master measurements
		me.maxWidth = maxWidth;
		me.maxHeight = maxHeight;
		me.margins = margins;

		// Dimensions
		me.beforeSetDimensions();
		me.setDimensions();
		me.afterSetDimensions();
		// Labels
		me.beforeBuildLabels();
		me.buildLabels();
		me.afterBuildLabels();

		// Fit
		me.beforeFit();
		me.fit();
		me.afterFit();
		//
		me.afterUpdate();

		return me.minSize;
	},
	afterUpdate: noop,

	//

	beforeSetDimensions: noop,
	setDimensions: function() {
		var me = this;
		// Set the unconstrained dimension before label rotation
		if (me.isHorizontal()) {
			// Reset position before calculating rotation
			me.width = me.maxWidth;
			me.left = 0;
			me.right = me.width;
		} else {
			me.height = me.maxHeight;

			// Reset position before calculating rotation
			me.top = 0;
			me.bottom = me.height;
		}

		// Reset padding
		me.paddingLeft = 0;
		me.paddingTop = 0;
		me.paddingRight = 0;
		me.paddingBottom = 0;

		// Reset minSize
		me.minSize = {
			width: 0,
			height: 0
		};
	},
	afterSetDimensions: noop,

	//

	beforeBuildLabels: noop,
	buildLabels: function() {
		var me = this;
		var labelOpts = me.options.labels || {};
		var legendItems = helpers.callback(labelOpts.generateLabels, [me.chart], me) || [];

		if (labelOpts.filter) {
			legendItems = legendItems.filter(function(item) {
				return labelOpts.filter(item, me.chart.data);
			});
		}

		if (me.options.reverse) {
			legendItems.reverse();
		}

		me.legendItems = legendItems;
	},
	afterBuildLabels: noop,

	//

	beforeFit: noop,
	fit: function() {
		var me = this;
		var opts = me.options;
		var labelOpts = opts.labels;
		var display = opts.display;

		var ctx = me.ctx;

		var globalDefault = defaults.global;
		var valueOrDefault = helpers.valueOrDefault;
		var fontSize = valueOrDefault(labelOpts.fontSize, globalDefault.defaultFontSize);
		var fontStyle = valueOrDefault(labelOpts.fontStyle, globalDefault.defaultFontStyle);
		var fontFamily = valueOrDefault(labelOpts.fontFamily, globalDefault.defaultFontFamily);
		var labelFont = helpers.fontString(fontSize, fontStyle, fontFamily);

		// Reset hit boxes
		var hitboxes = me.legendHitBoxes = [];

		var minSize = me.minSize;
		var isHorizontal = me.isHorizontal();

		if (isHorizontal) {
			minSize.width = me.maxWidth; // fill all the width
			minSize.height = display ? 10 : 0;
		} else {
			minSize.width = display ? 10 : 0;
			minSize.height = me.maxHeight; // fill all the height
		}

		// Increase sizes here
		if (display) {
			ctx.font = labelFont;

			if (isHorizontal) {
				// Labels

				// Width of each line of legend boxes. Labels wrap onto multiple lines when there are too many to fit on one
				var lineWidths = me.lineWidths = [0];
				var totalHeight = me.legendItems.length ? fontSize + (labelOpts.padding) : 0;

				ctx.textAlign = 'left';
				ctx.textBaseline = 'top';

				helpers.each(me.legendItems, function(legendItem, i) {
					var boxWidth = getBoxWidth(labelOpts, fontSize);
					var width = boxWidth + (fontSize / 2) + ctx.measureText(legendItem.text).width;

					if (lineWidths[lineWidths.length - 1] + width + labelOpts.padding >= me.width) {
						totalHeight += fontSize + (labelOpts.padding);
						lineWidths[lineWidths.length] = me.left;
					}

					// Store the hitbox width and height here. Final position will be updated in `draw`
					hitboxes[i] = {
						left: 0,
						top: 0,
						width: width,
						height: fontSize
					};

					lineWidths[lineWidths.length - 1] += width + labelOpts.padding;
				});

				minSize.height += totalHeight;

			} else {
				var vPadding = labelOpts.padding;
				var columnWidths = me.columnWidths = [];
				var totalWidth = labelOpts.padding;
				var currentColWidth = 0;
				var currentColHeight = 0;
				var itemHeight = fontSize + vPadding;

				helpers.each(me.legendItems, function(legendItem, i) {
					var boxWidth = getBoxWidth(labelOpts, fontSize);
					var itemWidth = boxWidth + (fontSize / 2) + ctx.measureText(legendItem.text).width;

					// If too tall, go to new column
					if (currentColHeight + itemHeight > minSize.height) {
						totalWidth += currentColWidth + labelOpts.padding;
						columnWidths.push(currentColWidth); // previous column width

						currentColWidth = 0;
						currentColHeight = 0;
					}

					// Get max width
					currentColWidth = Math.max(currentColWidth, itemWidth);
					currentColHeight += itemHeight;

					// Store the hitbox width and height here. Final position will be updated in `draw`
					hitboxes[i] = {
						left: 0,
						top: 0,
						width: itemWidth,
						height: fontSize
					};
				});

				totalWidth += currentColWidth;
				columnWidths.push(currentColWidth);
				minSize.width += totalWidth;
			}
		}

		me.width = minSize.width;
		me.height = minSize.height;
	},
	afterFit: noop,

	// Shared Methods
	isHorizontal: function() {
		return this.options.position === 'top' || this.options.position === 'bottom';
	},

	// Actually draw the legend on the canvas
	draw: function() {
		var me = this;
		var opts = me.options;
		var labelOpts = opts.labels;
		var globalDefault = defaults.global;
		var lineDefault = globalDefault.elements.line;
		var legendWidth = me.width;
		var lineWidths = me.lineWidths;

		if (opts.display) {
			var ctx = me.ctx;
			var valueOrDefault = helpers.valueOrDefault;
			var fontColor = valueOrDefault(labelOpts.fontColor, globalDefault.defaultFontColor);
			var fontSize = valueOrDefault(labelOpts.fontSize, globalDefault.defaultFontSize);
			var fontStyle = valueOrDefault(labelOpts.fontStyle, globalDefault.defaultFontStyle);
			var fontFamily = valueOrDefault(labelOpts.fontFamily, globalDefault.defaultFontFamily);
			var labelFont = helpers.fontString(fontSize, fontStyle, fontFamily);
			var cursor;

			// Canvas setup
			ctx.textAlign = 'left';
			ctx.textBaseline = 'middle';
			ctx.lineWidth = 0.5;
			ctx.strokeStyle = fontColor; // for strikethrough effect
			ctx.fillStyle = fontColor; // render in correct colour
			ctx.font = labelFont;

			var boxWidth = getBoxWidth(labelOpts, fontSize);
			var hitboxes = me.legendHitBoxes;

			// current position
			var drawLegendBox = function(x, y, legendItem) {
				if (isNaN(boxWidth) || boxWidth <= 0) {
					return;
				}

				// Set the ctx for the box
				ctx.save();

				ctx.fillStyle = valueOrDefault(legendItem.fillStyle, globalDefault.defaultColor);
				ctx.lineCap = valueOrDefault(legendItem.lineCap, lineDefault.borderCapStyle);
				ctx.lineDashOffset = valueOrDefault(legendItem.lineDashOffset, lineDefault.borderDashOffset);
				ctx.lineJoin = valueOrDefault(legendItem.lineJoin, lineDefault.borderJoinStyle);
				ctx.lineWidth = valueOrDefault(legendItem.lineWidth, lineDefault.borderWidth);
				ctx.strokeStyle = valueOrDefault(legendItem.strokeStyle, globalDefault.defaultColor);
				var isLineWidthZero = (valueOrDefault(legendItem.lineWidth, lineDefault.borderWidth) === 0);

				if (ctx.setLineDash) {
					// IE 9 and 10 do not support line dash
					ctx.setLineDash(valueOrDefault(legendItem.lineDash, lineDefault.borderDash));
				}

				if (opts.labels && opts.labels.usePointStyle) {
					// Recalculate x and y for drawPoint() because its expecting
					// x and y to be center of figure (instead of top left)
					var radius = fontSize * Math.SQRT2 / 2;
					var offSet = radius / Math.SQRT2;
					var centerX = x + offSet;
					var centerY = y + offSet;

					// Draw pointStyle as legend symbol
					helpers.canvas.drawPoint(ctx, legendItem.pointStyle, radius, centerX, centerY);
				} else {
					// Draw box as legend symbol
					if (!isLineWidthZero) {
						ctx.strokeRect(x, y, boxWidth, fontSize);
					}
					ctx.fillRect(x, y, boxWidth, fontSize);
				}

				ctx.restore();
			};
			var fillText = function(x, y, legendItem, textWidth) {
				var halfFontSize = fontSize / 2;
				var xLeft = boxWidth + halfFontSize + x;
				var yMiddle = y + halfFontSize;

				ctx.fillText(legendItem.text, xLeft, yMiddle);

				if (legendItem.hidden) {
					// Strikethrough the text if hidden
					ctx.beginPath();
					ctx.lineWidth = 2;
					ctx.moveTo(xLeft, yMiddle);
					ctx.lineTo(xLeft + textWidth, yMiddle);
					ctx.stroke();
				}
			};

			// Horizontal
			var isHorizontal = me.isHorizontal();
			if (isHorizontal) {
				cursor = {
					x: me.left + ((legendWidth - lineWidths[0]) / 2),
					y: me.top + labelOpts.padding,
					line: 0
				};
			} else {
				cursor = {
					x: me.left + labelOpts.padding,
					y: me.top + labelOpts.padding,
					line: 0
				};
			}

			var itemHeight = fontSize + labelOpts.padding;
			helpers.each(me.legendItems, function(legendItem, i) {
				var textWidth = ctx.measureText(legendItem.text).width;
				var width = boxWidth + (fontSize / 2) + textWidth;
				var x = cursor.x;
				var y = cursor.y;

				if (isHorizontal) {
					if (x + width >= legendWidth) {
						y = cursor.y += itemHeight;
						cursor.line++;
						x = cursor.x = me.left + ((legendWidth - lineWidths[cursor.line]) / 2);
					}
				} else if (y + itemHeight > me.bottom) {
					x = cursor.x = x + me.columnWidths[cursor.line] + labelOpts.padding;
					y = cursor.y = me.top + labelOpts.padding;
					cursor.line++;
				}

				drawLegendBox(x, y, legendItem);

				hitboxes[i].left = x;
				hitboxes[i].top = y;

				// Fill the actual label
				fillText(x, y, legendItem, textWidth);

				if (isHorizontal) {
					cursor.x += width + (labelOpts.padding);
				} else {
					cursor.y += itemHeight;
				}

			});
		}
	},

	/**
	 * Handle an event
	 * @private
	 * @param {IEvent} event - The event to handle
	 * @return {Boolean} true if a change occured
	 */
	handleEvent: function(e) {
		var me = this;
		var opts = me.options;
		var type = e.type === 'mouseup' ? 'click' : e.type;
		var changed = false;

		if (type === 'mousemove') {
			if (!opts.onHover) {
				return;
			}
		} else if (type === 'click') {
			if (!opts.onClick) {
				return;
			}
		} else {
			return;
		}

		// Chart event already has relative position in it
		var x = e.x;
		var y = e.y;

		if (x >= me.left && x <= me.right && y >= me.top && y <= me.bottom) {
			// See if we are touching one of the dataset boxes
			var lh = me.legendHitBoxes;
			for (var i = 0; i < lh.length; ++i) {
				var hitBox = lh[i];

				if (x >= hitBox.left && x <= hitBox.left + hitBox.width && y >= hitBox.top && y <= hitBox.top + hitBox.height) {
					// Touching an element
					if (type === 'click') {
						// use e.native for backwards compatibility
						opts.onClick.call(me, e.native, me.legendItems[i]);
						changed = true;
						break;
					} else if (type === 'mousemove') {
						// use e.native for backwards compatibility
						opts.onHover.call(me, e.native, me.legendItems[i]);
						changed = true;
						break;
					}
				}
			}
		}

		return changed;
	}
});

function createNewLegendAndAttach(chart, legendOpts) {
	var legend = new Legend({
		ctx: chart.ctx,
		options: legendOpts,
		chart: chart
	});

	layouts.configure(chart, legend, legendOpts);
	layouts.addBox(chart, legend);
	chart.legend = legend;
}

module.exports = {
	id: 'legend',

	/**
	 * Backward compatibility: since 2.1.5, the legend is registered as a plugin, making
	 * Chart.Legend obsolete. To avoid a breaking change, we export the Legend as part of
	 * the plugin, which one will be re-exposed in the chart.js file.
	 * https://github.com/chartjs/Chart.js/pull/2640
	 * @private
	 */
	_element: Legend,

	beforeInit: function(chart) {
		var legendOpts = chart.options.legend;

		if (legendOpts) {
			createNewLegendAndAttach(chart, legendOpts);
		}
	},

	beforeUpdate: function(chart) {
		var legendOpts = chart.options.legend;
		var legend = chart.legend;

		if (legendOpts) {
			helpers.mergeIf(legendOpts, defaults.global.legend);

			if (legend) {
				layouts.configure(chart, legend, legendOpts);
				legend.options = legendOpts;
			} else {
				createNewLegendAndAttach(chart, legendOpts);
			}
		} else if (legend) {
			layouts.removeBox(chart, legend);
			delete chart.legend;
		}
	},

	afterEvent: function(chart, e) {
		var legend = chart.legend;
		if (legend) {
			legend.handleEvent(e);
		}
	}
};


/***/ }),
/* 703 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var defaults = __webpack_require__(20);
var Element = __webpack_require__(46);
var helpers = __webpack_require__(15);
var layouts = __webpack_require__(106);

var noop = helpers.noop;

defaults._set('global', {
	title: {
		display: false,
		fontStyle: 'bold',
		fullWidth: true,
		lineHeight: 1.2,
		padding: 10,
		position: 'top',
		text: '',
		weight: 2000         // by default greater than legend (1000) to be above
	}
});

/**
 * IMPORTANT: this class is exposed publicly as Chart.Legend, backward compatibility required!
 */
var Title = Element.extend({
	initialize: function(config) {
		var me = this;
		helpers.extend(me, config);

		// Contains hit boxes for each dataset (in dataset order)
		me.legendHitBoxes = [];
	},

	// These methods are ordered by lifecycle. Utilities then follow.

	beforeUpdate: noop,
	update: function(maxWidth, maxHeight, margins) {
		var me = this;

		// Update Lifecycle - Probably don't want to ever extend or overwrite this function ;)
		me.beforeUpdate();

		// Absorb the master measurements
		me.maxWidth = maxWidth;
		me.maxHeight = maxHeight;
		me.margins = margins;

		// Dimensions
		me.beforeSetDimensions();
		me.setDimensions();
		me.afterSetDimensions();
		// Labels
		me.beforeBuildLabels();
		me.buildLabels();
		me.afterBuildLabels();

		// Fit
		me.beforeFit();
		me.fit();
		me.afterFit();
		//
		me.afterUpdate();

		return me.minSize;

	},
	afterUpdate: noop,

	//

	beforeSetDimensions: noop,
	setDimensions: function() {
		var me = this;
		// Set the unconstrained dimension before label rotation
		if (me.isHorizontal()) {
			// Reset position before calculating rotation
			me.width = me.maxWidth;
			me.left = 0;
			me.right = me.width;
		} else {
			me.height = me.maxHeight;

			// Reset position before calculating rotation
			me.top = 0;
			me.bottom = me.height;
		}

		// Reset padding
		me.paddingLeft = 0;
		me.paddingTop = 0;
		me.paddingRight = 0;
		me.paddingBottom = 0;

		// Reset minSize
		me.minSize = {
			width: 0,
			height: 0
		};
	},
	afterSetDimensions: noop,

	//

	beforeBuildLabels: noop,
	buildLabels: noop,
	afterBuildLabels: noop,

	//

	beforeFit: noop,
	fit: function() {
		var me = this;
		var valueOrDefault = helpers.valueOrDefault;
		var opts = me.options;
		var display = opts.display;
		var fontSize = valueOrDefault(opts.fontSize, defaults.global.defaultFontSize);
		var minSize = me.minSize;
		var lineCount = helpers.isArray(opts.text) ? opts.text.length : 1;
		var lineHeight = helpers.options.toLineHeight(opts.lineHeight, fontSize);
		var textSize = display ? (lineCount * lineHeight) + (opts.padding * 2) : 0;

		if (me.isHorizontal()) {
			minSize.width = me.maxWidth; // fill all the width
			minSize.height = textSize;
		} else {
			minSize.width = textSize;
			minSize.height = me.maxHeight; // fill all the height
		}

		me.width = minSize.width;
		me.height = minSize.height;

	},
	afterFit: noop,

	// Shared Methods
	isHorizontal: function() {
		var pos = this.options.position;
		return pos === 'top' || pos === 'bottom';
	},

	// Actually draw the title block on the canvas
	draw: function() {
		var me = this;
		var ctx = me.ctx;
		var valueOrDefault = helpers.valueOrDefault;
		var opts = me.options;
		var globalDefaults = defaults.global;

		if (opts.display) {
			var fontSize = valueOrDefault(opts.fontSize, globalDefaults.defaultFontSize);
			var fontStyle = valueOrDefault(opts.fontStyle, globalDefaults.defaultFontStyle);
			var fontFamily = valueOrDefault(opts.fontFamily, globalDefaults.defaultFontFamily);
			var titleFont = helpers.fontString(fontSize, fontStyle, fontFamily);
			var lineHeight = helpers.options.toLineHeight(opts.lineHeight, fontSize);
			var offset = lineHeight / 2 + opts.padding;
			var rotation = 0;
			var top = me.top;
			var left = me.left;
			var bottom = me.bottom;
			var right = me.right;
			var maxWidth, titleX, titleY;

			ctx.fillStyle = valueOrDefault(opts.fontColor, globalDefaults.defaultFontColor); // render in correct colour
			ctx.font = titleFont;

			// Horizontal
			if (me.isHorizontal()) {
				titleX = left + ((right - left) / 2); // midpoint of the width
				titleY = top + offset;
				maxWidth = right - left;
			} else {
				titleX = opts.position === 'left' ? left + offset : right - offset;
				titleY = top + ((bottom - top) / 2);
				maxWidth = bottom - top;
				rotation = Math.PI * (opts.position === 'left' ? -0.5 : 0.5);
			}

			ctx.save();
			ctx.translate(titleX, titleY);
			ctx.rotate(rotation);
			ctx.textAlign = 'center';
			ctx.textBaseline = 'middle';

			var text = opts.text;
			if (helpers.isArray(text)) {
				var y = 0;
				for (var i = 0; i < text.length; ++i) {
					ctx.fillText(text[i], 0, y, maxWidth);
					y += lineHeight;
				}
			} else {
				ctx.fillText(text, 0, 0, maxWidth);
			}

			ctx.restore();
		}
	}
});

function createNewTitleBlockAndAttach(chart, titleOpts) {
	var title = new Title({
		ctx: chart.ctx,
		options: titleOpts,
		chart: chart
	});

	layouts.configure(chart, title, titleOpts);
	layouts.addBox(chart, title);
	chart.titleBlock = title;
}

module.exports = {
	id: 'title',

	/**
	 * Backward compatibility: since 2.1.5, the title is registered as a plugin, making
	 * Chart.Title obsolete. To avoid a breaking change, we export the Title as part of
	 * the plugin, which one will be re-exposed in the chart.js file.
	 * https://github.com/chartjs/Chart.js/pull/2640
	 * @private
	 */
	_element: Title,

	beforeInit: function(chart) {
		var titleOpts = chart.options.title;

		if (titleOpts) {
			createNewTitleBlockAndAttach(chart, titleOpts);
		}
	},

	beforeUpdate: function(chart) {
		var titleOpts = chart.options.title;
		var titleBlock = chart.titleBlock;

		if (titleOpts) {
			helpers.mergeIf(titleOpts, defaults.global.title);

			if (titleBlock) {
				layouts.configure(chart, titleBlock, titleOpts);
				titleBlock.options = titleOpts;
			} else {
				createNewTitleBlockAndAttach(chart, titleOpts);
			}
		} else if (titleBlock) {
			layouts.removeBox(chart, titleBlock);
			delete chart.titleBlock;
		}
	}
};


/***/ }),
/* 704 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_assets_jss_material_dashboard_pro_react_customSelectStyle_jsx__ = __webpack_require__(705);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_assets_jss_material_dashboard_pro_react_customCheckboxRadioSwitch_jsx__ = __webpack_require__(130);
// ##############################
// // // ExtendedForms view styles
// #############################
var extendedFormsStyle=Object.assign({},__WEBPACK_IMPORTED_MODULE_2_assets_jss_material_dashboard_pro_react_customCheckboxRadioSwitch_jsx__["a" /* default */],__WEBPACK_IMPORTED_MODULE_1_assets_jss_material_dashboard_pro_react_customSelectStyle_jsx__["a" /* default */],{cardTitle:__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["b" /* cardTitle */],cardIconTitle:Object.assign({},__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["b" /* cardTitle */],{marginTop:"15px",marginBottom:"0px"}),label:{cursor:"pointer",paddingLeft:"0",color:"rgba(0, 0, 0, 0.26)",fontSize:"14px",lineHeight:"1.428571429",fontWeight:"400",display:"inline-flex"}});/* harmony default export */ __webpack_exports__["a"] = (extendedFormsStyle);

/***/ }),
/* 705 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__ = __webpack_require__(21);
var customSelectStyle={select:{padding:"12px 0 7px",fontSize:".75rem",fontWeight:"400",lineHeight:"1.42857",textDecoration:"none",textTransform:"uppercase",color:"#3C4858",letterSpacing:"0","&:focus":{backgroundColor:"transparent"},"&[aria-owns] + input + svg":{transform:"rotate(180deg)"},"& + input + svg":{transition:"all 300ms linear"}},selectFormControl:{margin:"10px 1px 10px 0px !important","& > div":{"&:before":{borderBottomWidth:"1px !important",borderBottomColor:"#D2D2D2 !important"},"&:after":{borderBottomColor:__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["r" /* primaryColor */]+"!important"}}},selectLabel:{fontSize:"12px",textTransform:"uppercase",color:"#3C4858 !important",top:"8px"},selectMenu:{"& > div > ul":{border:"0",padding:"5px 0",margin:"0",boxShadow:"none",minWidth:"100%",borderRadius:"4px",boxSizing:"border-box",display:"block",fontSize:"14px",textAlign:"left",listStyle:"none",backgroundColor:"#fff",backgroundClip:"padding-box"},"& $selectPaper $selectMenuItemSelectedMultiple":{backgroundColor:"inherit"},"& > div + div":{maxHeight:"266px !important"}},selectMenuItem:{fontSize:"13px",padding:"10px 20px",margin:"0 5px",borderRadius:"2px",transition:"all 150ms linear",display:"block",clear:"both",fontWeight:"400",lineHeight:"2",whiteSpace:"nowrap",color:"#333",paddingRight:"30px","&:hover":Object.assign({backgroundColor:__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["r" /* primaryColor */],color:"#FFFFFF"},__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["p" /* primaryBoxShadow */])},selectMenuItemSelected:{backgroundColor:__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["r" /* primaryColor */]+"!important",color:"#FFFFFF"},selectMenuItemSelectedMultiple:{backgroundColor:"transparent !important","&:hover":Object.assign({backgroundColor:__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["r" /* primaryColor */]+"!important",color:"#FFFFFF"},__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["p" /* primaryBoxShadow */],{"&:after":{color:"#FFFFFF"}}),"&:after":{top:"16px",right:"12px",width:"12px",height:"5px",borderLeft:"2px solid currentColor",transform:"rotate(-45deg)",opacity:"1",color:"#3c4858",position:"absolute",content:"''",borderBottom:"2px solid currentColor",transition:"opacity 90ms cubic-bezier(0,0,.2,.1)"}},selectPaper:{boxSizing:"borderBox",borderRadius:"4px",padding:"0",minWidth:"100%",display:"block",border:"0",boxShadow:"0 2px 5px 0 rgba(0, 0, 0, 0.26)",backgroundClip:"padding-box",margin:"2px 0 0",fontSize:"14px",textAlign:"left",listStyle:"none",backgroundColor:"transparent",maxHeight:"266px"}};/* harmony default export */ __webpack_exports__["a"] = (customSelectStyle);

/***/ }),
/* 706 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export CargaEGeracaoComponent */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles_withStyles__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_Accordion_Accordion_jsx__ = __webpack_require__(707);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_icons_Assignment__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_icons_Assignment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__material_ui_icons_Assignment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_EnergyCompany_BouncingLoader_BouncingLoader_jsx__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_EnergyCompany_Cards_ECCard_jsx__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_Grid_GridContainer_jsx__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_Grid_GridItem_jsx__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_components_EnergyCompany_Grid_InfoGrid_jsx__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_components_EnergyCompany_Grid_InfoGridItem_jsx__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_services_companies__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_services_utils__ = __webpack_require__(23);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var styles={contentWrapper:{width:"100%","& h4":{fontWeight:"normal !important"}},wrapper:{"& h4":{fontWeight:"bold"}}};var CargaEGeracao=function(_Component){_inherits(CargaEGeracao,_Component);function CargaEGeracao(){var _ref;var _temp,_this,_ret;_classCallCheck(this,CargaEGeracao);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=CargaEGeracao.__proto__||Object.getPrototypeOf(CargaEGeracao)).call.apply(_ref,[this].concat(args))),_this),_this.state={agents:[],loading:true},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(CargaEGeracao,[{key:"componentDidMount",value:function componentDidMount(){var _this2=this;Object(__WEBPACK_IMPORTED_MODULE_13_services_companies__["a" /* fetchCargasEGeracao */])(this.props.companyId).then(function(_ref2){var data=_ref2.data;_this2.setState({agents:data,loading:false});});}},{key:"render",value:function render(){var _state=this.state,agents=_state.agents,loading=_state.loading;var classes=this.props.classes;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_Grid_GridContainer_jsx__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_Grid_GridItem_jsx__["a" /* default */],{md:12,sm:12,xs:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_EnergyCompany_Cards_ECCard_jsx__["a" /* default */],{content:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:classes.wrapper},loading?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_EnergyCompany_BouncingLoader_BouncingLoader_jsx__["a" /* default */],null):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_Accordion_Accordion_jsx__["a" /* default */],{collapses:Object(__WEBPACK_IMPORTED_MODULE_4_lodash__["map"])(agents,function(agent){return{content:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:classes.contentWrapper},agent.cargas&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h4",null,"Cargas"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_Accordion_Accordion_jsx__["a" /* default */],{collapses:Object(__WEBPACK_IMPORTED_MODULE_4_lodash__["map"])(agent.cargas,function(carga){return{content:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components_EnergyCompany_Grid_InfoGrid_jsx__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_components_EnergyCompany_Grid_InfoGridItem_jsx__["a" /* default */],{label:"C\xF3digo",value:carga.codigoCarga}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_components_EnergyCompany_Grid_InfoGridItem_jsx__["a" /* default */],{label:"Nome",value:carga.nomeCarga}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_components_EnergyCompany_Grid_InfoGridItem_jsx__["a" /* default */],{label:"Submercado",modifiers:["forceNewRowModifier"],value:Object(__WEBPACK_IMPORTED_MODULE_4_lodash__["toUpper"])(carga.submercado)}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_components_EnergyCompany_Grid_InfoGridItem_jsx__["a" /* default */],{label:"Estado",value:Object(__WEBPACK_IMPORTED_MODULE_4_lodash__["toUpper"])(carga.estado)}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_components_EnergyCompany_Grid_InfoGridItem_jsx__["a" /* default */],{label:"Consumo 12M",modifiers:["forceNewRowModifier"],value:Object(__WEBPACK_IMPORTED_MODULE_14_services_utils__["f" /* localeString */])(carga.consumo.energiaMediaMWMed)+" MW Médio"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_components_EnergyCompany_Grid_InfoGridItem_jsx__["a" /* default */],{label:"Cidade",value:Object(__WEBPACK_IMPORTED_MODULE_4_lodash__["toUpper"])(carga.cidade)}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_components_EnergyCompany_Grid_InfoGridItem_jsx__["a" /* default */],{label:"Distr. Conectada",modifiers:["forceNewRowModifier"],value:Object(__WEBPACK_IMPORTED_MODULE_4_lodash__["toUpper"])(carga.nomeDistribuidora)}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_components_EnergyCompany_Grid_InfoGridItem_jsx__["a" /* default */],{label:"Capacidade Carga",value:carga.capacidadeCargaKW+" KW"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_components_EnergyCompany_Grid_InfoGridItem_jsx__["a" /* default */],{label:"Data Migra\xE7\xE3o",modifiers:["forceNewRowModifier"],value:__WEBPACK_IMPORTED_MODULE_2_moment___default()(carga.dataMigracao).format("DD/MM/YYYY")}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_components_EnergyCompany_Grid_InfoGridItem_jsx__["a" /* default */],{label:"Proinfa 12M",value:Object(__WEBPACK_IMPORTED_MODULE_14_services_utils__["f" /* localeString */])(Object(__WEBPACK_IMPORTED_MODULE_4_lodash__["get"])(carga,"energiaProinfa.energiaMediaMWMed",''))+" MWMéd"})),title:carga.nomeCarga+" - "+carga.estado+" - "+Object(__WEBPACK_IMPORTED_MODULE_14_services_utils__["f" /* localeString */])(carga.consumo.energiaMediaMWMed)+" MW M\xE9dio"};})})),agent.geracoesUsinas&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h4",null,"Gera\xE7\xE3o"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_Accordion_Accordion_jsx__["a" /* default */],{collapses:Object(__WEBPACK_IMPORTED_MODULE_4_lodash__["map"])(agent.geracoesUsinas,function(geracao){return{content:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components_EnergyCompany_Grid_InfoGrid_jsx__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_components_EnergyCompany_Grid_InfoGridItem_jsx__["a" /* default */],{label:"C\xF3digo",value:geracao.codigoParcelaUsina}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_components_EnergyCompany_Grid_InfoGridItem_jsx__["a" /* default */],{label:"Nome",value:geracao.nomeParcelaUsina}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_components_EnergyCompany_Grid_InfoGridItem_jsx__["a" /* default */],{label:"Garantia F\xEDsica",modifiers:["forceNewRowModifier"],value:geracao.garantiaFisicaMWMed?Object(__WEBPACK_IMPORTED_MODULE_14_services_utils__["f" /* localeString */])(geracao.garantiaFisicaMWMed)+" MW Médio":"--"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_components_EnergyCompany_Grid_InfoGridItem_jsx__["a" /* default */],{label:"Desconto",value:geracao.desconto*100+"%"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_components_EnergyCompany_Grid_InfoGridItem_jsx__["a" /* default */],{label:"Gera\xE7\xE3o 12 meses",modifiers:["forceNewRowModifier"],value:Object(__WEBPACK_IMPORTED_MODULE_14_services_utils__["f" /* localeString */])(geracao.geracao.energiaMediaMWMed)+" MW Médio"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_components_EnergyCompany_Grid_InfoGridItem_jsx__["a" /* default */],{label:"Pot\xEAncia",value:geracao.capacidadeMW+" MW"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_components_EnergyCompany_Grid_InfoGridItem_jsx__["a" /* default */],{label:"Fator de Capacidade",modifiers:["forceNewRowModifier"],value:Object(__WEBPACK_IMPORTED_MODULE_4_lodash__["round"])(geracao.fatorCapacidade*100)+"%"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_components_EnergyCompany_Grid_InfoGridItem_jsx__["a" /* default */],{label:"Fator Op. Comercial",value:Object(__WEBPACK_IMPORTED_MODULE_4_lodash__["round"])(geracao.fatorOperacaoComercial*100)+"%"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_components_EnergyCompany_Grid_InfoGridItem_jsx__["a" /* default */],{label:"In\xEDcio Op. Comercial",modifiers:["forceNewRowModifier"],value:__WEBPACK_IMPORTED_MODULE_2_moment___default()(geracao.dataInicioOperacaoComercial).format("DD/MM/YYYY")}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_components_EnergyCompany_Grid_InfoGridItem_jsx__["a" /* default */],{label:"Particpa MRE",value:geracao.participaMRE?"Sim":"Não"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_components_EnergyCompany_Grid_InfoGridItem_jsx__["a" /* default */],{label:"Fonte Primaria",modifiers:["forceNewRowModifier"],value:geracao.fonteEnergiaPrimaria}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_components_EnergyCompany_Grid_InfoGridItem_jsx__["a" /* default */],{label:"CEG",value:geracao.ceg}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_components_EnergyCompany_Grid_InfoGridItem_jsx__["a" /* default */],{label:"Despacho",modifiers:["forceNewRowModifier"],value:geracao.despachoParcelaUsina})),title:geracao.nomeParcelaUsina+" - "+geracao.estadoParcelaUsina+" - "+Object(__WEBPACK_IMPORTED_MODULE_14_services_utils__["f" /* localeString */])(geracao.geracao.energiaMediaMWMed)+" MW M\xE9dio"};})}))),title:agent.nomePerfilAgente};})})),icon:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_icons_Assignment___default.a,null),title:"Pontos de Carga e Gera\xE7\xE3o"})));}}]);return CargaEGeracao;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);;CargaEGeracao.propTypes={classes:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,companyId:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired};/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles_withStyles___default()(styles)(CargaEGeracao));

/***/ }),
/* 707 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_styles_withStyles__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_styles_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_styles_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_ExpansionPanel__ = __webpack_require__(708);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_ExpansionPanel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_ExpansionPanel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_ExpansionPanelSummary__ = __webpack_require__(711);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_ExpansionPanelSummary___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_ExpansionPanelSummary__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_ExpansionPanelDetails__ = __webpack_require__(713);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_ExpansionPanelDetails___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_ExpansionPanelDetails__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_icons_ExpandMore__ = __webpack_require__(295);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_icons_ExpandMore___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__material_ui_icons_ExpandMore__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_assets_jss_material_dashboard_pro_react_components_accordionStyle_jsx__ = __webpack_require__(715);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// @material-ui/core components
// @material-ui/icons
var Accordion=function(_React$Component){_inherits(Accordion,_React$Component);function Accordion(props){_classCallCheck(this,Accordion);var _this=_possibleConstructorReturn(this,(Accordion.__proto__||Object.getPrototypeOf(Accordion)).call(this,props));_this.handleChange=function(panel){return function(event,expanded){_this.setState({active:expanded?panel:-1});};};_this.state={active:props.active};return _this;}_createClass(Accordion,[{key:"render",value:function render(){var _this2=this;var _props=this.props,classes=_props.classes,collapses=_props.collapses;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:classes.root},collapses.map(function(prop,key){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_ExpansionPanel___default.a,{expanded:_this2.state.active===key,onChange:_this2.handleChange(key),key:key,classes:{root:classes.expansionPanel,expanded:classes.expansionPanelExpanded}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_ExpansionPanelSummary___default.a,{expandIcon:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_icons_ExpandMore___default.a,null),classes:{root:classes.expansionPanelSummary,expanded:classes.expansionPanelSummaryExpaned,content:classes.expansionPanelSummaryContent,expandIcon:classes.expansionPanelSummaryExpandIcon}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h4",{className:classes.title},prop.title)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_ExpansionPanelDetails___default.a,{className:classes.expansionPanelDetails},prop.content));}));}}]);return Accordion;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);Accordion.defaultProps={active:-1};Accordion.propTypes={classes:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,// index of the default active collapse
active:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,collapses:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({title:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,content:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node})).isRequired};/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_2__material_ui_core_styles_withStyles___default()(__WEBPACK_IMPORTED_MODULE_7_assets_jss_material_dashboard_pro_react_components_accordionStyle_jsx__["a" /* default */])(Accordion));

/***/ }),
/* 708 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(2);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _ExpansionPanel.default;
  }
});

var _ExpansionPanel = _interopRequireDefault(__webpack_require__(709));

/***/ }),
/* 709 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(2);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(6));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(7));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(4));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(11));

var _createClass2 = _interopRequireDefault(__webpack_require__(12));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(13));

var _inherits2 = _interopRequireDefault(__webpack_require__(14));

var _objectSpread2 = _interopRequireDefault(__webpack_require__(17));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _classnames = _interopRequireDefault(__webpack_require__(5));

var _warning = _interopRequireDefault(__webpack_require__(16));

var _Collapse = _interopRequireDefault(__webpack_require__(294));

var _Paper = _interopRequireDefault(__webpack_require__(51));

var _withStyles = _interopRequireDefault(__webpack_require__(3));

var _reactHelpers = __webpack_require__(184);

// @inheritedComponent Paper
// Workaround https://github.com/jsdom/jsdom/issues/2026
var edgeFix = typeof window !== 'undefined' && /jsdom/.test(window.navigator.userAgent) ? {} : {
  // Fix a rendering issue on Edge
  '@supports (-ms-ime-align: auto)': {
    borderBottomLeftRadius: 0,
    borderBottomRightRadius: 0
  }
};

var styles = function styles(theme) {
  var transition = {
    duration: theme.transitions.duration.shortest
  };
  return {
    /* Styles applied to the root element. */
    root: {
      position: 'relative',
      transition: theme.transitions.create(['margin'], transition),
      '&:before': {
        position: 'absolute',
        left: 0,
        top: -1,
        right: 0,
        height: 1,
        content: '""',
        opacity: 1,
        backgroundColor: theme.palette.divider,
        transition: theme.transitions.create(['opacity', 'background-color'], transition)
      },
      '&:first-child': {
        borderTopLeftRadius: 2,
        borderTopRightRadius: 2,
        '&:before': {
          display: 'none'
        }
      },
      '&:last-child': (0, _objectSpread2.default)({
        borderBottomLeftRadius: 2,
        borderBottomRightRadius: 2
      }, edgeFix),
      '&$expanded + &': {
        '&:before': {
          display: 'none'
        }
      }
    },

    /* Styles applied to the root element if `expanded={true}`. */
    expanded: {
      margin: '16px 0',
      '&:first-child': {
        marginTop: 0
      },
      '&:last-child': {
        marginBottom: 0
      },
      '&:before': {
        opacity: 0
      }
    },

    /* Styles applied to the root element if `disabled={true}`. */
    disabled: {
      backgroundColor: theme.palette.action.disabledBackground
    }
  };
};

exports.styles = styles;

var ExpansionPanel =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(ExpansionPanel, _React$Component);

  function ExpansionPanel(props) {
    var _this;

    (0, _classCallCheck2.default)(this, ExpansionPanel);
    _this = (0, _possibleConstructorReturn2.default)(this, (ExpansionPanel.__proto__ || Object.getPrototypeOf(ExpansionPanel)).call(this, props));
    _this.isControlled = null;
    _this.state = {};

    _this.handleChange = function (event) {
      var expanded = _this.isControlled ? _this.props.expanded : _this.state.expanded;

      if (!_this.isControlled) {
        _this.setState({
          expanded: !expanded
        });
      }

      if (_this.props.onChange) {
        _this.props.onChange(event, !expanded);
      }
    };

    _this.isControlled = props.expanded != null;

    if (!_this.isControlled) {
      // not controlled, use internal state
      _this.state.expanded = props.defaultExpanded !== undefined ? props.defaultExpanded : false;
    }

    return _this;
  }

  (0, _createClass2.default)(ExpansionPanel, [{
    key: "render",
    value: function render() {
      var _classNames,
          _this2 = this;

      var _props = this.props,
          childrenProp = _props.children,
          classes = _props.classes,
          classNameProp = _props.className,
          CollapsePropsProp = _props.CollapseProps,
          defaultExpanded = _props.defaultExpanded,
          disabled = _props.disabled,
          expandedProp = _props.expanded,
          onChange = _props.onChange,
          other = (0, _objectWithoutProperties2.default)(_props, ["children", "classes", "className", "CollapseProps", "defaultExpanded", "disabled", "expanded", "onChange"]);
      var expanded = this.isControlled ? expandedProp : this.state.expanded;
      var className = (0, _classnames.default)(classes.root, (_classNames = {}, (0, _defineProperty2.default)(_classNames, classes.expanded, expanded), (0, _defineProperty2.default)(_classNames, classes.disabled, disabled), _classNames), classNameProp);
      var summary = null;

      var children = _react.default.Children.map(childrenProp, function (child) {
        if (!_react.default.isValidElement(child)) {
          return null;
        }

         false ? (0, _warning.default)(child.type !== _react.default.Fragment, ["Material-UI: the ExpansionPanel component doesn't accept a Fragment as a child.", 'Consider providing an array instead.'].join('\n')) : void 0;

        if ((0, _reactHelpers.isMuiElement)(child, ['ExpansionPanelSummary'])) {
          summary = _react.default.cloneElement(child, {
            disabled: disabled,
            expanded: expanded,
            onChange: _this2.handleChange
          });
          return null;
        }

        return child;
      });

      var CollapseProps = !expanded ? {
        'aria-hidden': 'true'
      } : null;
      return _react.default.createElement(_Paper.default, (0, _extends2.default)({
        className: className,
        elevation: 1,
        square: true
      }, other), summary, _react.default.createElement(_Collapse.default, (0, _extends2.default)({
        "in": expanded,
        timeout: "auto"
      }, CollapseProps, CollapsePropsProp), children));
    }
  }]);
  return ExpansionPanel;
}(_react.default.Component);

ExpansionPanel.propTypes =  false ? {
  /**
   * The content of the expansion panel.
   */
  children: _propTypes.default.node.isRequired,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * Properties applied to the [`Collapse`](/api/collapse) element.
   */
  CollapseProps: _propTypes.default.object,

  /**
   * If `true`, expands the panel by default.
   */
  defaultExpanded: _propTypes.default.bool,

  /**
   * If `true`, the panel will be displayed in a disabled state.
   */
  disabled: _propTypes.default.bool,

  /**
   * If `true`, expands the panel, otherwise collapse it.
   * Setting this prop enables control over the panel.
   */
  expanded: _propTypes.default.bool,

  /**
   * Callback fired when the expand/collapse state is changed.
   *
   * @param {object} event The event source of the callback
   * @param {boolean} expanded The `expanded` state of the panel
   */
  onChange: _propTypes.default.func
} : {};
ExpansionPanel.defaultProps = {
  defaultExpanded: false,
  disabled: false
};

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiExpansionPanel'
})(ExpansionPanel);

exports.default = _default;

/***/ }),
/* 710 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(2);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(6));

var _objectSpread2 = _interopRequireDefault(__webpack_require__(17));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(7));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(4));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(11));

var _createClass2 = _interopRequireDefault(__webpack_require__(12));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(13));

var _inherits2 = _interopRequireDefault(__webpack_require__(14));

var _react = _interopRequireDefault(__webpack_require__(0));

var _classnames = _interopRequireDefault(__webpack_require__(5));

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _Transition = _interopRequireDefault(__webpack_require__(62));

var _withStyles = _interopRequireDefault(__webpack_require__(3));

var _transitions = __webpack_require__(93);

var _utils = __webpack_require__(131);

// @inheritedComponent Transition
var styles = function styles(theme) {
  return {
    /* Styles applied to the container element. */
    container: {
      height: 0,
      overflow: 'hidden',
      transition: theme.transitions.create('height')
    },

    /* Styles applied to the container element when the transition has entered. */
    entered: {
      height: 'auto'
    },

    /* Styles applied to the outer wrapper element. */
    wrapper: {
      // Hack to get children with a negative margin to not falsify the height computation.
      display: 'flex'
    },

    /* Styles applied to the outer wrapper element. */
    wrapperInner: {
      width: '100%'
    }
  };
};
/**
 * The Collapse transition is used by the
 * [Vertical Stepper](/demos/steppers#vertical-stepper) StepContent component.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */


exports.styles = styles;

var Collapse =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(Collapse, _React$Component);

  function Collapse() {
    var _ref;

    var _temp, _this;

    (0, _classCallCheck2.default)(this, Collapse);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return (0, _possibleConstructorReturn2.default)(_this, (_temp = _this = (0, _possibleConstructorReturn2.default)(this, (_ref = Collapse.__proto__ || Object.getPrototypeOf(Collapse)).call.apply(_ref, [this].concat(args))), _this.wrapper = null, _this.autoTransitionDuration = null, _this.timer = null, _this.handleEnter = function (node) {
      node.style.height = _this.props.collapsedHeight;

      if (_this.props.onEnter) {
        _this.props.onEnter(node);
      }
    }, _this.handleEntering = function (node) {
      var _this$props = _this.props,
          timeout = _this$props.timeout,
          theme = _this$props.theme;
      var wrapperHeight = _this.wrapperRef ? _this.wrapperRef.clientHeight : 0;

      var _getTransitionProps = (0, _utils.getTransitionProps)(_this.props, {
        mode: 'enter'
      }),
          transitionDuration = _getTransitionProps.duration;

      if (timeout === 'auto') {
        var duration2 = theme.transitions.getAutoHeightDuration(wrapperHeight);
        node.style.transitionDuration = "".concat(duration2, "ms");
        _this.autoTransitionDuration = duration2;
      } else {
        node.style.transitionDuration = typeof transitionDuration === 'string' ? transitionDuration : "".concat(transitionDuration, "ms");
      }

      node.style.height = "".concat(wrapperHeight, "px");

      if (_this.props.onEntering) {
        _this.props.onEntering(node);
      }
    }, _this.handleEntered = function (node) {
      node.style.height = 'auto';

      if (_this.props.onEntered) {
        _this.props.onEntered(node);
      }
    }, _this.handleExit = function (node) {
      var wrapperHeight = _this.wrapperRef ? _this.wrapperRef.clientHeight : 0;
      node.style.height = "".concat(wrapperHeight, "px");

      if (_this.props.onExit) {
        _this.props.onExit(node);
      }
    }, _this.handleExiting = function (node) {
      var _this$props2 = _this.props,
          timeout = _this$props2.timeout,
          theme = _this$props2.theme;
      var wrapperHeight = _this.wrapperRef ? _this.wrapperRef.clientHeight : 0;

      var _getTransitionProps2 = (0, _utils.getTransitionProps)(_this.props, {
        mode: 'exit'
      }),
          transitionDuration = _getTransitionProps2.duration;

      if (timeout === 'auto') {
        var duration2 = theme.transitions.getAutoHeightDuration(wrapperHeight);
        node.style.transitionDuration = "".concat(duration2, "ms");
        _this.autoTransitionDuration = duration2;
      } else {
        node.style.transitionDuration = typeof transitionDuration === 'string' ? transitionDuration : "".concat(transitionDuration, "ms");
      }

      node.style.height = _this.props.collapsedHeight;

      if (_this.props.onExiting) {
        _this.props.onExiting(node);
      }
    }, _this.addEndListener = function (_, next) {
      if (_this.props.timeout === 'auto') {
        _this.timer = setTimeout(next, _this.autoTransitionDuration || 0);
      }
    }, _temp));
  }

  (0, _createClass2.default)(Collapse, [{
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      clearTimeout(this.timer);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          children = _props.children,
          classes = _props.classes,
          className = _props.className,
          collapsedHeight = _props.collapsedHeight,
          Component = _props.component,
          onEnter = _props.onEnter,
          onEntered = _props.onEntered,
          onEntering = _props.onEntering,
          onExit = _props.onExit,
          onExiting = _props.onExiting,
          style = _props.style,
          theme = _props.theme,
          timeout = _props.timeout,
          other = (0, _objectWithoutProperties2.default)(_props, ["children", "classes", "className", "collapsedHeight", "component", "onEnter", "onEntered", "onEntering", "onExit", "onExiting", "style", "theme", "timeout"]);
      return _react.default.createElement(_Transition.default, (0, _extends2.default)({
        onEnter: this.handleEnter,
        onEntered: this.handleEntered,
        onEntering: this.handleEntering,
        onExit: this.handleExit,
        onExiting: this.handleExiting,
        addEndListener: this.addEndListener,
        timeout: timeout === 'auto' ? null : timeout
      }, other), function (state, childProps) {
        return _react.default.createElement(Component, (0, _extends2.default)({
          className: (0, _classnames.default)(classes.container, (0, _defineProperty2.default)({}, classes.entered, state === 'entered'), className),
          style: (0, _objectSpread2.default)({}, style, {
            minHeight: collapsedHeight
          })
        }, childProps), _react.default.createElement("div", {
          className: classes.wrapper,
          ref: function ref(_ref2) {
            _this2.wrapperRef = _ref2;
          }
        }, _react.default.createElement("div", {
          className: classes.wrapperInner
        }, children)));
      });
    }
  }]);
  return Collapse;
}(_react.default.Component);

Collapse.propTypes =  false ? {
  /**
   * The content node to be collapsed.
   */
  children: _propTypes.default.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * The height of the container when collapsed.
   */
  collapsedHeight: _propTypes.default.string,

  /**
   * The component used for the root node.
   * Either a string to use a DOM element or a component.
   */
  component: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func, _propTypes.default.object]),

  /**
   * If `true`, the component will transition in.
   */
  in: _propTypes.default.bool,

  /**
   * @ignore
   */
  onEnter: _propTypes.default.func,

  /**
   * @ignore
   */
  onEntered: _propTypes.default.func,

  /**
   * @ignore
   */
  onEntering: _propTypes.default.func,

  /**
   * @ignore
   */
  onExit: _propTypes.default.func,

  /**
   * @ignore
   */
  onExiting: _propTypes.default.func,

  /**
   * @ignore
   */
  style: _propTypes.default.object,

  /**
   * @ignore
   */
  theme: _propTypes.default.object.isRequired,

  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   *
   * Set to 'auto' to automatically calculate transition time based on height.
   */
  timeout: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.shape({
    enter: _propTypes.default.number,
    exit: _propTypes.default.number
  }), _propTypes.default.oneOf(['auto'])])
} : {};
Collapse.defaultProps = {
  collapsedHeight: '0px',
  component: 'div',
  timeout: _transitions.duration.standard
};
Collapse.muiSupportAuto = true;

var _default = (0, _withStyles.default)(styles, {
  withTheme: true,
  name: 'MuiCollapse'
})(Collapse);

exports.default = _default;

/***/ }),
/* 711 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(2);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _ExpansionPanelSummary.default;
  }
});

var _ExpansionPanelSummary = _interopRequireDefault(__webpack_require__(712));

/***/ }),
/* 712 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(2);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(6));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(7));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(4));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(11));

var _createClass2 = _interopRequireDefault(__webpack_require__(12));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(13));

var _inherits2 = _interopRequireDefault(__webpack_require__(14));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _classnames = _interopRequireDefault(__webpack_require__(5));

var _ButtonBase = _interopRequireDefault(__webpack_require__(124));

var _IconButton = _interopRequireDefault(__webpack_require__(98));

var _withStyles = _interopRequireDefault(__webpack_require__(3));

// @inheritedComponent ButtonBase
var styles = function styles(theme) {
  var transition = {
    duration: theme.transitions.duration.shortest
  };
  return {
    /* Styles applied to the root element. */
    root: {
      display: 'flex',
      minHeight: 8 * 6,
      transition: theme.transitions.create(['min-height', 'background-color'], transition),
      padding: '0 24px 0 24px',
      '&:hover:not($disabled)': {
        cursor: 'pointer'
      },
      '&$expanded': {
        minHeight: 64
      },
      '&$focused': {
        backgroundColor: theme.palette.grey[300]
      },
      '&$disabled': {
        opacity: 0.38
      }
    },

    /* Styles applied to the root element if `expanded={true}`. */
    expanded: {},

    /* Styles applied to the root and children wrapper elements when focused. */
    focused: {},

    /* Styles applied to the root element if `disabled={true}`. */
    disabled: {},

    /* Styles applied to the children wrapper element. */
    content: {
      display: 'flex',
      flexGrow: 1,
      transition: theme.transitions.create(['margin'], transition),
      margin: '12px 0',
      '& > :last-child': {
        paddingRight: 32
      },
      '&$expanded': {
        margin: '20px 0'
      }
    },

    /* Styles applied to the `IconButton` component when `expandIcon` is supplied. */
    expandIcon: {
      position: 'absolute',
      top: '50%',
      right: 8,
      transform: 'translateY(-50%) rotate(0deg)',
      transition: theme.transitions.create('transform', transition),
      '&:hover': {
        // Disable the hover effect for the IconButton,
        // because a hover effect should apply to the entire Expand button and
        // not only to the IconButton.
        backgroundColor: 'transparent'
      },
      '&$expanded': {
        transform: 'translateY(-50%) rotate(180deg)'
      }
    }
  };
};

exports.styles = styles;

var ExpansionPanelSummary =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(ExpansionPanelSummary, _React$Component);

  function ExpansionPanelSummary() {
    var _ref;

    var _temp, _this;

    (0, _classCallCheck2.default)(this, ExpansionPanelSummary);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return (0, _possibleConstructorReturn2.default)(_this, (_temp = _this = (0, _possibleConstructorReturn2.default)(this, (_ref = ExpansionPanelSummary.__proto__ || Object.getPrototypeOf(ExpansionPanelSummary)).call.apply(_ref, [this].concat(args))), _this.state = {
      focused: false
    }, _this.handleFocus = function () {
      _this.setState({
        focused: true
      });
    }, _this.handleBlur = function () {
      _this.setState({
        focused: false
      });
    }, _this.handleChange = function (event) {
      var _this$props = _this.props,
          onChange = _this$props.onChange,
          onClick = _this$props.onClick;

      if (onChange) {
        onChange(event);
      }

      if (onClick) {
        onClick(event);
      }
    }, _temp));
  }

  (0, _createClass2.default)(ExpansionPanelSummary, [{
    key: "render",
    value: function render() {
      var _classNames;

      var _props = this.props,
          children = _props.children,
          classes = _props.classes,
          className = _props.className,
          disabled = _props.disabled,
          expanded = _props.expanded,
          expandIcon = _props.expandIcon,
          IconButtonProps = _props.IconButtonProps,
          onChange = _props.onChange,
          other = (0, _objectWithoutProperties2.default)(_props, ["children", "classes", "className", "disabled", "expanded", "expandIcon", "IconButtonProps", "onChange"]);
      var focused = this.state.focused;
      return _react.default.createElement(_ButtonBase.default, (0, _extends2.default)({
        focusRipple: false,
        disableRipple: true,
        disabled: disabled,
        component: "div",
        "aria-expanded": expanded,
        className: (0, _classnames.default)(classes.root, (_classNames = {}, (0, _defineProperty2.default)(_classNames, classes.disabled, disabled), (0, _defineProperty2.default)(_classNames, classes.expanded, expanded), (0, _defineProperty2.default)(_classNames, classes.focused, focused), _classNames), className)
      }, other, {
        onFocusVisible: this.handleFocus,
        onBlur: this.handleBlur,
        onClick: this.handleChange
      }), _react.default.createElement("div", {
        className: (0, _classnames.default)(classes.content, (0, _defineProperty2.default)({}, classes.expanded, expanded))
      }, children), expandIcon && _react.default.createElement(_IconButton.default, (0, _extends2.default)({
        disabled: disabled,
        className: (0, _classnames.default)(classes.expandIcon, (0, _defineProperty2.default)({}, classes.expanded, expanded)),
        component: "div",
        tabIndex: -1,
        "aria-hidden": "true"
      }, IconButtonProps), expandIcon));
    }
  }]);
  return ExpansionPanelSummary;
}(_react.default.Component);

ExpansionPanelSummary.propTypes =  false ? {
  /**
   * The content of the expansion panel summary.
   */
  children: _propTypes.default.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * @ignore
   * If `true`, the summary will be displayed in a disabled state.
   */
  disabled: _propTypes.default.bool,

  /**
   * @ignore
   * If `true`, expands the summary, otherwise collapse it.
   */
  expanded: _propTypes.default.bool,

  /**
   * The icon to display as the expand indicator.
   */
  expandIcon: _propTypes.default.node,

  /**
   * Properties applied to the `TouchRipple` element wrapping the expand icon.
   */
  IconButtonProps: _propTypes.default.object,

  /**
   * @ignore
   */
  onChange: _propTypes.default.func,

  /**
   * @ignore
   */
  onClick: _propTypes.default.func
} : {};
ExpansionPanelSummary.defaultProps = {
  disabled: false
};
ExpansionPanelSummary.muiName = 'ExpansionPanelSummary';

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiExpansionPanelSummary'
})(ExpansionPanelSummary);

exports.default = _default;

/***/ }),
/* 713 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(2);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _ExpansionPanelDetails.default;
  }
});

var _ExpansionPanelDetails = _interopRequireDefault(__webpack_require__(714));

/***/ }),
/* 714 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(2);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(6));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(4));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _classnames = _interopRequireDefault(__webpack_require__(5));

var _withStyles = _interopRequireDefault(__webpack_require__(3));

var styles = {
  /* Styles applied to the root element. */
  root: {
    display: 'flex',
    padding: '8px 24px 24px'
  }
};
exports.styles = styles;

function ExpansionPanelDetails(props) {
  var classes = props.classes,
      children = props.children,
      className = props.className,
      other = (0, _objectWithoutProperties2.default)(props, ["classes", "children", "className"]);
  return _react.default.createElement("div", (0, _extends2.default)({
    className: (0, _classnames.default)(classes.root, className)
  }, other), children);
}

ExpansionPanelDetails.propTypes =  false ? {
  /**
   * The content of the expansion panel details.
   */
  children: _propTypes.default.node.isRequired,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string
} : {};

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiExpansionPanelDetails'
})(ExpansionPanelDetails);

exports.default = _default;

/***/ }),
/* 715 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__ = __webpack_require__(21);
function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var accordionStyle=function accordionStyle(theme){var _$expansionPanelSum,_expansionPanelSummar;return{root:{flexGrow:1,marginBottom:"20px"},expansionPanel:{boxShadow:"none","&:before":{display:"none !important"}},expansionPanelExpanded:{margin:"0"},expansionPanelSummary:{minHeight:"auto !important",backgroundColor:"transparent",borderBottom:"1px solid #ddd",padding:"25px 10px 5px 0px",borderTopLeftRadius:"3px",borderTopRightRadius:"3px",color:"#3C4858","&:hover":{color:__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["r" /* primaryColor */]}},expansionPanelSummaryExpaned:{color:__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["r" /* primaryColor */],"& $expansionPanelSummaryExpandIcon":(_$expansionPanelSum={},_defineProperty(_$expansionPanelSum,theme.breakpoints.up("md"),{top:"auto !important"}),_defineProperty(_$expansionPanelSum,"transform","rotate(180deg)"),_defineProperty(_$expansionPanelSum,theme.breakpoints.down("sm"),{top:"10px !important"}),_$expansionPanelSum)},expansionPanelSummaryContent:{margin:"0 !important"},expansionPanelSummaryExpandIcon:(_expansionPanelSummar={},_defineProperty(_expansionPanelSummar,theme.breakpoints.up("md"),{top:"auto !important"}),_defineProperty(_expansionPanelSummar,"transform","rotate(0deg)"),_defineProperty(_expansionPanelSummar,"color","inherit"),_defineProperty(_expansionPanelSummar,theme.breakpoints.down("sm"),{top:"10px !important"}),_expansionPanelSummar),expansionPanelSummaryExpandIconExpanded:{},title:{fontSize:"15px",fontWeight:"bolder",marginTop:"0",marginBottom:"0",color:"inherit"},expansionPanelDetails:{padding:"15px 0px 5px"}};};/* harmony default export */ __webpack_exports__["a"] = (accordionStyle);

/***/ }),
/* 716 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_styles_withStyles__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_styles_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_styles_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_icons_Assignment__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_icons_Assignment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__material_ui_icons_Assignment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_Checkbox__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_Checkbox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Checkbox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_EnergyCompany_Cards_ECCard_jsx__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_Grid_GridContainer_jsx__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_EnergyCompany_Grid_InfoGrid_jsx__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_EnergyCompany_Grid_InfoGridItem_jsx__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_Grid_GridItem_jsx__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_components_Table_Table_jsx__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_services_utils__ = __webpack_require__(23);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var styles={tableWrapper:{marginBottom:"25px","&:last-child":{marginBottom:"0"}}};var CCEEData=function(_Component){_inherits(CCEEData,_Component);function CCEEData(){_classCallCheck(this,CCEEData);return _possibleConstructorReturn(this,(CCEEData.__proto__||Object.getPrototypeOf(CCEEData)).apply(this,arguments));}_createClass(CCEEData,[{key:"getData",value:function getData(){var _props=this.props,agent=_props.agent,handleProfileCheck=_props.handleProfileCheck,profilesChecked=_props.profilesChecked;var agentTable={agentCode:agent.code,agentName:agent.name,agentCategory:agent.category,data:[]};var getCheckbox=function getCheckbox(profile){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Checkbox___default.a,{checked:!!profilesChecked[profile.id],onChange:handleProfileCheck,value:profile.id});};Object(__WEBPACK_IMPORTED_MODULE_3_lodash__["forEach"])(agent.agentProfiles,function(profile){agentTable.data.push([getCheckbox(profile),profile.code,profile.name,profile.class,profile.status,profile.submarket,profile.retailer?"Sim":"Não"]);});return agentTable;}},{key:"getCheckAll",value:function getCheckAll(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Checkbox___default.a,{checked:this.props.allProfilesChecked,onChange:this.props.handleAllProfilesCheck});}},{key:"render",value:function render(){var classes=this.props.classes;var tableData=this.getData();return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_Grid_GridContainer_jsx__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_Grid_GridItem_jsx__["a" /* default */],{xs:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_EnergyCompany_Cards_ECCard_jsx__["a" /* default */],{content:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:classes.tableWrapper},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_EnergyCompany_Grid_InfoGrid_jsx__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_EnergyCompany_Grid_InfoGridItem_jsx__["a" /* default */],{label:"C\xF3digo do Agente",value:tableData.agentCode}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_EnergyCompany_Grid_InfoGridItem_jsx__["a" /* default */],{label:"Nome",value:tableData.agentName}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_EnergyCompany_Grid_InfoGridItem_jsx__["a" /* default */],{label:"Categoria",value:Object(__WEBPACK_IMPORTED_MODULE_12_services_utils__["d" /* capitalizeString */])(tableData.agentCategory)})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components_Table_Table_jsx__["a" /* default */],{colorsColls:["primary"],tableData:tableData.data,tableHead:[this.getCheckAll(),"Código Perfil","Sigla","Classe","Status","Submercado","Perfil Varejista"],tableHeaderColor:"primary"})),icon:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_icons_Assignment___default.a,null),title:"Dados CCEE"})));}}]);return CCEEData;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);;CCEEData.propTypes={agent:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({agentProfiles:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array.isRequired,category:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,code:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,consolidatedAccountingValues:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,consolidatedEnergy:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,name:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired}).isRequired,allProfilesChecked:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,classes:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,handleAllProfilesCheck:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,handleProfileCheck:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,profilesChecked:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired};/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_2__material_ui_core_styles_withStyles___default()(styles)(CCEEData));

/***/ }),
/* 717 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export CNAEComponent */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_chart_js__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_chart_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_chart_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_Modal__ = __webpack_require__(134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_Modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_select__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_icons_Timeline__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_icons_Timeline___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__material_ui_icons_Timeline__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_styles_withStyles__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_styles_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_styles_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_select_lib_animated__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_select_lib_animated___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_react_select_lib_animated__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_EnergyCompany_BouncingLoader_BouncingLoader_jsx__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_components_CustomButtons_Button_jsx__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__material_ui_core_Checkbox__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__material_ui_core_Checkbox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__material_ui_core_Checkbox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_components_EnergyCompany_Cards_ECCard_jsx__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__material_ui_core_FormControlLabel__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__material_ui_core_FormControlLabel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__material_ui_core_FormControlLabel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_components_Grid_GridContainer_jsx__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_components_Grid_GridItem_jsx__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__SazoFlex__ = __webpack_require__(296);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__utils__ = __webpack_require__(137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_services_companies__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_services_utils__ = __webpack_require__(23);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var styles=function styles(theme){return{checkbox:{'& svg':{margin:0}},divider:{borderBottom:"1px solid black"},error:{color:'red'},modalPaper:{backgroundColor:theme.palette.background.paper,boxShadow:theme.shadows[5],height:"80%",margin:"auto",overflowY:"scroll",padding:theme.spacing.unit*4,paddingTop:0,width:"80%"},modalRoot:{display:"flex"},modalButton:{display:'flex',justifyContent:'flex-end',marginTop:'20px'}};};var CNAE=function(_Component){_inherits(CNAE,_Component);function CNAE(){var _ref;var _temp,_this,_ret;_classCallCheck(this,CNAE);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=CNAE.__proto__||Object.getPrototypeOf(CNAE)).call.apply(_ref,[this].concat(args))),_this),_this.state={curvaPerfisAgentesData:{},isModalOpened:false,empresas:[],empresasSelecionadas:[],isFetchEmpresasError:false,isFetchingEmpresas:false,isLoading:true,mostrarCurvaTotal:false},_this.fetchEmpresas=function(){var empresasSelecionadas=_this.state.empresasSelecionadas;_this.setState({isFetchEmpresasError:false,isFetchingEmpresas:true});var promises=Object(__WEBPACK_IMPORTED_MODULE_8_lodash__["map"])(empresasSelecionadas,function(empresa){var param={idsEmpresas:[empresa.id]};return Object(__WEBPACK_IMPORTED_MODULE_19_services_companies__["f" /* getCurvaPerfisAgentes */])(param);});Promise.all(promises).then(function(result){var empresasData=Object(__WEBPACK_IMPORTED_MODULE_8_lodash__["map"])(result,function(_ref2){var data=_ref2.data;return{nome:data.empresas[0].nome,data:data.curvaTotal};});_this.handleChart(empresasData);_this.setState({isModalOpened:false,isFetchingEmpresas:false});}).catch(function(){_this.setState({isFetchEmpresasError:true,isFetchingEmpresas:false});});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(CNAE,[{key:"componentDidMount",value:function componentDidMount(){var _this2=this;var param={cnaes:[this.props.cnae.id]};Object(__WEBPACK_IMPORTED_MODULE_19_services_companies__["f" /* getCurvaPerfisAgentes */])(param).then(function(_ref3){var data=_ref3.data;_this2.setState({curvaPerfisAgentesData:data,empresas:data.empresas,isLoading:false},function(){_this2.handleChart();});});}},{key:"componentDidUpdate",value:function componentDidUpdate(prevProps,prevState){var mostrarCurvaTotal=this.state.mostrarCurvaTotal;if(!Object(__WEBPACK_IMPORTED_MODULE_8_lodash__["isEqual"])(prevState.mostrarCurvaTotal,mostrarCurvaTotal)){this.handleChart();}}},{key:"getLabels",value:function getLabels(data){var labels=Object(__WEBPACK_IMPORTED_MODULE_8_lodash__["keys"])(data).map(function(key){return __WEBPACK_IMPORTED_MODULE_1_moment___default()(key).format("MMM Y");});return Object(__WEBPACK_IMPORTED_MODULE_18__utils__["a" /* fulfillWith */])(labels,"");}},{key:"handleChart",value:function handleChart(){var empresasData=arguments.length>0&&arguments[0]!==undefined?arguments[0]:[];var _state=this.state,curvaPerfisAgentesData=_state.curvaPerfisAgentesData,mostrarCurvaTotal=_state.mostrarCurvaTotal;var curvaMedia=curvaPerfisAgentesData.curvaMedia,curvaTotal=curvaPerfisAgentesData.curvaTotal;var ctx="chart-cnae";var data=mostrarCurvaTotal?curvaTotal:curvaMedia;var labels=this.getLabels(data);var chartData=Object(__WEBPACK_IMPORTED_MODULE_8_lodash__["map"])(Object(__WEBPACK_IMPORTED_MODULE_8_lodash__["values"])(data),'consumo');var empresasDatasets=[];if(this.chart){this.chart.destroy();}Object(__WEBPACK_IMPORTED_MODULE_8_lodash__["forEach"])(empresasData,function(empresaData){var randomColor="#"+Math.floor(Math.random()*16777215).toString(16);empresasDatasets.push({borderColor:randomColor,backgroundColor:randomColor,data:Object(__WEBPACK_IMPORTED_MODULE_8_lodash__["map"])(Object(__WEBPACK_IMPORTED_MODULE_8_lodash__["values"])(empresaData.data),'consumo'),fill:false,label:empresaData.nome,type:'line'});});this.chart=new __WEBPACK_IMPORTED_MODULE_0_chart_js___default.a(ctx,{type:'bar',data:{datasets:[{backgroundColor:'rgba(255, 99, 132, 0.4)',borderColor:'rgba(255,99,132,1)',borderWidth:1,data:chartData,label:'Consumo CNAE'}].concat(empresasDatasets),labels:labels},options:{scales:{yAxes:[{ticks:{beginAtZero:true,callback:function callback(value){return Object(__WEBPACK_IMPORTED_MODULE_20_services_utils__["f" /* localeString */])(Object(__WEBPACK_IMPORTED_MODULE_8_lodash__["round"])(value,2))+" MWh";}}}]},tooltips:{callbacks:{label:function label(tooltipItem){return Object(__WEBPACK_IMPORTED_MODULE_20_services_utils__["f" /* localeString */])(Object(__WEBPACK_IMPORTED_MODULE_8_lodash__["round"])(tooltipItem.yLabel,2))+" MWh";}},intersect:false,mode:'index'}}});}},{key:"getSazoFlexData",value:function getSazoFlexData(){var curvaPerfisAgentesData=this.state.curvaPerfisAgentesData;if(Object(__WEBPACK_IMPORTED_MODULE_8_lodash__["isEmpty"])(curvaPerfisAgentesData)){return curvaPerfisAgentesData;}var energiesValues={};Object(__WEBPACK_IMPORTED_MODULE_8_lodash__["forEach"])(curvaPerfisAgentesData.curvaMedia,function(data,month){energiesValues[month]={consumoMWMedPorPatamar:{leve:data.consumoPorPatamar.leve,medio:data.consumoPorPatamar.medio,pesado:data.consumoPorPatamar.pesado,total:data.consumoPorPatamar.total,recurso:data.compras+data.geracao}};});return[{energiesValues:energiesValues,submarket:'--'}];}},{key:"render",value:function render(){var _this3=this;var _state2=this.state,empresas=_state2.empresas,empresasSelecionadas=_state2.empresasSelecionadas,isFetchEmpresasError=_state2.isFetchEmpresasError,isFetchingEmpresas=_state2.isFetchingEmpresas,isModalOpened=_state2.isModalOpened,isLoading=_state2.isLoading,mostrarCurvaTotal=_state2.mostrarCurvaTotal;var classes=this.props.classes;var sazoFlexData=this.getSazoFlexData();return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("h3",{className:classes.divider,key:"0"},"Dados de empresas do ACL com mesma atividade"),isLoading?__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_EnergyCompany_BouncingLoader_BouncingLoader_jsx__["a" /* default */],null):__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_components_Grid_GridContainer_jsx__["a" /* default */],{key:"1"},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16_components_Grid_GridItem_jsx__["a" /* default */],{md:12,sm:12,xs:12},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_components_EnergyCompany_Cards_ECCard_jsx__["a" /* default */],{actions:__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__material_ui_core_FormControlLabel___default.a,{control:__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__material_ui_core_Checkbox___default.a,{checked:mostrarCurvaTotal,className:classes.checkbox,onChange:function onChange(e){return _this3.setState({mostrarCurvaTotal:!mostrarCurvaTotal});}}),label:"Mostrar curva total"}),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components_CustomButtons_Button_jsx__["a" /* default */],{color:"primary",onClick:function onClick(){return _this3.setState({isModalOpened:true});},round:true},"Abrir sele\xE7\xE3o de empresas")),content:__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("canvas",{id:"chart-cnae"})),icon:__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_icons_Timeline___default.a,null),title:"Curva de Consumo M\xE9dio do CNAE"}))),!Object(__WEBPACK_IMPORTED_MODULE_8_lodash__["isEmpty"])(sazoFlexData)&&__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__SazoFlex__["a" /* default */],{checkedAgentProfiles:sazoFlexData,key:"2",title:"Perfil de Contrata\xE7\xE3o M\xE9dia de Mercado"})),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Modal___default.a,{classes:{root:classes.modalRoot},onClose:function onClose(){return _this3.setState({isModalOpened:false});},open:isModalOpened},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("div",{className:classes.modalPaper},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("h2",null,"Selecionar empresas para compara\xE7\xE3o"),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_select__["a" /* default */],{components:__WEBPACK_IMPORTED_MODULE_9_react_select_lib_animated__,getOptionLabel:function getOptionLabel(option){return option.nome;},getOptionValue:function getOptionValue(option){return option.id;},isClearable:true,isDisabled:false,isMulti:true,noOptionsMessage:function noOptionsMessage(){return'Selecionar empresas para comparação';},onChange:function onChange(empresas){return _this3.setState({empresasSelecionadas:empresas});},options:Object(__WEBPACK_IMPORTED_MODULE_8_lodash__["sortBy"])(empresas,['nome']),placeholder:"Empresas",value:empresasSelecionadas}),isFetchEmpresasError&&__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("h4",{className:classes.error},"N\xE3o conseguimos buscar as empresas, por favor tente mais tarde."),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("div",{className:classes.modalButton},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components_CustomButtons_Button_jsx__["a" /* default */],{color:"rose",onClick:function onClick(){return _this3.setState({isModalOpened:false});}},"Fechar"),isFetchingEmpresas?__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_EnergyCompany_BouncingLoader_BouncingLoader_jsx__["a" /* default */],null):__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components_CustomButtons_Button_jsx__["a" /* default */],{color:"info",onClick:this.fetchEmpresas},"Buscar")))));}}]);return CNAE;}(__WEBPACK_IMPORTED_MODULE_3_react__["Component"]);;CNAE.propTypes={classes:__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object.isRequired,cnae:__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.shape({id:__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string.isRequired,nome:__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string.isRequired}).isRequired};/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_7__material_ui_core_styles_withStyles___default()(styles)(CNAE));

/***/ }),
/* 718 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ConsolidatedAccountingComponent */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles_withStyles__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_icons_Assignment__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_icons_Assignment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__material_ui_icons_Assignment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_EnergyCompany_Cards_ECCard_jsx__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_Grid_GridContainer_jsx__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_Grid_GridItem_jsx__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_icons_Info__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_icons_Info___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__material_ui_icons_Info__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_Table_Table_jsx__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__material_ui_core_Tooltip__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__material_ui_core_Tooltip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__material_ui_core_Tooltip__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_services_utils__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_assets_EnergyCompany_jss_lightTooltip__ = __webpack_require__(76);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var styles=function styles(theme){return Object.assign({},Object(__WEBPACK_IMPORTED_MODULE_13_assets_EnergyCompany_jss_lightTooltip__["a" /* default */])(theme));};var ConsolidatedAccounting=function(_Component){_inherits(ConsolidatedAccounting,_Component);function ConsolidatedAccounting(){var _ref;var _temp,_this,_ret;_classCallCheck(this,ConsolidatedAccounting);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=ConsolidatedAccounting.__proto__||Object.getPrototypeOf(ConsolidatedAccounting)).call.apply(_ref,[this].concat(args))),_this),_this.getData=function(){var consolidatedAccountingValues=_this.props.consolidatedAccountingValues;var deveMostrarMRE=_this.deveMostrarMRE();var total=0;var data=Object(__WEBPACK_IMPORTED_MODULE_4_lodash__["map"])(consolidatedAccountingValues,function(value,key){total+=value.resultadoFinal;return Object(__WEBPACK_IMPORTED_MODULE_4_lodash__["compact"])([__WEBPACK_IMPORTED_MODULE_0_moment___default()(key).format("MMM Y"),Object(__WEBPACK_IMPORTED_MODULE_12_services_utils__["g" /* numberToBRL */])(value.exposicaoMCP),deveMostrarMRE?Object(__WEBPACK_IMPORTED_MODULE_12_services_utils__["g" /* numberToBRL */])(value.compensacaoMRE):undefined,Object(__WEBPACK_IMPORTED_MODULE_12_services_utils__["g" /* numberToBRL */])(value.encargos),_this.getTooltip(value.efeitos,[{label:'Disponiblidade (ECD):',value:value.ecd},{label:'Quantidade (ECQA)',value:value.ecqa},{label:'Nuclear (ECCEN)',value:value.eccen},{label:'Cotas (ECCGF)',value:value.eccgf},{label:'Itaipu (EC_ITA)',value:value.ecita},{label:'Risco Hidrológico (ERRH)',value:value.errh},{label:'Descolamento PLD e PMO (E_DESC)',value:value.edesc}]),_this.getTooltip(value.ajustes,[{label:'Exposições Financeiras (TAJ_EF)',value:value.ajusteExposicaoFinanceira},{label:'Alívio Retroativo (TAJ_AR)',value:value.ajusteAlivioRetroativo},{label:'Recontabilizações (AJU_RECON)',value:value.ajusteRecontabilizacoes},{label:'MCSD Ex-Post (MCSD_XP)',value:value.ajusteMCSDExPost}]),Object(__WEBPACK_IMPORTED_MODULE_12_services_utils__["g" /* numberToBRL */])(value.excedenteER),Object(__WEBPACK_IMPORTED_MODULE_12_services_utils__["g" /* numberToBRL */])(value.resultadoFinal)]);});data.push({total:true,colspan:_this.getTableHead().length-2,amount:Object(__WEBPACK_IMPORTED_MODULE_12_services_utils__["g" /* numberToBRL */])(total)});return data;},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(ConsolidatedAccounting,[{key:"getHeaderTooltip",value:function getHeaderTooltip(header){var classes=this.props.classes;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core_Tooltip___default.a,{classes:{popper:classes.lightTooltipPopper,tooltip:classes.lightTooltip},placement:"top",title:"Passe o mouse sobre os valores para ver informa\xE7\xF5es detalhadas."},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span",{className:classes.tooltipContentWrapper},header," ",__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_icons_Info___default.a,null)));}},{key:"getTooltip",value:function getTooltip(value,data){var classes=this.props.classes;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core_Tooltip___default.a,{classes:{popper:classes.lightTooltipPopper,tooltip:classes.lightTooltip},placement:"left",title:Object(__WEBPACK_IMPORTED_MODULE_4_lodash__["map"])(data,function(datum,index){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{key:index},datum.label,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("b",null,Object(__WEBPACK_IMPORTED_MODULE_12_services_utils__["g" /* numberToBRL */])(datum.value)));})},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span",null,Object(__WEBPACK_IMPORTED_MODULE_12_services_utils__["g" /* numberToBRL */])(value)));}},{key:"getTableHead",value:function getTableHead(){return Object(__WEBPACK_IMPORTED_MODULE_4_lodash__["compact"])(["Mês","Exposição",this.deveMostrarMRE()?"MRE":undefined,"Encargos",this.getHeaderTooltip("Efeitos"),this.getHeaderTooltip("Ajustes"),"Exc. EER","Total"]);}},{key:"deveMostrarMRE",value:function deveMostrarMRE(){return Object(__WEBPACK_IMPORTED_MODULE_4_lodash__["some"])(this.props.consolidatedAccountingValues,function(value){return value.compensacaoMRE!==0;});}},{key:"render",value:function render(){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_Grid_GridContainer_jsx__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_Grid_GridItem_jsx__["a" /* default */],{xs:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_EnergyCompany_Cards_ECCard_jsx__["a" /* default */],{content:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_Table_Table_jsx__["a" /* default */],{coloredColls:[7],colorsColls:["primary"],tableData:this.getData(),tableHead:this.getTableHead(),tableHeaderColor:"primary"}),icon:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_icons_Assignment___default.a,null),title:"Contabiliza\xE7\xE3o"})));}}]);return ConsolidatedAccounting;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);;ConsolidatedAccounting.propTypes={classes:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired,consolidatedAccountingValues:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.objectOf(__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({ajusteAlivioRetroativo:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number.isRequired,ajusteExposicaoFinanceira:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number.isRequired,ajusteMCSDExPost:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number.isRequired,ajusteRecontabilizacoes:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number.isRequired,eccen:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number.isRequired,eccgf:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number.isRequired,ecd:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number.isRequired,ecita:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number.isRequired,ecqa:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number.isRequired,edesc:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number.isRequired,efeitos:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number.isRequired,encargos:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number.isRequired,errh:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number.isRequired,excedenteER:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number.isRequired,exposicaoMCP:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number.isRequired,resultadoFinal:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number.isRequired})).isRequired};/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles_withStyles___default()(styles)(ConsolidatedAccounting));

/***/ }),
/* 719 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_chart_js__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_chart_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_chart_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_icons_Timeline__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_icons_Timeline___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__material_ui_icons_Timeline__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils__ = __webpack_require__(137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_EnergyCompany_Cards_ECCard_jsx__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_Grid_GridContainer_jsx__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_Grid_GridItem_jsx__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__UsinaTooltip__ = __webpack_require__(297);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_services_utils__ = __webpack_require__(23);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ConsumptionChart=function(_Component){_inherits(ConsumptionChart,_Component);function ConsumptionChart(){_classCallCheck(this,ConsumptionChart);return _possibleConstructorReturn(this,(ConsumptionChart.__proto__||Object.getPrototypeOf(ConsumptionChart)).apply(this,arguments));}_createClass(ConsumptionChart,[{key:"componentDidMount",value:function componentDidMount(){this.handleChart();}},{key:"componentDidUpdate",value:function componentDidUpdate(){this.handleChart();}},{key:"getLabels",value:function getLabels(){var labels=Object(__WEBPACK_IMPORTED_MODULE_5_lodash__["keys"])(this.props.consolidatedEnergy).map(function(key){return __WEBPACK_IMPORTED_MODULE_1_moment___default()(key).format("MMM Y");});return Object(__WEBPACK_IMPORTED_MODULE_6__utils__["a" /* fulfillWith */])(labels,"");}},{key:"getData",value:function getData(key){var data=Object(__WEBPACK_IMPORTED_MODULE_5_lodash__["map"])(Object(__WEBPACK_IMPORTED_MODULE_5_lodash__["values"])(this.props.consolidatedEnergy),key);return Object(__WEBPACK_IMPORTED_MODULE_6__utils__["a" /* fulfillWith */])(data,undefined);}},{key:"handleChart",value:function handleChart(){var ctx="chart-recurso-requisito";var labels=this.getLabels();var recurso=this.getData("recurso");var requisito=this.getData("requisito");var recursoGarantiaFisica=this.getData("recursoConsiderandoGF");if(this.chart){this.chart.destroy();}this.chart=new __WEBPACK_IMPORTED_MODULE_0_chart_js___default.a(ctx,{type:'bar',data:{datasets:Object(__WEBPACK_IMPORTED_MODULE_5_lodash__["compact"])([{backgroundColor:'rgba(255, 99, 132, 0.4)',borderColor:'rgba(255,99,132,1)',data:requisito,fill:false,label:'Requisito (Venda + Consumo)',type:'line'},this.shouldShowGF()&&{backgroundColor:'rgba(168, 233, 241, 0.4)',borderColor:'rgba(0, 172, 193, 1)',data:recursoGarantiaFisica,fill:false,label:'Recurso (Compra + Garantia Física)',type:'line'},{backgroundColor:'rgba(54, 162, 235, 0.4)',borderColor:'rgba(54, 162, 235, 1)',borderWidth:1,data:recurso,label:'Recurso (Compra + Geração)'}]),labels:labels},options:{scales:{yAxes:[{ticks:{beginAtZero:true,callback:function callback(value){return Object(__WEBPACK_IMPORTED_MODULE_11_services_utils__["f" /* localeString */])(value)+" MWh";}}}]},tooltips:{callbacks:{label:function label(tooltipItem){return Object(__WEBPACK_IMPORTED_MODULE_11_services_utils__["f" /* localeString */])(tooltipItem.yLabel)+" MWh";}},intersect:false,mode:'index'}}});}},{key:"shouldShowGF",value:function shouldShowGF(){return Object(__WEBPACK_IMPORTED_MODULE_5_lodash__["sumBy"])(Object(__WEBPACK_IMPORTED_MODULE_5_lodash__["values"])(this.props.consolidatedEnergy),'garantiaFisica')>0;}},{key:"render",value:function render(){return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_Grid_GridContainer_jsx__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_Grid_GridItem_jsx__["a" /* default */],{md:12,sm:12,xs:12},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_EnergyCompany_Cards_ECCard_jsx__["a" /* default */],{content:__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("canvas",{id:"chart-recurso-requisito"}),icon:__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_icons_Timeline___default.a,null),title:__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__UsinaTooltip__["a" /* default */],{shouldShow:this.shouldShowGF(),title:"Balan\xE7o Energ\xE9tico"})})));}}]);return ConsumptionChart;}(__WEBPACK_IMPORTED_MODULE_2_react__["Component"]);;ConsumptionChart.propTypes={consolidatedEnergy:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.objectOf(__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.shape({garantiaFisica:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number.isRequired,lastro:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number.isRequired,recurso:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number.isRequired,recursoConsiderandoGF:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number.isRequired,requisito:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number.isRequired,saldo:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number.isRequired})).isRequired};/* harmony default export */ __webpack_exports__["a"] = (ConsumptionChart);

/***/ }),
/* 720 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export CorporateStructureComponent */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_classnames__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_icons_Assignment__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_icons_Assignment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__material_ui_icons_Assignment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_EnergyCompany_Cards_ECCard_jsx__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_icons_ExpandLess__ = __webpack_require__(721);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_icons_ExpandLess___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__material_ui_icons_ExpandLess__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_icons_ExpandMore__ = __webpack_require__(295);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_icons_ExpandMore___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__material_ui_icons_ExpandMore__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_Grid_GridContainer_jsx__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_EnergyCompany_Grid_InfoGrid_jsx__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_EnergyCompany_Grid_InfoGridItem_jsx__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_components_Grid_GridItem_jsx__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__material_ui_core_styles_withStyles__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__material_ui_core_styles_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__material_ui_core_styles_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_services_utils__ = __webpack_require__(23);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var styles={moreInfoWrapper:{display:"flex",flexDirection:"column",gridColumnStart:1,height:0,opacity:0,overflow:"hidden",paddingLeft:"10px",transition:"opacity 1s ease-out","& a":{cursor:"pointer"}},moreInfoWrapperOpened:{height:"auto",opacity:1},socioName:{cursor:"pointer"}};var CorporateStructure=function(_Component){_inherits(CorporateStructure,_Component);function CorporateStructure(){var _ref;var _temp,_this,_ret;_classCallCheck(this,CorporateStructure);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=CorporateStructure.__proto__||Object.getPrototypeOf(CorporateStructure)).call.apply(_ref,[this].concat(args))),_this),_this.state={opened:{}},_this.expand=function(index){var opened=_this.state.opened;_this.setState({opened:Object.assign({},opened,_defineProperty({},index,!opened[index]))});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(CorporateStructure,[{key:"render",value:function render(){var _this2=this;var _props=this.props,classes=_props.classes,companyResponsibles=_props.companyResponsibles,selectEmpresa=_props.selectEmpresa;var opened=this.state.opened;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_Grid_GridContainer_jsx__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components_Grid_GridItem_jsx__["a" /* default */],{xs:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_EnergyCompany_Cards_ECCard_jsx__["a" /* default */],{content:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_EnergyCompany_Grid_InfoGrid_jsx__["a" /* default */],null,Object(__WEBPACK_IMPORTED_MODULE_3_lodash__["sortBy"])(companyResponsibles,["role"]).map(function(socio,index){var _cx;return[__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_EnergyCompany_Grid_InfoGridItem_jsx__["a" /* default */],{actions:!!opened[index]?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_icons_ExpandLess___default.a,{onClick:function onClick(){return _this2.expand(index);}}):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_icons_ExpandMore___default.a,{onClick:function onClick(){return _this2.expand(index);}}),key:"1",label:(socio.role||"").split("-")[1],modifiers:["forceNewRowModifier"],value:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span",{className:classes.socioName,onClick:function onClick(){return _this2.expand(index);}},Object(__WEBPACK_IMPORTED_MODULE_13_services_utils__["d" /* capitalizeString */])(socio.name))}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:__WEBPACK_IMPORTED_MODULE_0_classnames___default()((_cx={},_defineProperty(_cx,classes.moreInfoWrapper,true),_defineProperty(_cx,classes.moreInfoWrapperOpened,!!opened[index]),_cx)),id:"CorporateStructure__outras-empresas",key:"2"},socio.outrasEmpresas?[Object(__WEBPACK_IMPORTED_MODULE_3_lodash__["map"])(socio.outrasEmpresas,function(outraEmpresa,index){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("a",{key:index,onClick:function onClick(){return selectEmpresa(outraEmpresa);}},outraEmpresa.nome);}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("small",{key:"info"},"1 O nome do s\xF3cio consta em outras empresas, necess\xE1rio confirma\xE7\xE3o via CPF.")]:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span",null,"N\xE3o foram encontradas outras empresas em que este nome faz parte do quadro societ\xE1rio."))];})),icon:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_icons_Assignment___default.a,null),title:"Quadro Societ\xE1rio"})));}}]);return CorporateStructure;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);;CorporateStructure.propTypes={classes:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired,companyResponsibles:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({name:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired,role:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired})).isRequired,selectEmpresa:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired};/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_12__material_ui_core_styles_withStyles___default()(styles)(CorporateStructure));

/***/ }),
/* 721 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(9);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(10));

var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
  d: "M12 8l-6 6 1.41 1.41L12 10.83l4.59 4.58L18 14z"
}), _react.default.createElement("path", {
  fill: "none",
  d: "M0 0h24v24H0z"
})), 'ExpandLess');

exports.default = _default;

/***/ }),
/* 722 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export DREComponent */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles_withStyles__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_icons_Assignment__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_icons_Assignment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__material_ui_icons_Assignment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_EnergyCompany_Cards_ECCard_jsx__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_Grid_GridContainer_jsx__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_Grid_GridItem_jsx__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_Table_Table_jsx__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_services_utils__ = __webpack_require__(23);
var styles={firstCell:{whiteSpace:"pre-wrap"}};var DRE=function DRE(_ref){var classes=_ref.classes,dre=_ref.dre;var getPadStart=function getPadStart(str){var countDots=Object(__WEBPACK_IMPORTED_MODULE_4_lodash__["filter"])(str,function(char){return char===".";}).length;return!countDots?str:Object(__WEBPACK_IMPORTED_MODULE_4_lodash__["padStart"])(str,str.length+countDots*3);};var getData=function getData(){var itens=Object(__WEBPACK_IMPORTED_MODULE_4_lodash__["last"])(dre).itens;var penultimateYearItens=penultimateYear();return Object(__WEBPACK_IMPORTED_MODULE_4_lodash__["compact"])(Object(__WEBPACK_IMPORTED_MODULE_4_lodash__["map"])(itens,function(item,index){return[getPadStart(item.codigo),item.descricao,Object(__WEBPACK_IMPORTED_MODULE_10_services_utils__["g" /* numberToBRL */])(item.valor),penultimateYearItens&&Object(__WEBPACK_IMPORTED_MODULE_10_services_utils__["g" /* numberToBRL */])(penultimateYearItens.itens[index].valor)];}));};var getTableHeaders=function getTableHeaders(){var _last=Object(__WEBPACK_IMPORTED_MODULE_4_lodash__["last"])(dre),dataInicio=_last.dataInicio;var lastYearLabel=__WEBPACK_IMPORTED_MODULE_0_moment___default()(dataInicio).format('YYYY');var penultimateYearItens=penultimateYear();var penultimateYearLabel=penultimateYearItens&&"Ano Anterior ("+__WEBPACK_IMPORTED_MODULE_0_moment___default()(penultimateYearItens.dataInicio).format('YYYY')+")";return Object(__WEBPACK_IMPORTED_MODULE_4_lodash__["compact"])(["Código","Descrição",lastYearLabel,penultimateYearLabel]);};var penultimateYear=function penultimateYear(){return dre.length>1&&dre[dre.length-2];};return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_Grid_GridContainer_jsx__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_Grid_GridItem_jsx__["a" /* default */],{md:12,sm:12,xs:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_EnergyCompany_Cards_ECCard_jsx__["a" /* default */],{content:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_Table_Table_jsx__["a" /* default */],{customCellClasses:[classes.firstCell],customClassesForCells:[0],tableData:getData(),tableHead:getTableHeaders(),tableHeaderColor:"primary"}),icon:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_icons_Assignment___default.a,null),title:"DRE"})));};DRE.propTypes={classes:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired,dre:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({dataInicio:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired,dataFim:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired,itens:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({codigo:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired,descricao:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired,valor:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number.isRequired}))})).isRequired};/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles_withStyles___default()(styles)(DRE));

/***/ }),
/* 723 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_icons_Assignment__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_icons_Assignment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__material_ui_icons_Assignment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_EnergyCompany_Cards_ECCard_jsx__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_Grid_GridContainer_jsx__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_EnergyCompany_Grid_InfoGrid_jsx__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_EnergyCompany_Grid_InfoGridItem_jsx__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_Grid_GridItem_jsx__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_services_utils__ = __webpack_require__(23);
var Informations=function Informations(_ref){var empresa=_ref.empresa;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_Grid_GridContainer_jsx__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_Grid_GridItem_jsx__["a" /* default */],{xs:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_EnergyCompany_Cards_ECCard_jsx__["a" /* default */],{content:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_EnergyCompany_Grid_InfoGrid_jsx__["a" /* default */],null,empresa.commercialName?[__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_EnergyCompany_Grid_InfoGridItem_jsx__["a" /* default */],{key:"1",label:"Raz\xE3o Social",value:empresa.name}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_EnergyCompany_Grid_InfoGridItem_jsx__["a" /* default */],{key:"2",label:"Nome Fantasia",value:empresa.commercialName})]:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_EnergyCompany_Grid_InfoGridItem_jsx__["a" /* default */],{label:"Raz\xE3o Social",modifiers:["forceNewFullRowModifier"],value:empresa.name}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_EnergyCompany_Grid_InfoGridItem_jsx__["a" /* default */],{label:"Atividade Principal",modifiers:["forceNewFullRowModifier"],value:Object(__WEBPACK_IMPORTED_MODULE_10_services_utils__["d" /* capitalizeString */])(Object(__WEBPACK_IMPORTED_MODULE_3_lodash__["get"])(empresa,"cnae.nome",""))}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_EnergyCompany_Grid_InfoGridItem_jsx__["a" /* default */],{label:"CNPJ",modifiers:["forceNewRowModifier"],value:Object(__WEBPACK_IMPORTED_MODULE_10_services_utils__["a" /* CNPJMask */])(empresa.cnpj)}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_EnergyCompany_Grid_InfoGridItem_jsx__["a" /* default */],{label:"Tipo",value:Object(__WEBPACK_IMPORTED_MODULE_10_services_utils__["d" /* capitalizeString */])(empresa.hierarchicalType)}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_EnergyCompany_Grid_InfoGridItem_jsx__["a" /* default */],{label:"Logradouro",modifiers:["forceNewRowModifier"],value:Object(__WEBPACK_IMPORTED_MODULE_10_services_utils__["d" /* capitalizeString */])(Object(__WEBPACK_IMPORTED_MODULE_3_lodash__["get"])(empresa,"address.street",""))}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_EnergyCompany_Grid_InfoGridItem_jsx__["a" /* default */],{label:"N\xFAmero",value:Object(__WEBPACK_IMPORTED_MODULE_3_lodash__["get"])(empresa,"address.number","")}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_EnergyCompany_Grid_InfoGridItem_jsx__["a" /* default */],{label:"CNAE",modifiers:["forceNewRowModifier"],value:Object(__WEBPACK_IMPORTED_MODULE_3_lodash__["get"])(empresa,"cnae.id","")}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_EnergyCompany_Grid_InfoGridItem_jsx__["a" /* default */],{label:"Bairro",value:Object(__WEBPACK_IMPORTED_MODULE_10_services_utils__["d" /* capitalizeString */])(Object(__WEBPACK_IMPORTED_MODULE_3_lodash__["get"])(empresa,"address.neighborhood",""))}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_EnergyCompany_Grid_InfoGridItem_jsx__["a" /* default */],{label:"Data de Abertura",modifiers:["forceNewRowModifier"],value:__WEBPACK_IMPORTED_MODULE_0_moment___default()(empresa.openDate).format("DD/MM/YYYY")}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_EnergyCompany_Grid_InfoGridItem_jsx__["a" /* default */],{label:"CEP",value:Object(__WEBPACK_IMPORTED_MODULE_10_services_utils__["k" /* zipCodeMask */])(Object(__WEBPACK_IMPORTED_MODULE_3_lodash__["get"])(empresa,"address.zipCode",""))}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_EnergyCompany_Grid_InfoGridItem_jsx__["a" /* default */],{label:"Telefone",modifiers:["forceNewRowModifier"],value:empresa.phoneNumber}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_EnergyCompany_Grid_InfoGridItem_jsx__["a" /* default */],{label:"Cidade",value:Object(__WEBPACK_IMPORTED_MODULE_10_services_utils__["d" /* capitalizeString */])(Object(__WEBPACK_IMPORTED_MODULE_3_lodash__["get"])(empresa,"address.city",""))}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_EnergyCompany_Grid_InfoGridItem_jsx__["a" /* default */],{label:"Email",modifiers:["forceNewRowModifier"],value:empresa.contactEmail}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_EnergyCompany_Grid_InfoGridItem_jsx__["a" /* default */],{label:"Estado",value:Object(__WEBPACK_IMPORTED_MODULE_10_services_utils__["d" /* capitalizeString */])(Object(__WEBPACK_IMPORTED_MODULE_3_lodash__["get"])(empresa,"address.state.name",""))}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_EnergyCompany_Grid_InfoGridItem_jsx__["a" /* default */],{label:"Capital Social",modifiers:["forceNewRowModifier"],value:Object(__WEBPACK_IMPORTED_MODULE_10_services_utils__["g" /* numberToBRL */])(empresa.shareCapital)}),!!empresa.notaRisco&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_EnergyCompany_Grid_InfoGridItem_jsx__["a" /* default */],{label:"\xCDndice Alavancagem",value:Object(__WEBPACK_IMPORTED_MODULE_3_lodash__["get"])(empresa,"notaRisco","")}),!empresa.agents.length&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_EnergyCompany_Grid_InfoGridItem_jsx__["a" /* default */],{label:"Observa\xE7\xE3o",modifiers:["forceNewFullRowModifier"],value:"Este consumidor \xE9 cativo e n\xE3o se encontra na base da CCEE."})),icon:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_icons_Assignment___default.a,null),title:"Informa\xE7\xF5es"})));};Informations.propTypes={empresa:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({address:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({city:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,neighborhood:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,number:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,state:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({name:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string}),street:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,zipCode:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string}),cnae:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({id:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,nome:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string}).isRequired,contactEmail:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,hierarchicalType:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,mainActivity:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,name:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired,openDate:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired,phoneNumber:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,shareCapital:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number}).isRequired};/* harmony default export */ __webpack_exports__["a"] = (Informations);

/***/ }),
/* 724 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(2);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(6));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(7));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(4));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _classnames = _interopRequireDefault(__webpack_require__(5));

var _warning = _interopRequireDefault(__webpack_require__(16));

var _withStyles = _interopRequireDefault(__webpack_require__(3));

var _colorManipulator = __webpack_require__(70);

var TRANSITION_DURATION = 4; // seconds

var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      position: 'relative',
      overflow: 'hidden',
      height: 5
    },

    /* Styles applied to the root & bar2 element if `color="primary"`; bar2 if `variant-"buffer"`. */
    colorPrimary: {
      backgroundColor: (0, _colorManipulator.lighten)(theme.palette.primary.light, 0.6)
    },

    /* Styles applied to the root & bar2 elements if `color="secondary"`; bar2 if variant="buffer". */
    colorSecondary: {
      backgroundColor: (0, _colorManipulator.lighten)(theme.palette.secondary.light, 0.4)
    },

    /* Styles applied to the root element if `variant="buffer"`. */
    buffer: {
      backgroundColor: 'transparent'
    },

    /* Styles applied to the root element if `variant="query"`. */
    query: {
      transform: 'rotate(180deg)'
    },

    /* Styles applied to the additional bar element if `variant="buffer"`. */
    dashed: {
      position: 'absolute',
      marginTop: 0,
      height: '100%',
      width: '100%',
      animation: 'buffer 3s infinite linear'
    },

    /* Styles applied to the additional bar element if `variant="buffer"` & `color="primary"`. */
    dashedColorPrimary: {
      backgroundImage: "radial-gradient(".concat((0, _colorManipulator.lighten)(theme.palette.primary.light, 0.6), " 0%, ").concat((0, _colorManipulator.lighten)(theme.palette.primary.light, 0.6), " 16%, transparent 42%)"),
      backgroundSize: '10px 10px',
      backgroundPosition: '0px -23px'
    },

    /* Styles applied to the additional bar element if `variant="buffer"` & `color="secondary"`. */
    dashedColorSecondary: {
      backgroundImage: "radial-gradient(".concat((0, _colorManipulator.lighten)(theme.palette.secondary.light, 0.4), " 0%, ").concat((0, _colorManipulator.lighten)(theme.palette.secondary.light, 0.6), " 16%, transparent 42%)"),
      backgroundSize: '10px 10px',
      backgroundPosition: '0px -23px'
    },

    /* Styles applied to the layered bar1 & bar2 elements. */
    bar: {
      width: '100%',
      position: 'absolute',
      left: 0,
      bottom: 0,
      top: 0,
      transition: 'transform 0.2s linear',
      transformOrigin: 'left'
    },

    /* Styles applied to the bar elements if `color="primary"`; bar2 if `variant` not "buffer". */
    barColorPrimary: {
      backgroundColor: theme.palette.primary.main
    },

    /* Styles applied to the bar elements if `color="secondary"`; bar2 if `variant` not "buffer". */
    barColorSecondary: {
      backgroundColor: theme.palette.secondary.main
    },

    /* Styles applied to the bar1 element if `variant="indeterminate or query"`. */
    bar1Indeterminate: {
      width: 'auto',
      willChange: 'left, right',
      animation: 'mui-indeterminate1 2.1s cubic-bezier(0.65, 0.815, 0.735, 0.395) infinite'
    },

    /* Styles applied to the bar1 element if `variant="determinate"`. */
    bar1Determinate: {
      willChange: 'transform',
      transition: "transform .".concat(TRANSITION_DURATION, "s linear")
    },

    /* Styles applied to the bar1 element if `variant="buffer"`. */
    bar1Buffer: {
      zIndex: 1,
      transition: "transform .".concat(TRANSITION_DURATION, "s linear")
    },

    /* Styles applied to the bar2 element if `variant="indeterminate or query"`. */
    bar2Indeterminate: {
      width: 'auto',
      willChange: 'left, right',
      animation: 'mui-indeterminate2 2.1s cubic-bezier(0.165, 0.84, 0.44, 1) infinite',
      animationDelay: '1.15s'
    },

    /* Styles applied to the bar2 element if `variant="determinate"`. */
    bar2Determinate: {},

    /* Styles applied to the bar2 element if `variant="buffer"`. */
    bar2Buffer: {
      transition: "transform .".concat(TRANSITION_DURATION, "s linear")
    },
    // Legends:
    // || represents the viewport
    // -  represents a light background
    // x  represents a dark background
    '@keyframes mui-indeterminate1': {
      //  |-----|---x-||-----||-----|
      '0%': {
        left: '-35%',
        right: '100%'
      },
      //  |-----|-----||-----||xxxx-|
      '60%': {
        left: '100%',
        right: '-90%'
      },
      '100%': {
        left: '100%',
        right: '-90%'
      }
    },
    '@keyframes mui-indeterminate2': {
      //  |xxxxx|xxxxx||-----||-----|
      '0%': {
        left: '-200%',
        right: '100%'
      },
      //  |-----|-----||-----||-x----|
      '60%': {
        left: '107%',
        right: '-8%'
      },
      '100%': {
        left: '107%',
        right: '-8%'
      }
    },
    '@keyframes buffer': {
      '0%': {
        opacity: 1,
        backgroundPosition: '0px -23px'
      },
      '50%': {
        opacity: 0,
        backgroundPosition: '0px -23px'
      },
      '100%': {
        opacity: 1,
        backgroundPosition: '-200px -23px'
      }
    }
  };
};
/**
 * ## ARIA
 *
 * If the progress bar is describing the loading progress of a particular region of a page,
 * you should use `aria-describedby` to point to the progress bar, and set the `aria-busy`
 * attribute to `true` on that region until it has finished loading.
 */


exports.styles = styles;

function LinearProgress(props) {
  var _classNames, _classNames2, _classNames3, _classNames4;

  var classes = props.classes,
      classNameProp = props.className,
      color = props.color,
      value = props.value,
      valueBuffer = props.valueBuffer,
      variant = props.variant,
      other = (0, _objectWithoutProperties2.default)(props, ["classes", "className", "color", "value", "valueBuffer", "variant"]);
  var className = (0, _classnames.default)(classes.root, (_classNames = {}, (0, _defineProperty2.default)(_classNames, classes.colorPrimary, color === 'primary'), (0, _defineProperty2.default)(_classNames, classes.colorSecondary, color === 'secondary'), (0, _defineProperty2.default)(_classNames, classes.buffer, variant === 'buffer'), (0, _defineProperty2.default)(_classNames, classes.query, variant === 'query'), _classNames), classNameProp);
  var dashedClass = (0, _classnames.default)(classes.dashed, (_classNames2 = {}, (0, _defineProperty2.default)(_classNames2, classes.dashedColorPrimary, color === 'primary'), (0, _defineProperty2.default)(_classNames2, classes.dashedColorSecondary, color === 'secondary'), _classNames2));
  var bar1ClassName = (0, _classnames.default)(classes.bar, (_classNames3 = {}, (0, _defineProperty2.default)(_classNames3, classes.barColorPrimary, color === 'primary'), (0, _defineProperty2.default)(_classNames3, classes.barColorSecondary, color === 'secondary'), (0, _defineProperty2.default)(_classNames3, classes.bar1Indeterminate, variant === 'indeterminate' || variant === 'query'), (0, _defineProperty2.default)(_classNames3, classes.bar1Determinate, variant === 'determinate'), (0, _defineProperty2.default)(_classNames3, classes.bar1Buffer, variant === 'buffer'), _classNames3));
  var bar2ClassName = (0, _classnames.default)(classes.bar, (_classNames4 = {}, (0, _defineProperty2.default)(_classNames4, classes.barColorPrimary, color === 'primary' && variant !== 'buffer'), (0, _defineProperty2.default)(_classNames4, classes.colorPrimary, color === 'primary' && variant === 'buffer'), (0, _defineProperty2.default)(_classNames4, classes.barColorSecondary, color === 'secondary' && variant !== 'buffer'), (0, _defineProperty2.default)(_classNames4, classes.colorSecondary, color === 'secondary' && variant === 'buffer'), (0, _defineProperty2.default)(_classNames4, classes.bar2Indeterminate, variant === 'indeterminate' || variant === 'query'), (0, _defineProperty2.default)(_classNames4, classes.bar2Determinate, variant === 'determinate'), (0, _defineProperty2.default)(_classNames4, classes.bar2Buffer, variant === 'buffer'), _classNames4));
  var rootProps = {};
  var inlineStyles = {
    bar1: {},
    bar2: {}
  };

  if (variant === 'determinate' || variant === 'buffer') {
    if (value !== undefined) {
      rootProps['aria-valuenow'] = Math.round(value);
      inlineStyles.bar1.transform = "scaleX(".concat(value / 100, ")");
    } else {
       false ? (0, _warning.default)(false, 'Material-UI: you need to provide a value property ' + 'when using the determinate or buffer variant of LinearProgress .') : void 0;
    }
  }

  if (variant === 'buffer') {
    if (valueBuffer !== undefined) {
      inlineStyles.bar2.transform = "scaleX(".concat((valueBuffer || 0) / 100, ")");
    } else {
       false ? (0, _warning.default)(false, 'Material-UI: you need to provide a valueBuffer property ' + 'when using the buffer variant of LinearProgress.') : void 0;
    }
  }

  return _react.default.createElement("div", (0, _extends2.default)({
    className: className,
    role: "progressbar"
  }, rootProps, other), variant === 'buffer' ? _react.default.createElement("div", {
    className: dashedClass
  }) : null, _react.default.createElement("div", {
    className: bar1ClassName,
    style: inlineStyles.bar1
  }), variant === 'determinate' ? null : _react.default.createElement("div", {
    className: bar2ClassName,
    style: inlineStyles.bar2
  }));
}

LinearProgress.propTypes =  false ? {
  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * The color of the component. It supports those theme colors that make sense for this component.
   */
  color: _propTypes.default.oneOf(['primary', 'secondary']),

  /**
   * The value of the progress indicator for the determinate and buffer variants.
   * Value between 0 and 100.
   */
  value: _propTypes.default.number,

  /**
   * The value for the buffer variant.
   * Value between 0 and 100.
   */
  valueBuffer: _propTypes.default.number,

  /**
   * The variant to use.
   * Use indeterminate or query when there is no progress value.
   */
  variant: _propTypes.default.oneOf(['determinate', 'indeterminate', 'buffer', 'query'])
} : {};
LinearProgress.defaultProps = {
  color: 'primary',
  variant: 'indeterminate'
};

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiLinearProgress'
})(LinearProgress);

exports.default = _default;

/***/ }),
/* 725 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_chart_js__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_chart_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_chart_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_icons_Timeline__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_icons_Timeline___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__material_ui_icons_Timeline__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_styles_withStyles__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_styles_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_styles_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_EnergyCompany_Cards_ECCard_jsx__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_Grid_GridContainer_jsx__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_Grid_GridItem_jsx__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_EnergyCompany_Grid_InfoGridItem_jsx__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__UsinaTooltip__ = __webpack_require__(297);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_services_utils__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__utils__ = __webpack_require__(137);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var styles={lastroWrapper:{alignItems:"flex-end",display:"flex",flexDirection:"column",marginRight:"25px",marginTop:"25px"}};var MediaMovel=function(_Component){_inherits(MediaMovel,_Component);function MediaMovel(){var _ref;var _temp,_this,_ret;_classCallCheck(this,MediaMovel);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=MediaMovel.__proto__||Object.getPrototypeOf(MediaMovel)).call.apply(_ref,[this].concat(args))),_this),_this.state={saldoMCP:0},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(MediaMovel,[{key:"componentDidMount",value:function componentDidMount(){this.handleChart();}},{key:"componentDidUpdate",value:function componentDidUpdate(prevProps){if(!Object(__WEBPACK_IMPORTED_MODULE_6_lodash__["isEqual"])(prevProps.consolidatedEnergy,this.props.consolidatedEnergy)||!Object(__WEBPACK_IMPORTED_MODULE_6_lodash__["isEqual"])(prevProps.checkedProfiles,this.props.checkedProfiles)){this.handleChart();}}},{key:"getMediaMovelAndCalculateLastro",value:function getMediaMovelAndCalculateLastro(){var mediaMovelData=[];var saldoMCP=0;Object(__WEBPACK_IMPORTED_MODULE_6_lodash__["forEach"])(Object(__WEBPACK_IMPORTED_MODULE_6_lodash__["values"])(this.props.consolidatedEnergy),function(_ref2){var saldo=_ref2.saldo;mediaMovelData.push(saldo);saldoMCP+=saldo;});this.setState({saldoMCP:saldoMCP});return Object(__WEBPACK_IMPORTED_MODULE_13__utils__["a" /* fulfillWith */])(mediaMovelData,undefined);}},{key:"getLabels",value:function getLabels(){var labels=Object(__WEBPACK_IMPORTED_MODULE_6_lodash__["keys"])(this.props.consolidatedEnergy).map(function(key){return __WEBPACK_IMPORTED_MODULE_1_moment___default()(key).format("MMM Y");});return Object(__WEBPACK_IMPORTED_MODULE_13__utils__["a" /* fulfillWith */])(labels,"");}},{key:"getLastroEstimadoData",value:function getLastroEstimadoData(){var data=Object(__WEBPACK_IMPORTED_MODULE_6_lodash__["map"])(Object(__WEBPACK_IMPORTED_MODULE_6_lodash__["values"])(this.props.consolidatedEnergy),'lastro');return Object(__WEBPACK_IMPORTED_MODULE_13__utils__["a" /* fulfillWith */])(data,undefined);}},{key:"handleChart",value:function handleChart(){var _props=this.props,checkedProfiles=_props.checkedProfiles,pld=_props.pld;var selectedSubmarkets=Object(__WEBPACK_IMPORTED_MODULE_6_lodash__["uniq"])(Object(__WEBPACK_IMPORTED_MODULE_6_lodash__["map"])(checkedProfiles,'submarket'));var ctx="chart-media-movel";var labels=this.getLabels();var mediaMovelData=this.getMediaMovelAndCalculateLastro();var lastroEstimadoData=this.getLastroEstimadoData();if(this.chart)this.chart.destroy();this.chart=new __WEBPACK_IMPORTED_MODULE_0_chart_js___default.a(ctx,{type:'bar',data:{datasets:Object(__WEBPACK_IMPORTED_MODULE_6_lodash__["compact"])([].concat(_toConsumableArray(Object(__WEBPACK_IMPORTED_MODULE_6_lodash__["map"])(selectedSubmarkets,function(value,index){var color=__WEBPACK_IMPORTED_MODULE_12_services_utils__["b" /* COLORS */][index];return{backgroundColor:color,borderColor:color,data:Object(__WEBPACK_IMPORTED_MODULE_6_lodash__["values"])(pld[value]),fill:false,label:"PLD "+value,type:'line',yAxisID:'pld'};})),[this.temUsina()&&{backgroundColor:'rgba(168, 233, 241, 0.4)',borderColor:'rgba(0, 172, 193, 1)',borderWidth:1,data:lastroEstimadoData,label:'Lastro Estimado',yAxisID:'media'},{backgroundColor:'rgba(54, 162, 235, 0.4)',borderColor:'rgba(54, 162, 235, 1)',borderWidth:1,data:mediaMovelData,label:'Saldo MCP',yAxisID:'media'}])),labels:labels},options:{scales:{yAxes:[].concat(_toConsumableArray(Object(__WEBPACK_IMPORTED_MODULE_6_lodash__["map"])(selectedSubmarkets,function(){return{gridLines:{display:false},id:"pld",position:"right",ticks:{beginAtZero:true,callback:function callback(value){return Object(__WEBPACK_IMPORTED_MODULE_12_services_utils__["g" /* numberToBRL */])(value)+"/MWh";}}};})),[{id:"media",position:"left",ticks:{beginAtZero:true,callback:function callback(value){return Object(__WEBPACK_IMPORTED_MODULE_12_services_utils__["f" /* localeString */])(value)+" MWh";}}}])},tooltips:{callbacks:{label:function label(tooltipItem,data){if(tooltipItem.datasetIndex+1<data.datasets.length){return Object(__WEBPACK_IMPORTED_MODULE_12_services_utils__["g" /* numberToBRL */])(tooltipItem.yLabel)+"/MWh";}else{return Object(__WEBPACK_IMPORTED_MODULE_12_services_utils__["f" /* localeString */])(tooltipItem.yLabel)+" MWh";}}},intersect:false,mode:'index'}}});}},{key:"temUsina",value:function temUsina(){return Object(__WEBPACK_IMPORTED_MODULE_6_lodash__["sumBy"])(Object(__WEBPACK_IMPORTED_MODULE_6_lodash__["values"])(this.props.consolidatedEnergy),'garantiaFisica')>0;}},{key:"render",value:function render(){var _props2=this.props,agentProfile=_props2.agentProfile,classes=_props2.classes;var saldoMCP=this.state.saldoMCP;return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_Grid_GridContainer_jsx__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_Grid_GridItem_jsx__["a" /* default */],{md:12,sm:12,xs:12},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_EnergyCompany_Cards_ECCard_jsx__["a" /* default */],{content:__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("canvas",{id:"chart-media-movel"}),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("div",{className:classes.lastroWrapper},this.temUsina()&&__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_EnergyCompany_Grid_InfoGridItem_jsx__["a" /* default */],{label:"Saldo MCP",value:Object(__WEBPACK_IMPORTED_MODULE_12_services_utils__["f" /* localeString */])(saldoMCP)+" MWh"}),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_EnergyCompany_Grid_InfoGridItem_jsx__["a" /* default */],{label:"Lastro",value:Object(__WEBPACK_IMPORTED_MODULE_12_services_utils__["f" /* localeString */])(agentProfile.lastro12Meses)+" MWh"}))),icon:__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_icons_Timeline___default.a,null),title:__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__UsinaTooltip__["a" /* default */],{shouldShow:this.temUsina(),title:"Lastro M\xE9dia M\xF3vel"})})));}}]);return MediaMovel;}(__WEBPACK_IMPORTED_MODULE_2_react__["Component"]);;MediaMovel.propTypes={agentProfile:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.array.isRequired,checkedProfiles:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.shape({submarket:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string.isRequired})).isRequired,classes:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,consolidatedEnergy:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.objectOf(__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.shape({garantiaFisica:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number.isRequired,lastro:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number.isRequired,saldo:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number.isRequired})).isRequired,pld:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.shape({N:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,NE:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,S:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,"SE/CO":__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired})};/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_5__material_ui_core_styles_withStyles___default()(styles)(MediaMovel));

/***/ }),
/* 726 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export DREComponent */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_styles_withStyles__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_styles_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_styles_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_icons_Map__ = __webpack_require__(727);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_icons_Map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__material_ui_icons_Map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_EnergyCompany_Cards_ECCard_jsx__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_Grid_GridContainer_jsx__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_Grid_GridItem_jsx__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_google_maps__ = __webpack_require__(728);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_google_maps___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react_google_maps__);
// const styles = {
//   firstCell: {
//     whiteSpace: "pre-wrap",
//   },
// };
var RegularMap=Object(__WEBPACK_IMPORTED_MODULE_7_react_google_maps__["withScriptjs"])(Object(__WEBPACK_IMPORTED_MODULE_7_react_google_maps__["withGoogleMap"])(function(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_google_maps__["GoogleMap"],{defaultCenter:{lat:props.lat,lng:props.lng},defaultOptions:{scrollwheel:false},defaultZoom:8},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_google_maps__["Marker"],{position:{lat:props.lat,lng:props.lng}}));}));var Mapa=function Mapa(_ref){var address=_ref.address,classes=_ref.classes;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_Grid_GridContainer_jsx__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_Grid_GridItem_jsx__["a" /* default */],{md:12,sm:12,xs:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_EnergyCompany_Cards_ECCard_jsx__["a" /* default */],{content:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(RegularMap,{containerElement:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{style:{borderRadius:"6px",height:"380px",overflow:"hidden"}}),googleMapURL:"https://maps.googleapis.com/maps/api/js?key=AIzaSyAn7KlMK6NEY1ysNzK_1oXPrudY2Vm8ibA",lat:address.latitude,lng:address.longitude,loadingElement:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{style:{height:"100%"}}),mapElement:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{style:{height:"100%"}})}),icon:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_icons_Map___default.a,null),title:"Localiza\xE7\xE3o"})));};Mapa.propTypes={address:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({latitude:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,longitude:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired})),classes:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired};/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_2__material_ui_core_styles_withStyles___default()({})(Mapa));

/***/ }),
/* 727 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(9);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(10));

var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
  d: "M20.5 3l-.16.03L15 5.1 9 3 3.36 4.9c-.21.07-.36.25-.36.48V20.5c0 .28.22.5.5.5l.16-.03L9 18.9l6 2.1 5.64-1.9c.21-.07.36-.25.36-.48V3.5c0-.28-.22-.5-.5-.5zM15 19l-6-2.11V5l6 2.11V19z"
}), _react.default.createElement("path", {
  fill: "none",
  d: "M0 0h24v24H0z"
})), 'Map');

exports.default = _default;

/***/ }),
/* 728 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true,
})

var _withScriptjs = __webpack_require__(729)

Object.defineProperty(exports, "withScriptjs", {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_withScriptjs).default
  },
})

var _withGoogleMap = __webpack_require__(802)

Object.defineProperty(exports, "withGoogleMap", {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_withGoogleMap).default
  },
})

var _GoogleMap = __webpack_require__(803)

Object.defineProperty(exports, "GoogleMap", {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_GoogleMap).default
  },
})

var _Circle = __webpack_require__(901)

Object.defineProperty(exports, "Circle", {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Circle).default
  },
})

var _Marker = __webpack_require__(902)

Object.defineProperty(exports, "Marker", {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Marker).default
  },
})

var _Polyline = __webpack_require__(903)

Object.defineProperty(exports, "Polyline", {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Polyline).default
  },
})

var _Polygon = __webpack_require__(904)

Object.defineProperty(exports, "Polygon", {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Polygon).default
  },
})

var _Rectangle = __webpack_require__(905)

Object.defineProperty(exports, "Rectangle", {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Rectangle).default
  },
})

var _InfoWindow = __webpack_require__(906)

Object.defineProperty(exports, "InfoWindow", {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_InfoWindow).default
  },
})

var _OverlayView = __webpack_require__(907)

Object.defineProperty(exports, "OverlayView", {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_OverlayView).default
  },
})

var _GroundOverlay = __webpack_require__(920)

Object.defineProperty(exports, "GroundOverlay", {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_GroundOverlay).default
  },
})

var _DirectionsRenderer = __webpack_require__(921)

Object.defineProperty(exports, "DirectionsRenderer", {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_DirectionsRenderer).default
  },
})

var _FusionTablesLayer = __webpack_require__(922)

Object.defineProperty(exports, "FusionTablesLayer", {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_FusionTablesLayer).default
  },
})

var _KmlLayer = __webpack_require__(923)

Object.defineProperty(exports, "KmlLayer", {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_KmlLayer).default
  },
})

var _TrafficLayer = __webpack_require__(924)

Object.defineProperty(exports, "TrafficLayer", {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_TrafficLayer).default
  },
})

var _StreetViewPanorama = __webpack_require__(925)

Object.defineProperty(exports, "StreetViewPanorama", {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_StreetViewPanorama).default
  },
})

var _BicyclingLayer = __webpack_require__(926)

Object.defineProperty(exports, "BicyclingLayer", {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_BicyclingLayer).default
  },
})

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj }
}


/***/ }),
/* 729 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true,
})

var _objectWithoutProperties2 = __webpack_require__(299)

var _objectWithoutProperties3 = _interopRequireDefault(
  _objectWithoutProperties2
)

var _getPrototypeOf = __webpack_require__(25)

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf)

var _classCallCheck2 = __webpack_require__(26)

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2)

var _createClass2 = __webpack_require__(27)

var _createClass3 = _interopRequireDefault(_createClass2)

var _possibleConstructorReturn2 = __webpack_require__(28)

var _possibleConstructorReturn3 = _interopRequireDefault(
  _possibleConstructorReturn2
)

var _inherits2 = __webpack_require__(29)

var _inherits3 = _interopRequireDefault(_inherits2)

var _bind2 = __webpack_require__(142)

var _bind3 = _interopRequireDefault(_bind2)

exports.withScriptjs = withScriptjs

var _invariant = __webpack_require__(30)

var _invariant2 = _interopRequireDefault(_invariant)

var _canUseDom = __webpack_require__(332)

var _canUseDom2 = _interopRequireDefault(_canUseDom)

var _recompose = __webpack_require__(333)

var _propTypes = __webpack_require__(1)

var _propTypes2 = _interopRequireDefault(_propTypes)

var _react = __webpack_require__(0)

var _react2 = _interopRequireDefault(_react)

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj }
}

var LOADING_STATE_NONE = "NONE"
var LOADING_STATE_BEGIN = "BEGIN"
var LOADING_STATE_LOADED = "LOADED"

function withScriptjs(BaseComponent) {
  var factory = _react2.default.createFactory(BaseComponent)

  var Container = (function(_React$PureComponent) {
    ;(0, _inherits3.default)(Container, _React$PureComponent)

    function Container() {
      var _ref

      var _temp, _this, _ret

      ;(0, _classCallCheck3.default)(this, Container)

      for (
        var _len = arguments.length, args = Array(_len), _key = 0;
        _key < _len;
        _key++
      ) {
        args[_key] = arguments[_key]
      }

      return (
        (_ret = ((_temp = ((_this = (0, _possibleConstructorReturn3.default)(
          this,
          (_ref =
            Container.__proto__ ||
            (0, _getPrototypeOf2.default)(Container)).call.apply(
            _ref,
            [this].concat(args)
          )
        )),
        _this)),
        (_this.state = {
          loadingState: LOADING_STATE_NONE,
        }),
        (_this.isUnmounted = false),
        (_this.handleLoaded = (0, _bind3.default)(_this.handleLoaded, _this)),
        _temp)),
        (0, _possibleConstructorReturn3.default)(_this, _ret)
      )
    }

    ;(0, _createClass3.default)(Container, [
      {
        key: "handleLoaded",
        value: function handleLoaded() {
          if (this.isUnmounted) {
            return
          }
          this.setState({
            loadingState: LOADING_STATE_LOADED,
          })
        },
      },
      {
        key: "componentWillMount",
        value: function componentWillMount() {
          var _props = this.props,
            loadingElement = _props.loadingElement,
            googleMapURL = _props.googleMapURL

          ;(0, _invariant2.default)(
            !!loadingElement && !!googleMapURL,
            "Required props loadingElement or googleMapURL is missing. You need to provide both of them."
          )
        },
      },
      {
        key: "componentDidMount",
        value: function componentDidMount() {
          var loadingState = this.state.loadingState

          if (loadingState !== LOADING_STATE_NONE || !_canUseDom2.default) {
            return
          }
          this.setState({
            loadingState: LOADING_STATE_BEGIN,
          })
          // Don't load scriptjs as a dependency since we do not want this module be used on server side.
          // eslint-disable-next-line global-require
          var scriptjs = __webpack_require__(801)
          var googleMapURL = this.props.googleMapURL

          scriptjs(googleMapURL, this.handleLoaded)
        },
      },
      {
        key: "componentWillUnmount",
        value: function componentWillUnmount() {
          this.isUnmounted = true
        },
      },
      {
        key: "render",
        value: function render() {
          var _props2 = this.props,
            loadingElement = _props2.loadingElement,
            googleMapURL = _props2.googleMapURL,
            restProps = (0, _objectWithoutProperties3.default)(_props2, [
              "loadingElement",
              "googleMapURL",
            ])
          var loadingState = this.state.loadingState

          if (loadingState === LOADING_STATE_LOADED) {
            return factory(restProps)
          } else {
            return loadingElement
          }
        },
      },
    ])
    return Container
  })(_react2.default.PureComponent)

  Container.displayName =
    "withScriptjs(" + (0, _recompose.getDisplayName)(BaseComponent) + ")"
  Container.propTypes = {
    loadingElement: _propTypes2.default.node.isRequired,
    googleMapURL: _propTypes2.default.string.isRequired,
  }

  return Container
}

exports.default = withScriptjs


/***/ }),
/* 730 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(731);
module.exports = __webpack_require__(42).Object.getPrototypeOf;


/***/ }),
/* 731 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 Object.getPrototypeOf(O)
var toObject = __webpack_require__(108);
var $getPrototypeOf = __webpack_require__(300);

__webpack_require__(732)('getPrototypeOf', function () {
  return function getPrototypeOf(it) {
    return $getPrototypeOf(toObject(it));
  };
});


/***/ }),
/* 732 */
/***/ (function(module, exports, __webpack_require__) {

// most Object methods by ES6 should accept primitives
var $export = __webpack_require__(57);
var core = __webpack_require__(42);
var fails = __webpack_require__(83);
module.exports = function (KEY, exec) {
  var fn = (core.Object || {})[KEY] || Object[KEY];
  var exp = {};
  exp[KEY] = exec(fn);
  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
};


/***/ }),
/* 733 */
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};


/***/ }),
/* 734 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(735);
var $Object = __webpack_require__(42).Object;
module.exports = function defineProperty(it, key, desc) {
  return $Object.defineProperty(it, key, desc);
};


/***/ }),
/* 735 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(57);
// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
$export($export.S + $export.F * !__webpack_require__(59), 'Object', { defineProperty: __webpack_require__(58).f });


/***/ }),
/* 736 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(737), __esModule: true };

/***/ }),
/* 737 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(305);
__webpack_require__(744);
module.exports = __webpack_require__(202).f('iterator');


/***/ }),
/* 738 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(197);
var defined = __webpack_require__(192);
// true  -> String#at
// false -> String#codePointAt
module.exports = function (TO_STRING) {
  return function (that, pos) {
    var s = String(defined(that));
    var i = toInteger(pos);
    var l = s.length;
    var a, b;
    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};


/***/ }),
/* 739 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var create = __webpack_require__(198);
var descriptor = __webpack_require__(109);
var setToStringTag = __webpack_require__(201);
var IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
__webpack_require__(80)(IteratorPrototype, __webpack_require__(47)('iterator'), function () { return this; });

module.exports = function (Constructor, NAME, next) {
  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
  setToStringTag(Constructor, NAME + ' Iterator');
};


/***/ }),
/* 740 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(58);
var anObject = __webpack_require__(81);
var getKeys = __webpack_require__(140);

module.exports = __webpack_require__(59) ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = getKeys(Properties);
  var length = keys.length;
  var i = 0;
  var P;
  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
  return O;
};


/***/ }),
/* 741 */
/***/ (function(module, exports, __webpack_require__) {

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__(84);
var toLength = __webpack_require__(310);
var toAbsoluteIndex = __webpack_require__(742);
module.exports = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};


/***/ }),
/* 742 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(197);
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};


/***/ }),
/* 743 */
/***/ (function(module, exports, __webpack_require__) {

var document = __webpack_require__(56).document;
module.exports = document && document.documentElement;


/***/ }),
/* 744 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(745);
var global = __webpack_require__(56);
var hide = __webpack_require__(80);
var Iterators = __webpack_require__(110);
var TO_STRING_TAG = __webpack_require__(47)('toStringTag');

var DOMIterables = ('CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,' +
  'DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,' +
  'MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,' +
  'SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,' +
  'TextTrackList,TouchList').split(',');

for (var i = 0; i < DOMIterables.length; i++) {
  var NAME = DOMIterables[i];
  var Collection = global[NAME];
  var proto = Collection && Collection.prototype;
  if (proto && !proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
  Iterators[NAME] = Iterators.Array;
}


/***/ }),
/* 745 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var addToUnscopables = __webpack_require__(746);
var step = __webpack_require__(747);
var Iterators = __webpack_require__(110);
var toIObject = __webpack_require__(84);

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = __webpack_require__(306)(Array, 'Array', function (iterated, kind) {
  this._t = toIObject(iterated); // target
  this._i = 0;                   // next index
  this._k = kind;                // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var kind = this._k;
  var index = this._i++;
  if (!O || index >= O.length) {
    this._t = undefined;
    return step(1);
  }
  if (kind == 'keys') return step(0, index);
  if (kind == 'values') return step(0, O[index]);
  return step(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
Iterators.Arguments = Iterators.Array;

addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');


/***/ }),
/* 746 */
/***/ (function(module, exports) {

module.exports = function () { /* empty */ };


/***/ }),
/* 747 */
/***/ (function(module, exports) {

module.exports = function (done, value) {
  return { value: value, done: !!done };
};


/***/ }),
/* 748 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(749), __esModule: true };

/***/ }),
/* 749 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(750);
__webpack_require__(755);
__webpack_require__(756);
__webpack_require__(757);
module.exports = __webpack_require__(42).Symbol;


/***/ }),
/* 750 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// ECMAScript 6 symbols shim
var global = __webpack_require__(56);
var has = __webpack_require__(64);
var DESCRIPTORS = __webpack_require__(59);
var $export = __webpack_require__(57);
var redefine = __webpack_require__(307);
var META = __webpack_require__(751).KEY;
var $fails = __webpack_require__(83);
var shared = __webpack_require__(194);
var setToStringTag = __webpack_require__(201);
var uid = __webpack_require__(139);
var wks = __webpack_require__(47);
var wksExt = __webpack_require__(202);
var wksDefine = __webpack_require__(203);
var enumKeys = __webpack_require__(752);
var isArray = __webpack_require__(753);
var anObject = __webpack_require__(81);
var isObject = __webpack_require__(82);
var toObject = __webpack_require__(108);
var toIObject = __webpack_require__(84);
var toPrimitive = __webpack_require__(196);
var createDesc = __webpack_require__(109);
var _create = __webpack_require__(198);
var gOPNExt = __webpack_require__(754);
var $GOPD = __webpack_require__(312);
var $GOPS = __webpack_require__(204);
var $DP = __webpack_require__(58);
var $keys = __webpack_require__(140);
var gOPD = $GOPD.f;
var dP = $DP.f;
var gOPN = gOPNExt.f;
var $Symbol = global.Symbol;
var $JSON = global.JSON;
var _stringify = $JSON && $JSON.stringify;
var PROTOTYPE = 'prototype';
var HIDDEN = wks('_hidden');
var TO_PRIMITIVE = wks('toPrimitive');
var isEnum = {}.propertyIsEnumerable;
var SymbolRegistry = shared('symbol-registry');
var AllSymbols = shared('symbols');
var OPSymbols = shared('op-symbols');
var ObjectProto = Object[PROTOTYPE];
var USE_NATIVE = typeof $Symbol == 'function' && !!$GOPS.f;
var QObject = global.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDesc = DESCRIPTORS && $fails(function () {
  return _create(dP({}, 'a', {
    get: function () { return dP(this, 'a', { value: 7 }).a; }
  })).a != 7;
}) ? function (it, key, D) {
  var protoDesc = gOPD(ObjectProto, key);
  if (protoDesc) delete ObjectProto[key];
  dP(it, key, D);
  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
} : dP;

var wrap = function (tag) {
  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
  sym._k = tag;
  return sym;
};

var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  return it instanceof $Symbol;
};

var $defineProperty = function defineProperty(it, key, D) {
  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
  anObject(it);
  key = toPrimitive(key, true);
  anObject(D);
  if (has(AllSymbols, key)) {
    if (!D.enumerable) {
      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
      it[HIDDEN][key] = true;
    } else {
      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
      D = _create(D, { enumerable: createDesc(0, false) });
    } return setSymbolDesc(it, key, D);
  } return dP(it, key, D);
};
var $defineProperties = function defineProperties(it, P) {
  anObject(it);
  var keys = enumKeys(P = toIObject(P));
  var i = 0;
  var l = keys.length;
  var key;
  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
  return it;
};
var $create = function create(it, P) {
  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
};
var $propertyIsEnumerable = function propertyIsEnumerable(key) {
  var E = isEnum.call(this, key = toPrimitive(key, true));
  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
};
var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
  it = toIObject(it);
  key = toPrimitive(key, true);
  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
  var D = gOPD(it, key);
  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
  return D;
};
var $getOwnPropertyNames = function getOwnPropertyNames(it) {
  var names = gOPN(toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
  } return result;
};
var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
  var IS_OP = it === ObjectProto;
  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
  } return result;
};

// 19.4.1.1 Symbol([description])
if (!USE_NATIVE) {
  $Symbol = function Symbol() {
    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
    var $set = function (value) {
      if (this === ObjectProto) $set.call(OPSymbols, value);
      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      setSymbolDesc(this, tag, createDesc(1, value));
    };
    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
    return wrap(tag);
  };
  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
    return this._k;
  });

  $GOPD.f = $getOwnPropertyDescriptor;
  $DP.f = $defineProperty;
  __webpack_require__(311).f = gOPNExt.f = $getOwnPropertyNames;
  __webpack_require__(141).f = $propertyIsEnumerable;
  $GOPS.f = $getOwnPropertySymbols;

  if (DESCRIPTORS && !__webpack_require__(138)) {
    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
  }

  wksExt.f = function (name) {
    return wrap(wks(name));
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });

for (var es6Symbols = (
  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);

for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);

$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
  // 19.4.2.1 Symbol.for(key)
  'for': function (key) {
    return has(SymbolRegistry, key += '')
      ? SymbolRegistry[key]
      : SymbolRegistry[key] = $Symbol(key);
  },
  // 19.4.2.5 Symbol.keyFor(sym)
  keyFor: function keyFor(sym) {
    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
  },
  useSetter: function () { setter = true; },
  useSimple: function () { setter = false; }
});

$export($export.S + $export.F * !USE_NATIVE, 'Object', {
  // 19.1.2.2 Object.create(O [, Properties])
  create: $create,
  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
  defineProperty: $defineProperty,
  // 19.1.2.3 Object.defineProperties(O, Properties)
  defineProperties: $defineProperties,
  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
  // 19.1.2.7 Object.getOwnPropertyNames(O)
  getOwnPropertyNames: $getOwnPropertyNames,
  // 19.1.2.8 Object.getOwnPropertySymbols(O)
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
// https://bugs.chromium.org/p/v8/issues/detail?id=3443
var FAILS_ON_PRIMITIVES = $fails(function () { $GOPS.f(1); });

$export($export.S + $export.F * FAILS_ON_PRIMITIVES, 'Object', {
  getOwnPropertySymbols: function getOwnPropertySymbols(it) {
    return $GOPS.f(toObject(it));
  }
});

// 24.3.2 JSON.stringify(value [, replacer [, space]])
$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
  var S = $Symbol();
  // MS Edge converts symbol values to JSON as {}
  // WebKit converts symbol values to JSON as null
  // V8 throws on boxed symbols
  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
})), 'JSON', {
  stringify: function stringify(it) {
    var args = [it];
    var i = 1;
    var replacer, $replacer;
    while (arguments.length > i) args.push(arguments[i++]);
    $replacer = replacer = args[1];
    if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
    if (!isArray(replacer)) replacer = function (key, value) {
      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
      if (!isSymbol(value)) return value;
    };
    args[1] = replacer;
    return _stringify.apply($JSON, args);
  }
});

// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(80)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
// 19.4.3.5 Symbol.prototype[@@toStringTag]
setToStringTag($Symbol, 'Symbol');
// 20.2.1.9 Math[@@toStringTag]
setToStringTag(Math, 'Math', true);
// 24.3.3 JSON[@@toStringTag]
setToStringTag(global.JSON, 'JSON', true);


/***/ }),
/* 751 */
/***/ (function(module, exports, __webpack_require__) {

var META = __webpack_require__(139)('meta');
var isObject = __webpack_require__(82);
var has = __webpack_require__(64);
var setDesc = __webpack_require__(58).f;
var id = 0;
var isExtensible = Object.isExtensible || function () {
  return true;
};
var FREEZE = !__webpack_require__(83)(function () {
  return isExtensible(Object.preventExtensions({}));
});
var setMeta = function (it) {
  setDesc(it, META, { value: {
    i: 'O' + ++id, // object ID
    w: {}          // weak collections IDs
  } });
};
var fastKey = function (it, create) {
  // return primitive with prefix
  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMeta(it);
  // return object ID
  } return it[META].i;
};
var getWeak = function (it, create) {
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMeta(it);
  // return hash weak collections IDs
  } return it[META].w;
};
// add metadata on freeze-family methods calling
var onFreeze = function (it) {
  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
  return it;
};
var meta = module.exports = {
  KEY: META,
  NEED: false,
  fastKey: fastKey,
  getWeak: getWeak,
  onFreeze: onFreeze
};


/***/ }),
/* 752 */
/***/ (function(module, exports, __webpack_require__) {

// all enumerable object keys, includes symbols
var getKeys = __webpack_require__(140);
var gOPS = __webpack_require__(204);
var pIE = __webpack_require__(141);
module.exports = function (it) {
  var result = getKeys(it);
  var getSymbols = gOPS.f;
  if (getSymbols) {
    var symbols = getSymbols(it);
    var isEnum = pIE.f;
    var i = 0;
    var key;
    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
  } return result;
};


/***/ }),
/* 753 */
/***/ (function(module, exports, __webpack_require__) {

// 7.2.2 IsArray(argument)
var cof = __webpack_require__(199);
module.exports = Array.isArray || function isArray(arg) {
  return cof(arg) == 'Array';
};


/***/ }),
/* 754 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var toIObject = __webpack_require__(84);
var gOPN = __webpack_require__(311).f;
var toString = {}.toString;

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function (it) {
  try {
    return gOPN(it);
  } catch (e) {
    return windowNames.slice();
  }
};

module.exports.f = function getOwnPropertyNames(it) {
  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
};


/***/ }),
/* 755 */
/***/ (function(module, exports) {



/***/ }),
/* 756 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(203)('asyncIterator');


/***/ }),
/* 757 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(203)('observable');


/***/ }),
/* 758 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(759), __esModule: true };

/***/ }),
/* 759 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(760);
module.exports = __webpack_require__(42).Object.setPrototypeOf;


/***/ }),
/* 760 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.19 Object.setPrototypeOf(O, proto)
var $export = __webpack_require__(57);
$export($export.S, 'Object', { setPrototypeOf: __webpack_require__(761).set });


/***/ }),
/* 761 */
/***/ (function(module, exports, __webpack_require__) {

// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */
var isObject = __webpack_require__(82);
var anObject = __webpack_require__(81);
var check = function (O, proto) {
  anObject(O);
  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
};
module.exports = {
  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
    function (test, buggy, set) {
      try {
        set = __webpack_require__(195)(Function.call, __webpack_require__(312).f(Object.prototype, '__proto__').set, 2);
        set(test, []);
        buggy = !(test instanceof Array);
      } catch (e) { buggy = true; }
      return function setPrototypeOf(O, proto) {
        check(O, proto);
        if (buggy) O.__proto__ = proto;
        else set(O, proto);
        return O;
      };
    }({}, false) : undefined),
  check: check
};


/***/ }),
/* 762 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(763), __esModule: true };

/***/ }),
/* 763 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(764);
var $Object = __webpack_require__(42).Object;
module.exports = function create(P, D) {
  return $Object.create(P, D);
};


/***/ }),
/* 764 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(57);
// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
$export($export.S, 'Object', { create: __webpack_require__(198) });


/***/ }),
/* 765 */
/***/ (function(module, exports, __webpack_require__) {

var apply = __webpack_require__(206);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */
function overRest(func, start, transform) {
  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
  return function() {
    var args = arguments,
        index = -1,
        length = nativeMax(args.length - start, 0),
        array = Array(length);

    while (++index < length) {
      array[index] = args[start + index];
    }
    index = -1;
    var otherArgs = Array(start + 1);
    while (++index < start) {
      otherArgs[index] = args[index];
    }
    otherArgs[start] = transform(array);
    return apply(func, this, otherArgs);
  };
}

module.exports = overRest;


/***/ }),
/* 766 */
/***/ (function(module, exports, __webpack_require__) {

var constant = __webpack_require__(767),
    defineProperty = __webpack_require__(314),
    identity = __webpack_require__(111);

/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var baseSetToString = !defineProperty ? identity : function(func, string) {
  return defineProperty(func, 'toString', {
    'configurable': true,
    'enumerable': false,
    'value': constant(string),
    'writable': true
  });
};

module.exports = baseSetToString;


/***/ }),
/* 767 */
/***/ (function(module, exports) {

/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */
function constant(value) {
  return function() {
    return value;
  };
}

module.exports = constant;


/***/ }),
/* 768 */
/***/ (function(module, exports, __webpack_require__) {

var isFunction = __webpack_require__(143),
    isMasked = __webpack_require__(771),
    isObject = __webpack_require__(66),
    toSource = __webpack_require__(316);

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

module.exports = baseIsNative;


/***/ }),
/* 769 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(144);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

module.exports = getRawTag;


/***/ }),
/* 770 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

module.exports = objectToString;


/***/ }),
/* 771 */
/***/ (function(module, exports, __webpack_require__) {

var coreJsData = __webpack_require__(772);

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

module.exports = isMasked;


/***/ }),
/* 772 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(38);

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

module.exports = coreJsData;


/***/ }),
/* 773 */
/***/ (function(module, exports) {

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

module.exports = getValue;


/***/ }),
/* 774 */
/***/ (function(module, exports, __webpack_require__) {

var baseSetData = __webpack_require__(318),
    createBind = __webpack_require__(775),
    createCurry = __webpack_require__(776),
    createHybrid = __webpack_require__(321),
    createPartial = __webpack_require__(793),
    getData = __webpack_require__(325),
    mergeData = __webpack_require__(794),
    setData = __webpack_require__(328),
    setWrapToString = __webpack_require__(329),
    toInteger = __webpack_require__(795);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/** Used to compose bitmasks for function metadata. */
var WRAP_BIND_FLAG = 1,
    WRAP_BIND_KEY_FLAG = 2,
    WRAP_CURRY_FLAG = 8,
    WRAP_CURRY_RIGHT_FLAG = 16,
    WRAP_PARTIAL_FLAG = 32,
    WRAP_PARTIAL_RIGHT_FLAG = 64;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * Creates a function that either curries or invokes `func` with optional
 * `this` binding and partially applied arguments.
 *
 * @private
 * @param {Function|string} func The function or method name to wrap.
 * @param {number} bitmask The bitmask flags.
 *    1 - `_.bind`
 *    2 - `_.bindKey`
 *    4 - `_.curry` or `_.curryRight` of a bound function
 *    8 - `_.curry`
 *   16 - `_.curryRight`
 *   32 - `_.partial`
 *   64 - `_.partialRight`
 *  128 - `_.rearg`
 *  256 - `_.ary`
 *  512 - `_.flip`
 * @param {*} [thisArg] The `this` binding of `func`.
 * @param {Array} [partials] The arguments to be partially applied.
 * @param {Array} [holders] The `partials` placeholder indexes.
 * @param {Array} [argPos] The argument positions of the new function.
 * @param {number} [ary] The arity cap of `func`.
 * @param {number} [arity] The arity of `func`.
 * @returns {Function} Returns the new wrapped function.
 */
function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
  var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
  if (!isBindKey && typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var length = partials ? partials.length : 0;
  if (!length) {
    bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
    partials = holders = undefined;
  }
  ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
  arity = arity === undefined ? arity : toInteger(arity);
  length -= holders ? holders.length : 0;

  if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
    var partialsRight = partials,
        holdersRight = holders;

    partials = holders = undefined;
  }
  var data = isBindKey ? undefined : getData(func);

  var newData = [
    func, bitmask, thisArg, partials, holders, partialsRight, holdersRight,
    argPos, ary, arity
  ];

  if (data) {
    mergeData(newData, data);
  }
  func = newData[0];
  bitmask = newData[1];
  thisArg = newData[2];
  partials = newData[3];
  holders = newData[4];
  arity = newData[9] = newData[9] === undefined
    ? (isBindKey ? 0 : func.length)
    : nativeMax(newData[9] - length, 0);

  if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) {
    bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
  }
  if (!bitmask || bitmask == WRAP_BIND_FLAG) {
    var result = createBind(func, bitmask, thisArg);
  } else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) {
    result = createCurry(func, bitmask, arity);
  } else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) {
    result = createPartial(func, bitmask, thisArg, partials);
  } else {
    result = createHybrid.apply(undefined, newData);
  }
  var setter = data ? baseSetData : setData;
  return setWrapToString(setter(result, newData), func, bitmask);
}

module.exports = createWrap;


/***/ }),
/* 775 */
/***/ (function(module, exports, __webpack_require__) {

var createCtor = __webpack_require__(145),
    root = __webpack_require__(38);

/** Used to compose bitmasks for function metadata. */
var WRAP_BIND_FLAG = 1;

/**
 * Creates a function that wraps `func` to invoke it with the optional `this`
 * binding of `thisArg`.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @param {*} [thisArg] The `this` binding of `func`.
 * @returns {Function} Returns the new wrapped function.
 */
function createBind(func, bitmask, thisArg) {
  var isBind = bitmask & WRAP_BIND_FLAG,
      Ctor = createCtor(func);

  function wrapper() {
    var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
    return fn.apply(isBind ? thisArg : this, arguments);
  }
  return wrapper;
}

module.exports = createBind;


/***/ }),
/* 776 */
/***/ (function(module, exports, __webpack_require__) {

var apply = __webpack_require__(206),
    createCtor = __webpack_require__(145),
    createHybrid = __webpack_require__(321),
    createRecurry = __webpack_require__(324),
    getHolder = __webpack_require__(210),
    replaceHolders = __webpack_require__(147),
    root = __webpack_require__(38);

/**
 * Creates a function that wraps `func` to enable currying.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @param {number} arity The arity of `func`.
 * @returns {Function} Returns the new wrapped function.
 */
function createCurry(func, bitmask, arity) {
  var Ctor = createCtor(func);

  function wrapper() {
    var length = arguments.length,
        args = Array(length),
        index = length,
        placeholder = getHolder(wrapper);

    while (index--) {
      args[index] = arguments[index];
    }
    var holders = (length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder)
      ? []
      : replaceHolders(args, placeholder);

    length -= holders.length;
    if (length < arity) {
      return createRecurry(
        func, bitmask, createHybrid, wrapper.placeholder, undefined,
        args, holders, undefined, undefined, arity - length);
    }
    var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
    return apply(fn, this, args);
  }
  return wrapper;
}

module.exports = createCurry;


/***/ }),
/* 777 */
/***/ (function(module, exports) {

/**
 * Gets the number of `placeholder` occurrences in `array`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} placeholder The placeholder to search for.
 * @returns {number} Returns the placeholder count.
 */
function countHolders(array, placeholder) {
  var length = array.length,
      result = 0;

  while (length--) {
    if (array[length] === placeholder) {
      ++result;
    }
  }
  return result;
}

module.exports = countHolders;


/***/ }),
/* 778 */
/***/ (function(module, exports, __webpack_require__) {

var LazyWrapper = __webpack_require__(208),
    getData = __webpack_require__(325),
    getFuncName = __webpack_require__(780),
    lodash = __webpack_require__(782);

/**
 * Checks if `func` has a lazy counterpart.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
 *  else `false`.
 */
function isLaziable(func) {
  var funcName = getFuncName(func),
      other = lodash[funcName];

  if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) {
    return false;
  }
  if (func === other) {
    return true;
  }
  var data = getData(other);
  return !!data && func === data[0];
}

module.exports = isLaziable;


/***/ }),
/* 779 */
/***/ (function(module, exports) {

/**
 * This method returns `undefined`.
 *
 * @static
 * @memberOf _
 * @since 2.3.0
 * @category Util
 * @example
 *
 * _.times(2, _.noop);
 * // => [undefined, undefined]
 */
function noop() {
  // No operation performed.
}

module.exports = noop;


/***/ }),
/* 780 */
/***/ (function(module, exports, __webpack_require__) {

var realNames = __webpack_require__(781);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Gets the name of `func`.
 *
 * @private
 * @param {Function} func The function to query.
 * @returns {string} Returns the function name.
 */
function getFuncName(func) {
  var result = (func.name + ''),
      array = realNames[result],
      length = hasOwnProperty.call(realNames, result) ? array.length : 0;

  while (length--) {
    var data = array[length],
        otherFunc = data.func;
    if (otherFunc == null || otherFunc == func) {
      return data.name;
    }
  }
  return result;
}

module.exports = getFuncName;


/***/ }),
/* 781 */
/***/ (function(module, exports) {

/** Used to lookup unminified function names. */
var realNames = {};

module.exports = realNames;


/***/ }),
/* 782 */
/***/ (function(module, exports, __webpack_require__) {

var LazyWrapper = __webpack_require__(208),
    LodashWrapper = __webpack_require__(326),
    baseLodash = __webpack_require__(209),
    isArray = __webpack_require__(44),
    isObjectLike = __webpack_require__(85),
    wrapperClone = __webpack_require__(783);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Creates a `lodash` object which wraps `value` to enable implicit method
 * chain sequences. Methods that operate on and return arrays, collections,
 * and functions can be chained together. Methods that retrieve a single value
 * or may return a primitive value will automatically end the chain sequence
 * and return the unwrapped value. Otherwise, the value must be unwrapped
 * with `_#value`.
 *
 * Explicit chain sequences, which must be unwrapped with `_#value`, may be
 * enabled using `_.chain`.
 *
 * The execution of chained methods is lazy, that is, it's deferred until
 * `_#value` is implicitly or explicitly called.
 *
 * Lazy evaluation allows several methods to support shortcut fusion.
 * Shortcut fusion is an optimization to merge iteratee calls; this avoids
 * the creation of intermediate arrays and can greatly reduce the number of
 * iteratee executions. Sections of a chain sequence qualify for shortcut
 * fusion if the section is applied to an array and iteratees accept only
 * one argument. The heuristic for whether a section qualifies for shortcut
 * fusion is subject to change.
 *
 * Chaining is supported in custom builds as long as the `_#value` method is
 * directly or indirectly included in the build.
 *
 * In addition to lodash methods, wrappers have `Array` and `String` methods.
 *
 * The wrapper `Array` methods are:
 * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
 *
 * The wrapper `String` methods are:
 * `replace` and `split`
 *
 * The wrapper methods that support shortcut fusion are:
 * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
 * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
 * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
 *
 * The chainable wrapper methods are:
 * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
 * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
 * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
 * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
 * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
 * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
 * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
 * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
 * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
 * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
 * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
 * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
 * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
 * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
 * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
 * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
 * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
 * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
 * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
 * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
 * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
 * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
 * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
 * `zipObject`, `zipObjectDeep`, and `zipWith`
 *
 * The wrapper methods that are **not** chainable by default are:
 * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
 * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
 * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
 * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
 * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
 * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
 * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
 * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
 * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
 * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
 * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
 * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
 * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
 * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
 * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
 * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
 * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
 * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
 * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
 * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
 * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
 * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
 * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
 * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
 * `upperFirst`, `value`, and `words`
 *
 * @name _
 * @constructor
 * @category Seq
 * @param {*} value The value to wrap in a `lodash` instance.
 * @returns {Object} Returns the new `lodash` wrapper instance.
 * @example
 *
 * function square(n) {
 *   return n * n;
 * }
 *
 * var wrapped = _([1, 2, 3]);
 *
 * // Returns an unwrapped value.
 * wrapped.reduce(_.add);
 * // => 6
 *
 * // Returns a wrapped value.
 * var squares = wrapped.map(square);
 *
 * _.isArray(squares);
 * // => false
 *
 * _.isArray(squares.value());
 * // => true
 */
function lodash(value) {
  if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
    if (value instanceof LodashWrapper) {
      return value;
    }
    if (hasOwnProperty.call(value, '__wrapped__')) {
      return wrapperClone(value);
    }
  }
  return new LodashWrapper(value);
}

// Ensure wrappers are instances of `baseLodash`.
lodash.prototype = baseLodash.prototype;
lodash.prototype.constructor = lodash;

module.exports = lodash;


/***/ }),
/* 783 */
/***/ (function(module, exports, __webpack_require__) {

var LazyWrapper = __webpack_require__(208),
    LodashWrapper = __webpack_require__(326),
    copyArray = __webpack_require__(327);

/**
 * Creates a clone of `wrapper`.
 *
 * @private
 * @param {Object} wrapper The wrapper to clone.
 * @returns {Object} Returns the cloned wrapper.
 */
function wrapperClone(wrapper) {
  if (wrapper instanceof LazyWrapper) {
    return wrapper.clone();
  }
  var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
  result.__actions__ = copyArray(wrapper.__actions__);
  result.__index__  = wrapper.__index__;
  result.__values__ = wrapper.__values__;
  return result;
}

module.exports = wrapperClone;


/***/ }),
/* 784 */
/***/ (function(module, exports) {

/** Used to match wrap detail comments. */
var reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/,
    reSplitDetails = /,? & /;

/**
 * Extracts wrapper details from the `source` body comment.
 *
 * @private
 * @param {string} source The source to inspect.
 * @returns {Array} Returns the wrapper details.
 */
function getWrapDetails(source) {
  var match = source.match(reWrapDetails);
  return match ? match[1].split(reSplitDetails) : [];
}

module.exports = getWrapDetails;


/***/ }),
/* 785 */
/***/ (function(module, exports) {

/** Used to match wrap detail comments. */
var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/;

/**
 * Inserts wrapper `details` in a comment at the top of the `source` body.
 *
 * @private
 * @param {string} source The source to modify.
 * @returns {Array} details The details to insert.
 * @returns {string} Returns the modified source.
 */
function insertWrapDetails(source, details) {
  var length = details.length;
  if (!length) {
    return source;
  }
  var lastIndex = length - 1;
  details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
  details = details.join(length > 2 ? ', ' : ' ');
  return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
}

module.exports = insertWrapDetails;


/***/ }),
/* 786 */
/***/ (function(module, exports, __webpack_require__) {

var arrayEach = __webpack_require__(330),
    arrayIncludes = __webpack_require__(787);

/** Used to compose bitmasks for function metadata. */
var WRAP_BIND_FLAG = 1,
    WRAP_BIND_KEY_FLAG = 2,
    WRAP_CURRY_FLAG = 8,
    WRAP_CURRY_RIGHT_FLAG = 16,
    WRAP_PARTIAL_FLAG = 32,
    WRAP_PARTIAL_RIGHT_FLAG = 64,
    WRAP_ARY_FLAG = 128,
    WRAP_REARG_FLAG = 256,
    WRAP_FLIP_FLAG = 512;

/** Used to associate wrap methods with their bit flags. */
var wrapFlags = [
  ['ary', WRAP_ARY_FLAG],
  ['bind', WRAP_BIND_FLAG],
  ['bindKey', WRAP_BIND_KEY_FLAG],
  ['curry', WRAP_CURRY_FLAG],
  ['curryRight', WRAP_CURRY_RIGHT_FLAG],
  ['flip', WRAP_FLIP_FLAG],
  ['partial', WRAP_PARTIAL_FLAG],
  ['partialRight', WRAP_PARTIAL_RIGHT_FLAG],
  ['rearg', WRAP_REARG_FLAG]
];

/**
 * Updates wrapper `details` based on `bitmask` flags.
 *
 * @private
 * @returns {Array} details The details to modify.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @returns {Array} Returns `details`.
 */
function updateWrapDetails(details, bitmask) {
  arrayEach(wrapFlags, function(pair) {
    var value = '_.' + pair[0];
    if ((bitmask & pair[1]) && !arrayIncludes(details, value)) {
      details.push(value);
    }
  });
  return details.sort();
}

module.exports = updateWrapDetails;


/***/ }),
/* 787 */
/***/ (function(module, exports, __webpack_require__) {

var baseIndexOf = __webpack_require__(788);

/**
 * A specialized version of `_.includes` for arrays without support for
 * specifying an index to search from.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */
function arrayIncludes(array, value) {
  var length = array == null ? 0 : array.length;
  return !!length && baseIndexOf(array, value, 0) > -1;
}

module.exports = arrayIncludes;


/***/ }),
/* 788 */
/***/ (function(module, exports, __webpack_require__) {

var baseFindIndex = __webpack_require__(789),
    baseIsNaN = __webpack_require__(790),
    strictIndexOf = __webpack_require__(791);

/**
 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseIndexOf(array, value, fromIndex) {
  return value === value
    ? strictIndexOf(array, value, fromIndex)
    : baseFindIndex(array, baseIsNaN, fromIndex);
}

module.exports = baseIndexOf;


/***/ }),
/* 789 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.findIndex` and `_.findLastIndex` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {number} fromIndex The index to search from.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseFindIndex(array, predicate, fromIndex, fromRight) {
  var length = array.length,
      index = fromIndex + (fromRight ? 1 : -1);

  while ((fromRight ? index-- : ++index < length)) {
    if (predicate(array[index], index, array)) {
      return index;
    }
  }
  return -1;
}

module.exports = baseFindIndex;


/***/ }),
/* 790 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.isNaN` without support for number objects.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 */
function baseIsNaN(value) {
  return value !== value;
}

module.exports = baseIsNaN;


/***/ }),
/* 791 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.indexOf` which performs strict equality
 * comparisons of values, i.e. `===`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function strictIndexOf(array, value, fromIndex) {
  var index = fromIndex - 1,
      length = array.length;

  while (++index < length) {
    if (array[index] === value) {
      return index;
    }
  }
  return -1;
}

module.exports = strictIndexOf;


/***/ }),
/* 792 */
/***/ (function(module, exports, __webpack_require__) {

var copyArray = __webpack_require__(327),
    isIndex = __webpack_require__(146);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMin = Math.min;

/**
 * Reorder `array` according to the specified indexes where the element at
 * the first index is assigned as the first element, the element at
 * the second index is assigned as the second element, and so on.
 *
 * @private
 * @param {Array} array The array to reorder.
 * @param {Array} indexes The arranged array indexes.
 * @returns {Array} Returns `array`.
 */
function reorder(array, indexes) {
  var arrLength = array.length,
      length = nativeMin(indexes.length, arrLength),
      oldArray = copyArray(array);

  while (length--) {
    var index = indexes[length];
    array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
  }
  return array;
}

module.exports = reorder;


/***/ }),
/* 793 */
/***/ (function(module, exports, __webpack_require__) {

var apply = __webpack_require__(206),
    createCtor = __webpack_require__(145),
    root = __webpack_require__(38);

/** Used to compose bitmasks for function metadata. */
var WRAP_BIND_FLAG = 1;

/**
 * Creates a function that wraps `func` to invoke it with the `this` binding
 * of `thisArg` and `partials` prepended to the arguments it receives.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} partials The arguments to prepend to those provided to
 *  the new function.
 * @returns {Function} Returns the new wrapped function.
 */
function createPartial(func, bitmask, thisArg, partials) {
  var isBind = bitmask & WRAP_BIND_FLAG,
      Ctor = createCtor(func);

  function wrapper() {
    var argsIndex = -1,
        argsLength = arguments.length,
        leftIndex = -1,
        leftLength = partials.length,
        args = Array(leftLength + argsLength),
        fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;

    while (++leftIndex < leftLength) {
      args[leftIndex] = partials[leftIndex];
    }
    while (argsLength--) {
      args[leftIndex++] = arguments[++argsIndex];
    }
    return apply(fn, isBind ? thisArg : this, args);
  }
  return wrapper;
}

module.exports = createPartial;


/***/ }),
/* 794 */
/***/ (function(module, exports, __webpack_require__) {

var composeArgs = __webpack_require__(322),
    composeArgsRight = __webpack_require__(323),
    replaceHolders = __webpack_require__(147);

/** Used as the internal argument placeholder. */
var PLACEHOLDER = '__lodash_placeholder__';

/** Used to compose bitmasks for function metadata. */
var WRAP_BIND_FLAG = 1,
    WRAP_BIND_KEY_FLAG = 2,
    WRAP_CURRY_BOUND_FLAG = 4,
    WRAP_CURRY_FLAG = 8,
    WRAP_ARY_FLAG = 128,
    WRAP_REARG_FLAG = 256;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMin = Math.min;

/**
 * Merges the function metadata of `source` into `data`.
 *
 * Merging metadata reduces the number of wrappers used to invoke a function.
 * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
 * may be applied regardless of execution order. Methods like `_.ary` and
 * `_.rearg` modify function arguments, making the order in which they are
 * executed important, preventing the merging of metadata. However, we make
 * an exception for a safe combined case where curried functions have `_.ary`
 * and or `_.rearg` applied.
 *
 * @private
 * @param {Array} data The destination metadata.
 * @param {Array} source The source metadata.
 * @returns {Array} Returns `data`.
 */
function mergeData(data, source) {
  var bitmask = data[1],
      srcBitmask = source[1],
      newBitmask = bitmask | srcBitmask,
      isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);

  var isCombo =
    ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_CURRY_FLAG)) ||
    ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_REARG_FLAG) && (data[7].length <= source[8])) ||
    ((srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG)) && (source[7].length <= source[8]) && (bitmask == WRAP_CURRY_FLAG));

  // Exit early if metadata can't be merged.
  if (!(isCommon || isCombo)) {
    return data;
  }
  // Use source `thisArg` if available.
  if (srcBitmask & WRAP_BIND_FLAG) {
    data[2] = source[2];
    // Set when currying a bound function.
    newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
  }
  // Compose partial arguments.
  var value = source[3];
  if (value) {
    var partials = data[3];
    data[3] = partials ? composeArgs(partials, value, source[4]) : value;
    data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
  }
  // Compose partial right arguments.
  value = source[5];
  if (value) {
    partials = data[5];
    data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
    data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
  }
  // Use source `argPos` if available.
  value = source[7];
  if (value) {
    data[7] = value;
  }
  // Use source `ary` if it's smaller.
  if (srcBitmask & WRAP_ARY_FLAG) {
    data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
  }
  // Use source `arity` if one is not provided.
  if (data[9] == null) {
    data[9] = source[9];
  }
  // Use source `func` and merge bitmasks.
  data[0] = source[0];
  data[1] = newBitmask;

  return data;
}

module.exports = mergeData;


/***/ }),
/* 795 */
/***/ (function(module, exports, __webpack_require__) {

var toFinite = __webpack_require__(796);

/**
 * Converts `value` to an integer.
 *
 * **Note:** This method is loosely based on
 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted integer.
 * @example
 *
 * _.toInteger(3.2);
 * // => 3
 *
 * _.toInteger(Number.MIN_VALUE);
 * // => 0
 *
 * _.toInteger(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toInteger('3.2');
 * // => 3
 */
function toInteger(value) {
  var result = toFinite(value),
      remainder = result % 1;

  return result === result ? (remainder ? result - remainder : result) : 0;
}

module.exports = toInteger;


/***/ }),
/* 796 */
/***/ (function(module, exports, __webpack_require__) {

var toNumber = __webpack_require__(331);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0,
    MAX_INTEGER = 1.7976931348623157e+308;

/**
 * Converts `value` to a finite number.
 *
 * @static
 * @memberOf _
 * @since 4.12.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted number.
 * @example
 *
 * _.toFinite(3.2);
 * // => 3.2
 *
 * _.toFinite(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toFinite(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toFinite('3.2');
 * // => 3.2
 */
function toFinite(value) {
  if (!value) {
    return value === 0 ? value : 0;
  }
  value = toNumber(value);
  if (value === INFINITY || value === -INFINITY) {
    var sign = (value < 0 ? -1 : 1);
    return sign * MAX_INTEGER;
  }
  return value === value ? value : 0;
}

module.exports = toFinite;


/***/ }),
/* 797 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var createChangeEmitter = exports.createChangeEmitter = function createChangeEmitter() {
  var currentListeners = [];
  var nextListeners = currentListeners;

  function ensureCanMutateNextListeners() {
    if (nextListeners === currentListeners) {
      nextListeners = currentListeners.slice();
    }
  }

  function listen(listener) {
    if (typeof listener !== 'function') {
      throw new Error('Expected listener to be a function.');
    }

    var isSubscribed = true;

    ensureCanMutateNextListeners();
    nextListeners.push(listener);

    return function () {
      if (!isSubscribed) {
        return;
      }

      isSubscribed = false;

      ensureCanMutateNextListeners();
      var index = nextListeners.indexOf(listener);
      nextListeners.splice(index, 1);
    };
  }

  function emit() {
    currentListeners = nextListeners;
    var listeners = currentListeners;
    for (var i = 0; i < listeners.length; i++) {
      listeners[i].apply(listeners, arguments);
    }
  }

  return {
    listen: listen,
    emit: emit
  };
};

/***/ }),
/* 798 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(799);


/***/ }),
/* 799 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global, module) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ponyfill = __webpack_require__(800);

var _ponyfill2 = _interopRequireDefault(_ponyfill);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var root; /* global window */


if (typeof self !== 'undefined') {
  root = self;
} else if (typeof window !== 'undefined') {
  root = window;
} else if (typeof global !== 'undefined') {
  root = global;
} else if (true) {
  root = module;
} else {
  root = Function('return this')();
}

var result = (0, _ponyfill2['default'])(root);
exports['default'] = result;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(36), __webpack_require__(94)(module)))

/***/ }),
/* 800 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports['default'] = symbolObservablePonyfill;
function symbolObservablePonyfill(root) {
	var result;
	var _Symbol = root.Symbol;

	if (typeof _Symbol === 'function') {
		if (_Symbol.observable) {
			result = _Symbol.observable;
		} else {
			result = _Symbol('observable');
			_Symbol.observable = result;
		}
	} else {
		result = '@@observable';
	}

	return result;
};

/***/ }),
/* 801 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
  * $script.js JS loader & dependency manager
  * https://github.com/ded/script.js
  * (c) Dustin Diaz 2014 | License MIT
  */

(function (name, definition) {
  if (typeof module != 'undefined' && module.exports) module.exports = definition()
  else if (true) !(__WEBPACK_AMD_DEFINE_FACTORY__ = (definition),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
  else this[name] = definition()
})('$script', function () {
  var doc = document
    , head = doc.getElementsByTagName('head')[0]
    , s = 'string'
    , f = false
    , push = 'push'
    , readyState = 'readyState'
    , onreadystatechange = 'onreadystatechange'
    , list = {}
    , ids = {}
    , delay = {}
    , scripts = {}
    , scriptpath
    , urlArgs

  function every(ar, fn) {
    for (var i = 0, j = ar.length; i < j; ++i) if (!fn(ar[i])) return f
    return 1
  }
  function each(ar, fn) {
    every(ar, function (el) {
      fn(el)
      return 1
    })
  }

  function $script(paths, idOrDone, optDone) {
    paths = paths[push] ? paths : [paths]
    var idOrDoneIsDone = idOrDone && idOrDone.call
      , done = idOrDoneIsDone ? idOrDone : optDone
      , id = idOrDoneIsDone ? paths.join('') : idOrDone
      , queue = paths.length
    function loopFn(item) {
      return item.call ? item() : list[item]
    }
    function callback() {
      if (!--queue) {
        list[id] = 1
        done && done()
        for (var dset in delay) {
          every(dset.split('|'), loopFn) && !each(delay[dset], loopFn) && (delay[dset] = [])
        }
      }
    }
    setTimeout(function () {
      each(paths, function loading(path, force) {
        if (path === null) return callback()
        
        if (!force && !/^https?:\/\//.test(path) && scriptpath) {
          path = (path.indexOf('.js') === -1) ? scriptpath + path + '.js' : scriptpath + path;
        }
        
        if (scripts[path]) {
          if (id) ids[id] = 1
          return (scripts[path] == 2) ? callback() : setTimeout(function () { loading(path, true) }, 0)
        }

        scripts[path] = 1
        if (id) ids[id] = 1
        create(path, callback)
      })
    }, 0)
    return $script
  }

  function create(path, fn) {
    var el = doc.createElement('script'), loaded
    el.onload = el.onerror = el[onreadystatechange] = function () {
      if ((el[readyState] && !(/^c|loade/.test(el[readyState]))) || loaded) return;
      el.onload = el[onreadystatechange] = null
      loaded = 1
      scripts[path] = 2
      fn()
    }
    el.async = 1
    el.src = urlArgs ? path + (path.indexOf('?') === -1 ? '?' : '&') + urlArgs : path;
    head.insertBefore(el, head.lastChild)
  }

  $script.get = create

  $script.order = function (scripts, id, done) {
    (function callback(s) {
      s = scripts.shift()
      !scripts.length ? $script(s, id, done) : $script(s, callback)
    }())
  }

  $script.path = function (p) {
    scriptpath = p
  }
  $script.urlArgs = function (str) {
    urlArgs = str;
  }
  $script.ready = function (deps, ready, req) {
    deps = deps[push] ? deps : [deps]
    var missing = [];
    !each(deps, function (dep) {
      list[dep] || missing[push](dep);
    }) && every(deps, function (dep) {return list[dep]}) ?
      ready() : !function (key) {
      delay[key] = delay[key] || []
      delay[key][push](ready)
      req && req(missing)
    }(deps.join('|'))
    return $script
  }

  $script.done = function (idOrDone) {
    $script([null], idOrDone)
  }

  return $script
});


/***/ }),
/* 802 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true,
})

var _objectWithoutProperties2 = __webpack_require__(299)

var _objectWithoutProperties3 = _interopRequireDefault(
  _objectWithoutProperties2
)

var _defineProperty2 = __webpack_require__(31)

var _defineProperty3 = _interopRequireDefault(_defineProperty2)

var _getPrototypeOf = __webpack_require__(25)

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf)

var _classCallCheck2 = __webpack_require__(26)

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2)

var _createClass2 = __webpack_require__(27)

var _createClass3 = _interopRequireDefault(_createClass2)

var _possibleConstructorReturn2 = __webpack_require__(28)

var _possibleConstructorReturn3 = _interopRequireDefault(
  _possibleConstructorReturn2
)

var _inherits2 = __webpack_require__(29)

var _inherits3 = _interopRequireDefault(_inherits2)

var _bind2 = __webpack_require__(142)

var _bind3 = _interopRequireDefault(_bind2)

exports.withGoogleMap = withGoogleMap

var _warning = __webpack_require__(334)

var _warning2 = _interopRequireDefault(_warning)

var _invariant = __webpack_require__(30)

var _invariant2 = _interopRequireDefault(_invariant)

var _recompose = __webpack_require__(333)

var _propTypes = __webpack_require__(1)

var _propTypes2 = _interopRequireDefault(_propTypes)

var _react = __webpack_require__(0)

var _react2 = _interopRequireDefault(_react)

var _constants = __webpack_require__(32)

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj }
}

/* global google */
function withGoogleMap(BaseComponent) {
  var factory = _react2.default.createFactory(BaseComponent)

  var Container = (function(_React$PureComponent) {
    ;(0, _inherits3.default)(Container, _React$PureComponent)

    function Container() {
      var _ref

      var _temp, _this, _ret

      ;(0, _classCallCheck3.default)(this, Container)

      for (
        var _len = arguments.length, args = Array(_len), _key = 0;
        _key < _len;
        _key++
      ) {
        args[_key] = arguments[_key]
      }

      return (
        (_ret = ((_temp = ((_this = (0, _possibleConstructorReturn3.default)(
          this,
          (_ref =
            Container.__proto__ ||
            (0, _getPrototypeOf2.default)(Container)).call.apply(
            _ref,
            [this].concat(args)
          )
        )),
        _this)),
        (_this.state = {
          map: null,
        }),
        (_this.handleComponentMount = (0, _bind3.default)(
          _this.handleComponentMount,
          _this
        )),
        _temp)),
        (0, _possibleConstructorReturn3.default)(_this, _ret)
      )
    }

    ;(0, _createClass3.default)(Container, [
      {
        key: "getChildContext",
        value: function getChildContext() {
          return (0, _defineProperty3.default)(
            {},
            _constants.MAP,
            this.state.map
          )
        },
      },
      {
        key: "componentWillMount",
        value: function componentWillMount() {
          var _props = this.props,
            containerElement = _props.containerElement,
            mapElement = _props.mapElement

          ;(0, _invariant2.default)(
            !!containerElement && !!mapElement,
            "Required props containerElement or mapElement is missing. You need to provide both of them.\n The `google.maps.Map` instance will be initialized on mapElement and it's wrapped by containerElement.\nYou need to provide both of them since Google Map requires the DOM to have height when initialized."
          )
        },
      },
      {
        key: "handleComponentMount",
        value: function handleComponentMount(node) {
          if (this.state.map || node === null) {
            return
          }
          ;(0, _warning2.default)(
            "undefined" !== typeof google,
            "Make sure you've put a <script> tag in your <head> element to load Google Maps JavaScript API v3.\n If you're looking for built-in support to load it for you, use the \"async/ScriptjsLoader\" instead.\n See https://github.com/tomchentw/react-google-maps/pull/168"
          )
          // https://developers.google.com/maps/documentation/javascript/3.exp/reference#Map
          var map = new google.maps.Map(node)
          this.setState({ map: map })
        },
      },
      {
        key: "render",
        value: function render() {
          var _props2 = this.props,
            containerElement = _props2.containerElement,
            mapElement = _props2.mapElement,
            restProps = (0, _objectWithoutProperties3.default)(_props2, [
              "containerElement",
              "mapElement",
            ])
          var map = this.state.map

          if (map) {
            return _react2.default.cloneElement(
              containerElement,
              {},
              _react2.default.cloneElement(mapElement, {
                ref: this.handleComponentMount,
              }),
              _react2.default.createElement("div", null, factory(restProps))
            )
          } else {
            return _react2.default.cloneElement(
              containerElement,
              {},
              _react2.default.cloneElement(mapElement, {
                ref: this.handleComponentMount,
              }),
              _react2.default.createElement("div", null)
            )
          }
        },
      },
    ])
    return Container
  })(_react2.default.PureComponent)

  Container.displayName =
    "withGoogleMap(" + (0, _recompose.getDisplayName)(BaseComponent) + ")"
  Container.propTypes = {
    containerElement: _propTypes2.default.node.isRequired,
    mapElement: _propTypes2.default.node.isRequired,
  }
  Container.childContextTypes = (0, _defineProperty3.default)(
    {},
    _constants.MAP,
    _propTypes2.default.object
  )

  return Container
}

exports.default = withGoogleMap


/***/ }),
/* 803 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true,
})
exports.GoogleMap = exports.Map = undefined

var _defineProperty2 = __webpack_require__(31)

var _defineProperty3 = _interopRequireDefault(_defineProperty2)

var _toConsumableArray2 = __webpack_require__(804)

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2)

var _getPrototypeOf = __webpack_require__(25)

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf)

var _classCallCheck2 = __webpack_require__(26)

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2)

var _possibleConstructorReturn2 = __webpack_require__(28)

var _possibleConstructorReturn3 = _interopRequireDefault(
  _possibleConstructorReturn2
)

var _createClass2 = __webpack_require__(27)

var _createClass3 = _interopRequireDefault(_createClass2)

var _inherits2 = __webpack_require__(29)

var _inherits3 = _interopRequireDefault(_inherits2)

var _invariant = __webpack_require__(30)

var _invariant2 = _interopRequireDefault(_invariant)

var _react = __webpack_require__(0)

var _react2 = _interopRequireDefault(_react)

var _propTypes = __webpack_require__(1)

var _propTypes2 = _interopRequireDefault(_propTypes)

var _MapChildHelper = __webpack_require__(35)

var _constants = __webpack_require__(32)

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj }
}

/**
 * A wrapper around `google.maps.Map`
 *
 * @see https://developers.google.com/maps/documentation/javascript/3.exp/reference#Map
 */
var Map = (exports.Map = (function(_React$PureComponent) {
  ;(0, _inherits3.default)(Map, _React$PureComponent)
  ;(0, _createClass3.default)(Map, [
    {
      key: "fitBounds",

      /**
       * @see https://developers.google.com/maps/documentation/javascript/3.exp/reference#Map
       * @public
       */
      value: function fitBounds() {
        var _context$MAP

        return (_context$MAP = this.context[_constants.MAP]).fitBounds.apply(
          _context$MAP,
          arguments
        )
      },

      /**
       * @see https://developers.google.com/maps/documentation/javascript/3.exp/reference#Map
       * @public
       */
    },
    {
      key: "panBy",
      value: function panBy() {
        var _context$MAP2

        return (_context$MAP2 = this.context[_constants.MAP]).panBy.apply(
          _context$MAP2,
          arguments
        )
      },

      /**
       * @see https://developers.google.com/maps/documentation/javascript/3.exp/reference#Map
       * @public
       */
    },
    {
      key: "panTo",
      value: function panTo() {
        var _context$MAP3

        return (_context$MAP3 = this.context[_constants.MAP]).panTo.apply(
          _context$MAP3,
          arguments
        )
      },

      /**
       * @see https://developers.google.com/maps/documentation/javascript/3.exp/reference#Map
       * @public
       */
    },
    {
      key: "panToBounds",
      value: function panToBounds() {
        var _context$MAP4

        return (_context$MAP4 = this.context[_constants.MAP]).panToBounds.apply(
          _context$MAP4,
          arguments
        )
      },

      /*
     * @see https://developers.google.com/maps/documentation/javascript/3.exp/reference#Map
     */
    },
  ])

  function Map(props, context) {
    ;(0, _classCallCheck3.default)(this, Map)

    var _this = (0, _possibleConstructorReturn3.default)(
      this,
      (Map.__proto__ || (0, _getPrototypeOf2.default)(Map)).call(
        this,
        props,
        context
      )
    )

    ;(0, _invariant2.default)(
      !!_this.context[_constants.MAP],
      "Did you wrap <GoogleMap> component with withGoogleMap() HOC?"
    )
    ;(0, _MapChildHelper.construct)(
      GoogleMap.propTypes,
      updaterMap,
      _this.props,
      _this.context[_constants.MAP]
    )
    return _this
  }

  ;(0, _createClass3.default)(Map, [
    {
      key: "componentDidMount",
      value: function componentDidMount() {
        ;(0, _MapChildHelper.componentDidMount)(
          this,
          this.context[_constants.MAP],
          eventMap
        )
      },
    },
    {
      key: "componentDidUpdate",
      value: function componentDidUpdate(prevProps) {
        ;(0, _MapChildHelper.componentDidUpdate)(
          this,
          this.context[_constants.MAP],
          eventMap,
          updaterMap,
          prevProps
        )
      },
    },
    {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        ;(0, _MapChildHelper.componentWillUnmount)(this)
      },
    },
    {
      key: "render",
      value: function render() {
        var children = this.props.children

        return _react2.default.createElement("div", null, children)
      },

      /**
       * Returns the lat/lng bounds of the current viewport. If more than one copy of the world is visible, the bounds range in longitude from -180 to 180 degrees inclusive. If the map is not yet initialized (i.e. the mapType is still null), or center and zoom have not been set then the result is `null` or `undefined`.
       * @type LatLngBoundsnullundefined
       * @public
       */
    },
    {
      key: "getBounds",
      value: function getBounds() {
        return this.context[_constants.MAP].getBounds()
      },

      /**
       * Returns the position displayed at the center of the map. Note that this `LatLng` object is _not_ wrapped. See `[LatLng](#LatLng)` for more information.
       * @type LatLngLatLngLatLng
       * @public
       */
    },
    {
      key: "getCenter",
      value: function getCenter() {
        return this.context[_constants.MAP].getCenter()
      },

      /**
       * Returns the clickability of the map icons. A map icon represents a point of interest, also known as a POI. If the returned value is true, then the icons are clickable on the map.
       * @type boolean
       * @public
       */
    },
    {
      key: "getClickableIcons",
      value: function getClickableIcons() {
        return this.context[_constants.MAP].getClickableIcons()
      },

      /**
       *
       * @type Element
       * @public
       */
    },
    {
      key: "getDiv",
      value: function getDiv() {
        return this.context[_constants.MAP].getDiv()
      },

      /**
       * Returns the compass heading of aerial imagery. The heading value is measured in degrees (clockwise) from cardinal direction North.
       * @type number
       * @public
       */
    },
    {
      key: "getHeading",
      value: function getHeading() {
        return this.context[_constants.MAP].getHeading()
      },

      /**
       *
       * @type MapTypeId|string
       * @public
       */
    },
    {
      key: "getMapTypeId",
      value: function getMapTypeId() {
        return this.context[_constants.MAP].getMapTypeId()
      },

      /**
       * Returns the current `Projection`. If the map is not yet initialized (i.e. the mapType is still null) then the result is null. Listen to `projection_changed` and check its value to ensure it is not null.
       * @type ProjectionProjectionprojection_changed
       * @public
       */
    },
    {
      key: "getProjection",
      value: function getProjection() {
        return this.context[_constants.MAP].getProjection()
      },

      /**
       * Returns the default `StreetViewPanorama` bound to the map, which may be a default panorama embedded within the map, or the panorama set using `setStreetView()`. Changes to the map's `streetViewControl` will be reflected in the display of such a bound panorama.
       * @type StreetViewPanoramaStreetViewPanoramasetStreetView()streetViewControl
       * @public
       */
    },
    {
      key: "getStreetView",
      value: function getStreetView() {
        return this.context[_constants.MAP].getStreetView()
      },

      /**
       * Returns the current angle of incidence of the map, in degrees from the viewport plane to the map plane. The result will be `0` for imagery taken directly overhead or `45` for 45° imagery. 45° imagery is only available for `satellite` and `hybrid` map types, within some locations, and at some zoom levels. **Note:** This method does not return the value set by `setTilt`. See `setTilt` for details.
       * @type number045satellitehybridsetTiltsetTilt
       * @public
       */
    },
    {
      key: "getTilt",
      value: function getTilt() {
        return this.context[_constants.MAP].getTilt()
      },

      /**
       *
       * @type number
       * @public
       */
    },
    {
      key: "getZoom",
      value: function getZoom() {
        return this.context[_constants.MAP].getZoom()
      },
    },
  ])
  return Map
})(
  _react2.default.PureComponent
)) /*
                                   * -----------------------------------------------------------------------------
                                   * This file is auto-generated from the corresponding file at `src/macros/`.
                                   * Please **DO NOT** edit this file directly when creating PRs.
                                   * -----------------------------------------------------------------------------
                                   */

Map.displayName = "GoogleMap"
Map.propTypes = {
  /**
   * @see https://developers.google.com/maps/documentation/javascript/3.exp/reference#MapTypeRegistry
   * @type Array<[id:string, mapType:MapType|*]>
   */
  defaultExtraMapTypes: _propTypes2.default.arrayOf(
    _propTypes2.default.arrayOf(_propTypes2.default.any)
  ),

  /**
   * @type LatLng|LatLngLiteral
   */
  defaultCenter: _propTypes2.default.any,

  /**
   * @type boolean
   */
  defaultClickableIcons: _propTypes2.default.bool,

  /**
   * @type number
   */
  defaultHeading: _propTypes2.default.number,

  /**
   * @type MapTypeId|string
   */
  defaultMapTypeId: _propTypes2.default.any,

  /**
   * @type MapOptions
   */
  defaultOptions: _propTypes2.default.any,

  /**
   * @type StreetViewPanorama
   */
  defaultStreetView: _propTypes2.default.any,

  /**
   * @type number
   */
  defaultTilt: _propTypes2.default.number,

  /**
   * @type number
   */
  defaultZoom: _propTypes2.default.number,

  /**
   * @type LatLng|LatLngLiteral
   */
  center: _propTypes2.default.any,

  /**
   * @type boolean
   */
  clickableIcons: _propTypes2.default.bool,

  /**
   * @type number
   */
  heading: _propTypes2.default.number,

  /**
   * @type MapTypeId|string
   */
  mapTypeId: _propTypes2.default.any,

  /**
   * @type MapOptions
   */
  options: _propTypes2.default.any,

  /**
   * @type StreetViewPanorama
   */
  streetView: _propTypes2.default.any,

  /**
   * @type number
   */
  tilt: _propTypes2.default.number,

  /**
   * @type number
   */
  zoom: _propTypes2.default.number,

  /**
   * function
   */
  onDblClick: _propTypes2.default.func,

  /**
   * function
   */
  onDragEnd: _propTypes2.default.func,

  /**
   * function
   */
  onDragStart: _propTypes2.default.func,

  /**
   * function
   */
  onMapTypeIdChanged: _propTypes2.default.func,

  /**
   * function
   */
  onMouseMove: _propTypes2.default.func,

  /**
   * function
   */
  onMouseOut: _propTypes2.default.func,

  /**
   * function
   */
  onMouseOver: _propTypes2.default.func,

  /**
   * function
   */
  onRightClick: _propTypes2.default.func,

  /**
   * function
   */
  onTilesLoaded: _propTypes2.default.func,

  /**
   * function
   */
  onBoundsChanged: _propTypes2.default.func,

  /**
   * function
   */
  onCenterChanged: _propTypes2.default.func,

  /**
   * function
   */
  onClick: _propTypes2.default.func,

  /**
   * function
   */
  onDrag: _propTypes2.default.func,

  /**
   * function
   */
  onHeadingChanged: _propTypes2.default.func,

  /**
   * function
   */
  onIdle: _propTypes2.default.func,

  /**
   * function
   */
  onProjectionChanged: _propTypes2.default.func,

  /**
   * function
   */
  onResize: _propTypes2.default.func,

  /**
   * function
   */
  onTiltChanged: _propTypes2.default.func,

  /**
   * function
   */
  onZoomChanged: _propTypes2.default.func,
}
Map.contextTypes = (0, _defineProperty3.default)(
  {},
  _constants.MAP,
  _propTypes2.default.object
)
var GoogleMap = (exports.GoogleMap = Map)

exports.default = Map

var eventMap = {
  onDblClick: "dblclick",
  onDragEnd: "dragend",
  onDragStart: "dragstart",
  onMapTypeIdChanged: "maptypeid_changed",
  onMouseMove: "mousemove",
  onMouseOut: "mouseout",
  onMouseOver: "mouseover",
  onRightClick: "rightclick",
  onTilesLoaded: "tilesloaded",
  onBoundsChanged: "bounds_changed",
  onCenterChanged: "center_changed",
  onClick: "click",
  onDrag: "drag",
  onHeadingChanged: "heading_changed",
  onIdle: "idle",
  onProjectionChanged: "projection_changed",
  onResize: "resize",
  onTiltChanged: "tilt_changed",
  onZoomChanged: "zoom_changed",
}

var updaterMap = {
  extraMapTypes: function extraMapTypes(instance, extra) {
    extra.forEach(function(it) {
      var _instance$mapTypes

      return (_instance$mapTypes = instance.mapTypes).set.apply(
        _instance$mapTypes,
        (0, _toConsumableArray3.default)(it)
      )
    })
  },
  center: function center(instance, _center) {
    instance.setCenter(_center)
  },
  clickableIcons: function clickableIcons(instance, _clickableIcons) {
    instance.setClickableIcons(_clickableIcons)
  },
  heading: function heading(instance, _heading) {
    instance.setHeading(_heading)
  },
  mapTypeId: function mapTypeId(instance, _mapTypeId) {
    instance.setMapTypeId(_mapTypeId)
  },
  options: function options(instance, _options) {
    instance.setOptions(_options)
  },
  streetView: function streetView(instance, _streetView) {
    instance.setStreetView(_streetView)
  },
  tilt: function tilt(instance, _tilt) {
    instance.setTilt(_tilt)
  },
  zoom: function zoom(instance, _zoom) {
    instance.setZoom(_zoom)
  },
}


/***/ }),
/* 804 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _from = __webpack_require__(805);

var _from2 = _interopRequireDefault(_from);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  } else {
    return (0, _from2.default)(arr);
  }
};

/***/ }),
/* 805 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(806), __esModule: true };

/***/ }),
/* 806 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(305);
__webpack_require__(807);
module.exports = __webpack_require__(42).Array.from;


/***/ }),
/* 807 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ctx = __webpack_require__(195);
var $export = __webpack_require__(57);
var toObject = __webpack_require__(108);
var call = __webpack_require__(808);
var isArrayIter = __webpack_require__(809);
var toLength = __webpack_require__(310);
var createProperty = __webpack_require__(810);
var getIterFn = __webpack_require__(811);

$export($export.S + $export.F * !__webpack_require__(813)(function (iter) { Array.from(iter); }), 'Array', {
  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
  from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
    var O = toObject(arrayLike);
    var C = typeof this == 'function' ? this : Array;
    var aLen = arguments.length;
    var mapfn = aLen > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var index = 0;
    var iterFn = getIterFn(O);
    var length, result, step, iterator;
    if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
    // if object isn't iterable or it's array with default iterator - use simple case
    if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
      }
    } else {
      length = toLength(O.length);
      for (result = new C(length); length > index; index++) {
        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
      }
    }
    result.length = index;
    return result;
  }
});


/***/ }),
/* 808 */
/***/ (function(module, exports, __webpack_require__) {

// call something on iterator step with safe closing on error
var anObject = __webpack_require__(81);
module.exports = function (iterator, fn, value, entries) {
  try {
    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
  // 7.4.6 IteratorClose(iterator, completion)
  } catch (e) {
    var ret = iterator['return'];
    if (ret !== undefined) anObject(ret.call(iterator));
    throw e;
  }
};


/***/ }),
/* 809 */
/***/ (function(module, exports, __webpack_require__) {

// check on default Array iterator
var Iterators = __webpack_require__(110);
var ITERATOR = __webpack_require__(47)('iterator');
var ArrayProto = Array.prototype;

module.exports = function (it) {
  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
};


/***/ }),
/* 810 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $defineProperty = __webpack_require__(58);
var createDesc = __webpack_require__(109);

module.exports = function (object, index, value) {
  if (index in object) $defineProperty.f(object, index, createDesc(0, value));
  else object[index] = value;
};


/***/ }),
/* 811 */
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__(812);
var ITERATOR = __webpack_require__(47)('iterator');
var Iterators = __webpack_require__(110);
module.exports = __webpack_require__(42).getIteratorMethod = function (it) {
  if (it != undefined) return it[ITERATOR]
    || it['@@iterator']
    || Iterators[classof(it)];
};


/***/ }),
/* 812 */
/***/ (function(module, exports, __webpack_require__) {

// getting tag from 19.1.3.6 Object.prototype.toString()
var cof = __webpack_require__(199);
var TAG = __webpack_require__(47)('toStringTag');
// ES3 wrong here
var ARG = cof(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (e) { /* empty */ }
};

module.exports = function (it) {
  var O, T, B;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
    // builtinTag case
    : ARG ? cof(O)
    // ES3 arguments fallback
    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};


/***/ }),
/* 813 */
/***/ (function(module, exports, __webpack_require__) {

var ITERATOR = __webpack_require__(47)('iterator');
var SAFE_CLOSING = false;

try {
  var riter = [7][ITERATOR]();
  riter['return'] = function () { SAFE_CLOSING = true; };
  // eslint-disable-next-line no-throw-literal
  Array.from(riter, function () { throw 2; });
} catch (e) { /* empty */ }

module.exports = function (exec, skipClosing) {
  if (!skipClosing && !SAFE_CLOSING) return false;
  var safe = false;
  try {
    var arr = [7];
    var iter = arr[ITERATOR]();
    iter.next = function () { return { done: safe = true }; };
    arr[ITERATOR] = function () { return iter; };
    exec(arr);
  } catch (e) { /* empty */ }
  return safe;
};


/***/ }),
/* 814 */
/***/ (function(module, exports, __webpack_require__) {

var arrayReduce = __webpack_require__(815),
    baseEach = __webpack_require__(335),
    baseIteratee = __webpack_require__(830),
    baseReduce = __webpack_require__(889),
    isArray = __webpack_require__(44);

/**
 * Reduces `collection` to a value which is the accumulated result of running
 * each element in `collection` thru `iteratee`, where each successive
 * invocation is supplied the return value of the previous. If `accumulator`
 * is not given, the first element of `collection` is used as the initial
 * value. The iteratee is invoked with four arguments:
 * (accumulator, value, index|key, collection).
 *
 * Many lodash methods are guarded to work as iteratees for methods like
 * `_.reduce`, `_.reduceRight`, and `_.transform`.
 *
 * The guarded methods are:
 * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
 * and `sortBy`
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @returns {*} Returns the accumulated value.
 * @see _.reduceRight
 * @example
 *
 * _.reduce([1, 2], function(sum, n) {
 *   return sum + n;
 * }, 0);
 * // => 3
 *
 * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
 *   (result[value] || (result[value] = [])).push(key);
 *   return result;
 * }, {});
 * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
 */
function reduce(collection, iteratee, accumulator) {
  var func = isArray(collection) ? arrayReduce : baseReduce,
      initAccum = arguments.length < 3;

  return func(collection, baseIteratee(iteratee, 4), accumulator, initAccum, baseEach);
}

module.exports = reduce;


/***/ }),
/* 815 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.reduce` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @param {boolean} [initAccum] Specify using the first element of `array` as
 *  the initial value.
 * @returns {*} Returns the accumulated value.
 */
function arrayReduce(array, iteratee, accumulator, initAccum) {
  var index = -1,
      length = array == null ? 0 : array.length;

  if (initAccum && length) {
    accumulator = array[++index];
  }
  while (++index < length) {
    accumulator = iteratee(accumulator, array[index], index, array);
  }
  return accumulator;
}

module.exports = arrayReduce;


/***/ }),
/* 816 */
/***/ (function(module, exports, __webpack_require__) {

var baseFor = __webpack_require__(817),
    keys = __webpack_require__(149);

/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */
function baseForOwn(object, iteratee) {
  return object && baseFor(object, iteratee, keys);
}

module.exports = baseForOwn;


/***/ }),
/* 817 */
/***/ (function(module, exports, __webpack_require__) {

var createBaseFor = __webpack_require__(818);

/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */
var baseFor = createBaseFor();

module.exports = baseFor;


/***/ }),
/* 818 */
/***/ (function(module, exports) {

/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseFor(fromRight) {
  return function(object, iteratee, keysFunc) {
    var index = -1,
        iterable = Object(object),
        props = keysFunc(object),
        length = props.length;

    while (length--) {
      var key = props[fromRight ? length : ++index];
      if (iteratee(iterable[key], key, iterable) === false) {
        break;
      }
    }
    return object;
  };
}

module.exports = createBaseFor;


/***/ }),
/* 819 */
/***/ (function(module, exports, __webpack_require__) {

var baseTimes = __webpack_require__(820),
    isArguments = __webpack_require__(336),
    isArray = __webpack_require__(44),
    isBuffer = __webpack_require__(337),
    isIndex = __webpack_require__(146),
    isTypedArray = __webpack_require__(338);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  var isArr = isArray(value),
      isArg = !isArr && isArguments(value),
      isBuff = !isArr && !isArg && isBuffer(value),
      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? baseTimes(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (
           // Safari 9 has enumerable `arguments.length` in strict mode.
           key == 'length' ||
           // Node.js 0.10 has enumerable non-index properties on buffers.
           (isBuff && (key == 'offset' || key == 'parent')) ||
           // PhantomJS 2 has enumerable non-index properties on typed arrays.
           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
           // Skip index properties.
           isIndex(key, length)
        ))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = arrayLikeKeys;


/***/ }),
/* 820 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

module.exports = baseTimes;


/***/ }),
/* 821 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(112),
    isObjectLike = __webpack_require__(85);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]';

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments(value) {
  return isObjectLike(value) && baseGetTag(value) == argsTag;
}

module.exports = baseIsArguments;


/***/ }),
/* 822 */
/***/ (function(module, exports) {

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = stubFalse;


/***/ }),
/* 823 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(112),
    isLength = __webpack_require__(211),
    isObjectLike = __webpack_require__(85);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
typedArrayTags[errorTag] = typedArrayTags[funcTag] =
typedArrayTags[mapTag] = typedArrayTags[numberTag] =
typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
typedArrayTags[setTag] = typedArrayTags[stringTag] =
typedArrayTags[weakMapTag] = false;

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
  return isObjectLike(value) &&
    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}

module.exports = baseIsTypedArray;


/***/ }),
/* 824 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

module.exports = baseUnary;


/***/ }),
/* 825 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var freeGlobal = __webpack_require__(315);

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && freeGlobal.process;

/** Used to access faster Node.js helpers. */
var nodeUtil = (function() {
  try {
    // Use `util.types` for Node.js 10+.
    var types = freeModule && freeModule.require && freeModule.require('util').types;

    if (types) {
      return types;
    }

    // Legacy `process.binding('util')` for Node.js < 10.
    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}());

module.exports = nodeUtil;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(94)(module)))

/***/ }),
/* 826 */
/***/ (function(module, exports, __webpack_require__) {

var isPrototype = __webpack_require__(339),
    nativeKeys = __webpack_require__(827);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

module.exports = baseKeys;


/***/ }),
/* 827 */
/***/ (function(module, exports, __webpack_require__) {

var overArg = __webpack_require__(828);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = overArg(Object.keys, Object);

module.exports = nativeKeys;


/***/ }),
/* 828 */
/***/ (function(module, exports) {

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

module.exports = overArg;


/***/ }),
/* 829 */
/***/ (function(module, exports, __webpack_require__) {

var isArrayLike = __webpack_require__(150);

/**
 * Creates a `baseEach` or `baseEachRight` function.
 *
 * @private
 * @param {Function} eachFunc The function to iterate over a collection.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseEach(eachFunc, fromRight) {
  return function(collection, iteratee) {
    if (collection == null) {
      return collection;
    }
    if (!isArrayLike(collection)) {
      return eachFunc(collection, iteratee);
    }
    var length = collection.length,
        index = fromRight ? length : -1,
        iterable = Object(collection);

    while ((fromRight ? index-- : ++index < length)) {
      if (iteratee(iterable[index], index, iterable) === false) {
        break;
      }
    }
    return collection;
  };
}

module.exports = createBaseEach;


/***/ }),
/* 830 */
/***/ (function(module, exports, __webpack_require__) {

var baseMatches = __webpack_require__(831),
    baseMatchesProperty = __webpack_require__(877),
    identity = __webpack_require__(111),
    isArray = __webpack_require__(44),
    property = __webpack_require__(886);

/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */
function baseIteratee(value) {
  // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
  // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
  if (typeof value == 'function') {
    return value;
  }
  if (value == null) {
    return identity;
  }
  if (typeof value == 'object') {
    return isArray(value)
      ? baseMatchesProperty(value[0], value[1])
      : baseMatches(value);
  }
  return property(value);
}

module.exports = baseIteratee;


/***/ }),
/* 831 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsMatch = __webpack_require__(832),
    getMatchData = __webpack_require__(876),
    matchesStrictComparable = __webpack_require__(344);

/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatches(source) {
  var matchData = getMatchData(source);
  if (matchData.length == 1 && matchData[0][2]) {
    return matchesStrictComparable(matchData[0][0], matchData[0][1]);
  }
  return function(object) {
    return object === source || baseIsMatch(object, source, matchData);
  };
}

module.exports = baseMatches;


/***/ }),
/* 832 */
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__(340),
    baseIsEqual = __webpack_require__(341);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */
function baseIsMatch(object, source, matchData, customizer) {
  var index = matchData.length,
      length = index,
      noCustomizer = !customizer;

  if (object == null) {
    return !length;
  }
  object = Object(object);
  while (index--) {
    var data = matchData[index];
    if ((noCustomizer && data[2])
          ? data[1] !== object[data[0]]
          : !(data[0] in object)
        ) {
      return false;
    }
  }
  while (++index < length) {
    data = matchData[index];
    var key = data[0],
        objValue = object[key],
        srcValue = data[1];

    if (noCustomizer && data[2]) {
      if (objValue === undefined && !(key in object)) {
        return false;
      }
    } else {
      var stack = new Stack;
      if (customizer) {
        var result = customizer(objValue, srcValue, key, object, source, stack);
      }
      if (!(result === undefined
            ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
            : result
          )) {
        return false;
      }
    }
  }
  return true;
}

module.exports = baseIsMatch;


/***/ }),
/* 833 */
/***/ (function(module, exports) {

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

module.exports = listCacheClear;


/***/ }),
/* 834 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(152);

/** Used for built-in method references. */
var arrayProto = Array.prototype;

/** Built-in value references. */
var splice = arrayProto.splice;

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

module.exports = listCacheDelete;


/***/ }),
/* 835 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(152);

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

module.exports = listCacheGet;


/***/ }),
/* 836 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(152);

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

module.exports = listCacheHas;


/***/ }),
/* 837 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(152);

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

module.exports = listCacheSet;


/***/ }),
/* 838 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(151);

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new ListCache;
  this.size = 0;
}

module.exports = stackClear;


/***/ }),
/* 839 */
/***/ (function(module, exports) {

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  var data = this.__data__,
      result = data['delete'](key);

  this.size = data.size;
  return result;
}

module.exports = stackDelete;


/***/ }),
/* 840 */
/***/ (function(module, exports) {

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

module.exports = stackGet;


/***/ }),
/* 841 */
/***/ (function(module, exports) {

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

module.exports = stackHas;


/***/ }),
/* 842 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(151),
    Map = __webpack_require__(212),
    MapCache = __webpack_require__(213);

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var data = this.__data__;
  if (data instanceof ListCache) {
    var pairs = data.__data__;
    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new MapCache(pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}

module.exports = stackSet;


/***/ }),
/* 843 */
/***/ (function(module, exports, __webpack_require__) {

var Hash = __webpack_require__(844),
    ListCache = __webpack_require__(151),
    Map = __webpack_require__(212);

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

module.exports = mapCacheClear;


/***/ }),
/* 844 */
/***/ (function(module, exports, __webpack_require__) {

var hashClear = __webpack_require__(845),
    hashDelete = __webpack_require__(846),
    hashGet = __webpack_require__(847),
    hashHas = __webpack_require__(848),
    hashSet = __webpack_require__(849);

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

module.exports = Hash;


/***/ }),
/* 845 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(154);

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
  this.size = 0;
}

module.exports = hashClear;


/***/ }),
/* 846 */
/***/ (function(module, exports) {

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = hashDelete;


/***/ }),
/* 847 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(154);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

module.exports = hashGet;


/***/ }),
/* 848 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(154);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
}

module.exports = hashHas;


/***/ }),
/* 849 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(154);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

module.exports = hashSet;


/***/ }),
/* 850 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(155);

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  var result = getMapData(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = mapCacheDelete;


/***/ }),
/* 851 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

module.exports = isKeyable;


/***/ }),
/* 852 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(155);

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

module.exports = mapCacheGet;


/***/ }),
/* 853 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(155);

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

module.exports = mapCacheHas;


/***/ }),
/* 854 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(155);

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  var data = getMapData(this, key),
      size = data.size;

  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

module.exports = mapCacheSet;


/***/ }),
/* 855 */
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__(340),
    equalArrays = __webpack_require__(342),
    equalByTag = __webpack_require__(861),
    equalObjects = __webpack_require__(865),
    getTag = __webpack_require__(872),
    isArray = __webpack_require__(44),
    isBuffer = __webpack_require__(337),
    isTypedArray = __webpack_require__(338);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    objectTag = '[object Object]';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
  var objIsArr = isArray(object),
      othIsArr = isArray(other),
      objTag = objIsArr ? arrayTag : getTag(object),
      othTag = othIsArr ? arrayTag : getTag(other);

  objTag = objTag == argsTag ? objectTag : objTag;
  othTag = othTag == argsTag ? objectTag : othTag;

  var objIsObj = objTag == objectTag,
      othIsObj = othTag == objectTag,
      isSameTag = objTag == othTag;

  if (isSameTag && isBuffer(object)) {
    if (!isBuffer(other)) {
      return false;
    }
    objIsArr = true;
    objIsObj = false;
  }
  if (isSameTag && !objIsObj) {
    stack || (stack = new Stack);
    return (objIsArr || isTypedArray(object))
      ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
      : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
  }
  if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

    if (objIsWrapped || othIsWrapped) {
      var objUnwrapped = objIsWrapped ? object.value() : object,
          othUnwrapped = othIsWrapped ? other.value() : other;

      stack || (stack = new Stack);
      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
    }
  }
  if (!isSameTag) {
    return false;
  }
  stack || (stack = new Stack);
  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
}

module.exports = baseIsEqualDeep;


/***/ }),
/* 856 */
/***/ (function(module, exports, __webpack_require__) {

var MapCache = __webpack_require__(213),
    setCacheAdd = __webpack_require__(857),
    setCacheHas = __webpack_require__(858);

/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */
function SetCache(values) {
  var index = -1,
      length = values == null ? 0 : values.length;

  this.__data__ = new MapCache;
  while (++index < length) {
    this.add(values[index]);
  }
}

// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;

module.exports = SetCache;


/***/ }),
/* 857 */
/***/ (function(module, exports) {

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */
function setCacheAdd(value) {
  this.__data__.set(value, HASH_UNDEFINED);
  return this;
}

module.exports = setCacheAdd;


/***/ }),
/* 858 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */
function setCacheHas(value) {
  return this.__data__.has(value);
}

module.exports = setCacheHas;


/***/ }),
/* 859 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */
function arraySome(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (predicate(array[index], index, array)) {
      return true;
    }
  }
  return false;
}

module.exports = arraySome;


/***/ }),
/* 860 */
/***/ (function(module, exports) {

/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function cacheHas(cache, key) {
  return cache.has(key);
}

module.exports = cacheHas;


/***/ }),
/* 861 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(144),
    Uint8Array = __webpack_require__(862),
    eq = __webpack_require__(153),
    equalArrays = __webpack_require__(342),
    mapToArray = __webpack_require__(863),
    setToArray = __webpack_require__(864);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/** `Object#toString` result references. */
var boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]';

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
  switch (tag) {
    case dataViewTag:
      if ((object.byteLength != other.byteLength) ||
          (object.byteOffset != other.byteOffset)) {
        return false;
      }
      object = object.buffer;
      other = other.buffer;

    case arrayBufferTag:
      if ((object.byteLength != other.byteLength) ||
          !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
        return false;
      }
      return true;

    case boolTag:
    case dateTag:
    case numberTag:
      // Coerce booleans to `1` or `0` and dates to milliseconds.
      // Invalid dates are coerced to `NaN`.
      return eq(+object, +other);

    case errorTag:
      return object.name == other.name && object.message == other.message;

    case regexpTag:
    case stringTag:
      // Coerce regexes to strings and treat strings, primitives and objects,
      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
      // for more details.
      return object == (other + '');

    case mapTag:
      var convert = mapToArray;

    case setTag:
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
      convert || (convert = setToArray);

      if (object.size != other.size && !isPartial) {
        return false;
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(object);
      if (stacked) {
        return stacked == other;
      }
      bitmask |= COMPARE_UNORDERED_FLAG;

      // Recursively compare objects (susceptible to call stack limits).
      stack.set(object, other);
      var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
      stack['delete'](object);
      return result;

    case symbolTag:
      if (symbolValueOf) {
        return symbolValueOf.call(object) == symbolValueOf.call(other);
      }
  }
  return false;
}

module.exports = equalByTag;


/***/ }),
/* 862 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(38);

/** Built-in value references. */
var Uint8Array = root.Uint8Array;

module.exports = Uint8Array;


/***/ }),
/* 863 */
/***/ (function(module, exports) {

/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */
function mapToArray(map) {
  var index = -1,
      result = Array(map.size);

  map.forEach(function(value, key) {
    result[++index] = [key, value];
  });
  return result;
}

module.exports = mapToArray;


/***/ }),
/* 864 */
/***/ (function(module, exports) {

/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */
function setToArray(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function(value) {
    result[++index] = value;
  });
  return result;
}

module.exports = setToArray;


/***/ }),
/* 865 */
/***/ (function(module, exports, __webpack_require__) {

var getAllKeys = __webpack_require__(866);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      objProps = getAllKeys(object),
      objLength = objProps.length,
      othProps = getAllKeys(other),
      othLength = othProps.length;

  if (objLength != othLength && !isPartial) {
    return false;
  }
  var index = objLength;
  while (index--) {
    var key = objProps[index];
    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
      return false;
    }
  }
  // Assume cyclic values are equal.
  var stacked = stack.get(object);
  if (stacked && stack.get(other)) {
    return stacked == other;
  }
  var result = true;
  stack.set(object, other);
  stack.set(other, object);

  var skipCtor = isPartial;
  while (++index < objLength) {
    key = objProps[index];
    var objValue = object[key],
        othValue = other[key];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, objValue, key, other, object, stack)
        : customizer(objValue, othValue, key, object, other, stack);
    }
    // Recursively compare objects (susceptible to call stack limits).
    if (!(compared === undefined
          ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
          : compared
        )) {
      result = false;
      break;
    }
    skipCtor || (skipCtor = key == 'constructor');
  }
  if (result && !skipCtor) {
    var objCtor = object.constructor,
        othCtor = other.constructor;

    // Non `Object` object instances with different constructors are not equal.
    if (objCtor != othCtor &&
        ('constructor' in object && 'constructor' in other) &&
        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
      result = false;
    }
  }
  stack['delete'](object);
  stack['delete'](other);
  return result;
}

module.exports = equalObjects;


/***/ }),
/* 866 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetAllKeys = __webpack_require__(867),
    getSymbols = __webpack_require__(869),
    keys = __webpack_require__(149);

/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeys(object) {
  return baseGetAllKeys(object, keys, getSymbols);
}

module.exports = getAllKeys;


/***/ }),
/* 867 */
/***/ (function(module, exports, __webpack_require__) {

var arrayPush = __webpack_require__(868),
    isArray = __webpack_require__(44);

/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */
function baseGetAllKeys(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
}

module.exports = baseGetAllKeys;


/***/ }),
/* 868 */
/***/ (function(module, exports) {

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

module.exports = arrayPush;


/***/ }),
/* 869 */
/***/ (function(module, exports, __webpack_require__) {

var arrayFilter = __webpack_require__(870),
    stubArray = __webpack_require__(871);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
  if (object == null) {
    return [];
  }
  object = Object(object);
  return arrayFilter(nativeGetSymbols(object), function(symbol) {
    return propertyIsEnumerable.call(object, symbol);
  });
};

module.exports = getSymbols;


/***/ }),
/* 870 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */
function arrayFilter(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (predicate(value, index, array)) {
      result[resIndex++] = value;
    }
  }
  return result;
}

module.exports = arrayFilter;


/***/ }),
/* 871 */
/***/ (function(module, exports) {

/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */
function stubArray() {
  return [];
}

module.exports = stubArray;


/***/ }),
/* 872 */
/***/ (function(module, exports, __webpack_require__) {

var DataView = __webpack_require__(873),
    Map = __webpack_require__(212),
    Promise = __webpack_require__(874),
    Set = __webpack_require__(875),
    WeakMap = __webpack_require__(320),
    baseGetTag = __webpack_require__(112),
    toSource = __webpack_require__(316);

/** `Object#toString` result references. */
var mapTag = '[object Map]',
    objectTag = '[object Object]',
    promiseTag = '[object Promise]',
    setTag = '[object Set]',
    weakMapTag = '[object WeakMap]';

var dataViewTag = '[object DataView]';

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = toSource(DataView),
    mapCtorString = toSource(Map),
    promiseCtorString = toSource(Promise),
    setCtorString = toSource(Set),
    weakMapCtorString = toSource(WeakMap);

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = baseGetTag;

// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
    (Map && getTag(new Map) != mapTag) ||
    (Promise && getTag(Promise.resolve()) != promiseTag) ||
    (Set && getTag(new Set) != setTag) ||
    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
  getTag = function(value) {
    var result = baseGetTag(value),
        Ctor = result == objectTag ? value.constructor : undefined,
        ctorString = Ctor ? toSource(Ctor) : '';

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString: return dataViewTag;
        case mapCtorString: return mapTag;
        case promiseCtorString: return promiseTag;
        case setCtorString: return setTag;
        case weakMapCtorString: return weakMapTag;
      }
    }
    return result;
  };
}

module.exports = getTag;


/***/ }),
/* 873 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(65),
    root = __webpack_require__(38);

/* Built-in method references that are verified to be native. */
var DataView = getNative(root, 'DataView');

module.exports = DataView;


/***/ }),
/* 874 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(65),
    root = __webpack_require__(38);

/* Built-in method references that are verified to be native. */
var Promise = getNative(root, 'Promise');

module.exports = Promise;


/***/ }),
/* 875 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(65),
    root = __webpack_require__(38);

/* Built-in method references that are verified to be native. */
var Set = getNative(root, 'Set');

module.exports = Set;


/***/ }),
/* 876 */
/***/ (function(module, exports, __webpack_require__) {

var isStrictComparable = __webpack_require__(343),
    keys = __webpack_require__(149);

/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */
function getMatchData(object) {
  var result = keys(object),
      length = result.length;

  while (length--) {
    var key = result[length],
        value = object[key];

    result[length] = [key, value, isStrictComparable(value)];
  }
  return result;
}

module.exports = getMatchData;


/***/ }),
/* 877 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsEqual = __webpack_require__(341),
    get = __webpack_require__(878),
    hasIn = __webpack_require__(884),
    isKey = __webpack_require__(214),
    isStrictComparable = __webpack_require__(343),
    matchesStrictComparable = __webpack_require__(344),
    toKey = __webpack_require__(156);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatchesProperty(path, srcValue) {
  if (isKey(path) && isStrictComparable(srcValue)) {
    return matchesStrictComparable(toKey(path), srcValue);
  }
  return function(object) {
    var objValue = get(object, path);
    return (objValue === undefined && objValue === srcValue)
      ? hasIn(object, path)
      : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
  };
}

module.exports = baseMatchesProperty;


/***/ }),
/* 878 */
/***/ (function(module, exports, __webpack_require__) {

var baseGet = __webpack_require__(345);

/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */
function get(object, path, defaultValue) {
  var result = object == null ? undefined : baseGet(object, path);
  return result === undefined ? defaultValue : result;
}

module.exports = get;


/***/ }),
/* 879 */
/***/ (function(module, exports, __webpack_require__) {

var memoizeCapped = __webpack_require__(880);

/** Used to match property names within property paths. */
var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath = memoizeCapped(function(string) {
  var result = [];
  if (string.charCodeAt(0) === 46 /* . */) {
    result.push('');
  }
  string.replace(rePropName, function(match, number, quote, subString) {
    result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
  });
  return result;
});

module.exports = stringToPath;


/***/ }),
/* 880 */
/***/ (function(module, exports, __webpack_require__) {

var memoize = __webpack_require__(881);

/** Used as the maximum memoize cache size. */
var MAX_MEMOIZE_SIZE = 500;

/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */
function memoizeCapped(func) {
  var result = memoize(func, function(key) {
    if (cache.size === MAX_MEMOIZE_SIZE) {
      cache.clear();
    }
    return key;
  });

  var cache = result.cache;
  return result;
}

module.exports = memoizeCapped;


/***/ }),
/* 881 */
/***/ (function(module, exports, __webpack_require__) {

var MapCache = __webpack_require__(213);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize(func, resolver) {
  if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized = function() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result) || cache;
    return result;
  };
  memoized.cache = new (memoize.Cache || MapCache);
  return memoized;
}

// Expose `MapCache`.
memoize.Cache = MapCache;

module.exports = memoize;


/***/ }),
/* 882 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(144),
    arrayMap = __webpack_require__(883),
    isArray = __webpack_require__(44),
    isSymbol = __webpack_require__(148);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isArray(value)) {
    // Recursively convert values (susceptible to call stack limits).
    return arrayMap(value, baseToString) + '';
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = baseToString;


/***/ }),
/* 883 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function arrayMap(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

module.exports = arrayMap;


/***/ }),
/* 884 */
/***/ (function(module, exports, __webpack_require__) {

var baseHasIn = __webpack_require__(885),
    hasPath = __webpack_require__(348);

/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */
function hasIn(object, path) {
  return object != null && hasPath(object, path, baseHasIn);
}

module.exports = hasIn;


/***/ }),
/* 885 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */
function baseHasIn(object, key) {
  return object != null && key in Object(object);
}

module.exports = baseHasIn;


/***/ }),
/* 886 */
/***/ (function(module, exports, __webpack_require__) {

var baseProperty = __webpack_require__(887),
    basePropertyDeep = __webpack_require__(888),
    isKey = __webpack_require__(214),
    toKey = __webpack_require__(156);

/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */
function property(path) {
  return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
}

module.exports = property;


/***/ }),
/* 887 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function baseProperty(key) {
  return function(object) {
    return object == null ? undefined : object[key];
  };
}

module.exports = baseProperty;


/***/ }),
/* 888 */
/***/ (function(module, exports, __webpack_require__) {

var baseGet = __webpack_require__(345);

/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function basePropertyDeep(path) {
  return function(object) {
    return baseGet(object, path);
  };
}

module.exports = basePropertyDeep;


/***/ }),
/* 889 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.reduce` and `_.reduceRight`, without support
 * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {*} accumulator The initial value.
 * @param {boolean} initAccum Specify using the first or last element of
 *  `collection` as the initial value.
 * @param {Function} eachFunc The function to iterate over `collection`.
 * @returns {*} Returns the accumulated value.
 */
function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
  eachFunc(collection, function(value, index, collection) {
    accumulator = initAccum
      ? (initAccum = false, value)
      : iteratee(accumulator, value, index, collection);
  });
  return accumulator;
}

module.exports = baseReduce;


/***/ }),
/* 890 */
/***/ (function(module, exports, __webpack_require__) {

var arrayEach = __webpack_require__(330),
    baseEach = __webpack_require__(335),
    castFunction = __webpack_require__(891),
    isArray = __webpack_require__(44);

/**
 * Iterates over elements of `collection` and invokes `iteratee` for each element.
 * The iteratee is invoked with three arguments: (value, index|key, collection).
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * **Note:** As with other "Collections" methods, objects with a "length"
 * property are iterated like arrays. To avoid this behavior use `_.forIn`
 * or `_.forOwn` for object iteration.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @alias each
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 * @see _.forEachRight
 * @example
 *
 * _.forEach([1, 2], function(value) {
 *   console.log(value);
 * });
 * // => Logs `1` then `2`.
 *
 * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
 *   console.log(key);
 * });
 * // => Logs 'a' then 'b' (iteration order is not guaranteed).
 */
function forEach(collection, iteratee) {
  var func = isArray(collection) ? arrayEach : baseEach;
  return func(collection, castFunction(iteratee));
}

module.exports = forEach;


/***/ }),
/* 891 */
/***/ (function(module, exports, __webpack_require__) {

var identity = __webpack_require__(111);

/**
 * Casts `value` to `identity` if it's not a function.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Function} Returns cast function.
 */
function castFunction(value) {
  return typeof value == 'function' ? value : identity;
}

module.exports = castFunction;


/***/ }),
/* 892 */
/***/ (function(module, exports, __webpack_require__) {

var createCaseFirst = __webpack_require__(893);

/**
 * Converts the first character of `string` to lower case.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.lowerFirst('Fred');
 * // => 'fred'
 *
 * _.lowerFirst('FRED');
 * // => 'fRED'
 */
var lowerFirst = createCaseFirst('toLowerCase');

module.exports = lowerFirst;


/***/ }),
/* 893 */
/***/ (function(module, exports, __webpack_require__) {

var castSlice = __webpack_require__(894),
    hasUnicode = __webpack_require__(349),
    stringToArray = __webpack_require__(896),
    toString = __webpack_require__(347);

/**
 * Creates a function like `_.lowerFirst`.
 *
 * @private
 * @param {string} methodName The name of the `String` case method to use.
 * @returns {Function} Returns the new case function.
 */
function createCaseFirst(methodName) {
  return function(string) {
    string = toString(string);

    var strSymbols = hasUnicode(string)
      ? stringToArray(string)
      : undefined;

    var chr = strSymbols
      ? strSymbols[0]
      : string.charAt(0);

    var trailing = strSymbols
      ? castSlice(strSymbols, 1).join('')
      : string.slice(1);

    return chr[methodName]() + trailing;
  };
}

module.exports = createCaseFirst;


/***/ }),
/* 894 */
/***/ (function(module, exports, __webpack_require__) {

var baseSlice = __webpack_require__(895);

/**
 * Casts `array` to a slice if it's needed.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {number} start The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the cast slice.
 */
function castSlice(array, start, end) {
  var length = array.length;
  end = end === undefined ? length : end;
  return (!start && end >= length) ? array : baseSlice(array, start, end);
}

module.exports = castSlice;


/***/ }),
/* 895 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.slice` without an iteratee call guard.
 *
 * @private
 * @param {Array} array The array to slice.
 * @param {number} [start=0] The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the slice of `array`.
 */
function baseSlice(array, start, end) {
  var index = -1,
      length = array.length;

  if (start < 0) {
    start = -start > length ? 0 : (length + start);
  }
  end = end > length ? length : end;
  if (end < 0) {
    end += length;
  }
  length = start > end ? 0 : ((end - start) >>> 0);
  start >>>= 0;

  var result = Array(length);
  while (++index < length) {
    result[index] = array[index + start];
  }
  return result;
}

module.exports = baseSlice;


/***/ }),
/* 896 */
/***/ (function(module, exports, __webpack_require__) {

var asciiToArray = __webpack_require__(897),
    hasUnicode = __webpack_require__(349),
    unicodeToArray = __webpack_require__(898);

/**
 * Converts `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function stringToArray(string) {
  return hasUnicode(string)
    ? unicodeToArray(string)
    : asciiToArray(string);
}

module.exports = stringToArray;


/***/ }),
/* 897 */
/***/ (function(module, exports) {

/**
 * Converts an ASCII `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function asciiToArray(string) {
  return string.split('');
}

module.exports = asciiToArray;


/***/ }),
/* 898 */
/***/ (function(module, exports) {

/** Used to compose unicode character classes. */
var rsAstralRange = '\\ud800-\\udfff',
    rsComboMarksRange = '\\u0300-\\u036f',
    reComboHalfMarksRange = '\\ufe20-\\ufe2f',
    rsComboSymbolsRange = '\\u20d0-\\u20ff',
    rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
    rsVarRange = '\\ufe0e\\ufe0f';

/** Used to compose unicode capture groups. */
var rsAstral = '[' + rsAstralRange + ']',
    rsCombo = '[' + rsComboRange + ']',
    rsFitz = '\\ud83c[\\udffb-\\udfff]',
    rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
    rsNonAstral = '[^' + rsAstralRange + ']',
    rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
    rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
    rsZWJ = '\\u200d';

/** Used to compose unicode regexes. */
var reOptMod = rsModifier + '?',
    rsOptVar = '[' + rsVarRange + ']?',
    rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
    rsSeq = rsOptVar + reOptMod + rsOptJoin,
    rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';

/** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');

/**
 * Converts a Unicode `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function unicodeToArray(string) {
  return string.match(reUnicode) || [];
}

module.exports = unicodeToArray;


/***/ }),
/* 899 */
/***/ (function(module, exports, __webpack_require__) {

var baseHas = __webpack_require__(900),
    hasPath = __webpack_require__(348);

/**
 * Checks if `path` is a direct property of `object`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = { 'a': { 'b': 2 } };
 * var other = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.has(object, 'a');
 * // => true
 *
 * _.has(object, 'a.b');
 * // => true
 *
 * _.has(object, ['a', 'b']);
 * // => true
 *
 * _.has(other, 'a');
 * // => false
 */
function has(object, path) {
  return object != null && hasPath(object, path, baseHas);
}

module.exports = has;


/***/ }),
/* 900 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.has` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */
function baseHas(object, key) {
  return object != null && hasOwnProperty.call(object, key);
}

module.exports = baseHas;


/***/ }),
/* 901 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true,
})
exports.Circle = undefined

var _defineProperty2 = __webpack_require__(31)

var _defineProperty3 = _interopRequireDefault(_defineProperty2)

var _getPrototypeOf = __webpack_require__(25)

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf)

var _classCallCheck2 = __webpack_require__(26)

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2)

var _createClass2 = __webpack_require__(27)

var _createClass3 = _interopRequireDefault(_createClass2)

var _possibleConstructorReturn2 = __webpack_require__(28)

var _possibleConstructorReturn3 = _interopRequireDefault(
  _possibleConstructorReturn2
)

var _inherits2 = __webpack_require__(29)

var _inherits3 = _interopRequireDefault(_inherits2)

var _react = __webpack_require__(0)

var _react2 = _interopRequireDefault(_react)

var _propTypes = __webpack_require__(1)

var _propTypes2 = _interopRequireDefault(_propTypes)

var _MapChildHelper = __webpack_require__(35)

var _constants = __webpack_require__(32)

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj }
}

/**
 * A wrapper around `google.maps.Circle`
 *
 * @see https://developers.google.com/maps/documentation/javascript/3.exp/reference#Circle
 */
/*
 * -----------------------------------------------------------------------------
 * This file is auto-generated from the corresponding file at `src/macros/`.
 * Please **DO NOT** edit this file directly when creating PRs.
 * -----------------------------------------------------------------------------
 */
/* global google */
var Circle = (exports.Circle = (function(_React$PureComponent) {
  ;(0, _inherits3.default)(Circle, _React$PureComponent)

  /*
   * @see https://developers.google.com/maps/documentation/javascript/3.exp/reference#Circle
   */
  function Circle(props, context) {
    ;(0, _classCallCheck3.default)(this, Circle)

    var _this = (0, _possibleConstructorReturn3.default)(
      this,
      (Circle.__proto__ || (0, _getPrototypeOf2.default)(Circle)).call(
        this,
        props,
        context
      )
    )

    var circle = new google.maps.Circle()
    ;(0, _MapChildHelper.construct)(
      Circle.propTypes,
      updaterMap,
      _this.props,
      circle
    )
    circle.setMap(_this.context[_constants.MAP])
    _this.state = (0, _defineProperty3.default)({}, _constants.CIRCLE, circle)
    return _this
  }

  ;(0, _createClass3.default)(Circle, [
    {
      key: "componentDidMount",
      value: function componentDidMount() {
        ;(0, _MapChildHelper.componentDidMount)(
          this,
          this.state[_constants.CIRCLE],
          eventMap
        )
      },
    },
    {
      key: "componentDidUpdate",
      value: function componentDidUpdate(prevProps) {
        ;(0, _MapChildHelper.componentDidUpdate)(
          this,
          this.state[_constants.CIRCLE],
          eventMap,
          updaterMap,
          prevProps
        )
      },
    },
    {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        ;(0, _MapChildHelper.componentWillUnmount)(this)
        var circle = this.state[_constants.CIRCLE]
        if (circle) {
          circle.setMap(null)
        }
      },
    },
    {
      key: "render",
      value: function render() {
        return false
      },

      /**
       * Gets the `LatLngBounds` of this Circle.
       * @type LatLngBoundsLatLngBounds
       * @public
       */
    },
    {
      key: "getBounds",
      value: function getBounds() {
        return this.state[_constants.CIRCLE].getBounds()
      },

      /**
       * Returns the center of this circle.
       * @type LatLng
       * @public
       */
    },
    {
      key: "getCenter",
      value: function getCenter() {
        return this.state[_constants.CIRCLE].getCenter()
      },

      /**
       * Returns whether this circle can be dragged by the user.
       * @type boolean
       * @public
       */
    },
    {
      key: "getDraggable",
      value: function getDraggable() {
        return this.state[_constants.CIRCLE].getDraggable()
      },

      /**
       * Returns whether this circle can be edited by the user.
       * @type boolean
       * @public
       */
    },
    {
      key: "getEditable",
      value: function getEditable() {
        return this.state[_constants.CIRCLE].getEditable()
      },

      /**
       * Returns the radius of this circle (in meters).
       * @type number
       * @public
       */
    },
    {
      key: "getRadius",
      value: function getRadius() {
        return this.state[_constants.CIRCLE].getRadius()
      },

      /**
       * Returns whether this circle is visible on the map.
       * @type boolean
       * @public
       */
    },
    {
      key: "getVisible",
      value: function getVisible() {
        return this.state[_constants.CIRCLE].getVisible()
      },
    },
  ])
  return Circle
})(_react2.default.PureComponent))

Circle.propTypes = {
  /**
   * @type LatLng|LatLngLiteral
   */
  defaultCenter: _propTypes2.default.any,

  /**
   * @type boolean
   */
  defaultDraggable: _propTypes2.default.bool,

  /**
   * @type boolean
   */
  defaultEditable: _propTypes2.default.bool,

  /**
   * @type CircleOptions
   */
  defaultOptions: _propTypes2.default.any,

  /**
   * @type number
   */
  defaultRadius: _propTypes2.default.number,

  /**
   * @type boolean
   */
  defaultVisible: _propTypes2.default.bool,

  /**
   * @type LatLng|LatLngLiteral
   */
  center: _propTypes2.default.any,

  /**
   * @type boolean
   */
  draggable: _propTypes2.default.bool,

  /**
   * @type boolean
   */
  editable: _propTypes2.default.bool,

  /**
   * @type CircleOptions
   */
  options: _propTypes2.default.any,

  /**
   * @type number
   */
  radius: _propTypes2.default.number,

  /**
   * @type boolean
   */
  visible: _propTypes2.default.bool,

  /**
   * function
   */
  onDblClick: _propTypes2.default.func,

  /**
   * function
   */
  onDragEnd: _propTypes2.default.func,

  /**
   * function
   */
  onDragStart: _propTypes2.default.func,

  /**
   * function
   */
  onMouseDown: _propTypes2.default.func,

  /**
   * function
   */
  onMouseMove: _propTypes2.default.func,

  /**
   * function
   */
  onMouseOut: _propTypes2.default.func,

  /**
   * function
   */
  onMouseOver: _propTypes2.default.func,

  /**
   * function
   */
  onMouseUp: _propTypes2.default.func,

  /**
   * function
   */
  onRightClick: _propTypes2.default.func,

  /**
   * function
   */
  onCenterChanged: _propTypes2.default.func,

  /**
   * function
   */
  onClick: _propTypes2.default.func,

  /**
   * function
   */
  onDrag: _propTypes2.default.func,

  /**
   * function
   */
  onRadiusChanged: _propTypes2.default.func,
}
Circle.contextTypes = (0, _defineProperty3.default)(
  {},
  _constants.MAP,
  _propTypes2.default.object
)
exports.default = Circle

var eventMap = {
  onDblClick: "dblclick",
  onDragEnd: "dragend",
  onDragStart: "dragstart",
  onMouseDown: "mousedown",
  onMouseMove: "mousemove",
  onMouseOut: "mouseout",
  onMouseOver: "mouseover",
  onMouseUp: "mouseup",
  onRightClick: "rightclick",
  onCenterChanged: "center_changed",
  onClick: "click",
  onDrag: "drag",
  onRadiusChanged: "radius_changed",
}

var updaterMap = {
  center: function center(instance, _center) {
    instance.setCenter(_center)
  },
  draggable: function draggable(instance, _draggable) {
    instance.setDraggable(_draggable)
  },
  editable: function editable(instance, _editable) {
    instance.setEditable(_editable)
  },
  options: function options(instance, _options) {
    instance.setOptions(_options)
  },
  radius: function radius(instance, _radius) {
    instance.setRadius(_radius)
  },
  visible: function visible(instance, _visible) {
    instance.setVisible(_visible)
  },
}


/***/ }),
/* 902 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true,
})
exports.Marker = undefined

var _defineProperty2 = __webpack_require__(31)

var _defineProperty3 = _interopRequireDefault(_defineProperty2)

var _getPrototypeOf = __webpack_require__(25)

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf)

var _classCallCheck2 = __webpack_require__(26)

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2)

var _createClass2 = __webpack_require__(27)

var _createClass3 = _interopRequireDefault(_createClass2)

var _possibleConstructorReturn2 = __webpack_require__(28)

var _possibleConstructorReturn3 = _interopRequireDefault(
  _possibleConstructorReturn2
)

var _inherits2 = __webpack_require__(29)

var _inherits3 = _interopRequireDefault(_inherits2)

var _Marker$contextTypes /*
                           * -----------------------------------------------------------------------------
                           * This file is auto-generated from the corresponding file at `src/macros/`.
                           * Please **DO NOT** edit this file directly when creating PRs.
                           * -----------------------------------------------------------------------------
                           */
/* global google */

var _react = __webpack_require__(0)

var _react2 = _interopRequireDefault(_react)

var _propTypes = __webpack_require__(1)

var _propTypes2 = _interopRequireDefault(_propTypes)

var _MapChildHelper = __webpack_require__(35)

var _constants = __webpack_require__(32)

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj }
}

/**
 * A wrapper around `google.maps.Marker`
 *
 * @see https://developers.google.com/maps/documentation/javascript/3.exp/reference#Marker
 */
var Marker = (exports.Marker = (function(_React$PureComponent) {
  ;(0, _inherits3.default)(Marker, _React$PureComponent)

  /*
   * @see https://developers.google.com/maps/documentation/javascript/3.exp/reference#Marker
   */
  function Marker(props, context) {
    ;(0, _classCallCheck3.default)(this, Marker)

    var _this = (0, _possibleConstructorReturn3.default)(
      this,
      (Marker.__proto__ || (0, _getPrototypeOf2.default)(Marker)).call(
        this,
        props,
        context
      )
    )

    var marker = new google.maps.Marker()
    ;(0, _MapChildHelper.construct)(
      Marker.propTypes,
      updaterMap,
      _this.props,
      marker
    )
    var markerClusterer = _this.context[_constants.MARKER_CLUSTERER]
    if (markerClusterer) {
      markerClusterer.addMarker(marker, !!_this.props.noRedraw)
    } else {
      marker.setMap(_this.context[_constants.MAP])
    }
    _this.state = (0, _defineProperty3.default)({}, _constants.MARKER, marker)
    return _this
  }

  ;(0, _createClass3.default)(Marker, [
    {
      key: "getChildContext",
      value: function getChildContext() {
        return (0, _defineProperty3.default)(
          {},
          _constants.ANCHOR,
          this.context[_constants.ANCHOR] || this.state[_constants.MARKER]
        )
      },
    },
    {
      key: "componentDidMount",
      value: function componentDidMount() {
        ;(0, _MapChildHelper.componentDidMount)(
          this,
          this.state[_constants.MARKER],
          eventMap
        )
      },
    },
    {
      key: "componentDidUpdate",
      value: function componentDidUpdate(prevProps) {
        ;(0, _MapChildHelper.componentDidUpdate)(
          this,
          this.state[_constants.MARKER],
          eventMap,
          updaterMap,
          prevProps
        )
      },
    },
    {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        ;(0, _MapChildHelper.componentWillUnmount)(this)
        var marker = this.state[_constants.MARKER]
        if (marker) {
          var markerClusterer = this.context[_constants.MARKER_CLUSTERER]
          if (markerClusterer) {
            markerClusterer.removeMarker(marker, !!this.props.noRedraw)
          }
          marker.setMap(null)
        }
      },
    },
    {
      key: "render",
      value: function render() {
        var children = this.props.children

        return _react2.default.createElement("div", null, children)
      },

      /**
       *
       * @type Animation
       * @public
       */
    },
    {
      key: "getAnimation",
      value: function getAnimation() {
        return this.state[_constants.MARKER].getAnimation()
      },

      /**
       *
       * @type boolean
       * @public
       */
    },
    {
      key: "getClickable",
      value: function getClickable() {
        return this.state[_constants.MARKER].getClickable()
      },

      /**
       *
       * @type string
       * @public
       */
    },
    {
      key: "getCursor",
      value: function getCursor() {
        return this.state[_constants.MARKER].getCursor()
      },

      /**
       *
       * @type boolean
       * @public
       */
    },
    {
      key: "getDraggable",
      value: function getDraggable() {
        return this.state[_constants.MARKER].getDraggable()
      },

      /**
       *
       * @type string|Icon|Symbol
       * @public
       */
    },
    {
      key: "getIcon",
      value: function getIcon() {
        return this.state[_constants.MARKER].getIcon()
      },

      /**
       *
       * @type MarkerLabel
       * @public
       */
    },
    {
      key: "getLabel",
      value: function getLabel() {
        return this.state[_constants.MARKER].getLabel()
      },

      /**
       *
       * @type number
       * @public
       */
    },
    {
      key: "getOpacity",
      value: function getOpacity() {
        return this.state[_constants.MARKER].getOpacity()
      },

      /**
       *
       * @type MarkerPlace
       * @public
       */
    },
    {
      key: "getPlace",
      value: function getPlace() {
        return this.state[_constants.MARKER].getPlace()
      },

      /**
       *
       * @type LatLng
       * @public
       */
    },
    {
      key: "getPosition",
      value: function getPosition() {
        return this.state[_constants.MARKER].getPosition()
      },

      /**
       *
       * @type MarkerShape
       * @public
       */
    },
    {
      key: "getShape",
      value: function getShape() {
        return this.state[_constants.MARKER].getShape()
      },

      /**
       *
       * @type string
       * @public
       */
    },
    {
      key: "getTitle",
      value: function getTitle() {
        return this.state[_constants.MARKER].getTitle()
      },

      /**
       *
       * @type boolean
       * @public
       */
    },
    {
      key: "getVisible",
      value: function getVisible() {
        return this.state[_constants.MARKER].getVisible()
      },

      /**
       *
       * @type number
       * @public
       */
    },
    {
      key: "getZIndex",
      value: function getZIndex() {
        return this.state[_constants.MARKER].getZIndex()
      },
    },
  ])
  return Marker
})(_react2.default.PureComponent))

Marker.propTypes = {
  /**
   * For the 2nd argument of `MarkerCluster#addMarker`
   * @see https://github.com/mikesaidani/marker-clusterer-plus
   */
  noRedraw: _propTypes2.default.bool,

  /**
   * @type Animation
   */
  defaultAnimation: _propTypes2.default.any,

  /**
   * @type boolean
   */
  defaultClickable: _propTypes2.default.bool,

  /**
   * @type string
   */
  defaultCursor: _propTypes2.default.string,

  /**
   * @type boolean
   */
  defaultDraggable: _propTypes2.default.bool,

  /**
   * @type string|Icon|Symbol
   */
  defaultIcon: _propTypes2.default.any,

  /**
   * @type string|MarkerLabel
   */
  defaultLabel: _propTypes2.default.any,

  /**
   * @type number
   */
  defaultOpacity: _propTypes2.default.number,

  /**
   * @type MarkerOptions
   */
  defaultOptions: _propTypes2.default.any,

  /**
   * @type MarkerPlace
   */
  defaultPlace: _propTypes2.default.any,

  /**
   * @type LatLng|LatLngLiteral
   */
  defaultPosition: _propTypes2.default.any,

  /**
   * @type MarkerShape
   */
  defaultShape: _propTypes2.default.any,

  /**
   * @type string
   */
  defaultTitle: _propTypes2.default.string,

  /**
   * @type boolean
   */
  defaultVisible: _propTypes2.default.bool,

  /**
   * @type number
   */
  defaultZIndex: _propTypes2.default.number,

  /**
   * @type Animation
   */
  animation: _propTypes2.default.any,

  /**
   * @type boolean
   */
  clickable: _propTypes2.default.bool,

  /**
   * @type string
   */
  cursor: _propTypes2.default.string,

  /**
   * @type boolean
   */
  draggable: _propTypes2.default.bool,

  /**
   * @type string|Icon|Symbol
   */
  icon: _propTypes2.default.any,

  /**
   * @type string|MarkerLabel
   */
  label: _propTypes2.default.any,

  /**
   * @type number
   */
  opacity: _propTypes2.default.number,

  /**
   * @type MarkerOptions
   */
  options: _propTypes2.default.any,

  /**
   * @type MarkerPlace
   */
  place: _propTypes2.default.any,

  /**
   * @type LatLng|LatLngLiteral
   */
  position: _propTypes2.default.any,

  /**
   * @type MarkerShape
   */
  shape: _propTypes2.default.any,

  /**
   * @type string
   */
  title: _propTypes2.default.string,

  /**
   * @type boolean
   */
  visible: _propTypes2.default.bool,

  /**
   * @type number
   */
  zIndex: _propTypes2.default.number,

  /**
   * function
   */
  onDblClick: _propTypes2.default.func,

  /**
   * function
   */
  onDragEnd: _propTypes2.default.func,

  /**
   * function
   */
  onDragStart: _propTypes2.default.func,

  /**
   * function
   */
  onMouseDown: _propTypes2.default.func,

  /**
   * function
   */
  onMouseOut: _propTypes2.default.func,

  /**
   * function
   */
  onMouseOver: _propTypes2.default.func,

  /**
   * function
   */
  onMouseUp: _propTypes2.default.func,

  /**
   * function
   */
  onRightClick: _propTypes2.default.func,

  /**
   * function
   */
  onAnimationChanged: _propTypes2.default.func,

  /**
   * function
   */
  onClick: _propTypes2.default.func,

  /**
   * function
   */
  onClickableChanged: _propTypes2.default.func,

  /**
   * function
   */
  onCursorChanged: _propTypes2.default.func,

  /**
   * function
   */
  onDrag: _propTypes2.default.func,

  /**
   * function
   */
  onDraggableChanged: _propTypes2.default.func,

  /**
   * function
   */
  onFlatChanged: _propTypes2.default.func,

  /**
   * function
   */
  onIconChanged: _propTypes2.default.func,

  /**
   * function
   */
  onPositionChanged: _propTypes2.default.func,

  /**
   * function
   */
  onShapeChanged: _propTypes2.default.func,

  /**
   * function
   */
  onTitleChanged: _propTypes2.default.func,

  /**
   * function
   */
  onVisibleChanged: _propTypes2.default.func,

  /**
   * function
   */
  onZindexChanged: _propTypes2.default.func,
}
Marker.contextTypes = ((_Marker$contextTypes = {}),
(0, _defineProperty3.default)(
  _Marker$contextTypes,
  _constants.MAP,
  _propTypes2.default.object
),
(0, _defineProperty3.default)(
  _Marker$contextTypes,
  _constants.MARKER_CLUSTERER,
  _propTypes2.default.object
),
_Marker$contextTypes)
Marker.childContextTypes = (0, _defineProperty3.default)(
  {},
  _constants.ANCHOR,
  _propTypes2.default.object
)
exports.default = Marker

var eventMap = {
  onDblClick: "dblclick",
  onDragEnd: "dragend",
  onDragStart: "dragstart",
  onMouseDown: "mousedown",
  onMouseOut: "mouseout",
  onMouseOver: "mouseover",
  onMouseUp: "mouseup",
  onRightClick: "rightclick",
  onAnimationChanged: "animation_changed",
  onClick: "click",
  onClickableChanged: "clickable_changed",
  onCursorChanged: "cursor_changed",
  onDrag: "drag",
  onDraggableChanged: "draggable_changed",
  onFlatChanged: "flat_changed",
  onIconChanged: "icon_changed",
  onPositionChanged: "position_changed",
  onShapeChanged: "shape_changed",
  onTitleChanged: "title_changed",
  onVisibleChanged: "visible_changed",
  onZindexChanged: "zindex_changed",
}

var updaterMap = {
  animation: function animation(instance, _animation) {
    instance.setAnimation(_animation)
  },
  clickable: function clickable(instance, _clickable) {
    instance.setClickable(_clickable)
  },
  cursor: function cursor(instance, _cursor) {
    instance.setCursor(_cursor)
  },
  draggable: function draggable(instance, _draggable) {
    instance.setDraggable(_draggable)
  },
  icon: function icon(instance, _icon) {
    instance.setIcon(_icon)
  },
  label: function label(instance, _label) {
    instance.setLabel(_label)
  },
  opacity: function opacity(instance, _opacity) {
    instance.setOpacity(_opacity)
  },
  options: function options(instance, _options) {
    instance.setOptions(_options)
  },
  place: function place(instance, _place) {
    instance.setPlace(_place)
  },
  position: function position(instance, _position) {
    instance.setPosition(_position)
  },
  shape: function shape(instance, _shape) {
    instance.setShape(_shape)
  },
  title: function title(instance, _title) {
    instance.setTitle(_title)
  },
  visible: function visible(instance, _visible) {
    instance.setVisible(_visible)
  },
  zIndex: function zIndex(instance, _zIndex) {
    instance.setZIndex(_zIndex)
  },
}


/***/ }),
/* 903 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true,
})
exports.Polyline = undefined

var _defineProperty2 = __webpack_require__(31)

var _defineProperty3 = _interopRequireDefault(_defineProperty2)

var _getPrototypeOf = __webpack_require__(25)

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf)

var _classCallCheck2 = __webpack_require__(26)

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2)

var _createClass2 = __webpack_require__(27)

var _createClass3 = _interopRequireDefault(_createClass2)

var _possibleConstructorReturn2 = __webpack_require__(28)

var _possibleConstructorReturn3 = _interopRequireDefault(
  _possibleConstructorReturn2
)

var _inherits2 = __webpack_require__(29)

var _inherits3 = _interopRequireDefault(_inherits2)

var _react = __webpack_require__(0)

var _react2 = _interopRequireDefault(_react)

var _propTypes = __webpack_require__(1)

var _propTypes2 = _interopRequireDefault(_propTypes)

var _MapChildHelper = __webpack_require__(35)

var _constants = __webpack_require__(32)

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj }
}

/**
 * A wrapper around `google.maps.Polyline`
 *
 * @see https://developers.google.com/maps/documentation/javascript/3.exp/reference#Polyline
 */
/*
 * -----------------------------------------------------------------------------
 * This file is auto-generated from the corresponding file at `src/macros/`.
 * Please **DO NOT** edit this file directly when creating PRs.
 * -----------------------------------------------------------------------------
 */
/* global google */
var Polyline = (exports.Polyline = (function(_React$PureComponent) {
  ;(0, _inherits3.default)(Polyline, _React$PureComponent)

  /*
   * @see https://developers.google.com/maps/documentation/javascript/3.exp/reference#Polyline
   */
  function Polyline(props, context) {
    ;(0, _classCallCheck3.default)(this, Polyline)

    var _this = (0, _possibleConstructorReturn3.default)(
      this,
      (Polyline.__proto__ || (0, _getPrototypeOf2.default)(Polyline)).call(
        this,
        props,
        context
      )
    )

    var polyline = new google.maps.Polyline()
    ;(0, _MapChildHelper.construct)(
      Polyline.propTypes,
      updaterMap,
      _this.props,
      polyline
    )
    polyline.setMap(_this.context[_constants.MAP])
    _this.state = (0, _defineProperty3.default)(
      {},
      _constants.POLYLINE,
      polyline
    )
    return _this
  }

  ;(0, _createClass3.default)(Polyline, [
    {
      key: "componentDidMount",
      value: function componentDidMount() {
        ;(0, _MapChildHelper.componentDidMount)(
          this,
          this.state[_constants.POLYLINE],
          eventMap
        )
      },
    },
    {
      key: "componentDidUpdate",
      value: function componentDidUpdate(prevProps) {
        ;(0, _MapChildHelper.componentDidUpdate)(
          this,
          this.state[_constants.POLYLINE],
          eventMap,
          updaterMap,
          prevProps
        )
      },
    },
    {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        ;(0, _MapChildHelper.componentWillUnmount)(this)
        var polyline = this.state[_constants.POLYLINE]
        if (polyline) {
          polyline.setMap(null)
        }
      },
    },
    {
      key: "render",
      value: function render() {
        return false
      },

      /**
       * Returns whether this shape can be dragged by the user.
       * @type boolean
       * @public
       */
    },
    {
      key: "getDraggable",
      value: function getDraggable() {
        return this.state[_constants.POLYLINE].getDraggable()
      },

      /**
       * Returns whether this shape can be edited by the user.
       * @type boolean
       * @public
       */
    },
    {
      key: "getEditable",
      value: function getEditable() {
        return this.state[_constants.POLYLINE].getEditable()
      },

      /**
       * Retrieves the path.
       * @type MVCArray<LatLng>
       * @public
       */
    },
    {
      key: "getPath",
      value: function getPath() {
        return this.state[_constants.POLYLINE].getPath()
      },

      /**
       * Returns whether this poly is visible on the map.
       * @type boolean
       * @public
       */
    },
    {
      key: "getVisible",
      value: function getVisible() {
        return this.state[_constants.POLYLINE].getVisible()
      },
    },
  ])
  return Polyline
})(_react2.default.PureComponent))

Polyline.propTypes = {
  /**
   * @type boolean
   */
  defaultDraggable: _propTypes2.default.bool,

  /**
   * @type boolean
   */
  defaultEditable: _propTypes2.default.bool,

  /**
   * @type PolylineOptions
   */
  defaultOptions: _propTypes2.default.any,

  /**
   * @type MVCArray<LatLng>|Array<LatLng|LatLngLiteral>
   */
  defaultPath: _propTypes2.default.any,

  /**
   * @type boolean
   */
  defaultVisible: _propTypes2.default.bool,

  /**
   * @type boolean
   */
  draggable: _propTypes2.default.bool,

  /**
   * @type boolean
   */
  editable: _propTypes2.default.bool,

  /**
   * @type PolylineOptions
   */
  options: _propTypes2.default.any,

  /**
   * @type MVCArray<LatLng>|Array<LatLng|LatLngLiteral>
   */
  path: _propTypes2.default.any,

  /**
   * @type boolean
   */
  visible: _propTypes2.default.bool,

  /**
   * function
   */
  onDblClick: _propTypes2.default.func,

  /**
   * function
   */
  onDragEnd: _propTypes2.default.func,

  /**
   * function
   */
  onDragStart: _propTypes2.default.func,

  /**
   * function
   */
  onMouseDown: _propTypes2.default.func,

  /**
   * function
   */
  onMouseMove: _propTypes2.default.func,

  /**
   * function
   */
  onMouseOut: _propTypes2.default.func,

  /**
   * function
   */
  onMouseOver: _propTypes2.default.func,

  /**
   * function
   */
  onMouseUp: _propTypes2.default.func,

  /**
   * function
   */
  onRightClick: _propTypes2.default.func,

  /**
   * function
   */
  onClick: _propTypes2.default.func,

  /**
   * function
   */
  onDrag: _propTypes2.default.func,
}
Polyline.contextTypes = (0, _defineProperty3.default)(
  {},
  _constants.MAP,
  _propTypes2.default.object
)
exports.default = Polyline

var eventMap = {
  onDblClick: "dblclick",
  onDragEnd: "dragend",
  onDragStart: "dragstart",
  onMouseDown: "mousedown",
  onMouseMove: "mousemove",
  onMouseOut: "mouseout",
  onMouseOver: "mouseover",
  onMouseUp: "mouseup",
  onRightClick: "rightclick",
  onClick: "click",
  onDrag: "drag",
}

var updaterMap = {
  draggable: function draggable(instance, _draggable) {
    instance.setDraggable(_draggable)
  },
  editable: function editable(instance, _editable) {
    instance.setEditable(_editable)
  },
  options: function options(instance, _options) {
    instance.setOptions(_options)
  },
  path: function path(instance, _path) {
    instance.setPath(_path)
  },
  visible: function visible(instance, _visible) {
    instance.setVisible(_visible)
  },
}


/***/ }),
/* 904 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true,
})
exports.Polygon = undefined

var _defineProperty2 = __webpack_require__(31)

var _defineProperty3 = _interopRequireDefault(_defineProperty2)

var _getPrototypeOf = __webpack_require__(25)

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf)

var _classCallCheck2 = __webpack_require__(26)

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2)

var _createClass2 = __webpack_require__(27)

var _createClass3 = _interopRequireDefault(_createClass2)

var _possibleConstructorReturn2 = __webpack_require__(28)

var _possibleConstructorReturn3 = _interopRequireDefault(
  _possibleConstructorReturn2
)

var _inherits2 = __webpack_require__(29)

var _inherits3 = _interopRequireDefault(_inherits2)

var _react = __webpack_require__(0)

var _react2 = _interopRequireDefault(_react)

var _propTypes = __webpack_require__(1)

var _propTypes2 = _interopRequireDefault(_propTypes)

var _MapChildHelper = __webpack_require__(35)

var _constants = __webpack_require__(32)

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj }
}

/**
 * A wrapper around `google.maps.Polygon`
 *
 * @see https://developers.google.com/maps/documentation/javascript/3.exp/reference#Polygon
 */
/*
 * -----------------------------------------------------------------------------
 * This file is auto-generated from the corresponding file at `src/macros/`.
 * Please **DO NOT** edit this file directly when creating PRs.
 * -----------------------------------------------------------------------------
 */
/* global google */
var Polygon = (exports.Polygon = (function(_React$PureComponent) {
  ;(0, _inherits3.default)(Polygon, _React$PureComponent)

  /*
   * @see https://developers.google.com/maps/documentation/javascript/3.exp/reference#Polygon
   */
  function Polygon(props, context) {
    ;(0, _classCallCheck3.default)(this, Polygon)

    var _this = (0, _possibleConstructorReturn3.default)(
      this,
      (Polygon.__proto__ || (0, _getPrototypeOf2.default)(Polygon)).call(
        this,
        props,
        context
      )
    )

    var polygon = new google.maps.Polygon()
    ;(0, _MapChildHelper.construct)(
      Polygon.propTypes,
      updaterMap,
      _this.props,
      polygon
    )
    polygon.setMap(_this.context[_constants.MAP])
    _this.state = (0, _defineProperty3.default)({}, _constants.POLYGON, polygon)
    return _this
  }

  ;(0, _createClass3.default)(Polygon, [
    {
      key: "componentDidMount",
      value: function componentDidMount() {
        ;(0, _MapChildHelper.componentDidMount)(
          this,
          this.state[_constants.POLYGON],
          eventMap
        )
      },
    },
    {
      key: "componentDidUpdate",
      value: function componentDidUpdate(prevProps) {
        ;(0, _MapChildHelper.componentDidUpdate)(
          this,
          this.state[_constants.POLYGON],
          eventMap,
          updaterMap,
          prevProps
        )
      },
    },
    {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        ;(0, _MapChildHelper.componentWillUnmount)(this)
        var polygon = this.state[_constants.POLYGON]
        if (polygon) {
          polygon.setMap(null)
        }
      },
    },
    {
      key: "render",
      value: function render() {
        return false
      },

      /**
       * Returns whether this shape can be dragged by the user.
       * @type boolean
       * @public
       */
    },
    {
      key: "getDraggable",
      value: function getDraggable() {
        return this.state[_constants.POLYGON].getDraggable()
      },

      /**
       * Returns whether this shape can be edited by the user.
       * @type boolean
       * @public
       */
    },
    {
      key: "getEditable",
      value: function getEditable() {
        return this.state[_constants.POLYGON].getEditable()
      },

      /**
       * Retrieves the first path.
       * @type MVCArray<LatLng>
       * @public
       */
    },
    {
      key: "getPath",
      value: function getPath() {
        return this.state[_constants.POLYGON].getPath()
      },

      /**
       * Retrieves the paths for this polygon.
       * @type MVCArray<MVCArray<LatLng>>
       * @public
       */
    },
    {
      key: "getPaths",
      value: function getPaths() {
        return this.state[_constants.POLYGON].getPaths()
      },

      /**
       * Returns whether this poly is visible on the map.
       * @type boolean
       * @public
       */
    },
    {
      key: "getVisible",
      value: function getVisible() {
        return this.state[_constants.POLYGON].getVisible()
      },
    },
  ])
  return Polygon
})(_react2.default.PureComponent))

Polygon.propTypes = {
  /**
   * @type boolean
   */
  defaultDraggable: _propTypes2.default.bool,

  /**
   * @type boolean
   */
  defaultEditable: _propTypes2.default.bool,

  /**
   * @type PolygonOptions
   */
  defaultOptions: _propTypes2.default.any,

  /**
   * @type MVCArray<LatLng>|Array<LatLng|LatLngLiteral>
   */
  defaultPath: _propTypes2.default.any,

  /**
   * @type MVCArray<MVCArray<LatLng>>|MVCArray<LatLng>|Array<Array<LatLng|LatLngLiteral>>|Array<LatLng|LatLngLiteral>
   */
  defaultPaths: _propTypes2.default.any,

  /**
   * @type boolean
   */
  defaultVisible: _propTypes2.default.bool,

  /**
   * @type boolean
   */
  draggable: _propTypes2.default.bool,

  /**
   * @type boolean
   */
  editable: _propTypes2.default.bool,

  /**
   * @type PolygonOptions
   */
  options: _propTypes2.default.any,

  /**
   * @type MVCArray<LatLng>|Array<LatLng|LatLngLiteral>
   */
  path: _propTypes2.default.any,

  /**
   * @type MVCArray<MVCArray<LatLng>>|MVCArray<LatLng>|Array<Array<LatLng|LatLngLiteral>>|Array<LatLng|LatLngLiteral>
   */
  paths: _propTypes2.default.any,

  /**
   * @type boolean
   */
  visible: _propTypes2.default.bool,

  /**
   * function
   */
  onDblClick: _propTypes2.default.func,

  /**
   * function
   */
  onDragEnd: _propTypes2.default.func,

  /**
   * function
   */
  onDragStart: _propTypes2.default.func,

  /**
   * function
   */
  onMouseDown: _propTypes2.default.func,

  /**
   * function
   */
  onMouseMove: _propTypes2.default.func,

  /**
   * function
   */
  onMouseOut: _propTypes2.default.func,

  /**
   * function
   */
  onMouseOver: _propTypes2.default.func,

  /**
   * function
   */
  onMouseUp: _propTypes2.default.func,

  /**
   * function
   */
  onRightClick: _propTypes2.default.func,

  /**
   * function
   */
  onClick: _propTypes2.default.func,

  /**
   * function
   */
  onDrag: _propTypes2.default.func,
}
Polygon.contextTypes = (0, _defineProperty3.default)(
  {},
  _constants.MAP,
  _propTypes2.default.object
)
exports.default = Polygon

var eventMap = {
  onDblClick: "dblclick",
  onDragEnd: "dragend",
  onDragStart: "dragstart",
  onMouseDown: "mousedown",
  onMouseMove: "mousemove",
  onMouseOut: "mouseout",
  onMouseOver: "mouseover",
  onMouseUp: "mouseup",
  onRightClick: "rightclick",
  onClick: "click",
  onDrag: "drag",
}

var updaterMap = {
  draggable: function draggable(instance, _draggable) {
    instance.setDraggable(_draggable)
  },
  editable: function editable(instance, _editable) {
    instance.setEditable(_editable)
  },
  options: function options(instance, _options) {
    instance.setOptions(_options)
  },
  path: function path(instance, _path) {
    instance.setPath(_path)
  },
  paths: function paths(instance, _paths) {
    instance.setPaths(_paths)
  },
  visible: function visible(instance, _visible) {
    instance.setVisible(_visible)
  },
}


/***/ }),
/* 905 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true,
})
exports.Rectangle = undefined

var _defineProperty2 = __webpack_require__(31)

var _defineProperty3 = _interopRequireDefault(_defineProperty2)

var _getPrototypeOf = __webpack_require__(25)

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf)

var _classCallCheck2 = __webpack_require__(26)

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2)

var _createClass2 = __webpack_require__(27)

var _createClass3 = _interopRequireDefault(_createClass2)

var _possibleConstructorReturn2 = __webpack_require__(28)

var _possibleConstructorReturn3 = _interopRequireDefault(
  _possibleConstructorReturn2
)

var _inherits2 = __webpack_require__(29)

var _inherits3 = _interopRequireDefault(_inherits2)

var _react = __webpack_require__(0)

var _react2 = _interopRequireDefault(_react)

var _propTypes = __webpack_require__(1)

var _propTypes2 = _interopRequireDefault(_propTypes)

var _MapChildHelper = __webpack_require__(35)

var _constants = __webpack_require__(32)

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj }
}

/**
 * A wrapper around `google.maps.Rectangle`
 *
 * @see https://developers.google.com/maps/documentation/javascript/3.exp/reference#Rectangle
 */
/*
 * -----------------------------------------------------------------------------
 * This file is auto-generated from the corresponding file at `src/macros/`.
 * Please **DO NOT** edit this file directly when creating PRs.
 * -----------------------------------------------------------------------------
 */
/* global google */
var Rectangle = (exports.Rectangle = (function(_React$PureComponent) {
  ;(0, _inherits3.default)(Rectangle, _React$PureComponent)

  /*
   * @see https://developers.google.com/maps/documentation/javascript/3.exp/reference#Rectangle
   */
  function Rectangle(props, context) {
    ;(0, _classCallCheck3.default)(this, Rectangle)

    var _this = (0, _possibleConstructorReturn3.default)(
      this,
      (Rectangle.__proto__ || (0, _getPrototypeOf2.default)(Rectangle)).call(
        this,
        props,
        context
      )
    )

    var rectangle = new google.maps.Rectangle()
    ;(0, _MapChildHelper.construct)(
      Rectangle.propTypes,
      updaterMap,
      _this.props,
      rectangle
    )
    rectangle.setMap(_this.context[_constants.MAP])
    _this.state = (0, _defineProperty3.default)(
      {},
      _constants.RECTANGLE,
      rectangle
    )
    return _this
  }

  ;(0, _createClass3.default)(Rectangle, [
    {
      key: "componentDidMount",
      value: function componentDidMount() {
        ;(0, _MapChildHelper.componentDidMount)(
          this,
          this.state[_constants.RECTANGLE],
          eventMap
        )
      },
    },
    {
      key: "componentDidUpdate",
      value: function componentDidUpdate(prevProps) {
        ;(0, _MapChildHelper.componentDidUpdate)(
          this,
          this.state[_constants.RECTANGLE],
          eventMap,
          updaterMap,
          prevProps
        )
      },
    },
    {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        ;(0, _MapChildHelper.componentWillUnmount)(this)
        var rectangle = this.state[_constants.RECTANGLE]
        if (rectangle) {
          rectangle.setMap(null)
        }
      },
    },
    {
      key: "render",
      value: function render() {
        return false
      },

      /**
       * Returns the bounds of this rectangle.
       * @type LatLngBounds
       * @public
       */
    },
    {
      key: "getBounds",
      value: function getBounds() {
        return this.state[_constants.RECTANGLE].getBounds()
      },

      /**
       * Returns whether this rectangle can be dragged by the user.
       * @type boolean
       * @public
       */
    },
    {
      key: "getDraggable",
      value: function getDraggable() {
        return this.state[_constants.RECTANGLE].getDraggable()
      },

      /**
       * Returns whether this rectangle can be edited by the user.
       * @type boolean
       * @public
       */
    },
    {
      key: "getEditable",
      value: function getEditable() {
        return this.state[_constants.RECTANGLE].getEditable()
      },

      /**
       * Returns whether this rectangle is visible on the map.
       * @type boolean
       * @public
       */
    },
    {
      key: "getVisible",
      value: function getVisible() {
        return this.state[_constants.RECTANGLE].getVisible()
      },
    },
  ])
  return Rectangle
})(_react2.default.PureComponent))

Rectangle.propTypes = {
  /**
   * @type LatLngBounds|LatLngBoundsLiteral
   */
  defaultBounds: _propTypes2.default.any,

  /**
   * @type boolean
   */
  defaultDraggable: _propTypes2.default.bool,

  /**
   * @type boolean
   */
  defaultEditable: _propTypes2.default.bool,

  /**
   * @type RectangleOptions
   */
  defaultOptions: _propTypes2.default.any,

  /**
   * @type boolean
   */
  defaultVisible: _propTypes2.default.bool,

  /**
   * @type LatLngBounds|LatLngBoundsLiteral
   */
  bounds: _propTypes2.default.any,

  /**
   * @type boolean
   */
  draggable: _propTypes2.default.bool,

  /**
   * @type boolean
   */
  editable: _propTypes2.default.bool,

  /**
   * @type RectangleOptions
   */
  options: _propTypes2.default.any,

  /**
   * @type boolean
   */
  visible: _propTypes2.default.bool,

  /**
   * function
   */
  onDblClick: _propTypes2.default.func,

  /**
   * function
   */
  onDragEnd: _propTypes2.default.func,

  /**
   * function
   */
  onDragStart: _propTypes2.default.func,

  /**
   * function
   */
  onMouseDown: _propTypes2.default.func,

  /**
   * function
   */
  onMouseMove: _propTypes2.default.func,

  /**
   * function
   */
  onMouseOut: _propTypes2.default.func,

  /**
   * function
   */
  onMouseOver: _propTypes2.default.func,

  /**
   * function
   */
  onMouseUp: _propTypes2.default.func,

  /**
   * function
   */
  onRightClick: _propTypes2.default.func,

  /**
   * function
   */
  onBoundsChanged: _propTypes2.default.func,

  /**
   * function
   */
  onClick: _propTypes2.default.func,

  /**
   * function
   */
  onDrag: _propTypes2.default.func,
}
Rectangle.contextTypes = (0, _defineProperty3.default)(
  {},
  _constants.MAP,
  _propTypes2.default.object
)
exports.default = Rectangle

var eventMap = {
  onDblClick: "dblclick",
  onDragEnd: "dragend",
  onDragStart: "dragstart",
  onMouseDown: "mousedown",
  onMouseMove: "mousemove",
  onMouseOut: "mouseout",
  onMouseOver: "mouseover",
  onMouseUp: "mouseup",
  onRightClick: "rightclick",
  onBoundsChanged: "bounds_changed",
  onClick: "click",
  onDrag: "drag",
}

var updaterMap = {
  bounds: function bounds(instance, _bounds) {
    instance.setBounds(_bounds)
  },
  draggable: function draggable(instance, _draggable) {
    instance.setDraggable(_draggable)
  },
  editable: function editable(instance, _editable) {
    instance.setEditable(_editable)
  },
  options: function options(instance, _options) {
    instance.setOptions(_options)
  },
  visible: function visible(instance, _visible) {
    instance.setVisible(_visible)
  },
}


/***/ }),
/* 906 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true,
})
exports.InfoWindow = undefined

var _defineProperty2 = __webpack_require__(31)

var _defineProperty3 = _interopRequireDefault(_defineProperty2)

var _getPrototypeOf = __webpack_require__(25)

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf)

var _classCallCheck2 = __webpack_require__(26)

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2)

var _createClass2 = __webpack_require__(27)

var _createClass3 = _interopRequireDefault(_createClass2)

var _possibleConstructorReturn2 = __webpack_require__(28)

var _possibleConstructorReturn3 = _interopRequireDefault(
  _possibleConstructorReturn2
)

var _inherits2 = __webpack_require__(29)

var _inherits3 = _interopRequireDefault(_inherits2)

var _InfoWindow$contextTy /*
                            * -----------------------------------------------------------------------------
                            * This file is auto-generated from the corresponding file at `src/macros/`.
                            * Please **DO NOT** edit this file directly when creating PRs.
                            * -----------------------------------------------------------------------------
                            */
/* global google */

var _invariant = __webpack_require__(30)

var _invariant2 = _interopRequireDefault(_invariant)

var _canUseDom = __webpack_require__(332)

var _canUseDom2 = _interopRequireDefault(_canUseDom)

var _react = __webpack_require__(0)

var _react2 = _interopRequireDefault(_react)

var _reactDom = __webpack_require__(24)

var _reactDom2 = _interopRequireDefault(_reactDom)

var _propTypes = __webpack_require__(1)

var _propTypes2 = _interopRequireDefault(_propTypes)

var _MapChildHelper = __webpack_require__(35)

var _constants = __webpack_require__(32)

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj }
}

/**
 * A wrapper around `google.maps.InfoWindow`
 *
 * @see https://developers.google.com/maps/documentation/javascript/3.exp/reference#InfoWindow
 */
var InfoWindow = (exports.InfoWindow = (function(_React$PureComponent) {
  ;(0, _inherits3.default)(InfoWindow, _React$PureComponent)

  /*
   * @see https://developers.google.com/maps/documentation/javascript/3.exp/reference#InfoWindow
   */
  function InfoWindow(props, context) {
    ;(0, _classCallCheck3.default)(this, InfoWindow)

    var _this = (0, _possibleConstructorReturn3.default)(
      this,
      (InfoWindow.__proto__ || (0, _getPrototypeOf2.default)(InfoWindow)).call(
        this,
        props,
        context
      )
    )

    var infoWindow = new google.maps.InfoWindow()
    ;(0, _MapChildHelper.construct)(
      InfoWindow.propTypes,
      updaterMap,
      _this.props,
      infoWindow
    )
    infoWindow.setMap(_this.context[_constants.MAP])
    _this.state = (0, _defineProperty3.default)(
      {},
      _constants.INFO_WINDOW,
      infoWindow
    )
    return _this
  }

  ;(0, _createClass3.default)(InfoWindow, [
    {
      key: "componentWillMount",
      value: function componentWillMount() {
        if (!_canUseDom2.default || this.containerElement) {
          return
        }
        if (_react2.default.version.match(/^16/)) {
          this.containerElement = document.createElement("div")
        }
      },
    },
    {
      key: "componentDidMount",
      value: function componentDidMount() {
        ;(0, _MapChildHelper.componentDidMount)(
          this,
          this.state[_constants.INFO_WINDOW],
          eventMap
        )
        if (_react2.default.version.match(/^16/)) {
          this.state[_constants.INFO_WINDOW].setContent(this.containerElement)
          open(
            this.state[_constants.INFO_WINDOW],
            this.context[_constants.ANCHOR]
          )
          return
        }
        var content = document.createElement("div")
        _reactDom2.default.unstable_renderSubtreeIntoContainer(
          this,
          _react2.default.Children.only(this.props.children),
          content
        )
        this.state[_constants.INFO_WINDOW].setContent(content)
        open(
          this.state[_constants.INFO_WINDOW],
          this.context[_constants.ANCHOR]
        )
      },
    },
    {
      key: "componentDidUpdate",
      value: function componentDidUpdate(prevProps) {
        ;(0, _MapChildHelper.componentDidUpdate)(
          this,
          this.state[_constants.INFO_WINDOW],
          eventMap,
          updaterMap,
          prevProps
        )
        if (_react2.default.version.match(/^16/)) {
          return
        }
        if (this.props.children !== prevProps.children) {
          _reactDom2.default.unstable_renderSubtreeIntoContainer(
            this,
            _react2.default.Children.only(this.props.children),
            this.state[_constants.INFO_WINDOW].getContent()
          )
        }
      },
    },
    {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        ;(0, _MapChildHelper.componentWillUnmount)(this)
        var infoWindow = this.state[_constants.INFO_WINDOW]
        if (infoWindow) {
          if (
            !_react2.default.version.match(/^16/) &&
            infoWindow.getContent()
          ) {
            _reactDom2.default.unmountComponentAtNode(infoWindow.getContent())
          }
          infoWindow.setMap(null)
        }
      },
    },
    {
      key: "render",
      value: function render() {
        if (_react2.default.version.match(/^16/)) {
          return _reactDom2.default.createPortal(
            _react2.default.Children.only(this.props.children),
            this.containerElement
          )
        }
        return false
      },

      /**
       *
       * @type LatLng
       * @public
       */
    },
    {
      key: "getPosition",
      value: function getPosition() {
        return this.state[_constants.INFO_WINDOW].getPosition()
      },

      /**
       *
       * @type number
       * @public
       */
    },
    {
      key: "getZIndex",
      value: function getZIndex() {
        return this.state[_constants.INFO_WINDOW].getZIndex()
      },
    },
  ])
  return InfoWindow
})(_react2.default.PureComponent))

InfoWindow.propTypes = {
  /**
   * @type InfoWindowOptions
   */
  defaultOptions: _propTypes2.default.any,

  /**
   * @type LatLng|LatLngLiteral
   */
  defaultPosition: _propTypes2.default.any,

  /**
   * @type number
   */
  defaultZIndex: _propTypes2.default.number,

  /**
   * @type InfoWindowOptions
   */
  options: _propTypes2.default.any,

  /**
   * @type LatLng|LatLngLiteral
   */
  position: _propTypes2.default.any,

  /**
   * @type number
   */
  zIndex: _propTypes2.default.number,

  /**
   * function
   */
  onCloseClick: _propTypes2.default.func,

  /**
   * function
   */
  onDomReady: _propTypes2.default.func,

  /**
   * function
   */
  onContentChanged: _propTypes2.default.func,

  /**
   * function
   */
  onPositionChanged: _propTypes2.default.func,

  /**
   * function
   */
  onZindexChanged: _propTypes2.default.func,
}
InfoWindow.contextTypes = ((_InfoWindow$contextTy = {}),
(0, _defineProperty3.default)(
  _InfoWindow$contextTy,
  _constants.MAP,
  _propTypes2.default.object
),
(0, _defineProperty3.default)(
  _InfoWindow$contextTy,
  _constants.ANCHOR,
  _propTypes2.default.object
),
_InfoWindow$contextTy)
exports.default = InfoWindow

var open = function open(infoWindow, anchor) {
  if (anchor) {
    infoWindow.open(infoWindow.getMap(), anchor)
  } else if (infoWindow.getPosition()) {
    infoWindow.open(infoWindow.getMap())
  } else {
    ;(0, _invariant2.default)(
      false,
      "You must provide either an anchor (typically render it inside a <Marker>) or a position props for <InfoWindow>."
    )
  }
}

var eventMap = {
  onCloseClick: "closeclick",
  onDomReady: "domready",
  onContentChanged: "content_changed",
  onPositionChanged: "position_changed",
  onZindexChanged: "zindex_changed",
}

var updaterMap = {
  options: function options(instance, _options) {
    instance.setOptions(_options)
  },
  position: function position(instance, _position) {
    instance.setPosition(_position)
  },
  zIndex: function zIndex(instance, _zIndex) {
    instance.setZIndex(_zIndex)
  },
}


/***/ }),
/* 907 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true,
})
exports.OverlayView = undefined

var _extends2 = __webpack_require__(908)

var _extends3 = _interopRequireDefault(_extends2)

var _defineProperty2 = __webpack_require__(31)

var _defineProperty3 = _interopRequireDefault(_defineProperty2)

var _getPrototypeOf = __webpack_require__(25)

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf)

var _classCallCheck2 = __webpack_require__(26)

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2)

var _createClass2 = __webpack_require__(27)

var _createClass3 = _interopRequireDefault(_createClass2)

var _possibleConstructorReturn2 = __webpack_require__(28)

var _possibleConstructorReturn3 = _interopRequireDefault(
  _possibleConstructorReturn2
)

var _inherits2 = __webpack_require__(29)

var _inherits3 = _interopRequireDefault(_inherits2)

var _delay2 = __webpack_require__(913)

var _delay3 = _interopRequireDefault(_delay2)

var _assign2 = __webpack_require__(915)

var _assign3 = _interopRequireDefault(_assign2)

var _bind2 = __webpack_require__(142)

var _bind3 = _interopRequireDefault(_bind2)

var _OverlayView$contextT /*
                            * -----------------------------------------------------------------------------
                            * This file is auto-generated from the corresponding file at `src/macros/`.
                            * Please **DO NOT** edit this file directly when creating PRs.
                            * -----------------------------------------------------------------------------
                            */
/* global google */

var _invariant = __webpack_require__(30)

var _invariant2 = _interopRequireDefault(_invariant)

var _react = __webpack_require__(0)

var _react2 = _interopRequireDefault(_react)

var _reactDom = __webpack_require__(24)

var _reactDom2 = _interopRequireDefault(_reactDom)

var _propTypes = __webpack_require__(1)

var _propTypes2 = _interopRequireDefault(_propTypes)

var _MapChildHelper = __webpack_require__(35)

var _OverlayViewHelper = __webpack_require__(919)

var _constants = __webpack_require__(32)

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj }
}

/**
 * A wrapper around `google.maps.OverlayView`
 *
 * @see https://developers.google.com/maps/documentation/javascript/3.exp/reference#OverlayView
 */
var OverlayView = (exports.OverlayView = (function(_React$PureComponent) {
  ;(0, _inherits3.default)(OverlayView, _React$PureComponent)

  /*
   * @see https://developers.google.com/maps/documentation/javascript/3.exp/reference#OverlayView
   */
  function OverlayView(props, context) {
    ;(0, _classCallCheck3.default)(this, OverlayView)

    var _this = (0, _possibleConstructorReturn3.default)(
      this,
      (
        OverlayView.__proto__ || (0, _getPrototypeOf2.default)(OverlayView)
      ).call(this, props, context)
    )

    var overlayView = new google.maps.OverlayView()
    // You must implement three methods: onAdd(), draw(), and onRemove().
    overlayView.onAdd = (0, _bind3.default)(_this.onAdd, _this)
    overlayView.draw = (0, _bind3.default)(_this.draw, _this)
    overlayView.onRemove = (0, _bind3.default)(_this.onRemove, _this)
    _this.onPositionElement = (0, _bind3.default)(
      _this.onPositionElement,
      _this
    )
    // You must call setMap() with a valid Map object to trigger the call to
    // the onAdd() method and setMap(null) in order to trigger the onRemove() method.
    overlayView.setMap(_this.context[_constants.MAP])
    _this.state = (0, _defineProperty3.default)(
      {},
      _constants.OVERLAY_VIEW,
      overlayView
    )
    return _this
  }

  ;(0, _createClass3.default)(OverlayView, [
    {
      key: "onAdd",
      value: function onAdd() {
        this.containerElement = document.createElement("div")
        this.containerElement.style.position = "absolute"
      },
    },
    {
      key: "draw",
      value: function draw() {
        var mapPaneName = this.props.mapPaneName

        ;(0, _invariant2.default)(
          !!mapPaneName,
          "OverlayView requires either props.mapPaneName or props.defaultMapPaneName but got %s",
          mapPaneName
        )
        // https://developers.google.com/maps/documentation/javascript/3.exp/reference#MapPanes
        var mapPanes = this.state[_constants.OVERLAY_VIEW].getPanes()
        mapPanes[mapPaneName].appendChild(this.containerElement)

        _reactDom2.default.unstable_renderSubtreeIntoContainer(
          this,
          _react2.default.Children.only(this.props.children),
          this.containerElement,
          this.onPositionElement
        )
      },
    },
    {
      key: "onPositionElement",
      value: function onPositionElement() {
        // https://developers.google.com/maps/documentation/javascript/3.exp/reference#MapCanvasProjection
        var mapCanvasProjection = this.state[
          _constants.OVERLAY_VIEW
        ].getProjection()

        var offset = (0, _extends3.default)(
          {
            x: 0,
            y: 0,
          },
          (0, _OverlayViewHelper.getOffsetOverride)(
            this.containerElement,
            this.props
          )
        )
        var layoutStyles = (0, _OverlayViewHelper.getLayoutStyles)(
          mapCanvasProjection,
          offset,
          this.props
        )
        ;(0, _assign3.default)(this.containerElement.style, layoutStyles)
      },
    },
    {
      key: "onRemove",
      value: function onRemove() {
        this.containerElement.parentNode.removeChild(this.containerElement)
        _reactDom2.default.unmountComponentAtNode(this.containerElement)
        this.containerElement = null
      },
    },
    {
      key: "componentDidMount",
      value: function componentDidMount() {
        ;(0, _MapChildHelper.componentDidMount)(
          this,
          this.state[_constants.OVERLAY_VIEW],
          eventMap
        )
      },
    },
    {
      key: "componentDidUpdate",
      value: function componentDidUpdate(prevProps) {
        ;(0, _MapChildHelper.componentDidUpdate)(
          this,
          this.state[_constants.OVERLAY_VIEW],
          eventMap,
          updaterMap,
          prevProps
        )
        ;(0, _delay3.default)(this.state[_constants.OVERLAY_VIEW].draw)
      },
    },
    {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        ;(0, _MapChildHelper.componentWillUnmount)(this)
        var overlayView = this.state[_constants.OVERLAY_VIEW]
        if (overlayView) {
          overlayView.setMap(null)
          // You must implement three methods: onAdd(), draw(), and onRemove().
          overlayView.onAdd = null
          overlayView.draw = null
          overlayView.onRemove = null
        }
      },
    },
    {
      key: "render",
      value: function render() {
        return false
      },

      /**
       * Returns the panes in which this OverlayView can be rendered. The panes are not initialized until `onAdd` is called by the API.
       * @type MapPanesonAdd
       * @public
       */
    },
    {
      key: "getPanes",
      value: function getPanes() {
        return this.state[_constants.OVERLAY_VIEW].getPanes()
      },

      /**
       * Returns the `MapCanvasProjection` object associated with this `OverlayView`. The projection is not initialized until `onAdd` is called by the API.
       * @type MapCanvasProjectionMapCanvasProjectionOverlayViewonAdd
       * @public
       */
    },
    {
      key: "getProjection",
      value: function getProjection() {
        return this.state[_constants.OVERLAY_VIEW].getProjection()
      },
    },
  ])
  return OverlayView
})(_react2.default.PureComponent))

OverlayView.FLOAT_PANE = "floatPane"
OverlayView.MAP_PANE = "mapPane"
OverlayView.MARKER_LAYER = "markerLayer"
OverlayView.OVERLAY_LAYER = "overlayLayer"
OverlayView.OVERLAY_MOUSE_TARGET = "overlayMouseTarget"
OverlayView.propTypes = {
  /**
   * @see https://developers.google.com/maps/documentation/javascript/3.exp/reference#OverlayView
   */
  mapPaneName: _propTypes2.default.string,

  /**
   * @see https://developers.google.com/maps/documentation/javascript/3.exp/reference#OverlayView
   */
  position: _propTypes2.default.object,

  /**
   * @see https://developers.google.com/maps/documentation/javascript/3.exp/reference#OverlayView
   */
  bounds: _propTypes2.default.object,

  /**
   * @see https://developers.google.com/maps/documentation/javascript/3.exp/reference#OverlayView
   */
  children: _propTypes2.default.node.isRequired,

  /**
   * @see https://developers.google.com/maps/documentation/javascript/3.exp/reference#OverlayView
   */
  getPixelPositionOffset: _propTypes2.default.func,
}
OverlayView.contextTypes = ((_OverlayView$contextT = {}),
(0, _defineProperty3.default)(
  _OverlayView$contextT,
  _constants.MAP,
  _propTypes2.default.object
),
(0, _defineProperty3.default)(
  _OverlayView$contextT,
  _constants.ANCHOR,
  _propTypes2.default.object
),
_OverlayView$contextT)
exports.default = OverlayView

var eventMap = {}

var updaterMap = {}


/***/ }),
/* 908 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _assign = __webpack_require__(909);

var _assign2 = _interopRequireDefault(_assign);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _assign2.default || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

/***/ }),
/* 909 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(910), __esModule: true };

/***/ }),
/* 910 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(911);
module.exports = __webpack_require__(42).Object.assign;


/***/ }),
/* 911 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.1 Object.assign(target, source)
var $export = __webpack_require__(57);

$export($export.S + $export.F, 'Object', { assign: __webpack_require__(912) });


/***/ }),
/* 912 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.2.1 Object.assign(target, source, ...)
var DESCRIPTORS = __webpack_require__(59);
var getKeys = __webpack_require__(140);
var gOPS = __webpack_require__(204);
var pIE = __webpack_require__(141);
var toObject = __webpack_require__(108);
var IObject = __webpack_require__(309);
var $assign = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$assign || __webpack_require__(83)(function () {
  var A = {};
  var B = {};
  // eslint-disable-next-line no-undef
  var S = Symbol();
  var K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function (k) { B[k] = k; });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
  var T = toObject(target);
  var aLen = arguments.length;
  var index = 1;
  var getSymbols = gOPS.f;
  var isEnum = pIE.f;
  while (aLen > index) {
    var S = IObject(arguments[index++]);
    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) {
      key = keys[j++];
      if (!DESCRIPTORS || isEnum.call(S, key)) T[key] = S[key];
    }
  } return T;
} : $assign;


/***/ }),
/* 913 */
/***/ (function(module, exports, __webpack_require__) {

var baseDelay = __webpack_require__(914),
    baseRest = __webpack_require__(205),
    toNumber = __webpack_require__(331);

/**
 * Invokes `func` after `wait` milliseconds. Any additional arguments are
 * provided to `func` when it's invoked.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to delay.
 * @param {number} wait The number of milliseconds to delay invocation.
 * @param {...*} [args] The arguments to invoke `func` with.
 * @returns {number} Returns the timer id.
 * @example
 *
 * _.delay(function(text) {
 *   console.log(text);
 * }, 1000, 'later');
 * // => Logs 'later' after one second.
 */
var delay = baseRest(function(func, wait, args) {
  return baseDelay(func, toNumber(wait) || 0, args);
});

module.exports = delay;


/***/ }),
/* 914 */
/***/ (function(module, exports) {

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * The base implementation of `_.delay` and `_.defer` which accepts `args`
 * to provide to `func`.
 *
 * @private
 * @param {Function} func The function to delay.
 * @param {number} wait The number of milliseconds to delay invocation.
 * @param {Array} args The arguments to provide to `func`.
 * @returns {number|Object} Returns the timer id or timeout object.
 */
function baseDelay(func, wait, args) {
  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  return setTimeout(function() { func.apply(undefined, args); }, wait);
}

module.exports = baseDelay;


/***/ }),
/* 915 */
/***/ (function(module, exports, __webpack_require__) {

var assignValue = __webpack_require__(350),
    copyObject = __webpack_require__(916),
    createAssigner = __webpack_require__(917),
    isArrayLike = __webpack_require__(150),
    isPrototype = __webpack_require__(339),
    keys = __webpack_require__(149);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Assigns own enumerable string keyed properties of source objects to the
 * destination object. Source objects are applied from left to right.
 * Subsequent sources overwrite property assignments of previous sources.
 *
 * **Note:** This method mutates `object` and is loosely based on
 * [`Object.assign`](https://mdn.io/Object/assign).
 *
 * @static
 * @memberOf _
 * @since 0.10.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @see _.assignIn
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * function Bar() {
 *   this.c = 3;
 * }
 *
 * Foo.prototype.b = 2;
 * Bar.prototype.d = 4;
 *
 * _.assign({ 'a': 0 }, new Foo, new Bar);
 * // => { 'a': 1, 'c': 3 }
 */
var assign = createAssigner(function(object, source) {
  if (isPrototype(source) || isArrayLike(source)) {
    copyObject(source, keys(source), object);
    return;
  }
  for (var key in source) {
    if (hasOwnProperty.call(source, key)) {
      assignValue(object, key, source[key]);
    }
  }
});

module.exports = assign;


/***/ }),
/* 916 */
/***/ (function(module, exports, __webpack_require__) {

var assignValue = __webpack_require__(350),
    baseAssignValue = __webpack_require__(351);

/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */
function copyObject(source, props, object, customizer) {
  var isNew = !object;
  object || (object = {});

  var index = -1,
      length = props.length;

  while (++index < length) {
    var key = props[index];

    var newValue = customizer
      ? customizer(object[key], source[key], key, object, source)
      : undefined;

    if (newValue === undefined) {
      newValue = source[key];
    }
    if (isNew) {
      baseAssignValue(object, key, newValue);
    } else {
      assignValue(object, key, newValue);
    }
  }
  return object;
}

module.exports = copyObject;


/***/ }),
/* 917 */
/***/ (function(module, exports, __webpack_require__) {

var baseRest = __webpack_require__(205),
    isIterateeCall = __webpack_require__(918);

/**
 * Creates a function like `_.assign`.
 *
 * @private
 * @param {Function} assigner The function to assign values.
 * @returns {Function} Returns the new assigner function.
 */
function createAssigner(assigner) {
  return baseRest(function(object, sources) {
    var index = -1,
        length = sources.length,
        customizer = length > 1 ? sources[length - 1] : undefined,
        guard = length > 2 ? sources[2] : undefined;

    customizer = (assigner.length > 3 && typeof customizer == 'function')
      ? (length--, customizer)
      : undefined;

    if (guard && isIterateeCall(sources[0], sources[1], guard)) {
      customizer = length < 3 ? undefined : customizer;
      length = 1;
    }
    object = Object(object);
    while (++index < length) {
      var source = sources[index];
      if (source) {
        assigner(object, source, index, customizer);
      }
    }
    return object;
  });
}

module.exports = createAssigner;


/***/ }),
/* 918 */
/***/ (function(module, exports, __webpack_require__) {

var eq = __webpack_require__(153),
    isArrayLike = __webpack_require__(150),
    isIndex = __webpack_require__(146),
    isObject = __webpack_require__(66);

/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */
function isIterateeCall(value, index, object) {
  if (!isObject(object)) {
    return false;
  }
  var type = typeof index;
  if (type == 'number'
        ? (isArrayLike(object) && isIndex(index, object.length))
        : (type == 'string' && index in object)
      ) {
    return eq(object[index], value);
  }
  return false;
}

module.exports = isIterateeCall;


/***/ }),
/* 919 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true,
})

var _isFunction2 = __webpack_require__(143)

var _isFunction3 = _interopRequireDefault(_isFunction2)

exports.getOffsetOverride = getOffsetOverride
exports.getLayoutStyles = getLayoutStyles

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj }
}

/* global google */
function getOffsetOverride(containerElement, props) {
  var getPixelPositionOffset = props.getPixelPositionOffset
  //
  // Allows the component to control the visual position of the OverlayView
  // relative to the LatLng pixel position.
  //

  if ((0, _isFunction3.default)(getPixelPositionOffset)) {
    return getPixelPositionOffset(
      containerElement.offsetWidth,
      containerElement.offsetHeight
    )
  } else {
    return {}
  }
}

function createLatLng(inst, Type) {
  return new Type(inst.lat, inst.lng)
}

function createLatLngBounds(inst, Type) {
  return new Type(
    new google.maps.LatLng(inst.ne.lat, inst.ne.lng),
    new google.maps.LatLng(inst.sw.lat, inst.sw.lng)
  )
}

function ensureOfType(inst, type, factory) {
  if (inst instanceof type) {
    return inst
  } else {
    return factory(inst, type)
  }
}

function getLayoutStylesByBounds(mapCanvasProjection, offset, bounds) {
  var ne = mapCanvasProjection.fromLatLngToDivPixel(bounds.getNorthEast())
  var sw = mapCanvasProjection.fromLatLngToDivPixel(bounds.getSouthWest())
  if (ne && sw) {
    return {
      left: sw.x + offset.x + "px",
      top: ne.y + offset.y + "px",
      width: ne.x - sw.x - offset.x + "px",
      height: sw.y - ne.y - offset.y + "px",
    }
  }
  return {
    left: "-9999px",
    top: "-9999px",
  }
}

function getLayoutStylesByPosition(mapCanvasProjection, offset, position) {
  var point = mapCanvasProjection.fromLatLngToDivPixel(position)
  if (point) {
    var x = point.x,
      y = point.y

    return {
      left: x + offset.x + "px",
      top: y + offset.y + "px",
    }
  }
  return {
    left: "-9999px",
    top: "-9999px",
  }
}

function getLayoutStyles(mapCanvasProjection, offset, props) {
  if (props.bounds) {
    var bounds = ensureOfType(
      props.bounds,
      google.maps.LatLngBounds,
      createLatLngBounds
    )
    return getLayoutStylesByBounds(mapCanvasProjection, offset, bounds)
  } else {
    var position = ensureOfType(
      props.position,
      google.maps.LatLng,
      createLatLng
    )
    return getLayoutStylesByPosition(mapCanvasProjection, offset, position)
  }
}


/***/ }),
/* 920 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true,
})
exports.GroundOverlay = undefined

var _defineProperty2 = __webpack_require__(31)

var _defineProperty3 = _interopRequireDefault(_defineProperty2)

var _getPrototypeOf = __webpack_require__(25)

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf)

var _classCallCheck2 = __webpack_require__(26)

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2)

var _createClass2 = __webpack_require__(27)

var _createClass3 = _interopRequireDefault(_createClass2)

var _possibleConstructorReturn2 = __webpack_require__(28)

var _possibleConstructorReturn3 = _interopRequireDefault(
  _possibleConstructorReturn2
)

var _inherits2 = __webpack_require__(29)

var _inherits3 = _interopRequireDefault(_inherits2)

var _warning = __webpack_require__(334)

var _warning2 = _interopRequireDefault(_warning)

var _react = __webpack_require__(0)

var _react2 = _interopRequireDefault(_react)

var _propTypes = __webpack_require__(1)

var _propTypes2 = _interopRequireDefault(_propTypes)

var _MapChildHelper = __webpack_require__(35)

var _constants = __webpack_require__(32)

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj }
}

/**
 * A wrapper around `google.maps.GroundOverlay`
 *
 * @see https://developers.google.com/maps/documentation/javascript/reference#GroundOverlay
 */
var GroundOverlay = (exports.GroundOverlay = (function(_React$PureComponent) {
  ;(0, _inherits3.default)(GroundOverlay, _React$PureComponent)

  /*
   * @see https://developers.google.com/maps/documentation/javascript/3.exp/reference#GroundOverlay
   */
  function GroundOverlay(props, context) {
    ;(0, _classCallCheck3.default)(this, GroundOverlay)

    var _this = (0, _possibleConstructorReturn3.default)(
      this,
      (
        GroundOverlay.__proto__ || (0, _getPrototypeOf2.default)(GroundOverlay)
      ).call(this, props, context)
    )

    ;(0, _warning2.default)(
      !props.url || !props.bounds,
      "\nFor GroundOveray, url and bounds are passed in to constructor and are immutable\n after iinstantiated. This is the behavior of Google Maps JavaScript API v3 (\n See https://developers.google.com/maps/documentation/javascript/reference#GroundOverlay)\n Hence, use the corresponding two props provided by `react-google-maps`.\n They're prefixed with _default_ (defaultUrl, defaultBounds).\n\n In some cases, you'll need the GroundOverlay component to reflect the changes\n of url and bounds. You can leverage the React's key property to remount the\n component. Typically, just `key={url}` would serve your need.\n See https://github.com/tomchentw/react-google-maps/issues/655\n"
    )
    var groundOverlay = new google.maps.GroundOverlay(
      props.defaultUrl || props.url,
      props.defaultBounds || props.bounds
    )
    ;(0, _MapChildHelper.construct)(
      GroundOverlay.propTypes,
      updaterMap,
      _this.props,
      groundOverlay
    )
    groundOverlay.setMap(_this.context[_constants.MAP])
    _this.state = (0, _defineProperty3.default)(
      {},
      _constants.GROUND_LAYER,
      groundOverlay
    )
    return _this
  }

  ;(0, _createClass3.default)(GroundOverlay, [
    {
      key: "componentDidMount",
      value: function componentDidMount() {
        ;(0, _MapChildHelper.componentDidMount)(
          this,
          this.state[_constants.GROUND_LAYER],
          eventMap
        )
      },
    },
    {
      key: "componentDidUpdate",
      value: function componentDidUpdate(prevProps) {
        ;(0, _MapChildHelper.componentDidUpdate)(
          this,
          this.state[_constants.GROUND_LAYER],
          eventMap,
          updaterMap,
          prevProps
        )
      },
    },
    {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        ;(0, _MapChildHelper.componentWillUnmount)(this)
        var GroundOverlay = this.state[_constants.GROUND_LAYER]
        if (GroundOverlay) {
          GroundOverlay.setMap(null)
        }
      },
    },
    {
      key: "render",
      value: function render() {
        return false
      },

      /**
       * Gets the `LatLngBounds` of this overlay.
       * @type LatLngBoundsLatLngBounds
       * @public
       */
    },
    {
      key: "getBounds",
      value: function getBounds() {
        return this.state[_constants.GROUND_LAYER].getBounds()
      },

      /**
       * Returns the opacity of this ground overlay.
       * @type number
       * @public
       */
    },
    {
      key: "getOpacity",
      value: function getOpacity() {
        return this.state[_constants.GROUND_LAYER].getOpacity()
      },

      /**
       * Gets the url of the projected image.
       * @type string
       * @public
       */
    },
    {
      key: "getUrl",
      value: function getUrl() {
        return this.state[_constants.GROUND_LAYER].getUrl()
      },
    },
  ])
  return GroundOverlay
})(
  _react2.default.PureComponent
)) /*
                                   * -----------------------------------------------------------------------------
                                   * This file is auto-generated from the corresponding file at `src/macros/`.
                                   * Please **DO NOT** edit this file directly when creating PRs.
                                   * -----------------------------------------------------------------------------
                                   */
/* global google */

GroundOverlay.propTypes = {
  /**
   * @type string
   */
  defaultUrl: _propTypes2.default.string /* v10.0.0 .isRequired */ /**
   * @see https://developers.google.com/maps/documentation/javascript/reference#GroundOverlay
   */,

  defaultBounds: _propTypes2.default.object /* v10.0.0 .isRequired */ /**
   * @type string
   * @deprecated use `defaultUrl` instead. It will be removed in v10.0.0
   */,

  url: _propTypes2.default.string,

  /**
   * @see https://developers.google.com/maps/documentation/javascript/reference#GroundOverlay
   * @deprecated use `defaultBounds` instead. It will be removed in v10.0.0
   */
  bounds: _propTypes2.default.object,

  /**
   * @type number
   */
  defaultOpacity: _propTypes2.default.number,

  /**
   * @type number
   */
  opacity: _propTypes2.default.number,

  /**
   * function
   */
  onDblClick: _propTypes2.default.func,

  /**
   * function
   */
  onClick: _propTypes2.default.func,
}
GroundOverlay.contextTypes = (0, _defineProperty3.default)(
  {},
  _constants.MAP,
  _propTypes2.default.object
)
exports.default = GroundOverlay

var eventMap = {
  onDblClick: "dblclick",
  onClick: "click",
}

var updaterMap = {
  opacity: function opacity(instance, _opacity) {
    instance.setOpacity(_opacity)
  },
}


/***/ }),
/* 921 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true,
})
exports.DirectionsRenderer = undefined

var _defineProperty2 = __webpack_require__(31)

var _defineProperty3 = _interopRequireDefault(_defineProperty2)

var _getPrototypeOf = __webpack_require__(25)

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf)

var _classCallCheck2 = __webpack_require__(26)

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2)

var _createClass2 = __webpack_require__(27)

var _createClass3 = _interopRequireDefault(_createClass2)

var _possibleConstructorReturn2 = __webpack_require__(28)

var _possibleConstructorReturn3 = _interopRequireDefault(
  _possibleConstructorReturn2
)

var _inherits2 = __webpack_require__(29)

var _inherits3 = _interopRequireDefault(_inherits2)

var _react = __webpack_require__(0)

var _react2 = _interopRequireDefault(_react)

var _propTypes = __webpack_require__(1)

var _propTypes2 = _interopRequireDefault(_propTypes)

var _MapChildHelper = __webpack_require__(35)

var _constants = __webpack_require__(32)

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj }
}

/**
 * A wrapper around `google.maps.DirectionsRenderer`
 *
 * @see https://developers.google.com/maps/documentation/javascript/3.exp/reference#DirectionsRenderer
 */
/*
 * -----------------------------------------------------------------------------
 * This file is auto-generated from the corresponding file at `src/macros/`.
 * Please **DO NOT** edit this file directly when creating PRs.
 * -----------------------------------------------------------------------------
 */
/* global google */
var DirectionsRenderer = (exports.DirectionsRenderer = (function(
  _React$PureComponent
) {
  ;(0, _inherits3.default)(DirectionsRenderer, _React$PureComponent)

  /*
   * @see https://developers.google.com/maps/documentation/javascript/3.exp/reference#DirectionsRenderer
   */
  function DirectionsRenderer(props, context) {
    ;(0, _classCallCheck3.default)(this, DirectionsRenderer)

    var _this = (0, _possibleConstructorReturn3.default)(
      this,
      (
        DirectionsRenderer.__proto__ ||
        (0, _getPrototypeOf2.default)(DirectionsRenderer)
      ).call(this, props, context)
    )

    var directionsRenderer = new google.maps.DirectionsRenderer()
    ;(0, _MapChildHelper.construct)(
      DirectionsRenderer.propTypes,
      updaterMap,
      _this.props,
      directionsRenderer
    )
    directionsRenderer.setMap(_this.context[_constants.MAP])
    _this.state = (0, _defineProperty3.default)(
      {},
      _constants.DIRECTIONS_RENDERER,
      directionsRenderer
    )
    return _this
  }

  ;(0, _createClass3.default)(DirectionsRenderer, [
    {
      key: "componentDidMount",
      value: function componentDidMount() {
        ;(0, _MapChildHelper.componentDidMount)(
          this,
          this.state[_constants.DIRECTIONS_RENDERER],
          eventMap
        )
      },
    },
    {
      key: "componentDidUpdate",
      value: function componentDidUpdate(prevProps) {
        ;(0, _MapChildHelper.componentDidUpdate)(
          this,
          this.state[_constants.DIRECTIONS_RENDERER],
          eventMap,
          updaterMap,
          prevProps
        )
      },
    },
    {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        ;(0, _MapChildHelper.componentWillUnmount)(this)
        var directionsRenderer = this.state[_constants.DIRECTIONS_RENDERER]
        if (directionsRenderer) {
          directionsRenderer.setMap(null)
        }
      },
    },
    {
      key: "render",
      value: function render() {
        return false
      },

      /**
       * Returns the renderer's current set of directions.
       * @type DirectionsResult
       * @public
       */
    },
    {
      key: "getDirections",
      value: function getDirections() {
        return this.state[_constants.DIRECTIONS_RENDERER].getDirections()
      },

      /**
       * Returns the panel `<div>` in which the `DirectionsResult` is rendered.
       * @type Node<div>DirectionsResult
       * @public
       */
    },
    {
      key: "getPanel",
      value: function getPanel() {
        return this.state[_constants.DIRECTIONS_RENDERER].getPanel()
      },

      /**
       * Returns the current (zero-based) route index in use by this `DirectionsRenderer` object.
       * @type numberDirectionsRenderer
       * @public
       */
    },
    {
      key: "getRouteIndex",
      value: function getRouteIndex() {
        return this.state[_constants.DIRECTIONS_RENDERER].getRouteIndex()
      },
    },
  ])
  return DirectionsRenderer
})(_react2.default.PureComponent))

DirectionsRenderer.propTypes = {
  /**
   * @type DirectionsResult
   */
  defaultDirections: _propTypes2.default.any,

  /**
   * @type DirectionsRendererOptions
   */
  defaultOptions: _propTypes2.default.any,

  /**
   * @type Node
   */
  defaultPanel: _propTypes2.default.any,

  /**
   * @type number
   */
  defaultRouteIndex: _propTypes2.default.number,

  /**
   * @type DirectionsResult
   */
  directions: _propTypes2.default.any,

  /**
   * @type DirectionsRendererOptions
   */
  options: _propTypes2.default.any,

  /**
   * @type Node
   */
  panel: _propTypes2.default.any,

  /**
   * @type number
   */
  routeIndex: _propTypes2.default.number,

  /**
   * function
   */
  onDirectionsChanged: _propTypes2.default.func,
}
DirectionsRenderer.contextTypes = (0, _defineProperty3.default)(
  {},
  _constants.MAP,
  _propTypes2.default.object
)
exports.default = DirectionsRenderer

var eventMap = {
  onDirectionsChanged: "directions_changed",
}

var updaterMap = {
  directions: function directions(instance, _directions) {
    instance.setDirections(_directions)
  },
  options: function options(instance, _options) {
    instance.setOptions(_options)
  },
  panel: function panel(instance, _panel) {
    instance.setPanel(_panel)
  },
  routeIndex: function routeIndex(instance, _routeIndex) {
    instance.setRouteIndex(_routeIndex)
  },
}


/***/ }),
/* 922 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true,
})
exports.FusionTablesLayer = undefined

var _defineProperty2 = __webpack_require__(31)

var _defineProperty3 = _interopRequireDefault(_defineProperty2)

var _getPrototypeOf = __webpack_require__(25)

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf)

var _classCallCheck2 = __webpack_require__(26)

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2)

var _createClass2 = __webpack_require__(27)

var _createClass3 = _interopRequireDefault(_createClass2)

var _possibleConstructorReturn2 = __webpack_require__(28)

var _possibleConstructorReturn3 = _interopRequireDefault(
  _possibleConstructorReturn2
)

var _inherits2 = __webpack_require__(29)

var _inherits3 = _interopRequireDefault(_inherits2)

var _react = __webpack_require__(0)

var _react2 = _interopRequireDefault(_react)

var _propTypes = __webpack_require__(1)

var _propTypes2 = _interopRequireDefault(_propTypes)

var _MapChildHelper = __webpack_require__(35)

var _constants = __webpack_require__(32)

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj }
}

/**
 * A wrapper around `google.maps.FusionTablesLayer`
 *
 * @see https://developers.google.com/maps/documentation/javascript/3.exp/reference#FusionTablesLayer
 */
/*
 * -----------------------------------------------------------------------------
 * This file is auto-generated from the corresponding file at `src/macros/`.
 * Please **DO NOT** edit this file directly when creating PRs.
 * -----------------------------------------------------------------------------
 */
/* global google */
var FusionTablesLayer = (exports.FusionTablesLayer = (function(
  _React$PureComponent
) {
  ;(0, _inherits3.default)(FusionTablesLayer, _React$PureComponent)

  /*
   * @see https://developers.google.com/maps/documentation/javascript/3.exp/reference#FusionTablesLayer
   */
  function FusionTablesLayer(props, context) {
    ;(0, _classCallCheck3.default)(this, FusionTablesLayer)

    var _this = (0, _possibleConstructorReturn3.default)(
      this,
      (
        FusionTablesLayer.__proto__ ||
        (0, _getPrototypeOf2.default)(FusionTablesLayer)
      ).call(this, props, context)
    )

    var fusionTablesLayer = new google.maps.FusionTablesLayer()
    ;(0, _MapChildHelper.construct)(
      FusionTablesLayer.propTypes,
      updaterMap,
      _this.props,
      fusionTablesLayer
    )
    fusionTablesLayer.setMap(_this.context[_constants.MAP])
    _this.state = (0, _defineProperty3.default)(
      {},
      _constants.FUSION_TABLES_LAYER,
      fusionTablesLayer
    )
    return _this
  }

  ;(0, _createClass3.default)(FusionTablesLayer, [
    {
      key: "componentDidMount",
      value: function componentDidMount() {
        ;(0, _MapChildHelper.componentDidMount)(
          this,
          this.state[_constants.FUSION_TABLES_LAYER],
          eventMap
        )
      },
    },
    {
      key: "componentDidUpdate",
      value: function componentDidUpdate(prevProps) {
        ;(0, _MapChildHelper.componentDidUpdate)(
          this,
          this.state[_constants.FUSION_TABLES_LAYER],
          eventMap,
          updaterMap,
          prevProps
        )
      },
    },
    {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        ;(0, _MapChildHelper.componentWillUnmount)(this)
        var fusionTablesLayer = this.state[_constants.FUSION_TABLES_LAYER]
        if (fusionTablesLayer) {
          fusionTablesLayer.setMap(null)
        }
      },
    },
    {
      key: "render",
      value: function render() {
        return false
      },
    },
  ])
  return FusionTablesLayer
})(_react2.default.PureComponent))

FusionTablesLayer.propTypes = {
  /**
   * @type FusionTablesLayerOptions
   */
  defaultOptions: _propTypes2.default.any,

  /**
   * @type FusionTablesLayerOptions
   */
  options: _propTypes2.default.any,

  /**
   * function
   */
  onClick: _propTypes2.default.func,
}
FusionTablesLayer.contextTypes = (0, _defineProperty3.default)(
  {},
  _constants.MAP,
  _propTypes2.default.object
)
exports.default = FusionTablesLayer

var eventMap = {
  onClick: "click",
}

var updaterMap = {
  options: function options(instance, _options) {
    instance.setOptions(_options)
  },
}


/***/ }),
/* 923 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true,
})
exports.KmlLayer = undefined

var _defineProperty2 = __webpack_require__(31)

var _defineProperty3 = _interopRequireDefault(_defineProperty2)

var _getPrototypeOf = __webpack_require__(25)

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf)

var _classCallCheck2 = __webpack_require__(26)

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2)

var _createClass2 = __webpack_require__(27)

var _createClass3 = _interopRequireDefault(_createClass2)

var _possibleConstructorReturn2 = __webpack_require__(28)

var _possibleConstructorReturn3 = _interopRequireDefault(
  _possibleConstructorReturn2
)

var _inherits2 = __webpack_require__(29)

var _inherits3 = _interopRequireDefault(_inherits2)

var _react = __webpack_require__(0)

var _react2 = _interopRequireDefault(_react)

var _propTypes = __webpack_require__(1)

var _propTypes2 = _interopRequireDefault(_propTypes)

var _MapChildHelper = __webpack_require__(35)

var _constants = __webpack_require__(32)

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj }
}

/**
 * A wrapper around `google.maps.KmlLayer`
 *
 * @see https://developers.google.com/maps/documentation/javascript/3.exp/reference#KmlLayer
 */
/*
 * -----------------------------------------------------------------------------
 * This file is auto-generated from the corresponding file at `src/macros/`.
 * Please **DO NOT** edit this file directly when creating PRs.
 * -----------------------------------------------------------------------------
 */
/* global google */
var KmlLayer = (exports.KmlLayer = (function(_React$PureComponent) {
  ;(0, _inherits3.default)(KmlLayer, _React$PureComponent)

  /*
   * @see https://developers.google.com/maps/documentation/javascript/3.exp/reference#KmlLayer
   */
  function KmlLayer(props, context) {
    ;(0, _classCallCheck3.default)(this, KmlLayer)

    var _this = (0, _possibleConstructorReturn3.default)(
      this,
      (KmlLayer.__proto__ || (0, _getPrototypeOf2.default)(KmlLayer)).call(
        this,
        props,
        context
      )
    )

    var kmlLayer = new google.maps.KmlLayer()
    ;(0, _MapChildHelper.construct)(
      KmlLayer.propTypes,
      updaterMap,
      _this.props,
      kmlLayer
    )
    kmlLayer.setMap(_this.context[_constants.MAP])
    _this.state = (0, _defineProperty3.default)(
      {},
      _constants.KML_LAYER,
      kmlLayer
    )
    return _this
  }

  ;(0, _createClass3.default)(KmlLayer, [
    {
      key: "componentDidMount",
      value: function componentDidMount() {
        ;(0, _MapChildHelper.componentDidMount)(
          this,
          this.state[_constants.KML_LAYER],
          eventMap
        )
      },
    },
    {
      key: "componentDidUpdate",
      value: function componentDidUpdate(prevProps) {
        ;(0, _MapChildHelper.componentDidUpdate)(
          this,
          this.state[_constants.KML_LAYER],
          eventMap,
          updaterMap,
          prevProps
        )
      },
    },
    {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        ;(0, _MapChildHelper.componentWillUnmount)(this)
        var kmlLayer = this.state[_constants.KML_LAYER]
        if (kmlLayer) {
          kmlLayer.setMap(null)
        }
      },
    },
    {
      key: "render",
      value: function render() {
        return false
      },

      /**
       * Get the default viewport for the layer being displayed.
       * @type LatLngBounds
       * @public
       */
    },
    {
      key: "getDefaultViewport",
      value: function getDefaultViewport() {
        return this.state[_constants.KML_LAYER].getDefaultViewport()
      },

      /**
       * Get the metadata associated with this layer, as specified in the layer markup.
       * @type KmlLayerMetadata
       * @public
       */
    },
    {
      key: "getMetadata",
      value: function getMetadata() {
        return this.state[_constants.KML_LAYER].getMetadata()
      },

      /**
       * Get the status of the layer, set once the requested document has loaded.
       * @type KmlLayerStatus
       * @public
       */
    },
    {
      key: "getStatus",
      value: function getStatus() {
        return this.state[_constants.KML_LAYER].getStatus()
      },

      /**
       * Gets the URL of the KML file being displayed.
       * @type string
       * @public
       */
    },
    {
      key: "getUrl",
      value: function getUrl() {
        return this.state[_constants.KML_LAYER].getUrl()
      },

      /**
       * Gets the z-index of the KML Layer.
       * @type number
       * @public
       */
    },
    {
      key: "getZIndex",
      value: function getZIndex() {
        return this.state[_constants.KML_LAYER].getZIndex()
      },
    },
  ])
  return KmlLayer
})(_react2.default.PureComponent))

KmlLayer.propTypes = {
  /**
   * @type KmlLayerOptions
   */
  defaultOptions: _propTypes2.default.any,

  /**
   * @type string
   */
  defaultUrl: _propTypes2.default.string,

  /**
   * @type number
   */
  defaultZIndex: _propTypes2.default.number,

  /**
   * @type KmlLayerOptions
   */
  options: _propTypes2.default.any,

  /**
   * @type string
   */
  url: _propTypes2.default.string,

  /**
   * @type number
   */
  zIndex: _propTypes2.default.number,

  /**
   * function
   */
  onDefaultViewportChanged: _propTypes2.default.func,

  /**
   * function
   */
  onClick: _propTypes2.default.func,

  /**
   * function
   */
  onStatusChanged: _propTypes2.default.func,
}
KmlLayer.contextTypes = (0, _defineProperty3.default)(
  {},
  _constants.MAP,
  _propTypes2.default.object
)
exports.default = KmlLayer

var eventMap = {
  onDefaultViewportChanged: "defaultviewport_changed",
  onClick: "click",
  onStatusChanged: "status_changed",
}

var updaterMap = {
  options: function options(instance, _options) {
    instance.setOptions(_options)
  },
  url: function url(instance, _url) {
    instance.setUrl(_url)
  },
  zIndex: function zIndex(instance, _zIndex) {
    instance.setZIndex(_zIndex)
  },
}


/***/ }),
/* 924 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true,
})
exports.TrafficLayer = undefined

var _defineProperty2 = __webpack_require__(31)

var _defineProperty3 = _interopRequireDefault(_defineProperty2)

var _getPrototypeOf = __webpack_require__(25)

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf)

var _classCallCheck2 = __webpack_require__(26)

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2)

var _createClass2 = __webpack_require__(27)

var _createClass3 = _interopRequireDefault(_createClass2)

var _possibleConstructorReturn2 = __webpack_require__(28)

var _possibleConstructorReturn3 = _interopRequireDefault(
  _possibleConstructorReturn2
)

var _inherits2 = __webpack_require__(29)

var _inherits3 = _interopRequireDefault(_inherits2)

var _react = __webpack_require__(0)

var _react2 = _interopRequireDefault(_react)

var _propTypes = __webpack_require__(1)

var _propTypes2 = _interopRequireDefault(_propTypes)

var _MapChildHelper = __webpack_require__(35)

var _constants = __webpack_require__(32)

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj }
}

/**
 * A wrapper around `google.maps.TrafficLayer`
 *
 * @see https://developers.google.com/maps/documentation/javascript/3.exp/reference#TrafficLayer
 */
/*
 * -----------------------------------------------------------------------------
 * This file is auto-generated from the corresponding file at `src/macros/`.
 * Please **DO NOT** edit this file directly when creating PRs.
 * -----------------------------------------------------------------------------
 */
/* global google */
var TrafficLayer = (exports.TrafficLayer = (function(_React$PureComponent) {
  ;(0, _inherits3.default)(TrafficLayer, _React$PureComponent)

  /*
   * @see https://developers.google.com/maps/documentation/javascript/3.exp/reference#TrafficLayer
   */
  function TrafficLayer(props, context) {
    ;(0, _classCallCheck3.default)(this, TrafficLayer)

    var _this = (0, _possibleConstructorReturn3.default)(
      this,
      (
        TrafficLayer.__proto__ || (0, _getPrototypeOf2.default)(TrafficLayer)
      ).call(this, props, context)
    )

    var trafficLayer = new google.maps.TrafficLayer()
    ;(0, _MapChildHelper.construct)(
      TrafficLayer.propTypes,
      updaterMap,
      _this.props,
      trafficLayer
    )
    trafficLayer.setMap(_this.context[_constants.MAP])
    _this.state = (0, _defineProperty3.default)(
      {},
      _constants.TRAFFIC_LAYER,
      trafficLayer
    )
    return _this
  }

  ;(0, _createClass3.default)(TrafficLayer, [
    {
      key: "componentDidMount",
      value: function componentDidMount() {
        ;(0, _MapChildHelper.componentDidMount)(
          this,
          this.state[_constants.TRAFFIC_LAYER],
          eventMap
        )
      },
    },
    {
      key: "componentDidUpdate",
      value: function componentDidUpdate(prevProps) {
        ;(0, _MapChildHelper.componentDidUpdate)(
          this,
          this.state[_constants.TRAFFIC_LAYER],
          eventMap,
          updaterMap,
          prevProps
        )
      },
    },
    {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        ;(0, _MapChildHelper.componentWillUnmount)(this)
        var trafficLayer = this.state[_constants.TRAFFIC_LAYER]
        if (trafficLayer) {
          trafficLayer.setMap(null)
        }
      },
    },
    {
      key: "render",
      value: function render() {
        return false
      },
    },
  ])
  return TrafficLayer
})(_react2.default.PureComponent))

TrafficLayer.propTypes = {
  /**
   * @type TrafficLayerOptions
   */
  defaultOptions: _propTypes2.default.any,

  /**
   * @type TrafficLayerOptions
   */
  options: _propTypes2.default.any,
}
TrafficLayer.contextTypes = (0, _defineProperty3.default)(
  {},
  _constants.MAP,
  _propTypes2.default.object
)
exports.default = TrafficLayer

var eventMap = {}

var updaterMap = {
  options: function options(instance, _options) {
    instance.setOptions(_options)
  },
}


/***/ }),
/* 925 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true,
})
exports.StreetViewPanorama = undefined

var _defineProperty2 = __webpack_require__(31)

var _defineProperty3 = _interopRequireDefault(_defineProperty2)

var _getPrototypeOf = __webpack_require__(25)

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf)

var _classCallCheck2 = __webpack_require__(26)

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2)

var _createClass2 = __webpack_require__(27)

var _createClass3 = _interopRequireDefault(_createClass2)

var _possibleConstructorReturn2 = __webpack_require__(28)

var _possibleConstructorReturn3 = _interopRequireDefault(
  _possibleConstructorReturn2
)

var _inherits2 = __webpack_require__(29)

var _inherits3 = _interopRequireDefault(_inherits2)

var _invariant = __webpack_require__(30)

var _invariant2 = _interopRequireDefault(_invariant)

var _react = __webpack_require__(0)

var _react2 = _interopRequireDefault(_react)

var _propTypes = __webpack_require__(1)

var _propTypes2 = _interopRequireDefault(_propTypes)

var _MapChildHelper = __webpack_require__(35)

var _constants = __webpack_require__(32)

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj }
}

/**
 * A wrapper around `google.maps.StreetViewPanorama`
 *
 * @see https://developers.google.com/maps/documentation/javascript/3.exp/reference#StreetViewPanorama
 */
var StreetViewPanorama = (exports.StreetViewPanorama = (function(
  _React$PureComponent
) {
  ;(0, _inherits3.default)(StreetViewPanorama, _React$PureComponent)

  function StreetViewPanorama(props, context) {
    ;(0, _classCallCheck3.default)(this, StreetViewPanorama)

    var _this = (0, _possibleConstructorReturn3.default)(
      this,
      (
        StreetViewPanorama.__proto__ ||
        (0, _getPrototypeOf2.default)(StreetViewPanorama)
      ).call(this, props, context)
    )

    ;(0, _invariant2.default)(
      !!_this.context[_constants.MAP],
      "Did you render <StreetViewPanorama> as a child of <GoogleMap> with withGoogleMap() HOC?"
    )
    ;(0, _MapChildHelper.construct)(
      StreetViewPanorama.propTypes,
      updaterMap,
      _this.props,
      _this.context[_constants.MAP].getStreetView()
    )
    return _this
  }

  ;(0, _createClass3.default)(StreetViewPanorama, [
    {
      key: "getChildContext",
      value: function getChildContext() {
        return (0, _defineProperty3.default)(
          {},
          _constants.MAP,
          this.context[_constants.MAP].getStreetView()
        )
      },
    },
    {
      key: "componentDidMount",
      value: function componentDidMount() {
        ;(0, _MapChildHelper.componentDidMount)(
          this,
          this.context[_constants.MAP].getStreetView(),
          eventMap
        )
      },
    },
    {
      key: "componentDidUpdate",
      value: function componentDidUpdate(prevProps) {
        ;(0, _MapChildHelper.componentDidUpdate)(
          this,
          this.context[_constants.MAP].getStreetView(),
          eventMap,
          updaterMap,
          prevProps
        )
      },
    },
    {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        ;(0, _MapChildHelper.componentWillUnmount)(this)
        var streetViewPanorama = this.context[_constants.MAP].getStreetView()
        if (streetViewPanorama) {
          streetViewPanorama.setVisible(false)
        }
      },
    },
    {
      key: "render",
      value: function render() {
        var children = this.props.children

        return _react2.default.createElement("div", null, children)
      },

      /**
       * Returns the set of navigation links for the Street View panorama.
       * @type Array<StreetViewLink>
       * @public
       */
    },
    {
      key: "getLinks",
      value: function getLinks() {
        return this.context[_constants.MAP].getLinks()
      },

      /**
       * Returns the StreetViewLocation of the current panorama.
       * @type StreetViewLocation
       * @public
       */
    },
    {
      key: "getLocation",
      value: function getLocation() {
        return this.context[_constants.MAP].getLocation()
      },

      /**
       * Returns the state of motion tracker. If true when the user physically moves the device and the browser supports it, the Street View Panorama tracks the physical movements.
       * @type boolean
       * @public
       */
    },
    {
      key: "getMotionTracking",
      value: function getMotionTracking() {
        return this.context[_constants.MAP].getMotionTracking()
      },

      /**
       * Returns the current panorama ID for the Street View panorama. This id is stable within the browser's current session only.
       * @type string
       * @public
       */
    },
    {
      key: "getPano",
      value: function getPano() {
        return this.context[_constants.MAP].getPano()
      },

      /**
       * Returns the heading and pitch of the photographer when this panorama was taken. For Street View panoramas on the road, this also reveals in which direction the car was travelling. This data is available after the `pano_changed` event.
       * @type StreetViewPovpano_changed
       * @public
       */
    },
    {
      key: "getPhotographerPov",
      value: function getPhotographerPov() {
        return this.context[_constants.MAP].getPhotographerPov()
      },

      /**
       * Returns the current `LatLng` position for the Street View panorama.
       * @type LatLngLatLng
       * @public
       */
    },
    {
      key: "getPosition",
      value: function getPosition() {
        return this.context[_constants.MAP].getPosition()
      },

      /**
       * Returns the current point of view for the Street View panorama.
       * @type StreetViewPov
       * @public
       */
    },
    {
      key: "getPov",
      value: function getPov() {
        return this.context[_constants.MAP].getPov()
      },

      /**
       * Returns the status of the panorama on completion of the `setPosition()` or `setPano()` request.
       * @type StreetViewStatussetPosition()setPano()
       * @public
       */
    },
    {
      key: "getStatus",
      value: function getStatus() {
        return this.context[_constants.MAP].getStatus()
      },

      /**
       * Returns `true` if the panorama is visible. It does not specify whether Street View imagery is available at the specified position.
       * @type booleantrue
       * @public
       */
    },
    {
      key: "getVisible",
      value: function getVisible() {
        return this.context[_constants.MAP].getVisible()
      },

      /**
       * Returns the zoom level of the panorama. Fully zoomed-out is level 0, where the field of view is 180 degrees. Zooming in increases the zoom level.
       * @type number
       * @public
       */
    },
    {
      key: "getZoom",
      value: function getZoom() {
        return this.context[_constants.MAP].getZoom()
      },
    },
  ])
  return StreetViewPanorama
})(
  _react2.default.PureComponent
)) /*
                                   * -----------------------------------------------------------------------------
                                   * This file is auto-generated from the corresponding file at `src/macros/`.
                                   * Please **DO NOT** edit this file directly when creating PRs.
                                   * -----------------------------------------------------------------------------
                                   */

StreetViewPanorama.propTypes = {
  /**
   * @type Array<StreetViewLink>
   */
  defaultLinks: _propTypes2.default.any,

  /**
   * @type boolean
   */
  defaultMotionTracking: _propTypes2.default.bool,

  /**
   * @type StreetViewPanoramaOptions
   */
  defaultOptions: _propTypes2.default.any,

  /**
   * @type string
   */
  defaultPano: _propTypes2.default.string,

  /**
   * @type LatLng|LatLngLiteral
   */
  defaultPosition: _propTypes2.default.any,

  /**
   * @type StreetViewPov
   */
  defaultPov: _propTypes2.default.any,

  /**
   * @type boolean
   */
  defaultVisible: _propTypes2.default.bool,

  /**
   * @type number
   */
  defaultZoom: _propTypes2.default.number,

  /**
   * @type Array<StreetViewLink>
   */
  links: _propTypes2.default.any,

  /**
   * @type boolean
   */
  motionTracking: _propTypes2.default.bool,

  /**
   * @type StreetViewPanoramaOptions
   */
  options: _propTypes2.default.any,

  /**
   * @type string
   */
  pano: _propTypes2.default.string,

  /**
   * @type LatLng|LatLngLiteral
   */
  position: _propTypes2.default.any,

  /**
   * @type StreetViewPov
   */
  pov: _propTypes2.default.any,

  /**
   * @type boolean
   */
  visible: _propTypes2.default.bool,

  /**
   * @type number
   */
  zoom: _propTypes2.default.number,

  /**
   * function
   */
  onCloseClick: _propTypes2.default.func,

  /**
   * function
   */
  onPanoChanged: _propTypes2.default.func,

  /**
   * function
   */
  onPositionChanged: _propTypes2.default.func,

  /**
   * function
   */
  onPovChanged: _propTypes2.default.func,

  /**
   * function
   */
  onResize: _propTypes2.default.func,

  /**
   * function
   */
  onStatusChanged: _propTypes2.default.func,

  /**
   * function
   */
  onVisibleChanged: _propTypes2.default.func,

  /**
   * function
   */
  onZoomChanged: _propTypes2.default.func,
}
StreetViewPanorama.contextTypes = (0, _defineProperty3.default)(
  {},
  _constants.MAP,
  _propTypes2.default.object
)
StreetViewPanorama.childContextTypes = (0, _defineProperty3.default)(
  {},
  _constants.MAP,
  _propTypes2.default.object
)
exports.default = StreetViewPanorama

var eventMap = {
  onCloseClick: "closeclick",
  onPanoChanged: "pano_changed",
  onPositionChanged: "position_changed",
  onPovChanged: "pov_changed",
  onResize: "resize",
  onStatusChanged: "status_changed",
  onVisibleChanged: "visible_changed",
  onZoomChanged: "zoom_changed",
}

var updaterMap = {
  links: function links(instance, _links) {
    instance.setLinks(_links)
  },
  motionTracking: function motionTracking(instance, _motionTracking) {
    instance.setMotionTracking(_motionTracking)
  },
  options: function options(instance, _options) {
    instance.setOptions(_options)
  },
  pano: function pano(instance, _pano) {
    instance.setPano(_pano)
  },
  position: function position(instance, _position) {
    instance.setPosition(_position)
  },
  pov: function pov(instance, _pov) {
    instance.setPov(_pov)
  },
  visible: function visible(instance, _visible) {
    instance.setVisible(_visible)
  },
  zoom: function zoom(instance, _zoom) {
    instance.setZoom(_zoom)
  },
}


/***/ }),
/* 926 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true,
})
exports.BicyclingLayer = undefined

var _defineProperty2 = __webpack_require__(31)

var _defineProperty3 = _interopRequireDefault(_defineProperty2)

var _getPrototypeOf = __webpack_require__(25)

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf)

var _classCallCheck2 = __webpack_require__(26)

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2)

var _createClass2 = __webpack_require__(27)

var _createClass3 = _interopRequireDefault(_createClass2)

var _possibleConstructorReturn2 = __webpack_require__(28)

var _possibleConstructorReturn3 = _interopRequireDefault(
  _possibleConstructorReturn2
)

var _inherits2 = __webpack_require__(29)

var _inherits3 = _interopRequireDefault(_inherits2)

var _react = __webpack_require__(0)

var _react2 = _interopRequireDefault(_react)

var _propTypes = __webpack_require__(1)

var _propTypes2 = _interopRequireDefault(_propTypes)

var _MapChildHelper = __webpack_require__(35)

var _constants = __webpack_require__(32)

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj }
}

/**
 * A wrapper around `google.maps.BicyclingLayer`
 *
 * @see https://developers.google.com/maps/documentation/javascript/3.exp/reference#BicyclingLayer
 */
/*
 * -----------------------------------------------------------------------------
 * This file is auto-generated from the corresponding file at `src/macros/`.
 * Please **DO NOT** edit this file directly when creating PRs.
 * -----------------------------------------------------------------------------
 */
/* global google */
var BicyclingLayer = (exports.BicyclingLayer = (function(_React$PureComponent) {
  ;(0, _inherits3.default)(BicyclingLayer, _React$PureComponent)

  /*
   * @see https://developers.google.com/maps/documentation/javascript/3.exp/reference#BicyclingLayer
   */
  function BicyclingLayer(props, context) {
    ;(0, _classCallCheck3.default)(this, BicyclingLayer)

    var _this = (0, _possibleConstructorReturn3.default)(
      this,
      (
        BicyclingLayer.__proto__ ||
        (0, _getPrototypeOf2.default)(BicyclingLayer)
      ).call(this, props, context)
    )

    var bicyclingLayer = new google.maps.BicyclingLayer()
    ;(0, _MapChildHelper.construct)(
      BicyclingLayer.propTypes,
      updaterMap,
      _this.props,
      bicyclingLayer
    )
    bicyclingLayer.setMap(_this.context[_constants.MAP])
    _this.state = (0, _defineProperty3.default)(
      {},
      _constants.BICYCLING_LAYER,
      bicyclingLayer
    )
    return _this
  }

  ;(0, _createClass3.default)(BicyclingLayer, [
    {
      key: "componentDidMount",
      value: function componentDidMount() {
        ;(0, _MapChildHelper.componentDidMount)(
          this,
          this.state[_constants.BICYCLING_LAYER],
          eventMap
        )
      },
    },
    {
      key: "componentDidUpdate",
      value: function componentDidUpdate(prevProps) {
        ;(0, _MapChildHelper.componentDidUpdate)(
          this,
          this.state[_constants.BICYCLING_LAYER],
          eventMap,
          updaterMap,
          prevProps
        )
      },
    },
    {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        ;(0, _MapChildHelper.componentWillUnmount)(this)
        var bicyclingLayer = this.state[_constants.BICYCLING_LAYER]
        if (bicyclingLayer) {
          bicyclingLayer.setMap(null)
        }
      },
    },
    {
      key: "render",
      value: function render() {
        return false
      },
    },
  ])
  return BicyclingLayer
})(_react2.default.PureComponent))

BicyclingLayer.propTypes = {}
BicyclingLayer.contextTypes = (0, _defineProperty3.default)(
  {},
  _constants.MAP,
  _propTypes2.default.object
)
exports.default = BicyclingLayer

var eventMap = {}

var updaterMap = {}


/***/ }),
/* 927 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_chart_js__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_chart_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_chart_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__material_ui_icons_Info__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__material_ui_icons_Info___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__material_ui_icons_Info__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_icons_Timeline__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_icons_Timeline___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__material_ui_icons_Timeline__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_Tooltip__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_Tooltip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Tooltip__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_styles_withStyles__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_styles_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_styles_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils__ = __webpack_require__(137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_EnergyCompany_Cards_ECCard_jsx__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_components_Grid_GridContainer_jsx__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_components_Grid_GridItem_jsx__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_services_utils__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_assets_EnergyCompany_jss_lightTooltip__ = __webpack_require__(76);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var styles=function styles(theme){return Object.assign({},Object(__WEBPACK_IMPORTED_MODULE_14_assets_EnergyCompany_jss_lightTooltip__["a" /* default */])(theme),{tooltipWrapper:Object.assign({},Object(__WEBPACK_IMPORTED_MODULE_14_assets_EnergyCompany_jss_lightTooltip__["a" /* default */])(theme).tooltipContentWrapper,{alignItems:"flex-end"})});};var RiscoChart=function(_Component){_inherits(RiscoChart,_Component);function RiscoChart(){_classCallCheck(this,RiscoChart);return _possibleConstructorReturn(this,(RiscoChart.__proto__||Object.getPrototypeOf(RiscoChart)).apply(this,arguments));}_createClass(RiscoChart,[{key:"componentDidMount",value:function componentDidMount(){this.handleChart();}},{key:"componentDidUpdate",value:function componentDidUpdate(){this.handleChart();}},{key:"getSortedMonths",value:function getSortedMonths(){return Object(__WEBPACK_IMPORTED_MODULE_8_lodash__["sortBy"])(Object(__WEBPACK_IMPORTED_MODULE_8_lodash__["keys"])(this.props.data),function(month){return __WEBPACK_IMPORTED_MODULE_2_moment___default()(month).unix();});}},{key:"getLabels",value:function getLabels(){var labels=Object(__WEBPACK_IMPORTED_MODULE_8_lodash__["map"])(this.getSortedMonths(),function(label){return __WEBPACK_IMPORTED_MODULE_2_moment___default()(label).format("MMM Y");});return Object(__WEBPACK_IMPORTED_MODULE_9__utils__["a" /* fulfillWith */])(labels,"");}},{key:"getData",value:function getData(key){var _this2=this;var data=[];Object(__WEBPACK_IMPORTED_MODULE_8_lodash__["forEach"])(this.getSortedMonths(),function(month){data.push(_this2.props.data[month][key]);});return Object(__WEBPACK_IMPORTED_MODULE_9__utils__["a" /* fulfillWith */])(data,undefined);}},{key:"handleChart",value:function handleChart(){var ctx="chart-risco";var labels=this.getLabels();var energiaVendida=this.getData("energiaVendida");var margemSeguranca=this.getData("margemSeguranca");if(this.chart){this.chart.destroy();}this.chart=new __WEBPACK_IMPORTED_MODULE_0_chart_js___default.a(ctx,{type:'bar',data:{datasets:Object(__WEBPACK_IMPORTED_MODULE_8_lodash__["compact"])([{backgroundColor:'rgba(54, 162, 235, 0.4)',borderColor:'rgba(54, 162, 235, 1)',data:margemSeguranca,fill:false,label:'Margem de Segurança (12 meses)',type:'line',yAxisID:'margemSeguranca'},{backgroundColor:'rgba(255, 99, 132, 0.4)',borderColor:'rgba(255,99,132,1)',borderWidth:1,data:energiaVendida,label:'MW médio negociado',yAxisID:'mwMedNegociado'}]),labels:labels},options:{scales:{yAxes:[{id:'margemSeguranca',position:'left',ticks:{beginAtZero:true,callback:function callback(value){return Object(__WEBPACK_IMPORTED_MODULE_13_services_utils__["f" /* localeString */])(value)+" R$/MWh";}}},{gridLines:{display:false},id:'mwMedNegociado',position:'right',ticks:{beginAtZero:true,callback:function callback(value){return Object(__WEBPACK_IMPORTED_MODULE_13_services_utils__["f" /* localeString */])(value)+" MWmed";}}}]},tooltips:{callbacks:{label:function label(tooltipItem,data){if(tooltipItem.datasetIndex+1<data.datasets.length){return Object(__WEBPACK_IMPORTED_MODULE_13_services_utils__["f" /* localeString */])(tooltipItem.yLabel)+" R$/MWh";}else{return Object(__WEBPACK_IMPORTED_MODULE_13_services_utils__["f" /* localeString */])(tooltipItem.yLabel)+" MWmed";}}},intersect:false,mode:'index'}}});}},{key:"render",value:function render(){var classes=this.props.classes;return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components_Grid_GridContainer_jsx__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_components_Grid_GridItem_jsx__["a" /* default */],{md:12,sm:12,xs:12},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_EnergyCompany_Cards_ECCard_jsx__["a" /* default */],{content:__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("canvas",{id:"chart-risco"}),icon:__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_icons_Timeline___default.a,null),title:__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Tooltip___default.a,{classes:{popper:classes.lightTooltipPopper,tooltip:classes.lightTooltip},placement:"top",title:"Margem de Risco = (Capital Social) x Idade / (MWm\xE9d x 8760)"},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("span",{className:classes.tooltipWrapper},"Margem de Risco ",__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_icons_Info___default.a,null)))})));}}]);return RiscoChart;}(__WEBPACK_IMPORTED_MODULE_3_react__["Component"]);;RiscoChart.propTypes={classes:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object.isRequired,data:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object.isRequired};/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_7__material_ui_core_styles_withStyles___default()(styles)(RiscoChart));

/***/ }),
/* 928 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export TabelaBalancoComponent */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles_withStyles__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_icons_Assignment__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_icons_Assignment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__material_ui_icons_Assignment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_EnergyCompany_Cards_ECCard_jsx__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_Grid_GridContainer_jsx__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_Grid_GridItem_jsx__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_icons_Info__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_icons_Info___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__material_ui_icons_Info__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_Table_Table_jsx__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__material_ui_core_Tooltip__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__material_ui_core_Tooltip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__material_ui_core_Tooltip__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_services_utils__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_assets_EnergyCompany_jss_lightTooltip__ = __webpack_require__(76);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var styles=function styles(theme){return Object.assign({tableWrapper:{marginTop:"30px"}},Object(__WEBPACK_IMPORTED_MODULE_13_assets_EnergyCompany_jss_lightTooltip__["a" /* default */])(theme));};var TabelaBalanco=function(_Component){_inherits(TabelaBalanco,_Component);function TabelaBalanco(){var _ref;var _temp,_this,_ret;_classCallCheck(this,TabelaBalanco);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=TabelaBalanco.__proto__||Object.getPrototypeOf(TabelaBalanco)).call.apply(_ref,[this].concat(args))),_this),_this.getTableData=function(){var balancoDados=_this.props.balancoDados;return Object(__WEBPACK_IMPORTED_MODULE_4_lodash__["map"])(balancoDados,function(data,month){return[__WEBPACK_IMPORTED_MODULE_0_moment___default()(month).format("MMM Y"),Object(__WEBPACK_IMPORTED_MODULE_12_services_utils__["f" /* localeString */])(data.consumoLiquido),Object(__WEBPACK_IMPORTED_MODULE_12_services_utils__["f" /* localeString */])(data.perdasConsumo),Object(__WEBPACK_IMPORTED_MODULE_12_services_utils__["f" /* localeString */])(data.consumo),Object(__WEBPACK_IMPORTED_MODULE_12_services_utils__["f" /* localeString */])(data.comprasSemProinfa),Object(__WEBPACK_IMPORTED_MODULE_12_services_utils__["f" /* localeString */])(data.proinfa),Object(__WEBPACK_IMPORTED_MODULE_12_services_utils__["f" /* localeString */])(data.vendas),Object(__WEBPACK_IMPORTED_MODULE_12_services_utils__["f" /* localeString */])(data.saldoContratos),Object(__WEBPACK_IMPORTED_MODULE_12_services_utils__["f" /* localeString */])(data.saldo)];});},_this.getHeaderTooltip=function(header,title){var classes=_this.props.classes;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core_Tooltip___default.a,{classes:{popper:classes.lightTooltipPopper,tooltip:classes.lightTooltip},placement:"top",title:title},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span",{className:classes.tooltipContentWrapper},header," ",__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_icons_Info___default.a,null)));},_this.getTableHead=function(){return["Mês","Consumo Líq.","Perdas",_this.getHeaderTooltip("Consumo Bruto","Consumo Líq. + Perdas"),"Compras","PROINFA","Cessão",_this.getHeaderTooltip("Net Contratos","Compras + PROINFA - Cessão"),"Saldo"];},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(TabelaBalanco,[{key:"render",value:function render(){var classes=this.props.classes;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_Grid_GridContainer_jsx__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_Grid_GridItem_jsx__["a" /* default */],{md:12,sm:12,xs:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_EnergyCompany_Cards_ECCard_jsx__["a" /* default */],{content:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:classes.tableWrapper},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_Table_Table_jsx__["a" /* default */],{tableData:this.getTableData(),tableHead:this.getTableHead(),tableHeaderColor:"primary"})),icon:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_icons_Assignment___default.a,null),title:"Balan\xE7o"})));}}]);return TabelaBalanco;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);;TabelaBalanco.propTypes={balancoDados:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired,classes:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired};/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles_withStyles___default()(styles)(TabelaBalanco));

/***/ }),
/* 929 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(9);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(10));

var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
  fill: "none",
  d: "M0 0h24v24H0z"
}), _react.default.createElement("path", {
  d: "M19.35 10.04C18.67 6.59 15.64 4 12 4 9.11 4 6.6 5.64 5.35 8.04 2.34 8.36 0 10.91 0 14c0 3.31 2.69 6 6 6h13c2.76 0 5-2.24 5-5 0-2.64-2.05-4.78-4.65-4.96zM17 13l-5 5-5-5h3V9h4v4h3z"
})), 'CloudDownload');

exports.default = _default;

/***/ }),
/* 930 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_Pagination_Pagination_jsx__ = __webpack_require__(931);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var CustomPagination=function(_React$Component){_inherits(CustomPagination,_React$Component);function CustomPagination(){var _ref;var _temp,_this,_ret;_classCallCheck(this,CustomPagination);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=CustomPagination.__proto__||Object.getPrototypeOf(CustomPagination)).call.apply(_ref,[this].concat(args))),_this),_this.state={pager:{}},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(CustomPagination,[{key:'componentWillMount',value:function componentWillMount(){this.setPage(this.props.initialPage,true);}},{key:'componentDidUpdate',value:function componentDidUpdate(prevProps){if(!Object(__WEBPACK_IMPORTED_MODULE_3_lodash__["isEqual"])(prevProps.totalItens,this.props.totalItens)){this.setPage(this.props.initialPage,true);}}},{key:'setPage',value:function setPage(page){var initialization=arguments.length>1&&arguments[1]!==undefined?arguments[1]:false;var _props=this.props,pageSize=_props.pageSize,totalItens=_props.totalItens;var pager=this.state.pager;if(page<1||page>pager.totalPages){return;}pager=this.getPager(totalItens,page,pageSize);this.setState({pager:pager});// call change page function in parent component
if(!initialization){this.props.onChangePage(page);}}},{key:'getPager',value:function getPager(totalItens){var currentPage=arguments.length>1&&arguments[1]!==undefined?arguments[1]:1;var pageSize=arguments.length>2&&arguments[2]!==undefined?arguments[2]:10;var totalPages=Math.ceil(totalItens/pageSize);var startPage=void 0,endPage=void 0;if(totalPages<=10){// less than 10 total pages so show all
startPage=1;endPage=totalPages;}else{// more than 10 total pages so calculate start and end pages
if(currentPage<=6){startPage=1;endPage=10;}else if(currentPage+4>=totalPages){startPage=totalPages-9;endPage=totalPages;}else{startPage=currentPage-5;endPage=currentPage+4;}}var startIndex=(currentPage-1)*pageSize;var endIndex=Math.min(startIndex+pageSize-1,totalItens-1);// create an array of pages to repeat in the pager control
var pages=[].concat(_toConsumableArray(Array(endPage+1-startPage).keys())).map(function(i){return startPage+i;});return{currentPage:currentPage,endIndex:endIndex,endPage:endPage,pageSize:pageSize,pages:pages,startIndex:startIndex,startPage:startPage,totalItens:totalItens,totalPages:totalPages};}},{key:'render',value:function render(){var _this2=this;var pager=this.state.pager;if(!pager.pages||pager.pages.length<=1){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_Pagination_Pagination_jsx__["a" /* default */],{color:'info',pages:[{disabled:pager.currentPage===1,onClick:function onClick(){return _this2.setPage(1);},text:"Primeira"},{disabled:pager.currentPage===1,onClick:function onClick(){return _this2.setPage(pager.currentPage-1);},text:"Anterior"}].concat(_toConsumableArray(pager.pages.map(function(page,index){return{active:pager.currentPage===page,onClick:function onClick(){return _this2.setPage(page);},text:page};})),[{disabled:pager.currentPage===pager.totalPages,onClick:function onClick(){return _this2.setPage(pager.currentPage+1);},text:"Próxima"},{disabled:pager.currentPage===pager.totalPages,onClick:function onClick(){return _this2.setPage(pager.totalPages);},text:"Última"}])}));}}]);return CustomPagination;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);CustomPagination.defaultProps={initialPage:1,pageSize:20};CustomPagination.propTypes={initialPage:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,items:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array.isRequired,onChangePage:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,pageSize:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,totalItens:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number};/* harmony default export */ __webpack_exports__["a"] = (CustomPagination);

/***/ }),
/* 931 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles_withStyles__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_Button__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_Button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_assets_jss_material_dashboard_pro_react_components_paginationStyle_jsx__ = __webpack_require__(932);
function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}// @material-ui/core components
function Pagination(_ref){var props=_objectWithoutProperties(_ref,[]);var classes=props.classes,pages=props.pages,color=props.color;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul",{className:classes.pagination},pages.map(function(prop,key){var _cx;var paginationLink=__WEBPACK_IMPORTED_MODULE_2_classnames___default()((_cx={},_defineProperty(_cx,classes.paginationLink,true),_defineProperty(_cx,classes[color],prop.active),_defineProperty(_cx,classes.disabled,prop.disabled),_cx));return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",{className:classes.paginationItem,key:key},prop.onClick!==undefined?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Button___default.a,{onClick:prop.onClick,className:paginationLink},prop.text):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Button___default.a,{onClick:function onClick(){return console.log("you've clicked "+prop.text);},className:paginationLink},prop.text));}));}Pagination.defaultProps={color:"primary"};Pagination.propTypes={classes:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,pages:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({active:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,disabled:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,text:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(["Primeira","Anterior","Próxima","Última"])]).isRequired,onClick:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func})).isRequired,color:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(["primary","info","success","warning","danger"])};/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles_withStyles___default()(__WEBPACK_IMPORTED_MODULE_5_assets_jss_material_dashboard_pro_react_components_paginationStyle_jsx__["a" /* default */])(Pagination));

/***/ }),
/* 932 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__ = __webpack_require__(21);
// ##############################
// // // Pagination component styles
// #############################
var paginationStyle={pagination:{display:"inline-block",paddingLeft:"0",margin:"20px 0",borderRadius:"4px"},paginationItem:{display:"inline"},paginationLink:{":first-of-type":{marginleft:"0"},border:"0",borderRadius:"30px !important",transition:"all .3s",padding:"0px 11px",margin:"0 3px",minWidth:"30px",height:"30px",minHeight:"auto",lineHeight:"30px",fontWeight:"400",fontSize:"12px",textTransform:"uppercase",background:"transparent",position:"relative",float:"left",textDecoration:"none",boxSizing:"border-box","&,&:hover,&:focus":{color:__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["l" /* grayColor */]},"&:hover,&:focus":{zIndex:"3",backgroundColor:"#eee",borderColor:"#ddd"},"&:hover":{cursor:"pointer"}},primary:{"&,&:hover,&:focus":{backgroundColor:__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["r" /* primaryColor */],borderColor:__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["r" /* primaryColor */],color:"#FFFFFF",boxShadow:"0 4px 5px 0 rgba(156, 39, 176, 0.14), 0 1px 10px 0 rgba(156, 39, 176, 0.12), 0 2px 4px -1px rgba(156, 39, 176, 0.2)"},"&:hover,&:focus":{zIndex:"2",cursor:"default"}},info:{"&,&:hover,&:focus":{backgroundColor:__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["o" /* infoColor */],borderColor:__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["o" /* infoColor */],color:"#FFFFFF",boxShadow:"0 4px 5px 0 rgba(0, 188, 212, 0.14), 0 1px 10px 0 rgba(0, 188, 212, 0.12), 0 2px 4px -1px rgba(0, 188, 212, 0.2)"},"&:hover,&:focus":{zIndex:"2",cursor:"default"}},success:{"&,&:hover,&:focus":{backgroundColor:__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["x" /* successColor */],borderColor:__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["x" /* successColor */],color:"#FFFFFF",boxShadow:"0 4px 5px 0 rgba(76, 175, 80, 0.14), 0 1px 10px 0 rgba(76, 175, 80, 0.12), 0 2px 4px -1px rgba(76, 175, 80, 0.2)"},"&:hover,&:focus":{zIndex:"2",cursor:"default"}},warning:{"&,&:hover,&:focus":{backgroundColor:__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["B" /* warningColor */],borderColor:__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["B" /* warningColor */],color:"#FFFFFF",boxShadow:"0 4px 5px 0 rgba(255, 152, 0, 0.14), 0 1px 10px 0 rgba(255, 152, 0, 0.12), 0 2px 4px -1px rgba(255, 152, 0, 0.2)"},"&:hover,&:focus":{zIndex:"2",cursor:"default"}},danger:{"&,&:hover,&:focus":{backgroundColor:__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["g" /* dangerColor */],borderColor:__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["g" /* dangerColor */],color:"#FFFFFF",boxShadow:"0 4px 5px 0 rgba(244, 67, 54, 0.14), 0 1px 10px 0 rgba(244, 67, 54, 0.12), 0 2px 4px -1px rgba(244, 67, 54, 0.2)"},"&:hover,&:focus":{zIndex:"2",cursor:"default"}},disabled:{"&,&:hover,&:focus":{color:"#777",cursor:"not-allowed",backgroundColor:"#fff",borderColor:"#ddd"}}};/* harmony default export */ __webpack_exports__["a"] = (paginationStyle);

/***/ }),
/* 933 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return fetchParametros; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return fetchReport; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return fetchReportPage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getRelatorioCSV; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__routes__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
var fetchParametros=function fetchParametros(){return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_1__routes__["a" /* default */].buscaCativo.parametros());};var fetchReport=function fetchReport(filtros){var atributos=filtros.atributos,cidades=filtros.cidades,cnaes=filtros.cnaes,divisoesCNAE=filtros.divisoesCNAE,estados=filtros.estados,gruposCNAE=filtros.gruposCNAE,classesCNAE=filtros.classesCNAE,ordenacao=filtros.ordenacao,regioes=filtros.regioes,sentidoOrdenacao=filtros.sentidoOrdenacao,subgroups=filtros.subgroups,submercados=filtros.submercados;var params={};if(submercados.length)params.submercados=Object(__WEBPACK_IMPORTED_MODULE_2_lodash__["map"])(submercados,'id');if(regioes.length)params.regioes=Object(__WEBPACK_IMPORTED_MODULE_2_lodash__["map"])(regioes,'id');if(estados.length)params.estados=Object(__WEBPACK_IMPORTED_MODULE_2_lodash__["map"])(estados,'id');if(cidades.length)params.cidades=Object(__WEBPACK_IMPORTED_MODULE_2_lodash__["map"])(cidades,'id');if(subgroups.length)params.subgroups=Object(__WEBPACK_IMPORTED_MODULE_2_lodash__["map"])(subgroups,'id');if(divisoesCNAE.length)params.divisoesCNAE=Object(__WEBPACK_IMPORTED_MODULE_2_lodash__["map"])(divisoesCNAE,'id');if(gruposCNAE.length)params.gruposCNAE=Object(__WEBPACK_IMPORTED_MODULE_2_lodash__["map"])(gruposCNAE,'id');if(classesCNAE.length)params.classesCNAE=Object(__WEBPACK_IMPORTED_MODULE_2_lodash__["map"])(classesCNAE,'id');if(cnaes.length)params.cnaes=Object(__WEBPACK_IMPORTED_MODULE_2_lodash__["map"])(cnaes,'id');params.filtroValores=Object(__WEBPACK_IMPORTED_MODULE_2_lodash__["compact"])(Object(__WEBPACK_IMPORTED_MODULE_2_lodash__["map"])(atributos,function(_ref){var condicao=_ref.condicao,tipo=_ref.tipo,unidade=_ref.unidade,valor=_ref.valor;if(tipo&&condicao&&unidade&&Object(__WEBPACK_IMPORTED_MODULE_2_lodash__["isNumber"])(valor)){return{atributo:tipo.id,condicao:condicao.id,unidade:unidade.id,valor:valor};}else{return false;}}));if(!params.filtroValores.length)delete params.filtroValores;if(ordenacao&&sentidoOrdenacao){params.ordenarPor=[{atributo:ordenacao.id,descendente:sentidoOrdenacao.id}];}return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_1__routes__["a" /* default */].buscaCativo.fetch(),params);};var fetchReportPage=function fetchReportPage(idRelatorio,pagina){return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_1__routes__["a" /* default */].buscaCativo.fetchNextPage(idRelatorio,pagina));};var getRelatorioCSV=function getRelatorioCSV(idRelatorio,pagina){return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_1__routes__["a" /* default */].buscaCativo.getRelatorioCSV(idRelatorio,pagina));};

/***/ }),
/* 934 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export DashboardComponent */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_file_download__ = __webpack_require__(267);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_file_download___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_js_file_download__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_select__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_styles_withStyles__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_styles_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_styles_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_select_lib_animated__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_select_lib_animated___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_select_lib_animated__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_CustomButtons_Button_jsx__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_CircularProgress__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_CircularProgress___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_CircularProgress__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_EnergyCompany_Input_Input__ = __webpack_require__(188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Dashboard__ = __webpack_require__(190);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__material_ui_icons_Delete__ = __webpack_require__(352);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__material_ui_icons_Delete___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__material_ui_icons_Delete__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__relatorio_partials_EmpresasFiltradas__ = __webpack_require__(353);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_services_utils__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_services_dados_gerais__ = __webpack_require__(354);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_services_reports__ = __webpack_require__(935);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var relatorioStyle=function relatorioStyle(theme){return{atributosWrapper:{display:"flex"},atributos:{display:"grid",gridColumnGap:"15px",gridRowGap:"15px",gridTemplateColumns:"repeat(auto-fit, minmax(150px, 1fr))",width:"100%"},atributosAction:{alignItems:"center",cursor:"pointer",display:"flex",marginLeft:"15px"},atributosActionWrapper:{display:"flex",alignItems:"flex-end",paddingBottom:"10px"},buscarButtonWrapper:{display:"flex",justifyContent:"flex-end",margin:"20px 0","& > div":{position:"relative"}},buttonProgress:{position:'absolute',top:'50%',left:'50%',marginTop:-12,marginLeft:-12},estados:{display:"grid",gridColumnGap:"15px",gridRowGap:"15px",gridTemplateColumns:"repeat(auto-fit, minmax(300px, 1fr))"},filtroWrapper:{marginBottom:"15px"},novoAtributo:{cursor:"pointer"},ordenaçãoWrapper:{display:"grid",gridColumnGap:"15px",gridRowGap:"15px",gridTemplateColumns:"repeat(auto-fit, minmax(250px, 1fr))"}};};var Relatorio=function(_Component){_inherits(Relatorio,_Component);function Relatorio(){var _ref;var _temp,_this,_ret;_classCallCheck(this,Relatorio);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=Relatorio.__proto__||Object.getPrototypeOf(Relatorio)).call.apply(_ref,[this].concat(args))),_this),_this.state=Object.assign({},_this.getPristineState()),_this.addAtributo=function(){_this.setState({atributos:_this.state.atributos.concat({uniqueId:Object(__WEBPACK_IMPORTED_MODULE_5_lodash__["uniqueId"])("atributo")})});},_this.removeAtributo=function(indexToRemove){_this.setState(function(prevState){var atributos=[].concat(_toConsumableArray(prevState.atributos));Object(__WEBPACK_IMPORTED_MODULE_5_lodash__["remove"])(atributos,function(val,index){return index===indexToRemove;});return{atributos:atributos};});},_this.clearSelections=function(){_this.setState(Object.assign({},_this.getPristineState(),{parametros:_this.state.parametros}));},_this.requestBuscaFiltrada=function(){var _this$state=_this.state,atributos=_this$state.atributos,cidades=_this$state.cidades,classesPerfilAgente=_this$state.classesPerfilAgente,cnaes=_this$state.cnaes,descontosPerfisAgentes=_this$state.descontosPerfisAgentes,estados=_this$state.estados,fontes=_this$state.fontes,ordenacao=_this$state.ordenacao,sentidoOrdenacao=_this$state.sentidoOrdenacao,submercados=_this$state.submercados;_this.setState({empresa:undefined,itens:undefined,loading:true,relatorio:undefined});Object(__WEBPACK_IMPORTED_MODULE_15_services_reports__["b" /* fetchReport */])({atributos:atributos,cidades:cidades,classesPerfilAgente:classesPerfilAgente,cnaes:cnaes,descontosPerfisAgentes:descontosPerfisAgentes,estados:estados,fontes:fontes,ordenacao:ordenacao,sentidoOrdenacao:sentidoOrdenacao,submercados:submercados}).then(function(_ref2){var data=_ref2.data;_this.setState({itens:data.relatorio.itens,loading:false,relatorio:data.relatorio});}).catch(function(){return _this.setState({loading:false});});},_this.requestNextPage=function(page){Object(__WEBPACK_IMPORTED_MODULE_15_services_reports__["c" /* fetchReportPage */])(_this.state.relatorio.id,page-1).then(function(_ref3){var data=_ref3.data;_this.setState({itens:data.relatorio.itens,relatorio:data.relatorio});});},_this.searchEmpresa=function(empresa){_this.setState({empresa:empresa});},_this.setEstadoAndFetchCidades=function(estados){_this.setState({estados:estados,loadingCidades:true});if(estados&&estados.length===1){Object(__WEBPACK_IMPORTED_MODULE_14_services_dados_gerais__["a" /* fetchCidades */])(estados[0].id).then(function(res){_this.setState({availableCidades:res.data,loadingCidades:false});});}else{_this.setState({availableCidades:[],cidades:[],loadingCidades:false});}},_this.updateAtributo=function(key,value,index){_this.setState(function(prevState){var atributos=[].concat(_toConsumableArray(prevState.atributos));atributos[index][key]=value;if(key==='tipo'){atributos[index]['condicao']=atributos[index]['condicao']||_this.state.parametros.condicoes[0];atributos[index]['valor']=atributos[index]['valor']||0;atributos[index]['unidade']=atributos[index]['unidade']||_this.state.parametros.unidades[0];}return{atributos:atributos};});},_this.updateSubmercado=function(value){if(value.length){_this.setState({cidades:[],estados:[],submercados:value});}else{_this.setState({submercados:value});}},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(Relatorio,[{key:"componentDidMount",value:function componentDidMount(){var _this2=this;Object(__WEBPACK_IMPORTED_MODULE_15_services_reports__["a" /* fetchParametros */])().then(function(_ref4){var data=_ref4.data;_this2.setState({parametros:data});});}},{key:"getPristineState",value:function getPristineState(){return{atributos:[{uniqueId:Object(__WEBPACK_IMPORTED_MODULE_5_lodash__["uniqueId"])("atributo")}],availableCidades:[],cidades:[],classesPerfilAgente:[],cnaes:[],descontosPerfisAgentes:[],empresa:undefined,estados:[],fontes:[],itens:undefined,loading:false,loadingCidades:false,ordenacao:"",parametros:{},relatorio:undefined,sentidoOrdenacao:"",submercados:[]};}},{key:"noOptionsMessage",value:function noOptionsMessage(options){return options?"Sem resultado":"Carregando...";}},{key:"render",value:function render(){var _this3=this;var classes=this.props.classes;var _state=this.state,atributos=_state.atributos,availableCidades=_state.availableCidades,cidades=_state.cidades,classesPerfilAgente=_state.classesPerfilAgente,cnaes=_state.cnaes,descontosPerfisAgentes=_state.descontosPerfisAgentes,empresa=_state.empresa,estados=_state.estados,fontes=_state.fontes,itens=_state.itens,loading=_state.loading,loadingCidades=_state.loadingCidades,ordenacao=_state.ordenacao,parametros=_state.parametros,relatorio=_state.relatorio,sentidoOrdenacao=_state.sentidoOrdenacao,submercados=_state.submercados;return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("div",{className:classes.filtroWrapper},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("h4",null,"Submercado"),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_select__["a" /* default */],{components:__WEBPACK_IMPORTED_MODULE_6_react_select_lib_animated__,getOptionLabel:function getOptionLabel(option){return option.nome;},getOptionValue:function getOptionValue(option){return option.id;},isDisabled:!!estados.length,isMulti:true,noOptionsMessage:function noOptionsMessage(){return _this3.noOptionsMessage(parametros.submercados);},onChange:this.updateSubmercado,options:parametros.submercados,placeholder:"Submercado",value:submercados})),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("div",{className:classes.filtroWrapper},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("div",{className:classes.estados},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("h4",null,"Estados"),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_select__["a" /* default */],{components:__WEBPACK_IMPORTED_MODULE_6_react_select_lib_animated__,getOptionLabel:function getOptionLabel(option){return option.nome;},getOptionValue:function getOptionValue(option){return option.id;},isClearable:true,isDisabled:!!submercados.length,isMulti:true,noOptionsMessage:function noOptionsMessage(){return _this3.noOptionsMessage(parametros.estados);},onChange:this.setEstadoAndFetchCidades,options:parametros.estados,placeholder:"Estados",value:estados})),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("h4",null,"Cidades"),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_select__["a" /* default */],{components:__WEBPACK_IMPORTED_MODULE_6_react_select_lib_animated__,getOptionLabel:function getOptionLabel(option){return Object(__WEBPACK_IMPORTED_MODULE_13_services_utils__["d" /* capitalizeString */])(option.nome);},getOptionValue:function getOptionValue(option){return option.id;},isDisabled:!!submercados.length||estados.length>1,isLoading:loadingCidades,isMulti:true,loadingMessage:function loadingMessage(){return"Carregando cidades...";},noOptionsMessage:function noOptionsMessage(){return"Sem resultado";},onChange:function onChange(e){return _this3.setState({cidades:e});},options:availableCidades,placeholder:"Cidades",value:cidades})))),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("div",{className:classes.filtroWrapper},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("h4",null,"Classes do Agente"),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_select__["a" /* default */],{components:__WEBPACK_IMPORTED_MODULE_6_react_select_lib_animated__,getOptionLabel:function getOptionLabel(option){return option.nome;},getOptionValue:function getOptionValue(option){return option.id;},isMulti:true,noOptionsMessage:function noOptionsMessage(){return _this3.noOptionsMessage(parametros.classesPerfilAgente);},onChange:function onChange(e){return _this3.setState({classesPerfilAgente:e});},options:parametros.classesPerfilAgente,placeholder:"Classe do Agente",value:classesPerfilAgente})),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("div",{className:classes.filtroWrapper},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("h4",null,"Descontos do Agente"),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_select__["a" /* default */],{components:__WEBPACK_IMPORTED_MODULE_6_react_select_lib_animated__,getOptionLabel:function getOptionLabel(option){return option.nome;},getOptionValue:function getOptionValue(option){return option.id;},isMulti:true,noOptionsMessage:function noOptionsMessage(){return _this3.noOptionsMessage(parametros.descontosPerfisAgentes);},onChange:function onChange(e){return _this3.setState({descontosPerfisAgentes:e});},options:parametros.descontosPerfisAgentes,placeholder:"Descontos do Agente",value:descontosPerfisAgentes})),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("div",{className:classes.filtroWrapper},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("h4",null,"CNAEs"),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_select__["a" /* default */],{components:__WEBPACK_IMPORTED_MODULE_6_react_select_lib_animated__,getOptionLabel:function getOptionLabel(option){return option.nome;},getOptionValue:function getOptionValue(option){return option.id;},isMulti:true,noOptionsMessage:function noOptionsMessage(){return _this3.noOptionsMessage(parametros.cnaes);},onChange:function onChange(e){return _this3.setState({cnaes:e});},options:Object(__WEBPACK_IMPORTED_MODULE_5_lodash__["orderBy"])(parametros.cnaes,["nome"]),placeholder:"CNAEs",value:cnaes})),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("div",{className:classes.filtroWrapper},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("h4",null,"Fontes de Energia"),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_select__["a" /* default */],{components:__WEBPACK_IMPORTED_MODULE_6_react_select_lib_animated__,getOptionLabel:function getOptionLabel(option){return option.nome;},getOptionValue:function getOptionValue(option){return option.id;},isMulti:true,noOptionsMessage:function noOptionsMessage(){return _this3.noOptionsMessage(parametros.fontesEnergia);},onChange:function onChange(e){return _this3.setState({fontes:e});},options:parametros.fontesEnergia,placeholder:"Fontes",value:fontes})),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("div",{className:classes.filtroWrapper},Object(__WEBPACK_IMPORTED_MODULE_5_lodash__["map"])(atributos,function(atributo,index){return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("div",{className:classes.filtroWrapper,key:atributo.uniqueId},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("div",{className:classes.atributosWrapper},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("div",{className:classes.atributos},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("h4",null,"Filtro"),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_select__["a" /* default */],{components:__WEBPACK_IMPORTED_MODULE_6_react_select_lib_animated__,getOptionLabel:function getOptionLabel(option){return option.nome;},getOptionValue:function getOptionValue(option){return option.id;},noOptionsMessage:function noOptionsMessage(){return _this3.noOptionsMessage(parametros.atributos);},onChange:function onChange(e){return _this3.updateAtributo('tipo',e,index);},options:parametros.atributos,placeholder:"Tipo",value:atributo.tipo})),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("h4",null,"Condi\xE7\xE3o"),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_select__["a" /* default */],{components:__WEBPACK_IMPORTED_MODULE_6_react_select_lib_animated__,getOptionLabel:function getOptionLabel(option){return option.nome;},getOptionValue:function getOptionValue(option){return option.id;},noOptionsMessage:function noOptionsMessage(){return _this3.noOptionsMessage(parametros.condicoes);},onChange:function onChange(e){return _this3.updateAtributo('condicao',e,index);},options:parametros.condicoes,placeholder:"Condi\xE7\xE3o",value:atributo.condicao})),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("h4",null,"Valor"),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_EnergyCompany_Input_Input__["a" /* default */],{onChange:function onChange(_ref5){var target=_ref5.target;return _this3.updateAtributo('valor',target.value===""?"":Number(target.value),index);},placeholder:"Valor",type:"number",value:Object(__WEBPACK_IMPORTED_MODULE_5_lodash__["isNumber"])(atributo.valor)?atributo.valor:""})),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("h4",null,"Unidade"),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_select__["a" /* default */],{components:__WEBPACK_IMPORTED_MODULE_6_react_select_lib_animated__,getOptionLabel:function getOptionLabel(option){return option.nome;},getOptionValue:function getOptionValue(option){return option.id;},label:"Unidade",noOptionsMessage:function noOptionsMessage(){return _this3.noOptionsMessage(parametros.unidades);},onChange:function onChange(e){return _this3.updateAtributo('unidade',e,index);},options:parametros.unidades,placeholder:"Unidade",value:atributo.unidade}))),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("div",{className:classes.atributosActionWrapper},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("div",{className:classes.atributosAction},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_icons_Delete___default.a,{onClick:function onClick(){return _this3.removeAtributo(index);}})))));}),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("a",{className:classes.novoAtributo,onClick:this.addAtributo},"+ Adicionar novo filtro")),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("div",{className:classes.ordenaçãoWrapper},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("h4",null,"Ordena\xE7\xE3o"),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_select__["a" /* default */],{components:__WEBPACK_IMPORTED_MODULE_6_react_select_lib_animated__,getOptionLabel:function getOptionLabel(option){return option.nome;},getOptionValue:function getOptionValue(option){return option.id;},noOptionsMessage:function noOptionsMessage(){return _this3.noOptionsMessage(parametros.atributosOrdenacao);},onChange:function onChange(e){return _this3.setState({ordenacao:e});},options:parametros.atributosOrdenacao,placeholder:"Ordena\xE7\xE3o",value:ordenacao})),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("h4",null,"Sentido da Ordena\xE7\xE3o"),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_select__["a" /* default */],{components:__WEBPACK_IMPORTED_MODULE_6_react_select_lib_animated__,getOptionLabel:function getOptionLabel(option){return option.nome;},getOptionValue:function getOptionValue(option){return option.id;},onChange:function onChange(e){return _this3.setState({sentidoOrdenacao:e});},options:[{id:false,nome:"A -> Z"},{id:true,nome:"Z -> A"}],placeholder:"Sentido da ordena\xE7\xE3o",value:sentidoOrdenacao}))),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("div",{className:classes.buscarButtonWrapper},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_CustomButtons_Button_jsx__["a" /* default */],{color:"rose",disabled:loading,onClick:this.clearSelections},"Limpar Filtros"),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_CustomButtons_Button_jsx__["a" /* default */],{color:"info",disabled:loading,onClick:this.requestBuscaFiltrada},"Buscar"),loading&&__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_CircularProgress___default.a,{className:classes.buttonProgress,size:24}))),itens&&itens.length>0&&__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__relatorio_partials_EmpresasFiltradas__["a" /* default */],{colunaFixa:{key:'nomePerfilAgente',label:'Perfil Agente'},downloadCSV:function downloadCSV(){Object(__WEBPACK_IMPORTED_MODULE_15_services_reports__["d" /* getRelatorioCSV */])(relatorio.id,0).then(function(response){__WEBPACK_IMPORTED_MODULE_0_js_file_download___default()(response.data,'empresas-relatorio.csv');});},itens:itens,relatorio:relatorio,requestNextPage:this.requestNextPage,searchEmpresa:this.searchEmpresa}),itens&&itens.length===0&&__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("h3",null,"Nenhuma empresa encontrada"),empresa&&__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__Dashboard__["a" /* default */],{selected:{id:empresa.idEmpresa},simplified:true}));}}]);return Relatorio;}(__WEBPACK_IMPORTED_MODULE_2_react__["Component"]);Relatorio.propTypes={classes:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired};/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_4__material_ui_core_styles_withStyles___default()(relatorioStyle)(Relatorio));

/***/ }),
/* 935 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return fetchParametros; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return fetchReport; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return fetchReportPage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getRelatorioCSV; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__routes__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
var fetchParametros=function fetchParametros(){return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_1__routes__["a" /* default */].relatorios.parametros());};var fetchReport=function fetchReport(filtros){var atributos=filtros.atributos,cidades=filtros.cidades,classesPerfilAgente=filtros.classesPerfilAgente,cnaes=filtros.cnaes,descontosPerfisAgentes=filtros.descontosPerfisAgentes,estados=filtros.estados,fontes=filtros.fontes,ordenacao=filtros.ordenacao,sentidoOrdenacao=filtros.sentidoOrdenacao,submercados=filtros.submercados;var params={};if(submercados.length)params.submercados=Object(__WEBPACK_IMPORTED_MODULE_2_lodash__["map"])(submercados,'id');if(estados.length)params.estados=Object(__WEBPACK_IMPORTED_MODULE_2_lodash__["map"])(estados,'id');if(cidades.length)params.cidades=Object(__WEBPACK_IMPORTED_MODULE_2_lodash__["map"])(cidades,'id');if(descontosPerfisAgentes.length)params.descontosPerfisAgentes=Object(__WEBPACK_IMPORTED_MODULE_2_lodash__["map"])(descontosPerfisAgentes,'id');if(classesPerfilAgente.length)params.classesPerfilAgente=Object(__WEBPACK_IMPORTED_MODULE_2_lodash__["map"])(classesPerfilAgente,'id');if(fontes.length)params.fontesEnergia=Object(__WEBPACK_IMPORTED_MODULE_2_lodash__["map"])(fontes,'id');if(cnaes.length)params.cnaes=Object(__WEBPACK_IMPORTED_MODULE_2_lodash__["map"])(cnaes,'id');params.filtroValores=Object(__WEBPACK_IMPORTED_MODULE_2_lodash__["compact"])(Object(__WEBPACK_IMPORTED_MODULE_2_lodash__["map"])(atributos,function(_ref){var condicao=_ref.condicao,tipo=_ref.tipo,unidade=_ref.unidade,valor=_ref.valor;if(tipo&&condicao&&unidade&&Object(__WEBPACK_IMPORTED_MODULE_2_lodash__["isNumber"])(valor)){return{atributo:tipo.id,condicao:condicao.id,unidade:unidade.id,valor:valor};}else{return false;}}));if(!params.filtroValores.length)delete params.filtroValores;if(ordenacao&&sentidoOrdenacao){params.ordenarPor=[{atributo:ordenacao.id,descendente:sentidoOrdenacao.id}];}return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_1__routes__["a" /* default */].relatorios.fetch(),params);};var fetchReportPage=function fetchReportPage(idRelatorio,pagina){return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_1__routes__["a" /* default */].relatorios.fetchNextPage(idRelatorio,pagina));};var getRelatorioCSV=function getRelatorioCSV(idRelatorio,pagina){return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_1__routes__["a" /* default */].relatorios.getRelatorioCSV(idRelatorio,pagina));};

/***/ }),
/* 936 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(9);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(10));

var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
  d: "M11.8 10.9c-2.27-.59-3-1.2-3-2.15 0-1.09 1.01-1.85 2.7-1.85 1.78 0 2.44.85 2.5 2.1h2.21c-.07-1.72-1.12-3.3-3.21-3.81V3h-3v2.16c-1.94.42-3.5 1.68-3.5 3.61 0 2.31 1.91 3.46 4.7 4.13 2.5.6 3 1.48 3 2.41 0 .69-.49 1.79-2.7 1.79-2.06 0-2.87-.92-2.98-2.1h-2.2c.12 2.19 1.76 3.42 3.68 3.83V21h3v-2.15c1.95-.37 3.5-1.5 3.5-3.55 0-2.84-2.43-3.81-4.7-4.4z"
}), _react.default.createElement("path", {
  fill: "none",
  d: "M0 0h24v24H0z"
})), 'AttachMoney');

exports.default = _default;

/***/ }),
/* 937 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(2);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(4));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _HiddenJs = _interopRequireDefault(__webpack_require__(938));

var _HiddenCss = _interopRequireDefault(__webpack_require__(941));

/**
 * Responsively hides children based on the selected implementation.
 */
function Hidden(props) {
  var implementation = props.implementation,
      other = (0, _objectWithoutProperties2.default)(props, ["implementation"]);

  if (implementation === 'js') {
    return _react.default.createElement(_HiddenJs.default, other);
  }

  return _react.default.createElement(_HiddenCss.default, other);
}

Hidden.propTypes =  false ? {
  /**
   * The content of the component.
   */
  children: _propTypes.default.node,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * Specify which implementation to use.  'js' is the default, 'css' works better for server
   * side rendering.
   */
  implementation: _propTypes.default.oneOf(['js', 'css']),

  /**
   * You can use this property when choosing the `js` implementation with server side rendering.
   *
   * As `window.innerWidth` is unavailable on the server,
   * we default to rendering an empty componenent during the first mount.
   * In some situation you might want to use an heristic to approximate
   * the screen width of the client browser screen width.
   *
   * For instance, you could be using the user-agent or the client-hints.
   * http://caniuse.com/#search=client%20hint
   */
  initialWidth: _propTypes.default.oneOf(['xs', 'sm', 'md', 'lg', 'xl']),

  /**
   * If true, screens this size and down will be hidden.
   */
  lgDown: _propTypes.default.bool,

  /**
   * If true, screens this size and up will be hidden.
   */
  lgUp: _propTypes.default.bool,

  /**
   * If true, screens this size and down will be hidden.
   */
  mdDown: _propTypes.default.bool,

  /**
   * If true, screens this size and up will be hidden.
   */
  mdUp: _propTypes.default.bool,

  /**
   * Hide the given breakpoint(s).
   */
  only: _propTypes.default.oneOfType([_propTypes.default.oneOf(['xs', 'sm', 'md', 'lg', 'xl']), _propTypes.default.arrayOf(_propTypes.default.oneOf(['xs', 'sm', 'md', 'lg', 'xl']))]),

  /**
   * If true, screens this size and down will be hidden.
   */
  smDown: _propTypes.default.bool,

  /**
   * If true, screens this size and up will be hidden.
   */
  smUp: _propTypes.default.bool,

  /**
   * If true, screens this size and down will be hidden.
   */
  xlDown: _propTypes.default.bool,

  /**
   * If true, screens this size and up will be hidden.
   */
  xlUp: _propTypes.default.bool,

  /**
   * If true, screens this size and down will be hidden.
   */
  xsDown: _propTypes.default.bool,

  /**
   * If true, screens this size and up will be hidden.
   */
  xsUp: _propTypes.default.bool
} : {};
Hidden.defaultProps = {
  implementation: 'js',
  lgDown: false,
  lgUp: false,
  mdDown: false,
  mdUp: false,
  smDown: false,
  smUp: false,
  xlDown: false,
  xlUp: false,
  xsDown: false,
  xsUp: false
};
var _default = Hidden;
exports.default = _default;

/***/ }),
/* 938 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(165);

var _interopRequireDefault = __webpack_require__(2);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _createBreakpoints = __webpack_require__(92);

var _withWidth = _interopRequireWildcard(__webpack_require__(939));

var _exactProp = _interopRequireDefault(__webpack_require__(95));

/**
 * @ignore - internal component.
 */
function HiddenJs(props) {
  var children = props.children,
      only = props.only,
      width = props.width;
  var visible = true; // `only` check is faster to get out sooner if used.

  if (only) {
    if (Array.isArray(only)) {
      for (var i = 0; i < only.length; i += 1) {
        var breakpoint = only[i];

        if (width === breakpoint) {
          visible = false;
          break;
        }
      }
    } else if (only && width === only) {
      visible = false;
    }
  } // Allow `only` to be combined with other props. If already hidden, no need to check others.


  if (visible) {
    // determine visibility based on the smallest size up
    for (var _i = 0; _i < _createBreakpoints.keys.length; _i += 1) {
      var _breakpoint = _createBreakpoints.keys[_i];
      var breakpointUp = props["".concat(_breakpoint, "Up")];
      var breakpointDown = props["".concat(_breakpoint, "Down")];

      if (breakpointUp && (0, _withWidth.isWidthUp)(_breakpoint, width) || breakpointDown && (0, _withWidth.isWidthDown)(_breakpoint, width)) {
        visible = false;
        break;
      }
    }
  }

  if (!visible) {
    return null;
  }

  return children;
}

HiddenJs.propTypes = {
  /**
   * The content of the component.
   */
  children: _propTypes.default.node,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * Specify which implementation to use.  'js' is the default, 'css' works better for server
   * side rendering.
   */
  implementation: _propTypes.default.oneOf(['js', 'css']),

  /**
   * You can use this property when choosing the `js` implementation with server side rendering.
   *
   * As `window.innerWidth` is unavailable on the server,
   * we default to rendering an empty componenent during the first mount.
   * In some situation you might want to use an heristic to approximate
   * the screen width of the client browser screen width.
   *
   * For instance, you could be using the user-agent or the client-hints.
   * http://caniuse.com/#search=client%20hint
   */
  initialWidth: _propTypes.default.oneOf(['xs', 'sm', 'md', 'lg', 'xl']),

  /**
   * If true, screens this size and down will be hidden.
   */
  lgDown: _propTypes.default.bool,

  /**
   * If true, screens this size and up will be hidden.
   */
  lgUp: _propTypes.default.bool,

  /**
   * If true, screens this size and down will be hidden.
   */
  mdDown: _propTypes.default.bool,

  /**
   * If true, screens this size and up will be hidden.
   */
  mdUp: _propTypes.default.bool,

  /**
   * Hide the given breakpoint(s).
   */
  only: _propTypes.default.oneOfType([_propTypes.default.oneOf(['xs', 'sm', 'md', 'lg', 'xl']), _propTypes.default.arrayOf(_propTypes.default.oneOf(['xs', 'sm', 'md', 'lg', 'xl']))]),

  /**
   * If true, screens this size and down will be hidden.
   */
  smDown: _propTypes.default.bool,

  /**
   * If true, screens this size and up will be hidden.
   */
  smUp: _propTypes.default.bool,

  /**
   * @ignore
   * width prop provided by withWidth decorator.
   */
  width: _propTypes.default.string.isRequired,

  /**
   * If true, screens this size and down will be hidden.
   */
  xlDown: _propTypes.default.bool,

  /**
   * If true, screens this size and up will be hidden.
   */
  xlUp: _propTypes.default.bool,

  /**
   * If true, screens this size and down will be hidden.
   */
  xsDown: _propTypes.default.bool,

  /**
   * If true, screens this size and up will be hidden.
   */
  xsUp: _propTypes.default.bool
};
HiddenJs.propTypes = (0, _exactProp.default)(HiddenJs.propTypes);

var _default = (0, _withWidth.default)()(HiddenJs);

exports.default = _default;

/***/ }),
/* 939 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(2);

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {};
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _withWidth.default;
  }
});

var _withWidth = _interopRequireDefault(__webpack_require__(940));

Object.keys(_withWidth).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _withWidth[key];
    }
  });
});

/***/ }),
/* 940 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(2);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.isWidthDown = exports.isWidthUp = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(6));

var _objectSpread2 = _interopRequireDefault(__webpack_require__(17));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(4));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(11));

var _createClass2 = _interopRequireDefault(__webpack_require__(12));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(13));

var _inherits2 = _interopRequireDefault(__webpack_require__(14));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _reactEventListener = _interopRequireDefault(__webpack_require__(102));

var _debounce = _interopRequireDefault(__webpack_require__(128));

var _wrapDisplayName = _interopRequireDefault(__webpack_require__(89));

var _hoistNonReactStatics = _interopRequireDefault(__webpack_require__(67));

var _withTheme = _interopRequireDefault(__webpack_require__(71));

var _createBreakpoints = __webpack_require__(92);

var _getThemeProps = _interopRequireDefault(__webpack_require__(241));

/* eslint-disable react/no-did-mount-set-state */
// < 1kb payload overhead when lodash/debounce is > 3kb.
// By default, returns true if screen width is the same or greater than the given breakpoint.
var isWidthUp = function isWidthUp(breakpoint, width) {
  var inclusive = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

  if (inclusive) {
    return _createBreakpoints.keys.indexOf(breakpoint) <= _createBreakpoints.keys.indexOf(width);
  }

  return _createBreakpoints.keys.indexOf(breakpoint) < _createBreakpoints.keys.indexOf(width);
}; // By default, returns true if screen width is the same or less than the given breakpoint.


exports.isWidthUp = isWidthUp;

var isWidthDown = function isWidthDown(breakpoint, width) {
  var inclusive = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

  if (inclusive) {
    return _createBreakpoints.keys.indexOf(width) <= _createBreakpoints.keys.indexOf(breakpoint);
  }

  return _createBreakpoints.keys.indexOf(width) < _createBreakpoints.keys.indexOf(breakpoint);
};

exports.isWidthDown = isWidthDown;

var withWidth = function withWidth() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return function (Component) {
    var _options$withTheme = options.withTheme,
        withThemeOption = _options$withTheme === void 0 ? false : _options$withTheme,
        _options$noSSR = options.noSSR,
        noSSR = _options$noSSR === void 0 ? false : _options$noSSR,
        initialWidthOption = options.initialWidth,
        _options$resizeInterv = options.resizeInterval,
        resizeInterval = _options$resizeInterv === void 0 ? 166 : _options$resizeInterv;

    var WithWidth =
    /*#__PURE__*/
    function (_React$Component) {
      (0, _inherits2.default)(WithWidth, _React$Component);

      function WithWidth(props) {
        var _this;

        (0, _classCallCheck2.default)(this, WithWidth);
        _this = (0, _possibleConstructorReturn2.default)(this, (WithWidth.__proto__ || Object.getPrototypeOf(WithWidth)).call(this, props));
        _this.handleResize = (0, _debounce.default)(function () {
          var width = _this.getWidth();

          if (width !== _this.state.width) {
            _this.setState({
              width: width
            });
          }
        }, resizeInterval);
        _this.state = {
          width: undefined
        };

        if (noSSR) {
          _this.state.width = _this.getWidth();
        }

        return _this;
      }

      (0, _createClass2.default)(WithWidth, [{
        key: "componentDidMount",
        value: function componentDidMount() {
          var width = this.getWidth();

          if (width !== this.state.width) {
            this.setState({
              width: width
            });
          }
        }
      }, {
        key: "componentWillUnmount",
        value: function componentWillUnmount() {
          this.handleResize.clear();
        }
      }, {
        key: "getWidth",
        value: function getWidth() {
          var innerWidth = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window.innerWidth;
          var breakpoints = this.props.theme.breakpoints;
          var width = null;
          /**
           * Start with the slowest value as low end devices often have a small screen.
           *
           * innerWidth |xs      sm      md      lg      xl
           *            |-------|-------|-------|-------|------>
           * width      |  xs   |  sm   |  md   |  lg   |  xl
           */

          var index = 1;

          while (width === null && index < _createBreakpoints.keys.length) {
            var currentWidth = _createBreakpoints.keys[index]; // @media are inclusive, so reproduce the behavior here.

            if (innerWidth < breakpoints.values[currentWidth]) {
              width = _createBreakpoints.keys[index - 1];
              break;
            }

            index += 1;
          }

          width = width || 'xl';
          return width;
        }
      }, {
        key: "render",
        value: function render() {
          var _props = this.props,
              initialWidth = _props.initialWidth,
              theme = _props.theme,
              width = _props.width,
              innerRef = _props.innerRef,
              other = (0, _objectWithoutProperties2.default)(_props, ["initialWidth", "theme", "width", "innerRef"]);
          var props = (0, _objectSpread2.default)({
            width: width || this.state.width || initialWidth || initialWidthOption || (0, _getThemeProps.default)({
              theme: theme,
              name: 'MuiWithWidth'
            }).initialWidth
          }, other);
          var more = {};

          if (withThemeOption) {
            more.theme = theme;
          } // When rendering the component on the server,
          // we have no idea about the client browser screen width.
          // In order to prevent blinks and help the reconciliation of the React tree
          // we are not rendering the child component.
          //
          // An alternative is to use the `initialWidth` property.


          if (props.width === undefined) {
            return null;
          }

          return _react.default.createElement(_reactEventListener.default, {
            target: "window",
            onResize: this.handleResize
          }, _react.default.createElement(Component, (0, _extends2.default)({}, more, props, {
            ref: innerRef
          })));
        }
      }]);
      return WithWidth;
    }(_react.default.Component);

    WithWidth.propTypes =  false ? {
      /**
       * As `window.innerWidth` is unavailable on the server,
       * we default to rendering an empty component during the first mount.
       * In some situation, you might want to use an heuristic to approximate
       * the screen width of the client browser screen width.
       *
       * For instance, you could be using the user-agent or the client-hints.
       * http://caniuse.com/#search=client%20hint
       */
      initialWidth: _propTypes.default.oneOf(['xs', 'sm', 'md', 'lg', 'xl']),

      /**
       * Use that property to pass a ref callback to the decorated component.
       */
      innerRef: _propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.object]),

      /**
       * @ignore
       */
      theme: _propTypes.default.object.isRequired,

      /**
       * Bypass the width calculation logic.
       */
      width: _propTypes.default.oneOf(['xs', 'sm', 'md', 'lg', 'xl'])
    } : {};

    if (false) {
      WithWidth.displayName = (0, _wrapDisplayName.default)(Component, 'WithWidth');
    }

    (0, _hoistNonReactStatics.default)(WithWidth, Component);
    return (0, _withTheme.default)()(WithWidth);
  };
};

var _default = withWidth;
exports.default = _default;

/***/ }),
/* 941 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(2);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(4));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(7));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _warning = _interopRequireDefault(__webpack_require__(16));

var _createBreakpoints = __webpack_require__(92);

var _helpers = __webpack_require__(37);

var _withStyles = _interopRequireDefault(__webpack_require__(3));

var styles = function styles(theme) {
  var hidden = {
    display: 'none'
  };
  return _createBreakpoints.keys.reduce(function (acc, key) {
    acc["only".concat((0, _helpers.capitalize)(key))] = (0, _defineProperty2.default)({}, theme.breakpoints.only(key), hidden);
    acc["".concat(key, "Up")] = (0, _defineProperty2.default)({}, theme.breakpoints.up(key), hidden);
    acc["".concat(key, "Down")] = (0, _defineProperty2.default)({}, theme.breakpoints.down(key), hidden);
    return acc;
  }, {});
};
/**
 * @ignore - internal component.
 */


function HiddenCss(props) {
  var children = props.children,
      classes = props.classes,
      className = props.className,
      lgDown = props.lgDown,
      lgUp = props.lgUp,
      mdDown = props.mdDown,
      mdUp = props.mdUp,
      only = props.only,
      smDown = props.smDown,
      smUp = props.smUp,
      xlDown = props.xlDown,
      xlUp = props.xlUp,
      xsDown = props.xsDown,
      xsUp = props.xsUp,
      other = (0, _objectWithoutProperties2.default)(props, ["children", "classes", "className", "lgDown", "lgUp", "mdDown", "mdUp", "only", "smDown", "smUp", "xlDown", "xlUp", "xsDown", "xsUp"]);
   false ? (0, _warning.default)(Object.keys(other).length === 0 || Object.keys(other).length === 1 && other.hasOwnProperty('ref'), "Material-UI: unsupported properties received ".concat(Object.keys(other).join(', '), " by `<Hidden />`.")) : void 0;
  var classNames = [];

  if (className) {
    classNames.push(className);
  }

  for (var i = 0; i < _createBreakpoints.keys.length; i += 1) {
    var breakpoint = _createBreakpoints.keys[i];
    var breakpointUp = props["".concat(breakpoint, "Up")];
    var breakpointDown = props["".concat(breakpoint, "Down")];

    if (breakpointUp) {
      classNames.push(classes["".concat(breakpoint, "Up")]);
    }

    if (breakpointDown) {
      classNames.push(classes["".concat(breakpoint, "Down")]);
    }
  }

  if (only) {
    var onlyBreakpoints = Array.isArray(only) ? only : [only];
    onlyBreakpoints.forEach(function (breakpoint) {
      classNames.push(classes["only".concat((0, _helpers.capitalize)(breakpoint))]);
    });
  }

  return _react.default.createElement("div", {
    className: classNames.join(' ')
  }, children);
}

HiddenCss.propTypes =  false ? {
  /**
   * The content of the component.
   */
  children: _propTypes.default.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * Specify which implementation to use.  'js' is the default, 'css' works better for server
   * side rendering.
   */
  implementation: _propTypes.default.oneOf(['js', 'css']),

  /**
   * If true, screens this size and down will be hidden.
   */
  lgDown: _propTypes.default.bool,

  /**
   * If true, screens this size and up will be hidden.
   */
  lgUp: _propTypes.default.bool,

  /**
   * If true, screens this size and down will be hidden.
   */
  mdDown: _propTypes.default.bool,

  /**
   * If true, screens this size and up will be hidden.
   */
  mdUp: _propTypes.default.bool,

  /**
   * Hide the given breakpoint(s).
   */
  only: _propTypes.default.oneOfType([_propTypes.default.oneOf(['xs', 'sm', 'md', 'lg', 'xl']), _propTypes.default.arrayOf(_propTypes.default.oneOf(['xs', 'sm', 'md', 'lg', 'xl']))]),

  /**
   * If true, screens this size and down will be hidden.
   */
  smDown: _propTypes.default.bool,

  /**
   * If true, screens this size and up will be hidden.
   */
  smUp: _propTypes.default.bool,

  /**
   * If true, screens this size and down will be hidden.
   */
  xlDown: _propTypes.default.bool,

  /**
   * If true, screens this size and up will be hidden.
   */
  xlUp: _propTypes.default.bool,

  /**
   * If true, screens this size and down will be hidden.
   */
  xsDown: _propTypes.default.bool,

  /**
   * If true, screens this size and up will be hidden.
   */
  xsUp: _propTypes.default.bool
} : {};

var _default = (0, _withStyles.default)(styles)(HiddenCss);

exports.default = _default;

/***/ }),
/* 942 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(2);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(6));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(7));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(4));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _classnames = _interopRequireDefault(__webpack_require__(5));

var _Typography = _interopRequireDefault(__webpack_require__(126));

var _withStyles = _interopRequireDefault(__webpack_require__(3));

var styles = {
  /* Styles applied to the root element. */
  root: {
    display: 'flex',
    maxHeight: '2em',
    alignItems: 'center'
  },

  /* Styles applied to the root element if `position="start"`. */
  positionStart: {
    marginRight: 8
  },

  /* Styles applied to the root element if `position="end"`. */
  positionEnd: {
    marginLeft: 8
  }
};
exports.styles = styles;

function InputAdornment(props) {
  var _classNames;

  var children = props.children,
      Component = props.component,
      classes = props.classes,
      className = props.className,
      disableTypography = props.disableTypography,
      position = props.position,
      other = (0, _objectWithoutProperties2.default)(props, ["children", "component", "classes", "className", "disableTypography", "position"]);
  return _react.default.createElement(Component, (0, _extends2.default)({
    className: (0, _classnames.default)(classes.root, (_classNames = {}, (0, _defineProperty2.default)(_classNames, classes.positionStart, position === 'start'), (0, _defineProperty2.default)(_classNames, classes.positionEnd, position === 'end'), _classNames), className)
  }, other), typeof children === 'string' && !disableTypography ? _react.default.createElement(_Typography.default, {
    color: "textSecondary"
  }, children) : children);
}

InputAdornment.propTypes =  false ? {
  /**
   * The content of the component, normally an `IconButton` or string.
   */
  children: _propTypes.default.node.isRequired,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * The component used for the root node.
   * Either a string to use a DOM element or a component.
   */
  component: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func, _propTypes.default.object]),

  /**
   * If children is a string then disable wrapping in a Typography component.
   */
  disableTypography: _propTypes.default.bool,

  /**
   * The position this adornment should appear relative to the `Input`.
   */
  position: _propTypes.default.oneOf(['start', 'end'])
} : {};
InputAdornment.defaultProps = {
  component: 'div',
  disableTypography: false
};

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiInputAdornment'
})(InputAdornment);

exports.default = _default;

/***/ }),
/* 943 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_autosuggest__ = __webpack_require__(286);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_autosuggest___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_autosuggest__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_autosuggest_highlight_match__ = __webpack_require__(287);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_autosuggest_highlight_match___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_autosuggest_highlight_match__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_MenuItem__ = __webpack_require__(135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_MenuItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_MenuItem__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_Paper__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_Paper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Paper__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_autosuggest_highlight_parse__ = __webpack_require__(289);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_autosuggest_highlight_parse___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_autosuggest_highlight_parse__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_TextField__ = __webpack_require__(189);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_TextField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_TextField__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_services_simulador__ = __webpack_require__(356);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_services_utils__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__material_ui_core_styles__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__material_ui_core_styles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_styles__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var styles=function styles(theme){return{container:{flexGrow:1,position:'relative'},suggestionsContainerOpen:{position:'absolute',left:0,marginTop:theme.spacing.unit,right:0,zIndex:1},suggestion:{display:'block',position:"relative","&:after":{content:'""',position:"absolute",bottom:"0",height:"1px",right:"15px",width:"calc(100% - 30px)",backgroundColor:"hsla(0, 3%, 20%, 0.3)"},"&:last-child":{"&:after":{content:"none"}}},suggestionsList:{listStyleType:'none',margin:0,padding:0}};};var AutosuggestCNPJAsync=function(_Component){_inherits(AutosuggestCNPJAsync,_Component);function AutosuggestCNPJAsync(){var _ref;var _temp,_this,_ret;_classCallCheck(this,AutosuggestCNPJAsync);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=AutosuggestCNPJAsync.__proto__||Object.getPrototypeOf(AutosuggestCNPJAsync)).call.apply(_ref,[this].concat(args))),_this),_this.state={suggestions:[],value:_this.props.defaultValue},_this.handleSuggestionsFetchRequested=function(_ref2){var value=_ref2.value;if(value.length>=5){_this.loadSuggestions(value);}},_this.handleSuggestionsClearRequested=function(){_this.setState({suggestions:[]});},_this.handleChange=function(event,_ref3){var newValue=_ref3.newValue;_this.setState({value:newValue});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(AutosuggestCNPJAsync,[{key:'componentDidUpdate',value:function componentDidUpdate(prevProps){if(prevProps.defaultValue!==this.props.defaultValue&&this.props.defaultValue!==''){this.setState({value:this.props.defaultValue});}}},{key:'getSuggestionValue',value:function getSuggestionValue(suggestion){return suggestion.name;}// Método chamado quando tem um onChange no input.
},{key:'loadSuggestions',value:function loadSuggestions(value){var _this2=this;var onlyNumbers=value.replace(/\D/g,'');Object(__WEBPACK_IMPORTED_MODULE_8_services_simulador__["a" /* buscarCNPJ */])(onlyNumbers).then(function(res){var hasData=res.data&&res.data.length!==0;if(hasData){_this2.setState({suggestions:res.data});}else{_this2.setState({suggestions:[{name:"Buscar no Mercado Cativo",cnpj:value,id:"CATIVO"}]});}});}},{key:'renderInput',value:function renderInput(inputProps){var classes=inputProps.classes,ref=inputProps.ref,other=_objectWithoutProperties(inputProps,['classes','ref']);return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_TextField___default.a,{fullWidth:true,InputProps:Object.assign({inputRef:ref,classes:{input:classes.input}},other)});}},{key:'renderSuggestion',value:function renderSuggestion(suggestion,_ref4){var query=_ref4.query,isHighlighted=_ref4.isHighlighted;var matches=__WEBPACK_IMPORTED_MODULE_1_autosuggest_highlight_match___default()(suggestion.name,query);var parts=__WEBPACK_IMPORTED_MODULE_5_autosuggest_highlight_parse___default()(suggestion.name,matches);var formattedCNPJ=Object(__WEBPACK_IMPORTED_MODULE_9_services_utils__["a" /* CNPJMask */])(suggestion.cnpj);var subtext=formattedCNPJ+' '+(suggestion.city?Object(__WEBPACK_IMPORTED_MODULE_9_services_utils__["d" /* capitalizeString */])(suggestion.city):"")+' '+(suggestion.stateCode?"- "+suggestion.stateCode:"");return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_MenuItem___default.a,{component:'div',selected:isHighlighted},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',null,parts.map(function(part,index){return part.highlight?__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('span',{key:String(index),style:{fontWeight:300}},part.text):__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('strong',{key:String(index),style:{fontWeight:500}},part.text);}))),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_MenuItem___default.a,{component:'div',selected:isHighlighted},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',null,subtext)));}},{key:'renderSuggestionsContainer',value:function renderSuggestionsContainer(options){var containerProps=options.containerProps,children=options.children;return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Paper___default.a,Object.assign({},containerProps,{square:true}),children);}},{key:'render',value:function render(){var _props=this.props,classes=_props.classes,onHandleSelected=_props.onHandleSelected,placeholder=_props.placeholder;var _state=this.state,suggestions=_state.suggestions,value=_state.value;return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react_autosuggest___default.a,{getSuggestionValue:this.getSuggestionValue,inputProps:{autoFocus:true,classes:classes,onChange:this.handleChange,placeholder:placeholder,value:value},onSuggestionsClearRequested:this.handleSuggestionsClearRequested,onSuggestionSelected:function onSuggestionSelected(event,_ref5){var suggestion=_ref5.suggestion;return onHandleSelected(suggestion);},onSuggestionsFetchRequested:this.handleSuggestionsFetchRequested,renderInputComponent:this.renderInput,renderSuggestion:this.renderSuggestion,renderSuggestionsContainer:this.renderSuggestionsContainer,suggestions:suggestions,theme:{container:classes.container,suggestionsContainerOpen:classes.suggestionsContainerOpen,suggestionsList:classes.suggestionsList,suggestion:classes.suggestion}});}}]);return AutosuggestCNPJAsync;}(__WEBPACK_IMPORTED_MODULE_3_react__["Component"]);AutosuggestCNPJAsync.defaultProps={defaultValue:'',placeholder:'Buscar empresa por Nome ou CNPJ'};AutosuggestCNPJAsync.propTypes={classes:__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object.isRequired,defaultValue:__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,onHandleSelected:__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func.isRequired,placeholder:__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_styles__["withStyles"])(styles)(AutosuggestCNPJAsync));

/***/ }),
/* 944 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ResultadoSimuladorCativoLivreComponent */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_styles_withStyles__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_styles_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_styles_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_services_utils__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_EnergyCompany_Grid_InfoGrid_jsx__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_EnergyCompany_Grid_InfoGridItem_jsx__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_Table_Table_jsx__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_Tooltip__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_Tooltip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Tooltip__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_assets_EnergyCompany_jss_lightTooltip__ = __webpack_require__(76);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var simuladorStyle=function simuladorStyle(theme){return Object.assign({spacedInfo:{justifyContent:"space-between",display:"flex",width:"90%"},centeredInfo:{justifyContent:"center",display:"flex",width:"90%"},dataWrapper:{display:"flex",flexDirection:"column",alignItems:"center"},tooltipLabel:{marginRight:'10px'},tableWrapper:{"& table":{width:"1500px","& tr td":{borderRight:"1px solid #dddddd",fontWeight:"500","&:first-child":{fontWeight:"bold",width:"220px"},"&:last-child":{borderRight:"none"}}}}},Object(__WEBPACK_IMPORTED_MODULE_9_assets_EnergyCompany_jss_lightTooltip__["a" /* default */])(theme));};var ResultadoSimuladorCativoLivre=function(_Component){_inherits(ResultadoSimuladorCativoLivre,_Component);function ResultadoSimuladorCativoLivre(){_classCallCheck(this,ResultadoSimuladorCativoLivre);return _possibleConstructorReturn(this,(ResultadoSimuladorCativoLivre.__proto__||Object.getPrototypeOf(ResultadoSimuladorCativoLivre)).apply(this,arguments));}_createClass(ResultadoSimuladorCativoLivre,[{key:"getTableData",value:function getTableData(){var _props=this.props,classes=_props.classes,resultadoEconomia=_props.resultadoEconomia;var comparacoesAnuais=resultadoEconomia.comparacoesAnuais,descricoesCustos=resultadoEconomia.descricoesCustos;var anos=Object(__WEBPACK_IMPORTED_MODULE_3_lodash__["keys"])(comparacoesAnuais);var getTooltip=function getTooltip(value,details){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Tooltip___default.a,{classes:{popper:classes.lightTooltipPopper,tooltip:classes.lightTooltip},placement:"top",title:details.length?Object(__WEBPACK_IMPORTED_MODULE_3_lodash__["map"])(details,function(detail,index){var parts=detail.split(':');return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{key:index},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("b",{className:classes.tooltipLabel},parts[0],":"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span",null,parts[1]));}):'Sem detalhes no momento.'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span",null,value));};// Linhas da descrição
var data=Object(__WEBPACK_IMPORTED_MODULE_3_lodash__["map"])(descricoesCustos,function(_ref){var descricao=_ref.descricao;return[__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("b",{key:"0"},descricao)].concat(_toConsumableArray(Object(__WEBPACK_IMPORTED_MODULE_3_lodash__["map"])(anos,function(ano){var custoCativo=Object(__WEBPACK_IMPORTED_MODULE_3_lodash__["get"])(comparacoesAnuais[ano],"custosCativo["+descricao+"].custo",0);var custoCativoDetalhado=Object(__WEBPACK_IMPORTED_MODULE_3_lodash__["get"])(comparacoesAnuais[ano],"custosCativo["+descricao+"].custoDetalhado",[]);var custoLivre=Object(__WEBPACK_IMPORTED_MODULE_3_lodash__["get"])(comparacoesAnuais[ano],"custosLivre["+descricao+"].custo",0);var custoLivreDetalhado=Object(__WEBPACK_IMPORTED_MODULE_3_lodash__["get"])(comparacoesAnuais[ano],"custosLivre["+descricao+"].custoDetalhado",[]);return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:classes.dataWrapper,key:ano},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:classes.spacedInfo},getTooltip(Object(__WEBPACK_IMPORTED_MODULE_4_services_utils__["g" /* numberToBRL */])(custoCativo),custoCativoDetalhado),getTooltip(Object(__WEBPACK_IMPORTED_MODULE_4_services_utils__["g" /* numberToBRL */])(custoLivre),custoLivreDetalhado)));})));});// Total
data.push([__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("b",{key:"0"},"Total")].concat(_toConsumableArray(Object(__WEBPACK_IMPORTED_MODULE_3_lodash__["map"])(anos,function(ano){var custoCativo=Object(__WEBPACK_IMPORTED_MODULE_3_lodash__["get"])(comparacoesAnuais[ano],"economia.custoCativo",0);var custoLivre=Object(__WEBPACK_IMPORTED_MODULE_3_lodash__["get"])(comparacoesAnuais[ano],"economia.custoLivre",0);return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:classes.dataWrapper,key:ano},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:classes.spacedInfo},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span",null,Object(__WEBPACK_IMPORTED_MODULE_4_services_utils__["g" /* numberToBRL */])(custoCativo)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span",null,Object(__WEBPACK_IMPORTED_MODULE_4_services_utils__["g" /* numberToBRL */])(custoLivre))));}))));// Economia
data.push([__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("b",{key:"0"},"Economia")].concat(_toConsumableArray(Object(__WEBPACK_IMPORTED_MODULE_3_lodash__["map"])(anos,function(ano){var economia=Object(__WEBPACK_IMPORTED_MODULE_3_lodash__["get"])(comparacoesAnuais[ano],"economia.economia",0);var economiaPercentual=Object(__WEBPACK_IMPORTED_MODULE_3_lodash__["get"])(comparacoesAnuais[ano],"economia.economiaPercentual",0);return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:classes.dataWrapper,key:ano},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:classes.centeredInfo},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span",null,Object(__WEBPACK_IMPORTED_MODULE_4_services_utils__["g" /* numberToBRL */])(economia)," (",economiaPercentual.toFixed(2),"%)")));}))));// BreakEven
data.push([__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("b",{key:"0"},"BreakEven")].concat(_toConsumableArray(Object(__WEBPACK_IMPORTED_MODULE_3_lodash__["map"])(anos,function(ano){var breakEven=Object(__WEBPACK_IMPORTED_MODULE_3_lodash__["get"])(comparacoesAnuais[ano],"precoBreakEven",0);return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:classes.dataWrapper,key:ano},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:classes.centeredInfo},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span",null,Object(__WEBPACK_IMPORTED_MODULE_4_services_utils__["g" /* numberToBRL */])(breakEven))));}))));return data;}},{key:"getTableHead",value:function getTableHead(){var _props2=this.props,classes=_props2.classes,resultadoEconomia=_props2.resultadoEconomia;var anos=Object(__WEBPACK_IMPORTED_MODULE_3_lodash__["keys"])(resultadoEconomia.comparacoesAnuais);return[__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("b",{key:"0"},"Dados")].concat(_toConsumableArray(Object(__WEBPACK_IMPORTED_MODULE_3_lodash__["map"])(anos,function(ano){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:classes.dataWrapper,key:ano},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("b",null,ano),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:classes.spacedInfo},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("b",null,"Cativo"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("b",null,"Livre")));})));}},{key:"render",value:function render(){var _props3=this.props,classes=_props3.classes,resultadoEconomia=_props3.resultadoEconomia;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("h3",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("b",null,"Resultado")),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("h6",null,"Passe o mouse sobre os valores para ver mais detalhes."),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:classes.tableWrapper},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_Table_Table_jsx__["a" /* default */],{tableData:this.getTableData(),tableHead:this.getTableHead(),tableHeaderColor:"primary"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_EnergyCompany_Grid_InfoGrid_jsx__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_EnergyCompany_Grid_InfoGridItem_jsx__["a" /* default */],{label:"Total Cativo",modifiers:["forceNewFullRowModifier"],value:Object(__WEBPACK_IMPORTED_MODULE_4_services_utils__["g" /* numberToBRL */])(Object(__WEBPACK_IMPORTED_MODULE_3_lodash__["get"])(resultadoEconomia,"comparacaoTotal.economia.custoCativo",0))}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_EnergyCompany_Grid_InfoGridItem_jsx__["a" /* default */],{label:"Total Livre",modifiers:["forceNewFullRowModifier"],value:Object(__WEBPACK_IMPORTED_MODULE_4_services_utils__["g" /* numberToBRL */])(Object(__WEBPACK_IMPORTED_MODULE_3_lodash__["get"])(resultadoEconomia,"comparacaoTotal.economia.custoLivre",0))}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_EnergyCompany_Grid_InfoGridItem_jsx__["a" /* default */],{label:"Economia",modifiers:["forceNewFullRowModifier"],value:Object(__WEBPACK_IMPORTED_MODULE_4_services_utils__["g" /* numberToBRL */])(Object(__WEBPACK_IMPORTED_MODULE_3_lodash__["get"])(resultadoEconomia,"comparacaoTotal.economia.economia",0))+" ("+Object(__WEBPACK_IMPORTED_MODULE_3_lodash__["get"])(resultadoEconomia,"comparacaoTotal.economia.economiaPercentual",0).toFixed(2)+"%)"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_EnergyCompany_Grid_InfoGridItem_jsx__["a" /* default */],{label:"Break Even",modifiers:["forceNewFullRowModifier"],value:Object(__WEBPACK_IMPORTED_MODULE_4_services_utils__["g" /* numberToBRL */])(Object(__WEBPACK_IMPORTED_MODULE_3_lodash__["get"])(resultadoEconomia,"comparacaoTotal.precoBreakEven",0))}))));}}]);return ResultadoSimuladorCativoLivre;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);ResultadoSimuladorCativoLivre.propTypes={classes:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object.isRequired,resultadoEconomia:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({comparacaoTotal:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object.isRequired,comparacoesAnuais:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object.isRequired,descricoesCustos:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.array.isRequired}).isRequired};/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_2__material_ui_core_styles_withStyles___default()(simuladorStyle)(ResultadoSimuladorCativoLivre));

/***/ }),
/* 945 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__material_ui_icons_Fingerprint__ = __webpack_require__(946);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__material_ui_icons_Fingerprint___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__material_ui_icons_Fingerprint__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__material_ui_icons_PermIdentity__ = __webpack_require__(360);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__material_ui_icons_PermIdentity___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__material_ui_icons_PermIdentity__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_styles_withStyles__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_styles_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_styles_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_redux__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_EnergyCompany_BouncingLoader_BouncingLoader_jsx__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_CustomButtons_Button_jsx__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_CustomInput_CustomInput_jsx__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_EnergyCompany_Cards_ECCard_jsx__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_components_Grid_GridContainer_jsx__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_components_Grid_GridItem_jsx__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_services_utils__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_reducers_user_actions__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_services_auth__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_reducers_alerts_actions__ = __webpack_require__(100);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// import ProfileCard from "components/EnergyCompany/Cards/ProfileCard.jsx";
// import avatar from "assets/img/faces/marc.jpg";
var styles={forgetPassword:{cursor:"pointer",marginLeft:"10px"}};var UserProfile=function(_Component){_inherits(UserProfile,_Component);function UserProfile(){var _ref;var _temp,_this,_ret;_classCallCheck(this,UserProfile);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=UserProfile.__proto__||Object.getPrototypeOf(UserProfile)).call.apply(_ref,[this].concat(args))),_this),_this.state={confirmacaoSenha:"",cpf:"",nome:"",senha:"",senhaAntiga:"",sobrenome:"",telefone:"",updatingInfo:false,updatingPassword:false},_this.forgetPassword=function(){var email=_this.props.user.info.email;_this.setState({updatingPassword:true});Object(__WEBPACK_IMPORTED_MODULE_15_services_auth__["e" /* forgetPassword */])(email).then(function(){_this.props.showAlert({message:__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("span",null,"E-mail enviado para ",__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("strong",null,email)),type:"info"});_this.setState({updatingPassword:false});}).catch(function(err){console.error(err);});},_this.updateUserInfo=function(){var _this$state=_this.state,cpf=_this$state.cpf,nome=_this$state.nome,sobrenome=_this$state.sobrenome,telefone=_this$state.telefone;_this.setState({updatingInfo:true});_this.props.updateUserInfo({cpf:cpf,nome:nome,sobrenome:sobrenome,telefone:Object(__WEBPACK_IMPORTED_MODULE_13_services_utils__["h" /* removeNonDigits */])(telefone)}).then(function(){_this.props.showAlert({message:"Informações atualizadas com sucesso.",type:"info"});_this.setState({updatingInfo:false});}).catch(function(){_this.props.showAlert({message:"Não conseguimos atualizar suas informações, por favor tente mais tarde.",type:"error"});_this.setState({updatingInfo:false});});},_this.updatePassword=function(){var _this$state2=_this.state,confirmacaoSenha=_this$state2.confirmacaoSenha,senha=_this$state2.senha,senhaAntiga=_this$state2.senhaAntiga;_this.setState({updatingPassword:true});Object(__WEBPACK_IMPORTED_MODULE_15_services_auth__["j" /* updateUserPassword */])({confirmacaoSenha:confirmacaoSenha,senha:senha,senhaAntiga:senhaAntiga}).then(function(){_this.props.showAlert({message:"Senha atualizada com sucesso.",type:"info"});_this.setState({confirmacaoSenha:"",senha:"",senhaAntiga:"",updatingPassword:false});}).catch(function(error){_this.props.showAlert({message:Object(__WEBPACK_IMPORTED_MODULE_6_lodash__["values"])(error.response.data).join(' '),type:"error"});_this.setState({updatingPassword:false});});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(UserProfile,[{key:"componentDidMount",value:function componentDidMount(){this.setUserInfo();}},{key:"componentDidUpdate",value:function componentDidUpdate(prevProps){if(!Object(__WEBPACK_IMPORTED_MODULE_6_lodash__["isEqual"])(prevProps.user,this.props.user)){this.setUserInfo();}}},{key:"setUserInfo",value:function setUserInfo(){var info=this.props.user.info;if(info){this.setState({cpf:info.cpf||"",nome:info.nome||"",sobrenome:info.sobrenome||"",telefone:info.telefone||""});}}},{key:"render",value:function render(){var _this2=this;var _state=this.state,confirmacaoSenha=_state.confirmacaoSenha,cpf=_state.cpf,nome=_state.nome,senha=_state.senha,senhaAntiga=_state.senhaAntiga,sobrenome=_state.sobrenome,telefone=_state.telefone,updatingInfo=_state.updatingInfo,updatingPassword=_state.updatingPassword;return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components_Grid_GridContainer_jsx__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_components_Grid_GridItem_jsx__["a" /* default */],{md:12,sm:12,xs:12},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_EnergyCompany_Cards_ECCard_jsx__["a" /* default */],{content:__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components_Grid_GridContainer_jsx__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_components_Grid_GridItem_jsx__["a" /* default */],{md:6,sm:12,xs:12},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_CustomInput_CustomInput_jsx__["a" /* default */],{error:!nome,formControlProps:{fullWidth:true},inputProps:{disabled:updatingInfo,onChange:function onChange(e){return _this2.setState({nome:e.target.value});},value:nome},labelText:"Nome*"})),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_components_Grid_GridItem_jsx__["a" /* default */],{md:6,sm:12,xs:12},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_CustomInput_CustomInput_jsx__["a" /* default */],{error:!sobrenome,formControlProps:{fullWidth:true},inputProps:{disabled:updatingInfo,onChange:function onChange(e){return _this2.setState({sobrenome:e.target.value});},value:sobrenome},labelText:"Sobrenome*"}))),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components_Grid_GridContainer_jsx__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_components_Grid_GridItem_jsx__["a" /* default */],{md:6,sm:12,xs:12},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_CustomInput_CustomInput_jsx__["a" /* default */],{error:!telefone,formControlProps:{fullWidth:true},inputProps:{disabled:updatingInfo,onChange:function onChange(e){return _this2.setState({telefone:e.target.value});},value:Object(__WEBPACK_IMPORTED_MODULE_13_services_utils__["j" /* telefoneMask */])(telefone)},labelText:"Telefone*"})),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_components_Grid_GridItem_jsx__["a" /* default */],{md:6,sm:12,xs:12},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_CustomInput_CustomInput_jsx__["a" /* default */],{formControlProps:{fullWidth:true},inputProps:{disabled:true,value:Object(__WEBPACK_IMPORTED_MODULE_13_services_utils__["c" /* CPFMask */])(cpf)},labelText:"CPF"})),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_components_Grid_GridItem_jsx__["a" /* default */],{md:6,sm:12,xs:12},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_CustomInput_CustomInput_jsx__["a" /* default */],{formControlProps:{fullWidth:true},inputProps:{disabled:true,value:Object(__WEBPACK_IMPORTED_MODULE_6_lodash__["get"])(this.props.user,"info.email","")},labelText:"Email"}))),updatingInfo?__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_EnergyCompany_BouncingLoader_BouncingLoader_jsx__["a" /* default */],null):__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_CustomButtons_Button_jsx__["a" /* default */],{color:"rose",disabled:!nome||!sobrenome||!telefone||Object(__WEBPACK_IMPORTED_MODULE_13_services_utils__["h" /* removeNonDigits */])(telefone).length<11,onClick:this.updateUserInfo},"Editar Informa\xE7\xF5es")),icon:__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_icons_PermIdentity___default.a,null),title:"Perfil"})),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_components_Grid_GridItem_jsx__["a" /* default */],{md:12,sm:12,xs:12},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_EnergyCompany_Cards_ECCard_jsx__["a" /* default */],{content:__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components_Grid_GridContainer_jsx__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_components_Grid_GridItem_jsx__["a" /* default */],{md:6,sm:12,xs:12},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_CustomInput_CustomInput_jsx__["a" /* default */],{formControlProps:{fullWidth:true},inputProps:{autoComplete:"current-password",onChange:function onChange(e){return _this2.setState({senhaAntiga:e.target.value});},type:"password",value:senhaAntiga},labelText:"Senha Atual"}))),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components_Grid_GridContainer_jsx__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_components_Grid_GridItem_jsx__["a" /* default */],{md:6,sm:12,xs:12},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_CustomInput_CustomInput_jsx__["a" /* default */],{formControlProps:{fullWidth:true},inputProps:{autoComplete:"new-password",onChange:function onChange(e){return _this2.setState({senha:e.target.value});},type:"password",value:senha},labelText:"Nova Senha"})),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_components_Grid_GridItem_jsx__["a" /* default */],{md:6,sm:12,xs:12},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_CustomInput_CustomInput_jsx__["a" /* default */],{formControlProps:{fullWidth:true},inputProps:{autoComplete:"new-password",onChange:function onChange(e){return _this2.setState({confirmacaoSenha:e.target.value});},type:"password",value:confirmacaoSenha},labelText:"Confirmar Nova Senha"}))),updatingPassword?__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_EnergyCompany_BouncingLoader_BouncingLoader_jsx__["a" /* default */],null):__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_CustomButtons_Button_jsx__["a" /* default */],{color:"rose",disabled:!confirmacaoSenha||!senha||!senhaAntiga,onClick:this.updatePassword},"Salvar nova senha"),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("a",{className:this.props.classes.forgetPassword,onClick:this.forgetPassword},"Esqueceu a senha?"))),icon:__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_icons_Fingerprint___default.a,null),title:"Senha"}))));}}]);return UserProfile;}(__WEBPACK_IMPORTED_MODULE_3_react__["Component"]);UserProfile.propTypes={classes:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired,showAlert:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,updateUserInfo:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,user:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired};var mapStateToProps=function mapStateToProps(state){return{user:state.user};};var mapDispatchToProps={showAlert:__WEBPACK_IMPORTED_MODULE_16_reducers_alerts_actions__["b" /* showAlert */],updateUserInfo:__WEBPACK_IMPORTED_MODULE_14_reducers_user_actions__["f" /* updateUserInfo */]};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_5_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_styles_withStyles___default()(styles)(UserProfile)));

/***/ }),
/* 946 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(9);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(10));

var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
  d: "M17.81 4.47c-.08 0-.16-.02-.23-.06C15.66 3.42 14 3 12.01 3c-1.98 0-3.86.47-5.57 1.41-.24.13-.54.04-.68-.2-.13-.24-.04-.55.2-.68C7.82 2.52 9.86 2 12.01 2c2.13 0 3.99.47 6.03 1.52.25.13.34.43.21.67-.09.18-.26.28-.44.28zM3.5 9.72c-.1 0-.2-.03-.29-.09-.23-.16-.28-.47-.12-.7.99-1.4 2.25-2.5 3.75-3.27C9.98 4.04 14 4.03 17.15 5.65c1.5.77 2.76 1.86 3.75 3.25.16.22.11.54-.12.7-.23.16-.54.11-.7-.12-.9-1.26-2.04-2.25-3.39-2.94-2.87-1.47-6.54-1.47-9.4.01-1.36.7-2.5 1.7-3.4 2.96-.08.14-.23.21-.39.21zm6.25 12.07c-.13 0-.26-.05-.35-.15-.87-.87-1.34-1.43-2.01-2.64-.69-1.23-1.05-2.73-1.05-4.34 0-2.97 2.54-5.39 5.66-5.39s5.66 2.42 5.66 5.39c0 .28-.22.5-.5.5s-.5-.22-.5-.5c0-2.42-2.09-4.39-4.66-4.39-2.57 0-4.66 1.97-4.66 4.39 0 1.44.32 2.77.93 3.85.64 1.15 1.08 1.64 1.85 2.42.19.2.19.51 0 .71-.11.1-.24.15-.37.15zm7.17-1.85c-1.19 0-2.24-.3-3.1-.89-1.49-1.01-2.38-2.65-2.38-4.39 0-.28.22-.5.5-.5s.5.22.5.5c0 1.41.72 2.74 1.94 3.56.71.48 1.54.71 2.54.71.24 0 .64-.03 1.04-.1.27-.05.53.13.58.41.05.27-.13.53-.41.58-.57.11-1.07.12-1.21.12zM14.91 22c-.04 0-.09-.01-.13-.02-1.59-.44-2.63-1.03-3.72-2.1-1.4-1.39-2.17-3.24-2.17-5.22 0-1.62 1.38-2.94 3.08-2.94 1.7 0 3.08 1.32 3.08 2.94 0 1.07.93 1.94 2.08 1.94s2.08-.87 2.08-1.94c0-3.77-3.25-6.83-7.25-6.83-2.84 0-5.44 1.58-6.61 4.03-.39.81-.59 1.76-.59 2.8 0 .78.07 2.01.67 3.61.1.26-.03.55-.29.64-.26.1-.55-.04-.64-.29-.49-1.31-.73-2.61-.73-3.96 0-1.2.23-2.29.68-3.24 1.33-2.79 4.28-4.6 7.51-4.6 4.55 0 8.25 3.51 8.25 7.83 0 1.62-1.38 2.94-3.08 2.94s-3.08-1.32-3.08-2.94c0-1.07-.93-1.94-2.08-1.94s-2.08.87-2.08 1.94c0 1.71.66 3.31 1.87 4.51.95.94 1.86 1.46 3.27 1.85.27.07.42.35.35.61-.05.23-.26.38-.47.38z"
}), _react.default.createElement("path", {
  fill: "none",
  d: "M0 0h24v24H0z"
})), 'Fingerprint');

exports.default = _default;

/***/ }),
/* 947 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__ = __webpack_require__(21);
// ##############################
// // // Footer styles
// #############################
var footerStyle={block:{},left:{float:"left!important",display:"block"},right:{margin:"0",fontSize:"14px",float:"right!important",padding:"15px"},footer:Object.assign({bottom:"0",borderTop:"1px solid #e7e7e7",padding:"15px 0"},__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["i" /* defaultFont */],{zIndex:4}),container:Object.assign({zIndex:3},__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["c" /* container */],{position:"relative"}),containerFluid:Object.assign({zIndex:3},__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["d" /* containerFluid */],{position:"relative"}),a:{color:__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["r" /* primaryColor */],textDecoration:"none",backgroundColor:"transparent"},list:{marginBottom:"0",padding:"0",marginTop:"0"},inlineBlock:{display:"inline-block",padding:"0",width:"auto"},whiteColor:{"&,&:hover,&:focus":{color:"#FFFFFF"}}};/* harmony default export */ __webpack_exports__["a"] = (footerStyle);

/***/ }),
/* 948 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(2);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _AppBar.default;
  }
});

var _AppBar = _interopRequireDefault(__webpack_require__(949));

/***/ }),
/* 949 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(2);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(6));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(7));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(4));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _classnames = _interopRequireDefault(__webpack_require__(5));

var _withStyles = _interopRequireDefault(__webpack_require__(3));

var _helpers = __webpack_require__(37);

var _Paper = _interopRequireDefault(__webpack_require__(51));

// @inheritedComponent Paper
var styles = function styles(theme) {
  var backgroundColorDefault = theme.palette.type === 'light' ? theme.palette.grey[100] : theme.palette.grey[900];
  return {
    /* Styles applied to the root element. */
    root: {
      display: 'flex',
      flexDirection: 'column',
      width: '100%',
      boxSizing: 'border-box',
      // Prevent padding issue with the Modal and fixed positioned AppBar.
      zIndex: theme.zIndex.appBar,
      flexShrink: 0
    },

    /* Styles applied to the root element if `position="fixed"`. */
    positionFixed: {
      position: 'fixed',
      top: 0,
      left: 'auto',
      right: 0
    },

    /* Styles applied to the root element if `position="absolute"`. */
    positionAbsolute: {
      position: 'absolute',
      top: 0,
      left: 'auto',
      right: 0
    },

    /* Styles applied to the root element if `position="sticky"`. */
    positionSticky: {
      position: 'sticky',
      top: 0,
      left: 'auto',
      right: 0
    },

    /* Styles applied to the root element if `position="static"`. */
    positionStatic: {
      position: 'static'
    },

    /* Styles applied to the root element if `color="default"`. */
    colorDefault: {
      backgroundColor: backgroundColorDefault,
      color: theme.palette.getContrastText(backgroundColorDefault)
    },

    /* Styles applied to the root element if `color="primary"`. */
    colorPrimary: {
      backgroundColor: theme.palette.primary.main,
      color: theme.palette.primary.contrastText
    },

    /* Styles applied to the root element if `color="secondary"`. */
    colorSecondary: {
      backgroundColor: theme.palette.secondary.main,
      color: theme.palette.secondary.contrastText
    }
  };
};

exports.styles = styles;

function AppBar(props) {
  var _classNames;

  var children = props.children,
      classes = props.classes,
      classNameProp = props.className,
      color = props.color,
      position = props.position,
      other = (0, _objectWithoutProperties2.default)(props, ["children", "classes", "className", "color", "position"]);
  var className = (0, _classnames.default)(classes.root, classes["position".concat((0, _helpers.capitalize)(position))], (_classNames = {}, (0, _defineProperty2.default)(_classNames, classes["color".concat((0, _helpers.capitalize)(color))], color !== 'inherit'), (0, _defineProperty2.default)(_classNames, 'mui-fixed', position === 'fixed'), _classNames), classNameProp);
  return _react.default.createElement(_Paper.default, (0, _extends2.default)({
    square: true,
    component: "header",
    elevation: 4,
    className: className
  }, other), children);
}

AppBar.propTypes =  false ? {
  /**
   * The content of the component.
   */
  children: _propTypes.default.node.isRequired,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * The color of the component. It supports those theme colors that make sense for this component.
   */
  color: _propTypes.default.oneOf(['inherit', 'primary', 'secondary', 'default']),

  /**
   * The positioning type. The behavior of the different options is described
   * [here](https://developer.mozilla.org/en-US/docs/Learn/CSS/CSS_layout/Positioning).
   * Note: `sticky` is not universally supported and will fall back to `static` when unavailable.
   */
  position: _propTypes.default.oneOf(['fixed', 'absolute', 'sticky', 'static'])
} : {};
AppBar.defaultProps = {
  color: 'primary',
  position: 'fixed'
};

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiAppBar'
})(AppBar);

exports.default = _default;

/***/ }),
/* 950 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(2);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Toolbar.default;
  }
});

var _Toolbar = _interopRequireDefault(__webpack_require__(951));

/***/ }),
/* 951 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(2);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(6));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(7));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(4));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _classnames = _interopRequireDefault(__webpack_require__(5));

var _withStyles = _interopRequireDefault(__webpack_require__(3));

var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      position: 'relative',
      display: 'flex',
      alignItems: 'center'
    },

    /* Styles applied to the root element if `disableGutters={false}`. */
    gutters: theme.mixins.gutters(),

    /* Styles applied to the root element if `variant="regular"`. */
    regular: theme.mixins.toolbar,

    /* Styles applied to the root element if `variant="dense"`. */
    dense: {
      minHeight: 48
    }
  };
};

exports.styles = styles;

function Toolbar(props) {
  var children = props.children,
      classes = props.classes,
      classNameProp = props.className,
      disableGutters = props.disableGutters,
      variant = props.variant,
      other = (0, _objectWithoutProperties2.default)(props, ["children", "classes", "className", "disableGutters", "variant"]);
  var className = (0, _classnames.default)(classes.root, classes[variant], (0, _defineProperty2.default)({}, classes.gutters, !disableGutters), classNameProp);
  return _react.default.createElement("div", (0, _extends2.default)({
    className: className
  }, other), children);
}

Toolbar.propTypes =  false ? {
  /**
   * Toolbar children, usually a mixture of `IconButton`, `Button` and `Typography`.
   */
  children: _propTypes.default.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * If `true`, disables gutter padding.
   */
  disableGutters: _propTypes.default.bool,

  /**
   * The variant to use.
   */
  variant: _propTypes.default.oneOf(['regular', 'dense'])
} : {};
Toolbar.defaultProps = {
  disableGutters: false,
  variant: 'regular'
};

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiToolbar'
})(Toolbar);

exports.default = _default;

/***/ }),
/* 952 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(9);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(10));

var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
  fill: "none",
  d: "M0 0h24v24H0z"
}), _react.default.createElement("path", {
  d: "M3 18h18v-2H3v2zm0-5h18v-2H3v2zm0-7v2h18V6H3z"
})), 'Menu');

exports.default = _default;

/***/ }),
/* 953 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(9);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(10));

var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
  fill: "none",
  d: "M0 0h24v24H0z"
}), _react.default.createElement("path", {
  d: "M12 8c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"
})), 'MoreVert');

exports.default = _default;

/***/ }),
/* 954 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(9);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(10));

var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
  d: "M4 14h4v-4H4v4zm0 5h4v-4H4v4zM4 9h4V5H4v4zm5 5h12v-4H9v4zm0 5h12v-4H9v4zM9 5v4h12V5H9z"
}), _react.default.createElement("path", {
  fill: "none",
  d: "M0 0h24v24H0z"
})), 'ViewList');

exports.default = _default;

/***/ }),
/* 955 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(2);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _ClickAwayListener.default;
  }
});

var _ClickAwayListener = _interopRequireDefault(__webpack_require__(956));

/***/ }),
/* 956 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(2);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(6));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(4));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(11));

var _createClass2 = _interopRequireDefault(__webpack_require__(12));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(13));

var _inherits2 = _interopRequireDefault(__webpack_require__(14));

var _react = _interopRequireDefault(__webpack_require__(0));

var _reactDom = _interopRequireDefault(__webpack_require__(24));

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _reactEventListener = _interopRequireDefault(__webpack_require__(102));

var _ownerDocument = _interopRequireDefault(__webpack_require__(48));

// @inheritedComponent EventListener

/**
 * Listen for click events that occur somewhere in the document, outside of the element itself.
 * For instance, if you need to hide a menu when people click anywhere else on your page.
 */
var ClickAwayListener =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(ClickAwayListener, _React$Component);

  function ClickAwayListener() {
    var _ref;

    var _temp, _this;

    (0, _classCallCheck2.default)(this, ClickAwayListener);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return (0, _possibleConstructorReturn2.default)(_this, (_temp = _this = (0, _possibleConstructorReturn2.default)(this, (_ref = ClickAwayListener.__proto__ || Object.getPrototypeOf(ClickAwayListener)).call.apply(_ref, [this].concat(args))), _this.node = null, _this.mounted = null, _this.handleClickAway = function (event) {
      // Ignore events that have been `event.preventDefault()` marked.
      if (event.defaultPrevented) {
        return;
      } // IE11 support, which trigger the handleClickAway even after the unbind


      if (!_this.mounted) {
        return;
      } // The child might render null.


      if (!_this.node) {
        return;
      }

      var doc = (0, _ownerDocument.default)(_this.node);

      if (doc.documentElement && doc.documentElement.contains(event.target) && !_this.node.contains(event.target)) {
        _this.props.onClickAway(event);
      }
    }, _temp));
  }

  (0, _createClass2.default)(ClickAwayListener, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      // Finds the first child when a component returns a fragment.
      // https://github.com/facebook/react/blob/036ae3c6e2f056adffc31dfb78d1b6f0c63272f0/packages/react-dom/src/__tests__/ReactDOMFiber-test.js#L105
      this.node = _reactDom.default.findDOMNode(this);
      this.mounted = true;
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.mounted = false;
    }
  }, {
    key: "render",
    value: function render() {
      var _props = this.props,
          children = _props.children,
          mouseEvent = _props.mouseEvent,
          touchEvent = _props.touchEvent,
          onClickAway = _props.onClickAway,
          other = (0, _objectWithoutProperties2.default)(_props, ["children", "mouseEvent", "touchEvent", "onClickAway"]);
      var listenerProps = {};

      if (mouseEvent !== false) {
        listenerProps[mouseEvent] = this.handleClickAway;
      }

      if (touchEvent !== false) {
        listenerProps[touchEvent] = this.handleClickAway;
      }

      return _react.default.createElement(_reactEventListener.default, (0, _extends2.default)({
        target: "document"
      }, listenerProps, other), children);
    }
  }]);
  return ClickAwayListener;
}(_react.default.Component);

ClickAwayListener.propTypes =  false ? {
  /**
   * The wrapped element.
   */
  children: _propTypes.default.element.isRequired,

  /**
   * The mouse event to listen to. You can disable the listener by providing `false`.
   */
  mouseEvent: _propTypes.default.oneOf(['onClick', 'onMouseDown', 'onMouseUp', false]),

  /**
   * Callback fired when a "click away" event is detected.
   */
  onClickAway: _propTypes.default.func.isRequired,

  /**
   * The touch event to listen to. You can disable the listener by providing `false`.
   */
  touchEvent: _propTypes.default.oneOf(['onTouchStart', 'onTouchEnd', false])
} : {};
ClickAwayListener.defaultProps = {
  mouseEvent: 'onMouseUp',
  touchEvent: 'onTouchEnd'
};
var _default = ClickAwayListener;
exports.default = _default;

/***/ }),
/* 957 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(9);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(10));

var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
  fill: "none",
  d: "M0 0h24v24H0V0z"
}), _react.default.createElement("path", {
  d: "M19.43 12.98c.04-.32.07-.64.07-.98s-.03-.66-.07-.98l2.11-1.65c.19-.15.24-.42.12-.64l-2-3.46c-.12-.22-.39-.3-.61-.22l-2.49 1c-.52-.4-1.08-.73-1.69-.98l-.38-2.65C14.46 2.18 14.25 2 14 2h-4c-.25 0-.46.18-.49.42l-.38 2.65c-.61.25-1.17.59-1.69.98l-2.49-1c-.23-.09-.49 0-.61.22l-2 3.46c-.13.22-.07.49.12.64l2.11 1.65c-.04.32-.07.65-.07.98s.03.66.07.98l-2.11 1.65c-.19.15-.24.42-.12.64l2 3.46c.12.22.39.3.61.22l2.49-1c.52.4 1.08.73 1.69.98l.38 2.65c.03.24.24.42.49.42h4c.25 0 .46-.18.49-.42l.38-2.65c.61-.25 1.17-.59 1.69-.98l2.49 1c.23.09.49 0 .61-.22l2-3.46c.12-.22.07-.49-.12-.64l-2.11-1.65zM12 15.5c-1.93 0-3.5-1.57-3.5-3.5s1.57-3.5 3.5-3.5 3.5 1.57 3.5 3.5-1.57 3.5-3.5 3.5z"
})), 'SettingsRounded');

exports.default = _default;

/***/ }),
/* 958 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_assets_jss_material_dashboard_pro_react_components_customDropdownStyle_jsx__ = __webpack_require__(959);
function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}// ##############################
// // // HeaderLinks styles
// #############################
var headerLinksStyle=function headerLinksStyle(theme){var _searchRTL,_notifications;return Object.assign({},Object(__WEBPACK_IMPORTED_MODULE_1_assets_jss_material_dashboard_pro_react_components_customDropdownStyle_jsx__["a" /* default */])(theme),{search:_defineProperty({margin:"0",paddingTop:"7px",paddingBottom:"7px"},theme.breakpoints.down("sm"),{margin:"10px 15px",float:"none !important",paddingTop:"1px",paddingBottom:"1px",padding:"10px 15px",width:"auto"}),searchInput:{paddingTop:"2px"},searchRTL:(_searchRTL={},_defineProperty(_searchRTL,theme.breakpoints.down("sm"),{marginRight:"18px !important"}),_defineProperty(_searchRTL,theme.breakpoints.up("md"),{marginLeft:"12px"}),_searchRTL),linkText:Object.assign({zIndex:"4"},__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["i" /* defaultFont */],{fontSize:"14px",margin:"0!important",textTransform:"none"}),buttonLink:_defineProperty({},theme.breakpoints.down("sm"),{display:"flex",margin:"5px 15px 0",width:"auto",height:"auto","& svg":{width:"30px",height:"24px",marginRight:"19px",marginLeft:"3px"},"& .fab,& .fas,& .far,& .fal,& .material-icons":{width:"30px",fontSize:"24px",lineHeight:"30px",marginRight:"19px",marginLeft:"3px"}}),searchButton:_defineProperty({},theme.breakpoints.down("sm"),{top:"-50px !important",marginRight:"38px",float:"right"}),top:{zIndex:"4"},searchIcon:{width:"17px",zIndex:"4"},links:_defineProperty({width:"20px",height:"20px",zIndex:"4"},theme.breakpoints.down("sm"),{display:"block",width:"30px",height:"30px",color:"inherit",opacity:"0.8",marginRight:"16px",marginLeft:"-5px"}),notifications:(_notifications={zIndex:"4"},_defineProperty(_notifications,theme.breakpoints.up("md"),{position:"absolute",top:"5px",border:"1px solid #FFF",right:"5px",fontSize:"9px",background:__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["g" /* dangerColor */],color:"#FFFFFF",minWidth:"16px",height:"16px",borderRadius:"10px",textAlign:"center",lineHeight:"14px",verticalAlign:"middle",display:"block"}),_defineProperty(_notifications,theme.breakpoints.down("sm"),Object.assign({},__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["i" /* defaultFont */],{fontSize:"14px",marginRight:"8px"})),_notifications),wrapperRTL:_defineProperty({},theme.breakpoints.up("md"),{paddingLeft:"16px"}),buttonLinkRTL:_defineProperty({},theme.breakpoints.down("sm"),{alignItems:"center",justifyContent:"flex-end",width:"-webkit-fill-available",margin:"10px 15px 0",padding:"10px 15px",display:"block",position:"relative"}),labelRTL:_defineProperty({},theme.breakpoints.down("sm"),{flexDirection:"row-reverse",justifyContent:"initial",display:"flex"}),linksRTL:_defineProperty({},theme.breakpoints.down("sm"),{marginRight:"-5px !important",marginLeft:"16px !important"}),managerClasses:_defineProperty({},theme.breakpoints.up("md"),{display:"inline-block"}),headerLinksSvg:{width:"20px !important",height:"20px !important"}});};/* harmony default export */ __webpack_exports__["a"] = (headerLinksStyle);

/***/ }),
/* 959 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__ = __webpack_require__(21);
function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var customDropdownStyle=function customDropdownStyle(theme){return{popperClose:{pointerEvents:"none",display:"none !important"},dropdown:{borderRadius:"3px",border:"0",boxShadow:"0 2px 5px 0 rgba(0, 0, 0, 0.26)",top:"100%",zIndex:"1000",minWidth:"160px",padding:"5px 0",margin:"2px 0 0",fontSize:"14px",textAlign:"left",listStyle:"none",backgroundColor:"#fff",backgroundClip:"padding-box"},menuList:{padding:"0"},pooperResponsive:_defineProperty({zIndex:"2"},theme.breakpoints.down("sm"),{zIndex:"1640",position:"static",float:"none",width:"auto",marginTop:"0",backgroundColor:"transparent",border:"0",boxShadow:"none",color:"black"}),pooperNav:_defineProperty({},theme.breakpoints.down("sm"),{color:"inherit",position:"static !important",left:"unset !important",top:"unset !important",transform:"none !important",willChange:"unset !important",boxShadow:"none !important","& > div":{boxShadow:"none !important",marginLeft:"0",marginRight:"0",transition:"none !important",marginTop:"0px !important",marginBottom:"5px !important",padding:"0px !important",backgroundColor:"transparent !important","& > ul li":{color:"inherit"}}}),dropdownItem:Object.assign({},__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["i" /* defaultFont */],{fontSize:"13px",padding:"10px 20px",margin:"0 5px",borderRadius:"2px",position:"relative",transition:"all 150ms linear",display:"block",clear:"both",fontWeight:"400",height:"fit-content",color:"#333",whiteSpace:"nowrap"}),dropdownItemRTL:{textAlign:"right !important"},blackHover:{"&:hover":{boxShadow:"0 4px 20px 0px rgba(0, 0, 0, 0.14), 0 7px 10px -5px rgba(33, 33, 33, 0.4)",backgroundColor:"#212121",color:"#fff"}},primaryHover:{"&:hover":Object.assign({backgroundColor:__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["r" /* primaryColor */],color:"#FFFFFF"},__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["p" /* primaryBoxShadow */])},dropdownDividerItem:{margin:"5px 0",backgroundColor:"rgba(0, 0, 0, 0.12)",height:"1px",overflow:"hidden"},buttonIcon:{width:"20px",height:"20px"},caret:{transition:"all 150ms ease-in",display:"inline-block",width:"0",height:"0",marginLeft:"4px",verticalAlign:"middle",borderTop:"4px solid",borderRight:"4px solid transparent",borderLeft:"4px solid transparent"},caretActive:{transform:"rotate(180deg)"},caretDropup:{transform:"rotate(180deg)"},caretRTL:{marginRight:"4px"},dropdownHeader:{display:"block",padding:"0.1875rem 1.25rem",fontSize:"0.75rem",lineHeight:"1.428571",color:"#777",whiteSpace:"nowrap",fontWeight:"inherit",marginTop:"10px","&:hover,&:focus":{backgroundColor:"transparent",cursor:"auto"}}};};/* harmony default export */ __webpack_exports__["a"] = (customDropdownStyle);

/***/ }),
/* 960 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__ = __webpack_require__(21);
// ##############################
// // // Header styles
// #############################
var headerStyle=function headerStyle(theme){return{appBar:{backgroundColor:"transparent",boxShadow:"none",borderBottom:"0",marginBottom:"0",position:"absolute",width:"100%",paddingTop:"10px",zIndex:"1029",color:"#555555",border:"0",borderRadius:"3px",padding:"10px 0",transition:"all 150ms ease 0s",minHeight:"50px",display:"block"},container:Object.assign({},__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["d" /* containerFluid */],{minHeight:"50px"}),flex:{flex:1},title:Object.assign({},__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["i" /* defaultFont */],{lineHeight:"30px",fontSize:"18px",borderRadius:"3px",textTransform:"none",color:"inherit",paddingTop:"0.625rem",paddingBottom:"0.625rem",margin:"0 !important","&:hover,&:focus":{background:"transparent"}}),primary:Object.assign({backgroundColor:__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["r" /* primaryColor */],color:"#FFFFFF"},__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["h" /* defaultBoxShadow */]),info:Object.assign({backgroundColor:__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["o" /* infoColor */],color:"#FFFFFF"},__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["h" /* defaultBoxShadow */]),success:Object.assign({backgroundColor:__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["x" /* successColor */],color:"#FFFFFF"},__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["h" /* defaultBoxShadow */]),warning:Object.assign({backgroundColor:__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["B" /* warningColor */],color:"#FFFFFF"},__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["h" /* defaultBoxShadow */]),danger:Object.assign({backgroundColor:__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["g" /* dangerColor */],color:"#FFFFFF"},__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["h" /* defaultBoxShadow */]),sidebarMinimize:{float:"left",padding:"0 0 0 15px",display:"block",color:"#555555"},sidebarMinimizeRTL:{padding:"0 15px 0 0 !important"},sidebarMiniIcon:{width:"20px",height:"17px"}};};/* harmony default export */ __webpack_exports__["a"] = (headerStyle);

/***/ }),
/* 961 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(9);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(10));

var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
  d: "M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"
}), _react.default.createElement("path", {
  fill: "none",
  d: "M0 0h24v24H0z"
})), 'Person');

exports.default = _default;

/***/ }),
/* 962 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(2);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Drawer.default;
  }
});

var _Drawer = _interopRequireDefault(__webpack_require__(963));

/***/ }),
/* 963 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(2);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isHorizontal = isHorizontal;
exports.getAnchor = getAnchor;
exports.default = exports.styles = void 0;

var _objectSpread2 = _interopRequireDefault(__webpack_require__(17));

var _extends2 = _interopRequireDefault(__webpack_require__(6));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(7));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(4));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(11));

var _createClass2 = _interopRequireDefault(__webpack_require__(12));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(13));

var _inherits2 = _interopRequireDefault(__webpack_require__(14));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _classnames = _interopRequireDefault(__webpack_require__(5));

var _Modal = _interopRequireDefault(__webpack_require__(134));

var _withStyles = _interopRequireDefault(__webpack_require__(3));

var _Slide = _interopRequireDefault(__webpack_require__(964));

var _Paper = _interopRequireDefault(__webpack_require__(51));

var _helpers = __webpack_require__(37);

var _transitions = __webpack_require__(93);

var oppositeDirection = {
  left: 'right',
  right: 'left',
  top: 'down',
  bottom: 'up'
};

function isHorizontal(props) {
  return ['left', 'right'].indexOf(props.anchor) !== -1;
}

function getAnchor(props) {
  return props.theme.direction === 'rtl' && isHorizontal(props) ? oppositeDirection[props.anchor] : props.anchor;
}

var styles = function styles(theme) {
  return {
    /* Styles applied to the root element if `variant="permanent or persistent"`. */
    docked: {
      flex: '0 0 auto'
    },

    /* Styles applied to the `Paper` component. */
    paper: {
      overflowY: 'auto',
      display: 'flex',
      flexDirection: 'column',
      height: '100vh',
      flex: '1 0 auto',
      zIndex: theme.zIndex.drawer,
      WebkitOverflowScrolling: 'touch',
      // Add iOS momentum scrolling.
      // temporary style
      position: 'fixed',
      top: 0,
      // We disable the focus ring for mouse, touch and keyboard users.
      // At some point, it would be better to keep it for keyboard users.
      // :focus-ring CSS pseudo-class will help.
      outline: 'none'
    },

    /* Styles applied to the `Paper` component if `anchor="left"`. */
    paperAnchorLeft: {
      left: 0,
      right: 'auto'
    },

    /* Styles applied to the `Paper` component if `anchor="right"`. */
    paperAnchorRight: {
      left: 'auto',
      right: 0
    },

    /* Styles applied to the `Paper` component if `anchor="top"`. */
    paperAnchorTop: {
      top: 0,
      left: 0,
      bottom: 'auto',
      right: 0,
      height: 'auto',
      maxHeight: '100vh'
    },

    /* Styles applied to the `Paper` component if `anchor="bottom"`. */
    paperAnchorBottom: {
      top: 'auto',
      left: 0,
      bottom: 0,
      right: 0,
      height: 'auto',
      maxHeight: '100vh'
    },

    /* Styles applied to the `Paper` component if `anchor="left"` & `variant` is not "temporary". */
    paperAnchorDockedLeft: {
      borderRight: "1px solid ".concat(theme.palette.divider)
    },

    /* Styles applied to the `Paper` component if `anchor="top"` & `variant` is not "temporary". */
    paperAnchorDockedTop: {
      borderBottom: "1px solid ".concat(theme.palette.divider)
    },

    /* Styles applied to the `Paper` component if `anchor="right"` & `variant` is not "temporary". */
    paperAnchorDockedRight: {
      borderLeft: "1px solid ".concat(theme.palette.divider)
    },

    /* Styles applied to the `Paper` component if `anchor="bottom"` & `variant` is not "temporary". */
    paperAnchorDockedBottom: {
      borderTop: "1px solid ".concat(theme.palette.divider)
    },

    /* Styles applied to the `Modal` component. */
    modal: {}
  };
};
/**
 * The properties of the [Modal](/api/modal) component are available
 * when `variant="temporary"` is set.
 */


exports.styles = styles;

var Drawer =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(Drawer, _React$Component);

  function Drawer() {
    var _ref;

    var _temp, _this;

    (0, _classCallCheck2.default)(this, Drawer);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return (0, _possibleConstructorReturn2.default)(_this, (_temp = _this = (0, _possibleConstructorReturn2.default)(this, (_ref = Drawer.__proto__ || Object.getPrototypeOf(Drawer)).call.apply(_ref, [this].concat(args))), _this.mounted = false, _temp));
  }

  (0, _createClass2.default)(Drawer, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.mounted = true;
    }
  }, {
    key: "render",
    value: function render() {
      var _props = this.props,
          anchorProp = _props.anchor,
          children = _props.children,
          classes = _props.classes,
          className = _props.className,
          elevation = _props.elevation,
          _props$ModalProps = _props.ModalProps;
      _props$ModalProps = _props$ModalProps === void 0 ? {} : _props$ModalProps;
      var BackdropPropsProp = _props$ModalProps.BackdropProps,
          ModalProps = (0, _objectWithoutProperties2.default)(_props$ModalProps, ["BackdropProps"]),
          onClose = _props.onClose,
          open = _props.open,
          PaperProps = _props.PaperProps,
          SlideProps = _props.SlideProps,
          theme = _props.theme,
          transitionDuration = _props.transitionDuration,
          variant = _props.variant,
          other = (0, _objectWithoutProperties2.default)(_props, ["anchor", "children", "classes", "className", "elevation", "ModalProps", "onClose", "open", "PaperProps", "SlideProps", "theme", "transitionDuration", "variant"]);
      var anchor = getAnchor(this.props);

      var drawer = _react.default.createElement(_Paper.default, (0, _extends2.default)({
        elevation: variant === 'temporary' ? elevation : 0,
        square: true,
        className: (0, _classnames.default)(classes.paper, classes["paperAnchor".concat((0, _helpers.capitalize)(anchor))], (0, _defineProperty2.default)({}, classes["paperAnchorDocked".concat((0, _helpers.capitalize)(anchor))], variant !== 'temporary'))
      }, PaperProps), children);

      if (variant === 'permanent') {
        return _react.default.createElement("div", (0, _extends2.default)({
          className: (0, _classnames.default)(classes.docked, className)
        }, other), drawer);
      }

      var slidingDrawer = _react.default.createElement(_Slide.default, (0, _extends2.default)({
        "in": open,
        direction: oppositeDirection[anchor],
        timeout: transitionDuration,
        appear: this.mounted
      }, SlideProps), drawer);

      if (variant === 'persistent') {
        return _react.default.createElement("div", (0, _extends2.default)({
          className: (0, _classnames.default)(classes.docked, className)
        }, other), slidingDrawer);
      } // variant === temporary


      return _react.default.createElement(_Modal.default, (0, _extends2.default)({
        BackdropProps: (0, _objectSpread2.default)({}, BackdropPropsProp, {
          transitionDuration: transitionDuration
        }),
        className: (0, _classnames.default)(classes.modal, className),
        open: open,
        onClose: onClose
      }, other, ModalProps), slidingDrawer);
    }
  }]);
  return Drawer;
}(_react.default.Component);

Drawer.propTypes =  false ? {
  /**
   * Side from which the drawer will appear.
   */
  anchor: _propTypes.default.oneOf(['left', 'top', 'right', 'bottom']),

  /**
   * The contents of the drawer.
   */
  children: _propTypes.default.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * The elevation of the drawer.
   */
  elevation: _propTypes.default.number,

  /**
   * Properties applied to the [`Modal`](/api/modal) element.
   */
  ModalProps: _propTypes.default.object,

  /**
   * Callback fired when the component requests to be closed.
   *
   * @param {object} event The event source of the callback
   */
  onClose: _propTypes.default.func,

  /**
   * If `true`, the drawer is open.
   */
  open: _propTypes.default.bool,

  /**
   * Properties applied to the [`Paper`](/api/paper) element.
   */
  PaperProps: _propTypes.default.object,

  /**
   * Properties applied to the [`Slide`](/api/slide) element.
   */
  SlideProps: _propTypes.default.object,

  /**
   * @ignore
   */
  theme: _propTypes.default.object.isRequired,

  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   */
  transitionDuration: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.shape({
    enter: _propTypes.default.number,
    exit: _propTypes.default.number
  })]),

  /**
   * The variant to use.
   */
  variant: _propTypes.default.oneOf(['permanent', 'persistent', 'temporary'])
} : {};
Drawer.defaultProps = {
  anchor: 'left',
  elevation: 16,
  open: false,
  transitionDuration: {
    enter: _transitions.duration.enteringScreen,
    exit: _transitions.duration.leavingScreen
  },
  variant: 'temporary' // Mobile first.

};

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiDrawer',
  flip: false,
  withTheme: true
})(Drawer);

exports.default = _default;

/***/ }),
/* 964 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(2);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Slide.default;
  }
});

var _Slide = _interopRequireDefault(__webpack_require__(965));

/***/ }),
/* 965 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(2);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setTranslateValue = setTranslateValue;
exports.default = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(6));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(4));

var _objectSpread2 = _interopRequireDefault(__webpack_require__(17));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(11));

var _createClass2 = _interopRequireDefault(__webpack_require__(12));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(13));

var _inherits2 = _interopRequireDefault(__webpack_require__(14));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _reactDom = _interopRequireDefault(__webpack_require__(24));

var _reactEventListener = _interopRequireDefault(__webpack_require__(102));

var _debounce = _interopRequireDefault(__webpack_require__(128));

var _Transition = _interopRequireDefault(__webpack_require__(62));

var _ownerWindow = _interopRequireDefault(__webpack_require__(125));

var _withTheme = _interopRequireDefault(__webpack_require__(71));

var _transitions = __webpack_require__(93);

var _utils = __webpack_require__(131);

// @inheritedComponent Transition
// < 1kb payload overhead when lodash/debounce is > 3kb.
var GUTTER = 24; // Translate the node so he can't be seen on the screen.
// Later, we gonna translate back the node to his original location
// with `translate3d(0, 0, 0)`.`

function getTranslateValue(props, node) {
  var direction = props.direction;
  var rect = node.getBoundingClientRect();
  var transform;

  if (node.fakeTransform) {
    transform = node.fakeTransform;
  } else {
    var computedStyle = (0, _ownerWindow.default)(node).getComputedStyle(node);
    transform = computedStyle.getPropertyValue('-webkit-transform') || computedStyle.getPropertyValue('transform');
  }

  var offsetX = 0;
  var offsetY = 0;

  if (transform && transform !== 'none' && typeof transform === 'string') {
    var transformValues = transform.split('(')[1].split(')')[0].split(',');
    offsetX = parseInt(transformValues[4], 10);
    offsetY = parseInt(transformValues[5], 10);
  }

  if (direction === 'left') {
    return "translateX(100vw) translateX(-".concat(rect.left - offsetX, "px)");
  }

  if (direction === 'right') {
    return "translateX(-".concat(rect.left + rect.width + GUTTER - offsetX, "px)");
  }

  if (direction === 'up') {
    return "translateY(100vh) translateY(-".concat(rect.top - offsetY, "px)");
  } // direction === 'down'


  return "translateY(-".concat(rect.top + rect.height + GUTTER - offsetY, "px)");
}

function setTranslateValue(props, node) {
  var transform = getTranslateValue(props, node);

  if (transform) {
    node.style.webkitTransform = transform;
    node.style.transform = transform;
  }
}
/**
 * The Slide transition is used by the [Snackbar](/demos/snackbars) component.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */


var Slide =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(Slide, _React$Component);

  function Slide() {
    var _ref;

    var _temp, _this;

    (0, _classCallCheck2.default)(this, Slide);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return (0, _possibleConstructorReturn2.default)(_this, (_temp = _this = (0, _possibleConstructorReturn2.default)(this, (_ref = Slide.__proto__ || Object.getPrototypeOf(Slide)).call.apply(_ref, [this].concat(args))), _this.mounted = false, _this.transition = null, _this.handleResize = (0, _debounce.default)(function () {
      // Skip configuration where the position is screen size invariant.
      if (_this.props.in || _this.props.direction === 'down' || _this.props.direction === 'right') {
        return;
      }

      if (_this.transitionRef) {
        setTranslateValue(_this.props, _this.transitionRef);
      }
    }, 166), _this.handleEnter = function (node) {
      setTranslateValue(_this.props, node);
      (0, _utils.reflow)(node);

      if (_this.props.onEnter) {
        _this.props.onEnter(node);
      }
    }, _this.handleEntering = function (node) {
      var theme = _this.props.theme;
      var transitionProps = (0, _utils.getTransitionProps)(_this.props, {
        mode: 'enter'
      });
      node.style.webkitTransition = theme.transitions.create('-webkit-transform', (0, _objectSpread2.default)({}, transitionProps, {
        easing: theme.transitions.easing.easeOut
      }));
      node.style.transition = theme.transitions.create('transform', (0, _objectSpread2.default)({}, transitionProps, {
        easing: theme.transitions.easing.easeOut
      }));
      node.style.webkitTransform = 'translate(0, 0)';
      node.style.transform = 'translate(0, 0)';

      if (_this.props.onEntering) {
        _this.props.onEntering(node);
      }
    }, _this.handleExit = function (node) {
      var theme = _this.props.theme;
      var transitionProps = (0, _utils.getTransitionProps)(_this.props, {
        mode: 'exit'
      });
      node.style.webkitTransition = theme.transitions.create('-webkit-transform', (0, _objectSpread2.default)({}, transitionProps, {
        easing: theme.transitions.easing.sharp
      }));
      node.style.transition = theme.transitions.create('transform', (0, _objectSpread2.default)({}, transitionProps, {
        easing: theme.transitions.easing.sharp
      }));
      setTranslateValue(_this.props, node);

      if (_this.props.onExit) {
        _this.props.onExit(node);
      }
    }, _this.handleExited = function (node) {
      // No need for transitions when the component is hidden
      node.style.webkitTransition = '';
      node.style.transition = '';

      if (_this.props.onExited) {
        _this.props.onExited(node);
      }
    }, _temp));
  }

  (0, _createClass2.default)(Slide, [{
    key: "componentDidMount",
    // Corresponds to 10 frames at 60 Hz.
    value: function componentDidMount() {
      // state.mounted handle SSR, once the component is mounted, we need
      // to properly hide it.
      if (!this.props.in) {
        // We need to set initial translate values of transition element
        // otherwise component will be shown when in=false.
        this.updatePosition();
      }

      this.mounted = true;
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (prevProps.direction !== this.props.direction && !this.props.in) {
        // We need to update the position of the drawer when the direction change and
        // when it's hidden.
        this.updatePosition();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.handleResize.clear();
    }
  }, {
    key: "updatePosition",
    value: function updatePosition() {
      if (this.transitionRef) {
        this.transitionRef.style.visibility = 'inherit';
        setTranslateValue(this.props, this.transitionRef);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          children = _props.children,
          onEnter = _props.onEnter,
          onEntering = _props.onEntering,
          onExit = _props.onExit,
          onExited = _props.onExited,
          styleProp = _props.style,
          theme = _props.theme,
          other = (0, _objectWithoutProperties2.default)(_props, ["children", "onEnter", "onEntering", "onExit", "onExited", "style", "theme"]);
      var style = {}; // We use this state to handle the server-side rendering.
      // We don't know the width of the children ahead of time.
      // We need to render it.

      if (!this.props.in && !this.mounted) {
        style.visibility = 'hidden';
      }

      style = (0, _objectSpread2.default)({}, style, styleProp, _react.default.isValidElement(children) ? children.props.style : {});
      return _react.default.createElement(_reactEventListener.default, {
        target: "window",
        onResize: this.handleResize
      }, _react.default.createElement(_Transition.default, (0, _extends2.default)({
        onEnter: this.handleEnter,
        onEntering: this.handleEntering,
        onExit: this.handleExit,
        onExited: this.handleExited,
        appear: true,
        style: style,
        ref: function ref(_ref2) {
          _this2.transitionRef = _reactDom.default.findDOMNode(_ref2);
        }
      }, other), children));
    }
  }]);
  return Slide;
}(_react.default.Component);

Slide.propTypes =  false ? {
  /**
   * A single child content element.
   */
  children: _propTypes.default.oneOfType([_propTypes.default.element, _propTypes.default.func]),

  /**
   * Direction the child node will enter from.
   */
  direction: _propTypes.default.oneOf(['left', 'right', 'up', 'down']),

  /**
   * If `true`, show the component; triggers the enter or exit animation.
   */
  in: _propTypes.default.bool,

  /**
   * @ignore
   */
  onEnter: _propTypes.default.func,

  /**
   * @ignore
   */
  onEntering: _propTypes.default.func,

  /**
   * @ignore
   */
  onExit: _propTypes.default.func,

  /**
   * @ignore
   */
  onExited: _propTypes.default.func,

  /**
   * @ignore
   */
  style: _propTypes.default.object,

  /**
   * @ignore
   */
  theme: _propTypes.default.object.isRequired,

  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   */
  timeout: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.shape({
    enter: _propTypes.default.number,
    exit: _propTypes.default.number
  })])
} : {};
Slide.defaultProps = {
  direction: 'down',
  timeout: {
    enter: _transitions.duration.enteringScreen,
    exit: _transitions.duration.leavingScreen
  }
};

var _default = (0, _withTheme.default)()(Slide);

exports.default = _default;

/***/ }),
/* 966 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(2);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _ListItemIcon.default;
  }
});

var _ListItemIcon = _interopRequireDefault(__webpack_require__(967));

/***/ }),
/* 967 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(2);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _objectSpread2 = _interopRequireDefault(__webpack_require__(17));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(4));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _classnames = _interopRequireDefault(__webpack_require__(5));

var _withStyles = _interopRequireDefault(__webpack_require__(3));

var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      marginRight: 16,
      color: theme.palette.action.active,
      flexShrink: 0
    }
  };
};
/**
 * A simple wrapper to apply `List` styles to an `Icon` or `SvgIcon`.
 */


exports.styles = styles;

function ListItemIcon(props) {
  var children = props.children,
      classes = props.classes,
      classNameProp = props.className,
      other = (0, _objectWithoutProperties2.default)(props, ["children", "classes", "className"]);
  return _react.default.cloneElement(children, (0, _objectSpread2.default)({
    className: (0, _classnames.default)(classes.root, classNameProp, children.props.className)
  }, other));
}

ListItemIcon.propTypes =  false ? {
  /**
   * The content of the component, normally `Icon`, `SvgIcon`,
   * or a `@material-ui/icons` SVG icon element.
   */
  children: _propTypes.default.element.isRequired,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string
} : {};

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiListItemIcon'
})(ListItemIcon);

exports.default = _default;

/***/ }),
/* 968 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(2);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _ListItemText.default;
  }
});

var _ListItemText = _interopRequireDefault(__webpack_require__(969));

/***/ }),
/* 969 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(2);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(6));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(7));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(4));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _classnames = _interopRequireDefault(__webpack_require__(5));

var _withStyles = _interopRequireDefault(__webpack_require__(3));

var _Typography = _interopRequireDefault(__webpack_require__(126));

var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      flex: '1 1 auto',
      minWidth: 0,
      padding: '0 16px',
      '&:first-child': {
        paddingLeft: 0
      }
    },

    /* Styles applied to the root element if `inset={true}`. */
    inset: {
      '&:first-child': {
        paddingLeft: 56
      }
    },

    /* Styles applied to the root element if `context.dense` is `true`. */
    dense: {
      fontSize: theme.typography.pxToRem(13)
    },

    /* Styles applied to the primary `Typography` component. */
    primary: {
      '&$textDense': {
        fontSize: 'inherit'
      }
    },

    /* Styles applied to the secondary `Typography` component. */
    secondary: {
      '&$textDense': {
        fontSize: 'inherit'
      }
    },

    /* Styles applied to the `Typography` components if `context.dense` is `true`. */
    textDense: {}
  };
};

exports.styles = styles;

function ListItemText(props, context) {
  var _classNames3;

  var children = props.children,
      classes = props.classes,
      classNameProp = props.className,
      disableTypography = props.disableTypography,
      inset = props.inset,
      primaryProp = props.primary,
      primaryTypographyProps = props.primaryTypographyProps,
      secondaryProp = props.secondary,
      secondaryTypographyProps = props.secondaryTypographyProps,
      other = (0, _objectWithoutProperties2.default)(props, ["children", "classes", "className", "disableTypography", "inset", "primary", "primaryTypographyProps", "secondary", "secondaryTypographyProps"]);
  var dense = context.dense;
  var primary = primaryProp != null ? primaryProp : children;

  if (primary != null && primary.type !== _Typography.default && !disableTypography) {
    primary = _react.default.createElement(_Typography.default, (0, _extends2.default)({
      variant: "subheading",
      className: (0, _classnames.default)(classes.primary, (0, _defineProperty2.default)({}, classes.textDense, dense)),
      component: "span"
    }, primaryTypographyProps), primary);
  }

  var secondary = secondaryProp;

  if (secondary != null && secondary.type !== _Typography.default && !disableTypography) {
    secondary = _react.default.createElement(_Typography.default, (0, _extends2.default)({
      variant: "body1",
      className: (0, _classnames.default)(classes.secondary, (0, _defineProperty2.default)({}, classes.textDense, dense)),
      color: "textSecondary"
    }, secondaryTypographyProps), secondary);
  }

  return _react.default.createElement("div", (0, _extends2.default)({
    className: (0, _classnames.default)(classes.root, (_classNames3 = {}, (0, _defineProperty2.default)(_classNames3, classes.dense, dense), (0, _defineProperty2.default)(_classNames3, classes.inset, inset), _classNames3), classNameProp)
  }, other), primary, secondary);
}

ListItemText.propTypes =  false ? {
  /**
   * Alias for the `primary` property.
   */
  children: _propTypes.default.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * If `true`, the children won't be wrapped by a Typography component.
   * This can be useful to render an alternative Typography variant by wrapping
   * the `children` (or `primary`) text, and optional `secondary` text
   * with the Typography component.
   */
  disableTypography: _propTypes.default.bool,

  /**
   * If `true`, the children will be indented.
   * This should be used if there is no left avatar or left icon.
   */
  inset: _propTypes.default.bool,

  /**
   * The main content element.
   */
  primary: _propTypes.default.node,

  /**
   * These props will be forwarded to the primary typography component
   * (as long as disableTypography is not `true`).
   */
  primaryTypographyProps: _propTypes.default.object,

  /**
   * The secondary content element.
   */
  secondary: _propTypes.default.node,

  /**
   * These props will be forwarded to the secondary typography component
   * (as long as disableTypography is not `true`).
   */
  secondaryTypographyProps: _propTypes.default.object
} : {};
ListItemText.defaultProps = {
  disableTypography: false,
  inset: false
};
ListItemText.contextTypes = {
  dense: _propTypes.default.bool
};

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiListItemText'
})(ListItemText);

exports.default = _default;

/***/ }),
/* 970 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_perfect_scrollbar__ = __webpack_require__(181);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}//////////////////////////////////////////////////////////////////////
///     Este componente foi modificado do original do tema.        ///
///     É basicamente igual só removendo/alterando algumas partes. ///
///     Checar novas versões manualmente.                          ///
//////////////////////////////////////////////////////////////////////
// javascript plugin used to create scrollbars on windows
// We've created this component so we can have a ref to the wrapper of the links that appears in our sidebar.
// This was necessary so that we could initialize PerfectScrollbar on the links.
// There might be something with the Hidden component from material-ui, and we didn't have access to
// the links, and couldn't initialize the plugin.
var SidebarWrapper=function(_Component){_inherits(SidebarWrapper,_Component);function SidebarWrapper(){_classCallCheck(this,SidebarWrapper);return _possibleConstructorReturn(this,(SidebarWrapper.__proto__||Object.getPrototypeOf(SidebarWrapper)).apply(this,arguments));}_createClass(SidebarWrapper,[{key:"componentDidMount",value:function componentDidMount(){if(navigator.platform.indexOf("Win")>-1){this.ps=new __WEBPACK_IMPORTED_MODULE_2_perfect_scrollbar__["a" /* default */](this.sidebarWrapper,{suppressScrollX:true,suppressScrollY:false});}}},{key:"componentWillUnmount",value:function componentWillUnmount(){if(navigator.platform.indexOf("Win")>-1){this.ps.destroy();}}},{key:"render",value:function render(){var _this2=this;var _props=this.props,className=_props.className,user=_props.user,headerLinks=_props.headerLinks,links=_props.links;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:className,ref:function ref(node){return _this2.sidebarWrapper=node;}},user,headerLinks,links);}}]);return SidebarWrapper;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);SidebarWrapper.propTypes={className:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,headerLinks:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,links:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,user:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node};/* harmony default export */ __webpack_exports__["a"] = (SidebarWrapper);

/***/ }),
/* 971 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__ = __webpack_require__(21);
function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}// ##############################
// // // Sidebar styles
// #############################
var sidebarStyle=function sidebarStyle(theme){var _drawerPaperRTL,_Object$assign;return{drawerPaperRTL:(_drawerPaperRTL={},_defineProperty(_drawerPaperRTL,theme.breakpoints.up("md"),{left:"auto !important",right:"0 !important"}),_defineProperty(_drawerPaperRTL,theme.breakpoints.down("sm"),{left:"0  !important",right:"auto !important"}),_drawerPaperRTL),drawerPaper:Object.assign({border:"none",position:"fixed",top:"0",bottom:"0",left:"0",zIndex:"1032",transitionProperty:"top, bottom, width",transitionDuration:".2s, .2s, .35s",transitionTimingFunction:"linear, linear, ease"},__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["a" /* boxShadow */],(_Object$assign={width:__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["k" /* drawerWidth */]},_defineProperty(_Object$assign,theme.breakpoints.up("md"),{width:__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["k" /* drawerWidth */],position:"fixed",height:"100%"}),_defineProperty(_Object$assign,theme.breakpoints.down("sm"),Object.assign({width:__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["k" /* drawerWidth */]},__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["a" /* boxShadow */],{position:"fixed",display:"block",top:"0",height:"100vh",right:"0",left:"auto",zIndex:"1032",visibility:"visible",overflowY:"visible",borderTop:"none",textAlign:"left",paddingRight:"0px",paddingLeft:"0",transform:"translate3d("+__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["k" /* drawerWidth */]+"px, 0, 0)"},__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["y" /* transition */])),_defineProperty(_Object$assign,"&:before,&:after",{position:"absolute",zIndex:"3",width:"100%",height:"100%",content:'""',display:"block",top:"0"}),_Object$assign)),blackBackground:{color:"#FFFFFF","&:after":{background:"#000",opacity:".8"}},blueBackground:{color:"#FFFFFF","&:after":{background:"#00acc1",opacity:".93"}},whiteBackground:{color:"#3C4858","&:after":{background:"#FFFFFF",opacity:".93"}},whiteAfter:{"&:after":{backgroundColor:"hsla(0,0%,71%,.3) !important"}},drawerPaperMini:{width:__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["j" /* drawerMiniWidth */]+"px!important"},logo:{padding:"15px 0px",margin:"0",display:"block",position:"relative",zIndex:"4","&:after":{content:'""',position:"absolute",bottom:"0",height:"1px",right:"15px",width:"calc(100% - 30px)",backgroundColor:"hsla(0,0%,100%,.3)"}},logoMini:{transition:"all 300ms linear",opacity:1,float:"left",textAlign:"center",width:"30px",display:"inline-block",maxHeight:"30px",marginLeft:"22px",marginRight:"18px",marginTop:"7px",color:"inherit"},logoMiniRTL:{float:"right",marginRight:"30px",marginLeft:"26px"},logoNormal:Object.assign({},__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["i" /* defaultFont */],{transition:"all 300ms linear",display:"block",opacity:"1",transform:"translate3d(0px, 0, 0)",textTransform:"uppercase",padding:"5px 0px",fontSize:"18px",whiteSpace:"nowrap",fontWeight:"400",lineHeight:"30px",overflow:"hidden","&,&:hover,&:focus":{color:"inherit"}}),logoNormalRTL:{textAlign:"right"},logoNormalSidebarMini:{opacity:"0",transform:"translate3d(-25px, 0, 0)"},logoNormalSidebarMiniRTL:{transform:"translate3d(25px, 0, 0)"},img:{width:"35px",verticalAlign:"middle",border:"0"},background:{position:"absolute",zIndex:"1",height:"100%",width:"100%",display:"block",top:"0",left:"0",backgroundSize:"cover",backgroundPosition:"center center",transition:"all 300ms linear"},list:{marginTop:"15px",paddingLeft:"0",paddingTop:"0",paddingBottom:"0",marginBottom:"0",listStyle:"none",color:"inherit","&:before,&:after":{display:"table",content:'" "'},"&:after":{clear:"both"}},item:{color:"inherit",position:"relative",display:"block",textDecoration:"none",margin:"0",padding:"0"},userItem:{"&:last-child":{paddingBottom:"0px"}},itemLink:Object.assign({paddingLeft:"10px",paddingRight:"10px",transition:"all 300ms linear",margin:"10px 15px 0",borderRadius:"3px",position:"relative",display:"block",padding:"10px 15px",backgroundColor:"transparent"},__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["i" /* defaultFont */],{width:"auto","&:hover":{outline:"none",backgroundColor:"rgba(200, 200, 200, 0.2)",boxShadow:"none"},"&,&:hover,&:focus":{color:"inherit"}}),itemIcon:{color:"inherit",width:"30px",height:"24px",float:"left",position:"inherit",top:"3px",marginRight:"15px",textAlign:"center",verticalAlign:"middle",opacity:"0.8"},itemIconRTL:{float:"right",marginLeft:"15px",marginRight:"1px"},itemText:Object.assign({color:"inherit"},__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["i" /* defaultFont */],{margin:"0",lineHeight:"30px",fontSize:"14px",transform:"translate3d(0px, 0, 0)",opacity:"1",transition:"transform 300ms ease 0s, opacity 300ms ease 0s",position:"relative",display:"block",height:"auto",whiteSpace:"nowrap"}),userItemText:{lineHeight:"22px"},itemTextRTL:{marginRight:"45px",textAlign:"right"},itemTextMini:{transform:"translate3d(-25px, 0, 0)",opacity:"0"},itemTextMiniRTL:{transform:"translate3d(25px, 0, 0) !important"},collapseList:{marginTop:"0"},collapseItem:{position:"relative",display:"block",textDecoration:"none",margin:"10px 0 0 0",padding:"0"},collapseActive:{outline:"none",backgroundColor:"rgba(200, 200, 200, 0.2)",boxShadow:"none"},collapseItemLink:Object.assign({transition:"all 300ms linear",margin:"0 15px",borderRadius:"3px",position:"relative",display:"block",padding:"10px",backgroundColor:"transparent"},__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["i" /* defaultFont */],{width:"auto","&:hover":{outline:"none",backgroundColor:"rgba(200, 200, 200, 0.2)",boxShadow:"none"},"&,&:hover,&:focus":{color:"inherit"}}),collapseItemMini:Object.assign({color:"inherit"},__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["i" /* defaultFont */],{textTransform:"uppercase",width:"30px",marginRight:"15px",textAlign:"center",letterSpacing:"1px",position:"relative",float:"left",display:"inherit",transition:"transform 300ms ease 0s, opacity 300ms ease 0s",fontSize:"14px"}),collapseItemMiniRTL:{float:"right",marginLeft:"30px",marginRight:"1px"},collapseItemText:Object.assign({color:"inherit"},__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["i" /* defaultFont */],{margin:"0",position:"relative",transform:"translateX(0px)",opacity:"1",whiteSpace:"nowrap",display:"block",transition:"transform 300ms ease 0s, opacity 300ms ease 0s",fontSize:"14px"}),collapseItemTextRTL:{textAlign:"right"},collapseItemTextMiniRTL:{transform:"translate3d(25px, 0, 0) !important"},collapseItemTextMini:{transform:"translate3d(-25px, 0, 0)",opacity:"0"},caret:{marginTop:"13px",position:"absolute",right:"18px",transition:"all 150ms ease-in",display:"inline-block",width:"0",height:"0",marginLeft:"2px",verticalAlign:"middle",borderTop:"4px solid",borderRight:"4px solid transparent",borderLeft:"4px solid transparent"},userCaret:{marginTop:"10px"},caretRTL:{left:"11px",right:"auto"},caretActive:{transform:"rotate(180deg)"},purple:{"&,&:hover,&:focus":Object.assign({color:"#FFFFFF",backgroundColor:__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["r" /* primaryColor */]},__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["p" /* primaryBoxShadow */])},blue:{"&,&:hover,&:focus":{color:"#FFFFFF",backgroundColor:__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["o" /* infoColor */],boxShadow:"0 12px 20px -10px rgba(0,188,212,.28), 0 4px 20px 0 rgba(0,0,0,.12), 0 7px 8px -5px rgba(0,188,212,.2)"}},green:{"&,&:hover,&:focus":{color:"#FFFFFF",backgroundColor:__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["x" /* successColor */],boxShadow:"0 12px 20px -10px rgba(76,175,80,.28), 0 4px 20px 0 rgba(0,0,0,.12), 0 7px 8px -5px rgba(76,175,80,.2)"}},orange:{"&,&:hover,&:focus":{color:"#FFFFFF",backgroundColor:__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["B" /* warningColor */],boxShadow:"0 12px 20px -10px rgba(255,152,0,.28), 0 4px 20px 0 rgba(0,0,0,.12), 0 7px 8px -5px rgba(255,152,0,.2)"}},red:{"&,&:hover,&:focus":{color:"#FFFFFF",backgroundColor:__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["g" /* dangerColor */],boxShadow:"0 12px 20px -10px rgba(244,67,54,.28), 0 4px 20px 0 rgba(0,0,0,.12), 0 7px 8px -5px rgba(244,67,54,.2)"}},white:{"&,&:hover,&:focus":{color:"#3C4858",backgroundColor:"#FFFFFF",boxShadow:"0 4px 20px 0 rgba(0,0,0,.14), 0 7px 10px -5px rgba(60,72,88,.4)"}},rose:{"&,&:hover,&:focus":{color:"#FFFFFF",backgroundColor:__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["u" /* roseColor */],boxShadow:"0 4px 20px 0 rgba(0,0,0,.14), 0 7px 10px -5px rgba(233,30,99,.4)"}},sidebarWrapper:{position:"relative",height:"calc(100vh - 75px)",overflow:"auto",width:"260px",zIndex:"4",overflowScrolling:"touch",transitionProperty:"top, bottom, width",transitionDuration:".2s, .2s, .35s",transitionTimingFunction:"linear, linear, ease",color:"inherit",paddingBottom:"30px"},sidebarWrapperWithPerfectScrollbar:{overflow:"hidden !important"},user:{paddingBottom:"20px",margin:"20px auto 0",position:"relative","&:after":{content:'""',position:"absolute",bottom:"0",right:"15px",height:"1px",width:"calc(100% - 30px)",backgroundColor:"hsla(0,0%,100%,.3)"}},photo:Object.assign({transition:"all 300ms linear",width:"34px",height:"34px",overflow:"hidden",float:"left",zIndex:"5",marginRight:"11px",borderRadius:"50%",marginLeft:"23px"},__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["a" /* boxShadow */]),photoRTL:{float:"right",marginLeft:"12px",marginRight:"24px"},avatarImg:{width:"100%",verticalAlign:"middle",border:"0"},userCollapseButton:{margin:"0",padding:"6px 15px","&:hover":{background:"none"}},userCollapseLinks:{marginTop:"-4px","&:hover,&:focus":{color:"#FFFFFF"}}};};/* harmony default export */ __webpack_exports__["a"] = (sidebarStyle);

/***/ }),
/* 972 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_classnames__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_perfect_scrollbar__ = __webpack_require__(181);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_styles_withStyles__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_styles_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_styles_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_router_dom__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_assets_jss_material_dashboard_pro_react_layouts_dashboardStyle_jsx__ = __webpack_require__(257);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_EnergyCompany_Alert_Alerts__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_routes_dashboardAreaAberta_jsx__ = __webpack_require__(973);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_EnergyCompany_Footer_Footer_jsx__ = __webpack_require__(361);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_components_EnergyCompany_Header_Header_jsx__ = __webpack_require__(362);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_assets_EnergyCompany_img_logoEC_png__ = __webpack_require__(364);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_assets_EnergyCompany_img_logoEC_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_assets_EnergyCompany_img_logoEC_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_components_EnergyCompany_Sidebar_Sidebar_jsx__ = __webpack_require__(365);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_perfect_scrollbar_css_perfect_scrollbar_css__ = __webpack_require__(256);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_perfect_scrollbar_css_perfect_scrollbar_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_perfect_scrollbar_css_perfect_scrollbar_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ps=void 0;var DashboardAreaAberta=function(_React$Component){_inherits(DashboardAreaAberta,_React$Component);function DashboardAreaAberta(){var _ref;var _temp,_this,_ret;_classCallCheck(this,DashboardAreaAberta);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=DashboardAreaAberta.__proto__||Object.getPrototypeOf(DashboardAreaAberta)).call.apply(_ref,[this].concat(args))),_this),_this.state={mobileOpen:false,miniActive:false},_this.handleDrawerToggle=function(){_this.setState({mobileOpen:!_this.state.mobileOpen});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(DashboardAreaAberta,[{key:"componentDidMount",value:function componentDidMount(){if(navigator.platform.indexOf("Win")>-1){// eslint-disable-next-line
ps=new __WEBPACK_IMPORTED_MODULE_1_perfect_scrollbar__["a" /* default */](this.mainPanel,{suppressScrollX:true,suppressScrollY:false});}}},{key:"componentDidUpdate",value:function componentDidUpdate(e){if(e.history.location.pathname!==e.location.pathname){this.mainPanel.scrollTop=0;}}},{key:"componentWillUnmount",value:function componentWillUnmount(){if(navigator.platform.indexOf("Win")>-1){ps.destroy();}}},{key:"getSwitchRoutes",value:function getSwitchRoutes(){return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_router_dom__["d" /* Switch */],null,Object(__WEBPACK_IMPORTED_MODULE_5_lodash__["map"])(__WEBPACK_IMPORTED_MODULE_9_routes_dashboardAreaAberta_jsx__["a" /* default */],function(prop,key){return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_router_dom__["b" /* Route */],{component:prop.component,exact:true,key:key,path:prop.path});}));}},{key:"sidebarMinimize",value:function sidebarMinimize(){this.setState({miniActive:!this.state.miniActive});}},{key:"render",value:function render(){var _cx,_this2=this;var _props=this.props,classes=_props.classes,rest=_objectWithoutProperties(_props,["classes"]);var mainPanel=classes.mainPanel+" "+__WEBPACK_IMPORTED_MODULE_0_classnames___default()((_cx={},_defineProperty(_cx,classes.mainPanelSidebarMini,this.state.miniActive),_defineProperty(_cx,classes.mainPanelWithPerfectScrollbar,navigator.platform.indexOf("Win")>-1),_cx));return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("div",{className:classes.wrapper},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_components_EnergyCompany_Sidebar_Sidebar_jsx__["a" /* default */],Object.assign({bgColor:"white",color:"blue",handleDrawerToggle:this.handleDrawerToggle,logo:__WEBPACK_IMPORTED_MODULE_12_assets_EnergyCompany_img_logoEC_png___default.a,logoText:"Energy Company",miniActive:this.state.miniActive,open:this.state.mobileOpen,routes:__WEBPACK_IMPORTED_MODULE_9_routes_dashboardAreaAberta_jsx__["a" /* default */],userInfo:undefined},rest)),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("div",{className:mainPanel,ref:function ref(node){return _this2.mainPanel=node;}},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components_EnergyCompany_Header_Header_jsx__["a" /* default */],Object.assign({handleDrawerToggle:this.handleDrawerToggle,miniActive:this.state.miniActive,routes:__WEBPACK_IMPORTED_MODULE_9_routes_dashboardAreaAberta_jsx__["a" /* default */],sidebarMinimize:this.sidebarMinimize.bind(this)},rest)),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("div",{className:classes.content},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("div",{className:classes.container},this.getSwitchRoutes())),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_EnergyCompany_Footer_Footer_jsx__["a" /* default */],{fluid:true})),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_EnergyCompany_Alert_Alerts__["a" /* default */],null));}}]);return DashboardAreaAberta;}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);DashboardAreaAberta.propTypes={classes:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired,location:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({pathname:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired}).isRequired};/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_4__material_ui_core_styles_withStyles___default()(__WEBPACK_IMPORTED_MODULE_7_assets_jss_material_dashboard_pro_react_layouts_dashboardStyle_jsx__["a" /* default */])(DashboardAreaAberta));

/***/ }),
/* 973 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__material_ui_icons_Dashboard__ = __webpack_require__(259);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__material_ui_icons_Dashboard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__material_ui_icons_Dashboard__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_views_Pages_SimuladoresPage_jsx__ = __webpack_require__(355);
var dashRoutes=[{path:"/area-aberta/simulador-cativo-livre",name:"Simulador Cativo",icon:__WEBPACK_IMPORTED_MODULE_0__material_ui_icons_Dashboard___default.a,component:__WEBPACK_IMPORTED_MODULE_1_views_Pages_SimuladoresPage_jsx__["a" /* default */]}];/* harmony default export */ __webpack_exports__["a"] = (dashRoutes);

/***/ }),
/* 974 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__partials_1_header__ = __webpack_require__(975);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__partials_2_section__ = __webpack_require__(979);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__partials_3_section__ = __webpack_require__(984);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__partials_4_testemunhos__ = __webpack_require__(986);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__partials_5_contato__ = __webpack_require__(990);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__partials_6_footer__ = __webpack_require__(992);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_services_assinatura__ = __webpack_require__(266);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var LandingPage=function(_Component){_inherits(LandingPage,_Component);function LandingPage(){_classCallCheck(this,LandingPage);return _possibleConstructorReturn(this,(LandingPage.__proto__||Object.getPrototypeOf(LandingPage)).apply(this,arguments));}_createClass(LandingPage,[{key:"componentDidMount",value:function componentDidMount(){// Checa se a requisição retorna 401 (token inválido)
// então mostra o botão de Login ou Dashboard.
Object(__WEBPACK_IMPORTED_MODULE_9_services_assinatura__["b" /* fetchAssinatura */])();}},{key:"render",value:function render(){var _props=this.props,history=_props.history,user=_props.user;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__partials_1_header__["a" /* default */],{history:history,user:user}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__partials_2_section__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__partials_3_section__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__partials_4_testemunhos__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__partials_5_contato__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__partials_6_footer__["a" /* default */],{history:history,user:user}));}}]);return LandingPage;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);;LandingPage.propTypes={history:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({push:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired}).isRequired,user:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object.isRequired};var mapStateToProps=function mapStateToProps(state){return{user:state.user};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(mapStateToProps)(LandingPage));

/***/ }),
/* 975 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__material_ui_core_Hidden__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__material_ui_core_Hidden___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__material_ui_core_Hidden__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles_withStyles__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_assets_EnergyCompany_img_bg_header_png__ = __webpack_require__(976);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_assets_EnergyCompany_img_bg_header_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_assets_EnergyCompany_img_bg_header_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_assets_EnergyCompany_jss_button_blue_jsx__ = __webpack_require__(366);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__center__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_assets_EnergyCompany_img_ipad_png__ = __webpack_require__(977);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_assets_EnergyCompany_img_ipad_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_assets_EnergyCompany_img_ipad_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_assets_EnergyCompany_img_logo_branca_svg__ = __webpack_require__(978);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_assets_EnergyCompany_img_logo_branca_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_assets_EnergyCompany_img_logo_branca_svg__);
function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var style=function style(theme){return{button:Object.assign({},__WEBPACK_IMPORTED_MODULE_5_assets_EnergyCompany_jss_button_blue_jsx__["a" /* default */]),buttonGreen:Object.assign({},__WEBPACK_IMPORTED_MODULE_5_assets_EnergyCompany_jss_button_blue_jsx__["a" /* default */],{backgroundColor:"#4CAF50",fontWeight:"bold"}),centeredSection:Object.assign({},Object(__WEBPACK_IMPORTED_MODULE_6__center__["a" /* default */])(theme),{padding:"20px 0"}),disclaimer:{color:"white",display:"grid",gridTemplateColumns:"repeat(auto-fit, minmax(300px, 1fr))",gridColumnGap:"30px"},disclaimerText:_defineProperty({"& h1":{fontWeight:"bold"},"& p":{fontSize:"20px",lineHeight:"1.5"}},theme.breakpoints.down("sm"),{textAlign:"center","& h1":{fontSize:"2.5em"}}),ipad:_defineProperty({marginTop:"100px","& img":{width:"100%"}},theme.breakpoints.down("sm"),{marginTop:"20px"}),li:{color:"white",display:"inline-block",fontWeight:"bold",listStyle:"none",marginLeft:theme.spacing.unit*2,textTransform:"uppercase","& a":{color:"white"},"& a:hover":{color:"white"}},linksWrapper:{alignItems:"center",display:"flex",justifyContent:"space-between"},logo:{width:"150px"},main:{backgroundImage:"url("+__WEBPACK_IMPORTED_MODULE_4_assets_EnergyCompany_img_bg_header_png___default.a+")",backgroundRepeat:"no-repeat",backgroundSize:"cover",backgroundPosition:"center",height:"440px"}};};var Header=function Header(_ref){var classes=_ref.classes,history=_ref.history,user=_ref.user;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("main",{className:classes.main},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:classes.centeredSection},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:classes.linksWrapper},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("img",{alt:"Logo",className:classes.logo,src:__WEBPACK_IMPORTED_MODULE_8_assets_EnergyCompany_img_logo_branca_svg___default.a}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("ul",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core_Hidden___default.a,{smDown:true},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("li",{className:classes.li},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("a",{href:"/area-aberta/simulador-cativo-livre"},"Simuladores")),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("li",{className:classes.li},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("a",{href:"/planos"},"Planos")),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("li",{className:classes.li},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("a",{href:"#sobre-nos"},"Sobre N\xF3s")),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("li",{className:classes.li},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("a",{href:"#contato"},"Contato"))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("li",{className:classes.li},user.access_token?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("button",{className:classes.button,onClick:function onClick(){return history.push("/dashboard");}},"DASHBOARD"):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("button",{className:classes.button,onClick:function onClick(){return history.push("/login");}},"LOGIN")),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("li",{className:classes.li},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("button",{className:classes.buttonGreen,onClick:function onClick(){return history.push("/cadastro");}},"CADASTRE-SE")))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:classes.disclaimer},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:classes.disclaimerText},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("h1",null,"Ser digital \xE9 inevit\xE1vel"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core_Hidden___default.a,{smDown:true},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("p",null,"A Energy Company e\u0301 a u\u0301nica plataforma de suporte aos"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("p",null,"agentes do mercado de energia que consolida informac\u0327o\u0303es"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("p",null,"essenciais para tomada de decisa\u0303o de forma ra\u0301pida e"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("p",null,"objetiva.")),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core_Hidden___default.a,{mdUp:true},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("p",null,"O mercado de energia est\xE1 se desenvolvendo como nunca e precisa de uma plataforma que acompanhe essa evolu\xE7\xE3o. Com a Energy Company \xE9 poss\xEDvel analisar de forma estrat\xE9gica as principais informa\xE7\xF5es."))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:classes.ipad},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("img",{alt:"iPad",src:__WEBPACK_IMPORTED_MODULE_7_assets_EnergyCompany_img_ipad_png___default.a})))));};Header.propTypes={classes:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired,history:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({push:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired}).isRequired,user:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired};/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles_withStyles___default()(style)(Header));

/***/ }),
/* 976 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/bg-header.8fc44e15.png";

/***/ }),
/* 977 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/ipad.906c1a42.png";

/***/ }),
/* 978 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/logo-branca.3a5aaee4.svg";

/***/ }),
/* 979 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__material_ui_core_Hidden__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__material_ui_core_Hidden___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__material_ui_core_Hidden__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles_withStyles__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__center__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_assets_EnergyCompany_img_inteligente_svg__ = __webpack_require__(980);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_assets_EnergyCompany_img_inteligente_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_assets_EnergyCompany_img_inteligente_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_assets_EnergyCompany_img_moderno_svg__ = __webpack_require__(981);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_assets_EnergyCompany_img_moderno_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_assets_EnergyCompany_img_moderno_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_assets_EnergyCompany_img_seguro_svg__ = __webpack_require__(982);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_assets_EnergyCompany_img_seguro_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_assets_EnergyCompany_img_seguro_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_assets_EnergyCompany_img_simples_svg__ = __webpack_require__(983);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_assets_EnergyCompany_img_simples_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_assets_EnergyCompany_img_simples_svg__);
function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var style=function style(theme){return{centeredSection:Object.assign({},Object(__WEBPACK_IMPORTED_MODULE_4__center__["a" /* default */])(theme),{color:"black"}),sectionWrapper:_defineProperty({alignItems:"center",display:"flex"},theme.breakpoints.down("sm"),{display:"block"}),disclaimerText:_defineProperty({flex:1,"& h1":{fontWeight:"bold"},"& p":{fontSize:"20px",lineHeight:"1.5"}},theme.breakpoints.down("sm"),{display:"block",textAlign:"center","& h1":{fontSize:"2.5em"}}),infos1Wrapper:{alignItems:"flex-end",display:"flex",flexDirection:"column"},infos2Wrapper:_defineProperty({alignItems:"flex-end",display:"flex",flexDirection:"column",marginTop:"70px"},theme.breakpoints.down("sm"),{marginTop:"0"}),infoCard:_defineProperty({alignItems:"center",boxShadow:"0px 2px 5px 0 #0000001F",borderRadius:"6px",display:"flex",flexDirection:"column",height:"230px",justifyContent:"center",margin:"0 0 20px 20px",padding:"20px",textAlign:"center",transition:"all 0.3s ease-in-out 0s",width:"260px","&:hover":{transform:"scale3d(1.02, 1.02, 1.02)"},"& img":{width:"50px"},"& h4":{fontWeight:"500"}},theme.breakpoints.down("sm"),{fontSize:"20px",margin:"20px 0",width:"100%"}),main:{backgroundColor:"white",color:"black",padding:"200px 0 0"}};};var Section1=function Section1(_ref){var classes=_ref.classes;var infos1=[{icon:__WEBPACK_IMPORTED_MODULE_5_assets_EnergyCompany_img_inteligente_svg___default.a,text:"Informações sempre atualizadas para montar sua estratégia",title:"Inteligente"},{icon:__WEBPACK_IMPORTED_MODULE_6_assets_EnergyCompany_img_moderno_svg___default.a,text:"Todos os dados na nuvem, sempre disponíveis",title:"Moderno"}];var infos2=[{icon:__WEBPACK_IMPORTED_MODULE_7_assets_EnergyCompany_img_seguro_svg___default.a,text:"Dados criptografados",title:"Seguro"},{icon:__WEBPACK_IMPORTED_MODULE_8_assets_EnergyCompany_img_simples_svg___default.a,text:"Tudo o que você precisa em um só lugar",title:"Simples"}];var renderInfos=function renderInfos(infos){return infos.map(function(info,index){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:classes.infoCard,key:index},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("img",{alt:info.title,src:info.icon}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("h4",null,info.title),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("p",null,info.text));});};return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("main",{className:classes.main},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("section",{className:classes.centeredSection},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:classes.sectionWrapper},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:classes.disclaimerText},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("h1",{id:"sobre-nos"},"Sem dor de cabe\xE7a"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core_Hidden___default.a,{smDown:true},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("p",null,"Esque\xE7a as planilhas do Excel e relat\xF3rios na mem\xF3ria"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("p",null,"do seu computador. Com a Energy Company voc\xEA tem"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("p",null,"todos os dados sempre a sua disposi\xE7\xE3o, unificados em"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("p",null,"uma plataforma simples e intuitiva.")),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core_Hidden___default.a,{smUp:true},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("p",null,"Esque\xE7a as planilhas do Excel e relat\xF3rios na mem\xF3ria do seu computador. Com a Energy Company voc\xEA tem todos os dados sempre a sua disposi\xE7\xE3o, unificados em uma plataforma simples e intuitiva."))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:classes.infos1Wrapper},renderInfos(infos1)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:classes.infos2Wrapper},renderInfos(infos2)))));};Section1.propTypes={classes:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired};/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles_withStyles___default()(style)(Section1));

/***/ }),
/* 980 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/inteligente.01478649.svg";

/***/ }),
/* 981 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/moderno.736b5565.svg";

/***/ }),
/* 982 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/seguro.ceb83075.svg";

/***/ }),
/* 983 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/simples.da1c2be5.svg";

/***/ }),
/* 984 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__material_ui_core_Hidden__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__material_ui_core_Hidden___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__material_ui_core_Hidden__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles_withStyles__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_assets_EnergyCompany_img_browser_png__ = __webpack_require__(985);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_assets_EnergyCompany_img_browser_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_assets_EnergyCompany_img_browser_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__center__ = __webpack_require__(86);
function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var style=function style(theme){return{centeredSection:Object.assign({},Object(__WEBPACK_IMPORTED_MODULE_5__center__["a" /* default */])(theme),{color:"black"}),sectionWrapper:_defineProperty({alignItems:"center",display:"flex"},theme.breakpoints.down("sm"),{flexDirection:"column"}),disclaimerText:_defineProperty({flex:1,paddingLeft:"50px","& h1":{fontWeight:"bold"},"& p":{fontSize:"20px",lineHeight:"1.5"}},theme.breakpoints.down("sm"),{paddingLeft:"0",textAlign:"center","& h1":{fontSize:"2.4em"}}),imgWrapper:{flex:1,"& img":{width:"100%"}},main:_defineProperty({backgroundColor:"white",color:"black",padding:"50px 0 30px"},theme.breakpoints.down("sm"),{padding:"0"})};};var Section2=function Section2(_ref){var classes=_ref.classes;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("main",{className:classes.main},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("section",{className:classes.centeredSection},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:classes.sectionWrapper},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:classes.imgWrapper},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("img",{alt:"Browser",className:classes.img,src:__WEBPACK_IMPORTED_MODULE_4_assets_EnergyCompany_img_browser_png___default.a})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:classes.disclaimerText},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("h1",null,"Energia + Computa\xE7\xE3o"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core_Hidden___default.a,{smDown:true},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("p",null,"A Energy Company est\xE1 conectada com a"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("p",null,"moderniza\xE7\xE3o do setor el\xE9trico e preparada para"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("p",null,"atender as novas exig\xEAncias de um mercado cada"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("p",null,"vez mais din\xE2mico.")),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core_Hidden___default.a,{mdUp:true},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("p",null,"A Energy Company est\xE1 conectada com a moderniza\xE7\xE3o do setor el\xE9trico e preparada para atender as novas exig\xEAncias de um mercado cada vez mais din\xE2mico."))))));};Section2.propTypes={classes:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired};/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles_withStyles___default()(style)(Section2));

/***/ }),
/* 985 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/browser.dd56aa2f.png";

/***/ }),
/* 986 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__material_ui_icons_FormatQuote__ = __webpack_require__(987);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__material_ui_icons_FormatQuote___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__material_ui_icons_FormatQuote__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles_withStyles__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_Card_Card_jsx__ = __webpack_require__(176);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_Card_CardBody_jsx__ = __webpack_require__(177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_Card_CardFooter_jsx__ = __webpack_require__(988);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__center__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_Grid_GridContainer_jsx__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_Grid_GridItem_jsx__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_assets_jss_material_dashboard_pro_react_jsx__ = __webpack_require__(21);
function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var styles=function styles(theme){return{cardTitle:__WEBPACK_IMPORTED_MODULE_10_assets_jss_material_dashboard_pro_react_jsx__["b" /* cardTitle */],card:_defineProperty({border:"1px solid #DDD",minHeight:"410px"},theme.breakpoints.down("sm"),{minHeight:"unset"}),cardCategory:{color:"#999999",marginTop:"10px"},cardTestimonialDescription:{fontStyle:"italic",color:"#999999"},centeredSection:Object.assign({},Object(__WEBPACK_IMPORTED_MODULE_7__center__["a" /* default */])(theme),{padding:"20px 0"}),main:_defineProperty({backgroundColor:"white",color:"black"},theme.breakpoints.down("sm"),{padding:"0"}),testimonialIcon:{marginTop:"30px","& svg":{width:"40px",height:"40px"}}};};var Testemunhos=function Testemunhos(_ref){var classes=_ref.classes;return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("main",{className:classes.main,id:"testemunhos"},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("section",{className:classes.centeredSection},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_Grid_GridContainer_jsx__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_Grid_GridItem_jsx__["a" /* default */],{lg:6,md:6,sm:12,xs:12},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_Card_Card_jsx__["a" /* default */],{className:classes.card,testimonial:true},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("div",{className:classes.testimonialIcon},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_icons_FormatQuote___default.a,null)),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_Card_CardBody_jsx__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("h5",{className:classes.cardTestimonialDescription},"A Energy Company me ajuda muito no dia dia, tenho ",__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("strong",null,"informa\xE7\xF5es em tempo real")," de forma pr\xE1tica e objetiva.")),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_Card_CardFooter_jsx__["a" /* default */],{testimonial:true},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("h4",{className:classes.cardTitle},"Leonardo Lopes"),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("h6",{className:classes.cardCategory},"@NC Energia")))),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_Grid_GridItem_jsx__["a" /* default */],{md:6,sm:12,xs:12},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_Card_Card_jsx__["a" /* default */],{className:classes.card,testimonial:true},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("div",{className:classes.testimonialIcon},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_icons_FormatQuote___default.a,null)),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_Card_CardBody_jsx__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("h5",{className:classes.cardTestimonialDescription},"A Energy Company permite que eu tenha acesso a informa\xE7\xE3o r\xE1pida sobre tudo relacionado ao CNPJ de qualquer cliente do mercado e traz a informa\xE7\xE3o detalhada do eventual perfil do cliente se o mesmo j\xE1 estiver no Mercado Livre, onde identificamos Requisito e Recurso, Lastro M\xE9dia M\xF3vel, Perfil de Contrata\xE7\xE3o Sugerida calculada j\xE1 com base nas medi\xE7\xF5es reais e p\xFAblicas do cliente na CCEE e abertura da Contabiliza\xE7\xE3o. Al\xE9m de tudo isso, o Relat\xF3rio ",__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("strong",null,"ajuda muito na prospec\xE7\xE3o de potenciais clientes")," no mercado. Por tudo isso eu recomendo.")),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_Card_CardFooter_jsx__["a" /* default */],{testimonial:true},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("h4",{className:classes.cardTitle},"Hugo Leite"),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("h6",{className:classes.cardCategory},"@CPFL Energia")))))));};Testemunhos.propTypes={classes:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired};/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles_withStyles___default()(styles)(Testemunhos));

/***/ }),
/* 987 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(9);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(10));

var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
  d: "M6 17h3l2-4V7H5v6h3zm8 0h3l2-4V7h-6v6h3z"
}), _react.default.createElement("path", {
  fill: "none",
  d: "M0 0h24v24H0z"
})), 'FormatQuote');

exports.default = _default;

/***/ }),
/* 988 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles_withStyles__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_assets_jss_material_dashboard_pro_react_components_cardFooterStyle_jsx__ = __webpack_require__(989);
function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}// nodejs library that concatenates classes
// nodejs library to set properties for components
// @material-ui/core components
// @material-ui/icons
// core components
function CardFooter(_ref){var _classNames;var props=_objectWithoutProperties(_ref,[]);var classes=props.classes,className=props.className,children=props.children,plain=props.plain,profile=props.profile,pricing=props.pricing,testimonial=props.testimonial,stats=props.stats,chart=props.chart,product=props.product,rest=_objectWithoutProperties(props,["classes","className","children","plain","profile","pricing","testimonial","stats","chart","product"]);var cardFooterClasses=__WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classNames={},_defineProperty(_classNames,classes.cardFooter,true),_defineProperty(_classNames,classes.cardFooterPlain,plain),_defineProperty(_classNames,classes.cardFooterProfile,profile||testimonial),_defineProperty(_classNames,classes.cardFooterPricing,pricing),_defineProperty(_classNames,classes.cardFooterTestimonial,testimonial),_defineProperty(_classNames,classes.cardFooterStats,stats),_defineProperty(_classNames,classes.cardFooterChart,chart||product),_defineProperty(_classNames,className,className!==undefined),_classNames));return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",Object.assign({className:cardFooterClasses},rest),children);}CardFooter.propTypes={classes:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired,className:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,plain:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,profile:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,pricing:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,testimonial:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,stats:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,chart:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,product:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool};/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles_withStyles___default()(__WEBPACK_IMPORTED_MODULE_4_assets_jss_material_dashboard_pro_react_components_cardFooterStyle_jsx__["a" /* default */])(CardFooter));

/***/ }),
/* 989 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var cardFooterStyle={cardFooter:{padding:"0",paddingTop:"10px",margin:"0 15px 10px",borderRadius:"0",justifyContent:"space-between",alignItems:"center",display:"flex",backgroundColor:"transparent",border:"0"},cardFooterProfile:{marginTop:"-15px"},cardFooterPlain:{paddingLeft:"5px",paddingRight:"5px",backgroundColor:"transparent"},cardFooterPricing:{zIndex:"2"},cardFooterTestimonial:{display:"block"},cardFooterStats:{borderTop:"1px solid #eee",marginTop:"20px","& svg":{position:"relative",top:"4px",marginRight:"3px",marginLeft:"3px",width:"16px",height:"16px"},"& .fab,& .fas,& .far,& .fal,& .material-icons":{position:"relative",top:"4px",marginRight:"3px",marginLeft:"3px",fontSize:"16px",lineHeight:"16px"}},cardFooterChart:{borderTop:"1px solid #eee"}};/* harmony default export */ __webpack_exports__["a"] = (cardFooterStyle);

/***/ }),
/* 990 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__material_ui_core_CircularProgress__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__material_ui_core_CircularProgress___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__material_ui_core_CircularProgress__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__material_ui_core_Hidden__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__material_ui_core_Hidden___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Hidden__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_styles_withStyles__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_styles_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_styles_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_assets_EnergyCompany_img_bg_footer_png__ = __webpack_require__(991);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_assets_EnergyCompany_img_bg_footer_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_assets_EnergyCompany_img_bg_footer_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_assets_EnergyCompany_jss_button_transparent_blue_border_jsx__ = __webpack_require__(357);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__center__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_services_contato__ = __webpack_require__(359);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var inputTextStyle={border:"none",background:"#F6F6F6",borderRadius:"3px",height:"40px",padding:"0 10px"};var style=function style(theme){return{button:Object.assign({},__WEBPACK_IMPORTED_MODULE_6_assets_EnergyCompany_jss_button_transparent_blue_border_jsx__["a" /* default */],{gridColumnStart:2}),centeredSection:Object.assign({},Object(__WEBPACK_IMPORTED_MODULE_7__center__["a" /* default */])(theme),{padding:"20px 0"}),circularProgress:{left:"50%",marginTop:-12,marginLeft:-12,position:"absolute",top:"50%"},disclaimer:_defineProperty({flex:1,"& h4":{fontWeight:"bold"},"& p":{fontWeight:"400"}},theme.breakpoints.down("sm"),{fontSize:"16px",textAlign:"center"}),emailSentMessage:{gridColumnEnd:"span 2"},form:{flex:1,display:"grid",gridGap:"15px",gridTemplateColumns:"1fr 1fr"},formCard:_defineProperty({backgroundColor:"white",borderRadius:"6px",display:"flex",padding:"50px"},theme.breakpoints.down("sm"),{padding:"10px",display:"block"}),inputText:Object.assign({},inputTextStyle),main:{alignItems:"center",backgroundImage:'url('+__WEBPACK_IMPORTED_MODULE_5_assets_EnergyCompany_img_bg_footer_png___default.a+')',backgroundRepeat:"no-repeat",backgroundSize:"cover",backgroundPosition:"center",display:"flex",height:"440px"},sendButtonWrapper:{display:"flex",gridColumnStart:2,justifyContent:"center",justifySelf:"flex-end",position:'relative'},textarea:Object.assign({},inputTextStyle,{gridColumn:"1 / span 2",height:"unset",padding:"10px"})};};var Contato=function(_Component){_inherits(Contato,_Component);function Contato(){var _ref;var _temp,_this,_ret;_classCallCheck(this,Contato);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=Contato.__proto__||Object.getPrototypeOf(Contato)).call.apply(_ref,[this].concat(args))),_this),_this.state={emailSentMessage:"",email:"",nome:"",msg:"",sending:false},_this.handleClick=function(){_this.setState({sending:true});var _this$state=_this.state,email=_this$state.email,nome=_this$state.nome,msg=_this$state.msg;Object(__WEBPACK_IMPORTED_MODULE_8_services_contato__["a" /* sendMessage */])({email:email,nome:nome,msg:msg}).then(function(){return _this.setState({emailSentMessage:"Mensagem enviada com sucesso, entraremos em contato em breve.",email:"",nome:"",msg:"",sending:false});}).catch(function(){return _this.setState({emailSentMessage:"Erro no envio da mensage, por favor tente novamente mais tarde.",sending:false});});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(Contato,[{key:'render',value:function render(){var _this2=this;var classes=this.props.classes;var _state=this.state,emailSentMessage=_state.emailSentMessage,email=_state.email,nome=_state.nome,msg=_state.msg,sending=_state.sending;return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('main',{className:classes.main,id:'contato'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('section',{className:classes.centeredSection},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:classes.formCard},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:classes.disclaimer},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('h4',null,'Entre em contato'),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Hidden___default.a,{smDown:true},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('p',null,'Ainda em d\xFAvida? Envie uma mensagem e retornaremos o contato'),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('p',null,'o mais r\xE1pido poss\xEDvel. Ou ',__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('a',{href:'cadastro'},'cadastre-se'),' agora e tenha acesso livre'),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('p',null,'durante ',__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('b',null,'30 dias'),' para testar todas as nossas funcionalidades.'),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('p',null,'S\xF3 comece a pagar se satisfeito.')),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Hidden___default.a,{mdUp:true},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('p',null,'Envie uma mensagem para se cadastrar na Energy Company, retornaremos o contato o mais r\xE1pido poss\xEDvel. Tenha acesso livre durante ',__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('b',null,'30 dias'),' para testar todas as nossas funcionalidades. S\xF3 comece a pagar se satisfeito.'))),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:classes.form},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('input',{className:classes.inputText,onChange:function onChange(e){return _this2.setState({nome:e.target.value});},placeholder:'Nome',type:'text',value:nome}),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('input',{className:classes.inputText,onChange:function onChange(e){return _this2.setState({email:e.target.value});},placeholder:'E-mail',type:'text',value:email}),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('textarea',{className:classes.textarea,onChange:function onChange(e){return _this2.setState({msg:e.target.value});},placeholder:'Mensagem',rows:'5',type:'area',value:msg}),emailSentMessage?__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('p',{className:classes.emailSentMessage},emailSentMessage):__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:classes.sendButtonWrapper},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('button',{className:classes.button,disabled:sending,onClick:this.handleClick},'Enviar'),sending&&__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core_CircularProgress___default.a,{className:classes.circularProgress,size:24}))))));}}]);return Contato;}(__WEBPACK_IMPORTED_MODULE_2_react__["Component"]);;Contato.propTypes={classes:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired};/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_4__material_ui_core_styles_withStyles___default()(style)(Contato));

/***/ }),
/* 991 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/bg-footer.eba77365.png";

/***/ }),
/* 992 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__material_ui_core_Hidden__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__material_ui_core_Hidden___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__material_ui_core_Hidden__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles_withStyles__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_assets_EnergyCompany_jss_button_blue_jsx__ = __webpack_require__(366);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__center__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_assets_EnergyCompany_img_logo_svg__ = __webpack_require__(993);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_assets_EnergyCompany_img_logo_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_assets_EnergyCompany_img_logo_svg__);
function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var style=function style(theme){return{button:Object.assign({},__WEBPACK_IMPORTED_MODULE_4_assets_EnergyCompany_jss_button_blue_jsx__["a" /* default */]),centeredSection:Object.assign({},Object(__WEBPACK_IMPORTED_MODULE_5__center__["a" /* default */])(theme)),contato:{alignItems:"center",display:"flex",flexDirection:"column","& span":{fontSize:"12px",marginTop:"10px"}},copyright:_defineProperty({color:"darkgrey",marginTop:"50px"},theme.breakpoints.down("sm"),{margin:"20px"}),logo:{width:"200px"},li:{cursor:"pointer",display:"inline-block",listStyle:"none",marginLeft:theme.spacing.unit*2,textTransform:"uppercase","& a":{color:"black"}},links:{alignItems:"center",display:"flex",flexDirection:"column",fontSize:"12px"},main:_defineProperty({backgroundColor:"white",color:"black",padding:"50px"},theme.breakpoints.down("sm"),{padding:"0"}),sectionWrapper:_defineProperty({alignItems:"center",display:"flex",justifyContent:"space-between"},theme.breakpoints.down("sm"),{flexDirection:"column"}),ul:{margin:0,padding:0}};};var Footer=function Footer(_ref){var classes=_ref.classes,history=_ref.history,user=_ref.user;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("main",{className:classes.main},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("section",{className:classes.centeredSection},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:classes.sectionWrapper},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("img",{alt:"Logo",className:classes.logo,src:__WEBPACK_IMPORTED_MODULE_6_assets_EnergyCompany_img_logo_svg___default.a}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:classes.links},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("ul",{className:classes.ul},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core_Hidden___default.a,{smDown:true},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("li",{className:classes.li},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("a",{href:"/planos"},"Planos")),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("li",{className:classes.li},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("a",{href:"#sobre-nos"},"Sobre N\xF3s")),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("li",{className:classes.li},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("a",{href:"#contato"},"Contato")))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span",{className:classes.copyright},"©"+new Date().getFullYear()+" Energy Company | Todos os direitos reservados")),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:classes.contato},user.access_token?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("button",{className:classes.button,onClick:function onClick(){return history.push("/dashboard");}},"DASHBOARD"):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("button",{className:classes.button,onClick:function onClick(){return history.push("/login");}},"LOGIN"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span",null,"(81) 99921-0131")))));};Footer.propTypes={classes:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired,history:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({push:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired}).isRequired,user:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired};/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles_withStyles___default()(style)(Footer));

/***/ }),
/* 993 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/logo.0ba4eb43.svg";

/***/ }),
/* 994 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__material_ui_icons_Email__ = __webpack_require__(367);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__material_ui_icons_Email___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__material_ui_icons_Email__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__material_ui_core_InputAdornment__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__material_ui_core_InputAdornment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_InputAdornment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_icons_LockOutlined__ = __webpack_require__(368);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_icons_LockOutlined___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__material_ui_icons_LockOutlined__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_styles_withStyles__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_styles_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_styles_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_redux__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_EnergyCompany_BouncingLoader_BouncingLoader_jsx__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_CustomButtons_Button_jsx__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_CustomInput_CustomInput_jsx__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_EnergyCompany_Cards_ECCard_jsx__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_components_Grid_GridContainer_jsx__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_components_Grid_GridItem_jsx__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_components_Snackbar_SnackbarContent_jsx__ = __webpack_require__(369);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_reducers_user_actions__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_services_auth__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_assets_jss_material_dashboard_pro_react_views_loginPageStyle_jsx__ = __webpack_require__(370);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// import CircularProgress from '@material-ui/core/CircularProgress';
var styles=function styles(theme){return Object.assign({},Object(__WEBPACK_IMPORTED_MODULE_16_assets_jss_material_dashboard_pro_react_views_loginPageStyle_jsx__["a" /* default */])(theme),{actionLink:{cursor:"pointer",marginTop:"10px"},container:Object.assign({},Object(__WEBPACK_IMPORTED_MODULE_16_assets_jss_material_dashboard_pro_react_views_loginPageStyle_jsx__["a" /* default */])(theme).container,{paddingTop:"18vh"}),loginButtonWrapper:{display:"flex",alignItems:"center",flexDirection:"column",margin:theme.spacing.unit,position:'relative'},titleActions:{color:"white",display:"flex",justifyContent:"center"}});};var LoginPage=function(_Component){_inherits(LoginPage,_Component);function LoginPage(){var _ref;var _temp,_this,_ret;_classCallCheck(this,LoginPage);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=LoginPage.__proto__||Object.getPrototypeOf(LoginPage)).call.apply(_ref,[this].concat(args))),_this),_this.state={error:false,forgetPassword:false,loading:false,password:"",updatingPasswordMsg:"",username:""},_this.forgetPassword=function(){_this.setState({forgetPassword:!_this.state.forgetPassword,updatingPasswordMsg:""});},_this.handleClick=function(){_this.state.forgetPassword?_this.sendForgetPasswordEmail():_this.login();},_this.sendForgetPasswordEmail=function(){var username=_this.state.username;_this.setState({loading:true,updatingPasswordMsg:""});Object(__WEBPACK_IMPORTED_MODULE_15_services_auth__["e" /* forgetPassword */])(username).then(function(){return _this.setState({loading:false,updatingPasswordMsg:__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("span",null,"E-mail enviado para ",__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("strong",null,username))});}).catch(function(err){console.log(err);});},_this.login=function(){var _this$state=_this.state,username=_this$state.username,password=_this$state.password;_this.setState({error:false,loading:true});_this.props.login(username,password).then(function(value){_this.setState({error:false,loading:false});_this.props.history.push("/dashboard");}).catch(function(err){_this.setState({error:true,loading:false});});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(LoginPage,[{key:"componentWillMount",value:function componentWillMount(){if(this.props.user.access_token){this.props.history.push("/dashboard");}}},{key:"render",value:function render(){var _this2=this;var classes=this.props.classes;var _state=this.state,error=_state.error,forgetPassword=_state.forgetPassword,loading=_state.loading,password=_state.password,updatingPasswordMsg=_state.updatingPasswordMsg,username=_state.username;return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div",{className:classes.container},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components_Grid_GridContainer_jsx__["a" /* default */],{alignContent:"center",justify:"center"},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_components_Grid_GridItem_jsx__["a" /* default */],{md:4,sm:6,xs:12},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("form",null,__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_EnergyCompany_Cards_ECCard_jsx__["a" /* default */],{content:__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_CustomInput_CustomInput_jsx__["a" /* default */],{formControlProps:{fullWidth:true},inputProps:{autoComplete:"username",endAdornment:__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_InputAdornment___default.a,{position:"end"},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_icons_Email___default.a,{className:classes.inputAdornmentIcon})),onChange:function onChange(evt){return _this2.setState({username:evt.target.value});},type:"email"},labelText:"Email"}),!forgetPassword&&__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_CustomInput_CustomInput_jsx__["a" /* default */],{formControlProps:{fullWidth:true},inputProps:{autoComplete:"current-password",endAdornment:__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_InputAdornment___default.a,{position:"end"},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_icons_LockOutlined___default.a,{className:classes.inputAdornmentIcon})),onChange:function onChange(evt){return _this2.setState({password:evt.target.value});},type:"password"},labelText:"Senha"})),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div",null,updatingPasswordMsg),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div",{className:classes.loginButtonWrapper},loading?__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_EnergyCompany_BouncingLoader_BouncingLoader_jsx__["a" /* default */],null):__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div",{className:classes.loginButtonWrapper},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_CustomButtons_Button_jsx__["a" /* default */],{color:"rose",disabled:!forgetPassword&&(!username||!password||loading),onClick:this.handleClick,size:"lg"},forgetPassword?"Enviar e-mail":"Entrar"),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("a",{className:classes.actionLink,onClick:this.forgetPassword},forgetPassword?"Login?":"Esqueceu a senha?"),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("a",{className:classes.actionLink,href:"/cadastro"},"N\xE3o tem conta? Cadastre-se")))),hasIcon:false,title:"Login",titleActionsClass:classes.titleActions})),error&&__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_components_Snackbar_SnackbarContent_jsx__["a" /* default */],{color:"rose",message:"Login ou senha inválidos."}))));}}]);return LoginPage;}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);LoginPage.propTypes={classes:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,history:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,login:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func.isRequired,user:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired};var mapStateToProps=function mapStateToProps(state){return{user:state.user};};var mapDispatchToProps={login:__WEBPACK_IMPORTED_MODULE_14_reducers_user_actions__["c" /* login */]};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_6_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_styles_withStyles___default()(styles)(LoginPage)));

/***/ }),
/* 995 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__ = __webpack_require__(21);
// ##############################
// // // SnackbarContent styles
// #############################
var snackbarContentStyle={root:Object.assign({},__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["i" /* defaultFont */],{flexWrap:"unset",position:"relative",padding:"20px 15px",lineHeight:"20px",marginBottom:"20px",fontSize:"14px",backgroundColor:"white",color:"#555555",borderRadius:"3px",boxShadow:"0 12px 20px -10px rgba(255, 255, 255, 0.28), 0 4px 20px 0px rgba(0, 0, 0, 0.12), 0 7px 8px -5px rgba(255, 255, 255, 0.2)"}),top20:{top:"20px"},top40:{top:"40px"},info:Object.assign({backgroundColor:"#00d3ee",color:"#ffffff"},__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["m" /* infoBoxShadow */]),success:Object.assign({backgroundColor:"#5cb860",color:"#ffffff"},__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["v" /* successBoxShadow */]),warning:Object.assign({backgroundColor:"#ffa21a",color:"#ffffff"},__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["z" /* warningBoxShadow */]),danger:Object.assign({backgroundColor:"#f55a4e",color:"#ffffff"},__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["e" /* dangerBoxShadow */]),primary:Object.assign({backgroundColor:"#af2cc5",color:"#ffffff"},__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["p" /* primaryBoxShadow */]),rose:Object.assign({backgroundColor:"#eb3573",color:"#ffffff"},__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["s" /* roseBoxShadow */]),message:{padding:"0",display:"block",maxWidth:"89%"},close:{width:"11px",height:"11px"},iconButton:{width:"24px",height:"24px"},icon:{// display: "block",
// left: "15px",
// position: "absolute",
// top: "50%",
// marginTop: "-15px",
width:"38px",height:"38px",display:"block",left:"15px",position:"absolute",marginTop:"-39px",fontSize:"20px",backgroundColor:"#FFFFFF",padding:"9px",borderRadius:"50%",maxWidth:"38px",boxShadow:"0 10px 30px -12px rgba(0, 0, 0, 0.42), 0 4px 25px 0px rgba(0, 0, 0, 0.12), 0 8px 10px -5px rgba(0, 0, 0, 0.2)"},infoIcon:{color:"#00d3ee"},successIcon:{color:"#5cb860"},warningIcon:{color:"#ffa21a"},dangerIcon:{color:"#f55a4e"},primaryIcon:{color:"#af2cc5"},roseIcon:{color:"#eb3573"},iconMessage:{paddingLeft:"50px",display:"block"}};/* harmony default export */ __webpack_exports__["a"] = (snackbarContentStyle);

/***/ }),
/* 996 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__material_ui_icons_Business__ = __webpack_require__(997);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__material_ui_icons_Business___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__material_ui_icons_Business__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles_withStyles__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_CustomButtons_Button_jsx__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_Card_Card_jsx__ = __webpack_require__(176);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_Card_CardBody_jsx__ = __webpack_require__(177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_Grid_GridContainer_jsx__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_Grid_GridItem_jsx__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_assets_jss_material_dashboard_pro_react_views_pricingPageStyle_jsx__ = __webpack_require__(998);
// import Home from "@material-ui/icons/Home";
// import Person from "@material-ui/icons/Person";
var styles=function styles(theme){var themeStyles=Object.assign({},Object(__WEBPACK_IMPORTED_MODULE_9_assets_jss_material_dashboard_pro_react_views_pricingPageStyle_jsx__["a" /* default */])(theme));return Object.assign({},themeStyles,{description:Object.assign({},themeStyles.description,{color:"black"}),escolherLink:{color:"white","&:focus":{color:"white"},"&:hover":{color:"white"},"&:visited":{color:"white"}},title:Object.assign({},themeStyles.title,{color:"black"})});};var PlanosPage=function PlanosPage(_ref){var classes=_ref.classes;return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("div",{className:classes.container},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_Grid_GridContainer_jsx__["a" /* default */],{justify:"center"},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_Grid_GridItem_jsx__["a" /* default */],{md:12,sm:12,xs:12},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("h2",{className:classes.title},"Entre em contato e tenha acesso ao Energy Company imediatamente"),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("h5",{className:classes.description},"Nosso plano garante acesso ilimitado ao Dashboard e Relat\xF3rios, al\xE9m de suporte personalizado."),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("h5",{className:classes.description},"Entre em contato via ",__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("a",{href:"mailto:contato@energycompany.com.br"},"contato@energycompany.com.br")))),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_Grid_GridContainer_jsx__["a" /* default */],{justify:"center"},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_Grid_GridItem_jsx__["a" /* default */],{md:3,sm:12,xs:12},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_Card_Card_jsx__["a" /* default */],{pricing:true,raised:true},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_Card_CardBody_jsx__["a" /* default */],{plain:true,pricing:true},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("div",{className:classes.icon},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_icons_Business___default.a,{className:classes.iconRose})),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("h3",{className:classes.cardTitle+" "+classes.marginTop30}),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_CustomButtons_Button_jsx__["a" /* default */],{color:"rose",round:true},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("a",{className:classes.escolherLink,href:"mailto:contato@energycompany.com.br?subject=Ol\xE1,%20gostaria%20de%20negociar%20o%20plano%20para%20mais%20de%2010%20pessoas"},"Entrar em contato")))))));};PlanosPage.propTypes={classes:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired};/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles_withStyles___default()(styles)(PlanosPage));

/***/ }),
/* 997 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(9);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(10));

var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
  fill: "none",
  d: "M0 0h24v24H0z"
}), _react.default.createElement("path", {
  d: "M12 7V3H2v18h20V7H12zM6 19H4v-2h2v2zm0-4H4v-2h2v2zm0-4H4V9h2v2zm0-4H4V5h2v2zm4 12H8v-2h2v2zm0-4H8v-2h2v2zm0-4H8V9h2v2zm0-4H8V5h2v2zm10 12h-8v-2h2v-2h-2v-2h2v-2h-2V9h8v10zm-2-8h-2v2h2v-2zm0 4h-2v2h2v-2z"
})), 'Business');

exports.default = _default;

/***/ }),
/* 998 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__ = __webpack_require__(21);
function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}// ##############################
// // // PricingPage Pages View styles
// #############################
var pricingPageStyle=function pricingPageStyle(theme){return{container:Object.assign({},__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["c" /* container */],_defineProperty({zIndex:"4"},theme.breakpoints.down("sm"),{paddingBottom:"100px"})),title:Object.assign({},__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["i" /* defaultFont */],{color:"#FFFFFF",marginTop:"5vh",marginBottom:"30px",textAlign:"center"}),description:{fontSize:"18px",color:"#FFFFFF",textAlign:"center"},cardTitleWhite:Object.assign({},__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["b" /* cardTitle */],{color:"#FFFFFF !important"}),cardCategory:{color:"#999999",marginTop:"10px"},cardCategoryWhite:{color:"#FFFFFF",marginTop:"10px"},icon:{color:"rgba(255, 255, 255, 0.76)",margin:"10px auto 0",width:"130px",height:"130px",border:"1px solid #E5E5E5",borderRadius:"50%",lineHeight:"174px","& svg":{width:"55px",height:"55px"},"& .fab,& .fas,& .far,& .fal,& .material-icons":{width:"55px",fontSize:"55px"}},iconWhite:{color:"#FFFFFF"},iconRose:{color:__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["u" /* roseColor */]},marginTop30:{marginTop:"30px"}};};/* harmony default export */ __webpack_exports__["a"] = (pricingPageStyle);

/***/ }),
/* 999 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export RegisterPageComponent */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__material_ui_icons_Check__ = __webpack_require__(260);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__material_ui_icons_Check___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__material_ui_icons_Check__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__material_ui_core_Checkbox__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__material_ui_core_Checkbox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Checkbox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_icons_Code__ = __webpack_require__(1000);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_icons_Code___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__material_ui_icons_Code__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_icons_Email__ = __webpack_require__(367);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_icons_Email___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__material_ui_icons_Email__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_icons_Face__ = __webpack_require__(1001);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_icons_Face___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__material_ui_icons_Face__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_icons_Filter7Rounded__ = __webpack_require__(1002);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_icons_Filter7Rounded___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__material_ui_icons_Filter7Rounded__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_FormControlLabel__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_FormControlLabel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_FormControlLabel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_icons_Group__ = __webpack_require__(1003);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_icons_Group___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__material_ui_icons_Group__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_InputAdornment__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_InputAdornment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_InputAdornment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_icons_Lock__ = __webpack_require__(1004);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_icons_Lock___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__material_ui_icons_Lock__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__material_ui_core_Modal__ = __webpack_require__(134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__material_ui_core_Modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_Modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__material_ui_icons_PermIdentity__ = __webpack_require__(360);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__material_ui_icons_PermIdentity___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__material_ui_icons_PermIdentity__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__material_ui_icons_Phone__ = __webpack_require__(1005);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__material_ui_icons_Phone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__material_ui_icons_Phone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_query_string__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_query_string___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_query_string__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__material_ui_icons_Timeline__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__material_ui_icons_Timeline___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__material_ui_icons_Timeline__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__material_ui_core_styles_withStyles__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__material_ui_core_styles_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__material_ui_core_styles_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_react_redux__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_lodash__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_components_EnergyCompany_Alert_Alerts__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_components_EnergyCompany_BouncingLoader_BouncingLoader_jsx__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_components_CustomButtons_Button_jsx__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_components_CustomInput_CustomInput_jsx__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_components_EnergyCompany_Cards_ECCard_jsx__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_components_Grid_GridContainer_jsx__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_components_Grid_GridItem_jsx__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_components_InfoArea_InfoArea_jsx__ = __webpack_require__(1006);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_services_utils__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_reducers_user_actions__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30_services_auth__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31_reducers_alerts_actions__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32_assets_jss_material_dashboard_pro_react_views_registerPageStyle__ = __webpack_require__(1008);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var styles=function styles(theme){return Object.assign({},__WEBPACK_IMPORTED_MODULE_32_assets_jss_material_dashboard_pro_react_views_registerPageStyle__["a" /* default */],{criarContaBtnWrapper:{paddingLeft:"14px"},emailSent:{fontWeight:"bold",marginBottom:"15px"},modalPaper:{backgroundColor:theme.palette.background.paper,boxShadow:theme.shadows[5],height:"80%",margin:"auto",overflowY:"scroll",padding:theme.spacing.unit*4,paddingTop:0,width:"80%"},root:{display:"flex"},termosWrapper:{padding:"10px 0"},titleActions:{color:"#3C4858",display:"flex",fontSize:"2.6em",justifyContent:"center"}});};var RegisterPage=function(_Component){_inherits(RegisterPage,_Component);function RegisterPage(props){_classCallCheck(this,RegisterPage);var _this=_possibleConstructorReturn(this,(RegisterPage.__proto__||Object.getPrototypeOf(RegisterPage)).call(this,props));_initialiseProps.call(_this);var queryStringParsed=__WEBPACK_IMPORTED_MODULE_13_query_string___default.a.parse(props.location.search);var _getFromAtob=Object(__WEBPACK_IMPORTED_MODULE_28_services_utils__["e" /* getFromAtob */])([queryStringParsed.id,queryStringParsed.nome,queryStringParsed.sobrenome]),_getFromAtob2=_slicedToArray(_getFromAtob,3),id=_getFromAtob2[0],nome=_getFromAtob2[1],sobrenome=_getFromAtob2[2];_this.foiConvidado=!!queryStringParsed.codigo;_this.state={cadastrando:false,cnpj:'',confirmacaoPendente:false,confirmacaoSenha:'',cpf:'',enviandoEmailCadastro:false,id:id,isModalOpened:false,nome:nome,senha:'',sobrenome:sobrenome,telefone:'',termosDeUsoChecked:false};return _this;}_createClass(RegisterPage,[{key:"shouldDisableSubmitButton",value:function shouldDisableSubmitButton(){var _this2=this;var requiredKeys=["confirmacaoSenha","cpf","id","nome","senha","sobrenome","telefone","termosDeUsoChecked"];return Object(__WEBPACK_IMPORTED_MODULE_19_lodash__["some"])(requiredKeys,function(requiredKey){return!!_this2.state[requiredKey]===false;});}},{key:"render",value:function render(){var _this3=this;var classes=this.props.classes;var _state=this.state,cadastrando=_state.cadastrando,cnpj=_state.cnpj,confirmacaoPendente=_state.confirmacaoPendente,confirmacaoSenha=_state.confirmacaoSenha,cpf=_state.cpf,enviandoEmailCadastro=_state.enviandoEmailCadastro,id=_state.id,isModalOpened=_state.isModalOpened,nome=_state.nome,senha=_state.senha,sobrenome=_state.sobrenome,telefone=_state.telefone,termosDeUsoChecked=_state.termosDeUsoChecked;return __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement("div",{className:classes.container},__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_25_components_Grid_GridContainer_jsx__["a" /* default */],{alignContent:"center",justify:"center"},__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_26_components_Grid_GridItem_jsx__["a" /* default */],{md:10,sm:12,xs:12},__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24_components_EnergyCompany_Cards_ECCard_jsx__["a" /* default */],{content:__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_25_components_Grid_GridContainer_jsx__["a" /* default */],{justify:"center"},__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_26_components_Grid_GridItem_jsx__["a" /* default */],{md:5,sm:12,xs:12},this.foiConvidado?__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_27_components_InfoArea_InfoArea_jsx__["a" /* default */],{description:"Ol\xE1, seja bem-vindo. Voc\xEA foi convidado para fazer parte de uma assinatura.",icon:__WEBPACK_IMPORTED_MODULE_7__material_ui_icons_Group___default.a,iconColor:"info",title:"Fa\xE7a parte de um time"}):__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_27_components_InfoArea_InfoArea_jsx__["a" /* default */],{description:"Tenha acesso ilimitado as funcionalidades do sistema, s\xF3 pague ap\xF3s 30 dias se satisfeito.",icon:__WEBPACK_IMPORTED_MODULE_5__material_ui_icons_Filter7Rounded___default.a,iconColor:"info",title:"Comece seu trial de 30 dias"}),__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_27_components_InfoArea_InfoArea_jsx__["a" /* default */],{description:"Verifique a atratividade de prec\u0327os do Mercado Livre x Cativo",icon:__WEBPACK_IMPORTED_MODULE_2__material_ui_icons_Code___default.a,iconColor:"rose",title:"Mercado Livre x Cativo"}),__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_27_components_InfoArea_InfoArea_jsx__["a" /* default */],{description:"Acompanhe o consumo dos agentes m\xEAs a m\xEAs",icon:__WEBPACK_IMPORTED_MODULE_16__material_ui_icons_Timeline___default.a,iconColor:"primary",title:"Acompanhamento de consumo"}),__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_27_components_InfoArea_InfoArea_jsx__["a" /* default */],{description:"Analise os dados de maneira estrat\xE9gica para a sua tomada de decis\xF5es",icon:__WEBPACK_IMPORTED_MODULE_0__material_ui_icons_Check___default.a,iconColor:"info",title:"Tome melhores decis\xF5es"})),__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_26_components_Grid_GridItem_jsx__["a" /* default */],{md:5,sm:8,xs:12},__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement("form",{className:classes.form},__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23_components_CustomInput_CustomInput_jsx__["a" /* default */],{formControlProps:{className:classes.customFormControlClasses,fullWidth:true},inputProps:{disabled:confirmacaoPendente,onChange:function onChange(e){return _this3.setState({nome:e.target.value});},placeholder:"Nome*",startAdornment:__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_InputAdornment___default.a,{className:classes.inputAdornment,position:"start"},__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_icons_Face___default.a,{className:classes.inputAdornmentIcon})),value:nome}}),__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23_components_CustomInput_CustomInput_jsx__["a" /* default */],{formControlProps:{className:classes.customFormControlClasses,fullWidth:true},inputProps:{disabled:confirmacaoPendente,onChange:function onChange(e){return _this3.setState({sobrenome:e.target.value});},placeholder:"Sobrenome*",startAdornment:__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_InputAdornment___default.a,{className:classes.inputAdornment,position:"start"},__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_icons_Face___default.a,{className:classes.inputAdornmentIcon})),value:sobrenome}}),__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23_components_CustomInput_CustomInput_jsx__["a" /* default */],{formControlProps:{className:classes.customFormControlClasses,fullWidth:true},inputProps:{disabled:this.foiConvidado||confirmacaoPendente,onChange:function onChange(e){return _this3.setState({id:e.target.value});},placeholder:"Email*",startAdornment:__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_InputAdornment___default.a,{className:classes.inputAdornment,position:"start"},__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_icons_Email___default.a,{className:classes.inputAdornmentIcon})),value:id}}),__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23_components_CustomInput_CustomInput_jsx__["a" /* default */],{formControlProps:{className:classes.customFormControlClasses,fullWidth:true},inputProps:{disabled:confirmacaoPendente,onChange:function onChange(_ref){var target=_ref.target;return target.value.length<16&&_this3.setState({telefone:target.value});},placeholder:"Telefone*",startAdornment:__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_InputAdornment___default.a,{className:classes.inputAdornment,position:"start"},__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__material_ui_icons_Phone___default.a,{className:classes.inputAdornmentIcon})),value:Object(__WEBPACK_IMPORTED_MODULE_28_services_utils__["j" /* telefoneMask */])(telefone)}}),__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23_components_CustomInput_CustomInput_jsx__["a" /* default */],{formControlProps:{className:classes.customFormControlClasses,fullWidth:true},inputProps:{disabled:confirmacaoPendente,onChange:function onChange(_ref2){var target=_ref2.target;return target.value.length<15&&_this3.setState({cpf:target.value});},placeholder:"CPF*",startAdornment:__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_InputAdornment___default.a,{className:classes.inputAdornment,position:"start"},__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_icons_PermIdentity___default.a,{className:classes.inputAdornmentIcon})),value:Object(__WEBPACK_IMPORTED_MODULE_28_services_utils__["c" /* CPFMask */])(cpf)}}),__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23_components_CustomInput_CustomInput_jsx__["a" /* default */],{formControlProps:{className:classes.customFormControlClasses,fullWidth:true},inputProps:{disabled:confirmacaoPendente,onChange:function onChange(_ref3){var target=_ref3.target;return target.value.length<19&&_this3.setState({cnpj:target.value});},placeholder:"CNPJ",startAdornment:__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_InputAdornment___default.a,{className:classes.inputAdornment,position:"start"},__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_icons_PermIdentity___default.a,{className:classes.inputAdornmentIcon})),value:Object(__WEBPACK_IMPORTED_MODULE_28_services_utils__["a" /* CNPJMask */])(cnpj)}}),__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23_components_CustomInput_CustomInput_jsx__["a" /* default */],{formControlProps:{className:classes.customFormControlClasses,fullWidth:true},inputProps:{autoComplete:"new-password",disabled:confirmacaoPendente,onChange:function onChange(e){return _this3.setState({senha:e.target.value});},placeholder:"Senha*",startAdornment:__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_InputAdornment___default.a,{className:classes.inputAdornment,position:"start"},__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_icons_Lock___default.a,{className:classes.inputAdornmentIcon})),type:"password",value:senha}}),__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23_components_CustomInput_CustomInput_jsx__["a" /* default */],{formControlProps:{className:classes.customFormControlClasses,fullWidth:true},inputProps:{autoComplete:"new-password",disabled:confirmacaoPendente,onChange:function onChange(e){return _this3.setState({confirmacaoSenha:e.target.value});},placeholder:"Confirmar Senha*",startAdornment:__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_InputAdornment___default.a,{className:classes.inputAdornment,position:"start"},__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_icons_Lock___default.a,{className:classes.inputAdornmentIcon})),type:"password",value:confirmacaoSenha}}),__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement("div",{className:classes.termosWrapper},__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_FormControlLabel___default.a,{classes:{root:classes.checkboxLabelControl,label:classes.checkboxLabel},control:__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Checkbox___default.a,{checked:termosDeUsoChecked,checkedIcon:__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_icons_Check___default.a,{className:classes.checkedIcon}),classes:{checked:classes.checked},disabled:confirmacaoPendente,icon:__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_icons_Check___default.a,{className:classes.uncheckedIcon}),onClick:this.checkTermos}),label:__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement("span",null,"Eu aceito os"," ",__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement("a",{onClick:function onClick(){return _this3.setState({isModalOpened:true});}},"termos e condi\xE7\xF5es"),".")})),__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement("div",{className:classes.criarContaBtnWrapper},confirmacaoPendente?__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement("div",null,enviandoEmailCadastro?__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21_components_EnergyCompany_BouncingLoader_BouncingLoader_jsx__["a" /* default */],null):__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement("div",{className:classes.emailSent},"Enviamos um email para voc\xEA confirmar o cadastro, ele pode levar alguns minutos para chegar."),__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22_components_CustomButtons_Button_jsx__["a" /* default */],{color:"primary",onClick:this.reenviarEmailCadastro,round:true},"N\xE3o recebeu o email? Reenvie"))):cadastrando?__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21_components_EnergyCompany_BouncingLoader_BouncingLoader_jsx__["a" /* default */],null):__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22_components_CustomButtons_Button_jsx__["a" /* default */],{color:"primary",disabled:this.shouldDisableSubmitButton(),onClick:this.onCadastrarUsuarioBtnClicked,round:true},"Criar conta"))))),title:"Crie sua conta",titleActionsClass:classes.titleActions}),__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_Modal___default.a,{"aria-describedby":"simple-modal-description","aria-labelledby":"simple-modal-title",classes:{root:classes.root},onClose:function onClose(){return _this3.setState({isModalOpened:false});},open:isModalOpened},__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement("div",{className:classes.modalPaper},__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement("h2",null,"Termos de uso"),__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement("p",null,__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement("strong",null,"\xDAltima atualiza\xE7\xE3o: 18 de Agosto de 2018")),__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement("ol",null,__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement("li",null,"Os presentes termos de uso (doravante denominados \u201Ctermos de uso\u201D) governam o acesso e utiliza\xE7\xE3o dos sites, plataformas, aplicativos e servi\xE7os oferecidos pela Energy Company, bem como qualquer outro servi\xE7o vinculado diretamente a ela de qualquer forma (todos s\xE3o doravante designados como Energy Company, assim como todo o empreendimento Energy Company tamb\xE9m \xE9 designado pelo termo Energy Company). Os presentes termos de uso estabelecem condi\xE7\xF5es essenciais e necess\xE1rias para a utiliza\xE7\xE3o da Energy Company. A utiliza\xE7\xE3o de qualquer servi\xE7o da Energy Company implica imediata aceita\xE7\xE3o dos presentes termos de uso, bem como dos termos de uso espec\xEDficos aplic\xE1veis. Os presentes termos de uso, al\xE9m de regularem contratualmente a rela\xE7\xE3o entre as partes, devem ser entendidos tamb\xE9m como licen\xE7a de uso dos servi\xE7os, aplicativos e plataformas da Energy Company. A Energy Company \xE9 detentora de v\xE1rios bens intelectuais. Para a utiliza\xE7\xE3o de qualquer forma dos seus servi\xE7os, \xE9 obrigat\xF3rio aceitar os presentes termos de uso. Sua n\xE3o aceita\xE7\xE3o ou infra\xE7\xE3o constitui n\xE3o apenas viola\xE7\xE3o dos presentes termos de uso, como tamb\xE9m viola\xE7\xE3o da propriedade intelectual da Energy Company."),__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement("li",null,"A vers\xE3o v\xE1lida e eficaz dos presentes termos de uso \xE9 aquela publicada atualmente pelo site. Esta vers\xE3o governa todas as rela\xE7\xF5es passadas e presentes entre os usu\xE1rios do site, respeitados direitos adquiridos, atos jur\xEDdicos perfeitos e coisas julgadas. O usu\xE1rio dever\xE1 sempre ler atentamente os presentes termos de uso, e n\xE3o poder\xE1 escusar-se deles alegando ignor\xE2ncia sobre seus termos, inclusive quanto a eventuais modifica\xE7\xF5es."),__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement("li",null,"V\xE1rios servi\xE7os e conte\xFAdos oferecidos pelo site s\xE3o objeto de termos de uso espec\xEDficos. Esses termos de uso podem substituir, complementar ou modificar os presentes termos de uso. No caso de conflito entre os presentes termos de uso e a pol\xEDtica de uso espec\xEDficas aplic\xE1veis a outras plataformas ou servi\xE7os espec\xEDficos, o especial dever\xE1 prevalecer sobre o geral. As condi\xE7\xF5es especiais tamb\xE9m dever\xE3o sempre ser lidas pelos usu\xE1rios, nos termos do item (2) acima. Outros avisos e comunicados poder\xE3o estar presentes ao longo do site, regulando sua forma de utiliza\xE7\xE3o. Esses avisos dever\xE3o ser interpretados em harmonia com os presentes termos de uso.")),__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement("p",null,__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement("strong",null,"A. Objeto dos Termos de Uso")),__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement("ol",null,__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement("li",null,"Uma vez que os presentes termos de uso s\xE3o aceitos, o usu\xE1rio tem a sua disposi\xE7\xE3o diversos servi\xE7os disponibilizados pela Energy Company (doravante designados servi\xE7os)."),__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement("li",null,"Os servi\xE7os oferecidos pela Energy Company s\xE3o de car\xE1ter restrito apenas para usu\xE1rios que possuam assinaturas v\xE1lidas.")),__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement("p",null,__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement("strong",null,"B. Registro dos Usu\xE1rios e Veracidade das Informa\xE7\xF5es")),__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement("ol",null,__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement("li",null,"O acesso aos servi\xE7os da Energy Company pode n\xE3o exigir o pr\xE9vio registro ou inscri\xE7\xE3o dos usu\xE1rios na plataforma. Entretanto, esse n\xE3o registro n\xE3o implica que esses usu\xE1rios n\xE3o tenham aceitado os presentes termos de uso. Outros servi\xE7os da Energy Company, para serem acessados, exigem que o usu\xE1rio seja cadastrado de acordo com mecanismos espec\xEDficos de cadastro."),__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement("li",null,"Toda informa\xE7\xE3o oferecida pelo usu\xE1rio para utilizar os servi\xE7os da Energy Company dever\xE1 ser verdadeira. O usu\xE1rio garante a autenticidade de todos os dados que informar atrav\xE9s do preenchimento dos formul\xE1rios disponibilizados ou atrav\xE9s de mecanismos automatizados de registro ou login. \xC9 de exclusiva responsabilidade do usu\xE1rio manter qualquer informa\xE7\xE3o fornecida \xE0 Energy Company permanentemente atualizada de forma a sempre refletir os dados reais do usu\xE1rio. O fornecimento de declara\xE7\xF5es falsas ou inexatas constitui viola\xE7\xE3o dos presentes termos de uso, bem como revoga\xE7\xE3o da licen\xE7a de utiliza\xE7\xE3o da Energy Company. Em quaisquer casos, o usu\xE1rio ser\xE1 sempre o \xFAnico e exclusivo respons\xE1vel pela sua conduta e por danos por ela causados no \xE2mbito da Energy Company, quanto a ela e quanto a terceiros e parceiros."),__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement("li",null,"Crian\xE7as e adolescentes devem obter a pr\xE9via autoriza\xE7\xE3o dos pais, tutores ou representantes legais como forma de acessarem os servi\xE7os da Energy Company, os quais ser\xE3o considerados respons\xE1veis por todos os atos praticados pelos menores. Os pais, tutores ou representantes legais ser\xE3o plenamente respons\xE1veis tamb\xE9m no caso de acesso dos servi\xE7os da Energy Company por parte de menores, sem a devida obten\xE7\xE3o de autoriza\xE7\xE3o pr\xE9via. Cabe a eles a integral responsabilidade pela fiscaliza\xE7\xE3o das atividades e conduta das respectivas crian\xE7as ou adolescentes sob sua tutela."),__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement("li",null,"O usu\xE1rio se compromete a utilizar os servi\xE7os da Energy Company de boa-f\xE9 e em conformidade como todos os preceitos legais, regulamentares e contratuais porventura aplic\xE1veis, bem como com a ordem p\xFAblica, as normas e padr\xF5es de conduta do mercado geralmente aceitas ou tidas como boas pr\xE1ticas."),__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement("li",null,"O usu\xE1rio n\xE3o poder\xE1 de nenhuma forma empregar mecanismos t\xE9cnicos que de qualquer forma subvertam a regular utiliza\xE7\xE3o dos servi\xE7os da Energy Company, sem a pr\xE9via consulta aos gestores da Energy Company. Esses mecanismos incluem a utiliza\xE7\xE3o de rob\xF4s (robots, ou bots), spiders, scripts, IP spoof, MAC Address spoof ou qualquer outra forma de acesso automatizado ao site que de alguma forma sirva para desvirtuar suas finalidades e prop\xF3sitos. O emprego desses recursos sem autoriza\xE7\xE3o pr\xE9via implica viola\xE7\xE3o dos presentes termos de uso e sujeita a parte infringente ao pagamento de danos emergentes e lucros cessantes, bem como de multa punitiva que se aplicar\xE1 mesmo que n\xE3o tenha sido produzido qualquer dano, a ser arbitrada pelo ju\xEDzo que for respons\xE1vel pelo julgamento da causa.")),__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement("p",null,__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement("strong",null,"C. Marcas, Patentes, Nomes Comerciais e Outros")),__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement("ol",null,__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement("li",null,"Todas as marcas, patentes, nomes comerciais e sinais distintivos de qualquer esp\xE9cie presentes nos servi\xE7os da Energy Company, incluindo sua pr\xF3pria marca e designa\xE7\xE3o, s\xE3o pertencentes a seus respectivos titulares de direito. Para a utiliza\xE7\xE3o de quaisquer destas marcas, nomes e sinais, \xE9 necess\xE1rio a obten\xE7\xE3o da respectiva autoriza\xE7\xE3o dos seus titulares.")),__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement("p",null,__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement("strong",null,"D. Suspens\xE3o de Servi\xE7o e Retirada de Usu\xE1rios")),__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement("ol",null,__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement("li",null,"A presta\xE7\xE3o dos servi\xE7os da Energy Company depende de informa\xE7\xF5es p\xFAblicas fornecidas por institui\xE7\xF5es independentes, desta forma a mesma poder\xE1 terminar, suspender ou interromper bilateralmente e a qualquer momento, com a necessidade de pr\xE9vio aviso, a presta\xE7\xE3o total ou parcial do servi\xE7o, ou sua inteira transforma\xE7\xE3o e modifica\xE7\xE3o, sem preju\xEDzo as partes envolvidas."),__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement("li",null,"O conte\xFAdo desta publica\xE7\xE3o foi produzido pela Energy Company com base em dados e informa\xE7\xF5es de conhecimento p\xFAblico. \xC9 de responsabilidade exclusiva dos agentes e demais interessados a obten\xE7\xE3o de outros dados e informa\xE7\xF5es, a realiza\xE7\xE3o de an\xE1lises, estudos e avalia\xE7\xF5es para fins de tomada de decis\xF5es, defini\xE7\xE3o de estrat\xE9gias de atua\xE7\xE3o, assun\xE7\xE3o de compromissos e obriga\xE7\xF5es e quaisquer outras finalidades, em qualquer tempo e sob qualquer condi\xE7\xE3o.")),__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement("div",{className:classes.right},__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22_components_CustomButtons_Button_jsx__["a" /* default */],{color:"primary",onClick:function onClick(){return _this3.setState({isModalOpened:false,termosDeUsoChecked:true});},round:true},"Aceitar Termos")))))),__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20_components_EnergyCompany_Alert_Alerts__["a" /* default */],null));}}]);return RegisterPage;}(__WEBPACK_IMPORTED_MODULE_14_react__["Component"]);var _initialiseProps=function _initialiseProps(){var _this4=this;this.checkTermos=function(){_this4.setState({termosDeUsoChecked:!_this4.state.termosDeUsoChecked});};this.onCadastrarUsuarioBtnClicked=function(){var _state2=_this4.state,cnpj=_state2.cnpj,confirmacaoSenha=_state2.confirmacaoSenha,cpf=_state2.cpf,id=_state2.id,nome=_state2.nome,senha=_state2.senha,sobrenome=_state2.sobrenome,telefone=_state2.telefone,termosDeUsoChecked=_state2.termosDeUsoChecked;var _props=_this4.props,history=_props.history,location=_props.location;var _queryString$parse=__WEBPACK_IMPORTED_MODULE_13_query_string___default.a.parse(location.search),codigo=_queryString$parse.codigo;var info={cnpj:Object(__WEBPACK_IMPORTED_MODULE_28_services_utils__["h" /* removeNonDigits */])(cnpj),codigo:codigo,confirmacaoSenha:confirmacaoSenha,cpf:Object(__WEBPACK_IMPORTED_MODULE_28_services_utils__["h" /* removeNonDigits */])(cpf),id:id,nome:nome,senha:senha,sobrenome:sobrenome,telefone:Object(__WEBPACK_IMPORTED_MODULE_28_services_utils__["h" /* removeNonDigits */])(telefone),termosDeUsoChecked:termosDeUsoChecked};_this4.setState({cadastrando:true});_this4.props.cadastrarUsuario(info).then(function(data){if(data.confirmacaoPendente){_this4.setState({confirmacaoPendente:true});}else{history.push("/dashboard");}}).catch(function(_ref4){var response=_ref4.response;_this4.setState({cadastrando:false});_this4.props.showAlert({message:Object(__WEBPACK_IMPORTED_MODULE_19_lodash__["values"])(response.data).join(" "),type:'error'});});};this.reenviarEmailCadastro=function(){_this4.setState({enviandoEmailCadastro:true});Object(__WEBPACK_IMPORTED_MODULE_30_services_auth__["d" /* enviarEmailCadastro */])({email:_this4.state.id}).then(function(_ref5){var response=_ref5.response;_this4.setState({enviandoEmailCadastro:false});}).catch(function(){_this4.setState({enviandoEmailCadastro:false});_this4.props.showAlert({message:'Não conseguimos reenviar o email, por favor tente após alguns instantes.',type:'error'});});};};RegisterPage.propTypes={cadastrarUsuario:__WEBPACK_IMPORTED_MODULE_15_prop_types___default.a.func.isRequired,classes:__WEBPACK_IMPORTED_MODULE_15_prop_types___default.a.object.isRequired,history:__WEBPACK_IMPORTED_MODULE_15_prop_types___default.a.object.isRequired,location:__WEBPACK_IMPORTED_MODULE_15_prop_types___default.a.object.isRequired,showAlert:__WEBPACK_IMPORTED_MODULE_15_prop_types___default.a.func.isRequired};var mapDispatchToProps={cadastrarUsuario:__WEBPACK_IMPORTED_MODULE_29_reducers_user_actions__["b" /* cadastrarUsuario */],showAlert:__WEBPACK_IMPORTED_MODULE_31_reducers_alerts_actions__["b" /* showAlert */]};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_18_react_redux__["b" /* connect */])(null,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_17__material_ui_core_styles_withStyles___default()(styles)(RegisterPage)));

/***/ }),
/* 1000 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(9);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(10));

var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
  fill: "none",
  d: "M0 0h24v24H0V0z"
}), _react.default.createElement("path", {
  d: "M9.4 16.6L4.8 12l4.6-4.6L8 6l-6 6 6 6 1.4-1.4zm5.2 0l4.6-4.6-4.6-4.6L16 6l6 6-6 6-1.4-1.4z"
})), 'Code');

exports.default = _default;

/***/ }),
/* 1001 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(9);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(10));

var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
  d: "M9 11.75c-.69 0-1.25.56-1.25 1.25s.56 1.25 1.25 1.25 1.25-.56 1.25-1.25-.56-1.25-1.25-1.25zm6 0c-.69 0-1.25.56-1.25 1.25s.56 1.25 1.25 1.25 1.25-.56 1.25-1.25-.56-1.25-1.25-1.25zM12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8 0-.29.02-.58.05-.86 2.36-1.05 4.23-2.98 5.21-5.37C11.07 8.33 14.05 10 17.42 10c.78 0 1.53-.09 2.25-.26.21.71.33 1.47.33 2.26 0 4.41-3.59 8-8 8z"
}), _react.default.createElement("path", {
  fill: "none",
  d: "M0 0h24v24H0z"
})), 'Face');

exports.default = _default;

/***/ }),
/* 1002 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(9);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(10));

var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
  fill: "none",
  d: "M0 0h24v24H0V0z"
}), _react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M2 5c-.55 0-1 .45-1 1v15c0 1.1.9 2 2 2h15c.55 0 1-.45 1-1s-.45-1-1-1H4c-.55 0-1-.45-1-1V6c0-.55-.45-1-1-1zm19-4H7c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zm-1 16H8c-.55 0-1-.45-1-1V4c0-.55.45-1 1-1h12c.55 0 1 .45 1 1v12c0 .55-.45 1-1 1zm-6.75-2.49l3.58-7.17c.11-.22.17-.47.17-.72 0-.9-.72-1.62-1.62-1.62H12c-.55 0-1 .45-1 1s.45 1 1 1h3l-3.36 6.71c-.3.59.13 1.29.8 1.29h.01c.34 0 .65-.19.8-.49z"
}))), 'Filter7Rounded');

exports.default = _default;

/***/ }),
/* 1003 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(9);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(10));

var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
  fill: "none",
  d: "M0 0h24v24H0z"
}), _react.default.createElement("path", {
  d: "M16 11c1.66 0 2.99-1.34 2.99-3S17.66 5 16 5c-1.66 0-3 1.34-3 3s1.34 3 3 3zm-8 0c1.66 0 2.99-1.34 2.99-3S9.66 5 8 5C6.34 5 5 6.34 5 8s1.34 3 3 3zm0 2c-2.33 0-7 1.17-7 3.5V19h14v-2.5c0-2.33-4.67-3.5-7-3.5zm8 0c-.29 0-.62.02-.97.05 1.16.84 1.97 1.97 1.97 3.45V19h6v-2.5c0-2.33-4.67-3.5-7-3.5z"
})), 'Group');

exports.default = _default;

/***/ }),
/* 1004 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(9);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(10));

var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
  fill: "none",
  d: "M0 0h24v24H0z"
}), _react.default.createElement("path", {
  d: "M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zm-6 9c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm3.1-9H8.9V6c0-1.71 1.39-3.1 3.1-3.1 1.71 0 3.1 1.39 3.1 3.1v2z"
})), 'Lock');

exports.default = _default;

/***/ }),
/* 1005 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(9);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(10));

var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
  fill: "none",
  d: "M0 0h24v24H0z"
}), _react.default.createElement("path", {
  d: "M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z"
})), 'Phone');

exports.default = _default;

/***/ }),
/* 1006 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_styles_withStyles__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_styles_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_styles_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_assets_jss_material_dashboard_pro_react_components_infoStyle__ = __webpack_require__(1007);
function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}// @material-ui/core components
function InfoArea(_ref){var props=_objectWithoutProperties(_ref,[]);var classes=props.classes,title=props.title,description=props.description,iconColor=props.iconColor;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:classes.infoArea},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:classes.iconWrapper+" "+classes[iconColor]},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(props.icon,{className:classes.icon})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:classes.descriptionWrapper},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h4",{className:classes.title},title),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{className:classes.description},description)));}InfoArea.defaultProps={iconColor:"gray"};InfoArea.propTypes={classes:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,icon:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,title:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,description:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,iconColor:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(["primary","warning","danger","success","info","rose","gray"])};/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_2__material_ui_core_styles_withStyles___default()(__WEBPACK_IMPORTED_MODULE_3_assets_jss_material_dashboard_pro_react_components_infoStyle__["a" /* default */])(InfoArea));

/***/ }),
/* 1007 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__ = __webpack_require__(21);
// ##############################
// // // Info component styles
// #############################
var infoStyle={infoArea:{maxWidth:"360px",margin:"0 auto",padding:"0px"},iconWrapper:{float:"left",marginTop:"24px",marginRight:"10px"},primary:{color:__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["r" /* primaryColor */]},warning:{color:__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["B" /* warningColor */]},danger:{color:__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["g" /* dangerColor */]},success:{color:__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["x" /* successColor */]},info:{color:__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["o" /* infoColor */]},rose:{color:__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["u" /* roseColor */]},gray:{color:__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["l" /* grayColor */]},icon:{width:"36px",height:"36px"},descriptionWrapper:{color:__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["l" /* grayColor */],overflow:"hidden"},title:{color:"#3C4858",margin:"30px 0 15px",textDecoration:"none",fontSize:"18px"},description:{color:__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["l" /* grayColor */],overflow:"hidden",marginTop:"0px",fontSize:"14px"}};/* harmony default export */ __webpack_exports__["a"] = (infoStyle);

/***/ }),
/* 1008 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_assets_jss_material_dashboard_pro_react_customCheckboxRadioSwitch_jsx__ = __webpack_require__(130);
// ##############################
// // // RegisterPage view styles
// #############################
var registerPageStyle=Object.assign({},__WEBPACK_IMPORTED_MODULE_1_assets_jss_material_dashboard_pro_react_customCheckboxRadioSwitch_jsx__["a" /* default */],{cardTitle:Object.assign({},__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["b" /* cardTitle */],{textAlign:"center"}),container:Object.assign({},__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["c" /* container */],{position:"relative",zIndex:"3"// paddingTop: "23vh"
}),cardSignup:{borderRadius:"6px",boxShadow:"0 16px 24px 2px rgba(0, 0, 0, 0.14), 0 6px 30px 5px rgba(0, 0, 0, 0.12), 0 8px 10px -5px rgba(0, 0, 0, 0.2)",marginBottom:"100px",padding:"40px 0px",marginTop:"15vh"},center:{textAlign:"center"},right:{textAlign:"right"},left:{textAlign:"left"},form:{padding:"0 20px",position:"relative"},socialTitle:{fontSize:"18px"},inputAdornment:{marginRight:"18px",position:"relative"},inputAdornmentIcon:{color:"#555"},customFormControlClasses:{margin:"0 12px"},checkboxLabelControl:{margin:"0"},checkboxLabel:{marginLeft:"6px",color:"rgba(0, 0, 0, 0.26)"}});/* harmony default export */ __webpack_exports__["a"] = (registerPageStyle);

/***/ }),
/* 1009 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__material_ui_core_InputAdornment__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__material_ui_core_InputAdornment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__material_ui_core_InputAdornment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__material_ui_icons_LockOutlined__ = __webpack_require__(368);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__material_ui_icons_LockOutlined___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__material_ui_icons_LockOutlined__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_query_string__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_query_string___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_query_string__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_styles_withStyles__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_styles_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_styles_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_redux__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_EnergyCompany_BouncingLoader_BouncingLoader_jsx__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_CustomButtons_Button_jsx__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_CustomInput_CustomInput_jsx__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_components_EnergyCompany_Cards_ECCard_jsx__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_components_Grid_GridContainer_jsx__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_components_Grid_GridItem_jsx__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_components_Snackbar_SnackbarContent_jsx__ = __webpack_require__(369);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_reducers_user_actions__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_assets_jss_material_dashboard_pro_react_views_loginPageStyle_jsx__ = __webpack_require__(370);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var styles=function styles(theme){return Object.assign({},Object(__WEBPACK_IMPORTED_MODULE_16_assets_jss_material_dashboard_pro_react_views_loginPageStyle_jsx__["a" /* default */])(theme),{container:Object.assign({},Object(__WEBPACK_IMPORTED_MODULE_16_assets_jss_material_dashboard_pro_react_views_loginPageStyle_jsx__["a" /* default */])(theme).container,{paddingTop:"18vh"}),loginButtonWrapper:{display:"flex",alignItems:"center",flexDirection:"column",margin:theme.spacing.unit,position:'relative'},titleActions:{color:"white",display:"flex",justifyContent:"center"}});};var ResetPasswordPage=function(_Component){_inherits(ResetPasswordPage,_Component);function ResetPasswordPage(){var _ref;var _temp,_this,_ret;_classCallCheck(this,ResetPasswordPage);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=ResetPasswordPage.__proto__||Object.getPrototypeOf(ResetPasswordPage)).call.apply(_ref,[this].concat(args))),_this),_this.state={confirmacaoSenha:"",loading:false,senha:"",updatingPasswordMsg:""},_this.handleClick=function(){var _this$props=_this.props,history=_this$props.history,location=_this$props.location,resetPassword=_this$props.resetPassword;var _this$state=_this.state,confirmacaoSenha=_this$state.confirmacaoSenha,senha=_this$state.senha;var _queryString$parse=__WEBPACK_IMPORTED_MODULE_3_query_string___default.a.parse(location.search),codigo=_queryString$parse.codigo,id=_queryString$parse.id;if(confirmacaoSenha!==senha){return _this.setState({updatingPasswordMsg:"As senhas devem ser iguais."});}_this.setState({loading:true,updatingPasswordMsg:""});resetPassword({codigo:codigo,confirmacaoSenha:confirmacaoSenha,id:id,senha:senha}).then(function(){return history.push("/dashboard");}).catch(function(_ref2){var response=_ref2.response;_this.setState({loading:false,updatingPasswordMsg:Object(__WEBPACK_IMPORTED_MODULE_7_lodash__["values"])(response.data).join(" ")});});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(ResetPasswordPage,[{key:"render",value:function render(){var _this2=this;var classes=this.props.classes;var _state=this.state,confirmacaoSenha=_state.confirmacaoSenha,loading=_state.loading,senha=_state.senha,updatingPasswordMsg=_state.updatingPasswordMsg;return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div",{className:classes.container},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_components_Grid_GridContainer_jsx__["a" /* default */],{alignContent:"center",justify:"center"},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_components_Grid_GridItem_jsx__["a" /* default */],{md:4,sm:6,xs:12},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("form",null,__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components_EnergyCompany_Cards_ECCard_jsx__["a" /* default */],{content:__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_CustomInput_CustomInput_jsx__["a" /* default */],{error:updatingPasswordMsg,formControlProps:{fullWidth:true},inputProps:{autoComplete:"new-password",disabled:loading,endAdornment:__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core_InputAdornment___default.a,{position:"end"},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_icons_LockOutlined___default.a,{className:classes.inputAdornmentIcon})),onChange:function onChange(evt){return _this2.setState({senha:evt.target.value});},type:"password"},labelText:"Nova senha"}),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_CustomInput_CustomInput_jsx__["a" /* default */],{error:updatingPasswordMsg,formControlProps:{fullWidth:true},inputProps:{autoComplete:"new-password",disabled:loading,endAdornment:__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core_InputAdornment___default.a,{position:"end"},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_icons_LockOutlined___default.a,{className:classes.inputAdornmentIcon})),onChange:function onChange(evt){return _this2.setState({confirmacaoSenha:evt.target.value});},type:"password"},labelText:"Confirma\xE7\xE3o de senha"})),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div",{className:classes.loginButtonWrapper},loading?__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_EnergyCompany_BouncingLoader_BouncingLoader_jsx__["a" /* default */],null):__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_CustomButtons_Button_jsx__["a" /* default */],{color:"rose",disabled:!senha||!confirmacaoSenha,onClick:this.handleClick,size:"lg"},"Resetar"))),hasIcon:false,title:"Resetar Senha",titleActionsClass:classes.titleActions})),updatingPasswordMsg&&__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_components_Snackbar_SnackbarContent_jsx__["a" /* default */],{color:"rose",message:updatingPasswordMsg}))));}}]);return ResetPasswordPage;}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);ResetPasswordPage.propTypes={classes:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired,history:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired,location:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired,resetPassword:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired};var mapDispatchToProps={resetPassword:__WEBPACK_IMPORTED_MODULE_15_reducers_user_actions__["e" /* resetPassword */]};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_6_react_redux__["b" /* connect */])(null,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_styles_withStyles___default()(styles)(ResetPasswordPage)));

/***/ }),
/* 1010 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__user_constants__ = __webpack_require__(179);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__alerts_reducer__ = __webpack_require__(1011);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__user_reducer__ = __webpack_require__(1012);
var appReducer=Object(__WEBPACK_IMPORTED_MODULE_0_redux__["c" /* combineReducers */])({alerts:__WEBPACK_IMPORTED_MODULE_2__alerts_reducer__["a" /* default */],user:__WEBPACK_IMPORTED_MODULE_3__user_reducer__["a" /* default */]});var rootReducer=function rootReducer(state,action){if(action.type===__WEBPACK_IMPORTED_MODULE_1__user_constants__["b" /* REVOKE_USER */]){// Reducers are supposed to return the initial state when
// they are called with undefined as the first argument.
state=undefined;}return appReducer(state,action);};/* harmony default export */ __webpack_exports__["a"] = (rootReducer);

/***/ }),
/* 1011 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__(247);
function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}/* harmony default export */ __webpack_exports__["a"] = (function(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:[];var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_1__constants__["a" /* DISMISS_ALERT */]:return Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["filter"])(state,function(alert){return alert.id!==action.payload.id;});case __WEBPACK_IMPORTED_MODULE_1__constants__["b" /* SHOW_ALERT */]:return[].concat(_toConsumableArray(state),[action.payload]);default:return state;}});

/***/ }),
/* 1012 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_config_axios__ = __webpack_require__(180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__(179);
var emptyUser={};var userInfo=JSON.parse(localStorage.getItem(__WEBPACK_IMPORTED_MODULE_1__constants__["c" /* USER_INFO */]));var initialState=userInfo||emptyUser;Object(__WEBPACK_IMPORTED_MODULE_0_config_axios__["b" /* axiosTokenSetup */])(initialState);/* harmony default export */ __webpack_exports__["a"] = (function(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_1__constants__["a" /* AUTHENTICATE_USER */]:{var user=Object.assign({},action.payload.user,{info:JSON.parse(action.payload.user.resource)});saveUserToLocalStorage(user);return user;}case __WEBPACK_IMPORTED_MODULE_1__constants__["b" /* REVOKE_USER */]:return Object.assign({},emptyUser);case __WEBPACK_IMPORTED_MODULE_1__constants__["d" /* USER_UPDATED */]:{var _user=Object.assign({},state,{info:Object.assign({},action.payload)});saveUserToLocalStorage(_user);return _user;}default:return state;}});///////////////////////////////////////
//              HELPERS              //
///////////////////////////////////////
var saveUserToLocalStorage=function saveUserToLocalStorage(user){return localStorage.setItem(__WEBPACK_IMPORTED_MODULE_1__constants__["c" /* USER_INFO */],JSON.stringify(user));};

/***/ }),
/* 1013 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return momentConfigLocale; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
var momentConfigLocale=function momentConfigLocale(){__WEBPACK_IMPORTED_MODULE_0_moment___default.a.locale("pt-BR");};

/***/ }),
/* 1014 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_chart_js__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_chart_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_chart_js__);
__WEBPACK_IMPORTED_MODULE_0_chart_js___default.a.defaults.global.defaultFontFamily="'Raleway', 'Roboto', 'Helvetica', 'Arial'";

/***/ }),
/* 1015 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1016 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(34)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var ptBr = moment.defineLocale('pt-br', {
        months : 'janeiro_fevereiro_março_abril_maio_junho_julho_agosto_setembro_outubro_novembro_dezembro'.split('_'),
        monthsShort : 'jan_fev_mar_abr_mai_jun_jul_ago_set_out_nov_dez'.split('_'),
        weekdays : 'Domingo_Segunda-feira_Terça-feira_Quarta-feira_Quinta-feira_Sexta-feira_Sábado'.split('_'),
        weekdaysShort : 'Dom_Seg_Ter_Qua_Qui_Sex_Sáb'.split('_'),
        weekdaysMin : 'Do_2ª_3ª_4ª_5ª_6ª_Sá'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D [de] MMMM [de] YYYY',
            LLL : 'D [de] MMMM [de] YYYY [às] HH:mm',
            LLLL : 'dddd, D [de] MMMM [de] YYYY [às] HH:mm'
        },
        calendar : {
            sameDay: '[Hoje às] LT',
            nextDay: '[Amanhã às] LT',
            nextWeek: 'dddd [às] LT',
            lastDay: '[Ontem às] LT',
            lastWeek: function () {
                return (this.day() === 0 || this.day() === 6) ?
                    '[Último] dddd [às] LT' : // Saturday + Sunday
                    '[Última] dddd [às] LT'; // Monday - Friday
            },
            sameElse: 'L'
        },
        relativeTime : {
            future : 'em %s',
            past : 'há %s',
            s : 'poucos segundos',
            ss : '%d segundos',
            m : 'um minuto',
            mm : '%d minutos',
            h : 'uma hora',
            hh : '%d horas',
            d : 'um dia',
            dd : '%d dias',
            M : 'um mês',
            MM : '%d meses',
            y : 'um ano',
            yy : '%d anos'
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal : '%dº'
    });

    return ptBr;

})));


/***/ })
/******/ ]);


// WEBPACK FOOTER //
// static/js/main.a22117cd.js